
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94e4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94e4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    for(var node = fiber, nextNode = node; nextNode && !nextNode.alternate;)node = nextNode, 0 !== (node.flags & 4098) && (fiber = node.return), nextNode = node.return;
    for(; node.return;)node = node.return;
    return 3 === node.tag ? fiber : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
function $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(child, searchWithinHosts, fn, a, b, c) {
    for(; null !== child;){
        if ((5 === child.tag || 27 === child.tag || 6 === child.tag) && fn(child, a, b, c) || (22 !== child.tag || null === child.memoizedState) && (searchWithinHosts || 5 !== child.tag && 27 !== child.tag) && $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(child.child, searchWithinHosts, fn, a, b, c)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(fiber) {
    for(fiber = fiber.return; null !== fiber;){
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) return fiber;
        fiber = fiber.return;
    }
    return null;
}
function $dca0ddb82b882518$var$fiberIsPortaledIntoHost(fiber) {
    var foundPortalParent = !1;
    for(fiber = fiber.return; null !== fiber;){
        4 === fiber.tag && (foundPortalParent = !0);
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) break;
        fiber = fiber.return;
    }
    return foundPortalParent;
}
function $dca0ddb82b882518$var$getFragmentInstanceOrTextInstanceSiblings(fiber) {
    var result = [
        null,
        null
    ], parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(fiber);
    if (null === parentHostFiber) return result;
    $dca0ddb82b882518$var$findFragmentInstanceOrTextInstanceSiblings(result, fiber, parentHostFiber.child, {
        foundSelf: !1
    });
    return result;
}
function $dca0ddb82b882518$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child, state) {
    for(; null !== child;){
        if (child === self) state.foundSelf = !0;
        else if (5 === child.tag || 27 === child.tag || 6 === child.tag) {
            if (state.foundSelf) return result[1] = child, !0;
            result[0] = child;
        } else if ((22 !== child.tag || null === child.memoizedState) && $dca0ddb82b882518$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child.child, state)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $dca0ddb82b882518$var$getInstanceFromHostFiber(fiber) {
    switch(fiber.tag){
        case 5:
        case 27:
        case 6:
            return fiber.stateNode;
        case 3:
            return fiber.stateNode.containerInfo;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(559));
    }
}
var $dca0ddb82b882518$var$searchTarget = null, $dca0ddb82b882518$var$searchBoundary = null;
function $dca0ddb82b882518$var$isFiberPrecedingCheck(child, target, boundary) {
    return child === boundary ? !0 : child === target ? ($dca0ddb82b882518$var$searchTarget = child, !0) : !1;
}
function $dca0ddb82b882518$var$isFiberFollowingCheck(child, target, boundary) {
    return child === boundary ? ($dca0ddb82b882518$var$searchBoundary = child, !1) : child === target ? (null !== $dca0ddb82b882518$var$searchBoundary && ($dca0ddb82b882518$var$searchTarget = child), !0) : !1;
}
function $dca0ddb82b882518$var$getParentForFragmentAncestors(inst) {
    if (null === inst) return null;
    do inst = null === inst ? null : inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag && 3 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$getLowestCommonAncestor(instA, instB, getParent) {
    for(var depthA = 0, tempA = instA; tempA; tempA = getParent(tempA))depthA++;
    tempA = 0;
    for(var tempB = instB; tempB; tempB = getParent(tempB))tempA++;
    for(; 0 < depthA - tempA;)instA = getParent(instA), depthA--;
    for(; 0 < tempA - depthA;)instB = getParent(instB), tempA--;
    for(; depthA--;){
        if (instA === instB || null !== instB && instA === instB.alternate) return instA;
        instA = getParent(instA);
        instB = getParent(instB);
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $dca0ddb82b882518$var$REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $dca0ddb82b882518$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
        case $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE:
            return "ViewTransition";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    var stateHook = fiber.memoizedState;
    null !== stateHook && ($dca0ddb82b882518$var$HostTransitionContext._currentValue = stateHook.memoizedState, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber));
    stateHook = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(stateHook, fiber.type);
    stateHook !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            Fake = !1;
                            try {
                                var prevProps = Object.getOwnPropertyDescriptor(fn.prototype, "props");
                                Object.defineProperty(fn.prototype, "props", {
                                    configurable: !0,
                                    set: function() {
                                        throw Error();
                                    }
                                });
                                Fake = !0;
                                new fn();
                            } finally{
                                Fake && (void 0 !== prevProps ? Object.defineProperty(fn.prototype, "props", prevProps) : delete fn.prototype.props);
                            }
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        case 30:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("ViewTransition");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & -lanes;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$getEntangledLanes(root, renderLanes) {
    0 !== (renderLanes & 8) && (renderLanes |= renderLanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= renderLanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        renderLanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    return renderLanes;
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalLoadPendingKey = "__reactLoad$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst;
    if (targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
function $dca0ddb82b882518$var$clearPendingLoadOnNode(node) {
    node[$dca0ddb82b882518$var$internalLoadPendingKey] = void 0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
var $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
function $dca0ddb82b882518$var$pushMutationContext() {
    var prev = $dca0ddb82b882518$var$viewTransitionMutationContext;
    $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
    return prev;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? "number" === type && element.value == value ? $dca0ddb82b882518$var$setDefaultValue(element, $dca0ddb82b882518$var$getToStringValue(element.value)) : $dca0ddb82b882518$var$setDefaultValue(element, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, value) {
    node.defaultValue !== "" + value && (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "", $dca0ddb82b882518$var$viewTransitionMutationContext = !0);
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && ($dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName), $dca0ddb82b882518$var$viewTransitionMutationContext = !0);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "maskType",
        "mask-type"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$SubmitEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    submitter: 0
}), $dca0ddb82b882518$var$SyntheticSubmitEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$SubmitEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0,
    source: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_474 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_474) {
            var $dca0ddb82b882518$var$element$jscomp$inline_475 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_475.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_474 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_475.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318 = $dca0ddb82b882518$var$isSupported$jscomp$inline_474;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e$20) {
        return doc.body;
    }
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error fullscreenChange fullscreenError gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$globalClientIdCounter$1 = 0;
function $dca0ddb82b882518$var$getViewTransitionName(props, instance) {
    if (null != props.name && "auto" !== props.name) return props.name;
    if (null !== instance.autoName) return instance.autoName;
    props = $dca0ddb82b882518$var$pendingEffectsRoot.identifierPrefix;
    var globalClientId = $dca0ddb82b882518$var$globalClientIdCounter$1++;
    props = "_" + props + "t_" + globalClientId.toString(32) + "_";
    return instance.autoName = props;
}
function $dca0ddb82b882518$var$getClassNameByType(classByType) {
    if (null == classByType || "string" === typeof classByType) return classByType;
    var className = null, activeTypes = $dca0ddb82b882518$var$pendingTransitionTypes;
    if (null !== activeTypes) for(var i = 0; i < activeTypes.length; i++){
        var match = classByType[activeTypes[i]];
        if (null != match) {
            if ("none" === match) return "none";
            className = null == className ? match : className + (" " + match);
        }
    }
    return null == className ? classByType.default : className;
}
function $dca0ddb82b882518$var$getViewTransitionClassName(defaultClass, eventClass) {
    defaultClass = $dca0ddb82b882518$var$getClassNameByType(defaultClass);
    eventClass = $dca0ddb82b882518$var$getClassNameByType(eventClass);
    return null == eventClass ? "auto" === defaultClass ? null : defaultClass : "auto" === eventClass ? null : eventClass;
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 1206910976;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 1206910978;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof owner) $dca0ddb82b882518$var$shouldConstruct(owner) && (fiberTag = 1);
    else if ("string" === typeof owner) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(owner){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_LEGACY_HIDDEN_TYPE:
        case $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE:
            return type = mode | 32, type = $dca0ddb82b882518$var$createFiberImplClass(30, pendingProps, key, type), type.elementType = $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE, type.lanes = lanes, type.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }, type;
        default:
            if ("object" === typeof owner && null !== owner) switch(owner.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else 13 === fiber.tag && null !== fiber.memoizedState && null === fiber.memoizedState.dehydrated ? (fiber.lanes |= renderLanes, nextFiber = fiber.alternate, null !== nextFiber && (nextFiber.lanes |= renderLanes), $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress), nextFiber = fiber.child, nextFiber = null !== nextFiber ? nextFiber.sibling : null) : nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
    return null !== current;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
function $dca0ddb82b882518$var$queueTransitionTypes(root, transitionTypes) {
    if (0 !== (root.pendingLanes & 4194048)) {
        var queued = root.transitionTypes;
        null === queued && (queued = root.transitionTypes = []);
        for(root = 0; root < transitionTypes.length; root++){
            var transitionType = transitionTypes[root];
            -1 === queued.indexOf(transitionType) && queued.push(transitionType);
        }
    }
}
var $dca0ddb82b882518$var$entangledTransitionTypes = null;
function $dca0ddb82b882518$var$claimQueuedTransitionTypes(root) {
    var claimed = root.transitionTypes;
    root.transitionTypes = null;
    return claimed;
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && ($dca0ddb82b882518$var$entangledTransitionTypes = null, null !== $dca0ddb82b882518$var$currentEntangledListeners)) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    if (null !== $dca0ddb82b882518$var$entangledTransitionTypes) for(var root$28 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$28;)$dca0ddb82b882518$var$queueTransitionTypes(root$28, $dca0ddb82b882518$var$entangledTransitionTypes), root$28 = root$28.next;
    root$28 = transition.types;
    if (null !== root$28) {
        for(var root$29 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$29;)$dca0ddb82b882518$var$queueTransitionTypes(root$29, root$28), root$29 = root$29.next;
        if (0 !== $dca0ddb82b882518$var$currentEntangledLane) {
            root$29 = $dca0ddb82b882518$var$entangledTransitionTypes;
            null === root$29 && (root$29 = $dca0ddb82b882518$var$entangledTransitionTypes = []);
            for(var i = 0; i < root$28.length; i++){
                var transitionType = root$28[i];
                -1 === root$29.indexOf(transitionType) && root$29.push(transitionType);
            }
        }
    }
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState);
            if (void 0 === thenableState && !("reason" in thenable)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(600));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null === currentFirstChild.key ? existingChildren.set(currentFirstChild.index, currentFirstChild) : existingChildren.set(currentFirstChild.key, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 2, lastPlacedIndex) : newIndex;
        newFiber.flags |= 134217730;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 134217730);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return returnFiber = updateFragment(returnFiber, current, element.props.children, lanes, element.key), $dca0ddb82b882518$var$coerceRef(returnFiber, element), returnFiber;
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && (newFiber = nextOldFiber.alternate, null !== newFiber && oldFiber.delete(null === newFiber.key ? newIdx : newFiber.key)), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && (nextOldFiber = step.alternate, null !== nextOldFiber && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key)), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && void 0 === newChild.props.ref && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack();
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushSuspenseListContext(fiber, newContext) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, newContext);
}
function $dca0ddb82b882518$var$popSuspenseListContext(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
}
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && "independent" !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_RECOVERABLE_TYPE) return;
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$64 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$64 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    subscribe = hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && 0 !== ($dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1);
    $dca0ddb82b882518$var$pushSimpleEffect(subscribe ? 9 : 8, {
        destroy: void 0
    }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
    if (subscribe) {
        fiber.flags |= 2048;
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        currentTransition.types = null !== prevTransition ? prevTransition.types : null;
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$70) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$70);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 106) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$73 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$73 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$73, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$73, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffectEvent: $dca0ddb82b882518$var$throwInvalidHookError
}, $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh,
    useEffectEvent: $dca0ddb82b882518$var$updateEvent
}, $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh,
    useEffectEvent: $dca0ddb82b882518$var$updateEvent
};
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$77 in Component)void 0 === newProps[propName$77] && (newProps[propName$77] = Component[propName$77]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$78) {
        setTimeout(function() {
            throw e$78;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$79) {
        setTimeout(function() {
            throw e$79;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                case 19:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                returnFiber = sourceFiber.type;
                wrapperError = sourceFiber.stateNode;
                if (0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
                break;
            case 22:
                if (null !== sourceFiber.memoizedState) return sourceFiber.flags |= 65536, !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack());
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, current.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            if (null === $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) {
                nextProps = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
                $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            }
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 134221824;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack();
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        didSuspend = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), showFallback = workInProgress.mode, didSuspend = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: didSuspend
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), didSuspend.return = workInProgress, nextProps.return = workInProgress, didSuspend.sibling = nextProps, workInProgress.child = didSuspend, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, didSuspend);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated$96 = prevState.dehydrated;
        if (null !== dehydrated$96) return $dca0ddb82b882518$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, JSCompiler_temp, nextProps, dehydrated$96, prevState, renderLanes);
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), showFallback = nextProps.fallback, didSuspend = workInProgress.mode, prevState = current.child, dehydrated$96 = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 1206910976, null !== dehydrated$96 ? showFallback = $dca0ddb82b882518$var$createWorkInProgress(dehydrated$96, showFallback) : (showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, didSuspend, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, showFallback = current.child.memoizedState, null === showFallback ? showFallback = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (didSuspend = showFallback.cachePool, null !== didSuspend ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, didSuspend = didSuspend.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : didSuspend) : didSuspend = $dca0ddb82b882518$var$getSuspendedCache(), showFallback = {
        baseLanes: showFallback.baseLanes | renderLanes,
        cachePool: didSuspend
    }), nextProps.memoizedState = showFallback, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, didPrimaryChildrenDefer, nextProps, suspenseInstance, suspenseState, renderLanes) {
    if (didSuspend) {
        if (workInProgress.flags & 256) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        if (null !== workInProgress.memoizedState) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), workInProgress.child = current.child, workInProgress.flags |= 128, null;
        $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack();
        suspenseInstance = nextProps.fallback;
        suspenseState = workInProgress.mode;
        nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, suspenseState);
        suspenseInstance = $dca0ddb82b882518$var$createFiberFromFragment(suspenseInstance, suspenseState, renderLanes, null);
        suspenseInstance.flags |= 2;
        nextProps.return = workInProgress;
        suspenseInstance.return = workInProgress;
        nextProps.sibling = suspenseInstance;
        workInProgress.child = nextProps;
        $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        nextProps = workInProgress.child;
        nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes);
        nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, didPrimaryChildrenDefer, renderLanes);
        workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER;
        return $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
    }
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    if ($dca0ddb82b882518$var$isSuspenseInstanceFallback(suspenseInstance)) {
        didPrimaryChildrenDefer = suspenseInstance.nextSibling && suspenseInstance.nextSibling.dataset;
        if (didPrimaryChildrenDefer) var digest = didPrimaryChildrenDefer.dgst;
        didPrimaryChildrenDefer = digest;
        "" !== didPrimaryChildrenDefer && (nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419)), nextProps.stack = "", nextProps.digest = didPrimaryChildrenDefer, $dca0ddb82b882518$var$queueHydrationError({
            value: nextProps,
            source: null,
            stack: null
        }));
        return $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    $dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
    didPrimaryChildrenDefer = 0 !== (renderLanes & current.childLanes);
    if ($dca0ddb82b882518$var$didReceiveUpdate || didPrimaryChildrenDefer) {
        if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        didPrimaryChildrenDefer = $dca0ddb82b882518$var$workInProgressRoot;
        if (null !== didPrimaryChildrenDefer && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(didPrimaryChildrenDefer, renderLanes), 0 !== nextProps && nextProps !== suspenseState.retryLane)) throw suspenseState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(didPrimaryChildrenDefer, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
        $dca0ddb82b882518$var$isSuspenseInstancePending(suspenseInstance) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    if ($dca0ddb82b882518$var$isSuspenseInstancePending(suspenseInstance)) return workInProgress.flags |= 192, workInProgress.child = current.child, null;
    current = suspenseState.treeContext;
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(suspenseInstance.nextSibling);
    $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
    $dca0ddb82b882518$var$isHydrating = !0;
    $dca0ddb82b882518$var$hydrationErrors = null;
    $dca0ddb82b882518$var$rootOrSingletonContext = !1;
    null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current);
    workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children);
    workInProgress.flags |= 134221824;
    return workInProgress;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$findLastContentRow(firstChild) {
    for(var lastContentRow = null; null !== firstChild;){
        var currentRow = firstChild.alternate;
        null !== currentRow && null === $dca0ddb82b882518$var$findFirstSuspended(currentRow) && (lastContentRow = firstChild);
        firstChild = firstChild.sibling;
    }
    return lastContentRow;
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$reverseChildren(fiber) {
    var row = fiber.child;
    for(fiber.child = null; null !== row;){
        var nextRow = row.sibling;
        row.sibling = fiber.child;
        fiber.child = row;
        row = nextRow;
    }
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current;
    if (workInProgress.flags & 128) return $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, suspenseContext), null;
    var shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, suspenseContext);
    "backwards" === revealOrder && null !== current ? ($dca0ddb82b882518$var$reverseChildren(current), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes), $dca0ddb82b882518$var$reverseChildren(current)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "backwards":
            renderLanes = $dca0ddb82b882518$var$findLastContentRow(workInProgress.child);
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null, $dca0ddb82b882518$var$reverseChildren(workInProgress));
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, revealOrder, null, tailMode, nextProps);
            break;
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        case "independent":
            workInProgress.memoizedState = null;
            break;
        default:
            renderLanes = $dca0ddb82b882518$var$findLastContentRow(workInProgress.child), null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null), $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateContextProvider(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, newProps.value);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, newProps.children, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$108 = workInProgress.memoizedState;
            if (null !== state$108) {
                if (null !== state$108.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                state$108 = $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
                var primaryChildLanes = workInProgress.child.childLanes;
                if (state$108 || 0 !== (renderLanes & primaryChildLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            if (workInProgress.flags & 128) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
            primaryChildLanes = 0 !== (current.flags & 128);
            state$108 = 0 !== (renderLanes & workInProgress.childLanes);
            state$108 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$108 = 0 !== (renderLanes & workInProgress.childLanes));
            if (primaryChildLanes) {
                if (state$108) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            primaryChildLanes = workInProgress.memoizedState;
            null !== primaryChildLanes && (primaryChildLanes.rendering = null, primaryChildLanes.tail = null, primaryChildLanes.lastEffect = null);
            $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$108) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) {
                            workInProgress.tag = 10;
                            workInProgress.type = current;
                            workInProgress = $dca0ddb82b882518$var$updateContextProvider(null, workInProgress, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 134221824, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (workInProgress.stateNode = $dca0ddb82b882518$var$createHoistableInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current, workInProgress)) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$markRef(current, workInProgress), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return $dca0ddb82b882518$var$updateContextProvider(current, workInProgress, renderLanes);
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 30:
            return null === workInProgress.stateNode && (workInProgress.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }), props = workInProgress.pendingProps, null != props.name && "auto" !== props.name ? workInProgress.flags |= null === current ? 18882560 : 18874368 : $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress), null !== current && current.memoizedProps.name !== props.name ? workInProgress.flags |= 4194816 : $dca0ddb82b882518$var$markRef(current, workInProgress), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    var JSCompiler_temp;
    if (JSCompiler_temp = 0 !== (workInProgress.mode & 32)) JSCompiler_temp = null === oldProps ? $dca0ddb82b882518$var$maySuspendCommit(type, newProps) : $dca0ddb82b882518$var$maySuspendCommit(type, newProps) && (newProps.src !== oldProps.src || newProps.srcSet !== oldProps.srcSet);
    if (JSCompiler_temp) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "visible":
            break;
        case "collapsed":
            for(var tailNode = renderState.tail, lastTailNode = null; null !== tailNode;)null !== tailNode.alternate && (lastTailNode = tailNode), tailNode = tailNode.sibling;
            null === lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode.sibling = null;
            break;
        default:
            hasRenderedATailFallback = renderState.tail;
            for(tailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (tailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === tailNode ? renderState.tail = null : tailNode.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags & 1206910976, subtreeFlags |= child$113.flags & 1206910976, child$113.return = completedWork, child$113 = child$113.sibling;
    else for(child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags, subtreeFlags |= child$113.flags, child$113.return = completedWork, child$113 = child$113.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), workInProgress.flags |= 67108864, $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$popSuspenseListContext(workInProgress);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "collapsed" !== newProps.tailMode && "visible" !== newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) {
                current = newProps.tail;
                a: {
                    for(renderLanes = current; null !== renderLanes;){
                        if (null !== renderLanes.alternate) {
                            renderLanes = !1;
                            break a;
                        }
                        renderLanes = renderLanes.sibling;
                    }
                    renderLanes = !0;
                }
                newProps.rendering = current;
                newProps.tail = current.sibling;
                newProps.renderingStartTime = $dca0ddb82b882518$var$now();
                current.sibling = null;
                nextResource = $dca0ddb82b882518$var$suspenseStackCursor.current;
                nextResource = type ? nextResource & 1 | 2 : nextResource & 1;
                "visible" === newProps.tailMode || "collapsed" === newProps.tailMode || !renderLanes || $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, nextResource) : (renderLanes = nextResource, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, workInProgress), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, renderLanes), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = workInProgress));
                $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                return current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return workInProgress.flags |= 33554432, $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$popSuspenseListContext(workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, current = workInProgress.memoizedState, null !== current && (current.rendering = null, current.tail = null), workInProgress.flags |= 4, workInProgress) : null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$popSuspenseListContext(interruptedWork);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    var instance = current.stateNode, name = $dca0ddb82b882518$var$getViewTransitionName(current.memoizedProps, instance);
                    if (null === instance.ref || instance.ref.name !== name) instance.ref = $dca0ddb82b882518$var$createViewTransitionInstance(name);
                    instanceToUse = instance.ref;
                    break;
                case 7:
                    if (null === current.stateNode) {
                        var fragmentInstance = new $dca0ddb82b882518$var$FragmentInstance(current);
                        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(current.child, !1, $dca0ddb82b882518$var$addFragmentHandleToFiber, fragmentInstance, void 0, void 0);
                        current.stateNode = fragmentInstance;
                    }
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$148) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$148);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitNewChildToFragmentInstances(fiber, parentFragmentInstances) {
    if ((5 === fiber.tag || 27 === fiber.tag || 6 === fiber.tag) && null === fiber.alternate && null !== parentFragmentInstances) for(var i = 0; i < parentFragmentInstances.length; i++)$dca0ddb82b882518$var$commitNewChildToFragmentInstance(fiber.stateNode, parentFragmentInstances[i]);
}
function $dca0ddb82b882518$var$commitFragmentInstanceInsertionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $dca0ddb82b882518$var$isFragmentInstanceParent(parent) && $dca0ddb82b882518$var$commitNewChildToFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($dca0ddb82b882518$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $dca0ddb82b882518$var$isFragmentInstanceParent(parent) && $dca0ddb82b882518$var$deleteChildFromFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($dca0ddb82b882518$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$isFragmentInstanceHostBoundary(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 27 === fiber.tag;
}
function $dca0ddb82b882518$var$isFragmentInstanceParent(fiber) {
    return fiber && 7 === fiber.tag && null !== fiber.stateNode;
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(tag, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(tag), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1)), $dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null)), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? parent.insertBefore(tag, before) : parent.appendChild(tag), $dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode)), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$shouldStartViewTransition = !1, $dca0ddb82b882518$var$appearingViewTransitions = null;
function $dca0ddb82b882518$var$trackEnterViewTransitions(placement) {
    if (30 === placement.tag || 0 !== (placement.subtreeFlags & 33554432)) $dca0ddb82b882518$var$shouldStartViewTransition = !0;
}
var $dca0ddb82b882518$var$viewTransitionCancelableChildren = null;
function $dca0ddb82b882518$var$pushViewTransitionCancelableScope() {
    var prevChildren = $dca0ddb82b882518$var$viewTransitionCancelableChildren;
    $dca0ddb82b882518$var$viewTransitionCancelableChildren = null;
    return prevChildren;
}
var $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0;
function $dca0ddb82b882518$var$applyViewTransitionToHostInstances(fiber, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0;
    return $dca0ddb82b882518$var$applyViewTransitionToHostInstancesRecursive(fiber.child, name, className, collectMeasurements, stopAtNestedViewTransitions);
}
function $dca0ddb82b882518$var$applyViewTransitionToHostInstancesRecursive(child, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== collectMeasurements) {
                var measurement = $dca0ddb82b882518$var$measureInstance(instance);
                collectMeasurements.push(measurement);
                measurement.view && (inViewport = !0);
            } else inViewport || $dca0ddb82b882518$var$measureInstance(instance).view && (inViewport = !0);
            $dca0ddb82b882518$var$shouldStartViewTransition = !0;
            $dca0ddb82b882518$var$applyViewTransitionName(instance, 0 === $dca0ddb82b882518$var$viewTransitionHostInstanceIdx ? name : name + "_" + $dca0ddb82b882518$var$viewTransitionHostInstanceIdx, className);
            $dca0ddb82b882518$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $dca0ddb82b882518$var$applyViewTransitionToHostInstancesRecursive(child.child, name, className, collectMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(child, stopAtNestedViewTransitions) {
    for(; null !== child;){
        if (5 === child.tag) $dca0ddb82b882518$var$restoreViewTransitionName(child.stateNode, child.memoizedProps);
        else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(child.child, stopAtNestedViewTransitions);
        child = child.sibling;
    }
}
function $dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement) {
    if (0 !== (placement.subtreeFlags & 18874368)) for(placement = placement.child; null !== placement;){
        if (22 !== placement.tag || null === placement.memoizedState) {
            if ($dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement), 30 === placement.tag && 0 !== (placement.flags & 18874368) && placement.stateNode.paired) {
                var props = placement.memoizedProps;
                if (null == props.name || "auto" === props.name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(544));
                var name = props.name;
                props = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.share);
                "none" !== props && ($dca0ddb82b882518$var$applyViewTransitionToHostInstances(placement, name, props, null, !1) || $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(placement.child, !1));
            }
        }
        placement = placement.sibling;
    }
}
function $dca0ddb82b882518$var$commitEnterViewTransitions(placement, gesture) {
    if (30 === placement.tag) {
        var state = placement.stateNode, props = placement.memoizedProps, name = $dca0ddb82b882518$var$getViewTransitionName(props, state), className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, state.paired ? props.share : props.enter);
        "none" !== className ? $dca0ddb82b882518$var$applyViewTransitionToHostInstances(placement, name, className, null, !1) ? ($dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement), state.paired || gesture || $dca0ddb82b882518$var$scheduleViewTransitionEvent(placement, props.onEnter)) : $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(placement.child, !1) : $dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement);
    } else if (0 !== (placement.subtreeFlags & 33554432)) for(placement = placement.child; null !== placement;)$dca0ddb82b882518$var$commitEnterViewTransitions(placement, gesture), placement = placement.sibling;
    else $dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement);
}
function $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion) {
    if (null !== $dca0ddb82b882518$var$appearingViewTransitions && 0 !== $dca0ddb82b882518$var$appearingViewTransitions.size) {
        var pairs = $dca0ddb82b882518$var$appearingViewTransitions;
        if (0 !== (deletion.subtreeFlags & 18874368)) for(deletion = deletion.child; null !== deletion;){
            if (22 !== deletion.tag || null === deletion.memoizedState) {
                if (30 === deletion.tag && 0 !== (deletion.flags & 18874368)) {
                    var props = deletion.memoizedProps, name = props.name;
                    if (null != name && "auto" !== name) {
                        var pair = pairs.get(name);
                        if (void 0 !== pair) {
                            var className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.share);
                            "none" !== className && ($dca0ddb82b882518$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $dca0ddb82b882518$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
                            pairs.delete(name);
                            if (0 === pairs.size) break;
                        }
                    }
                }
                $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion);
            }
            deletion = deletion.sibling;
        }
    }
}
function $dca0ddb82b882518$var$commitExitViewTransitions(deletion) {
    if (30 === deletion.tag) {
        var props = deletion.memoizedProps, name = $dca0ddb82b882518$var$getViewTransitionName(props, deletion.stateNode), pair = null !== $dca0ddb82b882518$var$appearingViewTransitions ? $dca0ddb82b882518$var$appearingViewTransitions.get(name) : void 0, className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, void 0 !== pair ? props.share : props.exit);
        "none" !== className && ($dca0ddb82b882518$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? void 0 !== pair ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $dca0ddb82b882518$var$appearingViewTransitions.delete(name), $dca0ddb82b882518$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $dca0ddb82b882518$var$scheduleViewTransitionEvent(deletion, props.onExit) : $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
        null !== $dca0ddb82b882518$var$appearingViewTransitions && $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion);
    } else if (0 !== (deletion.subtreeFlags & 33554432)) for(deletion = deletion.child; null !== deletion;)$dca0ddb82b882518$var$commitExitViewTransitions(deletion), deletion = deletion.sibling;
    else null !== $dca0ddb82b882518$var$appearingViewTransitions && $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion);
}
function $dca0ddb82b882518$var$commitNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, name = $dca0ddb82b882518$var$getViewTransitionName(props, changedParent.stateNode);
            props = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.update);
            changedParent.flags &= -5;
            "none" !== props && $dca0ddb82b882518$var$applyViewTransitionToHostInstances(changedParent, name, props, changedParent.memoizedState = [], !1);
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $dca0ddb82b882518$var$commitNestedViewTransitions(changedParent);
        changedParent = changedParent.sibling;
    }
}
function $dca0ddb82b882518$var$restorePairedViewTransitions(parent) {
    if (0 !== (parent.subtreeFlags & 18874368)) for(parent = parent.child; null !== parent;){
        if (22 !== parent.tag || null === parent.memoizedState) {
            if (30 === parent.tag && 0 !== (parent.flags & 18874368)) {
                var instance = parent.stateNode;
                null !== instance.paired && (instance.paired = null, $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(parent.child, !1));
            }
            $dca0ddb82b882518$var$restorePairedViewTransitions(parent);
        }
        parent = parent.sibling;
    }
}
function $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(fiber) {
    if (30 === fiber.tag) fiber.stateNode.paired = null, $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(fiber.child, !1), $dca0ddb82b882518$var$restorePairedViewTransitions(fiber);
    else if (0 !== (fiber.subtreeFlags & 33554432)) for(fiber = fiber.child; null !== fiber;)$dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(fiber), fiber = fiber.sibling;
    else $dca0ddb82b882518$var$restorePairedViewTransitions(fiber);
}
function $dca0ddb82b882518$var$restoreNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;)30 === changedParent.tag ? $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(changedParent.child, !1) : 0 !== (changedParent.subtreeFlags & 33554432) && $dca0ddb82b882518$var$restoreNestedViewTransitions(changedParent), changedParent = changedParent.sibling;
}
function $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== previousMeasurements && $dca0ddb82b882518$var$viewTransitionHostInstanceIdx < previousMeasurements.length) {
                var previousMeasurement = previousMeasurements[$dca0ddb82b882518$var$viewTransitionHostInstanceIdx], nextMeasurement = $dca0ddb82b882518$var$measureInstance(instance);
                if (previousMeasurement.view || nextMeasurement.view) inViewport = !0;
                var JSCompiler_temp;
                if (JSCompiler_temp = 0 === (parentViewTransition.flags & 4)) {
                    if (nextMeasurement.clip) JSCompiler_temp = !0;
                    else {
                        JSCompiler_temp = previousMeasurement.rect;
                        var newRect = nextMeasurement.rect;
                        JSCompiler_temp = JSCompiler_temp.y !== newRect.y || JSCompiler_temp.x !== newRect.x || JSCompiler_temp.height !== newRect.height || JSCompiler_temp.width !== newRect.width;
                    }
                }
                JSCompiler_temp && (parentViewTransition.flags |= 4);
                nextMeasurement.abs ? nextMeasurement = !previousMeasurement.abs : (previousMeasurement = previousMeasurement.rect, nextMeasurement = nextMeasurement.rect, nextMeasurement = previousMeasurement.height !== nextMeasurement.height || previousMeasurement.width !== nextMeasurement.width);
                nextMeasurement && (parentViewTransition.flags |= 32);
            } else parentViewTransition.flags |= 32;
            0 !== (parentViewTransition.flags & 4) && $dca0ddb82b882518$var$applyViewTransitionName(instance, 0 === $dca0ddb82b882518$var$viewTransitionHostInstanceIdx ? newName : newName + "_" + $dca0ddb82b882518$var$viewTransitionHostInstanceIdx, className);
            inViewport && 0 !== (parentViewTransition.flags & 4) || (null === $dca0ddb82b882518$var$viewTransitionCancelableChildren && ($dca0ddb82b882518$var$viewTransitionCancelableChildren = []), $dca0ddb82b882518$var$viewTransitionCancelableChildren.push(instance, 0 === $dca0ddb82b882518$var$viewTransitionHostInstanceIdx ? oldName : oldName + "_" + $dca0ddb82b882518$var$viewTransitionHostInstanceIdx, child.memoizedProps));
            $dca0ddb82b882518$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions ? parentViewTransition.flags |= child.flags & 32 : $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child.child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $dca0ddb82b882518$var$measureNestedViewTransitions(changedParent, gesture) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, state = changedParent.stateNode, name = $dca0ddb82b882518$var$getViewTransitionName(props, state), className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.update);
            if (gesture) {
                state = state.clones;
                var previousMeasurements = null === state ? null : state.map($dca0ddb82b882518$var$measureClonedInstance);
            } else previousMeasurements = changedParent.memoizedState, changedParent.memoizedState = null;
            state = changedParent;
            var child = changedParent.child;
            $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0;
            name = $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(state, child, name, name, className, previousMeasurements, !1);
            0 !== (changedParent.flags & 4) && name && (gesture || $dca0ddb82b882518$var$scheduleViewTransitionEvent(changedParent, props.onUpdate));
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $dca0ddb82b882518$var$measureNestedViewTransitions(changedParent, gesture);
        changedParent = changedParent.sibling;
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$offscreenDirectParentIsHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null, $dca0ddb82b882518$var$viewTransitionContextChanged = !1, $dca0ddb82b882518$var$inUpdateViewTransition = !1, $dca0ddb82b882518$var$rootViewTransitionAffected = !1, $dca0ddb82b882518$var$rootViewTransitionNameCanceled = !1;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild, committedLanes) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$21) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    committedLanes = (committedLanes & 335544064) === committedLanes;
    $dca0ddb82b882518$var$nextEffect = firstChild;
    for(firstChild = committedLanes ? 9270 : 1024; null !== $dca0ddb82b882518$var$nextEffect;){
        root = $dca0ddb82b882518$var$nextEffect;
        if (committedLanes && (JSCompiler_temp = root.deletions, null !== JSCompiler_temp)) for(anchorOffset = 0; anchorOffset < JSCompiler_temp.length; anchorOffset++)committedLanes && $dca0ddb82b882518$var$commitExitViewTransitions(JSCompiler_temp[anchorOffset]);
        if (null === root.alternate && 0 !== (root.flags & 2)) committedLanes && $dca0ddb82b882518$var$trackEnterViewTransitions(root), $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes);
        else {
            if (22 === root.tag) {
                if (JSCompiler_temp = root.alternate, null !== root.memoizedState) {
                    null !== JSCompiler_temp && null === JSCompiler_temp.memoizedState && committedLanes && $dca0ddb82b882518$var$commitExitViewTransitions(JSCompiler_temp);
                    $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                } else if (null !== JSCompiler_temp && null !== JSCompiler_temp.memoizedState) {
                    committedLanes && $dca0ddb82b882518$var$trackEnterViewTransitions(root);
                    $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                }
            }
            JSCompiler_temp = root.child;
            0 !== (root.subtreeFlags & firstChild) && null !== JSCompiler_temp ? (JSCompiler_temp.return = root, $dca0ddb82b882518$var$nextEffect = JSCompiler_temp) : (committedLanes && $dca0ddb82b882518$var$commitNestedViewTransitions(root), $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes));
        }
    }
    $dca0ddb82b882518$var$appearingViewTransitions = null;
}
function $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(isViewTransitionEligible$jscomp$0) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect, isViewTransitionEligible = isViewTransitionEligible$jscomp$0, current = fiber.alternate, flags = fiber.flags;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (flags & 1024) && null !== current) {
                    isViewTransitionEligible = void 0;
                    flags = current.memoizedProps;
                    current = current.memoizedState;
                    var instance = fiber.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(fiber.type, flags);
                        isViewTransitionEligible = instance.getSnapshotBeforeUpdate(resolvedPrevProps, current);
                        instance.__reactInternalSnapshotBeforeUpdate = isViewTransitionEligible;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (flags & 1024)) {
                    if (current = fiber.stateNode.containerInfo, isViewTransitionEligible = current.nodeType, 9 === isViewTransitionEligible) $dca0ddb82b882518$var$clearContainerSparingly(current);
                    else if (1 === isViewTransitionEligible) switch(current.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(current);
                            break;
                        default:
                            current.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            case 30:
                isViewTransitionEligible && null !== current && (isViewTransitionEligible = $dca0ddb82b882518$var$getViewTransitionName(current.memoizedProps, current.stateNode), flags = fiber.memoizedProps, flags = $dca0ddb82b882518$var$getViewTransitionClassName(flags.default, flags.update), "none" !== flags && $dca0ddb82b882518$var$applyViewTransitionToHostInstances(current, isViewTransitionEligible, flags, current.memoizedState = [], !0));
                break;
            default:
                if (0 !== (flags & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        current = fiber.sibling;
        if (null !== current) {
            current.return = fiber.return;
            $dca0ddb82b882518$var$nextEffect = current;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = fiber.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$146) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$146);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                var newOffscreenSubtreeWasHidden = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                current = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden) && !prevProps ? (flags = 2, 0 !== (finishedWork.subtreeFlags & 8772) && (flags |= 1), $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, flags)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = current;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevProps;
            }
            break;
        case 30:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 7:
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$hideOrUnhideAllChildren(parentFiber, isHidden) {
    for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$hideOrUnhideAllChildrenOnFiber(parentFiber, isHidden), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden) {
    switch(fiber.tag){
        case 5:
        case 26:
            try {
                var instance = fiber.stateNode;
                if (isHidden) {
                    var style = instance.style;
                    "function" === typeof style.setProperty ? style.setProperty("display", "none", "important") : style.display = "none";
                } else {
                    var instance$jscomp$0 = fiber.stateNode, styleProp = fiber.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                    instance$jscomp$0.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                }
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            $dca0ddb82b882518$var$hideOrUnhideNearestPortals(fiber, isHidden);
            break;
        case 6:
            try {
                fiber.stateNode.nodeValue = isHidden ? "" : fiber.memoizedProps, $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 18:
            try {
                var instance$jscomp$1 = fiber.stateNode;
                isHidden ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance$jscomp$1, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(fiber.stateNode, !1);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 22:
        case 23:
            null === fiber.memoizedState && $dca0ddb82b882518$var$hideOrUnhideAllChildren(fiber, isHidden);
            break;
        default:
            $dca0ddb82b882518$var$hideOrUnhideAllChildren(fiber, isHidden);
    }
}
function $dca0ddb82b882518$var$hideOrUnhideNearestPortals(parentFiber, isHidden$jscomp$0) {
    if (parentFiber.subtreeFlags & 67108864) for(parentFiber = parentFiber.child; null !== parentFiber;){
        a: {
            var fiber = parentFiber, isHidden = isHidden$jscomp$0;
            switch(fiber.tag){
                case 4:
                    $dca0ddb82b882518$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden);
                    break a;
                case 22:
                    null === fiber.memoizedState && $dca0ddb82b882518$var$hideOrUnhideNearestPortals(fiber, isHidden);
                    break a;
                default:
                    $dca0ddb82b882518$var$hideOrUnhideNearestPortals(fiber, isHidden);
            }
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && !$dca0ddb82b882518$var$offscreenSubtreeWasHidden && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode, deletedFiber.type, deletedFiber.memoizedProps);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(deletedFiber);
        case 6:
            6 === deletedFiber.tag && $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        case 30:
            $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 7:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber, lanes) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0, lanes), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root, lanes) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            if (flags & 4 && (current = finishedWork.updateQueue, current = null !== current ? current.events : null, null !== current)) for(var ii = 0; ii < current.length; ii++){
                var _eventPayloads$ii2 = current[ii];
                _eventPayloads$ii2.ref.impl = _eventPayloads$ii2.nextImpl;
            }
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (root = finishedWork.callbacks, null !== root && (lanes = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === lanes ? root : lanes.concat(root))));
            break;
        case 26:
            ii = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                if (flags = null !== current ? current.memoizedState : null, lanes = finishedWork.memoizedState, null === current) {
                    if (null === lanes) {
                        if (null === finishedWork.stateNode) {
                            if ($dca0ddb82b882518$var$offscreenSubtreeIsHidden) finishedWork.stateNode = $dca0ddb82b882518$var$createHoistableInstance(finishedWork.type, finishedWork.memoizedProps, root.containerInfo, finishedWork);
                            else {
                                a: {
                                    root = finishedWork.type;
                                    lanes = finishedWork.memoizedProps;
                                    flags = ii.ownerDocument || ii;
                                    b: switch(root){
                                        case "title":
                                            current = flags.getElementsByTagName("title")[0];
                                            if (!current || current[$dca0ddb82b882518$var$internalHoistableMarker] || current[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === current.namespaceURI || current.hasAttribute("itemprop")) current = flags.createElement(root), flags.head.insertBefore(current, flags.querySelector("head > title"));
                                            $dca0ddb82b882518$var$setInitialProperties(current, root, lanes);
                                            current[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                            $dca0ddb82b882518$var$markNodeAsHoistable(current);
                                            root = current;
                                            break a;
                                        case "link":
                                            if (ii = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", flags).get(root + (lanes.href || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("href") === (null == lanes.href || "" === lanes.href ? null : lanes.href) && current.getAttribute("rel") === (null == lanes.rel ? null : lanes.rel) && current.getAttribute("title") === (null == lanes.title ? null : lanes.title) && current.getAttribute("crossorigin") === (null == lanes.crossOrigin ? null : lanes.crossOrigin)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $dca0ddb82b882518$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        case "meta":
                                            if (ii = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", flags).get(root + (lanes.content || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("content") === (null == lanes.content ? null : "" + lanes.content) && current.getAttribute("name") === (null == lanes.name ? null : lanes.name) && current.getAttribute("property") === (null == lanes.property ? null : lanes.property) && current.getAttribute("http-equiv") === (null == lanes.httpEquiv ? null : lanes.httpEquiv) && current.getAttribute("charset") === (null == lanes.charSet ? null : lanes.charSet)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $dca0ddb82b882518$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        default:
                                            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, root));
                                    }
                                    current[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                    $dca0ddb82b882518$var$markNodeAsHoistable(current);
                                    root = current;
                                }
                                finishedWork.stateNode = root;
                            }
                        } else $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(ii, lanes, finishedWork.memoizedProps);
                } else flags !== lanes ? (null === flags ? (root = current.stateNode, null === root || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || root.parentNode.removeChild(root)) : flags.count--, null === lanes ? $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(ii, lanes, finishedWork.memoizedProps)) : null === lanes && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            ii = $dca0ddb82b882518$var$offscreenDirectParentIsHidden;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = !1;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = ii;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                root = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(root, ""), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (root = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, root, null !== current ? current.memoizedProps : root));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                root = finishedWork.memoizedProps;
                lanes = finishedWork.stateNode;
                try {
                    lanes.nodeValue = root, $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
            $dca0ddb82b882518$var$tagCaches = null;
            ii = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$currentHoistableRoot = ii;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
            break;
        case 4:
            flags = $dca0ddb82b882518$var$offscreenDirectParentIsHidden;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            current = $dca0ddb82b882518$var$pushMutationContext();
            ii = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = ii;
            $dca0ddb82b882518$var$viewTransitionMutationContext && $dca0ddb82b882518$var$inUpdateViewTransition && ($dca0ddb82b882518$var$rootViewTransitionAffected = !0);
            $dca0ddb82b882518$var$viewTransitionMutationContext = current;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 22:
            ii = null !== finishedWork.memoizedState;
            _eventPayloads$ii2 = null !== current && null !== current.memoizedState;
            var prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden, prevOffscreenDirectParentIsHidden$166 = $dca0ddb82b882518$var$offscreenDirectParentIsHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || ii;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166 || ii;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _eventPayloads$ii2;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 8192 && (root = finishedWork.stateNode, root._visibility = ii ? root._visibility & -2 : root._visibility | 1, !ii || null === current || _eventPayloads$ii2 || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || (root = _eventPayloads$ii2 || $dca0ddb82b882518$var$offscreenSubtreeWasHidden, lanes = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, current = $dca0ddb82b882518$var$offscreenSubtreeWasHidden, $dca0ddb82b882518$var$offscreenSubtreeIsHidden = ii || $dca0ddb82b882518$var$offscreenSubtreeIsHidden, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = root, $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, 2), $dca0ddb82b882518$var$offscreenSubtreeIsHidden = lanes, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = current), !ii && $dca0ddb82b882518$var$offscreenDirectParentIsHidden || $dca0ddb82b882518$var$hideOrUnhideAllChildren(finishedWork, ii));
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (lanes = root.retryQueue, null !== lanes && (root.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, lanes))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 30:
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags = $dca0ddb82b882518$var$pushMutationContext();
            ii = $dca0ddb82b882518$var$inUpdateViewTransition;
            _eventPayloads$ii2 = (lanes & 335544064) === lanes;
            prevOffscreenSubtreeIsHidden = finishedWork.memoizedProps;
            $dca0ddb82b882518$var$inUpdateViewTransition = _eventPayloads$ii2 && "none" !== $dca0ddb82b882518$var$getViewTransitionClassName(prevOffscreenSubtreeIsHidden.default, prevOffscreenSubtreeIsHidden.update);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            _eventPayloads$ii2 && null !== current && $dca0ddb82b882518$var$viewTransitionMutationContext && (finishedWork.flags |= 4);
            $dca0ddb82b882518$var$inUpdateViewTransition = ii;
            $dca0ddb82b882518$var$viewTransitionMutationContext = flags;
            break;
        case 21:
            break;
        case 7:
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return)), current && null !== current.stateNode && (current.stateNode._fragmentFiber = finishedWork);
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            parentFiber = null;
            for(var parent = finishedWork.return; null !== parent;){
                if ($dca0ddb82b882518$var$isFragmentInstanceParent(parent)) {
                    var fragmentInstance = parent.stateNode;
                    null === parentFiber ? parentFiber = [
                        fragmentInstance
                    ] : parentFiber.push(fragmentInstance);
                }
                if ($dca0ddb82b882518$var$isFragmentInstanceHostBoundary(parent)) break;
                parent = parent.return;
            }
            var JSCompiler_inline_result = parentFiber;
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent$jscomp$0 = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0, JSCompiler_inline_result);
                    break;
                case 5:
                    var parent$149 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$149, ""), hostParentFiber.flags &= -33);
                    var before$150 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$150, parent$149, JSCompiler_inline_result);
                    break;
                case 3:
                case 4:
                    var parent$151 = hostParentFiber.stateNode.containerInfo, before$152 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$152, parent$151, JSCompiler_inline_result);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && (fiber = fiber.stateNode, $dca0ddb82b882518$var$_enabled = !0, fiber.reset(), $dca0ddb82b882518$var$_enabled = !1);
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 9270) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitAfterMutationEffectsOnFiber(parentFiber, root), parentFiber = parentFiber.sibling;
    else $dca0ddb82b882518$var$measureNestedViewTransitions(parentFiber, !1);
}
function $dca0ddb82b882518$var$commitAfterMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate;
    if (null === current) $dca0ddb82b882518$var$commitEnterViewTransitions(finishedWork, !1);
    else switch(finishedWork.tag){
        case 3:
            $dca0ddb82b882518$var$rootViewTransitionNameCanceled = $dca0ddb82b882518$var$viewTransitionContextChanged = !1;
            $dca0ddb82b882518$var$pushViewTransitionCancelableScope();
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            if (!$dca0ddb82b882518$var$viewTransitionContextChanged && !$dca0ddb82b882518$var$rootViewTransitionAffected) {
                finishedWork = $dca0ddb82b882518$var$viewTransitionCancelableChildren;
                if (null !== finishedWork) for(var i = 0; i < finishedWork.length; i += 3){
                    current = finishedWork[i];
                    var oldName = finishedWork[i + 1];
                    $dca0ddb82b882518$var$restoreViewTransitionName(current, finishedWork[i + 2]);
                    current = current.ownerDocument.documentElement;
                    null !== current && current.animate({
                        opacity: [
                            0,
                            0
                        ],
                        pointerEvents: [
                            "none",
                            "none"
                        ]
                    }, {
                        duration: 0,
                        fill: "forwards",
                        pseudoElement: "::view-transition-group(" + oldName + ")"
                    });
                }
                finishedWork = root.containerInfo;
                finishedWork = 9 === finishedWork.nodeType ? finishedWork.documentElement : finishedWork.ownerDocument.documentElement;
                null !== finishedWork && "" === finishedWork.style.viewTransitionName && (finishedWork.style.viewTransitionName = "none", finishedWork.animate({
                    opacity: [
                        0,
                        0
                    ],
                    pointerEvents: [
                        "none",
                        "none"
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition-group(root)"
                }), finishedWork.animate({
                    width: [
                        0,
                        0
                    ],
                    height: [
                        0,
                        0
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition"
                }));
                $dca0ddb82b882518$var$rootViewTransitionNameCanceled = !0;
            }
            $dca0ddb82b882518$var$viewTransitionCancelableChildren = null;
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            break;
        case 4:
            i = $dca0ddb82b882518$var$viewTransitionContextChanged;
            $dca0ddb82b882518$var$viewTransitionContextChanged = !1;
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$viewTransitionContextChanged && ($dca0ddb82b882518$var$rootViewTransitionAffected = !0);
            $dca0ddb82b882518$var$viewTransitionContextChanged = i;
            break;
        case 22:
            null === finishedWork.memoizedState && (null !== current.memoizedState ? $dca0ddb82b882518$var$commitEnterViewTransitions(finishedWork, !1) : $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork));
            break;
        case 30:
            i = $dca0ddb82b882518$var$viewTransitionContextChanged;
            oldName = $dca0ddb82b882518$var$pushViewTransitionCancelableScope();
            $dca0ddb82b882518$var$viewTransitionContextChanged = !1;
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$viewTransitionContextChanged && (finishedWork.flags |= 4);
            var props = finishedWork.memoizedProps, state = finishedWork.stateNode;
            root = $dca0ddb82b882518$var$getViewTransitionName(props, state);
            state = $dca0ddb82b882518$var$getViewTransitionName(current.memoizedProps, state);
            var className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.update);
            "none" === className ? root = !1 : (props = current.memoizedState, current.memoizedState = null, current = finishedWork.child, $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0, root = $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(finishedWork, current, root, state, className, props, !0), $dca0ddb82b882518$var$viewTransitionHostInstanceIdx !== (null === props ? 0 : props.length) && (finishedWork.flags |= 32));
            0 !== (finishedWork.flags & 4) && root ? ($dca0ddb82b882518$var$scheduleViewTransitionEvent(finishedWork, finishedWork.memoizedProps.onUpdate), $dca0ddb82b882518$var$viewTransitionCancelableChildren = oldName) : null !== oldName && (oldName.push.apply(oldName, $dca0ddb82b882518$var$viewTransitionCancelableChildren), $dca0ddb82b882518$var$viewTransitionCancelableChildren = oldName);
            $dca0ddb82b882518$var$viewTransitionContextChanged = 0 !== (finishedWork.flags & 32) ? !0 : i;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber, layoutEffectTraversalFlags$jscomp$0) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber, layoutEffectTraversalFlags = layoutEffectTraversalFlags$jscomp$0;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode, finishedWork.type, finishedWork.memoizedProps);
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(finishedWork);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 6:
                $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(finishedWork);
                break;
            case 26:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || instance.parentNode.removeChild(instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 30:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 7:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, layoutEffectTraversalFlags) {
    layoutEffectTraversalFlags = 0 !== (parentFiber.subtreeFlags & 8772) ? layoutEffectTraversalFlags : layoutEffectTraversalFlags & -2;
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags, includeWorkInProgressEffects = 0 !== (layoutEffectTraversalFlags & 1);
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 5:
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $dca0ddb82b882518$var$commitFragmentInstanceInsertionEffects(finishedWork);
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 6:
                $dca0ddb82b882518$var$commitFragmentInstanceInsertionEffects(finishedWork);
                break;
            case 26:
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$mountHoistable($dca0ddb82b882518$var$getHoistableRoot(instance.ownerDocument), finishedWork.type, instance);
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 7:
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    if (parentFiber.subtreeFlags & (isViewTransitionEligible ? 10262 : 10256)) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
    else isViewTransitionEligible && $dca0ddb82b882518$var$restoreNestedViewTransitions(parentFiber);
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    isViewTransitionEligible && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(finishedWork);
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            isViewTransitionEligible && $dca0ddb82b882518$var$rootViewTransitionNameCanceled && (finishedRoot = finishedRoot.containerInfo, finishedRoot = 9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, "root" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""), finishedRoot = finishedRoot.ownerDocument.documentElement, null !== finishedRoot && "none" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""));
            flags & 2048 && (flags = null, null !== finishedWork.alternate && (flags = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== flags && (finishedWork.refCount++, null != flags && $dca0ddb82b882518$var$releaseCache(flags)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", flags.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? (isViewTransitionEligible && null !== id && null === id.memoizedState && $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(id), _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork)) : (isViewTransitionEligible && null !== id && null !== id.memoizedState && $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(finishedWork), _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1)));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        case 30:
            isViewTransitionEligible && (flags = finishedWork.alternate, null !== flags && ($dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(flags.child, !0), $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(finishedWork.child, !0)));
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && (null !== fiber.memoizedState ? $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps) : (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $dca0ddb82b882518$var$suspendInstance(suspendedState, fiber)));
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $dca0ddb82b882518$var$suspendInstance(suspendedState, fiber));
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        case 30:
            if (0 !== (fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag) && (previousHoistableRoot = fiber.memoizedProps.name, null != previousHoistableRoot && "auto" !== previousHoistableRoot)) {
                var state = fiber.stateNode;
                state.paired = null;
                null === $dca0ddb82b882518$var$appearingViewTransitions && ($dca0ddb82b882518$var$appearingViewTransitions = new Map());
                $dca0ddb82b882518$var$appearingViewTransitions.set(previousHoistableRoot, state);
            }
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$pendingViewTransition = null, $dca0ddb82b882518$var$pendingViewTransitionEvents = null, $dca0ddb82b882518$var$pendingTransitionTypes = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleViewTransitionEvent(fiber, callback) {
    if (null != callback) {
        var state = fiber.stateNode, instance = state.ref;
        null === instance && (instance = state.ref = $dca0ddb82b882518$var$createViewTransitionInstance($dca0ddb82b882518$var$getViewTransitionName(fiber.memoizedProps, state)));
        null === $dca0ddb82b882518$var$pendingViewTransitionEvents && ($dca0ddb82b882518$var$pendingViewTransitionEvents = []);
        $dca0ddb82b882518$var$pendingViewTransitionEvents.push(callback.bind(null, instance));
    }
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result && 6 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes && (lanes & 62914560) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$completeRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$completeRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$completeRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    var subtreeFlags = finishedWork.subtreeFlags, isViewTransitionEligible = (lanes & 335544064) === lanes;
    suspendedCommitReason = null;
    if (isViewTransitionEligible || subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if (suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        }, $dca0ddb82b882518$var$appearingViewTransitions = null, $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason), isViewTransitionEligible && (subtreeFlags = suspendedCommitReason, isViewTransitionEligible = root.containerInfo, isViewTransitionEligible = (9 === isViewTransitionEligible.nodeType ? isViewTransitionEligible : isViewTransitionEligible.ownerDocument).__reactViewTransition, null != isViewTransitionEligible && (subtreeFlags.count++, subtreeFlags.waitingForViewTransition = !0, subtreeFlags = $dca0ddb82b882518$var$onUnsuspend.bind(subtreeFlags), isViewTransitionEligible.finished.then(subtreeFlags, subtreeFlags))), subtreeFlags = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0, subtreeFlags = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, subtreeFlags), null !== subtreeFlags) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = subtreeFlags($dca0ddb82b882518$var$completeRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes = $dca0ddb82b882518$var$getEntangledLanes(root, suspendedLanes);
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$getEntangledLanes(root, lanes);
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$184) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$184);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$186) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$186);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
            var fiber = next;
            fiber === $dca0ddb82b882518$var$hydrationParentFiber && ($dca0ddb82b882518$var$isHydrating ? ($dca0ddb82b882518$var$popToNextHostParent(fiber), 5 === fiber.tag && null != fiber.stateNode && ($dca0ddb82b882518$var$nextHydratableInstance = fiber.stateNode)) : ($dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0));
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState) {
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = remainingLanes;
    remainingLanes |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
    $dca0ddb82b882518$var$markRootFinished(root, lanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    $dca0ddb82b882518$var$pendingViewTransitionEvents = null;
    (lanes & 335544064) === lanes ? ($dca0ddb82b882518$var$pendingTransitionTypes = $dca0ddb82b882518$var$claimQueuedTransitionTypes(root), spawnedLane = 10262) : ($dca0ddb82b882518$var$pendingTransitionTypes = null, spawnedLane = 10256);
    0 !== (finishedWork.subtreeFlags & spawnedLane) || 0 !== (finishedWork.flags & spawnedLane) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
        $dca0ddb82b882518$var$flushPassiveEffects();
        return null;
    })) : (root.callbackNode = null, root.callbackPriority = 0);
    $dca0ddb82b882518$var$shouldStartViewTransition = !1;
    spawnedLane = 0 !== (finishedWork.flags & 13878);
    if (0 !== (finishedWork.subtreeFlags & 13878) || spawnedLane) {
        spawnedLane = $dca0ddb82b882518$var$ReactSharedInternals.T;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        updatedLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
        suspendedRetryLanes = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        try {
            $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
        } finally{
            $dca0ddb82b882518$var$executionContext = suspendedRetryLanes, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = updatedLanes, $dca0ddb82b882518$var$ReactSharedInternals.T = spawnedLane;
        }
    }
    $dca0ddb82b882518$var$pendingEffectsStatus = 1;
    $dca0ddb82b882518$var$shouldStartViewTransition ? $dca0ddb82b882518$var$pendingViewTransition = $dca0ddb82b882518$var$startViewTransition(suspendedState, root.containerInfo, $dca0ddb82b882518$var$pendingTransitionTypes, $dca0ddb82b882518$var$flushMutationEffects, $dca0ddb82b882518$var$flushLayoutEffects, $dca0ddb82b882518$var$flushAfterMutationEffects, $dca0ddb82b882518$var$flushSpawnedWork, $dca0ddb82b882518$var$flushPassiveEffects, $dca0ddb82b882518$var$reportViewTransitionError, null, null) : ($dca0ddb82b882518$var$flushMutationEffects(), $dca0ddb82b882518$var$flushLayoutEffects(), $dca0ddb82b882518$var$flushSpawnedWork());
}
function $dca0ddb82b882518$var$reportViewTransitionError(error) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus) {
        var onRecoverableError = $dca0ddb82b882518$var$pendingEffectsRoot.onRecoverableError;
        onRecoverableError(error, {
            componentStack: null
        });
    }
}
function $dca0ddb82b882518$var$flushAfterMutationEffects() {
    3 === $dca0ddb82b882518$var$pendingEffectsStatus && ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$commitAfterMutationEffectsOnFiber($dca0ddb82b882518$var$pendingFinishedWork, $dca0ddb82b882518$var$pendingEffectsRoot), $dca0ddb82b882518$var$pendingEffectsStatus = 4);
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$inUpdateViewTransition = $dca0ddb82b882518$var$rootViewTransitionAffected = !1;
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root, lanes);
                lanes = $dca0ddb82b882518$var$selectionInformation;
                var curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var committedViewTransition = $dca0ddb82b882518$var$pendingViewTransition;
        $dca0ddb82b882518$var$pendingViewTransition = null;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors, passiveSubtreeMask = (lanes & 335544064) === lanes ? 10262 : 10256;
        0 !== (finishedWork.subtreeFlags & passiveSubtreeMask) || 0 !== (finishedWork.flags & passiveSubtreeMask) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        passiveSubtreeMask = root.pendingLanes;
        0 === passiveSubtreeMask && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            passiveSubtreeMask = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = passiveSubtreeMask;
            }
        }
        recoverableErrors = $dca0ddb82b882518$var$pendingViewTransitionEvents;
        onRecoverableError = $dca0ddb82b882518$var$pendingTransitionTypes;
        $dca0ddb82b882518$var$pendingTransitionTypes = null;
        if (null !== recoverableErrors && ($dca0ddb82b882518$var$pendingViewTransitionEvents = null, null === onRecoverableError && (onRecoverableError = []), null !== committedViewTransition)) for(recoverableError = 0; recoverableError < recoverableErrors.length; recoverableError++)finishedWork = (0, recoverableErrors[recoverableError])(onRecoverableError), void 0 !== finishedWork && committedViewTransition.finished.finally(finishedWork);
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        passiveSubtreeMask = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (passiveSubtreeMask & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null);
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    null !== $dca0ddb82b882518$var$pendingViewTransition && ($dca0ddb82b882518$var$pendingViewTransition.skipTransition(), $dca0ddb82b882518$var$pendingViewTransition = null);
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) ? $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$190 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$190;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$190.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$190.suspendedLanes, pingedLanes = root$190.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$190, root$190 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$190.cancelPendingCommit || -1 !== root$190.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$190, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                }
                root$190 = root$190.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL(actionProp);
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = new FormData(nativeEventTarget, submitter);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = new FormData(nativeEventTarget, submitter), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1667 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1667 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1667++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1668 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1667], $dca0ddb82b882518$var$domEventName$jscomp$inline_1669 = $dca0ddb82b882518$var$eventName$jscomp$inline_1668.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1670 = $dca0ddb82b882518$var$eventName$jscomp$inline_1668[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1668.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1669, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1670);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "submit":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticSubmitEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                SyntheticEventCtor = "mouseover" === domEventName || "pointerover" === domEventName;
                reactName = "mouseout" === domEventName || "pointerout" === domEventName;
                if (SyntheticEventCtor && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (reactName || SyntheticEventCtor) {
                    reactEventType = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (SyntheticEventCtor = nativeEventTarget.ownerDocument) ? SyntheticEventCtor.defaultView || SyntheticEventCtor.parentWindow : window;
                    if (reactName) {
                        if (SyntheticEventCtor = nativeEvent.relatedTarget || nativeEvent.toElement, reactName = targetInst, SyntheticEventCtor = SyntheticEventCtor ? $dca0ddb82b882518$var$getClosestInstanceFromNode(SyntheticEventCtor) : null, null !== SyntheticEventCtor && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(SyntheticEventCtor), inCapturePhase = SyntheticEventCtor.tag, SyntheticEventCtor !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) SyntheticEventCtor = null;
                    } else reactName = null, SyntheticEventCtor = targetInst;
                    if (reactName !== SyntheticEventCtor) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == reactName ? reactEventType : $dca0ddb82b882518$var$getNodeFromInstance(reactName);
                        lastHostComponent = null == SyntheticEventCtor ? reactEventType : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        reactEventType = new inCapturePhase(_instance, instance + "leave", reactName, nativeEvent, nativeEventTarget);
                        reactEventType.target = accumulateTargetOnly;
                        reactEventType.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", SyntheticEventCtor, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        inCapturePhase = reactName && SyntheticEventCtor ? $dca0ddb82b882518$var$getLowestCommonAncestor(reactName, SyntheticEventCtor, $dca0ddb82b882518$var$getParent) : null;
                        null !== reactName && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactEventType, reactName, inCapturePhase, !1);
                        null !== SyntheticEventCtor && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, SyntheticEventCtor, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            if ("string" === typeof value) "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            return;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL(value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "credentialless":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            else return;
    }
    $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "children":
            if ("string" === typeof value) $dca0ddb82b882518$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            return;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            return;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), prevValue = key.slice(2, props ? key.length - 7 : void 0), tag = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, tag = null != tag ? tag[key] : null, "function" === typeof tag && domElement.removeEventListener(prevValue, tag, props), "function" === typeof value)) {
                    "function" !== typeof tag && null !== tag && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(prevValue, value, props);
                    break a;
                }
                $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
            return;
    }
    $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$204 = props[hasSrc];
                if (null != propValue$204) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$204;
                        break;
                    case "type":
                        propValue = propValue$204;
                        break;
                    case "checked":
                        checked = propValue$204;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$204;
                        break;
                    case "value":
                        propKey = propValue$204;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$204;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$204) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$204, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$204 in props)props.hasOwnProperty(propValue$204) && (hasSrc = props[propValue$204], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$204, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
var $dca0ddb82b882518$var$emptyProps = {};
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$221 in nextProps){
                var propKey = nextProps[propKey$221];
                lastProp = lastProps[propKey$221];
                if (nextProps.hasOwnProperty(propKey$221) && (null != propKey || null != lastProp)) switch(propKey$221){
                    case "type":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        type = propKey;
                        break;
                    case "name":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        name = propKey;
                        break;
                    case "checked":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        defaultChecked = propKey;
                        break;
                    case "value":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        value = propKey;
                        break;
                    case "defaultValue":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$221, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$221 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    type !== lastDefaultValue && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    propKey$221 = type;
                    break;
                case "defaultValue":
                    type !== lastDefaultValue && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    defaultValue = type;
                    break;
                case "multiple":
                    type !== lastDefaultValue && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0), value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$221 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$221, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$221 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    name !== type && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    propKey$221 = name;
                    break;
                case "defaultValue":
                    name !== type && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$221, propKey);
            return;
        case "option":
            for(var propKey$237 in lastProps)if (propKey$221 = lastProps[propKey$237], lastProps.hasOwnProperty(propKey$237) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$237)) switch(propKey$237){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$237, null, nextProps, propKey$221);
            }
            for(lastDefaultValue in nextProps)if (propKey$221 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    propKey$221 !== propKey && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    domElement.selected = propKey$221 && "function" !== typeof propKey$221 && "symbol" !== typeof propKey$221;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$221, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$242 in lastProps)propKey$221 = lastProps[propKey$242], lastProps.hasOwnProperty(propKey$242) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$242) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$242, null, nextProps, propKey$221);
            for(checked in nextProps)if (propKey$221 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$221) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$221, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$247 in lastProps)propKey$221 = lastProps[propKey$247], lastProps.hasOwnProperty(propKey$247) && void 0 !== propKey$221 && !nextProps.hasOwnProperty(propKey$247) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$247, void 0, nextProps, propKey$221);
                for(defaultChecked in nextProps)propKey$221 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$221 === propKey || void 0 === propKey$221 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$221, nextProps, propKey);
                return;
            }
    }
    for(var propKey$252 in lastProps)propKey$221 = lastProps[propKey$252], lastProps.hasOwnProperty(propKey$252) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$252) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$252, null, nextProps, propKey$221);
    for(lastProp in nextProps)propKey$221 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$221 === propKey || null == propKey$221 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$221, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$createHoistableInstance(type, props, rootContainerInstance, internalInstanceHandle) {
    rootContainerInstance = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance).createElement(type);
    rootContainerInstance[$dca0ddb82b882518$var$internalInstanceKey] = internalInstanceHandle;
    rootContainerInstance[$dca0ddb82b882518$var$internalPropsKey] = props;
    $dca0ddb82b882518$var$setInitialProperties(rootContainerInstance, type, props);
    $dca0ddb82b882518$var$markNodeAsHoistable(rootContainerInstance);
    return rootContainerInstance;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$localRequestAnimationFrame = "function" === typeof requestAnimationFrame ? requestAnimationFrame : $dca0ddb82b882518$var$scheduleTimeout, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$clearSingletonPreambleContribution(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$applyViewTransitionName(instance, name, className) {
    name = CSS.escape(name) !== name ? "r-" + btoa(name).replace(/=/g, "") : name;
    instance.style.viewTransitionName = name;
    null != className && (instance.style.viewTransitionClass = className);
    className = getComputedStyle(instance);
    if ("inline" === className.display) {
        name = instance.getClientRects();
        if (1 === name.length) var JSCompiler_inline_result = 1;
        else for(var i = JSCompiler_inline_result = 0; i < name.length; i++){
            var rect = name[i];
            0 < rect.width && 0 < rect.height && JSCompiler_inline_result++;
        }
        1 === JSCompiler_inline_result && (instance = instance.style, instance.display = 1 === name.length ? "inline-block" : "block", instance.marginTop = "-" + className.paddingTop, instance.marginBottom = "-" + className.paddingBottom);
    }
}
function $dca0ddb82b882518$var$restoreViewTransitionName(instance, props) {
    instance = instance.style;
    props = props.style;
    var viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionName") ? props.viewTransitionName : props.hasOwnProperty("view-transition-name") ? props["view-transition-name"] : null : null;
    instance.viewTransitionName = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionClass") ? props.viewTransitionClass : props.hasOwnProperty("view-transition-class") ? props["view-transition-class"] : null : null;
    instance.viewTransitionClass = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    "inline-block" === instance.display && (null == props ? instance.display = instance.margin = "" : (viewTransitionName = props.display, instance.display = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, viewTransitionName = props.margin, null != viewTransitionName ? instance.margin = viewTransitionName : (viewTransitionName = props.hasOwnProperty("marginTop") ? props.marginTop : props["margin-top"], instance.marginTop = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, props = props.hasOwnProperty("marginBottom") ? props.marginBottom : props["margin-bottom"], instance.marginBottom = null == props || "boolean" === typeof props ? "" : props)));
}
function $dca0ddb82b882518$var$createMeasurement(rect, computedStyle, element) {
    element = element.ownerDocument.defaultView;
    return {
        rect: rect,
        abs: "absolute" === computedStyle.position || "fixed" === computedStyle.position,
        clip: "none" !== computedStyle.clipPath || "visible" !== computedStyle.overflow || "none" !== computedStyle.filter || "none" !== computedStyle.mask || "none" !== computedStyle.mask || "0px" !== computedStyle.borderRadius,
        view: 0 <= rect.bottom && 0 <= rect.right && rect.top <= element.innerHeight && rect.left <= element.innerWidth
    };
}
function $dca0ddb82b882518$var$measureInstance(instance) {
    var rect = instance.getBoundingClientRect(), computedStyle = getComputedStyle(instance);
    return $dca0ddb82b882518$var$createMeasurement(rect, computedStyle, instance);
}
function $dca0ddb82b882518$var$measureClonedInstance(instance) {
    var measuredRect = instance.getBoundingClientRect();
    measuredRect = new DOMRect(measuredRect.x + 2e4, measuredRect.y + 2e4, measuredRect.width, measuredRect.height);
    var computedStyle = getComputedStyle(instance);
    return $dca0ddb82b882518$var$createMeasurement(measuredRect, computedStyle, instance);
}
function $dca0ddb82b882518$var$forceLayout(ownerDocument) {
    return ownerDocument.documentElement.clientHeight;
}
function $dca0ddb82b882518$var$waitForImageToLoad(resolve) {
    this.addEventListener("load", resolve);
    this.addEventListener("error", resolve);
}
function $dca0ddb82b882518$var$startViewTransition(suspendedState, rootContainer, transitionTypes, mutationCallback, layoutCallback, afterMutationCallback, spawnedWorkCallback, passiveCallback, errorCallback) {
    var ownerDocument = 9 === rootContainer.nodeType ? rootContainer : rootContainer.ownerDocument;
    try {
        var transition = ownerDocument.startViewTransition({
            update: function() {
                var ownerWindow = ownerDocument.defaultView, pendingNavigation = ownerWindow.navigation && ownerWindow.navigation.transition, previousFontLoadingStatus = ownerDocument.fonts.status;
                mutationCallback();
                var blockingPromises = [];
                "loaded" === previousFontLoadingStatus && ($dca0ddb82b882518$var$forceLayout(ownerDocument), "loading" === ownerDocument.fonts.status && blockingPromises.push(ownerDocument.fonts.ready));
                previousFontLoadingStatus = blockingPromises.length;
                if (null !== suspendedState) for(var suspenseyImages = suspendedState.suspenseyImages, imgBytes = 0, i = 0; i < suspenseyImages.length; i++){
                    var suspenseyImage = suspenseyImages[i];
                    if (!suspenseyImage.complete) {
                        var rect = suspenseyImage.getBoundingClientRect();
                        if (0 < rect.bottom && 0 < rect.right && rect.top < ownerWindow.innerHeight && rect.left < ownerWindow.innerWidth) {
                            imgBytes += $dca0ddb82b882518$var$estimateImageBytes(suspenseyImage);
                            if (imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit) {
                                blockingPromises.length = previousFontLoadingStatus;
                                break;
                            }
                            suspenseyImage = new Promise($dca0ddb82b882518$var$waitForImageToLoad.bind(suspenseyImage));
                            blockingPromises.push(suspenseyImage);
                        }
                    }
                }
                if (0 < blockingPromises.length) return ownerWindow = Promise.race([
                    Promise.all(blockingPromises),
                    new Promise(function(resolve) {
                        return setTimeout(resolve, 500);
                    })
                ]).then(layoutCallback, layoutCallback), (pendingNavigation ? Promise.allSettled([
                    pendingNavigation.finished,
                    ownerWindow
                ]) : ownerWindow).then(afterMutationCallback, afterMutationCallback);
                layoutCallback();
                if (pendingNavigation) return pendingNavigation.finished.then(afterMutationCallback, afterMutationCallback);
                afterMutationCallback();
            },
            types: transitionTypes
        });
        ownerDocument.__reactViewTransition = transition;
        var viewTransitionAnimations = [];
        transition.ready.then(function() {
            for(var animations = ownerDocument.documentElement.getAnimations({
                subtree: !0
            }), i = 0; i < animations.length; i++){
                var animation = animations[i], effect = animation.effect, pseudoElement = effect.pseudoElement;
                if (null != pseudoElement && pseudoElement.startsWith("::view-transition")) {
                    viewTransitionAnimations.push(animation);
                    animation = effect.getKeyframes();
                    for(var height = pseudoElement = void 0, unchangedDimensions = !0, j = 0; j < animation.length; j++){
                        var keyframe = animation[j], w = keyframe.width;
                        if (void 0 === pseudoElement) pseudoElement = w;
                        else if (pseudoElement !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        w = keyframe.height;
                        if (void 0 === height) height = w;
                        else if (height !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        delete keyframe.width;
                        delete keyframe.height;
                        "none" === keyframe.transform && delete keyframe.transform;
                    }
                    unchangedDimensions && void 0 !== pseudoElement && void 0 !== height && (effect.setKeyframes(animation), unchangedDimensions = getComputedStyle(effect.target, effect.pseudoElement), unchangedDimensions.width !== pseudoElement || unchangedDimensions.height !== height) && (unchangedDimensions = animation[0], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, unchangedDimensions = animation[animation.length - 1], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, effect.setKeyframes(animation));
                }
            }
            spawnedWorkCallback();
        }, function(error) {
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            try {
                if ("object" === typeof error && null !== error) switch(error.name){
                    case "InvalidStateError":
                        if ("View transition was skipped because document visibility state is hidden." === error.message || "Skipping view transition because document visibility state has become hidden." === error.message || "Skipping view transition because viewport size changed." === error.message || "Transition was aborted because of invalid state" === error.message) error = null;
                }
                null !== error && errorCallback(error);
            } finally{
                mutationCallback(), layoutCallback(), spawnedWorkCallback();
            }
        });
        transition.finished.finally(function() {
            for(var i = 0; i < viewTransitionAnimations.length; i++)viewTransitionAnimations[i].cancel();
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            passiveCallback();
        });
        return transition;
    } catch (x) {
        return mutationCallback(), layoutCallback(), spawnedWorkCallback(), null;
    }
}
function $dca0ddb82b882518$var$ViewTransitionPseudoElement(pseudo, name) {
    this._scope = document.documentElement;
    this._selector = "::view-transition-" + pseudo + "(" + name + ")";
}
$dca0ddb82b882518$var$ViewTransitionPseudoElement.prototype.animate = function(keyframes, options) {
    options = "number" === typeof options ? {
        duration: options
    } : $dca0ddb82b882518$var$assign({}, options);
    options.pseudoElement = this._selector;
    return this._scope.animate(keyframes, options);
};
$dca0ddb82b882518$var$ViewTransitionPseudoElement.prototype.getAnimations = function() {
    for(var scope = this._scope, selector = this._selector, animations = scope.getAnimations({
        subtree: !0
    }), result = [], i = 0; i < animations.length; i++){
        var effect = animations[i].effect;
        null !== effect && effect.target === scope && effect.pseudoElement === selector && result.push(animations[i]);
    }
    return result;
};
$dca0ddb82b882518$var$ViewTransitionPseudoElement.prototype.getComputedStyle = function() {
    return getComputedStyle(this._scope, this._selector);
};
function $dca0ddb82b882518$var$createViewTransitionInstance(name) {
    return {
        name: name,
        group: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("group", name),
        imagePair: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("image-pair", name),
        old: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("old", name),
        new: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("new", name)
    };
}
function $dca0ddb82b882518$var$FragmentInstance(fragmentFiber) {
    this._fragmentFiber = fragmentFiber;
    this._observers = this._eventListeners = null;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.addEventListener = function(type, listener, optionsOrUseCapture) {
    var signal = null, cleanup = null;
    if (null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && (signal = optionsOrUseCapture.signal || null, null !== signal && signal.aborted)) return;
    null === this._eventListeners && (this._eventListeners = []);
    var listeners = this._eventListeners;
    if (-1 === $dca0ddb82b882518$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture)) {
        var fragmentInstance = this, attachedListener = listener;
        null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && !0 === optionsOrUseCapture.once && (attachedListener = function(event) {
            fragmentInstance.removeEventListener(type, listener, optionsOrUseCapture);
            "function" === typeof listener ? listener.call(this, event) : listener.handleEvent(event);
        });
        null !== signal && (cleanup = fragmentInstance.removeEventListener.bind(fragmentInstance, type, listener, optionsOrUseCapture), signal.addEventListener("abort", cleanup, {
            once: !0
        }), cleanup = signal.removeEventListener.bind(signal, "abort", cleanup));
        signal = $dca0ddb82b882518$var$getAttachOptions(optionsOrUseCapture);
        listeners.push({
            type: type,
            listener: listener,
            optionsOrUseCapture: optionsOrUseCapture,
            attachedListener: attachedListener,
            cleanup: cleanup
        });
        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$addEventListenerToChild, type, attachedListener, signal);
    }
    this._eventListeners = listeners;
};
function $dca0ddb82b882518$var$addEventListenerToChild(child, type, listener, optionsOrUseCapture) {
    $dca0ddb82b882518$var$getInstanceFromHostFiber(child).addEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.removeEventListener = function(type, listener, optionsOrUseCapture) {
    var listeners = this._eventListeners;
    if (null !== listeners && (listener = $dca0ddb82b882518$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture), -1 !== listener)) {
        var _listeners$index = listeners[listener];
        optionsOrUseCapture = _listeners$index.attachedListener;
        var cleanup = _listeners$index.cleanup;
        _listeners$index = $dca0ddb82b882518$var$getAttachOptions(_listeners$index.optionsOrUseCapture);
        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$removeEventListenerFromChild, type, optionsOrUseCapture, _listeners$index);
        listeners.splice(listener, 1);
        null !== cleanup && cleanup();
    }
};
function $dca0ddb82b882518$var$removeEventListenerFromChild(child, type, listener, optionsOrUseCapture) {
    $dca0ddb82b882518$var$getInstanceFromHostFiber(child).removeEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
function $dca0ddb82b882518$var$getAttachOptions(opts) {
    return null != opts && "boolean" !== typeof opts && (!0 === opts.once || opts.signal instanceof AbortSignal) ? {
        capture: opts.capture,
        passive: opts.passive
    } : opts;
}
function $dca0ddb82b882518$var$normalizeListenerOptions(opts) {
    return null == opts ? "c=0" : "boolean" === typeof opts ? "c=" + (opts ? "1" : "0") : "c=" + (opts.capture ? "1" : "0");
}
function $dca0ddb82b882518$var$indexOfEventListener(eventListeners, type, listener, optionsOrUseCapture) {
    if (0 === eventListeners.length) return -1;
    optionsOrUseCapture = $dca0ddb82b882518$var$normalizeListenerOptions(optionsOrUseCapture);
    for(var i = 0; i < eventListeners.length; i++){
        var item = eventListeners[i];
        if (item.type === type && item.listener === listener && $dca0ddb82b882518$var$normalizeListenerOptions(item.optionsOrUseCapture) === optionsOrUseCapture) return i;
    }
    return -1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.dispatchEvent = function(event) {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return !0;
    parentHostFiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber);
    var eventListeners = this._eventListeners;
    if (null !== eventListeners && 0 < eventListeners.length || !event.bubbles) {
        var temp = 9 === parentHostFiber.nodeType ? parentHostFiber.createComment("") : document.createTextNode("");
        if (eventListeners) for(var i = 0; i < eventListeners.length; i++){
            var _eventListeners$i = eventListeners[i];
            temp.addEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        }
        parentHostFiber.appendChild(temp);
        event = temp.dispatchEvent(event);
        if (eventListeners) for(i = 0; i < eventListeners.length; i++)_eventListeners$i = eventListeners[i], temp.removeEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        parentHostFiber.removeChild(temp);
        return event;
    }
    return parentHostFiber.dispatchEvent(event);
};
$dca0ddb82b882518$var$FragmentInstance.prototype.focus = function(focusOptions) {
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $dca0ddb82b882518$var$setFocusOnFiberIfFocusable, focusOptions, void 0, void 0);
};
function $dca0ddb82b882518$var$setFocusOnFiberIfFocusable(fiber, focusOptions) {
    if (6 === fiber.tag) return !1;
    fiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(fiber);
    return $dca0ddb82b882518$var$setFocusIfFocusable(fiber, focusOptions);
}
$dca0ddb82b882518$var$FragmentInstance.prototype.focusLast = function(focusOptions) {
    var children = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $dca0ddb82b882518$var$collectChildren, children, void 0, void 0);
    for(var i = children.length - 1; 0 <= i && !$dca0ddb82b882518$var$setFocusOnFiberIfFocusable(children[i], focusOptions); i--);
};
function $dca0ddb82b882518$var$collectChildren(child, collection) {
    collection.push(child);
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.blur = function() {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    null !== parentHostFiber && (parentHostFiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber), parentHostFiber = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(parentHostFiber).activeElement, null !== parentHostFiber && $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$blurActiveElementWithinFragment, parentHostFiber, void 0, void 0));
};
function $dca0ddb82b882518$var$blurActiveElementWithinFragment(child, activeElement) {
    if (6 === child.tag) return !1;
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    return child === activeElement || child.contains(activeElement) ? (activeElement.blur(), !0) : !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.observeUsing = function(observer) {
    null === this._observers && (this._observers = new Set());
    this._observers.add(observer);
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$observeChild, observer, void 0, void 0);
};
function $dca0ddb82b882518$var$observeChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    observer.observe(child);
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.unobserveUsing = function(observer) {
    var observers = this._observers;
    if (null !== observers && observers.has(observer)) {
        observers.delete(observer);
        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$unobserveChild, observer, void 0, void 0);
        for(var i = observers = 0; i < $dca0ddb82b882518$var$pendingIntersectionUnobserves.length; i++){
            var pending = $dca0ddb82b882518$var$pendingIntersectionUnobserves[i];
            pending.fragmentInstance === this && pending.observer === observer ? observer.unobserve(pending.instance) : $dca0ddb82b882518$var$pendingIntersectionUnobserves[observers++] = pending;
        }
        $dca0ddb82b882518$var$pendingIntersectionUnobserves.length = observers;
    }
};
function $dca0ddb82b882518$var$unobserveChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    observer.unobserve(child);
    return !1;
}
var $dca0ddb82b882518$var$pendingIntersectionUnobserves = [], $dca0ddb82b882518$var$intersectionUnobserveScheduled = !1;
function $dca0ddb82b882518$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, instance) {
    $dca0ddb82b882518$var$pendingIntersectionUnobserves.push({
        fragmentInstance: fragmentInstance,
        observer: observer,
        instance: instance
    });
    $dca0ddb82b882518$var$intersectionUnobserveScheduled || ($dca0ddb82b882518$var$intersectionUnobserveScheduled = !0, $dca0ddb82b882518$var$requestPostPaintCallback(function() {
        $dca0ddb82b882518$var$intersectionUnobserveScheduled = !1;
        var pending = $dca0ddb82b882518$var$pendingIntersectionUnobserves;
        $dca0ddb82b882518$var$pendingIntersectionUnobserves = [];
        for(var i = 0; i < pending.length; i++){
            var item = pending[i];
            item.observer.unobserve(item.instance);
        }
    }));
}
$dca0ddb82b882518$var$FragmentInstance.prototype.getClientRects = function() {
    var rects = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$collectClientRects, rects, void 0, void 0);
    return rects;
};
function $dca0ddb82b882518$var$collectClientRects(child, rects) {
    if (6 === child.tag) {
        child = child.stateNode;
        var range = child.ownerDocument.createRange();
        range.selectNodeContents(child);
        rects.push.apply(rects, range.getClientRects());
    } else child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child), rects.push.apply(rects, child.getClientRects());
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.getRootNode = function(getRootNodeOptions) {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    return null === parentHostFiber ? this : $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber).getRootNode(getRootNodeOptions);
};
$dca0ddb82b882518$var$FragmentInstance.prototype.compareDocumentPosition = function(otherNode) {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return Node.DOCUMENT_POSITION_DISCONNECTED;
    var children = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$collectChildren, children, void 0, void 0);
    var parentHostInstance = $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber);
    if (0 === children.length) {
        children = parentHostInstance;
        if ($dca0ddb82b882518$var$fiberIsPortaledIntoHost(this._fragmentFiber)) {
            a: {
                for(parentHostFiber = this._fragmentFiber.return; null !== parentHostFiber;){
                    if (4 === parentHostFiber.tag) {
                        parentHostFiber = parentHostFiber.stateNode.containerInfo;
                        break a;
                    }
                    if (3 === parentHostFiber.tag || 5 === parentHostFiber.tag || 27 === parentHostFiber.tag) break;
                    parentHostFiber = parentHostFiber.return;
                }
                parentHostFiber = null;
            }
            null != parentHostFiber && (children = parentHostFiber);
        }
        parentHostFiber = this._fragmentFiber;
        var result = parentHostInstance = children.compareDocumentPosition(otherNode);
        children === otherNode ? result = Node.DOCUMENT_POSITION_CONTAINS : parentHostInstance & Node.DOCUMENT_POSITION_CONTAINED_BY && (children = $dca0ddb82b882518$var$getFragmentInstanceOrTextInstanceSiblings(parentHostFiber)[1], null === children ? result = Node.DOCUMENT_POSITION_PRECEDING : (otherNode = $dca0ddb82b882518$var$getInstanceFromHostFiber(children).compareDocumentPosition(otherNode), result = 0 === otherNode || otherNode & Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : Node.DOCUMENT_POSITION_PRECEDING));
        return result |= Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
    }
    parentHostFiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(children[0]);
    result = $dca0ddb82b882518$var$getInstanceFromHostFiber(children[children.length - 1]);
    var parentHostInstanceFromDOM = $dca0ddb82b882518$var$fiberIsPortaledIntoHost(this._fragmentFiber) ? parentHostFiber.parentElement : parentHostInstance;
    if (null == parentHostInstanceFromDOM) return Node.DOCUMENT_POSITION_DISCONNECTED;
    parentHostInstance = parentHostInstanceFromDOM.compareDocumentPosition(parentHostFiber) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    parentHostInstanceFromDOM = parentHostInstanceFromDOM.compareDocumentPosition(result) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    var firstResult = parentHostFiber.compareDocumentPosition(otherNode), lastResult = result.compareDocumentPosition(otherNode), otherNodeIsWithinFirstOrLastChild = firstResult & Node.DOCUMENT_POSITION_CONTAINED_BY || lastResult & Node.DOCUMENT_POSITION_CONTAINED_BY;
    lastResult = parentHostInstance && parentHostInstanceFromDOM && firstResult & Node.DOCUMENT_POSITION_FOLLOWING && lastResult & Node.DOCUMENT_POSITION_PRECEDING;
    parentHostFiber = parentHostInstance && parentHostFiber === otherNode || parentHostInstanceFromDOM && result === otherNode || otherNodeIsWithinFirstOrLastChild || lastResult ? Node.DOCUMENT_POSITION_CONTAINED_BY : !parentHostInstance && parentHostFiber === otherNode || !parentHostInstanceFromDOM && result === otherNode ? Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC : firstResult;
    return parentHostFiber & Node.DOCUMENT_POSITION_DISCONNECTED || parentHostFiber & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC || $dca0ddb82b882518$var$validateDocumentPositionWithFiberTree(parentHostFiber, this._fragmentFiber, children[0], children[children.length - 1], otherNode) ? parentHostFiber : Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
};
function $dca0ddb82b882518$var$validateDocumentPositionWithFiberTree(documentPosition, fragmentFiber, precedingBoundaryFiber, followingBoundaryFiber, otherNode) {
    var otherFiber = $dca0ddb82b882518$var$getClosestInstanceFromNode(otherNode);
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINED_BY) {
        if (precedingBoundaryFiber = !!otherFiber) a: {
            for(; null !== otherFiber;){
                if (7 === otherFiber.tag && (otherFiber === fragmentFiber || otherFiber.alternate === fragmentFiber)) {
                    precedingBoundaryFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            precedingBoundaryFiber = !1;
        }
        return precedingBoundaryFiber;
    }
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINS) {
        if (null === otherFiber) return otherFiber = otherNode.ownerDocument, otherNode === otherFiber || otherNode === otherFiber.documentElement || otherNode === otherFiber.body;
        a: {
            otherFiber = fragmentFiber;
            for(fragmentFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(fragmentFiber); null !== otherFiber;){
                if (!(5 !== otherFiber.tag && 3 !== otherFiber.tag && 27 !== otherFiber.tag || otherFiber !== fragmentFiber && otherFiber.alternate !== fragmentFiber)) {
                    otherFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            otherFiber = !1;
        }
        return otherFiber;
    }
    return documentPosition & Node.DOCUMENT_POSITION_PRECEDING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === precedingBoundaryFiber) && (fragmentFiber = $dca0ddb82b882518$var$getLowestCommonAncestor(precedingBoundaryFiber, otherFiber, $dca0ddb82b882518$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $dca0ddb82b882518$var$isFiberPrecedingCheck, otherFiber, precedingBoundaryFiber), otherFiber = $dca0ddb82b882518$var$searchTarget, $dca0ddb82b882518$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : documentPosition & Node.DOCUMENT_POSITION_FOLLOWING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === followingBoundaryFiber) && (fragmentFiber = $dca0ddb82b882518$var$getLowestCommonAncestor(followingBoundaryFiber, otherFiber, $dca0ddb82b882518$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $dca0ddb82b882518$var$isFiberFollowingCheck, otherFiber, followingBoundaryFiber), otherFiber = $dca0ddb82b882518$var$searchTarget, $dca0ddb82b882518$var$searchBoundary = $dca0ddb82b882518$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : !1;
}
function $dca0ddb82b882518$var$scrollTextNodeIntoView(textNode, resolvedAlignToTop) {
    var range = textNode.ownerDocument.createRange();
    range.selectNodeContents(textNode);
    textNode = range.getBoundingClientRect();
    window.scrollTo(window.scrollX + textNode.left, resolvedAlignToTop ? window.scrollY + textNode.top : window.scrollY + textNode.bottom - window.innerHeight);
}
$dca0ddb82b882518$var$FragmentInstance.prototype.scrollIntoView = function(alignToTop) {
    if ("object" === typeof alignToTop) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(566));
    var children = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$collectChildren, children, void 0, void 0);
    var resolvedAlignToTop = !1 !== alignToTop;
    if (0 === children.length) {
        var hostSiblings = $dca0ddb82b882518$var$getFragmentInstanceOrTextInstanceSiblings(this._fragmentFiber);
        hostSiblings = resolvedAlignToTop ? hostSiblings[1] || hostSiblings[0] || $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber) : hostSiblings[0] || hostSiblings[1];
        if (null === hostSiblings) return;
        if (6 === hostSiblings.tag) {
            alignToTop = $dca0ddb82b882518$var$getInstanceFromHostFiber(hostSiblings);
            $dca0ddb82b882518$var$scrollTextNodeIntoView(alignToTop, resolvedAlignToTop);
            return;
        }
        hostSiblings = $dca0ddb82b882518$var$getInstanceFromHostFiber(hostSiblings);
        if (9 !== hostSiblings.nodeType) {
            if (11 === hostSiblings.nodeType) {
                resolvedAlignToTop = "host" in hostSiblings ? hostSiblings.host : null;
                null !== resolvedAlignToTop && resolvedAlignToTop.scrollIntoView(alignToTop);
                return;
            }
            hostSiblings.scrollIntoView(alignToTop);
        }
    }
    for(hostSiblings = resolvedAlignToTop ? children.length - 1 : 0; hostSiblings !== (resolvedAlignToTop ? -1 : children.length);){
        var child = children[hostSiblings];
        6 === child.tag ? (child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child), $dca0ddb82b882518$var$scrollTextNodeIntoView(child, resolvedAlignToTop)) : $dca0ddb82b882518$var$getInstanceFromHostFiber(child).scrollIntoView(alignToTop);
        hostSiblings += resolvedAlignToTop ? -1 : 1;
    }
};
function $dca0ddb82b882518$var$addFragmentHandleToFiber(child, fragmentInstance) {
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    $dca0ddb82b882518$var$addFragmentHandleToInstance(child, fragmentInstance);
    return !1;
}
function $dca0ddb82b882518$var$addFragmentHandleToInstance(instance, fragmentInstance) {
    null == instance.reactFragments && (instance.reactFragments = new Set());
    instance.reactFragments.add(fragmentInstance);
}
function $dca0ddb82b882518$var$commitNewChildToFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i$jscomp$0 = 0; i$jscomp$0 < eventListeners.length; i$jscomp$0++){
        var _eventListeners$i3 = eventListeners[i$jscomp$0];
        childInstance.addEventListener(_eventListeners$i3.type, _eventListeners$i3.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i3.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        for(var writeIdx = 0, i = 0; i < $dca0ddb82b882518$var$pendingIntersectionUnobserves.length; i++){
            var pending = $dca0ddb82b882518$var$pendingIntersectionUnobserves[i];
            if (pending.fragmentInstance !== fragmentInstance || pending.observer !== observer || pending.instance !== childInstance) $dca0ddb82b882518$var$pendingIntersectionUnobserves[writeIdx++] = pending;
        }
        $dca0ddb82b882518$var$pendingIntersectionUnobserves.length = writeIdx;
        observer.observe(childInstance);
    }), $dca0ddb82b882518$var$addFragmentHandleToInstance(childInstance, fragmentInstance));
}
function $dca0ddb82b882518$var$deleteChildFromFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i = 0; i < eventListeners.length; i++){
        var _eventListeners$i4 = eventListeners[i];
        childInstance.removeEventListener(_eventListeners$i4.type, _eventListeners$i4.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i4.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        "string" === typeof observer.rootMargin ? $dca0ddb82b882518$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, childInstance) : observer.unobserve(childInstance);
    }), null != childInstance.reactFragments && childInstance.reactFragments.delete(fragmentInstance));
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$setFocusIfFocusable(node, focusOptions) {
    function handleFocus() {
        didFocus = !0;
    }
    if (node.ownerDocument.activeElement === node) return !0;
    var didFocus = !1;
    try {
        node.ownerDocument.addEventListener("focus", handleFocus, !0), (node.focus || HTMLElement.prototype.focus).call(node, focusOptions);
    } finally{
        node.ownerDocument.removeEventListener("focus", handleFocus, !0);
    }
    return didFocus;
}
function $dca0ddb82b882518$var$requestPostPaintCallback(callback) {
    $dca0ddb82b882518$var$localRequestAnimationFrame(function() {
        $dca0ddb82b882518$var$localRequestAnimationFrame(function(time) {
            return callback(time);
        });
    });
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance, type, props) {
    for(var propKey in props){
        var propValue = props[propKey];
        props.hasOwnProperty(propKey) && null != propValue && $dca0ddb82b882518$var$setProp(instance, type, propKey, null, $dca0ddb82b882518$var$emptyProps, propValue);
    }
    null != props.dangerouslySetInnerHTML && (instance.textContent = "");
    instance.onclick === $dca0ddb82b882518$var$noop$1 && (instance.onclick = null);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
function $dca0ddb82b882518$var$clearSingletonPreambleContribution(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    if ("function" === typeof container.getRootNode) {
        var rootNode = container.getRootNode();
        if (9 === rootNode.nodeType || 11 === rootNode.nodeType) return rootNode;
    }
    return 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!($dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))))) {
            var instance = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", href);
            "style" === as && (instance[$dca0ddb82b882518$var$internalLoadPendingKey] = !0, instance.onload = instance.onerror = function() {
                $dca0ddb82b882518$var$clearPendingLoadOnNode(instance);
            });
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            ownerDocument.head.appendChild(instance);
        }
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), currentProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$268 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$269 = styles$268.get(type);
                resource$269 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$269 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$268.set(type, resource$269), (styles$268 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) ? styles$268._p || (resource$269.instance = styles$268, resource$269.state.loading = 5) : (styles$268 = $dca0ddb82b882518$var$preloadPropsMap.get(type), styles$268 || (styles$268 = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, styles$268)), $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, styles$268, resource$269.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$269;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), currentProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    if (key = ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]")) {
        if (!0 !== key[$dca0ddb82b882518$var$internalLoadPendingKey]) {
            state.loading = 1;
            return;
        }
    } else key = ownerDocument.createElement("link"), key[$dca0ddb82b882518$var$internalLoadPendingKey] = !0, key.onload = key.onerror = $dca0ddb82b882518$var$clearPendingLoadOnNode.bind(null, key), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key);
    state.preload = key;
    key.addEventListener("load", function() {
        return state.loading |= 1;
    });
    key.addEventListener("error", function() {
        return state.loading |= 2;
    });
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$274 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$274) return resource.state.loading |= 4, resource.instance = instance$274, $dca0ddb82b882518$var$markNodeAsHoistable(instance$274), instance$274;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$274 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$274);
            var linkInstance = instance$274;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$274, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$274, props.precedence, hoistableRoot);
            return resource.instance = instance$274;
        case "script":
            instance$274 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$274))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$274)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$maySuspendCommit(type, props) {
    return "img" === type && null != props.src && "" !== props.src && null == props.onLoad && "lazy" !== props.loading;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$estimateImageBytes(instance) {
    return (instance.width || 100) * (instance.height || 100) * ("number" === typeof devicePixelRatio ? devicePixelRatio : 1) * 0.25;
}
function $dca0ddb82b882518$var$suspendInstance(state, instance) {
    "function" === typeof instance.decode && (state.imgCount++, instance.complete || (state.imgBytes += $dca0ddb82b882518$var$estimateImageBytes(instance), state.suspenseyImages.push(instance)), state = $dca0ddb82b882518$var$onUnsuspendImg.bind(state), instance.decode().then(state, state));
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$checkIfFullyUnsuspended(state) {
    if (0 === state.count && (0 === state.imgCount || !state.waitingForImages)) {
        if (state.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
        else if (state.unsuspend) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
        }
    }
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    $dca0ddb82b882518$var$checkIfFullyUnsuspended(this);
}
function $dca0ddb82b882518$var$onUnsuspendImg() {
    this.imgCount--;
    $dca0ddb82b882518$var$checkIfFullyUnsuspended(this);
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.transitionTypes = null;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "fullscreenerror":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "resize":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_2043 = $acw62.version;
if ("19.3.1" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_2043) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_2043, "19.3.1"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2586 = {
    bundleType: 0,
    version: "19.3.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.3.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2587 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2587.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2587.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2587.inject($dca0ddb82b882518$var$internals$jscomp$inline_2586), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2587;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.3.1";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});
parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "ViewTransition", () => $72b03fdf46effee2$export$8cdaa4703948c5e9, (v) => $72b03fdf46effee2$export$8cdaa4703948c5e9 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "addTransitionType", () => $72b03fdf46effee2$export$87c99536b1b8cdd8, (v) => $72b03fdf46effee2$export$87c99536b1b8cdd8 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$8cdaa4703948c5e9;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$87c99536b1b8cdd8;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result, thenable = ctor();
        thenable.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject, void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error, void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
        });
        -1 === payload._status && (payload._status = 0, payload._result = thenable);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $72b03fdf46effee2$var$startTransition(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
}
function $72b03fdf46effee2$var$addTransitionType(type) {
    var transition = $72b03fdf46effee2$var$ReactSharedInternals.T;
    if (null !== transition) {
        var transitionTypes = transition.types;
        null === transitionTypes ? transition.types = [
            type
        ] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
    } else $72b03fdf46effee2$var$startTransition($72b03fdf46effee2$var$addTransitionType.bind(null, type));
}
var $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$8cdaa4703948c5e9 = $72b03fdf46effee2$var$REACT_VIEW_TRANSITION_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$87c99536b1b8cdd8 = $72b03fdf46effee2$var$addTransitionType;
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = $72b03fdf46effee2$var$startTransition;
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.3.1";

});


parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "browser", () => $4433d39f12c5883f$export$3f2684e5d7cb1006, (v) => $4433d39f12c5883f$export$3f2684e5d7cb1006 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$3f2684e5d7cb1006;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $4433d39f12c5883f$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $4433d39f12c5883f$var$REACT_OPTIMISTIC_KEY = Symbol.for("react.optimistic_key");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : key === $4433d39f12c5883f$var$REACT_OPTIMISTIC_KEY ? $4433d39f12c5883f$var$REACT_OPTIMISTIC_KEY : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$3f2684e5d7cb1006 = function(reason) {
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_RECOVERABLE_TYPE,
        _reason: reason
    };
};
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                    fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.3.1";

});



parcelRegister("f2WZf", function(module, exports) {
/* Mapbox GL JS is Copyright © 2020 Mapbox and subject to the Mapbox Terms of Service ((https://www.mapbox.com/legal/tos/). */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    let shared, sharedDeps, worker, workerDeps, mapboxgl;
    if (typeof self !== "undefined") self.__mapboxImport = (u)=>import(/* webpackIgnore: true */ /* @vite-ignore */ u);
    function define(deps, chunk) {
        if (!shared) {
            shared = chunk;
            sharedDeps = deps;
        } else if (!worker) {
            worker = chunk;
            workerDeps = deps;
        } else {
            const sharedChunk = {};
            const args = (deps2)=>deps2.map((dep)=>dep === "require" ? void 0 : sharedChunk);
            shared(...args(sharedDeps));
            mapboxgl = chunk(...args(deps));
            const argsString = (deps2)=>deps2.map((dep)=>dep === "require" ? "undefined" : "sharedChunk").join(", ");
            const workerBundleString = "self.onerror = function() { console.error('An error occurred while parsing the WebWorker bundle. This is most likely due to improper transpilation by Babel; please see https://docs.mapbox.com/mapbox-gl-js/guides/install/#transpiling'); }; var sharedChunk = {}; self.__mapboxImport = (u) => import(u); (" + shared + ")(" + argsString(sharedDeps) + "); (" + worker + ")(" + argsString(workerDeps) + "); self.onerror = null;";
            if (typeof window !== "undefined" && window && window.URL && window.URL.createObjectURL) mapboxgl.workerUrl = window.URL.createObjectURL(new Blob([
                workerBundleString
            ], {
                type: "text/javascript"
            }));
        }
    }
    define([
        "require",
        "exports"
    ], function(e1, t1) {
        var i = "3.34.1", n = 1e-6, r = "undefined" != typeof Float32Array ? Float32Array : Array;
        function o(e1, t1) {
            var i = t1[0], n = t1[1], r = t1[2], o = t1[3], a = i * o - r * n;
            return a ? (e1[0] = o * (a = 1 / a), e1[1] = -n * a, e1[2] = -r * a, e1[3] = i * a, e1) : null;
        }
        function a() {
            var e1 = new r(9);
            return r != Float32Array && (e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[5] = 0, e1[6] = 0, e1[7] = 0), e1[0] = 1, e1[4] = 1, e1[8] = 1, e1;
        }
        function s(e1, t1, i) {
            var n = t1[0], r = t1[1], o = t1[2], a = t1[3], s = t1[4], l = t1[5], c = t1[6], u = t1[7], h = t1[8], d = i[0], f = i[1], p = i[2], _ = i[3], m = i[4], g = i[5], y = i[6], x = i[7], v = i[8];
            return e1[0] = d * n + f * a + p * c, e1[1] = d * r + f * s + p * u, e1[2] = d * o + f * l + p * h, e1[3] = _ * n + m * a + g * c, e1[4] = _ * r + m * s + g * u, e1[5] = _ * o + m * l + g * h, e1[6] = y * n + x * a + v * c, e1[7] = y * r + x * s + v * u, e1[8] = y * o + x * l + v * h, e1;
        }
        function l(e1, t1) {
            var i = Math.sin(t1), n = Math.cos(t1);
            return e1[0] = n, e1[1] = i, e1[2] = 0, e1[3] = -i, e1[4] = n, e1[5] = 0, e1[6] = 0, e1[7] = 0, e1[8] = 1, e1;
        }
        function c() {
            var e1 = new r(16);
            return r != Float32Array && (e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0), e1[0] = 1, e1[5] = 1, e1[10] = 1, e1[15] = 1, e1;
        }
        function u(e1) {
            var t1 = new r(16);
            return t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[3] = e1[3], t1[4] = e1[4], t1[5] = e1[5], t1[6] = e1[6], t1[7] = e1[7], t1[8] = e1[8], t1[9] = e1[9], t1[10] = e1[10], t1[11] = e1[11], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15], t1;
        }
        function h(e1, t1) {
            return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1[3] = t1[3], e1[4] = t1[4], e1[5] = t1[5], e1[6] = t1[6], e1[7] = t1[7], e1[8] = t1[8], e1[9] = t1[9], e1[10] = t1[10], e1[11] = t1[11], e1[12] = t1[12], e1[13] = t1[13], e1[14] = t1[14], e1[15] = t1[15], e1;
        }
        function d(e1) {
            return e1[0] = 1, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = 1, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 1, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
        }
        function f(e1, t1) {
            if (e1 === t1) {
                var i = t1[1], n = t1[2], r = t1[3], o = t1[6], a = t1[7], s = t1[11];
                e1[1] = t1[4], e1[2] = t1[8], e1[3] = t1[12], e1[4] = i, e1[6] = t1[9], e1[7] = t1[13], e1[8] = n, e1[9] = o, e1[11] = t1[14], e1[12] = r, e1[13] = a, e1[14] = s;
            } else e1[0] = t1[0], e1[1] = t1[4], e1[2] = t1[8], e1[3] = t1[12], e1[4] = t1[1], e1[5] = t1[5], e1[6] = t1[9], e1[7] = t1[13], e1[8] = t1[2], e1[9] = t1[6], e1[10] = t1[10], e1[11] = t1[14], e1[12] = t1[3], e1[13] = t1[7], e1[14] = t1[11], e1[15] = t1[15];
            return e1;
        }
        function p(e1, t1) {
            var i = t1[0], n = t1[1], r = t1[2], o = t1[3], a = t1[4], s = t1[5], l = t1[6], c = t1[7], u = t1[8], h = t1[9], d = t1[10], f = t1[11], p = t1[12], _ = t1[13], m = t1[14], g = t1[15], y = i * s - n * a, x = i * l - r * a, v = i * c - o * a, b = n * l - r * s, w = n * c - o * s, A = r * c - o * l, E = u * _ - h * p, I = u * m - d * p, M = u * g - f * p, S = h * m - d * _, T = h * g - f * _, z = d * g - f * m, R = y * z - x * T + v * S + b * M - w * I + A * E;
            return R ? (e1[0] = (s * z - l * T + c * S) * (R = 1 / R), e1[1] = (r * T - n * z - o * S) * R, e1[2] = (_ * A - m * w + g * b) * R, e1[3] = (d * w - h * A - f * b) * R, e1[4] = (l * M - a * z - c * I) * R, e1[5] = (i * z - r * M + o * I) * R, e1[6] = (m * v - p * A - g * x) * R, e1[7] = (u * A - d * v + f * x) * R, e1[8] = (a * T - s * M + c * E) * R, e1[9] = (n * M - i * T - o * E) * R, e1[10] = (p * w - _ * v + g * y) * R, e1[11] = (h * v - u * w - f * y) * R, e1[12] = (s * I - a * S - l * E) * R, e1[13] = (i * S - n * I + r * E) * R, e1[14] = (_ * x - p * b - m * y) * R, e1[15] = (u * b - h * x + d * y) * R, e1) : null;
        }
        function _(e1, t1, i) {
            var n = t1[0], r = t1[1], o = t1[2], a = t1[3], s = t1[4], l = t1[5], c = t1[6], u = t1[7], h = t1[8], d = t1[9], f = t1[10], p = t1[11], _ = t1[12], m = t1[13], g = t1[14], y = t1[15], x = i[0], v = i[1], b = i[2], w = i[3];
            return e1[0] = x * n + v * s + b * h + w * _, e1[1] = x * r + v * l + b * d + w * m, e1[2] = x * o + v * c + b * f + w * g, e1[3] = x * a + v * u + b * p + w * y, e1[4] = (x = i[4]) * n + (v = i[5]) * s + (b = i[6]) * h + (w = i[7]) * _, e1[5] = x * r + v * l + b * d + w * m, e1[6] = x * o + v * c + b * f + w * g, e1[7] = x * a + v * u + b * p + w * y, e1[8] = (x = i[8]) * n + (v = i[9]) * s + (b = i[10]) * h + (w = i[11]) * _, e1[9] = x * r + v * l + b * d + w * m, e1[10] = x * o + v * c + b * f + w * g, e1[11] = x * a + v * u + b * p + w * y, e1[12] = (x = i[12]) * n + (v = i[13]) * s + (b = i[14]) * h + (w = i[15]) * _, e1[13] = x * r + v * l + b * d + w * m, e1[14] = x * o + v * c + b * f + w * g, e1[15] = x * a + v * u + b * p + w * y, e1;
        }
        function m(e1, t1, i) {
            var n, r, o, a, s, l, c, u, h, d, f, p, _ = i[0], m = i[1], g = i[2];
            return t1 === e1 ? (e1[12] = t1[0] * _ + t1[4] * m + t1[8] * g + t1[12], e1[13] = t1[1] * _ + t1[5] * m + t1[9] * g + t1[13], e1[14] = t1[2] * _ + t1[6] * m + t1[10] * g + t1[14], e1[15] = t1[3] * _ + t1[7] * m + t1[11] * g + t1[15]) : (r = t1[1], o = t1[2], a = t1[3], s = t1[4], l = t1[5], c = t1[6], u = t1[7], h = t1[8], d = t1[9], f = t1[10], p = t1[11], e1[0] = n = t1[0], e1[1] = r, e1[2] = o, e1[3] = a, e1[4] = s, e1[5] = l, e1[6] = c, e1[7] = u, e1[8] = h, e1[9] = d, e1[10] = f, e1[11] = p, e1[12] = n * _ + s * m + h * g + t1[12], e1[13] = r * _ + l * m + d * g + t1[13], e1[14] = o * _ + c * m + f * g + t1[14], e1[15] = a * _ + u * m + p * g + t1[15]), e1;
        }
        function g(e1, t1, i) {
            var n = i[0], r = i[1], o = i[2];
            return e1[0] = t1[0] * n, e1[1] = t1[1] * n, e1[2] = t1[2] * n, e1[3] = t1[3] * n, e1[4] = t1[4] * r, e1[5] = t1[5] * r, e1[6] = t1[6] * r, e1[7] = t1[7] * r, e1[8] = t1[8] * o, e1[9] = t1[9] * o, e1[10] = t1[10] * o, e1[11] = t1[11] * o, e1[12] = t1[12], e1[13] = t1[13], e1[14] = t1[14], e1[15] = t1[15], e1;
        }
        function y(e1, t1, i) {
            var n = Math.sin(i), r = Math.cos(i), o = t1[4], a = t1[5], s = t1[6], l = t1[7], c = t1[8], u = t1[9], h = t1[10], d = t1[11];
            return t1 !== e1 && (e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1[3] = t1[3], e1[12] = t1[12], e1[13] = t1[13], e1[14] = t1[14], e1[15] = t1[15]), e1[4] = o * r + c * n, e1[5] = a * r + u * n, e1[6] = s * r + h * n, e1[7] = l * r + d * n, e1[8] = c * r - o * n, e1[9] = u * r - a * n, e1[10] = h * r - s * n, e1[11] = d * r - l * n, e1;
        }
        function x(e1, t1, i) {
            var n = Math.sin(i), r = Math.cos(i), o = t1[0], a = t1[1], s = t1[2], l = t1[3], c = t1[8], u = t1[9], h = t1[10], d = t1[11];
            return t1 !== e1 && (e1[4] = t1[4], e1[5] = t1[5], e1[6] = t1[6], e1[7] = t1[7], e1[12] = t1[12], e1[13] = t1[13], e1[14] = t1[14], e1[15] = t1[15]), e1[0] = o * r - c * n, e1[1] = a * r - u * n, e1[2] = s * r - h * n, e1[3] = l * r - d * n, e1[8] = o * n + c * r, e1[9] = a * n + u * r, e1[10] = s * n + h * r, e1[11] = l * n + d * r, e1;
        }
        function v(e1, t1, i) {
            var n = Math.sin(i), r = Math.cos(i), o = t1[0], a = t1[1], s = t1[2], l = t1[3], c = t1[4], u = t1[5], h = t1[6], d = t1[7];
            return t1 !== e1 && (e1[8] = t1[8], e1[9] = t1[9], e1[10] = t1[10], e1[11] = t1[11], e1[12] = t1[12], e1[13] = t1[13], e1[14] = t1[14], e1[15] = t1[15]), e1[0] = o * r + c * n, e1[1] = a * r + u * n, e1[2] = s * r + h * n, e1[3] = l * r + d * n, e1[4] = c * r - o * n, e1[5] = u * r - a * n, e1[6] = h * r - s * n, e1[7] = d * r - l * n, e1;
        }
        function b(e1, t1) {
            return e1[0] = 1, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = 1, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 1, e1[11] = 0, e1[12] = t1[0], e1[13] = t1[1], e1[14] = t1[2], e1[15] = 1, e1;
        }
        function w(e1, t1) {
            return e1[0] = t1[0], e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = t1[1], e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = t1[2], e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
        }
        function A(e1, t1, i) {
            var r, o, a, s = i[0], l = i[1], c = i[2], u = Math.sqrt(s * s + l * l + c * c);
            return u < n ? null : (s *= u = 1 / u, l *= u, c *= u, r = Math.sin(t1), o = Math.cos(t1), e1[0] = s * s * (a = 1 - o) + o, e1[1] = l * s * a + c * r, e1[2] = c * s * a - l * r, e1[3] = 0, e1[4] = s * l * a - c * r, e1[5] = l * l * a + o, e1[6] = c * l * a + s * r, e1[7] = 0, e1[8] = s * c * a + l * r, e1[9] = l * c * a - s * r, e1[10] = c * c * a + o, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1);
        }
        function E(e1, t1) {
            var i = t1[0], n = t1[1], r = t1[2], o = t1[4], a = t1[5], s = t1[6], l = t1[8], c = t1[9], u = t1[10];
            return e1[0] = Math.sqrt(i * i + n * n + r * r), e1[1] = Math.sqrt(o * o + a * a + s * s), e1[2] = Math.sqrt(l * l + c * c + u * u), e1;
        }
        function I(e1, t1) {
            var i = new r(3);
            E(i, t1);
            var n = 1 / i[0], o = 1 / i[1], a = 1 / i[2], s = t1[0] * n, l = t1[1] * o, c = t1[2] * a, u = t1[4] * n, h = t1[5] * o, d = t1[6] * a, f = t1[8] * n, p = t1[9] * o, _ = t1[10] * a, m = s + h + _, g = 0;
            return m > 0 ? (g = 2 * Math.sqrt(m + 1), e1[3] = .25 * g, e1[0] = (d - p) / g, e1[1] = (f - c) / g, e1[2] = (l - u) / g) : s > h && s > _ ? (g = 2 * Math.sqrt(1 + s - h - _), e1[3] = (d - p) / g, e1[0] = .25 * g, e1[1] = (l + u) / g, e1[2] = (f + c) / g) : h > _ ? (g = 2 * Math.sqrt(1 + h - s - _), e1[3] = (f - c) / g, e1[0] = (l + u) / g, e1[1] = .25 * g, e1[2] = (d + p) / g) : (g = 2 * Math.sqrt(1 + _ - s - h), e1[3] = (l - u) / g, e1[0] = (f + c) / g, e1[1] = (d + p) / g, e1[2] = .25 * g), e1;
        }
        function M(e1, t1) {
            var i = t1[0], n = t1[1], r = t1[2], o = t1[3], a = i + i, s = n + n, l = r + r, c = i * a, u = n * a, h = n * s, d = r * a, f = r * s, p = r * l, _ = o * a, m = o * s, g = o * l;
            return e1[0] = 1 - h - p, e1[1] = u + g, e1[2] = d - m, e1[3] = 0, e1[4] = u - g, e1[5] = 1 - c - p, e1[6] = f + _, e1[7] = 0, e1[8] = d + m, e1[9] = f - _, e1[10] = 1 - c - h, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
        }
        var S = function(e1, t1, i, n, r) {
            var o = 1 / Math.tan(t1 / 2);
            if (e1[0] = o / i, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = o, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[11] = -1, e1[12] = 0, e1[13] = 0, e1[15] = 0, null != r && r !== 1 / 0) {
                var a = 1 / (n - r);
                e1[10] = (r + n) * a, e1[14] = 2 * r * n * a;
            } else e1[10] = -1, e1[14] = -2 * n;
            return e1;
        }, T = function(e1, t1, i, n, r, o, a) {
            var s = 1 / (t1 - i), l = 1 / (n - r), c = 1 / (o - a);
            return e1[0] = -2 * s, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = -2 * l, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 2 * c, e1[11] = 0, e1[12] = (t1 + i) * s, e1[13] = (r + n) * l, e1[14] = (a + o) * c, e1[15] = 1, e1;
        }, z = _;
        function R() {
            var e1 = new r(3);
            return r != Float32Array && (e1[0] = 0, e1[1] = 0, e1[2] = 0), e1;
        }
        function P(e1) {
            var t1 = e1[0], i = e1[1], n = e1[2];
            return Math.sqrt(t1 * t1 + i * i + n * n);
        }
        function D(e1, t1, i) {
            var n = new r(3);
            return n[0] = e1, n[1] = t1, n[2] = i, n;
        }
        function F(e1, t1, i, n) {
            return e1[0] = t1, e1[1] = i, e1[2] = n, e1;
        }
        function C(e1, t1, i) {
            return e1[0] = t1[0] + i[0], e1[1] = t1[1] + i[1], e1[2] = t1[2] + i[2], e1;
        }
        function O(e1, t1, i) {
            return e1[0] = t1[0] - i[0], e1[1] = t1[1] - i[1], e1[2] = t1[2] - i[2], e1;
        }
        function L(e1, t1, i) {
            return e1[0] = t1[0] * i[0], e1[1] = t1[1] * i[1], e1[2] = t1[2] * i[2], e1;
        }
        function B(e1, t1, i) {
            return e1[0] = Math.min(t1[0], i[0]), e1[1] = Math.min(t1[1], i[1]), e1[2] = Math.min(t1[2], i[2]), e1;
        }
        function V(e1, t1, i) {
            return e1[0] = Math.max(t1[0], i[0]), e1[1] = Math.max(t1[1], i[1]), e1[2] = Math.max(t1[2], i[2]), e1;
        }
        function N(e1, t1, i) {
            return e1[0] = t1[0] * i, e1[1] = t1[1] * i, e1[2] = t1[2] * i, e1;
        }
        function k(e1, t1, i, n) {
            return e1[0] = t1[0] + i[0] * n, e1[1] = t1[1] + i[1] * n, e1[2] = t1[2] + i[2] * n, e1;
        }
        function U(e1, t1) {
            var i = t1[0] - e1[0], n = t1[1] - e1[1], r = t1[2] - e1[2];
            return Math.sqrt(i * i + n * n + r * r);
        }
        function j(e1, t1) {
            var i = t1[0] - e1[0], n = t1[1] - e1[1], r = t1[2] - e1[2];
            return i * i + n * n + r * r;
        }
        function G(e1) {
            var t1 = e1[0], i = e1[1], n = e1[2];
            return t1 * t1 + i * i + n * n;
        }
        function H(e1, t1) {
            return e1[0] = -t1[0], e1[1] = -t1[1], e1[2] = -t1[2], e1;
        }
        function $(e1, t1) {
            var i = t1[0], n = t1[1], r = t1[2], o = i * i + n * n + r * r;
            return o > 0 && (o = 1 / Math.sqrt(o)), e1[0] = t1[0] * o, e1[1] = t1[1] * o, e1[2] = t1[2] * o, e1;
        }
        function Z(e1, t1) {
            return e1[0] * t1[0] + e1[1] * t1[1] + e1[2] * t1[2];
        }
        function W(e1, t1, i) {
            var n = t1[0], r = t1[1], o = t1[2], a = i[0], s = i[1], l = i[2];
            return e1[0] = r * l - o * s, e1[1] = o * a - n * l, e1[2] = n * s - r * a, e1;
        }
        function q(e1, t1, i, n) {
            var r = t1[0], o = t1[1], a = t1[2];
            return e1[0] = r + n * (i[0] - r), e1[1] = o + n * (i[1] - o), e1[2] = a + n * (i[2] - a), e1;
        }
        function X(e1, t1, i) {
            var n = t1[0], r = t1[1], o = t1[2], a = i[3] * n + i[7] * r + i[11] * o + i[15];
            return e1[0] = (i[0] * n + i[4] * r + i[8] * o + i[12]) / (a = a || 1), e1[1] = (i[1] * n + i[5] * r + i[9] * o + i[13]) / a, e1[2] = (i[2] * n + i[6] * r + i[10] * o + i[14]) / a, e1;
        }
        function Y(e1, t1, i) {
            var n = t1[0], r = t1[1], o = t1[2];
            return e1[0] = n * i[0] + r * i[3] + o * i[6], e1[1] = n * i[1] + r * i[4] + o * i[7], e1[2] = n * i[2] + r * i[5] + o * i[8], e1;
        }
        function J(e1, t1, i) {
            var n = i[0], r = i[1], o = i[2], a = i[3], s = t1[0], l = t1[1], c = t1[2], u = r * c - o * l, h = o * s - n * c, d = n * l - r * s;
            return e1[0] = s + a * (u += u) + r * (d += d) - o * (h += h), e1[1] = l + a * h + o * u - n * d, e1[2] = c + a * d + n * h - r * u, e1;
        }
        function K(e1) {
            return e1[0] = 0, e1[1] = 0, e1[2] = 0, e1;
        }
        function Q(e1, t1) {
            return e1[0] === t1[0] && e1[1] === t1[1] && e1[2] === t1[2];
        }
        var ee = O, te = L, ie = P;
        function ne() {
            var e1 = new r(4);
            return r != Float32Array && (e1[0] = 0, e1[1] = 0, e1[2] = 0, e1[3] = 0), e1;
        }
        function re(e1, t1, i, n) {
            var o = new r(4);
            return o[0] = e1, o[1] = t1, o[2] = i, o[3] = n, o;
        }
        function oe(e1, t1, i) {
            return e1[0] = t1[0] * i, e1[1] = t1[1] * i, e1[2] = t1[2] * i, e1[3] = t1[3] * i, e1;
        }
        function ae(e1, t1) {
            var i = t1[0], n = t1[1], r = t1[2], o = t1[3], a = i * i + n * n + r * r + o * o;
            return a > 0 && (a = 1 / Math.sqrt(a)), e1[0] = i * a, e1[1] = n * a, e1[2] = r * a, e1[3] = o * a, e1;
        }
        function se(e1, t1, i) {
            var n = t1[0], r = t1[1], o = t1[2], a = t1[3];
            return e1[0] = i[0] * n + i[4] * r + i[8] * o + i[12] * a, e1[1] = i[1] * n + i[5] * r + i[9] * o + i[13] * a, e1[2] = i[2] * n + i[6] * r + i[10] * o + i[14] * a, e1[3] = i[3] * n + i[7] * r + i[11] * o + i[15] * a, e1;
        }
        function le() {
            var e1 = new r(4);
            return r != Float32Array && (e1[0] = 0, e1[1] = 0, e1[2] = 0), e1[3] = 1, e1;
        }
        function ce(e1) {
            return e1[0] = 0, e1[1] = 0, e1[2] = 0, e1[3] = 1, e1;
        }
        function ue(e1, t1) {
            var i = 2 * Math.acos(t1[3]), r = Math.sin(i / 2);
            return r > n ? (e1[0] = t1[0] / r, e1[1] = t1[1] / r, e1[2] = t1[2] / r) : (e1[0] = 1, e1[1] = 0, e1[2] = 0), i;
        }
        function he(e1, t1, i) {
            i *= .5;
            var n = t1[0], r = t1[1], o = t1[2], a = t1[3], s = Math.sin(i), l = Math.cos(i);
            return e1[0] = n * l + a * s, e1[1] = r * l + o * s, e1[2] = o * l - r * s, e1[3] = a * l - n * s, e1;
        }
        function de(e1, t1, i) {
            i *= .5;
            var n = t1[0], r = t1[1], o = t1[2], a = t1[3], s = Math.sin(i), l = Math.cos(i);
            return e1[0] = n * l - o * s, e1[1] = r * l + a * s, e1[2] = o * l + n * s, e1[3] = a * l - r * s, e1;
        }
        function fe(e1, t1, i) {
            i *= .5;
            var n = t1[0], r = t1[1], o = t1[2], a = t1[3], s = Math.sin(i), l = Math.cos(i);
            return e1[0] = n * l + r * s, e1[1] = r * l - n * s, e1[2] = o * l + a * s, e1[3] = a * l - o * s, e1;
        }
        R(), ne();
        var pe, _e, me, ge = ae, ye = (pe = R(), _e = D(1, 0, 0), me = D(0, 1, 0), function(e1, t1, i) {
            var n = Z(t1, i);
            return n < -0.999999 ? (W(pe, _e, t1), ie(pe) < 1e-6 && W(pe, me, t1), $(pe, pe), function(e1, t1, i) {
                i *= .5;
                var n = Math.sin(i);
                e1[0] = n * t1[0], e1[1] = n * t1[1], e1[2] = n * t1[2], e1[3] = Math.cos(i);
            }(e1, pe, Math.PI), e1) : n > .999999 ? (e1[0] = 0, e1[1] = 0, e1[2] = 0, e1[3] = 1, e1) : (W(pe, t1, i), e1[0] = pe[0], e1[1] = pe[1], e1[2] = pe[2], e1[3] = 1 + n, ge(e1, e1));
        });
        function xe() {
            var e1 = new r(2);
            return r != Float32Array && (e1[0] = 0, e1[1] = 0), e1;
        }
        function ve(e1, t1) {
            var i = new r(2);
            return i[0] = e1, i[1] = t1, i;
        }
        function be(e1, t1, i) {
            return e1[0] = t1, e1[1] = i, e1;
        }
        function we(e1, t1, i) {
            return e1[0] = t1[0] + i[0], e1[1] = t1[1] + i[1], e1;
        }
        function Ae(e1, t1, i) {
            return e1[0] = t1[0] - i[0], e1[1] = t1[1] - i[1], e1;
        }
        function Ee(e1, t1, i) {
            return e1[0] = t1[0] * i, e1[1] = t1[1] * i, e1;
        }
        function Ie(e1) {
            var t1 = e1[0], i = e1[1];
            return Math.sqrt(t1 * t1 + i * i);
        }
        function Me(e1, t1) {
            var i = t1[0], n = t1[1], r = i * i + n * n;
            return r > 0 && (r = 1 / Math.sqrt(r)), e1[0] = t1[0] * r, e1[1] = t1[1] * r, e1;
        }
        function Se(e1, t1) {
            return e1[0] * t1[0] + e1[1] * t1[1];
        }
        le(), le(), a();
        var Te = Ae;
        function ze(e1, t1, i, n) {
            const r = 3 * e1, o = 3 * (i - e1) - r, a = 1 - r - o, s = 3 * t1, l = 3 * (n - t1) - s, c = 1 - s - l;
            return function(e1, t1 = 1e-6) {
                if (e1 <= 0) return 0;
                if (e1 >= 1) return 1;
                let i = e1;
                for(let n = 0; n < 8; n++){
                    const n = ((a * i + o) * i + r) * i - e1;
                    if (Math.abs(n) < t1) return ((c * i + l) * i + s) * i;
                    const u = (3 * a * i + 2 * o) * i + r;
                    if (Math.abs(u) < 1e-6) break;
                    i -= n / u;
                }
                let n = 0, u = 1;
                i = e1;
                for(let s = 0; s < 20; s++){
                    const s = ((a * i + o) * i + r) * i;
                    if (Math.abs(s - e1) < t1) break;
                    e1 > s ? n = i : u = i, i = .5 * (n + u);
                }
                return ((c * i + l) * i + s) * i;
            };
        }
        function Re(e1, t1) {
            this.x = e1, this.y = t1;
        }
        function Pe(e1, t1) {
            if (Array.isArray(e1)) {
                if (!Array.isArray(t1) || e1.length !== t1.length) return !1;
                for(let i = 0; i < e1.length; i++)if (!Pe(e1[i], t1[i])) return !1;
                return !0;
            }
            if ("object" == typeof e1 && null !== e1 && null !== t1) {
                if ("object" != typeof t1) return !1;
                const i = e1, n = t1;
                if (Object.keys(i).length !== Object.keys(n).length) return !1;
                for(const e1 in i)if (!Pe(i[e1], n[e1])) return !1;
                return !0;
            }
            return e1 === t1;
        }
        function De(e1, t1, i = 0, n = e1.length - 1, r = Ce) {
            for(; n > i;){
                if (n - i > 600) {
                    const o = n - i + 1, a = t1 - i + 1, s = Math.log(o), l = .5 * Math.exp(2 * s / 3), c = .5 * Math.sqrt(s * l * (o - l) / o) * (a - o / 2 < 0 ? -1 : 1);
                    De(e1, t1, Math.max(i, Math.floor(t1 - a * l / o + c)), Math.min(n, Math.floor(t1 + (o - a) * l / o + c)), r);
                }
                const o = e1[t1];
                let a = i, s = n;
                for(Fe(e1, i, t1), r(e1[n], o) > 0 && Fe(e1, i, n); a < s;){
                    for(Fe(e1, a, s), a++, s--; r(e1[a], o) < 0;)a++;
                    for(; r(e1[s], o) > 0;)s--;
                }
                0 === r(e1[i], o) ? Fe(e1, i, s) : (s++, Fe(e1, s, n)), s <= t1 && (i = s + 1), t1 <= s && (n = s - 1);
            }
        }
        function Fe(e1, t1, i) {
            const n = e1[t1];
            e1[t1] = e1[i], e1[i] = n;
        }
        function Ce(e1, t1) {
            return e1 < t1 ? -1 : e1 > t1 ? 1 : 0;
        }
        function Oe(e1) {
            let t1 = 0;
            for(let i, n, r = 0, o = e1.length, a = o - 1; r < o; a = r++)i = e1[r], n = e1[a], t1 += (n.x - i.x) * (i.y + n.y);
            return t1;
        }
        function Le(e1, t1) {
            return t1.area - e1.area;
        }
        function Be(e1) {
            const t1 = e1.length;
            if (t1 < 3) return !0;
            const i = e1[0];
            let n = 0, r = 0, o = 1;
            for(; o < t1 && (n = e1[o].x - i.x, r = e1[o].y - i.y, 0 === n && 0 === r); o++);
            if (o === t1) return !0;
            for(; o < t1; o++)if (n * (e1[o].y - i.y) - r * (e1[o].x - i.x) !== 0) return !1;
            return !0;
        }
        function Ve(e1, t1) {
            const i = e1.length, n = [];
            let r, o;
            for(let t1 = 0; t1 < i; t1++){
                const i = Oe(e1[t1]);
                0 === i && Be(e1[t1]) || (e1[t1].area = Math.abs(i), void 0 === o && (o = i < 0), o === i < 0 ? (r && n.push(r), r = [
                    e1[t1]
                ]) : r.push(e1[t1]));
            }
            if (r && n.push(r), t1 > 1) for(let e1 = 0; e1 < n.length; e1++){
                const i = n[e1];
                i.length <= t1 || (De(i, t1, 1, i.length - 1, Le), n[e1] = i.slice(0, t1));
            }
            return n;
        }
        function Ne(e1, t1) {
            e1[0] = Math.min(e1[0], t1[0]), e1[1] = Math.min(e1[1], t1[1]), e1[2] = Math.max(e1[2], t1[0]), e1[3] = Math.max(e1[3], t1[1]);
        }
        function ke(e1, t1) {
            return !(e1[0] <= t1[0] || e1[2] >= t1[2] || e1[1] <= t1[1] || e1[3] >= t1[3]);
        }
        function Ue(e1, t1, i) {
            const n = e1[0] - t1[0], r = e1[1] - t1[1], o = e1[0] - i[0], a = e1[1] - i[1];
            return n * a - o * r === 0 && n * o <= 0 && r * a <= 0;
        }
        function je(e1, t1, i) {
            return t1[1] > e1[1] != i[1] > e1[1] && e1[0] < (i[0] - t1[0]) * (e1[1] - t1[1]) / (i[1] - t1[1]) + t1[0];
        }
        function Ge(e1, t1, i = !1) {
            let n = !1;
            for(let r = 0, o = t1.length; r < o; r++){
                const o = t1[r];
                for(let t1 = 0, r = o.length, a = r - 1; t1 < r; a = t1++){
                    const r = o[a], s = o[t1];
                    if (Ue(e1, r, s)) return i;
                    je(e1, r, s) && (n = !n);
                }
            }
            return n;
        }
        function He(e1, t1, i, n) {
            const r = n[0] - i[0], o = n[1] - i[1], a = (e1[0] - i[0]) * o - r * (e1[1] - i[1]), s = (t1[0] - i[0]) * o - r * (t1[1] - i[1]);
            return a > 0 && s < 0 || a < 0 && s > 0;
        }
        function $e(e1, t1, i, n) {
            var r, o;
            return 0 !== (r = [
                n[0] - i[0],
                n[1] - i[1]
            ])[0] * (o = [
                t1[0] - e1[0],
                t1[1] - e1[1]
            ])[1] - r[1] * o[0] && !(!He(e1, t1, i, n) || !He(i, n, e1, t1));
        }
        function Ze(e1) {
            const t1 = new Re(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY), i = new Re(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY);
            for (const n of e1[0])t1.x > n.x && (t1.x = n.x), t1.y > n.y && (t1.y = n.y), i.x < n.x && (i.x = n.x), i.y < n.y && (i.y = n.y);
            return {
                min: t1,
                max: i
            };
        }
        xe(), Re.prototype = {
            clone () {
                return new Re(this.x, this.y);
            },
            add (e1) {
                return this.clone()._add(e1);
            },
            sub (e1) {
                return this.clone()._sub(e1);
            },
            multByPoint (e1) {
                return this.clone()._multByPoint(e1);
            },
            divByPoint (e1) {
                return this.clone()._divByPoint(e1);
            },
            mult (e1) {
                return this.clone()._mult(e1);
            },
            div (e1) {
                return this.clone()._div(e1);
            },
            rotate (e1) {
                return this.clone()._rotate(e1);
            },
            rotateAround (e1, t1) {
                return this.clone()._rotateAround(e1, t1);
            },
            matMult (e1) {
                return this.clone()._matMult(e1);
            },
            unit () {
                return this.clone()._unit();
            },
            perp () {
                return this.clone()._perp();
            },
            round () {
                return this.clone()._round();
            },
            mag () {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            },
            equals (e1) {
                return this.x === e1.x && this.y === e1.y;
            },
            dist (e1) {
                return Math.sqrt(this.distSqr(e1));
            },
            distSqr (e1) {
                const t1 = e1.x - this.x, i = e1.y - this.y;
                return t1 * t1 + i * i;
            },
            angle () {
                return Math.atan2(this.y, this.x);
            },
            angleTo (e1) {
                return Math.atan2(this.y - e1.y, this.x - e1.x);
            },
            angleWith (e1) {
                return this.angleWithSep(e1.x, e1.y);
            },
            angleWithSep (e1, t1) {
                return Math.atan2(this.x * t1 - this.y * e1, this.x * e1 + this.y * t1);
            },
            _matMult (e1) {
                const t1 = e1[2] * this.x + e1[3] * this.y;
                return this.x = e1[0] * this.x + e1[1] * this.y, this.y = t1, this;
            },
            _add (e1) {
                return this.x += e1.x, this.y += e1.y, this;
            },
            _sub (e1) {
                return this.x -= e1.x, this.y -= e1.y, this;
            },
            _mult (e1) {
                return this.x *= e1, this.y *= e1, this;
            },
            _div (e1) {
                return this.x /= e1, this.y /= e1, this;
            },
            _multByPoint (e1) {
                return this.x *= e1.x, this.y *= e1.y, this;
            },
            _divByPoint (e1) {
                return this.x /= e1.x, this.y /= e1.y, this;
            },
            _unit () {
                return this._div(this.mag()), this;
            },
            _perp () {
                const e1 = this.y;
                return this.y = this.x, this.x = -e1, this;
            },
            _rotate (e1) {
                const t1 = Math.cos(e1), i = Math.sin(e1), n = i * this.x + t1 * this.y;
                return this.x = t1 * this.x - i * this.y, this.y = n, this;
            },
            _rotateAround (e1, t1) {
                const i = Math.cos(e1), n = Math.sin(e1), r = t1.y + n * (this.x - t1.x) + i * (this.y - t1.y);
                return this.x = t1.x + i * (this.x - t1.x) - n * (this.y - t1.y), this.y = r, this;
            },
            _round () {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            },
            constructor: Re
        }, Re.convert = function(e1) {
            if (e1 instanceof Re) return e1;
            if (Array.isArray(e1)) return new Re(+e1[0], +e1[1]);
            if (void 0 !== e1.x && void 0 !== e1.y) return new Re(+e1.x, +e1.y);
            throw new Error("Expected [x, y] or {x, y} point format");
        };
        const We = Math.PI / 180, qe = 180 / Math.PI, Xe = /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        function Ye(e1) {
            return e1 * We;
        }
        function Je(e1) {
            return e1 * qe;
        }
        const Ke = [
            [
                0,
                0
            ],
            [
                1,
                0
            ],
            [
                1,
                1
            ],
            [
                0,
                1
            ]
        ];
        function Qe(e1) {
            if (e1 <= 0) return 0;
            if (e1 >= 1) return 1;
            const t1 = e1 * e1, i = t1 * e1;
            return 4 * (e1 < .5 ? i : 3 * (e1 - t1) + i - .75);
        }
        const et = ze(.25, .1, .25, 1);
        function tt(e1, t1, i) {
            return Math.min(i, Math.max(t1, e1));
        }
        function it(e1, t1, i) {
            return (i = tt((i - e1) / (t1 - e1), 0, 1)) * i * (3 - 2 * i);
        }
        function nt(e1, t1, i) {
            const n = i - t1, r = ((e1 - t1) % n + n) % n + t1;
            return r === t1 ? i : r;
        }
        function rt(e1, t1) {
            const i = {};
            for(let n = 0; n < t1.length; n++){
                const r = t1[n];
                r in e1 && (i[r] = e1[r]);
            }
            return i;
        }
        let ot = 1;
        function at() {
            return function e1(t1) {
                return t1 ? (+t1 ^ Math.random() * (16 >> +t1 / 4)).toString(16) : ([
                    1e7
                ] + -[
                    1e3
                ] + -4000 + -8000 + -100000000000).replace(/[018]/g, e1);
            }();
        }
        function st(e1) {
            return e1 <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log2(e1)));
        }
        function lt(e1) {
            return !!e1 && Xe.test(e1);
        }
        function ct(e1, t1) {
            const i = t1;
            e1.forEach((e1)=>{
                i[e1] && (i[e1] = i[e1].bind(t1));
            });
        }
        function ut(e1, t1, i) {
            const n = {};
            for(const i in e1)n[i] = t1.call(this, e1[i], i, e1);
            return n;
        }
        function ht(e1, t1, i) {
            const n = {};
            for(const i in e1)t1.call(this, e1[i], i, e1) && (n[i] = e1[i]);
            return n;
        }
        function dt(e1) {
            if (Array.isArray(e1)) {
                const t1 = new Array(e1.length);
                for(let i = 0; i < e1.length; i++)t1[i] = dt(e1[i]);
                return t1;
            }
            return "object" == typeof e1 && e1 ? ut(e1, dt) : e1;
        }
        function ft(e1, t1) {
            for(let i = 0; i < e1.length; i++)if (t1.includes(e1[i])) return !0;
            return !1;
        }
        const pt = {};
        function _t(e1) {
            pt[e1] || ("undefined" != typeof console && console.warn(e1), pt[e1] = !0);
        }
        function mt(e1, t1, i) {
            return (i.y - e1.y) * (t1.x - e1.x) > (t1.y - e1.y) * (i.x - e1.x);
        }
        function gt([e1, t1, i]) {
            const n = Ye(t1 + 90), r = Ye(i);
            return {
                x: e1 * Math.cos(n) * Math.sin(r),
                y: e1 * Math.sin(n) * Math.sin(r),
                z: e1 * Math.cos(r),
                azimuthal: t1,
                polar: i
            };
        }
        function yt(e1, t1, i) {
            const n = Math.sqrt(e1 * e1 + t1 * t1 + i * i), r = n > 0 ? Math.acos(i / n) * qe : 0;
            let o = 0 !== e1 || 0 !== t1 ? Math.atan2(-t1, -e1) * qe + 90 : 0;
            return o < 0 && (o += 360), [
                n,
                o,
                r
            ];
        }
        function xt(e1) {
            return ("undefined" != typeof self || void 0 !== e1) && "undefined" != typeof WorkerGlobalScope && (void 0 !== e1 ? e1 : self) instanceof WorkerGlobalScope;
        }
        function vt(e1) {
            const t1 = {};
            if (e1.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (e1, i, n, r)=>{
                const o = n || r;
                return t1[i] = !o || o.toLowerCase(), "";
            }), t1["max-age"]) {
                const e1 = parseInt(t1["max-age"], 10);
                isNaN(e1) ? delete t1["max-age"] : t1["max-age"] = e1;
            }
            return t1;
        }
        function bt(e1) {
            return e1 ? {
                cacheControl: e1.get("cache-control"),
                expires: e1.get("expires")
            } : {
                cacheControl: void 0,
                expires: void 0
            };
        }
        function wt(e1) {
            try {
                const t1 = self[e1];
                return t1.setItem("_mapbox_test_", 1), t1.removeItem("_mapbox_test_"), !0;
            } catch (e1) {
                return !1;
            }
        }
        function At(e1, t1) {
            return [
                e1[4 * t1],
                e1[4 * t1 + 1],
                e1[4 * t1 + 2],
                e1[4 * t1 + 3]
            ];
        }
        function Et(e1, t1, i) {
            e1[4 * t1 + 0] = i[0], e1[4 * t1 + 1] = i[1], e1[4 * t1 + 2] = i[2], e1[4 * t1 + 3] = i[3];
        }
        function It(e1) {
            return [
                Math.pow(e1[0], 1 / 2.2),
                Math.pow(e1[1], 1 / 2.2),
                Math.pow(e1[2], 1 / 2.2)
            ];
        }
        function Mt(e1) {
            return e1 > 0 ? 1 / (1.001 - e1) : 1 + e1;
        }
        function St(e1) {
            return e1 > 0 ? 1 - 1 / (1.001 - e1) : -e1;
        }
        function Tt(e1, t1, i) {
            return (e1 - t1.min) * (i.max - i.min) / (t1.max - t1.min) + i.min;
        }
        function zt(e1) {
            return e1 * e1 * e1 * e1 * e1;
        }
        function Rt(e1) {
            return e1 >>>= 0, e1 = Math.imul(2747636419 ^ e1, 2654435769) >>> 0, e1 = Math.imul(e1 ^ e1 >>> 16, 2654435769) >>> 0, (e1 = Math.imul(e1 ^ e1 >>> 16, 2654435769) >>> 0) / 4294967296;
        }
        let Pt, Dt, Ft, Ct, Ot, Lt;
        function Bt() {
            return Pt ??= self.OffscreenCanvas && !!new OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof self.createImageBitmap, Pt;
        }
        const Vt = {
            requestIdleCallback: (e1)=>{
                if ("undefined" != typeof requestIdleCallback) return requestIdleCallback(e1);
                setTimeout(()=>e1({
                        didTimeout: !1,
                        timeRemaining: ()=>50
                    }), 0);
            },
            now: ()=>void 0 !== Ct ? Ct : performance.now(),
            setNow (e1) {
                Ct = e1;
            },
            restoreNow () {
                Ct = void 0;
            },
            frame (e1) {
                const t1 = requestAnimationFrame(e1);
                return {
                    cancel: ()=>cancelAnimationFrame(t1)
                };
            },
            getImageData (e1, t1 = 0) {
                const { width: i, height: n } = e1;
                Ot || (Ot = document.createElement("canvas"));
                const r = Ot.getContext("2d", {
                    willReadFrequently: !0
                });
                if (!r) throw new Error("failed to create canvas 2d context");
                return (i > Ot.width || n > Ot.height) && (Ot.width = i, Ot.height = n), r.clearRect(-t1, -t1, i + 2 * t1, n + 2 * t1), r.drawImage(e1, 0, 0, i, n), r.getImageData(-t1, -t1, i + 2 * t1, n + 2 * t1);
            },
            resolveURL: (e1)=>(Dt || (Dt = document.createElement("a")), Dt.href = e1, Dt.href),
            get devicePixelRatio () {
                return window.devicePixelRatio;
            },
            get prefersReducedMotion () {
                return !!window.matchMedia && (Ft ??= window.matchMedia("(prefers-reduced-motion: reduce)"), Ft.matches);
            },
            hasCanvasFingerprintNoise () {
                if (void 0 !== Lt) return Lt;
                if (!Bt()) return Lt = !1, !1;
                const e1 = new OffscreenCanvas(85, 1), t1 = e1.getContext("2d", {
                    willReadFrequently: !0
                });
                let i = 0;
                for(let n = 0; n < e1.width; ++n)t1.fillStyle = `rgba(${i++},${i++},${i++}, 255)`, t1.fillRect(n, 0, 1, 1);
                const n = t1.getImageData(0, 0, e1.width, e1.height);
                i = 0;
                for(let e1 = 0; e1 < n.data.length; ++e1)if (e1 % 4 != 3 && i++ !== n.data[e1]) return Lt = !0, !0;
                return Lt = !1, !1;
            }
        };
        let Nt;
        const kt = {
            API_URL: "https://api.mapbox.com",
            API_URL_REGEX: /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i,
            API_TILEJSON_REGEX: /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/v[0-9]*\/.*\.json.*$)/i,
            API_SPRITE_REGEX: /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*\/sprite.*\..*$)/i,
            API_FONTS_REGEX: /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/fonts\/v[0-9]*\/)(.*\.pbf.*$)/i,
            API_STYLE_REGEX: /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*$)/i,
            API_CDN_URL_REGEX: /^((https?:)?\/\/)?api\.mapbox\.c(n|om)(\/mapbox-gl-js\/)(.*$)/i,
            get EVENTS_URL () {
                if (!kt.API_URL) return null;
                try {
                    const e1 = new URL(kt.API_URL);
                    return "api.mapbox.cn" === e1.hostname ? "https://events.mapbox.cn/events/v2" : "api.mapbox.com" === e1.hostname ? "https://events.mapbox.com/events/v2" : null;
                } catch (e1) {
                    return null;
                }
            },
            SESSION_PATH: "/map-sessions/v1",
            FEEDBACK_URL: "https://apps.mapbox.com/feedback",
            TILE_URL_VERSION: "v4",
            RASTER_URL_PREFIX: "raster/v1",
            RASTERARRAYS_URL_PREFIX: "rasterarrays/v1",
            REQUIRE_ACCESS_TOKEN: !0,
            ACCESS_TOKEN: null,
            DEFAULT_STYLE: "mapbox://styles/mapbox/standard",
            MAX_PARALLEL_IMAGE_REQUESTS: 16,
            DRACO_URL: "/mapbox-gl-js/draco_decoder_gltf_v1.5.6.wasm",
            MESHOPT_URL: "/mapbox-gl-js/meshopt_base_v1.2.wasm",
            MESHOPT_SIMD_URL: "/mapbox-gl-js/meshopt_simd_v1.2.wasm",
            BUILDING_GEN_URL: "/mapbox-gl-js/building-gen/building_gen_v1.2.6.wasm",
            RTL_TEXT_URL: "/mapbox-gl-js/rtl_text_v1.0.0.wasm",
            GLYPHS_URL: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf",
            TILES3D_URL_PREFIX: "3dtiles/v1",
            TILE_PROVIDER_URLS: Object.assign(Object.create(null), {
                pmtiles: "/mapbox-gl-js/plugins/mapbox-gl-pmtiles-provider/v0.0.3/mapbox-gl-pmtiles-provider.js"
            })
        };
        function Ut() {
            return new URL(kt.DRACO_URL, kt.API_URL).href;
        }
        function jt() {
            if ("object" != typeof WebAssembly) throw new Error("WebAssembly not supported, cannot instantiate meshoptimizer");
            return new URL(function() {
                if (void 0 === Nt) {
                    if ("object" != typeof WebAssembly) return !1;
                    const e1 = new Uint8Array([
                        0,
                        97,
                        115,
                        109,
                        1,
                        0,
                        0,
                        0,
                        1,
                        4,
                        1,
                        96,
                        0,
                        0,
                        3,
                        3,
                        2,
                        0,
                        0,
                        5,
                        3,
                        1,
                        0,
                        1,
                        12,
                        1,
                        0,
                        10,
                        22,
                        2,
                        12,
                        0,
                        65,
                        0,
                        65,
                        0,
                        65,
                        0,
                        252,
                        10,
                        0,
                        0,
                        11,
                        7,
                        0,
                        65,
                        0,
                        253,
                        15,
                        26,
                        11
                    ]);
                    Nt = WebAssembly.validate(e1);
                }
                return Nt;
            }() ? kt.MESHOPT_SIMD_URL : kt.MESHOPT_URL, kt.API_URL).href;
        }
        function Gt() {
            return new URL(kt.BUILDING_GEN_URL, kt.API_URL).href;
        }
        function Ht(e1, t1) {
            const i = e1.indexOf("?"), n = i < 0 ? e1 : e1.slice(0, i), r = new URLSearchParams(i < 0 ? "" : e1.slice(i));
            for (const [e1, i] of Object.entries(t1))r.set(e1, i);
            return `${n}?${r}`;
        }
        function $t(e1, t1 = {
            persistentParams: []
        }) {
            const i = e1.indexOf("?");
            if (i < 0) return e1;
            const n = new URLSearchParams, r = new URLSearchParams(e1.slice(i));
            for (const e1 of t1.persistentParams){
                const t1 = r.get(e1);
                t1 && n.set(e1, t1);
            }
            const o = n.toString();
            return `${e1.slice(0, i)}${o.length > 0 ? `?${o}` : ""}`;
        }
        const Zt = "mapbox-tiles";
        let Wt = 500, qt = 50;
        const Xt = [
            "language",
            "worldview",
            "jobid"
        ];
        let Yt;
        function Jt() {
            try {
                return caches;
            } catch (e1) {}
        }
        function Kt() {
            const e1 = Jt();
            e1 && null == Yt && (Yt = e1.open(Zt));
        }
        let Qt = 1 / 0;
        function ei(e1) {
            return kt.API_URL_REGEX.test(e1);
        }
        function ti(e1) {
            return 0 === e1.indexOf("mapbox:");
        }
        function ii(e1) {
            return kt.API_CDN_URL_REGEX.test(e1);
        }
        function ni(e1) {
            return kt.API_SPRITE_REGEX.test(e1);
        }
        function ri(e1) {
            return kt.API_STYLE_REGEX.test(e1) && !ni(e1);
        }
        const oi = {
            Unknown: "Unknown",
            Style: "Style",
            Source: "Source",
            Tile: "Tile",
            Glyphs: "Glyphs",
            SpriteImage: "SpriteImage",
            SpriteJSON: "SpriteJSON",
            Iconset: "Iconset",
            Image: "Image",
            Model: "Model"
        };
        Object.freeze(oi);
        class ai extends Error {
            constructor(e1, t1, i){
                super(), this.url = i, this.statusText = e1, this.status = t1;
            }
            get message() {
                return 401 === this.status && ei(this.url) ? `${this.statusText}: you may have provided an invalid Mapbox access token. See https://docs.mapbox.com/api/guides/#access-tokens-and-token-scopes` : this.statusText;
            }
            toString() {
                return `${this.name}: ${this.message} (${this.status}): ${this.url}`;
            }
        }
        function si(e1) {
            return "object" == typeof e1 && null !== e1 && "status" in e1 && 404 === e1.status;
        }
        const li = xt() ? ()=>self.worker.referrer : ()=>("blob:" === location.protocol ? parent : self).location.href, ci = /^\w+:/, ui = /[\r\n]+/;
        async function hi(e1, t1) {
            let i;
            return i = "arrayBuffer" === e1.type ? await t1.arrayBuffer() : "json" === e1.type ? await t1.json() : await t1.text(), {
                data: i,
                headers: t1.headers
            };
        }
        async function di(e1, t1) {
            var i;
            return t1 && t1.throwIfAborted(), (i = e1.url).startsWith("file:") || li().startsWith("file:") && !ci.test(i) ? async function(e1, t1) {
                return new Promise((i, n)=>{
                    const r = new XMLHttpRequest, o = ()=>{
                        t1.removeEventListener("abort", o), r.abort(), n(t1.reason);
                    };
                    t1 && t1.addEventListener("abort", o), r.open(e1.method || "GET", e1.url, !0), "arrayBuffer" === e1.type && (r.responseType = "arraybuffer");
                    for(const t1 in e1.headers)r.setRequestHeader(t1, e1.headers[t1]);
                    "json" === e1.type && (r.responseType = "text", r.setRequestHeader("Accept", "application/json")), r.withCredentials = "include" === e1.credentials, r.onerror = ()=>{
                        t1 && t1.removeEventListener("abort", o), n(new Error(r.statusText));
                    }, r.onload = ()=>{
                        if (t1 && t1.removeEventListener("abort", o), (r.status >= 200 && r.status < 300 || 0 === r.status) && null !== r.response) {
                            let t1 = r.response;
                            if ("json" === e1.type) try {
                                t1 = JSON.parse(r.response);
                            } catch (e1) {
                                return void n(e1);
                            }
                            const o = new Headers;
                            r.getAllResponseHeaders().trim().split(ui).forEach((e1)=>{
                                const t1 = e1.split(": "), i = t1.shift(), n = t1.join(": ");
                                i && o.set(i, n);
                            }), i({
                                data: t1,
                                headers: o
                            });
                        } else n(new ai(r.statusText, r.status, e1.url));
                    }, r.send(e1.body);
                });
            }(e1, t1) : async function(e1, t1) {
                const i = new Request(e1.url, {
                    method: e1.method || "GET",
                    body: e1.body,
                    credentials: e1.credentials,
                    headers: e1.headers,
                    referrer: li(),
                    referrerPolicy: e1.referrerPolicy,
                    signal: t1
                }), n = (r = i.url).indexOf("sku=") > 0 && ei(r);
                var r;
                if ("json" === e1.type && i.headers.set("Accept", "application/json"), n) {
                    let n = null;
                    try {
                        n = await async function(e1) {
                            if (Kt(), null == Yt) return null;
                            const t1 = await Yt;
                            let i = $t(e1.url, {
                                persistentParams: Xt
                            });
                            const n = e1.headers.get("Range");
                            n && (i = Ht(i, {
                                range: n
                            }));
                            const r = await t1.match(i);
                            if (!r) return null;
                            const o = function(e1) {
                                if (!e1) return !1;
                                const t1 = new Date(e1.headers.get("expires") || 0), i = vt(e1.headers.get("cache-control") || "");
                                return Number(t1) > Date.now() && !i["no-cache"];
                            }(r);
                            return t1.delete(i).catch((e1)=>_t(e1.message)), o && t1.put(i, r.clone()).catch((e1)=>_t(e1.message)), {
                                response: r,
                                fresh: o
                            };
                        }(i);
                    } catch (e1) {
                        "SecurityError" !== e1.message && _t(e1.toString());
                    }
                    if (n && n.fresh) return t1 && t1.throwIfAborted(), hi(e1, n.response);
                }
                const o = Date.now();
                let a;
                try {
                    a = await fetch(i);
                } catch (t1) {
                    if ("AbortError" === t1.name) throw t1;
                    throw new Error(`${t1.message} ${e1.url}`, {
                        cause: t1
                    });
                }
                if (t1 && t1.throwIfAborted(), !a.ok) throw new ai(a.statusText, a.status, e1.url);
                const s = n ? a.clone() : null, l = await hi(e1, a);
                return s && async function(e1, t1, i) {
                    if (Kt(), null == Yt) return;
                    const n = vt(t1.headers.get("cache-control") || "");
                    if (n["no-store"]) return;
                    const r = {
                        status: t1.status,
                        statusText: t1.statusText,
                        headers: new Headers(t1.headers)
                    };
                    n["max-age"] && r.headers.set("Expires", new Date(i + 1e3 * n["max-age"]).toUTCString());
                    const o = r.headers.get("expires");
                    if (!o) return;
                    if (new Date(o).getTime() - i < 42e4) return;
                    let a = $t(e1.url, {
                        persistentParams: Xt
                    });
                    if (206 === t1.status) {
                        const t1 = e1.headers.get("Range");
                        if (!t1) return;
                        r.status = 200, a = Ht(a, {
                            range: t1
                        });
                    }
                    const s = new Response(200 !== (l = t1.status) && 404 !== l && [
                        101,
                        103,
                        204,
                        205,
                        304
                    ].includes(l) ? null : t1.body, r);
                    var l;
                    if (Kt(), null != Yt) try {
                        const e1 = await Yt;
                        await e1.put(a, s);
                    } catch (e1) {
                        _t(e1.message);
                    }
                }(i, s, o), l;
            }(e1, t1);
        }
        async function fi(e1, t1) {
            return di(Object.assign(e1, {
                type: "json"
            }), t1);
        }
        async function pi(e1, t1) {
            return di(Object.assign(e1, {
                type: "arrayBuffer"
            }), t1);
        }
        function _i(e1) {
            const t1 = document.createElement("a");
            return t1.href = e1, t1.protocol === location.protocol && t1.host === location.host;
        }
        let mi, gi;
        mi = [], gi = 0;
        const yi = "01", xi = {
            create: "create",
            load: "load",
            fullLoad: "fullLoad"
        }, vi = {
            mark (e1) {
                performance.mark(e1);
            },
            measure (e1, t1, i) {
                performance.measure(e1, t1, i);
            }
        };
        function bi(e1) {
            const t1 = e1.name.split("?")[0];
            return ii(t1) && t1.includes("mapbox-gl.js") ? "javascript" : ii(t1) && t1.includes("mapbox-gl.css") ? "css" : function(e1) {
                return kt.API_FONTS_REGEX.test(e1);
            }(t1) ? "fontRange" : ni(t1) ? "sprite" : ri(t1) ? "style" : function(e1) {
                return kt.API_TILEJSON_REGEX.test(e1);
            }(t1) ? "tilejson" : "other";
        }
        const wi = /(\.(png|jpg)\d*)(?=$)/, Ai = /^.+\/v4\//, Ei = /\.[\w]+$/, Ii = /^(\/v4\/|\/(raster|rasterarrays)\/v1\/)/, Mi = /^access_token=(.*)$/, Si = "NO_ACCESS_TOKEN", Ti = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
        function zi(e1) {
            const t1 = e1.match(Ti);
            if (!t1) throw new Error("Unable to parse URL object");
            return {
                protocol: t1[1],
                authority: t1[2],
                path: t1[3] || "/",
                params: t1[4] ? t1[4].split("&") : []
            };
        }
        function Ri(e1) {
            const t1 = e1.params.length ? `?${e1.params.join("&")}` : "";
            return `${e1.protocol}://${e1.authority}${e1.path}${t1}`;
        }
        const Pi = "mapbox.eventData";
        function Di(e1) {
            if (!e1) return null;
            const t1 = e1.split(".");
            if (!t1 || 3 !== t1.length) return null;
            try {
                const e1 = JSON.parse(decodeURIComponent(atob(t1[1]).split("").map((e1)=>"%" + ("00" + e1.charCodeAt(0).toString(16)).slice(-2)).join("")));
                return e1;
            } catch (e1) {
                return null;
            }
        }
        function Fi(e1) {
            return !(!kt.EVENTS_URL || !e1 && !kt.ACCESS_TOKEN);
        }
        let Ci;
        const Oi = /^[\w.+-]+(\/[\w.+-]+)?$/;
        let Li = "other";
        class Bi {
            constructor(e1){
                this.type = e1, this.anonId = null, this.anonIdTimestamp = null, this.eventData = {}, this.queue = [], this.pendingRequest = !1;
            }
            getStorageKey(e1) {
                const t1 = Di(kt.ACCESS_TOKEN);
                let i = "";
                return i = t1 && t1.u ? btoa(encodeURIComponent(t1.u).replace(/%([0-9A-F]{2})/g, (e1, t1)=>String.fromCharCode(Number("0x" + t1)))) : kt.ACCESS_TOKEN || "", e1 ? `${Pi}.${e1}:${i}` : `${Pi}:${i}`;
            }
            fetchEventData() {
                const e1 = wt("localStorage"), t1 = this.getStorageKey(), i = this.getStorageKey("uuid"), n = this.getStorageKey("uuidTimestamp");
                if (e1) try {
                    const e1 = localStorage.getItem(t1);
                    e1 && (this.eventData = JSON.parse(e1));
                    const r = localStorage.getItem(i);
                    r && (this.anonId = r);
                    const o = localStorage.getItem(n);
                    o && (this.anonIdTimestamp = Number(o));
                    const a = Date.now() - 864e5;
                    (!this.anonIdTimestamp || this.anonIdTimestamp < a) && this.refreshUUID();
                } catch (e1) {
                    _t("Unable to read from LocalStorage");
                }
            }
            refreshUUID() {
                this.anonId = at(), this.anonIdTimestamp = Date.now();
            }
            saveEventData() {
                const e1 = wt("localStorage"), t1 = this.getStorageKey(), i = this.getStorageKey("uuid"), n = this.getStorageKey("uuidTimestamp"), r = this.anonId, o = this.anonIdTimestamp;
                if (e1 && r) try {
                    localStorage.setItem(i, r), Object.keys(this.eventData).length >= 1 && localStorage.setItem(t1, JSON.stringify(this.eventData)), o && localStorage.setItem(n, o.toString());
                } catch (e1) {
                    _t("Unable to write to LocalStorage");
                }
            }
            processRequests() {}
            postEvent(e1, t1, i, n) {
                if (!kt.EVENTS_URL) return;
                const r = zi(kt.EVENTS_URL);
                r.params.push(`access_token=${n || kt.ACCESS_TOKEN || ""}`);
                const o = {
                    event: this.type,
                    created: new Date(e1).toISOString()
                }, a = t1 ? Object.assign(o, t1) : o, s = {
                    url: Ri(r),
                    headers: {
                        "Content-Type": "text/plain"
                    },
                    body: JSON.stringify([
                        a
                    ])
                };
                this.pendingRequest = !0, (async function(e1) {
                    return di(Object.assign(e1, {
                        method: "POST"
                    }), void 0);
                })(s).then(()=>{
                    this.pendingRequest = !1, i(null), this.saveEventData(), this.processRequests();
                }).catch((e1)=>{
                    this.pendingRequest = !1, i(e1), this.saveEventData(), this.processRequests();
                });
            }
            queueRequest(e1, t1) {
                this.queue.push({
                    ...e1,
                    customAccessToken: t1
                }), this.processRequests();
            }
        }
        class Vi extends Bi {
            constructor(e1){
                super("metrics"), e1 && (this.data = e1);
            }
            postMetricsEvent(e1) {
                if (!Fi(e1)) return;
                this.anonId || this.fetchEventData(), lt(this.anonId) || this.refreshUUID();
                const t1 = {
                    ...this.data,
                    sessionId: this.anonId
                };
                this.queueRequest({
                    timestamp: Date.now(),
                    payload: t1
                }, e1);
            }
            processRequests() {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { timestamp: e1, payload: t1, customAccessToken: i } = this.queue.shift();
                this.postEvent(e1, t1, ()=>{}, i);
            }
        }
        const Ni = new class extends Bi {
            constructor(e1){
                super("appUserTurnstile"), this._customAccessToken = e1;
            }
            postTurnstileEvent(e1, t1) {
                Fi(t1) && Array.isArray(e1) && e1.some((e1)=>ti(e1) || ei(e1)) && this.queueRequest({
                    timestamp: Date.now()
                }, t1);
            }
            processRequests() {
                if (this.pendingRequest || 0 === this.queue.length) return;
                this.anonId && this.anonIdTimestamp && this.eventData.lastSuccess && this.eventData.tokenU || this.fetchEventData();
                const e1 = Di(kt.ACCESS_TOKEN), t1 = e1 ? e1.u : kt.ACCESS_TOKEN;
                let n = t1 !== this.eventData.tokenU;
                lt(this.anonId) || (this.refreshUUID(), n = !0);
                const { timestamp: r, customAccessToken: o } = this.queue.shift();
                if (this.eventData.lastSuccess) {
                    const e1 = new Date(this.eventData.lastSuccess), t1 = new Date(r), i = (r - this.eventData.lastSuccess) / 864e5;
                    n = n || i >= 1 || i < -1 || e1.getDate() !== t1.getDate();
                } else n = !0;
                if (!n) return void this.processRequests();
                const a = {
                    version: "2.2",
                    sdkIdentifier: "mapbox-gl-js",
                    sdkVersion: i,
                    skuId: yi,
                    "enabled.telemetry": !1,
                    userId: this.anonId,
                    bundleFormat: "umd",
                    bundleDistribution: Li
                };
                Ci && (a.sdkInfo = Ci), this.postEvent(r, a, (e1)=>{
                    e1 || (this.eventData.lastSuccess = r, this.eventData.tokenU = t1);
                }, o);
            }
        }, ki = Ni.postTurnstileEvent.bind(Ni), Ui = new class extends Bi {
            constructor(){
                super("map.load"), this.success = {}, this.skuToken = "";
            }
            postMapLoadEvent(e1, t1, i, n) {
                this.skuToken = t1, this.errorCb = n, kt.EVENTS_URL && (i || kt.ACCESS_TOKEN ? this.queueRequest({
                    id: e1,
                    timestamp: Date.now()
                }, i) : this.errorCb(new Error(Si)));
            }
            processRequests() {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { id: e1, timestamp: t1, customAccessToken: n } = this.queue.shift();
                if (e1 && this.success[e1]) return;
                this.anonId && this.anonIdTimestamp || this.fetchEventData(), lt(this.anonId) || this.refreshUUID();
                const r = {
                    version: "2.2",
                    sdkIdentifier: "mapbox-gl-js",
                    sdkVersion: i,
                    skuId: yi,
                    skuToken: this.skuToken,
                    userId: this.anonId,
                    bundleFormat: "umd",
                    bundleDistribution: Li
                };
                Ci && (r.sdkInfo = Ci), this.postEvent(t1, r, (t1)=>{
                    t1 ? this.errorCb(t1) : e1 && (this.success[e1] = !0);
                }, n);
            }
            remove() {
                this.errorCb = null;
            }
        }, ji = Ui.postMapLoadEvent.bind(Ui), Gi = new class extends Bi {
            constructor(){
                super("style.load"), this.eventIdPerMapInstanceMap = new Map, this.mapInstanceIdMap = new WeakMap;
            }
            getMapInstanceId(e1) {
                let t1 = this.mapInstanceIdMap.get(e1);
                return t1 || (t1 = at(), this.mapInstanceIdMap.set(e1, t1)), t1;
            }
            getEventId(e1) {
                const t1 = this.eventIdPerMapInstanceMap.get(e1) || 0;
                return this.eventIdPerMapInstanceMap.set(e1, t1 + 1), t1;
            }
            postStyleLoadEvent(e1, t1) {
                const { map: i, style: n, importedStyles: r } = t1;
                if (!Fi(e1)) return;
                const o = this.getMapInstanceId(i), a = {
                    mapInstanceId: o,
                    eventId: this.getEventId(o),
                    style: n
                };
                r.length && (a.importedStyles = r), this.queueRequest({
                    timestamp: Date.now(),
                    payload: a
                }, e1);
            }
            processRequests() {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { timestamp: e1, payload: t1, customAccessToken: i } = this.queue.shift();
                this.postEvent(e1, t1, ()=>{}, i);
            }
        }, Hi = Gi.postStyleLoadEvent.bind(Gi), $i = new Vi({
            attributes: [
                {
                    name: "maps/js/layer-animations/style-with-appearances"
                }
            ]
        }), Zi = $i.postMetricsEvent.bind($i), Wi = new Vi({
            attributes: [
                {
                    name: "maps/js/layer-animations/runtime-appearances"
                }
            ]
        }), qi = Wi.postMetricsEvent.bind(Wi), Xi = new class extends Bi {
            constructor(){
                super("gljs.performance");
            }
            postPerformanceEvent(e1, t1) {
                Fi(e1) && this.queueRequest({
                    timestamp: Date.now(),
                    performanceData: t1
                }, e1);
            }
            processRequests() {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { timestamp: e1, performanceData: t1, customAccessToken: n } = this.queue.shift(), r = function(e1) {
                    const t1 = performance.getEntriesByType("resource"), n = performance.getEntriesByType("mark"), r = function(e1) {
                        const t1 = {};
                        if (e1) {
                            for(const i in e1)if ("other" !== i) for (const n of e1[i]){
                                const e1 = `${i}ResolveRangeMin`, r = `${i}ResolveRangeMax`, o = `${i}RequestCount`, a = `${i}RequestCachedCount`;
                                t1[e1] = Math.min(t1[e1] || 1 / 0, n.startTime), t1[r] = Math.max(t1[r] || -1 / 0, n.responseEnd);
                                const s = (e1)=>{
                                    void 0 === t1[e1] && (t1[e1] = 0), ++t1[e1];
                                };
                                void 0 !== n.transferSize && 0 === n.transferSize && s(a), s(o);
                            }
                        }
                        return t1;
                    }(function(e1, t1) {
                        const i = {};
                        if (e1) for (const n of e1){
                            const e1 = t1(n);
                            void 0 === i[e1] && (i[e1] = []), i[e1].push(n);
                        }
                        return i;
                    }(t1, bi)), o = window.devicePixelRatio, a = navigator.connection || navigator.mozConnection || navigator.webkitConnection, s = a ? a.effectiveType : void 0, l = {
                        counters: [],
                        metadata: [],
                        attributes: []
                    }, c = (e1, t1, i)=>{
                        null != i && e1.push({
                            name: t1,
                            value: i.toString()
                        });
                    };
                    for(const e1 in r)c(l.counters, e1, r[e1]);
                    if (e1.interactionRange[0] !== 1 / 0 && e1.interactionRange[1] !== -1 / 0 && (c(l.counters, "interactionRangeMin", e1.interactionRange[0]), c(l.counters, "interactionRangeMax", e1.interactionRange[1])), n) for (const e1 of Object.values(xi)){
                        const t1 = n.find((t1)=>t1.name === e1);
                        t1 && c(l.counters, e1, t1.startTime);
                    }
                    return c(l.counters, "visibilityHidden", e1.visibilityHidden), c(l.attributes, "style", function(e1) {
                        if (e1) for (const t1 of e1){
                            const e1 = t1.name.split("?")[0];
                            if (ri(e1)) {
                                const t1 = e1.split("/").slice(-2);
                                if (2 === t1.length) return `mapbox://styles/${t1[0]}/${t1[1]}`;
                            }
                        }
                    }(t1)), c(l.attributes, "terrainEnabled", e1.terrainEnabled ? "true" : "false"), c(l.attributes, "fogEnabled", e1.fogEnabled ? "true" : "false"), c(l.attributes, "projection", e1.projection), c(l.attributes, "zoom", e1.zoom), c(l.metadata, "devicePixelRatio", o), c(l.metadata, "connectionEffectiveType", s), c(l.metadata, "navigatorUserAgent", navigator.userAgent), c(l.metadata, "screenWidth", window.screen.width), c(l.metadata, "screenHeight", window.screen.height), c(l.metadata, "windowWidth", window.innerWidth), c(l.metadata, "windowHeight", window.innerHeight), c(l.metadata, "mapWidth", e1.width / o), c(l.metadata, "mapHeight", e1.height / o), c(l.metadata, "webglRenderer", e1.renderer), c(l.metadata, "webglVendor", e1.vendor), c(l.metadata, "sdkVersion", i), c(l.metadata, "sdkIdentifier", "mapbox-gl-js"), l;
                }(t1);
                for (const e1 of r.metadata);
                for (const e1 of r.counters);
                for (const e1 of r.attributes);
                this.postEvent(e1, r, ()=>{}, n);
            }
        }, Yi = Xi.postPerformanceEvent.bind(Xi), Ji = new class extends Bi {
            constructor(){
                super("map.auth"), this.success = {}, this.skuToken = "";
            }
            getSession(e1, t1, i, n) {
                if (!kt.API_URL || !kt.SESSION_PATH) return;
                const r = zi(kt.API_URL + kt.SESSION_PATH);
                r.params.push(`sku=${t1 || ""}`), r.params.push(`access_token=${n || kt.ACCESS_TOKEN || ""}`);
                const o = {
                    url: Ri(r),
                    headers: {
                        "Content-Type": "text/plain"
                    }
                };
                this.pendingRequest = !0, (async function(e1) {
                    return di(Object.assign(e1, {
                        method: "GET"
                    }), void 0);
                })(o).then(()=>{
                    this.pendingRequest = !1, i(null), this.saveEventData(), this.processRequests();
                }).catch((e1)=>{
                    this.pendingRequest = !1, i(e1), this.saveEventData(), this.processRequests();
                });
            }
            getSessionAPI(e1, t1, i, n) {
                this.skuToken = t1, this.errorCb = n, kt.EVENTS_URL && kt.SESSION_PATH && kt.API_URL && (i || kt.ACCESS_TOKEN ? this.queueRequest({
                    id: e1,
                    timestamp: Date.now()
                }, i) : this.errorCb(new Error(Si)));
            }
            processRequests() {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { id: e1, timestamp: t1, customAccessToken: i } = this.queue.shift();
                e1 && this.success[e1] || this.getSession(t1, this.skuToken, (t1)=>{
                    t1 ? this.errorCb(t1) : e1 && (this.success[e1] = !0);
                }, i);
            }
            remove() {
                this.errorCb = null;
            }
        }, Ki = Ji.getSessionAPI.bind(Ji), Qi = new Set;
        function en(e1, t1 = 0) {
            const i = 3432918353, n = 461845907, r = e1.length, o = r - (3 & r);
            let a, s = 0 | t1, l = 0;
            for(; l < o;)a = 255 & e1.charCodeAt(l) | (255 & e1.charCodeAt(l + 1)) << 8 | (255 & e1.charCodeAt(l + 2)) << 16 | (255 & e1.charCodeAt(l + 3)) << 24, l += 4, a = Math.imul(a, i), a = a << 15 | a >>> 17, a = Math.imul(a, n), s ^= a, s = s << 13 | s >>> 19, s = Math.imul(s, 5) + 3864292196 | 0;
            a = 0;
            const c = 3 & r;
            return c > 0 && (c >= 3 && (a ^= (255 & e1.charCodeAt(l + 2)) << 16), c >= 2 && (a ^= (255 & e1.charCodeAt(l + 1)) << 8), a ^= 255 & e1.charCodeAt(l), a = Math.imul(a, i), a = a << 15 | a >>> 17, a = Math.imul(a, n), s ^= a), s ^= r, s ^= s >>> 16, s = Math.imul(s, 2246822507), s ^= s >>> 13, s = Math.imul(s, 3266489909), s ^= s >>> 16, s >>> 0;
        }
        class tn {
            constructor(e1, ...t1){
                Object.assign(this, t1[0] || {}), this.type = e1;
            }
        }
        class nn extends tn {
            constructor(e1, t1 = {}){
                super("error", {
                    error: e1,
                    ...t1
                }), this.error = e1;
            }
        }
        function rn(e1, t1, i) {
            i[e1] && i[e1].includes(t1) || (i[e1] = i[e1] || [], i[e1].push(t1));
        }
        function on(e1, t1, i) {
            if (i[e1]) {
                const n = i[e1].indexOf(t1);
                -1 !== n && i[e1].splice(n, 1);
            }
        }
        class an {
            constructor(){
                this._listeners = {}, this._oneTimeListeners = {};
            }
            on(e1, t1) {
                return rn(e1, t1, this._listeners), this;
            }
            off(e1, t1) {
                return on(e1, t1, this._listeners), on(e1, t1, this._oneTimeListeners), this;
            }
            once(e1, t1) {
                return t1 ? (rn(e1, t1, this._oneTimeListeners), this) : new Promise((t1)=>{
                    this.once(e1, t1);
                });
            }
            fire(e1, t1) {
                const i = "string" == typeof e1 ? new tn(e1, t1) : e1, n = i.type;
                if (this.listens(n)) {
                    i.target = this;
                    const e1 = this._listeners[n] ? this._listeners[n].slice() : [];
                    for (const t1 of e1)t1.call(this, i);
                    const t1 = this._oneTimeListeners[n] ? this._oneTimeListeners[n].slice() : [];
                    for (const e1 of t1)on(n, e1, this._oneTimeListeners), e1.call(this, i);
                    const r = this._eventedParent;
                    if (r) {
                        const e1 = "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData;
                        Object.assign(i, e1), r.fire(i);
                    }
                } else i instanceof nn && console.error(i.error);
                return this;
            }
            listens(e1) {
                return !!(this._listeners[e1] && this._listeners[e1].length > 0 || this._oneTimeListeners[e1] && this._oneTimeListeners[e1].length > 0 || this._eventedParent && this._eventedParent.listens(e1));
            }
            setEventedParent(e1, t1) {
                return this._eventedParent = e1, this._eventedParentData = t1, this;
            }
        }
        class sn {
            constructor(e1){
                "string" == typeof e1 ? this.name = e1 : (this.name = e1.name, this.iconsetId = e1.iconsetId);
            }
            static from(e1) {
                return new sn(e1);
            }
            static toString(e1) {
                return e1.iconsetId ? `${e1.name}${e1.iconsetId}` : e1.name;
            }
            static parse(e1) {
                const [t1, i] = e1.split("");
                return new sn({
                    name: t1,
                    iconsetId: i
                });
            }
            static isEqual(e1, t1) {
                return e1.name === t1.name && e1.iconsetId === t1.iconsetId;
            }
            toString() {
                return sn.toString(this);
            }
            serialize() {
                return {
                    name: this.name,
                    iconsetId: this.iconsetId
                };
            }
        }
        var ln, cn = {}, un = function() {
            if (ln) return cn;
            ln = 1;
            var e1 = {
                transparent: [
                    0,
                    0,
                    0,
                    0
                ],
                aliceblue: [
                    240,
                    248,
                    255,
                    1
                ],
                antiquewhite: [
                    250,
                    235,
                    215,
                    1
                ],
                aqua: [
                    0,
                    255,
                    255,
                    1
                ],
                aquamarine: [
                    127,
                    255,
                    212,
                    1
                ],
                azure: [
                    240,
                    255,
                    255,
                    1
                ],
                beige: [
                    245,
                    245,
                    220,
                    1
                ],
                bisque: [
                    255,
                    228,
                    196,
                    1
                ],
                black: [
                    0,
                    0,
                    0,
                    1
                ],
                blanchedalmond: [
                    255,
                    235,
                    205,
                    1
                ],
                blue: [
                    0,
                    0,
                    255,
                    1
                ],
                blueviolet: [
                    138,
                    43,
                    226,
                    1
                ],
                brown: [
                    165,
                    42,
                    42,
                    1
                ],
                burlywood: [
                    222,
                    184,
                    135,
                    1
                ],
                cadetblue: [
                    95,
                    158,
                    160,
                    1
                ],
                chartreuse: [
                    127,
                    255,
                    0,
                    1
                ],
                chocolate: [
                    210,
                    105,
                    30,
                    1
                ],
                coral: [
                    255,
                    127,
                    80,
                    1
                ],
                cornflowerblue: [
                    100,
                    149,
                    237,
                    1
                ],
                cornsilk: [
                    255,
                    248,
                    220,
                    1
                ],
                crimson: [
                    220,
                    20,
                    60,
                    1
                ],
                cyan: [
                    0,
                    255,
                    255,
                    1
                ],
                darkblue: [
                    0,
                    0,
                    139,
                    1
                ],
                darkcyan: [
                    0,
                    139,
                    139,
                    1
                ],
                darkgoldenrod: [
                    184,
                    134,
                    11,
                    1
                ],
                darkgray: [
                    169,
                    169,
                    169,
                    1
                ],
                darkgreen: [
                    0,
                    100,
                    0,
                    1
                ],
                darkgrey: [
                    169,
                    169,
                    169,
                    1
                ],
                darkkhaki: [
                    189,
                    183,
                    107,
                    1
                ],
                darkmagenta: [
                    139,
                    0,
                    139,
                    1
                ],
                darkolivegreen: [
                    85,
                    107,
                    47,
                    1
                ],
                darkorange: [
                    255,
                    140,
                    0,
                    1
                ],
                darkorchid: [
                    153,
                    50,
                    204,
                    1
                ],
                darkred: [
                    139,
                    0,
                    0,
                    1
                ],
                darksalmon: [
                    233,
                    150,
                    122,
                    1
                ],
                darkseagreen: [
                    143,
                    188,
                    143,
                    1
                ],
                darkslateblue: [
                    72,
                    61,
                    139,
                    1
                ],
                darkslategray: [
                    47,
                    79,
                    79,
                    1
                ],
                darkslategrey: [
                    47,
                    79,
                    79,
                    1
                ],
                darkturquoise: [
                    0,
                    206,
                    209,
                    1
                ],
                darkviolet: [
                    148,
                    0,
                    211,
                    1
                ],
                deeppink: [
                    255,
                    20,
                    147,
                    1
                ],
                deepskyblue: [
                    0,
                    191,
                    255,
                    1
                ],
                dimgray: [
                    105,
                    105,
                    105,
                    1
                ],
                dimgrey: [
                    105,
                    105,
                    105,
                    1
                ],
                dodgerblue: [
                    30,
                    144,
                    255,
                    1
                ],
                firebrick: [
                    178,
                    34,
                    34,
                    1
                ],
                floralwhite: [
                    255,
                    250,
                    240,
                    1
                ],
                forestgreen: [
                    34,
                    139,
                    34,
                    1
                ],
                fuchsia: [
                    255,
                    0,
                    255,
                    1
                ],
                gainsboro: [
                    220,
                    220,
                    220,
                    1
                ],
                ghostwhite: [
                    248,
                    248,
                    255,
                    1
                ],
                gold: [
                    255,
                    215,
                    0,
                    1
                ],
                goldenrod: [
                    218,
                    165,
                    32,
                    1
                ],
                gray: [
                    128,
                    128,
                    128,
                    1
                ],
                green: [
                    0,
                    128,
                    0,
                    1
                ],
                greenyellow: [
                    173,
                    255,
                    47,
                    1
                ],
                grey: [
                    128,
                    128,
                    128,
                    1
                ],
                honeydew: [
                    240,
                    255,
                    240,
                    1
                ],
                hotpink: [
                    255,
                    105,
                    180,
                    1
                ],
                indianred: [
                    205,
                    92,
                    92,
                    1
                ],
                indigo: [
                    75,
                    0,
                    130,
                    1
                ],
                ivory: [
                    255,
                    255,
                    240,
                    1
                ],
                khaki: [
                    240,
                    230,
                    140,
                    1
                ],
                lavender: [
                    230,
                    230,
                    250,
                    1
                ],
                lavenderblush: [
                    255,
                    240,
                    245,
                    1
                ],
                lawngreen: [
                    124,
                    252,
                    0,
                    1
                ],
                lemonchiffon: [
                    255,
                    250,
                    205,
                    1
                ],
                lightblue: [
                    173,
                    216,
                    230,
                    1
                ],
                lightcoral: [
                    240,
                    128,
                    128,
                    1
                ],
                lightcyan: [
                    224,
                    255,
                    255,
                    1
                ],
                lightgoldenrodyellow: [
                    250,
                    250,
                    210,
                    1
                ],
                lightgray: [
                    211,
                    211,
                    211,
                    1
                ],
                lightgreen: [
                    144,
                    238,
                    144,
                    1
                ],
                lightgrey: [
                    211,
                    211,
                    211,
                    1
                ],
                lightpink: [
                    255,
                    182,
                    193,
                    1
                ],
                lightsalmon: [
                    255,
                    160,
                    122,
                    1
                ],
                lightseagreen: [
                    32,
                    178,
                    170,
                    1
                ],
                lightskyblue: [
                    135,
                    206,
                    250,
                    1
                ],
                lightslategray: [
                    119,
                    136,
                    153,
                    1
                ],
                lightslategrey: [
                    119,
                    136,
                    153,
                    1
                ],
                lightsteelblue: [
                    176,
                    196,
                    222,
                    1
                ],
                lightyellow: [
                    255,
                    255,
                    224,
                    1
                ],
                lime: [
                    0,
                    255,
                    0,
                    1
                ],
                limegreen: [
                    50,
                    205,
                    50,
                    1
                ],
                linen: [
                    250,
                    240,
                    230,
                    1
                ],
                magenta: [
                    255,
                    0,
                    255,
                    1
                ],
                maroon: [
                    128,
                    0,
                    0,
                    1
                ],
                mediumaquamarine: [
                    102,
                    205,
                    170,
                    1
                ],
                mediumblue: [
                    0,
                    0,
                    205,
                    1
                ],
                mediumorchid: [
                    186,
                    85,
                    211,
                    1
                ],
                mediumpurple: [
                    147,
                    112,
                    219,
                    1
                ],
                mediumseagreen: [
                    60,
                    179,
                    113,
                    1
                ],
                mediumslateblue: [
                    123,
                    104,
                    238,
                    1
                ],
                mediumspringgreen: [
                    0,
                    250,
                    154,
                    1
                ],
                mediumturquoise: [
                    72,
                    209,
                    204,
                    1
                ],
                mediumvioletred: [
                    199,
                    21,
                    133,
                    1
                ],
                midnightblue: [
                    25,
                    25,
                    112,
                    1
                ],
                mintcream: [
                    245,
                    255,
                    250,
                    1
                ],
                mistyrose: [
                    255,
                    228,
                    225,
                    1
                ],
                moccasin: [
                    255,
                    228,
                    181,
                    1
                ],
                navajowhite: [
                    255,
                    222,
                    173,
                    1
                ],
                navy: [
                    0,
                    0,
                    128,
                    1
                ],
                oldlace: [
                    253,
                    245,
                    230,
                    1
                ],
                olive: [
                    128,
                    128,
                    0,
                    1
                ],
                olivedrab: [
                    107,
                    142,
                    35,
                    1
                ],
                orange: [
                    255,
                    165,
                    0,
                    1
                ],
                orangered: [
                    255,
                    69,
                    0,
                    1
                ],
                orchid: [
                    218,
                    112,
                    214,
                    1
                ],
                palegoldenrod: [
                    238,
                    232,
                    170,
                    1
                ],
                palegreen: [
                    152,
                    251,
                    152,
                    1
                ],
                paleturquoise: [
                    175,
                    238,
                    238,
                    1
                ],
                palevioletred: [
                    219,
                    112,
                    147,
                    1
                ],
                papayawhip: [
                    255,
                    239,
                    213,
                    1
                ],
                peachpuff: [
                    255,
                    218,
                    185,
                    1
                ],
                peru: [
                    205,
                    133,
                    63,
                    1
                ],
                pink: [
                    255,
                    192,
                    203,
                    1
                ],
                plum: [
                    221,
                    160,
                    221,
                    1
                ],
                powderblue: [
                    176,
                    224,
                    230,
                    1
                ],
                purple: [
                    128,
                    0,
                    128,
                    1
                ],
                rebeccapurple: [
                    102,
                    51,
                    153,
                    1
                ],
                red: [
                    255,
                    0,
                    0,
                    1
                ],
                rosybrown: [
                    188,
                    143,
                    143,
                    1
                ],
                royalblue: [
                    65,
                    105,
                    225,
                    1
                ],
                saddlebrown: [
                    139,
                    69,
                    19,
                    1
                ],
                salmon: [
                    250,
                    128,
                    114,
                    1
                ],
                sandybrown: [
                    244,
                    164,
                    96,
                    1
                ],
                seagreen: [
                    46,
                    139,
                    87,
                    1
                ],
                seashell: [
                    255,
                    245,
                    238,
                    1
                ],
                sienna: [
                    160,
                    82,
                    45,
                    1
                ],
                silver: [
                    192,
                    192,
                    192,
                    1
                ],
                skyblue: [
                    135,
                    206,
                    235,
                    1
                ],
                slateblue: [
                    106,
                    90,
                    205,
                    1
                ],
                slategray: [
                    112,
                    128,
                    144,
                    1
                ],
                slategrey: [
                    112,
                    128,
                    144,
                    1
                ],
                snow: [
                    255,
                    250,
                    250,
                    1
                ],
                springgreen: [
                    0,
                    255,
                    127,
                    1
                ],
                steelblue: [
                    70,
                    130,
                    180,
                    1
                ],
                tan: [
                    210,
                    180,
                    140,
                    1
                ],
                teal: [
                    0,
                    128,
                    128,
                    1
                ],
                thistle: [
                    216,
                    191,
                    216,
                    1
                ],
                tomato: [
                    255,
                    99,
                    71,
                    1
                ],
                turquoise: [
                    64,
                    224,
                    208,
                    1
                ],
                violet: [
                    238,
                    130,
                    238,
                    1
                ],
                wheat: [
                    245,
                    222,
                    179,
                    1
                ],
                white: [
                    255,
                    255,
                    255,
                    1
                ],
                whitesmoke: [
                    245,
                    245,
                    245,
                    1
                ],
                yellow: [
                    255,
                    255,
                    0,
                    1
                ],
                yellowgreen: [
                    154,
                    205,
                    50,
                    1
                ]
            };
            function t1(e1) {
                return (e1 = Math.round(e1)) < 0 ? 0 : e1 > 255 ? 255 : e1;
            }
            function i(e1) {
                return t1("%" === e1[e1.length - 1] ? parseFloat(e1) / 100 * 255 : parseInt(e1));
            }
            function n(e1) {
                var t1;
                return (t1 = "%" === e1[e1.length - 1] ? parseFloat(e1) / 100 : parseFloat(e1)) < 0 ? 0 : t1 > 1 ? 1 : t1;
            }
            function r(e1, t1, i) {
                return i < 0 ? i += 1 : i > 1 && (i -= 1), 6 * i < 1 ? e1 + (t1 - e1) * i * 6 : 2 * i < 1 ? t1 : 3 * i < 2 ? e1 + (t1 - e1) * (2 / 3 - i) * 6 : e1;
            }
            try {
                cn.parseCSSColor = function(o) {
                    var a, s = o.replace(/ /g, "").toLowerCase();
                    if (s in e1) return e1[s].slice();
                    if ("#" === s[0]) return 4 === s.length ? (a = parseInt(s.substr(1), 16)) >= 0 && a <= 4095 ? [
                        (3840 & a) >> 4 | (3840 & a) >> 8,
                        240 & a | (240 & a) >> 4,
                        15 & a | (15 & a) << 4,
                        1
                    ] : null : 7 === s.length && (a = parseInt(s.substr(1), 16)) >= 0 && a <= 16777215 ? [
                        (16711680 & a) >> 16,
                        (65280 & a) >> 8,
                        255 & a,
                        1
                    ] : null;
                    var l = s.indexOf("("), c = s.indexOf(")");
                    if (-1 !== l && c + 1 === s.length) {
                        var u = s.substr(0, l), h = s.substr(l + 1, c - (l + 1)).split(","), d = 1;
                        switch(u){
                            case "rgba":
                                if (4 !== h.length) return null;
                                d = n(h.pop());
                            case "rgb":
                                return 3 !== h.length ? null : [
                                    i(h[0]),
                                    i(h[1]),
                                    i(h[2]),
                                    d
                                ];
                            case "hsla":
                                if (4 !== h.length) return null;
                                d = n(h.pop());
                            case "hsl":
                                if (3 !== h.length) return null;
                                var f = (parseFloat(h[0]) % 360 + 360) % 360 / 360, p = n(h[1]), _ = n(h[2]), m = _ <= .5 ? _ * (p + 1) : _ + p - _ * p, g = 2 * _ - m;
                                return [
                                    t1(255 * r(g, m, f + 1 / 3)),
                                    t1(255 * r(g, m, f)),
                                    t1(255 * r(g, m, f - 1 / 3)),
                                    d
                                ];
                            default:
                                return null;
                        }
                    }
                    return null;
                };
            } catch (e1) {}
            return cn;
        }();
        function hn(e1, t1, i) {
            return e1 * (1 - i) + t1 * i;
        }
        const dn = new Map;
        class fn {
            constructor(e1, t1, i, n = 1){
                this.r = e1, this.g = t1, this.b = i, this.a = n;
            }
            static parse(e1) {
                if (!e1) return;
                if (e1 instanceof fn) return e1;
                if ("string" != typeof e1) return;
                const t1 = dn.get(e1);
                if (t1) return t1;
                const i = un.parseCSSColor(e1);
                if (!i) return;
                const n = new fn(i[0] / 255, i[1] / 255, i[2] / 255, i[3]);
                return dn.set(e1, n), n;
            }
            toString() {
                const { r: e1, g: t1, b: i, a: n } = this;
                return `rgba(${Math.round(255 * e1)},${Math.round(255 * t1)},${Math.round(255 * i)},${n})`;
            }
            toNonPremultipliedRenderColor(e1) {
                const { r: t1, g: i, b: n, a: r } = this;
                return new _n(e1, t1, i, n, r);
            }
            toPremultipliedRenderColor(e1) {
                const { r: t1, g: i, b: n, a: r } = this;
                return new mn(e1, t1 * r, i * r, n * r, r);
            }
            clone() {
                return new fn(this.r, this.g, this.b, this.a);
            }
        }
        class pn {
            constructor(e1, t1, i, n, r, o = !1){
                if (this.premultiplied = !1, this.premultiplied = o, e1) {
                    const o = e1.image.height, a = o * o;
                    this.premultiplied ? (t1 = 0 === r ? 0 : t1 / r * (o - 1), i = 0 === r ? 0 : i / r * (o - 1), n = 0 === r ? 0 : n / r * (o - 1)) : (t1 *= o - 1, i *= o - 1, n *= o - 1), t1 = Math.max(0, Math.min(o - 1, t1)), i = Math.max(0, Math.min(o - 1, i)), n = Math.max(0, Math.min(o - 1, n));
                    const s = Math.floor(t1), l = Math.floor(i), c = Math.floor(n), u = Math.ceil(t1), h = Math.ceil(i), d = Math.ceil(n), f = t1 - s, p = i - l, _ = n - c, m = e1.image.data, g = 4 * (s + l * a + c * o), y = 4 * (s + l * a + d * o), x = 4 * (s + h * a + c * o), v = 4 * (s + h * a + d * o), b = 4 * (u + l * a + c * o), w = 4 * (u + l * a + d * o), A = 4 * (u + h * a + c * o), E = 4 * (u + h * a + d * o);
                    this.r = hn(hn(hn(m[g], m[y], _), hn(m[x], m[v], _), p), hn(hn(m[b], m[w], _), hn(m[A], m[E], _), p), f) / 255 * (this.premultiplied ? r : 1), this.g = hn(hn(hn(m[g + 1], m[y + 1], _), hn(m[x + 1], m[v + 1], _), p), hn(hn(m[b + 1], m[w + 1], _), hn(m[A + 1], m[E + 1], _), p), f) / 255 * (this.premultiplied ? r : 1), this.b = hn(hn(hn(m[g + 2], m[y + 2], _), hn(m[x + 2], m[v + 2], _), p), hn(hn(m[b + 2], m[w + 2], _), hn(m[A + 2], m[E + 2], _), p), f) / 255 * (this.premultiplied ? r : 1), this.a = r;
                } else this.r = t1, this.g = i, this.b = n, this.a = r;
            }
            toArray() {
                const { r: e1, g: t1, b: i, a: n } = this;
                return [
                    255 * e1,
                    255 * t1,
                    255 * i,
                    n
                ];
            }
            toHslaArray() {
                let { r: e1, g: t1, b: i, a: n } = this;
                if (this.premultiplied) {
                    if (0 === n) return [
                        0,
                        0,
                        0,
                        0
                    ];
                    const r = 1 / n;
                    e1 *= r, t1 *= r, i *= r;
                }
                const r = Math.min(Math.max(e1, 0), 1), o = Math.min(Math.max(t1, 0), 1), a = Math.min(Math.max(i, 0), 1), s = Math.min(r, o, a), l = Math.max(r, o, a), c = l - s, u = .5 * (s + l);
                if (0 === c) return [
                    0,
                    0,
                    100 * u,
                    n
                ];
                const h = u > .5 ? c / (2 - l - s) : c / (l + s);
                let d;
                switch(l){
                    case r:
                        d = 60 * ((o - a) / c + (o < a ? 6 : 0));
                        break;
                    case o:
                        d = 60 * ((a - r) / c + 2);
                        break;
                    default:
                        d = 60 * ((r - o) / c + 4);
                }
                return [
                    d,
                    100 * h,
                    100 * u,
                    n
                ];
            }
            toArray01() {
                const { r: e1, g: t1, b: i, a: n } = this;
                return [
                    e1,
                    t1,
                    i,
                    n
                ];
            }
            toArray01Scaled(e1) {
                const { r: t1, g: i, b: n } = this;
                return [
                    t1 * e1,
                    i * e1,
                    n * e1
                ];
            }
            toArray01Linear() {
                const { r: e1, g: t1, b: i, a: n } = this;
                return [
                    Math.pow(e1, 2.2),
                    Math.pow(t1, 2.2),
                    Math.pow(i, 2.2),
                    n
                ];
            }
        }
        class _n extends pn {
            constructor(e1, t1, i, n, r){
                super(e1, t1, i, n, r, !1);
            }
        }
        class mn extends pn {
            constructor(e1, t1, i, n, r){
                super(e1, t1, i, n, r, !0);
            }
        }
        function gn(e1, t1, i) {
            return e1.map((e1, n)=>hn(e1, t1[n], i));
        }
        fn.black = new fn(0, 0, 0, 1), fn.white = new fn(1, 1, 1, 1), fn.transparent = new fn(0, 0, 0, 0), fn.red = new fn(1, 0, 0, 1), fn.blue = new fn(0, 0, 1, 1);
        var yn = Object.freeze({
            __proto__: null,
            array: gn,
            color: function(e1, t1, i) {
                return new fn(hn(e1.r, t1.r, i), hn(e1.g, t1.g, i), hn(e1.b, t1.b, i), hn(e1.a, t1.a, i));
            },
            number: hn
        });
        class xn extends Error {
            constructor(e1, t1){
                super(t1), this.message = t1, this.key = e1;
            }
        }
        class vn {
            constructor(e1, t1 = []){
                this.parent = e1, this.bindings = Object.create(null);
                for (const [e1, i] of t1)this.bindings[e1] = i;
            }
            concat(e1) {
                return new vn(this, e1);
            }
            get(e1) {
                if (this.bindings[e1]) return this.bindings[e1];
                if (this.parent) return this.parent.get(e1);
                throw new Error(`${e1} not found in scope.`);
            }
            has(e1) {
                return !!this.bindings[e1] || !!this.parent && this.parent.has(e1);
            }
        }
        const bn = {
            kind: "null"
        }, wn = {
            kind: "number"
        }, An = {
            kind: "string"
        }, En = {
            kind: "boolean"
        }, In = {
            kind: "color"
        }, Mn = {
            kind: "object"
        }, Sn = {
            kind: "value"
        }, Tn = {
            kind: "collator"
        }, zn = {
            kind: "formatted"
        }, Rn = {
            kind: "resolvedImage"
        };
        function Pn(e1, t1) {
            return {
                kind: "array",
                itemType: e1,
                N: t1
            };
        }
        function Dn(e1) {
            if ("array" === e1.kind) {
                const t1 = Dn(e1.itemType);
                return "number" == typeof e1.N ? `array<${t1}, ${e1.N}>` : "value" === e1.itemType.kind ? "array" : `array<${t1}>`;
            }
            return e1.kind;
        }
        function Fn(e1, t1) {
            return Cn(e1, t1) ? null : `Expected ${Dn(e1)} but found ${Dn(t1)} instead.`;
        }
        function Cn(e1, t1) {
            return "error" === t1.kind || ("array" === e1.kind ? "array" === t1.kind && (0 === t1.N && "value" === t1.itemType.kind || Cn(e1.itemType, t1.itemType)) && ("number" != typeof e1.N || e1.N === t1.N) : e1.kind === t1.kind || "value" === e1.kind && "collator" !== t1.kind);
        }
        function On(e1, t1) {
            return t1.some((t1)=>"null" === t1 ? null === e1 : "array" === t1 ? Array.isArray(e1) : "object" === t1 ? e1 && !Array.isArray(e1) && "object" == typeof e1 : t1 === typeof e1);
        }
        function Ln(e1, t1) {
            return "array" === e1.kind && "array" === t1.kind ? e1.N === t1.N && Ln(e1.itemType, t1.itemType) : e1.kind === t1.kind;
        }
        class Bn {
            constructor(e1, t1, i){
                this.sensitivity = e1 ? t1 ? "variant" : "case" : t1 ? "accent" : "base", this.locale = i, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                    sensitivity: this.sensitivity,
                    usage: "search"
                });
            }
            compare(e1, t1) {
                return this.collator.compare(e1, t1);
            }
            resolvedLocale() {
                return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
            }
        }
        class Vn {
            constructor(e1, t1, i, n, r){
                this.text = e1.normalize ? e1.normalize() : e1, this.image = t1, this.scale = i, this.fontStack = n, this.textColor = r;
            }
        }
        class Nn {
            constructor(e1){
                this.sections = e1;
            }
            static fromString(e1) {
                return new Nn([
                    new Vn(e1, null, null, null, null)
                ]);
            }
            isEmpty() {
                return 0 === this.sections.length || !this.sections.some((e1)=>0 !== e1.text.length || !!e1.image && e1.image.hasPrimary());
            }
            static factory(e1) {
                return e1 instanceof Nn ? e1 : Nn.fromString(e1);
            }
            toString() {
                return 0 === this.sections.length ? "" : this.sections.map((e1)=>e1.text).join("");
            }
            serialize() {
                const e1 = [
                    "format"
                ];
                for (const t1 of this.sections){
                    if (t1.image) {
                        const i = t1.image.getPrimary().id.toString();
                        e1.push([
                            "image",
                            i
                        ]);
                        continue;
                    }
                    e1.push(t1.text);
                    const i = {};
                    t1.fontStack && (i["text-font"] = [
                        "literal",
                        t1.fontStack.split(",")
                    ]), t1.scale && (i["font-scale"] = t1.scale), t1.textColor && (i["text-color"] = [
                        "rgba"
                    ].concat(t1.textColor.toNonPremultipliedRenderColor(null).toArray())), e1.push(i);
                }
                return e1;
            }
        }
        class kn {
            constructor(e1, t1 = {}){
                this.id = sn.from(e1), this.params = t1.params, this.sx = t1.sx || 1, this.sy = t1.sy || 1;
            }
            toString() {
                return JSON.stringify(this);
            }
            static parse(e1) {
                let t1, i, n, r;
                try {
                    ({ id: t1, params: i, sx: n, sy: r } = JSON.parse(e1) || {});
                } catch (e1) {
                    return null;
                }
                return t1 ? new kn(t1, {
                    params: i,
                    sx: n,
                    sy: r
                }) : null;
            }
            scaleSelf(e1, t1 = e1) {
                return this.sx *= e1, this.sy *= t1, this;
            }
        }
        class Un {
            constructor(e1, t1, i, n, r = !1){
                this.primaryId = sn.from(e1), this.primaryOptions = t1, i && (this.secondaryId = sn.from(i)), this.secondaryOptions = n, this.available = r;
            }
            toString() {
                return this.primaryId && this.secondaryId ? `[${this.primaryId.name},${this.secondaryId.name}]` : this.primaryId.name;
            }
            hasPrimary() {
                return !!this.primaryId;
            }
            getPrimary() {
                return new kn(this.primaryId, this.primaryOptions);
            }
            hasSecondary() {
                return !!this.secondaryId;
            }
            getSecondary() {
                return this.secondaryId ? new kn(this.secondaryId, this.secondaryOptions) : null;
            }
            static from(e1) {
                return "string" != typeof e1 ? e1 : Un.build({
                    name: e1
                });
            }
            static build(e1, t1, i, n) {
                return !e1 || "object" == typeof e1 && !("name" in e1) ? null : new Un(e1, i, t1, n);
            }
        }
        function jn(e1, t1, i, n) {
            return "number" == typeof e1 && e1 >= 0 && e1 <= 255 && "number" == typeof t1 && t1 >= 0 && t1 <= 255 && "number" == typeof i && i >= 0 && i <= 255 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : `Invalid rgba value [${[
                e1,
                t1,
                i,
                n
            ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof n ? [
                e1,
                t1,
                i,
                n
            ] : [
                e1,
                t1,
                i
            ]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
        }
        function Gn(e1) {
            if (null === e1) return !0;
            if ("string" == typeof e1) return !0;
            if ("boolean" == typeof e1) return !0;
            if ("number" == typeof e1) return !0;
            if (e1 instanceof fn) return !0;
            if (e1 instanceof Bn) return !0;
            if (e1 instanceof Nn) return !0;
            if (e1 instanceof Un) return !0;
            if (Array.isArray(e1)) {
                for (const t1 of e1)if (!Gn(t1)) return !1;
                return !0;
            }
            if ("object" == typeof e1) {
                for(const t1 in e1)if (!Gn(e1[t1])) return !1;
                return !0;
            }
            return !1;
        }
        function Hn(e1) {
            if (null === e1) return bn;
            if ("string" == typeof e1) return An;
            if ("boolean" == typeof e1) return En;
            if ("number" == typeof e1) return wn;
            if (e1 instanceof fn) return In;
            if (e1 instanceof Bn) return Tn;
            if (e1 instanceof Nn) return zn;
            if (e1 instanceof Un) return Rn;
            if (Array.isArray(e1)) {
                const t1 = e1.length;
                let i;
                for (const t1 of e1){
                    const e1 = Hn(t1);
                    if (i) {
                        if (i === e1) continue;
                        i = Sn;
                        break;
                    }
                    i = e1;
                }
                return Pn(i || Sn, t1);
            }
            return Mn;
        }
        function $n(e1) {
            return null === e1 ? "" : "string" == typeof e1 || "number" == typeof e1 || "boolean" == typeof e1 ? String(e1) : e1 instanceof Nn || e1 instanceof Un || e1 instanceof fn ? e1.toString() : JSON.stringify(e1);
        }
        class Zn {
            constructor(e1, t1){
                this.type = e1, this.value = t1;
            }
            static parse(e1, t1) {
                if (2 !== e1.length) return t1.error(`'literal' expression requires exactly one argument, but found ${e1.length - 1} instead.`);
                if (!Gn(e1[1])) return t1.error("invalid value");
                const i = e1[1];
                let n = Hn(i);
                const r = t1.expectedType;
                return "array" !== n.kind || 0 !== n.N || !r || "array" !== r.kind || "number" == typeof r.N && 0 !== r.N || (n = r), new Zn(n, i);
            }
            evaluate() {
                return this.value;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return "array" === this.type.kind || "object" === this.type.kind ? [
                    "literal",
                    this.value
                ] : this.value instanceof fn ? [
                    "rgba"
                ].concat(this.value.toNonPremultipliedRenderColor(null).toArray()) : this.value instanceof Nn ? this.value.serialize() : this.value;
            }
        }
        class Wn {
            constructor(e1){
                this.name = "ExpressionEvaluationError", this.message = e1;
            }
            toJSON() {
                return this.message;
            }
        }
        const qn = {
            string: An,
            number: wn,
            boolean: En,
            object: Mn
        };
        class Xn {
            constructor(e1, t1){
                this.type = e1, this.args = t1;
            }
            static parse(e1, t1) {
                if (e1.length < 2) return t1.error("Expected at least one argument.");
                let i, n = 1;
                const r = e1[0];
                if ("array" === r) {
                    let r, o;
                    if (e1.length > 2) {
                        const i = e1[1];
                        if ("string" != typeof i || !(i in qn) || "object" === i) return t1.error('The item type argument of "array" must be one of string, number, boolean', 1);
                        r = qn[i], n++;
                    } else r = Sn;
                    if (e1.length > 3) {
                        if (null !== e1[2] && ("number" != typeof e1[2] || e1[2] < 0 || e1[2] !== Math.floor(e1[2]))) return t1.error('The length argument to "array" must be a positive integer literal', 2);
                        o = e1[2], n++;
                    }
                    i = Pn(r, o);
                } else i = qn[r];
                const o = [];
                for(; n < e1.length; n++){
                    const i = t1.parse(e1[n], n, Sn);
                    if (!i) return null;
                    o.push(i);
                }
                return new Xn(i, o);
            }
            evaluate(e1) {
                for(let t1 = 0; t1 < this.args.length; t1++){
                    const i = this.args[t1].evaluate(e1);
                    if (!Fn(this.type, Hn(i))) return i;
                    if (t1 === this.args.length - 1) throw new Wn(`The expression ${JSON.stringify(this.args[t1].serialize())} evaluated to ${Dn(Hn(i))} but was expected to be of type ${Dn(this.type)}.`);
                }
                return null;
            }
            eachChild(e1) {
                this.args.forEach(e1);
            }
            outputDefined() {
                return this.args.every((e1)=>e1.outputDefined());
            }
            serialize() {
                const e1 = this.type, t1 = [
                    e1.kind
                ];
                if ("array" === e1.kind) {
                    const i = e1.itemType;
                    if ("string" === i.kind || "number" === i.kind || "boolean" === i.kind) {
                        t1.push(i.kind);
                        const n = e1.N;
                        ("number" == typeof n || this.args.length > 1) && t1.push(n);
                    }
                }
                return t1.concat(this.args.map((e1)=>e1.serialize()));
            }
        }
        class Yn {
            constructor(e1){
                this.type = zn, this.sections = e1;
            }
            static parse(e1, t1) {
                if (e1.length < 2) return t1.error("Expected at least one argument.");
                const i = e1[1];
                if (!Array.isArray(i) && "object" == typeof i) return t1.error("First argument must be an image or text section.");
                const n = [];
                let r = !1;
                for(let i = 1; i <= e1.length - 1; ++i){
                    const o = e1[i];
                    if (r && "object" == typeof o && !Array.isArray(o)) {
                        r = !1;
                        let e1 = null;
                        if (o["font-scale"] && (e1 = t1.parseObjectValue(o["font-scale"], i, "font-scale", wn), !e1)) return null;
                        let a = null;
                        if (o["text-font"] && (a = t1.parseObjectValue(o["text-font"], i, "text-font", Pn(An)), !a)) return null;
                        let s = null;
                        if (o["text-color"] && (s = t1.parseObjectValue(o["text-color"], i, "text-color", In), !s)) return null;
                        const l = n.at(-1);
                        l.scale = e1, l.font = a, l.textColor = s;
                    } else {
                        const o = t1.parse(e1[i], i, Sn);
                        if (!o) return null;
                        const a = o.type.kind;
                        if ("string" !== a && "value" !== a && "null" !== a && "resolvedImage" !== a) return t1.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                        r = !0, n.push({
                            content: o,
                            scale: null,
                            font: null,
                            textColor: null
                        });
                    }
                }
                return new Yn(n);
            }
            evaluate(e1) {
                return new Nn(this.sections.map((t1)=>{
                    const i = t1.content.evaluate(e1);
                    return Ln(Hn(i), Rn) ? new Vn("", i, null, null, null) : new Vn($n(i), null, t1.scale ? t1.scale.evaluate(e1) : null, t1.font ? t1.font.evaluate(e1).join(",") : null, t1.textColor ? t1.textColor.evaluate(e1) : null);
                }));
            }
            eachChild(e1) {
                for (const t1 of this.sections)e1(t1.content), t1.scale && e1(t1.scale), t1.font && e1(t1.font), t1.textColor && e1(t1.textColor);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const e1 = [
                    "format"
                ];
                for (const t1 of this.sections){
                    e1.push(t1.content.serialize());
                    const i = {};
                    t1.scale && (i["font-scale"] = t1.scale.serialize()), t1.font && (i["text-font"] = t1.font.serialize()), t1.textColor && (i["text-color"] = t1.textColor.serialize()), e1.push(i);
                }
                return e1;
            }
        }
        class Jn {
            constructor(e1, t1, i, n){
                this._imageWarnHistory = {}, this.type = Rn, this.namePrimary = e1, this.nameSecondary = t1, i && (this.paramsPrimary = i.params, this.iconsetIdPrimary = i.iconset ? i.iconset.id : void 0), n && (this.paramsSecondary = n.params, this.iconsetIdSecondary = n.iconset ? n.iconset.id : void 0);
            }
            static parse(e1, t1) {
                if (e1.length < 2) return t1.error("Expected two or more arguments.");
                let i = 1;
                const n = [];
                function r() {
                    if (i < e1.length) {
                        const r = t1.parse(e1[i], i++, An);
                        return r ? (n.push({
                            image: r,
                            options: {}
                        }), !0) : (t1.error(n.length ? "Secondary image variant is not a string." : "No image name provided."), !1);
                    }
                    return !0;
                }
                function o() {
                    if (i < e1.length) {
                        const o = e1[i];
                        if (null === (r = o) || "object" != typeof r || Array.isArray(r)) return !0;
                        const a = o.params, s = o.iconset, l = t1.concat(i);
                        if (!a && !s) return i++, !0;
                        if (a) {
                            if ("object" != typeof a || a.constructor !== Object) return l.error('Image options "params" should be an object'), !1;
                            const e1 = {}, t1 = l.concat(void 0, "params");
                            for(const i in a){
                                if (!i) return t1.error("Image parameter name should be non-empty"), !1;
                                const n = t1.concat(void 0, i).parse(a[i], void 0, In, void 0, {
                                    typeAnnotation: "coerce"
                                });
                                if (!n) return !1;
                                e1[i] = n;
                            }
                            n.at(-1).options.params = e1;
                        }
                        if (s) {
                            if ("object" != typeof s || s.constructor !== Object) return l.error('Image options "iconset" should be an object'), !1;
                            if (!s.id) return l.error('Image options "iconset" should have an "id" property'), !1;
                            n.at(-1).options.iconset = s;
                        }
                        return i++, !0;
                    }
                    var r;
                    return !0;
                }
                for(let e1 = 0; e1 < 2; e1++)if (!r() || !o()) return;
                return new Jn(n[0].image, n[1] ? n[1].image : void 0, n[0].options, n[1] ? n[1].options : void 0);
            }
            evaluateParams(e1, t1) {
                const i = {};
                if (t1) {
                    for(const n in t1)if (t1[n]) try {
                        i[n] = t1[n].evaluate(e1);
                    } catch (e1) {
                        continue;
                    }
                    if (0 !== Object.keys(i).length) return {
                        params: i
                    };
                }
            }
            evaluate(e1) {
                const t1 = {
                    name: this.namePrimary.evaluate(e1),
                    iconsetId: this.iconsetIdPrimary
                }, i = this.nameSecondary ? {
                    name: this.nameSecondary.evaluate(e1),
                    iconsetId: this.iconsetIdSecondary
                } : void 0, n = Un.build(t1, i, this.paramsPrimary ? this.evaluateParams(e1, this.paramsPrimary) : void 0, this.paramsSecondary ? this.evaluateParams(e1, this.paramsSecondary) : void 0);
                if (n && e1.availableImages) {
                    const t1 = n.getPrimary().id;
                    if (n.available = e1.availableImages.some((e1)=>sn.isEqual(e1, t1)), n.available) {
                        const t1 = n.getSecondary() ? n.getSecondary().id : null;
                        t1 && (n.available = e1.availableImages.some((e1)=>sn.isEqual(e1, t1)));
                    }
                }
                return n;
            }
            eachChild(e1) {
                if (e1(this.namePrimary), this.paramsPrimary) for(const t1 in this.paramsPrimary)this.paramsPrimary[t1] && e1(this.paramsPrimary[t1]);
                if (this.nameSecondary && (e1(this.nameSecondary), this.paramsSecondary)) for(const t1 in this.paramsSecondary)this.paramsSecondary[t1] && e1(this.paramsSecondary[t1]);
            }
            outputDefined() {
                return !1;
            }
            serializeOptions(e1, t1) {
                const i = {};
                if (t1 && (i.iconset = {
                    id: t1
                }), e1) {
                    i.params = {};
                    for(const t1 in e1)e1[t1] && (i.params[t1] = e1[t1].serialize());
                }
                return Object.keys(i).length > 0 ? i : void 0;
            }
            serialize() {
                const e1 = [
                    "image",
                    this.namePrimary.serialize()
                ];
                if (this.paramsPrimary || this.iconsetIdPrimary) {
                    const t1 = this.serializeOptions(this.paramsPrimary, this.iconsetIdPrimary);
                    t1 && e1.push(t1);
                }
                if (this.nameSecondary && (e1.push(this.nameSecondary.serialize()), this.paramsSecondary || this.iconsetIdSecondary)) {
                    const t1 = this.serializeOptions(this.paramsSecondary, this.iconsetIdSecondary);
                    t1 && e1.push(t1);
                }
                return e1;
            }
        }
        function Kn(e1) {
            return er(e1) ? "string" : tr(e1) ? "number" : ir(e1) ? "boolean" : Array.isArray(e1) ? "array" : null === e1 ? "null" : Qn(e1) ? "object" : typeof e1;
        }
        function Qn(e1) {
            return null != e1 && !Array.isArray(e1) && "function" != typeof e1 && !(e1 instanceof String || e1 instanceof Number || e1 instanceof Boolean) && "object" == typeof e1;
        }
        function er(e1) {
            return "string" == typeof e1 || e1 instanceof String;
        }
        function tr(e1) {
            return "number" == typeof e1 || e1 instanceof Number;
        }
        function ir(e1) {
            return "boolean" == typeof e1 || e1 instanceof Boolean;
        }
        const nr = {
            "to-boolean": En,
            "to-color": In,
            "to-number": wn,
            "to-string": An
        };
        class rr {
            constructor(e1, t1){
                this.type = e1, this.args = t1;
            }
            static parse(e1, t1) {
                if (e1.length < 2) return t1.error("Expected at least one argument.");
                const i = e1[0], n = [];
                let r = bn;
                if ("to-array" === i) {
                    if (!Array.isArray(e1[1])) return null;
                    const i = e1[1].length;
                    if (t1.expectedType) {
                        if ("array" !== t1.expectedType.kind) return t1.error(`Expected ${t1.expectedType.kind} but found array.`);
                        r = Pn(t1.expectedType.itemType, i);
                    } else {
                        if (!(i > 0 && Gn(e1[1][0]))) return null;
                        r = Pn(Hn(e1[1][0]), i);
                    }
                    for(let o = 0; o < i; o++){
                        const i = e1[1][o];
                        let a;
                        if (Array.isArray(i)) a = t1.parse(i, void 0, r.itemType);
                        else {
                            const e1 = Kn(i);
                            if (e1 !== r.itemType.kind) return t1.error(`Expected ${r.itemType.kind} but found ${e1}.`);
                            a = t1.registry.literal.parse([
                                "literal",
                                void 0 === i ? null : i
                            ], t1);
                        }
                        if (!a) return null;
                        n.push(a);
                    }
                } else {
                    if (("to-boolean" === i || "to-string" === i) && 2 !== e1.length) return t1.error("Expected one argument.");
                    r = nr[i];
                    for(let i = 1; i < e1.length; i++){
                        const r = t1.parse(e1[i], i, Sn);
                        if (!r) return null;
                        n.push(r);
                    }
                }
                return new rr(r, n);
            }
            evaluate(e1) {
                if ("boolean" === this.type.kind) return Boolean(this.args[0].evaluate(e1));
                if ("color" === this.type.kind) {
                    let t1, i;
                    for (const n of this.args){
                        if (t1 = n.evaluate(e1), i = null, t1 instanceof fn) return t1;
                        if ("string" == typeof t1) {
                            const i = e1.parseColor(t1);
                            if (i) return i;
                        } else if (Array.isArray(t1) && (i = t1.length < 3 || t1.length > 4 ? `Invalid rbga value ${JSON.stringify(t1)}: expected an array containing either three or four numeric values.` : jn(t1[0], t1[1], t1[2], t1[3]), !i)) return new fn(t1[0] / 255, t1[1] / 255, t1[2] / 255, t1[3]);
                    }
                    throw new Wn(i || `Could not parse color from value '${"string" == typeof t1 ? t1 : String(JSON.stringify(t1))}'`);
                }
                if ("number" === this.type.kind) {
                    let t1 = null;
                    for (const i of this.args){
                        if (t1 = i.evaluate(e1), null === t1) return 0;
                        const n = Number(t1);
                        if (!isNaN(n)) return n;
                    }
                    throw new Wn(`Could not convert ${JSON.stringify(t1)} to number.`);
                }
                return "formatted" === this.type.kind ? Nn.fromString($n(this.args[0].evaluate(e1))) : "resolvedImage" === this.type.kind ? Un.build($n(this.args[0].evaluate(e1))) : "array" === this.type.kind ? this.args.map((t1)=>t1.evaluate(e1)) : $n(this.args[0].evaluate(e1));
            }
            eachChild(e1) {
                this.args.forEach(e1);
            }
            outputDefined() {
                return this.args.every((e1)=>e1.outputDefined());
            }
            serialize() {
                if ("formatted" === this.type.kind) return new Yn([
                    {
                        content: this.args[0],
                        scale: null,
                        font: null,
                        textColor: null
                    }
                ]).serialize();
                if ("resolvedImage" === this.type.kind) return new Jn(this.args[0]).serialize();
                const e1 = "array" === this.type.kind ? [] : [
                    `to-${this.type.kind}`
                ];
                return this.eachChild((t1)=>{
                    e1.push(t1.serialize());
                }), e1;
            }
        }
        const or = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ];
        class ar {
            constructor(e1, t1, i){
                this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this.availableImages = null, this.canonical = null, this.featureTileCoord = null, this.featureDistanceData = null, this.scope = e1, this.options = t1, this.iconImageUseTheme = i;
            }
            id() {
                return this.feature && void 0 !== this.feature.id ? this.feature.id : null;
            }
            geometryType() {
                return this.feature ? "number" == typeof this.feature.type ? or[this.feature.type] : this.feature.type : null;
            }
            geometry() {
                return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
            }
            canonicalID() {
                return this.canonical;
            }
            properties() {
                return this.feature && this.feature.properties || {};
            }
            measureLight(e1) {
                return this.globals.brightness || 0;
            }
            distanceFromCenter() {
                if (this.featureTileCoord && this.featureDistanceData) {
                    const e1 = this.featureDistanceData.center, t1 = this.featureDistanceData.scale, { x: i, y: n } = this.featureTileCoord;
                    return this.featureDistanceData.bearing[0] * (i * t1 - e1[0]) + this.featureDistanceData.bearing[1] * (n * t1 - e1[1]);
                }
                return 0;
            }
            parseColor(e1) {
                return fn.parse(e1);
            }
            getConfig(e1) {
                return this.options ? this.options.get(e1) : null;
            }
        }
        class sr {
            constructor(e1, t1, i, n, r){
                this.name = e1, this.type = t1, this._evaluate = i, this.args = n, this._overloadIndex = r;
            }
            evaluate(e1) {
                if (!this._evaluate) {
                    const e1 = sr.definitions[this.name];
                    this._evaluate = Array.isArray(e1) ? e1[2] : e1.overloads[this._overloadIndex][1];
                }
                return this._evaluate(e1, this.args);
            }
            eachChild(e1) {
                this.args.forEach(e1);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    this.name
                ].concat(this.args.map((e1)=>e1.serialize()));
            }
            static parse(e1, t1) {
                const i = e1[0], n = sr.definitions[i];
                if (!n) return t1.error(`Unknown expression "${i}". If you wanted a literal array, use ["literal", [...]].`, 0);
                const r = Array.isArray(n) ? n[0] : n.type, o = Array.isArray(n) ? [
                    [
                        n[1],
                        n[2]
                    ]
                ] : n.overloads, a = [];
                let s = null, l = -1;
                for (const [n, c] of o){
                    if (Array.isArray(n) && n.length !== e1.length - 1) continue;
                    a.push(n), l++, null === s ? s = t1._forkForSignature() : s.errors.length = 0;
                    const o = [];
                    let u = !1;
                    for(let t1 = 1; t1 < e1.length; t1++){
                        const i = e1[t1], r = Array.isArray(n) ? n[t1 - 1] : n.type, a = s.parse(i, 1 + o.length, r);
                        if (!a) {
                            u = !0;
                            break;
                        }
                        o.push(a);
                    }
                    if (!u) {
                        if (Array.isArray(n) && n.length !== o.length) s.error(`Expected ${n.length} arguments, but found ${o.length} instead.`);
                        else {
                            for(let e1 = 0; e1 < o.length; e1++){
                                const t1 = Array.isArray(n) ? n[e1] : n.type;
                                s.checkSubtype(t1, o[e1].type, e1 + 1);
                            }
                            if (0 === s.errors.length) return new sr(i, r, c, o, l);
                        }
                    }
                }
                if (1 === a.length) t1.errors.push(...s.errors);
                else {
                    const i = (a.length ? a : o.map(([e1])=>e1)).map(lr).join(" | "), n = [];
                    for(let i = 1; i < e1.length; i++){
                        const r = t1.parse(e1[i], 1 + n.length);
                        if (!r) return null;
                        n.push(Dn(r.type));
                    }
                    t1.error(`Expected arguments of type ${i}, but found (${n.join(", ")}) instead.`);
                }
                return null;
            }
            static register(e1, t1) {
                sr.definitions = t1;
                for(const i in t1)e1[i] = sr;
            }
        }
        function lr(e1) {
            return Array.isArray(e1) ? `(${e1.map(Dn).join(", ")})` : `(${Dn(e1.type)}...)`;
        }
        class cr {
            constructor(e1, t1, i){
                this.type = Tn, this.locale = i, this.caseSensitive = e1, this.diacriticSensitive = t1;
            }
            static parse(e1, t1) {
                if (2 !== e1.length) return t1.error("Expected one argument."), null;
                const i = e1[1];
                if ("object" != typeof i || Array.isArray(i)) return t1.error("Collator options argument must be an object."), null;
                const n = void 0 === i["case-sensitive"] ? t1.parse(!1, 1, En) : t1.parseObjectValue(i["case-sensitive"], 1, "case-sensitive", En);
                if (!n) return null;
                const r = void 0 === i["diacritic-sensitive"] ? t1.parse(!1, 1, En) : t1.parseObjectValue(i["diacritic-sensitive"], 1, "diacritic-sensitive", En);
                if (!r) return null;
                let o = null;
                return i.locale && (o = t1.parseObjectValue(i.locale, 1, "locale", An), !o) ? null : new cr(n, r, o);
            }
            evaluate(e1) {
                return new Bn(this.caseSensitive.evaluate(e1), this.diacriticSensitive.evaluate(e1), this.locale ? this.locale.evaluate(e1) : null);
            }
            eachChild(e1) {
                e1(this.caseSensitive), e1(this.diacriticSensitive), this.locale && e1(this.locale);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const e1 = {};
                return e1["case-sensitive"] = this.caseSensitive.serialize(), e1["diacritic-sensitive"] = this.diacriticSensitive.serialize(), this.locale && (e1.locale = this.locale.serialize()), [
                    "collator",
                    e1
                ];
            }
        }
        function ur(e1) {
            return (180 + e1) / 360;
        }
        function hr(e1) {
            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + e1 * Math.PI / 360))) / 360;
        }
        function dr(e1) {
            return 360 * e1 - 180;
        }
        function fr(e1) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * e1) * Math.PI / 180)) - 90;
        }
        const pr = 8192;
        function _r(e1, t1) {
            const i = ur(e1[0]), n = hr(e1[1]), r = Math.pow(2, t1.z);
            return [
                Math.round(i * r * pr),
                Math.round(n * r * pr)
            ];
        }
        function mr(e1, t1) {
            for(let i = 0; i < t1.length; i++)if (Ge(e1, t1[i])) return !0;
            return !1;
        }
        function gr(e1, t1, i) {
            for (const n of i)for(let i = 0, r = n.length, o = r - 1; i < r; o = i++)if ($e(e1, t1, n[o], n[i])) return !0;
            return !1;
        }
        function yr(e1, t1) {
            for(let i = 0; i < e1.length; ++i)if (!Ge(e1[i], t1)) return !1;
            for(let i = 0; i < e1.length - 1; ++i)if (gr(e1[i], e1[i + 1], t1)) return !1;
            return !0;
        }
        function xr(e1, t1) {
            for(let i = 0; i < t1.length; i++)if (yr(e1, t1[i])) return !0;
            return !1;
        }
        function vr(e1, t1, i) {
            const n = [];
            for(let r = 0; r < e1.length; r++){
                const o = [];
                for(let n = 0; n < e1[r].length; n++){
                    const a = _r(e1[r][n], i);
                    Ne(t1, a), o.push(a);
                }
                n.push(o);
            }
            return n;
        }
        function br(e1, t1, i) {
            const n = [];
            for(let r = 0; r < e1.length; r++){
                const o = vr(e1[r], t1, i);
                n.push(o);
            }
            return n;
        }
        function wr(e1, t1, i, n) {
            if (e1[0] < i[0] || e1[0] > i[2]) {
                const t1 = .5 * n;
                let r = e1[0] - i[0] > t1 ? -n : i[0] - e1[0] > t1 ? n : 0;
                0 === r && (r = e1[0] - i[2] > t1 ? -n : i[2] - e1[0] > t1 ? n : 0), e1[0] += r;
            }
            Ne(t1, e1);
        }
        function Ar(e1, t1, i, n) {
            const r = Math.pow(2, n.z) * pr, o = [
                n.x * pr,
                n.y * pr
            ], a = [];
            if (!e1) return a;
            for (const n of e1)for (const e1 of n){
                const n = [
                    e1.x + o[0],
                    e1.y + o[1]
                ];
                wr(n, t1, i, r), a.push(n);
            }
            return a;
        }
        function Er(e1, t1, i, n) {
            const r = Math.pow(2, n.z) * pr, o = [
                n.x * pr,
                n.y * pr
            ], a = [];
            if (!e1) return a;
            for (const i of e1){
                const e1 = [];
                for (const n of i){
                    const i = [
                        n.x + o[0],
                        n.y + o[1]
                    ];
                    Ne(t1, i), e1.push(i);
                }
                a.push(e1);
            }
            if (t1[2] - t1[0] <= r / 2) {
                (s = t1)[0] = s[1] = 1 / 0, s[2] = s[3] = -1 / 0;
                for (const e1 of a)for (const n of e1)wr(n, t1, i, r);
            }
            var s;
            return a;
        }
        class Ir {
            constructor(e1, t1){
                this.type = En, this.geojson = e1, this.geometries = t1;
            }
            static parse(e1, t1) {
                if (2 !== e1.length) return t1.error(`'within' expression requires exactly one argument, but found ${e1.length - 1} instead.`);
                if (Gn(e1[1])) {
                    const t1 = e1[1];
                    if ("FeatureCollection" === t1.type) for(let e1 = 0; e1 < t1.features.length; ++e1){
                        const i = t1.features[e1].geometry.type;
                        if ("Polygon" === i || "MultiPolygon" === i) return new Ir(t1, t1.features[e1].geometry);
                    }
                    else if ("Feature" === t1.type) {
                        const e1 = t1.geometry.type;
                        if ("Polygon" === e1 || "MultiPolygon" === e1) return new Ir(t1, t1.geometry);
                    } else if ("Polygon" === t1.type || "MultiPolygon" === t1.type) return new Ir(t1, t1);
                }
                return t1.error("'within' expression requires valid geojson object that contains polygon geometry type.");
            }
            evaluate(e1) {
                if (null != e1.geometry() && null != e1.canonicalID()) {
                    if ("Point" === e1.geometryType()) return function(e1, t1) {
                        const i = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], r = e1.canonicalID();
                        if (!r) return !1;
                        if ("Polygon" === t1.type) {
                            const o = vr(t1.coordinates, n, r), a = Ar(e1.geometry(), i, n, r);
                            if (!ke(i, n)) return !1;
                            for (const e1 of a)if (!Ge(e1, o)) return !1;
                        }
                        if ("MultiPolygon" === t1.type) {
                            const o = br(t1.coordinates, n, r), a = Ar(e1.geometry(), i, n, r);
                            if (!ke(i, n)) return !1;
                            for (const e1 of a)if (!mr(e1, o)) return !1;
                        }
                        return !0;
                    }(e1, this.geometries);
                    if ("LineString" === e1.geometryType()) return function(e1, t1) {
                        const i = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], r = e1.canonicalID();
                        if (!r) return !1;
                        if ("Polygon" === t1.type) {
                            const o = vr(t1.coordinates, n, r), a = Er(e1.geometry(), i, n, r);
                            if (!ke(i, n)) return !1;
                            for (const e1 of a)if (!yr(e1, o)) return !1;
                        }
                        if ("MultiPolygon" === t1.type) {
                            const o = br(t1.coordinates, n, r), a = Er(e1.geometry(), i, n, r);
                            if (!ke(i, n)) return !1;
                            for (const e1 of a)if (!xr(e1, o)) return !1;
                        }
                        return !0;
                    }(e1, this.geometries);
                }
                return !1;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "within",
                    this.geojson
                ];
            }
        }
        class Mr {
            constructor(e1 = [], t1 = (e1, t1)=>e1 < t1 ? -1 : e1 > t1 ? 1 : 0){
                if (this.data = e1, this.length = this.data.length, this.compare = t1, this.length > 0) for(let e1 = (this.length >> 1) - 1; e1 >= 0; e1--)this._down(e1);
            }
            push(e1) {
                this.data.push(e1), this._up(this.length++);
            }
            pop() {
                if (0 === this.length) return;
                const e1 = this.data[0], t1 = this.data.pop();
                return --this.length > 0 && (this.data[0] = t1, this._down(0)), e1;
            }
            peek() {
                return this.data[0];
            }
            _up(e1) {
                const { data: t1, compare: i } = this, n = t1[e1];
                for(; e1 > 0;){
                    const r = e1 - 1 >> 1, o = t1[r];
                    if (i(n, o) >= 0) break;
                    t1[e1] = o, e1 = r;
                }
                t1[e1] = n;
            }
            _down(e1) {
                const { data: t1, compare: i } = this, n = this.length >> 1, r = t1[e1];
                for(; e1 < n;){
                    let n = 1 + (e1 << 1);
                    const o = n + 1;
                    if (o < this.length && i(t1[o], t1[n]) < 0 && (n = o), i(t1[n], r) >= 0) break;
                    t1[e1] = t1[n], e1 = n;
                }
                t1[e1] = r;
            }
        }
        var Sr = 8192;
        function Tr(e1, t1, i) {
            let n = e1 || "";
            return t1 && (n = n ? n + "" + t1 : t1), i && (n = n ? n + "" + i : i), n;
        }
        function zr(e1, t1) {
            switch(e1){
                case "string":
                    return $n(t1);
                case "number":
                    return +t1;
                case "boolean":
                    return !!t1;
                case "color":
                    return fn.parse(t1);
                case "formatted":
                    return Nn.fromString($n(t1));
                case "resolvedImage":
                    return Un.build($n(t1));
            }
            return t1;
        }
        function Rr(e1, t1, i, n) {
            return void 0 !== n && (e1 = n * Math.round(e1 / n)), void 0 !== t1 && e1 < t1 && (e1 = t1), void 0 !== i && e1 > i && (e1 = i), e1;
        }
        class Pr {
            constructor(e1, t1, i, n = !1){
                this.type = e1, this.key = t1, this.scope = i, this.featureConstant = n;
            }
            static parse(e1, t1) {
                let i = t1.expectedType;
                if (i ??= Sn, e1.length < 2 || e1.length > 3) return t1.error("Invalid number of arguments for 'config' expression.");
                const n = t1.parse(e1[1], 1);
                if (!(n instanceof Zn)) return t1.error("Key name of 'config' expression must be a string literal.");
                let r, o = !0;
                const a = $n(n.value);
                if (e1.length >= 3) {
                    const i = t1.parse(e1[2], 2);
                    if (!(i instanceof Zn)) return t1.error("Scope of 'config' expression must be a string literal.");
                    r = $n(i.value);
                }
                if (t1.options) {
                    const e1 = Tr(a, r, t1._scope), i = t1.options.get(e1);
                    i && (o = Dr(i.value || i.default));
                }
                return new Pr(i, a, r, o);
            }
            evaluate(e1) {
                const t1 = Tr(this.key, this.scope, e1.scope), i = e1.getConfig(t1);
                if (!i) return null;
                const { type: n, value: r, values: o, minValue: a, maxValue: s, stepValue: l } = i, c = i.default.evaluate(e1);
                let u = c;
                if (r) {
                    const t1 = e1.scope, i = t1 || "", n = i.indexOf("");
                    e1.scope = n >= 0 ? i.slice(n + 1) : "", u = r.evaluate(e1), e1.scope = t1;
                }
                return n && (u = zr(n, u)), void 0 === u || void 0 === a && void 0 === s && void 0 === l || ("number" == typeof u ? u = Rr(u, a, s, l) : Array.isArray(u) && (u = u.map((e1)=>"number" == typeof e1 ? Rr(e1, a, s, l) : e1))), void 0 !== r && void 0 !== u && o && !o.includes(u) && (u = c, n && (u = zr(n, u))), (n && n !== this.type || void 0 !== u && !Ln(Hn(u), this.type)) && (u = zr(this.type.kind, u)), u;
            }
            eachChild() {}
            outputDefined() {
                return !1;
            }
            serialize() {
                const e1 = [
                    "config",
                    this.key
                ];
                return this.scope && e1.push(this.scope), e1;
            }
        }
        function Dr(e1) {
            if (e1 instanceof sr) {
                if ("get" === e1.name && 1 === e1.args.length) return !1;
                if ("feature-state" === e1.name) return !1;
                if ("has" === e1.name && 1 === e1.args.length) return !1;
                if ("properties" === e1.name || "geometry-type" === e1.name || "id" === e1.name) return !1;
                if (e1.name.startsWith("filter-")) return !1;
            }
            if (e1 instanceof Ir) return !1;
            if (e1 instanceof bo) return !1;
            if (e1 instanceof Pr) return e1.featureConstant;
            let t1 = !0;
            return e1.eachChild((e1)=>{
                t1 && !Dr(e1) && (t1 = !1);
            }), t1;
        }
        function Fr(e1) {
            if (e1 instanceof sr && "feature-state" === e1.name) return !1;
            let t1 = !0;
            return e1.eachChild((e1)=>{
                t1 && !Fr(e1) && (t1 = !1);
            }), t1;
        }
        function Cr(e1, t1) {
            if (e1 instanceof sr && t1.has(e1.name)) return !1;
            let i = !0;
            return e1.eachChild((e1)=>{
                i && !Cr(e1, t1) && (i = !1);
            }), i;
        }
        function Or(e1, t1) {
            return Cr(e1, new Set(t1));
        }
        const Lr = {
            zoom: 1,
            pitch: 1,
            "distance-from-center": 1,
            "measure-light": 2,
            "line-progress": 4
        };
        function Br(e1) {
            let t1 = e1 instanceof sr && Lr[e1.name] || 0;
            return e1.eachChild((e1)=>{
                t1 |= Br(e1);
            }), t1;
        }
        const Vr = 1 / 298.257223563, Nr = Vr * (2 - Vr), kr = Math.PI / 180;
        function Ur(e1) {
            const t1 = 6378.137 * kr * 1e3, i = Math.cos(e1 * kr), n = 1 / (1 - Nr * (1 - i * i)), r = Math.sqrt(n);
            return [
                t1 * r * i,
                t1 * r * n * (1 - Nr)
            ];
        }
        function jr(e1) {
            for(; e1 < -180;)e1 += 360;
            for(; e1 > 180;)e1 -= 360;
            return e1;
        }
        function Gr(e1, t1, i, n) {
            const r = jr(e1[0] - t1[0]) * i, o = (e1[1] - t1[1]) * n;
            return Math.sqrt(r * r + o * o);
        }
        function Hr(e1, t1, i, n, r) {
            let o = t1[0], a = t1[1], s = jr(i[0] - o) * n, l = (i[1] - a) * r;
            if (0 !== s || 0 !== l) {
                const t1 = (jr(e1[0] - o) * n * s + (e1[1] - a) * r * l) / (s * s + l * l);
                t1 > 1 ? (o = i[0], a = i[1]) : t1 > 0 && (o += s / n * t1, a += l / r * t1);
            }
            return s = jr(e1[0] - o) * n, l = (e1[1] - a) * r, Math.sqrt(s * s + l * l);
        }
        function $r(e1, t1) {
            return t1.dist - e1.dist;
        }
        function Zr(e1) {
            const t1 = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            if (t1.length !== e1.length) return !1;
            for(let i = 0; i < t1.length; i++)if (t1[i] !== e1[i]) return !1;
            return !0;
        }
        function Wr(e1) {
            return e1[1] - e1[0] + 1;
        }
        function qr(e1, t1) {
            const i = e1[1] >= e1[0] && e1[1] < t1;
            return i || console.warn("Distance Expression: Index is out of range"), i;
        }
        function Xr(e1, t1) {
            if (e1[0] > e1[1]) return [
                null,
                null
            ];
            const i = Wr(e1);
            if (t1) {
                if (2 === i) return [
                    e1,
                    null
                ];
                const t1 = Math.floor(i / 2);
                return [
                    [
                        e1[0],
                        e1[0] + t1
                    ],
                    [
                        e1[0] + t1,
                        e1[1]
                    ]
                ];
            }
            {
                if (1 === i) return [
                    e1,
                    null
                ];
                const t1 = Math.floor(i / 2) - 1;
                return [
                    [
                        e1[0],
                        e1[0] + t1
                    ],
                    [
                        e1[0] + t1 + 1,
                        e1[1]
                    ]
                ];
            }
        }
        function Yr(e1, t1) {
            const i = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            if (!qr(t1, e1.length)) return i;
            for(let n = t1[0]; n <= t1[1]; ++n)Ne(i, e1[n]);
            return i;
        }
        function Jr(e1) {
            const t1 = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            for(let i = 0; i < e1.length; ++i)for(let n = 0; n < e1[i].length; ++n)Ne(t1, e1[i][n]);
            return t1;
        }
        function Kr(e1, t1, i, n) {
            if (Zr(e1) || Zr(t1)) return NaN;
            let r = 0, o = 0;
            return e1[2] < t1[0] && (r = t1[0] - e1[2]), e1[0] > t1[2] && (r = e1[0] - t1[2]), e1[1] > t1[3] && (o = e1[1] - t1[3]), e1[3] < t1[1] && (o = t1[1] - e1[3]), Gr([
                0,
                0
            ], [
                r,
                o
            ], i, n);
        }
        function Qr(e1, t1, i = 8192) {
            const n = Math.pow(2, t1.z), r = (e1.y / i + t1.y) / n;
            return [
                dr((e1.x / i + t1.x) / n),
                fr(r)
            ];
        }
        function eo(e1, t1) {
            const i = [];
            for(let n = 0; n < e1.length; ++n)i.push(Qr(e1[n], t1));
            return i;
        }
        function to(e1, t1, i, n) {
            const r = function(e1, t1, i, n) {
                let r = 1 / 0, o = e1[0][0], a = e1[0][1];
                for(let s = 0; s < e1.length - 1; s++){
                    let l = e1[s][0], c = e1[s][1], u = jr(e1[s + 1][0] - l) * i, h = (e1[s + 1][1] - c) * n, d = 0;
                    0 === u && 0 === h || (d = (jr(t1[0] - l) * i * u + (t1[1] - c) * n * h) / (u * u + h * h), d > 1 ? (l = e1[s + 1][0], c = e1[s + 1][1]) : d > 0 && (l += u / i * d, c += h / n * d)), u = jr(t1[0] - l) * i, h = (t1[1] - c) * n;
                    const f = u * u + h * h;
                    f < r && (r = f, o = l, a = c);
                }
                return [
                    o,
                    a
                ];
            }(t1, e1, i, n);
            return Gr(e1, r, i, n);
        }
        function io(e1, t1, i, n, r, o) {
            const a = i.slice(n[0], n[1] + 1);
            let s = 1 / 0;
            for(let i = t1[0]; i <= t1[1]; ++i)if (0 === (s = Math.min(s, to(e1[i], a, r, o)))) return 0;
            return s;
        }
        function no(e1, t1, i, n, r, o) {
            const a = Math.min(Hr(e1, i, n, r, o), Hr(t1, i, n, r, o)), s = Math.min(Hr(i, e1, t1, r, o), Hr(n, e1, t1, r, o));
            return Math.min(a, s);
        }
        function ro(e1, t1, i, n, r, o) {
            if (!qr(t1, e1.length) || !qr(n, i.length)) return NaN;
            let a = 1 / 0;
            for(let s = t1[0]; s < t1[1]; ++s)for(let t1 = n[0]; t1 < n[1]; ++t1){
                if ($e(e1[s], e1[s + 1], i[t1], i[t1 + 1])) return 0;
                a = Math.min(a, no(e1[s], e1[s + 1], i[t1], i[t1 + 1], r, o));
            }
            return a;
        }
        function oo(e1, t1, i, n, r, o) {
            if (!qr(t1, e1.length) || !qr(n, i.length)) return NaN;
            let a = 1 / 0;
            for(let s = t1[0]; s <= t1[1]; ++s)for(let t1 = n[0]; t1 <= n[1]; ++t1)if (0 === (a = Math.min(a, Gr(e1[s], i[t1], r, o)))) return a;
            return a;
        }
        function ao(e1, t1, i, n) {
            if (Ge(e1, t1, !0)) return 0;
            let r = 1 / 0;
            for (const o of t1){
                const t1 = o.length;
                if (t1 < 2) return console.warn("Distance Expression: Invalid polygon!"), NaN;
                if (o[0] !== o[t1 - 1] && 0 === (r = Math.min(r, Hr(e1, o[t1 - 1], o[0], i, n)))) return r;
                if (0 === (r = Math.min(r, to(e1, o, i, n)))) return r;
            }
            return r;
        }
        function so(e1, t1, i, n, r) {
            if (!qr(t1, e1.length)) return NaN;
            for(let n = t1[0]; n <= t1[1]; ++n)if (Ge(e1[n], i, !0)) return 0;
            let o = 1 / 0;
            for(let a = t1[0]; a < t1[1]; ++a)for (const t1 of i)for(let i = 0, s = t1.length, l = s - 1; i < s; l = i++){
                if ($e(e1[a], e1[a + 1], t1[l], t1[i])) return 0;
                o = Math.min(o, no(e1[a], e1[a + 1], t1[l], t1[i], n, r));
            }
            return o;
        }
        function lo(e1, t1) {
            for (const i of e1)for(let e1 = 0; e1 <= i.length - 1; ++e1)if (Ge(i[e1], t1, !0)) return !0;
            return !1;
        }
        function co(e1, t1, i, n, r = 1 / 0) {
            const o = Jr(e1), a = Jr(t1);
            if (r !== 1 / 0 && Kr(o, a, i, n) >= r) return r;
            if (ke(o, a)) {
                if (lo(e1, t1)) return 0;
            } else if (lo(t1, e1)) return 0;
            let s = r;
            for (const r of e1)for(let e1 = 0, o = r.length, a = o - 1; e1 < o; a = e1++)for (const o of t1)for(let t1 = 0, l = o.length, c = l - 1; t1 < l; c = t1++){
                if ($e(r[a], r[e1], o[c], o[t1])) return 0;
                s = Math.min(s, no(r[a], r[e1], o[c], o[t1], i, n));
            }
            return s;
        }
        function uo(e1, t1, i, n, r, o, a, s) {
            if (null === a || null === s) return;
            const l = Kr(Yr(r, a), Yr(o, s), i, n);
            l < t1 && e1.push({
                dist: l,
                range1: a,
                range2: s
            });
        }
        function ho(e1, t1, i, n, r, o = 1 / 0) {
            let a = Math.min(Gr(e1[0], i[0][0], n, r), o);
            if (0 === a) return a;
            const s = new Mr([
                {
                    dist: 0,
                    range1: [
                        0,
                        e1.length - 1
                    ],
                    range2: [
                        0,
                        0
                    ]
                }
            ], $r), l = t1 ? 50 : 100, c = Jr(i);
            for(; s.length;){
                const o = s.pop();
                if (o.dist >= a) continue;
                const u = o.range1;
                if (Wr(u) <= l) {
                    if (!qr(u, e1.length)) return NaN;
                    if (t1) {
                        const t1 = so(e1, u, i, n, r);
                        if (0 === (a = Math.min(a, t1))) return a;
                    } else for(let t1 = u[0]; t1 <= u[1]; ++t1){
                        const o = ao(e1[t1], i, n, r);
                        if (0 === (a = Math.min(a, o))) return a;
                    }
                } else {
                    const i = Xr(u, t1);
                    if (null !== i[0]) {
                        const t1 = Kr(Yr(e1, i[0]), c, n, r);
                        t1 < a && s.push({
                            dist: t1,
                            range1: i[0],
                            range2: [
                                0,
                                0
                            ]
                        });
                    }
                    if (null !== i[1]) {
                        const t1 = Kr(Yr(e1, i[1]), c, n, r);
                        t1 < a && s.push({
                            dist: t1,
                            range1: i[1],
                            range2: [
                                0,
                                0
                            ]
                        });
                    }
                }
            }
            return a;
        }
        function fo(e1, t1, i, n, r, o, a = 1 / 0) {
            let s = Math.min(a, Gr(e1[0], i[0], r, o));
            if (0 === s) return s;
            const l = new Mr([
                {
                    dist: 0,
                    range1: [
                        0,
                        e1.length - 1
                    ],
                    range2: [
                        0,
                        i.length - 1
                    ]
                }
            ], $r), c = t1 ? 50 : 100, u = n ? 50 : 100;
            for(; l.length;){
                const a = l.pop();
                if (a.dist >= s) continue;
                const h = a.range1, d = a.range2;
                if (Wr(h) <= c && Wr(d) <= u) {
                    if (!qr(h, e1.length) || !qr(d, i.length)) return NaN;
                    if (t1 && n ? s = Math.min(s, ro(e1, h, i, d, r, o)) : t1 || n ? t1 && !n ? s = Math.min(s, io(i, d, e1, h, r, o)) : !t1 && n && (s = Math.min(s, io(e1, h, i, d, r, o))) : s = Math.min(s, oo(e1, h, i, d, r, o)), 0 === s) return s;
                } else {
                    const a = Xr(h, t1), c = Xr(d, n);
                    uo(l, s, r, o, e1, i, a[0], c[0]), uo(l, s, r, o, e1, i, a[0], c[1]), uo(l, s, r, o, e1, i, a[1], c[0]), uo(l, s, r, o, e1, i, a[1], c[1]);
                }
            }
            return s;
        }
        function po(e1, t1, i, n, r, o = 1 / 0) {
            let a = o;
            const s = Yr(e1, [
                0,
                e1.length - 1
            ]);
            for (const o of i)if (!(a !== 1 / 0 && Kr(s, Yr(o, [
                0,
                o.length - 1
            ]), n, r) >= a) && (a = Math.min(a, fo(e1, t1, o, !0, n, r, a)), 0 === a)) return a;
            return a;
        }
        function _o(e1, t1, i, n, r, o = 1 / 0) {
            let a = o;
            const s = Yr(e1, [
                0,
                e1.length - 1
            ]);
            for (const o of i){
                if (a !== 1 / 0 && Kr(s, Jr(o), n, r) >= a) continue;
                const i = ho(e1, t1, o, n, r, a);
                if (isNaN(i)) return i;
                if (0 === (a = Math.min(a, i))) return a;
            }
            return a;
        }
        function mo(e1, t1, i) {
            const n = [];
            for (const i of e1)for (const e1 of i)n.push(Qr(e1, t1));
            const [r, o] = Ur(n[0][1]);
            return "Point" === i.type || "MultiPoint" === i.type || "LineString" === i.type ? fo(n, !1, "Point" === i.type ? [
                i.coordinates
            ] : i.coordinates, "LineString" === i.type, r, o) : "MultiLineString" === i.type ? po(n, !1, i.coordinates, r, o) : "Polygon" === i.type || "MultiPolygon" === i.type ? _o(n, !1, "Polygon" === i.type ? [
                i.coordinates
            ] : i.coordinates, r, o) : null;
        }
        function go(e1, t1, i) {
            const n = [];
            for (const i of e1){
                const e1 = [];
                for (const n of i)e1.push(Qr(n, t1));
                n.push(e1);
            }
            const [r, o] = Ur(n[0][0][1]);
            if ("Point" === i.type || "MultiPoint" === i.type || "LineString" === i.type) return po("Point" === i.type ? [
                i.coordinates
            ] : i.coordinates, "LineString" === i.type, n, r, o);
            if ("MultiLineString" === i.type) {
                let e1 = 1 / 0;
                for(let t1 = 0; t1 < i.coordinates.length; t1++){
                    const a = po(i.coordinates[t1], !0, n, r, o, e1);
                    if (isNaN(a)) return a;
                    if (0 === (e1 = Math.min(e1, a))) return e1;
                }
                return e1;
            }
            if ("Polygon" === i.type || "MultiPolygon" === i.type) {
                let e1 = 1 / 0;
                for(let t1 = 0; t1 < n.length; t1++){
                    const a = _o(n[t1], !0, "Polygon" === i.type ? [
                        i.coordinates
                    ] : i.coordinates, r, o, e1);
                    if (isNaN(a)) return a;
                    if (0 === (e1 = Math.min(e1, a))) return e1;
                }
                return e1;
            }
            return null;
        }
        function yo(e1, t1, i) {
            const n = [];
            for (const i of Ve(e1, 0)){
                const e1 = [];
                for(let n = 0; n < i.length; ++n)e1.push(eo(i[n], t1));
                n.push(e1);
            }
            const [r, o] = Ur(n[0][0][0][1]);
            if ("Point" === i.type || "MultiPoint" === i.type || "LineString" === i.type) return _o("Point" === i.type ? [
                i.coordinates
            ] : i.coordinates, "LineString" === i.type, n, r, o);
            if ("MultiLineString" === i.type) {
                let e1 = 1 / 0;
                for(let t1 = 0; t1 < i.coordinates.length; t1++){
                    const a = _o(i.coordinates[t1], !0, n, r, o, e1);
                    if (isNaN(a)) return a;
                    if (0 === (e1 = Math.min(e1, a))) return e1;
                }
                return e1;
            }
            return "Polygon" === i.type || "MultiPolygon" === i.type ? function(e1, t1, i, n) {
                let r = 1 / 0;
                for (const o of e1)for (const e1 of t1){
                    const t1 = co(o, e1, i, n, r);
                    if (isNaN(t1)) return t1;
                    if (0 === (r = Math.min(r, t1))) return r;
                }
                return r;
            }("Polygon" === i.type ? [
                i.coordinates
            ] : i.coordinates, n, r, o) : null;
        }
        function xo(e1) {
            return "Point" === e1 || "MultiPoint" === e1 || "LineString" === e1 || "MultiLineString" === e1 || "Polygon" === e1 || "MultiPolygon" === e1;
        }
        function vo(e1) {
            if (!Gn(e1) || "object" != typeof e1 || null === e1 || Array.isArray(e1)) return null;
            const t1 = e1;
            if ("FeatureCollection" === t1.type) {
                if (0 === t1.features.length) return null;
                const e1 = [];
                for (const i of t1.features){
                    if (!xo(i.geometry.type)) return null;
                    e1.push(i.geometry);
                }
                return e1;
            }
            return "Feature" === t1.type ? xo(t1.geometry.type) ? [
                t1.geometry
            ] : null : xo(t1.type) ? [
                t1
            ] : null;
        }
        class bo {
            constructor(e1){
                this.type = wn, this.geojson = e1;
            }
            static parse(e1, t1) {
                if (2 !== e1.length) return t1.error(`'distance' expression requires either one argument, but found ' ${e1.length - 1} instead.`);
                const i = e1[1], n = Gn(i) && !Array.isArray(i), r = t1.parse(n ? [
                    "literal",
                    i
                ] : i, 1, Sn);
                if (!r) return null;
                for (const [e1, i] of [
                    [
                        [
                            "measure-light"
                        ],
                        "brightness"
                    ],
                    [
                        [
                            "pitch"
                        ],
                        "pitch"
                    ],
                    [
                        [
                            "distance-from-center"
                        ],
                        "distance-from-center"
                    ]
                ])if (!Or(r, e1)) return t1.error(`'distance' expression may not depend on ${i}.`);
                return Fr(r) ? r instanceof Zn && !vo(r.value) ? t1.error("'distance' expression needs to be an array with format ['Distance', GeoJSONObj].") : new bo(r) : t1.error("'distance' expression may not depend on feature-state.");
            }
            evaluate(e1) {
                const t1 = vo(this.geojson.evaluate(e1));
                if (!t1) return console.warn("Distance Expression: could not resolve a valid Point/LineString/Polygon GeoJSON geometry."), null;
                const i = e1.geometry(), n = e1.canonicalID();
                if (null == i || null == n) return console.warn("Distance Expression: requires valid feature and canonical information."), null;
                const r = e1.geometryType(), o = "Point" === r ? mo : "LineString" === r ? go : "Polygon" === r ? yo : null;
                if (!o) return console.warn("Distance Expression: currently only evaluates valid Point/LineString/Polygon geometries."), null;
                let a = 1 / 0;
                for (const e1 of t1){
                    const t1 = o(i, n, e1);
                    if (null == t1 || isNaN(t1)) return t1;
                    if (0 === (a = Math.min(a, t1))) break;
                }
                return a;
            }
            eachChild(e1) {
                e1(this.geojson);
            }
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "distance",
                    this.geojson.serialize()
                ];
            }
        }
        class wo {
            constructor(e1, t1){
                this.type = t1.type, this.name = e1, this.boundExpression = t1;
            }
            static parse(e1, t1) {
                if (2 !== e1.length || "string" != typeof e1[1]) return t1.error("'var' expression requires exactly one string literal argument.");
                const i = e1[1];
                return t1.scope.has(i) ? new wo(i, t1.scope.get(i)) : t1.error(`Unknown variable "${i}". Make sure "${i}" has been bound in an enclosing "let" expression before using it.`, 1);
            }
            evaluate(e1) {
                return this.boundExpression.evaluate(e1);
            }
            eachChild() {}
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "var",
                    this.name
                ];
            }
        }
        class Ao {
            constructor(e1, t1 = [], i, n = new vn, r = [], o, a, s){
                this.registry = e1, this.path = t1, this.scope = n, this.errors = r, this.expectedType = i, this._scope = o, this.options = a, this.iconImageUseTheme = s;
            }
            get key() {
                let e1 = "";
                for(let t1 = 0; t1 < this.path.length; t1++){
                    const i = this.path[t1];
                    e1 += "string" == typeof i ? `['${i}']` : `[${i}]`;
                }
                return e1;
            }
            parse(e1, t1, i, n, r) {
                if (t1 || i) {
                    const o = this.expectedType, a = this.scope;
                    n && (this.scope = this.scope.concat(n)), this.expectedType = i || null;
                    const s = "number" == typeof t1;
                    s && this.path.push(t1);
                    const l = this._parse(e1, r);
                    return s && this.path.pop(), this.expectedType = o, this.scope = a, l;
                }
                return this._parse(e1, r);
            }
            parseObjectValue(e1, t1, i, n, r, o) {
                const a = this.expectedType, s = this.scope;
                r && (this.scope = this.scope.concat(r)), this.expectedType = n || null, this.path.push(t1), this.path.push(i);
                const l = this._parse(e1, o);
                return this.path.pop(), this.path.pop(), this.expectedType = a, this.scope = s, l;
            }
            _annotateToExpectedType(e1, t1) {
                const i = this.expectedType;
                if (!i) return e1;
                const n = e1.type;
                return "string" !== i.kind && "number" !== i.kind && "boolean" !== i.kind && "object" !== i.kind && "array" !== i.kind || "value" !== n.kind ? "color" !== i.kind && "formatted" !== i.kind && "resolvedImage" !== i.kind || "value" !== n.kind && "string" !== n.kind ? this.checkSubtype(i, n) ? null : e1 : Io(e1, i, t1?.typeAnnotation || "coerce") : Io(e1, i, t1?.typeAnnotation || "assert");
            }
            _parse(e1, t1) {
                const i = null === e1 ? bn : "string" == typeof e1 ? An : "boolean" == typeof e1 ? En : "number" == typeof e1 ? wn : null;
                let n;
                if (i) n = new Zn(i, e1);
                else {
                    if (!Array.isArray(e1)) return this.error(void 0 === e1 ? "'undefined' value invalid. Use null instead." : "object" == typeof e1 ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof e1} instead.`);
                    {
                        if (0 === e1.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                        const t1 = this.registry[e1[0]];
                        if (!t1) return rr.parse([
                            "to-array",
                            e1
                        ], this);
                        if (n = t1.parse(e1, this), !n) return null;
                    }
                }
                let r = this._annotateToExpectedType(n, t1);
                if (!r) return null;
                if (!(r instanceof Zn) && "resolvedImage" !== r.type.kind && Mo(r)) {
                    const e1 = new ar(this._scope, this.options, this.iconImageUseTheme);
                    try {
                        r = new Zn(r.type, r.evaluate(e1));
                    } catch (e1) {
                        return this.error(e1.message), null;
                    }
                }
                return r;
            }
            concat(e1, t1, i, n) {
                const r = n ? this.scope.concat(n) : this.scope, o = this.path.slice();
                return "number" == typeof e1 && o.push(e1), "string" == typeof t1 && o.push(t1), new Ao(this.registry, o, i || null, r, this.errors, this._scope, this.options, this.iconImageUseTheme);
            }
            _forkForSignature() {
                return new Ao(this.registry, this.path, null, this.scope, [], this._scope, this.options, this.iconImageUseTheme);
            }
            error(e1, ...t1) {
                const i = `${this.key}${t1.map((e1)=>`[${e1}]`).join("")}`;
                this.errors.push(new xn(i, e1));
            }
            checkSubtype(e1, t1, i) {
                const n = Fn(e1, t1);
                return n && this.error(n, ..."number" == typeof i ? [
                    i
                ] : []), n;
            }
        }
        const Eo = new Set([
            "zoom",
            "heatmap-density",
            "worldview",
            "line-progress",
            "raster-value",
            "sky-radial-progress",
            "accumulated",
            "is-supported-script",
            "pitch",
            "distance-from-center",
            "measure-light",
            "raster-particle-speed",
            "is-active-floor"
        ]);
        function Io(e1, t1, i) {
            return "assert" === i ? new Xn(t1, [
                e1
            ]) : "coerce" === i ? new rr(t1, [
                e1
            ]) : e1;
        }
        function Mo(e1) {
            if (e1 instanceof wo) return Mo(e1.boundExpression);
            if (e1 instanceof sr && "error" === e1.name) return !1;
            if (e1 instanceof cr) return !1;
            if (e1 instanceof Ir) return !1;
            if (e1 instanceof bo) return !1;
            if (e1 instanceof Pr) return !1;
            const t1 = e1 instanceof rr || e1 instanceof Xn;
            let i = !0;
            return e1.eachChild((e1)=>{
                i = t1 ? i && Mo(e1) : i && e1 instanceof Zn;
            }), !!i && Dr(e1) && Cr(e1, Eo);
        }
        function So(e1, t1) {
            const i = e1.length - 1;
            let n, r, o = 0, a = i, s = 0;
            for(; o <= a;)if (s = Math.floor((o + a) / 2), n = e1[s], r = e1[s + 1], n <= t1) {
                if (s === i || t1 < r) return s;
                o = s + 1;
            } else {
                if (!(n > t1)) throw new Wn("Input is not a number.");
                a = s - 1;
            }
            return 0;
        }
        class To {
            constructor(e1, t1, i){
                this.type = e1, this.input = t1, this.labels = [], this.outputs = [];
                for (const [e1, t1] of i)this.labels.push(e1), this.outputs.push(t1);
            }
            static parse(e1, t1) {
                if (e1.length - 1 < 4) return t1.error(`Expected at least 4 arguments, but found only ${e1.length - 1}.`);
                if ((e1.length - 1) % 2 != 0) return t1.error("Expected an even number of arguments.");
                const i = t1.parse(e1[1], 1, wn);
                if (!i) return null;
                const n = [];
                let r = null;
                t1.expectedType && "value" !== t1.expectedType.kind && (r = t1.expectedType);
                for(let i = 1; i < e1.length; i += 2){
                    const o = 1 === i ? -1 / 0 : e1[i], a = e1[i + 1], s = i, l = i + 1;
                    if ("number" != typeof o) return t1.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', s);
                    if (n.length && n.at(-1)[0] >= o) return t1.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', s);
                    const c = t1.parse(a, l, r);
                    if (!c) return null;
                    r = r || c.type, n.push([
                        o,
                        c
                    ]);
                }
                return new To(r, i, n);
            }
            evaluate(e1) {
                const t1 = this.labels, i = this.outputs;
                if (1 === t1.length) return i[0].evaluate(e1);
                const n = this.input.evaluate(e1);
                if (n <= t1[0]) return i[0].evaluate(e1);
                const r = t1.length;
                return n >= t1[r - 1] ? i[r - 1].evaluate(e1) : i[So(t1, n)].evaluate(e1);
            }
            eachChild(e1) {
                e1(this.input);
                for (const t1 of this.outputs)e1(t1);
            }
            outputDefined() {
                return this.outputs.every((e1)=>e1.outputDefined());
            }
            serialize() {
                const e1 = [
                    "step",
                    this.input.serialize()
                ];
                for(let t1 = 0; t1 < this.labels.length; t1++)t1 > 0 && e1.push(this.labels[t1]), e1.push(this.outputs[t1].serialize());
                return e1;
            }
        }
        const zo = .95047, Ro = 1.08883, Po = 4 / 29, Do = 6 / 29, Fo = 3 * Do * Do, Co = Do * Do * Do, Oo = Math.PI / 180, Lo = 180 / Math.PI;
        function Bo(e1) {
            return e1 > Co ? Math.pow(e1, 1 / 3) : e1 / Fo + Po;
        }
        function Vo(e1) {
            return e1 > Do ? e1 * e1 * e1 : Fo * (e1 - Po);
        }
        function No(e1) {
            return 255 * (e1 <= .0031308 ? 12.92 * e1 : 1.055 * Math.pow(e1, 1 / 2.4) - .055);
        }
        function ko(e1) {
            return (e1 /= 255) <= .04045 ? e1 / 12.92 : Math.pow((e1 + .055) / 1.055, 2.4);
        }
        function Uo(e1) {
            const t1 = ko(e1.r), i = ko(e1.g), n = ko(e1.b), r = Bo((.4124564 * t1 + .3575761 * i + .1804375 * n) / zo), o = Bo((.2126729 * t1 + .7151522 * i + .072175 * n) / 1);
            return {
                l: 116 * o - 16,
                a: 500 * (r - o),
                b: 200 * (o - Bo((.0193339 * t1 + .119192 * i + .9503041 * n) / Ro)),
                alpha: e1.a
            };
        }
        function jo(e1) {
            let t1 = (e1.l + 16) / 116, i = isNaN(e1.a) ? t1 : t1 + e1.a / 500, n = isNaN(e1.b) ? t1 : t1 - e1.b / 200;
            return t1 = 1 * Vo(t1), i = zo * Vo(i), n = Ro * Vo(n), new fn(No(3.2404542 * i - 1.5371385 * t1 - .4985314 * n), No(-0.969266 * i + 1.8760108 * t1 + .041556 * n), No(.0556434 * i - .2040259 * t1 + 1.0572252 * n), e1.alpha);
        }
        function Go(e1, t1, i) {
            const n = t1 - e1;
            return e1 + i * (n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n);
        }
        const Ho = {
            forward: Uo,
            reverse: jo,
            interpolate: function(e1, t1, i) {
                return {
                    l: hn(e1.l, t1.l, i),
                    a: hn(e1.a, t1.a, i),
                    b: hn(e1.b, t1.b, i),
                    alpha: hn(e1.alpha, t1.alpha, i)
                };
            }
        }, $o = {
            forward: function(e1) {
                const { l: t1, a: i, b: n } = Uo(e1), r = Math.atan2(n, i) * Lo;
                return {
                    h: r < 0 ? r + 360 : r,
                    c: Math.sqrt(i * i + n * n),
                    l: t1,
                    alpha: e1.a
                };
            },
            reverse: function(e1) {
                const t1 = e1.h * Oo, i = e1.c;
                return jo({
                    l: e1.l,
                    a: Math.cos(t1) * i,
                    b: Math.sin(t1) * i,
                    alpha: e1.alpha
                });
            },
            interpolate: function(e1, t1, i) {
                return {
                    h: Go(e1.h, t1.h, i),
                    c: hn(e1.c, t1.c, i),
                    l: hn(e1.l, t1.l, i),
                    alpha: hn(e1.alpha, t1.alpha, i)
                };
            }
        };
        var Zo = Object.freeze({
            __proto__: null,
            hcl: $o,
            lab: Ho
        });
        class Wo {
            constructor(e1, t1, i, n, r){
                this.type = e1, this.operator = t1, this.interpolation = i, this.input = n, this.labels = [], this.outputs = [];
                for (const [e1, t1] of r)this.labels.push(e1), this.outputs.push(t1);
            }
            static interpolationFactor(e1, t1, i, n) {
                let r = 0;
                if ("exponential" === e1.name) r = qo(t1, e1.base, i, n);
                else if ("linear" === e1.name) r = qo(t1, 1, i, n);
                else if ("cubic-bezier" === e1.name) {
                    const o = e1.controlPoints;
                    r = ze(o[0], o[1], o[2], o[3])(qo(t1, 1, i, n));
                }
                return r;
            }
            static parse(e1, t1) {
                let [i, n, r, ...o] = e1;
                if (!Array.isArray(n) || 0 === n.length) return t1.error("Expected an interpolation type expression.", 1);
                if ("linear" === n[0]) n = {
                    name: "linear"
                };
                else if ("exponential" === n[0]) {
                    const e1 = n[1];
                    if ("number" != typeof e1) return t1.error("Exponential interpolation requires a numeric base.", 1, 1);
                    n = {
                        name: "exponential",
                        base: e1
                    };
                } else {
                    if ("cubic-bezier" !== n[0]) return t1.error(`Unknown interpolation type ${String(n[0])}`, 1, 0);
                    {
                        const e1 = n.slice(1);
                        if (4 !== e1.length || e1.some((e1)=>"number" != typeof e1 || e1 < 0 || e1 > 1)) return t1.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                        n = {
                            name: "cubic-bezier",
                            controlPoints: e1
                        };
                    }
                }
                if (e1.length - 1 < 4) return t1.error(`Expected at least 4 arguments, but found only ${e1.length - 1}.`);
                if (e1.length - 1 > 3 && (e1.length - 1) % 2 != 0) return t1.error("Expected an even number of arguments.");
                if (r = t1.parse(r, 2, wn), !r) return null;
                const a = [];
                let s = null;
                "interpolate-hcl" === i || "interpolate-lab" === i ? s = In : t1.expectedType && "value" !== t1.expectedType.kind && (s = t1.expectedType);
                for(let e1 = 0; e1 < o.length; e1 += 2){
                    const i = o[e1], n = o[e1 + 1], r = e1 + 3, l = e1 + 4;
                    if ("number" != typeof i) return t1.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', r);
                    if (a.length && a.at(-1)[0] >= i) return t1.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', r);
                    const c = t1.parse(n, l, s);
                    if (!c) return null;
                    s = s || c.type, a.push([
                        i,
                        c
                    ]);
                }
                return "number" === s.kind || "color" === s.kind || "array" === s.kind && "number" === s.itemType.kind && "number" == typeof s.N ? new Wo(s, i, n, r, a) : t1.error(`Type ${Dn(s)} is not interpolatable.`);
            }
            evaluate(e1) {
                const t1 = this.labels, i = this.outputs;
                if (1 === t1.length) return i[0].evaluate(e1);
                const n = this.input.evaluate(e1);
                if (n <= t1[0]) return i[0].evaluate(e1);
                const r = t1.length;
                if (n >= t1[r - 1]) return i[r - 1].evaluate(e1);
                const o = So(t1, n), a = Wo.interpolationFactor(this.interpolation, n, t1[o], t1[o + 1]), s = i[o].evaluate(e1), l = i[o + 1].evaluate(e1);
                return "interpolate" === this.operator ? yn[this.type.kind.toLowerCase()](s, l, a) : "interpolate-hcl" === this.operator ? $o.reverse($o.interpolate($o.forward(s), $o.forward(l), a)) : Ho.reverse(Ho.interpolate(Ho.forward(s), Ho.forward(l), a));
            }
            eachChild(e1) {
                e1(this.input);
                for (const t1 of this.outputs)e1(t1);
            }
            outputDefined() {
                return this.outputs.every((e1)=>e1.outputDefined());
            }
            serialize() {
                let e1;
                e1 = "linear" === this.interpolation.name ? [
                    "linear"
                ] : "exponential" === this.interpolation.name ? 1 === this.interpolation.base ? [
                    "linear"
                ] : [
                    "exponential",
                    this.interpolation.base
                ] : [
                    "cubic-bezier",
                    ...this.interpolation.controlPoints
                ];
                const t1 = [
                    this.operator,
                    e1,
                    this.input.serialize()
                ];
                for(let e1 = 0; e1 < this.labels.length; e1++)t1.push(this.labels[e1], this.outputs[e1].serialize());
                return t1;
            }
        }
        function qo(e1, t1, i, n) {
            const r = n - i, o = e1 - i;
            return 0 === r ? 0 : 1 === t1 ? o / r : (Math.pow(t1, o) - 1) / (Math.pow(t1, r) - 1);
        }
        class Xo {
            constructor(e1, t1){
                this.type = e1, this.args = t1;
            }
            static parse(e1, t1) {
                if (e1.length < 2) return t1.error("Expectected at least one argument."), null;
                let i = null;
                const n = t1.expectedType;
                n && "value" !== n.kind && (i = n);
                const r = [];
                for (const n of e1.slice(1)){
                    const e1 = t1.parse(n, 1 + r.length, i, void 0, {
                        typeAnnotation: "omit"
                    });
                    if (!e1) return null;
                    i = i || e1.type, r.push(e1);
                }
                const o = n && r.some((e1)=>Fn(n, e1.type));
                return new Xo(o ? Sn : i, r);
            }
            evaluate(e1) {
                let t1, i = null, n = 0;
                for (const r of this.args){
                    if (n++, i = r.evaluate(e1), i && i instanceof Un && !i.available && (t1 || (t1 = i), i = null, n === this.args.length)) return t1;
                    if (null !== i) break;
                }
                return i;
            }
            eachChild(e1) {
                this.args.forEach(e1);
            }
            outputDefined() {
                return this.args.every((e1)=>e1.outputDefined());
            }
            serialize() {
                const e1 = [
                    "coalesce"
                ];
                return this.eachChild((t1)=>{
                    e1.push(t1.serialize());
                }), e1;
            }
        }
        const Yo = /[^a-zA-Z0-9_]/;
        class Jo {
            constructor(e1, t1){
                this.type = t1.type, this.bindings = [].concat(e1), this.result = t1;
            }
            evaluate(e1) {
                return this.result.evaluate(e1);
            }
            eachChild(e1) {
                for (const t1 of this.bindings)e1(t1[1]);
                e1(this.result);
            }
            static parse(e1, t1) {
                if (e1.length < 4) return t1.error(`Expected at least 3 arguments, but found ${e1.length - 1} instead.`);
                const i = [];
                for(let n = 1; n < e1.length - 1; n += 2){
                    const r = e1[n];
                    if ("string" != typeof r) return t1.error(`Expected string, but found ${typeof r} instead.`, n);
                    if (Yo.test(r)) return t1.error("Variable names must contain only alphanumeric characters or '_'.", n);
                    const o = t1.parse(e1[n + 1], n + 1);
                    if (!o) return null;
                    i.push([
                        r,
                        o
                    ]);
                }
                const n = t1.parse(e1.at(-1), e1.length - 1, t1.expectedType, i);
                return n ? new Jo(i, n) : null;
            }
            outputDefined() {
                return this.result.outputDefined();
            }
            serialize() {
                const e1 = [
                    "let"
                ];
                for (const [t1, i] of this.bindings)e1.push(t1, i.serialize());
                return e1.push(this.result.serialize()), e1;
            }
        }
        class Ko {
            constructor(e1, t1, i){
                this.type = e1, this.index = t1, this.input = i;
            }
            static parse(e1, t1) {
                if (3 !== e1.length) return t1.error(`Expected 2 arguments, but found ${e1.length - 1} instead.`);
                const i = t1.parse(e1[1], 1, wn), n = t1.parse(e1[2], 2, Pn(t1.expectedType || Sn));
                return i && n ? new Ko(n.type.itemType, i, n) : null;
            }
            evaluate(e1) {
                const t1 = this.index.evaluate(e1), i = this.input.evaluate(e1);
                if (t1 < 0) throw new Wn("Array index out of bounds: negative index");
                if (t1 >= i.length) throw new Wn("Array index out of bounds: index exceeds array size");
                if (t1 !== Math.floor(t1)) throw new Wn("Array index must be an integer. Use at-interpolated for fractional indices");
                return i[t1];
            }
            eachChild(e1) {
                e1(this.index), e1(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "at",
                    this.index.serialize(),
                    this.input.serialize()
                ];
            }
        }
        class Qo {
            constructor(e1, t1, i){
                this.type = e1, this.index = t1, this.input = i;
            }
            static parse(e1, t1) {
                if (3 !== e1.length) return t1.error(`Expected 2 arguments, but found ${e1.length - 1} instead.`);
                const i = t1.parse(e1[1], 1, wn), n = t1.parse(e1[2], 2, Pn(t1.expectedType || Sn));
                return i && n ? new Qo(n.type.itemType, i, n) : null;
            }
            evaluate(e1) {
                const t1 = this.index.evaluate(e1), i = this.input.evaluate(e1);
                if (t1 < 0) throw new Wn(`Array index out of bounds: ${t1} < 0.`);
                if (t1 > i.length - 1) throw new Wn(`Array index out of bounds: ${t1} > ${i.length - 1}.`);
                if (t1 === Math.floor(t1)) return i[t1];
                const n = Math.floor(t1), r = Math.ceil(t1), o = i[n], a = i[r];
                if ("number" != typeof o || "number" != typeof a) throw new Wn(`Cannot interpolate between non-number values at index ${t1}.`);
                return hn(o, a, t1 - n);
            }
            eachChild(e1) {
                e1(this.index), e1(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "at-interpolated",
                    this.index.serialize(),
                    this.input.serialize()
                ];
            }
        }
        class ea {
            constructor(e1, t1, i, n, r, o){
                this.inputType = e1, this.type = t1, this.input = i, this.cases = n, this.outputs = r, this.otherwise = o;
            }
            static parse(e1, t1) {
                if (e1.length < 5) return t1.error(`Expected at least 4 arguments, but found only ${e1.length - 1}.`);
                if (e1.length % 2 != 1) return t1.error("Expected an even number of arguments.");
                let i, n;
                t1.expectedType && "value" !== t1.expectedType.kind && (n = t1.expectedType);
                const r = {}, o = [];
                for(let a = 2; a < e1.length - 1; a += 2){
                    let s = e1[a];
                    const l = e1[a + 1];
                    if (Array.isArray(s) || (s = [
                        s
                    ]), 0 === s.length) return t1.error("Expected at least one branch label.", a);
                    for (const e1 of s){
                        if ("number" != typeof e1 && "string" != typeof e1) return t1.error("Branch labels must be numbers or strings.", a);
                        if ("number" == typeof e1 && Math.abs(e1) > Number.MAX_SAFE_INTEGER) return t1.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`, a);
                        if ("number" == typeof e1 && Math.floor(e1) !== e1) return t1.error("Numeric branch labels must be integer values.", a);
                        if (i) {
                            if (t1.checkSubtype(i, Hn(e1), a)) return null;
                        } else i = Hn(e1);
                        if (void 0 !== r[String(e1)]) return t1.error("Branch labels must be unique.", a);
                        r[String(e1)] = o.length;
                    }
                    const c = t1.parse(l, a, n);
                    if (!c) return null;
                    n = n || c.type, o.push(c);
                }
                const a = t1.parse(e1[1], 1, Sn);
                if (!a) return null;
                const s = t1.parse(e1.at(-1), e1.length - 1, n);
                return s ? "value" !== a.type.kind && t1.checkSubtype(i, a.type, 1) ? null : new ea(i, n, a, r, o, s) : null;
            }
            evaluate(e1) {
                const t1 = this.input.evaluate(e1);
                return (Ln(Hn(t1), this.inputType) && this.outputs[this.cases[t1]] || this.otherwise).evaluate(e1);
            }
            eachChild(e1) {
                e1(this.input), this.outputs.forEach(e1), e1(this.otherwise);
            }
            outputDefined() {
                return this.outputs.every((e1)=>e1.outputDefined()) && this.otherwise.outputDefined();
            }
            serialize() {
                const e1 = [
                    "match",
                    this.input.serialize()
                ], t1 = Object.keys(this.cases).sort(), i = [], n = {};
                for (const e1 of t1){
                    const t1 = n[this.cases[e1]];
                    void 0 === t1 ? (n[this.cases[e1]] = i.length, i.push([
                        this.cases[e1],
                        [
                            e1
                        ]
                    ])) : i[t1][1].push(e1);
                }
                const r = (e1)=>"number" === this.inputType.kind ? Number(e1) : e1;
                for (const [t1, n] of i)e1.push(1 === n.length ? r(n[0]) : n.map(r)), e1.push(this.outputs[t1].serialize());
                return e1.push(this.otherwise.serialize()), e1;
            }
        }
        class ta {
            constructor(e1, t1, i){
                this.type = e1, this.branches = t1, this.otherwise = i;
            }
            static parse(e1, t1) {
                if (e1.length < 4) return t1.error(`Expected at least 3 arguments, but found only ${e1.length - 1}.`), null;
                if (e1.length % 2 != 0) return t1.error("Expected an odd number of arguments."), null;
                let i;
                t1.expectedType && "value" !== t1.expectedType.kind && (i = t1.expectedType);
                const n = [];
                for(let r = 1; r < e1.length - 1; r += 2){
                    const o = t1.parse(e1[r], r, En);
                    if (!o) return null;
                    const a = t1.parse(e1[r + 1], r + 1, i);
                    if (!a) return null;
                    n.push([
                        o,
                        a
                    ]), i = i || a.type;
                }
                const r = t1.parse(e1.at(-1), e1.length - 1, i);
                return r ? new ta(i, n, r) : null;
            }
            evaluate(e1) {
                for (const [t1, i] of this.branches)if (t1.evaluate(e1)) return i.evaluate(e1);
                return this.otherwise.evaluate(e1);
            }
            eachChild(e1) {
                for (const [t1, i] of this.branches)e1(t1), e1(i);
                e1(this.otherwise);
            }
            outputDefined() {
                return this.branches.every(([e1, t1])=>t1.outputDefined()) && this.otherwise.outputDefined();
            }
            serialize() {
                const e1 = [
                    "case"
                ];
                return this.eachChild((t1)=>{
                    e1.push(t1.serialize());
                }), e1;
            }
        }
        class ia {
            constructor(e1, t1, i, n){
                this.type = e1, this.input = t1, this.beginIndex = i, this.endIndex = n;
            }
            static parse(e1, t1) {
                if (e1.length <= 2 || e1.length >= 5) return t1.error(`Expected 3 or 4 arguments, but found ${e1.length - 1} instead.`), null;
                const i = t1.parse(e1[1], 1, Sn), n = t1.parse(e1[2], 2, wn);
                if (!i || !n) return null;
                if (r = i.type, ![
                    Pn(Sn),
                    An,
                    Sn
                ].some((e1)=>e1.kind === r.kind)) return t1.error(`Expected first argument to be of type array or string, but found ${Dn(i.type)} instead`), null;
                var r;
                if (4 === e1.length) {
                    const r = t1.parse(e1[3], 3, wn);
                    return r ? new ia(i.type, i, n, r) : null;
                }
                return new ia(i.type, i, n);
            }
            evaluate(e1) {
                const t1 = this.input.evaluate(e1), i = this.beginIndex.evaluate(e1);
                if (!On(t1, [
                    "string",
                    "array"
                ])) throw new Wn(`Expected first argument to be of type array or string, but found ${Dn(Hn(t1))} instead.`);
                if (this.endIndex) {
                    const n = this.endIndex.evaluate(e1);
                    return t1.slice(i, n);
                }
                return t1.slice(i);
            }
            eachChild(e1) {
                e1(this.input), e1(this.beginIndex), this.endIndex && e1(this.endIndex);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                if (null != this.endIndex && void 0 !== this.endIndex) {
                    const e1 = this.endIndex.serialize();
                    return [
                        "slice",
                        this.input.serialize(),
                        this.beginIndex.serialize(),
                        e1
                    ];
                }
                return [
                    "slice",
                    this.input.serialize(),
                    this.beginIndex.serialize()
                ];
            }
        }
        function na(e1, t1) {
            return "==" === e1 || "!=" === e1 ? "boolean" === t1.kind || "string" === t1.kind || "number" === t1.kind || "null" === t1.kind || "value" === t1.kind : "string" === t1.kind || "number" === t1.kind || "value" === t1.kind;
        }
        function ra(e1, t1, i, n) {
            return 0 === n.compare(t1, i);
        }
        function oa(e1, t1, i) {
            const n = "==" !== e1 && "!=" !== e1;
            return class r {
                constructor(e1, t1, i){
                    this.type = En, this.lhs = e1, this.rhs = t1, this.collator = i, this.hasUntypedArgument = "value" === e1.type.kind || "value" === t1.type.kind;
                }
                static parse(e1, t1) {
                    if (3 !== e1.length && 4 !== e1.length) return t1.error("Expected two or three arguments.");
                    const i = e1[0];
                    let o = t1.parse(e1[1], 1, Sn);
                    if (!o) return null;
                    if (!na(i, o.type)) return t1.error(`"${i}" comparisons are not supported for type '${Dn(o.type)}'.`, 1);
                    let a = t1.parse(e1[2], 2, Sn);
                    if (!a) return null;
                    if (!na(i, a.type)) return t1.error(`"${i}" comparisons are not supported for type '${Dn(a.type)}'.`, 2);
                    if (o.type.kind !== a.type.kind && "value" !== o.type.kind && "value" !== a.type.kind) return t1.error(`Cannot compare types '${Dn(o.type)}' and '${Dn(a.type)}'.`);
                    n && ("value" === o.type.kind && "value" !== a.type.kind ? o = new Xn(a.type, [
                        o
                    ]) : "value" !== o.type.kind && "value" === a.type.kind && (a = new Xn(o.type, [
                        a
                    ])));
                    let s = null;
                    if (4 === e1.length) {
                        if ("string" !== o.type.kind && "string" !== a.type.kind && "value" !== o.type.kind && "value" !== a.type.kind) return t1.error("Cannot use collator to compare non-string types.");
                        if (s = t1.parse(e1[3], 3, Tn), !s) return null;
                    }
                    return new r(o, a, s);
                }
                evaluate(r) {
                    const o = this.lhs.evaluate(r), a = this.rhs.evaluate(r);
                    if (n && this.hasUntypedArgument) {
                        const t1 = Hn(o), i = Hn(a);
                        if (t1.kind !== i.kind || "string" !== t1.kind && "number" !== t1.kind) throw new Wn(`Expected arguments for "${e1}" to be (string, string) or (number, number), but found (${t1.kind}, ${i.kind}) instead.`);
                    }
                    if (this.collator && !n && this.hasUntypedArgument) {
                        const e1 = Hn(o), i = Hn(a);
                        if ("string" !== e1.kind || "string" !== i.kind) return t1(r, o, a);
                    }
                    return this.collator ? i(r, o, a, this.collator.evaluate(r)) : t1(r, o, a);
                }
                eachChild(e1) {
                    e1(this.lhs), e1(this.rhs), this.collator && e1(this.collator);
                }
                outputDefined() {
                    return !0;
                }
                serialize() {
                    const t1 = [
                        e1
                    ];
                    return this.eachChild((e1)=>{
                        t1.push(e1.serialize());
                    }), t1;
                }
            };
        }
        const aa = oa("==", function(e1, t1, i) {
            return t1 === i;
        }, ra), sa = oa("!=", function(e1, t1, i) {
            return t1 !== i;
        }, function(e1, t1, i, n) {
            return !ra(0, t1, i, n);
        }), la = oa("<", function(e1, t1, i) {
            return t1 < i;
        }, function(e1, t1, i, n) {
            return n.compare(t1, i) < 0;
        }), ca = oa(">", function(e1, t1, i) {
            return t1 > i;
        }, function(e1, t1, i, n) {
            return n.compare(t1, i) > 0;
        }), ua = oa("<=", function(e1, t1, i) {
            return t1 <= i;
        }, function(e1, t1, i, n) {
            return n.compare(t1, i) <= 0;
        }), ha = oa(">=", function(e1, t1, i) {
            return t1 >= i;
        }, function(e1, t1, i, n) {
            return n.compare(t1, i) >= 0;
        });
        class da {
            constructor(e1, t1, i, n, r, o){
                this.type = An, this.number = e1, this.locale = t1, this.currency = i, this.unit = n, this.minFractionDigits = r, this.maxFractionDigits = o;
            }
            static parse(e1, t1) {
                if (3 !== e1.length) return t1.error("Expected two arguments.");
                const i = t1.parse(e1[1], 1, wn);
                if (!i) return null;
                const n = e1[2];
                if ("object" != typeof n || Array.isArray(n)) return t1.error("NumberFormat options argument must be an object.");
                let r = null;
                if (n.locale && (r = t1.parseObjectValue(n.locale, 2, "locale", An), !r)) return null;
                let o = null;
                if (n.currency && (o = t1.parseObjectValue(n.currency, 2, "currency", An), !o)) return null;
                let a = null;
                if (n.unit && (a = t1.parseObjectValue(n.unit, 2, "unit", An), !a)) return null;
                let s = null;
                if (void 0 !== n["min-fraction-digits"] && (s = t1.parseObjectValue(n["min-fraction-digits"], 2, "min-fraction-digits", wn), !s)) return null;
                let l = null;
                return void 0 === n["max-fraction-digits"] || (l = t1.parseObjectValue(n["max-fraction-digits"], 2, "max-fraction-digits", wn), l) ? new da(i, r, o, a, s, l) : null;
            }
            evaluate(e1) {
                return new Intl.NumberFormat(this.locale ? this.locale.evaluate(e1) : [], {
                    style: (this.currency ? "currency" : this.unit && "unit") || "decimal",
                    currency: this.currency ? this.currency.evaluate(e1) : void 0,
                    unit: this.unit ? this.unit.evaluate(e1) : void 0,
                    minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(e1) : void 0,
                    maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(e1) : void 0
                }).format(this.number.evaluate(e1));
            }
            eachChild(e1) {
                e1(this.number), this.locale && e1(this.locale), this.currency && e1(this.currency), this.unit && e1(this.unit), this.minFractionDigits && e1(this.minFractionDigits), this.maxFractionDigits && e1(this.maxFractionDigits);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const e1 = {};
                return this.locale && (e1.locale = this.locale.serialize()), this.currency && (e1.currency = this.currency.serialize()), this.unit && (e1.unit = this.unit.serialize()), this.minFractionDigits && (e1["min-fraction-digits"] = this.minFractionDigits.serialize()), this.maxFractionDigits && (e1["max-fraction-digits"] = this.maxFractionDigits.serialize()), [
                    "number-format",
                    this.number.serialize(),
                    e1
                ];
            }
        }
        class fa {
            constructor(e1){
                this.type = wn, this.input = e1;
            }
            static parse(e1, t1) {
                if (2 !== e1.length) return t1.error(`Expected 1 argument, but found ${e1.length - 1} instead.`), null;
                const i = t1.parse(e1[1], 1);
                return i ? "array" !== i.type.kind && "string" !== i.type.kind && "value" !== i.type.kind ? (t1.error(`Expected argument of type string or array, but found ${Dn(i.type)} instead.`), null) : new fa(i) : null;
            }
            evaluate(e1) {
                const t1 = this.input.evaluate(e1);
                if ("string" == typeof t1) return t1.length;
                if (Array.isArray(t1)) return t1.length;
                throw new Wn(`Expected value to be of type string or array, but found ${Dn(Hn(t1))} instead.`);
            }
            eachChild(e1) {
                e1(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const e1 = [
                    "length"
                ];
                return this.eachChild((t1)=>{
                    e1.push(t1.serialize());
                }), e1;
            }
        }
        function pa(e1) {
            return function() {
                e1 = 1831565813 + (e1 |= 0) | 0;
                let t1 = Math.imul(e1 ^ e1 >>> 15, 1 | e1);
                return t1 = t1 + Math.imul(t1 ^ t1 >>> 7, 61 | t1) ^ t1, ((t1 ^ t1 >>> 14) >>> 0) / 4294967296;
            };
        }
        const _a = Object.assign(Object.create(null), {
            "==": aa,
            "!=": sa,
            ">": ca,
            "<": la,
            ">=": ha,
            "<=": ua,
            array: Xn,
            at: Ko,
            "at-interpolated": Qo,
            boolean: Xn,
            case: ta,
            coalesce: Xo,
            collator: cr,
            format: Yn,
            image: Jn,
            interpolate: Wo,
            "interpolate-hcl": Wo,
            "interpolate-lab": Wo,
            length: fa,
            let: Jo,
            literal: Zn,
            match: ea,
            number: Xn,
            "number-format": da,
            object: Xn,
            slice: ia,
            step: To,
            string: Xn,
            "to-boolean": rr,
            "to-color": rr,
            "to-number": rr,
            "to-string": rr,
            var: wo,
            within: Ir,
            distance: bo,
            config: Pr
        });
        function ma(e1, [t1, i, n, r]) {
            t1 = t1.evaluate(e1), i = i.evaluate(e1), n = n.evaluate(e1);
            const o = r ? r.evaluate(e1) : 1, a = jn(t1, i, n, o);
            if (a) throw new Wn(a);
            return new fn(t1 / 255, i / 255, n / 255, o);
        }
        function ga(e1, [t1, i, n, r]) {
            t1 = t1.evaluate(e1), i = i.evaluate(e1), n = n.evaluate(e1);
            const o = r ? r.evaluate(e1) : 1, a = function(e1, t1, i, n) {
                return "number" == typeof e1 && e1 >= 0 && e1 <= 360 ? "number" == typeof t1 && t1 >= 0 && t1 <= 100 && "number" == typeof i && i >= 0 && i <= 100 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : `Invalid hsla value [${[
                    e1,
                    t1,
                    i,
                    n
                ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid hsla value [${("number" == typeof n ? [
                    e1,
                    t1,
                    i,
                    n
                ] : [
                    e1,
                    t1,
                    i
                ]).join(", ")}]: 's', and 'l' must be between 0 and 100.` : `Invalid hsla value [${("number" == typeof n ? [
                    e1,
                    t1,
                    i,
                    n
                ] : [
                    e1,
                    t1,
                    i
                ]).join(", ")}]: 'h' must be between 0 and 360.`;
            }(t1, i, n, o);
            if (a) throw new Wn(a);
            const s = `hsla(${t1}, ${i}%, ${n}%, ${o})`, l = fn.parse(s);
            if (!l) throw new Wn(`Failed to parse HSLA color: ${s}`);
            return l;
        }
        function ya(e1, t1) {
            return e1 in t1;
        }
        function xa(e1, t1) {
            const i = t1[e1];
            return void 0 === i ? null : i;
        }
        function va(e1) {
            return {
                type: e1
            };
        }
        function ba(e1, t1) {
            if (!On(e1, [
                "boolean",
                "string",
                "number",
                "null"
            ])) throw new Wn(`Expected first argument to be of type boolean, string, number or null, but found ${Dn(Hn(e1))} instead.`);
            if (!On(t1, [
                "string",
                "array"
            ])) throw new Wn(`Expected second argument to be of type array or string, but found ${Dn(Hn(t1))} instead.`);
        }
        sr.register(_a, {
            error: [
                {
                    kind: "error"
                },
                [
                    An
                ],
                (e1, [t1])=>{
                    throw new Wn(t1.evaluate(e1));
                }
            ],
            typeof: [
                An,
                [
                    Sn
                ],
                (e1, [t1])=>Dn(Hn(t1.evaluate(e1)))
            ],
            "to-rgba": [
                Pn(wn, 4),
                [
                    In
                ],
                (e1, [t1])=>t1.evaluate(e1).toNonPremultipliedRenderColor(null).toArray()
            ],
            "to-hsla": [
                Pn(wn, 4),
                [
                    In
                ],
                (e1, [t1])=>t1.evaluate(e1).toNonPremultipliedRenderColor(null).toHslaArray()
            ],
            rgb: [
                In,
                [
                    wn,
                    wn,
                    wn
                ],
                ma
            ],
            rgba: [
                In,
                [
                    wn,
                    wn,
                    wn,
                    wn
                ],
                ma
            ],
            hsl: [
                In,
                [
                    wn,
                    wn,
                    wn
                ],
                ga
            ],
            hsla: [
                In,
                [
                    wn,
                    wn,
                    wn,
                    wn
                ],
                ga
            ],
            has: {
                type: En,
                overloads: [
                    [
                        [
                            An
                        ],
                        (e1, [t1])=>ya(t1.evaluate(e1), e1.properties())
                    ],
                    [
                        [
                            An,
                            Mn
                        ],
                        (e1, [t1, i])=>ya(t1.evaluate(e1), i.evaluate(e1))
                    ]
                ]
            },
            get: {
                type: Sn,
                overloads: [
                    [
                        [
                            An
                        ],
                        (e1, [t1])=>xa(t1.evaluate(e1), e1.properties())
                    ],
                    [
                        [
                            An,
                            Mn
                        ],
                        (e1, [t1, i])=>xa(t1.evaluate(e1), i.evaluate(e1))
                    ]
                ]
            },
            "feature-state": [
                Sn,
                [
                    An
                ],
                (e1, [t1])=>xa(t1.evaluate(e1), e1.featureState || {})
            ],
            properties: [
                Mn,
                [],
                (e1)=>e1.properties()
            ],
            "geometry-type": [
                An,
                [],
                (e1)=>e1.geometryType()
            ],
            worldview: [
                An,
                [],
                (e1)=>e1.globals.worldview || ""
            ],
            "is-active-floor": [
                En,
                va(An),
                (e1, t1)=>{
                    if (!(e1.globals && e1.globals.activeFloors && e1.globals.activeFloors.size > 0)) return !1;
                    if (0 === t1.length) return !0;
                    const i = e1.globals.activeFloors;
                    return t1.some((t1)=>{
                        const n = t1.evaluate(e1);
                        return i.has(n);
                    });
                }
            ],
            id: [
                Sn,
                [],
                (e1)=>e1.id()
            ],
            zoom: [
                wn,
                [],
                (e1)=>e1.globals.zoom
            ],
            pitch: [
                wn,
                [],
                (e1)=>e1.globals.pitch || 0
            ],
            "distance-from-center": [
                wn,
                [],
                (e1)=>e1.distanceFromCenter()
            ],
            "measure-light": [
                wn,
                [
                    An
                ],
                (e1, [t1])=>e1.measureLight(t1.evaluate(e1))
            ],
            "heatmap-density": [
                wn,
                [],
                (e1)=>e1.globals.heatmapDensity || 0
            ],
            "line-progress": [
                wn,
                [],
                (e1)=>e1.globals.lineProgress || 0
            ],
            "raster-value": [
                wn,
                [],
                (e1)=>e1.globals.rasterValue || 0
            ],
            "raster-particle-speed": [
                wn,
                [],
                (e1)=>e1.globals.rasterParticleSpeed || 0
            ],
            "sky-radial-progress": [
                wn,
                [],
                (e1)=>e1.globals.skyRadialProgress || 0
            ],
            accumulated: [
                Sn,
                [],
                (e1)=>void 0 === e1.globals.accumulated ? null : e1.globals.accumulated
            ],
            "+": [
                wn,
                va(wn),
                (e1, t1)=>{
                    let i = 0;
                    for (const n of t1)i += n.evaluate(e1);
                    return i;
                }
            ],
            "*": [
                wn,
                va(wn),
                (e1, t1)=>{
                    let i = 1;
                    for (const n of t1)i *= n.evaluate(e1);
                    return i;
                }
            ],
            "-": {
                type: wn,
                overloads: [
                    [
                        [
                            wn,
                            wn
                        ],
                        (e1, [t1, i])=>t1.evaluate(e1) - i.evaluate(e1)
                    ],
                    [
                        [
                            wn
                        ],
                        (e1, [t1])=>-t1.evaluate(e1)
                    ]
                ]
            },
            "/": [
                wn,
                [
                    wn,
                    wn
                ],
                (e1, [t1, i])=>t1.evaluate(e1) / i.evaluate(e1)
            ],
            "%": [
                wn,
                [
                    wn,
                    wn
                ],
                (e1, [t1, i])=>t1.evaluate(e1) % i.evaluate(e1)
            ],
            ln2: [
                wn,
                [],
                ()=>Math.LN2
            ],
            pi: [
                wn,
                [],
                ()=>Math.PI
            ],
            e: [
                wn,
                [],
                ()=>Math.E
            ],
            "^": [
                wn,
                [
                    wn,
                    wn
                ],
                (e1, [t1, i])=>Math.pow(t1.evaluate(e1), i.evaluate(e1))
            ],
            sqrt: [
                wn,
                [
                    wn
                ],
                (e1, [t1])=>Math.sqrt(t1.evaluate(e1))
            ],
            log10: [
                wn,
                [
                    wn
                ],
                (e1, [t1])=>Math.log(t1.evaluate(e1)) / Math.LN10
            ],
            ln: [
                wn,
                [
                    wn
                ],
                (e1, [t1])=>Math.log(t1.evaluate(e1))
            ],
            log2: [
                wn,
                [
                    wn
                ],
                (e1, [t1])=>Math.log2(t1.evaluate(e1))
            ],
            sin: [
                wn,
                [
                    wn
                ],
                (e1, [t1])=>Math.sin(t1.evaluate(e1))
            ],
            cos: [
                wn,
                [
                    wn
                ],
                (e1, [t1])=>Math.cos(t1.evaluate(e1))
            ],
            tan: [
                wn,
                [
                    wn
                ],
                (e1, [t1])=>Math.tan(t1.evaluate(e1))
            ],
            asin: [
                wn,
                [
                    wn
                ],
                (e1, [t1])=>Math.asin(t1.evaluate(e1))
            ],
            acos: [
                wn,
                [
                    wn
                ],
                (e1, [t1])=>Math.acos(t1.evaluate(e1))
            ],
            atan: [
                wn,
                [
                    wn
                ],
                (e1, [t1])=>Math.atan(t1.evaluate(e1))
            ],
            min: [
                wn,
                va(wn),
                (e1, t1)=>Math.min(...t1.map((t1)=>t1.evaluate(e1)))
            ],
            max: [
                wn,
                va(wn),
                (e1, t1)=>Math.max(...t1.map((t1)=>t1.evaluate(e1)))
            ],
            abs: [
                wn,
                [
                    wn
                ],
                (e1, [t1])=>Math.abs(t1.evaluate(e1))
            ],
            round: [
                wn,
                [
                    wn
                ],
                (e1, [t1])=>{
                    const i = t1.evaluate(e1);
                    return i < 0 ? -Math.round(-i) : Math.round(i);
                }
            ],
            floor: [
                wn,
                [
                    wn
                ],
                (e1, [t1])=>Math.floor(t1.evaluate(e1))
            ],
            ceil: [
                wn,
                [
                    wn
                ],
                (e1, [t1])=>Math.ceil(t1.evaluate(e1))
            ],
            "filter-==": [
                En,
                [
                    An,
                    Sn
                ],
                (e1, [t1, i])=>e1.properties()[t1.value] === i.value
            ],
            "filter-id-==": [
                En,
                [
                    Sn
                ],
                (e1, [t1])=>e1.id() === t1.value
            ],
            "filter-type-==": [
                En,
                [
                    An
                ],
                (e1, [t1])=>e1.geometryType() === t1.value
            ],
            "filter-<": [
                En,
                [
                    An,
                    Sn
                ],
                (e1, [t1, i])=>{
                    const n = e1.properties()[t1.value], r = i.value;
                    return typeof n == typeof r && n < r;
                }
            ],
            "filter-id-<": [
                En,
                [
                    Sn
                ],
                (e1, [t1])=>{
                    const i = e1.id(), n = t1.value;
                    return typeof i == typeof n && i < n;
                }
            ],
            "filter->": [
                En,
                [
                    An,
                    Sn
                ],
                (e1, [t1, i])=>{
                    const n = e1.properties()[t1.value], r = i.value;
                    return typeof n == typeof r && n > r;
                }
            ],
            "filter-id->": [
                En,
                [
                    Sn
                ],
                (e1, [t1])=>{
                    const i = e1.id(), n = t1.value;
                    return typeof i == typeof n && i > n;
                }
            ],
            "filter-<=": [
                En,
                [
                    An,
                    Sn
                ],
                (e1, [t1, i])=>{
                    const n = e1.properties()[t1.value], r = i.value;
                    return typeof n == typeof r && n <= r;
                }
            ],
            "filter-id-<=": [
                En,
                [
                    Sn
                ],
                (e1, [t1])=>{
                    const i = e1.id(), n = t1.value;
                    return typeof i == typeof n && i <= n;
                }
            ],
            "filter->=": [
                En,
                [
                    An,
                    Sn
                ],
                (e1, [t1, i])=>{
                    const n = e1.properties()[t1.value], r = i.value;
                    return typeof n == typeof r && n >= r;
                }
            ],
            "filter-id->=": [
                En,
                [
                    Sn
                ],
                (e1, [t1])=>{
                    const i = e1.id(), n = t1.value;
                    return typeof i == typeof n && i >= n;
                }
            ],
            "filter-has": [
                En,
                [
                    Sn
                ],
                (e1, [t1])=>t1.value in e1.properties()
            ],
            "filter-has-id": [
                En,
                [],
                (e1)=>null !== e1.id() && void 0 !== e1.id()
            ],
            "filter-type-in": [
                En,
                [
                    Pn(An)
                ],
                (e1, [t1])=>t1.value.includes(e1.geometryType())
            ],
            "filter-id-in": [
                En,
                [
                    Pn(Sn)
                ],
                (e1, [t1])=>t1.value.includes(e1.id())
            ],
            "filter-in-small": [
                En,
                [
                    An,
                    Pn(Sn)
                ],
                (e1, [t1, i])=>i.value.includes(e1.properties()[t1.value])
            ],
            "filter-in-large": [
                En,
                [
                    An,
                    Pn(Sn)
                ],
                (e1, [t1, i])=>(function(e1, t1, i, n) {
                        for(; i <= n;){
                            const r = i + n >> 1;
                            if (t1[r] === e1) return !0;
                            t1[r] > e1 ? n = r - 1 : i = r + 1;
                        }
                        return !1;
                    })(e1.properties()[t1.value], i.value, 0, i.value.length - 1)
            ],
            all: {
                type: En,
                overloads: [
                    [
                        [
                            En,
                            En
                        ],
                        (e1, [t1, i])=>t1.evaluate(e1) && i.evaluate(e1)
                    ],
                    [
                        va(En),
                        (e1, t1)=>{
                            for (const i of t1)if (!i.evaluate(e1)) return !1;
                            return !0;
                        }
                    ]
                ]
            },
            any: {
                type: En,
                overloads: [
                    [
                        [
                            En,
                            En
                        ],
                        (e1, [t1, i])=>t1.evaluate(e1) || i.evaluate(e1)
                    ],
                    [
                        va(En),
                        (e1, t1)=>{
                            for (const i of t1)if (i.evaluate(e1)) return !0;
                            return !1;
                        }
                    ]
                ]
            },
            "!": [
                En,
                [
                    En
                ],
                (e1, [t1])=>!t1.evaluate(e1)
            ],
            "is-supported-script": [
                En,
                [
                    An
                ],
                (e1, [t1])=>{
                    const i = e1.globals && e1.globals.isSupportedScript;
                    return !i || i(t1.evaluate(e1));
                }
            ],
            upcase: [
                An,
                [
                    An
                ],
                (e1, [t1])=>t1.evaluate(e1).toUpperCase()
            ],
            downcase: [
                An,
                [
                    An
                ],
                (e1, [t1])=>t1.evaluate(e1).toLowerCase()
            ],
            concat: [
                An,
                va(Sn),
                (e1, t1)=>t1.map((t1)=>$n(t1.evaluate(e1))).join("")
            ],
            split: [
                Pn(An),
                [
                    An,
                    An
                ],
                (e1, [t1, i])=>t1.evaluate(e1).split(i.evaluate(e1))
            ],
            in: [
                En,
                [
                    Sn,
                    Sn
                ],
                (e1, [t1, i])=>{
                    const n = t1.evaluate(e1), r = i.evaluate(e1);
                    return null != r && (ba(n, r), r.includes(n));
                }
            ],
            "index-of": {
                type: wn,
                overloads: [
                    [
                        [
                            Sn,
                            Sn
                        ],
                        (e1, [t1, i])=>{
                            const n = t1.evaluate(e1), r = i.evaluate(e1);
                            return ba(n, r), r.indexOf(n);
                        }
                    ],
                    [
                        [
                            Sn,
                            Sn,
                            wn
                        ],
                        (e1, [t1, i, n])=>{
                            const r = t1.evaluate(e1), o = i.evaluate(e1), a = n.evaluate(e1);
                            return ba(r, o), o.indexOf(r, a);
                        }
                    ]
                ]
            },
            "resolved-locale": [
                An,
                [
                    Tn
                ],
                (e1, [t1])=>t1.evaluate(e1).resolvedLocale()
            ],
            random: [
                wn,
                [
                    wn,
                    wn,
                    Sn
                ],
                (e1, t1)=>{
                    const [i, n, r] = t1.map((t1)=>t1.evaluate(e1));
                    if (i > n) return i;
                    if (i === n) return i;
                    let o;
                    if ("string" == typeof r) o = function(e1) {
                        let t1 = 0;
                        if (0 === e1.length) return t1;
                        for(let i = 0; i < e1.length; i++)t1 = (t1 << 5) - t1 + e1.charCodeAt(i), t1 &= t1;
                        return t1;
                    }(r);
                    else {
                        if ("number" != typeof r) throw new Wn(`Invalid seed input: ${r}`);
                        o = r;
                    }
                    return i + pa(o)() * (n - i);
                }
            ]
        });
        const wa = new Set;
        function Aa(e1, t1) {
            if (e1 instanceof Pr) return t1.configDependencies === wa && (t1.configDependencies = new Set), void t1.configDependencies.add(e1.key);
            e1 instanceof sr && "is-active-floor" === e1.name && (t1.isIndoorDependent = !0), e1 instanceof Jn && (t1.isImageDependent = !0), e1.eachChild((e1)=>{
                Aa(e1, t1);
            });
        }
        function Ea(e1) {
            const t1 = {
                configDependencies: wa,
                isIndoorDependent: !1,
                isImageDependent: !1
            };
            return Aa(e1, t1), t1;
        }
        function Ia(e1) {
            return {
                result: "success",
                value: e1
            };
        }
        function Ma(e1) {
            return {
                result: "error",
                value: e1
            };
        }
        function Sa(e1, t1) {
            return !!e1 && !!e1.parameters && e1.parameters.includes(t1);
        }
        function Ta(e1) {
            return "data-driven" === e1["property-type"];
        }
        function za(e1) {
            return Sa(e1.expression, "measure-light");
        }
        function Ra(e1) {
            return Sa(e1.expression, "zoom");
        }
        function Pa(e1) {
            return !!e1.expression && e1.expression.interpolated;
        }
        function Da(e1) {
            return "object" == typeof e1 && null !== e1 && !Array.isArray(e1);
        }
        function Fa(e1) {
            return e1;
        }
        function Ca(e1, t1) {
            let i = e1;
            const n = "color" === t1.type, r = i.stops && "object" == typeof i.stops[0][0], o = r || !(r || void 0 !== i.property), a = i.type || (Pa(t1) ? "exponential" : "interval");
            if (n && (i = {
                ...i
            }, i.stops && (i.stops = i.stops.map((e1)=>[
                    e1[0],
                    fn.parse(e1[1])
                ])), i.default = fn.parse(i.default ? i.default : t1.default)), i.colorSpace && "rgb" !== i.colorSpace && !Zo[i.colorSpace]) throw new Error(`Unknown color space: ${i.colorSpace}`);
            let s, l, c;
            if ("exponential" === a) s = Va;
            else if ("interval" === a) s = Ba;
            else if ("categorical" === a) {
                s = La, l = Object.create(null);
                for (const e1 of i.stops)l[e1[0]] = e1[1];
                c = typeof i.stops[0][0];
            } else {
                if ("identity" !== a) throw new Error(`Unknown function type "${a}"`);
                s = Na;
            }
            if (r) {
                const e1 = {}, n = [];
                for(let t1 = 0; t1 < i.stops.length; t1++){
                    const r = i.stops[t1], o = r[0].zoom;
                    void 0 === e1[o] && (e1[o] = {
                        zoom: o,
                        type: i.type,
                        property: i.property,
                        default: i.default,
                        stops: []
                    }, n.push(o)), e1[o].stops.push([
                        r[0].value,
                        r[1]
                    ]);
                }
                const r = [];
                for (const i of n)r.push([
                    e1[i].zoom,
                    Ca(e1[i], t1)
                ]);
                const o = {
                    name: "linear"
                };
                return {
                    kind: "composite",
                    interpolationType: o,
                    interpolationFactor: Wo.interpolationFactor.bind(void 0, o),
                    zoomStops: r.map((e1)=>e1[0]),
                    evaluate: ({ zoom: e1 }, n)=>Va({
                            stops: r,
                            base: i.base
                        }, t1, e1).evaluate(e1, n)
                };
            }
            if (o) {
                const e1 = "exponential" === a ? {
                    name: "exponential",
                    base: void 0 !== i.base ? i.base : 1
                } : null;
                return {
                    kind: "camera",
                    interpolationType: e1,
                    interpolationFactor: Wo.interpolationFactor.bind(void 0, e1),
                    zoomStops: i.stops.map((e1)=>e1[0]),
                    evaluate: ({ zoom: e1 })=>s(i, t1, e1, l, c)
                };
            }
            return {
                kind: "source",
                evaluate (e1, n) {
                    const r = n && n.properties ? n.properties[i.property] : void 0;
                    return void 0 === r ? Oa(i.default, t1.default) : s(i, t1, r, l, c);
                }
            };
        }
        function Oa(e1, t1, i) {
            return void 0 !== e1 ? e1 : void 0 !== t1 ? t1 : void 0 !== i ? i : void 0;
        }
        function La(e1, t1, i, n, r) {
            return Oa(typeof i === r ? n[i] : void 0, e1.default, t1.default);
        }
        function Ba(e1, t1, i) {
            if (!tr(i)) return Oa(e1.default, t1.default);
            const n = e1.stops, r = n.length;
            if (1 === r) return n[0][1];
            if (i <= n[0][0]) return n[0][1];
            if (i >= n[r - 1][0]) return n[r - 1][1];
            const o = So(n.map((e1)=>e1[0]), i);
            return n[o][1];
        }
        function Va(e1, t1, i) {
            const n = void 0 !== e1.base ? e1.base : 1;
            if (!tr(i)) return Oa(e1.default, t1.default);
            const r = e1.stops, o = r.length;
            if (1 === o) return r[0][1];
            if (i <= r[0][0]) return r[0][1];
            if (i >= r[o - 1][0]) return r[o - 1][1];
            const a = So(r.map((e1)=>e1[0]), i), s = function(e1, t1, i, n) {
                const r = n - i, o = e1 - i;
                return 0 === r ? 0 : 1 === t1 ? o / r : (Math.pow(t1, o) - 1) / (Math.pow(t1, r) - 1);
            }(i, n, r[a][0], r[a + 1][0]), l = r[a][1], c = r[a + 1][1];
            let u = yn[t1.type] || Fa;
            if (e1.colorSpace && "rgb" !== e1.colorSpace) {
                const t1 = Zo[e1.colorSpace];
                u = (e1, i)=>t1.reverse(t1.interpolate(t1.forward(e1), t1.forward(i), s));
            }
            return "function" == typeof l.evaluate ? {
                evaluate (...e1) {
                    const t1 = l.evaluate.apply(void 0, e1), i = c.evaluate.apply(void 0, e1);
                    if (void 0 !== t1 && void 0 !== i) return u(t1, i, s);
                }
            } : u(l, c, s);
        }
        function Na(e1, t1, i) {
            return "color" === t1.type ? i = fn.parse(i) : "formatted" === t1.type ? i = Nn.fromString(i.toString()) : "resolvedImage" === t1.type ? i = Un.build(i.toString()) : Kn(i) === t1.type || "enum" === t1.type && t1.values[i] || (i = void 0), Oa(i, e1.default, t1.default);
        }
        class ka {
            constructor(e1, t1, i, n, r){
                this.expression = e1, this._warningHistory = {}, this._scope = i, this._options = n, this._iconImageUseTheme = r, this._evaluator = new ar(i, n, r), this._defaultValue = t1 ? function(e1) {
                    return "color" === e1.type && (Da(e1.default) || Array.isArray(e1.default)) ? new fn(0, 0, 0, 0) : "color" === e1.type ? fn.parse(e1.default) || null : void 0 === e1.default ? null : e1.default;
                }(t1) : null, this._enumValues = t1 && "enum" === t1.type ? t1.values : null;
                const o = Ea(e1);
                this.configDependencies = o.configDependencies, this.isIndoorDependent = o.isIndoorDependent, this.isImageDependent = o.isImageDependent;
            }
            evaluateWithoutErrorHandling(e1, t1, i, n, r, o, a, s) {
                const l = this._evaluator;
                return l.globals = e1, l.feature = t1, l.featureState = i, l.canonical = n || null, l.availableImages = r || null, l.formattedSection = o, l.featureTileCoord = a || null, l.featureDistanceData = s || null, this.expression.evaluate(l);
            }
            evaluate(e1, t1, i, n, r, o, a, s, l) {
                this._evaluator || (this._evaluator = new ar(this._scope, this._options, this._iconImageUseTheme)), this._evaluator.globals = e1, this._evaluator.feature = t1 || null, this._evaluator.featureState = i || null, this._evaluator.canonical = n || null, this._evaluator.availableImages = r || null, this._evaluator.formattedSection = o || null, this._evaluator.featureTileCoord = a || null, this._evaluator.featureDistanceData = s || null, this._evaluator.iconImageUseTheme = l || null;
                try {
                    const e1 = this.expression.evaluate(this._evaluator);
                    if (null == e1 || "number" == typeof e1 && e1 != e1) return this._defaultValue;
                    if (this._enumValues && !(e1 in this._enumValues)) throw new Wn(`Expected value to be one of ${Object.keys(this._enumValues).map((e1)=>JSON.stringify(e1)).join(", ")}, but found ${JSON.stringify(e1)} instead.`);
                    return e1;
                } catch (e1) {
                    const t1 = e1;
                    return this._warningHistory[t1.message] || (this._warningHistory[t1.message] = !0, "undefined" != typeof console && console.warn(`Failed to evaluate expression "${JSON.stringify(this.expression.serialize())}". ${t1.message}`)), this._defaultValue;
                }
            }
        }
        function Ua(e1) {
            return Array.isArray(e1) && e1.length > 0 && "string" == typeof e1[0] && Object.hasOwn(_a, e1[0]);
        }
        function ja(e1, t1, i, n, r) {
            const o = new Ao(_a, [], t1 ? function(e1) {
                const t1 = {
                    color: In,
                    string: An,
                    number: wn,
                    enum: An,
                    boolean: En,
                    formatted: zn,
                    resolvedImage: Rn,
                    object: Mn
                };
                return "array" === e1.type ? Pn(t1[e1.value] || Sn, e1.length) : t1[e1.type];
            }(t1) : void 0, void 0, void 0, i, n, r), a = o.parse(e1, void 0, void 0, void 0, t1 && "string" === t1.type ? {
                typeAnnotation: "coerce"
            } : void 0);
            return a ? Ia(new ka(a, t1, i, n, r)) : Ma(o.errors);
        }
        class Ga {
            constructor(e1, t1, i, n){
                this.kind = e1, this._styleExpression = t1, this.isLightConstant = i, this.isLineProgressConstant = n, this.isStateDependent = "constant" !== e1 && !Fr(t1.expression), this.configDependencies = t1.configDependencies, this.isIndoorDependent = t1.isIndoorDependent;
            }
            evaluateWithoutErrorHandling(e1, t1, i, n, r, o) {
                return this._styleExpression.evaluateWithoutErrorHandling(e1, t1, i, n, r, o);
            }
            evaluate(e1, t1, i, n, r, o, a) {
                return this._styleExpression.evaluate(e1, t1, i, n, r, o, void 0, void 0, a);
            }
        }
        class Ha {
            constructor(e1, t1, i, n, r, o){
                this.kind = e1, this.zoomStops = i, this._styleExpression = t1, this.isStateDependent = "camera" !== e1 && !Fr(t1.expression), this.isIndoorDependent = t1.isIndoorDependent, this.isLightConstant = r, this.isLineProgressConstant = o, this.configDependencies = t1.configDependencies, this.interpolationType = n;
            }
            evaluateWithoutErrorHandling(e1, t1, i, n, r, o) {
                return this._styleExpression.evaluateWithoutErrorHandling(e1, t1, i, n, r, o);
            }
            evaluate(e1, t1, i, n, r, o) {
                return this._styleExpression.evaluate(e1, t1, i, n, r, o);
            }
            interpolationFactor(e1, t1, i) {
                return this.interpolationType ? Wo.interpolationFactor(this.interpolationType, e1, t1, i) : 0;
            }
        }
        function $a(e1, t1, i, n, r) {
            const o = ja(e1, t1, i, n, r);
            if ("error" === o.result) return o;
            const a = o.value.expression, s = Dr(a);
            if (!s && !Ta(t1)) return Ma([
                new xn("", "data expressions not supported")
            ]);
            const l = Br(a), c = !(1 & l);
            if (!c && !Ra(t1)) return Ma([
                new xn("", "zoom expressions not supported")
            ]);
            const u = !(2 & l);
            if (!u && !za(t1)) return Ma([
                new xn("", "measure-light expression not supported")
            ]);
            const h = !(4 & l);
            if (!h && !function(e1) {
                return Sa(e1.expression, "line-progress");
            }(t1)) return Ma([
                new xn("", "line-progress expression not supported")
            ]);
            const d = t1.expression && t1.expression.relaxZoomRestriction, f = Wa(a);
            return f || c || d ? f instanceof xn ? Ma([
                f
            ]) : f instanceof Wo && !Pa(t1) ? Ma([
                new xn("", '"interpolate" expressions cannot be used with this property')
            ]) : Ia(f ? new Ha(s && h ? "camera" : "composite", o.value, f.labels, f instanceof Wo ? f.interpolation : void 0, u, h) : new Ga(s && h ? "constant" : "source", o.value, u, h)) : Ma([
                new xn("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression, or in the properties of atmosphere.')
            ]);
        }
        class Za {
            constructor(e1, t1){
                this._parameters = e1, this._specification = t1, Object.assign(this, Ca(this._parameters, this._specification));
            }
            static deserialize(e1) {
                return new Za(e1._parameters, e1._specification);
            }
            static serialize(e1) {
                return {
                    _parameters: e1._parameters,
                    _specification: e1._specification
                };
            }
        }
        function Wa(e1) {
            let t1 = null;
            if (e1 instanceof Jo) t1 = Wa(e1.result);
            else if (e1 instanceof Xo) {
                for (const i of e1.args)if (t1 = Wa(i), t1) break;
            } else (e1 instanceof To || e1 instanceof Wo) && e1.input instanceof sr && "zoom" === e1.input.name && (t1 = e1);
            return t1 instanceof xn || e1.eachChild((e1)=>{
                const i = Wa(e1);
                i instanceof xn ? t1 = i : t1 && i && t1 !== i && (t1 = new xn("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
            }), t1;
        }
        class qa {
            constructor(e1, t1, i){
                if (this.boxSeen = new Uint32Array(0), this.circleSeen = new Uint32Array(0), this.generation = 0, e1 instanceof ArrayBuffer) {
                    const t1 = new Int32Array(e1);
                    this.width = t1[0], this.height = t1[1], this.xCellCount = t1[2], this.yCellCount = t1[3], this.boxUid = t1[4], this.circleUid = t1[5];
                    const i = this.xCellCount * this.yCellCount;
                    let n = t1[t1[6 + i] + i];
                    this.boxCells = [], this.circleCells = [], this.cellData = t1, this.boxKeys = t1.subarray(n, n + this.boxUid), n += this.boxUid, this.circleKeys = t1.subarray(n, n + this.circleUid), n += this.circleUid, this.bboxes = t1.subarray(n, n + 4 * this.boxUid), n += 4 * this.boxUid, this.circles = t1.subarray(n, n + 3 * this.circleUid);
                } else {
                    this.width = e1, this.height = t1, this.xCellCount = Math.ceil(e1 / i), this.yCellCount = Math.ceil(t1 / i);
                    const n = this.xCellCount * this.yCellCount, r = [], o = [];
                    for(let e1 = 0; e1 < n; e1++)r.push([]), o.push([]);
                    this.boxCells = r, this.circleCells = o, this.cellData = null, this.boxKeys = [], this.circleKeys = [], this.bboxes = [], this.circles = [], this.boxUid = 0, this.circleUid = 0;
                }
                this.xScale = this.xCellCount / this.width, this.yScale = this.yCellCount / this.height;
            }
            keysLength() {
                return this.boxKeys.length + this.circleKeys.length;
            }
            clear() {
                for (const e1 of this.boxCells)e1.length = 0;
                for (const e1 of this.circleCells)e1.length = 0;
                this.circleKeys.length = 0, this.boxKeys.length = 0, this.bboxes.length = 0, this.circles.length = 0, this.boxUid = 0, this.circleUid = 0;
            }
            insert(e1, t1, i, n, r) {
                const o = this.boxUid++, a = this._xCell(t1), s = this._yCell(i), l = this._xCell(n), c = this._yCell(r);
                for(let e1 = a; e1 <= l; e1++)for(let t1 = s; t1 <= c; t1++)this.boxCells[this.xCellCount * t1 + e1].push(o);
                this.boxKeys.push(e1), this.bboxes.push(t1, i, n, r);
            }
            insertCircle(e1, t1, i, n) {
                const r = this.circleUid++, o = this._xCell(t1 - n), a = this._yCell(i - n), s = this._xCell(t1 + n), l = this._yCell(i + n);
                for(let e1 = o; e1 <= s; e1++)for(let t1 = a; t1 <= l; t1++)this.circleCells[this.xCellCount * t1 + e1].push(r);
                this.circleKeys.push(e1), this.circles.push(t1, i, n);
            }
            query(e1, t1, i, n, r) {
                const o = [];
                if (i < 0 || e1 > this.width || n < 0 || t1 > this.height) return o;
                const a = this._nextGen(), { boxCells: s, circleCells: l, boxKeys: c, circleKeys: u, bboxes: h, circles: d, boxSeen: f, circleSeen: p, xCellCount: _ } = this, m = this._xCell(e1), g = this._yCell(t1), y = this._xCell(i), x = this._yCell(n);
                for(let v = m; v <= y; v++)for(let m = g; m <= x; m++){
                    const g = _ * m + v, y = s[g];
                    for(let s = 0; s < y.length; s++){
                        const l = y[s];
                        if (f[l] === a) continue;
                        f[l] = a;
                        const u = 4 * l, d = h[u], p = h[u + 1], _ = h[u + 2], m = h[u + 3];
                        e1 <= _ && t1 <= m && i >= d && n >= p && (!r || r(c[l])) && o.push({
                            key: c[l],
                            x1: d,
                            y1: p,
                            x2: _,
                            y2: m
                        });
                    }
                    const x = l[g];
                    for(let s = 0; s < x.length; s++){
                        const l = x[s];
                        if (p[l] === a) continue;
                        p[l] = a;
                        const c = 3 * l, h = d[c], f = d[c + 1], _ = d[c + 2];
                        !this._circleAndRectCollide(h, f, _, e1, t1, i, n) || r && !r(u[l]) || o.push({
                            key: u[l],
                            x1: h - _,
                            y1: f - _,
                            x2: h + _,
                            y2: f + _
                        });
                    }
                }
                return o;
            }
            queryKeys(e1, t1, i, n, r) {
                const o = [];
                if (i < 0 || e1 > this.width || n < 0 || t1 > this.height) return o;
                const a = this._nextGen(), { boxCells: s, cellData: l, boxKeys: c, bboxes: u, boxSeen: h, xCellCount: d, xScale: f, yScale: p } = this, _ = this._xCell(e1), m = this._yCell(t1), g = this._xCell(i), y = this._yCell(n);
                for(let x = _; x <= g; x++)for(let _ = m; _ <= y; _++){
                    if (r && !r(x / f, _ / p, (x + 1) / f, (_ + 1) / p)) continue;
                    const m = d * _ + x, g = l || s[m], y = l ? l[6 + m + 1] : g.length;
                    for(let s = l ? l[6 + m] : 0; s < y; s++){
                        const l = g[s];
                        if (h[l] === a) continue;
                        h[l] = a;
                        const d = 4 * l, f = u[d], p = u[d + 1], _ = u[d + 2], m = u[d + 3];
                        (r ? r(f, p, _, m) : e1 <= _ && t1 <= m && i >= f && n >= p) && o.push(c[l]);
                    }
                }
                return o;
            }
            hitTest(e1, t1, i, n, r) {
                if (i < 0 || e1 > this.width || n < 0 || t1 > this.height) return !1;
                const o = this._nextGen(), { boxCells: a, circleCells: s, boxKeys: l, circleKeys: c, bboxes: u, circles: h, boxSeen: d, circleSeen: f, xCellCount: p } = this, _ = this._xCell(e1), m = this._yCell(t1), g = this._xCell(i), y = this._yCell(n);
                for(let x = _; x <= g; x++)for(let _ = m; _ <= y; _++){
                    const m = p * _ + x, g = a[m];
                    for(let a = 0; a < g.length; a++){
                        const s = g[a];
                        if (d[s] === o) continue;
                        d[s] = o;
                        const c = 4 * s;
                        if (e1 <= u[c + 2] && t1 <= u[c + 3] && i >= u[c] && n >= u[c + 1] && (!r || r(l[s]))) return !0;
                    }
                    const y = s[m];
                    for(let a = 0; a < y.length; a++){
                        const s = y[a];
                        if (f[s] === o) continue;
                        f[s] = o;
                        const l = 3 * s;
                        if (this._circleAndRectCollide(h[l], h[l + 1], h[l + 2], e1, t1, i, n) && (!r || r(c[s]))) return !0;
                    }
                }
                return !1;
            }
            hitTestCircle(e1, t1, i, n) {
                const r = e1 - i, o = t1 - i, a = e1 + i, s = t1 + i;
                if (a < 0 || r > this.width || s < 0 || o > this.height) return !1;
                const l = this._nextGen(), { boxCells: c, circleCells: u, boxKeys: h, circleKeys: d, bboxes: f, circles: p, boxSeen: _, circleSeen: m, xCellCount: g } = this, y = this._xCell(r), x = this._yCell(o), v = this._xCell(a), b = this._yCell(s);
                for(let r = y; r <= v; r++)for(let o = x; o <= b; o++){
                    const a = g * o + r, s = c[a];
                    for(let r = 0; r < s.length; r++){
                        const o = s[r];
                        if (_[o] === l) continue;
                        _[o] = l;
                        const a = 4 * o;
                        if (this._circleAndRectCollide(e1, t1, i, f[a], f[a + 1], f[a + 2], f[a + 3]) && (!n || n(h[o]))) return !0;
                    }
                    const y = u[a];
                    for(let r = 0; r < y.length; r++){
                        const o = y[r];
                        if (m[o] === l) continue;
                        m[o] = l;
                        const a = 3 * o;
                        if (this._circlesCollide(p[a], p[a + 1], p[a + 2], e1, t1, i) && (!n || n(d[o]))) return !0;
                    }
                }
                return !1;
            }
            static serialize(e1, t1) {
                const i = e1.toArrayBuffer();
                return t1 && t1.add(i), {
                    buffer: i
                };
            }
            static deserialize(e1) {
                return new qa(e1.buffer);
            }
            toArrayBuffer() {
                const e1 = this.xCellCount * this.yCellCount;
                let t1 = 0, i = 0;
                for(let n = 0; n < e1; n++)t1 += this.boxCells[n].length, i += this.circleCells[n].length;
                const n = new Int32Array(6 + (e1 + 1) + t1 + (e1 + 1) + i + this.boxUid + this.circleUid + 4 * this.boxUid + 3 * this.circleUid);
                n[0] = this.width, n[1] = this.height, n[2] = this.xCellCount, n[3] = this.yCellCount, n[4] = this.boxUid, n[5] = this.circleUid;
                let r = 6 + (e1 + 1);
                for(let t1 = 0; t1 < e1; t1++){
                    n[6 + t1] = r;
                    const e1 = this.boxCells[t1];
                    n.set(e1, r), r += e1.length;
                }
                n[6 + e1] = r;
                const o = r;
                r += e1 + 1;
                for(let t1 = 0; t1 < e1; t1++){
                    n[o + t1] = r;
                    const e1 = this.circleCells[t1];
                    n.set(e1, r), r += e1.length;
                }
                return n[o + e1] = r, n.set(this.boxKeys, r), r += this.boxUid, n.set(this.circleKeys, r), r += this.circleUid, n.set(this.bboxes, r), r += 4 * this.boxUid, n.set(this.circles, r), n.buffer;
            }
            _xCell(e1) {
                return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(e1 * this.xScale)));
            }
            _yCell(e1) {
                return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(e1 * this.yScale)));
            }
            _nextGen() {
                return this.boxSeen.length < this.boxUid && (this.boxSeen = new Uint32Array(this.boxUid)), this.circleSeen.length < this.circleUid && (this.circleSeen = new Uint32Array(this.circleUid)), this.generation = this.generation + 1 >>> 0, 0 === this.generation && (this.boxSeen.fill(0), this.circleSeen.fill(0), this.generation = 1), this.generation;
            }
            _circlesCollide(e1, t1, i, n, r, o) {
                const a = n - e1, s = r - t1, l = i + o;
                return l * l > a * a + s * s;
            }
            _circleAndRectCollide(e1, t1, i, n, r, o, a) {
                const s = (o - n) / 2, l = Math.abs(e1 - (n + s));
                if (l > s + i) return !1;
                const c = (a - r) / 2, u = Math.abs(t1 - (r + c));
                if (u > c + i) return !1;
                if (l <= s || u <= c) return !0;
                const h = l - s, d = u - c;
                return h * h + d * d <= i * i;
            }
        }
        const Xa = {};
        function Ya(e1, t1, i = {}) {
            Object.defineProperty(e1, "_classRegistryKey", {
                value: t1,
                writable: !1
            }), Xa[t1] = {
                klass: e1,
                omit: i.omit || []
            };
        }
        Ya(Object, "Object"), Ya(qa, "Grid"), delete Re.prototype.constructor, Ya(fn, "Color"), Ya(Nn, "Formatted"), Ya(Vn, "FormattedSection"), Ya(Un, "ResolvedImage"), Ya(Za, "StylePropertyFunction"), Ya(ka, "StyleExpression", {
            omit: [
                "_evaluator"
            ]
        }), Ya(sn, "ImageId"), Ya(kn, "ImageVariant"), Ya(Ha, "ZoomDependentExpression"), Ya(Ga, "ZoomConstantExpression"), Ya(sr, "CompoundExpression", {
            omit: [
                "_evaluate"
            ]
        });
        for(const e1 in _a)Xa[_a[e1]._classRegistryKey] || Ya(_a[e1], `Expression${e1}`);
        function Ja(e1) {
            return e1 && (e1 instanceof ArrayBuffer || e1.constructor && "ArrayBuffer" === e1.constructor.name);
        }
        const Ka = {
            Error: Error,
            TypeError: TypeError,
            RangeError: RangeError,
            SyntaxError: SyntaxError,
            ReferenceError: ReferenceError,
            URIError: URIError,
            EvalError: EvalError
        }, Qa = new Set([
            "message",
            "stack",
            "cause",
            "errors",
            "name",
            "class"
        ]);
        function es(e1, t1) {
            if (null === e1) return null;
            if ("object" != typeof e1) return e1;
            if (Array.isArray(e1)) {
                const i = e1.length, n = [];
                n.length = i;
                for(let r = 0; r < i; r++)n[r] = es(e1[r], t1);
                return n;
            }
            const i = e1.constructor || Object, n = i._classRegistryKey;
            if (!n) {
                if (ArrayBuffer.isView(e1)) return t1 && t1.add(e1.buffer), e1;
                if (Ja(e1) || e1 instanceof ImageBitmap) return t1 && t1.add(e1), e1;
                if (e1 instanceof ImageData) return t1 && t1.add(e1.data.buffer), e1;
                if (e1 instanceof Map) {
                    const i = {
                        $name: "Map",
                        entries: []
                    };
                    for (const [n, r] of e1.entries())i.entries.push(es(n), es(r, t1));
                    return i;
                }
                if (e1 instanceof Headers) return {
                    $name: "Headers",
                    entries: [
                        ...e1
                    ]
                };
                if (e1 instanceof Set) {
                    const t1 = {
                        $name: "Set"
                    };
                    let i = 0;
                    for (const n of e1.values())t1[++i] = es(n);
                    return t1;
                }
                if (e1 instanceof Date || e1 instanceof RegExp || e1 instanceof Boolean || e1 instanceof Number || e1 instanceof String) return e1;
                if (e1 instanceof Error) {
                    const i = e1, n = i.constructor && i.constructor.name || "Error", r = {
                        $name: "$Error",
                        class: i instanceof ai ? "AJAXError" : i instanceof DOMException ? "DOMException" : i instanceof AggregateError ? "AggregateError" : Ka[n] ? n : "Error",
                        name: i.name,
                        message: i.message
                    };
                    i.stack && (r.stack = i.stack), "cause" in i && i.cause !== i && (r.cause = es(i.cause, t1)), i instanceof AggregateError && (r.errors = i.errors.filter((e1)=>e1 !== i).map((e1)=>es(e1, t1)));
                    const o = i;
                    for(const e1 in o)Object.hasOwn(o, e1) && (Qa.has(e1) || (r[e1] = es(o[e1], t1)));
                    return r;
                }
                throw new Error(`Can't serialize object of unregistered class "${i.name}".`);
            }
            const r = i.serialize ? i.serialize(e1, t1) : {};
            if (null === r) return null;
            if (!i.serialize) {
                const i = Xa[n].omit, o = e1;
                for(const e1 in o)Object.hasOwn(o, e1) && (i.includes(e1) || (r[e1] = es(o[e1], t1)));
            }
            if (r.$name) throw new Error("$name property is reserved for worker serialization logic.");
            return "Object" !== n && (r.$name = n), r;
        }
        function ts(e1) {
            if (null === e1 || "object" != typeof e1) return e1;
            if (Array.isArray(e1)) {
                for(let t1 = 0; t1 < e1.length; t1++)e1[t1] = ts(e1[t1]);
                return e1;
            }
            if (ArrayBuffer.isView(e1) || Ja(e1) || e1 instanceof ImageBitmap || e1 instanceof ImageData || e1 instanceof Date || e1 instanceof RegExp || e1 instanceof Boolean || e1 instanceof Number || e1 instanceof String) return e1;
            const t1 = e1.$name || "Object";
            if ("Map" === t1) {
                const t1 = e1.entries || [], i = new Map;
                for(let e1 = 0; e1 < t1.length; e1 += 2)i.set(ts(t1[e1]), ts(t1[e1 + 1]));
                return i;
            }
            if ("Headers" === t1) return new Headers(e1.entries);
            if ("Set" === t1) {
                const t1 = new Set;
                for(const i in e1)"$name" !== i && t1.add(ts(e1[i]));
                return t1;
            }
            if ("$Error" === t1) {
                const t1 = e1.class || "Error", i = e1.name || t1, n = e1.message || "";
                let r;
                r = "DOMException" === t1 ? new DOMException(n, i) : "AggregateError" === t1 ? new AggregateError((e1.errors || []).map(ts), n) : "AJAXError" === t1 ? new ai(e1.statusText, e1.status, e1.url) : new (Ka[t1] || Error)(n), "DOMException" !== t1 && (r.name = i), e1.stack && (r.stack = e1.stack), "cause" in e1 && (r.cause = ts(e1.cause));
                const o = r;
                for(const t1 in e1)Object.hasOwn(e1, t1) && ("$name" === t1 || Qa.has(t1) || (o[t1] = ts(e1[t1])));
                return r;
            }
            if ("Object" === t1) {
                for(const t1 in e1)e1[t1] = ts(e1[t1]);
                return e1;
            }
            const i = Xa[t1]?.klass;
            if (!i) throw new Error(`Can't deserialize unregistered class "${t1}".`);
            if (i.deserialize) return i.deserialize(e1);
            const n = Object.create(i.prototype);
            for(const t1 in e1)"$name" !== t1 && (n[t1] = ts(e1[t1]));
            return n;
        }
        const is = (e1)=>e1 >= 1536 && e1 <= 1791, ns = (e1)=>e1 >= 1872 && e1 <= 1919, rs = (e1)=>e1 >= 2208 && e1 <= 2303, os = (e1)=>e1 >= 11904 && e1 <= 12031, as = (e1)=>e1 >= 12032 && e1 <= 12255, ss = (e1)=>e1 >= 12272 && e1 <= 12287, ls = (e1)=>e1 >= 12288 && e1 <= 12351, cs = (e1)=>e1 >= 12352 && e1 <= 12447, us = (e1)=>e1 >= 12448 && e1 <= 12543, hs = (e1)=>e1 >= 12544 && e1 <= 12591, ds = (e1)=>e1 >= 12704 && e1 <= 12735, fs = (e1)=>e1 >= 12736 && e1 <= 12783, ps = (e1)=>e1 >= 12784 && e1 <= 12799, _s = (e1)=>e1 >= 12800 && e1 <= 13055, ms = (e1)=>e1 >= 13056 && e1 <= 13311, gs = (e1)=>e1 >= 13312 && e1 <= 19903, ys = (e1)=>e1 >= 19968 && e1 <= 40959, xs = (e1)=>e1 >= 40960 && e1 <= 42127, vs = (e1)=>e1 >= 42128 && e1 <= 42191, bs = (e1)=>e1 >= 44032 && e1 <= 55215, ws = (e1)=>e1 >= 63744 && e1 <= 64255, As = (e1)=>e1 >= 64336 && e1 <= 65023, Es = (e1)=>e1 >= 65040 && e1 <= 65055, Is = (e1)=>e1 >= 65072 && e1 <= 65103, Ms = (e1)=>e1 >= 65104 && e1 <= 65135, Ss = (e1)=>e1 >= 65136 && e1 <= 65279, Ts = (e1)=>e1 >= 65280 && e1 <= 65519;
        function zs(e1) {
            for (const t1 of e1)if (Ps(t1.charCodeAt(0))) return !0;
            return !1;
        }
        function Rs(e1) {
            return !(is(e1) || ns(e1) || rs(e1) || As(e1) || Ss(e1));
        }
        function Ps(e1) {
            return !(746 !== e1 && 747 !== e1 && (e1 < 4352 || !(ds(e1) || hs(e1) || Is(e1) && !(e1 >= 65097 && e1 <= 65103) || ws(e1) || ms(e1) || os(e1) || fs(e1) || !(!ls(e1) || e1 >= 12296 && e1 <= 12305 || e1 >= 12308 && e1 <= 12319 || 12336 === e1) || gs(e1) || ys(e1) || _s(e1) || ((e1)=>e1 >= 12592 && e1 <= 12687)(e1) || ((e1)=>e1 >= 43360 && e1 <= 43391)(e1) || ((e1)=>e1 >= 55216 && e1 <= 55295)(e1) || ((e1)=>e1 >= 4352 && e1 <= 4607)(e1) || bs(e1) || cs(e1) || ss(e1) || ((e1)=>e1 >= 12688 && e1 <= 12703)(e1) || as(e1) || ps(e1) || us(e1) && 12540 !== e1 || !(!Ts(e1) || 65288 === e1 || 65289 === e1 || 65293 === e1 || e1 >= 65306 && e1 <= 65310 || 65339 === e1 || 65341 === e1 || 65343 === e1 || e1 >= 65371 && e1 <= 65503 || 65507 === e1 || e1 >= 65512 && e1 <= 65519) || !(!Ms(e1) || e1 >= 65112 && e1 <= 65118 || e1 >= 65123 && e1 <= 65126) || ((e1)=>e1 >= 5120 && e1 <= 5759)(e1) || ((e1)=>e1 >= 6320 && e1 <= 6399)(e1) || Es(e1) || ((e1)=>e1 >= 19904 && e1 <= 19967)(e1) || xs(e1) || vs(e1))));
        }
        function Ds(e1) {
            return !(Ps(e1) || function(e1) {
                return !!(((e1)=>e1 >= 128 && e1 <= 255)(e1) && (167 === e1 || 169 === e1 || 174 === e1 || 177 === e1 || 188 === e1 || 189 === e1 || 190 === e1 || 215 === e1 || 247 === e1) || ((e1)=>e1 >= 8192 && e1 <= 8303)(e1) && (8214 === e1 || 8224 === e1 || 8225 === e1 || 8240 === e1 || 8241 === e1 || 8251 === e1 || 8252 === e1 || 8258 === e1 || 8263 === e1 || 8264 === e1 || 8265 === e1 || 8273 === e1) || ((e1)=>e1 >= 8448 && e1 <= 8527)(e1) || ((e1)=>e1 >= 8528 && e1 <= 8591)(e1) || ((e1)=>e1 >= 8960 && e1 <= 9215)(e1) && (e1 >= 8960 && e1 <= 8967 || e1 >= 8972 && e1 <= 8991 || e1 >= 8996 && e1 <= 9e3 || 9003 === e1 || e1 >= 9085 && e1 <= 9114 || e1 >= 9150 && e1 <= 9165 || 9167 === e1 || e1 >= 9169 && e1 <= 9179 || e1 >= 9186 && e1 <= 9215) || ((e1)=>e1 >= 9216 && e1 <= 9279)(e1) && 9251 !== e1 || ((e1)=>e1 >= 9280 && e1 <= 9311)(e1) || ((e1)=>e1 >= 9312 && e1 <= 9471)(e1) || ((e1)=>e1 >= 9632 && e1 <= 9727)(e1) || ((e1)=>e1 >= 9728 && e1 <= 9983)(e1) && !(e1 >= 9754 && e1 <= 9759) || ((e1)=>e1 >= 11008 && e1 <= 11263)(e1) && (e1 >= 11026 && e1 <= 11055 || e1 >= 11088 && e1 <= 11097 || e1 >= 11192 && e1 <= 11243) || ls(e1) || us(e1) || ((e1)=>e1 >= 57344 && e1 <= 63743)(e1) || Is(e1) || Ms(e1) || Ts(e1) || 8734 === e1 || 8756 === e1 || 8757 === e1 || e1 >= 9984 && e1 <= 10087 || e1 >= 10102 && e1 <= 10131 || 65532 === e1 || 65533 === e1);
            }(e1));
        }
        function Fs(e1) {
            return e1 >= 1424 && e1 <= 2303 || As(e1) || Ss(e1);
        }
        function Cs(e1) {
            return !(e1 >= 2304 && e1 <= 3583 || e1 >= 3840 && e1 <= 4255 || ((e1)=>e1 >= 6016 && e1 <= 6143)(e1));
        }
        function Os(e1) {
            for (const t1 of e1)if (Fs(t1.charCodeAt(0))) return !0;
            return !1;
        }
        class Ls {
            constructor(e1, t1){
                this.zoom = e1, t1 ? (this.now = t1.now, this.fadeDuration = t1.fadeDuration, this.transition = t1.transition, this.pitch = t1.pitch, this.brightness = t1.brightness, this.worldview = t1.worldview, this.activeFloors = t1.activeFloors) : (this.now = 0, this.fadeDuration = 0, this.transition = {}, this.pitch = 0, this.brightness = 0);
            }
            isSupportedScript(e1) {
                return function(e1) {
                    for (const t1 of e1)if (!Cs(t1.charCodeAt(0))) return !1;
                    return !0;
                }(e1);
            }
        }
        class Bs {
            constructor(e1, t1, i, n, r){
                this.property = e1, this.value = t1, this.expression = function(e1, t1, i, n, r) {
                    if (Da(e1)) return new Za(e1, t1);
                    if (Ua(e1) || Array.isArray(e1) && e1.length > 0) {
                        const o = $a(e1, t1, i, n, r);
                        if ("error" === o.result) throw new Error(o.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
                        return o.value;
                    }
                    {
                        let i = e1;
                        return "string" == typeof e1 && "color" === t1.type && (i = fn.parse(e1)), {
                            kind: "constant",
                            configDependencies: new Set,
                            isIndoorDependent: !1,
                            evaluate: ()=>i
                        };
                    }
                }(void 0 === t1 ? e1.specification.default : t1, e1.specification, i, n, r);
                const { kind: o } = this.expression, a = e1.specification.type, s = this.expression._styleExpression;
                this.deps = ("camera" === o || "composite" === o ? 1 : 0) | (!1 === this.expression.isLightConstant ? 2 : 0) | ("constant" !== o && "camera" !== o || !("resolvedImage" === a || "formatted" === a || s && s.isImageDependent) ? 0 : 4);
            }
            isIndoorDependent() {
                return this.expression.isIndoorDependent;
            }
            isDataDriven() {
                return "source" === this.expression.kind || "composite" === this.expression.kind;
            }
            possiblyEvaluate(e1, t1, i, n) {
                return this.property.possiblyEvaluate(this, e1, t1, i, n);
            }
        }
        function Vs(e1, t1, i, n, r) {
            const o = t1.now || 0, a = e1.value.possiblyEvaluate(t1, i, n, r), s = e1.prior;
            if (s) {
                if (o > e1.end) return e1.prior = null, a;
                if (e1.value.isDataDriven()) return e1.prior = null, a;
                if (o < e1.begin) return Vs(s, t1, i, n, r);
                {
                    const l = (o - e1.begin) / (e1.end - e1.begin);
                    return e1.value.property.interpolate(Vs(s, t1, i, n, r), a, Qe(l));
                }
            }
            return a;
        }
        class Ns {
            constructor(e1, t1, i, n){
                this.property = e1, this.value = new Bs(e1, void 0, t1, i, n), this.state = {
                    value: this.value,
                    prior: null,
                    begin: 0,
                    end: 0
                }, this.evaluated = void 0, this.evaluatedFrom = null;
            }
        }
        class ks {
            constructor(e1, t1, i, n){
                this._properties = e1, this._values = Object.create(e1.defaultPropertyValues), this._scope = t1, this._options = i, this._iconImageUseTheme = n, this._isIndoorDependent = !1, this.configDependencies = new Set, this.deps = 0, this._hasTransition = !1;
            }
            getValue(e1) {
                return dt(this._values[e1].value.value);
            }
            setValue(e1, t1) {
                Object.hasOwn(this._values, e1) || (this._values[e1] = new Ns(this._values[e1].property, this._scope, this._options, this._iconImageUseTheme));
                const i = this._values[e1], n = new Bs(i.property, null === t1 ? void 0 : dt(t1), this._scope, this._options, this._iconImageUseTheme);
                if (i.value = n, i.property.specification.transition || (i.state = {
                    value: n,
                    prior: null,
                    begin: 0,
                    end: 0
                }), this.deps |= n.deps, n.expression.configDependencies) {
                    for (const e1 of n.expression.configDependencies)this.configDependencies.add(e1);
                    this._isIndoorDependent = this._isIndoorDependent || n.isIndoorDependent();
                }
            }
            setTransitionOrValue(e1, t1) {
                t1 && (this._options = t1);
                const i = this._properties.properties;
                if (e1) for(const t1 in e1){
                    const n = e1[t1];
                    if (t1.endsWith("-transition")) {
                        const e1 = t1.slice(0, -11);
                        i[e1] && this.setTransition(e1, n);
                    } else Object.hasOwn(i, t1) && this.setValue(t1, n);
                }
            }
            getTransition(e1) {
                return dt(this._values[e1].transition);
            }
            setTransition(e1, t1) {
                Object.hasOwn(this._values, e1) || (this._values[e1] = new Ns(this._values[e1].property)), this._values[e1].transition = dt(t1) || void 0;
            }
            serialize() {
                const e1 = {};
                for (const t1 of Object.keys(this._values)){
                    const i = this.getValue(t1);
                    void 0 !== i && (e1[t1] = i);
                    const n = this.getTransition(t1);
                    void 0 !== n && (e1[`${t1}-transition`] = n);
                }
                return e1;
            }
            updateTransitions(e1) {
                const t1 = e1.now || 0;
                for (const i of Object.values(this._values)){
                    if (i.value === i.state.value) continue;
                    const n = {
                        ...e1.transition,
                        ...i.transition
                    }, r = t1 + (n.delay || 0), o = n.delay || n.duration ? i.state : null;
                    i.state = {
                        value: i.value,
                        prior: o,
                        begin: r,
                        end: r + (n.duration || 0)
                    }, o && (this._hasTransition = !0);
                }
            }
            snap() {
                for (const e1 of Object.values(this._values))e1.state = {
                    value: e1.value,
                    prior: null,
                    begin: 0,
                    end: 0
                };
                this._hasTransition = !1;
            }
            hasTransition() {
                return this._hasTransition;
            }
            possiblyEvaluate(e1, t1, i, n, r) {
                const o = new js(this._properties);
                let a = !1;
                for (const s of Object.keys(this._values)){
                    const l = this._values[s], c = l.state;
                    (void 0 === r || c.prior || l.evaluatedFrom !== c.value || c.value.deps & r) && (l.evaluated = Vs(c, e1, t1, i, n), l.evaluatedFrom = c.value, c.prior && (a = !0)), o._values[s] = l.evaluated;
                }
                return this._hasTransition = a, o;
            }
            isIndoorDependent() {
                return this._isIndoorDependent;
            }
        }
        class Us {
            constructor(e1, t1, i, n){
                this.property = e1, this.value = t1, this.parameters = i, this.iconImageUseTheme = n;
            }
            isConstant() {
                return "constant" === this.value.kind;
            }
            constantOr(e1) {
                return "constant" === this.value.kind ? this.value.value : e1;
            }
            evaluate(e1, t1, i, n, r) {
                return this.property.evaluate(this.value, this.parameters, e1, t1, i, n, this.iconImageUseTheme, r);
            }
        }
        class js {
            constructor(e1){
                this._properties = e1, this._values = Object.create(e1.defaultPossiblyEvaluatedValues);
            }
            get(e1) {
                return this._values[e1];
            }
        }
        class Gs {
            constructor(e1){
                this.specification = e1;
            }
            possiblyEvaluate(e1, t1) {
                return e1.expression.evaluate(t1);
            }
            interpolate(e1, t1, i) {
                const n = yn[this.specification.type];
                return n ? n(e1, t1, i) : e1;
            }
        }
        class Hs {
            constructor(e1, t1){
                this.specification = e1, this.overrides = t1;
            }
            possiblyEvaluate(e1, t1, i, n, r) {
                return "constant" === e1.expression.kind || "camera" === e1.expression.kind ? new Us(this, {
                    kind: "constant",
                    value: e1.expression.evaluate(t1, null, {}, i, n, void 0, r)
                }, t1) : new Us(this, e1.expression, t1, r);
            }
            interpolate(e1, t1, i) {
                if ("constant" !== e1.value.kind || "constant" !== t1.value.kind) return e1;
                if (void 0 === e1.value.value || void 0 === t1.value.value) return new Us(this, {
                    kind: "constant",
                    value: void 0
                }, e1.parameters);
                const n = yn[this.specification.type];
                return n ? new Us(this, {
                    kind: "constant",
                    value: n(e1.value.value, t1.value.value, i)
                }, e1.parameters) : e1;
            }
            evaluate(e1, t1, i, n, r, o, a, s) {
                return "constant" === e1.kind ? e1.value : e1.evaluate(t1, i, n, r, o, s, a);
            }
        }
        class $s {
            constructor(e1){
                this.specification = e1;
            }
            possiblyEvaluate(e1, t1, i, n) {
                return !!e1.expression.evaluate(t1, null, {}, i, n);
            }
            interpolate() {
                return !1;
            }
        }
        class Zs {
            constructor(e1){
                this.properties = e1, this.defaultPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
                const t1 = new Ls(0, {});
                for(const i in e1){
                    const n = e1[i], r = n.specification;
                    r && r.overridable && this.overridableProperties.push(i);
                    const o = this.defaultPropertyValues[i] = new Ns(n);
                    this.defaultPossiblyEvaluatedValues[i] = o.value.possiblyEvaluate(t1);
                }
            }
        }
        Ya(Hs, "DataDrivenProperty"), Ya(Gs, "DataConstantProperty"), Ya($s, "ColorRampProperty");
        var Ws = JSON.parse('{"expression":1,"transition":{"duration":{"type":"number","default":300,"minimum":0},"delay":{"type":"number","default":0,"minimum":0}},"appearance":{"condition":{"type":"boolean","expression":{"interpolated":1,"parameters":["distance-from-center","feature","feature-state","measure-light","pitch","zoom"]},"property-type":"data-driven"},"name":{"type":"string"},"properties":{"type":"*"}},"function":{"type":{"type":"enum","default":"exponential","values":{"identity":1,"exponential":1,"interval":1,"categorical":1}},"default":{"type":"*"},"expression":1,"stops":{"type":"array","value":"function_stop"},"base":{"type":"number","default":1,"minimum":0},"property":{"type":"string","default":"$zoom"},"colorSpace":{"type":"enum","default":"rgb","values":{"rgb":1,"lab":1,"hcl":1}}},"$version":8,"$root":{"transition":{"type":"transition"},"version":{"type":"enum","values":[8]},"fragment":{"type":"boolean"},"name":{"type":"string"},"metadata":{"type":"*"},"center":{"type":"array","value":"number"},"zoom":{"type":"number"},"bearing":{"type":"number","default":0},"pitch":{"type":"number","default":0},"light":{"type":"light"},"lights":{"type":"array","value":"light-3d"},"terrain":{"type":"terrain","optional":true},"fog":{"type":"fog"},"snow":{"type":"snow"},"rain":{"type":"rain"},"camera":{"type":"camera"},"color-theme":{"type":"colorTheme"},"indoor":{"type":"indoor"},"imports":{"type":"array","value":"import"},"iconsets":{"type":"iconsets"},"schema":{"type":"schema"},"sources":{"type":"sources"},"sprite":{"type":"string"},"glyphs":{"type":"string","default":"mapbox://fonts/mapbox/{fontstack}/{range}.pbf"},"projection":{"type":"projection"},"layers":{"type":"array","value":"layer"},"models":{"type":"models"},"featuresets":{"type":"featuresets"}},"featuresets":{"*":{"type":"featureset"}},"featureset":{"metadata":{"type":"*"},"selectors":{"type":"array","value":"selector"}},"selector":{"layer":{"type":"string"},"properties":{"type":"selectorProperty"},"featureNamespace":{"type":"string"},"_uniqueFeatureID":{"type":"boolean"}},"selectorProperty":{"*":{"type":"*"}},"model":{"type":"string"},"import":{"id":{"type":"string"},"url":{"type":"string"},"config":{"type":"config"},"data":{"type":"$root"},"color-theme":{"type":"colorTheme","optional":true}},"config":{"*":{"type":"*"}},"schema":{"*":{"type":"option"}},"option":{"type":{"type":"enum","values":{"string":1,"number":1,"boolean":1,"color":1,"object":{}}},"default":{"type":"*","expression":1},"values":{"type":"array","value":"*"},"array":{"type":"boolean"},"minValue":{"type":"number"},"maxValue":{"type":"number"},"stepValue":{"type":"number"},"metadata":{"type":"*"}},"models":{"*":{"type":"model"}},"light-3d":{"type":{"type":"enum","values":{"ambient":{},"directional":{},"flat":{}}},"id":{"type":"string"},"properties":{"type":"properties"}},"properties":["properties_light_directional","properties_light_ambient","properties_light_flat"],"properties_light_directional":{"direction":{"type":"array","default":[210,30],"minimum":[0,0],"maximum":[360,90],"length":2,"value":"number","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1,"use-theme":1},"intensity":{"type":"number","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"cast-shadows":{"type":"boolean","default":false},"shadow-quality":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"parameters":["zoom"]}},"shadow-intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"shadow-draw-before-layer":{"type":"string"}},"properties_light_ambient":{"color":{"type":"color","default":"#ffffff","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1,"use-theme":1},"intensity":{"type":"number","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1}},"properties_light_flat":{"anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1,"use-theme":1},"intensity":{"type":"number","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1}},"iconsets":{"*":{"type":"iconset"}},"iconset":["iconset_sprite","iconset_source"],"iconset_sprite":{"type":{"type":"enum","values":{"sprite":1}},"url":{"type":"string"}},"iconset_source":{"type":{"type":"enum","values":{"source":1}},"source":{"type":"string"}},"sources":{"*":{"type":"source"}},"source":["source_vector","source_raster","source_raster_dem","source_raster_array","source_geojson","source_video","source_image","source_model"],"source_vector":{"type":{"type":"enum","values":{"vector":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","default":[-180,-85.051129,180,85.051129],"length":4,"value":"number"},"extra_bounds":{"type":"array","value":{"type":"array","length":4,"value":"number"}},"scheme":{"type":"enum","default":"xyz","values":{"xyz":1,"tms":1}},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"attribution":{"type":"string"},"promoteId":{"type":"promoteId"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster":{"type":{"type":"enum","values":{"raster":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","default":[-180,-85.051129,180,85.051129],"length":4,"value":"number"},"extra_bounds":{"type":"array","value":{"type":"array","length":4,"value":"number"}},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"scheme":{"type":"enum","default":"xyz","values":{"xyz":1,"tms":1}},"attribution":{"type":"string"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_dem":{"type":{"type":"enum","values":{"raster-dem":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","default":[-180,-85.051129,180,85.051129],"length":4,"value":"number"},"extra_bounds":{"type":"array","value":{"type":"array","length":4,"value":"number"}},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"attribution":{"type":"string"},"encoding":{"type":"enum","default":"mapbox","values":{"terrarium":1,"mapbox":1}},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_array":{"type":{"type":"enum","values":{"raster-array":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","default":[-180,-85.051129,180,85.051129],"length":4,"value":"number"},"extra_bounds":{"type":"array","value":{"type":"array","length":4,"value":"number"}},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"attribution":{"type":"string"},"rasterLayers":{"type":"*"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_geojson":{"type":{"type":"enum","values":{"geojson":1}},"data":{"type":"*"},"maxzoom":{"type":"number","default":18},"minzoom":{"type":"number","default":0},"attribution":{"type":"string"},"buffer":{"type":"number","default":128,"minimum":0,"maximum":512},"filter":{"type":"*"},"tolerance":{"type":"number","default":0.375},"cluster":{"type":"boolean","default":false},"clusterRadius":{"type":"number","default":50,"minimum":0},"clusterMaxZoom":{"type":"number"},"clusterMinPoints":{"type":"number"},"clusterProperties":{"type":"*"},"lineMetrics":{"type":"boolean","default":false},"generateId":{"type":"boolean","default":false},"promoteId":{"type":"promoteId"},"dynamic":{"type":"boolean","default":false}},"source_video":{"type":{"type":"enum","values":{"video":1}},"urls":{"type":"array","value":"string"},"coordinates":{"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_image":{"type":{"type":"enum","values":{"image":1}},"url":{"type":"string"},"coordinates":{"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"modelNodeOverride":{"orientation":{"type":"array","default":[0,0,0],"length":3,"value":"number"}},"modelLightOverrides":{"light-ambient-color":{"type":"color"},"light-ambient-intensity":{"type":"number"},"light-directional-color":{"type":"color"},"light-directional-intensity":{"type":"number"}},"modelNodeOverrides":{"*":{"type":"modelNodeOverride"}},"modelMaterialOverride":{"model-color":{"type":"color"},"model-color-mix-intensity":{"type":"number"},"model-opacity":{"type":"number"},"model-emissive-strength":{"type":"number"}},"modelMaterialOverrides":{"*":{"type":"modelMaterialOverride"}},"modelSourceModel":{"uri":{"type":"string"},"position":{"type":"array","default":[0,0],"minimum":[-180,-90],"maximum":[180,90],"length":2,"value":"number"},"orientation":{"type":"array","default":[0,0,0],"length":3,"value":"number"},"lightOverrides":{"type":"modelLightOverrides"},"nodeOverrides":{"type":"modelNodeOverrides"},"materialOverrides":{"type":"modelMaterialOverrides"},"nodeOverrideNames":{"type":"array","value":"string"},"materialOverrideNames":{"type":"array","value":"string"},"featureProperties":{"type":"*"}},"modelSourceModels":{"*":{"type":"modelSourceModel"}},"source_model":{"type":{"type":"enum","values":{"model":1,"batched-model":1}},"url":{"type":"string"},"maxzoom":{"type":"number","default":18},"minzoom":{"type":"number","default":0},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","default":[-180,-85.051129,180,85.051129],"length":4,"value":"number"},"extra_bounds":{"type":"array","value":{"type":"array","length":4,"value":"number"}},"models":{"type":"modelSourceModels"}},"layer":{"type":{"type":"enum","values":{"fill":{},"line":{},"symbol":{},"circle":{},"heatmap":{},"fill-extrusion":{},"building":{},"raster":{},"raster-particle":{},"hillshade":{},"model":{},"background":{},"sky":{},"slot":{},"placement-group":{},"clip":{}}},"id":{"type":"string"},"metadata":{"type":"*"},"source":{"type":"string"},"source-layer":{"type":"string"},"slot":{"type":"string"},"minzoom":{"type":"number","minimum":0,"maximum":24},"maxzoom":{"type":"number","minimum":0,"maximum":24},"filter":{"type":"filter"},"layout":{"type":"layout"},"paint":{"type":"paint"},"appearances":{"type":"array","value":"appearance"}},"layout":["layout_clip","layout_fill","layout_line","layout_circle","layout_heatmap","layout_fill-extrusion","layout_building","layout_symbol","layout_raster","layout_raster-particle","layout_hillshade","layout_background","layout_sky","layout_model"],"layout_background":{"visibility":{"type":"enum","default":"visible","values":{"visible":1,"none":1},"expression":1}},"layout_sky":{"visibility":{"type":"enum","default":"visible","values":{"visible":1,"none":1},"expression":1}},"layout_model":{"visibility":{"type":"enum","default":"visible","values":{"visible":1,"none":1},"expression":1},"model-id":{"type":"string","default":"","expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"model-allow-density-reduction":{"type":"boolean","default":true}},"layout_clip":{"clip-layer-types":{"type":"array","default":[],"value":"enum","values":{"model":1,"symbol":1},"expression":1},"clip-layer-scope":{"type":"array","default":[],"value":"string","expression":1},"visibility":{"type":"enum","default":"visible","values":{"visible":1,"none":1},"expression":1}},"layout_fill":{"fill-sort-key":{"type":"number","expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"visibility":{"type":"enum","default":"visible","values":{"visible":1,"none":1},"expression":1},"fill-elevation-reference":{"type":"enum","default":"none","values":{"none":1,"hd-road-base":1,"hd-road-markup":1},"expression":1},"fill-construct-bridge-guard-rail":{"type":"boolean","default":"true","expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"}},"layout_circle":{"circle-sort-key":{"type":"number","expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"circle-elevation-reference":{"type":"enum","default":"none","values":{"none":1,"hd-road-markup":1},"expression":1},"visibility":{"type":"enum","default":"visible","values":{"visible":1,"none":1},"expression":1}},"layout_heatmap":{"visibility":{"type":"enum","default":"visible","values":{"visible":1,"none":1},"expression":1}},"layout_fill-extrusion":{"visibility":{"type":"enum","default":"visible","values":{"visible":1,"none":1},"expression":1},"fill-extrusion-edge-radius":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":1},"source-max-zoom":{"type":"number","minimum":0,"maximum":24}},"layout_building":{"visibility":{"type":"enum","default":"visible","values":{"visible":1,"none":1},"expression":1},"building-facade":{"type":"boolean","default":false,"expression":{"parameters":["feature"]},"property-type":"data-driven"},"building-facade-floors":{"type":"number","default":3,"minimum":1,"maximum":200,"expression":{"parameters":["feature"]},"property-type":"data-driven"},"building-facade-unit-width":{"type":"number","default":3.1,"minimum":1,"maximum":20,"expression":{"parameters":["feature"]},"property-type":"data-driven"},"building-facade-window":{"type":"array","default":[0.9,0.9],"minimum":0.1,"maximum":1,"length":2,"value":"number","expression":{"parameters":["feature"]},"property-type":"data-driven"},"building-roof-shape":{"type":"enum","default":"flat","values":{"flat":1,"hipped":1,"gabled":1,"parapet":1,"mansard":1,"skillion":1,"pyramidal":1},"expression":{"parameters":["feature"]},"property-type":"data-driven"},"building-height":{"type":"number","default":0,"minimum":0,"expression":1,"property-type":"data-driven"},"building-base":{"type":"number","default":0,"minimum":0,"expression":1,"property-type":"data-driven"},"building-flood-light-wall-radius":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state"]},"property-type":"data-driven"},"building-flood-light-ground-radius":{"type":"number","default":0,"expression":{"interpolated":1,"parameters":["feature","feature-state"]},"property-type":"data-driven"},"building-flip-roof-orientation":{"type":"boolean","default":false,"expression":{"interpolated":1,"parameters":["feature","feature-state"]},"property-type":"data-driven"}},"layout_line":{"line-cap":{"type":"enum","default":"butt","values":{"butt":1,"round":1,"square":1},"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"line-join":{"type":"enum","default":"miter","values":{"bevel":1,"round":1,"miter":1,"none":1},"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"line-miter-limit":{"type":"number","default":2,"expression":{"interpolated":1,"parameters":["zoom"]}},"line-round-limit":{"type":"number","default":1.05,"expression":{"interpolated":1,"parameters":["zoom"]}},"line-sort-key":{"type":"number","expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"line-z-offset":{"type":"number","default":0,"expression":{"parameters":["feature","line-progress","zoom"]},"property-type":"data-driven"},"line-elevation-reference":{"type":"enum","default":"none","values":{"none":1,"sea":1,"ground":1,"hd-road-markup":1},"expression":1},"line-cross-slope":{"type":"number","expression":1},"visibility":{"type":"enum","default":"visible","values":{"visible":1,"none":1},"expression":1},"line-width-unit":{"type":"enum","default":"pixels","values":{"pixels":1,"meters":1},"expression":{"parameters":["zoom"]}},"line-elevation-ground-scale":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["feature","line-progress","zoom"]},"property-type":"data-driven"}},"layout_symbol":{"symbol-placement":{"type":"enum","default":"point","values":{"point":1,"line":1,"line-center":1},"expression":{"parameters":["zoom"]}},"symbol-spacing":{"type":"number","default":250,"minimum":1,"expression":{"interpolated":1,"parameters":["zoom"]}},"symbol-avoid-edges":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"symbol-sort-key":{"type":"number","expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"symbol-z-order":{"type":"enum","default":"auto","values":{"auto":1,"viewport-y":1,"source":1},"expression":{"parameters":["zoom"]}},"symbol-z-elevate":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"symbol-elevation-reference":{"type":"enum","default":"ground","values":{"sea":1,"ground":1,"hd-road-markup":1},"expression":{"parameters":["zoom"]}},"icon-allow-overlap":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"icon-ignore-placement":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"icon-optional":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"icon-rotation-alignment":{"type":"enum","default":"auto","values":{"map":1,"viewport":1,"auto":1},"expression":{"parameters":["zoom"]}},"icon-size":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","zoom"]},"property-type":"data-driven","appearance":1},"icon-size-scale-range":{"type":"array","default":[0.8,2],"minimum":[0.1,0.1],"maximum":[10,10],"length":2,"value":"number","expression":1},"icon-text-fit":{"type":"enum","default":"none","values":{"none":1,"width":1,"height":1,"both":1},"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"icon-text-fit-padding":{"type":"array","default":[0,0,0,0],"length":4,"value":"number","expression":{"interpolated":1,"parameters":["feature","zoom"]},"property-type":"data-driven"},"icon-image":{"type":"resolvedImage","expression":{"parameters":["feature","zoom"]},"use-theme":1,"property-type":"data-driven","appearance":1,"tokens":1},"icon-rotate":{"type":"number","default":0,"expression":{"interpolated":1,"parameters":["feature","zoom"]},"property-type":"data-driven","appearance":1},"icon-padding":{"type":"number","default":2,"minimum":0,"expression":{"interpolated":1,"parameters":["zoom"]}},"icon-keep-upright":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"icon-offset":{"type":"array","default":[0,0],"length":2,"value":"number","expression":{"interpolated":1,"parameters":["feature","zoom"]},"property-type":"data-driven","appearance":1},"icon-anchor":{"type":"enum","default":"center","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"icon-pitch-alignment":{"type":"enum","default":"auto","values":{"map":1,"viewport":1,"auto":1},"expression":{"parameters":["zoom"]}},"text-pitch-alignment":{"type":"enum","default":"auto","values":{"map":1,"viewport":1,"auto":1},"expression":{"parameters":["zoom"]}},"text-rotation-alignment":{"type":"enum","default":"auto","values":{"map":1,"viewport":1,"auto":1},"expression":{"parameters":["zoom"]}},"text-field":{"type":"formatted","default":"","expression":{"parameters":["feature","zoom"]},"property-type":"data-driven","tokens":1},"text-font":{"type":"array","default":["Open Sans Regular","Arial Unicode MS Regular"],"value":"string","expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"text-size":{"type":"number","default":16,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","zoom"]},"property-type":"data-driven","appearance":1},"text-size-scale-range":{"type":"array","default":[0.8,2],"minimum":[0.1,0.1],"maximum":[10,10],"length":2,"value":"number","expression":1},"text-max-width":{"type":"number","default":10,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","zoom"]},"property-type":"data-driven"},"text-line-height":{"type":"number","default":1.2,"expression":{"interpolated":1,"parameters":["feature","zoom"]},"property-type":"data-driven"},"text-letter-spacing":{"type":"number","default":0,"expression":{"interpolated":1,"parameters":["feature","zoom"]},"property-type":"data-driven"},"text-justify":{"type":"enum","default":"center","values":{"auto":1,"left":1,"center":1,"right":1},"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"text-radial-offset":{"type":"number","default":0,"expression":{"interpolated":1,"parameters":["feature","zoom"]},"property-type":"data-driven"},"text-variable-anchor":{"type":"array","value":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"expression":{"parameters":["zoom"]}},"text-anchor":{"type":"enum","default":"center","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"text-max-angle":{"type":"number","default":45,"expression":{"interpolated":1,"parameters":["zoom"]}},"text-writing-mode":{"type":"array","value":"enum","values":{"horizontal":1,"vertical":1},"expression":{"parameters":["zoom"]}},"text-rotate":{"type":"number","default":0,"expression":{"interpolated":1,"parameters":["feature","zoom"]},"property-type":"data-driven","appearance":1},"text-padding":{"type":"number","default":2,"minimum":0,"expression":{"interpolated":1,"parameters":["zoom"]}},"text-keep-upright":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]}},"text-transform":{"type":"enum","default":"none","values":{"none":1,"uppercase":1,"lowercase":1},"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"text-offset":{"type":"array","default":[0,0],"length":2,"value":"number","expression":{"interpolated":1,"parameters":["feature","zoom"]},"property-type":"data-driven","appearance":1},"text-allow-overlap":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"text-ignore-placement":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"text-optional":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"visibility":{"type":"enum","default":"visible","values":{"visible":1,"none":1},"expression":1}},"layout_raster":{"visibility":{"type":"enum","default":"visible","values":{"visible":1,"none":1},"expression":1}},"layout_raster-particle":{"visibility":{"type":"enum","default":"visible","values":{"visible":1,"none":1},"expression":1}},"layout_hillshade":{"visibility":{"type":"enum","default":"visible","values":{"visible":1,"none":1},"expression":1}},"filter":{"type":"array","value":"*"},"filter_symbol":{"type":"boolean","default":false,"expression":{"parameters":["distance-from-center","feature","pitch","zoom"]},"property-type":"data-driven"},"filter_fill":{"type":"boolean","default":false,"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"filter_hillshade":{"type":"boolean","default":false,"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"filter_raster":{"type":"boolean","default":false,"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"filter_raster-particle":{"type":"boolean","default":false,"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"filter_clip":{"type":"boolean","default":false,"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"filter_model":{"type":"boolean","default":false,"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"filter_line":{"type":"boolean","default":false,"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"filter_circle":{"type":"boolean","default":false,"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"filter_fill-extrusion":{"type":"boolean","default":false,"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"filter_building":{"type":"boolean","default":false,"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"filter_heatmap":{"type":"boolean","default":false,"expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"filter_operator":{"type":"enum","values":{"==":1,"!=":1,">":1,">=":1,"<":1,"<=":1,"in":1,"!in":1,"all":1,"any":1,"none":1,"has":1,"!has":1}},"geometry_type":{"type":"enum","values":{"Point":1,"LineString":1,"Polygon":1}},"function_stop":{"type":"array","minimum":0,"maximum":24,"length":2,"value":["number","color"]},"fog":{"range":{"type":"array","default":[0.5,10],"minimum":-20,"maximum":20,"length":2,"value":"number","expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1,"use-theme":1},"high-color":{"type":"color","default":"#245cdf","expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1,"use-theme":1},"space-color":{"type":"color","default":["interpolate",["linear"],["zoom"],4,"#010b19",7,"#367ab9"],"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1,"use-theme":1},"horizon-blend":{"type":"number","default":["interpolate",["linear"],["zoom"],4,0.2,7,0.1],"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"star-intensity":{"type":"number","default":["interpolate",["linear"],["zoom"],5,0.35,6,0],"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"vertical-range":{"type":"array","default":[0,0],"minimum":0,"length":2,"value":"number","expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1}},"snow":{"density":{"type":"number","default":["interpolate",["linear"],["zoom"],11,0,13,0.85],"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1,"use-theme":1},"opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"vignette":{"type":"number","default":["interpolate",["linear"],["zoom"],11,0,13,0.3],"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"vignette-color":{"type":"color","default":"#ffffff","expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1,"use-theme":1},"center-thinning":{"type":"number","default":0.4,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"direction":{"type":"array","default":[0,50],"minimum":0,"maximum":360,"length":2,"value":"number","expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"flake-size":{"type":"number","default":0.71,"minimum":0,"maximum":5,"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1}},"rain":{"density":{"type":"number","default":["interpolate",["linear"],["zoom"],11,0,13,0.5],"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"color":{"type":"color","default":["interpolate",["linear"],["measure-light","brightness"],0,"#03113d",0.3,"#a8adbc"],"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1,"use-theme":1},"opacity":{"type":"number","default":["interpolate",["linear"],["measure-light","brightness"],0,0.88,1,0.7],"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"vignette":{"type":"number","default":["interpolate",["linear"],["zoom"],11,0,13,1],"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"vignette-color":{"type":"color","default":["interpolate",["linear"],["measure-light","brightness"],0,"#001736",0.3,"#464646"],"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1,"use-theme":1},"center-thinning":{"type":"number","default":0.57,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"direction":{"type":"array","default":[0,80],"minimum":0,"maximum":360,"length":2,"value":"number","expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"droplet-size":{"type":"array","default":[2.6,18.2],"minimum":0,"maximum":50,"length":2,"value":"number","expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1},"distortion-strength":{"type":"number","default":0.7,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"],"relaxZoomRestriction":1},"transition":1}},"camera":{"camera-projection":{"type":"enum","default":"perspective","values":{"perspective":1,"orthographic":1}}},"colorTheme":{"data":{"type":"string","expression":1}},"indoor_source":{"sourceId":{"type":"string"},"sourceLayers":{"type":"array","value":"string"}},"indoor":{"*":{"type":"indoor_source"}},"light":{"anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1,"use-theme":1},"intensity":{"type":"number","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1}},"projection":{"name":{"type":"enum","default":"mercator","values":{"albers":1,"equalEarth":1,"equirectangular":1,"lambertConformalConic":1,"mercator":1,"naturalEarth":1,"winkelTripel":1,"globe":1}},"center":{"type":"array","minimum":[-180,-90],"maximum":[180,90],"length":2,"value":"number"},"parallels":{"type":"array","minimum":[-90,-90],"maximum":[90,90],"length":2,"value":"number"}},"terrain":{"source":{"type":"string"},"exaggeration":{"type":"number","default":1,"minimum":0,"maximum":1000,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1}},"paint":["paint_fill","paint_line","paint_circle","paint_heatmap","paint_fill-extrusion","paint_building","paint_symbol","paint_raster","paint_raster-particle","paint_hillshade","paint_background","paint_sky","paint_model"],"paint_fill":{"fill-antialias":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]}},"fill-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"fill-color":{"type":"color","default":"#000000","expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"use-theme":1,"property-type":"data-driven"},"fill-outline-color":{"type":"color","expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"use-theme":1,"property-type":"data-driven"},"fill-translate":{"type":"array","default":[0,0],"length":2,"value":"number","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"fill-translate-anchor":{"type":"enum","default":"map","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"fill-pattern":{"type":"resolvedImage","expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"fill-pattern-cross-fade":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"]}},"fill-emissive-strength":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["measure-light","zoom"]},"transition":1},"fill-z-offset":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","zoom"]},"transition":1,"property-type":"data-driven"},"fill-bridge-guard-rail-color":{"type":"color","default":"rgba(241, 236, 225, 255)","expression":{"interpolated":1,"parameters":["feature","measure-light","zoom"]},"transition":1,"use-theme":1,"property-type":"data-driven"},"fill-tunnel-structure-color":{"type":"color","default":"rgba(241, 236, 225, 255)","expression":{"interpolated":1,"parameters":["feature","measure-light","zoom"]},"transition":1,"use-theme":1,"property-type":"data-driven"}},"paint_fill-extrusion":{"fill-extrusion-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"fill-extrusion-color":{"type":"color","default":"#000000","expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"use-theme":1,"property-type":"data-driven"},"fill-extrusion-translate":{"type":"array","default":[0,0],"length":2,"value":"number","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"fill-extrusion-translate-anchor":{"type":"enum","default":"map","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"fill-extrusion-pattern":{"type":"resolvedImage","expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"fill-extrusion-pattern-cross-fade":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"]}},"fill-extrusion-height":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","zoom"]},"transition":1,"property-type":"data-driven"},"fill-extrusion-base":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","zoom"]},"transition":1,"property-type":"data-driven"},"fill-extrusion-height-alignment":{"type":"enum","default":"flat","values":{"terrain":1,"flat":1}},"fill-extrusion-base-alignment":{"type":"enum","default":"terrain","values":{"terrain":1,"flat":1}},"fill-extrusion-vertical-gradient":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]}},"fill-extrusion-ambient-occlusion-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"fill-extrusion-ambient-occlusion-radius":{"type":"number","default":3,"minimum":0,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"fill-extrusion-ambient-occlusion-wall-radius":{"type":"number","default":3,"minimum":0,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"fill-extrusion-ambient-occlusion-ground-radius":{"type":"number","default":3,"minimum":0,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"fill-extrusion-ambient-occlusion-ground-attenuation":{"type":"number","default":0.69,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"fill-extrusion-flood-light-color":{"type":"color","default":"#ffffff","expression":{"interpolated":1,"parameters":["measure-light","zoom"]},"transition":1,"use-theme":1},"fill-extrusion-flood-light-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"]},"transition":1},"fill-extrusion-flood-light-wall-radius":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state"]},"transition":1,"property-type":"data-driven"},"fill-extrusion-flood-light-ground-radius":{"type":"number","default":0,"expression":{"interpolated":1,"parameters":["feature","feature-state"]},"transition":1,"property-type":"data-driven"},"fill-extrusion-flood-light-ground-attenuation":{"type":"number","default":0.69,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"fill-extrusion-vertical-scale":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"fill-extrusion-rounded-roof":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]}},"fill-extrusion-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":1},"fill-extrusion-front-cutoff":{"type":"array","default":[0,0,1],"minimum":[0,0,0],"maximum":[1,1,1],"length":3,"value":"number","expression":{"interpolated":1,"parameters":["zoom"]}},"fill-extrusion-emissive-strength":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"fill-extrusion-line-width":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"fill-extrusion-cast-shadows":{"type":"boolean","default":true}},"paint_building":{"building-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"building-ambient-occlusion-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"parameters":[]},"transition":1},"building-ambient-occlusion-ground-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"building-ambient-occlusion-ground-radius":{"type":"number","default":3,"minimum":0,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"building-ambient-occlusion-ground-attenuation":{"type":"number","default":0.69,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"building-vertical-scale":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"building-cast-shadows":{"type":"boolean","default":true},"building-color":{"type":"color","default":"rgba(193, 154, 127, 1)","expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light"]},"use-theme":1,"property-type":"data-driven"},"building-emissive-strength":{"type":"number","default":0,"minimum":0,"maximum":5,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light"]},"property-type":"data-driven"},"building-facade-emissive-chance":{"type":"number","default":0.35,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"]}},"building-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":1},"building-front-cutoff":{"type":"array","default":[0,0,1],"minimum":[0,0,0],"maximum":[1,1,1],"length":3,"value":"number","expression":{"interpolated":1,"parameters":["zoom"]}},"building-flood-light-color":{"type":"color","default":"#ffffff","expression":{"interpolated":1,"parameters":["measure-light","zoom"]},"transition":1,"use-theme":1},"building-flood-light-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"]},"transition":1},"building-flood-light-ground-attenuation":{"type":"number","default":0.69,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1}},"paint_line":{"line-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"line-color":{"type":"color","default":"#000000","expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"use-theme":1,"property-type":"data-driven"},"line-translate":{"type":"array","default":[0,0],"length":2,"value":"number","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"line-translate-anchor":{"type":"enum","default":"map","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"line-width":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","line-progress","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"line-gap-width":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"line-offset":{"type":"number","default":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"line-blur":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"line-dasharray":{"type":"array","minimum":0,"value":"number","expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"line-pattern":{"type":"resolvedImage","expression":{"parameters":["feature","zoom"]},"property-type":"data-driven"},"line-pattern-cross-fade":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"]}},"line-gradient":{"type":"color","expression":{"interpolated":1,"parameters":["line-progress"]},"use-theme":1},"line-trim-offset":{"type":"array","default":[0,0],"minimum":[0,0],"maximum":[1,1],"length":2,"value":"number"},"line-trim-fade-range":{"type":"array","default":[0,0],"minimum":[0,0],"maximum":[1,1],"length":2,"value":"number","expression":{"interpolated":1,"parameters":["measure-light","zoom"]}},"line-trim-color":{"type":"color","default":"transparent","expression":{"interpolated":1,"parameters":["measure-light","zoom"]},"transition":1,"use-theme":1},"line-emissive-strength":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["line-progress","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"line-border-width":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","zoom"]},"transition":1,"property-type":"data-driven"},"line-border-color":{"type":"color","default":"rgba(0, 0, 0, 0)","expression":{"interpolated":1,"parameters":["feature","feature-state","zoom"]},"transition":1,"use-theme":1,"property-type":"data-driven"},"line-border-gradient":{"type":"color","expression":{"interpolated":1,"parameters":["line-progress"]},"use-theme":1},"line-occlusion-opacity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"line-blend-mode":{"type":"enum","default":"default","values":{"default":1,"multiply":1,"additive":1},"expression":{"parameters":["zoom"]}},"line-blend-additive-clamp":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["zoom"]}},"line-cutout-depth":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1}},"paint_circle":{"circle-radius":{"type":"number","default":5,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"circle-color":{"type":"color","default":"#000000","expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"use-theme":1,"property-type":"data-driven"},"circle-blur":{"type":"number","default":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"circle-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"circle-translate":{"type":"array","default":[0,0],"length":2,"value":"number","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"circle-translate-anchor":{"type":"enum","default":"map","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"circle-pitch-scale":{"type":"enum","default":"map","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"circle-pitch-alignment":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"circle-stroke-width":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"circle-stroke-color":{"type":"color","default":"#000000","expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"use-theme":1,"property-type":"data-driven"},"circle-stroke-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"circle-emissive-strength":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["measure-light","zoom"]},"transition":1}},"paint_heatmap":{"heatmap-radius":{"type":"number","default":30,"minimum":1,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven"},"heatmap-weight":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"property-type":"data-driven"},"heatmap-intensity":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"heatmap-color":{"type":"color","default":["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",0.1,"royalblue",0.3,"cyan",0.5,"lime",0.7,"yellow",1,"red"],"expression":{"interpolated":1,"parameters":["heatmap-density"]},"use-theme":1},"heatmap-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1}},"paint_symbol":{"icon-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven","appearance":1},"icon-occlusion-opacity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven","appearance":1},"icon-emissive-strength":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":1,"parameters":["feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven","appearance":1},"text-emissive-strength":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":1,"parameters":["feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven","appearance":1},"icon-color":{"type":"color","default":"#000000","expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"use-theme":1,"property-type":"data-driven","appearance":1},"icon-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"use-theme":1,"property-type":"data-driven","appearance":1},"icon-halo-width":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven","appearance":1},"icon-halo-blur":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven","appearance":1},"icon-translate":{"type":"array","default":[0,0],"length":2,"value":"number","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1,"appearance":1},"icon-translate-anchor":{"type":"enum","default":"map","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"icon-image-cross-fade":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["measure-light","zoom"]}},"text-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven","appearance":1},"text-occlusion-opacity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven","appearance":1},"text-color":{"type":"color","default":"#000000","expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"use-theme":1,"property-type":"data-driven","appearance":1,"overridable":1},"text-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"use-theme":1,"property-type":"data-driven","appearance":1},"text-halo-width":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven","appearance":1},"text-halo-blur":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"property-type":"data-driven","appearance":1},"text-translate":{"type":"array","default":[0,0],"length":2,"value":"number","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1,"appearance":1},"text-translate-anchor":{"type":"enum","default":"map","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"icon-color-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"expression":1},"icon-color-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"expression":1},"icon-color-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":1},"icon-color-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":1},"symbol-z-offset":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["feature","zoom"]},"transition":1,"property-type":"data-driven","appearance":1},"placement-priority":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["distance-from-center","feature","feature-state","measure-light","pitch","zoom"]},"property-type":"data-driven","appearance":1},"placement-group":{"type":"string","expression":{"parameters":["distance-from-center","feature","feature-state","measure-light","pitch","zoom"]},"property-type":"data-driven","appearance":1}},"paint_raster":{"raster-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"raster-color":{"type":"color","expression":{"interpolated":1,"parameters":["raster-value"]},"use-theme":1},"raster-color-mix":{"type":"array","default":[0.2126,0.7152,0.0722,0],"length":4,"value":"number","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"raster-color-range":{"type":"array","length":2,"value":"number","expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"raster-color-scale":{"type":"enum","default":"linear","values":{"linear":1,"log":1},"expression":{"parameters":[]}},"raster-hue-rotate":{"type":"number","default":0,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"raster-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"raster-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"raster-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"raster-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"raster-resampling":{"type":"enum","default":"linear","values":{"linear":1,"nearest":1},"expression":{"parameters":["zoom"]}},"raster-fade-duration":{"type":"number","default":300,"minimum":0,"expression":{"interpolated":1,"parameters":["zoom"]}},"raster-emissive-strength":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["measure-light","zoom"]},"transition":1},"raster-array-band":{"type":"string"},"raster-elevation":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"raster-elevation-reference":{"type":"enum","default":"sea","values":{"sea":1,"ground":1},"expression":1},"raster-mask":{"type":"string"},"raster-mask-import":{"type":"string"},"raster-mask-mode":{"type":"enum","default":"clip-path-intersect","values":{"clip-path-intersect":1,"clip-path-exclude":1}}},"paint_raster-particle":{"raster-particle-array-band":{"type":"string"},"raster-particle-count":{"type":"number","default":512,"minimum":1},"raster-particle-color":{"type":"color","expression":{"interpolated":1,"parameters":["raster-particle-speed"]},"use-theme":1},"raster-particle-max-speed":{"type":"number","default":1,"minimum":1},"raster-particle-speed-factor":{"type":"number","default":0.2,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"raster-particle-fade-opacity-factor":{"type":"number","default":0.98,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"raster-particle-reset-rate-factor":{"type":"number","default":0.8,"minimum":0,"maximum":1},"raster-particle-elevation":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1}},"paint_hillshade":{"hillshade-illumination-direction":{"type":"number","default":335,"minimum":0,"maximum":359,"expression":{"interpolated":1,"parameters":["zoom"]}},"hillshade-illumination-anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"hillshade-exaggeration":{"type":"number","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"hillshade-shadow-color":{"type":"color","default":"#000000","expression":{"interpolated":1,"parameters":["measure-light","zoom"]},"transition":1,"use-theme":1},"hillshade-highlight-color":{"type":"color","default":"#FFFFFF","expression":{"interpolated":1,"parameters":["measure-light","zoom"]},"transition":1,"use-theme":1},"hillshade-accent-color":{"type":"color","default":"#000000","expression":{"interpolated":1,"parameters":["measure-light","zoom"]},"transition":1,"use-theme":1},"hillshade-emissive-strength":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["measure-light","zoom"]},"transition":1}},"paint_background":{"background-pitch-alignment":{"type":"enum","default":"map","values":{"map":1,"viewport":1},"expression":{"parameters":[]}},"background-color":{"type":"color","default":"#000000","expression":{"interpolated":1,"parameters":["measure-light","zoom"]},"transition":1,"use-theme":1},"background-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom"]}},"background-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"background-emissive-strength":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":1,"parameters":["measure-light","zoom"]},"transition":1}},"paint_sky":{"sky-type":{"type":"enum","default":"atmosphere","values":{"gradient":1,"atmosphere":1},"expression":{"parameters":["zoom"]}},"sky-atmosphere-sun":{"type":"array","minimum":[0,0],"maximum":[360,180],"length":2,"value":"number","expression":{"parameters":["zoom"]}},"sky-atmosphere-sun-intensity":{"type":"number","default":10,"minimum":0,"maximum":100},"sky-gradient-center":{"type":"array","default":[0,0],"minimum":[0,0],"maximum":[360,180],"length":2,"value":"number","expression":{"parameters":["zoom"]}},"sky-gradient-radius":{"type":"number","default":90,"minimum":0,"maximum":180,"expression":{"parameters":["zoom"]}},"sky-gradient":{"type":"color","default":["interpolate",["linear"],["sky-radial-progress"],0.8,"#87ceeb",1,"white"],"expression":{"interpolated":1,"parameters":["sky-radial-progress"]},"use-theme":1},"sky-atmosphere-halo-color":{"type":"color","default":"white","use-theme":1},"sky-atmosphere-color":{"type":"color","default":"white","use-theme":1},"sky-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1}},"paint_model":{"model-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["feature","feature-state","zoom"]},"transition":1,"property-type":"data-driven"},"model-rotation":{"type":"array","default":[0,0,0],"length":3,"value":"number","expression":{"interpolated":1,"parameters":["feature","feature-state","zoom"]},"transition":1,"property-type":"data-driven"},"model-scale":{"type":"array","default":[1,1,1],"length":3,"value":"number","expression":{"interpolated":1,"parameters":["feature","feature-state","zoom"]},"transition":1,"property-type":"data-driven"},"model-translation":{"type":"array","default":[0,0,0],"length":3,"value":"number","expression":{"interpolated":1,"parameters":["feature","feature-state","zoom"]},"transition":1,"property-type":"data-driven"},"model-color":{"type":"color","default":"#ffffff","expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":1,"use-theme":1,"property-type":"data-driven"},"model-color-mix-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light"]},"transition":1,"property-type":"data-driven"},"model-type":{"type":"enum","default":"common-3d","values":{"common-3d":1,"location-indicator":1}},"model-cast-shadows":{"type":"boolean","default":true},"model-receive-shadows":{"type":"boolean","default":true},"model-ambient-occlusion-intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["zoom"]},"transition":1},"model-emissive-strength":{"type":"number","default":0,"minimum":0,"maximum":5,"expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light"]},"transition":1,"property-type":"data-driven"},"model-roughness":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":1,"parameters":["feature","feature-state"]},"transition":1,"property-type":"data-driven"},"model-height-based-emissive-strength-multiplier":{"type":"array","default":[1,1,1,1,0],"length":5,"value":"number","expression":{"interpolated":1,"parameters":["feature","feature-state","measure-light"]},"transition":1,"property-type":"data-driven"},"model-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":1},"model-front-cutoff":{"type":"array","default":[0,0,1],"minimum":[0,0,0],"maximum":[1,1,1],"length":3,"value":"number","expression":{"interpolated":1,"parameters":["zoom"]}},"model-elevation-reference":{"type":"enum","default":"ground","values":{"sea":1,"ground":1,"hd-road-markup":1},"expression":1},"model-line-cutout-mode":{"type":"enum","default":"enabled","values":{"enabled":1,"disabled":1,"enabled-above-cutout":1},"expression":1}},"promoteId":{"*":{"type":"*"}}}');
        function qs(e1) {
            return e1 instanceof Number || e1 instanceof String || e1 instanceof Boolean ? e1.valueOf() : e1;
        }
        function Xs(e1) {
            if (Array.isArray(e1)) return e1.map(Xs);
            if (e1 instanceof Object && !(e1 instanceof Number || e1 instanceof String || e1 instanceof Boolean)) {
                const t1 = {}, i = e1;
                for(const e1 in i)t1[e1] = Xs(i[e1]);
                return t1;
            }
            return qs(e1);
        }
        function Ys(e1) {
            if (!0 === e1 || !1 === e1) return !0;
            if (!Array.isArray(e1) || 0 === e1.length) return !1;
            switch(e1[0]){
                case "has":
                    return e1.length >= 2 && "$id" !== e1[1] && "$type" !== e1[1];
                case "in":
                    return e1.length >= 3 && ("string" != typeof e1[1] || Array.isArray(e1[2]));
                case "!in":
                case "!has":
                case "none":
                    return !1;
                case "==":
                case "!=":
                case ">":
                case ">=":
                case "<":
                case "<=":
                    return 3 !== e1.length || Array.isArray(e1[1]) || Array.isArray(e1[2]);
                case "any":
                case "all":
                    for (const t1 of e1.slice(1))if (!Ys(t1) && "boolean" != typeof t1) return !1;
                    return !0;
                default:
                    return !0;
            }
        }
        function Js(e1, t1 = "", i = null, n = "fill") {
            if (null == e1) return {
                filter: ()=>!0,
                needGeometry: !1,
                needFeature: !1
            };
            Ys(e1) || (e1 = rl(e1));
            const r = e1;
            let o = !0;
            try {
                o = function(e1) {
                    if (!el(e1)) return e1;
                    let t1 = Xs(e1);
                    return Qs(t1), t1 = Ks(t1), t1;
                }(r);
            } catch (e1) {
                console.warn(`Failed to extract static filter. Filter will continue working, but at higher memory usage and slower framerate.\nThis is most likely a bug, please report this via https://github.com/mapbox/mapbox-gl-js/issues/new?assignees=&labels=&template=Bug_report.md\nand paste the contents of this message in the report.\nThank you!\nFilter Expression:\n${JSON.stringify(r, null, 2)}\n        `);
            }
            let a = null, s = null;
            if ("background" !== n && "sky" !== n && "slot" !== n) {
                s = Ws[`filter_${n}`];
                const e1 = ja(o, s, t1, i);
                if ("error" === e1.result) throw new Error(e1.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
                a = (t1, i, n)=>e1.value.evaluate(t1, i, {}, n);
            }
            let l = null, c = null;
            if (o !== r) {
                const e1 = ja(r, s, t1, i);
                if ("error" === e1.result) throw new Error(e1.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
                l = (t1, i, n, r, o)=>e1.value.evaluate(t1, i, {}, n, void 0, void 0, r, o), c = !Dr(e1.value.expression);
            }
            return {
                filter: a,
                dynamicFilter: l || void 0,
                needGeometry: nl(o),
                needFeature: !!c
            };
        }
        function Ks(e1) {
            if (!Array.isArray(e1)) return e1;
            const t1 = function(e1) {
                if (tl.has(e1[0])) {
                    for(let t1 = 1; t1 < e1.length; t1++)if (el(e1[t1])) return !0;
                }
                return e1;
            }(e1);
            return !0 === t1 ? t1 : t1.map((e1)=>Ks(e1));
        }
        function Qs(e1) {
            if (!Array.isArray(e1)) return;
            let t1 = !1;
            const i = [];
            if ("case" === e1[0]) {
                for(let n = 1; n < e1.length - 1; n += 2)t1 = t1 || el(e1[n]), i.push(e1[n + 1]);
                i.push(e1.at(-1));
            } else if ("match" === e1[0]) {
                t1 = t1 || el(e1[1]);
                for(let t1 = 2; t1 < e1.length - 1; t1 += 2)i.push(e1[t1 + 1]);
                i.push(e1.at(-1));
            } else if ("step" === e1[0]) {
                t1 = t1 || el(e1[1]);
                for(let t1 = 1; t1 < e1.length - 1; t1 += 2)i.push(e1[t1 + 1]);
            }
            t1 && (e1.length = 0, e1.push("any", ...i));
            for(let t1 = 1; t1 < e1.length; t1++)Qs(e1[t1]);
        }
        function el(e1) {
            if (!Array.isArray(e1)) return !1;
            if ("pitch" === (t1 = e1[0]) || "distance-from-center" === t1) return !0;
            var t1;
            for(let t1 = 1; t1 < e1.length; t1++)if (el(e1[t1])) return !0;
            return !1;
        }
        const tl = new Set([
            "in",
            "==",
            "!=",
            ">",
            ">=",
            "<",
            "<=",
            "to-boolean"
        ]);
        function il(e1, t1) {
            return e1 < t1 ? -1 : e1 > t1 ? 1 : 0;
        }
        function nl(e1) {
            if (!Array.isArray(e1)) return !1;
            if ("within" === e1[0] || "distance" === e1[0]) return !0;
            for(let t1 = 1; t1 < e1.length; t1++)if (nl(e1[t1])) return !0;
            return !1;
        }
        function rl(e1) {
            if (!e1) return !0;
            const t1 = e1[0];
            var i;
            return e1.length <= 1 ? "any" !== t1 : "==" === t1 ? ol(e1[1], e1[2], "==") : "!=" === t1 ? ll(ol(e1[1], e1[2], "==")) : "<" === t1 || ">" === t1 || "<=" === t1 || ">=" === t1 ? ol(e1[1], e1[2], t1) : "any" === t1 ? (i = e1.slice(1), [
                "any"
            ].concat(i.map(rl))) : "all" === t1 ? [
                "all"
            ].concat(e1.slice(1).map(rl)) : "none" === t1 ? [
                "all"
            ].concat(e1.slice(1).map(rl).map(ll)) : "in" === t1 ? al(e1[1], e1.slice(2)) : "!in" === t1 ? ll(al(e1[1], e1.slice(2))) : "has" === t1 ? sl(e1[1]) : "!has" !== t1 || ll(sl(e1[1]));
        }
        function ol(e1, t1, i) {
            switch(e1){
                case "$type":
                    return [
                        `filter-type-${i}`,
                        t1
                    ];
                case "$id":
                    return [
                        `filter-id-${i}`,
                        t1
                    ];
                default:
                    return [
                        `filter-${i}`,
                        e1,
                        t1
                    ];
            }
        }
        function al(e1, t1) {
            if (0 === t1.length) return !1;
            switch(e1){
                case "$type":
                    return [
                        "filter-type-in",
                        [
                            "literal",
                            t1
                        ]
                    ];
                case "$id":
                    return [
                        "filter-id-in",
                        [
                            "literal",
                            t1
                        ]
                    ];
                default:
                    return t1.length > 200 && !t1.some((e1)=>typeof e1 != typeof t1[0]) ? [
                        "filter-in-large",
                        e1,
                        [
                            "literal",
                            t1.sort(il)
                        ]
                    ] : [
                        "filter-in-small",
                        e1,
                        [
                            "literal",
                            t1
                        ]
                    ];
            }
        }
        function sl(e1) {
            switch(e1){
                case "$type":
                    return !0;
                case "$id":
                    return [
                        "filter-has-id"
                    ];
                default:
                    return [
                        "filter-has",
                        e1
                    ];
            }
        }
        function ll(e1) {
            return [
                "!",
                e1
            ];
        }
        const cl = "";
        function ul(e1, t1) {
            return t1 ? `${e1}${cl}${t1}` : e1;
        }
        function hl(e1) {
            const t1 = e1.indexOf(cl);
            return t1 >= 0 ? e1.slice(t1 + 1) : "";
        }
        let dl, fl = 1;
        const pl = ()=>dl || (dl = new Zs({
                "icon-size": new Hs(Ws.layout_symbol["icon-size"]),
                "icon-image": new Hs(Ws.layout_symbol["icon-image"]),
                "icon-rotate": new Hs(Ws.layout_symbol["icon-rotate"]),
                "icon-offset": new Hs(Ws.layout_symbol["icon-offset"]),
                "text-size": new Hs(Ws.layout_symbol["text-size"]),
                "text-rotate": new Hs(Ws.layout_symbol["text-rotate"]),
                "text-offset": new Hs(Ws.layout_symbol["text-offset"])
            }));
        let _l;
        const ml = ()=>_l || (_l = new Zs({
                "icon-opacity": new Hs(Ws.paint_symbol["icon-opacity"]),
                "icon-occlusion-opacity": new Hs(Ws.paint_symbol["icon-occlusion-opacity"]),
                "icon-emissive-strength": new Hs(Ws.paint_symbol["icon-emissive-strength"]),
                "text-emissive-strength": new Hs(Ws.paint_symbol["text-emissive-strength"]),
                "icon-color": new Hs(Ws.paint_symbol["icon-color"]),
                "icon-halo-color": new Hs(Ws.paint_symbol["icon-halo-color"]),
                "icon-halo-width": new Hs(Ws.paint_symbol["icon-halo-width"]),
                "icon-halo-blur": new Hs(Ws.paint_symbol["icon-halo-blur"]),
                "icon-translate": new Hs(Ws.paint_symbol["icon-translate"]),
                "text-opacity": new Hs(Ws.paint_symbol["text-opacity"]),
                "text-occlusion-opacity": new Hs(Ws.paint_symbol["text-occlusion-opacity"]),
                "text-color": new Hs(Ws.paint_symbol["text-color"], {
                    runtimeType: In,
                    getOverride: (e1)=>e1.textColor,
                    hasOverride: (e1)=>!!e1.textColor
                }),
                "text-halo-color": new Hs(Ws.paint_symbol["text-halo-color"]),
                "text-halo-width": new Hs(Ws.paint_symbol["text-halo-width"]),
                "text-halo-blur": new Hs(Ws.paint_symbol["text-halo-blur"]),
                "text-translate": new Hs(Ws.paint_symbol["text-translate"]),
                "symbol-z-offset": new Hs(Ws.paint_symbol["symbol-z-offset"]),
                "placement-priority": new Hs(Ws.paint_symbol["placement-priority"]),
                "placement-group": new Hs(Ws.paint_symbol["placement-group"]),
                "icon-color-use-theme": new Hs({
                    type: "string",
                    default: "default",
                    "property-type": "data-driven"
                }),
                "icon-halo-color-use-theme": new Hs({
                    type: "string",
                    default: "default",
                    "property-type": "data-driven"
                }),
                "text-color-use-theme": new Hs({
                    type: "string",
                    default: "default",
                    "property-type": "data-driven"
                }),
                "text-halo-color-use-theme": new Hs({
                    type: "string",
                    default: "default",
                    "property-type": "data-driven"
                })
            }));
        class gl {
            constructor(e1, t1, i, n, r, o){
                this._conditionSpec = e1, this._propertiesSpec = i;
                const a = ja(e1, Ws.appearance.condition);
                if ("success" === a.result && (this.condition = a.value), this.name = t1, i) {
                    this.layoutProperties = new js(pl()), this.unevaluatedLayout = new ks(pl(), n, r, o), this.paintProperties = new js(ml()), this.unevaluatedPaint = new ks(ml(), n, r, "");
                    for(const e1 in i)e1 in this.unevaluatedLayout._values ? this.unevaluatedLayout.setValue(e1, i[e1]) : e1 in this.unevaluatedPaint._values && this.unevaluatedPaint.setValue(e1, i[e1]);
                    this.unevaluatedPaint.snap();
                }
            }
            isActive(e1) {
                return !(this.condition || !e1.isHidden || "hidden" !== this.name) || this.condition.evaluate(e1.globals, e1.feature, e1.featureState, e1.canonical);
            }
            getCondition() {
                return this.condition;
            }
            getName() {
                return this.name;
            }
            getLayoutProperty(e1) {
                return this.layoutProperties.get(e1);
            }
            getPaintProperty(e1) {
                return this.paintProperties.get(e1);
            }
            getUnevaluatedLayoutProperties() {
                return this.unevaluatedLayout;
            }
            getUnevaluatedLayoutProperty(e1) {
                return this.unevaluatedLayout._values[e1].value;
            }
            getUnevaluatedPaintProperty(e1) {
                return this.unevaluatedPaint._values[e1].value;
            }
            recalculate(e1, t1, i) {
                this.unevaluatedLayout && (this.layoutProperties = this.unevaluatedLayout.possiblyEvaluate(e1, void 0, t1, i)), this.unevaluatedPaint && (this.paintProperties = this.unevaluatedPaint.possiblyEvaluate(e1, void 0, t1, ""));
            }
            serialize() {
                const e1 = {};
                e1.condition = this.condition.expression.serialize(), this.name && (e1.name = this.name);
                const t1 = {
                    ...this.unevaluatedLayout ? this.unevaluatedLayout.serialize() : {},
                    ...this.unevaluatedPaint ? this.unevaluatedPaint.serialize() : {}
                };
                return Object.keys(t1).length > 0 && (e1.properties = t1), e1;
            }
            hasIconLayoutProperties() {
                const e1 = this.hasLayoutProperty("icon-image"), t1 = this.hasLayoutProperty("icon-size"), i = this.hasLayoutProperty("icon-offset"), n = this.hasLayoutProperty("icon-rotate");
                return e1 || t1 || i || n;
            }
            hasTextLayoutProperties() {
                const e1 = this.hasLayoutProperty("text-size"), t1 = this.hasLayoutProperty("text-offset"), i = this.hasLayoutProperty("text-rotate");
                return e1 || t1 || i;
            }
            hasIconPaintProperties() {
                return !!this.unevaluatedPaint && Object.keys(this.unevaluatedPaint._values).filter((e1)=>!e1.endsWith("-use-theme")).some((e1)=>(e1.startsWith("icon-") || "symbol-z-offset" === e1) && this.hasPaintProperty(e1));
            }
            hasTextPaintProperties() {
                return !!this.unevaluatedPaint && Object.keys(this.unevaluatedPaint._values).filter((e1)=>!e1.endsWith("-use-theme")).some((e1)=>(e1.startsWith("text-") || "symbol-z-offset" === e1) && this.hasPaintProperty(e1));
            }
            hasLayoutProperty(e1) {
                return this.unevaluatedLayout && void 0 !== this.unevaluatedLayout._values[e1].value.value;
            }
            hasPaintProperty(e1) {
                return this.unevaluatedPaint && void 0 !== this.unevaluatedPaint._values[e1].value.value;
            }
        }
        const yl = "-transition", xl = new Set([
            "fill",
            "line",
            "background",
            "hillshade",
            "raster"
        ]);
        class vl extends an {
            constructor(e1, t1, i, n, r, o){
                if (super(), this.id = e1.id, this.fqid = ul(this.id, i), this.runtimeLayerUID = fl++, this.type = e1.type, this.scope = i, this.lut = n, this.options = r, this.iconImageUseTheme = o, this.appearances = new Array, this.appearancesVersion = 0, this.paintVersion = 0, this._dirty = !0, this._recalcParameters = null, this._recalcImages = null, this._featureFilter = {
                    filter: ()=>!0,
                    needGeometry: !1,
                    needFeature: !1
                }, this._filterCompiled = !1, "custom" !== e1.type && (this.metadata = e1.metadata, this.minzoom = e1.minzoom, this.maxzoom = e1.maxzoom, e1.type && "background" !== e1.type && "sky" !== e1.type && "slot" !== e1.type && "placement-group" !== e1.type && (this.source = e1.source, this.sourceFqid = ul(e1.source, i), this.sourceLayer = e1["source-layer"], this.filter = e1.filter), e1.slot && (this.slot = e1.slot), e1.appearances && this.setAppearances(e1.appearances), t1.layout && (this._layoutValues = new ks(t1.layout, this.scope, r, this.iconImageUseTheme)), t1.paint)) {
                    this._paintValues = new ks(t1.paint, this.scope, r);
                    for(const t1 in e1.paint)this.setPaintProperty(t1, e1.paint[t1]);
                    for(const t1 in e1.layout)this.setLayoutProperty(t1, e1.layout[t1]);
                    this._paintValues.snap(), this.paint = new js(t1.paint);
                }
            }
            onAdd(e1) {}
            onRemove(e1) {}
            placeSymbols(e1, t1, i, n, r, o) {}
            isDraped(e1) {
                return !this.is3D(!0) && xl.has(this.type);
            }
            getLayoutProperty(e1) {
                return "visibility" === e1 ? this.visibility : this._layoutValues.getValue(e1);
            }
            setLayoutProperty(e1, t1) {
                if ("custom" === this.type && "visibility" === e1) return void (this.visibility = t1);
                const i = this._layoutValues;
                i._properties.properties[e1] && (i.setValue(e1, t1), this._dirty = !0, "visibility" === e1 && this.possiblyEvaluateVisibility());
            }
            setAppearances(e1) {
                this.appearances = [], e1.forEach((e1)=>{
                    this.appearances.push(new gl(e1.condition, e1.name, e1.properties, this.scope, this.options, this.iconImageUseTheme));
                }), this.appearancesVersion++, this._dirty = !0;
            }
            possiblyEvaluateVisibility() {
                const e1 = this.getLayoutPropertyValue("visibility");
                e1 && (this.visibility = e1.possiblyEvaluate({
                    zoom: 0
                }));
            }
            getLayoutPropertyValue(e1) {
                const t1 = this._layoutValues && this._layoutValues._values[e1];
                return t1 && t1.value;
            }
            getPaintPropertyValue(e1) {
                const t1 = this._paintValues && this._paintValues._values[e1];
                return t1 && t1.value;
            }
            getPaintProperty(e1) {
                return e1.endsWith(yl) ? this._paintValues.getTransition(e1.slice(0, -11)) : this._paintValues.getValue(e1);
            }
            isPaintProperty(e1) {
                return !!this._paintValues._properties.properties[e1];
            }
            setPaintProperty(e1, t1) {
                const i = this._paintValues, n = i._properties.properties;
                if (e1.endsWith(yl)) {
                    const r = e1.slice(0, -11);
                    return n[r] && i.setTransition(r, t1 || void 0), !1;
                }
                if (!n[e1]) return !1;
                const r = i._values[e1], o = r.value.isDataDriven(), a = r.value;
                i.setValue(e1, t1), this._handleSpecialPaintPropertyUpdate(e1);
                const s = i._values[e1].value, l = s.isDataDriven(), c = e1.endsWith("pattern") || "line-dasharray" === e1;
                return l || o || c || this._handleOverridablePaintPropertyUpdate(e1, a, s);
            }
            _handleSpecialPaintPropertyUpdate(e1) {}
            getProgramIds() {
                return null;
            }
            getDefaultProgramParams(e1, t1, i) {
                return null;
            }
            _handleOverridablePaintPropertyUpdate(e1, t1, i) {
                return !1;
            }
            isPlacementAffectedByPaintChanges(e1) {
                return !1;
            }
            isHidden(e1) {
                return !!(this.minzoom && e1 < this.minzoom) || !!(this.maxzoom && e1 >= this.maxzoom) || "none" === this.visibility;
            }
            updateTransitions(e1) {
                this._paintValues.updateTransitions(e1), this.paintVersion++, this._dirty = !0;
            }
            hasTransition() {
                return this._paintValues.hasTransition();
            }
            getPropertyDependencies() {
                let e1 = (this._layoutValues ? this._layoutValues.deps : 0) | (this._paintValues ? this._paintValues.deps : 0);
                for (const { unevaluatedLayout: t1, unevaluatedPaint: i } of this.appearances)t1 && (e1 |= t1.deps | i.deps);
                return e1;
            }
            recalculate(e1, t1) {
                const i = this._recalcParameters;
                let n;
                (this._dirty || !i || e1.worldview !== i.worldview || e1.activeFloors !== i.activeFloors || (n = this.getPropertyDependencies() & ((e1.zoom !== i.zoom || e1.pitch !== i.pitch ? 1 : 0) | (e1.brightness !== i.brightness ? 2 : 0) | (t1 !== this._recalcImages ? 4 : 0)), n)) && (this._recalcParameters = e1, this._recalcImages = t1, this._layoutValues && (this.layout = this._layoutValues.possiblyEvaluate(e1, void 0, t1, this.iconImageUseTheme, n)), this.hasTransition() && this.paintVersion++, this.paint = this._paintValues.possiblyEvaluate(e1, void 0, t1, void 0, n), this._dirty = this.hasTransition(), this._finalizeEvaluated(e1, t1));
            }
            _finalizeEvaluated(e1, t1) {}
            serialize() {
                const e1 = {
                    id: this.id,
                    type: this.type,
                    slot: this.slot,
                    source: this.source,
                    "source-layer": this.sourceLayer,
                    metadata: this.metadata,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    filter: this.filter,
                    layout: this._layoutValues && this._layoutValues.serialize(),
                    paint: this._paintValues && this._paintValues.serialize()
                };
                return 0 !== this.appearances.length && (e1.appearances = this.appearances.map((e1)=>e1.serialize())), ht(e1, (e1, t1)=>!(void 0 === e1 || "layout" === t1 && !Object.keys(e1).length || "paint" === t1 && !Object.keys(e1).length));
            }
            is3D(e1) {
                return !1;
            }
            hasElevation() {
                return !1;
            }
            mayUse(e1) {
                return !1;
            }
            prepare() {
                return Promise.resolve();
            }
            isSky() {
                return !1;
            }
            isTileClipped() {
                return !1;
            }
            hasBlended3DDepthPrepass() {
                return !1;
            }
            hasOffscreenPass() {
                return !1;
            }
            hasShadowPass() {
                return !1;
            }
            canCastShadows() {
                return !1;
            }
            hasLightBeamPass() {
                return !1;
            }
            cutoffRange() {
                return 0;
            }
            tileCoverLift() {
                return 0;
            }
            resize() {}
            _clear() {}
            isStateDependent() {
                for(const e1 in this.paint._values){
                    const t1 = this.paint.get(e1);
                    if (t1 instanceof Us && Ta(t1.property.specification) && ("source" === t1.value.kind || "composite" === t1.value.kind) && t1.value.isStateDependent) return !0;
                }
                for (const e1 of this.appearances)if (!Fr(e1.condition.expression)) return !0;
                return !1;
            }
            compileFilter(e1) {
                this._filterCompiled || (this._featureFilter = Js(this.filter, this.scope, e1), this._filterCompiled = !0);
            }
            invalidateCompiledFilter() {
                this._filterCompiled = !1;
            }
            dynamicFilter() {
                return this._featureFilter.dynamicFilter;
            }
            dynamicFilterNeedsFeature() {
                return this._featureFilter.needFeature;
            }
            dynamicFilterNeedsGeometry() {
                return this._featureFilter.needGeometry;
            }
            getLayerRenderingStats() {
                return this._stats;
            }
            resetLayerRenderingStats(e1) {
                this._stats && ("shadow" === e1.renderPass ? this._stats.numRenderedVerticesInShadowPass = 0 : this._stats.numRenderedVerticesInTransparentPass = 0);
            }
            getAppearances() {
                return this.appearances;
            }
            queryRenderedFeatures(e1, t1, i) {
                return {};
            }
            queryRadius(e1) {}
            queryIntersectsFeature(e1, t1, i, n, r, o, a, s, l, c) {}
        }
        function bl(e1, t1, i) {
            const n = e1.getLayoutPropertyValue(t1)?.value;
            return void 0 !== n && ("string" != typeof n || i(n));
        }
        function wl(e1, t1, i = 2) {
            const n = t1 && t1.length, r = n ? t1[0] * i : e1.length;
            let o = Al(e1, 0, r, i, !0);
            const a = [];
            if (!o || o.next === o.prev) return a;
            let s, l, c;
            if (n && (o = function(e1, t1, i, n) {
                const r = [];
                for(let i = 0, o = t1.length; i < o; i++){
                    const a = Al(e1, t1[i] * n, i < o - 1 ? t1[i + 1] * n : e1.length, n, !1);
                    a === a.next && (a.steiner = !0), r.push(Cl(a));
                }
                r.sort(Rl);
                for(let e1 = 0; e1 < r.length; e1++)i = Pl(r[e1], i);
                return i;
            }(e1, t1, o, i)), e1.length > 80 * i) {
                s = e1[0], l = e1[1];
                let t1 = s, n = l;
                for(let o = i; o < r; o += i){
                    const i = e1[o], r = e1[o + 1];
                    i < s && (s = i), r < l && (l = r), i > t1 && (t1 = i), r > n && (n = r);
                }
                c = Math.max(t1 - s, n - l), c = 0 !== c ? 32767 / c : 0;
            }
            return Il(o, a, i, s, l, c, 0), a;
        }
        function Al(e1, t1, i, n, r) {
            let o;
            if (r === function(e1, t1, i, n) {
                let r = 0;
                for(let o = t1, a = i - n; o < i; o += n)r += (e1[a] - e1[o]) * (e1[o + 1] + e1[a + 1]), a = o;
                return r;
            }(e1, t1, i, n) > 0) for(let r = t1; r < i; r += n)o = $l(r / n | 0, e1[r], e1[r + 1], o);
            else for(let r = i - n; r >= t1; r -= n)o = $l(r / n | 0, e1[r], e1[r + 1], o);
            return o && Nl(o, o.next) && (Zl(o), o = o.next), o;
        }
        function El(e1, t1) {
            if (!e1) return e1;
            t1 || (t1 = e1);
            let i, n = e1;
            do if (i = !1, n.steiner || !Nl(n, n.next) && 0 !== Vl(n.prev, n, n.next)) n = n.next;
            else {
                if (Zl(n), n = t1 = n.prev, n === n.next) break;
                i = !0;
            }
            while (i || n !== t1);
            return t1;
        }
        function Il(e1, t1, i, n, r, o, a) {
            if (!e1) return;
            !a && o && function(e1, t1, i, n) {
                let r = e1;
                do 0 === r.z && (r.z = Fl(r.x, r.y, t1, i, n)), r.prevZ = r.prev, r.nextZ = r.next, r = r.next;
                while (r !== e1);
                r.prevZ.nextZ = null, r.prevZ = null, function(e1) {
                    let t1, i = 1;
                    do {
                        let n, r = e1;
                        e1 = null;
                        let o = null;
                        for(t1 = 0; r;){
                            t1++;
                            let a = r, s = 0;
                            for(let e1 = 0; e1 < i && (s++, a = a.nextZ, a); e1++);
                            let l = i;
                            for(; s > 0 || l > 0 && a;)0 !== s && (0 === l || !a || r.z <= a.z) ? (n = r, r = r.nextZ, s--) : (n = a, a = a.nextZ, l--), o ? o.nextZ = n : e1 = n, n.prevZ = o, o = n;
                            r = a;
                        }
                        o.nextZ = null, i *= 2;
                    }while (t1 > 1);
                }(r);
            }(e1, n, r, o);
            let s = e1;
            for(; e1.prev !== e1.next;){
                const l = e1.prev, c = e1.next;
                if (o ? Sl(e1, n, r, o) : Ml(e1)) t1.push(l.i, e1.i, c.i), Zl(e1), e1 = c.next, s = c.next;
                else if ((e1 = c) === s) {
                    a ? 1 === a ? Il(e1 = Tl(El(e1), t1), t1, i, n, r, o, 2) : 2 === a && zl(e1, t1, i, n, r, o) : Il(El(e1), t1, i, n, r, o, 1);
                    break;
                }
            }
        }
        function Ml(e1) {
            const t1 = e1.prev, i = e1, n = e1.next;
            if (Vl(t1, i, n) >= 0) return !1;
            const r = t1.x, o = i.x, a = n.x, s = t1.y, l = i.y, c = n.y, u = Math.min(r, o, a), h = Math.min(s, l, c), d = Math.max(r, o, a), f = Math.max(s, l, c);
            let p = n.next;
            for(; p !== t1;){
                if (p.x >= u && p.x <= d && p.y >= h && p.y <= f && Ll(r, s, o, l, a, c, p.x, p.y) && Vl(p.prev, p, p.next) >= 0) return !1;
                p = p.next;
            }
            return !0;
        }
        function Sl(e1, t1, i, n) {
            const r = e1.prev, o = e1, a = e1.next;
            if (Vl(r, o, a) >= 0) return !1;
            const s = r.x, l = o.x, c = a.x, u = r.y, h = o.y, d = a.y, f = Math.min(s, l, c), p = Math.min(u, h, d), _ = Math.max(s, l, c), m = Math.max(u, h, d), g = Fl(f, p, t1, i, n), y = Fl(_, m, t1, i, n);
            let x = e1.prevZ, v = e1.nextZ;
            for(; x && x.z >= g && v && v.z <= y;){
                if (x.x >= f && x.x <= _ && x.y >= p && x.y <= m && x !== r && x !== a && Ll(s, u, l, h, c, d, x.x, x.y) && Vl(x.prev, x, x.next) >= 0) return !1;
                if (x = x.prevZ, v.x >= f && v.x <= _ && v.y >= p && v.y <= m && v !== r && v !== a && Ll(s, u, l, h, c, d, v.x, v.y) && Vl(v.prev, v, v.next) >= 0) return !1;
                v = v.nextZ;
            }
            for(; x && x.z >= g;){
                if (x.x >= f && x.x <= _ && x.y >= p && x.y <= m && x !== r && x !== a && Ll(s, u, l, h, c, d, x.x, x.y) && Vl(x.prev, x, x.next) >= 0) return !1;
                x = x.prevZ;
            }
            for(; v && v.z <= y;){
                if (v.x >= f && v.x <= _ && v.y >= p && v.y <= m && v !== r && v !== a && Ll(s, u, l, h, c, d, v.x, v.y) && Vl(v.prev, v, v.next) >= 0) return !1;
                v = v.nextZ;
            }
            return !0;
        }
        function Tl(e1, t1) {
            let i = e1;
            do {
                const n = i.prev, r = i.next.next;
                !Nl(n, r) && kl(n, i, i.next, r) && Gl(n, r) && Gl(r, n) && (t1.push(n.i, i.i, r.i), Zl(i), Zl(i.next), i = e1 = r), i = i.next;
            }while (i !== e1);
            return El(i);
        }
        function zl(e1, t1, i, n, r, o) {
            let a = e1;
            do {
                let e1 = a.next.next;
                for(; e1 !== a.prev;){
                    if (a.i !== e1.i && Bl(a, e1)) {
                        let s = Hl(a, e1);
                        return a = El(a, a.next), s = El(s, s.next), Il(a, t1, i, n, r, o, 0), void Il(s, t1, i, n, r, o, 0);
                    }
                    e1 = e1.next;
                }
                a = a.next;
            }while (a !== e1);
        }
        function Rl(e1, t1) {
            let i = e1.x - t1.x;
            return 0 === i && (i = e1.y - t1.y, 0 === i) && (i = (e1.next.y - e1.y) / (e1.next.x - e1.x) - (t1.next.y - t1.y) / (t1.next.x - t1.x)), i;
        }
        function Pl(e1, t1) {
            const i = function(e1, t1) {
                let i = t1;
                const n = e1.x, r = e1.y;
                let o, a = -1 / 0;
                if (Nl(e1, i)) return i;
                do {
                    if (Nl(e1, i.next)) return i.next;
                    if (r <= i.y && r >= i.next.y && i.next.y !== i.y) {
                        const e1 = i.x + (r - i.y) * (i.next.x - i.x) / (i.next.y - i.y);
                        if (e1 <= n && e1 > a && (a = e1, o = i.x < i.next.x ? i : i.next, e1 === n)) return o;
                    }
                    i = i.next;
                }while (i !== t1);
                if (!o) return null;
                const s = o, l = o.x, c = o.y;
                let u = 1 / 0;
                i = o;
                do {
                    if (n >= i.x && i.x >= l && n !== i.x && Ol(r < c ? n : a, r, l, c, r < c ? a : n, r, i.x, i.y)) {
                        const t1 = Math.abs(r - i.y) / (n - i.x);
                        Gl(i, e1) && (t1 < u || t1 === u && (i.x > o.x || i.x === o.x && Dl(o, i))) && (o = i, u = t1);
                    }
                    i = i.next;
                }while (i !== s);
                return o;
            }(e1, t1);
            if (!i) return t1;
            const n = Hl(i, e1);
            return El(n, n.next), El(i, i.next);
        }
        function Dl(e1, t1) {
            return Vl(e1.prev, e1, t1.prev) < 0 && Vl(t1.next, e1, e1.next) < 0;
        }
        function Fl(e1, t1, i, n, r) {
            return (e1 = 1431655765 & ((e1 = 858993459 & ((e1 = 252645135 & ((e1 = 16711935 & ((e1 = (e1 - i) * r | 0) | e1 << 8)) | e1 << 4)) | e1 << 2)) | e1 << 1)) | (t1 = 1431655765 & ((t1 = 858993459 & ((t1 = 252645135 & ((t1 = 16711935 & ((t1 = (t1 - n) * r | 0) | t1 << 8)) | t1 << 4)) | t1 << 2)) | t1 << 1)) << 1;
        }
        function Cl(e1) {
            let t1 = e1, i = e1;
            do (t1.x < i.x || t1.x === i.x && t1.y < i.y) && (i = t1), t1 = t1.next;
            while (t1 !== e1);
            return i;
        }
        function Ol(e1, t1, i, n, r, o, a, s) {
            return (r - a) * (t1 - s) >= (e1 - a) * (o - s) && (e1 - a) * (n - s) >= (i - a) * (t1 - s) && (i - a) * (o - s) >= (r - a) * (n - s);
        }
        function Ll(e1, t1, i, n, r, o, a, s) {
            return !(e1 === a && t1 === s) && Ol(e1, t1, i, n, r, o, a, s);
        }
        function Bl(e1, t1) {
            return e1.next.i !== t1.i && e1.prev.i !== t1.i && !function(e1, t1) {
                let i = e1;
                do {
                    if (i.i !== e1.i && i.next.i !== e1.i && i.i !== t1.i && i.next.i !== t1.i && kl(i, i.next, e1, t1)) return !0;
                    i = i.next;
                }while (i !== e1);
                return !1;
            }(e1, t1) && (Gl(e1, t1) && Gl(t1, e1) && function(e1, t1) {
                let i = e1, n = !1;
                const r = (e1.x + t1.x) / 2, o = (e1.y + t1.y) / 2;
                do i.y > o != i.next.y > o && i.next.y !== i.y && r < (i.next.x - i.x) * (o - i.y) / (i.next.y - i.y) + i.x && (n = !n), i = i.next;
                while (i !== e1);
                return n;
            }(e1, t1) && (Vl(e1.prev, e1, t1.prev) || Vl(e1, t1.prev, t1)) || Nl(e1, t1) && Vl(e1.prev, e1, e1.next) > 0 && Vl(t1.prev, t1, t1.next) > 0);
        }
        function Vl(e1, t1, i) {
            return (t1.y - e1.y) * (i.x - t1.x) - (t1.x - e1.x) * (i.y - t1.y);
        }
        function Nl(e1, t1) {
            return e1.x === t1.x && e1.y === t1.y;
        }
        function kl(e1, t1, i, n) {
            const r = jl(Vl(e1, t1, i)), o = jl(Vl(e1, t1, n)), a = jl(Vl(i, n, e1)), s = jl(Vl(i, n, t1));
            return r !== o && a !== s || !(0 !== r || !Ul(e1, i, t1)) || !(0 !== o || !Ul(e1, n, t1)) || !(0 !== a || !Ul(i, e1, n)) || !(0 !== s || !Ul(i, t1, n));
        }
        function Ul(e1, t1, i) {
            return t1.x <= Math.max(e1.x, i.x) && t1.x >= Math.min(e1.x, i.x) && t1.y <= Math.max(e1.y, i.y) && t1.y >= Math.min(e1.y, i.y);
        }
        function jl(e1) {
            return e1 > 0 ? 1 : e1 < 0 ? -1 : 0;
        }
        function Gl(e1, t1) {
            return Vl(e1.prev, e1, e1.next) < 0 ? Vl(e1, t1, e1.next) >= 0 && Vl(e1, e1.prev, t1) >= 0 : Vl(e1, t1, e1.prev) < 0 || Vl(e1, e1.next, t1) < 0;
        }
        function Hl(e1, t1) {
            const i = Wl(e1.i, e1.x, e1.y), n = Wl(t1.i, t1.x, t1.y), r = e1.next, o = t1.prev;
            return e1.next = t1, t1.prev = e1, i.next = r, r.prev = i, n.next = i, i.prev = n, o.next = n, n.prev = o, n;
        }
        function $l(e1, t1, i, n) {
            const r = Wl(e1, t1, i);
            return n ? (r.next = n.next, r.prev = n, n.next.prev = r, n.next = r) : (r.prev = r, r.next = r), r;
        }
        function Zl(e1) {
            e1.next.prev = e1.prev, e1.prev.next = e1.next, e1.prevZ && (e1.prevZ.nextZ = e1.nextZ), e1.nextZ && (e1.nextZ.prevZ = e1.prevZ);
        }
        function Wl(e1, t1, i) {
            return {
                i: e1,
                x: t1,
                y: i,
                prev: null,
                next: null,
                z: 0,
                prevZ: null,
                nextZ: null,
                steiner: !1
            };
        }
        function ql(e1, t1, i = 1) {
            if (!e1) return null;
            const n = "string" == typeof e1 ? Un.from(e1).getPrimary() : e1.getPrimary(), r = "string" == typeof e1 ? null : e1.getSecondary();
            for (const e1 of [
                n,
                r
            ]){
                if (!e1) continue;
                const n = e1.id.toString();
                t1.has(n) || t1.set(n, []), e1.scaleSelf(i), t1.get(n).push(e1);
            }
            return {
                primary: n.toString(),
                secondary: r ? r.toString() : null
            };
        }
        function Xl(e1, t1, i, n) {
            const r = n.patternDependencies;
            let o = !1;
            for (const n of t1){
                const t1 = n.paint.get(`${e1}-pattern`);
                t1.isConstant() || (o = !0), ql(t1.constantOr(null), r, i) && (o = !0);
            }
            return o;
        }
        function Yl(e1, t1, i, n, r, o) {
            const a = o.patternDependencies;
            for (const s of t1){
                const t1 = s.paint.get(`${e1}-pattern`).value;
                if ("constant" !== t1.kind) {
                    const e1 = ql(t1.evaluate({
                        zoom: n
                    }, i, {}, void 0, o.availableImages), a, r);
                    if (!e1) continue;
                    const { primary: l, secondary: c } = e1;
                    l && (i.patterns[s.id] = [
                        l,
                        c
                    ].filter(Boolean));
                }
            }
            return i;
        }
        const Jl = Sr / Math.PI / 2, Kl = 64, Ql = [
            Kl,
            32,
            16
        ], ec = -Jl, tc = Jl;
        function ic(e1, t1, i, n = Jl) {
            return i = Ye(i), [
                e1 * Math.sin(i) * n,
                -t1 * n,
                e1 * Math.cos(i) * n
            ];
        }
        function nc(e1, t1, i) {
            return ic(Math.cos(Ye(e1)), Math.sin(Ye(e1)), t1, i);
        }
        const rc = 6371008.8, oc = 2 * Math.PI * rc;
        class ac {
            constructor(e1, t1){
                if (isNaN(e1) || isNaN(t1)) throw new Error(`Invalid LngLat object: (${e1}, ${t1})`);
                if (this.lng = +e1, this.lat = +t1, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
            }
            wrap() {
                return new ac(nt(this.lng, -180, 180), this.lat);
            }
            toArray() {
                return [
                    this.lng,
                    this.lat
                ];
            }
            toString() {
                return `LngLat(${this.lng}, ${this.lat})`;
            }
            distanceTo(e1) {
                const t1 = Math.PI / 180, i = this.lat * t1, n = e1.lat * t1, r = Math.sin(i) * Math.sin(n) + Math.cos(i) * Math.cos(n) * Math.cos((e1.lng - this.lng) * t1);
                return rc * Math.acos(Math.min(r, 1));
            }
            toBounds(e1 = 0) {
                const t1 = 360 * e1 / 40075017, i = t1 / Math.cos(Math.PI / 180 * this.lat);
                return new sc({
                    lng: this.lng - i,
                    lat: this.lat - t1
                }, {
                    lng: this.lng + i,
                    lat: this.lat + t1
                });
            }
            toEcef(e1) {
                return nc(this.lat, this.lng, Jl + e1 * Jl / rc);
            }
            static convert(e1) {
                if (e1 instanceof ac) return e1;
                if (Array.isArray(e1) && (2 === e1.length || 3 === e1.length)) return new ac(Number(e1[0]), Number(e1[1]));
                if (!Array.isArray(e1) && "object" == typeof e1 && null !== e1) return new ac(Number("lng" in e1 ? e1.lng : e1.lon), Number(e1.lat));
                throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
            }
        }
        class sc {
            constructor(e1, t1){
                e1 && (t1 ? this.setSouthWest(e1).setNorthEast(t1) : Array.isArray(e1) && 4 === e1.length ? this.setSouthWest([
                    e1[0],
                    e1[1]
                ]).setNorthEast([
                    e1[2],
                    e1[3]
                ]) : this.setSouthWest(e1[0]).setNorthEast(e1[1]));
            }
            setNorthEast(e1) {
                return this._ne = e1 instanceof ac ? new ac(e1.lng, e1.lat) : ac.convert(e1), this;
            }
            setSouthWest(e1) {
                return this._sw = e1 instanceof ac ? new ac(e1.lng, e1.lat) : ac.convert(e1), this;
            }
            extend(e1) {
                const t1 = this._sw, i = this._ne;
                let n, r;
                if (e1 instanceof ac) n = e1, r = e1;
                else {
                    if (!(e1 instanceof sc)) return Array.isArray(e1) ? 4 === e1.length || e1.every(Array.isArray) ? this.extend(sc.convert(e1)) : this.extend(ac.convert(e1)) : "object" == typeof e1 && null !== e1 && Object.hasOwn(e1, "lat") && (Object.hasOwn(e1, "lon") || Object.hasOwn(e1, "lng")) ? this.extend(ac.convert(e1)) : this;
                    if (n = e1._sw, r = e1._ne, !n || !r) return this;
                }
                return t1 || i ? (t1.lng = Math.min(n.lng, t1.lng), t1.lat = Math.min(n.lat, t1.lat), i.lng = Math.max(r.lng, i.lng), i.lat = Math.max(r.lat, i.lat)) : (this._sw = new ac(n.lng, n.lat), this._ne = new ac(r.lng, r.lat)), this;
            }
            getCenter() {
                return new ac((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
            }
            getSouthWest() {
                return this._sw;
            }
            getNorthEast() {
                return this._ne;
            }
            getNorthWest() {
                return new ac(this.getWest(), this.getNorth());
            }
            getSouthEast() {
                return new ac(this.getEast(), this.getSouth());
            }
            getWest() {
                return this._sw.lng;
            }
            getSouth() {
                return this._sw.lat;
            }
            getEast() {
                return this._ne.lng;
            }
            getNorth() {
                return this._ne.lat;
            }
            toArray() {
                return [
                    this._sw.toArray(),
                    this._ne.toArray()
                ];
            }
            toString() {
                return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
            }
            isEmpty() {
                return !(this._sw && this._ne);
            }
            contains(e1) {
                const { lng: t1, lat: i } = ac.convert(e1);
                let n = this._sw.lng <= t1 && t1 <= this._ne.lng;
                return this._sw.lng > this._ne.lng && (n = this._sw.lng >= t1 && t1 >= this._ne.lng), this._sw.lat <= i && i <= this._ne.lat && n;
            }
            static convert(e1) {
                if (e1) return e1 instanceof sc ? e1 : new sc(e1);
            }
        }
        function lc(e1) {
            return oc * Math.cos(e1 * Math.PI / 180);
        }
        function cc(e1, t1) {
            return e1 / lc(t1);
        }
        function uc(e1, t1) {
            return e1 * lc(fr(t1));
        }
        const hc = 85.051129;
        function dc(e1) {
            return Math.cos(Ye(tt(e1, -85.051129, hc)));
        }
        function fc(e1, t1) {
            const i = tt(t1, 0, 25.5), n = Math.pow(2, i);
            return dc(e1) * oc / (512 * n);
        }
        function pc(e1) {
            return 1 / Math.cos(e1 * Math.PI / 180);
        }
        function _c(e1, t1 = 0) {
            const i = Math.exp(Math.PI * (1 - (e1.y + t1 / Sr) / (1 << e1.z) * 2));
            return 80150034 * i / (i * i + 1) / Sr / (1 << e1.z);
        }
        class mc {
            constructor(e1, t1, i = 0){
                this.x = +e1, this.y = +t1, this.z = +i;
            }
            static fromLngLat(e1, t1 = 0) {
                const i = ac.convert(e1);
                return new mc(ur(i.lng), hr(i.lat), cc(t1, i.lat));
            }
            toLngLat() {
                return new ac(dr(this.x), fr(this.y));
            }
            toAltitude() {
                return uc(this.z, this.y);
            }
            meterInMercatorCoordinateUnits() {
                return 1 / oc * pc(fr(this.y));
            }
        }
        function gc(e1, t1, i, n, r, o, a, s, l) {
            const c = (t1 + n) / 2, u = (i + r) / 2, h = new Re(c, u);
            s(h), function(e1, t1, i, n, r, o) {
                const a = i - r, s = n - o;
                return Math.abs((n - t1) * a - (i - e1) * s) / Math.hypot(a, s);
            }(h.x, h.y, o.x, o.y, a.x, a.y) >= l ? (gc(e1, t1, i, c, u, o, h, s, l), gc(e1, c, u, n, r, h, a, s, l)) : e1.push(a);
        }
        function yc(e1, t1, i) {
            let n = e1[0], r = n.x, o = n.y;
            t1(n);
            const a = [
                n
            ];
            for(let s = 1; s < e1.length; s++){
                const l = e1[s], { x: c, y: u } = l;
                t1(l), gc(a, r, o, c, u, n, l, t1, i), r = c, o = u, n = l;
            }
            return a;
        }
        function xc(e1, t1, i, n) {
            if (n(t1, i)) {
                const r = t1.add(i)._mult(.5);
                xc(e1, t1, r, n), xc(e1, r, i, n);
            } else e1.push(i);
        }
        function vc(e1, t1) {
            let i = e1[0];
            const n = [
                i
            ];
            for(let r = 1; r < e1.length; r++){
                const o = e1[r];
                xc(n, i, o, t1), i = o;
            }
            return n;
        }
        const bc = Math.pow(2, 14) - 1, wc = -bc - 1;
        function Ac(e1, t1) {
            const i = Math.round(e1.x * t1), n = Math.round(e1.y * t1);
            return e1.x = tt(i, wc, bc), e1.y = tt(n, wc, bc), (i < e1.x || i > e1.x + 1 || n < e1.y || n > e1.y + 1) && _t("Geometry exceeds allowed extent, reduce your vector tile buffer size"), e1;
        }
        function Ec(e1, t1, i) {
            const n = e1.loadGeometry(), r = e1.extent, o = Sr / r;
            if (t1 && i && i.projection.isReprojectedInTileSpace) {
                const o = 1 << t1.z, { scale: a, x: s, y: l, projection: c } = i, u = (e1)=>{
                    const i = dr((t1.x + e1.x / r) / o), n = fr((t1.y + e1.y / r) / o), u = c.project(i, n);
                    e1.x = (u.x * a - s) * r, e1.y = (u.y * a - l) * r;
                };
                for(let t1 = 0; t1 < n.length; t1++)if (1 !== e1.type) n[t1] = yc(n[t1], u, 1);
                else {
                    const e1 = [];
                    for (const i of n[t1])i.x < 0 || i.x >= r || i.y < 0 || i.y >= r || (u(i), e1.push(i));
                    n[t1] = e1;
                }
            }
            for (const e1 of n)for (const t1 of e1)Ac(t1, o);
            return n;
        }
        function Ic(e1, t1, i, n, r) {
            return i && !r.projection.isReprojectedInTileSpace ? t1.geometry : Ec(e1, n, r);
        }
        function Mc(e1, t1) {
            return {
                type: e1.type,
                id: e1.id,
                properties: e1.properties,
                geometry: t1 ? Ec(e1) : []
            };
        }
        const Sc = {
            Int8: Int8Array,
            Uint8: Uint8Array,
            Int16: Int16Array,
            Uint16: Uint16Array,
            Int32: Int32Array,
            Uint32: Uint32Array,
            Float32: Float32Array
        };
        class Tc {
            constructor(e1, t1){
                this._structArray = e1, this._pos1 = t1 * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
            }
        }
        const zc = new ArrayBuffer(0);
        class Rc {
            constructor(){
                this._reallocCount = 0, this.capacity = 0, this.length = 0;
            }
            static serialize(e1, t1) {
                return e1._trim(), t1 && e1.arrayBuffer && t1.add(e1.arrayBuffer), {
                    length: e1.length,
                    arrayBuffer: e1.arrayBuffer
                };
            }
            static deserialize(e1) {
                const t1 = Object.create(this.prototype);
                return t1.arrayBuffer = e1.arrayBuffer, t1.length = e1.length, e1.arrayBuffer ? t1.capacity = e1.arrayBuffer.byteLength / t1.bytesPerElement : (t1.capacity = 0, t1.arrayBuffer = zc), t1._refreshViews(), t1;
            }
            _trim() {
                this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
            }
            clear() {
                this.length = 0;
            }
            resize(e1) {
                this.reserve(e1), this.length = e1;
            }
            resizeExact(e1) {
                this.reserveExact(e1), this.length = e1;
            }
            reserve(e1) {
                e1 > this.capacity && this._allocate(Math.max(e1, Math.floor(5 * this.capacity), 128));
            }
            reserveExact(e1) {
                (e1 > this.capacity || !this.arrayBuffer) && this._allocate(e1);
            }
            _allocate(e1) {
                this._reallocCount++, this.capacity = e1, this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                const t1 = this.uint8;
                this._refreshViews(), t1 && this.uint8.set(t1);
            }
            reserveForAdditional(e1) {
                this.reserve(this.length + e1);
            }
            _refreshViews() {
                throw new Error("StructArray#_refreshViews() must be implemented by each concrete StructArray layout");
            }
            emplace(...e1) {
                throw new Error("StructArray#emplace() must be implemented by each concrete StructArray layout");
            }
            emplaceBack(...e1) {
                throw new Error("StructArray#emplaceBack() must be implemented by each concrete StructArray layout");
            }
            destroy() {
                this.int8 = this.uint8 = this.int16 = this.uint16 = this.int32 = this.uint32 = this.float32 = null, this.arrayBuffer = null;
            }
        }
        function Pc(e1, t1 = 1) {
            let i = 0, n = 0;
            return {
                members: e1.map((e1)=>{
                    const r = Sc[e1.type].BYTES_PER_ELEMENT, o = i = Dc(i, Math.max(t1, r)), a = e1.components || 1;
                    return n = Math.max(n, r), i += r * a, {
                        name: e1.name,
                        type: e1.type,
                        components: a,
                        offset: o,
                        normalized: e1.normalized
                    };
                }),
                size: Dc(i, Math.max(n, t1)),
                alignment: t1
            };
        }
        function Dc(e1, t1) {
            return Math.ceil(e1 / t1) * t1;
        }
        class Fc extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, e1, t1);
            }
            emplace(e1, t1, i) {
                const n = 2 * e1;
                return this.int16[n + 0] = t1, this.int16[n + 1] = i, e1;
            }
        }
        Fc.prototype.bytesPerElement = 4, Ya(Fc, "StructArrayLayout2i4");
        class Cc extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t1, i);
            }
            emplace(e1, t1, i, n) {
                const r = 3 * e1;
                return this.int16[r + 0] = t1, this.int16[r + 1] = i, this.int16[r + 2] = n, e1;
            }
        }
        Cc.prototype.bytesPerElement = 6, Ya(Cc, "StructArrayLayout3i6");
        class Oc extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, e1, t1, i, n);
            }
            emplace(e1, t1, i, n, r) {
                const o = 4 * e1;
                return this.int16[o + 0] = t1, this.int16[o + 1] = i, this.uint16[o + 2] = n, this.uint16[o + 3] = r, e1;
            }
        }
        Oc.prototype.bytesPerElement = 8, Ya(Oc, "StructArrayLayout2i2ui8");
        class Lc extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1) {
                const t1 = this.length;
                return this.resize(t1 + 1), this.emplace(t1, e1);
            }
            emplace(e1, t1) {
                return this.float32[1 * e1 + 0] = t1, e1;
            }
        }
        Lc.prototype.bytesPerElement = 4, Ya(Lc, "StructArrayLayout1f4");
        class Bc extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t1, i);
            }
            emplace(e1, t1, i, n) {
                const r = 4 * e1, o = 2 * e1;
                return this.int16[r + 0] = t1, this.int16[r + 1] = i, this.float32[o + 1] = n, e1;
            }
        }
        Bc.prototype.bytesPerElement = 8, Ya(Bc, "StructArrayLayout2i1f8");
        class Vc extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t1, i);
            }
            emplace(e1, t1, i, n) {
                const r = 4 * e1;
                return this.int16[r + 0] = t1, this.int16[r + 1] = i, this.int16[r + 2] = n, e1;
            }
        }
        Vc.prototype.bytesPerElement = 8, Ya(Vc, "StructArrayLayout3i8");
        class Nc extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, e1, t1, i, n);
            }
            emplace(e1, t1, i, n, r) {
                const o = 4 * e1;
                return this.int16[o + 0] = t1, this.int16[o + 1] = i, this.int16[o + 2] = n, this.int16[o + 3] = r, e1;
            }
        }
        Nc.prototype.bytesPerElement = 8, Ya(Nc, "StructArrayLayout4i8");
        class kc extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, e1, t1, i, n, r);
            }
            emplace(e1, t1, i, n, r, o) {
                const a = 5 * e1;
                return this.int16[a + 0] = t1, this.int16[a + 1] = i, this.int16[a + 2] = n, this.int16[a + 3] = r, this.int16[a + 4] = o, e1;
            }
        }
        kc.prototype.bytesPerElement = 10, Ya(kc, "StructArrayLayout5i10");
        class Uc extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o, a, s) {
                const l = this.length;
                return this.resize(l + 1), this.emplace(l, e1, t1, i, n, r, o, a, s);
            }
            emplace(e1, t1, i, n, r, o, a, s, l) {
                const c = 8 * e1, u = 16 * e1, h = 4 * e1;
                return this.int16[c + 0] = t1, this.int16[c + 1] = i, this.uint8[u + 4] = n, this.uint8[u + 5] = r, this.uint8[u + 6] = o, this.uint8[u + 7] = a, this.float32[h + 2] = s, this.float32[h + 3] = l, e1;
            }
        }
        Uc.prototype.bytesPerElement = 16, Ya(Uc, "StructArrayLayout2i4ub1f1f16");
        class jc extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t1, i);
            }
            emplace(e1, t1, i, n) {
                const r = 3 * e1;
                return this.float32[r + 0] = t1, this.float32[r + 1] = i, this.float32[r + 2] = n, e1;
            }
        }
        jc.prototype.bytesPerElement = 12, Ya(jc, "StructArrayLayout3f12");
        class Gc extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, e1, t1, i, n, r);
            }
            emplace(e1, t1, i, n, r, o) {
                const a = 6 * e1, s = 3 * e1;
                return this.uint16[a + 0] = t1, this.uint16[a + 1] = i, this.uint16[a + 2] = n, this.uint16[a + 3] = r, this.float32[s + 2] = o, e1;
            }
        }
        Gc.prototype.bytesPerElement = 12, Ya(Gc, "StructArrayLayout4ui1f12");
        class Hc extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, e1, t1, i, n);
            }
            emplace(e1, t1, i, n, r) {
                const o = 4 * e1;
                return this.uint16[o + 0] = t1, this.uint16[o + 1] = i, this.uint16[o + 2] = n, this.uint16[o + 3] = r, e1;
            }
        }
        Hc.prototype.bytesPerElement = 8, Ya(Hc, "StructArrayLayout4ui8");
        class $c extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, e1, t1, i, n, r, o);
            }
            emplace(e1, t1, i, n, r, o, a) {
                const s = 6 * e1;
                return this.int16[s + 0] = t1, this.int16[s + 1] = i, this.int16[s + 2] = n, this.int16[s + 3] = r, this.int16[s + 4] = o, this.int16[s + 5] = a, e1;
            }
        }
        $c.prototype.bytesPerElement = 12, Ya($c, "StructArrayLayout6i12");
        class Zc extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o, a, s, l, c, u, h) {
                const d = this.length;
                return this.resize(d + 1), this.emplace(d, e1, t1, i, n, r, o, a, s, l, c, u, h);
            }
            emplace(e1, t1, i, n, r, o, a, s, l, c, u, h, d) {
                const f = 12 * e1;
                return this.int16[f + 0] = t1, this.int16[f + 1] = i, this.int16[f + 2] = n, this.int16[f + 3] = r, this.uint16[f + 4] = o, this.uint16[f + 5] = a, this.uint16[f + 6] = s, this.uint16[f + 7] = l, this.int16[f + 8] = c, this.int16[f + 9] = u, this.int16[f + 10] = h, this.int16[f + 11] = d, e1;
            }
        }
        Zc.prototype.bytesPerElement = 24, Ya(Zc, "StructArrayLayout4i4ui4i24");
        class Wc extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, e1, t1, i, n, r, o);
            }
            emplace(e1, t1, i, n, r, o, a) {
                const s = 10 * e1, l = 5 * e1;
                return this.int16[s + 0] = t1, this.int16[s + 1] = i, this.int16[s + 2] = n, this.float32[l + 2] = r, this.float32[l + 3] = o, this.float32[l + 4] = a, e1;
            }
        }
        Wc.prototype.bytesPerElement = 20, Ya(Wc, "StructArrayLayout3i3f20");
        class qc extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, e1, t1, i, n);
            }
            emplace(e1, t1, i, n, r) {
                const o = 4 * e1;
                return this.float32[o + 0] = t1, this.float32[o + 1] = i, this.float32[o + 2] = n, this.float32[o + 3] = r, e1;
            }
        }
        qc.prototype.bytesPerElement = 16, Ya(qc, "StructArrayLayout4f16");
        class Xc extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(e1) {
                const t1 = this.length;
                return this.resize(t1 + 1), this.emplace(t1, e1);
            }
            emplace(e1, t1) {
                return this.uint32[1 * e1 + 0] = t1, e1;
            }
        }
        Xc.prototype.bytesPerElement = 4, Ya(Xc, "StructArrayLayout1ul4");
        class Yc extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int32 = new Int32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, e1, t1);
            }
            emplace(e1, t1, i) {
                const n = 2 * e1;
                return this.int32[n + 0] = t1, this.int32[n + 1] = i, e1;
            }
        }
        Yc.prototype.bytesPerElement = 8, Ya(Yc, "StructArrayLayout2l8");
        class Jc extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, e1, t1);
            }
            emplace(e1, t1, i) {
                const n = 2 * e1;
                return this.uint16[n + 0] = t1, this.uint16[n + 1] = i, e1;
            }
        }
        Jc.prototype.bytesPerElement = 4, Ya(Jc, "StructArrayLayout2ui4");
        class Kc extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o, a, s, l, c, u, h, d) {
                const f = this.length;
                return this.resize(f + 1), this.emplace(f, e1, t1, i, n, r, o, a, s, l, c, u, h, d);
            }
            emplace(e1, t1, i, n, r, o, a, s, l, c, u, h, d, f) {
                const p = 20 * e1, _ = 10 * e1;
                return this.int16[p + 0] = t1, this.int16[p + 1] = i, this.int16[p + 2] = n, this.int16[p + 3] = r, this.int16[p + 4] = o, this.float32[_ + 3] = a, this.float32[_ + 4] = s, this.float32[_ + 5] = l, this.float32[_ + 6] = c, this.int16[p + 14] = u, this.uint32[_ + 8] = h, this.uint16[p + 18] = d, this.uint16[p + 19] = f, e1;
            }
        }
        Kc.prototype.bytesPerElement = 40, Ya(Kc, "StructArrayLayout5i4f1i1ul2ui40");
        class Qc extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o, a) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, e1, t1, i, n, r, o, a);
            }
            emplace(e1, t1, i, n, r, o, a, s) {
                const l = 8 * e1;
                return this.int16[l + 0] = t1, this.int16[l + 1] = i, this.int16[l + 2] = n, this.int16[l + 4] = r, this.int16[l + 5] = o, this.int16[l + 6] = a, this.int16[l + 7] = s, e1;
            }
        }
        Qc.prototype.bytesPerElement = 16, Ya(Qc, "StructArrayLayout3i2i2i16");
        class eu extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, e1, t1, i, n, r);
            }
            emplace(e1, t1, i, n, r, o) {
                const a = 4 * e1, s = 8 * e1;
                return this.float32[a + 0] = t1, this.float32[a + 1] = i, this.float32[a + 2] = n, this.int16[s + 6] = r, this.int16[s + 7] = o, e1;
            }
        }
        eu.prototype.bytesPerElement = 16, Ya(eu, "StructArrayLayout2f1f2i16");
        class tu extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o, a) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, e1, t1, i, n, r, o, a);
            }
            emplace(e1, t1, i, n, r, o, a, s) {
                const l = 6 * e1, c = 12 * e1;
                return this.float32[l + 0] = t1, this.float32[l + 1] = i, this.float32[l + 2] = n, this.float32[l + 3] = r, this.float32[l + 4] = o, this.int16[c + 10] = a, this.int16[c + 11] = s, e1;
            }
        }
        tu.prototype.bytesPerElement = 24, Ya(tu, "StructArrayLayout2f2f1f2i24");
        class iu extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, e1, t1, i, n, r, o);
            }
            emplace(e1, t1, i, n, r, o, a) {
                const s = 20 * e1, l = 5 * e1;
                return this.uint8[s + 0] = t1, this.uint8[s + 1] = i, this.float32[l + 1] = n, this.float32[l + 2] = r, this.float32[l + 3] = o, this.float32[l + 4] = a, e1;
            }
        }
        iu.prototype.bytesPerElement = 20, Ya(iu, "StructArrayLayout2ub4f20");
        class nu extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t1, i);
            }
            emplace(e1, t1, i, n) {
                const r = 3 * e1;
                return this.uint16[r + 0] = t1, this.uint16[r + 1] = i, this.uint16[r + 2] = n, e1;
            }
        }
        nu.prototype.bytesPerElement = 6, Ya(nu, "StructArrayLayout3ui6");
        class ru extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o, a, s, l, c, u, h, d, f, p, _, m, g, y, x, v) {
                const b = this.length;
                return this.resize(b + 1), this.emplace(b, e1, t1, i, n, r, o, a, s, l, c, u, h, d, f, p, _, m, g, y, x, v);
            }
            emplace(e1, t1, i, n, r, o, a, s, l, c, u, h, d, f, p, _, m, g, y, x, v, b) {
                const w = 30 * e1, A = 15 * e1, E = 60 * e1;
                return this.int16[w + 0] = t1, this.int16[w + 1] = i, this.int16[w + 2] = n, this.float32[A + 2] = r, this.float32[A + 3] = o, this.uint16[w + 8] = a, this.uint16[w + 9] = s, this.uint32[A + 5] = l, this.uint32[A + 6] = c, this.uint32[A + 7] = u, this.uint16[w + 16] = h, this.uint16[w + 17] = d, this.uint16[w + 18] = f, this.float32[A + 10] = p, this.float32[A + 11] = _, this.uint8[E + 48] = m, this.uint8[E + 49] = g, this.uint8[E + 50] = y, this.uint32[A + 13] = x, this.int16[w + 28] = v, this.uint8[E + 58] = b, e1;
            }
        }
        ru.prototype.bytesPerElement = 60, Ya(ru, "StructArrayLayout3i2f2ui3ul3ui2f3ub1ul1i1ub60");
        class ou extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o, a, s, l, c, u, h, d, f, p, _, m, g, y, x, v, b, w, A, E, I, M, S, T, z, R, P, D) {
                const F = this.length;
                return this.resize(F + 1), this.emplace(F, e1, t1, i, n, r, o, a, s, l, c, u, h, d, f, p, _, m, g, y, x, v, b, w, A, E, I, M, S, T, z, R, P, D);
            }
            emplace(e1, t1, i, n, r, o, a, s, l, c, u, h, d, f, p, _, m, g, y, x, v, b, w, A, E, I, M, S, T, z, R, P, D, F) {
                const C = 20 * e1, O = 40 * e1, L = 80 * e1;
                return this.float32[C + 0] = t1, this.float32[C + 1] = i, this.int16[O + 4] = n, this.int16[O + 5] = r, this.int16[O + 6] = o, this.int16[O + 7] = a, this.int16[O + 8] = s, this.int16[O + 9] = l, this.int16[O + 10] = c, this.int16[O + 11] = u, this.int16[O + 12] = h, this.uint16[O + 13] = d, this.uint16[O + 14] = f, this.uint16[O + 15] = p, this.uint16[O + 16] = _, this.uint16[O + 17] = m, this.uint16[O + 18] = g, this.uint16[O + 19] = y, this.uint16[O + 20] = x, this.uint16[O + 21] = v, this.uint16[O + 22] = b, this.uint16[O + 23] = w, this.uint16[O + 24] = A, this.uint16[O + 25] = E, this.uint16[O + 26] = I, this.uint16[O + 27] = M, this.uint32[C + 14] = S, this.float32[C + 15] = T, this.float32[C + 16] = z, this.float32[C + 17] = R, this.float32[C + 18] = P, this.uint8[L + 76] = D, this.uint16[O + 39] = F, e1;
            }
        }
        ou.prototype.bytesPerElement = 80, Ya(ou, "StructArrayLayout2f9i15ui1ul4f1ub1ui80");
        class au extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, e1, t1, i, n, r, o);
            }
            emplace(e1, t1, i, n, r, o, a) {
                const s = 6 * e1;
                return this.float32[s + 0] = t1, this.float32[s + 1] = i, this.float32[s + 2] = n, this.float32[s + 3] = r, this.float32[s + 4] = o, this.float32[s + 5] = a, e1;
            }
        }
        au.prototype.bytesPerElement = 24, Ya(au, "StructArrayLayout6f24");
        class su extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, e1, t1, i, n, r);
            }
            emplace(e1, t1, i, n, r, o) {
                const a = 5 * e1;
                return this.float32[a + 0] = t1, this.float32[a + 1] = i, this.float32[a + 2] = n, this.float32[a + 3] = r, this.float32[a + 4] = o, e1;
            }
        }
        su.prototype.bytesPerElement = 20, Ya(su, "StructArrayLayout5f20");
        class lu extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o, a) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, e1, t1, i, n, r, o, a);
            }
            emplace(e1, t1, i, n, r, o, a, s) {
                const l = 7 * e1;
                return this.float32[l + 0] = t1, this.float32[l + 1] = i, this.float32[l + 2] = n, this.float32[l + 3] = r, this.float32[l + 4] = o, this.float32[l + 5] = a, this.float32[l + 6] = s, e1;
            }
        }
        lu.prototype.bytesPerElement = 28, Ya(lu, "StructArrayLayout7f28");
        class cu extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o, a, s, l, c, u) {
                const h = this.length;
                return this.resize(h + 1), this.emplace(h, e1, t1, i, n, r, o, a, s, l, c, u);
            }
            emplace(e1, t1, i, n, r, o, a, s, l, c, u, h) {
                const d = 11 * e1;
                return this.float32[d + 0] = t1, this.float32[d + 1] = i, this.float32[d + 2] = n, this.float32[d + 3] = r, this.float32[d + 4] = o, this.float32[d + 5] = a, this.float32[d + 6] = s, this.float32[d + 7] = l, this.float32[d + 8] = c, this.float32[d + 9] = u, this.float32[d + 10] = h, e1;
            }
        }
        cu.prototype.bytesPerElement = 44, Ya(cu, "StructArrayLayout11f44");
        class uu extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o, a, s, l) {
                const c = this.length;
                return this.resize(c + 1), this.emplace(c, e1, t1, i, n, r, o, a, s, l);
            }
            emplace(e1, t1, i, n, r, o, a, s, l, c) {
                const u = 9 * e1;
                return this.float32[u + 0] = t1, this.float32[u + 1] = i, this.float32[u + 2] = n, this.float32[u + 3] = r, this.float32[u + 4] = o, this.float32[u + 5] = a, this.float32[u + 6] = s, this.float32[u + 7] = l, this.float32[u + 8] = c, e1;
            }
        }
        uu.prototype.bytesPerElement = 36, Ya(uu, "StructArrayLayout9f36");
        class hu extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, e1, t1);
            }
            emplace(e1, t1, i) {
                const n = 2 * e1;
                return this.float32[n + 0] = t1, this.float32[n + 1] = i, e1;
            }
        }
        hu.prototype.bytesPerElement = 8, Ya(hu, "StructArrayLayout2f8");
        class du extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, e1, t1, i, n);
            }
            emplace(e1, t1, i, n, r) {
                const o = 6 * e1;
                return this.uint32[3 * e1 + 0] = t1, this.uint16[o + 2] = i, this.uint16[o + 3] = n, this.uint16[o + 4] = r, e1;
            }
        }
        du.prototype.bytesPerElement = 12, Ya(du, "StructArrayLayout1ul3ui12");
        class fu extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1) {
                const t1 = this.length;
                return this.resize(t1 + 1), this.emplace(t1, e1);
            }
            emplace(e1, t1) {
                return this.uint16[1 * e1 + 0] = t1, e1;
            }
        }
        fu.prototype.bytesPerElement = 2, Ya(fu, "StructArrayLayout1ui2");
        class pu extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int8 = new Int8Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, e1, t1, i, n);
            }
            emplace(e1, t1, i, n, r) {
                const o = 4 * e1;
                return this.int8[o + 0] = t1, this.int8[o + 1] = i, this.int8[o + 2] = n, this.int8[o + 3] = r, e1;
            }
        }
        pu.prototype.bytesPerElement = 4, Ya(pu, "StructArrayLayout4b4");
        class _u extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, i, n, r, o, a, s, l, c, u, h, d, f, p, _) {
                const m = this.length;
                return this.resize(m + 1), this.emplace(m, e1, t1, i, n, r, o, a, s, l, c, u, h, d, f, p, _);
            }
            emplace(e1, t1, i, n, r, o, a, s, l, c, u, h, d, f, p, _, m) {
                const g = 16 * e1;
                return this.float32[g + 0] = t1, this.float32[g + 1] = i, this.float32[g + 2] = n, this.float32[g + 3] = r, this.float32[g + 4] = o, this.float32[g + 5] = a, this.float32[g + 6] = s, this.float32[g + 7] = l, this.float32[g + 8] = c, this.float32[g + 9] = u, this.float32[g + 10] = h, this.float32[g + 11] = d, this.float32[g + 12] = f, this.float32[g + 13] = p, this.float32[g + 14] = _, this.float32[g + 15] = m, e1;
            }
        }
        _u.prototype.bytesPerElement = 64, Ya(_u, "StructArrayLayout16f64");
        class mu extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1) {
                const t1 = this.length;
                return this.resize(t1 + 1), this.emplace(t1, e1);
            }
            emplace(e1, t1) {
                return this.int16[1 * e1 + 0] = t1, e1;
            }
        }
        mu.prototype.bytesPerElement = 2, Ya(mu, "StructArrayLayout1i2");
        class gu extends Rc {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer);
            }
            emplaceBack(e1) {
                const t1 = this.length;
                return this.resize(t1 + 1), this.emplace(t1, e1);
            }
            emplace(e1, t1) {
                return this.uint8[1 * e1 + 0] = t1, e1;
            }
        }
        gu.prototype.bytesPerElement = 1, Ya(gu, "StructArrayLayout1ub1");
        class yu extends Tc {
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get tileAnchorX() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get tileAnchorY() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get x1() {
                return this._structArray.float32[this._pos4 + 3];
            }
            get y1() {
                return this._structArray.float32[this._pos4 + 4];
            }
            get x2() {
                return this._structArray.float32[this._pos4 + 5];
            }
            get y2() {
                return this._structArray.float32[this._pos4 + 6];
            }
            get padding() {
                return this._structArray.int16[this._pos2 + 14];
            }
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 8];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 19];
            }
        }
        yu.prototype.size = 40;
        class xu extends Kc {
            get(e1) {
                return new yu(this, e1);
            }
        }
        Ya(xu, "CollisionBoxArray");
        class vu extends Tc {
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get tileAnchorX() {
                return this._structArray.float32[this._pos4 + 2];
            }
            get tileAnchorY() {
                return this._structArray.float32[this._pos4 + 3];
            }
            get glyphStartIndex() {
                return this._structArray.uint16[this._pos2 + 8];
            }
            get numGlyphs() {
                return this._structArray.uint16[this._pos2 + 9];
            }
            get vertexStartIndex() {
                return this._structArray.uint32[this._pos4 + 5];
            }
            get lineStartIndex() {
                return this._structArray.uint32[this._pos4 + 6];
            }
            get lineLength() {
                return this._structArray.uint32[this._pos4 + 7];
            }
            get segment() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get lowerSize() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get upperSize() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get lineOffsetX() {
                return this._structArray.float32[this._pos4 + 10];
            }
            get lineOffsetY() {
                return this._structArray.float32[this._pos4 + 11];
            }
            get writingMode() {
                return this._structArray.uint8[this._pos1 + 48];
            }
            get placedOrientation() {
                return this._structArray.uint8[this._pos1 + 49];
            }
            set placedOrientation(e1) {
                this._structArray.uint8[this._pos1 + 49] = e1;
            }
            get hidden() {
                return this._structArray.uint8[this._pos1 + 50];
            }
            set hidden(e1) {
                this._structArray.uint8[this._pos1 + 50] = e1;
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 13];
            }
            set crossTileID(e1) {
                this._structArray.uint32[this._pos4 + 13] = e1;
            }
            get associatedIconIndex() {
                return this._structArray.int16[this._pos2 + 28];
            }
            get flipState() {
                return this._structArray.uint8[this._pos1 + 58];
            }
            set flipState(e1) {
                this._structArray.uint8[this._pos1 + 58] = e1;
            }
        }
        vu.prototype.size = 60;
        class bu extends ru {
            get(e1) {
                return new vu(this, e1);
            }
        }
        Ya(bu, "PlacedSymbolArray");
        class wu extends Tc {
            get tileAnchorX() {
                return this._structArray.float32[this._pos4 + 0];
            }
            get tileAnchorY() {
                return this._structArray.float32[this._pos4 + 1];
            }
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 5];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 6];
            }
            get rightJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 7];
            }
            get centerJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 8];
            }
            get leftJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 9];
            }
            get verticalPlacedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 10];
            }
            get placedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 11];
            }
            get verticalPlacedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 12];
            }
            get key() {
                return this._structArray.uint16[this._pos2 + 13];
            }
            get textBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 14];
            }
            get textBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 15];
            }
            get verticalTextBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get verticalTextBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get iconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get iconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 19];
            }
            get verticalIconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 20];
            }
            get verticalIconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 21];
            }
            get featureIndex() {
                return this._structArray.uint16[this._pos2 + 22];
            }
            get numHorizontalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 23];
            }
            get numVerticalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 24];
            }
            get numIconVertices() {
                return this._structArray.uint16[this._pos2 + 25];
            }
            get numVerticalIconVertices() {
                return this._structArray.uint16[this._pos2 + 26];
            }
            get useRuntimeCollisionCircles() {
                return this._structArray.uint16[this._pos2 + 27];
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 14];
            }
            set crossTileID(e1) {
                this._structArray.uint32[this._pos4 + 14] = e1;
            }
            get textOffset0() {
                return this._structArray.float32[this._pos4 + 15];
            }
            get textOffset1() {
                return this._structArray.float32[this._pos4 + 16];
            }
            get collisionCircleDiameter() {
                return this._structArray.float32[this._pos4 + 17];
            }
            get zOffset() {
                return this._structArray.float32[this._pos4 + 18];
            }
            set zOffset(e1) {
                this._structArray.float32[this._pos4 + 18] = e1;
            }
            get hasIconTextFit() {
                return this._structArray.uint8[this._pos1 + 76];
            }
            get elevationFeatureIndex() {
                return this._structArray.uint16[this._pos2 + 39];
            }
        }
        wu.prototype.size = 80;
        class Au extends ou {
            get(e1) {
                return new wu(this, e1);
            }
        }
        Ya(Au, "SymbolInstanceArray");
        class Eu extends Lc {
            getoffsetX(e1) {
                return this.float32[1 * e1 + 0];
            }
        }
        Ya(Eu, "GlyphOffsetArray");
        class Iu extends Fc {
            getx(e1) {
                return this.int16[2 * e1 + 0];
            }
            gety(e1) {
                return this.int16[2 * e1 + 1];
            }
        }
        Ya(Iu, "SymbolLineVertexArray");
        class Mu extends Tc {
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 0];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 2];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 3];
            }
            get layoutVertexArrayOffset() {
                return this._structArray.uint16[this._pos2 + 4];
            }
        }
        Mu.prototype.size = 12;
        class Su extends du {
            get(e1) {
                return new Mu(this, e1);
            }
        }
        Ya(Su, "FeatureIndexArray");
        class Tu extends Jc {
            geta_centroid_pos0(e1) {
                return this.uint16[2 * e1 + 0];
            }
            geta_centroid_pos1(e1) {
                return this.uint16[2 * e1 + 1];
            }
        }
        Ya(Tu, "FillExtrusionCentroidArray");
        class zu extends Tc {
            get a_join_normal_inside0() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get a_join_normal_inside1() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get a_join_normal_inside2() {
                return this._structArray.int16[this._pos2 + 2];
            }
        }
        zu.prototype.size = 6;
        class Ru extends Cc {
            get(e1) {
                return new zu(this, e1);
            }
        }
        Ya(Ru, "FillExtrusionWallArray");
        const Pu = Pc([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), Du = Pc([
            {
                name: "a_road_z_offset",
                components: 1,
                type: "Float32"
            }
        ], 4), Fu = Pc([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_height",
                components: 1,
                type: "Float32"
            }
        ], 4), Cu = Pc([
            {
                name: "a_pos_normal_3",
                components: 3,
                type: "Int16"
            }
        ], 4);
        class Ou {
            constructor(e1 = []){
                this.segments = e1;
            }
            _prepareSegment(e1, t1, i, n, r) {
                let o = this.segments.at(-1);
                return e1 > Ou.MAX_VERTEX_ARRAY_LENGTH && _t(`Max vertices per segment is ${Ou.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${e1}`), (!o || o.vertexLength + e1 > Ou.MAX_VERTEX_ARRAY_LENGTH || o.sortKey !== n || void 0 !== r && o && void 0 !== o.batchIndex && o.batchIndex !== r) && (o = {
                    vertexOffset: t1,
                    primitiveOffset: i,
                    vertexLength: 0,
                    primitiveLength: 0
                }, void 0 !== n && (o.sortKey = n), void 0 !== r && (o.batchIndex = r), this.segments.push(o)), o;
            }
            prepareSegment(e1, t1, i, n, r) {
                return this._prepareSegment(e1, t1.length, i.length, n, r);
            }
            get() {
                return this.segments;
            }
            destroy() {
                for (const e1 of this.segments)for(const t1 in e1.vaos)for (const i of e1.vaos[t1].values())i.destroy();
            }
            static simpleSegment(e1, t1, i, n) {
                return new Ou([
                    {
                        vertexOffset: e1,
                        primitiveOffset: t1,
                        vertexLength: i,
                        primitiveLength: n,
                        vaos: {},
                        sortKey: 0
                    }
                ]);
            }
        }
        function Lu(e1, t1) {
            return 256 * (e1 = tt(Math.floor(e1), 0, 255)) + tt(Math.floor(t1), 0, 255);
        }
        Ou.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, Ya(Ou, "SegmentVector");
        const Bu = Pc([
            {
                name: "a_pattern",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio",
                components: 1,
                type: "Float32"
            }
        ]), Vu = Pc([
            {
                name: "a_pattern_b",
                components: 4,
                type: "Uint16"
            }
        ]), Nu = Pc([
            {
                name: "a_dash",
                components: 4,
                type: "Uint16"
            }
        ]);
        class ku {
            constructor(){
                this.ids = [], this.uniqueIds = [], this.positions = [], this.indexed = !1;
            }
            add(e1, t1, i, n) {
                this.ids.push(Uu(e1)), this.positions.push(t1, i, n);
            }
            eachPosition(e1, t1) {
                const i = Uu(e1);
                let n = 0, r = this.ids.length - 1;
                for(; n < r;){
                    const e1 = n + r >> 1;
                    this.ids[e1] >= i ? r = e1 : n = e1 + 1;
                }
                const o = this.ids[n] === i;
                for(; this.ids[n] === i;)t1(this.positions[3 * n], this.positions[3 * n + 1], this.positions[3 * n + 2]), n++;
                return o;
            }
            static serialize(e1, t1) {
                if (0 === e1.ids.length) return {};
                const i = new Float64Array(e1.ids), n = new Uint32Array(e1.positions);
                return ju(i, n, 0, i.length - 1), t1 && (t1.add(i.buffer), t1.add(n.buffer)), {
                    ids: i,
                    positions: n
                };
            }
            static deserialize(e1) {
                const t1 = new ku;
                let i;
                t1.ids = e1.ids || [], t1.positions = e1.positions || [];
                for (const e1 of t1.ids)e1 !== i && t1.uniqueIds.push(e1), i = e1;
                return t1.indexed = !0, t1;
            }
        }
        function Uu(e1) {
            const t1 = +e1;
            return Number.isSafeInteger(t1) ? t1 : en(String(e1));
        }
        function ju(e1, t1, i, n) {
            for(; i < n;){
                const r = e1[i + n >> 1];
                let o = i - 1, a = n + 1;
                for(;;){
                    do o++;
                    while (e1[o] < r);
                    do a--;
                    while (e1[a] > r);
                    if (o >= a) break;
                    Gu(e1, o, a), Gu(t1, 3 * o, 3 * a), Gu(t1, 3 * o + 1, 3 * a + 1), Gu(t1, 3 * o + 2, 3 * a + 2);
                }
                a - i < n - a ? (ju(e1, t1, i, a), i = a + 1) : (ju(e1, t1, a + 1, n), n = a);
            }
        }
        function Gu(e1, t1, i) {
            const n = e1[t1];
            e1[t1] = e1[i], e1[i] = n;
        }
        Ya(ku, "FeaturePositionMap");
        class Hu {
            constructor(e1){
                this.gl = e1.gl, this.initialized = !1;
            }
            fetchUniformLocation(e1, t1) {
                return this.location || this.initialized || (this.location = this.gl.getUniformLocation(e1, t1), this.initialized = !0), !!this.location;
            }
            set(e1, t1, i) {
                throw new Error("Uniform#set() must be implemented by each concrete Uniform");
            }
        }
        class $u extends Hu {
            constructor(e1){
                super(e1), this.current = 0;
            }
            set(e1, t1, i) {
                this.fetchUniformLocation(e1, t1) && this.current !== i && (this.current = i, this.gl.uniform1i(this.location, i));
            }
        }
        class Zu extends Hu {
            constructor(e1){
                super(e1), this.current = 0;
            }
            set(e1, t1, i) {
                this.fetchUniformLocation(e1, t1) && this.current !== i && (this.current = i, this.gl.uniform1f(this.location, i));
            }
        }
        class Wu extends Hu {
            constructor(e1){
                super(e1), this.current = [
                    0,
                    0
                ];
            }
            set(e1, t1, i) {
                this.fetchUniformLocation(e1, t1) && (i[0] === this.current[0] && i[1] === this.current[1] || (this.current = i, this.gl.uniform2f(this.location, i[0], i[1])));
            }
        }
        class qu extends Hu {
            constructor(e1){
                super(e1), this.current = [
                    0,
                    0,
                    0
                ];
            }
            set(e1, t1, i) {
                this.fetchUniformLocation(e1, t1) && (i[0] === this.current[0] && i[1] === this.current[1] && i[2] === this.current[2] || (this.current = i, this.gl.uniform3f(this.location, i[0], i[1], i[2])));
            }
        }
        class Xu extends Hu {
            constructor(e1){
                super(e1), this.current = [
                    0,
                    0,
                    0,
                    0
                ];
            }
            set(e1, t1, i) {
                this.fetchUniformLocation(e1, t1) && (i[0] === this.current[0] && i[1] === this.current[1] && i[2] === this.current[2] && i[3] === this.current[3] || (this.current = i, this.gl.uniform4ui(this.location, i[0], i[1], i[2], i[3])));
            }
        }
        class Yu extends Hu {
            constructor(e1){
                super(e1), this.current = [
                    0,
                    0,
                    0,
                    0
                ];
            }
            set(e1, t1, i) {
                this.fetchUniformLocation(e1, t1) && (i[0] === this.current[0] && i[1] === this.current[1] && i[2] === this.current[2] && i[3] === this.current[3] || (this.current = i, this.gl.uniform4f(this.location, i[0], i[1], i[2], i[3])));
            }
        }
        class Ju extends Hu {
            constructor(e1){
                super(e1), this.current = fn.transparent.toPremultipliedRenderColor(null);
            }
            set(e1, t1, i) {
                this.fetchUniformLocation(e1, t1) && (i.r === this.current.r && i.g === this.current.g && i.b === this.current.b && i.a === this.current.a || (this.current = i, this.gl.uniform4f(this.location, i.r, i.g, i.b, i.a)));
            }
        }
        class Ku extends Hu {
            constructor(e1){
                super(e1), this.current = new Float32Array(16);
            }
            set(e1, t1, i) {
                if (!this.fetchUniformLocation(e1, t1)) return;
                const n = this.current;
                if (i[12] !== n[12] || i[0] !== n[0]) return n.set(i), void this.gl.uniformMatrix4fv(this.location, !1, n);
                for(let e1 = 1; e1 < 16; e1++)if (i[e1] !== n[e1]) {
                    n.set(i), this.gl.uniformMatrix4fv(this.location, !1, n);
                    break;
                }
            }
        }
        class Qu extends Hu {
            constructor(e1){
                super(e1), this.current = new Float32Array(4);
            }
            set(e1, t1, i) {
                if (!this.fetchUniformLocation(e1, t1)) return;
                const n = this.current;
                for(let e1 = 0; e1 < 4; e1++)if (i[e1] !== n[e1]) {
                    n.set(i), this.gl.uniformMatrix2fv(this.location, !1, n);
                    break;
                }
            }
        }
        function eh(e1) {
            return [
                Lu(255 * e1.r, 255 * e1.g),
                Lu(255 * e1.b, 255 * e1.a)
            ];
        }
        function th(e1, t1, i, n, r, o, a, s) {
            return !!e1 && ("composite" === e1.kind || "source" === e1.kind ? "none" === e1.evaluate(new Ls(0, {
                brightness: o,
                worldview: s
            }), t1, i, r, n, a) : "none" === e1.value);
        }
        class ih {
            constructor(e1, t1){
                const i = e1.paint.get(t1), n = e1.paint.get(`${t1}-use-theme`);
                this.value = i.constantOr(void 0), this.uniformNames = hh(t1, e1.type).map((e1)=>`u_${e1}`), this.type = i.property.specification.type, n && (this.lutExpression = n.value);
            }
            static serialize() {
                return null;
            }
            setUniform(e1, t1, i, n, r) {
                const o = n.constantOr(this.value);
                t1.set(e1, r, o instanceof fn ? o.toPremultipliedRenderColor(this.lutExpression && "constant" === this.lutExpression.kind && "none" === this.lutExpression.value ? null : this.context.lut) : o);
            }
            getBinding(e1, t1) {
                return "color" === this.type ? new Ju(e1) : new Zu(e1);
            }
        }
        class nh {
            constructor(e1){
                this.uniformNames = e1.map((e1)=>`u_${e1}`), this.pattern = null, this.patternTransition = null, this.pixelRatio = 1;
            }
            setConstantPatternPositions(e1, t1) {
                this.pixelRatio = e1.pixelRatio || 1, this.pattern = e1.tl.concat(e1.br), this.patternTransition = t1 ? t1.tl.concat(t1.br) : this.pattern;
            }
            setUniform(e1, t1, i, n, r) {
                let o = null;
                "u_pattern" !== r && "u_dash" !== r || (o = this.pattern), "u_pattern_b" === r && (o = this.patternTransition), "u_pixel_ratio" === r && (o = this.pixelRatio), o && t1.set(e1, r, o);
            }
            getBinding(e1, t1) {
                return "u_pattern" === t1 || "u_pattern_b" === t1 || "u_dash" === t1 ? new Xu(e1) : new Zu(e1);
            }
        }
        class rh {
            constructor(e1, t1, i, n){
                this.expression = e1, this.type = i, this.maxValue = 0, this.paintVertexAttributes = t1.map((e1)=>({
                        name: `a_${e1}`,
                        type: "Float32",
                        components: "color" === i ? 2 : 1,
                        offset: 0
                    })), this.paintVertexArray = new n;
            }
            populatePaintArray(e1, t1, i, n, r, o, a, s) {
                const l = this.paintVertexArray.length, c = "composite" === this.expression.kind || "source" === this.expression.kind ? this.expression.evaluate(new Ls(0, {
                    brightness: o,
                    worldview: s
                }), t1, {}, r, n, a) : "constant" === this.expression.kind && this.expression.value, u = th(this.lutExpression, t1, {}, n, r, o, a, s);
                this.paintVertexArray.resize(e1), this._setPaintValue(l, e1, c, u ? null : this.context.lut);
            }
            updatePaintArray(e1, t1, i, n, r, o, a, s) {
                const l = "composite" === this.expression.kind || "source" === this.expression.kind ? this.expression.evaluate({
                    zoom: 0,
                    brightness: a,
                    worldview: s
                }, i, n, void 0, r) : "constant" === this.expression.kind && this.expression.value, c = th(this.lutExpression, i, n, r, void 0, a, void 0, s);
                this._setPaintValue(e1, t1, l, c ? null : this.context.lut);
            }
            _setPaintValue(e1, t1, i, n) {
                if ("color" === this.type) {
                    const r = eh(i.toPremultipliedRenderColor(n));
                    for(let i = e1; i < t1; i++)this.paintVertexArray.emplace(i, r[0], r[1]);
                } else {
                    for(let n = e1; n < t1; n++)this.paintVertexArray.emplace(n, i);
                    this.maxValue = Math.max(this.maxValue, Math.abs(i));
                }
            }
            upload(e1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = e1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.lutExpression && "constant" !== this.lutExpression.kind && (this.lutExpression.isStateDependent || !this.lutExpression.isLightConstant) || "constant" !== this.expression.kind && (this.expression.isStateDependent || !this.expression.isLightConstant)));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
        }
        class oh {
            constructor(e1, t1, i, n, r){
                this.expression = e1, this.uniformNames = t1.map((e1)=>`u_${e1}_t`), this.type = i, this.useIntegerZoom = n, this.maxValue = 0, this.paintVertexAttributes = t1.map((e1)=>({
                        name: `a_${e1}`,
                        type: "Float32",
                        components: "color" === i ? 4 : 2,
                        offset: 0
                    })), this.paintVertexArray = new r;
            }
            populatePaintArray(e1, t1, i, n, r, o, a, s) {
                const l = this.expression.evaluate(new Ls(this.context.zoom, {
                    brightness: o,
                    worldview: s
                }), t1, {}, r, n, a), c = this.expression.evaluate(new Ls(this.context.zoom + 1, {
                    brightness: o,
                    worldview: s
                }), t1, {}, r, n, a), u = th(this.lutExpression, t1, {}, n, r, o, a, s), h = this.paintVertexArray.length;
                this.paintVertexArray.resize(e1), this._setPaintValue(h, e1, l, c, u ? null : this.context.lut);
            }
            updatePaintArray(e1, t1, i, n, r, o, a, s) {
                const l = this.expression.evaluate({
                    zoom: this.context.zoom,
                    brightness: a,
                    worldview: s
                }, i, n, void 0, r), c = this.expression.evaluate({
                    zoom: this.context.zoom + 1,
                    brightness: a,
                    worldview: s
                }, i, n, void 0, r), u = th(this.lutExpression, i, n, r, void 0, a, void 0, s);
                this._setPaintValue(e1, t1, l, c, u ? null : this.context.lut);
            }
            _setPaintValue(e1, t1, i, n, r) {
                if ("color" === this.type) {
                    const o = eh(i.toPremultipliedRenderColor(r)), a = eh(n.toPremultipliedRenderColor(r));
                    for(let i = e1; i < t1; i++)this.paintVertexArray.emplace(i, o[0], o[1], a[0], a[1]);
                } else {
                    for(let r = e1; r < t1; r++)this.paintVertexArray.emplace(r, i, n);
                    this.maxValue = Math.max(this.maxValue, Math.abs(i), Math.abs(n));
                }
            }
            upload(e1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = e1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
            setUniform(e1, t1, i, n, r) {
                const o = this.useIntegerZoom ? Math.floor(i.zoom) : i.zoom, a = tt(this.expression.interpolationFactor(o, this.context.zoom, this.context.zoom + 1), 0, 1);
                t1.set(e1, r, a);
            }
            getBinding(e1, t1) {
                return new Zu(e1);
            }
        }
        class ah {
            constructor(e1, t1, i, n, r){
                this.expression = e1, this.layerId = r, this.paintVertexAttributes = ("array" === i ? Nu : Bu).members;
                for(let e1 = 0; e1 < t1.length; ++e1);
                this.paintVertexArray = new n, this.paintTransitionVertexArray = new Hc;
            }
            populatePaintArray(e1, t1, i, n) {
                const r = this.paintVertexArray.length;
                this.paintVertexArray.resize(e1), this._setPaintValues(r, e1, t1.patterns && t1.patterns[this.layerId], i);
            }
            updatePaintArray(e1, t1, i, n, r, o, a) {
                this._setPaintValues(e1, t1, i.patterns && i.patterns[this.layerId], o);
            }
            _setPaintValues(e1, t1, i, n) {
                if (!n || !i) return;
                const r = n[i[0]], o = n[i[1]];
                if (r) {
                    if (r) {
                        const { tl: i, br: n, pixelRatio: o } = r;
                        for(let r = e1; r < t1; r++)this.paintVertexArray.emplace(r, i[0], i[1], n[0], n[1], o);
                    }
                    if (o) {
                        this.paintTransitionVertexArray.resize(this.paintVertexArray.length);
                        const { tl: i, br: n } = o;
                        for(let r = e1; r < t1; r++)this.paintTransitionVertexArray.emplace(r, i[0], i[1], n[0], n[1]);
                    }
                }
            }
            upload(e1) {
                const t1 = this.expression.isStateDependent || !this.expression.isLightConstant;
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer = e1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, t1)), this.paintTransitionVertexArray && this.paintTransitionVertexArray.length && (this.paintTransitionVertexBuffer = e1.createVertexBuffer(this.paintTransitionVertexArray, Vu.members, t1));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy(), this.paintTransitionVertexBuffer && this.paintTransitionVertexBuffer.destroy();
            }
        }
        function sh(e1) {
            return e1 instanceof rh || e1 instanceof oh || e1 instanceof ah;
        }
        class lh {
            constructor(e1, t1, i = ()=>!0){
                this.binders = {}, this._buffers = [], this.context = t1;
                const n = [], r = e1;
                for(const o in e1.paint._values){
                    const a = r.paint.get(o);
                    if (o.endsWith("-use-theme")) continue;
                    if (!i(o)) continue;
                    if (!(a instanceof Us && Ta(a.property.specification))) continue;
                    const s = hh(o, e1.type), l = a.value, c = a.property.specification.type, u = !!a.property.useIntegerZoom, h = "line-dasharray" === o || o.endsWith("pattern"), d = r.paint.get(`${o}-use-theme`), f = "line-dasharray" === o && "constant" !== r.layout.get("line-cap").value.kind || d && "constant" !== d.value.kind;
                    if ("constant" !== l.kind || f) {
                        if ("source" === l.kind || f || h) {
                            const t1 = ph(o, c, "source");
                            this.binders[o] = h ? new ah(l, s, c, t1, e1.id) : new rh(l, s, c, t1), n.push(`/a_${o}`);
                        } else {
                            const e1 = ph(o, c, "composite");
                            this.binders[o] = new oh(l, s, c, u, e1), n.push(`/z_${o}`);
                        }
                    } else this.binders[o] = h ? new nh(s) : new ih(r, o), n.push(`/u_${o}`);
                    this.binders[o].context = t1, d && (this.binders[o].lutExpression = d.value);
                }
                this.cacheKey = n.sort().join("");
            }
            updateExpressions(e1) {
                const t1 = e1;
                for(const e1 in this.binders){
                    const i = this.binders[e1] || (this.binders[e1] = new ih(t1, e1));
                    i.context = this.context, sh(i) && (i.expression = t1.paint.get(e1).value);
                }
            }
            getMaxValue(e1) {
                const t1 = this.binders[e1];
                return t1 instanceof rh || t1 instanceof oh ? t1.maxValue : 0;
            }
            populatePaintArrays(e1, t1, i, n, r, o, a, s) {
                for(const l in this.binders){
                    const c = this.binders[l];
                    sh(c) && c.populatePaintArray(e1, t1, i, n, r, o, a, s);
                }
            }
            setConstantPatternPositions(e1, t1) {
                for(const i in this.binders){
                    const n = this.binders[i];
                    n instanceof nh && n.setConstantPatternPositions(e1, t1);
                }
            }
            getPatternTransitionVertexBuffer(e1) {
                const t1 = this.binders[e1];
                return t1 instanceof ah ? t1.paintTransitionVertexBuffer : null;
            }
            updatePaintArrays(e1, t1, i, n, r, o, a, s, l, c) {
                let u = !1;
                const h = Object.keys(e1), d = 0 !== h.length && !s, f = d ? h : t1.uniqueIds;
                this.context.lut = r.lut;
                for(const h in this.binders){
                    const p = this.binders[h];
                    if (!sh(p)) continue;
                    const _ = p.expression;
                    if ("constant" === _.kind || (!_.isStateDependent || s) && !1 !== _.isLightConstant) continue;
                    const m = r.paint.get(h);
                    p.expression = m.value;
                    const g = (t1, i)=>{
                        const r = e1[i.toString()];
                        return t1.eachPosition(i, (e1, t1, i)=>{
                            p.updatePaintArray(t1, i, n.feature(e1), r, o, a, l, c);
                        });
                    };
                    let y = !d;
                    for (const e1 of f)y = g(t1, e1) || y;
                    if (!d) for (const e1 of i.uniqueIds)g(i, e1);
                    u = u || y;
                }
                return u;
            }
            defines() {
                const e1 = [];
                for(const t1 in this.binders){
                    const i = this.binders[t1];
                    (i instanceof ih || i instanceof nh) && e1.push(...i.uniformNames.map((e1)=>`#define HAS_UNIFORM_${e1}`));
                }
                return e1;
            }
            getPaintVertexBuffers() {
                return this._buffers;
            }
            getUniforms(e1) {
                const t1 = [];
                for(const i in this.binders){
                    const n = this.binders[i];
                    if (n instanceof ih || n instanceof nh || n instanceof oh) for (const r of n.uniformNames)t1.push({
                        name: r,
                        property: i,
                        binding: n.getBinding(e1, r)
                    });
                }
                return t1;
            }
            setUniforms(e1, t1, i, n, r) {
                for (const { name: t1, property: o, binding: a } of i)this.binders[o].setUniform(e1, a, r, n.get(o), t1);
            }
            updatePaintBuffers() {
                this._buffers = [];
                for(const e1 in this.binders){
                    const t1 = this.binders[e1];
                    sh(t1) && t1.paintVertexBuffer && this._buffers.push(t1.paintVertexBuffer), t1 instanceof ah && t1.paintTransitionVertexBuffer && this._buffers.push(t1.paintTransitionVertexBuffer);
                }
            }
            upload(e1) {
                for(const t1 in this.binders){
                    const i = this.binders[t1];
                    sh(i) && i.upload(e1);
                }
                this.updatePaintBuffers();
            }
            destroy() {
                for(const e1 in this.binders){
                    const t1 = this.binders[e1];
                    sh(t1) && t1.destroy();
                }
            }
        }
        class ch {
            constructor(e1, t1, i = ()=>!0){
                this.programConfigurations = {};
                for (const n of e1)this.programConfigurations[n.id] = new lh(n, t1, i);
                this.needsUpload = !1, this._featureMap = new ku, this._featureMapWithoutIds = new ku, this._bufferOffset = 0, this._idlessCounter = 0;
            }
            populatePaintArrays(e1, t1, i, n, r, o, a, s, l) {
                for(const i in this.programConfigurations)this.programConfigurations[i].populatePaintArrays(e1, t1, n, r, o, a, s, l);
                void 0 !== t1.id ? this._featureMap.add(t1.id, i, this._bufferOffset, e1) : (this._featureMapWithoutIds.add(this._idlessCounter, i, this._bufferOffset, e1), this._idlessCounter += 1), this._bufferOffset = e1, this.needsUpload = !0;
            }
            updatePaintArrays(e1, t1, i, n, r, o, a, s) {
                for (const l of i){
                    const i = this.programConfigurations[l.id];
                    i && (this.needsUpload = i.updatePaintArrays(e1, this._featureMap, this._featureMapWithoutIds, t1, l, n, r, o, a || 0, s) || this.needsUpload);
                }
            }
            get(e1) {
                return this.programConfigurations[e1];
            }
            upload(e1) {
                if (this.needsUpload) {
                    for(const t1 in this.programConfigurations)this.programConfigurations[t1].upload(e1);
                    this.needsUpload = !1;
                }
            }
            destroy() {
                for(const e1 in this.programConfigurations)this.programConfigurations[e1].destroy();
            }
            updateExpressions(e1) {
                const t1 = new Set;
                for (const i of e1){
                    const e1 = this.programConfigurations[i.id];
                    e1 && (e1.updateExpressions(i), t1.add(i.id));
                }
                for(const e1 in this.programConfigurations)t1.has(e1) || delete this.programConfigurations[e1];
            }
        }
        const uh = {
            "text-opacity": [
                "opacity"
            ],
            "icon-opacity": [
                "opacity"
            ],
            "text-occlusion-opacity": [
                "occlusion_opacity"
            ],
            "icon-occlusion-opacity": [
                "occlusion_opacity"
            ],
            "text-color": [
                "fill_color"
            ],
            "icon-color": [
                "fill_color"
            ],
            "text-emissive-strength": [
                "emissive_strength"
            ],
            "icon-emissive-strength": [
                "emissive_strength"
            ],
            "text-halo-color": [
                "halo_color"
            ],
            "icon-halo-color": [
                "halo_color"
            ],
            "text-halo-blur": [
                "halo_blur"
            ],
            "icon-halo-blur": [
                "halo_blur"
            ],
            "text-halo-width": [
                "halo_width"
            ],
            "icon-halo-width": [
                "halo_width"
            ],
            "symbol-z-offset": [
                "z_offset"
            ],
            "line-gap-width": [
                "gapwidth"
            ],
            "line-pattern": [
                "pattern",
                "pixel_ratio",
                "pattern_b"
            ],
            "fill-pattern": [
                "pattern",
                "pixel_ratio",
                "pattern_b"
            ],
            "fill-extrusion-pattern": [
                "pattern",
                "pixel_ratio",
                "pattern_b"
            ],
            "line-dasharray": [
                "dash"
            ],
            "fill-bridge-guard-rail-color": [
                "structure_color"
            ],
            "fill-tunnel-structure-color": [
                "structure_color"
            ]
        };
        function hh(e1, t1) {
            return uh[e1] || [
                e1.replace(`${t1}-`, "").replace(/-/g, "_")
            ];
        }
        const dh = {
            "line-pattern": {
                source: Gc,
                composite: Gc
            },
            "fill-pattern": {
                source: Gc,
                composite: Gc
            },
            "fill-extrusion-pattern": {
                source: Gc,
                composite: Gc
            },
            "line-dasharray": {
                source: Hc,
                composite: Hc
            }
        }, fh = {
            color: {
                source: hu,
                composite: qc
            },
            number: {
                source: Lc,
                composite: hu
            }
        };
        function ph(e1, t1, i) {
            const n = dh[e1];
            return n && n[i] || fh[t1][i];
        }
        Ya(ih, "ConstantBinder"), Ya(nh, "PatternConstantBinder", {
            omit: [
                "context"
            ]
        }), Ya(rh, "SourceExpressionBinder", {
            omit: [
                "expression",
                "context"
            ]
        }), Ya(ah, "PatternCompositeBinder", {
            omit: [
                "expression",
                "context"
            ]
        }), Ya(oh, "CompositeExpressionBinder", {
            omit: [
                "expression",
                "context"
            ]
        }), Ya(lh, "ProgramConfiguration", {
            omit: [
                "_buffers"
            ]
        }), Ya(ch, "ProgramConfigurationSet");
        class _h {
            constructor(e1, t1, i){
                this.layoutVertexArray = new Fc, this.indexArray = new nu, this.lineIndexArray = new Jc, this.triangleSegments = new Ou, this.lineSegments = new Ou, this.programConfigurations = new ch(e1, {
                    zoom: t1,
                    lut: i
                }), this.uploaded = !1;
            }
            update(e1, t1, i, n, r, o, a, s) {
                this.programConfigurations.updatePaintArrays(e1, t1, r, i, n, o, a, s);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            needsUpload() {
                return this.programConfigurations.needsUpload;
            }
            upload(e1) {
                this.uploaded || (this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, Pu.members), this.indexBuffer = e1.createIndexBuffer(this.indexArray), this.lineIndexBuffer = e1.createIndexBuffer(this.lineIndexArray)), this.programConfigurations.upload(e1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.lineIndexBuffer.destroy(), this.programConfigurations.destroy(), this.triangleSegments.destroy(), this.lineSegments.destroy());
            }
            populatePaintArrays(e1, t1, i, n, r, o, a) {
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e1, t1, i, n, r, o, void 0, a);
            }
        }
        Ya(_h, "FillBufferData");
        class mh {
            constructor(e1){
                this.zoom = e1.zoom, this.pixelRatio = e1.pixelRatio, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.hasPattern = !1, this.patternFeatures = [], this.lut = e1.lut, this.bufferData = new _h(e1.layers, e1.zoom, e1.lut), this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.projection = e1.projection, this.sourceLayerIndex = e1.sourceLayerIndex, this.sourceLayerName = e1.sourceLayerName || "", this.worldview = e1.worldview, this.hasAppearances = null;
            }
            updateFootprints(e1, t1) {}
            updateAppearances(e1, t1, i, n) {
                return {
                    hasLayoutChanges: !1,
                    hasUboChanges: !1
                };
            }
            populate(e1, t1, i, n) {
                this.hasPattern = Xl("fill", this.layers, this.pixelRatio, t1);
                const r = this.layers[0].layout.get("fill-sort-key"), o = [], a = new Ls(this.zoom, {
                    worldview: this.worldview,
                    activeFloors: t1.activeFloors
                });
                for (const { feature: s, id: l, index: c, sourceLayerIndex: u } of e1){
                    const e1 = this.layers[0]._featureFilter.needGeometry, h = Mc(s, e1);
                    if (!this.layers[0]._featureFilter.filter(a, h, i)) continue;
                    const d = r ? r.evaluate(h, {}, i, t1.availableImages) : void 0, f = {
                        id: l,
                        properties: s.properties,
                        type: s.type,
                        sourceLayerIndex: u,
                        index: c,
                        geometry: Ic(s, h, e1, i, n),
                        patterns: {},
                        sortKey: d
                    };
                    o.push(f);
                }
                r && o.sort((e1, t1)=>e1.sortKey - t1.sortKey);
                for (const n of o){
                    const { geometry: r, index: o, sourceLayerIndex: a } = n;
                    if (this.hasPattern) {
                        const e1 = Yl("fill", this.layers, n, this.zoom, this.pixelRatio, t1);
                        this.patternFeatures.push(e1);
                    } else this.addFeature(n, r, o, i, {}, t1.availableImages, t1.brightness, t1.elevationFeatures);
                    t1.featureIndex.insert(e1[o].feature, r, o, a, this.index);
                }
                !this.hasPattern && this.hdExt && this.hdExt.buildFrcSegments(this);
            }
            update(e1, t1, i, n, r, o, a) {
                this.bufferData.update(e1, t1, i, n, r, o, a, this.worldview), this.hdExt && this.hdExt.update(e1, t1, i, n, r, o, a, this.worldview);
            }
            updateExpressions(e1) {
                this.bufferData.programConfigurations.updateExpressions(e1), this.hdExt && this.hdExt.updateExpressions(e1);
            }
            addFeatures(e1, t1, i, n, r, o) {
                for (const r of this.patternFeatures)this.addFeature(r, r.geometry, r.index, t1, i, n, o, e1.elevationFeatures);
                this.hdExt && this.hdExt.buildFrcSegments(this);
            }
            isEmpty() {
                return this.bufferData.isEmpty() && (!this.hdExt || this.hdExt.isEmpty());
            }
            uploadPending() {
                return !this.uploaded || this.bufferData.needsUpload() || null != this.hdExt && this.hdExt.needsUpload();
            }
            upload(e1) {
                this.bufferData.upload(e1), this.hdExt && this.hdExt.upload(e1);
            }
            destroy() {
                this.bufferData.destroy(), this.hdExt && this.hdExt.destroy();
            }
            addFeature(e1, t1, i, n, r, o = [], a, s) {
                const l = this.hdExt ? this.hdExt.trackFeatureFrc(e1.properties) : null, c = this.bufferData.indexArray.length, u = Ve(t1, 500);
                null != this.hdExt && this.hdExt.handleFeature(e1, u, i, n, s, this) || this.addGeometry(u, this.bufferData), this.bufferData.populatePaintArrays(e1, i, r, o, n, a, this.worldview), this.hdExt && this.hdExt.populatePaintArrays(e1, i, r, o, n, a, this.worldview), this.hdExt && this.hdExt.recordFeatureRange(this, c, this.bufferData.indexArray.length, l);
            }
            addGeometry(e1, t1, i, n) {
                let r = Number.POSITIVE_INFINITY, o = Number.NEGATIVE_INFINITY, a = null;
                i && (a = i.elevationSampler.constantElevation(i.elevation, i.bias), null != a && (r = a, o = a));
                const s = i ? t1 : null, l = (e1, t1, n)=>{
                    if (null != i) {
                        if (t1.push(e1), null != a) s.elevatedLayoutVertexArray.emplaceBack(a), n.push(a);
                        else {
                            const t1 = i.elevationSampler.pointElevation(e1, i.elevation, i.bias);
                            s.elevatedLayoutVertexArray.emplaceBack(t1), n.push(t1), r = Math.min(r, t1), o = Math.max(o, t1);
                        }
                    }
                };
                for (const r of e1){
                    let e1 = 0;
                    for (const t1 of r)e1 += t1.length;
                    const o = t1.triangleSegments.prepareSegment(e1, t1.layoutVertexArray, t1.indexArray), a = o.vertexLength, s = [], c = [], u = [], h = [], d = [], f = t1.layoutVertexArray.length;
                    for (const e1 of r){
                        if (0 === e1.length) continue;
                        e1 !== r[0] && c.push(s.length / 2);
                        const n = t1.lineSegments.prepareSegment(e1.length, t1.layoutVertexArray, t1.lineIndexArray), o = n.vertexLength;
                        i && d.push(t1.layoutVertexArray.length - f), l(e1[0], u, h), t1.layoutVertexArray.emplaceBack(e1[0].x, e1[0].y), t1.lineIndexArray.emplaceBack(o + e1.length - 1, o), s.push(e1[0].x), s.push(e1[0].y);
                        for(let i = 1; i < e1.length; i++)l(e1[i], u, h), t1.layoutVertexArray.emplaceBack(e1[i].x, e1[i].y), t1.lineIndexArray.emplaceBack(o + i - 1, o + i), s.push(e1[i].x), s.push(e1[i].y);
                        n.vertexLength += e1.length, n.primitiveLength += e1.length;
                    }
                    const p = wl(s, c);
                    for(let e1 = 0; e1 < p.length; e1 += 3)t1.indexArray.emplaceBack(a + p[e1], a + p[e1 + 1], a + p[e1 + 2]);
                    if (p.length > 0 && i && n) {
                        const e1 = i.elevation.isTunnel(), t1 = i.elevation.safeArea, r = n.addVertices(u, h);
                        n.addTriangles(p, r, e1);
                        const o = d.length;
                        if (o > 0) {
                            for(let a = 0; a < o - 1; a++)n.addRenderableRing(i.index, d[a] + r, d[a + 1] - d[a], e1, t1, i.featureInfo);
                            n.addRenderableRing(i.index, d[o - 1] + r, u.length - d[o - 1], e1, t1, i.featureInfo);
                        }
                    }
                    o.vertexLength += e1, o.primitiveLength += p.length / 3;
                }
                return [
                    r,
                    o
                ];
            }
        }
        Ya(mh, "FillBucket", {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        const gh = Pc([
            {
                name: "a_pos_normal",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint8"
            },
            {
                name: "a_linesofar",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_feature_index",
                components: 1,
                type: "Float32"
            }
        ], 4), yh = Pc([
            {
                name: "a_z_offset_width",
                components: 4,
                type: "Float32"
            }
        ], 4), xh = Pc([
            {
                name: "a_elevation_id_col",
                components: 3,
                type: "Float32"
            }
        ], 4), vh = Pc([
            {
                name: "a_elevation_ground_scale",
                components: 1,
                type: "Float32"
            }
        ], 4), { members: bh } = gh, wh = Pc([
            {
                name: "a_packed",
                components: 3,
                type: "Float32"
            }
        ]), { members: Ah } = wh, Eh = Pc([
            {
                name: "a_pattern_data",
                components: 3,
                type: "Float32"
            }
        ]), { members: Ih } = Eh, Mh = new Float32Array(1), Sh = new Uint32Array(Mh.buffer);
        function Th(e1) {
            return Mh[0] = e1, Sh[0];
        }
        const zh = new WeakMap;
        let Rh = null;
        class Ph {
            constructor(e1, t1, i, n){
                this.batchIndex = t1, this.headerBuffer = null, this.propertiesBuffer = null, this.blockIndicesBuffer = null, this.context = e1 || null, this.propsDwords = i, this.totalBytes = 4 * this.propsDwords, this.headerData = n, this.propertiesData = new Float32Array(this.propsDwords), this._headerDirty = !0, this._propsDirtyMin = -1, this._propsDirtyMax = -1, this._blockIndicesDirty = 3 === this._blockNames().length, e1 && this._initBuffers(e1);
            }
            _initBuffers(e1) {
                const t1 = e1.gl;
                if (this.totalBytes > e1.maxUniformBlockSize) throw new Error(`UBO size ${this.totalBytes} exceeds device limit ${e1.maxUniformBlockSize}`);
                t1.isContextLost() || (this.headerBuffer = t1.createBuffer(), t1.bindBuffer(t1.UNIFORM_BUFFER, this.headerBuffer), t1.bufferData(t1.UNIFORM_BUFFER, this._headerBytes(), t1.DYNAMIC_DRAW), this.propertiesBuffer = t1.createBuffer(), t1.bindBuffer(t1.UNIFORM_BUFFER, this.propertiesBuffer), t1.bufferData(t1.UNIFORM_BUFFER, this.totalBytes, t1.DYNAMIC_DRAW), 3 === this._blockNames().length && (this.blockIndicesBuffer = t1.createBuffer(), t1.bindBuffer(t1.UNIFORM_BUFFER, this.blockIndicesBuffer), t1.bufferData(t1.UNIFORM_BUFFER, this.totalBytes, t1.DYNAMIC_DRAW)), t1.bindBuffer(t1.UNIFORM_BUFFER, null));
            }
            markHeaderDirty() {
                this._headerDirty = !0;
            }
            writeDataDrivenBlock(e1, t1, i = 0) {
                const n = this.headerData, r = 4 * n[2];
                if (0 === r) return;
                const o = t1 * r;
                if (o + r > this.propertiesData.length) throw new Error(`UBO write out of bounds: feature index ${t1} exceeds propertiesData capacity`);
                const a = n[0], s = this._propCount();
                for(let t1 = 0; t1 < s; t1++)a & 1 << t1 && (i & 1 << t1 || this._copyFromFlat(o + 4 * n[3 + t1], t1, e1));
                (-1 === this._propsDirtyMin || o < this._propsDirtyMin) && (this._propsDirtyMin = o);
                const l = o + r;
                l > this._propsDirtyMax && (this._propsDirtyMax = l);
            }
            rightSizeForTransfer() {
                const e1 = -1 === this._propsDirtyMax ? 0 : this._propsDirtyMax;
                e1 < this.propertiesData.length && (this.propertiesData = this.propertiesData.slice(0, e1));
            }
            upload(e1) {
                this.context || (this.context = e1);
                const t1 = e1.gl, i = 3 === this._blockNames().length;
                this.headerBuffer && this.propertiesBuffer && (!i || this.blockIndicesBuffer) || this._initBuffers(e1);
                let n = !1;
                if (this._headerDirty && (t1.bindBuffer(t1.UNIFORM_BUFFER, this.headerBuffer), t1.bufferSubData(t1.UNIFORM_BUFFER, 0, this.headerData), this._headerDirty = !1, n = !0), -1 !== this._propsDirtyMin) {
                    const e1 = this._propsDirtyMin, i = this._propsDirtyMax;
                    t1.bindBuffer(t1.UNIFORM_BUFFER, this.propertiesBuffer), t1.bufferSubData(t1.UNIFORM_BUFFER, 4 * e1, this.propertiesData, e1, i - e1), this._propsDirtyMin = -1, this._propsDirtyMax = -1, n = !0;
                }
                this._blockIndicesDirty && (t1.bindBuffer(t1.UNIFORM_BUFFER, this.blockIndicesBuffer), t1.bufferSubData(t1.UNIFORM_BUFFER, 0, function(e1) {
                    let t1 = Rh;
                    if (!t1) {
                        t1 = Rh = new Uint32Array(e1);
                        for(let i = 0; i < e1; i++)t1[i] = i;
                    }
                    return t1;
                }(this.propsDwords)), this._blockIndicesDirty = !1, n = !0), n && t1.bindBuffer(t1.UNIFORM_BUFFER, null);
            }
            bind(e1, t1) {
                const i = e1.gl;
                let n = zh.get(t1);
                if (void 0 === n) {
                    const e1 = this._blockNames();
                    n = 0;
                    for(let r = 0; r < e1.length; r++){
                        const o = i.getUniformBlockIndex(t1, e1[r]);
                        o !== i.INVALID_INDEX && (i.uniformBlockBinding(t1, o, r), n |= 1 << r);
                    }
                    zh.set(t1, n);
                }
                1 & n && this.headerBuffer && i.bindBufferBase(i.UNIFORM_BUFFER, 0, this.headerBuffer), 2 & n && this.propertiesBuffer && i.bindBufferBase(i.UNIFORM_BUFFER, 1, this.propertiesBuffer), 4 & n && this.blockIndicesBuffer && i.bindBufferBase(i.UNIFORM_BUFFER, 2, this.blockIndicesBuffer);
            }
            destroy() {
                if (this.context) {
                    const e1 = this.context.gl;
                    this.headerBuffer && (e1.deleteBuffer(this.headerBuffer), this.headerBuffer = null), this.propertiesBuffer && (e1.deleteBuffer(this.propertiesBuffer), this.propertiesBuffer = null), this.blockIndicesBuffer && (e1.deleteBuffer(this.blockIndicesBuffer), this.blockIndicesBuffer = null);
                }
            }
        }
        const Dh = class e1 extends Ph {
            _headerBytes() {
                return e1.HEADER_BYTES;
            }
            _propCount() {
                return 12;
            }
            _blockNames() {
                return [
                    "LinePaintPropertiesHeaderUniform",
                    "LinePaintPropertiesUniform"
                ];
            }
            _copyFromFlat(t1, i, n) {
                const r = e1.EVAL_FLAT_OFFSETS[i];
                this.propertiesData.set(n.subarray(r, r + 4), t1);
            }
        };
        Dh.HEADER_DWORDS = 20, Dh.HEADER_BYTES = 80, Dh.LINE_HEADER_SHARED_ZOOM = 16, Dh.EVAL_FLAT_OFFSETS = [
            0,
            4,
            8,
            12,
            16,
            20,
            24,
            28,
            32,
            36,
            40,
            44
        ], Dh.EVAL_FLAT_TOTAL = 48;
        let Fh = Dh;
        function Ch(e1) {
            if (!(e1 instanceof Us)) return !1;
            const t1 = e1.value;
            return ("source" === t1.kind || "composite" === t1.kind) && t1.isStateDependent;
        }
        Ya(Fh, "LinePropertiesUBO", {
            omit: [
                "headerBuffer",
                "propertiesBuffer",
                "blockIndicesBuffer"
            ]
        });
        const Oh = new WeakMap, Lh = {
            type: 1,
            id: void 0,
            properties: {},
            geometry: []
        };
        class Bh {
            _immutableAfterPopulateMask() {
                return 0;
            }
            constructor(e1, t1, i, n = "", r){
                this.layer = e1, this.zoom = t1, this.lut = i, this.worldview = n, this.uboSizeDwords = r || 4096, this.allFeatureVtIndices = [], this.allFeatureIds = [], this.featureVertexRangesFromId = null, this.featureVertexRangesFromVtIndex = null, this.ubos = [], this.featureCount = 0, this.cachedConstantUniforms = null, this.cachedConstantBrightness = void 0, this.cachedConstantPaint = null;
            }
            _finishInitialization() {
                const e1 = this._propNames().length, t1 = this._headerDwords(), i = 4 * t1, n = new ArrayBuffer(i + 9 * e1);
                this.header = new Uint32Array(n, 0, t1), this.sharedZoomRanges = new Float32Array(n, i, 2 * e1), this.zoomDependency = new Uint8Array(n, i + 8 * e1, e1), this._floorZoom = Math.floor(this.zoom), this.updateHeader(), this.isAllConstant = 0 === this.header[0];
                const r = 4 * this.header[2];
                this.maxFeaturesPerBatch = 0 === r ? Number.MAX_SAFE_INTEGER : Math.floor(this.uboSizeDwords / r);
            }
            _computeZoomRange(e1, t1, i, n) {
                let r = 0, o = 1;
                const a = !e1 || "composite" !== e1.kind && "camera" !== e1.kind ? null : e1.zoomStops;
                if (a && a.length > 0) {
                    if (null == e1.interpolationType) {
                        r = o = 1;
                        for (const e1 of a)if (e1 > t1 && e1 < t1 + 1) {
                            r = o = e1 - t1;
                            break;
                        }
                    } else a[0] > t1 && a[0] < t1 + 1 && (r = a[0] - t1);
                }
                i[n] = r, i[n + 1] = o;
            }
            _resolveProp(e1, t1, i = !1, n) {
                const r = this._paintGet(e1);
                if (!r || "function" != typeof r.isConstant || !r.isConstant()) return r;
                const o = this._layerUnevaluated(e1);
                return this._unbakeCamera(r, o);
            }
            _unbakeCamera(e1, t1) {
                const i = t1 && t1.expression;
                if (!i || "camera" !== i.kind) return e1;
                let n = Oh.get(t1);
                return n || (n = new Us(e1.property, i, e1.parameters, e1.iconImageUseTheme), Oh.set(t1, n)), n;
            }
            _layerUnevaluated(e1) {
                return this.layer.getPaintPropertyValue(e1);
            }
            _zoomExprOf(e1) {
                const t1 = e1 && e1.expression;
                return !t1 || "composite" !== t1.kind && "camera" !== t1.kind ? null : t1;
            }
            _evalAt(e1, t1, i) {
                return e1.property.evaluate(e1.value, t1, i.feature, i.featureState, i.canonical, i.availableImages, e1.iconImageUseTheme, i.formattedSection);
            }
            _paintGet(e1) {
                return this.layer.paint._values[e1];
            }
            _effectiveLut(e1, t1, i, n, r, o, a) {
                return function(e1, t1, i, n, r, o, a, s) {
                    return !!e1 && ("constant" === e1.kind ? "none" === e1.value : "none" === e1.evaluate({
                        zoom: 0,
                        brightness: o,
                        worldview: s
                    }, t1, i, r, n, a));
                }(e1 && "string" != typeof e1 ? e1.value : void 0, t1, i, n, r, o, a, this.worldview) ? null : this.lut;
            }
            _writeZoomRange(e1, t1) {
                this._computeZoomRange(e1 && e1.value, this._floorZoom, this._flatScratch(), t1);
            }
            _writePropertyZoomRange(e1, t1, i, n, r) {
                const o = this._flatScratch();
                i ? this._writeZoomRange(n, r) : t1 ? (o[r] = this.sharedZoomRanges[2 * e1], o[r + 1] = this.sharedZoomRanges[2 * e1 + 1]) : (o[r] = 0, o[r + 1] = 0);
            }
            _evaluateColorValue(e1, t1, i, n, r, o, a) {
                const s = this._resolveProp(e1, o.activeAppearance, !1, o.formattedSection), l = this._flatScratch();
                if (r >= 0 && this._writePropertyZoomRange(t1, i, n, s, r), !s) return l[a] = 0, l[a + 1] = 0, l[a + 2] = 0, void (l[a + 3] = 1);
                const c = this._resolveProp(`${e1}-use-theme`, o.activeAppearance, !0), u = this._effectiveLut(c, o.feature, o.featureState, o.availableImages, o.canonical, o.params.brightness, o.formattedSection), h = (s.isConstant() ? s.constantOr(fn.transparent) : this._evalAt(s, o.params, o) || fn.transparent).toNonPremultipliedRenderColor(u);
                if (l[a] = Lu(255 * h.r, 255 * h.g), l[a + 1] = Lu(255 * h.b, 255 * h.a), i) {
                    const e1 = (this._evalAt(s, o.paramsNext, o) || fn.transparent).toNonPremultipliedRenderColor(u);
                    l[a + 2] = Lu(255 * e1.r, 255 * e1.g), l[a + 3] = Lu(255 * e1.b, 255 * e1.a);
                } else l[a + 2] = l[a], l[a + 3] = l[a + 1];
            }
            _evaluateFloatValue(e1, t1, i, n, r, o, a, s) {
                const l = this._resolveProp(e1, o.activeAppearance), c = this._flatScratch();
                this._writePropertyZoomRange(t1, i, n, l, r);
                const u = (l ? l.isConstant() ? l.constantOr(s) : this._evalAt(l, o.params, o) : s) ?? s;
                if (c[a] = u, i) {
                    const e1 = this._evalAt(l, o.paramsNext, o);
                    c[a + 1] = e1 ?? s;
                } else c[a + 1] = u;
            }
            evaluateAllProperties(e1, t1, i, n, r, o, a) {
                const s = {
                    brightness: r,
                    worldview: this.worldview
                }, l = {
                    feature: e1,
                    featureState: t1,
                    canonical: i,
                    availableImages: n,
                    params: new Ls(this.zoom, s),
                    paramsNext: new Ls(this.zoom + 1, s),
                    formattedSection: o,
                    activeAppearance: a
                }, c = this._propNames().length;
                for(let e1 = 0; e1 < c; e1++)this._evaluatePropertyAt(e1, l);
                return this._flatScratch();
            }
            hasStateDependentPaint(e1) {
                const t1 = e1.paint;
                for (const e1 of this._propNames())if (Ch(t1._values[e1])) return !0;
                return !1;
            }
            hasLightDependentBlocks(e1) {
                const t1 = this.header[0], i = this._propNames();
                for(let n = 0; n < i.length; n++)if (t1 & 1 << n && this._dependsOnLight(e1, i[n])) return !0;
                return !1;
            }
            _dependsOnLight(e1, t1) {
                const i = e1.getPaintPropertyValue(t1);
                return !!i && !!(2 & i.deps);
            }
            getCurrentBatchIndex() {
                return 0 === this.maxFeaturesPerBatch ? 0 : Math.floor(this.featureCount / this.maxFeaturesPerBatch);
            }
            _writeFeatureBlock(e1, t1) {
                const i = this.isAllConstant ? 0 : e1, n = Math.floor(i / this.maxFeaturesPerBatch), r = this.ubos[n];
                return !!r && (r.writeDataDrivenBlock(t1, i % this.maxFeaturesPerBatch, this._immutableAfterPopulateMask()), !0);
            }
            _reevaluateAt(e1, t1, i, n, r, o) {
                if (!t1) return;
                const a = this.allFeatureVtIndices[e1], s = t1.feature(a);
                if (!s) return;
                const l = this.allFeatureIds[e1], c = null != l && r[l] || {}, u = {
                    type: s.type,
                    id: l,
                    properties: s.properties || {},
                    geometry: []
                }, h = this.activeAppearanceByVtIndex ? this.activeAppearanceByVtIndex.get(a) : void 0, d = this.evaluateAllProperties(u, c, i, n, o, (this.allFormattedSections ? this.allFormattedSections[e1] : void 0) || void 0, h);
                this._writeFeatureBlock(e1, d);
            }
            _ensureRangeMaps() {
                if (!this.featureVertexRangesFromId) {
                    this.featureVertexRangesFromId = new Map, this.featureVertexRangesFromVtIndex = new Map;
                    for(let e1 = 0; e1 < this.allFeatureVtIndices.length; e1++){
                        const t1 = this.allFeatureIds[e1];
                        if (null != t1) {
                            let i = this.featureVertexRangesFromId.get(t1);
                            i || this.featureVertexRangesFromId.set(t1, i = []), i.push(e1);
                        }
                        const i = this.allFeatureVtIndices[e1];
                        let n = this.featureVertexRangesFromVtIndex.get(i);
                        n || this.featureVertexRangesFromVtIndex.set(i, n = []), n.push(e1);
                    }
                }
            }
            populateUBO(e1, t1, i, n, r, o) {
                const a = e1.id;
                let s, l;
                this.isAllConstant ? (s = 0, l = 0 === this.featureCount, l && (this.featureCount = 1)) : (s = this.featureCount++, l = !0);
                const c = Math.floor(s / this.maxFeaturesPerBatch), u = s % this.maxFeaturesPerBatch;
                if (l && (this.ubos[c] || (this.ubos[c] = this._createUBO(c)), !this.isAllConstant)) {
                    const t1 = this.evaluateAllProperties(e1, {}, i, n, r, o);
                    this.ubos[c].writeDataDrivenBlock(t1, u);
                }
                return this.allFeatureVtIndices.push(t1), this.allFeatureIds.push(a), this.allFormattedSections && this.allFormattedSections.push(o || null), u;
            }
            updateFeatures(e1, t1, i, n, r, o, a) {
                this.layer = t1, this._ensureRangeMaps();
                for (const t1 of e1){
                    const e1 = this.featureVertexRangesFromId.get(t1);
                    if (e1) for (const t1 of e1)this._reevaluateAt(t1, i, n, r, o, a);
                }
            }
            updateDynamicExpressions(e1, t1, i, n, r, o) {
                if (this.layer = e1, this._recomputeSharedRanges(), 0 !== this.header[0]) for(let e1 = 0; e1 < this.allFeatureVtIndices.length; e1++)this._reevaluateAt(e1, t1, i, n, r, o);
            }
            updatePaint(e1) {
                return this.paintVersion === e1.paintVersion ? "unchanged" : (this.paintVersion = e1.paintVersion, this.layer = e1, this._recomputeSharedRanges(), this.hasConstantsInBlocks ? "features" : "constants");
            }
            _constantColor(e1, t1, i) {
                const n = this._paintGet(e1);
                if (!n) return i;
                const r = this._paintGet(`${e1}-use-theme`), o = this._effectiveLut(r, Lh, {}, [], void 0, t1, void 0);
                return n.constantOr(fn.transparent).toNonPremultipliedRenderColor(o).toArray01();
            }
            _constantFloat(e1, t1) {
                const i = this._paintGet(e1);
                return i ? i.constantOr(t1) : t1;
            }
            getConstantUniformValues(e1) {
                if (this.cachedConstantUniforms && this.cachedConstantPaint === this.layer.paint && this.cachedConstantBrightness === e1) return this.cachedConstantUniforms;
                const t1 = this._buildConstantUniforms(e1);
                return this.cachedConstantUniforms = t1, this.cachedConstantBrightness = e1, this.cachedConstantPaint = this.layer.paint, t1;
            }
            finalize() {
                for (const e1 of this.ubos)e1.rightSizeForTransfer();
            }
            upload(e1) {
                for (const t1 of this.ubos)t1.upload(e1);
            }
            bind(e1, t1, i = 0) {
                this.ubos[i] && this.ubos[i].bind(e1, t1);
            }
            getUBO(e1 = 0) {
                return this.ubos[e1];
            }
            destroy() {
                for (const e1 of this.ubos)e1.destroy();
                this.ubos = [], this.featureVertexRangesFromId = null, this.featureVertexRangesFromVtIndex = null, this.allFeatureVtIndices = [], this.allFeatureIds = [], this.featureCount = 0, this.maxFeaturesPerBatch = 0;
            }
        }
        const Vh = [
            "line-color",
            "line-border-color",
            "line-opacity",
            "line-blur",
            "line-width",
            "line-gap-width",
            "line-offset",
            "line-floorwidth",
            "line-border-width",
            "line-emissive-strength",
            "line-dasharray",
            "line-side-z-offset"
        ], Nh = 1 << Vh.indexOf("line-floorwidth"), kh = Vh.indexOf("line-dasharray"), Uh = 1 << kh, jh = Fh.EVAL_FLAT_OFFSETS[kh], Gh = [
            "line-width",
            "line-gap-width",
            "line-offset"
        ].map((e1)=>Vh.indexOf(e1)), Hh = [
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            1,
            0,
            0,
            0,
            0
        ], $h = new Float32Array(Fh.EVAL_FLAT_TOTAL);
        class Zh extends Bh {
            constructor(e1, t1, i, n = "", r){
                super(e1, t1, i, n, r), this.maxValues = new Float32Array(Vh.length), this._finishInitialization();
            }
            getMaxValue(e1) {
                const t1 = Vh.indexOf(e1);
                return t1 >= 0 ? this.maxValues[t1] : 0;
            }
            _propNames() {
                return Vh;
            }
            _headerDwords() {
                return Fh.HEADER_DWORDS;
            }
            _createUBO(e1) {
                return new Fh(null, e1, this.uboSizeDwords, this.header);
            }
            _flatScratch() {
                return $h;
            }
            populateUBO(e1, t1, i, n, r, o, a) {
                this._pendingDashPosition = a;
                const s = super.populateUBO(e1, t1, i, n, r, o);
                return this._pendingDashPosition = null, s;
            }
            evaluateAllProperties(e1, t1, i, n, r, o, a) {
                const s = super.evaluateAllProperties(e1, t1, i, n, r, o, a);
                for(let e1 = 0; e1 < Gh.length; e1++){
                    const t1 = Gh[e1], i = Fh.EVAL_FLAT_OFFSETS[t1];
                    this.maxValues[t1] = Math.max(this.maxValues[t1], Math.abs(s[i]), Math.abs(s[i + 1]));
                }
                const l = this._pendingDashPosition;
                return this._pendingDashPosition = null, s[jh] = l ? l.tl[0] : 0, s[jh + 1] = l ? l.tl[1] : 0, s[jh + 2] = l ? l.br[0] : 0, s[jh + 3] = l ? l.br[1] : 0, s;
            }
            _immutableAfterPopulateMask() {
                return 0 !== (this.header[0] & Uh) ? Uh : 0;
            }
            updateHeader() {
                let e1 = 0, t1 = !1, i = 0;
                const n = this._floorZoom;
                for(let r = 0; r < 12; r++){
                    if (r === kh) {
                        this._isDashDataDriven() && (e1 |= Uh, this.zoomDependency[r] = 0, this.header[3 + r] = i, i += 1);
                        continue;
                    }
                    const o = Vh[r], a = r < 2, s = this._paintGet(o), l = !(!s || "function" != typeof s.isConstant || s.isConstant());
                    if (!(l || a && this._isUseThemeDataDriven(o))) continue;
                    e1 |= 1 << r, l || (t1 = !0);
                    const c = this._zoomExprOf(this._layerUnevaluated(o)), u = !!c;
                    this.zoomDependency[r] = u ? 1 : 0, this.header[3 + r] = i, i += 1, u && (this._computeZoomRange(c, n, this.sharedZoomRanges, 2 * r), a && (this.header[Fh.LINE_HEADER_SHARED_ZOOM + 2 * r] = Th(this.sharedZoomRanges[2 * r]), this.header[Fh.LINE_HEADER_SHARED_ZOOM + 2 * r + 1] = Th(this.sharedZoomRanges[2 * r + 1])));
                }
                this.header[0] = e1, this.header[2] = i, this.hasConstantsInBlocks = t1;
            }
            _recomputeSharedRanges() {
                const e1 = this._floorZoom;
                let t1 = !1;
                for(let i = 0; i < 12; i++)if (i !== kh && this.header[0] & 1 << i && 1 === this.zoomDependency[i]) {
                    const n = this._zoomExprOf(this._layerUnevaluated(Vh[i]));
                    n && (this._computeZoomRange(n, e1, this.sharedZoomRanges, 2 * i), i < 2 && (this.header[Fh.LINE_HEADER_SHARED_ZOOM + 2 * i] = Th(this.sharedZoomRanges[2 * i]), this.header[Fh.LINE_HEADER_SHARED_ZOOM + 2 * i + 1] = Th(this.sharedZoomRanges[2 * i + 1]), t1 = !0));
                }
                if (t1) for (const e1 of this.ubos)e1.markHeaderDirty();
            }
            _isUseThemeDataDriven(e1) {
                const t1 = this._paintGet(`${e1}-use-theme`);
                return !!t1 && "function" == typeof t1.isConstant && !t1.isConstant();
            }
            _isDashDataDriven() {
                const e1 = this._paintGet("line-dasharray"), t1 = !(!e1 || "function" != typeof e1.isConstant || e1.isConstant()), i = this.layer.layout.get("line-cap"), n = !!i && "function" == typeof i.isConstant && !i.isConstant();
                return t1 || n;
            }
            _evaluatePropertyAt(e1, t1) {
                if (e1 === kh) return;
                const i = Vh[e1], n = 1 === this.zoomDependency[e1], r = Fh.EVAL_FLAT_OFFSETS[e1];
                e1 < 2 ? this._evaluateColorValue(i, e1, n, !1, -1, t1, r) : this._evaluateFloatValue(i, e1, n, !1, r + 2, t1, r, Hh[e1]);
            }
            _buildConstantUniforms(e1) {
                return {
                    color_np_color: this._constantColor(Vh[0], e1, [
                        0,
                        0,
                        0,
                        1
                    ]),
                    border_np_color: this._constantColor(Vh[1], e1, [
                        0,
                        0,
                        0,
                        0
                    ]),
                    opacity: this._constantFloat(Vh[2], Hh[2]),
                    blur: this._constantFloat(Vh[3], Hh[3]),
                    width: this._constantFloat(Vh[4], Hh[4]),
                    gap_width: this._constantFloat(Vh[5], Hh[5]),
                    offset: this._constantFloat(Vh[6], Hh[6]),
                    floorwidth: this._constantFloat(Vh[7], Hh[7]),
                    border_width: this._constantFloat(Vh[8], Hh[8]),
                    emissive_strength: this._constantFloat(Vh[9], Hh[9]),
                    side_z_offset: this._constantFloat(Vh[11], Hh[11])
                };
            }
        }
        Ya(Zh, "LinePropertyBinderUBO", {
            omit: [
                "layer",
                "cachedConstantUniforms",
                "cachedConstantBrightness",
                "cachedConstantPaint",
                "featureVertexRangesFromId",
                "featureVertexRangesFromVtIndex"
            ]
        });
        class Wh {
            constructor(e1, t1, i, n, r){
                for(this.properties = Object.create(null), this.extent = i, this.type = 0, this.id = void 0, this._pbf = e1, this._geometry = -1, this._keys = n, this._values = r; e1.pos < t1;){
                    const t1 = e1.readVarint();
                    if (8 === t1) this.id = e1.readVarint();
                    else if (18 === t1) {
                        const t1 = e1.readVarint() + e1.pos;
                        for(; e1.pos < t1;){
                            const t1 = n[e1.readVarint()], i = r[e1.readVarint()];
                            this.properties[t1] = i;
                        }
                    } else 24 === t1 ? this.type = e1.readVarint() : 34 === t1 ? (this._geometry = e1.pos, e1.skip(t1)) : e1.skip(t1);
                }
            }
            loadGeometry() {
                if (this._geometry < 0) throw new Error("feature has no geometry");
                const e1 = this._pbf;
                e1.pos = this._geometry;
                const t1 = e1.readVarint() + e1.pos, i = [];
                let n, r = 1, o = 0, a = 0, s = 0;
                for(; e1.pos < t1;){
                    if (o <= 0) {
                        const t1 = e1.readVarint();
                        if (r = 7 & t1, o = t1 >> 3, 0 === o) continue;
                    }
                    if (o--, 1 === r) a += e1.readSVarint(), s += e1.readSVarint(), n && i.push(n), n = [
                        new Re(a, s)
                    ];
                    else if (2 === r) a += e1.readSVarint(), s += e1.readSVarint(), n && n.push(new Re(a, s));
                    else {
                        if (7 !== r) throw new Error(`unknown command ${r}`);
                        n && n.push(n[0].clone());
                    }
                }
                return n && i.push(n), i;
            }
            bbox() {
                if (this._geometry < 0) throw new Error("feature has no geometry");
                const e1 = this._pbf;
                e1.pos = this._geometry;
                const t1 = e1.readVarint() + e1.pos;
                let i = 1, n = 0, r = 0, o = 0, a = 1 / 0, s = -1 / 0, l = 1 / 0, c = -1 / 0;
                for(; e1.pos < t1;){
                    if (n <= 0) {
                        const t1 = e1.readVarint();
                        if (i = 7 & t1, n = t1 >> 3, 0 === n) continue;
                    }
                    if (n--, 1 === i || 2 === i) r += e1.readSVarint(), o += e1.readSVarint(), r < a && (a = r), r > s && (s = r), o < l && (l = o), o > c && (c = o);
                    else if (7 !== i) throw new Error(`unknown command ${i}`);
                }
                return [
                    a,
                    l,
                    s,
                    c
                ];
            }
            toGeoJSON(e1, t1, i) {
                const n = this.extent * Math.pow(2, i), r = this.extent * e1, o = this.extent * t1, a = this.loadGeometry();
                function s(e1) {
                    return [
                        360 * (e1.x + r) / n - 180,
                        360 / Math.PI * Math.atan(Math.exp((1 - 2 * (e1.y + o) / n) * Math.PI)) - 90
                    ];
                }
                function l(e1) {
                    return e1.map(s);
                }
                let c;
                if (1 === this.type) {
                    const e1 = [];
                    for (const t1 of a)e1.push(t1[0]);
                    const t1 = l(e1);
                    c = 1 === e1.length ? {
                        type: "Point",
                        coordinates: t1[0]
                    } : {
                        type: "MultiPoint",
                        coordinates: t1
                    };
                } else if (2 === this.type) {
                    const e1 = a.map(l);
                    c = 1 === e1.length ? {
                        type: "LineString",
                        coordinates: e1[0]
                    } : {
                        type: "MultiLineString",
                        coordinates: e1
                    };
                } else {
                    if (3 !== this.type) throw new Error("unknown feature type");
                    {
                        const e1 = function(e1) {
                            const t1 = e1.length;
                            if (t1 <= 1) return [
                                e1
                            ];
                            const i = [];
                            let n, r;
                            for(let o = 0; o < t1; o++){
                                const t1 = qh(e1[o]);
                                0 !== t1 && (void 0 === r && (r = t1 < 0), r === t1 < 0 ? (n && i.push(n), n = [
                                    e1[o]
                                ]) : n && n.push(e1[o]));
                            }
                            return n && i.push(n), i;
                        }(a), t1 = [];
                        for (const i of e1)t1.push(i.map(l));
                        c = 1 === t1.length ? {
                            type: "Polygon",
                            coordinates: t1[0]
                        } : {
                            type: "MultiPolygon",
                            coordinates: t1
                        };
                    }
                }
                const u = {
                    type: "Feature",
                    geometry: c,
                    properties: this.properties
                };
                return null != this.id && (u.id = this.id), u;
            }
        }
        function qh(e1) {
            let t1 = 0;
            for(let i, n, r = 0, o = e1.length, a = o - 1; r < o; a = r++)i = e1[r], n = e1[a], t1 += (n.x - i.x) * (i.y + n.y);
            return t1;
        }
        Wh.types = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ];
        class Xh {
            constructor(e1, t1){
                for(this.version = 1, this.name = "", this.extent = 4096, this.length = 0, this._pbf = e1, this._keys = [], this._values = [], this._features = [], void 0 === t1 && (t1 = e1.length); e1.pos < t1;){
                    const t1 = e1.readVarint();
                    10 === t1 ? this.name = e1.readString() : 18 === t1 ? (this._features.push(e1.pos), e1.skip(t1)) : 26 === t1 ? this._keys.push(e1.readString()) : 34 === t1 ? this._values.push(Yh(e1)) : 40 === t1 ? this.extent = e1.readVarint() : 120 === t1 ? this.version = e1.readVarint() : e1.skip(t1);
                }
                this.length = this._features.length;
            }
            feature(e1) {
                if (e1 < 0 || e1 >= this._features.length) throw new Error("feature index out of bounds");
                this._pbf.pos = this._features[e1];
                const t1 = this._pbf.readVarint() + this._pbf.pos;
                return new Wh(this._pbf, t1, this.extent, this._keys, this._values);
            }
        }
        function Yh(e1) {
            let t1 = null;
            const i = e1.readVarint() + e1.pos;
            for(; e1.pos < i;){
                const i = e1.readVarint();
                t1 = 10 === i ? e1.readString() : 21 === i ? e1.readFloat() : 25 === i ? e1.readDouble() : 32 === i ? e1.readVarint(!0) : 40 === i ? e1.readVarint() : 48 === i ? e1.readSVarint() : 56 === i ? e1.readBoolean() : (e1.skip(i), null);
            }
            if (null == t1) throw new Error("unknown feature value");
            return t1;
        }
        class Jh {
            constructor(e1, t1 = e1.length){
                const i = Object.create(null);
                for(; e1.pos < t1;){
                    const t1 = e1.readVarint();
                    if (26 === t1) {
                        const t1 = new Xh(e1, e1.readVarint() + e1.pos);
                        t1.length && (i[t1.name] = t1);
                    } else e1.skip(t1);
                }
                this.layers = i;
            }
        }
        function Kh(e1, t1) {
            for(let i = 0; i < e1.length; i++)if (cd(t1, e1[i])) return !0;
            for(let i = 0; i < t1.length; i++)if (cd(e1, t1[i])) return !0;
            return !!id(e1, t1);
        }
        function Qh(e1, t1, i) {
            return !!cd(e1, t1) || !!ad(t1, e1, i);
        }
        function ed(e1, t1) {
            if (1 === e1.length) return ld(t1, e1[0]);
            for(let i = 0; i < t1.length; i++){
                const n = t1[i];
                for(let t1 = 0; t1 < n.length; t1++)if (cd(e1, n[t1])) return !0;
            }
            for(let i = 0; i < e1.length; i++)if (ld(t1, e1[i])) return !0;
            for(let i = 0; i < t1.length; i++)if (id(e1, t1[i])) return !0;
            return !1;
        }
        function td(e1, t1, i) {
            if (e1.length > 1) {
                if (id(e1, t1)) return !0;
                for(let n = 0; n < t1.length; n++)if (ad(t1[n], e1, i)) return !0;
            }
            for(let n = 0; n < e1.length; n++)if (ad(e1[n], t1, i)) return !0;
            return !1;
        }
        function id(e1, t1) {
            if (0 === e1.length || 0 === t1.length) return !1;
            for(let i = 0; i < e1.length - 1; i++){
                const n = e1[i], r = e1[i + 1];
                for(let e1 = 0; e1 < t1.length - 1; e1++)if (nd(n, r, t1[e1], t1[e1 + 1])) return !0;
            }
            return !1;
        }
        function nd(e1, t1, i, n) {
            return mt(e1, i, n) !== mt(t1, i, n) && mt(e1, t1, i) !== mt(e1, t1, n);
        }
        function rd(e1, t1, i) {
            return (e1.x - i.x) * (t1.y - i.y) - (e1.y - i.y) * (t1.x - i.x);
        }
        function od(e1, t1, i, n) {
            const r = rd(e1, t1, n), o = rd(e1, t1, i);
            if (Math.sign(r) === Math.sign(o)) return;
            const a = rd(i, n, e1), s = a + o - r;
            return Math.sign(a) !== Math.sign(s) ? [
                a / (a - s),
                o / (o - r)
            ] : void 0;
        }
        function ad(e1, t1, i) {
            const n = i * i;
            if (1 === t1.length) return e1.distSqr(t1[0]) < n;
            for(let i = 1; i < t1.length; i++)if (sd(e1, t1[i - 1], t1[i]) < n) return !0;
            return !1;
        }
        function sd(e1, t1, i) {
            const n = t1.distSqr(i);
            if (0 === n) return e1.distSqr(t1);
            const r = ((e1.x - t1.x) * (i.x - t1.x) + (e1.y - t1.y) * (i.y - t1.y)) / n;
            return e1.distSqr(r < 0 ? t1 : r > 1 ? i : i.sub(t1)._mult(r)._add(t1));
        }
        function ld(e1, t1) {
            let i, n, r, o = !1;
            for(let a = 0; a < e1.length; a++){
                i = e1[a];
                for(let e1 = 0, a = i.length - 1; e1 < i.length; a = e1++)n = i[e1], r = i[a], n.y > t1.y != r.y > t1.y && t1.x < (r.x - n.x) * (t1.y - n.y) / (r.y - n.y) + n.x && (o = !o);
            }
            return o;
        }
        function cd(e1, t1) {
            let i = !1;
            for(let n = 0, r = e1.length - 1; n < e1.length; r = n++){
                const o = e1[n], a = e1[r];
                o.y > t1.y != a.y > t1.y && t1.x < (a.x - o.x) * (t1.y - o.y) / (a.y - o.y) + o.x && (i = !i);
            }
            return i;
        }
        function ud(e1, t1, i, n, r) {
            for (const o of e1)if (t1 <= o.x && i <= o.y && n >= o.x && r >= o.y) return !0;
            const o = [
                new Re(t1, i),
                new Re(t1, r),
                new Re(n, r),
                new Re(n, i)
            ];
            if (e1.length > 2) {
                for (const t1 of o)if (cd(e1, t1)) return !0;
            }
            for(let t1 = 0; t1 < e1.length - 1; t1++)if (hd(e1[t1], e1[t1 + 1], o)) return !0;
            return !1;
        }
        function hd(e1, t1, i) {
            const n = i[0], r = i[2];
            if (e1.x < n.x && t1.x < n.x || e1.x > r.x && t1.x > r.x || e1.y < n.y && t1.y < n.y || e1.y > r.y && t1.y > r.y) return !1;
            const o = mt(e1, t1, i[0]);
            return o !== mt(e1, t1, i[1]) || o !== mt(e1, t1, i[2]) || o !== mt(e1, t1, i[3]);
        }
        function dd(e1, t1, i, n, r, o) {
            let a = t1.y - e1.y, s = e1.x - t1.x;
            if (o = o || 0) {
                const e1 = a * a + s * s;
                if (0 === e1) return !0;
                const t1 = Math.sqrt(e1);
                a /= t1, s /= t1;
            }
            return !((i.x - e1.x) * a + (i.y - e1.y) * s - o < 0 || (n.x - e1.x) * a + (n.y - e1.y) * s - o < 0 || (r.x - e1.x) * a + (r.y - e1.y) * s - o < 0);
        }
        function fd(e1, t1, i, n, r, o, a) {
            return !(dd(e1, t1, n, r, o, a) || dd(t1, i, n, r, o, a) || dd(i, e1, n, r, o, a) || dd(n, r, e1, t1, i, a) || dd(r, o, e1, t1, i, a) || dd(o, n, e1, t1, i, a));
        }
        class pd extends Re {
            constructor(e1, t1, i){
                super(e1, t1), this.z = i;
            }
        }
        class _d extends pd {
            constructor(e1, t1, i, n){
                super(e1, t1, i), this.w = n;
            }
        }
        function md(e1, t1, i, n) {
            const r = "x" === i ? "y" : "x", o = (n - e1[i]) / (t1[i] - e1[i]);
            e1[r] = Math.round(e1[r] + (t1[r] - e1[r]) * o), e1[i] = n, Object.hasOwn(e1, "z") && (e1.z = hn(e1.z, t1.z, o)), Object.hasOwn(e1, "w") && (e1.w = hn(e1.w, t1.w, o));
        }
        function gd(e1, t1, i, n) {
            const r = i, o = n;
            for (const i of [
                "x",
                "y"
            ]){
                let n = e1, a = t1;
                n[i] >= a[i] && (n = t1, a = e1), n[i] < r && a[i] > r && md(n, a, i, r), n[i] < o && a[i] > o && md(a, n, i, o);
            }
        }
        function yd(e1, t1, i, n, r, o) {
            const a = [];
            for(let s = 0; s < e1.length; s++){
                const l = e1[s];
                let c;
                const u = a.length;
                let h = 0;
                for(let e1 = 0; e1 < l.length - 1; e1++){
                    let u = l[e1], d = l[e1 + 1], f = 0;
                    const p = h;
                    let _, m;
                    o && (f = Math.hypot(d.x - u.x, d.y - u.y), h += f, _ = u, m = d), u.x < t1 && d.x < t1 || (u.x < t1 ? u = new Re(t1, u.y + (t1 - u.x) / (d.x - u.x) * (d.y - u.y))._round() : d.x < t1 && (d = new Re(t1, u.y + (t1 - u.x) / (d.x - u.x) * (d.y - u.y))._round()), u.y < i && d.y < i || (u.y < i ? u = new Re(u.x + (i - u.y) / (d.y - u.y) * (d.x - u.x), i)._round() : d.y < i && (d = new Re(u.x + (i - u.y) / (d.y - u.y) * (d.x - u.x), i)._round()), u.x >= n && d.x >= n || (u.x >= n ? u = new Re(n, u.y + (n - u.x) / (d.x - u.x) * (d.y - u.y))._round() : d.x >= n && (d = new Re(n, u.y + (n - u.x) / (d.x - u.x) * (d.y - u.y))._round()), u.y >= r && d.y >= r || (u.y >= r ? u = new Re(u.x + (r - u.y) / (d.y - u.y) * (d.x - u.x), r)._round() : d.y >= r && (d = new Re(u.x + (r - u.y) / (d.y - u.y) * (d.x - u.x), r)._round()), c && u.equals(c.at(-1)) || (c = [
                        u
                    ], a.push(c), o && o.push({
                        progress: {
                            min: p + vd(_, m, u) * f,
                            max: 1
                        },
                        parentIndex: s,
                        prevPoint: _,
                        nextPoint: m
                    })), c.push(d), o && (o.at(-1).progress.max = p + vd(_, m, d) * f, o.at(-1).nextPoint = m)))));
                }
                if (o && h > 0) for(let e1 = u; e1 < a.length; e1++)o[e1].progress.min /= h, o[e1].progress.max /= h;
            }
            return a;
        }
        function xd(e1, t1, i, n, r) {
            if (e1.length < 2) return void n.push(e1);
            const o = [];
            for(; t1.valid();){
                const [i, n] = t1.get();
                for(let t1 = 0; t1 < e1.length - 1; t1++){
                    const r = e1[t1], a = e1[t1 + 1], s = od(r, a, i, n);
                    if (s) {
                        const [e1] = s, i = new Re(hn(r.x, a.x, e1), hn(r.y, a.y, e1));
                        o.push({
                            t: t1 + e1,
                            distance: 0,
                            point: i
                        });
                    }
                }
                t1.next();
            }
            if (0 === o.length) return void n.push(e1);
            o.sort((e1, t1)=>e1.t - t1.t);
            let a = 0, s = 0, l = [];
            for(n.push(l); a !== e1.length;){
                if (s === o.length) {
                    for(; a !== e1.length;)0 !== l.length && l.at(-1).equals(e1[a]) || l.push(e1[a]), a++;
                    break;
                }
                o[s].t <= a ? (0 !== l.length && l.at(-1).equals(o[s].point) || l.push(o[s].point), o[s].t, s++) : (0 !== l.length && l.at(-1).equals(e1[a]) || l.push(e1[a]), a++);
            }
        }
        function vd(e1, t1, i) {
            return e1.x !== t1.x ? (i.x - e1.x) / (t1.x - e1.x) : e1.y !== t1.y ? (i.y - e1.y) / (t1.y - e1.y) : 0;
        }
        function bd(e1, { width: t1, height: i }, n, r) {
            if (r) {
                if (r instanceof Uint8ClampedArray) r = new Uint8Array(r.buffer);
                else if (r.length !== t1 * i * n) throw new RangeError("mismatched image size");
            } else r = new Uint8Array(t1 * i * n);
            return e1.width = t1, e1.height = i, e1.data = r, e1;
        }
        function wd(e1, t1, i) {
            const { width: n, height: r } = t1;
            n === e1.width && r === e1.height || (Ad(e1, t1, {
                x: 0,
                y: 0
            }, {
                x: 0,
                y: 0
            }, {
                width: Math.min(e1.width, n),
                height: Math.min(e1.height, r)
            }, i, null), e1.width = n, e1.height = r, e1.data = t1.data);
        }
        function Ad(e1, t1, i, n, r, o, a, s) {
            if (0 === r.width || 0 === r.height) return t1;
            if (r.width > e1.width || r.height > e1.height || i.x > e1.width - r.width || i.y > e1.height - r.height) throw new RangeError("out of range source coordinates for image copy");
            if (r.width > t1.width || r.height > t1.height || n.x > t1.width - r.width || n.y > t1.height - r.height) throw new RangeError("out of range destination coordinates for image copy");
            const l = e1.data, c = t1.data, u = 4 === o && s;
            for(let s = 0; s < r.height; s++){
                const h = ((i.y + s) * e1.width + i.x) * o, d = ((n.y + s) * t1.width + n.x) * o;
                if (u) for(let e1 = 0; e1 < r.width; e1++){
                    const t1 = h + e1 * o + 3, i = d + e1 * o;
                    c[i + 0] = 255, c[i + 1] = 255, c[i + 2] = 255, c[i + 3] = l[t1];
                }
                else if (a) for(let e1 = 0; e1 < r.width; e1++){
                    const t1 = h + e1 * o, i = d + e1 * o, n = new fn(l[t1 + 0] / 255, l[t1 + 1] / 255, l[t1 + 2] / 255, l[t1 + 3]).toNonPremultipliedRenderColor(a).toArray();
                    c[i + 0] = n[0], c[i + 1] = n[1], c[i + 2] = n[2], c[i + 3] = n[3];
                }
                else for(let e1 = 0; e1 < r.width * o; e1++)c[d + e1] = l[h + e1];
            }
            return t1;
        }
        class Ed {
            constructor(e1, t1){
                bd(this, e1, 1, t1);
            }
            resize(e1) {
                wd(this, new Ed(e1), 1);
            }
            clone() {
                return new Ed({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(e1, t1, i, n, r) {
                Ad(e1, t1, i, n, r, 1, null);
            }
        }
        class Id {
            constructor(e1, t1){
                bd(this, e1, 4, t1);
            }
            resize(e1) {
                wd(this, new Id(e1), 4);
            }
            replace(e1, t1) {
                t1 ? this.data.set(e1) : this.data = e1 instanceof Uint8ClampedArray ? new Uint8Array(e1.buffer) : e1;
            }
            clone() {
                return new Id({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(e1, t1, i, n, r, o, a) {
                Ad(e1, t1, i, n, r, 4, o, a);
            }
        }
        class Md {
            constructor(e1, t1){
                this.width = e1.width, this.height = e1.height, this.data = t1 instanceof Uint8Array ? new Float32Array(t1.buffer) : t1;
            }
        }
        Ya(Ed, "AlphaImage"), Ya(Id, "RGBAImage");
        class Sd {
            constructor(e1, t1){
                this.width = e1, this.height = t1, this.nextRow = 0, this.image = new Ed({
                    width: e1,
                    height: t1
                }), this.positions = {}, this.uploaded = !1;
            }
            getDash(e1, t1) {
                const i = this.getKey(e1, t1);
                return this.positions[i];
            }
            trim() {
                const e1 = this.width, t1 = this.height = st(this.nextRow);
                this.image.resize({
                    width: e1,
                    height: t1
                });
            }
            getKey(e1, t1) {
                return e1.join(",") + t1;
            }
            getDashRanges(e1, t1) {
                const i = [];
                let n = e1.length % 2 == 1 ? -e1.at(-1) * t1 : 0, r = e1[0] * t1, o = !0;
                i.push({
                    left: n,
                    right: r,
                    isDash: o,
                    zeroLength: 0 === e1[0]
                });
                let a = e1[0];
                for(let s = 1; s < e1.length; s++){
                    o = !o;
                    const l = e1[s];
                    n = a * t1, a += l, r = a * t1, i.push({
                        left: n,
                        right: r,
                        isDash: o,
                        zeroLength: 0 === l
                    });
                }
                return i;
            }
            addRoundDash(e1, t1, i) {
                const n = t1 / 2;
                for(let t1 = -i; t1 <= i; t1++){
                    const r = this.width * (this.nextRow + i + t1);
                    let o = 0, a = e1[o];
                    for(let s = 0; s < this.width; s++){
                        s / a.right > 1 && (a = e1[++o]);
                        const l = Math.abs(s - a.left), c = Math.abs(s - a.right), u = Math.min(l, c);
                        let h;
                        const d = t1 / i * (n + 1);
                        if (a.isDash) {
                            const e1 = n - Math.abs(d);
                            h = Math.sqrt(u * u + e1 * e1);
                        } else h = n - Math.sqrt(u * u + d * d);
                        this.image.data[r + s] = Math.max(0, Math.min(255, h + 128));
                    }
                }
            }
            addRegularDash(e1, t1) {
                for(let t1 = e1.length - 1; t1 >= 0; --t1){
                    const i = e1[t1], n = e1[t1 + 1];
                    i.zeroLength ? e1.splice(t1, 1) : n && n.isDash === i.isDash && (n.left = i.left, e1.splice(t1, 1));
                }
                const i = e1[0], n = e1.at(-1);
                i.isDash === n.isDash && (i.left = n.left - this.width, n.right = i.right + this.width);
                const r = this.width * this.nextRow;
                let o = 0, a = e1[o];
                for(let i = 0; i < this.width; i++){
                    i / a.right > 1 && (a = e1[++o]);
                    const n = Math.abs(i - a.left), s = Math.abs(i - a.right), l = Math.min(n, s);
                    this.image.data[r + i] = Math.max(0, Math.min(255, (a.isDash ? l : -l) + t1 + 128));
                }
            }
            addDash(e1, t1) {
                const i = this.getKey(e1, t1);
                if (this.positions[i]) return this.positions[i];
                const n = "round" === t1, r = n ? 7 : 0, o = 2 * r + 1;
                if (this.nextRow + o > this.height) return _t("LineAtlas out of space"), null;
                0 === e1.length && e1.push(1);
                let a = 0;
                for(let t1 = 0; t1 < e1.length; t1++)e1[t1] < 0 && (_t("Negative value is found in line dasharray, replacing values with 0"), e1[t1] = 0), a += e1[t1];
                if (0 !== a) {
                    const i = this.width / a, o = this.getDashRanges(e1, i);
                    n ? this.addRoundDash(o, i, r) : this.addRegularDash(o, "square" === t1 ? .5 * i : 0);
                }
                const s = this.nextRow + r;
                let l = 0;
                if (0 !== a) {
                    const e1 = this.width * s;
                    for(let t1 = 0; t1 < this.width; t1++)this.image.data[e1 + t1] >= 128 && l++;
                }
                const c = Math.round(l / this.width * 4095);
                this.nextRow += o;
                const u = Math.floor(a), h = {
                    tl: [
                        s,
                        r | c << 4
                    ],
                    br: [
                        u,
                        Math.round(65535 * (a - u))
                    ]
                };
                return this.positions[i] = h, h;
            }
        }
        Ya(Sd, "LineAtlas");
        const Td = "3d_elevation_id", zd = "level", Rd = Wh.types, Pd = Math.cos(Math.PI / 180 * 37.5), Dd = Math.cos(Math.PI / 180 * 5);
        class Fd {
            constructor(e1){
                this.evaluationGlobals = {
                    zoom: 0,
                    lineProgress: void 0
                }, this.elevationType = "none", this.isSeaLevelReference = !1, this.showElevationIdDebug = !1, this.terrainEnabled = !1, this.zoom = e1.zoom, this.evaluationGlobals.zoom = this.zoom, this.overscaling = e1.overscaling, this.pixelRatio = e1.pixelRatio, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.projection = e1.projection, this.hasPattern = !1, this.hasCrossSlope = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.borderGradients = {}, this.layers.forEach((e1)=>{
                    this.gradients[e1.id] = {}, this.borderGradients[e1.id] = {};
                }), this.layoutVertexArray = new Uc, this.layoutVertexArray2 = new jc, this.patternVertexArray = new jc, this.indexArray = new nu;
                const t1 = e1.layers.filter((e1)=>!!e1.paint.get("line-pattern").constantOr(1));
                this.programConfigurations = new ch(t1, {
                    zoom: e1.zoom,
                    lut: e1.lut
                }), this.segments = new Ou, this.sourceLayerName = e1.sourceLayerName || "", this.maxLineLength = 0, this.zOffsetVertexArray = new qc, this.elevationIdColVertexArray = new jc, this.elevationGroundScaleVertexArray = new Lc, this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.tessellationStep = e1.tessellationStep ? e1.tessellationStep : 128, this.worldview = e1.worldview, this.hasAppearances = null, this.maxUniformBlockSizeDwords = e1.maxUniformBlockSizeDwords, this.uboBinders = {}, this.maxFeaturesPerBatch = Number.MAX_SAFE_INTEGER;
                for (const t1 of this.layers){
                    const i = new Zh(t1, e1.zoom, e1.lut, this.worldview, this.maxUniformBlockSizeDwords);
                    this.uboBinders[t1.id] = i, i.maxFeaturesPerBatch < this.maxFeaturesPerBatch && (this.maxFeaturesPerBatch = i.maxFeaturesPerBatch);
                }
                for (const e1 of this.layers)this.uboBinders[e1.id].maxFeaturesPerBatch = this.maxFeaturesPerBatch;
                this.cachedBatchIndices = null, this.cachedBatchSegments = null, this.currentFeatureUboIndex = 0, this.currentFeatureBatchIndex = 0;
            }
            updateFootprints(e1, t1) {}
            getBatchGrouping(e1) {
                const t1 = e1 === this.segments;
                if (t1 && this.cachedBatchIndices && this.cachedBatchSegments) return {
                    batchIndices: this.cachedBatchIndices,
                    batchSegments: this.cachedBatchSegments
                };
                const i = new Map;
                for (const t1 of e1.get()){
                    const e1 = void 0 !== t1.batchIndex ? t1.batchIndex : 0;
                    i.has(e1) || i.set(e1, []), i.get(e1).push(t1);
                }
                const n = Array.from(i.keys()).sort((e1, t1)=>e1 - t1), r = new Map;
                for (const e1 of n){
                    const t1 = i.get(e1);
                    r.set(e1, new Ou(t1));
                }
                return t1 && (this.cachedBatchIndices = n, this.cachedBatchSegments = r), {
                    batchIndices: n,
                    batchSegments: r
                };
            }
            updateAppearances(e1, t1, i, n) {
                return {
                    hasLayoutChanges: !1,
                    hasUboChanges: !1
                };
            }
            populate(e1, t1, i, n) {
                this.showElevationIdDebug = t1.showElevationIdDebug, this.terrainEnabled = t1.terrainEnabled, this.hasPattern = Xl("line", this.layers, this.pixelRatio, t1);
                const r = this.layers[0].layout.get("line-sort-key");
                this.tileToMeter = _c(i);
                const o = this.layers[0].layout.get("line-elevation-reference");
                if ("hd-road-markup" === o) this.elevationType = "road";
                else {
                    const e1 = this.layers[0].layout.get("line-z-offset"), t1 = e1.isConstant() && !e1.constantOr(0);
                    this.elevationType = "sea" !== o && "ground" !== o && t1 ? "none" : "offset", "offset" === this.elevationType && "none" === o && _t(`line-elevation-reference: ground is used for the layer ${this.layerIds[0]} because non-zero line-z-offset value was found.`), this.isSeaLevelReference = "sea" === o;
                }
                const a = this.layers[0].layout.get("line-cross-slope");
                this.hasCrossSlope = "offset" === this.elevationType && void 0 !== a;
                const s = [], l = new Ls(this.zoom, {
                    worldview: this.worldview,
                    activeFloors: t1.activeFloors
                });
                for (const { feature: t1, id: o, index: a, sourceLayerIndex: c } of e1){
                    const e1 = this.layers[0]._featureFilter.needGeometry, u = Mc(t1, e1);
                    if (!this.layers[0]._featureFilter.filter(l, u, i)) continue;
                    const h = r ? r.evaluate(u, {}, i) : void 0, d = {
                        id: o,
                        properties: t1.properties,
                        type: t1.type,
                        sourceLayerIndex: c,
                        index: a,
                        geometry: Ic(t1, u, e1, i, n),
                        patterns: {},
                        sortKey: h
                    };
                    s.push(d);
                }
                r && s.sort((e1, t1)=>e1.sortKey - t1.sortKey);
                const { lineAtlas: c, featureIndex: u } = t1, h = this.addConstantDashes(c);
                for (const n of s){
                    const { geometry: r, index: o, sourceLayerIndex: a } = n;
                    if (h && this.addFeatureDashes(n, c), this.hasPattern) {
                        const e1 = Yl("line", this.layers, n, this.zoom, this.pixelRatio, t1);
                        this.patternFeatures.push(e1);
                    } else this.addFeature(n, r, o, i, c.positions, t1.availableImages, t1.brightness, t1.elevationFeatures, t1.elevationParams, t1.crossSourceElevationEnabled);
                    u.insert(e1[o].feature, r, o, a, this.index);
                }
                if (!this.hasPattern && this.hdExt && this.hdExt.buildFrcSegments(this), this.hdExt && this.hdExt.endPopulate(), !this.hasPattern) for (const e1 of this.layers)this.uboBinders[e1.id].finalize();
            }
            addConstantDashes(e1) {
                let t1 = !1;
                for (const i of this.layers){
                    const n = i.paint.get("line-dasharray").value, r = i.layout.get("line-cap").value;
                    if ("constant" !== n.kind || "constant" !== r.kind) t1 = !0;
                    else {
                        const t1 = r.value, i = n.value;
                        if (!i) continue;
                        e1.addDash(i, t1);
                    }
                }
                return t1;
            }
            addFeatureDashes(e1, t1) {
                const i = this.zoom;
                for (const n of this.layers){
                    const r = n.paint.get("line-dasharray").value, o = n.layout.get("line-cap").value;
                    if ("constant" === r.kind && "constant" === o.kind) continue;
                    let a, s;
                    if ("constant" === r.kind) {
                        if (a = r.value, !a) continue;
                    } else a = r.evaluate({
                        zoom: i
                    }, e1);
                    s = "constant" === o.kind ? o.value : o.evaluate({
                        zoom: i
                    }, e1), t1.addDash(a, s), e1.patterns[n.id] = [
                        t1.getKey(a, s)
                    ];
                }
            }
            update(e1, t1, i, n, r, o, a, s, l) {
                if (this.programConfigurations.updatePaintArrays(e1, t1, r, i, n, o, a, l), s) {
                    if (o) for (const n of r){
                        const r = this.uboBinders[n.id];
                        r && r.hasLightDependentBlocks(n) && r.updateDynamicExpressions(n, t1, s, i, e1, a);
                    }
                    else if (Object.keys(e1).length > 0) {
                        const n = new Set(Object.keys(e1).map((e1)=>{
                            const t1 = Number(e1);
                            return !isNaN(t1) && Number.isSafeInteger(t1) && String(t1) === e1 ? t1 : e1;
                        }));
                        for (const o of r){
                            const r = this.uboBinders[o.id];
                            r && r.hasStateDependentPaint(o) && r.updateFeatures(n, o, t1, s, i, e1, a);
                        }
                    }
                }
            }
            updateExpressions(e1) {
                this.programConfigurations.updateExpressions(e1);
            }
            addFeatures(e1, t1, i, n, r, o) {
                for (const r of this.patternFeatures)this.addFeature(r, r.geometry, r.index, t1, i, n, o, e1.elevationFeatures, e1.elevationParams, e1.crossSourceElevationEnabled, e1.lineAtlas.positions);
                this.hdExt && (this.hdExt.buildFrcSegments(this), this.hdExt.endPopulate());
                for (const e1 of this.layers)this.uboBinders[e1.id].finalize();
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(e1) {
                this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = e1.createVertexBuffer(this.layoutVertexArray2, Ah)), 0 !== this.patternVertexArray.length && (this.patternVertexBuffer = e1.createVertexBuffer(this.patternVertexArray, Ih)), !this.zOffsetVertexBuffer && this.zOffsetVertexArray.length > 0 && (this.zOffsetVertexBuffer = e1.createVertexBuffer(this.zOffsetVertexArray, yh.members, !0)), !this.elevationIdColVertexBuffer && this.elevationIdColVertexArray.length > 0 && (this.elevationIdColVertexBuffer = e1.createVertexBuffer(this.elevationIdColVertexArray, xh.members, !0)), !this.elevationGroundScaleVertexBuffer && this.elevationGroundScaleVertexArray.length > 0 && (this.elevationGroundScaleVertexBuffer = e1.createVertexBuffer(this.elevationGroundScaleVertexArray, vh.members, !0)), this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, bh), this.indexBuffer = e1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(e1);
                for (const t1 of this.layers)this.uboBinders[t1.id].upload(e1);
                this.uploaded = !0;
            }
            destroy() {
                if (this.layoutVertexBuffer) {
                    this.zOffsetVertexBuffer && this.zOffsetVertexBuffer.destroy(), this.elevationIdColVertexBuffer && this.elevationIdColVertexBuffer.destroy(), this.elevationGroundScaleVertexBuffer && this.elevationGroundScaleVertexBuffer.destroy(), this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy();
                    for (const e1 of this.layers)this.uboBinders[e1.id].destroy();
                    this.segments.destroy();
                }
            }
            lineFeatureClips(e1, t1) {
                let i, n;
                if (t1 && t1 > 0 ? (i = `mapbox_clip_start_${t1}`, n = `mapbox_clip_end_${t1}`) : (i = "mapbox_clip_start", n = "mapbox_clip_end"), e1.properties && Object.hasOwn(e1.properties, i) && Object.hasOwn(e1.properties, n)) return {
                    start: +e1.properties[i],
                    end: +e1.properties[n]
                };
            }
            addFeature(e1, t1, i, n, r, o, a, s, l, c, u = r) {
                const h = this.layers[0].layout, d = this.hdExt ? this.hdExt.trackFeatureFrc(e1.properties) : null, f = this.indexArray.length, p = h.get("line-join").evaluate(e1, {}), _ = h.get("line-cap").evaluate(e1, {}), m = h.get("line-miter-limit"), g = h.get("line-round-limit");
                this.lineClips = this.lineFeatureClips(e1), this.lineFeature = e1;
                const y = !(!e1.properties || !Object.hasOwn(e1.properties, "mapbox_line_metrics")) && e1.properties.mapbox_line_metrics;
                this.zOffsetValue = h.get("line-z-offset").value;
                const x = this.layers[0].paint, v = x.get("line-width").value;
                "constant" !== v.kind && !1 === v.isLineProgressConstant && (this.variableWidthValue = v);
                const b = x.get("line-emissive-strength").value;
                if ("constant" !== b.kind && !1 === b.isLineProgressConstant && (this.variableEmissiveStrengthValue = b), this.isSeaLevelReference) {
                    const e1 = h.get("line-elevation-ground-scale").value;
                    "constant" === e1.kind && 0 === e1.value || (this.elevationGroundScaleValue = e1);
                }
                this.currentFeatureBatchIndex = 0, this.currentFeatureUboIndex = 0;
                let w = !1;
                for (const t1 of this.layers){
                    const r = this.uboBinders[t1.id], s = 0 !== (r.header[0] & Uh) && e1.patterns && e1.patterns[t1.id] && e1.patterns[t1.id][0], l = u && s ? u[s] : void 0, c = r.getCurrentBatchIndex(), h = r.populateUBO(e1, i, n, o, a, void 0, l);
                    r.isAllConstant || w || (this.currentFeatureBatchIndex = c, this.currentFeatureUboIndex = h, w = !0);
                }
                if (null == this.hdExt || !this.hdExt.handleFeature(e1, t1, n, s, l, !!c, p, _, m, g, this)) for(let i = 0; i < t1.length; i++)this.addLine(t1[i], e1, n, p, _, m, g, void 0, y && i > 0 ? i : null);
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e1, i, r, o, n, a, void 0, this.worldview), this.hdExt && this.hdExt.recordFeatureRange(this, f, this.indexArray.length, d);
            }
            fillNonElevatedRoadSegment(e1) {
                for(let t1 = Math.max(e1, this.zOffsetVertexArray.length); t1 < this.layoutVertexArray.length; t1++)this.zOffsetVertexArray.emplaceBack(0, 0, 0, 0), this.showElevationIdDebug && this.elevationIdColVertexArray.emplaceBack(0, 0, 0);
            }
            addLine(e1, t1, i, n, r, o, a, s, l) {
                this.distance = 0, this.prevDistance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.totalFeatureLength = 0, this.lineSoFar = 0, this.currentVertex = void 0, this.lineClips = l ? this.lineFeatureClips(t1, l) : this.lineClips;
                const c = "none" === n;
                this.patternJoinNone = this.hasPattern && c, this.currentLineJoinType = n, this.segmentStart = 0, this.segmentStartf32 = 0, this.segmentPoints = [];
                const u = s && s.progress.min > 0, h = s && s.progress.max < 1;
                if (this.lineClips) {
                    let i = {
                        min: this.lineClips.start,
                        max: this.lineClips.end
                    }, n = 1;
                    if (s) {
                        const e1 = this.lineClips.end - this.lineClips.start;
                        i = function(e1, t1, i) {
                            return {
                                min: Tt(e1.min, t1, i),
                                max: Tt(e1.max, t1, i)
                            };
                        }(s.progress, {
                            min: 0,
                            max: 1
                        }, i), e1 > 0 && (n = (i.max - i.min) / e1);
                    }
                    const r = +t1.properties.mapbox_clip_feature_len, o = +t1.properties.mapbox_clip_seg_len;
                    if (Number.isNaN(r) || Number.isNaN(o)) {
                        for(let t1 = 0; t1 < e1.length - 1; t1++)this.totalDistance += e1[t1].dist(e1[t1 + 1]);
                        const t1 = this.totalDistance / (i.max - i.min);
                        this.totalFeatureLength = Number.isFinite(t1) ? t1 : 0, this.lineClips.start = i.min, this.lineClips.end = i.max, this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                    } else this.totalFeatureLength = r, this.totalDistance = o * n, this.lineClips.start = i.min, this.lineClips.end = i.max, this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                    this.lineClipsArray.push(this.lineClips), this.updateScaledDistance();
                }
                const d = "Polygon" === Rd[t1.type];
                let f = e1.length;
                for(; f >= 2 && e1[f - 1].equals(e1[f - 2]);)f--;
                let p = 0;
                for(; p < f - 1 && e1[p].equals(e1[p + 1]);)p++;
                if (f < (d ? 3 : 2)) return;
                "bevel" === n && (o = 1.05);
                const _ = this.segments.prepareSegment(10 * f, this.layoutVertexArray, this.indexArray, void 0, this.currentFeatureBatchIndex);
                let m, g, y, x, v, b, w, A;
                s && s.prevDir && (b = s.prevDir.perp()), s && s.nextDir && (w = s.nextDir.perp()), this.e1 = this.e2 = -1, d && (m = e1[f - 2], v = e1[p].sub(m)._unit()._perp());
                for(let t1 = p; t1 < f; t1++){
                    if (y = t1 === f - 1 ? d ? e1[p + 1] : void 0 : e1[t1 + 1], y && e1[t1].equals(y)) continue;
                    v && (x = v), m && (g = m), m = e1[t1], A = this.evaluateLineProgressFeatures(g ? g.dist(m) : 0), v = y ? y.sub(m)._unit()._perp() : x, x = x || v;
                    const i = g && y;
                    let s = i ? n : d || c ? "butt" : r;
                    const l = x.x * v.x + x.y * v.y;
                    if (c) {
                        const e1 = function(e1) {
                            if (e1.patternJoinNone) {
                                const t1 = e1.segmentPoints.length / 2, i = e1.lineSoFar - e1.segmentStart;
                                for(let n = 0; n < t1; ++n){
                                    const t1 = e1.segmentPoints[2 * n + 1], r = Math.round(e1.segmentPoints[2 * n]) + .5 + .25 * t1;
                                    e1.patternVertexArray.emplaceBack(r, i, e1.segmentStart), e1.patternVertexArray.emplaceBack(r, i, e1.segmentStart);
                                }
                                e1.segmentPoints.length = 0;
                            }
                            e1.e1 = e1.e2 = -1;
                        };
                        if (i && l < Dd) {
                            this.updateDistance(g, m), this.addCurrentVertex(m, x, 1, 1, _, A), e1(this), this.addCurrentVertex(m, v, -1, -1, _, A);
                            continue;
                        }
                        if (g) {
                            if (!y) {
                                this.updateDistance(g, m), this.addCurrentVertex(m, x, 1, 1, _, A), e1(this);
                                continue;
                            }
                            s = "miter";
                        }
                    }
                    let E = x.add(v);
                    0 === E.x && 0 === E.y || E._unit();
                    const I = E.x * v.x + E.y * v.y, M = 0 !== I ? 1 / I : 1 / 0, S = 2 * Math.sqrt(2 - 2 * I), T = I < Pd && g && y, z = x.x * v.y - x.y * v.x > 0, R = this.overscaling <= 16 ? 122880 / (512 * this.overscaling) : 0;
                    if (i && "round" === s) {
                        if (M < a) s = "miter";
                        else if (M <= 2) {
                            const e1 = Cd(m, -10, 8202);
                            s = "offset" === this.elevationType && (e1 || this.hasCrossSlope) ? "miter" : "fakeround";
                        }
                    }
                    if ("miter" === s && M > o && (s = "bevel"), "bevel" === s && (M > 2 && (s = "flipbevel"), M < o && (s = "miter")), g && !("miter" === s && T) && this.updateDistance(g, m), "miter" === s) {
                        if (T) {
                            const e1 = m.dist(g);
                            if (e1 > 2 * R) {
                                const t1 = m.sub(m.sub(g)._mult(R / e1)._round());
                                this.updateDistance(g, t1), this.addCurrentVertex(t1, x, 0, 0, _, A), g = t1;
                            }
                            this.updateDistance(g, m), E._mult(M), this.addCurrentVertex(m, E, 0, 0, _, A);
                            const t1 = m.dist(y);
                            if (t1 > 2 * R) {
                                const e1 = m.add(y.sub(m)._mult(R / t1)._round());
                                this.updateDistance(m, e1), this.addCurrentVertex(e1, v, 0, 0, _, A), m = e1;
                            }
                        } else E._mult(M), this.addCurrentVertex(m, E, 0, 0, _, A);
                    } else if ("flipbevel" === s) {
                        if (M > 100) E = v.mult(-1);
                        else {
                            const e1 = M * x.add(v).mag() / x.sub(v).mag();
                            E._perp()._mult(e1 * (z ? -1 : 1));
                        }
                        this.addCurrentVertex(m, E, 0, 0, _, A), this.addCurrentVertex(m, E.mult(-1), 0, 0, _, A);
                    } else if ("bevel" === s || "fakeround" === s) {
                        const e1 = m.dist(g);
                        let t1 = 1;
                        if ("offset" === this.elevationType && "bevel" === s && "round" !== this.currentLineJoinType && !this.patternJoinNone && null != A && g && y) {
                            const i = 4 * R;
                            e1 < i && (t1 = Math.max(0, e1 / i));
                        }
                        null != A && g && this.addCurrentVertex(m, w || x, -t1, -t1, _, A);
                        const i = e1 <= 1 * R && "bevel" !== s, n = i ? 1 : M, r = E.mult(z ? 1 : -1);
                        r._mult(n);
                        const o = v.mult(z ? -1 : 1), a = x.mult(z ? -1 : 1), c = this.evaluateLineProgressFeatures(this.distance);
                        if (null == A && (this.addHalfVertex(m, r.x, r.y, !1, !z, 0, _, c), i || this.addHalfVertex(m, r.x + 2 * a.x, r.y + 2 * a.y, !1, z, 0, _, c)), "fakeround" === s) {
                            const e1 = Math.round(180 * S / Math.PI / 20);
                            this.addHalfVertex(m, a.x, a.y, !1, z, 0, _, c);
                            for(let t1 = 0; t1 < e1; t1++){
                                let i = t1 / e1;
                                if (.5 !== i) {
                                    const e1 = i - .5;
                                    i += i * e1 * (i - 1) * ((1.0904 + l * (l * (3.55645 - 1.43519 * l) - 3.2452)) * e1 * e1 + (.848013 + l * (.215638 * l - 1.06021)));
                                }
                                const n = o.sub(a)._mult(i)._add(a)._unit();
                                this.addHalfVertex(m, n.x, n.y, !1, z, 0, _, c);
                            }
                            this.addHalfVertex(m, o.x, o.y, !1, z, 0, _, c);
                        }
                        i || null != A || this.addHalfVertex(m, r.x + 2 * o.x, r.y + 2 * o.y, !1, z, 0, _, c), null != A && y && this.addCurrentVertex(m, b || v, t1, t1, _, A);
                    } else if ("butt" === s) this.addCurrentVertex(m, E, 0, 0, _, A);
                    else if ("square" === s) {
                        if (!g) {
                            const e1 = u ? 0 : -1;
                            this.addCurrentVertex(m, E, e1, e1, _, A);
                        }
                        if (this.addCurrentVertex(m, E, 0, 0, _, A), g) {
                            const e1 = h ? 0 : 1;
                            this.addCurrentVertex(m, E, e1, e1, _, A);
                        }
                    } else if ("round" === s) {
                        if (g) {
                            const e1 = !i && w ? w : x;
                            this.addCurrentVertex(m, e1, 0, 0, _, A), !i && h || this.addCurrentVertex(m, e1, 1, 1, _, A, !0);
                        }
                        if (y) {
                            const e1 = !i && b ? b : v;
                            !i && u || this.addCurrentVertex(m, e1, -1, -1, _, A, !0), this.addCurrentVertex(m, e1, 0, 0, _, A);
                        }
                    }
                }
            }
            addVerticesTo(e1, t1, i, n, r, o, a, s, l, c) {
                const u = (t1.w - e1.w) / this.tessellationStep | 0;
                let h = 0;
                const d = this.scaledDistance;
                if (u > 1) {
                    this.lineSoFar = e1.w;
                    const i = (t1.x - e1.x) / u, n = (t1.y - e1.y) / u, r = (t1.z - e1.z) / u, o = (t1.w - e1.w) / u, a = t1.x - e1.x, s = t1.y - e1.y, d = Math.sqrt(a * a + s * s);
                    if (0 === d) return;
                    const f = -s / d, p = a / d, _ = f, m = p, g = -f, y = -p;
                    for(let t1 = 1; t1 < u; ++t1){
                        e1.x += i, e1.y += n, e1.z += r, this.lineSoFar += o, h += o;
                        const t1 = this.evaluateLineProgressFeatures(this.prevDistance + h);
                        this.scaledDistance = (this.prevDistance + h) / this.totalDistance, this.addHalfVertex(e1, _, m, c, !1, 0, l, t1), this.addHalfVertex(e1, g, y, c, !0, 0, l, t1);
                    }
                }
                this.lineSoFar = t1.w, this.scaledDistance = d;
                const f = this.evaluateLineProgressFeatures(this.distance);
                this.addHalfVertex(t1, i, n, c, !1, a, l, f), this.addHalfVertex(t1, r, o, c, !0, -s, l, f);
            }
            evaluateLineProgressFeatures(e1) {
                if (!this.variableWidthValue && !this.variableEmissiveStrengthValue && "offset" !== this.elevationType) return null;
                this.evaluationGlobals.lineProgress = 0, this.lineClips ? this.evaluationGlobals.lineProgress = Math.min(1, (this.totalFeatureLength * this.lineClips.start + e1) / this.totalFeatureLength) : _t(`line-progress evaluation for ${this.layerIds[0]} requires enabling 'lineMetrics' for the source.`);
                let t1 = 0;
                this.variableWidthValue && "constant" !== this.variableWidthValue.kind && (t1 = this.variableWidthValue.evaluate(this.evaluationGlobals, this.lineFeature) || 0, t1 *= .5);
                let i = 0;
                this.variableEmissiveStrengthValue && "constant" !== this.variableEmissiveStrengthValue.kind && (i = this.variableEmissiveStrengthValue.evaluate(this.evaluationGlobals, this.lineFeature) || 0);
                const n = this.evaluateElevationGroundScale();
                return "offset" !== this.elevationType ? {
                    zOffset: 0,
                    variableWidth: t1,
                    elevationGroundScale: n,
                    variableEmissiveStrength: i
                } : "constant" === this.zOffsetValue.kind ? {
                    zOffset: this.zOffsetValue.value,
                    variableWidth: t1,
                    elevationGroundScale: n,
                    variableEmissiveStrength: i
                } : {
                    zOffset: this.zOffsetValue.evaluate(this.evaluationGlobals, this.lineFeature) || 0,
                    variableWidth: t1,
                    elevationGroundScale: n,
                    variableEmissiveStrength: i
                };
            }
            evaluateElevationGroundScale() {
                return this.elevationGroundScaleValue ? "constant" === this.elevationGroundScaleValue.kind ? this.elevationGroundScaleValue.value : this.elevationGroundScaleValue.evaluate(this.evaluationGlobals, this.lineFeature) || 0 : 0;
            }
            addCurrentVertex(e1, t1, i, n, r, o, a = !1) {
                const s = t1.x + t1.y * i, l = t1.y - t1.x * i, c = t1.y * n - t1.x, u = -t1.y - t1.x * n;
                if (null != o) {
                    const t1 = "offset" === this.elevationType, h = "offset" === this.elevationType ? 2 : 10, d = -h, f = Sr + h, p = o.zOffset, _ = new _d(e1.x, e1.y, p, this.lineSoFar), m = !!t1 && Cd(e1, d, f), g = this.lineSoFar, y = this.distance;
                    if (this.currentVertex) {
                        if (m) {
                            const t1 = this.currentVertexIsOutside, o = this.currentVertex, h = new _d(e1.x, e1.y, p, this.lineSoFar);
                            if (gd(o, h, d, f), !Cd(h, d, f)) {
                                if (t1) {
                                    this.e1 = this.e2 = -1, this.distance -= o.dist(_), this.lineSoFar = o.w;
                                    const e1 = this.evaluateLineProgressFeatures(o.w - this.totalFeatureLength * (this.lineClips ? this.lineClips.start : 0));
                                    this.addHalfVertex(o, s, l, a, !1, i, r, e1), this.addHalfVertex(o, c, u, a, !0, -n, r, e1), this.prevDistance = this.distance;
                                }
                                this.distance = this.prevDistance + o.dist(h), this.scaledDistance = this.distance / this.totalDistance, this.addVerticesTo(o, h, s, l, c, u, i, n, r, a), this.distance = y, this.scaledDistance = this.distance / this.totalDistance;
                            }
                        } else {
                            const e1 = this.currentVertex;
                            if (this.currentVertexIsOutside) {
                                gd(e1, _, d, f), this.e1 = this.e2 = -1, this.distance -= e1.dist(_), this.scaledDistance = this.distance / this.totalDistance, this.lineSoFar = e1.w;
                                const t1 = this.evaluateLineProgressFeatures(e1.w - this.totalFeatureLength * (this.lineClips ? this.lineClips.start : 0));
                                this.addHalfVertex(e1, s, l, a, !1, i, r, t1), this.addHalfVertex(e1, c, u, a, !0, -n, r, t1), this.prevDistance = this.distance, this.distance = y, this.scaledDistance = this.distance / this.totalDistance;
                            }
                            this.addVerticesTo(e1, _, s, l, c, u, i, n, r, a);
                        }
                    } else m || (this.addHalfVertex(e1, s, l, a, !1, i, r, o), this.addHalfVertex(e1, c, u, a, !0, -n, r, o));
                    this.currentVertex = _, this.currentVertexIsOutside = m, this.lineSoFar = g;
                } else this.addHalfVertex(e1, s, l, a, !1, i, r, o), this.addHalfVertex(e1, c, u, a, !0, -n, r, o);
            }
            addHalfVertex({ x: e1, y: t1 }, i, n, r, o, a, s, l) {
                if (this.patternJoinNone && (0 === this.segmentPoints.length && (this.segmentStart = this.lineSoFar, this.segmentStartf32 = Math.fround(this.lineSoFar)), o || this.segmentPoints.push(this.lineSoFar - this.segmentStart, a)), this.layoutVertexArray.emplaceBack((e1 << 1) + (r ? 1 : 0), (t1 << 1) + (o ? 1 : 0), Math.round(63 * i) + 128, Math.round(63 * n) + 128, 1 + (0 === a ? 0 : a < 0 ? -1 : 1), 0, this.lineSoFar - this.segmentStartf32, this.currentFeatureUboIndex), this.lineClips) {
                    const e1 = hn(this.lineClips.start, this.lineClips.end, this.scaledDistance);
                    this.layoutVertexArray2.emplaceBack(this.scaledDistance, this.lineClipsArray.length, e1);
                }
                const c = s.vertexLength++;
                if (this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, c), s.primitiveLength++), o ? this.e2 = c : this.e1 = c, null != l && (this.zOffsetVertexArray.emplaceBack(l.zOffset, l.variableWidth, l.variableWidth, l.variableEmissiveStrength), this.showElevationIdDebug && this.elevationIdColVertexArray.emplaceBack(0, 0, 0)), this.elevationGroundScaleValue) {
                    const e1 = l ? l.elevationGroundScale : this.evaluateElevationGroundScale();
                    this.elevationGroundScaleVertexArray.emplaceBack(e1);
                }
            }
            updateScaledDistance() {
                this.lineClips ? (this.scaledDistance = this.distance / this.totalDistance, this.lineSoFar = this.totalFeatureLength * this.lineClips.start + this.distance) : this.lineSoFar = this.distance;
            }
            updateDistance(e1, t1) {
                this.prevDistance = this.distance, this.distance += e1.dist(t1), this.updateScaledDistance();
            }
        }
        function Cd(e1, t1, i) {
            return e1.x < t1 || e1.x > i || e1.y < t1 || e1.y > i;
        }
        Ya(Fd, "LineBucket", {
            omit: [
                "layers",
                "patternFeatures",
                "currentVertex",
                "currentVertexIsOutside",
                "lineFeature",
                "cachedBatchIndices",
                "cachedBatchSegments"
            ]
        });
        const Od = Pc([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), Ld = Pc([
            {
                name: "a_circle_z_offset",
                components: 1,
                type: "Float32"
            }
        ], 4), Bd = Pc([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_pos_normal_3",
                components: 3,
                type: "Int16"
            }
        ]);
        class Vd {
            constructor(e1){
                this.zoom = e1.zoom, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.hasPattern = !1, this.projection = e1.projection, this.layoutVertexArray = new Fc, this.indexArray = new nu, this.segments = new Ou, this.programConfigurations = new ch(e1.layers, {
                    zoom: e1.zoom,
                    lut: e1.lut
                }), this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.worldview = e1.worldview, this.hasAppearances = null;
            }
            updateFootprints(e1, t1) {}
            updateAppearances(e1, t1, i, n) {
                return {
                    hasLayoutChanges: !1,
                    hasUboChanges: !1
                };
            }
            populate(e1, t1, i, n) {
                const r = this.layers[0], o = [];
                let a = null;
                "circle" === r.type && (a = r.layout.get("circle-sort-key"));
                const s = new Ls(this.zoom, {
                    worldview: this.worldview,
                    activeFloors: t1.activeFloors
                });
                for (const { feature: t1, id: r, index: l, sourceLayerIndex: c } of e1){
                    const e1 = this.layers[0]._featureFilter.needGeometry, u = Mc(t1, e1);
                    if (!this.layers[0]._featureFilter.filter(s, u, i)) continue;
                    const h = a ? a.evaluate(u, {}, i) : void 0, d = {
                        id: r,
                        properties: t1.properties,
                        type: t1.type,
                        sourceLayerIndex: c,
                        index: l,
                        geometry: Ic(t1, u, e1, i, n),
                        patterns: {},
                        sortKey: h
                    };
                    o.push(d);
                }
                a && o.sort((e1, t1)=>e1.sortKey - t1.sortKey);
                let l = null;
                "globe" === n.projection.name && (this.globeExtVertexArray = new $c, l = n.projection);
                for (const n of o){
                    const { geometry: r, index: o, sourceLayerIndex: a } = n, s = e1[o].feature;
                    this.addFeature(n, r, o, t1.availableImages, i, l, t1.brightness, t1.elevationFeatures), t1.featureIndex.insert(s, r, o, a, this.index);
                }
                this.hdExt && this.hdExt.finalize();
            }
            update(e1, t1, i, n, r, o, a) {
                this.programConfigurations.updatePaintArrays(e1, t1, r, i, n, o, a, this.worldview);
            }
            updateExpressions(e1) {
                this.programConfigurations.updateExpressions(e1);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(e1) {
                this.uploaded || (this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, Od.members), this.indexBuffer = e1.createIndexBuffer(this.indexArray), this.globeExtVertexArray && (this.globeExtVertexBuffer = e1.createVertexBuffer(this.globeExtVertexArray, Bd.members)), this.hdExt && this.hdExt.upload(e1)), this.programConfigurations.upload(e1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy(), this.hdExt && this.hdExt.destroy());
            }
            addFeature(e1, t1, i, n, r, o, a, s) {
                this.hdExt && this.hdExt.beginFeature(e1, s, r);
                for (const i of t1)for (const t1 of i){
                    const i = t1.x, n = t1.y;
                    if (i < 0 || i >= Sr || n < 0 || n >= Sr) continue;
                    if (o) {
                        const e1 = o.projectTilePoint(i, n, r), t1 = o.upVector(r, i, n);
                        this.addGlobeExtVertex(e1, t1), this.addGlobeExtVertex(e1, t1), this.addGlobeExtVertex(e1, t1), this.addGlobeExtVertex(e1, t1);
                    }
                    const a = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, e1.sortKey), s = a.vertexLength;
                    this.addCircleVertex(i, n, -1, -1), this.addCircleVertex(i, n, 1, -1), this.addCircleVertex(i, n, 1, 1), this.addCircleVertex(i, n, -1, 1), this.hdExt && this.hdExt.writeVertexQuad(i, n), this.indexArray.emplaceBack(s, s + 1, s + 2), this.indexArray.emplaceBack(s, s + 2, s + 3), a.vertexLength += 4, a.primitiveLength += 2;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e1, i, {}, n, r, a, void 0, this.worldview);
            }
            addCircleVertex(e1, t1, i, n) {
                this.layoutVertexArray.emplaceBack(2 * e1 + (i + 1) / 2, 2 * t1 + (n + 1) / 2);
            }
            addGlobeExtVertex(e1, t1) {
                const i = 16384;
                this.globeExtVertexArray.emplaceBack(e1.x, e1.y, e1.z, t1[0] * i, t1[1] * i, t1[2] * i);
            }
        }
        Ya(Vd, "CircleBucket", {
            omit: [
                "layers"
            ]
        });
        const Nd = Pc([
            {
                name: "a_pos_offset",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_tex_size",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixeloffset",
                components: 4,
                type: "Int16"
            }
        ], 4), kd = Pc([
            {
                name: "a_globe_anchor",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_globe_normal",
                components: 3,
                type: "Float32"
            }
        ], 4), Ud = Pc([
            {
                name: "a_projected_pos",
                components: 4,
                type: "Float32"
            }
        ], 4);
        Pc([
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint32"
            }
        ], 4);
        const jd = Pc([
            {
                name: "a_fade_ref_time",
                components: 2,
                type: "Int32"
            }
        ], 4), Gd = Pc([
            {
                name: "a_auto_z_offset",
                components: 1,
                type: "Float32"
            }
        ], 4), Hd = Pc([
            {
                name: "a_feature_index",
                components: 1,
                type: "Float32"
            }
        ], 4), $d = Pc([
            {
                name: "a_x_axis",
                components: 3,
                type: "Float32"
            },
            {
                name: "a_y_axis",
                components: 3,
                type: "Float32"
            }
        ]), Zd = Pc([
            {
                name: "a_texb",
                components: 2,
                type: "Uint16"
            }
        ]), Wd = Pc([
            {
                name: "a_placed",
                components: 2,
                type: "Uint8"
            },
            {
                name: "a_shift",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_elevation_from_sea",
                components: 2,
                type: "Float32"
            }
        ]), qd = Pc([
            {
                name: "a_size_scale",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_padding",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_auto_z_offset",
                components: 1,
                type: "Float32"
            }
        ]);
        Pc([
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Int16",
                name: "tileAnchorX"
            },
            {
                type: "Int16",
                name: "tileAnchorY"
            },
            {
                type: "Float32",
                name: "x1"
            },
            {
                type: "Float32",
                name: "y1"
            },
            {
                type: "Float32",
                name: "x2"
            },
            {
                type: "Float32",
                name: "y2"
            },
            {
                type: "Int16",
                name: "padding"
            },
            {
                type: "Uint32",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "sourceLayerIndex"
            },
            {
                type: "Uint16",
                name: "bucketIndex"
            }
        ]);
        const Xd = Pc([
            {
                name: "a_pos",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_anchor_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_extrude",
                components: 2,
                type: "Int16"
            }
        ], 4), Yd = Pc([
            {
                name: "a_pos_2f",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_radius",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_flags",
                components: 2,
                type: "Int16"
            }
        ], 4), Jd = Pc([
            {
                name: "a_pos_2f",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_size",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_collision_padding",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_flags",
                components: 2,
                type: "Int16"
            }
        ], 4);
        Pc([
            {
                name: "triangle",
                components: 3,
                type: "Uint16"
            }
        ]), Pc([
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Float32",
                name: "tileAnchorX"
            },
            {
                type: "Float32",
                name: "tileAnchorY"
            },
            {
                type: "Uint16",
                name: "glyphStartIndex"
            },
            {
                type: "Uint16",
                name: "numGlyphs"
            },
            {
                type: "Uint32",
                name: "vertexStartIndex"
            },
            {
                type: "Uint32",
                name: "lineStartIndex"
            },
            {
                type: "Uint32",
                name: "lineLength"
            },
            {
                type: "Uint16",
                name: "segment"
            },
            {
                type: "Uint16",
                name: "lowerSize"
            },
            {
                type: "Uint16",
                name: "upperSize"
            },
            {
                type: "Float32",
                name: "lineOffsetX"
            },
            {
                type: "Float32",
                name: "lineOffsetY"
            },
            {
                type: "Uint8",
                name: "writingMode"
            },
            {
                type: "Uint8",
                name: "placedOrientation"
            },
            {
                type: "Uint8",
                name: "hidden"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Int16",
                name: "associatedIconIndex"
            },
            {
                type: "Uint8",
                name: "flipState"
            }
        ]), Pc([
            {
                type: "Float32",
                name: "tileAnchorX"
            },
            {
                type: "Float32",
                name: "tileAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Int16",
                name: "rightJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "centerJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "leftJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "placedIconSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedIconSymbolIndex"
            },
            {
                type: "Uint16",
                name: "key"
            },
            {
                type: "Uint16",
                name: "textBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "textBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "numHorizontalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numIconVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalIconVertices"
            },
            {
                type: "Uint16",
                name: "useRuntimeCollisionCircles"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Float32",
                components: 2,
                name: "textOffset"
            },
            {
                type: "Float32",
                name: "collisionCircleDiameter"
            },
            {
                type: "Float32",
                name: "zOffset"
            },
            {
                type: "Uint8",
                name: "hasIconTextFit"
            },
            {
                type: "Uint16",
                name: "elevationFeatureIndex"
            }
        ]), Pc([
            {
                type: "Float32",
                name: "offsetX"
            }
        ]), Pc([
            {
                type: "Int16",
                name: "x"
            },
            {
                type: "Int16",
                name: "y"
            }
        ]);
        const Kd = class e1 extends Ph {
            _headerBytes() {
                return e1.HEADER_BYTES;
            }
            _propCount() {
                return 9;
            }
            _blockNames() {
                return [
                    "SymbolPaintPropertiesHeaderUniform",
                    "SymbolPaintPropertiesUniform",
                    "SymbolPaintPropertiesIndexUniform"
                ];
            }
            _copyFromFlat(t1, i, n) {
                let r = 4;
                (i < 2 || 8 === i) && (r = this.headerData[1] >>> i & 1 ? 8 : 4);
                const o = e1.EVAL_FLAT_OFFSETS[i];
                this.propertiesData.set(n.subarray(o, o + r), t1);
            }
        };
        Kd.HEADER_DWORDS = 16, Kd.HEADER_BYTES = 64, Kd.EVAL_FLAT_OFFSETS = [
            0,
            8,
            16,
            20,
            24,
            28,
            32,
            36,
            40
        ], Kd.EVAL_FLAT_TOTAL = 48;
        let Qd = Kd;
        Ya(Qd, "SymbolPropertiesUBO", {
            omit: [
                "headerBuffer",
                "propertiesBuffer",
                "blockIndicesBuffer"
            ]
        });
        const ef = [
            "icon",
            "text"
        ].map((e1)=>[
                `${e1}-color`,
                `${e1}-halo-color`,
                `${e1}-opacity`,
                `${e1}-halo-width`,
                `${e1}-halo-blur`,
                `${e1}-emissive-strength`,
                `${e1}-occlusion-opacity`,
                "symbol-z-offset",
                `${e1}-translate`
            ]), tf = new Float32Array(Qd.EVAL_FLAT_TOTAL), nf = new Float32Array(2), rf = [
            0,
            0
        ];
        class of extends Bh {
            constructor(e1, t1, i, n, r = "", o){
                super(e1, t1, i, r, o), this.isText = n, this.allFormattedSections = [], this.activeAppearanceByVtIndex = null, this._finishInitialization();
            }
            _propNames() {
                return ef[+this.isText];
            }
            _headerDwords() {
                return Qd.HEADER_DWORDS;
            }
            _createUBO(e1) {
                return new Qd(null, e1, this.uboSizeDwords, this.header);
            }
            _flatScratch() {
                return tf;
            }
            updateHeader() {
                const e1 = this.layer.paint;
                let t1 = 0, i = 0, n = !1, r = 0;
                const o = this._floorZoom, a = ef[+this.isText];
                for(let s = 0; s < 9; s++){
                    const l = a[s], c = s < 2, u = e1.get(l), h = !(!u || "function" != typeof u.isConstant || u.isConstant()), d = this._appearancesHavePaintProperties(l);
                    if (!h && !d) continue;
                    t1 |= 1 << s, h || (n = !0);
                    const f = this._collectZoomSignatures(l, o), p = f.hasZoom, _ = f.differs, m = 8 === s;
                    this.zoomDependency[s] = _ ? 2 : p ? 1 : 0;
                    const g = _ || m && p;
                    g && (i |= 1 << s), this.header[3 + s] = r, r += g ? 2 : 1, p && !_ && f.representative && (this._computeZoomRange(f.representative, o, this.sharedZoomRanges, 2 * s), c && (this.header[12 + 2 * s] = Th(this.sharedZoomRanges[2 * s]), this.header[12 + 2 * s + 1] = Th(this.sharedZoomRanges[2 * s + 1])));
                }
                this.header[0] = t1, this.header[1] = i, this.header[2] = r, this.hasConstantsInBlocks = n;
            }
            _recomputeSharedRanges() {
                const e1 = this._floorZoom, t1 = ef[+this.isText];
                let i = !1;
                for(let n = 0; n < 9; n++){
                    const r = this.zoomDependency[n];
                    if (this.header[0] & 1 << n && 0 !== r && 2 !== r) {
                        const r = this._collectZoomSignatures(t1[n], e1);
                        r.representative && (this._computeZoomRange(r.representative, e1, this.sharedZoomRanges, 2 * n), n < 2 && (this.header[12 + 2 * n] = Th(this.sharedZoomRanges[2 * n]), this.header[12 + 2 * n + 1] = Th(this.sharedZoomRanges[2 * n + 1]), i = !0));
                    }
                }
                if (i) for (const e1 of this.ubos)e1.markHeaderDirty();
            }
            _collectZoomSignatures(e1, t1) {
                let i = !1, n = !1, r = null, o = 0, a = 0;
                const s = (e1)=>{
                    if (!e1) return;
                    this._computeZoomRange(e1, t1, nf, 0);
                    const s = nf[0], l = nf[1];
                    i ? s === o && l === a || (n = !0) : (i = !0, o = s, a = l, r = e1);
                };
                s(this._zoomExprOf(this._layerUnevaluated(e1)));
                for (const t1 of this.layer.getAppearances() || [])t1.hasPaintProperty(e1) && s(this._zoomExprOf(t1.getUnevaluatedPaintProperty(e1)));
                return {
                    hasZoom: i,
                    differs: n,
                    representative: r
                };
            }
            _resolveProp(e1, t1, i = !1, n) {
                const r = this.layer.paint, o = r.get(e1), a = e1, s = !(!t1 || !t1.hasPaintProperty(a)), l = s ? n && o && o.property.overrides && o.property.overrides.hasOverride(n) ? o : t1.paintProperties.get(a) : r.get(e1);
                if (i || !l || "function" != typeof l.isConstant || !l.isConstant()) return l;
                const c = s ? t1.getUnevaluatedPaintProperty(a) : this._layerUnevaluated(e1);
                return this._unbakeCamera(l, c);
            }
            _evaluateTranslateValue(e1, t1, i, n, r, o, a) {
                const s = this._resolveProp(e1, o.activeAppearance);
                this._writePropertyZoomRange(t1, i, n, s, r);
                const l = !!s && "function" == typeof s.isConstant && !s.isConstant(), c = s ? "function" != typeof s.isConstant ? s : l ? this._evalAt(s, o.params, o) : s.constantOr(rf) : void 0;
                if (tf[a] = c ? c[0] : 0, tf[a + 1] = c ? c[1] : 0, i) {
                    const e1 = l ? this._evalAt(s, o.paramsNext, o) : c;
                    tf[a + 2] = e1 ? e1[0] : 0, tf[a + 3] = e1 ? e1[1] : 0;
                } else tf[a + 2] = tf[a], tf[a + 3] = tf[a + 1];
            }
            _evaluatePropertyAt(e1, t1) {
                const i = ef[+this.isText][e1], n = e1 < 2, r = 8 === e1, o = this.zoomDependency[e1], a = 0 !== o, s = 2 === o, l = Qd.EVAL_FLAT_OFFSETS[e1], c = l + (n || r ? 4 : 2);
                if (n) this._evaluateColorValue(i, e1, a, s, c, t1, l);
                else if (r) this._evaluateTranslateValue(i, e1, a, s, c, t1, l);
                else {
                    const n = i.endsWith("opacity") ? 1 : 0;
                    this._evaluateFloatValue(i, e1, a, s, c, t1, l, n);
                }
            }
            _appearancesHavePaintProperties(e1) {
                return this.layer.getAppearances().some((t1)=>t1.hasPaintProperty(e1));
            }
            hasStateDependentPaint(e1) {
                if (super.hasStateDependentPaint(e1)) return !0;
                const t1 = ef[+this.isText];
                for (const i of e1.getAppearances() || [])for (const e1 of t1){
                    const t1 = e1;
                    if (i.hasPaintProperty(t1) && Ch(i.paintProperties.get(t1))) return !0;
                }
                return !1;
            }
            _dependsOnLight(e1, t1) {
                if (super._dependsOnLight(e1, t1)) return !0;
                const i = t1;
                for (const t1 of e1.getAppearances() || [])if (t1.hasPaintProperty(i) && 2 & t1.getUnevaluatedPaintProperty(i).deps) return !0;
                return !1;
            }
            hasPerFeatureTranslate() {
                return !!(256 & this.header[0]);
            }
            updateFeaturePaintForAppearance(e1, t1, i, n, r, o, a) {
                if (!this.layer) return !1;
                if (this.activeAppearanceByVtIndex || (this.activeAppearanceByVtIndex = new Map), this.activeAppearanceByVtIndex.set(e1, a || null), 0 === this.header[0]) return !1;
                this._ensureRangeMaps();
                const s = this.featureVertexRangesFromVtIndex.get(e1);
                if (!s) return !1;
                let l = !1;
                for (const e1 of s){
                    const s = this.evaluateAllProperties(t1, i, n, r, o, (this.allFormattedSections ? this.allFormattedSections[e1] : void 0) || void 0, a);
                    l = this._writeFeatureBlock(e1, s) || l;
                }
                return l;
            }
            _buildConstantUniforms(e1) {
                const t1 = ef[+this.isText];
                return {
                    fill_np_color: this._constantColor(t1[0], e1, [
                        0,
                        0,
                        0,
                        1
                    ]),
                    halo_np_color: this._constantColor(t1[1], e1, [
                        0,
                        0,
                        0,
                        1
                    ]),
                    opacity: this._constantFloat(t1[2], 1),
                    halo_width: this._constantFloat(t1[3], 0),
                    halo_blur: this._constantFloat(t1[4], 0),
                    emissive_strength: this._constantFloat(t1[5], 0),
                    occlusion_opacity: this._constantFloat(t1[6], 1),
                    z_offset: this._constantFloat(t1[7], 0)
                };
            }
        }
        Ya(of, "SymbolPropertyBinderUBO", {
            omit: [
                "layer",
                "cachedConstantUniforms",
                "cachedConstantBrightness",
                "cachedConstantPaint",
                "activeAppearanceByVtIndex",
                "featureVertexRangesFromId",
                "featureVertexRangesFromVtIndex"
            ]
        });
        const af = 24;
        t1.fP = null;
        let sf = null;
        function lf(e1, i, n) {
            return e1.sections.forEach((e1)=>{
                e1.text = function(e1, i, n) {
                    const r = i.layout.get("text-transform").evaluate(n, {});
                    return "uppercase" === r ? e1 = e1.toLocaleUpperCase() : "lowercase" === r && (e1 = e1.toLocaleLowerCase()), t1.fP && (e1 = t1.fP.applyArabicShaping(e1)), e1;
                }(e1.text, i, n);
            }), e1;
        }
        const cf = {
            horizontal: 1,
            vertical: 2,
            horizontalOnly: 3
        };
        function uf(e1) {
            let t1 = .5, i = .5;
            switch(e1){
                case "right":
                case "top-right":
                case "bottom-right":
                    t1 = 1;
                    break;
                case "left":
                case "top-left":
                case "bottom-left":
                    t1 = 0;
            }
            switch(e1){
                case "bottom":
                case "bottom-right":
                case "bottom-left":
                    i = 1;
                    break;
                case "top":
                case "top-right":
                case "top-left":
                    i = 0;
            }
            return {
                horizontalAlign: t1,
                verticalAlign: i
            };
        }
        function hf(e1, t1, i, n) {
            const { horizontalAlign: r, verticalAlign: o } = uf(n), a = i[0] - e1.displaySize[0] * r, s = i[1] - e1.displaySize[1] * o;
            return {
                imagePrimary: e1,
                imageSecondary: t1,
                top: s,
                bottom: s + e1.displaySize[1],
                left: a,
                right: a + e1.displaySize[0]
            };
        }
        function df(e1, t1, i, n, r, o) {
            const a = e1.imagePrimary;
            let s;
            if (a.content) {
                const e1 = a.content, t1 = a.pixelRatio || 1;
                s = [
                    e1[0] / t1,
                    e1[1] / t1,
                    a.displaySize[0] - e1[2] / t1,
                    a.displaySize[1] - e1[3] / t1
                ];
            }
            const l = t1.left * o, c = t1.right * o;
            let u, h, d, f;
            "width" === i || "both" === i ? (f = r[0] + l - n[3], h = r[0] + c + n[1]) : (f = r[0] + (l + c - a.displaySize[0]) / 2, h = f + a.displaySize[0]);
            const p = t1.top * o, _ = t1.bottom * o;
            return "height" === i || "both" === i ? (u = r[1] + p - n[0], d = r[1] + _ + n[2]) : (u = r[1] + (p + _ - a.displaySize[1]) / 2, d = u + a.displaySize[1]), {
                imagePrimary: a,
                imageSecondary: void 0,
                top: u,
                right: h,
                bottom: d,
                left: f,
                collisionPadding: s
            };
        }
        const ff = {
            "!": "\uFE15",
            "#": "\uFF03",
            $: "\uFF04",
            "%": "\uFF05",
            "&": "\uFF06",
            "(": "\uFE35",
            ")": "\uFE36",
            "*": "\uFF0A",
            "+": "\uFF0B",
            ",": "\uFE10",
            "-": "\uFE32",
            ".": "\u30FB",
            "/": "\uFF0F",
            ":": "\uFE13",
            ";": "\uFE14",
            "<": "\uFE3F",
            "=": "\uFF1D",
            ">": "\uFE40",
            "?": "\uFE16",
            "@": "\uFF20",
            "[": "\uFE47",
            "\\": "\uFF3C",
            "]": "\uFE48",
            "^": "\uFF3E",
            _: "\uFE33",
            "`": "\uFF40",
            "{": "\uFE37",
            "|": "\u2015",
            "}": "\uFE38",
            "~": "\uFF5E",
            "\xa2": "\uFFE0",
            "\xa3": "\uFFE1",
            "\xa5": "\uFFE5",
            "\xa6": "\uFFE4",
            "\xac": "\uFFE2",
            "\xaf": "\uFFE3",
            "\u2013": "\uFE32",
            "\u2014": "\uFE31",
            "\u2018": "\uFE43",
            "\u2019": "\uFE44",
            "\u201C": "\uFE41",
            "\u201D": "\uFE42",
            "\u2026": "\uFE19",
            "\u2027": "\u30FB",
            "\u20A9": "\uFFE6",
            "\u3001": "\uFE11",
            "\u3002": "\uFE12",
            "\u3008": "\uFE3F",
            "\u3009": "\uFE40",
            "\u300A": "\uFE3D",
            "\u300B": "\uFE3E",
            "\u300C": "\uFE41",
            "\u300D": "\uFE42",
            "\u300E": "\uFE43",
            "\u300F": "\uFE44",
            "\u3010": "\uFE3B",
            "\u3011": "\uFE3C",
            "\u3014": "\uFE39",
            "\u3015": "\uFE3A",
            "\u3016": "\uFE17",
            "\u3017": "\uFE18",
            "\uFF01": "\uFE15",
            "\uFF08": "\uFE35",
            "\uFF09": "\uFE36",
            "\uFF0C": "\uFE10",
            "\uFF0D": "\uFE32",
            "\uFF0E": "\u30FB",
            "\uFF1A": "\uFE13",
            "\uFF1B": "\uFE14",
            "\uFF1C": "\uFE3F",
            "\uFF1E": "\uFE40",
            "\uFF1F": "\uFE16",
            "\uFF3B": "\uFE47",
            "\uFF3D": "\uFE48",
            "\uFF3F": "\uFE33",
            "\uFF5B": "\uFE37",
            "\uFF5C": "\u2015",
            "\uFF5D": "\uFE38",
            "\uFF5F": "\uFE35",
            "\uFF60": "\uFE36",
            "\uFF61": "\uFE12",
            "\uFF62": "\uFE41",
            "\uFF63": "\uFE42"
        };
        function pf(e1) {
            return "\uFE36" === e1 || "\uFE48" === e1 || "\uFE38" === e1 || "\uFE44" === e1 || "\uFE42" === e1 || "\uFE3E" === e1 || "\uFE3C" === e1 || "\uFE3A" === e1 || "\uFE18" === e1 || "\uFE40" === e1 || "\uFE10" === e1 || "\uFE13" === e1 || "\uFE14" === e1 || "\uFF40" === e1 || "\uFFE3" === e1 || "\uFE11" === e1 || "\uFE12" === e1;
        }
        function _f(e1) {
            return "\uFE35" === e1 || "\uFE47" === e1 || "\uFE37" === e1 || "\uFE43" === e1 || "\uFE41" === e1 || "\uFE3D" === e1 || "\uFE3B" === e1 || "\uFE39" === e1 || "\uFE17" === e1 || "\uFE3F" === e1;
        }
        const mf = 128;
        function gf(e1, t1, i, n) {
            const { expression: r } = t1;
            if ("constant" === r.kind) return {
                kind: "constant",
                layoutSize: r.evaluate(new Ls(e1 + 1, {
                    worldview: i
                }), void 0, void 0, void 0, n)
            };
            if ("source" === r.kind) return {
                kind: "source"
            };
            {
                const { zoomStops: t1, interpolationType: o } = r;
                let a = 0;
                for(; a < t1.length && t1[a] <= e1;)a++;
                a = Math.max(0, a - 1);
                let s = a;
                for(; s < t1.length && t1[s] < e1 + 1;)s++;
                s = Math.min(t1.length - 1, s);
                const l = t1[a], c = t1[s];
                return "composite" === r.kind ? {
                    kind: "composite",
                    minZoom: l,
                    maxZoom: c,
                    interpolationType: o
                } : {
                    kind: "camera",
                    minZoom: l,
                    maxZoom: c,
                    minSize: r.evaluate(new Ls(l, {
                        worldview: i
                    }), void 0, void 0, void 0, n),
                    maxSize: r.evaluate(new Ls(c, {
                        worldview: i
                    }), void 0, void 0, void 0, n),
                    interpolationType: o
                };
            }
        }
        function yf(e1, { uSize: t1, uSizeT: i }, { lowerSize: n, upperSize: r }) {
            return "source" === e1.kind ? n / mf : "composite" === e1.kind ? hn(n / mf, r / mf, i) : t1;
        }
        function xf(e1, t1, i = 1) {
            let n = 0, r = 0;
            if ("constant" === e1.kind) r = e1.layoutSize * i;
            else if ("source" !== e1.kind) {
                const { interpolationType: o, minZoom: a, maxZoom: s } = e1, l = o ? tt(Wo.interpolationFactor(o, t1, a, s), 0, 1) : 0;
                "camera" === e1.kind ? r = hn(e1.minSize, e1.maxSize, l) * i : n = l * i;
            }
            return {
                uSizeT: n,
                uSize: r
            };
        }
        const vf = Number.POSITIVE_INFINITY, bf = Math.sqrt(2), wf = 32640;
        function Af(e1, t1, i, n, r, o, a) {
            const s = e1.hasLayoutProperty(r) ? t1.getAppearanceValueAndResolveTokens(e1, r, i, n, []) : null;
            return (Array.isArray(o) ? Array.isArray(s) : typeof s == typeof o) ? a ? a(s) : s : o;
        }
        function Ef(e1, t1, i, n, r, o, a, s) {
            return {
                appearanceIconOffset: Af(e1, t1, i, n, "icon-offset", r),
                appearanceIconRotate: Af(e1, t1, i, n, "icon-rotate", o),
                appearanceIconSize: Af(e1, t1, i, n, "icon-size", a, (e1)=>e1 * s)
            };
        }
        function If(e1, t1, i, n, r, o, a) {
            const s = Af(e1, t1, i, n, "text-offset", r, ([e1, t1])=>[
                    e1 * af,
                    t1 * af
                ]);
            return {
                appearanceTextOffset: s,
                appearanceTextRotate: Af(e1, t1, i, n, "text-rotate", o),
                appearanceTextSize: Af(e1, t1, i, n, "text-size", a)
            };
        }
        function Mf(e1, t1, i, n, r, o, a, s, l, c) {
            if (!e1) return;
            const u = function(e1, t1, i, n, r, o, a) {
                if ("camera" === e1.kind) return e1.maxSize;
                if ("composite" === e1.kind) {
                    const n = t1.possiblyEvaluate(new Ls(e1.maxZoom, {
                        worldview: o
                    }), i, a).evaluate(r, {}, i, a), s = t1.possiblyEvaluate(new Ls(e1.minZoom, {
                        worldview: o
                    }), i, a).evaluate(r, {}, i, a);
                    return Math.max(n, s);
                }
                return t1.possiblyEvaluate(new Ls(n, {
                    worldview: o
                }), i, a).evaluate(r, {}, i, a);
            }(t1, i, n, r, o, l, c);
            return e1.scaleSelf(u * s * a);
        }
        function Sf(e1, t1, i, n, r, o, a, s, l, c) {
            return {
                iconPrimary: Mf(e1.getPrimary(), t1, i, n, r, o, a, s, l, c),
                iconSecondary: Mf(e1.getSecondary(), t1, i, n, r, o, a, s, l, c)
            };
        }
        function Tf(e1, t1, i, n, r, o) {
            let a = null;
            return "source" === t1.kind ? (a = [
                mf * i * n
            ], a[0] > wf && _t(`${e1}: Value for "text-size" or "icon-size" is >= 255. Reduce your "text-size" or "icon-size".`)) : "composite" === t1.kind && (a = [
                mf * r * n,
                mf * o * n
            ], (a[0] > wf || a[1] > wf) && _t(`${e1}: Value for "text-size" or "icon-size" is >= 255. Reduce your "text-size" or "icon-size".`)), a;
        }
        function zf(e1, t1) {
            const i = e1.layout;
            return "point" === i.get("symbol-placement") && ("icon" === t1 ? "map" === i.get("icon-rotation-alignment") : "map" === i.get("text-rotation-alignment"));
        }
        class Rf {
            constructor(e1, t1){
                this.pos = e1, this.dir = t1;
            }
            intersectsPlane(e1, t1, i) {
                const n = Se(t1, this.dir);
                if (Math.abs(n) < 1e-6) return !1;
                const r = ((e1[0] - this.pos[0]) * t1[0] + (e1[1] - this.pos[1]) * t1[1]) / n;
                return i[0] = this.pos[0] + this.dir[0] * r, i[1] = this.pos[1] + this.dir[1] * r, !0;
            }
        }
        class Pf {
            constructor(e1, t1){
                this.pos = e1, this.dir = t1;
            }
            intersectsPlane(e1, t1, i) {
                const n = Z(t1, this.dir);
                if (Math.abs(n) < 1e-6) return !1;
                const r = ((e1[0] - this.pos[0]) * t1[0] + (e1[1] - this.pos[1]) * t1[1] + (e1[2] - this.pos[2]) * t1[2]) / n;
                return i[0] = this.pos[0] + this.dir[0] * r, i[1] = this.pos[1] + this.dir[1] * r, i[2] = this.pos[2] + this.dir[2] * r, !0;
            }
            closestPointOnSphere(e1, t1, i) {
                if (function(e1, t1) {
                    var i = e1[0], r = e1[1], o = e1[2], a = t1[0], s = t1[1], l = t1[2];
                    return Math.abs(i - a) <= n * Math.max(1, Math.abs(i), Math.abs(a)) && Math.abs(r - s) <= n * Math.max(1, Math.abs(r), Math.abs(s)) && Math.abs(o - l) <= n * Math.max(1, Math.abs(o), Math.abs(l));
                }(this.pos, e1) || 0 === t1) return i[0] = i[1] = i[2] = 0, !1;
                const [r, o, a] = this.dir, s = this.pos[0] - e1[0], l = this.pos[1] - e1[1], c = this.pos[2] - e1[2], u = r * r + o * o + a * a, h = 2 * (s * r + l * o + c * a), d = h * h - 4 * u * (s * s + l * l + c * c - t1 * t1);
                if (d < 0) {
                    const e1 = Math.max(-h / 2, 0), n = s + r * e1, u = l + o * e1, d = c + a * e1, f = Math.hypot(n, u, d);
                    return i[0] = n * t1 / f, i[1] = u * t1 / f, i[2] = d * t1 / f, !1;
                }
                {
                    const e1 = (-h - Math.sqrt(d)) / (2 * u);
                    if (e1 < 0) {
                        const e1 = Math.hypot(s, l, c);
                        return i[0] = s * t1 / e1, i[1] = l * t1 / e1, i[2] = c * t1 / e1, !1;
                    }
                    return i[0] = s + r * e1, i[1] = l + o * e1, i[2] = c + a * e1, !0;
                }
            }
        }
        class Df {
            constructor(e1, t1, i, n, r){
                this.TL = e1, this.TR = t1, this.BR = i, this.BL = n, this.horizon = r;
            }
            static fromInvProjectionMatrix(e1, t1, i) {
                const n = [
                    -1,
                    1,
                    1
                ], r = [
                    1,
                    1,
                    1
                ], o = [
                    1,
                    -1,
                    1
                ], a = [
                    -1,
                    -1,
                    1
                ], s = X(n, n, e1), l = X(r, r, e1), c = X(o, o, e1), u = X(a, a, e1);
                return new Df(s, l, c, u, t1 / i);
            }
        }
        function Ff(e1, t1, i, n) {
            const r = t1[0], o = t1[1], a = t1[2], s = i[0], l = i[1], c = i[2];
            let u = 1 / 0, h = -1 / 0;
            for(let t1 = 0; t1 < e1.length; t1++){
                const i = e1[t1], n = (i[0] - r) * s + (i[1] - o) * l + (i[2] - a) * c;
                n < u && (u = n), n > h && (h = n);
            }
            return n[0] = u, n[1] = h, n;
        }
        function Cf(e1, t1, i, n, r) {
            let o = !0;
            for(let a = 0; a < e1.planes.length; a++){
                const s = e1.planes[a], l = s[0], c = s[1], u = s[2], h = s[3];
                if (!((l > 0 ? i[0] : t1[0]) * l + (c > 0 ? i[1] : t1[1]) * c + (u > 0 ? r : n) * u + h >= 0)) return 0;
                !o || (l > 0 ? t1[0] : i[0]) * l + (c > 0 ? t1[1] : i[1]) * c + (u > 0 ? n : r) * u + h >= 0 || (o = !1);
            }
            return o ? 2 : 1;
        }
        const Of = [
            0,
            0
        ];
        function Lf(e1, t1) {
            for (const i of e1.projections){
                const n = Ff(t1, e1.points[0], i.axis, Of);
                if (i.projection[1] < n[0] || i.projection[0] > n[1]) return 0;
            }
            return 1;
        }
        function Bf(e1, t1) {
            const i = t1[0], n = t1[1], r = t1[2], o = t1[3];
            for(let t1 = 0; t1 < e1.length; t1++){
                const a = e1[t1];
                if (i * a[0] + n * a[1] + r * a[2] + o >= 0) return !0;
            }
            return !1;
        }
        class Vf {
            constructor(e1, t1){
                this.points = e1 || new Array(8).fill([
                    0,
                    0,
                    0
                ]), this.planes = t1 || new Array(6).fill([
                    0,
                    0,
                    0,
                    0
                ]), this.bounds = Nf.fromPoints(this.points), this.projections = [], this.frustumEdges = [
                    ee([], this.points[2], this.points[3]),
                    ee([], this.points[0], this.points[3]),
                    ee([], this.points[4], this.points[0]),
                    ee([], this.points[5], this.points[1]),
                    ee([], this.points[6], this.points[2]),
                    ee([], this.points[7], this.points[3])
                ];
                for (const e1 of this.frustumEdges){
                    const t1 = [
                        0,
                        -e1[2],
                        e1[1]
                    ], i = [
                        e1[2],
                        0,
                        -e1[0]
                    ];
                    this.projections.push({
                        axis: t1,
                        projection: Ff(this.points, this.points[0], t1, [
                            0,
                            0
                        ])
                    }), this.projections.push({
                        axis: i,
                        projection: Ff(this.points, this.points[0], i, [
                            0,
                            0
                        ])
                    });
                }
            }
            static fromInvProjectionMatrix(e1, t1, i, n) {
                const r = Math.pow(2, i), o = [
                    [
                        -1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        -1,
                        1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        1,
                        1
                    ]
                ].map((i)=>{
                    const o = se([], i, e1), a = 1 / o[3] / t1 * r;
                    return function(e1, t1, i) {
                        return e1[0] = t1[0] * i[0], e1[1] = t1[1] * i[1], e1[2] = t1[2] * i[2], e1[3] = t1[3] * i[3], e1;
                    }(o, o, [
                        a,
                        a,
                        n ? 1 / o[3] : a,
                        a
                    ]);
                }), a = [
                    [
                        0,
                        1,
                        2
                    ],
                    [
                        6,
                        5,
                        4
                    ],
                    [
                        0,
                        3,
                        7
                    ],
                    [
                        2,
                        1,
                        5
                    ],
                    [
                        3,
                        2,
                        6
                    ],
                    [
                        0,
                        4,
                        5
                    ]
                ].map((e1)=>{
                    const t1 = $([], W([], ee([], o[e1[0]], o[e1[1]]), ee([], o[e1[2]], o[e1[1]]))), i = -Z(t1, o[e1[1]]);
                    return t1.concat(i);
                }), s = [];
                for(let e1 = 0; e1 < o.length; e1++)s.push([
                    o[e1][0],
                    o[e1][1],
                    o[e1][2]
                ]);
                return new Vf(s, a);
            }
            intersectsPrecise(e1, t1, i) {
                for(let i = 0; i < t1.length; i++)if (!Bf(e1, t1[i])) return 0;
                for(let t1 = 0; t1 < this.planes.length; t1++)if (!Bf(e1, this.planes[t1])) return 0;
                const n = this.points, r = n[0][0], o = n[0][1], a = n[0][2];
                for (const t1 of i)for (const i of this.frustumEdges){
                    const s = t1[1] * i[2] - t1[2] * i[1], l = t1[2] * i[0] - t1[0] * i[2], c = t1[0] * i[1] - t1[1] * i[0];
                    if (0 === s && 0 === l && 0 === c) continue;
                    let u = 1 / 0, h = -1 / 0;
                    for(let e1 = 0; e1 < n.length; e1++){
                        const t1 = n[e1], i = (t1[0] - r) * s + (t1[1] - o) * l + (t1[2] - a) * c;
                        i < u && (u = i), i > h && (h = i);
                    }
                    let d = 1 / 0, f = -1 / 0;
                    for(let t1 = 0; t1 < e1.length; t1++){
                        const i = e1[t1], n = (i[0] - r) * s + (i[1] - o) * l + (i[2] - a) * c;
                        n < d && (d = n), n > f && (f = n);
                    }
                    if (u > f || d > h) return 0;
                }
                return 1;
            }
            containsPoint(e1) {
                for (const t1 of this.planes){
                    const i = t1[3];
                    if (Z([
                        t1[0],
                        t1[1],
                        t1[2]
                    ], e1) + i < 0) return !1;
                }
                return !0;
            }
        }
        class Nf {
            static fromPoints(e1) {
                const t1 = [
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], i = [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ];
                for (const n of e1)B(t1, t1, n), V(i, i, n);
                return new Nf(t1, i);
            }
            static fromTileIdAndHeight(e1, t1, i) {
                const n = 1 << e1.canonical.z, r = e1.canonical.x, o = e1.canonical.y;
                return new Nf([
                    r / n,
                    o / n,
                    t1
                ], [
                    (r + 1) / n,
                    (o + 1) / n,
                    i
                ]);
            }
            static applyTransform(e1, t1) {
                const i = e1.getCorners();
                for(let e1 = 0; e1 < i.length; ++e1)X(i[e1], i[e1], t1);
                return Nf.fromPoints(i);
            }
            static applyTransformFast(e1, t1) {
                const i = [
                    t1[12],
                    t1[13],
                    t1[14]
                ], n = [
                    ...i
                ];
                for(let r = 0; r < 3; r++)for(let o = 0; o < 3; o++){
                    const a = t1[4 * o + r], s = a * e1.min[o], l = a * e1.max[o];
                    i[r] += Math.min(s, l), n[r] += Math.max(s, l);
                }
                return new Nf(i, n);
            }
            static projectAabbCorners(e1, t1) {
                const i = e1.getCorners();
                for(let e1 = 0; e1 < i.length; ++e1)X(i[e1], i[e1], t1);
                return i;
            }
            constructor(e1, t1){
                this.min = e1, this.max = t1, this.center = [
                    .5 * (e1[0] + t1[0]),
                    .5 * (e1[1] + t1[1]),
                    .5 * (e1[2] + t1[2])
                ];
            }
            quadrant(e1) {
                const { min: t1, max: i, center: n } = this, r = e1 % 2 == 0, o = e1 < 2;
                return new Nf(D(r ? t1[0] : n[0], o ? t1[1] : n[1], t1[2]), D(r ? n[0] : i[0], o ? n[1] : i[1], i[2]));
            }
            distanceX(e1) {
                return Math.max(Math.min(this.max[0], e1[0]), this.min[0]) - e1[0];
            }
            distanceY(e1) {
                return Math.max(Math.min(this.max[1], e1[1]), this.min[1]) - e1[1];
            }
            distanceZ(e1) {
                return Math.max(Math.min(this.max[2], e1[2]), this.min[2]) - e1[2];
            }
            getCorners() {
                const e1 = this.min, t1 = this.max;
                return [
                    [
                        e1[0],
                        e1[1],
                        e1[2]
                    ],
                    [
                        t1[0],
                        e1[1],
                        e1[2]
                    ],
                    [
                        t1[0],
                        t1[1],
                        e1[2]
                    ],
                    [
                        e1[0],
                        t1[1],
                        e1[2]
                    ],
                    [
                        e1[0],
                        e1[1],
                        t1[2]
                    ],
                    [
                        t1[0],
                        e1[1],
                        t1[2]
                    ],
                    [
                        t1[0],
                        t1[1],
                        t1[2]
                    ],
                    [
                        e1[0],
                        t1[1],
                        t1[2]
                    ]
                ];
            }
            intersects(e1) {
                return this.intersectsAabb(e1.bounds) ? Cf(e1, this.min, this.max, this.min[2], this.max[2]) : 0;
            }
            intersectsFlat(e1) {
                return this.intersectsAabb(e1.bounds) ? Cf(e1, this.min, this.max, 0, 0) : 0;
            }
            intersectsPrecise(e1, t1) {
                return t1 || this.intersects(e1) ? Lf(e1, this.getCorners()) : 0;
            }
            intersectsPreciseFlat(e1, t1) {
                return t1 || this.intersectsFlat(e1) ? Lf(e1, [
                    [
                        this.min[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.max[1],
                        0
                    ],
                    [
                        this.min[0],
                        this.max[1],
                        0
                    ]
                ]) : 0;
            }
            intersectsAabb(e1) {
                for(let t1 = 0; t1 < 3; ++t1)if (this.min[t1] > e1.max[t1] || e1.min[t1] > this.max[t1]) return !1;
                return !0;
            }
            intersectsAabbXY(e1) {
                return !(this.min[0] > e1.max[0] || e1.min[0] > this.max[0] || this.min[1] > e1.max[1] || e1.min[1] > this.max[1]);
            }
            encapsulate(e1) {
                for(let t1 = 0; t1 < 3; t1++)this.min[t1] = Math.min(this.min[t1], e1.min[t1]), this.max[t1] = Math.max(this.max[t1], e1.max[t1]);
            }
            encapsulatePoint(e1) {
                for(let t1 = 0; t1 < 3; t1++)this.min[t1] = Math.min(this.min[t1], e1[t1]), this.max[t1] = Math.max(this.max[t1], e1[t1]);
            }
            closestPoint(e1) {
                return [
                    Math.max(Math.min(this.max[0], e1[0]), this.min[0]),
                    Math.max(Math.min(this.max[1], e1[1]), this.min[1]),
                    Math.max(Math.min(this.max[2], e1[2]), this.min[2])
                ];
            }
        }
        Ya(Nf, "Aabb");
        const kf = Pc([
            {
                type: "Float32",
                name: "a_globe_pos",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            }
        ]), { members: Uf } = kf, jf = Pc([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            }
        ]);
        var Gf = Pc([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            }
        ]);
        function Hf(e1) {
            return e1 * Jl / rc;
        }
        const $f = [
            new Nf([
                ec,
                ec,
                ec
            ], [
                tc,
                tc,
                tc
            ]),
            new Nf([
                ec,
                ec,
                ec
            ], [
                0,
                0,
                tc
            ]),
            new Nf([
                0,
                ec,
                ec
            ], [
                tc,
                0,
                tc
            ]),
            new Nf([
                ec,
                0,
                ec
            ], [
                0,
                tc,
                tc
            ]),
            new Nf([
                0,
                0,
                ec
            ], [
                tc,
                tc,
                tc
            ])
        ];
        function Zf(e1, t1, i, n = !0) {
            const r = N([], e1._camera.position, e1.worldSize), o = [
                t1,
                i,
                1,
                1
            ];
            se(o, o, e1.pixelMatrixInverse), oe(o, o, 1 / o[3]);
            const a = $([], ee([], o, r)), s = e1.globeMatrix, l = [
                s[12],
                s[13],
                s[14]
            ], c = ee([], l, r), u = P(c), h = $([], c), d = e1.worldSize / (2 * Math.PI), f = Z(h, a), p = Math.asin(d / u);
            if (p < Math.acos(f)) {
                if (!n) return null;
                const e1 = [], t1 = [];
                N(e1, a, u / f), $(t1, ee(t1, e1, c)), $(a, C(a, c, N(a, t1, Math.tan(p) * u)));
            }
            const _ = [];
            new Pf(r, a).closestPointOnSphere(l, d, _);
            const m = $([], At(s, 0)), g = $([], At(s, 1)), y = $([], At(s, 2)), x = Z(m, _), v = Z(g, _), b = Z(y, _), w = Je(Math.asin(-v / d));
            let A = Je(Math.atan2(x, b));
            A = e1.center.lng + function(e1, t1) {
                const i = (t1 - e1 + 180) % 360 - 180;
                return i < -180 ? i + 360 : i;
            }(e1.center.lng, A);
            const E = ur(A), I = tt(hr(w), 0, 1);
            return new mc(E, I);
        }
        class Wf {
            constructor(e1, t1, i){
                this.a = ee([], e1, i), this.b = ee([], t1, i), this.center = i;
                const n = $([], this.a), r = $([], this.b);
                this.angle = Math.acos(Z(n, r));
            }
        }
        function qf(e1, t1) {
            if (0 === e1.angle) return null;
            let i;
            return i = 0 === e1.a[t1] ? 1 / e1.angle * .5 * Math.PI : 1 / e1.angle * Math.atan(e1.b[t1] / e1.a[t1] / Math.sin(e1.angle) - 1 / Math.tan(e1.angle)), i < 0 || i > 1 ? null : function(e1, t1, i, n) {
                const r = Math.sin(i);
                return e1 * (Math.sin((1 - n) * i) / r) + t1 * (Math.sin(n * i) / r);
            }(e1.a[t1], e1.b[t1], e1.angle, tt(i, 0, 1)) + e1.center[t1];
        }
        function Xf(e1) {
            if (e1.z <= 1) return $f[e1.z + 2 * e1.y + e1.x];
            const t1 = ep(Qf(e1));
            return Nf.fromPoints(t1);
        }
        function Yf(e1, t1, i) {
            return N(e1, e1, 1 - i), k(e1, e1, t1, i);
        }
        function Jf(e1, t1, i) {
            for (const n of e1)X(n, n, t1), N(n, n, i);
        }
        function Kf(e1, t1, i, n) {
            const r = t1 / e1.worldSize, o = e1.globeMatrix;
            if (i.z <= 1) {
                const e1 = Xf(i).getCorners();
                return Jf(e1, o, r), Nf.fromPoints(e1);
            }
            const a = Qf(i, n), s = ep(a, Jl + Hf(e1._tileCoverLift));
            Jf(s, o, r);
            const l = Number.MAX_VALUE, c = [
                -l,
                -l,
                -l
            ], u = [
                l,
                l,
                l
            ];
            if (a.contains(e1.center)) {
                for (const e1 of s)B(u, u, e1), V(c, c, e1);
                c[2] = 0;
                const t1 = e1.point, i = [
                    t1.x * r,
                    t1.y * r,
                    0
                ];
                return B(u, u, i), V(c, c, i), new Nf(u, c);
            }
            if (e1._tileCoverLift > 0) {
                for (const e1 of s)B(u, u, e1), V(c, c, e1);
                return new Nf(u, c);
            }
            const h = [
                o[12] * r,
                o[13] * r,
                o[14] * r
            ], d = a.getCenter(), f = tt(e1.center.lat, -85.051129, hc), p = tt(d.lat, -85.051129, hc), _ = ur(e1.center.lng), m = hr(f);
            let g = _ - ur(d.lng);
            const y = m - hr(p);
            g > .5 ? g -= 1 : g < -0.5 && (g += 1);
            let x = 0;
            Math.abs(g) > Math.abs(y) ? x = g >= 0 ? 1 : 3 : (x = y >= 0 ? 0 : 2, k(h, h, [
                o[4] * r,
                o[5] * r,
                o[6] * r
            ], -Math.sin(Ye(y >= 0 ? a.getSouth() : a.getNorth())) * Jl));
            const v = s[x], b = s[(x + 1) % 4], w = new Wf(v, b, h), A = [
                qf(w, 0) || v[0],
                qf(w, 1) || v[1],
                qf(w, 2) || v[2]
            ], E = cp(e1.zoom);
            if (E > 0) {
                const n = function({ x: e1, y: t1, z: i }, n, r, o, a) {
                    const s = 1 / (1 << i);
                    let l = e1 * s, c = l + s, u = t1 * s, h = u + s, d = 0;
                    const f = (l + c) / 2 - o;
                    return f > .5 ? d = -1 : f < -0.5 && (d = 1), l = ((l + d) * n - (o *= n)) * r + o, c = ((c + d) * n - o) * r + o, u = (u * n - (a *= n)) * r + a, h = (h * n - a) * r + a, [
                        [
                            l,
                            h,
                            0
                        ],
                        [
                            c,
                            h,
                            0
                        ],
                        [
                            c,
                            u,
                            0
                        ],
                        [
                            l,
                            u,
                            0
                        ]
                    ];
                }(i, t1, e1._pixelsPerMercatorPixel, _, m);
                for(let e1 = 0; e1 < s.length; e1++)Yf(s[e1], n[e1], E);
                const r = C([], n[x], n[(x + 1) % 4]);
                N(r, r, .5), Yf(A, r, E);
            }
            for (const e1 of s)B(u, u, e1), V(c, c, e1);
            return u[2] = Math.min(v[2], b[2]), B(u, u, A), V(c, c, A), new Nf(u, c);
        }
        function Qf({ x: e1, y: t1, z: i }, n = !1) {
            const r = 1 / (1 << i), o = new ac(dr(e1 * r), t1 === (1 << i) - 1 && n ? -90 : fr((t1 + 1) * r)), a = new ac(dr((e1 + 1) * r), 0 === t1 && n ? 90 : fr(t1 * r));
            return new sc(o, a);
        }
        function ep(e1, t1 = Jl) {
            const i = Ye(e1.getNorth()), n = Ye(e1.getSouth()), r = Math.cos(i), o = Math.cos(n), a = Math.sin(i), s = Math.sin(n), l = e1.getWest(), c = e1.getEast();
            return [
                ic(o, s, l, t1),
                ic(o, s, c, t1),
                ic(r, a, c, t1),
                ic(r, a, l, t1)
            ];
        }
        function tp(e1, t1, i, n) {
            const r = 1 << i.z, o = (e1 / Sr + i.x) / r;
            return nc(fr((t1 / Sr + i.y) / r), dr(o), n);
        }
        function ip({ min: e1, max: t1 }) {
            return 16383 / Math.max(t1[0] - e1[0], t1[1] - e1[1], t1[2] - e1[2]);
        }
        const np = new Float64Array(16);
        function rp(e1) {
            const t1 = ip(e1), i = w(np, [
                t1,
                t1,
                t1
            ]);
            return m(i, i, H([], e1.min));
        }
        function op(e1) {
            const t1 = 1 / ip(e1);
            return b(np, e1.min), g(np, np, [
                t1,
                t1,
                t1
            ]);
        }
        function ap(e1) {
            const t1 = Sr / (2 * Math.PI);
            return e1 / (2 * Math.PI) / t1;
        }
        function sp(e1, t1) {
            return Sr / (512 * Math.pow(2, e1)) * ip(Xf(t1));
        }
        function lp(e1, t1, i, n, r) {
            const o = ap(i), a = [
                e1,
                t1,
                -i / (2 * Math.PI)
            ], s = d(new Float64Array(16));
            return m(s, s, a), g(s, s, [
                o,
                o,
                o
            ]), y(s, s, Ye(-r)), x(s, s, Ye(-n)), s;
        }
        function cp(e1) {
            return it(5, 6, e1);
        }
        function up(e1) {
            const t1 = [
                0,
                0,
                0
            ], i = d(new Float64Array(16));
            return _(i, e1.pixelMatrix, e1.globeMatrix), X(t1, t1, i), new Re(t1[0], t1[1]);
        }
        function hp(e1) {
            const t1 = nc(e1._center.lat, e1._center.lng);
            let i = W([], D(0, 1, 0), t1);
            const n = A([], -e1.angle, t1);
            i = X(i, i, n), A(n, -e1._pitch, i);
            const r = $([], t1);
            return N(r, r, Hf(e1.cameraToCenterDistance / e1.pixelsPerMeter)), X(r, r, n), C([], t1, r);
        }
        function dp(e1, t1) {
            const i = nc(t1.lat, t1.lng);
            return function(e1, t1) {
                var i = e1[0], n = e1[1], r = e1[2], o = t1[0], a = t1[1], s = t1[2], l = Math.sqrt((i * i + n * n + r * r) * (o * o + a * a + s * s)), c = l && Z(e1, t1) / l;
                return Math.acos(Math.min(Math.max(c, -1), 1));
            }(O([], hp(e1), i), i);
        }
        function fp(e1, t1) {
            return dp(e1, t1) > Math.PI / 2 * 1.01;
        }
        const pp = Ye(85), _p = Math.cos(pp), mp = Math.sin(pp);
        class gp {
            constructor(e1, t1, i){
                this.z = e1, this.x = t1, this.y = i, this.key = vp(0, e1, e1, t1, i);
            }
            equals(e1) {
                return this.z === e1.z && this.x === e1.x && this.y === e1.y;
            }
            isChildOf(e1) {
                const t1 = this.z - e1.z;
                return 0 === e1.z || e1.z < this.z && e1.x === this.x >> t1 && e1.y === this.y >> t1;
            }
            url(e1, t1) {
                const i = function(e1, t1, i) {
                    const n = 2 ** i, r = 2 * Math.PI * 6378137, o = r * (e1 / n - .5), a = r * (.5 - (t1 + 1) / n);
                    return `${o},${a},${o + r / n},${a + r / n}`;
                }(this.x, this.y, this.z), n = function(e1, t1, i) {
                    let n, r = "";
                    for(let o = e1; o > 0; o--)n = 1 << o - 1, r += (t1 & n ? 1 : 0) + (i & n ? 2 : 0);
                    return r;
                }(this.z, this.x, this.y);
                return e1[(this.x + this.y) % e1.length].replace("{prefix}", (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === t1 ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace("{quadkey}", n).replace("{bbox-epsg-3857}", i);
            }
            toString() {
                return `${this.z}/${this.x}/${this.y}`;
            }
        }
        class yp {
            constructor(e1, t1){
                this.wrap = e1, this.canonical = t1, this.key = vp(e1, t1.z, t1.z, t1.x, t1.y);
            }
        }
        class xp {
            constructor(e1, t1, i, n, r){
                this.overscaledZ = e1, this.wrap = t1, this.canonical = new gp(i, +n, +r), this.key = 0 === t1 && e1 === i ? this.canonical.key : vp(t1, e1, i, n, r);
            }
            equals(e1) {
                return this.overscaledZ === e1.overscaledZ && this.wrap === e1.wrap && this.canonical.equals(e1.canonical);
            }
            scaledTo(e1) {
                const t1 = this.canonical.z - e1;
                return e1 > this.canonical.z ? new xp(e1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new xp(e1, this.wrap, e1, this.canonical.x >> t1, this.canonical.y >> t1);
            }
            calculateScaledKey(e1, t1 = !0) {
                if (this.overscaledZ === e1 && t1) return this.key;
                if (e1 > this.canonical.z) return vp(this.wrap * +t1, e1, this.canonical.z, this.canonical.x, this.canonical.y);
                {
                    const i = this.canonical.z - e1;
                    return vp(this.wrap * +t1, e1, e1, this.canonical.x >> i, this.canonical.y >> i);
                }
            }
            isChildOf(e1) {
                if (e1.wrap !== this.wrap) return !1;
                const t1 = this.canonical.z - e1.canonical.z;
                return 0 === e1.overscaledZ || e1.overscaledZ < this.overscaledZ && e1.canonical.z < this.canonical.z && e1.canonical.x === this.canonical.x >> t1 && e1.canonical.y === this.canonical.y >> t1;
            }
            children(e1) {
                if (this.overscaledZ >= e1) return [
                    new xp(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                ];
                const t1 = this.canonical.z + 1, i = 2 * this.canonical.x, n = 2 * this.canonical.y;
                return [
                    new xp(t1, this.wrap, t1, i, n),
                    new xp(t1, this.wrap, t1, i + 1, n),
                    new xp(t1, this.wrap, t1, i, n + 1),
                    new xp(t1, this.wrap, t1, i + 1, n + 1)
                ];
            }
            isLessThan(e1) {
                return this.wrap < e1.wrap || !(this.wrap > e1.wrap) && (this.overscaledZ < e1.overscaledZ || !(this.overscaledZ > e1.overscaledZ) && (this.canonical.x < e1.canonical.x || !(this.canonical.x > e1.canonical.x) && this.canonical.y < e1.canonical.y));
            }
            wrapped() {
                return new xp(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            unwrapTo(e1) {
                return new xp(this.overscaledZ, e1, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            overscaleFactor() {
                return Math.pow(2, this.overscaledZ - this.canonical.z);
            }
            toUnwrapped() {
                return new yp(this.wrap, this.canonical);
            }
            toString() {
                return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
            }
        }
        function vp(e1, t1, i, n, r) {
            const o = 1 << Math.min(i, 22);
            let a = o * (r % o) + n % o;
            return e1 && i < 22 && (a += o * o * ((e1 < 0 ? -2 * e1 - 1 : 2 * e1) % (1 << 2 * (22 - i)))), 16 * (32 * a + i) + (t1 - i);
        }
        const bp = [
            (e1)=>{
                let t1 = e1.canonical.x - 1, i = e1.wrap;
                return t1 < 0 && (t1 = (1 << e1.canonical.z) - 1, i--), new xp(e1.overscaledZ, i, e1.canonical.z, t1, e1.canonical.y);
            },
            (e1)=>{
                let t1 = e1.canonical.x + 1, i = e1.wrap;
                return t1 === 1 << e1.canonical.z && (t1 = 0, i++), new xp(e1.overscaledZ, i, e1.canonical.z, t1, e1.canonical.y);
            },
            (e1)=>new xp(e1.overscaledZ, e1.wrap, e1.canonical.z, e1.canonical.x, (0 === e1.canonical.y ? 1 << e1.canonical.z : e1.canonical.y) - 1),
            (e1)=>new xp(e1.overscaledZ, e1.wrap, e1.canonical.z, e1.canonical.x, e1.canonical.y === (1 << e1.canonical.z) - 1 ? 0 : e1.canonical.y + 1)
        ];
        function wp(e1, t1) {
            if (!t1.isReprojectedInTileSpace) return {
                scale: 1 << e1.z,
                x: e1.x,
                y: e1.y,
                x2: e1.x + 1,
                y2: e1.y + 1,
                projection: t1
            };
            const i = Math.pow(2, -e1.z), n = e1.x * i, r = (e1.x + 1) * i, o = e1.y * i, a = (e1.y + 1) * i, s = dr(n), l = dr(r), c = fr(o), u = fr(a), h = t1.project(s, c), d = t1.project(l, c), f = t1.project(l, u), p = t1.project(s, u);
            let _ = Math.min(h.x, d.x, f.x, p.x), m = Math.min(h.y, d.y, f.y, p.y), g = Math.max(h.x, d.x, f.x, p.x), y = Math.max(h.y, d.y, f.y, p.y);
            const x = i / 16;
            function v(e1, i, n, r, o, a) {
                const s = (n + o) / 2, l = (r + a) / 2, c = t1.project(dr(s), fr(l)), u = Math.max(0, _ - c.x, m - c.y, c.x - g, c.y - y);
                _ = Math.min(_, c.x), g = Math.max(g, c.x), m = Math.min(m, c.y), y = Math.max(y, c.y), u > x && (v(e1, c, n, r, s, l), v(c, i, s, l, o, a));
            }
            v(h, d, n, o, r, o), v(d, f, r, o, r, a), v(f, p, r, a, n, a), v(p, h, n, a, n, o), _ -= x, m -= x, g += x, y += x;
            const b = 1 / Math.max(g - _, y - m);
            return {
                scale: b,
                x: _ * b,
                y: m * b,
                x2: g * b,
                y2: y * b,
                projection: t1
            };
        }
        function Ap(e1, t1, i) {
            const { projection: n, scale: r } = e1;
            if (!n.isReprojectedInTileSpace) return 0;
            const { lng: o, lat: a } = n.unproject((t1 / Sr + e1.x) / r, (i / Sr + e1.y) / r), s = 1e-4, l = tt(a - s, -85.051129, hc), c = tt(a + s, -85.051129, hc);
            if (c === l) return 0;
            const u = n.project(o, l), h = n.project(o, c);
            return Je(Math.atan2(h.x - u.x, u.y - h.y));
        }
        function Ep(e1, t1, i, n, r, o, a, s, l) {
            if ("globe" === l.name) return Kf(e1, t1, new gp(i, n, r), !1);
            const c = wp({
                z: i,
                x: n,
                y: r
            }, l);
            return new Nf([
                (o + c.x / c.scale) * t1,
                t1 * (c.y / c.scale),
                a
            ], [
                (o + c.x2 / c.scale) * t1,
                t1 * (c.y2 / c.scale),
                s
            ]);
        }
        function Ip(e1, t1) {
            const i = e1.fovAboveCenter, n = e1.elevation ? e1.elevation.getMinElevationBelowMSL() * t1 : 0, r = Math.min(n, e1.isOrthographic ? -10 * t1 : 0), o = (e1._camera.position[2] * e1.worldSize - r) / Math.cos(e1._pitch), a = Math.sin(i) * o / Math.sin(Math.max(Math.PI / 2 - e1._pitch - i, .01));
            let s = Math.sin(e1._pitch) * a + o;
            const l = o * (1 / e1._horizonShift);
            if (!e1.elevation || 0 === e1.elevation.exaggeration()) {
                let t1 = Math.max(e1.zoom - 17, 0);
                e1.isOrthographic && (t1 /= 10), s *= 1 + t1;
            }
            return Math.min(1.01 * s, l);
        }
        Ya(gp, "CanonicalTileID"), Ya(xp, "OverscaledTileID", {
            omit: [
                "projMatrix",
                "expandedProjMatrix"
            ]
        });
        const Mp = d(new Float32Array(16));
        class Sp {
            constructor(e1){
                this.spec = e1, this.name = e1.name, this.wrap = !1, this.requiresDraping = !1, this.supportsWorldCopies = !1, this.supportsTerrain = !1, this.supportsFog = !1, this.supportsFreeCamera = !1, this.zAxisUnit = "meters", this.isReprojectedInTileSpace = !0, this.unsupportedLayers = [
                    "custom"
                ], this.center = [
                    0,
                    0
                ], this.range = [
                    3.5,
                    7
                ];
            }
            project(e1, t1) {
                return {
                    x: 0,
                    y: 0,
                    z: 0
                };
            }
            unproject(e1, t1) {
                return new ac(0, 0);
            }
            projectTilePoint(e1, t1, i) {
                return {
                    x: e1,
                    y: t1,
                    z: 0
                };
            }
            locationPoint(e1, t1, i, n = !0) {
                return e1._coordinatePoint(e1.locationCoordinate(t1, i), n);
            }
            globeCenterToScreenPoint(e1) {
                return null;
            }
            pixelsPerMeter(e1, t1) {
                return cc(1, e1) * t1;
            }
            pixelSpaceConversion(e1, t1, i) {
                return 1;
            }
            farthestPixelDistance(e1) {
                return Ip(e1, e1.pixelsPerMeter);
            }
            pointCoordinate(e1, t1, i, n) {
                const r = e1.horizonLineFromTop(!1), o = new Re(t1, Math.max(r, i));
                return e1.rayIntersectionCoordinate(e1.pointRayIntersection(o, n));
            }
            pointCoordinate3D(e1, t1, i) {
                const n = new Re(t1, i);
                if (e1.elevation) return e1.elevation.pointCoordinate(n);
                {
                    const t1 = this.pointCoordinate(e1, n.x, n.y, 0);
                    return [
                        t1.x,
                        t1.y,
                        t1.z
                    ];
                }
            }
            isPointAboveHorizon(e1, t1) {
                if (e1.elevation && e1.elevation.visibleDemTiles.length) return !this.pointCoordinate3D(e1, t1.x, t1.y);
                const i = e1.horizonLineFromTop();
                return t1.y < i;
            }
            createInversionMatrix(e1, t1) {
                return Mp;
            }
            createTileMatrix(e1, t1, i) {
                let n, r, o;
                const a = i.canonical, s = d(new Float64Array(16));
                if (this.isReprojectedInTileSpace) {
                    const l = wp(a, this);
                    n = 1, r = l.x + i.wrap * l.scale, o = l.y, g(s, s, [
                        n / l.scale,
                        n / l.scale,
                        e1.pixelsPerMeter / t1
                    ]);
                } else n = t1 / e1.zoomScale(a.z), r = (a.x + Math.pow(2, a.z) * i.wrap) * n, o = a.y * n;
                return m(s, s, [
                    r,
                    o,
                    0
                ]), g(s, s, [
                    n / Sr,
                    n / Sr,
                    1
                ]), s;
            }
            upVector(e1, t1, i) {
                return [
                    0,
                    0,
                    1
                ];
            }
            upVectorScale(e1, t1, i) {
                return {
                    metersToTile: 1
                };
            }
        }
        class Tp extends Sp {
            constructor(e1){
                super(e1), this.range = [
                    4,
                    7
                ], this.center = e1.center || [
                    -96,
                    37.5
                ];
                const [t1, i] = this.parallels = e1.parallels || [
                    29.5,
                    45.5
                ], n = Math.sin(Ye(t1));
                this.n = (n + Math.sin(Ye(i))) / 2, this.c = 1 + n * (2 * this.n - n), this.r0 = Math.sqrt(this.c) / this.n;
            }
            project(e1, t1) {
                const { n: i, c: n, r0: r } = this, o = Ye(e1 - this.center[0]), a = Ye(t1), s = Math.sqrt(n - 2 * i * Math.sin(a)) / i;
                return {
                    x: s * Math.sin(o * i),
                    y: s * Math.cos(o * i) - r,
                    z: 0
                };
            }
            unproject(e1, t1) {
                const { n: i, c: n, r0: r } = this, o = r + t1;
                let a = Math.atan2(e1, Math.abs(o)) * Math.sign(o);
                o * i < 0 && (a -= Math.PI * Math.sign(e1) * Math.sign(o));
                const s = Ye(this.center[0]) * i;
                a = nt(a, -Math.PI - s, Math.PI - s);
                const l = tt(Je(a / i) + this.center[0], -180, 180), c = Math.asin(tt((n - (e1 * e1 + o * o) * i * i) / (2 * i), -1, 1)), u = tt(Je(c), -85.051129, hc);
                return new ac(l, u);
            }
        }
        const zp = 1.340264, Rp = -0.081106, Pp = 893e-6, Dp = .003796, Fp = Math.sqrt(3) / 2;
        class Cp extends Sp {
            project(e1, t1) {
                t1 = t1 / 180 * Math.PI, e1 = e1 / 180 * Math.PI;
                const i = Math.asin(Fp * Math.sin(t1)), n = i * i, r = n * n * n;
                return {
                    x: .5 * (e1 * Math.cos(i) / (Fp * (zp + 3 * Rp * n + r * (7 * Pp + 9 * Dp * n))) / Math.PI + .5),
                    y: 1 - .5 * (i * (zp + Rp * n + r * (Pp + Dp * n)) / Math.PI + 1),
                    z: 0
                };
            }
            unproject(e1, t1) {
                e1 = (2 * e1 - .5) * Math.PI;
                let i = t1 = (2 * (1 - t1) - 1) * Math.PI, n = i * i, r = n * n * n;
                for(let e1, o, a, s = 0; s < 12 && (o = i * (zp + Rp * n + r * (Pp + Dp * n)) - t1, a = zp + 3 * Rp * n + r * (7 * Pp + 9 * Dp * n), e1 = o / a, i = tt(i - e1, -Math.PI / 3, Math.PI / 3), n = i * i, r = n * n * n, !(Math.abs(e1) < 1e-12)); ++s);
                const o = Fp * e1 * (zp + 3 * Rp * n + r * (7 * Pp + 9 * Dp * n)) / Math.cos(i), a = Math.asin(Math.sin(i) / Fp), s = tt(180 * o / Math.PI, -180, 180), l = tt(180 * a / Math.PI, -85.051129, hc);
                return new ac(s, l);
            }
        }
        class Op extends Sp {
            constructor(e1){
                super(e1), this.wrap = !0, this.supportsWorldCopies = !0;
            }
            project(e1, t1) {
                return {
                    x: .5 + e1 / 360,
                    y: .5 - t1 / 360,
                    z: 0
                };
            }
            unproject(e1, t1) {
                const i = 360 * (e1 - .5), n = tt(360 * (.5 - t1), -85.051129, hc);
                return new ac(i, n);
            }
        }
        const Lp = Math.PI / 2;
        function Bp(e1) {
            return Math.tan((Lp + e1) / 2);
        }
        class Vp extends Sp {
            constructor(e1){
                super(e1), this.center = e1.center || [
                    0,
                    30
                ];
                const [t1, i] = this.parallels = e1.parallels || [
                    30,
                    30
                ];
                let n = Ye(t1), r = Ye(i);
                this.southernCenter = n + r < 0, this.southernCenter && (n = -n, r = -r);
                const o = Math.cos(n), a = Bp(n);
                this.n = n === r ? Math.sin(n) : Math.log(o / Math.cos(r)) / Math.log(Bp(r) / a), this.f = o * Math.pow(Bp(n), this.n) / this.n;
            }
            project(e1, t1) {
                t1 = Ye(t1), this.southernCenter && (t1 = -t1), e1 = Ye(e1 - this.center[0]);
                const i = 1e-6, { n: n, f: r } = this;
                r > 0 ? t1 < -Lp + i && (t1 = -Lp + i) : t1 > Lp - i && (t1 = Lp - i);
                const o = r / Math.pow(Bp(t1), n);
                let a = o * Math.sin(n * e1), s = r - o * Math.cos(n * e1);
                return a = .5 * (a / Math.PI + .5), s = .5 * (s / Math.PI + .5), {
                    x: a,
                    y: this.southernCenter ? s : 1 - s,
                    z: 0
                };
            }
            unproject(e1, t1) {
                e1 = (2 * e1 - .5) * Math.PI, this.southernCenter && (t1 = 1 - t1), t1 = (2 * (1 - t1) - .5) * Math.PI;
                const { n: i, f: n } = this, r = n - t1, o = Math.sign(r), a = Math.sign(i) * Math.sqrt(e1 * e1 + r * r);
                let s = Math.atan2(e1, Math.abs(r)) * o;
                r * i < 0 && (s -= Math.PI * Math.sign(e1) * o);
                const l = tt(Je(s / i) + this.center[0], -180, 180), c = tt(Je(2 * Math.atan(Math.pow(n / a, 1 / i)) - Lp), -85.051129, hc);
                return new ac(l, this.southernCenter ? -c : c);
            }
        }
        class Np extends Sp {
            constructor(e1){
                super(e1), this.wrap = !0, this.supportsWorldCopies = !0, this.supportsTerrain = !0, this.supportsFog = !0, this.supportsFreeCamera = !0, this.isReprojectedInTileSpace = !1, this.unsupportedLayers = [], this.range = null;
            }
            project(e1, t1) {
                return {
                    x: ur(e1),
                    y: hr(t1),
                    z: 0
                };
            }
            unproject(e1, t1) {
                const i = dr(e1), n = fr(t1);
                return new ac(i, n);
            }
        }
        const kp = Ye(hc);
        class Up extends Sp {
            project(e1, t1) {
                const i = (t1 = Ye(t1)) * t1, n = i * i;
                return {
                    x: .5 * ((e1 = Ye(e1)) * (.8707 - .131979 * i + n * (n * (.003971 * i - .001529 * n) - .013791)) / Math.PI + .5),
                    y: 1 - .5 * (t1 * (1.007226 + i * (.015085 + n * (.028874 * i - .044475 - .005916 * n))) / Math.PI + 1),
                    z: 0
                };
            }
            unproject(e1, t1) {
                e1 = (2 * e1 - .5) * Math.PI;
                let i = t1 = (2 * (1 - t1) - 1) * Math.PI, n = 25, r = 0, o = i * i;
                do {
                    o = i * i;
                    const e1 = o * o;
                    r = (i * (1.007226 + o * (.015085 + e1 * (.028874 * o - .044475 - .005916 * e1))) - t1) / (1.007226 + o * (.045255 + e1 * (.259866 * o - .311325 - .005916 * 11 * e1))), i = tt(i - r, -kp, kp);
                }while (Math.abs(r) > 1e-6 && --n > 0);
                o = i * i;
                const a = tt(Je(e1 / (.8707 + o * (o * (o * o * o * (.003971 - .001529 * o) - .013791) - .131979))), -180, 180), s = Je(i);
                return new ac(a, s);
            }
        }
        const jp = Ye(hc);
        class Gp extends Sp {
            project(e1, t1) {
                t1 = Ye(t1), e1 = Ye(e1);
                const i = Math.cos(t1), n = 2 / Math.PI, r = Math.acos(i * Math.cos(e1 / 2)), o = Math.sin(r) / r, a = .5 * (e1 * n + 2 * i * Math.sin(e1 / 2) / o) || 0, s = .5 * (t1 + Math.sin(t1) / o) || 0;
                return {
                    x: .5 * (a / Math.PI + .5),
                    y: 1 - .5 * (s / Math.PI + 1),
                    z: 0
                };
            }
            unproject(e1, t1) {
                let i = e1 = (2 * e1 - .5) * Math.PI, n = t1 = (2 * (1 - t1) - 1) * Math.PI, r = 25;
                const o = 1e-6;
                let a = 0, s = 0;
                do {
                    const r = Math.cos(n), o = Math.sin(n), l = 2 * o * r, c = o * o, u = r * r, h = Math.cos(i / 2), d = Math.sin(i / 2), f = 2 * h * d, p = d * d, _ = 1 - u * h * h, m = _ ? 1 / _ : 0, g = _ ? Math.acos(r * h) * Math.sqrt(1 / _) : 0, y = .5 * (2 * g * r * d + 2 * i / Math.PI) - e1, x = .5 * (g * o + n) - t1, v = .5 * m * (u * p + g * r * h * c) + 1 / Math.PI, b = m * (f * l / 4 - g * o * d), w = .125 * m * (l * d - g * o * u * f), A = .5 * m * (c * h + g * p * r) + .5, E = b * w - A * v;
                    a = (x * b - y * A) / E, s = (y * w - x * v) / E, i = tt(i - a, -Math.PI, Math.PI), n = tt(n - s, -jp, jp);
                }while ((Math.abs(a) > o || Math.abs(s) > o) && --r > 0);
                return new ac(Je(i), Je(n));
            }
        }
        class Hp extends Sp {
            constructor(e1){
                super(e1), this.center = e1.center || [
                    0,
                    0
                ], this.parallels = e1.parallels || [
                    0,
                    0
                ], this.cosPhi = Math.max(.01, Math.cos(Ye(this.parallels[0]))), this.scale = 1 / (2 * Math.max(Math.PI * this.cosPhi, 1 / this.cosPhi)), this.wrap = !0, this.supportsWorldCopies = !0;
            }
            project(e1, t1) {
                const { scale: i, cosPhi: n } = this;
                return {
                    x: Ye(e1) * n * i + .5,
                    y: -Math.sin(Ye(t1)) / n * i + .5,
                    z: 0
                };
            }
            unproject(e1, t1) {
                const { scale: i, cosPhi: n } = this, r = -(t1 - .5) / i, o = tt(Je((e1 - .5) / i) / n, -180, 180), a = Math.asin(tt(r * n, -1, 1)), s = tt(Je(a), -85.051129, hc);
                return new ac(o, s);
            }
        }
        class $p extends Np {
            constructor(e1){
                super(e1), this.requiresDraping = !0, this.supportsWorldCopies = !1, this.supportsFog = !0, this.zAxisUnit = "pixels", this.unsupportedLayers = [
                    "debug"
                ], this.range = [
                    3,
                    5
                ];
            }
            projectTilePoint(e1, t1, i) {
                const n = tp(e1, t1, i);
                return X(n, n, rp(Xf(i))), {
                    x: n[0],
                    y: n[1],
                    z: n[2]
                };
            }
            locationPoint(e1, t1, i) {
                const n = nc(t1.lat, t1.lng), r = $([], n), o = i ? e1._centerAltitude + i : e1.elevation ? e1.elevation.getAtPointOrZero(e1.locationCoordinate(t1), e1._centerAltitude) : e1._centerAltitude;
                k(n, n, r, cc(1, 0) * Sr * o);
                const a = d(new Float64Array(16));
                return _(a, e1.pixelMatrix, e1.globeMatrix), X(n, n, a), new Re(n[0], n[1]);
            }
            globeCenterToScreenPoint(e1) {
                return up(e1);
            }
            pixelsPerMeter(e1, t1) {
                return cc(1, 0) * t1;
            }
            pixelSpaceConversion(e1, t1, i) {
                const n = cc(1, e1) * t1, r = hn(cc(1, 45) * t1, n, i);
                return this.pixelsPerMeter(e1, t1) / r;
            }
            createTileMatrix(e1, t1, i) {
                const n = op(Xf(i.canonical));
                return _(new Float64Array(16), e1.globeMatrix, n);
            }
            createInversionMatrix(e1, t1) {
                const { center: i } = e1, n = rp(Xf(t1));
                return x(n, n, Ye(i.lng)), y(n, n, Ye(i.lat)), g(n, n, [
                    e1._pixelsPerMercatorPixel,
                    e1._pixelsPerMercatorPixel,
                    1
                ]), Float32Array.from(n);
            }
            pointCoordinate(e1, t1, i, n) {
                return Zf(e1, t1, i, !0) || new mc(0, 0);
            }
            pointCoordinate3D(e1, t1, i) {
                const n = this.pointCoordinate(e1, t1, i, 0);
                return [
                    n.x,
                    n.y,
                    n.z
                ];
            }
            isPointAboveHorizon(e1, t1) {
                return !Zf(e1, t1.x, t1.y, !1);
            }
            farthestPixelDistance(e1) {
                const t1 = function(e1, t1) {
                    const i = e1.cameraToCenterDistance, n = e1._centerAltitude * t1, r = e1._camera, o = e1._camera.forward(), a = C([], N([], o, -i), [
                        0,
                        0,
                        n
                    ]), s = e1.worldSize / (2 * Math.PI), l = [
                        0,
                        0,
                        -s
                    ], c = e1.width / e1.height, u = Math.tan(e1.fovAboveCenter), h = N([], r.up(), u), d = N([], r.right(), u * c), f = $([], C([], C([], o, h), d)), p = [];
                    let _;
                    if (new Pf(a, f).closestPointOnSphere(l, s, p)) {
                        const t1 = C([], p, l), i = ee([], t1, a);
                        _ = Math.cos(e1.fovAboveCenter) * P(i);
                    } else {
                        const e1 = ee([], a, l), t1 = ee([], l, a);
                        $(t1, t1);
                        const i = P(e1) - s;
                        _ = Math.sqrt(i * (i + 2 * s));
                        const n = Math.acos(_ / (s + i)) - Math.acos(Z(o, t1));
                        _ *= Math.cos(n);
                    }
                    return 1.01 * _;
                }(e1, this.pixelsPerMeter(e1.center.lat, e1.worldSize)), i = cp(e1.zoom);
                if (i > 0) {
                    const n = Ip(e1, cc(1, e1.center.lat) * e1.worldSize), r = e1.worldSize / (2 * Math.PI), o = Math.max(e1.width, e1.height) / e1.worldSize * Math.PI;
                    return hn(t1, n + r * (1 - Math.cos(o)), Math.pow(i, 10));
                }
                return t1;
            }
            upVector(e1, t1, i) {
                return tp(t1, i, e1, 1);
            }
            upVectorScale(e1) {
                return {
                    metersToTile: Hf(ip(Xf(e1)))
                };
            }
        }
        function Zp(e1) {
            const t1 = e1.parallels, i = !!t1 && Math.abs(t1[0] + t1[1]) < .01;
            switch(e1.name){
                case "mercator":
                    return new Np(e1);
                case "equirectangular":
                    return new Op(e1);
                case "naturalEarth":
                    return new Up(e1);
                case "equalEarth":
                    return new Cp(e1);
                case "winkelTripel":
                    return new Gp(e1);
                case "albers":
                    return i ? new Hp(e1) : new Tp(e1);
                case "lambertConformalConic":
                    return i ? new Hp(e1) : new Vp(e1);
                case "globe":
                    return new $p(e1);
            }
            throw new Error(`Invalid projection name: ${e1.name}`);
        }
        const Wp = Number.MAX_SAFE_INTEGER, qp = Wp - 1;
        function Xp(e1, t1, i, n) {
            return e1.order < t1 || e1.order === Wp || !(e1.clipMask & i) || function(e1, t1) {
                if (0 === t1.length) return !1;
                let i = e1;
                for(; "" !== i;){
                    if (t1.includes(i)) return !1;
                    i = hl(i);
                }
                return !0;
            }(n, e1.clipScope);
        }
        function Yp(e1, t1) {
            return e1.x - t1.x || e1.y - t1.y;
        }
        function Jp(e1, t1) {
            return 0 === Yp(e1.min, t1.min) && 0 === Yp(e1.max, t1.max);
        }
        function Kp(e1, t1) {
            return !(e1.min.x > t1.max.x || e1.max.x < t1.min.x || e1.min.y > t1.max.y || e1.max.y < t1.min.y);
        }
        function Qp(e1, t1) {
            if (e1.length !== t1.length) return !1;
            for(let i = 0; i < e1.length; i++)if (e1[i].sourceId !== t1[i].sourceId || !Jp(e1[i], t1[i]) || e1[i].order !== t1[i].order || e1[i].clipMask !== t1[i].clipMask || !Pe(e1[i].clipScope, t1[i].clipScope)) return !1;
            return !0;
        }
        function e_(e1, t1, i) {
            const n = 1 / Sr, r = 1 / (1 << i.canonical.z), o = (t1.x * n + i.canonical.x) * r + i.wrap, a = (t1.y * n + i.canonical.y) * r;
            return {
                min: new Re((e1.x * n + i.canonical.x) * r + i.wrap, (e1.y * n + i.canonical.y) * r),
                max: new Re(o, a)
            };
        }
        function t_(e1, t1, i) {
            const n = 1 << i.canonical.z, r = ((t1.x - i.wrap) * n - i.canonical.x) * Sr, o = (t1.y * n - i.canonical.y) * Sr;
            return {
                min: new Re(((e1.x - i.wrap) * n - i.canonical.x) * Sr, (e1.y * n - i.canonical.y) * Sr),
                max: new Re(r, o)
            };
        }
        const i_ = new Re(0, 0), n_ = new Re(0, 0), r_ = new Re(0, 0), o_ = [
            i_,
            n_,
            r_
        ];
        function a_(e1, t1) {
            const { vertices: i, indices: n } = e1, r = 2 * n[3 * t1], o = 2 * n[3 * t1 + 1], a = 2 * n[3 * t1 + 2];
            i_.x = i[r], i_.y = i[r + 1], n_.x = i[o], n_.y = i[o + 1], r_.x = i[a], r_.y = i[a + 1];
        }
        function s_(e1, t1, i, n, r, o, a) {
            const s = [];
            for(let l = n; l < n + r; l += 3){
                const n = t1[i[l + 0] + o], r = t1[i[l + 1] + o], c = t1[i[l + 2] + o], u = Math.min(n.x, r.x, c.x), h = Math.max(n.x, r.x, c.x), d = Math.min(n.y, r.y, c.y), f = Math.max(n.y, r.y, c.y);
                s.length = 0, e1.grid.query(new Re(u, d), new Re(h, f), s);
                for(let t1 = 0; t1 < s.length; t1++)if (a_(e1, s[t1]), fd(i_, n_, r_, n, r, c, a)) return !0;
            }
            return !1;
        }
        function l_(e1, t1, i, n) {
            if (!e1 || !i) return !1;
            const r = t1.canonical.equals(n.canonical) && t1.wrap === n.wrap;
            if (!r && i.vertices.length < e1.vertices.length) return l_(i, n, e1, t1);
            const o = t1.canonical, a = n.canonical, s = Math.pow(2, a.z - o.z), l = [];
            for(let t1 = 0; t1 < e1.vertices.length; t1 += 2){
                const i = e1.vertices[t1], n = e1.vertices[t1 + 1];
                l.push(r ? new Re(i, n) : new Re((i + o.x * Sr) * s - a.x * Sr, (n + o.y * Sr) * s - a.y * Sr));
            }
            return s_(i, l, e1.indices, 0, e1.indices.length, 0, 0);
        }
        function c_(e1, t1, i, n) {
            const r = Math.pow(2, n.z - i.z);
            return new Re((e1 + i.x * Sr) * r - n.x * Sr, (t1 + i.y * Sr) * r - n.y * Sr);
        }
        function u_(e1, t1) {
            const i = [];
            t1.grid.queryPoint(e1, i);
            for(let n = 0; n < i.length; n++)if (a_(t1, i[n]), cd(o_, e1)) return !0;
            return !1;
        }
        const h_ = {
            None: 0,
            Model: 1,
            Symbol: 2,
            FillExtrusion: 4
        };
        function d_(e1, t1, i) {
            const n = t1[0], r = t1[1];
            return e1[0] = i[0] * n + i[4] * r + i[12], e1[1] = i[1] * n + i[5] * r + i[13], e1[3] = i[3] * n + i[7] * r + i[15], e1;
        }
        class f_ {
            isDataAvailableAtPoint(e1) {
                const t1 = this._source();
                if (this.isUsingMockSource() || !t1 || e1.y < 0 || e1.y > 1) return !1;
                const i = t1.getSource().maxzoom, n = 1 << i, r = Math.floor(e1.x), o = Math.floor((e1.x - r) * n), a = Math.floor(e1.y * n), s = this.findDEMTileFor(new xp(i, r, i, o, a));
                return !(!s || !s.dem);
            }
            getAtPointOrZero(e1, t1 = 0) {
                return this.getAtPoint(e1, t1) || 0;
            }
            getAtPoint(e1, t1, i = !0) {
                if (this.isUsingMockSource()) return null;
                t1 ??= null;
                const n = this._source();
                if (!n) return t1;
                if (e1.y < 0 || e1.y > 1) return t1;
                const r = n.getSource().maxzoom, o = 1 << r, a = Math.floor(e1.x), s = e1.x - a, l = new xp(r, a, r, Math.floor(s * o), Math.floor(e1.y * o)), c = this.findDEMTileFor(l);
                if (!c || !c.dem) return t1;
                const u = c.dem, h = 1 << c.tileID.canonical.z, d = (s * h - c.tileID.canonical.x) * u.dim, f = (e1.y * h - c.tileID.canonical.y) * u.dim, p = Math.floor(d), _ = Math.floor(f);
                return (i ? this.exaggeration() : 1) * hn(hn(u.get(p, _), u.get(p, _ + 1), f - _), hn(u.get(p + 1, _), u.get(p + 1, _ + 1), f - _), d - p);
            }
            static getAtTileOffset(e1, t1, i, n) {
                const r = 1 << e1.canonical.z;
                return n ? n.pointElevation(t1) : i ? i.getAtPointOrZero(new mc(e1.wrap + (e1.canonical.x + t1.x / Sr) / r, (e1.canonical.y + t1.y / Sr) / r)) : 0;
            }
            static getAtTileOffsetFunc(e1, t1, i, n) {
                return (r, o, a)=>{
                    const s = this.getAtTileOffset(e1, r, o, a), l = n.upVector(e1.canonical, r.x, r.y);
                    return N(l, l, s * n.upVectorScale(e1.canonical, t1, i).metersToTile), l;
                };
            }
            getForTilePoints(e1, t1, i, n) {
                if (this.isUsingMockSource()) return !1;
                const r = p_.create(this, e1, n);
                return !!r && (t1.forEach((e1)=>{
                    e1[2] = this.exaggeration() * r.getElevationAt(e1[0], e1[1], i, !0);
                }), !0);
            }
            getMinMaxForTile(e1) {
                if (this.isUsingMockSource()) return null;
                const t1 = this.findDEMTileFor(e1);
                if (!t1 || !t1.dem) return null;
                const i = t1.dem.tree, n = t1.tileID, r = 1 << e1.canonical.z - n.canonical.z;
                let o = e1.canonical.x / r - n.canonical.x, a = e1.canonical.y / r - n.canonical.y, s = 0;
                for(let t1 = 0; t1 < e1.canonical.z - n.canonical.z && !i.leaves[s]; t1++){
                    o *= 2, a *= 2;
                    const e1 = 2 * Math.floor(a) + Math.floor(o);
                    s = i.childOffsets[s] + e1, o %= 1, a %= 1;
                }
                return {
                    min: this.exaggeration() * i.minimums[s],
                    max: this.exaggeration() * i.maximums[s]
                };
            }
            getMinElevationBelowMSL() {
                throw new Error("Pure virtual method called.");
            }
            raycast(e1, t1, i) {
                throw new Error("Pure virtual method called.");
            }
            pointCoordinate(e1) {
                throw new Error("Pure virtual method called.");
            }
            _source() {
                throw new Error("Pure virtual method called.");
            }
            isUsingMockSource() {
                throw new Error("Pure virtual method called.");
            }
            exaggeration() {
                throw new Error("Pure virtual method called.");
            }
            findDEMTileFor(e1) {
                throw new Error("Pure virtual method called.");
            }
            get visibleDemTiles() {
                throw new Error("Getter must be implemented in subclass.");
            }
            getMinMaxForVisibleTiles() {
                const e1 = this.visibleDemTiles;
                if (0 === e1.length) return null;
                let t1 = !1, i = Number.MAX_VALUE, n = Number.MIN_VALUE;
                for (const r of e1){
                    const e1 = this.getMinMaxForTile(r.tileID);
                    e1 && (i = Math.min(i, e1.min), n = Math.max(n, e1.max), t1 = !0);
                }
                return t1 ? {
                    min: i,
                    max: n
                } : null;
            }
        }
        class p_ {
            constructor(e1, t1, i){
                this._demTile = e1, this._dem = this._demTile.dem, this._scale = t1, this._offset = i;
            }
            static create(e1, t1, i) {
                const n = i || e1.findDEMTileFor(t1);
                if (!n || !n.dem) return;
                const r = n.dem, o = n.tileID, a = 1 << t1.canonical.z - o.canonical.z;
                return new p_(n, r.dim / Sr / a, [
                    (t1.canonical.x / a - o.canonical.x) * r.dim,
                    (t1.canonical.y / a - o.canonical.y) * r.dim
                ]);
            }
            tileCoordToPixel(e1, t1) {
                const i = t1 * this._scale + this._offset[1];
                return new Re(Math.floor(e1 * this._scale + this._offset[0]), Math.floor(i));
            }
            getElevationAt(e1, t1, i, n) {
                const r = e1 * this._scale + this._offset[0], o = t1 * this._scale + this._offset[1], a = Math.floor(r), s = Math.floor(o), l = this._dem;
                return n = !!n, i ? hn(hn(l.get(a, s, n), l.get(a, s + 1, n), o - s), hn(l.get(a + 1, s, n), l.get(a + 1, s + 1, n), o - s), r - a) : l.get(a, s, n);
            }
            getElevationAtPixel(e1, t1, i) {
                return this._dem.get(e1, t1, !!i);
            }
            getMeterToDEM(e1) {
                return (1 << this._demTile.tileID.canonical.z) * cc(1, e1) * this._dem.stride;
            }
        }
        const __ = .05;
        function m_(e1, t1, i) {
            const n = it(45, 65, i), [r, o] = e1.range;
            let a = 1 - Math.min(1, Math.exp((t1 - r) / (o - r) * -6));
            return a *= a * a, a = Math.min(1, 1.00747 * a), a * n * e1.alpha;
        }
        function g_(e1, t1, i, n, r, o) {
            const a = [
                t1,
                i,
                n
            ];
            return X(a, a, o.calculateFogTileMatrix(r)), m_(e1, P(a), o.pitch);
        }
        function y_(e1, t1, i, n, r) {
            return m_(e1, P(X([], [
                t1,
                i,
                n
            ], r.mercatorFogMatrix)), r.pitch);
        }
        function x_(e1, t1, i) {
            const n = t1.createTileMatrix(e1, e1.worldSize, i.toUnwrapped());
            return _(new Float32Array(16), e1.projMatrix, n);
        }
        function v_(e1, t1, i, n) {
            return t1.name === n ? i.calculateProjMatrix(e1.toUnwrapped()) : x_(i, t1, e1);
        }
        const b_ = {
            SYMBOL_INVISIBLE: 0,
            VARIANT_VISIBLE: 2
        };
        function w_(e1, t1) {
            return {
                collisionRules: e1 ? void 0 : {},
                insertIntoCollisionGrid: !t1
            };
        }
        function A_(e1) {
            return 3 * e1;
        }
        const E_ = 4294967296, I_ = 1 / E_, M_ = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf-8");
        class S_ {
            constructor(e1){
                this.buf = ArrayBuffer.isView(e1) ? e1 : new Uint8Array(e1), this.dataView = new DataView(this.buf.buffer, this.buf.byteOffset, this.buf.byteLength), this.pos = 0, this.type = 0, this._valueStart = -1, this.length = this.buf.length;
            }
            readFields(e1, t1, i = this.length) {
                let n;
                for(; n = this.nextField(i);)e1(n, t1, this);
                return t1;
            }
            readMessage(e1, t1) {
                return this.readFields(e1, t1, this.readVarint() + this.pos);
            }
            readFixed32() {
                const e1 = this.dataView.getUint32(this.pos, !0);
                return this.pos += 4, e1;
            }
            readSFixed32() {
                const e1 = this.dataView.getInt32(this.pos, !0);
                return this.pos += 4, e1;
            }
            readFixed64() {
                const e1 = this.dataView.getUint32(this.pos, !0) + this.dataView.getUint32(this.pos + 4, !0) * E_;
                return this.pos += 8, e1;
            }
            readSFixed64() {
                const e1 = this.dataView.getUint32(this.pos, !0) + this.dataView.getInt32(this.pos + 4, !0) * E_;
                return this.pos += 8, e1;
            }
            readFloat() {
                const e1 = this.dataView.getFloat32(this.pos, !0);
                return this.pos += 4, e1;
            }
            readDouble() {
                const e1 = this.dataView.getFloat64(this.pos, !0);
                return this.pos += 8, e1;
            }
            readVarint(e1) {
                const t1 = this.buf, i = t1[this.pos++];
                if (i < 128) return i;
                let n, r = 127 & i;
                return n = t1[this.pos++], r |= (127 & n) << 7, n < 128 ? r : (n = t1[this.pos++], r |= (127 & n) << 14, n < 128 ? r : (n = t1[this.pos++], r |= (127 & n) << 21, n < 128 ? r : (n = t1[this.pos], r |= (15 & n) << 28, function(e1, t1, i) {
                    const n = i.buf;
                    let r, o;
                    if (o = n[i.pos++], r = (112 & o) >> 4, o < 128) return T_(e1, r, t1);
                    if (o = n[i.pos++], r |= (127 & o) << 3, o < 128) return T_(e1, r, t1);
                    if (o = n[i.pos++], r |= (127 & o) << 10, o < 128) return T_(e1, r, t1);
                    if (o = n[i.pos++], r |= (127 & o) << 17, o < 128) return T_(e1, r, t1);
                    if (o = n[i.pos++], r |= (127 & o) << 24, o < 128) return T_(e1, r, t1);
                    if (o = n[i.pos++], r |= (1 & o) << 31, o < 128) return T_(e1, r, t1);
                    throw new Error("Expected varint not more than 10 bytes");
                }(r, e1, this))));
            }
            readSVarint() {
                const e1 = this.readVarint();
                return e1 % 2 == 1 ? (e1 + 1) / -2 : e1 / 2;
            }
            readBoolean() {
                return Boolean(this.readVarint());
            }
            readString() {
                const e1 = this.readVarint() + this.pos, t1 = this.pos;
                return this.pos = e1, e1 - t1 >= 12 && M_ ? M_.decode(this.buf.subarray(t1, e1)) : function(e1, t1, i) {
                    let n = "", r = t1;
                    for(; r < i;){
                        const t1 = e1[r];
                        let o, a, s, l = null, c = t1 > 239 ? 4 : t1 > 223 ? 3 : t1 > 191 ? 2 : 1;
                        if (r + c > i) break;
                        1 === c ? t1 < 128 && (l = t1) : 2 === c ? (o = e1[r + 1], 128 == (192 & o) && (l = (31 & t1) << 6 | 63 & o, l <= 127 && (l = null))) : 3 === c ? (o = e1[r + 1], a = e1[r + 2], 128 == (192 & o) && 128 == (192 & a) && (l = (15 & t1) << 12 | (63 & o) << 6 | 63 & a, (l <= 2047 || l >= 55296 && l <= 57343) && (l = null))) : 4 === c && (o = e1[r + 1], a = e1[r + 2], s = e1[r + 3], 128 == (192 & o) && 128 == (192 & a) && 128 == (192 & s) && (l = (15 & t1) << 18 | (63 & o) << 12 | (63 & a) << 6 | 63 & s, (l <= 65535 || l >= 1114112) && (l = null))), null === l ? (l = 65533, c = 1) : l > 65535 && (l -= 65536, n += String.fromCharCode(l >>> 10 & 1023 | 55296), l = 56320 | 1023 & l), n += String.fromCharCode(l), r += c;
                    }
                    return n;
                }(this.buf, t1, e1);
            }
            readBytes() {
                const e1 = this.readVarint() + this.pos, t1 = this.buf.subarray(this.pos, e1);
                return this.pos = e1, t1;
            }
            readPackedVarint(e1 = [], t1) {
                const i = this.readPackedEnd();
                for(; this.pos < i;)e1.push(this.readVarint(t1));
                return e1;
            }
            readPackedSVarint(e1 = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e1.push(this.readSVarint());
                return e1;
            }
            readPackedBoolean(e1 = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e1.push(this.readBoolean());
                return e1;
            }
            readPackedFloat(e1 = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e1.push(this.readFloat());
                return e1;
            }
            readPackedDouble(e1 = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e1.push(this.readDouble());
                return e1;
            }
            readPackedFixed32(e1 = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e1.push(this.readFixed32());
                return e1;
            }
            readPackedSFixed32(e1 = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e1.push(this.readSFixed32());
                return e1;
            }
            readPackedFixed64(e1 = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e1.push(this.readFixed64());
                return e1;
            }
            readPackedSFixed64(e1 = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e1.push(this.readSFixed64());
                return e1;
            }
            readPackedEnd() {
                return 2 === this.type ? this.readVarint() + this.pos : this.pos + 1;
            }
            nextField(e1 = this.length) {
                if (this.pos === this._valueStart && this.skip(this.type), this.pos >= e1) return 0;
                const t1 = this.readVarint();
                return this.type = 7 & t1, this._valueStart = this.pos, t1 >>> 3;
            }
            skip(e1) {
                const t1 = 7 & e1;
                if (0 === t1) for(; this.buf[this.pos++] > 127;);
                else if (2 === t1) this.pos = this.readVarint() + this.pos;
                else if (5 === t1) this.pos += 4;
                else {
                    if (1 !== t1) throw new Error(`Unimplemented type: ${t1}`);
                    this.pos += 8;
                }
            }
        }
        function T_(e1, t1, i) {
            return i ? 4294967296 * t1 + (e1 >>> 0) : 4294967296 * (t1 >>> 0) + (e1 >>> 0);
        }
        function z_(e1, t1, i) {
            const n = t1 <= 16383 ? 1 : t1 <= 2097151 ? 2 : t1 <= 268435455 ? 3 : Math.floor(Math.log(t1) / (7 * Math.LN2));
            i.realloc(n), i.buf.copyWithin(e1 + n, e1, i.pos);
        }
        function R_(e1, t1) {
            const i = e1.length;
            let n = t1.buf, r = t1.pos, o = t1.length;
            for(let a = 0; a < i; a++){
                let i = e1[a];
                if (i < 0 || r + 10 > o) t1.pos = r, t1.writeVarint(i), n = t1.buf, r = t1.pos, o = t1.length;
                else {
                    for(; i > 127;)n[r++] = i % 128 | 128, i = Math.floor(i / 128);
                    n[r++] = i;
                }
            }
            t1.pos = r;
        }
        function P_(e1, t1) {
            for(let i = 0; i < e1.length; i++)t1.writeSVarint(e1[i]);
        }
        function D_(e1, t1) {
            for(let i = 0; i < e1.length; i++)t1.writeFloat(e1[i]);
        }
        function F_(e1, t1) {
            for(let i = 0; i < e1.length; i++)t1.writeDouble(e1[i]);
        }
        function C_(e1, t1) {
            for(let i = 0; i < e1.length; i++)t1.writeBoolean(e1[i]);
        }
        function O_(e1, t1) {
            for(let i = 0; i < e1.length; i++)t1.writeFixed32(e1[i]);
        }
        function L_(e1, t1) {
            for(let i = 0; i < e1.length; i++)t1.writeSFixed32(e1[i]);
        }
        function B_(e1, t1) {
            for(let i = 0; i < e1.length; i++)t1.writeFixed64(e1[i]);
        }
        function V_(e1, t1) {
            for(let i = 0; i < e1.length; i++)t1.writeSFixed64(e1[i]);
        }
        function N_(e1, t1, i) {
            let n;
            for(; n = e1.nextField(t1);)3 === n ? i.glyphs.push(k_(e1, e1.readVarint() + e1.pos)) : 4 === n ? i.ascender = e1.readSVarint() : 5 === n && (i.descender = e1.readSVarint());
        }
        function k_(e1, t1) {
            let i, n, r = 0, o = 0, a = 0, s = 0, l = 0, c = 0;
            for(; n = e1.nextField(t1);)1 === n ? r = e1.readVarint() : 2 === n ? i = e1.readBytes() : 3 === n ? o = e1.readVarint() : 4 === n ? a = e1.readVarint() : 5 === n ? s = e1.readSVarint() : 6 === n ? l = e1.readSVarint() : 7 === n && (c = e1.readVarint());
            return {
                id: r,
                bitmap: new Ed({
                    width: o + 6,
                    height: a + 6
                }, i),
                metrics: {
                    width: o,
                    height: a,
                    left: s,
                    top: l,
                    advance: c
                }
            };
        }
        function U_(e1) {
            let t1 = 0, i = 0;
            for (const n of e1)t1 += n.w * n.h, i = Math.max(i, n.w);
            e1.sort((e1, t1)=>t1.h - e1.h);
            const n = [
                {
                    x: 0,
                    y: 0,
                    w: Math.max(Math.ceil(Math.sqrt(t1 / .95)), i),
                    h: 1 / 0
                }
            ];
            let r = 0, o = 0;
            for (const t1 of e1)for(let e1 = n.length - 1; e1 >= 0; e1--){
                const i = n[e1];
                if (!(t1.w > i.w || t1.h > i.h)) {
                    if (t1.x = i.x, t1.y = i.y, o = Math.max(o, t1.y + t1.h), r = Math.max(r, t1.x + t1.w), t1.w === i.w && t1.h === i.h) {
                        const t1 = n.pop();
                        t1 && e1 < n.length && (n[e1] = t1);
                    } else t1.h === i.h ? (i.x += t1.w, i.w -= t1.w) : t1.w === i.w ? (i.y += t1.h, i.h -= t1.h) : (n.push({
                        x: i.x + t1.w,
                        y: i.y,
                        w: i.w - t1.w,
                        h: t1.h
                    }), i.y += t1.h, i.h -= t1.h);
                    break;
                }
            }
            return {
                w: r,
                h: o,
                fill: t1 / (r * o) || 0
            };
        }
        function j_(e1, t1) {
            return e1.id < t1.id ? -1 : e1.id > t1.id ? 1 : e1.version < t1.version ? -1 : e1.version > t1.version ? 1 : e1.sx < t1.sx ? -1 : e1.sx > t1.sx ? 1 : e1.sy < t1.sy ? -1 : e1.sy > t1.sy ? 1 : 0;
        }
        function G_(e1) {
            let t1 = 0;
            for(let i = 0; i < e1.length; i++)t1 = (t1 << 5) - t1 + e1.charCodeAt(i), t1 &= t1;
            return t1;
        }
        function H_(e1, t1) {
            return (e1 << 5) - e1 + t1;
        }
        function $_(e1, t1, i, n) {
            for (const [r] of e1.entries()){
                const e1 = n && n.get(r) || kn.parse(r), o = e1.id.toString(), a = t1.get(o) || 0;
                i.push({
                    id: r,
                    version: a,
                    sx: e1.sx,
                    sy: e1.sy
                });
            }
        }
        class Z_ {
            constructor(e1, t1, i, n, r = "", o){
                this.scope = r, this.iconDescriptors = [], this.patternDescriptors = [], this.requiresMipMaps = t1.size > 0, $_(e1, i, this.iconDescriptors, o), $_(t1, i, this.patternDescriptors, o), this.iconDescriptors.sort(j_), this.patternDescriptors.sort(j_);
                let a = 0;
                a = H_(a, G_(r)), a = H_(a, 1);
                const s = n ? n.data : "";
                s && (a = H_(a, G_(s))), a = H_(a, 1);
                for (const e1 of this.iconDescriptors)a = H_(a, G_(e1.id)), a = H_(a, e1.version), a = H_(a, e1.sx), a = H_(a, e1.sy);
                a = H_(a, 1);
                for (const e1 of this.patternDescriptors)a = H_(a, G_(e1.id)), a = H_(a, e1.version), a = H_(a, e1.sx), a = H_(a, e1.sy);
                this.hash = a;
            }
            subsetOf(e1) {
                return this.scope === e1.scope && this.isSubsetArray(this.iconDescriptors, e1.iconDescriptors, j_) && this.isSubsetArray(this.patternDescriptors, e1.patternDescriptors, j_);
            }
            isSubsetArray(e1, t1, i) {
                let n = 0, r = 0;
                if (e1.length > t1.length) return !1;
                for(; n < e1.length && r < t1.length;){
                    const o = i(e1[n], t1[r]);
                    if (0 === o) n++, r++;
                    else {
                        if (o < 0) return !1;
                        r++;
                    }
                }
                return n === e1.length;
            }
        }
        function W_(e1) {
            switch(e1){
                case WebGL2RenderingContext.RGBA8:
                case WebGL2RenderingContext.RGBA16F:
                    return WebGL2RenderingContext.RGBA;
                case WebGL2RenderingContext.DEPTH_COMPONENT16:
                    return WebGL2RenderingContext.DEPTH_COMPONENT;
                case WebGL2RenderingContext.DEPTH24_STENCIL8:
                    return WebGL2RenderingContext.DEPTH_STENCIL;
                case WebGL2RenderingContext.R8:
                case WebGL2RenderingContext.R32F:
                    return WebGL2RenderingContext.RED;
            }
        }
        function q_(e1) {
            switch(e1){
                case WebGL2RenderingContext.RGBA8:
                    return WebGL2RenderingContext.UNSIGNED_BYTE;
                case WebGL2RenderingContext.RGBA16F:
                    return WebGL2RenderingContext.HALF_FLOAT;
                case WebGL2RenderingContext.DEPTH_COMPONENT16:
                    return WebGL2RenderingContext.UNSIGNED_SHORT;
                case WebGL2RenderingContext.DEPTH24_STENCIL8:
                    return WebGL2RenderingContext.UNSIGNED_INT_24_8;
                case WebGL2RenderingContext.R8:
                    return WebGL2RenderingContext.UNSIGNED_BYTE;
                case WebGL2RenderingContext.R32F:
                    return WebGL2RenderingContext.FLOAT;
            }
        }
        Ya(Z_, "AtlasContentDescriptor");
        class X_ {
            constructor(e1, t1, i, n){
                this.context = e1, this.format = i, this.useMipmap = n && n.useMipmap, this.texture = e1.gl.createTexture(), this.update(t1, {
                    premultiply: n && n.premultiply
                });
            }
            update(e1, t1) {
                const i = e1 && e1 instanceof HTMLVideoElement && 0 === e1.width ? e1.videoWidth : e1.width, n = e1 && e1 instanceof HTMLVideoElement && 0 === e1.height ? e1.videoHeight : e1.height, { context: r } = this, { gl: o } = r, { x: a, y: s } = t1 && t1.position ? t1.position : {
                    x: 0,
                    y: 0
                }, l = a + i, c = s + n;
                this.size && (this.size[0] !== l || this.size[1] !== c) && (!t1 || void 0 === t1.recreateWhenResize || t1.recreateWhenResize) && (o.bindTexture(o.TEXTURE_2D, null), o.deleteTexture(this.texture), this.texture = o.createTexture(), this.size = null), o.bindTexture(o.TEXTURE_2D, this.texture), r.pixelStoreUnpackFlipY.set(!1), r.pixelStoreUnpack.set(1), r.pixelStoreUnpackPremultiplyAlpha.set(this.format === o.RGBA8 && (!t1 || !1 !== t1.premultiply));
                const u = e1 instanceof HTMLImageElement || e1 instanceof HTMLCanvasElement || e1 instanceof HTMLVideoElement || e1 instanceof ImageData || ImageBitmap && e1 instanceof ImageBitmap;
                if (!this.size && l > 0 && c > 0) {
                    const e1 = this.useMipmap ? Math.floor(Math.log2(Math.max(l, c))) + 1 : 1;
                    o.texStorage2D(o.TEXTURE_2D, e1, this.format, l, c), this.size = [
                        l,
                        c
                    ];
                }
                this.size && (u ? o.texSubImage2D(o.TEXTURE_2D, 0, a, s, W_(this.format), q_(this.format), e1) : "data" in e1 && e1.data && o.texSubImage2D(o.TEXTURE_2D, 0, a, s, i, n, W_(this.format), q_(this.format), e1.data)), this.useMipmap && o.generateMipmap(o.TEXTURE_2D);
            }
            bind(e1, t1, i = !1) {
                const { context: n } = this, { gl: r } = n;
                r.bindTexture(r.TEXTURE_2D, this.texture), e1 !== this.minFilter && (r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, e1), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, this.useMipmap && !i ? e1 === r.NEAREST ? r.NEAREST_MIPMAP_NEAREST : r.LINEAR_MIPMAP_LINEAR : e1), this.minFilter = e1), t1 !== this.wrapS && (r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_S, t1), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_T, t1), this.wrapS = t1);
            }
            bindExtraParam(e1, t1, i, n, r) {
                const { context: o } = this, { gl: a } = o;
                a.bindTexture(a.TEXTURE_2D, this.texture), t1 !== this.magFilter && (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MAG_FILTER, t1), this.magFilter = t1), e1 !== this.minFilter && (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MIN_FILTER, this.useMipmap ? e1 === a.NEAREST ? a.NEAREST_MIPMAP_NEAREST : a.LINEAR_MIPMAP_LINEAR : e1), this.minFilter = e1), i !== this.wrapS && (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_S, i), this.wrapS = i), n !== this.wrapT && (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_T, n), this.wrapT = n), r !== this.compareMode && (r ? (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_COMPARE_MODE, a.COMPARE_REF_TO_TEXTURE), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_COMPARE_FUNC, r)) : a.texParameteri(a.TEXTURE_2D, a.TEXTURE_COMPARE_MODE, a.NONE), this.compareMode = r);
            }
            destroy() {
                const { gl: e1 } = this.context;
                e1.deleteTexture(this.texture), this.texture = null;
            }
        }
        class Y_ {
            constructor(e1, t1, i, n){
                this.context = e1, this.format = n, this.size = i, this.texture = e1.gl.createTexture();
                const [r, o, a] = this.size, { gl: s } = e1;
                s.bindTexture(s.TEXTURE_3D, this.texture), e1.pixelStoreUnpackFlipY.set(!1), e1.pixelStoreUnpack.set(1), e1.pixelStoreUnpackPremultiplyAlpha.set(!1), "data" in t1 && t1.data && s.texImage3D(s.TEXTURE_3D, 0, this.format, r, o, a, 0, W_(this.format), q_(this.format), t1.data);
            }
            bind(e1, t1) {
                const { context: i } = this, { gl: n } = i;
                n.bindTexture(n.TEXTURE_3D, this.texture), e1 !== this.minFilter && (n.texParameteri(n.TEXTURE_3D, n.TEXTURE_MAG_FILTER, e1), n.texParameteri(n.TEXTURE_3D, n.TEXTURE_MIN_FILTER, e1), this.minFilter = e1), t1 !== this.wrapS && (n.texParameteri(n.TEXTURE_3D, n.TEXTURE_WRAP_S, t1), n.texParameteri(n.TEXTURE_3D, n.TEXTURE_WRAP_T, t1), this.wrapS = t1);
            }
            destroy() {
                const { gl: e1 } = this.context;
                e1.deleteTexture(this.texture), this.texture = null;
            }
        }
        class J_ {
            static getImagePositionScale(e1, t1, i) {
                if (t1 && e1) {
                    const { sx: t1, sy: i } = e1;
                    return {
                        x: t1,
                        y: i
                    };
                }
                return {
                    x: i,
                    y: i
                };
            }
            constructor(e1, t1, i, n){
                this.paddedRect = e1;
                const { pixelRatio: r, version: o, stretchX: a, stretchY: s, content: l, sdf: c, usvg: u } = t1;
                this.pixelRatio = r, this.stretchX = a, this.stretchY = s, this.content = l, this.version = o, this.padding = i, this.sdf = c, this.usvg = u, this.scale = J_.getImagePositionScale(n, u, r);
            }
            get tl() {
                return [
                    this.paddedRect.x + this.padding,
                    this.paddedRect.y + this.padding
                ];
            }
            get br() {
                return [
                    this.paddedRect.x + this.paddedRect.w - this.padding,
                    this.paddedRect.y + this.paddedRect.h - this.padding
                ];
            }
            get displaySize() {
                return [
                    (this.paddedRect.w - 2 * this.padding) / this.scale.x,
                    (this.paddedRect.h - 2 * this.padding) / this.scale.y
                ];
            }
        }
        function K_(e1, t1, i) {
            const n = kn.parse(e1), r = function(e1, t1, i = [
                1,
                1
            ]) {
                return {
                    x: 0,
                    y: 0,
                    w: (e1.data ? e1.data.width : e1.width * i[0]) + 2 * t1,
                    h: (e1.data ? e1.data.height : e1.height * i[1]) + 2 * t1
                };
            }(t1, i, [
                n.sx,
                n.sy
            ]);
            return {
                bin: r,
                imagePosition: new J_(r, t1, i, n),
                imageVariant: n
            };
        }
        function Q_(e1, t1) {
            const i = [];
            for (const [n, r] of e1.entries()){
                const e1 = kn.parse(n);
                e1 && (i.push({
                    key: n,
                    value: r,
                    variant: e1
                }), t1 && t1.set(n, e1));
            }
            i.sort((e1, t1)=>{
                const i = e1.variant.id.toString().localeCompare(t1.variant.id.toString());
                return 0 !== i ? i : e1.variant.sx !== t1.variant.sx ? e1.variant.sx - t1.variant.sx : e1.variant.sy !== t1.variant.sy ? e1.variant.sy - t1.variant.sy : e1.key.localeCompare(t1.key);
            });
            const n = new Map;
            for (const e1 of i)n.set(e1.key, e1.value);
            return n;
        }
        class em {
            constructor(e1){
                this.sourceAtlasHash = e1;
            }
        }
        class tm {
            constructor(e1, t1, i, n, r = ""){
                const o = new Map, a = new Map;
                this.haveRenderCallbacks = [];
                const s = [], l = void 0 !== n, c = l ? new Map : void 0, u = l ? Q_(e1, c) : e1, h = l ? Q_(t1, c) : t1;
                this.addImages(u, o, 1, s), this.addImages(h, a, 2, s);
                const { w: d, h: f } = U_(s), p = new Id({
                    width: d || 1,
                    height: f || 1
                });
                for (const [e1, t1] of u.entries()){
                    const i = o.get(e1).paddedRect;
                    Id.copy(t1.data, p, {
                        x: 0,
                        y: 0
                    }, {
                        x: i.x + 1,
                        y: i.y + 1
                    }, t1.data, null, t1.sdf);
                }
                for (const [e1, t1] of h.entries()){
                    const n = a.get(e1), r = n.paddedRect;
                    let o = n.padding;
                    const s = r.x + o, l = r.y + o, c = t1.data.width, u = t1.data.height;
                    o = o > 1 ? o - 1 : o, Id.copy(t1.data, p, {
                        x: 0,
                        y: 0
                    }, {
                        x: s,
                        y: l
                    }, t1.data, i), Id.copy(t1.data, p, {
                        x: 0,
                        y: u - o
                    }, {
                        x: s,
                        y: l - o
                    }, {
                        width: c,
                        height: o
                    }, i), Id.copy(t1.data, p, {
                        x: 0,
                        y: 0
                    }, {
                        x: s,
                        y: l + u
                    }, {
                        width: c,
                        height: o
                    }, i), Id.copy(t1.data, p, {
                        x: c - o,
                        y: 0
                    }, {
                        x: s - o,
                        y: l
                    }, {
                        width: o,
                        height: u
                    }, i), Id.copy(t1.data, p, {
                        x: 0,
                        y: 0
                    }, {
                        x: s + c,
                        y: l
                    }, {
                        width: o,
                        height: u
                    }, i), Id.copy(t1.data, p, {
                        x: c - o,
                        y: u - o
                    }, {
                        x: s - o,
                        y: l - o
                    }, {
                        width: o,
                        height: o
                    }, i), Id.copy(t1.data, p, {
                        x: 0,
                        y: u - o
                    }, {
                        x: s + c,
                        y: l - o
                    }, {
                        width: o,
                        height: o
                    }, i), Id.copy(t1.data, p, {
                        x: 0,
                        y: 0
                    }, {
                        x: s + c,
                        y: l + u
                    }, {
                        width: o,
                        height: o
                    }, i), Id.copy(t1.data, p, {
                        x: c - o,
                        y: 0
                    }, {
                        x: s - o,
                        y: l + u
                    }, {
                        width: o,
                        height: o
                    }, i);
                }
                this.lut = i, this.image = p, this.iconPositions = o, this.patternPositions = a, l && (this.contentDescriptor = new Z_(u, h, n, i, r, c));
            }
            addImages(e1, t1, i, n) {
                for (const [r, o] of e1.entries()){
                    const { bin: e1, imagePosition: a, imageVariant: s } = K_(r, o, i);
                    t1.set(r, a), n.push(e1), o.hasRenderCallback && this.haveRenderCallbacks.push(s.id);
                }
            }
            patchUpdatedImages(e1, t1, i, n) {
                this.haveRenderCallbacks = this.haveRenderCallbacks.filter((t1)=>e1.hasImage(t1, i)), e1.dispatchRenderCallbacks(this.haveRenderCallbacks, i);
                for (const r of e1.getUpdatedImages(i)){
                    for (const n of this.iconPositions.keys()){
                        const o = kn.parse(n);
                        if (sn.isEqual(o.id, r)) {
                            const o = e1.getImage(r, i);
                            this.patchUpdatedImage(this.iconPositions.get(n), o, t1, null);
                        }
                    }
                    for (const o of this.patternPositions.keys()){
                        const a = kn.parse(o);
                        if (sn.isEqual(a.id, r)) {
                            const a = e1.getImage(r, i);
                            this.patchUpdatedImage(this.patternPositions.get(o), a, t1, n || this.lut);
                        }
                    }
                }
            }
            patchUpdatedImage(e1, t1, i, n = null) {
                if (!e1 || !t1) return;
                if (e1.version === t1.version) return;
                e1.version = t1.version;
                const [r, o] = e1.tl, a = e1.sdf;
                if (this.lut || a) {
                    const e1 = {
                        width: t1.data.width,
                        height: t1.data.height
                    }, s = new Id(e1);
                    Id.copy(t1.data, s, {
                        x: 0,
                        y: 0
                    }, {
                        x: 0,
                        y: 0
                    }, e1, n, a), i.update(s, {
                        position: {
                            x: r,
                            y: o
                        },
                        recreateWhenResize: !1
                    });
                } else i.update(t1.data, {
                    position: {
                        x: r,
                        y: o
                    },
                    recreateWhenResize: !1
                });
            }
        }
        Ya(J_, "ImagePosition"), Ya(tm, "ImageAtlas", {
            omit: [
                "lut"
            ]
        }), Ya(em, "ImageAtlasReference");
        const im = 1e20, nm = new Float64Array(256);
        for(let e1 = 0; e1 < 256; e1++){
            const t1 = .5 - Math.pow(e1 / 255, 1 / 2.2);
            nm[e1] = t1 * Math.abs(t1);
        }
        function rm(e1, t1, i, n, r, o, a, s, l, c = 0) {
            for(let u = t1 + c; u < t1 + n - c; u++)om(e1, i * o + u, o, r, a, s, l);
            for(let c = i; c < i + r; c++)om(e1, c * o + t1, 1, n, a, s, l);
        }
        function om(e1, t1, i, n, r, o, a) {
            o[0] = 0, a[0] = -im, a[1] = im, r[0] = e1[t1];
            for(let s = 1, l = 0; s < n; s++){
                const n = r[s] = e1[t1 + s * i], c = s * s;
                let u;
                do {
                    const e1 = o[l];
                    u = (n - r[e1] + c - e1 * e1) / (s - e1) / 2;
                }while (u <= a[l] && --l > -1);
                l++, o[l] = s, a[l] = u, a[l + 1] = im;
            }
            for(let s = 0, l = 0; s < n; s++){
                for(; a[l + 1] < s;)l++;
                const n = o[l], c = s - n;
                e1[t1 + s * i] = r[n] + c * c;
            }
        }
        nm[255] = -im;
        const am = /bold/i, sm = /medium/i, lm = /light/i, cm = {
            none: 0,
            ideographs: 1,
            all: 2
        }, um = class e1 {
            constructor({ mode: e1, fontFamily: t1 }){
                this.mode = e1, this.fontFamily = t1, this.tinySDFs = {}, this.glyphs = {
                    200: {},
                    400: {},
                    500: {},
                    900: {}
                };
            }
            supports(e1) {
                var t1;
                return !!this.fontFamily && (this.mode === cm.all || ys(e1) || bs(e1) || cs(e1) || us(e1) || ls(e1) || gs(e1) || (t1 = e1) >= 131072 && t1 <= 173791 || ((e1)=>e1 >= 66736 && e1 <= 66815)(e1));
            }
            draw(t1, i) {
                if (!this.supports(i)) return;
                const n = function(e1) {
                    return am.test(e1) ? "900" : sm.test(e1) ? "500" : lm.test(e1) ? "200" : "400";
                }(t1), r = this.glyphs[n][i];
                if (r) return r;
                let o = this.tinySDFs[n];
                o || (o = this.tinySDFs[n] = new e1.TinySDF({
                    fontFamily: this.fontFamily,
                    fontWeight: n,
                    fontSize: 48,
                    buffer: 6,
                    radius: 16
                }));
                const a = String.fromCodePoint(i), { data: s, width: l, height: c, glyphWidth: u, glyphHeight: h, glyphLeft: d, glyphTop: f, glyphAdvance: p } = o.draw(a);
                return this.glyphs[n][i] = {
                    id: i,
                    bitmap: new Ed({
                        width: l,
                        height: c
                    }, s),
                    metrics: {
                        width: u / 2,
                        height: h / 2,
                        left: d / 2,
                        top: f / 2 - 27,
                        advance: p / 2,
                        localGlyph: !0
                    }
                };
            }
        };
        um.TinySDF = class {
            constructor({ fontSize: e1 = 24, buffer: t1 = 3, radius: i = 8, cutoff: n = .25, fontFamily: r = "sans-serif", fontWeight: o = "normal", fontStyle: a = "normal", lang: s = null } = {}){
                t1 = this.buffer = Math.round(t1), this.radius = i, this.cutoff = n, this.lang = s;
                const l = this.size = Math.ceil(e1) + 4 * t1, c = this._createCanvas(l), u = this.ctx = c.getContext("2d", {
                    willReadFrequently: !0
                });
                u.font = `${a} ${o} ${e1}px ${r}`, u.textBaseline = "alphabetic", u.textAlign = "left", u.fillStyle = "black", s && (u.lang = s);
                const h = (this.maxGlyphDim = l - t1) + 2 * t1;
                this.gridOuter = new Float64Array(h * h), this.gridInner = new Float64Array(h * h), this.f = new Float64Array(h), this.z = new Float64Array(h + 1), this.v = new Uint16Array(h);
            }
            _createCanvas(e1) {
                if ("undefined" != typeof OffscreenCanvas) return new OffscreenCanvas(e1, e1);
                const t1 = document.createElement("canvas");
                return t1.width = t1.height = e1, t1;
            }
            draw(e1) {
                const { width: t1, actualBoundingBoxAscent: i, actualBoundingBoxDescent: n, actualBoundingBoxLeft: r, actualBoundingBoxRight: o } = this.ctx.measureText(e1), a = Math.ceil(i), s = Math.floor(-r), l = Math.max(0, Math.min(this.maxGlyphDim, Math.ceil(o) - s)), c = Math.max(0, Math.min(this.maxGlyphDim, a + Math.ceil(n))), u = l + 2 * this.buffer, h = c + 2 * this.buffer, d = u * h, f = new Uint8ClampedArray(d), p = {
                    data: f,
                    width: u,
                    height: h,
                    glyphWidth: l,
                    glyphHeight: c,
                    glyphTop: a,
                    glyphLeft: s,
                    glyphAdvance: t1
                };
                if (0 === l || 0 === c) return p;
                const { ctx: _, buffer: m, gridInner: g, gridOuter: y } = this;
                _.clearRect(m, m, l, c), _.fillText(e1, m - s, m + a);
                const x = _.getImageData(m, m, l, c);
                y.fill(im, 0, d), g.fill(0, 0, d);
                let v = 3;
                for(let e1 = 0; e1 < c; e1++){
                    let t1 = (e1 + m) * u + m;
                    for(let e1 = 0; e1 < l; e1++, v += 4, t1++){
                        const e1 = x.data[v];
                        if (0 === e1) continue;
                        const i = nm[e1];
                        y[t1] = Math.max(0, i), g[t1] = Math.max(0, -i);
                    }
                }
                rm(y, 0, 0, u, h, u, this.f, this.v, this.z, m);
                const b = Math.min(m, 1);
                rm(g, m - b, m - b, l + 2 * b, c + 2 * b, u, this.f, this.v, this.z);
                const w = 255 / this.radius, A = 255 * (1 - this.cutoff);
                for(let e1 = 0; e1 < d; e1++){
                    const t1 = Math.sqrt(y[e1]) - Math.sqrt(g[e1]);
                    f[e1] = A - w * t1;
                }
                return p;
            }
        };
        let hm = um;
        function dm(e1, t1) {
            return e1 + t1[1] - t1[0];
        }
        function fm(e1, t1, i, n, r = 1) {
            const o = [], a = e1.imagePrimary, s = a.pixelRatio, l = a.paddedRect.w - 2, c = a.paddedRect.h - 2, u = (e1.right - e1.left) * r, h = (e1.bottom - e1.top) * r, d = a.stretchX || [
                [
                    0,
                    l
                ]
            ], f = a.stretchY || [
                [
                    0,
                    c
                ]
            ], p = d.reduce(dm, 0), _ = f.reduce(dm, 0), m = l - p, g = c - _;
            let y = 0, x = p, v = 0, b = _, w = 0, A = m, E = 0, I = g;
            if (a.content && n) {
                const e1 = a.content;
                y = pm(d, 0, e1[0]), v = pm(f, 0, e1[1]), x = pm(d, e1[0], e1[2]), b = pm(f, e1[1], e1[3]), w = e1[0] - y, E = e1[1] - v, A = e1[2] - e1[0] - x, I = e1[3] - e1[1] - b;
            }
            const M = (n, o, l, c)=>{
                const d = gm(n.stretch - y, x, u, e1.left * r), f = ym(n.fixed - w, A, n.stretch, p), m = gm(o.stretch - v, b, h, e1.top * r), g = ym(o.fixed - E, I, o.stretch, _), M = gm(l.stretch - y, x, u, e1.left * r), S = ym(l.fixed - w, A, l.stretch, p), T = gm(c.stretch - v, b, h, e1.top * r), z = ym(c.fixed - E, I, c.stretch, _), R = new Re(d, m), P = new Re(M, m), D = new Re(M, T), F = new Re(d, T), C = new Re(f / s, g / s), O = new Re(S / s, z / s), L = t1 * Math.PI / 180;
                if (L) {
                    const e1 = Math.sin(L), t1 = Math.cos(L), i = [
                        t1,
                        -e1,
                        e1,
                        t1
                    ];
                    R._matMult(i), P._matMult(i), F._matMult(i), D._matMult(i);
                }
                const B = n.stretch + n.fixed, V = l.stretch + l.fixed, N = o.stretch + o.fixed, k = c.stretch + c.fixed, U = e1.imageSecondary;
                return {
                    tl: R,
                    tr: P,
                    bl: F,
                    br: D,
                    texPrimary: {
                        x: a.paddedRect.x + 1 + B,
                        y: a.paddedRect.y + 1 + N,
                        w: V - B,
                        h: k - N
                    },
                    texSecondary: U ? {
                        x: U.paddedRect.x + 1 + B,
                        y: U.paddedRect.y + 1 + N,
                        w: V - B,
                        h: k - N
                    } : void 0,
                    writingMode: void 0,
                    glyphOffset: [
                        0,
                        0
                    ],
                    sectionIndex: 0,
                    pixelOffsetTL: C,
                    pixelOffsetBR: O,
                    minFontScaleX: A / s / u,
                    minFontScaleY: I / s / h,
                    isSDF: i
                };
            };
            if (a.stretchX || a.stretchY) {
                const e1 = _m(d, m, p), t1 = _m(f, g, _);
                for(let i = 0; i < e1.length - 1; i++){
                    const n = e1[i], r = e1[i + 1];
                    for(let e1 = 0; e1 < t1.length - 1; e1++)o.push(M(n, t1[e1], r, t1[e1 + 1]));
                }
            } else o.push(M({
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: l + 1
            }, {
                fixed: 0,
                stretch: c + 1
            }));
            return o;
        }
        function pm(e1, t1, i) {
            let n = 0;
            for (const r of e1)n += Math.max(t1, Math.min(i, r[1])) - Math.max(t1, Math.min(i, r[0]));
            return n;
        }
        function _m(e1, t1, i) {
            const n = [
                {
                    fixed: -1,
                    stretch: 0
                }
            ];
            for (const [t1, i] of e1){
                const e1 = n.at(-1);
                n.push({
                    fixed: t1 - e1.stretch,
                    stretch: e1.stretch
                }), n.push({
                    fixed: t1 - e1.stretch,
                    stretch: e1.stretch + (i - t1)
                });
            }
            return n.push({
                fixed: t1 + 1,
                stretch: i
            }), n;
        }
        function mm(e1) {
            return 2 * e1.length + 1;
        }
        function gm(e1, t1, i, n) {
            return e1 / t1 * i + n;
        }
        function ym(e1, t1, i, n) {
            return e1 - t1 * i / n;
        }
        function xm(e1, t1, i, n) {
            const r = t1 + e1.positionedLines[n].lineOffset;
            return 0 === n ? i + r / 2 : i + (r + (t1 + e1.positionedLines[n - 1].lineOffset)) / 2;
        }
        function vm(e1, t1, i, n, r, o, a, s, l, c = 1) {
            const u = [];
            if (0 === t1.positionedLines.length) return u;
            const h = (void 0 !== l ? l : n.layout.get("text-rotate").evaluate(o, {})) * Math.PI / 180, d = function(e1) {
                const t1 = e1[0], i = e1[1], n = t1 * i;
                return n > 0 ? [
                    t1,
                    -i
                ] : n < 0 ? [
                    -t1,
                    i
                ] : 0 === t1 ? [
                    i,
                    t1
                ] : [
                    i,
                    -t1
                ];
            }(i);
            let f = Math.abs(t1.top - t1.bottom);
            for (const e1 of t1.positionedLines)f -= e1.lineOffset;
            const p = t1.positionedLines.length, _ = f / p;
            let m = t1.top - i[1];
            for(let e1 = 0; e1 < p; ++e1){
                const n = t1.positionedLines[e1];
                m = xm(t1, _, m, e1);
                for (const e1 of n.positionedGlyphs){
                    if (!e1.rect) continue;
                    const n = e1.rect || {};
                    let o = 4, l = !0, f = 1, p = 0;
                    if (e1.image) {
                        const t1 = a.get(e1.image.toString());
                        if (!t1) continue;
                        l = !1, f = t1.pixelRatio, o = 1 / f, t1.usvg || (f /= c);
                    }
                    const _ = (r || s) && e1.vertical, g = e1.metrics.advance * e1.scale / 2, y = e1.metrics, x = e1.rect;
                    if (null === x) continue;
                    s && t1.verticalizable && (p = e1.image ? g - e1.metrics.width * e1.scale / 2 : 0);
                    const v = r ? [
                        e1.x + g,
                        e1.y
                    ] : [
                        0,
                        0
                    ];
                    let b = [
                        0,
                        0
                    ], w = [
                        0,
                        0
                    ], A = !1;
                    r || (_ ? (w = [
                        e1.x + g + d[0],
                        e1.y + d[1] - p
                    ], A = !0) : b = [
                        e1.x + g + i[0],
                        e1.y + i[1] - p
                    ]);
                    const E = x.w * e1.scale / (f * (e1.localGlyph ? 2 : 1)), I = x.h * e1.scale / (f * (e1.localGlyph ? 2 : 1));
                    let M, S, T, z;
                    if (_) {
                        const t1 = e1.y - m, i = new Re(-g, g - t1), n = -Math.PI / 2, r = new Re(...w);
                        M = new Re(-g + b[0], b[1]), M._rotateAround(n, i)._add(r), M.x += -t1 + g, M.y -= (y.left - o) * e1.scale;
                        const a = e1.image ? y.advance * e1.scale : af * e1.scale, s = String.fromCodePoint(e1.glyph);
                        pf(s) ? M.x += (1 - o) * e1.scale : _f(s) ? M.x += a - y.height * e1.scale + (-o - 1) * e1.scale : M.x += e1.image || y.width + 2 * o === x.w && y.height + 2 * o === x.h ? (a - I) / 2 : (a - (y.height + 2 * o) * e1.scale) / 2, S = new Re(M.x, M.y - E), T = new Re(M.x + I, M.y), z = new Re(M.x + I, M.y - E);
                    } else {
                        const t1 = (y.left - o) * e1.scale - g + b[0], i = (-y.top - o) * e1.scale + b[1], n = t1 + E, r = i + I;
                        M = new Re(t1, i), S = new Re(n, i), T = new Re(t1, r), z = new Re(n, r);
                    }
                    if (h) {
                        let e1;
                        e1 = r ? new Re(0, 0) : A ? new Re(d[0], d[1]) : new Re(i[0], i[1]), M._rotateAround(h, e1), S._rotateAround(h, e1), T._rotateAround(h, e1), z._rotateAround(h, e1);
                    }
                    const R = new Re(0, 0), P = new Re(0, 0);
                    u.push({
                        tl: M,
                        tr: S,
                        bl: T,
                        br: z,
                        texPrimary: n,
                        texSecondary: void 0,
                        writingMode: t1.writingMode,
                        glyphOffset: v,
                        sectionIndex: e1.sectionIndex,
                        isSDF: l,
                        pixelOffsetTL: R,
                        pixelOffsetBR: P,
                        minFontScaleX: 0,
                        minFontScaleY: 0
                    });
                }
            }
            return u;
        }
        class bm {
            constructor(e1, t1){
                this.lastParams = null, this.lastAllFeaturesIndex = -2, this.appearancesVersion = t1, this.appearances = e1;
                const i = e1.map((e1)=>(function(e1) {
                        if (!e1.condition) return {
                            featureDependent: !1,
                            stateDependent: !1,
                            zoomDependent: !1,
                            pitchDependent: !1,
                            brightnessDependent: !1,
                            worldviewDependent: !1
                        };
                        const t1 = e1.condition.expression;
                        return {
                            featureDependent: !Dr(t1),
                            stateDependent: !Fr(t1),
                            zoomDependent: !Or(t1, [
                                "zoom"
                            ]),
                            pitchDependent: !Or(t1, [
                                "pitch"
                            ]),
                            brightnessDependent: !Or(t1, [
                                "brightness",
                                "measure-light"
                            ]),
                            worldviewDependent: !Or(t1, [
                                "worldview"
                            ])
                        };
                    })(e1));
                this.anyFeatureDependent = i.some((e1)=>e1.featureDependent), this.anyStateDependent = i.some((e1)=>e1.stateDependent);
            }
            update(e1, t1) {
                const i = this.lastParams, n = !i || i.zoom !== e1.zoom || i.pitch !== (e1.pitch || 0) || i.brightness !== (e1.brightness || 0) || i.worldview !== e1.worldview;
                this.lastParams = {
                    zoom: e1.zoom,
                    pitch: e1.pitch || 0,
                    brightness: e1.brightness || 0,
                    worldview: e1.worldview
                };
                const r = t1 && this.anyStateDependent;
                if (!n && !r && -2 !== this.lastAllFeaturesIndex) return {
                    kind: "no-changes"
                };
                if (!this.anyFeatureDependent && !r) {
                    const t1 = this.evaluateAllFeatures(e1);
                    return t1 === this.lastAllFeaturesIndex ? {
                        kind: "no-changes"
                    } : (this.lastAllFeaturesIndex = t1, {
                        kind: "all-features",
                        appearanceIndex: t1
                    });
                }
                return {
                    kind: "per-feature"
                };
            }
            evaluateAllFeatures(e1) {
                for(let t1 = 0; t1 < this.appearances.length; t1++){
                    const i = this.appearances[t1];
                    if (i.condition && i.condition.evaluate(e1, void 0, void 0, void 0)) return t1;
                }
                return -1;
            }
        }
        const wm = Wh.types, Am = {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 0,
            padding: 0,
            projectedAnchorX: 0,
            projectedAnchorY: 0,
            projectedAnchorZ: 0,
            tileAnchorX: 0,
            tileAnchorY: 0,
            elevation: void 0,
            tileID: void 0
        }, Em = {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 0,
            padding: 0,
            projectedAnchorX: 0,
            projectedAnchorY: 0,
            projectedAnchorZ: 0,
            tileAnchorX: 0,
            tileAnchorY: 0,
            elevation: void 0,
            tileID: void 0
        }, Im = {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 0,
            padding: 0,
            projectedAnchorX: 0,
            projectedAnchorY: 0,
            projectedAnchorZ: 0,
            tileAnchorX: 0,
            tileAnchorY: 0,
            elevation: void 0,
            tileID: void 0
        }, Mm = {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 0,
            padding: 0,
            projectedAnchorX: 0,
            projectedAnchorY: 0,
            projectedAnchorZ: 0,
            tileAnchorX: 0,
            tileAnchorY: 0,
            elevation: void 0,
            tileID: void 0
        }, Sm = {};
        function Tm(e1, t1, i) {
            const n = e1.get(t1);
            return i.x1 = n.x1, i.y1 = n.y1, i.x2 = n.x2, i.y2 = n.y2, i.padding = n.padding, i.projectedAnchorX = n.projectedAnchorX, i.projectedAnchorY = n.projectedAnchorY, i.projectedAnchorZ = n.projectedAnchorZ, i.tileAnchorX = n.tileAnchorX, i.tileAnchorY = n.tileAnchorY, n.featureIndex;
        }
        const zm = [
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint8",
                offset: 0
            }
        ];
        function Rm(e1, t1, i, n, r, o, a, s, l, c, u, h, d) {
            const f = s ? Math.min(wf, Math.round(s[0])) : 0, p = s ? Math.min(wf, Math.round(s[1])) : 0;
            e1.emplaceBack(t1, i, Math.round(32 * n), Math.round(32 * r), o, a, (f << 1) + (l ? 1 : 0), 0 + (p << 1), 16 * c, 16 * u, 256 * h, 256 * d);
        }
        function Pm(e1, t1, i) {
            e1.emplaceBack(t1, i);
        }
        function Dm(e1, t1, i, n, r, o, a) {
            e1.emplaceBack(t1, i, n, r, o, a);
        }
        function Fm(e1, t1, i, n, r) {
            const o = 5 * t1 + 2;
            e1.float32[o + 0] = i, e1.float32[o + 1] = n, e1.float32[o + 2] = r;
        }
        function Cm(e1, t1, i, n, r) {
            e1.emplaceBack(t1, i, n, r), e1.emplaceBack(t1, i, n, r), e1.emplaceBack(t1, i, n, r), e1.emplaceBack(t1, i, n, r);
        }
        function Om(e1) {
            for (const t1 of e1.sections)if (Os(t1.text)) return !0;
            return !1;
        }
        const Lm = 12, Bm = 2 ** 24;
        function Vm(e1, t1) {
            return e1 * Bm + t1;
        }
        function Nm(e1, t1) {
            return (e1 ? 1 : 0) | (t1 ? 2 : 0);
        }
        const km = {}, Um = new Lc, jm = new Lc;
        function Gm(e1, t1, i) {
            if (0 === t1) return;
            const n = e1.length;
            e1.resize(n + t1), e1.float32.fill(i, n, n + t1);
        }
        class Hm {
            constructor(e1){
                this.layoutVertexArray = new Zc, this.indexArray = new nu, this.programConfigurations = e1, this.segments = new Ou, this.dynamicLayoutVertexArray = new qc, this.opacityVertexArray = new Xc, this.fadeVertexArray = new Yc, this.placedSymbolArray = new bu, this.iconTransitioningVertexArray = new Jc, this.globeExtVertexArray = new Wc, this.zOffsetVertexArray = new Lc, this.orientationVertexArray = new au, this.symbolInstanceIndices = [], this.uboBinder = null, this.featureIdArray = new Lc, this.featureIdBuffer = null, this.cachedBatchIndices = null, this.cachedBatchSegments = null;
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length && 0 === this.iconTransitioningVertexArray.length;
            }
            getBatchGrouping(e1) {
                const t1 = e1.get().length === this.segments.get().length;
                if (t1 && this.cachedBatchIndices && this.cachedBatchSegments) return {
                    batchIndices: this.cachedBatchIndices,
                    batchSegments: this.cachedBatchSegments
                };
                const i = new Map;
                for (const t1 of e1.get()){
                    const e1 = void 0 !== t1.batchIndex ? t1.batchIndex : 0;
                    i.has(e1) || i.set(e1, []), i.get(e1).push(t1);
                }
                const n = Array.from(i.keys()).sort((e1, t1)=>e1 - t1), r = new Map;
                for (const e1 of n){
                    const t1 = i.get(e1);
                    r.set(e1, new Ou(t1));
                }
                return t1 && (this.cachedBatchIndices = n, this.cachedBatchSegments = r), {
                    batchIndices: n,
                    batchSegments: r
                };
            }
            snapshotSymbolVertexData(e1, t1) {
                const i = e1 * Lm;
                return this.layoutVertexArray.uint16.slice(i, i + t1 * Lm);
            }
            restoreSymbolVertexData(e1, t1) {
                this.layoutVertexArray.uint16.set(t1, e1 * Lm);
            }
            snapshotIconTransitioningVertexData(e1, t1) {
                const i = 2 * e1;
                return this.iconTransitioningVertexArray.uint16.slice(i, i + 2 * t1);
            }
            restoreIconTransitioningVertexData(e1, t1) {
                this.iconTransitioningVertexArray.uint16.set(t1, 2 * e1);
            }
            updateSymbolVertexData(e1, t1, i, n, r, o, a, s, l, c, u, h, d) {
                const f = this.layoutVertexArray.uint16, p = e1 * Lm;
                f[p] = t1, f[p + 1] = i, f[p + 2] = n, f[p + 3] = r, f[p + 4] = o, f[p + 5] = a, f[p + 6] = s, f[p + 7] = l, f[p + 8] = c, f[p + 9] = u, f[p + 10] = h, f[p + 11] = d;
            }
            upload(e1, t1, i, n, r, o) {
                this.isEmpty() || (i && (this.cachedBatchIndices = null, this.cachedBatchSegments = null, this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, Nd.members, !!o), this.indexBuffer = e1.createIndexBuffer(this.indexArray, t1), this.dynamicLayoutVertexBuffer = e1.createVertexBuffer(this.dynamicLayoutVertexArray, Ud.members, !0), this.opacityVertexBuffer = e1.createVertexBuffer(this.opacityVertexArray, zm, !0), this.iconTransitioningVertexArray.length > 0 && (this.iconTransitioningVertexBuffer = e1.createVertexBuffer(this.iconTransitioningVertexArray, Zd.members, !0)), this.globeExtVertexArray.length > 0 && (this.globeExtVertexBuffer = e1.createVertexBuffer(this.globeExtVertexArray, kd.members, !0)), !this.zOffsetVertexBuffer && (this.zOffsetVertexArray.length > 0 || r) && (this.zOffsetVertexBuffer = e1.createVertexBuffer(this.zOffsetVertexArray, Gd.members, !0), this.zOffsetVertexArray.clear(), this.zOffsetVertexArray._trim()), !this.orientationVertexBuffer && this.orientationVertexArray && this.orientationVertexArray.length > 0 && (this.orientationVertexBuffer = e1.createVertexBuffer(this.orientationVertexArray, $d.members, !0)), this.opacityVertexBuffer.itemSize = 1, this.featureIdArray.length > 0 && (this.featureIdBuffer = e1.createVertexBuffer(this.featureIdArray, Hd.members, !1))), this.fadeUploadPending() && (this.fadeVertexBuffer = e1.createVertexBuffer(this.fadeVertexArray, jd.members, !0)), (i || n) && (this.programConfigurations.upload(e1), this.uboBinder && this.uboBinder.upload(e1)));
            }
            fadeUploadPending() {
                return this.fadeVertexArray.length > 0 && !this.fadeVertexBuffer;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy(), this.iconTransitioningVertexBuffer && this.iconTransitioningVertexBuffer.destroy(), this.fadeVertexBuffer && this.fadeVertexBuffer.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy(), this.zOffsetVertexBuffer && this.zOffsetVertexBuffer.destroy(), this.orientationVertexBuffer && this.orientationVertexBuffer.destroy(), this.featureIdBuffer && this.featureIdBuffer.destroy(), this.uboBinder && this.uboBinder.destroy());
            }
        }
        Ya(Hm, "SymbolBuffers", {
            omit: [
                "cachedBatchIndices",
                "cachedBatchSegments"
            ]
        });
        class $m {
            constructor(e1, t1, i){
                this.layoutVertexArray = new e1, this.layoutAttributes = t1, this.indexArray = new i, this.segments = new Ou, this.collisionVertexArray = new iu, this.collisionVertexArrayExt = new qc;
            }
            upload(e1) {
                this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = e1.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = e1.createVertexBuffer(this.collisionVertexArray, Wd.members, !0), this.collisionVertexBufferExt = e1.createVertexBuffer(this.collisionVertexArrayExt, qd.members, !0);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy(), this.collisionVertexBufferExt.destroy());
            }
        }
        Ya($m, "CollisionBuffers");
        class Zm {
            constructor(e1){
                this.collisionBoxArray = e1.collisionBoxArray, this.zoom = e1.zoom, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.pixelRatio = e1.pixelRatio, this.sourceLayerIndex = e1.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.fullyClipped = !1, this.hasAnyIconTextFit = !1, this.sortKeyRanges = [], this.placementVariantVisible = [], this.placementFadeRefTime = new Float64Array(0), this.placementFadeRunning = new Uint8Array(0), this._activeFadeCount = 0, this._fadeDuration = 0, this.collisionCircleArray = [], this.placementInvProjMatrix = d([]), this.placementViewportMatrix = d([]);
                const t1 = this.layers[0];
                this.worldview = e1.worldview, this.localizable = e1.localizable, this.maxUniformBlockSizeDwords = e1.maxUniformBlockSizeDwords, this.textSizeData = gf(this.zoom, t1.getLayoutPropertyValue("text-size"), this.worldview, e1.availableImages), this.iconSizeData = gf(this.zoom, t1.getLayoutPropertyValue("icon-size"), this.worldview, e1.availableImages);
                const i = this.layers[0].layout, n = i.get("symbol-sort-key"), r = i.get("symbol-z-order");
                this.lut = e1.lut, this.canOverlap = i.get("text-allow-overlap") || i.get("icon-allow-overlap") || i.get("text-ignore-placement") || i.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== r && void 0 !== n.constantOr(1), this.sortFeaturesByY = ("viewport-y" === r || "auto" === r && !this.sortFeaturesByKey) && this.canOverlap, this.writingModes = i.get("text-writing-mode").map((e1)=>cf[e1]), this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.sourceID = e1.sourceID, this.projection = e1.projection, this.hasAnyZOffset = !1, this.zOffsetSortDirty = !1, this.zOffsetBuffersNeedUpload = !1, this.elevationType = "none", this.activeReplacements = [], this.replacementUpdateTime = 0, this.hasAnySecondaryIcon = !1, this.hasAppearances = null, this.featureAppearances = null, this.featureAppearanceData = new Map;
            }
            hasAnyAppearanceLayoutProperty(e1) {
                const t1 = this.layers[0].getAppearances();
                if (!t1 || 0 === t1.length) return !1;
                const i = Array.isArray(e1) ? e1 : [
                    e1
                ];
                return t1.some((e1)=>i.some((t1)=>e1.hasLayoutProperty(t1)));
            }
            getAppearanceFeatureData(e1) {
                return this.featureAppearanceData.get(e1);
            }
            createArrays() {
                this.text = new Hm(new ch(this.layers, {
                    zoom: this.zoom,
                    lut: this.lut
                }, (e1)=>e1.startsWith("text") || e1.startsWith("symbol"))), this.icon = new Hm(new ch(this.layers, {
                    zoom: this.zoom,
                    lut: this.lut
                }, (e1)=>e1.startsWith("icon") || e1.startsWith("symbol"))), this.text.uboBinder = new of(this.layers[0], this.zoom, this.lut, !0, "", this.maxUniformBlockSizeDwords), this.icon.uboBinder = new of(this.layers[0], this.zoom, this.lut, !1, "", this.maxUniformBlockSizeDwords), this.glyphOffsetArray = new Eu, this.lineVertexArray = new Iu, this.symbolInstances = new Au;
            }
            calculateGlyphDependencies(e1, t1, i, n, r) {
                for (const i of e1){
                    const e1 = i.codePointAt(0);
                    if (void 0 === e1) break;
                    if (t1[e1] = !0, n && r && e1 <= 65535) {
                        const e1 = ff[i];
                        e1 && (t1[e1.charCodeAt(0)] = !0);
                    }
                }
            }
            calculateEffectiveAppearanceIconSize(e1, t1, i, n, r, o, a) {
                if (!e1.hasLayoutProperty("icon-size")) return a * o;
                let s = 1;
                const l = e1.getUnevaluatedLayoutProperty("icon-size"), c = gf(this.zoom, l, this.worldview, r), u = xf(c, t1);
                if ("constant" !== c.kind && "camera" !== c.kind || (s = u.uSize), "composite" === c.kind) {
                    const { minZoom: e1, maxZoom: t1 } = c, o = l.possiblyEvaluate(new Ls(e1, {
                        worldview: this.worldview
                    }), n), a = l.possiblyEvaluate(new Ls(t1, {
                        worldview: this.worldview
                    }), n), h = o.evaluate(i, {}, n, r);
                    s = h + (a.evaluate(i, {}, n, r) - h) * u.uSizeT;
                }
                return "source" === c.kind && (s = l.possiblyEvaluate(new Ls(this.zoom, {
                    worldview: this.worldview
                }), n).evaluate(i, {}, n, r)), s * o;
            }
            updateFootprints(e1, t1) {}
            hideSymbolVariant(e1, t1) {
                this._setSymbolVariantVisibility(e1, !1, t1);
            }
            showSymbolVariant(e1, t1) {
                this._setSymbolVariantVisibility(e1, !0, t1);
            }
            _initPlacementOpacities() {
                const e1 = (e1)=>{
                    const t1 = e1.layoutVertexArray.length;
                    for(let i = 0; i < t1; i++)e1.fadeVertexArray.emplaceBack(0, 2);
                };
                this.hasTextData() && e1(this.text), this.hasIconData() && e1(this.icon);
            }
            _setSymbolVariantVisibility(e1, t1, i) {
                const n = e1.symbolId.symbolId - this.bucketInstanceId * Bm, r = this.symbolInstances.get(n), o = function(e1, t1, i, n, r) {
                    if (i || 0 === r) return t1 ? 1 : 0;
                    const o = (n - e1) / r;
                    return tt(t1 ? o : 1 - o, 0, 1);
                }(this.placementFadeRefTime[n], this.placementVariantVisible[n], 0 === this.placementFadeRunning[n], i, this._fadeDuration), a = t1 ? i - o * this._fadeDuration : i - (1 - o) * this._fadeDuration;
                0 === this.placementFadeRunning[n] && this._activeFadeCount++, this.placementVariantVisible[n] = t1, this.placementFadeRefTime[n] = a, this.placementFadeRunning[n] = 1, this._writeFadeState(n, r, a, Nm(t1, !1));
            }
            hasActiveFade() {
                return this._activeFadeCount > 0;
            }
            _writeFadeState(e1, t1, i, n) {
                const r = (e1, t1)=>{
                    if (t1 < 0) return;
                    const r = e1.placedSymbolArray.get(t1), o = r.vertexStartIndex;
                    for(let t1 = 0; t1 < 4 * r.numGlyphs; t1++)e1.fadeVertexArray.emplace(o + t1, i, n);
                    e1.fadeVertexBuffer && e1.fadeVertexBuffer.updateData(e1.fadeVertexArray);
                };
                this.hasTextData() && r(this.text, this.defaultPlacedTextSymbolIndex(t1, e1)), this.hasIconData() && r(this.icon, t1.placedIconSymbolIndex);
            }
            _settleFinishedFade(e1, t1, i) {
                0 !== this.placementFadeRunning[e1] && (i - this.placementFadeRefTime[e1] < this._fadeDuration || (this.placementFadeRunning[e1] = 0, this._activeFadeCount--, this._writeFadeState(e1, t1, 0, Nm(this.placementVariantVisible[e1], !0))));
            }
            resetPlacementVisibility() {
                if (0 === this.placementVariantVisible.length) return;
                this.placementVariantVisible.fill(!1), this.placementFadeRefTime.fill(0), this.placementFadeRunning.fill(0), this._activeFadeCount = 0;
                const e1 = (e1)=>{
                    for(let t1 = 0; t1 < e1.fadeVertexArray.length; t1++)e1.fadeVertexArray.emplace(t1, 0, 2);
                    e1.fadeVertexBuffer && e1.fadeVertexBuffer.updateData(e1.fadeVertexArray);
                };
                this.hasTextData() && e1(this.text), this.hasIconData() && e1(this.icon);
            }
            addToPlacement(e1, t1, i, n, r, o, a, s, l, c, u, h, d, f, p) {
                if (0 === this.symbolInstances.length) return;
                if (this._fadeDuration = f, d && this.updateReplacement(s.tileID, d), !s.collisionBoxArray) return;
                0 === this.placementVariantVisible.length && (this.placementVariantVisible = new Array(this.symbolInstances.length).fill(!1), this.placementFadeRefTime = new Float64Array(this.symbolInstances.length), this.placementFadeRunning = new Uint8Array(this.symbolInstances.length), this._initPlacementOpacities());
                const _ = e1.timestamp(), m = this.layers[0];
                if (m.appearances && m.appearances.length > 0) return void _t("new placement: symbol appearances are not supported yet; hiding symbols");
                if ("point" !== m.layout.get("symbol-placement")) return void _t("new placement: along-line symbol placement is not supported yet; hiding symbols");
                const g = !!m.layout.get("text-variable-anchor"), y = this.getProjection(), x = "globe" === y.name ? cp(o.zoom) : 1, v = x < 1, b = s.tileID.toUnwrapped(), w = {
                    overscaledZ: s.tileID.overscaledZ,
                    wrap: s.tileID.wrap,
                    canonical: s.tileID.canonical
                }, A = o.pitch > 0, E = {}, I = w_(m.layout.get("icon-allow-overlap"), m.layout.get("icon-ignore-placement")), M = w_(m.layout.get("text-allow-overlap"), m.layout.get("text-ignore-placement")), S = o.zoom, T = xf(this.iconSizeData, S), z = xf(this.textSizeData, S), R = m.paint.get("symbol-z-offset"), P = "sea" === m.layout.get("symbol-elevation-reference"), D = !R.isConstant(), F = D ? 0 : R.evaluate(null, {}), C = o.elevation, O = A_(u), L = (e1)=>{
                    if (!e1) return O;
                    const t1 = c.get(ul(e1, m.scope));
                    return void 0 !== t1 ? t1 : (_t(`global placement: placement-group "${e1}" does not match any placement-group layer; using the layer's implicit group`), O);
                }, B = m.paint.get("placement-priority"), V = m.paint.get("placement-group"), N = !B.isConstant(), k = !V.isConstant(), U = N ? 0 : B.evaluate(null, {}), j = k ? O : L(V.evaluate(null, {})), G = N || k, H = e1.isCollectingDebugData(), $ = D || G || H ? s.latestFeatureIndex : null;
                $ && $.loadVTLayers();
                const Z = $ ? $.sourceLayerCoder.decode(this.sourceLayerIndex) : "", W = (e1, t1, a)=>{
                    let c;
                    if ("road" === this.elevationType) c = P ? a : a + f_.getAtTileOffset(s.tileID, new Re(e1.tileAnchorX, e1.tileAnchorY), C, null);
                    else {
                        const i = this.hdExt ? this.hdExt.elevationFeatures[t1.elevationFeatureIndex] : void 0;
                        c = P ? a : a + f_.getAtTileOffset(s.tileID, new Re(e1.tileAnchorX, e1.tileAnchorY), C, i);
                    }
                    c += t1.zOffset;
                    let u = e1.projectedAnchorX, h = e1.projectedAnchorY, d = e1.projectedAnchorZ;
                    const f = !!c;
                    if (f) {
                        const [t1, i, n] = y.upVector(s.tileID.canonical, e1.tileAnchorX, e1.tileAnchorY), r = y.upVectorScale(s.tileID.canonical, o.center.lat, o.worldSize).metersToTile * c;
                        u += t1 * r, h += i * r, d += n * r;
                    }
                    if ("globe" === y.name && v) {
                        const t1 = s.tileID.canonical, i = 1 << t1.z;
                        let o = (e1.tileAnchorX / Sr + t1.x) / i - r[0];
                        const a = ((e1.tileAnchorY / Sr + t1.y) / i - r[1]) * Sr;
                        o = nt(o, -0.5, .5) * Sr;
                        const l = re(o, a, Sr / (2 * Math.PI), 1);
                        se(l, l, n), u = hn(u, l[0], x), h = hn(h, l[1], x), d = hn(d, l[2], x);
                    }
                    return function(e1, t1, i, n, r, o, a, s, l) {
                        const c = [
                            t1,
                            i,
                            n,
                            1
                        ];
                        let u = !1;
                        n || r.pitch > 0 ? (se(c, c, e1), s && "globe" !== o.name && (u = g_(s, t1, i, n, l, r) > .9)) : d_(c, c, e1);
                        const h = c[3];
                        return {
                            x: (c[0] / h + 1) / 2 * r.width,
                            y: (-c[1] / h + 1) / 2 * r.height,
                            perspectiveRatio: Math.min(.5 + r.getCameraToCenterDistance(o) / h * .5, 1.5),
                            occluded: a && c[2] > h || u
                        };
                    }(i, u, h, d, o, y, A || f || "globe" === y.name, l, b);
                }, q = (t1, i, n, r, o)=>{
                    if (!t1) return;
                    const s = W(t1, n, r);
                    if (s.occluded || s.perspectiveRatio <= .55) return;
                    const l = o(), c = a * s.perspectiveRatio, u = (t1.x1 * l - t1.padding) * c + s.x, h = (t1.y1 * l - t1.padding) * c + s.y, d = (t1.x2 * l + t1.padding) * c + s.x, f = (t1.y2 * l + t1.padding) * c + s.y;
                    u < d && h < f && e1.addSymbolVariantPart([
                        {
                            kind: "box",
                            left: u,
                            top: h,
                            right: d,
                            bottom: f
                        }
                    ], i);
                };
                for(let i = 0; i < this.symbolInstances.length; i++){
                    const n = this.symbolInstances.get(i);
                    if (n.hasIconTextFit) {
                        _t("new placement: icon-text-fit is not supported yet; skipping symbols");
                        continue;
                    }
                    if (g && (n.numHorizontalGlyphVertices > 0 || n.numVerticalGlyphVertices > 0)) {
                        _t("new placement: text-variable-anchor is not supported yet; skipping symbols");
                        continue;
                    }
                    if (n.numVerticalGlyphVertices > 0) {
                        _t("new placement: vertical text-writing-mode is not supported yet; skipping symbols");
                        continue;
                    }
                    const r = this.getCollisionArrays(s.collisionBoxArray, n);
                    if (!r.iconBox && !r.textBox) continue;
                    let o = !1;
                    for (const e1 of this.activeReplacements)if (!Xp(e1, u, h_.Symbol, m.scope) && !(e1.min.x > n.tileAnchorX || n.tileAnchorX > e1.max.x || e1.min.y > n.tileAnchorY || n.tileAnchorY > e1.max.y) && (o = u_(c_(n.tileAnchorX, n.tileAnchorY, s.tileID.canonical, e1.footprintTileId.canonical), e1.footprint), o)) break;
                    const a = {
                        symbolId: {
                            styleLayerId: t1,
                            symbolIdOrigin: 1,
                            symbolId: Vm(this.bucketInstanceId, i)
                        },
                        variantIdx: 0
                    }, l = p.length > 0 && p.some((e1)=>n.tileAnchorX >= e1.min.x && n.tileAnchorX < e1.max.x && n.tileAnchorY >= e1.min.y && n.tileAnchorY < e1.max.y), c = $ ? $.loadFeature({
                        featureIndex: n.featureIndex,
                        sourceLayerIndex: this.sourceLayerIndex,
                        bucketIndex: this.index,
                        layoutVertexArrayOffset: 0
                    }) : null, d = (G || H) && c && $ ? $.getId(c, Z) : void 0, f = void 0 !== d && h[String(d)] || km, y = N && c ? B.evaluate(c, f) : U, x = k && c ? L(V.evaluate(c, f)) : j;
                    if (this._settleFinishedFade(i, n, _), e1.startSymbolVariantProcessing(a, {
                        placementSubgroupOrder: x,
                        symbolPlacementPriority: y,
                        symbolVariantVisibility: this.placementVariantVisible[i] ? b_.VARIANT_VISIBLE : b_.SYMBOL_INVISIBLE,
                        symbolPlacementType: 1,
                        styleLayerOrder: u,
                        symbolDisplayOrder: 0
                    }, E, w, d), !o && !l) {
                        const e1 = D && c ? R.evaluate(c, {}) : F;
                        q(r.iconBox, I, n, e1, ()=>this.getSymbolInstanceIconSize(T, S, n.placedIconSymbolIndex)), q(r.textBox, M, n, e1, ()=>this.getSymbolInstanceTextSize(z, n, S, i));
                    }
                    e1.finishVariantProcessing();
                }
            }
            updateReplacement(e1, t1) {
                if (t1.updateTime === this.replacementUpdateTime) return !1;
                this.replacementUpdateTime = t1.updateTime;
                const i = t1.getReplacementRegionsForTile(e1.toUnwrapped(), !0);
                return !Qp(this.activeReplacements, i) && (this.activeReplacements = i, !0);
            }
            getResolvedImageFromTokens(e1) {
                return "string" == typeof e1 ? Un.build(e1) : e1;
            }
            populate(e1, i, n, r) {
                const o = this.layers[0], a = o.layout, s = "globe" === this.projection.name, l = a.get("text-font"), c = a.get("text-field"), u = a.get("icon-image"), [h, d] = a.get("icon-size-scale-range"), f = tt(i.scaleFactor || 1, h, d), [p, _] = a.get("text-size-scale-range"), m = tt(i.scaleFactor || 1, p, _), g = ("constant" !== c.value.kind || c.value.value instanceof Nn && !c.value.value.isEmpty() || c.value.value.toString().length > 0) && ("constant" !== l.value.kind || l.value.value.length > 0), y = "constant" !== u.value.kind || !!u.value.value || Object.keys(u.parameters).length > 0, x = this.hasAnyAppearanceLayoutProperty("icon-image"), v = this.layers[0].getAppearances().length > 0, b = a.get("symbol-sort-key");
                if (this.features = [], this.featureAppearanceData = new Map, !g && !y && !x) return;
                const w = i.iconDependencies, A = i.glyphDependencies, E = i.availableImages, I = new Ls(this.zoom, {
                    worldview: this.worldview,
                    activeFloors: i.activeFloors
                }), M = (e1)=>{
                    const t1 = e1.id.toString();
                    w.has(t1) ? w.get(t1).push(e1) : w.set(t1, [
                        e1
                    ]);
                };
                for (const i of e1){
                    const { feature: e1, id: c, index: u, sourceLayerIndex: h } = i, d = o._featureFilter.needGeometry, p = Mc(e1, d);
                    if (!o._featureFilter.filter(I, p, n)) continue;
                    if (p.geometry = Ic(e1, p, d, n, r), s && 1 !== e1.type && n.z <= 5) {
                        const e1 = p.geometry, t1 = .98078528056, i = (e1, i)=>Z(tp(e1.x, e1.y, n, 1), tp(i.x, i.y, n, 1)) < t1;
                        for(let t1 = 0; t1 < e1.length; t1++)e1[t1] = vc(e1[t1], i);
                    }
                    let _, S;
                    if (g) {
                        const e1 = o.getValueAndResolveTokens("text-field", p, n, E), i = Nn.factory(e1), r = Om(i);
                        r && (this.hasRTLText = !0), r && !t1.fP || (_ = lf(i, o, p));
                    }
                    if (y) {
                        const e1 = o.getValueAndResolveTokens("icon-image", p, n, E);
                        S = this.getResolvedImageFromTokens(e1);
                    }
                    const T = this.layers[0];
                    let z = !1;
                    if (!S && x) {
                        const e1 = T.getAppearances();
                        for (const t1 of e1)if (t1.getLayoutProperty("icon-image")) {
                            const e1 = T.getAppearanceValueAndResolveTokens(t1, "icon-image", p, n, E);
                            if (e1) {
                                S = this.getResolvedImageFromTokens(e1), z = !0;
                                break;
                            }
                        }
                    }
                    if (!_ && !S) continue;
                    const R = this.sortFeaturesByKey ? b.evaluate(p, {}, n) : void 0, P = {
                        id: c,
                        text: _,
                        icon: S,
                        index: u,
                        sourceLayerIndex: h,
                        geometry: p.geometry,
                        properties: e1.properties,
                        type: wm[e1.type],
                        sortKey: R
                    };
                    if (this.features.push(P), v && this.featureAppearanceData.set(u, {
                        id: c,
                        properties: e1.properties,
                        usesAppearanceIconAsPlaceholder: z
                    }), S) {
                        const { iconPrimary: e1, iconSecondary: t1 } = Sf(S, this.iconSizeData, T.getLayoutPropertyValue("icon-size"), n, this.zoom, P, this.pixelRatio, f, this.worldview, E);
                        M(e1), t1 && (this.hasAnySecondaryIcon = !0, M(t1));
                    }
                    const D = T.getAppearances();
                    if (0 !== D.length && D.forEach((e1)=>{
                        if (!e1.getLayoutProperty("icon-image")) return;
                        const { iconPrimary: t1, iconSecondary: i } = this.getCombinedIconVariants(e1, T, p, n, E, P, f);
                        t1 && (M(t1), i && (this.hasAnySecondaryIcon = !0, M(i)));
                    }), _) {
                        const e1 = l.evaluate(p, {}, n).join(","), t1 = "map" === a.get("text-rotation-alignment") && "point" !== a.get("symbol-placement");
                        this.allowVerticalPlacement = this.writingModes && this.writingModes.includes(cf.vertical);
                        for (const i of _.sections)if (i.image) {
                            const e1 = i.image.getPrimary().scaleSelf(this.pixelRatio * m), t1 = e1.id.toString(), n = w.get(t1) || [];
                            n.push(e1), w.set(t1, n);
                        } else {
                            const n = zs(_.toString()), r = i.fontStack || e1, o = A[r] = A[r] || {};
                            this.calculateGlyphDependencies(i.text, o, t1, this.allowVerticalPlacement, n);
                        }
                    }
                }
                "line" === a.get("symbol-placement") && (this.features = function(e1) {
                    const t1 = {}, i = {}, n = [];
                    let r = 0;
                    function o(t1) {
                        n.push(e1[t1]), r++;
                    }
                    function a(e1, t1, r) {
                        const o = i[e1];
                        return delete i[e1], i[t1] = o, n[o].geometry[0].pop(), n[o].geometry[0] = n[o].geometry[0].concat(r[0]), o;
                    }
                    function s(e1, i, r) {
                        const o = t1[i];
                        return delete t1[i], t1[e1] = o, n[o].geometry[0].shift(), n[o].geometry[0] = r[0].concat(n[o].geometry[0]), o;
                    }
                    function l(e1, t1, i) {
                        const n = i ? t1[0].at(-1) : t1[0][0];
                        return `${e1}:${n.x}:${n.y}`;
                    }
                    for(let c = 0; c < e1.length; c++){
                        const u = e1[c], h = u.geometry, d = u.text ? u.text.toString() : null;
                        if (!d || h.length > 1) {
                            o(c);
                            continue;
                        }
                        const f = l(d, h, !1), p = l(d, h, !0);
                        if (f in i && p in t1 && i[f] !== t1[p]) {
                            const e1 = s(f, p, h), r = a(f, p, n[e1].geometry);
                            delete t1[f], delete i[p], i[l(d, n[r].geometry, !0)] = r, n[e1].geometry = null;
                        } else f in i ? a(f, p, h) : p in t1 ? s(f, p, h) : (o(c), t1[f] = r - 1, i[p] = r - 1);
                    }
                    return n.filter((e1)=>e1.geometry);
                }(this.features)), "hd-road-markup" === a.get("symbol-elevation-reference") ? (this.elevationType = "road", this.hdExt && (this.hdExt.configureCrossSource(n, i.elevationParams, i.crossSourceElevationEnabled, i.terrainEnabled), i.elevationFeatures && i.elevationFeatures.length > 0 && this.hdExt.addElevationFeatures(i.elevationFeatures, n))) : a.get("symbol-z-elevate") && (this.elevationType = "offset"), "none" !== this.elevationType && (this.zOffsetBuffersNeedUpload = !0), this.sortFeaturesByKey && this.features.sort((e1, t1)=>e1.sortKey - t1.sortKey);
            }
            getCombinedIconVariants(e1, t1, i, n, r, o, a) {
                let s;
                if (e1.hasLayoutProperty("icon-image")) {
                    const o = t1.getAppearanceValueAndResolveTokens(e1, "icon-image", i, n, r);
                    s = this.getResolvedImageFromTokens(o);
                } else {
                    const e1 = t1.getValueAndResolveTokens("icon-image", i, n, r);
                    s = this.getResolvedImageFromTokens(e1);
                }
                if (s) {
                    const i = e1.hasLayoutProperty("icon-size") ? e1.getUnevaluatedLayoutProperty("icon-size") : t1.getLayoutPropertyValue("icon-size"), l = gf(this.zoom, i, this.worldview, r), { iconPrimary: c, iconSecondary: u } = Sf(s, l, i, n, this.zoom, o, this.pixelRatio, a, this.worldview, r);
                    return {
                        iconPrimary: c,
                        iconSecondary: u
                    };
                }
                return {
                    iconPrimary: void 0,
                    iconSecondary: void 0
                };
            }
            getCombinedIconPrimary(e1, t1, i, n, r, o, a) {
                return this.getCombinedIconVariants(e1, t1, i, n, r, o, a).iconPrimary;
            }
            updateSymbolInstanceIconVertices(e1, t1, i, n, r, o) {
                const { canonical: a, availableImages: s, globalProperties: l, layer: c, iconScaleFactor: u, featureState: h, layoutIconOffset: d, layoutIconSize: f, layoutIconRotate: p, iconRotatesInTileSpace: _ } = o;
                if (e1.placedIconSymbolIndex < 0) return {
                    vertexOffsetDelta: 0,
                    hasChanges: !1
                };
                if (t1.activeAppearanceIndex === i) return {
                    vertexOffsetDelta: e1.numIconVertices,
                    hasChanges: !1
                };
                const m = i >= 0 ? c.appearances[i] : null;
                if (m) {
                    const i = {
                        sortKey: void 0,
                        text: void 0,
                        icon: null,
                        index: e1.featureIndex,
                        sourceLayerIndex: e1.featureIndex,
                        geometry: [],
                        properties: t1.properties,
                        type: "Point",
                        id: t1.id
                    }, { iconPrimary: o, iconSecondary: g } = this.getCombinedIconVariants(m, c, n, a, s, i, u);
                    if (!o) return {
                        vertexOffsetDelta: 0,
                        hasChanges: !1
                    };
                    const y = o.toString(), x = this.iconAtlasPositions && this.iconAtlasPositions.get(y);
                    if (x) {
                        const { appearanceIconOffset: i, appearanceIconRotate: o } = Ef(m, c, n, a, d, p, f, u), y = o + (_ ? Ap(this.getTileTransform(a), e1.tileAnchorX, e1.tileAnchorY) : 0), v = c.layout.get("icon-anchor").evaluate(n, h, a);
                        let b = hf(x, g ? this.iconAtlasPositions && this.iconAtlasPositions.get(g.toString()) : void 0, i, v);
                        const w = x.sdf, A = c.layout.get("icon-text-fit").constantOr("none");
                        "none" !== A && t1.textShaping && t1.iconTextFitPadding && t1.fontScale && (b = df(b, t1.textShaping, A, t1.iconTextFitPadding, i, t1.fontScale));
                        const E = this.calculateEffectiveAppearanceIconSize(m, l.zoom, n, a, s, u, f), I = 0, M = 1 + (Math.min(wf, Math.round(E * mf)) << 1), S = fm(b, y, w, "none" !== A, u), T = this.icon.iconTransitioningVertexArray.length > 0;
                        t1.isUsingAppearanceIconVertexData || (t1.isUsingAppearanceIconVertexData = !0, t1.layoutBasedIconVertexData = this.icon.snapshotSymbolVertexData(r, e1.numIconVertices), T && (t1.layoutBasedIconTransitioningVertexData = this.icon.snapshotIconTransitioningVertexData(r, e1.numIconVertices)));
                        const z = Math.floor(e1.numIconVertices / 4), R = Math.min(S.length, z);
                        let P = r;
                        const D = T ? this.icon.iconTransitioningVertexArray.uint16 : null;
                        for(let i = 0; i < R; ++i){
                            const n = S[i], r = t1.layoutBasedIconVertexData[0] || e1.tileAnchorX, o = t1.layoutBasedIconVertexData[1] || e1.tileAnchorY, a = 16 * n.pixelOffsetTL.x, s = 16 * n.pixelOffsetTL.y, l = 16 * n.pixelOffsetBR.x, c = 16 * n.pixelOffsetBR.y, u = 16 * n.minFontScaleX, h = 16 * n.minFontScaleY;
                            if (this.icon.updateSymbolVertexData(P, r, o, Math.round(32 * n.tl.x), Math.round(32 * n.tl.y), n.texPrimary.x, n.texPrimary.y, I, M, a, s, u, h), this.icon.updateSymbolVertexData(P + 1, r, o, Math.round(32 * n.tr.x), Math.round(32 * n.tr.y), n.texPrimary.x + n.texPrimary.w, n.texPrimary.y, I, M, l, s, u, h), this.icon.updateSymbolVertexData(P + 2, r, o, Math.round(32 * n.bl.x), Math.round(32 * n.bl.y), n.texPrimary.x, n.texPrimary.y + n.texPrimary.h, I, M, a, c, u, h), this.icon.updateSymbolVertexData(P + 3, r, o, Math.round(32 * n.br.x), Math.round(32 * n.br.y), n.texPrimary.x + n.texPrimary.w, n.texPrimary.y + n.texPrimary.h, I, M, l, c, u, h), D) {
                                const e1 = n.texSecondary ? n.texSecondary : n.texPrimary, t1 = 2 * P;
                                D[t1] = e1.x, D[t1 + 1] = e1.y, D[t1 + 2] = e1.x + e1.w, D[t1 + 3] = e1.y, D[t1 + 4] = e1.x, D[t1 + 5] = e1.y + e1.h, D[t1 + 6] = e1.x + e1.w, D[t1 + 7] = e1.y + e1.h;
                            }
                            P += 4;
                        }
                        const F = e1.numIconVertices - 4 * R;
                        for(let e1 = 0; e1 < F; ++e1)this.icon.updateSymbolVertexData(P + e1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                        return {
                            vertexOffsetDelta: e1.numIconVertices,
                            hasChanges: !0
                        };
                    }
                } else {
                    if (t1.usesAppearanceIconAsPlaceholder) return this.icon.updateSymbolVertexData(r, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0), this.icon.updateSymbolVertexData(r + 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0), this.icon.updateSymbolVertexData(r + 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0), this.icon.updateSymbolVertexData(r + 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0), {
                        vertexOffsetDelta: e1.numIconVertices,
                        hasChanges: !0
                    };
                    if (t1.isUsingAppearanceIconVertexData) return this.icon.restoreSymbolVertexData(r, t1.layoutBasedIconVertexData), t1.layoutBasedIconTransitioningVertexData && this.icon.restoreIconTransitioningVertexData(r, t1.layoutBasedIconTransitioningVertexData), t1.isUsingAppearanceIconVertexData = !1, {
                        vertexOffsetDelta: t1.layoutBasedIconVertexData.length / Lm,
                        hasChanges: !0
                    };
                }
                return {
                    vertexOffsetDelta: e1.numIconVertices,
                    hasChanges: !1
                };
            }
            updateSymbolInstanceTextVertices(e1, t1, i, n, r, o) {
                const { canonical: a, layer: s, textScaleFactor: l, imageMap: c, featureState: u, layoutTextOffset: h, layoutTextSize: d, layoutTextRotate: f, textRotatesInTileSpace: p, layoutMinZoomSize: _, layoutMaxZoomSize: m, layoutTextSizeMinZoom: g, layoutTextSizeMaxZoom: y, availableImages: x } = o, v = e1.numHorizontalGlyphVertices > 0 || e1.numVerticalGlyphVertices > 0;
                if (!v) return {
                    vertexOffsetDelta: v ? e1.numHorizontalGlyphVertices + e1.numVerticalGlyphVertices : 0,
                    hasChanges: !1
                };
                if (t1.activeAppearanceIndex === i) return {
                    vertexOffsetDelta: e1.numHorizontalGlyphVertices + e1.numVerticalGlyphVertices,
                    hasChanges: !1
                };
                const b = i >= 0 ? s.appearances[i] : null;
                if (b && t1.textShaping) {
                    const { appearanceTextOffset: i, appearanceTextRotate: o, appearanceTextSize: v } = If(b, s, n, a, h, f, d), w = o + (p ? Ap(this.getTileTransform(a), e1.tileAnchorX, e1.tileAnchorY) : 0);
                    t1.fontScale = function(e1, t1) {
                        return e1 * t1 / 24;
                    }(v, t1.textScaleFactor);
                    const A = b.getUnevaluatedLayoutProperty("text-size");
                    let E = this.textSizeData, I = g, M = y;
                    b.hasLayoutProperty("text-size") && (E = gf(this.zoom, A, this.worldview, x), I = "composite" === this.textSizeData.kind ? this.textSizeData.minZoom : 0, M = "composite" === this.textSizeData.kind ? this.textSizeData.maxZoom : 0);
                    const S = t1.textShaping.bottom - h[1], T = t1.textShaping.left - h[0], z = t1.textShaping.right - h[0];
                    t1.textShaping.top = i[1] + (t1.textShaping.top - h[1]), t1.textShaping.bottom = i[1] + S, t1.textShaping.left = i[0] + T, t1.textShaping.right = i[0] + z;
                    const R = vm(0, t1.textShaping, i, s, !1, n, c, this.allowVerticalPlacement, w), P = v && "composite" === E.kind ? A.possiblyEvaluate(new Ls(I, {}), a).evaluate(n, u, a) : _, D = v && "composite" === E.kind ? A.possiblyEvaluate(new Ls(M, {}), a).evaluate(n, u, a) : m, F = Tf(b.name, E, v, l, P, D), C = Array.isArray(F) ? F[1] : v, O = 0, L = 1 + (Math.min(wf, Math.round(C * mf)) << 1);
                    t1.isUsingAppearanceTextVertexData || (t1.isUsingAppearanceTextVertexData = !0, t1.layoutBasedTextVertexData = this.text.snapshotSymbolVertexData(r, e1.numHorizontalGlyphVertices + e1.numVerticalGlyphVertices));
                    for(let t1 = 0; t1 < R.length && t1 < (e1.numHorizontalGlyphVertices + e1.numVerticalGlyphVertices) / 4; ++t1){
                        const i = R[t1], n = i.glyphOffset[1], o = e1.tileAnchorX, a = e1.tileAnchorY, s = r + 4 * t1;
                        this.text.updateSymbolVertexData(s, o, a, Math.round(32 * i.tl.x), Math.round(32 * (n + i.tl.y)), i.texPrimary.x, i.texPrimary.y, O, L, i.pixelOffsetTL.x, i.pixelOffsetTL.y, i.minFontScaleX, i.minFontScaleY), this.text.updateSymbolVertexData(s + 1, o, a, Math.round(32 * i.tr.x), Math.round(32 * (n + i.tr.y)), i.texPrimary.x + i.texPrimary.w, i.texPrimary.y, O, L, i.pixelOffsetBR.x, i.pixelOffsetTL.y, i.minFontScaleX, i.minFontScaleY), this.text.updateSymbolVertexData(s + 2, o, a, Math.round(32 * i.bl.x), Math.round(32 * (n + i.bl.y)), i.texPrimary.x, i.texPrimary.y + i.texPrimary.h, O, L, i.pixelOffsetTL.x, i.pixelOffsetBR.y, i.minFontScaleX, i.minFontScaleY), this.text.updateSymbolVertexData(s + 3, o, a, Math.round(32 * i.br.x), Math.round(32 * (n + i.br.y)), i.texPrimary.x + i.texPrimary.w, i.texPrimary.y + i.texPrimary.h, O, L, i.pixelOffsetBR.x, i.pixelOffsetBR.y, i.minFontScaleX, i.minFontScaleY);
                    }
                    return {
                        vertexOffsetDelta: e1.numHorizontalGlyphVertices + e1.numVerticalGlyphVertices,
                        hasChanges: !0
                    };
                }
                return t1.isUsingAppearanceTextVertexData ? (this.text.restoreSymbolVertexData(r, t1.layoutBasedTextVertexData), t1.isUsingAppearanceTextVertexData = !1, {
                    vertexOffsetDelta: t1.layoutBasedTextVertexData.length / Lm,
                    hasChanges: !0
                }) : {
                    vertexOffsetDelta: e1.numHorizontalGlyphVertices + e1.numVerticalGlyphVertices,
                    hasChanges: !1
                };
            }
            updateExpressions(e1) {
                this.text && this.text.programConfigurations.updateExpressions(e1), this.icon && this.icon.programConfigurations.updateExpressions(e1);
            }
            update(e1, t1, i, n, r, o, a, s) {
                if (this.text.uboBinder || this.text.programConfigurations.updatePaintArrays(e1, t1, r, i, n, o, a, this.worldview), this.icon.uboBinder || this.icon.programConfigurations.updatePaintArrays(e1, t1, r, i, n, o, a, this.worldview), s) {
                    if (o) for (const n of [
                        this.text.uboBinder,
                        this.icon.uboBinder
                    ])n && n.hasLightDependentBlocks(r[0]) && n.updateDynamicExpressions(r[0], t1, s, i, e1, a);
                    else if (Object.keys(e1).length > 0) {
                        const n = r[0], o = [
                            this.text.uboBinder,
                            this.icon.uboBinder
                        ].filter((e1)=>e1 && e1.hasStateDependentPaint(n));
                        if (o.length > 0) {
                            const r = new Set(Object.keys(e1).map((e1)=>{
                                const t1 = Number(e1);
                                return !isNaN(t1) && Number.isSafeInteger(t1) && String(t1) === e1 ? t1 : e1;
                            }));
                            for (const l of o)l.updateFeatures(r, n, t1, s, i, e1, a);
                        }
                    }
                }
            }
            updateZOffset() {
                if (!this.zOffsetBuffersNeedUpload) return;
                this.zOffsetBuffersNeedUpload = !1;
                const e1 = this.text.zOffsetVertexBuffer ? Um : this.text.zOffsetVertexArray, t1 = this.icon.zOffsetVertexBuffer ? jm : this.icon.zOffsetVertexArray;
                e1.clear(), t1.clear();
                for(let i = 0; i < this.symbolInstances.length; i++){
                    const n = this.symbolInstances.get(i), r = n.zOffset;
                    Gm(e1, n.numHorizontalGlyphVertices, r), Gm(e1, n.numVerticalGlyphVertices, r), n.numIconVertices > 0 && (n.placedIconSymbolIndex >= 0 && Gm(t1, n.numIconVertices, r), n.verticalPlacedIconSymbolIndex >= 0 && Gm(t1, n.numVerticalIconVertices, r));
                }
                this.text.zOffsetVertexBuffer && this.text.zOffsetVertexBuffer.updateData(e1), this.icon.zOffsetVertexBuffer && this.icon.zOffsetVertexBuffer.updateData(t1);
            }
            isEmpty() {
                return 0 === this.symbolInstances.length;
            }
            uploadPending() {
                return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
            }
            upload(e1, t1, i, n, r) {
                !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(e1), this.iconCollisionBox.upload(e1)), this.text.upload(e1, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload, this.zOffsetBuffersNeedUpload, this.hasAppearances), null === this.hasAppearances && (this.hasAppearances = this.layers.some((e1)=>e1.appearances && e1.appearances.length > 0)), this.icon.upload(e1, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload, this.zOffsetBuffersNeedUpload, this.hasAppearances), this.uploaded = !0;
            }
            updateAppearances(e1, t1, i, n, r, o = !1) {
                const a = {
                    hasLayoutChanges: !1,
                    hasUboChanges: !1
                };
                if (!e1 || !i || !this.featureAppearanceData) return a;
                const s = t1 || {}, l = this.icon.layoutVertexArray && this.icon.layoutVertexArray.length > 0 && this.icon.layoutVertexArray.arrayBuffer, c = this.text.layoutVertexArray && this.text.layoutVertexArray.length > 0 && this.text.layoutVertexArray.arrayBuffer;
                if (!l && !c) return a;
                const u = this.layers[0], h = u.layout;
                this.featureAppearances && this.featureAppearances.appearancesVersion === u.appearancesVersion || (this.featureAppearances = new bm(u.appearances, u.appearancesVersion));
                const d = this.featureAppearances.update(n, o);
                if ("no-changes" === d.kind) return a;
                let f = 1, p = 0, _ = !1, m = !1;
                if (l) {
                    const [e1, t1] = h.get("icon-size-scale-range");
                    f = tt(1, e1, t1);
                }
                const g = l && zf(u, "icon");
                let y = 1, x = 0, v = !1;
                if (c) {
                    const [e1, t1] = h.get("text-size-scale-range");
                    y = tt(1, e1, t1);
                }
                const b = c && zf(u, "text"), w = new Map;
                if (r && i) for (const e1 of i){
                    const t1 = r.getImage(e1, u.scope);
                    if (t1) {
                        const i = new kn(e1.toString());
                        w.set(i.toString(), t1);
                    }
                }
                const A = [
                    this.text.uboBinder,
                    this.icon.uboBinder
                ];
                for(let t1 = 0; t1 < this.symbolInstances.length; t1++){
                    const r = this.symbolInstances.get(t1), o = this.getAppearanceFeatureData(r.featureIndex);
                    if (!o) continue;
                    const a = o.id, E = void 0 !== a ? s[String(a)] : void 0, I = {
                        type: "Point",
                        id: o.id,
                        properties: o.properties,
                        geometry: []
                    };
                    let M;
                    if ("all-features" === d.kind) M = d.appearanceIndex;
                    else {
                        const t1 = u.appearances ? u.appearances.findIndex((t1)=>t1.isActive({
                                globals: n,
                                feature: I,
                                canonical: e1,
                                featureState: E
                            })) : -1;
                        M = t1 >= 0 ? t1 : -1;
                    }
                    const S = o.activeAppearanceIndex !== M;
                    if (c) {
                        const t1 = h.get("text-size"), n = "composite" === this.textSizeData.kind ? this.textSizeData.minZoom : 0, a = "composite" === this.textSizeData.kind ? this.textSizeData.maxZoom : 0, s = {
                            canonical: e1,
                            layer: u,
                            featureState: E,
                            availableImages: i,
                            textScaleFactor: y,
                            imageMap: w,
                            layoutTextOffset: h.get("text-offset").evaluate(I, E, e1).map((e1)=>e1 * af),
                            layoutTextSize: t1.evaluate(I, E, e1),
                            layoutTextRotate: h.get("text-rotate").evaluate(I, E, e1),
                            textRotatesInTileSpace: b,
                            layoutMinZoomSize: t1.evaluate(I, {
                                zoom: n
                            }, e1),
                            layoutMaxZoomSize: t1.evaluate(I, {
                                zoom: a
                            }, e1),
                            layoutTextSizeMinZoom: n,
                            layoutTextSizeMaxZoom: a
                        }, l = this.updateSymbolInstanceTextVertices(r, o, M, I, x, s);
                        x += l.vertexOffsetDelta, v = v || l.hasChanges;
                    }
                    if (l) {
                        const t1 = {
                            canonical: e1,
                            layer: u,
                            featureState: E,
                            availableImages: i,
                            globalProperties: n,
                            iconScaleFactor: f,
                            layoutIconOffset: h.get("icon-offset").evaluate(I, E, e1),
                            layoutIconSize: h.get("icon-size").evaluate(I, E, e1, i),
                            layoutIconRotate: h.get("icon-rotate").evaluate(I, E, e1),
                            iconRotatesInTileSpace: g
                        }, a = this.updateSymbolInstanceIconVertices(r, o, M, I, p, t1);
                        p += a.vertexOffsetDelta, _ = _ || a.hasChanges;
                    }
                    if (S) {
                        const t1 = r.featureIndex, o = n ? n.brightness : null, a = E || {}, s = M >= 0 ? u.appearances[M] : null;
                        for (const n of A)n && (n.layer = u, m = n.updateFeaturePaintForAppearance(t1, I, a, e1, i, o, s) || m);
                    }
                    o.activeAppearanceIndex = M;
                }
                return _ && this.icon.layoutVertexBuffer && null !== this.icon.layoutVertexArray.arrayBuffer && this.icon.layoutVertexArray.length === this.icon.layoutVertexBuffer.length && this.icon.layoutVertexBuffer.updateData(this.icon.layoutVertexArray), _ && this.icon.iconTransitioningVertexBuffer && this.icon.iconTransitioningVertexArray.length > 0 && this.icon.iconTransitioningVertexArray.length === this.icon.iconTransitioningVertexBuffer.length && this.icon.iconTransitioningVertexBuffer.updateData(this.icon.iconTransitioningVertexArray), v && this.text.layoutVertexBuffer && null !== this.text.layoutVertexArray.arrayBuffer && this.text.layoutVertexArray.length === this.text.layoutVertexBuffer.length && this.text.layoutVertexBuffer.updateData(this.text.layoutVertexArray), {
                    hasLayoutChanges: _ || v,
                    hasUboChanges: m
                };
            }
            destroyDebugData() {
                this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
            }
            getProjection() {
                return this.projectionInstance || (this.projectionInstance = Zp(this.projection)), this.projectionInstance;
            }
            getTileTransform(e1) {
                return this.tileTransformInstance || (this.tileTransformInstance = wp(e1, this.getProjection())), this.tileTransformInstance;
            }
            destroy() {
                this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
            }
            addToLineVertexArray(e1, t1) {
                const i = this.lineVertexArray.length;
                if (void 0 !== e1.segment) for (const { x: e1, y: i } of t1)this.lineVertexArray.emplaceBack(e1, i);
                return {
                    lineStartIndex: i,
                    lineLength: this.lineVertexArray.length - i
                };
            }
            addSymbols(e1, t1, i, n, r, o, a, s, l, c, u, h, d, f, p, _, m, g) {
                const y = e1.indexArray, x = e1.layoutVertexArray, v = e1.globeExtVertexArray, b = g, w = e1.uboBinder ? e1.uboBinder.getCurrentBatchIndex() : void 0, A = e1.segments.prepareSegment(4 * b, x, y, this.canOverlap ? o.sortKey : void 0, w), E = this.glyphOffsetArray.length, I = A.vertexLength, M = this.allowVerticalPlacement && a === cf.vertical ? Math.PI / 2 : 0, S = o.text && o.text.sections;
                let T = x.length, z = -1;
                for(let n = 0; n < t1.length; n++){
                    const { tl: r, tr: a, bl: c, br: u, texPrimary: h, texSecondary: m, pixelOffsetTL: g, pixelOffsetBR: b, minFontScaleX: w, minFontScaleY: E, glyphOffset: I, isSDF: R, sectionIndex: P } = t1[n], D = A.vertexLength, F = I[1];
                    if (Rm(x, l.x, l.y, r.x, F + r.y, h.x, h.y, i, R, g.x, g.y, w, E), Rm(x, l.x, l.y, a.x, F + a.y, h.x + h.w, h.y, i, R, b.x, g.y, w, E), Rm(x, l.x, l.y, c.x, F + c.y, h.x, h.y + h.h, i, R, g.x, b.y, w, E), Rm(x, l.x, l.y, u.x, F + u.y, h.x + h.w, h.y + h.h, i, R, b.x, b.y, w, E), s) {
                        const { x: t1, y: i, z: n } = s.anchor, [r, o, a] = s.up;
                        Dm(v, t1, i, n, r, o, a), Dm(v, t1, i, n, r, o, a), Dm(v, t1, i, n, r, o, a), Dm(v, t1, i, n, r, o, a), Cm(e1.dynamicLayoutVertexArray, t1, i, n, M);
                    } else Cm(e1.dynamicLayoutVertexArray, l.x, l.y, l.z, M);
                    if (_) {
                        const t1 = m || h;
                        Pm(e1.iconTransitioningVertexArray, t1.x, t1.y), Pm(e1.iconTransitioningVertexArray, t1.x + t1.w, t1.y), Pm(e1.iconTransitioningVertexArray, t1.x, t1.y + t1.h), Pm(e1.iconTransitioningVertexArray, t1.x + t1.w, t1.y + t1.h);
                    }
                    if (y.emplaceBack(D, D + 1, D + 2), y.emplaceBack(D + 1, D + 2, D + 3), A.vertexLength += 4, A.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(I[0]), (n === t1.length - 1 || P !== t1[n + 1].sectionIndex) && (e1.uboBinder || e1.programConfigurations.populatePaintArrays(x.length, o, o.index, {}, d, f, p, S && S[P], this.worldview), e1.uboBinder)) {
                        const t1 = e1.uboBinder.populateUBO(o, o.index, f, d, p, S && S[P]);
                        z = t1;
                        const i = x.length - T;
                        for(let n = 0; n < i; n++)e1.featureIdArray.emplaceBack(t1);
                        T = x.length;
                    }
                }
                const R = g - t1.length;
                if (0 !== R && (this._addNullVertices(R, x, i, s, v, e1, _, A, y), e1.uboBinder && z >= 0)) {
                    const t1 = 4 * R;
                    for(let i = 0; i < t1; i++)e1.featureIdArray.emplaceBack(z);
                }
                const P = s ? s.anchor : l;
                e1.placedSymbolArray.emplaceBack(P.x, P.y, P.z, l.x, l.y, E, this.glyphOffsetArray.length - E, I, c, u, l.segment, i ? i[0] : 0, i ? i[1] : 0, n[0], n[1], a, 0, 0, 0, h, 0), e1.symbolInstanceIndices.push(m);
            }
            _addNullVertices(e1, t1, i, n, r, o, a, s, l) {
                for(let c = 0; c < e1; c++){
                    for(let e1 = 0; e1 < 4; e1++)Rm(t1, 0, 0, 0, 0, 0, 0, i, !1, 0, 0, 0, 0), n ? (Dm(r, 0, 0, 0, 0, 0, 0), Cm(o.dynamicLayoutVertexArray, 0, 0, 0, 0)) : Cm(o.dynamicLayoutVertexArray, 0, 0, 0, 0), a && Pm(o.iconTransitioningVertexArray, 0, 0);
                    const e1 = s.vertexLength;
                    l.emplaceBack(e1, e1 + 1, e1 + 2), l.emplaceBack(e1 + 1, e1 + 2, e1 + 3), s.vertexLength += 4, s.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(0);
                }
            }
            _commitLayoutVertex(e1, t1, i, n, r, o, a) {
                e1.emplaceBack(t1, i, n, r, o, Math.round(a.x), Math.round(a.y));
            }
            _addCollisionDebugVertices(e1, t1, i, n, r, o, a) {
                const s = i.segments.prepareSegment(4, i.layoutVertexArray, i.indexArray), l = s.vertexLength, c = a.tileAnchorX, u = a.tileAnchorY;
                for(let e1 = 0; e1 < 4; e1++)i.collisionVertexArray.emplaceBack(0, 0, 0, 0, 0, 0);
                this._commitDebugCollisionVertexUpdate(i.collisionVertexArrayExt, t1, e1.padding, a.zOffset), this._commitLayoutVertex(i.layoutVertexArray, n, r, o, c, u, new Re(e1.x1, e1.y1)), this._commitLayoutVertex(i.layoutVertexArray, n, r, o, c, u, new Re(e1.x2, e1.y1)), this._commitLayoutVertex(i.layoutVertexArray, n, r, o, c, u, new Re(e1.x2, e1.y2)), this._commitLayoutVertex(i.layoutVertexArray, n, r, o, c, u, new Re(e1.x1, e1.y2)), s.vertexLength += 4;
                const h = i.indexArray;
                h.emplaceBack(l, l + 1), h.emplaceBack(l + 1, l + 2), h.emplaceBack(l + 2, l + 3), h.emplaceBack(l + 3, l), s.primitiveLength += 4;
            }
            _addTextDebugCollisionBoxes(e1, t1, i, n, r, o) {
                for(let a = n; a < r; a++){
                    const n = i.get(a), r = this.getSymbolInstanceTextSize(e1, o, t1, a);
                    this._addCollisionDebugVertices(n, r, this.textCollisionBox, n.projectedAnchorX, n.projectedAnchorY, n.projectedAnchorZ, o);
                }
            }
            _addIconDebugCollisionBoxes(e1, t1, i, n, r, o) {
                for(let a = n; a < r; a++){
                    const n = i.get(a), r = this.getSymbolInstanceIconSize(e1, t1, o.placedIconSymbolIndex);
                    this._addCollisionDebugVertices(n, r, this.iconCollisionBox, n.projectedAnchorX, n.projectedAnchorY, n.projectedAnchorZ, o);
                }
            }
            generateCollisionDebugBuffers(e1, t1, i) {
                this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new $m(Qc, Xd.members, Jc), this.iconCollisionBox = new $m(Qc, Xd.members, Jc);
                const n = xf(this.iconSizeData, e1), r = xf(this.textSizeData, e1, i);
                for(let i = 0; i < this.symbolInstances.length; i++){
                    const o = this.symbolInstances.get(i);
                    this._addTextDebugCollisionBoxes(r, e1, t1, o.textBoxStartIndex, o.textBoxEndIndex, o), this._addTextDebugCollisionBoxes(r, e1, t1, o.verticalTextBoxStartIndex, o.verticalTextBoxEndIndex, o), this._addIconDebugCollisionBoxes(n, e1, t1, o.iconBoxStartIndex, o.iconBoxEndIndex, o), this._addIconDebugCollisionBoxes(n, e1, t1, o.verticalIconBoxStartIndex, o.verticalIconBoxEndIndex, o);
                }
            }
            defaultPlacedTextSymbolIndex(e1, t1) {
                return e1.rightJustifiedTextSymbolIndex >= 0 ? e1.rightJustifiedTextSymbolIndex : e1.centerJustifiedTextSymbolIndex >= 0 ? e1.centerJustifiedTextSymbolIndex : e1.leftJustifiedTextSymbolIndex >= 0 ? e1.leftJustifiedTextSymbolIndex : e1.verticalPlacedTextSymbolIndex >= 0 ? e1.verticalPlacedTextSymbolIndex : -1;
            }
            getSymbolInstanceTextSize(e1, t1, i, n) {
                const r = this.defaultPlacedTextSymbolIndex(t1, n), o = this.text.placedSymbolArray.get(r), a = yf(this.textSizeData, e1, o) / af;
                return this.tilePixelRatio * a;
            }
            getSymbolInstanceIconSize(e1, t1, i) {
                const n = this.icon.placedSymbolArray.get(i), r = yf(this.iconSizeData, e1, n);
                return this.tilePixelRatio * r;
            }
            _commitDebugCollisionVertexUpdate(e1, t1, i, n) {
                e1.emplaceBack(t1, -i, -i, n), e1.emplaceBack(t1, i, -i, n), e1.emplaceBack(t1, i, i, n), e1.emplaceBack(t1, -i, i, n);
            }
            _updateTextDebugCollisionBoxes(e1, t1, i, n, r, o, a) {
                for(let a = n; a < r; a++){
                    const n = i.get(a), r = this.getSymbolInstanceTextSize(e1, o, t1, a);
                    this._commitDebugCollisionVertexUpdate(this.textCollisionBox.collisionVertexArrayExt, r, n.padding, o.zOffset);
                }
            }
            _updateIconDebugCollisionBoxes(e1, t1, i, n, r, o, a) {
                for(let a = n; a < r; a++){
                    const n = i.get(a), r = this.getSymbolInstanceIconSize(e1, t1, o.placedIconSymbolIndex);
                    this._commitDebugCollisionVertexUpdate(this.iconCollisionBox.collisionVertexArrayExt, r, n.padding, o.zOffset);
                }
            }
            updateCollisionDebugBuffers(e1, t1, i, n) {
                if (!this.hasDebugData()) return;
                this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexArrayExt.clear(), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexArrayExt.clear();
                const r = xf(this.iconSizeData, e1, n), o = xf(this.textSizeData, e1, i);
                for(let a = 0; a < this.symbolInstances.length; a++){
                    const s = this.symbolInstances.get(a);
                    this._updateTextDebugCollisionBoxes(o, e1, t1, s.textBoxStartIndex, s.textBoxEndIndex, s, i), this._updateTextDebugCollisionBoxes(o, e1, t1, s.verticalTextBoxStartIndex, s.verticalTextBoxEndIndex, s, i), this._updateIconDebugCollisionBoxes(r, e1, t1, s.iconBoxStartIndex, s.iconBoxEndIndex, s, n), this._updateIconDebugCollisionBoxes(r, e1, t1, s.verticalIconBoxStartIndex, s.verticalIconBoxEndIndex, s, n);
                }
                this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexBufferExt && this.textCollisionBox.collisionVertexBufferExt.updateData(this.textCollisionBox.collisionVertexArrayExt), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexBufferExt && this.iconCollisionBox.collisionVertexBufferExt.updateData(this.iconCollisionBox.collisionVertexArrayExt);
            }
            getCollisionArrays(e1, t1) {
                const i = Sm, n = t1.textBoxStartIndex < t1.textBoxEndIndex, r = t1.verticalTextBoxStartIndex < t1.verticalTextBoxEndIndex, o = t1.iconBoxStartIndex < t1.iconBoxEndIndex, a = t1.verticalIconBoxStartIndex < t1.verticalIconBoxEndIndex;
                return i.textBox = n ? Am : void 0, i.verticalTextBox = r ? Em : void 0, i.iconBox = o ? Im : void 0, i.verticalIconBox = a ? Mm : void 0, i.textFeatureIndex = n ? Tm(e1, t1.textBoxStartIndex, Am) : void 0, i.verticalTextFeatureIndex = r ? Tm(e1, t1.verticalTextBoxStartIndex, Em) : void 0, i.iconFeatureIndex = o ? Tm(e1, t1.iconBoxStartIndex, Im) : void 0, i.verticalIconFeatureIndex = a ? Tm(e1, t1.verticalIconBoxStartIndex, Mm) : void 0, i;
            }
            hasTextData() {
                return this.text.segments.get().length > 0;
            }
            hasIconData() {
                return this.icon.segments.get().length > 0;
            }
            hasDebugData() {
                return this.textCollisionBox && this.iconCollisionBox;
            }
            hasTextCollisionBoxData() {
                return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
            }
            hasIconCollisionBoxData() {
                return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
            }
            hasIconTextFit() {
                return this.hasAnyIconTextFit;
            }
            addIndicesForPlacedSymbol(e1, t1) {
                const i = e1.placedSymbolArray.get(t1), n = i.vertexStartIndex + 4 * i.numGlyphs;
                for(let t1 = i.vertexStartIndex; t1 < n; t1 += 4)e1.indexArray.emplaceBack(t1, t1 + 1, t1 + 2), e1.indexArray.emplaceBack(t1 + 1, t1 + 2, t1 + 3);
            }
            getSortedSymbolIndexes(e1) {
                if (this.sortedAngle === e1 && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
                const t1 = Math.sin(e1), i = Math.cos(e1), n = [], r = [], o = [];
                for(let e1 = 0; e1 < this.symbolInstances.length; ++e1){
                    o.push(e1);
                    const a = this.symbolInstances.get(e1);
                    n.push(0 | Math.round(t1 * a.tileAnchorX + i * a.tileAnchorY)), r.push(a.featureIndex);
                }
                return o.sort((e1, t1)=>n[e1] - n[t1] || r[t1] - r[e1]), o;
            }
            getSortedIndexesByZOffset() {
                if (!this.zOffsetSortDirty) return this.symbolInstanceIndexesSortedZOffset;
                if (!this.symbolInstanceIndexesSortedZOffset) {
                    this.symbolInstanceIndexesSortedZOffset = [];
                    for(let e1 = 0; e1 < this.symbolInstances.length; ++e1)this.symbolInstanceIndexesSortedZOffset.push(e1);
                }
                return this.zOffsetSortDirty = !1, this.symbolInstanceIndexesSortedZOffset.sort((e1, t1)=>this.symbolInstances.get(t1).zOffset - this.symbolInstances.get(e1).zOffset);
            }
            addToSortKeyRanges(e1, t1) {
                const i = this.sortKeyRanges.at(-1);
                i && i.sortKey === t1 ? i.symbolInstanceEnd = e1 + 1 : this.sortKeyRanges.push({
                    sortKey: t1,
                    symbolInstanceStart: e1,
                    symbolInstanceEnd: e1 + 1
                });
            }
            sortFeatures(e1) {
                if (this.sortFeaturesByY && this.sortedAngle !== e1) {
                    if (this.text.segments.get().length > 1 || this.icon.segments.get().length > 1) this.sortFeaturesByY = !1;
                    else {
                        this.symbolInstanceIndexes = this.getSortedSymbolIndexes(e1), this.sortedAngle = e1, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                        for (const e1 of this.symbolInstanceIndexes){
                            const t1 = this.symbolInstances.get(e1);
                            this.featureSortOrder.push(t1.featureIndex);
                            const { rightJustifiedTextSymbolIndex: i, centerJustifiedTextSymbolIndex: n, leftJustifiedTextSymbolIndex: r, verticalPlacedTextSymbolIndex: o, placedIconSymbolIndex: a, verticalPlacedIconSymbolIndex: s } = t1;
                            i >= 0 && this.addIndicesForPlacedSymbol(this.text, i), n >= 0 && n !== i && this.addIndicesForPlacedSymbol(this.text, n), r >= 0 && r !== n && r !== i && this.addIndicesForPlacedSymbol(this.text, r), o >= 0 && this.addIndicesForPlacedSymbol(this.text, o), a >= 0 && this.addIndicesForPlacedSymbol(this.icon, a), s >= 0 && this.addIndicesForPlacedSymbol(this.icon, s);
                        }
                        this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                    }
                }
            }
        }
        Zm.maxBucketInstanceId = 0, Ya(Zm, "SymbolBucket", {
            omit: [
                "layers",
                "collisionBoxArray",
                "compareText",
                "features",
                "projectionInstance",
                "tileTransformInstance"
            ]
        }), Zm.addDynamicAttributes = Cm;
        class Wm extends _h {
            constructor(e1, t1, i){
                super(e1, t1, i), this.elevatedLayoutVertexArray = new Lc;
            }
            upload(e1) {
                const t1 = this.uploaded;
                super.upload(e1), !t1 && this.elevatedLayoutVertexArray.length > 0 && (this.elevatedLayoutVertexBuffer = e1.createVertexBuffer(this.elevatedLayoutVertexArray, Du.members));
            }
            destroy() {
                this.elevatedLayoutVertexBuffer && this.elevatedLayoutVertexBuffer.destroy(), super.destroy();
            }
        }
        Ya(Wm, "ElevatedFillBufferData");
        class qm {
            constructor(){
                this.portals = [];
            }
            static isOnBorder(e1, t1) {
                return e1 <= 0 && t1 <= 0 || e1 >= Sr && t1 >= Sr;
            }
            static evaluate(e1) {
                if (0 === e1.length) return new qm;
                let t1 = [];
                for (const i of e1)t1.push(...i.portals);
                if (0 === t1.length) return new qm;
                for (const e1 of t1){
                    const t1 = e1.va, i = e1.vb;
                    (qm.isOnBorder(t1.x, i.x) || qm.isOnBorder(t1.y, i.y)) && (e1.type = "border");
                }
                const i = t1.filter((e1)=>"unevaluated" !== e1.type), n = t1.filter((e1)=>"unevaluated" === e1.type);
                if (0 === n.length) return new qm;
                n.sort((e1, t1)=>e1.hash === t1.hash ? e1.isTunnel === t1.isTunnel ? 0 : e1.isTunnel ? -1 : 1 : e1.hash < t1.hash ? 1 : -1), t1 = i.concat(n);
                let r = i.length, o = r, a = r;
                do if (o++, o === t1.length || t1[r].hash !== t1[o].hash) {
                    if (o - r === 2) {
                        a < r && (t1[a] = t1[r], t1[r] = null);
                        const e1 = t1[a], i = t1[o - 1];
                        e1.type = e1.isTunnel !== i.isTunnel ? "tunnel" : "polygon", e1.connection = {
                            a: e1.connection.a,
                            b: i.connection.a
                        }, a++;
                    }
                    r = o;
                }
                while (r !== t1.length);
                return t1.splice(a), t1.sort((e1, t1)=>e1.hash < t1.hash ? 1 : -1), {
                    portals: t1
                };
            }
        }
        Ya(qm, "ElevationPortalGraph");
        const Xm = 8195;
        class Ym {
            constructor(e1, t1, i){
                this.outPositions = e1, this.outNormals = t1, this.outIndices = i, this.vertexLookup = new Map;
            }
            addVertex(e1, t1, i) {
                let n = e1[2];
                null != i && (n *= i);
                const r = `${e1[0]},${e1[1]},${e1[2]},${t1[0]},${t1[1]},${t1[2]}`, o = this.vertexLookup.get(r);
                if (null != o) return o;
                const a = this.outPositions.length;
                this.vertexLookup.set(r, a);
                const s = Math.trunc(16384 * t1[0]), l = Math.trunc(16384 * t1[1]), c = Math.trunc(16384 * t1[2]);
                return this.outPositions.emplaceBack(e1[0], e1[1], n), this.outNormals.emplaceBack(s, l, c), a;
            }
            addTriangle(e1, t1, i) {
                this.outIndices.emplaceBack(e1, t1, i);
            }
            addTriangles(e1, t1, i, n = 0) {
                if (0 === e1.length) return;
                const r = R(), o = R();
                for(let a = 0; a < e1.length; a += 3){
                    const s = t1[e1[a + 0]], l = t1[e1[a + 1]], c = t1[e1[a + 2]], u = i[e1[a + 1]] + n, h = i[e1[a + 2]] + n;
                    F(r, s.x, s.y, i[e1[a + 0]] + n);
                    const d = this.addVertex(r, o);
                    F(r, l.x, l.y, u);
                    const f = this.addVertex(r, o);
                    F(r, c.x, c.y, h);
                    const p = this.addVertex(r, o);
                    this.outIndices.emplaceBack(d, f, p);
                }
            }
            addQuad(e1, t1, i, n, r, o) {
                const a = this.addVertex(e1, r, o), s = this.addVertex(t1, r, o), l = this.addVertex(i, r, o), c = this.addVertex(n, r, o);
                this.addTriangle(a, s, l), this.addTriangle(l, c, a);
            }
            getVertexCount() {
                return this.outPositions.length;
            }
            clearVertexLookup() {
                this.vertexLookup.clear();
            }
        }
        class Jm {
            constructor(e1, t1, i, n){
                this.unevaluatedPortals = new qm, this.bridgeFeatureSections = [], this.tunnelFeatureSections = [], this.vertexHashLookup = new Map, this.unevalVertices = [], this.unevalHeights = [], this.unevalTriangles = [], this.unevalTunnelTriangles = [], this.unevalEdges = [], this.vertexPositions = new Bc, this.vertexNormals = new Vc, this.indexArray = new nu, this.tileToMeters = _c(e1), this.bridgeProgramConfigurations = new ch(t1, {
                    zoom: i,
                    lut: n
                }, (e1)=>"fill-tunnel-structure-color" !== e1), this.tunnelProgramConfigurations = new ch(t1, {
                    zoom: i,
                    lut: n
                }, (e1)=>"fill-bridge-guard-rail-color" !== e1);
            }
            addVertices(e1, t1) {
                const i = this.unevalVertices.length;
                for(let i = 0; i < e1.length; i++)this.unevalVertices.push(e1[i]), this.unevalHeights.push(t1[i]);
                return i;
            }
            addTriangles(e1, t1, i) {
                const n = i ? this.unevalTunnelTriangles : this.unevalTriangles;
                for (const i of e1)n.push(i + t1);
            }
            addRenderableRing(e1, t1, i, n, r, o) {
                const a = [
                    new Re(r.min.x, r.min.y),
                    new Re(r.max.x, r.min.y),
                    new Re(r.max.x, r.max.y),
                    new Re(r.min.x, r.max.y)
                ];
                for(let s = 0; s < i - 1; s++){
                    const i = t1 + s, l = i + 1, c = this.unevalVertices[i], u = this.unevalVertices[l];
                    if (!(c.x >= r.min.x && c.x <= r.max.x && c.y >= r.min.y && c.y <= r.max.y || u.x >= r.min.x && u.x <= r.max.x && u.y >= r.min.y && u.y <= r.max.y || hd(c, u, a))) continue;
                    if (this.isOnBorder(c.x, u.x) || this.isOnBorder(c.y, u.y)) continue;
                    const h = Jm.computeEdgeHash(this.unevalVertices[i], this.unevalVertices[l]);
                    let d, f = this.vertexHashLookup.get(Jm.computePosHash(c));
                    null != f ? d = f.next : (f = this.vertexHashLookup.get(Jm.computePosHash(u)), d = null != f ? f.prev : h), this.unevalEdges.push({
                        polygonIdx: e1,
                        a: i,
                        b: l,
                        hash: h,
                        portalHash: d,
                        isTunnel: n,
                        type: "unevaluated",
                        featureInfo: o
                    });
                }
            }
            addPortalCandidates(e1, t1, i, n, r) {
                if (0 !== t1.length) {
                    this.vertexHashLookup.clear();
                    for (const r of t1){
                        if (0 === r.length) continue;
                        const t1 = r[0];
                        let o = Jm.computeEdgeHash(t1[t1.length - 2], t1.at(-1));
                        for(let r = 0; r < t1.length - 1; r++){
                            const a = t1[r + 0], s = t1[r + 1], l = ve(s.x - a.x, s.y - a.y), c = Ie(l);
                            if (0 === c) continue;
                            let u = "unevaluated";
                            const h = n.pointElevation(a), d = n.pointElevation(s);
                            Math.abs(h) < .01 && Math.abs(d) < .01 ? u = "entrance" : (this.isOnBorder(a.x, s.x) || this.isOnBorder(a.y, s.y)) && (u = "border");
                            const f = Jm.computeEdgeHash(a, s);
                            this.unevaluatedPortals.portals.push({
                                connection: {
                                    a: e1,
                                    b: void 0
                                },
                                va: a,
                                vb: s,
                                vab: l,
                                length: c,
                                hash: f,
                                isTunnel: i,
                                type: u
                            });
                            const p = Jm.computePosHash(a);
                            this.vertexHashLookup.has(p) || this.vertexHashLookup.set(p, {
                                prev: o,
                                next: f
                            }), o = f;
                        }
                    }
                }
            }
            construct(e1) {
                if (0 === this.unevalVertices.length) return;
                const t1 = ()=>({
                        vertexOffset: 0,
                        primitiveOffset: this.indexArray.length
                    }), i = (e1)=>{
                    e1.primitiveLength = this.indexArray.length - e1.primitiveOffset;
                }, n = new Ym(this.vertexPositions, this.vertexNormals, this.indexArray);
                this.prepareEdges(e1.portals, this.unevalEdges);
                const r = t1(), o = t1(), a = t1(), s = (e1, t1)=>{
                    e1.sort((e1, i)=>e1.type === t1 && i.type !== t1 ? -1 : e1.type !== t1 && i.type === t1 ? 1 : 0);
                    const i = e1.findIndex((e1)=>e1.type !== t1);
                    return i >= 0 ? i : e1.length;
                };
                let l = 0;
                this.unevalEdges.length > 0 && (l = s(this.unevalEdges, "none"), this.constructBridgeStructures(n, this.unevalVertices, this.unevalHeights, this.unevalEdges, {
                    min: 0,
                    max: l
                }, this.tileToMeters)), i(a);
                const c = t1(), u = t1();
                if (this.unevalEdges.length > 0) {
                    const e1 = this.unevalEdges.splice(l), t1 = s(e1, "tunnel") + l;
                    this.unevalEdges.push(...e1), this.constructTunnelStructures(n, this.unevalVertices, this.unevalHeights, this.unevalEdges, {
                        min: 0,
                        max: l
                    }, {
                        min: l,
                        max: t1
                    });
                }
                i(c), n.addTriangles(this.unevalTriangles, this.unevalVertices, this.unevalHeights), i(u), n.addTriangles(this.unevalTunnelTriangles, this.unevalVertices, this.unevalHeights), i(o), n.addTriangles(this.unevalTunnelTriangles, this.unevalVertices, this.unevalHeights, 4), i(r), this.maskSegments = Ou.simpleSegment(0, u.primitiveOffset, 0, u.primitiveLength), this.depthSegments = Ou.simpleSegment(0, o.primitiveOffset, 0, o.primitiveLength), this.renderableBridgeSegments = Ou.simpleSegment(0, a.primitiveOffset, 0, a.primitiveLength), this.renderableTunnelSegments = Ou.simpleSegment(0, c.primitiveOffset, 0, c.primitiveLength), this.shadowCasterSegments = Ou.simpleSegment(0, r.primitiveOffset, 0, r.primitiveLength);
            }
            update(e1, t1, i, n, r, o, a, s) {
                this.bridgeProgramConfigurations.updatePaintArrays(e1, t1, r, i, n, o, a, s), this.tunnelProgramConfigurations.updatePaintArrays(e1, t1, r, i, n, o, a, s);
            }
            upload(e1) {
                this.vertexBuffer || 0 === this.vertexPositions.length || 0 === this.vertexNormals.length || 0 === this.indexArray.length || (this.vertexBuffer = e1.createVertexBuffer(this.vertexPositions, Fu.members), this.vertexBufferNormal = e1.createVertexBuffer(this.vertexNormals, Cu.members), this.indexBuffer = e1.createIndexBuffer(this.indexArray), this.bridgeProgramConfigurations.upload(e1), this.tunnelProgramConfigurations.upload(e1));
            }
            destroy() {
                this.vertexBuffer && (this.vertexBuffer.destroy(), this.vertexBufferNormal.destroy(), this.indexBuffer.destroy()), this.maskSegments && (this.maskSegments.destroy(), this.depthSegments.destroy(), this.renderableBridgeSegments.destroy(), this.renderableTunnelSegments.destroy(), this.shadowCasterSegments.destroy()), this.bridgeProgramConfigurations.destroy(), this.tunnelProgramConfigurations.destroy();
            }
            populatePaintArrays(e1, t1, i, n, r) {
                const o = (o, a)=>{
                    for(let s = 0; s < a.length - 1; s++){
                        const l = a[s].featureIndex, c = a[s + 1].vertexStart, u = e1.feature(l);
                        o.populatePaintArrays(c, u, l, {}, i, t1, n, void 0, r);
                    }
                };
                o(this.bridgeProgramConfigurations, this.bridgeFeatureSections), o(this.tunnelProgramConfigurations, this.tunnelFeatureSections);
            }
            computeVertexConnections(e1, t1, i, n, r) {
                const o = new Map;
                for(let a = n; a < r; a++){
                    const n = i[a], r = n.a, s = n.b, l = Jm.computePosHash(e1[r]), c = Jm.computePosHash(e1[s]);
                    let u = o.get(l);
                    u || (u = {}, o.set(l, u));
                    let h = o.get(c);
                    h || (h = {}, o.set(c, h)), t1[r] <= 0 && t1[s] <= 0 || (u.to = s, h.from = r);
                }
                return o;
            }
            isTerminalVertex(e1, t1) {
                const i = Jm.computePosHash(this.unevalVertices[e1]), n = t1.get(i);
                return !n || !n.from || !n.to;
            }
            constructBridgeStructures(e1, t1, i, n, r, o) {
                e1.clearVertexLookup();
                const a = this.computeVertexConnections(t1, i, n, r.min, r.max), s = 1 / o, l = .5 * s, c = (e1, n)=>F(e1, t1[n].x, t1[n].y, i[n] * s), u = R(), h = R(), d = R(), f = R(), p = R(), _ = (e1, i)=>{
                    const n = a.get(Jm.computePosHash(t1[i])), r = n.from, o = n.to;
                    if (!r || !o) return;
                    c(u, r), c(h, i), c(d, o), K(f), Q(u, h) || (ee(p, h, u), $(f, p)), Q(d, h) || (ee(p, d, h), C(f, f, $(p, p)));
                    const s = ie(f);
                    return s > 0 ? N(e1, f, 1 / s) : void 0;
                };
                let m = Number.POSITIVE_INFINITY;
                this.sortSubarray(n, r.min, r.max, (e1, t1)=>e1.featureInfo.featureIndex - t1.featureInfo.featureIndex);
                const g = R(), y = R(), x = R(), v = R(), b = R(), w = R(), A = R(), E = R(), I = R(), M = [
                    R(),
                    R(),
                    R(),
                    R()
                ], S = [
                    R(),
                    R(),
                    R(),
                    R()
                ], T = [
                    {
                        coord: new Re(0, 0),
                        height: 0
                    },
                    {
                        coord: new Re(0, 0),
                        height: 0
                    }
                ], z = (e1, t1)=>e1 > t1;
                for(let c = r.min; c < r.max; c++){
                    const r = n[c];
                    if (!r.featureInfo.guardRailEnabled) continue;
                    if (!this.prepareEdgePoints(T, t1, i, r, z)) continue;
                    const [u, h] = T;
                    if (F(g, u.coord.x, u.coord.y, s * u.height), F(y, h.coord.x, h.coord.y, s * h.height), Q(g, y)) continue;
                    ee(x, y, g), $(x, x);
                    const d = _(E, r.a) || x, f = _(I, r.b) || x;
                    F(v, d[1], -d[0], 0), $(v, v), F(b, f[1], -f[0], 0), $(b, b), W(E, v, d), $(w, E), W(E, b, f), $(A, E), C(M[0], g, N(E, ee(E, v, w), l)), C(M[1], g, N(E, C(E, v, w), l)), C(M[2], g, N(E, w, l)), M[3] = g, C(S[0], y, N(E, ee(E, b, A), l)), C(S[1], y, N(E, C(E, b, A), l)), C(S[2], y, N(E, A, l)), S[3] = y, m = this.addFeatureSection(r.featureInfo.featureIndex, m, this.bridgeFeatureSections, e1);
                    const p = e1.addVertex(M[0], v, o), R = e1.addVertex(M[1], v, o), P = e1.addVertex(S[0], b, o), D = e1.addVertex(S[1], b, o);
                    e1.addTriangle(p, R, P), e1.addTriangle(R, D, P);
                    const O = e1.addVertex(M[1], w, o), L = e1.addVertex(M[2], w, o), B = e1.addVertex(S[1], A, o), V = e1.addVertex(S[2], A, o);
                    e1.addTriangle(O, L, B), e1.addTriangle(L, V, B), H(v, v), H(b, b);
                    const k = e1.addVertex(M[2], v, o), U = e1.addVertex(M[3], v, o), j = e1.addVertex(S[2], b, o), G = e1.addVertex(S[3], b, o);
                    e1.addTriangle(k, U, j), e1.addTriangle(U, G, j);
                    const Z = this.isTerminalVertex(r.a, a), q = this.isTerminalVertex(r.b, a);
                    u.height < .01 && Z && e1.addQuad(M[3], M[2], M[1], M[0], H(d, d), o), h.height < .01 && q && e1.addQuad(S[0], S[1], S[2], S[3], f, o);
                }
                this.bridgeFeatureSections.push({
                    featureIndex: Number.POSITIVE_INFINITY,
                    vertexStart: e1.getVertexCount()
                });
            }
            constructTunnelStructures(e1, t1, i, n, r, o) {
                e1.clearVertexLookup();
                let a = Number.POSITIVE_INFINITY;
                const s = (e1, t1)=>e1.featureInfo.featureIndex - t1.featureInfo.featureIndex;
                this.sortSubarray(n, r.min, r.max, s), this.sortSubarray(n, o.min, o.max, s);
                const l = (e1)=>$(e1, e1), c = [
                    {
                        coord: new Re(0, 0),
                        height: 0
                    },
                    {
                        coord: new Re(0, 0),
                        height: 0
                    }
                ], u = (e1, t1)=>e1 < t1, h = R(), d = R(), f = R(), p = R(), _ = R();
                for(let o = r.min; o < r.max; o++){
                    if (!this.prepareEdgePoints(c, t1, i, n[o], u)) continue;
                    const [r, s] = c, m = l(F(_, -(s.coord.y - r.coord.y), s.coord.x - r.coord.x, 0));
                    a = this.addFeatureSection(n[o].featureInfo.featureIndex, a, this.tunnelFeatureSections, e1), e1.addQuad(F(h, r.coord.x, r.coord.y, r.height), F(d, s.coord.x, s.coord.y, s.height), F(f, s.coord.x, s.coord.y, n[o].isTunnel ? s.height + 4 : 0), F(p, r.coord.x, r.coord.y, n[o].isTunnel ? r.height + 4 : 0), m);
                }
                for(let r = o.min; r < o.max; r++){
                    const o = n[r];
                    o.isTunnel && ([o.a, o.b] = [
                        o.b,
                        o.a
                    ]);
                    const s = t1[o.a], c = t1[o.b], u = l(F(_, -(c.y - s.y), c.x - s.x, 0));
                    a = this.addFeatureSection(o.featureInfo.featureIndex, a, this.tunnelFeatureSections, e1), e1.addQuad(F(h, c.x, c.y, 0), F(d, s.x, s.y, 0), F(f, s.x, s.y, i[o.a] + 4), F(p, c.x, c.y, i[o.b] + 4), u), e1.addQuad(F(h, s.x, s.y, 0), F(d, c.x, c.y, 0), F(f, c.x, c.y, i[o.b] + 4), F(p, s.x, s.y, i[o.a] + 4), u);
                }
                this.tunnelFeatureSections.push({
                    featureIndex: Number.POSITIVE_INFINITY,
                    vertexStart: e1.getVertexCount()
                });
            }
            setElevatedPoint(e1, t1, i, n) {
                e1.coord.x = t1, e1.coord.y = i, e1.height = n;
            }
            prepareEdgePoints(e1, t1, i, n, r) {
                let o = t1[n.a].x, a = t1[n.a].y, s = t1[n.b].x, l = t1[n.b].y, c = i[n.a], u = i[n.b];
                const h = r(c, 0), d = r(u, 0);
                if (h && d) return this.setElevatedPoint(e1[0], o, a, c), this.setElevatedPoint(e1[1], s, l, u), !0;
                if (!h && !d) return !1;
                if (h) {
                    if (!d) {
                        const e1 = u / (u - c);
                        s = hn(s, o, e1), l = hn(l, a, e1), u = hn(u, c, e1);
                    }
                } else {
                    const e1 = c / (c - u);
                    o = hn(o, s, e1), a = hn(a, l, e1), c = hn(c, u, e1);
                }
                return this.setElevatedPoint(e1[0], o, a, c), this.setElevatedPoint(e1[1], s, l, u), !0;
            }
            prepareEdges(e1, t1) {
                if (0 === t1.length) return;
                t1.sort((e1, t1)=>e1.hash === t1.hash ? t1.polygonIdx - e1.polygonIdx : t1.hash > e1.hash ? 1 : -1);
                let i = 0, n = 0, r = 0, o = t1[i].polygonIdx;
                do n++, (n === t1.length || t1[i].hash !== t1[n].hash) && ((1 === n - i || t1[n - 1].polygonIdx !== o) && (r < i && (t1[r] = t1[i], t1[i] = null), t1[r].type = "none", r++), i = n, i !== t1.length && (o = t1[i].polygonIdx));
                while (i !== t1.length);
                if (t1.splice(r), 0 !== t1.length && 0 !== e1.length) {
                    t1.sort((e1, t1)=>e1.portalHash < t1.portalHash ? 1 : -1);
                    let i = 0, n = 0;
                    for(; i !== t1.length && n !== e1.length;){
                        const r = t1[i], o = e1[n];
                        r.portalHash > o.hash ? i++ : o.hash > r.portalHash ? n++ : (r.type = o.type, i++);
                    }
                }
            }
            isOnBorder(e1, t1) {
                return e1 <= 0 && t1 <= 0 || e1 >= Sr && t1 >= Sr;
            }
            addFeatureSection(e1, t1, i, n) {
                return e1 !== t1 && (t1 = e1, i.push({
                    featureIndex: e1,
                    vertexStart: n.getVertexCount()
                }), n.clearVertexLookup()), t1;
            }
            sortSubarray(e1, t1, i, n) {
                const r = e1.slice(t1, i);
                r.sort(n), e1.splice(t1, r.length, ...r);
            }
            static computeEdgeHash(e1, t1) {
                const i = Jm.computePosHash(e1), n = Jm.computePosHash(t1);
                return Math.min(i, n) * Xm * Xm + Math.max(i, n);
            }
            static computePosHash(e1) {
                const t1 = Math.floor(e1.x) + 1, i = Math.floor(e1.y) + 1;
                return t1 * Xm + i;
            }
        }
        class Km {
            constructor(){
                this._valid = !1;
            }
            reset(e1) {
                return this.feature = e1, this._valid = !0, this._geometry = e1.loadGeometry(), 0 !== this._geometry.length && 0 !== this._geometry[0].length || (this._valid = !1), this;
            }
            geometry(e1, t1) {
                return this._valid && e1(t1(this._geometry)), this;
            }
            require(e1, t1, i) {
                return this.get(e1, !0, t1, i);
            }
            optional(e1, t1, i) {
                return this.get(e1, !1, t1, i);
            }
            success() {
                return this._valid;
            }
            get(e1, t1, i, n) {
                const r = Object.hasOwn(this.feature.properties, e1) ? +this.feature.properties[e1] : void 0;
                return this._valid && void 0 !== r && !Number.isNaN(r) ? i(n ? n(r) : r) : t1 && (this._valid = !1), this;
            }
        }
        class Qm {
            constructor(e1, t1){
                this.featureFunc = e1, this.vertexFunc = t1;
            }
            parseFeature(e1, t1, i) {
                return this.featureFunc(e1, t1, i);
            }
            parseVertex(e1, t1, i) {
                return this.vertexFunc(e1, t1, i);
            }
        }
        const eg = new Qm((e1, t1, i)=>e1.reset(t1).require(Td, (e1)=>{
                i.id = e1;
            }).optional("fixed_height_relative", (e1)=>{
                i.constantHeight = e1;
            }, ig.decodeRelativeHeight).geometry((e1)=>{
                i.bounds = e1;
            }, Ze).success(), (e1, t1, i)=>e1.reset(t1).require(Td, (e1)=>{
                i.id = e1;
            }).require("elevation_idx", (e1)=>{
                i.idx = e1;
            }).require("extent", (e1)=>{
                i.extent = e1;
            }).require("height_relative", (e1)=>{
                i.height = e1;
            }, ig.decodeRelativeHeight).geometry((e1)=>{
                i.position = e1;
            }, ig.getPoint).success()), tg = new Qm((e1, t1, i)=>e1.reset(t1).require(Td, (e1)=>{
                i.id = e1;
            }).optional("fixed_height", (e1)=>{
                i.constantHeight = e1;
            }, ig.decodeMetricHeight).geometry((e1)=>{
                i.bounds = e1;
            }, Ze).success(), (e1, t1, i)=>e1.reset(t1).require(Td, (e1)=>{
                i.id = e1;
            }).require("elevation_idx", (e1)=>{
                i.idx = e1;
            }).require("extent", (e1)=>{
                i.extent = e1;
            }).require("height", (e1)=>{
                i.height = e1;
            }, ig.decodeMetricHeight).geometry((e1)=>{
                i.position = e1;
            }, ig.getPoint).success());
        class ig {
            static getPoint(e1) {
                return ve(e1[0][0].x, e1[0][0].y);
            }
            static decodeRelativeHeight(e1) {
                return 1e-4 * e1 * 5;
            }
            static decodeMetricHeight(e1) {
                return 1e-4 * e1;
            }
            static getVersionSchema(e1) {
                return e1 ? "1.0.1" === e1 ? tg : void 0 : eg;
            }
            static parse(e1) {
                const t1 = [], i = [], n = e1.length, r = new Km;
                for(let o = 0; o < n; o++){
                    const n = e1.feature(o), a = n.properties.version, s = ig.getVersionSchema(a);
                    if (void 0 === s) {
                        _t(`Unknown elevation feature version number ${a || "(unknown)"}`);
                        continue;
                    }
                    const l = n.properties.type;
                    if (!l) continue;
                    const c = Wh.types[n.type];
                    if ("Point" === c && "curve_point" === l) {
                        const e1 = {};
                        s.parseVertex(r, n, e1) && t1.push(e1);
                    } else if ("Polygon" === c && "curve_meta" === l) {
                        const e1 = {};
                        s.parseFeature(r, n, e1) && i.push(e1);
                    }
                }
                return {
                    vertices: t1,
                    features: i
                };
            }
        }
        const ng = [
            xe(),
            xe(),
            xe(),
            xe(),
            xe(),
            xe(),
            xe()
        ], rg = xe(), og = xe();
        function ag(e1) {
            return [
                e1[0],
                e1[1]
            ];
        }
        function sg(e1) {
            return ve(e1[0], e1[1]);
        }
        class lg {
            constructor(e1, t1, i = null){
                this.feature = e1, this.metersToTile = t1, this.sampler = i, this.index = 0;
            }
            get() {
                const e1 = this.feature.vertices[this.index], t1 = this.feature.vertexProps[this.index].dir, i = t1[1], n = -t1[0], r = (e1.extent + 1) * this.metersToTile, o = this.sampler ? this.sampler.pointTransform(e1.position) : e1.position;
                return [
                    new Re(Math.trunc(o[0] + i * r), Math.trunc(o[1] + n * r)),
                    new Re(Math.trunc(o[0] - i * r), Math.trunc(o[1] - n * r))
                ];
            }
            next() {
                this.index++;
            }
            valid() {
                return this.index < this.feature.vertices.length;
            }
        }
        class cg {
            constructor(e1, t1, i, n, r, o){
                if (this.vertices = new Array, this.vertexProps = new Array, this.edges = new Array, this.edgeProps = new Array, this.id = e1, this.heightRange = {
                    min: i,
                    max: i
                }, this.safeArea = t1, this.constantHeight = i, null == this.constantHeight && (null != this.constantHeight || 0 !== n.length)) {
                    this.vertices = n, this.edges = r;
                    for(let e1 = 0; e1 < this.vertices.length; e1++)this.vertices[e1].index = void 0 !== this.vertices[e1].index ? this.vertices[e1].index : e1;
                    this.edges = this.edges.filter((e1)=>e1.a < this.vertices.length && e1.b < this.vertices.length && !function(e1, t1) {
                            return e1[0] === t1[0] && e1[1] === t1[1];
                        }(this.vertices[e1.a].position, this.vertices[e1.b].position)), this.heightRange = {
                        min: Number.POSITIVE_INFINITY,
                        max: Number.NEGATIVE_INFINITY
                    };
                    for (const e1 of this.vertices)this.vertexProps.push({
                        dir: ve(0, 0)
                    }), this.heightRange.min = Math.min(this.heightRange.min, e1.height), this.heightRange.max = Math.max(this.heightRange.max, e1.height);
                    for (const e1 of this.edges){
                        const t1 = this.vertices[e1.a].position, i = this.vertices[e1.b].position, n = Ae(xe(), i, t1), r = Ie(n), o = Ee(xe(), n, 1 / r);
                        this.edgeProps.push({
                            vec: n,
                            dir: o,
                            len: r
                        });
                        const a = this.vertexProps[e1.a].dir, s = this.vertexProps[e1.b].dir;
                        we(a, a, o), we(s, s, o);
                    }
                    for (const e1 of this.vertexProps)0 === e1.dir[0] && 0 === e1.dir[1] || Me(e1.dir, e1.dir);
                    this.tessellate(o);
                }
            }
            pointElevation(e1) {
                if (null != this.constantHeight) return this.constantHeight;
                const t1 = this.getClosestEdge(e1);
                if (null == t1) return 0;
                const [i, n] = t1;
                return hn(this.vertices[this.edges[i].a].height, this.vertices[this.edges[i].b].height, n);
            }
            computeSlopeNormal(e1, t1) {
                const i = this.getClosestEdge(e1);
                if (!i) return D(0, 0, 1);
                const n = i[0], r = this.edges[n], o = this.edgeProps[n].vec, a = D(o[0], o[1], (this.vertices[r.b].height - this.vertices[r.a].height) * t1), s = D(a[1], -a[0], 0);
                W(s, s, a);
                const l = P(s);
                return l > 0 ? N(s, s, 1 / l) : F(s, 0, 0, 1);
            }
            getSafeArea() {
                return this.safeArea;
            }
            isTunnel() {
                return this.heightRange.max <= -5;
            }
            getClosestEdge(e1) {
                if (0 === this.edges.length) return;
                let t1 = 0, i = Number.POSITIVE_INFINITY, n = 0;
                const [r, o, a, s, l, c, u] = ng;
                be(u, e1.x, e1.y);
                const h = new Rf(u, null);
                for(let e1 = 0; e1 < this.edges.length; e1++){
                    const d = this.edges[e1], f = this.edgeProps[e1].dir;
                    h.dir = f;
                    const p = this.vertices[d.a].position, _ = this.vertices[d.b].position, m = h.intersectsPlane(p, this.vertexProps[d.a].dir, r), g = h.intersectsPlane(_, this.vertexProps[d.b].dir, o);
                    if (!m || !g) continue;
                    Ae(a, o, r), Ae(s, u, r);
                    const y = Se(a, a), x = y > 0 ? Se(s, a) / y : 0, v = tt(x, 0, 1), b = Math.abs((x - v) * this.edgeProps[e1].len);
                    Ae(l, u, p), be(c, f[1], -f[0]);
                    const w = b + Math.abs(Se(l, c));
                    w < i && (t1 = e1, i = w, n = v);
                }
                return [
                    t1,
                    n
                ];
            }
            tessellate(e1) {
                const t1 = R(), i = R(), n = R(), r = R();
                for(let o = this.edges.length - 1; o >= 0; --o){
                    const a = this.edges[o].a, s = this.edges[o].b, { position: l, height: c, extent: u } = this.vertices[a], { position: h, height: d, extent: f } = this.vertices[s], p = this.vertexProps[a].dir, _ = this.vertexProps[s].dir;
                    if (F(t1, l[0] / e1, l[1] / e1, c), F(i, h[0] / e1, h[1] / e1, d), F(n, p[1], -p[0], 0), N(n, n, u), F(r, _[1], -_[0], 0), N(r, r, f), this.distSqLines(D(t1[0] + .5 * n[0], t1[1] + .5 * n[1], t1[2] + .5 * n[2]), D(i[0] - .5 * r[0], i[1] - .5 * r[1], i[2] - .5 * r[2]), D(t1[0] - .5 * n[0], t1[1] - .5 * n[1], t1[2] - .5 * n[2]), D(i[0] + .5 * r[0], i[1] + .5 * r[1], i[2] + .5 * r[2])) <= .0025000000000000005) continue;
                    const m = this.vertices.length, g = we(xe(), l, h);
                    this.vertices.push({
                        position: Ee(g, g, .5),
                        height: .5 * (c + d),
                        extent: .5 * (u + f),
                        index: .5 * ((void 0 !== this.vertices[a].index ? this.vertices[a].index : a) + (void 0 !== this.vertices[s].index ? this.vertices[s].index : s))
                    });
                    const y = we(xe(), p, _);
                    this.vertexProps.push({
                        dir: Me(y, y)
                    }), this.edges.splice(o, 1), this.edgeProps.splice(o, 1), this.edges.push({
                        a: a,
                        b: m
                    }), this.edges.push({
                        a: m,
                        b: s
                    });
                    const x = Ae(xe(), this.vertices[m].position, l), v = Ie(x), b = {
                        vec: x,
                        dir: Ee(xe(), x, 1 / v),
                        len: v
                    };
                    this.edgeProps.push(b), this.edgeProps.push(b);
                }
            }
            distSqLines(e1, t1, i, n) {
                const r = O(R(), t1, e1), o = O(R(), n, i), a = O(R(), e1, i), s = Z(r, r), l = Z(r, o), c = Z(r, a), u = Z(o, o), h = Z(o, a), d = s * u - l * l;
                if (0 === d) return j(q(r, i, n, Z(a, o) / Z(o, o)), e1);
                const f = (s * h - l * c) / d;
                return j(q(r, e1, t1, (l * h - c * u) / d), q(o, i, n, f));
            }
            static serialize(e1, t1) {
                const i = {
                    id: e1.id,
                    heightRange: {
                        min: e1.heightRange.min,
                        max: e1.heightRange.max
                    },
                    safeArea: (n = e1.safeArea, {
                        min: {
                            x: n.min.x,
                            y: n.min.y
                        },
                        max: {
                            x: n.max.x,
                            y: n.max.y
                        }
                    })
                };
                var n;
                return null != e1.constantHeight ? (i.constantHeight = e1.constantHeight, i) : 0 === e1.vertices.length ? (i.vertices = [], i.vertexProps = [], i.edges = [], i.edgeProps = [], i) : (i.vertices = e1.vertices.map((e1)=>({
                        position: ag(e1.position),
                        height: e1.height,
                        extent: e1.extent,
                        index: e1.index
                    })), i.vertexProps = e1.vertexProps.map((e1)=>({
                        dir: ag(e1.dir)
                    })), i.edges = e1.edges.map((e1)=>({
                        a: e1.a,
                        b: e1.b
                    })), i.edgeProps = e1.edgeProps.map((e1)=>({
                        vec: ag(e1.vec),
                        dir: ag(e1.dir),
                        len: e1.len
                    })), i);
            }
            static deserialize(e1) {
                const t1 = function(e1) {
                    return {
                        min: new Re(e1.min.x, e1.min.y),
                        max: new Re(e1.max.x, e1.max.y)
                    };
                }(e1.safeArea);
                if (null != e1.constantHeight) return new cg(e1.id, t1, e1.constantHeight);
                if (!e1.vertices || 0 === e1.vertices.length) {
                    const i = Object.create(cg.prototype);
                    return i.id = e1.id, i.constantHeight = void 0, i.heightRange = {
                        min: e1.heightRange.min,
                        max: e1.heightRange.max
                    }, i.safeArea = t1, i.vertices = [], i.vertexProps = [], i.edges = [], i.edgeProps = [], i;
                }
                const i = Object.create(cg.prototype);
                return i.id = e1.id, i.constantHeight = void 0, i.heightRange = {
                    min: e1.heightRange.min,
                    max: e1.heightRange.max
                }, i.safeArea = t1, i.vertices = e1.vertices.map((e1)=>({
                        position: sg(e1.position),
                        height: e1.height,
                        extent: e1.extent,
                        index: e1.index
                    })), i.vertexProps = (e1.vertexProps || []).map((e1)=>({
                        dir: sg(e1.dir)
                    })), i.edges = (e1.edges || []).map((e1)=>({
                        a: e1.a,
                        b: e1.b
                    })), i.edgeProps = (e1.edgeProps || []).map((e1)=>({
                        vec: sg(e1.vec),
                        dir: sg(e1.dir),
                        len: e1.len
                    })), i;
            }
        }
        class ug {
            constructor(e1, t1){
                this.zScale = 1, this.xOffset = 0, this.yOffset = 0, e1.equals(t1) || (this.zScale = Math.pow(2, t1.z - e1.z), this.xOffset = (e1.x * this.zScale - t1.x) * Sr, this.yOffset = (e1.y * this.zScale - t1.y) * Sr);
            }
            pointTransform(e1) {
                return ve(e1[0] * this.zScale + this.xOffset, e1[1] * this.zScale + this.yOffset);
            }
            pointTransformInPlace(e1) {
                e1[0] = e1[0] * this.zScale + this.xOffset, e1[1] = e1[1] * this.zScale + this.yOffset;
            }
            constantElevation(e1, t1) {
                if (null != e1.constantHeight) return this.computeBiasedHeight(e1.constantHeight, t1);
            }
            pointElevation(e1, t1, i) {
                const n = this.constantElevation(t1, i);
                return null != n ? n : (e1.x = e1.x * this.zScale + this.xOffset, e1.y = e1.y * this.zScale + this.yOffset, this.computeBiasedHeight(t1.pointElevation(e1), i));
            }
            computeBiasedHeight(e1, t1) {
                return t1 <= 0 ? e1 : e1 + t1 * it(0, t1, e1 >= 0 ? e1 : Math.abs(.5 * e1));
            }
        }
        function hg(e1) {
            if (0 === e1) return [
                0,
                0,
                0
            ];
            const t1 = pa(e1);
            return [
                t1(),
                t1(),
                t1()
            ];
        }
        function dg(e1, t1) {
            let i = 0, n = e1.length - 1;
            for(; i <= n;){
                const r = i + n >> 1;
                e1[r].feature.id < t1 ? i = r + 1 : n = r - 1;
            }
            return i < e1.length && e1[i].feature.id === t1 ? i : -1;
        }
        function fg(e1, t1, i, n) {
            if (!e1.properties) return;
            const r = +e1.properties[Td];
            if (Number.isNaN(r)) return;
            if (t1) {
                const e1 = t1.find((e1)=>e1.id === r);
                if (e1 && n) return {
                    tileId: n,
                    feature: e1
                };
            }
            if (!i || 0 === i.length) return;
            const o = dg(i, r);
            if (!(o < 0)) {
                if (n) {
                    for(let e1 = o; e1 < i.length && i[e1].feature.id === r; e1++)if (i[e1].tileId.key === n.key) return i[e1];
                }
                return i[o];
            }
        }
        function pg(e1, t1) {
            return e1 > t1 ? 1 : e1 < t1 ? -1 : 0;
        }
        Ya(cg, "ElevationFeature");
        class _g {
            constructor(e1 = pg, t1 = !1){
                this._compare = e1, this._root = null, this._size = 0, this._noDuplicates = !!t1;
            }
            rotateLeft(e1) {
                var t1 = e1.right;
                t1 && (e1.right = t1.left, t1.left && (t1.left.parent = e1), t1.parent = e1.parent), e1.parent ? e1 === e1.parent.left ? e1.parent.left = t1 : e1.parent.right = t1 : this._root = t1, t1 && (t1.left = e1), e1.parent = t1;
            }
            rotateRight(e1) {
                var t1 = e1.left;
                t1 && (e1.left = t1.right, t1.right && (t1.right.parent = e1), t1.parent = e1.parent), e1.parent ? e1 === e1.parent.left ? e1.parent.left = t1 : e1.parent.right = t1 : this._root = t1, t1 && (t1.right = e1), e1.parent = t1;
            }
            _splay(e1) {
                for(; e1.parent;){
                    var t1 = e1.parent;
                    t1.parent ? t1.left === e1 && t1.parent.left === t1 ? (this.rotateRight(t1.parent), this.rotateRight(t1)) : t1.right === e1 && t1.parent.right === t1 ? (this.rotateLeft(t1.parent), this.rotateLeft(t1)) : t1.left === e1 && t1.parent.right === t1 ? (this.rotateRight(t1), this.rotateLeft(t1)) : (this.rotateLeft(t1), this.rotateRight(t1)) : t1.left === e1 ? this.rotateRight(t1) : this.rotateLeft(t1);
                }
            }
            splay(e1) {
                for(var t1, i, n, r, o; e1.parent;)(i = (t1 = e1.parent).parent) && i.parent ? ((n = i.parent).left === i ? n.left = e1 : n.right = e1, e1.parent = n) : (e1.parent = null, this._root = e1), r = e1.left, o = e1.right, e1 === t1.left ? (i && (i.left === t1 ? (t1.right ? (i.left = t1.right, i.left.parent = i) : i.left = null, t1.right = i, i.parent = t1) : (r ? (i.right = r, r.parent = i) : i.right = null, e1.left = i, i.parent = e1)), o ? (t1.left = o, o.parent = t1) : t1.left = null, e1.right = t1, t1.parent = e1) : (i && (i.right === t1 ? (t1.left ? (i.right = t1.left, i.right.parent = i) : i.right = null, t1.left = i, i.parent = t1) : (o ? (i.left = o, o.parent = i) : i.left = null, e1.right = i, i.parent = e1)), r ? (t1.right = r, r.parent = t1) : t1.right = null, e1.left = t1, t1.parent = e1);
            }
            replace(e1, t1) {
                e1.parent ? e1 === e1.parent.left ? e1.parent.left = t1 : e1.parent.right = t1 : this._root = t1, t1 && (t1.parent = e1.parent);
            }
            minNode(e1 = this._root) {
                if (e1) for(; e1.left;)e1 = e1.left;
                return e1;
            }
            maxNode(e1 = this._root) {
                if (e1) for(; e1.right;)e1 = e1.right;
                return e1;
            }
            insert(e1, t1) {
                var i = this._root, n = null, r = this._compare;
                if (this._noDuplicates) for(; i;){
                    if (n = i, 0 === r(i.key, e1)) return;
                    i = r(i.key, e1) < 0 ? i.right : i.left;
                }
                else for(; i;)n = i, i = r(i.key, e1) < 0 ? i.right : i.left;
                return i = {
                    key: e1,
                    data: t1,
                    left: null,
                    right: null,
                    parent: n
                }, n ? r(n.key, i.key) < 0 ? n.right = i : n.left = i : this._root = i, this.splay(i), this._size++, i;
            }
            find(e1) {
                for(var t1 = this._root, i = this._compare; t1;){
                    var n = i(t1.key, e1);
                    if (n < 0) t1 = t1.right;
                    else {
                        if (!(n > 0)) return t1;
                        t1 = t1.left;
                    }
                }
                return null;
            }
            contains(e1) {
                for(var t1 = this._root, i = this._compare; t1;){
                    var n = i(e1, t1.key);
                    if (0 === n) return !0;
                    t1 = n < 0 ? t1.left : t1.right;
                }
                return !1;
            }
            remove(e1) {
                var t1 = this.find(e1);
                if (!t1) return !1;
                if (this.splay(t1), t1.left) {
                    if (t1.right) {
                        var i = this.minNode(t1.right);
                        i.parent !== t1 && (this.replace(i, i.right), i.right = t1.right, i.right.parent = i), this.replace(t1, i), i.left = t1.left, i.left.parent = i;
                    } else this.replace(t1, t1.left);
                } else this.replace(t1, t1.right);
                return this._size--, !0;
            }
            removeNode(e1) {
                if (!e1) return !1;
                if (this.splay(e1), e1.left) {
                    if (e1.right) {
                        var t1 = this.minNode(e1.right);
                        t1.parent !== e1 && (this.replace(t1, t1.right), t1.right = e1.right, t1.right.parent = t1), this.replace(e1, t1), t1.left = e1.left, t1.left.parent = t1;
                    } else this.replace(e1, e1.left);
                } else this.replace(e1, e1.right);
                return this._size--, !0;
            }
            erase(e1) {
                var t1 = this.find(e1);
                if (t1) {
                    this.splay(t1);
                    var i = t1.left, n = t1.right, r = null;
                    i && (i.parent = null, r = this.maxNode(i), this.splay(r), this._root = r), n && (i ? r.right = n : this._root = n, n.parent = r), this._size--;
                }
            }
            pop() {
                var e1 = this._root, t1 = null;
                if (e1) {
                    for(; e1.left;)e1 = e1.left;
                    t1 = {
                        key: e1.key,
                        data: e1.data
                    }, this.remove(e1.key);
                }
                return t1;
            }
            next(e1) {
                var t1 = e1;
                if (t1) {
                    if (t1.right) for(t1 = t1.right; t1 && t1.left;)t1 = t1.left;
                    else for(t1 = e1.parent; t1 && t1.right === e1;)e1 = t1, t1 = t1.parent;
                }
                return t1;
            }
            prev(e1) {
                var t1 = e1;
                if (t1) {
                    if (t1.left) for(t1 = t1.left; t1 && t1.right;)t1 = t1.right;
                    else for(t1 = e1.parent; t1 && t1.left === e1;)e1 = t1, t1 = t1.parent;
                }
                return t1;
            }
            forEach(e1) {
                for(var t1 = this._root, i = [], n = !1, r = 0; !n;)t1 ? (i.push(t1), t1 = t1.left) : i.length > 0 ? (e1(t1 = i.pop(), r++), t1 = t1.right) : n = !0;
                return this;
            }
            range(e1, t1, i, n) {
                const r = [], o = this._compare;
                let a, s = this._root;
                for(; 0 !== r.length || s;)if (s) r.push(s), s = s.left;
                else {
                    if (s = r.pop(), a = o(s.key, t1), a > 0) break;
                    if (o(s.key, e1) >= 0 && i.call(n, s)) return this;
                    s = s.right;
                }
                return this;
            }
            keys() {
                for(var e1 = this._root, t1 = [], i = [], n = !1; !n;)e1 ? (t1.push(e1), e1 = e1.left) : t1.length > 0 ? (e1 = t1.pop(), i.push(e1.key), e1 = e1.right) : n = !0;
                return i;
            }
            values() {
                for(var e1 = this._root, t1 = [], i = [], n = !1; !n;)e1 ? (t1.push(e1), e1 = e1.left) : t1.length > 0 ? (e1 = t1.pop(), i.push(e1.data), e1 = e1.right) : n = !0;
                return i;
            }
            at(e1) {
                for(var t1 = this._root, i = [], n = !1, r = 0; !n;)if (t1) i.push(t1), t1 = t1.left;
                else if (i.length > 0) {
                    if (t1 = i.pop(), r === e1) return t1;
                    r++, t1 = t1.right;
                } else n = !0;
                return null;
            }
            load(e1 = [], t1 = [], i = !1) {
                if (0 !== this._size) throw new Error("bulk-load: tree is not empty");
                const n = e1.length;
                return i && gg(e1, t1, 0, n - 1, this._compare), this._root = mg(null, e1, t1, 0, n), this._size = n, this;
            }
            min() {
                var e1 = this.minNode(this._root);
                return e1 ? e1.key : null;
            }
            max() {
                var e1 = this.maxNode(this._root);
                return e1 ? e1.key : null;
            }
            isEmpty() {
                return null === this._root;
            }
            get size() {
                return this._size;
            }
            static createTree(e1, t1, i, n, r) {
                return new _g(i, r).load(e1, t1, n);
            }
        }
        function mg(e1, t1, i, n, r) {
            const o = r - n;
            if (o > 0) {
                const a = n + Math.floor(o / 2), s = {
                    key: t1[a],
                    data: i[a],
                    parent: e1
                };
                return s.left = mg(s, t1, i, n, a), s.right = mg(s, t1, i, a + 1, r), s;
            }
            return null;
        }
        function gg(e1, t1, i, n, r) {
            if (i >= n) return;
            const o = e1[i + n >> 1];
            let a = i - 1, s = n + 1;
            for(;;){
                do a++;
                while (r(e1[a], o) < 0);
                do s--;
                while (r(e1[s], o) > 0);
                if (a >= s) break;
                let i = e1[a];
                e1[a] = e1[s], e1[s] = i, i = t1[a], t1[a] = t1[s], t1[s] = i;
            }
            gg(e1, t1, i, s, r), gg(e1, t1, s + 1, n, r);
        }
        const yg = 11102230246251565e-32, xg = 134217729, vg = (3 + 8 * yg) * yg;
        function bg(e1, t1, i, n, r) {
            let o, a, s, l, c = t1[0], u = n[0], h = 0, d = 0;
            u > c == u > -c ? (o = c, c = t1[++h]) : (o = u, u = n[++d]);
            let f = 0;
            if (h < e1 && d < i) for(u > c == u > -c ? (a = c + o, s = o - (a - c), c = t1[++h]) : (a = u + o, s = o - (a - u), u = n[++d]), o = a, 0 !== s && (r[f++] = s); h < e1 && d < i;)u > c == u > -c ? (a = o + c, l = a - o, s = o - (a - l) + (c - l), c = t1[++h]) : (a = o + u, l = a - o, s = o - (a - l) + (u - l), u = n[++d]), o = a, 0 !== s && (r[f++] = s);
            for(; h < e1;)a = o + c, l = a - o, s = o - (a - l) + (c - l), c = t1[++h], o = a, 0 !== s && (r[f++] = s);
            for(; d < i;)a = o + u, l = a - o, s = o - (a - l) + (u - l), u = n[++d], o = a, 0 !== s && (r[f++] = s);
            return 0 === o && 0 !== f || (r[f++] = o), f;
        }
        function wg(e1) {
            return new Float64Array(e1);
        }
        const Ag = wg(4), Eg = wg(8), Ig = wg(12), Mg = wg(16), Sg = wg(4);
        function Tg(e1, t1, i) {
            null === t1 ? (e1.inOut = !1, e1.otherInOut = !0) : (e1.isSubject === t1.isSubject ? (e1.inOut = !t1.inOut, e1.otherInOut = t1.otherInOut) : (e1.inOut = !t1.otherInOut, e1.otherInOut = t1.isVertical() ? !t1.inOut : t1.inOut), t1 && (e1.prevInResult = !zg(t1, i) || t1.isVertical() ? t1.prevInResult : t1)), e1.resultTransition = zg(e1, i) ? function(e1, t1) {
                let i, n = !e1.inOut, r = !e1.otherInOut;
                switch(t1){
                    case 0:
                        i = n && r;
                        break;
                    case 1:
                        i = n || r;
                        break;
                    case 3:
                        i = n !== r;
                        break;
                    case 2:
                        i = e1.isSubject ? n && !r : r && !n;
                }
                return i ? 1 : -1;
            }(e1, i) : 0;
        }
        function zg(e1, t1) {
            switch(e1.type){
                case 0:
                    switch(t1){
                        case 0:
                            return !e1.otherInOut;
                        case 1:
                            return e1.otherInOut;
                        case 2:
                            return e1.isSubject && e1.otherInOut || !e1.isSubject && !e1.otherInOut;
                        case 3:
                            return !0;
                    }
                    break;
                case 2:
                    return 0 === t1 || 1 === t1;
                case 3:
                    return 2 === t1;
                case 1:
                    return !1;
            }
            return !1;
        }
        var Rg = class e1 {
            constructor(e1, t1, i, n, r){
                this.left = t1, this.point = e1, this.otherEvent = i, this.isSubject = n ?? !1, this.type = r || 0, this.inOut = !1, this.otherInOut = !1, this.prevInResult = null, this.resultTransition = 0, this.otherPos = -1, this.outputContourId = -1, this.isExteriorRing = !0, this.node = null;
            }
            isBelow(e1) {
                let t1 = this.point, i = this.otherEvent.point;
                return this.left ? (t1[0] - e1[0]) * (i[1] - e1[1]) - (i[0] - e1[0]) * (t1[1] - e1[1]) > 0 : (i[0] - e1[0]) * (t1[1] - e1[1]) - (t1[0] - e1[0]) * (i[1] - e1[1]) > 0;
            }
            isAbove(e1) {
                return !this.isBelow(e1);
            }
            isVertical() {
                return this.point[0] === this.otherEvent.point[0];
            }
            get inResult() {
                return 0 !== this.resultTransition;
            }
            clone() {
                let t1 = new e1(this.point, this.left, this.otherEvent, this.isSubject, this.type);
                return t1.contourId = this.contourId, t1.resultTransition = this.resultTransition, t1.prevInResult = this.prevInResult, t1.isExteriorRing = this.isExteriorRing, t1.inOut = this.inOut, t1.otherInOut = this.otherInOut, t1;
            }
        };
        function Pg(e1, t1, i) {
            let n = function(e1, t1, i, n, r, o) {
                const a = (t1 - o) * (i - r), s = (e1 - r) * (n - o), l = a - s;
                if (0 === a || 0 === s || a > 0 != s > 0) return l;
                const c = Math.abs(a + s);
                return Math.abs(l) >= 33306690738754716e-32 * c ? l : -function(e1, t1, i, n, r, o, a) {
                    let s, l, c, u, h, d, f, p, _, m, g, y, x, v, b, w, A, E;
                    const I = e1 - r, M = i - r, S = t1 - o, T = n - o;
                    v = I * T, d = xg * I, f = d - (d - I), p = I - f, d = xg * T, _ = d - (d - T), m = T - _, b = p * m - (v - f * _ - p * _ - f * m), w = S * M, d = xg * S, f = d - (d - S), p = S - f, d = xg * M, _ = d - (d - M), m = M - _, A = p * m - (w - f * _ - p * _ - f * m), g = b - A, h = b - g, Ag[0] = b - (g + h) + (h - A), y = v + g, h = y - v, x = v - (y - h) + (g - h), g = x - w, h = x - g, Ag[1] = x - (g + h) + (h - w), E = y + g, h = E - y, Ag[2] = y - (E - h) + (g - h), Ag[3] = E;
                    let z = function(e1, t1) {
                        let i = t1[0];
                        for(let e1 = 1; e1 < 4; e1++)i += t1[e1];
                        return i;
                    }(0, Ag), R = 22204460492503146e-32 * a;
                    if (z >= R || -z >= R) return z;
                    if (h = e1 - I, s = e1 - (I + h) + (h - r), h = i - M, c = i - (M + h) + (h - r), h = t1 - S, l = t1 - (S + h) + (h - o), h = n - T, u = n - (T + h) + (h - o), 0 === s && 0 === l && 0 === c && 0 === u) return z;
                    if (R = 11093356479670487e-47 * a + vg * Math.abs(z), z += I * u + T * s - (S * c + M * l), z >= R || -z >= R) return z;
                    v = s * T, d = xg * s, f = d - (d - s), p = s - f, d = xg * T, _ = d - (d - T), m = T - _, b = p * m - (v - f * _ - p * _ - f * m), w = l * M, d = xg * l, f = d - (d - l), p = l - f, d = xg * M, _ = d - (d - M), m = M - _, A = p * m - (w - f * _ - p * _ - f * m), g = b - A, h = b - g, Sg[0] = b - (g + h) + (h - A), y = v + g, h = y - v, x = v - (y - h) + (g - h), g = x - w, h = x - g, Sg[1] = x - (g + h) + (h - w), E = y + g, h = E - y, Sg[2] = y - (E - h) + (g - h), Sg[3] = E;
                    const P = bg(4, Ag, 4, Sg, Eg);
                    v = I * u, d = xg * I, f = d - (d - I), p = I - f, d = xg * u, _ = d - (d - u), m = u - _, b = p * m - (v - f * _ - p * _ - f * m), w = S * c, d = xg * S, f = d - (d - S), p = S - f, d = xg * c, _ = d - (d - c), m = c - _, A = p * m - (w - f * _ - p * _ - f * m), g = b - A, h = b - g, Sg[0] = b - (g + h) + (h - A), y = v + g, h = y - v, x = v - (y - h) + (g - h), g = x - w, h = x - g, Sg[1] = x - (g + h) + (h - w), E = y + g, h = E - y, Sg[2] = y - (E - h) + (g - h), Sg[3] = E;
                    const D = bg(P, Eg, 4, Sg, Ig);
                    v = s * u, d = xg * s, f = d - (d - s), p = s - f, d = xg * u, _ = d - (d - u), m = u - _, b = p * m - (v - f * _ - p * _ - f * m), w = l * c, d = xg * l, f = d - (d - l), p = l - f, d = xg * c, _ = d - (d - c), m = c - _, A = p * m - (w - f * _ - p * _ - f * m), g = b - A, h = b - g, Sg[0] = b - (g + h) + (h - A), y = v + g, h = y - v, x = v - (y - h) + (g - h), g = x - w, h = x - g, Sg[1] = x - (g + h) + (h - w), E = y + g, h = E - y, Sg[2] = y - (E - h) + (g - h), Sg[3] = E;
                    const F = bg(D, Ig, 4, Sg, Mg);
                    return Mg[F - 1];
                }(e1, t1, i, n, r, o, c);
            }(e1[0], e1[1], t1[0], t1[1], i[0], i[1]);
            return n > 0 ? -1 : +(n < 0);
        }
        function Dg(e1, t1) {
            let i = e1.point, n = t1.point;
            return i[0] > n[0] ? 1 : i[0] < n[0] ? -1 : i[1] === n[1] ? function(e1, t1, i) {
                return e1.left === t1.left ? 0 === Pg(i, e1.otherEvent.point, t1.otherEvent.point) ? !e1.isSubject && t1.isSubject ? 1 : -1 : e1.isBelow(t1.otherEvent.point) ? -1 : 1 : e1.left ? 1 : -1;
            }(e1, t1, i) : i[1] > n[1] ? 1 : -1;
        }
        function Fg(e1, t1, i) {
            let n = new Rg(t1, !1, e1, e1.isSubject), r = new Rg(t1, !0, e1.otherEvent, e1.isSubject);
            return n.contourId = r.contourId = e1.contourId, Dg(r, e1.otherEvent) > 0 && (e1.otherEvent.left = !0, r.left = !1), e1.otherEvent.otherEvent = r, e1.otherEvent = n, i.push(r), i.push(n), i;
        }
        function Cg(e1, t1, i, n, r) {
            return [
                e1 + i * n,
                t1 + i * r
            ];
        }
        function Og(e1, t1) {
            return e1[0] === t1[0] && e1[1] === t1[1];
        }
        function Lg(e1, t1) {
            return Math.abs(e1 - t1) <= 4 * 2 ** -52 * Math.max(Math.abs(e1), Math.abs(t1));
        }
        function Bg(e1, t1) {
            return Lg(e1[0], t1[0]) && Lg(e1[1], t1[1]);
        }
        function Vg(e1, t1, i) {
            let n = function(e1, t1, i, n) {
                let r = e1[0], o = e1[1], a = i[0], s = i[1], l = t1[0] - r, c = t1[1] - o, u = n[0] - a, h = n[1] - s, d = a - r, f = s - o, p = l * h - c * u, _ = p * p;
                if (_ > 0) {
                    let e1 = (d * h - f * u) / p;
                    if (e1 < 0 || e1 > 1) return null;
                    let t1 = (d * c - f * l) / p;
                    return t1 < 0 || t1 > 1 ? null : 0 === e1 || 1 === e1 ? [
                        Cg(r, o, e1, l, c)
                    ] : 0 === t1 || 1 === t1 ? [
                        Cg(a, s, t1, u, h)
                    ] : [
                        Cg(r, o, e1, l, c)
                    ];
                }
                if (p = d * c - f * l, _ = p * p, _ > 0) return null;
                let m = l * l + c * c, g = (l * d + c * f) / m, y = g + (l * u + c * h) / m, x = Math.min(g, y), v = Math.max(g, y);
                return x <= 1 && v >= 0 ? 1 === x ? [
                    Cg(r, o, x > 0 ? x : 0, l, c)
                ] : 0 === v ? [
                    Cg(r, o, v < 1 ? v : 1, l, c)
                ] : [
                    Cg(r, o, x > 0 ? x : 0, l, c),
                    Cg(r, o, v < 1 ? v : 1, l, c)
                ] : null;
            }(e1.point, e1.otherEvent.point, t1.point, t1.otherEvent.point);
            if (null === n) return 0;
            let r = n.length;
            if (1 === r) {
                let i = [
                    e1.point,
                    e1.otherEvent.point,
                    t1.point,
                    t1.otherEvent.point
                ];
                for (let e1 of i)if (Bg(n[0], e1)) {
                    n[0] = e1;
                    break;
                }
            }
            if (1 === r && (Og(e1.point, t1.point) || Og(e1.otherEvent.point, t1.otherEvent.point)) || 2 === r && e1.isSubject === t1.isSubject) return 0;
            if (1 === r) return !Og(e1.point, n[0]) && !Og(e1.otherEvent.point, n[0]) && Fg(e1, n[0], i), !Og(t1.point, n[0]) && !Og(t1.otherEvent.point, n[0]) && Fg(t1, n[0], i), 1;
            let o = [], a = !1, s = !1;
            return Og(e1.point, t1.point) ? a = !0 : 1 === Dg(e1, t1) ? o.push(t1, e1) : o.push(e1, t1), Og(e1.otherEvent.point, t1.otherEvent.point) ? s = !0 : 1 === Dg(e1.otherEvent, t1.otherEvent) ? o.push(t1.otherEvent, e1.otherEvent) : o.push(e1.otherEvent, t1.otherEvent), a && s || a ? (t1.type = 1, e1.type = t1.inOut === e1.inOut ? 2 : 3, a && !s && Fg(o[1].otherEvent, o[0].point, i), 2) : s ? (Fg(o[0], o[1].point, i), 3) : o[0] === o[3].otherEvent ? (Fg(o[0], o[1].point, i), Fg(o[3].otherEvent, o[2].point, i), 3) : (Fg(o[0], o[1].point, i), Fg(o[1], o[2].point, i), 3);
        }
        function Ng(e1, t1) {
            if (e1 === t1) return 0;
            if (0 !== Pg(e1.point, e1.otherEvent.point, t1.point) || 0 !== Pg(e1.point, e1.otherEvent.point, t1.otherEvent.point)) return Og(e1.point, t1.point) ? e1.isBelow(t1.otherEvent.point) ? -1 : 1 : e1.point[0] === t1.point[0] ? e1.point[1] < t1.point[1] ? -1 : 1 : 1 === Dg(e1, t1) ? t1.isAbove(e1.point) ? -1 : 1 : e1.isBelow(t1.point) ? -1 : 1;
            if (e1.isSubject !== t1.isSubject) return e1.isSubject ? -1 : 1;
            {
                let i = e1.point, n = t1.point;
                if (i[0] === n[0] && i[1] === n[1]) return i = e1.otherEvent.point, n = t1.otherEvent.point, i[0] === n[0] && i[1] === n[1] ? 0 : (e1.contourId ?? 0) > (t1.contourId ?? 0) ? 1 : -1;
            }
            return 1 === Dg(e1, t1) ? 1 : -1;
        }
        function kg(e1, t1, i, n, r, o) {
            let a, s, l = new _g(Ng), c = [], u = Math.min(n[2], r[2]), h = null;
            for(; 0 !== e1.length;){
                let t1 = e1.pop();
                if (c.push(t1), 0 === o && t1.point[0] > u || 2 === o && t1.point[0] > n[2]) break;
                if (t1.left) {
                    s = a = t1.node = l.insert(t1), h = l.minNode(), a = a === h ? null : l.prev(a), s = l.next(s);
                    let i, n = a ? a.key : null, r = e1.length;
                    if (Tg(t1, n, o), s && 2 === Vg(t1, s.key, e1) && (Tg(t1, n, o), Tg(s.key, t1, o)), a && 2 === Vg(a.key, t1, e1)) {
                        let e1 = a;
                        e1 = e1 === h ? null : l.prev(e1), i = e1 ? e1.key : null, Tg(a.key, i, o), Tg(t1, n, o);
                    }
                    if (e1.length > r) {
                        let i = e1.peek();
                        Og(i.point, t1.point) && -1 === Dg(i, t1) && 1 === Dg(t1, i) && (l.removeNode(t1.node), t1.node = null, c.pop(), e1.push(t1));
                    }
                } else t1 = t1.otherEvent, s = a = t1.node, a && s && (a = a === h ? null : l.prev(a), s = l.next(s), l.removeNode(t1.node), t1.node = null, s && a && Vg(a.key, s.key, e1));
            }
            return c;
        }
        var Ug = class {
            constructor(){
                this.points = [], this.holeIds = [], this.holeOf = null, this.depth = 0;
            }
            isExterior() {
                return null == this.holeOf;
            }
        };
        function jg(e1, t1, i, n) {
            let r = e1 + 1, o = t1[e1].point, a = o, s = t1.length;
            for(r < s && (a = t1[r].point); r < s && a[0] === o[0] && a[1] === o[1];){
                if (!i[r]) return r;
                r++, r < s && (a = t1[r].point);
            }
            for(r = e1 - 1; i[r] && r > n;)r--;
            return r;
        }
        function Gg(e1, t1, i) {
            let n = new Ug;
            if (null != e1.prevInResult) {
                let r = e1.prevInResult, o = r.outputContourId;
                if (r.resultTransition > 0) {
                    let e1 = t1[o];
                    if (null != e1.holeOf) {
                        let r = e1.holeOf;
                        t1[r].holeIds.push(i), n.holeOf = r, n.depth = t1[o].depth;
                    } else t1[o].holeIds.push(i), n.holeOf = o, n.depth = t1[o].depth + 1;
                } else n.holeOf = null, n.depth = t1[o].depth;
            } else n.holeOf = null, n.depth = 0;
            return n;
        }
        function Hg(e1) {
            let t1, i, n = function(e1) {
                let t1, i, n, r, o, a = [];
                for(i = 0, n = e1.length; i < n; i++)t1 = e1[i], (t1.left && t1.inResult || !t1.left && t1.otherEvent.inResult) && a.push(t1);
                let s = !1;
                for(; !s;)for(s = !0, i = 0, n = a.length; i < n; i++)i + 1 < n && 1 === Dg(a[i], a[i + 1]) && (r = a[i], a[i] = a[i + 1], a[i + 1] = r, s = !1);
                for(i = 0, n = a.length; i < n; i++)t1 = a[i], t1.otherPos = i;
                for(i = 0, n = a.length; i < n; i++)t1 = a[i], t1.left || (o = t1.otherPos, t1.otherPos = t1.otherEvent.otherPos, t1.otherEvent.otherPos = o);
                return a;
            }(e1), r = new Uint8Array(n.length), o = [];
            for(t1 = 0, i = n.length; t1 < i; t1++){
                if (r[t1]) continue;
                let e1 = o.length, i = Gg(n[t1], o, e1), a = (t1)=>{
                    r[t1] = 1, t1 < n.length && n[t1] && (n[t1].outputContourId = e1);
                }, s = t1, l = t1;
                for(i.points.push(n[t1].point); a(s), s = n[s].otherPos, a(s), i.points.push(n[s].point), s = jg(s, n, r, l), !(s == l || s >= n.length) && n[s];);
                o.push(i);
            }
            return o;
        }
        var $g = class {
            constructor(e1){
                this.index = 0, this.heap = new Mr(void 0, Dg), this.sorted = e1;
            }
            get length() {
                return this.sorted.length - this.index + this.heap.length;
            }
            push(e1) {
                this.heap.push(e1);
            }
            peek() {
                let e1 = this.sorted[this.index], t1 = this.heap.peek();
                return void 0 === t1 ? e1 : void 0 === e1 || Dg(t1, e1) < 0 ? t1 : e1;
            }
            pop() {
                let e1 = this.sorted[this.index], t1 = this.heap.peek();
                return void 0 !== t1 && (void 0 === e1 || Dg(t1, e1) < 0) ? this.heap.pop() : (void 0 !== e1 && this.index++, e1);
            }
        }, Zg = Math.max, Wg = Math.min, qg = 0;
        function Xg(e1, t1, i, n, r, o) {
            let a, s, l, c, u, h, d = e1.length - 1, f = e1[0];
            for(a = 0, s = f[0] === e1[d][0] && f[1] === e1[d][1] ? d : d + 1; a < s; a++){
                if (l = e1[a], c = a < d ? e1[a + 1] : f, u = new Rg(l, !1, void 0, t1), h = new Rg(c, !1, u, t1), u.otherEvent = h, l[0] === c[0] && l[1] === c[1]) continue;
                u.contourId = h.contourId = i, o || (u.isExteriorRing = !1, h.isExteriorRing = !1), Dg(u, h) > 0 ? h.left = !0 : u.left = !0;
                let s = l[0], p = l[1];
                r[0] = Wg(r[0], s), r[1] = Wg(r[1], p), r[2] = Zg(r[2], s), r[3] = Zg(r[3], p), n.push(u, h);
            }
        }
        function Yg(e1, t1, i, n, r) {
            let o, a, s, l, c, u, h = [];
            for(s = 0, l = e1.length; s < l; s++)for(o = e1[s], c = 0, u = o.length; c < u; c++)a = 0 === c, a && qg++, Xg(o[c], !0, qg, h, i, a);
            for(s = 0, l = t1.length; s < l; s++)for(o = t1[s], c = 0, u = o.length; c < u; c++)a = 0 === c, 2 === r && (a = !1), a && qg++, Xg(o[c], !1, qg, h, n, a);
            return new $g(h.sort(Dg));
        }
        function Jg(e1) {
            let t1 = e1[0], i = 1, n = e1.length;
            for(; i < n && e1[i][0] === t1[0] && e1[i][1] === t1[1];)i++;
            if (i === n) return !0;
            let r = e1[i];
            for(i++; i < n; i++)if (0 !== Pg(t1, r, e1[i])) return !1;
            return !0;
        }
        function Kg(e1, t1) {
            let i = function(e1) {
                let t1 = e1.length;
                t1 > 1 && Og(e1[0], e1[t1 - 1]) && t1--;
                let i = [];
                for(let n = 0; n < t1; n++){
                    let t1 = e1[n], r = i.length;
                    if (!(r > 0 && Og(i[r - 1], t1))) for(i.push(t1); (r = i.length) >= 3 && Og(i[r - 3], i[r - 1]);)i.length = r - 2;
                }
                let n = 0, r = i.length;
                for(; r - n >= 3;)if (Og(i[r - 1], i[n])) r--;
                else if (Og(i[r - 2], i[n])) r -= 2;
                else {
                    if (!Og(i[r - 1], i[n + 1])) break;
                    n++, r--;
                }
                let o = i.slice(n, r);
                return o.length > 0 && o.push(o[0]), o;
            }(e1);
            return Jg(i) ? null : (function(e1) {
                let t1 = e1.length - 1, i = 0;
                for(let n = 1; n < t1; n++)(e1[n][0] < e1[i][0] || e1[n][0] === e1[i][0] && e1[n][1] < e1[i][1]) && (i = n);
                let n = Pg(e1[(i + t1 - 1) % t1], e1[i], e1[(i + 1) % t1]);
                if (0 !== n) return n > 0;
                let r = 0;
                for(let i = 0; i < t1; i++)r += e1[i][0] * e1[i + 1][1] - e1[i + 1][0] * e1[i][1];
                return r > 0;
            }(i) === t1 && i.reverse(), i);
        }
        function Qg(e1) {
            let t1 = [];
            for (let i of e1){
                let e1 = Kg(i[0], !1);
                if (null === e1) continue;
                let n = [
                    e1
                ];
                for(let e1 = 1; e1 < i.length; e1++){
                    let t1 = Kg(i[e1], !0);
                    null !== t1 && n.push(t1);
                }
                t1.push(n);
            }
            return t1;
        }
        function ey(e1) {
            let t1 = null;
            for(let i = 0; i < e1.length; i++){
                let n = e1[i], r = null;
                for(let e1 = 0; e1 < n.length; e1++){
                    let t1 = Jg(n[e1]);
                    if (t1 && null === r ? r = n.slice(0, e1) : !t1 && null !== r && r.push(n[e1]), t1 && 0 === e1) break;
                }
                if (null !== r && null === t1 && (t1 = e1.slice(0, i)), null !== t1) {
                    let e1 = null === r ? n : r;
                    e1.length > 0 && t1.push(e1);
                }
            }
            return null === t1 ? e1 : t1;
        }
        function ty(e1, t1, i) {
            let n = e1, r = t1;
            "number" == typeof e1[0][0][0] && (n = [
                e1
            ]), "number" == typeof t1[0][0][0] && (r = [
                t1
            ]), n = ey(n), r = ey(r);
            let o = function(e1, t1, i) {
                let n = null;
                return e1.length * t1.length === 0 && (0 === i ? n = [] : 2 === i ? n = e1 : (1 === i || 3 === i) && (n = 0 === e1.length ? t1 : e1)), n;
            }(n, r, i);
            if (null !== o) return Qg(o);
            let a = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ], s = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ], l = Yg(n, r, a, s, i);
            if (o = function(e1, t1, i, n, r) {
                let o = null;
                return (i[0] > n[2] || n[0] > i[2] || i[1] > n[3] || n[1] > i[3]) && (0 === r ? o = [] : 2 === r ? o = e1 : (1 === r || 3 === r) && (o = e1.concat(t1))), o;
            }(n, r, a, s, i), null !== o) return Qg(o);
            let c = Hg(kg(l, 0, 0, a, s, i)), u = c.map((e1)=>Kg(e1.points, !e1.isExterior())), h = [];
            for(let e1 = 0; e1 < c.length; e1++){
                let t1 = c[e1], i = u[e1];
                if (t1.isExterior() && null !== i) {
                    let e1 = [
                        i
                    ];
                    for(let i = 0; i < t1.holeIds.length; i++){
                        let n = u[t1.holeIds[i]];
                        null !== n && e1.push(n);
                    }
                    h.push(e1);
                }
            }
            return h;
        }
        function iy(e1, t1) {
            return sy(ty(ry(e1), ry([
                t1
            ]), 0));
        }
        function ny(e1, t1, i = 0) {
            const n = 65536;
            let r = ry(e1, n);
            const o = [];
            for(; t1.valid(); t1.next()){
                const [e1, r] = t1.get();
                let a = e1.x * n, s = e1.y * n, l = r.x * n, c = r.y * n;
                const u = l - a, h = c - s, d = Math.hypot(u, h);
                if (0 === d) continue;
                a -= u * i, s -= h * i, l += u * i, c += h * i;
                const f = Math.trunc(h / d * 3), p = -Math.trunc(u / d * 3);
                o.push([
                    [
                        [
                            a,
                            s
                        ],
                        [
                            l,
                            c
                        ],
                        [
                            l + f,
                            c + p
                        ],
                        [
                            a + f,
                            s + p
                        ],
                        [
                            a,
                            s
                        ]
                    ]
                ]);
            }
            return o.length > 0 && (r = ty(r, o, 2)), sy(r, 1 / n, .001);
        }
        function ry(e1, t1 = 1) {
            return [
                e1.map((e1)=>e1.map((e1)=>[
                            e1.x * t1,
                            e1.y * t1
                        ]))
            ];
        }
        function oy(e1, t1) {
            const i = Math.floor(e1) + .5;
            return Math.abs(e1 - i) <= t1 ? Math.round(i) : Math.round(e1);
        }
        class ay {
            constructor(e1){
                this.xs = [], this.ys = [], this.ixs = [], this.iys = [], this.buckets = new Map, this.tolerance = e1;
            }
            canonicalize(e1, t1) {
                const i = this.tolerance, n = Math.floor(e1 / i), r = Math.floor(t1 / i);
                for(let o = -1; o <= 1; o++){
                    const a = this.buckets.get(n + o);
                    if (a) for(let o = -1; o <= 1; o++){
                        const s = a.get(r + o);
                        if (s) {
                            for (const o of s)if (Math.abs(this.xs[o] - e1) <= i && Math.abs(this.ys[o] - t1) <= i) {
                                const i = this.ixs[o], a = this.iys[o];
                                return this.xs[o] === e1 && this.ys[o] === t1 || this.store(e1, t1, i, a, n, r), [
                                    i,
                                    a
                                ];
                            }
                        }
                    }
                }
                const o = oy(e1, i), a = oy(t1, i);
                return this.store(e1, t1, o, a, n, r), [
                    o,
                    a
                ];
            }
            store(e1, t1, i, n, r, o) {
                const a = this.xs.length;
                this.xs.push(e1), this.ys.push(t1), this.ixs.push(i), this.iys.push(n);
                let s = this.buckets.get(r);
                s || (s = new Map, this.buckets.set(r, s));
                let l = s.get(o);
                l || (l = [], s.set(o, l)), l.push(a);
            }
        }
        function sy(e1, t1 = 1, i) {
            const n = null != i ? new ay(i) : null;
            return e1.map((e1)=>e1.map((e1)=>e1.map((e1)=>{
                        const i = e1[0] * t1, r = e1[1] * t1;
                        if (n) {
                            const [e1, t1] = n.canonicalize(i, r);
                            return new Re(e1, t1);
                        }
                        return new Re(Math.round(i), Math.round(r));
                    })));
        }
        class ly {
            constructor(){
                this.frcCoverage = new Set, this.featureTriSegments = [], this.frcPerLevel = new Map, this.frcNonRoadSegments = new Ou;
            }
            empty() {
                return 0 === this.frcCoverage.size;
            }
        }
        function cy(e1, t1, i) {
            if (0 === e1.frcCoverage.size || 0 === e1.featureTriSegments.length) return;
            const n = i.get(), r = t1.uint16, o = [];
            e1.featureTriSegments.sort((e1, t1)=>e1.segIdx !== t1.segIdx ? e1.segIdx - t1.segIdx : null === e1.frc && null === t1.frc ? 0 : null === e1.frc ? -1 : null === t1.frc ? 1 : t1.frc - e1.frc);
            const a = new Map;
            let s = 0, l = e1.featureTriSegments[0].frc, c = {
                vertexOffset: n[s].vertexOffset,
                primitiveOffset: 0,
                vertexLength: n[s].vertexLength,
                primitiveLength: 0,
                vaos: {},
                sortKey: void 0,
                batchIndex: n[s].batchIndex
            };
            const u = ()=>{
                c.primitiveLength > 0 && (a.has(l) || a.set(l, []), a.get(l).push({
                    ...c
                }));
            };
            for (const t1 of e1.featureTriSegments){
                t1.segIdx !== s && (u(), s = t1.segIdx, l = t1.frc, c = {
                    vertexOffset: n[s].vertexOffset,
                    primitiveOffset: o.length / 3,
                    vertexLength: n[s].vertexLength,
                    primitiveLength: 0,
                    vaos: {},
                    sortKey: void 0,
                    batchIndex: n[s].batchIndex
                }), t1.frc !== l && (u(), l = t1.frc, c = {
                    ...c,
                    primitiveOffset: o.length / 3,
                    primitiveLength: 0
                });
                for(let e1 = t1.start; e1 < t1.end; e1++)o.push(r[e1]);
                c.primitiveLength += (t1.end - t1.start) / 3;
            }
            u();
            for(let e1 = 0; e1 < o.length; e1++)r[e1] = o[e1];
            for (const [t1, i] of a)null !== t1 ? e1.frcPerLevel.set(t1, new Ou(i)) : e1.frcNonRoadSegments = new Ou(i);
            e1.featureTriSegments = [];
        }
        Ya(ly, "FrcSegmentData");
        const uy = {
            motorway: 0,
            motorway_link: 0,
            trunk: 1,
            trunk_link: 1,
            primary: 2,
            primary_link: 2,
            secondary: 3,
            secondary_link: 3,
            tertiary: 4,
            tertiary_link: 4,
            unclassified: 5,
            unclassified_link: 5,
            street: 6,
            street_limited: 6,
            residential: 6,
            service: 7,
            living_street: 7,
            pedestrian: 8,
            track: 8,
            path: 8,
            footway: 8,
            cycleway: 8,
            sidewalk: 8,
            crossing: 8
        };
        function hy(e1) {
            for (const t1 of [
                "class",
                "incident_class"
            ]){
                const i = e1[t1];
                if ("string" != typeof i) continue;
                const n = uy[i];
                if (void 0 !== n) return n;
            }
            return null;
        }
        function dy(e1, t1, i) {
            for (const n of e1)if (n.startsWith("(")) {
                const e1 = n.indexOf(")");
                if (-1 === e1) continue;
                if (n.slice(1, e1) === t1 && n.slice(e1 + 1) === i) return !0;
            } else if (n === i) return !0;
            return !1;
        }
        class fy {
            constructor(e1, t1, i){
                this.elevationMode = t1, t1 && (this.elevationBufferData = new Wm(e1.layers, e1.zoom, e1.lut)), i && (this.frcData = new ly);
            }
            isEmpty() {
                const e1 = !this.elevationBufferData || this.elevationBufferData.isEmpty(), t1 = !this.frcData || this.frcData.empty();
                return e1 && t1;
            }
            needsUpload() {
                return !!this.elevationBufferData && this.elevationBufferData.needsUpload();
            }
            trackFeatureFrc(e1) {
                if (!this.frcData) return null;
                const t1 = hy(e1 || {});
                return null !== t1 && this.frcData.frcCoverage.add(t1), t1;
            }
            recordFeatureRange(e1, t1, i, n) {
                if (!this.frcData || i <= t1) return;
                const r = e1.bufferData.triangleSegments.get();
                this.frcData.featureTriSegments.push({
                    start: 3 * t1,
                    end: 3 * i,
                    segIdx: r.length > 0 ? r.length - 1 : 0,
                    frc: n
                });
            }
            buildFrcSegments(e1) {
                this.frcData && !this.frcData.empty() && cy(this.frcData, e1.bufferData.indexArray, e1.bufferData.triangleSegments);
            }
            handleFeature(e1, t1, i, n, r, o) {
                const a = new Array;
                if (!this.elevationMode) return !1;
                const s = fg(e1, r, void 0, n);
                if (!s) return !1;
                {
                    const e1 = this.clipPolygonsToTile(t1, 1);
                    e1.length > 0 && a.push({
                        polygons: e1,
                        elevationFeature: s.feature,
                        elevationTileID: s.tileId
                    });
                }
                const l = {
                    guardRailEnabled: o.layers[0].layout.get("fill-construct-bridge-guard-rail").evaluate(e1, {}, n),
                    featureIndex: i
                };
                for (const t1 of a)if (t1.elevationFeature) {
                    if ("hd-road-base" === this.elevationMode) {
                        this.elevatedStructures || (this.elevatedStructures = new Jm(t1.elevationTileID, o.layers, o.zoom, o.lut));
                        const i = t1.elevationFeature.isTunnel();
                        let n = 0;
                        Object.hasOwn(e1.properties, zd) && (n = +e1.properties[zd]), this.elevatedStructures.addPortalCandidates(t1.elevationFeature.id, t1.polygons, i, t1.elevationFeature, n);
                    }
                    null == t1.elevationFeature.constantHeight && (t1.polygons = this.prepareElevatedPolygons(t1.polygons, t1.elevationFeature, t1.elevationTileID));
                    const r = new ug(n, t1.elevationTileID);
                    this.addElevatedGeometry(o, t1.polygons, r, t1.elevationFeature, "hd-road-base" === this.elevationMode ? 0 : .05, i, l);
                }
                return !0;
            }
            populatePaintArrays(e1, t1, i, n, r, o, a) {
                this.elevationBufferData && this.elevationBufferData.populatePaintArrays(e1, t1, i, n, r, o, a);
            }
            update(e1, t1, i, n, r, o, a, s) {
                this.elevationBufferData && this.elevationBufferData.update(e1, t1, i, n, r, o, a, s), this.elevatedStructures && this.elevatedStructures.update(e1, t1, i, n, r, o, a, s);
            }
            updateExpressions(e1) {
                this.elevationBufferData && this.elevationBufferData.programConfigurations.updateExpressions(e1), this.elevatedStructures && (this.elevatedStructures.bridgeProgramConfigurations.updateExpressions(e1), this.elevatedStructures.tunnelProgramConfigurations.updateExpressions(e1));
            }
            upload(e1) {
                this.elevationBufferData && this.elevationBufferData.upload(e1), this.elevatedStructures && this.elevatedStructures.upload(e1);
            }
            destroy() {
                this.elevationBufferData && this.elevationBufferData.destroy(), this.elevatedStructures && this.elevatedStructures.destroy();
            }
            getUnevaluatedPortalGraph() {
                return this.elevatedStructures ? this.elevatedStructures.unevaluatedPortals : void 0;
            }
            setEvaluatedPortalGraph(e1, t1, i, n, r, o) {
                this.elevatedStructures && (this.elevatedStructures.construct(e1), this.elevatedStructures.populatePaintArrays(t1, i, n, r, o));
            }
            addElevatedGeometry(e1, t1, i, n, r, o, a) {
                const s = {
                    elevation: n,
                    elevationSampler: i,
                    bias: r,
                    index: o,
                    featureInfo: a
                }, [l, c] = e1.addGeometry(t1, this.elevationBufferData, s, this.elevatedStructures);
                null == this.elevationBufferData.heightRange ? this.elevationBufferData.heightRange = {
                    min: l,
                    max: c
                } : (this.elevationBufferData.heightRange.min = Math.min(this.elevationBufferData.heightRange.min, l), this.elevationBufferData.heightRange.max = Math.max(this.elevationBufferData.heightRange.max, c));
            }
            prepareElevatedPolygons(e1, t1, i) {
                const n = 1 / _c(i), r = [];
                for (const i of e1){
                    const e1 = ny(i, new lg(t1, n), .1);
                    r.push(...e1);
                }
                return r;
            }
            clipPolygonsToTile(e1, t1) {
                const i = -t1, n = -t1, r = Sr + t1, o = Sr + t1;
                let a = 0;
                const s = [], l = [];
                for(; a < e1.length; a++){
                    const t1 = e1[a], c = Ze(t1);
                    (c.min.x >= i && c.max.x <= r && c.min.y >= n && c.max.y <= o ? s : l).push(t1);
                }
                if (s.length === e1.length) return e1;
                const c = [
                    new Re(i, n),
                    new Re(r, n),
                    new Re(r, o),
                    new Re(i, o),
                    new Re(i, n)
                ], u = s;
                for (const e1 of l)u.push(...iy(e1, c));
                return u;
            }
        }
        function py(e1, t1) {
            return e1.nextPoint.sub(t1.at(-2)).unit();
        }
        function _y(e1, t1) {
            return t1[1].sub(e1.prevPoint).unit();
        }
        Ya(fy, "FillHDExtension"), Ya(Jm, "ElevatedStructures", {
            omit: [
                "unevaluatedPortals",
                "bridgeFeatureSections",
                "tunnelFeatureSections",
                "vertexHashLookup",
                "unevalVertices",
                "unevalHeights",
                "unevalTriangles",
                "unevalTunnelTriangles",
                "unevalEdges",
                "tileToMeters"
            ]
        });
        class my {
            constructor(e1, t1){
                this.elevationEnabled = e1, this.hasDeferredElevationFeatures = !1, t1 && (this.frcData = new ly);
            }
            isEmpty() {
                const e1 = !this.elevationEnabled || void 0 === this.heightRange, t1 = !this.frcData || this.frcData.empty();
                return e1 && t1;
            }
            trackFeatureFrc(e1) {
                if (!this.frcData) return null;
                const t1 = hy(e1 || {});
                return null !== t1 && this.frcData.frcCoverage.add(t1), t1;
            }
            recordFeatureRange(e1, t1, i, n) {
                if (!this.frcData || i <= t1) return;
                const r = e1.segments.get();
                this.frcData.featureTriSegments.push({
                    start: 3 * t1,
                    end: 3 * i,
                    segIdx: r.length > 0 ? r.length - 1 : 0,
                    frc: n
                });
            }
            buildFrcSegments(e1) {
                this.frcData && !this.frcData.empty() && cy(this.frcData, e1.indexArray, e1.segments);
            }
            handleFeature(e1, t1, i, n, r, o, a, s, l, c, u) {
                if (!this.elevationEnabled) return !1;
                if (!u.terrainEnabled) {
                    const h = fg(e1, n, r ? r.registry : void 0, i), d = null != e1.properties && Object.hasOwn(e1.properties, Td) && !Number.isNaN(+e1.properties[Td]);
                    if (!h && d && o && (!r || !r.allProvidersReady)) return this.hasDeferredElevationFeatures = !0, !0;
                    if (h) {
                        let n = h.feature, o = h.tileId;
                        if (!h.tileId.equals(i)) {
                            const t1 = this.mergedFeatureCache ? this.mergedFeatureCache.get(n.id) : void 0;
                            if (t1) n = t1, o = i;
                            else {
                                const t1 = function(e1, t1, i) {
                                    if (!e1.properties || !t1 || 0 === t1.length) return [];
                                    const n = +e1.properties[Td];
                                    if (Number.isNaN(n)) return [];
                                    const r = dg(t1, n);
                                    if (r < 0) return [];
                                    const o = [];
                                    for(let e1 = r; e1 < t1.length && t1[e1].feature.id === n; e1++){
                                        const n = t1[e1];
                                        (n.tileId.isChildOf(i) || i.isChildOf(n.tileId) || null != n.feature.constantHeight) && o.push(n);
                                    }
                                    return o;
                                }(e1, r ? r.registry : void 0, i);
                                t1.length > 1 && (n = function(e1, t1) {
                                    const i = t1.slice().sort((e1, t1)=>t1.tileId.z - e1.tileId.z), n = new Re(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY), r = new Re(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY), o = [];
                                    for (const t1 of i){
                                        const i = new ug(t1.tileId, e1);
                                        for (const e1 of t1.feature.vertices)o.push({
                                            position: i.pointTransform(e1.position),
                                            height: e1.height,
                                            extent: e1.extent,
                                            index: e1.index
                                        });
                                        const a = t1.feature.safeArea;
                                        rg[0] = a.min.x, rg[1] = a.min.y, og[0] = a.max.x, og[1] = a.max.y, i.pointTransformInPlace(rg), i.pointTransformInPlace(og), n.x = Math.min(n.x, rg[0], og[0]), n.y = Math.min(n.y, rg[1], og[1]), r.x = Math.max(r.x, rg[0], og[0]), r.y = Math.max(r.y, rg[1], og[1]);
                                    }
                                    const a = {
                                        min: n,
                                        max: r
                                    };
                                    if (null != i[0].feature.constantHeight) return new cg(i[0].feature.id, a, i[0].feature.constantHeight);
                                    o.sort((e1, t1)=>e1.index - t1.index);
                                    const s = [];
                                    for (const e1 of o)0 !== s.length && s.at(-1).index === e1.index || s.push(e1);
                                    const l = [];
                                    for(let e1 = 1; e1 < s.length; e1++)s[e1].index - s[e1 - 1].index <= 1 && l.push({
                                        a: e1 - 1,
                                        b: e1
                                    });
                                    const c = 1 / _c(e1);
                                    return new cg(i[0].feature.id, a, void 0, s, l, c);
                                }(i, t1), o = i, this.mergedFeatureCache || (this.mergedFeatureCache = new Map), this.mergedFeatureCache.set(n.id, n));
                            }
                        }
                        const d = yd(t1, -1, -1, 8193, 8193), f = this.prepareElevatedLines(d, n, o, i);
                        for (const t1 of f){
                            const r = u.layoutVertexArray.length;
                            u.addLine(t1, e1, i, a, s, l, c);
                            const h = new ug(i, o), d = u.showElevationIdDebug ? hg(n.id) : null, f = u.layoutVertexArray.bytesPerElement / 2;
                            for(let e1 = r; e1 < u.layoutVertexArray.length; e1++){
                                const t1 = new Re(u.layoutVertexArray.int16[e1 * f] >> 1, u.layoutVertexArray.int16[e1 * f + 1] >> 1), i = h.pointElevation(t1, n, .05);
                                this.updateHeightRange(i), e1 < u.zOffsetVertexArray.length ? u.zOffsetVertexArray.float32[4 * e1] = i : u.zOffsetVertexArray.emplaceBack(i, 0, 0, 0), d ? e1 < u.elevationIdColVertexArray.length ? (u.elevationIdColVertexArray.float32[3 * e1] = d[0], u.elevationIdColVertexArray.float32[3 * e1 + 1] = d[1], u.elevationIdColVertexArray.float32[3 * e1 + 2] = d[2]) : u.elevationIdColVertexArray.emplaceBack(d[0], d[1], d[2]) : u.showElevationIdDebug && (e1 < u.elevationIdColVertexArray.length ? (u.elevationIdColVertexArray.float32[3 * e1] = 0, u.elevationIdColVertexArray.float32[3 * e1 + 1] = 0, u.elevationIdColVertexArray.float32[3 * e1 + 2] = 0) : u.elevationIdColVertexArray.emplaceBack(0, 0, 0));
                            }
                        }
                        return !0;
                    }
                    if (d && o && r && r.allProvidersReady && r.hasCoveringTile) return !0;
                }
                const h = !(!e1.properties || !Object.hasOwn(e1.properties, "mapbox_line_metrics")) && e1.properties.mapbox_line_metrics, d = u.layoutVertexArray.length, f = [], p = yd(t1, -1, -1, 8193, 8193, f);
                for(let t1 = 0; t1 < p.length; t1++){
                    const n = p[t1], r = f[t1], o = {
                        progress: {
                            min: r.progress.min,
                            max: r.progress.max
                        },
                        nextDir: py(r, n),
                        prevDir: _y(r, n)
                    };
                    u.addLine(n, e1, i, a, s, l, c, o, h && r.parentIndex > 0 ? r.parentIndex : null);
                }
                return u.fillNonElevatedRoadSegment(d), !0;
            }
            prepareElevatedLines(e1, t1, i, n) {
                if (null != t1.constantHeight) return e1;
                const r = [], o = 1 / _c(n), a = i.equals(n) ? null : new ug(i, n);
                for (const i of e1)xd(i, new lg(t1, o, a), 0, r);
                return r;
            }
            updateHeightRange(e1) {
                this.heightRange ? (this.heightRange.min = Math.min(this.heightRange.min, e1), this.heightRange.max = Math.max(this.heightRange.max, e1)) : this.heightRange = {
                    min: e1,
                    max: e1
                };
            }
            endPopulate() {
                this.mergedFeatureCache = void 0;
            }
        }
        Ya(my, "LineHDExtension");
        class gy {
            constructor(){
                this.elevatedLayoutVertexArray = new Lc, this.hasElevation = !1;
            }
            beginFeature(e1, t1, i) {
                const n = fg(e1, t1, void 0, i);
                this.currentFeatureElevation = n ? n.feature : void 0;
            }
            writeVertexQuad(e1, t1) {
                const i = this.currentFeatureElevation ? this.currentFeatureElevation.pointElevation(new Re(e1, t1)) : 0;
                this.hasElevation = this.hasElevation || 0 !== i;
                for(let e1 = 0; e1 < 4; e1++)this.elevatedLayoutVertexArray.emplaceBack(i);
            }
            finalize() {
                this.hasElevation || (this.elevatedLayoutVertexArray = void 0);
            }
            upload(e1) {
                this.elevatedLayoutVertexArray && !this.elevatedLayoutVertexBuffer && (this.elevatedLayoutVertexBuffer = e1.createVertexBuffer(this.elevatedLayoutVertexArray, Ld.members));
            }
            destroy() {
                this.elevatedLayoutVertexBuffer && this.elevatedLayoutVertexBuffer.destroy();
            }
        }
        Ya(gy, "CircleHDExtension");
        const yy = (e1, t1, i, n)=>{
            for(let r = 0; r < t1; r++)e1.emplaceBack(i[0], i[1], i[2], n[0], n[1], n[2]);
        };
        class xy {
            constructor(){
                this.elevationFeatures = [], this.elevationFeatureTileIds = [], this.elevationFeatureIdToIndex = new Map, this.elevationStateComplete = !1, this.hasDeferredElevationFeatures = !1, this.elevationParams = null, this.crossSourceElevationEnabled = !1, this.terrainEnabled = !1;
            }
            configureCrossSource(e1, t1, i, n) {
                this.consumerCanonical = e1, this.elevationParams = t1, this.crossSourceElevationEnabled = i, this.terrainEnabled = n;
            }
            addElevationFeatures(e1, t1) {
                for (const i of e1)this.elevationFeatureIdToIndex.set(i.id, this.elevationFeatures.length), this.elevationFeatures.push(i), this.elevationFeatureTileIds.push(t1);
            }
            resolveRoadElevation(e1, t1) {
                const i = this.elevationFeatureIdToIndex.get(t1);
                if (void 0 !== i) return i;
                if (this.terrainEnabled || !this.crossSourceElevationEnabled) return 65535;
                const n = fg(e1, void 0, this.elevationParams ? this.elevationParams.registry : void 0, this.consumerCanonical);
                if (n) {
                    const e1 = this.elevationFeatures.length;
                    return this.elevationFeatureIdToIndex.set(t1, e1), this.elevationFeatures.push(n.feature), this.elevationFeatureTileIds.push(n.tileId), e1;
                }
                return this.elevationParams && this.elevationParams.allProvidersReady ? 65535 : (this.hasDeferredElevationFeatures = !0, "defer");
            }
            getElevationFeatureSampler(e1, t1) {
                if (t1.equals(e1)) return new ug(e1, t1);
                this.elevationFeatureSamplerCache || (this.elevationFeatureSamplerCache = new Map);
                let i = this.elevationFeatureSamplerCache.get(t1.key);
                return i || (i = new ug(e1, t1), this.elevationFeatureSamplerCache.set(t1.key, i)), i;
            }
            isCrossTileRoadElevation(e1, t1) {
                if (65535 === e1 || e1 >= this.elevationFeatures.length) return !1;
                const i = this.elevationFeatureTileIds[e1];
                return null != i && !i.equals(t1);
            }
            getRoadFeatureHeightAtAnchor(e1, t1, i) {
                if (65535 === e1 || e1 >= this.elevationFeatures.length) return null;
                const n = this.elevationFeatures[e1], r = this.elevationFeatureTileIds[e1];
                return r.equals(i) ? n.pointElevation(t1) : this.getElevationFeatureSampler(i, r).pointElevation(new Re(t1.x, t1.y), n, 0);
            }
            sampleRoadFeatureHeight(e1, t1, i) {
                const n = this.getRoadFeatureHeightAtAnchor(e1, t1, i);
                return null === n ? void 0 : n;
            }
            clearWorkerState() {
                this.consumerCanonical = void 0, this.elevationParams = null, this.crossSourceElevationEnabled = !1, this.terrainEnabled = !1, this.elevationFeatureIdToIndex.clear();
            }
            updateRoadElevation(e1, t1) {
                if (this.elevationStateComplete) return;
                this.elevationStateComplete = !0, e1.hasAnyZOffset = !1;
                let i = !1;
                const n = _c(t1), r = 1 / n;
                let o = !1, a = !1;
                for(let s = 0; s < e1.symbolInstances.length; s++){
                    const l = e1.symbolInstances.get(s), c = D(1, 0, 0), u = D(0, 1, 0), { numHorizontalGlyphVertices: h, numVerticalGlyphVertices: d, numIconVertices: f, numVerticalIconVertices: p } = l, _ = h > 0 || d > 0, m = f > 0, g = l.elevationFeatureIndex, y = g < this.elevationFeatures.length ? this.elevationFeatures[g] : void 0;
                    if (y) {
                        const s = new Re(l.tileAnchorX, l.tileAnchorY), h = this.sampleRoadFeatureHeight(g, s, t1), d = void 0 !== h ? .075 + h : .075;
                        l.zOffset !== d && (i = !0, l.zOffset = d), 0 !== d && (e1.hasAnyZOffset = !0);
                        const f = y.computeSlopeNormal(s, r), p = ye(le(), D(0, 0, 1), f);
                        J(c, c, p), J(u, u, p), c[2] *= n, u[2] *= n, 1 === c[0] && 0 === c[1] && 0 === c[2] && 0 === u[0] && 1 === u[1] && 0 === u[2] || (o = o || _, a = a || m);
                    }
                    if (_ && (yy(e1.text.orientationVertexArray, h, c, u), yy(e1.text.orientationVertexArray, d, c, u)), m) {
                        const { placedIconSymbolIndex: t1, verticalPlacedIconSymbolIndex: i } = l;
                        t1 >= 0 && yy(e1.icon.orientationVertexArray, f, c, u), i >= 0 && yy(e1.icon.orientationVertexArray, p, c, u);
                    }
                }
                o || (e1.text.orientationVertexArray = void 0), a || (e1.icon.orientationVertexArray = void 0), i && (e1.zOffsetBuffersNeedUpload = !0, e1.zOffsetSortDirty = !0);
            }
            getRoadFeatureHeightForPlacedSymbol(e1, t1, i, n, r) {
                const o = e1.symbolInstances.get(t1.symbolInstanceIndices[i]);
                return this.getRoadFeatureHeightAtAnchor(o.elevationFeatureIndex, n, r);
            }
            getElevationFeatureForPlacedSymbol(e1, t1, i) {
                const n = e1.symbolInstances.get(t1.symbolInstanceIndices[i]).elevationFeatureIndex;
                if (n < this.elevationFeatures.length) return this.elevationFeatures[n];
            }
            makeRoadSymbolElevationParams(e1, t1, i, n, r, o, a, s, l) {
                const c = this.getElevationFeatureForPlacedSymbol(e1, t1, i), u = void 0 !== c ? c : null, h = e1.symbolInstances.get(t1.symbolInstanceIndices[i]);
                return this.isCrossTileRoadElevation(h.elevationFeatureIndex, n.canonical) ? {
                    getElevation: (r)=>{
                        const o = this.getRoadFeatureHeightForPlacedSymbol(e1, t1, i, r, n.canonical);
                        return function(e1, t1, i, n, r, o) {
                            const a = n.upVector(t1, i.x, i.y);
                            return N(a, a, e1 * n.upVectorScale(t1, r, o).metersToTile), [
                                a[0],
                                a[1],
                                a[2]
                            ];
                        }(null !== o ? o : 0, n.canonical, r, a, s, l);
                    },
                    elevation: o,
                    elevationFeature: null
                } : {
                    getElevation: r,
                    elevation: o,
                    elevationFeature: u
                };
            }
        }
        Ya(xy, "SymbolHDExtension", {
            omit: [
                "consumerCanonical",
                "elevationParams",
                "crossSourceElevationEnabled",
                "terrainEnabled",
                "hasDeferredElevationFeatures",
                "elevationFeatureIdToIndex"
            ]
        });
        let vy = null, by = null, wy = null, Ay = null;
        function Ey() {
            var e1;
            if (!wy) return null != Ay || (Ay = (e1 = fetch(jt()), WebAssembly.instantiateStreaming(e1, {}).then((e1)=>{
                const { sbrk: t1, memory: i, meshopt_decodeVertexBuffer: n, meshopt_decodeIndexBuffer: r, meshopt_decodeIndexSequence: o, meshopt_decodeFilterOct: a, meshopt_decodeFilterQuat: s, meshopt_decodeFilterExp: l } = e1.instance.exports, c = {
                    ATTRIBUTES: n,
                    TRIANGLES: r,
                    INDICES: o
                }, u = {
                    OCTAHEDRAL: a,
                    QUATERNION: s,
                    EXPONENTIAL: l
                };
                return e1.instance.exports.__wasm_call_ctors(), {
                    decodeGltfBuffer (e1, n, r, o, a, s) {
                        const l = n + 3 & -4, h = t1(l * r), d = t1(o.length), f = new Uint8Array(i.buffer);
                        f.set(o, d);
                        const p = c[a](h, n, r, d, o.length);
                        if (0 === p && u[s] && u[s](h, l, r), e1.set(f.subarray(h, h + n * r)), t1(h - t1(0)), 0 !== p) throw new Error(`Malformed buffer data: ${p}`);
                    }
                };
            })).then((e1)=>{
                wy = e1, Ay = null;
            })), Ay;
        }
        const Iy = 5120, My = 5121, Sy = 5122, Ty = 5123, zy = 5125, Ry = 5126, Py = {
            [Iy]: Int8Array,
            [My]: Uint8Array,
            [Sy]: Int16Array,
            [Ty]: Uint16Array,
            [zy]: Uint32Array,
            [Ry]: Float32Array
        }, Dy = {
            [Iy]: "DT_INT8",
            [My]: "DT_UINT8",
            [Sy]: "DT_INT16",
            [Ty]: "DT_UINT16",
            [zy]: "DT_UINT32",
            [Ry]: "DT_FLOAT32"
        }, Fy = {
            SCALAR: 1,
            VEC2: 2,
            VEC3: 3,
            VEC4: 4,
            MAT2: 4,
            MAT3: 9,
            MAT4: 16
        };
        function Cy(e1, t1, i) {
            const n = i.json.bufferViews.length, r = i.buffers.length;
            t1.bufferView = n, i.json.bufferViews[n] = {
                buffer: r,
                byteLength: e1.byteLength
            }, i.buffers[r] = e1;
        }
        const Oy = "KHR_draco_mesh_compression";
        function Ly(e1, t1) {
            const i = e1.extensions && e1.extensions[Oy];
            if (!i) return;
            const n = new vy.Decoder, r = Gy(t1, i.bufferView), o = new vy.Mesh;
            if (!n.DecodeArrayToMesh(r, r.byteLength, o)) throw new Error("Failed to decode Draco mesh");
            const a = t1.json.accessors[e1.indices], s = Py[a.componentType], l = a.count * s.BYTES_PER_ELEMENT, c = vy._malloc(l);
            s === Uint16Array ? n.GetTrianglesUInt16Array(o, l, c) : n.GetTrianglesUInt32Array(o, l, c), Cy(vy.memory.buffer.slice(c, c + l), a, t1), vy._free(c);
            for (const r of Object.keys(i.attributes)){
                const a = n.GetAttributeByUniqueId(o, i.attributes[r]), s = t1.json.accessors[e1.attributes[r]], l = Dy[s.componentType], c = s.count * Fy[s.type] * Py[s.componentType].BYTES_PER_ELEMENT, u = vy._malloc(c);
                n.GetAttributeDataArrayForAllPoints(o, a, vy[l], c, u), Cy(vy.memory.buffer.slice(u, u + c), s, t1), vy._free(u);
            }
            n.destroy(), o.destroy(), delete e1.extensions[Oy];
        }
        const By = "EXT_meshopt_compression";
        function Vy(e1, t1) {
            if (!e1.extensions || !e1.extensions[By]) return;
            const i = e1.extensions[By], n = new Uint8Array(t1.buffers[i.buffer], i.byteOffset || 0, i.byteLength || 0), r = new Uint8Array(i.count * i.byteStride);
            wy.decodeGltfBuffer(r, i.count, i.byteStride, n, i.mode, i.filter), e1.buffer = t1.buffers.length, e1.byteOffset = 0, t1.buffers[e1.buffer] = r.buffer, delete e1.extensions[By];
        }
        const Ny = 1179937895, ky = new TextDecoder("utf8");
        function Uy(e1, t1) {
            return new URL(e1, t1).href;
        }
        async function jy(e1, t1, i, n, r) {
            const o = await fetch(Uy(e1.uri, n), {
                signal: r
            }), a = await o.arrayBuffer();
            t1.buffers[i] = a;
        }
        function Gy(e1, t1) {
            const i = e1.json.bufferViews[t1];
            return new Uint8Array(e1.buffers[i.buffer], i.byteOffset || 0, i.byteLength);
        }
        async function Hy(e1, t1, i, n, r) {
            if (e1.uri) {
                const o = Uy(e1.uri, n), a = await fetch(o, {
                    signal: r
                }), s = await a.blob(), l = await createImageBitmap(s);
                t1.images[i] = l;
            } else if (void 0 !== e1.bufferView) {
                const n = Gy(t1, e1.bufferView), r = new Blob([
                    n
                ], {
                    type: e1.mimeType
                }), o = await createImageBitmap(r);
                t1.images[i] = o;
            }
        }
        async function $y(e1, t1 = 0, i, n) {
            const r = {
                json: null,
                images: [],
                buffers: []
            };
            if (new Uint32Array(e1, t1, 1)[0] === Ny) {
                const i = new Uint32Array(e1, t1);
                let n = 2;
                const o = (i[n++] >> 2) - 3, a = i[n++] >> 2;
                if (n++, r.json = JSON.parse(ky.decode(i.subarray(n, n + a))), n += a, n < o) {
                    const o = i[n++];
                    n++;
                    const a = t1 + (n << 2);
                    r.buffers[0] = e1.slice(a, a + o);
                }
            } else r.json = JSON.parse(ky.decode(new Uint8Array(e1, t1)));
            const { buffers: o, images: a, meshes: s, extensionsUsed: l, bufferViews: c } = r.json;
            if (o) {
                const e1 = [];
                for(let t1 = 0; t1 < o.length; t1++){
                    const a = o[t1];
                    a.uri ? e1.push(jy(a, r, t1, i, n)) : r.buffers[t1] || (r.buffers[t1] = null);
                }
                await Promise.all(e1);
            }
            n && n.throwIfAborted();
            const u = [], h = l && l.includes(Oy), d = l && l.includes(By);
            if (h && u.push(function() {
                if (!vy) return null != by || (by = (function(e1) {
                    let t1, i = null;
                    function n() {
                        t1 = new Uint8Array(i.buffer);
                    }
                    function r() {
                        throw new Error("Unexpected Draco error.");
                    }
                    return WebAssembly.instantiateStreaming(e1, {
                        a: {
                            a: r,
                            d: function(e1, i, n) {
                                return t1.copyWithin(e1, i, i + n);
                            },
                            c: function(e1) {
                                const r = t1.length, o = Math.max(e1 >>> 0, Math.ceil(1.2 * r)), a = Math.ceil((o - r) / 65536);
                                try {
                                    return i.grow(a), n(), !0;
                                } catch (e1) {
                                    return !1;
                                }
                            },
                            b: r
                        }
                    }).then((e1)=>{
                        const { Rb: r, Qb: o, P: a, T: s, X: l, Ja: c, La: u, Qa: h, Va: d, Wa: f, eb: p, jb: _, f: m, e: g, yb: y, zb: x, Ab: v, Bb: b, Db: w, Gb: A } = e1.instance.exports;
                        i = g;
                        const E = (()=>{
                            let e1 = 0, i = 0, n = 0, a = 0;
                            return (s)=>{
                                n && (r(a), r(e1), i += n, n = e1 = 0), e1 || (i += 128, e1 = o(i));
                                const l = s.length + 7 & -8;
                                let c = e1;
                                l >= i && (n = l, c = a = o(l));
                                for(let e1 = 0; e1 < s.length; e1++)t1[c + e1] = s[e1];
                                return c;
                            };
                        })();
                        return n(), m(), {
                            memory: g,
                            _free: r,
                            _malloc: o,
                            Mesh: class {
                                constructor(){
                                    this.ptr = a();
                                }
                                destroy() {
                                    s(this.ptr);
                                }
                            },
                            Decoder: class {
                                constructor(){
                                    this.ptr = c();
                                }
                                destroy() {
                                    _(this.ptr);
                                }
                                DecodeArrayToMesh(e1, t1, i) {
                                    const n = E(e1), r = u(this.ptr, n, t1, i.ptr);
                                    return !!l(r);
                                }
                                GetAttributeByUniqueId(e1, t1) {
                                    return {
                                        ptr: h(this.ptr, e1.ptr, t1)
                                    };
                                }
                                GetTrianglesUInt16Array(e1, t1, i) {
                                    d(this.ptr, e1.ptr, t1, i);
                                }
                                GetTrianglesUInt32Array(e1, t1, i) {
                                    f(this.ptr, e1.ptr, t1, i);
                                }
                                GetAttributeDataArrayForAllPoints(e1, t1, i, n, r) {
                                    p(this.ptr, e1.ptr, t1.ptr, i, n, r);
                                }
                            },
                            DT_INT8: y(),
                            DT_UINT8: x(),
                            DT_INT16: v(),
                            DT_UINT16: b(),
                            DT_UINT32: w(),
                            DT_FLOAT32: A()
                        };
                    });
                })(fetch(Ut())).then((e1)=>{
                    vy = e1, by = null;
                })), by;
            }()), d && u.push(Ey()), a) for(let e1 = 0; e1 < a.length; e1++)u.push(Hy(a[e1], r, e1, i, n));
            if (u.length && await Promise.all(u), n && n.throwIfAborted(), h && s) for (const { primitives: e1 } of s)for (const t1 of e1)Ly(t1, r);
            if (d && s && c) for (const e1 of c)Vy(e1, r);
            return r;
        }
        async function Zy(e1, t1) {
            const { data: i } = await pi(e1, t1);
            return $y(i, 0, e1.url, t1);
        }
        class Wy {
            constructor(e1, t1, i, n){
                if (this.triangleCount = t1.length / 3, this.min = new Re(0, 0), this.max = new Re(0, 0), this.xScale = 0, this.yScale = 0, this.cellsX = 0, this.cellsY = 0, this.cellOffsets = new Uint32Array(1), this.payload = new Uint32Array(0), 0 === this.triangleCount || 0 === e1.length) return;
                const [r, o] = [
                    e1[0].clone(),
                    e1[0].clone()
                ];
                for(let t1 = 1; t1 < e1.length; ++t1){
                    const i = e1[t1];
                    r.x = Math.min(r.x, i.x), r.y = Math.min(r.y, i.y), o.x = Math.max(o.x, i.x), o.y = Math.max(o.y, i.y);
                }
                if (n) {
                    const e1 = Math.ceil(Math.max(o.x - r.x, o.y - r.y) / n);
                    i = Math.max(i, e1);
                }
                if (0 === i) return;
                this.min = r, this.max = o;
                const a = this.max.sub(this.min);
                a.x = Math.max(a.x, 1), a.y = Math.max(a.y, 1);
                const s = Math.max(a.x, a.y) / i;
                this.cellsX = Math.max(1, Math.ceil(a.x / s)), this.cellsY = Math.max(1, Math.ceil(a.y / s)), this.xScale = 1 / s, this.yScale = 1 / s;
                const l = this.cellsX * this.cellsY, c = new Uint32Array(l + 1), u = [];
                for(let i = 0; i < this.triangleCount; i++){
                    const n = e1[t1[3 * i + 0]].sub(this.min), r = e1[t1[3 * i + 1]].sub(this.min), o = e1[t1[3 * i + 2]].sub(this.min), a = qy(Math.floor(Math.min(n.x, r.x, o.x)), this.xScale, this.cellsX), l = qy(Math.floor(Math.max(n.x, r.x, o.x)), this.xScale, this.cellsX), h = qy(Math.floor(Math.min(n.y, r.y, o.y)), this.yScale, this.cellsY), d = qy(Math.floor(Math.max(n.y, r.y, o.y)), this.yScale, this.cellsY), f = new Re(0, 0), p = new Re(0, 0), _ = new Re(0, 0), m = new Re(0, 0);
                    for(let e1 = h; e1 <= d; ++e1){
                        f.y = p.y = e1 * s, _.y = m.y = (e1 + 1) * s;
                        for(let t1 = a; t1 <= l; ++t1){
                            if (f.x = _.x = t1 * s, p.x = m.x = (t1 + 1) * s, !fd(n, r, o, f, p, m) && !fd(n, r, o, f, m, _)) continue;
                            const a = e1 * this.cellsX + t1;
                            u.push(a, i), c[a + 1]++;
                        }
                    }
                }
                if (this.cellOffsets = c, 0 === u.length) return;
                for(let e1 = 0; e1 < l; e1++)c[e1 + 1] += c[e1];
                const h = this.payload = new Uint32Array(u.length / 2), d = c.slice(0, l);
                for(let e1 = 0; e1 < u.length; e1 += 2)h[d[u[e1]]++] = u[e1 + 1];
            }
            _lazyInitLookup() {
                this.lookup || (this.lookup = new Uint8Array(Math.ceil(this.triangleCount / 8))), this.lookup.fill(0);
            }
            queryPoint(e1, t1) {
                if (0 === this.payload.length) return;
                if (e1.x > this.max.x || this.min.x > e1.x || e1.y > this.max.y || this.min.y > e1.y) return;
                const i = qy(e1.x - this.min.x, this.xScale, this.cellsX), n = qy(e1.y - this.min.y, this.yScale, this.cellsY) * this.cellsX + i, r = this.cellOffsets[n], o = this.cellOffsets[n + 1];
                if (r !== o) {
                    this._lazyInitLookup();
                    for(let e1 = r; e1 < o; e1++){
                        const i = this.payload[e1], n = Math.floor(i / 8), r = 1 << i % 8;
                        if (!(this.lookup[n] & r) && (this.lookup[n] |= r, t1.push(i), t1.length === this.triangleCount)) return;
                    }
                }
            }
            query(e1, t1, i) {
                if (0 === this.payload.length) return;
                if (e1.x > this.max.x || this.min.x > t1.x) return;
                if (e1.y > this.max.y || this.min.y > t1.y) return;
                this._lazyInitLookup();
                const n = qy(e1.x - this.min.x, this.xScale, this.cellsX), r = qy(t1.x - this.min.x, this.xScale, this.cellsX), o = qy(e1.y - this.min.y, this.yScale, this.cellsY), a = qy(t1.y - this.min.y, this.yScale, this.cellsY);
                for(let e1 = o; e1 <= a; e1++)for(let t1 = n; t1 <= r; t1++){
                    const n = e1 * this.cellsX + t1, r = this.cellOffsets[n + 1];
                    for(let e1 = this.cellOffsets[n]; e1 < r; e1++){
                        const t1 = this.payload[e1], n = Math.floor(t1 / 8), r = 1 << t1 % 8;
                        if (!(this.lookup[n] & r) && (this.lookup[n] |= r, i.push(t1), i.length === this.triangleCount)) return;
                    }
                }
            }
        }
        function qy(e1, t1, i) {
            return Math.max(0, Math.min(i - 1, Math.floor(e1 * t1)));
        }
        Ya(Wy, "TriangleGridIndex");
        const Xy = Pc([
            {
                name: "a_pos_3f",
                components: 3,
                type: "Float32"
            }
        ]), Yy = Pc([
            {
                name: "a_color_3f",
                components: 3,
                type: "Float32"
            }
        ]), Jy = Pc([
            {
                name: "a_color_4f",
                components: 4,
                type: "Float32"
            }
        ]), Ky = Pc([
            {
                name: "a_uv_2f",
                components: 2,
                type: "Float32"
            }
        ]), Qy = Pc([
            {
                name: "a_uv_2f",
                components: 2,
                type: "Uint16",
                normalized: !0
            }
        ]), ex = Pc([
            {
                name: "a_normal_4n",
                components: 4,
                type: "Int8",
                normalized: !0
            }
        ]), tx = Pc([
            {
                name: "a_normal_matrix0",
                components: 4,
                type: "Float32"
            },
            {
                name: "a_normal_matrix1",
                components: 4,
                type: "Float32"
            },
            {
                name: "a_normal_matrix2",
                components: 4,
                type: "Float32"
            },
            {
                name: "a_normal_matrix3",
                components: 4,
                type: "Float32"
            }
        ]), ix = Pc([
            {
                name: "a_feature",
                components: 2,
                type: "Uint16"
            }
        ]);
        function nx(e1, t1) {
            const i = ox(e1.projection, e1.zoom, e1.width, e1.height), n = function(e1, t1, i, n, r) {
                const o = new ac(i.lng - 180 * ax, i.lat), a = new ac(i.lng + 180 * ax, i.lat), s = e1.project(o.lng, o.lat), l = e1.project(a.lng, a.lat), c = -Math.atan2(l.y - s.y, l.x - s.x), u = mc.fromLngLat(i);
                u.y = tt(u.y, -1 + ax, 1 - ax);
                const h = u.toLngLat(), f = e1.project(h.lng, h.lat), p = mc.fromLngLat(h);
                p.x += ax;
                const m = p.toLngLat(), y = e1.project(m.lng, m.lat), x = lx(y.x - f.x, y.y - f.y, c), b = mc.fromLngLat(h);
                b.y += ax;
                const w = b.toLngLat(), A = e1.project(w.lng, w.lat), E = lx(A.x - f.x, A.y - f.y, c), I = Math.abs(x.x) / Math.abs(E.y), M = d([]);
                v(M, M, -c * (1 - (r ? 0 : n)));
                const S = d([]);
                return g(S, S, [
                    1,
                    1 - (1 - I) * n,
                    1
                ]), S[4] = -E.x / E.y * n, v(S, S, c), _(S, M, S), S;
            }(e1.projection, 0, e1.center, i, t1), r = rx(e1);
            return g(n, n, [
                r,
                r,
                1
            ]), n;
        }
        function rx(e1) {
            const t1 = e1.projection, i = ox(e1.projection, e1.zoom, e1.width, e1.height), n = sx(t1, e1.center), r = sx(t1, ac.convert(t1.center));
            return Math.pow(2, n * i + (1 - i) * r);
        }
        function ox(e1, t1, i, n, r = 1 / 0) {
            const o = e1.range;
            if (!o) return 0;
            const a = Math.min(r, Math.max(i, n)), s = Math.log2(a / 1024);
            return it(o[0] + s, o[1] + s, t1);
        }
        const ax = 1 / 4e4;
        function sx(e1, t1) {
            const i = tt(t1.lat, -85.051129, hc), n = new ac(t1.lng - 180 * ax, i), r = new ac(t1.lng + 180 * ax, i), o = e1.project(n.lng, i), a = e1.project(r.lng, i), s = mc.fromLngLat(n), l = mc.fromLngLat(r), c = a.x - o.x, u = a.y - o.y, h = l.x - s.x, d = l.y - s.y, f = Math.sqrt((h * h + d * d) / (c * c + u * u));
            return Math.log2(f);
        }
        function lx(e1, t1, i) {
            const n = Math.cos(i), r = Math.sin(i);
            return {
                x: e1 * n - t1 * r,
                y: e1 * r + t1 * n
            };
        }
        const cx = new Float64Array([
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            1
        ]);
        function ux(e1, t1, i) {
            d(e1), v(e1, e1, Ye(t1[2])), y(e1, e1, Ye(t1[0])), x(e1, e1, Ye(t1[1])), g(e1, e1, i), _(e1, e1, cx);
        }
        function hx(e1, t1, i, n, r, o, a, s) {
            const l = [
                i[0] - t1[0],
                i[1] - t1[1],
                0
            ], c = [
                n[0] - t1[0],
                n[1] - t1[1],
                0
            ];
            if (P(l) < 1e-12 || P(c) < 1e-12) return ce(e1);
            const u = W([], l, c);
            $(u, u), O(c, n, t1), l[2] = (o - r) * s, c[2] = (a - r) * s;
            const h = l;
            return W(h, l, c), $(h, h), ye(e1, u, h);
        }
        function dx(e1, t1, i = !1) {
            const n = cp(t1.zoom), r = function(e1, t1, i) {
                const n = t1.worldSize, r = [
                    e1[12],
                    e1[13],
                    e1[14]
                ], o = fr(r[1] / n), a = dr(r[0] / n), s = d([]), l = cc(1, o) * n, c = cc(1, 0) * n * fc(o, t1.zoom), u = 1 / ap(n);
                let h = c * u;
                if (i) {
                    const e1 = ox(t1.projection, t1.zoom, t1.width, t1.height, 1024);
                    h = u * t1.projection.pixelSpaceConversion(t1.center.lat, n, e1);
                }
                const f = nc(o, a);
                C(f, f, N([], $([], f), l * h * r[2]));
                const p = function(e1) {
                    const t1 = [
                        e1[0],
                        e1[1],
                        e1[2]
                    ];
                    let i = [
                        0,
                        1,
                        0
                    ];
                    const n = W([], i, t1);
                    return W(i, t1, n), 0 === G(i) && (i = [
                        0,
                        1,
                        0
                    ], W(n, t1, i)), $(n, n), $(i, i), $(t1, t1), [
                        n[0],
                        n[1],
                        n[2],
                        0,
                        i[0],
                        i[1],
                        i[2],
                        0,
                        t1[0],
                        t1[1],
                        t1[2],
                        0,
                        e1[0],
                        e1[1],
                        e1[2],
                        1
                    ];
                }(f);
                g(s, s, [
                    h,
                    h,
                    h * l
                ]), m(s, s, [
                    -r[0],
                    -r[1],
                    -r[2]
                ]);
                const y = _([], t1.globeMatrix, p);
                return _(y, y, s), _(y, y, e1), y;
            }(e1, t1, i);
            if (n > 0) {
                const i = function(e1, t1) {
                    const i = t1.worldSize, n = cc(1, 0) * i * fc(t1.center.lat, t1.zoom) / ap(i), r = cc(1, t1.center.lat) * i, o = d([]);
                    x(o, o, Ye(t1.center.lng)), y(o, o, Ye(t1.center.lat)), m(o, o, [
                        0,
                        0,
                        Jl
                    ]), g(o, o, [
                        n,
                        n,
                        n * r
                    ]);
                    const a = t1.point;
                    return m(o, o, [
                        -a.x,
                        -a.y,
                        0
                    ]), _(o, o, e1), _(o, t1.globeMatrix, o);
                }(e1, t1);
                return function(e1, t1, i) {
                    const n = (e1, t1, i)=>{
                        const n = P(e1), r = P(t1), o = Yf(e1, t1, i);
                        return N(o, o, 1 / P(o) * hn(n, r, i));
                    }, r = n([
                        e1[0],
                        e1[1],
                        e1[2]
                    ], [
                        t1[0],
                        t1[1],
                        t1[2]
                    ], i), o = n([
                        e1[4],
                        e1[5],
                        e1[6]
                    ], [
                        t1[4],
                        t1[5],
                        t1[6]
                    ], i), a = n([
                        e1[8],
                        e1[9],
                        e1[10]
                    ], [
                        t1[8],
                        t1[9],
                        t1[10]
                    ], i), s = Yf([
                        e1[12],
                        e1[13],
                        e1[14]
                    ], [
                        t1[12],
                        t1[13],
                        t1[14]
                    ], i);
                    return [
                        r[0],
                        r[1],
                        r[2],
                        0,
                        o[0],
                        o[1],
                        o[2],
                        0,
                        a[0],
                        a[1],
                        a[2],
                        0,
                        s[0],
                        s[1],
                        s[2],
                        1
                    ];
                }(r, i, n);
            }
            return r;
        }
        function fx(e1, t1, i, n) {
            const r = Nf.projectAabbCorners(n, i);
            let o = Number.MAX_VALUE;
            for(let e1 = 0; e1 < r.length; ++e1){
                const i = r[e1];
                i[0] = (.5 * i[0] + .5) * t1.width, i[1] = (.5 - .5 * i[1]) * t1.height, i[2] < o && (o = i[2]);
            }
            const a = function(e1) {
                const t1 = [];
                let i = 0;
                for(let t1 = 1; t1 < e1.length; t1++)(e1[t1][0] < e1[i][0] || e1[t1][0] === e1[i][0] && e1[t1][1] < e1[i][1]) && (i = t1);
                let n, r = i;
                const o = new Uint8Array(e1.length);
                do {
                    if (o[r]) break;
                    t1.push(new Re(e1[r][0], e1[r][1])), o[r] = 1, n = (r + 1) % e1.length;
                    for(let t1 = 0; t1 < e1.length; t1++){
                        if (e1[t1][0] === e1[n][0] && e1[t1][1] === e1[n][1] || e1[t1][0] === e1[r][0] && e1[t1][1] === e1[r][1]) continue;
                        const i = [
                            e1[t1][0] - e1[r][0],
                            e1[t1][1] - e1[r][1]
                        ], o = [
                            e1[n][0] - e1[r][0],
                            e1[n][1] - e1[r][1]
                        ], a = i[0] * o[1] - i[1] * o[0];
                        (a > 0 || 0 === a && i[0] * o[0] + i[1] * o[1] >= 0 && i[0] * i[0] + i[1] * i[1] > o[0] * o[0] + o[1] * o[1]) && (n = t1);
                    }
                    r = n;
                }while (r !== i);
                return t1.length > 0 && t1.push(t1[0]), t1;
            }(r);
            if (Kh(e1, a)) return o;
        }
        const px = 64, _x = [
            "",
            "wall",
            "door",
            "roof",
            "window",
            "lamp",
            "logo"
        ], mx = [
            1,
            1,
            1
        ];
        function gx(e1, t1, i, n, r, o, a, s, l, c = !1) {
            const u = i.zoom, h = i.project(n), f = fc(n.lat, u), p = 1 / f;
            d(e1), m(e1, e1, [
                h.x + a[0] * p,
                h.y + a[1] * p,
                a[2]
            ]);
            let y = 1, x = 1;
            const v = i.worldSize;
            if (c) {
                if ("mercator" === i.projection.name) {
                    let e1 = 0;
                    i.elevation && (e1 = i.elevation.getAtPointOrZero(new mc(h.x / v, h.y / v), 0));
                    const t1 = se([], [
                        h.x,
                        h.y,
                        e1,
                        1
                    ], i.projMatrix)[3] / i.cameraToCenterDistance;
                    y = t1, x = t1 * fc(i.center.lat, u);
                } else if ("globe" === i.projection.name) {
                    const t1 = dx(e1, i), r = [
                        0,
                        0,
                        0,
                        1
                    ];
                    se(r, r, _([], i.projMatrix, t1));
                    const o = r[3] / i.cameraToCenterDistance, a = cp(u), s = i.projection.pixelsPerMeter(n.lat, v) * fc(n.lat, u), l = i.projection.pixelsPerMeter(i.center.lat, v) * fc(i.center.lat, u);
                    y = o / hn(s, dc(i.center.lat), a), x = o * f / s, y *= l, x *= l;
                }
            } else y = p;
            g(e1, e1, [
                y,
                y,
                x
            ]);
            const b = [
                ...e1
            ], w = t1.orientation, A = [];
            if (ux(A, [
                w[0] + (r ? r[0] : 0),
                w[1] + (r ? r[1] : 0),
                w[2] + (r ? r[2] : 0)
            ], o), _(e1, b, A), s && i.elevation) {
                let r = 0;
                const o = [];
                if (l && i.elevation) {
                    r = function(e1, t1, i, n, r) {
                        const o = t1.elevation;
                        if (!o) return 0;
                        const a = Nf.projectAabbCorners(i, n), s = cc(1, r.lat) * t1.worldSize, l = function(e1, t1) {
                            const i = [
                                0,
                                0,
                                1
                            ], n = [
                                {
                                    corners: [
                                        0,
                                        1,
                                        3,
                                        2
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        1,
                                        5,
                                        2,
                                        6
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        0,
                                        4,
                                        1,
                                        5
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        2,
                                        6,
                                        3,
                                        7
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        4,
                                        7,
                                        5,
                                        6
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        0,
                                        3,
                                        4,
                                        7
                                    ],
                                    dotProductWithUp: 0
                                }
                            ];
                            for (const r of n){
                                const n = e1[r.corners[0]], o = e1[r.corners[1]], a = e1[r.corners[2]], s = [
                                    o[0] - n[0],
                                    o[1] - n[1],
                                    t1 * (o[2] - n[2])
                                ], l = W(s, s, [
                                    a[0] - n[0],
                                    a[1] - n[1],
                                    t1 * (a[2] - n[2])
                                ]);
                                $(l, l), r.dotProductWithUp = Z(l, i);
                            }
                            return n.sort((e1, t1)=>e1.dotProductWithUp - t1.dotProductWithUp), n[0].corners;
                        }(a, s), c = a[l[0]], u = a[l[1]], h = a[l[2]], d = a[l[3]], f = o.getAtPointOrZero(new mc(c[0] / t1.worldSize, c[1] / t1.worldSize), 0), p = o.getAtPointOrZero(new mc(u[0] / t1.worldSize, u[1] / t1.worldSize), 0), _ = o.getAtPointOrZero(new mc(h[0] / t1.worldSize, h[1] / t1.worldSize), 0), m = o.getAtPointOrZero(new mc(d[0] / t1.worldSize, d[1] / t1.worldSize), 0), g = (f + m) / 2, y = (p + _) / 2;
                        return g > y ? p < _ ? hx(e1, u, d, c, p, m, f, s) : hx(e1, h, c, d, _, f, m, s) : f < m ? hx(e1, c, u, h, f, p, _, s) : hx(e1, d, h, u, m, _, p, s), Math.max(g, y);
                    }(o, i, t1.aabb, e1, n);
                    const a = _([], M([], o), A);
                    _(e1, b, a);
                } else r = i.elevation.getAtPointOrZero(new mc(h.x / v, h.y / v), 0);
                0 !== r && (e1[14] += r);
            }
        }
        class yx {
            constructor(e1, t1, i, n, r){
                this.materialOverrides = new Map, this.nodeOverrides = new Map, this.materialOverrideNames = [], this.nodeOverrideNames = [], this.featureProperties = {}, this.id = e1, this.uri = t1, this.position = null != i ? new ac(i[0], i[1]) : new ac(0, 0), this.orientation = n ?? [
                    0,
                    0,
                    0
                ], this.nodes = r, this.uploaded = !1, this.aabb = new Nf([
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ]), this.matrix = [];
            }
            _applyTransformations(e1, t1) {
                _(e1.globalMatrix, t1, e1.localMatrix);
                const i = this.nodeOverrides.get(e1.name);
                if (void 0 !== i) {
                    if (i.orientation) {
                        const t1 = [];
                        r = i.orientation, d(n = t1), x(n, n, Ye(r[1])), v(n, n, Ye(r[2])), y(n, n, Ye(r[0])), _(e1.globalMatrix, e1.globalMatrix, t1);
                    }
                    i.minZoom && (e1.minZoom = i.minZoom), i.maxZoom && (e1.maxZoom = i.maxZoom);
                }
                var n, r;
                if (e1.meshes) for (const t1 of e1.meshes){
                    const i = Nf.applyTransformFast(t1.aabb, e1.globalMatrix);
                    this.aabb.encapsulate(i);
                }
                if (e1.children) for (const t1 of e1.children)this._applyTransformations(t1, e1.globalMatrix);
            }
            computeBoundsAndApplyParent() {
                const e1 = d(new Float64Array(16));
                this.aabb = new Nf([
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ]);
                for (const t1 of this.nodes)this._applyTransformations(t1, e1);
            }
            computeModelMatrix(e1, t1, i, n, r, o, a = !1) {
                gx(this.matrix, this, e1.transform, this.position, t1, i, n, r, o, a);
            }
            upload(e1) {
                if (!this.uploaded) {
                    for (const t1 of this.nodes)bx(t1, e1);
                    for (const e1 of this.nodes)Ax(e1);
                    this.uploaded = !0;
                }
            }
            destroy() {
                for (const e1 of this.nodes)Ix(e1);
            }
        }
        function xx(e1, t1, i = !1) {
            e1.uploaded || (e1.gfxTexture = new X_(t1, e1.image, i ? t1.gl.R8 : t1.gl.RGBA8, {
                useMipmap: e1.sampler.minFilter >= t1.gl.NEAREST_MIPMAP_NEAREST
            }), e1.uploaded = !0, e1.image = null);
        }
        function vx(e1, t1, i) {
            e1.indexBuffer = t1.createIndexBuffer(e1.indexArray, !1, !0), e1.vertexBuffer = t1.createVertexBuffer(e1.vertexArray, Xy.members, !1, !0), e1.normalArray && (e1.normalBuffer = t1.createVertexBuffer(e1.normalArray, ex.members, !1, !0)), e1.texcoordArray && (e1.texcoordBuffer = t1.createVertexBuffer(e1.texcoordArray, (8 === e1.texcoordArray.bytesPerElement ? Ky : Qy).members, !1, !0)), e1.colorArray && (e1.colorBuffer = t1.createVertexBuffer(e1.colorArray, (12 === e1.colorArray.bytesPerElement ? Yy : Jy).members, !1, !0)), e1.featureArray && (e1.featureBuffer = t1.createVertexBuffer(e1.featureArray, ix.members, !1, !0)), e1.segments = Ou.simpleSegment(0, 0, e1.vertexArray.length, e1.indexArray.length);
            const n = e1.material;
            n.pbrMetallicRoughness.baseColorTexture && xx(n.pbrMetallicRoughness.baseColorTexture, t1), n.pbrMetallicRoughness.metallicRoughnessTexture && xx(n.pbrMetallicRoughness.metallicRoughnessTexture, t1), n.normalTexture && xx(n.normalTexture, t1), n.occlusionTexture && xx(n.occlusionTexture, t1, i), n.emissionTexture && xx(n.emissionTexture, t1);
        }
        function bx(e1, t1, i) {
            if (e1.meshes) for (const n of e1.meshes)vx(n, t1, i);
            if (e1.lodMeshes) for (const n of e1.lodMeshes)vx(n, t1, i);
            if (e1.children) for (const n of e1.children)bx(n, t1, i);
        }
        function wx(e1) {
            e1.indexArray.destroy(), e1.vertexArray.destroy(), e1.colorArray && e1.colorArray.destroy(), e1.normalArray && e1.normalArray.destroy(), e1.texcoordArray && e1.texcoordArray.destroy(), e1.featureArray && e1.featureArray.destroy();
        }
        function Ax(e1) {
            if (e1.meshes) for (const t1 of e1.meshes)wx(t1);
            if (e1.lodMeshes) for (const t1 of e1.lodMeshes)wx(t1);
            if (e1.children) for (const t1 of e1.children)Ax(t1);
        }
        function Ex(e1) {
            var t1;
            e1.vertexBuffer && (e1.vertexBuffer.destroy(), e1.indexBuffer.destroy(), e1.normalBuffer && e1.normalBuffer.destroy(), e1.texcoordBuffer && e1.texcoordBuffer.destroy(), e1.colorBuffer && e1.colorBuffer.destroy(), e1.featureBuffer && e1.featureBuffer.destroy(), e1.segments.destroy(), e1.material && ((t1 = e1.material).pbrMetallicRoughness.baseColorTexture && t1.pbrMetallicRoughness.baseColorTexture.gfxTexture && t1.pbrMetallicRoughness.baseColorTexture.gfxTexture.destroy(), t1.pbrMetallicRoughness.metallicRoughnessTexture && t1.pbrMetallicRoughness.metallicRoughnessTexture.gfxTexture && t1.pbrMetallicRoughness.metallicRoughnessTexture.gfxTexture.destroy(), t1.normalTexture && t1.normalTexture.gfxTexture && t1.normalTexture.gfxTexture.destroy(), t1.emissionTexture && t1.emissionTexture.gfxTexture && t1.emissionTexture.gfxTexture.destroy(), t1.occlusionTexture && t1.occlusionTexture.gfxTexture && t1.occlusionTexture.gfxTexture.destroy()));
        }
        function Ix(e1) {
            if (e1.meshes) for (const t1 of e1.meshes)Ex(t1);
            if (e1.lodMeshes) for (const t1 of e1.lodMeshes)Ex(t1);
            if (e1.footprintDebugMesh && (e1.footprintDebugMesh.vertexBuffer.destroy(), e1.footprintDebugMesh.indexBuffer.destroy(), e1.footprintDebugMesh.segments.destroy()), e1.children) for (const t1 of e1.children)Ix(t1);
        }
        function Mx(e1, t1, i, n, r) {
            const o = 3 * i;
            return e1[o] <= r[0] && t1[o] >= n[0] && e1[o + 1] <= r[1] && t1[o + 1] >= n[1] && e1[o + 2] <= r[2] && t1[o + 2] >= n[2];
        }
        function Sx(e1, t1, i, n, r, o, a, s, l, c, u) {
            const h = .5 * (c[0] + u[0]), d = .5 * (c[1] + u[1]), f = .5 * (c[2] + u[2]), p = .5 * (u[0] - c[0]), _ = .5 * (u[1] - c[1]), m = .5 * (u[2] - c[2]), g = e1 - h, y = t1 - d, x = i - f, v = n - h, b = r - d, w = o - f, A = a - h, E = s - d, I = l - f, M = v - g, S = b - y, T = w - x, z = A - v, R = E - b, P = I - w, D = g - A, F = y - E, C = x - I;
            let O, L, B, V, N, k;
            if (O = x * S - y * T, L = w * S - b * T, B = I * S - E * T, V = Math.min(O, L, B), N = Math.max(O, L, B), k = Math.abs(T) * _ + Math.abs(S) * m, V > k || N < -k) return !1;
            if (O = x * R - y * P, L = w * R - b * P, B = I * R - E * P, V = Math.min(O, L, B), N = Math.max(O, L, B), k = Math.abs(P) * _ + Math.abs(R) * m, V > k || N < -k) return !1;
            if (O = x * F - y * C, L = w * F - b * C, B = I * F - E * C, V = Math.min(O, L, B), N = Math.max(O, L, B), k = Math.abs(C) * _ + Math.abs(F) * m, V > k || N < -k) return !1;
            if (O = g * T - x * M, L = v * T - w * M, B = A * T - I * M, V = Math.min(O, L, B), N = Math.max(O, L, B), k = Math.abs(T) * p + Math.abs(M) * m, V > k || N < -k) return !1;
            if (O = g * P - x * z, L = v * P - w * z, B = A * P - I * z, V = Math.min(O, L, B), N = Math.max(O, L, B), k = Math.abs(P) * p + Math.abs(z) * m, V > k || N < -k) return !1;
            if (O = g * C - x * D, L = v * C - w * D, B = A * C - I * D, V = Math.min(O, L, B), N = Math.max(O, L, B), k = Math.abs(C) * p + Math.abs(D) * m, V > k || N < -k) return !1;
            if (O = y * M - g * S, L = b * M - v * S, B = E * M - A * S, V = Math.min(O, L, B), N = Math.max(O, L, B), k = Math.abs(S) * p + Math.abs(M) * _, V > k || N < -k) return !1;
            if (O = y * z - g * R, L = b * z - v * R, B = E * z - A * R, V = Math.min(O, L, B), N = Math.max(O, L, B), k = Math.abs(R) * p + Math.abs(z) * _, V > k || N < -k) return !1;
            if (O = y * D - g * F, L = b * D - v * F, B = E * D - A * F, V = Math.min(O, L, B), N = Math.max(O, L, B), k = Math.abs(F) * p + Math.abs(D) * _, V > k || N < -k) return !1;
            if (V = Math.min(g, v, A), N = Math.max(g, v, A), V > p || N < -p) return !1;
            if (V = Math.min(y, b, E), N = Math.max(y, b, E), V > _ || N < -_) return !1;
            if (V = Math.min(x, w, I), N = Math.max(x, w, I), V > m || N < -m) return !1;
            const U = S * P - T * R, j = T * z - M * P, G = M * R - S * z, H = -(U * g + j * y + G * x);
            return k = p * Math.abs(U) + _ * Math.abs(j) + m * Math.abs(G), !(Math.abs(H) > k);
        }
        const Tx = [];
        class zx {
            serializeFromGltf(e1, t1, i, n) {
                if (e1.length < 7) return;
                let r = 0;
                if (109 !== e1[r++] || 98 !== e1[r++] || 120 !== e1[r++] || 98 !== e1[r++] || 118 !== e1[r++] || 104 !== e1[r++]) return;
                if (43 !== e1[r++]) return;
                const o = new DataView(e1.buffer, e1.byteOffset), a = o.getUint16(r, !0);
                if (r += 2, 0 === a) return;
                this._nodeMin = t1.slice(0, 3 * a), this._nodeMax = i.slice(0, 3 * a);
                const s = this._nodeData = new Uint32Array(3 * a);
                for(let e1 = 0; e1 < a; e1++){
                    const t1 = o.getUint16(r, !0);
                    r += 2, s[3 * e1] = t1, 65535 === t1 && (s[3 * e1 + 1] = o.getUint16(r, !0), r += 2, s[3 * e1 + 2] = o.getUint32(r, !0), r += 4);
                }
                const l = o.getUint32(r, !0);
                let c = 0;
                for(let e1 = 0; e1 < l; e1++)n[e1] > c && (c = n[e1]);
                this._indices = c < 65536 ? new Uint16Array(n.subarray(0, l)) : n.slice(0, l);
            }
            setVertices(e1) {
                this._vertices = e1;
            }
            findHighestPoint(e1, t1) {
                const i = this._nodeData;
                if (!i) return null;
                const n = this._nodeMin, r = this._nodeMax;
                if (!Mx(n, r, 0, e1, t1)) return null;
                const o = this._indices, a = this._vertices, s = Tx;
                s.length = 0, s.push(0);
                let l = -1 / 0;
                for(; s.length > 0;){
                    const c = s.pop();
                    if (r[3 * c + 2] <= l) continue;
                    const u = i[3 * c];
                    if (65535 === u) {
                        const n = i[3 * c + 1], r = i[3 * c + 2];
                        for(let i = 0; i < n; i += 3){
                            const n = 3 * o[r + i], s = 3 * o[r + i + 1], c = 3 * o[r + i + 2];
                            Sx(a[n], a[n + 1], a[n + 2], a[s], a[s + 1], a[s + 2], a[c], a[c + 1], a[c + 2], e1, t1) && (l = Math.max(l, a[n + 2], a[s + 2], a[c + 2]));
                        }
                        continue;
                    }
                    const h = c + 1, d = Mx(n, r, h, e1, t1), f = Mx(n, r, u, e1, t1);
                    d && f ? r[3 * h + 2] < r[3 * u + 2] ? (s.push(h), s.push(u)) : (s.push(u), s.push(h)) : d ? s.push(h) : f && s.push(u);
                }
                return l >= 0 ? l : null;
            }
        }
        function Rx(e1) {
            switch(e1){
                case Int8Array:
                    return 1 / 127;
                case Uint8Array:
                    return 1 / 255;
                case Int16Array:
                    return 1 / 32767;
                case Uint16Array:
                    return 1 / 65535;
                default:
                    return 1;
            }
        }
        function Px(e1, t1) {
            const i = e1.json.bufferViews[t1.bufferView], n = Py[t1.componentType];
            return new n(e1.buffers[i.buffer], (t1.byteOffset || 0) + (i.byteOffset || 0), t1.count * (i.byteStride && i.byteStride !== Fy[t1.type] * n.BYTES_PER_ELEMENT ? i.byteStride / n.BYTES_PER_ELEMENT : Fy[t1.type]));
        }
        function Dx(e1, t1, i, n) {
            const r = Px(e1, t1), o = r instanceof Float32Array ? r : new Uint32Array(r.buffer, r.byteOffset, t1.count), a = new Jc;
            a.reserveExact(t1.count);
            let s = -1;
            for(let e1 = 0; e1 < t1.count; e1++){
                const t1 = i ? o[e1] >>> 16 | o[e1] << 16 : o[e1], n = 65535 & t1, r = t1 >>> 16;
                s = s < 0 && 2 == (15 & r) ? n : s, a.emplaceBack(n, r);
            }
            n.featureArray = a, s >= 0 && (n.doorVertexColor = s);
        }
        function Fx(e1, t1, i, n, r = !0) {
            const o = Py[t1.componentType], a = Fy[t1.type], s = r ? Rx(o) : 1, l = e1.json.bufferViews[t1.bufferView], c = l.byteStride ? l.byteStride / o.BYTES_PER_ELEMENT : a, u = t1.count * c;
            for(let e1 = 0, t1 = 0; e1 < u; e1 += c, t1 += a)for(let r = 0; r < a; r++)i[t1 + r] = n[e1 + r] * s;
        }
        function Cx(e1, t1, i) {
            const n = e1.indices, r = e1.attributes, o = {};
            o.indexArray = new nu;
            const a = t1.json.accessors[n], s = Px(t1, a);
            o.indexArray.resizeExact(a.count / 3), o.indexArray.uint16.set(s), o.vertexArray = new jc;
            const l = t1.json.accessors[r.POSITION], c = Px(t1, l);
            o.vertexArray.resizeExact(l.count), o.vertexArray.float32.set(c), o.aabb = new Nf(l.min, l.max);
            const [u, h, d] = l.min, [f, p, _] = l.max;
            if (o.centroid = [
                .5 * (u + f),
                .5 * (h + p),
                .5 * (d + _)
            ], void 0 !== r.COLOR_0) {
                const e1 = t1.json.accessors[r.COLOR_0], i = Fy[e1.type], n = Px(t1, e1);
                o.colorArray = 3 === i ? new jc : new qc, o.colorArray.resizeExact(e1.count), Fx(t1, e1, o.colorArray.float32, n);
            }
            if (void 0 !== r.NORMAL) {
                o.normalArray = new pu;
                const e1 = t1.json.accessors[r.NORMAL];
                o.normalArray.resizeExact(e1.count);
                const i = Px(t1, e1);
                !function(e1, t1, i, n) {
                    const r = Py[t1.componentType], o = Rx(r), a = e1.json.bufferViews[t1.bufferView], s = Fy[t1.type], l = i.length / t1.count, c = a.byteStride ? a.byteStride / r.BYTES_PER_ELEMENT : s, u = t1.count * c;
                    for(let e1 = 0, t1 = 0; e1 < u; e1 += c, t1 += l)for(let r = 0; r < s; r++)i[t1 + r] = Math.round(127 * Math.min(1, Math.max(-1, n[e1 + r] * o)));
                }(t1, e1, o.normalArray.int8, i);
            }
            if (void 0 !== r.TEXCOORD_0 && i.length > 0) {
                const e1 = t1.json.accessors[r.TEXCOORD_0], i = Px(t1, e1);
                e1.normalized && Py[e1.componentType] === Uint16Array ? (o.texcoordArray = new Jc, o.texcoordArray.resizeExact(e1.count), Fx(t1, e1, o.texcoordArray.uint16, i, !1)) : (o.texcoordArray = new hu, o.texcoordArray.resizeExact(e1.count), Fx(t1, e1, o.texcoordArray.float32, i));
            }
            const m = !(!t1.json.extensionsUsed || !t1.json.extensionsUsed.includes("EXT_meshopt_compression"));
            void 0 !== r._FEATURE_ID_RGBA4444 && m && Dx(t1, t1.json.accessors[r._FEATURE_ID_RGBA4444], !1, o), void 0 !== r._FEATURE_RGBA4444 && Dx(t1, t1.json.accessors[r._FEATURE_RGBA4444], !m, o), o.hasFeatureData = !!o.featureArray;
            const g = e1.material;
            return o.material = function(e1, t1) {
                const { emissiveFactor: i = [
                    0,
                    0,
                    0
                ], alphaMode: n = "OPAQUE", alphaCutoff: r = .5, normalTexture: o, occlusionTexture: a, emissiveTexture: s, doubleSided: l, name: c } = e1, { baseColorFactor: u = [
                    1,
                    1,
                    1,
                    1
                ], metallicFactor: h = 1, roughnessFactor: d = 1, baseColorTexture: f, metallicRoughnessTexture: p } = e1.pbrMetallicRoughness || {}, _ = a ? t1[a.index] : void 0;
                if (a && a.extensions && a.extensions.KHR_texture_transform && _) {
                    const e1 = a.extensions.KHR_texture_transform;
                    _.offsetScale = [
                        e1.offset[0],
                        e1.offset[1],
                        e1.scale[0],
                        e1.scale[1]
                    ];
                }
                return {
                    name: c,
                    pbrMetallicRoughness: {
                        baseColorFactor: new fn(...u),
                        metallicFactor: h,
                        roughnessFactor: d,
                        baseColorTexture: f ? t1[f.index] : void 0,
                        metallicRoughnessTexture: p ? t1[p.index] : void 0
                    },
                    doubleSided: l,
                    emissiveFactor: new fn(...i),
                    alphaMode: n,
                    alphaCutoff: r,
                    normalTexture: o ? t1[o.index] : void 0,
                    occlusionTexture: _,
                    emissionTexture: s ? t1[s.index] : void 0,
                    defined: void 0 === e1.defined
                };
            }(void 0 !== g ? t1.json.materials[g] : {
                defined: !1
            }, i), o;
        }
        function Ox(e1, t1, i) {
            const { matrix: n, rotation: r, translation: o, scale: a, mesh: s, extras: l, children: c, name: h } = e1, d = {};
            if (d.name = h, d.localMatrix = n ? Float64Array.from(n) : function(e1, t1, i, n) {
                var r = t1[0], o = t1[1], a = t1[2], s = t1[3], l = r + r, c = o + o, u = a + a, h = r * l, d = r * c, f = r * u, p = o * c, _ = o * u, m = a * u, g = s * l, y = s * c, x = s * u, v = n[0], b = n[1], w = n[2];
                return e1[0] = (1 - (p + m)) * v, e1[1] = (d + x) * v, e1[2] = (f - y) * v, e1[3] = 0, e1[4] = (d - x) * b, e1[5] = (1 - (h + m)) * b, e1[6] = (_ + g) * b, e1[7] = 0, e1[8] = (f + y) * w, e1[9] = (_ - g) * w, e1[10] = (1 - (h + p)) * w, e1[11] = 0, e1[12] = i[0], e1[13] = i[1], e1[14] = i[2], e1[15] = 1, e1;
            }(new Float64Array(16), r || [
                0,
                0,
                0,
                1
            ], o || [
                0,
                0,
                0
            ], a || [
                1,
                1,
                1
            ]), d.globalMatrix = u(d.localMatrix), void 0 !== s) {
                d.meshes = i[s];
                const e1 = d.anchor = [
                    0,
                    0
                ];
                for (const t1 of d.meshes){
                    const { min: i, max: n } = t1.aabb;
                    e1[0] += i[0] + n[0], e1[1] += i[1] + n[1];
                }
                e1[0] = Math.floor(e1[0] / d.meshes.length / 2), e1[1] = Math.floor(e1[1] / d.meshes.length / 2);
            }
            if (l && (l.id && (d.id = l.id), l.lights && (d.lights = function(e1) {
                if (!e1.length) return [];
                const t1 = function(e1) {
                    const t1 = atob(e1), i = new Uint8Array(t1.length);
                    for(let e1 = 0; e1 < t1.length; e1++)i[e1] = t1.codePointAt(e1);
                    return i;
                }(e1), i = [], n = t1.length / 24, r = new Uint16Array(t1.buffer), o = new Float32Array(t1.buffer);
                for(let e1 = 0; e1 < n; e1++){
                    const t1 = r[2 * e1 * 6] / 30, n = r[2 * e1 * 6 + 1] / 30, a = r[2 * e1 * 6 + 10] / 100, s = o[6 * e1 + 1], l = o[6 * e1 + 2], c = o[6 * e1 + 3], u = o[6 * e1 + 4], h = c - s, d = u - l, f = Math.hypot(h, d);
                    i.push({
                        pos: [
                            s + .5 * h,
                            l + .5 * d,
                            n
                        ],
                        normal: [
                            d / f,
                            -h / f,
                            0
                        ],
                        width: f,
                        height: t1,
                        depth: a,
                        points: [
                            s,
                            l,
                            c,
                            u
                        ]
                    });
                }
                return i;
            }(l.lights)), l.MAPBOX_geometry_bloom && (d.isGeometryBloom = l.MAPBOX_geometry_bloom), l.MAPBOX_zoom_min && (d.minZoom = l.MAPBOX_zoom_min), l.MAPBOX_zoom_max && (d.maxZoom = l.MAPBOX_zoom_max)), c) {
                const e1 = [];
                for (const n of c)e1.push(Ox(t1.json.nodes[n], t1, i));
                d.children = e1;
            }
            if (e1.extensions && e1.extensions.mbx_bvh && (d.meshBVH = function(e1, t1, i) {
                const n = t1.binaryAccessor, r = t1.positionMinAccessor, o = t1.positionMaxAccessor, a = t1.indexAccessor;
                if (!(Number.isInteger(n) && Number.isInteger(r) && Number.isInteger(o) && Number.isInteger(a))) return null;
                const s = e1.json.accessors;
                if (n >= s.length || r >= s.length || o >= s.length || a >= s.length) return null;
                const l = s[n], c = s[r], u = s[o], h = s[a];
                if (void 0 === l.bufferView || void 0 === c.bufferView || void 0 === u.bufferView || void 0 === h.bufferView) return null;
                const d = e1.json.bufferViews;
                if (l.bufferView >= d.length || c.bufferView >= d.length || u.bufferView >= d.length || h.bufferView >= d.length) return null;
                const f = d[l.bufferView], p = d[c.bufferView], _ = d[u.bufferView], m = d[h.bufferView];
                if (f.buffer >= e1.buffers.length || p.buffer >= e1.buffers.length || _.buffer >= e1.buffers.length || m.buffer >= e1.buffers.length) return null;
                const g = (e1, t1, i)=>e1 >= 0 && e1 <= i && t1 <= i - e1, y = l.byteOffset || 0, x = c.byteOffset || 0, v = u.byteOffset || 0, b = h.byteOffset || 0;
                if (!(g(y, 0, f.byteLength) && g(x, 3 * c.count * 4, p.byteLength) && g(v, 3 * u.count * 4, _.byteLength) && g(b, 4 * h.count, m.byteLength))) return null;
                const w = new Uint8Array(e1.buffers[f.buffer], (f.byteOffset || 0) + y, f.byteLength - y), A = new Float32Array(e1.buffers[p.buffer], (p.byteOffset || 0) + x, 3 * c.count), E = new Float32Array(e1.buffers[_.buffer], (_.byteOffset || 0) + v, 3 * u.count), I = new Uint32Array(e1.buffers[m.buffer], (m.byteOffset || 0) + b, h.count), M = new zx;
                if (M.serializeFromGltf(w, A, E, I), void 0 !== i && e1.json.meshes && e1.json.meshes[i]) {
                    const t1 = e1.json.meshes[i].primitives[0];
                    if (t1 && void 0 !== t1.attributes.POSITION && t1.attributes.POSITION < s.length) {
                        const i = s[t1.attributes.POSITION];
                        if (void 0 !== i.bufferView && i.bufferView < d.length) {
                            const t1 = d[i.bufferView];
                            if (t1.buffer < e1.buffers.length) {
                                const n = i.byteOffset || 0, r = t1.byteStride ? t1.byteStride / 4 : 3;
                                if (g(n, i.count * r * 4, t1.byteLength)) {
                                    const o = (t1.byteOffset || 0) + n;
                                    if (3 === r) M.setVertices(new Float32Array(e1.buffers[t1.buffer], o, 3 * i.count).slice());
                                    else {
                                        const n = new Float32Array(e1.buffers[t1.buffer], o, i.count * r), a = new Float32Array(3 * i.count);
                                        for(let e1 = 0; e1 < i.count; e1++)a[3 * e1] = n[e1 * r], a[3 * e1 + 1] = n[e1 * r + 1], a[3 * e1 + 2] = n[e1 * r + 2];
                                        M.setVertices(a);
                                    }
                                }
                            }
                        }
                    }
                }
                return M;
            }(t1, e1.extensions.mbx_bvh, s)), !d.meshBVH && d.children) {
                for (const e1 of d.children)if (e1.meshBVH) {
                    d.meshBVH = e1.meshBVH;
                    break;
                }
            }
            return d;
        }
        function Lx(e1) {
            if (0 === e1.vertices.length || 0 === e1.indices.length) return null;
            const t1 = new Float64Array(2 * e1.vertices.length);
            for(let i = 0; i < e1.vertices.length; i++)t1[2 * i] = e1.vertices[i].x, t1[2 * i + 1] = e1.vertices[i].y;
            const i = new Uint32Array(e1.indices), n = new Wy(e1.vertices, i, 8, 256), [r, o] = [
                n.min.clone(),
                n.max.clone()
            ];
            return {
                vertices: t1,
                indices: i,
                grid: n,
                min: r,
                max: o
            };
        }
        function Bx(e1) {
            if (!e1.extras || !e1.extras.ground) return null;
            const t1 = e1.extras.ground;
            if (!t1 || !Array.isArray(t1) || 0 === t1.length) return null;
            const i = t1[0];
            if (!i || !Array.isArray(i) || 0 === i.length) return null;
            const n = [];
            for (const e1 of i){
                if (!Array.isArray(e1) || 2 !== e1.length) continue;
                const t1 = e1[0], i = e1[1];
                "number" == typeof t1 && "number" == typeof i && n.push(new Re(t1, i));
            }
            if (n.length < 3) return null;
            n.length > 1 && n.at(-1).equals(n[0]) && n.pop();
            let r = 0;
            for(let e1 = 0; e1 < n.length; e1++){
                const t1 = n[e1], i = n[(e1 + 1) % n.length], o = n[(e1 + 2) % n.length];
                r += (t1.x - i.x) * (o.y - i.y) - (o.x - i.x) * (t1.y - i.y);
            }
            r > 0 && n.reverse();
            const o = wl(n.flatMap((e1)=>[
                    e1.x,
                    e1.y
                ]), []);
            return 0 === o.length ? null : {
                vertices: n,
                indices: o
            };
        }
        function Vx(e1, t1) {
            const i = [], n = [];
            let r = 0;
            const o = [];
            for (const a of e1){
                r = i.length;
                const e1 = a.vertexArray.float32, s = a.indexArray.uint16;
                for(let n = 0; n < a.vertexArray.length; n++)o[0] = e1[3 * n + 0], o[1] = e1[3 * n + 1], o[2] = e1[3 * n + 2], X(o, o, t1), i.push(new Re(o[0], o[1]));
                for(let e1 = 0; e1 < 3 * a.indexArray.length; e1++)n.push(s[e1] + r);
            }
            if (n.length % 3 != 0) return null;
            for(let e1 = 0; e1 < n.length; e1 += 3){
                const t1 = i[n[e1 + 0]], r = i[n[e1 + 1]], o = i[n[e1 + 2]];
                (t1.x - r.x) * (o.y - r.y) - (o.x - r.x) * (t1.y - r.y) > 0 && ([n[e1 + 1], n[e1 + 2]] = [
                    n[e1 + 2],
                    n[e1 + 1]
                ]);
            }
            return {
                vertices: i,
                indices: n
            };
        }
        function Nx(e1, t1) {
            for(let i = 0; i < e1.length; i++)if (e1[i].name === t1) return i;
            return -1;
        }
        function kx(e1) {
            const t1 = function(e1, t1) {
                const i = [], n = WebGL2RenderingContext;
                if (e1.json.textures) for (const r of e1.json.textures){
                    const o = {
                        magFilter: n.LINEAR,
                        minFilter: n.NEAREST,
                        wrapS: n.REPEAT,
                        wrapT: n.REPEAT
                    };
                    void 0 !== r.sampler && Object.assign(o, e1.json.samplers[r.sampler]), i.push({
                        image: t1[r.source],
                        sampler: o,
                        uploaded: !1
                    });
                }
                return i;
            }(e1, e1.images), i = function(e1, t1) {
                const i = [];
                if (!e1.json.meshes) return i;
                for (const n of e1.json.meshes){
                    const r = [];
                    for (const i of n.primitives)r.push(Cx(i, e1, t1));
                    i.push(r);
                }
                return i;
            }(e1, t1), { scenes: n, scene: r, nodes: o } = e1.json;
            let a = n ? Nx(n, "Default Scene") : -1;
            a < 0 && (a = r || 0);
            const s = n && n[a] ? n[a].nodes || [] : [
                ...o.keys()
            ], l = [];
            for (const t1 of s)l.push(Ox(o[t1], e1, i));
            !function(e1, t1, i) {
                const n = {}, r = new Set;
                for(let o = 0; o < e1.length; o++){
                    const e1 = i[t1[o]];
                    if (!e1.extras) continue;
                    const a = e1.extras["mapbox:footprint:version"], s = e1.extras["mapbox:footprint:id"];
                    (a || s) && r.add(o), "1.0.0" === a && s && (n[s] = o);
                }
                for(let o = 0; o < e1.length; o++){
                    if (r.has(o)) continue;
                    const a = e1[o], s = i[t1[o]];
                    if (!s.extras) continue;
                    let l = null;
                    a.id in n && (l = Vx(e1[n[a.id]].meshes, a.localMatrix)), l || (l = Bx(s)), l && (a.footprint = Lx(l));
                }
                if (r.size > 0) {
                    const t1 = Array.from(r.values()).sort((e1, t1)=>e1 - t1);
                    for(let i = t1.length - 1; i >= 0; i--)e1.splice(t1[i], 1);
                }
            }(l, s, e1.json.nodes);
            const c = n ? Nx(n, "LOD") : -1;
            if (c >= 0) {
                const t1 = n[c].nodes, r = new Map;
                for (const n of t1){
                    const t1 = Ox(o[n], e1, i);
                    t1.id && r.set(t1.id, t1);
                }
                for (const e1 of l)if (e1.id) {
                    const t1 = r.get(e1.id);
                    t1 && t1.meshes && (e1.lodMeshes = t1.meshes, t1.meshBVH && (e1.meshBVH = t1.meshBVH));
                }
            }
            return l;
        }
        function Ux(e1) {
            e1.heightmap = new Float32Array(4096), e1.heightmap.fill(-1);
            const t1 = e1.vertexArray.float32, i = e1.aabb.min[0] - 1, n = e1.aabb.min[1] - 1, r = px / (e1.aabb.max[0] - i + 2), o = px / (e1.aabb.max[1] - n + 2);
            for(let a = 0; a < t1.length; a += 3){
                const s = t1[a + 2], l = (t1[a + 0] - i) * r | 0, c = (t1[a + 1] - n) * o | 0;
                s > e1.heightmap[c * px + l] && (e1.heightmap[c * px + l] = s);
            }
        }
        function jx(e1, t1, i, n, r) {
            i.reserve(i.length + 4 * e1.length), n.reserve(n.length + 10 * e1.length), r.reserve(r.length + 10 * e1.length);
            let o = n.length;
            for (const a of e1){
                const e1 = Math.min(10, Math.max(4, 1.3 * a.height)) * t1, s = [
                    -a.normal[1],
                    a.normal[0],
                    0
                ], l = Math.min(.29, .1 * a.width / a.depth), c = a.width - 2 * a.depth * t1 * (l + .01), u = k([], a.pos, s, c / 2), h = k([], a.pos, s, -c / 2), d = [
                    u[0],
                    u[1],
                    u[2] + a.height
                ], f = [
                    h[0],
                    h[1],
                    h[2] + a.height
                ], p = k([], a.normal, s, l);
                N(p, p, e1);
                const _ = k([], a.normal, s, -l);
                N(_, _, e1), C(p, u, p), C(_, h, _), u[2] += .1, h[2] += .1, n.emplaceBack(p[0], p[1], p[2]), n.emplaceBack(_[0], _[1], _[2]), n.emplaceBack(u[0], u[1], u[2]), n.emplaceBack(h[0], h[1], h[2]), n.emplaceBack(d[0], d[1], d[2]), n.emplaceBack(f[0], f[1], f[2]), n.emplaceBack(u[0], u[1], u[2]), n.emplaceBack(h[0], h[1], h[2]), n.emplaceBack(p[0], p[1], p[2]), n.emplaceBack(_[0], _[1], _[2]);
                const m = c / e1 / 2;
                r.emplaceBack(-m - l, -1, m, .8), r.emplaceBack(m + l, -1, m, .8), r.emplaceBack(-m, 0, m, 1.3), r.emplaceBack(m, 0, m, 1.3), r.emplaceBack(m + l, -0.8, m, .7), r.emplaceBack(m + l, -0.8, m, .7), r.emplaceBack(0, 0, m, 1.3), r.emplaceBack(0, 0, m, 1.3), r.emplaceBack(m + l, -1.2, m, .8), r.emplaceBack(m + l, -1.2, m, .8), i.emplaceBack(6 + o, 4 + o, 8 + o), i.emplaceBack(7 + o, 9 + o, 5 + o), i.emplaceBack(0 + o, 1 + o, 2 + o), i.emplaceBack(1 + o, 3 + o, 2 + o), o += 10;
            }
        }
        function Gx(e1, t1, i) {
            const n = {};
            n.indexArray = new nu, n.vertexArray = new jc, n.colorArray = new qc, n.indexArray.reserveExact(4 * e1.length), n.vertexArray.reserveExact(10 * e1.length), n.colorArray.reserveExact(10 * e1.length), jx(e1, t1, n.indexArray, n.vertexArray, n.colorArray), n.featureArray = new Jc, n.featureArray.reserveExact(n.vertexArray.length);
            for(let e1 = 0; e1 < n.vertexArray.length; e1++)n.featureArray.emplaceBack(i, 2);
            n.hasFeatureData = !0;
            const r = {
                defined: !0
            };
            r.emissiveFactor = fn.black;
            const o = {};
            return o.baseColorFactor = fn.white, r.pbrMetallicRoughness = o, n.material = r, n.aabb = new Nf([
                1 / 0,
                1 / 0,
                1 / 0
            ], [
                -1 / 0,
                -1 / 0,
                -1 / 0
            ]), n;
        }
        Ya(zx, "ModelBVH");
        const Hx = Pc([
            {
                name: "a_pos_packed",
                components: 2,
                type: "Int32"
            }
        ]), $x = Pc([
            {
                name: "a_pos_3f",
                components: 3,
                type: "Float32"
            }
        ]), Zx = Pc([
            {
                name: "a_normal_4n",
                components: 4,
                type: "Int8",
                normalized: !0
            }
        ]), Wx = Pc([
            {
                name: "a_centroid_3",
                components: 3,
                type: "Int16"
            }
        ]), qx = Pc([
            {
                name: "a_part_color_emissive",
                components: 2,
                type: "Uint16"
            }
        ]), Xx = Pc([
            {
                name: "a_faux_facade_color_emissive",
                components: 2,
                type: "Uint16"
            }
        ]), Yx = Pc([
            {
                name: "a_faux_facade_data",
                components: 4,
                type: "Uint16"
            }
        ]), Jx = Pc([
            {
                name: "a_faux_facade_vertical_range",
                components: 2,
                type: "Uint16"
            }
        ]), Kx = Pc([
            {
                name: "a_bloom_attenuation",
                components: 4,
                type: "Float32"
            }
        ]), Qx = Pc([
            {
                name: "a_flood_light_wall_radius_1i16",
                components: 1,
                type: "Int16"
            }
        ]), ev = Pc([
            {
                name: "a_pos_normal_ed",
                components: 4,
                type: "Int16"
            }
        ]), tv = Pc([
            {
                name: "a_pos_end",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_angular_offset_factor",
                components: 1,
                type: "Int16"
            }
        ]), iv = Pc([
            {
                name: "a_flood_light_ground_radius",
                components: 1,
                type: "Float32"
            }
        ]), nv = Pc([
            {
                name: "a_centroid_pos",
                components: 2,
                type: "Uint16"
            }
        ]), rv = Pc([
            {
                name: "a_join_normal_inside",
                components: 3,
                type: "Int16"
            }
        ]), ov = Pc([
            {
                name: "a_hidden_by_landmark",
                components: 1,
                type: "Uint8"
            }
        ]), av = Pc([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_pos_normal_3",
                components: 3,
                type: "Int16"
            }
        ]), { members: sv } = ev;
        function lv(e1, t1, i, n) {
            const r = [], o = 0 === n ? (e1, t1, i, n, r, o)=>{
                e1.push(new Re(o, i + (o - t1) / (n - t1) * (r - i)));
            } : (e1, t1, i, n, r, o)=>{
                e1.push(new Re(t1 + (o - i) / (r - i) * (n - t1), o));
            };
            for (const a of e1){
                const e1 = [];
                for (const r of a){
                    if (r.length <= 2) continue;
                    const a = [];
                    for(let e1 = 0; e1 < r.length - 1; e1++){
                        const s = r[e1].x, l = r[e1].y, c = r[e1 + 1].x, u = r[e1 + 1].y, h = 0 === n ? s : l, d = 0 === n ? c : u;
                        h < t1 ? d > t1 && o(a, s, l, c, u, t1) : h > i ? d < i && o(a, s, l, c, u, i) : a.push(r[e1]), d < t1 && h >= t1 && o(a, s, l, c, u, t1), d > i && h <= i && o(a, s, l, c, u, i);
                    }
                    let s = r.at(-1);
                    const l = 0 === n ? s.x : s.y;
                    l >= t1 && l <= i && a.push(s), a.length && (s = a.at(-1), a[0].x === s.x && a[0].y === s.y || a.push(a[0]), e1.push(a));
                }
                e1.length && r.push(e1);
            }
            return r;
        }
        const cv = [
            new Re(0, 0),
            new Re(Sr, 0),
            new Re(Sr, Sr),
            new Re(0, Sr)
        ];
        function uv(e1, t1) {
            const i = [];
            let n = [];
            if (!t1 || e1.length < 2) return [
                e1
            ];
            if (2 === e1.length) return hd(e1[0], e1[1], cv) ? [
                e1
            ] : [];
            for(let t1 = 0; t1 < e1.length + 2; t1++){
                const r = 0 === t1 ? e1.at(-1) : e1[(t1 - 1) % e1.length], o = e1[t1 % e1.length], a = e1[(t1 + 1) % e1.length], s = hd(r, o, cv), l = hd(o, a, cv), c = s || l;
                c && n.push(o), c && l || n.length > 0 && (n.length > 1 && i.push(n), n = []);
            }
            return n.length > 1 && i.push(n), i;
        }
        const hv = Wh.types, dv = [
            "fill-extrusion-base",
            "fill-extrusion-height",
            "fill-extrusion-color",
            "fill-extrusion-pattern",
            "fill-extrusion-flood-light-wall-radius",
            "fill-extrusion-line-width",
            "fill-extrusion-emissive-strength"
        ], fv = [
            "fill-extrusion-flood-light-ground-radius"
        ], pv = Math.pow(2, 13), _v = Math.pow(2, 15) - 1, mv = new Re(0, 1), gv = 2147483648, yv = 1073741824;
        function xv(e1, t1, i, n, r, o, a, s) {
            e1.emplaceBack((t1 << 1) + a, (i << 1) + o, (Math.floor(n * pv) << 1) + r, Math.round(s));
        }
        function vv(e1, t1, i) {
            e1.emplaceBack(t1.x * Sr, t1.y * Sr, i ? 1 : 0);
        }
        function bv(e1, t1, i, n, r, o) {
            e1.emplaceBack(t1.x, t1.y, (i.x << 1) + n, (i.y << 1) + r, o);
        }
        function wv(e1, t1, i) {
            const n = 16384;
            e1.emplaceBack(t1.x, t1.y, t1.z, i[0] * n, i[1] * n, i[2] * n);
        }
        class Av {
            constructor(){
                this.vertexOffset = 0, this.vertexCount = 0, this.indexOffset = 0, this.indexCount = 0;
            }
        }
        class Ev {
            constructor(){
                this.data = [];
            }
            get length() {
                return this.data.length;
            }
            push(e1) {
                this.data.push(e1);
            }
            get(e1) {
                return this.data[e1];
            }
            static serialize(e1, t1) {
                const i = e1.data.length, n = new Uint32Array(4 * i), r = [];
                r.length = i;
                for(let t1 = 0; t1 < i; t1++){
                    const i = e1.data[t1], o = 4 * t1;
                    n[o] = i.vertexOffset, n[o + 1] = i.vertexCount, n[o + 2] = i.indexOffset, n[o + 3] = i.indexCount, r[t1] = i.ringIndices;
                }
                return t1 && t1.add(n.buffer), {
                    scalars: n,
                    rings: r
                };
            }
            static deserialize(e1) {
                const { scalars: t1, rings: i } = e1, n = t1.length / 4, r = new Ev, o = [];
                o.length = n, r.data = o;
                for(let e1 = 0; e1 < n; e1++){
                    const n = 4 * e1, o = new Av;
                    o.vertexOffset = t1[n], o.vertexCount = t1[n + 1], o.indexOffset = t1[n + 2], o.indexCount = t1[n + 3], o.ringIndices = i[e1], r.data[e1] = o;
                }
                return r;
            }
        }
        class Iv {
            constructor(){
                this.centroidXY = new Re(0, 0), this.vertexArrayOffset = 0, this.vertexCount = 0, this.groundVertexArrayOffset = 0, this.groundVertexCount = 0, this.flags = 0, this.footprintSegIdx = -1, this.footprintSegLen = 0, this.polygonSegIdx = -1, this.polygonSegLen = 0, this.min = new Re(Number.MAX_VALUE, Number.MAX_VALUE), this.max = new Re(-Number.MAX_VALUE, -Number.MAX_VALUE), this.height = 0, this.buildingId = 0, this.groupCentroidPos = new Re(0, 0);
            }
        }
        class Mv {
            constructor(){
                this.data = [], this.buffer = null;
            }
            get length() {
                return this.data.length;
            }
            push(e1) {
                this.data.push(e1);
            }
            get(e1) {
                return this.data[e1];
            }
            find(e1) {
                return this.data.find(e1);
            }
            [Symbol.iterator]() {
                return this.data[Symbol.iterator]();
            }
            static serialize(e1, t1) {
                const i = e1.data.length, n = new Float64Array(15 * i);
                for(let t1 = 0; t1 < i; t1++){
                    const i = e1.data[t1], r = 15 * t1;
                    n[r] = i.centroidXY.x, n[r + 1] = i.centroidXY.y, n[r + 2] = i.min.x, n[r + 3] = i.min.y, n[r + 4] = i.max.x, n[r + 5] = i.max.y, n[r + 6] = i.groupCentroidPos.x, n[r + 7] = i.groupCentroidPos.y, n[r + 8] = i.vertexArrayOffset, n[r + 9] = i.vertexCount, n[r + 10] = i.groundVertexArrayOffset, n[r + 11] = i.groundVertexCount, n[r + 12] = i.footprintSegLen, n[r + 13] = i.height, n[r + 14] = i.buildingId;
                }
                return t1 && t1.add(n.buffer), {
                    buffer: n
                };
            }
            static deserialize(e1) {
                const t1 = e1.buffer, i = t1.length / 15, n = new Mv;
                n.buffer = t1;
                const r = [];
                r.length = i, n.data = r;
                let o = 0;
                for(let e1 = 0; e1 < i; e1++){
                    const i = 15 * e1, r = new Iv;
                    r.centroidXY = new Re(t1[i], t1[i + 1]), r.min = new Re(t1[i + 2], t1[i + 3]), r.max = new Re(t1[i + 4], t1[i + 5]), r.groupCentroidPos = new Re(t1[i + 6], t1[i + 7]), r.vertexArrayOffset = t1[i + 8], r.vertexCount = t1[i + 9], r.groundVertexArrayOffset = t1[i + 10], r.groundVertexCount = t1[i + 11], r.footprintSegLen = t1[i + 12], r.height = t1[i + 13], r.buildingId = t1[i + 14], r.footprintSegIdx = o, o += r.footprintSegLen, n.data[e1] = r;
                }
                return n;
            }
        }
        class Sv {
            constructor(){
                this.acc = new Re(0, 0), this.accCount = 0, this.centroidDataIndex = 0;
            }
            startRing(e1, t1) {
                e1.min.x === Number.MAX_VALUE && (e1.min.x = e1.max.x = t1.x, e1.min.y = e1.max.y = t1.y);
            }
            appendEdge(e1, t1, i) {
                this.accCount++, this.acc._add(t1);
                let n = !!this.borders;
                t1.x < e1.min.x ? (e1.min.x = t1.x, n = !0) : t1.x > e1.max.x && (e1.max.x = t1.x, n = !0), t1.y < e1.min.y ? (e1.min.y = t1.y, n = !0) : t1.y > e1.max.y && (e1.max.y = t1.y, n = !0), ((0 === t1.x || t1.x === Sr) && t1.x === i.x) != ((0 === t1.y || t1.y === Sr) && t1.y === i.y) && this.processBorderOverlap(t1, i), n && this.checkBorderIntersection(t1, i);
            }
            checkBorderIntersection(e1, t1) {
                t1.x < 0 != e1.x < 0 && this.addBorderIntersection(0, hn(t1.y, e1.y, (0 - t1.x) / (e1.x - t1.x))), t1.x > Sr != e1.x > Sr && this.addBorderIntersection(1, hn(t1.y, e1.y, (Sr - t1.x) / (e1.x - t1.x))), t1.y < 0 != e1.y < 0 && this.addBorderIntersection(2, hn(t1.x, e1.x, (0 - t1.y) / (e1.y - t1.y))), t1.y > Sr != e1.y > Sr && this.addBorderIntersection(3, hn(t1.x, e1.x, (Sr - t1.y) / (e1.y - t1.y)));
            }
            addBorderIntersection(e1, t1) {
                this.borders || (this.borders = [
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ]
                ]);
                const i = this.borders[e1];
                t1 < i[0] && (i[0] = t1), t1 > i[1] && (i[1] = t1);
            }
            processBorderOverlap(e1, t1) {
                if (e1.x === t1.x) {
                    if (e1.y === t1.y) return;
                    const i = 0 === e1.x ? 0 : 1;
                    this.addBorderIntersection(i, t1.y), this.addBorderIntersection(i, e1.y);
                } else {
                    const i = 0 === e1.y ? 2 : 3;
                    this.addBorderIntersection(i, t1.x), this.addBorderIntersection(i, e1.x);
                }
            }
            centroid() {
                return 0 === this.accCount ? new Re(0, 0) : new Re(Math.floor(Math.max(0, this.acc.x) / this.accCount), Math.floor(Math.max(0, this.acc.y) / this.accCount));
            }
            intersectsCount() {
                return this.borders ? this.borders.reduce((e1, t1)=>e1 + +(t1[0] !== Number.MAX_VALUE), 0) : 0;
            }
        }
        function Tv(e1, t1) {
            const i = e1.add(t1)._unit(), n = tt(e1.x * i.x + e1.y * i.y, -1, 1), r = (o = Math.acos(n), Math.min(4, Math.max(-4, Math.tan(o))) / 4 * _v * function(e1, t1) {
                return e1.x * t1.y - e1.y * t1.x < 0 ? -1 : 1;
            }(e1, t1));
            var o;
            return r;
        }
        const zv = [
            (e1)=>e1.x < 0,
            (e1)=>e1.x > Sr,
            (e1)=>e1.y < 0,
            (e1)=>e1.y > Sr
        ];
        function Rv(e1, t1, i, n) {
            const r = [
                4
            ];
            if (0 === n) return r;
            i._mult(n);
            const o = e1.sub(i), a = t1.sub(i), s = [
                e1,
                t1,
                o,
                a
            ];
            for(let e1 = 0; e1 < 4; e1++)for (const t1 of s)if (zv[e1](t1)) {
                r.push(e1);
                break;
            }
            return r;
        }
        class Pv {
            constructor(e1){
                this.groundRadiusArray = null, this.groundRadiusBuffer = null, this.vertexArray = new kc, this.indexArray = new nu, this.programConfigurations = new ch(e1.layers, {
                    zoom: e1.zoom,
                    lut: e1.lut
                }, (e1)=>fv.includes(e1)), this._segments = new Ou, this.hiddenByLandmarkVertexArray = new gu, this._segmentToGroundQuads = {}, this._segmentToGroundQuads[0] = [], this._segmentToRegionTriCounts = {}, this._segmentToRegionTriCounts[0] = [
                    0,
                    0,
                    0,
                    0,
                    0
                ], this.regionSegments = {}, this.regionSegments[4] = new Ou;
            }
            getDefaultSegment() {
                return this.regionSegments[4];
            }
            hasData() {
                return 0 !== this.vertexArray.length;
            }
            addData(e1, t1, i, n = !1) {
                const r = e1.length;
                if (r > 2) {
                    let o = Math.max(0, this._segments.get().length - 1);
                    const a = this._segments._prepareSegment(4 * r, this.vertexArray.length, 2 * this._segmentToGroundQuads[o].length);
                    let s;
                    o !== this._segments.get().length - 1 && (o++, this._segmentToGroundQuads[o] = [], this._segmentToRegionTriCounts[o] = [
                        0,
                        0,
                        0,
                        0,
                        0
                    ]);
                    {
                        const t1 = e1[0], i = e1[1];
                        s = Tv(t1.sub(e1[r - 1])._perp()._unit(), i.sub(t1)._perp()._unit());
                    }
                    for(let l = 0; l < r; l++){
                        const c = l === r - 1 ? 0 : l + 1, u = e1[l], h = e1[c], d = e1[c === r - 1 ? 0 : c + 1], f = h.sub(u)._perp()._unit(), p = Tv(f, d.sub(h)._perp()._unit()), _ = s, m = p;
                        if (Nv(u, h, t1) || n && kv(u, t1) && kv(h, t1)) {
                            s = p;
                            continue;
                        }
                        const g = a.vertexLength;
                        bv(this.vertexArray, u, h, 1, 1, _), bv(this.vertexArray, u, h, 1, 0, _), bv(this.vertexArray, u, h, 0, 1, m), bv(this.vertexArray, u, h, 0, 0, m), a.vertexLength += 4;
                        const y = Rv(u, h, f, i);
                        for (const e1 of y)this._segmentToGroundQuads[o].push({
                            id: g,
                            region: e1
                        }), this._segmentToRegionTriCounts[o][e1] += 2, a.primitiveLength += 2;
                        s = p;
                    }
                }
            }
            prepareBorderSegments() {
                if (!this.hasData()) return;
                const e1 = this._segments.get(), t1 = e1.length;
                for(let e1 = 0; e1 < t1; e1++)this._segmentToGroundQuads[e1].sort((e1, t1)=>e1.region - t1.region);
                for(let i = 0; i < t1; i++){
                    const t1 = this._segmentToGroundQuads[i], n = e1[i], r = this._segmentToRegionTriCounts[i];
                    r.reduce((e1, t1)=>e1 + t1, 0);
                    let o = 0;
                    for(let e1 = 0; e1 <= 4; e1++){
                        const t1 = r[e1];
                        if (0 !== t1) {
                            let i = this.regionSegments[e1];
                            i || (i = this.regionSegments[e1] = new Ou);
                            const r = {
                                vertexOffset: n.vertexOffset,
                                primitiveOffset: n.primitiveOffset + o,
                                vertexLength: n.vertexLength,
                                primitiveLength: t1
                            };
                            i.get().push(r);
                        }
                        o += t1;
                    }
                    for(let e1 = 0; e1 < t1.length; e1++){
                        const i = t1[e1].id;
                        this.indexArray.emplaceBack(i, i + 1, i + 3), this.indexArray.emplaceBack(i, i + 3, i + 2);
                    }
                }
                this._segmentToGroundQuads = null, this._segmentToRegionTriCounts = null, this._segments.destroy(), this._segments = null;
            }
            addPaintPropertiesData(e1, t1, i, n, r, o, a) {
                this.hasData() && this.programConfigurations.populatePaintArrays(this.vertexArray.length, e1, t1, i, n, r, o, void 0, a);
            }
            upload(e1) {
                this.hasData() && (this.vertexBuffer = e1.createVertexBuffer(this.vertexArray, tv.members), this.indexBuffer = e1.createIndexBuffer(this.indexArray), null != this.groundRadiusArray && (this.groundRadiusBuffer = e1.createVertexBuffer(this.groundRadiusArray, iv.members)));
            }
            uploadPaintProperties(e1) {
                this.hasData() && this.programConfigurations.upload(e1);
            }
            update(e1, t1, i, n, r, o, a, s) {
                this.hasData() && this.programConfigurations.updatePaintArrays(e1, t1, i, n, r, o, a, s);
            }
            updateHiddenByLandmark(e1) {
                this.updateHiddenByLandmarkRange(e1.groundVertexArrayOffset, e1.groundVertexCount, !!(e1.flags & gv || e1.flags & yv));
            }
            updateHiddenByLandmarkRange(e1, t1, i) {
                if (!this.hasData()) return;
                const n = t1 + e1;
                if (0 !== t1) {
                    for(let t1 = e1; t1 < n; ++t1)this.hiddenByLandmarkVertexArray.emplace(t1, i ? 1 : 0);
                    this._needsHiddenByLandmarkUpdate = !0;
                }
            }
            uploadHiddenByLandmark(e1) {
                this.hasData() && this._needsHiddenByLandmarkUpdate && (!this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexArray.length > 0 ? this.hiddenByLandmarkVertexBuffer = e1.createVertexBuffer(this.hiddenByLandmarkVertexArray, ov.members, !0) : this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexBuffer.updateData(this.hiddenByLandmarkVertexArray), this._needsHiddenByLandmarkUpdate = !1);
            }
            destroy() {
                if (this.vertexBuffer) {
                    this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexBuffer.destroy(), this.groundRadiusBuffer && this.groundRadiusBuffer.destroy(), this._segments && this._segments.destroy(), this.programConfigurations.destroy();
                    for(let e1 = 0; e1 <= 4; e1++){
                        const t1 = this.regionSegments[e1];
                        t1 && t1.destroy();
                    }
                }
            }
        }
        class Dv {
            constructor(e1){
                this.zoom = e1.zoom, this.canonical = e1.canonical, this.overscaling = e1.overscaling, this.layers = e1.layers, this.pixelRatio = e1.pixelRatio, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.hasPattern = !1, this.edgeRadius = 0, this.projection = e1.projection, this.activeReplacements = [], this.replacementUpdateTime = 0, this.centroidData = new Mv, this.footprintIndices = new nu, this.footprintVertices = new Fc, this.footprintSegments = new Ev, this.layoutVertexArray = new Nc, this.centroidVertexArray = new Tu, this.wallVertexArray = new Ru, this.indexArray = new nu, this.programConfigurations = new ch(e1.layers, {
                    zoom: e1.zoom,
                    lut: e1.lut
                }, (e1)=>dv.includes(e1)), this.segments = new Ou, this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.groundEffect = new Pv(e1), this.maxHeight = 0, this.triangleSubSegments = [], this.polygonSegments = [], this.buildingGroups = new Map, this.worldview = e1.worldview, this.hasAppearances = null;
            }
            updateFootprints(e1, t1) {}
            updateAppearances(e1, t1, i, n) {
                return {
                    hasLayoutChanges: !1,
                    hasUboChanges: !1
                };
            }
            populate(e1, t1, i, n) {
                this.features = [], this.hasPattern = Xl("fill-extrusion", this.layers, this.pixelRatio, t1), this.featuresOnBorder = [], this.borderFeatureIndices = [
                    [],
                    [],
                    [],
                    []
                ], this.borderDoneWithNeighborZ = [
                    -1,
                    -1,
                    -1,
                    -1
                ], this.selfDEMTileTimestamp = Number.MAX_VALUE, this.borderDEMTileTimestamp = [
                    Number.MAX_VALUE,
                    Number.MAX_VALUE,
                    Number.MAX_VALUE,
                    Number.MAX_VALUE
                ], this.tileToMeter = _c(i), this.edgeRadius = this.layers[0].layout.get("fill-extrusion-edge-radius") / this.tileToMeter, this.wallMode = 0 !== this.layers[0].paint.get("fill-extrusion-line-width").constantOr(1);
                const r = new Ls(this.zoom, {
                    worldview: this.worldview,
                    activeFloors: t1.activeFloors
                });
                for (const { feature: o, id: a, index: s, sourceLayerIndex: l } of e1){
                    const e1 = this.layers[0]._featureFilter.needGeometry, c = Mc(o, e1);
                    if (!this.layers[0]._featureFilter.filter(r, c, i)) continue;
                    const u = {
                        id: a,
                        sourceLayerIndex: l,
                        index: s,
                        geometry: Ic(o, c, e1, i, n),
                        properties: o.properties,
                        type: o.type,
                        patterns: {}
                    }, h = this.layoutVertexArray.length, d = "Polygon" === hv[u.type];
                    if (this.hasPattern) this.features.push({
                        featureId: o.id,
                        feature: Yl("fill-extrusion", this.layers, u, this.zoom, this.pixelRatio, t1)
                    });
                    else if (this.wallMode) for (const e1 of u.geometry)for (const r of uv(e1, d))this.addFeature(o.id, u, [
                        r
                    ], s, i, {}, t1.availableImages, n, t1.brightness);
                    else this.addFeature(o.id, u, u.geometry, s, i, {}, t1.availableImages, n, t1.brightness);
                    t1.featureIndex.insert(o, u.geometry, s, l, this.index, h);
                }
                this._finalizeBuildingGroups(), this.sortBorders(), "mercator" === this.projection.name && this.splitToSubtiles(), this.groundEffect.prepareBorderSegments(), this.polygonSegments.length = 0;
            }
            addFeatures(e1, t1, i, n, r, o) {
                for (const { featureId: e1, feature: a } of this.features){
                    const s = "Polygon" === hv[a.type], { geometry: l } = a;
                    if (this.wallMode) for (const c of l)for (const l of uv(c, s))this.addFeature(e1, a, [
                        l
                    ], a.index, t1, i, n, r, o);
                    else this.addFeature(e1, a, l, a.index, t1, i, n, r, o);
                }
                this._finalizeBuildingGroups(), this.sortBorders(), "mercator" === this.projection.name && this.splitToSubtiles();
            }
            update(e1, t1, i, n, r, o, a) {
                this.programConfigurations.updatePaintArrays(e1, t1, r, i, n, o, a, this.worldview), this.groundEffect.update(e1, t1, r, i, n, o, a, this.worldview);
            }
            updateExpressions(e1) {
                this.programConfigurations.updateExpressions(e1), this.groundEffect.programConfigurations.updateExpressions(e1);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload || this.groundEffect.programConfigurations.needsUpload;
            }
            upload(e1) {
                this.uploaded || (this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, sv), this.indexBuffer = e1.createIndexBuffer(this.indexArray), this.wallVertexBuffer = e1.createVertexBuffer(this.wallVertexArray, rv.members), this.layoutVertexExtArray && (this.layoutVertexExtBuffer = e1.createVertexBuffer(this.layoutVertexExtArray, av.members, !0)), this.groundEffect.upload(e1)), this.groundEffect.uploadPaintProperties(e1), this.programConfigurations.upload(e1), this.uploaded = !0;
            }
            uploadCentroid(e1) {
                this.groundEffect.uploadHiddenByLandmark(e1), this.needsCentroidUpdate && (!this.centroidVertexBuffer && this.centroidVertexArray.length > 0 ? this.centroidVertexBuffer = e1.createVertexBuffer(this.centroidVertexArray, nv.members, !0) : this.centroidVertexBuffer && this.centroidVertexBuffer.updateData(this.centroidVertexArray), this.needsCentroidUpdate = !1);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.centroidVertexBuffer && this.centroidVertexBuffer.destroy(), this.layoutVertexExtBuffer && this.layoutVertexExtBuffer.destroy(), this.groundEffect.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), new Ou(this.triangleSubSegments.map((e1)=>e1.segment)).destroy());
            }
            addFeature(e1, t1, i, n, r, o, a, s, l) {
                const c = this.layers[0].paint.get("fill-extrusion-flood-light-ground-radius").evaluate(t1, {}) / this.tileToMeter, u = [
                    new Re(0, 0),
                    new Re(Sr, Sr)
                ], h = s.projection, d = "globe" === h.name, f = this.wallMode || "Polygon" === hv[t1.type], p = new Sv;
                p.centroidDataIndex = this.centroidData.length;
                const _ = new Iv;
                _.buildingId = e1, t1.properties && Object.hasOwn(t1.properties, "building_id") && (_.buildingId = Number(t1.properties.building_id)), p.buildingId = _.buildingId;
                const m = this.layers[0].paint.get("fill-extrusion-base").evaluate(t1, {}, r) <= 0, g = this.layers[0].paint.get("fill-extrusion-height").evaluate(t1, {}, r);
                let y;
                if (_.height = g, _.vertexArrayOffset = this.layoutVertexArray.length, _.groundVertexArrayOffset = this.groundEffect.vertexArray.length, d && !this.layoutVertexExtArray && (this.layoutVertexExtArray = new $c), this.wallMode) {
                    if (d) return void _t("Non zero fill-extrusion-line-width is not yet supported on globe.");
                    if (1 !== i.length) return;
                    y = function(e1) {
                        const t1 = e1[0].x === e1.at(-1).x && e1[0].y === e1.at(-1).y, i = function(e1) {
                            let t1 = 0;
                            const i = e1.length;
                            for(let n = 0; n < i; n++)t1 += (e1[(n + 1) % i].x - e1[n].x) * (e1[(n + 1) % i].y + e1[n].y);
                            return t1 >= 0;
                        }(e1);
                        i || (e1 = e1.reverse());
                        const n = {
                            geometry: [],
                            joinNormals: [],
                            indices: []
                        }, r = [], o = [], a = [];
                        let s = e1.length;
                        for(; s >= 2 && e1[s - 1].equals(e1[s - 2]);)s--;
                        if (s < (t1 ? 3 : 2)) return n;
                        let l, c, u, h, d, f = 0;
                        for(; f < s - 1 && e1[f].equals(e1[f + 1]);)f++;
                        t1 && (l = e1[s - 2], d = e1[f].sub(l)._unit()._perp());
                        for(let i = f; i < s; i++){
                            if (u = i === s - 1 ? t1 ? e1[f + 1] : void 0 : e1[i + 1], u && e1[i].equals(u)) continue;
                            d && (h = d), l && (c = l), l = e1[i], d = u ? u.sub(l)._unit()._perp() : h, h = h || d;
                            let n = h.add(d);
                            0 === n.x && 0 === n.y || n._unit();
                            const p = n.x * d.x + n.y * d.y, _ = 0 !== p ? 1 / p : 1 / 0, m = h.x * d.y - h.y * d.x > 0;
                            let g = "miter";
                            const y = 2;
                            "miter" === g && _ > y && (g = "bevel"), "bevel" === g && (_ > 100 && (g = "flipbevel"), _ < y && (g = "miter"));
                            const x = (e1, t1, i, n)=>{
                                const s = new Re(e1.x, e1.y), l = new Re(e1.x, e1.y);
                                s.x += t1.x * n, s.y += t1.y * n, l.x -= t1.x * Math.max(i, 1), l.y -= t1.y * Math.max(i, 1), a.push(t1), r.push(s), o.push(l);
                            };
                            if ("miter" === g) n._mult(_), x(l, n, 0, 0);
                            else if ("flipbevel" === g) n = d.mult(-1), x(l, n, 0, 0), x(l, n.mult(-1), 0, 0);
                            else {
                                const e1 = -Math.sqrt(_ * _ - 1), t1 = m ? e1 : 0, i = m ? 0 : e1;
                                c && x(l, h, t1, i), u && x(l, d, t1, i);
                            }
                        }
                        n.geometry = [
                            ...r,
                            ...o.reverse(),
                            r[0]
                        ], n.joinNormals = [
                            ...a,
                            ...a.reverse(),
                            a.at(-1)
                        ];
                        const p = n.geometry.length - 1;
                        for(let e1 = 0; e1 < p / 2; e1++)if (e1 + 1 < p / 2) {
                            let t1 = e1, i = e1 + 1, r = p - 1 - e1, o = p - 2 - e1;
                            t1 = 0 === t1 ? p - 1 : t1 - 1, i = 0 === i ? p - 1 : i - 1, r = 0 === r ? p - 1 : r - 1, o = 0 === o ? p - 1 : o - 1, n.indices.push(r), n.indices.push(i), n.indices.push(t1), n.indices.push(r), n.indices.push(o), n.indices.push(i);
                        }
                        return n;
                    }(i[0]), i = [
                        y.geometry
                    ];
                }
                const x = (e1, t1)=>e1 < (t1.length - 1) / 2 || e1 === t1.length - 1, v = this.wallMode ? [
                    i
                ] : Ve(i, 500);
                for(let e1 = v.length - 1; e1 >= 0; e1--){
                    const t1 = v[e1];
                    (0 === t1.length || Uv(t1[0])) && v.splice(e1, 1);
                }
                let b;
                if (d) b = $v(v, u, r);
                else {
                    b = [];
                    for (const e1 of v)b.push({
                        polygon: e1,
                        bounds: u
                    });
                }
                const w = f ? this.edgeRadius : 0, A = w > 0 && this.zoom < 17, E = (e1, t1)=>{
                    if (0 === e1.length) return !1;
                    const i = e1.at(-1);
                    return t1.x === i.x && t1.y === i.y;
                };
                for (const { polygon: e1, bounds: t1 } of b){
                    let i = 0, n = 0;
                    for (const t1 of e1)f && !t1[0].equals(t1.at(-1)) && t1.push(t1[0]), n += f ? t1.length - 1 : t1.length;
                    const o = this.segments.prepareSegment((f ? 5 : 4) * n, this.layoutVertexArray, this.indexArray);
                    _.footprintSegIdx < 0 && (_.footprintSegIdx = this.footprintSegments.length), _.polygonSegIdx < 0 && (_.polygonSegIdx = this.polygonSegments.length);
                    const a = {
                        triangleArrayOffset: this.indexArray.length,
                        triangleCount: 0,
                        triangleSegIdx: this.segments.segments.length - 1
                    }, s = new Av;
                    if (s.vertexOffset = this.footprintVertices.length, s.indexOffset = 3 * this.footprintIndices.length, s.ringIndices = [], f) {
                        const n = [], a = [];
                        i = o.vertexLength;
                        for(let i = 0; i < e1.length; i++){
                            const l = e1[i];
                            l.length && 0 !== i && a.push(n.length / 2);
                            const u = [];
                            let f, p;
                            f = l[1].sub(l[0])._perp()._unit(), s.ringIndices.push(l.length - 1);
                            for(let e1 = 1; e1 < l.length; e1++){
                                const t1 = l[e1], i = l[e1 === l.length - 1 ? 1 : e1 + 1], a = t1.clone();
                                if (w) {
                                    p = Cv(t1, i, f);
                                    const e1 = Ov(f, p), n = Lv(f, p), r = w * Math.min(4, 1 / n);
                                    a.x += r * e1.x, a.y += r * e1.y, a.x = Math.round(a.x), a.y = Math.round(a.y), f = p;
                                }
                                if (!m || 0 !== w && !A || E(u, a) || u.push(a), xv(this.layoutVertexArray, a.x, a.y, 0, 0, 1, 1, 0), this.wallMode) {
                                    const t1 = x(e1, l);
                                    vv(this.wallVertexArray, y.joinNormals[e1], !t1);
                                }
                                o.vertexLength++, this.footprintVertices.emplaceBack(t1.x, t1.y), n.push(t1.x, t1.y), d && wv(this.layoutVertexExtArray, h.projectTilePoint(a.x, a.y, r), h.upVector(r, a.x, a.y));
                            }
                            m && (0 === w || A) && (0 !== u.length && E(u, u[0]) && u.pop(), this.groundEffect.addData(u, t1, c));
                        }
                        const l = this.wallMode ? y.indices : wl(n, a);
                        for(let e1 = 0; e1 < l.length; e1 += 3)this.footprintIndices.emplaceBack(s.vertexOffset + l[e1 + 0], s.vertexOffset + l[e1 + 1], s.vertexOffset + l[e1 + 2]), this.indexArray.emplaceBack(i + l[e1], i + l[e1 + 2], i + l[e1 + 1]), o.primitiveLength++;
                        s.indexCount += l.length, s.vertexCount += this.footprintVertices.length - s.vertexOffset;
                    }
                    for(let n = 0; n < e1.length; n++){
                        const a = e1[n];
                        p.startRing(_, a[0]);
                        let s = a.length > 4 && jv(a[a.length - 2], a[0], a[1]), l = w ? Bv(a[a.length - 2], a[0], a[1], w) : 0;
                        const u = [];
                        let g, v, b;
                        v = a[1].sub(a[0])._perp()._unit();
                        let A = !0;
                        for(let e1 = 1, n = 0; e1 < a.length; e1++){
                            let c = a[e1 - 1], f = a[e1];
                            const I = a[e1 === a.length - 1 ? 1 : e1 + 1];
                            if (p.appendEdge(_, f, c), Nv(f, c, t1)) {
                                w && (v = I.sub(f)._perp()._unit(), A = !A);
                                continue;
                            }
                            const M = f.sub(c)._perp(), S = M.x / (Math.abs(M.x) + Math.abs(M.y)), T = M.y > 0 ? 1 : 0, z = c.dist(f);
                            if (n + z > 32768 && (n = 0), w) {
                                b = Cv(f, I, v);
                                let e1 = Vv(c, f, I, Lv(v, b), w);
                                isNaN(e1) && (e1 = 0);
                                const t1 = Fv(c, f, new Re(0, 0));
                                c = c.add(t1.mult(l))._round(), f = f.add(t1.mult(-e1))._round(), l = e1, v = b, m && this.zoom >= 17 && (E(u, c) || u.push(c), E(u, f) || u.push(f));
                            }
                            const R = o.vertexLength, P = a.length > 4 && jv(c, f, I);
                            let D = Gv(n, s, A);
                            if (xv(this.layoutVertexArray, c.x, c.y, S, T, 0, 0, D), xv(this.layoutVertexArray, c.x, c.y, S, T, 0, 1, D), this.wallMode) {
                                const t1 = x(e1 - 1, a), i = y.joinNormals[e1 - 1];
                                vv(this.wallVertexArray, i, t1), vv(this.wallVertexArray, i, t1);
                            }
                            if (n += z, D = Gv(n, P, !A), s = P, xv(this.layoutVertexArray, f.x, f.y, S, T, 0, 0, D), xv(this.layoutVertexArray, f.x, f.y, S, T, 0, 1, D), this.wallMode) {
                                const t1 = x(e1, a), i = y.joinNormals[e1];
                                vv(this.wallVertexArray, i, t1), vv(this.wallVertexArray, i, t1);
                            }
                            if (o.vertexLength += 4, this.indexArray.emplaceBack(R + 0, R + 1, R + 2), this.indexArray.emplaceBack(R + 1, R + 3, R + 2), o.primitiveLength += 2, w) {
                                const n = i + (1 === e1 ? a.length - 2 : e1 - 2), r = 1 === e1 ? i : n + 1;
                                if (this.indexArray.emplaceBack(R + 1, n, R + 3), this.indexArray.emplaceBack(n, r, R + 3), o.primitiveLength += 2, void 0 === g && (g = R), !Nv(I, a[e1], t1)) {
                                    const t1 = e1 === a.length - 1 ? g : o.vertexLength;
                                    this.indexArray.emplaceBack(R + 2, R + 3, t1), this.indexArray.emplaceBack(R + 3, t1 + 1, t1), this.indexArray.emplaceBack(R + 3, r, t1 + 1), o.primitiveLength += 3;
                                }
                                A = !A;
                            }
                            if (d) {
                                const e1 = this.layoutVertexExtArray, t1 = h.projectTilePoint(c.x, c.y, r), i = h.projectTilePoint(f.x, f.y, r), n = h.upVector(r, c.x, c.y), o = h.upVector(r, f.x, f.y);
                                wv(e1, t1, n), wv(e1, t1, n), wv(e1, i, o), wv(e1, i, o);
                            }
                        }
                        f && (i += a.length - 1), m && w && this.zoom >= 17 && (0 !== u.length && E(u, u[0]) && u.pop(), this.groundEffect.addData(u, t1, c, w > 0));
                    }
                    this.footprintSegments.push(s), a.triangleCount = this.indexArray.length - a.triangleArrayOffset, this.polygonSegments.push(a), ++_.footprintSegLen, ++_.polygonSegLen;
                }
                if (_.vertexCount = this.layoutVertexArray.length - _.vertexArrayOffset, _.groundVertexCount = this.groundEffect.vertexArray.length - _.groundVertexArrayOffset, 0 !== _.vertexCount) {
                    if (_.centroidXY = p.borders ? mv : this.encodeCentroid(p.centroid(), _.min, _.max), t1.properties && Object.hasOwn(t1.properties, "building_id")) {
                        const e1 = _.buildingId;
                        let t1 = this.buildingGroups.get(e1);
                        t1 || (t1 = {
                            accX: 0,
                            accY: 0,
                            accCount: 0,
                            mergedMin: new Re(Number.MAX_VALUE, Number.MAX_VALUE),
                            mergedMax: new Re(-Number.MAX_VALUE, -Number.MAX_VALUE),
                            partIndices: []
                        }, this.buildingGroups.set(e1, t1)), t1.accX += p.acc.x, t1.accY += p.acc.y, t1.accCount += p.accCount, t1.mergedMin.x = Math.min(t1.mergedMin.x, _.min.x), t1.mergedMin.y = Math.min(t1.mergedMin.y, _.min.y), t1.mergedMax.x = Math.max(t1.mergedMax.x, _.max.x), t1.mergedMax.y = Math.max(t1.mergedMax.y, _.max.y), t1.partIndices.push(this.centroidData.length);
                    }
                    if (this.centroidData.push(_), p.borders) {
                        this.featuresOnBorder.push(p);
                        const e1 = this.featuresOnBorder.length - 1;
                        for(let t1 = 0; t1 < p.borders.length; t1++)p.borders[t1][0] !== Number.MAX_VALUE && this.borderFeatureIndices[t1].push(e1);
                    }
                    this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, n, o, a, r, l, void 0, this.worldview), this.groundEffect.addPaintPropertiesData(t1, n, o, a, r, l, this.worldview), this.maxHeight = Math.max(this.maxHeight, g);
                }
            }
            _finalizeBuildingGroups() {
                for (const [, e1] of this.buildingGroups){
                    if (0 === e1.partIndices.length) continue;
                    const t1 = new Sv;
                    t1.acc = new Re(e1.accX, e1.accY), t1.accCount = e1.accCount;
                    const i = t1.centroid(), n = this.encodeCentroid(i, e1.mergedMin, e1.mergedMax);
                    for (const t1 of e1.partIndices){
                        const r = this.centroidData.get(t1);
                        r.centroidXY.x === mv.x && r.centroidXY.y === mv.y || (r.centroidXY = n), r.min = e1.mergedMin, r.max = e1.mergedMax, r.groupCentroidPos = i;
                    }
                }
                this.buildingGroups.clear();
            }
            sortBorders() {
                for(let e1 = 0; e1 < this.borderFeatureIndices.length; e1++)this.borderFeatureIndices[e1].sort((t1, i)=>this.featuresOnBorder[t1].borders[e1][0] - this.featuresOnBorder[i].borders[e1][0]);
            }
            splitToSubtiles() {
                const e1 = [];
                for(let t1 = 0; t1 < this.centroidData.length; t1++){
                    const i = this.centroidData.get(t1), n = +(i.min.y + i.max.y > Sr), r = 2 * n + (+(i.min.x + i.max.x > Sr) ^ n);
                    for(let n = 0; n < i.polygonSegLen; n++){
                        const o = i.polygonSegIdx + n;
                        e1.push({
                            centroidIdx: t1,
                            subtile: r,
                            polygonSegmentIdx: o,
                            triangleSegmentIdx: this.polygonSegments[o].triangleSegIdx
                        });
                    }
                }
                const t1 = new nu;
                e1.sort((e1, t1)=>e1.triangleSegmentIdx === t1.triangleSegmentIdx ? e1.subtile - t1.subtile : e1.triangleSegmentIdx - t1.triangleSegmentIdx);
                let i = 0, n = 0, r = 0;
                for (const t1 of e1){
                    if (t1.triangleSegmentIdx !== i) break;
                    r++;
                }
                const o = e1.length;
                for(; n !== e1.length;){
                    i = e1[n].triangleSegmentIdx;
                    let a = 0, s = n, l = n;
                    for(let t1 = s; t1 < r && e1[t1].subtile === a; t1++)l++;
                    for(; s !== r;){
                        const n = e1[s];
                        a = n.subtile;
                        const o = this.centroidData.get(n.centroidIdx).min.clone(), c = this.centroidData.get(n.centroidIdx).max.clone(), u = {
                            vertexOffset: this.segments.segments[i].vertexOffset,
                            primitiveOffset: t1.length,
                            vertexLength: this.segments.segments[i].vertexLength,
                            primitiveLength: 0,
                            sortKey: void 0,
                            vaos: {}
                        };
                        for(let i = s; i < l; i++){
                            const n = e1[i], r = this.polygonSegments[n.polygonSegmentIdx], a = this.centroidData.get(n.centroidIdx).min, s = this.centroidData.get(n.centroidIdx).max, l = this.indexArray.uint16;
                            for(let e1 = r.triangleArrayOffset; e1 < r.triangleArrayOffset + r.triangleCount; e1++)t1.emplaceBack(l[3 * e1], l[3 * e1 + 1], l[3 * e1 + 2]);
                            u.primitiveLength += r.triangleCount, o.x = Math.min(o.x, a.x), o.y = Math.min(o.y, a.y), c.x = Math.max(c.x, s.x), c.y = Math.max(c.y, s.y);
                        }
                        u.primitiveLength > 0 && this.triangleSubSegments.push({
                            segment: u,
                            min: o,
                            max: c
                        }), s = l;
                        for(let t1 = s; t1 < r && e1[t1].subtile === e1[s].subtile; t1++)l++;
                    }
                    n = r;
                    for(let t1 = n; t1 < o && e1[t1].triangleSegmentIdx === e1[n].triangleSegmentIdx; t1++)r++;
                }
                t1._trim(), this.indexArray = t1;
            }
            getVisibleSegments(e1, t1, i) {
                const n = new Ou;
                if (this.wallMode) {
                    for (const e1 of this.triangleSubSegments)n.segments.push(e1.segment);
                    return n;
                }
                let r = 0, o = 0;
                const a = 1 << e1.canonical.z;
                if (t1) {
                    const i = t1.getMinMaxForTile(e1);
                    i && (r = i.min, o = i.max);
                }
                o += this.maxHeight;
                const s = e1.toUnwrapped();
                let l;
                const c = [
                    s.canonical.x / a + s.wrap,
                    s.canonical.y / a
                ], u = [
                    (s.canonical.x + 1) / a + s.wrap,
                    (s.canonical.y + 1) / a
                ], h = (e1, t1, i)=>[
                        hn(e1[0], t1[0], i[0]),
                        hn(e1[1], t1[1], i[1])
                    ], d = [], f = [];
                for (const e1 of this.triangleSubSegments){
                    d[0] = e1.min.x / Sr, d[1] = e1.min.y / Sr, f[0] = e1.max.x / Sr, f[1] = e1.max.y / Sr;
                    const t1 = h(c, u, d), a = h(c, u, f);
                    if (0 === new Nf([
                        t1[0],
                        t1[1],
                        r
                    ], [
                        a[0],
                        a[1],
                        o
                    ]).intersectsPrecise(i)) {
                        l && (n.segments.push(l), l = void 0);
                        continue;
                    }
                    const s = e1.segment;
                    l && l.vertexOffset !== s.vertexOffset && (n.segments.push(l), l = void 0), l ? (l.vertexLength += s.vertexLength, l.primitiveLength += s.primitiveLength) : l = {
                        vertexOffset: s.vertexOffset,
                        primitiveLength: s.primitiveLength,
                        vertexLength: s.vertexLength,
                        primitiveOffset: s.primitiveOffset,
                        sortKey: void 0,
                        vaos: s.vaos
                    };
                }
                return l && n.segments.push(l), n;
            }
            encodeCentroid(e1, t1, i) {
                const n = Math.min(7, Math.round((i.x - t1.x) * this.tileToMeter / 10)), r = Math.min(6, Math.round((i.y - t1.y) * this.tileToMeter / 10));
                return new Re(tt(e1.x, 1, 8191) << 3 | n, tt(e1.y, 1, 8191) << 3 | r);
            }
            encodeBorderCentroid(e1) {
                if (!e1.borders) return new Re(0, 0);
                const t1 = e1.borders, i = Number.MAX_VALUE;
                if (t1[0][0] !== i || t1[1][0] !== i) {
                    const e1 = t1[0][0] !== i ? 0 : 1;
                    return new Re(6 | (t1[0][0] !== i ? 0 : 65528), (t1[e1][0] + t1[e1][1]) / 2 << 3 | 6);
                }
                {
                    const e1 = t1[2][0] !== i ? 2 : 3;
                    return new Re((t1[e1][0] + t1[e1][1]) / 2 << 3 | 6, 6 | (t1[2][0] !== i ? 0 : 65528));
                }
            }
            setBuildingCentroid(e1, t1) {
                const i = this.centroidData.data;
                if (!this.partsByBuildingId) {
                    const e1 = new Uint32Array(i.length);
                    let t1 = 0;
                    for(let n = 0; n < i.length; n++)isNaN(i[n].buildingId) || (e1[t1++] = n);
                    this.partsByBuildingId = e1.subarray(0, t1).sort((e1, t1)=>i[e1].buildingId - i[t1].buildingId);
                }
                const n = this.partsByBuildingId;
                let r = 0, o = n.length;
                for(; r < o;){
                    const t1 = r + o >> 1;
                    i[n[t1]].buildingId < e1 ? r = t1 + 1 : o = t1;
                }
                for(let o = r; o < n.length && i[n[o]].buildingId === e1; o++)i[n[o]].centroidXY = t1, this.writeCentroidToBuffer(i[n[o]]);
            }
            showCentroid(e1, t1) {
                const i = this.centroidData.get(e1.centroidDataIndex);
                if (i.flags &= gv, "keep" === t1 && !(7 & ~i.centroidXY.y)) return void this.writeCentroidToBuffer(i);
                const n = i.groupCentroidPos;
                i.centroidXY = 0 !== n.x || 0 !== n.y ? this.encodeCentroid(n, i.min, i.max) : new Re(0, 0), this.writeCentroidToBuffer(i);
            }
            writeCentroidToBuffer(e1) {
                this.groundEffect.updateHiddenByLandmark(e1);
                const t1 = e1.vertexArrayOffset, i = e1.vertexCount + e1.vertexArrayOffset, n = -1073741824 & e1.flags ? mv : e1.centroidXY, r = this.centroidVertexArray.geta_centroid_pos0(t1);
                if (this.centroidVertexArray.geta_centroid_pos1(t1) !== n.y || r !== n.x) {
                    for(let e1 = t1; e1 < i; ++e1)this.centroidVertexArray.emplace(e1, n.x, n.y);
                    this.needsCentroidUpdate = !0;
                }
            }
            createCentroidsBuffer() {
                this.centroidVertexArray.resize(this.layoutVertexArray.length), this.groundEffect.hiddenByLandmarkVertexArray.resize(this.groundEffect.vertexArray.length);
                for (const e1 of this.centroidData)this.writeCentroidToBuffer(e1);
            }
            updateReplacement(e1, t1, i) {
                if (t1.updateTime === this.replacementUpdateTime) return;
                this.replacementUpdateTime = t1.updateTime;
                const n = t1.getReplacementRegionsForTile(e1.toUnwrapped());
                if (Qp(this.activeReplacements, n)) return;
                if (this.activeReplacements = n, 0 === this.centroidVertexArray.length) this.createCentroidsBuffer();
                else for (const e1 of this.centroidData)e1.flags &= 1073741823;
                const r = [];
                for (const t1 of this.activeReplacements){
                    if (t1.order < i) continue;
                    const n = Math.max(1, Math.pow(2, t1.footprintTileId.canonical.z - e1.canonical.z));
                    if (t1.footprint.buildingIds) for (const e1 of this.centroidData)e1.flags & gv || e1.flags & yv || t1.min.x > e1.max.x || e1.min.x > t1.max.x || t1.min.y > e1.max.y || e1.min.y > t1.max.y || t1.footprint.buildingIds.has(e1.buildingId) && (e1.flags |= t1.clipMask !== h_.None ? -1073741824 : gv);
                    else for (const i of this.centroidData)if (!(i.flags & gv || i.flags & yv || t1.min.x > i.max.x || i.min.x > t1.max.x || t1.min.y > i.max.y || i.min.y > t1.max.y)) for(let o = 0; o < i.footprintSegLen; o++){
                        const a = this.footprintSegments.get(i.footprintSegIdx + o);
                        if (r.length = 0, Zv(this.footprintVertices, a.vertexOffset, a.vertexCount, t1.footprintTileId.canonical, e1.canonical, r), s_(t1.footprint, r, this.footprintIndices.uint16, a.indexOffset, a.indexCount, -a.vertexOffset, -n)) {
                            i.flags |= t1.clipMask !== h_.None ? -1073741824 : gv;
                            break;
                        }
                    }
                }
                for (const e1 of this.centroidData)this.writeCentroidToBuffer(e1);
                this.borderDoneWithNeighborZ = [
                    -1,
                    -1,
                    -1,
                    -1
                ];
            }
            footprintContainsPoint(e1, t1, i) {
                let n = !1;
                for(let r = 0; r < i.footprintSegLen; r++){
                    const o = this.footprintSegments.get(i.footprintSegIdx + r);
                    let a = 0;
                    for (const i of o.ringIndices){
                        for(let r = a, s = i + a - 1; r < i + a; s = r++){
                            const i = this.footprintVertices.int16[2 * (r + o.vertexOffset) + 0], a = this.footprintVertices.int16[2 * (r + o.vertexOffset) + 1], l = this.footprintVertices.int16[2 * (s + o.vertexOffset) + 1];
                            a > t1 != l > t1 && e1 < (this.footprintVertices.int16[2 * (s + o.vertexOffset) + 0] - i) * (t1 - a) / (l - a) + i && (n = !n);
                        }
                        a = i;
                    }
                }
                return n;
            }
            getHeightAtTileCoord(e1, t1) {
                let i = Number.NEGATIVE_INFINITY, n = !0;
                const r = 4 * (e1 + Sr) * Sr + (t1 + Sr);
                this.partLookup ??= new Map;
                const o = this.partLookup.get(r);
                if (void 0 !== o) return o ? {
                    height: o.height,
                    hidden: !!(o.flags & gv)
                } : void 0;
                const a = this.centroidData.buffer, s = this.centroidData.length;
                for(let o = 0; o < s; o++){
                    const s = 15 * o;
                    if (e1 > a[s + 4] || a[s + 2] > e1 || t1 > a[s + 5] || a[s + 3] > t1) continue;
                    const l = a[s + 13];
                    if (l <= i) continue;
                    const c = this.centroidData.get(o);
                    this.footprintContainsPoint(e1, t1, c) && (i = l, this.partLookup.set(r, c), n = !!(c.flags & gv));
                }
                if (i !== Number.NEGATIVE_INFINITY) return {
                    height: i,
                    hidden: n
                };
                this.partLookup.set(r, null);
            }
        }
        function Fv(e1, t1, i) {
            return e1.equals(t1) ? i : t1.sub(e1)._unit();
        }
        function Cv(e1, t1, i) {
            return e1.equals(t1) ? i : t1.sub(e1)._perp()._unit();
        }
        function Ov(e1, t1) {
            const i = e1.add(t1), n = i.mag();
            return 0 === n ? e1 : i.div(n);
        }
        function Lv(e1, t1) {
            const i = Ov(e1, t1);
            return e1.x * i.x + e1.y * i.y;
        }
        function Bv(e1, t1, i, n) {
            let r, o;
            return e1.equals(t1) ? (o = Cv(t1, i, new Re(0, 0)), r = o) : (r = t1.sub(e1)._perp()._unit(), o = Cv(t1, i, r)), Vv(e1, t1, i, Lv(r, o), n);
        }
        function Vv(e1, t1, i, n, r) {
            const o = Math.sqrt(1 - n * n);
            return Math.min(e1.dist(t1) / 3, t1.dist(i) / 3, r * o / n);
        }
        function Nv(e1, t1, i) {
            return e1.x < i[0].x && t1.x < i[0].x || e1.x > i[1].x && t1.x > i[1].x || e1.y < i[0].y && t1.y < i[0].y || e1.y > i[1].y && t1.y > i[1].y;
        }
        function kv(e1, t1) {
            return e1.x < t1[0].x || e1.x > t1[1].x || e1.y < t1[0].y || e1.y > t1[1].y;
        }
        function Uv(e1) {
            return e1.every((e1)=>e1.x <= 0) || e1.every((e1)=>e1.x >= Sr) || e1.every((e1)=>e1.y <= 0) || e1.every((e1)=>e1.y >= Sr);
        }
        function jv(e1, t1, i) {
            if (e1.x < 0 || e1.x >= Sr || t1.x < 0 || t1.x >= Sr || i.x < 0 || i.x >= Sr) return !1;
            const n = i.sub(t1), r = n.perp(), o = e1.sub(t1);
            return (n.x * o.x + n.y * o.y) / Math.sqrt((n.x * n.x + n.y * n.y) * (o.x * o.x + o.y * o.y)) > -0.866 && r.x * o.x + r.y * o.y < 0;
        }
        function Gv(e1, t1, i) {
            const n = t1 ? 2 | e1 : -3 & e1;
            return i ? 1 | n : -2 & n;
        }
        function Hv() {
            const e1 = Math.PI / 32, t1 = Math.tan(e1), i = rc;
            return i * Math.sqrt(1 + 2 * t1 * t1) - i;
        }
        function $v(e1, t1, i) {
            const n = 1 << i.z, r = dr(i.x / n), o = dr((i.x + 1) / n), a = fr(i.y / n), s = fr((i.y + 1) / n);
            return function(e1, t1, i, n, r = 0, o) {
                const a = [];
                if (!e1.length || !i || !n) return a;
                const s = (e1, t1)=>{
                    for (const i of e1)a.push({
                        polygon: i,
                        bounds: t1
                    });
                }, l = Math.ceil(Math.log2(i)), c = Math.ceil(Math.log2(n)), u = l - c, h = [];
                for(let e1 = 0; e1 < Math.abs(u); e1++)h.push(u > 0 ? 0 : 1);
                for(let e1 = 0; e1 < Math.min(l, c); e1++)h.push(0), h.push(1);
                let d = e1;
                if (d = lv(d, t1[0].y - r, t1[1].y + r, 1), d = lv(d, t1[0].x - r, t1[1].x + r, 0), !d.length) return a;
                const f = [];
                for(h.length ? f.push({
                    polygons: d,
                    bounds: t1,
                    depth: 0
                }) : s(d, t1); f.length;){
                    const e1 = f.pop(), t1 = e1.depth, i = h[t1], n = e1.bounds[0], a = e1.bounds[1], l = 0 === i ? n.x : n.y, c = 0 === i ? a.x : a.y, u = o ? o(i, l, c) : .5 * (l + c), d = lv(e1.polygons, l - r, u + r, i), p = lv(e1.polygons, u - r, c + r, i);
                    if (d.length) {
                        const e1 = [
                            n,
                            new Re(0 === i ? u : a.x, 1 === i ? u : a.y)
                        ];
                        h.length > t1 + 1 ? f.push({
                            polygons: d,
                            bounds: e1,
                            depth: t1 + 1
                        }) : s(d, e1);
                    }
                    if (p.length) {
                        const e1 = [
                            new Re(0 === i ? u : n.x, 1 === i ? u : n.y),
                            a
                        ];
                        h.length > t1 + 1 ? f.push({
                            polygons: p,
                            bounds: e1,
                            depth: t1 + 1
                        }) : s(p, e1);
                    }
                }
                return a;
            }(e1, t1, Math.ceil((o - r) / 11.25), Math.ceil((a - s) / 11.25), 1, (e1, t1, r)=>{
                if (0 === e1) return .5 * (t1 + r);
                {
                    const e1 = fr((i.y + t1 / Sr) / n);
                    return (hr(.5 * (fr((i.y + r / Sr) / n) + e1)) * n - i.y) * Sr;
                }
            });
        }
        function Zv(e1, t1, i, n, r, o) {
            const a = Math.pow(2, n.z - r.z);
            for(let s = 0; s < i; s++){
                let i = e1.int16[2 * (s + t1) + 0], l = e1.int16[2 * (s + t1) + 1];
                i = (i + r.x * Sr) * a - n.x * Sr, l = (l + r.y * Sr) * a - n.y * Sr, o.push(new Re(i, l));
            }
        }
        Ya(Dv, "FillExtrusionBucket", {
            omit: [
                "layers",
                "features"
            ]
        }), Ya(Iv, "PartData"), Ya(Mv, "PartDataArray"), Ya(Ev, "FootprintSegmentArray"), Ya(Sv, "BorderCentroidData"), Ya(Pv, "GroundEffect");
        const Wv = 4096;
        class qv {
            constructor(e1){
                this.module = e1, this.memoryStack = this.module.malloc(Wv), this.memoryStackNextFree = this.memoryStack;
            }
            createIntArray(e1) {
                const t1 = this.memoryStackNextFree;
                return this.memoryStackNextFree += e1.length * Int32Array.BYTES_PER_ELEMENT, this.memoryStackNextFree - this.memoryStack > Wv ? -1 : (new Int32Array(this.module.heap32.buffer, t1, e1.length).set(e1), t1);
            }
            createFloatArray(e1) {
                const t1 = this.memoryStackNextFree;
                return this.memoryStackNextFree += e1.length * Float32Array.BYTES_PER_ELEMENT, this.memoryStackNextFree - this.memoryStack > Wv ? -1 : (new Float32Array(this.module.heapF32.buffer, t1, e1.length).set(e1), t1);
            }
            readStringBuffer(e1) {
                let t1 = "";
                for(; 0 !== this.module.heapU8[e1];)t1 += String.fromCharCode(this.module.heapU8[e1]), ++e1;
                return t1;
            }
            setStyle(e1) {
                const t1 = e1.normalScale;
                this.module.setStyle(t1[0], t1[1], t1[2], e1.tileToMeters);
            }
            setAOOptions(e1, t1) {
                this.module.setAOOptions(e1 ? 1 : 0, t1);
            }
            setMetricOptions(e1, t1) {
                this.module.setMetricOptions(e1 ? 1 : 0, t1);
            }
            setStructuralOptions(e1) {
                this.module.setStructuralOptions(e1 ? 1 : 0);
            }
            setFacadeOptions(e1, t1) {
                this.module.setFacadeOptions(e1, t1 ? 1 : 0);
            }
            setFauxFacadeOptions(e1, t1, i) {
                this.module.setFauxFacadeOptions(e1 ? 1 : 0, t1 ? 1 : 0, i);
            }
            setFacadeClassifierOptions(e1) {
                this.module.setFacadeClassifierOptions(e1);
            }
            generateMesh(e1, t1) {
                this.memoryStackNextFree = this.memoryStack;
                for (const t1 of e1){
                    const e1 = this.createIntArray(t1.ringIndices), i = this.createFloatArray(t1.coordinates);
                    if (-1 === e1 || -1 === i) return `building_gen: Out of stack memory: ${this.memoryStackNextFree - this.memoryStack}/4096`;
                    this.module.addFeature(t1.id, t1.sourceId, t1.minHeight, t1.height, t1.roofType, i, e1, t1.ringIndices.length - 1);
                }
                for (const e1 of t1){
                    let t1;
                    t1 = e1.entrances ? JSON.parse(e1.entrances) : [];
                    const i = this.createFloatArray(t1), n = this.createFloatArray(e1.coordinates);
                    if (-1 === i || -1 === n) return `building_gen: Out of stack memory: ${this.memoryStackNextFree - this.memoryStack}/4096`;
                    this.module.addFacade(e1.sourceId, e1.crossPerc, e1.distanceToRoad, i, t1.length, n, e1.coordinates.length);
                }
                if (!this.module.generateMesh()) {
                    const e1 = this.module.getLastError();
                    return this.readStringBuffer(e1);
                }
                const i = this.module.getMeshCount(), n = new Array(i);
                for(let e1 = 0; e1 < i; e1++){
                    const t1 = this.module.getPositionsPtr(e1), i = this.module.getPositionsLength(e1), r = new Float32Array(this.module.heapF32.buffer, t1, i), o = this.module.getNormalsPtr(e1), a = this.module.getNormalsLength(e1), s = new Float32Array(this.module.heapF32.buffer, o, a), l = this.module.getAOPtr(e1), c = this.module.getAOLength(e1), u = new Float32Array(this.module.heapF32.buffer, l, c), h = this.module.getUVPtr(e1), d = this.module.getUVLength(e1), f = new Float32Array(this.module.heapF32.buffer, h, d), p = this.module.getFauxFacadePtr(e1), _ = this.module.getFauxFacadeLength(e1), m = new Uint8Array(this.module.heapU8.buffer, p, _), g = this.module.getIndicesPtr(e1), y = this.module.getIndicesLength(e1), x = new Int16Array(this.module.heap16.buffer, g, y), v = this.module.getBuildingPart(e1);
                    n[e1] = {
                        positions: r,
                        normals: s,
                        ao: u,
                        uv: f,
                        isFauxFacade: m,
                        indices: x,
                        buildingPart: v
                    };
                }
                const r = this.module.getRingCount(), o = [];
                for(let e1 = 0; e1 < r; e1++){
                    const t1 = this.module.getRingPtr(e1), i = this.module.getRingLength(e1), n = new Float32Array(this.module.heapF32.buffer, t1, i);
                    o.push(n);
                }
                return {
                    meshes: n,
                    outerRingLength: this.module.getOuterRingLength(),
                    modifiedPolygonRings: o
                };
            }
        }
        const Xv = Wh.types, Yv = 32767, Jv = -32768, Kv = 127, Qv = new Float32Array(1), eb = new Int32Array(Qv.buffer);
        function tb(e1, t1) {
            const i = Sr + t1;
            for (const n of e1)for (const e1 of n)if (e1.x < -t1 || e1.x > i || e1.y < -t1 || e1.y > i) return !1;
            return !0;
        }
        function ib(e1) {
            switch(e1){
                case "flat":
                    return 3;
                case "hipped":
                    return 1;
                case "gabled":
                    return 2;
                case "parapet":
                    return 0;
                case "mansard":
                    return 4;
                case "skillion":
                    return 5;
                case "pyramidal":
                    return 6;
                default:
                    throw new Error(`Unknown roof shape: ${e1}`);
            }
        }
        let nb, rb, ob = null, ab = null, sb = null;
        class lb {
            constructor(){
                this.layoutVertexArray = new jc, this.layoutAttenuationArray = new qc, this.layoutColorArray = new Jc, this.indexArray = new nu, this.indexArrayForConflation = new nu, this.segmentsBucket = new Ou;
            }
        }
        class cb {
            constructor(e1){
                this.layoutFacadePaintArray = null, this.layoutFacadeDataArray = null, this.layoutFacadeVerticalRangeArray = null, this.segmentsBucket = new Ou, this.entranceBloom = new lb;
                const t1 = 66560;
                this.layoutVertexArray = new Yc, this.layoutVertexArray.reserve(t1), this.layoutNormalArray = new pu, this.layoutNormalArray.reserve(t1), this.layoutCentroidArray = new Cc, this.layoutCentroidArray.reserve(t1), this.layoutColorArray = new Jc, this.layoutColorArray.reserve(t1), this.layoutFloodLightDataArray = new mu, this.layoutFloodLightDataArray.reserve(t1), this.layoutAOArray = new gu, this.layoutAOArray.reserve(t1), this.indexArray = new nu, this.indexArray.reserve(66560), this.indexArrayForConflation = new nu, this.segmentsBucket = new Ou, this.entranceBloom = new lb, e1 && (this.layoutFacadePaintArray = new Jc, this.layoutFacadeDataArray = new Hc, this.layoutFacadeVerticalRangeArray = new Jc);
            }
            reserve(e1, t1, i) {
                this.layoutVertexArray.reserveForAdditional(e1), this.layoutCentroidArray.reserveForAdditional(e1), this.layoutFloodLightDataArray.reserveForAdditional(e1), this.layoutNormalArray.reserveForAdditional(e1), this.layoutAOArray.reserveForAdditional(e1), this.layoutColorArray.reserveForAdditional(e1), this.indexArray.reserveForAdditional(t1), i && (this.layoutFacadePaintArray.reserveForAdditional(e1), this.layoutFacadeDataArray.reserveForAdditional(e1), this.layoutFacadeVerticalRangeArray.reserveForAdditional(e1));
            }
        }
        class ub {
            constructor(e1){
                this.requiresHDRuntime = !0, this.colorBufferUploaded = !1, this.maxHeight = 0, this.replacementUpdateTime = 0, this.activeReplacements = [], this.footprints = [], this.footprintsVertices = new hu, this.footprintsIndices = new fu, this.footprintsMin = new Re(1 / 0, 1 / 0), this.footprintsMax = new Re(-1 / 0, -1 / 0), this.featuresOnBorder = [], this.buildingWithoutFacade = new cb(!1), this.buildingWithFacade = new cb(!0), this.indexArrayForConflationUploaded = !1, this.featureFootprintLookup = new Map, this.buildingIds = new Set, this.footprintLookup = {}, this.zoom = e1.zoom, this.canonical = e1.canonical, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.hasPattern = !1, this.worldview = e1.worldview, this.lut = e1.lut, this.programConfigurations = new ch(e1.layers, {
                    zoom: e1.zoom,
                    lut: e1.lut
                }), this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.projection = e1.projection, this.groundEffect = new Pv(e1), this.groundEffect.groundRadiusArray = new Lc, this.hasAppearances = null;
            }
            updateFootprints(e1, t1) {
                const i = new Wy([], [], 1), n = {
                    vertices: new Float64Array(0),
                    indices: new Uint32Array(0),
                    grid: i,
                    min: this.footprintsMin,
                    max: this.footprintsMax,
                    buildingIds: this.buildingIds
                };
                t1.push({
                    footprint: n,
                    id: e1
                });
            }
            updateAppearances(e1, t1, i, n) {
                return {
                    hasLayoutChanges: !1,
                    hasUboChanges: !1
                };
            }
            populate(e1, t1, i, n) {
                if (!sb) return;
                const r = _c(i);
                this.tileToMeter = r, this.brightness = t1.brightness, sb.setStyle({
                    normalScale: [
                        1,
                        -1,
                        r
                    ],
                    tileToMeters: r
                }), sb.setAOOptions(!1, .3), sb.setMetricOptions(!1, 16), sb.setStructuralOptions(!0), sb.setFacadeClassifierOptions(3);
                const o = this.layers[0]._featureFilter, a = o.needGeometry, s = new Ls(this.zoom, {
                    worldview: this.worldview,
                    activeFloors: t1.activeFloors
                }), l = new Map, c = new Map;
                let u = 0;
                for (const { feature: t1 } of e1){
                    if ("LineString" !== Xv[t1.type]) {
                        l.set(t1.id, t1.properties.source_id);
                        continue;
                    }
                    const e1 = Mc(t1, a);
                    if (!o.filter(s, e1, i)) continue;
                    const r = Ic(t1, e1, a, i, n), h = [];
                    for (const e1 of r)for (const t1 of e1)h.push(t1.x), h.push(t1.y);
                    const d = {
                        coordinates: h,
                        crossPerc: t1.properties.cross_perc,
                        distanceToRoad: t1.properties.distance_to_road,
                        entrances: t1.properties.entrances,
                        sourceId: 0
                    }, f = t1.properties.source_id;
                    let p = c.get(f);
                    p || (p = [], c.set(f, p)), p.push(d), ++u;
                }
                this.maxHeight = 0;
                const h = new Array, d = new Set, f = (e1)=>{
                    null != e1 && d.add(e1);
                }, p = (e1, t1)=>{
                    null != e1 && h.push({
                        buildingId: e1,
                        footprintIndex: t1
                    });
                }, _ = 64 * (e1.length - u), m = _ / 2;
                this.buildingWithFacade.reserve(_, m, !0), this.buildingWithoutFacade.reserve(2 * _, 2 * m, !1), this.footprintsIndices.reserve(16 * (e1.length - u)), this.footprintsVertices.reserve(8 * (e1.length - u));
                for (const { feature: u, id: h, index: _, sourceLayerIndex: m } of e1){
                    if ("LineString" === Xv[u.type]) continue;
                    let e1 = null;
                    if (u.properties && Object.hasOwn(u.properties, "building_id") && (e1 = Number(u.properties.building_id), d.has(e1))) continue;
                    const g = Mc(u, a);
                    if (!o.filter(s, g, i)) continue;
                    const y = Ic(u, g, a, i, n), x = Ve(y, 500);
                    let v = !1;
                    for (const e1 of x)if (1 !== e1.length) {
                        v = !0;
                        break;
                    }
                    if (v) {
                        f(e1);
                        continue;
                    }
                    if (!tb(y, 163)) {
                        f(e1);
                        continue;
                    }
                    const b = this.layers[0], w = ib(b.layout.get("building-roof-shape").evaluate(u, {}, i)), A = b.layout.get("building-base").evaluate(u, {}, i), E = b.layout.get("building-height").evaluate(u, {}, i), I = b.layout.get("building-flood-light-ground-radius").evaluate(u, {}, i), M = b.paint.get("building-ambient-occlusion-intensity"), S = I / this.tileToMeter;
                    u.properties["building-part"] = "roof";
                    const T = b.paint.get("building-color").evaluate(u, {}, this.canonical).toPremultipliedRenderColor(this.lut), z = b.paint.get("building-emissive-strength").evaluate(u, {}, this.canonical);
                    u.properties["building-part"] = "wall";
                    const R = b.paint.get("building-color").evaluate(u, {}, this.canonical).toPremultipliedRenderColor(this.lut), P = b.paint.get("building-emissive-strength").evaluate(u, {}, this.canonical);
                    u.properties["building-part"] = "window";
                    const D = b.paint.get("building-color").evaluate(u, {}, this.canonical).toPremultipliedRenderColor(this.lut), F = b.paint.get("building-emissive-strength").evaluate(u, {}, this.canonical);
                    u.properties["building-part"] = "door";
                    const C = b.paint.get("building-color").evaluate(u, {}, this.canonical).toPremultipliedRenderColor(this.lut), O = b.paint.get("building-emissive-strength").evaluate(u, {}, this.canonical);
                    let L = b.layout.get("building-flood-light-wall-radius").evaluate(u, {}, i);
                    L = tt(L, 0, 2048);
                    const B = L / 2048 * Yv, V = l.get(h), N = c.get(V) || [], k = 0 !== N.length && b.layout.get("building-facade").evaluate(u, {}, i);
                    sb.setFacadeOptions(4, !0), sb.setFauxFacadeOptions(k, !1, 1);
                    let U = 0, j = 0, G = 0, H = 0, $ = 0, Z = 0, W = 0, q = 0, X = 0, Y = 0, J = 0;
                    if (k) {
                        let e1 = Math.round(b.layout.get("building-facade-floors").evaluate(u, {}, i));
                        if (0 === A) {
                            e1 = Math.max(1, e1 - (N.length > 0 ? 1 : 0));
                            let t1 = 4;
                            if (E > 100) {
                                const e1 = [
                                    10,
                                    13,
                                    15
                                ];
                                t1 = e1[u.id ? u.id % e1.length : 0];
                            } else E <= 10 && (t1 = 3);
                            sb.setFacadeOptions(t1, !0), $ = (E < 15 ? 1.3 : 1.61803) * t1 / r;
                        } else $ = A / r;
                        Z = E / r, $ = Math.min($, Z), G = b.layout.get("building-facade-unit-width").evaluate(u, {}, i) / r, H = (Z - $) / e1, sb.setFauxFacadeOptions(!0, !0, G);
                        const t1 = b.layout.get("building-facade-window").evaluate(u, {}, i);
                        U = t1[0], j = t1[1], W = Math.floor(65535 * Math.min(1, $ / Sr)), q = Math.floor(65535 * Math.min(1, Z / Sr)), X = Math.floor(255 * U) << 8 | Math.floor(255 * j), Y = Math.floor(65535 * Math.min(1, G / Sr)), J = Math.floor(65535 * Math.min(1, H / Sr));
                    }
                    const K = Array(x.length), Q = {
                        x: 1 / 0,
                        y: 1 / 0
                    }, ee = {
                        x: -1 / 0,
                        y: -1 / 0
                    }, te = {
                        x: 0,
                        y: 0
                    };
                    let ie = 0;
                    for(let e1 = 0; e1 < x.length; e1++){
                        const t1 = x[e1];
                        if (t1.length > 0) {
                            const i = [], n = Array(t1.length + 1);
                            n[0] = 0;
                            for(let e1 = 0; e1 < t1.length; e1++){
                                const r = t1[e1];
                                for(let e1 = 0; e1 < r.length; e1++){
                                    const t1 = r[r.length - e1 - 1];
                                    Q.x = Math.min(Q.x, t1.x), Q.y = Math.min(Q.y, t1.y), ee.x = Math.max(ee.x, t1.x), ee.y = Math.max(ee.y, t1.y), te.x += t1.x, te.y += t1.y, ie++, i.push(t1.x), i.push(t1.y);
                                }
                                n[e1 + 1] = i.length;
                            }
                            K[e1] = {
                                id: u.id ? u.id : 0,
                                height: E,
                                minHeight: A,
                                sourceId: 0,
                                roofType: w,
                                coordinates: i,
                                ringIndices: n
                            };
                        }
                    }
                    te.x /= ie || 1, te.y /= ie || 1;
                    const ne = sb.generateMesh(K, N);
                    if ("string" == typeof ne) {
                        _t(`Unable to generate building ${u.id}: ${ne}`), f(e1);
                        continue;
                    }
                    if (0 === ne.meshes.length || 0 === ne.modifiedPolygonRings.length) {
                        f(e1);
                        continue;
                    }
                    const re = k ? this.buildingWithFacade : this.buildingWithoutFacade;
                    let oe = 0;
                    for (const e1 of ne.meshes)oe += e1.positions.length / 3;
                    const ae = re.segmentsBucket.prepareSegment(oe, re.layoutVertexArray, re.indexArray), se = [];
                    let le = null, ce = 0, ue = -1;
                    const he = re.layoutVertexArray.length, de = he + oe;
                    re.layoutVertexArray.resize(de), re.layoutCentroidArray.resize(de), re.layoutNormalArray.resize(de), re.layoutAOArray.resize(de), re.layoutColorArray.resize(de), re.layoutFloodLightDataArray.resize(de), k && (re.layoutFacadePaintArray.resize(de), re.layoutFacadeDataArray.resize(de), re.layoutFacadeVerticalRangeArray.resize(de));
                    const fe = re.indexArray.length;
                    let pe = 0, _e = he;
                    for (const e1 of ne.meshes){
                        let t1, i;
                        if (1 === e1.buildingPart) t1 = T, i = z;
                        else if (0 === e1.buildingPart) t1 = R, i = P;
                        else if (2 === e1.buildingPart) t1 = D, i = F;
                        else {
                            if (3 !== e1.buildingPart) continue;
                            t1 = C, i = O;
                        }
                        if (i = tt(i, 0, 1), 3 === e1.buildingPart) {
                            const t1 = new Array;
                            for(let i = 0; i < e1.positions.length; i += 12){
                                const n = e1.positions[i + 0], r = e1.positions[i + 1], o = e1.positions[i + 3], a = e1.positions[i + 4], s = e1.positions[i + 2], l = e1.positions[i + 8] - s, c = 1, u = o - n, h = a - r, d = Math.hypot(u, h);
                                t1.push({
                                    pos: [
                                        n + .5 * u,
                                        r + .5 * h,
                                        s
                                    ],
                                    normal: [
                                        h / d,
                                        -u / d,
                                        0
                                    ],
                                    width: d,
                                    height: l,
                                    depth: c,
                                    points: [
                                        n,
                                        r,
                                        o,
                                        a
                                    ]
                                });
                            }
                            const i = re.entranceBloom.segmentsBucket.prepareSegment(10 * t1.length, re.entranceBloom.layoutVertexArray, re.entranceBloom.indexArray), n = re.entranceBloom.layoutVertexArray.length;
                            ce = re.entranceBloom.indexArray.length, jx(t1, .5 / this.tileToMeter, re.entranceBloom.indexArray, re.entranceBloom.layoutVertexArray, re.entranceBloom.layoutAttenuationArray);
                            const r = re.entranceBloom.layoutVertexArray.length - n;
                            ue = re.entranceBloom.indexArray.length - ce;
                            for(let e1 = 0; e1 < r; e1++)re.entranceBloom.layoutColorArray.emplaceBack(255 * C.r << 8 | 255 * C.g, 255 * C.b << 8 | 51 * O);
                            i.vertexLength += r, i.primitiveLength += ue, le = {
                                part: e1.buildingPart,
                                vertexOffset: n,
                                vertexLength: r
                            };
                        }
                        const n = e1.positions.length / 3;
                        for(let r = 0; r < n; ++r){
                            const n = 3 * r, o = e1.positions[n + 2];
                            pe = Math.max(pe, o);
                            const a = 2 * (_e + r), s = tt(Math.round(e1.positions[n]), Jv, Yv), l = tt(Math.round(e1.positions[n + 1]), Jv, Yv);
                            Qv[0] = o, re.layoutVertexArray.int32[a + 0] = s << 16 | 65535 & l, re.layoutVertexArray.int32[a + 1] = eb[0];
                            const c = 4 * (_e + r);
                            re.layoutNormalArray.int8[c + 0] = tt(e1.normals[n + 0] * Kv, -127, Kv), re.layoutNormalArray.int8[c + 1] = tt(e1.normals[n + 1] * Kv, -127, Kv), re.layoutNormalArray.int8[c + 2] = tt(e1.normals[n + 2] * Kv, -127, Kv), re.layoutNormalArray.int8[c + 3] = 0;
                            const u = e1.ao[r];
                            re.layoutAOArray.uint8[_e + r] = 255 * u;
                            const h = 1 + (u - 1) * M, d = 255 * t1.b * h << 8 | 255 * i;
                            re.layoutColorArray.uint16[2 * (_e + r)] = 255 * t1.r * h << 8 | 255 * t1.g * h, re.layoutColorArray.uint16[2 * (_e + r) + 1] = d;
                        }
                        const r = Math.min(8191, Math.max(0, Math.floor(te.x))), o = Math.min(8191, Math.max(0, Math.floor(te.y))), a = Math.floor(E), s = 20, l = 4 * r + Math.min(3, Math.round((ee.x - Q.x) * this.tileToMeter / s)), c = 4 * o + Math.min(3, Math.round((ee.y - Q.y) * this.tileToMeter / s));
                        for(let e1 = 0; e1 < n; ++e1){
                            const t1 = 3 * (_e + e1);
                            re.layoutCentroidArray.int16[t1] = l, re.layoutCentroidArray.int16[t1 + 1] = c, re.layoutCentroidArray.int16[t1 + 2] = a;
                        }
                        if (re.layoutFloodLightDataArray.int16.fill(0 === e1.buildingPart ? B : 0, _e, _e + n), k) {
                            const t1 = 255 * D.r << 8 | 255 * D.g, i = 255 * D.b << 8 | 255 * F;
                            for(let e1 = 0; e1 < n; ++e1){
                                const n = 2 * (_e + e1);
                                re.layoutFacadePaintArray.uint16[n] = t1, re.layoutFacadePaintArray.uint16[n + 1] = i;
                            }
                            for(let t1 = 0; t1 < n; ++t1)if (e1.isFauxFacade[t1]) {
                                const i = Math.min(65535, Math.floor(e1.uv[2 * t1] * ne.outerRingLength));
                                re.layoutFacadeDataArray.emplace(_e + t1, 1 | i, X, Y, J), re.layoutFacadeVerticalRangeArray.emplace(_e + t1, W, q);
                            } else re.layoutFacadeDataArray.emplace(_e + t1, 0, 0, 0, 0), re.layoutFacadeVerticalRangeArray.emplace(_e + t1, 0, 0);
                        }
                        const u = ae.vertexLength, h = e1.indices.length / 3, d = re.indexArray.length;
                        re.indexArray.resize(d + h);
                        for(let t1 = 0; t1 < h; ++t1){
                            const i = 3 * t1, n = 3 * d + i;
                            re.indexArray.uint16[n] = u + e1.indices[i], re.indexArray.uint16[n + 1] = u + e1.indices[i + 1], re.indexArray.uint16[n + 2] = u + e1.indices[i + 2];
                        }
                        1 !== e1.buildingPart && 0 !== e1.buildingPart && 2 !== e1.buildingPart && 3 !== e1.buildingPart || se.push({
                            part: e1.buildingPart,
                            vertexOffset: _e,
                            vertexLength: e1.positions.length / 3
                        }), _e += n, ae.vertexLength += n, ae.primitiveLength += e1.indices.length / 3;
                    }
                    this.maxHeight = Math.max(this.maxHeight, pe);
                    const me = re.indexArray.length - fe, ge = this.footprintsIndices.length, ye = this.footprintsVertices.length, xe = [], ve = new Re(1 / 0, 1 / 0), be = new Re(-1 / 0, -1 / 0), we = A <= 0, Ae = this.groundEffect.vertexArray.length;
                    for (const e1 of ne.modifiedPolygonRings){
                        const t1 = [], i = new Re(1 / 0, 1 / 0), n = new Re(-1 / 0, -1 / 0);
                        for(let r = 0; r < e1.length; r += 2){
                            const o = e1.length - r - 2;
                            i.x = Math.min(i.x, e1[o]), i.y = Math.min(i.y, e1[o + 1]), n.x = Math.max(n.x, e1[o]), n.y = Math.max(n.y, e1[o + 1]);
                            const a = new Re(e1[o], e1[o + 1]);
                            we && t1.push(a), xe.push(a.x, a.y), this.footprintsVertices.emplaceBack(a.x, a.y);
                        }
                        ve.x = Math.min(ve.x, i.x), ve.y = Math.min(ve.y, i.y), be.x = Math.max(be.x, n.x), be.y = Math.max(be.y, n.y), we && this.groundEffect.addData(t1, [
                            i,
                            n
                        ], S);
                    }
                    const Ee = this.groundEffect.vertexArray.length - Ae;
                    this.groundEffect.groundRadiusArray.reserveForAdditional(Ee);
                    for(let e1 = 0; e1 < Ee; e1++)this.groundEffect.groundRadiusArray.emplaceBack(I);
                    (Q.x < 0 || ee.x > Sr || Q.y < 0 || ee.y > Sr) && this.featuresOnBorder.push({
                        featureId: u.id,
                        footprintIndex: this.footprints.length
                    });
                    {
                        const t1 = wl(xe, null, 2);
                        this.footprintsIndices.resize(this.footprintsIndices.length + t1.length), this.footprintsIndices.uint16.set(t1, ge), this.buildingIds.add(e1 ?? u.id), this.footprintsMin.x = Math.min(this.footprintsMin.x, ve.x), this.footprintsMin.y = Math.min(this.footprintsMin.y, ve.y), this.footprintsMax.x = Math.max(this.footprintsMax.x, be.x), this.footprintsMax.y = Math.max(this.footprintsMax.y, be.y);
                        const i = {
                            footprintVertexOffset: ye,
                            footprintVertexLength: this.footprintsVertices.length - ye,
                            footprintIndexOffset: ge,
                            footprintIndexLength: this.footprintsIndices.length - ge,
                            min: ve,
                            max: be,
                            hiddenFlags: 0,
                            indicesOffset: fe,
                            indicesLength: me,
                            bloomIndicesOffset: ce,
                            bloomIndicesLength: ue,
                            groundEffectVertexOffset: Ae,
                            groundEffectVertexLength: Ee,
                            hasFauxFacade: k,
                            height: pe,
                            promoteId: h,
                            feature: g,
                            parts: se,
                            buildingBloom: le
                        }, n = this.footprints.length;
                        void 0 !== u.id && this.featureFootprintLookup.set(u.id, n), p(e1, n), this.footprints.push(i);
                    }
                    this.programConfigurations.populatePaintArrays(re.layoutVertexArray.length, u, _, {}, t1.availableImages, i, t1.brightness), this.groundEffect.addPaintPropertiesData(u, _, {}, t1.availableImages, i, t1.brightness), t1.featureIndex.insert(u, y, _, m, this.index, he);
                }
                h.forEach(({ buildingId: e1, footprintIndex: t1 })=>{
                    d.has(e1) && (this.footprints[t1].hiddenFlags |= 4);
                });
                const g = new Set;
                this.buildingIds.forEach((e1, t1, i)=>{
                    d.has(e1) || g.add(e1);
                }), this.buildingIds = g, this.groundEffect.prepareBorderSegments();
            }
            update(e1, t1, i, n, r, o, a) {
                this.programConfigurations.updatePaintArrays(e1, t1, r, i, n, o, a), this.groundEffect.update(e1, t1, r, i, n, o, a), this.evaluate(this.layers[0], e1, o), this.colorBufferUploaded = !1;
            }
            updateExpressions(e1) {
                this.programConfigurations.updateExpressions(e1), this.groundEffect.programConfigurations.updateExpressions(e1);
            }
            isEmpty() {
                return 0 === this.buildingWithoutFacade.layoutVertexArray.length && 0 === this.buildingWithFacade.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload || this.groundEffect.programConfigurations.needsUpload;
            }
            upload(e1) {
                const t1 = (t1)=>{
                    t1.layoutVertexBuffer = e1.createVertexBuffer(t1.layoutVertexArray, Hx.members), t1.layoutNormalBuffer = e1.createVertexBuffer(t1.layoutNormalArray, Zx.members), t1.layoutCentroidBuffer = e1.createVertexBuffer(t1.layoutCentroidArray, Wx.members), t1.layoutFloodLightDataBuffer = e1.createVertexBuffer(t1.layoutFloodLightDataArray, Qx.members), t1.layoutFacadeDataArray && t1.layoutFacadeDataArray.length && (t1.layoutFacadeDataBuffer = e1.createVertexBuffer(t1.layoutFacadeDataArray, Yx.members)), t1.layoutFacadeVerticalRangeArray && t1.layoutFacadeVerticalRangeArray.length && (t1.layoutFacadeVerticalRangeBuffer = e1.createVertexBuffer(t1.layoutFacadeVerticalRangeArray, Jx.members)), t1.entranceBloom.layoutVertexArray.length && (t1.entranceBloom.layoutVertexBuffer = e1.createVertexBuffer(t1.entranceBloom.layoutVertexArray, $x.members), t1.entranceBloom.layoutAttenuationBuffer = e1.createVertexBuffer(t1.entranceBloom.layoutAttenuationArray, Kx.members)), this.uploadUpdatedColorBuffer(e1), this.uploadUpdatedIndexBuffer(e1);
                };
                this.uploaded || (t1(this.buildingWithoutFacade), t1(this.buildingWithFacade), this.groundEffect.upload(e1)), this.groundEffect.uploadPaintProperties(e1), this.programConfigurations.upload(e1), this.uploaded = !0;
            }
            destroy() {
                const e1 = (e1)=>{
                    e1.layoutVertexBuffer && (e1.layoutVertexBuffer.destroy(), e1.layoutNormalBuffer.destroy(), e1.layoutColorBuffer.destroy(), e1.segmentsBucket.destroy(), e1.indexBuffer && e1.indexBuffer.destroy(), e1.entranceBloom.layoutVertexBuffer && (e1.entranceBloom.layoutVertexBuffer.destroy(), e1.entranceBloom.layoutColorBuffer.destroy(), e1.entranceBloom.layoutAttenuationBuffer.destroy(), e1.entranceBloom.indexBuffer.destroy(), e1.entranceBloom.segmentsBucket.destroy()));
                };
                e1(this.buildingWithoutFacade), e1(this.buildingWithFacade), this.groundEffect.destroy(), this.programConfigurations.destroy();
            }
            updateFootprintHiddenFlags(e1, t1, i = !0) {
                let n = !1;
                const r = i ? t1 : 0, o = 0 | (i ? -1 : ~t1);
                0 === this.groundEffect.hiddenByLandmarkVertexArray.length && this.groundEffect.hiddenByLandmarkVertexArray.resize(this.groundEffect.vertexArray.length);
                for (const t1 of e1){
                    const e1 = this.footprints[t1], i = e1.hiddenFlags & o | r;
                    e1.hiddenFlags !== i && (e1.hiddenFlags = i, n = !0, this.groundEffect.updateHiddenByLandmarkRange(e1.groundEffectVertexOffset, e1.groundEffectVertexLength, 0 !== e1.hiddenFlags));
                }
                return n && (this.indexArrayForConflationUploaded = !1), n;
            }
            uploadUpdatedIndexBuffer(e1) {
                if (this.groundEffect.uploadHiddenByLandmark(e1), this.indexArrayForConflationUploaded) return;
                const t1 = (e1)=>{
                    0 !== e1.indexArray.length && (e1.indexArrayForConflation.resize(e1.indexArray.length), e1.indexArrayForConflation.uint16.set(e1.indexArray.uint16), e1.entranceBloom.indexArrayForConflation.resize(e1.entranceBloom.indexArray.length), e1.entranceBloom.indexArrayForConflation.uint16.set(e1.entranceBloom.indexArray.uint16));
                };
                t1(this.buildingWithoutFacade), t1(this.buildingWithFacade);
                for (const e1 of this.footprints){
                    const t1 = e1.hasFauxFacade ? this.buildingWithFacade : this.buildingWithoutFacade, i = e1.indicesOffset + e1.indicesLength;
                    if (0 !== e1.hiddenFlags) {
                        for(let n = e1.indicesOffset; n < i; n++)t1.indexArrayForConflation.uint16[3 * n + 0] = 0, t1.indexArrayForConflation.uint16[3 * n + 1] = 0, t1.indexArrayForConflation.uint16[3 * n + 2] = 0;
                        const n = e1.bloomIndicesOffset + e1.bloomIndicesLength;
                        for(let i = e1.bloomIndicesOffset; i < n; i++)t1.entranceBloom.indexArrayForConflation.uint16[3 * i + 0] = 0, t1.entranceBloom.indexArrayForConflation.uint16[3 * i + 1] = 0, t1.entranceBloom.indexArrayForConflation.uint16[3 * i + 2] = 0;
                    }
                }
                const i = (t1)=>{
                    0 !== t1.indexArray.length && (t1.indexBuffer ? t1.indexBuffer.updateData(t1.indexArrayForConflation) : t1.indexBuffer = e1.createIndexBuffer(t1.indexArrayForConflation, !0), t1.entranceBloom.indexBuffer ? t1.entranceBloom.indexBuffer.updateData(t1.entranceBloom.indexArrayForConflation) : t1.entranceBloom.indexBuffer = e1.createIndexBuffer(t1.entranceBloom.indexArrayForConflation, !0));
                };
                i(this.buildingWithoutFacade), i(this.buildingWithFacade), this.indexArrayForConflationUploaded = !0;
            }
            uploadUpdatedColorBuffer(e1) {
                const t1 = (t1)=>{
                    t1.layoutColorBuffer ? t1.layoutColorBuffer.updateData(t1.layoutColorArray) : t1.layoutColorBuffer = e1.createVertexBuffer(t1.layoutColorArray, qx.members, !0), t1.layoutFacadePaintArray && (t1.layoutFacadePaintBuffer ? t1.layoutFacadePaintBuffer.updateData(t1.layoutFacadePaintArray) : t1.layoutFacadePaintBuffer = e1.createVertexBuffer(t1.layoutFacadePaintArray, Xx.members, !0)), t1.entranceBloom.layoutColorBuffer ? t1.entranceBloom.layoutColorBuffer.updateData(t1.entranceBloom.layoutColorArray) : t1.entranceBloom.layoutColorBuffer = e1.createVertexBuffer(t1.entranceBloom.layoutColorArray, qx.members, !0);
                };
                t1(this.buildingWithoutFacade), t1(this.buildingWithFacade), this.colorBufferUploaded = !0;
            }
            evaluate(e1, t1, i) {
                const n = Object.keys(t1), r = 0 !== n.length && !i, o = e1.paint.get("building-ambient-occlusion-intensity"), a = (i)=>{
                    if (4 & i.hiddenFlags) return;
                    const n = t1[i.promoteId], r = i.feature;
                    r.properties["building-part"] = "roof";
                    const a = e1.paint.get("building-color").evaluate(r, n, this.canonical).toPremultipliedRenderColor(this.lut), s = e1.paint.get("building-emissive-strength").evaluate(r, n, this.canonical);
                    r.properties["building-part"] = "wall";
                    const l = e1.paint.get("building-color").evaluate(r, n, this.canonical).toPremultipliedRenderColor(this.lut), c = e1.paint.get("building-emissive-strength").evaluate(r, n, this.canonical);
                    r.properties["building-part"] = "window";
                    const u = e1.paint.get("building-color").evaluate(r, n, this.canonical).toPremultipliedRenderColor(this.lut), h = e1.paint.get("building-emissive-strength").evaluate(r, n, this.canonical);
                    r.properties["building-part"] = "door";
                    const d = e1.paint.get("building-color").evaluate(r, n, this.canonical).toPremultipliedRenderColor(this.lut), f = e1.paint.get("building-emissive-strength").evaluate(r, n, this.canonical), p = i.hasFauxFacade ? this.buildingWithFacade : this.buildingWithoutFacade;
                    for (const e1 of i.parts){
                        let t1, n = a;
                        1 === e1.part ? (n = a, t1 = s) : 0 === e1.part ? (n = l, t1 = c) : 2 === e1.part ? (n = u, t1 = h) : 3 === e1.part && (n = d, t1 = f), t1 = tt(t1, 0, 1);
                        for(let r = 0; r < e1.vertexLength; r++){
                            const a = e1.vertexOffset + r, s = 1 + (p.layoutAOArray.uint8[a] / 255 - 1) * o;
                            p.layoutColorArray.emplace(a, n.r * s * 255 << 8 | n.g * s * 255, n.b * s * 255 << 8 | 255 * t1), i.hasFauxFacade && p.layoutFacadePaintArray.emplace(a, 255 * u.r << 8 | 255 * u.g, 255 * u.b << 8 | 255 * h);
                        }
                    }
                    const _ = i.buildingBloom;
                    if (_) for(let e1 = 0; e1 < _.vertexLength; e1++)p.entranceBloom.layoutColorArray.emplace(_.vertexOffset + e1, 255 * d.r << 8 | 255 * d.g, 255 * d.b << 8 | 51 * f);
                };
                if (r) for (const e1 of n){
                    const t1 = this.featureFootprintLookup.get(Number(e1));
                    void 0 !== t1 && a(this.footprints[t1]);
                }
                else for (const e1 of this.footprints)a(e1);
            }
            needsEvaluation() {
                return !this.colorBufferUploaded;
            }
            updateReplacement(e1, t1, i) {
                if (t1.updateTime === this.replacementUpdateTime) return;
                this.replacementUpdateTime = t1.updateTime;
                const n = t1.getReplacementRegionsForTile(e1.toUnwrapped());
                if (Qp(this.activeReplacements, n)) return;
                this.activeReplacements = n;
                for (const e1 of this.footprints)e1.hiddenFlags &= -2;
                const r = [];
                for (const t1 of this.activeReplacements){
                    if (t1.order < i) continue;
                    const n = Math.max(1, Math.pow(2, t1.footprintTileId.canonical.z - e1.canonical.z));
                    for (const i of this.footprints)i.min.x > t1.max.x || i.max.x < t1.min.x || i.min.y > t1.max.y || i.max.y < t1.min.y || (r.length = 0, db(this.footprintsVertices, i.footprintVertexOffset, i.footprintVertexLength, t1.footprintTileId.canonical, e1.canonical, r), s_(t1.footprint, r, this.footprintsIndices.uint16, i.footprintIndexOffset, i.footprintIndexLength, 0, -n) && (i.hiddenFlags |= 1));
                }
                0 === this.groundEffect.hiddenByLandmarkVertexArray.length && this.groundEffect.hiddenByLandmarkVertexArray.resize(this.groundEffect.vertexArray.length);
                for (const e1 of this.footprints)this.groundEffect.updateHiddenByLandmarkRange(e1.groundEffectVertexOffset, e1.groundEffectVertexLength, 0 !== e1.hiddenFlags);
                this.indexArrayForConflationUploaded = !1;
            }
            getFootprint(e1) {
                if (void 0 !== e1.id) {
                    const t1 = this.featureFootprintLookup.get(e1.id);
                    return this.footprints[t1];
                }
                return null;
            }
            getHeightAtTileCoord(e1, t1) {
                let i = Number.NEGATIVE_INFINITY, n = !0;
                const r = 4 * (e1 + Sr) * Sr + (t1 + Sr);
                if (Object.hasOwn(this.footprintLookup, r)) {
                    const e1 = this.footprintLookup[r];
                    return e1 ? {
                        height: e1.height,
                        hidden: 0 !== e1.hiddenFlags
                    } : void 0;
                }
                const o = new Re(e1, t1);
                for (const a of this.footprints)e1 > a.max.x || a.min.x > e1 || t1 > a.max.y || a.min.y > t1 || a.height <= i || hb(o, this.footprintsVertices.float32.subarray(2 * a.footprintVertexOffset, 2 * (a.footprintVertexOffset + a.footprintVertexLength)), this.footprintsIndices.uint16.subarray(a.footprintIndexOffset, a.footprintIndexOffset + a.footprintIndexLength)) && (i = a.height, this.footprintLookup[r] = a, n = 0 !== a.hiddenFlags);
                if (i !== Number.NEGATIVE_INFINITY) return {
                    height: i,
                    hidden: n
                };
                this.footprintLookup[r] = void 0;
            }
        }
        function hb(e1, t1, i) {
            for(let n = 0; n < i.length; n += 3){
                const r = i[n], o = i[n + 1], a = i[n + 2], s = t1[2 * r + 0], l = t1[2 * r + 1], c = t1[2 * o + 0], u = t1[2 * o + 1], h = t1[2 * a + 0], d = t1[2 * a + 1], f = (s - h) * (e1.y - d) - (l - d) * (e1.x - h), p = (c - s) * (e1.y - l) - (u - l) * (e1.x - s);
                if (f < 0 != p < 0 && 0 !== f && 0 !== p) continue;
                const _ = (h - c) * (e1.y - u) - (d - u) * (e1.x - c);
                if (0 === _ || _ < 0 == f + p <= 0) return !0;
            }
            return !1;
        }
        function db(e1, t1, i, n, r, o) {
            const a = Math.pow(2, n.z - r.z);
            for(let s = 0; s < i; s++){
                let i = e1.float32[2 * (s + t1) + 0], l = e1.float32[2 * (s + t1) + 1];
                i = (i + r.x * Sr) * a - n.x * Sr, l = (l + r.y * Sr) * a - n.y * Sr, o.push(new Re(i, l));
            }
        }
        Ya(ub, "BuildingBucket", {
            omit: [
                "layers"
            ]
        }), Ya(cb, "BuildingGeometry"), Ya(lb, "BuildingBloomGeometry");
        class fb {
            constructor(e1 = 0, t1 = []){
                this.frcMask = e1, this.rings = t1;
            }
            hasGeometry() {
                return this.rings.length > 0 && this.rings[0].length > 0;
            }
        }
        async function pb() {}
        function _b(e1, t1, i) {
            const n = t1.paint.get(e1).value;
            return "constant" === n.kind ? n.value : i.getMaxValue(e1);
        }
        function mb(e1) {
            return Math.sqrt(e1[0] * e1[0] + e1[1] * e1[1]);
        }
        function gb(e1, t1, i, n, r) {
            if (!t1[0] && !t1[1]) return e1;
            const o = Re.convert(t1)._mult(r);
            "viewport" === i && o._rotate(-n);
            const a = [];
            for(let t1 = 0; t1 < e1.length; t1++)a.push(e1[t1].sub(o));
            return a;
        }
        function yb(e1, t1, i, n) {
            const r = Re.convert(e1)._mult(n);
            return "viewport" === t1 && r._rotate(-i), r;
        }
        Ya(fb, "FrcCoveragePolygon");
        const xb = c(), vb = (e1)=>{
            const t1 = [];
            return "map" === e1.paint.get("circle-pitch-alignment") && t1.push("PITCH_WITH_MAP"), "map" === e1.paint.get("circle-pitch-scale") && t1.push("SCALE_WITH_MAP"), t1;
        };
        function bb(e1, t1, i, n, r, o, a, s, l) {
            if (o && e1.queryGeometry.isAboveHorizon) return !1;
            o && (l *= e1.pixelToTileUnitsFactor);
            const c = e1.tileID.canonical, u = i.projection.upVectorScale(c, i.center.lat, i.worldSize).metersToTile;
            for (const h of t1)for (const t1 of h){
                const h = t1.add(s), d = r && i.elevation ? i.elevation.exaggeration() * r.getElevationAt(h.x, h.y, !0) : 0, f = i.projection.projectTilePoint(h.x, h.y, c);
                if (d > 0) {
                    const e1 = i.projection.upVector(c, h.x, h.y);
                    f.x += e1[0] * u * d, f.y += e1[1] * u * d, f.z += e1[2] * u * d;
                }
                const p = o ? h : wb(f.x, f.y, f.z, n), _ = o ? e1.tilespaceRays.map((e1)=>Ib(e1, d)) : e1.queryGeometry.screenGeometry, m = se([], [
                    f.x,
                    f.y,
                    f.z,
                    1
                ], n);
                if (!a && o ? l *= m[3] / i.cameraToCenterDistance : a && !o && (l *= i.cameraToCenterDistance / m[3]), o) {
                    const e1 = fr((t1.y / Sr + c.y) / (1 << c.z));
                    l /= i.projection.pixelsPerMeter(e1, 1) / cc(1, e1);
                }
                if (Qh(_, p, l)) return !0;
            }
            return !1;
        }
        function wb(e1, t1, i, n) {
            const r = se([], [
                e1,
                t1,
                i,
                1
            ], n);
            return new Re(r[0] / r[3], r[1] / r[3]);
        }
        const Ab = D(0, 0, 0), Eb = D(0, 0, 1);
        function Ib(e1, t1) {
            const i = R();
            return Ab[2] = t1, e1.intersectsPlane(Ab, Eb, i), new Re(i[0], i[1]);
        }
        class Mb extends Vd {
        }
        let Sb, Tb;
        Ya(Mb, "HeatmapBucket", {
            omit: [
                "layers"
            ]
        });
        const zb = (e1, t1, i, n)=>hn(t1, i, "log" === n ? (Math.pow(10, e1) - 1) / 9 : e1);
        function Rb(e1) {
            const { expression: t1, evaluationKey: i, resolution: n = 256, clips: r, scale: o = "linear", lut: a = null } = e1, s = r ? r.length : 1, l = e1.image || new Id({
                width: n,
                height: s
            }), c = {}, u = (e1, n, r)=>{
                c[i] = r;
                const o = t1.evaluate(c), s = o?.toNonPremultipliedRenderColor(a) ?? null;
                s && (l.data[e1 + n + 0] = Math.floor(255 * s.r), l.data[e1 + n + 1] = Math.floor(255 * s.g), l.data[e1 + n + 2] = Math.floor(255 * s.b), l.data[e1 + n + 3] = Math.floor(255 * s.a));
            };
            for(let e1 = 0, t1 = 0; e1 < s; ++e1, t1 += 4 * n){
                const i = r?.[e1].start ?? 0, a = r?.[e1].end ?? 1;
                for(let e1 = 0, r = 0; e1 < n; e1++, r += 4)u(t1, r, zb(e1 / (n - 1), i, a, o));
            }
            return l;
        }
        let Pb, Db, Fb, Cb, Ob, Lb, Bb, Vb, Nb, kb, Ub, jb;
        class Gb {
            constructor(e1){
                this.zoom = e1.zoom, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.hasPattern = !1, this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.footprints = [], this.worldview = e1.worldview, this.hasAppearances = null;
            }
            updateFootprints(e1, t1) {
                for (const i of this.footprints)t1.push({
                    footprint: i,
                    id: e1
                });
            }
            updateAppearances(e1, t1, i, n) {
                return {
                    hasLayoutChanges: !1,
                    hasUboChanges: !1
                };
            }
            populate(e1, t1, i, n) {
                const r = [], o = new Ls(this.zoom, {
                    worldview: this.worldview,
                    activeFloors: t1.activeFloors
                });
                for (const { feature: t1, id: a, index: s, sourceLayerIndex: l } of e1){
                    const e1 = this.layers[0]._featureFilter.needGeometry, c = Mc(t1, e1);
                    if (!this.layers[0]._featureFilter.filter(o, c, i)) continue;
                    const u = {
                        id: a,
                        properties: t1.properties,
                        type: t1.type,
                        sourceLayerIndex: l,
                        index: s,
                        geometry: Ic(t1, c, e1, i, n),
                        patterns: {}
                    };
                    r.push(u);
                }
                for (const n of r){
                    const { geometry: r, index: o, sourceLayerIndex: a } = n;
                    this.addFeature(n, r, o, i, {}, t1.availableImages, t1.brightness), t1.featureIndex.insert(e1[o].feature, r, o, a, this.index);
                }
            }
            isEmpty() {
                return 0 === this.footprints.length;
            }
            uploadPending() {
                return !1;
            }
            upload(e1) {}
            update(e1, t1, i, n, r, o, a) {}
            destroy() {}
            addFeature(e1, t1, i, n, r, o = [], a) {
                for (const e1 of Ve(t1, 2)){
                    const t1 = [], i = [], n = [], r = new Re(1 / 0, 1 / 0), o = new Re(-1 / 0, -1 / 0);
                    for (const a of e1)if (0 !== a.length) {
                        a !== e1[0] && n.push(i.length / 2);
                        for(let e1 = 0; e1 < a.length; e1++)i.push(a[e1].x), i.push(a[e1].y), t1.push(a[e1]), r.x = Math.min(r.x, a[e1].x), r.y = Math.min(r.y, a[e1].y), o.x = Math.max(o.x, a[e1].x), o.y = Math.max(o.y, a[e1].y);
                    }
                    const a = new Uint32Array(wl(i, n)), s = new Wy(t1, a, 8, 256);
                    this.footprints.push({
                        vertices: new Float64Array(i),
                        indices: a,
                        grid: s,
                        min: r,
                        max: o
                    });
                }
            }
        }
        function Hb(e1, t1) {
            return e1.x * t1.x + e1.y * t1.y;
        }
        function $b(e1, t1) {
            if (1 === e1.length) {
                let i = 0;
                const n = t1[i++];
                let r;
                for(; !r || n.equals(r);)if (r = t1[i++], !r) return 1 / 0;
                for(; i < t1.length; i++){
                    const o = t1[i], a = e1[0], s = r.sub(n), l = o.sub(n), c = a.sub(n), u = Hb(s, s), h = Hb(s, l), d = Hb(l, l), f = Hb(c, s), p = Hb(c, l), _ = u * d - h * h, m = (d * f - h * p) / _, g = (u * p - h * f) / _, y = n.z * (1 - m - g) + r.z * m + o.z * g;
                    if (isFinite(y)) return y;
                }
                return 1 / 0;
            }
            {
                let e1 = 1 / 0;
                for (const i of t1)e1 = Math.min(e1, i.z);
                return e1;
            }
        }
        function Zb(e1, t1, i) {
            let n = 1 / 0;
            ed(i, t1) && (n = $b(i, t1[0]));
            for(let r = 0; r < t1.length; r++){
                const o = t1[r], a = e1[r];
                for(let e1 = 0; e1 < o.length - 1; e1++){
                    const t1 = o[e1], r = [
                        t1,
                        o[e1 + 1],
                        a[e1 + 1],
                        a[e1],
                        t1
                    ];
                    Kh(i, r) && (n = Math.min(n, $b(i, r)));
                }
            }
            return n !== 1 / 0 && n;
        }
        function Wb(e1, t1, i, n, r, o, a, s, l, c, u) {
            return "globe" === e1.projection.name ? function(e1, t1, i, n, r, o, a, s, l, c, u) {
                const h = [], d = [], f = e1.projection.upVectorScale(u, e1.center.lat, e1.worldSize).metersToTile, p = [
                    0,
                    0,
                    0,
                    1
                ], _ = [
                    0,
                    0,
                    0,
                    1
                ], m = (e1, t1, i, n)=>{
                    e1[0] = t1, e1[1] = i, e1[2] = n, e1[3] = 1;
                }, g = Hv();
                i > 0 && (i += g), n += g;
                for (const g of t1){
                    const t1 = [], y = [];
                    for (const h of g){
                        const d = h.x + r.x, g = h.y + r.y, x = e1.projection.projectTilePoint(d, g, u), v = e1.projection.upVector(u, h.x, h.y);
                        let b = i, w = n;
                        if (a) {
                            const e1 = qb(d, g, i, n, a, s, l, c);
                            b += e1.base, w += e1.top;
                        }
                        0 !== i ? m(p, x.x + v[0] * f * b, x.y + v[1] * f * b, x.z + v[2] * f * b) : m(p, x.x, x.y, x.z), m(_, x.x + v[0] * f * w, x.y + v[1] * f * w, x.z + v[2] * f * w), X(p, p, o), X(_, _, o), t1.push(new pd(p[0], p[1], p[2])), y.push(new pd(_[0], _[1], _[2]));
                    }
                    h.push(t1), d.push(y);
                }
                return [
                    h,
                    d
                ];
            }(e1, t1, i, n, r, o, a, s, l, c, u) : a ? function(e1, t1, i, n, r, o, a, s, l) {
                const c = [], u = [], h = [
                    0,
                    0,
                    0,
                    1
                ];
                for (const d of e1){
                    const e1 = [], f = [];
                    for (const c of d){
                        const u = c.x + n.x, d = c.y + n.y, p = qb(u, d, t1, i, o, a, s, l);
                        h[0] = u, h[1] = d, h[2] = p.base, h[3] = 1, se(h, h, r), h[3] = Math.max(h[3], 1e-5);
                        const _ = new pd(h[0] / h[3], h[1] / h[3], h[2] / h[3]);
                        h[0] = u, h[1] = d, h[2] = p.top, h[3] = 1, se(h, h, r), h[3] = Math.max(h[3], 1e-5);
                        const m = new pd(h[0] / h[3], h[1] / h[3], h[2] / h[3]);
                        e1.push(_), f.push(m);
                    }
                    c.push(e1), u.push(f);
                }
                return [
                    c,
                    u
                ];
            }(t1, i, n, r, o, a, s, l, c) : function(e1, t1, i, n, r) {
                const o = [], a = [], s = r[8] * t1, l = r[9] * t1, c = r[10] * t1, u = r[11] * t1, h = r[8] * i, d = r[9] * i, f = r[10] * i, p = r[11] * i;
                for (const t1 of e1){
                    const e1 = [], i = [];
                    for (const o of t1){
                        const t1 = o.x + n.x, a = o.y + n.y, _ = r[0] * t1 + r[4] * a + r[12], m = r[1] * t1 + r[5] * a + r[13], g = r[2] * t1 + r[6] * a + r[14], y = r[3] * t1 + r[7] * a + r[15], x = _ + s, v = m + l, b = g + c, w = Math.max(y + u, 1e-5), A = _ + h, E = m + d, I = g + f, M = Math.max(y + p, 1e-5);
                        e1.push(new pd(x / w, v / w, b / w)), i.push(new pd(A / M, E / M, I / M));
                    }
                    o.push(e1), a.push(i);
                }
                return [
                    o,
                    a
                ];
            }(t1, i, n, r, o);
        }
        function qb(e1, t1, i, n, r, o, a, s) {
            const l = a * r.getElevationAt(e1, t1, !0, !0), c = 0 !== o[0], u = c ? 0 === o[1] ? a * (o[0] / 7 - 450) : a * function(e1, t1, i) {
                const n = Math.floor(t1[0] / 8), r = Math.floor(t1[1] / 8), o = 10 * (t1[0] - 8 * n), a = 10 * (t1[1] - 8 * r), s = e1.getElevationAt(n, r, !0, !0), l = e1.getMeterToDEM(i), c = Math.floor(.5 * (o * l - 1)), u = Math.floor(.5 * (a * l - 1)), h = e1.tileCoordToPixel(n, r), d = 2 * c + 1, f = 2 * u + 1, p = function(e1, t1, i, n, r) {
                    return [
                        e1.getElevationAtPixel(t1, i, !0),
                        e1.getElevationAtPixel(t1 + r, i, !0),
                        e1.getElevationAtPixel(t1, i + r, !0),
                        e1.getElevationAtPixel(t1 + n, i + r, !0)
                    ];
                }(e1, h.x - c, h.y - u, d, f), _ = Math.abs(p[0] - p[1]), m = Math.abs(p[2] - p[3]), g = Math.abs(p[0] - p[2]) + Math.abs(p[1] - p[3]), y = Math.min(.25, .5 * l * (_ + m) / d), x = Math.min(.25, .5 * l * g / f);
                return s + Math.max(y * o, x * a);
            }(r, o, s) : l;
            return {
                base: l + (0 === i ? -1 : i),
                top: c ? Math.max(u + n, l + i + 2) : l + n
            };
        }
        function Xb(e1, t1, i) {
            return t1 * (Sr / (e1.tileSize * Math.pow(2, i - e1.tileID.overscaledZ)));
        }
        function Yb(e1, t1) {
            return 1 / Xb(e1, 1, t1.tileZoom);
        }
        function Jb(e1, t1, i, n) {
            return e1.translatePosMatrix(n || t1.tileID.projMatrix, t1, i.paint.get("line-translate"), i.paint.get("line-translate-anchor"));
        }
        Ya(Gb, "ClipBucket", {
            omit: [
                "layers"
            ]
        });
        const Kb = (e1)=>{
            const t1 = [];
            e1.paint.get("line-gradient") && t1.push("RENDER_LINE_GRADIENT"), "multiply" === e1.paint.get("line-blend-mode") && t1.push("LINE_BLEND_MULTIPLY"), "additive" === e1.paint.get("line-blend-mode") && t1.push("LINE_BLEND_ADDITIVE");
            const i = e1.paint.get("line-trim-offset");
            0 === i[0] && 0 === i[1] || t1.push("RENDER_LINE_TRIM_OFFSET"), 0 !== e1.paint.get("line-border-width").constantOr(1) && e1.paint.get("line-border-gradient") && t1.push("RENDER_LINE_BORDER_GRADIENT");
            const n = "none" === e1.layout.get("line-join").constantOr("miter"), r = !!e1.paint.get("line-pattern").constantOr(1);
            return n && r && t1.push("LINE_JOIN_NONE"), t1;
        };
        function Qb(e1) {
            const t1 = e1.paint.get("line-dasharray").value;
            return "constant" !== t1.kind || null != t1.value;
        }
        let ew;
        const tw = ()=>ew || (ew = {
                layout: Ub || (Ub = new Zs({
                    "line-cap": new Hs(Ws.layout_line["line-cap"]),
                    "line-join": new Hs(Ws.layout_line["line-join"]),
                    "line-miter-limit": new Gs(Ws.layout_line["line-miter-limit"]),
                    "line-round-limit": new Gs(Ws.layout_line["line-round-limit"]),
                    "line-sort-key": new Hs(Ws.layout_line["line-sort-key"]),
                    "line-z-offset": new Hs(Ws.layout_line["line-z-offset"]),
                    "line-elevation-reference": new Gs(Ws.layout_line["line-elevation-reference"]),
                    "line-cross-slope": new Gs(Ws.layout_line["line-cross-slope"]),
                    visibility: new Gs(Ws.layout_line.visibility),
                    "line-width-unit": new Gs(Ws.layout_line["line-width-unit"]),
                    "line-elevation-ground-scale": new Hs(Ws.layout_line["line-elevation-ground-scale"])
                })),
                paint: jb || (jb = new Zs({
                    "line-opacity": new Hs(Ws.paint_line["line-opacity"]),
                    "line-color": new Hs(Ws.paint_line["line-color"]),
                    "line-translate": new Gs(Ws.paint_line["line-translate"]),
                    "line-translate-anchor": new Gs(Ws.paint_line["line-translate-anchor"]),
                    "line-width": new Hs(Ws.paint_line["line-width"]),
                    "line-gap-width": new Hs(Ws.paint_line["line-gap-width"]),
                    "line-offset": new Hs(Ws.paint_line["line-offset"]),
                    "line-blur": new Hs(Ws.paint_line["line-blur"]),
                    "line-dasharray": new Hs(Ws.paint_line["line-dasharray"]),
                    "line-pattern": new Hs(Ws.paint_line["line-pattern"]),
                    "line-pattern-cross-fade": new Gs(Ws.paint_line["line-pattern-cross-fade"]),
                    "line-gradient": new $s(Ws.paint_line["line-gradient"]),
                    "line-trim-offset": new Gs(Ws.paint_line["line-trim-offset"]),
                    "line-trim-fade-range": new Gs(Ws.paint_line["line-trim-fade-range"]),
                    "line-trim-color": new Gs(Ws.paint_line["line-trim-color"]),
                    "line-emissive-strength": new Hs(Ws.paint_line["line-emissive-strength"]),
                    "line-border-width": new Hs(Ws.paint_line["line-border-width"]),
                    "line-border-color": new Hs(Ws.paint_line["line-border-color"]),
                    "line-border-gradient": new $s(Ws.paint_line["line-border-gradient"]),
                    "line-occlusion-opacity": new Gs(Ws.paint_line["line-occlusion-opacity"]),
                    "line-blend-mode": new Gs(Ws.paint_line["line-blend-mode"]),
                    "line-blend-additive-clamp": new Gs(Ws.paint_line["line-blend-additive-clamp"]),
                    "line-cutout-depth": new Gs(Ws.paint_line["line-cutout-depth"]),
                    "line-color-use-theme": new Hs({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "line-gradient-use-theme": new Hs({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "line-trim-color-use-theme": new Hs({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "line-border-color-use-theme": new Hs({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "line-border-gradient-use-theme": new Hs({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    })
                }))
            }, ew);
        class iw extends Hs {
            possiblyEvaluate(e1, t1) {
                return t1 = new Ls(Math.floor(t1.zoom), {
                    now: t1.now,
                    fadeDuration: t1.fadeDuration,
                    transition: t1.transition,
                    worldview: t1.worldview
                }), super.possiblyEvaluate(e1, t1);
            }
            evaluate(e1, t1, i, n) {
                return t1 = {
                    ...t1,
                    zoom: Math.floor(t1.zoom)
                }, super.evaluate(e1, t1, i, n);
            }
        }
        let nw, rw, ow, aw;
        function sw(e1, t1) {
            return t1 > 0 ? t1 + 2 * e1 : e1;
        }
        function lw(e1, t1) {
            return t1.replace(/{([^{}]+)}/g, (t1, i)=>i in e1 ? String(e1[i]) : "");
        }
        class cw {
            constructor(e1){
                this.type = e1.property.overrides ? e1.property.overrides.runtimeType : bn, this.defaultValue = e1;
            }
            evaluate(e1) {
                if (e1.formattedSection) {
                    const t1 = this.defaultValue.property.overrides;
                    if (t1 && t1.hasOverride(e1.formattedSection)) return t1.getOverride(e1.formattedSection);
                }
                return e1.feature && e1.featureState ? this.defaultValue.evaluate(e1.feature, e1.featureState) : this.defaultValue.property.specification.default;
            }
            eachChild(e1) {
                this.defaultValue.isConstant() || e1(this.defaultValue.value._styleExpression.expression);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return null;
            }
        }
        Ya(cw, "FormatSectionOverride", {
            omit: [
                "defaultValue"
            ]
        });
        const uw = {};
        function hw(e1) {
            return "constant" !== e1.value.kind && e1.value.isStateDependent;
        }
        const dw = ()=>aw || (aw = {
                layout: rw || (rw = new Zs({
                    "symbol-placement": new Gs(Ws.layout_symbol["symbol-placement"]),
                    "symbol-spacing": new Gs(Ws.layout_symbol["symbol-spacing"]),
                    "symbol-avoid-edges": new Gs(Ws.layout_symbol["symbol-avoid-edges"]),
                    "symbol-sort-key": new Hs(Ws.layout_symbol["symbol-sort-key"]),
                    "symbol-z-order": new Gs(Ws.layout_symbol["symbol-z-order"]),
                    "symbol-z-elevate": new Gs(Ws.layout_symbol["symbol-z-elevate"]),
                    "symbol-elevation-reference": new Gs(Ws.layout_symbol["symbol-elevation-reference"]),
                    "icon-allow-overlap": new Gs(Ws.layout_symbol["icon-allow-overlap"]),
                    "icon-ignore-placement": new Gs(Ws.layout_symbol["icon-ignore-placement"]),
                    "icon-optional": new Gs(Ws.layout_symbol["icon-optional"]),
                    "icon-rotation-alignment": new Gs(Ws.layout_symbol["icon-rotation-alignment"]),
                    "icon-size": new Hs(Ws.layout_symbol["icon-size"]),
                    "icon-size-scale-range": new Gs(Ws.layout_symbol["icon-size-scale-range"]),
                    "icon-text-fit": new Hs(Ws.layout_symbol["icon-text-fit"]),
                    "icon-text-fit-padding": new Hs(Ws.layout_symbol["icon-text-fit-padding"]),
                    "icon-image": new Hs(Ws.layout_symbol["icon-image"]),
                    "icon-image-use-theme": new Gs({
                        type: "string",
                        default: "default",
                        "property-type": "data-constant"
                    }),
                    "icon-rotate": new Hs(Ws.layout_symbol["icon-rotate"]),
                    "icon-padding": new Gs(Ws.layout_symbol["icon-padding"]),
                    "icon-keep-upright": new Gs(Ws.layout_symbol["icon-keep-upright"]),
                    "icon-offset": new Hs(Ws.layout_symbol["icon-offset"]),
                    "icon-anchor": new Hs(Ws.layout_symbol["icon-anchor"]),
                    "icon-pitch-alignment": new Gs(Ws.layout_symbol["icon-pitch-alignment"]),
                    "text-pitch-alignment": new Gs(Ws.layout_symbol["text-pitch-alignment"]),
                    "text-rotation-alignment": new Gs(Ws.layout_symbol["text-rotation-alignment"]),
                    "text-field": new Hs(Ws.layout_symbol["text-field"]),
                    "text-font": new Hs(Ws.layout_symbol["text-font"]),
                    "text-size": new Hs(Ws.layout_symbol["text-size"]),
                    "text-size-scale-range": new Gs(Ws.layout_symbol["text-size-scale-range"]),
                    "text-max-width": new Hs(Ws.layout_symbol["text-max-width"]),
                    "text-line-height": new Hs(Ws.layout_symbol["text-line-height"]),
                    "text-letter-spacing": new Hs(Ws.layout_symbol["text-letter-spacing"]),
                    "text-justify": new Hs(Ws.layout_symbol["text-justify"]),
                    "text-radial-offset": new Hs(Ws.layout_symbol["text-radial-offset"]),
                    "text-variable-anchor": new Gs(Ws.layout_symbol["text-variable-anchor"]),
                    "text-anchor": new Hs(Ws.layout_symbol["text-anchor"]),
                    "text-max-angle": new Gs(Ws.layout_symbol["text-max-angle"]),
                    "text-writing-mode": new Gs(Ws.layout_symbol["text-writing-mode"]),
                    "text-rotate": new Hs(Ws.layout_symbol["text-rotate"]),
                    "text-padding": new Gs(Ws.layout_symbol["text-padding"]),
                    "text-keep-upright": new Gs(Ws.layout_symbol["text-keep-upright"]),
                    "text-transform": new Hs(Ws.layout_symbol["text-transform"]),
                    "text-offset": new Hs(Ws.layout_symbol["text-offset"]),
                    "text-allow-overlap": new Gs(Ws.layout_symbol["text-allow-overlap"]),
                    "text-ignore-placement": new Gs(Ws.layout_symbol["text-ignore-placement"]),
                    "text-optional": new Gs(Ws.layout_symbol["text-optional"]),
                    visibility: new Gs(Ws.layout_symbol.visibility)
                })),
                paint: ow || (ow = new Zs({
                    "icon-opacity": new Hs(Ws.paint_symbol["icon-opacity"]),
                    "icon-occlusion-opacity": new Hs(Ws.paint_symbol["icon-occlusion-opacity"]),
                    "icon-emissive-strength": new Hs(Ws.paint_symbol["icon-emissive-strength"]),
                    "text-emissive-strength": new Hs(Ws.paint_symbol["text-emissive-strength"]),
                    "icon-color": new Hs(Ws.paint_symbol["icon-color"]),
                    "icon-halo-color": new Hs(Ws.paint_symbol["icon-halo-color"]),
                    "icon-halo-width": new Hs(Ws.paint_symbol["icon-halo-width"]),
                    "icon-halo-blur": new Hs(Ws.paint_symbol["icon-halo-blur"]),
                    "icon-translate": new Gs(Ws.paint_symbol["icon-translate"]),
                    "icon-translate-anchor": new Gs(Ws.paint_symbol["icon-translate-anchor"]),
                    "icon-image-cross-fade": new Gs(Ws.paint_symbol["icon-image-cross-fade"]),
                    "text-opacity": new Hs(Ws.paint_symbol["text-opacity"]),
                    "text-occlusion-opacity": new Hs(Ws.paint_symbol["text-occlusion-opacity"]),
                    "text-color": new Hs(Ws.paint_symbol["text-color"], {
                        runtimeType: In,
                        getOverride: (e1)=>e1.textColor,
                        hasOverride: (e1)=>!!e1.textColor
                    }),
                    "text-halo-color": new Hs(Ws.paint_symbol["text-halo-color"]),
                    "text-halo-width": new Hs(Ws.paint_symbol["text-halo-width"]),
                    "text-halo-blur": new Hs(Ws.paint_symbol["text-halo-blur"]),
                    "text-translate": new Gs(Ws.paint_symbol["text-translate"]),
                    "text-translate-anchor": new Gs(Ws.paint_symbol["text-translate-anchor"]),
                    "icon-color-saturation": new Gs(Ws.paint_symbol["icon-color-saturation"]),
                    "icon-color-contrast": new Gs(Ws.paint_symbol["icon-color-contrast"]),
                    "icon-color-brightness-min": new Gs(Ws.paint_symbol["icon-color-brightness-min"]),
                    "icon-color-brightness-max": new Gs(Ws.paint_symbol["icon-color-brightness-max"]),
                    "symbol-z-offset": new Hs(Ws.paint_symbol["symbol-z-offset"]),
                    "placement-priority": new Hs(Ws.paint_symbol["placement-priority"]),
                    "placement-group": new Hs(Ws.paint_symbol["placement-group"]),
                    "icon-color-use-theme": new Hs({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "icon-halo-color-use-theme": new Hs({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "text-color-use-theme": new Hs({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "text-halo-color-use-theme": new Hs({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    })
                }))
            }, aw);
        class fw extends vl {
            constructor(e1, t1, i, n){
                super(e1, dw(), t1, i, n, e1.layout ? e1.layout["icon-image-use-theme"] : null), this._colorAdjustmentMatrix = d([]), this.hasOcclusionOpacityProperties = void 0 !== e1.paint && ("icon-occlusion-opacity" in e1.paint || "text-occlusion-opacity" in e1.paint), this._overridesTextField = null;
            }
            _handleSpecialPaintPropertyUpdate(e1) {
                "icon-occlusion-opacity" !== e1 && "text-occlusion-opacity" !== e1 || (this.hasOcclusionOpacityProperties = !0);
            }
            _finalizeEvaluated(e1, t1) {
                this.appearances && this.appearances.forEach((i)=>{
                    i.recalculate(e1, t1, this.iconImageUseTheme);
                }), 0 !== this.appearances.length && delete this.layout._values["text-variable-anchor"], "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = this.layout.get("text-rotation-alignment")), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment"));
                const i = this.layout.get("text-writing-mode");
                if (i) {
                    const e1 = [];
                    for (const t1 of i)e1.includes(t1) || e1.push(t1);
                    this.layout._values["text-writing-mode"] = e1;
                } else this.layout._values["text-writing-mode"] = "point" === this.layout.get("symbol-placement") ? [
                    "horizontal"
                ] : [
                    "horizontal",
                    "vertical"
                ];
                this._setPaintOverrides();
            }
            getColorAdjustmentMatrix(e1, t1, i, n) {
                return this._saturation === e1 && this._contrast === t1 && this._brightnessMin === i && this._brightnessMax === n || (this._colorAdjustmentMatrix = function(e1, t1, i, n) {
                    e1 = St(e1), t1 = Mt(t1);
                    const r = c(), o = e1 / 3, a = 1 - 2 * o, s = Float64Array.of(a, o, o, 0, o, a, o, 0, o, o, a, 0, 0, 0, 0, 1), l = .5 - .5 * t1, u = Float64Array.of(t1, 0, 0, 0, 0, t1, 0, 0, 0, 0, t1, 0, l, l, l, 1), h = n - i;
                    return _(r, Float64Array.of(h, 0, 0, 0, 0, h, 0, 0, 0, 0, h, 0, i, i, i, 1), u), _(r, r, s), r;
                }(e1, t1, i, n), this._saturation = e1, this._contrast = t1, this._brightnessMin = i, this._brightnessMax = n), this._colorAdjustmentMatrix;
            }
            getValueAndResolveTokens(e1, t1, i, n) {
                const r = this.layout.get(e1).evaluate(t1, {}, i, n), o = this.getLayoutPropertyValue(e1);
                return o.isDataDriven() || Ua(o.value) || !r ? r : lw(t1.properties, r);
            }
            getAppearanceValueAndResolveTokens(e1, t1, i, n, r) {
                const o = e1.getLayoutProperty(t1);
                if (!o) return;
                const a = o.evaluate(i, {}, n, r), s = e1.getUnevaluatedLayoutProperties()._values[t1].value;
                return s.isDataDriven() || Ua(s.value) || !a || "string" != typeof a ? a : lw(i.properties, a);
            }
            createBucket(e1) {
                return new Zm(e1);
            }
            placeSymbols(e1, t1, i, n, r, o) {
                const { globalPlacement: a, transform: s, buildingIndex: l, fogState: c, groupOrders: u, replacementSource: h, mercatorCenter: d, fadeDuration: f } = e1, p = this.runtimeLayerUID, _ = hw(this.paint.get("placement-group")) || hw(this.paint.get("placement-priority")) ? n._state.getState(this.sourceLayer || "_geojsonTileLayer") : uw;
                for (const e1 of t1){
                    const t1 = e1.getBucket(this);
                    if (!t1 || this.fqid !== t1.layerIds[0]) continue;
                    "offset" === t1.elevationType && l ? l.updateZOffset(t1, e1.tileID) : "road" === t1.elevationType && t1.hdExt && t1.hdExt.updateRoadElevation(t1, e1.tileID.canonical), t1.updateZOffset(), a.startSymbolSourceProcessing(t1);
                    const n = t1.getProjection(), m = n.name === s.projection.name ? s : s.clone();
                    m !== s && m.setProjection(t1.projection);
                    const g = v_(e1.tileID, n, m, m.projection.name), y = n.createInversionMatrix(m, e1.tileID.canonical), x = e1.tileSize / Sr, v = o.get(e1.tileID.key) || [];
                    t1.addToPlacement(a, p, g, y, d, m, x, e1, c, u, i, _, r ? h : null, f, v), a.finishSourceProcessing();
                }
            }
            queryRadius() {
                return 0;
            }
            queryIntersectsFeature() {
                return !1;
            }
            _setPaintOverrides() {
                const e1 = this.layout.get("text-field");
                this._overridesTextField !== e1 && (this._overridesTextField = e1, this._overriddenProperties = dw().paint.overridableProperties.filter((e1)=>fw.hasPaintOverride(this.layout, e1)));
                for (const e1 of this._overriddenProperties){
                    const t1 = this.paint.get(e1), i = new cw(t1), n = new ka(i, t1.property.specification, this.scope, this.options, this.layout.get("icon-image-use-theme")), r = "constant" === t1.value.kind || t1.value.isLightConstant;
                    let o = null;
                    o = "constant" === t1.value.kind || "source" === t1.value.kind ? new Ga("source", n, r) : new Ha("composite", n, t1.value.zoomStops, t1.value.interpolationType, r), this.paint._values[e1] = new Us(t1.property, o, t1.parameters);
                }
            }
            isPlacementAffectedByPaintChanges(e1) {
                const t1 = e1;
                return this.paint.get("symbol-z-offset").constantOr(void 0) !== t1.get("symbol-z-offset").constantOr(void 0);
            }
            _handleOverridablePaintPropertyUpdate(e1, t1, i) {
                return !(!this.layout || t1.isDataDriven() || i.isDataDriven()) && fw.hasPaintOverride(this.layout, e1);
            }
            static hasPaintOverride(e1, t1) {
                const i = e1.get("text-field"), n = dw().paint.properties[t1];
                let r = !1;
                const o = (e1)=>{
                    for (const t1 of e1)if (n.overrides && n.overrides.hasOverride(t1)) return void (r = !0);
                };
                if ("constant" === i.value.kind && i.value.value instanceof Nn) o(i.value.value.sections);
                else if ("source" === i.value.kind) {
                    const e1 = (t1)=>{
                        r || (t1 instanceof Zn && Hn(t1.value) === zn ? o(t1.value.sections) : t1 instanceof Yn ? o(t1.sections) : t1.eachChild(e1));
                    }, t1 = i.value;
                    t1._styleExpression && e1(t1._styleExpression.expression);
                }
                return r;
            }
            getProgramIds() {
                return [
                    "symbol"
                ];
            }
            getDefaultProgramParams(e1, t1, i) {
                return {
                    config: new lh(this, {
                        zoom: t1,
                        lut: i
                    }),
                    overrideFog: !1
                };
            }
            hasElevation() {
                return this.layout && "hd-road-markup" === this.layout.get("symbol-elevation-reference");
            }
            mayUse(e1) {
                return "HD" === e1 && bl(this, "symbol-elevation-reference", (e1)=>"hd-road-markup" === e1);
            }
            prepare() {
                return this.mayUse("HD") ? pb() : Promise.resolve();
            }
        }
        let pw, _w, mw, gw;
        const yw = 1024, xw = (Math.pow(yw, 2) - 1) / 268170240;
        class vw extends vl {
            constructor(e1, t1, i, n){
                super(e1, {
                    layout: mw || (mw = new Zs({
                        visibility: new Gs(Ws.layout_raster.visibility)
                    })),
                    paint: gw || (gw = new Zs({
                        "raster-opacity": new Gs(Ws.paint_raster["raster-opacity"]),
                        "raster-color": new $s(Ws.paint_raster["raster-color"]),
                        "raster-color-mix": new Gs(Ws.paint_raster["raster-color-mix"]),
                        "raster-color-range": new Gs(Ws.paint_raster["raster-color-range"]),
                        "raster-color-scale": new Gs(Ws.paint_raster["raster-color-scale"]),
                        "raster-hue-rotate": new Gs(Ws.paint_raster["raster-hue-rotate"]),
                        "raster-brightness-min": new Gs(Ws.paint_raster["raster-brightness-min"]),
                        "raster-brightness-max": new Gs(Ws.paint_raster["raster-brightness-max"]),
                        "raster-saturation": new Gs(Ws.paint_raster["raster-saturation"]),
                        "raster-contrast": new Gs(Ws.paint_raster["raster-contrast"]),
                        "raster-resampling": new Gs(Ws.paint_raster["raster-resampling"]),
                        "raster-fade-duration": new Gs(Ws.paint_raster["raster-fade-duration"]),
                        "raster-emissive-strength": new Gs(Ws.paint_raster["raster-emissive-strength"]),
                        "raster-array-band": new Gs(Ws.paint_raster["raster-array-band"]),
                        "raster-elevation": new Gs(Ws.paint_raster["raster-elevation"]),
                        "raster-elevation-reference": new Gs(Ws.paint_raster["raster-elevation-reference"]),
                        "raster-mask": new Gs(Ws.paint_raster["raster-mask"]),
                        "raster-mask-import": new Gs(Ws.paint_raster["raster-mask-import"]),
                        "raster-mask-mode": new Gs(Ws.paint_raster["raster-mask-mode"]),
                        "raster-color-use-theme": new Hs({
                            type: "string",
                            default: "default",
                            "property-type": "data-driven"
                        })
                    }))
                }, t1, i, n), this.updateColorRamp(), this._curRampRange = [
                    NaN,
                    NaN
                ];
            }
            getProgramIds() {
                return [
                    "raster"
                ];
            }
            hasColorMap() {
                return !!this.getPaintPropertyValue("raster-color").value;
            }
            mayUse(e1) {
                return "RasterArray" === e1 && !!this.paint.get("raster-mask");
            }
            tileCoverLift() {
                return this.paint.get("raster-elevation");
            }
            isDraped(e1) {
                const t1 = e1 ? e1._source : null;
                return (!t1 || "image" !== t1.type && "video" !== t1.type && "canvas" !== t1.type || !t1.onNorthPole && !t1.onSouthPole) && 0 === this.paint.get("raster-elevation");
            }
            _handleSpecialPaintPropertyUpdate(e1) {
                "raster-color" !== e1 && "raster-color-range" !== e1 && "raster-color-scale" !== e1 || (this._curRampRange = [
                    NaN,
                    NaN
                ], this.updateColorRamp());
            }
            _clear() {
                this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null);
            }
            updateColorRamp(e1) {
                if (!this.hasColorMap()) return;
                if (!this._curRampRange) return;
                const t1 = this.getPaintPropertyValue("raster-color").expression, [i, n] = e1 || this.getPaintPropertyValue("raster-color-range").expression.evaluate({
                    zoom: 0
                }) || [
                    NaN,
                    NaN
                ];
                if (isNaN(i) && isNaN(n)) return;
                if (i === this._curRampRange[0] && n === this._curRampRange[1]) return;
                const r = this.getPaintPropertyValue("raster-color-scale").expression.evaluate({
                    zoom: 0
                });
                this.colorRamp = Rb({
                    expression: t1,
                    evaluationKey: "rasterValue",
                    image: this.colorRamp,
                    clips: [
                        {
                            start: i,
                            end: n
                        }
                    ],
                    resolution: yw,
                    scale: r
                }), this.colorRampTexture = null, this._curRampRange = [
                    i,
                    n
                ];
            }
            is3D(e1) {
                return this.paint.get("raster-elevation") > 0;
            }
        }
        let bw, ww, Aw, Ew, Iw, Mw, Sw, Tw;
        class zw extends vl {
            constructor(e1, t1, i, n){
                super(e1, {
                    layout: bw || (bw = new Zs({
                        visibility: new Gs(Ws["layout_raster-particle"].visibility)
                    })),
                    paint: ww || (ww = new Zs({
                        "raster-particle-array-band": new Gs(Ws["paint_raster-particle"]["raster-particle-array-band"]),
                        "raster-particle-count": new Gs(Ws["paint_raster-particle"]["raster-particle-count"]),
                        "raster-particle-color": new $s(Ws["paint_raster-particle"]["raster-particle-color"]),
                        "raster-particle-max-speed": new Gs(Ws["paint_raster-particle"]["raster-particle-max-speed"]),
                        "raster-particle-speed-factor": new Gs(Ws["paint_raster-particle"]["raster-particle-speed-factor"]),
                        "raster-particle-fade-opacity-factor": new Gs(Ws["paint_raster-particle"]["raster-particle-fade-opacity-factor"]),
                        "raster-particle-reset-rate-factor": new Gs(Ws["paint_raster-particle"]["raster-particle-reset-rate-factor"]),
                        "raster-particle-elevation": new Gs(Ws["paint_raster-particle"]["raster-particle-elevation"]),
                        "raster-particle-color-use-theme": new Hs({
                            type: "string",
                            default: "default",
                            "property-type": "data-driven"
                        })
                    }))
                }, t1, i, n), this._updateColorRamp(), this.lastInvalidatedAt = Vt.now();
            }
            mayUse(e1) {
                return "HD" === e1;
            }
            _clear() {
                this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null), this.tileFramebuffer && (this.tileFramebuffer.destroy(), this.tileFramebuffer = null), this.particleFramebuffer && (this.particleFramebuffer.destroy(), this.particleFramebuffer = null);
            }
            onRemove(e1) {
                this.colorRampTexture && this.colorRampTexture.destroy(), this.tileFramebuffer && this.tileFramebuffer.destroy(), this.particleFramebuffer && this.particleFramebuffer.destroy();
            }
            hasColorMap() {
                return !!this.getPaintPropertyValue("raster-particle-color").value;
            }
            getProgramIds() {
                return [
                    "rasterParticle"
                ];
            }
            hasOffscreenPass() {
                return "none" !== this.visibility;
            }
            isDraped(e1) {
                return !1;
            }
            _handleSpecialPaintPropertyUpdate(e1) {
                "raster-particle-color" !== e1 && "raster-particle-max-speed" !== e1 || (this._updateColorRamp(), this._invalidateAnimationState()), "raster-particle-count" === e1 && this._invalidateAnimationState();
            }
            _updateColorRamp() {
                if (!this.hasColorMap()) return;
                const e1 = this.getPaintPropertyValue("raster-particle-color").expression, t1 = this.getPaintPropertyValue("raster-particle-max-speed").expression.evaluate({
                    zoom: 0
                });
                this.colorRamp = Rb({
                    expression: e1,
                    evaluationKey: "rasterParticleSpeed",
                    image: this.colorRamp,
                    clips: [
                        {
                            start: 0,
                            end: t1
                        }
                    ],
                    resolution: 256
                }), this.colorRampTexture = null;
            }
            _invalidateAnimationState() {
                this.lastInvalidatedAt = Vt.now();
            }
            tileCoverLift() {
                return this.paint.get("raster-particle-elevation");
            }
        }
        class Rw extends vl {
            constructor(e1, t1){
                super(e1, {}, t1, null), this.implementation = e1, e1.slot && (this.slot = e1.slot);
            }
            is3D(e1) {
                return "3d" === this.implementation.renderingMode;
            }
            hasOffscreenPass() {
                return void 0 !== this.implementation.prerender;
            }
            isDraped(e1) {
                return void 0 !== this.implementation.renderToTile;
            }
            shouldRedrape() {
                return !!this.implementation.shouldRerenderTiles && this.implementation.shouldRerenderTiles();
            }
            recalculate() {}
            updateTransitions() {}
            hasTransition() {
                return !1;
            }
            serialize() {}
            onAdd(e1) {
                this.implementation.onAdd && this.implementation.onAdd(e1, e1.painter.context.gl);
            }
            onRemove(e1) {
                this.implementation.onRemove && this.implementation.onRemove(e1, e1.painter.context.gl);
            }
        }
        function Pw(e1, t1, i) {
            const n = [
                0,
                0,
                1
            ], r = ce([]);
            return de(r, r, i ? -Ye(e1) + Math.PI : Ye(e1)), he(r, r, -Ye(t1)), J(n, n, r), $(n, n);
        }
        const Dw = [];
        class Fw {
            constructor(e1, t1){
                this.feature = e1, this.instancedDataOffset = t1, this.instancedDataCount = 0, this.rotation = [
                    0,
                    0,
                    0
                ], this.scale = [
                    1,
                    1,
                    1
                ], this.translation = [
                    0,
                    0,
                    0
                ];
            }
        }
        class Cw {
            constructor(){
                this.maxScale = 1, this.maxXYTranslationDistance = 0, this.instancedDataArray = new _u, this.instancesEvaluatedElevation = [], this.features = [], this.idToFeaturesIndex = {};
            }
            colorForInstance(e1) {
                const t1 = 16 * e1, i = this.instancedDataArray.float32;
                let n = Math.floor(i[t1 + 2]);
                const r = 1.05 * (i[t1 + 2] - n);
                return n /= 100, [
                    i[t1] % 1 * 1.05,
                    i[t1 + 1] % 1 * 1.05,
                    r,
                    n
                ];
            }
            tileCoordinatesForInstance(e1) {
                const t1 = 16 * e1, i = this.instancedDataArray.float32;
                let n = i[t1 + 0];
                return n = n > Sr ? n - Sr : n, new Re(Math.trunc(n), Math.trunc(i[t1 + 1]));
            }
            translationForInstance(e1) {
                const t1 = 16 * e1, i = this.instancedDataArray.float32;
                return [
                    i[t1 + 4],
                    i[t1 + 5],
                    i[t1 + 6]
                ];
            }
            rotationScaleForInstance(e1) {
                const t1 = 16 * e1, i = this.instancedDataArray.float32;
                return [
                    i[t1 + 7],
                    i[t1 + 8],
                    i[t1 + 9],
                    i[t1 + 10],
                    i[t1 + 11],
                    i[t1 + 12],
                    i[t1 + 13],
                    i[t1 + 14],
                    i[t1 + 15]
                ];
            }
            transformForInstance(e1) {
                const t1 = 16 * e1, i = this.instancedDataArray.float32;
                return [
                    i[t1 + 7],
                    i[t1 + 8],
                    i[t1 + 9],
                    i[t1 + 4],
                    i[t1 + 10],
                    i[t1 + 11],
                    i[t1 + 12],
                    i[t1 + 5],
                    i[t1 + 13],
                    i[t1 + 14],
                    i[t1 + 15],
                    i[t1 + 6],
                    0,
                    0,
                    0,
                    1
                ];
            }
        }
        class Ow {
            constructor(e1){
                this.requiresStandardRuntime = !0, this.zoom = e1.zoom, this.canonical = e1.canonical, this.overscaledZ = this.canonical.z + Math.log2(e1.overscaling), this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.projection = e1.projection, this.index = e1.index, this.worldview = e1.worldview, this.hasZoomDependentProperties = this.layers[0].isZoomDependent(), this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.hasPattern = !1, this.instancesPerModel = {}, this.validForExaggeration = 0, this.maxVerticalOffset = 0, this.maxScale = 0, this.maxHeight = 0, this.lookupDim = this.zoom > this.canonical.z + 1 ? 0 : this.zoom > this.canonical.z ? 256 : this.zoom > 15 ? 75 : 100, this.instanceCount = 0, this.terrainElevationMin = 0, this.terrainElevationMax = 0, this.validForDEMTile = {
                    id: null,
                    timestamp: 0
                }, this.modelUris = [], this.modelsRequested = !1, this.activeReplacements = [], this.replacementUpdateTime = 0, this.styleDefinedModelURLs = e1.styleDefinedModelURLs, this.hasAppearances = null;
            }
            updateFootprints(e1, t1) {}
            updateAppearances(e1, t1, i, n) {
                return {
                    hasLayoutChanges: !1,
                    hasUboChanges: !1
                };
            }
            populate(e1, t1, i, n) {
                this.tileToMeter = _c(i);
                const r = this.layers[0]._featureFilter.needGeometry;
                this.lookup = new Uint8Array(this.lookupDim * this.lookupDim);
                const o = "hd-road-markup" === this.layers[0].paint.get("model-elevation-reference") ? t1.elevationFeatures : void 0, a = new Ls(this.zoom, {
                    worldview: this.worldview,
                    activeFloors: t1.activeFloors
                });
                for (const { feature: s, id: l, index: c, sourceLayerIndex: u } of e1){
                    const e1 = l ?? (s.properties && Object.hasOwn(s.properties, "id") ? s.properties.id : void 0), h = Mc(s, r);
                    if (!this.layers[0]._featureFilter.filter(a, h, i)) continue;
                    const d = {
                        id: e1,
                        sourceLayerIndex: u,
                        index: c,
                        geometry: Ic(s, h, r, i, n),
                        properties: s.properties,
                        type: s.type,
                        patterns: {}
                    }, f = this.addFeature(d, d.geometry, h, o, i);
                    f && t1.featureIndex.insert(s, d.geometry, c, u, this.index, this.instancesPerModel[f].instancedDataArray.length, 256);
                }
                this.lookup = null;
            }
            evaluateQueryRenderedFeaturePadding() {
                const e1 = this.layers[0].modelManager, t1 = this.layers[0].scope;
                let i = 0;
                for (const n of this.modelUris){
                    const r = e1.getModel(n, t1);
                    if (!r) continue;
                    const o = this.instancesPerModel[n];
                    if (o) {
                        const e1 = .5 * U(r.aabb.max, r.aabb.min) * o.maxScale + o.maxXYTranslationDistance, t1 = Math.min(Sr, Math.max(e1 / this.tileToMeter, 256));
                        i = Math.max(t1, i);
                    }
                }
                return i;
            }
            update(e1, t1, i, n) {
                for(const t1 in this.instancesPerModel){
                    const i = this.instancesPerModel[t1];
                    for(const t1 in e1)if (Object.hasOwn(i.idToFeaturesIndex, t1)) {
                        const n = i.features[i.idToFeaturesIndex[t1]];
                        n.featureStates = e1[t1], this.evaluate(n, e1[t1], i, !0), this.uploaded = !1;
                    }
                }
                this.maxHeight = 0;
            }
            updateZoomBasedPaintProperties() {
                const e1 = this.layers[0].paint;
                if (!this.hasZoomDependentProperties || e1 === this.evaluatedPaint) return !1;
                this.evaluatedPaint = e1;
                const t1 = this.canonical, i = e1.get("model-rotation"), n = e1.get("model-scale"), r = e1.get("model-translation");
                let o = !1;
                for(const e1 in this.instancesPerModel){
                    const a = this.instancesPerModel[e1];
                    for (const e1 of a.features){
                        const { feature: s, featureStates: l } = e1, c = i.evaluate(s, l, t1), u = n.evaluate(s, l, t1), h = r.evaluate(s, l, t1);
                        Q(e1.rotation, c) && Q(e1.scale, u) && Q(e1.translation, h) || (this.evaluate(e1, l, a, !0), o = !0);
                    }
                }
                return o;
            }
            updateReplacement(e1, t1, i, n) {
                if (t1.updateTime === this.replacementUpdateTime) return !1;
                this.replacementUpdateTime = t1.updateTime;
                const r = t1.getReplacementRegionsForTile(e1.toUnwrapped(), !0);
                if (Qp(this.activeReplacements, r)) return !1;
                this.activeReplacements = r;
                let o = !1;
                for(const t1 in this.instancesPerModel){
                    const r = this.instancesPerModel[t1], a = r.instancedDataArray;
                    for (const t1 of r.features){
                        const r = t1.instancedDataOffset, s = t1.instancedDataCount;
                        for(let t1 = 0; t1 < s; t1++){
                            const s = 16 * (t1 + r);
                            let l = a.float32[s + 0];
                            const c = l > Sr;
                            l = c ? l - Sr : l;
                            const u = Math.floor(l), h = Math.floor(a.float32[s + 1]);
                            let d = !1;
                            for (const t1 of this.activeReplacements)if (!Xp(t1, i, h_.Model, n) && !(t1.min.x > u || u > t1.max.x || t1.min.y > h || h > t1.max.y) && (d = u_(c_(u, h, e1.canonical, t1.footprintTileId.canonical), t1.footprint), d)) break;
                            a.float32[s] = d ? l + Sr : l, o = o || d !== c;
                        }
                    }
                }
                return o;
            }
            isEmpty() {
                for(const e1 in this.instancesPerModel)if (0 !== this.instancesPerModel[e1].instancedDataArray.length) return !1;
                return !0;
            }
            uploadPending() {
                return !this.uploaded;
            }
            upload(e1) {
                if (!this.uploaded) for(const t1 in this.instancesPerModel){
                    const i = this.instancesPerModel[t1];
                    i.instancedDataArray.length < 0 || 0 === i.instancedDataArray.length || (i.instancedDataBuffer ? i.instancedDataBuffer.updateData(i.instancedDataArray) : i.instancedDataBuffer = e1.createVertexBuffer(i.instancedDataArray, tx.members, !0, void 0, this.instanceCount));
                }
                this.uploaded = !0;
            }
            destroy(e1) {
                for(const e1 in this.instancesPerModel){
                    const t1 = this.instancesPerModel[e1];
                    0 !== t1.instancedDataArray.length && t1.instancedDataBuffer && t1.instancedDataBuffer.destroy();
                }
                const t1 = this.layers[0].modelManager;
                if (e1 && t1 && this.modelUris && this.modelsRequested) for (const e1 of this.modelUris)t1.removeModel(e1, "", !0);
            }
            addFeature(e1, t1, i, n, r) {
                const o = this.layers[0], a = o.layout.get("model-id"), s = o.layout.get("model-allow-density-reduction"), l = a.evaluate(i, {}, this.canonical);
                if (!l) return _t(`modelId is not evaluated for layer ${o.id} and it is not going to get rendered.`), l;
                !l.includes("://") && !this.styleDefinedModelURLs[l] || this.modelUris.includes(l) || this.modelUris.push(l), this.instancesPerModel[l] || (this.instancesPerModel[l] = new Cw);
                const c = this.instancesPerModel[l], u = c.instancedDataArray, h = new Fw(i, u.length);
                let d;
                if (n) {
                    const t1 = fg(e1, n, void 0, r);
                    d = t1 ? t1.feature : void 0;
                }
                for (const e1 of t1)for (const t1 of e1){
                    if (t1.x < 0 || t1.x >= Sr || t1.y < 0 || t1.y >= Sr) continue;
                    if (0 !== this.lookupDim && s) {
                        const e1 = (this.lookupDim - 1) / Sr, i = this.lookupDim * (t1.y * e1 | 0) + t1.x * e1 | 0;
                        if (this.lookup) {
                            if (0 !== this.lookup[i]) continue;
                            this.lookup[i] = 1;
                        }
                    }
                    this.instanceCount++;
                    const e1 = u.length;
                    if (u.resize(e1 + 1), n) {
                        c.instancesRoadElevation || (c.instancesRoadElevation = []);
                        const e1 = d ? d.pointElevation(new Re(t1.x, t1.y)) : 0;
                        c.instancesRoadElevation.push(e1);
                    }
                    c.instancesEvaluatedElevation.push(0), u.float32[16 * e1] = t1.x, u.float32[16 * e1 + 1] = t1.y;
                }
                return h.instancedDataCount = c.instancedDataArray.length - h.instancedDataOffset, h.instancedDataCount > 0 && (e1.id && (c.idToFeaturesIndex[e1.id] = c.features.length), c.features.push(h), this.evaluate(h, {}, c, !1)), l;
            }
            getModelUris() {
                return this.modelUris;
            }
            evaluate(e1, t1, i, n) {
                const r = this.layers[0].paint, o = e1.feature, a = this.canonical, s = e1.rotation = r.get("model-rotation").evaluate(o, t1, a), l = e1.scale = r.get("model-scale").evaluate(o, t1, a), c = e1.translation = r.get("model-translation").evaluate(o, t1, a), { r: u, g: h, b: d } = r.get("model-color").evaluate(o, t1, a), f = r.get("model-color-mix-intensity").evaluate(o, t1, a);
                this.maxVerticalOffset < c[2] && (this.maxVerticalOffset = c[2]);
                const p = c[0] * c[0] + c[1] * c[1], _ = p > 0 ? Math.sqrt(p) : 0;
                i.maxScale = Math.max(Math.max(i.maxScale, l[0]), Math.max(l[1], l[2])), i.maxXYTranslationDistance = Math.max(i.maxXYTranslationDistance, _), this.maxScale = Math.max(Math.max(this.maxScale, l[0]), Math.max(l[1], l[2])), ux(Dw, s, l);
                const m = Math.round(100 * f) + d / 1.05, g = i.instancedDataArray.float32;
                for(let t1 = 0; t1 < e1.instancedDataCount; ++t1){
                    const r = e1.instancedDataOffset + t1, o = 16 * r;
                    let s = 0;
                    n && (s = g[o + 6] - i.instancesEvaluatedElevation[r]);
                    const l = 0 | g[o + 1];
                    g[o] = (0 | g[o]) + u / 1.05, g[o + 1] = l + h / 1.05, g[o + 2] = m, g[o + 3] = 1 / (a.z > 10 ? this.tileToMeter : _c(a, l)), g[o + 4] = c[0], g[o + 5] = c[1], g[o + 6] = c[2] + (i.instancesRoadElevation ? i.instancesRoadElevation[r] : 0) + s, g[o + 7] = Dw[0], g[o + 8] = Dw[1], g[o + 9] = Dw[2], g[o + 10] = Dw[4], g[o + 11] = Dw[5], g[o + 12] = Dw[6], g[o + 13] = Dw[8], g[o + 14] = Dw[9], g[o + 15] = Dw[10], i.instancesEvaluatedElevation[r] = c[2];
                }
            }
        }
        Ya(Ow, "ModelBucket", {
            omit: [
                "layers"
            ]
        }), Ya(Cw, "PerModelAttributes"), Ya(Fw, "ModelFeature");
        const Lw = new WeakMap;
        class Bw {
            constructor(e1, t1){
                const i = e1.gl;
                if (this.context = e1, this.buffer = i.createBuffer(), !this.buffer) throw new Error("Failed to create model part style UBO buffer");
                i.bindBuffer(i.UNIFORM_BUFFER, this.buffer), i.bufferData(i.UNIFORM_BUFFER, t1, i.DYNAMIC_DRAW), i.bindBuffer(i.UNIFORM_BUFFER, null);
            }
            update(e1) {
                const t1 = this.context.gl;
                t1.bindBuffer(t1.UNIFORM_BUFFER, this.buffer), t1.bufferSubData(t1.UNIFORM_BUFFER, 0, e1), t1.bindBuffer(t1.UNIFORM_BUFFER, null);
            }
            bind(e1, t1) {
                let i = Lw.get(t1);
                if (void 0 === i) {
                    const n = e1.gl, r = n.getUniformBlockIndex(t1, "ModelPartStyleUniform");
                    i = r !== n.INVALID_INDEX, i && n.uniformBlockBinding(t1, r, 0), Lw.set(t1, i);
                }
                if (!i) return;
                const n = e1.gl;
                n.bindBufferBase(n.UNIFORM_BUFFER, 0, this.buffer);
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), this.buffer = null);
            }
        }
        let Vw, Nw;
        const kw = [
            0,
            0,
            0
        ], Uw = [
            0,
            0,
            0
        ];
        function jw(e1) {
            let t1 = 0;
            if (e1.meshes) for (const i of e1.meshes)t1 = Math.max(t1, i.aabb.max[2]);
            if (e1.children) for (const i of e1.children)t1 = Math.max(t1, jw(i));
            return t1;
        }
        function Gw(e1, t1, i) {
            if (e1.meshes) for (const n of e1.meshes){
                if (n.aabb.min[0] === 1 / 0) continue;
                const r = Nf.applyTransform(n.aabb, e1.globalMatrix);
                i.insert(t1, r.min[0], r.min[1], r.max[0], r.max[1]);
            }
            if (e1.children) for (const n of e1.children)Gw(n, t1, i);
        }
        class Hw {
            constructor(e1){
                this.node = e1, this.hiddenByReplacement = !1, this.evaluatedTranslation = [
                    0,
                    0,
                    0
                ], this.evaluatedScale = [
                    1,
                    1,
                    1
                ], this.emissiveStrength = 0, this.partStyle = new Float32Array(112), this.partStyleUBO = null, this.needsPartStyleUBO = !1, this.cameraCollisionOpacity = 1, this.targetLod = -1, this.feature = {
                    type: "Point",
                    id: e1.id,
                    geometry: [],
                    properties: {
                        height: jw(e1)
                    }
                }, this.aabb = this._getLocalBounds(), this.state = null;
            }
            _getLocalBounds() {
                if (!this.node.meshes) return new Nf([
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ]);
                if (!this.aabb) {
                    let e1 = 0;
                    const t1 = new Nf([
                        1 / 0,
                        1 / 0,
                        1 / 0
                    ], [
                        -1 / 0,
                        -1 / 0,
                        -1 / 0
                    ]);
                    for (const i of this.node.meshes)this.node.lightMeshIndex !== e1 && (i.transformedAabb = Nf.applyTransformFast(i.aabb, this.node.globalMatrix), t1.encapsulate(i.transformedAabb)), e1++;
                    this.aabb = t1;
                }
                return this.aabb;
            }
        }
        class $w {
            constructor(e1, t1, i, n, r, o, a, s){
                this.requiresStandardRuntime = !0, this.isTiled3dModelBucket = !0, this.id = i, this.layers = e1, this.layerIds = this.layers.map((e1)=>e1.fqid), this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.modelTraits |= 1, this.uploaded = !1, this.hasPattern = !1, n && (this.modelTraits |= 4), r && (this.modelTraits |= 8), this.zoom = -1, this.terrainExaggeration = 1, this.projection = {
                    name: "mercator"
                }, this.replacementUpdateTime = 0, this.elevationReadFromZ = 255, this.brightness = o, this.worldview = s, this.dirty = !0, this.needsPartStyleUBOs = !1, this.filter = null, this.nodesInfo = [];
                for (const e1 of t1)this.nodesInfo.push(new Hw(e1)), Gw(e1, a.featureIndexArray.length, a.grid), a.featureIndexArray.emplaceBack(this.nodesInfo.length - 1, 0, a.bucketLayerIDs.length - 1, 0);
                this.states = {}, this.hasAppearances = null;
            }
            updateFootprints(e1, t1) {
                for (const i of this.getNodesInfo()){
                    const n = i.node;
                    n.footprint && t1.push({
                        footprint: n.footprint,
                        id: e1
                    });
                }
            }
            updateAppearances(e1, t1, i, n) {
                return {
                    hasLayoutChanges: !1,
                    hasUboChanges: !1
                };
            }
            update(e1) {
                const t1 = 0 !== Object.keys(e1).length;
                if (t1 && !this.stateDependentLayers.length) return;
                const i = t1 ? this.stateDependentLayers : this.layers;
                if (!Pe(e1, this.states)) for (const n of i)this.evaluate(n, e1, t1);
                this.states = structuredClone(e1);
            }
            populate() {
                console.log("populate 3D model bucket");
            }
            uploadPending() {
                return !this.uploaded || this.needsPartStyleUBOs;
            }
            upload(e1) {
                if (this.needsPartStyleUBOs && (this.createPartStyleUBOs(e1), this.needsPartStyleUBOs = !1), !this.uploaded) {
                    const t1 = this.getNodesInfo();
                    for (const i of t1)bx(i.node, e1, !0);
                    for (const e1 of t1)Ax(e1.node);
                    this.uploaded = !0;
                }
            }
            createPartStyleUBOs(e1) {
                for (const t1 of this.getNodesInfo())t1.needsPartStyleUBO && (t1.partStyleUBO = new Bw(e1, t1.partStyle), t1.needsPartStyleUBO = !1);
            }
            needsReEvaluation(e1, t1, i) {
                const n = e1.transform.projectionOptions, r = e1.style.getBrightness(), o = this.brightness !== r;
                if (!this.uploaded || this.dirty || n.name !== this.projection.name || Zw(i.paint.get("model-color").value, o) || Zw(i.paint.get("model-color-mix-intensity").value, o) || Zw(i.paint.get("model-roughness").value, o) || Zw(i.paint.get("model-emissive-strength").value, o) || Zw(i.paint.get("model-height-based-emissive-strength-multiplier").value, o)) {
                    this.projection = n, this.brightness = r;
                    const e1 = this.getNodesInfo();
                    for (const t1 of e1)t1.state = null;
                    return !0;
                }
                return !1;
            }
            evaluateTransform(e1, t1) {
                if (e1.transform.zoom === this.zoom) return;
                this.zoom = e1.transform.zoom;
                const i = this.getNodesInfo(), n = this.id.canonical;
                for (const e1 of i){
                    const i = e1.feature;
                    e1.evaluatedTranslation = t1.paint.get("model-translation").evaluate(i, {}, n), e1.evaluatedScale = t1.paint.get("model-scale").evaluate(i, {}, n);
                }
            }
            evaluate(e1, t1, i = !1) {
                const n = this.getNodesInfo(), r = this.id.canonical, o = i && t1 ? new Set(Object.keys(t1)) : null;
                for (const i of n){
                    if (!i.node.meshes) continue;
                    const n = i.feature;
                    if (o && !o.has(String(n.id))) continue;
                    const a = t1 && t1[n.id];
                    if (Pe(a, i.state)) continue;
                    i.state = structuredClone(a);
                    const s = i.node.meshes[0].hasFeatureData;
                    if (i.hasTranslucentParts = !1, s) {
                        for(let t1 = 0; t1 < _x.length; t1++){
                            const o = _x[t1];
                            o.length && (n.properties.part = o);
                            const s = e1.paint.get("model-color").evaluate(n, a, r).toPremultipliedRenderColor(null);
                            Ww(i.partStyle, 16 * t1, s, e1.paint.get("model-color-mix-intensity").evaluate(n, a, r), e1.paint.get("model-roughness").evaluate(n, a, r), "window" === o ? 1 : 0, e1.paint.get("model-emissive-strength").evaluate(n, a, r), e1.paint.get("model-height-based-emissive-strength-multiplier").evaluate(n, a, r)), s.a < 1 && (i.hasTranslucentParts = !0);
                        }
                        delete n.properties.part;
                    } else i.emissiveStrength = e1.paint.get("model-emissive-strength").evaluate(n, a, r);
                    i.evaluatedTranslation = e1.paint.get("model-translation").evaluate(n, a, r), i.evaluatedScale = e1.paint.get("model-scale").evaluate(n, a, r), s && (i.partStyleUBO ? i.partStyleUBO.update(i.partStyle) : (i.needsPartStyleUBO = !0, this.needsPartStyleUBOs = !0));
                }
                this.dirty = !1;
            }
            elevationUpdate(e1, t1, i, n) {
                const r = e1.findDEMTileFor(i);
                if (r && (r.tileID.canonical !== this.terrainTile || t1 !== this.terrainExaggeration)) {
                    if (r.dem && r.tileID.overscaledZ !== this.elevationReadFromZ) {
                        this.elevationReadFromZ = r.tileID.overscaledZ;
                        const t1 = p_.create(e1, i, r);
                        if (!t1) return;
                        4 & this.modelTraits && this.updateDEM(e1, t1, i, n);
                        for (const e1 of this.getNodesInfo()){
                            const i = e1.node;
                            if (!i.footprint || !i.footprint.vertices || !i.footprint.vertices.length) continue;
                            const n = i.footprint.vertices;
                            let r = t1.getElevationAt(n[0], n[1], !0, !0);
                            for(let e1 = 2; e1 < n.length; e1 += 2)r = Math.min(r, t1.getElevationAt(n[e1], n[e1 + 1], !0, !0));
                            i.elevation = r;
                        }
                    }
                    this.terrainTile = r.tileID.canonical, this.terrainExaggeration = t1;
                }
            }
            updateDEM(e1, t1, i, n) {
                let r = t1._dem._modifiedForSources[n];
                if (void 0 === r && (t1._dem._modifiedForSources[n] = [], r = t1._dem._modifiedForSources[n]), r.includes(i.canonical)) return;
                const o = t1._dem.dim;
                r.push(i.canonical), (!Vw || Vw.length < o * o) && (Vw = new Float32Array(o * o), Nw = new Uint8Array(o * o));
                let a = !1;
                for (const e1 of this.getNodesInfo()){
                    const i = e1.node;
                    if (!i.footprint || !i.footprint.grid) continue;
                    const n = i.footprint.grid, r = t1.tileCoordToPixel(n.min.x, n.min.y), s = t1.tileCoordToPixel(n.max.x, n.max.y), l = Math.min(Math.min(o - s.y, r.x), Math.min(r.y, o - s.x));
                    if (l < 0) continue;
                    const c = tt(l, 2, 5);
                    let u = Math.max(0, r.x - c), h = Math.max(0, r.y - c), d = Math.min(s.x + c, o - 1), f = Math.min(s.y + c, o - 1);
                    for(let e1 = h; e1 <= f; ++e1)for(let t1 = u; t1 <= d; ++t1)Nw[e1 * o + t1] = 255;
                    let p = 0, _ = 0;
                    for(let e1 = 0; e1 < n.cellsY; ++e1)for(let i = 0; i < n.cellsX; ++i){
                        const r = e1 * n.cellsX + i;
                        if (n.cellOffsets[r] === n.cellOffsets[r + 1]) continue;
                        const a = t1.tileCoordToPixel(n.min.x + i / n.xScale, n.min.y + e1 / n.yScale), s = t1.tileCoordToPixel(n.min.x + (i + 1) / n.xScale, n.min.y + (e1 + 1) / n.yScale);
                        for(let e1 = a.y; e1 <= Math.min(s.y + 1, o - 1); ++e1)for(let i = a.x; i <= Math.min(s.x + 1, o - 1); ++i)255 === Nw[e1 * o + i] && (Nw[e1 * o + i] = 0, p += t1.getElevationAtPixel(i, e1), _++);
                    }
                    const m = p / _;
                    u = Math.max(1, r.x - c), h = Math.max(1, r.y - c), d = Math.min(s.x + c, o - 2), f = Math.min(s.y + c, o - 2), a = !0;
                    for(let e1 = h; e1 <= f; ++e1)for(let i = u; i <= d; ++i)0 === Nw[e1 * o + i] && (Vw[e1 * o + i] = t1._dem.set(i, e1, m));
                    for(let e1 = 1; e1 < c; ++e1){
                        u = Math.max(1, r.x - e1), h = Math.max(1, r.y - e1), d = Math.min(s.x + e1, o - 2), f = Math.min(s.y + e1, o - 2);
                        for(let i = h; i <= f; ++i)for(let n = u; n <= d; ++n){
                            const r = i * o + n;
                            if (255 === Nw[r]) {
                                let a = 0, s = 0, l = -1, u = -1;
                                for(let t1 = -1; t1 <= 1; ++t1)for(let r = -1; r <= 1; ++r){
                                    const c = (i + t1) * o + n + r;
                                    if (Nw[c] >= e1) continue;
                                    const h = Vw[c], d = Math.abs(h);
                                    d > s && (a = h, s = d, l = r, u = t1);
                                }
                                if (s > .1) {
                                    const o = 1 - (e1 + .5 * Math.abs(l * u)) / c;
                                    let s = t1._dem.get(n, i) + a * o;
                                    const h = t1._dem.get(n + l, i + u), d = t1._dem.get(n - l, i - u, !0);
                                    (s - h) * (s - d) > 0 && (s = (h + d) / 2), Vw[r] = t1._dem.set(n, i, s), Nw[r] = e1;
                                }
                            }
                        }
                    }
                }
                a && (t1._demTile.needsDEMTextureUpload = !0, t1._dem._timestamp = Vt.now());
            }
            setFilter(e1) {
                this.filter = e1 ? Js(e1) : null;
            }
            getNodesInfo() {
                return this.filter ? this.nodesInfo.filter((e1)=>this.filter.filter(new Ls(this.id.overscaledZ, {
                        worldview: this.worldview
                    }), e1.feature, this.id.canonical)) : this.nodesInfo;
            }
            destroy() {
                const e1 = this.getNodesInfo();
                for (const t1 of e1)Ax(t1.node), Ix(t1.node), t1.partStyleUBO && (t1.partStyleUBO.destroy(), t1.partStyleUBO = null);
            }
            isEmpty() {
                return !this.nodesInfo.length;
            }
            updateReplacement(e1, t1) {
                if (t1.updateTime === this.replacementUpdateTime) return;
                this.replacementUpdateTime = t1.updateTime;
                const i = t1.getReplacementRegionsForTile(e1.toUnwrapped());
                for (const e1 of this.getNodesInfo()){
                    const t1 = e1.node.footprint;
                    e1.hiddenByReplacement = !!t1 && !i.some((e1)=>e1.footprint === t1);
                }
            }
            getHeightAtTileCoord(e1, t1) {
                const i = [
                    0,
                    0,
                    0
                ], n = d([]);
                for (const r of this.getNodesInfo()){
                    const o = r.node.meshes[0], a = o.transformedAabb;
                    if (e1 < a.min[0] || t1 < a.min[1] || e1 > a.max[0] || t1 > a.max[1]) continue;
                    if (!0 === r.node.hidden) return {
                        height: 1 / 0,
                        maxHeight: r.feature.properties.height,
                        hidden: !1,
                        verticalScale: r.evaluatedScale[2]
                    };
                    if (r.node.meshBVH) {
                        const o = 4 * (e1 + Sr) * Sr + (t1 + Sr);
                        r.bvhHeightLookup ??= new Map;
                        let a = r.bvhHeightLookup.get(o);
                        if (void 0 === a && (p(n, r.node.globalMatrix), X(i, F(i, e1, t1, 0), n), kw[0] = i[0] - 1, kw[1] = i[1] - 1, kw[2] = -1000, Uw[0] = i[0] + 1, Uw[1] = i[1] + 1, Uw[2] = 1e3, a = r.node.meshBVH.findHighestPoint(kw, Uw), r.bvhHeightLookup.set(o, a)), null !== a) return {
                            height: a,
                            maxHeight: r.feature.properties.height,
                            hidden: r.hiddenByReplacement,
                            verticalScale: r.evaluatedScale[2]
                        };
                        continue;
                    }
                    if (!o.heightmap) continue;
                    p(n, r.node.globalMatrix), X(i, F(i, e1, t1, 0), n);
                    const s = (i[0] - o.aabb.min[0]) / (o.aabb.max[0] - o.aabb.min[0]) * px | 0, l = Math.min(63, (i[1] - o.aabb.min[1]) / (o.aabb.max[1] - o.aabb.min[1]) * px | 0) * px + Math.min(63, s), c = o.heightmap[l];
                    if (c < 0 && r.node.footprint) {
                        const i = [];
                        if (r.node.footprint.grid.query(new Re(e1, t1), new Re(e1, t1), i), i.length > 0) return {
                            height: void 0,
                            maxHeight: r.feature.properties.height,
                            hidden: r.hiddenByReplacement,
                            verticalScale: r.evaluatedScale[2]
                        };
                        continue;
                    }
                    if (r.hiddenByReplacement) return;
                    return {
                        height: c,
                        maxHeight: r.feature.properties.height,
                        hidden: !1,
                        verticalScale: r.evaluatedScale[2]
                    };
                }
            }
        }
        function Zw(e1, t1) {
            return e1 instanceof Ga && !e1.isLightConstant && t1;
        }
        function Ww(e1, t1, i, n, r, o, a, s) {
            const l = tt(s[0], 0, 1), c = tt(s[1], 0, 1);
            e1[t1] = i.r, e1[t1 + 1] = i.g, e1[t1 + 2] = i.b, e1[t1 + 3] = tt(n, 0, 1), e1[t1 + 4] = r, e1[t1 + 5] = o, e1[t1 + 6] = tt(a, 0, 2), e1[t1 + 7] = i.a, l !== c ? (e1[t1 + 8] = l, e1[t1 + 9] = c, e1[t1 + 10] = tt(s[2], 0, 1), e1[t1 + 11] = tt(s[3], 0, 1) - e1[t1 + 10], e1[t1 + 12] = Math.pow(10, tt(s[4], -1, 1))) : (e1[t1 + 8] = 0, e1[t1 + 9] = 1, e1[t1 + 10] = 1, e1[t1 + 11] = 0, e1[t1 + 12] = 1), function(e1, t1) {
                e1[t1 + 4] = 16 * Math.floor(15 * e1[t1 + 4]) / 255, e1[t1 + 5] = 16 * Math.floor(15 * e1[t1 + 5]) / 255, e1[t1 + 6] = Math.min(Math.floor(127.5 * e1[t1 + 6] + .5), 255) / 255 * 2, e1[t1 + 7] = Math.floor(255 * e1[t1 + 7]) / 255;
                const i = Math.floor(255 * e1[t1 + 10]) / 256, n = Math.floor(255 * (e1[t1 + 10] + e1[t1 + 11])) / 256;
                e1[t1 + 10] = i, e1[t1 + 11] = n - i;
            }(e1, t1);
        }
        Ya($w, "Tiled3dModelBucket", {
            omit: [
                "layers"
            ]
        }), Ya(Hw, "Tiled3dModelFeature", {
            omit: [
                "partStyleUBO"
            ]
        });
        class qw {
            constructor(e1){
                this._stringToNumber = {}, this._numberToString = [];
                for(let t1 = 0; t1 < e1.length; t1++){
                    const i = e1[t1];
                    this._stringToNumber[i] = t1, this._numberToString[t1] = i;
                }
            }
            encode(e1) {
                return this._stringToNumber[e1];
            }
            decode(e1) {
                return this._numberToString[e1];
            }
        }
        const Xw = [
            "id",
            "tile",
            "layer",
            "source",
            "sourceLayer",
            "state"
        ];
        class Yw {
            constructor(e1, t1, i, n, r){
                this.type = "Feature", this._vectorTileFeature = e1, this._z = t1, this._x = i, this._y = n, this.properties = e1 ? e1.properties : {}, this.id = r;
            }
            clone() {
                const e1 = new Yw(this._vectorTileFeature, this._z, this._x, this._y, this.id);
                return this.state && (e1.state = {
                    ...this.state
                }), this.layer && (e1.layer = {
                    ...this.layer
                }), this.source && (e1.source = this.source), this.sourceLayer && (e1.sourceLayer = this.sourceLayer), e1;
            }
            get geometry() {
                return void 0 === this._geometry && this._vectorTileFeature && (this._geometry = this._vectorTileFeature.toGeoJSON(this._x, this._y, this._z).geometry), this._geometry;
            }
            set geometry(e1) {
                this._geometry = e1;
            }
            toJSON() {
                const e1 = {
                    type: "Feature",
                    state: void 0,
                    geometry: this.geometry,
                    properties: this.properties
                };
                for (const t1 of Xw)void 0 !== this[t1] && (e1[t1] = this[t1]);
                return e1;
            }
        }
        const Jw = {
            BaseColor: 5,
            MetallicRoughness: 6,
            Normal: 7,
            Occlusion: 8,
            Emission: 9,
            LUT: 10,
            ShadowMap0: 11
        }, Kw = new Float32Array(d([])), Qw = a(), eA = (e1, t1)=>{
            const i = e1.style.light.properties, n = i.get("position"), r = [
                -n.x,
                -n.y,
                n.z
            ];
            "viewport" === i.get("anchor") && Y(r, r, l(Qw, -e1.transform.angle));
            const o = i.get("color").toNonPremultipliedRenderColor(null), a = t1.paint.get("model-color").constantOr(fn.white).toNonPremultipliedRenderColor(null).toArray01();
            return a[3] = t1.paint.get("model-color-mix-intensity").constantOr(0), {
                lightPos: r,
                lightIntensity: i.get("intensity"),
                lightColor: [
                    o.r,
                    o.g,
                    o.b
                ],
                colorMix: a,
                aoIntensity: t1.paint.get("model-ambient-occlusion-intensity")
            };
        }, tA = (e1, t1, i, n, r, o, a, s, l = [
            0,
            0,
            0
        ], c, u, h, d = 1)=>{
            const f = a.pbrMetallicRoughness;
            let p = h || r.colorMix;
            if (u) {
                const e1 = u.color;
                p = [
                    e1.r,
                    e1.g,
                    e1.b,
                    u.colorMix
                ], s = u.emissionStrength, o *= u.opacity;
            }
            return {
                u_matrix: e1,
                u_lighting_matrix: t1,
                u_normal_matrix: i,
                u_node_matrix: n || Kw,
                u_lightpos: r.lightPos,
                u_lightintensity: r.lightIntensity,
                u_lightcolor: r.lightColor,
                u_camera_pos: l,
                u_opacity: o,
                u_alphaMask: +("MASK" === a.alphaMode),
                u_alphaCutoff: a.alphaCutoff,
                u_baseColorFactor: f.baseColorFactor.toNonPremultipliedRenderColor(null).toArray01(),
                u_emissiveFactor: a.emissiveFactor.toNonPremultipliedRenderColor(null).toArray01(),
                u_metallicFactor: f.metallicFactor,
                u_roughnessFactor: f.roughnessFactor,
                u_baseColorTexture: Jw.BaseColor,
                u_metallicRoughnessTexture: Jw.MetallicRoughness,
                u_normalTexture: Jw.Normal,
                u_occlusionTexture: Jw.Occlusion,
                u_emissionTexture: Jw.Emission,
                u_lutTexture: Jw.LUT,
                u_color_mix: p,
                u_aoIntensity: r.aoIntensity,
                u_emissive_strength: s,
                u_occlusionTextureTransform: c || [
                    0,
                    0,
                    0,
                    0
                ],
                u_dithered_discard_threshold: d,
                u_model_mesh_params: [
                    0,
                    1,
                    0,
                    0
                ]
            };
        }, iA = (e1, t1 = Kw, i = Kw)=>({
                u_matrix: e1,
                u_instance: t1,
                u_node_matrix: i
            }), nA = 7680;
        class rA {
            constructor(e1, t1, i, n, r, o){
                this.test = e1, this.ref = t1, this.mask = i, this.fail = n, this.depthFail = r, this.pass = o;
            }
        }
        rA.disabled = new rA({
            func: 519,
            mask: 0
        }, 0, 0, nA, nA, nA);
        const oA = 770, aA = 771;
        class sA {
            constructor(e1, t1, i, n){
                this.blendFunction = e1, this.blendColor = t1.toNonPremultipliedRenderColor(null), this.mask = i, this.blendEquation = n;
            }
        }
        sA.Replace = [
            1,
            0,
            1,
            0
        ], sA.disabled = new sA(sA.Replace, fn.transparent, [
            !1,
            !1,
            !1,
            !1
        ]), sA.unblended = new sA(sA.Replace, fn.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), sA.alphaBlended = new sA([
            1,
            aA,
            1,
            aA
        ], fn.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), sA.alphaBlendedNonPremultiplied = new sA([
            oA,
            aA,
            oA,
            aA
        ], fn.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), sA.multiply = new sA([
            774,
            0,
            774,
            0
        ], fn.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), sA.multiplyAccumulateAlpha = new sA([
            774,
            0,
            1,
            aA
        ], fn.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), sA.additive = new sA([
            1,
            1,
            1,
            1
        ], fn.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), sA.additiveAlphaWeighted = new sA([
            oA,
            1,
            773,
            1
        ], fn.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), sA.additiveAlphaWeightedUnboundedAlpha = new sA([
            oA,
            1,
            1,
            1
        ], fn.transparent, [
            !0,
            !0,
            !0,
            !0
        ]);
        class lA {
            constructor(e1, t1, i){
                this.func = e1, this.mask = t1, this.range = i;
            }
        }
        lA.ReadOnly = !1, lA.ReadWrite = !0, lA.disabled = new lA(519, lA.ReadOnly, [
            0,
            1
        ]);
        const cA = 1029, uA = 2305;
        class hA {
            constructor(e1, t1, i){
                this.enable = e1, this.mode = t1, this.frontFace = i;
            }
        }
        hA.disabled = new hA(!1, cA, uA), hA.backCCW = new hA(!0, cA, uA), hA.backCW = new hA(!0, cA, 2304), hA.frontCW = new hA(!0, 1028, 2304), hA.frontCCW = new hA(!0, 1028, uA);
        class dA {
            constructor(e1 = 0, t1 = 0, i = 0, n = 0){
                if (isNaN(e1) || e1 < 0 || isNaN(t1) || t1 < 0 || isNaN(i) || i < 0 || isNaN(n) || n < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
                this.top = e1, this.bottom = t1, this.left = i, this.right = n;
            }
            interpolate(e1, t1, i) {
                return null != t1.top && null != e1.top && (this.top = hn(e1.top, t1.top, i)), null != t1.bottom && null != e1.bottom && (this.bottom = hn(e1.bottom, t1.bottom, i)), null != t1.left && null != e1.left && (this.left = hn(e1.left, t1.left, i)), null != t1.right && null != e1.right && (this.right = hn(e1.right, t1.right, i)), this;
            }
            getCenter(e1, t1) {
                return new Re(tt((this.left + e1 - this.right) / 2, 0, e1), tt((this.top + t1 - this.bottom) / 2, 0, t1));
            }
            equals(e1) {
                return this.top === e1.top && this.bottom === e1.bottom && this.left === e1.left && this.right === e1.right;
            }
            clone() {
                return new dA(this.top, this.bottom, this.left, this.right);
            }
            toJSON() {
                return {
                    top: this.top,
                    bottom: this.bottom,
                    left: this.left,
                    right: this.right
                };
            }
        }
        function fA(e1, t1) {
            const i = At(e1, 3);
            M(e1, t1), Et(e1, 3, i);
        }
        function pA(e1, t1) {
            const i = ce([]);
            return fe(i, i, -t1), he(i, i, -e1), i;
        }
        function _A(e1, t1) {
            const i = [
                e1[0],
                e1[1],
                0
            ], n = [
                t1[0],
                t1[1],
                0
            ];
            if (P(i) >= 1e-15) {
                const e1 = $([], i);
                N(n, e1, Z(n, e1)), t1[0] = n[0], t1[1] = n[1];
            }
            const r = W([], t1, e1);
            if (ie(r) < 1e-15) return null;
            const o = Math.atan2(-r[1], r[0]);
            return pA(Math.atan2(Math.sqrt(e1[0] * e1[0] + e1[1] * e1[1]), -e1[2]), o);
        }
        class mA {
            constructor(e1, t1){
                this.position = e1, this.orientation = t1;
            }
            get position() {
                return this._position;
            }
            set position(e1) {
                if (e1) {
                    const t1 = e1 instanceof mc ? e1 : new mc(e1[0], e1[1], e1[2]);
                    this._renderWorldCopies && (t1.x = nt(t1.x, 0, 1)), this._position = t1;
                } else this._position = null;
            }
            lookAtPoint(e1, t1, i) {
                if (this.orientation = null, !this.position) return;
                const n = this.position, r = i || (this._elevation ? this._elevation.getAtPointOrZero(mc.fromLngLat(e1)) : 0), o = mc.fromLngLat(e1, r), a = [
                    o.x - n.x,
                    o.y - n.y,
                    o.z - n.z
                ];
                t1 || (t1 = [
                    0,
                    0,
                    1
                ]), t1[2] = Math.abs(t1[2]), this.orientation = _A(a, t1);
            }
            setPitchBearing(e1, t1) {
                this.orientation = pA(Ye(e1), Ye(-t1));
            }
        }
        class gA {
            constructor(e1, t1){
                this._transform = d([]), this.orientation = t1, this.position = e1;
            }
            get mercatorPosition() {
                const e1 = this.position;
                return new mc(e1[0], e1[1], e1[2]);
            }
            get position() {
                const e1 = At(this._transform, 3);
                return [
                    e1[0],
                    e1[1],
                    e1[2]
                ];
            }
            set position(e1) {
                var t1;
                e1 && Et(this._transform, 3, [
                    (t1 = e1)[0],
                    t1[1],
                    t1[2],
                    1
                ]);
            }
            get orientation() {
                return this._orientation;
            }
            set orientation(e1) {
                this._orientation = e1 || ce([]), e1 && fA(this._transform, this._orientation);
            }
            getPitchBearing() {
                const e1 = this.forward(), t1 = this.right();
                return {
                    bearing: Math.atan2(-t1[1], t1[0]),
                    pitch: Math.atan2(Math.sqrt(e1[0] * e1[0] + e1[1] * e1[1]), -e1[2])
                };
            }
            setPitchBearing(e1, t1) {
                this._orientation = pA(e1, t1), fA(this._transform, this._orientation);
            }
            forward() {
                const e1 = At(this._transform, 2);
                return [
                    -e1[0],
                    -e1[1],
                    -e1[2]
                ];
            }
            up() {
                const e1 = At(this._transform, 1);
                return [
                    -e1[0],
                    -e1[1],
                    -e1[2]
                ];
            }
            right() {
                const e1 = At(this._transform, 0);
                return [
                    e1[0],
                    e1[1],
                    e1[2]
                ];
            }
            getCameraToWorld(e1, t1) {
                const i = new Float64Array(16);
                return p(i, this.getWorldToCamera(e1, t1)), i;
            }
            getCameraToWorldMercator() {
                return this._transform;
            }
            getWorldToCameraPosition(e1, t1, i) {
                const n = this.position;
                N(n, n, -e1);
                const r = new Float64Array(16);
                return w(r, [
                    i,
                    i,
                    i
                ]), m(r, r, n), r[10] *= t1, r;
            }
            getWorldToCamera(e1, t1) {
                const i = new Float64Array(16), n = new Float64Array(4), r = this.position;
                var o, a;
                return (o = n)[0] = -(a = this._orientation)[0], o[1] = -a[1], o[2] = -a[2], o[3] = a[3], N(r, r, -e1), M(i, n), m(i, i, r), i[1] *= -1, i[5] *= -1, i[9] *= -1, i[13] *= -1, i[8] *= t1, i[9] *= t1, i[10] *= t1, i[11] *= t1, i;
            }
            getCameraToClipPerspective(e1, t1, i, n) {
                const r = new Float64Array(16);
                return S(r, e1, t1, i, n), r;
            }
            getCameraToClipOrthographic(e1, t1, i, n, r, o) {
                const a = new Float64Array(16);
                return T(a, e1, t1, i, n, r, o), a;
            }
            getDistanceToElevation(e1, t1 = !1) {
                const i = 0 === e1 ? 0 : cc(e1, t1 ? fr(this.position[1]) : this.position[1]), n = this.forward();
                return (i - this.position[2]) / n[2];
            }
            clone() {
                return new gA([
                    ...this.position
                ], [
                    ...this.orientation
                ]);
            }
        }
        const yA = Math.tan(85 * Math.PI / 180);
        function xA(e1, t1, i, n, r, a, s) {
            const l = c();
            if (i) {
                if ("globe" === a.name) {
                    const e1 = function(e1, t1) {
                        const { x: i, y: n } = e1.point, r = lp(i, n, e1.worldSize / e1._pixelsPerMercatorPixel, 0, 0);
                        return _(r, r, op(Xf(t1)));
                    }(r, t1);
                    _(l, l, e1);
                } else {
                    const e1 = o([], s);
                    l[0] = e1[0], l[1] = e1[1], l[4] = e1[2], l[5] = e1[3], n || v(l, l, r.angle);
                }
            } else _(l, r.labelPlaneMatrix, e1);
            return l;
        }
        function vA(e1, t1, i, n) {
            const r = [
                e1,
                t1,
                i,
                1
            ];
            i ? se(r, r, n) : d_(r, r, n);
            const o = r[3];
            return r[0] /= o, r[1] /= o, r[2] /= o, r;
        }
        function bA(e1, t1) {
            return Math.min(.5 + e1 / t1 * .5, 1.5);
        }
        function wA(e1, t1) {
            const i = e1[0] / e1[3], n = e1[1] / e1[3];
            return i >= -t1[0] && i <= t1[0] && n >= -t1[1] && n <= t1[1];
        }
        function AA(e1, t1, i, n, r, o, a, s, l, c, u, h, d, f, p, _, m, g) {
            const { lineStartIndex: y, glyphStartIndex: x, segment: v } = s, b = x + s.numGlyphs, w = y + s.lineLength, A = t1.getoffsetX(x), E = t1.getoffsetX(b - 1), I = zA(e1 * A, i, n, r, o, a, v, y, w, l, c, u, h, d, !0, f, p, _, m, g);
            if (!I) return null;
            const M = zA(e1 * E, i, n, r, o, a, v, y, w, l, c, u, h, d, !0, f, p, _, m, g);
            return M ? {
                first: I,
                last: M
            } : null;
        }
        function EA(e1, t1, i, n) {
            return e1 === cf.horizontal && Math.abs(n) > Math.abs(i) ? {
                useVertical: !0
            } : e1 === cf.vertical ? n > 0 ? {
                needsFlipping: !0
            } : null : 0 !== t1 && function(e1, t1) {
                return 0 === e1 || Math.abs(t1 / e1) > yA;
            }(i, n) ? 1 === t1 ? {
                needsFlipping: !0
            } : null : i < 0 ? {
                needsFlipping: !0
            } : null;
        }
        function IA(e1, t1, i, n, r, o, a, s, l, c, u, h, d, f, p, _, m, g, y, x, v) {
            const b = t1 / 24, w = e1.lineOffsetX * b, A = e1.lineOffsetY * b, { lineStartIndex: E, glyphStartIndex: I, numGlyphs: M, segment: S, writingMode: T, flipState: z } = e1, R = E + e1.lineLength, P = (e1)=>{
                if (u) {
                    const [t1, i, n] = e1.up, r = c.length;
                    Fm(u, r + 0, t1, i, n), Fm(u, r + 1, t1, i, n), Fm(u, r + 2, t1, i, n), Fm(u, r + 3, t1, i, n);
                }
                const [t1, i, n] = e1.point;
                Cm(c, t1, i, n, e1.angle);
            };
            if (M > 1) {
                const t1 = AA(b, s, w, A, i, h, d, e1, l, o, f, _, !1, m, g, y, x, v);
                if (!t1) return {
                    notEnoughRoom: !0
                };
                if (n && !i) {
                    let [i, n, r] = t1.first.point, [o, s, l] = t1.last.point;
                    [i, n] = vA(i, n, r, a), [o, s] = vA(o, s, l, a);
                    const c = EA(T, z, (o - i) * p, s - n);
                    if (e1.flipState = c && c.needsFlipping ? 1 : 2, c) return c;
                }
                P(t1.first);
                for(let e1 = I + 1; e1 < I + M - 1; e1++){
                    const t1 = zA(b * s.getoffsetX(e1), w, A, i, h, d, S, E, R, l, o, f, _, !1, !1, m, g, y, x, v);
                    if (!t1) return c.length -= 4 * (e1 - I), {
                        notEnoughRoom: !0
                    };
                    P(t1);
                }
                P(t1.last);
            } else {
                if (n && !i) {
                    const t1 = vA(d.x, d.y, 0, r), i = E + S + 1, n = new Re(l.getx(i), l.gety(i)), o = vA(n.x, n.y, 0, r), a = o[3] > 0 ? o : TA(d, n, t1, 1, r, void 0, m, g.canonical), s = EA(T, z, (a[0] - t1[0]) * p, a[1] - t1[1]);
                    if (e1.flipState = s && s.needsFlipping ? 1 : 2, s) return s;
                }
                const t1 = zA(b * s.getoffsetX(I), w, A, i, h, d, S, E, R, l, o, f, _, !1, !1, m, g, y, x, v);
                if (!t1) return {
                    notEnoughRoom: !0
                };
                P(t1);
            }
            return {};
        }
        function MA(e1, t1, i) {
            const n = 1 << t1.z;
            let r = (e1.x / Sr + t1.x) / n - i.mercCenter[0];
            const o = (e1.y / Sr + t1.y) / n - i.mercCenter[1];
            r -= Math.round(r);
            const a = [
                r * Sr,
                o * Sr,
                Sr / (2 * Math.PI),
                1
            ];
            return se(a, a, i.invMatrix), [
                a[0],
                a[1],
                a[2]
            ];
        }
        function SA(e1, t1, i, n, r, o) {
            let { x: a, y: s, z: l } = n.projectTilePoint(e1.x, e1.y, t1);
            if (o) {
                const [i, n, r] = MA(e1, t1, o);
                a += (i - a) * o.t, s += (n - s) * o.t, l += (r - l) * o.t;
            }
            if (!r) return vA(a, s, l, i);
            const [c, u, h] = r.getElevation(e1, r.elevation, r.elevationFeature);
            return vA(a + c, s + u, l + h, i);
        }
        function TA(e1, t1, i, n, r, o, a, s, l) {
            const c = SA(e1.sub(t1)._unit()._add(e1), s, r, a, o, l);
            return ee(c, i, c), $(c, c), k(c, i, c, n);
        }
        function zA(e1, t1, i, n, r, o, a, s, l, c, u, h, d, f, p, _, m, g, y, x) {
            const v = n ? e1 - t1 : e1 + t1;
            let b = v > 0 ? 1 : -1, w = 0;
            n && (b *= -1, w = Math.PI), b < 0 && (w += Math.PI);
            let A = s + a + (b > 0 ? 0 : 1) | 0, E = r, I = r, M = 0, S = 0;
            const T = Math.abs(v), z = [], R = [];
            let P = o, D = P, F = K([]);
            const C = ()=>TA(D, P, I, T - M + 1, u, d, _, m.canonical, x);
            for(; M + S <= T;){
                if (A += b, A < s || A >= l) return null;
                if (I = E, D = P, z.push(I), f && R.push(D), P = new Re(c.getx(A), c.gety(A)), E = h[A], !E) {
                    const e1 = SA(P, m.canonical, u, _, d, x);
                    E = e1[3] > 0 ? h[A] = e1 : C();
                }
                M += S;
                const e1 = ee([], E, I), t1 = U(I, E);
                if (i && t1 > 0 && S > 0 && Z(F, e1) / (S * t1) < y) return null;
                S = t1, F = e1;
            }
            p && d && (h[A] && (E = C(), S = U(I, E), F = ee([], E, I)), h[A] = E);
            const O = (T - M) / S, L = P.sub(D)._mult(O)._add(D), B = k([], I, F, O);
            let V = [
                0,
                0,
                1
            ], N = F[0], j = F[1];
            if (g && (V = _.upVector(m.canonical, L.x, L.y), 0 !== V[0] || 0 !== V[1] || 1 !== V[2])) {
                const e1 = [
                    V[2],
                    0,
                    -V[0]
                ], t1 = W([], V, e1);
                $(e1, e1), $(t1, t1), N = Z(F, e1), j = Z(F, t1);
            }
            if (i) {
                const e1 = W([], V, F);
                $(e1, e1), k(B, B, e1, i * b);
            }
            const G = w + Math.atan2(j, N);
            return z.push(B), f && R.push(L), {
                point: B,
                angle: G,
                path: z,
                tilePath: R,
                up: V
            };
        }
        function RA(e1, t1) {
            const i = t1.length, n = i + 4 * e1;
            t1.resize(n), t1.float32.fill(-1 / 0, 4 * i, 4 * n);
        }
        const PA = 15;
        class DA {
            constructor(e1, t1, i, n, r, o, a){
                this.tileSize = 512, this._renderWorldCopies = void 0 === r || r, this._minZoom = e1 || 0, this._maxZoom = t1 || 22, this._minPitch = i ?? 0, this._maxPitch = n ?? 60, this.setProjection(o), this.setMaxBounds(a), this.width = 0, this.height = 0, this._center = new ac(0, 0), this.zoom = 0, this.angle = 0, this._fov = .6435011087932844, this._pitch = 0, this._nearZ = 0, this._farZ = 0, this._nearClipOffset = 0, this._unmodified = !0, this._edgeInsets = new dA, this._frustumCache = new Map, this._posMatrixCache = new Map, this._projMatrixCache = new Map, this._alignedProjMatrixCache = new Map, this._pixelsToTileUnitsCache = new Map, this._fogTileMatrixCache = new Map, this._expandedProjMatrixCache = new Map, this._distanceTileDataCache = new Map, this._camera = new gA, this._centerAltitude = 0, this._averageElevation = 0, this.cameraElevationReference = "ground", this._pixelsPerMercatorPixel = 1, this.globeRadius = 0, this.globeCenterInViewSpace = [
                    0,
                    0,
                    0
                ], this._tileCoverLift = 0, this.freezeTileCoverage = !1, this._horizonShift = .1, this._orthographicProjectionAtLowPitch = !1, this._allowWorldUnderZoom = !1, this.mercatorMatrix = new Float64Array(16), this.mercatorFogMatrix = new Float32Array(16), this.invProjMatrix = new Float64Array(16), this._cameraToClip = new Float64Array(16), this._worldToCamera = new Float64Array(16), this._expandedFarZProjMatrixBuf = new Float64Array(16), this.expandedFarZProjMatrix = this._expandedFarZProjMatrixBuf, this.starsProjMatrix = new Float32Array(16), this.skyboxMatrix = new Float32Array(16), this._mat4Scratch = new Float64Array(16), this.alignedProjMatrix = new Float64Array(16), this.labelPlaneMatrix = new Float32Array(16), this.glCoordMatrix = new Float32Array(16), this.pixelMatrix = new Float64Array(16), this.pixelMatrixInverse = new Float64Array(16);
            }
            clone() {
                const e1 = new DA(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies, this.getProjection(), this.maxBounds);
                return e1._elevation = this._elevation, e1._centerAltitude = this._centerAltitude, e1._centerAltitudeValidForExaggeration = this._centerAltitudeValidForExaggeration, e1.tileSize = this.tileSize, e1.mercatorFromTransition = this.mercatorFromTransition, e1.width = this.width, e1.height = this.height, e1.cameraElevationReference = this.cameraElevationReference, e1._center = this._center, e1._setZoom(this.zoom), e1._seaLevelZoom = this._seaLevelZoom, e1.angle = this.angle, e1._fov = this._fov, e1._pitch = this._pitch, e1._nearZ = this._nearZ, e1._farZ = this._farZ, e1._nearClipOffset = this._nearClipOffset, e1._averageElevation = this._averageElevation, e1._orthographicProjectionAtLowPitch = this._orthographicProjectionAtLowPitch, e1._unmodified = this._unmodified, e1._edgeInsets = this._edgeInsets.clone(), e1._camera = this._camera.clone(), e1._calcMatrices(), e1.freezeTileCoverage = this.freezeTileCoverage, e1.frustumCorners = this.frustumCorners, e1._allowWorldUnderZoom = this._allowWorldUnderZoom, e1;
            }
            get isOrthographic() {
                return "globe" !== this.projection.name && this._orthographicProjectionAtLowPitch && this.pitch < PA;
            }
            get elevation() {
                return this._elevation;
            }
            set elevation(e1) {
                this._elevation !== e1 && (this._elevation = e1, this._updateCameraOnTerrain(), this._calcMatrices());
            }
            get nearClipOffset() {
                return this._nearClipOffset;
            }
            set nearClipOffset(e1) {
                this._nearClipOffset = e1, this._calcMatrices();
            }
            get depthOcclusionForSymbolsAndCircles() {
                return "globe" !== this.projection.name && !this.isOrthographic;
            }
            updateElevation(e1, t1 = !1) {
                const i = this._elevation && this._elevation.exaggeration() !== this._centerAltitudeValidForExaggeration;
                (null == this._seaLevelZoom || i) && this._updateCameraOnTerrain(), (e1 || i) && this._constrainCamera(t1), this._calcMatrices();
            }
            getProjection() {
                return rt(this.projection, [
                    "name",
                    "center",
                    "parallels"
                ]);
            }
            setProjection(e1) {
                this.projectionOptions = e1 || {
                    name: "mercator"
                };
                const t1 = this.projection ? this.getProjection() : void 0;
                this.projection = Zp(this.projectionOptions);
                const i = !Pe(t1, this.getProjection());
                return i && this._calcMatrices(), this.mercatorFromTransition = !1, i;
            }
            setOrthographicProjectionAtLowPitch(e1) {
                return this._orthographicProjectionAtLowPitch !== e1 && (this._orthographicProjectionAtLowPitch = e1, this._calcMatrices(), !0);
            }
            setMercatorFromTransition() {
                const e1 = this.projection.name;
                this.mercatorFromTransition = !0, this.projectionOptions = {
                    name: "mercator"
                }, this.projection = Zp({
                    name: "mercator"
                });
                const t1 = e1 !== this.projection.name;
                return t1 && this._calcMatrices(), t1;
            }
            get minZoom() {
                return this._minZoom;
            }
            set minZoom(e1) {
                this._minZoom !== e1 && (this._minZoom = e1, this.zoom = Math.max(this.zoom, e1));
            }
            get maxZoom() {
                return this._maxZoom;
            }
            set maxZoom(e1) {
                this._maxZoom !== e1 && (this._maxZoom = e1, this.zoom = Math.min(this.zoom, e1));
            }
            get minPitch() {
                return this._minPitch;
            }
            set minPitch(e1) {
                this._minPitch !== e1 && (this._minPitch = e1, this.pitch = Math.max(this.pitch, e1));
            }
            get maxPitch() {
                return this._maxPitch;
            }
            set maxPitch(e1) {
                this._maxPitch !== e1 && (this._maxPitch = e1, this.pitch = Math.min(this.pitch, e1));
            }
            get renderWorldCopies() {
                return this._renderWorldCopies && !0 === this.projection.supportsWorldCopies;
            }
            set renderWorldCopies(e1) {
                void 0 === e1 ? e1 = !0 : null === e1 && (e1 = !1), this._renderWorldCopies = e1;
            }
            get worldSize() {
                return this.tileSize * this.scale;
            }
            get cameraWorldSizeForFog() {
                const e1 = Math.max(this._camera.getDistanceToElevation(this._averageElevation), Number.EPSILON);
                return this._worldSizeFromZoom(this._zoomFromMercatorZ(e1));
            }
            get cameraWorldSize() {
                const e1 = Math.max(this._camera.getDistanceToElevation(this._averageElevation, !0), Number.EPSILON);
                return this._worldSizeFromZoom(this._zoomFromMercatorZ(e1));
            }
            get pixelsPerMeter() {
                return this.projection.pixelsPerMeter(this.center.lat, this.worldSize);
            }
            get cameraPixelsPerMeter() {
                return cc(1, this.center.lat) * this.cameraWorldSizeForFog;
            }
            get centerOffset() {
                return this.centerPoint._sub(this.size._div(2));
            }
            get size() {
                return new Re(this.width, this.height);
            }
            get bearing() {
                return nt(this.rotation, -180, 180);
            }
            set bearing(e1) {
                this.rotation = e1;
            }
            get rotation() {
                return -this.angle / Math.PI * 180;
            }
            set rotation(e1) {
                const t1 = -e1 * Math.PI / 180;
                if (this.angle === t1) return;
                this._unmodified = !1, this.angle = t1, this._calcMatrices();
                const i = Math.sin(this.angle), n = Math.cos(this.angle);
                this.rotationMatrix = [
                    n,
                    i,
                    -i,
                    n
                ];
            }
            get pitch() {
                return this._pitch / Math.PI * 180;
            }
            set pitch(e1) {
                const t1 = tt(e1, this.minPitch, this.maxPitch) / 180 * Math.PI;
                this._pitch !== t1 && (this._unmodified = !1, this._pitch = t1, this._calcMatrices());
            }
            get aspect() {
                return this.width / this.height;
            }
            get fov() {
                return this._fov / Math.PI * 180;
            }
            set fov(e1) {
                e1 = Math.max(.01, Math.min(60, e1)), this._fov !== e1 && (this._unmodified = !1, this._fov = Ye(e1), this._calcMatrices());
            }
            get fovX() {
                return this._fov;
            }
            get fovY() {
                const e1 = 1 / Math.tan(.5 * this.fovX);
                return 2 * Math.atan(1 / this.aspect / e1);
            }
            get horizontalFov() {
                return Je(2 * Math.atan(Math.tan(.5 * this._fov) * this.aspect));
            }
            get averageElevation() {
                return this._averageElevation;
            }
            set averageElevation(e1) {
                this._averageElevation = e1, this._calcFogMatrices(), this._distanceTileDataCache.clear();
            }
            get zoom() {
                return this._zoom;
            }
            set zoom(e1) {
                const t1 = Math.min(Math.max(e1, this.minZoom), this.maxZoom);
                this._zoom !== t1 && (this._unmodified = !1, this._setZoom(t1), this._updateSeaLevelZoom(), this._constrain(), this._calcMatrices());
            }
            _setZoom(e1) {
                this._zoom = e1, this.scale = this.zoomScale(e1), this.tileZoom = Math.floor(e1), this.zoomFraction = e1 - this.tileZoom;
            }
            get tileCoverLift() {
                return this._tileCoverLift;
            }
            set tileCoverLift(e1) {
                this._tileCoverLift !== e1 && (this._tileCoverLift = e1);
            }
            _updateCameraOnTerrain() {
                const e1 = this.elevation ? this.elevation.getAtPoint(this.locationCoordinate(this.center), Number.NEGATIVE_INFINITY) : Number.NEGATIVE_INFINITY, t1 = this.elevation && e1 === Number.NEGATIVE_INFINITY && this.elevation.visibleDemTiles.length > 0 && this.elevation.exaggeration() > 0 && this._centerAltitudeValidForExaggeration;
                if (!this._elevation || e1 === Number.NEGATIVE_INFINITY && (!t1 || !this._centerAltitude)) return this._centerAltitude = 0, this._seaLevelZoom = null, void (this._centerAltitudeValidForExaggeration = void 0);
                const i = this._elevation;
                t1 || this._centerAltitude && this._centerAltitudeValidForExaggeration && i.exaggeration() && this._centerAltitudeValidForExaggeration !== i.exaggeration() ? (this._centerAltitude = this._centerAltitude / this._centerAltitudeValidForExaggeration * i.exaggeration(), this._centerAltitudeValidForExaggeration = i.exaggeration()) : (this._centerAltitude = e1 || 0, this._centerAltitudeValidForExaggeration = i.exaggeration()), this._updateSeaLevelZoom();
            }
            _updateSeaLevelZoom() {
                if (void 0 === this._centerAltitudeValidForExaggeration) return;
                const e1 = Math.max(0, (this.pixelsPerMeter * this._centerAltitude + this.cameraToCenterDistance) / this.worldSize);
                this._seaLevelZoom = this._zoomFromMercatorZ(e1);
            }
            sampleAverageElevation() {
                if (!this._elevation) return 0;
                const e1 = this._elevation, t1 = [
                    [
                        .5,
                        .2
                    ],
                    [
                        .3,
                        .5
                    ],
                    [
                        .5,
                        .5
                    ],
                    [
                        .7,
                        .5
                    ],
                    [
                        .5,
                        .8
                    ]
                ], i = this.horizonLineFromTop();
                let n = 0, r = 0;
                for(let o = 0; o < t1.length; o++){
                    const a = new Re(t1[o][0] * this.width, i + t1[o][1] * (this.height - i)), s = e1.pointCoordinate(a);
                    if (!s) continue;
                    const l = 1 / Math.hypot(s[0] - this._camera.position[0], s[1] - this._camera.position[1]);
                    n += s[3] * l, r += l;
                }
                return 0 === r ? NaN : n / r;
            }
            get center() {
                return this._center;
            }
            set center(e1) {
                e1.lat === this._center.lat && e1.lng === this._center.lng || (this._unmodified = !1, this._center = e1, this._terrainEnabled() && ("ground" === this.cameraElevationReference ? this._updateCameraOnTerrain() : this._updateZoomFromElevation()), this._constrain(), this._calcMatrices());
            }
            _updateZoomFromElevation() {
                if (null == this._seaLevelZoom || !this._elevation) return;
                const e1 = this._seaLevelZoom, t1 = this._elevation.getAtPointOrZero(this.locationCoordinate(this.center)), i = this.pixelsPerMeter / this.worldSize * t1, n = this._mercatorZfromZoom(e1), r = this._mercatorZfromZoom(this._maxZoom), o = Math.max(n - i, r);
                this._setZoom(this._zoomFromMercatorZ(o));
            }
            get padding() {
                return this._edgeInsets.toJSON();
            }
            set padding(e1) {
                this._edgeInsets.equals(e1) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, e1, 1), this._calcMatrices());
            }
            equals(e1) {
                const t1 = this.elevation, i = e1.elevation, n = null != t1 != (null != i) || t1 && i && t1.exaggeration() !== i.exaggeration();
                return this.width === e1.width && this.height === e1.height && this.center.lng === e1.center.lng && this.center.lat === e1.center.lat && this.zoom === e1.zoom && this.bearing === e1.bearing && this.pitch === e1.pitch && this.fov === e1.fov && this.projection.name === e1.projection.name && this._edgeInsets.equals(e1.padding) && !n;
            }
            computeZoomRelativeTo(e1) {
                const t1 = this.rayIntersectionCoordinate(this.pointRayIntersection(this.centerPoint, e1.toAltitude()));
                let i;
                i = e1.z < this._camera.position[2] ? [
                    t1.x,
                    t1.y,
                    t1.z
                ] : [
                    e1.x,
                    e1.y,
                    e1.z
                ];
                const n = P(ee([], this._camera.position, i));
                return tt(this._zoomFromMercatorZ(n), this._minZoom, this._maxZoom);
            }
            setFreeCameraOptions(e1) {
                if (!this.height) return;
                if (!e1.position && !e1.orientation) return;
                this._updateCameraState();
                let t1 = !1;
                if (e1.orientation && !function(e1, t1) {
                    return e1[0] === t1[0] && e1[1] === t1[1] && e1[2] === t1[2] && e1[3] === t1[3];
                }(e1.orientation, this._camera.orientation) && (t1 = this._setCameraOrientation(e1.orientation)), e1.position) {
                    const i = [
                        e1.position.x,
                        e1.position.y,
                        e1.position.z
                    ];
                    Q(i, this._camera.position) || (this._setCameraPosition(i), t1 = !0);
                }
                t1 && (this._updateStateFromCamera(), this.recenterOnTerrain());
            }
            getFreeCameraOptions() {
                this._updateCameraState();
                const e1 = this._camera.position, t1 = new mA;
                return t1.position = new mc(e1[0], e1[1], e1[2]), t1.orientation = this._camera.orientation, t1._elevation = this.elevation, t1._renderWorldCopies = this.renderWorldCopies, t1;
            }
            _setCameraOrientation(e1) {
                if (!function(e1) {
                    var t1 = e1[0], i = e1[1], n = e1[2], r = e1[3];
                    return Math.sqrt(t1 * t1 + i * i + n * n + r * r);
                }(e1)) return !1;
                ge(e1, e1);
                const t1 = J([], [
                    0,
                    0,
                    -1
                ], e1), i = J([], [
                    0,
                    -1,
                    0
                ], e1);
                if (i[2] < 0) return !1;
                const n = _A(t1, i);
                return !!n && (this._camera.orientation = n, !0);
            }
            _setCameraPosition(e1) {
                const t1 = this.zoomScale(this.minZoom) * this.tileSize, i = this.zoomScale(this.maxZoom) * this.tileSize, n = this.cameraToCenterDistance;
                e1[2] = tt(e1[2], n / i, n / t1), this._camera.position = e1;
            }
            get centerPoint() {
                return this._edgeInsets.getCenter(this.width, this.height);
            }
            get fovAboveCenter() {
                return this._fov * (.5 + this.centerOffset.y / this.height);
            }
            isPaddingEqual(e1) {
                return this._edgeInsets.equals(e1);
            }
            interpolatePadding(e1, t1, i) {
                this._unmodified = !1, this._edgeInsets.interpolate(e1, t1, i), this._constrain(), this._calcMatrices();
            }
            coveringZoomLevel(e1) {
                const t1 = (e1.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / e1.tileSize));
                return Math.max(0, t1);
            }
            getVisibleUnwrappedCoordinates(e1) {
                const t1 = [
                    new yp(0, e1)
                ];
                if (this.renderWorldCopies) {
                    const i = this.pointCoordinate(new Re(0, 0)), n = this.pointCoordinate(new Re(this.width, 0)), r = this.pointCoordinate(new Re(this.width, this.height)), o = this.pointCoordinate(new Re(0, this.height)), a = Math.floor(Math.min(i.x, n.x, r.x, o.x)), s = Math.floor(Math.max(i.x, n.x, r.x, o.x)), l = 1;
                    for(let i = a - l; i <= s + l; i++)0 !== i && t1.push(new yp(i, e1));
                }
                return t1;
            }
            isLODDisabled(e1) {
                return (!e1 || this.pitch <= 60) && this._edgeInsets.top <= this._edgeInsets.bottom && !this._elevation && !this.projection.isReprojectedInTileSpace;
            }
            extendTileCover(e1, t1, i, n) {
                let r = [];
                const o = null != i, a = !o;
                if (a && this.zoom < t1) return r;
                if (o && 0 === i[0] && 0 === i[1]) return r;
                const s = new Set, l = (e1, t1, i, n, o)=>{
                    const a = vp(t1, e1, i, n, o);
                    s.has(a) || (r.push(new xp(e1, t1, i, n, o)), s.add(a));
                };
                for(let r = 0; r < e1.length; r++){
                    const s = e1[r];
                    if (a && s.canonical.z !== t1) continue;
                    if (o && void 0 !== n && n > s.canonical.z) continue;
                    const c = s.canonical, u = s.overscaledZ, h = s.wrap, d = 1 << c.z, f = c.x + 1 < d, p = c.x > 0, _ = c.y + 1 < d, m = c.y > 0, g = s.wrap - (p ? 0 : 1), y = s.wrap + (f ? 0 : 1), x = p ? c.x - 1 : d - 1, v = f ? c.x + 1 : 0;
                    if (o) i[0] < 0 ? (l(u, y, c.z, v, c.y), i[1] < 0 && _ && (l(u, h, c.z, c.x, c.y + 1), l(u, y, c.z, v, c.y + 1)), i[1] > 0 && m && (l(u, h, c.z, c.x, c.y - 1), l(u, y, c.z, v, c.y - 1))) : i[0] > 0 ? (l(u, g, c.z, x, c.y), i[1] < 0 && _ && (l(u, h, c.z, c.x, c.y + 1), l(u, g, c.z, x, c.y + 1)), i[1] > 0 && m && (l(u, h, c.z, c.x, c.y - 1), l(u, g, c.z, x, c.y - 1))) : i[1] < 0 && _ ? l(u, h, c.z, c.x, c.y + 1) : m && l(u, h, c.z, c.x, c.y - 1);
                    else {
                        const e1 = s.visibleQuadrants;
                        1 & e1 && (l(u, g, c.z, x, c.y), m && (l(u, h, c.z, c.x, c.y - 1), l(u, g, c.z, x, c.y - 1))), 2 & e1 && (l(u, y, c.z, v, c.y), m && (l(u, h, c.z, c.x, c.y - 1), l(u, y, c.z, v, c.y - 1))), 4 & e1 && (l(u, g, c.z, x, c.y), _ && (l(u, h, c.z, c.x, c.y + 1), l(u, g, c.z, x, c.y + 1))), 8 & e1 && (l(u, y, c.z, v, c.y), _ && (l(u, h, c.z, c.x, c.y + 1), l(u, y, c.z, v, c.y + 1)));
                    }
                }
                const c = [];
                for (const e1 of r)r.some((t1)=>e1.isChildOf(t1)) || c.push(e1);
                if (r = c.filter((i)=>!e1.some((e1)=>!!(i.overscaledZ < t1 && e1.isChildOf(i)) || i.equals(e1) || i.isChildOf(e1))), a) {
                    const e1 = 1 << t1, i = "globe" === this.projection.name ? this._camera.mercatorPosition : this.pointCoordinate(this.getCameraPoint()), n = [
                        e1 * i.x,
                        e1 * i.y
                    ], o = 4, a = o * o;
                    r = r.filter((e1)=>{
                        const t1 = e1.canonical.x + .5 - n[0], i = e1.canonical.y + .5 - n[1];
                        return t1 * t1 + i * i < a;
                    });
                }
                return r;
            }
            extendTileCoverToNearPlane(e1, t1, i) {
                const n = [], r = new Set;
                for (const t1 of e1)r.add(t1.key);
                const o = (e1, t1, i, o, a)=>{
                    const s = vp(t1, e1, i, o, a);
                    r.has(s) || (n.push(new xp(e1, t1, i, o, a)), r.add(s));
                }, a = e1.reduce((e1, t1)=>Math.max(e1, t1.overscaledZ), i), s = 1 << i, l = [
                    new Re(0, 0),
                    new Re(Sr, 0),
                    new Re(Sr, Sr),
                    new Re(0, Sr)
                ], c = new Re(0, 0), u = new Re(0, 0), h = (e1, t1)=>{
                    const n = Math.floor(e1[0]), r = Math.floor(e1[1]), h = (e1[0] - n) * Sr, d = (e1[1] - r) * Sr, f = Math.floor(t1[0]), p = Math.floor(t1[1]), _ = (t1[0] - f) * Sr, m = (t1[1] - p) * Sr;
                    for(let e1 = -1; e1 <= 1; e1++){
                        const t1 = n + e1;
                        if (!(t1 < 0 || t1 >= s)) {
                            c.x = h - e1 * Sr, u.x = _ - (t1 - f) * Sr;
                            for(let e1 = -1; e1 <= 1; e1++){
                                const n = r + e1;
                                c.y = d - e1 * Sr, u.y = m - (n - p) * Sr, hd(c, u, l) && o(a, 0, i, t1, n);
                            }
                        }
                    }
                }, d = t1.points, f = d[3], p = d[2], _ = this._projectToGround(f, d[7]), m = this._projectToGround(p, d[6]);
                return h(f, _), h(p, m), n;
            }
            _projectToGround(e1, t1) {
                return q(R(), e1, t1, e1[2] / (e1[2] - t1[2]));
            }
            _projectToZ(e1, t1, i) {
                const n = e1[2] - t1[2];
                var o, a;
                return Math.abs(n) < 1e-6 ? (o = e1, (a = new r(3))[0] = o[0], a[1] = o[1], a[2] = o[2], a) : q(R(), e1, t1, (e1[2] - i) / n);
            }
            extendTileCoverForTunnels(e1, t1, i, n) {
                if (i < 18) return [];
                const r = t1.points, o = r[0], a = r[1], s = r[4], l = r[5];
                if (s[2] >= 0 && l[2] >= 0 || o[2] <= 0 || a[2] <= 0) return [];
                const c = s[2] < 0 ? this._projectToZ(o, s, 0) : s, u = l[2] < 0 ? this._projectToZ(a, l, 0) : l, h = -n, d = s[2] < h ? this._projectToZ(o, s, h) : s, f = l[2] < h ? this._projectToZ(a, l, h) : l, p = this._findExtensionTilesInQuad(e1, i, [
                    f,
                    d,
                    u,
                    c
                ], [
                    .5 * (c[0] + u[0]),
                    .5 * (c[1] + u[1])
                ]);
                return p.length > 3 && (p.length = 3), p;
            }
            _findExtensionTilesInQuad(e1, t1, i, n) {
                const r = [], o = new Set;
                for (const t1 of e1)o.add(t1.key);
                const a = e1.reduce((e1, t1)=>Math.max(e1, t1.overscaledZ), t1), s = 1 << t1, l = [
                    new Re(i[0][0], i[0][1]),
                    new Re(i[1][0], i[1][1]),
                    new Re(i[3][0], i[3][1]),
                    new Re(i[2][0], i[2][1]),
                    new Re(i[0][0], i[0][1])
                ], c = i[0][0], u = i[1][0], h = i[2][0], d = i[3][0], f = i[0][1], p = i[1][1], _ = i[2][1], m = i[3][1], g = Math.max(0, Math.floor(Math.min(c, u, h, d))), y = Math.min(s - 1, Math.ceil(Math.max(c, u, h, d)) - 1), x = Math.max(0, Math.floor(Math.min(f, p, _, m))), v = Math.min(s - 1, Math.ceil(Math.max(f, p, _, m)) - 1);
                for(let e1 = x; e1 <= v; e1++)for(let i = g; i <= y; i++){
                    if (!ud(l, i, e1, i + 1, e1 + 1)) continue;
                    const n = vp(0, a, t1, i, e1);
                    o.has(n) || (r.push(new xp(a, 0, t1, i, e1)), o.add(n));
                }
                const b = n[0], w = n[1];
                return r.sort((e1, t1)=>{
                    const i = e1.canonical.x + .5 - b, n = e1.canonical.y + .5 - w, r = t1.canonical.x + .5 - b, o = t1.canonical.y + .5 - w;
                    return i * i + n * n - (r * r + o * o) || e1.canonical.x - t1.canonical.x || e1.canonical.y - t1.canonical.y;
                }), r;
            }
            coveringTiles(e1) {
                let t1 = this.coveringZoomLevel(e1);
                const i = t1, n = this.elevation && this.elevation.exaggeration(), r = n && !e1.isTerrainDEM, o = "mercator" === this.projection.name;
                if (void 0 !== e1.minzoom && t1 < e1.minzoom) return [];
                void 0 !== e1.maxzoom && t1 > e1.maxzoom && (t1 = e1.maxzoom);
                const a = this.locationCoordinate(this.center), s = this.center.lat, l = 1 << t1, c = [
                    l * a.x,
                    l * a.y,
                    0
                ], u = "globe" === this.projection.name, h = !u, d = this.getFrustum(t1), f = u ? this._camera.mercatorPosition : this.pointCoordinate(this.getCameraPoint()), p = l * cc(1, this.center.lat), _ = this._camera.position[2] / cc(1, this.center.lat), m = [
                    l * f.x,
                    l * f.y,
                    _ * (h ? 1 : p)
                ], g = u || n, y = this._camera.forward(), x = this.cameraToCenterDistance / e1.tileSize * (e1.roundZoom ? 1 : .502), v = this.isLODDisabled(!0) ? t1 : 0;
                let b;
                if (this._elevation && e1.isTerrainDEM) b = 1e4 * this._elevation.exaggeration();
                else if (this._elevation) {
                    const e1 = this._elevation.getMinMaxForVisibleTiles();
                    b = e1 ? e1.max : this._centerAltitude;
                } else b = this._centerAltitude;
                const w = e1.isTerrainDEM ? -b : this._elevation ? this._elevation.getMinElevationBelowMSL() : 0, A = this.projection.isReprojectedInTileSpace ? rx(this) : 1, E = (e1)=>{
                    const t1 = 1 / 4e4, i = new mc(e1.x + t1, e1.y, e1.z), n = new mc(e1.x, e1.y + t1, e1.z), r = e1.toLngLat(), o = i.toLngLat(), a = n.toLngLat(), s = this.locationCoordinate(r), l = this.locationCoordinate(o), c = this.locationCoordinate(a), u = Math.hypot(l.x - s.x, l.y - s.y), h = Math.hypot(c.x - s.x, c.y - s.y);
                    return Math.sqrt(u * h) * A / t1;
                }, I = (e1)=>{
                    const t1 = b, i = w;
                    return {
                        aabb: Ep(this, l, 0, 0, 0, e1, i, t1, this.projection),
                        zoom: 0,
                        x: 0,
                        y: 0,
                        minZ: i,
                        maxZ: t1,
                        wrap: e1,
                        fullyVisible: !1
                    };
                }, M = [];
                let S = [];
                const T = t1, z = e1.reparseOverscaled ? i : t1, R = (_ - this._centerAltitude) * p, P = (e1)=>{
                    if (!this._elevation || !e1.tileID || !o) return;
                    const t1 = this._elevation.getMinMaxForTile(e1.tileID), i = e1.aabb;
                    t1 ? (i.min[2] = t1.min, i.max[2] = t1.max, i.center[2] = (i.min[2] + i.max[2]) / 2) : (e1.shouldSplit = F(e1), e1.shouldSplit || (i.min[2] = i.max[2] = i.center[2] = this._centerAltitude));
                }, D = (e1, t1)=>{
                    if (.707 * t1 < e1) return 1;
                    const i = t1 / e1;
                    return i / (1.4144271570014144 + (Math.pow(1.1, i - 1.4144271570014144 + 1) - 1) / (1.1 - 1) - 1);
                }, F = (e1)=>{
                    if (e1.zoom < v) return !0;
                    if (e1.zoom === T) return !1;
                    if (null != e1.shouldSplit) return e1.shouldSplit;
                    const t1 = e1.aabb.distanceX(m), n = e1.aabb.distanceY(m);
                    let a = R, l = 1;
                    if (u) {
                        a = e1.aabb.distanceZ(m);
                        const t1 = Math.pow(2, e1.zoom), i = fr((e1.y + 1) / t1), n = fr(e1.y / t1), r = Math.min(Math.max(s, i), n), o = lc(r) / lc(s);
                        if (l = r === s ? 1 / Math.max(1, this._mercatorScaleRatio - .3) : Math.min(1, o / this._mercatorScaleRatio), this.zoom <= 5 && e1.zoom === T - 1 && o >= .9) return !0;
                    } else if (r && (a = e1.aabb.distanceZ(m) * p), this.projection.isReprojectedInTileSpace && i <= 5) {
                        const t1 = Math.pow(2, e1.zoom), i = E(new mc((e1.x + .5) / t1, (e1.y + .5) / t1));
                        l = i > .85 ? 1 : i;
                    }
                    if (!o && !u) {
                        const i = Math.sqrt(t1 * t1 + n * n + a * a);
                        let r = (1 << T - e1.zoom) * x * l;
                        return r *= D(Math.max(a, R), i), i < r;
                    }
                    let h = Number.MAX_VALUE, d = 0;
                    const { min: f, max: _ } = e1.aabb;
                    for(let e1 = 0; e1 < 8; e1++){
                        const t1 = 3 & e1;
                        let i = (e1 >= 4 ? _[2] : f[2]) - m[2];
                        u || (i = r ? i * p : R);
                        const n = ((1 === t1 || 2 === t1 ? _[0] : f[0]) - m[0]) * y[0] + ((t1 >= 2 ? _[1] : f[1]) - m[1]) * y[1] + i * y[2];
                        n < h && (h = n, d = Math.abs(i));
                    }
                    let g = (1 << T - e1.zoom) * x * l;
                    if (g *= D(Math.max(d, R), h), h < g) return !0;
                    const b = e1.aabb.closestPoint(c);
                    return b[0] === c[0] && b[1] === c[1];
                };
                if (this.renderWorldCopies) for(let e1 = 1; e1 <= 3; e1++)M.push(I(-e1)), M.push(I(e1));
                for(M.push(I(0)); M.length > 0;){
                    const i = M.pop(), n = i.x, a = i.y;
                    let s = i.fullyVisible;
                    const h = ()=>"globe" === this.projection.name && (0 === i.y || i.y === (1 << i.zoom) - 1);
                    if (!s) {
                        let e1 = g ? i.aabb.intersects(d) : i.aabb.intersectsFlat(d);
                        if (0 === e1 && h()) {
                            const t1 = new gp(i.zoom, n, a);
                            e1 = Kf(this, l, t1, !0).intersects(d);
                        }
                        if (0 === e1) continue;
                        s = 2 === e1;
                    }
                    if (i.zoom === T || !F(i)) {
                        const r = i.zoom === T ? z : i.zoom;
                        if (e1.minzoom && e1.minzoom > r) continue;
                        let o = 0;
                        if (!s) {
                            let t1 = g ? i.aabb.intersectsPrecise(d) : i.aabb.intersectsPreciseFlat(d);
                            if (0 === t1 && h()) {
                                const e1 = new gp(i.zoom, n, a);
                                t1 = Kf(this, l, e1, !0).intersectsPrecise(d);
                            }
                            if (0 === t1) continue;
                            if (e1.calculateQuadrantVisibility) {
                                if (d.containsPoint(i.aabb.center)) o = 15;
                                else for(let e1 = 0; e1 < 4; e1++)0 !== i.aabb.quadrant(e1).intersects(d) && (o |= 1 << e1);
                            }
                        }
                        const u = c[0] - (.5 + n + (i.wrap << i.zoom)) * (1 << t1 - i.zoom), f = c[1] - .5 - a, p = i.tileID ? i.tileID : new xp(r, i.wrap, i.zoom, n, a);
                        e1.calculateQuadrantVisibility && (p.visibleQuadrants = o), S.push({
                            tileID: p,
                            distanceSq: u * u + f * f
                        });
                        continue;
                    }
                    for(let e1 = 0; e1 < 4; e1++){
                        const t1 = (n << 1) + e1 % 2, c = (a << 1) + (e1 >> 1), h = {
                            aabb: o ? i.aabb.quadrant(e1) : Ep(this, l, i.zoom + 1, t1, c, i.wrap, i.minZ, i.maxZ, this.projection),
                            zoom: i.zoom + 1,
                            x: t1,
                            y: c,
                            wrap: i.wrap,
                            fullyVisible: s,
                            tileID: void 0,
                            shouldSplit: void 0,
                            minZ: i.minZ,
                            maxZ: i.maxZ
                        };
                        r && !u && (h.tileID = new xp(i.zoom + 1 === T ? z : i.zoom + 1, i.wrap, i.zoom + 1, t1, c), P(h)), M.push(h);
                    }
                }
                if (this.fogCullDistSq) {
                    const t1 = this.fogCullDistSq, i = this.horizonLineFromTop();
                    S = S.filter((n)=>{
                        const r = [
                            0,
                            0,
                            0,
                            1
                        ], o = [
                            Sr,
                            Sr,
                            0,
                            1
                        ], a = this.calculateFogTileMatrix(n.tileID.toUnwrapped());
                        se(r, r, a), se(o, o, a);
                        const s = function(e1, t1, i) {
                            return e1[0] = Math.min(t1[0], i[0]), e1[1] = Math.min(t1[1], i[1]), e1[2] = Math.min(t1[2], i[2]), e1[3] = Math.min(t1[3], i[3]), e1;
                        }([], r, o), l = function(e1, t1, i) {
                            return e1[0] = Math.max(t1[0], i[0]), e1[1] = Math.max(t1[1], i[1]), e1[2] = Math.max(t1[2], i[2]), e1[3] = Math.max(t1[3], i[3]), e1;
                        }([], r, o), c = function(e1, t1) {
                            let i = 0;
                            for(let n = 0; n < 2; ++n){
                                const r = 0;
                                e1[n] > r && (i += (e1[n] - r) * (e1[n] - r)), t1[n] < r && (i += (r - t1[n]) * (r - t1[n]));
                            }
                            return i;
                        }(s, l);
                        if (0 === c) return !0;
                        let u = !1;
                        const h = this._elevation;
                        if (h && c > t1 && 0 !== i) {
                            const t1 = this.calculateProjMatrix(n.tileID.toUnwrapped());
                            let r;
                            e1.isTerrainDEM || (r = h.getMinMaxForTile(n.tileID)), r || (r = {
                                min: w,
                                max: b
                            });
                            const o = function(e1) {
                                const t1 = Math.round((e1 + 45 + 360) % 360 / 90) % 4;
                                return Ke[t1];
                            }(this.rotation), a = [
                                o[0] * Sr,
                                o[1] * Sr,
                                r.max
                            ];
                            X(a, a, t1), u = (1 - a[1]) * this.height * .5 < i;
                        }
                        return c < t1 || u;
                    });
                }
                const C = S.sort((e1, t1)=>e1.distanceSq - t1.distanceSq).map((e1)=>e1.tileID);
                return C;
            }
            resize(e1, t1) {
                this.width = e1, this.height = t1, this.pixelsToGLUnits = [
                    2 / e1,
                    -2 / t1
                ], this._constrain(), this._calcMatrices();
            }
            get unmodified() {
                return this._unmodified;
            }
            zoomScale(e1) {
                return Math.pow(2, e1);
            }
            scaleZoom(e1) {
                return Math.log2(e1);
            }
            project(e1) {
                const t1 = tt(e1.lat, -85.051129, hc), i = this.projection.project(e1.lng, t1);
                return new Re(i.x * this.worldSize, i.y * this.worldSize);
            }
            unproject(e1) {
                return this.projection.unproject(e1.x / this.worldSize, e1.y / this.worldSize);
            }
            get point() {
                return this.project(this.center);
            }
            get pointMerc() {
                return this.point._div(this.worldSize);
            }
            get pixelsPerMeterRatio() {
                return this.pixelsPerMeter / cc(1, this.center.lat) / this.worldSize;
            }
            setLocationAtPoint(e1, t1) {
                let i, n;
                const r = this.centerPoint;
                if ("globe" === this.projection.name) {
                    const e1 = this.worldSize;
                    i = (t1.x - r.x) / e1, n = (t1.y - r.y) / e1;
                } else {
                    const e1 = this.pointCoordinate(t1), o = this.pointCoordinate(r);
                    i = e1.x - o.x, n = e1.y - o.y;
                }
                const o = this.locationCoordinate(e1);
                this.setLocation(new mc(o.x - i, o.y - n));
            }
            setLocation(e1) {
                this.center = this.coordinateLocation(e1), this.projection.wrap && (this.center = this.center.wrap());
            }
            locationPoint(e1, t1) {
                return this.projection.locationPoint(this, e1, t1);
            }
            locationPoint3D(e1, t1) {
                return this.projection.locationPoint(this, e1, t1, !0);
            }
            pointLocation(e1) {
                return this.coordinateLocation(this.pointCoordinate(e1));
            }
            pointLocation3D(e1, t1) {
                return this.coordinateLocation(this.pointCoordinate3D(e1, t1));
            }
            locationCoordinate(e1, t1) {
                const i = t1 ? cc(t1, e1.lat) : void 0, n = this.projection.project(e1.lng, e1.lat);
                return new mc(n.x, n.y, i);
            }
            coordinateLocation(e1) {
                return this.projection.unproject(e1.x, e1.y);
            }
            pointRayIntersection(e1, t1) {
                const i = t1 ?? this._centerAltitude, n = [
                    e1.x,
                    e1.y,
                    0,
                    1
                ], r = [
                    e1.x,
                    e1.y,
                    1,
                    1
                ];
                se(n, n, this.pixelMatrixInverse), se(r, r, this.pixelMatrixInverse);
                const o = r[3];
                oe(n, n, 1 / n[3]), oe(r, r, 1 / o);
                const a = n[2], s = r[2];
                return {
                    p0: n,
                    p1: r,
                    t: a === s ? 0 : (i - a) / (s - a)
                };
            }
            screenPointToMercatorRay(e1) {
                const t1 = [
                    e1.x,
                    e1.y,
                    0,
                    1
                ], i = [
                    e1.x,
                    e1.y,
                    1,
                    1
                ];
                return se(t1, t1, this.pixelMatrixInverse), se(i, i, this.pixelMatrixInverse), oe(t1, t1, 1 / t1[3]), oe(i, i, 1 / i[3]), t1[2] = cc(t1[2], this._center.lat) * this.worldSize, i[2] = cc(i[2], this._center.lat) * this.worldSize, oe(t1, t1, 1 / this.worldSize), oe(i, i, 1 / this.worldSize), new Pf([
                    t1[0],
                    t1[1],
                    t1[2]
                ], $([], ee([], i, t1)));
            }
            rayIntersectionCoordinate(e1) {
                const { p0: t1, p1: i, t: n } = e1, r = cc(t1[2], this._center.lat), o = cc(i[2], this._center.lat);
                return new mc(hn(t1[0], i[0], n) / this.worldSize, hn(t1[1], i[1], n) / this.worldSize, hn(r, o, n));
            }
            pointCoordinate(e1, t1 = this._centerAltitude) {
                return this.projection.pointCoordinate(this, e1.x, e1.y, t1);
            }
            pointCoordinate3D(e1, t1) {
                if (!this.elevation) return this.pointCoordinate(e1, t1);
                let i = this.projection.pointCoordinate3D(this, e1.x, e1.y);
                if (i) return new mc(i[0], i[1], i[2]);
                let n = 0, r = this.horizonLineFromTop();
                if (e1.y > r) return this.pointCoordinate(e1, t1);
                const o = .02 * r, a = e1.clone();
                for(let e1 = 0; e1 < 10 && r - n > o; e1++){
                    a.y = hn(n, r, .66);
                    const e1 = this.projection.pointCoordinate3D(this, a.x, a.y);
                    e1 ? (r = a.y, i = e1) : n = a.y;
                }
                return i ? new mc(i[0], i[1], i[2]) : this.pointCoordinate(e1);
            }
            isPointAboveHorizon(e1) {
                return this.projection.isPointAboveHorizon(this, e1);
            }
            isPointOnSurface(e1) {
                if (e1.y < 0 || e1.y > this.height || e1.x < 0 || e1.x > this.width) return !1;
                if (this.elevation || this.zoom >= 6) return !this.isPointAboveHorizon(e1);
                const t1 = this.pointCoordinate(e1);
                return t1.y >= 0 && t1.y <= 1;
            }
            _coordinatePoint(e1, t1) {
                const i = t1 && this.elevation ? this.elevation.getAtPointOrZero(e1, this._centerAltitude) : this._centerAltitude, n = [
                    e1.x * this.worldSize,
                    e1.y * this.worldSize,
                    i + e1.toAltitude(),
                    1
                ];
                return se(n, n, this.pixelMatrix), n[3] > 0 ? new Re(n[0] / n[3], n[1] / n[3]) : new Re(Number.MAX_VALUE, Number.MAX_VALUE);
            }
            _getBoundsNonRectangular() {
                const { top: e1, left: t1 } = this._edgeInsets, i = this.height - this._edgeInsets.bottom, n = this.width - this._edgeInsets.right, r = this.pointLocation3D(new Re(t1, e1)), o = this.pointLocation3D(new Re(n, e1)), a = this.pointLocation3D(new Re(n, i)), s = this.pointLocation3D(new Re(t1, i));
                let l = Math.min(r.lng, o.lng, a.lng, s.lng), c = Math.max(r.lng, o.lng, a.lng, s.lng), u = Math.min(r.lat, o.lat, a.lat, s.lat), h = Math.max(r.lat, o.lat, a.lat, s.lat);
                const f = Math.pow(2, -this.zoom) / 16 * 270, p = "globe" === this.projection.name ? 1 : 4, m = (e1, t1, i, n, r)=>{
                    const o = (e1 + i) / 2, a = (t1 + n) / 2, s = new Re(o, a), { lng: d, lat: _ } = this.pointLocation3D(s), g = Math.max(0, l - d, u - _, d - c, _ - h);
                    l = Math.min(l, d), c = Math.max(c, d), u = Math.min(u, _), h = Math.max(h, _), (r < p || g > f) && (m(e1, t1, o, a, r + 1), m(o, a, i, n, r + 1));
                };
                if (m(t1, e1, n, e1, 1), m(n, e1, n, i, 1), m(n, i, t1, i, 1), m(t1, i, t1, e1, 1), "globe" === this.projection.name) {
                    const [e1, t1] = function(e1) {
                        const t1 = d(new Float64Array(16));
                        _(t1, e1.pixelMatrix, e1.globeMatrix);
                        const i = [
                            0,
                            ec,
                            0
                        ], n = [
                            0,
                            tc,
                            0
                        ];
                        return X(i, i, t1), X(n, n, t1), [
                            i[0] > 0 && i[0] <= e1.width && i[1] > 0 && i[1] <= e1.height && !fp(e1, new ac(e1.center.lat, 90)),
                            n[0] > 0 && n[0] <= e1.width && n[1] > 0 && n[1] <= e1.height && !fp(e1, new ac(e1.center.lat, -90))
                        ];
                    }(this);
                    e1 ? (h = 90, c = 180, l = -180) : t1 && (u = -90, c = 180, l = -180);
                }
                return new sc(new ac(l, u), new ac(c, h));
            }
            _getBoundsRectangular(e1, t1) {
                const { top: i, left: n } = this._edgeInsets, r = this.height - this._edgeInsets.bottom, o = this.width - this._edgeInsets.right, a = new Re(n, i), s = new Re(o, i), l = new Re(o, r), c = new Re(n, r);
                let u = this.pointCoordinate(a, e1), h = this.pointCoordinate(s, e1);
                const d = this.pointCoordinate(l, t1), f = this.pointCoordinate(c, t1), p = (e1, t1)=>(t1.y - e1.y) / (t1.x - e1.x);
                return u.y > 1 && h.y >= 0 ? u = new mc((1 - f.y) / p(f, u) + f.x, 1) : u.y < 0 && h.y <= 1 && (u = new mc(-f.y / p(f, u) + f.x, 0)), h.y > 1 && u.y >= 0 ? h = new mc((1 - d.y) / p(d, h) + d.x, 1) : h.y < 0 && u.y <= 1 && (h = new mc(-d.y / p(d, h) + d.x, 0)), (new sc).extend(this.coordinateLocation(u)).extend(this.coordinateLocation(h)).extend(this.coordinateLocation(f)).extend(this.coordinateLocation(d));
            }
            _getBoundsRectangularTerrain() {
                const e1 = this.elevation;
                if (!e1.visibleDemTiles.length || e1.isUsingMockSource()) return this._getBoundsRectangular(0, 0);
                const t1 = e1.visibleDemTiles.reduce((e1, t1)=>{
                    if (t1.dem) {
                        const i = t1.dem.tree;
                        e1.min = Math.min(e1.min, i.minimums[0]), e1.max = Math.max(e1.max, i.maximums[0]);
                    }
                    return e1;
                }, {
                    min: Number.MAX_VALUE,
                    max: 0
                });
                return this._getBoundsRectangular(t1.min * e1.exaggeration(), t1.max * e1.exaggeration());
            }
            getBounds() {
                return "mercator" === this.projection.name || "equirectangular" === this.projection.name ? this._terrainEnabled() ? this._getBoundsRectangularTerrain() : this._getBoundsRectangular(0, 0) : this._getBoundsNonRectangular();
            }
            horizonLineFromTop(e1 = !0) {
                const t1 = this.height / 2 / Math.tan(this._fov / 2) / Math.tan(Math.max(this._pitch, .1)) - this.centerOffset.y, i = this.height / 2 - t1 * (1 - this._horizonShift);
                return e1 ? Math.max(0, i) : i;
            }
            getMaxBounds() {
                return this.maxBounds;
            }
            setMaxBounds(e1) {
                this.maxBounds = e1, this.minLat = -85.051129, this.maxLat = hc, this.minLng = -180, this.maxLng = 180, e1 && (this.minLat = e1.getSouth(), this.maxLat = e1.getNorth(), this.minLng = e1.getWest(), this.maxLng = e1.getEast(), this.maxLng < this.minLng && (this.maxLng += 360)), this.worldMinX = ur(this.minLng) * this.tileSize, this.worldMaxX = ur(this.maxLng) * this.tileSize, this.worldMinY = hr(this.maxLat) * this.tileSize, this.worldMaxY = hr(this.minLat) * this.tileSize, this._constrain();
            }
            calculatePosMatrix(e1) {
                let t1 = this._posMatrixCache.get(e1.key);
                return t1 || (t1 = this.projection.createTileMatrix(this, this.worldSize, e1), this._posMatrixCache.set(e1.key, t1)), t1;
            }
            calculateDistanceTileData(e1) {
                const t1 = this._distanceTileDataCache.get(e1.key);
                if (t1) return t1;
                const i = e1.canonical, n = 1 / this.height, r = this.cameraWorldSize, o = r / this.zoomScale(i.z), a = (i.x + Math.pow(2, i.z) * e1.wrap) * o, s = i.y * o, l = this.point;
                l.x *= r / this.worldSize, l.y *= r / this.worldSize;
                const c = this.angle, u = {
                    bearing: [
                        Math.sin(-c),
                        -Math.cos(-c)
                    ],
                    center: [
                        (l.x - a) * n,
                        (l.y - s) * n
                    ],
                    scale: o / Sr * n
                };
                return this._distanceTileDataCache.set(e1.key, u), u;
            }
            calculateFogTileMatrix(e1) {
                const t1 = this._fogTileMatrixCache.get(e1.key);
                if (t1) return t1;
                const i = this.projection.createTileMatrix(this, this.cameraWorldSizeForFog, e1);
                _(i, this.worldToFogMatrix, i);
                const n = new Float32Array(i);
                return this._fogTileMatrixCache.set(e1.key, n), n;
            }
            calculateProjMatrix(e1, t1 = !1, i = !1) {
                const n = i ? this._expandedProjMatrixCache : t1 ? this._alignedProjMatrixCache : this._projMatrixCache, r = n.get(e1.key);
                if (r) return r;
                let o;
                o = this.projection.isReprojectedInTileSpace ? this.mercatorMatrix : i ? this.expandedFarZProjMatrix : t1 ? this.alignedProjMatrix : this.projMatrix;
                const a = _(new Float32Array(16), o, this.calculatePosMatrix(e1));
                return n.set(e1.key, a), a;
            }
            calculatePixelsToTileUnitsMatrix(e1) {
                const t1 = this._pixelsToTileUnitsCache.get(e1.tileID.key);
                if (t1) return t1;
                const i = function(e1, t1) {
                    const { scale: i } = e1.tileTransform, n = i * Sr / (e1.tileSize * Math.pow(2, t1.zoom - e1.tileID.overscaledZ + e1.tileID.canonical.z)), r = t1.inverseAdjustmentMatrix;
                    return new Float32Array([
                        r[0] * n,
                        r[1] * n,
                        r[2] * n,
                        r[3] * n
                    ]);
                }(e1, this);
                return this._pixelsToTileUnitsCache.set(e1.tileID.key, i), i;
            }
            customLayerMatrix() {
                return this.mercatorMatrix.slice();
            }
            globeToMercatorMatrix() {
                if ("globe" === this.projection.name) {
                    const e1 = 1 / this.worldSize, t1 = w([], [
                        e1,
                        e1,
                        e1
                    ]);
                    return _(t1, t1, this.globeMatrix), t1;
                }
            }
            recenterOnTerrain() {
                if (!this._elevation || "globe" === this.projection.name) return;
                const e1 = this._elevation;
                this._updateCameraState();
                const t1 = cc(1, this._center.lat) * this.worldSize, i = this._computeCameraPosition(t1), n = this._camera.forward(), r = cc(1, this._center.lat);
                i[2] /= r, n[2] /= r, $(n, n);
                const o = e1.raycast(i, n, e1.exaggeration());
                if (o) {
                    const e1 = k([], i, n, o), t1 = new mc(e1[0], e1[1], cc(e1[2], fr(e1[1]))), a = (t1.z + P([
                        t1.x - i[0],
                        t1.y - i[1],
                        t1.z - i[2] * r
                    ])) * this._pixelsPerMercatorPixel;
                    this._seaLevelZoom = this._zoomFromMercatorZ(a), this._centerAltitude = t1.toAltitude(), this._center = this.coordinateLocation(t1), this._updateZoomFromElevation(), this._constrain(), this._calcMatrices();
                }
            }
            _constrainCamera(e1 = !1) {
                if (!this._elevation) return;
                const t1 = this._elevation, i = cc(1, this._center.lat) * this.worldSize, n = this._computeCameraPosition(i), r = t1.getAtPointOrZero(new mc(...n)), o = this.pixelsPerMeter / this.worldSize * r, a = this._minimumHeightOverTerrain(), s = n[2] - o;
                if (s <= a) {
                    if (s < 0 || e1) {
                        const e1 = this.locationCoordinate(this._center, this._centerAltitude), t1 = [
                            n[0],
                            n[1],
                            e1.z - n[2]
                        ], i = P(t1);
                        t1[2] -= (a - s) / this._pixelsPerMercatorPixel;
                        const r = P(t1);
                        if (0 === r) return;
                        N(t1, t1, i / r * this._pixelsPerMercatorPixel), this._camera.position = [
                            n[0],
                            n[1],
                            e1.z * this._pixelsPerMercatorPixel - t1[2]
                        ], this._updateStateFromCamera();
                    } else this._isCameraConstrained = !0;
                }
            }
            _constrain() {
                if (!this.center || !this.width || !this.height || this._constraining) return;
                this._constraining = !0;
                const e1 = "globe" === this.projection.name || this.mercatorFromTransition;
                if (this.projection.isReprojectedInTileSpace || e1) {
                    const t1 = this.center;
                    return t1.lat = tt(t1.lat, this.minLat, this.maxLat), (this.maxBounds || !this.renderWorldCopies && !e1) && (t1.lng = tt(t1.lng, this.minLng, this.maxLng)), this.center = t1, void (this._constraining = !1);
                }
                const t1 = this._unmodified, { x: i, y: n } = this.point;
                let r = 0, o = i, a = n;
                const s = this.width / 2, l = this.height / 2, c = this.worldMinY * this.scale, u = this.worldMaxY * this.scale;
                if (n - l < c && (a = c + l), n + l > u && (a = u - l), u - c < this.height && (r = Math.max(r, this.height / (u - c)), a = (u + c) / 2), this.maxBounds || !this._renderWorldCopies || !this.projection.wrap) {
                    const e1 = this.worldMinX * this.scale, t1 = this.worldMaxX * this.scale, n = this.worldSize / 2 - (e1 + t1) / 2;
                    o = (i + n + this.worldSize) % this.worldSize - n, o - s < e1 && (o = e1 + s), o + s > t1 && (o = t1 - s), t1 - e1 < this.width && (r = Math.max(r, this.width / (t1 - e1)), o = (t1 + e1) / 2);
                }
                o === i && a === n || this._allowWorldUnderZoom || (this.center = this.unproject(new Re(o, a))), r && !this._allowWorldUnderZoom && (this.zoom += this.scaleZoom(r)), this._constrainCamera(), this._unmodified = t1, this._constraining = !1;
            }
            _minZoomForBounds() {
                let e1 = Math.max(0, this.scaleZoom(Math.max(0, this.height) / (this.worldMaxY - this.worldMinY)));
                return this.maxBounds && (e1 = Math.max(e1, this.scaleZoom(this.width / (this.worldMaxX - this.worldMinX)))), e1;
            }
            _maxCameraBoundsDistance() {
                return this._mercatorZfromZoom(this._minZoomForBounds());
            }
            _calcMatrices() {
                if (!this.height) return;
                const e1 = this.centerOffset, t1 = "globe" === this.projection.name, i = this.pixelsPerMeter;
                "globe" === this.projection.name && (this._mercatorScaleRatio = cc(1, this.center.lat) / cc(1, 45));
                const n = ox(this.projection, this.zoom, this.width, this.height, 1024);
                this._pixelsPerMercatorPixel = this.projection.pixelSpaceConversion(this.center.lat, this.worldSize, n), this.cameraToCenterDistance = .5 / Math.tan(.5 * this._fov) * this.height * this._pixelsPerMercatorPixel, this._updateCameraState(), this._farZ = this.projection.farthestPixelDistance(this), this._nearZ = this.height / 50;
                const r = "meters" === this.projection.zAxisUnit ? i : 1, a = this._camera.getWorldToCamera(this.worldSize, r);
                let s;
                const l = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, this._farZ);
                if (l[8] = 2 * -e1.x / this.width, l[9] = 2 * e1.y / this.height, this.isOrthographic) {
                    let t1 = .5 * this.height / Math.tan(this._fov / 2) * 1 * Math.tan(.5 * this._fov), i = t1 * this.aspect, n = -i, r = -t1;
                    i -= e1.x, n -= e1.x, t1 += e1.y, r += e1.y, s = this._camera.getCameraToClipOrthographic(n, i, r, t1, this._nearZ + this._nearClipOffset, this._farZ), ((e1, t1, i, n)=>{
                        for(let r = 0; r < 16; r++)e1[r] = hn(t1[r], i[r], n);
                    })(s, s, l, zt(this.pitch >= PA ? 1 : this.pitch / PA));
                } else s = l;
                this._cameraToClip = s;
                const c = z(new Float64Array(16), l, a), u = z(new Float64Array(16), s, a);
                if (this.projection.isReprojectedInTileSpace) {
                    const e1 = this.locationCoordinate(this.center);
                    d(this._mat4Scratch);
                    const t1 = this._mat4Scratch;
                    m(t1, t1, [
                        e1.x * this.worldSize,
                        e1.y * this.worldSize,
                        0
                    ]), _(t1, t1, nx(this)), m(t1, t1, [
                        -e1.x * this.worldSize,
                        -e1.y * this.worldSize,
                        0
                    ]), _(u, u, t1), _(c, c, t1), this.inverseAdjustmentMatrix = function(e1) {
                        const t1 = nx(e1, !0);
                        return o([], [
                            t1[0],
                            t1[1],
                            t1[4],
                            t1[5]
                        ]);
                    }(this);
                } else this.inverseAdjustmentMatrix = [
                    1,
                    0,
                    0,
                    1
                ];
                if (g(this.mercatorMatrix, u, [
                    this.worldSize,
                    this.worldSize,
                    this.worldSize / r,
                    1
                ]), this.projMatrix = u, p(this.invProjMatrix, this.projMatrix), this._frustumCache.clear(), t1) {
                    const t1 = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, 1 / 0);
                    t1[8] = 2 * -e1.x / this.width, t1[9] = 2 * e1.y / this.height, z(this._expandedFarZProjMatrixBuf, t1, a), this.expandedFarZProjMatrix = this._expandedFarZProjMatrixBuf;
                } else this.expandedFarZProjMatrix = this.projMatrix;
                p(this._mat4Scratch, s), this.frustumCorners = Df.fromInvProjectionMatrix(this._mat4Scratch, this.horizonLineFromTop(), this.height), w(this.skyboxMatrix, [
                    1,
                    -1,
                    1
                ]), y(this.skyboxMatrix, this.skyboxMatrix, this._pitch), v(this.skyboxMatrix, this.skyboxMatrix, this.angle), S(this.starsProjMatrix, this._fov, this.width / this.height, this._nearZ, this._farZ);
                const f = (Math.PI / 2 - this._pitch) * (this.height / this._fov) * this._horizonShift;
                h(this._mat4Scratch, this.starsProjMatrix), this._mat4Scratch[8] = 2 * -e1.x / this.width, this._mat4Scratch[9] = 2 * (e1.y + f) / this.height, _(this.skyboxMatrix, this._mat4Scratch, this.skyboxMatrix);
                const x = this.point, b = x.x, A = x.y, E = this.width % 2 / 2, I = this.height % 2 / 2, M = Math.cos(this.angle), T = Math.sin(this.angle), R = b - Math.round(b) + M * E + T * I, P = A - Math.round(A) + M * I + T * E;
                if (h(this.alignedProjMatrix, u), m(this.alignedProjMatrix, this.alignedProjMatrix, [
                    R > .5 ? R - 1 : R,
                    P > .5 ? P - 1 : P,
                    0
                ]), w(this.labelPlaneMatrix, [
                    this.width / 2,
                    -this.height / 2,
                    1
                ]), m(this.labelPlaneMatrix, this.labelPlaneMatrix, [
                    1,
                    -1,
                    0
                ]), w(this.glCoordMatrix, [
                    1,
                    -1,
                    1
                ]), m(this.glCoordMatrix, this.glCoordMatrix, [
                    -1,
                    -1,
                    0
                ]), g(this.glCoordMatrix, this.glCoordMatrix, [
                    2 / this.width,
                    2 / this.height,
                    1
                ]), _(this.pixelMatrix, this.labelPlaneMatrix, c), this._calcFogMatrices(), this._distanceTileDataCache.clear(), !p(this.pixelMatrixInverse, this.pixelMatrix)) throw new Error("failed to invert matrix");
                if ("globe" === this.projection.name || this.mercatorFromTransition) {
                    this.globeMatrix = function(e1) {
                        const { x: t1, y: i } = e1.point, { lng: n, lat: r } = e1._center;
                        return lp(t1, i, e1.worldSize, n, r);
                    }(this);
                    const e1 = [
                        this.globeMatrix[12],
                        this.globeMatrix[13],
                        this.globeMatrix[14]
                    ];
                    this.globeCenterInViewSpace = X(e1, e1, a), this.globeRadius = this.worldSize / 2 / Math.PI - 1;
                } else this.globeMatrix = this.pixelMatrixInverse;
                this._worldToCamera = "globe" === this.projection.name ? _(new Float64Array(16), a, this.globeMatrix) : a, this._posMatrixCache.clear(), this._projMatrixCache.clear(), this._alignedProjMatrixCache.clear(), this._pixelsToTileUnitsCache.clear(), this._expandedProjMatrixCache.clear();
            }
            _calcFogMatrices() {
                this._fogTileMatrixCache.clear();
                const e1 = this.cameraWorldSizeForFog, t1 = this.cameraPixelsPerMeter, i = this._camera.position, n = 1 / this.height / this._pixelsPerMercatorPixel, r = [
                    e1,
                    e1,
                    t1
                ];
                N(r, r, n), N(i, i, -1), L(i, i, r), b(this.mercatorFogMatrix, i), g(this.mercatorFogMatrix, this.mercatorFogMatrix, r), this.worldToFogMatrix = this._camera.getWorldToCameraPosition(e1, t1, n);
            }
            _computeCameraPosition(e1) {
                const t1 = (e1 = e1 || this.pixelsPerMeter) / this.pixelsPerMeter, i = this._camera.forward(), n = this.point, r = this._mercatorZfromZoom(this._seaLevelZoom ? this._seaLevelZoom : this._zoom) * t1 - e1 / this.worldSize * this._centerAltitude;
                return [
                    n.x / this.worldSize - i[0] * r,
                    n.y / this.worldSize - i[1] * r,
                    e1 / this.worldSize * this._centerAltitude - i[2] * r
                ];
            }
            _updateCameraState() {
                this.height && (this._camera.setPitchBearing(this._pitch, this.angle), this._camera.position = this._computeCameraPosition());
            }
            _translateCameraConstrained(e1) {
                const t1 = this._maxCameraBoundsDistance() * Math.cos(this._pitch), i = this._camera.position[2], n = e1[2];
                let r = 1;
                this.projection.wrap && (this.center = this.center.wrap()), n > 0 && (r = Math.min((t1 - i) / n, 1)), this._camera.position = k([], this._camera.position, e1, r), this._updateStateFromCamera();
            }
            _updateStateFromCamera() {
                const e1 = this._camera.position, t1 = this._camera.forward(), { pitch: i, bearing: n } = this._camera.getPitchBearing(), r = cc(this._centerAltitude, this.center.lat) * this._pixelsPerMercatorPixel, o = this._mercatorZfromZoom(this._maxZoom) * Math.cos(Ye(this._maxPitch)), a = Math.max((e1[2] - r) / Math.cos(i), o), s = this._zoomFromMercatorZ(a);
                k(e1, e1, t1, a), this._pitch = tt(i, Ye(this.minPitch), Ye(this.maxPitch)), this.angle = nt(n, -Math.PI, Math.PI), this._setZoom(tt(s, this._minZoom, this._maxZoom)), this._updateSeaLevelZoom(), this._center = this.coordinateLocation(new mc(e1[0], e1[1], e1[2])), this._unmodified = !1, this._constrain(), this._calcMatrices();
            }
            _worldSizeFromZoom(e1) {
                return Math.pow(2, e1) * this.tileSize;
            }
            _mercatorZfromZoom(e1) {
                return this.cameraToCenterDistance / this._worldSizeFromZoom(e1);
            }
            _minimumHeightOverTerrain() {
                const e1 = Math.min(this._seaLevelZoom ?? this._zoom, this._maxZoom) + 4;
                return this._mercatorZfromZoom(e1);
            }
            _zoomFromMercatorZ(e1) {
                return this.scaleZoom(this.cameraToCenterDistance / (Math.max(0, e1) * this.tileSize));
            }
            zoomFromMercatorZAdjusted(e1) {
                let t1 = 0, i = 6, n = 0, r = 1 / 0;
                for(; i - t1 > 1e-6 && i > t1;){
                    const o = t1 + .5 * (i - t1), a = this.tileSize * Math.pow(2, o), s = this.getCameraToCenterDistance(this.projection, o, a), l = this.scaleZoom(s / (Math.max(0, e1) * this.tileSize)), c = Math.abs(o - l);
                    c < r && (r = c, n = o), o < l ? t1 = o : i = o;
                }
                return n;
            }
            _terrainEnabled() {
                return !(!this._elevation || !this.projection.supportsTerrain && (_t("Terrain is not yet supported with alternate projections. Use mercator or globe to enable terrain."), 1));
            }
            anyCornerOffEdge(e1, t1) {
                const i = Math.min(e1.x, t1.x), n = Math.max(e1.x, t1.x), r = Math.min(e1.y, t1.y), o = Math.max(e1.y, t1.y);
                if (r < this.horizonLineFromTop(!1)) return !0;
                if ("mercator" !== this.projection.name) return !1;
                const a = [
                    new Re(i, r),
                    new Re(n, o),
                    new Re(i, o),
                    new Re(n, r)
                ], s = this.renderWorldCopies ? -3 : 0, l = this.renderWorldCopies ? 4 : 1;
                for (const e1 of a){
                    const t1 = this.pointRayIntersection(e1);
                    if (t1.t < 0) return !0;
                    const i = this.rayIntersectionCoordinate(t1);
                    if (i.x < s || i.y < 0 || i.x > l || i.y > 1) return !0;
                }
                return !1;
            }
            isHorizonVisible() {
                return this.pitch + Je(this.fovAboveCenter) > 88 || this.anyCornerOffEdge(new Re(0, 0), new Re(this.width, this.height));
            }
            zoomDeltaToMovement(e1, t1) {
                const i = P(ee([], this._camera.position, e1)), n = this._zoomFromMercatorZ(i) + t1;
                return i - this._mercatorZfromZoom(n);
            }
            getCameraPoint() {
                if ("globe" === this.projection.name) {
                    const e1 = function([e1, t1, i], n) {
                        const r = [
                            e1,
                            t1,
                            i,
                            1
                        ];
                        se(r, r, n);
                        const o = r[3] = Math.max(r[3], 1e-6);
                        return r[0] /= o, r[1] /= o, r[2] /= o, r;
                    }([
                        this.globeMatrix[12],
                        this.globeMatrix[13],
                        this.globeMatrix[14]
                    ], this.pixelMatrix);
                    return new Re(e1[0], e1[1]);
                }
                {
                    const e1 = Math.tan(this._pitch) * (this.cameraToCenterDistance || 1);
                    return this.centerPoint.add(new Re(0, e1));
                }
            }
            getCameraToCenterDistance(e1, t1 = this.zoom, i = this.worldSize) {
                const n = ox(e1, t1, this.width, this.height, 1024), r = e1.pixelSpaceConversion(this.center.lat, i, n);
                let o = .5 / Math.tan(.5 * this._fov) * this.height * r;
                return this.isOrthographic && (o = hn(1, o, zt(this.pitch >= PA ? 1 : this.pitch / PA))), o;
            }
            getWorldToCameraMatrix() {
                return this._worldToCamera;
            }
            getCameraToClipMatrix() {
                return this._cameraToClip;
            }
            getFrustum(e1) {
                let t1 = this._frustumCache.get(e1);
                return t1 || (t1 = Vf.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, e1, "meters" === this.projection.zAxisUnit), this._frustumCache.set(e1, t1)), t1;
            }
            get cameraFrustum() {
                return this.getFrustum(0);
            }
        }
        const FA = (e1, t1)=>{
            if (t1 <= 0 || e1.terrain) return {
                shouldRenderCutoff: !1,
                uniformValues: {
                    u_cutoff_params: [
                        0,
                        0,
                        0,
                        1
                    ]
                }
            };
            const i = e1.transform, n = i.pitch, r = i.isLODDisabled(!1) ? 60 : 30;
            if (n < r - 15) return {
                shouldRenderCutoff: !1,
                uniformValues: {
                    u_cutoff_params: [
                        0,
                        0,
                        0,
                        1
                    ]
                }
            };
            const o = i._farZ - i._nearZ, a = t1 * i.height * 1.3, s = Math.pow(2, .85 * Math.max(i._zoom - e1.minCutoffZoom, 0)), l = 1.4 * i.cameraToCenterDistance * s, c = it(r - 15, r, n), u = hn(i._farZ + a, l, c), h = Math.min(a, u - i._nearZ);
            return {
                shouldRenderCutoff: c > 0,
                uniformValues: {
                    u_cutoff_params: [
                        i._nearZ,
                        i._farZ,
                        (u - i._nearZ) / o,
                        (u - h - i._nearZ) / o
                    ]
                }
            };
        };
        function CA(e1, t1, i, n) {
            const r = 1 << e1.z;
            t1.lat = fr((n / Sr + e1.y) / r), t1.lng = dr((i / Sr + e1.x) / r);
        }
        const OA = (e1, t1, i = 1)=>({
                u_matrix: e1,
                u_color: t1,
                u_overlay: 0,
                u_overlay_scale: i
            }), LA = new Float64Array(16), BA = new Float64Array(16), VA = new Float64Array(16), NA = new Float64Array(16), kA = new Float64Array(16), UA = new Float64Array(16), jA = new Float64Array(16), GA = [
            0,
            0,
            0
        ], HA = [
            0,
            0,
            0
        ], $A = new Float32Array(16), ZA = [
            0,
            0,
            0
        ], WA = new Float64Array(16), qA = new Float64Array(16), XA = new Float64Array(16), YA = [
            0,
            0,
            0
        ], JA = [];
        function KA(e1) {
            const t1 = e1.cameraWorldSizeForFog / e1.worldSize;
            return g(XA, e1.worldToFogMatrix, [
                t1,
                t1,
                1
            ]);
        }
        function QA(e1, t1, i, n) {
            return m(e1, t1, i), Q(n, mx) || g(e1, e1, n), e1;
        }
        function eE(e1, t1, i, n) {
            const r = i ? t1.lightsStyleAabb : e1.aabb, o = r ? r.min[2] : 1 / 0, a = (r ? r.max[2] : -1 / 0) - o;
            return [
                isFinite(o) ? o : 0,
                a > 0 && isFinite(a) ? a : 1,
                n ? 1 : 0,
                0
            ];
        }
        function tE(e1, t1) {
            return t1.featureBuffer ? e1.partStyleUBO : null;
        }
        function iE(e1, t1, i, n, r, o = null) {
            const a = i.material, s = n.context, { baseColorTexture: l, metallicRoughnessTexture: c } = a.pbrMetallicRoughness, { normalTexture: u, occlusionTexture: h, emissionTexture: d } = a;
            function f(t1, i, n) {
                if (t1 && (e1.push(i), s.activeTexture.set(s.gl.TEXTURE0 + n), t1.gfxTexture)) {
                    const { minFilter: e1, magFilter: i, wrapS: n, wrapT: r } = t1.sampler;
                    t1.gfxTexture.bindExtraParam(e1, i, n, r);
                }
            }
            f(l, "HAS_TEXTURE_u_baseColorTexture", Jw.BaseColor), f(c, "HAS_TEXTURE_u_metallicRoughnessTexture", Jw.MetallicRoughness), f(u, "HAS_TEXTURE_u_normalTexture", Jw.Normal), f(h, "HAS_TEXTURE_u_occlusionTexture", Jw.Occlusion), f(d, "HAS_TEXTURE_u_emissionTexture", Jw.Emission), r && (r.texture || (r.texture = new Y_(n.context, r.image, [
                r.image.height,
                r.image.height,
                r.image.height
            ], s.gl.RGBA8)), s.activeTexture.set(s.gl.TEXTURE0 + Jw.LUT), r.texture && r.texture.bind(s.gl.LINEAR, s.gl.CLAMP_TO_EDGE), e1.push("APPLY_LUT_ON_GPU")), i.texcoordBuffer && (e1.push("HAS_ATTRIBUTE_a_uv_2f"), t1.push(i.texcoordBuffer)), i.colorBuffer && (e1.push(12 === i.colorBuffer.itemSize ? "HAS_ATTRIBUTE_a_color_3f" : "HAS_ATTRIBUTE_a_color_4f"), t1.push(i.colorBuffer)), i.normalBuffer && (e1.push("HAS_ATTRIBUTE_a_normal_4n"), t1.push(i.normalBuffer)), o && (e1.push("HAS_ATTRIBUTE_a_feature"), t1.push(i.featureBuffer)), "OPAQUE" !== a.alphaMode && "MASK" !== a.alphaMode || e1.push("UNPREMULT_TEXTURE_IN_SHADER"), a.defined || e1.push("DIFFUSE_SHADED");
            const p = n.shadowRenderer;
            p && (e1.push("RENDER_SHADOWS"), p.useNormalOffset && e1.push("NORMAL_OFFSET"));
        }
        function nE(e1, t1, i, n, r, o, a) {
            const s = e1.modelOpacity, l = t1.context, c = new lA(l.gl.LEQUAL, e1.isLightMesh ? lA.ReadOnly : lA.ReadWrite, t1.depthRangeFor3D), u = t1.transform, h = e1.mesh, d = h.material, m = t1.style.fog;
            "pixels" === u.projection.zAxisUnit ? LA.set(e1.nodeModelMatrix) : _(LA, r.zScaleMatrix, e1.nodeModelMatrix), _(LA, r.negCameraPosMatrix, LA), p(BA, LA), f(BA, BA);
            const g = "none" === i.paint.get("model-color-use-theme").constantOr("default"), y = i.paint.get("model-emissive-strength").constantOr(0), x = {
                defines: []
            }, v = [], b = t1.shadowRenderer;
            b && (b.useNormalOffset = !1), iE(x.defines, v, h, t1, g ? null : i.lut);
            let w = null;
            if (m && (w = _(VA, KA(u), e1.nodeModelMatrix), "globe" !== u.projection.name)) {
                const e1 = h.aabb.min, t1 = h.aabb.max, [i, n] = m.getOpacityForBounds(w, e1[0], e1[1], t1[0], t1[1]);
                x.overrideFog = i >= __ || n >= __;
            }
            const A = FA(t1, i.paint.get("model-cutoff-fade-range"));
            A.shouldRenderCutoff && x.defines.push("RENDER_CUTOFF");
            const E = t1.getOrCreateProgram("model", x), I = tA(e1.worldViewProjection, LA, BA, null, n, s, d, y, void 0, void 0, e1.materialOverride, e1.modelColor);
            t1.uploadCommonUniforms(l, E, null, w, A, e1.lightOverrides), "shadow" !== t1.renderPass && b && b.setupShadowsFromMatrix(e1.nodeModelMatrix, E), E.draw(t1, l.gl.TRIANGLES, c, o, a, h.material.doubleSided ? hA.disabled : hA.backCCW, I, i.id, h.vertexBuffer, h.indexBuffer, h.segments, i.paint, u.zoom, void 0, v);
        }
        function rE(e1, t1) {
            return e1.style._importedAsBasemap ? "basemap" : t1.scope;
        }
        function oE(e1, t1, i, n, r, o, a, s, l, c, u) {
            const h = e1.transform, d = !!t1.isGeometryBloom && t1.isGeometryBloom;
            if (void 0 !== t1.minZoom && e1.transform.zoom < t1.minZoom) return;
            if (void 0 !== t1.maxZoom && e1.transform.zoom > t1.maxZoom) return;
            if (d && "shadow" === e1.renderPass) return;
            const f = "globe" === h.projection.name ? dx(i, h) : [
                ...i
            ];
            _(f, f, t1.globalMatrix);
            const p = _([], n, f);
            if (t1.meshes) for (const e1 of t1.meshes){
                const n = s.get(e1.material.name);
                if (n && n.opacity <= 0) continue;
                if ("BLEND" !== e1.material.alphaMode) {
                    a.push({
                        mesh: e1,
                        depth: 0,
                        modelIndex: r,
                        worldViewProjection: p,
                        nodeModelMatrix: f,
                        isLightMesh: d,
                        materialOverride: n,
                        modelOpacity: l,
                        modelColor: c,
                        lightOverrides: u,
                        node: t1,
                        modelMatrix: i
                    });
                    continue;
                }
                const _ = X([], e1.centroid, p);
                !h.isOrthographic && _[2] <= 0 || o.push({
                    mesh: e1,
                    depth: _[2],
                    modelIndex: r,
                    worldViewProjection: p,
                    nodeModelMatrix: f,
                    isLightMesh: d,
                    materialOverride: n,
                    modelOpacity: l,
                    modelColor: c,
                    lightOverrides: u,
                    node: t1,
                    modelMatrix: i
                });
            }
            if (t1.children) for (const h of t1.children)oE(e1, h, i, n, r, o, a, s, l, c, u);
        }
        function aE(e1, t1, i, n, r) {
            const o = i.shadowRenderer;
            if (!o) return;
            const a = o.getShadowPassDepthMode(), s = r || o.calculateShadowPassMatrixFromMatrix(t1), l = iA(s);
            i.getOrCreateProgram("modelDepth").draw(i, i.context.gl.TRIANGLES, a, rA.disabled, sA.disabled, hA.disabled, l, n.id, e1.vertexBuffer, e1.indexBuffer, e1.segments, n.paint, i.transform.zoom, void 0, void 0);
        }
        function sE(e1, t1, i, n) {
            const r = function(e1, t1) {
                if (t1.footprintDebugMesh) return t1.footprintDebugMesh;
                if (!t1.footprint) return null;
                const i = e1.context, n = t1.footprint.vertices, r = t1.footprint.indices, o = new Fc;
                o.reserve(n.length / 2);
                for(let e1 = 0; e1 < n.length; e1 += 2)o.emplaceBack(n[e1], n[e1 + 1]);
                const a = new nu;
                a.reserve(r.length);
                for(let e1 = 0; e1 < r.length; e1 += 3)a.emplaceBack(r[e1], r[e1 + 1], r[e1 + 2]);
                const s = i.createVertexBuffer(o, Gf.members), l = i.createIndexBuffer(a), c = Ou.simpleSegment(0, 0, n.length, r.length), u = t1.id || t1.name || "footprint";
                let h;
                const d = parseInt(u, 10);
                h = isNaN(d) ? function(e1) {
                    let t1 = 0;
                    for(let i = 0; i < e1.length; i++)t1 = (t1 << 5) - t1 + e1.charCodeAt(i) | 0;
                    return t1;
                }(u) : d;
                const f = Rt(h), p = Rt(h + 1), _ = Rt(h + 2);
                return t1.footprintDebugMesh = {
                    vertexBuffer: s,
                    indexBuffer: l,
                    segments: c,
                    color: new fn(f, p, _, .5)
                }, t1.footprintDebugMesh;
            }(e1, i);
            if (!r) return;
            const o = e1.context, a = o.gl, s = e1.getOrCreateProgram("debug"), l = r.color, c = lA.disabled;
            o.activeTexture.set(a.TEXTURE0), e1.emptyTexture.bind(a.LINEAR, a.CLAMP_TO_EDGE), s.draw(e1, a.TRIANGLES, c, rA.disabled, sA.alphaBlended, hA.disabled, OA(n, l.toPremultipliedRenderColor(null)), "$debug", r.vertexBuffer, r.indexBuffer, r.segments);
        }
        function lE(e1, t1, i, n, r, o) {
            for (const a of r){
                const r = {
                    ...n
                };
                r.part = a;
                const s = {
                    type: "Unknown",
                    id: t1,
                    properties: r
                }, l = {
                    orientation: e1.paint.get("model-rotation").evaluate(s, i)
                };
                o.set(a, l);
            }
        }
        function cE(e1, t1, i, n, r, o) {
            for (const a of r){
                const r = {
                    ...n
                };
                r.part = a;
                const s = {
                    type: "Unknown",
                    id: t1,
                    properties: r
                }, l = {
                    color: e1.paint.get("model-color").evaluate(s, i),
                    colorMix: e1.paint.get("model-color-mix-intensity").evaluate(s, i),
                    opacity: e1.paint.get("model-opacity").evaluate(s, i),
                    emissionStrength: e1.paint.get("model-emissive-strength").evaluate(s, i)
                };
                o.set(a, l);
            }
        }
        function uE(e1, t1, i, n, r) {
            let o = !1;
            const a = eA(e1, t1);
            for (const i of n)1 !== i.modelOpacity && (nE(i, e1, t1, a, r[i.modelIndex], rA.disabled, sA.disabled), o = !0);
            for (const i of n){
                const n = 1 !== i.modelOpacity ? e1.stencilModeFor3D() : rA.disabled;
                nE(i, e1, t1, a, r[i.modelIndex], n, e1.colorModeForRenderPass());
            }
            o && e1.resetStencilClippingMasks();
            const s = sA.additive;
            for (const n of i)nE(n, e1, t1, a, r[n.modelIndex], rA.disabled, n.isLightMesh ? s : e1.colorModeForRenderPass());
        }
        function hE(e1, t1, i) {
            const n = t1.updateZoomBasedPaintProperties(), r = function(e1, t1, i) {
                const n = e1.terrain;
                let r = n ? n.exaggeration() : 0;
                const o = r > 0 ? n.findDEMTileFor(i) : null, a = o && o.dem;
                if (a || (r = 0), 0 === r && (t1.terrainElevationMin = 0, t1.terrainElevationMax = 0), r === t1.validForExaggeration && (0 === r || o.tileID === t1.validForDEMTile.id && a._timestamp === t1.validForDEMTile.timestamp)) return !1;
                const s = a ? p_.create(n, i, o) : null;
                let l, c;
                for(const e1 in t1.instancesPerModel){
                    const i = t1.instancesPerModel[e1];
                    for(let e1 = 0; e1 < i.instancedDataArray.length; ++e1){
                        const n = (s ? r * s.getElevationAt(0 | i.instancedDataArray.float32[16 * e1], 0 | i.instancedDataArray.float32[16 * e1 + 1], !0, !0) : 0) + i.instancesEvaluatedElevation[e1];
                        i.instancedDataArray.float32[16 * e1 + 6] = n, l = l ? Math.min(t1.terrainElevationMin, n) : n, c = c ? Math.max(t1.terrainElevationMax, n) : n;
                    }
                }
                return t1.terrainElevationMin = l || 0, t1.terrainElevationMax = c || 0, t1.validForExaggeration = r, t1.validForDEMTile = a ? {
                    id: o.tileID,
                    timestamp: a._timestamp
                } : {
                    id: void 0,
                    timestamp: 0
                }, !0;
            }(e1, t1, i);
            (n || r) && (t1.uploaded = !1, t1.upload(e1.context));
        }
        const dE = {
            shadowUniformsInitialized: !1,
            useSingleShadowCascade: !1,
            tileMatrix: new Float64Array(16),
            shadowTileMatrix: new Float32Array(16),
            aabb: new Nf([
                0,
                0,
                0
            ], [
                Sr,
                Sr,
                0
            ])
        };
        function fE(e1, t1, i) {
            const n = 1 << e1.canonical.z, r = t1.elevation, o = e1.canonical.x / n, a = (e1.canonical.x + 1) / n, s = e1.canonical.y / n, l = (e1.canonical.y + 1) / n;
            let c = t1._centerAltitude;
            if (r) {
                const t1 = r.getMinMaxForTile(e1);
                t1 && t1.max > c && (c = t1.max);
            }
            const u = tt(i.x, o, a) - i.x, h = tt(i.y, s, l) - i.y, d = cc(c, t1.center.lat) - i.z;
            return t1._zoomFromMercatorZ(Math.sqrt(u * u + h * h + d * d));
        }
        function pE(e1, t1, i, n, r, o, a, s) {
            const l = e1.context, c = "shadow" === e1.renderPass, u = e1.shadowRenderer, h = c && u ? u.getShadowPassDepthMode() : new lA(l.gl.LEQUAL, lA.ReadWrite, e1.depthRangeFor3D), d = e1.isTileAffectedByFog(a), f = "globe" === e1.transform.projection.name;
            if (n.meshes) for (const p of n.meshes){
                const _ = f ? [] : [
                    "MODEL_POSITION_ON_GPU"
                ], m = [];
                let g, y, x;
                const v = !f && r.instancedDataArray.length > 20;
                v && _.push("INSTANCED_ARRAYS");
                const b = FA(e1, t1.paint.get("model-cutoff-fade-range"));
                if (b.shouldRenderCutoff && _.push("RENDER_CUTOFF"), c && u) g = e1.getOrCreateProgram("modelDepth", {
                    defines: _
                }), y = iA(s.shadowTileMatrix, s.shadowTileMatrix, n.globalMatrix), x = sA.disabled;
                else {
                    iE(_, m, p, e1, "none" === t1.paint.get("model-color-use-theme").constantOr("default") ? null : t1.lut), g = e1.getOrCreateProgram("model", {
                        defines: _,
                        overrideFog: d
                    });
                    const r = p.material, c = t1.paint.get("model-opacity").constantOr(1), h = t1.paint.get("model-emissive-strength").constantOr(0);
                    y = tA(a.expandedProjMatrix, n.globalMatrix, $A, null, i, c, r, h, o), u && (s.shadowUniformsInitialized ? g.setShadowUniformValues(l, u.getShadowUniformValues()) : (u.setupShadows(a.toUnwrapped(), g, "model-tile"), s.shadowUniformsInitialized = !0)), x = b.shouldRenderCutoff || c < 1 || "OPAQUE" !== r.alphaMode ? sA.alphaBlended : sA.unblended;
                }
                e1.uploadCommonUniforms(l, g, a.toUnwrapped(), null, b);
                const w = p.material.doubleSided ? hA.disabled : hA.backCCW;
                if (v) m.push(r.instancedDataBuffer), g.draw(e1, l.gl.TRIANGLES, h, rA.disabled, x, w, y, t1.id, p.vertexBuffer, p.indexBuffer, p.segments, t1.paint, e1.transform.zoom, void 0, m, r.instancedDataArray.length);
                else {
                    const i = c ? "u_instance" : "u_normal_matrix";
                    for(let n = 0; n < r.instancedDataArray.length; ++n)y[i] = new Float32Array(r.instancedDataArray.arrayBuffer, 64 * n, 16), g.draw(e1, l.gl.TRIANGLES, h, rA.disabled, x, w, y, t1.id, p.vertexBuffer, p.indexBuffer, p.segments, t1.paint, e1.transform.zoom, void 0, m);
                }
            }
            if (n.children) for (const l of n.children)pE(e1, t1, i, l, r, o, a, s);
        }
        function _E(e1, t1, i, n, r) {
            const o = e1.node;
            if (o.lodMeshes && o.lodMeshes.length > 0) {
                if (e1.targetLod < 0) e1.targetLod = t1 > n ? 1 : 0;
                else {
                    const o = r > 0 ? i / 1e3 / r : 1;
                    e1.targetLod = tt(t1 > n ? e1.targetLod + o : e1.targetLod - o, 0, 1);
                }
            } else e1.targetLod = 0;
        }
        function mE(e1, t1, i, n) {
            if (!i.modelManager) return !0;
            const r = i.modelManager;
            if (!i.shadowRenderer) return !0;
            const o = i.shadowRenderer, a = t1.aabb;
            let s = !0, l = e1.maxHeight;
            if (0 === l) {
                let t1 = 0;
                for(const i in e1.instancesPerModel){
                    const e1 = r.getModel(i, n);
                    e1 ? t1 = Math.max(t1, Math.max(Math.max(e1.aabb.max[0], e1.aabb.max[1]), e1.aabb.max[2])) : s = !1;
                }
                l = e1.maxScale * t1 * 1.41 + e1.maxVerticalOffset, s && (e1.maxHeight = l);
            }
            a.max[2] = l, a.min[2] += e1.terrainElevationMin, a.max[2] += e1.terrainElevationMax, X(a.min, a.min, t1.tileMatrix), X(a.max, a.max, t1.tileMatrix);
            const c = a.intersects(o.getCurrentCascadeFrustum());
            return 0 === i.currentShadowCascade && (e1.isInsideFirstShadowMapFrustum = 2 === c), 0 === c;
        }
        function gE(e1, t1) {
            const i = e1.uniformValues.u_cutoff_params[0], n = e1.uniformValues.u_cutoff_params[1], r = e1.uniformValues.u_cutoff_params[2], o = e1.uniformValues.u_cutoff_params[3];
            return n === i || o === r ? 1 : tt(((t1 - i) / (n - i) - r) / (o - r), 0, 1);
        }
        function yE(e1, t1, i, n) {
            if (t1.pitch < 20) return 1;
            const r = _(WA, t1.getWorldToCameraMatrix(), e1), o = i.min[2];
            let a = 1 / 0, s = 0, l = -1 / 0, c = 0;
            for(let e1 = 0; e1 < 4; e1++){
                const t1 = e1 < 2 ? i.min[0] : i.max[0], n = 1 === e1 || 2 === e1 ? i.max[1] : i.min[1], u = r[1] * t1 + r[5] * n + r[9] * o + r[13], h = r[2] * t1 + r[6] * n + r[10] * o + r[14];
                u < a && (a = u, s = h), u > l && (l = u, c = h);
            }
            const u = tt(n[0], 0, 1), h = 100 * t1.pixelsPerMeter * tt(n[1], 0, 1), d = tt(n[2], 0, 1), f = hn(a, l, u), p = -hn(s, c, u) * Math.tan(.5 * t1.fovX);
            if (0 === h) return f < -Math.abs(p) ? d : 1;
            const m = tt(hn(1, d, (-Math.abs(p) - f) / h), d, 1);
            return hn(1, m, tt((t1.pitch - 20) / 20, 0, 1));
        }
        var xE = "\n#define EPSILON 0.0000001\n#define PI 3.141592653589793\n#define storage_depth_to_native_ndc_z(z01) ((z01)*2.0-1.0)\n#define native_ndc_z_to_storage_depth(ndc_z) ((ndc_z)*0.5+0.5)\n#define native_clip_z_to_cutoff_depth(clip_z,clip_w) (clip_z)\n#define native_depth_epsilon(eps) (eps)\n#define depth_range_to_native_ndc_z(z01,unpack) ((z01)*(unpack).x+(unpack).y)\n#define bottom_left_to_native_uv(uv) (uv)\n#define native_cubemap_direction(dir) vec3((dir).x,-(dir).y,(dir).z)\n#define ndc_xy_to_framebuffer_uv(ndc_xy) ((ndc_xy)*0.5+0.5)\n#define ndc_xy_to_depth_texture_uv(ndc_xy) bottom_left_to_native_uv((ndc_xy)*0.5+0.5)\n#ifdef RENDER_CUTOFF\nfloat cutoff_opacity(vec4 cutoff_params,float depth) {float near=cutoff_params.x;float far=cutoff_params.y;float cutoffStart=cutoff_params.z;float cutoffEnd=cutoff_params.w;float linearDepth=(depth-near)/(far-near);return clamp((linearDepth-cutoffStart)/(cutoffEnd-cutoffStart),0.0,1.0);}\n#endif", vE = "\n#define fragcoord_to_bottom_left_uv(frag,size) ((frag)/(size))\n#define fragcoord_to_ndc_y(fragY,invY) ((fragY)*(invY)*2.0-1.0)\n#define native_window_space_normal(fdx,fdy) (normalize(cross((fdx),(fdy)))*-1.0)\n#define fragcoord_to_framebuffer_uv(frag,inv) ((frag)*(inv))\n#define native_window_space_tangent(axis) (axis)\n#define native_tbn_view_dir(position) (normalize(-(position)))\n#ifdef DUAL_SOURCE_BLENDING\nlayout(location=0,index=0) out vec4 glFragColor;layout(location=0,index=1) out vec4 glFragColorSrc1;\n#elif defined(FLOAT_RENDER_TARGET)\nlayout(location=0) out highp vec4 glFragColor;\n#else\nlayout(location=0) out vec4 glFragColor;\n#endif\n#ifdef USE_MRT1\nlayout(location=1) out vec4 out_Target1;\n#endif\nhighp float unpack_depth(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return storage_depth_to_native_ndc_z(dot(rgba_depth,bit_shift));}highp vec4 pack_depth(highp float ndc_z) {highp float depth=native_ndc_z_to_storage_depth(ndc_z);const highp vec4 bit_shift=vec4(255.0*255.0*255.0,255.0*255.0,255.0,1.0);const highp vec4 bit_mask =vec4(0.0,1.0/255.0,1.0/255.0,1.0/255.0);highp vec4 res=fract(depth*bit_shift);res-=res.xxyz*bit_mask;return res;}const float DITHER_THRESHOLDS[16]=float[16](\n1.0/17.0, 9.0/17.0, 3.0/17.0,11.0/17.0,13.0/17.0, 5.0/17.0,15.0/17.0, 7.0/17.0,4.0/17.0,12.0/17.0, 2.0/17.0,10.0/17.0,16.0/17.0, 8.0/17.0,14.0/17.0, 6.0/17.0\n);int viewport_dither_index(vec2 fragCoordXY) {return (int(fragCoordXY.x) % 4)*4+(int(fragCoordXY.y) % 4);}\n#ifdef DEBUG_WIREFRAME\n#define HANDLE_WIREFRAME_DEBUG \\\nglFragColor=vec4(0.7,0.0,0.0,0.7); \\\ngl_FragDepth=gl_FragCoord.z-0.0001;\n#else\n#define HANDLE_WIREFRAME_DEBUG\n#endif\n#ifdef RENDER_CUTOFF\nuniform highp vec4 u_cutoff_params;in float v_cutoff_opacity;\n#endif\nvec4 textureLodCustom(sampler2D image,highp vec2 pos,highp vec2 lod_coord) {highp vec2 size=vec2(textureSize(image,0));highp vec2 dx=dFdx(lod_coord.xy*size);highp vec2 dy=dFdy(lod_coord.xy*size);highp float delta_max_sqr=max(dot(dx,dx),dot(dy,dy));highp float lod=0.5*log2(delta_max_sqr);return textureLod(image,pos,lod);}vec4 premultiplyColor(vec3 nonPremultipliedColor,float a) {return vec4(nonPremultipliedColor*a,a);}vec3 unpremultiplyColor(vec4 premultipliedColor) {if (premultipliedColor.a > 0.0) {return premultipliedColor.rgb/premultipliedColor.a;}return premultipliedColor.rgb;}vec3 applyLUT(highp sampler3D lut,vec3 col) {vec3 size=vec3(textureSize(lut,0));vec3 uvw=(col.rbg*float(size-1.0)+0.5)/size;return texture(lut,uvw).rgb;}vec4 applyLUT(highp sampler3D lut,vec4 premultipliedColor) {return premultiplyColor(applyLUT(lut,unpremultiplyColor(premultipliedColor)),premultipliedColor.a);}void storeEmissiveColor(vec4 color,float emissiveStrength) {\n#ifdef DUAL_SOURCE_BLENDING\nglFragColorSrc1=vec4(vec3(0.0),emissiveStrength);\n#else\n#ifdef USE_MRT1\n#ifdef USE_MRT1_RGBA\nout_Target1=vec4(color.rgb*emissiveStrength,color.a);\n#else\nout_Target1=vec4(emissiveStrength*color.a,0.0,0.0,glFragColor.a);\n#endif\n#endif\n#endif\n}", bE = "\n#define EXTENT 8192.0\n#define RAD_TO_DEG 180.0/PI\n#define DEG_TO_RAD PI/180.0\n#define GLOBE_RADIUS EXTENT/PI/2.0\nfloat wrap(float n,float min,float max) {float d=max-min;float w=mod(mod(n-min,d)+d,d)+min;return (w==min) ? max : w;}\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 mercator_tile_position(mat4 matrix,vec2 tile_anchor,vec3 tile_id,vec2 mercator_center) {\n#ifndef PROJECTED_POS_ON_VIEWPORT\nfloat tiles=tile_id.z;vec2 mercator=(tile_anchor/EXTENT+tile_id.xy)/tiles;mercator-=mercator_center;mercator.x=wrap(mercator.x,-0.5,0.5);vec4 mercator_tile=vec4(mercator.xy*EXTENT,EXTENT/(2.0*PI),1.0);mercator_tile=matrix*mercator_tile;return mercator_tile.xyz;\n#else\nreturn vec3(0.0);\n#endif\n}vec3 mix_globe_mercator(vec3 globe,vec3 mercator,float t) {return mix(globe,mercator,t);}mat3 globe_mercator_surface_vectors(vec3 pos_normal,vec3 up_dir,float zoom_transition) {vec3 normal=zoom_transition==0.0 ? pos_normal : normalize(mix(pos_normal,up_dir,zoom_transition));vec3 xAxis=normalize(vec3(normal.z,0.0,-normal.x));vec3 yAxis=normalize(cross(normal,xAxis));return mat3(xAxis,yAxis,normal);}\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec4 decode_color(const vec2 encodedColor) {return vec4(\nunpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const vec2 units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (units_to_pixels*pos+offset)/pattern_size;}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {return get_pattern_pos(pixel_coord_upper,pixel_coord_lower,pattern_size,vec2(tile_units_to_pixels),pos);}float mercatorXfromLng(float lng) {return (180.0+lng)/360.0;}float mercatorYfromLat(float lat) {return (180.0-(RAD_TO_DEG*log(tan(PI/4.0+lat/2.0*DEG_TO_RAD))))/360.0;}vec3 latLngToECEF(vec2 latLng) {latLng=DEG_TO_RAD*latLng;float cosLat=cos(latLng[0]);float sinLat=sin(latLng[0]);float cosLng=cos(latLng[1]);float sinLng=sin(latLng[1]);float sx=cosLat*sinLng*GLOBE_RADIUS;float sy=-sinLat*GLOBE_RADIUS;float sz=cosLat*cosLng*GLOBE_RADIUS;return vec3(sx,sy,sz);}\n#ifdef RENDER_CUTOFF\nuniform vec4 u_cutoff_params;out float v_cutoff_opacity;\n#endif\nconst vec4 AWAY=vec4(-1000.0,-1000.0,-1000.0,1);const float skirtOffset=24575.0;vec3 decomposeToPosAndSkirt(ivec2 posWithComposedSkirt)\n{float skirt=float(float(posWithComposedSkirt.x) >=skirtOffset);vec2 pos=vec2(posWithComposedSkirt)-vec2(skirt*skirtOffset,0.0);return vec3(pos,skirt);}\n#define GET_ATTRIBUTE_float(attrib,matInfo,attrib_id) attrib\n#define GET_ATTRIBUTE_vec4(attrib,matInfo,attrib_id) attrib\n#define GET_ATTRIBUTE_vec2(attrib,matInfo,attrib_id) attrib\n#define DECLARE_MATERIAL_TABLE_INFO\n", wE = "in highp vec3 a_pos_3f;uniform lowp mat4 u_matrix;out highp vec3 v_uv;void main() {const mat3 half_neg_pi_around_x=mat3(1.0,0.0, 0.0,0.0,0.0,-1.0,0.0,1.0, 0.0);v_uv=half_neg_pi_around_x*a_pos_3f;vec4 pos=u_matrix*vec4(a_pos_3f,1.0);gl_Position=pos.xyww;}", AE = "\n#define ELEVATION_SCALE 7.0\n#define ELEVATION_OFFSET 450.0\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_tl_up;uniform vec3 u_tile_tr_up;uniform vec3 u_tile_br_up;uniform vec3 u_tile_bl_up;uniform float u_tile_up_scale;\n#endif\nvec3 elevationVector(vec2 pos) {\n#ifdef PROJECTION_GLOBE_VIEW\nvec2 uv=pos/EXTENT;vec3 up=normalize(mix(\nmix(u_tile_tl_up,u_tile_tr_up,uv.xxx),mix(u_tile_bl_up,u_tile_br_up,uv.xxx),uv.yyy));return up*u_tile_up_scale;\n#else\nreturn vec3(0,0,1);\n#endif\n}\n#ifdef TERRAIN\nuniform highp sampler2D u_dem;\n#ifdef TERRAIN_VERTEX_MORPHING\nuniform highp sampler2D u_dem_prev;\n#endif\nuniform vec2 u_dem_tl;uniform vec2 u_dem_tl_prev;uniform float u_dem_scale;uniform float u_dem_scale_prev;uniform float u_dem_size;uniform float u_dem_lerp;uniform float u_exaggeration;uniform float u_meter_to_dem;uniform mat4 u_label_plane_matrix_inv;vec4 tileUvToDemSample(vec2 uv,float dem_size,float dem_scale,vec2 dem_tl) {vec2 pos=dem_size*(uv*dem_scale+dem_tl)+1.0;vec2 f=fract(pos);return vec4((pos-f+0.5)/(dem_size+2.0),f);}float currentElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale+u_dem_tl)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture(u_dem,pos).r;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale,u_dem_tl);vec2 pos=r.xy;vec2 f=r.zw;float tl=texture(u_dem,pos).r;float tr=texture(u_dem,pos+vec2(dd,0)).r;float bl=texture(u_dem,pos+vec2(0,dd)).r;float br=texture(u_dem,pos+vec2(dd,dd)).r;return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}\n#ifdef TERRAIN_VERTEX_MORPHING\nfloat prevElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale_prev+u_dem_tl_prev)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture(u_dem_prev,pos).r;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale_prev,u_dem_tl_prev);vec2 pos=r.xy;vec2 f=r.zw;float tl=texture(u_dem_prev,pos).r;float tr=texture(u_dem_prev,pos+vec2(dd,0)).r;float bl=texture(u_dem_prev,pos+vec2(0,dd)).r;float br=texture(u_dem_prev,pos+vec2(dd,dd)).r;return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}\n#endif\nvec4 fourSample(vec2 pos,vec2 off) {float tl=texture(u_dem,pos).r;float tr=texture(u_dem,pos+vec2(off.x,0.0)).r;float bl=texture(u_dem,pos+vec2(0.0,off.y)).r;float br=texture(u_dem,pos+off).r;return vec4(tl,tr,bl,br);}float flatElevation(vec2 pack) {vec2 apos=floor(pack/8.0);vec2 span=10.0*(pack-apos*8.0);vec2 uvTex=(apos-vec2(1.0,1.0))/8190.0;float size=u_dem_size+2.0;float dd=1.0/size;vec2 pos=u_dem_size*(uvTex*u_dem_scale+u_dem_tl)+1.0;vec2 f=fract(pos);pos=(pos-f+0.5)*dd;vec4 h=fourSample(pos,vec2(dd));float z=mix(mix(h.x,h.y,f.x),mix(h.z,h.w,f.x),f.y);vec2 w=floor(0.5*(span*u_meter_to_dem-1.0));vec2 d=dd*w;h=fourSample(pos-d,2.0*d+vec2(dd));vec4 diff=abs(h.xzxy-h.ywzw);vec2 slope=min(vec2(0.25),u_meter_to_dem*0.5*(diff.xz+diff.yw)/(2.0*w+vec2(1.0)));vec2 fix=slope*span;float base=z+max(fix.x,fix.y);return u_exaggeration*base;}float elevationFromUint16(float word) {return u_exaggeration*(word/ELEVATION_SCALE-ELEVATION_OFFSET);}\n#endif\nfloat elevation(vec2 apos) {\n#ifdef TERRAIN\n#ifdef TERRAIN_VERTEX_MORPHING\nfloat nextElevation=currentElevation(apos);float prevElevation=prevElevation(apos);return mix(prevElevation,nextElevation,u_dem_lerp);\n#else\nreturn currentElevation(apos);\n#endif\n#else\nreturn 0.0;\n#endif\n}\n#ifdef DEPTH_OCCLUSION\nuniform highp sampler2D u_depth;uniform highp vec2 u_depth_size_inv;uniform highp vec2 u_depth_range_unpack;uniform highp float u_occluder_half_size;uniform highp float u_occlusion_depth_offset;\n#ifdef DEPTH_D24\nfloat unpack_depth(float depth) {return depth_range_to_native_ndc_z(depth,u_depth_range_unpack);}vec4 unpack_depth4(vec4 depth) {return depth_range_to_native_ndc_z(depth,u_depth_range_unpack);}\n#else\nhighp float unpack_depth_rgba(vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return storage_depth_to_native_ndc_z(dot(rgba_depth,bit_shift));}\n#endif\nhighp vec2 occlusionDepthUv(highp vec2 ndc_xy) {return ndc_xy_to_depth_texture_uv(ndc_xy);}\n#define occlusion_depth_bias native_depth_epsilon(u_occlusion_depth_offset)\n#define occlusion_fade_slope(native_delta) (300.0*(native_delta)/native_depth_epsilon(1.0))\nbool isOccluded(vec4 frag) {vec3 coord=frag.xyz/frag.w;highp vec2 uv=occlusionDepthUv(coord.xy);\n#ifdef DEPTH_D24\nfloat depth=unpack_depth(texture(u_depth,uv).r);\n#else\nfloat depth=unpack_depth_rgba(texture(u_depth,uv));\n#endif\nreturn coord.z+occlusion_depth_bias > depth;}highp vec4 getCornerDepths(vec2 coord) {highp vec3 df=vec3(u_occluder_half_size*u_depth_size_inv,0.0);highp vec2 uv=occlusionDepthUv(coord);\n#ifdef DEPTH_D24\nhighp vec4 depth=vec4(\ntexture(u_depth,uv-df.xz).r,texture(u_depth,uv+df.xz).r,texture(u_depth,uv-df.zy).r,texture(u_depth,uv+df.zy).r\n);depth=unpack_depth4(depth);\n#else\nhighp vec4 depth=vec4(\nunpack_depth_rgba(texture(u_depth,uv-df.xz)),unpack_depth_rgba(texture(u_depth,uv+df.xz)),unpack_depth_rgba(texture(u_depth,uv-df.zy)),unpack_depth_rgba(texture(u_depth,uv+df.zy))\n);\n#endif\nreturn depth;}highp float occlusionFadeMultiSample(vec4 frag) {highp vec3 coord=frag.xyz/frag.w;highp vec2 uv=occlusionDepthUv(coord.xy);int NX=3;int NY=4;highp vec2 df=u_occluder_half_size*u_depth_size_inv;highp vec2 oneStep=2.0*u_occluder_half_size*u_depth_size_inv/vec2(NX-1,NY-1);highp float res=0.0;for (int y=0; y < NY;++y) {for (int x=0; x < NX;++x) {\n#ifdef DEPTH_D24\nhighp float depth=unpack_depth(texture(u_depth,uv-df+vec2(float(x)*oneStep.x,float(y)*oneStep.y)).r);\n#else\nhighp float depth=unpack_depth_rgba(texture(u_depth,uv-df+vec2(float(x)*oneStep.x,float(y)*oneStep.y)));\n#endif\nres+=1.0-clamp(occlusion_fade_slope(coord.z+occlusion_depth_bias-depth),0.0,1.0);}}res=clamp(2.0*res/float(NX*NY)-0.5,0.0,1.0);return res;}highp float occlusionFade(vec4 frag) {highp vec3 coord=frag.xyz/frag.w;highp vec4 depth=getCornerDepths(coord.xy);return dot(vec4(0.25),vec4(1.0)-clamp(occlusion_fade_slope(vec4(coord.z+occlusion_depth_bias)-depth),0.0,1.0));}\n#else\nbool isOccluded(vec4 frag) { return false; }highp float occlusionFade(vec4 frag) { return 1.0; }highp float occlusionFadeMultiSample(vec4 frag) { return 1.0; }\n#endif", EE = "#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump mat4 u_fog_matrix;out vec3 v_fog_pos;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}vec3 fog_position(vec3 pos) {return (u_fog_matrix*vec4(pos,1.0)).xyz;}vec3 fog_position(vec2 pos) {return fog_position(vec3(pos,0.0));}float fog(vec3 pos) {float depth=length(pos);float opacity=fog_opacity(fog_range(depth));return opacity*fog_horizon_blending(pos/depth);}\n#endif", IE = "#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump vec2 u_fog_vertical_limit;uniform mediump float u_fog_temporal_offset;in vec3 v_fog_pos;uniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform highp vec2 u_viewport;uniform float u_globe_transition;uniform int u_is_globe;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}float globe_glow_progress() {highp vec2 uv=fragcoord_to_bottom_left_uv(gl_FragCoord.xy,u_viewport);highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);highp vec3 dir=normalize(ray_dir);highp vec3 closest_point=dot(u_globe_pos,dir)*dir;highp float sdf=length(closest_point-u_globe_pos)/u_globe_radius;return sdf+PI*0.5;}float fog_opacity(vec3 pos) {float depth=length(pos);return fog_opacity(fog_range(depth));}vec3 fog_apply(vec3 color,vec3 pos,float opacity_limit) {float depth=length(pos);float opacity;if (u_is_globe==1) {float glow_progress=globe_glow_progress();float t=mix(glow_progress,depth,u_globe_transition);opacity=fog_opacity(fog_range(t));} else {opacity=fog_opacity(fog_range(depth));opacity*=fog_horizon_blending(pos/depth);}return mix(color,u_fog_color.rgb,min(opacity,opacity_limit));}vec3 fog_apply(vec3 color,vec3 pos) {return fog_apply(color,pos,1.0);}vec4 fog_apply_from_vert(vec4 color,float fog_opac) {float alpha=EPSILON+color.a;color.rgb=mix(color.rgb/alpha,u_fog_color.rgb,fog_opac)*alpha;return color;}vec3 fog_apply_sky_gradient(vec3 camera_ray,vec3 sky_color) {float horizon_blend=fog_horizon_blending(normalize(camera_ray));return mix(sky_color,u_fog_color.rgb,horizon_blend);}vec4 fog_apply_premultiplied(vec4 color,vec3 pos) {float alpha=EPSILON+color.a;color.rgb=fog_apply(color.rgb/alpha,pos)*alpha;return color;}vec4 fog_apply_premultiplied(vec4 color,vec3 pos,float heightMeters) {float verticalProgress=(u_fog_vertical_limit.x > 0.0 || u_fog_vertical_limit.y > 0.0) ? smoothstep(u_fog_vertical_limit.x,u_fog_vertical_limit.y,heightMeters) : 0.0;float opacityLimit=1.0-smoothstep(0.9,1.0,fog_opacity(pos));return mix(fog_apply_premultiplied(color,pos),color,min(verticalProgress,opacityLimit));}vec3 fog_dither(vec3 color) {return color;}vec4 fog_dither(vec4 color) {return vec4(fog_dither(color.rgb),color.a);}\n#endif", ME = "\n#ifndef MAX_UBO_SIZE_VEC4\n#define MAX_UBO_SIZE_VEC4 1024u\n#endif\nfloat zoomFactor(float zm,float zM,float zoomFraction) {if (zm==zM) return zoomFraction-zm >=0.0 ? 1.0 : 0.0;return clamp((zoomFraction-zm)/(zM-zm),0.0,1.0);}", SE = "\n#ifdef LIGHTING_3D_MODE\nuniform mediump vec3 u_lighting_ambient_color;uniform mediump vec3 u_lighting_directional_dir;uniform mediump vec3 u_lighting_directional_color;uniform mediump vec3 u_ground_radiance;float calculate_ambient_directional_factor(vec3 normal) {float NdotL=dot(normal,u_lighting_directional_dir);const float factor_reduction_max=0.3;float dir_luminance=dot(u_lighting_directional_color,vec3(0.2126,0.7152,0.0722));float directional_factor_min=1.0-factor_reduction_max*min(dir_luminance,1.0);float ambient_directional_factor=mix(directional_factor_min,1.0,min((NdotL+1.0),1.0));const float vertical_factor_min=0.92;float vertical_factor=mix(vertical_factor_min,1.0,normal.z*0.5+0.5);return vertical_factor*ambient_directional_factor;}vec3 linearProduct(vec3 srgbIn,vec3 k) {return srgbIn*pow(k,vec3(1./2.2));}vec3 apply_lighting(vec3 color,vec3 normal,float dir_factor) {float ambient_directional_factor=calculate_ambient_directional_factor(normal);vec3 ambient_contrib=ambient_directional_factor*u_lighting_ambient_color;vec3 directional_contrib=u_lighting_directional_color*dir_factor;return linearProduct(color,ambient_contrib+directional_contrib);}vec4 apply_lighting(vec4 color,vec3 normal,float dir_factor) {return vec4(apply_lighting(color.rgb,normal,dir_factor),color.a);}vec3 apply_lighting(vec3 color,vec3 normal) {float dir_factor=max(dot(normal,u_lighting_directional_dir),0.0);return apply_lighting(color.rgb,normal,dir_factor);}vec4 apply_lighting(vec4 color,vec3 normal) {float dir_factor=max(dot(normal,u_lighting_directional_dir),0.0);return vec4(apply_lighting(color.rgb,normal,dir_factor),color.a);}vec3 apply_lighting_ground(vec3 color) {return color*u_ground_radiance;}vec4 apply_lighting_ground(vec4 color) {return vec4(apply_lighting_ground(color.rgb),color.a);}float calculate_NdotL(vec3 normal) {const float ext=0.70710678118;return (clamp(dot(normal,u_lighting_directional_dir),-ext,1.0)+ext)/(1.0+ext);}vec4 apply_lighting_with_emission_ground(vec4 color,float emissive_strength) {return mix(apply_lighting_ground(color),color,emissive_strength);}vec3 compute_flood_lighting(vec3 flood_light_color,float fully_occluded_factor,float occlusion,vec3 ground_shadow_factor) {vec3 fully_occluded_color=flood_light_color*mix(ground_shadow_factor,vec3(1.0),fully_occluded_factor);float occlusion_ramp=smoothstep(0.0,0.2,1.0-occlusion);return mix(fully_occluded_color,flood_light_color,occlusion_ramp);}vec3 compute_emissive_draped(vec3 unlit_color,float fully_occluded_factor,float occlusion,vec3 ground_shadow_factor) {vec3 fully_occluded_color=unlit_color*mix(ground_shadow_factor,vec3(1.0),fully_occluded_factor);return mix(fully_occluded_color,unlit_color,1.0-occlusion);}\n#endif", TE = "#ifdef RASTER_ARRAY\nuniform highp sampler2D u_image0;uniform sampler2D u_image1;const vec4 NODATA=vec4(1);ivec4 _raTexLinearCoord(highp vec2 texCoord,highp vec2 texResolution,out highp vec2 fxy) {texCoord=texCoord*texResolution-0.5;fxy=fract(texCoord);texCoord-=fxy;return ivec4(texCoord.xxyy+vec2(1.5,0.5).xyxy);}vec2 _raTexLinearMix(highp vec2 fxy,highp vec4 colorMix,highp float colorOffset,highp vec4 t00,highp vec4 t10,highp vec4 t01,highp vec4 t11) {vec2 c00=t00==NODATA ? vec2(0) : vec2(colorOffset+dot(t00,colorMix),1);vec2 c10=t10==NODATA ? vec2(0) : vec2(colorOffset+dot(t10,colorMix),1);vec2 c01=t01==NODATA ? vec2(0) : vec2(colorOffset+dot(t01,colorMix),1);vec2 c11=t11==NODATA ? vec2(0) : vec2(colorOffset+dot(t11,colorMix),1);return mix(mix(c01,c11,fxy.x),mix(c00,c10,fxy.x),fxy.y);}vec2 raTexture2D_image0_linear(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec2 fxy;ivec4 c=_raTexLinearCoord(texCoord,texResolution,fxy);return _raTexLinearMix(fxy,colorMix,colorOffset,texelFetch(u_image0,c.yz,0),texelFetch(u_image0,c.xz,0),texelFetch(u_image0,c.yw,0),texelFetch(u_image0,c.xw,0)\n);}vec2 raTexture2D_image1_linear(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec2 fxy;ivec4 c=_raTexLinearCoord(texCoord,texResolution,fxy);return _raTexLinearMix(fxy,colorMix,colorOffset,texelFetch(u_image1,c.yz,0),texelFetch(u_image1,c.xz,0),texelFetch(u_image1,c.yw,0),texelFetch(u_image1,c.xw,0)\n);}vec2 raTexture2D_image0_nearest(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec4 t=texelFetch(u_image0,ivec2(texCoord*texResolution),0);return t==NODATA ? vec2(0) : vec2(colorOffset+dot(t,colorMix),1);}vec2 raTexture2D_image1_nearest(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec4 t=texelFetch(u_image1,ivec2(texCoord*texResolution),0);return t==NODATA ? vec2(0) : vec2(colorOffset+dot(t,colorMix),1);}\n#endif", zE = "#ifdef RENDER_SHADOWS\nuniform mediump vec3 u_shadow_direction;uniform highp vec3 u_shadow_normal_offset;vec3 shadow_normal_offset(vec3 normal) {float tileInMeters=u_shadow_normal_offset[0];vec3 n=vec3(-normal.xy,tileInMeters*normal.z);float dotScale=min(1.0-dot(normal,u_shadow_direction),1.0)*0.5+0.5;return n*dotScale;}vec3 shadow_normal_offset_model(vec3 normal) {vec3 transformed_normal=vec3(-normal.xy,normal.z);float NDotL=dot(normalize(transformed_normal),u_shadow_direction);float dotScale=min(1.0-NDotL,1.0)*0.5+0.5;return normal*dotScale;}float shadow_normal_offset_multiplier0() {return u_shadow_normal_offset[1];}float shadow_normal_offset_multiplier1() {return u_shadow_normal_offset[2];}\n#endif", RE = "#ifdef RENDER_SHADOWS\nprecision highp sampler2DShadow;uniform sampler2DShadow u_shadowmap_0;uniform sampler2DShadow u_shadowmap_1;uniform float u_shadow_intensity;uniform float u_shadow_map_resolution;uniform float u_shadow_texel_size;uniform highp vec3 u_shadow_normal_offset;uniform vec2 u_fade_range;uniform mediump vec3 u_shadow_direction;uniform highp vec3 u_shadow_bias;highp vec2 shadow_map_ndc_to_uv(highp vec2 ndc_xy) {return ndc_xy*0.5+0.5;}highp vec3 shadow_map_ndc_to_sample_space(highp vec3 ndc) {return vec3(shadow_map_ndc_to_uv(ndc.xy),native_ndc_z_to_storage_depth(ndc.z));}float shadow_sample(sampler2DShadow shadowmap,highp vec3 pos,highp float bias) {highp vec3 coord=vec3(shadow_map_ndc_to_uv(pos.xy),native_ndc_z_to_storage_depth(pos.z)-bias);return texture(shadowmap,coord);}float shadow_occlusion(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth,highp float bias) {light_view_pos0.xyz/=light_view_pos0.w;\n#ifdef SHADOWS_SINGLE_CASCADE\nvec2 abs_bounds=abs(light_view_pos0.xy);if (abs_bounds.x >=1.0 || abs_bounds.y >=1.0) {return 0.0;}return shadow_sample(u_shadowmap_0,light_view_pos0.xyz,bias);\n#else\nlight_view_pos1.xyz/=light_view_pos1.w;vec4 abs_bounds=abs(vec4(light_view_pos0.xy,light_view_pos1.xy));if (abs_bounds.x < 1.0 && abs_bounds.y < 1.0) {return shadow_sample(u_shadowmap_0,light_view_pos0.xyz,bias);}if (abs_bounds.z >=1.0 || abs_bounds.w >=1.0) {return 0.0;}float occlusion1=shadow_sample(u_shadowmap_1,light_view_pos1.xyz,bias);return clamp(mix(occlusion1,0.0,smoothstep(u_fade_range.x,u_fade_range.y,view_depth)),0.0,1.0);\n#endif\n}highp float calculate_shadow_bias(float NDotL) {\n#ifdef NORMAL_OFFSET\nreturn 0.5*u_shadow_bias.x;\n#else\nreturn 0.5*(u_shadow_bias.x+clamp(u_shadow_bias.y*tan(acos(NDotL)),0.0,u_shadow_bias.z));\n#endif\n}float shadowed_light_factor_normal(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float NDotL=dot(N,u_shadow_direction);float bias=calculate_shadow_bias(NDotL);float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor_normal_opacity(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth,float shadow_opacity) {float NDotL=dot(N,u_shadow_direction);float bias=calculate_shadow_bias(NDotL);float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias)*shadow_opacity;return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor_normal_unbiased(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float NDotL=dot(N,u_shadow_direction);float bias=0.0;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}highp vec2 compute_receiver_plane_depth_bias(highp vec3 pos_dx,highp vec3 pos_dy)\n{highp vec2 biasUV=vec2(\npos_dy.y*pos_dx.z-pos_dx.y*pos_dy.z,pos_dx.x*pos_dy.z-pos_dy.x*pos_dx.z);biasUV*=1.0/((pos_dx.x*pos_dy.y)-(pos_dx.y*pos_dy.x));return biasUV;}float shadowed_light_factor_plane_bias(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {highp vec3 light_view_pos0_xyz=shadow_map_ndc_to_sample_space(light_view_pos0.xyz/light_view_pos0.w);highp vec3 light_view_pos0_ddx=dFdx(light_view_pos0_xyz);highp vec3 light_view_pos0_ddy=dFdy(light_view_pos0_xyz);highp vec2 plane_depth_bias=compute_receiver_plane_depth_bias(light_view_pos0_ddx,light_view_pos0_ddy);highp float bias=dot(vec2(u_shadow_texel_size,u_shadow_texel_size),plane_depth_bias)+0.0001;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return 1.0-(u_shadow_intensity*occlusion);}float shadowed_light_factor(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float bias=0.0;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return 1.0-(u_shadow_intensity*occlusion);}float shadow_occlusion(float ndotl,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float bias=calculate_shadow_bias(ndotl);return shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);}\n#endif";
        const PE = /^#include\s+"([^"]+)"\s*\r?\n/gm, DE = /#pragma mapbox: ([\w\-]+) ([\w]+) ([\w]+) ([\w]+)/g, FE = /\b[A-Za-z_][A-Za-z0-9_]*\b/g, CE = new Set([
            "ifdef",
            "ifndef",
            "elif",
            "if",
            "defined"
        ]), OE = new Set;
        $E(xE, OE), $E(bE, OE), $E(vE, OE);
        const LE = {
            "_prelude_fog.vertex.glsl": EE,
            "_prelude_terrain.vertex.glsl": AE,
            "_prelude_shadow.vertex.glsl": zE,
            "_prelude_material_table.vertex.glsl": "",
            "_prelude_fog.fragment.glsl": IE,
            "_prelude_shadow.fragment.glsl": RE,
            "_prelude_lighting.glsl": SE,
            "_prelude_ubo_properties.glsl": ME,
            "_prelude_raster_array.glsl": TE,
            "_prelude_indicator_cutout.fragment.glsl": "\nvec4 applyCutout(vec4 color,float height) {return color;}",
            "_prelude_feature_cutout.fragment.glsl": "// feature cutout (gl-native only)\n",
            "_prelude_feature_cutout.vertex.glsl": "// feature cutout (gl-native only)\n"
        }, BE = {}, VE = "precision highp float;", NE = "precision mediump float;", kE = "\n#if defined(GL_EXT_blend_func_extended) && defined(DUAL_SOURCE_BLENDING)\n#extension GL_EXT_blend_func_extended : require\n#endif", UE = {
            preludeTerrain: WE("", AE),
            preludeUBOProperties: WE("", ME),
            preludeFog: WE(IE, EE),
            preludeShadow: WE(RE, zE),
            preludeRasterArray: WE(TE, ""),
            preludeLighting: WE(SE, SE),
            preludePrecisionQualifiers: WE(NE, VE),
            prelude: WE(vE, bE),
            preludeExtensions: WE(kE, "")
        }, jE = [
            kE,
            NE,
            xE,
            UE.prelude.fragmentSource
        ].join("\n"), GE = [
            VE,
            xE,
            UE.prelude.vertexSource
        ].join("\n");
        var HE = {
            background: WE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_feature_cutout.fragment.glsl"\nuniform vec4 u_color;uniform float u_opacity;uniform mediump float u_emissive_strength;\n#ifdef LIGHTING_3D_MODE\nin vec4 v_color;\n#endif\nvoid main() {vec4 out_color;\n#ifdef LIGHTING_3D_MODE\nout_color=v_color;\n#else\nout_color=u_color;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*u_opacity;storeEmissiveColor(glFragColor,u_emissive_strength);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_lighting.glsl"\nin ivec2 a_pos;uniform mat4 u_matrix;uniform mediump float u_emissive_strength;\n#ifdef LIGHTING_3D_MODE\nuniform mediump vec4 u_color;out vec4 v_color;\n#endif\nvoid main() {gl_Position=u_matrix*vec4(a_pos,0,1);\n#ifdef LIGHTING_3D_MODE\nv_color=apply_lighting_with_emission_ground(u_color,u_emissive_strength);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(vec2(a_pos));\n#endif\n}'),
            backgroundPattern: WE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_pattern_tl;uniform vec2 u_pattern_br;uniform vec2 u_texsize;uniform float u_opacity;uniform float u_emissive_strength;uniform sampler2D u_image;in highp vec2 v_pos;void main() {highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(u_pattern_tl/u_texsize,u_pattern_br/u_texsize,imagecoord);vec4 out_color=textureLodCustom(u_image,pos,v_pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*u_opacity;storeEmissiveColor(glFragColor,u_emissive_strength);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pattern_size;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec2 u_pattern_units_to_pixels;in ivec2 a_pos;out highp vec2 v_pos;void main() {vec2 pos=vec2(a_pos);gl_Position=u_matrix*vec4(pos,0,1);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_pattern_size,u_pattern_units_to_pixels,pos);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            circle: WE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin vec3 v_data;in float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nuniform float u_emissive_strength;void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float blur_positive=blur < 0.0 ? 0.0 : 1.0;lowp float antialiasblur=v_data.z;float extrude_length=length(extrude)+antialiasblur*(1.0-blur_positive);float antialiased_blur=-max(abs(blur),antialiasblur);float antialiase_blur_opacity=smoothstep(0.0,antialiasblur,extrude_length-1.0);float opacity_t=blur_positive==1.0 ?\nsmoothstep(0.0,-antialiased_blur,1.0-extrude_length) :\nsmoothstep(antialiased_blur,0.0,extrude_length-1.0)-antialiase_blur_opacity;float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(\nantialiased_blur,0.0,extrude_length-radius/(radius+stroke_width)\n);vec4 out_color=mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_apply_premultiplied(out_color,v_fog_pos);\n#endif\nglFragColor=out_color*(v_visibility*opacity_t);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define NUM_VISIBILITY_RINGS 2\n#define INV_SQRT2 0.70710678\n#define ELEVATION_BIAS 0.0001\n#define NUM_VISIBILITY_SAMPLES_PER_RING 16\nuniform mat4 u_matrix;uniform mat2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;in ivec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin ivec4 a_pos_3;in ivec4 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\n#ifdef ELEVATED_ROADS\nin float a_circle_z_offset;\n#endif\nout vec3 v_data;out float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvec2 calc_offset(vec2 extrusion,float radius,float stroke_width, float perspective_scale) {return extrusion*(radius+stroke_width)*u_extrude_scale*perspective_scale;}float cantilevered_elevation(vec2 pos,float radius,float stroke_width,float perspective_scale) {vec2 c1=pos+calc_offset(vec2(-1.0,-1.0),radius,stroke_width,perspective_scale);vec2 c2=pos+calc_offset(vec2(1.0,-1.0),radius,stroke_width,perspective_scale);vec2 c3=pos+calc_offset(vec2(1.0,1.0),radius,stroke_width,perspective_scale);vec2 c4=pos+calc_offset(vec2(-1.0,1.0),radius,stroke_width,perspective_scale);float h1=elevation(c1)+ELEVATION_BIAS;float h2=elevation(c2)+ELEVATION_BIAS;float h3=elevation(c3)+ELEVATION_BIAS;float h4=elevation(c4)+ELEVATION_BIAS;return max(h4,max(h3,max(h1,h2)));}float circle_elevation(vec2 pos) {\n#if defined(TERRAIN)\nreturn elevation(pos)+ELEVATION_BIAS;\n#else\nreturn 0.0;\n#endif\n}vec4 project_vertex(vec2 extrusion,vec4 world_center,vec4 projected_center,float radius,float stroke_width, float perspective_scale,mat3 surface_vectors) {vec2 sample_offset=calc_offset(extrusion,radius,stroke_width,perspective_scale);\n#ifdef PITCH_WITH_MAP\n#ifdef PROJECTION_GLOBE_VIEW\nreturn u_matrix*( world_center+vec4(sample_offset.x*surface_vectors[0]+sample_offset.y*surface_vectors[1],0) );\n#else\nreturn u_matrix*( world_center+vec4(sample_offset,0,0) );\n#endif\n#else\nreturn projected_center+vec4(sample_offset,0,0);\n#endif\n}void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 pos2=vec2(a_pos);vec2 extrude=vec2(mod(pos2,2.0)*2.0-1.0);vec2 circle_center=floor(pos2*0.5);float height=circle_elevation(circle_center);vec4 world_center;mat3 surface_vectors;\n#ifdef PROJECTION_GLOBE_VIEW\nsurface_vectors=globe_mercator_surface_vectors(vec3(a_pos_normal_3)/16384.0,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(circle_center)*height;vec3 globe_pos=vec3(a_pos_3)+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*height;vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,circle_center,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;vec3 pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);world_center=vec4(pos,1);\n#else\nsurface_vectors=mat3(1.0);world_center=vec4(circle_center,height,1);\n#endif\n#ifdef ELEVATED_ROADS\nworld_center.z+=a_circle_z_offset+ELEVATION_BIAS;\n#endif\nvec4 projected_center=u_matrix*world_center;float perspective_scale=0.0;\n#ifdef PITCH_WITH_MAP\n#ifdef SCALE_WITH_MAP\nperspective_scale=1.0;\n#else\nperspective_scale=projected_center.w/u_camera_to_center_distance;\n#endif\n#else\n#ifdef SCALE_WITH_MAP\nperspective_scale=u_camera_to_center_distance;\n#else\nperspective_scale=projected_center.w;\n#endif\n#endif\ngl_Position=project_vertex(extrude,world_center,projected_center,radius,stroke_width,perspective_scale,surface_vectors);float terrain_visibility=0.0;\n#ifdef TERRAIN\nfloat arc;vec4 occlusion_world_center;vec4 occlusion_projected_center;\n#ifdef PITCH_WITH_MAP\narc=2.0*PI;float cantilevered_height=cantilevered_elevation(circle_center,radius,stroke_width,perspective_scale);occlusion_world_center=vec4(circle_center,cantilevered_height,1);occlusion_projected_center=u_matrix*occlusion_world_center;\n#else\narc=PI;occlusion_world_center=world_center;occlusion_projected_center=projected_center;\n#endif\nfloat step=arc/float(NUM_VISIBILITY_SAMPLES_PER_RING);for(int ring=0; ring < NUM_VISIBILITY_RINGS; ring++) {float ring_radius_fraction=(float(ring)+1.0)/float(NUM_VISIBILITY_RINGS);for(int i=0; i < NUM_VISIBILITY_SAMPLES_PER_RING; i++) {vec2 extrusion=vec2(cos(step*float(i)),-sin(step*float(i)))*ring_radius_fraction;vec4 frag_pos=project_vertex(extrusion,occlusion_world_center,occlusion_projected_center,radius,stroke_width,perspective_scale,surface_vectors);terrain_visibility+=float(!isOccluded(frag_pos));}}terrain_visibility/=float(NUM_VISIBILITY_RINGS)*float(NUM_VISIBILITY_SAMPLES_PER_RING);\n#else\nterrain_visibility=1.0;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nterrain_visibility=1.0;\n#endif\nv_visibility=terrain_visibility;lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);\n#ifdef FOG\nv_fog_pos=fog_position(world_center.xyz);\n#endif\n}'),
            clippingMask: WE("void main() {glFragColor=vec4(1.0);}", "in ivec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),
            heatmap: WE('#include "_prelude_fog.fragment.glsl"\nuniform highp float u_intensity;in vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);glFragColor=vec4(val,1.0,1.0,1.0);\n#ifdef FOG\nif (u_is_globe==0) {glFragColor.r*=pow(1.0-fog_opacity(v_fog_pos),2.0);}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_intensity;in ivec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin ivec4 a_pos_3;in ivec4 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nout vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(vec2(a_pos),2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 tilePos=floor(vec2(a_pos)*0.5);vec3 pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=vec3(a_pos_normal_3)/16384.0;mat3 surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(tilePos)*elevation(tilePos);vec3 globe_pos=vec3(a_pos_3)+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*elevation(tilePos);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,tilePos,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#else\npos=vec3(tilePos+extrude,elevation(tilePos));\n#endif\ngl_Position=u_matrix*vec4(pos,1);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            heatmapTexture: WE("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;in vec2 v_pos;void main() {float t=texture(u_image,v_pos).r;vec4 color=texture(u_color_ramp,vec2(t,0.5));glFragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(0.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}", "in ivec2 a_pos;out vec2 v_pos;void main() {gl_Position=vec4(a_pos,0,1);v_pos=bottom_left_to_native_uv(vec2(a_pos)*0.5+0.5);}"),
            collisionBox: WE("in float v_placed;in float v_notUsed;void main() {vec4 red =vec4(1.0,0.0,0.0,1.0);vec4 blue=vec4(0.0,0.0,1.0,0.5);glFragColor =mix(red,blue,step(0.5,v_placed))*0.5;glFragColor*=mix(1.0,0.1,step(0.5,v_notUsed));}", '#include "_prelude_terrain.vertex.glsl"\nin ivec4 a_pos;in ivec2 a_anchor_pos;in ivec2 a_extrude;in uvec2 a_placed;in vec2 a_shift;in vec2 a_elevation_from_sea;in float a_size_scale;in vec2 a_padding;in float a_auto_z_offset;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform float u_zoom_transition;\n#endif\nout float v_placed;out float v_notUsed;void main() {vec2 anchor_pos=vec2(a_anchor_pos);float feature_elevation=a_elevation_from_sea.x+a_auto_z_offset;float terrain_elevation=(a_elevation_from_sea.y==1.0 ? 0.0 : elevation(anchor_pos));vec3 proj_pos=vec3(a_pos)+elevationVector(anchor_pos)*(feature_elevation+terrain_elevation);\n#ifdef PROJECTION_GLOBE_VIEW\n#ifndef PROJECTED_POS_ON_VIEWPORT\nvec3 globe_pos=proj_pos;vec3 mercator_pos=mercator_tile_position(u_inv_rot_matrix,anchor_pos,u_tile_id,u_merc_center);proj_pos=mix_globe_mercator(globe_pos,mercator_pos,u_zoom_transition);\n#endif\n#endif\nvec4 projectedPoint=u_matrix*vec4(proj_pos,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,1.5);gl_Position=projectedPoint;gl_Position.xy+=(vec2(a_extrude)*a_size_scale+a_shift+a_padding)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=float(a_placed.x);v_notUsed=float(a_placed.y);}'),
            collisionCircle: WE("in float v_radius;in vec2 v_extrude;in float v_perspective_ratio;in float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);glFragColor=color*alpha*opacity_t;}", "in vec2 a_pos_2f;in float a_radius;in ivec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;out float v_radius;out vec2 v_extrude;out float v_perspective_ratio;out float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 anchorScreenPos=a_pos_2f;float radius=a_radius;int vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(\nmix(-1.0,1.0,float(vertexIdx >=2)),mix(-1.0,1.0,float(vertexIdx >=1 && vertexIdx <=2)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(anchorScreenPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=float(a_flags.x);gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),
            placementDebug: WE("uniform vec4 u_color;uniform float u_outline_width;uniform float u_opacity;uniform float u_stroke_opacity;uniform float u_collision_padding_opacity;in vec2 v_offset;in vec2 v_half_size;in float v_is_circle;in float v_collision_padding;float boxDistance(vec2 offset,vec2 halfSize) {vec2 toCorner=abs(offset)-halfSize;return max(toCorner.x,toCorner.y);}float circleDistance(vec2 offset,float radius) {return length(offset)-radius;}float linearStep(float start,float end,float x) {return (clamp(x,start,end)-start)/(end-start);}float onePxLongLinearStepAt(float center,float x) {const float halfPx=0.5;return linearStep(center-halfPx,center+halfPx,x);}void main() {float distanceToEdge=mix(boxDistance(v_offset,v_half_size),circleDistance(v_offset,v_half_size.x),v_is_circle);float linearStepAtMinusOutlineWidth=onePxLongLinearStepAt(-u_outline_width,distanceToEdge);float linearStepAtZero=onePxLongLinearStepAt(0.0,distanceToEdge);float linearStepAtCollisionPadding=onePxLongLinearStepAt(v_collision_padding,distanceToEdge);float interiorCoverage=1.0-linearStepAtMinusOutlineWidth;float outlineCoverage=linearStepAtMinusOutlineWidth-linearStepAtZero;float collisionPaddingCoverage=linearStepAtZero-linearStepAtCollisionPadding;glFragColor=u_color*(u_opacity*interiorCoverage+u_stroke_opacity*outlineCoverage+u_collision_padding_opacity*collisionPaddingCoverage);}", "\nin vec2 a_pos_2f;in vec2 a_size;in float a_collision_padding;in ivec2 a_flags;uniform vec2 u_viewport_size;out vec2 v_offset;out vec2 v_half_size;out float v_is_circle;out float v_collision_padding;const vec2 QUAD_CORNERS[4]=vec2[4](vec2(-1.0,-1.0),vec2(1.0,-1.0),vec2(1.0,1.0),vec2(-1.0,1.0));const float AA_width=1.0;void main() {vec2 offset=QUAD_CORNERS[a_flags.y]*(a_size+a_collision_padding+AA_width);v_offset=offset;v_half_size=a_size;v_is_circle=float(a_flags.x);v_collision_padding=a_collision_padding;vec2 viewportPos=(a_pos_2f+offset)/u_viewport_size;gl_Position=vec4(viewportPos*vec2(2.0,-2.0)+vec2(-1.0,1.0),0.0,1.0);}"),
            debug: WE("uniform highp vec4 u_color;uniform sampler2D u_overlay;in vec2 v_uv;void main() {vec4 overlay_color=texture(u_overlay,v_uv);glFragColor=mix(u_color,overlay_color,overlay_color.a);}", '#include "_prelude_terrain.vertex.glsl"\nin ivec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin ivec4 a_pos_3;\n#endif\nout vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {vec2 pos=vec2(a_pos);float h=elevation(pos);v_uv=pos/8192.0;\n#ifdef PROJECTION_GLOBE_VIEW\ngl_Position=u_matrix*vec4(vec3(a_pos_3)+elevationVector(pos)*h,1);\n#else\ngl_Position=u_matrix*vec4(pos*u_overlay_scale,h,1);\n#endif\n}'),
            fill: WE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_indicator_cutout.fragment.glsl"\n#include "_prelude_feature_cutout.fragment.glsl"\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nuniform float u_emissive_strength;uniform lowp float u_opacity_multiplier;\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\nvec2 cutout_factors=vec2(0.0);vec4 out_color=color;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);light=mix(light,1.0,cutout_factors.y);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nout_color*=(opacity*u_opacity_multiplier);glFragColor=out_color;storeEmissiveColor(glFragColor,u_emissive_strength);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin ivec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;out highp float v_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\nuniform mat4 u_matrix;uniform lowp float u_opacity_multiplier;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp float z_offset\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;v_road_z_offset=z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(vec2(a_pos));\n#endif\n}'),
            fillOutline: WE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_feature_cutout.fragment.glsl"\nin highp vec2 v_pos;uniform float u_emissive_strength;uniform lowp float u_opacity_multiplier;\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=outline_color;vec2 cutout_factors=vec2(0.0);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);light=mix(light,1.0,cutout_factors.y);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*(alpha*opacity*u_opacity_multiplier);storeEmissiveColor(glFragColor,u_emissive_strength);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin ivec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;out highp float v_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\nuniform mat4 u_matrix;uniform vec2 u_world;uniform lowp float u_opacity_multiplier;out highp vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp float z_offset\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;v_road_z_offset=z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);v_pos=ndc_xy_to_framebuffer_uv(gl_Position.xy/gl_Position.w)*u_world;\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(vec2(a_pos));\n#endif\n}'),
            fillOutlinePattern: WE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_feature_cutout.fragment.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;\n#ifdef FILL_PATTERN_TRANSITION\nuniform float u_pattern_transition;\n#endif\nuniform float u_emissive_strength;uniform lowp float u_opacity_multiplier;\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\nin highp vec2 v_pos;in highp vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp uvec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: define mediump uvec4 pattern_b\n#endif\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump uvec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump uvec4 pattern_b\n#endif\nvec2 pattern_tl=vec2(pattern.xy);vec2 pattern_br=vec2(pattern.zw);highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);float dist=length(v_pos_world-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef APPLY_LUT_ON_GPU\nout_color=applyLUT(u_lutTexture,out_color);\n#endif\n#ifdef FILL_PATTERN_TRANSITION\nvec2 pattern_b_tl=vec2(pattern_b.xy);vec2 pattern_b_br=vec2(pattern_b.zw);highp vec2 pos_b=mix(pattern_b_tl/u_texsize,pattern_b_br/u_texsize,imagecoord);vec4 color_b=textureLodCustom(u_image,pos_b,lod_pos);out_color=out_color*(1.0-u_pattern_transition)+color_b*u_pattern_transition;\n#endif\nvec2 cutout_factors=vec2(0.0);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);light=mix(light,1.0,cutout_factors.y);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*(alpha*opacity*u_opacity_multiplier);storeEmissiveColor(glFragColor,u_emissive_strength);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_world;uniform lowp float u_opacity_multiplier;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in ivec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;out highp float v_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\nout highp vec2 v_pos;out highp vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp uvec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: define mediump uvec4 pattern_b\n#endif\n#pragma mapbox: define lowp float pixel_ratio\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump uvec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump uvec4 pattern_b\n#endif\n#pragma mapbox: initialize lowp float pixel_ratio\n#pragma mapbox: initialize highp float z_offset\nvec2 pattern_tl=vec2(pattern.xy);vec2 pattern_br=vec2(pattern.zw);\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;v_road_z_offset=z_offset;\n#endif\nfloat hidden=float(opacity==0.0);vec2 pos=vec2(a_pos);gl_Position=mix(u_matrix*vec4(pos,z_offset,1),AWAY,hidden);vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,pos);v_pos_world=ndc_xy_to_framebuffer_uv(gl_Position.xy/gl_Position.w)*u_world;\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(pos,z_offset);vec3 shd_pos1=vec3(pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            fillPattern: WE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_feature_cutout.fragment.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;\n#ifdef FILL_PATTERN_TRANSITION\nuniform float u_pattern_transition;\n#endif\nin highp vec2 v_pos;uniform float u_emissive_strength;uniform lowp float u_opacity_multiplier;\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp uvec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: define mediump uvec4 pattern_b\n#endif\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump uvec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump uvec4 pattern_b\n#endif\nvec2 pattern_tl=vec2(pattern.xy);vec2 pattern_br=vec2(pattern.zw);highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef APPLY_LUT_ON_GPU\nout_color=applyLUT(u_lutTexture,out_color);\n#endif\n#ifdef FILL_PATTERN_TRANSITION\nvec2 pattern_b_tl=vec2(pattern_b.xy);vec2 pattern_b_br=vec2(pattern_b.zw);highp vec2 pos_b=mix(pattern_b_tl/u_texsize,pattern_b_br/u_texsize,imagecoord);vec4 color_b=textureLodCustom(u_image,pos_b,lod_pos);out_color=out_color*(1.0-u_pattern_transition)+color_b*u_pattern_transition;\n#endif\nvec2 cutout_factors=vec2(0.0);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);light=mix(light,1.0,cutout_factors.y);\n#ifdef ELEVATED_ROADS\nout_color.rgb*=mix(v_road_z_offset !=0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);\n#else\nout_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*(opacity*u_opacity_multiplier);storeEmissiveColor(glFragColor,u_emissive_strength);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nuniform mat4 u_matrix;uniform lowp float u_opacity_multiplier;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in ivec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;out highp float v_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\nout highp vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp uvec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: define mediump uvec4 pattern_b\n#endif\n#pragma mapbox: define lowp float pixel_ratio\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump uvec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\n#pragma mapbox: initialize highp float z_offset\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump uvec4 pattern_b\n#endif\nvec2 pattern_tl=vec2(pattern.xy);vec2 pattern_br=vec2(pattern.zw);vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;v_road_z_offset=z_offset;\n#endif\nfloat hidden=float(opacity==0.0);vec2 pos=vec2(a_pos);gl_Position=mix(u_matrix*vec4(pos,z_offset,1),AWAY,hidden);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,pos);\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(pos,z_offset);vec3 shd_pos1=vec3(pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            lineBlendComposite: WE("uniform highp sampler2D u_image;uniform float u_opacity;uniform int u_blend_mode;uniform highp float u_max_density;in vec2 v_pos;\n#define ADDITIVE 1\nvoid main() {vec4 color=texture(u_image,v_pos);if (u_blend_mode==ADDITIVE) {if (color.a <=0.0) {discard;}highp float density=color.a;vec3 avgColor=color.rgb/max(density,0.001);highp float n=density/max(u_max_density,0.001);highp float t=sqrt(n/(n+1.0));glFragColor=vec4(avgColor*t,t);} else {vec3 multiplyFactor=color.rgb*u_opacity+(1.0-u_opacity);glFragColor=vec4(multiplyFactor,1.0);}\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(0.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}", "in ivec2 a_pos;out vec2 v_pos;void main() {gl_Position=vec4(a_pos,0,1);v_pos=vec2(a_pos)*0.5+0.5;}"),
            lineBlendReduce: WE("uniform highp sampler2D u_image;uniform vec2 u_texel_size;uniform bool u_first_pass;in vec2 v_pos;void main() {vec2 o=u_texel_size*0.5;vec4 s0=texture(u_image,v_pos+vec2(-o.x,-o.y));vec4 s1=texture(u_image,v_pos+vec2( o.x,-o.y));vec4 s2=texture(u_image,v_pos+vec2(-o.x, o.y));vec4 s3=texture(u_image,v_pos+vec2( o.x, o.y));float r0; float g0;float r1; float g1;float r2; float g2;float r3; float g3;if (u_first_pass) {float a0=s0.a;float a1=s1.a;float a2=s2.a;float a3=s3.a;r0=a0; g0=a0 > 0.0 ? 1.0 : 0.0;r1=a1; g1=a1 > 0.0 ? 1.0 : 0.0;r2=a2; g2=a2 > 0.0 ? 1.0 : 0.0;r3=a3; g3=a3 > 0.0 ? 1.0 : 0.0;} else {r0=s0.r; g0=s0.g;r1=s1.r; g1=s1.g;r2=s2.r; g2=s2.g;r3=s3.r; g3=s3.g;}glFragColor=vec4((r0+r1+r2+r3)*0.25,(g0+g1+g2+g3)*0.25,0.0,0.0);}", "in ivec2 a_pos;out vec2 v_pos;void main() {gl_Position=vec4(a_pos,0,1);v_pos=vec2(a_pos)*0.5+0.5;}"),
            fillExtrusion: WE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_indicator_cutout.fragment.glsl"\n#include "_prelude_feature_cutout.fragment.glsl"\nin vec4 v_color;in vec4 v_flat;\n#if defined(RENDER_FRONT_CUTOFF) || defined(ROUTE_CORRIDOR)\nin float v_dither_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;\n#endif\nuniform lowp float u_opacity;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;in vec2 v_ao;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nin vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nin highp vec3 v_normal;\n#endif\nuniform vec3 u_flood_light_color;uniform highp float u_vertical_scale;uniform float u_flood_light_intensity;uniform vec3 u_ground_shadow_factor;\n#if defined(LIGHTING_3D_MODE) && defined(FLOOD_LIGHT)\nin float v_flood_radius;in float v_has_floodlight;\n#endif\nin float v_height;\n#pragma mapbox: define highp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp float emissive_strength\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nvec3 normal=normalize(v_normal);\n#endif\nfloat z;vec4 color=v_color;\n#ifdef ZERO_ROOF_RADIUS\nz=float(normal.z > 0.00001);\n#ifdef LIGHTING_3D_MODE\nnormal=mix(normal,vec3(0.0,0.0,1.0),z);\n#else\ncolor=mix(v_color,v_roof_color,z);\n#endif\n#endif\nfloat h=max(0.0,v_height);float ao_shade=1.0;\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h_floors=h/(u_ao[1]*u_vertical_scale);float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);ao_shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;\n#ifdef ZERO_ROOF_RADIUS\nconcave*=(1.0-z);\n#endif\nfloat x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);ao_shade*=mix(1.0,x_shade*x_shade*x_shade,concave);\n#ifdef LIGHTING_3D_MODE\n#ifdef FLOOD_LIGHT\ncolor.rgb*=mix(ao_shade,1.0,v_has_floodlight);\n#else\ncolor.rgb*=ao_shade;\n#endif\n#else\ncolor.rgb*=ao_shade;\n#endif\n#endif\n#ifdef LIGHTING_3D_MODE\nfloat flood_radiance=0.0;\n#ifdef FLOOD_LIGHT\nflood_radiance=(1.0-min(h/v_flood_radius,1.0))*u_flood_light_intensity*v_has_floodlight;\n#endif\n#ifdef RENDER_SHADOWS\n#ifdef FLOOD_LIGHT\nfloat ndotl_unclamped=dot(normal,u_shadow_direction);float ndotl=max(0.0,ndotl_unclamped);float occlusion=ndotl_unclamped < 0.0 ? 1.0 : shadow_occlusion(ndotl,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);vec3 litColor=apply_lighting(color.rgb,normal,(1.0-u_shadow_intensity*occlusion)*ndotl);vec3 floodLitColor=compute_flood_lighting(u_flood_light_color*u_opacity,1.0-u_shadow_intensity,occlusion,u_ground_shadow_factor);color.rgb=mix(litColor,floodLitColor,flood_radiance);\n#else\nfloat shadowed_lighting_factor;\n#ifdef RENDER_CUTOFF\nshadowed_lighting_factor=shadowed_light_factor_normal_opacity(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w,v_cutoff_opacity);if (v_cutoff_opacity==0.0) {discard;}\n#else\nshadowed_lighting_factor=shadowed_light_factor_normal(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);\n#endif\ncolor.rgb=apply_lighting(color.rgb,normal,shadowed_lighting_factor);\n#endif\n#else\ncolor.rgb=apply_lighting(color.rgb,normal);\n#ifdef FLOOD_LIGHT\ncolor.rgb=mix(color.rgb,u_flood_light_color*u_opacity,flood_radiance);\n#endif\n#endif\ncolor.rgb=mix(color.rgb,v_flat.rgb,emissive_strength);color*=u_opacity;\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos,h));\n#endif\n#if defined(RENDER_FRONT_CUTOFF) || defined(ROUTE_CORRIDOR)\nif (v_dither_opacity < 1.0) {int index=viewport_dither_index(gl_FragCoord.xy);if (v_dither_opacity < DITHER_THRESHOLDS[index]) {discard;}}\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_material_table.vertex.glsl"\n#include "_prelude_feature_cutout.vertex.glsl"\nuniform mat4 u_matrix;\n#ifndef LIGHTING_3D_MODE\nuniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;\n#endif\nuniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_edge_radius;uniform float u_width_scale;in ivec4 a_pos_normal_ed;\n#if defined(HAS_CENTROID) || defined(TERRAIN)\nin uvec2 a_centroid_pos;\n#endif\n#ifdef RENDER_WALL_MODE\nin ivec4 a_join_normal_inside;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin ivec4 a_pos_3;in ivec4 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\n#ifdef TERRAIN\nuniform int u_height_type;uniform int u_base_type;\n#endif\nuniform highp float u_vertical_scale;\n#if defined(RENDER_FRONT_CUTOFF) || defined(ROUTE_CORRIDOR)\n#ifdef RENDER_FRONT_CUTOFF\nuniform vec3 u_front_cutoff_params;\n#endif\nout float v_dither_opacity;\n#endif\nout vec4 v_color;out vec4 v_flat;\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nout vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nout highp vec3 v_normal;\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;out vec2 v_ao;invariant gl_Position;\n#endif\n#if defined(LIGHTING_3D_MODE) && defined(FLOOD_LIGHT)\nout float v_flood_radius;out float v_has_floodlight;\n#endif\nout float v_height;vec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define highp float flood_light_wall_radius\n#pragma mapbox: define highp float line_width\n#pragma mapbox: define highp float emissive_strength\nvoid main() {DECLARE_MATERIAL_TABLE_INFO\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize highp float flood_light_wall_radius\n#pragma mapbox: initialize highp float line_width\n#pragma mapbox: initialize highp float emissive_strength\nbase*=u_vertical_scale;height*=u_vertical_scale;vec4 top_up_ny_start=vec4(a_pos_normal_ed & 1);vec4 pos_nx=vec4(a_pos_normal_ed >> 1);float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny_start.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny_start.z-1.0)*(1.0-abs(x_normal)),0.0));\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nv_normal=normal;\n#endif\nbase=max(0.0,base);float attr_height=height;height=max(0.0,top_up_ny_start.y==0.0 && top_up_ny_start.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny_start.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=vec2(a_centroid_pos);\n#endif\nfloat ele=0.0;float h=0.0;float c_ele=0.0;vec3 pos;\n#ifdef TERRAIN\nbool is_flat_height=centroid_pos.x !=0.0 && u_height_type==1;bool is_flat_base=centroid_pos.x !=0.0 && u_base_type==1;ele=elevation(pos_nx.xy);bool is_elevation_encoded=centroid_pos.y==0.0 || (centroid_pos.y > 0.0 && (int(centroid_pos.y) & 7)==7);c_ele=is_flat_height || is_flat_base ? (is_elevation_encoded ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos)) : ele;float h_height=is_flat_height ? max(c_ele+height,ele+base+2.0) : ele+height;float h_base=is_flat_base ? max(c_ele+base,ele+base) : ele+(base==0.0 ?-5.0 : base);h=t > 0.0 ? max(h_base,h_height) : h_base;\n#else\nh=t > 0.0 ? height : base;\n#endif\npos=vec3(pos_nx.xy,h);\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(vec3(a_pos_normal_3)/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=vec3(a_pos_3)+globe_normal*(u_tile_up_scale*h);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,pos.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*pos.z;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\nfloat cutoff=1.0;vec3 scaled_pos=pos;\n#if defined(RENDER_CUTOFF) || defined(RENDER_FRONT_CUTOFF) || defined(ROUTE_CORRIDOR)\nvec2 centroid_decoded=pos.xy;bool isBorderCentroid=false;if (centroid_pos.x > 0.0 && centroid_pos.y > 0.0) {int iy=int(centroid_pos.y);int spanYbits=iy & 7;if (spanYbits==7) {isBorderCentroid=true;int borderID=(iy >> 3) & 3;float coordAlongBorder=float(iy >> 5)*4.0;if (borderID==0) centroid_decoded=vec2(0.0,coordAlongBorder);else if (borderID==1) centroid_decoded=vec2(EXTENT,coordAlongBorder);else if (borderID==2) centroid_decoded=vec2(coordAlongBorder,0.0);else centroid_decoded=vec2(coordAlongBorder,EXTENT);} else {centroid_decoded=floor(centroid_pos/8.0);}}\n#endif\n#if defined(RENDER_FRONT_CUTOFF) || defined(ROUTE_CORRIDOR)\nfloat frontCutoffOpacity=1.0;float routeFade=0.0;\n#endif\n#if defined(RENDER_CUTOFF) || defined(RENDER_FRONT_CUTOFF)\nvec4 ground=u_matrix*vec4(centroid_decoded,ele,1.0);\n#endif\n#ifdef RENDER_CUTOFF\ncutoff=cutoff_opacity(u_cutoff_params,native_clip_z_to_cutoff_depth(ground.z,ground.w));if (centroid_pos.y !=0.0 && centroid_pos.x !=0.0) {vec3 centroid_random=vec3(centroid_pos.xy,centroid_pos.x+centroid_pos.y+1.0);vec3 ground_pos=centroid_random/8.0;vec3 g=floor(ground_pos);vec3 mod_=centroid_random-g*8.0;float seed=min(1.0,0.1*(min(3.5,max(mod_.x+mod_.y,0.2*attr_height))*0.35+mod_.z));if (cutoff < 0.8-seed) {cutoff=0.0;}}float cutoff_scale=cutoff;v_cutoff_opacity=cutoff;scaled_pos.z=mix(c_ele,h,cutoff_scale);\n#endif\nfloat hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (cutoff==0.0 && centroid_pos.x !=0.0) || (color.a==0.0));\n#ifdef RENDER_FRONT_CUTOFF\nif (centroid_pos.x > 0.0 && centroid_pos.y > 0.0) {hidden=max(hidden,float(ground.w <=0.0));float ndc_y=ground.y/max(ground.w,0.001);float threshold=u_front_cutoff_params.x*2.0-1.0;float range_ndc=u_front_cutoff_params.y*2.0;if (!isBorderCentroid) {hidden=max(hidden,float(ndc_y < threshold-range_ndc));}float t=clamp((ndc_y-(threshold-range_ndc))/max(range_ndc,0.001),0.0,1.0);frontCutoffOpacity=mix(u_front_cutoff_params.z,1.0,t);}\n#endif\n#if defined(RENDER_FRONT_CUTOFF) || defined(ROUTE_CORRIDOR)\nv_dither_opacity=1.0;\n#ifdef RENDER_FRONT_CUTOFF\nv_dither_opacity=min(v_dither_opacity,frontCutoffOpacity);\n#endif\nif (centroid_pos.x > 0.0 && centroid_pos.y > 0.0) {hidden=max(hidden,float(v_dither_opacity <=0.0));}\n#endif\n#ifdef RENDER_WALL_MODE\nvec3 join_normal_inside=vec3(a_join_normal_inside);vec2 wall_offset=u_width_scale*line_width*(join_normal_inside.xy/EXTENT);scaled_pos.xy+=(1.0-join_normal_inside.z)*wall_offset*0.5;scaled_pos.xy-=join_normal_inside.z*wall_offset*0.5;\n#endif\ngl_Position=mix(u_matrix*vec4(scaled_pos,1),AWAY,hidden);h=h-ele;v_height=h;\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=pos;vec3 shd_pos1=pos;\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(normal);shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);\n#endif\nfloat NdotL=0.0;float colorvalue=0.0;\n#ifndef LIGHTING_3D_MODE\ncolorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;NdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),NdotL);if (normal.y !=0.0) {float r=0.84;r=mix(0.7,0.98,1.0-u_lightintensity);NdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}\n#endif\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec2(mix(concave,-concave,start),y_ground);NdotL*=(1.0+0.05*(1.0-top_up_ny_start.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\nfloat z_bias=native_depth_epsilon(0.0000006);gl_Position.z-=(z_bias*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\n#ifdef FLOOD_LIGHT\nfloat is_wall=1.0-float(t > 0.0 && top_up_ny_start.y > 0.0);v_has_floodlight=float(flood_light_wall_radius > 0.0 && is_wall > 0.0);v_flood_radius=flood_light_wall_radius*u_vertical_scale;\n#endif\nv_color=vec4(color.rgb,1.0);float ndotl=calculate_NdotL(normal);v_flat.rgb=sRGBToLinear(color.rgb);v_flat.rgb=v_flat.rgb*(ndotl+(1.0-min(ndotl*57.29,1.0))*emissive_strength);v_flat=vec4(linearTosRGB(v_flat.rgb),1.0);\n#else\nv_color=vec4(0.0,0.0,0.0,1.0);v_color.rgb+=clamp(color.rgb*NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_color*=u_opacity;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nfloat roofNdotL=clamp(u_lightpos.z,0.0,1.0);roofNdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),roofNdotL);v_roof_color=vec4(0.0,0.0,0.0,1.0);v_roof_color.rgb+=clamp(color.rgb*roofNdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_roof_color*=u_opacity;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            fillExtrusionPattern: WE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_indicator_cutout.fragment.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\nuniform float u_pattern_transition;\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;in vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nin vec3 v_normal;\n#endif\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\nin highp vec2 v_pos;in vec4 v_lighting;uniform lowp float u_opacity;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define mediump uvec4 pattern\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\n#pragma mapbox: define mediump uvec4 pattern_b\n#endif\n#pragma mapbox: define highp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize mediump uvec4 pattern\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump uvec4 pattern_b\n#endif\n#pragma mapbox: initialize highp float pixel_ratio\nvec2 pattern_tl=vec2(pattern.xy);vec2 pattern_br=vec2(pattern.zw);highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef APPLY_LUT_ON_GPU\nout_color=applyLUT(u_lutTexture,out_color);\n#endif\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\nvec2 pattern_b_tl=vec2(pattern_b.xy);vec2 pattern_b_br=vec2(pattern_b.zw);highp vec2 pos_b=mix(pattern_b_tl/u_texsize,pattern_b_br/u_texsize,imagecoord);vec4 color_b=textureLodCustom(u_image,pos_b,lod_pos);out_color=out_color*(1.0-u_pattern_transition)+color_b*u_pattern_transition;\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color,normalize(v_normal))*u_opacity;\n#else\nout_color=out_color*v_lighting;\n#endif\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h=max(0.0,v_ao.z);float h_floors=h/u_ao[1];float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);float shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;float x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);shade*=mix(1.0,x_shade*x_shade*x_shade,concave);out_color.rgb=out_color.rgb*shade;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_material_table.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform float u_tile_units_to_pixels;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_width_scale;\n#ifndef LIGHTING_3D_MODE\nuniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;\n#endif\nin ivec4 a_pos_normal_ed;\n#if defined(HAS_CENTROID) || defined(TERRAIN)\nin uvec2 a_centroid_pos;\n#endif\n#ifdef RENDER_WALL_MODE\nin ivec4 a_join_normal_inside;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin ivec4 a_pos_3;in ivec4 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\n#ifdef TERRAIN\nuniform int u_height_type;uniform int u_base_type;\n#endif\nout highp vec2 v_pos;out vec4 v_lighting;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;out vec3 v_ao;invariant gl_Position;\n#endif\n#ifdef LIGHTING_3D_MODE\nout vec3 v_normal;\n#endif\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump uvec4 pattern\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\n#pragma mapbox: define mediump uvec4 pattern_b\n#endif\n#pragma mapbox: define highp float pixel_ratio\n#pragma mapbox: define highp float line_width\nvoid main() {DECLARE_MATERIAL_TABLE_INFO\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump uvec4 pattern\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump uvec4 pattern_b\n#endif\n#pragma mapbox: initialize highp float pixel_ratio\n#pragma mapbox: initialize highp float line_width\nvec2 pattern_tl=vec2(pattern.xy);vec2 pattern_br=vec2(pattern.zw);vec4 top_up_ny_start=vec4(a_pos_normal_ed & 1);vec4 pos_nx=vec4(a_pos_normal_ed >> 1);float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny_start.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny_start.z-1.0)*(1.0-abs(x_normal)),0.0));float edgedistance=float(a_pos_normal_ed.w);vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;base=max(0.0,base);height=max(0.0,height);float t=top_up_ny_start.x;float z=t > 0.0 ? height : base;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=vec2(a_centroid_pos);\n#endif\nfloat ele=0.0;float h=z;vec3 p;float c_ele;\n#ifdef TERRAIN\nbool is_flat_height=centroid_pos.x !=0.0 && u_height_type==1;bool is_flat_base=centroid_pos.x !=0.0 && u_base_type==1;ele=elevation(pos_nx.xy);bool is_elevation_encoded=centroid_pos.y==0.0 || (centroid_pos.y > 0.0 && int(centroid_pos.y)-(int(centroid_pos.y)/8)*8==7);c_ele=is_flat_height || is_flat_base ? (is_elevation_encoded ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos)) : ele;float h_height=is_flat_height ? max(c_ele+height,ele+base+2.0) : ele+height;float h_base=is_flat_base ? max(c_ele+base,ele+base) : ele+(base==0.0 ?-5.0 : base);h=t > 0.0 ? max(h_base,h_height) : h_base;p=vec3(pos_nx.xy,h);\n#else\np=vec3(pos_nx.xy,z);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(vec3(a_pos_normal_3)/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=vec3(a_pos_3)+globe_normal*(u_tile_up_scale*(p.z+lift));vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,p.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*p.z;p=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\n#ifdef RENDER_WALL_MODE\nvec3 join_normal_inside=vec3(a_join_normal_inside);vec2 wall_offset=u_width_scale*line_width*(join_normal_inside.xy/EXTENT);p.xy+=(1.0-join_normal_inside.z)*wall_offset*0.5;p.xy-=join_normal_inside.z*wall_offset*0.5;\n#endif\nfloat hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (color.a==0.0));gl_Position=mix(u_matrix*vec4(p,1),AWAY,hidden);vec2 pos=normal.z==1.0\n? pos_nx.xy\n: vec2(edgedistance,z*u_height_factor);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float NdotL=0.0;\n#ifdef LIGHTING_3D_MODE\nNdotL=calculate_NdotL(normal);\n#else\nNdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),NdotL);\n#endif\nif (normal.y !=0.0) {float r=0.84;\n#ifndef LIGHTING_3D_MODE\nr=mix(0.7,0.98,1.0-u_lightintensity);\n#endif\nNdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec3(mix(concave,-concave,start),y_ground,h-ele);NdotL*=(1.0+0.05*(1.0-top_up_ny_start.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\nfloat z_bias=native_depth_epsilon(0.0000006);gl_Position.z-=(z_bias*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\nv_normal=normal;\n#else\nv_lighting.rgb+=clamp(NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(p);\n#endif\n}'),
            hillshadePrepare: WE("precision highp float;uniform highp sampler2D u_image;in vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;float getElevation(vec2 coord) {return texture(u_image,coord).r/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y));float b=getElevation(v_pos+vec2(0,-epsilon.y));float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y));float d=getElevation(v_pos+vec2(-epsilon.x,0));float e=getElevation(v_pos+vec2(epsilon.x,0));float f=getElevation(v_pos+vec2(-epsilon.x,epsilon.y));float g=getElevation(v_pos+vec2(0,epsilon.y));float h=getElevation(v_pos+vec2(epsilon.x,epsilon.y));float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2(\n(c+e+e+h)-(a+d+d+f),(f+g+g+h)-(a+b+b+c)\n)/pow(2.0,exaggeration+(19.2562-u_zoom));glFragColor=clamp(vec4(\nderiv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);}", "uniform mat4 u_matrix;uniform vec2 u_dimension;in ivec2 a_pos;in uvec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(vec2(a_texture_pos)/8192.0)*scale+epsilon;}"),
            hillshade: WE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;uniform float u_emissive_strength;void main() {vec4 pixel=texture(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);glFragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef LIGHTING_3D_MODE\nglFragColor=apply_lighting_with_emission_ground(glFragColor,u_emissive_strength);\n#endif\n#ifdef FOG\nglFragColor=fog_dither(fog_apply_premultiplied(glFragColor,v_fog_pos));\n#endif\nstoreEmissiveColor(glFragColor,u_emissive_strength);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;in ivec2 a_pos;in uvec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=bottom_left_to_native_uv(vec2(a_texture_pos)/8192.0);\n#ifdef FOG\nv_fog_pos=fog_position(vec2(a_pos));\n#endif\n}'),
            line: WE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_indicator_cutout.fragment.glsl"\n#include "_prelude_feature_cutout.fragment.glsl"\nuniform lowp float u_device_pixel_ratio;uniform highp float u_width_scale;uniform float u_alpha_discard_threshold;uniform lowp float u_opacity_multiplier;\n#ifdef ELEVATED_ROADS\nuniform bool u_clip_to_tile_borders;uniform vec4 u_child_quadrants;\n#endif\nin vec4 v_width2_dilute;in vec2 v_normal;in float v_gamma_scale;in highp vec2 v_tile_pos;\n#ifdef LINE_ROUND_JOIN_CLIP_BORDER_OVERLAP\nin highp vec4 v_round_join_conflict_offset;in highp vec4 v_round_join_conflict_dir;in mediump vec2 v_round_join_conflict_test;\n#endif\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\n#ifdef VARIABLE_LINE_WIDTH\nin float stub_side;in highp vec2 v_distance;\n#endif\nuniform bool u_has_dash;uniform bool u_has_border;uniform sampler2D u_dash_image;uniform highp float u_floor_width_scale;in highp vec2 v_tex;\n#ifdef DEBUG_ELEVATION_ID\nin vec3 v_elevation_id_col;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_BORDER_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nin highp vec3 v_uv;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform sampler2D u_gradient_image;\n#endif\n#ifdef RENDER_LINE_BORDER_GRADIENT\nuniform sampler2D u_border_gradient_image;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nuniform highp vec2 u_trim_offset;uniform highp vec2 u_trim_fade_range;uniform highp vec2 u_trim_gradient_mix_range;uniform lowp vec4 u_trim_color;\n#endif\n#ifdef RENDER_SHADOWS\nuniform bool u_emissive_in_shadows;uniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\nfloat luminance(vec3 c) {return (c.r+c.r+c.b+c.g+c.g+c.g)*0.1667;}in highp vec4 v_line_color;in lowp vec4 v_border_color;in lowp float v_opacity;in lowp float v_blur;in lowp float v_floorwidth;in lowp float v_border_width;in lowp float v_emissive_strength;in highp vec2 v_dash;\n#ifdef LINE_ROUND_JOIN_CLIP_BORDER_OVERLAP\nconst highp float ROUND_JOIN_NO_CONFLICT=32768.0;highp float roundJoinConflictDistance(highp vec2 conflictOffset,highp vec2 conflictDir,mediump float test) {if (test <=0.0) {return ROUND_JOIN_NO_CONFLICT;}highp float dirLenSq=max(dot(conflictDir,conflictDir),1e-6);highp float t=clamp(dot(conflictOffset,conflictDir)/dirLenSq,0.0,1.0);return length(conflictOffset-t*conflictDir);}float insideRoundJoinTestArea(highp float dist,vec2 testBounds,float pxStep) {float inside=1.0-smoothstep(testBounds.y-pxStep,testBounds.y+pxStep,dist);float pastGap=testBounds.x > 0.0 ? smoothstep(testBounds.x-pxStep,testBounds.x+pxStep,dist) : 1.0;return inside*pastGap;}float insideRoundJoinConflictBody(highp float dist,vec3 testBounds,float pxStep) {vec2 body=vec2(testBounds.x,testBounds.y-pxStep);return insideRoundJoinTestArea(dist,body,pxStep);}float insideRoundJoinConflictFill(highp float dist,vec3 testBounds,float pxStep) {float gap=testBounds.x;float outer=testBounds.y;float border=testBounds.z;vec2 fill=vec2(gap+(gap > 0.0 ? border : 0.0),max(outer-border,0.0));return insideRoundJoinTestArea(dist,fill,pxStep);}\n#endif\nfloat linearstep(float edge0,float edge1,float x) {return  clamp((x-edge0)/(edge1-edge0),0.0,1.0);}void main() {highp vec4 color=vec4(v_line_color.rgb*v_line_color.a,v_line_color.a);float floorwidth=v_floorwidth;float blur=v_blur;float opacity=v_opacity;float border_width=v_border_width;vec4 border_color=vec4(v_border_color.rgb*v_border_color.a,v_border_color.a);float emissive_strength=v_emissive_strength;float dist=length(v_normal)*v_width2_dilute.x;float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;\n#ifndef VARIABLE_LINE_WIDTH\nif (u_has_border) {ANTIALIASING*=8.0;}\n#endif\n#ifdef VARIABLE_LINE_WIDTH\nblur=mix(blur,0.0,stub_side);\n#endif\nfloat diluted_opacity=opacity*v_width2_dilute.z;float blur2=(u_width_scale*blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha;\n#ifdef VARIABLE_LINE_WIDTH\nfloat centre_distance=length(v_distance);float edge=mix(v_width2_dilute.y,v_width2_dilute.x,0.5+0.5*v_distance.y/max(centre_distance,1e-4));float inv_radius=1.0/max(length(vec4(dFdx(v_distance),dFdy(v_distance))),1e-4);vec2 edges=clamp((vec2(edge,-edge)-centre_distance)*inv_radius,-1.0,1.0);vec2 window=edges*(1.0-0.5*abs(edges));float blur_fade=clamp(edge*(1.0-centre_distance/(edge+ANTIALIASING))/blur2,0.0,1.0);alpha=mix(window.x-window.y,blur_fade,smoothstep(1.0,2.0,u_width_scale*blur*inv_radius));\n#else\nalpha=clamp(min(dist-(v_width2_dilute.y-blur2),v_width2_dilute.x-dist)/blur2,0.0,1.0);\n#endif\nfloat pxStep;float delta;float alpha2=1.0;\n#ifndef VARIABLE_LINE_WIDTH\nif (u_has_border) {pxStep=fwidth(dist);float out_edge=v_width2_dilute.x-dist;float in_edge=dist-(v_width2_dilute.y-2.0*ANTIALIASING);delta=v_width2_dilute.y > 0.0 ? min(in_edge,out_edge) : out_edge;float edge=ANTIALIASING;alpha=delta > 0.0 ? smoothstep(edge-pxStep,u_width_scale*blur+edge+pxStep,delta) : 0.0;float borderPx=border_width*u_width_scale;float edge2=borderPx+ANTIALIASING;alpha2=smoothstep(edge2-pxStep,edge2+pxStep,delta);\n#ifdef LINE_ROUND_JOIN_CLIP_BORDER_OVERLAP\nif (alpha > 0.0 && alpha2 < 1.0 &&\n(v_round_join_conflict_test.x > 0.0 || v_round_join_conflict_test.y > 0.0)) {highp float prevDist=roundJoinConflictDistance(v_round_join_conflict_offset.xy,v_round_join_conflict_dir.xy,v_round_join_conflict_test.x);highp float nextDist=roundJoinConflictDistance(v_round_join_conflict_offset.zw,v_round_join_conflict_dir.zw,v_round_join_conflict_test.y);vec3 testBounds=vec3(max(v_width2_dilute.y-ANTIALIASING,0.0),v_width2_dilute.x-ANTIALIASING,borderPx);float insideConflictFill=max(insideRoundJoinConflictFill(prevDist,testBounds,pxStep),insideRoundJoinConflictFill(nextDist,testBounds,pxStep));alpha2=max(alpha2,insideConflictFill);const float diluteEpsilon=0.004;if (u_alpha_discard_threshold !=0.0 && blur==0.0 && v_width2_dilute.z >=1.0-diluteEpsilon) {float insideConflictBody=max(insideRoundJoinConflictBody(prevDist,testBounds,pxStep),insideRoundJoinConflictBody(nextDist,testBounds,pxStep));alpha=max(alpha,delta >=edge ? insideConflictBody : 0.0);}}\n#endif\n}\n#endif\nif (u_has_dash) {highp float dash_len=v_dash.x;float sdfgamma=ANTIALIASING/float(dash_len);float scaled_floorwidth=(floorwidth*u_floor_width_scale);float periods_per_pixel=fwidth(v_tex.x);float dash_coverage=v_dash.y;float fade=linearstep(0.25,0.5,periods_per_pixel);float gamma=max(sdfgamma/scaled_floorwidth,0.5*periods_per_pixel);if (fade >=1.0) {alpha*=dash_coverage;} else if (periods_per_pixel < 0.1) {float sdfdist=texture(u_dash_image,v_tex).r;alpha*=linearstep(0.5-gamma,0.5+gamma,sdfdist);} else {float span=min(periods_per_pixel,1.0);float tap_offset=span*0.25;float sdf0=texture(u_dash_image,vec2(v_tex.x-tap_offset,v_tex.y)).r;float sdf1=texture(u_dash_image,vec2(v_tex.x+tap_offset,v_tex.y)).r;alpha*=mix(0.5*(\nlinearstep(0.5-gamma,0.5+gamma,sdf0)+linearstep(0.5-gamma,0.5+gamma,sdf1)\n),dash_coverage,fade);}}highp vec4 out_color;\n#ifdef RENDER_LINE_GRADIENT\nout_color=texture(u_gradient_image,v_uv.xy);\n#else\nout_color=color;\n#endif\nfloat trim_alpha=1.0;\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=v_uv[2];if (trim_end > trim_start) {highp float start_transition=max(0.0,min(1.0,(line_progress-trim_start)/max(u_trim_fade_range[0],1.0e-9)));highp float end_transition=max(0.0,min(1.0,(trim_end-line_progress)/max(u_trim_fade_range[1],1.0e-9)));highp float transition_factor=min(start_transition,end_transition);highp float gradient_trim_color_mix_factor=0.0;\n#ifdef RENDER_LINE_GRADIENT\ngradient_trim_color_mix_factor=smoothstep(u_trim_gradient_mix_range.x,u_trim_gradient_mix_range.y,line_progress);\n#endif\nhighp vec4 trim_color=mix(u_trim_color,out_color,gradient_trim_color_mix_factor);out_color=mix(u_trim_gradient_mix_range.x < 1.0 ? color : out_color,trim_color,transition_factor);trim_alpha=1.0-transition_factor;}\n#endif\nif (u_alpha_discard_threshold !=0.0) {if (alpha < u_alpha_discard_threshold) {discard;}}\n#ifdef VARIABLE_LINE_WIDTH\nif (alpha <=0.0) {discard;}\n#endif\n#ifndef VARIABLE_LINE_WIDTH\nif (u_has_border && alpha2 < 1.) {\n#ifdef RENDER_LINE_BORDER_GRADIENT\nvec4 border_gradient_color=texture(u_border_gradient_image,v_uv.xy);out_color=mix(border_gradient_color*trim_alpha,out_color,alpha2);\n#else\nif (border_color.a==0.0) {\n#ifndef RENDER_LINE_GRADIENT\nfloat Y=(out_color.a > 0.01) ? luminance(out_color.rgb/out_color.a) : 1.;float adjustment=(Y > 0.) ? 0.5/Y : 0.45;if (out_color.a > 0.25 && Y < 0.25) {vec3 borderColor=(Y > 0.) ? out_color.rgb : vec3(1,1,1)*out_color.a;out_color.rgb=out_color.rgb+borderColor*(adjustment*(1.0-alpha2));} else {out_color.rgb*=(0.6+0.4*alpha2);}\n#else\nout_color.rgb*=(0.6+0.4*alpha2);\n#endif\n} else {out_color=mix(border_color*trim_alpha,out_color,alpha2);}\n#endif\nout_color*=v_width2_dilute.w;}\n#endif\nvec2 cutout_factors=vec2(0.0);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);light=mix(light,1.0,cutout_factors.y);light=u_emissive_in_shadows ? mix(light,1.0,emissive_strength) : light;\n#ifdef ELEVATED_ROADS\nout_color.rgb*=mix(v_road_z_offset !=0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);\n#else\nout_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nout_color*=(alpha*diluted_opacity*u_opacity_multiplier);\n#ifdef LINE_BLEND_ADDITIVE\n{float cov=alpha*diluted_opacity;glFragColor=vec4(cov > 0.0 ? out_color.rgb/cov : vec3(0.0),cov);}\n#else\n#ifdef LINE_BLEND_MULTIPLY\nglFragColor=vec4(out_color.rgb+(1.0-out_color.a),1.0);\n#else\nglFragColor=out_color;\n#endif\n#endif\nstoreEmissiveColor(glFragColor,emissive_strength);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n#ifdef DEBUG_ELEVATION_ID\nglFragColor=vec4(v_elevation_id_col,1.0);\n#endif\n#ifdef ELEVATED_ROADS\nif (u_clip_to_tile_borders) {if (v_tile_pos.x > 1.0 || v_tile_pos.y > 1.0 || v_tile_pos.x < 0.0 || v_tile_pos.y < 0.0) {discard;}vec2 quadrant=step(vec2(0.5),v_tile_pos);vec2 row=mix(u_child_quadrants.xz,u_child_quadrants.yw,quadrant.x);if (mix(row.x,row.y,quadrant.y) > 0.5) {discard;}}\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_ubo_properties.glsl"\n#define EXTRUDE_SCALE 0.015873016\nin ivec2 a_pos_normal;in uvec4 a_data;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS) || defined(VARIABLE_LINE_WIDTH) || defined(VARIABLE_LINE_EMISSIVE_STRENGTH)\nin vec4 a_z_offset_width;\n#endif\n#ifdef DEBUG_ELEVATION_ID\nin vec3 a_elevation_id_col;\n#endif\n#ifdef DEBUG_ELEVATION_ID\nout vec3 v_elevation_id_col;\n#endif\n#ifdef ELEVATION_GROUND_SCALE\nin float a_elevation_ground_scale;\n#endif\n#ifdef LINE_ROUND_JOIN_CLIP_BORDER_OVERLAP\nin highp ivec4 a_round_join_conflict_segments;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_BORDER_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET) || defined(RENDER_LINE_CURVE)\nin highp vec3 a_packed;\n#endif\nuniform bool u_has_dash;uniform bool u_has_border;in float a_linesofar;uniform mat4 u_matrix;uniform mat2 u_pixels_to_tile_units;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;uniform float u_width_scale;uniform float u_z_offset;uniform highp float u_road_view_depth_bias;\n#ifdef ELEVATED\nuniform lowp float u_zbias_factor;uniform lowp float u_tile_to_meter;float sample_elevation(vec2 apos) {\n#ifdef ELEVATION_REFERENCE_SEA\nreturn 0.0;\n#else\nreturn elevation(apos);\n#endif\n}\n#endif\nout vec2 v_normal;out vec4 v_width2_dilute;out float v_gamma_scale;out highp vec2 v_tile_pos;\n#ifdef LINE_ROUND_JOIN_CLIP_BORDER_OVERLAP\nout highp vec4 v_round_join_conflict_offset;out highp vec4 v_round_join_conflict_dir;out mediump vec2 v_round_join_conflict_test;\n#endif\n#ifdef ELEVATED_ROADS\nout highp float v_road_z_offset;\n#endif\n#ifdef VARIABLE_LINE_WIDTH\nout float stub_side;out highp vec2 v_distance;uniform float u_width_addition;\n#endif\nuniform highp float u_floor_width_scale;uniform vec2 u_texsize;uniform float u_tile_units_to_pixels;out highp vec2 v_tex;\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_BORDER_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nout highp vec3 v_uv;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_BORDER_GRADIENT)\nuniform float u_image_height;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\n#define LPP_HEADER_SIZE_VEC4 5u\nstruct LinePaintProperties {vec4 color;vec4 border_color;float opacity;float blur;float width;float gap_width;float offset;float floorwidth;float border_width;float emissive_strength;vec4 dash;float side_z_offset;};uniform highp vec4 u_lpp_color;uniform lowp vec4 u_lpp_border_color;uniform lowp float u_lpp_opacity;uniform lowp float u_lpp_blur;uniform mediump float u_lpp_width;uniform mediump float u_lpp_gap_width;uniform lowp float u_lpp_offset;uniform lowp float u_lpp_floorwidth;uniform lowp float u_lpp_border_width;uniform lowp float u_lpp_emissive_strength;uniform highp vec4 u_lpp_dash;uniform mediump float u_lpp_side_z_offset;uniform highp float u_lpp_zoom_fraction;in float a_feature_index;layout(std140) uniform LinePaintPropertiesHeaderUniform {uvec4 header[LPP_HEADER_SIZE_VEC4];} u_lpp_header;layout(std140) uniform LinePaintPropertiesUniform {vec4 properties[MAX_UBO_SIZE_VEC4];} u_lpp_properties;out highp vec4 v_line_color;out lowp vec4 v_border_color;out lowp float v_opacity;out lowp float v_blur;out lowp float v_floorwidth;out lowp float v_border_width;out lowp float v_emissive_strength;out highp vec2 v_dash;vec4 readColor(uint base,bool isDataDriven,uint offsetVec4,vec2 headerZoom,vec4 fallbackValue) {if (!isDataDriven) return fallbackValue;vec4 value=u_lpp_properties.properties[base+offsetVec4];return unpack_mix_color(value,zoomFactor(headerZoom.x,headerZoom.y,u_lpp_zoom_fraction));}float readFloat(uint base,bool isDataDriven,uint offsetVec4,float fallbackValue) {if (!isDataDriven) return fallbackValue;vec4 slot=u_lpp_properties.properties[base+offsetVec4];return unpack_mix_vec2(slot.xy,zoomFactor(slot.z,slot.w,u_lpp_zoom_fraction));}highp vec4 readRaw(uint base,bool isDataDriven,uint offsetVec4,highp vec4 fallbackValue) {if (!isDataDriven) return fallbackValue;return u_lpp_properties.properties[base+offsetVec4];}LinePaintProperties readLinePaintProperties() {uint dataDrivenMask=u_lpp_header.header[0][0];uint blockSizeVec4 =u_lpp_header.header[0][2];vec2 colorHeaderZoom =uintBitsToFloat(u_lpp_header.header[4].xy);vec2 borderHeaderZoom=uintBitsToFloat(u_lpp_header.header[4].zw);uint base=uint(a_feature_index)*blockSizeVec4;LinePaintProperties props;props.color            =readColor(base,(dataDrivenMask & (1u << 0u)) !=0u,u_lpp_header.header[0][3],colorHeaderZoom,u_lpp_color);props.border_color     =readColor(base,(dataDrivenMask & (1u << 1u)) !=0u,u_lpp_header.header[1][0],borderHeaderZoom,u_lpp_border_color);props.opacity          =readFloat(base,(dataDrivenMask & (1u << 2u)) !=0u,u_lpp_header.header[1][1],u_lpp_opacity);props.blur             =readFloat(base,(dataDrivenMask & (1u << 3u)) !=0u,u_lpp_header.header[1][2],u_lpp_blur);props.width            =readFloat(base,(dataDrivenMask & (1u << 4u)) !=0u,u_lpp_header.header[1][3],u_lpp_width);props.gap_width        =readFloat(base,(dataDrivenMask & (1u << 5u)) !=0u,u_lpp_header.header[2][0],u_lpp_gap_width);props.offset           =readFloat(base,(dataDrivenMask & (1u << 6u)) !=0u,u_lpp_header.header[2][1],u_lpp_offset);props.floorwidth       =readFloat(base,(dataDrivenMask & (1u << 7u)) !=0u,u_lpp_header.header[2][2],u_lpp_floorwidth);props.border_width     =readFloat(base,(dataDrivenMask & (1u << 8u)) !=0u,u_lpp_header.header[2][3],u_lpp_border_width);props.emissive_strength=readFloat(base,(dataDrivenMask & (1u << 9u)) !=0u,u_lpp_header.header[3][0],u_lpp_emissive_strength);props.dash             =readRaw(base,(dataDrivenMask & (1u << 10u)) !=0u,u_lpp_header.header[3][1],u_lpp_dash);props.side_z_offset    =readFloat(base,(dataDrivenMask & (1u << 11u)) !=0u,u_lpp_header.header[3][2],u_lpp_side_z_offset);return props;}\n#ifdef LINE_ROUND_JOIN_CLIP_BORDER_OVERLAP\nhighp vec3 unpackRoundJoinTestCoordinate(highp int packedCoord) {highp int x=(((packedCoord & 0xfffe) ^ 0x8000)-0x8000) >> 1;return vec3(float(x),float(packedCoord >> 16),float(packedCoord & 1));}\n#endif\nvoid main() {LinePaintProperties paint_properties=readLinePaintProperties();v_line_color=paint_properties.color;float floorwidth=paint_properties.floorwidth;float blur=paint_properties.blur;float opacity=paint_properties.opacity;float gapwidth=paint_properties.gap_width;float offset=paint_properties.offset;float width=paint_properties.width;float border_width=paint_properties.border_width;vec4 border_color=paint_properties.border_color;float emissive_strength=paint_properties.emissive_strength;float side_z_offset=paint_properties.side_z_offset;\n#ifdef VARIABLE_LINE_EMISSIVE_STRENGTH\nemissive_strength=a_z_offset_width.w;\n#endif\nv_border_color=border_color;v_opacity=opacity;v_blur=blur;v_floorwidth=floorwidth;v_border_width=border_width;v_emissive_strength=emissive_strength;float a_z_offset=u_z_offset;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS)\na_z_offset+=a_z_offset_width.x;\n#endif\n#ifdef DEBUG_ELEVATION_ID\nv_elevation_id_col=a_elevation_id_col;\n#endif\nhighp float line_progress=0.0;\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_BORDER_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET) || defined(RENDER_LINE_CURVE)\nline_progress=a_packed[2];\n#endif\nfloat arrow_head_fraction=-1.0;float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;\n#ifndef VARIABLE_LINE_WIDTH\nif (u_has_border) {ANTIALIASING*=8.0;}\n#endif\nvec2 a_extrude=vec2(a_data.xy)-128.0;float a_direction=float(a_data.z & 3u)-1.0;vec2 pos_normal=vec2(a_pos_normal);vec2 pos=floor(pos_normal*0.5);mediump vec2 normal=pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;offset=-1.0*offset*u_width_scale;bool left=normal.y==1.0;gapwidth=gapwidth/2.0;float halfwidth;float dilute_scale=1.0;float dilute_border_scale=1.0;vec2 side_widths=vec2(0.0);\n#ifdef VARIABLE_LINE_WIDTH\nfloat left_width=a_z_offset_width.y;float right_width=a_z_offset_width.z;bool zero_right_width=border_width==0.0 && right_width==0.0;side_widths=u_width_scale*(zero_right_width ? vec2(left_width+u_width_addition) : vec2(left_width,right_width)+0.5*u_width_addition);halfwidth=left ? side_widths.x : (zero_right_width ? 0.0 : side_widths.y);if (side_z_offset !=0.0) {float left_f=step(1.0,normal.y);float is_negative=step(side_z_offset,0.0);float apply=mix(1.0-left_f,left_f,is_negative);a_extrude*=apply;a_z_offset+=abs(side_z_offset)*apply;v_normal*=apply;}offset=border_width > 0.0 ? (left_width+right_width+u_width_addition)*u_width_scale : offset;halfwidth=border_width > 0.0 ? border_width*u_width_scale*0.5 : halfwidth;side_widths=border_width > 0.0 ? vec2(halfwidth) : side_widths;stub_side=zero_right_width ?-normal.y : 0.0;v_normal=!left && zero_right_width ? vec2(0.0) : v_normal;ANTIALIASING=!left && zero_right_width ? 0.0 : ANTIALIASING;\n#else\nhalfwidth=(u_width_scale*width)/2.0;\n#endif\nfloat inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth > 0.0 ? ANTIALIASING : 0.0);\n#ifdef VARIABLE_LINE_WIDTH\nv_distance=v_normal*outset;\n#endif\nmediump vec2 dist=outset*a_extrude*EXTRUDE_SCALE;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*EXTRUDE_SCALE*normal.y*mat2(t,-u,u,t);float hidden=float(opacity==0.0);vec2 extrude=dist*u_pixels_to_tile_units;vec4 projected_extrude=u_matrix*vec4(extrude,0.0,0.0);vec2 projected_extrude_xy=projected_extrude.xy;\n#ifdef ELEVATED_ROADS\nv_road_z_offset=a_z_offset;v_tile_pos=pos+offset2*u_pixels_to_tile_units;gl_Position=u_matrix*vec4(v_tile_pos,a_z_offset,1.0);\n#else\n#ifdef ELEVATED\nvec2 offsetTile=offset2*u_pixels_to_tile_units;vec2 offset_pos=pos+offsetTile;float ele=0.0;float scaled_z_offset=a_z_offset;\n#ifdef ELEVATION_GROUND_SCALE\nscaled_z_offset=a_z_offset*mix(1.0,u_exaggeration,a_elevation_ground_scale);\n#endif\n#ifdef CROSS_SLOPE_VERTICAL\nfloat top=pos_normal.y-2.0*floor(pos_normal.y*0.5);float line_height=2.0*u_tile_to_meter*outset*top*u_pixels_to_tile_units[1][1]+scaled_z_offset;ele=sample_elevation(offset_pos)+line_height;projected_extrude=vec4(0);\n#else\n#ifdef CROSS_SLOPE_HORIZONTAL\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,max(ele1,ele2));ele=ele_max+scaled_z_offset;\n#else\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,0.5*(ele1+ele2));ele=ele_max-ele0+ele1+scaled_z_offset;\n#endif\n#endif\nv_tile_pos=offset_pos;gl_Position=u_matrix*vec4(v_tile_pos,ele,1.0)+projected_extrude;float z=clamp(gl_Position.z/gl_Position.w,0.5,1.0);float zbias=max(0.00005,(pow(z,0.8)-z)*u_zbias_factor*u_exaggeration);gl_Position.z-=(gl_Position.w*zbias);gl_Position=mix(gl_Position,AWAY,hidden);\n#else\nv_tile_pos=pos+offset2*u_pixels_to_tile_units;gl_Position=u_matrix*vec4(v_tile_pos,0.0,1.0);\n#endif\n#endif\n#ifndef ELEVATED\n#ifndef VARIABLE_LINE_WIDTH\n#ifndef RENDER_TO_TEXTURE\nfloat base_w=gl_Position.w;vec2 screen_width=abs(projected_extrude.xy/base_w*u_units_to_pixels);float max_extrude_component=max(screen_width.x,screen_width.y);if (width >=1.0 && base_w > 0.0 && max_extrude_component > 0.0001) {float min_pixel=1.05;if (max_extrude_component < min_pixel) {vec2 abs_pos=abs(gl_Position.xy);float is_out=max(abs_pos.x,abs_pos.y)/base_w;dilute_scale=mix(max_extrude_component/min_pixel,1.0,smoothstep(2.5,4.5,is_out));projected_extrude/=dilute_scale;}else if (gapwidth > 0.0) {float visible_ratio=(halfwidth+ANTIALIASING)/outset;vec2 visible_screen_width=screen_width*visible_ratio;float max_visible_component=max(visible_screen_width.x,visible_screen_width.y);dilute_scale=min(1.0,max_visible_component/min_pixel);}else\n{if (u_has_border) {float border_ratio=(border_width*u_width_scale+ANTIALIASING)/outset;screen_width*=border_ratio;float max_border_component=max(screen_width.x,screen_width.y);dilute_border_scale=min(1.0,max_border_component/min_pixel);}}}\n#endif\n#endif\n#ifdef VARIABLE_LINE_WIDTH\n#ifndef RENDER_TO_TEXTURE\nvec2 ndc=gl_Position.xy/gl_Position.w;vec4 projected_tangent=u_matrix*vec4(extrude.y,-extrude.x,0.0,0.0);vec2 screen_extrude=(projected_extrude.xy-ndc*projected_extrude.w)*u_units_to_pixels;vec2 screen_tangent=(projected_tangent.xy-ndc*projected_tangent.w)*u_units_to_pixels;float thickness=abs(screen_extrude.x*screen_tangent.y-screen_extrude.y*screen_tangent.x)/max(length(screen_tangent),1e-6);float thickness_px=max(thickness,0.2*length(screen_extrude))/gl_Position.w*u_device_pixel_ratio;float headroom_scale=gl_Position.w > 0.0 ? 1.0+(1.0-smoothstep(2.0,4.0,thickness_px))/max(thickness_px,0.0001) : 1.0;projected_extrude*=headroom_scale;extrude*=headroom_scale;v_distance*=headroom_scale;\n#endif\n#endif\nv_tile_pos=(v_tile_pos+extrude)/EXTENT;\n#ifdef ELEVATED_ROADS\ngl_Position=gl_Position+projected_extrude;\n#ifdef VARIABLE_LINE_WIDTH\n#ifndef ELEVATED\ngl_Position.z-=u_road_view_depth_bias*smoothstep(-0.5,0.0,a_z_offset);\n#endif\n#endif\n#else\ngl_Position=mix(gl_Position+projected_extrude,AWAY,hidden);\n#endif\n#endif\n#ifdef ELEVATED_ROADS\n#ifdef RENDER_SHADOWS\nvec3 shd_pos=vec3(pos+(offset2+dist)*u_pixels_to_tile_units,a_z_offset);vec3 shd_pos0=shd_pos;vec3 shd_pos1=shd_pos;\n#ifdef NORMAL_OFFSET\nvec3 shd_pos_offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=shd_pos_offset*shadow_normal_offset_multiplier0();shd_pos1+=shd_pos_offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#endif\n#ifndef RENDER_TO_TEXTURE\nfloat epsilon=0.0001;float extrude_length_without_perspective=max(length(dist),epsilon);float extrude_length_with_perspective=max(length(projected_extrude_xy/gl_Position.w*u_units_to_pixels),epsilon);v_gamma_scale=mix(extrude_length_without_perspective/extrude_length_with_perspective,1.0,step(0.01,blur));\n#else\nv_gamma_scale=1.0;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_BORDER_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nhighp float a_uv_x=a_packed[0];float a_split_index=a_packed[1];\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_BORDER_GRADIENT)\nhighp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec3(a_uv_x,a_split_index*texel_height-half_texel_height,line_progress);\n#else\nv_uv=vec3(a_uv_x,0.0,line_progress);\n#endif\n#endif\nif (u_has_dash) {highp vec4 dashf=paint_properties.dash;highp float dash_w=dashf.w;highp float totalLength=dashf.z+dash_w/65535.0;float scale=totalLength==0.0 ? 0.0 : u_tile_units_to_pixels/totalLength;highp uint dash_bits=uint(dashf.y+0.5);float dash_half_height=float(dash_bits & 15u);float dash_coverage=float(dash_bits >> 4u)/4095.0;v_tex=vec2(a_linesofar*scale/(floorwidth*u_floor_width_scale),(-normal.y*dash_half_height+dashf.x+0.5)/u_texsize.y);v_dash=vec2(totalLength,dash_coverage);} else {v_tex=vec2(0.0);v_dash=vec2(0.0);}v_width2_dilute=vec4(outset,inset,dilute_scale,dilute_border_scale);\n#ifdef VARIABLE_LINE_WIDTH\nv_width2_dilute.xy=side_widths;\n#endif\n#ifdef LINE_ROUND_JOIN_CLIP_BORDER_OVERLAP\nhighp float tileToPixels=1.0/u_pixels_to_tile_units[0][0];highp vec2 testPos=pos+extrude/dilute_scale;highp vec3 prevA=unpackRoundJoinTestCoordinate(a_round_join_conflict_segments.x);highp vec3 prevB=unpackRoundJoinTestCoordinate(a_round_join_conflict_segments.y);highp vec3 nextA=unpackRoundJoinTestCoordinate(a_round_join_conflict_segments.z);highp vec3 nextB=unpackRoundJoinTestCoordinate(a_round_join_conflict_segments.w);v_round_join_conflict_offset=vec4(testPos-prevA.xy,testPos-nextA.xy)*tileToPixels;v_round_join_conflict_dir=vec4(prevB.xy-prevA.xy,nextB.xy-nextA.xy)*tileToPixels;v_round_join_conflict_test=vec2(prevA.z,nextA.z);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            linePattern: WE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_indicator_cutout.fragment.glsl"\nuniform highp float u_device_pixel_ratio;uniform highp float u_width_scale;uniform highp float u_alpha_discard_threshold;uniform lowp float u_opacity_multiplier;uniform highp vec2 u_texsize;uniform highp float u_tile_units_to_pixels;uniform highp vec2 u_trim_offset;uniform highp vec2 u_trim_fade_range;uniform lowp vec4 u_trim_color;uniform sampler2D u_image;\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\n#ifdef LINE_PATTERN_TRANSITION\nuniform float u_pattern_transition;\n#endif\nin vec2 v_normal;in vec2 v_width2;in highp float v_linesofar;in float v_gamma_scale;in float v_width;\n#ifdef RENDER_LINE_TRIM_OFFSET\nin highp vec3 v_uv;\n#endif\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\n#ifdef LINE_JOIN_NONE\nin vec2 v_pattern_data;\n#endif\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#pragma mapbox: define mediump uvec4 pattern\n#ifdef LINE_PATTERN_TRANSITION\n#pragma mapbox: define mediump uvec4 pattern_b\n#endif\n#pragma mapbox: define mediump float pixel_ratio\n#pragma mapbox: define mediump float blur\n#pragma mapbox: define mediump float opacity\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize mediump uvec4 pattern\n#ifdef LINE_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump uvec4 pattern_b\n#endif\n#pragma mapbox: initialize mediump float pixel_ratio\n#pragma mapbox: initialize mediump float blur\n#pragma mapbox: initialize mediump float opacity\n#pragma mapbox: initialize lowp float emissive_strength\nvec2 pattern_tl=vec2(pattern.xy);vec2 pattern_br=vec2(pattern.zw);vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;highp float pattern_size=display_size.x/u_tile_units_to_pixels;float aspect=display_size.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(u_width_scale*blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);highp float pattern_x=v_linesofar/pattern_size*aspect;highp float x=mod(pattern_x,1.0);highp float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;highp vec2 pos=mix(pattern_tl*texel_size-texel_size,pattern_br*texel_size+texel_size,vec2(x,y));highp vec2 lod_pos=mix(pattern_tl*texel_size-texel_size,pattern_br*texel_size+texel_size,vec2(pattern_x,y));vec4 color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef APPLY_LUT_ON_GPU\ncolor=applyLUT(u_lutTexture,color);\n#endif\n#ifdef LINE_PATTERN_TRANSITION\nvec2 pattern_b_tl=vec2(pattern_b.xy);vec2 pattern_b_br=vec2(pattern_b.zw);highp vec2 pos_b=mix(pattern_b_tl*texel_size-texel_size,pattern_b_br*texel_size+texel_size,vec2(x,y));vec4 color_b=textureLodCustom(u_image,pos_b,lod_pos);color=color*(1.0-u_pattern_transition)+color_b*u_pattern_transition;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=v_uv[2];if (trim_end > trim_start) {highp float start_transition=max(0.0,min(1.0,(line_progress-trim_start)/max(u_trim_fade_range[0],1.0e-9)));highp float end_transition=max(0.0,min(1.0,(trim_end-line_progress)/max(u_trim_fade_range[1],1.0e-9)));highp float transition_factor=min(start_transition,end_transition);color=mix(color,color.a*u_trim_color,transition_factor);}\n#endif\n#ifdef LINE_JOIN_NONE\nhighp float pattern_len=pattern_size/aspect;highp float segment_phase=pattern_len-mod(v_linesofar-v_pattern_data.x+pattern_len,pattern_len);highp float visible_start=segment_phase-step(pattern_len*0.5,segment_phase)*pattern_len;highp float visible_end=floor((v_pattern_data.y-segment_phase)/pattern_len)*pattern_len+segment_phase;visible_end+=step(pattern_len*0.5,v_pattern_data.y-visible_end)*pattern_len;if (v_pattern_data.x < visible_start || v_pattern_data.x >=visible_end) {color=vec4(0.0);}\n#endif\n#ifdef LIGHTING_3D_MODE\ncolor=apply_lighting_with_emission_ground(color,emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);\n#ifdef ELEVATED_ROADS\ncolor.rgb*=mix(v_road_z_offset !=0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);\n#else\ncolor.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ncolor*=(alpha*opacity*u_opacity_multiplier);if (u_alpha_discard_threshold !=0.0) {if (color.a < u_alpha_discard_threshold) {discard;}}glFragColor=color;storeEmissiveColor(glFragColor,emissive_strength);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define scale 0.015873016\nin ivec2 a_pos_normal;in uvec4 a_data;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS)\nin vec4 a_z_offset_width;\n#endif\n#ifdef ELEVATION_GROUND_SCALE\nin float a_elevation_ground_scale;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nin highp vec3 a_packed;\n#endif\nin highp float a_linesofar;\n#ifdef LINE_JOIN_NONE\nin highp vec3 a_pattern_data;out vec2 v_pattern_data;\n#endif\nuniform mat4 u_matrix;uniform float u_tile_units_to_pixels;uniform vec2 u_units_to_pixels;uniform mat2 u_pixels_to_tile_units;uniform float u_device_pixel_ratio;uniform float u_width_scale;uniform float u_floor_width_scale;\n#ifdef ELEVATED\nuniform lowp float u_zbias_factor;uniform lowp float u_tile_to_meter;float sample_elevation(vec2 apos) {\n#ifdef ELEVATION_REFERENCE_SEA\nreturn 0.0;\n#else\nreturn elevation(apos);\n#endif\n}\n#endif\nout vec2 v_normal;out vec2 v_width2;out highp float v_linesofar;out float v_gamma_scale;out float v_width;\n#ifdef RENDER_LINE_TRIM_OFFSET\nout highp vec3 v_uv;\n#endif\n#ifdef ELEVATED_ROADS\nout highp float v_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\n#pragma mapbox: define mediump float blur\n#pragma mapbox: define mediump float opacity\n#pragma mapbox: define mediump float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define mediump float floorwidth\n#pragma mapbox: define mediump uvec4 pattern\n#ifdef LINE_PATTERN_TRANSITION\n#pragma mapbox: define mediump uvec4 pattern_b\n#endif\n#pragma mapbox: define mediump float pixel_ratio\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize mediump float blur\n#pragma mapbox: initialize mediump float opacity\n#pragma mapbox: initialize mediump float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize mediump float floorwidth\n#pragma mapbox: initialize mediump uvec4 pattern\n#ifdef LINE_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump uvec4 pattern_b\n#endif\n#pragma mapbox: initialize mediump float pixel_ratio\n#pragma mapbox: initialize lowp float emissive_strength\nfloat a_z_offset;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS)\na_z_offset=a_z_offset_width.x;\n#endif\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=vec2(a_data.xy)-128.0;float a_direction=float(a_data.z & 3u)-1.0;vec2 pos_normal=vec2(a_pos_normal);vec2 pos=floor(pos_normal*0.5);vec2 normal=pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=(u_width_scale*width)/2.0;offset=-1.0*offset*u_width_scale;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);vec2 dist=outset*a_extrude*scale;float u=0.5*a_direction;float t=1.0-abs(u);vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float hidden=float(opacity==0.0);vec2 extrude=dist*u_pixels_to_tile_units;vec4 projected_extrude=u_matrix*vec4(extrude,0.0,0.0);vec2 projected_extrude_xy=projected_extrude.xy;\n#ifdef ELEVATED_ROADS\nv_road_z_offset=a_z_offset;gl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,a_z_offset,1.0)+projected_extrude;\n#else\n#ifdef ELEVATED\nvec2 offsetTile=offset2*u_pixels_to_tile_units;vec2 offset_pos=pos+offsetTile;float ele=0.0;float scaled_z_offset=a_z_offset;\n#ifdef ELEVATION_GROUND_SCALE\nscaled_z_offset=a_z_offset*mix(1.0,u_exaggeration,a_elevation_ground_scale);\n#endif\n#ifdef CROSS_SLOPE_VERTICAL\nfloat top=pos_normal.y-2.0*floor(pos_normal.y*0.5);float line_height=2.0*u_tile_to_meter*outset*top*u_pixels_to_tile_units[1][1]+scaled_z_offset;ele=sample_elevation(offset_pos)+line_height;projected_extrude=vec4(0);\n#else\n#ifdef CROSS_SLOPE_HORIZONTAL\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,max(ele1,ele2));ele=ele_max+scaled_z_offset;\n#else\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,0.5*(ele1+ele2));ele=ele_max-ele0+ele1+scaled_z_offset;\n#endif\n#endif\ngl_Position=u_matrix*vec4(offset_pos,ele,1.0)+projected_extrude;float z=clamp(gl_Position.z/gl_Position.w,0.5,1.0);float zbias=max(0.00005,(pow(z,0.8)-z)*u_zbias_factor*u_exaggeration);gl_Position.z-=(gl_Position.w*zbias);gl_Position=mix(gl_Position,AWAY,hidden);\n#else\ngl_Position=mix(u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude,AWAY,hidden);\n#endif\n#endif\n#ifdef ELEVATED_ROADS\n#ifdef RENDER_SHADOWS\nvec3 shd_pos=vec3(pos+(offset2+dist)*u_pixels_to_tile_units,a_z_offset);vec3 shd_pos0=shd_pos;vec3 shd_pos1=shd_pos;\n#ifdef NORMAL_OFFSET\nvec3 shd_pos_offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=shd_pos_offset*shadow_normal_offset_multiplier0();shd_pos1+=shd_pos_offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#endif\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude_xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=mix(extrude_length_without_perspective/extrude_length_with_perspective,1.0,step(0.01,blur));\n#else\nv_gamma_scale=1.0;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float a_uv_x=a_packed[0];highp float line_progress=a_packed[2];v_uv=vec3(a_uv_x,0.0,line_progress);\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=(floorwidth*u_floor_width_scale);\n#ifdef LINE_JOIN_NONE\nv_width=(floorwidth*u_floor_width_scale)+ANTIALIASING;mediump float pixels_to_tile_units=1.0/u_tile_units_to_pixels;mediump float pixel_ratio_inverse=1.0/pixel_ratio;mediump float aspect=v_width/(float(pattern.w-pattern.y)*pixel_ratio_inverse);highp float subt_multiple=float(pattern.z-pattern.x)*pixel_ratio_inverse*pixels_to_tile_units*aspect*32.0;highp float subt=floor(a_pattern_data.z/subt_multiple)*subt_multiple;float offset_sign=(fract(a_pattern_data.x)-0.5)*4.0;float line_progress_offset=offset_sign*v_width*0.5*pixels_to_tile_units;v_linesofar=(a_pattern_data.z-subt)+a_linesofar+line_progress_offset;v_pattern_data=vec2(a_pattern_data.x+line_progress_offset,a_pattern_data.y);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            raster: WE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_raster_array.glsl"\nuniform float u_fade_t;uniform float u_opacity;uniform highp float u_raster_elevation;uniform highp float u_zoom_transition;in vec2 v_pos0;in vec2 v_pos1;in float v_depth;\n#ifdef PROJECTION_GLOBE_VIEW\nin float v_split_fade;\n#endif\nuniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;uniform float u_emissive_strength;\n#ifndef RASTER_ARRAY\nuniform highp sampler2D u_image0;uniform sampler2D u_image1;\n#endif\n#ifdef RASTER_COLOR\nuniform sampler2D u_color_ramp;uniform highp vec4 u_colorization_mix;uniform highp float u_colorization_offset;uniform vec2 u_texture_res;uniform highp float u_color_ramp_size;\n#endif\nvoid main() {vec4 color0,color1,color;vec2 value;\n#ifdef RASTER_COLOR\n#ifdef RASTER_ARRAY\n#ifdef RASTER_ARRAY_LINEAR\nvalue=mix(\nraTexture2D_image0_linear(v_pos0,u_texture_res,u_colorization_mix,u_colorization_offset),raTexture2D_image1_linear(v_pos1,u_texture_res,u_colorization_mix,u_colorization_offset),u_fade_t\n);\n#else\nvalue=mix(\nraTexture2D_image0_nearest(v_pos0,u_texture_res,u_colorization_mix,u_colorization_offset),raTexture2D_image1_nearest(v_pos1,u_texture_res,u_colorization_mix,u_colorization_offset),u_fade_t\n);\n#endif\nif (value.y > 0.0) value.x/=value.y;\n#ifdef RASTER_COLOR_SCALE_LOG\nfloat N=u_color_ramp_size;float vNorm=max((value.x-0.5/N)*N/(N-1.0),0.0);vNorm=log(vNorm*(10.0-1.0)+1.0)/log(10.0);value.x=0.5/N+vNorm*(N-1.0)/N;\n#endif\n#else\ncolor=mix(texture(u_image0,v_pos0),texture(u_image1,v_pos1),u_fade_t);value=vec2(u_colorization_offset+dot(color.rgb,u_colorization_mix.rgb),color.a);\n#endif\ncolor=texture(u_color_ramp,vec2(value.x,0.5));if (color.a > 0.0) color.rgb/=color.a;color.a*=value.y;\n#else\ncolor0=texture(u_image0,v_pos0);color1=texture(u_image1,v_pos1);if (color0.a > 0.0) color0.rgb/=color0.a;if (color1.a > 0.0) color1.rgb/=color1.a;color=mix(color0,color1,u_fade_t);\n#endif\ncolor.a*=u_opacity;\n#ifdef GLOBE_POLES\ncolor.a*=1.0-smoothstep(0.0,0.05,u_zoom_transition);\n#endif\nvec3 rgb=color.rgb;rgb=vec3(\ndot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);vec3 out_color=mix(u_high_vec,u_low_vec,rgb);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(vec4(out_color,1.0),u_emissive_strength).rgb;\n#endif\n#ifdef FOG\nhighp float fog_limit_high_meters=1000000.0;highp float fog_limit_low_meters=600000.0;float fog_limit=1.0-smoothstep(fog_limit_low_meters,fog_limit_high_meters,u_raster_elevation);out_color=fog_dither(fog_apply(out_color,v_fog_pos,fog_limit));\n#endif\nglFragColor=vec4(out_color*color.a,color.a);\n#ifdef PROJECTION_GLOBE_VIEW\nglFragColor*=mix(1.0,1.0-smoothstep(0.0,0.05,u_zoom_transition),smoothstep(0.8,0.9,v_split_fade));\n#endif\n#ifdef RENDER_CUTOFF\nglFragColor=glFragColor*cutoff_opacity(u_cutoff_params,v_depth);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nstoreEmissiveColor(glFragColor,u_emissive_strength);HANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform mat3 u_grid_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform vec2 u_perspective_transform;uniform vec2 u_texture_offset;uniform float u_raster_elevation;uniform float u_zoom_transition;uniform vec2 u_merc_center;\n#ifdef ELEVATED\nuniform lowp float u_zbias_factor;\n#endif\n#define GLOBE_UPSCALE GLOBE_RADIUS/6371008.8\n#ifdef GLOBE_POLES\nin vec3 a_globe_pos;in vec2 a_uv;\n#else\nin ivec2 a_pos;in uvec2 a_texture_pos;\n#endif\nout vec2 v_pos0;out vec2 v_pos1;out float v_depth;\n#ifdef PROJECTION_GLOBE_VIEW\nout float v_split_fade;\n#endif\nvoid main() {vec2 uv;\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;uv=a_uv;float ele=u_raster_elevation;\n#ifdef ELEVATION_REFERENCE_GROUND\nele+=elevation(uv*EXTENT);\n#endif\nglobe_pos+=normalize(globe_pos)*ele*GLOBE_UPSCALE;gl_Position=u_matrix*u_globe_matrix*vec4(globe_pos,1.0);\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(a_globe_pos,1.0)).xyz);\n#endif\n#else\nvec4 world_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec2 texture_pos=vec2(a_texture_pos);uv=texture_pos/8192.0;vec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float mercatorX=mercatorXfromLng(latLng[1]);float tiles=u_grid_matrix[0][2];if (tiles > 0.0) {float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];float uvY=mercatorY*tiles-idy;float uvX=mercatorX*tiles-idx;uv=vec2(uvX,uvY);}float ele=u_raster_elevation;\n#ifdef ELEVATION_REFERENCE_GROUND\nele+=elevation(uv*EXTENT)-decomposed_pos_and_skirt.z;\n#endif\nvec4 merc_world_pos=vec4(0.0);v_split_fade=0.0;if (u_zoom_transition > 0.0) {vec2 merc_pos=vec2(mercatorX,mercatorY);merc_world_pos=vec4(merc_pos,ele,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;float opposite_merc_center=mod(u_merc_center.x+0.5,1.0);float dist_from_poles=(abs(mercatorY-0.5)*2.0);float range=0.1;v_split_fade=abs(opposite_merc_center-mercatorX);v_split_fade=clamp(1.0-v_split_fade,0.0,1.0);v_split_fade=max(smoothstep(1.0-range,1.0,dist_from_poles),max(smoothstep(1.0-range,1.0,v_split_fade),smoothstep(1.0-range,1.0,1.0-v_split_fade)));}vec3 globe_pos=latLngToECEF(latLng.xy);globe_pos+=normalize(globe_pos)*ele*GLOBE_UPSCALE;vec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);world_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition),1.0);\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n#else\nfloat ele=0.0;vec2 decodedPos=vec2(a_pos);\n#ifdef ELEVATION_REFERENCE_GROUND\nvec3 decomposedPosAndSkirt=decomposeToPosAndSkirt(a_pos);float skirt=decomposedPosAndSkirt.z;decodedPos=decomposedPosAndSkirt.xy;uv=decodedPos/8192.0;ele=elevation(decodedPos)-skirt;\n#else\nuv=vec2(a_texture_pos)/8192.0;\n#endif\nworld_pos=vec4(decodedPos,(u_raster_elevation+ele),1.0);\n#ifdef FOG\nv_fog_pos=fog_position(decodedPos);\n#endif\n#endif\nfloat w=1.0+dot(uv*EXTENT,u_perspective_transform);gl_Position=u_matrix*world_pos*w;\n#endif\nv_pos0=uv;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;v_pos0=u_texture_offset.x+u_texture_offset.y*v_pos0;v_pos1=u_texture_offset.x+u_texture_offset.y*v_pos1;\n#ifdef ELEVATED\nfloat z=clamp(gl_Position.z/gl_Position.w,0.5,1.0);float zbias=max(0.00005,(pow(z,0.8)-z)*u_zbias_factor);gl_Position.z-=(gl_Position.w*zbias);\n#endif\n#ifdef RENDER_CUTOFF\nv_depth=native_clip_z_to_cutoff_depth(gl_Position.z,gl_Position.w);\n#endif\n}'),
            symbol: WE('#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_indicator_cutout.fragment.glsl"\n#include "_prelude_feature_cutout.fragment.glsl"\n#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform sampler2D u_texture;\n#ifdef RENDER_TEXT_AND_SYMBOL\nuniform sampler2D u_texture_icon;\n#endif\nuniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;uniform bool u_is_sdf;uniform lowp float u_scale_factor;uniform lowp float u_opacity_multiplier;\n#ifdef ICON_TRANSITION\nuniform float u_icon_transition;\n#endif\n#ifdef COLOR_ADJUSTMENT\nuniform mat4 u_color_adj_mat;\n#endif\n#ifdef RENDER_SHADOWS\nin highp float v_z_offset;\n#endif\nin vec2 v_tex_a;\n#ifdef ICON_TRANSITION\nin vec2 v_tex_b;\n#endif\nin float v_draw_halo;in vec3 v_gamma_scale_size_fade_opacity;\n#ifdef RENDER_TEXT_AND_SYMBOL\nin float is_sdf;in vec2 v_tex_a_icon;\n#endif\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\nin lowp float v_opacity;in lowp vec4 v_fill_np_color;in lowp vec4 v_halo_np_color;in lowp float v_halo_width;in lowp float v_halo_blur;\n#ifdef LIGHTING_3D_MODE\nin lowp float v_emissive_strength;\n#endif\nvoid main() {lowp float opacity=v_opacity;lowp vec4 fill_color=vec4(0.0);lowp vec4 halo_color=vec4(0.0);lowp float halo_width=0.0;lowp float halo_blur=0.0;if (u_is_sdf) {fill_color=vec4(v_fill_np_color.rgb*v_fill_np_color.a,v_fill_np_color.a);halo_color=vec4(v_halo_np_color.rgb*v_halo_np_color.a,v_halo_np_color.a);halo_width=v_halo_width;halo_blur=v_halo_blur;}lowp float emissive_strength=0.0;\n#ifdef LIGHTING_3D_MODE\nemissive_strength=v_emissive_strength;\n#endif\nvec4 out_color;float fade_opacity=v_gamma_scale_size_fade_opacity[2];\n#ifdef RENDER_TEXT_AND_SYMBOL\nif (is_sdf==ICON) {vec2 tex_icon=v_tex_a_icon;lowp float alpha=opacity*fade_opacity*u_opacity_multiplier;glFragColor=texture(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nreturn;}\n#endif\nvec2 cutout_factors=vec2(0.0);if (u_is_sdf) {float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_gamma_scale_size_fade_opacity.x;float size=v_gamma_scale_size_fade_opacity.y;float fontScale=u_is_text ? size/24.0 : size;out_color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;bool draw_halo=v_draw_halo > 0.0;if (draw_halo) {out_color=halo_color;gamma=(halo_blur*u_scale_factor*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width*u_scale_factor/fontScale)/SDF_PX;}lowp float dist=texture(u_texture,v_tex_a).r;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);out_color*=alpha;} else {\n#ifdef ICON_TRANSITION\nvec4 a=texture(u_texture,v_tex_a)*(1.0-u_icon_transition);vec4 b=texture(u_texture,v_tex_b)*u_icon_transition;out_color=(a+b);\n#else\nout_color=texture(u_texture,v_tex_a);\n#endif\n#ifdef APPLY_LUT_ON_GPU\nout_color=applyLUT(u_lutTexture,out_color);\n#endif\n#ifdef COLOR_ADJUSTMENT\nout_color=u_color_adj_mat*out_color;\n#endif\n}out_color*=opacity*fade_opacity*u_opacity_multiplier;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);light=mix(light,1.0,cutout_factors.y);\n#ifdef TERRAIN\nout_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#else\nout_color.rgb*=mix(v_z_offset !=0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);\n#endif\n#endif\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_ubo_properties.glsl"\n#define USING_APPEARANCE 1.0\nin ivec4 a_pos_offset;in uvec4 a_tex_size;in ivec4 a_pixeloffset;in vec4 a_projected_pos;\n#define FADE_TIME_HALF_PERIOD 2147483648u\n#define FADE_TIME_PERIOD 4294967296.0\n#ifdef GLOBAL_PLACEMENT_FADE\nin highp ivec2 a_fade_ref_time;\n#endif\n#ifdef LEGACY_PLACEMENT_FADE\nin uint a_fade_opacity;\n#endif\n#ifdef Z_OFFSET\nin float a_auto_z_offset;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin ivec4 a_globe_anchor;in vec3 a_globe_normal;\n#endif\n#ifdef ICON_TRANSITION\nin uvec2 a_texb;\n#endif\n#ifdef ELEVATED_ROADS\nin vec3 a_x_axis;in vec3 a_y_axis;uniform float u_normal_scale;\n#endif\n#ifdef RENDER_SHADOWS\nout highp float v_z_offset;\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;\n#ifdef RENDER_SHADOWS\nuniform mat4 u_inv_matrix;\n#endif\nuniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_elevation_from_sea;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;\n#ifdef GLOBAL_PLACEMENT_FADE\nuniform highp int u_now;uniform float u_fade_duration;\n#endif\n#ifdef LEGACY_PLACEMENT_FADE\nuniform float u_fade_change;\n#endif\nuniform vec2 u_texsize;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_up_vector;\n#endif\n#ifdef RENDER_TEXT_AND_SYMBOL\nuniform vec2 u_texsize_icon;\n#endif\nuniform bool u_is_halo;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nout vec2 v_tex_a;\n#ifdef ICON_TRANSITION\nout vec2 v_tex_b;\n#endif\nout float v_draw_halo;out vec3 v_gamma_scale_size_fade_opacity;\n#ifdef RENDER_TEXT_AND_SYMBOL\nout float is_sdf;out vec2 v_tex_a_icon;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\n#define SPP_HEADER_SIZE_VEC4 4u\nstruct SymbolPaintProperties {vec4 fill_np_color;vec4 halo_np_color;float opacity;float halo_width;float halo_blur;float emissive_strength;float occlusion_opacity;float z_offset;vec2 translate;};uniform lowp vec4 u_spp_fill_np_color;uniform lowp vec4 u_spp_halo_np_color;uniform lowp float u_spp_opacity;uniform lowp float u_spp_halo_width;uniform lowp float u_spp_halo_blur;uniform lowp float u_spp_emissive_strength;uniform lowp float u_spp_occlusion_opacity;uniform highp float u_spp_z_offset;uniform lowp vec2 u_spp_translate_rotation;uniform highp float u_spp_zoom_fraction;in float a_feature_index;layout(std140) uniform SymbolPaintPropertiesHeaderUniform {uvec4 header[SPP_HEADER_SIZE_VEC4];} u_spp_header;layout(std140) uniform SymbolPaintPropertiesUniform {vec4 properties[MAX_UBO_SIZE_VEC4];} u_spp_properties;layout(std140) uniform SymbolPaintPropertiesIndexUniform {uvec4 block_indices[MAX_UBO_SIZE_VEC4];} u_spp_index;out lowp float v_opacity;out lowp vec4 v_fill_np_color;out lowp vec4 v_halo_np_color;out lowp float v_halo_width;out lowp float v_halo_blur;\n#ifdef LIGHTING_3D_MODE\nout lowp float v_emissive_strength;\n#endif\nuint uvec4At(uvec4 v,uint index) {return (index==0u) ? v.x :\n(index==1u) ? v.y :\n(index==2u) ? v.z : v.w;}vec4 readColor(uint base,bool isDataDriven,uint offsetVec4,uint dzr,vec2 headerZoom,vec4 fallbackValue) {if (!isDataDriven) return fallbackValue;vec4 value=u_spp_properties.properties[base+offsetVec4];vec2 blockZoom=u_spp_properties.properties[base+offsetVec4+dzr].xy;vec2 zr=mix(headerZoom,blockZoom,float(dzr));return unpack_mix_color(value,zoomFactor(zr.x,zr.y,u_spp_zoom_fraction));}float readScalar(uint base,bool isDataDriven,uint offsetVec4,float fallbackValue) {if (!isDataDriven) return fallbackValue;vec4 slot=u_spp_properties.properties[base+offsetVec4];return unpack_mix_vec2(slot.xy,zoomFactor(slot.z,slot.w,u_spp_zoom_fraction));}vec2 readTranslate(uint base,bool isDataDriven,uint offsetVec4,uint dzr) {if (!isDataDriven) return vec2(0.0);vec4 value=u_spp_properties.properties[base+offsetVec4];vec2 blockZoom=u_spp_properties.properties[base+offsetVec4+dzr].xy;float t=zoomFactor(blockZoom.x,blockZoom.y,u_spp_zoom_fraction)*float(dzr);return mix(value.xy,value.zw,t);}SymbolPaintProperties readSymbolPaintProperties() {uint dataDrivenMask=u_spp_header.header[0][0];uint dzrMask       =u_spp_header.header[0][1];uint blockSizeVec4 =u_spp_header.header[0][2];uint fillColorDzr=dzrMask & 1u;uint haloColorDzr=(dzrMask >> 1u) & 1u;vec2 fillColorHeaderZoom=uintBitsToFloat(u_spp_header.header[3].xy);vec2 haloColorHeaderZoom=uintBitsToFloat(u_spp_header.header[3].zw);uint featureIndex=uint(a_feature_index);uvec4 indexSlot=u_spp_index.block_indices[featureIndex/4u];uint base=uvec4At(indexSlot,featureIndex % 4u)*blockSizeVec4;SymbolPaintProperties props;props.fill_np_color    =readColor(base,(dataDrivenMask & (1u << 0u)) !=0u,u_spp_header.header[0][3],fillColorDzr,fillColorHeaderZoom,u_spp_fill_np_color);props.halo_np_color    =readColor(base,(dataDrivenMask & (1u << 1u)) !=0u,u_spp_header.header[1][0],haloColorDzr,haloColorHeaderZoom,u_spp_halo_np_color);props.opacity          =readScalar(base,(dataDrivenMask & (1u << 2u)) !=0u,u_spp_header.header[1][1],u_spp_opacity);props.halo_width       =readScalar(base,(dataDrivenMask & (1u << 3u)) !=0u,u_spp_header.header[1][2],u_spp_halo_width);props.halo_blur        =readScalar(base,(dataDrivenMask & (1u << 4u)) !=0u,u_spp_header.header[1][3],u_spp_halo_blur);props.emissive_strength=readScalar(base,(dataDrivenMask & (1u << 5u)) !=0u,u_spp_header.header[2][0],u_spp_emissive_strength);props.occlusion_opacity=readScalar(base,(dataDrivenMask & (1u << 6u)) !=0u,u_spp_header.header[2][1],u_spp_occlusion_opacity);props.z_offset         =readScalar(base,(dataDrivenMask & (1u << 7u)) !=0u,u_spp_header.header[2][2],u_spp_z_offset);uint translateDzr=(dzrMask >> 8u) & 1u;props.translate        =readTranslate(base,(dataDrivenMask & (1u << 8u)) !=0u,u_spp_header.header[2][3],translateDzr);return props;}vec2 unpack_opacity(uint packedOpacity) {return vec2(float(packedOpacity/2u)/127.0,float(packedOpacity & 1u));}void main() {SymbolPaintProperties paint_properties=readSymbolPaintProperties();lowp float opacity=paint_properties.opacity;v_opacity=opacity;v_fill_np_color=paint_properties.fill_np_color;v_halo_np_color=paint_properties.halo_np_color;v_halo_width=paint_properties.halo_width;v_halo_blur=paint_properties.halo_blur;\n#ifdef LIGHTING_3D_MODE\nv_emissive_strength=paint_properties.emissive_strength;\n#endif\nlowp float occlusion_opacity=paint_properties.occlusion_opacity;highp float z_offset=paint_properties.z_offset;vec2 a_pos=vec2(a_pos_offset.xy);vec2 a_offset=vec2(a_pos_offset.zw);vec2 a_tex=vec2(a_tex_size.xy);vec2 a_size=vec2(a_tex_size.zw);float a_size_min=floor(a_size[0]*0.5);float a_size_max= floor(a_size[1]*0.5);float a_apperance=a_size[1]-2.0*a_size_max;vec2 a_pxoffset=vec2(a_pixeloffset.xy);vec2 a_min_font_scale=vec2(a_pixeloffset.zw)/256.0;highp float segment_angle=-a_projected_pos[3];float size;if (a_apperance==USING_APPEARANCE) {size=a_size_max/128.0;} else if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size_max,u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;float e=u_elevation_from_sea ? z_offset : z_offset+elevation(tile_anchor);\n#ifdef Z_OFFSET\ne+=a_auto_z_offset;\n#endif\nvec3 h=elevationVector(tile_anchor)*e;float globe_occlusion_fade;vec3 world_pos;vec3 mercator_pos;vec3 world_pos_globe;\n#ifdef PROJECTION_GLOBE_VIEW\nmercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);world_pos_globe=vec3(a_globe_anchor)+h;world_pos=mix_globe_mercator(world_pos_globe,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nworld_pos=vec3(tile_anchor,0)+h;globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float font_scale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetprojected_point;vec2 a;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 displacement=vec3(a_globe_normal.z,0,-a_globe_normal.x);offsetprojected_point=u_matrix*vec4(vec3(a_globe_anchor)+displacement,1);vec4 projected_point_globe=u_matrix*vec4(world_pos_globe,1);a=projected_point_globe.xy/projected_point_globe.w;\n#else\noffsetprojected_point=u_matrix*vec4(tile_anchor+vec2(1,0),0,1);a=projected_point.xy/projected_point.w;\n#endif\nvec2 b=offsetprojected_point.xy/offsetprojected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec4 projected_pos;\n#ifdef PROJECTION_GLOBE_VIEW\n#ifdef PROJECTED_POS_ON_VIEWPORT\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xyz+h,1.0);\n#else\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz,mercator_pos,u_zoom_transition)+h;projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);\n#endif\n#else\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*max(a_min_font_scale,font_scale)+a_pxoffset/16.0);\n#ifdef TERRAIN\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\n#endif\n#ifdef Z_OFFSET\nz+=u_pitch_with_map ? a_auto_z_offset+z_offset : 0.0;\n#else\nz+=u_pitch_with_map ? z_offset : 0.0;\n#endif\nfloat occlusion_fade=globe_occlusion_fade;float out_fade_opacity=occlusion_fade;\n#ifdef GLOBAL_PLACEMENT_FADE\nhighp int fade_state=a_fade_ref_time.y;float fade_target=float(fade_state & 1);highp uint fade_elapsed_bits=uint(u_now)-uint(a_fade_ref_time.x);float fade_elapsed=float(fade_elapsed_bits);if (fade_elapsed_bits >=FADE_TIME_HALF_PERIOD) fade_elapsed-=FADE_TIME_PERIOD;bool fade_settled=(fade_state & 2) !=0;float fade_t=(fade_settled || u_fade_duration==0.0) ? 1.0 : fade_elapsed/u_fade_duration;float raw_fade_opacity=fade_target > 0.5 ? fade_t : 1.0-fade_t;out_fade_opacity=clamp(raw_fade_opacity,0.0,occlusion_fade);\n#endif\n#ifdef LEGACY_PLACEMENT_FADE\nvec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;out_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change));\n#endif\n#ifdef DEPTH_OCCLUSION\nfloat depth_occlusion=occlusionFadeMultiSample(projected_point);float depth_occlusion_multplier=mix(occlusion_opacity,1.0,depth_occlusion);out_fade_opacity*=depth_occlusion_multplier;\n#endif\nfloat alpha=opacity*out_fade_opacity;float hidden=float(alpha==0.0 || projected_point.w <=0.0 || occlusion_fade==0.0);vec3 pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);pos=projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y;\n#else\n#ifdef ELEVATED_ROADS\nvec3 xAxis=vec3(a_x_axis.xy,a_x_axis.z*u_normal_scale);vec3 yAxis=vec3(a_y_axis.xy,a_y_axis.z*u_normal_scale);pos=projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y;\n#else\npos=vec3(projected_pos.xy/projected_pos.w+offset,z);\n#endif\n#endif\ngl_Position=mix(u_coord_matrix*vec4(pos,1.0),AWAY,hidden);{vec2 tr=paint_properties.translate;vec2 rotated_tr=vec2(\nu_spp_translate_rotation.x*tr.x-u_spp_translate_rotation.y*tr.y,u_spp_translate_rotation.y*tr.x+u_spp_translate_rotation.x*tr.y\n);gl_Position.xy+=(u_coord_matrix*vec4(rotated_tr,0.0,0.0)).xy;}float gamma_scale=gl_Position.w;v_draw_halo=(u_is_halo && float(gl_InstanceID)==0.0) ? 1.0 : 0.0;v_gamma_scale_size_fade_opacity=vec3(gamma_scale,size,out_fade_opacity);v_tex_a=a_tex/u_texsize;\n#ifdef RENDER_TEXT_AND_SYMBOL\nis_sdf=a_size[0]-2.0*a_size_min;v_tex_a_icon=a_tex/u_texsize_icon;\n#endif\n#ifdef ICON_TRANSITION\nv_tex_b=vec2(a_texb)/u_texsize;\n#endif\n#ifdef RENDER_SHADOWS\nvec4 shd_pos=u_inv_matrix*vec4(pos,1.0);vec3 shd_pos0=shd_pos.xyz;vec3 shd_pos1=shd_pos.xyz;\n#ifdef NORMAL_OFFSET\nvec3 shd_pos_offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=shd_pos_offset*shadow_normal_offset_multiplier0();shd_pos1+=shd_pos_offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef RENDER_SHADOWS\nv_z_offset=e;\n#endif\n}'),
            skybox: WE('#include "_prelude_fog.fragment.glsl"\nin lowp vec3 v_uv;uniform lowp samplerCube u_cubemap;uniform lowp float u_opacity;uniform highp float u_temporal_offset;uniform highp vec3 u_sun_direction;float sun_disk(highp vec3 ray_direction,highp vec3 sun_direction) {highp float cos_angle=dot(normalize(ray_direction),sun_direction);const highp float cos_sun_angular_diameter=0.99996192306;const highp float smoothstep_delta=1e-5;return smoothstep(\ncos_sun_angular_diameter-smoothstep_delta,cos_sun_angular_diameter+smoothstep_delta,cos_angle);}float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec3 uv=v_uv;const float y_bias=0.015;uv.y+=y_bias;uv.y=pow(abs(uv.y),1.0/5.0);uv.y=map(uv.y,0.0,1.0,-1.0,1.0);vec3 sky_color=texture(u_cubemap,uv).rgb;\n#ifdef FOG\nsky_color=fog_apply_sky_gradient(v_uv.xzy,sky_color);\n#endif\nsky_color+=0.1*sun_disk(v_uv,u_sun_direction);glFragColor=vec4(sky_color*u_opacity,u_opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', wE),
            skyboxGradient: WE('#include "_prelude_fog.fragment.glsl"\nin highp vec3 v_uv;uniform lowp sampler2D u_color_ramp;uniform highp vec3 u_center_direction;uniform lowp float u_radius;uniform lowp float u_opacity;uniform highp float u_temporal_offset;void main() {float progress=acos(dot(normalize(v_uv),u_center_direction))/u_radius;vec4 color=texture(u_color_ramp,vec2(progress,0.5));\n#ifdef FOG\ncolor.rgb=fog_apply_sky_gradient(v_uv.xzy,color.rgb/color.a)*color.a;\n#endif\ncolor*=u_opacity;glFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', wE),
            skyboxCapture: WE("\nin highp vec3 v_position;uniform highp float u_sun_intensity;uniform highp float u_luminance;uniform lowp vec3 u_sun_direction;uniform highp vec4 u_color_tint_r;uniform highp vec4 u_color_tint_m;precision highp float;\n#define BETA_R                  vec3(5.5e-6,13.0e-6,22.4e-6)\n#define BETA_M                  vec3(21e-6,21e-6,21e-6)\n#define MIE_G                   0.76\n#define DENSITY_HEIGHT_SCALE_R  8000.0\n#define DENSITY_HEIGHT_SCALE_M  1200.0\n#define PLANET_RADIUS           6360e3\n#define ATMOSPHERE_RADIUS       6420e3\n#define SAMPLE_STEPS            10\n#define DENSITY_STEPS           4\nfloat ray_sphere_exit(vec3 orig,vec3 dir,float radius) {float a=dot(dir,dir);float b=2.0*dot(dir,orig);float c=dot(orig,orig)-radius*radius;float d=sqrt(b*b-4.0*a*c);return (-b+d)/(2.0*a);}vec3 extinction(vec2 density) {return exp(-vec3(BETA_R*u_color_tint_r.a*density.x+BETA_M*u_color_tint_m.a*density.y));}vec2 local_density(vec3 point) {float height=max(length(point)-PLANET_RADIUS,0.0);float exp_r=exp(-height/DENSITY_HEIGHT_SCALE_R);float exp_m=exp(-height/DENSITY_HEIGHT_SCALE_M);return vec2(exp_r,exp_m);}float phase_ray(float cos_angle) {return (3.0/(16.0*PI))*(1.0+cos_angle*cos_angle);}float phase_mie(float cos_angle) {return (3.0/(8.0*PI))*((1.0-MIE_G*MIE_G)*(1.0+cos_angle*cos_angle))/((2.0+MIE_G*MIE_G)*pow(1.0+MIE_G*MIE_G-2.0*MIE_G*cos_angle,1.5));}vec2 density_to_atmosphere(vec3 point,vec3 light_dir) {float ray_len=ray_sphere_exit(point,light_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(DENSITY_STEPS);vec2 density_point_to_atmosphere=vec2(0.0);for (int i=0; i < DENSITY_STEPS;++i) {vec3 point_on_ray=point+light_dir*((float(i)+0.5)*step_len);density_point_to_atmosphere+=local_density(point_on_ray)*step_len;;}return density_point_to_atmosphere;}vec3 atmosphere(vec3 ray_dir,vec3 sun_direction,float sun_intensity) {vec2 density_orig_to_point=vec2(0.0);vec3 scatter_r=vec3(0.0);vec3 scatter_m=vec3(0.0);vec3 origin=vec3(0.0,PLANET_RADIUS,0.0);float ray_len=ray_sphere_exit(origin,ray_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(SAMPLE_STEPS);for (int i=0; i < SAMPLE_STEPS;++i) {vec3 point_on_ray=origin+ray_dir*((float(i)+0.5)*step_len);vec2 density=local_density(point_on_ray)*step_len;density_orig_to_point+=density;vec2 density_point_to_atmosphere=density_to_atmosphere(point_on_ray,sun_direction);vec2 density_orig_to_atmosphere=density_orig_to_point+density_point_to_atmosphere;vec3 extinction=extinction(density_orig_to_atmosphere);scatter_r+=density.x*extinction;scatter_m+=density.y*extinction;}float cos_angle=dot(ray_dir,sun_direction);float phase_r=phase_ray(cos_angle);float phase_m=phase_mie(cos_angle);vec3 beta_r=BETA_R*u_color_tint_r.rgb*u_color_tint_r.a;vec3 beta_m=BETA_M*u_color_tint_m.rgb*u_color_tint_m.a;return (scatter_r*phase_r*beta_r+scatter_m*phase_m*beta_m)*sun_intensity;}const float A=0.15;const float B=0.50;const float C=0.10;const float D=0.20;const float E=0.02;const float F=0.30;vec3 uncharted2_tonemap(vec3 x) {return ((x*(A*x+C*B)+D*E)/(x*(A*x+B)+D*F))-E/F;}void main() {vec3 ray_direction=v_position;ray_direction.y=pow(ray_direction.y,5.0);const float y_bias=0.015;ray_direction.y+=y_bias;vec3 color=atmosphere(normalize(ray_direction),u_sun_direction,u_sun_intensity);float white_scale=1.0748724675633854;color=uncharted2_tonemap((log2(2.0/pow(u_luminance,4.0)))*color)*white_scale;glFragColor=vec4(color,1.0);}", "in highp vec3 a_pos_3f;uniform mat3 u_matrix_3f;out highp vec3 v_position;float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec4 pos=vec4(u_matrix_3f*a_pos_3f,1.0);v_position=native_cubemap_direction(pos.xyz);v_position.y=map(v_position.y,-1.0,1.0,0.0,1.0);gl_Position=vec4(a_pos_3f.xy,0.0,1.0);}"),
            globeAtmosphere: WE('#include "_prelude_fog.fragment.glsl"\nuniform float u_transition;uniform highp float u_fadeout_range;uniform highp float u_temporal_offset;uniform vec4 u_atmosphere_fog_color;uniform vec4 u_high_color;uniform vec4 u_space_color;uniform float u_horizon_angle;in highp vec3 v_ray_dir;in highp vec3 v_horizon_dir;void main() {highp vec3 dir=normalize(v_ray_dir);float globe_pos_dot_dir;\n#ifdef PROJECTION_GLOBE_VIEW\nglobe_pos_dot_dir=dot(u_globe_pos,dir);highp vec3 closest_point_forward=abs(globe_pos_dot_dir)*dir;float norm_dist_from_center=length(closest_point_forward-u_globe_pos)/u_globe_radius;if (norm_dist_from_center < 0.98) {\n#ifdef ALPHA_PASS\nglFragColor=vec4(0,0,0,0);return;\n#else\nglFragColor=vec4(0,0,0,1);return;\n#endif\n}\n#endif\nhighp vec3 horizon_dir=normalize(v_horizon_dir);float horizon_angle_mercator=dir.y < horizon_dir.y ?\n0.0 : max(acos(clamp(dot(dir,horizon_dir),-1.0,1.0)),0.0);float horizon_angle;\n#ifdef PROJECTION_GLOBE_VIEW\nhighp vec3 closest_point=globe_pos_dot_dir*dir;highp float closest_point_to_center=length(closest_point-u_globe_pos);highp float theta=asin(clamp(closest_point_to_center/length(u_globe_pos),-1.0,1.0));horizon_angle=globe_pos_dot_dir < 0.0 ?\nPI-theta-u_horizon_angle : theta-u_horizon_angle;float angle_t=pow(u_transition,10.0);horizon_angle=mix(horizon_angle,horizon_angle_mercator,angle_t);\n#else\nhorizon_angle=horizon_angle_mercator;\n#endif\nhorizon_angle/=PI;float t=exp(-horizon_angle/u_fadeout_range);float alpha_0=u_atmosphere_fog_color.a;float alpha_1=u_high_color.a;float alpha_2=u_space_color.a;vec3 color_stop_0=u_atmosphere_fog_color.rgb;vec3 color_stop_1=u_high_color.rgb;vec3 color_stop_2=u_space_color.rgb;\n#ifdef ALPHA_PASS\nfloat a0=mix(alpha_2,1.0,alpha_1);float a1=mix(a0,1.0,alpha_0);float a2=mix(a0,a1,t);float a =mix(alpha_2,a2,t);glFragColor=vec4(1.0,1.0,1.0,a);\n#else\nvec3 c0=mix(color_stop_2,color_stop_1,alpha_1);vec3 c1=mix(c0,color_stop_0,alpha_0);vec3 c2=mix(c0,c1,t);vec3 c=c2;glFragColor=vec4(c*t,t);\n#endif\n}', "in vec3 a_pos;in vec2 a_uv;uniform vec3 u_frustum_tl;uniform vec3 u_frustum_tr;uniform vec3 u_frustum_br;uniform vec3 u_frustum_bl;uniform float u_horizon;out highp vec3 v_ray_dir;out highp vec3 v_horizon_dir;void main() {v_ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,a_uv.x),mix(u_frustum_bl,u_frustum_br,a_uv.x),a_uv.y);v_horizon_dir=mix(\nmix(u_frustum_tl,u_frustum_bl,u_horizon),mix(u_frustum_tr,u_frustum_br,u_horizon),a_uv.x);gl_Position=vec4(a_pos,1.0);}"),
            stars: WE("in highp vec2 v_uv;in mediump float v_intensity;float shapeCircle(in vec2 uv)\n{float beginFade=0.6;float lengthFromCenter=length(v_uv);return 1.0-clamp((lengthFromCenter-beginFade)/(1.0-beginFade),0.0,1.0);}void main() {float alpha=shapeCircle(v_uv);vec3 color=vec3(1.0,1.0,1.0);alpha*=v_intensity;glFragColor=vec4(color*alpha,alpha);HANDLE_WIREFRAME_DEBUG;}", "\nin vec3 a_pos_3f;in vec2 a_uv;in float a_size_scale;in float a_opacity;uniform mat4 u_matrix;uniform vec3 u_up;uniform vec3 u_right;uniform float u_intensity_multiplier;out highp vec2 v_uv;out mediump float v_intensity;void main() {v_uv=a_uv;v_intensity=a_opacity*u_intensity_multiplier;vec3 pos=a_pos_3f;pos+=a_uv.x*u_right*a_size_scale;pos+=a_uv.y*u_up*a_size_scale;gl_Position=u_matrix*vec4(pos,1.0);}"),
            occlusion: WE("uniform vec4 u_color;void main() {glFragColor=u_color;}", '#include "_prelude_terrain.vertex.glsl"\nin highp vec2 a_offset_xy;uniform highp vec3 u_anchorPos;uniform mat4 u_matrix;uniform vec2 u_screenSizePx;uniform vec2 u_occluderSizePx;void main() {vec3 world_pos=u_anchorPos;\n#ifdef TERRAIN\nfloat e=elevation(world_pos.xy);world_pos.z+=e;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1.0);projected_point.xy+=projected_point.w*a_offset_xy*0.5*u_occluderSizePx/u_screenSizePx;gl_Position=projected_point;}')
        };
        function $E(e1, t1) {
            const i = e1.split("\n");
            for (let e1 of i){
                if (e1 = e1.trimStart(), "#" !== e1[0]) continue;
                if (!e1.includes("if")) continue;
                if (e1.startsWith("#endif")) continue;
                const i = e1.match(FE);
                if (i) for (const e1 of i)CE.has(e1) || t1.add(e1);
            }
        }
        function ZE(e1) {
            return new Set([
                "uint",
                "int",
                "uvec2",
                "ivec2",
                "uvec3",
                "ivec3",
                "uvec4",
                "ivec4"
            ]).has(e1);
        }
        function WE(e1, t1) {
            const i = new Set, n = [], r = [];
            e1 = e1.replace(PE, (e1, t1)=>(r.push(t1), "")), t1 = t1.replace(PE, (e1, t1)=>(n.push(t1), ""));
            let o = new Set(OE);
            $E(e1, o), $E(t1, o);
            for (const e1 of [
                ...n,
                ...r
            ])BE[e1] || (BE[e1] = new Set, $E(LE[e1], BE[e1])), o = new Set([
                ...o,
                ...BE[e1]
            ]);
            return {
                fragmentSource: e1 = e1.replace(DE, (e1, t1, n, r, o)=>(i.add(o), "define" === t1 ? `\n#ifndef HAS_UNIFORM_u_${o}\n${ZE(r) ? "flat " : ""}in ${n} ${r} ${o};\n#else\nuniform ${n} ${r} u_${o};\n#endif\n` : "initialize" === t1 ? `\n#ifdef HAS_UNIFORM_u_${o}\n    ${n} ${r} ${o} = u_${o};\n#endif\n` : "define-attribute" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${o}\n    in ${n} ${r} ${o};\n#endif\n` : "initialize-attribute" === t1 ? "" : void 0)),
                vertexSource: t1 = t1.replace(DE, (e1, t1, n, r, o)=>{
                    const a = `MATERIAL_ATTRIBUTE_OFFSET_${o}`, s = "float" === r ? "vec2" : r, l = `GET_ATTRIBUTE_${s}(a_${o}, materialInfo, ${a})`, c = o.includes("color") ? "color" : s;
                    return "define-attribute-vertex-shader-only" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${o}\nin ${n} ${r} a_${o};\n#endif\n` : i.has(o) ? "define" === t1 ? `\n#ifndef HAS_UNIFORM_u_${o}\nuniform lowp float u_${o}_t;\n    #if !defined(${a})\n        in ${n} ${s} a_${o};\n    #endif\n${ZE(r) ? "flat " : ""}out ${n} ${r} ${o};\n#else\nuniform ${n} ${r} u_${o};\n#endif\n` : "initialize" === t1 ? "vec4" === c || "uvec4" === c ? `\n#ifndef HAS_UNIFORM_u_${o}\n    ${o} = a_${o};\n#else\n    ${n} ${r} ${o} = u_${o};\n#endif\n` : `\n#if !defined(HAS_UNIFORM_u_${o})\n    #ifdef ${a}\n        ${o} = unpack_mix_${c}(${l}, u_${o}_t);\n    #else\n        ${o} = unpack_mix_${c}(a_${o}, u_${o}_t);\n    #endif\n#else\n    ${n} ${r} ${o} = u_${o};\n#endif\n` : "define-attribute" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${o}\n    in ${n} ${r} a_${o};\n    out ${n} ${r} ${o};\n#endif\n` : "initialize-attribute" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${o}\n    ${o} = a_${o};\n#endif\n` : void 0 : "define" === t1 ? `\n#ifndef HAS_UNIFORM_u_${o}\nuniform lowp float u_${o}_t;\n    #if !defined(${a})\n        in ${n} ${s} a_${o};\n    #endif\n#else\nuniform ${n} ${r} u_${o};\n#endif\n` : "define-instanced" === t1 ? "mat4" === c ? `\n#ifdef INSTANCED_ARRAYS\nin vec4 a_${o}0;\nin vec4 a_${o}1;\nin vec4 a_${o}2;\nin vec4 a_${o}3;\n#else\nuniform ${n} ${r} u_${o};\n#endif\n` : `\n#ifdef INSTANCED_ARRAYS\nin ${n} ${s} a_${o};\n#else\nuniform ${n} ${r} u_${o};\n#endif\n` : "initialize-attribute-custom" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${o}\n    ${n} ${r} ${o} = a_${o};\n#endif\n` : "vec4" === c || "uvec4" === c ? `\n#ifndef HAS_UNIFORM_u_${o}\n    #ifdef ${a}\n        ${n} ${r} ${o} = ${l};\n    #else\n        ${n} ${r} ${o} = a_${o};\n    #endif\n#else\n    ${n} ${r} ${o} = u_${o};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${o}\n    #ifdef ${a}\n        ${n} ${r} ${o} = unpack_mix_${c}(${l}, u_${o}_t);\n    #else\n        ${n} ${r} ${o} = unpack_mix_${c}(a_${o}, u_${o}_t);\n    #endif\n#else\n    ${n} ${r} ${o} = u_${o};\n#endif\n`;
                }),
                usedDefines: o,
                vertexIncludes: n,
                fragmentIncludes: r
            };
        }
        var qE = {
            model: WE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_indicator_cutout.fragment.glsl"\n#include "_prelude_feature_cutout.fragment.glsl"\nuniform float u_opacity;\n#ifdef DITHERED_DISCARD\nuniform float u_dithered_discard_threshold;\n#endif\n#ifndef LIGHTING_3D_MODE\nuniform vec3 u_lightcolor;uniform vec3 u_lightpos;uniform float u_lightintensity;\n#endif\nuniform vec4 u_baseColorFactor;uniform vec4 u_emissiveFactor;uniform float u_metallicFactor;uniform float u_roughnessFactor;uniform float u_emissive_strength;in highp vec4 v_position_height;in lowp vec4 v_color_mix;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in float v_depth_shadows;\n#endif\n#ifdef OCCLUSION_TEXTURE_TRANSFORM\nuniform vec4 u_occlusionTextureTransform;\n#endif\n#pragma mapbox: define-attribute highp vec4 normal_4n\n#pragma mapbox: define-attribute highp vec3 color_3f\n#pragma mapbox: define-attribute highp vec4 color_4f\n#pragma mapbox: define-attribute highp vec2 uv_2f\n#pragma mapbox: initialize-attribute highp vec4 normal_4n\n#pragma mapbox: initialize-attribute highp vec3 color_3f\n#pragma mapbox: initialize-attribute highp vec4 color_4f\n#pragma mapbox: initialize-attribute highp vec2 uv_2f\n#ifdef HAS_ATTRIBUTE_a_feature\nin lowp vec4 v_roughness_metallic_emissive_alpha;in mediump vec4 v_height_based_emission_params;\n#endif\n#ifdef HAS_TEXTURE_u_baseColorTexture\nuniform sampler2D u_baseColorTexture;uniform bool u_baseTextureIsAlpha;uniform bool u_alphaMask;uniform float u_alphaCutoff;\n#endif\n#ifdef HAS_TEXTURE_u_metallicRoughnessTexture\nuniform sampler2D u_metallicRoughnessTexture;\n#endif\n#ifdef HAS_TEXTURE_u_occlusionTexture\nuniform sampler2D u_occlusionTexture;uniform float u_aoIntensity;\n#endif\n#ifdef HAS_TEXTURE_u_normalTexture\nuniform sampler2D u_normalTexture;\n#endif\n#ifdef HAS_TEXTURE_u_emissionTexture\nuniform sampler2D u_emissionTexture;\n#endif\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\n#define saturate(_x) clamp(_x,0.,1.)\nvec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}float calculate_NdotL(vec3 normal,vec3 lightDir) {const float ext=0.70710678118;return (clamp(dot(normal,lightDir),-ext,1.0)+ext)/(1.0+ext);}vec3 getDiffuseShadedColor(vec3 albedo,vec3 normal,vec3 lightDir,vec3 lightColor)\n{\n#ifdef LIGHTING_3D_MODE\nvec3 transformed_normal=vec3(-normal.xy,normal.z);float lighting_factor;\n#ifdef RENDER_SHADOWS\nlighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);\n#else\nlighting_factor=saturate(dot(transformed_normal,u_lighting_directional_dir));\n#endif\nreturn apply_lighting(albedo,transformed_normal,lighting_factor);\n#else\nvec3 n=normal;float colorvalue=((albedo.x*0.2126)+(albedo.y*0.7152))+(albedo.z*0.0722);vec3 c=vec3(0.03,0.03,0.03);float directional=clamp(dot(n,vec3(lightDir)),0.0,1.0);directional=mix(1.0-u_lightintensity,max((1.0-colorvalue)+u_lightintensity,1.0),directional);vec3 c3=c+clamp((albedo*directional)*lightColor,mix(vec3(0.0),vec3(0.3),vec3(1.0)-lightColor),vec3(1.0));return c3;\n#endif\n}vec4 getBaseColor() {vec4 albedo=u_baseColorFactor;\n#ifdef HAS_ATTRIBUTE_a_color_3f\nalbedo*=vec4(color_3f,1.0);\n#endif\n#ifdef HAS_ATTRIBUTE_a_feature\n#else\n#ifdef HAS_ATTRIBUTE_a_color_4f\nalbedo*=color_4f;\n#endif\n#endif\n#if defined (HAS_TEXTURE_u_baseColorTexture) && defined (HAS_ATTRIBUTE_a_uv_2f)\nvec4 texColor=texture(u_baseColorTexture,uv_2f);if(u_alphaMask) {if (texColor.w < u_alphaCutoff) {discard;}}\n#ifdef UNPREMULT_TEXTURE_IN_SHADER\ntexColor=vec4(unpremultiplyColor(texColor),1.0);\n#endif\nif(u_baseTextureIsAlpha) {if (texColor.r < 0.5) {discard;}} else {texColor.rgb=sRGBToLinear(texColor.rgb);albedo*=texColor;}\n#endif\nvec4 color=vec4(mix(albedo.rgb,v_color_mix.rgb,v_color_mix.a),albedo.a);\n#ifdef APPLY_LUT_ON_GPU\ncolor=applyLUT(u_lutTexture,color);\n#endif\nreturn color;}highp mat3 cotangentFrame(highp vec3 N,highp vec3 p,highp vec2 uv ) {\n#ifdef HAS_TEXTURE_u_normalTexture\nhighp vec3 dp1=vec3(dFdx(p.x),dFdx(p.y),dFdx(p.z));highp vec3 dp2=vec3(dFdy(p.x),dFdy(p.y),dFdy(p.z));highp vec2 duv1=vec2(dFdx(uv.x),dFdx(uv.y));highp vec2 duv2=vec2(dFdy(uv.x),dFdy(uv.y));highp vec3 dp2perp=cross( dp2,N );highp vec3 dp1perp=cross( N,dp1 );highp vec3 T=native_window_space_tangent(dp2perp*duv1.x+dp1perp*duv2.x);highp vec3 B=native_window_space_tangent(dp2perp*duv1.y+dp1perp*duv2.y);highp float lengthT=dot(T,T);highp float lengthB=dot(B,B);highp float maxLength=max(lengthT,lengthB);highp float invmax=inversesqrt( maxLength );highp mat3 res=mat3( T*invmax,B*invmax,N );return res;\n#else\nreturn mat3(1.0);\n#endif\n}highp vec3 getNormal(){highp vec3 n;\n#ifdef HAS_ATTRIBUTE_a_normal_4n\nn=normalize(normal_4n.xyz);\n#else\nhighp vec3 fdx=vec3(dFdx(v_position_height.x),dFdx(v_position_height.y),dFdx(v_position_height.z));highp vec3 fdy=vec3(dFdy(v_position_height.x),dFdy(v_position_height.y),dFdy(v_position_height.z));n=native_window_space_normal(fdx,fdy);\n#endif\n#if defined(HAS_TEXTURE_u_normalTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nvec3 nMap=texture( u_normalTexture,uv_2f).xyz;nMap=normalize(2.0*nMap-vec3(1.0));highp vec3 v=native_tbn_view_dir(v_position_height.xyz);highp mat3 TBN=cotangentFrame(n,v,uv_2f);n=normalize(TBN*nMap);\n#endif\nreturn n;}struct Material {float perceptualRoughness;float alphaRoughness;float metallic;vec3 f90;vec4 baseColor;vec3 diffuseColor;vec3 specularColor;highp vec3 normal;};Material getPBRMaterial() {Material mat;mat.baseColor=getBaseColor();mat.perceptualRoughness=u_roughnessFactor;mat.metallic=u_metallicFactor;\n#ifdef HAS_ATTRIBUTE_a_feature\nmat.perceptualRoughness=v_roughness_metallic_emissive_alpha.x;mat.metallic=v_roughness_metallic_emissive_alpha.y;mat.baseColor.w*=v_roughness_metallic_emissive_alpha.w;\n#endif\n#if defined(HAS_TEXTURE_u_metallicRoughnessTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nvec4 mrSample=texture(u_metallicRoughnessTexture,uv_2f);mat.perceptualRoughness*=mrSample.g;mat.metallic*=mrSample.b;\n#endif\nconst float c_minRoughness=0.04;mat.perceptualRoughness=clamp(mat.perceptualRoughness,c_minRoughness,1.0);mat.metallic=saturate(mat.metallic);mat.alphaRoughness=mat.perceptualRoughness*mat.perceptualRoughness;const vec3 f0=vec3(0.04);mat.diffuseColor=mat.baseColor.rgb*(vec3(1.0)-f0);mat.diffuseColor*=1.0-mat.metallic;mat.specularColor=mix(f0,mat.baseColor.rgb,mat.metallic);highp float reflectance=max(max(mat.specularColor.r,mat.specularColor.g),mat.specularColor.b);highp float reflectance90=saturate(reflectance*25.0);mat.f90=vec3(reflectance90);mat.normal=getNormal();return mat;}float V_GGX(float NdotL,float NdotV,float roughness)\n{float a2=roughness*roughness;float GGXV=NdotL*sqrt(NdotV*NdotV*(1.0-a2)+a2);float GGXL=NdotV*sqrt(NdotL*NdotL*(1.0-a2)+a2);return 0.5/(GGXV+GGXL);}float V_GGXFast(float NdotL,float NdotV,float roughness) {float a=roughness;float GGXV=NdotL*(NdotV*(1.0-a)+a);float GGXL=NdotV*(NdotL*(1.0-a)+a);return 0.5/(GGXV+GGXL);}vec3 F_Schlick(vec3 specularColor,vec3 f90,float VdotH)\n{return specularColor+(f90-specularColor)*pow(clamp(1.0-VdotH,0.0,1.0),5.0);}vec3 F_SchlickFast(vec3 specularColor,float VdotH)\n{float x=1.0-VdotH;float x4=x*x*x*x;return specularColor+(1.0-specularColor)*x4*x;}float D_GGX(highp float NdotH,float alphaRoughness)\n{highp float a4=alphaRoughness*alphaRoughness;highp float f=(NdotH*a4-NdotH)*NdotH+1.0;return a4/(PI*f*f);}vec3 diffuseBurley(Material mat,float LdotH,float NdotL,float NdotV)\n{float f90=2.0*LdotH*LdotH*mat.alphaRoughness-0.5;return (mat.diffuseColor/PI)*(1.0+f90*pow((1.0-NdotL),5.0))*(1.0+f90*pow((1.0-NdotV),5.0));}vec3 diffuseLambertian(Material mat)\n{\n#ifdef LIGHTING_3D_MODE\nreturn mat.diffuseColor;\n#else\nreturn mat.diffuseColor/PI;\n#endif\n}vec3 EnvBRDFApprox(vec3 specularColor,float roughness,highp float NdotV)\n{vec4 c0=vec4(-1,-0.0275,-0.572,0.022);vec4 c1=vec4(1,0.0425,1.04,-0.04);highp vec4 r=roughness*c0+c1;highp float a004=min(r.x*r.x,exp2(-9.28*NdotV))*r.x+r.y;vec2 AB=vec2(-1.04,1.04)*a004+r.zw;return specularColor*AB.x+AB.y;}vec3 computeIndirectLightContribution(Material mat,float NdotV,vec3 normal)\n{vec3 env_light=vec3(0.65,0.65,0.65);\n#ifdef LIGHTING_3D_MODE\nfloat ambient_factor=calculate_ambient_directional_factor(normal);env_light=u_lighting_ambient_color*ambient_factor;\n#endif\nvec3 envBRDF=EnvBRDFApprox(mat.specularColor,mat.perceptualRoughness,NdotV);vec3 indirectSpecular= envBRDF*env_light;vec3 indirectDiffuse=mat.diffuseColor*env_light;return indirectSpecular+indirectDiffuse;}vec3 computeLightContribution(Material mat,vec3 lightPosition,vec3 lightColor)\n{highp vec3 n=mat.normal;highp vec3 v=normalize(-v_position_height.xyz);highp vec3 l=normalize(lightPosition);highp vec3 h=normalize(v+l);float NdotV=clamp(abs(dot(n,v)),0.001,1.0);float NdotL=saturate(dot(n,l));highp float NdotH=saturate(dot(n,h));float VdotH=saturate(dot(v,h));vec3 f=F_SchlickFast(mat.specularColor,VdotH);float g=V_GGXFast(NdotL,NdotV,mat.alphaRoughness);float d=D_GGX(NdotH,mat.alphaRoughness);vec3 diffuseTerm=(1.0-f)*diffuseLambertian(mat);vec3 specularTerm=f*g*d;vec3 transformed_normal=vec3(-n.xy,n.z);float lighting_factor;\n#ifdef RENDER_SHADOWS\nlighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);\n#else\nlighting_factor=NdotL;\n#endif\nvec3 directLightColor=(specularTerm+diffuseTerm)*lighting_factor*lightColor;vec3 indirectLightColor=computeIndirectLightContribution(mat,NdotV,transformed_normal);vec3 color=(saturate(directLightColor)+indirectLightColor);float intensityFactor=1.0;\n#if !defined(LIGHTING_3D_MODE)\nconst vec3 luminosityFactor=vec3(0.2126,0.7152,0.0722);float luminance=dot(diffuseTerm,luminosityFactor);intensityFactor=mix((1.0-u_lightintensity),max((1.0-luminance+u_lightintensity),1.0),NdotL);\n#endif\ncolor*=intensityFactor;return color;}void main() {vec3 lightDir;vec3 lightColor;\n#ifdef LIGHTING_3D_MODE\nlightDir=u_lighting_directional_dir;lightDir.xy=-lightDir.xy;lightColor=u_lighting_directional_color;\n#else\nlightDir=u_lightpos;lightColor=u_lightcolor;\n#endif\nvec4 finalColor;\n#ifdef DIFFUSE_SHADED\nvec3 N=getNormal();vec3 baseColor=getBaseColor().rgb;vec3 diffuse=getDiffuseShadedColor(baseColor,N,lightDir,lightColor);\n#ifdef HAS_TEXTURE_u_occlusionTexture\nfloat ao=(texture(u_occlusionTexture,uv_2f).r-1.0)*u_aoIntensity+1.0;diffuse*=ao;\n#endif\nfinalColor=vec4(mix(diffuse,baseColor,u_emissive_strength),1.0)*u_opacity;\n#else\nMaterial mat=getPBRMaterial();vec3 color=computeLightContribution(mat,lightDir,lightColor);float ao=1.0;\n#if defined (HAS_TEXTURE_u_occlusionTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\n#ifdef OCCLUSION_TEXTURE_TRANSFORM\nvec2 uv=uv_2f.xy*u_occlusionTextureTransform.zw+u_occlusionTextureTransform.xy;\n#else\nvec2 uv=uv_2f;\n#endif\nao=(texture(u_occlusionTexture,uv).x-1.0)*u_aoIntensity+1.0;color*=ao;\n#endif\nvec4 emissive=u_emissiveFactor;\n#if defined(HAS_TEXTURE_u_emissionTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nemissive.rgb*=sRGBToLinear(texture(u_emissionTexture,uv_2f).rgb);\n#endif\n#ifdef APPLY_LUT_ON_GPU\nfloat emissiveFactorLength=max(length(u_emissiveFactor.rgb),0.001);emissive.rgb=sRGBToLinear(applyLUT(u_lutTexture,linearTosRGB(emissive.rgb/emissiveFactorLength).rbg))*emissiveFactorLength;\n#endif\ncolor+=emissive.rgb;float opacity=mat.baseColor.w*u_opacity;\n#ifdef HAS_ATTRIBUTE_a_feature\nfloat resEmission=v_roughness_metallic_emissive_alpha.z;resEmission*=v_height_based_emission_params.z+v_height_based_emission_params.w*pow(clamp(v_height_based_emission_params.x,0.0,1.0),v_height_based_emission_params.y);vec3 color_mix=v_color_mix.rgb;\n#ifdef APPLY_LUT_ON_GPU\ncolor_mix=applyLUT(u_lutTexture,color_mix);\n#endif\ncolor=mix(color,color_mix,min(1.0,resEmission));\n#ifdef HAS_ATTRIBUTE_a_color_4f\nfloat distance=length(vec2(1.3*max(0.0,abs(color_4f.x)-color_4f.z),color_4f.y));distance+= mix(0.5,0.0,clamp(resEmission-1.0,0.0,1.0));opacity*=v_roughness_metallic_emissive_alpha.w*saturate(1.0-distance*distance);\n#endif\n#endif\nvec3 unlitColor=mat.baseColor.rgb*ao+emissive.rgb;color=mix(color,unlitColor,u_emissive_strength);color=linearTosRGB(color);color*=opacity;finalColor=vec4(color,opacity);\n#endif\n#ifdef DITHERED_DISCARD\nif (abs(u_dithered_discard_threshold) < 1.0) {float ditherValue=fract(52.9829189*fract(0.06711056*gl_FragCoord.x+0.00583715*gl_FragCoord.y));float compareValue=mix(1.0-ditherValue,ditherValue,step(0.0,u_dithered_discard_threshold));if (abs(u_dithered_discard_threshold) < compareValue) {discard;}}\n#endif\n#ifdef FOG\nfinalColor=fog_dither(fog_apply_premultiplied(finalColor,v_fog_pos,v_position_height.w));\n#endif\n#ifdef RENDER_CUTOFF\nfinalColor*=v_cutoff_opacity;\n#endif\nglFragColor=finalColor;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_feature_cutout.vertex.glsl"\nin vec3 a_pos_3f;\n#pragma mapbox: define-attribute highp vec4 normal_4n\n#pragma mapbox: define-attribute highp vec2 uv_2f\n#pragma mapbox: define-attribute highp vec3 color_3f\n#pragma mapbox: define-attribute highp vec4 color_4f\n#pragma mapbox: define-attribute-vertex-shader-only highp uvec2 feature\n#define MODEL_PART_COUNT 7u\n#define MODEL_PART_STYLE_SIZE_VEC4 28u\n#ifdef HAS_ATTRIBUTE_a_feature\nstruct ModelPartStyle {vec4 color_mix;vec4 rmea;vec4 gradient;float gradient_power;};layout(std140) uniform ModelPartStyleUniform {vec4 part_style[MODEL_PART_STYLE_SIZE_VEC4];} u_model_part_style;uniform vec4 u_model_mesh_params;\n#endif\nuniform mat4 u_matrix;uniform mat4 u_node_matrix;uniform mat4 u_lighting_matrix;uniform vec3 u_camera_pos;uniform vec4 u_color_mix;\n#ifdef INSTANCED_ARRAYS\nin vec4 a_normal_matrix0;in vec4 a_normal_matrix1;in vec4 a_normal_matrix2;in vec4 a_normal_matrix3;\n#else\nuniform highp mat4 u_normal_matrix;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out float v_depth_shadows;\n#endif\nout vec4 v_position_height;out lowp vec4 v_color_mix;\n#ifdef HAS_ATTRIBUTE_a_feature\nout lowp vec4 v_roughness_metallic_emissive_alpha;out mediump vec4 v_height_based_emission_params;\n#endif\nvec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}\n#ifdef HAS_ATTRIBUTE_a_feature\nuint decodeModelPartId(uvec2 feature) {uint partId=feature.y & 0xFu;return partId < MODEL_PART_COUNT ? partId : 0u;}vec4 decodeModelVertexColor(uvec2 feature) {uvec4 nibbles=uvec4(feature.x >> 12u,feature.x >> 8u,feature.x >> 4u,feature.x) & 0xFu;return vec4(nibbles*17u)/255.0;}ModelPartStyle readModelPartStyle(uint partId) {uint base=partId*4u;ModelPartStyle style;style.color_mix=u_model_part_style.part_style[base];style.rmea=u_model_part_style.part_style[base+1u];style.gradient=u_model_part_style.part_style[base+2u];style.gradient_power=u_model_part_style.part_style[base+3u].x;return style;}vec3 modelAlbedo(ModelPartStyle style,vec4 vertexColor) {float ambientOcclusion=mix(1.0,vertexColor.a,u_model_mesh_params.z);return ambientOcclusion*mix(vertexColor.rgb,style.color_mix.rgb,style.color_mix.a);}vec4 resolveModelEmissiveGradient(ModelPartStyle style,float height) {float begin=u_model_mesh_params.x+u_model_mesh_params.y*style.gradient.x;float span=u_model_mesh_params.y*(style.gradient.y-style.gradient.x);return vec4((height-begin)/span,style.gradient_power,style.gradient.z,style.gradient.w);}\n#endif\nvoid main() {\n#pragma mapbox: initialize-attribute highp vec4 normal_4n\n#pragma mapbox: initialize-attribute highp vec2 uv_2f\n#pragma mapbox: initialize-attribute highp vec3 color_3f\n#pragma mapbox: initialize-attribute highp vec4 color_4f\n#pragma mapbox: initialize-attribute-custom highp uvec2 feature\nhighp mat4 normal_matrix;\n#ifdef INSTANCED_ARRAYS\nnormal_matrix=mat4(a_normal_matrix0,a_normal_matrix1,a_normal_matrix2,a_normal_matrix3);\n#else\nnormal_matrix=u_normal_matrix;\n#endif\nvec3 local_pos;mat3 rs;\n#ifdef MODEL_POSITION_ON_GPU\nvec3 pos_color=normal_matrix[0].xyz;vec4 translate=normal_matrix[1];vec3 pos_a=floor(pos_color);vec3 rgb=1.05*(pos_color-pos_a);float hidden=float(pos_a.x > EXTENT);float color_mix=pos_a.z/100.0;v_color_mix=vec4(sRGBToLinear(rgb),color_mix);float meter_to_tile=normal_matrix[0].w;vec4 pos=vec4(pos_a.xy,translate.z,1.0);rs[0].x=normal_matrix[1].w;rs[0].yz=normal_matrix[2].xy;rs[1].xy=normal_matrix[2].zw;rs[1].z=normal_matrix[3].x;rs[2].xyz=normal_matrix[3].yzw;vec4 pos_node=u_lighting_matrix*vec4(a_pos_3f,1.0);vec3 rotated_pos_node=rs*pos_node.xyz;vec3 pos_model_tile=(rotated_pos_node+vec3(translate.xy,0.0))*vec3(meter_to_tile,meter_to_tile,1.0);pos.xyz+=pos_model_tile;local_pos=pos.xyz;gl_Position=mix(u_matrix*pos,AWAY,hidden);pos.z*=meter_to_tile;v_position_height.xyz=pos.xyz-u_camera_pos;\n#else\nlocal_pos=a_pos_3f;gl_Position=u_matrix*vec4(a_pos_3f,1);v_position_height.xyz=vec3(u_lighting_matrix*vec4(a_pos_3f,1));v_color_mix=vec4(sRGBToLinear(u_color_mix.rgb),u_color_mix.a);\n#endif\nv_position_height.w=a_pos_3f.z;\n#ifdef HAS_ATTRIBUTE_a_feature\nModelPartStyle part_style=readModelPartStyle(decodeModelPartId(feature));v_color_mix=vec4(modelAlbedo(part_style,decodeModelVertexColor(feature)),1.0);v_roughness_metallic_emissive_alpha=part_style.rmea;v_height_based_emission_params=resolveModelEmissiveGradient(part_style,a_pos_3f.z);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(local_pos);\n#endif\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,native_clip_z_to_cutoff_depth(gl_Position.z,gl_Position.w));\n#endif\n#ifdef HAS_ATTRIBUTE_a_normal_4n\n#ifdef MODEL_POSITION_ON_GPU\nfloat x_squared_scale=dot(rs[0],rs[0]);float y_squared_scale=dot(rs[1],rs[1]);float z_squared_scale=dot(rs[2],rs[2]);vec3 squared_scale=vec3(x_squared_scale,y_squared_scale,z_squared_scale);normal_4n=vec4(rs*((u_lighting_matrix*vec4(normal_4n.xyz,0.0)).xyz/squared_scale),0.0);normal_4n=normalize(normal_4n);\n#else\nnormal_4n=vec4((normal_matrix*vec4(normal_4n.xyz,0)).xyz,0.0);\n#endif\n#endif\n#ifdef HAS_ATTRIBUTE_a_feature\n#ifdef HAS_ATTRIBUTE_a_color_4f\nv_roughness_metallic_emissive_alpha.w=clamp(color_4f.a*v_roughness_metallic_emissive_alpha.w*(v_roughness_metallic_emissive_alpha.z-1.0),0.0,1.0);\n#endif\n#endif\n#ifdef RENDER_SHADOWS\nvec4 shadow_pos=u_node_matrix*vec4(local_pos,1.0);\n#ifdef NORMAL_OFFSET\n#ifdef HAS_ATTRIBUTE_a_normal_4n\n#ifdef MODEL_POSITION_ON_GPU\nvec3 offset=shadow_normal_offset(vec3(-normal_4n.xy,normal_4n.z));shadow_pos.xyz+=offset*shadow_normal_offset_multiplier0();\n#else\nvec3 offset=shadow_normal_offset_model(normal_4n.xyz);shadow_pos.xyz+=offset*shadow_normal_offset_multiplier0();\n#endif\n#endif\n#endif\nv_pos_light_view_0=u_light_matrix_0*shadow_pos;v_pos_light_view_1=u_light_matrix_1*shadow_pos;v_depth_shadows=gl_Position.w;\n#endif\n}'),
            modelDepth: WE("void main() {}", "in vec3 a_pos_3f;uniform mat4 u_matrix;\n#ifdef MODEL_POSITION_ON_GPU\n#ifdef INSTANCED_ARRAYS\nin vec4 a_normal_matrix0;in vec4 a_normal_matrix1;in vec4 a_normal_matrix2;in vec4 a_normal_matrix3;\n#else\nuniform highp mat4 u_instance;\n#endif\nuniform highp mat4 u_node_matrix;\n#endif\nvoid main() {\n#ifdef MODEL_POSITION_ON_GPU\nhighp mat4 instance;\n#ifdef INSTANCED_ARRAYS\ninstance=mat4(a_normal_matrix0,a_normal_matrix1,a_normal_matrix2,a_normal_matrix3);\n#else\ninstance=u_instance;\n#endif\nvec3 pos_color=instance[0].xyz;vec4 translate=instance[1];vec3 pos_a=floor(pos_color);float hidden=float(pos_a.x > EXTENT);float meter_to_tile=instance[0].w;vec4 pos=vec4(pos_a.xy,translate.z,1.0);mat3 rs;rs[0].x=instance[1].w;rs[0].yz=instance[2].xy;rs[1].xy=instance[2].zw;rs[1].z=instance[3].x;rs[2].xyz=instance[3].yzw;vec4 pos_node=u_node_matrix*vec4(a_pos_3f,1.0);vec3 rotated_pos_node=rs*pos_node.xyz;vec3 pos_model_tile=(rotated_pos_node+vec3(translate.xy,0.0))*vec3(meter_to_tile,meter_to_tile,1.0);pos.xyz+=pos_model_tile;gl_Position=mix(u_matrix*pos,AWAY,hidden);\n#else\ngl_Position=u_matrix*vec4(a_pos_3f,1);\n#endif\n}"),
            fillExtrusionDepth: WE("void main() {}", '#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_material_table.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_edge_radius;uniform float u_width_scale;uniform float u_vertical_scale;\n#ifdef TERRAIN\nuniform int u_height_type;uniform int u_base_type;\n#endif\nin ivec4 a_pos_normal_ed;\n#if defined(HAS_CENTROID) || defined(TERRAIN)\nin uvec2 a_centroid_pos;\n#endif\n#ifdef RENDER_WALL_MODE\nin ivec4 a_join_normal_inside;\n#endif\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp float line_width\n#pragma mapbox: define highp vec4 color\nvoid main() {DECLARE_MATERIAL_TABLE_INFO\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp float line_width\n#pragma mapbox: initialize highp vec4 color\nbase*=u_vertical_scale;height*=u_vertical_scale;vec3 top_up_ny=vec3(a_pos_normal_ed.xyz & 1);vec3 pos_nx=vec3(a_pos_normal_ed.xyz >> 1);base=max(0.0,base);height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=vec2(a_centroid_pos);\n#endif\nvec3 pos;\n#ifdef TERRAIN\nbool is_flat_height=centroid_pos.x !=0.0 && u_height_type==1;bool is_flat_base=centroid_pos.x !=0.0 && u_base_type==1;float ele=elevation(pos_nx.xy);bool is_elevation_encoded=centroid_pos.y==0.0 || (centroid_pos.y > 0.0 && int(centroid_pos.y)-(int(centroid_pos.y)/8)*8==7);float c_ele=is_flat_height || is_flat_base ? (is_elevation_encoded ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos)) : ele;float h_height=is_flat_height ? max(c_ele+height,ele+base+2.0) : ele+height;float h_base=is_flat_base ? max(c_ele+base,ele+base) : ele+(base==0.0 ?-5.0 : base);float h=t > 0.0 ? max(h_base,h_height) : h_base;pos=vec3(pos_nx.xy,h);\n#else\npos=vec3(pos_nx.xy,t > 0.0 ? height : base);\n#endif\n#ifdef RENDER_WALL_MODE\nvec3 join_normal_inside=vec3(a_join_normal_inside);vec2 wall_offset=u_width_scale*line_width*(join_normal_inside.xy/EXTENT);pos.xy+=(1.0-join_normal_inside.z)*wall_offset*0.5;pos.xy-=join_normal_inside.z*wall_offset*0.5;\n#endif\nfloat hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (color.a==0.0));gl_Position=mix(u_matrix*vec4(pos,1),AWAY,hidden);}'),
            fillExtrusionGroundEffect: WE("uniform highp float u_ao_pass;uniform highp float u_opacity;uniform highp float u_flood_light_intensity;uniform highp vec3 u_flood_light_color;uniform highp float u_attenuation;uniform sampler2D u_fb;uniform float u_fb_size;\n#ifdef SDF_SUBPASS\nin highp vec2 v_pos;in highp vec4 v_line_segment;in highp float v_flood_light_radius_tile;in highp vec2 v_ao;float line_df(highp vec2 a,highp vec2 b,highp vec2 p) {highp vec2 ba=b-a;highp vec2 pa=p-a;highp float r=clamp(dot(pa,ba)/dot(ba,ba),0.0,1.0);return length(pa-r*ba);}\n#ifdef FOG\nin highp float v_fog;\n#endif\n#endif\nvoid main() {\n#ifdef CLEAR_SUBPASS\nvec4 color=vec4(1.0);\n#ifdef CLEAR_FROM_TEXTURE\ncolor=texture(u_fb,gl_FragCoord.xy/vec2(u_fb_size));\n#endif\nglFragColor=color;\n#else\n#ifdef SDF_SUBPASS\nhighp float d=line_df(v_line_segment.xy,v_line_segment.zw,v_pos);highp float effect_radius=mix(v_flood_light_radius_tile,v_ao.y,u_ao_pass);d/=effect_radius;d=min(d,1.0);d=1.0-pow(1.0-d,u_attenuation);highp float effect_intensity=mix(u_flood_light_intensity,v_ao.x,u_ao_pass);highp float fog=1.0;\n#ifdef FOG\nfog=v_fog;\n#endif\n#ifdef RENDER_CUTOFF\nfog*=v_cutoff_opacity;\n#endif\nglFragColor=vec4(vec3(0.0),mix(1.0,d,effect_intensity*u_opacity*fog));\n#else\n#ifdef USE_MRT1\nout_Target1=vec4(1.0-texture(u_fb,gl_FragCoord.xy/vec2(u_fb_size)).a,0.0,0.0,0.0);\n#else\nvec4 color=mix(vec4(u_flood_light_color,1.0),vec4(vec3(0.0),1.0),u_ao_pass);\n#ifdef OVERDRAW_INSPECTOR\ncolor=vec4(1.0);\n#endif\nglFragColor=color;\n#endif\n#endif\nHANDLE_WIREFRAME_DEBUG;\n#endif\n}", '#include "_prelude_fog.vertex.glsl"\nin highp ivec4 a_pos_end;in highp int a_angular_offset_factor;in highp uint a_hidden_by_landmark;\n#ifdef SDF_SUBPASS\nout highp vec2 v_pos;out highp vec4 v_line_segment;out highp float v_flood_light_radius_tile;out highp vec2 v_ao;\n#ifdef FOG\nout highp float v_fog;\n#endif\n#endif\nuniform highp float u_flood_light_intensity;uniform highp mat4 u_matrix;uniform highp float u_ao_pass;uniform highp float u_meter_to_tile;uniform highp float u_edge_radius;uniform highp float u_dynamic_offset;uniform highp vec2 u_ao;\n#pragma mapbox: define highp float flood_light_ground_radius\nconst float TANGENT_CUTOFF=4.0;const float NORM=32767.0;void main() {\n#pragma mapbox: initialize highp float flood_light_ground_radius\nvec4 pos_end=vec4(a_pos_end);vec2 p=pos_end.xy;vec2 q=floor(pos_end.zw*0.5);vec2 start_bottom=pos_end.zw-q*2.0;float fl_ground_radius=abs(flood_light_ground_radius);float direction=flood_light_ground_radius < 0.0 ?-1.0 : 1.0;float flood_radius_tile=fl_ground_radius*u_meter_to_tile;vec2 v=normalize(q-p);float ao_radius=u_ao.y/3.5;float effect_radius=mix(flood_radius_tile,ao_radius,u_ao_pass)+u_edge_radius;float angular_offset_factor=float(a_angular_offset_factor)/NORM*TANGENT_CUTOFF;float angular_offset=direction*angular_offset_factor*effect_radius;float top=1.0-start_bottom.y;float side=(0.5-start_bottom.x)*2.0;vec2 extrusion_parallel=v*side*mix(u_dynamic_offset,angular_offset,top);vec2 perp=vec2(v.y,-v.x);vec2 extrusion_perp=direction*perp*effect_radius*top;vec3 pos=vec3(mix(q,p,start_bottom.x),0.0);pos.xy+=extrusion_parallel+extrusion_perp;\n#ifdef SDF_SUBPASS\nv_pos=pos.xy;v_line_segment=vec4(p,q)+perp.xyxy*u_edge_radius;v_flood_light_radius_tile=flood_radius_tile;v_ao=vec2(u_ao.x,ao_radius);\n#ifdef FOG\nv_fog_pos=fog_position(pos);v_fog=1.0-fog(v_fog_pos);\n#endif\n#endif\nfloat hidden_by_landmark=0.0;\n#ifdef HAS_CENTROID\nhidden_by_landmark=float(a_hidden_by_landmark);\n#endif\nfloat isFloodlit=float(fl_ground_radius > 0.0 && u_flood_light_intensity > 0.0);float hidden=mix(1.0-isFloodlit,isFloodlit,u_ao_pass);hidden+=hidden_by_landmark;gl_Position=mix(u_matrix*vec4(pos,1.0),AWAY,float(hidden > 0.0));\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,native_clip_z_to_cutoff_depth(gl_Position.z,gl_Position.w));\n#endif\n}'),
            groundShadow: WE('#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_indicator_cutout.fragment.glsl"\n#include "_prelude_feature_cutout.fragment.glsl"\nprecision highp float;uniform vec3 u_ground_shadow_factor;in vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;\n#ifdef FOG\nin float v_fog_opacity;\n#endif\nvoid main() {float light=shadowed_light_factor_plane_bias(v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);vec3 shadow=mix(u_ground_shadow_factor,vec3(1.0),light);\n#ifdef RENDER_CUTOFF\nshadow=mix(vec3(1.0),shadow,cutoff_opacity(u_cutoff_params,1.0/gl_FragCoord.w));\n#endif\n#ifdef FOG\nshadow=mix(shadow,vec3(1.0),v_fog_opacity);\n#endif\nglFragColor=vec4(shadow,1.0);}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;in ivec2 a_pos;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;\n#ifdef FOG\nout float v_fog_opacity;\n#endif\nvoid main() {gl_Position=u_matrix*vec4(a_pos,0.0,1.0);v_pos_light_view_0=u_light_matrix_0*vec4(a_pos,0.0,1.0);v_pos_light_view_1=u_light_matrix_1*vec4(a_pos,0.0,1.0);\n#ifdef FOG\nv_fog_pos=fog_position(vec2(a_pos));v_fog_opacity=fog(v_fog_pos);\n#endif\n}')
        };
        const XE = (e1, t1)=>({
                u_matrix: e1,
                u_ground_shadow_factor: t1
            });
        function YE(e1, t1, i = 0) {
            const n = Math.pow(2, t1.tileID.overscaledZ), r = t1.tileSize * Math.pow(2, e1.transform.tileZoom) / n, o = r * (t1.tileID.canonical.x + t1.tileID.wrap * n), a = r * t1.tileID.canonical.y;
            return {
                u_image: 0,
                u_texsize: t1.imageAtlasTexture ? t1.imageAtlasTexture.size : [
                    0,
                    0
                ],
                u_tile_units_to_pixels: 1 / Xb(t1, 1, e1.transform.tileZoom),
                u_pixel_coord_upper: [
                    o >> 16,
                    a >> 16
                ],
                u_pixel_coord_lower: [
                    65535 & o,
                    65535 & a
                ],
                u_pattern_transition: i
            };
        }
        const JE = {
            terrain: 0,
            flat: 1
        }, KE = c(), QE = [
            0,
            0,
            0
        ], eI = (e1, t1, i, n, r, o, s, c, u, h, d, f, p, _, m, g, y, x, v = [
            0,
            0,
            1
        ], b = !1)=>{
            let w = QE, A = 0, E = QE;
            if (!b) {
                const e1 = t1.style.light, i = e1.properties.get("position");
                if (w = [
                    i.x,
                    i.y,
                    i.z
                ], "viewport" === e1.properties.get("anchor")) {
                    const e1 = a();
                    l(e1, -t1.transform.angle), Y(w, w, e1);
                }
                const n = e1.properties.get("color").toPremultipliedRenderColor(null);
                A = e1.properties.get("intensity"), E = [
                    n.r,
                    n.g,
                    n.b
                ];
            }
            const I = t1.transform, M = {
                u_matrix: e1,
                u_lightpos: w,
                u_lightintensity: A,
                u_lightcolor: E,
                u_vertical_gradient: +i,
                u_opacity: n,
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_inv_rot_matrix: KE,
                u_merc_center: [
                    0,
                    0
                ],
                u_up_dir: [
                    0,
                    0,
                    0
                ],
                u_height_lift: 0,
                u_height_type: JE[h],
                u_base_type: JE[d],
                u_ao: r,
                u_edge_radius: o,
                u_width_scale: s,
                u_flood_light_color: m,
                u_vertical_scale: g,
                u_flood_light_intensity: y,
                u_ground_shadow_factor: x,
                u_front_cutoff_params: v
            };
            return "globe" === I.projection.name && (M.u_tile_id = [
                c.canonical.x,
                c.canonical.y,
                1 << c.canonical.z
            ], M.u_zoom_transition = f, M.u_inv_rot_matrix = _, M.u_merc_center = p, M.u_up_dir = I.projection.upVector(new gp(0, 0, 0), p[0] * Sr, p[1] * Sr), M.u_height_lift = u), M;
        }, tI = new Float32Array(16);
        function iI(e1, t1, i, n, r, o, a, s, l, c, u, h, d, f, p, _, g, y, x, v, b) {
            const w = t1.context, A = w.gl, E = t1.transform, I = t1.transform.zoom, M = [], S = e1.translate, T = e1.translateAnchor, z = e1.edgeRadius, R = FA(t1, e1.cutoffFadeRange);
            "clear" === u ? (M.push("CLEAR_SUBPASS"), v && (M.push("CLEAR_FROM_TEXTURE"), w.activeTexture.set(A.TEXTURE0), v.bind(A.LINEAR, A.CLAMP_TO_EDGE))) : "sdf" === u ? M.push("SDF_SUBPASS") : "emissive" === u && (M.push("USE_MRT1"), w.activeTexture.set(A.TEXTURE0), v.bind(A.LINEAR, A.CLAMP_TO_EDGE)), y && M.push("HAS_CENTROID"), R.shouldRenderCutoff && M.push("RENDER_CUTOFF");
            const P = (e1, i, r, u, m)=>{
                let x = M;
                null != i.groundRadiusBuffer && (x = M.concat("HAS_ATTRIBUTE_a_flood_light_ground_radius"));
                const b = i.programConfigurations.get(n.id), A = t1.isTileAffectedByFog(e1), E = t1.getOrCreateProgram("fillExtrusionGroundEffect", {
                    config: b,
                    defines: x,
                    overrideFog: A
                }), S = ((e1, t1, i, n, r, o, a, s, l, c)=>({
                        u_matrix: e1,
                        u_opacity: t1,
                        u_ao_pass: i ? 1 : 0,
                        u_meter_to_tile: n,
                        u_ao: r,
                        u_flood_light_intensity: o,
                        u_flood_light_color: a,
                        u_attenuation: s,
                        u_edge_radius: l,
                        u_fb: 0,
                        u_fb_size: c,
                        u_dynamic_offset: 1
                    }))(u, h, c, m, [
                    d,
                    f * m
                ], p, _, g, I >= 17 ? 0 : z * m, v ? v.size[0] : 0), T = [];
                y && T.push(i.hiddenByLandmarkVertexBuffer), null != i.groundRadiusBuffer && T.push(i.groundRadiusBuffer), t1.uploadCommonUniforms(w, E, e1.toUnwrapped(), null, R), E.draw(t1, w.gl.TRIANGLES, o, a, s, l, S, n.id, i.vertexBuffer, i.indexBuffer, r, n.paint, I, b, T);
            };
            for (const e1 of r){
                const r = i.getTile(e1), o = r.getBucket(n);
                if (!o || o.projection.name !== E.projection.name || !o.groundEffect || o.groundEffect && !o.groundEffect.hasData()) continue;
                const a = o.groundEffect, s = 1 / o.tileToMeter;
                {
                    const i = t1.translatePosMatrix(e1.projMatrix, r, S, T), n = a.getDefaultSegment();
                    P(e1, a, n, i, s);
                }
                if (x) for(let o = 0; o < 4; o++){
                    const a = bp[o](e1), l = i.getTile(a);
                    if (!l) continue;
                    const c = l.getBucket(n);
                    if (!c || c.projection.name !== E.projection.name || !c.groundEffect || c.groundEffect && !c.groundEffect.hasData()) continue;
                    const u = c.groundEffect;
                    let h, d;
                    0 === o ? (h = [
                        -8192,
                        0,
                        0
                    ], d = 1) : 1 === o ? (h = [
                        Sr,
                        0,
                        0
                    ], d = 0) : 2 === o ? (h = [
                        0,
                        -8192,
                        0
                    ], d = 3) : (h = [
                        0,
                        Sr,
                        0
                    ], d = 2);
                    const f = u.regionSegments[d];
                    f && (m(tI, e1.projMatrix, h), P(e1, u, f, t1.translatePosMatrix(tI, r, S, T), s));
                }
            }
        }
        const nI = {
            model: (e1)=>({
                    u_matrix: new Ku(e1),
                    u_lighting_matrix: new Ku(e1),
                    u_normal_matrix: new Ku(e1),
                    u_node_matrix: new Ku(e1),
                    u_lightpos: new qu(e1),
                    u_lightintensity: new Zu(e1),
                    u_lightcolor: new qu(e1),
                    u_camera_pos: new qu(e1),
                    u_opacity: new Zu(e1),
                    u_baseColorFactor: new Yu(e1),
                    u_emissiveFactor: new Yu(e1),
                    u_metallicFactor: new Zu(e1),
                    u_roughnessFactor: new Zu(e1),
                    u_alphaMask: new $u(e1),
                    u_alphaCutoff: new Zu(e1),
                    u_baseColorTexture: new $u(e1),
                    u_metallicRoughnessTexture: new $u(e1),
                    u_normalTexture: new $u(e1),
                    u_occlusionTexture: new $u(e1),
                    u_emissionTexture: new $u(e1),
                    u_lutTexture: new $u(e1),
                    u_color_mix: new Yu(e1),
                    u_aoIntensity: new Zu(e1),
                    u_emissive_strength: new Zu(e1),
                    u_occlusionTextureTransform: new Yu(e1),
                    u_dithered_discard_threshold: new Zu(e1),
                    u_model_mesh_params: new Yu(e1)
                }),
            modelDepth: (e1)=>({
                    u_matrix: new Ku(e1),
                    u_instance: new Ku(e1),
                    u_node_matrix: new Ku(e1)
                }),
            groundShadow: (e1)=>({
                    u_matrix: new Ku(e1),
                    u_ground_shadow_factor: new qu(e1)
                }),
            fillExtrusionDepth: (e1)=>({
                    u_matrix: new Ku(e1),
                    u_edge_radius: new Zu(e1),
                    u_width_scale: new Zu(e1),
                    u_vertical_scale: new Zu(e1),
                    u_height_type: new $u(e1),
                    u_base_type: new $u(e1)
                }),
            fillExtrusionGroundEffect: (e1)=>({
                    u_matrix: new Ku(e1),
                    u_opacity: new Zu(e1),
                    u_ao_pass: new Zu(e1),
                    u_meter_to_tile: new Zu(e1),
                    u_ao: new Wu(e1),
                    u_flood_light_intensity: new Zu(e1),
                    u_flood_light_color: new qu(e1),
                    u_attenuation: new Zu(e1),
                    u_edge_radius: new Zu(e1),
                    u_fb: new $u(e1),
                    u_fb_size: new Zu(e1),
                    u_dynamic_offset: new Zu(e1)
                })
        };
        function rI(e1) {
            const t1 = e1.properties.get("direction"), i = yt(t1.x, t1.y, t1.z);
            i[2] = tt(i[2], 0, 75);
            const n = gt([
                i[0],
                i[1],
                i[2]
            ]);
            return D(n.x, n.y, n.z);
        }
        function oI(e1, t1, i) {
            const n = "none" === t1.properties.get("color-use-theme"), r = t1.properties.get("color"), o = t1.properties.get("intensity"), a = t1.properties.get("direction"), s = [
                a.x,
                a.y,
                a.z
            ], l = "none" === i.properties.get("color-use-theme"), c = i.properties.get("color"), u = i.properties.get("intensity"), h = Math.max(Z([
                0,
                0,
                1
            ], s), 0), d = [
                0,
                0,
                0
            ];
            N(d, c.toPremultipliedRenderColor(l ? null : e1.getLut(t1.scope)).toArray01Linear().slice(0, 3), u);
            const f = [
                0,
                0,
                0
            ];
            return N(f, r.toPremultipliedRenderColor(n ? null : e1.getLut(i.scope)).toArray01Linear().slice(0, 3), h * o), It([
                d[0] > 0 ? d[0] / (d[0] + f[0]) : 0,
                d[1] > 0 ? d[1] / (d[1] + f[1]) : 0,
                d[2] > 0 ? d[2] / (d[2] + f[2]) : 0
            ]);
        }
        const aI = [];
        function sI(e1) {
            return aI[e1] = aI[e1] || new Float64Array(16);
        }
        const lI = [], cI = new Float32Array(16);
        class uI {
            constructor(e1, t1){
                this.aabb = e1, this.lastCascade = t1;
            }
        }
        class hI {
            add(e1, t1) {
                const i = this.receivers[e1.key];
                void 0 !== i ? (i.aabb.min[0] = Math.min(i.aabb.min[0], t1.min[0]), i.aabb.min[1] = Math.min(i.aabb.min[1], t1.min[1]), i.aabb.min[2] = Math.min(i.aabb.min[2], t1.min[2]), i.aabb.max[0] = Math.max(i.aabb.max[0], t1.max[0]), i.aabb.max[1] = Math.max(i.aabb.max[1], t1.max[1]), i.aabb.max[2] = Math.max(i.aabb.max[2], t1.max[2])) : this.receivers[e1.key] = new uI(t1, null);
            }
            clear() {
                this.receivers = {};
            }
            get(e1) {
                return this.receivers[e1.key];
            }
            computeRequiredCascades(e1, t1, i) {
                const n = Nf.fromPoints(e1.points);
                let r = 0;
                for(const e1 in this.receivers){
                    const o = this.receivers[e1];
                    if (!o) continue;
                    if (!n.intersectsAabb(o.aabb)) continue;
                    o.aabb.min = n.closestPoint(o.aabb.min), o.aabb.max = n.closestPoint(o.aabb.max);
                    const a = o.aabb.getCorners();
                    for(let e1 = 0; e1 < i.length; e1++){
                        let n = !0;
                        for (const r of a){
                            const o = [
                                r[0] * t1,
                                r[1] * t1,
                                r[2]
                            ];
                            if (X(o, o, i[e1].matrix), o[0] < -1 || o[0] > 1 || o[1] < -1 || o[1] > 1) {
                                n = !1;
                                break;
                            }
                        }
                        if (o.lastCascade = e1, r = Math.max(r, e1), n) break;
                    }
                }
                return r + 1;
            }
        }
        function dI(e1, t1, i) {
            const n = W([], ee([], i, t1), ee([], e1, t1)), r = P(n);
            return 0 === r ? [
                0,
                0,
                1,
                0
            ] : (N(n, n, 1 / r), [
                n[0],
                n[1],
                n[2],
                -Z(n, t1)
            ]);
        }
        function fI(e1, t1, i, n, r, o) {
            const a = e1.zoom, s = e1.scale, l = e1.worldSize, c = 1 / l, u = e1.aspect, h = Math.sqrt(1 + u * u) * Math.tan(.5 * e1.fovX), f = h * h, g = n - i, y = n + i;
            let x, v;
            f > g / y ? (x = n, v = n * h) : (x = .5 * y * (1 + f), v = .5 * Math.sqrt(g * g + 2 * (n * n + i * i) * f + y * y * f * f));
            const b = e1.projection.pixelsPerMeter(e1.center.lat, l), w = [
                0,
                0,
                -x * c
            ];
            X(w, w, e1._camera.getCameraToWorldMercator());
            let A = v * c;
            const E = function(t1) {
                return t1[0] /= s, t1[1] /= s, t1[2] = cc(t1[2], e1._center.lat), t1;
            }, I = e1._edgeInsets;
            if (!(0 === I.left && 0 === I.top && 0 === I.right && 0 === I.bottom || I.left === I.right && I.top === I.bottom)) {
                const t1 = e1._camera.getWorldToCamera(e1.worldSize, "meters" === e1.projection.zAxisUnit ? b : 1), r = e1._camera.getCameraToClipPerspective(e1._fov, e1.width / e1.height, i, n);
                r[8] = 2 * -e1.centerOffset.x / e1.width, r[9] = 2 * e1.centerOffset.y / e1.height;
                const o = new Float64Array(16);
                z(o, r, t1);
                const s = new Float64Array(16);
                p(s, o);
                const c = Vf.fromInvProjectionMatrix(s, l, a, !0);
                for (const e1 of c.points){
                    const t1 = E(e1);
                    A = Math.max(A, ie(O([], w, t1)));
                }
            }
            A *= r / (r - 1);
            const M = Math.acos(t1[2]), S = Math.atan2(-t1[0], -t1[1]), T = new gA;
            T.position = w, T.setPitchBearing(M, S);
            const R = T.getWorldToCamera(l, b), P = A * l, F = Math.min(e1._mercatorZfromZoom(17) * l * -2, -2 * P), C = T.getCameraToClipOrthographic(-P, P, -P, P, F, (P + o * b) / t1[2]), L = new Float64Array(16);
            _(L, C, R);
            const B = .5 * r, V = [
                0,
                0,
                0
            ];
            X(V, D(Math.floor(1e6 * w[0]) / 1e6 * l, Math.floor(1e6 * w[1]) / 1e6 * l, 0), L), N(V, V, B);
            const k = [
                Math.floor(V[0]),
                Math.floor(V[1]),
                Math.floor(V[2])
            ], U = [
                0,
                0,
                0
            ];
            ee(U, V, k), N(U, U, -1 / B);
            const j = new Float64Array(16);
            return d(j), m(j, j, U), _(L, j, L), [
                L,
                P
            ];
        }
        class pI extends an {
            constructor(e1, t1, i, n){
                super(), this.id = e1, this.type = "model", this.models = [], this._options = t1, this._modelsInfo = new Map, this._abortController = null;
            }
            cancelModelRequests() {
                this._abortController && (this._abortController.abort(), this._abortController = null);
            }
            async loadGLTFFromURI(e1, t1) {
                return Zy(await this.map._requestManager.transformRequest(e1, oi.Model, t1), t1);
            }
            async loadModel(e1, t1, i) {
                try {
                    const n = await this.loadGLTFFromURI(t1.uri, i);
                    if (i.aborted) return;
                    const r = this._modelsInfo.get(e1);
                    if (!r) return;
                    const o = kx(n), a = r.modelSpec, s = new yx(e1, a.uri, a.position, a.orientation, o);
                    pI.applyModelSpecification(s, a), s.computeBoundsAndApplyParent(), this.models.push(s), r.model = s;
                } catch (n) {
                    if (i.aborted) return;
                    this.fire(new nn(new Error(`Could not load model ${e1} from ${t1.uri}`, {
                        cause: n
                    })));
                }
            }
            async load() {
                this._abortController || (this._abortController = new AbortController);
                const e1 = this._abortController.signal, t1 = [];
                for(const i in this._options.models){
                    const n = this._options.models[i], r = this._modelsInfo.get(i);
                    if (r && r.model) {
                        r.modelSpec = n;
                        const e1 = r.model;
                        e1.position = null != n.position ? new ac(n.position[0], n.position[1]) : new ac(0, 0), e1.orientation = n.orientation ?? [
                            0,
                            0,
                            0
                        ], pI.applyModelSpecification(e1, n), e1.computeBoundsAndApplyParent(), this.models.push(e1);
                    } else r ? r.modelSpec = n : (this._modelsInfo.set(i, {
                        modelSpec: n,
                        model: null
                    }), t1.push(this.loadModel(i, n, e1)));
                }
                0 !== t1.length ? (await Promise.allSettled(t1), e1.aborted || this.fire(new tn("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                }))) : this.loaded() && this.fire(new tn("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                }));
            }
            static arrayFromColorSpecification(e1) {
                const t1 = e1;
                if (void 0 === t1) return;
                if (Array.isArray(t1)) return [
                    t1[0],
                    t1[1],
                    t1[2]
                ];
                const i = fn.parse(t1);
                return i ? [
                    i.r,
                    i.g,
                    i.b
                ] : void 0;
            }
            static applyModelSpecification(e1, t1) {
                if (t1.nodeOverrides && pI.convertNodeOverrides(e1, t1.nodeOverrides), t1.materialOverrides && pI.convertMaterialOverrides(e1, t1.materialOverrides), t1.nodeOverrideNames && (e1.nodeOverrideNames = [
                    ...t1.nodeOverrideNames
                ]), t1.materialOverrideNames && (e1.materialOverrideNames = [
                    ...t1.materialOverrideNames
                ]), t1.featureProperties && (e1.featureProperties = t1.featureProperties), t1.lightOverrides) {
                    const i = t1.lightOverrides, n = pI.arrayFromColorSpecification(i["light-ambient-color"]), r = pI.arrayFromColorSpecification(i["light-directional-color"]);
                    e1.lightOverrides = {
                        ambientIntensity: i["light-ambient-intensity"],
                        ambientColor: n,
                        directionalIntensity: i["light-directional-intensity"],
                        directionalColor: r
                    };
                } else e1.lightOverrides = void 0;
            }
            static convertNodeOverrides(e1, t1) {
                if (Array.isArray(t1) && t1.every((e1)=>"string" == typeof e1)) {
                    e1.nodeOverrideNames = [];
                    for (const i of t1)e1.nodeOverrideNames.push(i);
                } else Object.entries(t1).forEach(([t1, i])=>{
                    const n = {
                        orientation: [
                            0,
                            0,
                            0
                        ],
                        minZoom: void 0,
                        maxZoom: void 0
                    };
                    if (Object.hasOwn(i, "orientation")) {
                        const e1 = i.orientation;
                        e1 && (n.orientation = e1);
                    }
                    Object.hasOwn(i, "minzoom") && (n.minZoom = i.minzoom), Object.hasOwn(i, "maxzoom") && (n.maxZoom = i.maxzoom), e1.nodeOverrides.set(t1, n);
                });
            }
            static convertMaterialOverrides(e1, t1) {
                if (Array.isArray(t1) && t1.every((e1)=>"string" == typeof e1)) {
                    e1.materialOverrideNames = [];
                    for (const i of t1)e1.materialOverrideNames.push(i);
                } else Object.entries(t1).forEach(([t1, i])=>{
                    const n = pI.arrayFromColorSpecification(i["model-color"]), r = {
                        color: void 0 !== n ? new fn(n[0], n[1], n[2]) : new fn(1, 1, 1),
                        colorMix: 0,
                        emissionStrength: 0,
                        opacity: 1
                    }, o = i["model-color-mix-intensity"];
                    void 0 !== o && (r.colorMix = o);
                    const a = i["model-emissive-strength"];
                    void 0 !== a && (r.emissionStrength = a);
                    const s = i["model-opacity"];
                    void 0 !== s && (r.opacity = s), e1.materialOverrides.set(t1, r);
                });
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            hasTransition() {
                return !1;
            }
            loaded() {
                if (0 === this._modelsInfo.size) return !0;
                for (const e1 of this._modelsInfo.values())if (null == e1.model) return !1;
                return !0;
            }
            getModels() {
                return this.models;
            }
            loadTile(e1, t1) {}
            serialize() {
                return this._options;
            }
            setProperty(e1, t1) {
                return !1;
            }
            reload() {
                this.cancelModelRequests();
                const e1 = ul(this.id, this.scope);
                this.map.style.clearSource(e1), this.models = [], this._modelsInfo.clear(), this.load();
            }
            onRemove(e1) {
                this.cancelModelRequests();
            }
            setModels(e1) {
                this.models = [];
                const t1 = new Map;
                for(const i in e1){
                    const n = e1[i], r = this._modelsInfo.get(i);
                    r && r.modelSpec.uri === n.uri && t1.set(i, r);
                }
                if (this._modelsInfo.size !== t1.size) {
                    this.cancelModelRequests();
                    for (const [e1, i] of t1)i.model || t1.delete(e1);
                }
                this._modelsInfo = t1, this._options.models = e1, this.load();
            }
        }
        function _I(e1, t1, i) {
            try {
                t1 = function(e1) {
                    if (!e1.variants) return e1;
                    if (!Array.isArray(e1.variants)) throw new Error("variants must be an array");
                    let t1 = null, i = null;
                    for (const n of e1.variants){
                        if (null == n || "object" != typeof n || n.constructor !== Object) throw new Error("variant must be an object");
                        if (!Array.isArray(n.capabilities)) throw new Error("capabilities must be an array");
                        1 === n.capabilities.length && ("meshopt-v2+lod" === n.capabilities[0] ? i = n : "meshopt" === n.capabilities[0] && (t1 = n));
                    }
                    const n = null !== i ? i : t1;
                    return null !== n ? Object.assign(e1, n) : e1;
                }(t1);
            } catch (e1) {
                return new Error("Failed to process TileJSON variants", {
                    cause: e1
                });
            }
            const n = rt({
                ...t1,
                ...e1
            }, [
                "tilejson",
                "tiles",
                "minzoom",
                "maxzoom",
                "attribution",
                "mapbox_logo",
                "bounds",
                "extra_bounds",
                "scheme",
                "tileSize",
                "encoding",
                "vector_layers",
                "raster_layers",
                "worldview_options",
                "worldview_default",
                "worldview"
            ]);
            return e1.url && t1.tiles && e1.tiles && (n.tiles = t1.tiles), n.tiles = i.canonicalizeTileset(n, e1.url), n;
        }
        function mI(e1, t1, i, n, r) {
            const o = function(i, n) {
                if (i) return r(i);
                if (n) {
                    e1.url && n.tiles && e1.tiles && delete e1.tiles;
                    const i = _I(e1, n, t1);
                    if (i instanceof Error) return r(i);
                    r(null, i);
                }
            }, a = function(e1, t1, i) {
                if (!e1) return null;
                if (!t1 && !i) return e1;
                i = i || e1.worldview_default;
                const n = Object.values(e1.language || {});
                if (0 === n.length) return null;
                const r = Object.values(e1.worldview || {});
                if (0 === r.length) return null;
                const o = n.every((e1)=>e1 === t1), a = r.every((e1)=>e1 === i);
                return o && a ? e1 : null;
            }(e1.data, i, n);
            if (a) return Vt.frame(()=>o(null, a));
            if (e1.url) {
                const r = new AbortController;
                return (async ()=>{
                    const a = await t1.transformRequest(t1.normalizeSourceURL(e1.url, null, i, n), oi.Source, r.signal), { data: s } = await fi(a, r.signal);
                    o(null, s);
                })().catch((e1)=>{
                    r.signal.aborted || o(e1);
                }), {
                    cancel: ()=>r.abort()
                };
            }
            return Vt.frame(()=>{
                const { data: t1, ...i } = e1;
                o(null, i);
            });
        }
        function gI(e1, t1) {
            const i = Math.pow(2, t1.z), n = Math.floor(ur(e1.getWest()) * i), r = Math.floor(hr(e1.getNorth()) * i), o = Math.ceil(ur(e1.getEast()) * i), a = Math.ceil(hr(e1.getSouth()) * i);
            return t1.x >= n && t1.x < o && t1.y >= r && t1.y < a;
        }
        class yI {
            constructor(e1){
                this.bounds = e1.bounds ? sc.convert(this.validateBounds(e1.bounds)) : null, this.extraBounds = e1.extra_bounds && e1.extra_bounds.length > 0 ? e1.extra_bounds.map((e1)=>sc.convert(this.validateBounds(e1))) : null, this.minzoom = e1.minzoom || 0, this.maxzoom = e1.maxzoom || 24;
            }
            validateBounds(e1) {
                return Array.isArray(e1) && 4 === e1.length ? [
                    Math.max(-180, e1[0]),
                    Math.max(-90, e1[1]),
                    Math.min(180, e1[2]),
                    Math.min(90, e1[3])
                ] : [
                    -180,
                    -90,
                    180,
                    90
                ];
            }
            contains(e1) {
                if (e1.z > this.maxzoom || e1.z < this.minzoom) return !1;
                if (this.bounds && !gI(this.bounds, e1)) return !1;
                if (!this.extraBounds) return !0;
                for (const t1 of this.extraBounds)if (gI(t1, e1)) return !0;
                return !1;
            }
        }
        const xI = {
            loaded: !0,
            drawModels: function(e1, t1, i, n) {
                if ("opaque" === e1.renderPass) return;
                const r = i.paint.get("model-opacity").constantOr(1), o = i.paint.get("model-elevation-reference"), a = "ground" === o, s = "ground" === o;
                if (0 === r) return;
                const l = i.paint.get("model-cast-shadows");
                if ("shadow" === e1.renderPass) {
                    if (!l) return;
                    if (e1.terrain && r < .65 && i.getPaintPropertyValue("model-opacity").expression instanceof Ha) return;
                }
                const u = e1.shadowRenderer, h = i.paint.get("model-receive-shadows");
                u && (u.useNormalOffset = !0, h || (u.enabled = !1));
                const d = ()=>{
                    u && (u.useNormalOffset = !0, h || (u.enabled = !0));
                }, m = t1.getSource();
                if ("light-beam" === e1.renderPass && "batched-model" !== m.type) return;
                if ("vector" === m.type || "geojson" === m.type) return function(e1, t1, i, n, r) {
                    const o = e1.transform, a = "globe" === o.projection.name, s = o.getFreeCameraOptions().position;
                    if (!e1.modelManager) return;
                    const l = e1.modelManager;
                    i.modelManager = l;
                    const u = e1.shadowRenderer, h = i.getLayoutPropertyValue("model-id");
                    if (void 0 === h.value) return;
                    const d = {
                        ...i.layout.get("model-id").parameters
                    }, f = e1.style.order.indexOf(i.fqid), p = i.paint.get("model-opacity").constantOr(1), _ = eA(e1, i);
                    for (const m of n){
                        const n = t1.getTile(m).getBucket(i);
                        if (!n || n.projection.name !== o.projection.name) continue;
                        const g = n.getModelUris();
                        if (g && !n.modelsRequested && (l.addModelsFromBucket(g, r), n.modelsRequested = !0), a) d.zoom = m.overscaledZ;
                        else {
                            const e1 = fE(m, o, s);
                            d.zoom = e1;
                        }
                        const y = h.possiblyEvaluate(d);
                        if (hE(e1, n, m), dE.shadowUniformsInitialized = !1, dE.useSingleShadowCascade = !!u && 0 === u.getMaxCascadeForTile(m.toUnwrapped()), "shadow" === e1.renderPass && u) {
                            if (1 === e1.currentShadowCascade && n.isInsideFirstShadowMapFrustum) continue;
                            const t1 = o.calculatePosMatrix(m.toUnwrapped());
                            if (dE.tileMatrix.set(t1), dE.shadowTileMatrix.set(u.calculateShadowPassMatrixFromMatrix(t1)), dE.aabb.min = [
                                0,
                                0,
                                0
                            ], dE.aabb.max[0] = dE.aabb.max[1] = Sr, dE.aabb.max[2] = 0, mE(n, dE, e1, i.scope)) continue;
                        }
                        const x = 1 << m.canonical.z, v = [
                            ((s.x - m.wrap) * x - m.canonical.x) * Sr,
                            (s.y * x - m.canonical.y) * Sr,
                            s.z * x * Sr
                        ];
                        e1.conflationActive && Object.keys(n.instancesPerModel).length > 0 && e1.style.isLayerClipped(i, t1.getSource()) && n.updateReplacement(m, e1.replacementSource, f, i.scope) && (n.uploaded = !1, n.upload(e1.context));
                        let A = 0;
                        const M = new Array, S = new Array, T = new Array;
                        for(let t1 in n.instancesPerModel){
                            const o = n.instancesPerModel[t1];
                            o.features.length > 0 && !a && (t1 = y.evaluate(o.features[0].feature, {}));
                            const u = l.getModel(t1, r);
                            if (u || l.hasURLBeenRequested(t1) || n.modelUris.includes(t1) || (n.modelUris.push(t1), n.modelsRequested = !1), u && u.uploaded) {
                                if (a) {
                                    const t1 = N([], [
                                        s.x,
                                        s.y,
                                        s.z
                                    ], e1.transform.worldSize);
                                    H(t1, t1);
                                    for(let i = 0; i < o.instancedDataArray.length; ++i){
                                        const r = [
                                            0,
                                            0,
                                            0
                                        ], a = [
                                            1,
                                            1,
                                            1
                                        ], s = le(), l = o.tileCoordinatesForInstance(i), h = o.transformForInstance(i);
                                        E(a, h), I(s, h), ue(r, s);
                                        const d = o.translationForInstance(i), f = new ac(0, 0);
                                        CA(n.canonical, f, l.x, l.y);
                                        const _ = c();
                                        gx(_, u, e1.transform, f, r, a, d, !0, !1, !1);
                                        const m = o.colorForInstance(i), g = b([], t1), y = w([], [
                                            1,
                                            1,
                                            1 / fc(f.lat, e1.transform.zoom)
                                        ]);
                                        T.push({
                                            zScaleMatrix: y,
                                            negCameraPosMatrix: g
                                        });
                                        for (const t1 of u.nodes)oE(e1, t1, _, e1.transform.expandedFarZProjMatrix, A, M, S, u.materialOverrides, p, m);
                                        ++A;
                                    }
                                } else for (const t1 of u.nodes)pE(e1, i, _, t1, o, v, m, dE);
                            }
                        }
                        if (a) {
                            if ("shadow" === e1.renderPass) {
                                for (const t1 of S)aE(t1.mesh, t1.nodeModelMatrix, e1, i);
                                for (const t1 of M)aE(t1.mesh, t1.nodeModelMatrix, e1, i);
                            } else uE(e1, i, M, S, T);
                        }
                    }
                }(e1, t1, i, n, rE(e1, i)), void d();
                if (!m.loaded()) return;
                if ("batched-model" === m.type) return function(e1, t1, i, n) {
                    i.resetLayerRenderingStats(e1);
                    const r = e1.context, o = e1.transform, a = e1.style.fog, s = e1.shadowRenderer;
                    if ("mercator" !== o.projection.name) return void _t(`Drawing 3D landmark models for ${o.projection.name} projection is not yet implemented`);
                    const l = e1.transform.getFreeCameraOptions().position, c = N([], [
                        l.x,
                        l.y,
                        l.z
                    ], e1.transform.worldSize), u = H([], c), h = b(new Float64Array(16), u), d = fc(o.center.lat, o.zoom), m = 1 / d, y = w(new Float64Array(16), [
                        1,
                        1,
                        m
                    ]), x = _(new Float64Array(16), h, y), v = i.paint.get("model-opacity").constantOr(1), A = eA(e1, i), E = "shadow" === e1.renderPass, I = a && !E ? KA(o) : null, M = new lA(r.gl.LEQUAL, lA.ReadWrite, e1.depthRangeFor3D), S = new lA(r.gl.LEQUAL, lA.ReadOnly, e1.depthRangeFor3D), T = new Nf([
                        1 / 0,
                        1 / 0,
                        1 / 0
                    ], [
                        -1 / 0,
                        -1 / 0,
                        -1 / 0
                    ]), z = "light-beam" === e1.renderPass, P = "none" === i.paint.get("model-color-use-theme").constantOr("default"), D = E && s ? s.getCurrentCascadeFrustum() : o.getFrustum(o.scaleZoom(o.worldSize)), C = i.paint.get("model-front-cutoff"), O = C[2] < 1, L = FA(e1, i.paint.get("model-cutoff-fade-range")), B = i.getLayerRenderingStats();
                    (function(e1, t1, i, n) {
                        const r = e1.terrain ? e1.terrain.exaggeration() : 0, o = e1.transform.zoom;
                        for (const a of n){
                            const n = t1.getTile(a).getBucket(i);
                            n && (n.setFilter(i.filter), e1.conflationActive && n.updateReplacement(a, e1.replacementSource), n.evaluateTransform(e1, i), e1.terrain && r > 0 && n.elevationUpdate(e1.terrain, r, a, i.source), n.needsReEvaluation(e1, o, i) && n.evaluate(i));
                        }
                    })(e1, t1, i, n), function() {
                        const l = new Map;
                        let u, h, m;
                        O ? (u = n.length - 1, h = -1, m = -1) : (u = 0, h = n.length, m = 1);
                        const y = R(), b = new Re(0, 0);
                        for(let w = u; w !== h; w += m){
                            const u = n[w], h = t1.getTile(u).getBucket(i);
                            if (!h || !h.uploaded) continue;
                            let m = !1;
                            s && (m = 0 === s.getMaxCascadeForTile(u.toUnwrapped()));
                            const R = o.calculatePosMatrix(u.toUnwrapped()), V = !!(4 & h.modelTraits);
                            _(NA, o.expandedFarZProjMatrix, R), _(kA, x, R), p(kA, kA), f(kA, kA);
                            const N = !E && s && s.enabled ? s.computeCascadeTileMatrices(R) : null;
                            !E && O && (p(BA, R), X(y, c, BA), b.x = y[0], b.y = y[1]);
                            const k = 1 / _c(u.canonical), j = [];
                            h.setFilter(i.filter);
                            for (const t1 of h.getNodesInfo()){
                                if (t1.hiddenByReplacement) continue;
                                if (!t1.node.meshes) continue;
                                const i = t1.node;
                                let n = 0;
                                e1.terrain && i.elevation && (n = i.elevation * e1.terrain.exaggeration());
                                const r = t1.aabb, a = T.min, s = T.max;
                                a[0] = r.min[0], a[1] = r.min[1], a[2] = r.min[2] + n, s[0] = r.max[0], s[1] = r.max[1], s[2] = r.max[2] + n, X(a, a, R), X(s, s, R);
                                const l = t1.evaluatedScale;
                                if (l[0] <= 1 && l[1] <= 1 && l[2] <= 1 && 0 === T.intersects(D)) continue;
                                if (!E) {
                                    ZA[0] = .5 * (a[0] + s[0]), ZA[1] = .5 * (a[1] + s[1]), ZA[2] = .5 * (a[2] + s[2]);
                                    const i = U(c, ZA) * d, n = e1._debugParams.lodSwitchDistance, r = n >= 0;
                                    if (r && n >= 9999) t1.targetLod = 0;
                                    else {
                                        let o;
                                        if (r) o = n;
                                        else {
                                            const e1 = (s[2] - a[2]) * d * l[2], t1 = Math.max(s[0] - a[0], s[1] - a[1]) * d * Math.max(l[0], l[1]);
                                            let i;
                                            i = e1 >= 30 ? 1 : t1 >= 80 ? .5 : Math.max(e1, t1) >= 20 ? .25 : 0, o = 2e3 + 3e3 * i;
                                        }
                                        _E(t1, i, Math.min(e1.frameTimeDelta, 1e3 / 30), o, e1._debugParams.lodSwitchFadeDuration);
                                    }
                                }
                                if (!E && O) {
                                    const e1 = 1 / 6;
                                    t1.cameraCollisionOpacity = c[0] > a[0] && c[0] < s[0] && c[1] > a[1] && c[1] < s[1] && c[2] * d < s[2] && i.footprint && u_(b, i.footprint) ? Math.max(t1.cameraCollisionOpacity - e1, 0) : Math.min(1, t1.cameraCollisionOpacity + e1);
                                }
                                const u = i.anchor ? i.anchor[0] : 0, h = i.anchor ? i.anchor[1] : 0, f = [
                                    u * (l[0] - 1) + t1.evaluatedTranslation[0] * k,
                                    h * (l[1] - 1) + t1.evaluatedTranslation[1] * k,
                                    n + t1.evaluatedTranslation[2]
                                ], p = QA(qA, R, f, l);
                                X(GA, F(GA, u, h, n), i.globalMatrix), X(GA, GA, p);
                                const _ = o.expandedFarZProjMatrix, m = _[2] * GA[0] + _[6] * GA[1] + _[10] * GA[2] + _[14];
                                i.hidden = !1;
                                let g = v;
                                E || (O && (g *= t1.cameraCollisionOpacity, g *= yE(p, o, t1.aabb, C)), g *= gE(L, m)), 0 !== g ? j.push({
                                    nodeInfo: t1,
                                    depth: m,
                                    opacity: g,
                                    tileTranslation: f
                                }) : i.hidden = !0;
                            }
                            E || j.sort((e1, t1)=>!O || 1 === e1.opacity && 1 === t1.opacity ? e1.depth < t1.depth ? -1 : 1 : 1 === e1.opacity ? -1 : 1 === t1.opacity ? 1 : e1.depth > t1.depth ? -1 : 1);
                            for (const t1 of j){
                                const { nodeInfo: n, tileTranslation: c, opacity: u } = t1, { node: h, evaluatedScale: d } = n;
                                let f = null;
                                if (e1._debugParams.show3DModelFootprints && h.footprint) {
                                    const e1 = h.id || h.name || "footprint";
                                    if (!l.has(e1)) {
                                        const t1 = QA(new Float64Array(16), NA, c, d);
                                        l.set(e1, {
                                            node: h,
                                            mvp: t1
                                        });
                                    }
                                }
                                const p = V ? 0 : n.emissiveStrength, y = n.targetLod, v = h.lodMeshes && h.lodMeshes.length > 0, b = v && y > 0 && y < 1;
                                if (E && v && 1 === Math.round(y)) continue;
                                const w = QA(qA, R, c, d);
                                _(w, w, h.globalMatrix);
                                const T = I ? _(VA, I, w) : null, D = E && s ? s.calculateShadowPassMatrixFromMatrix(w) : null;
                                E || (_(jA, o.expandedFarZProjMatrix, w), _(LA, x, w), HA[0] = 1 / d[0], HA[1] = -1 / d[1], HA[2] = 1 / d[2], g(BA, kA, HA));
                                const F = b ? 2 : 1, C = v && 1 === Math.round(y);
                                for(let t1 = 0; t1 < F; ++t1){
                                    const l = b ? 1 === t1 : C, _ = l ? h.lodMeshes : h.meshes, g = b ? l ? -y : 1 - y : 1;
                                    for(let t1 = 0; t1 < _.length; ++t1){
                                        const y = _[t1], x = !l && t1 === h.lightMeshIndex;
                                        let v = jA;
                                        if (x) {
                                            if (!z && !e1.terrain && e1.shadowRenderer) {
                                                e1.currentLayer < e1.firstLightBeamLayer && (e1.firstLightBeamLayer = e1.currentLayer);
                                                continue;
                                            }
                                            v = QA(UA, NA, c, d);
                                        } else if (z) continue;
                                        if (E) {
                                            B && (B.numRenderedVerticesInShadowPass += y.vertexArray.length), aE(y, w, e1, i, D);
                                            continue;
                                        }
                                        B && (B.numRenderedVerticesInTransparentPass += y.vertexArray.length);
                                        const I = {
                                            defines: []
                                        }, R = [], F = !!y.normalBuffer;
                                        s && (s.useNormalOffset = F);
                                        const C = tE(n, y);
                                        if (iE(I.defines, R, y, e1, P ? null : i.lut, C), V || I.defines.push("DIFFUSE_SHADED"), m && I.defines.push("SHADOWS_SINGLE_CASCADE"), a && "globe" !== o.projection.name) {
                                            const e1 = y.aabb.min, t1 = y.aabb.max, [i, n] = a.getOpacityForBounds(T, e1[0], e1[1], t1[0], t1[1]);
                                            I.overrideFog = i >= __ || n >= __;
                                        }
                                        const O = y.material;
                                        let L;
                                        O.occlusionTexture && O.occlusionTexture.offsetScale && (L = O.occlusionTexture.offsetScale, I.defines.push("OCCLUSION_TEXTURE_TRANSFORM")), b && I.defines.push("DITHERED_DISCARD");
                                        const k = e1.getOrCreateProgram("model", I);
                                        if (s && s.enabled) {
                                            if (f !== F) {
                                                for(let e1 = 0; e1 < N.length; e1++)QA(JA[e1] = JA[e1] || new Float64Array(16), N[e1], c, d);
                                                s.setupShadowsFromCascadeMatrices(JA, k, F), f = F;
                                            } else k.setShadowUniformValues(r, s.getShadowUniformValues());
                                        }
                                        e1.uploadCommonUniforms(r, k, null, T);
                                        const U = O.pbrMetallicRoughness;
                                        U.metallicFactor = .9, U.roughnessFactor = .5;
                                        const j = tA(v, LA, BA, h.globalMatrix, A, u, O, p, YA, L, void 0, void 0, g);
                                        j.u_model_mesh_params = eE(y, h, x, l), C && C.bind(r, k.program), !x && (n.hasTranslucentParts || u < 1) && k.draw(e1, r.gl.TRIANGLES, M, rA.disabled, sA.disabled, hA.backCCW, j, i.id, y.vertexBuffer, y.indexBuffer, y.segments, i.paint, e1.transform.zoom, void 0, R), k.draw(e1, r.gl.TRIANGLES, x ? S : M, rA.disabled, x || u < 1 || n.hasTranslucentParts ? sA.alphaBlended : sA.unblended, hA.backCCW, j, i.id, y.vertexBuffer, y.indexBuffer, y.segments, i.paint, e1.transform.zoom, void 0, R);
                                    }
                                }
                            }
                        }
                        if (e1._debugParams.show3DModelFootprints && l.size > 0) {
                            const t1 = Array.from(l.keys()).sort();
                            for (const i of t1){
                                const { node: t1, mvp: n } = l.get(i);
                                sE(e1, 0, t1, n);
                            }
                        }
                    }();
                }(e1, t1, i, n), void d();
                if ("model" !== m.type) return;
                const y = m.getModels(), x = [], v = e1.transform.getFreeCameraOptions().position, A = N([], [
                    v.x,
                    v.y,
                    v.z
                ], e1.transform.worldSize);
                H(A, A);
                const M = [], S = [];
                let T = 0;
                for (const n of y){
                    const r = t1.getFeatureState("", n.id), o = {
                        type: "Unknown",
                        id: n.id,
                        properties: n.featureProperties
                    }, l = i.paint.get("model-rotation").evaluate(o, r), c = i.paint.get("model-scale").evaluate(o, r), u = i.paint.get("model-translation").evaluate(o, r), h = i.paint.get("model-opacity").evaluate(o, r);
                    lE(i, n.id, r, n.featureProperties, n.nodeOverrideNames, n.nodeOverrides), cE(i, n.id, r, n.featureProperties, n.materialOverrideNames, n.materialOverrides), n.nodeOverrides.size > 0 && n.computeBoundsAndApplyParent(), n.computeModelMatrix(e1, l, c, u, s, a, !1);
                    const d = b([], A), f = w([], [
                        1,
                        1,
                        1 / fc(n.position.lat, e1.transform.zoom)
                    ]);
                    x.push({
                        zScaleMatrix: f,
                        negCameraPosMatrix: d
                    });
                    for (const t1 of n.nodes)oE(e1, t1, n.matrix, e1.transform.expandedFarZProjMatrix, T, M, S, n.materialOverrides, h, void 0, n.lightOverrides);
                    T++;
                }
                if (M.sort((e1, t1)=>t1.depth - e1.depth), "shadow" !== e1.renderPass) {
                    if (e1._debugParams.show3DModelFootprints) {
                        const t1 = e1.transform.projMatrix, i = new Map, n = (e1, n)=>{
                            if (e1.footprint) {
                                const r = e1.id || e1.name || "footprint";
                                if (!i.has(r)) {
                                    const o = _([], t1, n);
                                    i.set(r, {
                                        node: e1,
                                        mvp: o
                                    });
                                }
                            }
                        };
                        for (const e1 of S)n(e1.node, e1.modelMatrix);
                        for (const e1 of M)n(e1.node, e1.modelMatrix);
                        const r = Array.from(i.keys()).sort();
                        for (const t1 of r){
                            const { node: n, mvp: r } = i.get(t1);
                            sE(e1, 0, n, r);
                        }
                    }
                    uE(e1, i, M, S, x), d();
                } else {
                    for (const t1 of S)aE(t1.mesh, t1.nodeModelMatrix, e1, i);
                    for (const t1 of M)aE(t1.mesh, t1.nodeModelMatrix, e1, i);
                    d();
                }
            },
            prepare: function(e1, t1, i) {
                const n = t1.getSource();
                if (!n.loaded()) return;
                if ("vector" === n.type || "geojson" === n.type) return void (i.modelManager && i.modelManager.upload(i, rE(i, e1)));
                if ("batched-model" === n.type) return;
                if ("model" !== n.type) return;
                const r = n.getModels();
                for (const e1 of r)e1.upload(i.context);
            },
            shaders: qE,
            programUniforms: nI,
            ShadowRenderer: class {
                constructor(e1){
                    this.painter = e1, this._enabled = !1, this._drawShadowAfterLayer = -1, this._numCascadesToRender = 0, this._cascades = [], this._groundShadowTiles = [], this._receivers = new hI, this._depthMode = new lA(e1.context.gl.LEQUAL, lA.ReadWrite, [
                        0,
                        1
                    ]), this._uniformValues = {
                        u_light_matrix_0: new Float32Array(16),
                        u_light_matrix_1: new Float32Array(16),
                        u_shadow_intensity: 0,
                        u_fade_range: [
                            0,
                            0
                        ],
                        u_shadow_normal_offset: [
                            1,
                            1,
                            1
                        ],
                        u_shadow_texel_size: 1,
                        u_shadow_map_resolution: 1,
                        u_shadow_direction: [
                            0,
                            0,
                            1
                        ],
                        u_shadow_bias: [
                            36e-5,
                            .0012,
                            .012
                        ],
                        u_shadowmap_0: 0,
                        u_shadowmap_1: 0
                    }, this._forceDisable = !1, this._devtoolsFolder = null, this.useNormalOffset = !1, this._shadowParameters = {
                        cascadeCount: 2,
                        normalOffset: 3,
                        shadowMapResolution: 2048
                    };
                }
                destroy() {
                    for (const e1 of this._cascades)e1.texture.destroy(), e1.framebuffer.destroy();
                    this._cascades = [];
                }
                _hasCasterGeometry(e1, t1) {
                    const i = this.painter.style.getLayerSourceCache(e1);
                    if (!i) return !1;
                    const n = i.getSource();
                    if ("model" === n.type) return n.getModels().length > 0;
                    const r = t1[i.id];
                    if (!r) return !1;
                    for (const t1 of r){
                        const n = i.getTile(t1);
                        if (n && n.getBucket(e1)) return !0;
                    }
                    return !1;
                }
                updateShadowParameters(e1, t1, i) {
                    const n = this.painter;
                    if (this._enabled = !1, this._drawShadowAfterLayer = -1, this._receivers.clear(), !t1 || !t1.properties) return;
                    const r = t1.properties.get("shadow-intensity"), o = t1.properties.get("shadow-draw-before-layer");
                    if (!t1.shadowsEnabled() || r <= 0) return;
                    let a = -1, s = 0;
                    for (const t1 of n.style.order){
                        const r = n.style._mergedLayers[t1];
                        r.hasShadowPass() && !r.isHidden(e1.zoom) && this._hasCasterGeometry(r, i) && (a = s), !o || o !== t1 && o !== r.slot || (this._drawShadowAfterLayer = s > 0 ? s - 1 : 0), s += 1;
                    }
                    if (this._enabled = a >= 0, !this.enabled) return;
                    this._drawShadowAfterLayer < 0 && (this._drawShadowAfterLayer = a);
                    const l = n.context, c = this._shadowParameters.shadowMapResolution, u = this._shadowParameters.shadowMapResolution;
                    if (0 === this._cascades.length || this._shadowParameters.shadowMapResolution !== this._cascades[0].texture.size[0]) {
                        this._cascades = [];
                        for(let e1 = 0; e1 < this._shadowParameters.cascadeCount; ++e1){
                            const e1 = l.gl, t1 = l.createFramebuffer(c, u, 0, "texture"), i = new X_(l, {
                                width: c,
                                height: u,
                                data: null
                            }, e1.DEPTH_COMPONENT16);
                            t1.depthAttachment.set(i.texture), this._cascades.push({
                                framebuffer: t1,
                                texture: i,
                                matrix: [],
                                far: 0,
                                boundingSphereRadius: 0,
                                frustum: new Vf,
                                scale: 0
                            });
                        }
                    }
                    this.shadowDirection = rI(t1);
                    let h = 0;
                    if (e1.elevation) {
                        const t1 = e1.elevation, i = [
                            1e4,
                            -10000
                        ];
                        t1.visibleDemTiles.filter((e1)=>e1.dem).forEach((e1)=>{
                            const t1 = e1.dem.tree;
                            i[0] = Math.min(i[0], t1.minimums[0]), i[1] = Math.max(i[1], t1.maximums[0]);
                        }), 1e4 !== i[0] && (h = (i[1] - i[0]) * t1.exaggeration());
                    }
                    const d = 1.5 * e1.cameraToCenterDistance, f = 3 * d, _ = new Float64Array(16);
                    for(let t1 = 0; t1 < this._cascades.length; ++t1){
                        const i = this._cascades[t1];
                        let n = e1.height / 50, r = 1;
                        1 === this._shadowParameters.cascadeCount ? r = f : 0 === t1 ? r = d : (n = d, r = f);
                        const [o, a] = fI(e1, this.shadowDirection, n, r, this._shadowParameters.shadowMapResolution, h);
                        i.scale = e1.scale, i.matrix = o, i.boundingSphereRadius = a, p(_, i.matrix), i.frustum = Vf.fromInvProjectionMatrix(_, 1, 0, !0), i.far = r;
                    }
                    const m = this._cascades.length - 1;
                    this._uniformValues.u_fade_range = [
                        .75 * this._cascades[m].far,
                        this._cascades[m].far
                    ], this._uniformValues.u_shadow_intensity = r, this._uniformValues.u_shadow_direction = [
                        this.shadowDirection[0],
                        this.shadowDirection[1],
                        this.shadowDirection[2]
                    ], this._uniformValues.u_shadow_texel_size = 1 / this._shadowParameters.shadowMapResolution, this._uniformValues.u_shadow_map_resolution = this._shadowParameters.shadowMapResolution, this._uniformValues.u_shadowmap_0 = Jw.ShadowMap0, this._uniformValues.u_shadowmap_1 = Jw.ShadowMap0 + 1, this._groundShadowTiles = n.transform.coveringTiles({
                        tileSize: 512,
                        renderWorldCopies: !0
                    });
                    const g = n.transform.elevation;
                    for (const e1 of this._groundShadowTiles){
                        let t1 = {
                            min: 0,
                            max: 0
                        };
                        if (g) {
                            const i = g.getMinMaxForTile(e1);
                            i && (t1 = i);
                        }
                        this.addShadowReceiver(e1.toUnwrapped(), t1.min, t1.max);
                    }
                }
                get enabled() {
                    return this._enabled && !this._forceDisable;
                }
                set enabled(e1) {
                    this._enabled = e1;
                }
                drawShadowPass(e1, t1) {
                    if (!this.enabled) return;
                    const i = this.painter, n = i.context;
                    this._numCascadesToRender = this._receivers.computeRequiredCascades(i.transform.getFrustum(0), i.transform.worldSize, this._cascades), n.viewport.set([
                        0,
                        0,
                        this._shadowParameters.shadowMapResolution,
                        this._shadowParameters.shadowMapResolution
                    ]);
                    for(let r = 0; r < this._numCascadesToRender; ++r){
                        i.currentShadowCascade = r, n.bindFramebuffer.set(this._cascades[r].framebuffer.framebuffer), n.clear({
                            color: fn.white,
                            depth: 1
                        });
                        for (const n of e1.order){
                            const r = e1._mergedLayers[n];
                            if (!r.hasShadowPass() || r.isHidden(i.transform.zoom)) continue;
                            const o = e1.getLayerSourceCache(r), a = o ? t1[o.id] : void 0;
                            ("model" === r.type || a && a.length) && i.renderLayer(i, o, r, a);
                        }
                    }
                    i.currentShadowCascade = 0;
                }
                drawGroundShadows() {
                    if (!this.enabled) return;
                    const e1 = this.painter, t1 = e1.style, i = e1.context, n = i.gl, r = t1.directionalLight, o = t1.ambientLight;
                    if (!r || !o) return;
                    const a = [], s = FA(e1, e1.longestCutoffRange);
                    s.shouldRenderCutoff && a.push("RENDER_CUTOFF"), a.push("RENDER_SHADOWS"), this.useNormalOffset && a.push("NORMAL_OFFSET");
                    const l = oI(t1, r, o), c = new lA(n.LEQUAL, lA.ReadOnly, e1.depthRangeFor3D), u = new rA({
                        func: n.EQUAL,
                        mask: 255
                    }, 0, 255, n.KEEP, n.KEEP, n.KEEP);
                    for (const t1 of this._groundShadowTiles){
                        const r = t1.toUnwrapped(), o = e1.isTileAffectedByFog(t1), h = e1.getOrCreateProgram("groundShadow", {
                            defines: a,
                            overrideFog: o
                        });
                        this.setupShadows(r, h), e1.uploadCommonUniforms(i, h, r, null, s);
                        const d = XE(e1.transform.calculateProjMatrix(r), l);
                        h.draw(e1, n.TRIANGLES, c, u, sA.multiply, hA.disabled, d, "ground_shadow", e1.tileExtentBuffer, e1.quadTriangleIndexBuffer, e1.tileExtentSegments, null, e1.transform.zoom, null, null);
                    }
                }
                getShadowPassDepthMode() {
                    return this._depthMode;
                }
                getGroundShadowLayerIndex() {
                    return this._drawShadowAfterLayer;
                }
                calculateShadowPassMatrixFromTile(e1) {
                    const t1 = this.painter.transform, i = this._cascades[this.painter.currentShadowCascade].matrix;
                    return _(new Float32Array(16), i, t1.calculatePosMatrix(e1));
                }
                calculateShadowPassMatrixFromMatrix(e1) {
                    return _(cI, this._cascades[this.painter.currentShadowCascade].matrix, e1);
                }
                setupShadows(e1, t1, i) {
                    if (!this.enabled) return;
                    const n = this.painter.transform, r = this.painter.context, o = r.gl, a = this._uniformValues, s = n.calculatePosMatrix(e1);
                    for(let e1 = 0; e1 < this._cascades.length; e1++){
                        const t1 = sI(e1);
                        _(t1, this._cascades[e1].matrix, s), a[0 === e1 ? "u_light_matrix_0" : "u_light_matrix_1"] = t1, r.activeTexture.set(o.TEXTURE0 + Jw.ShadowMap0 + e1), this._cascades[e1].texture.bindExtraParam(o.LINEAR, o.LINEAR, o.CLAMP_TO_EDGE, o.CLAMP_TO_EDGE, o.GREATER);
                    }
                    if (this.useNormalOffset = !!i, this.useNormalOffset) {
                        const t1 = _c(e1.canonical), r = 2 / n.tileSize * Sr / this._shadowParameters.shadowMapResolution, o = r * this._cascades[0].boundingSphereRadius, s = r * this._cascades.at(-1).boundingSphereRadius, l = ("vector-tile" === i ? 1 : 3) * function(e1) {
                            const t1 = tt((e1 - 22) / -22, 0, 1);
                            return .125 * (1 - t1) + 4 * t1;
                        }(n.zoom);
                        a.u_shadow_normal_offset = [
                            t1,
                            o * l,
                            s * l
                        ], a.u_shadow_bias = [
                            1e-4,
                            .0012,
                            .012
                        ];
                    } else a.u_shadow_bias = [
                        36e-5,
                        .0012,
                        .012
                    ];
                    t1.setShadowUniformValues(r, a);
                }
                computeCascadeTileMatrices(e1) {
                    const t1 = this._shadowParameters.cascadeCount;
                    for(let i = 0; i < t1; i++)_(lI[i] = lI[i] || new Float64Array(16), this._cascades[i].matrix, e1);
                    return lI.length = t1, lI;
                }
                setupShadowsFromMatrix(e1, t1, i = !1) {
                    if (!this.enabled) return;
                    const n = this._shadowParameters.cascadeCount;
                    for(let t1 = 0; t1 < n; t1++)_(sI(t1), this._cascades[t1].matrix, e1);
                    aI.length = n, this.setupShadowsFromCascadeMatrices(aI, t1, i);
                }
                setupShadowsFromCascadeMatrices(e1, t1, i = !1) {
                    if (!this.enabled) return;
                    const n = this.painter.context, r = n.gl, o = this._uniformValues;
                    for(let t1 = 0; t1 < this._shadowParameters.cascadeCount; t1++)o[0 === t1 ? "u_light_matrix_0" : "u_light_matrix_1"] = e1[t1], n.activeTexture.set(r.TEXTURE0 + Jw.ShadowMap0 + t1), this._cascades[t1].texture.bindExtraParam(r.LINEAR, r.LINEAR, r.CLAMP_TO_EDGE, r.CLAMP_TO_EDGE, r.GREATER);
                    if (this.useNormalOffset = i, i) {
                        const e1 = this._shadowParameters.normalOffset;
                        o.u_shadow_normal_offset = [
                            1,
                            e1,
                            e1
                        ], o.u_shadow_bias = [
                            6e-5,
                            .0012,
                            .012
                        ];
                    } else o.u_shadow_bias = [
                        36e-5,
                        .0012,
                        .012
                    ];
                    t1.setShadowUniformValues(n, o);
                }
                getShadowUniformValues() {
                    return this._uniformValues;
                }
                getCurrentCascadeFrustum() {
                    return this._cascades[this.painter.currentShadowCascade].frustum;
                }
                computeSimplifiedTileShadowVolume(e1, t1, i, n) {
                    if (n[2] >= 0) return {};
                    const r = (function(e1, t1, i) {
                        const n = i / (1 << e1.canonical.z);
                        return new Nf([
                            e1.canonical.x * n + e1.wrap * i,
                            e1.canonical.y * n + e1.wrap * i,
                            0
                        ], [
                            (e1.canonical.x + 1) * n + e1.wrap * i,
                            (e1.canonical.y + 1) * n + e1.wrap * i,
                            t1
                        ]);
                    })(e1, t1, i).getCorners(), o = t1 / -n[2];
                    n[0] < 0 ? (C(r[0], r[0], [
                        n[0] * o,
                        0,
                        0
                    ]), C(r[3], r[3], [
                        n[0] * o,
                        0,
                        0
                    ])) : n[0] > 0 && (C(r[1], r[1], [
                        n[0] * o,
                        0,
                        0
                    ]), C(r[2], r[2], [
                        n[0] * o,
                        0,
                        0
                    ])), n[1] < 0 ? (C(r[0], r[0], [
                        0,
                        n[1] * o,
                        0
                    ]), C(r[1], r[1], [
                        0,
                        n[1] * o,
                        0
                    ])) : n[1] > 0 && (C(r[2], r[2], [
                        0,
                        n[1] * o,
                        0
                    ]), C(r[3], r[3], [
                        0,
                        n[1] * o,
                        0
                    ]));
                    const a = {};
                    return a.vertices = r, a.planes = [
                        dI(r[1], r[0], r[4]),
                        dI(r[2], r[1], r[5]),
                        dI(r[3], r[2], r[6]),
                        dI(r[0], r[3], r[7])
                    ], a;
                }
                addShadowReceiver(e1, t1, i) {
                    this._receivers.add(e1, Nf.fromTileIdAndHeight(e1, t1, i));
                }
                getMaxCascadeForTile(e1) {
                    const t1 = this._receivers.get(e1);
                    return t1 && t1.lastCascade ? t1.lastCascade : 0;
                }
            },
            drawGroundEffect: iI,
            queryModelLayerRendered: function(e1, t1, i, n) {
                const r = i.getSource();
                if (!r || "model" !== r.type) return {};
                const o = r, a = {};
                a[e1.id] = [];
                const s = a[e1.id];
                let l = 0;
                for (const r of o.models){
                    const o = i.getFeatureState(e1.sourceLayer, r.id), a = {
                        type: "Unknown",
                        id: r.id,
                        properties: r.featureProperties
                    }, c = e1.paint.get("model-rotation").evaluate(a, o), u = e1.paint.get("model-scale").evaluate(a, o), h = e1.paint.get("model-translation").evaluate(a, o), d = e1.paint.get("model-elevation-reference");
                    let f = [];
                    gx(f, r, n, r.position, c, u, h, "ground" === d, "ground" === d, !1), "globe" === n.projection.name && (f = dx(f, n));
                    const p = _([], n.projMatrix, f), m = fx(t1.isPointQuery() ? t1.screenBounds : t1.screenGeometry, n, p, r.aabb);
                    if (null != m) {
                        const t1 = new Yw(void 0, 0, 0, 0, r.id);
                        t1.layer = e1.layer, t1.properties = structuredClone(r.featureProperties), t1.properties.layer = e1.id, t1.properties.uri = r.uri, t1.properties.orientation = r.orientation, t1.sourceLayer = e1.sourceLayer, t1.geometry = {
                            type: "Point",
                            coordinates: [
                                r.position.lng,
                                r.position.lat
                            ]
                        }, t1.state = o, t1.source = e1.source, s.push({
                            featureIndex: l,
                            feature: t1,
                            intersectionZ: m
                        });
                    }
                    ++l;
                }
                return a;
            },
            queryModelLayerIntersectsFeature: function(e1, t1, i, n, r, o) {
                if (!e1.modelManager) return !1;
                const a = e1.modelManager, s = t1.tile.getBucket(e1);
                if (!(s && s instanceof Ow)) return !1;
                for(const n in s.instancesPerModel){
                    const l = s.instancesPerModel[n], c = void 0 !== i.id ? i.id : i.properties && Object.hasOwn(i.properties, "id") ? i.properties.id : void 0;
                    if (Object.hasOwn(l.idToFeaturesIndex, c)) {
                        const i = l.features[l.idToFeaturesIndex[c]], u = a.getModel(n, o || e1.scope);
                        if (!u) return !1;
                        let h = [];
                        const d = new ac(0, 0), f = s.canonical;
                        let p = Number.MAX_VALUE;
                        for(let e1 = 0; e1 < i.instancedDataCount; ++e1){
                            const n = 16 * (i.instancedDataOffset + e1), o = l.instancedDataArray.float32, a = [
                                o[n + 4],
                                o[n + 5],
                                o[n + 6]
                            ];
                            CA(f, d, Math.floor(o[n]), Math.floor(o[n + 1])), gx(h, u, r, d, i.rotation, i.scale, a, !1, !1, !1), "globe" === r.projection.name && (h = dx(h, r));
                            const s = _([], r.projMatrix, h), c = t1.queryGeometry, m = fx(c.isPointQuery() ? c.screenBounds : c.screenGeometry, r, s, u.aabb);
                            null != m && (p = Math.min(m, p));
                        }
                        return p !== Number.MAX_VALUE && p;
                    }
                }
                return !1;
            },
            loadMatchingModelFeature: function(e1, t1, i, n) {
                const r = e1.getNodesInfo()[t1];
                if (!r || r.hiddenByReplacement || !r.node.meshes) return;
                let o = Number.MAX_VALUE;
                const a = r.node, s = i.tile, l = n.calculatePosMatrix(s.tileID.toUnwrapped()), c = r.evaluatedScale;
                let u = 0;
                n.elevation && a.elevation && (u = a.elevation * n.elevation.exaggeration());
                const h = a.anchor ? a.anchor[0] : 0, d = a.anchor ? a.anchor[1] : 0, f = m(new Float64Array(16), l, [
                    h * (c[0] - 1),
                    d * (c[1] - 1),
                    u
                ]);
                g(f, f, c);
                const p = i.queryGeometry, y = p.isPointQuery() ? p.screenBounds : p.screenGeometry, x = function(e1) {
                    const t1 = _([], f, e1.globalMatrix);
                    _(t1, n.expandedFarZProjMatrix, t1);
                    for(let i = 0; i < e1.meshes.length; ++i){
                        const r = e1.meshes[i];
                        if (i === e1.lightMeshIndex) continue;
                        const a = fx(y, n, t1, r.aabb);
                        null != a && (o = Math.min(a, o));
                    }
                    if (e1.children) for (const t1 of e1.children)x(t1);
                };
                if (x(a), o === Number.MAX_VALUE) return;
                const v = new ac(0, 0);
                return CA(s.tileID.canonical, v, r.node.anchor[0], r.node.anchor[1]), {
                    intersectionZ: o,
                    position: v,
                    feature: r.feature
                };
            },
            ModelSource: pI,
            Tiled3dModelSource: class extends an {
                constructor(e1, t1, i, n){
                    super(), this.type = "batched-model", this.id = e1, this.tileSize = 512, this._options = t1, this.tiles = this._options.tiles, this.maxzoom = t1.maxzoom || 19, this.minzoom = t1.minzoom || 0, this.roundZoom = !0, this.usedInConflation = !0, this.dispatcher = i, this.reparseOverscaled = !1, this.scheme = "xyz", this._loaded = !1, this.setEventedParent(n);
                }
                onAdd(e1) {
                    this.map = e1, this.load();
                }
                reload() {
                    this.cancelTileJSONRequest();
                    const e1 = ul(this.id, this.scope);
                    this.load(()=>this.map.style.clearSource(e1));
                }
                cancelTileJSONRequest() {
                    this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
                }
                load(e1) {
                    this._loaded = !1, this.fire(new tn("dataloading", {
                        dataType: "source"
                    }));
                    const t1 = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language, i = this.map.getWorldview();
                    this._tileJSONRequest = mI(this._options, this.map._requestManager, t1, i, (n, r)=>{
                        this._tileJSONRequest = null, this._loaded = !0, n ? (t1 && console.warn(`Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ${t1}`), i && 2 !== i.length && console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${i}`), this.fire(new nn(n))) : r && (Object.assign(this, r), this.tileBounds = new yI(r), ki(r.tiles, this.map._requestManager._customAccessToken), this.fire(new tn("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        })), this.fire(new tn("data", {
                            dataType: "source",
                            sourceDataType: "content"
                        }))), e1 && e1(n);
                    });
                }
                hasTransition() {
                    return !1;
                }
                hasTile(e1) {
                    return !this.tileBounds || this.tileBounds.contains(e1.canonical);
                }
                loaded() {
                    return this._loaded;
                }
                async loadTile(e1, t1) {
                    const i = this.map._requestManager.normalizeTileURL(e1.tileID.canonical.url(this.tiles, this.scheme)), n = !e1.actor || "expired" === e1.state;
                    if (n) e1.actor = this.dispatcher.getActor();
                    else {
                        if ("loading" === e1.state) return void (e1.reloadCallback = t1);
                        if (e1.buckets) {
                            const t1 = Object.values(e1.buckets);
                            for (const e1 of t1)e1.dirty = !0;
                            return void (e1.state = "loaded");
                        }
                    }
                    const r = n ? "loadTile" : "reloadTile", o = new AbortController;
                    e1.request = o;
                    const a = (i, n)=>(delete e1.request, e1.aborted ? t1(null) : i && !si(i) ? t1(i) : (this.map._refreshExpiredTiles && n && e1.setExpiryData(bt(n.headers)), e1.loadModelData(n, this.map.painter), e1.state = "loaded", t1(null), void (e1.reloadCallback && (this.loadTile(e1, e1.reloadCallback), e1.reloadCallback = null))));
                    try {
                        const n = await this.map._requestManager.transformRequest(i, oi.Tile, o.signal);
                        if (o.signal.aborted) return t1(null);
                        const s = {
                            request: n,
                            data: void 0,
                            uid: e1.uid,
                            tileID: e1.tileID,
                            tileZoom: e1.tileZoom,
                            zoom: e1.tileID.overscaledZ,
                            tileSize: this.tileSize * e1.tileID.overscaleFactor(),
                            type: this.type,
                            source: this.id,
                            scope: this.scope,
                            showCollisionBoxes: this.map.showCollisionBoxes,
                            renderSourceType: e1.renderSourceType,
                            brightness: this.map.style && this.map.style.getBrightness() || 0,
                            pixelRatio: Vt.devicePixelRatio,
                            promoteId: this.promoteId
                        };
                        e1.request = e1.actor.sendCancelable(r, s, {}, a);
                    } catch (e1) {
                        if (o.signal.aborted) return t1(null);
                        t1(e1);
                    }
                }
                abortTile(e1) {
                    e1.request && (e1.request.abort(), delete e1.request), e1.actor && e1.actor.notify("abortTile", {
                        uid: e1.uid,
                        type: this.type,
                        source: this.id,
                        scope: this.scope
                    });
                }
                serialize() {
                    return {
                        ...this._options
                    };
                }
            },
            loadModel: async function(e1, t1, i) {
                const n = await Zy(e1), r = new yx(t1, i, void 0, void 0, kx(n));
                return r.computeBoundsAndApplyParent(), r;
            }
        };
        class vI {
            constructor(e1, t1){
                this.tileID = e1, this.x = e1.canonical.x, this.y = e1.canonical.y, this.z = e1.canonical.z, this.grid = new qa(Sr, Sr, 512), this.featureIndexArray = new Su, this.promoteId = t1, this.is3DTile = !1, this.serializedLayersCache = new Map;
            }
            insert(e1, t1, i, n, r, o = 0, a = 0) {
                const s = this.featureIndexArray.length;
                this.featureIndexArray.emplaceBack(i, n, r, o);
                const l = this.grid;
                for(let e1 = 0; e1 < t1.length; e1++){
                    const i = t1[e1], n = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ];
                    for(let e1 = 0; e1 < i.length; e1++){
                        const t1 = i[e1];
                        n[0] = Math.min(n[0], t1.x), n[1] = Math.min(n[1], t1.y), n[2] = Math.max(n[2], t1.x), n[3] = Math.max(n[3], t1.y);
                    }
                    0 !== a && (n[0] -= a, n[1] -= a, n[2] += a, n[3] += a), n[0] < Sr && n[1] < Sr && n[2] >= 0 && n[3] >= 0 && l.insert(s, n[0], n[1], n[2], n[3]);
                }
            }
            loadVTLayers() {
                if (!this.vtLayers) {
                    this.vtLayers = new Jh(new S_(this.rawTileData)).layers, this.sourceLayerCoder = new qw(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                        "_geojsonTileLayer"
                    ]), this.vtFeatures = {};
                    for(const e1 in this.vtLayers)this.vtFeatures[e1] = [];
                }
                return this.vtLayers;
            }
            query(e1, t1) {
                const { tilespaceGeometry: i, transform: n, tileTransform: r, pixelPosMatrix: o, availableImages: a, worldview: s } = t1;
                this.loadVTLayers(), this.serializedLayersCache.clear();
                const l = t1.queryRadius ? t1.queryRadius : 0, c = i.bufferedTilespaceBounds, u = this.grid.queryKeys(c.min.x, c.min.y, c.max.x, c.max.y, (e1, t1, n, r)=>ud(i.bufferedTilespaceGeometry, e1 - l, t1 - l, n + l, r + l));
                u.sort(wI);
                let h = null;
                n.elevation && u.length > 0 && (h = p_.create(n.elevation, this.tileID));
                const d = {};
                let f;
                for(let l = 0; l < u.length; l++){
                    const c = u[l];
                    if (c === f) continue;
                    f = c;
                    const p = this.featureIndexArray.get(c);
                    let _ = null;
                    this.is3DTile ? this.loadMatchingModelFeature(d, p, e1, i, n, s) : this.loadMatchingFeature(d, p, e1, a, s, (e1, a, s, l = 0)=>(_ || (_ = Ec(e1, this.tileID.canonical, r)), a.queryIntersectsFeature(i, e1, s, _, this.z, n, o, h, l, t1.scope)));
                }
                return d;
            }
            loadMatchingFeature(e1, t1, i, n, r, o) {
                const { featureIndex: a, bucketIndex: s, sourceLayerIndex: l, layoutVertexArrayOffset: c } = t1, u = this.bucketLayerIDs[s], h = i.layers, d = Object.keys(h);
                if (d.length && !ft(d, u)) return;
                const f = i.sourceCache, p = this.sourceLayerCoder.decode(l), _ = this.vtLayers[p].feature(a), m = this.getId(_, p);
                for(let t1 = 0; t1 < u.length; t1++){
                    const i = u[t1];
                    if (!h[i]) continue;
                    const { styleLayer: s, targets: l } = h[i];
                    let d = {};
                    void 0 !== m && (d = f.getFeatureState(s.sourceLayer, m));
                    const p = !o || o(_, s, d, c);
                    if (!p) continue;
                    const g = new Yw(_, this.z, this.x, this.y, m);
                    g.tile = this.tileID.canonical, g.state = d;
                    let y = this.serializedLayersCache.get(i);
                    y || (y = s.serialize(), y.id = i, this.serializedLayersCache.set(i, y)), g.source = y.source, g.sourceLayer = y["source-layer"], g.layer = {
                        ...y
                    }, g.layer.paint = bI(y.paint, s.paint, _, d, n), g.layer.layout = bI(y.layout, s.layout, _, d, n);
                    const x = new Ls(this.tileID.overscaledZ, {
                        worldview: r
                    });
                    let v = !1;
                    for (const e1 of l){
                        this.updateFeatureProperties(g, e1);
                        const { filter: t1 } = e1;
                        if (t1) {
                            if (_.properties = g.properties, t1.needGeometry) {
                                const e1 = Mc(_, !0);
                                if (!t1.filter(x, e1, this.tileID.canonical)) continue;
                            } else if (!t1.filter(x, _)) continue;
                        }
                        v = !0, e1.targetId && this.addFeatureVariant(g, e1);
                    }
                    v && this.appendToResult(e1, i, a, g, p);
                }
            }
            loadMatchingModelFeature(e1, t1, i, n, r, o) {
                const { featureIndex: a, bucketIndex: s } = t1, l = this.bucketLayerIDs[s], c = i.layers, u = Object.keys(c);
                if (!u.length || ft(u, l)) for(let t1 = 0; t1 < l.length; t1++){
                    const s = l[t1], { styleLayer: u, targets: h } = c[s];
                    if ("model" !== u.type) continue;
                    const d = n.tile, f = d.getBucket(u);
                    if (!f || !f.isTiled3dModelBucket) continue;
                    if (!xI.loadMatchingModelFeature) continue;
                    const p = xI.loadMatchingModelFeature(f, a, n, r);
                    if (!p) continue;
                    const { z: _, x: m, y: g } = d.tileID.canonical, { feature: y, intersectionZ: x, position: v } = p;
                    let b = {};
                    void 0 !== y.id && (b = i.sourceCache.getFeatureState(u.sourceLayer, y.id));
                    const w = new Yw({}, _, m, g, y.id);
                    w.tile = this.tileID.canonical, w.state = b, w.properties = y.properties, w.geometry = {
                        type: "Point",
                        coordinates: [
                            v.lng,
                            v.lat
                        ]
                    };
                    let A = this.serializedLayersCache.get(s);
                    A || (A = u.serialize(), A.id = s, this.serializedLayersCache.set(s, A)), w.source = A.source, w.sourceLayer = A["source-layer"], w.layer = {
                        ...A
                    };
                    const E = new Ls(this.tileID.overscaledZ, {
                        worldview: o
                    });
                    let I = !1;
                    for (const e1 of h){
                        this.updateFeatureProperties(w, e1);
                        const { filter: t1 } = e1;
                        if (t1) {
                            if (y.properties = w.properties, t1.needGeometry) {
                                if (!t1.filter(E, y, this.tileID.canonical)) continue;
                            } else if (!t1.filter(E, y)) continue;
                        }
                        I = !0, e1.targetId && this.addFeatureVariant(w, e1);
                    }
                    I && this.appendToResult(e1, s, a, w, x);
                }
            }
            updateFeatureProperties(e1, t1, i) {
                if (t1.properties) {
                    const n = {};
                    for(const r in t1.properties){
                        const o = t1.properties[r].evaluate({
                            zoom: this.z
                        }, e1._vectorTileFeature, e1.state, e1.tile, i);
                        null != o && (n[r] = o);
                    }
                    e1.properties = n;
                }
            }
            addFeatureVariant(e1, t1, i) {
                const n = {
                    target: t1.target,
                    namespace: t1.namespace,
                    uniqueFeatureID: t1.uniqueFeatureID
                };
                t1.properties && (n.properties = e1.properties), e1.variants = e1.variants || {}, e1.variants[t1.targetId] = e1.variants[t1.targetId] || [], e1.variants[t1.targetId].push(n);
            }
            appendToResult(e1, t1, i, n, r) {
                let o = e1[t1];
                void 0 === o && (o = e1[t1] = []), o.push({
                    featureIndex: i,
                    feature: n,
                    intersectionZ: r
                });
            }
            lookupSymbolFeatures(e1, t1, i, n, r, o) {
                const a = {};
                this.loadVTLayers();
                for (const s of e1)this.loadMatchingFeature(a, {
                    bucketIndex: t1,
                    sourceLayerIndex: i,
                    featureIndex: s,
                    layoutVertexArrayOffset: 0
                }, n, r, o);
                return a;
            }
            loadFeature(e1) {
                const { featureIndex: t1, sourceLayerIndex: i } = e1;
                this.loadVTLayers();
                const n = this.sourceLayerCoder.decode(i), r = this.vtFeatures[n];
                if (r[t1]) return r[t1];
                const o = this.vtLayers[n].feature(t1);
                return r[t1] = o, o;
            }
            hasLayer(e1) {
                for (const t1 of this.bucketLayerIDs)for (const i of t1)if (e1 === i) return !0;
                return !1;
            }
            getId(e1, t1) {
                let i = e1.id;
                if (this.promoteId) {
                    const n = Array.isArray(this.promoteId) || "object" != typeof this.promoteId ? this.promoteId : this.promoteId[t1];
                    if (null != n) {
                        if (Array.isArray(n)) {
                            if (!this.promoteIdExpression) {
                                const e1 = ja(n);
                                if ("success" !== e1.result) {
                                    const t1 = e1.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", ");
                                    return void _t(`Failed to create expression for promoteId: ${t1}`);
                                }
                                this.promoteIdExpression = e1.value;
                            }
                            i = this.promoteIdExpression.evaluate({
                                zoom: 0
                            }, e1);
                        } else i = e1.properties[n];
                    }
                    "boolean" == typeof i && (i = Number(i));
                }
                return i;
            }
        }
        function bI(e1, t1, i, n, r) {
            return ut(e1, (e1, o)=>{
                const a = t1 instanceof js ? t1.get(o) : null;
                return a && a.evaluate ? a.evaluate(i, n, void 0, r) : a;
            });
        }
        function wI(e1, t1) {
            return t1 - e1;
        }
        async function AI() {
            return Promise.resolve();
        }
        Ya(vI, "FeatureIndex", {
            omit: [
                "rawTileData",
                "sourceLayerCoder"
            ]
        });
        const EI = {
            circle: class extends vl {
                constructor(e1, t1, i, n){
                    super(e1, {
                        layout: nb || (nb = new Zs({
                            "circle-sort-key": new Hs(Ws.layout_circle["circle-sort-key"]),
                            "circle-elevation-reference": new Gs(Ws.layout_circle["circle-elevation-reference"]),
                            visibility: new Gs(Ws.layout_circle.visibility)
                        })),
                        paint: rb || (rb = new Zs({
                            "circle-radius": new Hs(Ws.paint_circle["circle-radius"]),
                            "circle-color": new Hs(Ws.paint_circle["circle-color"]),
                            "circle-blur": new Hs(Ws.paint_circle["circle-blur"]),
                            "circle-opacity": new Hs(Ws.paint_circle["circle-opacity"]),
                            "circle-translate": new Gs(Ws.paint_circle["circle-translate"]),
                            "circle-translate-anchor": new Gs(Ws.paint_circle["circle-translate-anchor"]),
                            "circle-pitch-scale": new Gs(Ws.paint_circle["circle-pitch-scale"]),
                            "circle-pitch-alignment": new Gs(Ws.paint_circle["circle-pitch-alignment"]),
                            "circle-stroke-width": new Hs(Ws.paint_circle["circle-stroke-width"]),
                            "circle-stroke-color": new Hs(Ws.paint_circle["circle-stroke-color"]),
                            "circle-stroke-opacity": new Hs(Ws.paint_circle["circle-stroke-opacity"]),
                            "circle-emissive-strength": new Gs(Ws.paint_circle["circle-emissive-strength"]),
                            "circle-color-use-theme": new Hs({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "circle-stroke-color-use-theme": new Hs({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, i, n);
                }
                createBucket(e1) {
                    return new Vd(e1);
                }
                queryRadius(e1) {
                    const t1 = e1.programConfigurations.get(this.id);
                    return _b("circle-radius", this, t1) + _b("circle-stroke-width", this, t1) + mb(this.paint.get("circle-translate"));
                }
                queryIntersectsFeature(e1, t1, i, n, r, o, a, s) {
                    const l = yb(this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), o.angle, e1.pixelToTileUnitsFactor), c = this.paint.get("circle-radius").evaluate(t1, i) + this.paint.get("circle-stroke-width").evaluate(t1, i);
                    return bb(e1, n, o, a, s, "map" === this.paint.get("circle-pitch-alignment"), "map" === this.paint.get("circle-pitch-scale"), l, c);
                }
                getProgramIds() {
                    return [
                        "circle"
                    ];
                }
                getDefaultProgramParams(e1, t1, i) {
                    const n = vb(this);
                    return {
                        config: new lh(this, {
                            zoom: t1,
                            lut: i
                        }),
                        defines: n,
                        overrideFog: !1
                    };
                }
                is3D(e1) {
                    return !e1 && !!this.layout && "none" !== this.layout.get("circle-elevation-reference");
                }
                hasElevation() {
                    return this.layout && "none" !== this.layout.get("circle-elevation-reference");
                }
                mayUse(e1) {
                    return "HD" === e1 && bl(this, "circle-elevation-reference", (e1)=>"hd-road-markup" === e1);
                }
                prepare() {
                    return this.mayUse("HD") ? pb() : Promise.resolve();
                }
            },
            heatmap: class extends vl {
                createBucket(e1) {
                    return new Mb(e1);
                }
                constructor(e1, t1, i, n){
                    super(e1, {
                        layout: Sb || (Sb = new Zs({
                            visibility: new Gs(Ws.layout_heatmap.visibility)
                        })),
                        paint: Tb || (Tb = new Zs({
                            "heatmap-radius": new Hs(Ws.paint_heatmap["heatmap-radius"]),
                            "heatmap-weight": new Hs(Ws.paint_heatmap["heatmap-weight"]),
                            "heatmap-intensity": new Gs(Ws.paint_heatmap["heatmap-intensity"]),
                            "heatmap-color": new $s(Ws.paint_heatmap["heatmap-color"]),
                            "heatmap-opacity": new Gs(Ws.paint_heatmap["heatmap-opacity"]),
                            "heatmap-color-use-theme": new Hs({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, i, n), this._updateColorRamp();
                }
                _handleSpecialPaintPropertyUpdate(e1) {
                    "heatmap-color" === e1 && this._updateColorRamp();
                }
                _updateColorRamp() {
                    const e1 = this.getPaintPropertyValue("heatmap-color").expression;
                    this.colorRamp = Rb({
                        expression: e1,
                        evaluationKey: "heatmapDensity",
                        image: this.colorRamp
                    }), this.colorRampTexture = null;
                }
                resize() {
                    this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
                }
                _clear() {
                    this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null), this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null);
                }
                queryRadius(e1) {
                    return _b("heatmap-radius", this, e1.programConfigurations.get(this.id));
                }
                queryIntersectsFeature(e1, t1, i, n, r, o, a, s) {
                    const l = this.paint.get("heatmap-radius").evaluate(t1, i);
                    return bb(e1, n, o, a, s, !0, !0, new Re(0, 0), l);
                }
                hasOffscreenPass() {
                    return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
                }
                getProgramIds() {
                    return [
                        "heatmap",
                        "heatmapTexture"
                    ];
                }
                getDefaultProgramParams(e1, t1, i) {
                    return "heatmap" === e1 ? {
                        config: new lh(this, {
                            zoom: t1,
                            lut: i
                        }),
                        overrideFog: !1
                    } : {};
                }
            },
            hillshade: class extends vl {
                constructor(e1, t1, i, n){
                    super(e1, {
                        layout: Pb || (Pb = new Zs({
                            visibility: new Gs(Ws.layout_hillshade.visibility)
                        })),
                        paint: Db || (Db = new Zs({
                            "hillshade-illumination-direction": new Gs(Ws.paint_hillshade["hillshade-illumination-direction"]),
                            "hillshade-illumination-anchor": new Gs(Ws.paint_hillshade["hillshade-illumination-anchor"]),
                            "hillshade-exaggeration": new Gs(Ws.paint_hillshade["hillshade-exaggeration"]),
                            "hillshade-shadow-color": new Gs(Ws.paint_hillshade["hillshade-shadow-color"]),
                            "hillshade-highlight-color": new Gs(Ws.paint_hillshade["hillshade-highlight-color"]),
                            "hillshade-accent-color": new Gs(Ws.paint_hillshade["hillshade-accent-color"]),
                            "hillshade-emissive-strength": new Gs(Ws.paint_hillshade["hillshade-emissive-strength"]),
                            "hillshade-shadow-color-use-theme": new Hs({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "hillshade-highlight-color-use-theme": new Hs({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "hillshade-accent-color-use-theme": new Hs({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, i, n);
                }
                shouldRedrape() {
                    return this.hasOffscreenPass() && "viewport" === this.paint.get("hillshade-illumination-anchor");
                }
                hasOffscreenPass() {
                    return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
                }
                getProgramIds() {
                    return [
                        "hillshade",
                        "hillshadePrepare"
                    ];
                }
                getDefaultProgramParams(e1, t1, i) {
                    return {
                        overrideFog: !1
                    };
                }
            },
            fill: class extends vl {
                constructor(e1, t1, i, n){
                    super(e1, {
                        layout: Fb || (Fb = new Zs({
                            "fill-sort-key": new Hs(Ws.layout_fill["fill-sort-key"]),
                            visibility: new Gs(Ws.layout_fill.visibility),
                            "fill-elevation-reference": new Gs(Ws.layout_fill["fill-elevation-reference"]),
                            "fill-construct-bridge-guard-rail": new Hs(Ws.layout_fill["fill-construct-bridge-guard-rail"])
                        })),
                        paint: Cb || (Cb = new Zs({
                            "fill-antialias": new Gs(Ws.paint_fill["fill-antialias"]),
                            "fill-opacity": new Hs(Ws.paint_fill["fill-opacity"]),
                            "fill-color": new Hs(Ws.paint_fill["fill-color"]),
                            "fill-outline-color": new Hs(Ws.paint_fill["fill-outline-color"]),
                            "fill-translate": new Gs(Ws.paint_fill["fill-translate"]),
                            "fill-translate-anchor": new Gs(Ws.paint_fill["fill-translate-anchor"]),
                            "fill-pattern": new Hs(Ws.paint_fill["fill-pattern"]),
                            "fill-pattern-cross-fade": new Gs(Ws.paint_fill["fill-pattern-cross-fade"]),
                            "fill-emissive-strength": new Gs(Ws.paint_fill["fill-emissive-strength"]),
                            "fill-z-offset": new Hs(Ws.paint_fill["fill-z-offset"]),
                            "fill-bridge-guard-rail-color": new Hs(Ws.paint_fill["fill-bridge-guard-rail-color"]),
                            "fill-tunnel-structure-color": new Hs(Ws.paint_fill["fill-tunnel-structure-color"]),
                            "fill-color-use-theme": new Hs({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "fill-outline-color-use-theme": new Hs({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "fill-bridge-guard-rail-color-use-theme": new Hs({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "fill-tunnel-structure-color-use-theme": new Hs({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, i, n);
                }
                getProgramIds() {
                    const e1 = this.paint.get("fill-pattern"), t1 = e1 && e1.constantOr(1), i = [
                        t1 ? "fillPattern" : "fill"
                    ];
                    return this.paint.get("fill-antialias") && i.push(t1 && !this.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline"), i;
                }
                getDefaultProgramParams(e1, t1, i) {
                    return {
                        config: new lh(this, {
                            zoom: t1,
                            lut: i
                        }),
                        overrideFog: !1
                    };
                }
                _finalizeEvaluated() {
                    const e1 = this.paint._values["fill-outline-color"];
                    "constant" === e1.value.kind && void 0 === e1.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
                }
                createBucket(e1) {
                    return new mh(e1);
                }
                queryRadius() {
                    return mb(this.paint.get("fill-translate"));
                }
                queryIntersectsFeature(e1, t1, i, n, r, o) {
                    return !e1.queryGeometry.isAboveHorizon && ed(gb(e1.tilespaceGeometry, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), o.angle, e1.pixelToTileUnitsFactor), n);
                }
                isTileClipped() {
                    return 0 === this.paint.get("fill-z-offset").constantOr(1);
                }
                is3D(e1) {
                    if (0 !== this.paint.get("fill-z-offset").constantOr(1)) return !0;
                    const t1 = this.layout && "none" !== this.layout.get("fill-elevation-reference");
                    return null != e1 ? t1 && !e1 : t1;
                }
                hasElevation() {
                    return this.layout && "none" !== this.layout.get("fill-elevation-reference");
                }
                mayUse(e1) {
                    return "HD" === e1 && bl(this, "fill-elevation-reference", (e1)=>"none" !== e1);
                }
                prepare() {
                    return this.mayUse("HD") ? pb() : Promise.resolve();
                }
                hasShadowPass() {
                    return this.layout && "none" !== this.layout.get("fill-elevation-reference");
                }
            },
            "fill-extrusion": class extends vl {
                constructor(e1, t1, i, n){
                    super(e1, {
                        layout: Bb || (Bb = new Zs({
                            visibility: new Gs(Ws["layout_fill-extrusion"].visibility),
                            "fill-extrusion-edge-radius": new Gs(Ws["layout_fill-extrusion"]["fill-extrusion-edge-radius"]),
                            "source-max-zoom": new Gs(Ws["layout_fill-extrusion"]["source-max-zoom"])
                        })),
                        paint: Vb || (Vb = new Zs({
                            "fill-extrusion-opacity": new Gs(Ws["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                            "fill-extrusion-color": new Hs(Ws["paint_fill-extrusion"]["fill-extrusion-color"]),
                            "fill-extrusion-translate": new Gs(Ws["paint_fill-extrusion"]["fill-extrusion-translate"]),
                            "fill-extrusion-translate-anchor": new Gs(Ws["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                            "fill-extrusion-pattern": new Hs(Ws["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                            "fill-extrusion-pattern-cross-fade": new Gs(Ws["paint_fill-extrusion"]["fill-extrusion-pattern-cross-fade"]),
                            "fill-extrusion-height": new Hs(Ws["paint_fill-extrusion"]["fill-extrusion-height"]),
                            "fill-extrusion-base": new Hs(Ws["paint_fill-extrusion"]["fill-extrusion-base"]),
                            "fill-extrusion-height-alignment": new Gs(Ws["paint_fill-extrusion"]["fill-extrusion-height-alignment"]),
                            "fill-extrusion-base-alignment": new Gs(Ws["paint_fill-extrusion"]["fill-extrusion-base-alignment"]),
                            "fill-extrusion-vertical-gradient": new Gs(Ws["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"]),
                            "fill-extrusion-ambient-occlusion-intensity": new Gs(Ws["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-intensity"]),
                            "fill-extrusion-ambient-occlusion-radius": new Gs(Ws["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-radius"]),
                            "fill-extrusion-ambient-occlusion-wall-radius": new Gs(Ws["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-wall-radius"]),
                            "fill-extrusion-ambient-occlusion-ground-radius": new Gs(Ws["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-ground-radius"]),
                            "fill-extrusion-ambient-occlusion-ground-attenuation": new Gs(Ws["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-ground-attenuation"]),
                            "fill-extrusion-flood-light-color": new Gs(Ws["paint_fill-extrusion"]["fill-extrusion-flood-light-color"]),
                            "fill-extrusion-flood-light-intensity": new Gs(Ws["paint_fill-extrusion"]["fill-extrusion-flood-light-intensity"]),
                            "fill-extrusion-flood-light-wall-radius": new Hs(Ws["paint_fill-extrusion"]["fill-extrusion-flood-light-wall-radius"]),
                            "fill-extrusion-flood-light-ground-radius": new Hs(Ws["paint_fill-extrusion"]["fill-extrusion-flood-light-ground-radius"]),
                            "fill-extrusion-flood-light-ground-attenuation": new Gs(Ws["paint_fill-extrusion"]["fill-extrusion-flood-light-ground-attenuation"]),
                            "fill-extrusion-vertical-scale": new Gs(Ws["paint_fill-extrusion"]["fill-extrusion-vertical-scale"]),
                            "fill-extrusion-rounded-roof": new Gs(Ws["paint_fill-extrusion"]["fill-extrusion-rounded-roof"]),
                            "fill-extrusion-cutoff-fade-range": new Gs(Ws["paint_fill-extrusion"]["fill-extrusion-cutoff-fade-range"]),
                            "fill-extrusion-front-cutoff": new Gs(Ws["paint_fill-extrusion"]["fill-extrusion-front-cutoff"]),
                            "fill-extrusion-emissive-strength": new Hs(Ws["paint_fill-extrusion"]["fill-extrusion-emissive-strength"]),
                            "fill-extrusion-line-width": new Hs(Ws["paint_fill-extrusion"]["fill-extrusion-line-width"]),
                            "fill-extrusion-cast-shadows": new Gs(Ws["paint_fill-extrusion"]["fill-extrusion-cast-shadows"]),
                            "fill-extrusion-color-use-theme": new Hs({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "fill-extrusion-flood-light-color-use-theme": new Hs({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, i, n), this._stats = {
                        numRenderedVerticesInShadowPass: 0,
                        numRenderedVerticesInTransparentPass: 0
                    };
                }
                createBucket(e1) {
                    return new Dv(e1);
                }
                queryRadius() {
                    return mb(this.paint.get("fill-extrusion-translate"));
                }
                is3D(e1) {
                    return !0;
                }
                hasBlended3DDepthPrepass() {
                    const e1 = this.paint.get("fill-extrusion-opacity");
                    return !(e1 <= 0 || e1 >= 1) && 0 !== this.paint.get("fill-extrusion-color").constantOr(fn.white).a;
                }
                isPlacementAffectedByPaintChanges(e1) {
                    const t1 = e1;
                    return this.paint.get("fill-extrusion-vertical-scale") !== t1.get("fill-extrusion-vertical-scale") || this.paint.get("fill-extrusion-opacity") > 0 != t1.get("fill-extrusion-opacity") > 0;
                }
                hasShadowPass() {
                    return this.paint.get("fill-extrusion-cast-shadows");
                }
                cutoffRange() {
                    return this.paint.get("fill-extrusion-cutoff-fade-range");
                }
                canCastShadows() {
                    return !0;
                }
                getProgramIds() {
                    return [
                        this.paint.get("fill-extrusion-pattern").constantOr(1) ? "fillExtrusionPattern" : "fillExtrusion"
                    ];
                }
                queryIntersectsFeature(e1, t1, i, n, r, o, a, s, l) {
                    const c = yb(this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), o.angle, e1.pixelToTileUnitsFactor), u = this.paint.get("fill-extrusion-height").evaluate(t1, i), h = this.paint.get("fill-extrusion-base").evaluate(t1, i), d = [
                        0,
                        0
                    ], f = s && o.elevation, p = o.elevation ? o.elevation.exaggeration() : 1, _ = e1.tile.getBucket(this);
                    if (_ instanceof Dv) {
                        const e1 = _.centroidData.find((e1)=>l >= e1.vertexArrayOffset && l < e1.vertexArrayOffset + e1.vertexCount);
                        if (e1 && e1.flags & yv) return !1;
                        if (f) {
                            const e1 = _.centroidVertexArray, t1 = l + 1;
                            t1 < e1.length && (d[0] = e1.geta_centroid_pos0(t1), d[1] = e1.geta_centroid_pos1(t1));
                        }
                    }
                    if (0 === d[0] && 1 === d[1]) return !1;
                    "globe" === o.projection.name && (n = $v([
                        n
                    ], [
                        new Re(0, 0),
                        new Re(Sr, Sr)
                    ], e1.tileID.canonical).map((e1)=>e1.polygon).flat());
                    const m = f ? s : null, [g, y] = Wb(o, n, h, u, c, a, m, d, p, o.center.lat, e1.tileID.canonical), x = e1.queryGeometry;
                    return Zb(g, y, x.isPointQuery() ? x.screenBounds : x.screenGeometry);
                }
            },
            building: class extends vl {
                constructor(e1, t1, i, n){
                    super(e1, {
                        layout: Nb || (Nb = new Zs({
                            visibility: new Gs(Ws.layout_building.visibility),
                            "building-facade": new Hs(Ws.layout_building["building-facade"]),
                            "building-facade-floors": new Hs(Ws.layout_building["building-facade-floors"]),
                            "building-facade-unit-width": new Hs(Ws.layout_building["building-facade-unit-width"]),
                            "building-facade-window": new Hs(Ws.layout_building["building-facade-window"]),
                            "building-roof-shape": new Hs(Ws.layout_building["building-roof-shape"]),
                            "building-height": new Hs(Ws.layout_building["building-height"]),
                            "building-base": new Hs(Ws.layout_building["building-base"]),
                            "building-flood-light-wall-radius": new Hs(Ws.layout_building["building-flood-light-wall-radius"]),
                            "building-flood-light-ground-radius": new Hs(Ws.layout_building["building-flood-light-ground-radius"]),
                            "building-flip-roof-orientation": new Hs(Ws.layout_building["building-flip-roof-orientation"])
                        })),
                        paint: kb || (kb = new Zs({
                            "building-opacity": new Gs(Ws.paint_building["building-opacity"]),
                            "building-ambient-occlusion-intensity": new Gs(Ws.paint_building["building-ambient-occlusion-intensity"]),
                            "building-ambient-occlusion-ground-intensity": new Gs(Ws.paint_building["building-ambient-occlusion-ground-intensity"]),
                            "building-ambient-occlusion-ground-radius": new Gs(Ws.paint_building["building-ambient-occlusion-ground-radius"]),
                            "building-ambient-occlusion-ground-attenuation": new Gs(Ws.paint_building["building-ambient-occlusion-ground-attenuation"]),
                            "building-vertical-scale": new Gs(Ws.paint_building["building-vertical-scale"]),
                            "building-cast-shadows": new Gs(Ws.paint_building["building-cast-shadows"]),
                            "building-color": new Hs(Ws.paint_building["building-color"]),
                            "building-emissive-strength": new Hs(Ws.paint_building["building-emissive-strength"]),
                            "building-facade-emissive-chance": new Gs(Ws.paint_building["building-facade-emissive-chance"]),
                            "building-cutoff-fade-range": new Gs(Ws.paint_building["building-cutoff-fade-range"]),
                            "building-front-cutoff": new Gs(Ws.paint_building["building-front-cutoff"]),
                            "building-flood-light-color": new Gs(Ws.paint_building["building-flood-light-color"]),
                            "building-flood-light-intensity": new Gs(Ws.paint_building["building-flood-light-intensity"]),
                            "building-flood-light-ground-attenuation": new Gs(Ws.paint_building["building-flood-light-ground-attenuation"]),
                            "building-color-use-theme": new Hs({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "building-flood-light-color-use-theme": new Hs({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, i, n), this._stats = {
                        numRenderedVerticesInShadowPass: 0,
                        numRenderedVerticesInTransparentPass: 0
                    };
                }
                mayUse(e1) {
                    return "HD" === e1;
                }
                prepare() {
                    return async function() {
                        return function() {
                            if (!xt(self)) return null;
                            if (null != sb || null != ab) return null;
                            if (null != ob) return ob;
                            const e1 = fetch(Gt());
                            return ob = (function(e1) {
                                let t1, i, n, r, o;
                                function a() {
                                    t1 = new Uint8Array(o.buffer), i = new Int16Array(o.buffer), n = new Int32Array(o.buffer), r = new Float32Array(o.buffer);
                                }
                                function s() {
                                    throw new Error("Unexpected BuildingGen error.");
                                }
                                const l = ()=>{}, c = {
                                    a: {
                                        a: s,
                                        f: function(e1) {
                                            const i = t1.length, n = Math.max(e1 >>> 0, Math.ceil(1.2 * i)), r = Math.ceil((n - i) / 65536);
                                            try {
                                                return o.grow(r), a(), !0;
                                            } catch (e1) {
                                                return !1;
                                            }
                                        },
                                        g: s,
                                        b: l,
                                        c: l,
                                        d: l,
                                        e: l
                                    }
                                };
                                return (WebAssembly.instantiateStreaming ? WebAssembly.instantiateStreaming(e1, c) : e1.then((e1)=>e1.arrayBuffer()).then((e1)=>WebAssembly.instantiate(e1, c))).then((e1)=>{
                                    const s = e1.instance.exports;
                                    return (0, s.g)(), o = s.f, a(), new qv({
                                        setStyle: s.h,
                                        setAOOptions: s.i,
                                        setMetricOptions: s.j,
                                        setStructuralOptions: s.k,
                                        setFacadeOptions: s.l,
                                        setFauxFacadeOptions: s.m,
                                        setFacadeClassifierOptions: s.n,
                                        addFeature: s.o,
                                        addFacade: s.p,
                                        generateMesh: s.q,
                                        getLastError: s.r,
                                        getOuterRingLength: s.s,
                                        getMeshCount: s.t,
                                        getPositionsPtr: s.u,
                                        getPositionsLength: s.v,
                                        getNormalsPtr: s.w,
                                        getNormalsLength: s.x,
                                        getAOPtr: s.y,
                                        getAOLength: s.z,
                                        getUVPtr: s.A,
                                        getUVLength: s.B,
                                        getFauxFacadePtr: s.C,
                                        getFauxFacadeLength: s.D,
                                        getIndicesPtr: s.E,
                                        getIndicesLength: s.F,
                                        getBuildingPart: s.G,
                                        getRingCount: s.H,
                                        getRingPtr: s.I,
                                        getRingLength: s.J,
                                        malloc: s.K,
                                        free: s.L,
                                        heapU8: t1,
                                        heap16: i,
                                        heap32: n,
                                        heapF32: r
                                    });
                                });
                            })(e1).then((e1)=>{
                                ob = null, sb = e1;
                            }).catch((e1)=>{
                                _t("Could not load building-gen"), ob = null, ab = e1;
                            }), ob;
                        }();
                    }();
                }
                createBucket(e1) {
                    return new ub(e1);
                }
                cutoffRange() {
                    return this.paint.get("building-cutoff-fade-range");
                }
                isPlacementAffectedByPaintChanges(e1) {
                    const t1 = e1;
                    return this.paint.get("building-vertical-scale") !== t1.get("building-vertical-scale") || this.paint.get("building-opacity") > 0 != t1.get("building-opacity") > 0;
                }
                hasShadowPass() {
                    return this.paint.get("building-cast-shadows");
                }
                hasLightBeamPass() {
                    return !0;
                }
                canCastShadows() {
                    return !0;
                }
                is3D(e1) {
                    return !0;
                }
                hasBlended3DDepthPrepass() {
                    const e1 = this.paint.get("building-opacity");
                    return e1 > 0 && e1 < 1 && this.paint.get("building-vertical-scale") > 0;
                }
                queryRadius(e1) {
                    return 0;
                }
                queryIntersectsFeature(e1, t1, i, n, r, o, a, s, l, c) {
                    let u = this.layout.get("building-height").evaluate(t1, i);
                    const h = this.layout.get("building-base").evaluate(t1, i), d = e1.tile.getBucket(this).getFootprint(t1);
                    if (d) {
                        if (0 !== d.hiddenFlags) return !1;
                        u = d.height;
                    }
                    const [f, p] = Wb(o, n, h, u, new Re(0, 0), a, null, [
                        0,
                        0
                    ], 1, o.center.lat, e1.tileID.canonical), _ = e1.queryGeometry;
                    return Zb(f, p, _.isPointQuery() ? _.screenBounds : _.screenGeometry);
                }
            },
            line: class extends vl {
                constructor(e1, t1, i, n){
                    const r = tw();
                    super(e1, r, t1, i, n), r.layout && (this.layout = new js(r.layout)), this.gradientVersion = 0, this.borderGradientVersion = 0, this.hasElevatedBuckets = !1, this.hasNonElevatedBuckets = !1, this.lineBlendFbos = null, this.lineBlendDensityReadback = null;
                }
                _handleSpecialPaintPropertyUpdate(e1) {
                    if ("line-gradient" === e1) {
                        const e1 = this.getPaintPropertyValue("line-gradient").expression;
                        this.stepInterpolant = e1._styleExpression && e1._styleExpression.expression instanceof To, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
                    } else if ("line-gradient-use-theme" === e1) this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
                    else if ("line-border-gradient" === e1) {
                        const e1 = this.getPaintPropertyValue("line-border-gradient").expression;
                        this.borderStepInterpolant = e1._styleExpression && e1._styleExpression.expression instanceof To, this.borderGradientVersion = (this.borderGradientVersion + 1) % Number.MAX_SAFE_INTEGER;
                    } else "line-border-gradient-use-theme" === e1 && (this.borderGradientVersion = (this.borderGradientVersion + 1) % Number.MAX_SAFE_INTEGER);
                }
                _finalizeEvaluated(e1) {
                    this.paint._values["line-floorwidth"] = (()=>{
                        if (nw) return nw;
                        const e1 = tw();
                        return nw = new iw(e1.paint.properties["line-width"].specification), nw.useIntegerZoom = !0, nw;
                    })().possiblyEvaluate(this.getPaintPropertyValue("line-width"), e1);
                }
                createBucket(e1) {
                    return new Fd(e1);
                }
                getProgramIds() {
                    const e1 = [
                        this.paint.get("line-pattern").constantOr(1) ? "linePattern" : "line"
                    ];
                    return "default" !== this.paint.get("line-blend-mode") && e1.push("lineBlendComposite"), e1;
                }
                getDefaultProgramParams(e1, t1, i) {
                    if ("lineBlendComposite" === e1) return {};
                    const n = Kb(this);
                    return {
                        config: new lh(this, {
                            zoom: t1,
                            lut: i
                        }),
                        defines: n,
                        overrideFog: !1
                    };
                }
                queryRadius(e1) {
                    const t1 = e1.uboBinders[this.id], i = sw(_b("line-width", this, t1), _b("line-gap-width", this, t1)), n = _b("line-offset", this, t1);
                    return i / 2 + Math.abs(n) + mb(this.paint.get("line-translate"));
                }
                queryIntersectsFeature(e1, t1, i, n, r, o) {
                    if (e1.queryGeometry.isAboveHorizon) return !1;
                    const a = gb(e1.tilespaceGeometry, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), o.angle, e1.pixelToTileUnitsFactor), s = e1.pixelToTileUnitsFactor / 2 * sw(this.paint.get("line-width").evaluate(t1, i), this.paint.get("line-gap-width").evaluate(t1, i)), l = this.paint.get("line-offset").evaluate(t1, i);
                    return l && (n = function(e1, t1) {
                        const i = [], n = new Re(0, 0);
                        for(let r = 0; r < e1.length; r++){
                            const o = e1[r], a = [];
                            for(let e1 = 0; e1 < o.length; e1++){
                                const i = o[e1], r = o[e1 + 1], s = 0 === e1 ? n : i.sub(o[e1 - 1])._unit()._perp(), l = e1 === o.length - 1 ? n : r.sub(i)._unit()._perp(), c = s._add(l)._unit();
                                c._mult(1 / (c.x * l.x + c.y * l.y)), a.push(c._mult(t1)._add(i));
                            }
                            i.push(a);
                        }
                        return i;
                    }(n, l * e1.pixelToTileUnitsFactor)), function(e1, t1, i) {
                        for(let n = 0; n < t1.length; n++){
                            const r = t1[n];
                            if (e1.length >= 3) {
                                for(let t1 = 0; t1 < r.length; t1++)if (cd(e1, r[t1])) return !0;
                            }
                            if (td(e1, r, i)) return !0;
                        }
                        return !1;
                    }(a, n, s);
                }
                isTileClipped() {
                    return this.hasNonElevatedBuckets;
                }
                isDraped(e1) {
                    return !this.hasElevatedBuckets || this.layout && "hd-road-markup" === this.layout.get("line-elevation-reference");
                }
                hasElevation() {
                    return this.layout && "none" !== this.layout.get("line-elevation-reference");
                }
                mayUse(e1) {
                    return "HD" === e1 ? bl(this, "line-elevation-reference", (e1)=>"hd-road-markup" === e1) : "Lite" === e1 && function(e1) {
                        const t1 = e1.getLayoutPropertyValue("line-elevation-reference")?.value;
                        if (void 0 !== t1 && ("string" != typeof t1 || "none" !== t1)) return !0;
                        const i = e1.getLayoutPropertyValue("line-z-offset")?.value;
                        return void 0 !== i && ("number" != typeof i || 0 !== i);
                    }(this);
                }
                prepare() {
                    return this.mayUse("HD") ? pb() : Promise.resolve();
                }
                hasOffscreenPass() {
                    return "default" !== this.paint.get("line-blend-mode") && 0 !== this.paint.get("line-opacity").constantOr(1) && 0 !== this.paint.get("line-width").constantOr(1) && "none" !== this.visibility;
                }
                resize() {
                    this._destroyLineBlendFbo();
                }
                onRemove(e1) {
                    this._destroyLineBlendFbo(e1.painter && e1.painter.context && e1.painter.context.gl || void 0);
                }
                _clear() {
                    this._destroyLineBlendFbo();
                }
                _destroyLineBlendFbo(e1) {
                    this.lineBlendFbos && (this.lineBlendFbos.destroy(), this.lineBlendFbos = null), e1 && this.lineBlendDensityReadback && this.lineBlendDensityReadback.destroy(e1), this.lineBlendDensityReadback = null;
                }
            },
            symbol: fw,
            background: class extends vl {
                constructor(e1, t1, i, n){
                    super(e1, {
                        layout: pw || (pw = new Zs({
                            visibility: new Gs(Ws.layout_background.visibility)
                        })),
                        paint: _w || (_w = new Zs({
                            "background-pitch-alignment": new Gs(Ws.paint_background["background-pitch-alignment"]),
                            "background-color": new Gs(Ws.paint_background["background-color"]),
                            "background-pattern": new Gs(Ws.paint_background["background-pattern"]),
                            "background-opacity": new Gs(Ws.paint_background["background-opacity"]),
                            "background-emissive-strength": new Gs(Ws.paint_background["background-emissive-strength"]),
                            "background-color-use-theme": new Hs({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, i, n);
                }
                getProgramIds() {
                    return [
                        this.paint.get("background-pattern") ? "backgroundPattern" : "background"
                    ];
                }
                getDefaultProgramParams(e1, t1, i) {
                    return {
                        overrideFog: !1
                    };
                }
                is3D(e1) {
                    return "viewport" === this.paint.get("background-pitch-alignment");
                }
            },
            raster: vw,
            "raster-particle": zw,
            sky: class extends vl {
                constructor(e1, t1, i, n){
                    super(e1, {
                        layout: Aw || (Aw = new Zs({
                            visibility: new Gs(Ws.layout_sky.visibility)
                        })),
                        paint: Ew || (Ew = new Zs({
                            "sky-type": new Gs(Ws.paint_sky["sky-type"]),
                            "sky-atmosphere-sun": new Gs(Ws.paint_sky["sky-atmosphere-sun"]),
                            "sky-atmosphere-sun-intensity": new Gs(Ws.paint_sky["sky-atmosphere-sun-intensity"]),
                            "sky-gradient-center": new Gs(Ws.paint_sky["sky-gradient-center"]),
                            "sky-gradient-radius": new Gs(Ws.paint_sky["sky-gradient-radius"]),
                            "sky-gradient": new $s(Ws.paint_sky["sky-gradient"]),
                            "sky-atmosphere-halo-color": new Gs(Ws.paint_sky["sky-atmosphere-halo-color"]),
                            "sky-atmosphere-color": new Gs(Ws.paint_sky["sky-atmosphere-color"]),
                            "sky-opacity": new Gs(Ws.paint_sky["sky-opacity"]),
                            "sky-gradient-use-theme": new Hs({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "sky-atmosphere-halo-color-use-theme": new Hs({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "sky-atmosphere-color-use-theme": new Hs({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, i, n), this._updateColorRamp();
                }
                _clear() {
                    this.skyboxFbo && (this.skyboxFbo.destroy(), this.skyboxFbo = null), this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null), this._skyboxInvalidated = !0;
                }
                _handleSpecialPaintPropertyUpdate(e1) {
                    "sky-gradient" === e1 ? this._updateColorRamp() : "sky-atmosphere-sun" !== e1 && "sky-atmosphere-halo-color" !== e1 && "sky-atmosphere-color" !== e1 && "sky-atmosphere-sun-intensity" !== e1 || (this._skyboxInvalidated = !0);
                }
                _updateColorRamp() {
                    const e1 = this.getPaintPropertyValue("sky-gradient").expression;
                    this.colorRamp = Rb({
                        expression: e1,
                        evaluationKey: "skyRadialProgress"
                    }), this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null);
                }
                needsSkyboxCapture(e1) {
                    if (this._skyboxInvalidated || !this.skyboxTexture || !this.skyboxGeometry) return !0;
                    if (!this.paint.get("sky-atmosphere-sun")) {
                        const t1 = e1.style.light.properties.get("position");
                        return this._lightPosition.azimuthal !== t1.azimuthal || this._lightPosition.polar !== t1.polar;
                    }
                    return !1;
                }
                getCenter(e1, t1) {
                    if ("atmosphere" === this.paint.get("sky-type")) {
                        const i = this.paint.get("sky-atmosphere-sun"), n = !i, r = e1.style.light, o = r.properties.get("position");
                        return n && "viewport" === r.properties.get("anchor") && _t("The sun direction is attached to a light with viewport anchor, lighting may behave unexpectedly."), n ? Pw(o.azimuthal, 90 - o.polar, t1) : Pw(i[0], 90 - i[1], t1);
                    }
                    const i = this.paint.get("sky-gradient-center");
                    return Pw(i[0], 90 - i[1], t1);
                }
                isSky() {
                    return !0;
                }
                markSkyboxValid(e1) {
                    this._skyboxInvalidated = !1, this._lightPosition = e1.style.light.properties.get("position");
                }
                hasOffscreenPass() {
                    return !0;
                }
                getProgramIds() {
                    const e1 = this.paint.get("sky-type");
                    return "atmosphere" === e1 ? [
                        "skyboxCapture",
                        "skybox"
                    ] : "gradient" === e1 ? [
                        "skyboxGradient"
                    ] : null;
                }
            },
            slot: class extends vl {
                constructor(e1, t1, i, n){
                    super(e1, {
                        paint: Iw || (Iw = new Zs({}))
                    }, t1, null);
                }
            },
            "placement-group": class extends vl {
                constructor(e1, t1, i, n){
                    super(e1, {
                        paint: Mw || (Mw = new Zs({}))
                    }, t1, i, n);
                }
            },
            model: class extends vl {
                constructor(e1, t1, i, n){
                    super(e1, {
                        layout: Sw || (Sw = new Zs({
                            visibility: new Gs(Ws.layout_model.visibility),
                            "model-id": new Hs(Ws.layout_model["model-id"]),
                            "model-allow-density-reduction": new Gs(Ws.layout_model["model-allow-density-reduction"])
                        })),
                        paint: Tw || (Tw = new Zs({
                            "model-opacity": new Hs(Ws.paint_model["model-opacity"]),
                            "model-rotation": new Hs(Ws.paint_model["model-rotation"]),
                            "model-scale": new Hs(Ws.paint_model["model-scale"]),
                            "model-translation": new Hs(Ws.paint_model["model-translation"]),
                            "model-color": new Hs(Ws.paint_model["model-color"]),
                            "model-color-mix-intensity": new Hs(Ws.paint_model["model-color-mix-intensity"]),
                            "model-type": new Gs(Ws.paint_model["model-type"]),
                            "model-cast-shadows": new Gs(Ws.paint_model["model-cast-shadows"]),
                            "model-receive-shadows": new Gs(Ws.paint_model["model-receive-shadows"]),
                            "model-ambient-occlusion-intensity": new Gs(Ws.paint_model["model-ambient-occlusion-intensity"]),
                            "model-emissive-strength": new Hs(Ws.paint_model["model-emissive-strength"]),
                            "model-roughness": new Hs(Ws.paint_model["model-roughness"]),
                            "model-height-based-emissive-strength-multiplier": new Hs(Ws.paint_model["model-height-based-emissive-strength-multiplier"]),
                            "model-cutoff-fade-range": new Gs(Ws.paint_model["model-cutoff-fade-range"]),
                            "model-front-cutoff": new Gs(Ws.paint_model["model-front-cutoff"]),
                            "model-elevation-reference": new Gs(Ws.paint_model["model-elevation-reference"]),
                            "model-line-cutout-mode": new Gs(Ws.paint_model["model-line-cutout-mode"]),
                            "model-color-use-theme": new Hs({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, i, n), this.layer = e1, this._stats = {
                        numRenderedVerticesInShadowPass: 0,
                        numRenderedVerticesInTransparentPass: 0
                    };
                }
                mayUse(e1) {
                    return "Standard" === e1;
                }
                prepare() {
                    return AI();
                }
                createBucket(e1) {
                    return new Ow(e1);
                }
                getProgramIds() {
                    return [
                        "model"
                    ];
                }
                is3D(e1) {
                    return !0;
                }
                hasShadowPass() {
                    return this.paint.get("model-cast-shadows");
                }
                canCastShadows() {
                    return !0;
                }
                hasLightBeamPass() {
                    return !0;
                }
                cutoffRange() {
                    return this.paint.get("model-cutoff-fade-range");
                }
                queryRadius(e1) {
                    return e1.isTiled3dModelBucket ? 8191 : 0;
                }
                queryRenderedFeatures(e1, t1, i) {
                    return xI.queryModelLayerRendered ? xI.queryModelLayerRendered(this, e1, t1, i) : {};
                }
                queryIntersectsFeature(e1, t1, i, n, r, o, a, s, l, c) {
                    return !!xI.queryModelLayerIntersectsFeature && xI.queryModelLayerIntersectsFeature(this, e1, t1, i, o, c);
                }
                _handleOverridablePaintPropertyUpdate(e1, t1, i) {
                    return !(!this.layout || t1.isDataDriven() || i.isDataDriven() || "model-color" !== e1 && "model-color-mix-intensity" !== e1 && "model-rotation" !== e1 && "model-scale" !== e1 && "model-translation" !== e1 && "model-emissive-strength" !== e1);
                }
                _isPropertyZoomDependent(e1) {
                    const t1 = this.getPaintPropertyValue(e1);
                    return null != t1 && t1.expression instanceof Ha;
                }
                isZoomDependent() {
                    return this._isPropertyZoomDependent("model-scale") || this._isPropertyZoomDependent("model-rotation") || this._isPropertyZoomDependent("model-translation");
                }
            },
            clip: class extends vl {
                constructor(e1, t1, i, n){
                    super(e1, {
                        layout: Ob || (Ob = new Zs({
                            "clip-layer-types": new Gs(Ws.layout_clip["clip-layer-types"]),
                            "clip-layer-scope": new Gs(Ws.layout_clip["clip-layer-scope"]),
                            visibility: new Gs(Ws.layout_clip.visibility)
                        })),
                        paint: Lb || (Lb = new Zs({}))
                    }, t1, i, n);
                }
                createBucket(e1) {
                    return new Gb(e1);
                }
                is3D(e1) {
                    return !0;
                }
            }
        };
        class II {
            constructor(e1){
                this.capacity = e1, this.cache = new Map;
            }
            get(e1) {
                if (!this.cache.has(e1)) return;
                const t1 = this.cache.get(e1);
                return this.cache.delete(e1), this.cache.set(e1, t1), t1;
            }
            put(e1, t1) {
                this.cache.has(e1) ? this.cache.delete(e1) : this.cache.size === this.capacity && this.cache.delete(this.cache.keys().next().value), this.cache.set(e1, t1);
            }
            delete(e1) {
                this.cache.delete(e1);
            }
        }
        Ya(II, "LRUCache");
        class MI {
            constructor(e1){
                this._callback = e1, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel, this._channel.port2.onmessage = ()=>{
                    this._triggered = !1, this._callback();
                });
            }
            trigger() {
                this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(()=>{
                    this._triggered = !1, this._callback();
                }, 0));
            }
            remove() {
                this._channel && (this._channel.port1.close(), this._channel.port2.close()), this._callback = ()=>{};
            }
        }
        const SI = {
            Other: 0,
            Symbol: 1,
            FillExtrusion: 2,
            HdRoadCoverage: 3
        };
        class TI {
            constructor(){
                this.tasks = new Map, ct([
                    "process"
                ], this), this.invoker = new MI(this.process), this.nextId = 0;
            }
            add(e1, t1) {
                const i = this.nextId++, n = function({ type: e1, renderSourceType: t1, zoom: i }) {
                    i = i || 0;
                    const n = t1 === SI.Symbol;
                    return "message" === e1 ? 0 : "maybePrepare" !== e1 || n ? "parseTile" !== e1 || n ? "parseTile" === e1 && n ? 300 - i : "maybePrepare" === e1 && n ? 400 - i : 500 : 200 - i : 100 - i;
                }(t1);
                if (0 === n) {
                    e1();
                    return null;
                }
                return this.tasks.set(i, {
                    fn: e1,
                    metadata: t1,
                    priority: n,
                    id: i
                }), this.invoker.trigger(), {
                    cancel: ()=>{
                        this.tasks.delete(i);
                    }
                };
            }
            process() {
                {
                    const e1 = this.pick();
                    if (!e1) return;
                    this.tasks.delete(e1.id), this.tasks.size > 0 && this.invoker.trigger(), e1.fn();
                }
            }
            pick() {
                let e1 = null, t1 = 1 / 0;
                for (const i of this.tasks.values())i.priority < t1 && (t1 = i.priority, e1 = i);
                return e1;
            }
            remove() {
                this.tasks.clear(), this.invoker.remove();
            }
        }
        const zI = {
            type: "message"
        };
        function RI(e1, t1) {
            const i = {};
            let n;
            for(; n = e1.nextField(t1);)1 === n ? (i.delta_filter = PI(e1, e1.readVarint() + e1.pos), i.filter = "delta_filter") : 2 === n ? (e1.readVarint(), i.filter = "zigzag_filter") : 3 === n ? (e1.readVarint(), i.filter = "bitshuffle_filter") : 4 === n && (e1.readVarint(), i.filter = "byteshuffle_filter");
            return i;
        }
        function PI(e1, t1) {
            const i = {
                blockSize: 0
            };
            let n;
            for(; n = e1.nextField(t1);)1 === n && (i.blockSize = e1.readVarint());
            return i;
        }
        function DI(e1, t1) {
            const i = {};
            let n;
            for(; n = e1.nextField(t1);)1 === n ? (e1.readVarint(), i.codec = "gzip_data") : 2 === n ? (e1.readVarint(), i.codec = "jpeg_image") : 3 === n ? (e1.readVarint(), i.codec = "webp_image") : 4 === n && (e1.readVarint(), i.codec = "png_image");
            return i;
        }
        function FI(e1, t1) {
            const i = {
                firstByte: 0,
                lastByte: 0,
                filters: [],
                codec: null,
                offset: 0,
                scale: 0,
                bands: []
            };
            let n, r = 0, o = 0;
            for(; n = e1.nextField(t1);)1 === n ? i.firstByte = e1.readFixed64() : 2 === n ? i.lastByte = e1.readFixed64() : 3 === n ? i.filters.push(RI(e1, e1.readVarint() + e1.pos)) : 4 === n ? i.codec = DI(e1, e1.readVarint() + e1.pos) : 5 === n ? o = e1.readFloat() : 6 === n ? r = e1.readFloat() : 7 === n ? i.bands.push(e1.readString()) : 8 === n ? i.offset = e1.readDouble() : 9 === n && (i.scale = e1.readDouble());
            return 0 === i.offset && (i.offset = o), 0 === i.scale && (i.scale = r), i;
        }
        function CI(e1, t1) {
            const i = {
                version: 0,
                name: "",
                units: "",
                tileSize: 0,
                buffer: 0,
                pixelFormat: 0,
                dataIndex: []
            };
            let n;
            for(; n = e1.nextField(t1);)1 === n ? i.version = e1.readVarint() : 2 === n ? i.name = e1.readString() : 3 === n ? i.units = e1.readString() : 4 === n ? i.tileSize = e1.readVarint() : 5 === n ? i.buffer = e1.readVarint() : 6 === n ? i.pixelFormat = e1.readVarint() : 7 === n && i.dataIndex.push(FI(e1, e1.readVarint() + e1.pos));
            return i;
        }
        function OI(e1, t1, i) {
            let n;
            for(; n = e1.nextField(t1);)if (1 === n) {
                let t1 = 0;
                const n = e1.readVarint() + e1.pos;
                for(; e1.pos < n;)i[t1++] = e1.readVarint();
            }
            return i;
        }
        function LI(e1, t1) {
            if (4 !== t1.length) throw new Error(`Expected data of dimension 4 but got ${t1.length}.`);
            let i = t1[3];
            for(let n = 2; n >= 1; n--){
                const r = 1 === n ? 1 : 0, o = 2 === n ? 1 : 0;
                for(let n = 0; n < t1[0]; n++){
                    const a = t1[1] * n;
                    for(let n = r; n < t1[1]; n++){
                        const r = t1[2] * (n + a);
                        for(let n = o; n < t1[2]; n++){
                            const o = t1[3] * (n + r);
                            for(let n = 0; n < t1[3]; n++){
                                const t1 = o + n;
                                e1[t1] += e1[t1 - i];
                            }
                        }
                    }
                }
                i *= t1[n];
            }
            return e1;
        }
        function BI(e1) {
            for(let t1 = 0, i = e1.length; t1 < i; t1++)e1[t1] = e1[t1] >>> 1 ^ -(1 & e1[t1]);
            return e1;
        }
        function VI(e1, t1) {
            switch(t1){
                case "uint32":
                    return e1;
                case "uint16":
                    for(let t1 = 0; t1 < e1.length; t1 += 2){
                        const i = e1[t1], n = e1[t1 + 1];
                        e1[t1] = (240 & i) >> 4 | (61440 & i) >> 8 | (240 & n) << 4 | 61440 & n, e1[t1 + 1] = 15 & i | (3840 & i) >> 4 | (15 & n) << 8 | (3840 & n) << 4;
                    }
                    return e1;
                case "uint8":
                    for(let t1 = 0; t1 < e1.length; t1 += 4){
                        const i = e1[t1], n = e1[t1 + 1], r = e1[t1 + 2], o = e1[t1 + 3];
                        e1[t1 + 0] = (192 & i) >> 6 | (192 & n) >> 4 | (192 & r) >> 2 | 192 & o, e1[t1 + 1] = (48 & i) >> 4 | (48 & n) >> 2 | 48 & r | (48 & o) << 2, e1[t1 + 2] = (12 & i) >> 2 | 12 & n | (12 & r) << 2 | (12 & o) << 4, e1[t1 + 3] = 3 & i | (3 & n) << 2 | (3 & r) << 4 | (3 & o) << 6;
                    }
                    return e1;
                default:
                    throw new Error(`Invalid pixel format, "${t1}"`);
            }
        }
        var NI = Uint8Array, kI = Uint16Array, UI = Int32Array, jI = new NI([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            0,
            0,
            0,
            0
        ]), GI = new NI([
            0,
            0,
            0,
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            13,
            13,
            0,
            0
        ]), HI = new NI([
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ]), $I = function(e1, t1) {
            for(var i = new kI(31), n = 0; n < 31; ++n)i[n] = t1 += 1 << e1[n - 1];
            var r = new UI(i[30]);
            for(n = 1; n < 30; ++n)for(var o = i[n]; o < i[n + 1]; ++o)r[o] = o - i[n] << 5 | n;
            return {
                b: i,
                r: r
            };
        }, ZI = $I(jI, 2), WI = ZI.b, qI = ZI.r;
        WI[28] = 258, qI[258] = 28;
        for(var XI = $I(GI, 0).b, YI = new kI(32768), JI = 0; JI < 32768; ++JI){
            var KI = (43690 & JI) >> 1 | (21845 & JI) << 1;
            YI[JI] = ((65280 & (KI = (61680 & (KI = (52428 & KI) >> 2 | (13107 & KI) << 2)) >> 4 | (3855 & KI) << 4)) >> 8 | (255 & KI) << 8) >> 1;
        }
        var QI = function(e1, t1, i) {
            for(var n = e1.length, r = 0, o = new kI(t1); r < n; ++r)e1[r] && ++o[e1[r] - 1];
            var a, s = new kI(t1);
            for(r = 1; r < t1; ++r)s[r] = s[r - 1] + o[r - 1] << 1;
            a = new kI(1 << t1);
            var l = 15 - t1;
            for(r = 0; r < n; ++r)if (e1[r]) for(var c = r << 4 | e1[r], u = t1 - e1[r], h = s[e1[r] - 1]++ << u, d = h | (1 << u) - 1; h <= d; ++h)a[YI[h] >> l] = c;
            return a;
        }, eM = new NI(288);
        for(JI = 0; JI < 144; ++JI)eM[JI] = 8;
        for(JI = 144; JI < 256; ++JI)eM[JI] = 9;
        for(JI = 256; JI < 280; ++JI)eM[JI] = 7;
        for(JI = 280; JI < 288; ++JI)eM[JI] = 8;
        var tM = new NI(32);
        for(JI = 0; JI < 32; ++JI)tM[JI] = 5;
        var iM = QI(eM, 9), nM = QI(tM, 5), rM = function(e1) {
            for(var t1 = e1[0], i = 1; i < e1.length; ++i)e1[i] > t1 && (t1 = e1[i]);
            return t1;
        }, oM = function(e1, t1, i) {
            var n = t1 / 8 | 0;
            return (e1[n] | e1[n + 1] << 8) >> (7 & t1) & i;
        }, aM = function(e1, t1) {
            var i = t1 / 8 | 0;
            return (e1[i] | e1[i + 1] << 8 | e1[i + 2] << 16) >> (7 & t1);
        }, sM = function(e1) {
            return (e1 + 7) / 8 | 0;
        }, lM = [
            "unexpected EOF",
            "invalid block type",
            "invalid length/literal",
            "invalid distance",
            "stream finished",
            "no stream handler",
            ,
            "no callback",
            "invalid UTF-8 data",
            "extra field too long",
            "date not in range 1980-2099",
            "filename too long",
            "stream finishing",
            "invalid zip data"
        ], cM = function(e1, t1, i) {
            var n = new Error(t1 || lM[e1]);
            if (n.code = e1, Error.captureStackTrace && Error.captureStackTrace(n, cM), !i) throw n;
            return n;
        }, uM = new NI(0);
        var hM = "undefined" != typeof TextDecoder && new TextDecoder;
        try {
            hM.decode(uM, {
                stream: !0
            });
        } catch (e1) {}
        const dM = {
            gzip_data: "gzip"
        };
        class fM extends Error {
            constructor(e1){
                super(e1), this.name = "MRTError";
            }
        }
        const pM = {
            0: "uint32",
            1: "uint32",
            2: "uint16",
            3: "uint8"
        }, _M = {
            uint32: 1,
            uint16: 2,
            uint8: 4
        }, mM = {
            uint32: Uint32Array,
            uint16: Uint16Array,
            uint8: Uint8Array
        };
        let gM;
        class yM {
            constructor(e1 = 5){
                this.x = NaN, this.y = NaN, this.z = NaN, this.layers = {}, this._cacheSize = e1;
            }
            getLayer(e1) {
                const t1 = this.layers[e1];
                if (!t1) throw new fM(`Layer '${e1}' not found`);
                return t1;
            }
            getHeaderLength(e1) {
                const t1 = new Uint8Array(e1), i = new DataView(e1);
                if (13 !== t1[0]) throw new fM("File is not a valid MRT.");
                return i.getUint32(1, !0);
            }
            parseHeader(e1) {
                const t1 = new Uint8Array(e1), i = this.getHeaderLength(e1);
                if (t1.length < i) throw new fM(`Expected header with length >= ${i} but got buffer of length ${t1.length}`);
                const n = function(e1) {
                    const t1 = {
                        headerLength: 0,
                        x: 0,
                        y: 0,
                        z: 0,
                        layers: []
                    };
                    let i;
                    for(; i = e1.nextField(void 0);)1 === i ? t1.headerLength = e1.readFixed32() : 2 === i ? t1.x = e1.readVarint() : 3 === i ? t1.y = e1.readVarint() : 4 === i ? t1.z = e1.readVarint() : 5 === i && t1.layers.push(CI(e1, e1.readVarint() + e1.pos));
                    return t1;
                }(new gM(t1.subarray(0, i)));
                if (!isNaN(this.x) && (this.x !== n.x || this.y !== n.y || this.z !== n.z)) throw new fM(`Invalid attempt to parse header ${n.z}/${n.x}/${n.y} for tile ${this.z}/${this.x}/${this.y}`);
                this.x = n.x, this.y = n.y, this.z = n.z;
                for (const e1 of n.layers)this.layers[e1.name] = new xM(e1, {
                    cacheSize: this._cacheSize
                });
                return this;
            }
            createDecodingTask(e1) {
                const t1 = [], i = this.getLayer(e1.layerName);
                for (let n of e1.blockIndices){
                    const r = i.dataIndex[n], o = r.firstByte - e1.firstByte, a = r.lastByte - e1.firstByte;
                    if (i._blocksInProgress.has(n)) continue;
                    const s = {
                        layerName: i.name,
                        firstByte: o,
                        lastByte: a,
                        pixelFormat: i.pixelFormat,
                        blockIndex: n,
                        blockShape: [
                            r.bands.length
                        ].concat(i.bandShape),
                        buffer: i.buffer,
                        codec: r.codec.codec,
                        filters: r.filters.map((e1)=>e1.filter)
                    };
                    i._blocksInProgress.add(n), t1.push(s);
                }
                return new vM(t1, ()=>{
                    t1.forEach((e1)=>i._blocksInProgress.delete(e1.blockIndex));
                }, (e1, n)=>{
                    if (t1.forEach((e1)=>i._blocksInProgress.delete(e1.blockIndex)), e1) throw e1;
                    n.forEach((e1)=>{
                        this.getLayer(e1.layerName).processDecodedData(e1);
                    });
                });
            }
        }
        class xM {
            constructor({ version: e1, name: t1, units: i, tileSize: n, pixelFormat: r, buffer: o, dataIndex: a }, s){
                if (this.version = e1, 1 !== this.version) throw new fM(`Cannot parse raster layer encoded with MRT version ${e1}`);
                this.name = t1, this.units = i, this.tileSize = n, this.buffer = o, this.pixelFormat = pM[r], this.dataIndex = a, this.bandShape = [
                    n + 2 * o,
                    n + 2 * o,
                    _M[this.pixelFormat]
                ], this._decodedBlocks = new II(s ? s.cacheSize : 5), this._blocksInProgress = new Set;
            }
            get dimension() {
                return _M[this.pixelFormat];
            }
            get cacheSize() {
                return this._decodedBlocks.capacity;
            }
            getBandList() {
                return this.dataIndex.map(({ bands: e1 })=>e1).flat();
            }
            processDecodedData(e1) {
                const t1 = e1.blockIndex.toString();
                this._decodedBlocks.get(t1) || this._decodedBlocks.put(t1, e1.data);
            }
            getBlockForBand(e1) {
                let t1 = 0;
                switch(typeof e1){
                    case "string":
                        for (const [i, n] of this.dataIndex.entries()){
                            for (const [r, o] of n.bands.entries())if (o === e1) return {
                                bandIndex: t1 + r,
                                blockIndex: i,
                                blockBandIndex: r
                            };
                            t1 += n.bands.length;
                        }
                        break;
                    case "number":
                        for (const [i, n] of this.dataIndex.entries()){
                            if (e1 >= t1 && e1 < t1 + n.bands.length) return {
                                bandIndex: e1,
                                blockIndex: i,
                                blockBandIndex: e1 - t1
                            };
                            t1 += n.bands.length;
                        }
                        break;
                    default:
                        throw new fM(`Invalid band \`${JSON.stringify(e1)}\`. Expected string or integer.`);
                }
                return {
                    blockIndex: -1,
                    blockBandIndex: -1
                };
            }
            getDataRange(e1) {
                let t1 = 1 / 0, i = -1 / 0;
                const n = [], r = new Set;
                for (const o of e1){
                    const { blockIndex: e1 } = this.getBlockForBand(o);
                    if (e1 < 0) throw new fM(`Invalid band: ${JSON.stringify(o)}`);
                    const a = this.dataIndex[e1];
                    n.includes(e1) || n.push(e1), r.add(e1), t1 = Math.min(t1, a.firstByte), i = Math.max(i, a.lastByte);
                }
                if (r.size > this.cacheSize) throw new fM(`Number of blocks to decode (${r.size}) exceeds cache size (${this.cacheSize}).`);
                return {
                    layerName: this.name,
                    firstByte: t1,
                    lastByte: i,
                    blockIndices: n
                };
            }
            hasBand(e1) {
                const { blockIndex: t1 } = this.getBlockForBand(e1);
                return t1 >= 0;
            }
            hasDataForBand(e1) {
                const { blockIndex: t1 } = this.getBlockForBand(e1);
                return t1 >= 0 && !!this._decodedBlocks.get(t1.toString());
            }
            getBandView(e1) {
                const { blockIndex: t1, blockBandIndex: i } = this.getBlockForBand(e1);
                if (t1 < 0) throw new fM(`Band not found: ${JSON.stringify(e1)}`);
                const n = this._decodedBlocks.get(t1.toString());
                if (!n) throw new fM(`Data for band ${JSON.stringify(e1)} of layer "${this.name}" not decoded.`);
                const r = this.dataIndex[t1], o = this.bandShape.reduce((e1, t1)=>e1 * t1, 1), a = i * o, s = n.subarray(a, a + o);
                return {
                    data: s,
                    bytes: new Uint8Array(s.buffer).subarray(s.byteOffset, s.byteOffset + s.byteLength),
                    tileSize: this.tileSize,
                    buffer: this.buffer,
                    pixelFormat: this.pixelFormat,
                    dimension: this.dimension,
                    offset: r.offset,
                    scale: r.scale
                };
            }
        }
        yM.setPbf = function(e1) {
            gM = e1;
        };
        class vM {
            constructor(e1, t1, i){
                this.tasks = e1, this._onCancel = t1, this._onComplete = i, this._finalized = !1;
            }
            cancel() {
                this._finalized || (this._onCancel(), this._finalized = !0);
            }
            complete(e1, t1) {
                this._finalized || (this._onComplete(e1, t1), this._finalized = !0);
            }
        }
        yM.performDecoding = function(e1, t1) {
            const i = new Uint8Array(e1);
            return Promise.all(t1.tasks.map((e1)=>{
                const { layerName: t1, firstByte: n, lastByte: r, pixelFormat: o, blockShape: a, blockIndex: s, filters: l, codec: c } = e1, u = i.subarray(n, r + 1), h = new Uint32Array(a[0] * a[1] * a[2]);
                let d;
                if ("gzip_data" !== c) throw new fM(`Unhandled codec: ${c}`);
                return d = (function(e1, t1) {
                    if (!globalThis.DecompressionStream && "gzip_data" === t1) return Promise.resolve((r = function(e1) {
                        31 == e1[0] && 139 == e1[1] && 8 == e1[2] || cM(6, "invalid gzip data");
                        var t1 = e1[3], i = 10;
                        4 & t1 && (i += 2 + (e1[10] | e1[11] << 8));
                        for(var n = (t1 >> 3 & 1) + (t1 >> 4 & 1); n > 0; n -= !e1[i++]);
                        return i + (2 & t1);
                    }(i = e1), r + 8 > i.length && cM(6, "invalid gzip data"), function(e1, t1, i, n) {
                        var r = e1.length;
                        if (!r || t1.f && !t1.l) return i || new NI(0);
                        var o = !i, a = o || 2 != t1.i, s = t1.i;
                        o && (i = new NI(3 * r));
                        var l = function(e1) {
                            var t1 = i.length;
                            if (e1 > t1) {
                                var n = new NI(Math.max(2 * t1, e1));
                                n.set(i), i = n;
                            }
                        }, c = t1.f || 0, u = t1.p || 0, h = t1.b || 0, d = t1.l, f = t1.d, p = t1.m, _ = t1.n, m = 8 * r;
                        do {
                            if (!d) {
                                c = oM(e1, u, 1);
                                var g = oM(e1, u + 1, 3);
                                if (u += 3, !g) {
                                    var y = e1[(z = sM(u) + 4) - 4] | e1[z - 3] << 8, x = z + y;
                                    if (x > r) {
                                        s && cM(0);
                                        break;
                                    }
                                    a && l(h + y), i.set(e1.subarray(z, x), h), t1.b = h += y, t1.p = u = 8 * x, t1.f = c;
                                    continue;
                                }
                                if (1 == g) d = iM, f = nM, p = 9, _ = 5;
                                else if (2 == g) {
                                    var v = oM(e1, u, 31) + 257, b = oM(e1, u + 10, 15) + 4, w = v + oM(e1, u + 5, 31) + 1;
                                    u += 14;
                                    for(var A = new NI(w), E = new NI(19), I = 0; I < b; ++I)E[HI[I]] = oM(e1, u + 3 * I, 7);
                                    u += 3 * b;
                                    var M = rM(E), S = (1 << M) - 1, T = QI(E, M);
                                    for(I = 0; I < w;){
                                        var z, R = T[oM(e1, u, S)];
                                        if (u += 15 & R, (z = R >> 4) < 16) A[I++] = z;
                                        else {
                                            var P = 0, D = 0;
                                            for(16 == z ? (D = 3 + oM(e1, u, 3), u += 2, P = A[I - 1]) : 17 == z ? (D = 3 + oM(e1, u, 7), u += 3) : 18 == z && (D = 11 + oM(e1, u, 127), u += 7); D--;)A[I++] = P;
                                        }
                                    }
                                    var F = A.subarray(0, v), C = A.subarray(v);
                                    p = rM(F), _ = rM(C), d = QI(F, p), f = QI(C, _);
                                } else cM(1);
                                if (u > m) {
                                    s && cM(0);
                                    break;
                                }
                            }
                            a && l(h + 131072);
                            for(var O = (1 << p) - 1, L = (1 << _) - 1, B = u;; B = u){
                                var V = (P = d[aM(e1, u) & O]) >> 4;
                                if ((u += 15 & P) > m) {
                                    s && cM(0);
                                    break;
                                }
                                if (P || cM(2), V < 256) i[h++] = V;
                                else {
                                    if (256 == V) {
                                        B = u, d = null;
                                        break;
                                    }
                                    var N = V - 254;
                                    V > 264 && (N = oM(e1, u, (1 << (j = jI[I = V - 257])) - 1) + WI[I], u += j);
                                    var k = f[aM(e1, u) & L], U = k >> 4;
                                    if (k || cM(3), u += 15 & k, C = XI[U], U > 3) {
                                        var j = GI[U];
                                        C += aM(e1, u) & (1 << j) - 1, u += j;
                                    }
                                    if (u > m) {
                                        s && cM(0);
                                        break;
                                    }
                                    a && l(h + 131072);
                                    var G = h + N;
                                    if (h < C) {
                                        var H = 0 - C, $ = Math.min(C, G);
                                        for(H + h < 0 && cM(3); h < $; ++h)i[h] = n[H + h];
                                    }
                                    for(; h < G; ++h)i[h] = i[h - C];
                                }
                            }
                            t1.l = d, t1.p = B, t1.b = h, t1.f = c, d && (c = 1, t1.m = p, t1.d = f, t1.n = _);
                        }while (!c);
                        return h != i.length && o ? function(e1, t1, i) {
                            return (null == i || i > e1.length) && (i = e1.length), new NI(e1.subarray(0, i));
                        }(i, 0, h) : i.subarray(0, h);
                    }(i.subarray(r, -8), {
                        i: 2
                    }, new NI(function(e1) {
                        var t1 = e1.length;
                        return (e1[t1 - 4] | e1[t1 - 3] << 8 | e1[t1 - 2] << 16 | e1[t1 - 1] << 24) >>> 0;
                    }(i)), n)));
                    var i, n, r;
                    const o = dM[t1];
                    if (!o) throw new Error(`Unhandled codec: ${t1}`);
                    const a = new globalThis.DecompressionStream(o);
                    return new Response(new Blob([
                        e1
                    ]).stream().pipeThrough(a)).arrayBuffer().then((e1)=>new Uint8Array(e1));
                })(u, c).then((e1)=>((function(e1, t1) {
                        let i;
                        for(; i = e1.nextField();)if (2 === i) OI(e1, e1.readVarint() + e1.pos, t1);
                        else if (3 === i) throw new Error("Not implemented");
                    })(new gM(e1), h), new mM[o](h.buffer))), d.then((e1)=>{
                    for(let t1 = l.length - 1; t1 >= 0; t1--)switch(l[t1]){
                        case "delta_filter":
                            LI(e1, a);
                            break;
                        case "zigzag_filter":
                            BI(e1);
                            break;
                        case "bitshuffle_filter":
                            VI(e1, o);
                            break;
                        default:
                            throw new fM(`Unhandled filter "${l[t1]}"`);
                    }
                    return {
                        layerName: t1,
                        blockIndex: s,
                        data: e1
                    };
                }).catch((e1)=>{
                    throw e1;
                });
            }));
        }, Ya(vM, "MRTDecodingBatch", {
            omit: [
                "_onCancel",
                "_onComplete"
            ]
        }), Ya(yM, "MapboxRasterTile"), Ya(xM, "MapboxRasterLayer", {
            omit: [
                "_blocksInProgress"
            ]
        });
        const bM = new Map, wM = new Map;
        class AM {
            constructor(e1){
                this.size = e1, this.minimums = [], this.maximums = [], this.leaves = [];
            }
            isLeaf(e1, t1) {
                return this.leaves[this.toIdx(e1, t1)];
            }
            toIdx(e1, t1) {
                return t1 * this.size + e1;
            }
        }
        function EM(e1, t1, i, n) {
            let r = 0, o = Number.MAX_VALUE;
            for(let a = 0; a < 3; a++)if (Math.abs(n[a]) < 1e-15) {
                if (i[a] < e1[a] || i[a] > t1[a]) return null;
            } else {
                const s = 1 / n[a];
                let l = (e1[a] - i[a]) * s, c = (t1[a] - i[a]) * s;
                if (l > c) {
                    const e1 = l;
                    l = c, c = e1;
                }
                if (l > r && (r = l), c < o && (o = c), r > o) return null;
            }
            return r;
        }
        function IM(e1, t1, i, n, r, o, a, s, l, c, u) {
            const h = n - e1, d = r - t1, f = o - i, p = a - e1, _ = s - t1, m = l - i, g = u[1] * m - u[2] * _, y = u[2] * p - u[0] * m, x = u[0] * _ - u[1] * p, v = h * g + d * y + f * x;
            if (Math.abs(v) < 1e-15) return null;
            const b = 1 / v, w = c[0] - e1, A = c[1] - t1, E = c[2] - i, I = (w * g + A * y + E * x) * b;
            if (I < 0 || I > 1) return null;
            const M = A * f - E * d, S = E * h - w * f, T = w * d - A * h, z = (u[0] * M + u[1] * S + u[2] * T) * b;
            return z < 0 || I + z > 1 ? null : (p * M + _ * S + m * T) * b;
        }
        function MM(e1, t1, i, n, r, o, a, s, l) {
            const c = 1 << i, u = o - n, h = a - r, d = (e1 + 1) / c * u + n, f = (t1 + 0) / c * h + r, p = (t1 + 1) / c * h + r;
            s[0] = (e1 + 0) / c * u + n, s[1] = f, l[0] = d, l[1] = p;
        }
        class SM {
            constructor(e1){
                this.nodeCount = 0, this.dem = e1;
                const t1 = this.dem ? function(e1) {
                    const t1 = e1.dim, i = Math.ceil(Math.log2(t1 / 8)), n = [];
                    let r = Math.ceil(Math.pow(2, i));
                    const o = (e1, t1, i, n, r)=>{
                        const o = n ? 1 : 0, a = (e1 + 1) * i - o, s = t1 * i, l = (t1 + 1) * i - o;
                        r[0] = e1 * i, r[1] = s, r[2] = a, r[3] = l;
                    };
                    let a = new AM(r);
                    const s = 1 / r, { floatView: l, stride: c } = e1, u = [];
                    for(let i = 0; i < r * r; i++){
                        const n = Math.floor(i / r), h = i % r;
                        o(h, n, s, !1, u);
                        const d = zM(u[0], u[1], e1), f = zM(u[2], u[1], e1), p = zM(u[2], u[3], e1), _ = zM(u[0], u[3], e1), m = Math.min(d, f, p, _), g = Math.max(0, 8 * h - 1), y = Math.min(t1 - 1, 8 * (h + 1)), x = Math.max(0, 8 * n - 1), v = Math.min(t1 - 1, 8 * (n + 1));
                        let b = -1 / 0;
                        for(let e1 = x; e1 <= v; e1++){
                            const t1 = (e1 + 1) * c;
                            for(let e1 = g; e1 <= y; e1++){
                                const i = l[t1 + e1 + 1];
                                i > b && (b = i);
                            }
                        }
                        a.minimums.push(m), a.maximums.push(b), a.leaves.push(1);
                    }
                    for(n.push(a), r /= 2; r >= 1; r /= 2){
                        const e1 = n.at(-1);
                        a = new AM(r);
                        for(let t1 = 0; t1 < r * r; t1++){
                            o(t1 % r, Math.floor(t1 / r), 2, !0, u);
                            const i = e1.toIdx(u[0], u[1]), n = e1.toIdx(u[2], u[1]), s = e1.toIdx(u[2], u[3]), l = e1.toIdx(u[0], u[3]), { minimums: c, maximums: h, leaves: d } = e1, f = Math.min(c[i], c[n], c[s], c[l]), p = Math.max(h[i], h[n], h[s], h[l]), _ = d[i] && d[n] && d[s] && d[l];
                            a.maximums.push(p), a.minimums.push(f), a.leaves.push(p - f <= 5 && _ ? 1 : 0);
                        }
                        n.push(a);
                    }
                    return n;
                }(this.dem) : [], i = t1.reduce((e1, t1)=>e1 + t1.size * t1.size, 0);
                if (this.maximums = new Float32Array(i), this.minimums = new Float32Array(i), this.leaves = new Uint8Array(i), this.childOffsets = new Uint32Array(i), !this.dem) return;
                const n = t1.length - 1, r = t1[n];
                this._addNode(r.minimums[0], r.maximums[0], r.leaves[0]), this._construct(t1, 0, 0, n, 0), this.maximums = this.maximums.subarray(0, this.nodeCount), this.minimums = this.minimums.subarray(0, this.nodeCount), this.leaves = this.leaves.subarray(0, this.nodeCount), this.childOffsets = this.childOffsets.subarray(0, this.nodeCount);
            }
            raycastRoot(e1, t1, i, n, r, o, a = 1) {
                return EM([
                    e1,
                    t1,
                    -100
                ], [
                    i,
                    n,
                    this.maximums[0] * a
                ], r, o);
            }
            raycast(e1, t1, i, n, r, o, a = 1) {
                if (!this.nodeCount) return null;
                const s = this.raycastRoot(e1, t1, i, n, r, o, a);
                if (null == s) return null;
                const l = [], c = [], u = [], h = [], d = [
                    {
                        idx: 0,
                        t: s,
                        nodex: 0,
                        nodey: 0,
                        depth: 0
                    }
                ];
                for(; d.length > 0;){
                    const { idx: s, t: f, nodex: p, nodey: _, depth: m } = d.pop();
                    if (this.leaves[s]) {
                        MM(p, _, m, e1, t1, i, n, u, h);
                        const s = 1 << m, l = p / s, c = (p + 1) / s, d = _ / s, g = (_ + 1) / s, { dim: y, floatView: x, stride: v } = this.dem, b = Math.floor(l * y), w = Math.ceil(c * y), A = Math.floor(d * y), E = w - b, I = Math.ceil(g * y) - A;
                        if (E <= 0 || I <= 0) continue;
                        const M = u[0], S = u[1], T = (h[0] - M) / E, z = (h[1] - S) / I, R = Math.max(0, f), P = r[0] + o[0] * R, D = r[1] + o[1] * R, F = Math.abs(o[0]) > 1e-10, C = Math.abs(o[1]) > 1e-10, O = o[0] >= 0 ? 1 : -1, L = o[1] >= 0 ? 1 : -1;
                        let B = Math.max(0, Math.min(E - 1, Math.floor((P - M) / T))), V = Math.max(0, Math.min(I - 1, Math.floor((D - S) / z)));
                        const N = F ? Math.abs(T / o[0]) : Number.MAX_VALUE, U = C ? Math.abs(z / o[1]) : Number.MAX_VALUE;
                        let j = F ? R + (M + (o[0] >= 0 ? B + 1 : B) * T - P) / o[0] : Number.MAX_VALUE, G = C ? R + (S + (o[1] >= 0 ? V + 1 : V) * z - D) / o[1] : Number.MAX_VALUE;
                        const H = (e1, t1)=>x[(t1 + 1) * v + e1 + 1] * a;
                        let $ = H(b + B, A + V), Z = H(b + B + 1, A + V), W = H(b + B, A + V + 1), q = H(b + B + 1, A + V + 1), X = null;
                        for(let e1 = 0; e1 < E + I; e1++){
                            const e1 = Math.min(j, G);
                            if (o[2] >= 0 || r[2] + o[2] * e1 <= Math.max($, Z, W, q)) {
                                const e1 = M + B * T, t1 = e1 + T, i = S + V * z, n = i + z, a = IM(t1, i, Z, e1, i, $, e1, n, W, r, o), s = IM(e1, n, W, t1, n, q, t1, i, Z, r, o);
                                null != a && a >= 0 && (null === X || a < X) && (X = a), null != s && s >= 0 && (null === X || s < X) && (X = s);
                            }
                            const t1 = j < G;
                            if (t1 ? (B += O, j += N) : (V += L, G += U), B < 0 || B >= E || V < 0 || V >= I) break;
                            if (null !== X && e1 > X) break;
                            t1 ? O > 0 ? ($ = Z, W = q, Z = H(b + B + 1, A + V), q = H(b + B + 1, A + V + 1)) : (Z = $, q = W, $ = H(b + B, A + V), W = H(b + B, A + V + 1)) : L > 0 ? ($ = W, Z = q, W = H(b + B, A + V + 1), q = H(b + B + 1, A + V + 1)) : (W = $, q = Z, $ = H(b + B, A + V), Z = H(b + B + 1, A + V));
                        }
                        if (null !== X) return X || 0;
                        const Y = k([], r, o, f), J = (Y[0] - u[0]) / (h[0] - u[0]), K = (Y[1] - u[1]) / (h[1] - u[1]), Q = zM(l, d, this.dem) * a, ee = zM(c, d, this.dem) * a, te = zM(c, g, this.dem) * a;
                        if (TM(Q, ee, zM(l, g, this.dem) * a, te, J, K) >= Y[2]) return f;
                        continue;
                    }
                    let g = 0;
                    for(let d = 0; d < 4; d++){
                        MM((p << 1) + (1 & d), (_ << 1) + (d >> 1), m + 1, e1, t1, i, n, u, h), u[2] = -100, h[2] = this.maximums[this.childOffsets[s] + d] * a;
                        const f = EM(u, h, r, o);
                        if (null != f) {
                            const e1 = f;
                            l[d] = e1;
                            let t1 = !1;
                            for(let i = 0; i < g && !t1; i++)e1 >= l[c[i]] && (c.splice(i, 0, d), t1 = !0);
                            t1 || (c[g] = d), g++;
                        }
                    }
                    for(let e1 = 0; e1 < g; e1++){
                        const t1 = c[e1];
                        d.push({
                            idx: this.childOffsets[s] + t1,
                            t: l[t1],
                            nodex: (p << 1) + (1 & t1),
                            nodey: (_ << 1) + (t1 >> 1),
                            depth: m + 1
                        });
                    }
                }
                return null;
            }
            _addNode(e1, t1, i) {
                const n = this.nodeCount++;
                return this.minimums[n] = e1, this.maximums[n] = t1, this.leaves[n] = i, n;
            }
            _construct(e1, t1, i, n, r) {
                if (1 === e1[n].isLeaf(t1, i)) return;
                this.childOffsets[r] || (this.childOffsets[r] = this.nodeCount);
                const o = n - 1, a = e1[o];
                let s = 0, l = 0;
                for(let e1 = 0; e1 < 4; e1++){
                    const n = a.toIdx(2 * t1 + (1 & e1), 2 * i + (e1 >> 1)), r = a.leaves[n], o = this._addNode(a.minimums[n], a.maximums[n], r);
                    r && (s |= 1 << e1), l || (l = o);
                }
                for(let n = 0; n < 4; n++)s & 1 << n || this._construct(e1, 2 * t1 + (1 & n), 2 * i + (n >> 1), o, l + n);
            }
        }
        function TM(e1, t1, i, n, r, o) {
            return hn(hn(e1, i, o), hn(t1, n, o), r);
        }
        function zM(e1, t1, i) {
            const n = i.dim, r = tt(e1 * n - .5, 0, n - 1), o = tt(t1 * n - .5, 0, n - 1), a = Math.floor(r), s = Math.floor(o), l = Math.min(a + 1, n - 1), c = Math.min(s + 1, n - 1);
            return TM(i.get(a, s), i.get(l, s), i.get(a, c), i.get(l, c), r - a, o - s);
        }
        const RM = {
            mapbox: [
                6553.6,
                25.6,
                .1,
                1e4
            ],
            terrarium: [
                256,
                1,
                1 / 256,
                32768
            ]
        };
        function PM(e1, t1, i) {
            return (256 * e1 * 256 + 256 * t1 + i) / 10 - 1e4;
        }
        function DM(e1, t1, i) {
            return 256 * e1 + t1 + i / 256 - 32768;
        }
        class FM {
            get tree() {
                return this._tree || this._buildQuadTree(), this._tree;
            }
            constructor(e1, t1, i, n = !1){
                if (this.uid = e1, t1.height !== t1.width) throw new RangeError("DEM tiles must be square");
                if (i && "mapbox" !== i && "terrarium" !== i) return void _t(`"${i}" is not a valid encoding type. Valid types include "mapbox" and "terrarium".`);
                this.stride = t1.height;
                const r = this.dim = t1.height - 2, o = new Uint32Array(t1.data.buffer);
                if (this.pixels = new Uint8Array(t1.data.buffer), this.floatView = new Float32Array(t1.data.buffer), this.borderReady = n, this._modifiedForSources = {}, !n) {
                    for(let e1 = 0; e1 < r; e1++)o[this._idx(-1, e1)] = o[this._idx(0, e1)], o[this._idx(r, e1)] = o[this._idx(r - 1, e1)], o[this._idx(e1, -1)] = o[this._idx(e1, 0)], o[this._idx(e1, r)] = o[this._idx(e1, r - 1)];
                    o[this._idx(-1, -1)] = o[this._idx(0, 0)], o[this._idx(r, -1)] = o[this._idx(r - 1, 0)], o[this._idx(-1, r)] = o[this._idx(0, r - 1)], o[this._idx(r, r)] = o[this._idx(r - 1, r - 1)];
                }
                const a = "terrarium" === i ? DM : PM;
                for(let e1 = 0; e1 < o.length; ++e1){
                    const t1 = 4 * e1;
                    this.floatView[e1] = a(this.pixels[t1], this.pixels[t1 + 1], this.pixels[t1 + 2]);
                }
                this._timestamp = Vt.now();
            }
            _buildQuadTree() {
                this._tree = new SM(this);
            }
            get(e1, t1, i = !1) {
                i && (e1 = tt(e1, -1, this.dim), t1 = tt(t1, -1, this.dim));
                const n = this._idx(e1, t1);
                return this.floatView[n];
            }
            set(e1, t1, i) {
                const n = this._idx(e1, t1), r = this.floatView[n];
                return this.floatView[n] = i, i - r;
            }
            static getUnpackVector(e1) {
                return RM[e1];
            }
            _idx(e1, t1) {
                if (e1 < -1 || e1 >= this.dim + 1 || t1 < -1 || t1 >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
                return (t1 + 1) * this.stride + (e1 + 1);
            }
            static pack(e1, t1) {
                const i = [
                    0,
                    0,
                    0,
                    0
                ], n = FM.getUnpackVector(t1);
                let r = Math.floor((e1 + n[3]) / n[2]);
                return i[2] = r % 256, r = Math.floor(r / 256), i[1] = r % 256, r = Math.floor(r / 256), i[0] = r, i;
            }
            getPixels() {
                return new Md({
                    width: this.stride,
                    height: this.stride
                }, this.pixels);
            }
            backfillBorder(e1, t1, i) {
                if (this.dim !== e1.dim) throw new Error("dem dimension mismatch");
                let n = t1 * this.dim, r = t1 * this.dim + this.dim, o = i * this.dim, a = i * this.dim + this.dim;
                switch(t1){
                    case -1:
                        n = r - 1;
                        break;
                    case 1:
                        r = n + 1;
                }
                switch(i){
                    case -1:
                        o = a - 1;
                        break;
                    case 1:
                        a = o + 1;
                }
                const s = -t1 * this.dim, l = -i * this.dim;
                for(let t1 = o; t1 < a; t1++)for(let i = n; i < r; i++){
                    const n = 4 * this._idx(i, t1), r = 4 * this._idx(i + s, t1 + l);
                    this.pixels[n + 0] = e1.pixels[r + 0], this.pixels[n + 1] = e1.pixels[r + 1], this.pixels[n + 2] = e1.pixels[r + 2], this.pixels[n + 3] = e1.pixels[r + 3];
                }
            }
            onDeserialize() {
                this._tree && (this._tree.dem = this);
            }
        }
        Ya(FM, "DEMData"), Ya(SM, "DemMinMaxQuadTree", {
            omit: [
                "dem"
            ]
        });
        const CM = [
            Int8Array,
            Uint8Array,
            Uint8ClampedArray,
            Int16Array,
            Uint16Array,
            Int32Array,
            Uint32Array,
            Float32Array,
            Float64Array
        ], OM = new Uint32Array(96);
        class LM {
            static from(e1) {
                if (!e1 || void 0 === e1.byteLength || e1.buffer) throw new Error("Data must be an instance of ArrayBuffer or SharedArrayBuffer.");
                const [t1, i] = new Uint8Array(e1, 0, 2);
                if (219 !== t1) throw new Error("Data does not appear to be in a KDBush format.");
                const n = i >> 4;
                if (1 !== n) throw new Error(`Got v${n} data when expected v1.`);
                const r = CM[15 & i];
                if (!r) throw new Error("Unrecognized array type.");
                const [o] = new Uint16Array(e1, 2, 1), [a] = new Uint32Array(e1, 4, 1);
                return new LM(a, o, r, void 0, e1);
            }
            constructor(e1, t1 = 64, i = Float64Array, n = ArrayBuffer, r){
                if (isNaN(e1) || e1 < 0) throw new Error(`Unexpected numItems value: ${e1}.`);
                this.numItems = +e1, this.nodeSize = Math.min(Math.max(+t1, 2), 65535), this.ArrayType = i, this.IndexArrayType = e1 < 65536 ? Uint16Array : Uint32Array;
                const o = CM.indexOf(this.ArrayType), a = 2 * e1 * this.ArrayType.BYTES_PER_ELEMENT, s = e1 * this.IndexArrayType.BYTES_PER_ELEMENT, l = (8 - s % 8) % 8;
                if (o < 0) throw new Error(`Unexpected typed array class: ${i}.`);
                if (r) this.data = r, this.ids = new this.IndexArrayType(r, 8, e1), this.coords = new i(r, 8 + s + l, 2 * e1), this._pos = 2 * e1, this._finished = !0;
                else {
                    const r = this.data = new n(8 + a + s + l);
                    this.ids = new this.IndexArrayType(r, 8, e1), this.coords = new i(r, 8 + s + l, 2 * e1), this._pos = 0, this._finished = !1, new Uint8Array(r, 0, 2).set([
                        219,
                        16 + o
                    ]), new Uint16Array(r, 2, 1)[0] = t1, new Uint32Array(r, 4, 1)[0] = e1;
                }
            }
            add(e1, t1) {
                const i = this._pos >> 1;
                return this.ids[i] = i, this.coords[this._pos++] = e1, this.coords[this._pos++] = t1, i;
            }
            finish() {
                const e1 = this._pos >> 1;
                if (e1 !== this.numItems) throw new Error(`Added ${e1} items when expected ${this.numItems}.`);
                return BM(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
            }
            range(e1, t1, i, n) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: r, coords: o, nodeSize: a } = this;
                OM[0] = 0, OM[1] = r.length - 1, OM[2] = 0;
                let s = 3;
                const l = [];
                for(; s > 0;){
                    const c = OM[--s], u = OM[--s], h = OM[--s];
                    if (u - h <= a) {
                        for(let a = h; a <= u; a++){
                            const s = o[2 * a], c = o[2 * a + 1];
                            s >= e1 && s <= i && c >= t1 && c <= n && l.push(r[a]);
                        }
                        continue;
                    }
                    const d = h + u >> 1, f = o[2 * d], p = o[2 * d + 1];
                    f >= e1 && f <= i && p >= t1 && p <= n && l.push(r[d]), (0 === c ? e1 <= f : t1 <= p) && (OM[s++] = h, OM[s++] = d - 1, OM[s++] = 1 - c), (0 === c ? i >= f : n >= p) && (OM[s++] = d + 1, OM[s++] = u, OM[s++] = 1 - c);
                }
                return l;
            }
            within(e1, t1, i) {
                const n = [];
                return this.withinInto(e1, t1, i, n), n;
            }
            withinInto(e1, t1, i, n) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: r, coords: o, nodeSize: a } = this;
                OM[0] = 0, OM[1] = r.length - 1, OM[2] = 0;
                let s = 3, l = 0;
                const c = i * i;
                for(; s > 0;){
                    const u = OM[--s], h = OM[--s], d = OM[--s];
                    if (h - d <= a) {
                        for(let i = d; i <= h; i++)UM(o[2 * i], o[2 * i + 1], e1, t1) <= c && (n[l++] = r[i]);
                        continue;
                    }
                    const f = d + h >> 1, p = o[2 * f], _ = o[2 * f + 1];
                    UM(p, _, e1, t1) <= c && (n[l++] = r[f]), (0 === u ? e1 - i <= p : t1 - i <= _) && (OM[s++] = d, OM[s++] = f - 1, OM[s++] = 1 - u), (0 === u ? e1 + i >= p : t1 + i >= _) && (OM[s++] = f + 1, OM[s++] = h, OM[s++] = 1 - u);
                }
                return l;
            }
        }
        function BM(e1, t1, i, n, r, o) {
            if (r - n <= i) return;
            const a = n + r >> 1;
            VM(e1, t1, a, n, r, o), BM(e1, t1, i, n, a - 1, 1 - o), BM(e1, t1, i, a + 1, r, 1 - o);
        }
        function VM(e1, t1, i, n, r, o) {
            for(; r > n;){
                if (r - n > 600) {
                    const a = r - n + 1, s = i - n + 1, l = Math.log(a), c = .5 * Math.exp(2 * l / 3), u = .5 * Math.sqrt(l * c * (a - c) / a) * (s - a / 2 < 0 ? -1 : 1);
                    VM(e1, t1, i, Math.max(n, Math.floor(i - s * c / a + u)), Math.min(r, Math.floor(i + (a - s) * c / a + u)), o);
                }
                const a = t1[2 * i + o];
                let s = n, l = r;
                for(NM(e1, t1, n, i), t1[2 * r + o] > a && NM(e1, t1, n, r); s < l;){
                    for(NM(e1, t1, s, l), s++, l--; t1[2 * s + o] < a;)s++;
                    for(; t1[2 * l + o] > a;)l--;
                }
                t1[2 * n + o] === a ? NM(e1, t1, n, l) : (l++, NM(e1, t1, l, r)), l <= i && (n = l + 1), i <= l && (r = l - 1);
            }
        }
        function NM(e1, t1, i, n) {
            kM(e1, i, n), kM(t1, 2 * i, 2 * n), kM(t1, 2 * i + 1, 2 * n + 1);
        }
        function kM(e1, t1, i) {
            const n = e1[t1];
            e1[t1] = e1[i], e1[i] = n;
        }
        function UM(e1, t1, i, n) {
            const r = e1 - i, o = t1 - n;
            return r * r + o * o;
        }
        t1.$ = function(e1, t1) {
            const i = cp(t1.zoom);
            if (0 === i) return Xf(e1);
            const n = Qf(e1), r = ep(n), o = ur(n.getWest()) * t1.worldSize, a = ur(n.getEast()) * t1.worldSize, s = hr(n.getNorth()) * t1.worldSize, l = hr(n.getSouth()) * t1.worldSize, c = [
                o,
                s,
                0
            ], u = [
                a,
                s,
                0
            ], h = [
                o,
                l,
                0
            ], d = [
                a,
                l,
                0
            ], f = p([], t1.globeMatrix);
            return X(c, c, f), X(u, u, f), X(h, h, f), X(d, d, f), r[0] = Yf(r[0], h, i), r[1] = Yf(r[1], d, i), r[2] = Yf(r[2], u, i), r[3] = Yf(r[3], c, i), Nf.fromPoints(r);
        }, t1.A = Pa, t1.B = Ta, t1.C = fn, t1.D = Ra, t1.E = an, t1.F = Ua, t1.G = Xs, t1.H = $a, t1.I = sn, t1.J = Fr, t1.K = Or, t1.L = II, t1.M = Dr, t1.N = sr, t1.O = ir, t1.P = Re, t1.Q = er, t1.R = oi, t1.S = Ys, t1.T = X_, t1.U = /^(.*)-use-theme$/, t1.V = /^(.*)-transition$/, t1.W = Da, t1.X = za, t1.Y = Pe, t1.Z = u, t1._ = cp, t1.a = async function(e1, t1) {
            e1.headers || (e1.headers = {}), e1.headers.accept = "image/webp,*/*";
            const i = await function(e1) {
                return new Promise((t1, i)=>{
                    if (e1 && e1.aborted) return void i(e1.reason);
                    const n = ()=>{
                        const e1 = mi.shift();
                        e1 ? e1() : gi--;
                    };
                    if (gi < kt.MAX_PARALLEL_IMAGE_REQUESTS) return gi++, void t1(n);
                    const r = ()=>{
                        e1 && e1.removeEventListener("abort", o), t1(n);
                    }, o = ()=>{
                        const t1 = mi.indexOf(r);
                        -1 !== t1 && mi.splice(t1, 1), i(e1.reason);
                    };
                    e1 && e1.addEventListener("abort", o), mi.push(r);
                });
            }(t1);
            try {
                const { data: i, headers: n } = await pi(e1, t1);
                let r;
                try {
                    r = await createImageBitmap(new Blob([
                        new Uint8Array(i)
                    ], {
                        type: "image/png"
                    }));
                } catch (e1) {
                    throw new Error(`Could not load image because of ${e1.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`, {
                        cause: e1
                    });
                }
                return t1 && t1.throwIfAborted(), {
                    data: r,
                    headers: n
                };
            } finally{
                i();
            }
        }, t1.a$ = iI, t1.a0 = op, t1.a1 = _, t1.a2 = c, t1.a3 = lA, t1.a4 = rA, t1.a5 = hA, t1.a6 = OA, t1.a7 = sA, t1.a8 = Wu, t1.a9 = Zu, t1.aA = function(e1, t1, i) {
            const n = mc.fromLngLat(t1), r = i.elevation ? i.elevation.getAtPointOrZero(n) : 0;
            return y_(e1, n.x, n.y, r, i);
        }, t1.aB = function(e1, t1, i, n, r, o, a) {
            const s = [
                [
                    i,
                    n,
                    0
                ],
                [
                    r,
                    n,
                    0
                ],
                [
                    r,
                    o,
                    0
                ],
                [
                    i,
                    o,
                    0
                ]
            ];
            let l = Number.MAX_VALUE, c = -Number.MAX_VALUE;
            for (const e1 of s){
                const i = P(X([], e1, t1));
                l = Math.min(l, i), c = Math.max(c, i);
            }
            return [
                m_(e1, l, a.pitch),
                m_(e1, c, a.pitch)
            ];
        }, t1.aC = gn, t1.aD = y_, t1.aE = __, t1.aF = Ye, t1.aG = function() {
            return ot++;
        }, t1.aH = class {
            constructor(e1, t1, i){
                this.target = e1, this.parent = t1, this.mapId = i, this.pendingResponses = new Map, ct([
                    "receive"
                ], this), this.target.addEventListener("message", this.receive, !1), this.scheduler = new TI;
            }
            send(e1, t1, i) {
                const { signal: n, targetMapId: r, metadata: o } = i || {}, a = Math.round(1e18 * Math.random()).toString(36).substring(0, 10), s = new Set;
                return n && n.aborted ? Promise.reject(n.reason) : (this.target.postMessage({
                    id: a,
                    type: e1,
                    targetMapId: r,
                    sourceMapId: this.mapId,
                    data: es(t1, s)
                }, [
                    ...s
                ]), new Promise((e1, t1)=>{
                    const i = {
                        resolve: e1,
                        reject: t1,
                        metadata: o || zI
                    };
                    if (n) {
                        const e1 = ()=>{
                            this.pendingResponses.delete(a), t1(n.reason);
                        };
                        n.addEventListener("abort", e1, {
                            once: !0
                        }), i.detach = ()=>n.removeEventListener("abort", e1);
                    }
                    this.pendingResponses.set(a, i);
                }));
            }
            notify(e1, t1, i) {
                const { targetMapId: n } = i || {}, r = new Set;
                this.target.postMessage({
                    type: e1,
                    targetMapId: n,
                    sourceMapId: this.mapId,
                    data: es(t1, r)
                }, [
                    ...r
                ]);
            }
            sendCancelable(e1, t1, i, n) {
                const r = new AbortController;
                return this.send(e1, t1, {
                    ...i,
                    signal: r.signal
                }).then((e1)=>n(null, e1)).catch((e1)=>{
                    "AbortError" !== e1.name && n(e1);
                }), r;
            }
            getWorkerSourceActor(e1) {
                return {
                    scheduler: this.scheduler,
                    send: (t1, i, n)=>this.send(t1, i, {
                            ...n,
                            targetMapId: e1
                        }),
                    notify: (t1, i)=>{
                        this.notify(t1, i, {
                            targetMapId: e1
                        });
                    },
                    sendCancelable: (t1, i, n, r)=>this.sendCancelable(t1, i, {
                            ...n,
                            targetMapId: e1
                        }, r)
                };
            }
            receive(e1) {
                const t1 = e1.data;
                if (!t1) return;
                const i = t1.id;
                if (!t1.targetMapId || this.mapId === t1.targetMapId) {
                    if (xt(self)) {
                        const e1 = this.pendingResponses.get(i);
                        this.scheduler.add(()=>{
                            this.processTask(i, t1);
                        }, e1 && e1.metadata || zI);
                    } else this.processTask(i, t1);
                }
            }
            async processTask(e1, t1) {
                if ("<response>" === t1.type) {
                    const i = this.pendingResponses.get(e1);
                    if (this.pendingResponses.delete(e1), i) {
                        i.detach && i.detach();
                        try {
                            t1.error ? i.reject(ts(t1.error)) : i.resolve(ts(t1.data));
                        } catch (e1) {
                            i.reject(e1);
                        }
                    }
                    return;
                }
                const i = new Set, n = ts(t1.data);
                try {
                    let r;
                    if (this.parent[t1.type]) r = await this.parent[t1.type](t1.sourceMapId, n);
                    else {
                        if (!this.parent.getWorkerSource) throw new Error(`Could not find function ${t1.type}`);
                        {
                            const e1 = t1.type.split("."), { source: i, scope: o } = n, a = this.parent.getWorkerSource(t1.sourceMapId, {
                                type: e1[0],
                                source: i,
                                scope: o
                            });
                            r = await a[e1[1]](n);
                        }
                    }
                    if (!e1) return;
                    this.target.postMessage({
                        id: e1,
                        type: "<response>",
                        sourceMapId: this.mapId,
                        error: null,
                        data: es(r, i)
                    }, [
                        ...i
                    ]);
                } catch (t1) {
                    this.target.postMessage({
                        id: e1,
                        type: "<response>",
                        sourceMapId: this.mapId,
                        error: es(t1),
                        data: null
                    }, []);
                }
            }
            remove() {
                for (const e1 of this.pendingResponses.values())e1.detach && e1.detach(), e1.reject(new DOMException("Actor removed", "AbortError"));
                this.pendingResponses.clear(), this.scheduler.remove(), this.target.removeEventListener("message", this.receive, !1);
            }
        }, t1.aI = class {
            constructor(e1){
                this.specification = e1;
            }
            possiblyEvaluate(e1, t1) {
                return function([e1, t1]) {
                    const i = gt([
                        1,
                        e1,
                        t1
                    ]);
                    return {
                        x: i.x,
                        y: i.y,
                        z: i.z
                    };
                }(e1.expression.evaluate(t1));
            }
            interpolate(e1, t1, i) {
                return {
                    x: hn(e1.x, t1.x, i),
                    y: hn(e1.y, t1.y, i),
                    z: hn(e1.z, t1.z, i)
                };
            }
        }, t1.aJ = xI, t1.aK = Vf, t1.aL = fc, t1.aM = bp, t1.aN = Dv, t1.aO = Hv, t1.aP = FA, t1.aQ = oI, t1.aR = Un, t1.aS = (e1, t1, i, n, r, o, a, s, l, c, u, h, d, f, p, _, m, g, y = !1)=>{
            const x = eI(e1, t1, i, n, r, o, a, s, c, u, h, d, f, p, _, m, 1, [
                0,
                0,
                0
            ], [
                0,
                0,
                1
            ], y), v = {
                u_height_factor: -Math.pow(2, s.overscaledZ) / l.tileSize / 8
            };
            return Object.assign(x, YE(t1, l, g), v);
        }, t1.aT = eI, t1.aU = gv, t1.aV = 450, t1.aW = 7, t1.aX = (e1, t1, i, n, r, o)=>({
                u_matrix: e1,
                u_edge_radius: t1,
                u_width_scale: i,
                u_vertical_scale: n,
                u_height_type: JE[r],
                u_base_type: JE[o]
            }), t1.aY = g, t1.aZ = p, t1.a_ = f, t1.aa = Ku, t1.ab = qu, t1.ac = Sr, t1.ad = ur, t1.ae = hr, t1.af = function(e1, t1, i) {
            if (t1.projection.name === i.projection.name) return e1.projMatrix;
            const n = i.clone();
            return n.setProjection(t1.projection), x_(n, t1.getProjection(), e1);
        }, t1.ag = z, t1.ah = eu, t1.ai = Yd, t1.aj = Ou, t1.ak = nu, t1.al = Ju, t1.am = tu, t1.an = Jd, t1.ao = ks, t1.ap = js, t1.aq = Zs, t1.ar = Gs, t1.as = class {
            constructor(e1){
                this.specification = e1;
            }
            possiblyEvaluate(e1, t1) {
                return gt(e1.expression.evaluate(t1));
            }
            interpolate(e1, t1, i) {
                return {
                    x: hn(e1.x, t1.x, i),
                    y: hn(e1.y, t1.y, i),
                    z: hn(e1.z, t1.z, i),
                    azimuthal: hn(e1.azimuthal, t1.azimuthal, i),
                    polar: hn(e1.polar, t1.polar, i)
                };
            }
        }, t1.at = Vs, t1.au = Ls, t1.av = Ha, t1.aw = hn, t1.ax = it, t1.ay = 65, t1.az = 45, t1.b = Id, t1.b$ = mc, t1.b0 = 4, t1.b1 = 2, t1.b2 = Kh, t1.b3 = ed, t1.b4 = ct, t1.b5 = class {
            static calculate(e1, t1, i) {
                const n = new Set, r = new Map, o = new Set, a = new Set;
                for (const i of Object.values(e1))for (const [e1, s] of Object.entries(i.floors)){
                    o.add(e1), s.isDefault && a.add(e1), s.conflicts && r.set(e1, s.conflicts);
                    const i = e1 === t1, l = s.connections && t1 && s.connections.has(t1);
                    (i || l) && n.add(e1);
                }
                const s = (e1)=>{
                    const t1 = r.get(e1) || new Set;
                    for (const i of n)if ((r.get(i) || new Set).has(e1) || t1.has(i)) return !0;
                    return !1;
                };
                if (i) for (const e1 of i)o.has(e1) && (s(e1) || n.add(e1));
                for (const e1 of a)n.has(e1) || s(e1) || n.add(e1);
                return n;
            }
        }, t1.b6 = $u, t1.b7 = Yu, t1.b8 = class extends Hu {
            constructor(e1){
                super(e1), this.current = new Float32Array(9);
            }
            set(e1, t1, i) {
                if (!this.fetchUniformLocation(e1, t1)) return;
                const n = this.current;
                for(let e1 = 0; e1 < 9; e1++)if (i[e1] !== n[e1]) {
                    n.set(i), this.gl.uniformMatrix3fv(this.location, !1, n);
                    break;
                }
            }
        }, t1.b9 = Pc, t1.bA = wp, t1.bB = dr, t1.bC = fr, t1.bD = Oc, t1.bE = xu, t1.bF = Zm, t1.bG = Fd, t1.bH = Js, t1.bI = Mc, t1.bJ = Yw, t1.bK = vt, t1.bL = mh, t1.bM = Ec, t1.bN = Fc, t1.bO = fu, t1.bP = Gf, t1.bQ = wl, t1.bR = tp, t1.bS = X, t1.bT = Yf, t1.bU = Cc, t1.bV = jf, t1.bW = w, t1.bX = m, t1.bY = si, t1.bZ = xp, t1.b_ = SI, t1.ba = mu, t1.bb = tt, t1.bc = 6, t1.bd = Qf, t1.be = function(e1) {
            const t1 = 80.051129;
            e1 = tt(e1, -80.051129, t1) / t1 * 90;
            const i = Math.pow(Math.abs(Math.sin(Ye(e1))), 3);
            return Math.round(i * (Ql.length - 1));
        }, t1.bf = rp, t1.bg = Xf, t1.bh = function(e1) {
            const t1 = e1.pixelsPerMeter, i = t1 / cc(1, e1.center.lat), n = d(new Float64Array(16));
            return m(n, n, [
                e1.point.x,
                e1.point.y,
                0
            ]), g(n, n, [
                i,
                i,
                t1
            ]), Float32Array.from(n);
        }, t1.bi = function(e1, t1, i, n) {
            const r = t1.getNorth(), o = t1.getSouth(), a = t1.getWest(), l = t1.getEast(), c = 1 << e1.z, u = l - a, h = r - o, d = u / Kl, f = -h / Ql[i], p = [
                0,
                d,
                0,
                f,
                0,
                0,
                r,
                a,
                0
            ];
            if (e1.z > 0) {
                const e1 = 180 / n;
                s(p, p, [
                    e1 / u + 1,
                    0,
                    0,
                    0,
                    e1 / h + 1,
                    0,
                    -0.5 * e1 / d,
                    .5 * e1 / f,
                    1
                ]);
            }
            return p[2] = c, p[5] = e1.x, p[8] = e1.y, p;
        }, t1.bj = Rt, t1.bk = 256, t1.bl = LE, t1.bm = WE, t1.bn = hu, t1.bo = ce, t1.bp = he, t1.bq = fe, t1.br = M, t1.bs = D, t1.bt = pa, t1.bu = rc, t1.bv = uu, t1.bw = cu, t1.bx = uc, t1.by = PA, t1.bz = zt, t1.c = ja, t1.c$ = function(e1, t1, i, n) {
            for(; t1 < i;){
                const r = t1 + i >> 1;
                e1[r] <= n ? t1 = r + 1 : i = r;
            }
            return t1;
        }, t1.c0 = "hd_road_coverage", t1.c1 = gp, t1.c2 = yp, t1.c3 = T, t1.c4 = yt, t1.c5 = Qe, t1.c6 = function(e1, t1, i) {
            const n = cp(i.zoom), r = e1.style.map._antialias, o = e1.terrain && e1.terrain.exaggeration() > 0;
            return 0 === n && !r && !o;
        }, t1.c7 = function(e1, t1, i) {
            const n = d(new Float64Array(16)), r = (t1 / (1 << e1) - .5) * Math.PI * 2;
            return x(n, i.globeMatrix, r), Float32Array.from(n);
        }, t1.c8 = f_, t1.c9 = Md, t1.cA = bt, t1.cB = function(e1) {
            Qt++, Qt > qt && (e1.getActor().notify("enforceCacheSizeLimit", Wt), Qt = 0);
        }, t1.cC = yI, t1.cD = ki, t1.cE = async function(e1, t1, i) {
            const n = e1.url && !e1.tiles ? await t1.transformRequest(e1.url, oi.Source, i) : void 0;
            return {
                request: n,
                options: n ? {
                    ...e1,
                    url: n.url
                } : e1
            };
        }, t1.cF = async function(e1, t1) {
            const i = wM.get(e1);
            if (i) return i;
            const n = bM.get(e1);
            if (void 0 !== n) return n;
            const r = self.__mapboxImport(/* webpackIgnore: true */ /* @vite-ignore */ t1).catch((t1)=>{
                throw new Error(`TileProvider "${e1}" failed to load: ${t1 instanceof Error ? t1.message : String(t1)}`);
            }).then((t1)=>{
                const i = t1.default;
                if ("function" != typeof i) throw new Error(`TileProvider "${e1}" module must default-export a class`);
                if ("function" != typeof i.prototype.loadTile) throw new Error(`TileProvider "${e1}" class must have a loadTile method`);
                return wM.set(e1, i), i;
            }).finally(()=>{
                bM.delete(e1);
            });
            return bM.set(e1, r), r;
        }, t1.cG = function(e1, t1, i) {
            return t1 ? _I(e1, t1, i) : e1.tiles && e1.tiles.length > 0 ? {
                tiles: e1.tiles
            } : new Error('TileJSON is missing required "tiles" property');
        }, t1.cH = vw, t1.cI = zw, t1.cJ = ac, t1.cK = yM, t1.cL = function(e1, t1, i = 0, n = !0) {
            const r = new Re(i, i), o = e1.sub(r), a = t1.add(r), s = [
                o,
                new Re(a.x, o.y),
                a,
                new Re(o.x, a.y)
            ];
            return n && s.push(o.clone()), s;
        }, t1.cM = function(e1, t1) {
            const i = [];
            for(let n = 0; n < e1.length; n++){
                const r = nt(n - 1, -1, e1.length - 1), o = nt(n + 1, -1, e1.length - 1), a = e1[n], s = e1[o], l = e1[r].sub(a).unit(), c = s.sub(a).unit(), u = c.angleWithSep(l.x, l.y), h = l.add(c).unit().mult(-1 * t1 / Math.sin(u / 2));
                i.push(a.add(h));
            }
            return i;
        }, t1.cN = function(e1, { x: t1, y: i }, n = 0) {
            return new Re(((t1 - n) * e1.scale - e1.x) * Sr, (i * e1.scale - e1.y) * Sr);
        }, t1.cO = ud, t1.cP = function(e1, t1, i = 0) {
            return D(((t1.x - i) * e1.scale - e1.x) * Sr, (t1.y * e1.scale - e1.y) * Sr, uc(t1.z, t1.y));
        }, t1.cQ = ee, t1.cR = Pf, t1.cS = function(e1) {
            let t1 = 1 / 0, i = 1 / 0, n = -1 / 0, r = -1 / 0;
            for (const o of e1)t1 = Math.min(t1, o.x), i = Math.min(i, o.y), n = Math.max(n, o.x), r = Math.max(r, o.y);
            return {
                min: new Re(t1, i),
                max: new Re(n, r)
            };
        }, t1.cT = Jl, t1.cU = cd, t1.cV = yc, t1.cW = class {
            constructor(e1){
                this.entries = {}, this.scheduler = e1;
            }
            request(e1, t1, i, n) {
                const r = this.entries[e1] = this.entries[e1] || {
                    callbacks: []
                };
                if (r.result) {
                    const [e1, i] = r.result;
                    return this.scheduler ? this.scheduler.add(()=>{
                        n(e1, i);
                    }, t1) : n(e1, i), ()=>{};
                }
                return r.callbacks.push(n), r.cancel || (r.cancel = i((i, n)=>{
                    r.result = [
                        i,
                        n
                    ];
                    for (const e1 of r.callbacks)this.scheduler ? this.scheduler.add(()=>{
                        e1(i, n);
                    }, t1) : e1(i, n);
                    setTimeout(()=>delete this.entries[e1], 3e3);
                })), ()=>{
                    r.result || (r.callbacks = r.callbacks.filter((e1)=>e1 !== n), r.callbacks.length || (r.cancel(), delete this.entries[e1]));
                };
            }
        }, t1.cX = ti, t1.cY = function(e1, t1, i) {
            const n = JSON.stringify(e1.request);
            return e1.data && (this.deduped.entries[n] = {
                result: [
                    null,
                    e1.data
                ]
            }), this.deduped.request(n, {
                type: "parseTile",
                renderSourceType: e1.renderSourceType,
                zoom: e1.tileZoom
            }, (t1)=>{
                const n = new AbortController;
                return pi(e1.request, n.signal).then(({ data: e1, headers: n })=>{
                    t1(null, {
                        rawData: e1,
                        vectorTile: i ? void 0 : new Jh(new S_(e1)),
                        headers: n
                    });
                }).catch((e1)=>{
                    n.signal.aborted || (si(e1) ? t1(null, null) : t1(e1));
                }), ()=>{
                    n.abort(), t1(null, null);
                };
            }, t1);
        }, t1.cZ = class {
            constructor(e1, t1){
                this.context = e1, this.texture = t1;
            }
            bind(e1, t1) {
                const { context: i } = this, { gl: n } = i;
                n.bindTexture(n.TEXTURE_2D, this.texture), e1 !== this.minFilter && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, e1), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, e1), this.minFilter = e1), t1 !== this.wrapS && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, t1), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, t1), this.wrapS = t1);
            }
        }, t1.c_ = hc, t1.ca = cc, t1.cb = Hf, t1.cc = 128, t1.cd = se, t1.ce = oe, t1.cf = O, t1.cg = $, t1.ch = k, t1.ci = YE, t1.cj = sp, t1.ck = Xb, t1.cl = yw, t1.cm = Mt, t1.cn = St, t1.co = function(e1, t1) {
            const i = [
                0,
                0,
                0
            ];
            return X(i, i, rp(Xf(t1.canonical))), X(i, i, e1), i;
        }, t1.cp = Jw, t1.cq = function(e1, t1, i, n, r, o) {
            const { width: a, height: s } = n.imageManager.getPixelSize(t1), l = Math.pow(2, o.tileID.overscaledZ), c = o.tileSize * Math.pow(2, n.transform.tileZoom) / l, u = c * (o.tileID.canonical.x + o.tileID.wrap * l), h = c * o.tileID.canonical.y;
            return {
                u_image: 0,
                u_pattern_tl: i.tl,
                u_pattern_br: i.br,
                u_texsize: [
                    a,
                    s
                ],
                u_pattern_size: i.displaySize,
                u_pattern_units_to_pixels: r ? [
                    n.transform.width,
                    -1 * n.transform.height
                ] : [
                    1 / Xb(o, 1, n.transform.tileZoom),
                    1 / Xb(o, 1, n.transform.tileZoom)
                ],
                u_pixel_coord_upper: [
                    u >> 16,
                    h >> 16
                ],
                u_pixel_coord_lower: [
                    65535 & u,
                    65535 & h
                ]
            };
        }, t1.cr = (e1)=>({
                u_matrix: new Ku(e1),
                u_texsize: new Wu(e1),
                u_pixels_to_tile_units: new Qu(e1),
                u_device_pixel_ratio: new Zu(e1),
                u_width_scale: new Zu(e1),
                u_floor_width_scale: new Zu(e1),
                u_image: new $u(e1),
                u_units_to_pixels: new Wu(e1),
                u_tile_units_to_pixels: new Zu(e1),
                u_alpha_discard_threshold: new Zu(e1),
                u_trim_offset: new Wu(e1),
                u_trim_fade_range: new Wu(e1),
                u_trim_gradient_mix_range: new Wu(e1),
                u_trim_color: new Yu(e1),
                u_zbias_factor: new Zu(e1),
                u_tile_to_meter: new Zu(e1),
                u_ground_shadow_factor: new qu(e1),
                u_pattern_transition: new Zu(e1),
                u_opacity_multiplier: new Zu(e1)
            }), t1.cs = (e1)=>({
                u_matrix: new Ku(e1),
                u_pixels_to_tile_units: new Qu(e1),
                u_device_pixel_ratio: new Zu(e1),
                u_width_scale: new Zu(e1),
                u_floor_width_scale: new Zu(e1),
                u_units_to_pixels: new Wu(e1),
                u_dash_image: new $u(e1),
                u_has_dash: new $u(e1),
                u_has_border: new $u(e1),
                u_gradient_image: new $u(e1),
                u_border_gradient_image: new $u(e1),
                u_image_height: new Zu(e1),
                u_texsize: new Wu(e1),
                u_tile_units_to_pixels: new Zu(e1),
                u_alpha_discard_threshold: new Zu(e1),
                u_trim_offset: new Wu(e1),
                u_trim_fade_range: new Wu(e1),
                u_trim_gradient_mix_range: new Wu(e1),
                u_trim_color: new Yu(e1),
                u_zbias_factor: new Zu(e1),
                u_road_view_depth_bias: new Zu(e1),
                u_tile_to_meter: new Zu(e1),
                u_ground_shadow_factor: new qu(e1),
                u_opacity_multiplier: new Zu(e1),
                u_lpp_color: new Yu(e1),
                u_lpp_border_color: new Yu(e1),
                u_lpp_opacity: new Zu(e1),
                u_lpp_blur: new Zu(e1),
                u_lpp_width: new Zu(e1),
                u_lpp_gap_width: new Zu(e1),
                u_lpp_offset: new Zu(e1),
                u_lpp_floorwidth: new Zu(e1),
                u_lpp_border_width: new Zu(e1),
                u_lpp_emissive_strength: new Zu(e1),
                u_lpp_dash: new Yu(e1),
                u_lpp_side_z_offset: new Zu(e1),
                u_lpp_zoom_fraction: new Zu(e1)
            }), t1.ct = (e1)=>({
                u_color: new Ju(e1),
                u_matrix: new Ku(e1),
                u_overlay: new $u(e1),
                u_overlay_scale: new Zu(e1)
            }), t1.cu = (e1)=>({
                u_camera_to_center_distance: new Zu(e1),
                u_extrude_scale: new Qu(e1),
                u_device_pixel_ratio: new Zu(e1),
                u_matrix: new Ku(e1),
                u_inv_rot_matrix: new Ku(e1),
                u_merc_center: new Wu(e1),
                u_tile_id: new qu(e1),
                u_zoom_transition: new Zu(e1),
                u_up_dir: new qu(e1),
                u_emissive_strength: new Zu(e1)
            }), t1.cv = (e1)=>({
                u_matrix: new Ku(e1),
                u_lightpos: new qu(e1),
                u_lightintensity: new Zu(e1),
                u_lightcolor: new qu(e1),
                u_vertical_gradient: new Zu(e1),
                u_height_factor: new Zu(e1),
                u_edge_radius: new Zu(e1),
                u_width_scale: new Zu(e1),
                u_ao: new Wu(e1),
                u_height_type: new $u(e1),
                u_base_type: new $u(e1),
                u_tile_id: new qu(e1),
                u_zoom_transition: new Zu(e1),
                u_inv_rot_matrix: new Ku(e1),
                u_merc_center: new Wu(e1),
                u_up_dir: new qu(e1),
                u_height_lift: new Zu(e1),
                u_image: new $u(e1),
                u_texsize: new Wu(e1),
                u_pixel_coord_upper: new Wu(e1),
                u_pixel_coord_lower: new Wu(e1),
                u_tile_units_to_pixels: new Zu(e1),
                u_opacity: new Zu(e1),
                u_pattern_transition: new Zu(e1)
            }), t1.cw = (e1)=>({
                u_matrix: new Ku(e1),
                u_lightpos: new qu(e1),
                u_lightintensity: new Zu(e1),
                u_lightcolor: new qu(e1),
                u_vertical_gradient: new Zu(e1),
                u_opacity: new Zu(e1),
                u_edge_radius: new Zu(e1),
                u_width_scale: new Zu(e1),
                u_ao: new Wu(e1),
                u_height_type: new $u(e1),
                u_base_type: new $u(e1),
                u_tile_id: new qu(e1),
                u_zoom_transition: new Zu(e1),
                u_inv_rot_matrix: new Ku(e1),
                u_merc_center: new Wu(e1),
                u_up_dir: new qu(e1),
                u_height_lift: new Zu(e1),
                u_flood_light_color: new qu(e1),
                u_vertical_scale: new Zu(e1),
                u_flood_light_intensity: new Zu(e1),
                u_ground_shadow_factor: new qu(e1),
                u_front_cutoff_params: new qu(e1)
            }), t1.cx = rt, t1.cy = function(e1) {
            if ("provider" in e1 && !e1.provider) return null;
            let t1 = e1.provider;
            if (!t1 && "url" in e1 && e1.url && (t1 = function(e1) {
                try {
                    const t1 = new URL(e1).pathname.split("/").pop() || "", i = t1.lastIndexOf(".");
                    return i >= 0 ? t1.slice(i + 1) : "";
                } catch  {
                    return "";
                }
            }(e1.url)), !t1) return null;
            const i = kt.TILE_PROVIDER_URLS[t1];
            if (!i) return null;
            let n;
            try {
                n = new URL(i, kt.API_URL).href;
            } catch (e1) {
                return new Error(`TileProvider "${t1}" has an invalid URL: "${i}"`);
            }
            return {
                name: t1,
                url: n
            };
        }, t1.cz = mI, t1.d = S_, t1.d$ = Z, t1.d0 = function(e1, t1, i, n) {
            for(; t1 < i;){
                const r = t1 + i >> 1;
                e1[r] < n ? t1 = r + 1 : i = r;
            }
            return t1;
        }, t1.d1 = Kl, t1.d2 = Y, t1.d3 = function(e1, t1) {
            var i = t1[0], n = t1[1], r = t1[2], o = t1[3], a = t1[4], s = t1[5], l = t1[6], c = t1[7], u = t1[8];
            return e1[0] = a * u - s * c, e1[1] = r * c - n * u, e1[2] = n * s - r * a, e1[3] = s * l - o * u, e1[4] = i * u - r * l, e1[5] = r * o - i * s, e1[6] = o * c - a * l, e1[7] = n * l - i * c, e1[8] = i * a - n * o, e1;
        }, t1.d4 = s, t1.d5 = async function(e1) {
            const t1 = document.createElement("video");
            t1.muted = !0;
            for (const i of e1){
                const e1 = document.createElement("source");
                _i(i) || (t1.crossOrigin = "Anonymous"), e1.src = i, t1.appendChild(e1);
            }
            return await new Promise((i, n)=>{
                t1.onloadstart = ()=>i(), t1.onerror = ()=>n(new Error(`Could not load video: ${e1.join(", ")}`));
            }), t1;
        }, t1.d6 = [
            "type",
            "source",
            "source-layer",
            "minzoom",
            "maxzoom",
            "filter",
            "layout"
        ], t1.d7 = qa, t1.d8 = ve, t1.d9 = Ee, t1.dA = function(e1, [t1, i]) {
            let n = 0, r = 0;
            if (i === vf) {
                t1 < 0 && (t1 = 0);
                const i = t1 / bf;
                switch(e1){
                    case "top-right":
                    case "top-left":
                        r = i - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                        r = 7 - i;
                        break;
                    case "bottom":
                        r = 7 - t1;
                        break;
                    case "top":
                        r = t1 - 7;
                }
                switch(e1){
                    case "top-right":
                    case "bottom-right":
                        n = -i;
                        break;
                    case "top-left":
                    case "bottom-left":
                        n = i;
                        break;
                    case "left":
                        n = t1;
                        break;
                    case "right":
                        n = -t1;
                }
            } else {
                switch(t1 = Math.abs(t1), i = Math.abs(i), e1){
                    case "top-right":
                    case "top-left":
                    case "top":
                        r = i - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                    case "bottom":
                        r = 7 - i;
                }
                switch(e1){
                    case "top-right":
                    case "bottom-right":
                    case "right":
                        n = -t1;
                        break;
                    case "top-left":
                    case "bottom-left":
                    case "left":
                        n = t1;
                }
            }
            return [
                n,
                r
            ];
        }, t1.dB = function(e1) {
            switch(e1){
                case "right":
                case "top-right":
                case "bottom-right":
                    return "right";
                case "left":
                case "top-left":
                case "bottom-left":
                    return "left";
            }
            return "center";
        }, t1.dC = LM, t1.dD = b_, t1.dE = Bs, t1.dF = cm, t1.dG = function() {
            return {
                API_URL: kt.API_URL,
                DRACO_URL: kt.DRACO_URL,
                MESHOPT_URL: kt.MESHOPT_URL,
                MESHOPT_SIMD_URL: kt.MESHOPT_SIMD_URL,
                BUILDING_GEN_URL: kt.BUILDING_GEN_URL,
                RTL_TEXT_URL: kt.RTL_TEXT_URL
            };
        }, t1.dH = li, t1.dI = function(e1) {
            if ("undefined" == typeof document || !document.fonts) return !1;
            const t1 = (e1)=>e1.trim().replace(/^["']|["']$/g, "").toLowerCase(), i = e1.split(",").map(t1);
            let n = !1;
            return document.fonts.forEach((e1)=>{
                i.includes(t1(e1.family)) && (n = !0);
            }), n;
        }, t1.dJ = $t, t1.dK = en, t1.dL = dt, t1.dM = function(e1) {
            const t1 = e1.indexOf(cl);
            return t1 >= 0 ? e1.slice(0, t1) : e1;
        }, t1.dN = function(e1) {
            return e1.includes(cl);
        }, t1.dO = function(e1) {
            const t1 = e1.lastIndexOf(cl);
            return t1 >= 0 ? e1.slice(t1 + 1) : "";
        }, t1.dP = function(e1, t1 = {}) {
            const i = t1.type && !t1.array && Array.isArray(e1) ? {
                type: t1.type,
                "property-type": "data-constant"
            } : void 0;
            return ja(null === e1 || "object" != typeof e1 || Array.isArray(e1) ? e1 : [
                "literal",
                e1
            ], i);
        }, t1.dQ = function(e1) {
            const t1 = [], i = e1.id;
            return void 0 === i && t1.push({
                message: `layers.${i}: missing required property "id"`
            }), void 0 === e1.render && t1.push({
                message: `layers.${i}: missing required method "render"`
            }), e1.renderingMode && "2d" !== e1.renderingMode && "3d" !== e1.renderingMode && t1.push({
                message: `layers.${i}: property "renderingMode" must be either "2d" or "3d"`
            }), t1;
        }, t1.dR = function(e1, t1, i, n) {
            return "custom" === e1.type ? new Rw(e1, t1) : new EI[e1.type](e1, t1, i, n);
        }, t1.dS = ht, t1.dT = hl, t1.dU = class extends Yw {
            constructor(e1, t1){
                super(e1._vectorTileFeature, e1._z, e1._x, e1._y, e1.id), e1.state && (this.state = {
                    ...e1.state
                }), this.target = t1.target, this.namespace = t1.namespace, t1.properties && (this.properties = t1.properties), this.target && ("featuresetId" in this.target && !this.target.importId || "layerId" in this.target) && (this.source = e1.source, this.sourceLayer = e1.sourceLayer, this.layer = e1.layer);
            }
            toJSON() {
                const e1 = super.toJSON();
                return e1.target = this.target, e1.namespace = this.namespace, e1;
            }
        }, t1.dV = rI, t1.dW = A_, t1.dX = function(e1, t1) {
            return [
                Math.pow(e1[0], 2.2) * t1,
                Math.pow(e1[1], 2.2) * t1,
                Math.pow(e1[2], 2.2) * t1
            ];
        }, t1.dY = N, t1.dZ = C, t1.d_ = It, t1.da = we, t1.db = Te, t1.dc = nt, t1.dd = re, t1.de = .55, t1.df = vA, t1.dg = AA, t1.dh = yd, t1.di = g_, t1.dj = d_, t1.dk = d, t1.dl = af, t1.dm = .9, t1.dn = v_, t1.dp = function(e1, t1, i, n, r, o, a) {
            const s = xA(e1, t1, i, n, r, o, a);
            return "globe" === o.name && i || (s[2] = s[6] = s[10] = s[14] = 0), s;
        }, t1.dq = function(e1, t1, i, n, r, o, a) {
            if (i) {
                if ("globe" === o.name) {
                    const s = xA(e1, t1, i, n, r, o, a);
                    return p(s, s), _(s, e1, s), s;
                }
                {
                    const t1 = u(e1), [i, o, s, l] = a, [c, h, d, f, p, _, m, g] = t1;
                    return t1[0] = i * c + o * p, t1[1] = i * h + o * _, t1[2] = i * d + o * m, t1[3] = i * f + o * g, t1[4] = s * c + l * p, t1[5] = s * h + l * _, t1[6] = s * d + l * m, t1[7] = s * f + l * g, n || v(t1, t1, -r.angle), t1;
                }
            }
            return r.glCoordMatrix;
        }, t1.dr = xf, t1.ds = Xp, t1.dt = h_, t1.du = c_, t1.dv = u_, t1.dw = ne, t1.dx = yf, t1.dy = cf, t1.dz = uf, t1.e = Vt, t1.e$ = function(e1, t1) {
            t1 ? Qi.add(e1) : Qi.delete(e1);
        }, t1.e0 = jE, t1.e1 = GE, t1.e2 = (e1)=>({
                u_cutoff_params: new Yu(e1)
            }), t1.e3 = (e1)=>({
                u_light_matrix_0: new Ku(e1),
                u_light_matrix_1: new Ku(e1),
                u_fade_range: new Wu(e1),
                u_shadow_normal_offset: new qu(e1),
                u_shadow_intensity: new Zu(e1),
                u_shadow_texel_size: new Zu(e1),
                u_shadow_map_resolution: new Zu(e1),
                u_shadow_direction: new qu(e1),
                u_shadow_bias: new qu(e1),
                u_shadowmap_0: new $u(e1),
                u_shadowmap_1: new $u(e1)
            }), t1.e4 = function(e1, t1, i) {
            return t1.name === i.projection.name ? e1.projMatrix : x_(i, t1, e1);
        }, t1.e5 = xA, t1.e6 = RA, t1.e7 = bA, t1.e8 = Cm, t1.e9 = function(e1, t1, i, n, r, o, a, s, l, c, u = 1) {
            const h = i.transform, d = n ? e1.textSizeData : e1.iconSizeData, f = xf(d, i.transform.zoom, u), p = "globe" === h.projection.name, _ = (()=>{
                if (!p) return null;
                const e1 = cp(h.zoom);
                return 0 === e1 ? null : {
                    t: e1,
                    invMatrix: h.projection.createInversionMatrix(h, c.canonical),
                    mercCenter: [
                        ur(h.center.lng),
                        hr(h.center.lat)
                    ]
                };
            })(), m = [
                256 / i.width * 2 + 1,
                256 / i.height * 2 + 1
            ], g = n ? e1.text.dynamicLayoutVertexArray : e1.icon.dynamicLayoutVertexArray;
            g.clear();
            let y = null;
            p && (y = n ? e1.text.globeExtVertexArray : e1.icon.globeExtVertexArray);
            const x = e1.lineVertexArray, v = n ? e1.text.placedSymbolArray : e1.icon.placedSymbolArray, b = i.transform.width / i.transform.height;
            let w, A = !1;
            for(let u = 0; u < v.length; u++){
                const p = v.get(u), { numGlyphs: E, writingMode: I } = p;
                if (I !== cf.vertical || A || w === cf.horizontal || (A = !0), w = I, (p.hidden || I === cf.vertical) && !A) {
                    RA(E, g);
                    continue;
                }
                A = !1;
                const M = new Re(p.tileAnchorX, p.tileAnchorY), S = "road" === e1.elevationType, T = !!h.elevation || S;
                let { x: z, y: R, z: P } = h.projection.projectTilePoint(M.x, M.y, c.canonical);
                if (_) {
                    const [e1, t1, i] = MA(M, c.canonical, _);
                    z += (e1 - z) * _.t, R += (t1 - R) * _.t, P += (i - P) * _.t;
                }
                let D = null;
                if (T) {
                    D = S && e1.hdExt ? e1.hdExt.makeRoadSymbolElevationParams(e1, n ? e1.text : e1.icon, u, c, l, h.elevation, h.projection, h.center.lat, h.worldSize) : {
                        getElevation: l,
                        elevation: h.elevation,
                        elevationFeature: null
                    };
                    const [t1, i, r] = D.getElevation(M, h.elevation, D.elevationFeature);
                    z += t1, R += i, P += r;
                }
                const F = [
                    z,
                    R,
                    P,
                    1
                ];
                if (se(F, F, t1), !wA(F, m)) {
                    RA(E, g);
                    continue;
                }
                const C = F[3], O = bA(i.transform.getCameraToCenterDistance(h.projection), C), L = yf(d, f, p), B = a ? L / O : L * O, V = vA(z, R, P, r);
                if (V[3] <= 0) {
                    RA(E, g);
                    continue;
                }
                let N = {};
                const k = Ye(e1.layers[0].layout.get("text-max-angle")), U = Math.cos(k), j = a ? null : D, G = IA(p, B, !1, s, t1, r, o, e1.glyphOffsetArray, x, g, y, V, M, N, b, j, h.projection, c, a, U, _);
                A = G.useVertical, j && G.needsFlipping && (N = {}), (G.notEnoughRoom || A || G.needsFlipping && IA(p, B, !0, s, t1, r, o, e1.glyphOffsetArray, x, g, y, V, M, N, b, j, h.projection, c, a, U, _).notEnoughRoom) && RA(E, g);
            }
            n ? (e1.text.dynamicLayoutVertexBuffer.updateData(g), y && e1.text.globeExtVertexBuffer && e1.text.globeExtVertexBuffer.updateData(y)) : (e1.icon.dynamicLayoutVertexBuffer.updateData(g), y && e1.icon.globeExtVertexBuffer && e1.icon.globeExtVertexBuffer.updateData(y));
        }, t1.eA = Jc, t1.eB = class {
            constructor(){
                this._updateTime = 0, this._sourceIds = [], this._activeRegions = [], this._prevRegions = [], this._globalClipBounds = {
                    min: new Re(1 / 0, 1 / 0),
                    max: new Re(-1 / 0, -1 / 0)
                };
            }
            clear() {
                this._activeRegions.length > 0 && ++this._updateTime, this._activeRegions = [], this._prevRegions = [];
            }
            get updateTime() {
                return this._updateTime;
            }
            getReplacementRegionsForTile(e1, t1 = !1) {
                const i = e_(new Re(0, 0), new Re(Sr, Sr), e1), n = [];
                if (t1 && !Kp(i, this._globalClipBounds)) return n;
                for (const t1 of this._activeRegions){
                    if (t1.hiddenByOverlap) continue;
                    if (!Kp(i, t1)) continue;
                    const r = t_(t1.min, t1.max, e1);
                    n.push({
                        min: r.min,
                        max: r.max,
                        sourceId: this._sourceIds[t1.priority],
                        footprint: t1.footprint,
                        footprintTileId: t1.tileId,
                        order: t1.order,
                        clipMask: t1.clipMask,
                        clipScope: t1.clipScope
                    });
                }
                return n;
            }
            setSources(e1) {
                this._setSources(e1.map((e1)=>({
                        getSourceId: ()=>e1.cache.id,
                        getFootprints: ()=>{
                            const t1 = [];
                            for (const i of e1.cache.getVisibleCoordinates()){
                                const n = e1.cache.getTile(i).buckets[e1.layer];
                                n && n.updateFootprints(i.toUnwrapped(), t1);
                            }
                            return t1;
                        },
                        getOrder: ()=>e1.order,
                        getClipMask: ()=>e1.clipMask,
                        getClipScope: ()=>e1.clipScope
                    })));
            }
            _addSource(e1) {
                const t1 = e1.getFootprints();
                if (0 === t1.length) return;
                const i = e1.getOrder(), n = e1.getClipMask(), r = e1.getClipScope();
                for (const e1 of t1){
                    if (!e1.footprint) continue;
                    const t1 = e_(e1.footprint.min, e1.footprint.max, e1.id);
                    this._activeRegions.push({
                        min: t1.min,
                        max: t1.max,
                        hiddenByOverlap: !1,
                        priority: this._sourceIds.length,
                        tileId: e1.id,
                        footprint: e1.footprint,
                        order: i,
                        clipMask: n,
                        clipScope: r
                    });
                }
                this._sourceIds.push(e1.getSourceId());
            }
            _computeReplacement() {
                this._activeRegions.sort((e1, t1)=>e1.priority - t1.priority || Yp(e1.min, t1.min) || Yp(e1.max, t1.max) || e1.order - t1.order || e1.clipMask - t1.clipMask || function(e1, t1) {
                        const i = (e1, t1)=>e1 + t1;
                        return e1.length - t1.length || e1.reduce(i, "").localeCompare(t1.reduce(i, ""));
                    }(e1.clipScope, t1.clipScope));
                let e1 = this._activeRegions.length !== this._prevRegions.length;
                if (!e1) {
                    let t1 = 0;
                    for(; !e1 && t1 !== this._activeRegions.length;){
                        const i = this._activeRegions[t1], n = this._prevRegions[t1];
                        e1 = i.priority !== n.priority || !Jp(i, n) || i.order !== n.order || i.clipMask !== n.clipMask || !Pe(i.clipScope, n.clipScope), this._activeRegions[t1].hiddenByOverlap = n.hiddenByOverlap, ++t1;
                    }
                }
                if (e1) {
                    ++this._updateTime;
                    for (const e1 of this._activeRegions)e1.order !== Wp && (this._globalClipBounds.min.x = Math.min(this._globalClipBounds.min.x, e1.min.x), this._globalClipBounds.min.y = Math.min(this._globalClipBounds.min.y, e1.min.y), this._globalClipBounds.max.x = Math.max(this._globalClipBounds.max.x, e1.max.x), this._globalClipBounds.max.y = Math.max(this._globalClipBounds.max.y, e1.max.y));
                    const e1 = (e1)=>{
                        const t1 = this._activeRegions;
                        if (e1 >= t1.length) return e1;
                        const i = t1[e1].priority;
                        for(; e1 < t1.length && t1[e1].priority === i;)++e1;
                        return e1;
                    };
                    if (this._sourceIds.length > 1) {
                        let t1 = 0, i = e1(t1);
                        for(; t1 !== i;){
                            let n = t1;
                            const r = t1;
                            for(; n !== i;){
                                const e1 = this._activeRegions[n];
                                e1.hiddenByOverlap = !1;
                                for(let t1 = 0; t1 < r; t1++){
                                    const i = this._activeRegions[t1];
                                    if (!i.hiddenByOverlap && e1.order === Wp && Kp(e1, i) && (e1.hiddenByOverlap = l_(e1.footprint, e1.tileId, i.footprint, i.tileId), e1.hiddenByOverlap)) break;
                                }
                                ++n;
                            }
                            t1 = i, i = e1(t1);
                        }
                    }
                }
            }
            _setSources(e1) {
                [this._prevRegions, this._activeRegions] = [
                    this._activeRegions,
                    []
                ], this._sourceIds = [];
                for(let t1 = e1.length - 1; t1 >= 0; t1--)this._addSource(e1[t1]);
                this._computeReplacement();
            }
        }, t1.eC = Wp, t1.eD = class {
            constructor(e1){
                this._createGrid(e1), this._createPoles(e1);
            }
            destroy() {
                this._poleIndexBuffer.destroy(), this._gridBuffer.destroy(), this._gridIndexBuffer.destroy(), this._poleNorthVertexBuffer.destroy(), this._poleSouthVertexBuffer.destroy();
                for (const e1 of this._poleSegments)e1.destroy();
                for (const e1 of this._gridSegments)e1.withSkirts.destroy(), e1.withoutSkirts.destroy();
            }
            _fillGridMeshWithLods(e1, t1) {
                const i = new Fc, n = new nu, r = [], o = e1 + 1 + 2, a = t1[0] + 1, s = t1[0] + 1 + (1 + t1.length), l = (e1, t1, i)=>{
                    let n = e1 === o - 1 ? e1 - 2 : 0 === e1 ? e1 : e1 - 1;
                    return n += i ? 24575 : 0, [
                        n,
                        t1
                    ];
                };
                for(let e1 = 0; e1 < o; ++e1)i.emplaceBack(...l(e1, 0, !0));
                for(let e1 = 0; e1 < a; ++e1)for(let t1 = 0; t1 < o; ++t1)i.emplaceBack(...l(t1, e1, (0 === t1 || t1 === o - 1) && !0));
                for(let e1 = 0; e1 < t1.length; ++e1){
                    const n = t1[e1];
                    for(let e1 = 0; e1 < o; ++e1)i.emplaceBack(...l(e1, n, !0));
                }
                for(let e1 = 0; e1 < t1.length; ++e1){
                    const a = n.length, l = t1[e1] + 1 + 2, c = new nu;
                    for(let i = 0; i < l - 1; i++){
                        const r = i === l - 2, a = r ? o * (s - t1.length + e1 - i) : o;
                        for(let e1 = 0; e1 < o - 1; e1++){
                            const t1 = i * o + e1;
                            0 === i || r || 0 === e1 || e1 === o - 2 ? (c.emplaceBack(t1 + 1, t1, t1 + a), c.emplaceBack(t1 + a, t1 + a + 1, t1 + 1)) : (n.emplaceBack(t1 + 1, t1, t1 + a), n.emplaceBack(t1 + a, t1 + a + 1, t1 + 1));
                        }
                    }
                    const u = Ou.simpleSegment(0, a, i.length, n.length - a);
                    for(let e1 = 0; e1 < c.uint16.length; e1 += 3)n.emplaceBack(c.uint16[e1], c.uint16[e1 + 1], c.uint16[e1 + 2]);
                    const h = Ou.simpleSegment(0, a, i.length, n.length - a);
                    r.push({
                        withoutSkirts: u,
                        withSkirts: h
                    });
                }
                return {
                    vertices: i,
                    indices: n,
                    segments: r
                };
            }
            _createGrid(e1) {
                const t1 = this._fillGridMeshWithLods(Kl, Ql);
                this._gridSegments = t1.segments, this._gridBuffer = e1.createVertexBuffer(t1.vertices, Gf.members), this._gridIndexBuffer = e1.createIndexBuffer(t1.indices, !0);
            }
            _createPoles(e1) {
                const t1 = new nu;
                for(let e1 = 0; e1 <= Kl; e1++)t1.emplaceBack(0, e1 + 1, e1 + 2);
                this._poleIndexBuffer = e1.createIndexBuffer(t1, !0);
                const i = new su, n = new su, r = new su, o = new su;
                this._poleSegments = [];
                for(let e1 = 0, t1 = 0; e1 < 6; e1++){
                    const a = 360 / (1 << e1);
                    i.emplaceBack(0, -Jl, 0, .5, 0), n.emplaceBack(0, -Jl, 0, .5, 1), r.emplaceBack(0, -Jl, 0, .5, .5), o.emplaceBack(0, -Jl, 0, .5, .5);
                    for(let e1 = 0; e1 <= Kl; e1++){
                        let t1 = e1 / Kl, s = 0;
                        const l = hn(0, a, t1), [c, u, h] = ic(_p, mp, l, Jl);
                        i.emplaceBack(c, u, h, t1, s), n.emplaceBack(c, u, h, t1, 1 - s);
                        const d = Ye(l);
                        t1 = .5 + .5 * Math.sin(d), s = .5 + .5 * Math.cos(d), r.emplaceBack(c, u, h, t1, s), o.emplaceBack(c, u, h, t1, 1 - s);
                    }
                    this._poleSegments.push(Ou.simpleSegment(t1, 0, 66, 64)), t1 += 66;
                }
                this._poleNorthVertexBuffer = e1.createVertexBuffer(i, Uf, !1), this._poleSouthVertexBuffer = e1.createVertexBuffer(n, Uf, !1), this._texturedPoleNorthVertexBuffer = e1.createVertexBuffer(r, Uf, !1), this._texturedPoleSouthVertexBuffer = e1.createVertexBuffer(o, Uf, !1);
            }
            getGridBuffers(e1, t1) {
                return [
                    this._gridBuffer,
                    this._gridIndexBuffer,
                    t1 ? this._gridSegments[e1].withSkirts : this._gridSegments[e1].withoutSkirts
                ];
            }
            getPoleBuffers(e1, t1) {
                return [
                    t1 ? this._texturedPoleNorthVertexBuffer : this._poleNorthVertexBuffer,
                    t1 ? this._texturedPoleSouthVertexBuffer : this._poleSouthVertexBuffer,
                    this._poleIndexBuffer,
                    this._poleSegments[e1]
                ];
            }
        }, t1.eE = function(e1) {
            return Qi.has(e1);
        }, t1.eF = HE, t1.eG = qp, t1.eH = ze, t1.eI = function() {
            return !!document.fullscreenElement || !!document.webkitFullscreenElement;
        }, t1.eJ = et, t1.eK = pc, t1.eL = function(e1, t1, i) {
            return e1[0] = t1[0] / i[0], e1[1] = t1[1] / i[1], e1[2] = t1[2] / i[2], e1;
        }, t1.eM = te, t1.eN = sc, t1.eO = nc, t1.eP = W, t1.eQ = Nf, t1.eR = G, t1.eS = F, t1.eT = function([e1, t1, i]) {
            const n = Math.hypot(e1, t1, i), r = Math.atan2(e1, i), o = .5 * Math.PI - Math.acos(-t1 / n);
            return new ac(Je(r), Je(o));
        }, t1.eU = U, t1.eV = ae, t1.eW = sx, t1.eX = vi, t1.eY = DA, t1.eZ = class {
            constructor(e1, t1, i){
                this._transformRequestFn = e1, this._customAccessToken = t1, this._silenceAuthErrors = !!i, this._createSkuToken();
            }
            _createSkuToken() {
                const e1 = function() {
                    let e1 = "";
                    for(let t1 = 0; t1 < 10; t1++)e1 += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62 * Math.random())];
                    return {
                        token: [
                            "1",
                            yi,
                            e1
                        ].join(""),
                        tokenExpiresAt: Date.now() + 432e5
                    };
                }();
                this._skuToken = e1.token, this._skuTokenExpiresAt = e1.tokenExpiresAt;
            }
            _isSkuTokenExpired() {
                return Date.now() > this._skuTokenExpiresAt;
            }
            async transformRequest(e1, t1, i) {
                if (!this._transformRequestFn) return {
                    url: e1
                };
                const n = i ? {
                    signal: i
                } : {};
                return await this._transformRequestFn(e1, t1, n) || {
                    url: e1
                };
            }
            normalizeStyleURL(e1, t1) {
                if (!ti(e1)) return e1;
                const n = zi(e1);
                return n.params.push(`sdk=js-${i}`), n.path = `/styles/v1${n.path}`, this._makeAPIURL(n, this._customAccessToken || t1);
            }
            normalizeGlyphsURL(e1, t1) {
                if (!ti(e1)) return e1;
                const i = zi(e1);
                return i.path = `/fonts/v1${i.path}`, this._makeAPIURL(i, this._customAccessToken || t1);
            }
            normalizeModelURL(e1, t1) {
                if (!ti(e1)) return e1;
                const i = zi(e1);
                return i.path = `/models/v1${i.path}`, this._makeAPIURL(i, this._customAccessToken || t1);
            }
            normalizeSourceURL(e1, t1, i, n) {
                if (!ti(e1)) return e1;
                const r = zi(e1);
                return r.path = `/v4/${r.authority}.json`, r.params.push("secure"), i && r.params.push(`language=${i}`), n && r.params.push(`worldview=${n}`), this._makeAPIURL(r, this._customAccessToken || t1);
            }
            normalizeIconsetURL(e1, t1) {
                const i = zi(e1);
                return ti(e1) ? (i.path = `/styles/v1${i.path}/iconset.pbf`, this._makeAPIURL(i, this._customAccessToken || t1)) : Ri(i);
            }
            normalizeSpriteURL(e1, t1, i, n) {
                const r = zi(e1);
                return ti(e1) ? (r.path = `/styles/v1${r.path}/sprite${t1}${i}`, this._makeAPIURL(r, this._customAccessToken || n)) : (r.path += `${t1}${i}`, Ri(r));
            }
            normalizeTileURL(e1, t1, i) {
                if (this._isSkuTokenExpired() && this._createSkuToken(), e1 && !ti(e1)) return e1;
                const n = zi(e1);
                n.path = n.path.replace(wi, (t1 || i && "raster" !== n.authority && 512 === i ? "@2x" : "") + ".webp"), "raster" === n.authority ? n.path = `/${kt.RASTER_URL_PREFIX}${n.path}` : "rasterarrays" === n.authority ? n.path = `/${kt.RASTERARRAYS_URL_PREFIX}${n.path}` : "3dtiles" === n.authority ? n.path = `/${kt.TILES3D_URL_PREFIX}${n.path}` : (n.path = n.path.replace(Ai, "/"), n.path = `/${kt.TILE_URL_VERSION}${n.path}`);
                const r = this._customAccessToken || function(e1) {
                    for (const t1 of e1){
                        const e1 = t1.match(Mi);
                        if (e1) return e1[1];
                    }
                    return null;
                }(n.params) || kt.ACCESS_TOKEN;
                return kt.REQUIRE_ACCESS_TOKEN && r && this._skuToken && n.params.push(`sku=${this._skuToken}`), this._makeAPIURL(n, r);
            }
            canonicalizeTileURL(e1, t1) {
                const i = zi(e1);
                if (!Ii.test(i.path) || !Ei.test(i.path)) return e1;
                let n = "mapbox://";
                i.path.startsWith("/raster/v1/") ? n += `raster/${i.path.replace(`/${kt.RASTER_URL_PREFIX}/`, "")}` : i.path.startsWith("/rasterarrays/v1/") ? n += `rasterarrays/${i.path.replace(`/${kt.RASTERARRAYS_URL_PREFIX}/`, "")}` : n += `tiles/${i.path.replace(`/${kt.TILE_URL_VERSION}/`, "")}`;
                let r = i.params;
                return t1 && (r = r.filter((e1)=>!e1.match(Mi))), r.length && (n += `?${r.join("&")}`), n;
            }
            canonicalizeTileset(e1, t1) {
                const i = !!t1 && ti(t1), n = [];
                for (const t1 of e1.tiles || [])ei(t1) ? n.push(this.canonicalizeTileURL(t1, i)) : n.push(t1);
                return n;
            }
            _makeAPIURL(e1, t1) {
                const i = "See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes", n = zi(kt.API_URL);
                if (e1.protocol = n.protocol, e1.authority = n.authority, "http" === e1.protocol) {
                    const t1 = e1.params.indexOf("secure");
                    t1 >= 0 && e1.params.splice(t1, 1);
                }
                if ("/" !== n.path && (e1.path = `${n.path}${e1.path}`), !kt.REQUIRE_ACCESS_TOKEN) return Ri(e1);
                if (t1 = t1 || kt.ACCESS_TOKEN, !this._silenceAuthErrors) {
                    if (!t1) throw new Error(`An API access token is required to use Mapbox GL. ${i}`);
                    if ("s" === t1[0]) throw new Error(`Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). ${i}`);
                }
                return e1.params = e1.params.filter((e1)=>!e1.includes("access_token")), e1.params.push(`access_token=${t1 || ""}`), Ri(e1);
            }
        }, t1.e_ = Di, t1.ea = Y_, t1.eb = vb, t1.ec = (e1, t1, i, n, r, o)=>{
            const a = e1.transform, s = "globe" === a.projection.name;
            let l;
            if ("map" === o.paint.get("circle-pitch-alignment")) {
                if (s) {
                    const e1 = sp(a.zoom, t1.canonical) * a._pixelsPerMercatorPixel;
                    l = Float32Array.from([
                        e1,
                        0,
                        0,
                        e1
                    ]);
                } else l = a.calculatePixelsToTileUnitsMatrix(i);
            } else l = new Float32Array([
                a.pixelsToGLUnits[0],
                0,
                0,
                a.pixelsToGLUnits[1]
            ]);
            const c = {
                u_camera_to_center_distance: e1.transform.getCameraToCenterDistance(a.projection),
                u_matrix: e1.translatePosMatrix(t1.projMatrix, i, o.paint.get("circle-translate"), o.paint.get("circle-translate-anchor")),
                u_device_pixel_ratio: Vt.devicePixelRatio,
                u_extrude_scale: l,
                u_inv_rot_matrix: xb,
                u_merc_center: [
                    0,
                    0
                ],
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_up_dir: [
                    0,
                    0,
                    0
                ],
                u_emissive_strength: o.paint.get("circle-emissive-strength")
            };
            if (s) {
                c.u_inv_rot_matrix = n, c.u_merc_center = r, c.u_tile_id = [
                    t1.canonical.x,
                    t1.canonical.y,
                    1 << t1.canonical.z
                ], c.u_zoom_transition = cp(a.zoom);
                const e1 = r[0] * Sr, i = r[1] * Sr;
                c.u_up_dir = a.projection.upVector(new gp(0, 0, 0), e1, i);
            }
            return c;
        }, t1.ed = Kb, t1.ee = (e1, t1, i, n, r, o, a, s, l, c)=>{
            const u = e1.transform, h = u.pitch < 15 ? hn(.07, .7, tt((14 - u.zoom) / 5, 0, 1)) : .07, d = "none" === i.paint.get("line-trim-color-use-theme").constantOr("default");
            return {
                u_matrix: Jb(e1, t1, i, n),
                u_texsize: t1.imageAtlasTexture ? t1.imageAtlasTexture.size : [
                    0,
                    0
                ],
                u_pixels_to_tile_units: u.calculatePixelsToTileUnitsMatrix(t1),
                u_device_pixel_ratio: r,
                u_width_scale: o,
                u_floor_width_scale: a,
                u_image: 0,
                u_tile_units_to_pixels: Yb(t1, u),
                u_units_to_pixels: [
                    1 / u.pixelsToGLUnits[0],
                    1 / u.pixelsToGLUnits[1]
                ],
                u_alpha_discard_threshold: 0,
                u_trim_offset: s,
                u_trim_fade_range: i.paint.get("line-trim-fade-range"),
                u_trim_gradient_mix_range: [
                    1,
                    1
                ],
                u_trim_color: i.paint.get("line-trim-color").toPremultipliedRenderColor(d ? null : i.lut).toArray01(),
                u_zbias_factor: h,
                u_tile_to_meter: _c(t1.tileID.canonical, 0),
                u_ground_shadow_factor: l,
                u_pattern_transition: c,
                u_opacity_multiplier: 1
            };
        }, t1.ef = (e1, t1, i, n, r, o, a, s, l, c)=>{
            const u = e1.transform, h = u.calculatePixelsToTileUnitsMatrix(t1), d = "none" === i.paint.get("line-trim-color-use-theme").constantOr("default"), f = u.pitch < 15 ? hn(.07, .7, tt((14 - u.zoom) / 5, 0, 1)) : .07;
            return {
                u_matrix: Jb(e1, t1, i, n),
                u_pixels_to_tile_units: h,
                u_device_pixel_ratio: o,
                u_width_scale: a,
                u_floor_width_scale: s,
                u_units_to_pixels: [
                    1 / u.pixelsToGLUnits[0],
                    1 / u.pixelsToGLUnits[1]
                ],
                u_has_dash: +Qb(i),
                u_has_border: +(0 !== i.paint.get("line-border-width").constantOr(1)),
                u_dash_image: 0,
                u_gradient_image: 1,
                u_border_gradient_image: 2,
                u_image_height: r,
                u_texsize: Qb(i) && t1.lineAtlasTexture ? t1.lineAtlasTexture.size : [
                    0,
                    0
                ],
                u_tile_units_to_pixels: Yb(t1, e1.transform),
                u_alpha_discard_threshold: 0,
                u_trim_offset: l,
                u_trim_fade_range: i.paint.get("line-trim-fade-range"),
                u_trim_gradient_mix_range: [
                    1,
                    1
                ],
                u_trim_color: i.paint.get("line-trim-color").toPremultipliedRenderColor(d ? null : i.lut).toArray01(),
                u_zbias_factor: f,
                u_road_view_depth_bias: 0,
                u_tile_to_meter: _c(t1.tileID.canonical, 0),
                u_ground_shadow_factor: c,
                u_opacity_multiplier: 1,
                u_lpp_color: [
                    0,
                    0,
                    0,
                    1
                ],
                u_lpp_border_color: [
                    0,
                    0,
                    0,
                    0
                ],
                u_lpp_opacity: 1,
                u_lpp_blur: 0,
                u_lpp_width: 1,
                u_lpp_gap_width: 0,
                u_lpp_offset: 0,
                u_lpp_floorwidth: 1,
                u_lpp_border_width: 0,
                u_lpp_emissive_strength: 0,
                u_lpp_dash: [
                    0,
                    0,
                    0,
                    0
                ],
                u_lpp_side_z_offset: 0,
                u_lpp_zoom_fraction: 0
            };
        }, t1.eg = 0, t1.eh = Nh, t1.ei = st, t1.ej = Rb, t1.ek = 5, t1.el = xw, t1.em = hp, t1.en = P, t1.eo = jc, t1.ep = function(e1, t1) {
            var i = Math.sin(t1), n = Math.cos(t1);
            return e1[0] = n, e1[1] = 0, e1[2] = -i, e1[3] = 0, e1[4] = 0, e1[5] = 1, e1[6] = 0, e1[7] = 0, e1[8] = i, e1[9] = 0, e1[10] = n, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
        }, t1.eq = function(e1, t1) {
            var i = Math.sin(t1), n = Math.cos(t1);
            return e1[0] = 1, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = n, e1[6] = i, e1[7] = 0, e1[8] = 0, e1[9] = -i, e1[10] = n, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
        }, t1.er = function(e1, t1) {
            return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1[3] = t1[4], e1[4] = t1[5], e1[5] = t1[6], e1[6] = t1[8], e1[7] = t1[9], e1[8] = t1[10], e1;
        }, t1.es = a, t1.et = su, t1.eu = 1, t1.ev = aA, t1.ew = lu, t1.ex = function(e1, t1, i, n, r) {
            return tt((e1 - t1) / (i - t1) * (r - n) + n, n, r);
        }, t1.ey = de, t1.ez = function(e1, t1) {
            var i = t1[0], n = t1[1], r = t1[2], o = t1[3], a = t1[4], s = t1[5], l = t1[6], c = t1[7], u = t1[8], h = u * a - s * c, d = -u * o + s * l, f = c * o - a * l, p = i * h + n * d + r * f;
            return p ? (e1[0] = h * (p = 1 / p), e1[1] = (-u * n + r * c) * p, e1[2] = (s * n - r * a) * p, e1[3] = d * p, e1[4] = (u * i - r * l) * p, e1[5] = (-s * i + r * o) * p, e1[6] = f * p, e1[7] = (-c * i + n * l) * p, e1[8] = (a * i - n * o) * p, e1) : null;
        }, t1.f = class {
            constructor(e1){
                this.cache = new Map, this.textures = new Map, this.textureAccessTimes = new Map, this.textureMemoryUsed = 0, this.maxTextureMemory = 1024 * (e1 && e1.maxTextureMemoryMB ? e1.maxTextureMemoryMB : 256) * 1024, this.currentFrameAtlases = new Set, this.previousFrameAtlases = new Set, this.finalizationRegistry = new FinalizationRegistry((e1)=>{
                    this.cache.get(e1)?.deref() || this.cache.delete(e1), this.clearExpiredTextures();
                });
            }
            beginFrame() {
                const e1 = this.previousFrameAtlases;
                this.previousFrameAtlases = this.currentFrameAtlases, this.currentFrameAtlases = e1, e1.clear();
            }
            calculateTextureMemory(e1, [t1, i]) {
                return Math.ceil(t1 * i * 4 * (e1.patternPositions.size > 0 ? 1.33 : 1));
            }
            evictTexture(e1) {
                const t1 = this.textures.get(e1);
                if (t1) {
                    this.isAtlasCached(e1) && this.cache.delete(e1.contentDescriptor.hash);
                    const i = this.calculateTextureMemory(e1, t1.size);
                    t1.destroy(), this.textures.delete(e1), this.textureAccessTimes.delete(e1), this.textureMemoryUsed -= i;
                }
            }
            evictTexturesIfNeeded(e1) {
                for(; this.textureMemoryUsed + e1 > this.maxTextureMemory && this.textures.size > 0;){
                    let e1 = null, t1 = 1 / 0;
                    for (const [i] of this.textures.entries()){
                        if (this.currentFrameAtlases.has(i) || this.previousFrameAtlases.has(i)) continue;
                        const n = this.textureAccessTimes.get(i) || 0;
                        n < t1 && (t1 = n, e1 = i);
                    }
                    if (!e1) break;
                    this.evictTexture(e1);
                }
            }
            findCachedAtlas(e1) {
                const t1 = this.cache.get(e1.hash);
                if (t1) {
                    const i = t1.deref();
                    if (i && i.contentDescriptor && this.isMipmapCompatible(e1, i.contentDescriptor)) return i;
                }
                for (const [, t1] of this.cache.entries()){
                    const i = t1.deref();
                    if (i && i.contentDescriptor) {
                        const t1 = e1.subsetOf(i.contentDescriptor), n = this.isMipmapCompatible(e1, i.contentDescriptor);
                        if (t1 && n) return i;
                    }
                }
            }
            getTextureForAtlas(e1, t1, i) {
                this.textureAccessTimes.set(e1, performance.now()), this.currentFrameAtlases.add(e1);
                let n = this.textures.get(e1);
                if (n) return n;
                if (e1.image) {
                    const r = this.calculateTextureMemory(e1, [
                        e1.image.width,
                        e1.image.height
                    ]);
                    return this.evictTexturesIfNeeded(r), n = new X_(t1, e1.image, i, {
                        useMipmap: !!e1.patternPositions.size
                    }), this.textures.set(e1, n), this.textureMemoryUsed += r, e1.image = null, n;
                }
                return null;
            }
            clearExpiredTextures() {
                for (const e1 of this.textures.keys())this.isAtlasCached(e1) || this.evictTexture(e1);
            }
            isAtlasCached(e1) {
                if (!e1.contentDescriptor) return !1;
                const t1 = this.cache.get(e1.contentDescriptor.hash);
                return !!t1 && t1.deref() === e1;
            }
            getOrCache(e1) {
                if (!("image" in e1)) {
                    const t1 = this.cache.get(e1.sourceAtlasHash);
                    if (t1) {
                        const e1 = t1.deref();
                        if (e1) return e1;
                    }
                    return _t("ImageAtlasReference points to GC'd atlas - atlas may have been evicted"), null;
                }
                if (!e1.contentDescriptor) return e1;
                const t1 = e1.contentDescriptor, i = t1.hash, n = this.cache.get(i);
                if (n) {
                    const e1 = n.deref();
                    if (e1 && e1.contentDescriptor && this.isMipmapCompatible(t1, e1.contentDescriptor)) return e1;
                }
                return this.cache.set(i, new WeakRef(e1)), this.finalizationRegistry.register(e1, i, e1), e1;
            }
            isMipmapCompatible(e1, t1) {
                return !e1.requiresMipMaps || t1.requiresMipMaps;
            }
            clear() {
                for (const e1 of this.textures.values())e1.destroy();
                this.cache.clear(), this.textures.clear(), this.textureAccessTimes.clear(), this.textureMemoryUsed = 0, this.currentFrameAtlases.clear(), this.previousFrameAtlases.clear();
            }
            removeScope(e1) {
                for (const [t1, i] of this.cache){
                    const n = i.deref();
                    n && n.contentDescriptor.scope !== e1 || this.cache.delete(t1);
                }
                this.clearExpiredTextures();
            }
        }, t1.f$ = Sf, t1.f0 = Yi, t1.f1 = Ki, t1.f2 = Si, t1.f3 = ji, t1.f4 = Hi, t1.f5 = Zi, t1.f6 = qi, t1.f7 = function(e1) {
            Qi.delete(e1);
        }, t1.f8 = Ji, t1.f9 = Ui, t1.fA = hy, t1.fB = Ge, t1.fC = Qr, t1.fD = function(e1, t1) {
            const i = e1.layers[0].layout.get("fill-elevation-reference"), n = "hd-road-base" === i || "hd-road-markup" === i ? i : null, r = !!t1 && t1.length > 0 && dy(t1, e1.layers[0].source, e1.sourceLayerName);
            (n || r) && (e1.hdExt = new fy(e1, n, r));
        }, t1.fE = function(e1, t1) {
            const i = "hd-road-markup" === e1.layers[0].layout.get("line-elevation-reference"), n = !!t1 && t1.length > 0 && dy(t1, e1.layers[0].source, e1.sourceLayerName);
            (i || n) && (e1.hdExt = new my(i, n));
        }, t1.fF = Vd, t1.fG = function(e1) {
            const t1 = e1.layers[0];
            "circle" === t1.type && "hd-road-markup" === t1.layout.get("circle-elevation-reference") && (e1.hdExt = new gy);
        }, t1.fH = function(e1) {
            "hd-road-markup" === e1.layers[0].layout.get("symbol-elevation-reference") && (e1.hdExt = new xy);
        }, t1.fI = Ey, t1.fJ = vI, t1.fK = function(e1) {
            let t1 = 0;
            if (new Uint32Array(e1, 0, 1)[0] !== Ny) {
                const i = new Uint32Array(e1, 0, 7), [, , n, r, o, a] = i;
                t1 = i.byteLength + r + o + a + o, (n !== e1.byteLength || t1 >= e1.byteLength) && _t("Invalid b3dm header information.");
            }
            return $y(e1, t1);
        }, t1.fL = function(e1, t1) {
            const i = kx(e1);
            for (const e1 of i){
                if (!e1.meshBVH) for (const t1 of e1.meshes)Ux(t1);
                if (e1.lights) {
                    let i = 65535;
                    for (const t1 of e1.meshes)void 0 !== t1.doorVertexColor && (i = t1.doorVertexColor, e1.lightsStyleAabb = t1.aabb);
                    e1.lightMeshIndex = e1.meshes.length, e1.meshes.push(Gx(e1.lights, t1, i));
                }
            }
            return i;
        }, t1.fM = _c, t1.fN = $w, t1.fO = Ya, t1.fQ = function(e1, t1) {
            let i = "";
            for(let n = 0; n < e1.length; n++){
                const r = e1.charCodeAt(n + 1) || null, o = e1.charCodeAt(n - 1) || null;
                i += !t1 && (r && Ds(r) && !ff[e1[n + 1]] || o && Ds(o) && !ff[e1[n - 1]]) || !ff[e1[n]] ? e1[n] : ff[e1[n]];
            }
            return i;
        }, t1.fR = function(e1) {
            return !(e1 < 11904 || !(ds(e1) || hs(e1) || Is(e1) || ws(e1) || ms(e1) || os(e1) || fs(e1) || ls(e1) || gs(e1) || ys(e1) || _s(e1) || Ts(e1) || cs(e1) || ss(e1) || as(e1) || ps(e1) || us(e1) || Es(e1) || vs(e1) || xs(e1)));
        }, t1.fS = Ps, t1.fT = function(e1) {
            return is(e1) || ns(e1) || rs(e1) || As(e1) || Ss(e1);
        }, t1.fU = function(e1) {
            return 12307 === e1 || 12312 === e1 || 12313 === e1 || 12316 === e1 || 12448 === e1 || 12540 === e1 || e1 >= 8592 && e1 <= 8595 || 8208 === e1 || 8229 === e1 || 8741 === e1 || e1 >= 9472 && e1 <= 9547 || 65294 === e1 || 65309 === e1 || 65374 === e1 || 65507 === e1;
        }, t1.fV = 3, t1.fW = Mr, t1.fX = sd, t1.fY = Td, t1.fZ = function(e1) {
            for (const t1 of e1)if (!Rs(t1.charCodeAt(0))) return !1;
            return !0;
        }, t1.f_ = zs, t1.fa = i, t1.fb = xi, t1.fc = function(e1, t1) {
            Wt = e1, qt = t1;
        }, t1.fd = fp, t1.fe = Je, t1.ff = dp, t1.fg = up, t1.fh = function(e1) {
            Li = e1;
        }, t1.fi = ii, t1.fj = mA, t1.fk = function(e1, t1) {
            if (!e1 || !t1) throw new Error("TileProvider name and URL are required");
            kt.TILE_PROVIDER_URLS[e1] = Vt.resolveURL(t1);
        }, t1.fl = function(e1) {
            "string" != typeof e1 || e1.length > 64 || !Oi.test(e1) ? _t(`Invalid SDK info "${e1}"; expected a "Name/version" string. Ignoring.`) : Ci = e1;
        }, t1.fm = function(e1) {
            kt.BUILDING_GEN_URL = Vt.resolveURL(e1);
        }, t1.fn = Gt, t1.fo = function(e1) {
            const t1 = Vt.resolveURL(e1);
            kt.MESHOPT_URL = t1, kt.MESHOPT_SIMD_URL = t1;
        }, t1.fp = jt, t1.fq = function(e1) {
            kt.DRACO_URL = Vt.resolveURL(e1);
        }, t1.fr = Ut, t1.fs = function(e1) {
            const t1 = Jt();
            if (!t1) return;
            const i = t1.delete(Zt);
            e1 && i.then(()=>e1()).catch(e1);
        }, t1.ft = function(e1) {
            kt.MAX_PARALLEL_IMAGE_REQUESTS = e1;
        }, t1.fu = function(e1) {
            kt.API_URL = e1;
        }, t1.fv = function(e1) {
            kt.ACCESS_TOKEN = e1;
        }, t1.fw = "hd_road_elevation", t1.fx = class {
            static parseFrom(e1, t1) {
                const i = ig.parse(e1);
                if (!i) return [];
                let { vertices: n, features: r } = i;
                const o = 1 / _c(t1);
                r.sort((e1, t1)=>e1.id - t1.id), n.sort((e1, t1)=>e1.id - t1.id || e1.idx - t1.idx), n = n.filter((e1, t1, i)=>t1 === i.findIndex((t1)=>t1.id === e1.id && t1.idx === e1.idx));
                const a = new Array;
                let s = 0;
                const l = n.length;
                for (const e1 of r){
                    if (e1.constantHeight) {
                        a.push(new cg(e1.id, e1.bounds, e1.constantHeight));
                        continue;
                    }
                    for(; s !== l && n[s].id < e1.id;)s++;
                    if (s === l || n[s].id !== e1.id) continue;
                    const t1 = new Array, i = new Array, r = s;
                    for(; s !== l && n[s].id === e1.id;){
                        const e1 = n[s];
                        if (t1.push({
                            position: e1.position,
                            height: e1.height,
                            extent: e1.extent,
                            index: e1.idx
                        }), s !== r && n[s - 1].idx === e1.idx - 1) {
                            const e1 = s - r;
                            i.push({
                                a: e1 - 1,
                                b: e1
                            });
                        }
                        s++;
                    }
                    a.push(new cg(e1.id, e1.bounds, void 0, t1, i, o));
                }
                return a;
            }
        }, t1.fy = qm, t1.fz = fb, t1.g = fi, t1.g0 = hf, t1.g1 = df, t1.g2 = K_, t1.g3 = 1, t1.g4 = Ef, t1.g5 = If, t1.g6 = Ve, t1.g7 = gf, t1.g8 = zf, t1.g9 = Ap, t1.ga = fm, t1.gb = Tf, t1.gc = function(e1, t1) {
            const i = e1.stretchY || [
                [
                    0,
                    e1.paddedRect.h - 2
                ]
            ];
            return e1.stretchX || e1.stretchY ? mm(e1.stretchX || [
                [
                    0,
                    e1.paddedRect.w - 2
                ]
            ]) * mm(i) : 1;
        }, t1.gd = vm, t1.ge = Ed, t1.gf = 2, t1.gg = qw, t1.gh = Sd, t1.gi = dy, t1.gj = function(e1, t1) {
            const i = hy(e1);
            return null !== i && !!(t1 & 1 << i);
        }, t1.gk = function() {
            if (!t1.fP) return sf ??= (async function(e1) {
                const { instance: t1 } = await WebAssembly.instantiateStreaming(e1), { memory: i, ushapeArabic: n, bidiProcessLines: r, malloc: o, free: a } = t1.exports;
                t1.exports._initialize();
                const s = new Uint16Array(i.buffer), l = new Int32Array(i.buffer), c = new TextDecoder("utf-16le");
                function u(e1, t1) {
                    const i = o(2 * e1.length + t1);
                    if (!i) throw new Error("mapbox-gl-rtl-text: out of memory");
                    for(let t1 = 0; t1 < e1.length; t1++)s[(i >> 1) + t1] = e1.charCodeAt(t1);
                    return i;
                }
                function h(e1, t1) {
                    return c.decode(new Uint16Array(i.buffer, e1, t1));
                }
                function d(e1, t1, i) {
                    if (!e1) return [
                        i ? [
                            e1,
                            i
                        ] : e1
                    ];
                    const n = e1.length, o = t1.length, s = u(e1, 10 * n + 8 * o), c = s + 2 * n, d = s + 4 * n >> 2, f = d + n, p = f + o;
                    l.set(t1, f);
                    const _ = r(s, n, f << 2, o, c, d << 2, p << 2);
                    if (_ <= 0) return a(s), _ ? [] : [
                        i ? [
                            e1,
                            i
                        ] : e1
                    ];
                    const m = h(c, l[p + _ - 1]), g = [];
                    for(let e1 = 0, t1 = 0; e1 < _; e1++){
                        const n = l[p + e1], r = m.slice(t1, n);
                        if (i) {
                            const e1 = [];
                            for(let r = t1; r < n; r++)e1.push(i[l[d + r]]);
                            g.push([
                                r,
                                e1
                            ]);
                        } else g.push(r);
                        t1 = n;
                    }
                    return a(s), g;
                }
                return {
                    applyArabicShaping: function(e1) {
                        if (!e1) return e1;
                        const t1 = u(e1, 2 * e1.length), i = t1 + 2 * e1.length, r = n(t1, e1.length, i), o = r < 0 ? e1 : h(i, r);
                        return a(t1), o;
                    },
                    processBidirectionalText: function(e1, t1) {
                        return d(e1, t1);
                    },
                    processStyledBidirectionalText: function(e1, t1, i) {
                        return d(e1, i, t1);
                    }
                };
            })(fetch(new URL(kt.RTL_TEXT_URL, kt.API_URL))).then((e1)=>{
                t1.fP = e1;
            }), sf;
        }, t1.gl = ut, t1.gm = Q_, t1.gn = Z_, t1.go = em, t1.gp = tm, t1.gq = Jh, t1.gr = function(e1) {
            return e1 <= 1 ? 1 : Math.pow(2, Math.floor(Math.log2(e1)));
        }, t1.gs = FM, t1.gt = Wh, t1.gu = class {
            constructor(e1 = new Uint8Array(16)){
                this.buf = ArrayBuffer.isView(e1) ? e1 : new Uint8Array(e1), this.dataView = new DataView(this.buf.buffer, this.buf.byteOffset, this.buf.byteLength), this.pos = 0, this.length = this.buf.length;
            }
            writeTag(e1, t1) {
                this.writeVarint(e1 << 3 | t1);
            }
            realloc(e1) {
                let t1 = this.length || 16;
                for(; t1 < this.pos + e1;)t1 *= 2;
                if (t1 !== this.length) {
                    const e1 = new Uint8Array(t1);
                    e1.set(this.buf), this.buf = e1, this.dataView = new DataView(e1.buffer), this.length = t1;
                }
            }
            finish() {
                return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
            }
            writeFixed32(e1) {
                this.realloc(4), this.dataView.setInt32(this.pos, e1, !0), this.pos += 4;
            }
            writeSFixed32(e1) {
                this.realloc(4), this.dataView.setInt32(this.pos, e1, !0), this.pos += 4;
            }
            writeFixed64(e1) {
                this.realloc(8), this.dataView.setInt32(this.pos, -1 & e1, !0), this.dataView.setInt32(this.pos + 4, Math.floor(e1 * I_), !0), this.pos += 8;
            }
            writeSFixed64(e1) {
                this.realloc(8), this.dataView.setInt32(this.pos, -1 & e1, !0), this.dataView.setInt32(this.pos + 4, Math.floor(e1 * I_), !0), this.pos += 8;
            }
            writeVarint(e1) {
                if ((e1 = +e1 || 0) >= 0 && e1 < 128) return this.pos >= this.length && this.realloc(1), void (this.buf[this.pos++] = e1);
                e1 > 268435455 || e1 < 0 ? function(e1, t1) {
                    let i, n;
                    if (e1 >= 0 ? (i = e1 % 4294967296 | 0, n = e1 / 4294967296 | 0) : (i = ~(-e1 % 4294967296), n = ~(-e1 / 4294967296), 4294967295 ^ i ? i = i + 1 | 0 : (i = 0, n = n + 1 | 0)), e1 >= 0x10000000000000000 || e1 < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                    t1.realloc(10), function(e1, t1, i) {
                        i.buf[i.pos++] = 127 & e1 | 128, e1 >>>= 7, i.buf[i.pos++] = 127 & e1 | 128, e1 >>>= 7, i.buf[i.pos++] = 127 & e1 | 128, e1 >>>= 7, i.buf[i.pos++] = 127 & e1 | 128, i.buf[i.pos] = 127 & (e1 >>>= 7);
                    }(i, 0, t1), function(e1, t1) {
                        const i = (7 & e1) << 4;
                        t1.buf[t1.pos++] |= i | ((e1 >>>= 3) ? 128 : 0), e1 && (t1.buf[t1.pos++] = 127 & e1 | ((e1 >>>= 7) ? 128 : 0), e1 && (t1.buf[t1.pos++] = 127 & e1 | ((e1 >>>= 7) ? 128 : 0), e1 && (t1.buf[t1.pos++] = 127 & e1 | ((e1 >>>= 7) ? 128 : 0), e1 && (t1.buf[t1.pos++] = 127 & e1 | ((e1 >>>= 7) ? 128 : 0), e1 && (t1.buf[t1.pos++] = 127 & e1)))));
                    }(n, t1);
                }(e1, this) : (this.realloc(4), this.buf[this.pos++] = 127 & e1 | (e1 > 127 ? 128 : 0), e1 <= 127 || (this.buf[this.pos++] = 127 & (e1 >>>= 7) | (e1 > 127 ? 128 : 0), e1 <= 127 || (this.buf[this.pos++] = 127 & (e1 >>>= 7) | (e1 > 127 ? 128 : 0), e1 <= 127 || (this.buf[this.pos++] = e1 >>> 7 & 127))));
            }
            writeSVarint(e1) {
                this.writeVarint(e1 < 0 ? 2 * -e1 - 1 : 2 * e1);
            }
            writeBoolean(e1) {
                this.writeVarint(+e1);
            }
            writeString(e1) {
                e1 = String(e1), this.realloc(4 * e1.length), this.pos++;
                const t1 = this.pos;
                this.pos = function(e1, t1, i) {
                    for(let n, r, o = 0; o < t1.length; o++){
                        if (n = t1.charCodeAt(o), n > 55295 && n < 57344) {
                            if (!r) {
                                n > 56319 || o + 1 === t1.length ? (e1[i++] = 239, e1[i++] = 191, e1[i++] = 189) : r = n;
                                continue;
                            }
                            if (n < 56320) {
                                e1[i++] = 239, e1[i++] = 191, e1[i++] = 189, r = n;
                                continue;
                            }
                            n = r - 55296 << 10 | n - 56320 | 65536, r = null;
                        } else r && (e1[i++] = 239, e1[i++] = 191, e1[i++] = 189, r = null);
                        n < 128 ? e1[i++] = n : (n < 2048 ? e1[i++] = n >> 6 | 192 : (n < 65536 ? e1[i++] = n >> 12 | 224 : (e1[i++] = n >> 18 | 240, e1[i++] = n >> 12 & 63 | 128), e1[i++] = n >> 6 & 63 | 128), e1[i++] = 63 & n | 128);
                    }
                    return i;
                }(this.buf, e1, this.pos);
                const i = this.pos - t1;
                i >= 128 && z_(t1, i, this), this.pos = t1 - 1, this.writeVarint(i), this.pos += i;
            }
            writeFloat(e1) {
                this.realloc(4), this.dataView.setFloat32(this.pos, e1, !0), this.pos += 4;
            }
            writeDouble(e1) {
                this.realloc(8), this.dataView.setFloat64(this.pos, e1, !0), this.pos += 8;
            }
            writeBytes(e1) {
                const t1 = e1.length;
                this.writeVarint(t1), this.realloc(t1), this.buf.set(e1, this.pos), this.pos += t1;
            }
            writeRawMessage(e1, t1) {
                this.pos++;
                const i = this.pos;
                e1(t1, this);
                const n = this.pos - i;
                n >= 128 && z_(i, n, this), this.pos = i - 1, this.writeVarint(n), this.pos += n;
            }
            writeMessage(e1, t1, i) {
                this.writeTag(e1, 2), this.writeRawMessage(t1, i);
            }
            writePackedVarint(e1, t1) {
                t1.length && this.writeMessage(e1, R_, t1);
            }
            writePackedSVarint(e1, t1) {
                t1.length && this.writeMessage(e1, P_, t1);
            }
            writePackedBoolean(e1, t1) {
                t1.length && this.writeMessage(e1, C_, t1);
            }
            writePackedFloat(e1, t1) {
                t1.length && this.writeMessage(e1, D_, t1);
            }
            writePackedDouble(e1, t1) {
                t1.length && this.writeMessage(e1, F_, t1);
            }
            writePackedFixed32(e1, t1) {
                t1.length && this.writeMessage(e1, O_, t1);
            }
            writePackedSFixed32(e1, t1) {
                t1.length && this.writeMessage(e1, L_, t1);
            }
            writePackedFixed64(e1, t1) {
                t1.length && this.writeMessage(e1, B_, t1);
            }
            writePackedSFixed64(e1, t1) {
                t1.length && this.writeMessage(e1, V_, t1);
            }
            writeBytesField(e1, t1) {
                this.writeTag(e1, 2), this.writeBytes(t1);
            }
            writeFixed32Field(e1, t1) {
                this.writeTag(e1, 5), this.writeFixed32(t1);
            }
            writeSFixed32Field(e1, t1) {
                this.writeTag(e1, 5), this.writeSFixed32(t1);
            }
            writeFixed64Field(e1, t1) {
                this.writeTag(e1, 1), this.writeFixed64(t1);
            }
            writeSFixed64Field(e1, t1) {
                this.writeTag(e1, 1), this.writeSFixed64(t1);
            }
            writeVarintField(e1, t1) {
                this.writeTag(e1, 0), this.writeVarint(t1);
            }
            writeSVarintField(e1, t1) {
                this.writeTag(e1, 0), this.writeSVarint(t1);
            }
            writeStringField(e1, t1) {
                this.writeTag(e1, 2), this.writeString(t1);
            }
            writeFloatField(e1, t1) {
                this.writeTag(e1, 5), this.writeFloat(t1);
            }
            writeDoubleField(e1, t1) {
                this.writeTag(e1, 1), this.writeDouble(t1);
            }
            writeBooleanField(e1, t1) {
                this.writeVarintField(e1, +t1);
            }
        }, t1.gv = xt, t1.gw = Zp, t1.gx = AI, t1.gy = function(e1) {
            Kt(), null != Yt && Yt.then((t1)=>{
                t1.keys().then((i)=>{
                    for(let n = 0; n < i.length - e1; n++)t1.delete(i[n]).catch((e1)=>_t(e1.message));
                }).catch((e1)=>_t(e1.message));
            }).catch((e1)=>_t(e1.message));
        }, t1.h = nn, t1.i = tn, t1.j = kn, t1.k = 2, t1.l = J_, t1.m = ul, t1.n = pi, t1.o = Bt, t1.p = U_, t1.q = function(e1) {
            return function(e1) {
                const t1 = {
                    glyphs: []
                };
                let i;
                for(; i = e1.nextField();)1 === i && N_(e1, e1.readVarint() + e1.pos, t1);
                return t1;
            }(new S_(e1));
        }, t1.r = hm, t1.s = Ws, t1.t = kt, t1.u = function(e1, t1, i) {
            if (!e1.length) return i(null, []);
            let n = e1.length;
            const r = new Array(e1.length);
            let o = null;
            e1.forEach((e1, a)=>{
                t1(e1, (e1, t1)=>{
                    e1 && (o = e1), r[a] = t1, 0 === --n && i(o, r);
                });
            });
        }, t1.v = Qn, t1.w = _t, t1.x = qs, t1.y = Kn, t1.z = tr;
    });
    define([
        "./shared"
    ], function(e1) {
        function t1(e1) {
            const t1 = e1 ? e1.url.toString() : void 0;
            return t1 ? performance.getEntriesByName(t1) : [];
        }
        function o(t1, o) {
            if (Object.hasOwn(t1.layers, e1.fw)) return e1.fx.parseFrom(t1.layers[e1.fw], o);
        }
        function n({ buckets: t1, data: o, sourceLayerCoder: n, canonical: i, options: s }) {
            if (!s.elevationFeatures || 0 === s.elevationFeatures.length) return;
            const r = [];
            for (const o of Object.values(t1))if (o instanceof e1.bL && o.hdExt) {
                const e1 = o.hdExt.getUnevaluatedPortalGraph();
                e1 && r.push(e1);
            }
            const a = e1.fy.evaluate(r);
            for (const r of Object.values(t1))if (r instanceof e1.bL && r.hdExt) {
                const e1 = o.layers[n.decode(r.sourceLayerIndex)];
                r.hdExt.setEvaluatedPortalGraph(a, e1, i, s.availableImages, s.brightness, r.worldview);
            }
        }
        function i(t1) {
            const o = [];
            for(let n = 0; n < t1.length; n++){
                const i = t1.feature(n), s = i.properties.frc_mask;
                if (null == s) continue;
                const r = Number(s);
                if (!r) continue;
                const a = i.loadGeometry();
                if (a.length > 0) {
                    let t1 = !1;
                    for (const o of a[0])if (o.x < 0 || o.x > e1.ac || o.y < 0 || o.y > e1.ac) {
                        t1 = !0;
                        break;
                    }
                    if (t1) continue;
                }
                const l = 1 === a.length && 5 === a[0].length && a[0].some((e1)=>e1.x <= 0 && e1.y <= 0) && a[0].some((t1)=>t1.x >= e1.ac && t1.y <= 0) && a[0].some((t1)=>t1.x >= e1.ac && t1.y >= e1.ac) && a[0].some((t1)=>t1.x <= 0 && t1.y >= e1.ac);
                o.push(new e1.fz(r, l ? [] : a));
            }
            return o;
        }
        function s(t1, o, n, i, s) {
            const r = e1.fA(o);
            if (null === r) return !1;
            let a = n.x, l = n.y;
            const c = s ?? i.z;
            if (i.z !== c) {
                const t1 = 1 << i.z - c, o = e1.ac / t1;
                a = i.x % t1 * o + n.x / t1, l = i.y % t1 * o + n.y / t1;
            }
            for (const o of t1){
                if (!(o.hasGeometry() && o.frcMask & 1 << r)) continue;
                const t1 = o.rings.map((e1)=>e1.map((e1)=>[
                            e1.x,
                            e1.y
                        ]));
                if (e1.fB([
                    a,
                    l
                ], t1)) return !0;
            }
            return !1;
        }
        function r(t1, o, n, i) {
            const s = o.indoorState.activeFloorsVisible;
            if (!o.sourceLayers) return s ? o.indoorState.activeFloors : void 0;
            const r = function(t1, o) {
                if (!t1) return e1.w("No source layers defined in indoor specification"), o;
                if (0 === t1.size) return o;
                const n = t1.difference(o);
                for (const t1 of n)e1.w(`Missing source layer required in indoor specification: ${t1}`);
                return o.intersection(o);
            }(o.sourceLayers, new Set(Object.keys(t1.layers))), h = o.indoorState, g = function(t1, o, n, i, s) {
                const r = {};
                for (const n of o){
                    const o = t1.layers[n];
                    if (o) for(let e1 = 0; e1 < o.length; e1++){
                        const t1 = o.feature(e1);
                        if (d(t1)) {
                            const { id: e1, center: o } = c(t1);
                            a(r, e1, o);
                            continue;
                        }
                        if (f(t1)) {
                            const e1 = u(t1, s);
                            l(r, e1.buildings, e1.id, e1);
                        }
                    }
                    else e1.w(`indoor source layer not found: ${n}`);
                }
                return {
                    buildings: r,
                    activeFloors: e1.b5.calculate(r, i, n)
                };
            }(t1, r, h.activeFloors, h.selectedFloorId, i);
            return n.notify("setIndoorData", g), s ? g.activeFloors : void 0;
        }
        function a(e1, t1, o) {
            e1[t1] ? o && (e1[t1].center = o) : e1[t1] = {
                floorIds: new Set,
                center: o || [
                    0,
                    0
                ],
                floors: {}
            };
        }
        function l(e1, t1, o, n) {
            for (const i of t1)a(e1, i), e1[i].floors[o] = n, e1[i].floorIds.add(o);
        }
        function c(e1) {
            return {
                id: e1.properties.id.toString(),
                center: [
                    e1.properties.center_lon || 0,
                    e1.properties.center_lat || 0
                ]
            };
        }
        function u(t1, o) {
            const n = t1.properties.id.toString(), i = !!t1.properties.is_default && t1.properties.is_default, s = t1.properties.connected_floor_ids ? new Set(t1.properties.connected_floor_ids.toString().split(";")) : new Set, r = t1.properties.conflicted_floor_ids ? new Set(t1.properties.conflicted_floor_ids.toString().split(";")) : new Set, a = t1.properties.structure_ids ? new Set(t1.properties.structure_ids.toString().split(";")) : new Set, l = t1.properties.name.toString(), c = t1.properties.z_index, u = function(t1, o) {
                const n = t1.loadGeometry();
                if (!n || 0 === n.length) return;
                const i = n.map((n)=>n.map((n)=>e1.fC(n, o, t1.extent)));
                return 0 === i.length ? void 0 : {
                    type: "Polygon",
                    coordinates: [
                        i[0]
                    ]
                };
            }(t1, o);
            return {
                id: n,
                isDefault: i,
                connections: s,
                conflicts: r,
                buildings: a,
                name: l,
                zIndex: c,
                geometry: u
            };
        }
        function h(e1, t1) {
            return t1.every((t1)=>e1.properties && null != e1.properties[t1]);
        }
        function d(e1) {
            return h(e1, [
                "type",
                "id",
                "name"
            ]) && "structure" === e1.properties.type;
        }
        function f(e1) {
            return h(e1, [
                "type",
                "id",
                "name",
                "z_index"
            ]) && "floor" === e1.properties.type;
        }
        function g(t1, o) {
            t1 instanceof e1.bL ? e1.fD(t1, o) : t1 instanceof e1.bG ? e1.fE(t1, o) : t1 instanceof e1.fF ? e1.fG(t1) : t1 instanceof e1.bF && e1.fH(t1);
        }
        function p(t1) {
            for(const o in t1){
                const n = t1[o];
                if (n instanceof e1.bG && n.hdExt && n.hdExt.hasDeferredElevationFeatures) return !0;
                if (n instanceof e1.bF && n.hdExt && n.hdExt.hasDeferredElevationFeatures) return !0;
            }
            return !1;
        }
        class m {
            constructor(t1, o, n){
                this.tileID = new e1.bZ(t1.tileID.overscaledZ, t1.tileID.wrap, t1.tileID.canonical.z, t1.tileID.canonical.x, t1.tileID.canonical.y), this.tileZoom = t1.tileZoom, this.uid = t1.uid, this.zoom = t1.zoom, this.canonical = t1.tileID.canonical, this.pixelRatio = t1.pixelRatio, this.tileSize = t1.tileSize, this.source = t1.source, this.overscaling = this.tileID.overscaleFactor(), this.projection = t1.projection, this.brightness = o, this.worldview = n;
            }
            async parse(t1, o, n) {
                this.status = "parsing";
                const i = new e1.bZ(n.tileID.overscaledZ, n.tileID.wrap, n.tileID.canonical.z, n.tileID.canonical.x, n.tileID.canonical.y), s = [], r = o.familiesBySource[n.source], a = new e1.fJ(i, n.promoteId);
                a.bucketLayerIDs = [], a.is3DTile = !0;
                const l = await e1.fK(t1), c = l.json.extensionsUsed && l.json.extensionsUsed.includes("MAPBOX_mesh_features") || l.json.asset.extras && l.json.asset.extras.MAPBOX_mesh_features, u = l.json.extensionsUsed && l.json.extensionsUsed.includes("EXT_meshopt_compression"), h = new e1.au(this.zoom, {
                    brightness: this.brightness,
                    worldview: this.worldview
                });
                for(const t1 in r)for (const o of r[t1]){
                    const t1 = o[0];
                    a.bucketLayerIDs.push(o.map((t1)=>e1.m(t1.id, t1.scope))), t1.recalculate(h, []);
                    const r = e1.fL(l, 1 / e1.fM(n.tileID.canonical)), d = new e1.fN(o, r, i, c, u, this.brightness, a, this.worldview);
                    s.push(d), d.evaluate(t1);
                }
                return this.status = "done", {
                    buckets: s,
                    featureIndex: a,
                    collisionBoxArray: null,
                    glyphAtlasImage: null,
                    lineAtlas: null,
                    imageAtlas: null,
                    brightness: null
                };
            }
        }
        class y {
            constructor({ actor: e1, layerIndex: t1, availableImages: o, availableModels: n, brightness: i, worldview: s }){
                this.actor = e1, this.layerIndex = t1, this.availableImages = o, this.availableModels = n, this.brightness = i, this.loading = {}, this.loaded = {}, this.worldview = s;
            }
            async loadTile(t1) {
                const o = t1.uid;
                e1.fI()?.catch(()=>{});
                const n = new AbortController, i = this.loading[o] = new m(t1, this.brightness, this.worldview);
                i.abort = ()=>n.abort();
                const s = (e1, t1)=>{
                    const o = i.reloadCallback;
                    o && (delete i.reloadCallback, o(e1, t1));
                };
                let r;
                try {
                    r = (await e1.n(t1.request, n.signal)).data;
                } catch (e1) {
                    if (delete this.loading[o], i.status = "done", this.loaded[o] = i, n.signal.aborted) return null;
                    throw e1;
                }
                if (delete this.loading[o], !r || 0 === r.byteLength) return i.status = "done", this.loaded[o] = i, null;
                try {
                    const e1 = await i.parse(r, this.layerIndex, t1);
                    return this.loaded[o] = i, s(null, e1), e1;
                } catch (e1) {
                    throw this.loaded[o] = i, s(e1), e1;
                }
            }
            async reloadTile(e1) {
                const t1 = this.loaded && this.loaded[e1.uid];
                if (t1) return t1.projection = e1.projection, t1.brightness = e1.brightness, "parsing" === t1.status && await new Promise((e1, o)=>{
                    t1.reloadCallback = (t1)=>{
                        t1 ? o(t1) : e1();
                    };
                }), this.loadTile(e1);
            }
            abortTile(e1) {
                const t1 = e1.uid, o = this.loading[t1];
                o && (o.abort && o.abort(), delete this.loading[t1]);
            }
            removeTile(e1) {
                const t1 = this.loaded, o = e1.uid;
                t1 && t1[o] && delete t1[o];
            }
        }
        function x(e1) {
            if ("number" == typeof e1 || "boolean" == typeof e1 || "string" == typeof e1 || null == e1) return JSON.stringify(e1);
            if (Array.isArray(e1)) {
                let t1 = "[";
                for (const o of e1)t1 += `${x(o)},`;
                return `${t1}]`;
            }
            let t1 = "{";
            for (const o of Object.keys(e1).sort())t1 += `${o}:${x(e1[o])},`;
            return `${t1}}`;
        }
        function w(t1) {
            let o = "";
            for (const n of e1.d6)o += `/${x(t1[n])}`;
            return o;
        }
        function v(e1, t1) {
            return function e1(o) {
                return "string" == typeof o && o === t1 || (Array.isArray(o) ? o.some(e1) : !(!o || "object" != typeof o) && Object.values(o).some(e1));
            }(e1);
        }
        class b {
            constructor(e1){
                this.keyCache = Object.create(null), this._layers = Object.create(null), this._layerConfigs = Object.create(null), e1 && this.replace(e1);
            }
            replace(e1, t1) {
                this._layerConfigs = Object.create(null), this._layers = Object.create(null), this.update(e1, [], t1);
            }
            update(t1, o, n) {
                this._options = n;
                for (const o of t1)this._layerConfigs[o.id] = o, (this._layers[o.id] = e1.dR(o, this.scope, null, this._options)).compileFilter(n), this.keyCache[o.id] && delete this.keyCache[o.id];
                for (const e1 of o)delete this.keyCache[e1], delete this._layerConfigs[e1], delete this._layers[e1];
                this.familiesBySource = Object.create(null);
                const i = function(e1, t1) {
                    const o = Object.create(null);
                    for(let n = 0; n < e1.length; n++){
                        const i = e1[n];
                        let s = t1 && t1[i.id];
                        s || ("symbol" === i.type ? s = i.id : (s = w(i), "line" === i.type && i.paint && (v(i.paint["line-width"], "line-progress") && (s += `/${x(i.paint["line-width"])}`), v(i.paint["line-emissive-strength"], "line-progress") && (s += `/${x(i.paint["line-emissive-strength"])}`)))), t1 && (t1[i.id] = s);
                        let r = o[s];
                        r || (r = o[s] = []), r.push(i);
                    }
                    const n = [];
                    for(const e1 in o)n.push(o[e1]);
                    return n;
                }(Object.values(this._layerConfigs), this.keyCache);
                for (const e1 of i){
                    const t1 = e1.map((e1)=>this._layers[e1.id]), o = t1[0];
                    if ("none" === o.visibility) continue;
                    o.prepare();
                    const n = o.source || "";
                    let i = this.familiesBySource[n];
                    i || (i = this.familiesBySource[n] = Object.create(null));
                    const s = o.sourceLayer || "_geojsonTileLayer";
                    let r = i[s];
                    r || (r = i[s] = []), r.push(t1);
                }
            }
        }
        class S extends e1.P {
            constructor(e1, t1, o, n, i){
                super(e1, t1), this.angle = n, this.z = o, void 0 !== i && (this.segment = i);
            }
            clone() {
                return new S(this.x, this.y, this.z, this.angle, this.segment);
            }
        }
        function I(e1, t1, o, n, i) {
            if (void 0 === t1.segment) return !0;
            let s = t1, r = t1.segment + 1, a = 0;
            for(; a > -o / 2;){
                if (r--, r < 0) return !1;
                a -= e1[r].dist(s), s = e1[r];
            }
            a += e1[r].dist(e1[r + 1]), r++;
            const l = [];
            let c = 0;
            for(; a < o / 2;){
                const t1 = e1[r], o = e1[r + 1];
                if (!o) return !1;
                let s = e1[r - 1].angleTo(t1) - t1.angleTo(o);
                for(s = Math.abs((s + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l.push({
                    distance: a,
                    angleDelta: s
                }), c += s; a - l[0].distance > n;)c -= l.shift().angleDelta;
                if (c > i) return !1;
                r++, a += t1.dist(o);
            }
            return !0;
        }
        function M(e1) {
            let t1 = 0;
            for(let o = 0; o < e1.length - 1; o++)t1 += e1[o].dist(e1[o + 1]);
            return t1;
        }
        function T(e1, t1, o) {
            return e1 ? .6 * t1 * o : 0;
        }
        function P(e1, t1) {
            return Math.max(e1 ? e1.right - e1.left : 0, t1 ? t1.right - t1.left : 0);
        }
        function z(t1, o, n, i, s, r) {
            const a = T(n, s, r), l = P(n, i) * r;
            let c = 0;
            const u = M(t1) / 2;
            for(let n = 0; n < t1.length - 1; n++){
                const i = t1[n], s = t1[n + 1], r = i.dist(s);
                if (c + r > u) {
                    const h = (u - c) / r, d = e1.aw(i.x, s.x, h), f = e1.aw(i.y, s.y, h), g = new S(d, f, 0, s.angleTo(i), n);
                    return !a || I(t1, g, l, a, o) ? g : void 0;
                }
                c += r;
            }
        }
        function k(e1, t1, o, n, i, s, r, a, l) {
            const c = T(n, s, r), u = P(n, i), h = u * r, d = 0 === e1[0].x || e1[0].x === l || 0 === e1[0].y || e1[0].y === l;
            return t1 - h < t1 / 4 && (t1 = h + t1 / 4), B(e1, d ? t1 / 2 * a % t1 : (u / 2 + 2 * s) * r * a % t1, t1, c, o, h, d, !1, l);
        }
        function B(t1, o, n, i, s, r, a, l, c) {
            const u = r / 2, h = M(t1);
            let d = 0, f = o - n, g = [];
            for(let o = 0; o < t1.length - 1; o++){
                const a = t1[o], l = t1[o + 1], p = a.dist(l), m = l.angleTo(a);
                for(; f + n < d + p;){
                    f += n;
                    const y = (f - d) / p, x = e1.aw(a.x, l.x, y), w = e1.aw(a.y, l.y, y);
                    if (x >= 0 && x < c && w >= 0 && w < c && f - u >= 0 && f + u <= h) {
                        const e1 = new S(x, w, 0, m, o);
                        i && !I(t1, e1, r, i, s) || g.push(e1);
                    }
                }
                d += p;
            }
            return l || g.length || a || (g = B(t1, d / 2, n, i, s, r, a, !0, c)), g;
        }
        e1.fO(S, "Anchor");
        class C {
            constructor(){
                this.scale = 1, this.fontStack = "", this.image = null;
            }
            static forText(e1, t1) {
                const o = new C;
                return o.scale = e1 || 1, o.fontStack = t1, o;
            }
            static forImage(e1) {
                const t1 = new C;
                return t1.image = e1, t1;
            }
        }
        class _ {
            constructor(){
                this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
            }
            static fromFeature(e1, t1, o, n = 1) {
                const i = new _;
                for(let s = 0; s < e1.sections.length; s++){
                    const r = e1.sections[s];
                    r.image ? i.addImageSection(r, o, n) : i.addTextSection(r, t1);
                }
                return i;
            }
            length() {
                return this.text.length;
            }
            getSection(e1) {
                return this.sections[this.sectionIndex[e1]];
            }
            getSections() {
                return this.sections;
            }
            getSectionIndex(e1) {
                return this.sectionIndex[e1];
            }
            getCodePoint(e1) {
                return this.text.codePointAt(e1);
            }
            verticalizePunctuation(t1) {
                this.text = e1.fQ(this.text, t1);
            }
            trim() {
                let e1 = 0;
                for(let t1 = 0; t1 < this.text.length && D[this.text.charCodeAt(t1)]; t1++)e1++;
                let t1 = this.text.length;
                for(let o = this.text.length - 1; o >= 0 && o >= e1 && D[this.text.charCodeAt(o)]; o--)t1--;
                this.text = this.text.substring(e1, t1), this.sectionIndex = this.sectionIndex.slice(e1, t1);
            }
            substring(e1, t1) {
                const o = new _;
                return o.text = this.text.substring(e1, t1), o.sectionIndex = this.sectionIndex.slice(e1, t1), o.sections = this.sections, o;
            }
            toString() {
                return this.text;
            }
            getMaxScale() {
                return this.sectionIndex.reduce((e1, t1)=>Math.max(e1, this.sections[t1].scale), 0);
            }
            addTextSection(e1, t1) {
                this.text += e1.text, this.sections.push(C.forText(e1.scale, e1.fontStack || t1));
                const o = this.sections.length - 1;
                for(let t1 = 0; t1 < e1.text.length; ++t1)this.sectionIndex.push(o);
            }
            addImageSection(t1, o, n = 1) {
                const i = t1.image ? t1.image.getPrimary() : null;
                if (!i) return void e1.w("Can't add FormattedSection with an empty image.");
                i.scaleSelf(o * n);
                const s = this.getNextImageSectionCharCode();
                s ? (this.text += String.fromCodePoint(s), this.sections.push(C.forImage(i)), this.sectionIndex.push(this.sections.length - 1)) : e1.w("Reached maximum number of images 6401");
            }
            getNextImageSectionCharCode() {
                return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
            }
        }
        function A(e1, t1) {
            if (!e1.image) return !1;
            const o = t1.get(e1.image.toString());
            return !!o && o.sdf;
        }
        function F(t1, o, n, i, s, r, a, l, c, u, h, d, f, g, p = 1, m = 1) {
            const y = _.fromFeature(t1, s, p, m);
            d === e1.dy.vertical && y.verticalizePunctuation(f);
            const x = y.toString();
            if (function(t1, o) {
                const n = t1.sections.findIndex((e1)=>A(e1, o));
                if (-1 === n) return;
                e1.w(`SDF image ${t1.sections[n].image.id.name} is not supported in text-field`);
                const i = t1.sections.map((e1)=>A(e1, o));
                let s = "";
                const r = [];
                for(let e1 = 0; e1 < t1.length(); e1++){
                    const o = t1.sectionIndex[e1];
                    i[o] || (s += t1.text[e1], r.push(o));
                }
                t1.text = s, t1.sectionIndex = r;
            }(y, i), 0 === y.length()) return;
            let w = [];
            const v = function(t1, o, n, i, s, r, a) {
                if (!t1) return [];
                const l = [], c = function(e1, t1, o, n, i, s, r) {
                    let a = 0;
                    for(let o = 0; o < e1.length(); o++){
                        const l = e1.getSection(o);
                        a += O(e1.getCodePoint(o), l, n, i, t1, s, r);
                    }
                    return a / Math.max(1, Math.ceil(a / o));
                }(t1, o, n, i, s, r, a), u = t1.text.includes("\u200B");
                let h = 0;
                for(let n = 0; n < t1.length(); n++){
                    const d = t1.getSection(n), f = t1.getCodePoint(n);
                    if (D[f] || (h += O(f, d, i, s, o, r, a)), n < t1.length() - 1) {
                        const o = e1.fR(f);
                        (E[f] || o || d.image) && l.push(R(n + 1, h, c, l, j(f, t1.getCodePoint(n + 1), o && u), !1));
                    }
                }
                return V(R(t1.length(), h, c, l, 0, !0));
            }(y, u, r, o, i, g, m);
            if (e1.fP && 1 === y.sections.length) {
                const t1 = e1.fP.processBidirectionalText(y.toString(), v);
                for (const e1 of t1){
                    const t1 = new _;
                    t1.text = e1, t1.sections = y.sections;
                    for(let o = 0; o < e1.length; o++)t1.sectionIndex.push(0);
                    w.push(t1);
                }
            } else if (e1.fP) {
                const t1 = e1.fP.processStyledBidirectionalText(y.text, y.sectionIndex, v);
                for (const e1 of t1){
                    const t1 = new _;
                    t1.text = e1[0], t1.sectionIndex = e1[1], t1.sections = y.sections, w.push(t1);
                }
            } else w = function(e1, t1) {
                const o = [], n = e1.text;
                let i = 0;
                for (const n of t1)o.push(e1.substring(i, n)), i = n;
                return i < n.length && o.push(e1.substring(i, n.length)), o;
            }(y, v);
            const b = [], S = {
                positionedLines: b,
                text: x,
                top: h[1],
                bottom: h[1],
                left: h[0],
                right: h[0],
                writingMode: d,
                iconsInText: !1,
                verticalizable: !1,
                hasBaseline: !1
            };
            return function(t1, o, n, i, s, r, a, l, c, u, h, d, f) {
                let g = 0, p = 0, m = 0;
                const y = "right" === l ? 1 : "left" === l ? 0 : .5;
                let x = !1;
                for (const e1 of s){
                    const t1 = e1.getSections();
                    for (const e1 of t1){
                        if (e1.image) continue;
                        const t1 = o[e1.fontStack];
                        if (t1 && (x = void 0 !== t1.ascender && void 0 !== t1.descender, !x)) break;
                    }
                    if (!x) break;
                }
                let w = 0;
                for (const a of s){
                    a.trim();
                    const s = a.getMaxScale(), l = (s - 1) * e1.dl, v = {
                        positionedGlyphs: [],
                        lineOffset: 0
                    };
                    t1.positionedLines[w] = v;
                    const b = v.positionedGlyphs;
                    let S = 0;
                    if (!a.length()) {
                        p += r, ++w;
                        continue;
                    }
                    let I = 0, M = 0;
                    for(let r = 0; r < a.length(); r++){
                        const l = a.getSection(r), m = a.getSectionIndex(r), y = a.getCodePoint(r);
                        let w = l.scale, v = null, T = null, P = null, z = e1.dl, k = 0, B = c;
                        B === e1.dy.vertical && e1.fU(y) && (B = e1.dy.horizontal);
                        const C = !(B === e1.dy.horizontal || !h && !e1.fS(y) || h && (D[y] || e1.fT(y)));
                        if (l.image) {
                            const o = i.get(l.image.toString());
                            if (!o) continue;
                            P = l.image, t1.iconsInText = !0, T = o.paddedRect;
                            const n = o.displaySize, r = n[0] * f, a = n[1] * f;
                            w = w * e1.dl / d, v = {
                                width: r,
                                height: a,
                                left: 0,
                                top: -e1.fV,
                                advance: C ? a : r,
                                localGlyph: !1
                            }, k = x ? -v.height * w : s * e1.dl - 17 - a * w, z = v.advance;
                            const c = (C ? r : a) * w - e1.dl * s;
                            c > 0 && c > S && (S = c);
                        } else {
                            const t1 = n[l.fontStack];
                            if (!t1) continue;
                            t1[y] && (T = t1[y]);
                            const i = o[l.fontStack];
                            if (!i) continue;
                            const r = i.glyphs[y];
                            if (!r) continue;
                            if (v = r.metrics, z = 8203 !== y ? e1.dl : 0, x) {
                                const e1 = void 0 !== i.ascender ? Math.abs(i.ascender) : 0, t1 = void 0 !== i.descender ? Math.abs(i.descender) : 0, o = (e1 + t1) * w;
                                I < o && (I = o, M = (e1 - t1) / 2 * w), k = -e1 * w;
                            } else k = (s - w) * e1.dl - 17;
                        }
                        b.push({
                            glyph: y,
                            image: P,
                            x: g,
                            y: p + k,
                            vertical: C,
                            scale: w,
                            localGlyph: v.localGlyph,
                            fontStack: l.fontStack,
                            sectionIndex: m,
                            metrics: v,
                            rect: T
                        }), C ? (t1.verticalizable = !0, g += z * w + u) : g += v.advance * w + u;
                    }
                    0 !== b.length && (m = Math.max(g - u, m), x ? Z(b, y, S, M, r * s / 2) : Z(b, y, S, 0, r / 2)), g = 0;
                    const T = r * s + S;
                    v.lineOffset = Math.max(S, l), p += T, ++w;
                }
                const v = p, { horizontalAlign: b, verticalAlign: S } = e1.dz(a);
                (function(e1, t1, o, n, i, s) {
                    const r = (t1 - o) * i, a = -s * n;
                    for (const t1 of e1)for (const e1 of t1.positionedGlyphs)e1.x += r, e1.y += a;
                })(t1.positionedLines, y, b, S, m, v), t1.top += -S * v, t1.bottom = t1.top + v, t1.left += -b * m, t1.right = t1.left + m, t1.hasBaseline = x;
            }(S, o, n, i, w, a, l, c, d, u, f, g, m), function(e1) {
                for (const t1 of e1)if (0 !== t1.positionedGlyphs.length) return !1;
                return !0;
            }(b) ? void 0 : S;
        }
        const D = {
            9: !0,
            10: !0,
            11: !0,
            12: !0,
            13: !0,
            32: !0
        }, E = {
            10: !0,
            32: !0,
            38: !0,
            40: !0,
            41: !0,
            43: !0,
            45: !0,
            47: !0,
            173: !0,
            183: !0,
            8203: !0,
            8208: !0,
            8211: !0,
            8231: !0
        };
        function O(t1, o, n, i, s, r, a) {
            if (o.image) {
                const t1 = i.get(o.image.toString());
                return t1 ? t1.displaySize[0] * a * o.scale * e1.dl / r + s : 0;
            }
            {
                const e1 = n[o.fontStack], i = e1 && e1.glyphs[t1];
                return i ? i.metrics.advance * o.scale + s : 0;
            }
        }
        function L(e1, t1, o, n) {
            const i = Math.pow(e1 - t1, 2);
            return n ? e1 < t1 ? i / 2 : 2 * i : i + Math.abs(o) * o;
        }
        function j(e1, t1, o) {
            let n = 0;
            return 10 === e1 && (n -= 1e4), o && (n += 150), 40 !== e1 && 65288 !== e1 || (n += 50), 41 !== t1 && 65289 !== t1 || (n += 50), n;
        }
        function R(e1, t1, o, n, i, s) {
            let r = null, a = L(t1, o, i, s);
            for (const e1 of n){
                const n = L(t1 - e1.x, o, i, s) + e1.badness;
                n <= a && (r = e1, a = n);
            }
            return {
                index: e1,
                x: t1,
                priorBreak: r,
                badness: a
            };
        }
        function V(e1) {
            return e1 ? V(e1.priorBreak).concat(e1.index) : [];
        }
        function Z(e1, t1, o, n, i) {
            if (!(t1 || o || n || i)) return;
            const s = e1.length - 1, r = e1[s], a = (r.x + r.metrics.advance * r.scale) * t1;
            for(let t1 = 0; t1 <= s; t1++)e1[t1].x -= a, e1[t1].y += o + n + i;
        }
        function G(t1, o = 1, n = !1) {
            let i = 1 / 0, s = 1 / 0, r = -1 / 0, a = -1 / 0;
            const l = t1[0];
            for(let e1 = 0; e1 < l.length; e1++){
                const t1 = l[e1];
                (!e1 || t1.x < i) && (i = t1.x), (!e1 || t1.y < s) && (s = t1.y), (!e1 || t1.x > r) && (r = t1.x), (!e1 || t1.y > a) && (a = t1.y);
            }
            const c = Math.min(r - i, a - s);
            let u = c / 2;
            const h = new e1.fW([], N);
            if (0 === c) return new e1.P(i, s);
            for(let e1 = i; e1 < r; e1 += c)for(let o = s; o < a; o += c)h.push(new Y(e1 + u, o + u, u, t1));
            let d = function(e1) {
                let t1 = 0, o = 0, n = 0;
                const i = e1[0];
                for(let e1 = 0, s = i.length, r = s - 1; e1 < s; r = e1++){
                    const s = i[e1], a = i[r], l = s.x * a.y - a.x * s.y;
                    o += (s.x + a.x) * l, n += (s.y + a.y) * l, t1 += 3 * l;
                }
                return new Y(o / t1, n / t1, 0, e1);
            }(t1), f = h.length;
            for(; h.length;){
                const e1 = h.pop();
                (e1.d > d.d || !d.d) && (d = e1, n && console.log("found best %d after %d probes", Math.round(1e4 * e1.d) / 1e4, f)), e1.max - d.d <= o || (u = e1.h / 2, h.push(new Y(e1.p.x - u, e1.p.y - u, u, t1)), h.push(new Y(e1.p.x + u, e1.p.y - u, u, t1)), h.push(new Y(e1.p.x - u, e1.p.y + u, u, t1)), h.push(new Y(e1.p.x + u, e1.p.y + u, u, t1)), f += 4);
            }
            return n && (console.log(`num probes: ${f}`), console.log(`best distance: ${d.d}`)), d.p;
        }
        function N(e1, t1) {
            return t1.max - e1.max;
        }
        class Y {
            constructor(t1, o, n, i){
                this.p = new e1.P(t1, o), this.h = n, this.d = function(t1, o) {
                    let n = !1, i = 1 / 0;
                    for(let s = 0; s < o.length; s++){
                        const r = o[s];
                        for(let o = 0, s = r.length, a = s - 1; o < s; a = o++){
                            const s = r[o], l = r[a];
                            s.y > t1.y != l.y > t1.y && t1.x < (l.x - s.x) * (t1.y - s.y) / (l.y - s.y) + s.x && (n = !n), i = Math.min(i, e1.fX(t1, s, l));
                        }
                    }
                    return (n ? 1 : -1) * Math.sqrt(i);
                }(this.p, i), this.max = this.d + this.h * Math.SQRT2;
            }
        }
        const $ = Object.keys;
        function X(e1) {
            return void 0 !== e1.imagePrimary && void 0 !== e1.top && void 0 !== e1.bottom && void 0 !== e1.left && void 0 !== e1.right;
        }
        function J(e1) {
            return !e1.imagePrimary.stretchX;
        }
        function q(e1) {
            return !e1.imagePrimary.stretchY;
        }
        function U(e1) {
            return {
                width: e1.right - e1.left,
                height: e1.bottom - e1.top
            };
        }
        const W = Number.POSITIVE_INFINITY;
        function H(t1, o, n, i, s, r) {
            const a = X(t1) && t1.collisionPadding ? t1.collisionPadding : [
                0,
                0,
                0,
                0
            ], l = {
                top: t1.top - a[1],
                bottom: t1.bottom + a[3],
                left: t1.left - a[0],
                right: t1.right + a[2],
                scaled: !1
            };
            return void 0 !== i && function(e1, t1) {
                e1.top *= t1, e1.bottom *= t1, e1.left *= t1, e1.right *= t1, e1.scaled = !0;
            }(l, i), r && (l.left += r[0], l.right += r[0], l.top += r[1], l.bottom += r[1]), n && function(t1, o, n) {
                if (!o) return;
                const i = e1.aF(o), s = new e1.P(n ? n[0] : 0, n ? n[1] : 0), r = new e1.P(t1.left, t1.top), a = new e1.P(t1.right, t1.top), l = new e1.P(t1.left, t1.bottom), c = new e1.P(t1.right, t1.bottom);
                r._rotateAround(i, s), a._rotateAround(i, s), l._rotateAround(i, s), c._rotateAround(i, s), t1.left = Math.min(r.x, a.x, l.x, c.x), t1.right = Math.max(r.x, a.x, l.x, c.x), t1.top = Math.min(r.y, a.y, l.y, c.y), t1.bottom = Math.max(r.y, a.y, l.y, c.y);
            }(l, n, s), o ? {
                top: Math.min(o.top, l.top),
                bottom: Math.max(o.bottom, l.bottom),
                left: Math.min(o.left, l.left),
                right: Math.max(o.right, l.right),
                scaled: o.scaled || l.scaled
            } : l;
        }
        function K(t1, o, n, i, s, r, a, l = 1, c, u, h, d, f, g, p, m, y) {
            t1.createArrays(), t1.tilePixelRatio = e1.ac / (512 * t1.overscaling), t1.compareText = {}, t1.iconsNeedLinear = !1;
            const x = t1.layers[0].layout, w = {};
            w.scaleFactor = l, w.textSizeScaleRange = x.get("text-size-scale-range"), w.iconSizeScaleRange = x.get("icon-size-scale-range");
            const [v, b] = w.textSizeScaleRange, [S, I] = w.iconSizeScaleRange;
            w.textScaleFactor = e1.bb(w.scaleFactor, v, b), w.iconScaleFactor = e1.bb(w.scaleFactor, S, I);
            const M = t1.layers[0].getLayoutPropertyValue("text-size"), T = t1.layers[0].getLayoutPropertyValue("icon-size");
            if ("composite" === t1.textSizeData.kind) {
                const { minZoom: o, maxZoom: n } = t1.textSizeData;
                w.compositeTextSizes = [
                    M.possiblyEvaluate(new e1.au(o, {
                        worldview: h
                    }), r),
                    M.possiblyEvaluate(new e1.au(n, {
                        worldview: h
                    }), r)
                ];
            }
            if ("composite" === t1.iconSizeData.kind) {
                const { minZoom: o, maxZoom: n } = t1.iconSizeData;
                w.compositeIconSizes = [
                    T.possiblyEvaluate(new e1.au(o, {
                        worldview: h
                    }), r, d),
                    T.possiblyEvaluate(new e1.au(n, {
                        worldview: h
                    }), r, d)
                ];
            }
            const { maxzoom: P } = t1.layers[0], z = null != P ? Math.min(a + 1, P) : a + 1;
            w.layoutTextSize = M.possiblyEvaluate(new e1.au(z, {
                worldview: h
            }), r), w.layoutIconSize = T.possiblyEvaluate(new e1.au(z, {
                worldview: h
            }), r, d), w.textMaxSize = M.possiblyEvaluate(new e1.au(18, {
                worldview: h
            }), r);
            const k = x.get("symbol-placement"), B = "map" === x.get("text-rotation-alignment") && "point" !== k, C = x.get("text-size");
            let _ = !1;
            const A = [], D = null != f && 0 !== f;
            for (const a of t1.features){
                if (D && a.properties && m && m(a.properties, f)) continue;
                let l = 65535;
                if (t1.hdExt && a.properties && Object.hasOwn(a.properties, e1.fY)) {
                    const o = +a.properties[e1.fY];
                    if (!Number.isNaN(o)) {
                        const e1 = t1.hdExt.resolveRoadElevation(a, o);
                        if ("defer" === e1) continue;
                        l = e1;
                    }
                }
                const g = x.get("text-font").evaluate(a, {}, r).join(","), p = Math.max(w.layoutTextSize.evaluate(a, {}, r), C.evaluate(a, {}, r)) * w.textScaleFactor, y = w.layoutIconSize.evaluate(a, {}, r, d) * w.iconScaleFactor, v = {
                    horizontal: {},
                    vertical: void 0
                }, b = a.text;
                let S, I = [
                    0,
                    0
                ];
                if (b) {
                    const i = b.toString(), l = x.get("text-letter-spacing").evaluate(a, {}, r) * e1.dl, u = x.get("text-line-height").evaluate(a, {}, r) * e1.dl, h = e1.fZ(i) ? l : 0, d = x.get("text-anchor").evaluate(a, {}, r), f = x.get("text-variable-anchor");
                    if (!f) {
                        const t1 = x.get("text-radial-offset").evaluate(a, {}, r);
                        if (t1) I = e1.dA(d, [
                            t1 * e1.dl,
                            W
                        ]);
                        else {
                            const t1 = x.get("text-offset").evaluate(a, {}, r);
                            I = [
                                t1[0] * e1.dl,
                                t1[1] * e1.dl
                            ];
                        }
                    }
                    let m = B ? "center" : x.get("text-justify").evaluate(a, {}, r);
                    const y = "point" === k, S = y ? x.get("text-max-width").evaluate(a, {}, r) * e1.dl : 1 / 0, M = (r)=>{
                        t1.allowVerticalPlacement && e1.f_(i) && (v.vertical = F(b, o, n, s, g, S, u, d, r, h, I, e1.dy.vertical, !0, p, c, w.textScaleFactor));
                    };
                    if (!B && f) {
                        const t1 = "auto" === m ? f.map((t1)=>e1.dB(t1)) : [
                            m
                        ];
                        let i = !1;
                        for(let r = 0; r < t1.length; r++){
                            const a = t1[r];
                            if (!v.horizontal[a]) {
                                if (i) v.horizontal[a] = v.horizontal[0];
                                else {
                                    const t1 = F(b, o, n, s, g, S, u, "center", a, h, I, e1.dy.horizontal, !1, p, c, w.textScaleFactor);
                                    t1 && (v.horizontal[a] = t1, i = 1 === t1.positionedLines.length);
                                }
                            }
                        }
                        M("left");
                    } else {
                        if ("auto" === m && (m = e1.dB(d)), y || x.get("text-writing-mode").includes("horizontal") || !e1.f_(i)) {
                            const t1 = F(b, o, n, s, g, S, u, d, m, h, I, e1.dy.horizontal, !1, p, c, w.textScaleFactor);
                            t1 && (v.horizontal[m] = t1);
                        }
                        M(y ? "left" : m);
                    }
                }
                let M, P, z, E, O, L, j = !1;
                const R = x.get("icon-text-fit").evaluate(a, {}, r);
                if (a.icon && a.icon.hasPrimary()) {
                    const o = e1.f$(a.icon, t1.iconSizeData, T, r, t1.zoom, a, c, w.iconScaleFactor, h, d);
                    M = o.iconPrimary, z = o.iconSecondary;
                    const n = M.toString();
                    if (P = i.get(n), P && (O = x.get("icon-offset").evaluate(a, {}, r), L = x.get("icon-anchor").evaluate(a, {}, r), S = e1.g0(s.get(n), z ? s.get(z.toString()) : void 0, O, L), j = P.sdf, void 0 === t1.sdfIcons ? t1.sdfIcons = P.sdf : t1.sdfIcons !== P.sdf && e1.w("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (P.pixelRatio !== t1.pixelRatio || 0 !== x.get("icon-rotate").constantOr(1)) && (t1.iconsNeedLinear = !0)), z) {
                        const e1 = z.toString();
                        E = i.get(e1);
                    }
                }
                _ = _ || !(!a.icon || !a.icon.hasSecondary());
                const V = de(v.horizontal) || v.vertical;
                t1.iconsInText || (t1.iconsInText = !!V && V.iconsInText);
                const Z = p / e1.dl, { defaultShapedIcon: G, verticallyShapedIcon: N } = ce(t1, S, x, a, r, v, Z, O, R);
                "none" !== R && S && (J(S) || q(S)) && (ne(P, M, S, G, R, u, i, s), ne(E, z, S, G, R, u, i, s), N && (ne(P, M, S, N, R, u, i, s), ne(E, z, S, N, R, u, i, s))), S = G;
                const { iconBBox: Y, iconVerticalBBox: $, textBBox: X, textVerticalBBox: U } = Q(t1, S, N, x, a, r, y, O, w, s, L, v, p, I, d);
                A.push({
                    feature: a,
                    shapedTextOrientations: v,
                    shapedText: V,
                    shapedIcon: S,
                    iconPrimary: M,
                    iconSecondary: z,
                    iconOffset: O,
                    iconAnchor: L,
                    verticallyShapedIcon: N,
                    layoutTextSize: p,
                    layoutIconSize: y,
                    textOffset: I,
                    isSDFIcon: j,
                    iconTextFit: R,
                    iconCollisionBounds: Y,
                    iconVerticalCollisionBounds: $,
                    textCollisionBounds: X,
                    textVerticalCollisionBounds: U,
                    elevationFeatureIndex: l
                });
            }
            return t1.hdExt && t1.hdExt.clearWorkerState(), {
                featureData: A,
                sizes: w,
                hasAnySecondaryIcon: _,
                textAlongLine: B,
                symbolPlacement: k,
                coverageFrcMask: f,
                coveragePolygons: g,
                coverageTileZoom: p,
                isFeatureCoveredByFrcMask: m,
                symbolAnchorInFrcCoverage: y
            };
        }
        function Q(t1, o, n, i, s, r, a, l, c, u, h, d, f, g, p) {
            const m = t1.layers[0], y = m.appearances;
            if (0 === y.length) return {
                iconBBox: null,
                iconVerticalBBox: null,
                textBBox: null,
                textVerticalBBox: null
            };
            const x = {
                iconBBox: null,
                iconVerticalBBox: null
            }, w = {
                textBBox: null,
                textVerticalBBox: null
            }, { baseIconRotate: v, baseTextRotate: b, iconScaleFactor: S } = function(t1, o, n) {
                const i = t1.get("icon-rotate").evaluate(o, {}, n), s = t1.get("text-rotate").evaluate(o, {}, n), [r, a] = t1.get("icon-size-scale-range");
                return {
                    baseIconRotate: i,
                    baseTextRotate: s,
                    iconScaleFactor: e1.bb(1, r, a)
                };
            }(i, s, r);
            o && (x.iconBBox = H(o, x.iconBBox, v), n) && (x.iconVerticalBBox = H(n, x.iconVerticalBBox, v + 90));
            const I = de(d.horizontal);
            I && (w.textBBox = H(I, w.textBBox, b, 1, g)), d.vertical && (w.textVerticalBBox = H(d.vertical, w.textVerticalBBox, b + 90, 1, g));
            for (const e1 of y)e1.hasIconLayoutProperties() && ee(x, t1, m, e1, s, r, l, v, a, c, o, u, S, h, p), e1.hasTextLayoutProperties() && oe(w, m, e1, s, r, g, b, f, I, d.vertical);
            return {
                iconBBox: x.iconBBox,
                iconVerticalBBox: x.iconVerticalBBox,
                textBBox: w.textBBox,
                textVerticalBBox: w.textVerticalBBox
            };
        }
        function ee(t1, o, n, i, s, r, a, l, c, u, h, d, f, g, p) {
            const { appearanceIconOffset: m, appearanceIconRotate: y, appearanceIconSize: x } = e1.g4(i, n, s, r, a, l, c, u.iconScaleFactor);
            let w = null, v = null, b = null;
            i.hasLayoutProperty("icon-image") ? b = te(o, n, i, s, r, d, f, p) : h && (b = h.imagePrimary), b && (w = e1.g0(b, null, m, g), o.allowVerticalPlacement && (v = w));
            const S = c > 0 ? x / c : 1;
            w && (t1.iconBBox = H(w, t1.iconBBox, y, 1 !== S ? S : void 0)), v && (t1.iconVerticalBBox = H(v, t1.iconVerticalBBox, y + 90, 1 !== S ? S : void 0));
        }
        function te(t1, o, n, i, s, r, a, l) {
            let c = null;
            const u = o.getAppearanceValueAndResolveTokens(n, "icon-image", i, s, l);
            if (u) {
                const h = t1.getResolvedImageFromTokens(u), d = n.hasLayoutProperty("icon-size") ? n.getUnevaluatedLayoutProperty("icon-size") : o.getLayoutPropertyValue("icon-size"), f = e1.g7(t1.zoom, d, t1.worldview, l), g = e1.f$(h, f, d, s, t1.zoom, i, t1.pixelRatio, a, t1.worldview, l);
                c = r.get(g.iconPrimary.toString());
            }
            return c;
        }
        function oe(t1, o, n, i, s, r, a, l, c, u) {
            const { appearanceTextOffset: h, appearanceTextRotate: d, appearanceTextSize: f } = e1.g5(n, o, i, s, r, a, l), g = f / l, p = [
                (h[0] - r[0]) * g,
                (h[1] - r[1]) * g
            ], m = 0 !== p[0] || 0 !== p[1];
            c && (t1.textBBox = H(c, t1.textBBox, d, g, h, m ? p : void 0)), u && (t1.textVerticalBBox = H(u, t1.textVerticalBBox, d + 90, g, h, m ? p : void 0));
        }
        function ne(t1, o, n, i, s, r, a, l) {
            if (!t1 || !t1.usvg) return;
            const c = U(n), u = U(i), h = "both" !== s && "width" !== s || !J(n) ? 1 : u.width / c.width, d = "both" !== s && "height" !== s || !q(n) ? 1 : u.height / c.height;
            o.scaleSelf(h, d);
            const f = o.toString();
            r.set(f, o), a.set(f, t1);
            const { imagePosition: g } = e1.g2(f, t1, e1.g3);
            l.set(f, g);
        }
        function ie(t1, o, n) {
            if (!o) return;
            const i = n.get(t1.toString()), s = n.get(o.toString());
            i && s && (i.paddedRect.w === s.paddedRect.w && i.paddedRect.h === s.paddedRect.h || e1.w(`Mismatch in icon variant sizes: ${t1.toString()} and ${o.toString()}`), i.usvg !== s.usvg && e1.w(`Mismatch in icon variant image types: ${t1.id} and ${o.id}`));
        }
        function se(e1, t1, o, n, i, s, r, a, l, c) {
            e1.iconAtlasPositions = c.iconPositions;
            const { featureData: u, sizes: h, textAlongLine: d, symbolPlacement: f, coveragePolygons: g, coverageTileZoom: p, symbolAnchorInFrcCoverage: m } = t1, y = t1.hasAnySecondaryIcon || e1.hasAnySecondaryIcon;
            for (const t1 of u){
                const { shapedIcon: o, verticallyShapedIcon: s, feature: u, shapedTextOrientations: x, shapedText: w, layoutTextSize: v, textOffset: b, isSDFIcon: S, iconPrimary: I, iconSecondary: M, iconTextFit: T, iconOffset: P, iconCollisionBounds: z, iconVerticalCollisionBounds: k, textCollisionBounds: B, textVerticalCollisionBounds: C, elevationFeatureIndex: _ } = t1;
                re(o, c.iconPositions, I, M), re(s, c.iconPositions, I, M), ae(x, c.iconPositions), ie(I, M, c.iconPositions), (w || o) && ue(e1, u, x, o, s, l, h, v, 0, b, S, n, i, r, a, y, T, P, d, f, z, k, B, C, 0, g, p, m, _);
            }
            o && e1.generateCollisionDebugBuffers(s, e1.collisionBoxArray, h.textScaleFactor), 0 === e1.layers[0].getAppearances().length && (e1.iconAtlasPositions = void 0), e1.text.uboBinder && e1.text.uboBinder.finalize(), e1.icon.uboBinder && e1.icon.uboBinder.finalize();
        }
        function re(e1, t1, o, n) {
            if (!e1) return;
            const i = t1.get(o.toString());
            if (i && (e1.imagePrimary = i), n) {
                const o = t1.get(n.toString());
                e1.imageSecondary = o;
            }
        }
        function ae(e1, t1) {
            for(const o in e1.horizontal)le(e1.horizontal[o], t1);
            le(e1.vertical, t1);
        }
        function le(e1, t1) {
            if (e1) {
                for (const o of e1.positionedLines)for (const e1 of o.positionedGlyphs)if (null !== e1.image) {
                    const o = e1.image.toString();
                    e1.rect = t1.get(o).paddedRect;
                }
            }
        }
        function ce(t1, o, n, i, s, r, a, l, c) {
            const u = de(r.horizontal) || r.vertical, h = n.get("icon-text-fit-padding").evaluate(i, {}, s);
            let d, f = o;
            return o && "none" !== c && (t1.allowVerticalPlacement && r.vertical && (d = e1.g1(o, r.vertical, c, h, l, a)), u && (f = e1.g1(o, u, c, h, l, a))), {
                defaultShapedIcon: f,
                verticallyShapedIcon: d
            };
        }
        function ue(t1, o, n, i, s, r, a, l, c, u, h, d, f, g, p, m, y, x, w, v, b, I, M, T, P, B, C, _, A = 65535) {
            const F = a.textMaxSize.evaluate(o, {}, f) * a.textScaleFactor, D = t1.layers[0].layout, E = e1.dl, O = l / E, L = de(n.horizontal) || n.vertical, j = t1.hasAnyAppearanceLayoutProperty([
                "text-size",
                "text-offset",
                "text-rotate"
            ]), R = t1.getAppearanceFeatureData(o.index);
            ("none" !== y || j) && R && (R.textShaping = L, R.iconTextFitPadding = D.get("icon-text-fit-padding").evaluate(o, {}, f), R.fontScale = O, R.textScaleFactor = a.textScaleFactor);
            const V = "globe" === g.name, Z = t1.tilePixelRatio * F / E, N = (H = t1.overscaling, t1.zoom > 18 && H > 2 && (H >>= 1), Math.max(e1.ac / (512 * H), 1) * D.get("symbol-spacing")), Y = D.get("text-padding") * t1.tilePixelRatio, X = D.get("icon-padding") * t1.tilePixelRatio, J = e1.aF(D.get("text-max-angle")), q = "map" === D.get("icon-rotation-alignment") && "point" !== v, U = N / 2;
            var H;
            !1 === t1.hasAnyIconTextFit && "none" !== y && (t1.hasAnyIconTextFit = !0);
            const K = (l, c, v)=>{
                if (c.x < 0 || c.x >= e1.ac || c.y < 0 || c.y >= e1.ac) return;
                if (B && B.length > 0 && o.properties && _ && _(B, o.properties, c, f, C)) return;
                let P = null;
                if (V) {
                    const { x: e1, y: t1, z: o } = g.projectTilePoint(c.x, c.y, v);
                    P = {
                        anchor: new S(e1, t1, o, 0, void 0),
                        up: g.upVector(v, c.x, c.y)
                    };
                }
                !function(t1, o, n, i, s, r, a, l, c, u, h, d, f, g, p, m, y, x, w, v, b, S, I, M, T, P, z, k, B, C, _, A, F) {
                    const D = t1.addToLineVertexArray(o, i);
                    let E, O, L, j, R, V, Z, G = 0, N = 0, Y = 0, X = 0, J = -1, q = -1;
                    const U = {};
                    let H = e1.dK("");
                    const K = n ? n.anchor : o, Q = "none" !== k, ee = e1.g8(c, "icon"), oe = e1.g8(c, "text"), ne = ee || oe ? e1.g9(t1.getTileTransform(T), o.x, o.y) : 0, ie = ee ? ne : 0, se = oe ? ne : 0, re = c.layout.get("icon-rotate").evaluate(b, {}, T) + ie, ae = c.layout.get("text-rotate").evaluate(b, {}, T) + se, le = C ? ie : re, ce = A ? se : ae;
                    let ue = 0, de = 0;
                    if (void 0 === c.getLayoutPropertyValue("text-radial-offset").value) {
                        const t1 = c.layout.get("text-offset").evaluate(b, {}, T);
                        ue = t1[0] * e1.dl, de = t1[1] * e1.dl;
                    } else ue = c.layout.get("text-radial-offset").evaluate(b, {}, T) * e1.dl, de = W;
                    if (t1.allowVerticalPlacement && s.vertical) {
                        const e1 = s.vertical;
                        if (p) V = ge(e1), l && (Z = ge(l));
                        else {
                            const t1 = ae + 90, n = _ ? ie : t1;
                            L = fe(u, K, o, h, d, f, e1, g, F ? se : t1, m, F), l && (j = fe(u, K, o, h, d, f, l, x, n, null, _));
                        }
                    }
                    if (r) {
                        const i = e1.ga(r, re, I, Q, S.iconScaleFactor), s = l ? e1.ga(l, re, I, Q, S.iconScaleFactor) : void 0;
                        O = fe(u, K, o, h, d, f, r, x, le, null, C);
                        const a = function(t1, o, n, i, s, r, a, l, c) {
                            const u = t1.layers[0], h = u.appearances;
                            let d = o.length;
                            if (n && (d = Math.max(d, n.length)), 0 === h.length) return d;
                            const [f, g] = i.get("icon-size-scale-range"), p = e1.bb(1, f, g);
                            for (const o of h)if (o.hasLayoutProperty("icon-image")) {
                                const n = te(t1, u, o, s, r, a, p, c);
                                n && (d = Math.max(d, e1.gc(n)));
                            }
                            return d;
                        }(t1, i, s, c.layout, b, T, t1.iconAtlasPositions, 0, M);
                        G = 4 * a;
                        const g = c.layout.get("icon-size").evaluate(b, {}, T, M), p = S.compositeIconSizes ? S.compositeIconSizes[0].evaluate(b, {}, T, M) : 0, m = S.compositeIconSizes ? S.compositeIconSizes[1].evaluate(b, {}, T, M) : 0, y = e1.gb(t1.layerIds[0], t1.iconSizeData, g, r.imagePrimary.usvg ? 1 : S.iconScaleFactor, p, m);
                        t1.addSymbols(t1.icon, i, y, v, w, b, void 0, n, o, D.lineStartIndex, D.lineLength, -1, M, T, P, z, t1.symbolInstances.length, a), J = t1.icon.placedSymbolArray.length - 1, s && (N = 4 * a, t1.addSymbols(t1.icon, s, y, v, w, b, e1.dy.vertical, n, o, D.lineStartIndex, D.lineLength, -1, M, T, P, z, t1.symbolInstances.length, a), q = t1.icon.placedSymbolArray.length - 1);
                    }
                    for(const i in s.horizontal){
                        const r = i, l = s.horizontal[r];
                        E || (H = e1.dK(l.text), p ? R = ge(l) : E = fe(u, K, o, h, d, f, l, g, ce, m, A));
                        const y = 1 === l.positionedLines.length;
                        if (Y += he(t1, n, o, l, a, c, p, b, m, D, s.vertical ? e1.dy.horizontal : e1.dy.horizontalOnly, y ? $(s.horizontal) : [
                            r
                        ], U, J, S, M, T, t1.symbolInstances.length, ae, P), y) break;
                    }
                    s.vertical && (X += he(t1, n, o, s.vertical, a, c, p, b, m, D, e1.dy.vertical, [
                        "vertical"
                    ], U, q, S, M, T, t1.symbolInstances.length, ae, P));
                    let pe = -1;
                    const me = (e1, t1)=>e1 ? Math.max(e1, t1) : t1;
                    pe = me(R, pe), pe = me(V, pe), pe = me(Z, pe);
                    const ye = pe > -1 ? 1 : 0;
                    t1.glyphOffsetArray.length >= 65535 && e1.w("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== b.sortKey && t1.addToSortKeyRanges(t1.symbolInstances.length, b.sortKey), t1.symbolInstances.emplaceBack(o.x, o.y, K.x, K.y, K.z, U.right >= 0 ? U.right : -1, U.center >= 0 ? U.center : -1, U.left >= 0 ? U.left : -1, U.vertical >= 0 ? U.vertical : -1, J, q, H, void 0 !== E ? E : t1.collisionBoxArray.length, void 0 !== E ? E + 1 : t1.collisionBoxArray.length, void 0 !== L ? L : t1.collisionBoxArray.length, void 0 !== L ? L + 1 : t1.collisionBoxArray.length, void 0 !== O ? O : t1.collisionBoxArray.length, void 0 !== O ? O + 1 : t1.collisionBoxArray.length, j || t1.collisionBoxArray.length, j ? j + 1 : t1.collisionBoxArray.length, h, Y, X, G, N, ye, 0, ue, de, pe, 0, Q ? 1 : 0, B);
                }(t1, c, P, l, n, i, r, s, t1.layers[0], t1.collisionBoxArray, o.index, o.sourceLayerIndex, t1.index, Y, w, u, 0, X, q, x, o, a, h, d, f, p, m, y, A, b, I, M, T);
            };
            if ("line" === v) for (const s of e1.dh(o.geometry, 0, 0, e1.ac, e1.ac)){
                const o = k(s, N, J, n.vertical || L, i, E, Z, t1.overscaling, e1.ac);
                for (const e1 of o)L && pe(t1, L.text, U, e1) || K(s, e1, f);
            }
            else if ("line-center" === v) {
                for (const e1 of o.geometry)if (e1.length > 1) {
                    const t1 = z(e1, J, n.vertical || L, i, E, Z);
                    t1 && K(e1, t1, f);
                }
            } else if ("Polygon" === o.type) for (const t1 of e1.g6(o.geometry, 0)){
                const e1 = G(t1, 16);
                K(t1[0], new S(e1.x, e1.y, 0, 0, void 0), f);
            }
            else if ("LineString" === o.type) for (const e1 of o.geometry)K(e1, new S(e1[0].x, e1[0].y, 0, 0, void 0), f);
            else if ("Point" === o.type) for (const e1 of o.geometry)for (const t1 of e1)K([
                t1
            ], new S(t1.x, t1.y, 0, 0, void 0), f);
        }
        function he(t1, o, n, i, s, r, a, l, c, u, h, d, f, g, p, m, y, x, w, v) {
            const b = e1.gd(n, i, c, r, a, l, s, t1.allowVerticalPlacement, w, p.textScaleFactor), S = r.layout.get("text-size").evaluate(l, {}, y), I = p.compositeTextSizes ? p.compositeTextSizes[0].evaluate(l, {}, y) : 0, M = p.compositeTextSizes ? p.compositeTextSizes[1].evaluate(l, {}, y) : 0, T = e1.gb(t1.layerIds[0], t1.textSizeData, S, p.textScaleFactor, I, M);
            t1.addSymbols(t1.text, b, T, c, a, l, h, o, n, u.lineStartIndex, u.lineLength, g, m, y, v, !1, x, b.length);
            for (const e1 of d)f[e1] = t1.text.placedSymbolArray.length - 1;
            return 4 * b.length;
        }
        function de(e1) {
            for(const t1 in e1)return e1[t1];
            return null;
        }
        function fe(t1, o, n, i, s, r, a, l, c, u, h) {
            let d, f, g, p;
            if (d = h ? h.top : a.top, f = h ? h.bottom : a.bottom, g = h ? h.left : a.left, p = h ? h.right : a.right, X(a) && a.collisionPadding) {
                const e1 = a.collisionPadding;
                g -= e1[0], d -= e1[1], p += e1[2], f += e1[3];
            }
            if (c) {
                const t1 = new e1.P(g, d), o = new e1.P(p, d), n = new e1.P(g, f), i = new e1.P(p, f), s = e1.aF(c);
                let r = new e1.P(0, 0);
                u && (r = new e1.P(u[0], u[1])), t1._rotateAround(s, r), o._rotateAround(s, r), n._rotateAround(s, r), i._rotateAround(s, r), g = Math.min(t1.x, o.x, n.x, i.x), p = Math.max(t1.x, o.x, n.x, i.x), d = Math.min(t1.y, o.y, n.y, i.y), f = Math.max(t1.y, o.y, n.y, i.y);
            }
            return t1.emplaceBack(o.x, o.y, o.z, n.x, n.y, g, d, p, f, l, i, s, r), t1.length - 1;
        }
        function ge(e1) {
            X(e1) && e1.collisionPadding && (e1.top -= e1.collisionPadding[1], e1.bottom += e1.collisionPadding[3]);
            const t1 = e1.bottom - e1.top;
            return t1 > 0 ? Math.max(10, t1) : null;
        }
        function pe(e1, t1, o, n) {
            const i = e1.compareText;
            if (t1 in i) {
                const e1 = i[t1];
                for(let t1 = e1.length - 1; t1 >= 0; t1--)if (n.dist(e1[t1]) < o) return !0;
            } else i[t1] = [];
            return i[t1].push(n), !1;
        }
        const me = 1 * e1.gf;
        class ye {
            constructor(t1){
                const o = {}, n = [];
                for(const e1 in t1){
                    const i = t1[e1], s = o[e1] = {};
                    for(const e1 in i.glyphs){
                        const t1 = i.glyphs[+e1];
                        if (!t1 || 0 === t1.bitmap.width || 0 === t1.bitmap.height) continue;
                        const o = t1.metrics.localGlyph ? me : 1, r = {
                            x: 0,
                            y: 0,
                            w: t1.bitmap.width + 2 * o,
                            h: t1.bitmap.height + 2 * o
                        };
                        n.push(r), s[e1] = r;
                    }
                }
                const { w: i, h: s } = e1.p(n), r = new e1.ge({
                    width: i || 1,
                    height: s || 1
                });
                for(const n in t1){
                    const i = t1[n];
                    for(const t1 in i.glyphs){
                        const s = i.glyphs[+t1];
                        if (!s || 0 === s.bitmap.width || 0 === s.bitmap.height) continue;
                        const a = o[n][t1], l = s.metrics.localGlyph ? me : 1;
                        e1.ge.copy(s.bitmap, r, {
                            x: 0,
                            y: 0
                        }, {
                            x: a.x + l,
                            y: a.y + l
                        }, s.bitmap);
                    }
                }
                this.image = r, this.positions = o;
            }
        }
        function xe(e1) {
            for (const t1 of e1){
                if (null != t1.hdExt) return !0;
                if (t1.requiresHDRuntime) return !0;
            }
            return !1;
        }
        function we(e1) {
            for (const t1 of e1)if (t1.requiresStandardRuntime) return !0;
            return !1;
        }
        function ve(t1, o, n) {
            const i = null != t1 && !!e1.gi && e1.gi(t1.sourceLayers, o, n);
            return {
                applies: i,
                frcMask: i && t1 ? t1.frcMask : null,
                polygons: i && t1 ? t1.polygons : null,
                tileZoom: i && t1 ? t1.tileZoom : null
            };
        }
        e1.fO(ye, "GlyphAtlas");
        class be {
            constructor(t1){
                this.tileID = new e1.bZ(t1.tileID.overscaledZ, t1.tileID.wrap, t1.tileID.canonical.z, t1.tileID.canonical.x, t1.tileID.canonical.y), this.tileZoom = t1.tileZoom, this.uid = t1.uid, this.zoom = t1.zoom, this.lut = t1.lut, this.canonical = t1.tileID.canonical, this.pixelRatio = t1.pixelRatio, this.tileSize = t1.tileSize, this.source = t1.source, this.scope = t1.scope, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = t1.showCollisionBoxes, this.showElevationIdDebug = t1.showElevationIdDebug, this.collectResourceTiming = !!t1.request && t1.request.collectResourceTiming, this.promoteId = t1.promoteId, this.renderSourceType = t1.renderSourceType, this.frcCoverage = t1.frcCoverage || null, this.elevation = t1.elevation || null, this.crossSourceElevationEnabled = !!t1.crossSourceElevationEnabled, this.terrainEnabled = !!t1.terrainEnabled, this.deferRoadStructure = !1, this.tileTransform = e1.bA(t1.tileID.canonical, t1.projection), this.projection = t1.projection, this.worldview = t1.worldview, this.localizableLayerIds = t1.localizableLayerIds, this.brightness = t1.brightness, this.extraShadowCaster = !!t1.extraShadowCaster, this.tessellationStep = t1.tessellationStep, this.scaleFactor = t1.scaleFactor, this.worldview = t1.worldview, this.indoor = t1.indoor;
            }
            isLayerActiveForTile(t1) {
                return !(this.renderSourceType === e1.b_.Symbol && "symbol" !== t1.type || this.renderSourceType === e1.b_.FillExtrusion && "fill-extrusion" !== t1.type || this.renderSourceType === e1.b_.Other && ("symbol" === t1.type || "fill-extrusion" === t1.type) || t1.minzoom && this.zoom < Math.floor(t1.minzoom) || t1.maxzoom && this.zoom >= t1.maxzoom || "none" === t1.visibility);
            }
            parse(e1, t1, o, n, i, s) {
                this._parseAfterHD(e1, t1, o, n, i, s);
            }
            _parseAfterHD(t1, a, l, c, u, h) {
                let d;
                if (this.status = "parsing", this.data = t1, this.renderSourceType === e1.b_.HdRoadCoverage) {
                    const o = t1.layers[e1.c0];
                    d = o && i ? i(o) : [];
                }
                this.collisionBoxArray = new e1.bE;
                const f = new e1.gg(Object.keys(t1.layers).sort()), m = new e1.fJ(this.tileID, this.promoteId);
                m.bucketLayerIDs = [];
                const y = {}, x = new e1.gh(256, 256), w = {
                    featureIndex: m,
                    iconDependencies: new Map,
                    patternDependencies: new Map,
                    glyphDependencies: {},
                    lineAtlas: x,
                    availableImages: l,
                    brightness: this.brightness,
                    scaleFactor: this.scaleFactor,
                    showElevationIdDebug: this.showElevationIdDebug,
                    elevationFeatures: void 0,
                    elevationParams: this.elevation,
                    crossSourceElevationEnabled: this.crossSourceElevationEnabled,
                    terrainEnabled: this.terrainEnabled,
                    activeFloors: void 0
                };
                this.indoor && r && (w.activeFloors = r(t1, this.indoor, u, this.canonical));
                const v = [], b = a.familiesBySource[this.source];
                if (this.deferRoadStructure = !1, this.renderSourceType !== e1.b_.HdRoadCoverage && null != this.frcCoverage && !this.frcCoverage.resolved && null === this.frcCoverage.frcMask) {
                    for(const t1 in b)if (e1.gi && e1.gi(this.frcCoverage.sourceLayers, this.source, t1)) {
                        this.deferRoadStructure = !0;
                        break;
                    }
                }
                for(const n in b){
                    const i = t1.layers[n];
                    if (!i) continue;
                    let s = !1, r = !1, a = !1, u = !1;
                    for (const e1 of b[n])"symbol" === e1[0].type ? s = !0 : "fill-extrusion" === e1[0].type ? r = !0 : a = !0, e1[0].is3D() && "model" !== e1[0].type && (u = !0);
                    if (this.extraShadowCaster && !u) continue;
                    if (this.renderSourceType === e1.b_.Symbol && !s) continue;
                    if (this.renderSourceType === e1.b_.FillExtrusion && !r) continue;
                    if ((this.renderSourceType === e1.b_.Other || this.renderSourceType === e1.b_.HdRoadCoverage) && !a) continue;
                    const h = null != this.frcCoverage && !!e1.gi && e1.gi(this.frcCoverage.sourceLayers, this.source, n);
                    if (this.deferRoadStructure && h) continue;
                    1 === i.version && e1.w(`Vector tile source "${this.source}" layer "${n}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
                    const d = f.encode(n), p = [], x = this.localizableLayerIds && this.localizableLayerIds.has(n);
                    let S = !1;
                    for(let t1 = 0, o = 0; t1 < i.length; t1++){
                        const s = i.feature(t1), r = m.getId(s, n), a = s.properties ? s.properties.worldview : null;
                        if (x && this.worldview && "string" == typeof a) {
                            if ("all" === a) s.properties.$localized = !0;
                            else {
                                if (!a.split(",").includes(this.worldview)) continue;
                                s.properties.$localized = !0, s.properties.worldview = this.worldview;
                            }
                        }
                        !S && s.properties && Object.hasOwn(s.properties, e1.fY) && (S = !0), h && this.frcCoverage && this.frcCoverage.frcMask && s.properties && e1.gj && e1.gj(s.properties, this.frcCoverage.frcMask) || (p.push({
                            feature: s,
                            id: r,
                            index: o,
                            sourceLayerIndex: d
                        }), o++);
                    }
                    S && !w.elevationFeatures && o && (w.elevationFeatures = o(t1, this.canonical));
                    for (const t1 of b[n]){
                        const o = t1[0];
                        if (this.extraShadowCaster && (!o.is3D() || "model" === o.type)) continue;
                        if (this.renderSourceType === e1.b_.Symbol && "symbol" !== o.type) continue;
                        if (this.renderSourceType === e1.b_.FillExtrusion && "fill-extrusion" !== o.type) continue;
                        if (!(this.renderSourceType !== e1.b_.Other && this.renderSourceType !== e1.b_.HdRoadCoverage || "symbol" !== o.type && "fill-extrusion" !== o.type)) continue;
                        if (!this.isLayerActiveForTile(o)) continue;
                        const i = m.bucketLayerIDs.length;
                        m.bucketLayerIDs.push(t1.map((t1)=>e1.m(t1.id, t1.scope)));
                        const s = ()=>{
                            Se(t1, this.zoom, w.brightness, l, this.worldview, w.activeFloors);
                            const r = y[o.id] = o.createBucket({
                                index: i,
                                layers: t1,
                                zoom: this.zoom,
                                lut: this.lut,
                                canonical: this.canonical,
                                pixelRatio: this.pixelRatio,
                                overscaling: this.overscaling,
                                collisionBoxArray: this.collisionBoxArray,
                                sourceLayerIndex: d,
                                sourceLayerName: n,
                                sourceID: this.source,
                                projection: this.projection.spec,
                                tessellationStep: this.tessellationStep,
                                styleDefinedModelURLs: c,
                                worldview: this.worldview,
                                localizable: x,
                                availableImages: l,
                                maxUniformBlockSizeDwords: this.maxUniformBlockSizeDwords
                            });
                            g && g(r, this.frcCoverage ? this.frcCoverage.sourceLayers : null), r.populate(p, w, this.tileID.canonical, this.tileTransform);
                            const a = r instanceof e1.bF && r.hasRTLText && e1.gk();
                            if (a) return a.then(s);
                        };
                        if (o.mayUse("HD") || o.mayUse("Standard")) v.push(o.prepare().then(()=>s()));
                        else {
                            const e1 = s();
                            e1 && v.push(e1);
                        }
                    }
                }
                const S = ()=>{
                    x.trim();
                    const i = !(!w.elevationFeatures || !w.elevationFeatures.some((e1)=>e1.heightRange.min < 0));
                    let r, a, c, g, v, b, S, I = w.elevationFeatures;
                    this.crossSourceElevationEnabled && o && (I = I || o(t1, this.canonical) || []);
                    const M = {
                        type: "maybePrepare",
                        renderSourceType: this.renderSourceType,
                        zoom: this.zoom
                    }, T = ()=>{
                        if (r) return this.status = "done", h(r);
                        if (this.extraShadowCaster) {
                            this.status = "done";
                            const e1 = Object.values(y).filter((e1)=>!e1.isEmpty());
                            h(null, {
                                buckets: e1,
                                containsHdExt: xe(e1),
                                containsStandardExt: we(e1),
                                featureIndex: m,
                                collisionBoxArray: null,
                                hasTunnelGeometry: i,
                                glyphAtlasImage: null,
                                lineAtlas: null,
                                imageAtlas: null,
                                brightness: w.brightness,
                                hasDeferredElevationFeatures: !!p && p(y),
                                parsedElevationFeatures: I,
                                glyphMap: null,
                                iconMap: null,
                                glyphPositions: null
                            });
                        } else if (a && c && g && S) {
                            const t1 = void 0, o = new ye(a), n = new Map;
                            for (const [t1, o] of c.entries()){
                                const { imagePosition: i } = e1.g2(t1, o, e1.g3);
                                n.set(t1, i);
                            }
                            const i = {};
                            for(const t1 in y){
                                const r = y[t1];
                                if (r instanceof e1.bF) {
                                    Se(r.layers, this.zoom, w.brightness, l, this.worldview, w.activeFloors);
                                    const u = ve(this.frcCoverage, this.source, r.layers[0].sourceLayer);
                                    i[t1] = K(r, a, o.positions, c, n, this.tileID.canonical, this.tileZoom, this.scaleFactor, this.pixelRatio, v, this.worldview, l, u.frcMask, u.polygons, u.tileZoom, e1.gj || null, s || null);
                                }
                            }
                            v.size || b.size ? this.rasterizeTask = u.sendCancelable("rasterizeImages", {
                                scope: this.scope,
                                iconTasks: v,
                                patternTasks: b
                            }, {}, (e1, n)=>{
                                if (!e1) for (const [e1, t1] of n.entries())c.has(e1) && c.set(e1, Object.assign(c.get(e1), {
                                    data: t1
                                })), g.has(e1) && g.set(e1, Object.assign(g.get(e1), {
                                    data: t1
                                }));
                                P(i, o, t1, S);
                            }) : P(i, o, t1, S);
                        }
                    }, P = (t1, o, n, s)=>{
                        const r = c.size > 0 || g.size > 0, a = Object.keys(t1).length > 0;
                        if (!r && !a) {
                            this.status = "done";
                            const e1 = Object.values(y).filter((e1)=>!e1.isEmpty());
                            return void h(null, {
                                buckets: e1,
                                containsHdExt: xe(e1),
                                containsStandardExt: we(e1),
                                featureIndex: m,
                                collisionBoxArray: this.collisionBoxArray,
                                hasTunnelGeometry: i,
                                glyphAtlasImage: o.image,
                                lineAtlas: x,
                                imageAtlas: null,
                                brightness: w.brightness,
                                hasDeferredRoadStructure: this.deferRoadStructure,
                                frcCoveragePolygons: d,
                                hasDeferredElevationFeatures: !!p && p(y),
                                parsedElevationFeatures: I
                            });
                        }
                        const f = (n, s)=>{
                            for(const o in y){
                                const n = y[o];
                                if (o in t1) se(n, t1[o], this.showCollisionBoxes, l, this.tileID.canonical, this.tileZoom, this.projection, this.brightness, c, s);
                                else if (n.hasPattern && (n instanceof e1.bG || n instanceof e1.bL || n instanceof e1.aN)) {
                                    Se(n.layers, this.zoom, w.brightness, l, this.worldview, w.activeFloors);
                                    const e1 = Object.fromEntries(s.patternPositions);
                                    n.addFeatures(w, this.tileID.canonical, e1, l, this.tileTransform, this.brightness);
                                }
                            }
                            this.status = "done";
                            const r = Object.values(y).filter((e1)=>!e1.isEmpty());
                            h(null, {
                                buckets: r,
                                containsHdExt: xe(r),
                                containsStandardExt: we(r),
                                featureIndex: m,
                                collisionBoxArray: this.collisionBoxArray,
                                hasTunnelGeometry: i,
                                glyphAtlasImage: o.image,
                                lineAtlas: x,
                                imageAtlas: n,
                                brightness: w.brightness,
                                hasDeferredRoadStructure: this.deferRoadStructure,
                                frcCoveragePolygons: d,
                                hasDeferredElevationFeatures: !!p && p(y),
                                parsedElevationFeatures: I
                            });
                        };
                        if (r) {
                            const t1 = new Map, o = e1.gm(c, t1), n = e1.gm(g, t1), i = new e1.gn(o, n, s, this.lut, this.scope, t1);
                            u.send("checkAtlasCache", {
                                descriptor: i,
                                scope: this.scope
                            }).then((t1)=>{
                                let o, n;
                                if (t1) o = new e1.go(t1.sourceHash), n = t1;
                                else {
                                    const t1 = new e1.gp(c, g, this.lut, s, this.scope);
                                    o = t1, n = t1;
                                }
                                f(o, n);
                            }).catch((t1)=>{
                                "AbortError" !== t1.name && e1.w(`[Worker] Error checking atlas cache: ${t1.message}`);
                                const o = new e1.gp(c, g, this.lut, s, this.scope);
                                f(o, o);
                            });
                        } else f(null, {
                            iconPositions: new Map,
                            patternPositions: new Map
                        });
                    };
                    if (!this.extraShadowCaster) {
                        const t1 = e1.gl(w.glyphDependencies, (e1)=>Object.keys(e1).map(Number)), o = {};
                        if (this.localGlyphs) for(const e1 in t1)o[e1] = t1[e1].filter((e1)=>this.localGlyphs.supports(e1)), t1[e1] = t1[e1].filter((e1)=>!this.localGlyphs.supports(e1));
                        const n = {};
                        Object.keys(t1).length ? u.send("getGlyphs", {
                            uid: this.uid,
                            stacks: t1
                        }, {
                            metadata: M
                        }).then((e1)=>{
                            if (!r) {
                                a = e1;
                                for(const e1 in n)Object.assign(a[e1].glyphs, n[e1]);
                                T();
                            }
                        }).catch((e1)=>{
                            r || (r = e1, T());
                        }) : a = {}, S = new Map;
                        const i = Array.from(w.iconDependencies.keys()).map((t1)=>e1.I.parse(t1)), s = Array.from(w.patternDependencies.keys()).map((t1)=>e1.I.parse(t1));
                        i.length || s.length ? u.send("getImages", {
                            icons: i,
                            patterns: s,
                            source: this.source,
                            scope: this.scope,
                            tileID: this.tileID
                        }, {
                            metadata: M
                        }).then((e1)=>{
                            if (!r) {
                                c = new Map, g = new Map, v = this.updateImageMapAndGetImageTaskQueue(c, e1.images, w.iconDependencies), b = this.updateImageMapAndGetImageTaskQueue(g, e1.images, w.patternDependencies);
                                for (const [t1, o] of e1.versions.entries())S.set(t1, o);
                                T();
                            }
                        }).catch((e1)=>{
                            r || (r = e1, T());
                        }) : (c = new Map, g = new Map, v = new Map, b = new Map);
                        for(const e1 in o){
                            const t1 = n[e1] = {};
                            for (const n of o[e1])t1[n] = this.localGlyphs.draw(e1, n);
                        }
                    }
                    n && n({
                        buckets: y,
                        data: t1,
                        sourceLayerCoder: f,
                        canonical: this.tileID.canonical,
                        options: w
                    }), T();
                };
                v.length > 0 ? Promise.allSettled(v).then(S).catch(h) : S();
            }
            updateParameters(t1) {
                this.scaleFactor = t1.scaleFactor, this.showCollisionBoxes = t1.showCollisionBoxes, this.showElevationIdDebug = t1.showElevationIdDebug, this.projection = t1.projection, this.brightness = t1.brightness, this.tileTransform = e1.bA(t1.tileID.canonical, t1.projection), this.extraShadowCaster = t1.extraShadowCaster, this.lut = t1.lut, this.worldview = t1.worldview, this.indoor = t1.indoor, this.frcCoverage = t1.frcCoverage || null, this.elevation = t1.elevation || null, this.crossSourceElevationEnabled = !!t1.crossSourceElevationEnabled, this.terrainEnabled = !!t1.terrainEnabled;
            }
            updateImageMapAndGetImageTaskQueue(e1, t1, o) {
                const n = new Map;
                for (const i of t1.keys()){
                    const s = o.get(i) || [];
                    for (const o of s){
                        const i = o.toString(), s = t1.get(o.id.toString());
                        s.usvg ? n.has(i) || (n.set(i, o), e1.set(i, {
                            ...s
                        })) : e1.set(i, s);
                    }
                }
                return n;
            }
            cancelRasterize() {
                this.rasterizeTask && this.rasterizeTask.abort();
            }
        }
        function Se(t1, o, n, i, s, r) {
            const a = new e1.au(o, {
                brightness: n,
                worldview: s,
                activeFloors: r
            });
            for (const e1 of t1)e1.recalculate(a, i);
        }
        class Ie extends e1.E {
            constructor({ actor: t1, layerIndex: o, availableImages: n, availableModels: i, isSpriteLoaded: s, tileProvider: r, brightness: a, maxUniformBlockSizeDwords: l, localGlyphs: c }){
                super(), this.actor = t1, this.layerIndex = o, this.availableImages = n, this.availableModels = i, this.loadVectorData = e1.cY, this.tileProvider = r, this.loading = {}, this.loaded = {}, this.deduped = new e1.cW(t1.scheduler), this.isSpriteLoaded = s, this.scheduler = t1.scheduler, this.brightness = a, this.maxUniformBlockSizeDwords = l, this.localGlyphs = c;
            }
            loadTileData(e1, t1) {
                if (!this.tileProvider) return this.loadVectorData(e1, t1);
                const o = new AbortController;
                return this.loadTileWithProvider(this.tileProvider, e1, o, t1), ()=>o.abort();
            }
            async loadTileWithProvider(e1, t1, o, n) {
                const { z: i, x: s, y: r } = t1.tileID.canonical;
                try {
                    const a = await e1.loadTile({
                        z: i,
                        x: s,
                        y: r
                    }, {
                        request: t1.request,
                        signal: o.signal
                    });
                    if (o.signal.aborted) return;
                    if (null == a) {
                        const e1 = new Error("Tile not found");
                        return e1.status = 404, n(e1);
                    }
                    if (null == a.data) return n(null, null);
                    if (a.data instanceof ImageBitmap) return n(new Error("Vector tiles require ArrayBuffer data"));
                    const l = new Headers;
                    a.expires && l.set("expires", a.expires), a.cacheControl && l.set("cache-control", a.cacheControl), n(null, {
                        rawData: a.data,
                        headers: l
                    });
                } catch (e1) {
                    if (o.signal.aborted) return;
                    n(e1 instanceof Error ? e1 : new Error(String(e1)));
                }
            }
            _fetchTileData(e1, t1) {
                return new Promise((o, n)=>{
                    e1.abort = this.loadTileData(t1, (e1, t1)=>{
                        e1 ? n(e1) : o(t1);
                    });
                });
            }
            async _parse(e1, t1) {
                const o = !this.isSpriteLoaded;
                return o && await this.once("isSpriteLoaded"), new Promise((n, i)=>{
                    const s = ()=>e1.parse(e1.vectorTile, this.layerIndex, this.availableImages, this.availableModels, this.actor, (e1, t1)=>{
                            e1 ? i(e1) : n(t1);
                        });
                    o && this.scheduler ? this.scheduler.add(s, {
                        type: "parseTile",
                        renderSourceType: t1.renderSourceType,
                        zoom: t1.tileZoom
                    }) : s();
                });
            }
            async loadTile(o) {
                const n = o.uid, i = o && o.request, s = i && i.collectResourceTiming, r = this.loading[n] = new be(o);
                r.maxUniformBlockSizeDwords = this.maxUniformBlockSizeDwords, r.localGlyphs = this.localGlyphs;
                const a = (e1, t1)=>{
                    const o = r.reloadCallback;
                    o && (delete r.reloadCallback, e1 || !t1 ? o(e1, null) : r.parse(r.vectorTile, this.layerIndex, this.availableImages, this.availableModels, this.actor, o));
                };
                let l, c;
                try {
                    l = await this._fetchTileData(r, o);
                } catch (e1) {
                    c = e1;
                }
                const u = !this.loading[n];
                if (delete this.loading[n], r.cancelRasterize(), c || u || !l) {
                    if (r.status = "done", u || (this.loaded[n] = r), c) throw c;
                    return null;
                }
                const h = l.rawData;
                let d;
                r.vectorTile = l.vectorTile || new e1.gq(new e1.d(h)), this.loaded = this.loaded || {}, this.loaded[n] = r;
                try {
                    d = await this._parse(r, o);
                } catch (e1) {
                    throw a(e1), e1;
                }
                if (!d) return a(null, null), null;
                const f = {};
                if (s) {
                    const e1 = t1(i);
                    e1.length > 0 && (f.resourceTiming = JSON.parse(JSON.stringify(e1)));
                }
                const g = {
                    rawTileData: h.slice(0),
                    headers: l.headers,
                    ...d,
                    ...f
                };
                return a(null, d), g;
            }
            async reloadTile(e1) {
                const t1 = this.loaded, o = e1.uid;
                if (t1 && t1[o]) return new Promise((n, i)=>{
                    const s = t1[o];
                    s.updateParameters(e1);
                    const r = (e1, t1)=>{
                        const o = s.reloadCallback;
                        o && (delete s.reloadCallback, s.parse(s.vectorTile, this.layerIndex, this.availableImages, this.availableModels, this.actor, o)), e1 ? i(e1) : n(t1);
                    };
                    "parsing" === s.status ? s.reloadCallback = r : "done" === s.status ? s.vectorTile ? s.parse(s.vectorTile, this.layerIndex, this.availableImages, this.availableModels, this.actor, r) : r() : n(void 0);
                });
            }
            abortTile(e1) {
                const t1 = e1.uid, o = this.loading[t1];
                o && (o.abort && o.abort(), delete this.loading[t1]);
            }
            removeTile(e1) {
                const t1 = this.loaded, o = e1.uid;
                t1 && t1[o] && delete t1[o];
            }
        }
        class Me {
            constructor(e1){
                this.tileProvider = e1.tileProvider, this.loading = {};
            }
            async loadTile(t1) {
                const o = t1.uid, n = new AbortController;
                if (this.loading[o] = {
                    cancel: ()=>n.abort()
                }, this.tileProvider) return this.loadTileWithProvider(this.tileProvider, o, t1, n);
                try {
                    const { data: i, headers: s } = await e1.n(t1.request, n.signal);
                    if (!i) return null;
                    const r = await this.decodeTile(o, i, t1.encoding);
                    return r.headers = s, r;
                } catch (e1) {
                    if (n.signal.aborted) return null;
                    throw e1;
                } finally{
                    delete this.loading[o];
                }
            }
            async decodeTile(t1, o, n) {
                const i = o instanceof ImageBitmap ? o : await createImageBitmap(new Blob([
                    new Uint8Array(o)
                ], {
                    type: "image/png"
                })), s = 1 - (i.width - e1.gr(i.width)) / 2, r = s < 1, a = this.getImageData(i, s);
                i.close();
                const l = new e1.gs(t1, a, n, r);
                return l._buildQuadTree(), {
                    dem: l,
                    borderReady: r
                };
            }
            async loadTileWithProvider(e1, t1, o, n) {
                const { z: i, x: s, y: r } = o.tileID.canonical;
                try {
                    const a = await e1.loadTile({
                        z: i,
                        x: s,
                        y: r
                    }, {
                        request: o.request,
                        signal: n.signal
                    });
                    if (n.signal.aborted) return null;
                    if (null == a) {
                        const e1 = new Error("Tile not found");
                        throw e1.status = 404, e1;
                    }
                    if (null == a.data) return null;
                    const l = await this.decodeTile(t1, a.data, o.encoding);
                    if (n.signal.aborted) return null;
                    const c = new Headers;
                    return a.expires && c.set("expires", a.expires), a.cacheControl && c.set("cache-control", a.cacheControl), l.headers = c, l;
                } catch (e1) {
                    if (n.signal.aborted) return null;
                    throw e1;
                } finally{
                    delete this.loading[t1];
                }
            }
            async reloadTile(e1) {}
            abortTile(e1) {
                const t1 = e1.uid, o = this.loading[t1];
                o && (o.cancel(), delete this.loading[t1]);
            }
            removeTile(e1) {}
            getImageData(e1, t1) {
                this.offscreenCanvas && this.offscreenCanvasContext || (this.offscreenCanvas = new OffscreenCanvas(e1.width, e1.height), this.offscreenCanvasContext = this.offscreenCanvas.getContext("2d", {
                    willReadFrequently: !0
                })), this.offscreenCanvas.width = e1.width, this.offscreenCanvas.height = e1.height, this.offscreenCanvasContext.drawImage(e1, 0, 0, e1.width, e1.height);
                const o = this.offscreenCanvasContext.getImageData(-t1, -t1, e1.width + 2 * t1, e1.height + 2 * t1);
                return this.offscreenCanvasContext.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height), o;
            }
        }
        const Te = e1.gt.prototype.toGeoJSON;
        class Pe {
            constructor(t1){
                this._feature = t1, this.extent = e1.ac, this.type = 4 === t1.type ? 1 : t1.type, this.properties = t1.tags || {}, "id" in t1 && !isNaN(t1.id) && (this.id = parseInt(t1.id, 10));
            }
            loadGeometry() {
                const t1 = this._feature, o = [];
                if (4 === t1.type) o.push([
                    new e1.P(t1.x, t1.y)
                ]);
                else if (1 === t1.type) for(let n = 0; n < t1.geometry.length; n += 2)o.push([
                    new e1.P(t1.geometry[n], t1.geometry[n + 1])
                ]);
                else for (const n of t1.geometry){
                    const t1 = [];
                    for(let o = 0; o < n.length; o += 2)t1.push(new e1.P(n[o], n[o + 1]));
                    o.push(t1);
                }
                return o;
            }
            toGeoJSON(e1, t1, o) {
                return Te.call(this, e1, t1, o);
            }
        }
        class ze {
            constructor(t1, o){
                this.name = t1, this.extent = e1.ac, this.length = o.length, this._jsonFeatures = o;
            }
            feature(e1) {
                return new Pe(this._jsonFeatures[e1]);
            }
        }
        class ke {
            constructor(t1){
                this.layers = {}, this.extent = e1.ac;
                for (const e1 of Object.keys(t1))this.layers[e1] = new ze(e1, t1[e1]);
            }
        }
        const Be = 64 / 4096;
        class Ce {
            constructor(){
                this.features = new Map;
            }
            clear() {
                this.features.clear();
            }
            load(e1 = [], t1) {
                for (const o of e1){
                    const e1 = o.id;
                    if (null == e1) continue;
                    const n = this.features.get(e1);
                    if (n && this.updateCache(n, t1), o.geometry) {
                        const n = Ae(o);
                        this.updateCache(n, t1), this.features.set(e1, n);
                    } else this.features.delete(e1);
                }
            }
            updateCache(e1, t1) {
                for (const { canonical: o, uid: n } of Object.values(t1)){
                    const { z: i, x: s, y: r } = o;
                    _e(e1, Math.pow(2, i), s, r) && delete t1[n];
                }
            }
            getTileRaw(e1, t1, o) {
                const n = Math.pow(2, e1), i = [];
                for (const e1 of this.features.values())_e(e1, n, t1, o) && i.push(Le(e1, n, t1, o));
                return {
                    features: i
                };
            }
            getFeatures() {
                return [
                    ...this.features.values()
                ];
            }
        }
        function _e({ minX: e1, minY: t1, maxX: o, maxY: n }, i, s, r) {
            return e1 < (s + 1 + Be) / i && t1 < (r + 1 + Be) / i && o > (s - Be) / i && n > (r - Be) / i;
        }
        function Ae(e1) {
            const { id: t1, geometry: o, properties: n } = e1;
            if ("GeometryCollection" === o.type) throw new Error("GeometryCollection not supported in dynamic mode.");
            const { type: i, coordinates: s } = o, r = {
                id: t1,
                type: 1,
                geometry: [],
                tags: n,
                minX: 1 / 0,
                minY: 1 / 0,
                maxX: -1 / 0,
                maxY: -1 / 0
            }, a = r.geometry;
            if ("Point" === i) Fe(s, a, r);
            else if ("MultiPoint" === i) for (const e1 of s)Fe(e1, a, r);
            else if ("LineString" === i) r.type = 2, De(s, a, r);
            else if ("MultiLineString" === i) r.type = 2, Ee(s, a, r);
            else if ("Polygon" === i) r.type = 3, Ee(s, a, r, !0);
            else {
                if ("MultiPolygon" !== i) throw new Error("Input data is not a valid GeoJSON object.");
                r.type = 3;
                for (const e1 of s)Ee(e1, a, r, !0);
            }
            return r;
        }
        function Fe([t1, o], n, i) {
            const s = e1.ad(t1);
            let r = e1.ae(o);
            r = r < 0 ? 0 : r > 1 ? 1 : r, n.push(s, r), i.minX = Math.min(i.minX, s), i.minY = Math.min(i.minY, r), i.maxX = Math.max(i.maxX, s), i.maxY = Math.max(i.maxY, r);
        }
        function De(e1, t1, o, n = !1, i = !1) {
            const s = [];
            for (const t1 of e1)Fe(t1, s, o);
            t1.push(s), n && function(e1, t1) {
                let o = 0;
                for(let t1 = 0, n = e1.length, i = n - 2; t1 < n; i = t1, t1 += 2)o += (e1[t1] - e1[i]) * (e1[t1 + 1] + e1[i + 1]);
                if (o > 0 === t1) for(let t1 = 0, o = e1.length; t1 < o / 2; t1 += 2){
                    const n = e1[t1], i = e1[t1 + 1];
                    e1[t1] = e1[o - 2 - t1], e1[t1 + 1] = e1[o - 1 - t1], e1[o - 2 - t1] = n, e1[o - 1 - t1] = i;
                }
            }(s, i);
        }
        function Ee(e1, t1, o, n = !1) {
            for(let i = 0; i < e1.length; i++)De(e1[i], t1, o, n, 0 === i);
        }
        function Oe(t1, o, n) {
            return Math.round(e1.ac * (t1 * o - n));
        }
        function Le(e1, t1, o, n) {
            const { id: i, type: s, geometry: r, tags: a } = e1;
            if (1 === s) {
                const e1 = r;
                if (2 === e1.length) return {
                    id: i,
                    type: 4,
                    x: Oe(e1[0], t1, o),
                    y: Oe(e1[1], t1, n),
                    tags: a
                };
                const s = new Int32Array(e1.length);
                for(let i = 0; i < e1.length; i += 2)s[i] = Oe(e1[i], t1, o), s[i + 1] = Oe(e1[i + 1], t1, n);
                return {
                    id: i,
                    type: 1,
                    geometry: s,
                    tags: a
                };
            }
            const l = [];
            if (2 === s) {
                const e1 = [];
                for (const i of r)je(i, t1, o, n, e1);
                for (const t1 of e1)l.push(new Int32Array(t1));
            } else for (const e1 of r)Re(e1, t1, o, n, l);
            return {
                id: i,
                type: s,
                geometry: l,
                tags: a
            };
        }
        function je(t1, o, n, i, s) {
            const r = -128, a = e1.ac + 128;
            let l;
            for(let e1 = 0; e1 < t1.length - 2; e1 += 2){
                let c = Oe(t1[e1 + 0], o, n), u = Oe(t1[e1 + 1], o, i), h = Oe(t1[e1 + 2], o, n), d = Oe(t1[e1 + 3], o, i);
                const f = h - c, g = d - u;
                c < r && h < r || (c < r ? (u += Math.round(g * ((r - c) / f)), c = r) : h < r && (d = u + Math.round(g * ((r - c) / f)), h = r), u < r && d < r || (u < r ? (c += Math.round(f * ((r - u) / g)), u = r) : d < r && (h = c + Math.round(f * ((r - u) / g)), d = r), c >= a && h >= a || (c >= a ? (u += Math.round(g * ((a - c) / f)), c = a) : h >= a && (d = u + Math.round(g * ((a - c) / f)), h = a), u >= a && d >= a || (u >= a ? (c += Math.round(f * ((a - u) / g)), u = a) : d >= a && (h = c + Math.round(f * ((a - u) / g)), d = a), l && c === l.at(-2) && u === l.at(-1) || (l = [
                    c,
                    u
                ], s.push(l)), l.push(h, d)))));
            }
        }
        function Re(e1, t1, o, n, i) {
            const s = (o - Be) / t1, r = (n - Be) / t1, a = (o + 1 + Be) / t1, l = (n + 1 + Be) / t1;
            function c(e1, t1) {
                let o = 0;
                return e1 < s ? o |= 1 : e1 > a && (o |= 2), t1 < r ? o |= 4 : t1 > l && (o |= 8), o;
            }
            let u = [];
            for(let t1 = 1; t1 <= 8; t1 *= 2){
                let o = e1.at(-2), n = e1.at(-1), i = !(c(o, n) & t1);
                for(let h = 0; h < e1.length; h += 2){
                    const d = e1[h], f = e1[h + 1], g = !(c(d, f) & t1);
                    g !== i && (8 & t1 ? u.push(o + (d - o) * (l - n) / (f - n), l) : 4 & t1 ? u.push(o + (d - o) * (r - n) / (f - n), r) : 2 & t1 ? u.push(a, n + (f - n) * (a - o) / (d - o)) : 1 & t1 && u.push(s, n + (f - n) * (s - o) / (d - o))), g && u.push(d, f), o = d, n = f, i = g;
                }
                if (!(e1 = u).length || 8 === t1) break;
                u = [];
            }
            if (!u.length) return;
            const h = new Int32Array(u.length);
            for(let e1 = 0; e1 < u.length; e1 += 2)h[e1] = Oe(u[e1], t1, o), h[e1 + 1] = Oe(u[e1 + 1], t1, n);
            i.push(h);
        }
        function Ve({ name: t1, features: o }, n) {
            n.writeStringField(1, t1), n.writeVarintField(5, e1.ac);
            const i = new Map, s = new Map, r = {
                keys: i,
                values: s,
                feature: null
            };
            for (const e1 of o)r.feature = e1, n.writeMessage(2, Ze, r);
            for (const e1 of i.keys())n.writeStringField(3, e1);
            for (const e1 of s.keys())n.writeMessage(4, Xe, e1);
        }
        function Ze(e1, t1) {
            const o = e1.feature;
            void 0 !== o.id && Number.isSafeInteger(+o.id) && t1.writeVarintField(1, +o.id), o.tags && t1.writeMessage(2, Ge, e1), t1.writeVarintField(3, 4 === o.type ? 1 : o.type), t1.writeMessage(4, $e, o);
        }
        function Ge({ keys: e1, values: t1, feature: o }, n) {
            const i = o.tags;
            for (const o of Object.keys(i)){
                let s = i[o];
                if (null === s) continue;
                let r = e1.get(o);
                void 0 === r && (r = e1.size, e1.set(o, r)), n.writeVarint(r);
                const a = typeof s;
                "string" !== a && "boolean" !== a && "number" !== a && (s = JSON.stringify(s));
                let l = t1.get(s);
                void 0 === l && (l = t1.size, t1.set(s, l)), n.writeVarint(l);
            }
        }
        function Ne(e1, t1) {
            return (t1 << 3) + (7 & e1);
        }
        function Ye(e1) {
            return e1 << 1 ^ e1 >> 31;
        }
        function $e(e1, t1) {
            if (4 === e1.type) return t1.writeVarint(Ne(1, 1)), t1.writeVarint(Ye(e1.x)), void t1.writeVarint(Ye(e1.y));
            let o = 0, n = 0;
            if (1 === e1.type) {
                const { geometry: i } = e1;
                t1.writeVarint(Ne(1, i.length >> 1));
                for(let e1 = 0; e1 < i.length; e1 += 2){
                    const s = i[e1] - o, r = i[e1 + 1] - n;
                    t1.writeVarint(Ye(s)), t1.writeVarint(Ye(r)), o += s, n += r;
                }
            } else {
                const i = 3 === e1.type;
                for (const s of e1.geometry){
                    if (0 === s.length) continue;
                    t1.writeVarint(Ne(1, 1));
                    const e1 = (s.length >> 1) - (i ? 1 : 0);
                    for(let i = 0; i < e1; i++){
                        1 === i && t1.writeVarint(Ne(2, e1 - 1));
                        const r = s[2 * i] - o, a = s[2 * i + 1] - n;
                        t1.writeVarint(Ye(r)), t1.writeVarint(Ye(a)), o += r, n += a;
                    }
                    i && t1.writeVarint(Ne(7, 1));
                }
            }
        }
        function Xe(e1, t1) {
            const o = typeof e1;
            "string" === o ? t1.writeStringField(1, e1) : "boolean" === o ? t1.writeBooleanField(7, e1) : "number" === o && (e1 % 1 != 0 ? t1.writeDoubleField(3, e1) : e1 < 0 ? t1.writeSVarintField(6, e1) : t1.writeVarintField(5, e1));
        }
        const Je = {
            minZoom: 0,
            maxZoom: 16,
            minPoints: 2,
            radius: 40,
            extent: 512,
            nodeSize: 64,
            log: !1,
            generateId: !1,
            reduce: null,
            map: (e1)=>e1
        }, qe = 1073741824, Ue = 1 / qe, We = (e1)=>(e1 - .5) * qe, He = (e1)=>e1 * Ue + .5;
        class Ke {
            constructor(e1){
                const t1 = this.options = Object.assign(Object.create(Je), e1);
                t1.maxZoom = Math.min(t1.maxZoom, 30), t1.minZoom = Math.min(t1.minZoom, t1.maxZoom), this.trees = new Array(t1.maxZoom + 1), this.stride = t1.reduce ? 7 : 6, this.clusterProps = [];
            }
            load(e1) {
                const { log: t1, minZoom: o, maxZoom: n } = this.options;
                t1 && console.time("total time");
                const i = n + 1, s = `z${i}: ${e1.length} points`;
                t1 && console.time(s);
                const r = this.stride;
                let a = e1.length;
                for (const t1 of e1){
                    const e1 = t1.geometry;
                    e1 && "MultiPoint" === e1.type && (a += e1.coordinates.length - 1);
                }
                this.numPoints = a;
                const l = this.props = new Array(a), c = this.coords = new Float64Array(2 * a);
                let u = null;
                const h = new Int32Array(a * r);
                let d = 0, f = 0;
                for (const t1 of e1){
                    const e1 = t1.geometry;
                    if (!e1) {
                        f++;
                        continue;
                    }
                    const o = e1.coordinates, n = "MultiPoint" === e1.type;
                    for(let e1 = 0, s = n ? o.length : 1; e1 < s; e1++, f++){
                        const [s, g] = n ? o[e1] : o, p = et(s), m = tt(g);
                        c[2 * f] = p, c[2 * f + 1] = m, h[d] = We(p), h[d + 1] = We(m), h[d + 2] = i, h[d + 3] = f, h[d + 4] = -1, h[d + 5] = 1, l[f] = t1.properties, void 0 !== t1.id && (u || (u = new Array(a)), u[f] = t1.id), d += r;
                    }
                }
                this.ids = u;
                let g = d === h.length ? h : h.subarray(0, d), p = d / r;
                this.trees[n + 1] = this._createTree(g, p), t1 && console.timeEnd(s);
                let m = null;
                for(let e1 = n; e1 >= o; e1--){
                    const o = performance.now(), n = m || new Int32Array(p * r);
                    m = null;
                    const i = this._cluster(g, p, e1, n);
                    i === p ? (this.trees[e1] = this.trees[e1 + 1], m = n) : (this.trees[e1] = this._createTree(n, i), g = n, p = i), t1 && console.log(`z${e1}: ${this.trees[e1].numItems} clusters in ${(performance.now() - o).toFixed(2)}ms`);
                }
                return t1 && console.timeEnd("total time"), this;
            }
            getClusters(e1, t1) {
                let o = ((e1[0] + 180) % 360 + 360) % 360 - 180;
                const n = Math.max(-90, Math.min(90, e1[1]));
                let i = 180 === e1[2] ? 180 : ((e1[2] + 180) % 360 + 360) % 360 - 180;
                const s = Math.max(-90, Math.min(90, e1[3]));
                if (e1[2] - e1[0] >= 360) o = -180, i = 180;
                else if (o > i) {
                    const e1 = this.getClusters([
                        o,
                        n,
                        180,
                        s
                    ], t1), r = this.getClusters([
                        -180,
                        n,
                        i,
                        s
                    ], t1);
                    return e1.concat(r);
                }
                const r = this.trees[this._limitZoom(t1)], a = r.range(We(et(o)), We(tt(s)), We(et(i)), We(tt(n))), l = r.data, c = [];
                for (const e1 of a)c.push(this._featureJSON(l, this.stride * e1));
                return c;
            }
            getChildren(e1) {
                const t1 = this._getOriginId(e1), o = this._getOriginZoom(e1), n = "No cluster with the specified id.", i = this.trees[o];
                if (!i) throw new Error(n);
                const s = i.data;
                if (t1 >= i.numItems) throw new Error(n);
                const r = this.options.radius / (this.options.extent * Math.pow(2, o - 1)), a = i.within(s[t1 * this.stride], s[t1 * this.stride + 1], r * qe), l = [];
                for (const t1 of a){
                    const o = t1 * this.stride;
                    s[o + 4] === e1 && l.push(this._featureJSON(s, o));
                }
                if (0 === l.length) throw new Error(n);
                return l;
            }
            getLeaves(e1, t1, o) {
                const n = [];
                return this._appendLeaves(n, e1, t1 = t1 || 10, o = o || 0, 0), n;
            }
            getTile(e1, t1, o) {
                return this._getTile(e1, t1, o, !1);
            }
            getTileRaw(e1, t1, o) {
                return this._getTile(e1, t1, o, !0);
            }
            _getTile(e1, t1, o, n) {
                const i = this.trees[this._limitZoom(e1)], s = Math.pow(2, e1), { extent: r, radius: a } = this.options, l = a / r, c = We((o - l) / s), u = We((o + 1 + l) / s), h = {
                    features: []
                };
                return this._addTileFeatures(i.range(We((t1 - l) / s), c, We((t1 + 1 + l) / s), u), i.data, t1, o, s, h, n), 0 === t1 && this._addTileFeatures(i.range(We(1 - l / s), c, We(1), u), i.data, s, o, s, h, n), t1 === s - 1 && this._addTileFeatures(i.range(We(0), c, We(l / s), u), i.data, -1, o, s, h, n), h.features.length ? h : null;
            }
            getClusterExpansionZoom(e1) {
                let t1 = this._getOriginZoom(e1) - 1;
                for(; t1 <= this.options.maxZoom;){
                    const o = this.getChildren(e1);
                    if (t1++, 1 !== o.length) break;
                    e1 = o[0].properties.cluster_id;
                }
                return t1;
            }
            _appendLeaves(e1, t1, o, n, i) {
                const s = this.getChildren(t1);
                for (const t1 of s){
                    const s = t1.properties;
                    if (s && s.cluster ? i + s.point_count <= n ? i += s.point_count : i = this._appendLeaves(e1, s.cluster_id, o, n, i) : i < n ? i++ : e1.push(t1), e1.length === o) break;
                }
                return i;
            }
            _createTree(t1, o) {
                const n = new e1.dC(o, this.options.nodeSize, Int32Array), i = this.stride;
                for(let e1 = 0; e1 < o; e1++)n.add(t1[e1 * i], t1[e1 * i + 1]);
                return n.finish(), n.data = t1, n;
            }
            _addTileFeatures(e1, t1, o, n, i, s, r) {
                for (const a of e1){
                    const e1 = a * this.stride, l = t1[e1 + 5] > 1;
                    let c, u, h;
                    if (l) c = Qe(t1, e1, this.clusterProps), u = He(t1[e1]), h = He(t1[e1 + 1]);
                    else {
                        const o = t1[e1 + 3];
                        c = this.props[o], u = this.coords[2 * o], h = this.coords[2 * o + 1];
                    }
                    const d = Math.round(this.options.extent * (u * i - o)), f = Math.round(this.options.extent * (h * i - n)), g = r ? {
                        type: 4,
                        x: d,
                        y: f,
                        tags: c
                    } : {
                        type: 1,
                        geometry: [
                            [
                                d,
                                f
                            ]
                        ],
                        tags: c
                    }, p = t1[e1 + 3], m = l || this.options.generateId ? p : this.ids ? this.ids[p] : void 0;
                    void 0 !== m && (g.id = m), s.features.push(g);
                }
            }
            _limitZoom(e1) {
                return Math.max(this.options.minZoom, Math.min(Math.floor(+e1), this.options.maxZoom + 1));
            }
            _cluster(e1, t1, o, n) {
                const { radius: i, extent: s, reduce: r, minPoints: a, maxZoom: l } = this.options, c = i / (s * (1 << o)) * qe, u = l + 1, h = this.trees[o + 1], d = this.stride, f = t1 * d, g = new Uint32Array(t1);
                let p = 0;
                for(let t1 = 0; t1 < f; t1 += d){
                    if (e1[t1 + 2] <= o) continue;
                    e1[t1 + 2] = o;
                    const i = e1[t1], s = e1[t1 + 1], l = h.withinInto(i, s, c, g), f = e1[t1 + 5];
                    let m = f;
                    for(let t1 = 0; t1 < l; t1++){
                        const n = g[t1] * d;
                        e1[n + 2] > o && (m += e1[n + 5]);
                    }
                    if (m > f && m >= a) {
                        let a, c = i * f, h = s * f, y = -1;
                        const x = (t1 / d << 5) + (o + 1) + this.numPoints;
                        for(let n = 0; n < l; n++){
                            const i = g[n] * d;
                            if (e1[i + 2] <= o) continue;
                            e1[i + 2] = o;
                            const s = e1[i + 5];
                            c += e1[i] * s, h += e1[i + 1] * s, e1[i + 4] = x, r && (a || (a = this._map(e1, t1, !0), y = this.clusterProps.length, this.clusterProps.push(a)), r(a, this._map(e1, i)));
                        }
                        e1[t1 + 4] = x, n[p] = c / m, n[p + 1] = h / m, n[p + 2] = u, n[p + 3] = x, n[p + 4] = -1, n[p + 5] = m, r && (n[p + 6] = y), p += d;
                    } else {
                        for(let o = 0; o < d; o++)n[p + o] = e1[t1 + o];
                        if (p += d, m > 1) for(let t1 = 0; t1 < l; t1++){
                            const i = g[t1] * d;
                            if (!(e1[i + 2] <= o)) {
                                e1[i + 2] = o;
                                for(let t1 = 0; t1 < d; t1++)n[p + t1] = e1[i + t1];
                                p += d;
                            }
                        }
                    }
                }
                return p / d;
            }
            _getOriginId(e1) {
                return e1 - this.numPoints >> 5;
            }
            _getOriginZoom(e1) {
                return (e1 - this.numPoints) % 32;
            }
            _featureJSON(e1, t1) {
                const o = e1[t1 + 3], n = e1[t1 + 5] > 1, i = n ? o : this.ids ? this.ids[o] : void 0, s = {
                    type: "Feature",
                    properties: n ? Qe(e1, t1, this.clusterProps) : this.props[o],
                    geometry: {
                        type: "Point",
                        coordinates: n ? [
                            ot(He(e1[t1])),
                            nt(He(e1[t1 + 1]))
                        ] : [
                            ot(this.coords[2 * o]),
                            nt(this.coords[2 * o + 1])
                        ]
                    }
                };
                return void 0 !== i && (s.id = i), s;
            }
            _map(e1, t1, o) {
                if (e1[t1 + 5] > 1) {
                    const n = this.clusterProps[e1[t1 + 6]];
                    return o ? Object.assign({}, n) : n;
                }
                const n = this.props[e1[t1 + 3]], i = this.options.map(n);
                return o && i === n ? Object.assign({}, i) : i;
            }
        }
        function Qe(e1, t1, o) {
            const n = e1[t1 + 5], i = n >= 1e4 ? `${Math.round(n / 1e3)}k` : n >= 1e3 ? Math.round(n / 100) / 10 + "k" : n, s = e1[t1 + 6], r = -1 === s ? {} : Object.assign({}, o[s]);
            return Object.assign(r, {
                cluster: !0,
                cluster_id: e1[t1 + 3],
                point_count: n,
                point_count_abbreviated: i
            });
        }
        function et(e1) {
            return e1 / 360 + .5;
        }
        function tt(e1) {
            const t1 = Math.sin(e1 * Math.PI / 180), o = .5 - .25 * Math.log((1 + t1) / (1 - t1)) / Math.PI;
            return o < 0 ? 0 : o > 1 ? 1 : o;
        }
        function ot(e1) {
            return 360 * (e1 - .5);
        }
        function nt(e1) {
            const t1 = (180 - 360 * e1) * Math.PI / 180;
            return 360 * Math.atan(Math.exp(t1)) / Math.PI - 90;
        }
        const it = 2147483647;
        function st(e1, t1, o, n) {
            return {
                id: e1,
                type: 4,
                x: t1,
                y: o,
                tags: n
            };
        }
        function rt(e1, t1, o, n) {
            const i = {
                id: e1,
                type: t1,
                geometry: o,
                tags: n,
                minX: 1 / 0,
                minY: 1 / 0,
                maxX: -1 / 0,
                maxY: -1 / 0
            };
            if (1 === t1) at(i, o, 0, o.length);
            else {
                const e1 = 3 === t1;
                for(let t1 = 0; t1 < o.length;){
                    const n = t1 + 2, s = n + 3 * o[t1];
                    (!e1 || o[t1 + 1] >= 0) && at(i, o, n, s), t1 = s;
                }
            }
            return i;
        }
        function at(e1, t1, o, n) {
            for(let i = o; i < n; i += 3){
                const o = t1[i], n = t1[i + 1];
                o < e1.minX && (e1.minX = o), n < e1.minY && (e1.minY = n), o > e1.maxX && (e1.maxX = o), n > e1.maxY && (e1.maxY = n);
            }
        }
        function lt(e1, t1, o, n) {
            let i = n;
            const s = t1 + (o - t1 >> 1);
            let r, a = o - t1;
            const l = e1[t1], c = e1[t1 + 1], u = e1[o], h = e1[o + 1];
            for(let n = t1 + 3; n < o; n += 3){
                const t1 = ct(e1[n], e1[n + 1], l, c, u, h);
                if (t1 > i) r = n, i = t1;
                else if (t1 === i) {
                    const e1 = Math.abs(n - s);
                    e1 < a && (r = n, a = e1);
                }
            }
            if (i > n) {
                const s = r;
                s - t1 > 3 && lt(e1, t1, s, n), e1[s + 2] = Math.min(Math.sqrt(i), it), o - s > 3 && lt(e1, s, o, n);
            }
        }
        function ct(e1, t1, o, n, i, s) {
            let r = i - o, a = s - n;
            if (0 !== r || 0 !== a) {
                const l = ((e1 - o) * r + (t1 - n) * a) / (r * r + a * a);
                l > 1 ? (o = i, n = s) : l > 0 && (o += r * l, n += a * l);
            }
            return r = e1 - o, a = t1 - n, r * r + a * a;
        }
        const ut = "Input data is not a valid GeoJSON object.";
        let ht = !1;
        function dt(e1, t1, o, n) {
            const i = t1.geometry;
            if (!i) return;
            const s = "GeometryCollection" === i.type ? i.geometries : i.coordinates;
            if (!s) throw new Error(ut);
            if (!s.length) return;
            const r = o.tolerance * o.worldScale / ((1 << o.maxZoom) * o.extent), a = r * r, l = t1.properties, c = o.CoordArray, u = o.worldScale, h = o.originShift, d = o.useInt32;
            let f = t1.id;
            o.promoteId ? f = t1.properties?.[o.promoteId] : o.generateId && (f = n || 0);
            const g = e1.length;
            if ("Point" === i.type) e1.push(st(f, wt(i.coordinates[0], u, h), vt(i.coordinates[1], u, h), l));
            else if ("MultiPoint" === i.type) {
                const t1 = i.coordinates, n = new c(3 * t1.length);
                for(let e1 = 0; e1 < t1.length; e1++){
                    const o = xt(wt(t1[e1][0], u, h), d);
                    n[3 * e1] = o, Math.abs(o) >= 2147483648 && (ht = !0), n[3 * e1 + 1] = xt(vt(t1[e1][1], u, h), d);
                }
                pt(e1, f, 1, n, l, o);
            } else if ("LineString" === i.type) mt(e1, f, i.coordinates, l, a, o);
            else if ("MultiLineString" === i.type && o.lineMetrics) for (const t1 of i.coordinates)mt(e1, f, t1, l, a, o);
            else if ("MultiLineString" === i.type || "Polygon" === i.type || "MultiPolygon" === i.type) {
                const t1 = "MultiLineString" !== i.type, n = "MultiPolygon" === i.type ? i.coordinates : [
                    i.coordinates
                ];
                let s = 0;
                for (const e1 of n)s += ft(e1);
                const r = new c(s);
                let g = 0;
                for (const e1 of n)for(let o = 0; o < e1.length; o++)g = yt(r, g, e1[o], a, t1, t1 && 0 === o, u, h, d);
                pt(e1, f, t1 ? 3 : 2, r, l, o);
            } else {
                if ("GeometryCollection" !== i.type) throw new Error(ut);
                for (const s of i.geometries)dt(e1, {
                    id: f,
                    geometry: s,
                    properties: t1.properties
                }, o, n);
            }
            ht && (ht = !1, c === Int32Array && (e1.length = g, dt(e1, t1, Object.assign(Object.create(o), {
                CoordArray: Float64Array
            }), n)));
        }
        function ft(e1) {
            let t1 = 0;
            for (const o of e1)o.length > 0 && (t1 += 2 + 3 * o.length);
            return t1;
        }
        let gt = 0;
        function pt(e1, t1, o, n, i, s, r) {
            const a = rt(t1, o, n, i);
            2 === o && s.lineMetrics && (a.start = 0, a.end = a.size = r), e1.push(a);
        }
        function mt(e1, t1, o, n, i, s) {
            const r = new s.CoordArray(2 + 3 * o.length);
            yt(r, 0, o, i, !1, !1, s.worldScale, s.originShift, s.useInt32), pt(e1, t1, 2, r, n, s, gt);
        }
        function yt(e1, t1, o, n, i, s, r, a, l) {
            if (0 === o.length) return t1;
            const c = t1, u = t1 += 2;
            let h = 0, d = 0, f = 0;
            for(let n = 0; n < o.length; n++){
                const s = xt(wt(o[n][0], r, a), l), c = xt(vt(o[n][1], r, a), l);
                if (e1[t1] = s, e1[t1 + 1] = c, Math.abs(s) >= 2147483648 && (ht = !0), t1 += 3, n > 0) {
                    if (i) f += (h * c - s * d) / 2;
                    else {
                        const e1 = s - h, t1 = c - d;
                        f += Math.sqrt(e1 * e1 + t1 * t1);
                    }
                }
                h = s, d = c;
            }
            const g = t1;
            if (i && (s && f < 0 || !s && f >= 0)) {
                const t1 = g - u;
                for(let o = 0; o < t1 / 2; o += 3){
                    const t1 = u + o, n = g - 3 - o, i = e1[t1], s = e1[t1 + 1], r = e1[t1 + 2];
                    e1[t1] = e1[n], e1[t1 + 1] = e1[n + 1], e1[t1 + 2] = e1[n + 2], e1[n] = i, e1[n + 1] = s, e1[n + 2] = r;
                }
                f = -f;
            }
            const p = g - 3;
            return e1[u + 2] = it, lt(e1, u, p, n), e1[p + 2] = it, e1[c] = (g - u) / 3, i ? e1[c + 1] = Math.sign(f) * Math.min(Math.sqrt(Math.abs(f)), it) : (gt = f, e1[c + 1] = Math.min(f, it)), t1;
        }
        function xt(e1, t1) {
            return t1 ? Math.floor(e1 + .5) : e1;
        }
        function wt(e1, t1, o) {
            return (e1 / 360 + .5 - o) * t1;
        }
        function vt(e1, t1, o) {
            const n = Math.sin(e1 * Math.PI / 180), i = .5 - .25 * Math.log((1 + n) / (1 - n)) / Math.PI;
            return ((i < 0 ? 0 : i > 1 ? 1 : i) - o) * t1;
        }
        function bt(e1, t1, o, n, i, s, r) {
            if (i >= t1 && s < o) return e1;
            if (s < t1 || i >= o) return null;
            const a = r.lineMetrics;
            let l = null;
            for(let i = 0; i < e1.length; i++){
                const s = e1[i], r = s.type;
                if (4 === r) {
                    const r = 0 === n ? s.x : s.y;
                    r >= t1 && r < o ? null !== l && l.push(s) : null === l && (l = e1.slice(0, i));
                    continue;
                }
                const c = s.geometry, u = 0 === n ? s.minX : s.minY, h = 0 === n ? s.maxX : s.maxY;
                if (u >= t1 && h < o) {
                    null !== l && l.push(s);
                    continue;
                }
                if (h < t1 || u >= o) {
                    null === l && (l = e1.slice(0, i));
                    continue;
                }
                null === l && (l = e1.slice(0, i));
                const d = c.constructor;
                1 !== r ? It(c, r, t1, o, n, s, l, a, d) : St(c, t1, o, n, s, l, d);
            }
            return null === l ? e1 : l.length ? l : null;
        }
        function St(e1, t1, o, n, i, s, r) {
            let a = 0;
            for(let i = 0; i < e1.length; i += 3)e1[i + n] >= t1 && e1[i + n] < o && (a += 3);
            if (0 === a) return;
            const l = new r(a);
            let c = 0;
            for(let i = 0; i < e1.length; i += 3)e1[i + n] >= t1 && e1[i + n] < o && (l[c] = e1[i], l[c + 1] = e1[i + 1], l[c + 2] = e1[i + 2], c += 3);
            s.push(rt(i.id, 1, l, i.tags));
        }
        function It(e1, t1, o, n, i, s, r, a, l) {
            const c = 3 === t1;
            let u = 0;
            for(let t1 = 0; t1 < e1.length;){
                const s = t1 + 2 + 3 * e1[t1];
                u += Mt(e1, t1 + 2, s, o, n, i, c), t1 = s;
            }
            if (0 === u) return;
            let h = new l(u);
            const d = l === Int32Array, f = a && 2 === t1 ? [] : null;
            let g = 0;
            for(let t1 = 0; t1 < e1.length;){
                const r = t1 + 2 + 3 * e1[t1];
                g = Tt(e1, t1 + 2, r, e1[t1 + 1], h, g, o, n, i, c, d, f, s.start || 0), t1 = r;
            }
            if (g < u && (h = h.subarray(0, g)), null !== f) for(let e1 = 0, t1 = 0; e1 < h.length; t1 += 2){
                const o = e1 + 2 + 3 * h[e1], n = rt(s.id, 2, h.slice(e1, o), s.tags);
                n.start = f[t1], n.end = f[t1 + 1], n.size = s.size, r.push(n), e1 = o;
            }
            else r.push(rt(s.id, t1, h, s.tags));
        }
        function Mt(e1, t1, o, n, i, s, r) {
            let a = 0, l = 0, c = 0, u = 0;
            for(let h = t1; h < o - 3; h += 3){
                const t1 = e1[h + s], o = e1[h + 3 + s];
                let d = !1;
                t1 < n ? o >= n && (c++, u++) : t1 > i ? o <= i && (c++, u++) : c++, o < n && t1 >= n && (c++, u++, d = !0), o > i && t1 <= i && (c++, u++, d = !0), !r && d && (c > 0 && (l += c, a++), c = 0);
            }
            const h = e1[o - 3 + s];
            return h >= n && h <= i && c++, r && c >= 2 && u >= 1 && c++, c > 0 && (l += c, a++), 3 * l + 2 * a;
        }
        function Tt(e1, t1, o, n, i, s, r, a, l, c, u, h, d) {
            const f = null !== h;
            let g = s;
            i[s] = 0, i[s + 1] = n;
            let p = s += 2, m = d, y = m, x = 0, w = 0;
            for(let d = t1; d < o - 3; d += 3){
                const t1 = e1[d], o = e1[d + 1], v = e1[d + 2], b = e1[d + 3], S = e1[d + 4], I = 0 === l ? t1 : o, M = 0 === l ? b : S;
                let T = !1;
                if (f && (x = Math.sqrt((t1 - b) * (t1 - b) + (o - S) * (o - S))), I < r ? M >= r && (w = Pt(i, s, t1, o, b, S, r, l, u), s += 3, f && (y = m + x * w)) : I > a ? M <= a && (w = Pt(i, s, t1, o, b, S, a, l, u), s += 3, f && (y = m + x * w)) : (i[s] = t1, i[s + 1] = o, i[s + 2] = v, s += 3), M < r && I >= r && (w = Pt(i, s, t1, o, b, S, r, l, u), s += 3, T = !0), M > a && I <= a && (w = Pt(i, s, t1, o, b, S, a, l, u), s += 3, T = !0), !c && T) {
                    const e1 = (s - p) / 3;
                    e1 > 0 && (i[g] = e1, f && h.push(y, m + x * w), g = s, i[s] = 0, i[s + 1] = n, p = s += 2);
                }
                f && (m += x);
            }
            const v = o - 3, b = e1[v], S = e1[v + 1], I = e1[v + 2], M = 0 === l ? b : S;
            M >= r && M <= a && (i[s] = b, i[s + 1] = S, i[s + 2] = I, s += 3), c && s - p >= 6 && (i[s - 3] !== i[p] || i[s - 2] !== i[p + 1]) && (i[s] = i[p], i[s + 1] = i[p + 1], i[s + 2] = i[p + 2], s += 3);
            const T = (s - p) / 3;
            return T > 0 ? (i[g] = T, f && h.push(y, m)) : s = g, s;
        }
        function Pt(e1, t1, o, n, i, s, r, a, l) {
            let c;
            if (0 === a) {
                c = (r - o) / (i - o);
                const a = n + (s - n) * c;
                e1[t1] = r, e1[t1 + 1] = l ? Math.floor(a + .5) : a;
            } else {
                c = (r - n) / (s - n);
                const a = o + (i - o) * c;
                e1[t1] = l ? Math.floor(a + .5) : a, e1[t1 + 1] = r;
            }
            return e1[t1 + 2] = it, c;
        }
        function zt(e1, t1) {
            const o = [];
            for (const n of e1){
                if (4 === n.type) {
                    o.push(st(n.id, n.x + t1, n.y, n.tags));
                    continue;
                }
                const e1 = kt(n.geometry, n.type, t1), i = rt(n.id, n.type, e1, n.tags);
                void 0 !== n.start && (i.start = n.start, i.end = n.end, i.size = n.size), o.push(i);
            }
            return o;
        }
        function kt(e1, t1, o) {
            const n = e1.slice();
            if (1 === t1) for(let e1 = 0; e1 < n.length; e1 += 3)n[e1] += o;
            else for(let e1 = 0; e1 < n.length;){
                const t1 = e1 + 2 + 3 * n[e1];
                for(let i = e1 + 2; i < t1; i += 3)n[i] += o;
                e1 = t1;
            }
            return n;
        }
        function Bt(e1, t1, o, n, i) {
            const s = i.extent, r = i.worldScale, a = i.originShift, l = t1 === i.maxZoom ? 0 : i.tolerance * r / ((1 << t1) * s), c = 1 << t1, u = s + i.buffer <= 32767 ? Int16Array : Int32Array, h = {
                features: [],
                numPoints: 0,
                numSimplified: 0,
                numFeatures: e1.length,
                source: null,
                x: o,
                y: n,
                z: t1,
                minX: 1 / 0,
                minY: 1 / 0,
                maxX: -1 / 0,
                maxY: -1 / 0
            };
            for (const t1 of e1)_t(h, t1, l, i, c, o, n, s, u, r, a);
            return h;
        }
        function Ct(e1, t1, o, n, i, s) {
            return Math.round(n * ((e1 / i + s) * t1 - o));
        }
        function _t(e1, t1, o, n, i, s, r, a, l, c, u) {
            const h = t1.type;
            if (4 === h) {
                const o = t1.x, n = t1.y;
                o < e1.minX && (e1.minX = o), n < e1.minY && (e1.minY = n), o > e1.maxX && (e1.maxX = o), n > e1.maxY && (e1.maxY = n), e1.numPoints++, e1.numSimplified++;
                const l = {
                    x: Ct(o, i, s, a, c, u),
                    y: Ct(n, i, r, a, c, u),
                    type: 4,
                    tags: t1.tags || null
                };
                return void 0 !== t1.id && (l.id = t1.id), void e1.features.push(l);
            }
            const d = t1.geometry;
            let f;
            if (t1.minX < e1.minX && (e1.minX = t1.minX), t1.minY < e1.minY && (e1.minY = t1.minY), t1.maxX > e1.maxX && (e1.maxX = t1.maxX), t1.maxY > e1.maxY && (e1.maxY = t1.maxY), 1 === h) {
                const t1 = d.length / 3;
                f = new l(2 * t1);
                for(let e1 = 0, t1 = 0; e1 < d.length; e1 += 3, t1 += 2)f[t1] = Ct(d[e1], i, s, a, c, u), f[t1 + 1] = Ct(d[e1 + 1], i, r, a, c, u);
                if (e1.numPoints += t1, e1.numSimplified += t1, !f.length) return;
            } else {
                f = [];
                for(let t1 = 0; t1 < d.length;){
                    const n = t1 + 2, h = n + 3 * d[t1];
                    At(f, d, n, h, d[t1 + 1], e1, o, 0, i, s, r, a, l, c, u), t1 = h;
                }
                if (!f.length) return;
            }
            let g = t1.tags || null;
            if (2 === h && n.lineMetrics) {
                g = {};
                for(const e1 in t1.tags)g[e1] = t1.tags[e1];
                const e1 = t1.start, o = t1.end, n = t1.size, s = a * i / c;
                g.mapbox_clip_feature_len = n * s, g.mapbox_clip_seg_len = (o - e1) * s, g.mapbox_clip_start = n > 0 ? Math.max(0, e1 / n) : 0, g.mapbox_clip_end = o >= n ? 1 : o / n;
            }
            const p = {
                geometry: f,
                type: h,
                tags: g
            };
            void 0 !== t1.id && (p.id = t1.id), e1.features.push(p);
        }
        function At(e1, t1, o, n, i, s, r, a, l, c, u, h, d, f, g) {
            const p = (n - o) / 3;
            if (Math.abs(i) < r) return void (s.numPoints += p);
            let m = 0;
            if (0 === r) m = p;
            else for(let e1 = o; e1 < n; e1 += 3)t1[e1 + 2] > r && m++;
            s.numPoints += p, s.numSimplified += m;
            const y = new d(2 * m);
            let x = 0;
            for(let e1 = o; e1 < n; e1 += 3)(0 === r || t1[e1 + 2] > r) && (y[x++] = Ct(t1[e1], l, c, h, f, g), y[x++] = Ct(t1[e1 + 1], l, u, h, f, g));
            e1.push(y);
        }
        const Ft = {
            maxZoom: 14,
            indexMaxZoom: 5,
            indexMaxPoints: 1e5,
            tolerance: 3,
            extent: 4096,
            buffer: 64,
            lineMetrics: !1,
            promoteId: null,
            generateId: !1,
            debug: 0
        };
        class Dt {
            constructor(e1, t1){
                const o = this.options = Object.assign(Object.create(Ft), t1), n = o.debug;
                if (n && console.time("preprocess data"), o.maxZoom < 0 || o.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
                if (o.promoteId && o.generateId) throw new Error("promoteId and generateId cannot be used together.");
                const i = (o.extent + 2 * o.buffer) * (1 << o.maxZoom) < 4294967296;
                o.useInt32 = i, o.CoordArray = i ? Int32Array : Float64Array, o.worldScale = i ? o.extent * (1 << o.maxZoom) : 1, o.originShift = i ? .5 : 0;
                let s = function(e1, t1) {
                    const o = [];
                    if ("FeatureCollection" === e1.type) for(let n = 0; n < e1.features.length; n++)dt(o, e1.features[n], t1, n);
                    else dt(o, "Feature" === e1.type ? e1 : {
                        geometry: e1,
                        properties: null
                    }, t1);
                    return o;
                }(e1, o);
                if (this.tiles = {}, this.tileCoords = [], this.stats = {}, this.total = 0, n && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", o.indexMaxZoom, o.indexMaxPoints), console.time("generate tiles")), s = function(e1, t1) {
                    const o = t1.worldScale, n = t1.originShift, i = t1.buffer * o / t1.extent, s = -n * o, r = (1 - n) * o;
                    let a = e1;
                    const l = bt(e1, s - o - i, s + i, 0, s - o, r + o, t1), c = bt(e1, r - i, r + o + i, 0, s - o, r + o, t1);
                    return (l || c) && (a = bt(e1, s - i, r + i, 0, s - o, r + o, t1) || [], l && (a = zt(l, o).concat(a)), c && (a = a.concat(zt(c, -o)))), a;
                }(s, o), s.length && this.splitTile(s, 0, 0, 0), n) {
                    const e1 = this.tiles[0];
                    e1 && console.log(`features: ${e1.numFeatures}, points: ${e1.numPoints}`), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats));
                }
            }
            splitTile(e1, t1, o, n, i, s, r) {
                const a = [
                    e1
                ], l = [
                    t1,
                    o,
                    n
                ], c = this.options, u = c.debug;
                for(; a.length;){
                    n = l.pop(), o = l.pop(), t1 = l.pop(), e1 = a.pop();
                    const h = 1 << t1, d = Ot(t1, o, n);
                    let f = this.tiles[d];
                    if (f || (u > 1 && console.time("creation"), f = this.tiles[d] = Bt(e1, t1, o, n, c), this.tileCoords.push({
                        z: t1,
                        x: o,
                        y: n
                    }), this.stats[t1] = (this.stats[t1] || 0) + 1, this.total++, u > 1 && (console.log(`tile z${t1}-${o}-${n} (features: ${f.numFeatures}, points: ${f.numPoints}, simplified: ${f.numSimplified})`), console.timeEnd("creation"))), f.source = e1, null == i) {
                        if (t1 === c.indexMaxZoom || f.numPoints <= c.indexMaxPoints) continue;
                    } else {
                        if (t1 === c.maxZoom || t1 === i) continue;
                        {
                            const e1 = i - t1;
                            if (o !== s >> e1 || n !== r >> e1) continue;
                        }
                    }
                    if (f.source = null, 0 === e1.length) continue;
                    u > 1 && console.time("clipping");
                    const g = c.worldScale, p = c.originShift, m = g / h, y = .5 * c.buffer * g / (h * c.extent), x = (o / h - p) * g, w = (n / h - p) * g;
                    let v = null, b = null, S = null, I = null;
                    const M = bt(e1, x - y, x + m / 2 + y, 0, f.minX, f.maxX, c), T = bt(e1, x + m / 2 - y, x + m + y, 0, f.minX, f.maxX, c);
                    M && (v = bt(M, w - y, w + m / 2 + y, 1, f.minY, f.maxY, c), b = bt(M, w + m / 2 - y, w + m + y, 1, f.minY, f.maxY, c)), T && (S = bt(T, w - y, w + m / 2 + y, 1, f.minY, f.maxY, c), I = bt(T, w + m / 2 - y, w + m + y, 1, f.minY, f.maxY, c)), u > 1 && console.timeEnd("clipping"), a.push(v || [], b || [], S || [], I || []), l.push(t1 + 1, 2 * o, 2 * n, t1 + 1, 2 * o, 2 * n + 1, t1 + 1, 2 * o + 1, 2 * n, t1 + 1, 2 * o + 1, 2 * n + 1);
                }
            }
            getTile(e1, t1, o) {
                const n = this.findTile(e1, t1, o);
                return n ? function(e1) {
                    const t1 = [];
                    for (const o of e1.features){
                        let e1;
                        e1 = 4 === o.type ? {
                            type: 1,
                            geometry: [
                                [
                                    o.x,
                                    o.y
                                ]
                            ],
                            tags: o.tags ?? null
                        } : 1 === o.type ? {
                            type: 1,
                            geometry: Et(o.geometry),
                            tags: o.tags ?? null
                        } : {
                            type: o.type,
                            geometry: o.geometry.map(Et),
                            tags: o.tags ?? null
                        }, null != o.id && (e1.id = o.id), t1.push(e1);
                    }
                    return {
                        features: t1
                    };
                }(n) : null;
            }
            getTileRaw(e1, t1, o) {
                const n = this.findTile(e1, t1, o);
                return n ? {
                    features: n.features
                } : null;
            }
            findTile(e1, t1, o) {
                const n = this.options.debug;
                if ((e1 = +e1) < 0 || e1 > 24) return null;
                const i = 1 << e1, s = Ot(e1, t1 = (t1 = +t1) + i & i - 1, o = +o);
                if (this.tiles[s]) return this.tiles[s];
                n > 1 && console.log("drilling down to z%d-%d-%d", e1, t1, o);
                let r, a = e1, l = t1, c = o;
                for(; !r && a > 0;)a--, l >>= 1, c >>= 1, r = this.tiles[Ot(a, l, c)];
                return r && r.source ? (n > 1 && (console.log("found parent tile z%d-%d-%d", a, l, c), console.time("drilling down")), this.splitTile(r.source, a, l, c, e1, t1, o), n > 1 && console.timeEnd("drilling down"), this.tiles[s] ?? null) : null;
            }
        }
        function Et(e1) {
            const t1 = [];
            for(let o = 0; o < e1.length; o += 2)t1.push([
                e1[o],
                e1[o + 1]
            ]);
            return t1;
        }
        function Ot(e1, t1, o) {
            return 32 * ((1 << e1) * o + t1) + e1;
        }
        function Lt(t1, o) {
            const n = t1.tileID.canonical;
            if (!this._geoJSONIndex) return void o(null, null);
            const i = this._geoJSONIndex.getTileRaw(n.z, n.x, n.y);
            if (!i) return void o(null, null);
            const s = (e1)=>e1.tags && "3d_elevation_id" in e1.tags && "source" in e1.tags && "elevation" === e1.tags.source, r = i.features.filter(s);
            let a = {
                _geojsonTileLayer: i.features
            };
            r.length > 0 && (a = {
                _geojsonTileLayer: i.features.filter((e1)=>!s(e1)),
                hd_road_elevation: r
            });
            const l = new ke(a), c = function(t1) {
                const o = new e1.gu;
                for (const e1 of Object.keys(t1))o.writeMessage(3, Ve, {
                    name: e1,
                    features: t1[e1]
                });
                return o.finish();
            }(a).buffer;
            o(null, {
                vectorTile: l,
                rawData: c,
                headers: new Headers
            });
        }
        class jt extends Ie {
            constructor(e1){
                super(e1), this.loadVectorData = Lt, this._dynamicIndex = new Ce;
            }
            async loadData(o) {
                const n = o && o.request, i = n && n.collectResourceTiming;
                this._geoJSONIndex = null;
                let s = await new Promise((e1, t1)=>{
                    this.loadGeoJSON(o, (o, n)=>{
                        o ? t1(o) : e1(n);
                    });
                });
                if (!s) return {};
                if ("object" != typeof s) throw new Error(`Input data given to '${o.source}' is not a valid GeoJSON object.`);
                if (o.filter) {
                    const t1 = e1.c(o.filter, {
                        type: "boolean",
                        "property-type": "data-driven",
                        overridable: !1,
                        transition: !1
                    });
                    if ("error" === t1.result) throw new Error(t1.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
                    s.features = s.features.filter((e1)=>t1.value.evaluate({
                            zoom: 0
                        }, e1));
                }
                o.dynamic ? ("Feature" === s.type && (s = {
                    type: "FeatureCollection",
                    features: [
                        s
                    ]
                }), o.append || (this._dynamicIndex.clear(), this.loaded = {}), this._dynamicIndex.load(s.features, this.loaded), o.cluster && (s.features = this._dynamicIndex.getFeatures())) : this.loaded = {}, this._geoJSONIndex = o.cluster ? new Ke(function({ superclusterOptions: t1, clusterProperties: o }) {
                    if (!o || !t1) return t1;
                    const n = {}, i = {}, s = {
                        accumulated: null,
                        zoom: 0
                    }, r = {
                        properties: null
                    }, a = Object.keys(o);
                    for (const t1 of a){
                        const [s, r] = o[t1], a = e1.c(r), l = e1.c("string" == typeof s ? [
                            s,
                            [
                                "accumulated"
                            ],
                            [
                                "get",
                                t1
                            ]
                        ] : s);
                        n[t1] = a.value, i[t1] = l.value;
                    }
                    return t1.map = (e1)=>{
                        r.properties = e1;
                        const t1 = {};
                        for (const e1 of a)t1[e1] = n[e1].evaluate(s, r);
                        return t1;
                    }, t1.reduce = (e1, t1)=>{
                        r.properties = t1;
                        for (const t1 of a)s.accumulated = e1[t1], e1[t1] = i[t1].evaluate(s, r);
                    }, t1;
                }(o)).load(s.features) : o.dynamic ? this._dynamicIndex : new Dt(s, o.geojsonVtOptions);
                const r = {};
                if (i) {
                    const e1 = t1(n);
                    e1 && (r.resourceTiming = {}, r.resourceTiming[o.source] = JSON.parse(JSON.stringify(e1)));
                }
                return r;
            }
            async reloadTile(e1) {
                const t1 = this.loaded;
                if (t1 && t1[e1.uid]) {
                    if (e1.partial) return;
                    return super.reloadTile(e1);
                }
                return this.loadTile(e1);
            }
            loadGeoJSON(t1, o) {
                if (t1.request) e1.g(t1.request).then(({ data: e1 })=>o(null, e1)).catch((e1)=>o(e1));
                else {
                    if ("string" != typeof t1.data) return o(new Error(`Input data given to '${t1.source}' is not a valid GeoJSON object.`));
                    setTimeout(()=>{
                        try {
                            return o(null, JSON.parse(t1.data));
                        } catch (e1) {
                            return o(new Error(`Input data given to '${t1.source}' is not a valid GeoJSON object.`));
                        }
                    }, 0);
                }
            }
            getClusterExpansionZoom(e1) {
                return this._geoJSONIndex.getClusterExpansionZoom(e1.clusterId);
            }
            getClusterChildren(e1) {
                return this._geoJSONIndex.getChildren(e1.clusterId);
            }
            getClusterLeaves(e1) {
                return this._geoJSONIndex.getLeaves(e1.clusterId, e1.limit, e1.offset);
            }
        }
        e1.cK.setPbf(e1.d);
        class Rt {
            constructor(t1){
                this._mrt = new e1.cK(t1.partial ? 30 : 1 / 0), this._isHeaderLoaded = !1, this.uid = t1.uid, this.tileID = t1.tileID, this.source = t1.source;
            }
            async parse(t1) {
                const o = this._mrt;
                this.status = "parsing", this._entireBuffer = t1, o.parseHeader(t1), this._isHeaderLoaded = !0;
                const n = [];
                for(const i in o.layers){
                    const s = o.getLayer(i), r = s.getDataRange(s.getBandList()), a = o.createDecodingTask(r), l = t1.slice(r.firstByte, r.lastByte + 1);
                    n.push(e1.cK.performDecoding(l, a).then((e1)=>a.complete(null, e1)).catch((e1)=>a.complete(e1, null)));
                }
                return await Promise.allSettled(n), o;
            }
        }
        class Vt {
            constructor({ actor: e1 }){
                this.actor = e1, this.loading = {}, this.loaded = {};
            }
            async loadTile(t1) {
                const o = t1.uid, n = new AbortController, i = this.loading[o] = new Rt(t1);
                i.abort = ()=>n.abort();
                try {
                    const { data: s, headers: r } = await e1.n(t1.request, n.signal);
                    return s ? (this.loaded[o] = i, {
                        mrt: await i.parse(s),
                        headers: r
                    }) : (i.status = "done", this.loaded[o] = i, null);
                } catch (e1) {
                    if (n.signal.aborted) return null;
                    throw i.status = "done", this.loaded[o] = i, e1;
                } finally{
                    delete this.loading[o];
                }
            }
            async reloadTile(e1) {}
            abortTile(e1) {
                const t1 = e1.uid, o = this.loading[t1];
                o && (o.abort && o.abort(), delete this.loading[t1]);
            }
            removeTile(e1) {
                const t1 = e1.uid;
                this.loaded[t1] && delete this.loaded[t1];
            }
            async decodeRasterArray(t1) {
                return e1.cK.performDecoding(t1.buffer, t1.task);
            }
        }
        class Zt {
            constructor(t1){
                this.self = t1, this.actor = new e1.aH(t1, this), this.layerIndexes = {}, this.availableImages = {}, this.availableModels = {}, this.isSpriteLoaded = {}, this.localGlyphs = {}, this.projections = {}, this.defaultProjection = e1.gw({
                    name: "mercator"
                }), this.workerSourceTypes = {
                    vector: Ie,
                    geojson: jt,
                    "raster-dem": Me
                }, this.workerSources = {};
            }
            clearCaches(e1, t1) {
                delete this.layerIndexes[e1], delete this.availableImages[e1], delete this.availableModels[e1], delete this.workerSources[e1], delete this.isSpriteLoaded[e1], delete this.localGlyphs[e1];
            }
            checkIfReady(e1, t1) {}
            spriteLoaded(t1, o) {
                const { scope: n } = o;
                if (this.isSpriteLoaded[t1] || (this.isSpriteLoaded[t1] = {}), this.isSpriteLoaded[t1][n] = !0, this.workerSources[t1] && this.workerSources[t1][n]) for(const o in this.workerSources[t1][n]){
                    const i = this.workerSources[t1][n][o];
                    for(const t1 in i){
                        const o = i[t1];
                        o instanceof Ie && (o.isSpriteLoaded = !0, o.fire(new e1.i("isSpriteLoaded")));
                    }
                }
            }
            setImages(e1, t1) {
                this.availableImages[e1] || (this.availableImages[e1] = {});
                const { scope: o, images: n } = t1;
                if (this.availableImages[e1][o] = n, t1.isSpriteLoaded && this.spriteLoaded(e1, {
                    scope: o
                }), this.workerSources[e1] && this.workerSources[e1][o]) for(const t1 in this.workerSources[e1][o]){
                    const i = this.workerSources[e1][o][t1];
                    for(const e1 in i)i[e1].availableImages = n;
                }
            }
            setModels(e1, { scope: t1, models: o }) {
                if (this.availableModels[e1] || (this.availableModels[e1] = {}), this.availableModels[e1][t1] = o, this.workerSources[e1] && this.workerSources[e1][t1]) for(const n in this.workerSources[e1][t1]){
                    const i = this.workerSources[e1][t1][n];
                    for(const e1 in i)i[e1].availableModels = o;
                }
            }
            setProjection(t1, o) {
                this.projections[t1] = e1.gw(o);
            }
            setGlobalParams(t1, o) {
                this.referrer = o.referrer, Object.assign(e1.t, o.config), o.contextOptions && (this.maxUniformBlockSizeDwords = o.contextOptions.maxUniformBlockSizeDwords), o.localGlyphs && e1.o() && (this.localGlyphs[t1] = new e1.r(o.localGlyphs));
            }
            upsertRenderParams(e1, t1) {
                void 0 !== t1.brightness && (this.brightness = t1.brightness), void 0 !== t1.worldview && (this.worldview = t1.worldview);
            }
            setLayers(e1, t1) {
                this.getLayerIndex(e1, t1.scope).replace(t1.layers, t1.options);
            }
            updateLayers(e1, t1) {
                this.getLayerIndex(e1, t1.scope).update(t1.layers, t1.removedIds, t1.options);
            }
            async loadTile(t1, o) {
                if (o.projection = this.projections[t1] || this.defaultProjection, "batched-model" === o.type && !this.workerSourceTypes["batched-model"]) {
                    if (await e1.gx(), !y) throw new Error('Could not load Standard module for "batched-model" source.');
                    this.workerSourceTypes["batched-model"] = y;
                }
                return "raster-array" === o.type && await this.ensureRasterArrayWorkerSource(), this.getWorkerSource(t1, o).loadTile(o);
            }
            async ensureRasterArraySource(e1, t1) {
                await this.ensureRasterArrayWorkerSource();
            }
            async ensureRasterArrayWorkerSource() {
                if (!this.workerSourceTypes["raster-array"]) {
                    if (await async function() {
                        return Promise.resolve();
                    }(), !Vt) throw new Error('Could not load raster-array module for "raster-array" source.');
                    this.workerSourceTypes["raster-array"] = Vt;
                }
            }
            async decodeRasterArray(e1, t1) {
                return await this.ensureRasterArrayWorkerSource(), this.getWorkerSource(e1, t1).decodeRasterArray(t1);
            }
            reloadTile(e1, t1) {
                return t1.projection = this.projections[e1] || this.defaultProjection, this.getWorkerSource(e1, t1).reloadTile(t1);
            }
            abortTile(e1, t1) {
                const o = this.getExistingWorkerSource(e1, t1);
                return o ? o.abortTile(t1) : void 0;
            }
            removeTile(e1, t1) {
                const o = this.getExistingWorkerSource(e1, t1);
                return o ? o.removeTile(t1) : void 0;
            }
            getExistingWorkerSource(e1, t1) {
                const { type: o, source: n, scope: i } = t1, s = this.workerSources[e1];
                if (s && s[i] && s[i][o]) return s[i][o][n];
            }
            async removeSource(e1, t1) {
                const { type: o, source: n, scope: i } = t1, s = this.workerSources[e1] && this.workerSources[e1][i] && this.workerSources[e1][i][o], r = s && s[n];
                r && (delete s[n], r.removeSource && await r.removeSource({
                    source: n
                }));
            }
            async loadTileProvider(t1, o) {
                const n = new (await e1.cF(o.name, o.url))(o.options);
                return this.getWorkerSource(t1, {
                    type: o.type,
                    source: o.source,
                    scope: o.scope
                }, n), n.load && o.request ? n.load({
                    request: o.request
                }) : null;
            }
            getAvailableImages(e1, t1) {
                this.availableImages[e1] || (this.availableImages[e1] = {});
                let o = this.availableImages[e1][t1];
                return o || (o = []), o;
            }
            getAvailableModels(e1, t1) {
                this.availableModels[e1] || (this.availableModels[e1] = {});
                let o = this.availableModels[e1][t1];
                return o || (o = {}), o;
            }
            getLayerIndex(e1, t1) {
                this.layerIndexes[e1] || (this.layerIndexes[e1] = {});
                let o = this.layerIndexes[e1][t1];
                return o || (o = this.layerIndexes[e1][t1] = new b, o.scope = t1), o;
            }
            getWorkerSource(e1, t1, o) {
                const { type: n, source: i, scope: s } = t1, r = this.workerSources;
                if (r[e1] || (r[e1] = {}), r[e1][s] || (r[e1][s] = {}), r[e1][s][n] || (r[e1][s][n] = {}), this.isSpriteLoaded[e1] || (this.isSpriteLoaded[e1] = {}), this.getExistingWorkerSource(e1, t1)) o && (r[e1][s][n][i].tileProvider = o);
                else {
                    const t1 = this.actor.getWorkerSourceActor(e1), a = this.workerSourceTypes[n];
                    if (!a) throw new Error(`Unknown worker source type "${n}".`);
                    r[e1][s][n][i] = new a({
                        actor: t1,
                        layerIndex: this.getLayerIndex(e1, s),
                        availableImages: this.getAvailableImages(e1, s),
                        availableModels: this.getAvailableModels(e1, s),
                        isSpriteLoaded: this.isSpriteLoaded[e1][s],
                        tileProvider: o,
                        brightness: this.brightness,
                        worldview: this.worldview,
                        maxUniformBlockSizeDwords: this.maxUniformBlockSizeDwords,
                        localGlyphs: this.localGlyphs[e1]
                    });
                }
                return r[e1][s][n][i];
            }
            enforceCacheSizeLimit(t1, o) {
                e1.gy(o);
            }
        }
        return e1.gv(self) && (self.worker = new Zt(self)), Zt;
    });
    define([
        "./shared"
    ], function(e1) {
        const t1 = {
            antialias: !1,
            alpha: !0,
            stencil: !0,
            depth: !0
        };
        let i, s;
        function r(e1) {
            const i = document.createElement("canvas"), s = Object.create(t1);
            s.failIfMajorPerformanceCaveat = e1;
            const r = i.getContext("webgl2", s);
            if (!r) return !1;
            let o;
            try {
                o = r.createShader(r.VERTEX_SHADER);
            } catch (e1) {
                return !1;
            }
            return !(!o || r.isContextLost()) && (r.shaderSource(o, "void main() {}"), r.compileShader(o), !0 === r.getShaderParameter(o, r.COMPILE_STATUS));
        }
        const o = /firefox/i, n = /macintosh/i;
        function a(e1, t1, i) {
            const s = document.createElement(e1);
            return null != t1 && (s.className = t1), i && i.appendChild(s), s;
        }
        function l(e1, t1, i) {
            const s = document.createElementNS("http://www.w3.org/2000/svg", e1);
            for (const e1 of Object.keys(t1))s.setAttributeNS(null, e1, String(t1[e1]));
            return i && i.appendChild(s), s;
        }
        const c = "undefined" != typeof document ? document.documentElement && document.documentElement.style : null, h = c && void 0 !== c.userSelect ? "userSelect" : "WebkitUserSelect";
        let d;
        function u1() {
            c && h && (d = c[h], c[h] = "none");
        }
        function p() {
            c && h && (c[h] = d);
        }
        function f(e1) {
            e1.preventDefault(), e1.stopPropagation(), window.removeEventListener("click", f, !0);
        }
        function m() {
            window.addEventListener("click", f, !0), window.setTimeout(()=>{
                window.removeEventListener("click", f, !0);
            }, 0);
        }
        function _(e1, t1) {
            const i = e1.getBoundingClientRect();
            return v(e1, i, t1);
        }
        function g(e1, t1) {
            const i = e1.getBoundingClientRect(), s = [];
            for(let r = 0; r < t1.length; r++)s.push(v(e1, i, t1[r]));
            return s;
        }
        function y(e1) {
            return o.test(navigator.userAgent) && n.test(navigator.userAgent) && 2 === e1.button && e1.ctrlKey ? 0 : e1.button;
        }
        function v(t1, i, s) {
            const r = t1.offsetWidth === i.width ? 1 : t1.offsetWidth / i.width;
            return new e1.P((s.clientX - i.left) * r, (s.clientY - i.top) * r);
        }
        class b {
            constructor(){
                this._changed = !1, this._updatedLayers = Object.create(null), this._removedLayers = Object.create(null), this._updatedSourceCaches = Object.create(null), this._updatedPaintProps = new Set, this._updatedImages = Object.create(null);
            }
            isDirty() {
                return this._changed;
            }
            setDirty() {
                this._changed = !0;
            }
            getUpdatedSourceCaches() {
                return this._updatedSourceCaches;
            }
            updateSourceCache(e1, t1) {
                this._updatedSourceCaches[e1] = t1, this.setDirty();
            }
            discardSourceCacheUpdate(e1) {
                delete this._updatedSourceCaches[e1];
            }
            updateLayer(e1) {
                const t1 = e1.scope;
                this._updatedLayers[t1] = this._updatedLayers[t1] || new Set, this._updatedLayers[t1].add(e1.id), this.setDirty();
            }
            removeLayer(e1) {
                const t1 = e1.scope;
                this._removedLayers[t1] = this._removedLayers[t1] || {}, this._updatedLayers[t1] = this._updatedLayers[t1] || new Set, this._removedLayers[t1][e1.id] = e1, this._updatedLayers[t1].delete(e1.id), this._updatedPaintProps.delete(e1.fqid), this.setDirty();
            }
            getRemovedLayer(e1) {
                return this._removedLayers[e1.scope] ? this._removedLayers[e1.scope][e1.id] : null;
            }
            discardLayerRemoval(e1) {
                this._removedLayers[e1.scope] && delete this._removedLayers[e1.scope][e1.id];
            }
            getLayerUpdatesByScope() {
                const e1 = {};
                for(const t1 in this._updatedLayers)e1[t1] = e1[t1] || {}, e1[t1].updatedIds = Array.from(this._updatedLayers[t1].values());
                for(const t1 in this._removedLayers)e1[t1] = e1[t1] || {}, e1[t1].removedIds = Object.keys(this._removedLayers[t1]);
                return e1;
            }
            getUpdatedPaintProperties() {
                return this._updatedPaintProps;
            }
            updatePaintProperties(e1) {
                this._updatedPaintProps.add(e1.fqid), this.setDirty();
            }
            getUpdatedImages(e1) {
                return this._updatedImages[e1] ? Array.from(this._updatedImages[e1].values()) : [];
            }
            updateImage(t1, i) {
                this._updatedImages[i] = this._updatedImages[i] || new Set, this._updatedImages[i].add(e1.I.toString(t1)), this.setDirty();
            }
            resetUpdatedImages(e1) {
                this._updatedImages[e1] && this._updatedImages[e1].clear();
            }
            reset() {
                this._changed = !1, this._updatedLayers = Object.create(null), this._removedLayers = Object.create(null), this._updatedSourceCaches = Object.create(null), this._updatedPaintProps.clear(), this._updatedImages = Object.create(null);
            }
        }
        class x {
            constructor(e1){
                this._layer = e1, this._filterDependencies = void 0;
            }
            invalidateFilter() {
                this._filterDependencies = void 0;
            }
            get _filterDeps() {
                return void 0 === this._filterDependencies && (this._filterDependencies = this._computeFilterDependencies()), this._filterDependencies;
            }
            _computeFilterDependencies() {
                const t1 = this._layer;
                if (!t1.type || "custom" === t1.type || "background" === t1.type || "sky" === t1.type || "slot" === t1.type || "placement-group" === t1.type) return null;
                const i = e1.c(t1.filter, e1.s[`filter_${t1.type}`]);
                return "error" === i.result ? null : {
                    configDependencies: i.value.configDependencies,
                    isIndoorDependent: i.value.isIndoorDependent
                };
            }
            hasConfigDependency(e1) {
                const t1 = (t1)=>e1 ? t1.has(e1) : 0 !== t1.size, { _layoutValues: i, _paintValues: s } = this._layer;
                if (i && t1(i.configDependencies)) return !0;
                if (s && t1(s.configDependencies)) return !0;
                for (const { unevaluatedLayout: e1, unevaluatedPaint: i } of this._layer.appearances)if (e1 && (t1(e1.configDependencies) || t1(i.configDependencies))) return !0;
                const r = this._filterDeps;
                return !!r && t1(r.configDependencies);
            }
            get isIndoorDependent() {
                const { _layoutValues: e1, _paintValues: t1 } = this._layer;
                if (e1 && e1.isIndoorDependent()) return !0;
                if (t1 && t1.isIndoorDependent()) return !0;
                const i = this._filterDeps;
                return !!i && i.isIndoorDependent;
            }
        }
        function w(e1) {
            const { userImage: t1 } = e1;
            return !!(t1 && t1.render && t1.render()) && (e1.data.replace(new Uint8Array(t1.data.buffer)), !0);
        }
        const T = new e1.C(0, 0, 0);
        function S(e1, t1) {
            const i = [], s = e1[`stretch_${t1}`];
            let r = null;
            for(let e1 = 0; e1 < s.length; e1++)null === r ? r = 0 === i.length ? s[0] : i.at(-1)[1] + s[e1] : (i.push([
                r,
                r + s[e1]
            ]), r = null);
            e1[`stretch_${t1}_areas`] = i;
        }
        function C(e1, t1) {
            const i = {
                name: void 0
            };
            let s;
            for(; s = e1.nextField(t1);)if (1 === s) i.name = e1.readString();
            else if (2 === s) i.metadata = E(e1, e1.readVarint() + e1.pos);
            else if (3 === s) {
                const t1 = e1.readVarint() + e1.pos, s = e1.pos;
                i.usvg_tree = P(e1, t1, !0), i.data = "usvg_tree", i.pending_usvg_tree = {
                    buf: e1.buf,
                    start: s,
                    end: t1
                };
            }
            return function(e1) {
                if (e1.usvg_tree.height || (e1.usvg_tree.height = e1.usvg_tree.width), !e1.metadata) return e1;
                const { metadata: t1 } = e1;
                if (t1.content_area) {
                    const { content_area: i } = t1;
                    i.left ??= 0, i.top ??= i.left, i.width ??= e1.usvg_tree.width, i.height ??= i.width;
                }
                if (t1.text_placeholder) {
                    const { text_placeholder: e1 } = t1;
                    e1.top ??= e1.left, e1.height ??= e1.width;
                }
                return t1.stretch_x && t1.stretch_x.length && S(t1, "x"), t1.stretch_y && t1.stretch_y.length && S(t1, "y"), e1;
            }(i);
        }
        function E(e1, t1) {
            const i = {
                stretch_x: null,
                stretch_y: null,
                stretch_x_areas: null,
                stretch_y_areas: null,
                variables: []
            };
            let s;
            for(; s = e1.nextField(t1);)1 === s ? i.stretch_x = e1.readPackedVarint() : 2 === s ? i.stretch_y = e1.readPackedVarint() : 3 === s ? i.content_area = I(e1, e1.readVarint() + e1.pos) : 4 === s ? i.variables.push(D(e1, e1.readVarint() + e1.pos)) : 5 === s && (i.text_placeholder = I(e1, e1.readVarint() + e1.pos));
            return i;
        }
        function I(e1, t1) {
            const i = {};
            let s;
            for(; s = e1.nextField(t1);)1 === s ? i.left = e1.readVarint() : 2 === s ? i.width = e1.readVarint() : 3 === s ? i.top = e1.readVarint() : 4 === s && (i.height = e1.readVarint());
            return i;
        }
        function D(e1, t1) {
            const i = {
                name: void 0
            };
            let s;
            for(; s = e1.nextField(t1);)1 === s ? i.name = e1.readString() : 2 === s && (i.rgb_color = k(e1.readVarint()), i.value = "rgb_color");
            return i;
        }
        function P(e1, t1, i) {
            const s = {
                width: 20,
                children: [],
                linear_gradients: [],
                radial_gradients: [],
                clip_paths: [],
                masks: [],
                height: 20
            };
            let r;
            for(; r = e1.nextField(t1);)if (1 === r) s.width = s.height = e1.readVarint();
            else if (2 === r) s.height = e1.readVarint();
            else {
                if (i) continue;
                3 === r ? s.children.push(L(e1, e1.readVarint() + e1.pos)) : 4 === r ? s.linear_gradients.push(B(e1, e1.readVarint() + e1.pos)) : 5 === r ? s.radial_gradients.push(U(e1, e1.readVarint() + e1.pos)) : 7 === r ? s.clip_paths.push(N(e1, e1.readVarint() + e1.pos)) : 8 === r && s.masks.push(j(e1, e1.readVarint() + e1.pos));
            }
            return s;
        }
        function L(e1, t1) {
            const i = {};
            let s;
            for(; s = e1.nextField(t1);)1 === s ? (i.group = R(e1, e1.readVarint() + e1.pos), i.node = "group") : 2 === s && (i.path = M(e1, e1.readVarint() + e1.pos), i.node = "path");
            return i;
        }
        function R(e1, t1) {
            const i = {
                opacity: 255,
                children: []
            };
            let s;
            for(; s = e1.nextField(t1);)1 === s ? i.transform = A(e1, e1.readVarint() + e1.pos) : 2 === s ? i.opacity = e1.readVarint() : 5 === s ? i.clip_path_idx = e1.readVarint() : 6 === s ? i.mask_idx = e1.readVarint() : 7 === s && i.children.push(L(e1, e1.readVarint() + e1.pos));
            return i;
        }
        function A(e1, t1) {
            const i = {
                sx: 1,
                ky: 0,
                kx: 0,
                sy: 1,
                tx: 0,
                ty: 0
            };
            let s;
            for(; s = e1.nextField(t1);)1 === s ? i.sx = e1.readFloat() : 2 === s ? i.ky = e1.readFloat() : 3 === s ? i.kx = e1.readFloat() : 4 === s ? i.sy = e1.readFloat() : 5 === s ? i.tx = e1.readFloat() : 6 === s && (i.ty = e1.readFloat());
            return i;
        }
        function M(e1, t1) {
            const i = {
                paint_order: 1,
                commands: [],
                step: 1,
                diffs: [],
                rule: 1
            };
            let s;
            for(; s = e1.nextField(t1);)1 === s ? i.fill = F(e1, e1.readVarint() + e1.pos) : 2 === s ? i.stroke = O(e1, e1.readVarint() + e1.pos) : 3 === s ? i.paint_order = e1.readVarint() : 5 === s ? e1.readPackedVarint(i.commands) : 6 === s ? i.step = e1.readFloat() : 7 === s ? e1.readPackedSVarint(i.diffs) : 8 === s && (i.rule = e1.readVarint());
            return i;
        }
        function F(e1, t1) {
            const i = {
                rgb_color: T,
                paint: "rgb_color",
                opacity: 255
            };
            let s;
            for(; s = e1.nextField(t1);)1 === s ? (i.rgb_color = k(e1.readVarint()), i.paint = "rgb_color") : 2 === s ? (i.linear_gradient_idx = e1.readVarint(), i.paint = "linear_gradient_idx") : 3 === s ? (i.radial_gradient_idx = e1.readVarint(), i.paint = "radial_gradient_idx") : 5 === s && (i.opacity = e1.readVarint());
            return i;
        }
        function O(e1, t1) {
            const i = {
                rgb_color: T,
                paint: "rgb_color",
                dasharray: [],
                dashoffset: 0,
                miterlimit: 4,
                opacity: 255,
                width: 1,
                linecap: 1,
                linejoin: 1
            };
            let s;
            for(; s = e1.nextField(t1);)1 === s ? (i.rgb_color = k(e1.readVarint()), i.paint = "rgb_color") : 2 === s ? (i.linear_gradient_idx = e1.readVarint(), i.paint = "linear_gradient_idx") : 3 === s ? (i.radial_gradient_idx = e1.readVarint(), i.paint = "radial_gradient_idx") : 5 === s ? e1.readPackedFloat(i.dasharray) : 6 === s ? i.dashoffset = e1.readFloat() : 7 === s ? i.miterlimit = e1.readFloat() : 8 === s ? i.opacity = e1.readVarint() : 9 === s ? i.width = e1.readFloat() : 10 === s ? i.linecap = e1.readVarint() : 11 === s && (i.linejoin = e1.readVarint());
            return i;
        }
        function k(t1) {
            return new e1.C((t1 >> 16 & 255) / 255, (t1 >> 8 & 255) / 255, (255 & t1) / 255, 1);
        }
        function B(e1, t1) {
            const i = {
                spread_method: 1,
                stops: [],
                x1: 0,
                y1: 0,
                x2: 1,
                y2: 0
            };
            let s;
            for(; s = e1.nextField(t1);)1 === s ? i.transform = A(e1, e1.readVarint() + e1.pos) : 2 === s ? i.spread_method = e1.readVarint() : 3 === s ? i.stops.push(z(e1, e1.readVarint() + e1.pos)) : 4 === s ? i.x1 = e1.readFloat() : 5 === s ? i.y1 = e1.readFloat() : 6 === s ? i.x2 = e1.readFloat() : 7 === s && (i.y2 = e1.readFloat());
            return i;
        }
        function z(e1, t1) {
            const i = {
                offset: 0,
                opacity: 255,
                rgb_color: T
            };
            let s;
            for(; s = e1.nextField(t1);)1 === s ? i.offset = e1.readFloat() : 2 === s ? i.opacity = e1.readVarint() : 3 === s && (i.rgb_color = k(e1.readVarint()));
            return i;
        }
        function U(e1, t1) {
            const i = {
                spread_method: 1,
                stops: [],
                cx: .5,
                cy: .5,
                r: .5,
                fx: .5,
                fy: .5,
                fr: 0
            };
            let s;
            for(; s = e1.nextField(t1);)1 === s ? i.transform = A(e1, e1.readVarint() + e1.pos) : 2 === s ? i.spread_method = e1.readVarint() : 3 === s ? i.stops.push(z(e1, e1.readVarint() + e1.pos)) : 4 === s ? i.cx = e1.readFloat() : 5 === s ? i.cy = e1.readFloat() : 6 === s ? i.r = e1.readFloat() : 7 === s ? i.fx = e1.readFloat() : 8 === s ? i.fy = e1.readFloat() : 9 === s && (i.fr = e1.readFloat());
            return i;
        }
        function N(e1, t1) {
            const i = {
                children: []
            };
            let s;
            for(; s = e1.nextField(t1);)1 === s ? i.transform = A(e1, e1.readVarint() + e1.pos) : 2 === s ? i.clip_path_idx = e1.readVarint() : 3 === s && i.children.push(L(e1, e1.readVarint() + e1.pos));
            return i;
        }
        function j(e1, t1) {
            const i = {
                left: 0,
                width: 20,
                mask_type: 1,
                children: []
            };
            let s;
            for(; s = e1.nextField(t1);)1 === s ? i.left = i.top = e1.readFloat() : 2 === s ? i.width = i.height = e1.readFloat() : 3 === s ? i.top = e1.readFloat() : 4 === s ? i.height = e1.readFloat() : 5 === s ? i.mask_type = e1.readVarint() : 6 === s ? i.mask_idx = e1.readVarint() : 7 === s && i.children.push(L(e1, e1.readVarint() + e1.pos));
            return i.height ??= i.width, i.top ??= i.left, i;
        }
        class V {
            static calculate(t1 = {}, i = []) {
                const s = new Map, r = new Map;
                if (0 === Object.keys(t1).length) return s;
                i.forEach((t1)=>{
                    r.set(t1.name, t1.rgb_color || new e1.C(0, 0, 0));
                });
                for (const [e1, i] of Object.entries(t1))r.has(e1) ? s.set(r.get(e1).toString(), i) : console.warn(`Ignoring unknown image variable "${e1}"`);
                return s;
            }
        }
        function G(t1, i = 255, s) {
            const r = s.get(t1.toString()) || t1;
            return 255 === i ? r.toString() : new e1.C(r.r, r.g, r.b, r.a * i / 255).toString();
        }
        const q = [];
        let $ = 0;
        function Z(t1, i) {
            if ($ >= q.length) {
                const s = e1.o() ? new OffscreenCanvas(t1, i).getContext("2d", {
                    willReadFrequently: !0
                }) : document.createElement("canvas").getContext("2d", {
                    willReadFrequently: !0
                });
                q.push(s);
            }
            const s = q[$++];
            return s.canvas.width = t1, s.canvas.height = i, s;
        }
        function W() {
            $--;
        }
        function H(e1, t1, i, s, r) {
            for (const o of s.children)X(e1, t1, i, o, r);
        }
        function X(e1, t1, i, s, r) {
            s.group ? (e1.save(), function(e1, t1, i, s, r) {
                const o = null != s.mask_idx ? i.masks[s.mask_idx] : null, n = null != s.clip_path_idx ? i.clip_paths[s.clip_path_idx] : null;
                if (s.transform && (t1 = re(s.transform).preMultiplySelf(t1)), !function(e1, t1, i) {
                    return 255 !== e1.opacity || t1 || i;
                }(s, null != n, null != o)) return void H(e1, t1, i, s, r);
                const a = Z(e1.canvas.width, e1.canvas.height);
                H(a, t1, i, s, r), n && ie(a, t1, i, n), o && se(a, t1, i, o, r), e1.globalAlpha = s.opacity / 255, e1.drawImage(a.canvas, 0, 0), W();
            }(e1, t1, i, s.group, r), e1.restore()) : s.path && (e1.save(), function(e1, t1, i, s, r) {
                e1.setTransform(t1), 1 === s.paint_order ? (Y(e1, i, s, r), Q(e1, i, s, r)) : (Q(e1, i, s, r), Y(e1, i, s, r));
            }(e1, t1, i, s.path, r), e1.restore());
        }
        function Y(e1, t1, i, s) {
            const r = i.fill;
            if (!r) return;
            const o = r.opacity / 255;
            switch(e1.save(), e1.beginPath(), oe(i, e1), r.paint){
                case "rgb_color":
                    e1.fillStyle = G(r.rgb_color, r.opacity, s);
                    break;
                case "linear_gradient_idx":
                    {
                        const i = t1.linear_gradients[r.linear_gradient_idx];
                        i.transform && e1.setTransform(re(i.transform).preMultiplySelf(e1.getTransform())), e1.fillStyle = J(e1, i, o, s);
                        break;
                    }
                case "radial_gradient_idx":
                    {
                        const i = t1.radial_gradients[r.radial_gradient_idx];
                        i.transform && e1.setTransform(re(i.transform).preMultiplySelf(e1.getTransform())), e1.fillStyle = ee(e1, i, o, s);
                    }
            }
            e1.fill(K(i)), e1.restore();
        }
        function K(e1) {
            return 1 === e1.rule ? "nonzero" : 2 === e1.rule ? "evenodd" : void 0;
        }
        function Q(e1, t1, i, s) {
            const r = i.stroke;
            if (!r) return;
            const o = ne(i);
            e1.lineWidth = r.width, e1.miterLimit = r.miterlimit, e1.setLineDash(r.dasharray), e1.lineDashOffset = r.dashoffset;
            const n = r.opacity / 255;
            switch(r.paint){
                case "rgb_color":
                    e1.strokeStyle = G(r.rgb_color, r.opacity, s);
                    break;
                case "linear_gradient_idx":
                    e1.strokeStyle = J(e1, t1.linear_gradients[r.linear_gradient_idx], n, s, !0);
                    break;
                case "radial_gradient_idx":
                    e1.strokeStyle = ee(e1, t1.radial_gradients[r.radial_gradient_idx], n, s, !0);
            }
            switch(r.linejoin){
                case 2:
                case 1:
                    e1.lineJoin = "miter";
                    break;
                case 3:
                    e1.lineJoin = "round";
                    break;
                case 4:
                    e1.lineJoin = "bevel";
            }
            switch(r.linecap){
                case 1:
                    e1.lineCap = "butt";
                    break;
                case 2:
                    e1.lineCap = "round";
                    break;
                case 3:
                    e1.lineCap = "square";
            }
            e1.stroke(o);
        }
        function J(e1, t1, i, s, r = !1) {
            if (1 === t1.stops.length) {
                const e1 = t1.stops[0];
                return G(e1.rgb_color, e1.opacity * i, s);
            }
            const { x1: o, y1: n, x2: a, y2: l } = t1;
            let c = new DOMPoint(o, n), h = new DOMPoint(a, l);
            if (r) {
                const e1 = re(t1.transform);
                c = e1.transformPoint(c), h = e1.transformPoint(h);
            }
            const d = e1.createLinearGradient(c.x, c.y, h.x, h.y);
            for (const e1 of t1.stops)d.addColorStop(e1.offset, G(e1.rgb_color, e1.opacity * i, s));
            return d;
        }
        function ee(e1, t1, i, s, r = !1) {
            if (1 === t1.stops.length) {
                const e1 = t1.stops[0];
                return G(e1.rgb_color, e1.opacity * i, s);
            }
            const o = re(t1.transform), { fx: n, fy: a, fr: l, cx: c, cy: h, r: d } = t1;
            let u = new DOMPoint(n, a), p = new DOMPoint(c, h), f = l, m = d;
            if (r) {
                u = o.transformPoint(u), p = o.transformPoint(p);
                const e1 = (o.a + o.d) / 2;
                f = l * e1, m = t1.r * e1;
            }
            const _ = e1.createRadialGradient(u.x, u.y, f, p.x, p.y, m);
            for (const e1 of t1.stops)_.addColorStop(e1.offset, G(e1.rgb_color, e1.opacity * i, s));
            return _;
        }
        function te(e1, t1, i, s) {
            const r = s.transform ? re(s.transform).preMultiplySelf(t1) : t1, o = Z(e1.canvas.width, e1.canvas.height);
            for (const e1 of s.children)if (e1.group) te(o, r, i, e1.group);
            else if (e1.path) {
                const t1 = e1.path, i = new Path2D;
                i.addPath(ne(t1), r), o.fill(i, K(t1));
            }
            const n = null != s.clip_path_idx ? i.clip_paths[s.clip_path_idx] : null;
            n && ie(o, r, i, n), e1.globalCompositeOperation = "source-over", e1.drawImage(o.canvas, 0, 0), W();
        }
        function ie(e1, t1, i, s) {
            const r = Z(e1.canvas.width, e1.canvas.height);
            te(r, t1, i, s), e1.globalCompositeOperation = "destination-in", e1.drawImage(r.canvas, 0, 0), W();
        }
        function se(e1, t1, i, s, r) {
            if (0 === s.children.length) return;
            const o = null != s.mask_idx ? i.masks[s.mask_idx] : null;
            o && se(e1, t1, i, o, r);
            const n = e1.canvas.width, a = e1.canvas.height, l = Z(n, a), c = s.width, h = s.height, d = s.left, u = s.top, p = new Path2D, f = new Path2D;
            f.rect(d, u, c, h), p.addPath(f, t1), l.clip(p);
            for (const e1 of s.children)X(l, t1, i, e1, r);
            const m = l.getImageData(0, 0, n, a), _ = m.data;
            if (1 === s.mask_type) for(let e1 = 0; e1 < _.length; e1 += 4)_[e1 + 3] = _[e1 + 3] / 255 * (.2126 * _[e1] + .7152 * _[e1 + 1] + .0722 * _[e1 + 2]);
            l.putImageData(m, 0, 0), e1.globalCompositeOperation = "destination-in", e1.drawImage(l.canvas, 0, 0), W();
        }
        function re(e1) {
            return e1 ? new DOMMatrix([
                e1.sx,
                e1.ky,
                e1.kx,
                e1.sy,
                e1.tx,
                e1.ty
            ]) : new DOMMatrix;
        }
        function oe(e1, t1) {
            const i = e1.step;
            let s = e1.diffs[0] * i, r = e1.diffs[1] * i;
            t1.moveTo(s, r);
            for(let o = 0, n = 2; o < e1.commands.length; o++)switch(e1.commands[o]){
                case 1:
                    s += e1.diffs[n++] * i, r += e1.diffs[n++] * i, t1.moveTo(s, r);
                    break;
                case 2:
                    s += e1.diffs[n++] * i, r += e1.diffs[n++] * i, t1.lineTo(s, r);
                    break;
                case 3:
                    {
                        const o = s + e1.diffs[n++] * i, a = r + e1.diffs[n++] * i;
                        s = o + e1.diffs[n++] * i, r = a + e1.diffs[n++] * i, t1.quadraticCurveTo(o, a, s, r);
                        break;
                    }
                case 4:
                    {
                        const o = s + e1.diffs[n++] * i, a = r + e1.diffs[n++] * i, l = o + e1.diffs[n++] * i, c = a + e1.diffs[n++] * i;
                        s = l + e1.diffs[n++] * i, r = c + e1.diffs[n++] * i, t1.bezierCurveTo(o, a, l, c, s, r);
                        break;
                    }
                case 5:
                    t1.closePath();
            }
            return t1;
        }
        function ne(e1) {
            return oe(e1, new Path2D);
        }
        class ae {
            constructor(){
                this.cacheMap = new Map, this.cacheDependenciesMap = new Map;
            }
            static _getImage(t1) {
                return new e1.b(t1, t1.data);
            }
            getFromCache(t1, i, s) {
                return this.cacheMap.has(s) || this.cacheMap.set(s, new e1.L(150)), this.cacheMap.get(s).get(e1.m(t1.toString(), i));
            }
            setInCache(t1, i, s, r) {
                this.cacheDependenciesMap.has(r) || this.cacheDependenciesMap.set(r, new Map), this.cacheMap.has(r) || this.cacheMap.set(r, new e1.L(150));
                const o = this.cacheDependenciesMap.get(r), n = e1.m(t1.id.toString(), s);
                o.get(n) || o.set(n, new Set);
                const a = this.cacheMap.get(r), l = t1.toString();
                o.get(n).add(l), a.put(e1.m(t1.toString(), s), i);
            }
            removeImagesFromCacheByIds(t1, i, s = 0) {
                if (!this.cacheMap.has(s) || !this.cacheDependenciesMap.has(s)) return;
                const r = this.cacheMap.get(s), o = this.cacheDependenciesMap.get(s);
                for (const s of t1){
                    const t1 = e1.m(s.toString(), i);
                    if (o.has(t1)) {
                        for (const e1 of o.get(t1))r.delete(e1);
                        o.delete(t1);
                    }
                }
            }
            rasterize(t1, i, s, r) {
                const o = this.getFromCache(t1, s, r);
                if (o) return o.clone();
                !function(t1) {
                    const i = t1.pending_usvg_tree;
                    if (!i) return;
                    delete t1.pending_usvg_tree;
                    const s = new e1.d(i.buf);
                    s.pos = i.start, t1.usvg_tree = P(s, i.end);
                }(i.icon);
                const n = function(e1, t1) {
                    const i = V.calculate(t1.params, e1.metadata ? e1.metadata.variables : []), s = e1.usvg_tree, r = s.width, o = s.height, n = Math.max(1, Math.round(r * t1.sx)), a = Math.max(1, Math.round(o * t1.sy)), l = new DOMMatrix([
                        n / r,
                        0,
                        0,
                        a / o,
                        0,
                        0
                    ]), c = Z(n, a);
                    H(c, l, s, s, i);
                    const h = c.getImageData(0, 0, n, a);
                    return W(), h;
                }(i.icon, t1), a = ae._getImage(n);
                return this.setInCache(t1, a, s, r), a.clone();
            }
        }
        class le extends e1.E {
            constructor(t1){
                super(), this.imageProviders = new Map, this.images = new Map, this.updatedImages = new Map, this.callbackDispatchedThisFrame = new Map, this.imageVersions = new Map, this.loaded = new Map, this.requestors = [], this.patterns = new Map, this.patternsInFlight = new Set, this.atlasImage = new Map, this.atlasTexture = new Map, this.imageAtlasCache = new e1.f, this.dirty = !0, this.spriteFormat = t1, this.imageRasterizer = new ae;
            }
            addScope(t1) {
                this.loaded.set(t1, !1), this.imageProviders.set(t1, new Map), this.images.set(t1, new Map), this.updatedImages.set(t1, new Set), this.callbackDispatchedThisFrame.set(t1, new Set), this.imageVersions.set(t1, new Map), this.patterns.set(t1, new Map), this.atlasImage.set(t1, new e1.b({
                    width: 1,
                    height: 1
                }));
            }
            removeScope(e1) {
                this.loaded.delete(e1), this.imageProviders.delete(e1), this.images.delete(e1), this.updatedImages.delete(e1), this.callbackDispatchedThisFrame.delete(e1), this.imageVersions.delete(e1), this.patterns.delete(e1), this.atlasImage.delete(e1);
                const t1 = this.atlasTexture.get(e1);
                t1 && (t1.destroy(), this.atlasTexture.delete(e1));
            }
            addImageProvider(e1, t1) {
                this.imageProviders.has(t1) || this.imageProviders.set(t1, new Map), this.imageProviders.get(t1).set(e1.id, e1);
            }
            removeImageProvider(e1, t1) {
                this.imageProviders.has(t1) && this.imageProviders.get(t1).delete(e1);
            }
            getPendingImageProviders() {
                const e1 = [];
                for (const t1 of this.imageProviders.values())for (const i of t1.values())i.hasPendingRequests() && e1.push(i);
                return e1;
            }
            isLoaded() {
                for (const e1 of this.loaded.keys())if (!this.loaded.get(e1)) return !1;
                return !0;
            }
            setLoaded(e1, t1) {
                if (this.loaded.get(t1) !== e1 && (this.loaded.set(t1, e1), e1)) {
                    for (const { ids: e1, callback: i } of this.requestors)this._notify(e1, t1, i);
                    this.requestors = [];
                }
            }
            hasImage(e1, t1) {
                return !!this.getImage(e1, t1);
            }
            getImage(e1, t1) {
                return this.images.get(t1).get(e1.toString());
            }
            addImage(e1, t1, i) {
                if (this._validate(e1, i)) {
                    this.images.get(t1).set(e1.toString(), i);
                    const s = this.imageVersions.get(t1), r = s.get(e1.toString()) || 0;
                    s.set(e1.toString(), r + 1);
                }
            }
            _validate(t1, i) {
                let s = !0;
                return this._validateStretch(i.stretchX, i.data && i.data.width) || (this.fire(new e1.h(new Error(`Image "${t1.name}" has invalid "stretchX" value`))), s = !1), this._validateStretch(i.stretchY, i.data && i.data.height) || (this.fire(new e1.h(new Error(`Image "${t1.name}" has invalid "stretchY" value`))), s = !1), this._validateContent(i.content, i) || (this.fire(new e1.h(new Error(`Image "${t1.name}" has invalid "content" value`))), s = !1), s;
            }
            _validateStretch(e1, t1) {
                if (!e1) return !0;
                let i = 0;
                for (const s of e1){
                    if (s[0] < i || s[1] < s[0] || t1 < s[1]) return !1;
                    i = s[1];
                }
                return !0;
            }
            _validateContent(e1, t1) {
                if (!e1) return !0;
                if (4 !== e1.length) return !1;
                if (!t1.usvg) {
                    if (e1[0] < 0 || t1.data.width < e1[0]) return !1;
                    if (e1[1] < 0 || t1.data.height < e1[1]) return !1;
                    if (e1[2] < 0 || t1.data.width < e1[2]) return !1;
                    if (e1[3] < 0 || t1.data.height < e1[3]) return !1;
                }
                return !(e1[2] < e1[0] || e1[3] < e1[1]);
            }
            updateImage(e1, t1, i) {
                const s = this.images.get(t1).get(e1.toString());
                i.version = s.version + 1, this.images.get(t1).set(e1.toString(), i), this.updatedImages.get(t1).add(e1);
                const r = this.imageVersions.get(t1), o = r.get(e1.toString()) || 0;
                r.set(e1.toString(), o + 1), this.removeFromImageRasterizerCache(e1, t1);
            }
            clearUpdatedImages(e1) {
                this.updatedImages.get(e1).clear();
            }
            removeFromImageRasterizerCache(e1, t1) {
                "raster" !== this.spriteFormat && this.imageRasterizer.removeImagesFromCacheByIds([
                    e1
                ], t1);
            }
            removeImage(e1, t1) {
                const i = this.images.get(t1), s = i.get(e1.toString());
                i.delete(e1.toString());
                const r = this.imageVersions.get(t1), o = r.get(e1.toString()) || 0;
                r.set(e1.toString(), o + 1), this.patterns.get(t1).delete(e1.toString()), this.removeFromImageRasterizerCache(e1, t1), s.userImage && s.userImage.onRemove && s.userImage.onRemove();
            }
            listImages(t1) {
                return Array.from(this.images.get(t1).keys()).map((t1)=>e1.I.from(t1));
            }
            hasImageProviderForSource(e1, t1) {
                const i = this.imageProviders.get(t1);
                if (!i) return !1;
                for (const t1 of i.values())if (t1.sourceCache.getSource().id === e1) return !0;
                return !1;
            }
            getImages(e1, t1, i) {
                const s = [], r = [], o = this.imageProviders.get(t1);
                for (const i of e1){
                    if (!i.iconsetId) {
                        s.push(i);
                        continue;
                    }
                    const e1 = o.get(i.iconsetId);
                    e1 && (this.getImage(i, t1) ? r.push(i) : e1.addPendingRequest(i));
                }
                if (0 === s.length) return void this._notify(r, t1, i);
                let n = !0;
                const a = !!this.loaded.get(t1), l = this.images.get(t1);
                if (!a) for (const e1 of s)l.has(e1.toString()) || (n = !1);
                a || n ? this._notify(s, t1, i) : this.requestors.push({
                    ids: s,
                    scope: t1,
                    callback: i
                });
            }
            rasterizeImages(e1, t1) {
                const i = new Map, { iconTasks: s, patternTasks: r, scope: o } = e1;
                for (const e1 of [
                    s,
                    r
                ])for (const [t1, s] of e1.entries()){
                    const e1 = this.getImage(s.id, o);
                    e1 && i.set(t1, {
                        image: e1,
                        imageVariant: s
                    });
                }
                t1(null, this._rasterizeImages(o, i));
            }
            _rasterizeImages(e1, t1) {
                const i = new Map;
                for (const [s, { image: r, imageVariant: o }] of t1.entries())i.set(s, this.imageRasterizer.rasterize(o, r, e1, 0));
                return i;
            }
            getUpdatedImages(e1) {
                return this.updatedImages.get(e1) || new Set;
            }
            _notify(t1, i, s) {
                const r = this.images.get(i), o = new Map, n = this.imageVersions.get(i), a = new Map;
                for (const i of t1){
                    if (!r.get(i.toString())) {
                        if (i.iconsetId) continue;
                        this.fire(new e1.i("styleimagemissing", {
                            id: i.name
                        }));
                    }
                    const t1 = r.get(i.toString());
                    if (!t1) {
                        e1.w(`Image "${i.name}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
                        continue;
                    }
                    const s = {
                        data: t1.usvg ? null : t1.data.clone(),
                        pixelRatio: t1.pixelRatio,
                        sdf: t1.sdf,
                        usvg: t1.usvg,
                        stretchX: t1.stretchX,
                        stretchY: t1.stretchY,
                        content: t1.content,
                        hasRenderCallback: Boolean(t1.userImage && t1.userImage.render)
                    };
                    t1.usvg && Object.assign(s, {
                        width: t1.icon.usvg_tree.width,
                        height: t1.icon.usvg_tree.height
                    });
                    const l = e1.I.toString(i);
                    o.set(l, s);
                    const c = n && n.get(l);
                    c && a.set(l, c);
                }
                s(null, {
                    images: o,
                    versions: a
                });
            }
            getPixelSize(e1) {
                const { width: t1, height: i } = this.atlasImage.get(e1);
                return {
                    width: t1,
                    height: i
                };
            }
            getPattern(t1, i, s) {
                const r = t1.toString(), o = this.patterns.get(i), n = o.get(r), a = this.getImage(t1, i);
                if (!a) return null;
                if (n) {
                    if (n.position.version === a.version) return n.position;
                    n.position.version = a.version;
                } else {
                    if (a.usvg && !a.data) {
                        const o = this.getPatternInFlightId(r, i);
                        if (this.patternsInFlight.has(o)) return null;
                        this.patternsInFlight.add(o);
                        const n = new e1.j(t1).scaleSelf(e1.e.devicePixelRatio), l = new Map([
                            [
                                n.toString(),
                                {
                                    image: a,
                                    imageVariant: n
                                }
                            ]
                        ]), c = this._rasterizeImages(i, l);
                        return this.storePatternImage(n, i, a, s, c), null;
                    }
                    this.storePattern(t1, i, a);
                }
                return this._updatePatternAtlas(i, s), o.get(r).position;
            }
            getPatternInFlightId(t1, i) {
                return e1.m(t1, i);
            }
            hasPatternsInFlight() {
                return 0 !== this.patternsInFlight.size;
            }
            storePatternImage(e1, t1, i, s, r) {
                const o = e1.toString(), n = r ? r.get(o) : void 0;
                n && (i.data = n, this.storePattern(e1.id, t1, i), this._updatePatternAtlas(t1, s), this.patternsInFlight.delete(this.getPatternInFlightId(e1.id.toString(), t1)));
            }
            storePattern(t1, i, s) {
                const r = {
                    w: s.data.width + 2 * e1.k,
                    h: s.data.height + 2 * e1.k,
                    x: 0,
                    y: 0
                }, o = new e1.l(r, s, e1.k);
                this.patterns.get(i).set(t1.toString(), {
                    bin: r,
                    position: o
                });
            }
            destroyAtlasTextures() {
                for (const e1 of this.atlasTexture.values())e1 && e1.destroy();
                this.atlasTexture.clear();
            }
            bind(t1, i) {
                const s = t1.gl;
                let r = this.atlasTexture.get(i);
                r ? this.dirty && (r.update(this.atlasImage.get(i)), this.dirty = !1) : (r = new e1.T(t1, this.atlasImage.get(i), s.RGBA8), this.atlasTexture.set(i, r)), r.bind(s.LINEAR, s.CLAMP_TO_EDGE);
            }
            _updatePatternAtlas(t1, i) {
                const s = this.patterns.get(t1), r = Array.from(s.values()).map(({ bin: e1 })=>e1), { w: o, h: n } = e1.p(r), a = this.atlasImage.get(t1);
                a.resize({
                    width: o || 1,
                    height: n || 1
                });
                const l = this.images.get(t1);
                for (const [t1, { bin: r, position: o }] of s.entries()){
                    let s = o.padding;
                    const n = r.x + s, c = r.y + s, h = l.get(t1).data, d = h.width, u = h.height;
                    s = s > 1 ? s - 1 : s, e1.b.copy(h, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: n,
                        y: c
                    }, {
                        width: d,
                        height: u
                    }, i), e1.b.copy(h, a, {
                        x: 0,
                        y: u - s
                    }, {
                        x: n,
                        y: c - s
                    }, {
                        width: d,
                        height: s
                    }, i), e1.b.copy(h, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: n,
                        y: c + u
                    }, {
                        width: d,
                        height: s
                    }, i), e1.b.copy(h, a, {
                        x: d - s,
                        y: 0
                    }, {
                        x: n - s,
                        y: c
                    }, {
                        width: s,
                        height: u
                    }, i), e1.b.copy(h, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: n + d,
                        y: c
                    }, {
                        width: s,
                        height: u
                    }, i), e1.b.copy(h, a, {
                        x: d - s,
                        y: u - s
                    }, {
                        x: n - s,
                        y: c - s
                    }, {
                        width: s,
                        height: s
                    }, i), e1.b.copy(h, a, {
                        x: 0,
                        y: u - s
                    }, {
                        x: n + d,
                        y: c - s
                    }, {
                        width: s,
                        height: s
                    }, i), e1.b.copy(h, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: n + d,
                        y: c + u
                    }, {
                        width: s,
                        height: s
                    }, i), e1.b.copy(h, a, {
                        x: d - s,
                        y: 0
                    }, {
                        x: n - s,
                        y: c + u
                    }, {
                        width: s,
                        height: s
                    }, i);
                }
                this.dirty = !0;
            }
            beginFrame() {
                for (const e1 of this.images.keys())this.callbackDispatchedThisFrame.set(e1, new Set);
                this.imageAtlasCache.beginFrame();
            }
            dispatchRenderCallbacks(e1, t1) {
                const i = this.images.get(t1);
                for (const s of e1){
                    if (this.callbackDispatchedThisFrame.get(t1).has(s.toString())) continue;
                    this.callbackDispatchedThisFrame.get(t1).add(s.toString());
                    const e1 = i.get(s.toString());
                    w(e1) && this.updateImage(s, t1, e1);
                }
            }
        }
        class ce {
            constructor(e1){
                this.pendingRequests = new Map, this.cachedRanges = new Map, this.fontstackCompositing = e1 && e1.fontstackCompositing || "client";
            }
            loadGlyphRange(e1, t1, i, s, r) {
                if ("server" === this.fontstackCompositing) return void ce.loadGlyphRange(e1, t1, i, s, r);
                const o = e1.split(",").map((e1)=>e1.trim()).filter((e1)=>e1.length > 0);
                0 !== o.length ? 1 !== o.length ? this._loadMultipleFonts(o, t1, i, s, r) : this._loadFont(o[0], t1, i, s, r) : r(new Error("Empty fontstack"));
            }
            _loadMultipleFonts(e1, t1, i, s, r) {
                const o = e1.map(()=>null), n = {
                    completed: 0,
                    firstError: null,
                    callbackCalled: !1
                }, a = (t1, i, s)=>{
                    if (!n.callbackCalled && (i && !n.firstError && (n.firstError = i), s && (o[t1] = s), n.completed++, n.completed === e1.length)) {
                        n.callbackCalled = !0;
                        const e1 = o.filter((e1)=>null !== e1);
                        if (0 === e1.length) return void r(n.firstError || new Error("All fonts failed to load"));
                        const t1 = this._composeGlyphs(e1);
                        r(null, t1);
                    }
                };
                for(let r = 0; r < e1.length; r++)this._loadFont(e1[r], t1, i, s, (e1, t1)=>{
                    a(r, e1, t1);
                });
            }
            _loadFont(t1, i, s, r, o) {
                const n = `${t1}:${i}`;
                if (this.cachedRanges.has(n)) {
                    const t1 = this.cachedRanges.get(n);
                    return void e1.e.frame(()=>o(null, t1));
                }
                const a = this.pendingRequests.get(n);
                a ? a.push(o) : (this.pendingRequests.set(n, [
                    o
                ]), ce.loadGlyphRange(t1, i, s, r, (e1, t1)=>{
                    e1 || this.cachedRanges.set(n, t1 || null);
                    const i = this.pendingRequests.get(n);
                    if (this.pendingRequests.delete(n), i) for (const s of i)s(e1, t1);
                }));
            }
            _composeGlyphs(e1) {
                const t1 = {};
                let i, s;
                for (const r of e1)if (void 0 === i && void 0 !== r.ascender && (i = r.ascender), void 0 === s && void 0 !== r.descender && (s = r.descender), r.glyphs) for(const e1 in r.glyphs)void 0 === t1[e1] && (t1[e1] = r.glyphs[e1]);
                return {
                    glyphs: t1,
                    ascender: i,
                    descender: s
                };
            }
        }
        ce.loadGlyphRange = async function(t1, i, s, r, o) {
            const n = 256 * i, a = n + 255;
            let l;
            try {
                const i = await r.transformRequest(r.normalizeGlyphsURL(s).replace("{fontstack}", t1).replace("{range}", `${n}-${a}`), e1.R.Glyphs), { data: o } = await e1.n(i), c = {}, h = e1.q(o);
                for (const e1 of h.glyphs)c[e1.id] = e1;
                l = {
                    glyphs: c,
                    ascender: h.ascender,
                    descender: h.descender
                };
            } catch (e1) {
                return o(e1);
            }
            o(null, l);
        };
        class he {
            constructor(t1, i, s, r){
                this.requestManager = t1, this.localGlyphs = new e1.r({
                    mode: i,
                    fontFamily: s
                }), this.url = "", this.entries = {}, this.glyphLoader = new ce({
                    fontstackCompositing: r
                });
            }
            setURL(e1) {
                this.url = e1;
            }
            getGlyphs(t1, i) {
                const s = [], r = Object.keys(t1), o = this.url || e1.t.GLYPHS_URL;
                for(const e1 in t1)for (const i of t1[e1])s.push({
                    stack: e1,
                    id: i
                });
                e1.u(s, ({ stack: t1, id: i }, s)=>{
                    let r = this.entries[t1];
                    r || (r = this.entries[t1] = {
                        glyphs: {},
                        requests: {},
                        ranges: {},
                        ascender: void 0,
                        descender: void 0
                    });
                    let n = r.glyphs[i];
                    if (void 0 !== n) return void s(null, {
                        stack: t1,
                        id: i,
                        glyph: n
                    });
                    if (n = this.localGlyphs.draw(t1, i), n) return r.glyphs[i] = n, void s(null, {
                        stack: t1,
                        id: i,
                        glyph: n
                    });
                    const a = Math.floor(i / 256);
                    if (256 * a > 65535) return e1.w("glyphs > 65535 not supported"), void s(null, {
                        stack: t1,
                        id: i,
                        glyph: n
                    });
                    if (r.ranges[a]) return void s(null, {
                        stack: t1,
                        id: i,
                        glyph: n
                    });
                    let l = r.requests[a];
                    l || (l = r.requests[a] = [], this.glyphLoader.loadGlyphRange(t1, a, o, this.requestManager, (e1, t1)=>{
                        if (t1) {
                            r.ascender = t1.ascender, r.descender = t1.descender;
                            for(const e1 in t1.glyphs)this.localGlyphs.supports(+e1) || (r.glyphs[+e1] = t1.glyphs[+e1]);
                            r.ranges[a] = !0;
                        }
                        for (const i of l)i(e1, t1);
                        delete r.requests[a];
                    })), l.push((e1, r)=>{
                        e1 ? s(e1) : r && s(null, {
                            stack: t1,
                            id: i,
                            glyph: r.glyphs[i] || null
                        });
                    });
                }, (e1, t1)=>{
                    if (e1) i(e1);
                    else if (t1) {
                        const e1 = {};
                        for (const t1 of r){
                            const i = this.entries[t1];
                            e1[t1] = {
                                glyphs: {},
                                ascender: i && i.ascender,
                                descender: i && i.descender
                            };
                        }
                        for (const { stack: i, id: s, glyph: r } of t1)e1[i].glyphs[s] = r && {
                            id: r.id,
                            bitmap: r.bitmap.clone(),
                            metrics: r.metrics
                        };
                        i(null, e1);
                    }
                });
            }
        }
        class de {
            constructor(e1, t1, i, s){
                this.message = (e1 ? `${e1}: ` : "") + i, s && (this.identifier = s), null != t1 && t1.__line__ && (this.line = t1.__line__);
            }
        }
        class ue extends de {
        }
        function pe(t1) {
            const i = t1.value, s = t1.valueSpec, r = t1.style, o = t1.styleSpec, n = t1.key, a = t1.arrayElementValidator || Ue;
            if (!Array.isArray(i)) return [
                new de(n, i, `array expected, ${e1.y(i)} found`)
            ];
            if (s.length && i.length !== s.length) return [
                new de(n, i, `array length ${s.length} expected, length ${i.length} found`)
            ];
            if (s["min-length"] && i.length < s["min-length"]) return [
                new de(n, i, `array length at least ${s["min-length"]} expected, length ${i.length} found`)
            ];
            let l = {
                type: s.value,
                values: s.values,
                minimum: s.minimum,
                maximum: s.maximum,
                function: void 0
            };
            o.$version < 7 && (l.function = s.function), e1.v(s.value) && (l = s.value);
            let c = [];
            for(let e1 = 0; e1 < i.length; e1++)c = c.concat(a({
                array: i,
                arrayIndex: e1,
                value: i[e1],
                valueSpec: l,
                style: r,
                styleSpec: o,
                key: `${n}[${e1}]`
            }, !0));
            return c;
        }
        function fe(t1) {
            const i = t1.key, s = t1.value, r = t1.valueSpec;
            if (!e1.z(s)) return [
                new de(i, s, `number expected, ${e1.y(s)} found`)
            ];
            if (s != s) return [
                new de(i, s, "number expected, NaN found")
            ];
            if ("minimum" in r) {
                let e1 = r.minimum;
                if (Array.isArray(r.minimum) && (e1 = r.minimum[t1.arrayIndex]), s < e1) return [
                    new de(i, s, `${s} is less than the minimum value ${e1}`)
                ];
            }
            if ("maximum" in r) {
                let e1 = r.maximum;
                if (Array.isArray(r.maximum) && (e1 = r.maximum[t1.arrayIndex]), s > e1) return [
                    new de(i, s, `${s} is greater than the maximum value ${e1}`)
                ];
            }
            return [];
        }
        function me(t1) {
            const i = t1.key, s = t1.value;
            if (!e1.v(s)) return [
                new de(i, s, `object expected, ${e1.y(s)} found`)
            ];
            const r = t1.valueSpec, o = e1.x(s.type);
            let n, a, l, c = {};
            const h = "categorical" !== o && void 0 === s.property, d = !h, u = function(t1) {
                const i = t1.stops;
                return Array.isArray(i) && Array.isArray(i[0]) && e1.v(i[0][0]);
            }(s), p = Ne({
                key: t1.key,
                value: t1.value,
                valueSpec: t1.styleSpec.function,
                style: t1.style,
                styleSpec: t1.styleSpec,
                objectElementValidators: {
                    stops: function(e1) {
                        if ("identity" === o) return [
                            new de(e1.key, e1.value, 'identity function may not have a "stops" property')
                        ];
                        let t1 = [];
                        const i = e1.value;
                        return t1 = t1.concat(pe({
                            key: e1.key,
                            value: i,
                            valueSpec: e1.valueSpec,
                            style: e1.style,
                            styleSpec: e1.styleSpec,
                            arrayElementValidator: f
                        })), Array.isArray(i) && 0 === i.length && t1.push(new de(e1.key, i, "array must have at least one stop")), t1;
                    },
                    default: function(e1) {
                        return Ue({
                            key: e1.key,
                            value: e1.value,
                            valueSpec: r,
                            style: e1.style,
                            styleSpec: e1.styleSpec
                        });
                    }
                }
            });
            return "identity" === o && h && p.push(new de(t1.key, t1.value, 'missing required property "property"')), "identity" === o || s.stops || p.push(new de(t1.key, t1.value, 'missing required property "stops"')), "exponential" === o && r.expression && !e1.A(r) && p.push(new de(t1.key, t1.value, "exponential functions not supported")), t1.styleSpec.$version >= 8 && (d && !e1.B(r) ? p.push(new de(t1.key, t1.value, "property functions not supported")) : h && !e1.D(r) && p.push(new de(t1.key, t1.value, "zoom functions not supported"))), "categorical" !== o && !u || void 0 !== s.property || p.push(new de(t1.key, t1.value, '"property" property is required')), p;
            function f(t1) {
                let i = [];
                const s = t1.value, o = t1.key;
                if (!Array.isArray(s)) return [
                    new de(o, s, `array expected, ${e1.y(s)} found`)
                ];
                if (2 !== s.length) return [
                    new de(o, s, `array length 2 expected, length ${s.length} found`)
                ];
                if (u) {
                    if (!e1.v(s[0])) return [
                        new de(o, s, `object expected, ${e1.y(s[0])} found`)
                    ];
                    const r = s[0];
                    if (void 0 === r.zoom) return [
                        new de(o, s, "object stop key must have zoom")
                    ];
                    if (void 0 === r.value) return [
                        new de(o, s, "object stop key must have value")
                    ];
                    const n = e1.x(r.zoom);
                    if ("number" != typeof n) return [
                        new de(o, r.zoom, "stop zoom values must be numbers")
                    ];
                    if (l && l > n) return [
                        new de(o, r.zoom, "stop zoom values must appear in ascending order")
                    ];
                    n !== l && (l = n, a = void 0, c = {}), i = i.concat(Ne({
                        key: `${o}[0]`,
                        value: s[0],
                        valueSpec: {
                            zoom: {}
                        },
                        style: t1.style,
                        styleSpec: t1.styleSpec,
                        objectElementValidators: {
                            zoom: fe,
                            value: m
                        }
                    }));
                } else i = i.concat(m({
                    key: `${o}[0]`,
                    value: s[0],
                    style: t1.style,
                    styleSpec: t1.styleSpec
                }, s));
                return e1.F(e1.G(s[1])) ? i.concat([
                    new de(`${o}[1]`, s[1], "expressions are not allowed in function stops.")
                ]) : i.concat(Ue({
                    key: `${o}[1]`,
                    value: s[1],
                    valueSpec: r,
                    style: t1.style,
                    styleSpec: t1.styleSpec
                }));
            }
            function m(t1, i) {
                const s = e1.y(t1.value), l = e1.x(t1.value), h = null !== t1.value ? t1.value : i;
                if (n) {
                    if (s !== n) return [
                        new de(t1.key, h, `${s} stop domain type must match previous stop domain type ${n}`)
                    ];
                } else n = s;
                if ("number" !== s && "string" !== s && "boolean" !== s && "number" != typeof l && "string" != typeof l && "boolean" != typeof l) return [
                    new de(t1.key, h, "stop domain value must be a number, string, or boolean")
                ];
                if ("number" !== s && "categorical" !== o) {
                    let i = `number expected, ${s} found`;
                    return e1.B(r) && void 0 === o && (i += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                        new de(t1.key, h, i)
                    ];
                }
                return "categorical" !== o || "number" !== s || "number" == typeof l && isFinite(l) && Math.floor(l) === l ? "categorical" !== o && "number" === s && "number" == typeof l && "number" == typeof a && void 0 !== a && l < a ? [
                    new de(t1.key, h, "stop domain values must appear in ascending order")
                ] : (a = l, "categorical" === o && l in c ? [
                    new de(t1.key, h, "stop domain values must be unique")
                ] : (c[l] = !0, [])) : [
                    new de(t1.key, h, `integer expected, found ${String(l)}`)
                ];
            }
        }
        function _e(t1) {
            const i = ("property" === t1.expressionContext ? e1.H : e1.c)(e1.G(t1.value), t1.valueSpec);
            if ("error" === i.result) return i.value.map((e1)=>new de(`${t1.key}${e1.key}`, t1.value, e1.message));
            const s = i.value.expression || i.value._styleExpression.expression;
            if ("property" === t1.expressionContext && "text-font" === t1.propertyKey && !s.outputDefined()) return [
                new de(t1.key, t1.value, `Invalid data expression for "${t1.propertyKey}". Output values must be contained as literals within the expression.`)
            ];
            if ("property" === t1.expressionContext && "layout" === t1.propertyType && !e1.J(s)) return [
                new de(t1.key, t1.value, '"feature-state" data expressions are not supported with layout properties.')
            ];
            if ("filter" === t1.expressionContext) return ge(s, t1);
            if ("appearance" === t1.expressionContext) return ve(s, t1);
            if (t1.expressionContext && 0 === t1.expressionContext.indexOf("cluster")) {
                if (!e1.K(s, [
                    "zoom",
                    "feature-state"
                ])) return [
                    new de(t1.key, t1.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                ];
                if ("cluster-initial" === t1.expressionContext && !e1.M(s)) return [
                    new de(t1.key, t1.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                ];
            }
            return [];
        }
        function ge(t1, i) {
            const s = new Set([
                "zoom",
                "feature-state",
                "pitch",
                "distance-from-center"
            ]);
            if (i.valueSpec && i.valueSpec.expression) for (const e1 of i.valueSpec.expression.parameters)s.delete(e1);
            if (0 === s.size) return [];
            const r = [];
            return t1 instanceof e1.N && s.has(t1.name) ? [
                new de(i.key, i.value, `["${t1.name}"] expression is not supported in a filter for a ${i.object.type} layer with id: ${i.object.id}`)
            ] : (t1.eachChild((e1)=>{
                r.push(...ge(e1, i));
            }), r);
        }
        const ye = new Set([
            "get",
            "has",
            "properties",
            "geometry-type",
            "id"
        ]);
        function ve(t1, i) {
            const s = new Set([
                "zoom",
                "pitch",
                "distance-from-center",
                "feature",
                "feature-state",
                "measure-light",
                "heatmap-density",
                "line-progress",
                "raster-value",
                "raster-particle-speed",
                "sky-radial-progress"
            ]);
            if (i.valueSpec && i.valueSpec.expression) for (const e1 of i.valueSpec.expression.parameters)s.delete(e1);
            if (0 === s.size) return [];
            const r = [];
            if (t1 instanceof e1.N) {
                const e1 = ye.has(t1.name) ? "feature" : t1.name;
                if (s.has(e1)) return [
                    new de(i.key, i.value, `["${t1.name}"] is not an allowed parameter`)
                ];
            }
            return t1.eachChild((e1)=>{
                r.push(...ve(e1, i));
            }), r;
        }
        function be(t1) {
            const i = t1.key, s = t1.value, r = t1.valueSpec, o = [];
            return Array.isArray(r.values) ? r.values.includes(e1.x(s)) || o.push(new de(i, s, `expected one of [${r.values.join(", ")}], ${JSON.stringify(s)} found`)) : Object.keys(r.values).includes(e1.x(s)) || o.push(new de(i, s, `expected one of [${Object.keys(r.values).join(", ")}], ${JSON.stringify(s)} found`)), o;
        }
        function xe(t1) {
            if (e1.S(e1.G(t1.value))) {
                const e1 = t1.layerType || "fill";
                return _e({
                    ...t1,
                    expressionContext: "filter",
                    valueSpec: t1.styleSpec[`filter_${e1}`]
                });
            }
            return we(t1);
        }
        function we(t1) {
            const i = t1.value, s = t1.key;
            if (!Array.isArray(i)) return [
                new de(s, i, `array expected, ${e1.y(i)} found`)
            ];
            if (i.length < 1) return [
                new de(s, i, "filter array must have at least 1 element")
            ];
            const r = t1.styleSpec;
            let o = be({
                key: `${s}[0]`,
                value: i[0],
                valueSpec: r.filter_operator
            });
            const n = ()=>{
                i.length >= 2 && (e1.Q(i[1]) || o.push(new de(`${s}[1]`, i[1], `string expected, ${e1.y(i[1])} found`)));
                for(let t1 = 2; t1 < i.length; t1++)"$type" === e1.x(i[1]) ? o = o.concat(be({
                    key: `${s}[${t1}]`,
                    value: i[t1],
                    valueSpec: r.geometry_type
                })) : e1.Q(i[t1]) || e1.z(i[t1]) || e1.O(i[t1]) || o.push(new de(`${s}[${t1}]`, i[t1], `string, number, or boolean expected, ${e1.y(i[t1])} found.`));
            };
            switch(e1.x(i[0])){
                case "<":
                case "<=":
                case ">":
                case ">=":
                    i.length >= 2 && "$type" === e1.x(i[1]) && o.push(new de(s, i, `"$type" cannot be use with operator "${i[0]}"`)), 3 !== i.length && o.push(new de(s, i, `filter array for operator "${i[0]}" must have 3 elements`)), n();
                    break;
                case "==":
                case "!=":
                    3 !== i.length && o.push(new de(s, i, `filter array for operator "${i[0]}" must have 3 elements`)), n();
                    break;
                case "in":
                case "!in":
                    n();
                    break;
                case "any":
                case "all":
                case "none":
                    for(let e1 = 1; e1 < i.length; e1++)o = o.concat(we({
                        key: `${s}[${e1}]`,
                        value: i[e1],
                        style: t1.style,
                        styleSpec: t1.styleSpec
                    }));
                    break;
                case "has":
                case "!has":
                    2 !== i.length ? o.push(new de(s, i, `filter array for "${i[0]}" operator must have 2 elements`)) : e1.Q(i[1]) || o.push(new de(`${s}[1]`, i[1], `string expected, ${e1.y(i[1])} found`));
            }
            return o;
        }
        const Te = /^{([^}]+)}$/;
        function Se(t1, i) {
            const s = t1.key, r = t1.style, o = t1.layer, n = t1.styleSpec, a = t1.value, l = t1.objectKey, c = n[`${i}_${t1.layerType}`];
            if (!c) return [];
            const h = l.match(e1.U);
            if (h && c[h[1]]) return e1.F(e1.G(a)) ? [].concat(Ue({
                key: s,
                value: a,
                valueSpec: {
                    type: "string",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                style: r,
                styleSpec: n,
                expressionContext: "property",
                propertyType: i,
                propertyKey: l
            })) : Ue({
                key: s,
                value: a,
                valueSpec: {
                    type: "string"
                },
                style: r,
                styleSpec: n
            });
            const d = l.match(e1.V);
            if ("paint" === i && d && c[d[1]] && c[d[1]].transition) return Ue({
                key: s,
                value: a,
                valueSpec: n.transition,
                style: r,
                styleSpec: n
            });
            const u = t1.valueSpec || c[l];
            if (!u) return [
                new ue(s, a, `unknown property "${l}"`)
            ];
            let p;
            if (e1.Q(a) && e1.B(u) && !u.tokens && (p = Te.exec(a))) {
                const e1 = `\`{ "type": "identity", "property": ${p ? JSON.stringify(p[1]) : '"_"'} }\``;
                return [
                    new de(s, a, `"${l}" does not support interpolation syntax\nUse an identity property function instead: ${e1}.`)
                ];
            }
            const f = [];
            if ("symbol" === t1.layerType) "text-field" !== l || !r || r.glyphs || r.imports || f.push(new de(s, a, 'use of "text-field" requires a style "glyphs" property')), "text-font" === l && e1.W(e1.G(a)) && "identity" === e1.x(a.type) && f.push(new de(s, a, '"text-font" does not support identity functions'));
            else if ("model" === t1.layerType && "paint" === i && o && o.layout && Object.hasOwn(o.layout, "model-id") && e1.B(u) && (e1.X(u) || e1.D(u))) {
                const t1 = e1.H(e1.G(a), u).value, i = "expression" in t1 && t1.expression || "_styleExpression" in t1 && t1._styleExpression && t1._styleExpression.expression;
                i && !e1.K(i, [
                    "measure-light"
                ]) && ("model-emissive-strength" === l && e1.M(i) && e1.J(i) || f.push(new de(s, a, `${l} does not support measure-light expressions when the model layer source is vector tile or GeoJSON.`)));
            }
            return f.concat(Ue({
                key: t1.key,
                value: a,
                valueSpec: u,
                style: r,
                styleSpec: n,
                expressionContext: "property",
                propertyType: i,
                propertyKey: l
            }));
        }
        function Ce(e1) {
            return Se(e1, "paint");
        }
        function Ee(e1) {
            return Se(e1, "layout");
        }
        function Ie(t1) {
            let i = [];
            const s = t1.value, r = t1.key, o = t1.style, n = t1.styleSpec;
            if (!e1.v(s)) return [
                new de(r, s, "object expected")
            ];
            s.type || s.ref || i.push(new de(r, s, 'either "type" or "ref" is required'));
            let a = e1.x(s.type);
            const l = e1.x(s.ref);
            if (s.id) {
                const n = e1.x(s.id);
                for(let a = 0; a < t1.arrayIndex; a++){
                    const t1 = o.layers[a];
                    e1.x(t1.id) === n && i.push(new de(r, s.id, `duplicate layer id "${n}", previously used at line ${t1.id.__line__}`));
                }
            }
            if ("ref" in s) {
                let t1;
                [
                    "type",
                    "source",
                    "source-layer",
                    "filter",
                    "layout"
                ].forEach((e1)=>{
                    e1 in s && i.push(new de(r, s[e1], `"${e1}" is prohibited for ref layers`));
                }), o.layers.forEach((i)=>{
                    e1.x(i.id) === l && (t1 = i);
                }), t1 ? t1.ref ? i.push(new de(r, s.ref, "ref cannot reference another ref layer")) : a = e1.x(t1.type) : "string" == typeof l && i.push(new de(r, s.ref, `ref layer "${l}" not found`));
            } else if ("background" !== a && "sky" !== a && "slot" !== a && "placement-group" !== a) {
                if (s.source) {
                    if (e1.Q(s.source)) {
                        const t1 = o.sources && Object.hasOwn(o.sources, s.source) ? o.sources[s.source] : void 0, n = t1 && e1.x(t1.type);
                        t1 ? "vector" === n && "raster" === a ? i.push(new de(r, s.source, `layer "${s.id}" requires a raster source`)) : "raster" === n && "raster" !== a ? i.push(new de(r, s.source, `layer "${s.id}" requires a vector source`)) : "vector" !== n || s["source-layer"] ? "raster-dem" === n && "hillshade" !== a ? i.push(new de(r, s.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "raster-array" !== n || [
                            "raster",
                            "raster-particle"
                        ].includes(a) ? "line" === a && s.paint && s.paint["line-gradient"] && "geojson" === n && !t1.lineMetrics ? i.push(new de(r, s, `layer "${s.id}" specifies a line-gradient, which requires the GeoJSON source to have \`lineMetrics\` enabled.`)) : "line" === a && s.paint && s.paint["line-trim-offset"] && "geojson" === n && !t1.lineMetrics ? i.push(new de(r, s, `layer "${s.id}" specifies a line-trim-offset, which requires the GeoJSON source to have \`lineMetrics\` enabled.`)) : "raster-particle" === a && "raster-array" !== n && i.push(new de(r, s.source, `layer "${s.id}" requires a 'raster-array' source.`)) : i.push(new de(r, s.source, "raster-array source can only be used with layer type 'raster'.")) : i.push(new de(r, s, `layer "${s.id}" must specify a "source-layer"`)) : i.push(new de(r, s.source, `source "${s.source}" not found`));
                    } else i.push(new de(`${r}.source`, s.source, '"source" must be a string'));
                } else i.push(new de(r, s, 'missing required property "source"'));
            }
            if ("raster" === a && e1.v(s.paint)) {
                const t1 = s.paint, n = e1.x(t1["raster-mask"]), a = e1.x(t1["raster-mask-import"]);
                if (e1.Q(n) && n) {
                    if (e1.Q(a) && a) (o.imports || []).some((t1)=>e1.x(t1.id) === a) || i.push(new de(`${r}.paint.raster-mask-import`, t1["raster-mask-import"], `import "${a}" not found`));
                    else {
                        const s = (o.layers || []).find((t1)=>e1.x(t1.id) === n);
                        s ? "fill" !== e1.x(s.type) && i.push(new de(`${r}.paint.raster-mask`, t1["raster-mask"], `layer "${n}" must be a "fill" layer`)) : i.push(new de(`${r}.paint.raster-mask`, t1["raster-mask"], `layer "${n}" not found`));
                    }
                }
            }
            return i = i.concat(Ne({
                key: r,
                value: s,
                valueSpec: n.layer,
                style: t1.style,
                styleSpec: t1.styleSpec,
                objectElementValidators: {
                    "*": ()=>[],
                    type: ()=>Ue({
                            key: `${r}.type`,
                            value: s.type,
                            valueSpec: n.layer.type,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            object: s,
                            objectKey: "type"
                        }),
                    filter: (e1)=>xe({
                            layerType: a,
                            ...e1
                        }),
                    layout: (e1)=>Ne({
                            layer: s,
                            key: e1.key,
                            value: e1.value,
                            valueSpec: {},
                            style: e1.style,
                            styleSpec: e1.styleSpec,
                            objectElementValidators: {
                                "*": (e1)=>Ee({
                                        layerType: a,
                                        ...e1
                                    })
                            }
                        }),
                    paint: (e1)=>Ne({
                            layer: s,
                            key: e1.key,
                            value: e1.value,
                            valueSpec: {},
                            style: e1.style,
                            styleSpec: e1.styleSpec,
                            objectElementValidators: {
                                "*": (e1)=>Ce({
                                        layerType: a,
                                        layer: s,
                                        ...e1
                                    })
                            }
                        }),
                    appearances (t1) {
                        const i = pe({
                            key: t1.key,
                            value: t1.value,
                            valueSpec: t1.valueSpec,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            arrayElementValidator: (t1)=>(function(t1) {
                                    const { key: i, layer: s, layerType: r } = t1, o = e1.x(t1.value), n = e1.x(o.name), a = e1.x(o.condition), l = Ne({
                                        key: i,
                                        value: o,
                                        valueSpec: t1.styleSpec.appearance,
                                        style: t1.style,
                                        styleSpec: t1.styleSpec,
                                        objectElementValidators: {
                                            condition: (e1)=>(function(e1) {
                                                    const t1 = [];
                                                    return t1.push(..._e({
                                                        key: e1.key,
                                                        value: e1.object.condition,
                                                        valueSpec: e1.styleSpec.appearance.condition,
                                                        expressionContext: "appearance"
                                                    })), t1;
                                                })({
                                                    ...e1
                                                }),
                                            properties: (e1)=>(function(e1) {
                                                    const t1 = [], { styleSpec: i, layer: s, layerType: r } = e1, o = i[`paint_${r}`], n = i[`layout_${r}`], a = e1.object[e1.objectKey];
                                                    for(const i in a){
                                                        const l = i in o ? "paint" : i in n ? "layout" : void 0;
                                                        if (!l) {
                                                            t1.push(new de(e1.key, i, `unknown property "${i}" for layer type "${r}"`));
                                                            continue;
                                                        }
                                                        const c = {
                                                            ...e1,
                                                            key: `${e1.key}.${i}`,
                                                            objectKey: i,
                                                            layer: s,
                                                            layerType: r,
                                                            value: a[i],
                                                            valueSpec: "paint" === l ? o[i] : n[i]
                                                        };
                                                        t1.push(...Se(c, l));
                                                    }
                                                    return t1;
                                                })({
                                                    layer: s,
                                                    layerType: r,
                                                    ...e1
                                                })
                                        }
                                    });
                                    return "hidden" !== n && void 0 === a && l.push(new de(t1.key, "name", 'Appearance with name different than "hidden" must have a condition')), l;
                                })({
                                    layerType: a,
                                    layer: s,
                                    ...t1
                                })
                        }), r = Array.isArray(t1.value) ? t1.value : [], o = new Set;
                        return r.forEach((r, n)=>{
                            const a = e1.x(r.name);
                            if (a) {
                                if (o.has(a)) {
                                    const r = e1.x(s.id);
                                    i.push(new de(t1.key, a, `Duplicated appearance name "${a}" for layer "${r}"`));
                                } else o.add(a);
                            }
                        }), i;
                    }
                }
            })), i;
        }
        function De({ key: t1, value: i }) {
            return e1.Q(i) ? [] : [
                new de(t1, i, `string expected, ${e1.y(i)} found`)
            ];
        }
        const Pe = {
            promoteId: function t1({ key: i, value: s }) {
                if (e1.Q(s)) return De({
                    key: i,
                    value: s
                });
                if (Array.isArray(s)) {
                    const t1 = [], r = e1.G(s), o = e1.c(r);
                    return "error" === o.result ? (o.value.forEach((e1)=>{
                        t1.push(new de(`${i}${e1.key}`, null, `${e1.message}`));
                    }), t1) : (e1.K(o.value.expression, [
                        "zoom",
                        "heatmap-density",
                        "line-progress",
                        "raster-value",
                        "sky-radial-progress",
                        "accumulated",
                        "is-supported-script",
                        "pitch",
                        "distance-from-center",
                        "measure-light",
                        "raster-particle-speed"
                    ]) || t1.push(new de(`${i}`, null, "promoteId expression should be only feature dependent")), t1);
                }
                if (!e1.v(s)) return [
                    new de(i, s, `string, expression or object expected, "${e1.y(s)}" found`)
                ];
                const r = [];
                for(const e1 in s)r.push(...t1({
                    key: `${i}.${e1}`,
                    value: s[e1]
                }));
                return r;
            }
        };
        function Le(t1) {
            const i = t1.value, s = t1.key, r = t1.styleSpec, o = t1.style;
            if (!e1.v(i)) return [
                new de(s, i, `object expected, ${e1.y(i)} found`)
            ];
            if (!("type" in i)) return [
                new de(s, i, '"type" is required')
            ];
            const n = e1.x(i.type);
            let a = [];
            switch([
                "vector",
                "raster",
                "raster-dem",
                "raster-array"
            ].includes(n) && ("url" in i || "tiles" in i || a.push(new ue(s, i, 'Either "url" or "tiles" is required.'))), n){
                case "vector":
                case "raster":
                case "raster-dem":
                case "raster-array":
                    return a = a.concat(Ne({
                        key: s,
                        value: i,
                        valueSpec: r[`source_${n.replace("-", "_")}`],
                        style: t1.style,
                        styleSpec: r,
                        objectElementValidators: Pe
                    })), a;
                case "geojson":
                    if (a = Ne({
                        key: s,
                        value: i,
                        valueSpec: r.source_geojson,
                        style: o,
                        styleSpec: r,
                        objectElementValidators: Pe
                    }), "cluster" in i && "clusterProperties" in i) {
                        if (!e1.v(i.clusterProperties)) return [
                            new de(`${s}.clusterProperties`, i, `object expected, ${e1.y(i)} found`)
                        ];
                        for(const e1 in i.clusterProperties){
                            const t1 = i.clusterProperties[e1];
                            if (!Array.isArray(t1)) return [
                                new de(`${s}.clusterProperties.${e1}`, t1, "array expected")
                            ];
                            const [r, o] = t1, n = "string" == typeof r ? [
                                r,
                                [
                                    "accumulated"
                                ],
                                [
                                    "get",
                                    e1
                                ]
                            ] : r;
                            a.push(..._e({
                                key: `${s}.${e1}.map`,
                                value: o,
                                expressionContext: "cluster-map"
                            })), a.push(..._e({
                                key: `${s}.${e1}.reduce`,
                                value: n,
                                expressionContext: "cluster-reduce"
                            }));
                        }
                    }
                    return a;
                case "video":
                    return Ne({
                        key: s,
                        value: i,
                        valueSpec: r.source_video,
                        style: o,
                        styleSpec: r
                    });
                case "image":
                    return Ne({
                        key: s,
                        value: i,
                        valueSpec: r.source_image,
                        style: o,
                        styleSpec: r
                    });
                case "canvas":
                    return [
                        new de(s, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                    ];
                default:
                    return be({
                        key: `${s}.type`,
                        value: i.type,
                        valueSpec: {
                            values: Re(r)
                        }
                    });
            }
        }
        function Re(e1) {
            return e1.source.reduce((t1, i)=>{
                const s = e1[i];
                return "enum" === s.type.type && (t1 = t1.concat(Object.keys(s.type.values || {}))), t1;
            }, []);
        }
        function Ae(e1, t1) {
            const i = !e1.includes("://");
            try {
                return new URL(e1, i && t1 ? "http://example.com" : void 0), !0;
            } catch (e1) {
                return !1;
            }
        }
        function Me(t1) {
            const i = t1.value;
            return i ? e1.Q(i) ? Ae(i, !0) ? [] : [
                new de(t1.key, i, `invalid url "${i}"`)
            ] : [
                new de(t1.key, i, `string expected, "${e1.y(i)}" found`)
            ] : [];
        }
        function Fe(t1) {
            const i = t1.value, s = t1.styleSpec, r = s.light, o = t1.style;
            if (void 0 === i) return [];
            if (!e1.v(i)) return [
                new de("light", i, `object expected, ${e1.y(i)} found`)
            ];
            let n = [];
            for(const t1 in i){
                const a = t1.match(e1.V), l = t1.match(e1.U);
                n = n.concat(l && r[l[1]] ? Ue({
                    key: t1,
                    value: i[t1],
                    valueSpec: {
                        type: "string"
                    },
                    style: o,
                    styleSpec: s
                }) : a && r[a[1]] && r[a[1]].transition ? Ue({
                    key: t1,
                    value: i[t1],
                    valueSpec: s.transition,
                    style: o,
                    styleSpec: s
                }) : r[t1] ? Ue({
                    key: t1,
                    value: i[t1],
                    valueSpec: r[t1],
                    style: o,
                    styleSpec: s
                }) : [
                    new de(t1, i[t1], `unknown property "${t1}"`)
                ]);
            }
            return n;
        }
        function Oe(t1) {
            const i = t1.value;
            if (!i) return [];
            const s = t1.key;
            if (!e1.v(i)) return [
                new de(s, i, `object expected, ${e1.y(i)} found`)
            ];
            let r = [];
            const o = t1.styleSpec, n = o["light-3d"], a = t1.style, l = t1.style.lights;
            for (const e1 of [
                "type",
                "id"
            ])if (!(e1 in i)) return r = r.concat([
                new de(s, i, `missing property "${e1}"`)
            ]), r;
            if (!e1.Q(i.type)) return r = r.concat([
                new de(`${s}.type`, i.type, "string expected")
            ]), r;
            if (l) for(let o = 0; o < t1.arrayIndex; o++){
                const t1 = e1.x(i.type), n = l[o];
                e1.x(n.type) === t1 && r.push(new de(s, i.id, `duplicate light type "${i.type}", previously defined at line ${n.id.__line__}`));
            }
            const c = `properties_light_${i.type}`;
            if (!(c in o)) return r = r.concat([
                new de(`${s}.type`, i, `Invalid light type ${i.type}`)
            ]), r;
            const h = o[c];
            for(const s in i)if ("properties" === s) {
                const n = i[s];
                if (!e1.v(n)) return r = r.concat([
                    new de("properties", n, `object expected, ${e1.y(n)} found`)
                ]), r;
                for(const i in n){
                    const s = i.match(e1.V), l = i.match(e1.U);
                    r = r.concat(l && h[l[1]] ? Ue({
                        key: i,
                        value: n[i],
                        valueSpec: {
                            type: "string"
                        },
                        style: a,
                        styleSpec: o
                    }) : s && h[s[1]] && h[s[1]].transition ? Ue({
                        key: i,
                        value: n[i],
                        valueSpec: o.transition,
                        style: a,
                        styleSpec: o
                    }) : h[i] ? Ue({
                        key: i,
                        value: n[i],
                        valueSpec: h[i],
                        style: a,
                        styleSpec: o
                    }) : [
                        new ue(t1.key, n[i], `unknown property "${i}"`)
                    ]);
                }
            } else r = r.concat(n[s] ? Ue({
                key: s,
                value: i[s],
                valueSpec: n[s],
                style: a,
                styleSpec: o
            }) : [
                new ue(s, i[s], `unknown property "${s}"`)
            ]);
            return r;
        }
        function ke(t1) {
            const i = t1.value, s = t1.key, r = t1.style, o = t1.styleSpec, n = o.terrain;
            if (null == i) return [];
            if (!e1.v(i)) return [
                new de("terrain", i, `object expected, ${e1.y(i)} found`)
            ];
            let a = [];
            for(const t1 in i){
                const s = t1.match(e1.V), l = t1.match(e1.U);
                a = a.concat(l && n[l[1]] ? Ue({
                    key: t1,
                    value: i[t1],
                    valueSpec: {
                        type: "string"
                    },
                    style: r,
                    styleSpec: o
                }) : s && n[s[1]] && n[s[1]].transition ? Ue({
                    key: t1,
                    value: i[t1],
                    valueSpec: o.transition,
                    style: r,
                    styleSpec: o
                }) : n[t1] ? Ue({
                    key: t1,
                    value: i[t1],
                    valueSpec: n[t1],
                    style: r,
                    styleSpec: o
                }) : [
                    new ue(t1, i[t1], `unknown property "${t1}"`)
                ]);
            }
            if (i.source) {
                if (e1.Q(i.source)) {
                    const t1 = r.sources && Object.hasOwn(r.sources, i.source) ? r.sources[i.source] : void 0, o = t1 && e1.x(t1.type);
                    t1 ? "raster-dem" !== o && a.push(new de(`${s}.source`, i.source, `terrain cannot be used with a source of type ${o}, it only be used with a "raster-dem" source type`)) : a.push(new de(`${s}.source`, i.source, `source "${i.source}" not found`));
                } else a.push(new de(`${s}.source`, i.source, "source must be a string"));
            } else a.push(new de(s, i, 'terrain is missing required property "source"'));
            return a;
        }
        function Be(t1) {
            const i = t1.value, s = t1.style, r = t1.styleSpec, o = r.fog;
            if (void 0 === i) return [];
            if (!e1.v(i)) return [
                new de("fog", i, `object expected, ${e1.y(i)} found`)
            ];
            let n = [];
            for(const t1 in i){
                const a = t1.match(e1.V), l = t1.match(e1.U);
                n = n.concat(l && o[l[1]] ? Ue({
                    key: t1,
                    value: i[t1],
                    valueSpec: {
                        type: "string"
                    },
                    style: s,
                    styleSpec: r
                }) : a && o[a[1]] && o[a[1]].transition ? Ue({
                    key: t1,
                    value: i[t1],
                    valueSpec: r.transition,
                    style: s,
                    styleSpec: r
                }) : o[t1] ? Ue({
                    key: t1,
                    value: i[t1],
                    valueSpec: o[t1],
                    style: s,
                    styleSpec: r
                }) : [
                    new ue(t1, i[t1], `unknown property "${t1}"`)
                ]);
            }
            return n;
        }
        const ze = {
            "*": ()=>[],
            array: pe,
            boolean: function(t1) {
                const i = t1.value, s = t1.key;
                return e1.O(i) ? [] : [
                    new de(s, i, `boolean expected, ${e1.y(i)} found`)
                ];
            },
            number: fe,
            color: function({ key: t1, value: i }) {
                return e1.Q(i) ? void 0 === e1.C.parse(e1.x(i)) ? [
                    new de(t1, i, `color expected, "${i}" found`)
                ] : [] : [
                    new de(t1, i, `color expected, ${e1.y(i)} found`)
                ];
            },
            enum: be,
            filter: xe,
            function: me,
            layer: Ie,
            object: Ne,
            source: Le,
            model: Me,
            light: Fe,
            "light-3d": Oe,
            terrain: ke,
            fog: Be,
            string: De,
            formatted: function(e1) {
                return 0 === De(e1).length ? [] : _e(e1);
            },
            resolvedImage: function(e1) {
                return 0 === De(e1).length ? [] : _e(e1);
            },
            projection: function(t1) {
                const i = t1.value, s = t1.styleSpec, r = s.projection, o = t1.style;
                if (e1.v(i)) {
                    let e1 = [];
                    for(const t1 in i)e1 = e1.concat(Ue({
                        key: t1,
                        value: i[t1],
                        valueSpec: r[t1],
                        style: o,
                        styleSpec: s
                    }));
                    return e1;
                }
                return e1.Q(i) ? [] : [
                    new de("projection", i, `object or string expected, ${e1.y(i)} found`)
                ];
            },
            import: function(t1) {
                const i = t1.key, { value: s, styleSpec: r } = t1;
                if (!e1.v(s)) return [
                    new de(i, s, "import must be an object")
                ];
                const { data: o, ...n } = s;
                Object.defineProperty(n, "__line__", {
                    value: s.__line__,
                    enumerable: !1
                });
                let a = Ne({
                    ...t1,
                    value: n,
                    valueSpec: r.import
                });
                "" === e1.x(n.id) && a.push(new de(`${t1.key}.id`, n, "import id can't be an empty string"));
                const l = e1.x(n.id);
                return "__proto__" !== l && "constructor" !== l && "prototype" !== l || a.push(new de(`${t1.key}.id`, n, `import id can't be "${String(l)}"`)), o && (a = a.concat(Ve(o, r, {
                    key: `${t1.key}.data`
                }))), a;
            },
            iconset: function(t1) {
                const i = t1.value, s = t1.key, r = t1.styleSpec, o = t1.style;
                if (!e1.v(i)) return [
                    new de(s, i, "object expected")
                ];
                if (!i.type) return [
                    new de(s, i, '"type" is required')
                ];
                const n = e1.x(i.type);
                let a = [];
                if (a = a.concat(Ne({
                    key: s,
                    value: i,
                    valueSpec: r[`iconset_${n}`],
                    style: o,
                    styleSpec: r
                })), function(e1, t1) {
                    return !("source" !== e1 || !t1.source);
                }(n, i)) {
                    const t1 = o.sources && Object.hasOwn(o.sources, i.source) ? o.sources[i.source] : void 0, r = t1 && e1.x(t1.type);
                    t1 ? "raster-array" !== r && a.push(new de(s, i.source, `iconset cannot be used with a source of type ${String(r)}, it only be used with a "raster-array" source type`)) : a.push(new de(s, i.source, `source "${i.source}" not found`));
                }
                return a;
            },
            option: function(t1) {
                const i = t1.styleSpec, s = t1.value, r = e1.v(s) && !0 === e1.x(s.array) || !e1.v(s) ? void 0 : e1.x(s.type);
                return Ne({
                    ...t1,
                    valueSpec: i.option,
                    objectElementValidators: {
                        default: (t1)=>{
                            const i = t1.value;
                            return e1.v(i) ? Ue({
                                ...t1,
                                valueSpec: {
                                    ...t1.valueSpec,
                                    type: "*",
                                    expression: void 0
                                }
                            }) : r && Array.isArray(i) ? Ue({
                                ...t1,
                                valueSpec: {
                                    ...t1.valueSpec,
                                    type: r
                                }
                            }) : Ue(t1);
                        }
                    }
                });
            }
        };
        function Ue(t1, i = !1) {
            const s = t1.value, r = t1.valueSpec, o = t1.styleSpec;
            if (r.expression) {
                if (e1.W(e1.x(s))) return me(t1);
                if (e1.F(e1.G(s))) return _e(t1);
            }
            if (r.type && ze[r.type]) {
                const e1 = ze[r.type](t1);
                return !0 === i && e1.length > 0 && Array.isArray(t1.value) ? _e(t1) : e1;
            }
            return Ne({
                ...t1,
                valueSpec: r.type ? o[r.type] : r
            });
        }
        function Ne(t1) {
            const i = t1.key, s = t1.value, r = t1.valueSpec || {}, o = t1.objectElementValidators || {}, n = t1.style, a = t1.styleSpec;
            if (!e1.v(s)) return [
                new de(i, s, `object expected, ${e1.y(s)} found`)
            ];
            let l = [];
            for(const e1 in s){
                if (!Object.hasOwn(s, e1)) continue;
                const t1 = e1.split(".")[0], c = Object.hasOwn(r, t1), h = Object.hasOwn(r, "*"), d = c ? r[t1] : h ? r["*"] : void 0;
                let u;
                Object.hasOwn(o, t1) ? u = o[t1] : c ? u = Ue : Object.hasOwn(o, "*") ? u = o["*"] : h && (u = Ue), u ? l = l.concat(u({
                    key: (i ? `${i}.` : i) + e1,
                    value: s[e1],
                    valueSpec: d,
                    style: n,
                    styleSpec: a,
                    object: s,
                    objectKey: e1
                }, s)) : l.push(new ue(i, s[e1], `unknown property "${e1}"`));
            }
            for(const e1 in r){
                if (!Object.hasOwn(r, e1)) continue;
                if (Object.hasOwn(o, e1)) continue;
                const t1 = r[e1];
                !t1.required || void 0 !== t1.default || Object.hasOwn(s, e1) && void 0 !== s[e1] || l.push(new de(i, s, `missing required property "${e1}"`));
            }
            return l;
        }
        function je({ key: e1, value: t1 }) {
            const i = De({
                key: e1,
                value: t1
            });
            if (i.length) return i;
            const s = t1;
            return s.includes("{fontstack}") || i.push(new de(e1, t1, '"glyphs" url must include a "{fontstack}" token')), s.includes("{range}") || i.push(new de(e1, t1, '"glyphs" url must include a "{range}" token')), i;
        }
        function Ve(t1, i = e1.s, s = {}) {
            return Ne({
                key: s.key || "",
                value: t1,
                valueSpec: {
                    ...i.$root,
                    "*": {
                        type: "*"
                    }
                },
                styleSpec: i,
                style: t1,
                objectElementValidators: {
                    glyphs: je
                }
            });
        }
        function Ge(e1) {
            return e1.slice().sort((e1, t1)=>e1.line && t1.line ? e1.line - t1.line : 0);
        }
        const qe = "setStyle", $e = "addLayer", Ze = "removeLayer", We = "setPaintProperty", He = "setLayerProperty", Xe = "setTerrain", Ye = "removeImport", Ke = "addIconset", Qe = "removeIconset";
        function Je(e1, t1, i) {
            i.push({
                command: "addSource",
                args: [
                    e1,
                    t1[e1]
                ]
            });
        }
        function et(e1, t1, i) {
            t1.push({
                command: "removeSource",
                args: [
                    e1
                ]
            }), i[e1] = !0;
        }
        function tt(e1, t1, i, s) {
            et(e1, i, s), Je(e1, t1, i);
        }
        function it(t1, i, s) {
            let r;
            for(r in t1[s])if (Object.hasOwn(t1[s], r) && "data" !== r && !e1.Y(t1[s][r], i[s][r])) return !1;
            for(r in i[s])if (Object.hasOwn(i[s], r) && "data" !== r && !e1.Y(t1[s][r], i[s][r])) return !1;
            return !0;
        }
        function st(t1, i, s, r, o, n) {
            let a;
            for(a in i = i || {}, t1 = t1 || {})Object.hasOwn(t1, a) && (e1.Y(t1[a], i[a]) || s.push({
                command: n,
                args: [
                    r,
                    a,
                    i[a],
                    o
                ]
            }));
            for(a in i)Object.hasOwn(i, a) && !Object.hasOwn(t1, a) && (e1.Y(t1[a], i[a]) || s.push({
                command: n,
                args: [
                    r,
                    a,
                    i[a],
                    o
                ]
            }));
        }
        function rt(e1) {
            return e1.id;
        }
        function ot(e1, t1) {
            return e1[t1.id] = t1, e1;
        }
        const nt = new e1.C(1, 0, 0, 1), at = new e1.C(0, 1, 0, 1), lt = new e1.C(0, 0, 1, 1), ct = new e1.C(1, 0, 1, 1), ht = new e1.C(0, 1, 1, 1);
        function dt(t1, i, s, r, o, n, a) {
            const l = t1.context, c = t1.transform, h = l.gl, d = "globe" === c.projection.name, u = d ? [
                "PROJECTION_GLOBE_VIEW"
            ] : [];
            let p = e1.Z(s.projMatrix);
            if (d && e1._(c.zoom) > 0) {
                const t1 = e1.$(s.canonical, c), i = e1.a0(t1);
                p = e1.a1(new Float32Array(16), c.globeMatrix, i), e1.a1(p, c.projMatrix, p);
            }
            const f = e1.a2();
            f[12] += 2 * o / (e1.e.devicePixelRatio * c.width), f[13] += 2 * n / (e1.e.devicePixelRatio * c.height), e1.a1(p, f, p);
            const m = t1.getOrCreateProgram("debug", {
                defines: u
            }), _ = i.getTileByID(s.key);
            t1.terrain && t1.terrain.setupElevationDraw(_, m);
            const g = e1.a3.disabled, y = e1.a4.disabled, v = t1.colorModeForRenderPass(), b = "$debug";
            l.activeTexture.set(h.TEXTURE0), t1.emptyTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE), d ? _._makeGlobeTileDebugBuffers(t1.context, c) : _._makeDebugTileBoundsBuffers(t1.context, c.projection);
            const x = _._tileDebugBuffer || t1.debugBuffer, w = _._tileDebugIndexBuffer || t1.debugIndexBuffer, T = _._tileDebugSegments || t1.debugSegments;
            if (m.draw(t1, h.LINE_STRIP, g, y, v, e1.a5.disabled, e1.a6(p, r.toPremultipliedRenderColor(null)), b, x, w, T, null, null, null, [
                _._globeTileDebugBorderBuffer
            ]), a) {
                const e1 = _.latestRawTileData, i = Math.floor((e1 && e1.byteLength || 0) / 1024);
                let r = s.canonical.toString();
                s.overscaledZ !== s.canonical.z && (r += ` => ${s.overscaledZ}`), r += ` ${_.state}`, r += ` ${i}kb`, function(e1, t1) {
                    e1.initDebugOverlayCanvas();
                    const i = e1.debugOverlayCanvas, s = e1.context.gl, r = e1.debugOverlayCanvas.getContext("2d");
                    r.clearRect(0, 0, i.width, i.height), r.shadowColor = "white", r.shadowBlur = 2, r.lineWidth = 1.5, r.strokeStyle = "white", r.textBaseline = "top", r.font = "bold 36px Open Sans, sans-serif", r.fillText(t1, 5, 5), r.strokeText(t1, 5, 5), e1.debugOverlayTexture.update(i), e1.debugOverlayTexture.bind(s.LINEAR, s.CLAMP_TO_EDGE);
                }(t1, r);
            }
            const S = i.getTile(s).tileSize, C = 512 / Math.min(S, 512) * (s.overscaledZ / c.zoom) * .5, E = _._tileDebugTextBuffer || t1.debugBuffer, I = _._tileDebugTextIndexBuffer || t1.quadTriangleIndexBuffer, D = _._tileDebugTextSegments || t1.debugSegments;
            m.draw(t1, h.TRIANGLES, g, y, e1.a7.alphaBlended, e1.a5.disabled, e1.a6(p, e1.C.transparent.toPremultipliedRenderColor(null), C), b, E, I, D, null, null, null, [
                _._globeTileDebugTextBuffer
            ]);
        }
        function ut(e1, t1, i, s) {
            ft(e1, 0, t1 + i / 2, e1.transform.width, i, s);
        }
        function pt(e1, t1, i, s) {
            ft(e1, t1 - i / 2, 0, i, e1.transform.height, s);
        }
        function ft(t1, i, s, r, o, n) {
            const a = t1.context, l = a.gl;
            l.enable(l.SCISSOR_TEST), l.scissor(i * e1.e.devicePixelRatio, s * e1.e.devicePixelRatio, r * e1.e.devicePixelRatio, o * e1.e.devicePixelRatio), a.clear({
                color: n
            }), l.disable(l.SCISSOR_TEST);
        }
        function mt(t1, i, s) {
            const r = t1.context, o = r.gl, n = s.projMatrix, a = t1.getOrCreateProgram("debug"), l = i.getTileByID(s.key);
            t1.terrain && t1.terrain.setupElevationDraw(l, a);
            const c = e1.a3.disabled, h = e1.a4.disabled, d = t1.colorModeForRenderPass(), u = "$debug";
            r.activeTexture.set(o.TEXTURE0), t1.emptyTexture.bind(o.LINEAR, o.CLAMP_TO_EDGE);
            const p = l.queryGeometryDebugViz, f = l.queryBoundsDebugViz;
            if (p && p.vertices.length > 0) {
                p.lazyUpload(r);
                const i = p.vertexBuffer, s = p.indexBuffer, l = p.segments;
                null != i && null != s && null != l && a.draw(t1, o.LINE_STRIP, c, h, d, e1.a5.disabled, e1.a6(n, p.color.toPremultipliedRenderColor(null)), u, i, s, l);
            }
            if (f && f.vertices.length > 0) {
                f.lazyUpload(r);
                const i = f.vertexBuffer, s = f.indexBuffer, l = f.segments;
                null != i && null != s && null != l && a.draw(t1, o.LINE_STRIP, c, h, d, e1.a5.disabled, e1.a6(n, f.color.toPremultipliedRenderColor(null)), u, i, s, l);
            }
        }
        const _t = (t1, i, s, r, o, n, a, l)=>{
            const c = e1.ac / n.tileSize;
            return {
                u_matrix: t1,
                u_inv_rot_matrix: i,
                u_camera_to_center_distance: s.getCameraToCenterDistance(l),
                u_extrude_scale: [
                    s.pixelsToGLUnits[0] / c,
                    s.pixelsToGLUnits[1] / c
                ],
                u_zoom_transition: r,
                u_tile_id: a,
                u_merc_center: o
            };
        }, gt = (e1, t1, i, s)=>({
                u_matrix: e1,
                u_inv_matrix: t1,
                u_camera_to_center_distance: i.getCameraToCenterDistance(s),
                u_viewport_size: [
                    i.width,
                    i.height
                ]
            });
        let yt;
        const vt = (e1, t1, i, s, r, o)=>({
                u_viewport_size: e1,
                u_color: t1,
                u_outline_width: i,
                u_opacity: s,
                u_stroke_opacity: r,
                u_collision_padding_opacity: o
            }), bt = [
            {
                status: 1,
                color: new e1.C(1, 0, 0, 1).toPremultipliedRenderColor(null)
            },
            {
                status: 2,
                color: new e1.C(1, 1, 0, 1).toPremultipliedRenderColor(null)
            },
            {
                status: 3,
                color: new e1.C(1, 0, 1, 1).toPremultipliedRenderColor(null)
            },
            {
                status: 0,
                color: new e1.C(0, 0, 1, 1).toPremultipliedRenderColor(null)
            }
        ];
        function xt(e1, t1, i, s, r, o) {
            let n, a, l, c, h;
            "box" === s.kind ? (n = .5 * (s.left + s.right), a = .5 * (s.top + s.bottom), l = .5 * (s.right - s.left), c = .5 * (s.bottom - s.top), h = 0) : (n = s.x, a = s.y, l = s.radius, c = s.radius, h = 1);
            const d = i.prepareSegment(4, e1, t1), u = d.vertexLength;
            for(let t1 = 0; t1 < 4; t1++)e1.emplaceBack(n * o, a * o, l * o, c * o, r * o, h, t1);
            t1.emplaceBack(u, u + 1, u + 2), t1.emplaceBack(u, u + 2, u + 3), d.vertexLength += 4, d.primitiveLength += 2;
        }
        const wt = {
            loaded: !0,
            validateStyle: function(t1, i = e1.s) {
                return Ge(Ve(t1, i));
            },
            validateSource: (e1)=>Ge(Le(e1)),
            validateLight: (e1)=>Ge(Fe(e1)),
            validateLights: (e1)=>Ge(Oe(e1)),
            validateTerrain: (e1)=>Ge(ke(e1)),
            validateFog: (e1)=>Ge(Be(e1)),
            validateSnow: (t1)=>Ge(function(t1) {
                    const i = t1.value, s = t1.style, r = t1.styleSpec, o = r.snow;
                    if (void 0 === i) return [];
                    if (!e1.v(i)) return [
                        new de("snow", i, `object expected, ${e1.y(i)} found`)
                    ];
                    let n = [];
                    for(const t1 in i){
                        const a = t1.match(e1.V);
                        n = n.concat(a && o[a[1]] && o[a[1]].transition ? Ue({
                            key: t1,
                            value: i[t1],
                            valueSpec: r.transition,
                            style: s,
                            styleSpec: r
                        }) : o[t1] ? Ue({
                            key: t1,
                            value: i[t1],
                            valueSpec: o[t1],
                            style: s,
                            styleSpec: r
                        }) : [
                            new ue(t1, i[t1], `unknown property "${t1}"`)
                        ]);
                    }
                    return n;
                }(t1)),
            validateRain: (t1)=>Ge(function(t1) {
                    const i = t1.value, s = t1.style, r = t1.styleSpec, o = r.rain;
                    if (void 0 === i) return [];
                    if (!e1.v(i)) return [
                        new de("rain", i, `object expected, ${e1.y(i)} found`)
                    ];
                    let n = [];
                    for(const t1 in i){
                        const a = t1.match(e1.V);
                        n = n.concat(a && o[a[1]] && o[a[1]].transition ? Ue({
                            key: t1,
                            value: i[t1],
                            valueSpec: r.transition,
                            style: s,
                            styleSpec: r
                        }) : o[t1] ? Ue({
                            key: t1,
                            value: i[t1],
                            valueSpec: o[t1],
                            style: s,
                            styleSpec: r
                        }) : [
                            new ue(t1, i[t1], `unknown property "${t1}"`)
                        ]);
                    }
                    return n;
                }(t1)),
            validateLayer: (e1)=>Ge(Ie(e1)),
            validateFilter: (e1)=>Ge(xe(e1)),
            validatePaintProperty: (e1)=>Ge(Ce(e1)),
            validateLayoutProperty: (e1)=>Ge(Ee(e1)),
            validateModel: (e1)=>Ge(Me(e1)),
            diffStyles: function(t1, i) {
                if (!t1) return [
                    {
                        command: qe,
                        args: [
                            i
                        ]
                    }
                ];
                let s = [];
                try {
                    if (!e1.Y(t1.version, i.version)) return [
                        {
                            command: qe,
                            args: [
                                i
                            ]
                        }
                    ];
                    if (e1.Y(t1.center, i.center) || s.push({
                        command: "setCenter",
                        args: [
                            i.center
                        ]
                    }), e1.Y(t1.zoom, i.zoom) || s.push({
                        command: "setZoom",
                        args: [
                            i.zoom
                        ]
                    }), e1.Y(t1.bearing, i.bearing) || s.push({
                        command: "setBearing",
                        args: [
                            i.bearing
                        ]
                    }), e1.Y(t1.pitch, i.pitch) || s.push({
                        command: "setPitch",
                        args: [
                            i.pitch
                        ]
                    }), e1.Y(t1.sprite, i.sprite) || s.push({
                        command: "setSprite",
                        args: [
                            i.sprite
                        ]
                    }), e1.Y(t1.glyphs, i.glyphs) || s.push({
                        command: "setGlyphs",
                        args: [
                            i.glyphs
                        ]
                    }), e1.Y(t1.imports, i.imports) || function(t1 = [], i = [], s) {
                        i = i || [];
                        const r = (t1 = t1 || []).map(rt), o = i.map(rt), n = t1.reduce(ot, {}), a = i.reduce(ot, {}), l = r.slice();
                        let c, h, d, u;
                        for(c = 0, h = 0; c < r.length; c++)d = r[c], Object.hasOwn(a, d) ? h++ : (s.push({
                            command: Ye,
                            args: [
                                d
                            ]
                        }), l.splice(l.indexOf(d, h), 1));
                        for(c = 0, h = 0; c < o.length; c++)d = o[o.length - 1 - c], l[l.length - 1 - c] !== d && (Object.hasOwn(n, d) ? (s.push({
                            command: Ye,
                            args: [
                                d
                            ]
                        }), l.splice(l.lastIndexOf(d, l.length - h), 1)) : h++, u = l[l.length - c], s.push({
                            command: "addImport",
                            args: [
                                a[d],
                                u
                            ]
                        }), l.splice(l.length - c, 0, d));
                        for (const t1 of i){
                            const i = n[t1.id];
                            i && (delete i.data, e1.Y(i, t1) || s.push({
                                command: "updateImport",
                                args: [
                                    t1.id,
                                    t1
                                ]
                            }));
                        }
                    }(t1.imports, i.imports, s), e1.Y(t1.transition, i.transition) || s.push({
                        command: "setTransition",
                        args: [
                            i.transition
                        ]
                    }), e1.Y(t1.light, i.light) || s.push({
                        command: "setLight",
                        args: [
                            i.light
                        ]
                    }), e1.Y(t1.fog, i.fog) || s.push({
                        command: "setFog",
                        args: [
                            i.fog
                        ]
                    }), e1.Y(t1.snow, i.snow) || s.push({
                        command: "setSnow",
                        args: [
                            i.snow
                        ]
                    }), e1.Y(t1.rain, i.rain) || s.push({
                        command: "setRain",
                        args: [
                            i.rain
                        ]
                    }), e1.Y(t1.projection, i.projection) || s.push({
                        command: "setProjection",
                        args: [
                            i.projection
                        ]
                    }), e1.Y(t1.lights, i.lights) || s.push({
                        command: "setLights",
                        args: [
                            i.lights
                        ]
                    }), e1.Y(t1.camera, i.camera) || s.push({
                        command: "setCamera",
                        args: [
                            i.camera
                        ]
                    }), e1.Y(t1.iconsets, i.iconsets) || function(t1, i, s) {
                        let r;
                        for(r in i = i || {}, t1 = t1 || {})Object.hasOwn(t1, r) && (Object.hasOwn(i, r) || s.push({
                            command: Qe,
                            args: [
                                r
                            ]
                        }));
                        for(r in i){
                            if (!Object.hasOwn(i, r)) continue;
                            const o = i[r];
                            Object.hasOwn(t1, r) ? e1.Y(t1[r], o) || (s.push({
                                command: Qe,
                                args: [
                                    r
                                ]
                            }), s.push({
                                command: Ke,
                                args: [
                                    r,
                                    o
                                ]
                            })) : s.push({
                                command: Ke,
                                args: [
                                    r,
                                    o
                                ]
                            });
                        }
                    }(t1.iconsets, i.iconsets, s), !e1.Y(t1["color-theme"], i["color-theme"])) return [
                        {
                            command: qe,
                            args: [
                                i
                            ]
                        }
                    ];
                    const r = {}, o = [];
                    !function(t1, i, s, r) {
                        let o;
                        for(o in i = i || {}, t1 = t1 || {})Object.hasOwn(t1, o) && (Object.hasOwn(i, o) || et(o, s, r));
                        for(o in i){
                            if (!Object.hasOwn(i, o)) continue;
                            const n = i[o];
                            Object.hasOwn(t1, o) ? e1.Y(t1[o], n) || ("geojson" === t1[o].type && "geojson" === n.type && it(t1, i, o) ? s.push({
                                command: "setGeoJSONSourceData",
                                args: [
                                    o,
                                    n.data
                                ]
                            }) : tt(o, i, s, r)) : Je(o, i, s);
                        }
                    }(t1.sources, i.sources, o, r);
                    const n = [];
                    t1.layers && t1.layers.forEach((e1)=>{
                        e1.source && r[e1.source] ? s.push({
                            command: Ze,
                            args: [
                                e1.id
                            ]
                        }) : n.push(e1);
                    });
                    let a = t1.terrain;
                    a && r[a.source] && (s.push({
                        command: Xe,
                        args: [
                            void 0
                        ]
                    }), a = void 0), s = s.concat(o), e1.Y(a, i.terrain) || s.push({
                        command: Xe,
                        args: [
                            i.terrain
                        ]
                    }), function(t1, i, s) {
                        i = i || [];
                        const r = (t1 = t1 || []).map(rt), o = i.map(rt), n = t1.reduce(ot, {}), a = i.reduce(ot, {}), l = r.slice(), c = Object.create(null);
                        let h, d, u, p, f, m, _;
                        for(h = 0, d = 0; h < r.length; h++)u = r[h], Object.hasOwn(a, u) ? d++ : (s.push({
                            command: Ze,
                            args: [
                                u
                            ]
                        }), l.splice(l.indexOf(u, d), 1));
                        for(h = 0, d = 0; h < o.length; h++)u = o[o.length - 1 - h], l[l.length - 1 - h] !== u && (Object.hasOwn(n, u) ? (s.push({
                            command: Ze,
                            args: [
                                u
                            ]
                        }), l.splice(l.lastIndexOf(u, l.length - d), 1)) : d++, m = l[l.length - h], s.push({
                            command: $e,
                            args: [
                                a[u],
                                m
                            ]
                        }), l.splice(l.length - h, 0, u), c[u] = !0);
                        for(h = 0; h < o.length; h++)if (u = o[h], p = n[u], f = a[u], !c[u] && !e1.Y(p, f)) {
                            if (e1.Y(p.source, f.source) && e1.Y(p["source-layer"], f["source-layer"]) && e1.Y(p.type, f.type)) {
                                for(_ in st(p.layout, f.layout, s, u, null, "setLayoutProperty"), st(p.paint, f.paint, s, u, null, We), e1.Y(p.slot, f.slot) || s.push({
                                    command: "setSlot",
                                    args: [
                                        u,
                                        f.slot
                                    ]
                                }), e1.Y(p.filter, f.filter) || s.push({
                                    command: "setFilter",
                                    args: [
                                        u,
                                        f.filter
                                    ]
                                }), e1.Y(p.minzoom, f.minzoom) && e1.Y(p.maxzoom, f.maxzoom) || s.push({
                                    command: "setLayerZoomRange",
                                    args: [
                                        u,
                                        f.minzoom,
                                        f.maxzoom
                                    ]
                                }), p)Object.hasOwn(p, _) && "layout" !== _ && "paint" !== _ && "filter" !== _ && "metadata" !== _ && "minzoom" !== _ && "maxzoom" !== _ && "slot" !== _ && (0 === _.indexOf("paint.") ? st(p[_], f[_], s, u, _.slice(6), We) : e1.Y(p[_], f[_]) || s.push({
                                    command: He,
                                    args: [
                                        u,
                                        _,
                                        f[_]
                                    ]
                                }));
                                for(_ in f)Object.hasOwn(f, _) && !Object.hasOwn(p, _) && "layout" !== _ && "paint" !== _ && "filter" !== _ && "metadata" !== _ && "minzoom" !== _ && "maxzoom" !== _ && "slot" !== _ && (0 === _.indexOf("paint.") ? st(p[_], f[_], s, u, _.slice(6), We) : e1.Y(p[_], f[_]) || s.push({
                                    command: He,
                                    args: [
                                        u,
                                        _,
                                        f[_]
                                    ]
                                }));
                            } else s.push({
                                command: Ze,
                                args: [
                                    u
                                ]
                            }), m = l[l.lastIndexOf(u) + 1], s.push({
                                command: $e,
                                args: [
                                    f,
                                    m
                                ]
                            });
                        }
                    }(n, i.layers, s);
                } catch (e1) {
                    console.warn("Unable to compute style diff:", e1), s = [
                        {
                            command: qe,
                            args: [
                                i
                            ]
                        }
                    ];
                }
                return s;
            },
            drawDebug: function(t1, i, s, r, o, n) {
                for(let a = 0; a < s.length; a++)if (o) {
                    const o = 1, l = .8, c = new e1.C(r.r * l, r.g * l, r.b * l, 1);
                    dt(t1, i, s[a], r, -o, -o, n), dt(t1, i, s[a], r, -o, o, n), dt(t1, i, s[a], r, o, o, n), dt(t1, i, s[a], r, o, -o, n), dt(t1, i, s[a], c, 0, 0, n);
                } else dt(t1, i, s[a], r, 0, 0, n);
            },
            drawDebugPadding: function(e1) {
                const t1 = e1.transform.padding;
                ut(e1, e1.transform.height - (t1.top || 0), 3, nt), ut(e1, t1.bottom || 0, 3, at), pt(e1, t1.left || 0, 3, lt), pt(e1, e1.transform.width - (t1.right || 0), 3, ct);
                const i = e1.transform.centerPoint;
                !function(e1, t1, i, s) {
                    ft(e1, t1 - 1, i - 10, 2, 20, s), ft(e1, t1 - 10, i - 1, 20, 2, s);
                }(e1, i.x, e1.transform.height - i.y, ht);
            },
            drawDebugQueryGeometry: function(e1, t1, i) {
                for(let s = 0; s < i.length; s++)mt(e1, t1, i[s]);
            },
            drawCollisionDebug: function(t1, i, s, r, o, n, a) {
                const l = t1.context, c = l.gl, h = t1.transform, d = [
                    e1.ad(h.center.lng),
                    e1.ae(h.center.lat)
                ], u = s.layout.get("symbol-placement"), p = s.layout.get("text-variable-anchor"), f = "map" === s.layout.get("icon-rotation-alignment"), m = "map" === s.layout.get("text-rotation-alignment"), _ = "point" !== u, g = [];
                let y = 0, v = 0;
                for(let l = 0; l < r.length; l++){
                    const u = r[l], b = i.getTile(u), x = b.getBucket(s);
                    if (!x) continue;
                    const w = x.getProjection().createInversionMatrix(h, u.canonical), T = [], S = e1.af(u, x, h), C = !a && f && _, E = a && m && _, I = p && x.hasTextData(), D = x.hasIconTextFit() && I && x.hasIconData(), P = C || E || a && I || D, L = "globe" === x.projection.name, R = L ? e1._(h.zoom) : 0;
                    L && (T.push("PROJECTION_GLOBE_VIEW"), P && T.push("PROJECTED_POS_ON_VIEWPORT"));
                    const A = t1.getOrCreateProgram("collisionBox", {
                        defines: T
                    });
                    let M = S;
                    0 === o[0] && 0 === o[1] || (M = t1.translatePosMatrix(S, b, o, n));
                    const F = a ? x.textCollisionBox : x.iconCollisionBox, O = x.collisionCircleArray;
                    if (O.length > 0) {
                        const t1 = e1.a2(), i = M;
                        e1.ag(t1, x.placementInvProjMatrix, h.glCoordMatrix), e1.ag(t1, t1, x.placementViewportMatrix), g.push({
                            circleArray: O,
                            circleOffset: v,
                            transform: i,
                            invTransform: t1,
                            projection: x.getProjection()
                        }), y += O.length / 4, v = y;
                    }
                    if (!F) continue;
                    t1.terrain && t1.terrain.setupElevationDraw(b, A);
                    const k = L ? [
                        u.canonical.x,
                        u.canonical.y,
                        1 << u.canonical.z
                    ] : [
                        0,
                        0,
                        0
                    ];
                    A.draw(t1, c.LINES, e1.a3.disabled, e1.a4.disabled, t1.colorModeForRenderPass(), e1.a5.disabled, _t(M, w, h, R, d, b, k, x.getProjection()), s.id, F.layoutVertexBuffer, F.indexBuffer, F.segments, null, h.zoom, null, [
                        F.collisionVertexBuffer,
                        F.collisionVertexBufferExt
                    ]);
                }
                if (!a || !g.length) return;
                const b = t1.getOrCreateProgram("collisionCircle"), x = new e1.ah;
                x.resize(4 * y), x._trim();
                let w = 0;
                for (const e1 of g)for(let t1 = 0; t1 < e1.circleArray.length / 4; t1++){
                    const i = 4 * t1, s = e1.circleArray[i + 0], r = e1.circleArray[i + 1], o = e1.circleArray[i + 2], n = e1.circleArray[i + 3];
                    x.emplace(w++, s, r, o, n, 0), x.emplace(w++, s, r, o, n, 1), x.emplace(w++, s, r, o, n, 2), x.emplace(w++, s, r, o, n, 3);
                }
                (!yt || yt.length < 2 * y) && (yt = function(t1) {
                    const i = 2 * t1, s = new e1.ak;
                    s.resize(i), s._trim();
                    for(let e1 = 0; e1 < i; e1++){
                        const t1 = 6 * e1;
                        s.uint16[t1 + 0] = 4 * e1 + 0, s.uint16[t1 + 1] = 4 * e1 + 1, s.uint16[t1 + 2] = 4 * e1 + 2, s.uint16[t1 + 3] = 4 * e1 + 2, s.uint16[t1 + 4] = 4 * e1 + 3, s.uint16[t1 + 5] = 4 * e1 + 0;
                    }
                    return s;
                }(y));
                const T = l.createIndexBuffer(yt, !0), S = l.createVertexBuffer(x, e1.ai.members, !0);
                for (const i of g){
                    const r = gt(i.transform, i.invTransform, h, i.projection);
                    b.draw(t1, c.TRIANGLES, e1.a3.disabled, e1.a4.disabled, t1.colorModeForRenderPass(), e1.a5.disabled, r, s.id, S, T, e1.aj.simpleSegment(0, 2 * i.circleOffset, i.circleArray.length, i.circleArray.length / 2), null, h.zoom);
                }
                S.destroy(), T.destroy();
            },
            drawPlacementDebug: function(t1) {
                const i = t1.style.globalPlacement ? t1.style.globalPlacement.debugSymbols() : null;
                if (!i || 0 === i.length) return;
                const s = t1.context, r = s.gl, o = t1.transform, n = e1.e.devicePixelRatio, a = new e1.am, l = new e1.ak, c = bt.map(({ status: t1 })=>{
                    const s = new e1.aj;
                    for (const e1 of i)if (e1.status === t1) for (const t1 of e1.geometry)xt(a, l, s, t1, e1.collisionPadding, n);
                    return s;
                });
                if (0 === a.length) return;
                const h = s.createVertexBuffer(a, e1.an.members, !0), d = s.createIndexBuffer(l, !0), u = t1.getOrCreateProgram("placementDebug"), p = [
                    o.width * n,
                    o.height * n
                ];
                for(let i = 0; i < bt.length; i++){
                    const s = c[i];
                    0 !== s.segments.length && u.draw(t1, r.TRIANGLES, e1.a3.disabled, e1.a4.disabled, e1.a7.alphaBlended, e1.a5.disabled, vt(p, bt[i].color, 1 * n, .07, .65, .4), "$placement-debug", h, d, s, null, o.zoom);
                }
                h.destroy(), d.destroy();
            }
        };
        function Tt() {
            return Promise.resolve();
        }
        function St(t1, i) {
            let s = !1;
            if (i && i.length) for (const r of i)r instanceof ue ? e1.w(r.message) : (t1.fire(new e1.h(new Error(r.message))), s = !0);
            return s;
        }
        function Ct(e1) {
            return (...t1)=>{
                const i = wt[e1];
                return i ? i(...t1) : [];
            };
        }
        const Et = Ct("validateStyle"), It = Ct("validateSource"), Dt = Ct("validateLight"), Pt = Ct("validateLights"), Lt = Ct("validateTerrain"), Rt = Ct("validateFog"), At = Ct("validateSnow"), Mt = Ct("validateRain"), Ft = Ct("validateLayer"), Ot = Ct("validateFilter"), kt = Ct("validatePaintProperty"), Bt = Ct("validateLayoutProperty"), zt = Ct("validateModel");
        class Ut extends e1.E {
            constructor(t1, i, s){
                super(), this.scope = i, this._transitionable = new e1.ao(t1, i, s), this.properties = new e1.ap(t1);
            }
            _setValues(e1, t1) {
                this._values = e1, this._transitionable.setTransitionOrValue(e1, t1 ? new Map(t1) : void 0);
            }
            updateConfig(e1) {
                this._transitionable.setTransitionOrValue(this._values, new Map(e1));
            }
            resetConfig(e1) {
                this.updateConfig(e1), this._transitionable.snap();
            }
            updateTransitions(e1) {
                this._transitionable.updateTransitions(e1);
            }
            hasTransition() {
                return this._transitionable.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitionable.possiblyEvaluate(e1);
            }
            _validate(t1, i, s) {
                return (!s || !1 !== s.validate) && St(this, t1.call(Et, {
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e1.s
                }));
            }
        }
        const Nt = e1.s.light;
        let jt;
        class Vt extends Ut {
            constructor(t1, i = "flat"){
                super(jt || (jt = new e1.aq({
                    anchor: new e1.ar(Nt.anchor),
                    position: new e1.as(Nt.position),
                    color: new e1.ar(Nt.color),
                    intensity: new e1.ar(Nt.intensity)
                }))), this.setLight(t1, i), this._transitionable.snap();
            }
            getLight() {
                return this._transitionable.serialize();
            }
            setLight(e1, t1, i = {}) {
                this._validate(Dt, e1, i) || (this._setValues(e1), this.id = t1);
            }
        }
        const Gt = e1.s.terrain;
        let qt = class extends Ut {
            constructor(t1, i, s, r, o){
                super(new e1.aq({
                    source: new e1.ar(Gt.source),
                    exaggeration: new e1.ar(Gt.exaggeration)
                }), s, r), this._transitionable.setTransitionOrValue(t1, r), this._transitionable.snap(), this.drapeRenderMode = i, this.worldview = o;
            }
            get() {
                return this._transitionable.serialize();
            }
            set(e1, t1) {
                this._transitionable.setTransitionOrValue(e1, t1);
            }
            getExaggeration(t1) {
                return e1.at(this._transitionable._values.exaggeration.state, new e1.au(t1, {
                    worldview: this.worldview
                }));
            }
            getAttenuationRange() {
                if (!this.isZoomDependent()) return null;
                const t1 = this._transitionable._values.exaggeration.value.expression;
                let i = -1, s = -1, r = 1;
                for (const o of t1.zoomStops)r = t1.evaluate(new e1.au(o, {
                    worldview: this.worldview
                })), r > .01 ? (i = o, s = -1) : s = o;
                return r < .01 && i > 0 && s > i ? [
                    i,
                    s
                ] : null;
            }
            isZoomDependent() {
                return this._transitionable._values.exaggeration.value.expression instanceof e1.av;
            }
        };
        function $t(e1, t1) {
            const i = e1 ? e1.terrain : null;
            return !!i && (!t1 || !!t1.projection.requiresDraping || !i.isZoomDependent() || i.getExaggeration(t1.zoom) > 0);
        }
        const Zt = e1.s.fog;
        class Wt extends Ut {
            constructor(t1, i, s, r){
                super(new e1.aq({
                    range: new e1.ar(Zt.range),
                    color: new e1.ar(Zt.color),
                    "color-use-theme": new e1.ar({
                        type: "string",
                        "property-type": "data-constant",
                        default: "default"
                    }),
                    "high-color": new e1.ar(Zt["high-color"]),
                    "high-color-use-theme": new e1.ar({
                        type: "string",
                        "property-type": "data-constant",
                        default: "default"
                    }),
                    "space-color": new e1.ar(Zt["space-color"]),
                    "space-color-use-theme": new e1.ar({
                        type: "string",
                        "property-type": "data-constant",
                        default: "default"
                    }),
                    "horizon-blend": new e1.ar(Zt["horizon-blend"]),
                    "star-intensity": new e1.ar(Zt["star-intensity"]),
                    "vertical-range": new e1.ar(Zt["vertical-range"])
                }), s, new Map(r)), this._transform = i, this.set(t1), this._transitionable.snap();
            }
            get state() {
                const t1 = this._transform, i = "globe" === t1.projection.name, s = e1._(t1.zoom), r = this.properties.get("range"), o = [
                    2,
                    4.5
                ], n = .5 / Math.tan(.5 * t1._fov), a = [
                    r[0] + n,
                    r[1] + n
                ];
                return {
                    range: i ? [
                        e1.aw(o[0], a[0], s),
                        e1.aw(o[1], a[1], s)
                    ] : a,
                    horizonBlend: this.properties.get("horizon-blend"),
                    alpha: this.properties.get("color").a
                };
            }
            get() {
                return this._transitionable.serialize();
            }
            set(e1, t1, i = {}) {
                if (this._validate(Rt, e1, i)) return;
                const s = {
                    ...e1
                };
                for (const e1 of Object.keys(Zt))void 0 === s[e1] && (s[e1] = Zt[e1].default);
                this._setValues(s, t1);
            }
            getOpacity(t1) {
                if (!this._transform.projection.supportsFog) return 0;
                const i = this.properties && this.properties.get("color") || 1;
                return ("globe" === this._transform.projection.name ? 1 : e1.ax(e1.az, e1.ay, t1)) * i.a;
            }
            getOpacityAtLatLng(t1, i) {
                return this._transform.projection.supportsFog ? e1.aA(this.state, t1, i) : 0;
            }
            getOpacityForTile(t1) {
                if (!this._transform.projection.supportsFog) return [
                    1,
                    1
                ];
                const i = this._transform.calculateFogTileMatrix(t1.toUnwrapped());
                return e1.aB(this.state, i, 0, 0, e1.ac, e1.ac, this._transform);
            }
            getOpacityForBounds(t1, i, s, r, o) {
                return this._transform.projection.supportsFog ? e1.aB(this.state, t1, i, s, r, o, this._transform) : [
                    1,
                    1
                ];
            }
            getRangeForProjection() {
                return this._transform.projection.supportsFog ? this.state.range : [
                    0,
                    1
                ];
            }
            isVisibleOnFrustum(t1) {
                if (!this._transform.projection.supportsFog) return !1;
                const i = [
                    4,
                    5,
                    6,
                    7
                ];
                for (const s of i){
                    const i = t1.points[s];
                    let r;
                    if (i[2] >= 0) r = i;
                    else {
                        const o = t1.points[s - 4];
                        r = e1.aC(o, i, o[2] / (o[2] - i[2]));
                    }
                    if (e1.aD(this.state, r[0], r[1], 0, this._transform) >= e1.aE) return !0;
                }
                return !1;
            }
        }
        let Ht, Xt, Yt = class extends Ut {
            constructor(t1, i, s, r){
                super(Ht || (Ht = new e1.aq({
                    density: new e1.ar(e1.s.snow.density),
                    intensity: new e1.ar(e1.s.snow.intensity),
                    color: new e1.ar(e1.s.snow.color),
                    opacity: new e1.ar(e1.s.snow.opacity),
                    vignette: new e1.ar(e1.s.snow.vignette),
                    "vignette-color": new e1.ar(e1.s.snow["vignette-color"]),
                    "center-thinning": new e1.ar(e1.s.snow["center-thinning"]),
                    direction: new e1.ar(e1.s.snow.direction),
                    "flake-size": new e1.ar(e1.s.snow["flake-size"])
                })), s, new Map(r)), this.set(t1), this._transitionable.snap();
            }
            get state() {
                const t1 = this.properties.get("opacity"), i = this.properties.get("color"), s = this.properties.get("direction"), r = e1.aF(s[0]), o = -Math.max(e1.aF(s[1]), .01), n = [
                    Math.cos(r) * Math.cos(o),
                    Math.sin(r) * Math.cos(o),
                    Math.sin(o)
                ], a = this.properties.get("vignette"), l = this.properties.get("vignette-color"), c = new e1.C(l.r, l.g, l.b, a);
                return {
                    density: this.properties.get("density"),
                    intensity: this.properties.get("intensity"),
                    color: new e1.C(i.r, i.g, i.b, i.a * t1),
                    direction: n,
                    centerThinning: this.properties.get("center-thinning"),
                    flakeSize: this.properties.get("flake-size"),
                    vignetteColor: c
                };
            }
            get() {
                return this._transitionable.serialize();
            }
            set(t1, i, s = {}) {
                if (this._validate(At, t1, s)) return;
                const r = {
                    ...t1
                }, o = e1.s.snow;
                for (const e1 of Object.keys(o))void 0 === r[e1] && (r[e1] = o[e1].default);
                this._setValues(r, i);
            }
        }, Kt = class extends Ut {
            constructor(t1, i, s, r){
                super(Xt || (Xt = new e1.aq({
                    density: new e1.ar(e1.s.rain.density),
                    intensity: new e1.ar(e1.s.rain.intensity),
                    color: new e1.ar(e1.s.rain.color),
                    opacity: new e1.ar(e1.s.rain.opacity),
                    vignette: new e1.ar(e1.s.rain.vignette),
                    "vignette-color": new e1.ar(e1.s.rain["vignette-color"]),
                    "center-thinning": new e1.ar(e1.s.rain["center-thinning"]),
                    direction: new e1.ar(e1.s.rain.direction),
                    "droplet-size": new e1.ar(e1.s.rain["droplet-size"]),
                    "distortion-strength": new e1.ar(e1.s.rain["distortion-strength"])
                })), s, new Map(r)), this.set(t1), this._transitionable.snap();
            }
            get state() {
                const t1 = this.properties.get("opacity"), i = this.properties.get("color"), s = this.properties.get("direction"), r = e1.aF(s[0]), o = -Math.max(e1.aF(s[1]), .01), n = [
                    Math.cos(r) * Math.cos(o),
                    Math.sin(r) * Math.cos(o),
                    Math.sin(o)
                ], a = this.properties.get("vignette-color"), l = new e1.C(a.r, a.g, a.b, this.properties.get("vignette"));
                return {
                    density: this.properties.get("density"),
                    intensity: this.properties.get("intensity"),
                    color: new e1.C(i.r, i.g, i.b, i.a * t1),
                    direction: n,
                    centerThinning: this.properties.get("center-thinning"),
                    dropletSize: this.properties.get("droplet-size"),
                    distortionStrength: this.properties.get("distortion-strength"),
                    vignetteColor: l
                };
            }
            get() {
                return this._transitionable.serialize();
            }
            set(t1, i, s = {}) {
                if (this._validate(Mt, t1, s)) return;
                const r = {
                    ...t1
                }, o = e1.s.rain;
                for (const e1 of Object.keys(o))void 0 === r[e1] && (r[e1] = o[e1].default);
                this._setValues(r, i);
            }
        };
        const Qt = {
            workerUrl: "",
            workerClass: null,
            workerParams: void 0
        };
        function Jt(e1) {
            return null != Qt.workerClass ? new Qt.workerClass : new self.Worker(Qt.workerUrl, {
                name: e1,
                type: "module",
                ...Qt.workerParams
            });
        }
        const ei = "mapboxgl_preloaded_worker_pool";
        class ti {
            constructor(e1){
                this.active = {}, this.workers = null, this.name = e1;
            }
            acquire(e1, t1 = ti.workerCount) {
                if (!this.workers) for(this.workers = []; this.workers.length < t1;){
                    const t1 = Jt(`${this.name || ""}WorkerPool: ${e1}-${this.workers.length}`);
                    this.workers.push(t1);
                }
                return this.active[e1] = !0, this.workers.slice();
            }
            release(e1) {
                delete this.active[e1], this.workers && 0 === this.numActive() && (this.workers.forEach((e1)=>{
                    e1.terminate();
                }), this.workers = null);
            }
            isPreloaded() {
                return !!this.active[ei];
            }
            numActive() {
                return Object.keys(this.active).length;
            }
        }
        ti.workerCount = 2;
        class ii {
            constructor(t1, i, s = "Worker", r = ti.workerCount){
                this.workerPool = t1, this.actors = [], this.currentActor = 0, this.id = e1.aG();
                const o = this.workerPool.acquire(this.id, r);
                for(let e1 = 0; e1 < o.length; e1++){
                    const t1 = new ii.Actor(o[e1], i, this.id);
                    t1.name = `${s} ${e1}`, this.actors.push(t1);
                }
                this.ready = !1, this.send("checkIfReady", null).then(()=>{
                    this.ready = !0;
                }).catch(()=>{});
            }
            send(e1, t1, i) {
                return Promise.all(this.actors.map((s)=>s.send(e1, t1, i)));
            }
            broadcast(e1, t1) {
                for (const i of this.actors)i.notify(e1, t1);
            }
            getActor() {
                return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
            }
            remove() {
                this.actors.forEach((e1)=>{
                    e1.remove();
                }), this.actors = [], this.workerPool.release(this.id);
            }
        }
        ii.Actor = e1.aH;
        class si extends Ut {
            constructor(e1, t1, i, s){
                super(t1, i, new Map(s)), this.set(e1), this._transitionable.snap();
            }
            get() {
                return this._options.properties = this._transitionable.serialize(), this._options;
            }
            set(e1, t1) {
                this._options = e1, this._setValues(e1.properties, t1);
            }
            shadowsEnabled() {
                return !!this.properties && !0 === this.properties.get("cast-shadows");
            }
        }
        let ri;
        const oi = ()=>ri || (ri = new e1.aq({
                color: new e1.ar(e1.s.properties_light_ambient.color),
                "color-use-theme": new e1.ar({
                    type: "string",
                    default: "default",
                    "property-type": "data-constant"
                }),
                intensity: new e1.ar(e1.s.properties_light_ambient.intensity)
            }));
        let ni;
        const ai = ()=>ni || (ni = new e1.aq({
                direction: new e1.aI(e1.s.properties_light_directional.direction),
                color: new e1.ar(e1.s.properties_light_directional.color),
                "color-use-theme": new e1.ar({
                    type: "string",
                    default: "default",
                    "property-type": "data-constant"
                }),
                intensity: new e1.ar(e1.s.properties_light_directional.intensity),
                "cast-shadows": new e1.ar(e1.s.properties_light_directional["cast-shadows"]),
                "shadow-quality": new e1.ar(e1.s.properties_light_directional["shadow-quality"]),
                "shadow-intensity": new e1.ar(e1.s.properties_light_directional["shadow-intensity"]),
                "shadow-draw-before-layer": new e1.ar(e1.s.properties_light_directional["shadow-draw-before-layer"])
            })), li = (e1, t1, i, s, r, o, n, a, l, c = [
            0,
            0,
            1
        ])=>({
                u_matrix: e1,
                u_normal_matrix: t1,
                u_opacity: i,
                u_faux_facade_ao_intensity: s,
                u_camera_pos: r,
                u_tile_to_meter: o,
                u_facade_emissive_chance: n,
                u_flood_light_color: a,
                u_flood_light_intensity: l,
                u_front_cutoff_params: c
            }), ci = (e1)=>({
                u_matrix: e1
            }), hi = (e1)=>({
                u_matrix: e1
            }), di = e1.aJ;
        async function ui() {
            return Promise.resolve();
        }
        function pi(t1, i, s, r, o, n, a, l) {
            s.resetLayerRenderingStats(t1);
            const c = t1.context, h = c.gl, d = t1.transform, u = s.paint.get("fill-extrusion-pattern"), p = s.paint.get("fill-extrusion-pattern-cross-fade"), f = u.constantOr(null), m = u.constantOr(1), _ = s.paint.get("fill-extrusion-opacity"), g = t1.style.enable3dLights(), y = s.paint.get(g && !m ? "fill-extrusion-ambient-occlusion-wall-radius" : "fill-extrusion-ambient-occlusion-radius"), v = [
                s.paint.get("fill-extrusion-ambient-occlusion-intensity"),
                y
            ], b = s.layout.get("fill-extrusion-edge-radius"), x = b > 0 && !s.paint.get("fill-extrusion-rounded-roof"), w = x ? 0 : b, T = "globe" === d.projection.name ? e1.aO() : 0, S = "globe" === d.projection.name, C = S ? e1._(d.zoom) : 0, E = [
                e1.ad(d.center.lng),
                e1.ae(d.center.lat)
            ], I = "none" === s.paint.get("fill-extrusion-flood-light-color-use-theme").constantOr("default"), D = s.paint.get("fill-extrusion-flood-light-color").toNonPremultipliedRenderColor(I ? null : s.lut).toArray01().slice(0, 3), P = s.paint.get("fill-extrusion-flood-light-intensity"), L = s.paint.get("fill-extrusion-vertical-scale"), R = 0 !== s.paint.get("fill-extrusion-line-width").constantOr(1), A = s.paint.get("fill-extrusion-height-alignment"), M = s.paint.get("fill-extrusion-base-alignment"), F = e1.aP(t1, s.paint.get("fill-extrusion-cutoff-fade-range")), O = s.paint.get("fill-extrusion-front-cutoff"), k = mi(d.pitch, O, !!t1.terrain), B = k[2] < 1;
            B && (t1.maxFrontCutoffRawStart = Math.max(t1.maxFrontCutoffRawStart, O[0]));
            const z = [];
            let U;
            S && z.push("PROJECTION_GLOBE_VIEW"), v[0] > 0 && z.push("FAUX_AO"), x && z.push("ZERO_ROOF_RADIUS"), l && z.push("HAS_CENTROID"), P > 0 && z.push("FLOOD_LIGHT"), F.shouldRenderCutoff && z.push("RENDER_CUTOFF"), B && z.push("RENDER_FRONT_CUTOFF"), R && z.push("RENDER_WALL_MODE");
            const N = "shadow" === t1.renderPass, j = t1.shadowRenderer, V = N && !!j, G = N ? e1.a5.disabled : e1.a5.backCCW;
            t1.shadowRenderer && (t1.shadowRenderer.useNormalOffset = !0);
            let q = [
                0,
                0,
                0
            ];
            if (j) {
                const i = t1.style.directionalLight, s = t1.style.ambientLight;
                i && s && (q = e1.aQ(t1.style, i, s)), N || (z.push("RENDER_SHADOWS"), j.useNormalOffset && z.push("NORMAL_OFFSET")), U = z.concat([
                    "SHADOWS_SINGLE_CASCADE"
                ]);
            }
            const $ = V ? "fillExtrusionDepth" : m ? "fillExtrusionPattern" : "fillExtrusion", Z = s.getLayerRenderingStats();
            for (const u of r){
                const r = i.getTile(u), g = r.getBucket(s);
                if (!g || g.projection.name !== d.projection.name) continue;
                let y = !1;
                j && (y = 0 === j.getMaxCascadeForTile(u.toUnwrapped()));
                const b = t1.isTileAffectedByFog(u), x = g.programConfigurations.get(s.id);
                let I = !1;
                if (f && r.imageAtlas) {
                    const t1 = r.imageAtlas, i = e1.aR.from(f), s = i.getPrimary().scaleSelf(e1.e.devicePixelRatio).toString(), o = i.getSecondary(), n = t1.patternPositions.get(s), a = o ? t1.patternPositions.get(o.scaleSelf(e1.e.devicePixelRatio).toString()) : null;
                    I = !!n && !!a, n && x.setConstantPatternPositions(n, a);
                }
                p > 0 && (I || x.getPatternTransitionVertexBuffer("fill-extrusion-pattern")) && z.push("FILL_EXTRUSION_PATTERN_TRANSITION");
                const O = t1.getOrCreateProgram($, {
                    config: x,
                    defines: y ? U : z,
                    overrideFog: b
                });
                if (t1.terrain && t1.terrain.setupElevationDraw(r, O, {
                    useMeterToDem: !0
                }), !g.centroidVertexBuffer) {
                    const e1 = O.getAttributeLocation(h, "a_centroid_pos");
                    -1 !== e1 && h.vertexAttribI4ui(e1, 0, 0, 0, 0);
                }
                !N && j && j.setupShadows(r.tileID.toUnwrapped(), O, "vector-tile"), m && (t1.context.activeTexture.set(h.TEXTURE0), r.imageAtlasTexture && r.imageAtlasTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE), x.updatePaintBuffers());
                const B = s.paint.get("fill-extrusion-vertical-gradient"), V = 1 / g.tileToMeter;
                let W;
                if (N && j) {
                    if (bi(r.tileID, g.maxHeight, t1)) continue;
                    const i = j.calculateShadowPassMatrixFromTile(r.tileID.toUnwrapped());
                    W = e1.aX(i, w, V, L, A, M);
                } else {
                    const i = t1.translatePosMatrix(u.expandedProjMatrix, r, s.paint.get("fill-extrusion-translate"), s.paint.get("fill-extrusion-translate-anchor")), o = d.projection.createInversionMatrix(d, u.canonical), n = O.fixedDefines.includes("LIGHTING_3D_MODE");
                    W = m ? e1.aS(i, t1, B, _, v, w, V, u, r, T, A, M, C, E, o, D, L, p, n) : e1.aT(i, t1, B, _, v, w, V, u, T, A, M, C, E, o, D, L, P, q, k, n);
                }
                t1.uploadCommonUniforms(c, O, u.toUnwrapped(), null, F);
                let H = g.segments;
                if ("mercator" === d.projection.name && !N && (H = g.getVisibleSegments(r.tileID, t1.terrain, t1.transform.getFrustum(0)), !H.get().length)) continue;
                if (Z) {
                    if (N) for (const e1 of H.get())Z.numRenderedVerticesInShadowPass += e1.primitiveLength;
                    else for (const e1 of H.get())Z.numRenderedVerticesInTransparentPass += e1.primitiveLength;
                }
                const X = [];
                (t1.terrain || l) && X.push(g.centroidVertexBuffer), S && X.push(g.layoutVertexExtBuffer), R && X.push(g.wallVertexBuffer), O.draw(t1, c.gl.TRIANGLES, o, n, a, G, W, s.id, g.layoutVertexBuffer, g.indexBuffer, H, s.paint, t1.transform.zoom, x, X);
            }
            t1.shadowRenderer && (t1.shadowRenderer.useNormalOffset = !1);
        }
        class fi {
            constructor(){
                this.translate = [
                    0,
                    0
                ], this.translateAnchor = "map", this.edgeRadius = 0, this.cutoffFadeRange = 0;
            }
        }
        function mi(e1, t1, i) {
            if (!(t1[2] < 1) || i) return [
                0,
                0,
                1
            ];
            const s = 180 * e1 / Math.PI;
            if (s < 15) return [
                -0.5,
                t1[1],
                t1[2]
            ];
            const r = Math.min(1, Math.max(0, (s - 15) / 5)), o = r * r * (3 - 2 * r);
            return [
                -0.5 * (1 - o) + t1[0] * o,
                t1[1],
                t1[2]
            ];
        }
        function _i(t1, i, s, r, o, n, a) {
            0 === r.centroidVertexArray.length && r.createCentroidsBuffer();
            const l = n ? n.findDEMTileFor(s) : null;
            if (!(l && l.dem || a)) return;
            n && l && l.dem && r.selfDEMTileTimestamp !== l.dem._timestamp && (r.borderDoneWithNeighborZ = [
                -1,
                -1,
                -1,
                -1
            ], r.selfDEMTileTimestamp = l.dem._timestamp);
            const c = (t1, i)=>{
                (t1.flags | i.flags) & e1.aU ? (t1.flags |= e1.aU, i.flags |= e1.aU) : (t1.flags &= ~e1.aU, i.flags &= ~e1.aU);
            }, h = (t1)=>new e1.P(Math.ceil((t1 + e1.aV) * e1.aW), 0), d = (t1, i, s)=>{
                const r = Math.ceil((t1 + e1.aV) * e1.aW), o = Math.floor(Math.max(0, Math.min(e1.ac - 1, s)) / 4);
                return new e1.P(r, o << 5 | (3 & i) << 3 | 7);
            }, u = (t1, i)=>{
                const s = Number.MAX_VALUE, r = i[0][0] !== s, o = i[1][0] !== s, n = i[2][0] !== s, a = i[3][0] !== s;
                if (!((r ? 1 : 0) + (o ? 1 : 0) + (n ? 1 : 0) + (a ? 1 : 0) > 2)) return t1 < 2 ? n === a ? void 0 : n ? 0 : e1.ac - 1 : r === o ? void 0 : r ? 0 : e1.ac - 1;
            }, p = (e1, t1, i, s)=>(t1 ? u(e1, t1) : void 0) ?? (s ? u(i, s) : void 0), f = (e1)=>{
                const t1 = i.getSource().minzoom, s = (e1)=>{
                    const t1 = i.getTileByID(e1);
                    if (t1 && t1.hasData()) return t1.getBucket(o);
                }, r = [
                    0,
                    -1,
                    1
                ];
                for (const i of r){
                    if (e1.overscaledZ + i < t1) continue;
                    const r = s(e1.calculateScaledKey(e1.overscaledZ + i));
                    if (r) return r;
                }
            }, m = [
                0,
                0,
                0
            ], _ = (t1, i)=>(m[0] = Math.min(t1.min.y, i.min.y), m[1] = Math.max(t1.max.y, i.max.y), m[2] = e1.ac - i.min.x > t1.max.x ? i.min.x - e1.ac : t1.max.x, m), g = (t1, i)=>(m[0] = Math.min(t1.min.x, i.min.x), m[1] = Math.max(t1.max.x, i.max.x), m[2] = e1.ac - i.min.y > t1.max.y ? i.min.y - e1.ac : t1.max.y, m), y = [
                (e1, t1)=>_(e1, t1),
                (e1, t1)=>_(t1, e1),
                (e1, t1)=>g(e1, t1),
                (e1, t1)=>g(t1, e1)
            ], v = (t1, i, r, o, a, c, h)=>{
                if (!n) return 0;
                const d = [
                    [
                        c ? r : t1,
                        c ? t1 : r,
                        0
                    ],
                    [
                        c ? r : i,
                        c ? i : r,
                        0
                    ]
                ], u = h < 0 ? e1.ac + h : h, p = [
                    c ? u : (t1 + i) / 2,
                    c ? (t1 + i) / 2 : u,
                    0
                ];
                return 0 === r && h < 0 || 0 !== r && h > 0 ? n.getForTilePoints(a, [
                    p
                ], !0, o) : d.push(p), n.getForTilePoints(s, d, !0, l), Math.max(d[0][2], d[1][2], p[2]) / n.exaggeration();
            };
            for(let t1 = 0; t1 < 4; t1++){
                const i = r.borderFeatureIndices[t1];
                if (0 === i.length) continue;
                const o = e1.aM[t1](s), l = f(o);
                if (!(l && l instanceof e1.aN)) continue;
                const u = n ? n.findDEMTileFor(o) : null;
                if (!(u && u.dem || a)) continue;
                if (n && u && u.dem && r.borderDEMTileTimestamp[t1] !== u.dem._timestamp && (r.borderDoneWithNeighborZ[t1] = -1, r.borderDEMTileTimestamp[t1] = u.dem._timestamp), r.borderDoneWithNeighborZ[t1] === l.canonical.z) continue;
                0 === l.centroidVertexArray.length && l.createCentroidsBuffer();
                const m = (t1 < 2 ? 1 : 5) - t1, _ = l.borderDoneWithNeighborZ[m] !== r.canonical.z, g = l.borderFeatureIndices[m];
                let b = 0;
                if (r.canonical.z !== l.canonical.z) {
                    for (const e1 of i)r.showCentroid(r.featuresOnBorder[e1], "discard");
                    if (_) for (const e1 of g)l.showCentroid(l.featuresOnBorder[e1], "discard");
                    r.borderDoneWithNeighborZ[t1] = l.canonical.z, l.borderDoneWithNeighborZ[m] = r.canonical.z;
                    continue;
                }
                const x = new Map, w = new Set, T = new Set;
                for(let e1 = 0; e1 < g.length; e1++){
                    const t1 = l.featuresOnBorder[g[e1]];
                    void 0 !== t1.buildingId && x.set(t1.buildingId, e1);
                }
                for (const s of i){
                    const i = r.featuresOnBorder[s], h = r.centroidData.get(i.centroidDataIndex);
                    if (void 0 === i.buildingId) continue;
                    const f = x.get(i.buildingId);
                    if (void 0 === f) continue;
                    const _ = l.featuresOnBorder[g[f]], b = l.centroidData.get(_.centroidDataIndex);
                    w.add(s), T.add(f), a && c(h, b);
                    const S = 0 !== h.groupCentroidPos.x || 0 !== h.groupCentroidPos.y ? h.groupCentroidPos : i.centroid(), C = 0 !== b.groupCentroidPos.x || 0 !== b.groupCentroidPos.y ? b.groupCentroidPos : _.centroid(), E = n ? void 0 : p(t1, i.borders, m, _.borders), I = void 0 !== E ? E : t1 < 2 ? Math.round((S.y + C.y) / 2) : Math.round((S.x + C.x) / 2), D = i.intersectsCount() > 1 || _.intersectsCount() > 1;
                    {
                        let i = 0;
                        if (u && u.dem && !D) {
                            const s = y[t1](h, b), r = t1 % 2 ? e1.ac - 1 : 0;
                            i = v(s[0], Math.min(e1.ac - 1, s[1]), r, u, o, t1 < 2, s[2]);
                        }
                        h.centroidXY = d(i, t1, I), b.centroidXY = d(i, m, I);
                    }
                    r.writeCentroidToBuffer(h), l.writeCentroidToBuffer(b), r.setBuildingCentroid(i.buildingId, h.centroidXY), l.setBuildingCentroid(i.buildingId, b.centroidXY);
                }
                for (const s of i){
                    if (w.has(s)) continue;
                    const i = r.featuresOnBorder[s], f = r.centroidData.get(i.centroidDataIndex), _ = i.borders[t1];
                    let x;
                    for(; b < g.length;){
                        if (T.has(b)) {
                            b++;
                            continue;
                        }
                        x = l.featuresOnBorder[g[b]];
                        const e1 = x.borders[m];
                        if (e1[1] > _[0] + 3 || e1[0] > _[0] - 3) break;
                        l.showCentroid(x, "keep"), b++;
                    }
                    if (x && b < g.length) {
                        let s = b, w = 0;
                        for(;;)if (T.has(b)) {
                            if (++b === g.length) break;
                            x = l.featuresOnBorder[g[b]];
                        } else {
                            if (x.borders[m][0] > _[1] - 3) break;
                            if (w++, ++b === g.length) break;
                            x = l.featuresOnBorder[g[b]];
                        }
                        for(; s < g.length && T.has(s);)s++;
                        if (s >= g.length) {
                            r.showCentroid(i, "keep");
                            continue;
                        }
                        x = l.featuresOnBorder[g[s]];
                        let S = !1;
                        if (w >= 1) {
                            const e1 = x.borders[m];
                            Math.abs(_[0] - e1[0]) < 3 && Math.abs(_[1] - e1[1]) < 3 && (w = 1, S = !0, b = s + 1);
                        } else if (0 === w) {
                            r.showCentroid(i, "keep");
                            continue;
                        }
                        const C = l.centroidData.get(x.centroidDataIndex);
                        a && S && c(f, C);
                        const E = i.intersectsCount() > 1 || x.intersectsCount() > 1;
                        if (w > 1) b = s, f.centroidXY = C.centroidXY = new e1.P(0, 0);
                        else if (u && u.dem && !E) {
                            const i = y[t1](f, C), s = t1 % 2 ? e1.ac - 1 : 0, r = v(i[0], Math.min(e1.ac - 1, i[1]), s, u, o, t1 < 2, i[2]);
                            f.centroidXY = C.centroidXY = h(r);
                        } else if (E) {
                            const s = n ? void 0 : p(t1, i.borders, m, x.borders);
                            void 0 !== s ? (f.centroidXY = d(0, t1, s), C.centroidXY = d(0, m, s)) : f.centroidXY = C.centroidXY = new e1.P(0, 0);
                        } else f.centroidXY = r.encodeBorderCentroid(i), C.centroidXY = l.encodeBorderCentroid(x);
                        r.writeCentroidToBuffer(f), l.writeCentroidToBuffer(C);
                    } else r.showCentroid(i, "keep");
                }
                r.borderDoneWithNeighborZ[t1] = l.canonical.z, l.borderDoneWithNeighborZ[m] = r.canonical.z;
            }
            (r.needsCentroidUpdate || !r.centroidVertexBuffer && 0 !== r.centroidVertexArray.length) && r.uploadCentroid(t1);
        }
        const gi = [
            1,
            0,
            0
        ], yi = [
            0,
            1,
            0
        ], vi = [
            0,
            0,
            1
        ];
        function bi(t1, i, s) {
            const r = s.transform, o = s.shadowRenderer;
            if (!o) return !0;
            const n = s.frameCounter, a = s.currentShadowCascade;
            let l = s._shadowCullCache;
            if (!l || l.frame !== n || l.cascade !== a) {
                const t1 = r.tileSize * o._cascades[a].scale, i = r.scaleZoom(t1), c = o.shadowDirection, h = [
                    c[0],
                    c[1],
                    -c[2]
                ], d = [
                    gi,
                    yi,
                    vi,
                    h,
                    [
                        h[0],
                        0,
                        h[2]
                    ],
                    [
                        0,
                        h[1],
                        h[2]
                    ]
                ];
                l = {
                    frame: n,
                    cascade: a,
                    cameraFrustum: e1.aK.fromInvProjectionMatrix(r.invProjMatrix, r.worldSize, i, !("globe" === r.projection.name)),
                    edges: d,
                    shadowDir: h,
                    ws: t1,
                    zoom: i
                }, s._shadowCullCache = l;
            }
            const { cameraFrustum: c, edges: h, shadowDir: d, ws: u, zoom: p } = l;
            let f = i;
            if (r.elevation) {
                const e1 = r.elevation.getMinMaxForTile(t1);
                e1 && (f += e1.max);
            }
            f /= e1.aL(r.center.lat, p);
            const m = o.computeSimplifiedTileShadowVolume(t1.toUnwrapped(), f, u, d);
            if (!m) return !1;
            const { vertices: _, planes: g } = m;
            return 0 === c.intersectsPrecise(_, g, h) || 0 === o.getCurrentCascadeFrustum().intersectsPrecise(_, g, h);
        }
        const xi = new Float32Array(16), wi = new Float32Array(16);
        function Ti(t1) {
            const { painter: i, source: s, layer: r, coords: o } = t1;
            let n = t1.defines;
            const a = i.context, l = "shadow" === i.renderPass, c = "light-beam" === i.renderPass, h = i.shadowRenderer, d = e1.aL(i.transform.center.lat, i.transform.zoom), u = e1.aP(i, r.paint.get("building-cutoff-fade-range"));
            u.shouldRenderCutoff && (n = n.concat("RENDER_CUTOFF"));
            const p = r.paint.get("building-front-cutoff"), f = p[2] < 1 && !i.terrain, m = mi(i.transform.pitch, p, !!i.terrain);
            f && (n = n.concat("RENDER_FRONT_CUTOFF"), i.maxFrontCutoffRawStart = Math.max(i.maxFrontCutoffRawStart, p[0])), t1.floodLightIntensity > 0 && (n = n.concat("FLOOD_LIGHT"));
            for (const p of o){
                const o = s.getTile(p), f = o.getBucket(r);
                if (!f) continue;
                h && 0 === h.getMaxCascadeForTile(p.toUnwrapped()) && (n = n.concat("SHADOWS_SINGLE_CASCADE"));
                const _ = f.programConfigurations.get(r.id);
                let g, y;
                const v = i.translatePosMatrix(p.expandedProjMatrix, o, [
                    0,
                    0
                ], "map");
                e1.aY(xi, v, [
                    1,
                    1,
                    t1.verticalScale
                ]);
                const b = xi;
                let x;
                if (l && h) {
                    if (bi(o.tileID, f.maxHeight * d, i)) continue;
                    const s = h.calculateShadowPassMatrixFromTile(o.tileID.toUnwrapped());
                    e1.aY(s, s, [
                        1,
                        1,
                        t1.verticalScale
                    ]), x = hi(s), g = y = i.getOrCreateProgram("buildingDepth", {
                        config: _,
                        defines: n,
                        overrideFog: !1
                    });
                } else if (c) g = y = i.getOrCreateProgram("buildingBloom", {
                    config: _,
                    defines: n,
                    overrideFog: !1
                }), x = ci(b);
                else {
                    const s = e1.aY(new Float64Array(16), i.transform.calculatePosMatrix(p.toUnwrapped()), [
                        1,
                        1,
                        t1.verticalScale
                    ]);
                    e1.aY(wi, s, [
                        1,
                        -1,
                        1 / d
                    ]), e1.aZ(wi, wi), e1.a_(wi, wi);
                    const r = wi, o = i.transform.getFreeCameraOptions().position, l = 1 << p.canonical.z;
                    if (x = li(b, r, t1.opacity, t1.facadeAOIntensity, [
                        ((o.x - p.wrap) * l - p.canonical.x) * e1.ac,
                        (o.y * l - p.canonical.y) * e1.ac,
                        o.z * l * e1.ac
                    ], f.tileToMeter, t1.facadeEmissiveChance, t1.floodLightColor, t1.floodLightIntensity, m), y = i.getOrCreateProgram("building", {
                        config: _,
                        defines: n,
                        overrideFog: !1
                    }), !0 === t1.depthOnly) g = y;
                    else {
                        const e1 = n.concat([
                            "BUILDING_FAUX_FACADE",
                            "HAS_ATTRIBUTE_a_faux_facade_color_emissive"
                        ]);
                        g = i.getOrCreateProgram("building", {
                            config: _,
                            defines: e1,
                            overrideFog: !1
                        });
                    }
                    h && (h.setupShadowsFromMatrix(s, y, !0), g !== y && g.setShadowUniformValues(a, h.getShadowUniformValues()));
                }
                const w = (s, o)=>{
                    if (c) {
                        const n = s.entranceBloom;
                        o.draw(i, a.gl.TRIANGLES, t1.depthMode, e1.a4.disabled, t1.blendMode, e1.a5.disabled, x, r.id, n.layoutVertexBuffer, n.indexBuffer, n.segmentsBucket, r.paint, i.transform.zoom, _, [
                            n.layoutAttenuationBuffer,
                            n.layoutColorBuffer
                        ]);
                    } else {
                        const n = s.segmentsBucket;
                        let c = [
                            s.layoutNormalBuffer,
                            s.layoutCentroidBuffer,
                            s.layoutColorBuffer,
                            s.layoutFloodLightDataBuffer
                        ];
                        s.layoutFacadePaintBuffer && (c = c.concat([
                            s.layoutFacadeDataBuffer,
                            s.layoutFacadeVerticalRangeBuffer,
                            s.layoutFacadePaintBuffer
                        ])), o.draw(i, a.gl.TRIANGLES, t1.depthMode, t1.stencilMode || e1.a4.disabled, t1.blendMode, l ? e1.a5.disabled : e1.a5.backCW, x, r.id, s.layoutVertexBuffer, s.indexBuffer, n, r.paint, i.transform.zoom, _, c);
                    }
                };
                i.uploadCommonUniforms(a, y, p.toUnwrapped(), null, u), f.buildingWithoutFacade && w(f.buildingWithoutFacade, y), f.buildingWithFacade && (g !== y && i.uploadCommonUniforms(a, g, p.toUnwrapped(), null, u), w(f.buildingWithFacade, g));
            }
        }
        function Si(t1, i, s, r, o, n, a, l, c, h, d, u, p, f) {
            const m = t1.context.gl, _ = t1.depthModeForSublayer(1, e1.a3.ReadOnly, m.LEQUAL, !0), g = e1.aw(.1, 3, d), y = t1._showOverdrawInspector, v = u, b = new fi;
            if (!y) {
                const d = new e1.a4({
                    func: m.ALWAYS,
                    mask: 255
                }, 255, 255, m.KEEP, m.KEEP, m.REPLACE), u = new e1.a7([
                    m.ONE,
                    m.ONE,
                    m.ONE,
                    m.ONE
                ], e1.C.transparent, [
                    !1,
                    !1,
                    !1,
                    !0
                ], m.MIN);
                e1.a$(b, t1, i, s, r, _, d, u, e1.a5.disabled, o, "sdf", n, a, l, c, h, g, v, !1, void 0);
            }
            {
                const d = y ? e1.a4.disabled : new e1.a4({
                    func: m.EQUAL,
                    mask: 255
                }, 255, 255, m.KEEP, m.DECR, m.DECR), u = y ? t1.colorModeForRenderPass() : new e1.a7([
                    m.ONE_MINUS_DST_ALPHA,
                    m.DST_ALPHA,
                    m.ONE,
                    m.ONE
                ], e1.C.transparent, [
                    !0,
                    !0,
                    !0,
                    !0
                ]);
                e1.a$(b, t1, i, s, r, _, d, u, e1.a5.disabled, o, "color", n, a, l, c, h, g, v, !1, void 0);
            }
        }
        class Ci {
            constructor(){
                this._previousClosestBuildingId = null, this._hysteresisRatio = .8, this._indoorMinimumZoom = 16;
            }
            findClosestBuilding(e1, t1, i, s, r) {
                if (i < this._indoorMinimumZoom) return this._previousClosestBuildingId = null, null;
                let o = null, n = Number.MAX_VALUE, a = Number.MAX_VALUE, l = !1;
                const c = this._previousClosestBuildingId ? e1[this._previousClosestBuildingId] : null;
                this._previousClosestBuildingId && c && this._isBuildingVisible(c, s, r) && (l = !0, a = this._calculateDistance(t1, c));
                for (const [i, a] of Object.entries(e1)){
                    if (!this._isBuildingVisible(a, s, r)) continue;
                    const e1 = this._calculateDistance(t1, a);
                    e1 < n && (n = e1, o = i);
                }
                return l && o && this._previousClosestBuildingId && o !== this._previousClosestBuildingId ? n > a * this._hysteresisRatio && (o = this._previousClosestBuildingId) : l && !o && (o = this._previousClosestBuildingId), this._previousClosestBuildingId = o, o;
            }
            _calculateDistance(e1, t1) {
                if (!t1.center) return Number.MAX_VALUE;
                const i = e1.lat - t1.center[1], s = e1.lng - t1.center[0];
                return i * i + s * s;
            }
            _isBuildingVisible(t1, i, s) {
                if (!s) return !1;
                for (const i of t1.floorIds){
                    const r = t1.floors[i];
                    if (!r.geometry) continue;
                    const o = r.geometry;
                    if ("Polygon" === o.type) {
                        const t1 = this._convertRingToPoints(o.coordinates[0]);
                        if (e1.b2(t1, s)) return !0;
                    } else if ("MultiPolygon" === o.type) {
                        const t1 = this._convertMultiPolygonToPoints(o.coordinates);
                        if (e1.b3(s, t1)) return !0;
                    }
                }
                return !1;
            }
            _convertRingToPoints(t1) {
                return t1.map((t1)=>new e1.P(t1[0], t1[1]));
            }
            _convertMultiPolygonToPoints(t1) {
                return t1.map((t1)=>0 === t1.length ? [] : t1[0].map((t1)=>new e1.P(t1[0], t1[1])));
            }
        }
        const Ei = .05, Ii = (e1, t1, i, s, r, o, n, a, l, c, h, d)=>({
                u_matrix: e1,
                u_normalize_matrix: t1,
                u_globe_matrix: i,
                u_merc_matrix: s,
                u_grid_matrix: r,
                u_tl_parent: o,
                u_scale_parent: c,
                u_fade_t: h.mix,
                u_opacity: h.opacity,
                u_image0: 0,
                u_image1: 1,
                u_raster_elevation: d,
                u_zoom_transition: n,
                u_merc_center: a,
                u_cutoff_params: l
            }), Di = (e1, t1, i, s, r, o, n, a, l, c)=>({
                u_particle_texture: e1,
                u_particle_texture_side_len: t1,
                u_tile_offset: i,
                u_velocity: s,
                u_color_ramp: o,
                u_velocity_res: r,
                u_max_speed: n,
                u_uv_offset: a,
                u_data_scale: [
                    255 * l[0],
                    255 * l[1]
                ],
                u_data_offset: c,
                u_particle_pos_scale: 1.1,
                u_particle_pos_offset: [
                    Ei,
                    Ei
                ]
            }), Pi = (e1, t1, i, s, r, o, n, a, l, c)=>({
                u_particle_texture: e1,
                u_particle_texture_side_len: t1,
                u_velocity: i,
                u_velocity_res: s,
                u_max_speed: r,
                u_speed_factor: o,
                u_reset_rate: n,
                u_rand_seed: Math.random(),
                u_uv_offset: a,
                u_data_scale: [
                    255 * l[0],
                    255 * l[1]
                ],
                u_data_offset: c,
                u_particle_pos_scale: 1.1,
                u_particle_pos_offset: [
                    Ei,
                    Ei
                ]
            });
        function Li(e1, [t1, i, s, r], [o, n]) {
            if (o === n) return [
                0,
                0,
                0,
                0
            ];
            const a = 255 * (e1 - 1) / (e1 * (n - o));
            return [
                t1 * a,
                i * a,
                s * a,
                r * a
            ];
        }
        function Ri(e1, t1, [i, s]) {
            return i === s ? 0 : .5 / e1 + (t1 - i) * (e1 - 1) / (e1 * (s - i));
        }
        var Ai = e1.b9([
            {
                name: "a_index",
                type: "Int16",
                components: 1
            }
        ]);
        class Mi {
            constructor(t1, i, s, r){
                const o = {
                    width: s[0],
                    height: s[1],
                    data: null
                }, n = t1.gl;
                this.targetColorTexture = new e1.T(t1, o, n.RGBA8, {
                    useMipmap: !1
                }), this.backgroundColorTexture = new e1.T(t1, o, n.RGBA8, {
                    useMipmap: !1
                }), this.context = t1, this.updateParticleTexture(i, r), this.lastInvalidatedAt = 0;
            }
            updateParticleTexture(t1, i) {
                if (this.particleTextureDimension === i.width) return;
                (this.particleTexture0 || this.particleTexture1 || this.particleIndexBuffer || this.particleSegment) && (this.particleTexture0.destroy(), this.particleTexture1.destroy(), this.particleIndexBuffer.destroy(), this.particleSegment.destroy());
                const s = this.context.gl, r = i.width * i.height;
                this.particleTexture0 = new e1.T(this.context, i, s.RGBA8, {
                    premultiply: !1,
                    useMipmap: !1
                }), this.particleTexture1 = new e1.T(this.context, i, s.RGBA8, {
                    premultiply: !1,
                    useMipmap: !1
                });
                const o = new e1.ba;
                o.reserve(r);
                for(let e1 = 0; e1 < r; e1++)o.emplaceBack(e1);
                this.particleIndexBuffer = this.context.createVertexBuffer(o, Ai.members, !0), this.particleSegment = e1.aj.simpleSegment(0, 0, this.particleIndexBuffer.length, 0), this.particleTextureDimension = i.width;
            }
            update(t1) {
                return !(this.lastInvalidatedAt < t1 && (this.lastInvalidatedAt = e1.e.now(), 1));
            }
            destroy() {
                this.targetColorTexture.destroy(), this.backgroundColorTexture.destroy(), this.particleIndexBuffer.destroy(), this.particleTexture0.destroy(), this.particleTexture1.destroy(), this.particleSegment.destroy();
            }
        }
        function Fi(t1, i, s, r, o) {
            if (o > 0) {
                const n = e1.e.now(), a = (n - t1.timeAdded) / o, l = i ? (n - i.timeAdded) / o : -1, c = s.getSource(), h = r.coveringZoomLevel({
                    tileSize: c.tileSize,
                    roundZoom: c.roundZoom
                }), d = !i || Math.abs(i.tileID.overscaledZ - h) > Math.abs(t1.tileID.overscaledZ - h), u = d && t1.refreshedUponExpiration ? 1 : e1.bb(d ? a : 1 - l, 0, 1);
                return i ? {
                    opacity: 1,
                    mix: 1 - u,
                    isFading: a < 1
                } : {
                    opacity: u,
                    mix: 0,
                    isFading: a < 1
                };
            }
            return {
                opacity: 1,
                mix: 0,
                isFading: !1
            };
        }
        function Oi(t1, i, s) {
            if (!t1) return null;
            const r = i.getTextureDescriptor(t1, s, !0);
            if (!r) return null;
            let { texture: o, mix: n, offset: a, tileSize: l, buffer: c, format: h } = r;
            if (!o || !h) return null;
            let d = !1;
            return "uint32" === h && (d = !0, n[3] = 0, n = Li(e1.bk, n, [
                0,
                s.paint.get("raster-particle-max-speed")
            ]), a = Ri(e1.bk, a, [
                0,
                s.paint.get("raster-particle-max-speed")
            ])), {
                texture: o,
                textureOffset: [
                    c / (l + 2 * c),
                    l / (l + 2 * c)
                ],
                tileSize: l,
                scalarData: d,
                scale: n,
                offset: a,
                defines: [
                    "RASTER_ARRAY",
                    {
                        uint8: "DATA_FORMAT_UINT8",
                        uint16: "DATA_FORMAT_UINT16",
                        uint32: "DATA_FORMAT_UINT32"
                    }[h]
                ]
            };
        }
        function ki(e1) {
            const t1 = e1._nearZ, i = e1.projection.farthestPixelDistance(e1), s = i - t1, r = .2 * e1.height, o = t1 + r;
            return [
                t1,
                i,
                (o - r - t1) / s,
                (o - t1) / s
            ];
        }
        var Bi = "#ifdef RASTER_ARRAY\nuniform sampler2D u_velocity;uniform mediump vec2 u_velocity_res;uniform mediump float u_max_speed;const vec4 NO_DATA=vec4(1);const vec2 INVALID_VELOCITY=vec2(-1);uniform highp vec2 u_uv_offset;uniform highp float u_data_offset;uniform highp vec2 u_data_scale;ivec4 rasterArrayLinearCoord(highp vec2 texCoord,highp vec2 texResolution,out highp vec2 fxy) {texCoord=texCoord*texResolution-0.5;fxy=fract(texCoord);texCoord-=fxy;return ivec4(texCoord.xxyy+vec2(1.5,0.5).xyxy);}highp vec2 lookup_velocity(highp vec2 uv) {uv=u_uv_offset.x+u_uv_offset.y*uv;highp vec2 fxy;ivec4 c=rasterArrayLinearCoord(uv,u_velocity_res,fxy);highp vec4 tl=texelFetch(u_velocity,c.yz,0);highp vec4 tr=texelFetch(u_velocity,c.xz,0);highp vec4 bl=texelFetch(u_velocity,c.yw,0);highp vec4 br=texelFetch(u_velocity,c.xw,0);if (tl==NO_DATA) {return INVALID_VELOCITY;}if (tr==NO_DATA) {return INVALID_VELOCITY;}if (bl==NO_DATA) {return INVALID_VELOCITY;}if (br==NO_DATA) {return INVALID_VELOCITY;}highp vec4 t=mix(mix(bl,br,fxy.x),mix(tl,tr,fxy.x),fxy.y);highp vec2 velocity=u_data_offset+vec2(dot(t.rg,u_data_scale),dot(t.ba,u_data_scale));velocity.y=-velocity.y;velocity/=max(u_max_speed,length(velocity));return velocity;}\n#endif\nuniform highp float u_particle_pos_scale;uniform highp vec2 u_particle_pos_offset;highp vec4 pack_pos_to_rgba(highp vec2 p) {highp vec2 v=(p+u_particle_pos_offset)/u_particle_pos_scale;highp vec4 r=vec4(v.x,fract(v.x*255.0),v.y,fract(v.y*255.0));return vec4(r.x-r.y/255.0,r.y,r.z-r.w/255.0,r.w);}highp vec2 unpack_pos_from_rgba(highp vec4 v) {v=floor(v*255.0+0.5)/255.0;highp vec2 p=vec2(v.x+(v.y/255.0),v.z+(v.w/255.0));return u_particle_pos_scale*p-u_particle_pos_offset;}";
        e1.bl["_prelude_raster_particle.glsl"] || (e1.bl["_prelude_raster_particle.glsl"] = Bi);
        var zi = {
            building: e1.bm('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_indicator_cutout.fragment.glsl"\n#include "_prelude_feature_cutout.fragment.glsl"\nconst float window_depth=0.5;const float ao_radius=0.2;in vec4 v_color;in highp vec3 v_normal;in highp vec3 v_pos;\n#if defined(RENDER_FRONT_CUTOFF) || defined(ROUTE_CORRIDOR)\nin float v_dither_opacity;\n#endif\n#ifdef BUILDING_FAUX_FACADE\nin lowp float v_faux_facade;in highp float v_faux_facade_ed;in highp vec2 v_faux_facade_window;in highp vec2 v_faux_facade_floor;in highp vec2 v_faux_facade_range;in highp float v_aspect;in highp vec3 v_tbn_0;in highp vec3 v_tbn_1;in highp vec3 v_tbn_2;in highp vec4 v_faux_color_emissive;uniform float u_faux_facade_ao_intensity;\n#endif\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;\n#endif\n#ifdef FLOOD_LIGHT\nin highp float v_flood_radius;in float v_has_flood_light;\n#endif\nuniform lowp float u_opacity;uniform vec3 u_camera_pos;uniform highp float u_tile_to_meter;uniform float u_facade_emissive_chance;uniform vec3 u_flood_light_color;uniform float u_flood_light_intensity;vec3 linearTosRGB(in vec3 color) {return pow(color,vec3(1./2.2));}\n#ifdef BUILDING_FAUX_FACADE\nhighp float hash12(in highp vec2 p) {highp vec3 p3 =fract(vec3(p.xyx)*0.1031);p3+=dot(p3,p3.yzx+33.33);return fract((p3.x+p3.y)*p3.z);}float min3(in vec3 v) {return min(min(v.x,v.y),v.z);}highp vec2 get_uv_mask_id(in highp vec2 q,out highp float mask,out highp vec2 id) {highp vec2 p=q;mask=step(v_faux_facade_range.x,p.y)*step(p.y,v_faux_facade_range.y);p.y=p.y-v_faux_facade_range.x;highp vec2 uv=modf(p/v_faux_facade_floor,id);highp vec4 d=(v_faux_facade_floor.xyxy+vec4(-v_faux_facade_window,v_faux_facade_window))*0.5;highp vec4 edge=d/v_faux_facade_floor.xyxy;highp vec2 m=step(edge.xy,uv)*step(uv,edge.zw);mask*=m.x*m.y;uv-=vec2(0.5);uv*=vec2(0.5)/(vec2(0.5)-edge.xy);uv+=vec2(0.5);return uv;}highp float ray_unit_box(in highp vec3 ray_o,in highp vec3 ray_d,in highp vec3 bmin,in highp vec3 bmax) {highp vec3 planes=mix(bmin,bmax,step(0.0,ray_d));highp vec3 t=(planes-ray_o)/ray_d;return min3(t);}float get_emissive(in vec2 id) {if (u_facade_emissive_chance > 0.0) {return (step(hash12(id),u_facade_emissive_chance)+0.05)*v_faux_color_emissive.a;}return 0.0;}vec3 get_shade_info(in highp vec3 v,in highp vec3 v_normalized,in vec3 color,in vec2 id,in mat3 tbn,inout vec3 out_normal,inout float out_emissive) {vec3 out_color=color;highp vec3 abs_v=abs(v_normalized);bool x_major=abs_v.x >=abs_v.y && abs_v.x >=abs_v.z;bool y_major=abs_v.y >=abs_v.x && abs_v.y >=abs_v.z;bool z_major=abs_v.z >=abs_v.x && abs_v.z >=abs_v.y;if (x_major) {out_normal=-sign(v.x)*tbn[0];} else if (y_major) {out_normal=vec3(0.0,0.0,-sign(v.y));} else if (z_major) {out_color=v_faux_color_emissive.rgb;out_emissive=v.z <=0.0 ? get_emissive(id) : out_emissive;}float ao=1.0;if (u_faux_facade_ao_intensity > 0.0) {vec4 ao_range=v_faux_facade_window.xxyy*0.5-vec4(0,ao_radius,0,ao_radius);vec2 ao_range_z=vec2(window_depth*0.5)-vec2(0.0,ao_radius);if (x_major || y_major) {ao*=smoothstep(-ao_range_z.x,-ao_range_z.y,v.z);} else if (z_major) {ao*=smoothstep(-ao_range.x,-ao_range.y,v.x)*(1.0-smoothstep(ao_range.y,ao_range.x,v.x));ao*=smoothstep(-ao_range.z,-ao_range.w,v.y)*(1.0-smoothstep(ao_range.w,ao_range.z,v.y));}ao=mix(1.0,min(1.0,ao+0.25),u_faux_facade_ao_intensity);}out_color*=ao;return out_color;}\n#endif\nvec3 apply_lighting_linear(in vec3 color,in vec3 normal,in float dir_factor) {float ambient_directional_factor=calculate_ambient_directional_factor(normal);vec3 ambient_contrib=ambient_directional_factor*u_lighting_ambient_color;vec3 directional_contrib=u_lighting_directional_color*dir_factor;return color*(ambient_contrib+directional_contrib);}void main() {vec3 normal=normalize(v_normal);vec3 base_color=v_color.rgb;float emissive=v_color.a;\n#ifdef BUILDING_FAUX_FACADE\nif (v_faux_facade > 0.0) {highp mat3 tbn=mat3(v_tbn_0,v_tbn_1,v_tbn_2);highp vec3 v=vec3(v_pos.xy,v_pos.z/u_tile_to_meter)-u_camera_pos;highp vec3 view_tangent=transpose(tbn)*v;highp vec2 q=vec2(v_faux_facade_ed,v_pos.z);float mask=0.0;vec2 id=vec2(0.0);highp vec2 uv=get_uv_mask_id(q,mask,id);uv*=v_faux_facade_window;highp vec3 bmin=vec3(0.0,0.0,-window_depth);highp vec3 bmax=bmin+vec3(v_faux_facade_window,window_depth);highp vec3 ray_o=vec3(uv,0.0);highp vec3 ray_d=normalize(view_tangent);highp float t_min=ray_unit_box(ray_o,ray_d,bmin,bmax);highp vec3 hit=ray_o+t_min*ray_d;highp vec3 r=vec3(v_faux_facade_window,-window_depth);hit-=r*0.5;highp vec3 normalized=hit/r;vec3 out_normal=normal;float out_emissive=emissive;vec3 room_color=get_shade_info(hit,normalized,base_color,id,tbn,out_normal,out_emissive);base_color=mix(base_color,room_color,mask);normal=mix(normal,out_normal,mask);emissive=mix(emissive,out_emissive,mask);}\n#endif\nvec4 color=vec4(base_color,1.0);vec3 xy_flipped_normal=vec3(-normal.xy,normal.z);float shadowed_lighting_factor=0.0;\n#ifdef RENDER_SHADOWS\n#ifdef RENDER_CUTOFF\nshadowed_lighting_factor=shadowed_light_factor_normal_opacity(xy_flipped_normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w,v_cutoff_opacity);\n#else\nshadowed_lighting_factor=shadowed_light_factor_normal(xy_flipped_normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);\n#endif\n#else\nshadowed_lighting_factor=max(0.0,dot(xy_flipped_normal,u_lighting_directional_dir));\n#endif\ncolor.rgb=apply_lighting_linear(color.rgb,xy_flipped_normal,shadowed_lighting_factor);color.rgb=linearTosRGB(color.rgb);\n#ifdef FLOOD_LIGHT\nfloat flood_radiance=(1.0-min(v_pos.z/v_flood_radius,1.0))*u_flood_light_intensity*v_has_flood_light;color.rgb=mix(color.rgb,u_flood_light_color,flood_radiance);\n#endif\ncolor.rgb=mix(color.rgb,linearTosRGB(base_color.rgb),emissive);\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos,v_pos.z));\n#endif\ncolor*=u_opacity;\n#if defined(RENDER_FRONT_CUTOFF) || defined(ROUTE_CORRIDOR)\nif (v_dither_opacity < 1.0) {int index=viewport_dither_index(gl_FragCoord.xy);if (v_dither_opacity < DITHER_THRESHOLDS[index]) {discard;}}\n#endif\nglFragColor=color;\n#ifdef DEBUG_SHOW_NORMALS\ncolor.rgb=xy_flipped_normal*0.5+vec3(0.5,0.5,0.5);color.a=1.0;glFragColor=color;\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_feature_cutout.vertex.glsl"\nin ivec2 a_pos_packed;in vec4 a_normal_4n;in ivec4 a_centroid_3;\n#ifdef FLOOD_LIGHT\nin int a_flood_light_wall_radius_1i16;\n#endif\n#ifdef BUILDING_FAUX_FACADE\nin uvec4 a_faux_facade_data;in uvec2 a_faux_facade_vertical_range;\n#endif\nuniform mat4 u_matrix;uniform mat4 u_normal_matrix;uniform highp float u_tile_to_meter;\n#if defined(RENDER_FRONT_CUTOFF) || defined(ROUTE_CORRIDOR)\n#ifdef RENDER_FRONT_CUTOFF\nuniform vec3 u_front_cutoff_params;\n#endif\nout float v_dither_opacity;\n#endif\nout vec4 v_color;out vec3 v_normal;out highp vec3 v_pos;\n#ifdef BUILDING_FAUX_FACADE\nout lowp float v_faux_facade;out highp float v_faux_facade_ed;out highp vec2 v_faux_facade_window;out highp vec2 v_faux_facade_floor;out highp vec2 v_faux_facade_range;out highp float v_aspect;out highp vec3 v_tbn_0;out highp vec3 v_tbn_1;out highp vec3 v_tbn_2;out highp vec4 v_faux_color_emissive;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;\n#endif\n#ifdef FLOOD_LIGHT\nout highp float v_flood_radius;out float v_has_flood_light;\n#endif\nconst float MAX_UINT_16=65535.0;const float MAX_INT_16=32767.0;const float MAX_UINT_8=255.0;const float MAX_INT_8=127.0;const float TWO_POW_8=256.0;const float FLOOD_LIGHT_MAX_RADIUS_METER=2048.0;vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}\n#ifdef BUILDING_FAUX_FACADE\nmat3 get_tbn(in vec3 normal) {const vec3 bitangent=vec3(0.0,0.0,1.0);vec3 tangent=normalize(vec3(normal.y,-normal.x,0.0));return mat3(tangent,bitangent,normal);}\n#endif\n#pragma mapbox: define-attribute-vertex-shader-only highp uvec2 part_color_emissive\n#pragma mapbox: define-attribute-vertex-shader-only highp uvec2 faux_facade_color_emissive\ninvariant gl_Position;void main() {\n#pragma mapbox: initialize-attribute-custom highp uvec2 part_color_emissive\n#pragma mapbox: initialize-attribute-custom highp uvec2 faux_facade_color_emissive\n#ifdef FLOOD_LIGHT\nv_flood_radius=(float(a_flood_light_wall_radius_1i16)/MAX_INT_16*FLOOD_LIGHT_MAX_RADIUS_METER);v_has_flood_light=step(0.0,v_flood_radius);\n#endif\nvec4 color_emissive=decode_color(vec2(part_color_emissive));v_color=vec4(sRGBToLinear(color_emissive.rgb),color_emissive.a);v_normal=vec3(u_normal_matrix*vec4(a_normal_4n.xyz,0.0));float hidden=0.0;float depth_offset=0.0;float frontCutoffOpacity=1.0;float routeFade=0.0;vec2 centroid_xy=vec2(a_centroid_3.xy >> 2);vec2 spanBits=vec2(a_centroid_3.xy & 3);\n#ifdef BUILDING_FAUX_FACADE\nvec4 faux_facade_data=vec4(a_faux_facade_data);v_faux_facade=faux_facade_data.x;if (v_faux_facade > 0.0) {v_faux_facade_ed=faux_facade_data.x *u_tile_to_meter;float window_x_perc=floor(faux_facade_data.y/TWO_POW_8);float window_y_perc=faux_facade_data.y-TWO_POW_8*window_x_perc;vec2 window_perc=vec2(window_x_perc,window_y_perc)/MAX_UINT_8;v_faux_facade_floor=(faux_facade_data.zw/MAX_UINT_16*EXTENT)*u_tile_to_meter;v_faux_facade_window=window_perc*v_faux_facade_floor;v_faux_facade_range=(vec2(a_faux_facade_vertical_range)/MAX_UINT_16*EXTENT)*u_tile_to_meter;v_aspect=v_faux_facade_window.x/v_faux_facade_window.y;mat3 tbn=get_tbn(normalize(v_normal));v_tbn_0=tbn[0];v_tbn_1=tbn[1];v_tbn_2=tbn[2];v_faux_color_emissive=decode_color(vec2(faux_facade_color_emissive));v_faux_color_emissive.rgb=sRGBToLinear(v_faux_color_emissive.rgb);depth_offset=min(1000.0,float(a_centroid_3.z))*0.0000002;}\n#endif\nv_pos=vec3(float(a_pos_packed.x >> 16),float((a_pos_packed.x << 16) >> 16),intBitsToFloat(a_pos_packed.y));\n#if defined(RENDER_CUTOFF) || defined(RENDER_FRONT_CUTOFF)\nfloat halfSpanX=spanBits.x*10.0/u_tile_to_meter;float halfSpanY=spanBits.y*10.0/u_tile_to_meter;vec2 screenUpInTile=vec2(u_matrix[0][1],u_matrix[1][1]);vec2 spanOffset=vec2(halfSpanX,halfSpanY)*sign(screenUpInTile);vec2 cutoff_highestCorner=centroid_xy+spanOffset;vec2 cutoff_lowestCorner=centroid_xy-spanOffset;\n#endif\n#if defined(RENDER_CUTOFF) || defined(RENDER_FRONT_CUTOFF)\nvec4 ground=u_matrix*vec4(centroid_xy,0.0,1.0);\n#endif\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,native_clip_z_to_cutoff_depth(ground.z,ground.w));hidden=float(v_cutoff_opacity==0.0);v_pos.z*=v_cutoff_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nvec3 shadow_pos=v_pos;\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset_model(v_normal);shadow_pos+=offset*shadow_normal_offset_multiplier0();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shadow_pos,1.0);v_pos_light_view_1=u_light_matrix_1*vec4(shadow_pos,1.0);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(v_pos);\n#endif\n#ifdef RENDER_FRONT_CUTOFF\n{hidden=max(hidden,float(ground.w <=0.0));float ndc_y=ground.y/max(ground.w,0.001);float threshold=u_front_cutoff_params.x*2.0-1.0;float range_ndc=u_front_cutoff_params.y*2.0;hidden=max(hidden,float(ndc_y < threshold-range_ndc));float t=clamp((ndc_y-(threshold-range_ndc))/max(range_ndc,0.001),0.0,1.0);frontCutoffOpacity=mix(u_front_cutoff_params.z,1.0,t);}\n#endif\n#if defined(RENDER_FRONT_CUTOFF) || defined(ROUTE_CORRIDOR)\nv_dither_opacity=1.0;\n#ifdef RENDER_FRONT_CUTOFF\nv_dither_opacity=min(v_dither_opacity,frontCutoffOpacity);\n#endif\nhidden=max(hidden,float(v_dither_opacity <=0.0));\n#endif\ngl_Position=mix(u_matrix*vec4(v_pos,1),AWAY,hidden);gl_Position.z-=depth_offset*gl_Position.w;}'),
            buildingBloom: e1.bm("in vec4 v_color_emissive;\n#pragma mapbox: define-attribute highp vec4 bloom_attenuation\nfloat saturate(float val) {return clamp(val,0.0,1.0);}void main() {\n#pragma mapbox: initialize-attribute highp vec4 bloom_attenuation\nfloat emission=v_color_emissive.a;float opacity=1.0;\n#ifdef HAS_ATTRIBUTE_a_bloom_attenuation\nfloat distance=length(vec2(1.3*max(0.0,abs(bloom_attenuation.x)-bloom_attenuation.z),bloom_attenuation.y));distance+= mix(0.5,0.0,clamp(emission-1.0,0.0,1.0));opacity*=saturate(1.0-distance*distance);\n#endif\n#ifdef RENDER_CUTOFF\nopacity*=v_cutoff_opacity;\n#endif\nglFragColor=vec4(v_color_emissive.rgb,1.0)*opacity;}", "in vec3 a_pos_3f;\n#pragma mapbox: define-attribute-vertex-shader-only highp uvec2 part_color_emissive\n#pragma mapbox: define-attribute highp vec4 bloom_attenuation\nout vec4 v_color_emissive;uniform mat4 u_matrix;vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}void main() {\n#pragma mapbox: initialize-attribute-custom highp uvec2 part_color_emissive\n#pragma mapbox: initialize-attribute highp vec4 bloom_attenuation\n#ifdef HAS_ATTRIBUTE_a_part_color_emissive\nvec4 color_emissive=decode_color(vec2(part_color_emissive));float part_emissive=color_emissive.a*5.0;v_color_emissive=vec4(sRGBToLinear(color_emissive.rgb),part_emissive);\n#else\nv_color_emissive=vec4(1.0);\n#endif\ngl_Position=u_matrix*vec4(a_pos_3f,1.0);\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,native_clip_z_to_cutoff_depth(gl_Position.z,gl_Position.w));\n#endif\n}"),
            buildingDepth: e1.bm("void main() {}", "in ivec2 a_pos_packed;uniform mat4 u_matrix;void main() {vec3 pos=vec3(float(a_pos_packed.x >> 16),float((a_pos_packed.x << 16) >> 16),intBitsToFloat(a_pos_packed.y));gl_Position=u_matrix*vec4(pos,1.0);}"),
            rasterParticle: e1.bm('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform float u_fade_t;uniform float u_opacity;uniform highp float u_raster_elevation;in vec2 v_pos0;in vec2 v_pos1;uniform sampler2D u_image0;uniform sampler2D u_image1;void main() {vec4 color0,color1,color;color0=texture(u_image0,v_pos0);color1=texture(u_image1,v_pos1);if (color0.a > 0.0) color0.rgb/=color0.a;if (color1.a > 0.0) color1.rgb/=color1.a;color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 out_color=color.rgb;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(vec4(out_color,1.0),1.0).rgb;\n#endif\n#ifdef FOG\nhighp float fog_limit_high_meters=1000000.0;highp float fog_limit_low_meters=600000.0;float fog_limit=1.0-smoothstep(fog_limit_low_meters,fog_limit_high_meters,u_raster_elevation);out_color=fog_dither(fog_apply(out_color,v_fog_pos,fog_limit));\n#endif\nglFragColor=vec4(out_color*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform mat3 u_grid_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_raster_elevation;uniform float u_zoom_transition;uniform vec2 u_merc_center;\n#define GLOBE_UPSCALE GLOBE_RADIUS/6371008.8\nin ivec2 a_pos;in uvec2 a_texture_pos;out vec2 v_pos0;out vec2 v_pos1;void main() {float w=1.0;vec2 uv;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float mercatorX=mercatorXfromLng(latLng[1]);float tiles=u_grid_matrix[0][2];float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];float uvX=mercatorX*tiles-idx;float uvY=mercatorY*tiles-idy;uv=vec2(uvX,uvY);vec3 globe_pos=latLngToECEF(latLng.xy);globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;vec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {vec2 merc_pos=vec2(mercatorX,mercatorY);merc_world_pos=vec4(merc_pos,u_raster_elevation,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition)*w,w);gl_Position=u_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n#else\nuv=vec2(a_texture_pos)/8192.0;gl_Position=u_matrix*vec4(vec2(a_pos)*w,u_raster_elevation*w,w);\n#ifdef FOG\nv_fog_pos=fog_position(vec2(a_pos));\n#endif\n#endif\nv_pos0=bottom_left_to_native_uv(uv);v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}'),
            rasterParticleDraw: e1.bm("uniform sampler2D u_color_ramp;in float v_particle_speed;void main() {glFragColor=texture(u_color_ramp,vec2(v_particle_speed,0.5));}", '#include "_prelude_raster_particle.glsl"\nin int a_index;uniform sampler2D u_particle_texture;uniform float u_particle_texture_side_len;uniform vec2 u_tile_offset;out float v_particle_speed;void main() {ivec2 pixel_coord=ivec2(\nmod(float(a_index),u_particle_texture_side_len),float(a_index)/u_particle_texture_side_len);vec4 pixel=texelFetch(u_particle_texture,pixel_coord,0);vec2 pos=unpack_pos_from_rgba(pixel)+u_tile_offset;vec2 tex_coord=fract(pos);vec2 velocity=lookup_velocity(tex_coord);if (velocity==INVALID_VELOCITY) {gl_Position=AWAY;v_particle_speed=0.0;} else {gl_Position=vec4(2.0*pos-1.0,0,1);v_particle_speed=length(velocity);}gl_PointSize=1.0;}'),
            rasterParticleTexture: e1.bm("uniform sampler2D u_texture;uniform float u_opacity;in vec2 v_tex_pos;void main() {vec4 color=texture(u_texture,v_tex_pos);glFragColor=vec4(floor(255.0*color*u_opacity)/255.0);}", "in ivec2 a_pos;out vec2 v_tex_pos;void main() {vec2 uv=0.5*vec2(a_pos)+vec2(0.5);v_tex_pos=bottom_left_to_native_uv(uv);gl_Position=vec4(a_pos,0.0,1.0);}"),
            rasterParticleUpdate: e1.bm('#include "_prelude_raster_particle.glsl"\nuniform sampler2D u_particle_texture;uniform mediump float u_particle_texture_side_len;uniform mediump float u_speed_factor;uniform highp float u_reset_rate;uniform highp float u_rand_seed;in highp vec2 v_tex_coord;vec2 linearstep(vec2 edge0,vec2 edge1,vec2 x) {return  clamp((x-edge0)/(edge1-edge0),vec2(0),vec2(1));}const highp vec3 rand_constants=vec3(12.9898,78.233,4375.85453);highp float rand(const highp vec2 co) {highp float t=dot(rand_constants.xy,co);return fract(sin(t)*(rand_constants.z+t));}void main() {ivec2 pixel_coord=ivec2(v_tex_coord*u_particle_texture_side_len);highp vec4 pixel=texelFetch(u_particle_texture,pixel_coord,0);highp vec2 pos=unpack_pos_from_rgba(pixel);highp vec2 velocity=lookup_velocity(clamp(pos,0.0,1.0));highp vec2 dp=velocity==INVALID_VELOCITY ? vec2(0) : velocity*u_speed_factor;pos=pos+dp;highp vec2 seed=(pos+v_tex_coord)*u_rand_seed;highp vec2 random_pos=vec2(rand(seed+1.3),rand(seed+2.1));highp vec2 persist_rate=pow(\nlinearstep(vec2(-u_particle_pos_offset),vec2(0),pos)*linearstep(vec2(1.0+u_particle_pos_offset),vec2(1),pos),vec2(4)\n);highp vec2 per_frame_persist=pow(persist_rate,abs(dp)/u_particle_pos_offset);highp float drop_rate=1.0-per_frame_persist.x*per_frame_persist.y;drop_rate=any(greaterThanEqual(abs(pos-0.5),vec2(0.5+u_particle_pos_offset))) ? 1.0 : drop_rate;highp float drop=step(1.0-drop_rate-u_reset_rate,rand(seed));highp vec2 next_pos=mix(pos,random_pos,drop);glFragColor=pack_pos_to_rgba(next_pos);}', "in ivec2 a_pos;out vec2 v_tex_coord;void main() {v_tex_coord=0.5*vec2(a_pos+ivec2(1));gl_Position=vec4(a_pos,0.0,1.0);}"),
            snowParticle: e1.bm("in highp vec2 uv;in highp float alphaMultiplier;uniform vec4 u_particleColor;uniform vec2 u_simpleShapeParameters;void main() {float t=clamp((length(uv)-u_simpleShapeParameters.x)/(1.0-u_simpleShapeParameters.x),0.0,1.0);float alpha=1.0-pow(t,pow(10.0,u_simpleShapeParameters.y));alpha*=alphaMultiplier;alpha*=u_particleColor.a;vec3 color=u_particleColor.rgb*alpha;glFragColor=vec4(color,alpha) ;HANDLE_WIREFRAME_DEBUG;}", "\nin highp vec3 a_pos_3f;in highp vec2 a_uv;in highp vec4 a_snowParticleData;in highp vec4 a_snowParticleDataHorizontalOscillation;uniform mat4 u_modelview;uniform mat4 u_projection;uniform vec3 u_cam_pos;uniform vec2 u_screenSize;uniform float u_time;uniform float u_boxSize;uniform float u_velocityConeAperture;uniform float u_velocity;uniform vec3 u_direction;uniform float u_horizontalOscillationRadius;uniform float u_horizontalOscillationRate;uniform float u_billboardSize;uniform vec2 u_thinningCenterPos;uniform vec3 u_thinningShape;uniform float u_thinningAffectedRatio;uniform float u_thinningParticleOffset;out highp vec2 uv;out highp float alphaMultiplier;void main() {vec3 pos=a_pos_3f;float halfBoxSize=0.5*u_boxSize;pos.xyz*=halfBoxSize;pos+=u_cam_pos;float velocityConeApertureRad=radians(u_velocityConeAperture*0.5);float coneAnglePichRad=velocityConeApertureRad*a_snowParticleData.z;float coneAngleHeadingRad=a_snowParticleData.w*radians(360.0);vec3 localZ=normalize(u_direction);vec3 localX=normalize(cross(localZ,vec3(1,0,0)));vec3 localY=normalize(cross(localZ,localX));vec3 direction;direction.x=cos(coneAngleHeadingRad)*sin(coneAnglePichRad);direction.y=sin(coneAngleHeadingRad)*sin(coneAnglePichRad);direction.z=cos(coneAnglePichRad);direction=normalize(direction);vec3 simPosLocal=vec3(0,0,0);float velocityScale=(1.0+3.0*a_snowParticleData.y)*u_velocity;simPosLocal+=direction*velocityScale*u_time;float horizontalOscillationRadius=u_horizontalOscillationRadius*a_snowParticleDataHorizontalOscillation.x;float horizontalOscillationAngle=u_horizontalOscillationRate*u_time*(-1.0+2.0*a_snowParticleDataHorizontalOscillation.y);simPosLocal.xy+=horizontalOscillationRadius*vec2(cos(horizontalOscillationAngle),sin(horizontalOscillationAngle));vec3 simPos=localX*simPosLocal.x+localY*simPosLocal.y+localZ*simPosLocal.z;pos+=simPos;pos=fract((pos+vec3(halfBoxSize))/vec3(u_boxSize))*u_boxSize-vec3(halfBoxSize);float clipZ=-u_cam_pos.z+pos.z;vec4 posView=u_modelview*vec4(pos,1.0);float size=u_billboardSize;alphaMultiplier=1.0;vec4 posScreen=u_projection*posView;posScreen/=posScreen.w;posScreen.xy=vec2(0.5)+posScreen.xy*0.5;posScreen.xy*=u_screenSize;vec2 thinningCenterPos=u_thinningCenterPos.xy;thinningCenterPos.y=u_screenSize.y-thinningCenterPos.y;float screenDist=length((thinningCenterPos-posScreen.xy)/(0.5*u_screenSize));screenDist+=a_snowParticleData.x*u_thinningParticleOffset;float scaleFactorMode=0.0;float thinningShapeDist=u_thinningShape.x+u_thinningShape.y;if (screenDist < thinningShapeDist) {float thinningFadeRatio=clamp((screenDist-u_thinningShape.x)/u_thinningShape.y,0.0,1.0);thinningFadeRatio=pow(thinningFadeRatio,u_thinningShape.z);if (a_snowParticleData.x < u_thinningAffectedRatio) {scaleFactorMode=1.0-thinningFadeRatio;alphaMultiplier=thinningFadeRatio;}}vec4 posScreen1=u_projection*vec4(posView.x-size,posView.yzw);posScreen1/=posScreen1.w;vec4 posScreen2=u_projection*vec4(posView.x+size,posView.yzw);posScreen2/=posScreen2.w;posScreen1.xy=vec2(0.5)+posScreen1.xy*0.5;posScreen1.xy*=u_screenSize;posScreen2.xy=vec2(0.5)+posScreen2.xy*0.5;posScreen2.xy*=u_screenSize;float screenLength=length(posScreen1.xy-posScreen2.xy);float screenEpsilon=3.0;float scaleFactor=1.0;if (screenLength < screenEpsilon) {scaleFactor=screenEpsilon/max(screenLength,0.01);scaleFactor=mix(scaleFactor,1.0,scaleFactorMode);}float screenEpsilon2=15.0;if (screenLength > screenEpsilon2) {scaleFactor=screenEpsilon2/max(screenLength,0.01);}size*=scaleFactor;vec2 right=size*vec2(1,0);vec2 up=size*vec2(0,1);posView.xy+=right*a_uv.x;posView.xy+=up*a_uv.y;uv=a_uv;gl_Position=u_projection*posView;}"),
            rainParticle: e1.bm("in highp vec2 uv;in highp float particleRandomValue;uniform sampler2D u_texScreen;uniform float u_distortionStrength;uniform vec4 u_color;uniform vec2 u_thinningCenterPos;uniform vec3 u_thinningShape;uniform float u_thinningAffectedRatio;uniform float u_thinningParticleOffset;uniform float u_shapeDirectionalPower;uniform float u_mode;void main() {vec2 st=uv*0.5+vec2(0.5);vec2 uvm=uv;uvm.y=-1.0+2.0*pow(st.y,u_shapeDirectionalPower);float shape=clamp(1.0-length(uvm),0.0,1.0);float alpha=abs(shape)*u_color.a;vec2 screenSize=vec2(textureSize(u_texScreen,0));vec2 thinningCenterPos=u_thinningCenterPos.xy;thinningCenterPos.y=screenSize.y-thinningCenterPos.y;float screenDist=length((thinningCenterPos-gl_FragCoord.xy)/(0.5*screenSize));screenDist+=(0.5+0.5*particleRandomValue)*u_thinningParticleOffset;float thinningShapeDist=u_thinningShape.x+u_thinningShape.y;float thinningAlpha=1.0;if (screenDist < thinningShapeDist) {float thinningFadeRatio=clamp((screenDist-u_thinningShape.x)/u_thinningShape.y,0.0,1.0);thinningFadeRatio=pow(thinningFadeRatio,u_thinningShape.z);thinningAlpha*=thinningFadeRatio;}vec2 offsetXY=normalize(uvm)*abs(shape);vec2 stScreen=(gl_FragCoord.xy+offsetXY*u_distortionStrength*thinningAlpha)/screenSize;vec3 colorScreen=texture(u_texScreen,stScreen).rgb;alpha*=thinningAlpha;glFragColor=mix(vec4(colorScreen,1.0),vec4(u_color.rgb*alpha,alpha),u_mode);HANDLE_WIREFRAME_DEBUG;}", "\nin highp vec3 a_pos_3f;in highp vec2 a_uv;in highp vec4 a_rainParticleData;uniform mat4 u_modelview;uniform mat4 u_projection;uniform vec3 u_cam_pos;uniform float u_time;uniform float u_boxSize;uniform float u_velocityConeAperture;uniform float u_velocity;uniform vec2 u_rainDropletSize;uniform vec3 u_rainDirection;out highp vec2 uv;out highp float particleRandomValue;void main() {vec3 pos=a_pos_3f;float halfBoxSize=0.5*u_boxSize;pos*=halfBoxSize;pos+=u_cam_pos;float velocityConeApertureRad=radians(u_velocityConeAperture*0.5);float coneAnglePichRad=velocityConeApertureRad*a_rainParticleData.z;float coneAngleHeadingRad=a_rainParticleData.w*radians(360.0);vec3 localZ=normalize(u_rainDirection);vec3 localX=normalize(cross(localZ,vec3(1,0,0)));vec3 localY=normalize(cross(localZ,localX));vec3 directionLocal;directionLocal.x=cos(coneAngleHeadingRad)*sin(coneAnglePichRad);directionLocal.y=sin(coneAngleHeadingRad)*sin(coneAnglePichRad);directionLocal.z=cos(coneAnglePichRad);directionLocal=normalize(directionLocal);vec3 directionWorld=localX*directionLocal.x+localY*directionLocal.y+localZ*directionLocal.z;float velocityScale=(1.0+3.0*a_rainParticleData.y)*u_velocity;vec3 simPosLocal=vec3(0,0,0);simPosLocal+=directionLocal*velocityScale*u_time;vec3 simPos=localX*simPosLocal.x+localY*simPosLocal.y+localZ*simPosLocal.z;pos+=simPos;pos=fract((pos+vec3(halfBoxSize))/vec3(u_boxSize))*u_boxSize-vec3(halfBoxSize);vec4 posView=u_modelview*vec4(pos,1.0);vec3 directionView=normalize((u_modelview*vec4(directionWorld,0.0)).xyz);vec3 side=cross(directionView,normalize(posView.xyz));posView.xyz+=side*a_uv.x*u_rainDropletSize.x;posView.xyz+=directionView*a_uv.y*u_rainDropletSize.y;uv=a_uv;particleRandomValue=a_rainParticleData.x;gl_Position=u_projection*posView;}"),
            vignette: e1.bm("uniform vec3 u_vignetteShape;uniform vec4 u_vignetteColor;in vec2 st;void main() {float screenDist=length(st);float alpha=clamp((screenDist-u_vignetteShape.x)/u_vignetteShape.y,0.0,1.0);alpha=pow(alpha,u_vignetteShape.z)*u_vignetteColor.a;vec3 color=u_vignetteColor.rgb;glFragColor=vec4(color*alpha,alpha) ;}", "in vec2 a_pos_2f;out vec2 st;void main() {st=a_pos_2f;gl_Position=vec4(a_pos_2f,0,1);}"),
            elevatedStructuresDepth: e1.bm("void main() {}", "in ivec2 a_pos;in float a_height;uniform mat4 u_matrix;uniform float u_depth_bias;void main() {gl_Position=u_matrix*vec4(a_pos,a_height,1);gl_Position.z=gl_Position.z+u_depth_bias;}"),
            elevatedStructures: e1.bm('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_indicator_cutout.fragment.glsl"\n#include "_prelude_feature_cutout.fragment.glsl"\nin vec3 v_normal;in float v_height;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in float v_depth;\n#endif\nvec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}vec3 compute_view_dependent_emissive_color(float ndotl,float emissive_strength,vec3 color)\n{color=sRGBToLinear(color);color=color*(ndotl+(1.0-min(ndotl*57.29,1.0))*emissive_strength);color=linearTosRGB(color.rgb);return color;}uniform float u_emissive_strength;uniform float u_opacity_multiplier;\n#pragma mapbox: define highp vec4 structure_color\nvoid main() {\n#pragma mapbox: initialize highp vec4 structure_color\nvec3 color=structure_color.xyz;vec2 cutout_factors=vec2(0.0);\n#ifdef LIGHTING_3D_MODE\nvec3 normal=normalize(v_normal);vec3 transformed_normal=vec3(-normal.xy,normal.z);float ndotl=calculate_NdotL(transformed_normal);float emissive_strength=u_emissive_strength;emissive_strength=0.0;vec3 emissive_color=compute_view_dependent_emissive_color(ndotl,emissive_strength,color.xyz);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth);light=mix(light,1.0,cutout_factors.y);color.rgb=apply_lighting(color.rgb,transformed_normal,light);\n#else\ncolor=apply_lighting(color,transformed_normal);\n#endif\ncolor=mix(color,emissive_color,emissive_strength);if (v_height < 0.0) {float penetration=max(v_height+7.5,0.0);float occlusion=1.0-1.0/PI*acos(1.0-penetration/4.0);color=color*(1.0-pow(occlusion,2.0)*0.3);}\n#endif\n#ifdef FOG\ncolor=fog_apply(color,v_fog_pos);\n#endif\nvec4 out_color=vec4(color,1.0);out_color*=u_opacity_multiplier;glFragColor=out_color;HANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin ivec2 a_pos;in float a_height;in ivec4 a_pos_normal_3;uniform mat4 u_matrix;out vec3 v_normal;out float v_height;\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out float v_depth;\n#endif\n#pragma mapbox: define highp vec4 structure_color\nvoid main() {\n#pragma mapbox: initialize highp vec4 structure_color\nv_normal=vec3(a_pos_normal_3)/16384.0;v_height=a_height;vec3 pos=vec3(vec2(a_pos),a_height);gl_Position=u_matrix*vec4(pos,1);\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=pos;vec3 shd_pos1=pos;\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(-v_normal.xy,v_normal.z));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(vec2(a_pos));\n#endif\n}'),
            elevatedStructuresDepthReconstruct: e1.bm('#include "_prelude_feature_cutout.fragment.glsl"\n#ifdef DEPTH_RECONSTRUCTION\nin float v_height;\n#endif\nvoid main() {\n#ifdef DEPTH_RECONSTRUCTION\nif (v_height >=0.0)\ndiscard;\n#else\n#endif\nglFragColor=vec4(1.0,0.0,0.0,1.0);}', "in ivec2 a_pos;in float a_height;uniform mat4 u_matrix;uniform vec3 u_camera_pos;uniform highp float u_depth_bias;uniform lowp float u_height_scale;uniform lowp float u_reset_depth;\n#ifdef DEPTH_RECONSTRUCTION\nout float v_height;\n#endif\nvoid main() {vec3 vpos=vec3(a_pos,a_height*u_height_scale);\n#ifdef DEPTH_RECONSTRUCTION\nif (u_camera_pos.z > vpos.z) {vpos-=(u_camera_pos-vpos)*(vpos.z/(u_camera_pos.z-vpos.z));}v_height=a_height;\n#endif\ngl_Position=u_matrix*vec4(vpos,1);gl_Position.z=u_reset_depth==1.0 ? gl_Position.w : gl_Position.z+u_depth_bias;}")
        };
        e1.bm(Bi, "");
        const Ui = e1.b9([
            {
                type: "Float32",
                name: "a_pos_3f",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            },
            {
                type: "Float32",
                name: "a_rainParticleData",
                components: 4
            }
        ]), Ni = e1.b9([
            {
                type: "Float32",
                name: "a_pos_2f",
                components: 2
            }
        ]);
        class ji {
            destroy() {
                this.vignetteVx && this.vignetteVx.destroy(), this.vignetteIdx && this.vignetteIdx.destroy();
            }
            draw(t1, i) {
                const s = t1.getOrCreateProgram("vignette");
                if (!this.vignetteVx || !this.vignetteIdx) {
                    const i = new e1.bn, s = new e1.ak;
                    i.emplaceBack(-1, -1), i.emplaceBack(1, -1), i.emplaceBack(1, 1), i.emplaceBack(-1, 1), s.emplaceBack(0, 1, 2), s.emplaceBack(0, 2, 3), this.vignetteVx = t1.context.createVertexBuffer(i, Ni.members), this.vignetteIdx = t1.context.createIndexBuffer(s);
                }
                const r = e1.aj.simpleSegment(0, 0, 4, 6);
                if (this.vignetteVx && this.vignetteIdx) {
                    t1.uploadCommonUniforms(t1.context, s);
                    const n = {
                        u_vignetteShape: (o = {
                            vignetteShape: [
                                i.start,
                                i.range,
                                Math.pow(10, i.fadePower)
                            ],
                            vignetteColor: [
                                i.color.r,
                                i.color.g,
                                i.color.b,
                                i.color.a * i.strength
                            ]
                        }).vignetteShape,
                        u_vignetteColor: o.vignetteColor
                    };
                    s.draw(t1, t1.context.gl.TRIANGLES, e1.a3.disabled, e1.a4.disabled, e1.a7.alphaBlended, e1.a5.disabled, n, "vignette", this.vignetteVx, this.vignetteIdx, r);
                }
                var o;
            }
        }
        class Vi {
            constructor(){
                this._accumulatedOffsetX = 0, this._accumulatedOffsetY = 0, this._accumulatedElevation = 0;
            }
            update(t1, i) {
                const s = t1.getFreeCameraOptions().position, r = s.toAltitude(), o = s.toLngLat(), n = e1.aF(o.lng), a = e1.aF(o.lat), l = t1.pixelsPerMeter / i, c = n * e1.bu, h = e1.bu * Math.log(Math.tan(Math.PI / 4 + a / 2));
                if (void 0 === this._offsetXPrev) this._offsetXPrev = 0, this._offsetYPrev = 0, this._elevationPrev = 0, this._accumulatedOffsetX = 0, this._accumulatedOffsetY = 0, this._accumulatedElevation = 0;
                else {
                    const e1 = -this._offsetYPrev + h, t1 = -this._elevationPrev + r;
                    this._accumulatedOffsetX += (-this._offsetXPrev + c) * l, this._accumulatedOffsetY += e1 * l, this._accumulatedElevation += t1 * l, this._offsetXPrev = c, this._offsetYPrev = h, this._elevationPrev = r;
                }
            }
            getPosition() {
                return [
                    this._accumulatedOffsetX,
                    this._accumulatedOffsetY,
                    this._accumulatedElevation
                ];
            }
        }
        function Gi(e1, t1) {
            return [
                -(e1[0] - Math.floor(e1[0] / t1) * t1),
                -(e1[1] - Math.floor(e1[1] / t1) * t1),
                -(e1[2] - Math.floor(e1[2] / t1) * t1)
            ];
        }
        function qi(t1) {
            const i = e1.bt(1323123451230), s = [];
            for(let r = 0; r < t1; ++r){
                const t1 = 2 * i() - 1, r = 2 * i() - 1, o = 2 * i() - 1;
                s.push(e1.bs(t1, r, o));
            }
            return s;
        }
        function $i(t1, i, s, r, o) {
            const n = e1.bb((o - s) / (r - s), 0, 1);
            return e1.aw(t1, i, n);
        }
        class Zi {
            constructor(e1){
                this._movement = new Vi, this._accumulatedTimeFromStart = 0, this._prevTime = Date.now() / 1e3, this._vignette = new ji, this._ppmScaleFactor = e1;
            }
            destroy() {
                this.particlesVx && this.particlesVx.destroy(), this.particlesIdx && this.particlesIdx.destroy(), this._vignette && this._vignette.destroy();
            }
            updateOnRender(t1, i) {
                const s = t1.transform;
                this._movement.update(s, this._ppmScaleFactor);
                const r = s.starsProjMatrix, o = e1.bo([]);
                e1.bp(o, o, e1.aF(90) - s._pitch), e1.bq(o, o, -s.angle);
                const n = e1.br(new Float32Array(16), o), a = new Float32Array([
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    -1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1
                ]), l = e1.a_([], a), c = e1.a1([], l, n), h = Date.now() / 1e3;
                return this._accumulatedTimeFromStart += (h - this._prevTime) * i, this._prevTime = h, {
                    projectionMatrix: r,
                    modelviewMatrix: c
                };
            }
        }
        const Wi = e1.b9([
            {
                type: "Float32",
                name: "a_pos_3f",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            },
            {
                type: "Float32",
                name: "a_snowParticleData",
                components: 4
            },
            {
                type: "Float32",
                name: "a_snowParticleDataHorizontalOscillation",
                components: 2
            }
        ]), Hi = (e1, t1)=>({
                u_matrix: e1,
                u_depth_bias: t1
            }), Xi = (e1, t1)=>({
                u_matrix: e1,
                u_ground_shadow_factor: t1,
                u_opacity_multiplier: 1
            }), Yi = (e1, t1, i, s, r)=>({
                u_matrix: e1,
                u_camera_pos: [
                    t1[0],
                    t1[1],
                    t1[2]
                ],
                u_depth_bias: i,
                u_height_scale: s,
                u_reset_depth: r
            }), Ki = {
            building: (t1)=>({
                    u_matrix: new e1.aa(t1),
                    u_normal_matrix: new e1.aa(t1),
                    u_opacity: new e1.a9(t1),
                    u_faux_facade_ao_intensity: new e1.a9(t1),
                    u_camera_pos: new e1.ab(t1),
                    u_tile_to_meter: new e1.a9(t1),
                    u_facade_emissive_chance: new e1.a9(t1),
                    u_flood_light_color: new e1.ab(t1),
                    u_flood_light_intensity: new e1.a9(t1),
                    u_front_cutoff_params: new e1.ab(t1)
                }),
            buildingBloom: (t1)=>({
                    u_matrix: new e1.aa(t1)
                }),
            buildingDepth: (t1)=>({
                    u_matrix: new e1.aa(t1)
                }),
            elevatedStructuresDepth: (t1)=>({
                    u_matrix: new e1.aa(t1),
                    u_depth_bias: new e1.a9(t1)
                }),
            elevatedStructures: (t1)=>({
                    u_matrix: new e1.aa(t1),
                    u_ground_shadow_factor: new e1.ab(t1),
                    u_opacity_multiplier: new e1.a9(t1)
                }),
            elevatedStructuresDepthReconstruct: (t1)=>({
                    u_matrix: new e1.aa(t1),
                    u_camera_pos: new e1.ab(t1),
                    u_depth_bias: new e1.a9(t1),
                    u_height_scale: new e1.a9(t1),
                    u_reset_depth: new e1.a9(t1)
                }),
            rasterParticle: (t1)=>({
                    u_matrix: new e1.aa(t1),
                    u_normalize_matrix: new e1.aa(t1),
                    u_globe_matrix: new e1.aa(t1),
                    u_merc_matrix: new e1.aa(t1),
                    u_grid_matrix: new e1.b8(t1),
                    u_tl_parent: new e1.a8(t1),
                    u_scale_parent: new e1.a9(t1),
                    u_fade_t: new e1.a9(t1),
                    u_opacity: new e1.a9(t1),
                    u_image0: new e1.b6(t1),
                    u_image1: new e1.b6(t1),
                    u_raster_elevation: new e1.a9(t1),
                    u_zoom_transition: new e1.a9(t1),
                    u_merc_center: new e1.a8(t1),
                    u_cutoff_params: new e1.b7(t1)
                }),
            rasterParticleTexture: (t1)=>({
                    u_texture: new e1.b6(t1),
                    u_opacity: new e1.a9(t1)
                }),
            rasterParticleDraw: (t1)=>({
                    u_particle_texture: new e1.b6(t1),
                    u_particle_texture_side_len: new e1.a9(t1),
                    u_tile_offset: new e1.a8(t1),
                    u_velocity: new e1.b6(t1),
                    u_color_ramp: new e1.b6(t1),
                    u_velocity_res: new e1.a8(t1),
                    u_max_speed: new e1.a9(t1),
                    u_uv_offset: new e1.a8(t1),
                    u_data_scale: new e1.a8(t1),
                    u_data_offset: new e1.a9(t1),
                    u_particle_pos_scale: new e1.a9(t1),
                    u_particle_pos_offset: new e1.a8(t1)
                }),
            rasterParticleUpdate: (t1)=>({
                    u_particle_texture: new e1.b6(t1),
                    u_particle_texture_side_len: new e1.a9(t1),
                    u_velocity: new e1.b6(t1),
                    u_velocity_res: new e1.a8(t1),
                    u_max_speed: new e1.a9(t1),
                    u_speed_factor: new e1.a9(t1),
                    u_reset_rate: new e1.a9(t1),
                    u_rand_seed: new e1.a9(t1),
                    u_uv_offset: new e1.a8(t1),
                    u_data_scale: new e1.a8(t1),
                    u_data_offset: new e1.a9(t1),
                    u_particle_pos_scale: new e1.a9(t1),
                    u_particle_pos_offset: new e1.a8(t1)
                }),
            snowParticle: (t1)=>({
                    u_modelview: new e1.aa(t1),
                    u_projection: new e1.aa(t1),
                    u_time: new e1.a9(t1),
                    u_cam_pos: new e1.ab(t1),
                    u_velocityConeAperture: new e1.a9(t1),
                    u_velocity: new e1.a9(t1),
                    u_horizontalOscillationRadius: new e1.a9(t1),
                    u_horizontalOscillationRate: new e1.a9(t1),
                    u_boxSize: new e1.a9(t1),
                    u_billboardSize: new e1.a9(t1),
                    u_simpleShapeParameters: new e1.a8(t1),
                    u_screenSize: new e1.a8(t1),
                    u_thinningCenterPos: new e1.a8(t1),
                    u_thinningShape: new e1.ab(t1),
                    u_thinningAffectedRatio: new e1.a9(t1),
                    u_thinningParticleOffset: new e1.a9(t1),
                    u_particleColor: new e1.b7(t1),
                    u_direction: new e1.ab(t1)
                }),
            rainParticle: (t1)=>({
                    u_modelview: new e1.aa(t1),
                    u_projection: new e1.aa(t1),
                    u_time: new e1.a9(t1),
                    u_cam_pos: new e1.ab(t1),
                    u_texScreen: new e1.b6(t1),
                    u_velocityConeAperture: new e1.a9(t1),
                    u_velocity: new e1.a9(t1),
                    u_boxSize: new e1.a9(t1),
                    u_rainDropletSize: new e1.a8(t1),
                    u_distortionStrength: new e1.a9(t1),
                    u_rainDirection: new e1.ab(t1),
                    u_color: new e1.b7(t1),
                    u_screenSize: new e1.a8(t1),
                    u_thinningCenterPos: new e1.a8(t1),
                    u_thinningShape: new e1.ab(t1),
                    u_thinningAffectedRatio: new e1.a9(t1),
                    u_thinningParticleOffset: new e1.a9(t1),
                    u_shapeDirectionalPower: new e1.a9(t1),
                    u_shapeNormalPower: new e1.a9(t1),
                    u_mode: new e1.a9(t1)
                }),
            vignette: (t1)=>({
                    u_vignetteShape: new e1.ab(t1),
                    u_vignetteColor: new e1.b7(t1)
                })
        };
        function Qi(t1, i) {
            const s = 1 << t1.canonical.z, r = (i.x * s - t1.canonical.x - t1.wrap * s) * e1.ac, o = (i.y * s - t1.canonical.y) * e1.ac, n = e1.bx(i.z, i.y);
            return e1.bs(r, o, n);
        }
        function Ji(e1) {
            let t1 = 0;
            for (const i of e1)t1 |= i.frcMask;
            return t1;
        }
        class es {
            constructor(e1 = []){
                this.tiles = e1;
            }
            getTile(e1) {
                for (const t1 of this.tiles)if (t1.tileId.z === e1.z && t1.tileId.x === e1.x && t1.tileId.y === e1.y) return t1;
                return null;
            }
            getTileOrParent(e1) {
                for(let t1 = e1.z; t1 > 0; --t1){
                    const i = Math.floor(e1.x / (1 << e1.z - t1)), s = Math.floor(e1.y / (1 << e1.z - t1));
                    for (const e1 of this.tiles)if (e1.tileId.z === t1 && e1.tileId.x === i && e1.tileId.y === s && 0 !== e1.frcMask) return e1;
                }
                return null;
            }
            getFullCoverageMask(t1) {
                let i = null, s = 0;
                for(let e1 = t1.z; e1 > 0; --e1){
                    const r = Math.floor(t1.x / (1 << t1.z - e1)), o = Math.floor(t1.y / (1 << t1.z - e1));
                    for (const t1 of this.tiles)if (t1.tileId.z === e1 && t1.tileId.x === r && t1.tileId.y === o) {
                        i = t1, s = e1;
                        break;
                    }
                    if (i) break;
                }
                if (!i || 0 === i.frcMask) return null;
                const r = 1 << t1.z - s, o = e1.ac / r, n = t1.x % r * o, a = t1.y % r * o, l = n + o, c = a + o;
                let h = 0;
                for (const e1 of i.polygons)0 !== e1.frcMask && (e1.hasGeometry() ? 0 === e1.rings.length || t1.z <= s || ts(e1.rings, n, a, l, c) && (h |= e1.frcMask) : h |= e1.frcMask);
                return 0 !== h ? h : null;
            }
            equals(e1) {
                if (this.tiles.length !== e1.length) return !1;
                for(let t1 = 0; t1 < this.tiles.length; ++t1){
                    const i = this.tiles[t1], s = e1[t1];
                    if (i.tileId.z !== s.tileId.z || i.tileId.x !== s.tileId.x || i.tileId.y !== s.tileId.y || i.frcMask !== s.frcMask || i.polygons.length !== s.polygons.length) return !1;
                }
                return !0;
            }
            empty() {
                return 0 === this.tiles.length;
            }
        }
        function ts(e1, t1, i, s, r) {
            const o = [
                0,
                0,
                0,
                0
            ], n = [
                t1,
                s,
                s,
                t1
            ], a = [
                i,
                i,
                r,
                r
            ];
            for (const l of e1){
                const e1 = l.length;
                if (!(e1 < 2)) for(let c = 0, h = e1 - 1; c < e1; h = c++){
                    const e1 = l[h].x, d = l[h].y, u = l[c].x, p = l[c].y;
                    for(let t1 = 0; t1 < 4; ++t1)d > a[t1] != p > a[t1] && n[t1] < e1 + (u - e1) * (a[t1] - d) / (p - d) && o[t1]++;
                    let f = 0, m = 0;
                    if (e1 < t1 ? f |= 1 : e1 > s && (f |= 2), d < i ? f |= 4 : d > r && (f |= 8), u < t1 ? m |= 1 : u > s && (m |= 2), p < i ? m |= 4 : p > r && (m |= 8), !(f & m)) {
                        if (0 === f || 0 === m) return !1;
                        if (is(e1, d, u, p, t1, i, s, r)) return !1;
                    }
                }
            }
            for(let e1 = 0; e1 < 4; ++e1)if (!(1 & o[e1])) return !1;
            return !0;
        }
        function is(e1, t1, i, s, r, o, n, a) {
            const l = (e1, t1, i, s, r, o, n, a)=>{
                const l = (i - e1) * (o - t1) - (s - t1) * (r - e1), c = (i - e1) * (a - t1) - (s - t1) * (n - e1);
                if (l > 0 && c > 0 || l < 0 && c < 0) return !1;
                const h = (n - r) * (t1 - o) - (a - o) * (e1 - r), d = (n - r) * (s - o) - (a - o) * (i - r);
                return !(h > 0 && d > 0 || h < 0 && d < 0);
            };
            return !!(l(e1, t1, i, s, r, o, n, o) || l(e1, t1, i, s, n, o, n, a) || l(e1, t1, i, s, r, a, n, a) || l(e1, t1, i, s, r, o, r, a));
        }
        class ss {
            constructor(){
                this._tileCoverages = [], this._snapshot = new es;
            }
            clear() {
                this._tileCoverages = [];
            }
            addTileCoverage(e1, t1) {
                this._tileCoverages.push({
                    tileId: e1,
                    polygons: t1,
                    frcMask: Ji(t1)
                });
            }
            empty() {
                return 0 === this._tileCoverages.length;
            }
            updateSnapshotIfNeeded() {
                if (this._snapshot.equals(this._tileCoverages)) return this._snapshot;
                const e1 = this._tileCoverages.map((e1)=>({
                        tileId: e1.tileId,
                        polygons: e1.polygons,
                        frcMask: e1.frcMask
                    }));
                return this._snapshot = new es(e1), this._snapshot;
            }
        }
        function rs(e1, t1) {
            const i = {};
            if (!t1) return i;
            for (const s of e1){
                const e1 = s.layerIds.map((e1)=>t1.getLayer(e1)).filter(Boolean);
                if (0 !== e1.length) {
                    s.layers = e1, s.stateDependentLayerIds && (s.stateDependentLayers = s.stateDependentLayerIds.map((t1)=>e1.filter((e1)=>e1.id === t1)[0])), s.updateExpressions && s.updateExpressions(e1);
                    for (const t1 of e1)i[t1.fqid] = s;
                }
            }
            return i;
        }
        const os = 32, ns = 33, as = new Uint16Array(8184);
        for(let e1 = 0; e1 < 2046; e1++){
            let t1 = e1 + 2, i = 0, s = 0, r = 0, o = 0, n = 0, a = 0;
            for(1 & t1 ? r = o = n = os : i = s = a = os; (t1 >>= 1) > 1;){
                const e1 = i + r >> 1, l = s + o >> 1;
                1 & t1 ? (r = i, o = s, i = n, s = a) : (i = r, s = o, r = n, o = a), n = e1, a = l;
            }
            const l = 4 * e1;
            as[l + 0] = i, as[l + 1] = s, as[l + 2] = r, as[l + 3] = o;
        }
        const ls = new Uint16Array(2178), cs = new Uint8Array(1089), hs = new Uint16Array(1089);
        function ds(e1) {
            return 0 === e1 ? -0.03125 : 32 === e1 ? .03125 : 0;
        }
        var us = e1.b9([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            },
            {
                name: "a_texture_pos",
                type: "Uint16",
                components: 2
            }
        ]);
        const ps = (()=>({
                type: 2,
                extent: e1.ac,
                loadGeometry: ()=>[
                        [
                            new e1.P(0, 0),
                            new e1.P(e1.ac + 1, 0),
                            new e1.P(e1.ac + 1, e1.ac + 1),
                            new e1.P(0, e1.ac + 1),
                            new e1.P(0, 0)
                        ]
                    ]
            }))();
        let fs, ms = 0;
        class _s {
            constructor(t1, i, s, r, o, n){
                this.tileID = t1, this.uid = e1.aG(), this.uses = 0, this.tileSize = i, this.tileZoom = s, this.dashIdealZ = t1.overscaledZ, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasTunnelGeometry = !1, this.dependencies = {}, this.isRaster = o, r && r.style && (this._lastUpdatedBrightness = r.style.getBrightness()), this._lastAvailableImagesCount = 0, this._firstPrepareComplete = !1, this._queryPaddingPaintVersions = {}, this.expiredRequestCount = 0, this.state = "loading", r && r.transform && (this.projection = r.transform.projection), this.worldview = n, this._hasAppearances = null;
            }
            registerFadeDuration(t1) {
                const i = t1 + this.timeAdded;
                i < e1.e.now() || void 0 !== this.fadeEndTime && i < this.fadeEndTime || (this.fadeEndTime = i);
            }
            wasRequested() {
                return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
            }
            get tileTransform() {
                return this._tileTransform || (this._tileTransform = e1.bA(this.tileID.canonical, this.projection)), this._tileTransform;
            }
            loadVectorData(t1, i, s) {
                if (this.unloadVectorData(), this.state = "loaded", t1) {
                    t1.featureIndex && (this.latestFeatureIndex = t1.featureIndex, t1.rawTileData ? (this.latestRawTileData = t1.rawTileData, this.latestFeatureIndex.rawTileData = t1.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = t1.collisionBoxArray, this.buckets = rs(t1.buckets, i.style), t1.frcCoveragePolygons && t1.frcCoveragePolygons.length > 0 && (this.frcCoveragePolygons = t1.frcCoveragePolygons), this.hasDeferredRoadStructure = !!t1.hasDeferredRoadStructure, void 0 !== t1.parsedElevationFeatures && (this.parsedElevationFeatures = t1.parsedElevationFeatures, this.parsedElevationGeneration = ++ms), this.hasDeferredElevationFeatures = !!t1.hasDeferredElevationFeatures, this.hasSymbolBuckets = !1, this.hasTunnelGeometry = !!t1.hasTunnelGeometry;
                    for(const t1 in this.buckets){
                        const i = this.buckets[t1];
                        if (i instanceof e1.bF) {
                            if (this.hasSymbolBuckets = !0, !s) break;
                            i.justReloaded = !0;
                        }
                    }
                    this.queryPadding = 0, this._queryPaddingPaintVersions = {};
                    for(const t1 in this.buckets){
                        const s = this.buckets[t1];
                        s instanceof e1.bF && !s.bucketInstanceId && (s.bucketInstanceId = e1.bF.maxBucketInstanceId++);
                        const r = i.style.getOwnLayer(t1);
                        if (!r) continue;
                        const o = r.queryRadius(s) || 0;
                        this.queryPadding = Math.max(this.queryPadding, o), this._queryPaddingPaintVersions[t1] = r.paintVersion;
                    }
                    t1.imageAtlas && (this.imageAtlas = i.style.imageManager.imageAtlasCache.getOrCache(t1.imageAtlas)), t1.glyphAtlasImage && (this.glyphAtlasImage = t1.glyphAtlasImage), t1.lineAtlas && (this.lineAtlas = t1.lineAtlas), this._lastUpdatedBrightness = t1.brightness;
                } else this.collisionBoxArray = new e1.bE;
            }
            resetPlacementVisibility() {
                for(const e1 in this.buckets)this.buckets[e1].resetPlacementVisibility?.();
            }
            unloadVectorData() {
                if (this.hasData()) {
                    for(const e1 in this.buckets)this.buckets[e1].destroy();
                    this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && (this.imageAtlasTexture = null), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.lineAtlasTexture && this.lineAtlasTexture.destroy(), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), this.latestFeatureIndex = null, this.state = "unloaded";
                }
            }
            loadModelData(e1, t1, i) {
                e1 && (e1.resourceTiming && (this.resourceTiming = e1.resourceTiming), this.buckets = {
                    ...this.buckets,
                    ...rs(e1.buckets, t1.style)
                }, e1.featureIndex && (this.latestFeatureIndex = e1.featureIndex));
            }
            getBucket(e1) {
                return this.buckets[e1.fqid];
            }
            upload(t1, i) {
                for(const e1 in this.buckets){
                    const s = this.buckets[e1];
                    if (s.uploadPending()) {
                        let e1 = {}, r = [], o = {
                            zoom: 0,
                            pitch: 0,
                            brightness: 0,
                            worldview: ""
                        };
                        if (i) {
                            if (i.style) {
                                r = i.style.listImages();
                                const t1 = s.layers[0], o = t1.sourceLayer || "_geojsonTileLayer", n = i.style.getLayerSourceCache(t1);
                                n && (e1 = n._state.getState(o, void 0));
                            }
                            o = {
                                zoom: i.transform.zoom || 0,
                                pitch: i.transform.pitch || 0,
                                brightness: i.style.getBrightness() || 0,
                                worldview: i.worldview || ""
                            };
                        }
                        s.upload(t1, this.tileID.canonical, e1, r, o);
                    }
                }
                const s = t1.gl, r = this.imageAtlas;
                r && i && (this.imageAtlasTexture = i.style.imageManager.imageAtlasCache.getTextureForAtlas(r, t1, s.RGBA8)), this.glyphAtlasImage && (this.glyphAtlasTexture = new e1.T(t1, this.glyphAtlasImage, s.R8), this.glyphAtlasImage = null), this.lineAtlas && !this.lineAtlas.uploaded && (this.lineAtlasTexture = new e1.T(t1, this.lineAtlas.image, s.R8), this.lineAtlas.uploaded = !0);
            }
            prepare(e1, t1, i) {
                if (this.imageAtlas && this.imageAtlasTexture && t1) {
                    const s = t1.style.getLut(i);
                    this.imageAtlas.patchUpdatedImages(e1, this.imageAtlasTexture, i, s);
                }
                if (!t1 || !this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData) return;
                const s = t1.style.getBrightness(), r = t1.style.listImages(), o = r.length, n = this._firstPrepareComplete && o !== this._lastAvailableImagesCount;
                this._updatePaint(t1, r, s, n), null === this._hasAppearances && (this._hasAppearances = this.hasAppearances(t1));
                const a = this._lastUpdatedBrightness !== s;
                this._lastAvailableImagesCount = o, this._firstPrepareComplete = !0, (this._lastUpdatedBrightness || s || this._hasAppearances || n) && (!this._hasAppearances && !n && this._lastUpdatedBrightness && s && Math.abs(this._lastUpdatedBrightness - s) < .001 || (this.updateBuckets(t1, a, void 0, n, r), this._lastUpdatedBrightness = s));
            }
            _updatePaint(t1, i, s, r) {
                const o = t1.style;
                for(const n in this.buckets){
                    const a = this.buckets[n], l = o.getOwnLayer(n);
                    l && (a instanceof e1.bG && "line" === l.type ? this._updateBinderPaint(t1, a, a.uboBinders[l.id], l, i, s, r) : a instanceof e1.bF && "symbol" === l.type && (this._updateBinderPaint(t1, a, a.text.uboBinder, l, i, s, r), this._updateBinderPaint(t1, a, a.icon.uboBinder, l, i, s, r)), this._queryPaddingPaintVersions[n] !== l.paintVersion && (this._queryPaddingPaintVersions[n] = l.paintVersion, this.queryPadding = Math.max(this.queryPadding, l.queryRadius(a) || 0)));
                }
            }
            _updateBinderPaint(e1, t1, i, s, r, o, n) {
                if (!i) return;
                const a = i.updatePaint(s);
                if ("unchanged" !== a || n) {
                    if ("features" === a || n) {
                        const n = t1.layers[0], a = n.sourceLayer || "_geojsonTileLayer", l = e1.style.getLayerSourceCache(n), c = l ? l._state.getState(a, void 0) : {}, h = this.latestFeatureIndex.loadVTLayers()[a];
                        i.updateDynamicExpressions(s, h, this.tileID.canonical, r, c, o);
                    }
                    i.upload(e1.context);
                }
            }
            evaluateQueryRenderedFeaturePadding() {
                let e1 = 0;
                for(const t1 in this.buckets){
                    const i = this.buckets[t1];
                    i.evaluateQueryRenderedFeaturePadding && (e1 = Math.max(e1, i.evaluateQueryRenderedFeaturePadding()));
                }
                return e1;
            }
            queryRenderedFeatures(t1, i, s, r, o, n, a) {
                if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData && !this.latestFeatureIndex.is3DTile) return {};
                const l = this.evaluateQueryRenderedFeaturePadding(), c = function(t1, i) {
                    const s = e1.bW([], [
                        .5 * t1.width,
                        .5 * -t1.height,
                        1
                    ]);
                    return e1.bX(s, s, [
                        1,
                        -1,
                        0
                    ]), e1.a1(s, s, t1.calculateProjMatrix(i.toUnwrapped())), Float32Array.from(s);
                }(o, this.tileID);
                return this.latestFeatureIndex.query(t1, {
                    tilespaceGeometry: i,
                    pixelPosMatrix: c,
                    transform: r,
                    availableImages: s,
                    tileTransform: this.tileTransform,
                    worldview: this.worldview,
                    queryRadius: l,
                    scope: a
                });
            }
            querySourceFeatures(t1, i) {
                const s = this.latestFeatureIndex;
                if (!s || !s.rawTileData) return;
                const r = s.loadVTLayers(), o = i ? i.sourceLayer : "", n = r._geojsonTileLayer || r[o];
                if (!n) return;
                const a = e1.bH(i && i.filter), { z: l, x: c, y: h } = this.tileID.canonical, d = {
                    z: l,
                    x: c,
                    y: h
                };
                for(let i = 0; i < n.length; i++){
                    const r = n.feature(i);
                    if (a.needGeometry) {
                        const t1 = e1.bI(r, !0);
                        if (!a.filter(new e1.au(this.tileID.overscaledZ, {
                            worldview: this.worldview
                        }), t1, this.tileID.canonical)) continue;
                    } else if (!a.filter(new e1.au(this.tileID.overscaledZ, {
                        worldview: this.worldview
                    }), r)) continue;
                    const u = s.getId(r, o), p = new e1.bJ(r, l, c, h, u);
                    p.tile = d, t1.push(p);
                }
            }
            loaded() {
                return "loaded" === this.state || "errored" === this.state;
            }
            hasData() {
                return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
            }
            patternsLoaded() {
                return !!this.imageAtlas && !!this.imageAtlas.patternPositions.size;
            }
            setExpiryData(t1) {
                const i = this.expirationTime;
                if (t1.cacheControl) {
                    const i = e1.bK(t1.cacheControl);
                    i["max-age"] && (this.expirationTime = Date.now() + 1e3 * i["max-age"]);
                } else t1.expires && (this.expirationTime = new Date(t1.expires).getTime());
                if (this.expirationTime) {
                    const e1 = Date.now();
                    let t1 = !1;
                    if (this.expirationTime > e1) t1 = !1;
                    else if (i) {
                        if (this.expirationTime < i) t1 = !0;
                        else {
                            const s = this.expirationTime - i;
                            s ? this.expirationTime = e1 + Math.max(s, 3e4) : t1 = !0;
                        }
                    } else t1 = !0;
                    t1 ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
                }
            }
            getExpiryTimeout() {
                if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - Date.now(), Math.pow(2, 31) - 1);
            }
            refreshFeatureState(e1, t1) {
                if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData && !this.latestFeatureIndex.is3DTile || !e1) return;
                const i = e1.style.listImages();
                this.updateBuckets(e1, !1, t1, void 0, i);
            }
            hasAppearances(e1) {
                for(const t1 in this.buckets)if (e1.style.hasLayer(t1) && this.buckets[t1].layers.some((e1)=>e1.appearances && e1.appearances.length > 0)) return !0;
                return !1;
            }
            updateBuckets(t1, i, s, r, o) {
                if (!this.latestFeatureIndex) return;
                if (!t1.style) return;
                const n = o || t1.style.listImages(), a = t1.style.getBrightness();
                for(const o in this.buckets){
                    if (!t1.style.hasLayer(o)) continue;
                    const l = this.buckets[o], c = l.layers[0], h = c.sourceLayer || "_geojsonTileLayer", d = t1.style.getLayerSourceCache(c);
                    let u = s && s[h] || {};
                    d && !s && (u = d._state.getState(h, void 0));
                    const p = this.imageAtlas ? Object.fromEntries(this.imageAtlas.patternPositions) : {}, f = Object.keys(u).length > 0 && !i;
                    l.hasAppearances = l.layers.some((e1)=>e1.appearances && e1.appearances.length > 0);
                    const m = f ? l.stateDependentLayers : l.layers, _ = f && 0 !== l.stateDependentLayers.length;
                    if (_ || i || r) {
                        const s = this.latestFeatureIndex.loadVTLayers();
                        if (l.update(u, s[h], n, p, m, i, a, this.tileID.canonical), l instanceof e1.bF) l.text.uboBinder && l.text.uboBinder.upload(t1.context), l.icon.uboBinder && l.icon.uboBinder.upload(t1.context);
                        else if (l instanceof e1.bG) for (const { id: e1 } of l.layers)l.uboBinders[e1].upload(t1.context);
                    }
                    if (_ || i || l.hasAppearances) {
                        const i = {
                            zoom: t1.transform.zoom,
                            pitch: t1.transform.pitch,
                            brightness: t1.style.getBrightness() || 0,
                            worldview: t1.worldview
                        }, s = l.updateAppearances(this.tileID.canonical, u, n, i, t1.imageManager, _);
                        s && s.hasUboChanges && l instanceof e1.bF && (l.text.uboBinder && l.text.uboBinder.upload(t1.context), l.icon.uboBinder && l.icon.uboBinder.upload(t1.context));
                    }
                    (l instanceof e1.bG || l instanceof e1.bL) && t1._terrain && t1._terrain.enabled && d && l.uploadPending() && t1._terrain._clearRenderCacheForTile(d.id, this.tileID);
                    const g = t1 && t1.style && t1.style.getOwnLayer(o);
                    g && (this.queryPadding = Math.max(this.queryPadding, g.queryRadius(l) || 0));
                }
            }
            holdingForFade() {
                return void 0 !== this.symbolFadeHoldUntil;
            }
            symbolFadeFinished() {
                return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < e1.e.now();
            }
            clearFadeHold() {
                this.symbolFadeHoldUntil = void 0;
            }
            setHoldDuration(t1) {
                this.symbolFadeHoldUntil = e1.e.now() + t1;
            }
            setTexture(t1, i) {
                const s = i.context, r = s.gl;
                this.texture = this.texture || i.getTileTexture(t1.width), this.texture && this.texture instanceof e1.T ? this.texture.update(t1) : (this.texture = new e1.T(s, t1, r.RGBA8, {
                    useMipmap: !0
                }), this.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE));
            }
            setDependencies(e1, t1) {
                const i = {};
                for (const e1 of t1)i[e1] = !0;
                this.dependencies[e1] = i;
            }
            hasDependency(e1, t1) {
                for (const i of e1){
                    const e1 = this.dependencies[i];
                    if (e1) {
                        for (const i of t1)if (e1[i]) return !0;
                    }
                }
                return !1;
            }
            clearQueryDebugViz() {}
            _makeDebugTileBoundsBuffers(t1, i) {
                if (!i || "mercator" === i.name || this._tileDebugBuffer) return;
                const s = e1.bM(ps, this.tileID.canonical, this.tileTransform)[0], r = new e1.bN, o = new e1.bO;
                for(let e1 = 0; e1 < s.length; e1++){
                    const { x: t1, y: i } = s[e1];
                    r.emplaceBack(t1, i), o.emplaceBack(e1);
                }
                o.emplaceBack(0), this._tileDebugIndexBuffer = t1.createIndexBuffer(o), this._tileDebugBuffer = t1.createVertexBuffer(r, e1.bP.members), this._tileDebugSegments = e1.aj.simpleSegment(0, 0, r.length, o.length);
            }
            _makeTileBoundsBuffers(t1, i) {
                if (this._tileBoundsBuffer || !i || "mercator" === i.name) return;
                const s = e1.bM(ps, this.tileID.canonical, this.tileTransform)[0];
                let r, o;
                if (this.isRaster) {
                    const t1 = function(t1, i) {
                        const s = e1.bA(t1, i), r = Math.pow(2, t1.z);
                        for(let o = 0; o < ns; o++)for(let n = 0; n < ns; n++){
                            const a = e1.bB((t1.x + (n + ds(n)) / os) / r), l = e1.bC((t1.y + (o + ds(o)) / os) / r), c = i.project(a, l), h = o * ns + n;
                            ls[2 * h + 0] = Math.round((c.x * s.scale - s.x) * e1.ac), ls[2 * h + 1] = Math.round((c.y * s.scale - s.y) * e1.ac);
                        }
                        cs.fill(0), hs.fill(0);
                        for(let e1 = 2045; e1 >= 0; e1--){
                            const t1 = 4 * e1, i = as[t1 + 0], s = as[t1 + 1], r = as[t1 + 2], o = as[t1 + 3], n = i + r >> 1, a = s + o >> 1, l = n + a - s, c = a + i - n, h = s * ns + i, d = o * ns + r, u = a * ns + n, p = Math.hypot((ls[2 * h + 0] + ls[2 * d + 0]) / 2 - ls[2 * u + 0], (ls[2 * h + 1] + ls[2 * d + 1]) / 2 - ls[2 * u + 1]) >= 16;
                            cs[u] = cs[u] || (p ? 1 : 0), e1 < 1022 && (cs[u] = cs[u] || cs[(s + c >> 1) * ns + (i + l >> 1)] || cs[(o + c >> 1) * ns + (r + l >> 1)]);
                        }
                        const o = new e1.bD, n = new e1.ak;
                        let a = 0;
                        function l(t1, i) {
                            const s = i * ns + t1;
                            return 0 === hs[s] && (o.emplaceBack(ls[2 * s + 0], ls[2 * s + 1], t1 * e1.ac / os, i * e1.ac / os), hs[s] = ++a), hs[s] - 1;
                        }
                        function c(e1, t1, i, s, r, o) {
                            const a = e1 + i >> 1, h = t1 + s >> 1;
                            if (Math.abs(e1 - r) + Math.abs(t1 - o) > 1 && cs[h * ns + a]) c(r, o, e1, t1, a, h), c(i, s, r, o, a, h);
                            else {
                                const a = l(e1, t1), c = l(i, s), h = l(r, o);
                                n.emplaceBack(a, c, h);
                            }
                        }
                        return c(0, 0, os, os, os, 0), c(os, os, 0, 0, 0, os), {
                            vertices: o,
                            indices: n
                        };
                    }(this.tileID.canonical, i);
                    r = t1.vertices, o = t1.indices;
                } else {
                    r = new e1.bD, o = new e1.ak;
                    for (const { x: e1, y: t1 } of s)r.emplaceBack(e1, t1, 0, 0);
                    const t1 = e1.bQ(r.int16.subarray(0, 4 * r.length), void 0, 4);
                    for(let e1 = 0; e1 < t1.length; e1 += 3)o.emplaceBack(t1[e1], t1[e1 + 1], t1[e1 + 2]);
                }
                this._tileBoundsBuffer = t1.createVertexBuffer(r, us.members), this._tileBoundsIndexBuffer = t1.createIndexBuffer(o), this._tileBoundsSegments = e1.aj.simpleSegment(0, 0, r.length, o.length);
            }
            _makeGlobeTileDebugBuffers(t1, i) {
                const s = i.projection;
                if (!s || "globe" !== s.name || i.freezeTileCoverage) return;
                const r = this.tileID.canonical, o = e1.$(r, i), n = e1.bf(o), a = e1._(i.zoom);
                let l;
                a > 0 && (l = e1.aZ(new Float64Array(16), i.globeMatrix)), this._makeGlobeTileDebugBorderBuffer(t1, r, i, n, l, a), this._makeGlobeTileDebugTextBuffer(t1, r, i, n, l, a);
            }
            _globePoint(t1, i, s, r, o, n, a) {
                let l = e1.bR(t1, i, s);
                if (n) {
                    const o = 1 << s.z, c = e1.ad(r.center.lng), h = e1.ae(r.center.lat), d = (s.x + .5) / o - c;
                    let u = 0;
                    d > .5 ? u = -1 : d < -0.5 && (u = 1);
                    let p = (t1 / e1.ac + s.x) / o + u, f = (i / e1.ac + s.y) / o;
                    p = (p - c) * r._pixelsPerMercatorPixel + c, f = (f - h) * r._pixelsPerMercatorPixel + h;
                    const m = [
                        p * r.worldSize,
                        f * r.worldSize,
                        0
                    ];
                    e1.bS(m, m, n), l = e1.bT(l, m, a);
                }
                return e1.bS(l, l, o);
            }
            _makeGlobeTileDebugBorderBuffer(t1, i, s, r, o, n) {
                const a = new e1.bN, l = new e1.bO, c = new e1.bU, h = (e1, t1, h, d, u)=>{
                    const p = (h - e1) / (u - 1), f = (d - t1) / (u - 1), m = a.length;
                    for(let h = 0; h < u; h++){
                        const d = e1 + h * p, u = t1 + h * f;
                        a.emplaceBack(d, u);
                        const _ = this._globePoint(d, u, i, s, r, o, n);
                        c.emplaceBack(_[0], _[1], _[2]), l.emplaceBack(m + h);
                    }
                }, d = e1.ac;
                h(0, 0, d, 0, 16), h(d, 0, d, d, 16), h(d, d, 0, d, 16), h(0, d, 0, 0, 16), this._tileDebugIndexBuffer = t1.createIndexBuffer(l), this._tileDebugBuffer = t1.createVertexBuffer(a, e1.bP.members), this._globeTileDebugBorderBuffer = t1.createVertexBuffer(c, e1.bV.members), this._tileDebugSegments = e1.aj.simpleSegment(0, 0, a.length, l.length);
            }
            _makeGlobeTileDebugTextBuffer(t1, i, s, r, o, n) {
                const a = e1.ac / 4, l = new e1.bN, c = new e1.ak, h = new e1.bU, d = 25;
                c.reserve(32), l.reserve(d), h.reserve(d);
                const u = (e1, t1)=>d * e1 + t1;
                for(let e1 = 0; e1 < d; e1++){
                    const t1 = e1 * a;
                    for(let e1 = 0; e1 < d; e1++){
                        const c = e1 * a;
                        l.emplaceBack(c, t1);
                        const d = this._globePoint(c, t1, i, s, r, o, n);
                        h.emplaceBack(d[0], d[1], d[2]);
                    }
                }
                for(let e1 = 0; e1 < 4; e1++)for(let t1 = 0; t1 < 4; t1++){
                    const i = u(e1, t1), s = u(e1, t1 + 1), r = u(e1 + 1, t1), o = u(e1 + 1, t1 + 1);
                    c.emplaceBack(i, s, r), c.emplaceBack(r, s, o);
                }
                this._tileDebugTextIndexBuffer = t1.createIndexBuffer(c), this._tileDebugTextBuffer = t1.createVertexBuffer(l, e1.bP.members), this._globeTileDebugTextBuffer = t1.createVertexBuffer(h, e1.bV.members), this._tileDebugTextSegments = e1.aj.simpleSegment(0, 0, d, 32);
            }
            destroy(t1 = !0) {
                for(const e1 in this.buckets)this.buckets[e1].destroy(t1);
                this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && delete this.imageAtlasTexture, this.glyphAtlasTexture && (this.glyphAtlasTexture.destroy(), delete this.glyphAtlasTexture), this.lineAtlasTexture && (this.lineAtlasTexture.destroy(), delete this.lineAtlasTexture), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), t1 && this.texture && this.texture instanceof e1.T && (this.texture.destroy(), delete this.texture), this.emissiveTexture && this.emissiveTexture instanceof e1.T && (this.emissiveTexture.destroy(), delete this.emissiveTexture), this.hillshadeFBO && (this.hillshadeFBO.destroy(), delete this.hillshadeFBO), this.dem && delete this.dem, this.neighboringTiles && delete this.neighboringTiles, this.demTexture && (this.demTexture.destroy(), delete this.demTexture), this.rasterParticleState && (this.rasterParticleState.destroy(), delete this.rasterParticleState), this.latestFeatureIndex = null, this.state = "unloaded";
            }
        }
        class gs {
            constructor(e1, t1){
                this.max = e1, this.onRemove = t1, this.reset();
            }
            reset() {
                for(const e1 in this.data)for (const t1 of this.data[e1])t1.timeout && clearTimeout(t1.timeout), this.onRemove(t1.value);
                return this.data = {}, this.order = [], this;
            }
            add(e1, t1, i) {
                const s = e1.wrapped().key;
                void 0 === this.data[s] && (this.data[s] = []);
                const r = {
                    value: t1,
                    timeout: void 0
                };
                if (void 0 !== i && (r.timeout = setTimeout(()=>{
                    this.remove(e1, r);
                }, i)), this.data[s].push(r), this.order.push(s), this.order.length > this.max) {
                    const e1 = this._getAndRemoveByKey(this.order[0]);
                    e1 && this.onRemove(e1);
                }
                return this;
            }
            has(e1) {
                return e1.wrapped().key in this.data;
            }
            getAndRemove(e1) {
                return this.has(e1) ? this._getAndRemoveByKey(e1.wrapped().key) : null;
            }
            _getAndRemoveByKey(e1) {
                const t1 = this.data[e1].shift();
                return t1.timeout && clearTimeout(t1.timeout), 0 === this.data[e1].length && delete this.data[e1], this.order.splice(this.order.indexOf(e1), 1), t1.value;
            }
            getByKey(e1) {
                const t1 = this.data[e1];
                return t1 ? t1[0].value : null;
            }
            get(e1) {
                return this.has(e1) ? this.data[e1.wrapped().key][0].value : null;
            }
            remove(e1, t1) {
                if (!this.has(e1)) return this;
                const i = e1.wrapped().key, s = void 0 === t1 ? 0 : this.data[i].indexOf(t1), r = this.data[i][s];
                return this.data[i].splice(s, 1), r.timeout && clearTimeout(r.timeout), 0 === this.data[i].length && delete this.data[i], this.onRemove(r.value), this.order.splice(this.order.indexOf(i), 1), this;
            }
            setMaxSize(e1) {
                for(this.max = e1; this.order.length > this.max;){
                    const e1 = this._getAndRemoveByKey(this.order[0]);
                    e1 && this.onRemove(e1);
                }
                return this;
            }
            filter(e1) {
                const t1 = [];
                for(const i in this.data)for (const s of this.data[i])e1(s.value) || t1.push(s);
                for (const e1 of t1)this.remove(e1.value.tileID, e1);
            }
        }
        class ys {
            constructor(){
                this.state = Object.create(null), this.stateChanges = Object.create(null), this.deletedStates = Object.create(null);
            }
            updateState(e1, t1, i) {
                const s = String(t1);
                if (this.stateChanges[e1] = this.stateChanges[e1] || Object.create(null), this.stateChanges[e1][s] = this.stateChanges[e1][s] || Object.create(null), Object.assign(this.stateChanges[e1][s], i), null === this.deletedStates[e1]) {
                    this.deletedStates[e1] = Object.create(null);
                    for(const t1 in this.state[e1])t1 !== s && (this.deletedStates[e1][t1] = null);
                } else if (this.deletedStates[e1] && null === this.deletedStates[e1][s]) {
                    this.deletedStates[e1][s] = Object.create(null);
                    for(const t1 in this.state[e1][s])i[t1] || (this.deletedStates[e1][s][t1] = null);
                } else for(const t1 in i)this.deletedStates[e1] && this.deletedStates[e1][s] && null === this.deletedStates[e1][s][t1] && delete this.deletedStates[e1][s][t1];
            }
            removeFeatureState(e1, t1, i) {
                if (null === this.deletedStates[e1]) return;
                const s = String(t1);
                if (this.deletedStates[e1] = this.deletedStates[e1] || Object.create(null), i && void 0 !== t1) null !== this.deletedStates[e1][s] && (this.deletedStates[e1][s] = this.deletedStates[e1][s] || Object.create(null), this.deletedStates[e1][s][i] = null);
                else if (void 0 !== t1) {
                    if (this.stateChanges[e1] && this.stateChanges[e1][s]) for(i in this.deletedStates[e1][s] = Object.create(null), this.stateChanges[e1][s])this.deletedStates[e1][s][i] = null;
                    else this.deletedStates[e1][s] = null;
                } else this.deletedStates[e1] = null;
            }
            getState(e1, t1) {
                const i = this.state[e1] || Object.create(null), s = this.stateChanges[e1] || Object.create(null), r = this.deletedStates[e1];
                if (null === r) return Object.create(null);
                if (void 0 !== t1) {
                    const e1 = String(t1), o = Object.assign(Object.create(null), i[e1], s[e1]);
                    if (r) {
                        const e1 = r[t1];
                        if (null === e1) return Object.create(null);
                        for(const t1 in e1)delete o[t1];
                    }
                    return o;
                }
                const o = Object.assign(Object.create(null), i, s);
                if (r) for(const e1 in r)delete o[e1];
                return o;
            }
            initializeTileState(e1, t1) {
                e1.refreshFeatureState(t1);
            }
            coalesceChanges(e1, t1) {
                const i = Object.create(null);
                for(const e1 in this.stateChanges){
                    this.state[e1] = this.state[e1] || Object.create(null);
                    const t1 = Object.create(null);
                    for(const i in this.stateChanges[e1])this.state[e1][i] || (this.state[e1][i] = Object.create(null)), Object.assign(this.state[e1][i], this.stateChanges[e1][i]), t1[i] = this.state[e1][i];
                    i[e1] = t1;
                }
                for(const e1 in this.deletedStates){
                    this.state[e1] = this.state[e1] || Object.create(null);
                    const t1 = Object.create(null);
                    if (null === this.deletedStates[e1]) for(const i in this.state[e1])t1[i] = Object.create(null), this.state[e1][i] = Object.create(null);
                    else for(const i in this.deletedStates[e1]){
                        if (null === this.deletedStates[e1][i]) this.state[e1][i] = Object.create(null);
                        else if (this.state[e1][i]) for (const t1 of Object.keys(this.deletedStates[e1][i]))delete this.state[e1][i][t1];
                        t1[i] = this.state[e1][i];
                    }
                    i[e1] = i[e1] || Object.create(null), Object.assign(i[e1], t1);
                }
                if (this.stateChanges = Object.create(null), this.deletedStates = Object.create(null), 0 !== Object.keys(i).length) for (const s of e1.values())s.refreshFeatureState(t1, i);
            }
        }
        class vs extends e1.E {
            constructor(e1, t1, i, s){
                super(), this.id = e1, this.type = t1.type, this._options = t1, this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.setEventedParent(s);
            }
            hasTransition() {
                return !1;
            }
            startLoad() {
                const e1 = this._loader;
                this._loader = void 0, e1 && e1();
            }
            loaded() {
                return void 0 !== this._loader;
            }
            onAdd(e1) {}
            onRemove(e1) {}
            loadTile(e1, t1) {}
            serialize() {
                return this._options;
            }
        }
        class bs extends e1.E {
            constructor(e1, t1, i){
                super(), this.id = e1, this._renderSourceType = i, this._maxzoomOverride = null, this.setSource(t1), this._tiles = new Map, this._cache = new gs(0, this._unloadTile.bind(this)), this._timers = new Map, this._minTileCacheSize = t1.minTileCacheSize, this._maxTileCacheSize = t1.maxTileCacheSize, this._loadedParentTiles = new Map, this.castsShadows = !1, this.tileCoverLift = 0, this._coveredTiles = new Set, this._shadowCasterTiles = new Set, this._state = new ys, this._isRaster = "raster" === this._source.type || "raster-dem" === this._source.type || "raster-array" === this._source.type || "custom" === this._source.type && "_dataType" in this._source && "raster" === this._source._dataType, this._supportsFading = "raster" === this._source.type || "raster-array" === this._source.type || "image" === this._source.type || "video" === this._source.type || "custom" === this._source.type, this._isRasterElevatedOverTerrain = !1;
            }
            onAdd(e1) {
                this.map = e1, this._minTileCacheSize = void 0 === this._minTileCacheSize && e1 ? e1._minTileCacheSize : this._minTileCacheSize, this._maxTileCacheSize = void 0 === this._maxTileCacheSize && e1 ? e1._maxTileCacheSize : this._maxTileCacheSize;
            }
            setSource(e1) {
                e1.on("data", (e1)=>{
                    "source" === e1.dataType && "metadata" === e1.sourceDataType && (this._sourceLoaded = !0), this._sourceLoaded && !this._paused && "source" === e1.dataType && "content" === e1.sourceDataType && (this.reload(), this.transform && this.update(this.transform));
                }), e1.on("error", ()=>{
                    this._sourceErrored = !0;
                }), this._source = e1;
            }
            loaded() {
                if (this._sourceErrored) return !0;
                if (this._source instanceof vs) return this._source.loaded();
                if (!this._sourceLoaded) return !1;
                if (!this._source.loaded()) return !1;
                for (const e1 of this._tiles.values())if (!e1.loaded()) return !1;
                return !0;
            }
            getSource() {
                return this._source;
            }
            pause() {
                this._paused = !0;
            }
            resume() {
                if (!this._paused) return;
                const e1 = this._shouldReloadOnResume;
                this._paused = !1, this._shouldReloadOnResume = !1, e1 && this.reload(), this.transform && this.update(this.transform);
            }
            setMaxzoomOverride(e1) {
                this._maxzoomOverride = e1;
            }
            _loadTile(e1, t1) {
                return e1.renderSourceType = this._renderSourceType, e1.isExtraShadowCaster = this._shadowCasterTiles.has(e1.tileID.key), this._source.loadTile(e1, t1);
            }
            _unloadTile(e1) {
                if (e1.aborted = !0, this._abortTile(e1), this._source.unloadTile) return this._source.unloadTile(e1);
            }
            _abortTile(e1) {
                if (this._source.abortTile) return this._source.abortTile(e1);
            }
            serialize() {
                return this._source.serialize();
            }
            prepare(e1) {
                this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
                for (const [t1, i] of this._tiles)i.upload(e1, this.map ? this.map.painter : void 0), i.imageAtlas && !i.imageAtlasTexture && "loaded" === i.state && this._reloadTile(t1, "reloading"), i.prepare(this.map.style.imageManager, this.map ? this.map.painter : null, this._source.scope);
            }
            getIds() {
                return Array.from(this._tiles.values(), (e1)=>e1.tileID).sort(xs).map((e1)=>e1.key);
            }
            getRenderableIds(t1, i) {
                const s = [];
                for (const e1 of this._tiles.values())this._isTileRenderable(e1, t1, i) && s.push(e1);
                return t1 ? s.sort((t1, i)=>{
                    const s = t1.tileID, r = i.tileID, o = new e1.P(s.canonical.x, s.canonical.y)._rotate(this.transform.angle), n = new e1.P(r.canonical.x, r.canonical.y)._rotate(this.transform.angle);
                    return s.overscaledZ - r.overscaledZ || n.y - o.y || n.x - o.x;
                }).map((e1)=>e1.tileID.key) : s.map((e1)=>e1.tileID).sort(xs).map((e1)=>e1.key);
            }
            hasRenderableParent(e1) {
                const t1 = this.findLoadedParent(e1, 0);
                return !!t1 && this._isIdRenderable(t1.tileID.key);
            }
            _isIdRenderable(e1, t1, i) {
                const s = this._tiles.get(e1);
                return !!s && this._isTileRenderable(s, t1, i);
            }
            _isTileRenderable(e1, t1, i) {
                const s = e1.tileID.key;
                return e1.hasData() && !this._coveredTiles.has(s) && (t1 || !e1.holdingForFade()) && (i || !this._shadowCasterTiles.has(s));
            }
            reload() {
                if (this._paused) this._shouldReloadOnResume = !0;
                else {
                    this._cache.reset();
                    for (const [e1, t1] of this._tiles)"errored" !== t1.state && this._reloadTile(e1, "reloading");
                }
            }
            _reloadTile(e1, t1) {
                const i = this._tiles.get(e1);
                i && ("loading" !== i.state && (i.state = t1), this._loadTile(i, this._tileLoaded.bind(this, i, e1, t1)));
            }
            _tileLoaded(t1, i, s, r, o) {
                if (t1.aborted) return;
                if (r) {
                    if (t1.state = "errored", e1.bY(r)) {
                        if (this._source.fire(new e1.i("data", {
                            dataType: "source",
                            sourceDataType: "error",
                            sourceId: this._source.id,
                            tile: t1
                        })), !this._loadedParentTiles.has(t1.tileID.key)) return;
                        if ("raster-dem" === this._source.type && this.usedForTerrain && this.map.painter.terrain) {
                            const e1 = this.map.painter.terrain;
                            this.update(this.transform, e1.getScaledDemTileSize(), !0), e1.resetTileLookupCache(this.id);
                        } else this.update(this.transform);
                    } else this._source.fire(new e1.h(r, {
                        tile: t1
                    }));
                    return;
                }
                t1.timeAdded = e1.e.now(), "expired" === s && (t1.refreshedUponExpiration = !0), this._setTileReloadTimer(i, t1), "raster-dem" === this._source.type && t1.dem && this._backfillDEM(t1), this._state.initializeTileState(t1, this.map ? this.map.painter : null);
                let n = new Headers;
                o && o.headers && (n = o.headers), this._source.fire(new e1.i("data", {
                    dataType: "source",
                    tile: t1,
                    coord: t1.tileID,
                    sourceCacheId: this.id,
                    responseHeaders: n
                }));
            }
            _hasTunnelGeometry() {
                for (const e1 of this._tiles.values())if (e1.hasTunnelGeometry) return !0;
                return !1;
            }
            _backfillDEM(e1) {
                const t1 = this.getRenderableIds();
                for(let s = 0; s < t1.length; s++){
                    const r = t1[s];
                    if (e1.neighboringTiles && e1.neighboringTiles[r]) {
                        const t1 = this.getTileByID(r);
                        i(e1, t1), i(t1, e1);
                    }
                }
                function i(e1, t1) {
                    if (!e1.dem || e1.dem.borderReady) return;
                    e1.needsHillshadePrepare = !0, e1.needsDEMTextureUpload = !0;
                    let i = t1.tileID.canonical.x - e1.tileID.canonical.x;
                    const s = t1.tileID.canonical.y - e1.tileID.canonical.y, r = Math.pow(2, e1.tileID.canonical.z), o = t1.tileID.key;
                    0 === i && 0 === s || Math.abs(s) > 1 || (Math.abs(i) > 1 && (1 === Math.abs(i + r) ? i += r : 1 === Math.abs(i - r) && (i -= r)), t1.dem && e1.dem && (e1.dem.backfillBorder(t1.dem, i, s), e1.neighboringTiles && e1.neighboringTiles[o] && (e1.neighboringTiles[o].backfilled = !0)));
                }
            }
            getTile(e1) {
                return this.getTileByID(e1.key);
            }
            getTileByID(e1) {
                return this._tiles.get(e1);
            }
            _retainLoadedChildren(e1, t1, i, s) {
                const r = "raster-array" === this._source.type;
                for (const [o, n] of this._tiles){
                    let a = n;
                    if (s.has(o) || !a.hasData() || a.tileID.overscaledZ <= t1 || a.tileID.overscaledZ > i) continue;
                    if (r && a.parentTile) continue;
                    let l = a.tileID;
                    for(; a && a.tileID.overscaledZ > t1 + 1;){
                        const e1 = a.tileID.scaledTo(a.tileID.overscaledZ - 1);
                        a = this._tiles.get(e1.key), a && a.hasData() && (l = e1);
                    }
                    let c = l;
                    for(; c.overscaledZ > t1;)if (c = c.scaledTo(c.overscaledZ - 1), e1.has(c.key)) {
                        s.set(l.key, l);
                        const e1 = this._tiles.get(l.key);
                        e1 && (e1.dashIdealZ = c.overscaledZ);
                        break;
                    }
                }
            }
            findLoadedParent(e1, t1) {
                if (this._loadedParentTiles.has(e1.key)) {
                    const i = this._loadedParentTiles.get(e1.key);
                    return i && i.tileID.overscaledZ >= t1 ? i : null;
                }
                for(let i = e1.overscaledZ - 1; i >= t1; i--){
                    const t1 = e1.scaledTo(i), s = this._getLoadedTile(t1);
                    if (s) return s;
                }
            }
            _getLoadedTile(e1) {
                const t1 = this._tiles.get(e1.key);
                return t1 && t1.hasData() ? t1 : this._cache.getByKey(this._source.reparseOverscaled ? e1.wrapped().key : e1.canonical.key);
            }
            updateCacheSize(e1, t1) {
                t1 = t1 || this._source.tileSize;
                const i = Math.ceil(e1.width / t1) + 1, s = Math.ceil(e1.height / t1) + 1, r = Math.floor(i * s * 5), o = "number" == typeof this._minTileCacheSize ? Math.max(this._minTileCacheSize, r) : r, n = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, o) : o;
                this._cache.setMaxSize(n);
            }
            handleWrapJump(e1) {
                const t1 = Math.round((e1 - (void 0 === this._prevLng ? e1 : this._prevLng)) / 360);
                if (this._prevLng = e1, t1) {
                    const e1 = new Map;
                    for (const i of this._tiles.values())i.tileID = i.tileID.unwrapTo(i.tileID.wrap + t1), e1.set(i.tileID.key, i);
                    this._tiles = e1;
                    for (const e1 of this._timers.values())clearTimeout(e1);
                    this._timers.clear();
                    for (const [e1, t1] of this._tiles)this._setTileReloadTimer(e1, t1);
                }
            }
            update(t1, i, s, r, o) {
                if (this.transform = t1, !this._sourceLoaded || this._paused || this.transform.freezeTileCoverage) return;
                if (this.usedForTerrain && !s) return;
                this.updateCacheSize(t1, i), "globe" !== this.transform.projection.name && this.handleWrapJump(this.transform.center.lng), this._shadowCasterTiles = new Set, this._coveredTiles = new Set;
                const n = "batched-model" === this._source.type;
                let a, l = this._source.maxzoom;
                null !== this._maxzoomOverride && (l = Math.min(l, this._maxzoomOverride));
                const c = this.map && this.map.painter ? this.map.painter._terrain : null;
                if (c && c.sourceCache === this && c.attenuationRange()) {
                    const e1 = c.attenuationRange()[0], t1 = Math.floor(e1) - Math.log2(c.getDemUpscale());
                    l > t1 && (l = t1);
                }
                const h = null === this._maxzoomOverride && this._source.reparseOverscaled;
                if (this.used || this.usedForTerrain) {
                    if (this._source.tileID) a = t1.getVisibleUnwrappedCoordinates(this._source.tileID).map((t1)=>new e1.bZ(t1.canonical.z, t1.wrap, t1.canonical.z, t1.canonical.x, t1.canonical.y));
                    else if (0 !== this.tileCoverLift) {
                        const r = t1.clone();
                        r.tileCoverLift = this.tileCoverLift, a = r.coveringTiles({
                            tileSize: i || this._source.tileSize,
                            minzoom: this._source.minzoom,
                            maxzoom: l,
                            roundZoom: this._source.roundZoom && !s,
                            reparseOverscaled: h,
                            isTerrainDEM: this.usedForTerrain,
                            calculateQuadrantVisibility: n
                        }), this._source.minzoom <= 1 && "globe" === t1.projection.name && (a.push(new e1.bZ(1, 0, 1, 0, 0)), a.push(new e1.bZ(1, 0, 1, 1, 0)), a.push(new e1.bZ(1, 0, 1, 0, 1)), a.push(new e1.bZ(1, 0, 1, 1, 1)));
                    } else a = t1.coveringTiles({
                        tileSize: i || this._source.tileSize,
                        minzoom: this._source.minzoom,
                        maxzoom: l,
                        roundZoom: this._source.roundZoom && !s,
                        reparseOverscaled: h,
                        isTerrainDEM: this.usedForTerrain,
                        calculateQuadrantVisibility: n
                    });
                } else a = [];
                if (a.length > 0 && "globe" !== this.transform.projection.name && !this.usedForTerrain && !this._supportsFading) {
                    const e1 = t1.coveringZoomLevel({
                        tileSize: i || this._source.tileSize,
                        roundZoom: this._source.roundZoom && !s
                    }), c = Math.min(e1, l);
                    if (n) {
                        const e1 = t1.extendTileCover(a, c);
                        for (const t1 of e1)a.push(t1);
                    } else if (o) {
                        const e1 = this.transform.getFrustum(c), i = t1.extendTileCoverToNearPlane(a, e1, c);
                        for (const e1 of i)a.push(e1);
                        if (c >= 18 && this._hasTunnelGeometry()) {
                            const i = t1.extendTileCoverForTunnels(a, e1, c, 20);
                            for (const e1 of i)a.push(e1);
                        }
                    } else if (this.castsShadows && r) {
                        const e1 = t1.extendTileCover(a, c, r, 16);
                        for (const t1 of e1)this._shadowCasterTiles.add(t1.key), a.push(t1);
                    }
                }
                for (const e1 of this._tiles.values())e1.dashIdealZ = e1.tileID.overscaledZ;
                this._source.hasTile && (a = a.filter((e1)=>this._source.hasTile(e1)));
                const d = this._updateRetainedTiles(a);
                if (this._supportsFading && 0 !== a.length) {
                    const t1 = new Map, i = new Set, s = e1.e.now();
                    for (const [e1, r] of d){
                        const o = this._tiles.get(e1);
                        if (!o || void 0 !== o.fadeEndTime && o.fadeEndTime <= s) continue;
                        const n = this.findLoadedParent(r, Math.max(r.overscaledZ - bs.maxOverzooming, this._source.minzoom));
                        n && (this._addTile(n.tileID), t1.set(n.tileID.key, n.tileID)), i.add(e1);
                    }
                    const r = a.at(-1).overscaledZ;
                    for (const [e1, t1] of this._tiles){
                        if (d.has(e1) || !t1.hasData()) continue;
                        let s = t1.tileID;
                        for(; s.overscaledZ > r;){
                            s = s.scaledTo(s.overscaledZ - 1);
                            const r = this._tiles.get(s.key);
                            if (r && r.hasData() && i.has(s.key)) {
                                d.set(e1, t1.tileID);
                                break;
                            }
                        }
                    }
                    for (const [e1, i] of t1)d.has(e1) || (this._coveredTiles.add(e1), d.set(e1, i));
                }
                for (const e1 of d.keys())this._tiles.get(e1).clearFadeHold();
                for (const [e1, t1] of this._tiles)d.has(e1) || (t1.hasSymbolBuckets && !t1.holdingForFade() ? t1.setHoldDuration(this.map._fadeDuration) : t1.hasSymbolBuckets && !t1.symbolFadeFinished() || this._removeTile(e1));
                this._updateLoadedParentTileCache(), this._renderSourceType === e1.b_.Symbol && this._source.afterUpdate && this._source.afterUpdate();
            }
            releaseSymbolFadeTiles() {
                for (const [e1, t1] of this._tiles)t1.holdingForFade() && this._removeTile(e1);
            }
            _updateRetainedTiles(e1) {
                const t1 = new Map;
                if (0 === e1.length) return t1;
                const i = new Set, s = e1.reduce((e1, t1)=>Math.min(e1, t1.overscaledZ), 1 / 0), r = e1[0].overscaledZ, o = Math.max(r - bs.maxOverzooming, this._source.minzoom), n = Math.max(r + bs.maxUnderzooming, this._source.minzoom), a = new Set;
                for (const i of e1){
                    const e1 = this._addTile(i);
                    t1.set(i.key, i), e1.hasData() || s < this._source.maxzoom && a.add(i.key);
                }
                if (this._retainLoadedChildren(a, s, n, t1), "raster-array" === this._source.type) {
                    const i = this._source, s = this._tiles;
                    for (const r of i.collectOverzoomParentTileIDs(s, e1))t1.set(r.key, r);
                }
                for (const s of e1){
                    let e1 = this._tiles.get(s.key);
                    if (e1.hasData()) continue;
                    if (s.canonical.z >= this._source.maxzoom) {
                        const e1 = s.children(this._source.maxzoom)[0], i = this.getTile(e1);
                        if (i && i.hasData()) {
                            t1.set(e1.key, e1), i.dashIdealZ = s.overscaledZ;
                            continue;
                        }
                    } else {
                        const e1 = s.children(this._source.maxzoom);
                        if (t1.has(e1[0].key) && t1.has(e1[1].key) && t1.has(e1[2].key) && t1.has(e1[3].key)) continue;
                    }
                    let r = e1.wasRequested();
                    for(let n = s.overscaledZ - 1; n >= o; --n){
                        const o = s.scaledTo(n);
                        if (i.has(o.key)) break;
                        if (i.add(o.key), e1 = this.getTile(o), !e1 && r && (e1 = this._addTile(o)), e1 && (t1.set(o.key, o), e1.dashIdealZ = s.overscaledZ, r = e1.wasRequested(), e1.hasData())) break;
                    }
                }
                return t1;
            }
            _updateLoadedParentTileCache() {
                this._loadedParentTiles.clear();
                for (const e1 of this._tiles.values()){
                    const t1 = [];
                    let i, s = e1.tileID;
                    for(; s.overscaledZ > 0;){
                        if (this._loadedParentTiles.has(s.key)) {
                            i = this._loadedParentTiles.get(s.key);
                            break;
                        }
                        t1.push(s.key);
                        const e1 = s.scaledTo(s.overscaledZ - 1);
                        if (i = this._getLoadedTile(e1), i) break;
                        s = e1;
                    }
                    for (const e1 of t1)this._loadedParentTiles.set(e1, i);
                }
            }
            _addTile(t1) {
                let i = this._tiles.get(t1.key);
                const s = this._shadowCasterTiles.has(t1.key);
                if (i) return !0 !== i.isExtraShadowCaster || s || this._reloadTile(t1.key, "reloading"), i;
                i = this._cache.getAndRemove(t1), i && (this._setTileReloadTimer(t1.key, i), i.tileID = t1, this._state.initializeTileState(i, this.map ? this.map.painter : null), i.resetPlacementVisibility());
                const r = Boolean(i);
                if (!r) {
                    const e1 = this.map ? this.map.painter : null, s = this._source.tileSize * t1.overscaleFactor();
                    i = "raster-array" === this._source.type ? function(e1, t1, i, s, r) {
                        if (!fs) throw new Error("Raster-array module is not loaded.");
                        return fs(e1, t1, i, s, r);
                    }(t1, s, this.transform.tileZoom, e1, this._isRaster) : new _s(t1, s, this.transform.tileZoom, e1, this._isRaster, this._source.worldview), this._loadTile(i, this._tileLoaded.bind(this, i, t1.key, i.state));
                }
                return i.uses++, this._tiles.set(t1.key, i), r || this._source.fire(new e1.i("dataloading", {
                    tile: i,
                    coord: i.tileID,
                    dataType: "source"
                })), i;
            }
            _setTileReloadTimer(e1, t1) {
                clearTimeout(this._timers.get(e1)), this._timers.delete(e1);
                const i = t1.getExpiryTimeout();
                i && this._timers.set(e1, setTimeout(()=>{
                    this._reloadTile(e1, "expired"), this._timers.delete(e1);
                }, i));
            }
            _removeTile(e1) {
                const t1 = this._tiles.get(e1);
                t1 && (t1.uses--, this._tiles.delete(e1), clearTimeout(this._timers.get(e1)), this._timers.delete(e1), t1.uses > 0 || (t1.hasData() && "reloading" !== t1.state || "empty" === t1.state ? this._cache.add(t1.tileID, t1, t1.getExpiryTimeout()) : this._unloadTile(t1)));
            }
            clearTiles() {
                this._shouldReloadOnResume = !1, this._paused = !1;
                for (const e1 of this._tiles.keys())this._removeTile(e1);
                this._source._clear && this._source._clear(), this._cache.reset(), this.map && this.usedForTerrain && this.map.painter.terrain && this.map.painter.terrain.resetTileLookupCache(this.id);
            }
            tilesIn(t1, i, s) {
                const r = [], o = this.transform;
                if (!o) return r;
                const n = "globe" === o.projection.name, a = e1.ad(o.center.lng), l = o.getFreeCameraOptions().position || new e1.b$(0, 0, 0);
                for (const c of this._tiles.values()){
                    if (s && c.clearQueryDebugViz(), c.holdingForFade()) continue;
                    let h;
                    if (n) {
                        const t1 = c.tileID.canonical;
                        if (0 === t1.z) {
                            const i = [
                                Math.abs(e1.bb(a, ...ws(t1, -1)) - a),
                                Math.abs(e1.bb(a, ...ws(t1, 1)) - a)
                            ];
                            h = [
                                0,
                                2 * i.indexOf(Math.min(...i)) - 1
                            ];
                        } else {
                            const i = [
                                Math.abs(e1.bb(a, ...ws(t1, -1)) - a),
                                Math.abs(e1.bb(a, ...ws(t1, 0)) - a),
                                Math.abs(e1.bb(a, ...ws(t1, 1)) - a)
                            ];
                            h = [
                                i.indexOf(Math.min(...i)) - 1
                            ];
                        }
                    } else h = [
                        0
                    ];
                    for (const e1 of h){
                        const s = t1.containsTile(c, o, i, e1, l);
                        s && r.push(s);
                    }
                }
                return r;
            }
            getShadowCasterCoordinates() {
                return this._getRenderableCoordinates(!1, !0);
            }
            getVisibleCoordinates(e1) {
                return this._getRenderableCoordinates(e1);
            }
            _getRenderableCoordinates(e1, t1) {
                if (!this.transform) return [];
                const i = this.getRenderableIds(e1, t1).map((e1)=>this._tiles.get(e1).tileID), s = "globe" === this.transform.projection.name;
                for (const e1 of i)e1.projMatrix = this.transform.calculateProjMatrix(e1.toUnwrapped()), e1.expandedProjMatrix = s ? this.transform.calculateProjMatrix(e1.toUnwrapped(), !1, !0) : e1.projMatrix;
                return i;
            }
            sortCoordinatesByDistance(e1) {
                if (!this.transform) return e1.slice();
                const t1 = e1.slice(), i = this.transform._camera.position, s = this.transform._camera.forward(), r = new Map;
                for (const e1 of t1){
                    const t1 = 1 / (1 << e1.canonical.z);
                    r.set(e1.key, ((e1.canonical.x + .5) * t1 + e1.wrap - i[0]) * s[0] + ((e1.canonical.y + .5) * t1 - i[1]) * s[1] - i[2] * s[2]);
                }
                return t1.sort((e1, t1)=>r.get(e1.key) - r.get(t1.key)), t1;
            }
            hasTransition() {
                if (this._source.hasTransition()) return !0;
                if (this._supportsFading) {
                    const t1 = e1.e.now();
                    for (const e1 of this._tiles.values())if (void 0 !== e1.fadeEndTime && e1.fadeEndTime >= t1) return !0;
                }
                return !1;
            }
            setFeatureState(e1, t1, i) {
                this._state.updateState(e1 = e1 || "_geojsonTileLayer", t1, i);
            }
            removeFeatureState(e1, t1, i) {
                this._state.removeFeatureState(e1 = e1 || "_geojsonTileLayer", t1, i);
            }
            getFeatureState(e1, t1) {
                return this._state.getState(e1 = e1 || "_geojsonTileLayer", t1);
            }
            setDependencies(e1, t1, i) {
                const s = this._tiles.get(e1);
                s && s.setDependencies(t1, i);
            }
            reloadTilesForDependencies(e1, t1) {
                for (const [i, s] of this._tiles)s.hasDependency(e1, t1) && this._reloadTile(i, "reloading");
                this._cache.filter((i)=>!i.hasDependency(e1, t1));
            }
            _preloadTiles(t1, i) {
                if (!this._sourceLoaded) {
                    const e1 = ()=>{
                        this._sourceLoaded && (this._source.off("data", e1), this._preloadTiles(t1, i));
                    };
                    return void this._source.on("data", e1);
                }
                const s = new Map, r = Array.isArray(t1) ? t1 : [
                    t1
                ], o = this.map.painter.terrain, n = this.usedForTerrain && o ? o.getScaledDemTileSize() : this._source.tileSize;
                for (const e1 of r){
                    const t1 = e1.coveringTiles({
                        tileSize: n,
                        minzoom: this._source.minzoom,
                        maxzoom: this._source.maxzoom,
                        roundZoom: this._source.roundZoom && !this.usedForTerrain,
                        reparseOverscaled: this._source.reparseOverscaled,
                        isTerrainDEM: this.usedForTerrain
                    });
                    for (const e1 of t1)s.set(e1.key, e1);
                    this.usedForTerrain && e1.updateElevation(!1);
                }
                const a = Array.from(s.values());
                e1.u(a, (e1, t1)=>{
                    const i = new _s(e1, this._source.tileSize * e1.overscaleFactor(), this.transform.tileZoom, this.map.painter, this._isRaster, this._source.worldview);
                    this._loadTile(i, (e1)=>{
                        "raster-dem" === this._source.type && i.dem && this._backfillDEM(i), t1(e1, i);
                    });
                }, i);
            }
        }
        function xs(e1, t1) {
            const i = Math.abs(2 * e1.wrap) - +(e1.wrap < 0), s = Math.abs(2 * t1.wrap) - +(t1.wrap < 0);
            return e1.overscaledZ - t1.overscaledZ || s - i || t1.canonical.y - e1.canonical.y || t1.canonical.x - e1.canonical.x;
        }
        function ws(e1, t1) {
            const i = 1 << e1.z;
            return [
                e1.x / i + t1,
                (e1.x + 1) / i + t1
            ];
        }
        function Ts(e1, t1) {
            if (e1.z <= t1.z) {
                const i = t1.z - e1.z;
                return t1.x >> i === e1.x && t1.y >> i === e1.y;
            }
            const i = e1.z - t1.z;
            return e1.x >> i === t1.x && e1.y >> i === t1.y;
        }
        function Ss(e1, t1) {
            return e1.sourceFQID !== t1.sourceFQID ? e1.sourceFQID < t1.sourceFQID ? -1 : 1 : e1.tileId.z !== t1.tileId.z ? e1.tileId.z - t1.tileId.z : e1.tileId.x !== t1.tileId.x ? e1.tileId.x - t1.tileId.x : e1.tileId.y - t1.tileId.y;
        }
        bs.maxOverzooming = 10, bs.maxUnderzooming = 3;
        class Cs {
            constructor(e1 = []){
                this.tiles = e1;
            }
            getTilesIntersecting(e1) {
                const t1 = [];
                for (const i of this.tiles)Ts(i.tileId, e1) && t1.push(i);
                return t1;
            }
            equals(e1) {
                if (this.tiles.length !== e1.length) return !1;
                for(let t1 = 0; t1 < this.tiles.length; ++t1){
                    const i = this.tiles[t1], s = e1[t1];
                    if (i.sourceFQID !== s.sourceFQID || i.tileId.z !== s.tileId.z || i.tileId.x !== s.tileId.x || i.tileId.y !== s.tileId.y || i.generation !== s.generation) return !1;
                }
                return !0;
            }
            empty() {
                return 0 === this.tiles.length;
            }
        }
        class Es {
            constructor(){
                this._tiles = [], this._snapshot = new Cs, this._snapshotChanged = !1;
            }
            clear() {
                this._tiles.length = 0;
            }
            consumeSnapshotChanged() {
                const e1 = this._snapshotChanged;
                return this._snapshotChanged = !1, e1;
            }
            addTileElevation(e1, t1, i, s) {
                this._tiles.push({
                    sourceFQID: e1,
                    tileId: t1,
                    features: i,
                    generation: s
                });
            }
            updateSnapshotIfNeeded() {
                return this._tiles.sort(Ss), this._snapshot.equals(this._tiles) || (this._snapshot = new Cs(this._tiles.slice()), this._snapshotChanged = !0), this._snapshot;
            }
        }
        function Is(e1, t1) {
            const i = [];
            for (const s of e1.getTilesIntersecting(t1))i.push(`${s.tileId.z}/${s.tileId.x}/${s.tileId.y}:${s.generation}`);
            return i.sort(), i.join("|");
        }
        function Ds(e1, t1) {
            return e1._mergedOtherSourceCaches[t1] || e1._mergedSymbolSourceCaches[t1];
        }
        function Ps(e1) {
            return !("none" === e1.visibility || !e1.sourceLayer || "fill" !== e1.type || !e1.layout || "hd-road-base" !== e1.layout.get("fill-elevation-reference"));
        }
        function Ls(e1) {
            return !!e1.layout && ("line" === e1.type && "hd-road-markup" === e1.layout.get("line-elevation-reference") || "circle" === e1.type && "hd-road-markup" === e1.layout.get("circle-elevation-reference") || "symbol" === e1.type && "hd-road-markup" === e1.layout.get("symbol-elevation-reference") || "fill" === e1.type && "hd-road-markup" === e1.layout.get("fill-elevation-reference"));
        }
        function Rs(t1) {
            const i = new Set;
            for(const s in t1._mergedLayers){
                const r = t1._mergedLayers[s];
                Ls(r) && i.add(e1.m(r.source, r.scope));
            }
            return i;
        }
        function As(e1) {
            const t1 = Rs(e1);
            if (0 === t1.size) return !1;
            const i = Ms(e1);
            for (const e1 of t1)for (const t1 of i)if (e1 !== t1) return !0;
            return !1;
        }
        function Ms(t1) {
            const i = new Set;
            for(const s in t1._mergedLayers){
                const r = t1._mergedLayers[s];
                r.source && Ps(r) && i.add(e1.m(r.source, r.scope));
            }
            return i;
        }
        function Fs(t1, i, s) {
            const r = new Set;
            for(const i in t1._mergedLayers){
                const s = t1._mergedLayers[i];
                "none" !== s.visibility && Ls(s) && r.add(e1.m(s.source, s.scope));
            }
            if (0 === r.size) return;
            if (!s) {
                const e1 = Ms(t1);
                for (const t1 of e1)r.delete(t1);
            }
            if (0 === r.size) return;
            const o = [
                t1._mergedOtherSourceCaches,
                t1._mergedSymbolSourceCaches
            ];
            for (const e1 of o)for(const t1 in e1){
                if (!r.has(t1)) continue;
                const s = e1[t1];
                for (const [e1, t1] of s._tiles)i && !i(t1) || (t1.hasDeferredElevationFeatures = !1, s._reloadTile(e1, "reloading"));
            }
        }
        class Os {
            constructor(){
                this.manager = new Es, this._needsCrossSourceElevation = !1, this._ingestFQIDs = new Set, this._terrainActiveLast = void 0;
            }
        }
        function ks(e1) {
            e1.map && e1.map.painter && (e1.map.painter.elevationCoverageSnapshot = null, e1.map.painter.elevationProvidersReady = void 0);
        }
        function Bs(e1) {
            if (e1._crossSourceElevationActive = !1, function(e1) {
                const t1 = e1._hdElevation, i = !!(e1.map && e1.map.painter && e1.map.painter.elevationCoverageSnapshot);
                return t1 ? !t1._needsCrossSourceElevation && 0 === t1._ingestFQIDs.size && 0 === t1.manager._tiles.length && !i : !i;
            }(e1)) return;
            const t1 = !!e1._hdElevation && e1._hdElevation._needsCrossSourceElevation;
            ks(e1), e1._hdElevation && (e1._hdElevation._needsCrossSourceElevation = !1, e1._hdElevation._ingestFQIDs.clear(), e1._hdElevation.manager.clear(), e1._hdElevation._terrainActiveLast = void 0, t1 && Fs(e1, void 0, !0));
        }
        function zs(t1, i) {
            if ($t(t1, t1.map && t1.map.transform)) return i.manager.clear(), void (t1.map.painter && (t1.map.painter.elevationCoverageSnapshot = null));
            if (!i._needsCrossSourceElevation) return void ks(t1);
            i.manager.clear();
            let s = !0;
            for (const e1 of i._ingestFQIDs){
                const r = Ds(t1, e1);
                if (!r) continue;
                const o = r._tiles;
                for (const t1 of o.values()){
                    if (!t1.loaded()) continue;
                    const r = t1.parsedElevationFeatures;
                    void 0 !== r ? i.manager.addTileElevation(e1, t1.tileID.canonical, r, t1.parsedElevationGeneration) : s = !1;
                }
            }
            const r = i.manager._snapshot, o = i.manager.updateSnapshotIfNeeded();
            t1.map.painter && (t1.map.painter.elevationCoverageSnapshot = o.empty() ? null : o);
            const n = s && function(e1, t1) {
                for (const i of t1){
                    const t1 = Ds(e1, i);
                    if (!t1) return !1;
                    if (!t1._sourceLoaded) return !1;
                    for (const e1 of t1._tiles.values())if ("loading" === e1.state || "reloading" === e1.state) return !1;
                }
                return !0;
            }(t1, function(t1) {
                const i = Rs(t1), s = new Set;
                for(const r in t1._mergedLayers){
                    const o = t1._mergedLayers[r];
                    if (!o.source || !Ps(o)) continue;
                    const n = e1.m(o.source, o.scope);
                    i.has(n) || s.add(n);
                }
                return s;
            }(t1));
            t1.map.painter && (t1.map.painter.elevationProvidersReady = n);
            const a = i.manager.consumeSnapshotChanged();
            (a || n) && Fs(t1, (e1)=>{
                var t1, i;
                return !!e1.hasDeferredElevationFeatures || a && (t1 = o, Is(r, i = e1.tileID.canonical) !== Is(t1, i));
            });
        }
        const Us = (e1)=>({
                u_matrix: e1
            });
        function Ns(t1, i) {
            const s = t1.context.gl, r = t1._tileClippingMaskIDs.get(i.key) || 0;
            return new e1.a4({
                func: s.EQUAL,
                mask: 255
            }, r, 0, s.KEEP, s.KEEP, s.KEEP);
        }
        function js(t1, i) {
            const s = t1.context.gl, r = t1._tileClippingMaskIDs.get(i.key) || 0;
            return new e1.a4({
                func: s.EQUAL,
                mask: 255
            }, 255 & ~r, 0, s.KEEP, s.KEEP, s.KEEP);
        }
        function Vs(t1, i) {
            if (!t1.frcCoverageSnapshot || !t1.frcCoverageRenderer) return null;
            const s = t1.frcCoverageSnapshot.getTileOrParent(i.canonical);
            if (!s || 0 === s.frcMask) return null;
            const r = t1.frcCoverageRenderer.getBuffers(s.tileId);
            if (!r) return null;
            const o = new e1.c1(s.tileId.z, s.tileId.x, s.tileId.y), n = new e1.c2(i.wrap, o);
            return {
                buffers: r,
                projMatrix: t1.transform.calculateProjMatrix(n),
                coverageTile: s
            };
        }
        function Gs(t1, i, s) {
            if (!t1.frcCoverageSnapshot) return;
            const r = t1.context, o = r.gl, n = t1.getOrCreateProgram("clippingMask");
            r.setColorMode(e1.a7.disabled), r.setDepthMode(e1.a3.disabled);
            for (const r of i){
                const i = Vs(t1, r);
                if (!i) continue;
                const a = i.buffers.frcLevelSegments[s];
                if (!a) continue;
                const l = t1._tileClippingMaskIDs.get(r.key) || 0;
                n.draw(t1, o.TRIANGLES, e1.a3.disabled, new e1.a4({
                    func: o.EQUAL,
                    mask: 255
                }, l, 255, o.KEEP, o.KEEP, o.INVERT), e1.a7.disabled, e1.a5.disabled, Us(i.projMatrix), `$frc_coverage_${s}`, i.buffers.vertexBuffer, i.buffers.indexBuffer, a);
            }
        }
        function qs(t1, i, s) {
            if (!t1.frcCoverageSnapshot) return;
            const r = t1.context, o = r.gl, n = t1.getOrCreateProgram("clippingMask");
            r.setColorMode(e1.a7.disabled), r.setDepthMode(e1.a3.disabled);
            for (const r of i){
                const i = Vs(t1, r);
                if (!i) continue;
                const a = i.buffers.frcLevelSegments[s];
                if (!a) continue;
                const l = t1._tileClippingMaskIDs.get(r.key) || 0;
                n.draw(t1, o.TRIANGLES, e1.a3.disabled, new e1.a4({
                    func: o.EQUAL,
                    mask: 255
                }, 255 & ~l, 255, o.KEEP, o.KEEP, o.INVERT), e1.a7.disabled, e1.a5.disabled, Us(i.projMatrix), `$frc_coverage_restore_${s}`, i.buffers.vertexBuffer, i.buffers.indexBuffer, a);
            }
        }
        function $s(e1, t1, i, s, r) {
            if (0 === t1.length) return;
            let o = 0;
            for (const e1 of t1)o |= e1.frcMask;
            const n = t1.map((e1)=>e1.coord);
            for(let a = 0; a < 9; ++a)if (o & 1 << a) {
                if (Gs(e1, n, a), s) for (const i of t1)i.frcMask & 1 << a && s(i, a, Ns(e1, i.coord));
                if (i > 0 && r) for (const i of t1)i.frcMask & 1 << a && r(i, a, js(e1, i.coord));
                qs(e1, n, a);
            }
        }
        function Zs(e1) {
            for (const t1 of e1)if (t1.rings.length > 0 && t1.rings[0].length > 0) return !0;
            return !1;
        }
        function Ws(e1) {
            const t1 = e1.frcCoverageFadeRange;
            return !t1 || t1[1] <= t1[0] ? 0 : 1 - Math.max(0, Math.min(1, (e1.transform.zoom - t1[0]) / (t1[1] - t1[0])));
        }
        const Hs = {
            loaded: !0,
            drawBuilding: function(t1, i, s, r) {
                t1.currentLayer < t1.firstLightBeamLayer && (t1.firstLightBeamLayer = t1.currentLayer);
                const o = s.paint.get("building-ambient-occlusion-ground-intensity"), n = s.paint.get("building-ambient-occlusion-ground-radius"), a = s.paint.get("building-ambient-occlusion-ground-attenuation"), l = s.paint.get("building-opacity");
                if (l <= 0) return;
                let c = o > 0 && n > 0, h = !0;
                const d = s.paint.get("building-vertical-scale");
                if (d <= 0) return;
                t1.shadowRenderer || (h = !1);
                const u = t1.conflationActive && t1.style.isLayerClipped(s, i.getSource()), p = t1.style.order.indexOf(s.fqid);
                if (function(e1, t1, i, s, r, o) {
                    for (const n of o){
                        const o = t1.getTile(n).getBucket(i);
                        o && (r && o.updateReplacement(n, e1.replacementSource, s), o.uploadUpdatedIndexBuffer(e1.context));
                    }
                }(t1, i, s, p, u, r), function(e1, t1, i, s) {
                    for (const r of s){
                        const s = t1.getTile(r).getBucket(i);
                        s && s.needsEvaluation() && s.uploadUpdatedColorBuffer(e1.context);
                    }
                }(t1, i, s, r), s.resetLayerRenderingStats(t1), t1.shadowRenderer && (t1.shadowRenderer.useNormalOffset = !0), "shadow" === t1.renderPass && t1.shadowRenderer) {
                    const o = [], n = t1.shadowRenderer.getShadowPassDepthMode();
                    Ti({
                        painter: t1,
                        source: i,
                        layer: s,
                        coords: r,
                        defines: o,
                        blendMode: e1.a7.disabled,
                        depthMode: n,
                        opacity: l,
                        verticalScale: d,
                        facadeEmissiveChance: 0,
                        facadeAOIntensity: 0,
                        floodLightIntensity: 0,
                        floodLightColor: [
                            0,
                            0,
                            0
                        ]
                    });
                } else if ("translucent" === t1.renderPass) {
                    let p = [
                        "HAS_ATTRIBUTE_a_part_color_emissive",
                        "LIGHTING_3D_MODE"
                    ];
                    h && (p = p.concat("RENDER_SHADOWS")), t1.shadowRenderer && t1.shadowRenderer.useNormalOffset && (p = p.concat("NORMAL_OFFSET"));
                    const f = s.paint.get("building-facade-emissive-chance"), m = s.paint.get("building-ambient-occlusion-intensity"), _ = s.paint.get("building-flood-light-intensity"), g = "none" === s.paint.get("building-flood-light-color-use-theme").constantOr("default"), y = s.paint.get("building-flood-light-color").toNonPremultipliedRenderColor(g ? null : s.lut).toArray01().slice(0, 3), v = s.paint.get("building-flood-light-ground-attenuation"), b = _ > 0, x = new e1.a3(t1.context.gl.LEQUAL, e1.a3.ReadWrite, t1.depthRangeFor3D), w = s.hasBlended3DDepthPrepass(), T = ()=>Ti({
                            painter: t1,
                            source: i,
                            layer: s,
                            coords: r,
                            defines: p,
                            blendMode: e1.a7.disabled,
                            depthMode: x,
                            opacity: l,
                            verticalScale: d,
                            facadeEmissiveChance: f,
                            facadeAOIntensity: m,
                            floodLightIntensity: _,
                            floodLightColor: y,
                            depthOnly: !0
                        });
                    if (t1.depthPrepassPhase) return void (w && T());
                    w && !t1.hasGrouped3DDepthPrepass(t1.currentLayer) && T();
                    const S = t1.colorModeForRenderPass();
                    Ti({
                        painter: t1,
                        source: i,
                        layer: s,
                        coords: r,
                        defines: p,
                        blendMode: S,
                        depthMode: x,
                        opacity: l,
                        verticalScale: d,
                        facadeEmissiveChance: f,
                        facadeAOIntensity: m,
                        floodLightIntensity: _,
                        floodLightColor: y,
                        stencilMode: w ? t1.stencilModeFor3DGroup(t1.currentLayer) : void 0
                    });
                    const C = s.paint.get("building-front-cutoff");
                    mi(t1.transform.pitch, C, !!t1.terrain), c && Si(t1, i, s, r, !0, l, o, n, _, y, a, u), b && Si(t1, i, s, r, !1, l, o, n, _, y, v, u);
                } else if ("light-beam" === t1.renderPass) {
                    const o = [
                        "HAS_ATTRIBUTE_a_part_color_emissive",
                        "HAS_ATTRIBUTE_a_bloom_attenuation"
                    ], n = new e1.a3(t1.context.gl.LEQUAL, e1.a3.ReadOnly, t1.depthRangeFor3D);
                    Ti({
                        painter: t1,
                        source: i,
                        layer: s,
                        coords: r,
                        defines: o,
                        blendMode: e1.a7.alphaBlended,
                        depthMode: n,
                        opacity: l,
                        verticalScale: d,
                        facadeEmissiveChance: 0,
                        facadeAOIntensity: 0,
                        floodLightIntensity: 0,
                        floodLightColor: [
                            0,
                            0,
                            0
                        ]
                    });
                }
                t1.shadowRenderer && (t1.shadowRenderer.useNormalOffset = !1), t1.resetStencilClippingMasks();
            },
            BuildingTileBorderManager: class {
                constructor(){
                    this.visibleTiles = [];
                }
                updateBorders(t1, i) {
                    const s = [], r = [], o = t1._getRenderableCoordinates(!1, !0);
                    for (const e1 of o){
                        const o = t1.getTile(e1);
                        if (!o.hasData()) continue;
                        const n = o.getBucket(i);
                        n && (n.isEmpty() || (s.push(e1.key), r.push({
                            bucket: n,
                            tileID: e1.canonical
                        })));
                    }
                    let n = s.length !== this.visibleTiles.length;
                    if (!n) {
                        s.sort();
                        for(let e1 = 0; e1 < s.length; e1++)if (s[e1] !== this.visibleTiles[e1]) {
                            n = !0;
                            break;
                        }
                    }
                    if (!n) return;
                    const a = new Set;
                    this.visibleTiles = s, r.sort((e1, t1)=>e1.tileID.z - t1.tileID.z || e1.tileID.x - t1.tileID.x || e1.tileID.y - t1.tileID.y);
                    for (const t1 of r){
                        const i = new Array, s = new Array, r = t1.bucket;
                        for (const t1 of r.featuresOnBorder)r.footprints[t1.footprintIndex].hiddenFlags & e1.b0 || (a.has(t1.featureId) ? s.push(t1.footprintIndex) : (a.add(t1.featureId), i.push(t1.footprintIndex)));
                        r.updateFootprintHiddenFlags(i, e1.b1, !1), r.updateFootprintHiddenFlags(s, e1.b1, !0);
                    }
                }
            },
            drawRasterParticle: function(t1, i, s, r, o, n) {
                "offscreen" === t1.renderPass && function(t1, i, s, r) {
                    if (!r.length) return;
                    const o = t1.context, n = o.gl, a = i.getSource();
                    if ("raster-array" !== a.type) return;
                    const l = Math.ceil(Math.sqrt(s.paint.get("raster-particle-count")));
                    let c = s.particlePositionRGBAImage;
                    if (!c || c.width !== l) {
                        const t1 = function(t1) {
                            const i = t1 * t1, s = new Uint8Array(4 * i), r = .9090909090909091;
                            for(let t1 = 0; t1 < i; t1++){
                                const i = r * (e1.bj(2 * t1 + 0) + Ei), o = r * (e1.bj(2 * t1 + 1) + Ei), n = 255 * i % 1, a = 255 * o % 1, l = n, c = o - a / 255, h = a;
                                s[4 * t1 + 0] = 255 * (i - n / 255), s[4 * t1 + 1] = 255 * l, s[4 * t1 + 2] = 255 * c, s[4 * t1 + 3] = 255 * h;
                            }
                            return s;
                        }(l);
                        c = s.particlePositionRGBAImage = new e1.b({
                            width: l,
                            height: l
                        }, t1);
                    }
                    let h = s.particleFramebuffer;
                    h ? h.width !== l && (h.destroy(), h = s.particleFramebuffer = o.createFramebuffer(l, l, 1, null)) : h = s.particleFramebuffer = o.createFramebuffer(l, l, 1, null);
                    const d = [];
                    for (const e1 of r){
                        const t1 = i.getTile(e1);
                        if (!t1) continue;
                        const r = Oi(t1, a, s);
                        if (!r) continue;
                        const n = [
                            t1.tileSize,
                            t1.tileSize
                        ];
                        let h = s.tileFramebuffer;
                        h || (h = s.tileFramebuffer = o.createFramebuffer(n[0], n[1], 1, null));
                        let u = t1.rasterParticleState;
                        u || (u = t1.rasterParticleState = new Mi(o, e1, n, c));
                        const p = u.update(s.lastInvalidatedAt);
                        u.particleTextureDimension !== l && u.updateParticleTexture(e1, c);
                        const f = u.targetColorTexture;
                        u.targetColorTexture = u.backgroundColorTexture, u.backgroundColorTexture = f;
                        const m = u.particleTexture0;
                        u.particleTexture0 = u.particleTexture1, u.particleTexture1 = m, d.push([
                            e1,
                            r,
                            u,
                            p
                        ]);
                    }
                    if (0 === d.length) return;
                    const u = e1.e.now(), p = s.previousDrawTimestamp ? .001 * (u - s.previousDrawTimestamp) : .0167;
                    if (s.previousDrawTimestamp = u, s.hasColorMap()) {
                        o.activeTexture.set(n.TEXTURE0 + 2);
                        let t1 = s.colorRampTexture;
                        t1 || (t1 = s.colorRampTexture = new e1.T(o, s.colorRamp, n.RGBA8)), t1.bind(n.LINEAR, n.CLAMP_TO_EDGE);
                    }
                    o.bindFramebuffer.set(s.tileFramebuffer.framebuffer), function(t1, i, s) {
                        const r = t1.context, o = r.gl, n = i.tileFramebuffer;
                        r.activeTexture.set(o.TEXTURE0);
                        const a = {
                            u_texture: 0,
                            u_opacity: 1.05 * (c = i.paint.get("raster-particle-fade-opacity-factor")) / (c + .05)
                        }, l = t1.getOrCreateProgram("rasterParticleTexture", {
                            defines: [],
                            overrideFog: !1
                        });
                        var c;
                        for (const c of s){
                            const [, , s, h] = c;
                            n.colorAttachment0.set(s.targetColorTexture.texture), r.viewport.set([
                                0,
                                0,
                                n.width,
                                n.height
                            ]), r.clear({
                                color: e1.C.transparent
                            }), h && (s.backgroundColorTexture.bind(o.NEAREST, o.CLAMP_TO_EDGE), l.draw(t1, o.TRIANGLES, e1.a3.disabled, e1.a4.disabled, e1.a7.alphaBlended, e1.a5.disabled, a, i.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments));
                        }
                    }(t1, s, d), function(t1, i, s, r) {
                        const o = t1.context, n = o.gl, a = s.tileFramebuffer, l = "globe" === t1.transform.projection.name, c = s.paint.get("raster-particle-max-speed");
                        for (const h of r){
                            const [r, d, u] = h;
                            o.activeTexture.set(n.TEXTURE0 + 0), d.texture.bind(n.LINEAR, n.CLAMP_TO_EDGE), a.colorAttachment0.set(u.targetColorTexture.texture);
                            const p = t1.getOrCreateProgram("rasterParticleDraw", {
                                defines: d.defines,
                                overrideFog: !1
                            });
                            o.activeTexture.set(n.TEXTURE0 + 1);
                            const f = d.scalarData ? [] : [
                                0,
                                1,
                                2,
                                3
                            ].map((t1)=>e1.aM[t1](r));
                            f.push(r);
                            const m = r.canonical.x, _ = r.canonical.y;
                            for (const o of f){
                                const a = i.getTile(l ? o.wrapped() : o);
                                if (!a) continue;
                                const h = a.rasterParticleState;
                                if (!h) continue;
                                const u = o.canonical.x + (1 << o.canonical.z) * (o.wrap - r.wrap), f = o.canonical.y;
                                h.particleTexture0.bind(n.NEAREST, n.CLAMP_TO_EDGE);
                                const g = Di(1, h.particleTexture0.size[0], [
                                    u - m,
                                    f - _
                                ], 0, d.texture.size, 2, c, d.textureOffset, d.scale, d.offset);
                                p.draw(t1, n.POINTS, e1.a3.disabled, e1.a4.disabled, e1.a7.alphaBlended, e1.a5.disabled, g, s.id, h.particleIndexBuffer, void 0, h.particleSegment);
                            }
                        }
                    }(t1, i, s, d), o.bindFramebuffer.set(s.particleFramebuffer.framebuffer), function(t1, i, s, r) {
                        const o = t1.context, n = o.gl, a = i.paint.get("raster-particle-max-speed"), l = r * i.paint.get("raster-particle-speed-factor") * .15, c = function(e1) {
                            return Math.pow(e1, 6);
                        }(.01 + 1 * i.paint.get("raster-particle-reset-rate-factor")), h = i.particleFramebuffer;
                        o.viewport.set([
                            0,
                            0,
                            h.width,
                            h.height
                        ]);
                        for (const r of s){
                            const [, s, d] = r;
                            o.activeTexture.set(n.TEXTURE0 + 0), s.texture.bind(n.LINEAR, n.CLAMP_TO_EDGE), o.activeTexture.set(n.TEXTURE0 + 1);
                            const u = d.particleTexture0;
                            u.bind(n.NEAREST, n.CLAMP_TO_EDGE);
                            const p = Pi(1, u.size[0], 0, s.texture.size, a, l, c, s.textureOffset, s.scale, s.offset);
                            h.colorAttachment0.set(d.particleTexture1.texture), o.clear({
                                color: e1.C.transparent
                            }), t1.getOrCreateProgram("rasterParticleUpdate", {
                                defines: s.defines
                            }).draw(t1, n.TRIANGLES, e1.a3.disabled, e1.a4.disabled, e1.a7.unblended, e1.a5.disabled, p, i.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments);
                        }
                    }(t1, s, d, p);
                }(t1, i, s, r), "translucent" === t1.renderPass && (function(t1, i, s, r) {
                    const o = t1.context, n = o.gl, a = i.getSource().tileSize, l = 5 * (1 - e1.ax(e1.bc, e1.bc + 1, t1.transform.zoom)) * a + s.paint.get("raster-particle-elevation"), c = !t1.options.moving, h = "globe" === t1.transform.projection.name;
                    if (!r.length) return;
                    const [d, u] = t1.stencilConfigForOverlap(r), p = [];
                    h && p.push("PROJECTION_GLOBE_VIEW");
                    const f = t1.stencilModeFor3D();
                    for (const r of u){
                        const a = r.toUnwrapped(), u = i.getTile(r);
                        if (!u.rasterParticleState) continue;
                        const m = u.rasterParticleState, _ = 100;
                        u.registerFadeDuration(_);
                        const g = i.findLoadedParent(r, 0), y = Fi(u, g, i, t1.transform, _);
                        let v, b;
                        t1.terrain && t1.terrain.prepareDrawTile(), o.activeTexture.set(n.TEXTURE0), m.targetColorTexture.bind(n.LINEAR, n.CLAMP_TO_EDGE), o.activeTexture.set(n.TEXTURE1), g && g.rasterParticleState ? (g.rasterParticleState.targetColorTexture.bind(n.LINEAR, n.CLAMP_TO_EDGE), v = Math.pow(2, g.tileID.overscaledZ - u.tileID.overscaledZ), b = [
                            u.tileID.canonical.x * v % 1,
                            u.tileID.canonical.y * v % 1
                        ]) : m.targetColorTexture.bind(n.LINEAR, n.CLAMP_TO_EDGE);
                        const x = h ? t1.transform.expandedFarZProjMatrix : t1.transform.calculateProjMatrix(a, c), w = t1.transform, T = ki(w), S = e1.bd(r.canonical), C = e1.be(S.getCenter().lat);
                        let E, I, D, P, L;
                        h ? (E = Float32Array.from(e1.bf(e1.bg(r.canonical))), I = Float32Array.from(w.globeMatrix), D = Float32Array.from(e1.bh(w)), P = [
                            e1.ad(w.center.lng),
                            e1.ae(w.center.lat)
                        ], L = Float32Array.from(e1.bi(r.canonical, S, C, w.worldSize / w._pixelsPerMercatorPixel))) : (E = new Float32Array(16), I = new Float32Array(9), D = new Float32Array(16), P = [
                            0,
                            0
                        ], L = new Float32Array(9));
                        const R = Ii(x, E, I, D, L, b || [
                            0,
                            0
                        ], e1._(t1.transform.zoom), P, T, v || 1, y, l), A = t1.isTileAffectedByFog(r), M = t1.getOrCreateProgram("rasterParticle", {
                            defines: p,
                            overrideFog: A
                        });
                        if (t1.uploadCommonUniforms(o, M, a), h) {
                            const i = new e1.a3(n.LEQUAL, e1.a3.ReadOnly, t1.depthRangeFor3D), r = 0, o = t1.globeSharedBuffers;
                            if (o) {
                                const [a, l, c] = o.getGridBuffers(C, 0 !== r);
                                M.draw(t1, n.TRIANGLES, i, f, e1.a7.alphaBlended, t1.renderElevatedRasterBackface ? e1.a5.frontCCW : e1.a5.backCCW, R, s.id, a, l, c);
                            }
                        } else {
                            const i = t1.depthModeForSublayer(0, e1.a3.ReadOnly), o = d[r.overscaledZ], { tileBoundsBuffer: a, tileBoundsIndexBuffer: l, tileBoundsSegments: c } = t1.getTileBoundsBuffers(u);
                            M.draw(t1, n.TRIANGLES, i, o, e1.a7.alphaBlended, e1.a5.disabled, R, s.id, a, l, c);
                        }
                    }
                    t1.resetStencilClippingMasks();
                }(t1, i, s, r), t1.style.map.triggerRepaint());
            },
            prepareRasterParticle: function(e1, t1, i) {
                const s = t1.getSource();
                if ("raster-array" !== s.type || !s.loaded()) return;
                const r = e1.sourceLayer || s.rasterLayerIds && s.rasterLayerIds[0];
                if (!r) return;
                const o = e1.paint.get("raster-particle-array-band") || s.getInitialBand(r);
                if (null == o) return;
                const n = t1.getIds().map((e1)=>t1.getTileByID(e1));
                for (const t1 of n)t1.updateNeeded(e1.id, o) && (t1._isHeaderLoaded || t1.parentTile) && s.prepareTile(t1, r, e1.id, o);
            },
            Rain: class extends Zi {
                constructor(){
                    super(4.25), this._params = {
                        intensity: .5,
                        timeFactor: 1,
                        velocityConeAperture: 0,
                        velocity: 300,
                        boxSize: 2500,
                        dropletSizeX: 1,
                        dropletSizeYScale: 10,
                        distortionStrength: 70,
                        screenThinning: {
                            intensity: .57,
                            start: .46,
                            range: 1.17,
                            fadePower: .17,
                            affectedRatio: 1,
                            particleOffset: -0.2
                        },
                        color: {
                            r: .66,
                            g: .68,
                            b: .74,
                            a: .7
                        },
                        direction: {
                            x: -50,
                            y: -35
                        },
                        shapeDirPower: 2,
                        shapeNormalPower: 1
                    }, this._vignetteParams = {
                        strength: 1,
                        start: .7,
                        range: 1,
                        fadePower: .4,
                        color: {
                            r: .27,
                            g: .27,
                            b: .27,
                            a: 1
                        }
                    }, this.particlesCount = 16e3, this._devtoolsFolder = null, this._painter = null;
                }
                destroy() {
                    super.destroy();
                }
                update(t1) {
                    const i = t1.context;
                    if (!this.particlesVx) {
                        const t1 = qi(this.particlesCount), s = new e1.bv, r = new e1.ak;
                        let o = 0;
                        const n = e1.bt(1323123451230);
                        for(let e1 = 0; e1 < t1.length; ++e1){
                            const i = t1[e1], a = [
                                2 * n() - 1,
                                n(),
                                n(),
                                n()
                            ];
                            s.emplaceBack(i[0], i[1], i[2], -1, -1, ...a), s.emplaceBack(i[0], i[1], i[2], 1, -1, ...a), s.emplaceBack(i[0], i[1], i[2], 1, 1, ...a), s.emplaceBack(i[0], i[1], i[2], -1, 1, ...a), r.emplaceBack(o + 0, o + 1, o + 2), r.emplaceBack(o + 0, o + 2, o + 3), o += 4;
                        }
                        this.particlesVx = i.createVertexBuffer(s, Ui.members), this.particlesIdx = i.createIndexBuffer(r);
                    }
                }
                getDrawParams(e1) {
                    if (!e1.style.rain) return null;
                    const t1 = e1.style.rain.state, i = structuredClone(this._params);
                    i.intensity = t1.density, i.timeFactor = t1.intensity, i.color = structuredClone(t1.color), i.screenThinning.intensity = t1.centerThinning, i.dropletSizeX = t1.dropletSize[0], i.dropletSizeYScale = t1.dropletSize[1] / t1.dropletSize[0], i.distortionStrength = 100 * t1.distortionStrength;
                    const s = structuredClone(this._vignetteParams);
                    return s.strength = 1, s.color = structuredClone(t1.vignetteColor), {
                        params: i,
                        vignetteParams: s,
                        revealParams: {
                            revealStart: 0,
                            revealRange: .01
                        },
                        direction: structuredClone(t1.direction)
                    };
                }
                draw(t1) {
                    const i = this.getDrawParams(t1);
                    if (!i) return;
                    const { params: s, revealParams: r, direction: o, vignetteParams: n } = i, a = t1.transform.zoom;
                    if (r.revealStart > a) return;
                    const l = $i(0, 1, r.revealStart, r.revealStart + r.revealRange, a);
                    if (!this.particlesVx || !this.particlesIdx) return;
                    n.strength *= l;
                    const c = this.updateOnRender(t1, s.timeFactor), h = t1.context, d = h.gl, u = t1.transform;
                    this.screenTexture && this.screenTexture.size[0] === t1.width && this.screenTexture.size[1] === t1.height || (this.screenTexture = new e1.T(h, {
                        width: t1.width,
                        height: t1.height,
                        data: null
                    }, d.RGBA8)), s.distortionStrength > 0 && (h.activeTexture.set(d.TEXTURE0), this.screenTexture.bind(d.LINEAR, d.CLAMP_TO_EDGE), d.copyTexSubImage2D(d.TEXTURE_2D, 0, 0, 0, 0, 0, t1.width, t1.height));
                    const p = t1.getOrCreateProgram("rainParticle");
                    t1.uploadCommonUniforms(h, p), h.activeTexture.set(d.TEXTURE0), this.screenTexture.bind(d.LINEAR, d.CLAMP_TO_EDGE);
                    const f = [
                        s.color.r,
                        s.color.g,
                        s.color.b,
                        s.color.a
                    ], m = (i, r)=>{
                        const n = Gi(this._movement.getPosition(), i), a = s.dropletSizeX, l = s.dropletSizeX * s.dropletSizeYScale, h = t1.width / 2, m = t1.height / 2, _ = $i(0, s.screenThinning.start, 0, 1, s.screenThinning.intensity), g = $i(.001, s.screenThinning.range, 0, 1, s.screenThinning.intensity), y = $i(0, s.screenThinning.particleOffset, 0, 1, s.screenThinning.intensity), v = (b = {
                            modelview: c.modelviewMatrix,
                            projection: c.projectionMatrix,
                            time: this._accumulatedTimeFromStart,
                            camPos: n,
                            velocityConeAperture: s.velocityConeAperture,
                            velocity: s.velocity,
                            boxSize: i,
                            rainDropletSize: [
                                a,
                                l
                            ],
                            distortionStrength: s.distortionStrength,
                            rainDirection: o,
                            color: f,
                            screenSize: [
                                u.width,
                                u.height
                            ],
                            thinningCenterPos: [
                                h,
                                m
                            ],
                            thinningShape: [
                                _,
                                g,
                                Math.pow(10, s.screenThinning.fadePower)
                            ],
                            thinningAffectedRatio: s.screenThinning.affectedRatio,
                            thinningParticleOffset: y,
                            shapeDirectionalPower: s.shapeDirPower,
                            shapeNormalPower: s.shapeNormalPower,
                            mode: r ? 0 : 1
                        }, {
                            u_modelview: Float32Array.from(b.modelview),
                            u_projection: Float32Array.from(b.projection),
                            u_time: b.time,
                            u_cam_pos: b.camPos,
                            u_texScreen: 0,
                            u_velocityConeAperture: b.velocityConeAperture,
                            u_velocity: b.velocity,
                            u_boxSize: b.boxSize,
                            u_rainDropletSize: b.rainDropletSize,
                            u_distortionStrength: b.distortionStrength,
                            u_rainDirection: b.rainDirection,
                            u_color: b.color,
                            u_screenSize: b.screenSize,
                            u_thinningCenterPos: b.thinningCenterPos,
                            u_thinningShape: b.thinningShape,
                            u_thinningAffectedRatio: b.thinningAffectedRatio,
                            u_thinningParticleOffset: b.thinningParticleOffset,
                            u_shapeDirectionalPower: b.shapeDirectionalPower,
                            u_shapeNormalPower: b.shapeNormalPower,
                            u_mode: b.mode
                        });
                        var b;
                        const x = Math.round(s.intensity * this.particlesCount), w = e1.aj.simpleSegment(0, 0, 4 * x, 2 * x);
                        p.draw(t1, d.TRIANGLES, e1.a3.disabled, e1.a4.disabled, e1.a7.alphaBlended, e1.a5.disabled, v, "rain_particles", this.particlesVx, this.particlesIdx, w);
                    };
                    s.distortionStrength > 0 && m(s.boxSize, !0), m(s.boxSize, !1), this._vignette.draw(t1, n);
                }
            },
            Snow: class extends Zi {
                constructor(){
                    super(2.25), this._params = {
                        intensity: .85,
                        timeFactor: .75,
                        velocityConeAperture: 70,
                        velocity: 40,
                        horizontalOscillationRadius: 4,
                        horizontalOscillationRate: 1.5,
                        boxSize: 2e3,
                        billboardSize: 2,
                        shapeFadeStart: .27,
                        shapeFadePower: .21,
                        screenThinning: {
                            intensity: .4,
                            start: .15,
                            range: 1.4,
                            fadePower: .24,
                            affectedRatio: 1,
                            particleOffset: -0.2
                        },
                        color: {
                            r: 1,
                            g: 1,
                            b: 1,
                            a: 1
                        },
                        direction: {
                            x: -50,
                            y: -35
                        }
                    }, this._vignetteParams = {
                        strength: .3,
                        start: .78,
                        range: .46,
                        fadePower: .2,
                        color: {
                            r: 1,
                            g: 1,
                            b: 1,
                            a: 1
                        }
                    }, this.particlesCount = 16e3, this._devtoolsFolder = null, this._painter = null;
                }
                destroy() {
                    super.destroy();
                }
                update(t1) {
                    const i = t1.context;
                    if (!this.particlesVx) {
                        const t1 = qi(this.particlesCount), s = new e1.bw, r = new e1.ak;
                        let o = 0;
                        const n = e1.bt(1323123451230);
                        for(let e1 = 0; e1 < t1.length; ++e1){
                            const i = t1[e1], a = n(), l = n(), c = n(), h = [
                                e1 / t1.length,
                                a,
                                l,
                                c
                            ], d = [
                                n(),
                                n()
                            ];
                            s.emplaceBack(i[0], i[1], i[2], -1, -1, ...h, ...d), s.emplaceBack(i[0], i[1], i[2], 1, -1, ...h, ...d), s.emplaceBack(i[0], i[1], i[2], 1, 1, ...h, ...d), s.emplaceBack(i[0], i[1], i[2], -1, 1, ...h, ...d), r.emplaceBack(o + 0, o + 1, o + 2), r.emplaceBack(o + 0, o + 2, o + 3), o += 4;
                        }
                        this.particlesVx = i.createVertexBuffer(s, Wi.members), this.particlesIdx = i.createIndexBuffer(r);
                    }
                }
                getDrawParams(e1) {
                    if (!e1.style.snow) return null;
                    const t1 = e1.style.snow.state, i = structuredClone(this._params);
                    i.intensity = t1.density, i.timeFactor = t1.intensity, i.color = structuredClone(t1.color), i.screenThinning.intensity = t1.centerThinning, i.billboardSize = 2.79 * t1.flakeSize;
                    const s = structuredClone(this._vignetteParams);
                    return s.strength = 1, s.color = structuredClone(t1.vignetteColor), {
                        params: i,
                        vignetteParams: s,
                        revealParams: {
                            revealStart: 0,
                            revealRange: .01
                        },
                        direction: structuredClone(t1.direction)
                    };
                }
                draw(t1) {
                    const i = this.getDrawParams(t1);
                    if (!i) return;
                    const { params: s, revealParams: r, direction: o, vignetteParams: n } = i, a = t1.transform.zoom;
                    if (r.revealStart > a) return;
                    const l = $i(0, 1, r.revealStart, r.revealStart + r.revealRange, a);
                    n.strength *= l;
                    const c = this.updateOnRender(t1, s.timeFactor);
                    if (!this.particlesVx || !this.particlesIdx) return;
                    const h = t1.context, d = h.gl, u = t1.transform, p = t1.getOrCreateProgram("snowParticle");
                    t1.uploadCommonUniforms(h, p), ((i, s, r)=>{
                        const n = Gi(this._movement.getPosition(), i), a = u.width / 2, l = u.height / 2, h = $i(0, r.screenThinning.start, 0, 1, r.screenThinning.intensity), f = $i(.001, r.screenThinning.range, 0, 1, r.screenThinning.intensity), m = $i(0, r.screenThinning.particleOffset, 0, 1, r.screenThinning.intensity), _ = (g = {
                            modelview: c.modelviewMatrix,
                            projection: c.projectionMatrix,
                            time: this._accumulatedTimeFromStart,
                            camPos: n,
                            velocityConeAperture: r.velocityConeAperture,
                            velocity: r.velocity,
                            horizontalOscillationRadius: r.horizontalOscillationRadius,
                            horizontalOscillationRate: r.horizontalOscillationRate,
                            boxSize: i,
                            billboardSize: 1 * r.billboardSize,
                            simpleShapeParameters: [
                                r.shapeFadeStart,
                                r.shapeFadePower
                            ],
                            screenSize: [
                                u.width,
                                u.height
                            ],
                            thinningCenterPos: [
                                a,
                                l
                            ],
                            thinningShape: [
                                h,
                                f,
                                Math.pow(10, r.screenThinning.fadePower)
                            ],
                            thinningAffectedRatio: r.screenThinning.affectedRatio,
                            thinningParticleOffset: m,
                            color: [
                                r.color.r,
                                r.color.g,
                                r.color.b,
                                r.color.a
                            ],
                            direction: o
                        }, {
                            u_modelview: Float32Array.from(g.modelview),
                            u_projection: Float32Array.from(g.projection),
                            u_time: g.time,
                            u_cam_pos: g.camPos,
                            u_velocityConeAperture: g.velocityConeAperture,
                            u_velocity: g.velocity,
                            u_horizontalOscillationRadius: g.horizontalOscillationRadius,
                            u_horizontalOscillationRate: g.horizontalOscillationRate,
                            u_boxSize: g.boxSize,
                            u_billboardSize: g.billboardSize,
                            u_simpleShapeParameters: g.simpleShapeParameters,
                            u_screenSize: g.screenSize,
                            u_thinningCenterPos: g.thinningCenterPos,
                            u_thinningShape: g.thinningShape,
                            u_thinningAffectedRatio: g.thinningAffectedRatio,
                            u_thinningParticleOffset: g.thinningParticleOffset,
                            u_particleColor: g.color,
                            u_direction: g.direction
                        });
                        var g;
                        const y = Math.round(r.intensity * this.particlesCount), v = e1.aj.simpleSegment(0, 0, 4 * y, 2 * y);
                        this.particlesVx && this.particlesIdx && p.draw(t1, d.TRIANGLES, e1.a3.disabled, e1.a4.disabled, e1.a7.alphaBlended, e1.a5.disabled, _, "snow_particles", this.particlesVx, this.particlesIdx, v);
                    })(s.boxSize, 0, s), this._vignette.draw(t1, n);
                }
            },
            shaders: zi,
            programUniforms: Ki,
            drawElevatedStructures: function(t1) {
                const { painter: i, sourceCache: s, layer: r, coords: o, colorMode: n } = t1, a = i.context.gl, l = t1.painter.shadowRenderer, c = !!l && l.enabled, h = new e1.a3(i.context.gl.LEQUAL, e1.a3.ReadOnly, i.depthRangeFor3D);
                let d = [
                    0,
                    0,
                    0
                ];
                if (c) {
                    const t1 = i.style.directionalLight, s = i.style.ambientLight;
                    t1 && s && (d = e1.aQ(i.style, t1, s));
                }
                const u = (t1)=>{
                    for (const u of o){
                        const o = s.getTile(u), p = o.getBucket(r);
                        if (!p) continue;
                        const f = p.hdExt ? p.hdExt.elevatedStructures : void 0;
                        if (!f) continue;
                        let m, _;
                        if (t1 ? (m = f.renderableBridgeSegments, _ = f.bridgeProgramConfigurations.get(r.id)) : (m = f.renderableTunnelSegments, _ = f.tunnelProgramConfigurations.get(r.id)), !m || 0 === m.segments[0].primitiveLength) continue;
                        _.updatePaintBuffers(), i.prepareDrawTile();
                        const g = i.isTileAffectedByFog(u), y = [];
                        c && y.push("RENDER_SHADOWS", "NORMAL_OFFSET");
                        const v = i.getOrCreateProgram("elevatedStructures", {
                            config: _,
                            overrideFog: g,
                            defines: y
                        }), b = i.translatePosMatrix(u.projMatrix, o, r.paint.get("fill-translate"), r.paint.get("fill-translate-anchor"));
                        c && l.setupShadows(o.tileID.toUnwrapped(), v, "vector-tile");
                        const x = Xi(b, d);
                        i.uploadCommonUniforms(i.context, v, u.toUnwrapped()), v.draw(i, a.TRIANGLES, h, e1.a4.disabled, n, e1.a5.backCCW, x, r.id, f.vertexBuffer, f.indexBuffer, m, r.paint, i.transform.zoom, _, [
                            f.vertexBufferNormal
                        ]);
                    }
                };
                u(!0), u(!1);
            },
            drawElevatedFillShadows: function(t1) {
                const { painter: i, sourceCache: s, layer: r, coords: o } = t1, n = i.context.gl, a = t1.painter.shadowRenderer;
                for (const t1 of o){
                    const o = s.getTile(t1), l = o.getBucket(r);
                    if (!l) continue;
                    const c = l.hdExt ? l.hdExt.elevatedStructures : void 0;
                    if (!c) continue;
                    if (!c.shadowCasterSegments || 0 === c.shadowCasterSegments.segments[0].primitiveLength) continue;
                    i.prepareDrawTile();
                    const h = l.bufferData.programConfigurations.get(r.id), d = i.isTileAffectedByFog(t1), u = i.getOrCreateProgram("elevatedStructuresDepth", {
                        config: h,
                        overrideFog: d
                    }), p = a.calculateShadowPassMatrixFromTile(o.tileID.toUnwrapped());
                    i.uploadCommonUniforms(i.context, u, t1.toUnwrapped());
                    const f = Hi(p, 0);
                    u.draw(i, n.TRIANGLES, a.getShadowPassDepthMode(), e1.a4.disabled, e1.a7.disabled, e1.a5.disabled, f, r.id, c.vertexBuffer, c.indexBuffer, c.shadowCasterSegments, r.paint, i.transform.zoom, h);
                }
            },
            drawDepthPrepass: function(t1, i, s, r, o) {
                if (!i) return;
                if (!s.layout || "none" === s.layout.get("fill-elevation-reference") || 0 === s.paint.get("fill-opacity").constantOr(1)) return;
                const n = t1.context.gl, a = new e1.a3(t1.context.gl.LEQUAL, e1.a3.ReadWrite, t1.depthRangeFor3D), l = new e1.a3(t1.context.gl.GREATER, e1.a3.ReadWrite, t1.depthRangeFor3D), c = function(t1) {
                    let i = .01;
                    return t1.isOrthographic && (i = e1.aw(1e-4, i, e1.bz(t1.pitch >= e1.by ? 1 : t1.pitch / e1.by))), 2 * i;
                }(t1.transform), h = t1.transform.getFreeCameraOptions().position, d = "elevatedStructuresDepthReconstruct";
                let u;
                for (const p of r){
                    const r = i.getTile(p), f = r.getBucket(s);
                    if (!f) continue;
                    if (!f.hdExt) continue;
                    const m = f.hdExt.elevatedStructures, _ = f.hdExt.elevationBufferData;
                    if (!m || !m.depthSegments || !_) continue;
                    const g = _.heightRange, y = Qi(p.toUnwrapped(), h), v = t1.translatePosMatrix(p.projMatrix, r, s.paint.get("fill-translate"), s.paint.get("fill-translate-anchor"));
                    let b, x, w;
                    if ("initialize" === o) {
                        if (!g || g.min >= 1 || 0 === m.depthSegments.segments[0].primitiveLength) continue;
                        b = Yi(v, y, c, 1, 0), x = a, w = m.depthSegments, u = u || t1.getOrCreateProgram(d, {
                            defines: [
                                "DEPTH_RECONSTRUCTION"
                            ]
                        });
                    } else if ("reset" === o) {
                        if (!g || g.min >= 0 || 0 === m.maskSegments.segments[0].primitiveLength) continue;
                        b = Yi(v, y, 0, 0, 1), x = l, w = m.maskSegments, u = u || t1.getOrCreateProgram(d, {
                            defines: [
                                "DEPTH_RECONSTRUCTION"
                            ]
                        });
                    } else if ("geometry" === o) {
                        if (0 === m.depthSegments.segments[0].primitiveLength) continue;
                        b = Yi(v, y, c, 1, 0), x = a, w = m.depthSegments, u = u || t1.getOrCreateProgram(d);
                    }
                    u.draw(t1, n.TRIANGLES, x, e1.a4.disabled, e1.a7.disabled, e1.a5.disabled, b, s.id, m.vertexBuffer, m.indexBuffer, w, s.paint, t1.transform.zoom);
                }
            },
            drawGroundShadowMask: function(t1, i, s, r) {
                if (!i) return;
                if (!s.layout || "none" === s.layout.get("fill-elevation-reference") || 0 === s.paint.get("fill-opacity").constantOr(1)) return;
                const o = t1.context.gl, n = new e1.a3(o.LEQUAL, e1.a3.ReadOnly, t1.depthRangeFor3D), a = new e1.a4({
                    func: o.ALWAYS,
                    mask: 255
                }, 255, 255, o.KEEP, o.KEEP, o.REPLACE), l = t1.transform.getFreeCameraOptions().position;
                let c;
                for (const h of r){
                    const r = i.getTile(h), d = r.getBucket(s);
                    if (!d) continue;
                    const u = d.hdExt ? d.hdExt.elevatedStructures : void 0;
                    if (!u || !u.depthSegments || 0 === u.depthSegments.segments[0].primitiveLength) continue;
                    const p = Qi(h.toUnwrapped(), l), f = t1.translatePosMatrix(h.projMatrix, r, s.paint.get("fill-translate"), s.paint.get("fill-translate-anchor"));
                    c = c || t1.getOrCreateProgram("elevatedStructuresDepthReconstruct");
                    const m = Yi(f, p, 0, 1, 0);
                    c.draw(t1, o.TRIANGLES, n, a, e1.a7.disabled, e1.a5.disabled, m, s.id, u.vertexBuffer, u.indexBuffer, u.depthSegments, s.paint, t1.transform.zoom);
                }
            },
            IndoorManager: class extends e1.E {
                constructor(t1, i = !1){
                    super(), this._style = t1, this._buildings = {}, this._activeFloors = new Set, this._closestBuildingId = null, this._indoorState = {
                        selectedFloorId: null,
                        activeFloorsVisible: !0,
                        activeFloors: this._activeFloors
                    }, this._buildingDetectionStrategy = new Ci, this._initialLoadDone = !1, e1.b4([
                        "_updateUI"
                    ], this);
                    const s = ()=>{
                        this._style.isIndoorEnabled() && (this._style.map.on("load", ()=>{
                            this._initialLoadDone = !0, this._indoorState && this._indoorState.needsUpdate && (this._indoorState.needsUpdate = !1, this._style.updateIndoorDependentLayers()), this._updateUI();
                        }), this._style.map.on("move", this._updateUI), this._style.map.on("idle", this._updateUI));
                    };
                    i ? (this._initialLoadDone = !0, s()) : this._style.on("style.load", s);
                }
                destroy() {
                    this._buildings = {}, this._activeFloors = new Set, this._indoorState = null;
                }
                selectFloor(e1) {
                    e1 === this._selectedFloorId && this._indoorState && this._indoorState.activeFloorsVisible || (this._selectedFloorId = e1, this._recalculateActiveFloors());
                }
                setActiveFloorsVisibility(e1) {
                    this._updateActiveFloors(e1), this._updateIndoorSelector();
                }
                setIndoorData(e1) {
                    let t1 = !1;
                    for (const [i, s] of Object.entries(e1.buildings))if (this._buildings[i]) for (const e1 of s.floorIds)this._buildings[i].floorIds.add(e1), this._buildings[i].floors[e1] ? this._mergeFloors(this._buildings[i].floors[e1], s.floors[e1]) : (this._buildings[i].floors[e1] = s.floors[e1], t1 = !0);
                    else this._buildings[i] = s, t1 = !0;
                    t1 && this._recalculateActiveFloors();
                }
                getIndoorTileOptions(e1, t1) {
                    return this._indoorState ? {
                        sourceLayers: this._style.getIndoorSourceLayers(e1, t1),
                        indoorState: this._indoorState
                    } : null;
                }
                getControlState() {
                    const e1 = this._buildings, t1 = this._closestBuildingId, i = t1 && e1 ? e1[t1] : void 0;
                    if (!i) return {
                        selectedFloorId: null,
                        activeFloorsVisible: !!this._indoorState && this._indoorState.activeFloorsVisible,
                        floors: []
                    };
                    let s = null;
                    for (const e1 of i.floorIds)if (this._activeFloors && this._activeFloors.has(e1)) {
                        s = e1;
                        break;
                    }
                    const r = Array.from(i.floorIds).map((e1)=>({
                            id: e1,
                            name: i.floors[e1].name,
                            zIndex: i.floors[e1].zIndex
                        })).sort((e1, t1)=>t1.zIndex - e1.zIndex).filter((e1, t1, i)=>0 === t1 || e1.zIndex !== i[t1 - 1].zIndex);
                    return {
                        selectedFloorId: s,
                        activeFloorsVisible: !!this._indoorState && this._indoorState.activeFloorsVisible,
                        floors: r
                    };
                }
                _updateUI() {
                    this._initialLoadDone = !0;
                    const e1 = this._style.map.transform, t1 = this._buildingDetectionStrategy.findClosestBuilding(this._buildings, e1.center, e1.zoom, e1.getBounds(), this._makeViewportPolygon());
                    if (t1 !== this._closestBuildingId) {
                        const e1 = this._closestBuildingId;
                        this._closestBuildingId = t1, this._onBuildingTransition(e1, t1), this._updateIndoorSelector();
                    }
                }
                _onBuildingTransition(e1, t1) {
                    if (!this._indoorState) return;
                    const i = !!t1 && !e1;
                    !t1 && e1 ? (this._indoorState.activeFloors = new Set, this._indoorState.activeFloorsVisible = !1, this._style.updateIndoorDependentLayers()) : i && (this._recalculateActiveFloors(), this._updateActiveFloors(!0));
                }
                _updateIndoorSelector() {
                    this.fire(new e1.i("selector-update", this.getControlState()));
                }
                _updateActiveFloors(e1) {
                    this._indoorState = {
                        selectedFloorId: this._selectedFloorId,
                        activeFloorsVisible: e1,
                        activeFloors: this._activeFloors
                    }, this._initialLoadDone ? this._style.updateIndoorDependentLayers() : this._indoorState.needsUpdate = !0;
                }
                _recalculateActiveFloors() {
                    if (!this._buildings) return;
                    const t1 = e1.b5.calculate(this._buildings, this._selectedFloorId, this._activeFloors);
                    (function(e1, t1) {
                        if (e1 === t1) return !0;
                        if (!e1 || !t1) return !1;
                        if (e1.size !== t1.size) return !1;
                        for (const i of e1)if (!t1.has(i)) return !1;
                        return !0;
                    })(t1, this._activeFloors) || (this._activeFloors = t1, this._updateActiveFloors(!!this._indoorState && this._indoorState.activeFloorsVisible), this._updateIndoorSelector());
                }
                _mergeFloors(e1, t1) {
                    t1.geometry && (e1.geometry ? ("Polygon" === e1.geometry.type && (e1.geometry = {
                        type: "MultiPolygon",
                        coordinates: [
                            e1.geometry.coordinates
                        ]
                    }), "Polygon" === t1.geometry.type ? e1.geometry.coordinates.push(t1.geometry.coordinates) : "MultiPolygon" === t1.geometry.type && e1.geometry.coordinates.push(...t1.geometry.coordinates)) : e1.geometry = t1.geometry);
                }
                _makeViewportPolygon() {
                    const t1 = this._style.map.transform, i = t1.width, s = t1.height;
                    return [
                        t1.pointLocation(new e1.P(0, 0)),
                        t1.pointLocation(new e1.P(i, 0)),
                        t1.pointLocation(new e1.P(i, s)),
                        t1.pointLocation(new e1.P(0, s))
                    ].map((t1)=>new e1.P(t1.lng, t1.lat));
                }
            },
            HdCoverageState: class {
                constructor(){
                    this.coverageSourceCaches = {}, this.manager = new ss;
                }
            },
            updateFrcCoverage: function(e1, t1) {
                t1.manager.clear();
                for(const i in e1._mergedHdRoadCoverageSourceCaches){
                    const s = e1._mergedHdRoadCoverageSourceCaches[i]._tiles;
                    for (const e1 of s.values()){
                        if (!e1.loaded()) continue;
                        const i = e1.frcCoveragePolygons;
                        t1.manager.addTileCoverage(e1.tileID.canonical, i && i.length > 0 ? i : []);
                    }
                }
                const i = t1.manager.updateSnapshotIfNeeded();
                if (e1.map.painter && (e1.map.painter.frcCoverageSnapshot = i.empty() ? null : i), !i.empty()) {
                    const t1 = [
                        e1._mergedOtherSourceCaches,
                        e1._mergedSymbolSourceCaches
                    ];
                    for (const e1 of t1)for(const t1 in e1){
                        const i = e1[t1];
                        for (const [e1, t1] of i._tiles)t1.hasDeferredRoadStructure && (t1.hasDeferredRoadStructure = !1, i._reloadTile(e1, "reloading"));
                    }
                }
            },
            updateHdCoverageSourceCache: function(t1, i, s) {
                if ("fill" !== s.type || s.sourceLayer !== e1.c0) return;
                if (i.coverageSourceCaches[s.source]) return;
                const r = t1.getOwnSource(s.source);
                if (!r || "vector" !== r.type) return;
                const o = `hd-road-coverage:${s.source}`, n = e1.m(o, t1.scope), a = t1._sourceCaches[o] = new bs(n, r, e1.b_.HdRoadCoverage);
                i.coverageSourceCaches[s.source] = a, a.setMaxzoomOverride(14), a.onAdd(t1.map);
                const l = t1._otherSourceCaches[s.source];
                l && l._sourceLoaded && (a._sourceLoaded = !0);
            },
            updateFrcCoverageFadeRange: function(t1, i) {
                let s = null, r = null;
                const o = {
                    globals: {
                        zoom: 0
                    }
                };
                t1.forEachFragmentStyle((i)=>{
                    if (s) return;
                    const n = i.stylesheet ? i.stylesheet.schema : null;
                    if (!n || !n.sdCoverageFadeRange) return;
                    const a = e1.m("sdCoverageFadeRange", i.scope), l = i.options ? i.options.get(a) : void 0, c = l ? l.value || l.default : null;
                    if (c) {
                        const e1 = c.evaluate(o);
                        Array.isArray(e1) && 2 === e1.length && (e1[0] > 0 || e1[1] > 0) && (s = [
                            e1[0],
                            e1[1]
                        ]);
                    }
                    const h = e1.m("sdCoverageSourceLayers", i.scope), d = i.options ? i.options.get(h) : void 0, u = d ? d.value || d.default : null;
                    if (u) {
                        const e1 = u.evaluate(o);
                        Array.isArray(e1) && e1.length > 0 && (r = e1);
                    } else {
                        const e1 = t1.stylesheet && t1.stylesheet.imports || [];
                        for (const t1 of e1)if (t1.id === i.scope) {
                            const e1 = t1.config ? t1.config.sdCoverageSourceLayers : void 0;
                            Array.isArray(e1) && e1.length > 0 && (r = e1);
                            break;
                        }
                    }
                }), i.frcCoverageFadeRange = s, i.frcCoverageSourceLayers = null != s ? r || [
                    "road",
                    "structure"
                ] : [];
            },
            HdElevationState: Os,
            setupAndUpdateElevationCoverage: function(e1) {
                if (!function(e1) {
                    for(const t1 in e1._mergedLayers)if (Ls(e1._mergedLayers[t1])) return !0;
                    return !1;
                }(e1)) return void Bs(e1);
                const t1 = $t(e1, e1.map && e1.map.transform);
                e1._hdElevation || (e1._hdElevation = new Os);
                const i = e1._hdElevation._terrainActiveLast;
                if (e1._hdElevation._terrainActiveLast = t1, void 0 !== i && i !== t1 && Fs(e1, void 0, !0), t1) return void (e1.map.painter && (e1.map.painter.elevationCoverageSnapshot = null));
                if (!As(e1)) return void Bs(e1);
                void 0 === i && Fs(e1, void 0, !0);
                const s = e1._hdElevation;
                s._needsCrossSourceElevation = !0, e1._crossSourceElevationActive = !0, s._ingestFQIDs = Ms(e1), zs(e1, s);
            },
            updateElevationCoverage: zs,
            updateCrossSourceElevationGate: function(e1) {
                e1._crossSourceElevationActive = As(e1);
            },
            buildElevationRequestParams: function(e1, t1, i) {
                if ($t(e1.style, e1.transform)) return null;
                if (!i) return null;
                const s = e1.painter ? e1.painter.elevationCoverageSnapshot : null, r = !(!e1.painter || !e1.painter.elevationProvidersReady);
                return s ? function(e1, t1, i) {
                    const s = e1.getTilesIntersecting(t1);
                    if (0 === s.length) return {
                        registry: [],
                        hasCoveringTile: !1,
                        allProvidersReady: i
                    };
                    const r = [];
                    for (const e1 of s)for (const t1 of e1.features)r.push({
                        tileId: e1.tileId,
                        feature: t1
                    });
                    return r.sort((e1, t1)=>e1.feature.id - t1.feature.id), {
                        registry: r,
                        hasCoveringTile: !0,
                        allProvidersReady: i
                    };
                }(s, t1.tileID.canonical, r) : {
                    registry: [],
                    hasCoveringTile: !1,
                    allProvidersReady: r
                };
            },
            FrcCoverageRenderer: class {
                constructor(){
                    this.tileBuffers = new Map, this._context = null;
                }
                update(e1, t1) {
                    this._context = e1;
                    const i = new Set;
                    for (const s of t1){
                        if (0 === s.frcMask) continue;
                        let t1 = !1;
                        for (const e1 of s.polygons)if (e1.hasGeometry()) {
                            t1 = !0;
                            break;
                        }
                        if (!t1) continue;
                        const r = `${s.tileId.z}/${s.tileId.x}/${s.tileId.y}`;
                        if (i.add(r), !this.tileBuffers.has(r)) {
                            const t1 = this._createBuffers(e1, s);
                            t1 && this.tileBuffers.set(r, t1);
                        }
                    }
                    for (const e1 of this.tileBuffers.keys())if (!i.has(e1)) {
                        const t1 = this.tileBuffers.get(e1);
                        t1.vertexBuffer.destroy(), t1.indexBuffer.destroy();
                        for (const e1 of t1.frcLevelSegments)e1 && e1.destroy();
                        this.tileBuffers.delete(e1);
                    }
                }
                getBuffers(e1) {
                    return this.tileBuffers.get(`${e1.z}/${e1.x}/${e1.y}`) || null;
                }
                destroy() {
                    for (const e1 of this.tileBuffers.values()){
                        e1.vertexBuffer.destroy(), e1.indexBuffer.destroy();
                        for (const t1 of e1.frcLevelSegments)t1 && t1.destroy();
                    }
                    this.tileBuffers.clear();
                }
                _createBuffers(t1, i) {
                    const s = new e1.bN, r = new e1.ak, o = [];
                    for (const t1 of i.polygons){
                        if (!t1.hasGeometry() || 0 === t1.rings.length) continue;
                        const i = s.length, n = r.length, a = s.length, l = [], c = [];
                        let h = 0;
                        for(let e1 = 0; e1 < t1.rings.length; e1++){
                            const i = t1.rings[e1];
                            if (!(i.length < 3)) {
                                e1 > 0 && c.push(h);
                                for (const e1 of i)s.emplaceBack(e1.x, e1.y), l.push(e1.x, e1.y), h++;
                            }
                        }
                        const d = e1.bQ(l, c.length > 0 ? c : void 0);
                        for(let e1 = 0; e1 < d.length; e1 += 3)r.emplaceBack(a + d[e1], a + d[e1 + 1], a + d[e1 + 2]);
                        o.push({
                            vertexOffset: i,
                            indexOffset: n,
                            vertexCount: s.length - i,
                            indexCount: r.length - n,
                            frcMask: t1.frcMask
                        });
                    }
                    if (0 === s.length) return null;
                    const n = new Array(9).fill(null);
                    for(let t1 = 0; t1 < 9; ++t1){
                        const s = 1 << t1;
                        if (0 === (i.frcMask & s)) continue;
                        let r = 0, a = 0, l = 0, c = !1, h = null;
                        const d = ()=>{
                            h || (h = new e1.aj), h.segments.push({
                                vertexOffset: 0,
                                primitiveOffset: r,
                                vertexLength: l,
                                primitiveLength: a - r,
                                vaos: {},
                                sortKey: 0
                            });
                        };
                        for (const e1 of o)0 !== (e1.frcMask & s) ? (c || (r = e1.indexOffset, c = !0), a = e1.indexOffset + e1.indexCount, l = e1.vertexOffset + e1.vertexCount) : c && (d(), c = !1);
                        c && d(), h && (n[t1] = h);
                    }
                    return {
                        vertexBuffer: t1.createVertexBuffer(s, e1.bP.members),
                        indexBuffer: t1.createIndexBuffer(r),
                        frcLevelSegments: n
                    };
                }
            },
            drawFillFrcCoverageFirstPass: function(t1) {
                const { painter: i, bucket: s, coord: r, elevatedGeometry: o } = t1, n = "road" === s.sourceLayerName, a = "structure" === s.sourceLayerName;
                if (!n && !a) return "fallthrough";
                if (!i.frcCoverageSnapshot || o) return "fallthrough";
                const l = i.frcCoverageSnapshot.getTileOrParent(r.canonical);
                if (!l || 0 === l.frcMask) return "fallthrough";
                const c = s.hdExt && s.hdExt.frcData, h = !!c && !c.empty(), d = Zs(l.polygons);
                if (a && !d) return "skip";
                if (a && d) return t1.polygonCoverageTiles.push({
                    coord: t1.coord,
                    bufferData: t1.bufferData,
                    program: t1.program,
                    programConfiguration: t1.programConfiguration,
                    uniformValues: t1.uniformValues,
                    depthMode: t1.depthMode,
                    dynamicBuffers: t1.dynamicBuffers,
                    indexBuffer: t1.indexBuffer,
                    segments: t1.segments,
                    frcMask: l.frcMask
                }), "deferred";
                if (n && h && c) {
                    const s = l.frcMask, r = i.transform.zoom;
                    for (const [o, n] of c.frcPerLevel)s & 1 << o || 0 !== n.segments.length && t1.program.draw(i, t1.drawMode, t1.depthMode, t1.stencilMode, t1.colorMode, e1.a5.disabled, t1.uniformValues, t1.layer.id, t1.bufferData.layoutVertexBuffer, t1.indexBuffer, n, t1.layer.paint, r, t1.programConfiguration, t1.dynamicBuffers);
                    return c.frcNonRoadSegments.segments.length > 0 && t1.program.draw(i, t1.drawMode, t1.depthMode, t1.stencilMode, t1.colorMode, e1.a5.disabled, t1.uniformValues, t1.layer.id, t1.bufferData.layoutVertexBuffer, t1.indexBuffer, c.frcNonRoadSegments, t1.layer.paint, r, t1.programConfiguration, t1.dynamicBuffers), "drawn";
                }
                return "fallthrough";
            },
            drawFillFrcCoverageSecondPass: function(t1, i, s, r, o) {
                if (0 === s.length) return;
                const n = Ws(t1), a = t1.transform.zoom, l = (s, n, l)=>{
                    1 !== l && (s.uniformValues.u_opacity_multiplier = l), s.program.draw(t1, r, s.depthMode, n, o, e1.a5.disabled, s.uniformValues, i.id, s.bufferData.layoutVertexBuffer, s.indexBuffer, s.segments, i.paint, a, s.programConfiguration, s.dynamicBuffers), 1 !== l && (s.uniformValues.u_opacity_multiplier = 1);
                };
                $s(t1, s, n, (e1, t1, i)=>l(e1, i, 1), (e1, t1, i)=>l(e1, i, n));
            },
            drawLineFrcCoverageDetect: function(e1, t1, i, s, r, o) {
                const n = t1.hdExt && t1.hdExt.frcData;
                if (!n || 0 === n.frcPerLevel.size) return null;
                if (!e1.frcCoverageSnapshot || s) return null;
                const a = e1.frcCoverageSnapshot.getTileOrParent(i.canonical);
                if (!a || 0 === a.frcMask) return null;
                const l = Zs(a.polygons), c = e1.frcCoverageFadeRange, h = null != c && e1.transform.zoom >= c[0];
                if (l && h) {
                    let e1 = !1;
                    for (const t1 of n.frcPerLevel.keys())if (a.frcMask & 1 << t1) {
                        e1 = !0;
                        break;
                    }
                    e1 && o.push({
                        coord: i,
                        bucket: t1,
                        drawWithSegments: r,
                        frcMask: a.frcMask
                    });
                }
                return {
                    coverageTile: a,
                    frcMask: a.frcMask,
                    active: h,
                    hasPolygonGeometry: l
                };
            },
            drawLineFrcRenderLine: function(e1, t1, i, s) {
                const r = e1.hdExt && e1.hdExt.frcData;
                if (!r) return;
                const o = t1.frcMask;
                for (const [e1, t1] of r.frcPerLevel)o & 1 << e1 || s(i, t1);
                const n = r.frcNonRoadSegments;
                n.segments.length > 0 && s(i, n);
            },
            drawLineFrcFadePass: function(e1, t1, i, s, r, o, n) {
                if (s.hasPolygonGeometry) return;
                const a = t1.hdExt && t1.hdExt.frcData;
                if (!a || !e1.frcCoverageFadeRange) return;
                const [l, c] = e1.frcCoverageFadeRange;
                if (l >= c) return;
                const h = 1 - Math.max(0, Math.min(1, (e1.transform.zoom - l) / (c - l)));
                if (h <= 0) return;
                const d = r ? o : e1.stencilModeForClipping(i), u = s.frcMask;
                for (const [e1, t1] of a.frcPerLevel)u & 1 << e1 && n(d, t1, h);
            },
            drawLineFrcCoverageSecondPass: function(e1, t1, i) {
                if (0 === i.length) return;
                const s = Ws(e1), r = (e1, t1, i, s)=>{
                    const r = e1.bucket.hdExt && e1.bucket.hdExt.frcData, o = r && r.frcPerLevel.get(t1);
                    e1.drawWithSegments(i, o, s);
                };
                $s(e1, i, s, (e1, t1, i)=>r(e1, t1, i), (e1, t1, i)=>r(e1, t1, i, s));
            }
        }, Xs = Hs;
        async function Ys() {
            return Promise.resolve();
        }
        function Ks(t1, i) {
            const s = Math.pow(2, i.canonical.z), r = i.canonical.y;
            return [
                new e1.b$(0, r / s).toLngLat().lat,
                new e1.b$(0, (r + 1) / s).toLngLat().lat
            ];
        }
        function Qs(t1, i, s, r, o, n, a) {
            const l = t1.context, c = l.gl, h = s.hillshadeFBO;
            if (!h) return;
            t1.prepareDrawTile();
            const d = t1.isTileAffectedByFog(i), u = [];
            t1.terrain && t1.terrain.renderingToTexture && t1.isEmissiveMrtActive() && (u.push("USE_MRT1"), "mrt-full-rgba" === t1.emissiveMode && u.push("USE_MRT1_RGBA"));
            const p = t1.getOrCreateProgram("hillshade", {
                overrideFog: d,
                defines: u
            });
            l.activeTexture.set(c.TEXTURE0), c.bindTexture(c.TEXTURE_2D, h.colorAttachment0.get());
            const f = ((t1, i, s, r)=>{
                const o = s.paint.get("hillshade-shadow-color"), n = "none" === s.paint.get("hillshade-shadow-color-use-theme").constantOr("default"), a = s.paint.get("hillshade-highlight-color"), l = "none" === s.paint.get("hillshade-highlight-color-use-theme").constantOr("default"), c = s.paint.get("hillshade-accent-color"), h = "none" === s.paint.get("hillshade-accent-color-use-theme").constantOr("default"), d = s.paint.get("hillshade-emissive-strength");
                let u = e1.aF(s.paint.get("hillshade-illumination-direction"));
                if ("viewport" === s.paint.get("hillshade-illumination-anchor")) u -= t1.transform.angle;
                else if (t1.style && t1.style.enable3dLights() && t1.style.directionalLight) {
                    const i = t1.style.directionalLight.properties.get("direction"), s = e1.c4(i.x, i.y, i.z);
                    u = e1.aF(s[1]);
                }
                const p = !t1.options.moving;
                return {
                    u_matrix: r || t1.transform.calculateProjMatrix(i.tileID.toUnwrapped(), p),
                    u_image: 0,
                    u_latrange: Ks(0, i.tileID),
                    u_light: [
                        s.paint.get("hillshade-exaggeration"),
                        u
                    ],
                    u_shadow: o.toPremultipliedRenderColor(n ? null : s.lut),
                    u_highlight: a.toPremultipliedRenderColor(l ? null : s.lut),
                    u_emissive_strength: d,
                    u_accent: c.toPremultipliedRenderColor(h ? null : s.lut)
                };
            })(t1, s, r, t1.terrain ? i.projMatrix : null);
            t1.uploadCommonUniforms(l, p, i.toUnwrapped());
            const { tileBoundsBuffer: m, tileBoundsIndexBuffer: _, tileBoundsSegments: g } = t1.getTileBoundsBuffers(s);
            p.draw(t1, c.TRIANGLES, o, n, a, e1.a5.disabled, f, r.id, m, _, g);
        }
        function Js(t1, i, s) {
            if (!i.needsDEMTextureUpload) return;
            const r = t1.context, o = r.gl;
            r.pixelStoreUnpackPremultiplyAlpha.set(!1), i.demTexture = i.demTexture || t1.getTileTexture(s.stride);
            const n = s.getPixels();
            i.demTexture ? i.demTexture.update(n, {
                premultiply: !1
            }) : i.demTexture = new e1.T(r, n, o.R32F, {
                premultiply: !1
            }), i.needsDEMTextureUpload = !1;
        }
        function er(t1, i, s) {
            const r = t1.context, o = r.gl;
            if (!i.dem) return;
            const n = i.dem;
            if (r.activeTexture.set(o.TEXTURE1), Js(t1, i, n), !i.demTexture) return;
            i.demTexture.bind(o.NEAREST, o.CLAMP_TO_EDGE);
            const a = n.dim;
            r.activeTexture.set(o.TEXTURE0);
            let l = i.hillshadeFBO;
            if (!l) {
                const t1 = new e1.T(r, {
                    width: a,
                    height: a,
                    data: null
                }, o.RGBA8);
                t1.bind(o.LINEAR, o.CLAMP_TO_EDGE), l = i.hillshadeFBO = r.createFramebuffer(a, a, 1, "renderbuffer"), l.colorAttachment0.set(t1.texture);
            }
            r.bindFramebuffer.set(l.framebuffer), r.viewport.set([
                0,
                0,
                a,
                a
            ]);
            const { tileBoundsBuffer: c, tileBoundsIndexBuffer: h, tileBoundsSegments: d } = t1.getMercatorTileBoundsBuffers(), u = [];
            t1.linearFloatFilteringSupported() && u.push("TERRAIN_DEM_FLOAT_FORMAT"), t1.terrain && t1.terrain.renderingToTexture && t1.isEmissiveMrtActive() && (u.push("USE_MRT1"), "mrt-full-rgba" === t1.emissiveMode && u.push("USE_MRT1_RGBA")), t1.getOrCreateProgram("hillshadePrepare", {
                defines: u
            }).draw(t1, o.TRIANGLES, e1.a3.disabled, e1.a4.disabled, e1.a7.unblended, e1.a5.disabled, ((t1, i)=>{
                const s = i.stride, r = e1.a2();
                return e1.c3(r, 0, e1.ac, -e1.ac, 0, 0, 1), e1.bX(r, r, [
                    0,
                    -e1.ac,
                    0
                ]), {
                    u_matrix: r,
                    u_image: 1,
                    u_dimension: [
                        s,
                        s
                    ],
                    u_zoom: t1.overscaledZ
                };
            })(i.tileID, n), s.id, c, h, d), i.needsHillshadePrepare = !1;
        }
        class tr {
            constructor(e1){
                this.gl = e1.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
            }
            get() {
                return this.current;
            }
            set(e1) {}
            getDefault() {
                return this.default;
            }
            setDefault() {
                this.set(this.default);
            }
        }
        class ir extends tr {
            getDefault() {
                return e1.C.transparent.toNonPremultipliedRenderColor(null);
            }
            set(e1) {
                const t1 = this.current;
                (e1.r !== t1.r || e1.g !== t1.g || e1.b !== t1.b || e1.a !== t1.a || this.dirty) && (this.gl.clearColor(e1.r, e1.g, e1.b, e1.a), this.current = e1, this.dirty = !1);
            }
        }
        class sr extends tr {
            getDefault() {
                return 1;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.clearDepth(e1), this.current = e1, this.dirty = !1);
            }
        }
        class rr extends tr {
            getDefault() {
                return 0;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.clearStencil(e1), this.current = e1, this.dirty = !1);
            }
        }
        class or extends tr {
            getDefault() {
                return [
                    !0,
                    !0,
                    !0,
                    !0
                ];
            }
            set(e1) {
                const t1 = this.current;
                (e1[0] !== t1[0] || e1[1] !== t1[1] || e1[2] !== t1[2] || e1[3] !== t1[3] || this.dirty) && (this.gl.colorMask(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
            }
        }
        class nr extends tr {
            getDefault() {
                return !0;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.depthMask(e1), this.current = e1, this.dirty = !1);
            }
        }
        class ar extends tr {
            getDefault() {
                return 255;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.stencilMask(e1), this.current = e1, this.dirty = !1);
            }
        }
        class lr extends tr {
            getDefault() {
                return {
                    func: this.gl.ALWAYS,
                    ref: 0,
                    mask: 255
                };
            }
            set(e1) {
                const t1 = this.current;
                (e1.func !== t1.func || e1.ref !== t1.ref || e1.mask !== t1.mask || this.dirty) && (this.gl.stencilFunc(e1.func, e1.ref, e1.mask), this.current = e1, this.dirty = !1);
            }
        }
        class cr extends tr {
            getDefault() {
                const e1 = this.gl;
                return [
                    e1.KEEP,
                    e1.KEEP,
                    e1.KEEP
                ];
            }
            set(e1) {
                const t1 = this.current;
                (e1[0] !== t1[0] || e1[1] !== t1[1] || e1[2] !== t1[2] || this.dirty) && (this.gl.stencilOp(e1[0], e1[1], e1[2]), this.current = e1, this.dirty = !1);
            }
        }
        class hr extends tr {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                e1 ? t1.enable(t1.STENCIL_TEST) : t1.disable(t1.STENCIL_TEST), this.current = e1, this.dirty = !1;
            }
        }
        class dr extends tr {
            getDefault() {
                return [
                    0,
                    1
                ];
            }
            set(e1) {
                const t1 = this.current;
                (e1[0] !== t1[0] || e1[1] !== t1[1] || this.dirty) && (this.gl.depthRange(e1[0], e1[1]), this.current = e1, this.dirty = !1);
            }
        }
        class ur extends tr {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                e1 ? t1.enable(t1.DEPTH_TEST) : t1.disable(t1.DEPTH_TEST), this.current = e1, this.dirty = !1;
            }
        }
        class pr extends tr {
            getDefault() {
                return this.gl.LESS;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.depthFunc(e1), this.current = e1, this.dirty = !1);
            }
        }
        class fr extends tr {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                e1 ? t1.enable(t1.BLEND) : t1.disable(t1.BLEND), this.current = e1, this.dirty = !1;
            }
        }
        class mr extends tr {
            getDefault() {
                const e1 = this.gl;
                return [
                    e1.ONE,
                    e1.ZERO,
                    e1.ONE,
                    e1.ZERO
                ];
            }
            set(e1) {
                const t1 = this.current;
                (e1[0] !== t1[0] || e1[1] !== t1[1] || e1[2] !== t1[2] || e1[3] !== t1[3] || this.dirty) && (this.gl.blendFuncSeparate(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
            }
        }
        class _r extends tr {
            getDefault() {
                return e1.C.transparent.toNonPremultipliedRenderColor(null);
            }
            set(e1) {
                const t1 = this.current;
                (e1.r !== t1.r || e1.g !== t1.g || e1.b !== t1.b || e1.a !== t1.a || this.dirty) && (this.gl.blendColor(e1.r, e1.g, e1.b, e1.a), this.current = e1, this.dirty = !1);
            }
        }
        class gr extends tr {
            getDefault() {
                return this.gl.FUNC_ADD;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.blendEquationSeparate(e1, e1), this.current = e1, this.dirty = !1);
            }
        }
        class yr extends tr {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                e1 ? t1.enable(t1.CULL_FACE) : t1.disable(t1.CULL_FACE), this.current = e1, this.dirty = !1;
            }
        }
        class vr extends tr {
            getDefault() {
                return this.gl.BACK;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.cullFace(e1), this.current = e1, this.dirty = !1);
            }
        }
        class br extends tr {
            getDefault() {
                return this.gl.CCW;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.frontFace(e1), this.current = e1, this.dirty = !1);
            }
        }
        let xr = class extends tr {
            getDefault() {
                return null;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.useProgram(e1), this.current = e1, this.dirty = !1);
            }
        };
        class wr extends tr {
            getDefault() {
                return this.gl.TEXTURE0;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.activeTexture(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Tr extends tr {
            getDefault() {
                const e1 = this.gl;
                return [
                    0,
                    0,
                    e1.drawingBufferWidth,
                    e1.drawingBufferHeight
                ];
            }
            set(e1) {
                const t1 = this.current;
                (e1[0] !== t1[0] || e1[1] !== t1[1] || e1[2] !== t1[2] || e1[3] !== t1[3] || this.dirty) && (this.gl.viewport(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
            }
        }
        class Sr extends tr {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindFramebuffer(t1.FRAMEBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Cr extends tr {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindRenderbuffer(t1.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Er extends tr {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindTexture(t1.TEXTURE_2D, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Ir extends tr {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindBuffer(t1.ARRAY_BUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Dr extends tr {
            getDefault() {
                return null;
            }
            set(e1) {
                const t1 = this.gl;
                t1.bindBuffer(t1.ELEMENT_ARRAY_BUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Pr extends tr {
            getDefault() {
                return null;
            }
            set(e1) {
                this.gl && (e1 !== this.current || this.dirty) && (this.gl.bindVertexArray(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Lr extends tr {
            getDefault() {
                return 4;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.pixelStorei(t1.UNPACK_ALIGNMENT, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Rr extends tr {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.pixelStorei(t1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Ar extends tr {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.pixelStorei(t1.UNPACK_FLIP_Y_WEBGL, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Mr extends tr {
            constructor(e1, t1){
                super(e1), this.context = e1, this.parent = t1;
            }
            getDefault() {
                return null;
            }
        }
        class Fr extends Mr {
            constructor(e1, t1, i = 0){
                super(e1, t1), this.attachmentPoint = e1.gl.COLOR_ATTACHMENT0 + i;
            }
            setDirty() {
                this.dirty = !0;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t1 = this.gl;
                t1.framebufferTexture2D(t1.FRAMEBUFFER, this.attachmentPoint, t1.TEXTURE_2D, e1, 0), this.current = e1, this.dirty = !1;
            }
        }
        class Or extends Mr {
            attachment() {
                return this.gl.DEPTH_ATTACHMENT;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t1 = this.gl;
                t1.framebufferRenderbuffer(t1.FRAMEBUFFER, this.attachment(), t1.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class kr extends Mr {
            attachment() {
                return this.gl.DEPTH_ATTACHMENT;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t1 = this.gl;
                t1.framebufferTexture2D(t1.FRAMEBUFFER, this.attachment(), t1.TEXTURE_2D, e1, 0), this.current = e1, this.dirty = !1;
            }
        }
        class Br extends Or {
            attachment() {
                return this.gl.DEPTH_STENCIL_ATTACHMENT;
            }
        }
        const zr = (e1, t1, i, s)=>({
                u_matrix: e1,
                u_image0: 0,
                u_image1: 1,
                u_skirt_height: t1,
                u_ground_shadow_factor: i,
                u_emissive_texture_available: s
            }), Ur = (e1, t1, i, s, r, o, n, a, l, c, h, d, u, p, f, m, _)=>({
                u_proj_matrix: Float32Array.from(e1),
                u_globe_matrix: t1,
                u_normalize_matrix: Float32Array.from(s),
                u_merc_matrix: i,
                u_zoom_transition: r,
                u_merc_center: o,
                u_image0: 0,
                u_image1: 1,
                u_frustum_tl: n,
                u_frustum_tr: a,
                u_frustum_br: l,
                u_frustum_bl: c,
                u_globe_pos: h,
                u_globe_radius: d,
                u_viewport: u,
                u_grid_matrix: _ ? Float32Array.from(_) : new Float32Array(9),
                u_skirt_height: p,
                u_far_z_cutoff: f,
                u_emissive_texture_available: m
            });
        function Nr(e1, t1) {
            return null != e1 && null != t1 && !(!e1.hasData() || !t1.hasData()) && null != e1.demTexture && null != t1.demTexture && e1.tileID.key !== t1.tileID.key;
        }
        const jr = new class {
            constructor(){
                this.operations = {};
            }
            newMorphing(e1, t1, i, s, r) {
                if (e1 in this.operations) {
                    const t1 = this.operations[e1];
                    t1.to.tileID.key !== i.tileID.key && (t1.queued = i);
                } else this.operations[e1] = {
                    startTime: s,
                    phase: 0,
                    duration: r,
                    from: t1,
                    to: i,
                    queued: null
                };
            }
            getMorphValuesForProxy(e1) {
                if (!(e1 in this.operations)) return null;
                const t1 = this.operations[e1];
                return {
                    from: t1.from,
                    to: t1.to,
                    phase: t1.phase
                };
            }
            update(e1) {
                for(const t1 in this.operations){
                    const i = this.operations[t1];
                    for(i.phase = (e1 - i.startTime) / i.duration; i.phase >= 1 || !this._validOp(i);)if (!this._nextOp(i, e1)) {
                        delete this.operations[t1];
                        break;
                    }
                }
            }
            _nextOp(e1, t1) {
                return !!e1.queued && (e1.from = e1.to, e1.to = e1.queued, e1.queued = null, e1.phase = 0, e1.startTime = t1, !0);
            }
            _validOp(e1) {
                return e1.from.hasData() && e1.to.hasData();
            }
        };
        function Vr(e1, t1, i) {
            if (0 === t1) return 0;
            const s = t1 < 1 && 514 === i ? .25 / t1 : 1;
            return 6 * Math.pow(1.5, 22 - e1) * Math.max(t1, 1) * s;
        }
        function Gr(e1, t1) {
            const i = 1 << e1.z;
            return !t1 && (0 === e1.x || e1.x === i - 1) || 0 === e1.y || e1.y === i - 1;
        }
        function qr(e1, t1) {
            if (!e1.style || !e1.style.enable3dLights()) return;
            const i = e1.context, s = i.gl;
            i.activeTexture.set(s.TEXTURE1), t1 ? t1.bind(s.LINEAR, s.CLAMP_TO_EDGE) : e1.emptyTexture.bind(s.LINEAR, s.CLAMP_TO_EDGE);
        }
        class $r extends e1.E {
            constructor(e1, t1, i, s, r, o){
                super(), this.id = e1, this.type = t1, this.tileSize = i, this.minzoom = s, this.maxzoom = r, this.roundZoom = !1, this.reparseOverscaled = o;
            }
            loaded() {
                return !0;
            }
            loadTile(e1, t1) {
                t1(null);
            }
            serialize() {
                return {
                    type: this.type
                };
            }
        }
        class Zr extends bs {
            constructor(e1){
                const t1 = new $r("mock-dem", "raster-dem", 512, 0, Math.ceil(e1.transform.maxZoom), !1);
                super("mock-dem", t1, null), t1.setEventedParent(this), this._sourceLoaded = !0;
            }
            _loadTile(e1, t1) {
                e1.state = "loaded", t1(null);
            }
        }
        class Wr extends bs {
            constructor(e1){
                const t1 = new $r("proxy", "geojson", 512, 0, Math.ceil(e1.transform.maxZoom), !0);
                super("proxy", t1, null), t1.setEventedParent(this), this.map = this.getSource().map = e1, this.used = this._sourceLoaded = !0, this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
            }
            update(e1, t1, i) {
                if (e1.freezeTileCoverage) return;
                this.transform = e1;
                const s = e1.coveringTiles({
                    tileSize: this._source.tileSize,
                    minzoom: this._source.minzoom,
                    maxzoom: this._source.maxzoom,
                    roundZoom: this._source.roundZoom,
                    reparseOverscaled: this._source.reparseOverscaled
                }), r = new Set;
                for (const t1 of s)if (r.add(t1.key), !this._tiles.has(t1.key)) {
                    const i = new _s(t1, this._source.tileSize * t1.overscaleFactor(), e1.tileZoom, void 0, void 0, this._source.worldview);
                    i.state = "loaded", this._tiles.set(t1.key, i);
                }
                for (const [e1, t1] of this._tiles)r.has(e1) || (this.freeFBO(e1), t1.unloadVectorData(), this._tiles.delete(e1));
            }
            freeFBO(e1) {
                const t1 = this.proxyCachedFBO[e1];
                if (void 0 !== t1) {
                    const i = Object.values(t1);
                    this.renderCachePool.push(...i), delete this.proxyCachedFBO[e1];
                }
            }
            deallocRenderCache() {
                this.renderCache.forEach((e1)=>e1.fb.destroy()), this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
            }
        }
        class Hr extends e1.bZ {
            constructor(e1, t1, i){
                super(e1.overscaledZ, e1.wrap, e1.canonical.z, e1.canonical.x, e1.canonical.y), this.proxyTileKey = t1, this.projMatrix = i;
            }
        }
        function Xr(e1, t1) {
            return "rgba8" === t1 ? e1.RGBA8 : e1.R8;
        }
        class Yr extends e1.c8 {
            constructor(t1, i){
                super(), this.painter = t1, this.terrainTileForTile = {}, this.prevTerrainTileForTile = {};
                const [s, r, o] = function() {
                    const t1 = new e1.bN, i = new e1.ak, s = 131;
                    t1.reserve(17161), i.reserve(33800);
                    const r = e1.ac / 128, o = e1.ac + r / 2, n = o + r;
                    for(let i = -r; i < n; i += r)for(let s = -r; s < n; s += r){
                        const r = s < 0 || s > o || i < 0 || i > o ? 24575 : 0, n = e1.bb(Math.round(s), 0, e1.ac), a = e1.bb(Math.round(i), 0, e1.ac);
                        t1.emplaceBack(n + r, a);
                    }
                    const a = (e1, t1)=>{
                        const r = t1 * s + e1;
                        i.emplaceBack(r + 1, r, r + s), i.emplaceBack(r + s, r + s + 1, r + 1);
                    };
                    for(let e1 = 1; e1 < 129; e1++)for(let t1 = 1; t1 < 129; t1++)a(t1, e1);
                    return [
                        0,
                        129
                    ].forEach((e1)=>{
                        for(let t1 = 0; t1 < 130; t1++)a(t1, e1), a(e1, t1);
                    }), [
                        t1,
                        i,
                        32768
                    ];
                }(), n = t1.context;
                this.gridBuffer = n.createVertexBuffer(s, e1.bP.members), this.gridIndexBuffer = n.createIndexBuffer(r), this.gridSegments = e1.aj.simpleSegment(0, 0, s.length, r.length), this.gridNoSkirtSegments = e1.aj.simpleSegment(0, 0, s.length, o), this.proxyCoords = [], this.proxiedCoords = {}, this._visibleDemTiles = [], this._drapedRenderBatches = [], this._sourceTilesOverlap = {}, this.proxySourceCache = new Wr(i.map), this.orthoMatrix = e1.a2(), e1.c3(this.orthoMatrix, "globe" === this.painter.transform.projection.name ? .015 : 0, e1.ac, 0, e1.ac, 0, 1);
                const a = n.gl;
                this._overlapStencilMode = new e1.a4({
                    func: a.GEQUAL,
                    mask: 255
                }, 0, 255, a.KEEP, a.KEEP, a.REPLACE), this._previousZoom = t1.transform.zoom, this.pool = [], this._findCoveringTileCache = {}, this._tilesDirty = {}, this.style = i, this._useVertexMorphing = !0, this._exaggeration = 1, this._mockSourceCache = new Zr(i.map), this._pendingGroundEffectLayers = [], this._emissiveTexture = "none", this._devtoolsFolder = null;
            }
            set style(e1) {
                e1.on("data", this._onStyleDataEvent.bind(this)), this._style = e1, this._style.map.on("moveend", ()=>{
                    this._clearLineLayersFromRenderCache();
                });
            }
            update(t1, i, s) {
                if (t1 && t1.terrain) {
                    this._style !== t1 && (this.style = t1, this._evaluationZoom = void 0);
                    const r = t1.terrain.properties, o = 0 === t1.terrain.drapeRenderMode, n = t1.terrain.isZoomDependent();
                    this._previousUpdateTimestamp = this.enabled ? this._updateTimestamp : void 0, this._updateTimestamp = e1.e.now();
                    const a = t1.terrain && t1.terrain.scope, l = r.get("source"), c = o ? this._mockSourceCache : t1.getSourceCache(l, a);
                    if (!c) return void e1.w(`Couldn't find terrain source "${l}".`);
                    if (this.sourceCache = c, this._attenuationRange = t1.terrain.getAttenuationRange(), this._exaggeration = n ? this.calculateExaggeration(i) : r.get("exaggeration"), !i.projection.requiresDraping && n && 0 === this._exaggeration) return void this._disable();
                    this.enabled = !0;
                    const h = ()=>{
                        this.sourceCache.used && e1.w(`Raster DEM source '${this.sourceCache.id}' is used both for terrain and as layer source.\nThis leads to lower resolution of hillshade. For full hillshade resolution but higher memory consumption, define another raster DEM source.`);
                        const t1 = this.getScaledDemTileSize();
                        this.sourceCache.update(i, t1, !0), this.resetTileLookupCache(this.sourceCache.id);
                    };
                    this.sourceCache.usedForTerrain || (this.resetTileLookupCache(this.sourceCache.id), this.sourceCache.usedForTerrain = !0, h(), this._initializing = !0), h(), i.updateElevation(!0, s), this.resetTileLookupCache(this.proxySourceCache.id), this.proxySourceCache.update(i), this._emptyDEMTextureDirty = !0, this._previousZoom = i.zoom;
                } else this._disable();
            }
            calculateExaggeration(t1) {
                if (this._attenuationRange && t1.zoom >= Math.ceil(this._attenuationRange[1])) return this._style.terrain.getExaggeration(t1.zoom);
                const i = this._previousCameraAltitude, s = t1.getFreeCameraOptions().position.z / t1.pixelsPerMeter * t1.worldSize;
                this._previousCameraAltitude = s;
                const r = null != i ? s - i : Number.MAX_VALUE;
                if (Math.abs(r) < 2) return this._exaggeration;
                const o = t1.zoom, n = this._style.terrain;
                if (!this._previousUpdateTimestamp) return n.getExaggeration(o);
                let a = o - this._previousZoom;
                const l = this._previousUpdateTimestamp;
                let c = o;
                null != this._evaluationZoom && (c = this._evaluationZoom, Math.abs(o - c) > .5 && (a = .5 * (o - c + a)), a * r < 0 && (c += a)), this._evaluationZoom = c;
                const h = n.getExaggeration(c), d = h === n.getExaggeration(Math.max(0, c - .1));
                if (d && Math.abs(h - this._exaggeration) < .01) return h;
                let u = Math.min(.1, .00375 * (this._updateTimestamp - l));
                return (d || h < .1 || Math.abs(a) < 1e-4) && (u = Math.min(.2, 4 * u)), e1.aw(this._exaggeration, h, u);
            }
            resetTileLookupCache(e1) {
                this._findCoveringTileCache[e1] = {};
            }
            attenuationRange() {
                return this._attenuationRange;
            }
            getDemUpscale() {
                return this.proxySourceCache.getSource().tileSize / 128;
            }
            getScaledDemTileSize() {
                return this.sourceCache.getSource().tileSize / 128 * this.proxySourceCache.getSource().tileSize;
            }
            _onStyleDataEvent(e1) {
                "source" === e1.dataType && e1.coord ? this._clearRenderCacheForTile(e1.sourceCacheId, e1.coord) : "style" === e1.dataType && (this.invalidateRenderCache = !0, this._evaluationZoom = void 0, this._previousUpdateTimestamp = void 0, this._previousCameraAltitude = void 0);
            }
            _disable() {
                if (this.enabled && (this.enabled = !1, this._emptyDEMTextureDirty = !0, this._sharedDepthStencil = void 0, this._evaluationZoom = void 0, this._previousUpdateTimestamp = void 0, this.proxySourceCache.deallocRenderCache(), this._style)) for(const e1 in this._style._mergedSourceCaches)this._style._mergedSourceCaches[e1].usedForTerrain = !1;
            }
            destroy() {
                this._disable(), this._emptyDEMTexture && this._emptyDEMTexture.destroy(), this.pool.forEach((e1)=>e1.fb.destroy()), this.pool = [], this.framebufferCopyTexture && this.framebufferCopyTexture.destroy();
            }
            _source() {
                return this.enabled ? this.sourceCache : null;
            }
            isUsingMockSource() {
                return this.sourceCache === this._mockSourceCache;
            }
            exaggeration() {
                return this.enabled ? this._exaggeration : 0;
            }
            get visibleDemTiles() {
                return this._visibleDemTiles;
            }
            get drapeBufferSize() {
                const e1 = 2 * this.proxySourceCache.getSource().tileSize;
                return [
                    e1,
                    e1
                ];
            }
            set useVertexMorphing(e1) {
                this._useVertexMorphing = e1;
            }
            updateTileBinding(t1) {
                if (!this.enabled) return;
                this.prevTerrainTileForTile = this.terrainTileForTile;
                const i = this.proxySourceCache, s = this.painter.transform;
                this._initializing && (this._initializing = 0 === s._centerAltitude && -1 === this.getAtPointOrZero(e1.b$.fromLngLat(s.center), -1), this._emptyDEMTextureDirty = !this._initializing);
                const r = this.proxyCoords = i.getIds().map((e1)=>{
                    const t1 = i.getTileByID(e1).tileID;
                    return t1.projMatrix = s.calculateProjMatrix(t1.toUnwrapped()), t1;
                });
                !function(t1, i) {
                    const s = i.transform.pointCoordinate(i.transform.getCameraPoint()), r = new e1.P(s.x, s.y);
                    t1.sort((t1, i)=>{
                        if (i.overscaledZ - t1.overscaledZ) return i.overscaledZ - t1.overscaledZ;
                        const s = new e1.P(t1.canonical.x + (1 << t1.canonical.z) * t1.wrap, t1.canonical.y), o = new e1.P(i.canonical.x + (1 << i.canonical.z) * i.wrap, i.canonical.y), n = r.mult(1 << t1.canonical.z);
                        return n.x -= .5, n.y -= .5, n.distSqr(s) - n.distSqr(o);
                    });
                }(r, this.painter);
                const o = this.proxyToSource || {};
                this.proxyToSource = {}, r.forEach((e1)=>{
                    this.proxyToSource[e1.key] = {};
                }), this.terrainTileForTile = {};
                const n = this._style._mergedSourceCaches;
                for(const e1 in n){
                    const i = n[e1];
                    if (!i.used) continue;
                    if (!i.transform) continue;
                    if (i !== this.sourceCache && this.resetTileLookupCache(i.id), this._setupProxiedCoordsForOrtho(i, t1[e1], o), i.usedForTerrain) continue;
                    const s = t1[e1];
                    (i.getSource().reparseOverscaled || i._isRasterElevatedOverTerrain) && this._assignTerrainTiles(s);
                }
                this.proxiedCoords[i.id] = r.map((e1)=>new Hr(e1, e1.key, this.orthoMatrix)), this._assignTerrainTiles(r), this._prepareDEMTextures(), this._setupDrapedRenderBatches(), this._initFBOPool(), this._setupRenderCache(o), this.renderingToTexture = !1;
                const a = {};
                this._visibleDemTiles = [];
                for (const e1 of this.proxyCoords){
                    const t1 = this.terrainTileForTile[e1.key];
                    if (!t1) continue;
                    const i = t1.tileID.key;
                    i in a || (this._visibleDemTiles.push(t1), a[i] = i);
                }
            }
            _assignTerrainTiles(e1) {
                this._initializing || e1.forEach((e1)=>{
                    if (this.terrainTileForTile[e1.key]) return;
                    const t1 = this._findTileCoveringTileID(e1, this.sourceCache);
                    t1 && (this.terrainTileForTile[e1.key] = t1);
                });
            }
            _prepareDEMTextures() {
                const e1 = this.painter.context, t1 = e1.gl;
                for(const i in this.terrainTileForTile){
                    const s = this.terrainTileForTile[i], r = s.dem;
                    !r || s.demTexture && !s.needsDEMTextureUpload || (e1.activeTexture.set(t1.TEXTURE1), Js(this.painter, s, r));
                }
            }
            _prepareDemTileUniforms(e1, t1, i, s) {
                if (!t1 || null == t1.demTexture) return !1;
                const r = e1.tileID.canonical, o = Math.pow(2, t1.tileID.canonical.z - r.z), n = s || "";
                return i[`u_dem_tl${n}`] = [
                    r.x * o % 1,
                    r.y * o % 1
                ], i[`u_dem_scale${n}`] = o, !0;
            }
            get emptyDEMTexture() {
                return !this._emptyDEMTextureDirty && this._emptyDEMTexture ? this._emptyDEMTexture : this._updateEmptyDEMTexture();
            }
            _getLoadedAreaMinimum() {
                if (!this.enabled) return 0;
                let e1 = 0;
                const t1 = this._visibleDemTiles.reduce((t1, i)=>{
                    if (!i.dem) return t1;
                    const s = i.dem.tree.minimums[0];
                    return s > 0 && e1++, t1 + s;
                }, 0);
                return e1 ? t1 / e1 : 0;
            }
            _updateEmptyDEMTexture() {
                const t1 = this.painter.context, i = t1.gl;
                t1.activeTexture.set(i.TEXTURE2);
                const s = this._getLoadedAreaMinimum(), r = new e1.c9({
                    width: 1,
                    height: 1
                }, new Float32Array([
                    s
                ]));
                this._emptyDEMTextureDirty = !1;
                let o = this._emptyDEMTexture;
                return o ? o.update(r, {
                    premultiply: !1
                }) : o = this._emptyDEMTexture = new e1.T(t1, r, i.R32F, {
                    premultiply: !1
                }), o;
            }
            setupElevationDraw(t1, i, s) {
                const r = this.painter.context, o = r.gl, n = {
                    u_dem: 2,
                    u_dem_prev: 4,
                    u_dem_tl: [
                        0,
                        0
                    ],
                    u_dem_tl_prev: [
                        0,
                        0
                    ],
                    u_dem_scale: 0,
                    u_dem_scale_prev: 0,
                    u_dem_size: 0,
                    u_dem_lerp: 1,
                    u_depth: 3,
                    u_depth_size_inv: [
                        0,
                        0
                    ],
                    u_depth_range_unpack: [
                        0,
                        1
                    ],
                    u_occluder_half_size: 16,
                    u_occlusion_depth_offset: -0.0001,
                    u_exaggeration: 0
                };
                n.u_exaggeration = this.exaggeration();
                let a = null, l = null, c = 1;
                if (s && s.morphing && this._useVertexMorphing) {
                    const e1 = s.morphing.srcDemTile, i = s.morphing.dstDemTile;
                    c = s.morphing.phase, e1 && i && (this._prepareDemTileUniforms(t1, e1, n, "_prev") && (l = e1), this._prepareDemTileUniforms(t1, i, n) && (a = i));
                }
                const h = (e1)=>e1 && e1.demTexture && this.painter.linearFloatFilteringSupported() ? o.LINEAR : o.NEAREST;
                let d = null;
                var u;
                if (this.enabled ? l && a ? (d = a.demTexture, r.activeTexture.set(o.TEXTURE4), l.demTexture.bind(h(l), o.CLAMP_TO_EDGE), n.u_dem_lerp = c) : (a = this.terrainTileForTile[t1.tileID.key], d = this._prepareDemTileUniforms(t1, a, n) ? a.demTexture : this.emptyDEMTexture) : d = this.emptyDEMTexture, r.activeTexture.set(o.TEXTURE2), d && (n.u_dem_size = 1 === (u = d).size[0] ? 1 : u.size[0] - 2, d.bind(h(a), o.CLAMP_TO_EDGE)), this.painter.setupDepthForOcclusion(s && s.useDepthForOcclusion, i, n), s && s.useMeterToDem && a) {
                    const t1 = (1 << a.tileID.canonical.z) * e1.ca(1, this.painter.transform.center.lat) * this.sourceCache.getSource().tileSize;
                    n.u_meter_to_dem = t1;
                }
                if (s && s.labelPlaneMatrixInv && (n.u_label_plane_matrix_inv = s.labelPlaneMatrixInv), i.setTerrainUniformValues(r, n), "globe" === this.painter.transform.projection.name) {
                    const e1 = this.globeUniformValues(this.painter.transform, t1.tileID.canonical, s && s.useDenormalizedUpVectorScale);
                    i.setGlobeUniformValues(r, e1);
                }
            }
            globeUniformValues(t1, i, s) {
                const r = t1.projection;
                return {
                    u_tile_tl_up: r.upVector(i, 0, 0),
                    u_tile_tr_up: r.upVector(i, e1.ac, 0),
                    u_tile_br_up: r.upVector(i, e1.ac, e1.ac),
                    u_tile_bl_up: r.upVector(i, 0, e1.ac),
                    u_tile_up_scale: s ? e1.cb(1) : r.upVectorScale(i, t1.center.lat, t1.worldSize).metersToTile
                };
            }
            renderToBackBuffer(t1) {
                const i = this.painter, s = this.painter.context;
                0 !== t1.length && (s.bindFramebuffer.set(null), s.viewport.set([
                    0,
                    0,
                    i.width,
                    i.height
                ]), i.gpuTimingDeferredRenderStart(), this.renderingToTexture = !1, function(t1, i, s, r, o) {
                    if ("globe" === t1.transform.projection.name) !function(t1, i, s, r, o) {
                        const n = t1.context, a = n.gl;
                        let l, c;
                        const h = t1.transform, d = e1.c6(t1, n, h), u = (e1, i)=>{
                            if (c === i) return;
                            const s = [];
                            1 === i && s.push("TERRAIN_VERTEX_MORPHING"), s.push("PROJECTION_GLOBE_VIEW"), d && s.push("CUSTOM_ANTIALIASING");
                            const r = t1.isTileAffectedByFog(e1);
                            l = t1.getOrCreateProgram("globeRaster", {
                                defines: s,
                                overrideFog: r
                            }), c = i;
                        }, p = t1.colorModeForRenderPass(), f = new e1.a3(a.LEQUAL, e1.a3.ReadWrite, t1.depthRangeFor3D);
                        jr.update(o);
                        const m = e1.bh(h), _ = [
                            e1.ad(h.center.lng),
                            e1.ae(h.center.lat)
                        ], g = t1.globeSharedBuffers, y = [
                            h.width * e1.e.devicePixelRatio,
                            h.height * e1.e.devicePixelRatio
                        ], v = Float32Array.from(h.globeMatrix), b = {
                            useDenormalizedUpVectorScale: !0
                        };
                        {
                            const h = t1.transform, d = Vr(h.zoom, i.exaggeration(), i.sourceCache._source.tileSize);
                            c = -1;
                            const x = a.TRIANGLES;
                            for (const c of r){
                                const r = s.getTile(c), w = e1.a4.disabled, T = i.prevTerrainTileForTile[c.key], S = i.terrainTileForTile[c.key];
                                Nr(T, S) && jr.newMorphing(c.key, T, S, o, 250), qr(t1, r.emissiveTexture), n.activeTexture.set(a.TEXTURE0), r.texture && r.texture.bind(a.LINEAR, a.CLAMP_TO_EDGE);
                                const C = jr.getMorphValuesForProxy(c.key), E = C ? 1 : 0;
                                C && Object.assign(b, {
                                    morphing: {
                                        srcDemTile: C.from,
                                        dstDemTile: C.to,
                                        phase: e1.c5(C.phase)
                                    }
                                });
                                const I = e1.bd(c.canonical), D = e1.be(I.getCenter().lat), P = e1.bi(c.canonical, I, D, h.worldSize / h._pixelsPerMercatorPixel), L = e1.bf(e1.bg(c.canonical)), R = t1.isEmissiveMrtActive() ? 1 : 0, A = Ur(h.expandedFarZProjMatrix, v, m, L, e1._(h.zoom), _, h.frustumCorners.TL, h.frustumCorners.TR, h.frustumCorners.BR, h.frustumCorners.BL, h.globeCenterInViewSpace, h.globeRadius, y, d, h._farZ, R, P);
                                if (u(c, E), l && (i.setupElevationDraw(r, l, b), t1.uploadCommonUniforms(n, l, c.toUnwrapped()), g)) {
                                    const [i, s, r] = g.getGridBuffers(D, 0 !== d);
                                    l.draw(t1, x, f, w, p, e1.a5.backCCW, A, "globe_raster", i, s, r);
                                }
                            }
                        }
                        if (g && (t1.renderDefaultNorthPole || t1.renderDefaultSouthPole)) {
                            const o = [
                                "GLOBE_POLES",
                                "PROJECTION_GLOBE_VIEW"
                            ];
                            d && o.push("CUSTOM_ANTIALIASING"), l = t1.getOrCreateProgram("globeRaster", {
                                defines: o
                            });
                            for (const o of r){
                                const { x: r, y: c, z: d } = o.canonical, u = 0 === c, m = c === (1 << d) - 1, [v, x, w, T] = g.getPoleBuffers(d, !1);
                                if (T && (u || m)) {
                                    const c = s.getTile(o);
                                    qr(t1, c.emissiveTexture), n.activeTexture.set(a.TEXTURE0), c.texture && c.texture.bind(a.LINEAR, a.CLAMP_TO_EDGE);
                                    let g = e1.c7(d, r, h);
                                    const S = e1.bf(e1.bg(o.canonical)), C = t1.isEmissiveMrtActive() ? 1 : 0, E = (i, s)=>i.draw(t1, a.TRIANGLES, f, e1.a4.disabled, p, e1.a5.disabled, Ur(h.expandedFarZProjMatrix, g, g, S, 0, _, h.frustumCorners.TL, h.frustumCorners.TR, h.frustumCorners.BR, h.frustumCorners.BL, h.globeCenterInViewSpace, h.globeRadius, y, 0, h._farZ, C), "globe_pole_raster", s, w, T);
                                    i.setupElevationDraw(c, l, b), t1.uploadCommonUniforms(n, l, o.toUnwrapped()), u && t1.renderDefaultNorthPole && E(l, v), m && t1.renderDefaultSouthPole && (g = e1.aY(e1.a2(), g, [
                                        1,
                                        -1,
                                        1
                                    ]), E(l, x));
                                }
                            }
                        }
                    }(t1, i, s, r, o);
                    else {
                        const n = t1.context, a = n.gl;
                        let l, c;
                        const h = t1.shadowRenderer, d = e1.aP(t1, t1.longestCutoffRange), u = (e1)=>{
                            if (c === e1) return;
                            const i = [];
                            1 === e1 && i.push("TERRAIN_VERTEX_MORPHING"), d.shouldRenderCutoff && i.push("RENDER_CUTOFF"), h && (i.push("RENDER_SHADOWS"), h.useNormalOffset && i.push("NORMAL_OFFSET")), l = t1.getOrCreateProgram("terrainRaster", {
                                defines: i
                            }), c = e1;
                        }, p = t1.colorModeForRenderPass(), f = new e1.a3(a.LEQUAL, e1.a3.ReadWrite, t1.depthRangeFor3D);
                        jr.update(o);
                        const m = t1.transform, _ = Vr(m.zoom, i.exaggeration(), i.sourceCache._source.tileSize);
                        let g = [
                            0,
                            0,
                            0
                        ];
                        if (h) {
                            const i = t1.style.directionalLight, s = t1.style.ambientLight;
                            i && s && (g = e1.aQ(t1.style, i, s));
                        }
                        {
                            c = -1;
                            const y = a.TRIANGLES, [v, b] = [
                                i.gridIndexBuffer,
                                i.gridSegments
                            ];
                            for (const c of r){
                                const r = s.getTile(c), x = e1.a4.disabled, w = i.prevTerrainTileForTile[c.key], T = i.terrainTileForTile[c.key];
                                Nr(w, T) && jr.newMorphing(c.key, w, T, o, 250), qr(t1, r.emissiveTexture), n.activeTexture.set(a.TEXTURE0), r.texture && r.texture.bind(a.LINEAR, a.CLAMP_TO_EDGE);
                                const S = jr.getMorphValuesForProxy(c.key), C = S ? 1 : 0;
                                let E;
                                S && (E = {
                                    morphing: {
                                        srcDemTile: S.from,
                                        dstDemTile: S.to,
                                        phase: e1.c5(S.phase)
                                    }
                                });
                                const I = t1.isEmissiveMrtActive() ? 1 : 0, D = zr(c.projMatrix, Gr(c.canonical, m.renderWorldCopies) ? _ / 10 : _, g, I);
                                if (u(C), !l) continue;
                                i.setupElevationDraw(r, l, E);
                                const P = c.toUnwrapped();
                                h && h.setupShadows(P, l), t1.uploadCommonUniforms(n, l, P, null, d), l.draw(t1, y, f, x, p, e1.a5.backCCW, D, "terrain_raster", i.gridBuffer, v, b);
                            }
                        }
                    }
                }(i, this, this.proxySourceCache, t1, this._updateTimestamp), this.renderingToTexture = !0, i.gpuTimingDeferredRenderEnd(), t1.splice(0, t1.length));
            }
            renderBatch(t1) {
                if (0 === this._drapedRenderBatches.length) return t1 + 1;
                this.renderingToTexture = !0;
                const i = this.painter, s = this.painter.context, r = this.proxySourceCache, o = this.proxiedCoords[r.id], n = this._drapedRenderBatches.shift(), a = i.style.order, l = [];
                this._updateFBOs("mrt-full-rgba" === i.emissiveMode ? "rgba8" : "mrt-fallback" === i.emissiveMode ? "r8" : "none");
                let c = 0;
                for (const h of o){
                    const o = r.getTileByID(h.proxyTileKey), d = r.proxyCachedFBO[h.key] ? r.proxyCachedFBO[h.key][t1] : void 0, u = void 0 !== d ? r.renderCache[d] : this.pool[c++], p = void 0 !== d;
                    if (o.texture = u.tex, o.emissiveTexture = u.emissiveTex, p && !u.dirty) {
                        l.push(o.tileID);
                        continue;
                    }
                    s.bindFramebuffer.set(u.fb.framebuffer);
                    const f = s.gl;
                    let m;
                    i.isEmissiveMrtActive() ? f.drawBuffers([
                        f.COLOR_ATTACHMENT0,
                        f.COLOR_ATTACHMENT1
                    ]) : f.drawBuffers([
                        f.COLOR_ATTACHMENT0
                    ]), this.renderedToTile = !1, u.dirty && (s.clear({
                        color: e1.C.transparent,
                        stencil: 0
                    }), u.dirty = !1);
                    for(let e1 = n.start; e1 <= n.end; ++e1){
                        const t1 = i.style._mergedLayers[a[e1]];
                        if (t1.isHidden(i.transform.zoom)) continue;
                        const r = i.style.getLayerSourceCache(t1), o = r ? this.proxyToSource[h.key][r.id] : [
                            h
                        ];
                        if (!o) continue;
                        this._currentProxyKey = h.key;
                        const n = o;
                        s.viewport.set([
                            0,
                            0,
                            u.fb.width,
                            u.fb.height
                        ]), m !== (r ? r.id : null) && (this._setupStencil(u, o, t1, r), m = r ? r.id : null), i.renderLayer(i, r, t1, n);
                    }
                    if (f.drawBuffers([
                        f.COLOR_ATTACHMENT0
                    ]), 0 === this._drapedRenderBatches.length) for (const e1 of this._pendingGroundEffectLayers){
                        const t1 = i.style._mergedLayers[a[e1]];
                        if (t1.isHidden(i.transform.zoom)) continue;
                        const r = i.style.getLayerSourceCache(t1), o = r ? this.proxyToSource[h.key][r.id] : [
                            h
                        ];
                        if (!o) continue;
                        const n = o;
                        s.viewport.set([
                            0,
                            0,
                            u.fb.width,
                            u.fb.height
                        ]), m !== (r ? r.id : null) && (this._setupStencil(u, o, t1, r), m = r ? r.id : null), i.renderLayer(i, r, t1, n);
                    }
                    this.renderedToTile ? (u.dirty = !0, l.push(o.tileID)) : p || --c, 5 === c && (c = 0, this.renderToBackBuffer(l));
                }
                return this.renderToBackBuffer(l), this.renderingToTexture = !1, s.bindFramebuffer.set(null), s.viewport.set([
                    0,
                    0,
                    i.width,
                    i.height
                ]), n.end + 1;
            }
            postRender() {}
            isLayerOrderingCorrect(e1) {
                const t1 = e1.order.length;
                let i = -1, s = t1;
                for(let r = 0; r < t1; ++r)this._style.isLayerDraped(e1._mergedLayers[e1.order[r]]) ? i = Math.max(i, r) : s = Math.min(s, r);
                return s > i;
            }
            getMinElevationBelowMSL() {
                let e1 = 0;
                return this._visibleDemTiles.filter((e1)=>e1.dem).forEach((t1)=>{
                    e1 = Math.min(e1, t1.dem.tree.minimums[0]);
                }), 0 === e1 ? e1 : (e1 - 30) * this._exaggeration;
            }
            raycast(e1, t1, i) {
                if (!this._visibleDemTiles) return null;
                const s = this._visibleDemTiles.filter((e1)=>e1.dem).map((s)=>{
                    const r = s.tileID, o = 1 << r.overscaledZ, { x: n, y: a } = r.canonical, l = n / o, c = (n + 1) / o, h = a / o, d = (a + 1) / o;
                    return {
                        minx: l,
                        miny: h,
                        maxx: c,
                        maxy: d,
                        t: s.dem.tree.raycastRoot(l, h, c, d, e1, t1, i),
                        tile: s
                    };
                });
                s.sort((e1, t1)=>(null !== e1.t ? e1.t : Number.MAX_VALUE) - (null !== t1.t ? t1.t : Number.MAX_VALUE));
                for (const r of s){
                    if (null == r.t) return null;
                    const s = r.tile.dem.tree.raycast(r.minx, r.miny, r.maxx, r.maxy, e1, t1, i);
                    if (null != s) return s;
                }
                return null;
            }
            _createFBO() {
                const t1 = this.painter.context, i = t1.gl, s = this.drapeBufferSize;
                t1.activeTexture.set(i.TEXTURE0);
                const r = new e1.T(t1, {
                    width: s[0],
                    height: s[1],
                    data: null
                }, i.RGBA8);
                r.bind(i.LINEAR, i.CLAMP_TO_EDGE);
                const o = t1.createFramebuffer(s[0], s[1], 1, null);
                let n;
                return o.colorAttachment0.set(r.texture), "none" !== this._emissiveTexture && (n = new e1.T(t1, {
                    width: s[0],
                    height: s[1],
                    data: null
                }, Xr(i, this._emissiveTexture)), n.bind(i.LINEAR, i.CLAMP_TO_EDGE), o.createColorAttachment(t1, 1), o.colorAttachment1.set(n.texture)), o.depthAttachment = new Br(t1, o.framebuffer), void 0 === this._sharedDepthStencil ? (this._sharedDepthStencil = t1.createRenderbuffer(t1.gl.DEPTH_STENCIL, s[0], s[1]), this._stencilRef = 0, o.depthAttachment.set(this._sharedDepthStencil), t1.clear({
                    stencil: 0
                })) : o.depthAttachment.set(this._sharedDepthStencil), t1.extTextureFilterAnisotropic && i.texParameterf(i.TEXTURE_2D, t1.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, t1.extTextureFilterAnisotropicMax), {
                    fb: o,
                    tex: r,
                    emissiveTex: n,
                    dirty: !1
                };
            }
            _updateFBOs(e1) {
                if (this._emissiveTexture !== e1) {
                    for (const t1 of this.pool)this._updateFBO(t1, e1);
                    for (const t1 of this.proxySourceCache.renderCache)this._updateFBO(t1, e1);
                    this._emissiveTexture = e1;
                }
            }
            _updateFBO(t1, i) {
                const s = t1.fb, r = this.painter.context, o = r.gl, n = this.drapeBufferSize;
                if ("none" !== i) {
                    const a = new e1.T(r, {
                        width: n[0],
                        height: n[1],
                        data: null
                    }, Xr(o, i));
                    a.bind(o.LINEAR, o.CLAMP_TO_EDGE), t1.emissiveTex = a, s.createColorAttachment(r, 1), s.colorAttachment1.set(a.texture);
                } else t1.emissiveTex = void 0, s.removeColorAttachment(r, 1);
                t1.dirty = !0;
            }
            _initFBOPool() {
                for(; this.pool.length < Math.min(5, this.proxyCoords.length);)this.pool.push(this._createFBO());
            }
            _shouldDisableRenderCache() {
                if (this._style.hasLightTransitions()) return !0;
                for(const e1 in this._style._mergedSourceCaches)if (this._style._mergedSourceCaches[e1].hasTransition()) return !0;
                return this._style.order.some((e1)=>{
                    const t1 = this._style._mergedLayers[e1], i = t1.isHidden(this.painter.transform.zoom);
                    return "hillshade" === t1.type || "custom" === t1.type ? !i && t1.shouldRedrape() : !i && t1.hasTransition();
                });
            }
            _clearLineLayersFromRenderCache() {
                let t1 = !1;
                for (const e1 of this._style.getSources())if ("vector" === e1.type) {
                    t1 = !0;
                    break;
                }
                if (!t1) return;
                const i = {};
                for(let t1 = 0; t1 < this._style.order.length; ++t1){
                    const s = this._style._mergedLayers[this._style.order[t1]], r = this._style.getLayerSourceCache(s);
                    if (!r || i[r.id]) continue;
                    if (s.isHidden(this.painter.transform.zoom) || "line" !== s.type) continue;
                    const o = s.getPaintPropertyValue("line-width").expression, n = s.getPaintPropertyValue("line-emissive-strength").expression;
                    if (o instanceof e1.av || n instanceof e1.av) {
                        i[r.id] = !0;
                        for (const e1 of this.proxyCoords){
                            const t1 = this.proxyToSource[e1.key][r.id];
                            if (t1) for (const e1 of t1)this._clearRenderCacheForTile(r.id, e1);
                        }
                    }
                }
            }
            _clearRasterLayersFromRenderCache() {
                let e1 = !1;
                for(const t1 in this._style._mergedSourceCaches){
                    const i = this._style._mergedSourceCaches[t1]._source.type;
                    if ("raster" === i || "raster-dem" === i || "raster-array" === i) {
                        e1 = !0;
                        break;
                    }
                }
                if (!e1) return;
                const t1 = {};
                for(let e1 = 0; e1 < this._style.order.length; ++e1){
                    const i = this._style._mergedLayers[this._style.order[e1]], s = this._style.getLayerSourceCache(i);
                    if (!s || t1[s.id]) continue;
                    if (i.isHidden(this.painter.transform.zoom) || "raster" !== i.type) continue;
                    const r = i.paint.get("raster-fade-duration");
                    for (const e1 of this.proxyCoords){
                        const t1 = this.proxyToSource[e1.key][s.id];
                        if (t1) for (const e1 of t1){
                            const t1 = Fi(s.getTile(e1), s.findLoadedParent(e1, 0), s, this.painter.transform, r);
                            (1 !== t1.opacity || 0 !== t1.mix) && this._clearRenderCacheForTile(s.id, e1);
                        }
                    }
                }
            }
            _setupDrapedRenderBatches() {
                this._style.updateDrapeFirstLayers();
                const t1 = this._style.order, i = t1.length;
                if (0 === i) return;
                const s = [];
                this._pendingGroundEffectLayers = [];
                let r, o = 0, n = this._style._mergedLayers[t1[o]];
                for(; !this._style.isLayerDraped(n) && n.isHidden(this.painter.transform.zoom) && ++o < i;)n = this._style._mergedLayers[t1[o]];
                for(; o < i; ++o){
                    const e1 = this._style._mergedLayers[t1[o]];
                    e1.isHidden(this.painter.transform.zoom) || (this._style.isLayerDraped(e1) ? void 0 === r && (r = o) : ("fill-extrusion" === e1.type && this._pendingGroundEffectLayers.push(o), void 0 !== r && (s.push({
                        start: r,
                        end: o - 1
                    }), r = void 0)));
                }
                if (void 0 !== r && s.push({
                    start: r,
                    end: o - 1
                }), 0 !== s.length) {
                    const t1 = s.at(-1);
                    this._pendingGroundEffectLayers.every((e1)=>e1 > t1.end) || e1.w("fill-extrusion with flood lighting and/or ground ambient occlusion should be moved to be on top of all draped layers.");
                }
                this._drapedRenderBatches = s;
            }
            _setupRenderCache(e1) {
                const t1 = this.proxySourceCache;
                if (this._shouldDisableRenderCache() || this.invalidateRenderCache) {
                    if (this.invalidateRenderCache = !1, t1.renderCache.length > t1.renderCachePool.length) {
                        const e1 = Object.values(t1.proxyCachedFBO);
                        t1.proxyCachedFBO = {};
                        for(let i = 0; i < e1.length; ++i){
                            const s = Object.values(e1[i]);
                            t1.renderCachePool.push(...s);
                        }
                    }
                    return;
                }
                this._clearRasterLayersFromRenderCache();
                const i = this.proxyCoords, s = this._tilesDirty;
                for(let r = i.length - 1; r >= 0; r--){
                    const o = i[r];
                    if (t1.getTileByID(o.key), void 0 !== t1.proxyCachedFBO[o.key]) {
                        const i = e1[o.key], r = this.proxyToSource[o.key];
                        let n = 0;
                        for(const e1 in r){
                            const t1 = r[e1], o = i[e1];
                            if (!o || o.length !== t1.length || t1.some((t1, i)=>t1 !== o[i] || s[e1] && Object.hasOwn(s[e1], t1.key))) {
                                n = -1;
                                break;
                            }
                            ++n;
                        }
                        for(const e1 in t1.proxyCachedFBO[o.key])t1.renderCache[t1.proxyCachedFBO[o.key][e1]].dirty = n < 0 || n !== Object.values(i).length;
                    }
                }
                const r = [
                    ...this._drapedRenderBatches
                ];
                r.sort((e1, t1)=>t1.end - t1.start - (e1.end - e1.start));
                for (const e1 of r)for (const s of i){
                    if (t1.proxyCachedFBO[s.key]) continue;
                    let i = t1.renderCachePool.pop();
                    void 0 === i && t1.renderCache.length < 50 && (i = t1.renderCache.length, t1.renderCache.push(this._createFBO())), void 0 !== i && (t1.proxyCachedFBO[s.key] = {}, t1.proxyCachedFBO[s.key][e1.start] = i, t1.renderCache[i].dirty = !0);
                }
                this._tilesDirty = {};
            }
            _setupStencil(t1, i, s, r) {
                if (!r || !this._sourceTilesOverlap[r.id]) return void (this._overlapStencilType && (this._overlapStencilType = !1));
                const o = this.painter.context, n = o.gl;
                if (i.length <= 1) return void (this._overlapStencilType = !1);
                let a;
                if (s.isTileClipped()) a = i.length, this._overlapStencilMode.test = {
                    func: n.EQUAL,
                    mask: 255
                }, this._overlapStencilType = "Clip";
                else {
                    if (!(i[0].overscaledZ > i.at(-1).overscaledZ)) return void (this._overlapStencilType = !1);
                    a = 1, this._overlapStencilMode.test = {
                        func: n.GREATER,
                        mask: 255
                    }, this._overlapStencilType = "Mask";
                }
                const l = "raster" === s.type && s.paint.get("raster-mask") ? e1.cc - 1 : 255;
                this._stencilRef + a > l && (o.clear({
                    stencil: 0
                }), this._stencilRef = 0), this._stencilRef += a, this._overlapStencilMode.ref = this._stencilRef, s.isTileClipped() && this._renderTileClippingMasks(i, this._overlapStencilMode.ref);
            }
            clipOrMaskOverlapStencilType() {
                return "Clip" === this._overlapStencilType || "Mask" === this._overlapStencilType;
            }
            getCurrentProxiedCoords(e1) {
                if (null == this._currentProxyKey) return null;
                const t1 = this.proxyToSource[this._currentProxyKey];
                return t1 ? t1[e1] : null;
            }
            stencilModeForRTTOverlap(t1) {
                return this.renderingToTexture && this._overlapStencilType ? ("Clip" === this._overlapStencilType && (this._overlapStencilMode.ref = this.painter._tileClippingMaskIDs.get(t1.key)), this._overlapStencilMode) : e1.a4.disabled;
            }
            _renderTileClippingMasks(t1, i) {
                const s = this.painter, r = this.painter.context, o = r.gl;
                s._tileClippingMaskIDs = new Map, r.setColorMode(e1.a7.disabled), r.setDepthMode(e1.a3.disabled);
                const n = s.getOrCreateProgram("clippingMask");
                for (const r of t1){
                    const t1 = --i;
                    s._tileClippingMaskIDs.set(r.key, t1), n.draw(s, o.TRIANGLES, e1.a3.disabled, new e1.a4({
                        func: o.ALWAYS,
                        mask: 0
                    }, t1, 255, o.KEEP, o.KEEP, o.REPLACE), e1.a7.disabled, e1.a5.disabled, Us(r.projMatrix), "$clipping", s.tileExtentBuffer, s.quadTriangleIndexBuffer, s.tileExtentSegments);
                }
            }
            pointCoordinate(t1) {
                const i = this.painter.transform;
                if (t1.x < 0 || t1.x > i.width || t1.y < 0 || t1.y > i.height) return null;
                const s = [
                    t1.x,
                    t1.y,
                    1,
                    1
                ];
                e1.cd(s, s, i.pixelMatrixInverse), e1.ce(s, s, 1 / s[3]), s[0] /= i.worldSize, s[1] /= i.worldSize;
                const r = i._camera.position, o = e1.ca(1, i.center.lat), n = [
                    r[0],
                    r[1],
                    r[2] / o,
                    0
                ], a = e1.cf([], s.slice(0, 3), n);
                e1.cg(a, a);
                const l = this.raycast(n, a, this._exaggeration);
                return null !== l && l ? (e1.ch(n, n, a, l), n[3] = n[2], n[2] *= o, n) : null;
            }
            _setupProxiedCoordsForOrtho(e1, t1, i) {
                if ([
                    "image",
                    "video",
                    "canvas"
                ].includes(e1.getSource().type)) return this._setupProxiedCoordsForImageSource(e1, t1, i);
                this._findCoveringTileCache[e1.id] = this._findCoveringTileCache[e1.id] || {};
                const s = this.proxiedCoords[e1.id] = [], r = this.proxyCoords;
                for(let t1 = 0; t1 < r.length; t1++){
                    const o = r[t1], n = this._findTileCoveringTileID(o, e1);
                    if (n) {
                        const t1 = this._createProxiedId(o, n, i[o.key] && i[o.key][e1.id]);
                        s.push(t1), this.proxyToSource[o.key][e1.id] = [
                            t1
                        ];
                    }
                }
                let o = !1;
                const n = new Set;
                for(let r = 0; r < t1.length; r++){
                    const a = e1.getTile(t1[r]);
                    if (!a || !a.hasData()) continue;
                    const l = this._findTileCoveringTileID(a.tileID, this.proxySourceCache);
                    if (l && l.tileID.canonical.z !== a.tileID.canonical.z) {
                        const t1 = this.proxyToSource[l.tileID.key][e1.id], r = this._createProxiedId(l.tileID, a, i[l.tileID.key] && i[l.tileID.key][e1.id]);
                        t1 ? t1.splice(t1.length - 1, 0, r) : this.proxyToSource[l.tileID.key][e1.id] = [
                            r
                        ];
                        const c = this.proxyToSource[l.tileID.key][e1.id];
                        n.has(c) || n.add(c), s.push(r), o = !0;
                    }
                }
                if (this._sourceTilesOverlap[e1.id] = o, o) for (const e1 of n)e1.sort((e1, t1)=>t1.overscaledZ - e1.overscaledZ);
            }
            _setupProxiedCoordsForImageSource(t1, i, s) {
                if (!t1.getSource().loaded()) return;
                const r = this.proxiedCoords[t1.id] = [], o = this.proxyCoords, n = t1.getSource(), a = n.tileID;
                if (!a) return;
                const l = new e1.P(a.x, a.y)._div(1 << a.z), c = n.coordinates.map(e1.b$.fromLngLat).reduce((e1, t1)=>(e1.min.x = Math.min(e1.min.x, t1.x - l.x), e1.min.y = Math.min(e1.min.y, t1.y - l.y), e1.max.x = Math.max(e1.max.x, t1.x - l.x), e1.max.y = Math.max(e1.max.y, t1.y - l.y), e1), {
                    min: new e1.P(Number.MAX_VALUE, Number.MAX_VALUE),
                    max: new e1.P(-Number.MAX_VALUE, -Number.MAX_VALUE)
                }), h = (t1, i)=>{
                    const s = t1.wrap + t1.canonical.x / (1 << t1.canonical.z), r = t1.canonical.y / (1 << t1.canonical.z), o = e1.ac / (1 << t1.canonical.z), n = i.wrap + i.canonical.x / (1 << i.canonical.z), a = i.canonical.y / (1 << i.canonical.z);
                    return s + o < n + c.min.x || s > n + c.max.x || r + o < a + c.min.y || r > a + c.max.y;
                };
                for(let e1 = 0; e1 < o.length; e1++){
                    const n = o[e1];
                    for(let e1 = 0; e1 < i.length; e1++){
                        const o = t1.getTile(i[e1]);
                        if (!o || !o.hasData()) continue;
                        if (h(n, o.tileID)) continue;
                        const a = this._createProxiedId(n, o, s[n.key] && s[n.key][t1.id]), l = this.proxyToSource[n.key][t1.id];
                        l ? l.push(a) : this.proxyToSource[n.key][t1.id] = [
                            a
                        ], r.push(a);
                    }
                }
            }
            _createProxiedId(t1, i, s) {
                let r = this.orthoMatrix;
                if (s) {
                    const e1 = s.find((e1)=>e1.key === i.tileID.key);
                    if (e1) return e1;
                }
                if (i.tileID.key !== t1.key) {
                    const s = t1.canonical.z - i.tileID.canonical.z;
                    let o, n, a;
                    r = e1.a2();
                    const l = i.tileID.wrap - t1.wrap << t1.overscaledZ;
                    s > 0 ? (o = e1.ac >> s, n = o * ((i.tileID.canonical.x << s) - t1.canonical.x + l), a = o * ((i.tileID.canonical.y << s) - t1.canonical.y)) : (o = e1.ac << -s, n = e1.ac * (i.tileID.canonical.x - (t1.canonical.x + l << -s)), a = e1.ac * (i.tileID.canonical.y - (t1.canonical.y << -s))), e1.c3(r, 0, o, 0, o, 0, 1), e1.bX(r, r, [
                        n,
                        a,
                        0
                    ]);
                }
                return new Hr(i.tileID, t1.key, r);
            }
            _findTileCoveringTileID(t1, i) {
                let s = i.getTile(t1);
                if (s && s.hasData()) return s;
                const r = this._findCoveringTileCache[i.id], o = r[t1.key];
                if (s = o ? i.getTileByID(o) : null, s && s.hasData() || null === o) return s;
                let n = s ? s.tileID : t1, a = n.overscaledZ;
                const l = i.getSource().minzoom, c = [];
                if (!o) {
                    const r = i.getSource().maxzoom;
                    if (t1.canonical.z >= r) {
                        const s = t1.canonical.z - r;
                        i.getSource().reparseOverscaled ? (a = Math.max(t1.canonical.z + 2, i.transform.tileZoom), n = new e1.bZ(a, t1.wrap, r, t1.canonical.x >> s, t1.canonical.y >> s)) : 0 !== s && (a = r, n = new e1.bZ(a, t1.wrap, r, t1.canonical.x >> s, t1.canonical.y >> s));
                    }
                    n.key !== t1.key && (c.push(n.key), s = i.getTile(n));
                }
                const h = (e1)=>{
                    c.forEach((t1)=>{
                        r[t1] = e1;
                    }), c.length = 0;
                };
                for(a -= 1; a >= l && (!s || !s.hasData()); a--){
                    s && h(s.tileID.key);
                    const e1 = n.calculateScaledKey(a);
                    if (s = i.getTileByID(e1), s && s.hasData()) break;
                    const t1 = r[e1];
                    if (null === t1) break;
                    void 0 === t1 ? c.push(e1) : s = i.getTileByID(t1);
                }
                return h(s ? s.tileID.key : null), s && s.hasData() ? s : null;
            }
            findDEMTileFor(e1) {
                return this.enabled ? this._findTileCoveringTileID(e1, this.sourceCache) : null;
            }
            prepareDrawTile() {
                this.renderedToTile = !0;
            }
            _clearRenderCacheForTile(e1, t1) {
                let i = this._tilesDirty[e1];
                i || (i = this._tilesDirty[e1] = {}), i[t1.key] = !0;
            }
        }
        let Kr = null;
        const Qr = [];
        function Jr(e1, t1) {
            return Kr ? Kr.create(e1, t1) : null;
        }
        const eo = (e1, t1, i)=>({
                u_matrix: e1,
                u_emissive_strength: t1,
                u_ground_shadow_factor: i,
                u_opacity_multiplier: 1
            }), to = (t1, i, s, r, o, n = 0)=>Object.assign(eo(t1, i, o), e1.ci(s, r, n)), io = (e1, t1, i, s)=>({
                u_matrix: e1,
                u_world: i,
                u_emissive_strength: t1,
                u_ground_shadow_factor: s,
                u_opacity_multiplier: 1
            }), so = (e1, t1, i, s, r, o, n = 0)=>Object.assign(to(e1, t1, i, s, o, n), {
                u_world: r
            }), ro = (e1, t1, i)=>({
                u_image: e1,
                u_texel_size: t1,
                u_first_pass: i ? 1 : 0
            }), oo = e1.a2(), no = (t1, i, s, r, o, n, a)=>{
            const l = t1.transform, c = "globe" === l.projection.name, h = c ? e1.cj(l.zoom, i.canonical) * l._pixelsPerMercatorPixel : e1.ck(s, 1, n), d = {
                u_matrix: i.projMatrix,
                u_extrude_scale: h,
                u_intensity: a,
                u_inv_rot_matrix: oo,
                u_merc_center: [
                    0,
                    0
                ],
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_up_dir: [
                    0,
                    0,
                    0
                ]
            };
            if (c) {
                d.u_inv_rot_matrix = r, d.u_merc_center = o, d.u_tile_id = [
                    i.canonical.x,
                    i.canonical.y,
                    1 << i.canonical.z
                ], d.u_zoom_transition = e1._(l.zoom);
                const t1 = o[0] * e1.ac, s = o[1] * e1.ac;
                d.u_up_dir = l.projection.upVector(new e1.c1(0, 0, 0), t1, s);
            }
            return d;
        };
        function ao(t1) {
            const i = t1.terrain ? t1.terrain.exaggeration() : 1;
            return (t1.transform.pitch < 15 ? e1.aw(.07, .7, e1.bb((14 - t1.transform.zoom) / 5, 0, 1)) : .07) * i;
        }
        const lo = (t1, i, s, r, o, n, a, l, c, h, d, u, p, f, m, _, g, y, v, b, x, w)=>({
                u_matrix: i,
                u_normalize_matrix: s,
                u_globe_matrix: r,
                u_merc_matrix: o,
                u_grid_matrix: n,
                u_tl_parent: a,
                u_scale_parent: d,
                u_fade_t: u.mix,
                u_opacity: u.opacity * p.paint.get("raster-opacity"),
                u_image0: 0,
                u_image1: 1,
                u_brightness_low: p.paint.get("raster-brightness-min"),
                u_brightness_high: p.paint.get("raster-brightness-max"),
                u_saturation_factor: e1.cn(p.paint.get("raster-saturation")),
                u_contrast_factor: e1.cm(p.paint.get("raster-contrast")),
                u_spin_weights: co(p.paint.get("raster-hue-rotate")),
                u_perspective_transform: f,
                u_raster_elevation: m,
                u_zoom_transition: l,
                u_merc_center: c,
                u_cutoff_params: h,
                u_colorization_mix: Li(e1.cl, g, v),
                u_colorization_offset: Ri(e1.cl, y, v),
                u_color_ramp: _,
                u_color_ramp_size: e1.cl,
                u_texture_offset: [
                    x / (b + 2 * x),
                    b / (b + 2 * x)
                ],
                u_texture_res: [
                    b + 2 * x,
                    b + 2 * x
                ],
                u_emissive_strength: w,
                u_zbias_factor: ao(t1)
            });
        function co(e1) {
            e1 *= Math.PI / 180;
            const t1 = Math.sin(e1), i = Math.cos(e1);
            return [
                (2 * i + 1) / 3,
                (-Math.sqrt(3) * t1 - i + 1) / 3,
                (Math.sqrt(3) * t1 - i + 1) / 3
            ];
        }
        const ho = e1.a2(), uo = (t1, i, s, r, o, n, a, l, c, h, d, u, p, f, m, _, g, y, v, b, x, w, T, S, C)=>{
            const E = o.transform, I = {
                u_is_size_zoom_constant: +("constant" === t1 || "source" === t1),
                u_is_size_feature_constant: +("constant" === t1 || "camera" === t1),
                u_size_t: i ? i.uSizeT : 0,
                u_size: i ? i.uSize : 0,
                u_camera_to_center_distance: E.getCameraToCenterDistance(b),
                u_rotate_symbol: +s,
                u_aspect_ratio: E.width / E.height,
                u_fade_change: o.options.fadeDuration ? o.symbolFadeChange : 1,
                u_now: 0 | Math.round(o.now),
                u_fade_duration: o.options.fadeDuration,
                u_matrix: n,
                u_label_plane_matrix: a,
                u_coord_matrix: l,
                u_is_text: +h,
                u_is_sdf: +d,
                u_elevation_from_sea: c ? 1 : 0,
                u_pitch_with_map: +r,
                u_texsize: u,
                u_texsize_icon: p,
                u_texture: 0,
                u_texture_icon: 1,
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_inv_rot_matrix: ho,
                u_merc_center: [
                    0,
                    0
                ],
                u_camera_forward: [
                    0,
                    0,
                    0
                ],
                u_ecef_origin: [
                    0,
                    0,
                    0
                ],
                u_tile_matrix: ho,
                u_up_vector: [
                    0,
                    -1,
                    0
                ],
                u_color_adj_mat: T,
                u_icon_transition: S || 0,
                u_gamma_scale: d ? r ? o.transform.getCameraToCenterDistance(b) * Math.cos(o.terrain ? 0 : o.transform._pitch) : 1 : 0,
                u_device_pixel_ratio: e1.e.devicePixelRatio,
                u_is_halo: 1,
                u_scale_factor: C || 1,
                u_ground_shadow_factor: x,
                u_inv_matrix: e1.aZ(e1.a2(), a),
                u_normal_scale: w,
                u_lutTexture: e1.cp.LUT,
                u_spp_fill_np_color: [
                    0,
                    0,
                    0,
                    1
                ],
                u_spp_halo_np_color: [
                    0,
                    0,
                    0,
                    0
                ],
                u_spp_opacity: 1,
                u_spp_halo_width: 0,
                u_spp_halo_blur: 0,
                u_spp_emissive_strength: 0,
                u_spp_occlusion_opacity: 1,
                u_spp_z_offset: 0,
                u_spp_translate_rotation: [
                    1,
                    0
                ],
                u_spp_zoom_fraction: 0,
                u_opacity_multiplier: 1
            };
            return "globe" === b.name && (I.u_tile_id = [
                m.canonical.x,
                m.canonical.y,
                1 << m.canonical.z
            ], I.u_zoom_transition = _, I.u_inv_rot_matrix = y, I.u_merc_center = g, I.u_camera_forward = E._camera.forward(), I.u_ecef_origin = e1.co(E.globeMatrix, m.toUnwrapped()), I.u_tile_matrix = E.globeMatrix, I.u_up_vector = v), I;
        }, po = (e1, t1, i, s)=>({
                u_matrix: e1,
                u_emissive_strength: t1,
                u_opacity: i,
                u_color: s
            }), fo = (t1, i, s, r, o, n, a, l, c)=>Object.assign(e1.cq(o, n, a, r, l, c), {
                u_matrix: t1,
                u_emissive_strength: i,
                u_opacity: s
            }), mo = {
            fillExtrusion: e1.cw,
            fillExtrusionPattern: e1.cv,
            fill: (t1)=>({
                    u_matrix: new e1.aa(t1),
                    u_emissive_strength: new e1.a9(t1),
                    u_ground_shadow_factor: new e1.ab(t1),
                    u_opacity_multiplier: new e1.a9(t1)
                }),
            fillPattern: (t1)=>({
                    u_matrix: new e1.aa(t1),
                    u_emissive_strength: new e1.a9(t1),
                    u_image: new e1.b6(t1),
                    u_texsize: new e1.a8(t1),
                    u_pixel_coord_upper: new e1.a8(t1),
                    u_pixel_coord_lower: new e1.a8(t1),
                    u_tile_units_to_pixels: new e1.a9(t1),
                    u_ground_shadow_factor: new e1.ab(t1),
                    u_pattern_transition: new e1.a9(t1),
                    u_opacity_multiplier: new e1.a9(t1)
                }),
            fillOutline: (t1)=>({
                    u_matrix: new e1.aa(t1),
                    u_emissive_strength: new e1.a9(t1),
                    u_world: new e1.a8(t1),
                    u_ground_shadow_factor: new e1.ab(t1),
                    u_opacity_multiplier: new e1.a9(t1)
                }),
            fillOutlinePattern: (t1)=>({
                    u_matrix: new e1.aa(t1),
                    u_emissive_strength: new e1.a9(t1),
                    u_world: new e1.a8(t1),
                    u_image: new e1.b6(t1),
                    u_texsize: new e1.a8(t1),
                    u_pixel_coord_upper: new e1.a8(t1),
                    u_pixel_coord_lower: new e1.a8(t1),
                    u_tile_units_to_pixels: new e1.a9(t1),
                    u_ground_shadow_factor: new e1.ab(t1),
                    u_pattern_transition: new e1.a9(t1),
                    u_opacity_multiplier: new e1.a9(t1)
                }),
            lineBlendComposite: (t1)=>({
                    u_image: new e1.b6(t1),
                    u_opacity: new e1.a9(t1),
                    u_blend_mode: new e1.b6(t1),
                    u_max_density: new e1.a9(t1)
                }),
            lineBlendReduce: (t1)=>({
                    u_image: new e1.b6(t1),
                    u_texel_size: new e1.a8(t1),
                    u_first_pass: new e1.b6(t1)
                }),
            circle: e1.cu,
            collisionBox: (t1)=>({
                    u_matrix: new e1.aa(t1),
                    u_inv_rot_matrix: new e1.aa(t1),
                    u_camera_to_center_distance: new e1.a9(t1),
                    u_extrude_scale: new e1.a8(t1),
                    u_zoom_transition: new e1.a9(t1),
                    u_merc_center: new e1.a8(t1),
                    u_tile_id: new e1.ab(t1)
                }),
            collisionCircle: (t1)=>({
                    u_matrix: new e1.aa(t1),
                    u_inv_matrix: new e1.aa(t1),
                    u_camera_to_center_distance: new e1.a9(t1),
                    u_viewport_size: new e1.a8(t1)
                }),
            placementDebug: (t1)=>({
                    u_viewport_size: new e1.a8(t1),
                    u_color: new e1.al(t1),
                    u_outline_width: new e1.a9(t1),
                    u_opacity: new e1.a9(t1),
                    u_stroke_opacity: new e1.a9(t1),
                    u_collision_padding_opacity: new e1.a9(t1)
                }),
            debug: e1.ct,
            clippingMask: (t1)=>({
                    u_matrix: new e1.aa(t1)
                }),
            heatmap: (t1)=>({
                    u_extrude_scale: new e1.a9(t1),
                    u_intensity: new e1.a9(t1),
                    u_matrix: new e1.aa(t1),
                    u_inv_rot_matrix: new e1.aa(t1),
                    u_merc_center: new e1.a8(t1),
                    u_tile_id: new e1.ab(t1),
                    u_zoom_transition: new e1.a9(t1),
                    u_up_dir: new e1.ab(t1)
                }),
            heatmapTexture: (t1)=>({
                    u_image: new e1.b6(t1),
                    u_color_ramp: new e1.b6(t1),
                    u_opacity: new e1.a9(t1)
                }),
            hillshade: (t1)=>({
                    u_matrix: new e1.aa(t1),
                    u_image: new e1.b6(t1),
                    u_latrange: new e1.a8(t1),
                    u_light: new e1.a8(t1),
                    u_shadow: new e1.al(t1),
                    u_highlight: new e1.al(t1),
                    u_emissive_strength: new e1.a9(t1),
                    u_accent: new e1.al(t1)
                }),
            hillshadePrepare: (t1)=>({
                    u_matrix: new e1.aa(t1),
                    u_image: new e1.b6(t1),
                    u_dimension: new e1.a8(t1),
                    u_zoom: new e1.a9(t1)
                }),
            line: e1.cs,
            linePattern: e1.cr,
            raster: (t1)=>({
                    u_matrix: new e1.aa(t1),
                    u_normalize_matrix: new e1.aa(t1),
                    u_globe_matrix: new e1.aa(t1),
                    u_merc_matrix: new e1.aa(t1),
                    u_grid_matrix: new e1.b8(t1),
                    u_tl_parent: new e1.a8(t1),
                    u_scale_parent: new e1.a9(t1),
                    u_fade_t: new e1.a9(t1),
                    u_opacity: new e1.a9(t1),
                    u_image0: new e1.b6(t1),
                    u_image1: new e1.b6(t1),
                    u_brightness_low: new e1.a9(t1),
                    u_brightness_high: new e1.a9(t1),
                    u_saturation_factor: new e1.a9(t1),
                    u_contrast_factor: new e1.a9(t1),
                    u_spin_weights: new e1.ab(t1),
                    u_perspective_transform: new e1.a8(t1),
                    u_raster_elevation: new e1.a9(t1),
                    u_zoom_transition: new e1.a9(t1),
                    u_merc_center: new e1.a8(t1),
                    u_cutoff_params: new e1.b7(t1),
                    u_colorization_mix: new e1.b7(t1),
                    u_colorization_offset: new e1.a9(t1),
                    u_color_ramp: new e1.b6(t1),
                    u_color_ramp_size: new e1.a9(t1),
                    u_texture_offset: new e1.a8(t1),
                    u_texture_res: new e1.a8(t1),
                    u_emissive_strength: new e1.a9(t1),
                    u_zbias_factor: new e1.a9(t1)
                }),
            symbol: (t1)=>({
                    u_is_size_zoom_constant: new e1.b6(t1),
                    u_is_size_feature_constant: new e1.b6(t1),
                    u_size_t: new e1.a9(t1),
                    u_size: new e1.a9(t1),
                    u_camera_to_center_distance: new e1.a9(t1),
                    u_rotate_symbol: new e1.b6(t1),
                    u_aspect_ratio: new e1.a9(t1),
                    u_fade_change: new e1.a9(t1),
                    u_now: new e1.b6(t1),
                    u_fade_duration: new e1.a9(t1),
                    u_matrix: new e1.aa(t1),
                    u_label_plane_matrix: new e1.aa(t1),
                    u_coord_matrix: new e1.aa(t1),
                    u_is_text: new e1.b6(t1),
                    u_is_sdf: new e1.b6(t1),
                    u_elevation_from_sea: new e1.b6(t1),
                    u_pitch_with_map: new e1.b6(t1),
                    u_texsize: new e1.a8(t1),
                    u_texsize_icon: new e1.a8(t1),
                    u_texture: new e1.b6(t1),
                    u_texture_icon: new e1.b6(t1),
                    u_gamma_scale: new e1.a9(t1),
                    u_device_pixel_ratio: new e1.a9(t1),
                    u_tile_id: new e1.ab(t1),
                    u_zoom_transition: new e1.a9(t1),
                    u_inv_rot_matrix: new e1.aa(t1),
                    u_merc_center: new e1.a8(t1),
                    u_camera_forward: new e1.ab(t1),
                    u_tile_matrix: new e1.aa(t1),
                    u_up_vector: new e1.ab(t1),
                    u_ecef_origin: new e1.ab(t1),
                    u_is_halo: new e1.b6(t1),
                    u_icon_transition: new e1.a9(t1),
                    u_color_adj_mat: new e1.aa(t1),
                    u_scale_factor: new e1.a9(t1),
                    u_ground_shadow_factor: new e1.ab(t1),
                    u_inv_matrix: new e1.aa(t1),
                    u_normal_scale: new e1.a9(t1),
                    u_lutTexture: new e1.b6(t1),
                    u_spp_fill_np_color: new e1.b7(t1),
                    u_spp_halo_np_color: new e1.b7(t1),
                    u_spp_opacity: new e1.a9(t1),
                    u_spp_halo_width: new e1.a9(t1),
                    u_spp_halo_blur: new e1.a9(t1),
                    u_spp_emissive_strength: new e1.a9(t1),
                    u_spp_occlusion_opacity: new e1.a9(t1),
                    u_spp_z_offset: new e1.a9(t1),
                    u_spp_translate_rotation: new e1.a8(t1),
                    u_spp_zoom_fraction: new e1.a9(t1),
                    u_opacity_multiplier: new e1.a9(t1)
                }),
            background: (t1)=>({
                    u_matrix: new e1.aa(t1),
                    u_emissive_strength: new e1.a9(t1),
                    u_opacity: new e1.a9(t1),
                    u_color: new e1.al(t1)
                }),
            backgroundPattern: (t1)=>({
                    u_matrix: new e1.aa(t1),
                    u_emissive_strength: new e1.a9(t1),
                    u_opacity: new e1.a9(t1),
                    u_image: new e1.b6(t1),
                    u_pattern_tl: new e1.a8(t1),
                    u_pattern_br: new e1.a8(t1),
                    u_texsize: new e1.a8(t1),
                    u_pattern_size: new e1.a8(t1),
                    u_pixel_coord_upper: new e1.a8(t1),
                    u_pixel_coord_lower: new e1.a8(t1),
                    u_pattern_units_to_pixels: new e1.a8(t1)
                }),
            skybox: (t1)=>({
                    u_matrix: new e1.aa(t1),
                    u_sun_direction: new e1.ab(t1),
                    u_cubemap: new e1.b6(t1),
                    u_opacity: new e1.a9(t1),
                    u_temporal_offset: new e1.a9(t1)
                }),
            skyboxGradient: (t1)=>({
                    u_matrix: new e1.aa(t1),
                    u_color_ramp: new e1.b6(t1),
                    u_center_direction: new e1.ab(t1),
                    u_radius: new e1.a9(t1),
                    u_opacity: new e1.a9(t1),
                    u_temporal_offset: new e1.a9(t1)
                }),
            skyboxCapture: (t1)=>({
                    u_matrix_3f: new e1.b8(t1),
                    u_sun_direction: new e1.ab(t1),
                    u_sun_intensity: new e1.a9(t1),
                    u_color_tint_r: new e1.b7(t1),
                    u_color_tint_m: new e1.b7(t1),
                    u_luminance: new e1.a9(t1)
                }),
            globeAtmosphere: (t1)=>({
                    u_frustum_tl: new e1.ab(t1),
                    u_frustum_tr: new e1.ab(t1),
                    u_frustum_br: new e1.ab(t1),
                    u_frustum_bl: new e1.ab(t1),
                    u_horizon: new e1.a9(t1),
                    u_transition: new e1.a9(t1),
                    u_fadeout_range: new e1.a9(t1),
                    u_atmosphere_fog_color: new e1.b7(t1),
                    u_high_color: new e1.b7(t1),
                    u_space_color: new e1.b7(t1),
                    u_temporal_offset: new e1.a9(t1),
                    u_horizon_angle: new e1.a9(t1)
                }),
            stars: (t1)=>({
                    u_matrix: new e1.aa(t1),
                    u_up: new e1.ab(t1),
                    u_right: new e1.ab(t1),
                    u_intensity_multiplier: new e1.a9(t1)
                }),
            occlusion: (t1)=>({
                    u_matrix: new e1.aa(t1),
                    u_anchorPos: new e1.ab(t1),
                    u_screenSizePx: new e1.a8(t1),
                    u_occluderSizePx: new e1.a8(t1),
                    u_color: new e1.b7(t1)
                })
        };
        var _o = {
            terrainRaster: e1.bm('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image0;\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nuniform sampler2D u_image1;uniform float u_emissive_texture_available;\n#endif\nin vec2 v_pos0;\n#ifdef FOG\nin float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nin vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;\n#endif\nuniform vec3 u_ground_shadow_factor;void main() {vec4 image_color=texture(u_image0,v_pos0);vec4 color;\n#ifdef LIGHTING_3D_MODE\nconst vec3 normal=vec3(0.0,0.0,1.0);\n#ifdef RENDER_SHADOWS\nfloat cutoffOpacity=1.0;\n#ifdef RENDER_CUTOFF\ncutoffOpacity=cutoff_opacity(u_cutoff_params,1.0/gl_FragCoord.w);\n#endif\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nvec3 unlit_base;vec3 emissive_base;\n#ifdef USE_MRT1_RGBA\nvec4 emissive_premult=vec4(0.0);if (u_emissive_texture_available > 0.5) {emissive_premult=texture(u_image1,v_pos0);}unlit_base=image_color.rgb-emissive_premult.rgb;emissive_base=emissive_premult.rgb;\n#else\nfloat emissive_strength=image_color.a;if (u_emissive_texture_available > 0.5) {emissive_strength=texture(u_image1,v_pos0).r;}unlit_base=image_color.rgb*(1.0-emissive_strength);emissive_base=image_color.rgb*emissive_strength;\n#endif\nfloat ndotl=u_shadow_direction.z;float occlusion=1.0;if (ndotl >=0.0) {occlusion=shadow_occlusion(v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w,0.0);}ndotl=max(0.0,ndotl);vec3 lit=apply_lighting(unlit_base,normal,mix(1.0,(1.0-(u_shadow_intensity*occlusion))*ndotl,cutoffOpacity));vec3 emissive=compute_emissive_draped(emissive_base,1.0-u_shadow_intensity,occlusion,u_ground_shadow_factor);color.rgb=lit+emissive;color.a=1.0;\n#else\nfloat lighting_factor=shadowed_light_factor_normal_unbiased(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);color=apply_lighting(image_color,normal,mix(1.0,lighting_factor,cutoffOpacity));\n#endif\n#else\nfloat lighting_factor=u_lighting_directional_dir.z;\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\n#ifdef USE_MRT1_RGBA\nvec4 emissive_premult=vec4(0.0);if (u_emissive_texture_available > 0.5) {emissive_premult=texture(u_image1,v_pos0);}vec3 unlit_base=image_color.rgb-emissive_premult.rgb;color.rgb=apply_lighting(unlit_base,normal,lighting_factor)+emissive_premult.rgb;color.a=1.0;\n#else\ncolor=apply_lighting(image_color,normal,lighting_factor);float emissive_strength=image_color.a;if (u_emissive_texture_available > 0.5) {emissive_strength=texture(u_image1,v_pos0).r;}color.rgb=mix(color.rgb,image_color.rgb,emissive_strength);color.a=1.0;\n#endif\n#else\ncolor=apply_lighting(image_color,normal,lighting_factor);\n#endif\n#endif\n#else\ncolor=image_color;\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_from_vert(color,v_fog_opacity));\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_skirt_height;in ivec2 a_pos;out vec2 v_pos0;\n#ifdef FOG\nout float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;\n#endif\nvoid main() {vec3 decomposedPosAndSkirt=decomposeToPosAndSkirt(a_pos);float skirt=decomposedPosAndSkirt.z;vec2 decodedPos=decomposedPosAndSkirt.xy;float elevation=elevation(decodedPos)-skirt*u_skirt_height;v_pos0=bottom_left_to_native_uv(decodedPos/8192.0);gl_Position=u_matrix*vec4(decodedPos,elevation,1.0);\n#ifdef FOG\nv_fog_opacity=fog(fog_position(vec3(decodedPos,elevation)));\n#endif\n#ifdef RENDER_SHADOWS\nvec3 pos=vec3(decodedPos,elevation);v_pos_light_view_0=u_light_matrix_0*vec4(pos,1.);v_pos_light_view_1=u_light_matrix_1*vec4(pos,1.);\n#endif\n}'),
            terrainDepth: e1.bm("precision highp float;in float v_depth;void main() {glFragColor=pack_depth(v_depth);}", '#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;in ivec2 a_pos;out float v_depth;void main() {float elevation=elevation(vec2(a_pos));gl_Position=u_matrix*vec4(a_pos,elevation,1.0);v_depth=gl_Position.z/gl_Position.w;}'),
            globeRaster: e1.bm('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image0;\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nuniform sampler2D u_image1;uniform float u_emissive_texture_available;\n#endif\nuniform float u_far_z_cutoff;in vec2 v_pos0;\n#ifndef FOG\nuniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform vec2 u_viewport;\n#endif\nvoid main() {vec4 color;\n#ifdef CUSTOM_ANTIALIASING\nhighp vec2 uv=fragcoord_to_bottom_left_uv(gl_FragCoord.xy,u_viewport);highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);highp vec3 dir=normalize(ray_dir);highp vec3 closest_point=dot(u_globe_pos,dir)*dir;highp float norm_dist_from_center=1.0-length(closest_point-u_globe_pos)/u_globe_radius;const float antialias_pixel=2.0;highp float antialias_factor=antialias_pixel*fwidth(norm_dist_from_center);highp float antialias=smoothstep(0.0,antialias_factor,norm_dist_from_center);vec4 raster=texture(u_image0,v_pos0);\n#ifdef LIGHTING_3D_MODE\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\n#ifdef USE_MRT1_RGBA\nvec4 emissive_premult=vec4(0.0);if (u_emissive_texture_available > 0.5) {emissive_premult=texture(u_image1,v_pos0);}vec3 unlit_base=raster.rgb-emissive_premult.rgb;raster.rgb=apply_lighting_ground(vec4(unlit_base,1.0)).rgb+emissive_premult.rgb;color=vec4(clamp(raster.rgb,vec3(0),vec3(1))*antialias,antialias);\n#else\nfloat emissive_strength=raster.a;if (u_emissive_texture_available > 0.5) {emissive_strength=texture(u_image1,v_pos0).r;}raster=apply_lighting_with_emission_ground(raster,emissive_strength);color=vec4(clamp(raster.rgb,vec3(0),vec3(1))*antialias,antialias);\n#endif\n#else\nraster=apply_lighting_ground(raster);color=vec4(raster.rgb*antialias,raster.a*antialias);\n#endif\n#else\ncolor=vec4(raster.rgb*antialias,raster.a*antialias);\n#endif\n#else\ncolor=texture(u_image0,v_pos0);\n#ifdef LIGHTING_3D_MODE\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\n#ifdef USE_MRT1_RGBA\nvec4 emissive_premult=vec4(0.0);if (u_emissive_texture_available > 0.5) {emissive_premult=texture(u_image1,v_pos0);}vec3 unlit_base=color.rgb-emissive_premult.rgb;color.rgb=apply_lighting_ground(vec4(unlit_base,1.0)).rgb+emissive_premult.rgb;color.a=1.0;\n#else\nfloat emissive_strength=color.a;if (u_emissive_texture_available > 0.5) {emissive_strength=texture(u_image1,v_pos0).r;}color=apply_lighting_with_emission_ground(color,emissive_strength);color.a=1.0;\n#endif\n#else\ncolor=apply_lighting_ground(color);\n#endif\n#endif\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ncolor*=1.0-step(u_far_z_cutoff,1.0/gl_FragCoord.w);glFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_proj_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;\n#ifndef GLOBE_POLES\nuniform mat4 u_merc_matrix;\n#endif\nuniform float u_zoom_transition;uniform vec2 u_merc_center;\n#ifndef GLOBE_POLES\nuniform mat3 u_grid_matrix;\n#endif\nuniform float u_skirt_height;\n#ifdef GLOBE_POLES\nin vec3 a_globe_pos;in vec2 a_uv;\n#else\nin ivec2 a_pos;\n#endif\nout vec2 v_pos0;void main() {\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;vec2 uv=a_uv;\n#else\nfloat tiles=u_grid_matrix[0][2];float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];vec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float uvY=mercatorY*tiles-idy;float mercatorX=mercatorXfromLng(latLng[1]);float uvX=mercatorX*tiles-idx;vec3 globe_pos=latLngToECEF(latLng.xy);vec2 merc_pos=vec2(mercatorX,mercatorY);vec2 uv=vec2(uvX,uvY);\n#endif\nv_pos0=bottom_left_to_native_uv(uv);vec2 tile_pos=uv*EXTENT;vec3 globe_derived_up_vector=normalize(globe_pos)*u_tile_up_scale;\n#ifdef GLOBE_POLES\nvec3 up_vector=globe_derived_up_vector;\n#else\nvec3 up_vector=elevationVector(tile_pos);\n#endif\nfloat height=elevation(tile_pos);globe_pos+=up_vector*height;\n#ifndef GLOBE_POLES\nglobe_pos-=globe_derived_up_vector*u_skirt_height*decomposed_pos_and_skirt.z;\n#endif\n#ifdef GLOBE_POLES\nvec4 interpolated_pos=u_globe_matrix*vec4(globe_pos,1.0);\n#else\nvec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {merc_world_pos=vec4(merc_pos,height-u_skirt_height*decomposed_pos_and_skirt.z,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition),1.0);\n#endif\ngl_Position=u_proj_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n}')
        };
        !function(e1) {
            Kr = e1;
            for (const e1 of Qr.splice(0))e1();
        }({
            create: (e1, t1)=>new Yr(e1, t1)
        }), Object.assign(mo, {
            terrainRaster: (t1)=>({
                    u_matrix: new e1.aa(t1),
                    u_image0: new e1.b6(t1),
                    u_image1: new e1.b6(t1),
                    u_skirt_height: new e1.a9(t1),
                    u_ground_shadow_factor: new e1.ab(t1),
                    u_emissive_texture_available: new e1.a9(t1)
                }),
            globeRaster: (t1)=>({
                    u_proj_matrix: new e1.aa(t1),
                    u_globe_matrix: new e1.aa(t1),
                    u_normalize_matrix: new e1.aa(t1),
                    u_merc_matrix: new e1.aa(t1),
                    u_zoom_transition: new e1.a9(t1),
                    u_merc_center: new e1.a8(t1),
                    u_image0: new e1.b6(t1),
                    u_image1: new e1.b6(t1),
                    u_grid_matrix: new e1.b8(t1),
                    u_skirt_height: new e1.a9(t1),
                    u_far_z_cutoff: new e1.a9(t1),
                    u_frustum_tl: new e1.ab(t1),
                    u_frustum_tr: new e1.ab(t1),
                    u_frustum_br: new e1.ab(t1),
                    u_frustum_bl: new e1.ab(t1),
                    u_globe_pos: new e1.ab(t1),
                    u_globe_radius: new e1.a9(t1),
                    u_viewport: new e1.a8(t1),
                    u_emissive_texture_available: new e1.a9(t1)
                })
        });
        const go = {
            shaders: _o
        };
        class yo extends e1.E {
            constructor(t1, i, s, r){
                super(), this.id = t1, this.dispatcher = s, this.setEventedParent(r), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = {
                    type: "raster",
                    ...i
                }, Object.assign(this, e1.cx(i, [
                    "url",
                    "scheme",
                    "tileSize"
                ]));
            }
            load(t1) {
                this._loaded = !1, this.fire(new e1.i("dataloading", {
                    dataType: "source"
                }));
                const i = this.map.getWorldview(), s = (i, s)=>{
                    this._tileJSONRequest = null, this._loaded = !0, i ? this.fire(new e1.h(i)) : s && (Object.assign(this, s), s.raster_layers && (this.rasterLayers = s.raster_layers, this.rasterLayerIds = this.rasterLayers.map((e1)=>e1.id)), this.tileBounds = new e1.cC(s), e1.cD(s.tiles), this.fire(new e1.i("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new e1.i("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }))), t1 && t1(i);
                };
                this.provider = "string" == typeof this._options.provider ? this._options.provider : void 0, this._tileProvider = void 0;
                const r = e1.cy(this._options);
                return r instanceof Error ? (this._loaded = !0, this.fire(new e1.h(r)), void (t1 && t1())) : this.provider && !r ? (this._loaded = !0, this.fire(new e1.h(new Error(`TileProvider "${this.provider}" is not registered`))), void (t1 && t1())) : void (this._tileJSONRequest = r ? this.loadTileJSONWithProvider(r, s) : e1.cz(this._options, this.map._requestManager, null, i, s));
            }
            loadTileJSONWithProvider(t1, i) {
                this.provider = t1.name;
                const s = new AbortController;
                return (async ()=>{
                    const { request: r, options: o } = await e1.cE(this._options, this.map._requestManager, s.signal);
                    if (s.signal.aborted) return;
                    const n = await e1.cF(t1.name, t1.url);
                    if (s.signal.aborted) return;
                    const a = new n(o);
                    let l = null;
                    if (a.load && r && (l = await a.load({
                        request: r
                    }), s.signal.aborted)) return;
                    this._tileProvider = a;
                    const c = e1.cG(this._options, l, this.map._requestManager);
                    c instanceof Error ? i(c) : i(null, c);
                })().catch((e1)=>{
                    s.signal.aborted || i(new Error(`Could not load tile provider ${t1.name}`, {
                        cause: e1
                    }));
                }), {
                    cancel: ()=>s.abort()
                };
            }
            loaded() {
                return this._loaded;
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            reload() {
                this.cancelTileJSONRequest();
                const t1 = e1.m(this.id, this.scope);
                this.load(()=>this.map.style.clearSource(t1));
            }
            setTiles(e1) {
                return this._options.tiles = e1, this.reload(), this;
            }
            setUrl(e1) {
                return this.url = e1, this._options.url = e1, this.reload(), this;
            }
            onRemove(e1) {
                this.cancelTileJSONRequest();
            }
            serialize() {
                return {
                    ...this._options
                };
            }
            hasTile(e1) {
                return !this.tileBounds || this.tileBounds.contains(e1.canonical);
            }
            async loadTile(t1, i) {
                const s = e1.e.devicePixelRatio >= 2, r = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), s, this.tileSize), o = new AbortController;
                if (t1.request = o, this._tileProvider) this.loadTileWithProvider(t1, this._tileProvider, r, o, i);
                else try {
                    const s = await this.map._requestManager.transformRequest(r, e1.R.Tile, o.signal);
                    if (o.signal.aborted) return delete t1.request, i(null);
                    const { data: n, headers: a } = await e1.a(s, o.signal);
                    if (delete t1.request, t1.aborted) return i(null);
                    const l = e1.cA(a);
                    this.map._refreshExpiredTiles && t1.setExpiryData(l), t1.setTexture(n, this.map.painter), t1.state = "loaded", e1.cB(this.dispatcher), i(null);
                } catch (e1) {
                    if (delete t1.request, o.signal.aborted) return i(null);
                    t1.state = "errored", i(e1);
                }
            }
            async loadTileWithProvider(t1, i, s, r, o) {
                const { z: n, x: a, y: l } = t1.tileID.canonical;
                try {
                    const c = await this.map._requestManager.transformRequest(s, e1.R.Tile, r.signal);
                    if (r.signal.aborted) return o(null);
                    const h = await i.loadTile({
                        z: n,
                        x: a,
                        y: l
                    }, {
                        request: c,
                        signal: r.signal
                    });
                    if (r.signal.aborted) return o(null);
                    if (null == h) {
                        const e1 = new Error("Tile not found");
                        return e1.status = 404, t1.state = "errored", o(e1);
                    }
                    if (null == h.data) return t1.state = "loaded", o(null);
                    const d = h.data instanceof ImageBitmap ? h.data : await createImageBitmap(new Blob([
                        h.data
                    ]));
                    if (r.signal.aborted) return o(null);
                    t1.setTexture(d, this.map.painter), t1.state = "loaded", this.map._refreshExpiredTiles && t1.setExpiryData({
                        cacheControl: h.cacheControl,
                        expires: h.expires
                    }), o(null);
                } catch (e1) {
                    if (r.signal.aborted) return o(null);
                    t1.state = "errored", o(new Error(`Could not load tile from ${s}`, {
                        cause: e1
                    }));
                } finally{
                    delete t1.request;
                }
            }
            abortTile(e1, t1) {
                e1.request && (e1.request.abort(), delete e1.request), t1 && t1();
            }
            unloadTile(t1, i) {
                t1.texture && t1.texture instanceof e1.T ? (t1.destroy(!1), t1.texture && t1.texture instanceof e1.T && this.map.painter.saveTileTexture(t1.texture)) : t1.destroy(), i && i();
            }
            hasTransition() {
                return !1;
            }
            cancelTileJSONRequest() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
        }
        function vo([t1, i], s, r, { scaled: o = !0 } = {}) {
            const { tileSize: n, buffer: a } = r, { x: l, y: c, z: h } = s;
            if (!isFinite(l) || !isFinite(c) || !isFinite(h)) throw new Error("Invalid MRT header");
            const d = 2 ** h, u = d * e1.ad(t1), p = d * e1.ae(i);
            return function([e1, t1], i, { scaled: s = !0 } = {}) {
                if (!i) throw new Error("bandView is undefined");
                const { data: r, tileSize: o, buffer: n, offset: a, scale: l, dimension: c } = i;
                if (e1 < -n || e1 > o + n || t1 < -n || t1 > o + n) throw new Error(`Point (${e1}, ${t1}) out of bounds for tileSize=${o}, buffer=${n}`);
                const h = (t1 + n) * (o + 2 * n) + (e1 + n);
                if (4294967295 === new Uint32Array(r.buffer)[h]) return null;
                let d = [];
                d = s ? [] : new i.data.constructor(c);
                for(let e1 = 0; e1 < c; e1++)d[e1] = Math.round(1e12 * (r[c * h + e1] * l + a)) / 1e12;
                return d;
            }([
                Math.min(Math.max(-a, Math.floor((u - l) * n)), n - 1 + a),
                Math.min(Math.max(-a, Math.floor((p - c) * n)), n - 1 + a)
            ], r, {
                scaled: o
            });
        }
        function bo(e1, t1) {
            const { terrain: i } = e1;
            return i && i.renderingToTexture ? i.getCurrentProxiedCoords(t1.id) || [] : t1.getVisibleCoordinates();
        }
        function xo(t1, i) {
            const { context: s } = t1, r = s.gl;
            t1.getOrCreateProgram("clippingMask").draw(t1, r.TRIANGLES, e1.a3.disabled, new e1.a4({
                func: r.ALWAYS,
                mask: 0
            }, i, e1.cc, r.KEEP, r.KEEP, r.REPLACE), e1.a7.disabled, e1.a5.disabled, Us(t1.identityMat), "$raster-mask", t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments);
        }
        function wo(e1, t1) {
            return !!e1 && e1.hasData() && ("reloading" !== e1.state || !!e1.getBucket(t1));
        }
        function To(t1, i, s, r) {
            const o = t1.context.gl, { tileBoundsBuffer: n, tileBoundsIndexBuffer: a, tileBoundsSegments: l } = t1.terrain && t1.terrain.renderingToTexture ? t1.getMercatorTileBoundsBuffers() : t1.getTileBoundsBuffers(i);
            t1.getOrCreateProgram("clippingMask").draw(t1, o.TRIANGLES, e1.a3.disabled, r, e1.a7.disabled, e1.a5.disabled, Us(s.projMatrix), "$raster-mask", n, a, l);
        }
        function So(t1, i, s, r) {
            const o = t1.context.gl, { bufferData: n } = i;
            n && n.layoutVertexBuffer && n.indexBuffer && 0 !== n.triangleSegments.get().length && t1.getOrCreateProgram("clippingMask").draw(t1, o.TRIANGLES, e1.a3.disabled, r, e1.a7.disabled, e1.a5.disabled, Us(s.projMatrix), "$raster-mask", n.layoutVertexBuffer, n.indexBuffer, n.triangleSegments);
        }
        class Co extends Error {
            constructor(e1){
                super(e1), this.name = "MRTOverzoomError";
            }
        }
        const Eo = {
            uint8: Uint8Array,
            uint16: Uint16Array,
            uint32: Uint32Array
        };
        function Io(e1, t1, i) {
            const { x: s, y: r, z: o } = t1, { x: n, y: a, z: l } = i, c = l - o;
            if (c < 0) throw new Co(`Invalid overzoom, source (z=${o}) is higher zoom than destination (z=${l}).`);
            const h = n - (s << c), d = a - (r << c), u = 1 << c;
            if (h < 0 || h >= u || d < 0 || d >= u) throw new Co(`Invalid overzoom, ${l}/${n}/${a} is not a child of ${o}/${s}/${r}.`);
            const p = 0 | Math.log2(e1), f = Math.min(c, p), m = c - f, _ = e1 >> f;
            return {
                offset: [
                    (h >> m) * _,
                    (d >> m) * _
                ],
                tileSize: _,
                deltaZ: c
            };
        }
        e1.cK.setPbf(e1.d);
        class Do extends _s {
            constructor(e1, t1, i, s, r){
                super(e1, t1, i, s, r), this._workQueuePerLayer = new Map, this._fetchQueuePerLayer = new Map, this._taskQueue = new Map, this._isHeaderLoaded = !1, this._isLoadInProgress = !1, this.textureDescriptorPerLayer = new Map, this.texturePerLayer = new Map, this.parentTile = null, this.overzoomCoordsPerLayer = null;
            }
            getLayers() {
                return this._mrt ? Object.values(this._mrt.layers) : [];
            }
            getLayer(e1) {
                return this._mrt && this._mrt.getLayer(e1);
            }
            setTexturePerLayer(t1, i, s) {
                const r = s.context, o = r.gl;
                let n = this.texturePerLayer.get(t1) || s.getTileTexture(i.width);
                n && n instanceof e1.T ? n.update(i, {
                    premultiply: !1
                }) : (n = new e1.T(r, i, o.RGBA8, {
                    premultiply: !1
                }), n.bind(o.LINEAR, o.CLAMP_TO_EDGE)), this.texturePerLayer.has(t1) || this.texturePerLayer.set(t1, n);
            }
            flushQueues(e1) {
                const t1 = this._workQueuePerLayer.get(e1) || [], i = this._fetchQueuePerLayer.get(e1) || [];
                for(; t1.length;)t1.pop()();
                for(; i.length;)i.pop()();
            }
            flushAllQueues() {
                for (const e1 of this._workQueuePerLayer.keys()){
                    const t1 = this._workQueuePerLayer.get(e1) || [];
                    for(; t1.length;)t1.pop()();
                }
                for (const e1 of this._fetchQueuePerLayer.keys()){
                    const t1 = this._fetchQueuePerLayer.get(e1) || [];
                    for(; t1.length;)t1.pop()();
                }
            }
            fetchHeader(t1 = 16384, i) {
                const s = this._mrt = new e1.cK(30), r = {
                    ...this.requestParams,
                    headers: {
                        Range: "bytes=0-" + (t1 - 1)
                    }
                };
                this.entireBuffer = null;
                const o = new AbortController;
                return this.request = o, e1.n(r, o.signal).then(({ data: e1, headers: r })=>{
                    try {
                        const o = s.getHeaderLength(e1);
                        if (o > t1) return void (this.request = this.fetchHeader(o, i));
                        s.parseHeader(e1), this._isHeaderLoaded = !0;
                        let n = 0;
                        for (const e1 of Object.values(s.layers))n = Math.max(n, e1.dataIndex.at(-1).lastByte);
                        e1.byteLength >= n && (this.entireBuffer = e1), i(null, this.entireBuffer || e1, r);
                    } catch (e1) {
                        i(e1);
                    }
                }).catch((e1)=>{
                    o.signal.aborted || i(e1);
                }), this.request;
            }
            fetchBandForRender(e1, t1, i, s) {
                this.fetchBand(e1, t1, i, (r)=>{
                    if (r) return void s(r);
                    this.updateTextureDescriptor(e1, t1, i);
                    const o = this.textureDescriptorPerLayer.get(t1);
                    s(null, o ? o.img : null);
                });
            }
            fetchBand(t1, i, s, r) {
                const o = this._mrt;
                if (!this._isHeaderLoaded || !o) return void r(new Error("Tile header is not ready"));
                if (this.parentTile && this.overzoomCoordsPerLayer) return void r(null, null);
                const n = this.actor;
                if (!n) return void r(new Error("Can't fetch tile band without an actor"));
                let a;
                const l = e1.m(String(s), e1.m(this.tileID.key, t1));
                let c = this._taskQueue.get(l);
                c ? c.add(r) : (c = new Set, c.add(r), this._taskQueue.set(l, c));
                const h = (e1, t1)=>{
                    a.complete(e1, t1), e1 ? r(e1) : (c.forEach((e1)=>e1(null, t1)), this._taskQueue.delete(l));
                }, d = (e1, t1)=>{
                    if (e1) return r(e1);
                    let s, o = !1;
                    if (null !== i) {
                        const e1 = this._workQueuePerLayer.get(i) || [];
                        e1.push(()=>{
                            o = !0, s && s.abort(), a.cancel();
                        }), this._workQueuePerLayer.has(i) || this._workQueuePerLayer.set(i, e1);
                    }
                    const l = ()=>{
                        o || (s = n.sendCancelable("decodeRasterArray", {
                            type: "raster-array",
                            source: this.source,
                            scope: this.scope,
                            tileID: this.tileID,
                            uid: this.uid,
                            buffer: t1,
                            task: a
                        }, {}, h));
                    };
                    void 0 !== this.workerReady ? this.workerReady.then(l).catch((e1)=>r(e1)) : l();
                };
                let u;
                try {
                    u = o.getLayer(t1);
                } catch (e1) {
                    if (this.parentTile && this.overzoomCoordsPerLayer) return void r(new Error(`Layer '${t1}' not found in parent tile MRT`));
                    if ("reloading" === this.state) return;
                    throw e1;
                }
                if (!u) return void r(new Error(`Unknown sourceLayer "${t1}"`));
                if (u.hasDataForBand(s)) return c.forEach((e1)=>e1(null, null)), void this._taskQueue.delete(l);
                const p = u.getDataRange([
                    s
                ]);
                if (a = o.createDecodingTask(p), !a || a.tasks.length) {
                    if (null !== i && this.flushQueues(i), this.entireBuffer) d(null, this.entireBuffer.slice(p.firstByte, p.lastByte + 1));
                    else {
                        const t1 = {
                            ...this.requestParams,
                            headers: {
                                Range: `bytes=${p.firstByte}-${p.lastByte}`
                            }
                        }, s = new AbortController;
                        if (e1.n(t1, s.signal).then(({ data: e1 })=>d(null, e1)).catch((e1)=>{
                            s.signal.aborted || d(e1);
                        }), null !== i) {
                            const e1 = this._fetchQueuePerLayer.get(i) || [];
                            e1.push(()=>{
                                s.abort(), a.cancel();
                            }), this._fetchQueuePerLayer.has(i) || this._fetchQueuePerLayer.set(i, e1);
                        }
                    }
                }
            }
            updateNeeded(e1, t1) {
                return (!this.textureDescriptorPerLayer.get(e1) || this.textureDescriptorPerLayer.get(e1).band !== t1 || this.refreshedUponExpiration) && "errored" !== this.state;
            }
            updateTextureDescriptor(t1, i, s) {
                if (!this._mrt) return;
                let r;
                try {
                    r = this._mrt.getLayer(t1);
                } catch (e1) {
                    return;
                }
                if (!r || !r.hasBand(s) || !r.hasDataForBand(s)) return;
                let { bytes: o, tileSize: n, buffer: a, offset: l, scale: c } = r.getBandView(s);
                if (this.parentTile && this.overzoomCoordsPerLayer) {
                    const e1 = this.overzoomCoordsPerLayer.get(t1);
                    e1 && (o = this.cropBandData(o, n, a, e1), n = e1.tileSize);
                }
                const h = n + 2 * a, d = new e1.b({
                    width: h,
                    height: h
                }, o), u = this.texturePerLayer.get(i);
                u && u instanceof e1.T && u.update(d, {
                    premultiply: !1
                }), this.textureDescriptorPerLayer.set(i, {
                    layer: t1,
                    band: s,
                    img: d,
                    buffer: a,
                    offset: l,
                    tileSize: n,
                    format: r.pixelFormat,
                    mix: [
                        c,
                        256 * c,
                        65536 * c,
                        16777216 * c
                    ]
                });
            }
            cropBandData(e1, t1, i, s) {
                const { offset: r, tileSize: o } = s, n = t1 + 2 * i, a = o + 2 * i;
                return function(e1, t1, i, s) {
                    const r = function(e1) {
                        if (e1 instanceof Uint8Array) return "uint8";
                        if (e1 instanceof Uint16Array) return "uint16";
                        if (e1 instanceof Uint32Array) return "uint32";
                        throw new Error("Invalid array type");
                    }(e1), o = Eo[r];
                    if (!o) throw new Error(`Invalid data type "${r}"`);
                    const n = t1[2] * t1[3], a = t1[1] * n, l = i[2] * i[3], c = i[1] * l, h = new o(c * i[0]);
                    for(let r = 0; r < i[0]; r++){
                        let o = r * a;
                        o += i[3] * (s[1] * t1[2] + s[0]);
                        let d = r * c;
                        for(let t1 = 0; t1 < i[1]; t1++)h.subarray(d, d + l).set(e1.subarray(o, o + l)), o += n, d += l;
                    }
                    return h;
                }(e1, [
                    1,
                    n,
                    n,
                    4
                ], [
                    1,
                    a,
                    a,
                    4
                ], r);
            }
            setupOverzoom(e1) {
                let t1 = e1;
                for(; t1.parentTile;)t1 = t1.parentTile;
                const i = t1._mrt;
                if (!i || !i.layers) return !1;
                const s = Object.values(i.layers);
                if (0 === s.length) return !1;
                const r = {
                    x: t1.tileID.canonical.x,
                    y: t1.tileID.canonical.y,
                    z: t1.tileID.canonical.z
                }, o = {
                    x: this.tileID.canonical.x,
                    y: this.tileID.canonical.y,
                    z: this.tileID.canonical.z
                }, n = new Map;
                for (const e1 of s)try {
                    n.set(e1.name, Io(e1.tileSize, r, o));
                } catch (e1) {
                    return !1;
                }
                return this.parentTile = t1, this._mrt = i, this._isHeaderLoaded = !0, this.overzoomCoordsPerLayer = n, !0;
            }
            destroy(t1 = !1) {
                if (super.destroy(t1), delete this._mrt, !t1) for (const t1 of this.texturePerLayer.values())t1 && t1 instanceof e1.T && t1.destroy();
                this.texturePerLayer.clear(), this.textureDescriptorPerLayer.clear(), this.fbo && (this.fbo.destroy(), delete this.fbo), delete this.request, delete this.requestParams, this._isHeaderLoaded = !1;
            }
        }
        fs = (e1, t1, i, s, r)=>new Do(e1, t1, i, s, r);
        const Po = {
            RasterArrayTileSource: class extends yo {
                get partial() {
                    return !this.map.style.imageManager.hasImageProviderForSource(this.id, this.scope);
                }
                constructor(e1, t1, i, s){
                    super(e1, t1, i, s), this.type = "raster-array", this.maxzoom = void 0 !== t1.maxzoom ? t1.maxzoom : 22, this._loadTilePending = {}, this._loadTileLoaded = {}, this._pendingParentWaiters = new Map, this._options = {
                        type: "raster-array",
                        ...t1
                    };
                }
                onAdd(e1) {
                    super.onAdd(e1);
                    const t1 = (e1)=>{
                        "source" === e1.dataType && "metadata" === e1.sourceDataType && (this.off("data", t1), void 0 === this._dataMaxzoom && (this._dataMaxzoom = this.maxzoom));
                    };
                    this.on("data", t1);
                }
                getDataMaxzoom() {
                    return this._dataMaxzoom;
                }
                collectOverzoomParentTileIDs(e1, t1) {
                    const i = [];
                    for (const t1 of e1.values()){
                        const s = t1.parentTile;
                        s && e1.has(s.tileID.key) && i.push(s.tileID);
                    }
                    const s = this._dataMaxzoom;
                    if (void 0 !== s) for (const r of t1){
                        if (r.canonical.z <= s) continue;
                        const t1 = r.scaledTo(s);
                        e1.has(t1.key) && i.push(t1);
                    }
                    return i;
                }
                _narrowDataMaxzoom(e1) {
                    const t1 = Math.max(this.minzoom, e1 - 1);
                    (void 0 === this._dataMaxzoom || t1 < this._dataMaxzoom) && (this._dataMaxzoom = t1);
                }
                _isParentReady(e1) {
                    const t1 = e1._mrt;
                    return e1._isHeaderLoaded && !!t1 && !!t1.layers && Object.keys(t1.layers).length > 0;
                }
                _waitForParent(e1, t1) {
                    if (this._isParentReady(e1)) return void t1(null);
                    if ("errored" === e1.state) return void t1(new Error("Parent tile failed to load"));
                    const i = this._pendingParentWaiters.get(e1.uid);
                    if (i) return void i.push(t1);
                    this._pendingParentWaiters.set(e1.uid, [
                        t1
                    ]);
                    const s = (t1)=>{
                        if ("source" !== t1.dataType || t1.tile !== e1) return;
                        const i = this._isParentReady(e1);
                        if (!i && "errored" !== e1.state) return;
                        this.off("data", s);
                        const r = this._pendingParentWaiters.get(e1.uid) || [];
                        this._pendingParentWaiters.delete(e1.uid);
                        const o = i ? null : new Error("Parent tile failed to load");
                        for (const e1 of r)e1(o);
                    };
                    this.on("data", s);
                }
                triggerRepaint(e1) {
                    const t1 = this.map.painter._terrain, i = this.map.style.getSourceCache(this.id);
                    t1 && t1.enabled && i && t1._clearRenderCacheForTile(i.id, e1.tileID), this.map.triggerRepaint();
                }
                _setupOverzoomTile(e1, t1) {
                    const i = void 0 !== this._dataMaxzoom ? this._dataMaxzoom : this.maxzoom, s = this.map.style.getSourceCache(this.id);
                    if (!s) return void t1(new Error("Source cache not found"));
                    e1._isLoadInProgress = !0;
                    const r = e1.tileID.scaledTo(i);
                    let o = s.getTile(r);
                    for(; o && o.parentTile;)o = o.parentTile;
                    o || (o = s._addTile(r));
                    const n = (i)=>{
                        e1._isLoadInProgress = !1, t1(i);
                    };
                    this._waitForParent(o, (t1)=>{
                        if (t1 || !e1.setupOverzoom(o)) return e1.state = "errored", void n(t1 || new Error("Parent tile setup failed"));
                        e1.state = "loaded", n(null);
                    });
                }
                async loadTile(t1, i) {
                    const s = t1.tileID.canonical.z > (void 0 !== this._dataMaxzoom ? this._dataMaxzoom : this.maxzoom);
                    if ("loaded" === t1.state) return void i(null);
                    if (t1._isLoadInProgress) return void i(null);
                    if (s) return void this._setupOverzoomTile(t1, i);
                    const r = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), !1, this.tileSize);
                    t1.source = this.id, t1.scope = this.scope, void 0 === this._workerReady && (this._workerReady = this.dispatcher.send("ensureRasterArraySource", void 0).then(()=>{}), this._workerReady.catch(()=>{})), t1.workerReady = this._workerReady, t1.actor || (t1.actor = this.dispatcher.getActor());
                    const o = new AbortController;
                    t1.request = o;
                    const n = (s, r, o)=>{
                        if (delete t1.request, t1.aborted) return i(null);
                        if (s) return (404 === s.status || "string" == typeof s.message && s.message.includes("Not Found")) && (this._narrowDataMaxzoom(t1.tileID.canonical.z), void 0 !== this._dataMaxzoom && t1.tileID.canonical.z > this._dataMaxzoom) ? void this._setupOverzoomTile(t1, i) : (t1.state = "errored", i(s));
                        if (this.map._refreshExpiredTiles && r && t1.setExpiryData(e1.cA(o)), this.partial && "expired" !== t1.state) t1.state = "empty";
                        else if (!this.partial) {
                            if (!r) return i(null);
                            t1.state = "loaded", t1._isHeaderLoaded = !0, t1._mrt = r;
                        }
                        i(null);
                    };
                    try {
                        const s = await this.map._requestManager.transformRequest(r, e1.R.Tile, o.signal);
                        if (o.signal.aborted) return i(null);
                        t1.requestParams = s;
                        const a = {
                            request: s,
                            uid: t1.uid,
                            tileID: t1.tileID,
                            type: this.type,
                            source: this.id,
                            scope: this.scope,
                            partial: this.partial
                        };
                        t1.request = this.partial ? t1.fetchHeader(void 0, (e1, t1, i)=>{
                            n(e1, t1, i);
                        }) : t1.actor.sendCancelable("loadTile", a, {}, (e1, t1)=>e1 ? n(e1) : t1 ? void n(null, t1.mrt, t1.headers) : n(null, null));
                    } catch (e1) {
                        if (o.signal.aborted) return i(null);
                        t1.state = "errored", i(e1);
                    }
                }
                abortTile(e1) {
                    e1.request && (e1.request.abort(), delete e1.request), e1.actor && e1.actor.notify("abortTile", {
                        uid: e1.uid,
                        type: this.type,
                        source: this.id,
                        scope: this.scope
                    });
                }
                unloadTile(e1, t1) {
                    const i = e1.texturePerLayer;
                    if (e1.flushAllQueues(), i.size) {
                        e1.destroy(!1);
                        for (const e1 of i.values())this.map.painter.saveTileTexture(e1);
                    } else e1.destroy();
                }
                prepareTile(t1, i, s, r) {
                    t1.tileID.canonical.z > (void 0 !== this._dataMaxzoom ? this._dataMaxzoom : this.maxzoom) && (!t1.parentTile || !t1.overzoomCoordsPerLayer) || t1._isHeaderLoaded && ("empty" !== t1.state && (t1.state = "reloading"), t1.fetchBandForRender(i, s, r, (i, r)=>{
                        i ? (t1.state = "errored", this.fire(new e1.h(i))) : r && (t1._isHeaderLoaded = !0, t1.setTexturePerLayer(s, r, this.map.painter), t1.state = "loaded"), this.triggerRepaint(t1);
                    }));
                }
                getInitialBand(e1) {
                    if (!this.rasterLayers) return 0;
                    const t1 = this.rasterLayers.find(({ id: t1 })=>t1 === e1), i = t1 && t1.fields, s = i && i.bands && i.bands;
                    return s ? s[0] : 0;
                }
                getTextureDescriptor(t1, i, s) {
                    if (!t1) return;
                    const r = i.sourceLayer || this.rasterLayerIds && this.rasterLayerIds[0];
                    if (!r) return;
                    let o = null;
                    i instanceof e1.cH ? o = i.paint.get("raster-array-band") : i instanceof e1.cI && (o = i.paint.get("raster-particle-array-band"));
                    const n = o || this.getInitialBand(r);
                    return null == n || !t1.textureDescriptorPerLayer.get(i.id) || t1.updateNeeded(i.id, n) && !s ? void 0 : {
                        ...t1.textureDescriptorPerLayer.get(i.id),
                        texture: t1.texturePerLayer.get(i.id)
                    };
                }
                getImages(t1, i) {
                    const s = new Map;
                    for (const r of t1)for (const t1 of i){
                        const [i, o] = t1.split("/"), n = r.getLayer(i);
                        if (!n) continue;
                        if (!n.hasBand(o) || !n.hasDataForBand(o)) continue;
                        const { bytes: a, tileSize: l, buffer: c } = n.getBandView(o), h = l + 2 * c, d = {
                            data: new e1.b({
                                width: h,
                                height: h
                            }, a),
                            pixelRatio: 2,
                            sdf: !1,
                            usvg: !1,
                            version: 0
                        };
                        s.set(t1, d);
                    }
                    return s;
                }
                queryRasterArrayValueByBandId(t1, i, s) {
                    const r = i._mrt;
                    return new Promise((o)=>{
                        const n = {}, a = new Set;
                        for (const [l, c] of Object.entries(r.layers)){
                            if (s.layerName && l !== s.layerName) continue;
                            const h = {};
                            n[l] = h;
                            for (const { bands: d } of c.dataIndex)for (const u of d)s.bands && !s.bands.includes(u) || (a.add(e1.m(l, u)), i.fetchBand(l, null, u, (i)=>{
                                e1.e.frame(()=>{
                                    h[u] = i ? null : vo([
                                        t1.lng,
                                        t1.lat
                                    ], r, c.getBandView(u)), a.delete(e1.m(l, u)), 0 === a.size && o(n);
                                });
                            }));
                        }
                        0 === a.size && o(n);
                    });
                }
                _loadTileForQuery(e1) {
                    if (this._loadTileLoaded[e1.uid]) return Promise.resolve(e1._mrt);
                    if (e1.uid in this._loadTilePending) return this._loadTilePending[e1.uid];
                    const t1 = this._fetchTileForQuery(e1);
                    return this._loadTilePending[e1.uid] = t1, t1;
                }
                async _fetchTileForQuery(t1) {
                    const i = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), !1, this.tileSize);
                    try {
                        const s = {
                            request: await this.map._requestManager.transformRequest(i, e1.R.Tile),
                            uid: t1.uid,
                            tileID: t1.tileID,
                            type: this.type,
                            source: this.id,
                            scope: this.scope,
                            partial: !1
                        }, r = await t1.actor.send("loadTile", s);
                        if (!r) return null;
                        const o = r.mrt;
                        return this.map._refreshExpiredTiles && t1.setExpiryData(e1.cA(r.headers)), t1._mrt = o, t1._isHeaderLoaded = !0, t1.state = "loaded", this._loadTileLoaded[t1.uid] = !0, o;
                    } finally{
                        delete this._loadTilePending[t1.uid];
                    }
                }
                async queryRasterArrayValueByAllBands(e1, t1, i) {
                    return await this._loadTileForQuery(t1) ? this.queryRasterArrayValueByBandId(e1, t1, i) : null;
                }
                queryRasterArrayValue(t1, i) {
                    const s = e1.cJ.convert(t1), r = this.findLoadedParent(s);
                    return r && r._mrt ? i.bands || !this.partial ? this.queryRasterArrayValueByBandId(s, r, i) : this.queryRasterArrayValueByAllBands(s, r, i) : Promise.resolve(null);
                }
                findLoadedParent(t1) {
                    const i = e1.b$.fromLngLat(t1, this.map.transform.tileSize), s = this.maxzoom + 1, r = 1 << s, o = Math.floor(i.x), n = Math.floor((i.x - o) * r), a = Math.floor(i.y * r);
                    if (n < 0 || n >= r || a < 0 || a >= r) return null;
                    const l = this.map.style.getSourceCache(this.id), c = new e1.bZ(s, o, s, n, a);
                    return l.findLoadedParent(c, this.minzoom);
                }
            },
            resolveRasterMask: function(t1, i) {
                const s = i.paint.get("raster-mask");
                if (!s) return null;
                if (i.paint.get("raster-elevation") > 0) return e1.w(`raster-mask: not supported together with "raster-elevation" (layer "${i.id}"); the raster layer is not drawn.`), "unavailable";
                const r = t1.style, o = i.paint.get("raster-mask-import") || void 0, n = !(!t1.terrain || !t1.terrain.enabled), a = [];
                for (const l of function(t1, i, s, r) {
                    if (!r) {
                        const r = t1.getLayer(e1.m(s, i.scope));
                        return r ? [
                            r
                        ] : (e1.w(`raster-mask: no layer found with id "${s}" (referenced by layer "${i.id}"); the raster layer is not drawn.`), []);
                    }
                    const o = t1.getFragmentStyle(i.scope), n = o ? o.getFragmentStyle(r) : void 0;
                    if (!n) return e1.w(`raster-mask: no import found with id "${r}" (referenced by layer "${i.id}"); the raster layer is not drawn.`), [];
                    if (!n._loaded || !n.stylesheet) return [];
                    const a = n.stylesheet.featuresets, l = a ? a[s] : void 0;
                    if (!l) return e1.w(`raster-mask: import "${r}" has no featureset "${s}" (referenced by layer "${i.id}"); the raster layer is not drawn.`), [];
                    const c = new Set;
                    for (const e1 of l.selectors){
                        const t1 = n.getOwnLayer(e1.layer);
                        t1 && c.add(t1);
                    }
                    return c.size || e1.w(`raster-mask: featureset "${s}" of import "${r}" selects no layers (referenced by layer "${i.id}"); the raster layer is not drawn.`), Array.from(c);
                }(r, i, s, o)){
                    if ("fill" !== l.type) {
                        e1.w(`raster-mask: layer "${l.id}" is of type "${l.type}"; only "fill" layers are used as a mask (referenced by layer "${i.id}").`);
                        continue;
                    }
                    if (l.isHidden(t1.transform.zoom)) {
                        e1.w(`raster-mask: layer "${l.id}" is hidden at the current zoom or by its visibility, so it is not part of the mask of layer "${i.id}". Use "fill-opacity": 0 to keep a mask layer invisible.`);
                        continue;
                    }
                    if (l.is3D(n)) {
                        e1.w(`raster-mask: elevated fill layer "${l.id}" is not supported as a mask (referenced by layer "${i.id}").`);
                        continue;
                    }
                    const s = r.getLayerSourceCache(l);
                    s ? a.push({
                        layer: l,
                        sourceCache: s
                    }) : e1.w(`raster-mask: no source found for layer "${l.id}" (referenced by layer "${i.id}").`);
                }
                return a.length ? {
                    sources: a,
                    inside: "clip-path-exclude" !== i.paint.get("raster-mask-mode")
                } : "unavailable";
            },
            renderRasterMask: function(t1, i) {
                const s = t1.context.gl, r = new e1.a4({
                    func: s.ALWAYS,
                    mask: 0
                }, e1.cc, e1.cc, s.KEEP, s.KEEP, s.REPLACE), o = new e1.a4({
                    func: s.ALWAYS,
                    mask: 0
                }, 0, e1.cc, s.KEEP, s.KEEP, s.REPLACE);
                xo(t1, e1.cc);
                const n = [];
                for (const { layer: e1, sourceCache: s } of i.sources)for (const i of bo(t1, s)){
                    const t1 = s.getTile(i);
                    wo(t1, e1) && n.push({
                        layer: e1,
                        tile: t1,
                        coord: i
                    });
                }
                if (i.inside) for (const { layer: e1, tile: i, coord: s } of n){
                    const r = i.getBucket(e1);
                    r && So(t1, r, s, o);
                }
                else {
                    for (const { tile: e1, coord: i } of n)To(t1, e1, i, o);
                    for (const { layer: e1, tile: i, coord: s } of n){
                        const o = i.getBucket(e1);
                        o && So(t1, o, s, r);
                    }
                }
            },
            clearRasterMask: function(e1) {
                xo(e1, 0);
            },
            stencilModeWithRasterMask: function(t1, i) {
                const s = t1.context.gl;
                return i && i !== e1.a4.disabled && 0 !== i.test.mask ? i : new e1.a4({
                    func: s.EQUAL,
                    mask: e1.cc
                }, 0, 0, s.KEEP, s.KEEP, s.KEEP);
            }
        }, Lo = Po;
        async function Ro() {
            return Promise.resolve();
        }
        class Ao {
            constructor(e1, t1, i){
                this.screenBounds = e1, this.cameraPoint = i.getCameraPoint(), this._screenRaycastCache = {}, this._cameraRaycastCache = {}, this.isAboveHorizon = t1, this.screenGeometry = this.bufferedScreenGeometry(0), this.screenGeometryMercator = this._bufferedScreenMercator(0, i);
            }
            static createFromScreenPoints(t1, i) {
                let s, r;
                if (t1 instanceof e1.P || "number" == typeof t1[0]) {
                    const o = e1.P.convert(t1);
                    s = [
                        o
                    ], r = i.isPointAboveHorizon(o);
                } else {
                    const o = e1.P.convert(t1[0]), n = e1.P.convert(t1[1]), a = o.add(n)._div(2);
                    s = [
                        o,
                        n
                    ], r = e1.cL(o, n).every((e1)=>i.isPointAboveHorizon(e1)) && i.isPointAboveHorizon(a);
                }
                return new Ao(s, r, i);
            }
            isPointQuery() {
                return 1 === this.screenBounds.length;
            }
            bufferedScreenGeometry(t1) {
                return e1.cL(this.screenBounds[0], 1 === this.screenBounds.length ? this.screenBounds[0] : this.screenBounds[1], t1);
            }
            bufferedCameraGeometry(t1) {
                const i = this.screenBounds[0], s = 1 === this.screenBounds.length ? this.screenBounds[0].add(new e1.P(1, 1)) : this.screenBounds[1], r = e1.cL(i, s, 0, !1);
                return this.cameraPoint.y > s.y && (this.cameraPoint.x > i.x && this.cameraPoint.x < s.x ? r.splice(3, 0, this.cameraPoint) : this.cameraPoint.x >= s.x ? r[2] = this.cameraPoint : this.cameraPoint.x <= i.x && (r[3] = this.cameraPoint)), e1.cM(r, t1);
            }
            bufferedCameraGeometryGlobe(t1) {
                const i = this.screenBounds[0], s = 1 === this.screenBounds.length ? this.screenBounds[0].add(new e1.P(1, 1)) : this.screenBounds[1], r = e1.cL(i, s, t1), o = this.cameraPoint.clone(), n = Number(o.x > i.x) + Number(o.x > s.x);
                switch(3 * (Number(o.y > i.y) + Number(o.y > s.y)) + n){
                    case 0:
                        r[0] = o, r[4] = o.clone();
                        break;
                    case 1:
                        r.splice(1, 0, o);
                        break;
                    case 2:
                        r[1] = o;
                        break;
                    case 3:
                        r.splice(4, 0, o);
                        break;
                    case 5:
                        r.splice(2, 0, o);
                        break;
                    case 6:
                        r[3] = o;
                        break;
                    case 7:
                        r.splice(3, 0, o);
                        break;
                    case 8:
                        r[2] = o;
                }
                return r;
            }
            containsTile(t1, i, s, r = 0, o) {
                const n = Math.max(t1.queryPadding, t1.evaluateQueryRenderedFeaturePadding()) / i._pixelsPerMercatorPixel + 1, a = s ? this._bufferedCameraMercator(n, i) : this._bufferedScreenMercator(n, i);
                let l = t1.tileID.wrap + (a.unwrapped ? r : 0);
                const c = a.polygon.map((i)=>e1.cN(t1.tileTransform, i, l));
                if (!e1.cO(c, 0, 0, e1.ac, e1.ac)) return;
                l = t1.tileID.wrap + (this.screenGeometryMercator.unwrapped ? r : 0);
                const h = this.screenGeometryMercator.polygon.map((i)=>e1.cP(t1.tileTransform, i, l)), d = h.map((t1)=>new e1.P(t1[0], t1[1])), u = e1.cP(t1.tileTransform, o, l), p = h.map((t1)=>{
                    const i = e1.cQ(t1, t1, u);
                    return e1.cg(i, i), new e1.cR(u, i);
                }), f = e1.ck(t1, 1, i.zoom) * i._pixelsPerMercatorPixel;
                var m;
                return {
                    queryGeometry: this,
                    tilespaceGeometry: d,
                    tilespaceRays: p,
                    bufferedTilespaceGeometry: c,
                    bufferedTilespaceBounds: (m = e1.cS(c), m.min.x = e1.bb(m.min.x, 0, e1.ac), m.min.y = e1.bb(m.min.y, 0, e1.ac), m.max.x = e1.bb(m.max.x, 0, e1.ac), m.max.y = e1.bb(m.max.y, 0, e1.ac), m),
                    tile: t1,
                    tileID: t1.tileID,
                    pixelToTileUnitsFactor: f
                };
            }
            _bufferedScreenMercator(e1, t1) {
                const i = Oo(e1);
                if (this._screenRaycastCache[i]) return this._screenRaycastCache[i];
                {
                    let s;
                    return s = "globe" === t1.projection.name ? this._projectAndResample(this.bufferedScreenGeometry(e1), t1) : {
                        polygon: this.bufferedScreenGeometry(e1).map((e1)=>t1.pointCoordinate3D(e1)),
                        unwrapped: !0
                    }, this._screenRaycastCache[i] = s, s;
                }
            }
            _bufferedCameraMercator(e1, t1) {
                const i = Oo(e1);
                if (this._cameraRaycastCache[i]) return this._cameraRaycastCache[i];
                {
                    let s;
                    return s = "globe" === t1.projection.name ? this._projectAndResample(this.bufferedCameraGeometryGlobe(e1), t1) : {
                        polygon: this.bufferedCameraGeometry(e1).map((e1)=>t1.pointCoordinate3D(e1)),
                        unwrapped: !0
                    }, this._cameraRaycastCache[i] = s, s;
                }
            }
            _projectAndResample(t1, i) {
                const s = function(t1, i) {
                    const s = e1.a1([], i.pixelMatrix, i.globeMatrix), r = [
                        0,
                        -e1.cT,
                        0,
                        1
                    ], o = [
                        0,
                        e1.cT,
                        0,
                        1
                    ], n = [
                        0,
                        0,
                        0,
                        1
                    ];
                    e1.cd(r, r, s), e1.cd(o, o, s), e1.cd(n, n, s);
                    const a = new e1.P(r[0] / r[3], r[1] / r[3]), l = new e1.P(o[0] / o[3], o[1] / o[3]), c = e1.cU(t1, a) && r[3] < n[3], h = e1.cU(t1, l) && o[3] < n[3];
                    if (!c && !h) return null;
                    const d = function(e1, t1, i) {
                        for(let s = 1; s < e1.length; s++){
                            const r = Fo(t1.pointCoordinate3D(e1[s - 1]).x), o = Fo(t1.pointCoordinate3D(e1[s]).x);
                            if (i < 0) {
                                if (r < o) return {
                                    idx: s,
                                    t: -r / (o - 1 - r)
                                };
                            } else if (o < r) return {
                                idx: s,
                                t: (1 - r) / (o + 1 - r)
                            };
                        }
                        return null;
                    }(t1, i, c ? -1 : 1);
                    if (!d) return null;
                    const { idx: u, t: p } = d;
                    let f = u > 1 ? Mo(t1.slice(0, u), i) : [], m = u < t1.length ? Mo(t1.slice(u), i) : [];
                    f = f.map((t1)=>new e1.P(Fo(t1.x), t1.y)), m = m.map((t1)=>new e1.P(Fo(t1.x), t1.y));
                    const _ = [
                        ...f
                    ];
                    0 === _.length && _.push(m.at(-1));
                    const g = _.at(-1), y = e1.aw(g.y, (0 === m.length ? f[0] : m[0]).y, p);
                    let v;
                    return v = c ? [
                        new e1.P(0, y),
                        new e1.P(0, 0),
                        new e1.P(1, 0),
                        new e1.P(1, y)
                    ] : [
                        new e1.P(1, y),
                        new e1.P(1, 1),
                        new e1.P(0, 1),
                        new e1.P(0, y)
                    ], _.push(...v), 0 === m.length ? _.push(f[0]) : _.push(...m), {
                        polygon: _.map((t1)=>new e1.b$(t1.x, t1.y)),
                        unwrapped: !1
                    };
                }(t1, i);
                if (s) return s;
                const r = function(t1, i) {
                    let s = !1, r = -1 / 0, o = 0;
                    for(let e1 = 0; e1 < t1.length - 1; e1++)t1[e1].x > r && (r = t1[e1].x, o = e1);
                    for(let e1 = 0; e1 < t1.length - 1; e1++){
                        const i = (o + e1) % (t1.length - 1), r = t1[i], n = t1[i + 1];
                        Math.abs(r.x - n.x) > .5 && (r.x < n.x ? (r.x += 1, 0 === i && (t1.at(-1).x += 1)) : (n.x += 1, i + 1 === t1.length - 1 && (t1[0].x += 1)), s = !0);
                    }
                    const n = e1.ad(i.center.lng);
                    return s && n < Math.abs(n - 1) && t1.forEach((e1)=>{
                        e1.x -= 1;
                    }), {
                        polygon: t1,
                        unwrapped: s
                    };
                }(Mo(t1, i).map((t1)=>new e1.P(Fo(t1.x), t1.y)), i);
                return {
                    polygon: r.polygon.map((t1)=>new e1.b$(t1.x, t1.y)),
                    unwrapped: r.unwrapped
                };
            }
        }
        function Mo(t1, i) {
            return e1.cV(t1, (e1)=>{
                const t1 = i.pointCoordinate3D(e1);
                e1.x = t1.x, e1.y = t1.y;
            }, 1 / 256);
        }
        function Fo(e1) {
            return e1 < 0 ? 1 + e1 % 1 : e1 % 1;
        }
        function Oo(e1) {
            return 100 * e1 | 0;
        }
        function ko(t1, i, s, r, o, n, a, l) {
            const c = [
                t1,
                i,
                1,
                s,
                r,
                1,
                o,
                n,
                1
            ], h = [
                a,
                l,
                1
            ], d = e1.d3([], c), [u, p, f] = e1.d2(h, h, d);
            return e1.d4(c, c, [
                u,
                0,
                0,
                0,
                p,
                0,
                0,
                0,
                f
            ]);
        }
        function Bo(t1, i, s, r, o, n, a, l) {
            const c = function(t1, i, s, r, o, n, a, l) {
                const c = ko(0, 0, 1, 0, 1, 1, 0, 1), h = ko(t1, i, s, r, o, n, a, l), d = e1.d3([], c);
                return e1.d4(h, h, d);
            }(t1, i, s, r, o, n, a, l);
            return [
                c[2] / c[8] / e1.ac,
                c[5] / c[8] / e1.ac
            ];
        }
        function zo(t1) {
            return [
                t1[0],
                Math.min(Math.max(t1[1], -e1.c_), e1.c_)
            ];
        }
        class Uo extends e1.E {
            constructor(e1, t1, i, s){
                super(), this.id = e1, this.dispatcher = i, this.coordinates = t1.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.onNorthPole = !1, this.onSouthPole = !1, this.setEventedParent(s), this.options = t1, this._dirty = !1;
            }
            async load(t1, i) {
                if (this._loaded = i || !1, this.fire(new e1.i("dataloading", {
                    dataType: "source"
                })), this.url = this.options.url, !this.url) return t1 && (this.coordinates = t1), this._loaded = !0, void this._finishLoading();
                const s = new AbortController;
                this._imageRequest = s;
                try {
                    const i = await this.map._requestManager.transformRequest(this.url, e1.R.Image, s.signal), { data: r } = await e1.a(i, s.signal);
                    this._imageRequest = null, this._loaded = !0, this.image = r, this._dirty = !0, this.width = this.image.width, this.height = this.image.height, t1 && (this.coordinates = t1), this._finishLoading();
                } catch (t1) {
                    if (s.signal.aborted) return;
                    this._imageRequest = null, this._loaded = !0, this.fire(new e1.h(t1));
                }
            }
            loaded() {
                return this._loaded;
            }
            updateImage(e1) {
                return e1.url ? (this._imageRequest && e1.url !== this.options.url && (this._imageRequest.abort(), this._imageRequest = null), this.options.url = e1.url, this.load(e1.coordinates, this._loaded), this) : this;
            }
            setTexture(t1) {
                if (!(t1.handle instanceof WebGLTexture)) throw new Error("The provided handle is not a WebGLTexture instance");
                return this.texture = new e1.cZ(this.map.painter.context, t1.handle), this.width = t1.dimensions[0], this.height = t1.dimensions[1], this._dirty = !1, this._loaded = !0, this._finishLoading(), this;
            }
            _finishLoading() {
                this.map && (this.setCoordinates(this.coordinates), this.fire(new e1.i("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                })));
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            onRemove(t1) {
                this._imageRequest && (this._imageRequest.abort(), this._imageRequest = null), !this.texture || this.texture instanceof e1.cZ || this.texture.destroy(), this.boundsBuffer && (this.boundsBuffer.destroy(), this.elevatedGlobeVertexBuffer && this.elevatedGlobeVertexBuffer.destroy(), this.elevatedGlobeIndexBuffer && this.elevatedGlobeIndexBuffer.destroy());
            }
            setCoordinates(t1) {
                if (this.coordinates = t1, this._boundsArray = void 0, this._unsupportedCoords = !1, !t1.length) return this;
                this.onNorthPole = !1, this.onSouthPole = !1;
                let i = t1[0][1], s = t1[0][1];
                for (const e1 of t1)e1[1] > s && (s = e1[1]), e1[1] < i && (i = e1[1]);
                const r = (s + i) / 2;
                if (r > e1.c_ ? this.onNorthPole = !0 : r < -e1.c_ && (this.onSouthPole = !0), !this.onNorthPole && !this.onSouthPole) {
                    const i = t1.map(e1.b$.fromLngLat);
                    this.tileID = function(t1) {
                        let i = 1 / 0, s = 1 / 0, r = -1 / 0, o = -1 / 0;
                        for (const e1 of t1)i = Math.min(i, e1.x), s = Math.min(s, e1.y), r = Math.max(r, e1.x), o = Math.max(o, e1.y);
                        const n = Math.max(r - i, o - s), a = Math.max(0, Math.floor(-Math.log2(n))), l = Math.pow(2, a);
                        let c = Math.floor((i + r) / 2 * l);
                        return c > 1 && (c -= 1), new e1.c1(a, c, Math.floor((s + o) / 2 * l));
                    }(i), this.minzoom = this.maxzoom = this.tileID.z;
                }
                return this.fire(new e1.i("data", {
                    dataType: "source",
                    sourceDataType: "content"
                })), this;
            }
            _clear() {
                !this.texture || this.texture instanceof e1.cZ || (this.texture.destroy(), this._dirty = !0), this.texture = null, this._boundsArray = void 0, this._unsupportedCoords = !1;
            }
            _prepareData(t1) {
                for(const e1 in this.tiles){
                    const t1 = this.tiles[e1];
                    "loaded" !== t1.state && (t1.state = "loaded", t1.texture = this.texture);
                }
                if (this._boundsArray || this.onNorthPole || this.onSouthPole || this._unsupportedCoords) return;
                const i = e1.bA(new e1.c1(0, 0, 0), this.map.transform.projection), s = [
                    i.projection.project(this.coordinates[0][0], this.coordinates[0][1]),
                    i.projection.project(this.coordinates[1][0], this.coordinates[1][1]),
                    i.projection.project(this.coordinates[2][0], this.coordinates[2][1]),
                    i.projection.project(this.coordinates[3][0], this.coordinates[3][1])
                ];
                if (!function(e1) {
                    const t1 = e1[1].x - e1[0].x, i = e1[1].y - e1[0].y, s = e1[2].x - e1[1].x, r = e1[2].y - e1[1].y, o = e1[3].x - e1[2].x, n = e1[3].y - e1[2].y, a = e1[0].x - e1[3].x, l = e1[0].y - e1[3].y, c = t1 * r - s * i, h = s * n - o * r, d = o * l - a * n, u = a * i - t1 * l;
                    return c > 0 && h > 0 && d > 0 && u > 0 || c < 0 && h < 0 && d < 0 && u < 0;
                }(s)) return console.warn("Image source coordinates are defining non-convex area in the Mercator projection"), void (this._unsupportedCoords = !0);
                const r = e1.bA(this.tileID, this.map.transform.projection), [o, n, a, l] = this.coordinates.map((t1)=>{
                    const i = r.projection.project(t1[0], t1[1]);
                    return e1.cN(r, i)._round();
                });
                this.perspectiveTransform = Bo(o.x, o.y, n.x, n.y, a.x, a.y, l.x, l.y);
                const c = this._boundsArray = new e1.bD;
                c.emplaceBack(o.x, o.y, 0, 0), c.emplaceBack(n.x, n.y, e1.ac, 0), c.emplaceBack(l.x, l.y, 0, e1.ac), c.emplaceBack(a.x, a.y, e1.ac, e1.ac), this.boundsBuffer && (this.boundsBuffer.destroy(), this.elevatedGlobeVertexBuffer && this.elevatedGlobeVertexBuffer.destroy(), this.elevatedGlobeIndexBuffer && this.elevatedGlobeIndexBuffer.destroy()), this.boundsBuffer = t1.createVertexBuffer(c, us.members), this.boundsSegments = e1.aj.simpleSegment(0, 0, 4, 2);
                const h = e1.d1, d = h + 1, u = h + 1, p = d * u, f = h * h * 2, m = [], _ = function(e1) {
                    return [
                        zo(e1[0]),
                        zo(e1[1]),
                        zo(e1[2]),
                        zo(e1[3])
                    ];
                }(this.coordinates), [g, y, v, b] = function(e1) {
                    let t1 = e1[0][0], i = t1, s = e1[0][1], r = s;
                    for(let o = 1; o < e1.length; o++)e1[o][0] < t1 ? t1 = e1[o][0] : e1[o][0] > i && (i = e1[o][0]), e1[o][1] < s ? s = e1[o][1] : e1[o][1] > r && (r = e1[o][1]);
                    return [
                        t1,
                        s,
                        i - t1,
                        r - s
                    ];
                }(_);
                {
                    const r = new e1.bD, [o, n, a, l] = function(e1) {
                        let t1 = e1[0].x, i = t1, s = e1[0].y, r = s;
                        for(let o = 1; o < e1.length; o++)e1[o].x < t1 ? t1 = e1[o].x : e1[o].x > i && (i = e1[o].x), e1[o].y < s ? s = e1[o].y : e1[o].y > r && (r = e1[o].y);
                        return [
                            t1,
                            s,
                            i - t1,
                            r - s
                        ];
                    }(s), c = (e1)=>[
                            (e1.x - o) / a,
                            (e1.y - n) / l
                        ], [p, f, _, x] = s.map(c), w = function(t1, i, s, r, o, n, a, l) {
                        const c = ko(0, 0, 1, 0, 1, 1, 0, 1), h = ko(t1, i, s, r, o, n, a, l), d = e1.d3([], h);
                        return e1.d4(c, c, d);
                    }(p[0], p[1], f[0], f[1], _[0], _[1], x[0], x[1]);
                    this.elevatedGlobePerspectiveTransform = Bo(p[0], p[1], f[0], f[1], _[0], _[1], x[0], x[1]);
                    const T = (t1, i)=>{
                        m.push(t1.lng);
                        const s = Math.round((t1.lng - g) / v * e1.ac), o = Math.round((t1.lat - y) / b * e1.ac), n = c(i), a = e1.d2([], [
                            n[0],
                            n[1],
                            1
                        ], w), l = Math.round(a[0] / a[2] * e1.ac), h = Math.round(a[1] / a[2] * e1.ac);
                        r.emplaceBack(s, o, l, h);
                    }, S = s[3].x - s[0].x, C = s[3].y - s[0].y, E = s[2].x - s[1].x, I = s[2].y - s[1].y;
                    for(let e1 = 0; e1 < u; e1++){
                        const t1 = e1 / h, r = [
                            s[0].x + t1 * S,
                            s[0].y + t1 * C
                        ], o = [
                            s[1].x + t1 * E,
                            s[1].y + t1 * I
                        ], n = o[0] - r[0], a = o[1] - r[1];
                        for(let e1 = 0; e1 < d; e1++){
                            const t1 = e1 / h, s = {
                                x: r[0] + n * t1,
                                y: r[1] + a * t1
                            };
                            T(i.projection.unproject(s.x, s.y), s);
                        }
                    }
                    this.elevatedGlobeVertexBuffer = t1.createVertexBuffer(r, us.members);
                }
                {
                    this.maxLongitudeTriangleSize = 0;
                    let i = [], s = new e1.ak;
                    const r = (e1, t1, r)=>{
                        s.emplaceBack(e1, t1, r);
                        const o = m[e1], n = m[t1], a = m[r], l = Math.min(Math.min(o, n), a), c = Math.max(Math.max(o, n), a) - l;
                        c > this.maxLongitudeTriangleSize && (this.maxLongitudeTriangleSize = c), i.push(l + c / 2);
                    };
                    for(let e1 = 0; e1 < h; e1++)for(let t1 = 0; t1 < h; t1++){
                        const i = e1 * d + t1, s = i + 1, o = i + d, n = o + 1;
                        r(i, o, s), r(s, o, n);
                    }
                    [i, s] = function(t1, i) {
                        const s = Array.from({
                            length: t1.length
                        }, (e1, t1)=>t1);
                        s.sort((e1, i)=>t1[e1] - t1[i]);
                        const r = [], o = new e1.ak;
                        for(let e1 = 0; e1 < s.length; e1++){
                            const n = s[e1];
                            r.push(t1[n]);
                            const a = 3 * n, l = a + 1;
                            o.emplaceBack(i.uint16[a], i.uint16[l], i.uint16[l + 1]);
                        }
                        return [
                            r,
                            o
                        ];
                    }(i, s), this.elevatedGlobeTrianglesCenterLongitudes = i, this.elevatedGlobeIndexBuffer = t1.createIndexBuffer(s);
                }
                this.elevatedGlobeSegments = e1.aj.simpleSegment(0, 0, p, f), this.elevatedGlobeGridMatrix = new Float32Array([
                    0,
                    v / e1.ac,
                    0,
                    b / e1.ac,
                    0,
                    0,
                    y,
                    g,
                    0
                ]);
            }
            prepare() {
                const t1 = 0 !== Object.keys(this.tiles).length;
                if (this.tileID && !t1) return;
                const i = this.map.painter.context, s = i.gl;
                !this._dirty || this.texture instanceof e1.cZ || (this.texture ? this.texture.update(this.image) : (this.texture = new e1.T(i, this.image, s.RGBA8), this.texture.bind(s.LINEAR, s.CLAMP_TO_EDGE)), this._dirty = !1), t1 && this._prepareData(i);
            }
            loadTile(e1, t1) {
                this.tileID && this.tileID.equals(e1.tileID.canonical) ? (this.tiles[String(e1.tileID.wrap)] = e1, e1.buckets = {}, t1(null)) : (e1.state = "errored", t1(null));
            }
            serialize() {
                return {
                    type: "image",
                    url: this.options.url,
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return !1;
            }
            getSegmentsForLongitude(t1) {
                const i = this.elevatedGlobeSegments;
                if (!this.elevatedGlobeTrianglesCenterLongitudes || !i) return null;
                const s = this.elevatedGlobeTrianglesCenterLongitudes;
                let r = (o = t1 + 180) + 360 * Math.round((s[0] - o) / 360);
                var o;
                const n = new e1.aj, a = (e1, t1)=>{
                    n.segments.push({
                        vertexOffset: 0,
                        primitiveOffset: e1,
                        vertexLength: i.segments[0].vertexLength,
                        primitiveLength: t1,
                        sortKey: void 0,
                        vaos: {}
                    });
                }, l = .51 * this.maxLongitudeTriangleSize;
                if (Math.abs(s[0] - r) <= l) {
                    const t1 = e1.c$(s, 0, s.length, r + l);
                    return t1 === s.length || a(t1, e1.d0(s, t1 + 1, s.length, r + 360 - l) - t1), n;
                }
                r < s[0] && (r += 360);
                const c = e1.d0(s, 0, s.length, r - l);
                if (c === s.length) return a(0, s.length), n;
                a(0, c - 0);
                const h = e1.c$(s, c + 1, s.length, r + l);
                return h !== s.length && a(h, s.length - h), n;
            }
        }
        const No = {
            vector: class extends e1.E {
                constructor(t1, i, s, r){
                    if (super(), this.id = t1, this.dispatcher = s, this.type = "vector", this.provider = i.provider, this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, Object.assign(this, e1.cx(i, [
                        "url",
                        "scheme",
                        "tileSize",
                        "promoteId"
                    ])), this._options = {
                        type: "vector",
                        ...i
                    }, this._collectResourceTiming = !!i.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
                    this.setEventedParent(r), this._tileWorkers = {}, this._deduped = new e1.cW;
                }
                load(t1) {
                    this._loaded = !1, this.fire(new e1.i("dataloading", {
                        dataType: "source"
                    }));
                    const i = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language, s = this.map.getWorldview(), r = (r, o)=>{
                        this._tileJSONRequest = null, this._loaded = !0, r ? (i && console.warn(`Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ${i}`), s && console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${s}`), this.fire(new e1.h(r))) : o && (this._setTileJSON(o), Xs.updateCrossSourceElevationGate && this.map.style && Xs.updateCrossSourceElevationGate(this.map.style), e1.cD(o.tiles, this.map._requestManager._customAccessToken), this.fire(new e1.i("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        })), this.fire(new e1.i("data", {
                            dataType: "source",
                            sourceDataType: "content"
                        }))), t1 && t1(r);
                    };
                    this.provider = this._options.provider;
                    const o = e1.cy(this._options);
                    return o instanceof Error ? (this._loaded = !0, this.fire(new e1.h(o)), void (t1 && t1())) : this.provider && !o ? (this._loaded = !0, this.fire(new e1.h(new Error(`TileProvider "${this.provider}" is not registered`))), void (t1 && t1())) : void (this._tileJSONRequest = o ? this.loadTileJSONWithProvider(o, r) : e1.cz(this._options, this.map._requestManager, i, s, r));
                }
                loadTileJSONWithProvider(t1, i) {
                    this.provider = t1.name;
                    const s = new AbortController;
                    return (async ()=>{
                        const { request: r, options: o } = await e1.cE(this._options, this.map._requestManager, s.signal);
                        if (s.signal.aborted) return;
                        const n = await this.dispatcher.send("loadTileProvider", {
                            name: t1.name,
                            url: t1.url,
                            source: this.id,
                            scope: this.scope,
                            type: this.type,
                            options: o,
                            request: r
                        }, {
                            signal: s.signal
                        });
                        if (s.signal.aborted) return;
                        const a = n ? n.find((e1)=>null != e1) : null, l = e1.cG(this._options, a, this.map._requestManager);
                        l instanceof Error ? i(l) : i(null, l);
                    })().catch((e1)=>{
                        s.signal.aborted || i(e1);
                    }), {
                        cancel: ()=>s.abort()
                    };
                }
                _setTileJSON(t1) {
                    if (Object.assign(this, t1), this.hasWorldviews = !!t1.worldview_options, t1.worldview_default && (this.worldviewDefault = t1.worldview_default), t1.vector_layers) {
                        this.vectorLayers = t1.vector_layers, this.vectorLayerIds = [], this.localizableLayerIds = new Set;
                        for (const e1 of t1.vector_layers)this.vectorLayerIds.push(e1.id), t1.worldview && t1.worldview[e1.source] && this.localizableLayerIds.add(e1.id);
                    }
                    this.tileBounds = new e1.cC(t1);
                }
                loaded() {
                    return this._loaded;
                }
                hasTile(e1) {
                    return !this.tileBounds || this.tileBounds.contains(e1.canonical);
                }
                onAdd(e1) {
                    this.map = e1, this.load();
                }
                reload() {
                    this.cancelTileJSONRequest();
                    const t1 = e1.m(this.id, this.scope);
                    this.load(()=>this.map.style.clearSource(t1));
                }
                setTiles(e1) {
                    return this._options.tiles = e1, this.reload(), this;
                }
                setUrl(e1) {
                    return this.url = e1, this._options.url = e1, this.reload(), this;
                }
                onRemove(e1) {
                    this.cancelTileJSONRequest();
                }
                serialize() {
                    return {
                        ...this._options
                    };
                }
                async loadTile(t1, i) {
                    const s = t1.tileID.canonical.url(this.tiles, this.scheme), r = this.map._requestManager.normalizeTileURL(s), o = !t1.actor || "expired" === t1.state;
                    if (!o && "loading" === t1.state) return void (t1.reloadCallback = i);
                    o && (t1.actor = this._tileWorkers[r] = this._tileWorkers[r] || this.dispatcher.getActor());
                    const n = new AbortController;
                    t1.request = n;
                    try {
                        const a = await this.map._requestManager.transformRequest(r, e1.R.Tile, n.signal);
                        if (n.signal.aborted) return i(null);
                        this.dispatchTile(t1, r, s, a, n, o, i);
                    } catch (e1) {
                        if (n.signal.aborted) return i(null);
                        i(e1);
                    }
                }
                dispatchTile(t1, i, s, r, o, n, a) {
                    const l = this.map.style ? this.map.style.getLut(this.scope) : null, c = l ? {
                        image: l.image.clone()
                    } : null, h = !(!this.map.style || !this.map.style._crossSourceElevationActive), d = !(!this.map.style || !h), u = {
                        request: r,
                        data: void 0,
                        uid: t1.uid,
                        tileID: t1.tileID,
                        tileZoom: t1.tileZoom,
                        zoom: t1.tileID.overscaledZ,
                        maxZoom: this.maxzoom,
                        lut: c,
                        tileSize: this.tileSize * t1.tileID.overscaleFactor(),
                        type: this.type,
                        source: this.id,
                        scope: this.scope,
                        pixelRatio: e1.e.devicePixelRatio,
                        showCollisionBoxes: this.map.showCollisionBoxes,
                        showElevationIdDebug: !!this.map.painter && this.map.painter._debugParams.showElevationIdDebug,
                        promoteId: this.promoteId,
                        renderSourceType: t1.renderSourceType,
                        frcCoverage: (()=>{
                            const e1 = this.map.painter, i = e1 ? e1.frcCoverageFadeRange : null;
                            if (null == i) return null;
                            const s = e1 ? e1.frcCoverageSnapshot : null, r = this.map.transform.zoom < i[0], o = s ? s.getTileOrParent(t1.tileID.canonical) : null, n = t1.tileID.overscaledZ >= Math.ceil(i[1]), a = s && n ? s.getFullCoverageMask(t1.tileID.canonical) : null;
                            return {
                                frcMask: n ? a ?? null : null,
                                resolved: r || null != s,
                                polygons: o && 0 !== o.frcMask ? o.polygons : null,
                                tileZoom: o && 0 !== o.frcMask ? o.tileId.z : null,
                                sourceLayers: e1 ? e1.frcCoverageSourceLayers : [
                                    "road",
                                    "structure"
                                ]
                            };
                        })(),
                        terrainEnabled: $t(this.map.style, this.map.transform),
                        crossSourceElevationEnabled: d,
                        elevation: Xs.buildElevationRequestParams ? Xs.buildElevationRequestParams(this.map, t1, h) : null,
                        brightness: this.map.style && this.map.style.getBrightness() || 0,
                        extraShadowCaster: t1.isExtraShadowCaster,
                        tessellationStep: this.map._tessellationStep,
                        scaleFactor: this.map.getScaleFactor(),
                        worldview: this.map.getWorldview() || this.worldviewDefault,
                        indoor: this.map.getIndoorTileOptions(this.id, this.scope)
                    };
                    if (this.hasWorldviews && e1.cX(s) && (u.localizableLayerIds = this.localizableLayerIds), u.request.collectResourceTiming = this._collectResourceTiming, n) {
                        if (this.dispatcher.ready || this.provider) t1.request = t1.actor.sendCancelable("loadTile", u, {}, p.bind(this));
                        else {
                            const i = e1.cY.call({
                                deduped: this._deduped
                            }, u, (e1, i)=>{
                                t1.aborted || (e1 || !i ? p.call(this, e1) : (u.data = {
                                    rawData: i.rawData.slice(0),
                                    headers: i.headers
                                }, t1.actor && (t1.request = t1.actor.sendCancelable("loadTile", u, {}, p.bind(this)))));
                            }, !0);
                            o.signal.addEventListener("abort", i, {
                                once: !0
                            });
                        }
                    } else t1.request = t1.actor.sendCancelable("reloadTile", u, {}, p.bind(this));
                    function p(i, s) {
                        return delete t1.request, t1.aborted ? a(null) : i ? a(i) : (s && s.resourceTiming && (t1.resourceTiming = s.resourceTiming), this.map._refreshExpiredTiles && s && t1.setExpiryData(e1.cA(s.headers)), void (function() {
                            if (t1.aborted) return a(null);
                            t1.loadVectorData(s, this.map.painter), e1.cB(this.dispatcher), a(null, s), t1.reloadCallback && (this.loadTile(t1, t1.reloadCallback), t1.reloadCallback = null);
                        }).call(this));
                    }
                }
                abortTile(e1) {
                    e1.request && (e1.request.abort(), delete e1.request), e1.actor && e1.actor.notify("abortTile", {
                        uid: e1.uid,
                        type: this.type,
                        source: this.id,
                        scope: this.scope
                    });
                }
                unloadTile(e1, t1) {
                    e1.actor && e1.actor.notify("removeTile", {
                        uid: e1.uid,
                        type: this.type,
                        source: this.id,
                        scope: this.scope
                    }), e1.destroy();
                }
                hasTransition() {
                    return !1;
                }
                afterUpdate() {
                    this._tileWorkers = {};
                }
                cancelTileJSONRequest() {
                    this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
                }
            },
            raster: yo,
            "raster-dem": class extends yo {
                constructor(e1, t1, i, s){
                    super(e1, t1, i, s), this.type = "raster-dem", this.maxzoom = 22, this._options = {
                        type: "raster-dem",
                        ...t1
                    }, this.encoding = t1.encoding || "mapbox";
                }
                loadTileJSONWithProvider(t1, i) {
                    this.provider = t1.name;
                    const s = new AbortController;
                    return (async ()=>{
                        const { request: r, options: o } = await e1.cE(this._options, this.map._requestManager, s.signal);
                        if (s.signal.aborted) return;
                        const n = await this.dispatcher.send("loadTileProvider", {
                            name: t1.name,
                            url: t1.url,
                            source: this.id,
                            scope: this.scope,
                            type: this.type,
                            options: o,
                            request: r
                        }, {
                            signal: s.signal
                        });
                        if (s.signal.aborted) return;
                        const a = n ? n.find((e1)=>null != e1) : null, l = e1.cG(this._options, a, this.map._requestManager);
                        l instanceof Error ? i(l) : i(null, l);
                    })().catch((e1)=>{
                        s.signal.aborted || i(e1);
                    }), {
                        cancel: ()=>s.abort()
                    };
                }
                async loadTile(t1, i) {
                    if (t1.actor && "expired" !== t1.state) return;
                    const s = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), !1, this.tileSize);
                    t1.actor = this.dispatcher.getActor();
                    const r = new AbortController;
                    t1.request = r;
                    try {
                        const o = await this.map._requestManager.transformRequest(s, e1.R.Tile, r.signal);
                        if (r.signal.aborted) return i(null);
                        t1.request = t1.actor.sendCancelable("loadTile", {
                            uid: t1.uid,
                            tileID: t1.tileID,
                            source: this.id,
                            type: this.type,
                            scope: this.scope,
                            request: o,
                            encoding: this.encoding
                        }, {}, (function(s, r) {
                            return delete t1.request, t1.aborted ? i(null) : s ? (t1.state = "errored", i(s)) : (r && (this.map._refreshExpiredTiles && t1.setExpiryData(e1.cA(r.headers)), r.borderReady || t1.neighboringTiles || (t1.neighboringTiles = this._getNeighboringTiles(t1.tileID)), t1.dem = r.dem, t1.dem.onDeserialize(), t1.needsHillshadePrepare = !0, t1.needsDEMTextureUpload = !0), t1.state = "loaded", void i(null));
                        }).bind(this));
                    } catch (e1) {
                        if (r.signal.aborted) return i(null);
                        t1.state = "errored", i(e1);
                    }
                }
                abortTile(e1, t1) {
                    e1.request && (e1.request.abort(), delete e1.request), e1.actor && e1.actor.notify("abortTile", {
                        uid: e1.uid,
                        type: this.type,
                        source: this.id,
                        scope: this.scope
                    }), t1 && t1();
                }
                _getNeighboringTiles(t1) {
                    const i = t1.canonical, s = Math.pow(2, i.z), r = (i.x - 1 + s) % s, o = 0 === i.x ? t1.wrap - 1 : t1.wrap, n = (i.x + 1 + s) % s, a = i.x + 1 === s ? t1.wrap + 1 : t1.wrap, l = {};
                    return l[new e1.bZ(t1.overscaledZ, o, i.z, r, i.y).key] = {
                        backfilled: !1
                    }, l[new e1.bZ(t1.overscaledZ, a, i.z, n, i.y).key] = {
                        backfilled: !1
                    }, i.y > 0 && (l[new e1.bZ(t1.overscaledZ, o, i.z, r, i.y - 1).key] = {
                        backfilled: !1
                    }, l[new e1.bZ(t1.overscaledZ, t1.wrap, i.z, i.x, i.y - 1).key] = {
                        backfilled: !1
                    }, l[new e1.bZ(t1.overscaledZ, a, i.z, n, i.y - 1).key] = {
                        backfilled: !1
                    }), i.y + 1 < s && (l[new e1.bZ(t1.overscaledZ, o, i.z, r, i.y + 1).key] = {
                        backfilled: !1
                    }, l[new e1.bZ(t1.overscaledZ, t1.wrap, i.z, i.x, i.y + 1).key] = {
                        backfilled: !1
                    }, l[new e1.bZ(t1.overscaledZ, a, i.z, n, i.y + 1).key] = {
                        backfilled: !1
                    }), l;
                }
            },
            geojson: class extends e1.E {
                constructor(t1, i, s, r){
                    super(), this.id = t1, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._loaded = !1, this.actor = s.getActor(), this.setEventedParent(r), this._data = i.data, this._options = {
                        ...i
                    }, this._collectResourceTiming = i.collectResourceTiming, void 0 !== i.maxzoom && (this.maxzoom = i.maxzoom), void 0 !== i.minzoom && (this.minzoom = i.minzoom), i.type && (this.type = i.type), i.attribution && (this.attribution = i.attribution), this.promoteId = i.promoteId;
                    const o = e1.ac / this.tileSize;
                    this.workerOptions = {
                        source: this.id,
                        scope: this.scope,
                        cluster: i.cluster || !1,
                        geojsonVtOptions: {
                            buffer: (void 0 !== i.buffer ? i.buffer : 128) * o,
                            tolerance: (void 0 !== i.tolerance ? i.tolerance : .375) * o,
                            extent: e1.ac,
                            maxZoom: this.maxzoom,
                            lineMetrics: i.lineMetrics || !1,
                            generateId: i.generateId || !1
                        },
                        superclusterOptions: {
                            maxZoom: void 0 !== i.clusterMaxZoom ? i.clusterMaxZoom : this.maxzoom - 1,
                            minPoints: Math.max(2, i.clusterMinPoints || 2),
                            extent: e1.ac,
                            radius: (void 0 !== i.clusterRadius ? i.clusterRadius : 50) * o,
                            log: !1,
                            generateId: i.generateId || !1
                        },
                        clusterProperties: i.clusterProperties,
                        filter: i.filter,
                        dynamic: i.dynamic,
                        ...i.workerOptions
                    };
                }
                onAdd(e1) {
                    this.map = e1, this.setData(this._data);
                }
                setData(e1) {
                    return this._data = e1, this._updateWorkerData(), this;
                }
                updateData(t1) {
                    if (!this._options.dynamic) return this.fire(new e1.h(new Error("Can't call updateData on a GeoJSON source with dynamic set to false.")));
                    if ("string" != typeof t1 && ("Feature" === t1.type && (t1 = {
                        type: "FeatureCollection",
                        features: [
                            t1
                        ]
                    }), "FeatureCollection" !== t1.type)) return this.fire(new e1.h(new Error("Data to update should be a feature or a feature collection.")));
                    if (this._coalesce && "string" != typeof t1 && "string" != typeof this._data && "FeatureCollection" === this._data.type) {
                        const e1 = new Map;
                        for (const t1 of this._data.features)e1.set(t1.id, t1);
                        for (const i of t1.features)e1.set(i.id, i);
                        this._data.features = [
                            ...e1.values()
                        ];
                    } else this._data = t1;
                    return this._updateWorkerData(!0), this;
                }
                getClusterExpansionZoom(e1, t1) {
                    return this.actor.send("geojson.getClusterExpansionZoom", {
                        clusterId: e1,
                        source: this.id,
                        scope: this.scope
                    }).then((e1)=>t1(null, e1)).catch((e1)=>t1(e1)), this;
                }
                getClusterChildren(e1, t1) {
                    return this.actor.send("geojson.getClusterChildren", {
                        clusterId: e1,
                        source: this.id,
                        scope: this.scope
                    }).then((e1)=>t1(null, e1)).catch((e1)=>t1(e1)), this;
                }
                getClusterLeaves(e1, t1, i, s) {
                    return this.actor.send("geojson.getClusterLeaves", {
                        source: this.id,
                        scope: this.scope,
                        clusterId: e1,
                        limit: t1,
                        offset: i
                    }).then((e1)=>s(null, e1)).catch((e1)=>s(e1)), this;
                }
                async _updateWorkerData(t1 = !1) {
                    if (this._pendingLoad) return void (this._coalesce = !0);
                    this.fire(new e1.i("dataloading", {
                        dataType: "source"
                    })), this._loaded = !1;
                    const i = {
                        append: t1,
                        ...this.workerOptions
                    };
                    i.scope = this.scope;
                    const s = this._data, r = new AbortController;
                    this._pendingLoad = r;
                    try {
                        if ("string" == typeof s) {
                            if (i.request = await this.map._requestManager.transformRequest(e1.e.resolveURL(s), e1.R.Source, r.signal), r.signal.aborted) return this._pendingLoad = null, void (this._coalesce = !1);
                            i.request.collectResourceTiming = this._collectResourceTiming;
                        } else i.data = JSON.stringify(s);
                        const o = await this.actor.send(`${this.type}.loadData`, i, {
                            signal: r.signal
                        });
                        this._loaded = !0, this._pendingLoad = null;
                        const n = {
                            dataType: "source",
                            sourceDataType: this._metadataFired ? "content" : "metadata"
                        };
                        this._collectResourceTiming && o && o.resourceTiming && o.resourceTiming[this.id] && (n.resourceTiming = o.resourceTiming[this.id]), t1 && (this._partialReload = !0), this.fire(new e1.i("data", n)), this._partialReload = !1, this._metadataFired = !0;
                    } catch (t1) {
                        if (r.signal.aborted) return this._pendingLoad = null, void (this._coalesce = !1);
                        this._loaded = !0, this._pendingLoad = null, this.fire(new e1.h(t1));
                    }
                    this._coalesce && (this._updateWorkerData(t1), this._coalesce = !1);
                }
                loaded() {
                    return this._loaded;
                }
                reload() {
                    const t1 = e1.m(this.id, this.scope);
                    this.map.style.clearSource(t1), this._updateWorkerData();
                }
                loadTile(t1, i) {
                    const s = t1.actor ? "reloadTile" : "loadTile";
                    t1.actor = this.actor;
                    const r = this.map.style ? this.map.style.getLut(this.scope) : null, o = r ? {
                        image: r.image.clone()
                    } : null, n = this._partialReload, a = {
                        type: this.type,
                        uid: t1.uid,
                        tileID: t1.tileID,
                        tileZoom: t1.tileZoom,
                        zoom: t1.tileID.overscaledZ,
                        maxZoom: this.maxzoom,
                        tileSize: this.tileSize,
                        source: this.id,
                        lut: o,
                        scope: this.scope,
                        pixelRatio: e1.e.devicePixelRatio,
                        showCollisionBoxes: this.map.showCollisionBoxes,
                        showElevationIdDebug: !!this.map.painter && this.map.painter._debugParams.showElevationIdDebug,
                        promoteId: this.promoteId,
                        brightness: this.map.style && this.map.style.getBrightness() || 0,
                        extraShadowCaster: t1.isExtraShadowCaster,
                        scaleFactor: this.map.getScaleFactor(),
                        partial: n,
                        worldview: this.map.getWorldview(),
                        indoor: this.map.getIndoorTileOptions(this.id, this.scope)
                    };
                    t1.request = this.actor.sendCancelable(s, a, {}, (e1, r)=>n && !r ? (t1.state = "loaded", i(null)) : (delete t1.request, t1.destroy(!1), t1.aborted ? i(null) : e1 ? i(e1) : (t1.loadVectorData(r, this.map.painter, "reloadTile" === s), void i(null))));
                }
                abortTile(e1) {
                    e1.request && (e1.request.abort(), delete e1.request), e1.aborted = !0;
                }
                unloadTile(e1, t1) {
                    this.actor.notify("removeTile", {
                        uid: e1.uid,
                        type: this.type,
                        source: this.id,
                        scope: this.scope
                    }), e1.destroy();
                }
                onRemove(e1) {
                    this._pendingLoad && this._pendingLoad.abort();
                }
                serialize() {
                    return {
                        ...this._options,
                        type: this.type,
                        data: this._data
                    };
                }
                hasTransition() {
                    return !1;
                }
            },
            video: class extends Uo {
                constructor(e1, t1, i, s){
                    super(e1, t1, i, s), this.roundZoom = !0, this.type = "video", this.options = t1;
                }
                async load() {
                    this._loaded = !1;
                    const t1 = this.options, i = new AbortController;
                    this._imageRequest = i;
                    try {
                        const s = await Promise.all(t1.urls.map(async (t1)=>(await this.map._requestManager.transformRequest(t1, e1.R.Source, i.signal)).url));
                        if (i.signal.aborted) return;
                        this.urls = s;
                        const r = await e1.d5(s);
                        if (i.signal.aborted) return;
                        this._imageRequest = null, this.video = r, this.video.loop = !0, this.video.setAttribute("playsinline", ""), this.video.addEventListener("playing", ()=>{
                            this.map.triggerRepaint();
                        }), this.map && this.video.play(), this._finishLoading();
                    } catch (t1) {
                        if (i.signal.aborted) return;
                        this.fire(new e1.h(t1));
                    } finally{
                        this._loaded = !0;
                    }
                }
                pause() {
                    this.video && this.video.pause();
                }
                play() {
                    this.video && this.video.play();
                }
                seek(t1) {
                    if (this.video) {
                        const i = this.video.seekable;
                        t1 < i.start(0) || t1 > i.end(0) ? this.fire(new e1.h(new de(`sources.${this.id}`, null, `Playback for this video can be set only between the ${i.start(0)} and ${i.end(0)}-second mark.`))) : this.video.currentTime = t1;
                    }
                }
                getVideo() {
                    return this.video;
                }
                onAdd(e1) {
                    this.map || (this.map = e1, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
                }
                prepare() {
                    if (0 === Object.keys(this.tiles).length || this.video.readyState < 2) return;
                    const t1 = this.map.painter.context, i = t1.gl;
                    this.texture ? this.video.paused || (this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), i.texSubImage2D(i.TEXTURE_2D, 0, 0, 0, i.RGBA, i.UNSIGNED_BYTE, this.video)) : (this.texture = new e1.T(t1, this.video, i.RGBA8), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), this.width = this.video.videoWidth, this.height = this.video.videoHeight), this._prepareData(t1);
                }
                serialize() {
                    return {
                        type: "video",
                        urls: this.options.urls,
                        coordinates: this.coordinates
                    };
                }
                hasTransition() {
                    return this.video && !this.video.paused;
                }
            },
            image: Uo,
            canvas: class extends Uo {
                constructor(t1, i, s, r){
                    super(t1, i, s, r), i.coordinates ? Array.isArray(i.coordinates) && 4 === i.coordinates.length && !i.coordinates.some((e1)=>!Array.isArray(e1) || 2 !== e1.length || e1.some((e1)=>"number" != typeof e1)) || this.fire(new e1.h(new de(`sources.${t1}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new e1.h(new de(`sources.${t1}`, null, 'missing required property "coordinates"'))), i.animate && "boolean" != typeof i.animate && this.fire(new e1.h(new de(`sources.${t1}`, null, 'optional "animate" property must be a boolean value'))), i.canvas ? "string" == typeof i.canvas || i.canvas instanceof HTMLCanvasElement || this.fire(new e1.h(new de(`sources.${t1}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new e1.h(new de(`sources.${t1}`, null, 'missing required property "canvas"'))), this.options = i, this.animate = void 0 === i.animate || i.animate;
                }
                async load() {
                    this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new e1.h(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                        this._playing = !0, this.map.triggerRepaint();
                    }, this.pause = function() {
                        this._playing && (this.prepare(), this._playing = !1);
                    }, this._finishLoading());
                }
                getCanvas() {
                    return this.canvas;
                }
                onAdd(e1) {
                    this.map = e1, this.load(), this.canvas && this.animate && this.play();
                }
                onRemove(e1) {
                    this.pause();
                }
                prepare() {
                    let t1 = !1;
                    if (this.canvas.width !== this.width && (this.width = this.canvas.width, t1 = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, t1 = !0), this._hasInvalidDimensions()) return;
                    if (0 === Object.keys(this.tiles).length) return;
                    const i = this.map.painter.context;
                    this.texture ? !t1 && !this._playing || this.texture instanceof e1.cZ || this.texture.update(this.canvas, {
                        premultiply: !0
                    }) : this.texture = new e1.T(i, this.canvas, i.gl.RGBA8, {
                        premultiply: !0
                    }), this._prepareData(i);
                }
                serialize() {
                    return {
                        type: "canvas",
                        coordinates: this.coordinates
                    };
                }
                hasTransition() {
                    return this._playing;
                }
                _hasInvalidDimensions() {
                    for (const e1 of [
                        this.canvas.width,
                        this.canvas.height
                    ])if (isNaN(e1) || e1 <= 0) return !0;
                    return !1;
                }
            },
            custom: class extends e1.E {
                constructor(t1, i, s, r){
                    super(), this.id = t1, this.type = "custom", this._dataType = "raster", this._dispatcher = s, this._implementation = i, this.setEventedParent(r), this.scheme = "xyz", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this._loaded = !1, this.roundZoom = !0, this._implementation || this.fire(new e1.h(new Error(`Missing implementation for ${this.id} custom source`))), this._implementation.loadTile || this.fire(new e1.h(new Error(`Missing loadTile implementation for ${this.id} custom source`)));
                    const o = i;
                    o.update = this._update.bind(this), o.clearTiles = this._clearTiles.bind(this), o.coveringTiles = this._coveringTiles.bind(this), Object.assign(this, e1.cx(i, [
                        "dataType",
                        "scheme",
                        "minzoom",
                        "maxzoom",
                        "tileSize",
                        "attribution",
                        "minTileCacheSize",
                        "maxTileCacheSize"
                    ])), this._implementation.bounds && (this.tileBounds = new e1.cC({
                        bounds: this._implementation.bounds,
                        minzoom: this.minzoom,
                        maxzoom: this.maxzoom
                    }));
                }
                serialize() {
                    return e1.cx(this, [
                        "type",
                        "scheme",
                        "minzoom",
                        "maxzoom",
                        "tileSize",
                        "attribution"
                    ]);
                }
                load() {
                    this._loaded = !0, this.fire(new e1.i("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new e1.i("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }));
                }
                loaded() {
                    return this._loaded;
                }
                onAdd(t1) {
                    this.map = t1, this._loaded = !1, this.fire(new e1.i("dataloading", {
                        dataType: "source"
                    })), this._implementation.onAdd && this._implementation.onAdd(t1), this.load();
                }
                onRemove(e1) {
                    this._implementation.onRemove && this._implementation.onRemove(e1);
                }
                hasTile(e1) {
                    if (this._implementation.hasTile) {
                        const { x: t1, y: i, z: s } = e1.canonical;
                        return this._implementation.hasTile({
                            x: t1,
                            y: i,
                            z: s
                        });
                    }
                    return !this.tileBounds || this.tileBounds.contains(e1.canonical);
                }
                async loadTile(e1, t1) {
                    const { x: i, y: s, z: r } = e1.tileID.canonical, o = new AbortController;
                    e1.request = o;
                    try {
                        const n = await this._implementation.loadTile({
                            x: i,
                            y: s,
                            z: r
                        }, {
                            signal: o.signal
                        });
                        if (delete e1.request, e1.aborted) return e1.state = "unloaded", t1(null);
                        if (void 0 === n) return e1.state = "errored", t1(null);
                        if (null === n) return this.loadTileData(e1, {
                            width: this.tileSize,
                            height: this.tileSize,
                            data: null
                        }), e1.state = "loaded", t1(null);
                        if (!function(e1) {
                            return e1 instanceof ImageData || e1 instanceof HTMLCanvasElement || e1 instanceof ImageBitmap || e1 instanceof HTMLImageElement;
                        }(n)) return e1.state = "errored", t1(new Error(`Can't infer data type for ${this.id}, only raster data supported at the moment`));
                        this.loadTileData(e1, n), e1.state = "loaded", t1(null);
                    } catch (i) {
                        if (o.signal.aborted) return;
                        e1.state = "errored", t1(i);
                    }
                }
                loadTileData(e1, t1) {
                    e1.setTexture(t1, this.map.painter);
                }
                unloadTile(t1, i) {
                    if (t1.texture && t1.texture instanceof e1.T ? (t1.destroy(!1), t1.texture && t1.texture instanceof e1.T && this.map.painter.saveTileTexture(t1.texture)) : t1.destroy(), this._implementation.unloadTile) {
                        const { x: e1, y: i, z: s } = t1.tileID.canonical;
                        this._implementation.unloadTile({
                            x: e1,
                            y: i,
                            z: s
                        });
                    }
                    i && i();
                }
                abortTile(e1, t1) {
                    e1.request && (e1.request.abort(), delete e1.request), t1 && t1();
                }
                hasTransition() {
                    return !1;
                }
                _coveringTiles() {
                    return this.map.transform.coveringTiles({
                        tileSize: this.tileSize,
                        minzoom: this.minzoom,
                        maxzoom: this.maxzoom,
                        roundZoom: this.roundZoom
                    }).map((e1)=>({
                            x: e1.canonical.x,
                            y: e1.canonical.y,
                            z: e1.canonical.z
                        }));
                }
                _clearTiles() {
                    const t1 = e1.m(this.id, this.scope);
                    this.map.style.clearSource(t1);
                }
                _update() {
                    this.fire(new e1.i("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }));
                }
            }
        }, jo = function(t1, i, s, r) {
            const o = Vo(i.type);
            if (!o) throw new Error(`Unknown source type "${i.type}"`);
            const n = new o(t1, i, s, r);
            if (n.id !== t1) throw new Error(`Expected Source id to be ${t1} instead of ${n.id}`);
            return e1.b4([
                "load",
                "abort",
                "unload",
                "serialize",
                "prepare"
            ], n), n;
        }, Vo = function(e1) {
            return Object.hasOwn(No, e1) ? No[e1] : void 0;
        }, Go = {
            model: ()=>ui().then(()=>di.ModelSource),
            "batched-model": ()=>ui().then(()=>di.Tiled3dModelSource),
            "raster-array": ()=>Ro().then(()=>Lo.RasterArrayTileSource)
        };
        function qo(e1, t1, i = "") {
            return `${i}:${t1.id || ""}:${t1.layer.id}:${function(e1) {
                if ("layerId" in e1) return `layer:${e1.layerId}`;
                {
                    const { featuresetId: t1, importId: i } = e1;
                    return `featureset:${t1}${i ? `:import:${i}` : ""}`;
                }
            }(e1.target)}`;
        }
        function $o(e1, t1, i, s = "") {
            if (e1.uniqueFeatureID) {
                const r = qo(e1, t1, s);
                if (i.has(r)) return !0;
                i.add(r);
            }
            return !1;
        }
        function Zo(e1, t1, i, s, r = !1, o) {
            const n = t1.sourceCache.transform, a = t1.sourceCache.tilesIn(e1, t1.has3DLayers, r);
            a.sort(Xo);
            const l = [];
            for (const e1 of a){
                const a = e1.tile.queryRenderedFeatures(t1, e1, i, s, n, r, o);
                Object.keys(a).length && l.push({
                    wrappedTileID: e1.tile.tileID.wrapped().key,
                    queryResults: a
                });
            }
            for(const i in t1.layers){
                const r = t1.layers[i];
                if (r.styleLayer) {
                    const i = r.styleLayer.queryRenderedFeatures(e1, t1.sourceCache, s);
                    Object.keys(i).length && l.push({
                        wrappedTileID: 0,
                        queryResults: i
                    });
                }
            }
            return 0 === l.length ? {} : function(e1) {
                const t1 = {}, i = {};
                for (const s of e1){
                    const e1 = s.queryResults, r = s.wrappedTileID, o = i[r] = i[r] || {};
                    for(const i in e1){
                        const s = e1[i], r = o[i] = o[i] || {}, n = t1[i] = t1[i] || [];
                        for (const e1 of s)r[e1.featureIndex] || (r[e1.featureIndex] = !0, n.push(e1));
                    }
                }
                return t1;
            }(l);
        }
        function Wo(e1, t1, i, s, r, o) {
            const n = {}, a = s.queryRenderedSymbols(e1), l = [];
            for (const e1 of Object.keys(a).map(Number))l.push(r[e1]);
            l.sort(Xo);
            for (const e1 of l){
                const s = e1.featureIndex.lookupSymbolFeatures(a[e1.bucketInstanceId], e1.bucketIndex, e1.sourceLayerIndex, t1, i, o);
                for(const t1 in s){
                    const i = n[t1] = n[t1] || [], r = s[t1];
                    r.sort((t1, i)=>{
                        const s = e1.featureSortOrder;
                        if (s) {
                            const e1 = s.indexOf(t1.featureIndex);
                            return s.indexOf(i.featureIndex) - e1;
                        }
                        return i.featureIndex - t1.featureIndex;
                    });
                    for (const e1 of r)i.push(e1);
                }
            }
            return n;
        }
        function Ho(e1, t1) {
            const i = e1.getRenderableIds().map((t1)=>e1.getTileByID(t1)), s = [], r = {};
            for(let e1 = 0; e1 < i.length; e1++){
                const o = i[e1], n = o.tileID.canonical.key;
                r[n] || (r[n] = !0, o.querySourceFeatures(s, t1));
            }
            return s;
        }
        function Xo(e1, t1) {
            const i = e1.tileID, s = t1.tileID;
            return i.overscaledZ - s.overscaledZ || i.canonical.y - s.canonical.y || i.wrap - s.wrap || i.canonical.x - s.canonical.x;
        }
        class Yo {
            constructor(e1){
                this.style = e1, this.layersGotHidden = !1, this.layers = [];
            }
            processLayersChanged() {
                this.layers = [];
                const e1 = !1, t1 = !1;
                for(const i in this.style._mergedLayers){
                    const s = this.style._mergedLayers[i];
                    if ("fill-extrusion" === s.type || "building" === s.type) this.layers.push({
                        layer: s,
                        visible: e1,
                        visibilityChanged: t1
                    });
                    else if ("model" === s.type) {
                        const i = this.style.getLayerSource(s);
                        i && "batched-model" === i.type && this.layers.push({
                            layer: s,
                            visible: e1,
                            visibilityChanged: t1
                        });
                    }
                }
            }
            onNewFrame(e1) {
                this.layersGotHidden = !1;
                for (const t1 of this.layers){
                    const i = t1.layer;
                    let s = !1;
                    "fill-extrusion" === i.type ? s = !i.isHidden(e1) && i.paint.get("fill-extrusion-opacity") > 0 : "building" === i.type ? s = !i.isHidden(e1) && i.paint.get("building-opacity") > 0 : "model" === i.type && (s = !i.isHidden(e1) && i.paint.get("model-opacity").constantOr(1) > 0), this.layersGotHidden = this.layersGotHidden || !s && t1.visible, t1.visible = s;
                }
            }
            updateZOffset(e1, t1) {
                this.currentBuildingBuckets = [];
                for (const e1 of this.layers){
                    const i = e1.layer, s = this.style.getLayerSourceCache(i);
                    let r = 1;
                    "fill-extrusion" === i.type ? r = e1.visible ? i.paint.get("fill-extrusion-vertical-scale") : 0 : "building" === i.type && (r = e1.visible ? i.paint.get("building-vertical-scale") : 0);
                    let o = s ? s.getTile(t1) : null;
                    if (!o && s) {
                        for (const e1 of s._tiles.values())if (t1.canonical.isChildOf(e1.tileID.canonical)) {
                            o = e1;
                            break;
                        }
                    }
                    this.currentBuildingBuckets.push({
                        bucket: o ? o.getBucket(i) : null,
                        tileID: o ? o.tileID : t1,
                        verticalScale: r
                    });
                }
                e1.hasAnyZOffset = !1;
                let i = !1;
                for(let s = 0; s < e1.symbolInstances.length; s++){
                    const r = e1.symbolInstances.get(s), o = r.zOffset, n = this._getHeightAtTileOffset(t1, r.tileAnchorX, r.tileAnchorY);
                    r.zOffset = n !== Number.NEGATIVE_INFINITY ? n : o, i || o === r.zOffset || (i = !0), e1.hasAnyZOffset || 0 === r.zOffset || (e1.hasAnyZOffset = !0);
                }
                i && (e1.zOffsetBuffersNeedUpload = !0, e1.zOffsetSortDirty = !0);
            }
            hasLayerForSourceCache(e1) {
                for (const { layer: t1 } of this.layers){
                    const i = this.style.getLayerSourceCache(t1);
                    if (i && i.id === e1) return !0;
                }
                return !1;
            }
            _mapCoordToOverlappingTile(t1, i, s, r) {
                let o = i, n = s;
                if (t1.canonical.z !== r.canonical.z) {
                    const a = r.canonical, l = 1 / (1 << t1.canonical.z - a.z);
                    o = (i + t1.canonical.x * e1.ac) * l - a.x * e1.ac | 0, n = (s + t1.canonical.y * e1.ac) * l - a.y * e1.ac | 0;
                }
                return {
                    tileX: o,
                    tileY: n
                };
            }
            _getHeightAtTileOffset(e1, t1, i) {
                let s, r;
                for(let o = 0; o < this.layers.length; ++o){
                    const n = this.layers[o].layer;
                    if ("fill-extrusion" !== n.type && "building" !== n.type) continue;
                    const { bucket: a, tileID: l, verticalScale: c } = this.currentBuildingBuckets[o];
                    if (!a) continue;
                    const { tileX: h, tileY: d } = this._mapCoordToOverlappingTile(e1, t1, i, l), u = a.getHeightAtTileCoord(h, d);
                    u && void 0 !== u.height && (u.hidden ? s = u.height : r = Math.max(u.height * c, r || 0));
                }
                if (void 0 !== r) return r;
                for(let r = 0; r < this.layers.length; ++r){
                    const o = this.layers[r];
                    if ("model" !== o.layer.type || !o.visible) continue;
                    const { bucket: n, tileID: a } = this.currentBuildingBuckets[r];
                    if (!n) continue;
                    const { tileX: l, tileY: c } = this._mapCoordToOverlappingTile(e1, t1, i, a), h = n.getHeightAtTileCoord(l, c);
                    if (h && !h.hidden) return void 0 === h.height && void 0 !== s ? Math.min(h.maxHeight, s) * h.verticalScale : h.height ? h.height * h.verticalScale : Number.NEGATIVE_INFINITY;
                }
                return this.layersGotHidden ? 0 : Number.NEGATIVE_INFINITY;
            }
        }
        let Ko;
        function Qo() {
            return Ko || (Ko = new ti), Ko;
        }
        function Jo(t1, i) {
            const s = {}, r = t1, o = i, n = s;
            for(const e1 in r)"ref" !== e1 && (n[e1] = r[e1]);
            return e1.d6.forEach((e1)=>{
                e1 in o && (n[e1] = o[e1]);
            }), s;
        }
        function en(e1) {
            e1 = e1.slice();
            const t1 = Object.create(null);
            for (const i of e1)t1[i.id] = i;
            for(let i = 0; i < e1.length; i++){
                const s = e1[i];
                if (s && "ref" in s) {
                    const r = t1[s.ref];
                    r && (e1[i] = Jo(s, r));
                }
            }
            return e1;
        }
        class tn {
            constructor(e1, t1){
                this.reset(e1, t1);
            }
            reset(e1, t1) {
                this.points = e1 || [], this._distances = [
                    0
                ];
                for(let e1 = 1; e1 < this.points.length; e1++)this._distances[e1] = this._distances[e1 - 1] + this.points[e1].dist(this.points[e1 - 1]);
                this.length = this._distances.at(-1), this.padding = Math.min(t1 || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
            }
            lerp(t1) {
                if (1 === this.points.length) return this.points[0];
                t1 = e1.bb(t1, 0, 1);
                let i = 1, s = this._distances[i];
                const r = t1 * this.paddedLength + this.padding;
                for(; s < r && i < this._distances.length;)s = this._distances[++i];
                const o = i - 1, n = this._distances[o], a = s - n, l = a > 0 ? (r - n) / a : 0;
                return this.points[o].mult(1 - l).add(this.points[i].mult(l));
            }
        }
        const sn = 100;
        class rn {
            constructor(e1, t1){
                this.gridRightBoundary = 0, this.gridBottomBoundary = 0, this.clippedSymbols = new Map, this.reset(e1, t1);
            }
            reset(t1, i) {
                const s = t1.width + 200, r = t1.height + 200;
                s !== this.gridRightBoundary || r !== this.gridBottomBoundary ? (this.grid = new e1.d7(s, r, 25), this.ignoredGrid = new e1.d7(s, r, 25)) : (this.grid.clear(), this.ignoredGrid.clear()), this.transform = t1, this.fogState = i, this.pitchfactor = Math.cos(t1._pitch) * t1.cameraToCenterDistance, this.screenRightBoundary = t1.width + sn, this.screenBottomBoundary = t1.height + sn, this.gridRightBoundary = s, this.gridBottomBoundary = r, this.clippedSymbols.clear();
            }
            clearClippedSymbolsForBucket(e1) {
                this.clippedSymbols.delete(e1);
            }
            markSymbolAsClipped(e1, t1) {
                let i = this.clippedSymbols.get(e1);
                i || (i = new Set, this.clippedSymbols.set(e1, i)), i.add(t1);
            }
            placeCollisionBox(t1, i, s, r, o, n, a, l, c, h, d) {
                let u = s.projectedAnchorX, p = s.projectedAnchorY, f = s.projectedAnchorZ;
                const m = s.tileAnchorX, _ = s.tileAnchorY, g = s.elevation, y = s.tileID, v = t1.getProjection();
                if (g && y) {
                    const [e1, t1, i] = v.upVector(y.canonical, s.tileAnchorX, s.tileAnchorY), r = v.upVectorScale(y.canonical, this.transform.center.lat, this.transform.worldSize).metersToTile;
                    u += e1 * g * r, p += t1 * g * r, f += i * g * r;
                }
                const b = "globe" === t1.projection.name, x = "globe" === t1.projection.name ? e1._(this.transform.zoom) : 0;
                if (y && b && x < 1 && !n) {
                    const t1 = 1 << y.canonical.z, i = e1.d8(m, _);
                    e1.d9(i, i, 1 / e1.ac), e1.da(i, i, e1.d8(y.canonical.x, y.canonical.y)), e1.d9(i, i, 1 / t1), e1.db(i, i, e1.d8(r[0], r[1])), i[0] = e1.dc(i[0], -0.5, .5), e1.d9(i, i, e1.ac);
                    const s = e1.dd(i[0], i[1], e1.ac / (2 * Math.PI), 1);
                    e1.cd(s, s, o), u = e1.aw(u, s[0], x), p = e1.aw(p, s[1], x), f = e1.aw(f, s[2], x);
                }
                const w = this.projectAndGetPerspectiveRatio(h, u, p, f, s.tileID, "globe" === v.name || !!g || this.transform.pitch > 0, v), T = c * w.perspectiveRatio, S = (s.x1 * i + a.x - s.padding) * T + w.point.x, C = (s.y1 * i + a.y - s.padding) * T + w.point.y, E = (s.x2 * i + a.x + s.padding) * T + w.point.x, I = (s.y2 * i + a.y + s.padding) * T + w.point.y, D = w.perspectiveRatio <= e1.de || w.occluded;
                return !this.isInsideGrid(S, C, E, I) || !l && this.grid.hitTest(S, C, E, I, d) || D ? {
                    box: [],
                    offscreen: !1,
                    occluded: w.occluded
                } : {
                    box: [
                        S,
                        C,
                        E,
                        I
                    ],
                    offscreen: this.isOffscreen(S, C, E, I),
                    occluded: !1
                };
            }
            placeCollisionCircles(t1, i, s, r, o, n, a, l, c, h, d, u, p, f, m, _) {
                const g = [], y = this.transform.elevation, v = t1.getProjection(), b = "road" === t1.elevationType, x = !!y || b, w = e1.c8.getAtTileOffsetFunc(_, this.transform.center.lat, this.transform.worldSize, v), T = new e1.P(s.tileAnchorX, s.tileAnchorY), S = new e1.P(s.tileAnchorX, s.tileAnchorY);
                let { x: C, y: E, z: I } = v.projectTilePoint(S.x, S.y, _.canonical), D = null;
                if (x) {
                    D = b && t1.hdExt ? t1.hdExt.makeRoadSymbolElevationParams(t1, t1.text, r, _, w, y, v, this.transform.center.lat, this.transform.worldSize) : {
                        getElevation: w,
                        elevation: y,
                        elevationFeature: null
                    };
                    const [e1, i, s] = D.getElevation(T, y, D.elevationFeature);
                    C += e1, E += i, I += s;
                }
                const P = "globe" === v.name, L = this.projectAndGetPerspectiveRatio(l, C, E, I, _, P || !!y || this.transform.pitch > 0, v), { perspectiveRatio: R } = L, A = (u ? a / R : a * R) / e1.dl, M = e1.df(C, E, I, c), F = s.lineOffsetX * A, O = s.lineOffsetY * A, k = e1.aF(t1.layers[0].layout.get("text-max-angle")), B = Math.cos(k), z = L.signedDistanceFromCamera > 0 ? e1.dg(A, n, F, O, b && 1 === s.flipState, M, S, s, o, c, {}, x && !u ? D : null, u && x, v, _, u, B) : null;
                let U = !1, N = !1, j = !0;
                if (z && !L.occluded) {
                    const t1 = .5 * f * R + m, s = new e1.P(-100, -100), r = new e1.P(this.screenRightBoundary, this.screenBottomBoundary), o = new tn, { first: n, last: a } = z, l = n.path.length;
                    let c = [];
                    for(let e1 = l - 1; e1 >= 1; e1--)c.push(n.path[e1]);
                    for(let e1 = 1; e1 < a.path.length; e1++)c.push(a.path[e1]);
                    const u = 2.5 * t1;
                    h && (c = c.map(([t1, i, s], r)=>(x && !P && (s = D.getElevation(r < l - 1 ? n.tilePath[l - 1 - r] : a.tilePath[r - l + 2], y, D.elevationFeature)[2]), e1.df(t1, i, s, h))), c.some((e1)=>e1[3] <= 0) && (c = []));
                    let _ = [];
                    if (c.length > 0) {
                        let t1 = 1 / 0, i = -1 / 0, o = 1 / 0, n = -1 / 0;
                        for (const e1 of c)t1 = Math.min(t1, e1[0]), o = Math.min(o, e1[1]), i = Math.max(i, e1[0]), n = Math.max(n, e1[1]);
                        i >= s.x && t1 <= r.x && n >= s.y && o <= r.y && (_ = [
                            c.map((t1)=>new e1.P(t1[0], t1[1]))
                        ], (t1 < s.x || i > r.x || o < s.y || n > r.y) && (_ = e1.dh(_, s.x, s.y, r.x, r.y)));
                    }
                    for (const e1 of _){
                        o.reset(e1, .25 * t1);
                        let s = 0;
                        s = o.length <= .5 * t1 ? 1 : Math.ceil(o.paddedLength / u) + 1;
                        for(let e1 = 0; e1 < s; e1++){
                            const r = e1 / Math.max(s - 1, 1), n = o.lerp(r), a = n.x + sn, l = n.y + sn;
                            g.push(a, l, t1, 0);
                            const c = a - t1, h = l - t1, u = a + t1, f = l + t1;
                            if (j = j && this.isOffscreen(c, h, u, f), N = N || this.isInsideGrid(c, h, u, f), !i && this.grid.hitTestCircle(a, l, t1, p) && (U = !0, !d)) return {
                                circles: [],
                                offscreen: !1,
                                collisionDetected: U,
                                occluded: !1
                            };
                        }
                    }
                }
                return {
                    circles: !d && U || !N ? [] : g,
                    offscreen: j,
                    collisionDetected: U,
                    occluded: L.occluded
                };
            }
            queryRenderedSymbols(t1) {
                if (0 === t1.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
                const i = [];
                let s = 1 / 0, r = 1 / 0, o = -1 / 0, n = -1 / 0;
                for (const a of t1){
                    const t1 = new e1.P(a.x + sn, a.y + sn);
                    s = Math.min(s, t1.x), r = Math.min(r, t1.y), o = Math.max(o, t1.x), n = Math.max(n, t1.y), i.push(t1);
                }
                const a = this.grid.query(s, r, o, n).concat(this.ignoredGrid.query(s, r, o, n)), l = {}, c = {};
                for (const t1 of a){
                    const s = t1.key;
                    if (void 0 === l[s.bucketInstanceId] && (l[s.bucketInstanceId] = {}), l[s.bucketInstanceId][s.featureIndex]) continue;
                    const r = this.clippedSymbols.get(s.bucketInstanceId);
                    if (r && r.has(s.featureIndex)) continue;
                    const o = [
                        new e1.P(t1.x1, t1.y1),
                        new e1.P(t1.x2, t1.y1),
                        new e1.P(t1.x2, t1.y2),
                        new e1.P(t1.x1, t1.y2)
                    ];
                    e1.b2(i, o) && (l[s.bucketInstanceId][s.featureIndex] = !0, void 0 === c[s.bucketInstanceId] && (c[s.bucketInstanceId] = []), c[s.bucketInstanceId].push(s.featureIndex));
                }
                return c;
            }
            insertCollisionBox(e1, t1, i, s, r) {
                (t1 ? this.ignoredGrid : this.grid).insert({
                    bucketInstanceId: i,
                    featureIndex: s,
                    collisionGroupID: r
                }, e1[0], e1[1], e1[2], e1[3]);
            }
            insertCollisionCircles(e1, t1, i, s, r) {
                const o = t1 ? this.ignoredGrid : this.grid, n = {
                    bucketInstanceId: i,
                    featureIndex: s,
                    collisionGroupID: r
                };
                for(let t1 = 0; t1 < e1.length; t1 += 4)o.insertCircle(n, e1[t1], e1[t1 + 1], e1[t1 + 2]);
            }
            projectAndGetPerspectiveRatio(t1, i, s, r, o, n, a) {
                const l = [
                    i,
                    s,
                    r,
                    1
                ];
                let c = !1;
                r || this.transform.pitch > 0 ? (e1.cd(l, l, t1), this.fogState && o && "globe" !== a.name && (c = e1.di(this.fogState, i, s, r, o.toUnwrapped(), this.transform) > e1.dm)) : e1.dj(l, l, t1);
                const h = l[3];
                return {
                    point: new e1.P((l[0] / h + 1) / 2 * this.transform.width + sn, (-l[1] / h + 1) / 2 * this.transform.height + sn),
                    perspectiveRatio: Math.min(.5 + this.transform.getCameraToCenterDistance(a) / h * .5, 1.5),
                    signedDistanceFromCamera: h,
                    occluded: n && l[2] > h || c
                };
            }
            isOffscreen(e1, t1, i, s) {
                return i < sn || e1 >= this.screenRightBoundary || s < sn || t1 > this.screenBottomBoundary;
            }
            isInsideGrid(e1, t1, i, s) {
                return i >= 0 && e1 < this.gridRightBoundary && s >= 0 && t1 < this.gridBottomBoundary;
            }
            getViewportMatrix() {
                const t1 = e1.dk([]);
                return e1.bX(t1, t1, [
                    -100,
                    -100,
                    0
                ]), t1;
            }
        }
        class on {
            constructor(e1, t1, i, s){
                this.opacity = e1 ? Math.max(0, Math.min(1, e1.opacity + (e1.placed ? t1 : -t1))) : s && i ? 1 : 0, this.placed = i;
            }
            isHidden() {
                return 0 === this.opacity && !this.placed;
            }
        }
        class nn {
            constructor(e1, t1, i, s, r, o = !1){
                this.text = new on(e1 ? e1.text : null, t1, i, r), this.icon = new on(e1 ? e1.icon : null, t1, s, r), this.clipped = o;
            }
            isHidden() {
                return this.text.isHidden() && this.icon.isHidden();
            }
        }
        class an {
            constructor(e1, t1, i, s = !1){
                this.text = e1, this.icon = t1, this.skipFade = i, this.clipped = s;
            }
        }
        class ln {
            constructor(){
                this.invProjMatrix = e1.a2(), this.viewportMatrix = e1.a2(), this.circles = [];
            }
        }
        class cn {
            constructor(e1, t1, i, s, r){
                this.bucketInstanceId = e1, this.featureIndex = t1, this.sourceLayerIndex = i, this.bucketIndex = s, this.tileID = r;
            }
        }
        class hn {
            constructor(e1){
                this.crossSourceCollisions = e1, this.maxGroupID = 0, this.collisionGroups = {};
            }
            get(e1) {
                if (this.crossSourceCollisions) return {
                    ID: 0,
                    predicate: null
                };
                if (!this.collisionGroups[e1]) {
                    const t1 = ++this.maxGroupID;
                    this.collisionGroups[e1] = {
                        ID: t1,
                        predicate: (e1)=>e1.collisionGroupID === t1
                    };
                }
                return this.collisionGroups[e1];
            }
        }
        function dn(t1, i, s, r, o) {
            const { horizontalAlign: n, verticalAlign: a } = e1.dz(t1), l = -(n - .5) * i, c = -(a - .5) * s, h = e1.dA(t1, r);
            return new e1.P(l + h[0] * o, c + h[1] * o);
        }
        function un(t1, i, s, r, o) {
            const n = new e1.P(t1, i);
            return s && n._rotate(r ? o : -o), n;
        }
        function pn(t1, i, s, r) {
            const { leftJustifiedTextSymbolIndex: o, centerJustifiedTextSymbolIndex: n, rightJustifiedTextSymbolIndex: a, verticalPlacedTextSymbolIndex: l, crossTileID: c } = s, h = e1.dB(i), d = r === e1.dy.vertical ? l : "left" === h ? o : "center" === h ? n : "right" === h ? a : -1;
            o >= 0 && (t1.text.placedSymbolArray.get(o).crossTileID = d >= 0 && o !== d ? 0 : c), n >= 0 && (t1.text.placedSymbolArray.get(n).crossTileID = d >= 0 && n !== d ? 0 : c), a >= 0 && (t1.text.placedSymbolArray.get(a).crossTileID = d >= 0 && a !== d ? 0 : c), l >= 0 && (t1.text.placedSymbolArray.get(l).crossTileID = d >= 0 && l !== d ? 0 : c);
        }
        function fn(t1, i, s) {
            const r = i === e1.dy.horizontal || i === e1.dy.horizontalOnly ? i : 0, o = i === e1.dy.vertical ? i : 0, { leftJustifiedTextSymbolIndex: n, centerJustifiedTextSymbolIndex: a, rightJustifiedTextSymbolIndex: l, verticalPlacedTextSymbolIndex: c } = s, h = t1.text.placedSymbolArray;
            n >= 0 && (h.get(n).placedOrientation = r), a >= 0 && (h.get(a).placedOrientation = r), l >= 0 && (h.get(l).placedOrientation = r), c >= 0 && (h.get(c).placedOrientation = o);
        }
        class mn {
            constructor(e1, t1, i, s, r, o, n){
                this.transform = e1.clone(), this.projection = e1.projection.name, n instanceof rn ? (n.reset(this.transform, r), this.collisionIndex = n) : this.collisionIndex = new rn(this.transform, r), this.buildingIndex = o, this.frontCutoffStart = 0, this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = t1, this.retainedQueryData = {}, this.collisionGroups = new hn(i), this.collisionCircleArrays = {}, this.prevPlacement = s, s && (s.prevPlacement = void 0), this.placedOrientations = {}, this.lastReplacementSourceUpdateTime = 0;
            }
            getBucketParts(t1, i, s, r, o = 1) {
                const n = s.getBucket(i), a = s.latestFeatureIndex;
                if (!n || !a || i.fqid !== n.layerIds[0]) return;
                const l = n.layers[0].layout, c = n.layers[0].paint, h = s.collisionBoxArray, d = Math.pow(2, this.transform.zoom - s.tileID.overscaledZ), u = s.tileSize / e1.ac, p = s.tileID.toUnwrapped();
                this.transform.setProjection(n.projection);
                const f = e1.dn(s.tileID, n.getProjection(), this.transform, this.projection), m = "map" === l.get("text-pitch-alignment"), _ = "map" === l.get("text-rotation-alignment");
                i.compileFilter(i.options);
                const g = i.dynamicFilter(), y = i.dynamicFilterNeedsFeature(), v = i.dynamicFilterNeedsGeometry(), b = this.transform.calculatePixelsToTileUnitsMatrix(s), x = e1.dp(f, s.tileID.canonical, m, _, this.transform, n.getProjection(), b);
                let w = null;
                const T = n.getProjection().createInversionMatrix(this.transform, s.tileID.canonical);
                if (m) {
                    const t1 = e1.dq(f, s.tileID.canonical, m, _, this.transform, n.getProjection(), b);
                    w = e1.a1([], this.transform.labelPlaneMatrix, t1);
                }
                let S = null;
                g && s.latestFeatureIndex && (S = {
                    unwrappedTileID: p,
                    dynamicFilter: g,
                    dynamicFilterNeedsFeature: y,
                    needGeometry: v
                }), this.retainedQueryData[n.bucketInstanceId] = new cn(n.bucketInstanceId, a, n.sourceLayerIndex, n.index, s.tileID);
                const [C, E] = n.layers[0].layout.get("text-size-scale-range"), I = e1.bb(o, C, E), [D, P] = l.get("icon-size-scale-range"), L = e1.bb(o, D, P), R = {
                    bucket: n,
                    layout: l,
                    paint: c,
                    posMatrix: f,
                    invMatrix: T,
                    mercatorCenter: [
                        e1.ad(this.transform.center.lng),
                        e1.ae(this.transform.center.lat)
                    ],
                    textLabelPlaneMatrix: x,
                    labelToScreenMatrix: w,
                    clippingData: S,
                    scale: d,
                    textPixelRatio: u,
                    holdingForFade: s.holdingForFade(),
                    collisionBoxArray: h,
                    partiallyEvaluatedTextSize: e1.dr(n.textSizeData, this.transform.zoom, I),
                    partiallyEvaluatedIconSize: e1.dr(n.iconSizeData, this.transform.zoom, L),
                    collisionGroup: this.collisionGroups.get(n.sourceID),
                    latestFeatureIndex: s.latestFeatureIndex
                };
                if (r) for (const e1 of n.sortKeyRanges){
                    const { sortKey: i, symbolInstanceStart: s, symbolInstanceEnd: r } = e1;
                    t1.push({
                        sortKey: i,
                        symbolInstanceStart: s,
                        symbolInstanceEnd: r,
                        parameters: R
                    });
                }
                else t1.push({
                    symbolInstanceStart: 0,
                    symbolInstanceEnd: n.symbolInstances.length,
                    parameters: R
                });
            }
            placeLayerBucketPart(t1, i, s, r = 1) {
                const { bucket: o, layout: n, paint: a, posMatrix: l, textLabelPlaneMatrix: c, labelToScreenMatrix: h, clippingData: d, textPixelRatio: u, mercatorCenter: p, invMatrix: f, holdingForFade: m, collisionBoxArray: _, partiallyEvaluatedTextSize: g, partiallyEvaluatedIconSize: y, collisionGroup: v, latestFeatureIndex: b } = t1.parameters, x = n.get("text-optional"), w = n.get("icon-optional"), T = n.get("text-allow-overlap"), S = n.get("icon-allow-overlap"), C = "map" === n.get("text-rotation-alignment"), E = "map" === n.get("icon-rotation-alignment"), I = "map" === n.get("text-pitch-alignment"), D = a.get("symbol-z-offset"), P = "sea" === n.get("symbol-elevation-reference"), L = n.get("symbol-placement"), R = n.get("text-variable-anchor"), A = C && "point" !== L, M = E && "point" !== L, F = R && o.hasTextData(), O = o.hasIconTextFit() && F && o.hasIconData();
                this.transform.setProjection(o.projection);
                const k = F || A, B = M || O;
                let z = T && (S || !o.hasIconData() || w), U = S && (T || !o.hasTextData() || x);
                const N = !D.isConstant(), j = (t1, r)=>{
                    const { crossTileID: a, numVerticalGlyphVertices: E } = t1, L = o.getCollisionArrays(_, t1);
                    let A = null;
                    if (d && d.dynamicFilterNeedsFeature || N) {
                        const i = this.retainedQueryData[o.bucketInstanceId], s = b.loadFeature({
                            featureIndex: t1.featureIndex,
                            bucketIndex: i.bucketIndex,
                            sourceLayerIndex: i.sourceLayerIndex,
                            layoutVertexArrayOffset: 0
                        }), r = s.properties ? s.properties.worldview : null;
                        if (o.localizable && o.worldview && "string" == typeof r) {
                            if ("all" === r) s.properties.$localized = !0;
                            else {
                                if (!r.split(",").includes(o.worldview)) return;
                                s.properties.$localized = !0, s.properties.worldview = o.worldview;
                            }
                        }
                        A = d && d.needGeometry ? e1.bI(s, !0) : s;
                    }
                    if (d && !(0, d.dynamicFilter)({
                        zoom: this.transform.zoom,
                        pitch: this.transform.pitch,
                        worldview: o.worldview
                    }, A, this.retainedQueryData[o.bucketInstanceId].tileID.canonical, new e1.P(t1.tileAnchorX, t1.tileAnchorY), this.transform.calculateDistanceTileData(d.unwrappedTileID))) return this.placements[a] = new an(!1, !1, !1, !0), void i.add(a);
                    const M = D.evaluate(A, {});
                    if ((t1.zOffset || 0) + (M || 0) > 0 && this.frontCutoffStart > 0) {
                        const s = 2 * this.frontCutoffStart - 1, r = [
                            t1.tileAnchorX,
                            t1.tileAnchorY,
                            0,
                            1
                        ], o = e1.cd(e1.dw(), r, l);
                        if (o[1] / o[3] < s) return this.placements[a] = new an(!1, !1, !1, !0), void i.add(a);
                    }
                    if (i.has(a)) return;
                    if (m) return void (this.placements[a] = new an(!1, !1, !1));
                    let F = !1, O = !1, j = !0, V = !1, G = !1, q = null, $ = {
                        box: null,
                        offscreen: null,
                        occluded: null
                    }, Z = {
                        box: null
                    }, W = null, H = null, X = null, Y = 0, K = 0, Q = 0;
                    L.textFeatureIndex ? Y = L.textFeatureIndex : t1.useRuntimeCollisionCircles && (Y = t1.featureIndex), L.verticalTextFeatureIndex && (K = L.verticalTextFeatureIndex);
                    const J = (i)=>{
                        i.tileID = this.retainedQueryData[o.bucketInstanceId].tileID;
                        const s = this.transform.elevation;
                        if ("road" === o.elevationType) i.elevation = P ? M : M + e1.c8.getAtTileOffset(i.tileID, new e1.P(i.tileAnchorX, i.tileAnchorY), s, null);
                        else {
                            const r = o.hdExt ? o.hdExt.elevationFeatures[t1.elevationFeatureIndex] : void 0;
                            i.elevation = P ? M : M + e1.c8.getAtTileOffset(i.tileID, new e1.P(i.tileAnchorX, i.tileAnchorY), s, r);
                        }
                        i.elevation += t1.zOffset;
                    }, ee = L.textBox;
                    if (ee) {
                        J(ee);
                        const i = (i)=>{
                            let s = e1.dy.horizontal;
                            if (o.allowVerticalPlacement && !i && this.prevPlacement) {
                                const e1 = this.prevPlacement.placedOrientations[a];
                                e1 && (this.placedOrientations[a] = e1, s = e1, fn(o, s, t1));
                            }
                            return s;
                        }, s = (t1, i)=>{
                            if (o.allowVerticalPlacement && E > 0 && L.verticalTextBox) {
                                for (const s of o.writingModes)if (s === e1.dy.vertical ? ($ = i(), Z = $) : $ = t1(), $ && $.box && $.box.length) break;
                            } else $ = t1();
                        };
                        if (R) {
                            let n = R;
                            if (this.prevPlacement && this.prevPlacement.variableOffsets[a]) {
                                const e1 = this.prevPlacement.variableOffsets[a];
                                n.indexOf(e1.anchor) > 0 && (n = n.filter((t1)=>t1 !== e1.anchor), n.unshift(e1.anchor));
                            }
                            const c = (e1, i, s)=>{
                                const a = o.getSymbolInstanceTextSize(g, t1, this.transform.zoom, r), c = (e1.x2 - e1.x1) * a + 2 * e1.padding, h = (e1.y2 - e1.y1) * a + 2 * e1.padding, d = t1.hasIconTextFit && !S ? i : null;
                                d && J(d);
                                let m = {
                                    box: [],
                                    offscreen: !1,
                                    occluded: !1
                                };
                                const _ = T ? 2 * n.length : n.length;
                                for(let i = 0; i < _; ++i){
                                    const _ = this.attemptAnchorPlacement(n[i % n.length], e1, p, f, k, c, h, a, C, I, u, l, v, i >= n.length, t1, r, o, s, d, g, y);
                                    if (_ && (m = _.placedGlyphBoxes, m && m.box && m.box.length)) {
                                        F = !0, q = _.shift;
                                        break;
                                    }
                                }
                                return m;
                            };
                            s(()=>c(ee, L.iconBox, e1.dy.horizontal), ()=>{
                                const t1 = L.verticalTextBox;
                                return t1 && J(t1), o.allowVerticalPlacement && !($ && $.box && $.box.length) && E > 0 && t1 ? c(t1, L.verticalIconBox, e1.dy.vertical) : {
                                    box: null,
                                    offscreen: null,
                                    occluded: null
                                };
                            }), $ && (F = $.box, j = $.offscreen, V = $.occluded);
                            const h = i(!(!$ || !$.box));
                            if (!F && this.prevPlacement) {
                                const e1 = this.prevPlacement.variableOffsets[a];
                                e1 && (this.variableOffsets[a] = e1, pn(o, e1.anchor, t1, h));
                            }
                        } else {
                            const n = (i, s)=>{
                                const n = o.getSymbolInstanceTextSize(g, t1, this.transform.zoom, r), c = this.collisionIndex.placeCollisionBox(o, n, i, p, f, k, new e1.P(0, 0), T, u, l, v.predicate);
                                return c && c.box && c.box.length && (fn(o, s, t1), this.placedOrientations[a] = s), c;
                            };
                            s(()=>n(ee, e1.dy.horizontal), ()=>{
                                const t1 = L.verticalTextBox;
                                return o.allowVerticalPlacement && E > 0 && t1 ? (J(t1), n(t1, e1.dy.vertical)) : {
                                    box: null,
                                    offscreen: null,
                                    occluded: null
                                };
                            }), i(!!($ && $.box && $.box.length));
                        }
                    }
                    if (W = $, F = W && W.box && W.box.length > 0, j = W && W.offscreen, V = W && W.occluded, t1.useRuntimeCollisionCircles) {
                        const i = t1.centerJustifiedTextSymbolIndex >= 0 ? t1.centerJustifiedTextSymbolIndex : t1.verticalPlacedTextSymbolIndex, r = o.text.placedSymbolArray.get(i), a = e1.dx(o.textSizeData, g, r), d = n.get("text-padding");
                        H = this.collisionIndex.placeCollisionCircles(o, T, r, i, o.lineVertexArray, o.glyphOffsetArray, a, l, c, h, s, I, v.predicate, t1.collisionCircleDiameter * a / e1.dl, d, this.retainedQueryData[o.bucketInstanceId].tileID), F = T || H.circles.length > 0 && !H.collisionDetected, j = j && H.offscreen, V = H.occluded;
                    }
                    if (L.iconFeatureIndex && (Q = L.iconFeatureIndex), L.iconBox) {
                        const i = (i)=>{
                            J(i);
                            const s = t1.hasIconTextFit && q ? un(q.x, q.y, C, I, this.transform.angle) : new e1.P(0, 0), r = o.getSymbolInstanceIconSize(y, this.transform.zoom, t1.placedIconSymbolIndex);
                            return this.collisionIndex.placeCollisionBox(o, r, i, p, f, B, s, S, u, l, v.predicate);
                        };
                        Z && Z.box && Z.box.length && L.verticalIconBox ? (X = i(L.verticalIconBox), O = X.box.length > 0) : (X = i(L.iconBox), O = X.box.length > 0), j = j && X.offscreen, G = X.occluded;
                    }
                    const te = x || 0 === t1.numHorizontalGlyphVertices && 0 === E, ie = w || 0 === t1.numIconVertices;
                    if (te || ie ? ie ? te || (O = O && F) : F = O && F : O = F = O && F, F && W && W.box && this.collisionIndex.insertCollisionBox(W.box, n.get("text-ignore-placement"), o.bucketInstanceId, Z && Z.box && K ? K : Y, v.ID), O && X && this.collisionIndex.insertCollisionBox(X.box, n.get("icon-ignore-placement"), o.bucketInstanceId, Q, v.ID), H && (F && this.collisionIndex.insertCollisionCircles(H.circles, n.get("text-ignore-placement"), o.bucketInstanceId, Y, v.ID), s)) {
                        const e1 = o.bucketInstanceId;
                        let t1 = this.collisionCircleArrays[e1];
                        void 0 === t1 && (t1 = this.collisionCircleArrays[e1] = new ln);
                        for(let e1 = 0; e1 < H.circles.length; e1 += 4)t1.circles.push(H.circles[e1 + 0]), t1.circles.push(H.circles[e1 + 1]), t1.circles.push(H.circles[e1 + 2]), t1.circles.push(H.collisionDetected ? 1 : 0);
                    }
                    const se = "globe" !== o.projection.name;
                    z = z && (se || !V), U = U && (se || !G), this.placements[a] = new an(F || z, O || U, j || o.justReloaded), i.add(a);
                }, V = this.retainedQueryData[o.bucketInstanceId].tileID;
                if ("offset" === o.elevationType && this.buildingIndex && this.buildingIndex.updateZOffset(o, V), "road" === o.elevationType && o.hdExt && o.hdExt.updateRoadElevation(o, V.canonical), o.updateZOffset(), o.sortFeaturesByY) {
                    const t1 = o.getSortedSymbolIndexes(this.transform.angle);
                    for(let e1 = t1.length - 1; e1 >= 0; --e1){
                        const i = t1[e1];
                        j(o.symbolInstances.get(i), i);
                    }
                    o.hasAnyZOffset && e1.w(`${o.layerIds[0]} layer symbol-z-elevate: symbols are not sorted by elevation if symbol-z-order is evaluated to viewport-y`);
                } else if (o.hasAnyZOffset) {
                    const e1 = o.getSortedIndexesByZOffset();
                    for(let t1 = 0; t1 < e1.length; ++t1){
                        const i = e1[t1];
                        j(o.symbolInstances.get(i), i);
                    }
                } else for(let e1 = t1.symbolInstanceStart; e1 < t1.symbolInstanceEnd; e1++)j(o.symbolInstances.get(e1), e1);
                if (s && o.bucketInstanceId in this.collisionCircleArrays) {
                    const t1 = this.collisionCircleArrays[o.bucketInstanceId];
                    e1.aZ(t1.invProjMatrix, l), t1.viewportMatrix = this.collisionIndex.getViewportMatrix();
                }
                o.justReloaded = !1;
            }
            attemptAnchorPlacement(e1, t1, i, s, r, o, n, a, l, c, h, d, u, p, f, m, _, g, y, v, b) {
                const { textOffset0: x, textOffset1: w, crossTileID: T } = f, S = [
                    x,
                    w
                ], C = dn(e1, o, n, S, a), E = this.collisionIndex.placeCollisionBox(_, a, t1, i, s, r, un(C.x, C.y, l, c, this.transform.angle), p, h, d, u.predicate);
                if (y) {
                    const e1 = _.getSymbolInstanceIconSize(b, this.transform.zoom, f.placedIconSymbolIndex);
                    if (0 === this.collisionIndex.placeCollisionBox(_, e1, y, i, s, r, un(C.x, C.y, l, c, this.transform.angle), p, h, d, u.predicate).box.length) return;
                }
                if (E.box.length > 0) {
                    let t1;
                    return this.prevPlacement && this.prevPlacement.variableOffsets[T] && this.prevPlacement.placements[T] && this.prevPlacement.placements[T].text && (t1 = this.prevPlacement.variableOffsets[T].anchor), this.variableOffsets[T] = {
                        textOffset: S,
                        width: o,
                        height: n,
                        anchor: e1,
                        textScale: a,
                        prevAnchor: t1
                    }, pn(_, e1, f, g), _.allowVerticalPlacement && (fn(_, g, f), this.placedOrientations[T] = g), {
                        shift: C,
                        placedGlyphBoxes: E
                    };
                }
            }
            commit(e1) {
                this.commitTime = e1, this.zoomAtLastRecencyCheck = this.transform.zoom;
                const t1 = this.prevPlacement;
                let i = !1;
                this.prevZoomAdjustment = t1 ? t1.zoomAdjustment(this.transform.zoom) : 0;
                const s = t1 ? t1.symbolFadeChange(e1) : 1, r = t1 ? t1.opacities : {}, o = t1 ? t1.variableOffsets : {}, n = t1 ? t1.placedOrientations : {};
                for(const e1 in this.placements){
                    const t1 = this.placements[e1], o = r[e1];
                    o ? (this.opacities[e1] = new nn(o, s, t1.text, t1.icon, null, t1.clipped), i = i || t1.text !== o.text.placed || t1.icon !== o.icon.placed) : (this.opacities[e1] = new nn(null, s, t1.text, t1.icon, t1.skipFade, t1.clipped), i = i || t1.text || t1.icon);
                }
                for(const e1 in r){
                    const t1 = r[e1];
                    if (!this.opacities[e1]) {
                        const r = new nn(t1, s, !1, !1);
                        r.isHidden() || (this.opacities[e1] = r, i = i || t1.text.placed || t1.icon.placed);
                    }
                }
                for(const e1 in o)this.variableOffsets[e1] || !this.opacities[e1] || this.opacities[e1].isHidden() || (this.variableOffsets[e1] = o[e1]);
                for(const e1 in n)this.placedOrientations[e1] || !this.opacities[e1] || this.opacities[e1].isHidden() || (this.placedOrientations[e1] = n[e1]);
                i ? this.lastPlacementChangeTime = e1 : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = t1 ? t1.lastPlacementChangeTime : e1);
            }
            updateLayerOpacities(t1, i, s, r, o = !1, n = 1) {
                r && (this.lastReplacementSourceUpdateTime = r.updateTime);
                const a = new Set;
                for (const l of i){
                    const i = l.getBucket(t1);
                    if (i && l.latestFeatureIndex && t1.fqid === i.layerIds[0] && (this.updateBucketOpacities(i, a, l, l.collisionBoxArray, s, r, l.tileID, t1.scope), "offset" === i.elevationType && this.buildingIndex && this.buildingIndex.updateZOffset(i, l.tileID), "road" === i.elevationType && i.hdExt && i.hdExt.updateRoadElevation(i, l.tileID.canonical), i.updateZOffset(), o && l.collisionBoxArray)) {
                        const t1 = i.layers[0].layout, [s, r] = t1.get("text-size-scale-range"), [o, a] = t1.get("icon-size-scale-range"), c = e1.bb(n, s, r), h = e1.bb(n, o, a);
                        i.updateCollisionDebugBuffers(this.transform.zoom, l.collisionBoxArray, c, h);
                    }
                }
            }
            updateBucketOpacities(t1, i, s, r, o, n, a, l) {
                t1.hasTextData() && t1.text.opacityVertexArray.clear(), t1.hasIconData() && t1.icon.opacityVertexArray.clear(), t1.hasIconCollisionBoxData() && t1.iconCollisionBox.collisionVertexArray.clear(), t1.hasTextCollisionBoxData() && t1.textCollisionBox.collisionVertexArray.clear();
                const c = t1.layers[0].layout, h = t1.layers[0].paint, d = !!t1.layers[0].dynamicFilter(), u = new nn(null, 0, !1, !1, !0), p = c.get("text-allow-overlap"), f = c.get("icon-allow-overlap"), m = c.get("text-variable-anchor"), _ = "map" === c.get("text-rotation-alignment"), g = "map" === c.get("text-pitch-alignment"), y = h.get("symbol-z-offset"), v = "sea" === c.get("symbol-elevation-reference"), b = !y.isConstant(), x = new nn(null, 0, p && (f || !t1.hasIconData() || c.get("icon-optional")), f && (p || !t1.hasTextData() || c.get("text-optional")), !0), w = (e1, t1, i)=>{
                    const s = e1.opacityVertexArray;
                    let r = !1;
                    for(let e1 = 0; e1 < t1 / 4; e1++)s.uint32[s.length] !== i && (r = !0), s.emplaceBack(i);
                    return r;
                };
                let T = !1, S = !1, C = 0;
                n && t1.updateReplacement(a, n), this.collisionIndex.clearClippedSymbolsForBucket(t1.bucketInstanceId);
                for(let c = 0; c < t1.symbolInstances.length; c++){
                    const h = t1.symbolInstances.get(c), { numHorizontalGlyphVertices: p, numVerticalGlyphVertices: f, crossTileID: E, numIconVertices: I, tileAnchorX: D, tileAnchorY: P } = h;
                    let L = null;
                    const R = this.retainedQueryData[t1.bucketInstanceId];
                    b && h && R && (L = s.latestFeatureIndex.loadFeature({
                        featureIndex: h.featureIndex,
                        bucketIndex: R.bucketIndex,
                        sourceLayerIndex: R.sourceLayerIndex,
                        layoutVertexArrayOffset: 0
                    }));
                    const A = y.evaluate(L, {}), M = i.has(E);
                    let F = this.opacities[E];
                    M ? F = u : F || (F = x, this.opacities[E] = F), i.add(E);
                    const O = p > 0 || f > 0, k = I > 0, B = this.placedOrientations[E], z = B === e1.dy.vertical, U = B === e1.dy.horizontal || B === e1.dy.horizontalOnly;
                    !O && !k || F.isHidden() || C++;
                    let N = !1;
                    if ((O || k) && n) for (const i of t1.activeReplacements){
                        if (e1.ds(i, o, e1.dt.Symbol, l)) continue;
                        if (i.min.x > D || D > i.max.x || i.min.y > P || P > i.max.y) continue;
                        const t1 = e1.du(D, P, a.canonical, i.footprintTileId.canonical);
                        if (N = e1.dv(t1, i.footprint), N) break;
                    }
                    if (N && this.collisionIndex.markSymbolAsClipped(t1.bucketInstanceId, h.featureIndex), O) {
                        const e1 = N ? Cn : Sn(F.text);
                        w(t1.text, p, z ? Cn : e1) && (T = !0), w(t1.text, f, U ? Cn : e1) && (T = !0);
                        const i = F.text.isHidden(), { leftJustifiedTextSymbolIndex: s, centerJustifiedTextSymbolIndex: r, rightJustifiedTextSymbolIndex: o, verticalPlacedTextSymbolIndex: n } = h, a = t1.text.placedSymbolArray, l = i || z ? 1 : 0;
                        s >= 0 && (a.get(s).hidden = l), r >= 0 && (a.get(r).hidden = l), o >= 0 && (a.get(o).hidden = l), n >= 0 && (a.get(n).hidden = i || U ? 1 : 0);
                        const c = this.variableOffsets[E];
                        c && pn(t1, c.anchor, h, B);
                        const d = this.placedOrientations[E];
                        d && (pn(t1, "left", h, d), fn(t1, d, h));
                    }
                    if (k) {
                        const e1 = N ? Cn : Sn(F.icon), { placedIconSymbolIndex: i, verticalPlacedIconSymbolIndex: s } = h, r = t1.icon.placedSymbolArray, o = F.icon.isHidden() ? 1 : 0;
                        i >= 0 && (w(t1.icon, I, z ? Cn : e1) && (S = !0), r.get(i).hidden = o), s >= 0 && (w(t1.icon, h.numVerticalIconVertices, U ? Cn : e1) && (S = !0), r.get(s).hidden = o);
                    }
                    if ((t1.hasIconCollisionBoxData() || t1.hasTextCollisionBoxData()) && r) {
                        const i = h.textBoxStartIndex < h.textBoxEndIndex, s = h.verticalTextBoxStartIndex < h.verticalTextBoxEndIndex, r = h.iconBoxStartIndex < h.iconBoxEndIndex, o = h.verticalIconBoxStartIndex < h.verticalIconBoxEndIndex;
                        let n = new e1.P(0, 0), a = !0;
                        if (i || s) {
                            if (m) {
                                const e1 = this.variableOffsets[E];
                                e1 ? (n = dn(e1.anchor, e1.width, e1.height, e1.textOffset, e1.textScale), _ && n._rotate(g ? this.transform.angle : -this.transform.angle)) : a = !1;
                            }
                            d && (a = !F.clipped), i && _n(t1.textCollisionBox.collisionVertexArray, F.text.placed, !a || z, A, v, n.x, n.y), s && _n(t1.textCollisionBox.collisionVertexArray, F.text.placed, !a || U, A, v, n.x, n.y);
                        }
                        const l = a && !U && o;
                        r && _n(t1.iconCollisionBox.collisionVertexArray, F.icon.placed, l, A, v, h.hasIconTextFit ? n.x : 0, h.hasIconTextFit ? n.y : 0), o && _n(t1.iconCollisionBox.collisionVertexArray, F.icon.placed, !l, A, v, h.hasIconTextFit ? n.x : 0, h.hasIconTextFit ? n.y : 0);
                    }
                }
                if (t1.fullyClipped = 0 === C, t1.sortFeatures(this.transform.angle), this.retainedQueryData[t1.bucketInstanceId] && (this.retainedQueryData[t1.bucketInstanceId].featureSortOrder = t1.featureSortOrder), T && t1.hasTextData() && t1.text.opacityVertexBuffer && t1.text.opacityVertexBuffer.updateData(t1.text.opacityVertexArray), S && t1.hasIconData() && t1.icon.opacityVertexBuffer && t1.icon.opacityVertexBuffer.updateData(t1.icon.opacityVertexArray), t1.hasIconCollisionBoxData() && t1.iconCollisionBox.collisionVertexBuffer && t1.iconCollisionBox.collisionVertexBuffer.updateData(t1.iconCollisionBox.collisionVertexArray), t1.hasTextCollisionBoxData() && t1.textCollisionBox.collisionVertexBuffer && t1.textCollisionBox.collisionVertexBuffer.updateData(t1.textCollisionBox.collisionVertexArray), t1.bucketInstanceId in this.collisionCircleArrays) {
                    const e1 = this.collisionCircleArrays[t1.bucketInstanceId];
                    t1.placementInvProjMatrix = e1.invProjMatrix, t1.placementViewportMatrix = e1.viewportMatrix, t1.collisionCircleArray = e1.circles, delete this.collisionCircleArrays[t1.bucketInstanceId];
                }
            }
            symbolFadeChange(e1) {
                return 0 === this.fadeDuration ? 1 : (e1 - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
            }
            zoomAdjustment(e1) {
                return Math.max(0, (this.transform.zoom - e1) / 1.5);
            }
            hasTransitions(e1) {
                return e1 - this.lastPlacementChangeTime < this.fadeDuration;
            }
            stillRecent(e1, t1) {
                const i = this.zoomAtLastRecencyCheck === t1 ? 1 - this.zoomAdjustment(t1) : 1;
                return this.zoomAtLastRecencyCheck = t1, this.commitTime + this.fadeDuration * i > e1;
            }
            isStale() {
                return this.stale;
            }
            setStale() {
                this.stale = !0;
            }
        }
        function _n(e1, t1, i, s, r, o, n) {
            e1.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, o || 0, n || 0, s, r ? 1 : 0), e1.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, o || 0, n || 0, s, r ? 1 : 0), e1.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, o || 0, n || 0, s, r ? 1 : 0), e1.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, o || 0, n || 0, s, r ? 1 : 0);
        }
        const gn = Math.pow(2, 25), yn = Math.pow(2, 24), vn = Math.pow(2, 17), bn = Math.pow(2, 16), xn = Math.pow(2, 9), wn = Math.pow(2, 8), Tn = Math.pow(2, 1);
        function Sn(e1) {
            if (0 === e1.opacity && !e1.placed) return 0;
            if (1 === e1.opacity && e1.placed) return 4294967295;
            const t1 = e1.placed ? 1 : 0, i = Math.floor(127 * e1.opacity);
            return i * gn + t1 * yn + i * vn + t1 * bn + i * xn + t1 * wn + i * Tn + t1;
        }
        const Cn = 0;
        class En {
            constructor(e1){
                this._sortAcrossTiles = "viewport-y" !== e1.layout.get("symbol-z-order") && void 0 !== e1.layout.get("symbol-sort-key").constantOr(1), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = new Set, this._bucketParts = [];
            }
            continuePlacement(e1, t1, i, s, r, o) {
                const n = this._bucketParts;
                for(; this._currentTileIndex < e1.length;)if (t1.getBucketParts(n, s, e1[this._currentTileIndex], this._sortAcrossTiles, o), this._currentTileIndex++, r()) return !0;
                for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, n.sort((e1, t1)=>e1.sortKey - t1.sortKey)); this._currentPartIndex < n.length;)if (t1.placeLayerBucketPart(n[this._currentPartIndex], this._seenCrossTileIDs, i, o), this._currentPartIndex++, r()) return !0;
                return !1;
            }
        }
        class In {
            constructor(){
                this._retiredCI = null;
            }
            startNewPlacement(e1, t1, i, s, r, o, n, a) {
                return this.placement = new mn(e1, s, r, o, n, a, this._retiredCI), this._retiredCI = null, this._currentPlacementIndex = t1.length - 1, this._forceFullPlacement = !1, this._showCollisionBoxes = i, this._fadeDuration = s, this._done = !1, this._inProgressLayer = null, this;
            }
            requestFullPlacement() {
                this._forceFullPlacement = !0;
            }
            isFullPlacementRequested() {
                return this._forceFullPlacement;
            }
            setStale() {
                this.placement && (this.placement.stale = !0);
            }
            isStale() {
                return !!this.placement && this.placement.stale;
            }
            isDone() {
                return this._done;
            }
            continuePlacement(t1, i, s, r, o) {
                const n = e1.e.now(), a = ()=>!this.isFullPlacementRequested() && 0 !== this._fadeDuration && e1.e.now() - n > 2;
                for(; this._currentPlacementIndex >= 0;){
                    const n = i[t1[this._currentPlacementIndex]], l = this.placement.collisionIndex.transform.zoom;
                    if ("symbol" === n.type && "none" !== n.visibility && (!n.minzoom || n.minzoom <= l) && (!n.maxzoom || n.maxzoom > l)) {
                        const t1 = n, i = t1.layout.get("symbol-z-elevate"), l = void 0 !== t1.layout.get("symbol-sort-key").constantOr(1), c = t1.layout.get("symbol-z-order"), h = "viewport-y" === c || "auto" === c && !("viewport-y" !== c && l), d = t1.layout.get("text-allow-overlap") || t1.layout.get("icon-allow-overlap") || t1.layout.get("text-ignore-placement") || t1.layout.get("icon-ignore-placement"), u = h && d, p = this._inProgressLayer = this._inProgressLayer || new En(t1), f = e1.m(n.source, n.scope);
                        if (p.continuePlacement(i || u ? r[f] : s[f], this.placement, this._showCollisionBoxes, n, a, o)) return;
                        delete this._inProgressLayer;
                    }
                    this._currentPlacementIndex--;
                }
                this._forceFullPlacement = !1, this._done = !0;
            }
            commit(e1) {
                return this._retiredCI = this.placement.prevPlacement ? this.placement.prevPlacement.collisionIndex : null, this.placement.commit(e1), this.placement;
            }
        }
        const Dn = 512 / e1.ac / 2;
        class Pn {
            constructor(t1, i, s){
                this.tileID = t1, this.bucketInstanceId = s, this.index = new e1.dC(i.length, 16, Int32Array), this.keys = [], this.crossTileIDs = [];
                const r = t1.canonical.x * e1.ac, o = t1.canonical.y * e1.ac;
                for(let e1 = 0; e1 < i.length; e1++){
                    const { key: t1, crossTileID: s, tileAnchorX: n, tileAnchorY: a } = i.get(e1), l = Math.floor((r + n) * Dn), c = Math.floor((o + a) * Dn);
                    this.index.add(l, c), this.keys.push(t1), this.crossTileIDs.push(s);
                }
                this.index.finish();
            }
            findMatches(t1, i, s) {
                const r = this.tileID.canonical.z < i.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - i.canonical.z), o = Dn / Math.pow(2, i.canonical.z - this.tileID.canonical.z), n = i.canonical.x * e1.ac, a = i.canonical.y * e1.ac;
                for(let e1 = 0; e1 < t1.length; e1++){
                    const i = t1.get(e1);
                    if (i.crossTileID) continue;
                    const { key: l, tileAnchorX: c, tileAnchorY: h } = i, d = Math.floor((n + c) * o), u = Math.floor((a + h) * o), p = this.index.range(d - r, u - r, d + r, u + r).sort((e1, t1)=>e1 - t1);
                    for (const e1 of p){
                        const t1 = this.crossTileIDs[e1];
                        if (this.keys[e1] === l && !s.has(t1)) {
                            s.add(t1), i.crossTileID = t1;
                            break;
                        }
                    }
                }
            }
        }
        class Ln {
            constructor(){
                this.maxCrossTileID = 0;
            }
            generate() {
                return ++this.maxCrossTileID;
            }
        }
        class Rn {
            constructor(){
                this.indexes = [], this.usedCrossTileIDs = [], this.lng = 0;
            }
            handleWrapJump(e1) {
                const t1 = Math.round((e1 - this.lng) / 360);
                if (0 !== t1) for(let e1 = 0; e1 < this.indexes.length; e1++){
                    const i = this.indexes[e1];
                    if (!i) continue;
                    const s = new Map;
                    for (const e1 of i.values())e1.tileID = e1.tileID.unwrapTo(e1.tileID.wrap + t1), s.set(e1.tileID.key, e1);
                    this.indexes[e1] = s;
                }
                this.lng = e1;
            }
            addBucket(e1, t1, i) {
                const s = e1.overscaledZ, r = this.indexes[s] && this.indexes[s].get(e1.key);
                if (r) {
                    if (r.bucketInstanceId === t1.bucketInstanceId) return !1;
                    this.removeBucketCrossTileIDs(s, r);
                }
                for(let e1 = 0; e1 < t1.symbolInstances.length; e1++)t1.symbolInstances.get(e1).crossTileID = 0;
                let o = this.usedCrossTileIDs[s];
                o || (o = this.usedCrossTileIDs[s] = new Set);
                for(let i = 0; i < this.indexes.length; i++){
                    const r = this.indexes[i];
                    if (r) {
                        if (i > s) for (const i of r.values())i.tileID.isChildOf(e1) && i.findMatches(t1.symbolInstances, e1, o);
                        else {
                            const s = r.get(e1.scaledTo(i).key);
                            s && s.findMatches(t1.symbolInstances, e1, o);
                        }
                    }
                }
                for(let e1 = 0; e1 < t1.symbolInstances.length; e1++){
                    const s = t1.symbolInstances.get(e1);
                    s.crossTileID || (s.crossTileID = i.generate(), o.add(s.crossTileID));
                }
                let n = this.indexes[s];
                return n || (n = this.indexes[s] = new Map), n.set(e1.key, new Pn(e1, t1.symbolInstances, t1.bucketInstanceId)), !0;
            }
            removeBucketCrossTileIDs(e1, t1) {
                for (const i of t1.crossTileIDs)this.usedCrossTileIDs[e1].delete(i);
            }
            removeStaleBuckets(e1) {
                let t1 = !1;
                for(let i = 0; i < this.indexes.length; i++){
                    const s = this.indexes[i];
                    if (s) for (const [r, o] of s)e1.has(o.bucketInstanceId) || (this.removeBucketCrossTileIDs(i, o), s.delete(r), t1 = !0);
                }
                return t1;
            }
        }
        class An {
            constructor(){
                this.layerIndexes = new Map, this.crossTileIDs = new Ln;
            }
            addLayer(e1, t1, i, s) {
                let r = this.layerIndexes.get(e1.fqid);
                void 0 === r && (r = new Rn, this.layerIndexes.set(e1.fqid, r));
                let o = !1;
                const n = new Set;
                "globe" !== s.name && r.handleWrapJump(i);
                for (const i of t1){
                    const t1 = i.getBucket(e1);
                    t1 && e1.fqid === t1.layerIds[0] && (r.addBucket(i.tileID, t1, this.crossTileIDs) && (o = !0), n.add(t1.bucketInstanceId));
                }
                return r.removeStaleBuckets(n) && (o = !0), o;
            }
            pruneUnusedLayers(e1) {
                const t1 = new Set(e1);
                for (const e1 of this.layerIndexes.keys())t1.has(e1) || this.layerIndexes.delete(e1);
            }
        }
        function Mn(e1, t1) {
            const i = (t1.right - t1.left) / 2, s = Math.abs(e1.x - (t1.left + i));
            if (s >= e1.radius + i) return !1;
            const r = (t1.bottom - t1.top) / 2, o = Math.abs(e1.y - (t1.top + r));
            if (o >= e1.radius + r) return !1;
            if (s < i || o < r) return !0;
            const n = s - i, a = o - r;
            return n * n + a * a < e1.radius * e1.radius;
        }
        function Fn(e1, t1) {
            return "box" === e1.kind && "box" === t1.kind ? function(e1, t1) {
                return e1.left < t1.right && t1.left < e1.right && e1.top < t1.bottom && t1.top < e1.bottom;
            }(e1, t1) : "circle" === e1.kind && "circle" === t1.kind ? function(e1, t1) {
                const i = e1.x - t1.x, s = e1.y - t1.y, r = e1.radius + t1.radius;
                return i * i + s * s < r * r;
            }(e1, t1) : "circle" === e1.kind ? Mn(e1, t1) : Mn(t1, e1);
        }
        class On {
            constructor(t1, i, s, r){
                this._cellSize = r, this._padding = s, this._screenWidth = t1, this._screenHeight = i, this._grid = new e1.d7(t1 + 2 * s, i + 2 * s, r), this._workingArea = this._computeWorkingArea(), this._geometries = [], this._geometryData = [];
            }
            clearAndResize(t1, i) {
                t1 === this._screenWidth && i === this._screenHeight ? this._grid.clear() : (this._screenWidth = t1, this._screenHeight = i, this._grid = new e1.d7(t1 + 2 * this._padding, i + 2 * this._padding, this._cellSize), this._workingArea = this._computeWorkingArea()), this._geometries.length = 0, this._geometryData.length = 0;
            }
            _computeWorkingArea() {
                return {
                    kind: "box",
                    left: -this._padding,
                    top: -this._padding,
                    right: this._grid.xCellCount * this._cellSize - this._padding,
                    bottom: this._grid.yCellCount * this._cellSize - this._padding
                };
            }
            intersects(e1, t1, i, s) {
                let r = "outside-of-grid";
                for (const o of e1){
                    const e1 = this._elementIntersects(o, t1, i, s);
                    if ("intersects" === e1) return "intersects";
                    "does-not-intersect" === e1 && (r = "does-not-intersect");
                }
                return r;
            }
            _elementIntersects(e1, t1, i, s) {
                if (!Fn(e1, this._workingArea)) return "outside-of-grid";
                const r = this._padding, o = function(e1, t1) {
                    return 0 === t1 ? e1 : "box" === e1.kind ? {
                        kind: "box",
                        left: e1.left - t1,
                        top: e1.top - t1,
                        right: e1.right + t1,
                        bottom: e1.bottom + t1
                    } : {
                        kind: "circle",
                        x: e1.x,
                        y: e1.y,
                        radius: e1.radius + t1
                    };
                }(e1, t1);
                let n;
                const a = (e1)=>{
                    if (!Fn(this._geometries[e1], o)) return !1;
                    const t1 = this._geometryData[e1];
                    return !(void 0 !== t1 && i(t1) || (n = t1, 0));
                }, l = "box" === o.kind ? this._grid.hitTest(o.left + r, o.top + r, o.right + r, o.bottom + r, a) : this._grid.hitTestCircle(o.x + r, o.y + r, o.radius, a);
                return l && void 0 !== n && s(n), l ? "intersects" : "does-not-intersect";
            }
            insert(e1, t1) {
                const i = this._padding;
                let s = !1;
                for (const r of e1){
                    if (!Fn(r, this._workingArea)) continue;
                    const e1 = this._geometries.length;
                    this._geometries.push(r), this._geometryData.push(t1), "box" === r.kind ? this._grid.insert(e1, r.left + i, r.top + i, r.right + i, r.bottom + i) : this._grid.insertCircle(e1, r.x + i, r.y + i, r.radius), s = !0;
                }
                return s;
            }
        }
        function kn() {}
        function Bn(e1) {
            return 2 * e1.styleLayerId + e1.symbolIdOrigin;
        }
        function zn(e1, t1) {
            const i = e1.get(Bn(t1.symbolId));
            if (!i) return !1;
            const s = i.get(t1.symbolId.symbolId);
            return void 0 !== s && s.has(t1.variantIdx);
        }
        function Un(e1, t1) {
            const i = Bn(t1.symbolId);
            let s = e1.get(i);
            s || (s = new Map, e1.set(i, s));
            let r = s.get(t1.symbolId.symbolId);
            r || (r = new Set, s.set(t1.symbolId.symbolId, r)), r.add(t1.variantIdx);
        }
        class Nn {
            constructor(){
                this._runStarted = !1, this._grid = null, this._timestamp = 0, this._symbols = [], this._onlyIfPlacedReferencedIds = new Map, this._placedVariantIds = new Map, this._placedSymbolIds = new Map, this._processingSource = null, this._variantProcessingStarted = !1, this._collectDebugData = !1, this._debugSymbols = [], this._lastBlockedBy = void 0;
            }
            isCollectingDebugData() {
                return this._collectDebugData;
            }
            startPlacement(e1, t1, i, s = !1) {
                if (this._runStarted) throw new Error("Attempt to start a placement run before finishing the previous one");
                this._runStarted = !0, this._grid ? this._grid.clearAndResize(t1, i) : this._grid = new On(t1, i, 100, 32), this._timestamp = e1, this._symbols = [], this._onlyIfPlacedReferencedIds.clear(), this._placedVariantIds.clear(), this._placedSymbolIds.clear(), this._collectDebugData = s, this._debugSymbols = [];
            }
            debugSymbols() {
                return this._debugSymbols;
            }
            timestamp() {
                return this._timestamp;
            }
            _hasPlacedSymbol(e1) {
                const t1 = this._placedSymbolIds.get(Bn(e1));
                return void 0 !== t1 && t1.has(e1.symbolId);
            }
            _placedVariantIdxFor(e1) {
                const t1 = this._placedSymbolIds.get(Bn(e1));
                return t1 && t1.get(e1.symbolId);
            }
            _addPlacedSymbol(e1) {
                const t1 = Bn(e1.symbolId);
                let i = this._placedSymbolIds.get(t1);
                i || (i = new Map, this._placedSymbolIds.set(t1, i)), i.set(e1.symbolId.symbolId, e1.variantIdx);
            }
            startSymbolSourceProcessing(e1) {
                if (!this._runStarted) throw new Error("Attempt to start symbol source processing outside of a placement run");
                if (this._processingSource) throw new Error("Attempt to start a placement symbol source processing before finishing the previous one");
                this._processingSource = e1;
            }
            startSymbolVariantProcessing(e1, t1, i, s, r) {
                const o = this._processingSource;
                if (!o) throw new Error("Attempt to start a symbol variant processing outside of symbol source processing");
                if (this._variantProcessingStarted) throw new Error("Attempt to begin a symbol variant processing before finishing the previous one");
                this._symbols.push({
                    priority: t1,
                    source: o,
                    variantId: e1,
                    parts: [],
                    placementRules: i,
                    tileID: s,
                    featureId: r
                }), i.onlyIfPlaced && Un(this._onlyIfPlacedReferencedIds, i.onlyIfPlaced), this._variantProcessingStarted = !0;
            }
            addSymbolVariantPart(e1, t1) {
                if (!this._variantProcessingStarted) throw new Error("Attempt to add a symbol variant part outside of symbol variant processing");
                if (0 === e1.length) throw new Error("Attempt to add a symbol variant part without geometry");
                this._symbols.at(-1).parts.push({
                    geometry: e1,
                    rules: t1
                });
            }
            finishVariantProcessing() {
                if (!this._variantProcessingStarted) throw new Error("Attempt to finish a symbol variant processing that was not started");
                this._variantProcessingStarted = !1;
                const t1 = this._symbols.at(-1);
                0 === t1.parts.length && (t1.priority.symbolVariantVisibility === e1.dD.VARIANT_VISIBLE && t1.source.hideSymbolVariant(t1.variantId, this._timestamp), this._symbols.pop());
            }
            finishSourceProcessing() {
                this._processingSource = null;
            }
            _placeSymbolVariant(e1, t1) {
                const i = this._grid;
                if (this._lastBlockedBy = void 0, this._hasPlacedSymbol(e1.variantId.symbolId)) {
                    if (this._collectDebugData) {
                        const t1 = this._placedVariantIdxFor(e1.variantId.symbolId);
                        void 0 !== t1 && (this._lastBlockedBy = {
                            symbolId: e1.variantId.symbolId,
                            variantIdx: t1
                        });
                    }
                    return 2;
                }
                const s = e1.placementRules.onlyIfPlaced;
                if (s && !zn(this._placedVariantIds, s)) return 3;
                const r = this._collectDebugData ? (e1)=>{
                    this._lastBlockedBy = e1;
                } : kn;
                let o = !1, n = !1;
                for (const s of e1.parts){
                    const e1 = s.rules.collisionRules;
                    if (!e1) continue;
                    o = !0;
                    const a = e1.symbolVariantToIgnoreCollisionWith, l = i.intersects(s.geometry, t1, (e1)=>{
                        var t1, i;
                        return void 0 !== a && (t1 = e1).variantIdx === (i = a).variantIdx && t1.symbolId.styleLayerId === i.symbolId.styleLayerId && t1.symbolId.symbolIdOrigin === i.symbolId.symbolIdOrigin && t1.symbolId.symbolId === i.symbolId.symbolId;
                    }, r);
                    if ("intersects" === l) return 1;
                    "does-not-intersect" === l && (n = !0);
                }
                if (o && !n) return 4;
                let a = !1, l = !1;
                for (const t1 of e1.parts)t1.rules.insertIntoCollisionGrid && (i.insert(t1.geometry, e1.variantId) ? a = !0 : l = !0);
                return l && !a ? 4 : 0;
            }
            finishPlacementRun() {
                if (!this._runStarted) throw new Error("Attempt to finish a placement run that was not started");
                this._runStarted = !1;
                const t1 = this._timestamp;
                this._symbols.sort((e1, t1)=>(function(e1, t1) {
                        return e1.placementSubgroupOrder - t1.placementSubgroupOrder || e1.symbolPlacementPriority - t1.symbolPlacementPriority || e1.symbolVariantVisibility - t1.symbolVariantVisibility || e1.symbolPlacementType - t1.symbolPlacementType || e1.styleLayerOrder - t1.styleLayerOrder || e1.symbolDisplayOrder - t1.symbolDisplayOrder;
                    })(t1.priority, e1.priority));
                for (const i of this._symbols){
                    const s = i.priority.symbolVariantVisibility === e1.dD.VARIANT_VISIBLE, r = s ? 0 : 1, o = this._placeSymbolVariant(i, r), n = 0 === o;
                    if (n && (this._addPlacedSymbol(i.variantId), zn(this._onlyIfPlacedReferencedIds, i.variantId) && Un(this._placedVariantIds, i.variantId)), s !== n && (n ? i.source.showSymbolVariant(i.variantId, t1) : i.source.hideSymbolVariant(i.variantId, t1)), this._collectDebugData) {
                        const e1 = n ? 0 : r, t1 = [];
                        for (const e1 of i.parts)t1.push(...e1.geometry);
                        this._debugSymbols.push({
                            geometry: t1,
                            collisionPadding: e1,
                            variantId: i.variantId,
                            tileID: i.tileID,
                            featureId: i.featureId,
                            placementRules: i.placementRules,
                            partPlacementRules: i.parts.map((e1)=>e1.rules),
                            status: o,
                            blockedBy: this._lastBlockedBy
                        });
                    }
                }
            }
        }
        class jn extends e1.E {
            constructor(e1){
                super(), this.requestManager = e1, this.models = Object.create(null), this.models[""] = Object.create(null), this.modelUris = Object.create(null), this.modelUris[""] = Object.create(null), this.modelByURL = Object.create(null), this.numModelsLoading = Object.create(null);
            }
            async loadModel(t1, i) {
                try {
                    const s = await this.requestManager.transformRequest(i, e1.R.Model);
                    return this.modelByURL[i] ? (await ui(), di.loadModel ? await di.loadModel(s, t1, i) : null) : null;
                } catch (s) {
                    if (404 === s.status) return null;
                    this.fire(new e1.h(new Error(`Could not load model ${t1} from ${i}`, {
                        cause: s
                    })));
                }
            }
            load(t1, i, s = {
                forceReload: !1
            }) {
                this.models[i] || (this.models[i] = Object.create(null));
                const r = Object.keys(t1), o = [], n = [];
                for (const e1 of r){
                    const r = t1[e1];
                    this.hasURLBeenRequested(r) && !s.forceReload || (this.modelByURL[r] = {
                        modelId: e1,
                        scope: i
                    }, o.push(this.loadModel(e1, r)), n.push(e1)), this.models[i][e1] || (this.models[i][e1] = {
                        model: null,
                        numReferences: 1
                    });
                }
                0 !== n.length && (this.numModelsLoading[i] = (this.numModelsLoading[i] || 0) + n.length, Promise.allSettled(o).then((t1)=>{
                    for(let e1 = 0; e1 < t1.length; e1++){
                        const { status: s } = t1[e1];
                        if ("rejected" === s) continue;
                        const { value: r } = t1[e1];
                        this.models[i][n[e1]] || (this.models[i][n[e1]] = {
                            model: null,
                            numReferences: 1
                        }), this.models[i][n[e1]].model = r;
                    }
                    this.numModelsLoading[i] -= n.length, this.fire(new e1.i("data", {
                        dataType: "style"
                    }));
                }).catch((t1)=>{
                    this.fire(new e1.h(new Error(`Could not load models: ${t1.message}`)));
                }));
            }
            isLoaded() {
                for(const e1 in this.numModelsLoading)if (this.numModelsLoading[e1] > 0) return !1;
                return !0;
            }
            hasModel(e1, t1, i = {
                exactIdMatch: !1
            }) {
                return !!(i.exactIdMatch ? this.getModel(e1, t1) : this.getModelByURL(this.modelUris[t1][e1]));
            }
            getModel(e1, t1) {
                return this.models[t1] || (this.models[t1] = Object.create(null)), this.models[t1][e1] ? this.models[t1][e1].model : void 0;
            }
            getModelByURL(e1) {
                if (!e1) return null;
                const t1 = this.modelByURL[e1];
                return t1 ? this.models[t1.scope][t1.modelId].model : null;
            }
            hasModelBeenAdded(e1, t1) {
                return this.models[t1] && void 0 !== this.models[t1][e1];
            }
            getModelURIs(e1) {
                return this.modelUris[e1] || Object.create(null);
            }
            addModel(e1, t1, i) {
                this.models[i] || (this.models[i] = Object.create(null)), this.modelUris[i] || (this.modelUris[i] = Object.create(null));
                const s = this.requestManager.normalizeModelURL(t1);
                if ((this.hasModel(e1, i, {
                    exactIdMatch: !0
                }) || this.hasModelBeenAdded(e1, i)) && this.modelUris[i][e1] === s) this.models[i][e1].numReferences++;
                else if (this.hasURLBeenRequested(s)) {
                    const { scope: e1, modelId: t1 } = this.modelByURL[s];
                    this.models[e1][t1].numReferences++;
                } else this.modelUris[i][e1] = s, this.load({
                    [e1]: this.modelUris[i][e1]
                }, i);
            }
            addModelURLs(e1, t1) {
                this.models[t1] || (this.models[t1] = Object.create(null)), this.modelUris[t1] || (this.modelUris[t1] = Object.create(null));
                const i = this.modelUris[t1];
                for (const t1 of Object.keys(e1))i[t1] = this.requestManager.normalizeModelURL(e1[t1]);
            }
            reloadModels(e1) {
                this.load(this.modelUris[e1], e1, {
                    forceReload: !0
                });
            }
            addModelsFromBucket(e1, t1) {
                this.models[t1] || (this.models[t1] = Object.create(null)), this.modelUris[t1] || (this.modelUris[t1] = Object.create(null));
                const i = Object.create(null);
                for (const s of e1)this.hasModel(s, t1, {
                    exactIdMatch: !0
                }) || this.hasURLBeenRequested(s) ? this.models[t1][s].numReferences++ : this.modelUris[t1][s] && !this.hasURLBeenRequested(s) ? i[s] = this.modelUris[t1][s] : !this.hasURLBeenRequested(s) && Ae(s, !1) && (this.modelUris[t1][s] = this.requestManager.normalizeModelURL(s), i[s] = this.modelUris[t1][s]);
                this.load(i, t1);
            }
            hasURLBeenRequested(e1) {
                return void 0 !== this.modelByURL[e1];
            }
            removeModel(e1, t1, i = !1, s = !1) {
                if (this.models[t1] && this.models[t1][e1] && (this.models[t1][e1].numReferences--, 0 === this.models[t1][e1].numReferences || s)) {
                    const s = this.modelUris[t1][e1];
                    i || delete this.modelUris[t1][e1], delete this.modelByURL[s];
                    const r = this.models[t1][e1].model;
                    if (!r) return;
                    delete this.models[t1][e1], r.destroy();
                }
            }
            destroy() {
                for (const e1 of Object.keys(this.models))for (const t1 of Object.keys(this.models[e1])){
                    const i = this.models[e1][t1].model;
                    delete this.models[e1][t1], i && i.destroy();
                }
                this.models = Object.create(null), this.models[""] = Object.create(null), this.modelUris = Object.create(null), this.modelUris[""] = Object.create(null), this.modelByURL = Object.create(null), this.numModelsLoading = Object.create(null);
            }
            listModels(e1) {
                return this.models[e1] || (this.models[e1] = Object.create(null)), Object.keys(this.models[e1]);
            }
            upload(e1, t1) {
                this.models[t1] || (this.models[t1] = Object.create(null));
                for(const i in this.models[t1])this.models[t1][i].model && this.models[t1][i].model.upload(e1.context);
            }
        }
        const Vn = [
            "RENDER_SHADOWS",
            "NORMAL_OFFSET"
        ], Gn = new Set([
            "symbol",
            "circle"
        ]), qn = class t1 {
            constructor(){
                this._queue = [], this._needsBuild = !0, this._idleHandle = null;
            }
            needsBuild() {
                return this._needsBuild;
            }
            buildQueue(e1, t1, i) {
                null != this._idleHandle && "undefined" != typeof cancelIdleCallback && cancelIdleCallback(this._idleHandle), this._idleHandle = null, this._queue = [], this._needsBuild = !1;
                const s = !!i.fog, r = i.hasTerrain(), o = !(!i.projection || "globe" !== i.projection.name), n = r || o, a = !(!i.directionalLight || !i.directionalLight.shadowsEnabled()), l = i.map && i.map.painter, c = !l || !l.context.extParallelShaderCompile, h = !!l && ("mrt-fallback" === l.emissiveMode || "mrt-full-rgba" === l.emissiveMode), d = (e1, t1 = [], i = {})=>{
                    this._queue.push({
                        programId: e1,
                        params: {
                            ...i.params,
                            defines: t1,
                            overrideFog: !!i.fog,
                            overrideTerrain: !!i.terrain,
                            overrideGlobe: !!i.globe,
                            overrideRtt: !!i.rtt,
                            precompiled: !0
                        }
                    });
                };
                for (const u of e1){
                    if ("none" === u.visibility) continue;
                    const e1 = u.getProgramIds();
                    if (e1) for (const p of e1){
                        if (Gn.has(p)) continue;
                        const e1 = u.getDefaultProgramParams(p, t1.zoom, i._styleColorTheme.lut);
                        if (!e1) continue;
                        const f = l ? l.getShaderSource(p) : null, m = n && (!f || f.usedDefines.has("RENDER_TO_TEXTURE"));
                        let _ = e1.defines;
                        if (h && m && (_ = (_ || []).concat("USE_MRT1"), "mrt-full-rgba" === l.emissiveMode && (_ = (_ || []).concat("USE_MRT1_RGBA"))), c) {
                            d(p, e1.defines, {
                                params: e1
                            }), m && d(p, _, {
                                params: e1,
                                rtt: !0
                            });
                            continue;
                        }
                        const g = s && (!f || f.usedDefines.has("FOG")), y = r && !u.isDraped() && (!f || f.usedDefines.has("TERRAIN")), v = o && (!f || f.usedDefines.has("GLOBE")), b = a && u.hasElevation() && (!f || f.usedDefines.has("RENDER_SHADOWS"));
                        for (const t1 of b ? [
                            !1,
                            !0
                        ] : [
                            !1
                        ]){
                            const i = t1 ? (e1.defines || []).concat(Vn) : e1.defines || [];
                            for (const t1 of y ? [
                                !1,
                                !0
                            ] : [
                                !1
                            ])for (const s of v ? [
                                !1,
                                !0
                            ] : [
                                !1
                            ])for (const r of g ? [
                                !1,
                                !0
                            ] : [
                                !1
                            ])d(p, i, {
                                params: e1,
                                fog: r,
                                terrain: t1,
                                globe: s
                            });
                        }
                        m && d(p, _, {
                            params: e1,
                            rtt: !0
                        });
                    }
                }
                if (d("clippingMask"), r) for (const e1 of [
                    !1,
                    !0
                ])d("terrainRaster", e1 ? [
                    "TERRAIN_VERTEX_MORPHING"
                ] : [], {
                    terrain: !0,
                    fog: s
                });
                if (!c) {
                    if (e1.some((e1)=>"hillshade" === e1.type) && d("hillshadePrepare"), a) for (const e1 of [
                        !1,
                        !0
                    ])for (const t1 of [
                        !1,
                        !0
                    ]){
                        const i = [];
                        e1 && i.push("RENDER_CUTOFF"), i.push("RENDER_SHADOWS"), t1 && i.push("NORMAL_OFFSET"), d("groundShadow", i), s && d("groundShadow", i, {
                            fog: !0
                        });
                    }
                    if (o) {
                        for (const e1 of [
                            [],
                            [
                                "TERRAIN_VERTEX_MORPHING"
                            ],
                            [
                                "GLOBE_POLES"
                            ]
                        ])for (const t1 of [
                            !1,
                            !0
                        ]){
                            const i = [
                                ...e1,
                                "PROJECTION_GLOBE_VIEW"
                            ];
                            t1 && i.push("CUSTOM_ANTIALIASING"), d("globeRaster", i, {
                                terrain: r,
                                globe: !0,
                                fog: s
                            });
                        }
                        for (const e1 of [
                            !1,
                            !0
                        ]){
                            const t1 = e1 ? [
                                "PROJECTION_GLOBE_VIEW",
                                "FOG"
                            ] : [
                                "FOG"
                            ];
                            d("globeAtmosphere", t1, {
                                fog: !0,
                                terrain: r,
                                globe: e1
                            }), d("globeAtmosphere", [
                                ...t1,
                                "ALPHA_PASS"
                            ], {
                                fog: !0,
                                terrain: r,
                                globe: e1
                            });
                        }
                        d("stars", [], {
                            fog: s,
                            terrain: r,
                            globe: !0
                        });
                    }
                }
            }
            _executeBatch(i, s, r) {
                if (r.map && r.map.isMoving()) return void (this._idleHandle = e1.e.requestIdleCallback((e1)=>this._executeBatch(e1, s, r)));
                s.context.sweepPendingPrograms();
                const o = s.context.extParallelShaderCompile ? t1.DEADLINE_MARGIN_KHR_MS : t1.DEADLINE_MARGIN_SYNC_MS;
                let n = 0;
                for(; this._queue.length > 0;){
                    const e1 = this._queue.shift();
                    if (!e1) break;
                    if (e1.programId in mo && (s.style = r, s._fogVisible = !!e1.params.overrideFog, s.getOrCreateProgram(e1.programId, e1.params), n++, i.timeRemaining() <= o)) break;
                }
                const a = 0 === this._queue.length || i.timeRemaining() > o;
                n > 0 && a && s.context.gl.flush(), this._idleHandle = this._queue.length > 0 || s.context._pendingPrograms.size > 0 ? e1.e.requestIdleCallback((e1)=>this._executeBatch(e1, s, r)) : null;
            }
            processQueue(t1, i) {
                0 !== this._queue.length && (null != this._idleHandle && "undefined" != typeof cancelIdleCallback && cancelIdleCallback(this._idleHandle), this._idleHandle = e1.e.requestIdleCallback((e1)=>this._executeBatch(e1, t1, i)));
            }
            reset() {
                null != this._idleHandle && "undefined" != typeof cancelIdleCallback && cancelIdleCallback(this._idleHandle), this._queue = [], this._idleHandle = null, this._needsBuild = !0;
            }
        };
        qn.DEADLINE_MARGIN_KHR_MS = 5, qn.DEADLINE_MARGIN_SYNC_MS = 25;
        let $n = qn;
        const Zn = new e1.ar(e1.s.colorTheme.data);
        function Wn(t1) {
            if (!t1.metadata || !t1.metadata.content_area) return;
            const i = e1.e.devicePixelRatio, { left: s, top: r, width: o, height: n } = t1.metadata.content_area, a = s * i, l = r * i;
            return [
                a,
                l,
                a + o * i,
                l + n * i
            ];
        }
        function Hn(t1) {
            if (t1) return t1.map(([t1, i])=>[
                    t1 * e1.e.devicePixelRatio,
                    i * e1.e.devicePixelRatio
                ]);
        }
        class Xn {
            constructor(e1, t1, i){
                this.id = e1, this.scope = t1, this.sourceCache = i, this.pendingRequests = new Set, this.missingRequests = new Set;
            }
            addPendingRequest(e1) {
                this.missingRequests.has(e1.name) || this.pendingRequests.has(e1.name) || this.pendingRequests.add(e1.name);
            }
            hasPendingRequests() {
                return this.pendingRequests.size > 0;
            }
            resolvePendingRequests() {
                const t1 = new Map;
                if (!this.sourceCache.loaded()) return t1;
                const i = this.sourceCache.getVisibleCoordinates();
                if (0 === i.length) return t1;
                const s = this.sourceCache.getSource();
                if ("raster-array" !== s.type) return t1;
                const r = i.map((e1)=>this.sourceCache.getTile(e1)), o = s.getImages(r, Array.from(this.pendingRequests));
                for (const [i, s] of o)t1.set(e1.I.from({
                    name: i,
                    iconsetId: this.id
                }), s), this.pendingRequests.delete(i);
                for (const e1 of this.pendingRequests)this.missingRequests.add(e1);
                return this.pendingRequests.clear(), t1;
            }
        }
        const Yn = (e1, t1)=>St(e1, t1 && t1.filter((e1)=>"source.canvas" !== e1.identifier)), Kn = new Set([
            "addLayer",
            "removeLayer",
            "setLights",
            "setPaintProperty",
            "setLayoutProperty",
            "setLayerProperty",
            "setSlot",
            "setFilter",
            "addSource",
            "removeSource",
            "setLayerZoomRange",
            "setLight",
            "setTransition",
            "setGeoJSONSourceData",
            "setTerrain",
            "setFog",
            "setSnow",
            "setRain",
            "setProjection",
            "setCamera",
            "addImport",
            "removeImport",
            "updateImport",
            "addIconset",
            "removeIconset"
        ]), Qn = new Set([
            "setCenter",
            "setZoom",
            "setBearing",
            "setPitch"
        ]), Jn = new Set([
            "background",
            "sky",
            "slot",
            "custom",
            "placement-group"
        ]), ea = {
            version: 8,
            layers: [],
            sources: {}
        }, ta = {
            duration: 300,
            delay: 0
        };
        function ia(e1, t1, i) {
            return `${e1}_${t1}_${i}`;
        }
        function sa(t1, i, s) {
            const r = {
                min: e1.du(0, 0, s.tileID.canonical, i.tileID.canonical),
                max: e1.du(e1.ac, e1.ac, s.tileID.canonical, i.tileID.canonical)
            }, o = t1.get(i.tileID.key);
            o ? o.push(r) : t1.set(i.tileID.key, [
                r
            ]);
        }
        function ra(e1, t1) {
            const i = new Map;
            let s = 1 / 0;
            for (const t1 of e1){
                const { z: e1, x: r, y: o } = t1.tileID.canonical;
                e1 < s && (s = e1);
                const n = ia(e1, r, o), a = i.get(n);
                a ? a.push(t1) : i.set(n, [
                    t1
                ]);
            }
            for (const r of e1){
                const { z: e1, x: o, y: n } = r.tileID.canonical, a = i.get(ia(e1, o, n));
                if (a && a.length > 1) for (const e1 of a)e1 !== r && e1.tileID.overscaledZ < r.tileID.overscaledZ && sa(t1, e1, r);
                for(let a = e1 - 1; a >= s; a--){
                    const s = e1 - a, l = i.get(ia(a, o >> s, n >> s));
                    if (l) for (const e1 of l)sa(t1, e1, r);
                }
            }
        }
        function oa(e1) {
            const t1 = new Map;
            if (e1.length < 2) return t1;
            const i = new Map;
            for (const t1 of e1){
                const e1 = i.get(t1.tileID.wrap);
                e1 ? e1.push(t1) : i.set(t1.tileID.wrap, [
                    t1
                ]);
            }
            for (const e1 of i.values())e1.length > 1 && ra(e1, t1);
            return t1;
        }
        class na extends e1.E {
            constructor(t1, i = {}){
                super(), this.map = t1, this.scope = i.scope || "", this.globalId = null, this.fragments = [], this.importDepth = i.importDepth || 0, this.importsCache = i.importsCache || new Map, this.resolvedImports = i.resolvedImports || new Set, this.transition = {
                    ...ta
                }, this._buildingIndex = new Yo(this), this.crossTileSymbolIndex = new An, this.globalPlacement = null, this._groupOrders = null, this._groupOrdersVersion = -1, this._mergedOrder = [], this._mergedOrderVersion = 0, this._drapedFirstOrder = [], this._mergedLayers = Object.create(null), this._mergedIndoor = {}, this._indoorEnabled = !1, this._mergedSourceCaches = {}, this._mergedOtherSourceCaches = Object.create(null), this._mergedSymbolSourceCaches = Object.create(null), this._mergedFillExtrusionSourceCaches = Object.create(null), this._mergedHdRoadCoverageSourceCaches = Object.create(null), this._hdCoverage = null, this._hdElevation = null, this._crossSourceElevationActive = !1, this._clipLayerPresent = !1, this._hasAppearances = !1, this._has3DLayers = !1, this._hasCircleLayers = !1, this._hasSymbolLayers = !1, this._importedAsBasemap = !1, this._changes = i.styleChanges || new b, this._hasDataDrivenEmissive = !1, this.indoorManager = null, this.dispatcher = i.dispatcher ? i.dispatcher : new ii(Qo(), this), this.glyphManager = i.glyphManager ? i.glyphManager : new he(t1._requestManager, i.localFontFamily ? e1.dF.all : i.localIdeographFontFamily ? e1.dF.ideographs : e1.dF.none, i.localFontFamily || i.localIdeographFontFamily, i.fontstackCompositing);
                const s = {
                    referrer: e1.dH(),
                    config: e1.dG()
                };
                if (this.map.painter && this.map.painter.context) {
                    const e1 = Math.floor(this.map.painter.context.maxUniformBlockSize / 4);
                    s.contextOptions = {
                        maxUniformBlockSizeDwords: e1
                    };
                }
                if (this.isRootStyle()) {
                    const { mode: t1, fontFamily: i } = this.glyphManager.localGlyphs;
                    i && !e1.dI(i) && (s.localGlyphs = {
                        mode: t1,
                        fontFamily: i
                    }), this.dispatcher.broadcast("setGlobalParams", s);
                }
                i.imageManager ? this.imageManager = i.imageManager : (this.imageManager = new le(this.map._spriteFormat), this.imageManager.setEventedParent(this)), this.imageManager.addScope(this.scope), i.modelManager ? this.modelManager = i.modelManager : (this.modelManager = new jn(t1._requestManager), this.modelManager.setEventedParent(this)), this._layers = Object.create(null), this._sourceCaches = {}, this._otherSourceCaches = Object.create(null), this._symbolSourceCaches = Object.create(null), this._fillExtrusionSourceCaches = Object.create(null), this._hdCoverage = null, this._hdElevation = null, this._crossSourceElevationActive = !1, this._loaded = !1, this._drapingLoaded = void 0, this._rasterArrayLoaded = void 0, this._initialBroadcastDone = !1, this._programPrecompiler = this.map._precompilePrograms && this.isRootStyle() ? new $n : null, this._availableImages = [], this._availableModels = {}, this._order = [], this._markersNeedUpdate = !1, this.options = i.configOptions ? i.configOptions : new Map, this._layerExpressionDependencies = i.layerExpressionDependencies ? i.layerExpressionDependencies : new Map, this._config = i.config, this._styleColorTheme = {
                    lut: null,
                    lutLoading: !1,
                    lutLoadingCorrelationID: 0,
                    colorTheme: null,
                    colorThemeOverride: i.colorThemeOverride
                }, this._styleColorThemeForScope = {}, this._initialConfig = i.initialConfig, this.on("data", (e1)=>{
                    if ("source" !== e1.dataType || "metadata" !== e1.sourceDataType) return;
                    const t1 = this.getOwnSource(e1.sourceId);
                    if (t1 && t1.vectorLayerIds) for(const e1 in this._layers){
                        const i = this._layers[e1];
                        i.source === t1.id && this._validateLayer(i);
                    }
                });
            }
            load(e1) {
                return e1 ? ("string" == typeof e1 ? this.loadURL(e1) : this.loadJSON(e1), this) : this;
            }
            _getGlobalId(t1) {
                if (!t1) return null;
                if ("string" == typeof t1) {
                    if (e1.cX(t1)) return t1;
                    const i = e1.dJ(t1);
                    if (!i.startsWith("http")) try {
                        return new URL(i, location.href).toString();
                    } catch (e1) {
                        return i;
                    }
                    return i;
                }
                return `json://${e1.dK(JSON.stringify(t1))}`;
            }
            _diffStyle(t1, i, s) {
                this.globalId = this._getGlobalId(t1), Tt();
                const r = (e1, t1)=>{
                    try {
                        t1(null, this.setState(e1, s));
                    } catch (e1) {
                        t1(e1, !1);
                    }
                };
                if ("string" == typeof t1) {
                    const s = this.map._requestManager.normalizeStyleURL(t1), o = new AbortController;
                    this._request = {
                        cancel: ()=>o.abort()
                    }, (async ()=>{
                        const t1 = await this.map._requestManager.transformRequest(s, e1.R.Style, o.signal), { data: n } = await e1.g(t1, o.signal);
                        this._request = null, r(n, i);
                    })().catch((t1)=>{
                        this._request = null, o.signal.aborted || this.fire(new e1.h(t1));
                    });
                } else "object" == typeof t1 && r(t1, i);
            }
            loadURL(t1, i = {}) {
                this.fire(new e1.i("dataloading", {
                    dataType: "style"
                }));
                const s = "boolean" == typeof i.validate ? i.validate : !e1.cX(t1);
                s && Tt(), t1.startsWith("mapbox://styles/mapbox/standard") && ui(), this.globalId = this._getGlobalId(t1), t1 = this.map._requestManager.normalizeStyleURL(t1, i.accessToken), this.resolvedImports.add(t1);
                const r = this.importsCache.get(t1);
                if (r) return void this._load(r, s);
                const o = new AbortController;
                this._request = {
                    cancel: ()=>o.abort()
                }, (async ()=>{
                    const i = await this.map._requestManager.transformRequest(t1, e1.R.Style, o.signal), { data: r } = await e1.g(i, o.signal);
                    this._request = null, this.importsCache.set(t1, r), this._load(r, s);
                })().catch((t1)=>{
                    this._request = null, o.signal.aborted || this.fire(new e1.h(t1));
                });
            }
            loadJSON(t1, i = {}) {
                this.fire(new e1.i("dataloading", {
                    dataType: "style"
                }));
                const s = !1 !== i.validate;
                s && Tt(), this.globalId = this._getGlobalId(t1), this._request = e1.e.frame(()=>{
                    this._request = null, this._load(t1, s);
                });
            }
            loadEmpty() {
                this.fire(new e1.i("dataloading", {
                    dataType: "style"
                })), this._load(ea, !1);
            }
            _loadImports(t1, i, s) {
                if (this.importDepth >= 4) return e1.w("Style doesn't support nesting deeper than 5"), Promise.resolve();
                const r = [];
                for (const o of t1){
                    const t1 = this._createFragmentStyle(o), n = new Promise((e1)=>{
                        t1.once("style.import.load", e1), t1.once("error", (i)=>{
                            t1._loaded || e1(i);
                        });
                    }).then(()=>{
                        this.mergeAll(), this.fire(new e1.i("data", {
                            dataType: "style"
                        }));
                    });
                    if (r.push(n), this.resolvedImports.has(o.url)) {
                        t1.loadEmpty();
                        continue;
                    }
                    const a = o.data || this.importsCache.get(o.url);
                    a ? (o.data ? (t1.fire(new e1.i("dataloading", {
                        dataType: "style"
                    })), t1.globalId = t1._getGlobalId(a), i && Tt(), queueMicrotask(()=>{
                        t1._load(a, i);
                    })) : t1.loadJSON(a, {
                        validate: i
                    }), this._isInternalStyle(a) && (t1.globalId = null)) : o.url ? t1.loadURL(o.url, {
                        validate: i
                    }) : t1.loadEmpty();
                    const l = {
                        style: t1,
                        id: o.id,
                        config: o.config
                    };
                    if (s) {
                        const e1 = this.fragments.findIndex(({ id: e1 })=>e1 === s);
                        this.fragments = this.fragments.slice(0, e1).concat(l).concat(this.fragments.slice(e1));
                    } else this.fragments.push(l);
                }
                return Promise.allSettled(r);
            }
            getImportGlobalIds(e1 = this, t1 = new Set) {
                for (const i of e1.fragments)i.style.globalId && t1.add(i.style.globalId), this.getImportGlobalIds(i.style, t1);
                return [
                    ...t1.values()
                ];
            }
            _createFragmentStyle(t1) {
                const i = this.scope ? e1.m(t1.id, this.scope) : t1.id;
                let s;
                const r = this._initialConfig && this._initialConfig[i];
                (t1.config || r) && (s = {
                    ...t1.config,
                    ...r
                });
                const o = new na(this.map, {
                    scope: i,
                    styleChanges: this._changes,
                    importDepth: this.importDepth + 1,
                    importsCache: this.importsCache,
                    resolvedImports: new Set(this.resolvedImports),
                    dispatcher: this.dispatcher,
                    imageManager: this.imageManager,
                    glyphManager: this.glyphManager,
                    modelManager: this.modelManager,
                    config: s,
                    configOptions: this.options,
                    colorThemeOverride: t1["color-theme"],
                    layerExpressionDependencies: this._layerExpressionDependencies
                });
                return o.setEventedParent(this.map, {
                    style: o
                }), o;
            }
            _reloadImports(e1 = !1) {
                this.mergeAll(), this._updateMapProjection(), e1 ? this._updateEnvConfig("reset") : this.updateConfigDependencies(), this._updateLayers(this._dependentLayerIds((e1)=>e1.isIndoorDependent)), this.map._triggerCameraUpdate(this.camera), (!e1 || this.isRootStyle() || this.map.style._initialBroadcastDone) && (e1 && this.isRootStyle() ? (this.forEachFragmentStyle((e1)=>{
                    this.dispatcher.broadcast("setLayers", {
                        layers: e1._serializeLayers(e1._order),
                        scope: e1.scope,
                        options: e1.options
                    });
                }), this._initialBroadcastDone = !0) : this.dispatcher.broadcast("setLayers", {
                    layers: this._serializeLayers(this._order),
                    scope: this.scope,
                    options: this.options
                }));
            }
            _isInternalStyle(e1) {
                return this.isRootStyle() && (e1.fragment || !!e1.schema && !1 !== e1.fragment);
            }
            async _load(t1, i) {
                if (this._isInternalStyle(t1)) {
                    const e1 = {
                        id: "basemap",
                        data: t1,
                        url: ""
                    }, s = {
                        ...ea,
                        imports: [
                            e1
                        ],
                        ...t1.center ? {
                            center: t1.center
                        } : {},
                        ...t1.bearing ? {
                            bearing: t1.bearing
                        } : {},
                        ...t1.pitch ? {
                            pitch: t1.pitch
                        } : {},
                        ...t1.zoom ? {
                            zoom: t1.zoom
                        } : {},
                        ...t1.light ? {
                            light: t1.light
                        } : {}
                    };
                    return this._importedAsBasemap = !0, void this._load(s, i);
                }
                if (i) {
                    if (await Tt(), !this.dispatcher.actors.length) return;
                    if (Yn(this, Et(t1))) return;
                }
                t1.sprite && this._loadIconset(t1.sprite), this._loaded = !0, this.updateConfig(this._config, t1.schema);
                for(const e1 in t1.sources)this.addSource(e1, t1.sources[e1], {
                    validate: !1,
                    isInitialLoad: !0
                });
                this.stylesheet = e1.dL(t1);
                const s = ()=>{
                    if (t1.iconsets) for(const e1 in t1.iconsets)this.addIconset(e1, t1.iconsets[e1]);
                    t1.sprite || (this.imageManager.setLoaded(!0, this.scope), this.dispatcher.broadcast("spriteLoaded", {
                        scope: this.scope
                    })), !this.glyphManager.url && t1.glyphs && this.glyphManager.setURL(t1.glyphs);
                    const s = en(this.stylesheet.layers);
                    if (this._order = s.map((e1)=>e1.id), this.stylesheet.light && e1.w("The `light` root property is deprecated, prefer using `lights` with `flat` light type instead."), this.stylesheet.lights) {
                        if (1 === this.stylesheet.lights.length && "flat" === this.stylesheet.lights[0].type) {
                            const e1 = this.stylesheet.lights[0];
                            this.light = new Vt(e1.properties, e1.id);
                        } else this.setLights(this.stylesheet.lights);
                    }
                    this.light || (this.light = new Vt(this.stylesheet.light)), this._layers = Object.create(null);
                    let r = !1;
                    for (const t1 of s){
                        const i = e1.dR(t1, this.scope, this._styleColorTheme.lut, this.options);
                        this._layerExpressionDependencies.set(i.fqid, new x(i)), this._hasAppearances = this._hasAppearances || 0 !== i.getAppearances().length, i.setEventedParent(this, {
                            layer: {
                                id: i.id
                            }
                        }), this._layers[i.id] = i, this._updateHdCoverageSourceCache(i) && (r = !0);
                        const s = this.getOwnLayerSourceCache(i), o = !!this.directionalLight && this.directionalLight.shadowsEnabled();
                        s && i.canCastShadows() && o && (s.castsShadows = !0);
                    }
                    r && Ys().then(()=>{
                        if (!this.map) return;
                        for(const e1 in this._layers)this._updateHdCoverageSourceCache(this._layers[e1]);
                        this.map.style.mergeAll();
                        const e1 = this.map.transform;
                        for(const t1 in this.map.style._mergedHdRoadCoverageSourceCaches){
                            const i = this.map.style._mergedHdRoadCoverageSourceCaches[t1];
                            i.used = !0, e1 && i.update(e1);
                        }
                        this.map._update();
                    }), this.stylesheet.featuresets && this.setFeaturesetSelectors(this.stylesheet.featuresets), this.stylesheet.models && this.addModelURLs(this.stylesheet.models);
                    const o = this.stylesheet.terrain;
                    o && (this.checkCanvasFingerprintNoise(), this.disableElevatedTerrain || this.terrainSetForDrapingOnly() || (this._startLiteLoad(), this._createTerrain(o, 1))), this.stylesheet.fog && this._createFog(this.stylesheet.fog), this.stylesheet.snow && this._createSnow(this.stylesheet.snow), this.stylesheet.rain && this._createRain(this.stylesheet.rain), this.stylesheet.transition && this.setTransition(this.stylesheet.transition), this.fire(new e1.i("data", {
                        dataType: "style"
                    }));
                    const n = this.isRootStyle();
                    t1.imports ? this._loadImports(t1.imports, i).then(()=>{
                        this._reloadImports(!0), this.fire(new e1.i(n ? "style.load" : "style.import.load"));
                    }).catch((t1)=>{
                        this.fire(new e1.h(new Error("Failed to load imports", t1))), this.fire(new e1.i(n ? "style.load" : "style.import.load"));
                    }) : (this._reloadImports(!0), this.fire(new e1.i(n ? "style.load" : "style.import.load")));
                };
                this._styleColorTheme.colorTheme = this.stylesheet["color-theme"];
                const r = this._styleColorTheme.colorThemeOverride ? this._styleColorTheme.colorThemeOverride : this._styleColorTheme.colorTheme;
                if (r) {
                    const t1 = this._evaluateColorThemeData(r);
                    this._loadColorTheme(t1).then(()=>{
                        s();
                    }).catch((t1)=>{
                        e1.w(`Couldn't load color theme from the stylesheet: ${t1}`), s();
                    });
                } else this._styleColorTheme.lut = null, s();
            }
            isRootStyle() {
                return 0 === this.importDepth;
            }
            hasAppearances() {
                return this._hasAppearances || this.fragments.some((e1)=>e1.style.hasAppearances());
            }
            mergeAll() {
                let e1, t1, i, s, r, o, n, a, l, c;
                const h = {};
                this.terrain && this.terrain.scope !== this.scope && delete this.terrain, this.forEachFragmentStyle((d)=>{
                    if (d.stylesheet) {
                        if (d.disableElevatedTerrain && (this.disableElevatedTerrain = !0), null != d.light && (e1 = d.light), d.stylesheet.lights) for (const e1 of d.stylesheet.lights)"ambient" === e1.type && null != d.ambientLight && (t1 = d.ambientLight), "directional" === e1.type && null != d.directionalLight && (i = d.directionalLight);
                        s = this._prioritizeTerrain(s, d.terrain, d.stylesheet.terrain), d.stylesheet.fog && null != d.fog && (r = d.fog), d.stylesheet.snow && null != d.snow && (o = d.snow), d.stylesheet.rain && null != d.rain && (n = d.rain), null != d.stylesheet.camera && (c = d.stylesheet.camera), null != d.stylesheet.projection && (a = d.stylesheet.projection), null != d.stylesheet.transition && (l = d.stylesheet.transition), h[d.scope] = d._styleColorTheme;
                    }
                }), this.light = e1, this.ambientLight = t1, this.directionalLight = i, this.fog = r, this.snow = o, this.rain = n, this._styleColorThemeForScope = h, null === s ? delete this.terrain : this.terrain = s, this.camera = c || {
                    "camera-projection": "perspective"
                }, this.projection = a || {
                    name: "mercator"
                }, this.transition = {
                    ...ta,
                    ...l
                }, this.mergeSources(), this.mergeLayers(), this.mergeIndoor(), this._programPrecompiler && this._programPrecompiler.reset();
            }
            forEachFragmentStyle(e1) {
                const t1 = (i)=>{
                    for (const e1 of i.fragments)t1(e1.style);
                    e1(i);
                };
                t1(this);
            }
            _prioritizeTerrain(e1, t1, i) {
                const s = e1 && 0 === e1.drapeRenderMode;
                return null === i ? t1 && 0 === t1.drapeRenderMode ? t1 : s ? e1 : null : null != t1 && (!e1 || s || t1 && 1 === t1.drapeRenderMode) ? t1 : e1;
            }
            mergeTerrain() {
                let e1;
                this.terrain && this.terrain.scope !== this.scope && delete this.terrain, this.forEachFragmentStyle((t1)=>{
                    e1 = this._prioritizeTerrain(e1, t1.terrain, t1.stylesheet.terrain);
                }), null === e1 ? delete this.terrain : this.terrain = e1, this._programPrecompiler && this._programPrecompiler.reset();
            }
            mergeProjection() {
                let e1;
                this.forEachFragmentStyle((t1)=>{
                    null != t1.stylesheet.projection && (e1 = t1.stylesheet.projection);
                }), this.projection = e1 || {
                    name: "mercator"
                }, this._programPrecompiler && this._programPrecompiler.reset();
            }
            mergeSources() {
                const t1 = {}, i = Object.create(null), s = Object.create(null), r = Object.create(null), o = Object.create(null);
                this.forEachFragmentStyle((n)=>{
                    for(const i in n._sourceCaches){
                        const s = e1.m(i, n.scope);
                        t1[s] = n._sourceCaches[i];
                    }
                    for(const t1 in n._otherSourceCaches){
                        const s = e1.m(t1, n.scope);
                        i[s] = n._otherSourceCaches[t1];
                    }
                    for(const t1 in n._symbolSourceCaches){
                        const i = e1.m(t1, n.scope);
                        s[i] = n._symbolSourceCaches[t1];
                    }
                    for(const t1 in n._fillExtrusionSourceCaches){
                        const i = e1.m(t1, n.scope);
                        r[i] = n._fillExtrusionSourceCaches[t1];
                    }
                    if (n._hdCoverage) {
                        const t1 = n._hdCoverage.coverageSourceCaches;
                        for(const i in t1)o[e1.m(i, n.scope)] = t1[i];
                    }
                }), this._mergedSourceCaches = t1, this._mergedOtherSourceCaches = i, this._mergedSymbolSourceCaches = s, this._mergedFillExtrusionSourceCaches = r, this._mergedHdRoadCoverageSourceCaches = o, Object.keys(o).length > 0 && !this._hdCoverage && Xs.HdCoverageState && (this._hdCoverage = new Xs.HdCoverageState), Xs.updateCrossSourceElevationGate && Xs.updateCrossSourceElevationGate(this);
            }
            mergeIndoor() {
                this._mergedIndoor = {}, this.forEachFragmentStyle((t1)=>{
                    if (t1.stylesheet && t1.stylesheet.indoor) for (const i of Object.values(t1.stylesheet.indoor)){
                        const s = i, r = e1.m(s.sourceId, t1.scope);
                        this._mergedIndoor[r] = new Set(s.sourceLayers || []);
                    }
                }), this._updateIndoorEnabled();
            }
            _updateIndoorEnabled() {
                const t1 = this._indoorEnabled;
                if (this._indoorEnabled = !1, Object.keys(this._mergedIndoor).length > 0) for (const t1 of this._mergedOrder){
                    const i = this._mergedLayers[t1];
                    if ("none" !== i.visibility && this._mergedIndoor[e1.m(i.source, i.scope)]) {
                        this._indoorEnabled = !0;
                        break;
                    }
                }
                !this._indoorEnabled || t1 || this.indoorManager || Ys().then(()=>{
                    this._initIndoorManager();
                });
            }
            _initIndoorManager() {
                if (!this.indoorManager && Xs.IndoorManager && this.isRootStyle() && 0 !== Object.keys(this._mergedIndoor).length && (this.indoorManager = new Xs.IndoorManager(this, this._loaded), this._loaded)) for (const e1 of Object.keys(this._mergedIndoor)){
                    const t1 = this._mergedSourceCaches[e1] || this._mergedOtherSourceCaches[e1];
                    t1 && t1.reload();
                }
            }
            mergeLayers() {
                const t1 = {}, i = [], s = Object.create(null);
                this._mergedSlots = [], this._has3DLayers = !1, this._hasCircleLayers = !1, this._hasSymbolLayers = !1, this.forEachFragmentStyle((s)=>{
                    for (const r of s._order){
                        const o = s._layers[r];
                        if ("slot" === o.type) {
                            const i = e1.dM(r);
                            if (t1[i]) continue;
                            t1[i] = [];
                        }
                        o.slot && t1[o.slot] ? t1[o.slot].push(o) : i.push(o);
                    }
                }), this._mergedOrder = [];
                let r = -1;
                const o = (i = [])=>{
                    for (const n of i)if ("slot" === n.type) {
                        const i = e1.dM(n.id);
                        t1[i] && o(t1[i]), this._mergedSlots.push(i);
                    } else {
                        const t1 = e1.m(n.id, n.scope);
                        this._mergedOrder.push(t1), s[t1] = n, n.is3D(!!this.terrain) && (this._has3DLayers = !0, r = this._mergedOrder.length - 1), "circle" === n.type && (this._hasCircleLayers = !0), "symbol" === n.type && (this._hasSymbolLayers = !0), "clip" === n.type && (this._clipLayerPresent = !0);
                    }
                };
                if (o(i), this._has3DLayers) {
                    const e1 = {};
                    for(let t1 = 0; t1 < this._mergedOrder.length; ++t1){
                        const i = this._mergedOrder[t1];
                        e1[i] = t1 === r ? 1 : t1 < r ? s[i].hasOcclusionOpacityProperties ? 2 : 0 : 4;
                    }
                    this._mergedOrder.sort((t1, i)=>e1[t1] - e1[i]);
                }
                this._mergedLayers = s, this._mergedOrderVersion++, this.updateDrapeFirstLayers(), this._buildingIndex.processLayersChanged(), this._updateDataDrivenEmissiveStrength();
            }
            terrainSetForDrapingOnly() {
                return !!this.terrain && 0 === this.terrain.drapeRenderMode;
            }
            getCamera() {
                return this.stylesheet.camera;
            }
            setCamera(e1) {
                return this.stylesheet.camera = {
                    ...this.stylesheet.camera,
                    ...e1
                }, this.camera = this.stylesheet.camera, this;
            }
            _evaluateColorThemeData(t1) {
                return t1.data ? new e1.dE(Zn, t1.data, this.scope, this.options).possiblyEvaluate(new e1.au(0)) : null;
            }
            _loadColorTheme(t1) {
                this._styleColorTheme.lutLoading = !0, this._styleColorTheme.lutLoadingCorrelationID += 1;
                const i = this._styleColorTheme.lutLoadingCorrelationID;
                return new Promise((s, r)=>{
                    const o = "data:image/png;base64,";
                    if (!t1 || 0 === t1.length) return this._styleColorTheme.lut = null, this._styleColorTheme.lutLoading = !1, void s();
                    let n = t1;
                    n.startsWith(o) || (n = o + n);
                    const a = e1.I.from("mapbox-reserved-lut"), l = new Image;
                    l.src = n, l.onerror = ()=>{
                        this._styleColorTheme.lutLoading = !1, r(new Error("Failed to load image data"));
                    }, l.onload = ()=>{
                        if (this._styleColorTheme.lutLoadingCorrelationID !== i) return void s();
                        this._styleColorTheme.lutLoading = !1;
                        const { width: o, height: n, data: c } = e1.e.getImageData(l);
                        if (n > 32) return void r(new Error("The height of the image must be less than or equal to 32 pixels."));
                        if (o !== n * n) return void r(new Error("The width of the image must be equal to the height squared."));
                        this.getImage(a) && this.removeImage(a), this.addImage(a, {
                            data: new e1.b({
                                width: o,
                                height: n
                            }, c),
                            pixelRatio: 1,
                            sdf: !1,
                            usvg: !1,
                            version: 0
                        });
                        const h = this.imageManager.getImage(a, this.scope);
                        h ? (this._styleColorTheme.lut = {
                            image: h.data,
                            data: t1
                        }, s()) : r(new Error("Missing LUT image."));
                    };
                });
            }
            getLut(e1) {
                const t1 = this._styleColorThemeForScope[e1];
                return t1 ? t1.lut : null;
            }
            setProjection(e1) {
                e1 ? this.stylesheet.projection = e1 : delete this.stylesheet.projection, this.mergeProjection(), this._updateMapProjection();
            }
            applyProjectionUpdate() {
                this.map.transform.projection.requiresDraping && this._startLiteLoad(), this._loaded && (this.dispatcher.broadcast("setProjection", this.map.transform.projectionOptions), this.map.transform.projection.requiresDraping ? (this.getTerrain() || this.stylesheet.terrain) && !this.disableElevatedTerrain || this.setTerrainForDraping() : this.terrainSetForDrapingOnly() && this.setTerrain(null, 0));
            }
            _updateMapProjection() {
                this.isRootStyle() && (this.map._useExplicitProjection ? this.applyProjectionUpdate() : this.map._prioritizeAndUpdateProjection(null, this.projection));
            }
            _loadSprite(t1) {
                const i = new AbortController;
                this._spriteRequest = i, function(t1, i, s, r) {
                    let o, n, a;
                    const l = e1.e.devicePixelRatio > 1 ? "@2x" : "";
                    function c(t1) {
                        a || t1 && s.aborted || (t1 && (a = t1), function() {
                            if (a) r(a);
                            else if (o && n) {
                                const t1 = e1.e.getImageData(n), i = {};
                                for(const s in o){
                                    const { width: r, height: n, x: a, y: l, sdf: c, pixelRatio: h, stretchX: d, stretchY: u, content: p } = o[s], f = new e1.b({
                                        width: r,
                                        height: n
                                    });
                                    e1.b.copy(t1, f, {
                                        x: a,
                                        y: l
                                    }, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        width: r,
                                        height: n
                                    }, null), i[s] = {
                                        data: f,
                                        pixelRatio: void 0 !== h ? h : 1,
                                        sdf: void 0 !== c && c,
                                        stretchX: d,
                                        stretchY: u,
                                        content: p,
                                        usvg: !1,
                                        version: 0
                                    };
                                }
                                r(null, i);
                            }
                        }());
                    }
                    (async function() {
                        const r = await i.transformRequest(i.normalizeSpriteURL(t1, l, ".json"), e1.R.SpriteJSON, s), { data: n } = await e1.g(r, s);
                        a || (o = n);
                    })().then(()=>c(void 0), (e1)=>c(e1)), (async function() {
                        const r = await i.transformRequest(i.normalizeSpriteURL(t1, l, ".png"), e1.R.SpriteImage, s), { data: o } = await e1.a(r, s);
                        a || (n = o);
                    })().then(()=>c(void 0), (e1)=>c(e1));
                }(t1, this.map._requestManager, i.signal, (t1, i)=>{
                    if (this._spriteRequest = null, t1) this.dispatcher.broadcast("spriteLoaded", {
                        scope: this.scope
                    }), this.fire(new e1.h(t1));
                    else if (i) {
                        const t1 = new Map;
                        for(const s in i)t1.set(e1.I.from(s), i[s]);
                        this.addImages(t1, !0);
                    }
                    this.imageManager.setLoaded(!0, this.scope), this.fire(new e1.i("data", {
                        dataType: "style"
                    }));
                });
            }
            addIconset(t1, i) {
                if ("sprite" === i.type) return void this._loadSprite(i.url);
                const s = this.getOwnSourceCache(i.source);
                if (!s) return void this.fire(new e1.h(new Error(`Source "${i.source}" as specified by iconset "${t1}" does not exist and cannot be used as an iconset source`)));
                if ("raster-array" !== s.getSource().type) return void this.fire(new e1.h(new Error(`Source "${i.source}" as specified by iconset "${t1}" is not a "raster-array" source and cannot be used as an iconset source`)));
                const r = new Xn(t1, this.scope, s);
                this.imageManager.addImageProvider(r, this.scope);
            }
            removeIconset(e1) {
                this.imageManager.removeImageProvider(e1, this.scope);
            }
            _loadIconset(t1) {
                if (!e1.cX(t1) && "icon_set" !== this.map._spriteFormat || "raster" === this.map._spriteFormat) return void this._loadSprite(t1);
                const i = "auto" === this.map._spriteFormat, s = new AbortController;
                this._spriteRequest = s, async function(t1, i, s, r) {
                    try {
                        const o = await i.transformRequest(i.normalizeIconsetURL(t1), e1.R.Iconset, s), { data: n } = await e1.n(o, s), a = {}, l = function(e1) {
                            const t1 = {
                                icons: []
                            };
                            let i;
                            for(; i = e1.nextField(void 0);)1 === i && t1.icons.push(C(e1, e1.readVarint() + e1.pos));
                            return t1;
                        }(new e1.d(n));
                        for (const t1 of l.icons){
                            const i = {
                                version: 1,
                                pixelRatio: e1.e.devicePixelRatio,
                                content: Wn(t1),
                                stretchX: t1.metadata ? Hn(t1.metadata.stretch_x_areas) : void 0,
                                stretchY: t1.metadata ? Hn(t1.metadata.stretch_y_areas) : void 0,
                                sdf: !1,
                                usvg: !0,
                                icon: t1
                            };
                            a[t1.name] = i;
                        }
                        r(null, a);
                    } catch (e1) {
                        s.aborted || r(e1);
                    }
                }(t1, this.map._requestManager, s.signal, (s, r)=>{
                    if (this._spriteRequest = null, s) i ? this._loadSprite(t1) : (this.dispatcher.broadcast("spriteLoaded", {
                        scope: this.scope
                    }), this.fire(new e1.h(s)));
                    else if (r) {
                        const t1 = new Map;
                        for(const i in r)t1.set(e1.I.from(i), r[i]);
                        this.addImages(t1, !0);
                    }
                    this.imageManager.setLoaded(!0, this.scope), this.fire(new e1.i("data", {
                        dataType: "style"
                    }));
                });
            }
            _validateLayer(t1) {
                const i = this.getOwnSource(t1.source);
                if (!i) return;
                const s = t1.sourceLayer;
                s && ("geojson" === i.type || i.vectorLayerIds && !i.vectorLayerIds.includes(s)) && this.fire(new e1.h(new Error(`Source layer "${s}" does not exist on source "${i.id}" as specified by style layer "${t1.id}"`)));
            }
            loaded() {
                if (!this._loaded) return !1;
                if (Object.keys(this._changes.getUpdatedSourceCaches()).length) return !1;
                for(const e1 in this._sourceCaches)if (!this._sourceCaches[e1].loaded()) return !1;
                if (!this.imageManager.isLoaded()) return !1;
                if (this.imageManager.hasPatternsInFlight()) return !1;
                if (!this.modelManager.isLoaded()) return !1;
                if (this._styleColorTheme.lutLoading) return !1;
                if (!1 === this._drapingLoaded) return !1;
                if (!1 === this._rasterArrayLoaded) return !1;
                for (const { style: e1 } of this.fragments)if (!e1.loaded()) return !1;
                return !0;
            }
            _serializeImports() {
                if (this.stylesheet.imports) return this.stylesheet.imports.map((e1, t1)=>{
                    const i = this.fragments[t1];
                    return i && i.style && (e1.data = i.style.serialize()), e1;
                });
            }
            _serializeSources() {
                const e1 = {};
                for(const t1 in this._sourceCaches){
                    const i = this._sourceCaches[t1].getSource();
                    e1[i.id] || (e1[i.id] = i.serialize());
                }
                return e1;
            }
            _serializeLayers(e1) {
                const t1 = [];
                for (const i of e1){
                    const e1 = this._layers[i];
                    e1 && "custom" !== e1.type && t1.push(e1.serialize());
                }
                return t1;
            }
            hasLightTransitions() {
                return !(!this.light || !this.light.hasTransition()) || !(!this.ambientLight || !this.ambientLight.hasTransition()) || !(!this.directionalLight || !this.directionalLight.hasTransition());
            }
            hasFogTransition() {
                return !!this.fog && this.fog.hasTransition();
            }
            hasSnowTransition() {
                return !!this.snow && this.snow.hasTransition();
            }
            hasRainTransition() {
                return !!this.rain && this.rain.hasTransition();
            }
            hasTransitions() {
                if (this.hasLightTransitions()) return !0;
                if (this.hasFogTransition()) return !0;
                if (this.hasSnowTransition()) return !0;
                if (this.hasRainTransition()) return !0;
                for(const e1 in this._mergedSourceCaches)if (this._mergedSourceCaches[e1].hasTransition()) return !0;
                for(const e1 in this._mergedLayers)if (this._mergedLayers[e1].hasTransition()) return !0;
                return !1;
            }
            _updateDataDrivenEmissiveStrength() {
                for(const e1 in this._mergedLayers){
                    const t1 = this._mergedLayers[e1].getPaintPropertyValue("line-emissive-strength");
                    if (t1 && t1.isDataDriven()) return void (this._hasDataDrivenEmissive = !0);
                }
                this._hasDataDrivenEmissive = !1;
            }
            hasDataDrivenEmissiveStrength() {
                return this._hasDataDrivenEmissive;
            }
            get order() {
                return this.terrain ? this._drapedFirstOrder : this._mergedOrder;
            }
            _getOrder(e1) {
                return e1 ? this.order : this._mergedOrder;
            }
            isLayerDraped(e1) {
                return !!this.terrain && e1.isDraped(this.getLayerSourceCache(e1));
            }
            _checkLoaded() {
                if (!this._loaded) throw new Error("Style is not done loading");
            }
            _checkLayer(t1) {
                const i = this.getOwnLayer(t1);
                if (i) return i;
                this.fire(new e1.h(new Error(`The layer '${t1}' does not exist in the map's style.`)));
            }
            _checkSource(t1) {
                const i = this.getOwnSource(t1);
                if (i) return i;
                this.fire(new e1.h(new Error(`The source '${t1}' does not exist in the map's style.`)));
            }
            _resolveLayerFragment(t1) {
                const i = this.getLayer(t1);
                if (!i) return void this.fire(new e1.h(new Error(`The layer '${t1}' does not exist in the map's style.`)));
                const s = this.getFragmentStyle(i.scope);
                return s ? {
                    layer: i,
                    fragment: s
                } : void 0;
            }
            handleIdle() {
                const e1 = this.map.painter;
                e1 && (e1.context.sweepPendingPrograms(), this._programPrecompiler && this._programPrecompiler.processQueue(e1, this));
            }
            handleContextLost() {
                this._programPrecompiler && this._programPrecompiler.reset();
            }
            update(t1) {
                if (!this._loaded) return;
                this.ambientLight && this.ambientLight.recalculate(t1), this.directionalLight && this.directionalLight.recalculate(t1);
                const i = this.calculateLightsBrightness();
                t1.brightness = i || 0;
                let s = !1;
                i !== this._brightness && (this._brightness = i, s = !0), t1.worldview !== this._worldview && (this._worldview = t1.worldview, s = !0), s && this.dispatcher.broadcast("upsertRenderParams", {
                    brightness: this._brightness,
                    worldview: this._worldview
                });
                const r = this._changes.isDirty();
                let o = !1;
                if (this._changes.isDirty()) {
                    const e1 = this._changes.getLayerUpdatesByScope();
                    for(const t1 in e1){
                        const { updatedIds: i, removedIds: s } = e1[t1];
                        (i || s) && (this._updateWorkerLayers(t1, i, s), o = !0);
                    }
                    this.updateSourceCaches(), this._updateTilesForChangedImages(), this.updateLayers(t1), this.light && this.light.updateTransitions(t1), this.ambientLight && this.ambientLight.updateTransitions(t1), this.directionalLight && this.directionalLight.updateTransitions(t1), this.fog && this.fog.updateTransitions(t1), this.snow && this.snow.updateTransitions(t1), this.rain && this.rain.updateTransitions(t1), this._changes.reset();
                }
                const n = {};
                for(const e1 in this._mergedSourceCaches){
                    const t1 = this._mergedSourceCaches[e1];
                    n[e1] = t1.used, t1.used = !1, t1.tileCoverLift = 0;
                }
                const a = {};
                for (const i of this._mergedOrder){
                    const s = this._mergedLayers[i], r = s.paint;
                    if ("none" === s.visibility && !s.hasTransition() || !s._dirty && s.isHidden(t1.zoom) || s.recalculate(t1, this._availableImages), r && r !== s.paint && s.isPlacementAffectedByPaintChanges(r) && this._setLabelPlacementStale(), !s.isHidden(t1.zoom)) {
                        s.mayUse("HD") && (s.prepare(), Ys()), s.mayUse("Standard") && (s.prepare(), ui()), s.mayUse("Lite") && (this.checkCanvasFingerprintNoise(), this.disableElevatedTerrain || this._startLiteLoad()), s.mayUse("RasterArray") && this._startRasterArrayLoad();
                        const e1 = this.getLayerSourceCache(s);
                        e1 && (e1.used = !0, e1.tileCoverLift = Math.max(e1.tileCoverLift, s.tileCoverLift()));
                    }
                    if (s.source) {
                        const e1 = this._mergedHdRoadCoverageSourceCaches[s.sourceFqid];
                        e1 && !e1.used && (e1.used = !0);
                    }
                    if ("fill-extrusion" === s.type) {
                        const t1 = e1.m(s.source, s.scope);
                        if (t1 in this._mergedFillExtrusionSourceCaches) {
                            const e1 = s.layout && s.layout.get("source-max-zoom");
                            if (null != e1) {
                                const i = a[t1];
                                a[t1] = null == i ? e1 : Math.min(i, e1);
                            }
                        }
                    }
                }
                if (this._programPrecompiler && this._programPrecompiler.needsBuild()) {
                    const e1 = this._mergedOrder.map((e1)=>this._mergedLayers[e1]);
                    this._programPrecompiler.buildQueue(e1, t1, this);
                }
                for(const e1 in this._mergedFillExtrusionSourceCaches)this._mergedFillExtrusionSourceCaches[e1].setMaxzoomOverride(a[e1] ?? null);
                this.terrain && o && this.mergeLayers();
                const l = this.imageManager.getPendingImageProviders();
                for (const e1 of l)e1.sourceCache.used = !0;
                for(const t1 in n){
                    const i = this._mergedSourceCaches[t1], s = i.getSource();
                    i.used && s instanceof vs && s.startLoad(), n[t1] !== i.used && s.fire(new e1.i("data", {
                        sourceDataType: "visibility",
                        dataType: "source",
                        sourceId: s.id
                    }));
                }
                this.light && this.light.recalculate(t1), this.terrain && this.terrain.recalculate(t1), this.fog && this.fog.recalculate(t1), this.snow && this.snow.recalculate(t1), this.rain && this.rain.recalculate(t1), this.z = t1.zoom, this._markersNeedUpdate && (this._updateMarkersOpacity(), this._markersNeedUpdate = !1), this.imageManager.clearUpdatedImages(this.scope), r && this.fire(new e1.i("data", {
                    dataType: "style"
                }));
            }
            updateImageProviders() {
                const e1 = this.imageManager.getPendingImageProviders();
                for (const t1 of e1){
                    const e1 = t1.resolvePendingRequests(), i = this.getFragmentStyle(t1.scope);
                    i && i.addImages(e1);
                }
            }
            _updateTilesForChangedImages() {
                const e1 = {};
                for(const t1 in this._mergedSourceCaches){
                    const i = this._mergedSourceCaches[t1].getSource().scope;
                    e1[i] = e1[i] || this._changes.getUpdatedImages(i), 0 !== e1[i].length && this._mergedSourceCaches[t1].reloadTilesForDependencies([
                        "icons",
                        "patterns"
                    ], e1[i]);
                }
                for(const t1 in e1)this._changes.resetUpdatedImages(t1);
            }
            _updateWorkerLayers(e1, t1, i) {
                const s = this.getFragmentStyle(e1);
                s && this.dispatcher.broadcast("updateLayers", {
                    layers: t1 ? s._serializeLayers(t1) : [],
                    scope: e1,
                    removedIds: i || [],
                    options: s.options
                });
            }
            setState(t1, i) {
                if (this._checkLoaded(), Yn(this, Et(t1))) return !1;
                if ((t1 = e1.dL(t1)).layers = en(t1.layers), !wt.diffStyles) throw new Error("Debug module not loaded; cannot diff style.");
                const s = wt.diffStyles(this.serialize(), t1).filter((e1)=>!Qn.has(e1.command));
                if (0 === s.length) return !1;
                const r = s.filter((e1)=>!Kn.has(e1.command));
                if (r.length > 0) throw new Error(`Unimplemented: ${r.map((e1)=>e1.command).join(", ")}.`);
                const o = [];
                return s.forEach((e1)=>{
                    o.push(this[e1.command](...e1.args));
                }), i && Promise.all(o).then(i).catch(i), this.stylesheet = t1, this.mergeAll(), this.dispatcher.broadcast("setLayers", {
                    layers: this._serializeLayers(this._order),
                    scope: this.scope,
                    options: this.options
                }), !0;
            }
            _updateWorkerImages(e1 = !1) {
                this._availableImages = this.imageManager.listImages(this.scope);
                const t1 = {
                    scope: this.scope,
                    images: this._availableImages
                };
                e1 && (t1.isSpriteLoaded = !0), this.dispatcher.broadcast("setImages", t1);
            }
            _updateWorkerModels() {
                this._availableModels = this.modelManager.getModelURIs(this.scope), this.dispatcher.broadcast("setModels", {
                    scope: this.scope,
                    models: this._availableModels
                });
            }
            addImages(t1, i) {
                if (0 === t1.size) return i && this.dispatcher.broadcast("spriteLoaded", {
                    scope: this.scope
                }), this;
                for (const [i, s] of t1.entries()){
                    if (this.getImage(i)) return this.fire(new e1.h(new Error(`An image with the name "${i.name}" already exists.`)));
                    this.imageManager.addImage(i, this.scope, s), this._changes.updateImage(i, this.scope);
                }
                return this._updateWorkerImages(i), this.fire(new e1.i("data", {
                    dataType: "style"
                })), this;
            }
            addImage(t1, i) {
                return this.getImage(t1) ? this.fire(new e1.h(new Error(`An image with the name "${t1.name}" already exists.`))) : (this.imageManager.addImage(t1, this.scope, i), this._changes.updateImage(t1, this.scope), this._updateWorkerImages(), this.fire(new e1.i("data", {
                    dataType: "style"
                })), this);
            }
            updateImage(t1, i, s = !1) {
                this.imageManager.updateImage(t1, this.scope, i), s && (this._changes.updateImage(t1, this.scope), this._updateWorkerImages(), this.fire(new e1.i("data", {
                    dataType: "style"
                })));
            }
            getImage(e1) {
                return this.imageManager.getImage(e1, this.scope);
            }
            removeImage(t1) {
                return this.getImage(t1) ? (this.imageManager.removeImage(t1, this.scope), this._changes.updateImage(t1, this.scope), this._updateWorkerImages(), this.fire(new e1.i("data", {
                    dataType: "style"
                })), this) : this.fire(new e1.h(new Error("No image with this name exists.")));
            }
            listImages() {
                return this._checkLoaded(), this._availableImages.slice();
            }
            getActualScope() {
                return this._importedAsBasemap ? "basemap" : this.scope;
            }
            addModelURLs(t1) {
                return this.modelManager.addModelURLs(t1, this.getActualScope()), this._updateWorkerModels(), this.fire(new e1.i("data", {
                    dataType: "style"
                })), this;
            }
            addModel(t1, i, s = {}) {
                return this._checkLoaded(), this._validate(zt, `models.${t1}`, i, null, s) || (this.modelManager.addModel(t1, i, this.getActualScope()), this.fire(new e1.i("data", {
                    dataType: "style"
                }))), this;
            }
            hasModel(e1) {
                return this.modelManager.hasModel(e1, this.getActualScope());
            }
            removeModel(t1) {
                return this.hasModel(t1) ? (this.modelManager.removeModel(t1, this.getActualScope(), !1, !0), this.fire(new e1.i("data", {
                    dataType: "style"
                })), this) : this.fire(new e1.h(new Error("No model with this ID exists.")));
            }
            listModels() {
                return this._checkLoaded(), this.modelManager.listModels(this.getActualScope());
            }
            addSource(t1, i, s = {}) {
                if (this._checkLoaded(), void 0 !== this.getOwnSource(t1)) throw new Error(`There is already a source with ID "${t1}".`);
                if (!i.type) throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(i).join(", ")}.`);
                if ([
                    "vector",
                    "raster",
                    "geojson",
                    "video",
                    "image"
                ].includes(i.type) && this._validate(It, `sources.${t1}`, i, null, s)) return;
                this.map && this.map._collectResourceTiming && (i.collectResourceTiming = !0);
                const r = Object.hasOwn(Go, i.type) && !Vo(i.type) ? new vs(t1, i, this.dispatcher, this) : void 0, o = r || jo(t1, i, this.dispatcher, this);
                o.scope = this.scope;
                const n = (e1)=>{
                    e1.setEventedParent(this, ()=>({
                            isSourceLoaded: this._isSourceCacheLoaded(e1.id),
                            source: e1.serialize(),
                            sourceId: e1.id
                        }));
                };
                n(o);
                const a = (t1)=>{
                    const i = (t1 === e1.b_.Symbol ? "symbol:" : t1 === e1.b_.FillExtrusion ? "fill-extrusion:" : "other:") + o.id, s = e1.m(i, this.scope), r = this._sourceCaches[i] = new bs(s, o, t1);
                    t1 === e1.b_.Symbol ? this._symbolSourceCaches[o.id] = r : t1 === e1.b_.FillExtrusion ? this._fillExtrusionSourceCaches[o.id] = r : this._otherSourceCaches[o.id] = r, r.onAdd(this.map);
                };
                a(e1.b_.Other), "vector" !== i.type && "geojson" !== i.type || (a(e1.b_.Symbol), "vector" === i.type && a(e1.b_.FillExtrusion)), o.onAdd && o.onAdd(this.map), r && (r._loader = ()=>{
                    (async function(e1) {
                        if (Vo(e1)) return;
                        const t1 = Go[e1];
                        if (!t1) throw new Error(`Unknown source type "${e1}"`);
                        const i = await t1();
                        i && !Vo(e1) && function(e1, t1) {
                            No[e1] = t1;
                        }(e1, i);
                    })(i.type).then(()=>{
                        const s = Vo(i.type), r = this._otherSourceCaches[t1];
                        if (!r || r.getSource() !== o) return;
                        if (!s) return void this.fire(new e1.h(new Error(`Could not load module for source type "${i.type}".`)));
                        const a = jo(t1, i, this.dispatcher, this);
                        a.scope = this.scope, n(a), r.setSource(a), a.onAdd && a.onAdd(this.map), this._changes.setDirty();
                    });
                }), s.isInitialLoad || (this.mergeSources(), this._changes.setDirty());
            }
            removeSource(t1) {
                this._checkLoaded();
                const i = this.getOwnSource(t1);
                if (!i) throw new Error("There is no source with this ID");
                for(const i in this._layers)if (this._layers[i].source === t1) return this.fire(new e1.h(new Error(`Source "${t1}" cannot be removed while layer "${i}" is using it.`)));
                if (this.terrain && this.terrain.scope === this.scope && this.terrain.get().source === t1) return this.fire(new e1.h(new Error(`Source "${t1}" cannot be removed while terrain is using it.`)));
                if (this.stylesheet.iconsets) {
                    const i = Object.entries(this.stylesheet.iconsets).find(([e1, i])=>"source" === i.type && i.source === t1);
                    if (i) return this.fire(new e1.h(new Error(`Source "${t1}" cannot be removed while iconset "${i[0]}" is using it.`)));
                }
                const s = this.getOwnSourceCaches(t1);
                for (const t1 of s){
                    const i = e1.dM(t1.id);
                    delete this._sourceCaches[i], this._changes.discardSourceCacheUpdate(t1.id), t1.fire(new e1.i("data", {
                        sourceDataType: "metadata",
                        dataType: "source",
                        sourceId: t1.getSource().id
                    })), t1.setEventedParent(null), t1.clearTiles();
                }
                return delete this._otherSourceCaches[t1], delete this._symbolSourceCaches[t1], delete this._fillExtrusionSourceCaches[t1], this._hdCoverage && delete this._hdCoverage.coverageSourceCaches[t1], this.mergeSources(), i.setEventedParent(null), i.onRemove && i.onRemove(this.map), this.dispatcher.broadcast("removeSource", {
                    type: i.type,
                    source: t1,
                    scope: i.scope
                }), this._changes.setDirty(), this;
            }
            setGeoJSONSourceData(e1, t1) {
                this._checkLoaded(), this.getOwnSource(e1).setData(t1), this._changes.setDirty();
            }
            getOwnSource(e1) {
                const t1 = this.getOwnSourceCache(e1);
                return t1 && t1.getSource();
            }
            getOwnSources() {
                const e1 = [];
                for(const t1 in this._otherSourceCaches){
                    const i = this.getOwnSourceCache(t1);
                    i && e1.push(i.getSource());
                }
                return e1;
            }
            areTilesLoaded() {
                const e1 = this._mergedSourceCaches;
                for(const t1 in e1){
                    const i = e1[t1];
                    for (const e1 of i._tiles.values())if ("loaded" !== e1.state && "errored" !== e1.state) return !1;
                }
                return !0;
            }
            setLights(t1) {
                if (this._checkLoaded(), this._programPrecompiler && this._programPrecompiler.reset(), !t1) return delete this.ambientLight, void delete this.directionalLight;
                const i = this._getTransitionParameters();
                for (const e1 of t1){
                    if (this._validate(Pt, "lights", e1)) return;
                    switch(e1.type){
                        case "ambient":
                            if (this.ambientLight) {
                                const t1 = this.ambientLight;
                                t1.set(e1), t1.updateTransitions(i);
                            } else this.ambientLight = new si(e1, oi(), this.scope, this.options);
                            break;
                        case "directional":
                            if (this.directionalLight) {
                                const t1 = this.directionalLight;
                                t1.set(e1), t1.updateTransitions(i);
                            } else this.directionalLight = new si(e1, ai(), this.scope, this.options);
                    }
                }
                const s = Object.assign(i, {
                    worldview: this.map.getWorldview()
                }), r = new e1.au(this.z || 0, s);
                this.ambientLight && this.ambientLight.recalculate(r), this.directionalLight && this.directionalLight.recalculate(r), this._brightness = this.calculateLightsBrightness(), this.dispatcher.broadcast("upsertRenderParams", {
                    brightness: this._brightness
                });
            }
            calculateLightsBrightness() {
                const t1 = this.directionalLight, i = this.ambientLight;
                if (!t1 || !i) return;
                const s = (e1)=>.2126 * (e1[0] <= .03928 ? e1[0] / 12.92 : Math.pow((e1[0] + .055) / 1.055, 2.4)) + .7152 * (e1[1] <= .03928 ? e1[1] / 12.92 : Math.pow((e1[1] + .055) / 1.055, 2.4)) + .0722 * (e1[2] <= .03928 ? e1[2] / 12.92 : Math.pow((e1[2] + .055) / 1.055, 2.4)), r = t1.properties.get("color").toNonPremultipliedRenderColor(null).toArray01(), o = t1.properties.get("intensity"), n = t1.properties.get("direction"), a = 1 - e1.c4(n.x, n.y, n.z)[2] / 90, l = s(r) * o * a, c = i.properties.get("color").toNonPremultipliedRenderColor(null).toArray01(), h = i.properties.get("intensity"), d = s(c) * h;
                return Number(((l + d) / 2).toFixed(6));
            }
            getBrightness() {
                return this._brightness;
            }
            getLights() {
                if (!this.enable3dLights()) return null;
                const e1 = [];
                return this.directionalLight && e1.push(this.directionalLight.get()), this.ambientLight && e1.push(this.ambientLight.get()), e1;
            }
            enable3dLights() {
                return !!this.ambientLight && !!this.directionalLight;
            }
            getFragmentStyle(t1) {
                if (null == t1 || "" === t1 && this.isRootStyle()) return this;
                if (e1.dN(t1)) {
                    const i = e1.dO(t1), s = this.fragments.find(({ id: e1 })=>e1 === i);
                    if (!s) return;
                    const r = e1.dM(t1);
                    return s.style.getFragmentStyle(r);
                }
                {
                    const e1 = this.fragments.find(({ id: e1 })=>e1 === t1);
                    return e1 ? e1.style : void 0;
                }
            }
            setFeaturesetSelectors(t1) {
                if (!t1) return;
                const i = (e1, t1 = "")=>`${e1}::${t1}`;
                this._featuresetSelectors = {};
                for(const s in t1){
                    const r = {}, o = this._featuresetSelectors[s] = [];
                    for (const n of t1[s].selectors){
                        if (n.featureNamespace) {
                            const t1 = this.getOwnLayer(n.layer);
                            if (!t1) {
                                e1.w(`Layer is undefined for selector: ${n.layer}`);
                                continue;
                            }
                            const o = i(t1.source, t1.sourceLayer);
                            if (o in r && r[o] !== n.featureNamespace) {
                                e1.w(`"featureNamespace ${n.featureNamespace} of featureset ${s}'s selector is not associated to the same source, skip this selector`);
                                continue;
                            }
                            r[o] = n.featureNamespace;
                        }
                        let t1;
                        if (n.properties) for(const i in n.properties){
                            const s = e1.c(n.properties[i]);
                            "success" === s.result && (t1 = t1 || {}, t1[i] = s.value);
                        }
                        o.push({
                            layerId: n.layer,
                            namespace: n.featureNamespace,
                            properties: t1,
                            uniqueFeatureID: n._uniqueFeatureID
                        });
                    }
                }
            }
            getFeaturesetDescriptors(e1) {
                const t1 = this.getFragmentStyle(e1);
                if (!t1 || !t1.stylesheet.featuresets) return [];
                const i = [];
                for(const e1 in t1.stylesheet.featuresets)i.push({
                    featuresetId: e1,
                    importId: t1.scope ? t1.scope : void 0
                });
                return i;
            }
            getFeaturesetLayers(t1, i) {
                const s = this.getFragmentStyle(i), r = s.stylesheet.featuresets;
                if (!r || !r[t1]) return this.fire(new e1.h(new Error(`The featureset '${t1}' does not exist in the map's style and cannot be queried.`))), [];
                const o = [];
                for (const e1 of r[t1].selectors){
                    const t1 = s.getOwnLayer(e1.layer);
                    t1 && o.push(t1);
                }
                return o;
            }
            getConfigProperty(t1, i) {
                const s = this.getFragmentStyle(t1);
                if (!s) return null;
                const r = e1.m(i, s.scope), o = s.options.get(r), n = o ? o.value || o.default : null;
                return n ? n.serialize() : null;
            }
            isIndoorEnabled() {
                return this._indoorEnabled;
            }
            getIndoorSourceLayers(t1, i) {
                const s = e1.m(t1, i);
                return this._mergedIndoor[s];
            }
            setIndoorData(e1, t1) {
                this.indoorManager && this.indoorManager.setIndoorData(t1);
            }
            updateIndoorDependentLayers() {
                this._updateLayers(this._dependentLayerIds((e1)=>e1.isIndoorDependent)), this.map._styleDirty = !0, this.map.triggerRepaint();
            }
            setConfigProperty(t1, i, s) {
                const r = this.getFragmentStyle(t1);
                if (!r) return;
                const o = r.stylesheet.schema;
                if (!o || !o[i]) return;
                const n = e1.dP(s, o[i]);
                if ("success" !== n.result) return void Yn(this, n.value);
                const a = n.value.expression, l = e1.m(i, r.scope), c = r.options.get(l);
                if (!c) return;
                let h;
                const { minValue: d, maxValue: u, stepValue: p, type: f, values: m } = o[i], _ = e1.dP(o[i].default, o[i]);
                "success" === _.result && (h = _.value.expression), h ? (this.options.set(l, {
                    ...c,
                    value: a,
                    default: h,
                    minValue: d,
                    maxValue: u,
                    stepValue: p,
                    type: f,
                    values: m
                }), this.updateConfigDependencies(i)) : this.fire(new e1.h(new Error(`No schema defined for the config option "${i}" in the "${t1}" fragment.`)));
            }
            getConfig(t1) {
                const i = this.getFragmentStyle(t1);
                if (!i) return null;
                const s = i.stylesheet.schema;
                if (!s) return null;
                const r = {};
                for(const t1 in s){
                    const s = e1.m(t1, i.scope), o = i.options.get(s), n = o ? o.value || o.default : null;
                    r[t1] = n ? n.serialize() : null;
                }
                return r;
            }
            setConfig(e1, t1) {
                const i = this.getFragmentStyle(e1);
                i && (i.updateConfig(t1, i.stylesheet.schema), this.updateConfigDependencies());
            }
            getSchema(e1) {
                const t1 = this.getFragmentStyle(e1);
                return t1 ? t1.stylesheet.schema : null;
            }
            setSchema(e1, t1) {
                const i = this.getFragmentStyle(e1);
                i && (i.stylesheet.schema = t1, i.updateConfig(i._config, t1), this.updateConfigDependencies());
            }
            updateConfig(t1, i) {
                if (this._config = t1, t1 || i) {
                    if (i) for(const s in i){
                        let r, o;
                        const n = e1.dP(i[s].default, i[s]);
                        if ("success" === n.result && (r = n.value.expression), t1 && void 0 !== t1[s]) {
                            const r = e1.dP(t1[s], i[s]);
                            "success" === r.result && (o = r.value.expression);
                        }
                        const { minValue: a, maxValue: l, stepValue: c, type: h, values: d } = i[s];
                        if (r) {
                            const t1 = e1.m(s, this.scope);
                            this.options.set(t1, {
                                default: r,
                                value: o,
                                minValue: a,
                                maxValue: l,
                                stepValue: c,
                                type: h,
                                values: d
                            });
                        } else this.fire(new e1.h(new Error(`No schema defined for config option "${s}".`)));
                    }
                    else this.fire(new e1.h(new Error("Attempting to set config for a style without schema.")));
                }
            }
            _updateLayers(e1) {
                for (const t1 of e1){
                    const e1 = this.getLayer(t1);
                    e1 && (e1.possiblyEvaluateVisibility(), e1._dirty = !0, this._updateLayer(e1), this._changes.setDirty());
                }
            }
            _dependentLayerIds(e1) {
                const t1 = [];
                for (const [i, s] of this._layerExpressionDependencies)e1(s) && t1.push(i);
                return t1;
            }
            _updateEnvConfig(e1 = "update") {
                const t1 = "reset" === e1 ? "resetConfig" : "updateConfig";
                this.ambientLight && this.ambientLight[t1](this.options), this.directionalLight && this.directionalLight[t1](this.options), this.fog && this.fog[t1](this.options), this.snow && this.snow[t1](this.options), this.rain && this.rain[t1](this.options);
            }
            updateConfigDependencies(e1) {
                this._updateLayers(this._dependentLayerIds((t1)=>t1.hasConfigDependency(e1))), this._updateEnvConfig(), this.forEachFragmentStyle((e1)=>{
                    const t1 = e1._styleColorTheme.colorThemeOverride ? e1._styleColorTheme.colorThemeOverride : e1._styleColorTheme.colorTheme;
                    if (t1) {
                        const i = e1._evaluateColorThemeData(t1);
                        (!e1._styleColorTheme.lut && "" !== i || e1._styleColorTheme.lut && i !== e1._styleColorTheme.lut.data) && e1.setColorTheme(t1);
                    }
                }), this._updateIndoorEnabled(), this._changes.setDirty();
            }
            addLayer(t1, i, s = {}) {
                this._checkLoaded();
                const r = t1.id;
                if (this._layers[r]) return void this.fire(new e1.h(new Error(`Layer with id "${r}" already exists on this map`)));
                let o;
                if ("custom" === t1.type) {
                    if (Yn(this, e1.dQ(t1))) return;
                    o = e1.dR(t1, this.scope, this._styleColorTheme.lut, this.options);
                } else {
                    if ("object" == typeof t1.source && (this.addSource(r, t1.source), t1 = e1.dL(t1), t1 = Object.assign(t1, {
                        source: r
                    })), this._validate(Ft, `layers.${r}`, t1, {
                        arrayIndex: -1
                    }, s)) return;
                    o = e1.dR(t1, this.scope, this._styleColorTheme.lut, this.options), this._validateLayer(o), o.setEventedParent(this, {
                        layer: {
                            id: r
                        }
                    });
                }
                this._layerExpressionDependencies.set(o.fqid, new x(o));
                let n = this._order.length;
                if (i) {
                    const t1 = this._order.indexOf(i);
                    if (-1 === t1) return void this.fire(new e1.h(new Error(`Layer with id "${i}" does not exist on this map.`)));
                    o.slot && o.slot !== this._layers[i].slot ? e1.w(`Layer with id "${i}" has a different slot. Layers can only be rearranged within the same slot.`) : n = t1;
                }
                this._order.splice(n, 0, r), this._handleLayerOrderChange(), this._layers[r] = o;
                const a = this.getOwnLayerSourceCache(o), l = !!this.directionalLight && this.directionalLight.shadowsEnabled();
                a && o.canCastShadows() && l && (a.castsShadows = !0);
                const c = this._changes.getRemovedLayer(o);
                if (c && o.source && a && "custom" !== o.type) {
                    this._changes.discardLayerRemoval(o);
                    const t1 = e1.m(o.source, o.scope);
                    c.type !== o.type ? this._changes.updateSourceCache(t1, "clear") : (this._changes.updateSourceCache(t1, "reload"), a.pause());
                }
                this._updateLayer(o), o.onAdd && o.onAdd(this.map), o.scope = this.scope, this.mergeLayers();
            }
            moveLayer(t1, i) {
                this._checkLoaded();
                const s = this._checkLayer(t1);
                if (!s) return;
                if (t1 === i) return;
                const r = this._order.indexOf(t1);
                this._order.splice(r, 1);
                let o = this._order.length;
                if (i) {
                    const t1 = this._order.indexOf(i);
                    if (-1 === t1) return void this.fire(new e1.h(new Error(`Layer with id "${i}" does not exist on this map.`)));
                    s.slot && s.slot !== this._layers[i].slot ? e1.w(`Layer with id "${i}" has a different slot. Layers can only be rearranged within the same slot.`) : o = t1;
                }
                this._order.splice(o, 0, t1), this._changes.setDirty(), this._handleLayerOrderChange(), this.mergeLayers();
            }
            removeLayer(e1) {
                this._checkLoaded();
                const t1 = this._checkLayer(e1);
                if (!t1) return;
                t1.setEventedParent(null);
                const i = this._order.indexOf(e1);
                this._order.splice(i, 1), delete this._layers[e1], this._changes.setDirty(), this._handleLayerOrderChange(), this._layerExpressionDependencies.delete(t1.fqid), this._changes.removeLayer(t1);
                const s = this.getOwnLayerSourceCache(t1);
                if (s && s.castsShadows) {
                    let e1 = !1;
                    for(const i in this._layers)if (this._layers[i].source === t1.source && this._layers[i].canCastShadows()) {
                        e1 = !0;
                        break;
                    }
                    s.castsShadows = e1;
                }
                t1.onRemove && t1.onRemove(this.map), this.mergeLayers();
            }
            getOwnLayer(e1) {
                return this._layers[e1];
            }
            hasLayer(e1) {
                return e1 in this._mergedLayers;
            }
            hasLayerType(e1) {
                for(const t1 in this._layers)if (this._layers[t1].type === e1) return !0;
                return !1;
            }
            setLayerZoomRange(e1, t1, i) {
                this._checkLoaded();
                const s = this._checkLayer(e1);
                s && (s.minzoom === t1 && s.maxzoom === i || (null != t1 && (s.minzoom = t1), null != i && (s.maxzoom = i), this._updateLayer(s)));
            }
            getSlots() {
                return this._checkLoaded(), this._mergedSlots;
            }
            setSlot(e1, t1) {
                this._checkLoaded();
                const i = this._checkLayer(e1);
                i && i.slot !== t1 && (i.slot = t1, this._updateLayer(i));
            }
            setFilter(t1, i, s = {}) {
                this._checkLoaded();
                const r = this._checkLayer(t1);
                if (!r) return;
                if (e1.Y(r.filter, i)) return;
                const o = this._layerExpressionDependencies.get(r.fqid);
                if (null == i) return r.filter = void 0, o && o.invalidateFilter(), void this._updateLayer(r);
                this._validate(Ot, `layers.${r.id}.filter`, i, {
                    layerType: r.type
                }, s) || (r.filter = e1.dL(i), o && o.invalidateFilter(), this._updateLayer(r));
            }
            getFilter(t1) {
                const i = this._checkLayer(t1);
                if (i) return e1.dL(i.filter);
            }
            setLayoutProperty(t1, i, s, r = {}) {
                this._checkLoaded();
                const o = this._checkLayer(t1);
                if (o && !e1.Y(o.getLayoutProperty(i), s)) {
                    if (null != s && (!r || !1 !== r.validate) && Yn(o, Bt.call(Et, {
                        key: `layers.${t1}.layout.${i}`,
                        layerType: o.type,
                        objectKey: i,
                        value: s,
                        styleSpec: e1.s,
                        style: {
                            glyphs: !0,
                            sprite: !0
                        }
                    }))) return;
                    o.setLayoutProperty(i, s), this._updateLayer(o);
                }
            }
            getLayerProperty(e1, t1) {
                const i = this._checkLayer(e1);
                if (i) {
                    switch(t1){
                        case "minzoom":
                            return i.minzoom;
                        case "maxzoom":
                            return i.maxzoom;
                        case "filter":
                            return this.getFilter(e1);
                        case "slot":
                            return i.slot;
                        case "appearances":
                            return i.getAppearances().map((e1)=>e1.serialize());
                    }
                    return i.isPaintProperty(t1) ? this.getPaintProperty(e1, t1) : this.getLayoutProperty(e1, t1);
                }
            }
            setLayerProperty(e1, t1, i, s = {}) {
                this._checkLoaded();
                const r = this._checkLayer(e1);
                if (r) {
                    switch(t1){
                        case "appearances":
                            return r.setAppearances(i), void this._updateLayer(r);
                        case "minzoom":
                            return this.setLayerZoomRange(e1, i);
                        case "maxzoom":
                            return this.setLayerZoomRange(e1, null, i);
                        case "filter":
                            return this.setFilter(e1, i, s);
                        case "slot":
                            return this.setSlot(e1, i);
                    }
                    r.isPaintProperty(t1) ? this.setPaintProperty(e1, t1, i, s) : this.setLayoutProperty(e1, t1, i, s);
                }
            }
            getLayoutProperty(e1, t1) {
                const i = this._checkLayer(e1);
                if (i) return i.getLayoutProperty(t1);
            }
            setPaintProperty(t1, i, s, r = {}) {
                this._checkLoaded();
                const o = this._checkLayer(t1);
                o && (e1.Y(o.getPaintProperty(i), s) || (null == s || r && !1 === r.validate || !Yn(o, kt.call(Et, {
                    key: `layers.${t1}.paint.${i}`,
                    layerType: o.type,
                    objectKey: i,
                    value: s,
                    styleSpec: e1.s
                }))) && (o.setPaintProperty(i, s) && this._updateLayer(o), this._changes.updatePaintProperties(o)));
            }
            getPaintProperty(e1, t1) {
                const i = this._checkLayer(e1);
                if (i) return i.getPaintProperty(t1);
            }
            setFeatureState(t1, i) {
                if (this._checkLoaded(), "target" in t1) {
                    if ("featuresetId" in t1.target) {
                        const { featuresetId: e1, importId: s } = t1.target, r = this.getFragmentStyle(s), o = r.getFeaturesetLayers(e1);
                        for (const { source: e1, sourceLayer: s } of o)r.setFeatureState({
                            id: t1.id,
                            source: e1,
                            sourceLayer: s
                        }, i);
                    } else if ("layerId" in t1.target) {
                        const e1 = this._resolveLayerFragment(t1.target.layerId);
                        e1?.fragment.setFeatureState({
                            id: t1.id,
                            source: e1.layer.source,
                            sourceLayer: e1.layer.sourceLayer
                        }, i);
                    }
                    return;
                }
                const s = t1.source, r = t1.sourceLayer, o = this._checkSource(s);
                if (!o) return;
                const n = o.type;
                if ("geojson" === n && r) return void this.fire(new e1.h(new Error("GeoJSON sources cannot have a sourceLayer parameter.")));
                if ("vector" === n && !r) return void this.fire(new e1.h(new Error("The sourceLayer parameter must be provided for vector source types.")));
                void 0 === t1.id && this.fire(new e1.h(new Error("The feature id parameter must be provided.")));
                const a = this.getOwnSourceCaches(s);
                for (const e1 of a)e1.setFeatureState(r, t1.id, i);
            }
            removeFeatureState(t1, i) {
                if (this._checkLoaded(), "target" in t1) {
                    if ("featuresetId" in t1.target) {
                        const { featuresetId: e1, importId: s } = t1.target, r = this.getFragmentStyle(s), o = r.getFeaturesetLayers(e1);
                        for (const { source: e1, sourceLayer: s } of o)r.removeFeatureState({
                            id: t1.id,
                            source: e1,
                            sourceLayer: s
                        }, i);
                    } else if ("layerId" in t1.target) {
                        const e1 = this._resolveLayerFragment(t1.target.layerId);
                        e1?.fragment.removeFeatureState({
                            id: t1.id,
                            source: e1.layer.source,
                            sourceLayer: e1.layer.sourceLayer
                        }, i);
                    }
                    return;
                }
                const s = t1.source, r = this._checkSource(s);
                if (!r) return;
                const o = r.type, n = "vector" === o ? t1.sourceLayer : void 0;
                if ("vector" === o && !n) return void this.fire(new e1.h(new Error("The sourceLayer parameter must be provided for vector source types.")));
                if (i && "string" != typeof t1.id && "number" != typeof t1.id) return void this.fire(new e1.h(new Error("A feature id is required to remove its specific state property.")));
                const a = this.getOwnSourceCaches(s);
                for (const e1 of a)e1.removeFeatureState(n, t1.id, i);
            }
            getFeatureState(t1) {
                if (this._checkLoaded(), "target" in t1) {
                    let i;
                    if ("featuresetId" in t1.target) {
                        const { featuresetId: s, importId: r } = t1.target, o = this.getFragmentStyle(r), n = o.getFeaturesetLayers(s);
                        for (const { source: s, sourceLayer: r } of n){
                            const n = o.getFeatureState({
                                id: t1.id,
                                source: s,
                                sourceLayer: r
                            });
                            if (n && !i) i = n;
                            else if (!e1.Y(i, n)) return void this.fire(new e1.h(new Error("The same feature id exists in multiple sources in the featureset, but their feature states are not consistent through the sources.")));
                        }
                    } else if ("layerId" in t1.target) {
                        const e1 = this._resolveLayerFragment(t1.target.layerId);
                        i = e1?.fragment.getFeatureState({
                            id: t1.id,
                            source: e1.layer.source,
                            sourceLayer: e1.layer.sourceLayer
                        });
                    }
                    return i;
                }
                const i = t1.source, s = t1.sourceLayer, r = this._checkSource(i);
                if (r) {
                    if ("vector" !== r.type || s) return void 0 === t1.id && this.fire(new e1.h(new Error("The feature id parameter must be provided."))), this.getOwnSourceCaches(i)[0].getFeatureState(s, t1.id);
                    this.fire(new e1.h(new Error("The sourceLayer parameter must be provided for vector source types.")));
                }
            }
            resetFeatureStates(e1) {
                if (this._checkLoaded(), "featuresetId" in e1) {
                    const { featuresetId: t1, importId: i } = e1, s = this.getFragmentStyle(i);
                    if (!s) return;
                    const r = s.getFeaturesetLayers(t1);
                    for (const { source: e1, sourceLayer: t1 } of r)s.removeFeatureState({
                        source: e1,
                        sourceLayer: t1
                    });
                } else {
                    const t1 = this._resolveLayerFragment(e1.layerId);
                    t1?.fragment.removeFeatureState({
                        source: t1.layer.source,
                        sourceLayer: t1.layer.sourceLayer
                    });
                }
            }
            setTransition(e1) {
                return this.stylesheet.transition = {
                    ...this.stylesheet.transition,
                    ...e1
                }, this.transition = this.stylesheet.transition, this;
            }
            getTransition() {
                return {
                    ...this.stylesheet.transition
                };
            }
            setWorldview(e1) {
                e1 !== this._worldview && (this._worldview = e1, this.dispatcher.broadcast("upsertRenderParams", {
                    worldview: this._worldview
                }), this.reloadSources());
            }
            serialize() {
                this._checkLoaded();
                const t1 = this.getTerrain(), i = t1 && this.terrain && this.terrain.scope === this.scope ? t1 : this.stylesheet.terrain;
                return e1.dS({
                    version: this.stylesheet.version,
                    name: this.stylesheet.name,
                    metadata: this.stylesheet.metadata,
                    fragment: this.stylesheet.fragment,
                    iconsets: this.stylesheet.iconsets,
                    featuresets: this.stylesheet.featuresets,
                    imports: this._serializeImports(),
                    schema: this.stylesheet.schema,
                    camera: this.stylesheet.camera,
                    light: this.stylesheet.light,
                    lights: this.stylesheet.lights,
                    terrain: i,
                    fog: this.stylesheet.fog,
                    snow: this.stylesheet.snow,
                    rain: this.stylesheet.rain,
                    indoor: this.stylesheet.indoor,
                    center: this.stylesheet.center,
                    "color-theme": this.stylesheet["color-theme"],
                    zoom: this.stylesheet.zoom,
                    bearing: this.stylesheet.bearing,
                    pitch: this.stylesheet.pitch,
                    sprite: this.stylesheet.sprite,
                    glyphs: this.stylesheet.glyphs,
                    transition: this.stylesheet.transition,
                    projection: this.stylesheet.projection,
                    sources: this._serializeSources(),
                    layers: this._serializeLayers(this._order)
                }, (e1)=>void 0 !== e1);
            }
            _updateFilteredLayers(e1) {
                for (const t1 of Object.values(this._mergedLayers))e1(t1) && this._updateLayer(t1);
            }
            _updateLayer(e1) {
                this._changes.updateLayer(e1);
                const t1 = this.getLayerSourceCache(e1), i = e1.sourceFqid, s = this._changes.getUpdatedSourceCaches();
                e1.source && !s[i] && t1 && "raster" !== t1.getSource().type && (this._changes.updateSourceCache(i, "reload"), t1.pause()), e1.invalidateCompiledFilter();
            }
            _flattenAndSortRenderedFeatures(e1) {
                const t1 = (e1)=>this._mergedLayers[e1].is3D(!!this.terrain), i = this.order, s = {}, r = [];
                for(let o = i.length - 1; o >= 0; o--){
                    const n = i[o];
                    if (t1(n)) {
                        s[n] = o;
                        for (const t1 of e1){
                            const e1 = t1[n];
                            if (e1) for (const t1 of e1)r.push(t1);
                        }
                    }
                }
                r.sort((e1, t1)=>t1.intersectionZ - e1.intersectionZ);
                const o = [];
                for(let n = i.length - 1; n >= 0; n--){
                    const a = i[n];
                    if (t1(a)) for(let e1 = r.length - 1; e1 >= 0; e1--){
                        const t1 = r[e1].feature;
                        if (t1.layer && s[t1.layer.id] < n) break;
                        o.push(t1), r.pop();
                    }
                    else for (const t1 of e1){
                        const e1 = t1[a];
                        if (e1) for (const t1 of e1)o.push(t1.feature);
                    }
                }
                return o;
            }
            queryRasterValue(t1, i, s) {
                const r = this.getOwnSource(t1);
                return r ? "raster-array" !== r.type ? (this.fire(new e1.h(new Error('queryRasterValue support only "raster-array" sources.'))), Promise.resolve(null)) : r.queryRasterArrayValue(i, s) : (this.fire(new e1.h(new Error(`Source with id "${t1}" does not exist in the style.`))), Promise.resolve(null));
            }
            queryRenderedFeatures(t1, i, s) {
                let r;
                i && !Array.isArray(i) && i.filter && (this._validate(Ot, "queryRenderedFeatures.filter", i.filter, null, i), r = e1.bH(i.filter));
                const o = {}, n = (e1)=>{
                    if (Jn.has(e1.type)) return;
                    const t1 = this.getOwnLayerSourceCache(e1), i = o[t1.id] = o[t1.id] || {
                        sourceCache: t1,
                        layers: {},
                        has3DLayers: !1
                    };
                    e1.is3D(!!this.terrain) && (i.has3DLayers = !0), i.layers[e1.fqid] = i.layers[e1.fqid] || {
                        styleLayer: e1,
                        targets: []
                    }, i.layers[e1.fqid].targets.push({
                        filter: r
                    });
                };
                if (i && i.layers) {
                    if (!Array.isArray(i.layers)) return this.fire(new e1.h(new Error("parameters.layers must be an Array."))), [];
                    for (const t1 of i.layers){
                        const i = this._layers[t1];
                        if (!i) return this.fire(new e1.h(new Error(`The layer '${t1}' does not exist in the map's style and cannot be queried for features.`))), [];
                        n(i);
                    }
                } else for(const e1 in this._layers)n(this._layers[e1]);
                const a = this._queryRenderedFeatures(t1, o, s), l = this._flattenAndSortRenderedFeatures(a), c = [];
                for (const t1 of l)e1.dT(t1.layer.id) === this.scope && c.push(t1);
                return c;
            }
            queryRenderedFeatureset(t1, i, s) {
                let r;
                i && !Array.isArray(i) && i.filter && (this._validate(Ot, "queryRenderedFeatures.filter", i.filter, null, i), r = e1.bH(i.filter));
                const o = "mock", n = [];
                if (i && i.target) n.push({
                    ...i,
                    targetId: o,
                    filter: r
                });
                else {
                    const e1 = this.getFeaturesetDescriptors();
                    for (const t1 of e1)n.push({
                        targetId: o,
                        filter: r,
                        target: t1
                    });
                    for (const { style: e1 } of this.fragments){
                        const t1 = e1.getFeaturesetDescriptors();
                        for (const e1 of t1)n.push({
                            targetId: o,
                            filter: r,
                            target: e1
                        });
                    }
                }
                const a = this.queryRenderedTargets(t1, n, s), l = [], c = new Set;
                for (const t1 of a)for (const i of t1.variants[o])$o(i, t1, c) || l.push(new e1.dU(t1, i));
                return l;
            }
            queryRenderedTargets(t1, i, s) {
                const r = {}, o = (e1, t1, i, s)=>{
                    const o = r[t1.id] = r[t1.id] || {
                        sourceCache: t1,
                        layers: {},
                        has3DLayers: !1
                    };
                    if (o.layers[e1.fqid] = o.layers[e1.fqid] || {
                        styleLayer: e1,
                        targets: []
                    }, e1.is3D(!!this.terrain) && (o.has3DLayers = !0), !s) return i.uniqueFeatureID = !1, void o.layers[e1.fqid].targets.push(i);
                    o.layers[e1.fqid].targets.push({
                        ...i,
                        namespace: s.namespace,
                        properties: s.properties,
                        uniqueFeatureID: s.uniqueFeatureID
                    });
                };
                for (const t1 of i)if ("featuresetId" in t1.target) {
                    const { featuresetId: i, importId: s } = t1.target, r = this.getFragmentStyle(s);
                    if (!r || !r._featuresetSelectors) continue;
                    const n = r._featuresetSelectors[i];
                    if (!n) {
                        this.fire(new e1.h(new Error(`The featureset '${i}' does not exist in the map's style and cannot be queried for features.`)));
                        continue;
                    }
                    for (const e1 of n){
                        const i = r.getOwnLayer(e1.layerId);
                        i && !Jn.has(i.type) && o(i, r.getOwnLayerSourceCache(i), t1, e1);
                    }
                } else if ("layerId" in t1.target) {
                    const { layerId: e1 } = t1.target, i = this.getLayer(e1);
                    if (!i || Jn.has(i.type)) continue;
                    o(i, this.getLayerSourceCache(i), t1);
                }
                const n = this._queryRenderedFeatures(t1, r, s);
                return this._flattenAndSortRenderedFeatures(n);
            }
            _queryRenderedFeatures(t1, i, s) {
                const r = [], o = !!this.map._showQueryGeometry, n = Ao.createFromScreenPoints(t1, s);
                for(const e1 in i){
                    const t1 = Zo(n, i[e1], this._availableImages, s, o, this.getActualScope());
                    Object.keys(t1).length && r.push(t1);
                }
                if (this.placement) for(const t1 in i){
                    if (i[t1].sourceCache._renderSourceType !== e1.b_.Symbol) continue;
                    const s = Wo(n.screenGeometry, i[t1], this._availableImages, this.placement.collisionIndex, this.placement.retainedQueryData, this.map.getWorldview());
                    Object.keys(s).length && r.push(s);
                }
                return r;
            }
            querySourceFeatures(e1, t1) {
                const i = t1 && t1.filter;
                i && this._validate(Ot, "querySourceFeatures.filter", i, null, t1);
                let s = [];
                const r = this.getOwnSourceCaches(e1);
                for (const e1 of r)s = s.concat(Ho(e1, t1));
                return s;
            }
            getFlatLight() {
                return this.light.getLight();
            }
            setFlatLight(t1, i, s = {}) {
                this._checkLoaded();
                const r = this.light.getLight();
                let o = !1;
                for(const i in t1)if (!e1.Y(t1[i], r[i])) {
                    o = !0;
                    break;
                }
                if (!o) return;
                const n = this._getTransitionParameters();
                this.light.setLight(t1, i, s), this.light.updateTransitions(n);
            }
            hasTerrain() {
                return !!this.terrain && 1 === this.terrain.drapeRenderMode;
            }
            getTerrain() {
                return this.hasTerrain() ? this.terrain.get() : null;
            }
            _startLiteLoad() {
                void 0 === this._drapingLoaded && (this._drapingLoaded = !1, (async function() {
                    return Promise.resolve();
                })().then(()=>{
                    this._drapingLoaded = !0, this.map._removed || 0 === this.dispatcher.actors.length || this.map.triggerRepaint();
                }));
            }
            _getRasterMaskUser(e1, t1) {
                for (const i of this._order){
                    const s = this._layers[i];
                    if ("raster" !== s.type || !s.getPaintProperty("raster-mask")) continue;
                    const r = s.getPaintProperty("raster-mask-import");
                    if ("import" === t1 ? r === e1 : !r && s.getPaintProperty("raster-mask") === e1) return i;
                }
            }
            _startRasterArrayLoad() {
                void 0 === this._rasterArrayLoaded && (this._rasterArrayLoaded = !1, Ro().then(()=>{
                    this._rasterArrayLoaded = !0, this.map._removed || this.map.triggerRepaint();
                }));
            }
            setTerrainForDraping() {
                this._startLiteLoad(), this.setTerrain({
                    source: "",
                    exaggeration: 0
                }, 0);
            }
            checkCanvasFingerprintNoise() {
                void 0 === this.disableElevatedTerrain && (this.disableElevatedTerrain = e1.e.hasCanvasFingerprintNoise(), this.disableElevatedTerrain && e1.w("Terrain and hillshade are disabled because of Canvas2D limitations when fingerprinting protection is enabled (e.g. in private browsing mode)."));
            }
            setTerrain(t1, i = 1) {
                if (this._checkLoaded(), !t1) return this.terrainSetForDrapingOnly() || (delete this.terrain, this.map.transform.projection.requiresDraping && this.setTerrainForDraping()), 0 === i && delete this.terrain, null === t1 ? this.stylesheet.terrain = null : delete this.stylesheet.terrain, this._force3DLayerUpdate(), void (this._markersNeedUpdate = !0);
                this.checkCanvasFingerprintNoise();
                let s = t1;
                const r = !("source" in t1) || null == t1.source;
                if (1 === i) {
                    if (this._startLiteLoad(), this.disableElevatedTerrain) return;
                    if ("source" in s && "object" == typeof s.source) {
                        const t1 = "terrain-dem-src";
                        this.addSource(t1, s.source), s = e1.dL(s), s = Object.assign(s, {
                            source: t1
                        });
                    }
                    const t1 = {
                        ...s
                    }, i = {};
                    if (this.terrain && r) {
                        t1.source = this.terrain.get().source;
                        const e1 = this.terrain ? this.getFragmentStyle(this.terrain.scope) : null;
                        e1 && (i.style = e1.serialize());
                    }
                    if (this._validate(Lt, "terrain", t1, i)) return;
                }
                if (!this.terrain || this.terrain.scope !== this.scope && !r || this.terrain && i !== this.terrain.drapeRenderMode) {
                    if (!s) return;
                    this._createTerrain(s, i), this.fire(new e1.i("data", {
                        dataType: "style"
                    }));
                } else {
                    const i = this.terrain, r = i.get();
                    for (const t1 of Object.keys(e1.s.terrain))!Object.hasOwn(s, t1) && e1.s.terrain[t1].default && (s[t1] = e1.s.terrain[t1].default);
                    for(const s in t1)if (!e1.Y(t1[s], r[s])) {
                        i.set(t1, this.options), this.stylesheet.terrain = t1;
                        const s = this._getTransitionParameters({
                            duration: 0
                        });
                        i.updateTransitions(s), this.fire(new e1.i("data", {
                            dataType: "style"
                        }));
                        break;
                    }
                }
                this.mergeTerrain(), this.updateDrapeFirstLayers(), this._markersNeedUpdate = !0;
            }
            _createFog(e1) {
                const t1 = this.fog = new Wt(e1, this.map.transform, this.scope, this.options);
                this.stylesheet.fog = t1.get();
                const i = this._getTransitionParameters({
                    duration: 0
                });
                t1.updateTransitions(i);
            }
            _createSnow(e1) {
                const t1 = this.snow = new Yt(e1, this.map.transform, this.scope, this.options);
                this.stylesheet.snow = t1.get();
                const i = this._getTransitionParameters({
                    duration: 0
                });
                t1.updateTransitions(i);
            }
            _createRain(e1) {
                const t1 = this.rain = new Kt(e1, this.map.transform, this.scope, this.options);
                this.stylesheet.rain = t1.get();
                const i = this._getTransitionParameters({
                    duration: 0
                });
                t1.updateTransitions(i);
            }
            _updateMarkersOpacity() {
                0 !== this.map._markers.length && this.map._requestDomTask(()=>{
                    for (const e1 of this.map._markers)e1._evaluateOpacity();
                });
            }
            getFog() {
                return this.fog ? this.fog.get() : null;
            }
            setFog(t1) {
                if (this._checkLoaded(), t1) {
                    if (this.fog) {
                        const i = this.fog;
                        if (!e1.Y(i.get(), t1)) {
                            i.set(t1, this.options), this.stylesheet.fog = i.get();
                            const e1 = this._getTransitionParameters({
                                duration: 0
                            });
                            i.updateTransitions(e1);
                        }
                    } else this._createFog(t1);
                } else delete this.fog, delete this.stylesheet.fog;
                this._markersNeedUpdate = !0, this._programPrecompiler && this._programPrecompiler.reset();
            }
            getSnow() {
                return this.snow ? this.snow.get() : null;
            }
            setSnow(t1) {
                if (this._checkLoaded(), !t1) return delete this.snow, void delete this.stylesheet.snow;
                if (this.snow) {
                    const i = this.snow;
                    if (!e1.Y(i.get(), t1)) {
                        i.set(t1, this.options), this.stylesheet.snow = i.get();
                        const e1 = this._getTransitionParameters({
                            duration: 0
                        });
                        i.updateTransitions(e1);
                    }
                } else this._createSnow(t1);
                this._markersNeedUpdate = !0;
            }
            getRain() {
                return this.rain ? this.rain.get() : null;
            }
            setRain(t1) {
                if (this._checkLoaded(), !t1) return delete this.rain, void delete this.stylesheet.rain;
                if (this.rain) {
                    const i = this.rain;
                    if (!e1.Y(i.get(), t1)) {
                        i.set(t1, this.options), this.stylesheet.rain = i.get();
                        const e1 = this._getTransitionParameters({
                            duration: 0
                        });
                        i.updateTransitions(e1);
                    }
                } else this._createRain(t1);
                this._markersNeedUpdate = !0;
            }
            _reloadColorTheme() {
                const t1 = ()=>{
                    for(const e1 in this._layers)this._layers[e1].lut = this._styleColorTheme.lut;
                    for(const e1 in this._sourceCaches)this._sourceCaches[e1].clearTiles();
                }, i = this._styleColorTheme.colorThemeOverride ? this._styleColorTheme.colorThemeOverride : this._styleColorTheme.colorTheme;
                if (!i) return this._styleColorTheme.lut = null, void t1();
                const s = this._evaluateColorThemeData(i);
                this._loadColorTheme(s).then(()=>{
                    this.fire(new e1.i("colorthemeset")), t1();
                }).catch((t1)=>{
                    e1.w(`Couldn't set color theme: ${t1}`);
                });
            }
            setColorTheme(t1) {
                this._checkLoaded(), this._styleColorTheme.colorThemeOverride && e1.w("Note: setColorTheme is called on a style with a color-theme override, the passed color-theme won't be visible."), this._styleColorTheme.colorTheme = t1, this._reloadColorTheme();
            }
            setImportColorTheme(e1, t1) {
                const i = this.getFragmentStyle(e1);
                i && (i._styleColorTheme.colorThemeOverride = t1, i._reloadColorTheme());
            }
            _getTransitionParameters(t1) {
                return {
                    now: e1.e.now(),
                    transition: Object.assign(this.transition, t1)
                };
            }
            updateDrapeFirstLayers() {
                if (!this.terrain) return;
                const e1 = [], t1 = [];
                for (const i of this._mergedOrder)this.isLayerDraped(this._mergedLayers[i]) ? e1.push(i) : t1.push(i);
                this._drapedFirstOrder = [], this._drapedFirstOrder.push(...e1), this._drapedFirstOrder.push(...t1);
            }
            _createTerrain(t1, i) {
                const s = this.terrain = new qt(t1, i, this.scope, this.options, this.map.getWorldview());
                1 === i && (this.stylesheet.terrain = t1), this.mergeTerrain(), this.updateDrapeFirstLayers(), this._force3DLayerUpdate();
                const r = this._getTransitionParameters({
                    duration: 0
                });
                s.updateTransitions(r);
                const o = new e1.au(this.z || 0, {
                    ...r,
                    worldview: this.map.getWorldview()
                });
                s.recalculate(o);
            }
            _force3DLayerUpdate() {
                for(const e1 in this._layers){
                    const t1 = this._layers[e1];
                    "fill-extrusion" === t1.type && this._updateLayer(t1);
                }
            }
            _forceSymbolLayerUpdate() {
                for(const e1 in this._layers){
                    const t1 = this._layers[e1];
                    "symbol" === t1.type && this._updateLayer(t1);
                }
            }
            _validate(t1, i, s, r, o = {}) {
                if (o && !1 === o.validate) return !1;
                const n = {
                    ...this.serialize()
                };
                return Yn(this, t1.call(Et, {
                    key: i,
                    style: n,
                    value: s,
                    styleSpec: e1.s,
                    ...r
                }));
            }
            _remove() {
                this._programPrecompiler && (this._programPrecompiler.reset(), this._programPrecompiler = null), this._request && (this._request.cancel(), this._request = null), this._spriteRequest && (this._spriteRequest.abort(), this._spriteRequest = null);
                for(const e1 in this._mergedLayers)this._mergedLayers[e1].setEventedParent(null);
                for(const e1 in this._mergedSourceCaches){
                    const t1 = this._mergedSourceCaches[e1];
                    t1.clearTiles(), t1.setEventedParent(null);
                    const i = t1.getSource();
                    i && i.onRemove && i.onRemove(this.map);
                }
                this.imageManager.removeScope(this.scope), this.isRootStyle() ? this.imageManager.imageAtlasCache.clear() : this.imageManager.imageAtlasCache.removeScope(this.scope), this.setEventedParent(null), delete this.fog, delete this.snow, delete this.rain, delete this.terrain, delete this.ambientLight, delete this.directionalLight, this.indoorManager && this.indoorManager.destroy(), this.isRootStyle() && (this.imageManager.setEventedParent(null), this.modelManager.setEventedParent(null), this.modelManager.destroy(), this.dispatcher.remove());
            }
            clearSource(e1) {
                const t1 = this.getSourceCaches(e1);
                for (const e1 of t1)e1.clearTiles();
            }
            clearSources() {
                for(const e1 in this._mergedSourceCaches)this._mergedSourceCaches[e1].clearTiles();
            }
            clearLayers() {
                for(const e1 in this._mergedLayers){
                    const t1 = this._mergedLayers[e1];
                    t1._clear && t1._clear();
                }
            }
            reloadSource(e1) {
                const t1 = this.getSourceCaches(e1);
                for (const e1 of t1)e1.resume(), e1.reload();
            }
            reloadSources() {
                for (const e1 of this.getSources())e1.reload && e1.reload();
            }
            reloadModels() {
                this.modelManager.reloadModels(""), this.forEachFragmentStyle((e1)=>{
                    e1.modelManager.reloadModels(e1.scope);
                });
            }
            updateSources(t1) {
                let i;
                this.directionalLight && (i = e1.dV(this.directionalLight));
                const s = new Set, r = new Set, o = new Set;
                for(const e1 in this._mergedLayers){
                    const t1 = this._mergedLayers[e1];
                    "building" === t1.type ? s.add(t1.source) : "raster" === t1.type && t1.paint && "ground" === t1.paint.get("raster-elevation-reference") && o.add(t1.source), t1.hasElevation() && !r.has(t1.source) && r.add(t1.source);
                }
                this.updateFrcCoverageFadeRange();
                for(const e1 in this._mergedSourceCaches){
                    const n = this._mergedSourceCaches[e1], a = r.has(n._source.id);
                    n._isRasterElevatedOverTerrain = o.has(n._source.id), s.has(n._source.id) && (n._source.reparseOverscaled = !1), n.update(t1, void 0, void 0, i, a);
                }
                this.updateFrcCoverage(), this.updateElevationCoverage();
            }
            _reloadSources() {
                for(const e1 in this._sourceCaches){
                    const t1 = this._sourceCaches[e1];
                    t1.resume(), t1.reload();
                }
            }
            updateFrcCoverageFadeRange() {
                this.map.painter && Xs.updateFrcCoverageFadeRange && Xs.updateFrcCoverageFadeRange(this, this.map.painter);
            }
            updateFrcCoverage() {
                this._hdCoverage && Xs.updateFrcCoverage && Xs.updateFrcCoverage(this, this._hdCoverage);
            }
            updateElevationCoverage() {
                this.isRootStyle() && Xs.setupAndUpdateElevationCoverage && Xs.setupAndUpdateElevationCoverage(this);
            }
            _handleLayerOrderChange() {
                this._requestFullLabelPlacement(), this.fire(new e1.i("neworder"));
            }
            _requestFullLabelPlacement() {
                this.pauseablePlacement || (this.pauseablePlacement = new In), this.pauseablePlacement.requestFullPlacement();
            }
            _setLabelPlacementStale() {
                this.placement && this.placement.setStale();
            }
            _updatePlacement(t1, i, s, r, o, n) {
                this.pauseablePlacement || (this.pauseablePlacement = new In);
                let a = !1, l = !1;
                const c = {}, h = {}, d = "global" === n, u = d ? [] : this._mergedOrder;
                let p = !1;
                d && (p = this._driveGlobalPlacement(t1, o, s, i));
                for (const i of u){
                    const s = this._mergedLayers[i];
                    if ("symbol" !== s.type) continue;
                    const r = e1.m(s.source, s.scope);
                    let o = c[r];
                    if (!o) {
                        const e1 = this.getLayerSourceCache(s);
                        if (!e1) continue;
                        const t1 = e1.getRenderableIds(!0).map((t1)=>e1.getTileByID(t1));
                        h[r] = t1.slice(), o = c[r] = t1.sort((e1, t1)=>t1.tileID.overscaledZ - e1.tileID.overscaledZ || (e1.tileID.isLessThan(t1.tileID) ? -1 : 1));
                    }
                    const n = this.crossTileSymbolIndex.addLayer(s, o, t1.center.lng, t1.projection);
                    a = a || n;
                }
                this.crossTileSymbolIndex.pruneUnusedLayers(u);
                const f = Boolean(this.placement && !t1.equals(this.placement.transform)), m = Boolean(this.placement && (0 !== this.placement.lastReplacementSourceUpdateTime && !o || this.placement.lastReplacementSourceUpdateTime !== o.updateTime)), _ = f || m || a, g = (_ || this.pauseablePlacement.isStale()) && 0 === s, y = this.pauseablePlacement.isDone() && !this.placement.stillRecent(e1.e.now(), t1.zoom) && 0 !== s;
                if ((this.pauseablePlacement.isFullPlacementRequested() || !this.pauseablePlacement.placement || g || y) && (this.pauseablePlacement = this.pauseablePlacement.startNewPlacement(t1, u, i, s, r, this.placement, this.fog && t1.projection.supportsFog ? this.fog.state : null, this._buildingIndex), this.map.painter)) {
                    const e1 = this.map.painter.maxFrontCutoffRawStart;
                    if (e1 > 0) {
                        const i = 180 * t1.pitch / Math.PI;
                        if (i >= 15) {
                            const t1 = Math.min(1, Math.max(0, (i - 15) / 5)), s = t1 * t1 * (3 - 2 * t1);
                            this.pauseablePlacement.placement.frontCutoffStart = -0.5 * (1 - s) + e1 * s;
                        }
                    }
                }
                if (this.pauseablePlacement.isDone() ? _ && 0 !== s && this.pauseablePlacement.setStale() : (this.pauseablePlacement.continuePlacement(u, this._mergedLayers, c, h, this.map.painter.scaleFactor), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(e1.e.now()), l = !0), a && this.pauseablePlacement.setStale()), l || a) {
                    this._buildingIndex.onNewFrame(t1.zoom);
                    for(let t1 = 0; t1 < u.length; t1++){
                        const s = this._mergedLayers[u[t1]];
                        if ("symbol" !== s.type) continue;
                        if ("none" === s.visibility) continue;
                        const r = this.isLayerClipped(s);
                        this.placement.updateLayerOpacities(s, c[e1.m(s.source, s.scope)], t1, r ? o : null, i, this.map.painter.scaleFactor);
                    }
                }
                return !this.pauseablePlacement.isDone() || this.placement.isStale() || this.placement.hasTransitions(e1.e.now()) || p;
            }
            _driveGlobalPlacement(t1, i, s, r) {
                if (0 === t1.width || 0 === t1.height) return !1;
                this.globalPlacement || (this.globalPlacement = new Nn);
                const o = this.globalPlacement;
                o.startPlacement(e1.e.now(), t1.width, t1.height, r), this._buildingIndex.onNewFrame(t1.zoom);
                const n = this.fog && t1.projection.supportsFog ? this.fog.state : null;
                if (this._groupOrdersVersion !== this._mergedOrderVersion || !this._groupOrders) {
                    const t1 = new Map;
                    for(let i = 0; i < this._mergedOrder.length; i++){
                        const s = this._mergedLayers[this._mergedOrder[i]];
                        "placement-group" === s.type && t1.set(s.fqid, e1.dW(i));
                    }
                    this._groupOrders = t1, this._groupOrdersVersion = this._mergedOrderVersion;
                }
                const a = this._groupOrders, l = [
                    e1.ad(t1.center.lng),
                    e1.ae(t1.center.lat)
                ], c = {
                    globalPlacement: o,
                    transform: t1,
                    buildingIndex: this._buildingIndex,
                    fogState: n,
                    groupOrders: a,
                    replacementSource: i,
                    mercatorCenter: l,
                    fadeDuration: s
                }, h = {}, d = {};
                let u = !1;
                for(let t1 = 0; t1 < this._mergedOrder.length; t1++){
                    const i = this._mergedLayers[this._mergedOrder[t1]];
                    if ("symbol" !== i.type) continue;
                    const s = this.getLayerSourceCache(i);
                    if (!s) continue;
                    const r = e1.m(i.source, i.scope);
                    let o = h[r], n = d[r];
                    o || (o = h[r] = s.getRenderableIds(!0).map((e1)=>s.getTileByID(e1)), n = d[r] = oa(o));
                    const a = this.isLayerClipped(i);
                    i.placeSymbols(c, o, t1, s, a, n);
                    for (const e1 of o){
                        const t1 = e1.getBucket(i);
                        t1 && i.fqid === t1.layerIds[0] && t1.hasActiveFade() && (u = !0);
                    }
                }
                return o.finishPlacementRun(), u;
            }
            _releaseSymbolFadeTiles() {
                for(const e1 in this._sourceCaches)this._sourceCaches[e1].releaseSymbolFadeTiles();
            }
            addImport(t1, i) {
                if (this._checkLoaded(), new Set([
                    "__proto__",
                    "constructor",
                    "prototype"
                ]).has(t1.id)) return void this.fire(new e1.h(new Error(`Import id can't be "${t1.id}".`)));
                const s = this.stylesheet.imports = this.stylesheet.imports || [];
                if (-1 !== s.findIndex(({ id: e1 })=>e1 === t1.id)) return void this.fire(new e1.h(new Error(`Import with id '${t1.id}' already exists in the map's style.`)));
                if (!i) return s.push(t1), this._loadImports([
                    t1
                ], !0);
                const r = s.findIndex(({ id: e1 })=>e1 === i);
                return -1 === r && this.fire(new e1.h(new Error(`Import with id "${i}" does not exist on this map.`))), this.stylesheet.imports = s.slice(0, r).concat(t1).concat(s.slice(r)), this._loadImports([
                    t1
                ], !0, i);
            }
            updateImport(t1, i) {
                this._checkLoaded();
                const s = this.stylesheet.imports || [], r = this.getImportIndex(t1);
                return -1 === r ? this : "string" == typeof i ? (this.setImportUrl(t1, i), this) : (i.url && i.url !== s[r].url && this.setImportUrl(t1, i.url), e1.Y(i.config, s[r].config) || this.setImportConfig(t1, i.config, i.data.schema), e1.Y(i.data, s[r].data) || this.setImportData(t1, i.data), this);
            }
            moveImport(e1, t1) {
                this._checkLoaded();
                let i = this.stylesheet.imports || [];
                const s = this.getImportIndex(e1);
                if (-1 === s) return this;
                const r = this.getImportIndex(t1);
                if (-1 === r) return this;
                const o = i[s], n = this.fragments[s];
                return i = i.filter(({ id: t1 })=>t1 !== e1), this.fragments = this.fragments.filter(({ id: t1 })=>t1 !== e1), this.stylesheet.imports = i.slice(0, r).concat(o).concat(i.slice(r)), this.fragments = this.fragments.slice(0, r).concat(n).concat(this.fragments.slice(r)), this.mergeLayers(), this;
            }
            setImportUrl(e1, t1) {
                this._checkLoaded();
                const i = this.stylesheet.imports || [], s = this.getImportIndex(e1);
                if (-1 === s) return this;
                i[s].url = t1;
                const r = this.fragments[s];
                return r.style = this._createFragmentStyle(i[s]), r.style.on("style.import.load", ()=>this.mergeAll()), r.style.loadURL(t1), this;
            }
            setImportData(e1, t1) {
                this._checkLoaded();
                const i = this.getImportIndex(e1), s = this.stylesheet.imports || [];
                return -1 === i ? this : t1 ? (this.fragments[i].style.setState(t1), this._reloadImports(), this) : (delete s[i].data, this.setImportUrl(e1, s[i].url));
            }
            setImportConfig(e1, t1, i) {
                this._checkLoaded();
                const s = this.getImportIndex(e1), r = this.stylesheet.imports || [];
                if (-1 === s) return this;
                t1 ? r[s].config = t1 : delete r[s].config;
                const o = this.fragments[s];
                i && o.style.stylesheet && (o.style.stylesheet.schema = i);
                const n = o.style.stylesheet && o.style.stylesheet.schema;
                return o.config = t1, o.style.updateConfig(t1, n), this.updateConfigDependencies(), this;
            }
            removeImport(e1) {
                this._checkLoaded();
                const t1 = this.stylesheet.imports || [], i = this.getImportIndex(e1);
                -1 !== i && (t1.splice(i, 1), this.fragments[i].style._remove(), this.fragments.splice(i, 1), this._reloadImports());
            }
            getImportIndex(t1) {
                const i = (this.stylesheet.imports || []).findIndex((e1)=>e1.id === t1);
                return -1 === i && this.fire(new e1.h(new Error(`Import '${t1}' does not exist in the map's style and cannot be updated.`))), i;
            }
            getLayer(e1) {
                return this._mergedLayers[e1];
            }
            getSources() {
                const e1 = [];
                for(const t1 in this._mergedOtherSourceCaches){
                    const i = this._mergedOtherSourceCaches[t1];
                    i && e1.push(i.getSource());
                }
                return e1;
            }
            getSource(e1, t1) {
                const i = this.getSourceCache(e1, t1);
                return i && i.getSource();
            }
            getLayerSource(e1) {
                const t1 = this.getLayerSourceCache(e1);
                return t1 && t1.getSource();
            }
            getSourceCache(t1, i) {
                const s = e1.m(t1, i);
                return this._mergedOtherSourceCaches[s];
            }
            getLayerSourceCache(t1) {
                const i = t1.sourceFqid;
                return "symbol" === t1.type ? this._mergedSymbolSourceCaches[i] : "fill-extrusion" === t1.type ? this._mergedFillExtrusionSourceCaches[i] || this._mergedOtherSourceCaches[i] : "fill" === t1.type && t1.sourceLayer === e1.c0 && this._mergedHdRoadCoverageSourceCaches[i] ? this._mergedHdRoadCoverageSourceCaches[i] : this._mergedOtherSourceCaches[i];
            }
            getSourceCaches(e1) {
                return null == e1 ? Object.values(this._mergedSourceCaches) : [
                    this._mergedOtherSourceCaches[e1],
                    this._mergedSymbolSourceCaches[e1],
                    this._mergedFillExtrusionSourceCaches[e1],
                    this._mergedHdRoadCoverageSourceCaches[e1]
                ].filter(Boolean);
            }
            updateSourceCaches() {
                const e1 = this._changes.getUpdatedSourceCaches();
                for(const t1 in e1){
                    const i = e1[t1];
                    "reload" === i ? this.reloadSource(t1) : "clear" === i && this.clearSource(t1);
                }
            }
            updateLayers(e1) {
                const t1 = this._changes.getUpdatedPaintProperties();
                for (const i of t1){
                    const t1 = this.getLayer(i);
                    t1 && t1.updateTransitions(e1);
                }
            }
            getGlyphsUrl() {
                return this.stylesheet.glyphs;
            }
            setGlyphsUrl(e1) {
                this.stylesheet.glyphs = e1, this.glyphManager.setURL(e1);
            }
            getOwnSourceCache(e1) {
                return this._otherSourceCaches[e1];
            }
            getOwnLayerSourceCache(e1) {
                return "symbol" === e1.type ? this._symbolSourceCaches[e1.source] : "fill-extrusion" === e1.type && this._fillExtrusionSourceCaches[e1.source] || this._otherSourceCaches[e1.source];
            }
            getOwnSourceCaches(e1) {
                return [
                    this._otherSourceCaches[e1],
                    this._symbolSourceCaches[e1],
                    this._fillExtrusionSourceCaches[e1],
                    this._hdCoverage && this._hdCoverage.coverageSourceCaches[e1]
                ].filter(Boolean);
            }
            _updateHdCoverageSourceCache(t1) {
                return Xs.HdCoverageState && Xs.updateHdCoverageSourceCache ? (this._hdCoverage || (this._hdCoverage = new Xs.HdCoverageState), Xs.updateHdCoverageSourceCache(this, this._hdCoverage, t1), !1) : "fill" === t1.type && t1.sourceLayer === e1.c0;
            }
            _isSourceCacheLoaded(t1) {
                const i = this.getOwnSourceCaches(t1);
                return 0 === i.length ? (this.fire(new e1.h(new Error(`There is no source with ID '${t1}'`))), !1) : i.every((e1)=>e1.loaded());
            }
            has3DLayers() {
                return this._has3DLayers;
            }
            hasSymbolLayers() {
                return this._hasSymbolLayers;
            }
            hasCircleLayers() {
                return this._hasCircleLayers;
            }
            isLayerClipped(e1, t1) {
                if (!this._clipLayerPresent && "fill-extrusion" !== e1.type && "building" !== e1.type) return !1;
                const i = "fill-extrusion" === e1.type && ("building" === e1.sourceLayer || "procedural_buildings" === e1.sourceLayer), s = "building" === e1.type;
                if (e1.is3D(!!this.terrain)) {
                    if (i || s || t1 && "batched-model" === t1.type) return !0;
                    if ("model" === e1.type) return !0;
                } else if ("symbol" === e1.type) return !0;
                return !1;
            }
            _clearWorkerCaches() {
                this.dispatcher.broadcast("clearCaches");
            }
            getBOMObject() {}
            destroy() {
                this._clearWorkerCaches(), this.imageManager.imageAtlasCache.clear(), this.fragments.forEach((e1)=>{
                    e1.style._remove();
                }), this.terrainSetForDrapingOnly() && (delete this.terrain, delete this.stylesheet.terrain);
            }
            async getImages(t1, i) {
                const s = new Promise((e1, t1)=>{
                    this.imageManager.getImages(i.icons.concat(i.patterns), i.scope, (i, s)=>{
                        i ? t1(i) : e1(s);
                    });
                });
                this._updateTilesForChangedImages();
                const r = i.icons.map((t1)=>e1.I.toString(t1)), o = i.patterns.map((t1)=>e1.I.toString(t1)), n = (e1)=>{
                    e1 && (e1.setDependencies(i.tileID.key, "icons", r), e1.setDependencies(i.tileID.key, "patterns", o));
                }, a = e1.m(i.source, i.scope);
                return n(this._mergedOtherSourceCaches[a]), n(this._mergedSymbolSourceCaches[a]), (i.icons.some((e1)=>e1.iconsetId) || i.patterns.some((e1)=>e1.iconsetId)) && this.fire(new e1.i("data", {
                    dataType: "style"
                })), s;
            }
            async rasterizeImages(e1, t1) {
                return new Promise((e1, i)=>{
                    this.imageManager.rasterizeImages(t1, (t1, s)=>{
                        t1 ? i(t1) : e1(s);
                    });
                });
            }
            async checkAtlasCache(e1, t1) {
                const i = this.imageManager.imageAtlasCache.findCachedAtlas(t1.descriptor);
                return i && i.contentDescriptor ? {
                    iconPositions: i.iconPositions,
                    patternPositions: i.patternPositions,
                    sourceHash: i.contentDescriptor.hash
                } : null;
            }
            async getGlyphs(e1, t1) {
                return new Promise((e1, i)=>{
                    this.glyphManager.getGlyphs(t1.stacks, (t1, s)=>{
                        t1 ? i(t1) : e1(s);
                    });
                });
            }
        }
        class aa {
            constructor(){
                this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffers = [], this.vao = null;
            }
            bind(e1, t1, i, s, r, o, n, a) {
                this.context = e1;
                let l = this.boundPaintVertexBuffers.length !== s.length;
                for(let e1 = 0; !l && e1 < s.length; e1++)this.boundPaintVertexBuffers[e1] !== s[e1] && (l = !0);
                let c = this.boundDynamicVertexBuffers.length !== n.length;
                for(let e1 = 0; !c && e1 < n.length; e1++){
                    const t1 = this.boundDynamicVertexBuffers[e1], i = n[e1];
                    t1 === i || t1 && i && t1.attributes === i.attributes || (c = !0);
                }
                if (!this.vao || this.boundProgram !== t1 || this.boundLayoutVertexBuffer !== i || l || c || this.boundIndexBuffer !== r || this.boundVertexOffset !== o) this.freshBind(t1, i, s, r, o, n, a);
                else {
                    e1.bindVertexArrayOES.set(this.vao);
                    for(let i = 0; i < n.length; i++){
                        const s = n[i];
                        s && (s.bind(), s !== this.boundDynamicVertexBuffers[i] && s.setVertexAttribPointers(e1.gl, t1, o), a && s.instanceCount && s.setVertexAttribDivisor(e1.gl, t1, a));
                    }
                    r && r.dynamicDraw && r.bind(), this.boundDynamicVertexBuffers = n;
                }
            }
            freshBind(e1, t1, i, s, r, o, n) {
                const a = this.context, l = a.gl;
                this.vao && this.destroy(), this.vao = a.gl.createVertexArray(), a.bindVertexArrayOES.set(this.vao), this.boundProgram = e1, this.boundLayoutVertexBuffer = t1, this.boundPaintVertexBuffers = i, this.boundIndexBuffer = s, this.boundVertexOffset = r, this.boundDynamicVertexBuffers = o, t1.enableAttributes(l, e1), t1.bind(), t1.setVertexAttribPointers(l, e1, r);
                for (const t1 of i)t1.enableAttributes(l, e1), t1.bind(), t1.setVertexAttribPointers(l, e1, r);
                for (const t1 of o)t1 && (t1.enableAttributes(l, e1), t1.bind(), t1.setVertexAttribPointers(l, e1, r), n && t1.instanceCount && t1.setVertexAttribDivisor(l, e1, n));
                s && s.bind();
            }
            destroy() {
                this.vao && (this.context.gl.deleteVertexArray(this.vao), this.vao = null);
            }
        }
        function la(t1, i, s) {
            const r = function(t1, i, s) {
                const r = e1.d$(i, t1), o = e1.d$(s, [
                    .2126,
                    .7152,
                    .0722
                ]), n = 1 - .3 * Math.min(o, 1), a = e1.aw(n, 1, Math.min(r + 1, 1));
                return e1.aw(.92, 1, Math.asin(e1.bb(i[2], -1, 1)) / Math.PI + .5) * a;
            }(t1, [
                0,
                0,
                1
            ], i), o = [
                0,
                0,
                0
            ];
            e1.dY(o, s.slice(0, 3), r);
            const n = [
                0,
                0,
                0
            ];
            e1.dY(n, i.slice(0, 3), t1[2]);
            const a = [
                0,
                0,
                0
            ];
            return e1.dZ(a, o, n), e1.d_(a);
        }
        const ca = (t1, i, s, r)=>{
            const o = t1.properties.get("direction"), n = "none" === t1.properties.get("color-use-theme"), a = t1.properties.get("color").toNonPremultipliedRenderColor(n ? null : s.getLut(t1.scope)).toArray01();
            let l = t1.properties.get("intensity");
            const c = "none" === i.properties.get("color-use-theme"), h = i.properties.get("color").toNonPremultipliedRenderColor(c ? null : s.getLut(i.scope)).toArray01();
            let d = i.properties.get("intensity");
            const u = [
                o.x,
                o.y,
                o.z
            ];
            r && (void 0 !== r.ambientIntensity && (d = r.ambientIntensity), void 0 !== r.directionalIntensity && (l = r.directionalIntensity), void 0 !== r.ambientColor && (h[0] = r.ambientColor[0], h[1] = r.ambientColor[1], h[2] = r.ambientColor[2]), void 0 !== r.directionalColor && (a[0] = r.directionalColor[0], a[1] = r.directionalColor[1], a[2] = r.directionalColor[2]));
            const p = e1.dX(h, d), f = e1.dX(a, l);
            return {
                u_lighting_ambient_color: p,
                u_lighting_directional_dir: u,
                u_lighting_directional_color: f,
                u_ground_radiance: la(u, f, p)
            };
        }, ha = [
            "fill",
            "fillOutline",
            "fillPattern",
            "line",
            "linePattern",
            "background",
            "backgroundPattern",
            "hillshade",
            "raster"
        ], da = [
            "stars",
            "rainParticle",
            "snowParticle",
            "fillExtrusion",
            "fillExtrusionGroundEffect",
            "building",
            "buildingBloom",
            "elevatedStructures",
            "model",
            "symbol"
        ];
        function ua(e1, t1, i) {
            for (const s of i)(s.includes(" ") || t1.usedDefines.has(s)) && (e1 += `/${s}`);
            return e1;
        }
        class pa {
            static cacheKey(e1, t1, i, s, r) {
                let o = t1;
                return r && (o += `/${r.cacheKey}`), o = ua(o, e1, i), s ? ua(o, e1, s) : o;
            }
            constructor(t1, i, s, r, o, n, a = !1){
                const l = t1.gl;
                this.program = l.createProgram(), this._context = t1, this._fixedUniformsFn = o, this._pending = !0, this._precompiled = a, this.attributes = {}, this.configuration = r, this.name = i, this.fixedDefines = [
                    ...n
                ], a ? t1._compileStats.precompiled++ : t1._compileStats.onDemand++;
                const c = `#version 300 es\n${(r ? r.defines() : []).concat(n.map((e1)=>`#define ${e1}`)).join("\n")}`, h = [
                    c,
                    e1.e0
                ];
                for (const t1 of s.fragmentIncludes)h.push(e1.bl[t1]);
                h.push(s.fragmentSource);
                const d = h.join("\n"), u = [
                    c,
                    e1.e1
                ];
                for (const t1 of s.vertexIncludes)u.push(e1.bl[t1]);
                this.forceManualRenderingForInstanceIDShaders = t1.forceManualRenderingForInstanceIDShaders && s.vertexSource.includes("gl_InstanceID"), this.forceManualRenderingForInstanceIDShaders && u.push("uniform int u_instanceID;"), u.push(s.vertexSource);
                let p = u.join("\n");
                this.forceManualRenderingForInstanceIDShaders && (p = p.replaceAll("gl_InstanceID", "u_instanceID"));
                const f = l.createShader(l.FRAGMENT_SHADER);
                if (l.isContextLost()) return this.failedToCreate = !0, void (this._pending = !1);
                l.shaderSource(f, d), l.compileShader(f), l.attachShader(this.program, f);
                const m = l.createShader(l.VERTEX_SHADER);
                if (l.isContextLost()) return this.failedToCreate = !0, void (this._pending = !1);
                l.shaderSource(m, p), l.compileShader(m), l.attachShader(this.program, m), l.linkProgram(this.program), this._fragmentShader = f, this._vertexShader = m, t1.extParallelShaderCompile ? t1._pendingPrograms.add(this) : this._finalize();
            }
            _finalize() {
                if (!this._pending) return;
                this._pending = !1;
                const t1 = this._context, i = t1.gl;
                t1._pendingPrograms.delete(this);
                const s = e1.e.now(), r = i.getProgramParameter(this.program, i.LINK_STATUS), o = e1.e.now() - s, n = t1._compileStats;
                if (n.totalStallMs += o, o > n.maxStallMs && (n.maxStallMs = o), o > 1) {
                    n.framesMissed += Math.floor(60 * o / 1e3);
                    const e1 = this.fixedDefines.join(",");
                    n.stalls.push({
                        name: `${this.name}${e1 ? "/" : ""}${e1}`,
                        ms: o,
                        timestamp: s
                    });
                }
                if (this._fragmentShader && (r || e1.w(`Fragment shader '${this.name}': ${i.getShaderInfoLog(this._fragmentShader)}`), i.deleteShader(this._fragmentShader), this._fragmentShader = null), this._vertexShader && (r || e1.w(`Vertex shader '${this.name}': ${i.getShaderInfoLog(this._vertexShader)}`), i.deleteShader(this._vertexShader), this._vertexShader = null), !r) return e1.w(`Failed to link program '${this.name}': ${i.getProgramInfoLog(this.program)}`), void (this.failedToCreate = !0);
                this.fixedUniforms = this._fixedUniformsFn(t1), this.activeUniforms = Object.entries(this.fixedUniforms).filter(([e1, t1])=>t1.fetchUniformLocation(this.program, e1)), this.binderUniforms = this.configuration ? this.configuration.getUniforms(t1) : [], this.forceManualRenderingForInstanceIDShaders && (this.instancingUniforms = ((t1)=>({
                        u_instanceID: new e1.b6(t1)
                    }))(t1));
                const a = this.fixedDefines, l = this.name;
                (a.includes("TERRAIN") || a.includes("ELEVATED") || l.includes("symbol") || l.includes("circle")) && (this.terrainUniforms = ((t1)=>({
                        u_dem: new e1.b6(t1),
                        u_dem_prev: new e1.b6(t1),
                        u_dem_tl: new e1.a8(t1),
                        u_dem_scale: new e1.a9(t1),
                        u_dem_tl_prev: new e1.a8(t1),
                        u_dem_scale_prev: new e1.a9(t1),
                        u_dem_size: new e1.a9(t1),
                        u_dem_lerp: new e1.a9(t1),
                        u_exaggeration: new e1.a9(t1),
                        u_depth: new e1.b6(t1),
                        u_depth_size_inv: new e1.a8(t1),
                        u_depth_range_unpack: new e1.a8(t1),
                        u_occluder_half_size: new e1.a9(t1),
                        u_occlusion_depth_offset: new e1.a9(t1),
                        u_meter_to_dem: new e1.a9(t1),
                        u_label_plane_matrix_inv: new e1.aa(t1)
                    }))(t1)), a.includes("GLOBE") && (this.globeUniforms = ((t1)=>({
                        u_tile_tl_up: new e1.ab(t1),
                        u_tile_tr_up: new e1.ab(t1),
                        u_tile_br_up: new e1.ab(t1),
                        u_tile_bl_up: new e1.ab(t1),
                        u_tile_up_scale: new e1.a9(t1)
                    }))(t1)), a.includes("FOG") && (this.fogUniforms = ((t1)=>({
                        u_fog_matrix: new e1.aa(t1),
                        u_fog_range: new e1.a8(t1),
                        u_fog_color: new e1.b7(t1),
                        u_fog_horizon_blend: new e1.a9(t1),
                        u_fog_vertical_limit: new e1.a8(t1),
                        u_fog_temporal_offset: new e1.a9(t1),
                        u_frustum_tl: new e1.ab(t1),
                        u_frustum_tr: new e1.ab(t1),
                        u_frustum_br: new e1.ab(t1),
                        u_frustum_bl: new e1.ab(t1),
                        u_globe_pos: new e1.ab(t1),
                        u_globe_radius: new e1.a9(t1),
                        u_globe_transition: new e1.a9(t1),
                        u_is_globe: new e1.b6(t1),
                        u_viewport: new e1.a8(t1)
                    }))(t1)), a.includes("RENDER_CUTOFF") && (this.cutoffUniforms = e1.e2(t1)), a.includes("LIGHTING_3D_MODE") && (this.lightsUniforms = ((t1)=>({
                        u_lighting_ambient_color: new e1.ab(t1),
                        u_lighting_directional_dir: new e1.ab(t1),
                        u_lighting_directional_color: new e1.ab(t1),
                        u_ground_radiance: new e1.ab(t1)
                    }))(t1)), a.includes("RENDER_SHADOWS") && (this.shadowUniforms = e1.e3(t1));
            }
            maybeFinalize() {
                if (!this._pending) return;
                const e1 = this._context.extParallelShaderCompile;
                e1 && !this._context.gl.getProgramParameter(this.program, e1.COMPLETION_STATUS_KHR) || this._finalize();
            }
            _ensureReady() {
                this._pending && (this._finalize(), this._context.sweepPendingPrograms());
            }
            getAttributeLocation(e1, t1) {
                this._ensureReady();
                let i = this.attributes[t1];
                return void 0 === i && (i = this.attributes[t1] = e1.getAttribLocation(this.program, t1)), i;
            }
            _setUniformGroup(e1, t1, i) {
                this._ensureReady();
                const s = this[t1];
                if (!this.failedToCreate && s) {
                    e1.program.set(this.program);
                    for(const e1 in i){
                        const t1 = s[e1];
                        t1 && t1.set(this.program, e1, i[e1]);
                    }
                }
            }
            setTerrainUniformValues(e1, t1) {
                this._setUniformGroup(e1, "terrainUniforms", t1);
            }
            setGlobeUniformValues(e1, t1) {
                this._setUniformGroup(e1, "globeUniforms", t1);
            }
            setFogUniformValues(e1, t1) {
                this._setUniformGroup(e1, "fogUniforms", t1);
            }
            setCutoffUniformValues(e1, t1) {
                this._setUniformGroup(e1, "cutoffUniforms", t1);
            }
            setLightsUniformValues(e1, t1) {
                this._setUniformGroup(e1, "lightsUniforms", t1);
            }
            setShadowUniformValues(e1, t1) {
                this._setUniformGroup(e1, "shadowUniforms", t1);
            }
            _drawDebugWireframe(t1, i, s, r, o, n, a, l, c, h, d) {
                const u = t1.options.wireframe;
                if (!1 === u.terrain && !1 === u.layers2D && !1 === u.layers3D) return;
                const p = t1.context;
                if (!(()=>!(!u.terrain || "terrainRaster" !== this.name && "globeRaster" !== this.name) || !(!u.layers2D || t1._terrain && t1._terrain.renderingToTexture || !ha.includes(this.name)) || !(!u.layers3D || !da.includes(this.name)))()) return;
                const f = p.gl, m = t1.wireframeDebugCache.getLinesFromTrianglesBuffer(t1.frameCounter, o, p);
                if (!m) return;
                const _ = [
                    ...this.fixedDefines,
                    "DEBUG_WIREFRAME"
                ], g = t1.getOrCreateProgram(this.name, {
                    config: this.configuration,
                    defines: _
                });
                g._ensureReady(), p.program.set(g.program), d && d.bind(p, g.program);
                const y = (e1, t1, i)=>{
                    if (t1[e1] && i[e1]) for(const s in t1[e1])i[e1][s] && i[e1][s].set(i.program, s, t1[e1][s].current);
                };
                c && c.setUniforms(g.program, p, g.binderUniforms, a, {
                    zoom: l
                }), y("fixedUniforms", this, g), y("terrainUniforms", this, g), y("globeUniforms", this, g), y("fogUniforms", this, g), y("lightsUniforms", this, g), y("shadowUniforms", this, g), m.bind(), p.setColorMode(new e1.a7([
                    f.ONE,
                    f.ONE_MINUS_SRC_ALPHA,
                    f.ZERO,
                    f.ONE
                ], e1.C.transparent, [
                    !0,
                    !0,
                    !0,
                    !1
                ])), p.setDepthMode(new e1.a3(i.func === f.LESS ? f.LEQUAL : i.func, e1.a3.ReadOnly, i.range)), p.setStencilMode(e1.a4.disabled);
                const v = 3 * n.primitiveLength * 2, b = 3 * n.primitiveOffset * 4;
                if (this.forceManualRenderingForInstanceIDShaders) {
                    const e1 = h || 1;
                    for(let t1 = 0; t1 < e1; ++t1)g.instancingUniforms.u_instanceID.set(this.program, "u_instanceID", t1), f.drawElements(f.LINES, v, f.UNSIGNED_SHORT, b);
                } else h && h > 1 ? f.drawElementsInstanced(f.LINES, v, f.UNSIGNED_SHORT, b, h) : f.drawElements(f.LINES, v, f.UNSIGNED_SHORT, b);
                o.bind(), p.program.set(this.program), p.setDepthMode(i), p.setStencilMode(s), p.setColorMode(r);
            }
            checkUniforms(e1, t1, i) {
                if (this.fixedDefines.includes(t1)) {
                    for (const s of Object.keys(i))if (!i[s].initialized) throw new Error(`Program '${this.name}', from draw '${e1}': uniform ${s} not set but required by ${t1} being defined`);
                }
            }
            draw(e1, t1, i, s, r, o, n, a, l, c, h, d, u, p, f, m, _) {
                const g = e1.context, y = g.gl;
                if (this._ensureReady(), this.failedToCreate) return;
                g.program.set(this.program), g.setDepthMode(i), g.setStencilMode(s), g.setColorMode(r), g.setCullFace(o);
                for (const [e1, t1] of this.activeUniforms)t1.set(this.program, e1, n[e1]);
                p && p.setUniforms(this.program, g, this.binderUniforms, d, {
                    zoom: u
                });
                const v = {
                    [y.POINTS]: 1,
                    [y.LINES]: 2,
                    [y.TRIANGLES]: 3,
                    [y.LINE_STRIP]: 1
                }[t1];
                this.checkUniforms(a, "RENDER_SHADOWS", this.shadowUniforms);
                const b = f || [], x = p ? p.getPaintVertexBuffers() : [], w = t1 === y.TRIANGLES && c, T = m && m > 0 ? 1 : void 0;
                for (const o of h.get()){
                    const n = o.vaos || (o.vaos = {}), h = n[a] || (n[a] = new Map);
                    let f = h.get(this.program);
                    if (f || h.set(this.program, f = new aa), f.bind(g, this, l, x, c, o.vertexOffset, b, T), this.forceManualRenderingForInstanceIDShaders) {
                        const e1 = m || 1;
                        for(let i = 0; i < e1; ++i)this.instancingUniforms.u_instanceID.set(this.program, "u_instanceID", i), c ? y.drawElements(t1, o.primitiveLength * v, y.UNSIGNED_SHORT, o.primitiveOffset * v * 2) : y.drawArrays(t1, o.vertexOffset, o.vertexLength);
                    } else m && m > 1 ? y.drawElementsInstanced(t1, o.primitiveLength * v, y.UNSIGNED_SHORT, o.primitiveOffset * v * 2, m) : c ? y.drawElements(t1, o.primitiveLength * v, y.UNSIGNED_SHORT, o.primitiveOffset * v * 2) : y.drawArrays(t1, o.vertexOffset, o.vertexLength);
                    w && this._drawDebugWireframe(e1, i, s, r, c, o, d, u, p, m, _);
                }
            }
        }
        class fa {
            constructor(e1, t1, i, s){
                this.id = fa.uniqueIdxCounter, fa.uniqueIdxCounter++, this.context = e1;
                const r = e1.gl;
                this.buffer = r.createBuffer(), this.dynamicDraw = Boolean(i), this.context.unbindVAO(), e1.bindElementBuffer.set(this.buffer), r.bufferData(r.ELEMENT_ARRAY_BUFFER, t1.arrayBuffer, this.dynamicDraw ? r.DYNAMIC_DRAW : r.STATIC_DRAW), this.dynamicDraw || s || t1.destroy();
            }
            bind() {
                this.context.bindElementBuffer.set(this.buffer);
            }
            updateData(e1) {
                this.id = fa.uniqueIdxCounter, fa.uniqueIdxCounter++;
                const t1 = this.context.gl;
                this.context.unbindVAO(), this.bind(), t1.bufferSubData(t1.ELEMENT_ARRAY_BUFFER, 0, e1.arrayBuffer);
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        fa.uniqueIdxCounter = 0;
        const ma = {
            Int8: "BYTE",
            Uint8: "UNSIGNED_BYTE",
            Int16: "SHORT",
            Uint16: "UNSIGNED_SHORT",
            Int32: "INT",
            Uint32: "UNSIGNED_INT",
            Float32: "FLOAT"
        };
        class _a {
            constructor(e1, t1, i, s, r, o){
                this.length = t1.length, this.attributes = i, this.itemSize = t1.bytesPerElement, this.dynamicDraw = s, this.instanceCount = o, this.context = e1;
                const n = e1.gl;
                this.buffer = n.createBuffer(), e1.bindVertexBuffer.set(this.buffer), n.bufferData(n.ARRAY_BUFFER, t1.arrayBuffer, this.dynamicDraw ? n.DYNAMIC_DRAW : n.STATIC_DRAW), this.dynamicDraw || r || t1.destroy();
            }
            bind() {
                this.context.bindVertexBuffer.set(this.buffer);
            }
            updateData(e1) {
                const t1 = this.context.gl;
                this.bind(), t1.bufferSubData(t1.ARRAY_BUFFER, 0, e1.uint8, 0, e1.length * e1.bytesPerElement);
            }
            enableAttributes(e1, t1) {
                for (const i of this.attributes){
                    const s = t1.getAttributeLocation(e1, i.name);
                    -1 !== s && e1.enableVertexAttribArray(s);
                }
            }
            setVertexAttribPointers(e1, t1, i) {
                for (const s of this.attributes){
                    const r = t1.getAttributeLocation(e1, s.name);
                    if (-1 !== r) {
                        const t1 = s.offset + this.itemSize * (i || 0);
                        "Float32" === s.type || s.normalized ? e1.vertexAttribPointer(r, s.components, e1[ma[s.type]], !!s.normalized, this.itemSize, t1) : e1.vertexAttribIPointer(r, s.components, e1[ma[s.type]], this.itemSize, t1);
                    }
                }
            }
            setVertexAttribDivisor(e1, t1, i) {
                for(let s = 0; s < this.attributes.length; s++){
                    const r = t1.getAttributeLocation(e1, this.attributes[s].name);
                    -1 !== r && this.instanceCount && this.instanceCount > 0 && e1.vertexAttribDivisor(r, i);
                }
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        class ga {
            constructor(e1, t1, i, s, r){
                this.context = e1, this.width = t1, this.height = i;
                const o = this.framebuffer = e1.gl.createFramebuffer();
                s > 0 && (this.colorAttachment0 = new Fr(e1, o, 0)), s > 1 && (this.colorAttachment1 = new Fr(e1, o, 1)), r && (this.depthAttachmentType = r, this.depthAttachment = "renderbuffer" === r ? new Or(e1, o) : new kr(e1, o));
            }
            static createWithTexture(t1, i, s, r, o) {
                const n = t1.gl;
                if (t1.activeTexture.set(n.TEXTURE1), t1.viewport.set([
                    0,
                    0,
                    s,
                    r
                ]), i && i.width === s && i.height === r) return n.bindTexture(n.TEXTURE_2D, i.colorAttachment0.get()), t1.bindFramebuffer.set(i.framebuffer), i;
                i && i.destroy();
                const a = t1.extRenderToTextureHalfFloat || t1.extColorBufferFloat ? t1.gl.RGBA16F : t1.gl.RGBA8, l = new e1.T(t1, {
                    width: s,
                    height: r,
                    data: null
                }, a);
                l.bind(n.LINEAR, n.CLAMP_TO_EDGE);
                const c = t1.createFramebuffer(s, r, 1, null);
                if (c.format = a, c.colorAttachment0.set(l.texture), o) {
                    const e1 = t1.createRenderbuffer(n.DEPTH24_STENCIL8, s, r);
                    t1.bindFramebuffer.set(c.framebuffer), n.framebufferRenderbuffer(n.FRAMEBUFFER, n.DEPTH_STENCIL_ATTACHMENT, n.RENDERBUFFER, e1), c._stencilRbo = e1;
                }
                return c;
            }
            createColorAttachment(e1, t1) {
                0 === t1 ? this.colorAttachment0 = new Fr(e1, this.framebuffer, 0) : 1 === t1 && (this.colorAttachment1 = new Fr(e1, this.framebuffer, 1));
            }
            removeColorAttachment(e1, t1) {
                const i = this.context.gl;
                let s;
                0 === t1 ? (s = this.colorAttachment0.get(), this.colorAttachment0 = void 0) : 1 === t1 && (s = this.colorAttachment1.get(), this.colorAttachment1 = void 0), s && i.deleteTexture(s);
            }
            destroy() {
                const e1 = this.context.gl;
                if (this.colorAttachment0) {
                    const t1 = this.colorAttachment0.get();
                    t1 && e1.deleteTexture(t1);
                }
                if (this.colorAttachment1) {
                    const t1 = this.colorAttachment1.get();
                    t1 && e1.deleteTexture(t1);
                }
                if (this.depthAttachment && this.depthAttachmentType) {
                    if ("renderbuffer" === this.depthAttachmentType) {
                        const t1 = this.depthAttachment.get();
                        t1 && e1.deleteRenderbuffer(t1);
                    } else {
                        const t1 = this.depthAttachment.get();
                        t1 && e1.deleteTexture(t1);
                    }
                }
                this._stencilRbo && (e1.deleteRenderbuffer(this._stencilRbo), this._stencilRbo = null), e1.deleteFramebuffer(this.framebuffer);
            }
        }
        class ya {
            constructor(e1, t1){
                this.gl = e1, this._pendingPrograms = new Set, this._compileStats = {
                    precompiled: 0,
                    onDemand: 0,
                    totalStallMs: 0,
                    maxStallMs: 0,
                    framesMissed: 0,
                    stalls: []
                }, this.clearColor = new ir(this), this.clearDepth = new sr(this), this.clearStencil = new rr(this), this.colorMask = new or(this), this.depthMask = new nr(this), this.stencilMask = new ar(this), this.stencilFunc = new lr(this), this.stencilOp = new cr(this), this.stencilTest = new hr(this), this.depthRange = new dr(this), this.depthTest = new ur(this), this.depthFunc = new pr(this), this.blend = new fr(this), this.blendFunc = new mr(this), this.blendColor = new _r(this), this.blendEquation = new gr(this), this.cullFace = new yr(this), this.cullFaceSide = new vr(this), this.frontFace = new br(this), this.program = new xr(this), this.activeTexture = new wr(this), this.viewport = new Tr(this), this.bindFramebuffer = new Sr(this), this.bindRenderbuffer = new Cr(this), this.bindTexture = new Er(this), this.bindVertexBuffer = new Ir(this), this.bindElementBuffer = new Dr(this), this.bindVertexArrayOES = new Pr(this), this.pixelStoreUnpack = new Lr(this), this.pixelStoreUnpackPremultiplyAlpha = new Rr(this), this.pixelStoreUnpackFlipY = new Ar(this), this.options = t1 ? {
                    ...t1
                } : {}, this.options.extTextureFilterAnisotropicForceOff || (this.extTextureFilterAnisotropic = e1.getExtension("EXT_texture_filter_anisotropic") || e1.getExtension("MOZ_EXT_texture_filter_anisotropic") || e1.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = e1.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT))), this.extDebugRendererInfo = e1.getExtension("WEBGL_debug_renderer_info"), this.extDebugRendererInfo && (this.renderer = e1.getParameter(this.extDebugRendererInfo.UNMASKED_RENDERER_WEBGL), this.vendor = e1.getParameter(this.extDebugRendererInfo.UNMASKED_VENDOR_WEBGL)), this.forceManualRenderingForInstanceIDShaders = t1 && !!t1.forceManualRenderingForInstanceIDShaders || this.renderer && this.renderer.includes("PowerVR"), this.options.extTextureFloatLinearForceOff || (this.extTextureFloatLinear = e1.getExtension("OES_texture_float_linear")), this.extRenderToTextureHalfFloat = e1.getExtension("EXT_color_buffer_half_float"), this.extColorBufferFloat = e1.getExtension("EXT_color_buffer_float"), this.extTimerQuery = e1.getExtension("EXT_disjoint_timer_query_webgl2"), this.maxTextureSize = e1.getParameter(e1.MAX_TEXTURE_SIZE), this.maxUniformBlockSize = Math.min(e1.getParameter(e1.MAX_UNIFORM_BLOCK_SIZE), 32768), this.extBlendFuncExtended = e1.getExtension("WEBGL_blend_func_extended"), this.extParallelShaderCompile = e1.getExtension("KHR_parallel_shader_compile");
            }
            sweepPendingPrograms() {
                if (0 !== this._pendingPrograms.size) for (const e1 of this._pendingPrograms)e1.maybeFinalize();
            }
            setDefault() {
                this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
            }
            setDirty() {
                this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.bindVertexArrayOES.dirty = !0, this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
            }
            createIndexBuffer(e1, t1, i) {
                return new fa(this, e1, t1, i);
            }
            createVertexBuffer(e1, t1, i, s, r) {
                return new _a(this, e1, t1, i, s, r);
            }
            createRenderbuffer(e1, t1, i) {
                const s = this.gl, r = s.createRenderbuffer();
                return this.bindRenderbuffer.set(r), s.renderbufferStorage(s.RENDERBUFFER, e1, t1, i), this.bindRenderbuffer.set(null), r;
            }
            createFramebuffer(e1, t1, i, s) {
                return new ga(this, e1, t1, i, s);
            }
            clear({ color: e1, depth: t1, stencil: i, colorMask: s }) {
                const r = this.gl;
                let o = 0;
                e1 && (o |= r.COLOR_BUFFER_BIT, this.clearColor.set(e1.toNonPremultipliedRenderColor(null)), this.colorMask.set(s || [
                    !0,
                    !0,
                    !0,
                    !0
                ])), void 0 !== t1 && (o |= r.DEPTH_BUFFER_BIT, this.depthRange.set([
                    0,
                    1
                ]), this.clearDepth.set(t1), this.depthMask.set(!0)), void 0 !== i && (o |= r.STENCIL_BUFFER_BIT, this.clearStencil.set(i), this.stencilMask.set(255)), r.clear(o);
            }
            setCullFace(e1) {
                !1 === e1.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(e1.mode), this.frontFace.set(e1.frontFace));
            }
            setDepthMode(e1) {
                e1.func !== this.gl.ALWAYS || e1.mask ? (this.depthTest.set(!0), this.depthFunc.set(e1.func), this.depthMask.set(e1.mask), this.depthRange.set(e1.range)) : this.depthTest.set(!1);
            }
            setStencilMode(e1) {
                e1.test.func !== this.gl.ALWAYS || e1.mask ? (this.stencilTest.set(!0), this.stencilMask.set(e1.mask), this.stencilOp.set([
                    e1.fail,
                    e1.depthFail,
                    e1.pass
                ]), this.stencilFunc.set({
                    func: e1.test.func,
                    ref: e1.ref,
                    mask: e1.test.mask
                })) : this.stencilTest.set(!1);
            }
            setColorMode(t1) {
                t1.blendFunction === e1.a7.Replace ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(t1.blendFunction), this.blendColor.set(t1.blendColor), t1.blendEquation ? this.blendEquation.set(t1.blendEquation) : this.blendEquation.setDefault()), this.colorMask.set(t1.mask);
            }
            unbindVAO() {
                this.bindVertexArrayOES.set(null);
            }
        }
        const va = e1.a2();
        function ba(t1) {
            const i = t1._camera.getWorldToCamera(t1.worldSize, 1), s = e1.a1(new Float64Array(16), i, t1.globeMatrix);
            e1.aZ(s, s);
            const r = [
                0,
                0,
                0
            ], o = [
                0,
                1,
                0,
                0
            ];
            return e1.cd(o, o, s), r[0] = o[0], r[1] = o[1], r[2] = o[2], e1.cg(r, r), r;
        }
        function xa({ width: t1, height: i, anchor: s, textOffset: r, textScale: o }, n) {
            const { horizontalAlign: a, verticalAlign: l } = e1.dz(s), c = -(a - .5) * t1, h = -(l - .5) * i, d = e1.dA(s, r);
            return new e1.P((c / o + d[0]) * n, (h / o + d[1]) * n);
        }
        function wa(t1, i, s, r, o, n, a, l, c, h) {
            const d = t1.text.placedSymbolArray, u = t1.text.dynamicLayoutVertexArray, p = t1.icon.dynamicLayoutVertexArray, f = {}, m = t1.getProjection(), _ = e1.e4(a, m, o), g = o.elevation, y = m.upVectorScale(a.canonical, o.center.lat, o.worldSize).metersToTile;
            u.clear();
            for(let p = 0; p < d.length; p++){
                const v = d.get(p), { tileAnchorX: b, tileAnchorY: x, numGlyphs: w } = v, T = v.hidden || !v.crossTileID || t1.allowVerticalPlacement && !v.placedOrientation ? null : r[v.crossTileID];
                if (T) {
                    let r = 0, d = 0, S = 0;
                    const C = "road" === t1.elevationType;
                    if (g || C) {
                        const i = new e1.P(b, x);
                        let s = 0;
                        if (C && t1.hdExt) {
                            const r = t1.symbolInstances.get(t1.text.symbolInstanceIndices[p]);
                            if (t1.hdExt.isCrossTileRoadElevation(r.elevationFeatureIndex, a.canonical)) {
                                const e1 = t1.hdExt.getRoadFeatureHeightForPlacedSymbol(t1, t1.text, p, i, a.canonical);
                                s = null !== e1 ? e1 : 0;
                            } else {
                                const r = t1.hdExt.getElevationFeatureForPlacedSymbol(t1, t1.text, p);
                                s = e1.c8.getAtTileOffset(a, i, g, void 0 !== r ? r : null);
                            }
                        } else s = e1.c8.getAtTileOffset(a, i, g, null);
                        const [o, n, l] = m.upVector(a.canonical, b, x);
                        r = s * o * y, d = s * n * y, S = s * l * y;
                    }
                    let [E, I, D, P] = e1.df(v.projectedAnchorX + r, v.projectedAnchorY + d, v.projectedAnchorZ + S, s ? _ : n);
                    const L = e1.e7(o.getCameraToCenterDistance(m), P);
                    let R = e1.dx(t1.textSizeData, c, v) * L / e1.dl;
                    s && (R *= t1.tilePixelRatio / l);
                    const A = xa(T, R);
                    s ? ({ x: E, y: I, z: D } = m.projectTilePoint(b + A.x, x + A.y, a.canonical), [E, I, D] = e1.df(E + r, I + d, D + S, n)) : (i && A._rotate(-o.angle), E += A.x, I += A.y, D = 0);
                    const M = t1.allowVerticalPlacement && v.placedOrientation === e1.dy.vertical ? Math.PI / 2 : 0;
                    for(let t1 = 0; t1 < w; t1++)e1.e8(u, E, I, D, M);
                    h && v.associatedIconIndex >= 0 && (f[v.associatedIconIndex] = {
                        x: E,
                        y: I,
                        z: D,
                        angle: M
                    });
                } else e1.e6(w, u);
            }
            if (h) {
                p.clear();
                const i = t1.icon.placedSymbolArray;
                for(let t1 = 0; t1 < i.length; t1++){
                    const s = i.get(t1), { numGlyphs: r } = s, o = f[t1];
                    if (s.hidden || !o) e1.e6(r, p);
                    else {
                        const { x: t1, y: i, z: s, angle: n } = o;
                        for(let o = 0; o < r; o++)e1.e8(p, t1, i, s, n);
                    }
                }
                t1.icon.dynamicLayoutVertexBuffer.updateData(p);
            }
            t1.text.dynamicLayoutVertexBuffer.updateData(u);
        }
        function Ta(t1, i, s, r, o, n, a = {}) {
            const l = s.paint.get("icon-translate"), c = s.paint.get("text-translate"), h = s.paint.get("icon-translate-anchor"), d = s.paint.get("text-translate-anchor"), u = s.layout.get("icon-rotation-alignment"), p = s.layout.get("text-rotation-alignment"), f = s.layout.get("icon-pitch-alignment"), m = s.layout.get("text-pitch-alignment"), _ = s.layout.get("icon-keep-upright"), g = s.layout.get("text-keep-upright"), y = s.paint.get("icon-color-saturation"), v = s.paint.get("icon-color-contrast"), b = s.paint.get("icon-color-brightness-min"), x = s.paint.get("icon-color-brightness-max"), w = "sea" === s.layout.get("symbol-elevation-reference"), T = "none" === s.layout.get("icon-image-use-theme"), S = t1.context, C = S.gl, E = t1.transform, I = "map" === u, D = "map" === p, P = "map" === f, L = "map" === m, R = void 0 !== s.layout.get("symbol-sort-key").constantOr(1);
            let A = !1;
            const M = t1.depthModeForSublayer(0, e1.a3.ReadOnly), F = new e1.a3(t1.context.gl.LEQUAL, e1.a3.ReadOnly, t1.depthRangeFor3D), O = [
                e1.ad(E.center.lng),
                e1.ae(E.center.lat)
            ], k = s.layout.get("text-variable-anchor"), B = "globe" === E.projection.name, z = [], U = [
                0,
                -1,
                0
            ];
            for (const o of r){
                const r = i.getTile(o), n = r.getBucket(s);
                if (!n) continue;
                if ("mercator" === n.projection.name && B) continue;
                if (n.fullyClipped) continue;
                const u = "globe" === n.projection.name, p = u ? e1._(E.zoom) : 0, f = e1.e4(o, n.getProjection(), E), m = E.calculatePixelsToTileUnitsMatrix(r), N = k && n.hasTextData(), j = n.hasIconTextFit() && N && n.hasIconData(), V = n.getProjection().createInversionMatrix(E, o.canonical), G = (1 << r.tileID.canonical.z) * e1.ac / t1.transform.worldSize, q = (i)=>{
                    let s = [
                        0,
                        0,
                        0
                    ];
                    if (i) {
                        const i = t1.style.directionalLight, r = t1.style.ambientLight;
                        i && r && (s = e1.aQ(t1.style, i, r));
                    }
                    return s;
                }, $ = (e1)=>{
                    const i = Math.floor(t1.context.maxUniformBlockSize / 4), s = Math.floor(i / 4);
                    e1.push(`MAX_UBO_SIZE_VEC4 ${s}u`);
                }, Z = (e1)=>{
                    E.depthOcclusionForSymbolsAndCircles && (s.hasOcclusionOpacityProperties || t1.terrain) && (e1.push("DEPTH_D24"), e1.push("DEPTH_OCCLUSION"));
                }, W = (i)=>{
                    s.lut && !T && (s.lut.texture || (s.lut.texture = new e1.ea(t1.context, s.lut.image, [
                        s.lut.image.height,
                        s.lut.image.height,
                        s.lut.image.height
                    ], S.gl.RGBA8)), S.activeTexture.set(S.gl.TEXTURE0 + e1.cp.LUT), s.lut.texture && s.lut.texture.bind(S.gl.LINEAR, S.gl.CLAMP_TO_EDGE), i.push("APPLY_LUT_ON_GPU"));
                }, H = ()=>{
                    const i = I && "point" !== s.layout.get("symbol-placement"), a = [];
                    Z(a), W(a);
                    const c = i || j, d = "road" === n.elevationType, g = t1.shadowRenderer, T = d && P && !!g && g.enabled, S = q(T), D = d && P && !t1.terrain ? F : M, L = s.paint.get("icon-image-cross-fade");
                    t1.terrainRenderModeElevated() && P && a.push("PITCH_WITH_MAP_TERRAIN"), u && (a.push("PROJECTION_GLOBE_VIEW"), c && a.push("PROJECTED_POS_ON_VIEWPORT")), L > 0 && n.hasAnySecondaryIcon && a.push("ICON_TRANSITION"), !n.icon.zOffsetVertexBuffer || d && t1.terrain || a.push("Z_OFFSET"), a.push(n.icon.fadeVertexBuffer ? "GLOBAL_PLACEMENT_FADE" : "LEGACY_PLACEMENT_FADE"), 0 === y && 0 === v && 0 === b && 1 === x || a.push("COLOR_ADJUSTMENT"), T && a.push("RENDER_SHADOWS", "NORMAL_OFFSET"), d && P && !t1.terrain && n.icon.orientationVertexBuffer && a.push("ELEVATED_ROADS"), $(a);
                    const R = t1.getOrCreateProgram("symbol", {
                        defines: a
                    }), A = r.imageAtlasTexture ? r.imageAtlasTexture.size : [
                        0,
                        0
                    ], k = n.iconSizeData, z = e1.dr(k, E.zoom), N = P || !E.isOrthographic, H = e1.e5(f, r.tileID.canonical, P, I, E, n.getProjection(), m), X = e1.dq(f, r.tileID.canonical, P, I, E, n.getProjection(), m), Y = n.icon.uboBinder && n.icon.uboBinder.hasPerFeatureTranslate() ? [
                        0,
                        0
                    ] : l, K = t1.translatePosMatrix(X, r, Y, h, !0), Q = t1.translatePosMatrix(f, r, Y, h), J = c ? va : H, ee = I && !P && !i;
                    let te = U;
                    !B && !E.mercatorFromTransition || I || (te = ba(E));
                    const ie = u ? te : U, se = s.getColorAdjustmentMatrix(y, v, b, x), re = uo(k.kind, z, ee, P, t1, Q, J, K, w, !1, n.sdfIcons, A, [
                        0,
                        0
                    ], 0, o, p, O, V, ie, n.getProjection(), S, G, se, L, null), oe = r.imageAtlasTexture ? r.imageAtlasTexture : null, ne = 1 !== s.layout.get("icon-size").constantOr(0) || n.iconsNeedLinear, ae = n.sdfIcons || t1.options.rotating || t1.options.zooming || ne || N ? C.LINEAR : C.NEAREST, le = n.sdfIcons && 0 !== s.paint.get("icon-halo-width").constantOr(1), ce = t1.terrain && P && i ? e1.aZ(e1.a2(), H) : va;
                    if (i && n.icon) {
                        const i = e1.c8.getAtTileOffsetFunc(o, E.center.lat, E.worldSize, n.getProjection()), a = e1.dp(f, r.tileID.canonical, P, I, E, n.getProjection(), m), l = s.layout.get("icon-size-scale-range"), c = e1.bb(t1.scaleFactor, l[0], l[1]);
                        e1.e9(n, f, t1, !1, a, X, P, _, i, o, c);
                    }
                    return {
                        program: R,
                        buffers: n.icon,
                        uniformValues: re,
                        atlasTexture: oe,
                        atlasTextureIcon: null,
                        atlasInterpolation: ae,
                        atlasInterpolationIcon: null,
                        isSDF: n.sdfIcons,
                        hasHalo: le,
                        depthMode: D,
                        tile: r,
                        renderWithShadows: T,
                        labelPlaneMatrixInv: ce
                    };
                }, X = ()=>{
                    const i = D && "point" !== s.layout.get("symbol-placement"), a = [], l = i || k || j, h = "road" === n.elevationType, _ = t1.shadowRenderer, y = h && L && !!_ && _.enabled, v = q(y), b = h && L && !t1.terrain ? F : M;
                    t1.terrainRenderModeElevated() && L && a.push("PITCH_WITH_MAP_TERRAIN"), u && (a.push("PROJECTION_GLOBE_VIEW"), l && a.push("PROJECTED_POS_ON_VIEWPORT")), !n.text.zOffsetVertexBuffer || h && t1.terrain || a.push("Z_OFFSET"), a.push(n.text.fadeVertexBuffer ? "GLOBAL_PLACEMENT_FADE" : "LEGACY_PLACEMENT_FADE"), n.iconsInText && a.push("RENDER_TEXT_AND_SYMBOL"), y && a.push("RENDER_SHADOWS", "NORMAL_OFFSET"), h && L && !t1.terrain && n.text.orientationVertexBuffer && a.push("ELEVATED_ROADS"), Z(a), $(a);
                    const x = t1.getOrCreateProgram("symbol", {
                        defines: a
                    });
                    let T, S = [
                        0,
                        0
                    ], I = null;
                    const P = n.textSizeData;
                    n.iconsInText && (S = r.imageAtlasTexture ? r.imageAtlasTexture.size : [
                        0,
                        0
                    ], I = r.imageAtlasTexture ? r.imageAtlasTexture : null, T = L || !E.isOrthographic || t1.options.rotating || t1.options.zooming || "composite" === P.kind || "camera" === P.kind ? C.LINEAR : C.NEAREST);
                    const R = r.glyphAtlasTexture ? r.glyphAtlasTexture.size : [
                        0,
                        0
                    ], A = s.layout.get("text-size-scale-range"), z = e1.bb(t1.scaleFactor, A[0], A[1]), N = e1.dr(P, E.zoom, z), W = e1.e5(f, r.tileID.canonical, L, D, E, n.getProjection(), m), H = e1.dq(f, r.tileID.canonical, L, D, E, n.getProjection(), m), X = n.text.uboBinder && n.text.uboBinder.hasPerFeatureTranslate() ? [
                        0,
                        0
                    ] : c, Y = t1.translatePosMatrix(H, r, X, d, !0), K = t1.translatePosMatrix(f, r, X, d), Q = l ? va : W, J = D && !L && !i;
                    let ee = U;
                    !B && !E.mercatorFromTransition || D || (ee = ba(E));
                    const te = uo(P.kind, N, J, L, t1, K, Q, Y, w, !0, !0, R, S, 0, o, p, O, V, u ? ee : U, n.getProjection(), v, G, null, null, z), ie = r.glyphAtlasTexture ? r.glyphAtlasTexture : null, se = C.LINEAR, re = 0 !== s.paint.get("text-halo-width").constantOr(1), oe = t1.terrain && L && i ? e1.aZ(e1.a2(), W) : va;
                    if (i && n.text) {
                        const i = e1.c8.getAtTileOffsetFunc(o, E.center.lat, E.worldSize, n.getProjection()), s = e1.dp(f, r.tileID.canonical, L, D, E, n.getProjection(), m);
                        e1.e9(n, f, t1, !0, s, H, L, g, i, o, z);
                    }
                    return {
                        program: x,
                        buffers: n.text,
                        uniformValues: te,
                        atlasTexture: ie,
                        atlasTextureIcon: I,
                        atlasInterpolation: se,
                        atlasInterpolationIcon: T,
                        isSDF: !0,
                        hasHalo: re,
                        depthMode: b,
                        tile: r,
                        renderWithShadows: y,
                        labelPlaneMatrixInv: oe
                    };
                }, Y = n.icon.segments.get().length, K = n.text.segments.get().length, Q = Y && !a.onlyText ? H() : null, J = K && !a.onlyIcons ? X() : null, ee = s.paint.get("icon-opacity").constantOr(1), te = s.paint.get("text-opacity").constantOr(1);
                if (R && n.canOverlap) {
                    A = !0;
                    const t1 = ee && !a.onlyText ? n.icon.segments.get() : [], i = te && !a.onlyIcons ? n.text.segments.get() : [];
                    for (const i of t1)z.push({
                        segments: new e1.aj([
                            i
                        ]),
                        sortKey: i.sortKey,
                        state: Q
                    });
                    for (const t1 of i)z.push({
                        segments: new e1.aj([
                            t1
                        ]),
                        sortKey: t1.sortKey,
                        state: J
                    });
                } else a.onlyText || z.push({
                    segments: ee ? n.icon.segments : new e1.aj([]),
                    sortKey: 0,
                    state: Q
                }), a.onlyIcons || z.push({
                    segments: te ? n.text.segments : new e1.aj([]),
                    sortKey: 0,
                    state: J
                });
            }
            A && z.sort((e1, t1)=>e1.sortKey - t1.sortKey);
            for (const e1 of z){
                const i = e1.state;
                if (i) {
                    if (t1.terrain ? t1.terrain.setupElevationDraw(i.tile, i.program, {
                        useDepthForOcclusion: E.depthOcclusionForSymbolsAndCircles,
                        labelPlaneMatrixInv: i.labelPlaneMatrixInv
                    }) : t1.setupDepthForOcclusion(E.depthOcclusionForSymbolsAndCircles, i.program), S.activeTexture.set(C.TEXTURE0), i.atlasTexture && i.atlasTexture.bind(i.atlasInterpolation, C.CLAMP_TO_EDGE, !0), i.atlasTextureIcon && (S.activeTexture.set(C.TEXTURE1), i.atlasTextureIcon && i.atlasTextureIcon.bind(i.atlasInterpolationIcon, C.CLAMP_TO_EDGE, !0)), i.renderWithShadows && t1.shadowRenderer.setupShadows(i.tile.tileID.toUnwrapped(), i.program, "vector-tile"), t1.uploadCommonLightUniforms(t1.context, i.program), i.hasHalo) {
                        const r = i.uniformValues;
                        r.u_is_halo = 1, Sa(i.buffers, e1.segments, s, t1, i.program, i.depthMode, o, n, r, 2), r.u_is_halo = 0;
                    } else {
                        if (i.isSDF) {
                            const r = i.uniformValues;
                            i.hasHalo && (r.u_is_halo = 1, Sa(i.buffers, e1.segments, s, t1, i.program, i.depthMode, o, n, r, 1)), r.u_is_halo = 0;
                        }
                        Sa(i.buffers, e1.segments, s, t1, i.program, i.depthMode, o, n, i.uniformValues, 1);
                    }
                }
            }
        }
        function Sa(t1, i, s, r, o, n, a, l, c, h) {
            const d = r.context, u = d.gl, p = [
                t1.dynamicLayoutVertexBuffer,
                t1.opacityVertexBuffer,
                t1.iconTransitioningVertexBuffer,
                t1.globeExtVertexBuffer,
                t1.zOffsetVertexBuffer,
                t1.orientationVertexBuffer
            ];
            t1.featureIdBuffer && p.push(t1.featureIdBuffer), t1.fadeVertexBuffer && p.push(t1.fadeVertexBuffer);
            const f = t1.uboBinder ? null : t1.programConfigurations.get(s.id);
            if (t1.uboBinder) {
                t1.uboBinder.layer = s;
                const e1 = r.transform.zoom, i = r.style.getBrightness ? r.style.getBrightness() : null, o = t1.uboBinder.getConstantUniformValues(i);
                c.u_spp_fill_np_color = o.fill_np_color, c.u_spp_halo_np_color = o.halo_np_color, c.u_spp_opacity = o.opacity, c.u_spp_halo_width = o.halo_width, c.u_spp_halo_blur = o.halo_blur, c.u_spp_emissive_strength = o.emissive_strength, c.u_spp_occlusion_opacity = o.occlusion_opacity, c.u_spp_z_offset = o.z_offset, c.u_spp_zoom_fraction = e1 - t1.uboBinder._floorZoom;
                const n = s.paint.get(t1.uboBinder.isText ? "text-translate-anchor" : "icon-translate-anchor"), a = t1.uboBinder.hasPerFeatureTranslate() && "map" === n ? r.transform.angle : 0;
                c.u_spp_translate_rotation = [
                    Math.cos(a),
                    Math.sin(a)
                ];
            }
            const { batchIndices: m, batchSegments: _ } = t1.getBatchGrouping(i);
            for (const i of m){
                const m = _.get(i);
                t1.uboBinder && t1.uboBinder.bind(d, o.program, i), o.draw(r, u.TRIANGLES, n, a, l, e1.a5.disabled, c, s.id, t1.layoutVertexBuffer, t1.indexBuffer, m, s.paint, r.transform.zoom, f, p, h, t1.uboBinder ? t1.uboBinder.getUBO(i) : void 0);
            }
        }
        function Ca(t1, i, s, r, o, n) {
            const a = s.paint.get("line-width"), l = s.paint.get("line-emissive-strength").isConstant(), c = s.paint.get("line-emissive-strength").constantOr(0), h = s.paint.get("line-occlusion-opacity"), d = s.layout.get("line-elevation-reference"), u = "meters" === s.layout.get("line-width-unit"), p = "sea" === d, f = !(!t1.terrain || !t1.terrain.enabled), m = t1.context, _ = m.gl;
            if (s.hasElevatedBuckets && "globe" === t1.transform.projection.name) return;
            const g = s.layout.get("line-cross-slope"), y = void 0 !== g, v = g < 1, b = o || t1.colorModeForDrapableLayerRenderPass(l ? c : null), x = t1.terrain && t1.terrain.renderingToTexture || n, w = x ? 1 : e1.e.devicePixelRatio, T = s.paint.get("line-dasharray"), S = T.constantOr(1), C = s.layout.get("line-cap"), E = T.constantOr(null), I = C.constantOr(null), D = s.paint.get("line-pattern"), P = D.constantOr(1), L = s.paint.get("line-pattern-cross-fade"), R = D.constantOr(null), A = s.paint.get("line-opacity").constantOr(1);
            let M = !P && 1 !== A || t1.depthOcclusion && h > 0 && h < 1;
            const F = s.paint.get("line-gradient"), O = 0 !== s.paint.get("line-border-width").constantOr(1) ? s.paint.get("line-border-gradient") : null, k = P ? "linePattern" : "line", B = e1.ed(s);
            if (!P) {
                const e1 = Math.floor(t1.context.maxUniformBlockSize / 4), i = Math.floor(e1 / 4);
                B.push(`MAX_UBO_SIZE_VEC4 ${i}u`);
            }
            let z;
            if (x && t1.terrain && t1.terrain.clipOrMaskOverlapStencilType() && (M = !1), 0 !== h && t1.depthOcclusion) {
                const t1 = s.paint._values["line-opacity"];
                t1 && t1.value && "constant" === t1.value.kind ? z = t1.value : e1.w(`Occlusion opacity for layer ${s.id} is supported only when line-opacity isn't data-driven.`);
            }
            "constant" !== a.value.kind && !1 === a.value.isLineProgressConstant && B.push("VARIABLE_LINE_WIDTH");
            const U = s.paint.get("line-emissive-strength");
            P || "constant" === U.value.kind || !1 !== U.value.isLineProgressConstant || B.push("VARIABLE_LINE_EMISSIVE_STRENGTH"), t1._debugParams.showElevationIdDebug && B.push("DEBUG_ELEVATION_ID"), x && ("dual-source-blending" !== t1.emissiveMode || l ? t1.isEmissiveMrtActive() && (B.push("USE_MRT1"), "mrt-full-rgba" === t1.emissiveMode && B.push("USE_MRT1_RGBA")) : B.push("DUAL_SOURCE_BLENDING"));
            const N = {};
            let j = null;
            const V = [], G = (r, o, n, a, l, c)=>{
                for (const d of r){
                    const r = i.getTile(d);
                    if (P && !r.patternsLoaded()) continue;
                    const p = r.getBucket(s);
                    if (!p) continue;
                    if ("none" !== p.elevationType && !l || "none" === p.elevationType && l) continue;
                    t1.prepareDrawTile();
                    const f = [
                        ...o
                    ], g = "road" === p.elevationType, y = t1.shadowRenderer, v = g && !!y && y.enabled;
                    let T = [
                        0,
                        0,
                        0
                    ];
                    if (v) {
                        const i = t1.style.directionalLight, s = t1.style.ambientLight;
                        i && s && (T = e1.aQ(t1.style, i, s)), f.push("RENDER_SHADOWS", "NORMAL_OFFSET");
                    }
                    const C = P ? p.programConfigurations.get(s.id) : null, D = P ? null : p.uboBinders[s.id];
                    let B = !1;
                    if (C && R && r.imageAtlas) {
                        const t1 = e1.aR.from(R), i = t1.getPrimary().scaleSelf(w).toString(), s = r.imageAtlas.patternPositions.get(i), o = t1.getSecondary(), n = o ? r.imageAtlas.patternPositions.get(o.scaleSelf(w).toString()) : null;
                        B = !!s && !!n, s && C.setConstantPatternPositions(s, n);
                    }
                    C && L > 0 && (B || C.getPatternTransitionVertexBuffer("line-pattern")) && f.push("LINE_PATTERN_TRANSITION"), p.elevationGroundScaleVertexBuffer && f.push("ELEVATION_GROUND_SCALE");
                    const U = t1.isTileAffectedByFog(d), G = t1.getOrCreateProgram(k, {
                        config: C,
                        defines: f,
                        overrideFog: U
                    });
                    let q = null;
                    !P && E && I && r.lineAtlas && (q = r.lineAtlas.getDash(E, I)), v && y.setupShadows(r.tileID.toUnwrapped(), G, "vector-tile");
                    let [$, Z] = s.paint.get("line-trim-offset");
                    if ("round" === I || "square" === I) {
                        const e1 = 1;
                        $ !== Z && (0 === $ && ($ -= e1), 1 === Z && (Z += e1));
                    }
                    const W = x ? d.projMatrix : null, H = u ? 1 / p.tileToMeter / e1.ck(r, 1, t1.transform.zoom) : 1, X = u ? 1 / p.tileToMeter / e1.ck(r, 1, Math.floor(t1.transform.zoom)) : 1, Y = P && S ? s.paint._values["line-floorwidth"] : null;
                    let K;
                    const Q = r.dashIdealZ;
                    if (Y && "constant" === Y.value.kind && Q !== r.tileID.overscaledZ) {
                        const e1 = p.zoom;
                        e1 in N || (N[e1] = Math.max(.01, s.getPaintPropertyValue("line-width").expression.evaluate({
                            zoom: e1
                        }))), K = Y.value.value, Y.value.value = N[e1] * Math.pow(2, Q - e1);
                    }
                    const J = P ? e1.ee(t1, r, s, W, w, H, X, [
                        $,
                        Z
                    ], T, L) : e1.ef(t1, r, s, W, p.lineClipsArray.length, w, H, X, [
                        $,
                        Z
                    ], T), ee = (r, o, n, a, l, c)=>{
                        let h = r.texture;
                        if (o !== r.version) {
                            let c = 256;
                            if (n) {
                                const s = i.getSource().maxzoom, r = d.canonical.z === s ? Math.ceil(1 << t1.transform.maxZoom - d.canonical.z) : 1;
                                c = e1.bb(e1.ei(p.maxLineLength / e1.ac * 1024 * r), 256, m.maxTextureSize);
                            }
                            r.gradient = e1.ej({
                                expression: a,
                                evaluationKey: "lineProgress",
                                resolution: c,
                                image: r.gradient || void 0,
                                clips: p.lineClipsArray,
                                lut: l ? null : s.lut
                            }), r.texture ? r.texture.update(r.gradient) : r.texture = new e1.T(m, r.gradient, _.RGBA8), r.version = o, h = r.texture;
                        }
                        m.activeTexture.set(c), h.bind(n ? _.NEAREST : _.LINEAR, _.CLAMP_TO_EDGE);
                    };
                    if (D) {
                        D.layer = s;
                        const i = t1.transform.zoom;
                        if (!j) {
                            const e1 = t1.style.getBrightness ? t1.style.getBrightness() : null;
                            j = D.getConstantUniformValues(e1);
                        }
                        const o = j, n = J;
                        if (n.u_lpp_color = o.color_np_color, n.u_lpp_border_color = o.border_np_color, n.u_lpp_opacity = o.opacity, n.u_lpp_blur = o.blur, n.u_lpp_width = o.width, n.u_lpp_gap_width = o.gap_width, n.u_lpp_offset = o.offset, n.u_lpp_floorwidth = o.floorwidth, n.u_lpp_border_width = o.border_width, n.u_lpp_emissive_strength = o.emissive_strength, n.u_lpp_side_z_offset = o.side_z_offset, q && (n.u_lpp_dash = [
                            q.tl[0],
                            q.tl[1],
                            q.br[0],
                            q.br[1]
                        ]), n.u_lpp_zoom_fraction = i - D._floorZoom, S && Q !== r.tileID.overscaledZ && 0 === (D.header[e1.eg] & e1.eh)) {
                            const e1 = p.zoom;
                            e1 in N || (N[e1] = Math.max(.01, s.getPaintPropertyValue("line-width").expression.evaluate({
                                zoom: e1
                            }))), n.u_lpp_floorwidth = N[e1] * Math.pow(2, Q - e1);
                        }
                    }
                    F && ee(p.gradients[s.id], s.gradientVersion, s.stepInterpolant, s.getPaintPropertyValue("line-gradient").expression, "none" === s.paint.get("line-gradient-use-theme").constantOr("default"), _.TEXTURE1), O && ee(p.borderGradients[s.id], s.borderGradientVersion, s.borderStepInterpolant, s.getPaintPropertyValue("line-border-gradient").expression, "none" === s.paint.get("line-border-gradient-use-theme").constantOr("default"), _.TEXTURE2), S ? (m.activeTexture.set(_.TEXTURE0), r.lineAtlasTexture && r.lineAtlasTexture.bind(_.LINEAR, _.REPEAT)) : P || (m.activeTexture.set(_.TEXTURE0), t1.emptyTexture.bind(_.LINEAR, _.CLAMP_TO_EDGE)), P && C && (m.activeTexture.set(_.TEXTURE0), r.imageAtlasTexture && r.imageAtlasTexture.bind(_.LINEAR, _.CLAMP_TO_EDGE), C.updatePaintBuffers()), l && !g && t1.terrain.setupElevationDraw(r, G), t1.uploadCommonUniforms(m, G, d.toUnwrapped());
                    const te = (i, r, o)=>{
                        if (r && 0 !== r.get().length) {
                            if (null != z && (z.value = A * h, D && (J.u_lpp_opacity = A * h)), void 0 !== o && (J.u_opacity_multiplier = o), D) {
                                const { batchIndices: o, batchSegments: a } = p.getBatchGrouping(r);
                                for (const r of o)D.bind(m, G.program, r), G.draw(t1, _.TRIANGLES, n, i, b, e1.a5.disabled, J, s.id, p.layoutVertexBuffer, p.indexBuffer, a.get(r), s.paint, t1.transform.zoom, C, [
                                    p.layoutVertexBuffer2,
                                    p.patternVertexBuffer,
                                    p.zOffsetVertexBuffer,
                                    p.elevationIdColVertexBuffer,
                                    p.elevationGroundScaleVertexBuffer
                                ], void 0, D.getUBO(r));
                            } else G.draw(t1, _.TRIANGLES, n, i, b, e1.a5.disabled, J, s.id, p.layoutVertexBuffer, p.indexBuffer, r, s.paint, t1.transform.zoom, C, [
                                p.layoutVertexBuffer2,
                                p.patternVertexBuffer,
                                p.zOffsetVertexBuffer,
                                p.elevationIdColVertexBuffer,
                                p.elevationGroundScaleVertexBuffer
                            ]);
                            void 0 !== o && (J.u_opacity_multiplier = 1), null != z && (z.value = A, D && (J.u_lpp_opacity = A));
                        }
                    }, ie = Xs.drawLineFrcCoverageDetect ? Xs.drawLineFrcCoverageDetect(t1, p, d, l, te, V) : null, se = (e1)=>{
                        ie && ie.active && Xs.drawLineFrcRenderLine ? Xs.drawLineFrcRenderLine(p, ie, e1, te) : te(e1, p.segments);
                    };
                    if (M && !l) {
                        const i = t1.stencilModeForClipping(d).ref;
                        0 === i && x && m.clear({
                            stencil: 0
                        });
                        const s = {
                            func: _.EQUAL,
                            mask: 255
                        };
                        J.u_alpha_discard_threshold = .8, se(new e1.a4(s, i, 255, _.KEEP, _.KEEP, _.INVERT)), J.u_alpha_discard_threshold = 0, se(new e1.a4(s, i, 255, _.KEEP, _.KEEP, _.KEEP));
                    } else J.u_alpha_discard_threshold = M && l && c ? .8 : 0, se(l ? a : t1.stencilModeForClipping(d));
                    ie && Xs.drawLineFrcFadePass && Xs.drawLineFrcFadePass(t1, p, d, ie, l, a, te), void 0 !== K && (Y.value.value = K);
                }
            };
            let q = t1.depthModeForSublayer(0, e1.a3.ReadOnly);
            const $ = new e1.a3(t1.depthOcclusion ? _.GREATER : _.LEQUAL, e1.a3.ReadOnly, t1.depthRangeFor3D);
            if (s.hasNonElevatedBuckets) {
                const i = !x && t1.terrain;
                0 !== h && i ? e1.w(`Occlusion opacity for layer ${s.id} is supported on terrain only if the layer has line-z-offset enabled.`) : i ? e1.w(`Cannot render non-elevated lines in immediate mode when terrain is enabled. Layer: ${s.id}.`) : G(r, B, q, e1.a4.disabled, !1, !0);
            }
            if (s.hasElevatedBuckets) {
                "hd-road-markup" === d ? f || (q = $, B.push("ELEVATED_ROADS")) : (B.push("ELEVATED"), q = $, y && B.push(v ? "CROSS_SLOPE_HORIZONTAL" : "CROSS_SLOPE_VERTICAL"), p && B.push("ELEVATION_REFERENCE_SEA"));
                const i = M ? t1.stencilModeFor3D() : e1.a4.disabled;
                "hd-road-markup" !== d && (t1.forceTerrainMode = !0), G(r, B, q, i, !0, !0), M && G(r, B, q, i, !0, !1), "hd-road-markup" !== d && (t1.forceTerrainMode = !1);
            }
            Xs.drawLineFrcCoverageSecondPass && Xs.drawLineFrcCoverageSecondPass(t1, s, V), M && (t1.resetStencilClippingMasks(), x && m.clear({
                stencil: 0
            })), 0 === h || t1.depthOcclusion || x || t1.layersWithOcclusionOpacity.push(t1.currentLayer);
        }
        class Ea {
            destroy() {
                this.fbo && (this.fbo.destroy(), this.fbo = null), this.drapeFbo && (this.drapeFbo.destroy(), this.drapeFbo = null);
            }
        }
        class Ia {
            constructor(e1){
                this.pbo = e1.createBuffer(), this.sync = null, this.fboA = null, this.fboB = null, this.maxDensity = 0;
            }
            destroy(e1) {
                this.sync && (e1.deleteSync(this.sync), this.sync = null), e1.deleteBuffer(this.pbo), this.fboA && (this.fboA.destroy(), this.fboA = null), this.fboB && (this.fboB.destroy(), this.fboB = null);
            }
        }
        const Da = {
            additive: {
                clearColor: new e1.C(0, 0, 0, 0),
                colorMode: e1.a7.additiveAlphaWeighted,
                compositeUniformValue: 1
            },
            multiply: {
                clearColor: new e1.C(1, 1, 1, 1),
                colorMode: e1.a7.multiply,
                compositeUniformValue: 0
            }
        };
        function Pa(e1) {
            return !(!e1.extRenderToTextureHalfFloat && !e1.extColorBufferFloat);
        }
        function La(t1, i) {
            return "additive" === t1 && Pa(i) ? e1.a7.additiveAlphaWeightedUnboundedAlpha : Da[t1].colorMode;
        }
        function Ra(t1, i, s) {
            const r = t1.context, o = r.gl;
            let n = s.width, a = s.height, l = s.colorAttachment0.get();
            i.lineBlendDensityReadback || (i.lineBlendDensityReadback = new Ia(o));
            const c = i.lineBlendDensityReadback;
            let h = 0, d = !0;
            for(; n > 1 || a > 1;){
                const s = Math.max(1, Math.floor(n / 2)), u = Math.max(1, Math.floor(a / 2)), p = 0 === h ? "fboA" : "fboB";
                c[p] = ga.createWithTexture(r, c[p], s, u, !1);
                const f = c[p];
                r.bindFramebuffer.set(f.framebuffer), r.viewport.set([
                    0,
                    0,
                    s,
                    u
                ]), r.activeTexture.set(o.TEXTURE0), o.bindTexture(o.TEXTURE_2D, l), t1.getOrCreateProgram("lineBlendReduce").draw(t1, o.TRIANGLES, e1.a3.disabled, e1.a4.disabled, e1.a7.unblended, e1.a5.disabled, ro(0, [
                    1 / n,
                    1 / a
                ], d), i.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments, i.paint, t1.transform.zoom), n = s, a = u, l = f.colorAttachment0.get(), h = 1 - h, d = !1;
            }
            const u = Pa(r), p = u ? 16 : 4;
            c.sync && (o.deleteSync(c.sync), c.sync = null), o.bindBuffer(o.PIXEL_PACK_BUFFER, c.pbo), o.bufferData(o.PIXEL_PACK_BUFFER, p, o.STREAM_READ), o.readPixels(0, 0, 1, 1, o.RGBA, u ? o.FLOAT : o.UNSIGNED_BYTE, 0), o.bindBuffer(o.PIXEL_PACK_BUFFER, null), c.sync = o.fenceSync(o.SYNC_GPU_COMMANDS_COMPLETE, 0), r.viewport.set([
                0,
                0,
                t1.width,
                t1.height
            ]);
        }
        function Aa(e1, t1, i) {
            if (!Pa(e1.context)) return;
            const s = t1.lineBlendDensityReadback;
            s && s.sync ? (function(e1, t1, i) {
                if (e1.sync && t1.getSyncParameter(e1.sync, t1.SYNC_STATUS) === t1.SIGNALED) {
                    if (t1.deleteSync(e1.sync), e1.sync = null, t1.bindBuffer(t1.PIXEL_PACK_BUFFER, e1.pbo), Pa(i)) {
                        const i = new Float32Array(4);
                        t1.getBufferSubData(t1.PIXEL_PACK_BUFFER, 0, i);
                        const s = i[1];
                        e1.maxDensity = Math.max(2 * (s > 0 ? i[0] / s : 0), 1);
                    } else e1.maxDensity = 1;
                    t1.bindBuffer(t1.PIXEL_PACK_BUFFER, null);
                }
            }(s, e1.context.gl, e1.context), s.sync || (Ra(e1, t1, i), e1.style.map.triggerRepaint())) : (Ra(e1, t1, i), e1.style.map.triggerRepaint());
        }
        function Ma(t1, i, s, r, o, n) {
            const a = t1.context, l = a.gl, c = "additive" === s ? 1 : i.paint.get("line-opacity").constantOr(1), h = "additive" === s ? function(e1, t1) {
                const i = t1.paint.get("line-blend-additive-clamp");
                if (i > 0) return i;
                const s = t1.lineBlendDensityReadback;
                return s && 0 !== s.maxDensity ? s.maxDensity : null;
            }(0, i) : 1;
            if (null === h) return;
            a.bindFramebuffer.set(o), n && a.viewport.set([
                0,
                0,
                n[0],
                n[1]
            ]), a.activeTexture.set(l.TEXTURE0), l.bindTexture(l.TEXTURE_2D, r.colorAttachment0.get());
            const d = La(s, t1.context);
            t1.getOrCreateProgram("lineBlendComposite").draw(t1, l.TRIANGLES, e1.a3.disabled, e1.a4.disabled, d, e1.a5.disabled, ((e1, t1, i, s)=>({
                    u_image: 0,
                    u_opacity: t1,
                    u_blend_mode: i,
                    u_max_density: s
                }))(0, c, Da[s].compositeUniformValue, h), i.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments, i.paint, t1.transform.zoom);
        }
        function Fa(t1, i, s, r) {
            const { painter: o, sourceCache: n, layer: a, coords: l, colorMode: c, elevationType: h, terrainEnabled: d, pass: u } = t1, p = o.context.gl, f = a.paint.get("fill-pattern"), m = a.paint.get("fill-pattern-cross-fade"), _ = f.constantOr(null);
            let g = h;
            "road" !== h || i && !d || (g = "none");
            const y = "road" === g, v = t1.painter.shadowRenderer, b = y && !!v && v.enabled, x = new e1.a3(o.context.gl.LEQUAL, e1.a3.ReadOnly, o.depthRangeFor3D);
            let w = [
                0,
                0,
                0
            ];
            if (b) {
                const t1 = o.style.directionalLight, i = o.style.ambientLight;
                t1 && i && (w = e1.aQ(o.style, t1, i));
            }
            const T = f && f.constantOr(1), S = o.terrain && o.terrain.renderingToTexture, C = (t1, u)=>{
                let f, g, C, E, I;
                u ? (f = T && !a.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", C = p.LINES) : (f = T ? "fillPattern" : "fill", C = p.TRIANGLES);
                const D = [];
                for (const P of l){
                    const l = n.getTile(P);
                    if (T && !l.patternsLoaded()) continue;
                    const L = l.getBucket(a);
                    if (!L) continue;
                    const R = i ? L.hdExt && L.hdExt.elevationBufferData : L.bufferData;
                    if (!R || R.isEmpty()) continue;
                    o.prepareDrawTile();
                    const A = R.programConfigurations.get(a.id), M = o.isTileAffectedByFog(P), F = [], O = [];
                    y && (F.push("ELEVATED_ROADS"), O.push(R.elevatedLayoutVertexBuffer)), b && F.push("RENDER_SHADOWS", "NORMAL_OFFSET"), S && s && (F.push("USE_MRT1"), "mrt-full-rgba" === o.emissiveMode && F.push("USE_MRT1_RGBA")), T && (o.context.activeTexture.set(p.TEXTURE0), l.imageAtlasTexture && l.imageAtlasTexture.bind(p.LINEAR, p.CLAMP_TO_EDGE), A.updatePaintBuffers());
                    let k = !1;
                    if (_ && l.imageAtlas) {
                        const t1 = l.imageAtlas, i = e1.aR.from(_), s = i.getPrimary().scaleSelf(e1.e.devicePixelRatio).toString(), r = i.getSecondary(), o = t1.patternPositions.get(s), n = r ? t1.patternPositions.get(r.scaleSelf(e1.e.devicePixelRatio).toString()) : null;
                        k = !!o && !!n, o && A.setConstantPatternPositions(o, n);
                    }
                    m > 0 && (k || A.getPatternTransitionVertexBuffer("fill-pattern")) && F.push("FILL_PATTERN_TRANSITION");
                    const B = o.getOrCreateProgram(f, {
                        config: A,
                        overrideFog: M,
                        defines: F
                    }), z = o.translatePosMatrix(P.projMatrix, l, a.paint.get("fill-translate"), a.paint.get("fill-translate-anchor"));
                    b && v.setupShadows(l.tileID.toUnwrapped(), B, "vector-tile");
                    const U = a.paint.get("fill-emissive-strength");
                    if (u) {
                        E = R.lineIndexBuffer, I = R.lineSegments;
                        const e1 = o.terrain && o.terrain.renderingToTexture ? o.terrain.drapeBufferSize : [
                            p.drawingBufferWidth,
                            p.drawingBufferHeight
                        ];
                        g = "fillOutlinePattern" === f && T ? so(z, U, o, l, e1, w, m) : io(z, U, e1, w);
                    } else E = R.indexBuffer, I = R.triangleSegments, g = T ? to(z, U, o, l, w, m) : eo(z, U, w);
                    o.uploadCommonUniforms(o.context, B, P.toUnwrapped());
                    let N = t1;
                    if (("road" === h && !d || "offset" === h) && (N = x), !I || I.get && 0 === I.get().length) continue;
                    const j = r || o.stencilModeForClipping(P);
                    let V = "fallthrough";
                    !u && Xs.drawFillFrcCoverageFirstPass && (V = Xs.drawFillFrcCoverageFirstPass({
                        painter: o,
                        layer: a,
                        bucket: L,
                        coord: P,
                        elevatedGeometry: i,
                        program: B,
                        programConfiguration: A,
                        uniformValues: g,
                        drawMode: C,
                        depthMode: N,
                        stencilMode: j,
                        colorMode: c,
                        bufferData: R,
                        indexBuffer: E,
                        segments: I,
                        dynamicBuffers: O,
                        polygonCoverageTiles: D
                    })), "fallthrough" === V && B.draw(o, C, N, j, c, e1.a5.disabled, g, a.id, R.layoutVertexBuffer, E, I, a.paint, o.transform.zoom, A, O);
                }
                !u && Xs.drawFillFrcCoverageSecondPass && Xs.drawFillFrcCoverageSecondPass(o, a, D, C, c);
            };
            o.renderPass === u && C(o.depthModeForSublayer(1, "opaque" === o.renderPass ? e1.a3.ReadWrite : e1.a3.ReadOnly), !1), "none" === g && "translucent" === o.renderPass && a.paint.get("fill-antialias") && C(o.depthModeForSublayer(a.getPaintProperty("fill-outline-color") ? 2 : 0, e1.a3.ReadOnly), !0);
        }
        function Oa(t1) {
            return [
                t1[0] * e1.el,
                t1[1] * e1.el,
                t1[2] * e1.el,
                0
            ];
        }
        function ka(t1, i, s, r, o, n, a, l, c, h) {
            const d = o.getSource(), u = r.globeSharedBuffers;
            if (!u) return;
            let p, f, m;
            if (s && (p = o.getTile(s)), d instanceof Uo ? (f = d.texture, m = e1.c7(0, 0, r.transform)) : p && s && (f = p.texture, m = e1.c7(s.canonical.z, s.canonical.x, r.transform)), !f || !m) return;
            i || (m = e1.aY(e1.a2(), m, [
                1,
                -1,
                1
            ]));
            const _ = r.context, g = _.gl, y = "nearest" === n.paint.get("raster-resampling") ? g.NEAREST : g.LINEAR, v = r.colorModeForDrapableLayerRenderPass(a), b = l.defines;
            b.push("GLOBE_POLES");
            const x = new e1.a3(g.LEQUAL, e1.a3.ReadWrite, r.depthRangeFor3D), w = r.transform.expandedFarZProjMatrix, T = Float32Array.from(e1.bf(e1.bg(new e1.c1(0, 0, 0))));
            r.terrain && r.terrain.prepareDrawTile(), _.activeTexture.set(g.TEXTURE0), f.bind(y, g.CLAMP_TO_EDGE), _.activeTexture.set(g.TEXTURE1), f.bind(y, g.CLAMP_TO_EDGE), "useMipmap" in f && _.extTextureFilterAnisotropic && r.transform.pitch > 20 && g.texParameterf(g.TEXTURE_2D, _.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, _.extTextureFilterAnisotropicMax);
            const [S, C, E, I] = s ? u.getPoleBuffers(s.canonical.z, !1) : u.getPoleBuffers(0, !0), D = t1;
            let P;
            i ? (P = S, r.renderDefaultNorthPole = 0 !== D) : (P = C, r.renderDefaultSouthPole = 0 !== D);
            const L = Oa(l.mix), R = ((e1, t1, i, s, r, o, n, a, l, c, h, d, u, p)=>lo(e1, t1, i, s, new Float32Array(16), new Float32Array(9), [
                    0,
                    0
                ], r, [
                    0,
                    0
                ], [
                    0,
                    0,
                    0,
                    0
                ], 1, {
                    opacity: 1,
                    mix: 0
                }, n, [
                    0,
                    0
                ], l, 2, h, d, u, 1, 0, p))(r, w, T, m, e1._(r.transform.zoom), 0, n, 0, D, 0, L, l.offset, l.range, a), A = r.getOrCreateProgram("raster", {
                defines: b
            });
            r.uploadCommonUniforms(_, A, null), A.draw(r, g.TRIANGLES, x, h, v, c, R, n.id, P, E, I);
        }
        function Ba(e1) {
            if (e1.isOrthographic) return [
                0,
                0,
                0,
                0
            ];
            const t1 = e1._nearZ, i = e1.projection.farthestPixelDistance(e1), s = i - t1, r = .2 * e1.height, o = t1 + r;
            return [
                t1,
                i,
                (o - r - t1) / s,
                (o - t1) / s
            ];
        }
        function za(e1, t1, i, s) {
            if (e1) return "raster-array" === t1.type ? t1.getTextureDescriptor(e1, i, !0) : {
                texture: e1.texture,
                mix: Oa(s.mix),
                offset: s.offset,
                buffer: 0,
                tileSize: 1
            };
        }
        const Ua = e1.dk(new Float32Array(16)), Na = {
            "dual-source-blending": "dual-source-blending",
            "mrt-fallback": "mrt",
            "mrt-full-rgba": "mrt-rgba"
        }, ja = e1.b9([
            {
                name: "a_pos_3f",
                components: 3,
                type: "Float32"
            }
        ]), { members: Va } = ja;
        function Ga(e1, t1, i, s) {
            e1.emplaceBack(t1, i, s);
        }
        class qa {
            constructor(t1){
                this.vertexArray = new e1.eo, this.indices = new e1.ak, Ga(this.vertexArray, -1, -1, 1), Ga(this.vertexArray, 1, -1, 1), Ga(this.vertexArray, -1, 1, 1), Ga(this.vertexArray, 1, 1, 1), Ga(this.vertexArray, -1, -1, -1), Ga(this.vertexArray, 1, -1, -1), Ga(this.vertexArray, -1, 1, -1), Ga(this.vertexArray, 1, 1, -1), this.indices.emplaceBack(5, 1, 3), this.indices.emplaceBack(3, 7, 5), this.indices.emplaceBack(6, 2, 0), this.indices.emplaceBack(0, 4, 6), this.indices.emplaceBack(2, 6, 7), this.indices.emplaceBack(7, 3, 2), this.indices.emplaceBack(5, 4, 0), this.indices.emplaceBack(0, 1, 5), this.indices.emplaceBack(0, 2, 3), this.indices.emplaceBack(3, 1, 0), this.indices.emplaceBack(7, 6, 4), this.indices.emplaceBack(4, 5, 7), this.vertexBuffer = t1.createVertexBuffer(this.vertexArray, Va), this.indexBuffer = t1.createIndexBuffer(this.indices), this.segment = e1.aj.simpleSegment(0, 0, 36, 12);
            }
        }
        function $a(t1, i, s, r, o, n) {
            const a = t1.context.gl, l = i.paint.get("sky-atmosphere-color"), c = i.paint.get("sky-atmosphere-halo-color"), h = i.paint.get("sky-atmosphere-sun-intensity"), d = ((e1, t1, i, s, r)=>({
                    u_matrix_3f: e1,
                    u_sun_direction: t1,
                    u_sun_intensity: i,
                    u_color_tint_r: [
                        s.r,
                        s.g,
                        s.b,
                        s.a
                    ],
                    u_color_tint_m: [
                        r.r,
                        r.g,
                        r.b,
                        r.a
                    ],
                    u_luminance: 5e-5
                }))(e1.er(e1.es(), r), o, h, l.toPremultipliedRenderColor(null), c.toPremultipliedRenderColor(null));
            a.framebufferTexture2D(a.FRAMEBUFFER, a.COLOR_ATTACHMENT0, a.TEXTURE_CUBE_MAP_POSITIVE_X + n, i.skyboxTexture, 0), s.draw(t1, a.TRIANGLES, e1.a3.disabled, e1.a4.disabled, e1.a7.unblended, e1.a5.frontCW, d, "skyboxCapture", i.skyboxGeometry.vertexBuffer, i.skyboxGeometry.indexBuffer, i.skyboxGeometry.segment);
        }
        const Za = e1.b9([
            {
                type: "Float32",
                name: "a_pos",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            }
        ]);
        class Wa {
            constructor(t1){
                const i = new e1.et;
                i.emplaceBack(-1, 1, 1, 0, 0), i.emplaceBack(1, 1, 1, 1, 0), i.emplaceBack(1, -1, 1, 1, 1), i.emplaceBack(-1, -1, 1, 0, 1);
                const s = new e1.ak;
                s.emplaceBack(0, 1, 2), s.emplaceBack(2, 3, 0), this.vertexBuffer = t1.createVertexBuffer(i, Za.members), this.indexBuffer = t1.createIndexBuffer(s), this.segments = e1.aj.simpleSegment(0, 0, 4, 2);
            }
            destroy() {
                this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy();
            }
        }
        const Ha = e1.b9([
            {
                type: "Float32",
                name: "a_pos_3f",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            },
            {
                type: "Float32",
                name: "a_size_scale",
                components: 1
            },
            {
                type: "Float32",
                name: "a_opacity",
                components: 1
            }
        ]);
        class Xa {
            constructor(){
                this.colorModeAlphaBlendedWriteRGB = new e1.a7([
                    e1.eu,
                    e1.ev,
                    e1.eu,
                    e1.ev
                ], e1.C.transparent, [
                    !0,
                    !0,
                    !0,
                    !1
                ]), this.colorModeWriteAlpha = new e1.a7(e1.a7.Replace, e1.C.transparent, [
                    !1,
                    !1,
                    !1,
                    !0
                ]), this.params = {
                    starsCount: 16e3,
                    sizeMultiplier: .15,
                    sizeRange: 100,
                    intensityRange: 200
                }, this.updateNeeded = !0, this._painter = null, this._devtoolsFolder = null;
            }
            update(t1) {
                this._painter = t1;
                const i = t1.context;
                if (!this.atmosphereBuffer || this.updateNeeded) {
                    this.updateNeeded = !1, this.atmosphereBuffer = new Wa(i);
                    let t1 = this.params;
                    const s = t1.sizeRange, r = t1.intensityRange, o = function(t1) {
                        const i = e1.bt(30), s = [];
                        for(let r = 0; r < t1; ++r){
                            const t1 = 2 * Math.PI * i(), r = Math.acos(1 - 2 * i()) - .5 * Math.PI;
                            s.push(e1.bs(Math.cos(r) * Math.cos(t1), Math.cos(r) * Math.sin(t1), Math.sin(r)));
                        }
                        return s;
                    }(t1.starsCount), n = e1.bt(300), a = new e1.ew, l = new e1.ak;
                    let c = 0;
                    for(let t1 = 0; t1 < o.length; ++t1){
                        const i = e1.dY([], o[t1], 200), h = Math.max(0, 1 + .01 * s * (1 * n() - .5)), d = Math.max(0, 1 + .01 * r * (1 * n() - .5));
                        a.emplaceBack(i[0], i[1], i[2], -1, -1, h, d), a.emplaceBack(i[0], i[1], i[2], 1, -1, h, d), a.emplaceBack(i[0], i[1], i[2], 1, 1, h, d), a.emplaceBack(i[0], i[1], i[2], -1, 1, h, d), l.emplaceBack(c + 0, c + 1, c + 2), l.emplaceBack(c + 0, c + 2, c + 3), c += 4;
                    }
                    this.starsVx = i.createVertexBuffer(a, Ha.members), this.starsIdx = i.createIndexBuffer(l), this.starsSegments = e1.aj.simpleSegment(0, 0, a.length, l.length);
                }
            }
            destroy() {
                this.atmosphereBuffer && this.atmosphereBuffer.destroy(), this.starsVx && this.starsVx.destroy(), this.starsIdx && this.starsIdx.destroy(), this._painter = null;
            }
            drawAtmosphereGlow(t1, i) {
                const s = t1.context, r = s.gl, o = t1.transform, n = new e1.a3(r.LEQUAL, e1.a3.ReadOnly, [
                    0,
                    1
                ]), a = e1._(o.zoom), l = t1.style.getLut(i.scope), c = "none" === i.properties.get("color-use-theme"), h = i.properties.get("color").toNonPremultipliedRenderColor(c ? null : l), d = "none" === i.properties.get("high-color-use-theme"), u = i.properties.get("high-color").toNonPremultipliedRenderColor(d ? null : l), p = "none" === i.properties.get("space-color-use-theme"), f = i.properties.get("space-color").toNonPremultipliedRenderColor(p ? null : l), m = 5e-4, _ = e1.ex(i.properties.get("horizon-blend"), 0, 1, m, .25), g = e1.c6(t1, s, o) && _ === m ? o.worldSize / (2 * Math.PI * 1.025) - 1 : o.globeRadius, y = t1.frameCounter / 1e3 % 1, v = e1.en(o.globeCenterInViewSpace), b = Math.sqrt(Math.pow(v, 2) - Math.pow(g, 2)), x = Math.acos(b / v), w = (i)=>{
                    const l = "globe" === o.projection.name ? [
                        "PROJECTION_GLOBE_VIEW",
                        "FOG"
                    ] : [
                        "FOG"
                    ];
                    i && l.push("ALPHA_PASS");
                    const c = t1.getOrCreateProgram("globeAtmosphere", {
                        defines: l
                    }), d = ((e1, t1, i, s, r, o, n, a, l, c, h, d)=>({
                            u_frustum_tl: e1,
                            u_frustum_tr: t1,
                            u_frustum_br: i,
                            u_frustum_bl: s,
                            u_horizon: r,
                            u_transition: o,
                            u_fadeout_range: n,
                            u_atmosphere_fog_color: a.toArray01(),
                            u_high_color: l.toArray01(),
                            u_space_color: c.toArray01(),
                            u_temporal_offset: h,
                            u_horizon_angle: d
                        }))(o.frustumCorners.TL, o.frustumCorners.TR, o.frustumCorners.BR, o.frustumCorners.BL, o.frustumCorners.horizon, a, _, h, u, f, y, x);
                    t1.uploadCommonUniforms(s, c);
                    const p = this.atmosphereBuffer;
                    p && c.draw(t1, r.TRIANGLES, n, e1.a4.disabled, i ? this.colorModeWriteAlpha : this.colorModeAlphaBlendedWriteRGB, e1.a5.backCW, d, i ? "atmosphere_glow_alpha" : "atmosphere_glow", p.vertexBuffer, p.indexBuffer, p.segments);
                };
                w(!1), w(!0);
            }
            drawStars(t1, i) {
                const s = e1.bb(i.properties.get("star-intensity"), 0, 1);
                if (0 === s) return;
                const r = t1.context, o = r.gl, n = t1.transform, a = t1.getOrCreateProgram("stars"), l = e1.bo([]);
                e1.bp(l, l, -n._pitch), e1.bq(l, l, -n.angle), e1.bp(l, l, e1.aF(n._center.lat)), e1.ey(l, l, -e1.aF(n._center.lng));
                const c = e1.br(new Float32Array(16), l), h = e1.a1([], n.starsProjMatrix, c), d = e1.er([], c), u = e1.ez([], d);
                let p = this.params.sizeMultiplier;
                const f = [
                    0,
                    1,
                    0
                ];
                e1.d2(f, f, u), e1.dY(f, f, p);
                const m = [
                    1,
                    0,
                    0
                ];
                e1.d2(m, m, u), e1.dY(m, m, p);
                const _ = (g = f, y = m, v = s, {
                    u_matrix: Float32Array.from(h),
                    u_up: g,
                    u_right: y,
                    u_intensity_multiplier: v
                });
                var g, y, v;
                t1.uploadCommonUniforms(r, a), this.starsVx && this.starsIdx && a.draw(t1, o.TRIANGLES, e1.a3.disabled, e1.a4.disabled, this.colorModeAlphaBlendedWriteRGB, e1.a5.disabled, _, "atmosphere_stars", this.starsVx, this.starsIdx, this.starsSegments);
            }
        }
        class Ya {
        }
        class Ka {
            constructor(){
                this._storage = new Map;
            }
            getLinesFromTrianglesBuffer(t1, i, s) {
                {
                    const e1 = this._storage.get(i.id);
                    if (e1) return e1.lastUsedFrameIdx = t1, e1.buf;
                }
                const r = s.gl, o = r.getBufferParameter(r.ELEMENT_ARRAY_BUFFER, r.BUFFER_SIZE), n = new ArrayBuffer(o), a = new Int16Array(n);
                r.getBufferSubData(r.ELEMENT_ARRAY_BUFFER, 0, new Int16Array(n));
                const l = new e1.eA;
                for(let e1 = 0; e1 < o / 2; e1 += 3){
                    const t1 = a[e1], i = a[e1 + 1], s = a[e1 + 2];
                    l.emplaceBack(t1, i), l.emplaceBack(i, s), l.emplaceBack(s, t1);
                }
                const c = s.bindVertexArrayOES.current, h = new Ya;
                return h.buf = new fa(s, l), h.lastUsedFrameIdx = t1, this._storage.set(i.id, h), s.bindVertexArrayOES.set(c), h.buf;
            }
            update(e1) {
                for (const [t1, i] of this._storage)e1 - i.lastUsedFrameIdx > 30 && (i.buf.destroy(), this._storage.delete(t1));
            }
            destroy() {
                for (const [e1, t1] of this._storage)t1.buf.destroy(), this._storage.delete(e1);
            }
        }
        class Qa {
            constructor(){
                this.occluderSize = 30, this.depthOffset = -0.0001;
            }
        }
        const Ja = {
            symbol: function(t1, i, s, r, o) {
                if ("translucent" !== t1.renderPass) return;
                const n = e1.a4.disabled, a = t1.colorModeForRenderPass(), l = s.layout.get("text-variable-anchor"), c = s.layout.get("text-size-scale-range"), h = e1.bb(t1.scaleFactor, c[0], c[1]);
                l && function(t1, i, s, r, o, n, a, l) {
                    const c = i.transform, h = "map" === o, d = "map" === n;
                    for (const i of t1){
                        const t1 = r.getTile(i), o = t1.getBucket(s);
                        if (!o || !o.text || !o.text.segments.get().length) continue;
                        const n = e1.dr(o.textSizeData, c.zoom, l), u = e1.e4(i, o.getProjection(), c), p = c.calculatePixelsToTileUnitsMatrix(t1), f = e1.e5(u, t1.tileID.canonical, d, h, c, o.getProjection(), p), m = o.hasIconTextFit() && o.hasIconData();
                        n && wa(o, h, d, a, c, f, i, Math.pow(2, c.zoom - t1.tileID.overscaledZ), n, m);
                    }
                }(r, t1, s, i, s.layout.get("text-rotation-alignment"), s.layout.get("text-pitch-alignment"), o, h);
                const d = 0 !== s.paint.get("icon-opacity").constantOr(1), u = 0 !== s.paint.get("text-opacity").constantOr(1);
                void 0 !== s.layout.get("symbol-sort-key").constantOr(1) && (d || u) ? Ta(t1, i, s, r, n, a) : (d && Ta(t1, i, s, r, n, a, {
                    onlyIcons: !0
                }), u && Ta(t1, i, s, r, n, a, {
                    onlyText: !0
                })), i.map.showCollisionBoxes && "global" !== i.map._placementAlgorithm && wt.drawCollisionDebug && (wt.drawCollisionDebug(t1, i, s, r, s.paint.get("text-translate"), s.paint.get("text-translate-anchor"), !0), wt.drawCollisionDebug(t1, i, s, r, s.paint.get("icon-translate"), s.paint.get("icon-translate-anchor"), !1));
            },
            circle: function(t1, i, s, r) {
                if ("translucent" !== t1.renderPass) return;
                const o = s.paint.get("circle-opacity"), n = s.paint.get("circle-stroke-width"), a = s.paint.get("circle-stroke-opacity"), l = void 0 !== s.layout.get("circle-sort-key").constantOr(1), c = s.paint.get("circle-emissive-strength");
                if (0 === o.constantOr(1) && (0 === n.constantOr(1) || 0 === a.constantOr(1))) return;
                const h = t1.context, d = h.gl, u = t1.transform, p = !(!t1.terrain || !t1.terrain.enabled), f = s.layout.get("circle-elevation-reference"), m = t1.depthModeForSublayer(0, e1.a3.ReadOnly), _ = new e1.a3(t1.context.gl.LEQUAL, e1.a3.ReadOnly, t1.depthRangeFor3D), g = "none" === f || p ? m : _, y = e1.a4.disabled, v = t1.colorModeForDrapableLayerRenderPass(c), b = "globe" === u.projection.name, x = [
                    e1.ad(u.center.lng),
                    e1.ae(u.center.lat)
                ], w = [];
                for(let o = 0; o < r.length; o++){
                    const n = r[o], a = i.getTile(n), c = a.getBucket(s);
                    if (!c || c.projection.name !== u.projection.name) continue;
                    const h = c.programConfigurations.get(s.id), d = c.layoutVertexBuffer, p = c.globeExtVertexBuffer, f = c.indexBuffer, m = e1.eb(s), _ = [
                        p
                    ], g = t1.isTileAffectedByFog(n);
                    b && m.push("PROJECTION_GLOBE_VIEW"), m.push("DEPTH_D24"), t1.terrain && u.depthOcclusionForSymbolsAndCircles && m.push("DEPTH_OCCLUSION"), c.hdExt && c.hdExt.hasElevation && !t1.terrain && (m.push("ELEVATED_ROADS"), _.push(c.hdExt.elevatedLayoutVertexBuffer));
                    const y = t1.getOrCreateProgram("circle", {
                        config: h,
                        defines: m,
                        overrideFog: g
                    }), v = u.projection.createInversionMatrix(u, n.canonical), T = {
                        programConfiguration: h,
                        program: y,
                        layoutVertexBuffer: d,
                        dynamicBuffers: _,
                        indexBuffer: f,
                        uniformValues: e1.ec(t1, n, a, v, x, s),
                        tile: a
                    };
                    if (l) {
                        const t1 = c.segments.get();
                        for (const i of t1)w.push({
                            segments: new e1.aj([
                                i
                            ]),
                            sortKey: i.sortKey,
                            state: T
                        });
                    } else w.push({
                        segments: c.segments,
                        sortKey: 0,
                        state: T
                    });
                }
                l && w.sort((e1, t1)=>e1.sortKey - t1.sortKey);
                const T = {
                    useDepthForOcclusion: u.depthOcclusionForSymbolsAndCircles
                };
                for (const i of w){
                    const { programConfiguration: r, program: o, layoutVertexBuffer: n, dynamicBuffers: a, indexBuffer: l, uniformValues: c, tile: p } = i.state, f = i.segments;
                    t1.terrain && t1.terrain.setupElevationDraw(p, o, T), t1.uploadCommonUniforms(h, o, p.tileID.toUnwrapped()), o.draw(t1, d.TRIANGLES, g, y, v, e1.a5.disabled, c, s.id, n, l, f, s.paint, u.zoom, r, a);
                }
            },
            heatmap: function(t1, i, s, r) {
                if (0 !== s.paint.get("heatmap-opacity")) {
                    if ("offscreen" === t1.renderPass) {
                        const o = t1.context, n = o.gl, a = e1.a4.disabled, l = new e1.a7([
                            n.ONE,
                            n.ONE,
                            n.ONE,
                            n.ONE
                        ], e1.C.transparent, [
                            !0,
                            !0,
                            !0,
                            !0
                        ]), c = "globe" === t1.transform.projection.name ? .5 : .25;
                        s.heatmapFbo = ga.createWithTexture(o, s.heatmapFbo, t1.width * c, t1.height * c), o.clear({
                            color: e1.C.transparent
                        });
                        const h = t1.transform, d = "globe" === h.projection.name, u = d ? [
                            "PROJECTION_GLOBE_VIEW"
                        ] : [], p = d ? e1.a5.frontCCW : e1.a5.disabled, f = [
                            e1.ad(h.center.lng),
                            e1.ae(h.center.lat)
                        ];
                        for(let c = 0; c < r.length; c++){
                            const m = r[c];
                            if (i.hasRenderableParent(m)) continue;
                            const _ = i.getTile(m), g = _.getBucket(s);
                            if (!g || g.projection.name !== h.projection.name) continue;
                            const y = t1.isTileAffectedByFog(m), v = g.programConfigurations.get(s.id), b = t1.getOrCreateProgram("heatmap", {
                                config: v,
                                defines: u,
                                overrideFog: y
                            }), { zoom: x } = t1.transform;
                            t1.terrain && t1.terrain.setupElevationDraw(_, b), t1.uploadCommonUniforms(o, b, m.toUnwrapped());
                            const w = h.projection.createInversionMatrix(h, m.canonical);
                            b.draw(t1, n.TRIANGLES, e1.a3.disabled, a, l, p, no(t1, m, _, w, f, x, s.paint.get("heatmap-intensity")), s.id, g.layoutVertexBuffer, g.indexBuffer, g.segments, s.paint, t1.transform.zoom, v, d ? [
                                g.globeExtVertexBuffer
                            ] : null);
                        }
                        o.viewport.set([
                            0,
                            0,
                            t1.width,
                            t1.height
                        ]);
                    } else "translucent" === t1.renderPass && (t1.context.setColorMode(t1.colorModeForRenderPass()), function(t1, i) {
                        const s = t1.context, r = s.gl, o = i.heatmapFbo;
                        if (!o) return;
                        s.activeTexture.set(r.TEXTURE0), r.bindTexture(r.TEXTURE_2D, o.colorAttachment0.get()), s.activeTexture.set(r.TEXTURE1);
                        let n = i.colorRampTexture;
                        n || (n = i.colorRampTexture = new e1.T(s, i.colorRamp, r.RGBA8)), n.bind(r.LINEAR, r.CLAMP_TO_EDGE), t1.getOrCreateProgram("heatmapTexture").draw(t1, r.TRIANGLES, e1.a3.disabled, e1.a4.disabled, t1.colorModeForRenderPass(), e1.a5.disabled, ((e1, t1)=>({
                                u_image: 0,
                                u_color_ramp: 1,
                                u_opacity: t1.paint.get("heatmap-opacity")
                            }))(0, i), i.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments, i.paint, t1.transform.zoom);
                    }(t1, s));
                }
            },
            line: function(e1, t1, i, s) {
                const r = i.paint.get("line-opacity"), o = i.paint.get("line-width");
                if (0 === r.constantOr(1) || 0 === o.constantOr(1)) return;
                const n = i.paint.get("line-blend-mode"), a = e1.terrain && e1.terrain.renderingToTexture;
                if ("default" === n || "globe" === e1.transform.projection.name) "translucent" === e1.renderPass && Ca(e1, t1, i, s);
                else {
                    if (a) return void function(e1, t1, i, s, r) {
                        if ("translucent" !== e1.renderPass) return;
                        const o = e1.context, n = o.gl, a = e1.terrain;
                        if (!a) return;
                        const l = o.bindFramebuffer.current, c = e1.isEmissiveMrtActive(), h = a.drapeBufferSize[0], d = a.drapeBufferSize[1];
                        i.lineBlendFbos || (i.lineBlendFbos = new Ea), i.lineBlendFbos.drapeFbo = ga.createWithTexture(o, i.lineBlendFbos.drapeFbo, h, d, !0), c && n.drawBuffers([
                            n.COLOR_ATTACHMENT0
                        ]), o.clear({
                            color: Da[r].clearColor,
                            depth: 1,
                            stencil: 0
                        });
                        const u = e1.currentStencilSource, p = e1._tileClippingMaskIDs, f = e1.nextStencilID;
                        e1.currentStencilSource = void 0, e1._tileClippingMaskIDs = new Map, e1.nextStencilID = 1;
                        const m = e1._terrain;
                        e1._terrain = null, e1._renderTileClippingMasks(i, t1, s), Ca(e1, t1, i, s, La(r, e1.context), !0), e1._terrain = m, e1.currentStencilSource = u, e1._tileClippingMaskIDs = p, e1.nextStencilID = f, c && n.drawBuffers([
                            n.COLOR_ATTACHMENT0,
                            n.COLOR_ATTACHMENT1
                        ]);
                        const _ = a.drapeBufferSize, g = i.lineBlendFbos && i.lineBlendFbos.drapeFbo;
                        g && ("additive" === r && Aa(e1, i, g), Ma(e1, i, r, g, l, _));
                    }(e1, t1, i, s, n);
                    if ("offscreen" === e1.renderPass) return void function(e1, t1, i, s, r) {
                        const o = e1.context, n = Math.ceil(e1.width), a = Math.ceil(e1.height);
                        i.lineBlendFbos || (i.lineBlendFbos = new Ea), i.lineBlendFbos.fbo = ga.createWithTexture(o, i.lineBlendFbos.fbo, n, a, !0), o.clear({
                            color: Da[r].clearColor,
                            depth: 1,
                            stencil: 0
                        });
                        const l = e1.currentStencilSource, c = e1._tileClippingMaskIDs, h = e1.nextStencilID;
                        e1.currentStencilSource = void 0, e1._tileClippingMaskIDs = new Map, e1.nextStencilID = 1, e1._renderTileClippingMasks(i, t1, s);
                        const d = e1.renderPass;
                        e1.renderPass = "translucent", Ca(e1, t1, i, s, La(r, e1.context)), e1.renderPass = d, e1.currentStencilSource = l, e1._tileClippingMaskIDs = c, e1.nextStencilID = h, o.viewport.set([
                            0,
                            0,
                            e1.width,
                            e1.height
                        ]), "additive" === r && Aa(e1, i, i.lineBlendFbos.fbo);
                    }(e1, t1, i, s, n);
                    if ("translucent" === e1.renderPass) {
                        const t1 = i.lineBlendFbos && i.lineBlendFbos.fbo;
                        return void (t1 && Ma(e1, i, n, t1, null));
                    }
                }
            },
            fill: function(t1, i, s, r) {
                const o = s.paint.get("fill-color"), n = s.paint.get("fill-opacity");
                if (0 === n.constantOr(1)) return;
                const a = s.paint.get("fill-emissive-strength"), l = t1.colorModeForDrapableLayerRenderPass(a), c = s.paint.get("fill-pattern"), h = t1.opaquePassEnabledForLayer() && !c.constantOr(1) && 1 === o.constantOr(e1.C.transparent).a && 1 === n.constantOr(0) ? "opaque" : "translucent";
                let d = "none";
                "none" !== s.layout.get("fill-elevation-reference") ? d = "road" : 0 !== s.paint.get("fill-z-offset").constantOr(1) && (d = "offset");
                const u = !(!t1.terrain || !t1.terrain.enabled), p = {
                    painter: t1,
                    sourceCache: i,
                    layer: s,
                    coords: r,
                    colorMode: l,
                    elevationType: d,
                    terrainEnabled: u,
                    pass: h
                };
                if ("shadow" === t1.renderPass) return void (t1.shadowRenderer && "road" === d && !u && Xs.drawElevatedFillShadows && Xs.drawElevatedFillShadows(p));
                const f = t1.isEmissiveMrtActive();
                if ("offset" !== d) {
                    if (Fa(p, !1, f), "road" === d) {
                        const o = !u && "translucent" === t1.renderPass;
                        o && Xs.drawDepthPrepass && Xs.drawDepthPrepass(t1, i, s, r, "geometry"), Fa(p, !0, f, e1.a4.disabled), o && Xs.drawElevatedStructures && Xs.drawElevatedStructures(p);
                    }
                } else Fa(p, !1, f, t1.stencilModeFor3D());
            },
            "fill-extrusion": function(t1, i, s, r) {
                const o = s.paint.get("fill-extrusion-opacity"), n = t1.context, a = n.gl, l = t1.terrain, c = l && l.renderingToTexture;
                if (0 === o) return;
                const h = t1.isEmissiveMrtActive(), d = t1.conflationActive && t1.style.isLayerClipped(s, i.getSource()), u = t1.style.order.indexOf(s.fqid);
                if (d && function(e1, t1, i, s, r) {
                    for (const o of s){
                        const s = t1.getTile(o).getBucket(i);
                        s && (s.updateReplacement(o, e1.replacementSource, r), s.uploadCentroid(e1.context));
                    }
                }(t1, i, s, r, u), l || d) for (const e1 of r){
                    const r = i.getTile(e1).getBucket(s);
                    r && _i(t1.context, i, e1, r, s, l, d);
                }
                if (t1.depthPrepassPhase) {
                    if (!c) {
                        const o = new e1.a3(a.LEQUAL, e1.a3.ReadWrite, t1.depthRangeFor3D);
                        pi(t1, i, s, r, o, e1.a4.disabled, e1.a7.disabled, d);
                    }
                } else if ("shadow" === t1.renderPass && t1.shadowRenderer) {
                    const n = t1.shadowRenderer;
                    if (l && o < .65 && s.getPaintPropertyValue("fill-extrusion-opacity").expression instanceof e1.av) return;
                    const a = n.getShadowPassDepthMode();
                    pi(t1, i, s, r, a, e1.a4.disabled, e1.a7.disabled, d);
                } else if ("translucent" === t1.renderPass) {
                    const u = !s.paint.get("fill-extrusion-pattern").constantOr(1), p = s.paint.get("fill-extrusion-color").constantOr(e1.C.white);
                    if (!c && 0 !== p.a) {
                        const n = new e1.a3(t1.context.gl.LEQUAL, e1.a3.ReadWrite, t1.depthRangeFor3D);
                        1 === o && u ? pi(t1, i, s, r, n, e1.a4.disabled, e1.a7.unblended, d) : (t1.hasGrouped3DDepthPrepass(t1.currentLayer) || pi(t1, i, s, r, n, e1.a4.disabled, e1.a7.disabled, d), pi(t1, i, s, r, n, t1.stencilModeFor3DGroup(t1.currentLayer), t1.colorModeForRenderPass(), d), t1.resetStencilClippingMasks());
                    }
                    const f = t1.style.enable3dLights() && u && (!l && "globe" !== t1.transform.projection.name || c);
                    if (f && !di.drawGroundEffect && ui(), f && di.drawGroundEffect) {
                        const o = s.paint.get("fill-extrusion-opacity"), u = s.paint.get("fill-extrusion-ambient-occlusion-intensity"), p = s.paint.get("fill-extrusion-ambient-occlusion-ground-radius"), f = s.paint.get("fill-extrusion-flood-light-intensity"), m = "none" === s.paint.get("fill-extrusion-flood-light-color-use-theme").constantOr("default"), _ = s.paint.get("fill-extrusion-flood-light-color").toNonPremultipliedRenderColor(m ? null : s.lut).toArray01().slice(0, 3), g = u > 0 && p > 0, y = f > 0, v = new fi;
                        v.translate = s.paint.get("fill-extrusion-translate"), v.translateAnchor = s.paint.get("fill-extrusion-translate-anchor"), v.edgeRadius = s.layout.get("fill-extrusion-edge-radius"), v.cutoffFadeRange = s.paint.get("fill-extrusion-cutoff-fade-range");
                        const b = (n)=>{
                            const l = t1.depthModeForSublayer(1, e1.a3.ReadOnly, a.LEQUAL, !0), c = s.paint.get(n ? "fill-extrusion-ambient-occlusion-ground-attenuation" : "fill-extrusion-flood-light-ground-attenuation"), h = e1.aw(.1, 3, c), m = t1._showOverdrawInspector;
                            if (!m) {
                                const c = new e1.a4({
                                    func: a.ALWAYS,
                                    mask: 255
                                }, 255, 255, a.KEEP, a.KEEP, a.REPLACE), m = new e1.a7([
                                    a.ONE,
                                    a.ONE,
                                    a.ONE,
                                    a.ONE
                                ], e1.C.transparent, [
                                    !1,
                                    !1,
                                    !1,
                                    !0
                                ], a.MIN);
                                di.drawGroundEffect(v, t1, i, s, r, l, c, m, e1.a5.disabled, n, "sdf", o, u, p, f, _, h, d, !1);
                            }
                            {
                                const c = m ? e1.a4.disabled : new e1.a4({
                                    func: a.EQUAL,
                                    mask: 255
                                }, 255, 255, a.KEEP, a.DECR, a.DECR), g = m ? t1.colorModeForRenderPass() : new e1.a7([
                                    a.ONE_MINUS_DST_ALPHA,
                                    a.DST_ALPHA,
                                    a.ONE,
                                    a.ONE
                                ], e1.C.transparent, [
                                    !0,
                                    !0,
                                    !0,
                                    !0
                                ]);
                                di.drawGroundEffect(v, t1, i, s, r, l, c, g, e1.a5.disabled, n, "color", o, u, p, f, _, h, d, !1);
                            }
                        };
                        if (c) {
                            const c = ()=>{
                                const t1 = l.drapeBufferSize[0], i = l.drapeBufferSize[1];
                                let s = l.framebufferCopyTexture;
                                return s && (!s || s.size[0] === t1 && s.size[1] === i) || (s && s.destroy(), s = l.framebufferCopyTexture = new e1.T(n, new e1.b({
                                    width: t1,
                                    height: i
                                }), a.RGBA8)), s.bind(a.LINEAR, a.CLAMP_TO_EDGE), a.copyTexSubImage2D(a.TEXTURE_2D, 0, 0, 0, 0, 0, t1, i), s;
                            }, m = (n, l, m)=>{
                                const g = t1.depthModeForSublayer(1, e1.a3.ReadOnly, a.LEQUAL, !1), y = s.paint.get(n ? "fill-extrusion-ambient-occlusion-ground-attenuation" : "fill-extrusion-flood-light-ground-attenuation"), b = e1.aw(.1, 3, y);
                                {
                                    const c = new e1.a7([
                                        a.ONE,
                                        a.ONE,
                                        a.ONE,
                                        a.ONE
                                    ], e1.C.transparent, [
                                        !1,
                                        !1,
                                        !1,
                                        !0
                                    ]);
                                    di.drawGroundEffect(v, t1, i, s, r, g, e1.a4.disabled, c, e1.a5.disabled, n, "clear", o, u, p, f, _, b, d, l);
                                }
                                {
                                    const c = new e1.a4({
                                        func: a.ALWAYS,
                                        mask: 255
                                    }, 255, 255, a.KEEP, a.KEEP, a.REPLACE), h = new e1.a7([
                                        a.ONE,
                                        a.ONE,
                                        a.ONE,
                                        a.ONE
                                    ], e1.C.transparent, [
                                        !1,
                                        !1,
                                        !1,
                                        !0
                                    ], a.MIN);
                                    di.drawGroundEffect(v, t1, i, s, r, g, c, h, e1.a5.disabled, n, "sdf", o, u, p, f, _, b, d, l);
                                }
                                h && !n && (m = c());
                                {
                                    const c = n ? a.ZERO : a.ONE_MINUS_DST_ALPHA, h = new e1.a4({
                                        func: a.EQUAL,
                                        mask: 255
                                    }, 255, 255, a.KEEP, a.DECR, a.DECR), m = new e1.a7([
                                        c,
                                        a.DST_ALPHA,
                                        a.ONE_MINUS_DST_ALPHA,
                                        a.ZERO
                                    ], e1.C.transparent, [
                                        !0,
                                        !0,
                                        !0,
                                        !0
                                    ]);
                                    di.drawGroundEffect(v, t1, i, s, r, g, h, m, e1.a5.disabled, n, "color", o, u, p, f, _, b, d, l);
                                }
                                if (!h || n) {
                                    const c = new e1.a7([
                                        a.ONE,
                                        a.ONE,
                                        a.ONE,
                                        n ? a.ZERO : a.ONE
                                    ], e1.C.transparent, [
                                        !1,
                                        !1,
                                        !1,
                                        !0
                                    ], n ? a.FUNC_ADD : a.MAX);
                                    di.drawGroundEffect(v, t1, i, s, r, g, e1.a4.disabled, c, e1.a5.disabled, n, "clear", o, u, p, f, _, b, d, l, m);
                                } else {
                                    a.drawBuffers([
                                        a.NONE,
                                        a.COLOR_ATTACHMENT1
                                    ]);
                                    const c = new e1.a4({
                                        func: a.EQUAL,
                                        mask: 255
                                    }, 254, 255, a.KEEP, a.DECR, a.DECR), h = new e1.a7([
                                        a.ONE,
                                        a.ONE,
                                        a.ONE,
                                        a.ONE
                                    ], e1.C.transparent, [
                                        !0,
                                        !1,
                                        !1,
                                        !1
                                    ], a.MAX);
                                    di.drawGroundEffect(v, t1, i, s, r, g, c, h, e1.a5.disabled, n, "emissive", o, u, p, f, _, b, d, l, m), a.drawBuffers([
                                        a.COLOR_ATTACHMENT0
                                    ]);
                                }
                            };
                            if (g || y) {
                                let e1;
                                t1.prepareDrawTile(), h && !g || (e1 = c()), g && m(!0, !1, e1), y && m(!1, !0, e1);
                            }
                        } else g && b(!0), y && b(!1), (g || y) && t1.resetStencilClippingMasks();
                    }
                }
            },
            hillshade: function(t1, i, s, r) {
                if ("offscreen" !== t1.renderPass && "translucent" !== t1.renderPass) return;
                if (t1.style.disableElevatedTerrain) return;
                const o = t1.context, n = t1.terrain && t1.terrain.renderingToTexture, [a, l] = "translucent" !== t1.renderPass || n ? [
                    {},
                    r
                ] : t1.stencilConfigForOverlap(r);
                for (const r of l){
                    const o = i.getTile(r);
                    if (o.needsHillshadePrepare && "offscreen" === t1.renderPass) er(t1, o, s);
                    else if ("translucent" === t1.renderPass) {
                        const i = t1.depthModeForSublayer(0, e1.a3.ReadOnly), l = s.paint.get("hillshade-emissive-strength"), c = t1.colorModeForDrapableLayerRenderPass(l), h = n && t1.terrain ? t1.terrain.stencilModeForRTTOverlap(r) : a[r.overscaledZ];
                        Qs(t1, r, o, s, i, h, c);
                    }
                }
                o.viewport.set([
                    0,
                    0,
                    t1.width,
                    t1.height
                ]), t1.resetStencilClippingMasks();
            },
            raster: function(t1, i, s, r, o, n) {
                if ("translucent" !== t1.renderPass) return;
                const a = s.paint.get("raster-opacity");
                if (0 === a) return;
                const l = "globe" === t1.transform.projection.name, c = s.paint.get("raster-elevation"), h = "ground" === s.paint.get("raster-elevation-reference"), d = c > 0, u = t1.terrain && t1.terrain.exaggeration() > 0 && d && h, p = d && l, f = !l && u;
                if (t1.renderElevatedRasterBackface && !p) return;
                const m = t1.context, _ = m.gl, g = i.getSource(), y = function(t1, i, s, r, o) {
                    const n = s.paint.get("raster-color"), a = "raster-array" === i.type, l = [], c = s.paint.get("raster-resampling"), h = s.paint.get("raster-color-mix");
                    let d = s.paint.get("raster-color-range");
                    const u = [
                        h[0],
                        h[1],
                        h[2],
                        0
                    ], p = h[3];
                    let f = "nearest" === c ? o.NEAREST : o.LINEAR;
                    if (a && (l.push("RASTER_ARRAY"), n || l.push("RASTER_COLOR"), "linear" === c && l.push("RASTER_ARRAY_LINEAR"), f = o.NEAREST, n && "log" === s.paint.get("raster-color-scale") && l.push("RASTER_COLOR_SCALE_LOG"), !d && i.rasterLayers)) {
                        const e1 = i.rasterLayers.find(({ id: e1 })=>e1 === s.sourceLayer);
                        e1 && e1.fields && e1.fields.range && (d = e1.fields.range);
                    }
                    if (d = d || [
                        0,
                        1
                    ], n) {
                        l.push("RASTER_COLOR"), r.activeTexture.set(o.TEXTURE2), s.updateColorRamp(d);
                        let t1 = s.colorRampTexture;
                        t1 || (t1 = s.colorRampTexture = new e1.T(r, s.colorRamp, o.RGBA8)), t1.bind(f, o.CLAMP_TO_EDGE);
                    }
                    return t1.terrain && t1.terrain.renderingToTexture && t1.isEmissiveMrtActive() && (l.push("USE_MRT1"), "mrt-full-rgba" === t1.emissiveMode && l.push("USE_MRT1_RGBA")), {
                        mix: u,
                        range: d,
                        offset: p,
                        defines: l,
                        resampling: f
                    };
                }(t1, g, s, m, _);
                if (g instanceof Uo && !r.length && !l) return;
                const v = s.paint.get("raster-emissive-strength"), b = t1.colorModeForDrapableLayerRenderPass(v), x = t1.terrain && t1.terrain.renderingToTexture, w = !t1.options.moving, T = "nearest" === s.paint.get("raster-resampling") ? _.NEAREST : _.LINEAR;
                if (g instanceof Uo && !r.length && (g.onNorthPole || g.onSouthPole)) {
                    const r = d ? t1.stencilModeFor3D() : e1.a4.disabled;
                    return void ka(c, !!g.onNorthPole, null, t1, i, s, v, y, e1.a5.disabled, r);
                }
                if (!r.length) return;
                if (s.paint.get("raster-mask") && !Lo.resolveRasterMask) return;
                const S = Lo.resolveRasterMask ? Lo.resolveRasterMask(t1, s) : null;
                if ("unavailable" === S) return;
                let C = !1;
                const [E, I] = g instanceof Uo || x ? [
                    {},
                    r
                ] : t1.stencilConfigForOverlap(r, S ? e1.cc : void 0), D = I.at(-1).overscaledZ;
                p && y.defines.push("PROJECTION_GLOBE_VIEW"), d && y.defines.push("RENDER_CUTOFF", "ELEVATED"), u && y.defines.push("ELEVATION_REFERENCE_GROUND");
                const P = (r, o, h)=>{
                    for (const S of r){
                        const r = S.toUnwrapped(), I = i.getTile(S);
                        if (x && (!I || !I.hasData())) continue;
                        m.activeTexture.set(_.TEXTURE0);
                        const P = za(I, g, s, y);
                        if (!P || !P.texture) continue;
                        const { texture: L, mix: R, offset: A, tileSize: M, buffer: F } = P;
                        let O, k;
                        x ? (O = e1.a3.disabled, k = S.projMatrix) : d ? (O = new e1.a3(_.LEQUAL, e1.a3.ReadWrite, t1.depthRangeFor3D), k = l ? t1.transform.expandedFarZProjMatrix : t1.transform.calculateProjMatrix(r, w)) : (O = t1.depthModeForSublayer(S.overscaledZ - D, 1 === a ? e1.a3.ReadWrite : e1.a3.ReadOnly, _.LESS), k = t1.transform.calculateProjMatrix(r, w));
                        let B = t1.terrain && x ? t1.terrain.stencilModeForRTTOverlap(S) : E[S.overscaledZ];
                        C && (B = Lo.stencilModeWithRasterMask(t1, B));
                        const z = n ? 0 : s.paint.get("raster-fade-duration");
                        I.registerFadeDuration(z);
                        const U = i.findLoadedParent(S, 0), N = Fi(I, U, i, t1.transform, z);
                        let j, V;
                        !N.isFading && I.refreshedUponExpiration && (I.refreshedUponExpiration = !1), t1.terrain && t1.terrain.prepareDrawTile(), m.activeTexture.set(_.TEXTURE0), L.bind(T, _.CLAMP_TO_EDGE), m.activeTexture.set(_.TEXTURE1), U ? (U.texture && U.texture.bind(T, _.CLAMP_TO_EDGE), j = Math.pow(2, U.tileID.overscaledZ - I.tileID.overscaledZ), V = [
                            I.tileID.canonical.x * j % 1,
                            I.tileID.canonical.y * j % 1
                        ]) : L.bind(T, _.CLAMP_TO_EDGE), "useMipmap" in L && m.extTextureFilterAnisotropic && t1.transform.pitch > 20 && _.texParameterf(_.TEXTURE_2D, m.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, m.extTextureFilterAnisotropicMax);
                        const G = t1.transform;
                        let q;
                        const $ = d ? Ba(G) : [
                            0,
                            0,
                            0,
                            0
                        ];
                        let Z, W, H, X, Y, K = 0;
                        if (p && g instanceof Uo && g.coordinates.length > 3) Z = Float32Array.from(e1.bf(e1.bg(new e1.c1(0, 0, 0)))), W = Float32Array.from(G.globeMatrix), H = Float32Array.from(e1.bh(G)), X = [
                            e1.ad(G.center.lng),
                            e1.ae(G.center.lat)
                        ], q = g.elevatedGlobePerspectiveTransform, Y = g.elevatedGlobeGridMatrix || new Float32Array(9);
                        else if (p) {
                            const t1 = e1.bd(S.canonical);
                            K = e1.be(t1.getCenter().lat), Z = Float32Array.from(e1.bf(e1.bg(S.canonical))), W = Float32Array.from(G.globeMatrix), H = Float32Array.from(e1.bh(G)), X = [
                                e1.ad(G.center.lng),
                                e1.ae(G.center.lat)
                            ], q = [
                                0,
                                0
                            ], Y = Float32Array.from(e1.bi(S.canonical, t1, K, G.worldSize / G._pixelsPerMercatorPixel));
                        } else q = g instanceof Uo ? g.perspectiveTransform : [
                            0,
                            0
                        ], Z = new Float32Array(16), W = new Float32Array(9), H = new Float32Array(16), X = [
                            0,
                            0
                        ], Y = new Float32Array(9);
                        const Q = lo(t1, k, Z, W, H, Y, V || [
                            0,
                            0
                        ], e1._(t1.transform.zoom), X, $, j || 1, N, s, q, c, 2, R, A, y.range, M, F, v), J = t1.isTileAffectedByFog(S), ee = t1.getOrCreateProgram("raster", {
                            defines: y.defines,
                            overrideFog: J
                        });
                        if (t1.uploadCommonUniforms(m, ee, r), g instanceof Uo) {
                            const i = C ? Lo.stencilModeWithRasterMask(t1, e1.a4.disabled) : e1.a4.disabled, r = g.elevatedGlobeVertexBuffer, n = g.elevatedGlobeIndexBuffer;
                            if (x || !l) g.boundsBuffer && g.boundsSegments && ee.draw(t1, _.TRIANGLES, O, i, b, e1.a5.disabled, Q, s.id, g.boundsBuffer, t1.quadTriangleIndexBuffer, g.boundsSegments);
                            else if (r && n) {
                                const a = G.zoom <= e1.ek ? g.elevatedGlobeSegments : g.getSegmentsForLongitude(G.center.lng);
                                a && ee.draw(t1, _.TRIANGLES, O, i, b, o, Q, s.id, r, n, a);
                            }
                        } else if (p) {
                            O = new e1.a3(_.LEQUAL, e1.a3.ReadOnly, t1.depthRangeFor3D);
                            const i = t1.globeSharedBuffers;
                            if (i) {
                                u && (t1.terrain.setupElevationDraw(I, ee), t1.uploadCommonUniforms(m, ee, I.tileID.toUnwrapped()));
                                const [e1, r, n] = i.getGridBuffers(K, !1), a = ee.getAttributeLocation(_, "a_texture_pos");
                                -1 !== a && _.vertexAttribI4ui(a, 0, 0, 0, 0), ee.draw(t1, _.TRIANGLES, O, h || B, t1.colorModeForRenderPass(), o, Q, s.id, e1, r, n);
                            }
                        } else if (f) O = new e1.a3(_.LEQUAL, e1.a3.ReadOnly, t1.depthRangeFor3D), t1.terrain.setupElevationDraw(I, ee), t1.uploadCommonUniforms(m, ee, I.tileID.toUnwrapped()), G.pitch > 20 && ee.draw(t1, _.TRIANGLES, O, e1.a4.disabled, e1.a7.disabled, e1.a5.frontCCW, Q, s.id, t1.terrain.gridBuffer, t1.terrain.gridIndexBuffer, t1.terrain.gridSegments), ee.draw(t1, _.TRIANGLES, O, B, b, e1.a5.backCCW, Q, s.id, t1.terrain.gridBuffer, t1.terrain.gridIndexBuffer, t1.terrain.gridSegments);
                        else {
                            const { tileBoundsBuffer: i, tileBoundsIndexBuffer: r, tileBoundsSegments: o } = t1.getTileBoundsBuffers(I);
                            ee.draw(t1, _.TRIANGLES, O, B, b, e1.a5.disabled, Q, s.id, i, r, o);
                        }
                    }
                    if (!(g instanceof Uo) && p) for (const n of r){
                        const r = n.canonical.y === (1 << n.canonical.z) - 1;
                        0 === n.canonical.y && ka(c, !0, n, t1, i, s, v, y, o, h || e1.a4.disabled), r && ka(c, !1, n, t1, i, s, v, y, o === e1.a5.frontCW ? e1.a5.backCW : e1.a5.frontCW, h || e1.a4.disabled);
                    }
                };
                p ? P(I, t1.renderElevatedRasterBackface ? e1.a5.backCW : e1.a5.frontCW, t1.stencilModeFor3D()) : (S && (Lo.renderRasterMask(t1, S), C = !0), P(I, e1.a5.disabled, void 0), C && (Lo.clearRasterMask(t1), C = !1)), t1.resetStencilClippingMasks();
            },
            background: function(t1, i, s, r) {
                const o = s.paint.get("background-color"), n = "none" === s.paint.get("background-color-use-theme").constantOr("default"), a = s.paint.get("background-opacity"), l = s.paint.get("background-emissive-strength"), c = "viewport" === s.paint.get("background-pitch-alignment");
                if (0 === a) return;
                const h = t1.context, d = h.gl, u = t1.transform, p = u.tileSize, f = s.paint.get("background-pattern");
                let m;
                if (void 0 !== f) {
                    if (null === f) return;
                    if (m = t1.imageManager.getPattern(e1.I.from(f.toString()), s.scope, t1.style.getLut(s.scope)), !m) return;
                }
                const _ = !f && 1 === o.a && 1 === a && t1.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                if (t1.renderPass !== _) return;
                const g = e1.a4.disabled, y = t1.depthModeForSublayer(0, "opaque" === _ ? e1.a3.ReadWrite : e1.a3.ReadOnly), v = t1.colorModeForDrapableLayerRenderPass(l), b = f ? "backgroundPattern" : "background";
                let x, w = r;
                w || (x = t1.getBackgroundTiles(), w = Object.values(x).map((e1)=>e1.tileID)), f && (h.activeTexture.set(d.TEXTURE0), t1.imageManager.bind(t1.context, s.scope));
                const T = [];
                if (t1.terrain && t1.terrain.renderingToTexture && t1.isEmissiveMrtActive() && (T.push("USE_MRT1"), "mrt-full-rgba" === t1.emissiveMode && T.push("USE_MRT1_RGBA")), c) {
                    const i = t1.getOrCreateProgram(b, {
                        overrideFog: !1,
                        overrideRtt: !0,
                        defines: T
                    }), r = Ua, h = new e1.bZ(0, 0, 0, 0, 0), u = f ? fo(r, l, a, t1, f, s.scope, m, c, {
                        tileID: h,
                        tileSize: p
                    }) : po(r, l, a, o.toPremultipliedRenderColor(n ? null : s.lut));
                    return void i.draw(t1, d.TRIANGLES, y, g, v, e1.a5.disabled, u, s.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments);
                }
                for (const _ of w){
                    const w = t1.isTileAffectedByFog(_), S = t1.getOrCreateProgram(b, {
                        overrideFog: w,
                        defines: T
                    }), C = _.toUnwrapped(), E = r ? _.projMatrix : t1.transform.calculateProjMatrix(C);
                    t1.prepareDrawTile();
                    const I = i ? i.getTile(_) : x ? x[_.key] : new _s(_, p, u.zoom, t1), D = f ? fo(E, l, a, t1, f, s.scope, m, c, {
                        tileID: _,
                        tileSize: p
                    }) : po(E, l, a, o.toPremultipliedRenderColor(n ? null : s.lut));
                    t1.uploadCommonUniforms(h, S, C);
                    const { tileBoundsBuffer: P, tileBoundsIndexBuffer: L, tileBoundsSegments: R } = t1.getTileBoundsBuffers(I);
                    S.draw(t1, d.TRIANGLES, y, g, v, e1.a5.disabled, D, s.id, P, L, R);
                }
            },
            sky: function(t1, i, s) {
                const r = t1._atmosphere ? e1._(t1.transform.zoom) : 1, o = s.paint.get("sky-opacity") * r;
                if (0 === o) return;
                const n = t1.context, a = s.paint.get("sky-type"), l = new e1.a3(n.gl.LEQUAL, e1.a3.ReadOnly, [
                    0,
                    1
                ]), c = t1.frameCounter / 1e3 % 1;
                "atmosphere" === a ? "offscreen" === t1.renderPass ? s.needsSkyboxCapture(t1) && (function(t1, i) {
                    const s = t1.context, r = s.gl;
                    let o = i.skyboxFbo;
                    if (!o) {
                        o = i.skyboxFbo = s.createFramebuffer(32, 32, 1, null), i.skyboxGeometry = new qa(s), i.skyboxTexture = s.gl.createTexture(), r.bindTexture(r.TEXTURE_CUBE_MAP, i.skyboxTexture), r.texParameteri(r.TEXTURE_CUBE_MAP, r.TEXTURE_WRAP_S, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_CUBE_MAP, r.TEXTURE_WRAP_T, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_CUBE_MAP, r.TEXTURE_MIN_FILTER, r.LINEAR), r.texParameteri(r.TEXTURE_CUBE_MAP, r.TEXTURE_MAG_FILTER, r.LINEAR);
                        for(let e1 = 0; e1 < 6; ++e1)r.texImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + e1, 0, r.RGBA, 32, 32, 0, r.RGBA, r.UNSIGNED_BYTE, null);
                    }
                    s.bindFramebuffer.set(o.framebuffer), s.viewport.set([
                        0,
                        0,
                        32,
                        32
                    ]);
                    const n = i.getCenter(t1, !0), a = t1.getOrCreateProgram("skyboxCapture"), l = new Float64Array(16);
                    e1.ep(l, .5 * -Math.PI), $a(t1, i, a, l, n, 0), e1.ep(l, .5 * Math.PI), $a(t1, i, a, l, n, 1), e1.eq(l, .5 * -Math.PI), $a(t1, i, a, l, n, 2), e1.eq(l, .5 * Math.PI), $a(t1, i, a, l, n, 3), e1.dk(l), $a(t1, i, a, l, n, 4), e1.ep(l, Math.PI), $a(t1, i, a, l, n, 5), s.viewport.set([
                        0,
                        0,
                        t1.width,
                        t1.height
                    ]);
                }(t1, s), s.markSkyboxValid(t1)) : "sky" === t1.renderPass && function(t1, i, s, r, o) {
                    const n = t1.context, a = n.gl, l = t1.transform, c = t1.getOrCreateProgram("skybox");
                    n.activeTexture.set(a.TEXTURE0), a.bindTexture(a.TEXTURE_CUBE_MAP, i.skyboxTexture);
                    const h = ((e1, t1, i, s, r)=>({
                            u_matrix: e1,
                            u_sun_direction: t1,
                            u_cubemap: 0,
                            u_opacity: s,
                            u_temporal_offset: r
                        }))(l.skyboxMatrix, i.getCenter(t1, !1), 0, r, o);
                    t1.uploadCommonUniforms(n, c), c.draw(t1, a.TRIANGLES, s, e1.a4.disabled, t1.colorModeForRenderPass(), e1.a5.backCW, h, "skybox", i.skyboxGeometry.vertexBuffer, i.skyboxGeometry.indexBuffer, i.skyboxGeometry.segment);
                }(t1, s, l, o, c) : "gradient" === a && "sky" === t1.renderPass && function(t1, i, s, r, o) {
                    const n = t1.context, a = n.gl, l = t1.transform, c = t1.getOrCreateProgram("skyboxGradient");
                    i.skyboxGeometry || (i.skyboxGeometry = new qa(n)), n.activeTexture.set(a.TEXTURE0);
                    let h = i.colorRampTexture;
                    h || (h = i.colorRampTexture = new e1.T(n, i.colorRamp, a.RGBA8)), h.bind(a.LINEAR, a.CLAMP_TO_EDGE);
                    const d = ((t1, i, s, r, o)=>({
                            u_matrix: t1,
                            u_color_ramp: 0,
                            u_center_direction: i,
                            u_radius: e1.aF(s),
                            u_opacity: r,
                            u_temporal_offset: o
                        }))(l.skyboxMatrix, i.getCenter(t1, !1), i.paint.get("sky-gradient-radius"), r, o);
                    t1.uploadCommonUniforms(n, c), c.draw(t1, a.TRIANGLES, s, e1.a4.disabled, t1.colorModeForRenderPass(), e1.a5.backCW, d, "skyboxGradient", i.skyboxGeometry.vertexBuffer, i.skyboxGeometry.indexBuffer, i.skyboxGeometry.segment);
                }(t1, s, l, o, c);
            },
            custom: function(t1, i, s, r) {
                const o = t1.context, n = s.implementation;
                if (t1.transform.projection.unsupportedLayers && t1.transform.projection.unsupportedLayers.includes("custom") && (!t1.terrain || !t1.terrain.renderingToTexture && "offscreen" !== t1.renderPass || !s.isDraped(i))) return void e1.w("Custom layers are not yet supported with this projection. Use mercator or globe to enable usage of custom layers.");
                const a = function(t1) {
                    if (t1._customRenderArgs && t1._customRenderArgsFrameCounter === t1.frameCounter) return t1._customRenderArgs;
                    const i = t1.transform;
                    let s = null, r = null;
                    if ("globe" === i.projection.name) {
                        const t1 = e1.em(i), o = e1.en(t1);
                        if (o > 0) {
                            const i = e1.dY([], t1, 1 / o);
                            s = [
                                i[0],
                                i[1],
                                i[2],
                                -e1.cT * e1.cT / o
                            ];
                        }
                        const n = i.projection.globeCenterToScreenPoint(i);
                        n && (r = [
                            n.x,
                            n.y
                        ]);
                    }
                    const o = {
                        projectionMatrix: new Float64Array(i.getCameraToClipMatrix()),
                        viewMatrix: new Float64Array(i.getWorldToCameraMatrix()),
                        globeClippingPlane: s,
                        globeCenterInScreenPixels: r
                    };
                    return t1._customRenderArgs = o, t1._customRenderArgsFrameCounter = t1.frameCounter, o;
                }(t1);
                if ("offscreen" === t1.renderPass) {
                    const i = n.prerender;
                    if (i) {
                        if (t1.setCustomLayerDefaults(), o.setColorMode(t1.colorModeForRenderPass()), "globe" === t1.transform.projection.name) {
                            const s = t1.transform.pointMerc;
                            i.call(n, o.gl, t1.transform.customLayerMatrix(), t1.transform.getProjection(), t1.transform.globeToMercatorMatrix(), e1._(t1.transform.zoom), [
                                s.x,
                                s.y
                            ], t1.transform.pixelsPerMeterRatio, a);
                        } else i.call(n, o.gl, t1.transform.customLayerMatrix(), void 0, void 0, void 0, void 0, void 0, a);
                        o.setDirty(), t1.setBaseState();
                    }
                } else if ("translucent" === t1.renderPass) {
                    if (t1.terrain && t1.terrain.renderingToTexture) {
                        const i = n.renderToTile;
                        if (i) {
                            const s = r[0].canonical, a = {
                                x: s.x + r[0].wrap * (n.wrapTileId ? 0 : 1 << s.z),
                                y: s.y,
                                z: s.z
                            };
                            o.setDepthMode(e1.a3.disabled), o.setStencilMode(e1.a4.disabled), o.setColorMode(t1.colorModeForRenderPass()), t1.setCustomLayerDefaults();
                            const l = Na[t1.emissiveMode], c = o.gl, h = n.supportsEmissiveMode, d = l && h && h.call(n, l);
                            t1.isEmissiveMrtActive() && !d && c.drawBuffers([
                                c.COLOR_ATTACHMENT0
                            ]), i.call(n, o.gl, a, l), t1.isEmissiveMrtActive() && !d && c.drawBuffers([
                                c.COLOR_ATTACHMENT0,
                                c.COLOR_ATTACHMENT1
                            ]), o.setDirty(), t1.setBaseState();
                        }
                        return;
                    }
                    t1.setCustomLayerDefaults(), o.setColorMode(t1.colorModeForRenderPass()), o.setStencilMode(e1.a4.disabled);
                    const i = "3d" === n.renderingMode ? new e1.a3(t1.context.gl.LEQUAL, e1.a3.ReadWrite, t1.depthRangeFor3D) : t1.depthModeForSublayer(0, e1.a3.ReadOnly);
                    if (o.setDepthMode(i), "globe" === t1.transform.projection.name) {
                        const i = t1.transform.pointMerc;
                        n.render(o.gl, t1.transform.customLayerMatrix(), t1.transform.getProjection(), t1.transform.globeToMercatorMatrix(), e1._(t1.transform.zoom), [
                            i.x,
                            i.y
                        ], t1.transform.pixelsPerMeterRatio, a);
                    } else n.render(o.gl, t1.transform.customLayerMatrix(), void 0, void 0, void 0, void 0, void 0, a);
                    o.setDirty(), t1.setBaseState(), o.bindFramebuffer.set(null);
                }
            }
        }, el = {
            line: function(e1, t1, i) {
                if (e1.hasElevatedBuckets = !1, e1.hasNonElevatedBuckets = !1, void 0 !== e1.getLayoutPropertyValue("line-elevation-reference").value || void 0 !== e1.getLayoutPropertyValue("line-z-offset").value) {
                    if (t1) {
                        const i = t1.getVisibleCoordinates();
                        for (const s of i){
                            const i = t1.getTile(s).getBucket(e1);
                            if (i && ("none" !== i.elevationType ? e1.hasElevatedBuckets = !0 : e1.hasNonElevatedBuckets = !0, e1.hasElevatedBuckets && e1.hasNonElevatedBuckets)) break;
                        }
                    }
                } else e1.hasNonElevatedBuckets = !0;
            },
            raster: function(e1, t1, i) {
                const s = t1.getSource();
                if ("raster-array" !== s.type || !s.loaded()) return;
                const r = e1.sourceLayer || s.rasterLayerIds && s.rasterLayerIds[0];
                if (!r) return;
                const o = e1.paint.get("raster-array-band") || s.getInitialBand(r);
                if (null == o) return;
                const n = t1.getIds().map((e1)=>t1.getTileByID(e1));
                for (const t1 of n)t1.updateNeeded(e1.id, o) && s.prepareTile(t1, r, e1.id, o);
            }
        };
        async function tl(e1) {
            if (await ui(), Object.assign(Ja, {
                model: di.drawModels
            }), Object.assign(el, {
                model: di.prepare
            }), e1 && !e1._destroyed && !e1._shadowRenderer) {
                const t1 = di.ShadowRenderer;
                t1 && (e1._shadowRenderer = new t1(e1));
            }
        }
        class il {
            constructor(t1, i, s, r, o, n){
                this._lightsUniforms = null, this._fogUniforms = null, this._forceFullRgbaEmissive = !1, this.context = new ya(t1, i), this._forceFullRgbaEmissive = "exact" === n, this.transform = s, this.cache = new Map, this._tileTextures = {}, this.frameCopies = [], this.loadTimeStamps = [], this.frcCoverageSnapshot = null, this.elevationCoverageSnapshot = null, this.elevationProvidersReady = void 0, this.frcCoverageFadeRange = null, this.frcCoverageSourceLayers = [], this.frcCoverageRenderer = Xs.FrcCoverageRenderer ? new Xs.FrcCoverageRenderer : null, this._debugParams = {
                    averageFPS: 0,
                    fpsHistory: [],
                    fpsWindow: 30,
                    continousRedraw: !1,
                    enabledLayers: {},
                    buildingsShowNormals: !1,
                    buildingsDrawGroundAO: !0,
                    buildingsDrawShadowPass: !0,
                    buildingsDrawTranslucentPass: !0,
                    showTerrainProxyTiles: !1,
                    terrainSortTilesHiZFirst: !0,
                    terrainDisableRenderCache: !1,
                    forceEnablePrecipitation: !1,
                    overrideSnowParams: !1,
                    snowParamsOverride: null,
                    snowRevealParamsOverride: null,
                    snowVignetteParamsOverride: null,
                    overrideRainParams: !1,
                    rainParamsOverride: null,
                    rainRevealParamsOverride: null,
                    rainVignetteParamsOverride: null,
                    overrideStarsParams: !1,
                    starsParamsOverride: null,
                    show3DModelFootprints: !1,
                    showElevationIdDebug: !1,
                    lodSwitchDistance: -1,
                    lodSwitchFadeDuration: .5
                }, this.occlusionParams = new Qa, this.setup(), this.numSublayers = bs.maxUnderzooming + bs.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.deferredRenderGpuTimeQueries = [], this.gpuTimers = {}, this.frameCounter = 0, this.frameTimeDelta = 0, this.lastPaintStartTimeStamp = 0, this._shadowCullCache = null, this._backgroundTiles = {}, this.depthPrepassPhase = !1, this._grouped3DDepthPrepassStart = -1, this._grouped3DDepthPrepassEnd = -1, this._grouped3DStencil = null, this.conflationActive = !1, this.replacementSource = new e1.eB, this.longestCutoffRange = 0, this.minCutoffZoom = 0, this._fogVisible = !1, this._cachedTileFogOpacities = new Map, this._wireframeDebugCache = new Ka, this.renderDefaultNorthPole = !0, this.renderDefaultSouthPole = !0, this.layersWithOcclusionOpacity = [];
                const a = new e1.b({
                    width: 1,
                    height: 1
                }, Uint8Array.of(0, 0, 0, 0));
                this.emptyDepthTexture = new e1.T(this.context, a, t1.RGBA8), this._clippingActiveLastFrame = !1, this.scaleFactor = r, this.maxFrontCutoffRawStart = 0, this.worldview = o, this._forceEmissiveMode = !1, this.emissiveMode = "constant";
            }
            updateTerrain(e1, t1) {
                const i = !!e1 && !!e1.terrain && this.transform.projection.supportsTerrain;
                var s;
                (i || this._terrain && this._terrain.enabled) && (this._terrain || (this._terrain = Jr(this, e1), this._terrain) ? (this.transform.elevation = i ? this._terrain : null, this._terrain.update(e1, this.transform, t1), this.transform.elevation && !this._terrain.enabled && (this.transform.elevation = null)) : this._terrainRendererRetryPending || (this._terrainRendererRetryPending = !0, s = ()=>{
                    this._terrainRendererRetryPending = !1, this.style && this.style.map && this.style.map._update(!1);
                }, Kr ? s() : Qr.push(s)));
            }
            _updateFog(e1) {
                const t1 = e1.fog;
                if (!t1 || "globe" === this.transform.projection.name || t1.getOpacity(this.transform.pitch) < 1 || t1.properties.get("horizon-blend") < .03) return void (this.transform.fogCullDistSq = null);
                const [i, s] = t1.getRangeForProjection();
                if (i > s) return void (this.transform.fogCullDistSq = null);
                const r = i + .78 * (s - i);
                this.transform.fogCullDistSq = r * r;
            }
            get terrain() {
                return this.transform._terrainEnabled() && this._terrain && this._terrain.enabled || this._forceTerrainMode ? this._terrain : null;
            }
            get forceTerrainMode() {
                return this._forceTerrainMode;
            }
            set forceTerrainMode(e1) {
                e1 && !this._terrain && (this._terrain = Jr(this, this.style), this._terrain || console.warn("forceTerrainMode: Lite module not loaded yet, terrain renderer unavailable")), this._forceTerrainMode = e1;
            }
            get shadowRenderer() {
                return this._shadowRenderer && this._shadowRenderer.enabled ? this._shadowRenderer : null;
            }
            get wireframeDebugCache() {
                return this._wireframeDebugCache;
            }
            resize(t1, i) {
                if (this.width = t1 * e1.e.devicePixelRatio, this.height = i * e1.e.devicePixelRatio, this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.style) for (const e1 of this.style.order)this.style._mergedLayers[e1].resize();
            }
            setup() {
                const t1 = this.context, i = new e1.bN;
                i.emplaceBack(0, 0), i.emplaceBack(e1.ac, 0), i.emplaceBack(0, e1.ac), i.emplaceBack(e1.ac, e1.ac), this.tileExtentBuffer = t1.createVertexBuffer(i, e1.bP.members), this.tileExtentSegments = e1.aj.simpleSegment(0, 0, 4, 2);
                const s = new e1.bN;
                s.emplaceBack(0, 0), s.emplaceBack(e1.ac, 0), s.emplaceBack(0, e1.ac), s.emplaceBack(e1.ac, e1.ac), this.debugBuffer = t1.createVertexBuffer(s, e1.bP.members), this.debugSegments = e1.aj.simpleSegment(0, 0, 4, 5);
                const r = new e1.bN;
                r.emplaceBack(-1, -1), r.emplaceBack(1, -1), r.emplaceBack(-1, 1), r.emplaceBack(1, 1), this.viewportBuffer = t1.createVertexBuffer(r, e1.bP.members), this.viewportSegments = e1.aj.simpleSegment(0, 0, 4, 2);
                const o = new e1.bD;
                o.emplaceBack(0, 0, 0, 0), o.emplaceBack(e1.ac, 0, e1.ac, 0), o.emplaceBack(0, e1.ac, 0, e1.ac), o.emplaceBack(e1.ac, e1.ac, e1.ac, e1.ac), this.mercatorBoundsBuffer = t1.createVertexBuffer(o, us.members), this.mercatorBoundsSegments = e1.aj.simpleSegment(0, 0, 4, 2);
                const n = new e1.ak;
                n.emplaceBack(0, 1, 2), n.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = t1.createIndexBuffer(n);
                const a = new e1.bO;
                for (const e1 of [
                    0,
                    1,
                    3,
                    2,
                    0
                ])a.emplaceBack(e1);
                this.debugIndexBuffer = t1.createIndexBuffer(a), this.emptyTexture = new e1.T(t1, new e1.b({
                    width: 1,
                    height: 1
                }, Uint8Array.of(0, 0, 0, 0)), t1.gl.RGBA8), this.identityMat = e1.a2();
                const l = this.context.gl;
                this.stencilClearMode = new e1.a4({
                    func: l.ALWAYS,
                    mask: 0
                }, 0, 255, l.ZERO, l.ZERO, l.ZERO), this.loadTimeStamps.push(performance.now());
            }
            getMercatorTileBoundsBuffers() {
                return {
                    tileBoundsBuffer: this.mercatorBoundsBuffer,
                    tileBoundsIndexBuffer: this.quadTriangleIndexBuffer,
                    tileBoundsSegments: this.mercatorBoundsSegments
                };
            }
            getTileBoundsBuffers(e1) {
                return e1._makeTileBoundsBuffers(this.context, this.transform.projection), e1._tileBoundsBuffer ? {
                    tileBoundsBuffer: e1._tileBoundsBuffer,
                    tileBoundsIndexBuffer: e1._tileBoundsIndexBuffer,
                    tileBoundsSegments: e1._tileBoundsSegments
                } : this.getMercatorTileBoundsBuffers();
            }
            clearStencil() {
                const t1 = this.context.gl;
                this.nextStencilID = 1, this.currentStencilSource = void 0, this._tileClippingMaskIDs = new Map, this._grouped3DStencil = null, this.getOrCreateProgram("clippingMask").draw(this, t1.TRIANGLES, e1.a3.disabled, this.stencilClearMode, e1.a7.disabled, e1.a5.disabled, Us(this.identityMat), "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
            }
            resetStencilClippingMasks() {
                this.terrain || (this.currentStencilSource = void 0, this._tileClippingMaskIDs = new Map);
            }
            _renderTileClippingMasks(t1, i, s) {
                if (!i || this.currentStencilSource === i.id || !t1.isTileClipped() || !s || 0 === s.length) return;
                if (this._tileClippingMaskIDs && !this.terrain) {
                    let e1 = !1;
                    for (const t1 of s)if (!this._tileClippingMaskIDs.has(t1.key)) {
                        e1 = !0;
                        break;
                    }
                    if (!e1) return;
                }
                this.currentStencilSource = i.id;
                const r = this.context, o = r.gl;
                this.nextStencilID + s.length - 1 > 253 && this.clearStencil(), r.setColorMode(e1.a7.disabled), r.setDepthMode(e1.a3.disabled);
                const n = this.getOrCreateProgram("clippingMask");
                this._tileClippingMaskIDs = new Map;
                for (const t1 of s){
                    const s = i.getTile(t1), r = this.nextStencilID++;
                    this._tileClippingMaskIDs.set(t1.key, r);
                    const { tileBoundsBuffer: a, tileBoundsIndexBuffer: l, tileBoundsSegments: c } = this.getTileBoundsBuffers(s);
                    n.draw(this, o.TRIANGLES, e1.a3.disabled, new e1.a4({
                        func: o.ALWAYS,
                        mask: 0
                    }, r, 255, o.KEEP, o.KEEP, o.REPLACE), e1.a7.disabled, e1.a5.disabled, Us(t1.projMatrix), "$clipping", a, l, c);
                }
            }
            stencilModeFor3D() {
                this.currentStencilSource = void 0, this.nextStencilID > 253 && this.clearStencil();
                const t1 = this.nextStencilID++, i = this.context.gl;
                return new e1.a4({
                    func: i.NOTEQUAL,
                    mask: 255
                }, t1, 255, i.KEEP, i.KEEP, i.REPLACE);
            }
            _beginGrouped3DDepthPrepass(e1, t1) {
                const i = this.currentLayer;
                if (!e1[i].hasBlended3DDepthPrepass()) return;
                const s = [];
                let r = i;
                for(let t1 = i; t1 < e1.length; t1++){
                    const i = e1[t1];
                    if (!i.isHidden(this.transform.zoom)) {
                        if (!i.hasBlended3DDepthPrepass() || s.includes(i.type)) break;
                        s.push(i.type), r = t1 + 1;
                    }
                }
                if (!(s.length < 2)) {
                    for(this._grouped3DDepthPrepassStart = i, this._grouped3DDepthPrepassEnd = r, this._grouped3DStencil = null, this.depthPrepassPhase = !0, this.currentLayer = i; this.currentLayer < r; this.currentLayer++){
                        const i = e1[this.currentLayer], s = this.style.getLayerSourceCache(i);
                        this.renderLayer(this, s, i, t1(i, s));
                    }
                    this.depthPrepassPhase = !1, this.currentLayer = i;
                }
            }
            hasGrouped3DDepthPrepass(e1) {
                return e1 >= this._grouped3DDepthPrepassStart && e1 < this._grouped3DDepthPrepassEnd;
            }
            stencilModeFor3DGroup(e1) {
                return this.hasGrouped3DDepthPrepass(e1) ? (this._grouped3DStencil || (this._grouped3DStencil = this.stencilModeFor3D()), this.currentStencilSource = void 0, this._grouped3DStencil) : this.stencilModeFor3D();
            }
            stencilModeForClipping(t1) {
                if (this.terrain) return this.terrain.stencilModeForRTTOverlap(t1);
                const i = this.context.gl, s = this._tileClippingMaskIDs.get(t1.key);
                return new e1.a4({
                    func: i.EQUAL,
                    mask: 255
                }, s, 0, i.KEEP, i.KEEP, i.REPLACE);
            }
            stencilConfigForOverlap(t1, i = 254) {
                const s = this.context.gl, r = t1.sort((e1, t1)=>t1.overscaledZ - e1.overscaledZ), o = r.at(-1).overscaledZ, n = r[0].overscaledZ - o + 1;
                if (n > 1) {
                    this.currentStencilSource = void 0, this.nextStencilID + n > i && this.clearStencil();
                    const t1 = {};
                    for(let i = 0; i < n; i++)t1[i + o] = new e1.a4({
                        func: s.GEQUAL,
                        mask: 255
                    }, i + this.nextStencilID, 255, s.KEEP, s.KEEP, s.REPLACE);
                    return this.nextStencilID += n, [
                        t1,
                        r
                    ];
                }
                return [
                    {
                        [o]: e1.a4.disabled
                    },
                    r
                ];
            }
            colorModeForRenderPass() {
                const t1 = this.context.gl;
                if (this._showOverdrawInspector) {
                    const i = 1 / 8;
                    return new e1.a7([
                        t1.CONSTANT_COLOR,
                        t1.ONE,
                        t1.CONSTANT_COLOR,
                        t1.ONE
                    ], new e1.C(i, i, i, 0), [
                        !0,
                        !0,
                        !0,
                        !0
                    ]);
                }
                return "opaque" === this.renderPass ? e1.a7.unblended : e1.a7.alphaBlended;
            }
            isEmissiveMrtActive() {
                return "mrt-fallback" === this.emissiveMode || "mrt-full-rgba" === this.emissiveMode;
            }
            colorModeForDrapableLayerRenderPass(t1) {
                const i = this.context.gl;
                return (()=>this.style && this.style.enable3dLights() && !!this._terrain && this._terrain.renderingToTexture)() && "translucent" === this.renderPass ? null != t1 && !this.isEmissiveMrtActive() || "constant" === this.emissiveMode ? new e1.a7([
                    i.ONE,
                    i.ONE_MINUS_SRC_ALPHA,
                    i.CONSTANT_ALPHA,
                    i.ONE_MINUS_SRC_ALPHA
                ], new e1.C(0, 0, 0, t1 ?? 0), [
                    !0,
                    !0,
                    !0,
                    !0
                ]) : "dual-source-blending" === this.emissiveMode ? new e1.a7([
                    i.ONE,
                    i.ONE_MINUS_SRC_ALPHA,
                    this.context.extBlendFuncExtended.SRC1_ALPHA_WEBGL,
                    i.ONE_MINUS_SRC_ALPHA
                ], e1.C.transparent, [
                    !0,
                    !0,
                    !0,
                    !0
                ]) : this.colorModeForRenderPass() : this.colorModeForRenderPass();
            }
            depthModeForSublayer(t1, i, s, r = !1) {
                if (this.depthOcclusion) return new e1.a3(this.context.gl.GREATER, e1.a3.ReadOnly, this.depthRangeFor3D);
                if (!this.opaquePassEnabledForLayer() && !r) return e1.a3.disabled;
                const o = 1 - ((1 + this.currentLayer) * this.numSublayers + t1) * this.depthEpsilon;
                return new e1.a3(s || this.context.gl.LEQUAL, i, [
                    o,
                    o
                ]);
            }
            opaquePassEnabledForLayer() {
                return this.currentLayer < this.opaquePassCutoff;
            }
            blitDepth() {
                const t1 = this.context.gl, i = Math.ceil(this.width), s = Math.ceil(this.height), r = this.context.bindFramebuffer.get(), o = t1.getParameter(t1.TEXTURE_BINDING_2D);
                this.depthFBO && this.depthFBO.width === i && this.depthFBO.height === s || (this.depthFBO && (this.depthFBO.destroy(), this.depthFBO = void 0, this.depthTexture = void 0), 0 !== i && 0 !== s && (this.depthFBO = new ga(this.context, i, s, 0, "texture"), this.depthTexture = new e1.T(this.context, {
                    width: i,
                    height: s,
                    data: null
                }, t1.DEPTH24_STENCIL8), this.depthFBO.depthAttachment.set(this.depthTexture.texture))), this.context.bindFramebuffer.set(r), t1.bindTexture(t1.TEXTURE_2D, o), this.depthFBO && (t1.bindFramebuffer(t1.READ_FRAMEBUFFER, null), t1.bindFramebuffer(t1.DRAW_FRAMEBUFFER, this.depthFBO.framebuffer), t1.blitFramebuffer(0, 0, i, s, 0, 0, i, s, t1.DEPTH_BUFFER_BIT, t1.NEAREST), t1.bindFramebuffer(t1.FRAMEBUFFER, this.context.bindFramebuffer.current));
            }
            render(t1, i) {
                this.context.sweepPendingPrograms(), this.frameTimeDelta = 0 === this.lastPaintStartTimeStamp ? 0 : i.paintStartTimeStamp - this.lastPaintStartTimeStamp, this.lastPaintStartTimeStamp = i.paintStartTimeStamp, this._wireframeDebugCache.update(this.frameCounter), this.style = t1, this.options = i;
                const { directionalLight: s, ambientLight: r } = t1;
                this._lightsUniforms = t1.enable3dLights() && s && r ? ca(s, r, t1) : null;
                const o = this.transform;
                this._fogUniforms = t1.fog ? ((t1, i, s, r, o, n, a, l, c, h)=>{
                    const d = t1.transform, u = "none" === i.properties.get("color-use-theme"), p = i.properties.get("color").toNonPremultipliedRenderColor(u ? null : t1.style.getLut(i.scope)).toArray01();
                    p[3] = s;
                    const f = t1.frameCounter / 1e3 % 1, [m, _] = i.properties.get("vertical-range");
                    return {
                        u_fog_matrix: t1.identityMat,
                        u_fog_range: i.getRangeForProjection(),
                        u_fog_color: p,
                        u_fog_horizon_blend: i.properties.get("horizon-blend"),
                        u_fog_vertical_limit: [
                            Math.min(m, _),
                            _
                        ],
                        u_fog_temporal_offset: f,
                        u_frustum_tl: r,
                        u_frustum_tr: o,
                        u_frustum_br: n,
                        u_frustum_bl: a,
                        u_globe_pos: l,
                        u_globe_radius: c,
                        u_viewport: h,
                        u_globe_transition: e1._(d.zoom),
                        u_is_globe: +("globe" === d.projection.name)
                    };
                })(this, t1.fog, t1.fog.getOpacity(o.pitch), o.frustumCorners.TL, o.frustumCorners.TR, o.frustumCorners.BR, o.frustumCorners.BL, o.globeCenterInViewSpace, o.globeRadius, [
                    this.width,
                    this.height
                ]) : null, this.frcCoverageSnapshot && !this.frcCoverageSnapshot.empty() && (!this.frcCoverageRenderer && Xs.FrcCoverageRenderer && (this.frcCoverageRenderer = new Xs.FrcCoverageRenderer), this.frcCoverageRenderer && this.frcCoverageRenderer.update(this.context, this.frcCoverageSnapshot.tiles));
                const n = this.style._mergedLayers, a = !(!this.terrain || !this.terrain.enabled), l = ()=>this.style._getOrder(a);
                let c = l(), h = !1, d = !1, u = null, p = 0, f = !1;
                for (const e1 of c){
                    const t1 = n[e1];
                    "none" !== t1.visibility && ("circle" === t1.type ? h = !0 : "building" === t1.type ? (u = t1, ++p) : "symbol" === t1.type && (t1.hasOcclusionOpacityProperties ? d = !0 : h = !0));
                }
                this.updateEmissiveMode();
                let m = c.map((e1)=>n[e1]);
                const _ = this.style._mergedSourceCaches;
                this.imageManager = t1.imageManager, this.modelManager = t1.modelManager, this.now = e1.e.now(), this.symbolFadeChange = t1.placement ? t1.placement.symbolFadeChange(this.now) : 1, this.imageManager.beginFrame();
                for(const e1 in _){
                    const t1 = _[e1];
                    t1.used && (t1.prepare(this.context), t1.getSource().usedInConflation && ++p);
                }
                let g = !1;
                for (const e1 of m)e1.isHidden(this.transform.zoom) || ("clip" === e1.type && (g = !0), this.prepareLayer(e1));
                const y = {}, v = {}, b = {}, x = {}, w = {};
                for(const e1 in _){
                    const t1 = _[e1];
                    y[e1] = t1.getVisibleCoordinates(), v[e1] = y[e1].slice().reverse(), b[e1] = t1.getVisibleCoordinates(!0).reverse(), x[e1] = t1.getShadowCasterCoordinates(), w[e1] = t1.sortCoordinatesByDistance(y[e1]);
                }
                const T = (e1)=>{
                    const t1 = this.style.getLayerSourceCache(e1);
                    return t1 && t1.used ? t1.getSource() : null;
                };
                if (p || g || this._clippingActiveLastFrame) {
                    const t1 = [], i = [];
                    let s = 0;
                    for (const e1 of m)this.isSourceForClippingOrConflation(e1, T(e1)) && (t1.push(e1), i.push(s)), s++;
                    if (t1 && (g || t1.length > 1) || this._clippingActiveLastFrame) {
                        g = !1;
                        const s = [];
                        for(let r = 0; r < t1.length; r++){
                            const o = t1[r], n = i[r], a = this.style.getLayerSourceCache(o);
                            if (!a || !a.used || !a.getSource().usedInConflation && "clip" !== o.type && "building" !== o.type) continue;
                            let l = e1.eC, c = e1.dt.None;
                            const h = [];
                            let d = !0;
                            if ("building" === o.type) l = e1.eG;
                            else if ("clip" === o.type) {
                                if (l = n, o.isHidden(this.transform.zoom)) d = !1;
                                else {
                                    if (!o.layout) {
                                        d = !1;
                                        continue;
                                    }
                                    for (const t1 of o.layout.get("clip-layer-types"))c |= "model" === t1 ? e1.dt.Model : "symbol" === t1 ? e1.dt.Symbol : e1.dt.FillExtrusion;
                                    for (const t1 of o.layout.get("clip-layer-scope"))h.push(e1.m(t1, o.scope));
                                    g = !0;
                                }
                            }
                            d && s.push({
                                layer: o.fqid,
                                cache: a,
                                order: l,
                                clipMask: c,
                                clipScope: h
                            });
                        }
                        this.replacementSource.setSources(s), f = !0;
                    }
                }
                this._clippingActiveLastFrame = g, f || this.replacementSource.clear(), this.conflationActive = f, this.minCutoffZoom = 0, this.longestCutoffRange = 0, this.maxFrontCutoffRawStart = 0, this.opaquePassCutoff = 1 / 0, this._lastOcclusionLayer = -1, this.layersWithOcclusionOpacity = [];
                for(let e1 = 0; e1 < m.length; e1++){
                    const t1 = m[e1];
                    if ("none" === t1.visibility) continue;
                    const i = t1.cutoffRange();
                    if (this.longestCutoffRange = Math.max(i, this.longestCutoffRange), i > 0) {
                        const e1 = T(t1);
                        e1 && (this.minCutoffZoom = Math.max(e1.minzoom, this.minCutoffZoom)), t1.minzoom && (this.minCutoffZoom = Math.max(t1.minzoom, this.minCutoffZoom));
                    }
                    t1.is3D(a) && (this.opaquePassCutoff === 1 / 0 && (this.opaquePassCutoff = e1), this._lastOcclusionLayer = e1);
                }
                const S = this.style && this.style.fog;
                S ? (this._fogVisible = 0 !== S.getOpacity(this.transform.pitch), this._fogVisible && "globe" !== this.transform.projection.name && (this._fogVisible = S.isVisibleOnFrustum(this.transform.cameraFrustum))) : this._fogVisible = !1, this._cachedTileFogOpacities.clear(), this.terrain && (this.terrain.updateTileBinding(b), this.opaquePassCutoff = 0, c = l(), m = c.map((e1)=>n[e1])), this.style.enable3dLights() && !this._shadowRenderer && tl(this);
                const C = this._shadowRenderer;
                if (C) {
                    C.updateShadowParameters(this.transform, this.style.directionalLight, x);
                    for(const e1 in _)for (const t1 of y[e1]){
                        let e1 = {
                            min: 0,
                            max: 0
                        };
                        this.terrain && (e1 = this.terrain.getMinMaxForTile(t1) || e1), C.addShadowReceiver(t1.toUnwrapped(), e1.min, e1.max);
                    }
                }
                "globe" !== this.transform.projection.name || this.globeSharedBuffers || (this.globeSharedBuffers = new e1.eD(this.context)), this.style.fog && this.transform.projection.supportsFog ? (this._atmosphere || (this._atmosphere = new Xa), this._atmosphere.update(this)) : this._atmosphere && (this._atmosphere.destroy(), this._atmosphere = void 0);
                let E = !(!this.style || !this.style.snow), I = !(!this.style || !this.style.rain);
                if (E && !this._snow && Xs.Snow && (this._snow = new Xs.Snow), !E && this._snow && (this._snow.destroy(), delete this._snow), I && !this._rain && Xs.Rain && (this._rain = new Xs.Rain), !I && this._rain && (this._rain.destroy(), delete this._rain), this._snow && this._snow.update(this), this._rain && this._rain.update(this), u && (!this.buildingTileBorderManager && Xs.BuildingTileBorderManager && (this.buildingTileBorderManager = new Xs.BuildingTileBorderManager), this.buildingTileBorderManager)) {
                    const e1 = this.style.getLayerSourceCache(u);
                    this.buildingTileBorderManager.updateBorders(e1, u);
                }
                if (!e1.eE(this.context.gl)) return;
                this.renderPass = "offscreen";
                for (const e1 of m){
                    const i = t1.getLayerSourceCache(e1);
                    if (!e1.hasOffscreenPass() || e1.isHidden(this.transform.zoom)) continue;
                    const s = i ? v[i.id] : void 0;
                    ("custom" === e1.type || "raster" === e1.type || "raster-particle" === e1.type || e1.isSky() || s && s.length) && this.renderLayer(this, i, e1, s);
                }
                this.depthRangeFor3D = [
                    0,
                    1 - (m.length + 2) * this.numSublayers * this.depthEpsilon
                ], this._shadowRenderer && (this.renderPass = "shadow", this._shadowRenderer.drawShadowPass(this.style, x)), this.context.bindFramebuffer.set(null), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]);
                const D = "globe" === this.transform.projection.name || this.transform.isHorizonVisible(), P = (()=>{
                    if (i.showOverdrawInspector) return e1.C.black;
                    const t1 = this.style.fog;
                    if (t1 && this.transform.projection.supportsFog) {
                        const i = this.style.getLut(t1.scope);
                        if (!D) {
                            const s = "none" === t1.properties.get("color-use-theme"), r = t1.properties.get("color").toNonPremultipliedRenderColor(s ? null : i).toArray01();
                            return new e1.C(...r);
                        }
                        if (D) {
                            const s = "none" === t1.properties.get("space-color-use-theme"), r = t1.properties.get("space-color").toNonPremultipliedRenderColor(s ? null : i).toArray01();
                            return new e1.C(...r);
                        }
                    }
                    return e1.C.transparent;
                })();
                if (this.context.clear({
                    color: P,
                    depth: 1
                }), this.clearStencil(), this._showOverdrawInspector = i.showOverdrawInspector, this.renderPass = "opaque", this.style.fog && this.transform.projection.supportsFog && this._atmosphere && !this._showOverdrawInspector && D && this._atmosphere.drawStars(this, this.style.fog), !this.terrain) for(this.currentLayer = c.length - 1; this.currentLayer >= 0; this.currentLayer--){
                    const e1 = m[this.currentLayer], i = t1.getLayerSourceCache(e1);
                    if (e1.isSky()) continue;
                    const s = i ? (e1.is3D(a) ? w : v)[i.id] : void 0;
                    this._renderTileClippingMasks(e1, i, s), this.renderLayer(this, i, e1, s);
                }
                if (this.style.fog && this.transform.projection.supportsFog && this._atmosphere && !this._showOverdrawInspector && D && this._atmosphere.drawAtmosphereGlow(this, this.style.fog), this.renderPass = "sky", (!this._atmosphere || e1._(this.transform.zoom) > 0) && ("globe" === this.transform.projection.name || this.transform.isHorizonVisible())) for(this.currentLayer = 0; this.currentLayer < c.length; this.currentLayer++){
                    const e1 = m[this.currentLayer], i = t1.getLayerSourceCache(e1);
                    e1.isSky() && this.renderLayer(this, i, e1, i ? v[i.id] : void 0);
                }
                function L(e1, t1) {
                    let i;
                    return t1 && (i = ("symbol" === e1.type ? b : e1.is3D(a) ? w : v)[t1.id]), i;
                }
                if (this.renderPass = "translucent", "globe" === this.transform.projection.name) {
                    for(this.renderElevatedRasterBackface = !0, this.currentLayer = 0; this.currentLayer < c.length;){
                        const e1 = m[this.currentLayer];
                        if ("raster" === e1.type || "raster-particle" === e1.type) {
                            const i = t1.getLayerSourceCache(e1);
                            this.renderLayer(this, i, e1, L(e1, i));
                        }
                        ++this.currentLayer;
                    }
                    this.renderElevatedRasterBackface = !1;
                }
                this.currentLayer = 0, this.firstLightBeamLayer = Number.MAX_SAFE_INTEGER, this.depthPrepassPhase = !1, this._grouped3DDepthPrepassStart = -1, this._grouped3DDepthPrepassEnd = -1, this._grouped3DStencil = null;
                const R = C ? C.getGroundShadowLayerIndex() : -1;
                let A = !1, M = -1;
                for(let e1 = 0; e1 < c.length; ++e1){
                    const t1 = m[e1];
                    t1.isHidden(this.transform.zoom) || t1.is3D(a) && (M = e1);
                }
                d && -1 === M && (h = !0);
                let F = !1;
                for(; this.currentLayer < c.length;){
                    const e1 = m[this.currentLayer], i = t1.getLayerSourceCache(e1);
                    if (e1.isSky()) ++this.currentLayer;
                    else if (this.terrain && this.style.isLayerDraped(e1)) {
                        if (e1.isHidden(this.transform.zoom)) {
                            ++this.currentLayer;
                            continue;
                        }
                        this.currentLayer = this.terrain.renderBatch(this.currentLayer), this._lastOcclusionLayer = Math.max(this.currentLayer, this._lastOcclusionLayer);
                    } else {
                        if (!F && e1.is3D(a) && !a) {
                            const e1 = this.currentLayer, t1 = (e1)=>{
                                for(this.currentLayer = 0; this.currentLayer < m.length; this.currentLayer++){
                                    const t1 = m[this.currentLayer];
                                    if ("fill" === t1.type && Xs.drawDepthPrepass) {
                                        const i = this.style.getLayerSourceCache(t1);
                                        Xs.drawDepthPrepass(this, i, t1, L(t1, i), e1);
                                    }
                                }
                            };
                            t1("initialize"), t1("reset"), this.currentLayer = e1, F = !0;
                        }
                        if (h && !A && this.terrain && !this.transform.isOrthographic && (A = !0, this.blitDepth()), d && -1 !== M && this.currentLayer === M + 1 && !this.transform.isOrthographic && this.blitDepth(), !a && this._grouped3DDepthPrepassEnd <= this.currentLayer && this._beginGrouped3DDepthPrepass(m, L), this.terrain || this._renderTileClippingMasks(e1, i, i ? y[i.id] : void 0), this.renderLayer(this, i, e1, L(e1, i)), !this.terrain && C && this.currentLayer === R) {
                            {
                                this.clearStencil(), this.resetStencilClippingMasks();
                                const e1 = this.currentLayer;
                                for(this.currentLayer = 0; this.currentLayer < m.length; this.currentLayer++){
                                    const e1 = m[this.currentLayer];
                                    if ("fill" === e1.type && Xs.drawGroundShadowMask) {
                                        const t1 = this.style.getLayerSourceCache(e1);
                                        Xs.drawGroundShadowMask(this, t1, e1, L(e1, t1));
                                    }
                                }
                                this.currentLayer = e1;
                            }
                            if (C.drawGroundShadows(), this.firstLightBeamLayer <= this.currentLayer) {
                                const e1 = this.currentLayer;
                                for(this.renderPass = "light-beam", this.currentLayer = this.firstLightBeamLayer; this.currentLayer <= e1; this.currentLayer++){
                                    const e1 = m[this.currentLayer];
                                    if (!e1.hasLightBeamPass()) continue;
                                    const i = t1.getLayerSourceCache(e1);
                                    this.renderLayer(this, i, e1, i ? v[i.id] : void 0);
                                }
                                this.currentLayer = e1, this.renderPass = "translucent";
                            }
                        }
                        if (this.currentLayer >= this._lastOcclusionLayer && this.layersWithOcclusionOpacity.length > 0) {
                            const e1 = this.currentLayer;
                            this.depthOcclusion = !0;
                            for (const e1 of this.layersWithOcclusionOpacity){
                                this.currentLayer = e1;
                                const i = m[this.currentLayer], s = t1.getLayerSourceCache(i), r = s ? v[s.id] : void 0;
                                this.terrain || this._renderTileClippingMasks(i, s, s ? y[s.id] : void 0), this.renderLayer(this, s, i, r);
                            }
                            this.depthOcclusion = !1, this.currentLayer = e1, this.renderPass = "translucent", this.layersWithOcclusionOpacity = [];
                        }
                        ++this.currentLayer;
                    }
                }
                if (this.terrain && this.terrain.postRender(), this._snow && this._snow.draw(this), this._rain && this._rain.draw(this), this.options.showTileBoundaries || this.options.showQueryGeometry || this.options.showTileAABBs) {
                    let i = null;
                    m.forEach((e1)=>{
                        const s = t1.getLayerSourceCache(e1);
                        s && !e1.isHidden(this.transform.zoom) && s.getVisibleCoordinates().length && (!i || i.getSource().maxzoom < s.getSource().maxzoom) && (i = s);
                    }), i && this.options.showTileBoundaries && wt.drawDebug && wt.drawDebug(this, i, i.getVisibleCoordinates(), e1.C.red, !1, this.options.showParseStatus);
                }
                this.options.showPadding && wt.drawDebugPadding && wt.drawDebugPadding(this), wt.drawPlacementDebug && wt.drawPlacementDebug(this), this.context.setDefault(), this.frameCounter = (this.frameCounter + 1) % Number.MAX_SAFE_INTEGER, this.tileLoaded && this.options.speedIndexTiming && (this.loadTimeStamps.push(performance.now()), this.saveCanvasCopy()), f || (this.conflationActive = !1);
            }
            prepareLayer(e1) {
                this.gpuTimingStart(e1);
                const { unsupportedLayers: t1 } = this.transform.projection, i = !t1 || !t1.includes(e1.type);
                if (el[e1.type] && (i || this.terrain && "custom" === e1.type)) {
                    const t1 = this.style.getLayerSourceCache(e1);
                    el[e1.type](e1, t1, this);
                }
                this.gpuTimingEnd();
            }
            renderLayer(e1, t1, i, s) {
                i.isHidden(this.transform.zoom) || ("background" === i.type || "sky" === i.type || "custom" === i.type || "model" === i.type || "raster" === i.type || "raster-particle" === i.type || s && s.length) && (this.id = i.id, this.gpuTimingStart(i), (!e1.transform.projection.unsupportedLayers || !e1.transform.projection.unsupportedLayers.includes(i.type) || e1.terrain && "custom" === i.type) && "clip" !== i.type && "slot" !== i.type && "placement-group" !== i.type && Ja[i.type] && Ja[i.type](e1, t1, i, s, this.style.placement ? this.style.placement.variableOffsets : {}, this.options.isInitialLoad), Ja[i.type] || (i.mayUse("HD") && async function() {
                    await Ys(), Object.assign(Ja, {
                        building: Xs.drawBuilding,
                        "raster-particle": Xs.drawRasterParticle
                    }), Object.assign(el, {
                        "raster-particle": Xs.prepareRasterParticle
                    });
                }(), i.mayUse("Standard") && tl(e1)), this.gpuTimingEnd());
            }
            gpuTimingStart(e1) {
                if (!this.options.gpuTiming) return;
                const t1 = this.context.extTimerQuery, i = this.context.gl;
                let s = this.gpuTimers[e1.id];
                s || (s = this.gpuTimers[e1.id] = {
                    calls: 0,
                    cpuTime: 0,
                    query: i.createQuery()
                }), s.calls++, i.beginQuery(t1.TIME_ELAPSED_EXT, s.query);
            }
            gpuTimingDeferredRenderStart() {
                if (this.options.gpuTimingDeferredRender) {
                    const e1 = this.context.extTimerQuery, t1 = this.context.gl, i = t1.createQuery();
                    this.deferredRenderGpuTimeQueries.push(i), t1.beginQuery(e1.TIME_ELAPSED_EXT, i);
                }
            }
            gpuTimingDeferredRenderEnd() {
                this.options.gpuTimingDeferredRender && this.context.gl.endQuery(this.context.extTimerQuery.TIME_ELAPSED_EXT);
            }
            gpuTimingEnd() {
                this.options.gpuTiming && this.context.gl.endQuery(this.context.extTimerQuery.TIME_ELAPSED_EXT);
            }
            collectGpuTimers() {
                const e1 = this.gpuTimers;
                return this.gpuTimers = {}, e1;
            }
            collectDeferredRenderGpuQueries() {
                const e1 = this.deferredRenderGpuTimeQueries;
                return this.deferredRenderGpuTimeQueries = [], e1;
            }
            queryGpuTimers(e1) {
                const t1 = {};
                for(const i in e1){
                    const s = e1[i], r = this.context.extTimerQuery, o = r.getQueryParameter(s.query, this.context.gl.QUERY_RESULT) / 1e6;
                    r.deleteQueryEXT(s.query), t1[i] = o;
                }
                return t1;
            }
            queryGpuTimeDeferredRender(e1) {
                if (!this.options.gpuTimingDeferredRender) return 0;
                const t1 = this.context.gl;
                let i = 0;
                for (const s of e1)i += t1.getQueryParameter(s, t1.QUERY_RESULT) / 1e6, t1.deleteQuery(s);
                return i;
            }
            translatePosMatrix(t1, i, s, r, o) {
                if (!s[0] && !s[1]) return t1;
                const n = o ? "map" === r ? this.transform.angle : 0 : "viewport" === r ? -this.transform.angle : 0;
                if (n) {
                    const e1 = Math.sin(n), t1 = Math.cos(n);
                    s = [
                        s[0] * t1 - s[1] * e1,
                        s[0] * e1 + s[1] * t1
                    ];
                }
                const a = [
                    o ? s[0] : e1.ck(i, s[0], this.transform.zoom),
                    o ? s[1] : e1.ck(i, s[1], this.transform.zoom),
                    0
                ], l = new Float32Array(16);
                return e1.bX(l, t1, a), l;
            }
            saveTileTexture(e1) {
                if (e1.context !== this.context) return;
                const t1 = e1.size[0], i = this._tileTextures[t1];
                i ? i.push(e1) : this._tileTextures[t1] = [
                    e1
                ];
            }
            getTileTexture(e1) {
                const t1 = this._tileTextures[e1];
                return t1 && t1.length > 0 ? t1.pop() : null;
            }
            terrainRenderModeElevated() {
                return this.style && this.style.hasTerrain() && !!this.terrain && !this.terrain.renderingToTexture || this.forceTerrainMode;
            }
            linearFloatFilteringSupported() {
                return null != this.context.extTextureFloatLinear;
            }
            currentGlobalDefines(e1, t1, i, s, r) {
                const o = void 0 === i ? !!this._terrain && this._terrain.renderingToTexture : i, n = void 0 === s ? this.terrainRenderModeElevated() : s, a = void 0 === r ? "globe" === this.transform.projection.name : r, l = [];
                return this.style && this.style.enable3dLights() && ("globeRaster" === e1 || "terrainRaster" === e1 ? (l.push("LIGHTING_3D_MODE"), l.push("LIGHTING_3D_ALPHA_EMISSIVENESS"), "mrt-full-rgba" === this.emissiveMode && l.push("USE_MRT1_RGBA")) : o || l.push("LIGHTING_3D_MODE")), n && (l.push("TERRAIN"), this.linearFloatFilteringSupported() && l.push("TERRAIN_DEM_FLOAT_FORMAT")), a && l.push("GLOBE"), !this._fogVisible || o || void 0 !== t1 && !t1 || l.push("FOG"), o && l.push("RENDER_TO_TEXTURE"), this._showOverdrawInspector && l.push("OVERDRAW_INSPECTOR"), l;
            }
            getOrCreateProgram(e1, t1) {
                const { defines: i, config: s, overrideFog: r, overrideRtt: o, overrideTerrain: n, overrideGlobe: a, precompiled: l } = t1 || {}, c = this.currentGlobalDefines(e1, r, o, n, a), h = this.getShaderSource(e1), d = pa.cacheKey(h, e1, c, i, s);
                let u = this.cache.get(d);
                if (!u) {
                    const t1 = Xs.programUniforms, r = di.programUniforms, o = mo[e1] || t1 && t1[e1] || r && r[e1], n = i ? c.concat(i) : c;
                    u = new pa(this.context, e1, h, s, o, n, l), this.cache.set(d, u);
                }
                return u;
            }
            getShaderSource(t1) {
                const i = Xs.shaders, s = di.shaders, r = go.shaders;
                return e1.eF[t1] || i && i[t1] || s && s[t1] || r && r[t1];
            }
            setCustomLayerDefaults() {
                this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.frontFace.setDefault(), this.context.cullFaceSide.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
            }
            setBaseState() {
                const e1 = this.context.gl;
                this.context.cullFace.set(!1), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.context.blendEquation.set(e1.FUNC_ADD);
            }
            initDebugOverlayCanvas() {
                null == this.debugOverlayCanvas && (this.debugOverlayCanvas = document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new e1.T(this.context, this.debugOverlayCanvas, this.context.gl.RGBA8));
            }
            destroy() {
                this._terrain && this._terrain.destroy(), this._atmosphere && (this._atmosphere.destroy(), this._atmosphere = void 0), this.globeSharedBuffers && this.globeSharedBuffers.destroy(), this.emptyTexture.destroy(), this.debugOverlayTexture && this.debugOverlayTexture.destroy(), this._wireframeDebugCache.destroy(), this.depthFBO && (this.depthFBO.destroy(), this.depthFBO = void 0, this.depthTexture = void 0), this.emptyDepthTexture && this.emptyDepthTexture.destroy(), this._destroyed = !0;
            }
            prepareDrawTile() {
                this.terrain && this.terrain.prepareDrawTile();
            }
            uploadCommonLightUniforms(e1, t1, i) {
                const s = i && this._lightsUniforms ? ca(this.style.directionalLight, this.style.ambientLight, this.style, i) : this._lightsUniforms;
                s && t1.setLightsUniformValues(e1, s);
            }
            uploadCommonUniforms(e1, t1, i, s, r, o) {
                if (this.uploadCommonLightUniforms(e1, t1, o), this.terrain && this.terrain.renderingToTexture) return;
                const n = this._fogUniforms;
                n && (n.u_fog_matrix = i ? this.transform.calculateFogTileMatrix(i) : s || this.identityMat, t1.setFogUniformValues(e1, n)), r && t1.setCutoffUniformValues(e1, r.uniformValues);
            }
            setTileLoadedFlag(e1) {
                this.tileLoaded = e1;
            }
            saveCanvasCopy() {
                const e1 = this.canvasCopy();
                e1 && (this.frameCopies.push(e1), this.tileLoaded = !1);
            }
            canvasCopy() {
                const e1 = this.context.gl, t1 = e1.createTexture();
                return e1.bindTexture(e1.TEXTURE_2D, t1), e1.copyTexImage2D(e1.TEXTURE_2D, 0, e1.RGBA, 0, 0, e1.drawingBufferWidth, e1.drawingBufferHeight, 0), t1;
            }
            getCanvasCopiesAndTimestamps() {
                return {
                    canvasCopies: this.frameCopies,
                    timeStamps: this.loadTimeStamps
                };
            }
            averageElevationNeedsEasing() {
                if (!this.transform._elevation) return !1;
                const e1 = this.style && this.style.fog;
                return !!e1 && 0 !== e1.getOpacity(this.transform.pitch);
            }
            getBackgroundTiles() {
                const e1 = this._backgroundTiles, t1 = this._backgroundTiles = {}, i = this.transform.coveringTiles({
                    tileSize: 512
                });
                for (const s of i)t1[s.key] = e1[s.key] || new _s(s, 512, this.transform.tileZoom, this, void 0, this.worldview);
                return t1;
            }
            clearBackgroundTiles() {
                this._backgroundTiles = {};
            }
            isSourceForClippingOrConflation(e1, t1) {
                return !(!e1.is3D(!(!this.terrain || !this.terrain.enabled)) || "clip" !== e1.type && "building" !== e1.type && (e1.minzoom && e1.minzoom > this.transform.zoom || (this.style._clipLayerPresent || "building" !== e1.sourceLayer && "procedural_buildings" !== e1.sourceLayer) && (!t1 || "batched-model" !== t1.type)));
            }
            isTileAffectedByFog(t1) {
                if (!this._fogVisible) return !1;
                if ("globe" === this.transform.projection.name) return !0;
                let i = this._cachedTileFogOpacities.get(t1.key);
                return i || (i = this.style.fog.getOpacityForTile(t1), this._cachedTileFogOpacities.set(t1.key, i)), i[0] >= e1.aE || i[1] >= e1.aE;
            }
            setupDepthForOcclusion(e1, t1, i) {
                const s = this.context, r = s.gl, o = !!i;
                var n;
                i || (i = {
                    u_dem: 2,
                    u_dem_prev: 4,
                    u_dem_tl: [
                        0,
                        0
                    ],
                    u_dem_tl_prev: [
                        0,
                        0
                    ],
                    u_dem_scale: 0,
                    u_dem_scale_prev: 0,
                    u_dem_size: 0,
                    u_dem_lerp: 1,
                    u_depth: 3,
                    u_depth_size_inv: [
                        0,
                        0
                    ],
                    u_depth_range_unpack: [
                        0,
                        1
                    ],
                    u_occluder_half_size: 16,
                    u_occlusion_depth_offset: -0.0001,
                    u_exaggeration: 0
                }), s.activeTexture.set(r.TEXTURE3), e1 && this.depthFBO && this.depthTexture ? (this.depthTexture.bind(r.NEAREST, r.CLAMP_TO_EDGE), i.u_depth_size_inv = [
                    1 / this.depthFBO.width,
                    1 / this.depthFBO.height
                ], i.u_depth_range_unpack = [
                    2 / ((n = this.depthRangeFor3D)[1] - n[0]),
                    -1 - 2 * n[0] / (n[1] - n[0])
                ], i.u_occluder_half_size = .5 * this.occlusionParams.occluderSize, i.u_occlusion_depth_offset = this.occlusionParams.depthOffset) : this.emptyDepthTexture.bind(r.NEAREST, r.CLAMP_TO_EDGE), s.activeTexture.set(r.TEXTURE0), o || t1.setTerrainUniformValues(s, i);
            }
            updateEmissiveMode() {
                if (this._forceEmissiveMode) return;
                const e1 = this.style.hasDataDrivenEmissiveStrength();
                this.emissiveMode = this._forceFullRgbaEmissive ? "mrt-full-rgba" : e1 ? this.context.extBlendFuncExtended ? "dual-source-blending" : "mrt-fallback" : "constant";
            }
        }
        function sl(e1, t1) {
            let i = !1, s = null;
            const r = ()=>{
                s = null, i && (e1(), s = setTimeout(r, t1), i = !1);
            };
            return ()=>(i = !0, s || r(), s);
        }
        const rl = /(#.+)?$/;
        class ol {
            constructor(t1){
                this._hashName = t1 && encodeURIComponent(t1), e1.b4([
                    "_getCurrentHash",
                    "_onHashChange",
                    "_updateHash"
                ], this), this._updateHash = sl(this._updateHashUnthrottled.bind(this), 300);
            }
            addTo(e1) {
                return this._map = e1, window.addEventListener("hashchange", this._onHashChange, !1), e1.on("moveend", this._updateHash), this;
            }
            remove() {
                return this._map ? (this._map.off("moveend", this._updateHash), window.removeEventListener("hashchange", this._onHashChange, !1), clearTimeout(this._updateHash()), this._map = void 0, this) : this;
            }
            getHashString() {
                const e1 = this._map;
                if (!e1) return "";
                const t1 = nl(e1);
                if (this._hashName) {
                    const e1 = this._hashName;
                    let i = !1;
                    const s = location.hash.slice(1).split("&").map((s)=>{
                        const r = s.split("=")[0];
                        return r === e1 ? (i = !0, `${r}=${t1}`) : s;
                    }).filter((e1)=>e1);
                    return i || s.push(`${e1}=${t1}`), `#${s.join("&")}`;
                }
                return `#${t1}`;
            }
            _getCurrentHash() {
                const e1 = location.hash.replace("#", "");
                if (this._hashName) {
                    let t1;
                    return e1.split("&").map((e1)=>e1.split("=")).forEach((e1)=>{
                        e1[0] === this._hashName && (t1 = e1);
                    }), (t1 && t1[1] || "").split("/");
                }
                return e1.split("/");
            }
            _onHashChange() {
                const e1 = this._map;
                if (!e1) return !1;
                const t1 = this._getCurrentHash();
                if (t1.length >= 3 && !t1.some((e1)=>isNaN(Number(e1)))) {
                    const i = e1.dragRotate.isEnabled() && e1.touchZoomRotate.isEnabled() ? +(t1[3] || 0) : e1.getBearing();
                    return e1.jumpTo({
                        center: [
                            +t1[2],
                            +t1[1]
                        ],
                        zoom: +t1[0],
                        bearing: i,
                        pitch: +(t1[4] || 0)
                    }), !0;
                }
                return !1;
            }
            _updateHashUnthrottled() {
                history.replaceState(history.state, "", location.href.replace(rl, this.getHashString()));
            }
        }
        function nl(e1, t1) {
            const i = e1.getCenter(), s = Math.round(100 * e1.getZoom()) / 100, r = Math.ceil((s * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), o = Math.pow(10, r), n = Math.round(i.lng * o) / o, a = Math.round(i.lat * o) / o, l = e1.getBearing(), c = e1.getPitch();
            let h = t1 ? `/${n}/${a}/${s}` : `${s}/${a}/${n}`;
            return (l || c) && (h += "/" + Math.round(10 * l) / 10), c && (h += `/${Math.round(c)}`), h;
        }
        const al = {
            linearity: .3,
            easing: e1.eH(0, 0, .3, 1)
        }, ll = {
            deceleration: 2500,
            maxSpeed: 1400,
            ...al
        }, cl = {
            deceleration: 20,
            maxSpeed: 1400,
            ...al
        }, hl = {
            deceleration: 1e3,
            maxSpeed: 360,
            ...al
        }, dl = {
            deceleration: 1e3,
            maxSpeed: 90,
            ...al
        };
        class ul {
            constructor(e1){
                this._map = e1, this.clear();
            }
            clear() {
                this._inertiaBuffer = [];
            }
            record(t1) {
                this._drainInertiaBuffer(), this._inertiaBuffer.push({
                    time: e1.e.now(),
                    settings: t1
                });
            }
            _drainInertiaBuffer() {
                const t1 = this._inertiaBuffer, i = e1.e.now();
                for(; t1.length > 0 && i - t1[0].time > 160;)t1.shift();
            }
            _onMoveEnd(t1) {
                if (this._map._prefersReducedMotion()) return;
                if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
                const i = {
                    zoom: 0,
                    bearing: 0,
                    pitch: 0,
                    pan: new e1.P(0, 0),
                    pinchAround: void 0,
                    around: void 0
                };
                for (const { settings: e1 } of this._inertiaBuffer)i.zoom += e1.zoomDelta || 0, i.bearing += e1.bearingDelta || 0, i.pitch += e1.pitchDelta || 0, e1.panDelta && i.pan._add(e1.panDelta), e1.around && (i.around = e1.around), e1.pinchAround && (i.pinchAround = e1.pinchAround);
                const s = this._inertiaBuffer.at(-1).time - this._inertiaBuffer[0].time, r = {};
                if (i.pan.mag()) {
                    const e1 = fl(i.pan.mag(), s, {
                        ...ll,
                        ...t1 || {}
                    });
                    r.offset = i.pan.mult(e1.amount / i.pan.mag()), r.center = this._map.transform.center, pl(r, e1);
                }
                if (i.zoom) {
                    const e1 = fl(i.zoom, s, cl);
                    r.zoom = this._map.transform.zoom + e1.amount, pl(r, e1);
                }
                if (i.bearing) {
                    const t1 = fl(i.bearing, s, hl);
                    r.bearing = this._map.transform.bearing + e1.bb(t1.amount, -179, 179), pl(r, t1);
                }
                if (i.pitch) {
                    const e1 = fl(i.pitch, s, dl);
                    r.pitch = this._map.transform.pitch + e1.amount, pl(r, e1);
                }
                if (r.zoom || r.bearing) {
                    const e1 = void 0 === i.pinchAround ? i.around : i.pinchAround;
                    r.around = e1 ? this._map.unproject(e1) : this._map.getCenter();
                }
                return this.clear(), r.noMoveStart = !0, r;
            }
        }
        function pl(e1, t1) {
            (!e1.duration || e1.duration < t1.duration) && (e1.duration = t1.duration, e1.easing = t1.easing);
        }
        function fl(t1, i, s) {
            const { maxSpeed: r, linearity: o, deceleration: n } = s, a = e1.bb(t1 * o / (i / 1e3), -r, r), l = Math.abs(a) / (n * o);
            return {
                easing: s.easing,
                duration: 1e3 * l,
                amount: a * (l / 2)
            };
        }
        class ml extends e1.i {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e1, t1, i, s = {}){
                const r = _(t1.getCanvasContainer(), i);
                super(e1, {
                    point: r,
                    lngLat: t1.unproject(r),
                    originalEvent: i,
                    ...s
                }), this._defaultPrevented = !1, this.target = t1;
            }
        }
        class _l extends e1.i {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(t1, i, s){
                const r = "touchend" === t1 ? s.changedTouches : s.touches, o = g(i.getCanvasContainer(), r), n = o.map((e1)=>i.unproject(e1)), a = o.reduce((e1, t1, i, s)=>e1.add(t1.div(s.length)), new e1.P(0, 0));
                super(t1, {
                    points: o,
                    point: a,
                    lngLats: n,
                    lngLat: i.unproject(a),
                    originalEvent: s
                }), this._defaultPrevented = !1;
            }
        }
        class gl extends e1.i {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e1, t1){
                super("wheel", {
                    originalEvent: t1
                }), this._defaultPrevented = !1;
            }
        }
        class yl {
            constructor(e1, t1){
                this._map = e1, this._clickTolerance = t1.clickTolerance;
            }
            reset() {
                this._mousedownPos = void 0;
            }
            wheel(e1) {
                return this._firePreventable(new gl(this._map, e1));
            }
            mousedown(e1, t1) {
                return this._mousedownPos = t1, this._firePreventable(new ml(e1.type, this._map, e1));
            }
            mouseup(e1) {
                this._map.fire(new ml(e1.type, this._map, e1));
            }
            preclick(e1) {
                const t1 = new MouseEvent("preclick", e1);
                this._map.fire(new ml(t1.type, this._map, t1));
            }
            click(e1, t1) {
                this._mousedownPos && this._mousedownPos.dist(t1) >= this._clickTolerance || (this.preclick(e1), this._map.fire(new ml(e1.type, this._map, e1)));
            }
            dblclick(e1) {
                return this._firePreventable(new ml(e1.type, this._map, e1));
            }
            mouseover(e1) {
                this._map.fire(new ml(e1.type, this._map, e1));
            }
            mouseout(e1) {
                this._map.fire(new ml(e1.type, this._map, e1));
            }
            touchstart(e1) {
                return this._firePreventable(new _l(e1.type, this._map, e1));
            }
            touchmove(e1) {
                this._map.fire(new _l(e1.type, this._map, e1));
            }
            touchend(e1) {
                this._map.fire(new _l(e1.type, this._map, e1));
            }
            touchcancel(e1) {
                this._map.fire(new _l(e1.type, this._map, e1));
            }
            _firePreventable(e1) {
                if (this._map.fire(e1), e1.defaultPrevented) return {};
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class vl {
            constructor(e1){
                this._map = e1;
            }
            reset() {
                this._delayContextMenu = !1, this._contextMenuEvent = void 0;
            }
            mousemove(e1) {
                this._map.fire(new ml(e1.type, this._map, e1));
            }
            mousedown() {
                this._delayContextMenu = !0;
            }
            mouseup() {
                this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new ml("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
            }
            contextmenu(e1) {
                this._delayContextMenu ? this._contextMenuEvent = e1 : this._map.fire(new ml(e1.type, this._map, e1)), this._map.listens("contextmenu") && e1.preventDefault();
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class bl {
            constructor(e1, t1){
                this._map = e1, this._el = e1.getCanvasContainer(), this._container = e1.getContainer(), this._clickTolerance = t1.clickTolerance || 1;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            enable() {
                this.isEnabled() || (this._enabled = !0);
            }
            disable() {
                this.isEnabled() && (this._enabled = !1);
            }
            mousedown(e1, t1) {
                this.isEnabled() && e1.shiftKey && 0 === e1.button && (u1(), this._startPos = this._lastPos = t1, this._active = !0);
            }
            mousemoveWindow(e1, t1) {
                if (!this._active) return;
                const i = t1, s = this._startPos, r = this._lastPos;
                if (!s || !r || r.equals(i) || !this._box && i.dist(s) < this._clickTolerance) return;
                this._lastPos = i, this._box || (this._box = a("div", "mapboxgl-boxzoom", this._container), this._container.classList.add("mapboxgl-crosshair"), this._fireEvent("boxzoomstart", e1));
                const o = Math.min(s.x, i.x), n = Math.max(s.x, i.x), l = Math.min(s.y, i.y), c = Math.max(s.y, i.y);
                this._map._requestDomTask(()=>{
                    this._box && (this._box.style.transform = `translate(${o}px,${l}px)`, this._box.style.width = n - o + "px", this._box.style.height = c - l + "px");
                });
            }
            mouseupWindow(t1, i) {
                if (!this._active) return;
                const s = this._startPos, r = i;
                if (s && 0 === t1.button) {
                    if (this.reset(), m(), s.x !== r.x || s.y !== r.y) return this._map.fire(new e1.i("boxzoomend", {
                        originalEvent: t1
                    })), {
                        cameraAnimation: (e1)=>e1.fitScreenCoordinates(s, r, this._map.getBearing(), {
                                linear: !1
                            })
                    };
                    this._fireEvent("boxzoomcancel", t1);
                }
            }
            keydown(e1) {
                this._active && 27 === e1.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", e1));
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1, this._container.classList.remove("mapboxgl-crosshair"), this._box && (this._box.remove(), this._box = null), p(), delete this._startPos, delete this._lastPos;
            }
            _fireEvent(t1, i) {
                return this._map.fire(new e1.i(t1, {
                    originalEvent: i
                }));
            }
        }
        function xl(e1, t1) {
            const i = {};
            for(let s = 0; s < e1.length; s++)i[e1[s].identifier] = t1[s];
            return i;
        }
        class wl {
            constructor(e1){
                this.reset(), this.numTouches = e1.numTouches;
            }
            reset() {
                this.centroid = void 0, this.startTime = 0, this.touches = {}, this.aborted = !1;
            }
            touchstart(t1, i, s) {
                (this.centroid || s.length > this.numTouches) && (this.aborted = !0), this.aborted || (0 === this.startTime && (this.startTime = t1.timeStamp), s.length === this.numTouches && (this.centroid = function(t1) {
                    const i = new e1.P(0, 0);
                    for (const e1 of t1)i._add(e1);
                    return i.div(t1.length);
                }(i), this.touches = xl(s, i)));
            }
            touchmove(e1, t1, i) {
                if (this.aborted || !this.centroid) return;
                const s = xl(i, t1);
                for(const e1 in this.touches){
                    const t1 = s[e1];
                    (!t1 || t1.dist(this.touches[e1]) > 30) && (this.aborted = !0);
                }
            }
            touchend(e1, t1, i) {
                if ((!this.centroid || e1.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === i.length) {
                    const e1 = !this.aborted && this.centroid;
                    if (this.reset(), e1) return e1;
                }
            }
        }
        class Tl {
            constructor(e1){
                this.singleTap = new wl(e1), this.numTaps = e1.numTaps, this.reset();
            }
            reset() {
                this.lastTime = 1 / 0, this.lastTap = void 0, this.count = 0, this.singleTap.reset();
            }
            touchstart(e1, t1, i) {
                this.singleTap.touchstart(e1, t1, i);
            }
            touchmove(e1, t1, i) {
                this.singleTap.touchmove(e1, t1, i);
            }
            touchend(e1, t1, i) {
                const s = this.singleTap.touchend(e1, t1, i);
                if (s) {
                    const t1 = e1.timeStamp - this.lastTime < 500, i = !this.lastTap || this.lastTap.dist(s) < 30;
                    if (t1 && i || this.reset(), this.count++, this.lastTime = e1.timeStamp, this.lastTap = s, this.count === this.numTaps) return this.reset(), s;
                }
            }
        }
        class Sl {
            constructor(){
                this._zoomIn = new Tl({
                    numTouches: 1,
                    numTaps: 2
                }), this._zoomOut = new Tl({
                    numTouches: 2,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
            }
            touchstart(e1, t1, i) {
                this._zoomIn.touchstart(e1, t1, i), this._zoomOut.touchstart(e1, t1, i);
            }
            touchmove(e1, t1, i) {
                this._zoomIn.touchmove(e1, t1, i), this._zoomOut.touchmove(e1, t1, i);
            }
            touchend(e1, t1, i) {
                const s = this._zoomIn.touchend(e1, t1, i), r = this._zoomOut.touchend(e1, t1, i);
                return s ? (this._active = !0, e1.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (t1)=>t1.easeTo({
                            duration: 300,
                            zoom: t1.getZoom() + 1,
                            around: t1.unproject(s)
                        }, {
                            originalEvent: e1
                        })
                }) : r ? (this._active = !0, e1.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (t1)=>t1.easeTo({
                            duration: 300,
                            zoom: t1.getZoom() - 1,
                            around: t1.unproject(r)
                        }, {
                            originalEvent: e1
                        })
                }) : void 0;
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        const Cl = 0, El = 2, Il = {
            [Cl]: 1,
            [El]: 2
        }, Dl = {
            Control: "ctrlKey",
            Alt: "altKey",
            Shift: "shiftKey",
            Meta: "metaKey"
        };
        class Pl {
            constructor(e1){
                this.reset(), this._clickTolerance = e1.clickTolerance || 1;
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1, this._moved = !1, this._lastPoint = void 0, this._eventButton = void 0;
            }
            _correctButton(e1, t1) {
                return !1;
            }
            _move(e1, t1) {
                return {};
            }
            mousedown(e1, t1) {
                if (this._lastPoint) return;
                const i = y(e1);
                this._correctButton(e1, i) && (this._lastPoint = t1, this._eventButton = i);
            }
            mousemoveWindow(e1, t1) {
                const i = this._lastPoint;
                if (i) {
                    if (e1.preventDefault(), null != this._eventButton && function(e1, t1) {
                        const i = Il[t1];
                        return void 0 === e1.buttons || (e1.buttons & i) !== i;
                    }(e1, this._eventButton)) this.reset();
                    else if (this._moved || !(t1.dist(i) < this._clickTolerance)) return this._moved = !0, this._lastPoint = t1, this._move(i, t1);
                }
            }
            mouseupWindow(e1) {
                this._lastPoint && y(e1) === this._eventButton && (this._moved && m(), this.reset());
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Ll extends Pl {
            mousedown(e1, t1) {
                super.mousedown(e1, t1), this._lastPoint && (this._active = !0);
            }
            _correctButton(e1, t1) {
                return 0 === t1 && !e1.ctrlKey;
            }
            _move(e1, t1) {
                return {
                    around: t1,
                    panDelta: t1.sub(e1)
                };
            }
        }
        class Rl extends Pl {
            constructor(e1){
                super(e1), this._pitchRotateKey = e1.pitchRotateKey ? Dl[e1.pitchRotateKey] : void 0;
            }
            _correctButton(e1, t1) {
                return this._pitchRotateKey ? 0 === t1 && e1[this._pitchRotateKey] : 0 === t1 && e1.ctrlKey || 2 === t1;
            }
            _move(e1, t1) {
                const i = .8 * (t1.x - e1.x);
                if (i) return this._active = !0, {
                    bearingDelta: i
                };
            }
            contextmenu(e1) {
                this._pitchRotateKey || e1.preventDefault();
            }
        }
        class Al extends Pl {
            constructor(e1){
                super(e1), this._pitchRotateKey = e1.pitchRotateKey ? Dl[e1.pitchRotateKey] : void 0;
            }
            _correctButton(e1, t1) {
                return this._pitchRotateKey ? 0 === t1 && e1[this._pitchRotateKey] : 0 === t1 && e1.ctrlKey || 2 === t1;
            }
            _move(e1, t1) {
                const i = -0.5 * (t1.y - e1.y);
                if (i) return this._active = !0, {
                    pitchDelta: i
                };
            }
            contextmenu(e1) {
                this._pitchRotateKey || e1.preventDefault();
            }
        }
        class Ml {
            constructor(t1, i){
                this._map = t1, this._el = t1.getCanvasContainer(), this._minTouches = 1, this._clickTolerance = i.clickTolerance || 1, this.reset(), e1.b4([
                    "_addTouchPanBlocker",
                    "_showTouchPanBlockerAlert"
                ], this);
            }
            reset() {
                this._active = !1, this._touches = {}, this._sum = new e1.P(0, 0);
            }
            touchstart(e1, t1, i) {
                return this._calculateTransform(e1, t1, i);
            }
            touchmove(t1, i, s) {
                if (this._active && !(s.length < this._minTouches)) {
                    if (this._map._cooperativeGestures && !this._map.isMoving()) {
                        if (1 === s.length && !e1.eI()) return void this._showTouchPanBlockerAlert();
                        "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
                    }
                    return t1.cancelable && t1.preventDefault(), this._calculateTransform(t1, i, s);
                }
            }
            touchend(e1, t1, i) {
                this._calculateTransform(e1, t1, i), this._active && i.length < this._minTouches && this.reset();
            }
            touchcancel() {
                this.reset();
            }
            _calculateTransform(t1, i, s) {
                s.length > 0 && (this._active = !0);
                const r = xl(s, i), o = new e1.P(0, 0), n = new e1.P(0, 0);
                let a = 0;
                for(const e1 in r){
                    const t1 = r[e1], i = this._touches[e1];
                    i && (o._add(t1), n._add(t1.sub(i)), a++, r[e1] = t1);
                }
                if (this._touches = r, a < this._minTouches || !n.mag()) return;
                const l = n.div(a);
                return this._sum._add(l), this._sum.mag() < this._clickTolerance ? void 0 : {
                    around: o.div(a),
                    panDelta: l
                };
            }
            enable() {
                this._enabled = !0, this._map._cooperativeGestures && (this._addTouchPanBlocker(), this._el.classList.add("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page"));
            }
            disable() {
                this._enabled = !1, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove(), this._el.classList.remove("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page")), this.reset();
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            _addTouchPanBlocker() {
                this._map && !this._alertContainer && (this._alertContainer = a("div", "mapboxgl-touch-pan-blocker", this._map._container), this._alertContainer.textContent = this._map._getUIString("TouchPanBlocker.Message"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(.05 * this._el.clientWidth)))}px`);
            }
            _showTouchPanBlockerAlert() {
                this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-touch-pan-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = window.setTimeout(()=>{
                    this._alertContainer.classList.remove("mapboxgl-touch-pan-blocker-show"), this._alertContainer.removeAttribute("role");
                }, 500);
            }
        }
        class Fl {
            constructor(){
                this.reset();
            }
            reset() {
                this._active = !1, this._firstTwoTouches = void 0;
            }
            _start(e1) {}
            _move(e1, t1, i) {
                return {};
            }
            touchstart(e1, t1, i) {
                this._firstTwoTouches || i.length < 2 || (this._firstTwoTouches = [
                    i[0].identifier,
                    i[1].identifier
                ], this._start([
                    t1[0],
                    t1[1]
                ]));
            }
            touchmove(e1, t1, i) {
                const s = this._firstTwoTouches;
                if (!s) return;
                e1.preventDefault();
                const [r, o] = s, n = Ol(i, t1, r), a = Ol(i, t1, o);
                if (!n || !a) return;
                const l = this._aroundCenter ? null : n.add(a).div(2);
                return this._move([
                    n,
                    a
                ], l, e1);
            }
            touchend(e1, t1, i) {
                if (!this._firstTwoTouches) return;
                const [s, r] = this._firstTwoTouches, o = Ol(i, t1, s), n = Ol(i, t1, r);
                o && n || (this._active && m(), this.reset());
            }
            touchcancel() {
                this.reset();
            }
            enable(e1) {
                this._enabled = !0, this._aroundCenter = !!e1 && "center" === e1.around;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        function Ol(e1, t1, i) {
            for(let s = 0; s < e1.length; s++)if (e1[s].identifier === i) return t1[s];
        }
        function kl(e1, t1) {
            return Math.log2(e1 / t1);
        }
        class Bl extends Fl {
            reset() {
                super.reset(), this._distance = 0, this._startDistance = 0;
            }
            _start(e1) {
                this._startDistance = this._distance = e1[0].dist(e1[1]);
            }
            _move(e1, t1) {
                const i = this._distance;
                if (this._distance = e1[0].dist(e1[1]), this._active || !(Math.abs(kl(this._distance, this._startDistance)) < .1)) return this._active = !0, {
                    zoomDelta: kl(this._distance, i),
                    pinchAround: t1
                };
            }
        }
        function zl(e1, t1) {
            return 180 * e1.angleWith(t1) / Math.PI;
        }
        class Ul extends Fl {
            reset() {
                super.reset(), this._minDiameter = 0, this._startVector = void 0, this._vector = void 0;
            }
            _start(e1) {
                this._startVector = this._vector = e1[0].sub(e1[1]), this._minDiameter = e1[0].dist(e1[1]);
            }
            _move(e1, t1) {
                const i = this._vector;
                if (this._vector = e1[0].sub(e1[1]), i && (this._active || !this._isBelowThreshold(this._vector))) return this._active = !0, {
                    bearingDelta: zl(this._vector, i),
                    pinchAround: t1
                };
            }
            _isBelowThreshold(e1) {
                this._minDiameter = Math.min(this._minDiameter, e1.mag());
                const t1 = 25 / (Math.PI * this._minDiameter) * 360, i = this._startVector;
                if (!i) return !1;
                const s = zl(e1, i);
                return Math.abs(s) < t1;
            }
        }
        function Nl(e1) {
            return Math.abs(e1.y) > Math.abs(e1.x);
        }
        class jl extends Fl {
            constructor(e1){
                super(), this._map = e1;
            }
            reset() {
                super.reset(), this._valid = void 0, this._firstMove = void 0, this._lastPoints = void 0;
            }
            _start(e1) {
                this._lastPoints = e1, Nl(e1[0].sub(e1[1])) && (this._valid = !1);
            }
            _move(t1, i, s) {
                const r = this._lastPoints;
                if (!r) return;
                const o = t1[0].sub(r[0]), n = t1[1].sub(r[1]);
                return this._map._cooperativeGestures && !e1.eI() && s.touches.length < 3 || (this._valid = this.gestureBeginsVertically(o, n, s.timeStamp), !this._valid) ? void 0 : (this._lastPoints = t1, this._active = !0, {
                    pitchDelta: (o.y + n.y) / 2 * -0.5
                });
            }
            gestureBeginsVertically(e1, t1, i) {
                if (void 0 !== this._valid) return this._valid;
                const s = e1.mag() >= 2, r = t1.mag() >= 2;
                if (!s && !r) return;
                if (!s || !r) return this._firstMove ??= i, i - this._firstMove < 100 && void 0;
                const o = e1.y > 0 == t1.y > 0;
                return Nl(e1) && Nl(t1) && o;
            }
        }
        const Vl = {
            panStep: 100,
            bearingStep: 15,
            pitchStep: 10
        };
        class Gl {
            constructor(){
                const e1 = Vl;
                this._panStep = e1.panStep, this._bearingStep = e1.bearingStep, this._pitchStep = e1.pitchStep, this._bearingDisabled = !1, this._pitchDisabled = !1, this._panDisabled = !1, this._zoomDisabled = !1;
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            keydown(e1) {
                if (e1.altKey || e1.ctrlKey || e1.metaKey) return;
                if (!this.isEnabled()) return;
                let t1 = 0, i = 0, s = 0, r = 0, o = 0;
                switch(e1.keyCode){
                    case 61:
                    case 107:
                    case 171:
                    case 187:
                        t1 = 1;
                        break;
                    case 189:
                    case 109:
                    case 173:
                        t1 = -1;
                        break;
                    case 37:
                        e1.shiftKey ? i = -1 : (e1.preventDefault(), r = -1);
                        break;
                    case 39:
                        e1.shiftKey ? i = 1 : (e1.preventDefault(), r = 1);
                        break;
                    case 38:
                        e1.shiftKey ? s = 1 : (e1.preventDefault(), o = -1);
                        break;
                    case 40:
                        e1.shiftKey ? s = -1 : (e1.preventDefault(), o = 1);
                        break;
                    default:
                        return;
                }
                return this._bearingDisabled && (i = 0), this._pitchDisabled && (s = 0), this._panDisabled && (r = 0, o = 0), this._zoomDisabled && (t1 = 0), {
                    cameraAnimation: (n)=>{
                        const a = n.getZoom();
                        n.easeTo({
                            duration: 300,
                            easeId: "keyboardHandler",
                            easing: ql,
                            zoom: t1 ? Math.round(a) + t1 * (e1.shiftKey ? 2 : 1) : a,
                            bearing: n.getBearing() + i * this._bearingStep,
                            pitch: n.getPitch() + s * this._pitchStep,
                            offset: [
                                -r * this._panStep,
                                -o * this._panStep
                            ],
                            center: n.getCenter()
                        }, {
                            originalEvent: e1
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled && !(this._bearingDisabled && this._pitchDisabled && this._panDisabled && this._zoomDisabled);
            }
            isActive() {
                return this._active;
            }
            disableRotation() {
                this._pitchDisabled = !0, this._bearingDisabled = !0;
            }
            enableRotation() {
                this._pitchDisabled = !1, this._bearingDisabled = !1;
            }
            isRotationEnabled() {
                return !this._pitchDisabled && !this._bearingDisabled;
            }
            disablePan() {
                this._panDisabled = !0;
            }
            enablePan() {
                this._panDisabled = !1;
            }
            isPanEnabled() {
                return !this._panDisabled;
            }
            disableZoom() {
                this._zoomDisabled = !0;
            }
            enableZoom() {
                this._zoomDisabled = !1;
            }
            isZoomEnabled() {
                return !this._zoomDisabled;
            }
            disablePitch() {
                this._pitchDisabled = !0;
            }
            enablePitch() {
                this._pitchDisabled = !1;
            }
            isPitchEnabled() {
                return !this._pitchDisabled;
            }
            disableBearing() {
                this._bearingDisabled = !0;
            }
            enableBearing() {
                this._bearingDisabled = !1;
            }
            isBearingEnabled() {
                return !this._bearingDisabled;
            }
        }
        function ql(e1) {
            return e1 * (2 - e1);
        }
        const $l = 4.000244140625, Zl = 1 / 450, Wl = /(Mac|iPad)/i;
        class Hl {
            constructor(t1, i){
                this._map = t1, this._el = t1.getCanvasContainer(), this._handler = i, this._delta = 0, this._lastDelta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = Zl, e1.b4([
                    "_onTimeout",
                    "_addScrollZoomBlocker",
                    "_showBlockerAlert"
                ], this);
            }
            setZoomRate(e1) {
                this._defaultZoomRate = e1;
            }
            setWheelZoomRate(e1) {
                this._wheelZoomRate = e1;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return this._active || void 0 !== this._finishTimeout;
            }
            isZooming() {
                return !!this._zooming;
            }
            enable(e1) {
                this.isEnabled() || (this._enabled = !0, this._aroundCenter = !!e1 && "center" === e1.around, this._map._cooperativeGestures && this._addScrollZoomBlocker());
            }
            disable() {
                this.isEnabled() && (this._enabled = !1, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove()));
            }
            wheel(t1) {
                if (!this.isEnabled()) return;
                if (this._map._cooperativeGestures) {
                    if (!(t1.ctrlKey || t1.metaKey || this.isZooming() || e1.eI())) return void this._showBlockerAlert();
                    "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
                }
                let i = t1.deltaMode === WheelEvent.DOM_DELTA_LINE ? 40 * t1.deltaY : t1.deltaY;
                const s = e1.e.now(), r = s - (this._lastWheelEventTime || 0);
                this._lastWheelEventTime = s, 0 !== i && i % $l === 0 ? this._type = "wheel" : 0 !== i && Math.abs(i) < 4 ? this._type = "trackpad" : r > 400 ? (this._type = null, this._lastValue = i, this._timeout = window.setTimeout(this._onTimeout, 40, t1)) : this._type || (this._type = Math.abs(r * i) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, i += this._lastValue)), t1.shiftKey && i && (i /= 4), this._type && (this._lastWheelEvent = t1, this._delta -= i, this._active || this._start(t1)), t1.preventDefault();
            }
            _onTimeout(e1) {
                this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(e1);
            }
            _start(e1) {
                if (!this._delta) return;
                this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                const t1 = _(this._el, e1);
                this._aroundPoint = this._aroundCenter ? this._map.transform.centerPoint : t1, this._aroundCoord = this._map.transform.pointCoordinate3D(this._aroundPoint), this._targetZoom = void 0, this._frameId || (this._frameId = !0, this._handler._triggerRenderFrame());
            }
            renderFrame() {
                if (!this._frameId) return;
                if (this._frameId = null, !this.isActive()) return;
                const t1 = this._map.transform;
                "wheel" === this._type && t1.projection.wrap && (t1._center.lng >= 180 || t1._center.lng <= -180) && (this._prevEase = null, this._easing = null, this._lastWheelEvent = null, this._lastWheelEventTime = 0);
                const i = ()=>t1._terrainEnabled() && this._aroundCoord ? t1.computeZoomRelativeTo(this._aroundCoord) : t1.zoom;
                if (0 !== this._delta) {
                    const e1 = "wheel" === this._type && Math.abs(this._delta) > $l ? this._wheelZoomRate : this._defaultZoomRate;
                    let s = 2 / (1 + Math.exp(-Math.abs(this._delta * e1)));
                    this._delta < 0 && 0 !== s && (s = 1 / s);
                    const r = i(), o = Math.pow(2, r), n = "number" == typeof this._targetZoom ? t1.zoomScale(this._targetZoom) : o;
                    this._targetZoom = Math.min(t1.maxZoom, Math.max(t1.minZoom, t1.scaleZoom(n * s))), "wheel" === this._type && (this._startZoom = r, this._easing = this._smoothOutEasing(200)), this._lastDelta = this._delta, this._delta = 0;
                }
                const s = "number" == typeof this._targetZoom ? this._targetZoom : i(), r = this._startZoom, o = this._easing;
                let n, a = !1;
                if ("wheel" === this._type && r && o) {
                    const t1 = Math.min((e1.e.now() - this._lastWheelEventTime) / 200, 1), i = o(t1);
                    n = e1.aw(r, s, i), t1 < 1 ? this._frameId || (this._frameId = !0) : a = !0;
                } else n = s, a = !0;
                this._active = !0, a && (this._active = !1, this._finishTimeout = window.setTimeout(()=>{
                    this._zooming = !1, this._handler._triggerRenderFrame(), delete this._targetZoom, delete this._finishTimeout;
                }, 200));
                let l = n - i();
                return l * this._lastDelta < 0 && (l = 0), {
                    noInertia: !0,
                    needsRenderFrame: !a,
                    zoomDelta: l,
                    around: this._aroundPoint,
                    aroundCoord: this._aroundCoord,
                    originalEvent: this._lastWheelEvent
                };
            }
            _smoothOutEasing(t1) {
                let i = e1.eJ;
                if (this._prevEase) {
                    const t1 = this._prevEase, s = (e1.e.now() - t1.start) / t1.duration, r = t1.easing(s + .01) - t1.easing(s), o = .27 / Math.sqrt(r * r + 1e-4) * .01, n = Math.sqrt(.0729 - o * o);
                    i = e1.eH(o, n, .25, 1);
                }
                return this._prevEase = {
                    start: e1.e.now(),
                    duration: t1,
                    easing: i
                }, i;
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            _addScrollZoomBlocker() {
                this._map && !this._alertContainer && (this._alertContainer = a("div", "mapboxgl-scroll-zoom-blocker", this._map._container), this._alertContainer.textContent = Wl.test(navigator.userAgent) ? this._map._getUIString("ScrollZoomBlocker.CmdMessage") : this._map._getUIString("ScrollZoomBlocker.CtrlMessage"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(.05 * this._el.clientWidth)))}px`);
            }
            _showBlockerAlert() {
                this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = window.setTimeout(()=>{
                    this._alertContainer.classList.remove("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.removeAttribute("role");
                }, 200);
            }
        }
        class Xl {
            constructor(e1, t1){
                this._clickZoom = e1, this._tapZoom = t1;
            }
            enable() {
                this._clickZoom.enable(), this._tapZoom.enable();
            }
            disable() {
                this._clickZoom.disable(), this._tapZoom.disable();
            }
            isEnabled() {
                return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
            }
            isActive() {
                return this._clickZoom.isActive() || this._tapZoom.isActive();
            }
        }
        class Yl {
            constructor(){
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            blur() {
                this.reset();
            }
            dblclick(e1, t1) {
                return e1.preventDefault(), {
                    cameraAnimation: (i)=>{
                        i.easeTo({
                            duration: 300,
                            zoom: i.getZoom() + (e1.shiftKey ? -1 : 1),
                            around: i.unproject(t1)
                        }, {
                            originalEvent: e1
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Kl {
            constructor(){
                this._tap = new Tl({
                    numTouches: 1,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, this._swipePoint = void 0, this._swipeTouch = 0, this._tapTime = 0, this._tap.reset();
            }
            touchstart(e1, t1, i) {
                this._swipePoint || (this._tapTime && e1.timeStamp - this._tapTime > 500 && this.reset(), this._tapTime ? i.length > 0 && (this._swipePoint = t1[0], this._swipeTouch = i[0].identifier) : this._tap.touchstart(e1, t1, i));
            }
            touchmove(e1, t1, i) {
                if (this._tapTime) {
                    if (this._swipePoint) {
                        if (i[0].identifier !== this._swipeTouch) return;
                        const s = t1[0], r = s.y - this._swipePoint.y;
                        return this._swipePoint = s, e1.preventDefault(), this._active = !0, {
                            zoomDelta: r / 128
                        };
                    }
                } else this._tap.touchmove(e1, t1, i);
            }
            touchend(e1, t1, i) {
                this._tapTime ? this._swipePoint && 0 === i.length && this.reset() : this._tap.touchend(e1, t1, i) && (this._tapTime = e1.timeStamp);
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Ql {
            constructor(e1, t1, i){
                this._el = e1, this._mousePan = t1, this._touchPan = i;
            }
            enable(e1) {
                this._inertiaOptions = e1 || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("mapboxgl-touch-drag-pan");
            }
            disable() {
                this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("mapboxgl-touch-drag-pan");
            }
            isEnabled() {
                return this._mousePan.isEnabled() && this._touchPan.isEnabled();
            }
            isActive() {
                return this._mousePan.isActive() || this._touchPan.isActive();
            }
        }
        class Jl {
            constructor(e1, t1, i){
                this._pitchWithRotate = e1.pitchWithRotate, this._mouseRotate = t1, this._mousePitch = i, this._pitchDisabled = !1, this._rotationDisabled = !1;
            }
            enable() {
                this._rotationDisabled || this._mouseRotate.enable(), this._pitchWithRotate && !this._pitchDisabled && this._mousePitch.enable();
            }
            disable() {
                this._mouseRotate.disable(), this._mousePitch.disable();
            }
            isEnabled() {
                return this._pitchWithRotate ? !this._rotationDisabled && this._mouseRotate.isEnabled() || !this._pitchDisabled && this._mousePitch.isEnabled() : !this._rotationDisabled && this._mouseRotate.isEnabled();
            }
            isActive() {
                return this._mouseRotate.isActive() || this._mousePitch.isActive();
            }
            disablePitch() {
                this._pitchDisabled = !0, this._mousePitch.disable();
            }
            enablePitch() {
                this._pitchDisabled = !1, this._pitchWithRotate && this._mousePitch.enable();
            }
            isPitchEnabled() {
                return !this._pitchDisabled && this._mousePitch.isEnabled();
            }
            disableRotation() {
                this._rotationDisabled = !0, this._mouseRotate.disable();
            }
            enableRotation() {
                this._rotationDisabled = !1, this._mouseRotate.enable();
            }
            isRotationEnabled() {
                return !this._rotationDisabled && this._mouseRotate.isEnabled();
            }
        }
        class ec {
            constructor(e1, t1, i, s){
                this._el = e1, this._touchZoom = t1, this._touchRotate = i, this._tapDragZoom = s, this._rotationDisabled = !1, this._tapDragZoomDisabled = !1, this._enabled = !0;
            }
            enable(e1) {
                this._touchZoom.enable(e1), this._rotationDisabled || this._touchRotate.enable(e1), this._tapDragZoomDisabled || this._tapDragZoom.enable(), this._el.classList.add("mapboxgl-touch-zoom-rotate");
            }
            disable() {
                this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("mapboxgl-touch-zoom-rotate");
            }
            isEnabled() {
                return this._touchZoom.isEnabled() || !this._rotationDisabled && this._touchRotate.isEnabled() || !this._tapDragZoomDisabled && this._tapDragZoom.isEnabled();
            }
            isActive() {
                return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
            }
            disableRotation() {
                this._rotationDisabled = !0, this._touchRotate.disable();
            }
            enableRotation() {
                this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
            }
            isRotationEnabled() {
                return !this._rotationDisabled;
            }
            disableTapDragZoom() {
                this._tapDragZoomDisabled = !0, this._tapDragZoom.disable();
            }
            enableTapDragZoom() {
                this._tapDragZoomDisabled = !1, this._touchZoom.isEnabled() && this._tapDragZoom.enable();
            }
            isTapDragZoomEnabled() {
                return !this._tapDragZoomDisabled;
            }
        }
        const tc = (e1)=>e1.zoom || e1.drag || e1.pitch || e1.rotate;
        class ic extends e1.i {
        }
        class sc {
            constructor(){
                this.constants = [
                    1,
                    1,
                    .01
                ], this.radius = 0;
            }
            setup(t1, i) {
                const s = e1.cQ([], i, t1);
                this.radius = e1.en(s[2] < 0 ? e1.eL([], s, this.constants) : [
                    s[0],
                    s[1],
                    0
                ]);
            }
            projectRay(t1) {
                e1.eL(t1, t1, this.constants), e1.cg(t1, t1), e1.eM(t1, t1, this.constants);
                const i = e1.dY([], t1, this.radius);
                if (i[2] > 0) {
                    const t1 = e1.dY([], [
                        0,
                        0,
                        1
                    ], e1.d$(i, [
                        0,
                        0,
                        1
                    ])), s = e1.dY([], e1.cg([], [
                        i[0],
                        i[1],
                        0
                    ]), this.radius), r = e1.dZ([], i, e1.dY([], e1.cQ([], e1.dZ([], s, t1), i), 2));
                    i[0] = r[0], i[1] = r[1];
                }
                return i;
            }
        }
        function rc(e1) {
            return e1.panDelta && e1.panDelta.mag() || e1.zoomDelta || e1.bearingDelta || e1.pitchDelta;
        }
        class oc {
            constructor(t1, i){
                this._map = t1, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new ul(t1), this._bearingSnap = i.bearingSnap, this._previousActiveHandlers = {}, this._trackingEllipsoid = new sc, this._dragOrigin = null, this._mouseBeingPressed = !1, this._activeTouchCount = 0, this._eventsInProgress = {}, this._addDefaultHandlers(i), e1.b4([
                    "handleEvent",
                    "handleWindowEvent"
                ], this);
                const s = this._el;
                this._listeners = [
                    [
                        s,
                        "touchstart",
                        {
                            passive: !0
                        }
                    ],
                    [
                        s,
                        "touchmove",
                        {
                            passive: !1
                        }
                    ],
                    [
                        s,
                        "touchend",
                        void 0
                    ],
                    [
                        s,
                        "touchcancel",
                        void 0
                    ],
                    [
                        s,
                        "mousedown",
                        void 0
                    ],
                    [
                        s,
                        "mousemove",
                        void 0
                    ],
                    [
                        s,
                        "mouseup",
                        void 0
                    ],
                    [
                        document,
                        "mousemove",
                        {
                            capture: !0
                        }
                    ],
                    [
                        document,
                        "mouseup",
                        void 0
                    ],
                    [
                        s,
                        "mouseover",
                        void 0
                    ],
                    [
                        s,
                        "mouseout",
                        void 0
                    ],
                    [
                        s,
                        "dblclick",
                        void 0
                    ],
                    [
                        s,
                        "click",
                        void 0
                    ],
                    [
                        s,
                        "keydown",
                        {
                            capture: !1
                        }
                    ],
                    [
                        s,
                        "keyup",
                        void 0
                    ],
                    [
                        s,
                        "wheel",
                        {
                            passive: !1
                        }
                    ],
                    [
                        s,
                        "contextmenu",
                        void 0
                    ],
                    [
                        window,
                        "blur",
                        void 0
                    ]
                ];
                for (const [e1, t1, i] of this._listeners){
                    const s = e1 === document ? this.handleWindowEvent : this.handleEvent;
                    e1.addEventListener(t1, s, i);
                }
            }
            destroy() {
                for (const [e1, t1, i] of this._listeners){
                    const s = e1 === document ? this.handleWindowEvent : this.handleEvent;
                    e1.removeEventListener(t1, s, i);
                }
            }
            _addDefaultHandlers(e1) {
                const t1 = this._map, i = t1.getCanvasContainer();
                this._add("mapEvent", new yl(t1, e1));
                const s = t1.boxZoom = new bl(t1, e1);
                this._add("boxZoom", s);
                const r = new Sl, o = new Yl;
                t1.doubleClickZoom = new Xl(o, r), this._add("tapZoom", r), this._add("clickZoom", o);
                const n = new Kl;
                this._add("tapDragZoom", n);
                const a = t1.touchPitch = new jl(t1);
                this._add("touchPitch", a);
                const l = new Rl(e1), c = new Al(e1);
                t1.dragRotate = new Jl(e1, l, c), this._add("mouseRotate", l, [
                    "mousePitch"
                ]), this._add("mousePitch", c, [
                    "mouseRotate"
                ]);
                const h = new Ll(e1), d = new Ml(t1, e1);
                t1.dragPan = new Ql(i, h, d), this._add("mousePan", h), this._add("touchPan", d, [
                    "touchZoom",
                    "touchRotate"
                ]);
                const u = new Ul, p = new Bl;
                t1.touchZoomRotate = new ec(i, p, u, n), this._add("touchRotate", u, [
                    "touchPan",
                    "touchZoom"
                ]), this._add("touchZoom", p, [
                    "touchPan",
                    "touchRotate"
                ]), this._add("blockableMapEvent", new vl(t1));
                const f = t1.scrollZoom = new Hl(t1, this);
                this._add("scrollZoom", f, [
                    "mousePan"
                ]);
                const m = t1.keyboard = new Gl;
                this._add("keyboard", m);
                for (const i of [
                    "boxZoom",
                    "doubleClickZoom",
                    "tapDragZoom",
                    "touchPitch",
                    "dragRotate",
                    "dragPan",
                    "touchZoomRotate",
                    "scrollZoom",
                    "keyboard"
                ])e1.interactive && e1[i] && t1[i].enable(e1[i]);
            }
            _add(e1, t1, i) {
                this._handlers.push({
                    handlerName: e1,
                    handler: t1,
                    allowed: i
                }), this._handlersById[e1] = t1;
            }
            stop(e1 = "never") {
                if (!this._updatingCamera && !("always" === e1 || "ifPointerDown" === e1 && this._isPointerDown())) {
                    for (const { handler: e1 } of this._handlers)e1.reset();
                    this._inertia.clear(), this._fireEvents({}, {}, !1), this._changes = [], this._originalZoom = void 0;
                }
            }
            isActive() {
                for (const { handler: e1 } of this._handlers)if (e1.isActive()) return !0;
                return !1;
            }
            isZooming() {
                return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
            }
            isRotating() {
                return !!this._eventsInProgress.rotate;
            }
            isMoving() {
                return !!tc(this._eventsInProgress) || this.isZooming();
            }
            _isDragging() {
                return !!this._eventsInProgress.drag;
            }
            _blockedByActive(e1, t1, i) {
                for(const s in e1)if (!(s === i || t1 && t1.includes(s))) return !0;
                return !1;
            }
            handleWindowEvent(e1) {
                this.handleEvent(e1, `${e1.type}Window`);
            }
            _getMapTouches(e1) {
                const t1 = [];
                for (const i of e1)this._el.contains(i.target) && t1.push(i);
                return t1;
            }
            _updatePointerLiveness(e1) {
                switch(e1.type){
                    case "mousedown":
                        this._mouseBeingPressed = !0;
                        break;
                    case "mousemove":
                        0 === e1.buttons && (this._mouseBeingPressed = !1);
                        break;
                    case "mouseup":
                        this._mouseBeingPressed = !1;
                        break;
                    case "touchstart":
                    case "touchmove":
                    case "touchend":
                    case "touchcancel":
                        this._activeTouchCount = e1.touches ? e1.touches.length : 0;
                        break;
                    case "blur":
                        this._mouseBeingPressed = !1, this._activeTouchCount = 0;
                }
            }
            _isPointerDown() {
                return this._mouseBeingPressed || this._activeTouchCount > 0;
            }
            handleEvent(e1, t1) {
                this._updatePointerLiveness(e1), this._updatingCamera = !0;
                const i = "renderFrame" === e1.type, s = i ? void 0 : e1, r = {
                    needsRenderFrame: !1
                }, o = {}, n = {}, a = e1.touches ? this._getMapTouches(e1.touches) : void 0, l = a ? g(this._el, a) : i ? void 0 : _(this._el, e1);
                for (const { handlerName: i, handler: c, allowed: h } of this._handlers){
                    if (!c.isEnabled()) continue;
                    let d;
                    this._blockedByActive(n, h, i) ? c.reset() : c[t1 || e1.type] && (d = c[t1 || e1.type](e1, l, a), this.mergeHandlerResult(r, o, d, i, s), d && d.needsRenderFrame && this._triggerRenderFrame()), (d || c.isActive()) && (n[i] = c);
                }
                const c = {};
                for(const e1 in this._previousActiveHandlers)n[e1] || (c[e1] = s);
                this._previousActiveHandlers = n, (Object.keys(c).length || rc(r)) && (this._changes.push([
                    r,
                    o,
                    c
                ]), this._triggerRenderFrame()), (Object.keys(n).length || rc(r)) && this._map._stop({
                    keepGesture: "always"
                }), this._updatingCamera = !1;
                const { cameraAnimation: h } = r;
                h && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], h(this._map));
            }
            mergeHandlerResult(e1, t1, i, s, r) {
                if (!i) return;
                Object.assign(e1, i);
                const o = {
                    handlerName: s,
                    originalEvent: i.originalEvent || r
                };
                void 0 !== i.zoomDelta && (t1.zoom = o), void 0 !== i.panDelta && (t1.drag = o), void 0 !== i.pitchDelta && (t1.pitch = o), void 0 !== i.bearingDelta && (t1.rotate = o);
            }
            _applyChanges() {
                const t1 = {}, i = {}, s = {};
                for (const [r, o, n] of this._changes)r.panDelta && (t1.panDelta = (t1.panDelta || new e1.P(0, 0))._add(r.panDelta)), r.zoomDelta && (t1.zoomDelta = (t1.zoomDelta || 0) + r.zoomDelta), r.bearingDelta && (t1.bearingDelta = (t1.bearingDelta || 0) + r.bearingDelta), r.pitchDelta && (t1.pitchDelta = (t1.pitchDelta || 0) + r.pitchDelta), void 0 !== r.around && (t1.around = r.around), void 0 !== r.aroundCoord && (t1.aroundCoord = r.aroundCoord), void 0 !== r.pinchAround && (t1.pinchAround = r.pinchAround), r.noInertia && (t1.noInertia = r.noInertia), Object.assign(i, o), Object.assign(s, n);
                this._updateMapTransform(t1, i, s), this._changes = [];
            }
            _updateMapTransform(t1, i, s) {
                const r = this._map, o = r.transform, n = (e1)=>[
                        e1.x,
                        e1.y,
                        e1.z
                    ];
                if ((()=>{
                    const e1 = this._eventsInProgress.drag;
                    return e1 && !this._handlersById[e1.handlerName].isActive();
                })() && !rc(t1)) {
                    const e1 = o.zoom;
                    o.cameraElevationReference = "sea", null != this._originalZoom && o._orthographicProjectionAtLowPitch && "globe" !== o.projection.name && 0 === o.pitch ? (o.cameraElevationReference = "ground", o.zoom = this._originalZoom) : (o.recenterOnTerrain(), o.cameraElevationReference = "ground"), e1 !== o.zoom && this._map._update(!0);
                }
                if (o._isCameraConstrained && r._stop({
                    keepGesture: "always"
                }), !rc(t1)) return void this._fireEvents(i, s, !0);
                let { panDelta: a, zoomDelta: l, bearingDelta: c, pitchDelta: h, around: d, aroundCoord: u, pinchAround: p } = t1;
                o._isCameraConstrained && (l > 0 && (l = 0), o._isCameraConstrained = !1), void 0 !== p && (d = p), (l || ((e1)=>i[e1] && !this._eventsInProgress[e1])("drag")) && d && (this._dragOrigin = n(o.pointCoordinate3D(d)), this._originalZoom = o.zoom, this._trackingEllipsoid.setup(o._camera.position, this._dragOrigin)), o.cameraElevationReference = "sea", r._stop({
                    keepGesture: "always"
                }), d = d || r.transform.centerPoint, c && (o.bearing += c), h && (o.pitch += h), o._updateCameraState();
                const f = [
                    0,
                    0,
                    0
                ];
                if (a) {
                    if ("mercator" === o.projection.name) {
                        const e1 = this._trackingEllipsoid.projectRay(o.screenPointToMercatorRay(d).dir), t1 = this._trackingEllipsoid.projectRay(o.screenPointToMercatorRay(d.sub(a)).dir);
                        f[0] = t1[0] - e1[0], f[1] = t1[1] - e1[1];
                    } else {
                        const t1 = o.pointCoordinate(d);
                        if ("globe" === o.projection.name) {
                            a = a.rotate(-o.angle);
                            const i = o._pixelsPerMercatorPixel / o.worldSize;
                            f[0] = -a.x * e1.eK(e1.bC(t1.y)) * i, f[1] = -a.y * e1.eK(o.center.lat) * i;
                        } else {
                            const e1 = o.pointCoordinate(d.sub(a));
                            t1 && e1 && (f[0] = e1.x - t1.x, f[1] = e1.y - t1.y);
                        }
                    }
                }
                const m = o.zoom, _ = [
                    0,
                    0,
                    0
                ];
                if (l) {
                    const t1 = n(u || o.pointCoordinate3D(d)), i = {
                        dir: e1.cg([], e1.cQ([], t1, o._camera.position))
                    };
                    if (i.dir[2] < 0) {
                        const s = o.zoomDeltaToMovement(t1, l);
                        e1.dY(_, i.dir, s);
                    }
                }
                const g = e1.dZ(f, f, _);
                o._translateCameraConstrained(g), l && Math.abs(o.zoom - m) > 1e-4 && o.recenterOnTerrain(), o.cameraElevationReference = "ground", this._map._update(), t1.noInertia || this._inertia.record(t1), this._fireEvents(i, s, !0);
            }
            _fireEvents(t1, i, s) {
                const r = tc(this._eventsInProgress), o = tc(t1), n = {};
                for(const e1 in t1){
                    const { originalEvent: i } = t1[e1];
                    this._eventsInProgress[e1] || (n[`${e1}start`] = i), this._eventsInProgress[e1] = t1[e1];
                }
                !r && o && this._fireEvent("movestart", o.originalEvent);
                for(const e1 in n)this._fireEvent(e1, n[e1]);
                o && this._fireEvent("move", o.originalEvent);
                for(const e1 in t1){
                    const { originalEvent: i } = t1[e1];
                    this._fireEvent(e1, i);
                }
                const a = {};
                let l;
                for(const e1 in this._eventsInProgress){
                    const { handlerName: t1, originalEvent: s } = this._eventsInProgress[e1];
                    this._handlersById[t1].isActive() || (delete this._eventsInProgress[e1], l = i[t1] || s, a[`${e1}end`] = l);
                }
                for(const e1 in a)this._fireEvent(e1, a[e1]);
                const c = tc(this._eventsInProgress);
                if (s && (r || o) && !c) {
                    this._updatingCamera = !0;
                    const t1 = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), i = (e1)=>0 !== e1 && -this._bearingSnap < e1 && e1 < this._bearingSnap;
                    t1 ? (i(t1.bearing || this._map.getBearing()) && (t1.bearing = 0), this._map.easeTo(t1, {
                        originalEvent: l
                    })) : (this._map.fire(new e1.i("moveend", {
                        originalEvent: l
                    })), i(this._map.getBearing()) && this._map.resetNorth()), this._updatingCamera = !1;
                }
            }
            _fireEvent(t1, i) {
                this._map.fire(new e1.i(t1, i ? {
                    originalEvent: i
                } : {}));
            }
            _requestFrame() {
                return this._map.triggerRepaint(), this._map._renderTaskQueue.add((e1)=>{
                    this._frameId = void 0, this.handleEvent(new ic("renderFrame", {
                        timeStamp: e1
                    })), this._applyChanges();
                });
            }
            _triggerRenderFrame() {
                void 0 === this._frameId && (this._frameId = this._requestFrame());
            }
        }
        const nc = "map.setFreeCameraOptions(...) and map.getFreeCameraOptions() are not yet supported for non-mercator projections.";
        class ac extends e1.E {
            constructor(t1, i){
                super(), this._moving = !1, this._zooming = !1, this.transform = t1, this._bearingSnap = i.bearingSnap, this._respectPrefersReducedMotion = !1 !== i.respectPrefersReducedMotion, e1.b4([
                    "_renderFrameCallback"
                ], this);
            }
            getCenter() {
                return new e1.cJ(this.transform.center.lng, this.transform.center.lat);
            }
            setCenter(e1, t1) {
                return this.jumpTo({
                    center: e1
                }, t1);
            }
            panBy(t1, i, s) {
                return t1 = e1.P.convert(t1).mult(-1), this.panTo(this.transform.center, {
                    offset: t1,
                    ...i
                }, s);
            }
            panTo(e1, t1, i) {
                return this.easeTo({
                    center: e1,
                    ...t1
                }, i);
            }
            getZoom() {
                return this.transform.zoom;
            }
            setZoom(e1, t1) {
                return this.jumpTo({
                    zoom: e1
                }, t1), this;
            }
            zoomTo(e1, t1, i) {
                return this.easeTo({
                    zoom: e1,
                    ...t1
                }, i);
            }
            zoomIn(e1, t1) {
                return this.zoomTo(this.getZoom() + 1, e1, t1), this;
            }
            zoomOut(e1, t1) {
                return this.zoomTo(this.getZoom() - 1, e1, t1), this;
            }
            getBearing() {
                return this.transform.bearing;
            }
            setBearing(e1, t1) {
                return this.jumpTo({
                    bearing: e1
                }, t1), this;
            }
            getPadding() {
                return this.transform.padding;
            }
            setPadding(e1, t1) {
                return this.jumpTo({
                    padding: e1
                }, t1), this;
            }
            rotateTo(e1, t1, i) {
                return this.easeTo({
                    bearing: e1,
                    ...t1
                }, i);
            }
            resetNorth(e1, t1) {
                return this.rotateTo(0, {
                    duration: 1e3,
                    ...e1
                }, t1), this;
            }
            resetNorthPitch(e1, t1) {
                return this.easeTo({
                    bearing: 0,
                    pitch: 0,
                    duration: 1e3,
                    ...e1
                }, t1), this;
            }
            snapToNorth(e1, t1) {
                return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(e1, t1) : this;
            }
            getPitch() {
                return this.transform.pitch;
            }
            setPitch(e1, t1) {
                return this.jumpTo({
                    pitch: e1
                }, t1), this;
            }
            getVerticalFieldOfView() {
                return this.transform.fov;
            }
            setVerticalFieldOfView(e1, t1) {
                return this.jumpTo({
                    fov: e1
                }, t1);
            }
            getHorizontalFieldOfView() {
                return this.transform.horizontalFov;
            }
            cameraForBounds(t1, i) {
                t1 = e1.eN.convert(t1);
                const s = i && i.bearing || 0, r = i && i.pitch || 0, o = t1.getNorthWest(), n = t1.getSouthEast();
                return this._cameraForBounds(this.transform, o, n, s, r, i);
            }
            _extendPadding(e1) {
                const t1 = {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                };
                return null == e1 ? {
                    ...t1,
                    ...this.transform.padding
                } : "number" == typeof e1 ? {
                    top: e1,
                    bottom: e1,
                    right: e1,
                    left: e1
                } : {
                    ...t1,
                    ...e1
                };
            }
            _extendCameraOptions(e1) {
                return (e1 = {
                    offset: [
                        0,
                        0
                    ],
                    maxZoom: this.transform.maxZoom,
                    ...e1
                }).padding = this._extendPadding(e1.padding), e1;
            }
            _minimumAABBFrustumDistance(e1, t1) {
                const i = t1.max[0] - t1.min[0], s = t1.max[1] - t1.min[1];
                return i / s > e1.aspect ? i / (2 * Math.tan(.5 * e1.fovX) * e1.aspect) : s / (2 * Math.tan(.5 * e1.fovY) * e1.aspect);
            }
            _cameraForBoundsOnGlobe(t1, i, s, r, o, n) {
                const a = t1.clone(), l = this._extendCameraOptions(n);
                a.bearing = r, a.pitch = o;
                const c = e1.cJ.convert(i), h = e1.cJ.convert(s), d = .5 * (c.lat + h.lat), u = .5 * (c.lng + h.lng), p = e1.eO(d, u), f = e1.cg([], p), m = e1.cg([], e1.eP([], f, [
                    0,
                    1,
                    0
                ])), _ = e1.eP([], m, f), g = [
                    m[0],
                    m[1],
                    m[2],
                    0,
                    _[0],
                    _[1],
                    _[2],
                    0,
                    f[0],
                    f[1],
                    f[2],
                    0,
                    0,
                    0,
                    0,
                    1
                ], y = [
                    p,
                    e1.eO(c.lat, c.lng),
                    e1.eO(h.lat, c.lng),
                    e1.eO(h.lat, h.lng),
                    e1.eO(c.lat, h.lng),
                    e1.eO(d, c.lng),
                    e1.eO(d, h.lng),
                    e1.eO(c.lat, u),
                    e1.eO(h.lat, u)
                ];
                let v = e1.eQ.fromPoints(y.map((t1)=>[
                        e1.d$(m, t1),
                        e1.d$(_, t1),
                        e1.d$(f, t1)
                    ]));
                const b = e1.bS([], v.center, g);
                0 === e1.eR(b) && e1.eS(b, 0, 0, 1), e1.cg(b, b), e1.dY(b, b, e1.cT), a.center = e1.eT(b);
                const x = a.getWorldToCameraMatrix(), w = e1.aZ(new Float64Array(16), x);
                v = e1.eQ.applyTransform(v, e1.a1([], x, g));
                const T = this._extendAABB(v, a, l, r);
                if (!T) return void e1.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                v = T, e1.bS(b, b, x);
                const S = .5 * (v.max[2] - v.min[2]), C = this._minimumAABBFrustumDistance(a, v), E = e1.dY([], [
                    0,
                    0,
                    1
                ], S), I = e1.dZ(E, b, E), D = C + (0 === a.pitch ? 0 : e1.eU(b, I)), P = a.globeCenterInViewSpace, L = e1.cQ([], b, [
                    P[0],
                    P[1],
                    P[2]
                ]);
                e1.cg(L, L), e1.dY(L, L, D);
                const R = e1.dZ([], b, L);
                e1.bS(R, R, w);
                const A = e1.bu / e1.cT, M = e1.en(R), F = e1.ca(Math.max(M * A - e1.bu, Number.EPSILON), 0), O = Math.min(a.zoomFromMercatorZAdjusted(F), l.maxZoom);
                return O > .5 * (e1.ek + e1.bc) ? (a.setProjection({
                    name: "mercator"
                }), a.zoom = O, this._cameraForBounds(a, i, s, r, o, n)) : {
                    center: a.center,
                    zoom: O,
                    bearing: r,
                    pitch: o
                };
            }
            _extendAABB(t1, i, s, r) {
                const o = .5 * ((s.padding.left || 0) + (s.padding.right || 0)), n = .5 * ((s.padding.top || 0) + (s.padding.bottom || 0)), a = n, l = o, c = o, h = n, d = i.width - (l + c), u = i.height - (a + h), p = e1.cQ([], t1.max, t1.min), f = Math.min(d / p[0], u / p[1]), m = Math.min(i.scaleZoom(i.scale * f), s.maxZoom);
                if (isNaN(m)) return null;
                const _ = i.scale / i.zoomScale(m), g = new e1.eQ([
                    t1.min[0] - l * _,
                    t1.min[1] - h * _,
                    t1.min[2]
                ], [
                    t1.max[0] + c * _,
                    t1.max[1] + a * _,
                    t1.max[2]
                ]), y = ("number" == typeof s.offset.x && "number" == typeof s.offset.y ? new e1.P(s.offset.x, s.offset.y) : e1.P.convert(s.offset)).rotate(-e1.aF(r));
                return g.center[0] -= y.x * _, g.center[1] += y.y * _, g;
            }
            queryTerrainElevation(t1, i) {
                const s = this.transform.elevation;
                return s ? (i = {
                    exaggerated: !0,
                    ...i
                }, s.getAtPoint(e1.b$.fromLngLat(t1), null, i.exaggerated)) : null;
            }
            _cameraForBounds(t1, i, s, r, o, n) {
                if ("globe" === t1.projection.name) return this._cameraForBoundsOnGlobe(t1, i, s, r, o, n);
                const a = t1.clone(), l = this._extendCameraOptions(n);
                a.bearing = r, a.pitch = o;
                const c = e1.cJ.convert(i), h = e1.cJ.convert(s), d = new e1.cJ(c.lng, h.lat), u = new e1.cJ(h.lng, c.lat), p = a.project(c), f = a.project(h), m = this.queryTerrainElevation(c), _ = this.queryTerrainElevation(h), g = this.queryTerrainElevation(d), y = this.queryTerrainElevation(u), v = [
                    [
                        p.x,
                        p.y,
                        Math.min(m || 0, _ || 0, g || 0, y || 0)
                    ],
                    [
                        f.x,
                        f.y,
                        Math.max(m || 0, _ || 0, g || 0, y || 0)
                    ]
                ];
                let b = e1.eQ.fromPoints(v);
                const x = a.getWorldToCameraMatrix(), w = e1.aZ(new Float64Array(16), x);
                b = e1.eQ.applyTransform(b, x);
                const T = this._extendAABB(b, a, l, r);
                if (!T) return void e1.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                b = T;
                const S = .5 * e1.cQ([], b.max, b.min)[2], C = this._minimumAABBFrustumDistance(a, b), E = [
                    0,
                    0,
                    1,
                    0
                ];
                e1.cd(E, E, x), e1.eV(E, E);
                const I = e1.dY([], E, C + S), D = e1.dZ([], b.center, I);
                e1.bS(b.center, b.center, w), e1.bS(D, D, w);
                const P = a.unproject(new e1.P(b.center[0], b.center[1])), L = e1.eW(a.projection, P), R = Math.pow(2, L), A = Math.min(a._zoomFromMercatorZ(D[2] * a.pixelsPerMeter * R / a.worldSize), l.maxZoom);
                return a.mercatorFromTransition && A < .5 * (e1.ek + e1.bc) ? (a.setProjection({
                    name: "globe"
                }), a.zoom = A, this._cameraForBounds(a, i, s, r, o, n)) : {
                    center: P,
                    zoom: A,
                    bearing: r,
                    pitch: o
                };
            }
            fitBounds(e1, t1, i) {
                const s = this.cameraForBounds(e1, t1);
                return this._fitInternal(s, t1, i);
            }
            fitScreenCoordinates(t1, i, s, r, o) {
                const n = e1.P.convert(t1), a = e1.P.convert(i), l = new e1.P(Math.min(n.x, a.x), Math.min(n.y, a.y)), c = new e1.P(Math.max(n.x, a.x), Math.max(n.y, a.y));
                if ("mercator" === this.transform.projection.name && this.transform.anyCornerOffEdge(n, a)) return this;
                const h = this.transform.pointLocation3D(l), d = this.transform.pointLocation3D(c), u = this.transform.pointLocation3D(new e1.P(l.x, c.y)), p = this.transform.pointLocation3D(new e1.P(c.x, l.y)), f = [
                    Math.min(h.lng, d.lng, u.lng, p.lng),
                    Math.min(h.lat, d.lat, u.lat, p.lat)
                ], m = [
                    Math.max(h.lng, d.lng, u.lng, p.lng),
                    Math.max(h.lat, d.lat, u.lat, p.lat)
                ], _ = r && r.pitch ? r.pitch : this.getPitch(), g = this._cameraForBounds(this.transform, f, m, s, _, r);
                return this._fitInternal(g, r, o);
            }
            _fitInternal(e1, t1, i) {
                return e1 ? (t1 = Object.assign(e1, t1)).linear ? this.easeTo(t1, i) : this.flyTo(t1, i) : this;
            }
            jumpTo(t1, i) {
                this._stop({
                    keepGesture: "ifPointerDown"
                });
                const s = t1.preloadOnly ? this.transform.clone() : this.transform;
                let r = !1, o = !1, n = !1;
                "zoom" in t1 && s.zoom !== +t1.zoom && (r = !0, s.zoom = +t1.zoom), void 0 !== t1.center && (s.center = e1.cJ.convert(t1.center)), "bearing" in t1 && s.bearing !== +t1.bearing && (o = !0, s.bearing = +t1.bearing), "pitch" in t1 && s.pitch !== +t1.pitch && (n = !0, s.pitch = +t1.pitch), "fov" in t1 && (s.fov = +t1.fov);
                const a = "number" == typeof t1.padding ? this._extendPadding(t1.padding) : t1.padding;
                if (null != t1.padding && !s.isPaddingEqual(a)) {
                    if (!1 === t1.retainPadding) {
                        const e1 = s.clone();
                        e1.padding = a, s.setLocationAtPoint(s.center, e1.centerPoint);
                    } else s.padding = a;
                }
                return t1.preloadOnly ? (this._preloadTiles(s), this) : (this.fire(new e1.i("movestart", i)).fire(new e1.i("move", i)), r && this.fire(new e1.i("zoomstart", i)).fire(new e1.i("zoom", i)).fire(new e1.i("zoomend", i)), o && this.fire(new e1.i("rotatestart", i)).fire(new e1.i("rotate", i)).fire(new e1.i("rotateend", i)), n && this.fire(new e1.i("pitchstart", i)).fire(new e1.i("pitch", i)).fire(new e1.i("pitchend", i)), this.fire(new e1.i("moveend", i)));
            }
            getFreeCameraOptions() {
                return this.transform.projection.supportsFreeCamera || e1.w(nc), this.transform.getFreeCameraOptions();
            }
            setFreeCameraOptions(t1, i) {
                const s = this.transform;
                if (!s.projection.supportsFreeCamera) return e1.w(nc), this;
                this.stop();
                const r = s.zoom, o = s.pitch, n = s.bearing;
                s.setFreeCameraOptions(t1);
                const a = r !== s.zoom, l = o !== s.pitch, c = n !== s.bearing;
                return this.fire(new e1.i("movestart", i)).fire(new e1.i("move", i)), a && this.fire(new e1.i("zoomstart", i)).fire(new e1.i("zoom", i)).fire(new e1.i("zoomend", i)), c && this.fire(new e1.i("rotatestart", i)).fire(new e1.i("rotate", i)).fire(new e1.i("rotateend", i)), l && this.fire(new e1.i("pitchstart", i)).fire(new e1.i("pitch", i)).fire(new e1.i("pitchend", i)), this.fire(new e1.i("moveend", i)), this;
            }
            easeTo(t1, i) {
                this._stop({
                    easeId: t1.easeId
                }), (!1 === (t1 = {
                    offset: [
                        0,
                        0
                    ],
                    duration: 500,
                    easing: e1.eJ,
                    ...t1
                }).animate || this._prefersReducedMotion(t1)) && (t1.duration = 0);
                const s = t1.preloadOnly ? this.transform.clone() : this.transform, r = this.getZoom(), o = this.getBearing(), n = this.getPitch(), a = this.getPadding(), l = this.getVerticalFieldOfView(), c = "zoom" in t1 ? +t1.zoom : r, h = "bearing" in t1 ? this._normalizeBearing(t1.bearing, o) : o, d = "pitch" in t1 ? +t1.pitch : n, u = "fov" in t1 ? +t1.fov : l, p = this._extendPadding(t1.padding), f = e1.P.convert(t1.offset);
                let m, _, g;
                if ("globe" === s.projection.name) {
                    const i = e1.b$.fromLngLat(s.center), r = f.rotate(-s.angle);
                    i.x += r.x / s.worldSize, i.y += r.y / s.worldSize;
                    const o = i.toLngLat(), n = e1.cJ.convert(t1.center || o);
                    this._normalizeCenter(n), m = s.centerPoint.add(r), _ = new e1.P(i.x, i.y).mult(s.worldSize), g = new e1.P(e1.ad(n.lng), e1.ae(n.lat)).mult(s.worldSize).sub(_);
                } else {
                    m = s.centerPoint.add(f);
                    const i = s.pointLocation(m), r = e1.cJ.convert(t1.center || i);
                    this._normalizeCenter(r), _ = s.project(i), g = s.project(r).sub(_);
                }
                const y = s.zoomScale(c - r);
                let v, b;
                t1.around && (v = e1.cJ.convert(t1.around), b = s.locationPoint(v));
                const x = this._zooming || c !== r, w = this._rotating || o !== h, T = this._pitching || d !== n, S = u !== l, C = !s.isPaddingEqual(p), E = !1 === t1.retainPadding ? s.clone() : s, I = (s)=>(I)=>{
                        if (x && (s.zoom = e1.aw(r, c, I)), w && (s.bearing = e1.aw(o, h, I)), T && (s.pitch = e1.aw(n, d, I)), S && (s.fov = e1.aw(l, u, I)), C && (E.interpolatePadding(a, p, I), m = E.centerPoint.add(f)), v) s.setLocationAtPoint(v, b);
                        else {
                            const e1 = s.zoomScale(s.zoom - r), t1 = c > r ? Math.min(2, y) : Math.max(.5, y), i = Math.pow(t1, 1 - I), o = s.unproject(_.add(g.mult(I * i)).mult(e1));
                            s.setLocationAtPoint(s.renderWorldCopies ? o.wrap() : o, m);
                        }
                        return t1.preloadOnly || this._fireMoveEvents(i), s;
                    };
                if (t1.preloadOnly) {
                    const e1 = this._emulate(I, t1.duration, s);
                    return this._preloadTiles(e1), this;
                }
                const D = {
                    moving: this._moving,
                    zooming: this._zooming,
                    rotating: this._rotating,
                    pitching: this._pitching
                };
                return this._zooming = x, this._rotating = w, this._pitching = T, this._padding = C, this._easeId = t1.easeId, this._prepareEase(i, t1.noMoveStart, D), this._ease(I(s), (e1)=>{
                    "sea" === s.cameraElevationReference && s.recenterOnTerrain(), this._afterEase(i, e1);
                }, t1), this;
            }
            _prepareEase(t1, i, s = {}) {
                this._moving = !0, this.transform.cameraElevationReference = "sea", this.transform._orthographicProjectionAtLowPitch && 0 === this.transform.pitch && "globe" !== this.transform.projection.name && (this.transform.cameraElevationReference = "ground"), i || s.moving || this.fire(new e1.i("movestart", t1)), this._zooming && !s.zooming && this.fire(new e1.i("zoomstart", t1)), this._rotating && !s.rotating && this.fire(new e1.i("rotatestart", t1)), this._pitching && !s.pitching && this.fire(new e1.i("pitchstart", t1));
            }
            _fireMoveEvents(t1) {
                this.fire(new e1.i("move", t1)), this._zooming && this.fire(new e1.i("zoom", t1)), this._rotating && this.fire(new e1.i("rotate", t1)), this._pitching && this.fire(new e1.i("pitch", t1));
            }
            _afterEase(t1, i) {
                if (this._easeId && i && this._easeId === i) return;
                this._easeId = void 0, this.transform.cameraElevationReference = "ground";
                const s = this._zooming, r = this._rotating, o = this._pitching;
                this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._padding = !1, s && this.fire(new e1.i("zoomend", t1)), r && this.fire(new e1.i("rotateend", t1)), o && this.fire(new e1.i("pitchend", t1)), this.fire(new e1.i("moveend", t1));
            }
            flyTo(t1, i) {
                if (this._prefersReducedMotion(t1)) {
                    const s = e1.cx(t1, [
                        "center",
                        "zoom",
                        "bearing",
                        "pitch",
                        "fov",
                        "around",
                        "padding",
                        "retainPadding"
                    ]);
                    return this.jumpTo(s, i);
                }
                this.stop();
                const s = (t1 = {
                    offset: [
                        0,
                        0
                    ],
                    speed: 1.2,
                    curve: 1.42,
                    easing: e1.eJ,
                    ...t1
                }).preloadOnly ? this.transform.clone() : this.transform, r = this.getZoom(), o = this.getBearing(), n = this.getPitch(), a = this.getPadding(), l = this.getVerticalFieldOfView(), c = "zoom" in t1 ? e1.bb(+t1.zoom, s.minZoom, s.maxZoom) : r, h = "bearing" in t1 ? this._normalizeBearing(t1.bearing, o) : o, d = "pitch" in t1 ? +t1.pitch : n, u = "fov" in t1 ? +t1.fov : l, p = u !== l, f = this._extendPadding(t1.padding), m = s.zoomScale(c - r), _ = e1.P.convert(t1.offset);
                let g = s.centerPoint.add(_);
                const y = s.pointLocation(g), v = e1.cJ.convert(t1.center || y);
                this._normalizeCenter(v);
                const b = s.project(y), x = s.project(v).sub(b);
                let w = t1.curve;
                const T = Math.max(s.width, s.height), S = T / m, C = x.mag();
                if ("minZoom" in t1) {
                    const i = e1.bb(Math.min(t1.minZoom, r, c), s.minZoom, s.maxZoom), o = T / s.zoomScale(i - r);
                    w = Math.sqrt(o / C * 2);
                }
                const E = w * w;
                function I(e1) {
                    return -Math.asinh((S * S - T * T + (e1 ? -1 : 1) * E * E * C * C) / (2 * (e1 ? S : T) * E * C));
                }
                function D(e1) {
                    return (Math.exp(e1) - Math.exp(-e1)) / 2;
                }
                function P(e1) {
                    return (Math.exp(e1) + Math.exp(-e1)) / 2;
                }
                const L = I(0);
                let R = function(e1) {
                    return P(L) / P(L + w * e1);
                }, A = function(e1) {
                    var t1;
                    return T * ((P(L) * (D(t1 = L + w * e1) / P(t1)) - D(L)) / E) / C;
                }, M = (I(1) - L) / w;
                if (Math.abs(C) < 1e-6 || !isFinite(M)) {
                    if (Math.abs(T - S) < 1e-6) return this.easeTo(t1, i);
                    const e1 = S < T ? -1 : 1;
                    M = Math.abs(Math.log(S / T)) / w, A = function() {
                        return 0;
                    }, R = function(t1) {
                        return Math.exp(e1 * w * t1);
                    };
                }
                t1.duration = "duration" in t1 ? +t1.duration : 1e3 * M / ("screenSpeed" in t1 ? +t1.screenSpeed / w : +t1.speed), t1.maxDuration && t1.duration > t1.maxDuration && (t1.duration = 0);
                const F = o !== h, O = d !== n, k = !s.isPaddingEqual(f), B = !1 === t1.retainPadding ? s.clone() : s, z = (s)=>(m)=>{
                        const y = m * M, w = 1 / R(y);
                        s.zoom = 1 === m ? c : r + s.scaleZoom(w), F && (s.bearing = e1.aw(o, h, m)), O && (s.pitch = e1.aw(n, d, m)), p && (s.fov = e1.aw(l, u, m)), k && (B.interpolatePadding(a, f, m), g = B.centerPoint.add(_));
                        const T = 1 === m ? v : s.unproject(b.add(x.mult(A(y))).mult(w));
                        return s.setLocationAtPoint(s.renderWorldCopies ? T.wrap() : T, g), s._updateCameraOnTerrain(), t1.preloadOnly || this._fireMoveEvents(i), s;
                    };
                if (t1.preloadOnly) {
                    const e1 = this._emulate(z, t1.duration, s);
                    return this._preloadTiles(e1), this;
                }
                return this._zooming = !0, this._rotating = F, this._pitching = O, this._padding = k, this._prepareEase(i, !1), this._ease(z(s), ()=>this._afterEase(i), t1), this;
            }
            isEasing() {
                return !!this._easeFrameId;
            }
            stop() {
                return this._stop();
            }
            _requestRenderFrame(e1) {}
            _cancelRenderFrame(e1) {}
            _stop({ easeId: e1, keepGesture: t1 } = {}) {
                if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), this._easeFrameId = void 0, this._onEaseFrame = void 0), this._onEaseEnd) {
                    const t1 = this._onEaseEnd;
                    this._onEaseEnd = void 0, t1.call(this, e1);
                }
                const i = this.handlers;
                return i && i.stop(t1), this;
            }
            _ease(t1, i, s) {
                !1 === s.animate || 0 === s.duration ? (t1(1), i()) : (this._easeStart = e1.e.now(), this._easeOptions = s, this._onEaseFrame = t1, this._onEaseEnd = i, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
            }
            _renderFrameCallback() {
                const t1 = Math.min((e1.e.now() - this._easeStart) / this._easeOptions.duration, 1), i = this._onEaseFrame;
                i && i(this._easeOptions.easing(t1)), t1 < 1 ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
            }
            _normalizeBearing(t1, i) {
                t1 = e1.dc(t1, -180, 180);
                const s = Math.abs(t1 - i);
                return Math.abs(t1 - 360 - i) < s && (t1 -= 360), Math.abs(t1 + 360 - i) < s && (t1 += 360), t1;
            }
            _normalizeCenter(e1) {
                const t1 = this.transform;
                if (t1.maxBounds) return;
                if ("globe" !== t1.projection.name && !t1.renderWorldCopies) return;
                const i = e1.lng - t1.center.lng;
                e1.lng += i > 180 ? -360 : i < -180 ? 360 : 0;
            }
            _prefersReducedMotion(t1) {
                return this._respectPrefersReducedMotion && e1.e.prefersReducedMotion && !(t1 && t1.essential);
            }
            _emulate(e1, t1, i) {
                const s = Math.ceil(15 * t1 / 1e3), r = [], o = e1(i.clone());
                for(let e1 = 0; e1 <= s; e1++){
                    const t1 = o(e1 / s);
                    r.push(t1.clone());
                }
                return r;
            }
            _preloadTiles(e1, t1) {}
        }
        const lc = /^(https?:|mailto:)/i;
        class cc {
            constructor(t1 = {}){
                this.options = t1, e1.b4([
                    "_toggleAttribution",
                    "_updateEditLink",
                    "_updateData",
                    "_updateCompact"
                ], this);
            }
            getDefaultPosition() {
                return "bottom-right";
            }
            onAdd(e1) {
                const t1 = this.options && this.options.compact, i = e1._getUIString("AttributionControl.ToggleAttribution");
                this._map = e1, this._container = a("div", "mapboxgl-ctrl mapboxgl-ctrl-attrib"), this._compactButton = a("button", "mapboxgl-ctrl-attrib-button", this._container), this._compactButton.type = "button", this._compactButton.addEventListener("click", this._toggleAttribution), this._compactButton.setAttribute("aria-label", i);
                const s = a("span", "mapboxgl-ctrl-icon", this._compactButton);
                return s.setAttribute("aria-hidden", "true"), s.setAttribute("title", i), this._innerContainer = a("div", "mapboxgl-ctrl-attrib-inner", this._container), t1 && this._container.classList.add("mapboxgl-compact"), this._updateAttributions(), this._updateEditLink(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("moveend", this._updateEditLink), void 0 === t1 && (this._map.on("resize", this._updateCompact), this._updateCompact()), this._container;
            }
            onRemove() {
                this._container.remove(), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("moveend", this._updateEditLink), this._map.off("resize", this._updateCompact), this._map = void 0, this._attribHTML = void 0;
            }
            _toggleAttribution() {
                this._container.classList.contains("mapboxgl-compact-show") ? (this._container.classList.remove("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "false")) : (this._container.classList.add("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "true"));
            }
            _updateEditLink() {
                let t1 = this._editLink;
                t1 || (t1 = this._editLink = this._container.querySelector(".mapbox-improve-map"));
                const i = [
                    {
                        key: "owner",
                        value: this.styleOwner
                    },
                    {
                        key: "id",
                        value: this.styleId
                    },
                    {
                        key: "access_token",
                        value: this._map._requestManager._customAccessToken || e1.t.ACCESS_TOKEN
                    }
                ];
                if (t1) {
                    const s = i.reduce((e1, t1, s)=>(t1.value && (e1 += `${t1.key}=${t1.value}${s < i.length - 1 ? "&" : ""}`), e1), "?");
                    t1.href = `${e1.t.FEEDBACK_URL}/${s}#${nl(this._map, !0)}`, t1.rel = "noopener nofollow";
                }
            }
            _updateData(e1) {
                !e1 || ("source" !== e1.dataType || "metadata" !== e1.sourceDataType && "visibility" !== e1.sourceDataType) && "style" !== e1.dataType || (this._updateAttributions(), this._updateEditLink());
            }
            _updateAttributions() {
                if (!this._map.style) return;
                let e1 = [];
                if (this._map.style.stylesheet) {
                    const e1 = this._map.style.stylesheet;
                    this.styleOwner = e1.owner, this.styleId = e1.id;
                }
                const t1 = this._map.style._mergedSourceCaches;
                for(const i in t1){
                    const s = t1[i];
                    if (s.used) {
                        const t1 = s.getSource();
                        t1.attribution && !e1.includes(t1.attribution) && e1.push(t1.attribution);
                    }
                }
                e1.sort((e1, t1)=>e1.length - t1.length), e1 = e1.filter((t1, i)=>{
                    for(let s = i + 1; s < e1.length; s++)if (e1[s].includes(t1)) return !1;
                    return !0;
                }), this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? e1 = [
                    ...this.options.customAttribution,
                    ...e1
                ] : e1.unshift(this.options.customAttribution));
                const i = e1.map((e1)=>(function(e1) {
                        const t1 = (new DOMParser).parseFromString(e1, "text/html");
                        return Array.from(t1.body.querySelectorAll("*")).reverse().forEach((e1)=>{
                            const i = e1.textContent || "";
                            if ("A" !== e1.tagName) return void e1.replaceWith(...e1.childNodes);
                            const s = e1.getAttribute("href");
                            if (!s || !lc.test(s)) return void e1.replaceWith(t1.createTextNode(i));
                            const r = t1.createElement("a");
                            r.href = s, r.textContent = i, r.rel = "noopener nofollow";
                            const o = e1.getAttribute("class");
                            o && (r.className = o), e1.replaceWith(r);
                        }), t1.body.innerHTML;
                    })(e1)).join(" | ");
                i !== this._attribHTML && (this._attribHTML = i, e1.length ? (this._innerContainer.innerHTML = i, this._container.classList.remove("mapboxgl-attrib-empty")) : this._container.classList.add("mapboxgl-attrib-empty"), this._editLink = null);
            }
            _updateCompact() {
                this._map.getCanvasContainer().offsetWidth <= 640 ? this._container.classList.add("mapboxgl-compact") : this._container.classList.remove("mapboxgl-compact", "mapboxgl-compact-show");
            }
        }
        class hc {
            constructor(){
                e1.b4([
                    "_updateLogo",
                    "_updateCompact"
                ], this);
            }
            onAdd(e1) {
                this._map = e1, this._container = a("div", "mapboxgl-ctrl");
                const t1 = a("a", "mapboxgl-ctrl-logo");
                return t1.target = "_blank", t1.rel = "noopener nofollow", t1.href = "https://www.mapbox.com/", t1.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), t1.setAttribute("rel", "noopener nofollow"), this._container.appendChild(t1), this._container.style.display = "none", this._map.on("sourcedata", this._updateLogo), this._updateLogo(), this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
            }
            onRemove() {
                this._container.remove(), this._map.off("sourcedata", this._updateLogo), this._map.off("resize", this._updateCompact);
            }
            getDefaultPosition() {
                return "bottom-left";
            }
            _updateLogo(e1) {
                e1 && "metadata" !== e1.sourceDataType || (this._container.style.display = this._logoRequired() ? "block" : "none");
            }
            _logoRequired() {
                if (!this._map.style) return !0;
                const e1 = this._map.style._sourceCaches;
                if (0 === Object.entries(e1).length) return !0;
                for(const t1 in e1){
                    const i = e1[t1].getSource();
                    if (Object.hasOwn(i, "mapbox_logo") && !i.mapbox_logo) return !1;
                }
                return !0;
            }
            _updateCompact() {
                const e1 = this._container.children;
                if (e1.length) {
                    const t1 = e1[0];
                    this._map.getCanvasContainer().offsetWidth < 250 ? t1.classList.add("mapboxgl-compact") : t1.classList.remove("mapboxgl-compact");
                }
            }
        }
        class dc {
            constructor(){
                this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
            }
            add(e1) {
                const t1 = ++this._id;
                return this._queue.push({
                    callback: e1,
                    id: t1,
                    cancelled: !1
                }), t1;
            }
            remove(e1) {
                const t1 = this._currentlyRunning, i = t1 ? this._queue.concat(t1) : this._queue;
                for (const t1 of i)if (t1.id === e1) return void (t1.cancelled = !0);
            }
            run(e1 = 0) {
                const t1 = this._currentlyRunning = this._queue;
                this._queue = [];
                for (const i of t1)if (!i.cancelled && (i.callback(e1), this._cleared)) break;
                this._cleared = !1, this._currentlyRunning = !1;
            }
            clear() {
                this._currentlyRunning && (this._cleared = !0), this._queue = [];
            }
        }
        class uc {
            constructor(e1){
                this.jumpTo(e1);
            }
            getValue(t1) {
                if (t1 <= this._startTime) return this._start;
                if (t1 >= this._endTime) return this._end;
                const i = e1.c5((t1 - this._startTime) / (this._endTime - this._startTime));
                return this._start * (1 - i) + this._end * i;
            }
            isEasing(e1) {
                return e1 >= this._startTime && e1 <= this._endTime;
            }
            jumpTo(e1) {
                this._startTime = -1 / 0, this._endTime = -1 / 0, this._start = e1, this._end = e1;
            }
            easeTo(e1, t1, i) {
                this._start = this.getValue(t1), this._end = e1, this._startTime = t1, this._endTime = t1 + i;
            }
        }
        const pc = {
            "AttributionControl.ToggleAttribution": "Toggle attribution",
            "FullscreenControl.Enter": "Enter fullscreen",
            "FullscreenControl.Exit": "Exit fullscreen",
            "GeolocateControl.FindMyLocation": "Find my location",
            "GeolocateControl.LocationNotAvailable": "Location not available",
            "LogoControl.Title": "Mapbox homepage",
            "Map.Title": "Map",
            "NavigationControl.ResetBearing": "Reset bearing to north",
            "NavigationControl.ZoomIn": "Zoom in",
            "NavigationControl.ZoomOut": "Zoom out",
            "ScrollZoomBlocker.CtrlMessage": "Use ctrl + scroll to zoom the map",
            "ScrollZoomBlocker.CmdMessage": "Use \u2318 + scroll to zoom the map",
            "TouchPanBlocker.Message": "Use two fingers to move the map"
        };
        class fc extends e1.i {
            constructor(e1, t1, i, s){
                const { point: r, lngLat: o, originalEvent: n, target: a } = e1;
                super(e1.type, {
                    point: r,
                    lngLat: o,
                    originalEvent: n,
                    target: a
                }), this.preventDefault = ()=>{
                    e1.preventDefault();
                }, this.id = t1, this.interaction = i, this.feature = s;
            }
        }
        class mc {
            constructor(e1){
                this.map = e1, this.interactionsByType = new Map, this.delegatedInteractions = new Map, this.typeById = new Map, this.filters = new Map, this.handleType = this.handleType.bind(this), this.handleMove = this.handleMove.bind(this), this.handleOut = this.handleOut.bind(this), this.hoveredFeatures = new Map, this.prevHoveredFeatures = new Map;
            }
            add(t1, i) {
                if (this.typeById.has(t1)) throw new Error(`Interaction id "${t1}" already exists.`);
                const s = i.filter;
                let r = i.type;
                s && this.filters.set(t1, e1.bH(s)), "mouseover" === r && (r = "mouseenter"), "mouseout" === r && (r = "mouseleave");
                const o = this.interactionsByType.get(r) || new Map;
                "mouseenter" === r || "mouseleave" === r ? (0 === this.delegatedInteractions.size && (this.map.on("mousemove", this.handleMove), this.map.on("mouseout", this.handleOut)), this.delegatedInteractions.set(t1, i)) : 0 === o.size && this.map.on(r, this.handleType), 0 === o.size && this.interactionsByType.set(r, o), o.set(t1, i), this.typeById.set(t1, r);
            }
            get(e1) {
                const t1 = this.typeById.get(e1);
                if (!t1) return;
                const i = this.interactionsByType.get(t1);
                return i ? i.get(e1) : void 0;
            }
            remove(e1) {
                const t1 = this.typeById.get(e1);
                if (!t1) return;
                this.typeById.delete(e1), this.filters.delete(e1);
                const i = this.interactionsByType.get(t1);
                i && (i.delete(e1), "mouseenter" === t1 || "mouseleave" === t1 ? (this.delegatedInteractions.delete(e1), 0 === this.delegatedInteractions.size && (this.map.off("mousemove", this.handleMove), this.map.off("mouseout", this.handleOut))) : 0 === i.size && this.map.off(t1, this.handleType));
            }
            queryTargets(e1, t1) {
                const i = [];
                for (const [e1, s] of t1)s.target && i.push({
                    targetId: e1,
                    target: s.target,
                    filter: this.filters.get(e1)
                });
                return this.map.style.queryRenderedTargets(e1, i, this.map.transform);
            }
            handleMove(e1) {
                this.prevHoveredFeatures = this.hoveredFeatures, this.hoveredFeatures = new Map;
                const t1 = this.queryTargets(e1.point, Array.from(this.delegatedInteractions).reverse());
                t1.length && (e1.type = "mouseenter", this.handleType(e1, t1));
                const i = new Map;
                for (const [e1, { feature: t1 }] of this.prevHoveredFeatures)this.hoveredFeatures.has(e1) || i.set(t1.id, t1);
                i.size && (e1.type = "mouseleave", this.handleType(e1, Array.from(i.values())));
            }
            handleOut(e1) {
                const t1 = Array.from(this.hoveredFeatures.values()).map(({ feature: e1 })=>e1);
                t1.length && (e1.type = "mouseleave", this.handleType(e1, t1)), this.hoveredFeatures.clear();
            }
            handleType(t1, i) {
                const s = "mouseenter" === t1.type;
                if (s && !this.interactionsByType.has(t1.type)) return void e1.w("mouseenter interaction required for mouseleave to work.");
                const r = Array.from(this.interactionsByType.get(t1.type)).reverse(), o = !!i;
                i = i || this.queryTargets(t1.point, r);
                let n = !1;
                const a = new Set;
                for (const l of i){
                    for (const [i, c] of r){
                        if (!c.target) continue;
                        const r = l.variants ? l.variants[i] : null;
                        if (r) {
                            for (const h of r){
                                if ($o(h, l, a, i)) continue;
                                const r = new e1.dU(l, h), d = qo(h, l, i);
                                o && void 0 !== r.id && (r.state = this.map.getFeatureState(r));
                                const u = s ? this.prevHoveredFeatures.get(d) : null, p = new fc(t1, i, c, r), f = u ? u.stop : c.handler(p);
                                if (s && this.hoveredFeatures.set(d, {
                                    feature: l,
                                    stop: f
                                }), !1 !== f) {
                                    n = !0;
                                    break;
                                }
                            }
                            if (n) break;
                        }
                    }
                    if (n) break;
                }
                if (!n) for (const [e1, i] of r){
                    const { handler: s, target: r } = i;
                    if (!r && !1 !== s(new fc(t1, e1, i, null))) break;
                }
            }
        }
        function _c(t1, i) {
            if (Array.isArray(t1) && Array.isArray(i)) {
                const e1 = new Set(t1), s = new Set(i);
                return e1.size === s.size && t1.every((e1)=>s.has(e1));
            }
            return e1.Y(t1, i);
        }
        const gc = /matrix.*\((.+)\)/, yc = {
            center: [
                0,
                0
            ],
            zoom: 0,
            bearing: 0,
            pitch: 0,
            minZoom: -2,
            maxZoom: 22,
            minPitch: 0,
            maxPitch: 85,
            interactive: !0,
            scrollZoom: !0,
            boxZoom: !0,
            dragRotate: !0,
            dragPan: !0,
            keyboard: !0,
            doubleClickZoom: !0,
            touchZoomRotate: !0,
            touchPitch: !0,
            cooperativeGestures: !1,
            performanceMetricsCollection: !0,
            bearingSnap: 7,
            clickTolerance: 3,
            pitchWithRotate: !0,
            hash: !1,
            attributionControl: !0,
            antialias: !1,
            failIfMajorPerformanceCaveat: !1,
            preserveDrawingBuffer: !1,
            trackResize: !0,
            renderWorldCopies: !0,
            refreshExpiredTiles: !0,
            minTileCacheSize: null,
            maxTileCacheSize: null,
            localIdeographFontFamily: "sans-serif",
            localFontFamily: null,
            fontstackCompositing: "client",
            transformRequest: null,
            accessToken: null,
            fadeDuration: 300,
            respectPrefersReducedMotion: !0,
            crossSourceCollisions: !0,
            collectResourceTiming: !1,
            testMode: !1,
            precompilePrograms: !0,
            scaleFactor: 1,
            emissiveColorPrecision: "approximate"
        }, vc = {
            showCompass: !0,
            showZoom: !0,
            visualizePitch: !1
        };
        class bc {
            constructor(t1, i, s = !1){
                this._clickTolerance = 10, this.element = i, this.mouseRotate = new Rl({
                    clickTolerance: t1.dragRotate._mouseRotate._clickTolerance
                }), this.map = t1, s && (this.mousePitch = new Al({
                    clickTolerance: t1.dragRotate._mousePitch._clickTolerance
                })), e1.b4([
                    "mousedown",
                    "mousemove",
                    "mouseup",
                    "touchstart",
                    "touchmove",
                    "touchend",
                    "reset"
                ], this), i.addEventListener("mousedown", this.mousedown), i.addEventListener("touchstart", this.touchstart, {
                    passive: !1
                }), i.addEventListener("touchmove", this.touchmove), i.addEventListener("touchend", this.touchend), i.addEventListener("touchcancel", this.reset);
            }
            down(e1, t1) {
                this.mouseRotate.mousedown(e1, t1), this.mousePitch && this.mousePitch.mousedown(e1, t1), u1();
            }
            move(e1, t1) {
                const i = this.map, s = this.mouseRotate.mousemoveWindow(e1, t1), r = s && s.bearingDelta;
                if (r && i.setBearing(i.getBearing() + r), this.mousePitch) {
                    const s = this.mousePitch.mousemoveWindow(e1, t1), r = s && s.pitchDelta;
                    r && i.setPitch(i.getPitch() + r);
                }
            }
            off() {
                const e1 = this.element;
                e1.removeEventListener("mousedown", this.mousedown), e1.removeEventListener("touchstart", this.touchstart), e1.removeEventListener("touchmove", this.touchmove), e1.removeEventListener("touchend", this.touchend), e1.removeEventListener("touchcancel", this.reset), this.offTemp();
            }
            offTemp() {
                p(), window.removeEventListener("mousemove", this.mousemove), window.removeEventListener("mouseup", this.mouseup);
            }
            mousedown(e1) {
                this.down({
                    ...e1,
                    button: e1.button,
                    type: e1.type,
                    ctrlKey: !0,
                    preventDefault: ()=>e1.preventDefault()
                }, _(this.element, e1)), window.addEventListener("mousemove", this.mousemove), window.addEventListener("mouseup", this.mouseup);
            }
            mousemove(e1) {
                this.move(e1, _(this.element, e1));
            }
            mouseup(e1) {
                this.mouseRotate.mouseupWindow(e1), this.mousePitch && this.mousePitch.mouseupWindow(e1), this.offTemp();
            }
            touchstart(e1) {
                1 !== e1.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = g(this.element, e1.targetTouches)[0], this.down({
                    type: "mousedown",
                    button: 0,
                    ctrlKey: !0,
                    preventDefault: ()=>e1.preventDefault()
                }, this._startPos));
            }
            touchmove(e1) {
                1 !== e1.targetTouches.length ? this.reset() : (this._lastPos = g(this.element, e1.targetTouches)[0], this.move({
                    buttons: 1,
                    preventDefault: ()=>e1.preventDefault()
                }, this._lastPos));
            }
            touchend(e1) {
                0 === e1.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), this.reset();
            }
            reset() {
                this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
            }
        }
        function xc(t1, i, s) {
            if (t1 = new e1.cJ(t1.lng, t1.lat), i) {
                const r = new e1.cJ(t1.lng - 360, t1.lat), o = new e1.cJ(t1.lng + 360, t1.lat), n = 360 * Math.ceil(Math.abs(t1.lng - s.center.lng) / 360), a = s.locationPoint3D(t1).distSqr(i), l = i.x < 0 || i.y < 0 || i.x > s.width || i.y > s.height;
                s.locationPoint3D(r).distSqr(i) < a && (l || Math.abs(r.lng - s.center.lng) < n) ? t1 = r : s.locationPoint3D(o).distSqr(i) < a && (l || Math.abs(o.lng - s.center.lng) < n) && (t1 = o);
            }
            for(; Math.abs(t1.lng - s.center.lng) > 180;){
                const e1 = s.locationPoint3D(t1);
                if (e1.x >= 0 && e1.y >= 0 && e1.x <= s.width && e1.y <= s.height) break;
                t1.lng > s.center.lng ? t1.lng -= 360 : t1.lng += 360;
            }
            return t1;
        }
        const wc = {
            center: "translate(-50%,-50%)",
            top: "translate(-50%,0)",
            "top-left": "translate(0,0)",
            "top-right": "translate(-100%,0)",
            bottom: "translate(-50%,-100%)",
            "bottom-left": "translate(0,-100%)",
            "bottom-right": "translate(-100%,-100%)",
            left: "translate(0,-50%)",
            right: "translate(-100%,-50%)"
        }, Tc = /\s+/, Sc = {
            rotation: 0,
            rotationAlignment: "auto",
            pitchAlignment: "auto",
            occludedOpacity: .2,
            altitude: 0
        };
        class Cc extends e1.E {
            constructor(t1, i){
                super(), (t1 instanceof HTMLElement || i) && (t1 = {
                    element: t1,
                    ...i
                }), e1.b4([
                    "_update",
                    "_onMove",
                    "_onUp",
                    "_addDragHandler",
                    "_onMapClick",
                    "_onKeyPress",
                    "_clearFadeTimer"
                ], this);
                const { anchor: s = "center", color: r = "#3FB1CE", scale: o = 1, draggable: n = !1, clickTolerance: a = 0, rotation: l = Sc.rotation, rotationAlignment: c = Sc.rotationAlignment, pitchAlignment: h = Sc.pitchAlignment, occludedOpacity: d = Sc.occludedOpacity, altitude: u = Sc.altitude } = t1 || {};
                this._anchor = s, this._color = r, this._scale = o, this._draggable = n, this._clickTolerance = a, this._rotation = l, this._rotationAlignment = c, this._pitchAlignment = h, this._occludedOpacity = d, this._altitude = u, this._state = "inactive", this._isDragging = !1, this._pointerEvents = null, this._updateMoving = ()=>this._update(!0), t1 && t1.element ? (this._element = t1.element, this._offset = e1.P.convert(t1 && t1.offset || [
                    0,
                    0
                ])) : (this._defaultMarker = !0, this._element = this._createDefaultMarker(), this._offset = e1.P.convert(t1 && t1.offset || [
                    0,
                    -14
                ])), this._element.hasAttribute("aria-label") || this._element.setAttribute("aria-label", "Map marker"), this._element.hasAttribute("role") || this._element.setAttribute("role", "img"), this._element.classList.add("mapboxgl-marker"), this._element.addEventListener("dragstart", (e1)=>{
                    e1.preventDefault();
                }), this._element.addEventListener("mousedown", (e1)=>{
                    e1.preventDefault();
                });
                const p = this._element.classList;
                for(const e1 in wc)p.remove(`mapboxgl-marker-anchor-${e1}`);
                p.add(`mapboxgl-marker-anchor-${this._anchor}`), t1 && t1.className && p.add(...t1.className.trim().split(Tc)), this._popup = null;
            }
            _createDefaultMarker() {
                const e1 = a("div"), t1 = l("svg", {
                    display: "block",
                    height: 41 * this._scale + "px",
                    width: 27 * this._scale + "px",
                    viewBox: "0 0 27 41"
                }, e1);
                this._svgElement = t1;
                const i = l("radialGradient", {
                    id: "shadowGradient"
                }, l("defs", {}, t1));
                l("stop", {
                    offset: "10%",
                    "stop-opacity": .4
                }, i), l("stop", {
                    offset: "100%",
                    "stop-opacity": .05
                }, i);
                const s = l("ellipse", {
                    cx: 13.5,
                    cy: 34.8,
                    rx: 10.5,
                    ry: 5.25,
                    fill: "url(#shadowGradient)"
                });
                return this._shadowElement = s, 0 === this._altitude && t1.insertBefore(s, t1.firstChild), l("path", {
                    fill: this._color,
                    d: "M27,13.5C27,19.07 20.25,27 14.75,34.5C14.02,35.5 12.98,35.5 12.25,34.5C6.75,27 0,19.22 0,13.5C0,6.04 6.04,0 13.5,0C20.96,0 27,6.04 27,13.5Z"
                }, t1), l("path", {
                    opacity: .25,
                    d: "M13.5,0C6.04,0 0,6.04 0,13.5C0,19.22 6.75,27 12.25,34.5C13,35.52 14.02,35.5 14.75,34.5C20.25,27 27,19.07 27,13.5C27,6.04 20.96,0 13.5,0ZM13.5,1C20.42,1 26,6.58 26,13.5C26,15.9 24.5,19.18 22.22,22.74C19.95,26.3 16.71,30.14 13.94,33.91C13.74,34.18 13.61,34.32 13.5,34.44C13.39,34.32 13.26,34.18 13.06,33.91C10.28,30.13 7.41,26.31 5.02,22.77C2.62,19.23 1,15.95 1,13.5C1,6.58 6.58,1 13.5,1Z"
                }, t1), l("circle", {
                    fill: "white",
                    cx: 13.5,
                    cy: 13.5,
                    r: 5.5
                }, t1), e1;
            }
            addTo(e1) {
                return e1 === this._map || (this.remove(), this._map = e1, e1.getCanvasContainer().appendChild(this._element), e1.on("move", this._updateMoving), e1.on("moveend", this._update), e1.on("remove", this._clearFadeTimer), e1._addMarker(this), this.setDraggable(this._draggable), this._update(), e1.on("click", this._onMapClick)), this;
            }
            remove() {
                const e1 = this._map;
                return e1 && (e1.off("click", this._onMapClick), e1.off("move", this._updateMoving), e1.off("moveend", this._update), e1.off("mousedown", this._addDragHandler), e1.off("touchstart", this._addDragHandler), e1.off("mouseup", this._onUp), e1.off("touchend", this._onUp), e1.off("mousemove", this._onMove), e1.off("touchmove", this._onMove), e1.off("remove", this._clearFadeTimer), e1._removeMarker(this), this._map = void 0), this._clearFadeTimer(), this._element.remove(), this._popup && this._popup.remove(), this;
            }
            getLngLat() {
                return this._lngLat;
            }
            setLngLat(t1) {
                return this._lngLat = e1.cJ.convert(t1), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(!0), this;
            }
            setAltitude(e1) {
                if (e1 === this._altitude) return this;
                const t1 = this._altitude;
                return this._altitude = e1 || Sc.altitude, this._defaultMarker && 0 === t1 != (0 === this._altitude) && (0 === this._altitude ? this._svgElement.insertBefore(this._shadowElement, this._svgElement.firstChild) : this._shadowElement.remove()), this._update(), this;
            }
            getAltitude() {
                return this._altitude;
            }
            getElement() {
                return this._element;
            }
            setPopup(e1) {
                if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeAttribute("role"), this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), e1) {
                    if (!("offset" in e1.options)) {
                        const t1 = 38.1, i = 13.5, s = Math.sqrt(Math.pow(i, 2) / 2);
                        e1.options.offset = this._defaultMarker ? {
                            top: [
                                0,
                                0
                            ],
                            "top-left": [
                                0,
                                0
                            ],
                            "top-right": [
                                0,
                                0
                            ],
                            bottom: [
                                0,
                                -t1
                            ],
                            "bottom-left": [
                                s,
                                -1 * (t1 - i + s)
                            ],
                            "bottom-right": [
                                -s,
                                -1 * (t1 - i + s)
                            ],
                            left: [
                                i,
                                -1 * (t1 - i)
                            ],
                            right: [
                                -i,
                                -1 * (t1 - i)
                            ]
                        } : this._offset;
                    }
                    this._popup = e1, e1._marker = this, e1._altitude = this._altitude, this._lngLat && this._popup.setLngLat(this._lngLat), this._element.setAttribute("role", "button"), this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress), this._element.setAttribute("aria-expanded", "false");
                }
                return this;
            }
            _onKeyPress(e1) {
                const t1 = e1.code, i = e1.charCode || e1.keyCode;
                "Space" !== t1 && "Enter" !== t1 && 32 !== i && 13 !== i || this.togglePopup();
            }
            _onMapClick(e1) {
                const t1 = e1.originalEvent.target, i = this._element;
                this._popup && (t1 === i || i.contains(t1)) && this.togglePopup();
            }
            getPopup() {
                return this._popup;
            }
            togglePopup() {
                const e1 = this._popup;
                return e1 ? (e1.isOpen() ? (e1.remove(), this._element.setAttribute("aria-expanded", "false")) : this._map && (e1.addTo(this._map), this._element.setAttribute("aria-expanded", "true")), this) : this;
            }
            _behindTerrain() {
                const e1 = this._map, t1 = this._pos;
                if (!e1 || !t1) return !1;
                const i = e1.unproject(t1, this._altitude), s = e1.getFreeCameraOptions();
                if (!s.position) return !1;
                const r = s.position.toLngLat();
                return r.distanceTo(i) < .9 * r.distanceTo(this._lngLat);
            }
            _evaluateOpacity() {
                const t1 = this._map;
                if (!t1) return;
                const i = this._pos;
                if (!i || i.x < 0 || i.x > t1.transform.width || i.y < 0 || i.y > t1.transform.height) return void this._clearFadeTimer();
                const s = t1.unproject(i, this._altitude);
                let r;
                t1._showingGlobe() && e1.fd(t1.transform, this._lngLat) ? r = 0 : (r = 1 - t1._queryFogOpacity(s), t1.transform._terrainEnabled() && t1.style && t1.style.hasTerrain() && this._behindTerrain() && (r *= this._occludedOpacity)), this._element.style.opacity = `${r}`;
                const o = this._element.style.pointerEvents;
                (null === this._pointerEvents ? "" === o : o === this._pointerEvents) && (this._pointerEvents = r > 0 ? "auto" : "none", this._element.style.pointerEvents = this._pointerEvents), this._popup && this._popup._setOpacity(r), this._fadeTimer = null;
            }
            _clearFadeTimer() {
                this._fadeTimer && (clearTimeout(this._fadeTimer), this._fadeTimer = null);
            }
            _updateDOM() {
                const e1 = this._pos;
                if (!e1 || !this._map) return;
                const t1 = this._offset.mult(this._scale);
                this._element.style.transform = `\n            translate(${e1.x}px,${e1.y}px)\n            ${wc[this._anchor]}\n            ${this._calculateXYTransform()} ${this._calculateZTransform()}\n            translate(${t1.x}px,${t1.y}px)\n        `;
            }
            _calculateXYTransform() {
                const t1 = this._pos, i = this._map, s = this.getPitchAlignment();
                if (!i || !t1 || "map" !== s) return "";
                if (!i._showingGlobe()) {
                    const e1 = i.getPitch();
                    return e1 ? `rotateX(${e1}deg)` : "";
                }
                const r = e1.fe(e1.ff(i.transform, this._lngLat)), o = t1.sub(e1.fg(i.transform)), n = Math.abs(o.x) + Math.abs(o.y);
                if (0 === n) return "";
                const a = r / n;
                return `rotateX(${-o.y * a}deg) rotateY(${o.x * a}deg)`;
            }
            _calculateZTransform() {
                const t1 = this._pos, i = this._map;
                if (!i || !t1) return "";
                let s = 0;
                const r = this.getRotationAlignment();
                if ("map" === r) {
                    if (i._showingGlobe()) {
                        const t1 = i.project(new e1.cJ(this._lngLat.lng, this._lngLat.lat + .001), this._altitude), r = i.project(new e1.cJ(this._lngLat.lng, this._lngLat.lat - .001), this._altitude).sub(t1);
                        s = e1.fe(Math.atan2(r.y, r.x)) - 90;
                    } else s = -i.getBearing();
                } else if ("horizon" === r) {
                    const r = e1.ax(4, 6, i.getZoom()), o = e1.fg(i.transform);
                    o.y += r * i.transform.height;
                    const n = t1.sub(o), a = e1.fe(Math.atan2(n.y, n.x));
                    s = (a > 90 ? a - 270 : a + 90) * (1 - r);
                }
                return s += this._rotation, s ? `rotateZ(${s}deg)` : "";
            }
            _update(e1) {
                cancelAnimationFrame(this._updateFrameId);
                const t1 = this._map;
                t1 && (t1.transform.renderWorldCopies && (this._lngLat = xc(this._lngLat, this._pos, t1.transform)), this._pos = t1.project(this._lngLat, this._altitude), !0 === e1 ? this._updateFrameId = requestAnimationFrame(()=>{
                    this._element && this._pos && this._anchor && (this._pos = this._pos.round(), this._updateDOM());
                }) : this._pos = this._pos.round(), t1._requestDomTask(()=>{
                    this._map && (this._element && this._pos && this._anchor && this._updateDOM(), (t1._showingGlobe() || t1.style && t1.style.hasTerrain() || t1.getFog()) && !this._fadeTimer && (this._fadeTimer = window.setTimeout(this._evaluateOpacity.bind(this), 60)));
                }));
            }
            getOffset() {
                return this._offset;
            }
            setOffset(t1) {
                return this._offset = e1.P.convert(t1), this._update(), this;
            }
            addClassName(e1) {
                return this._element.classList.add(e1), this;
            }
            removeClassName(e1) {
                return this._element.classList.remove(e1), this;
            }
            toggleClassName(e1) {
                return this._element.classList.toggle(e1);
            }
            _onMove(t1) {
                const i = this._map;
                if (!i) return;
                const s = this._pointerdownPos, r = this._positionDelta;
                if (s && r) {
                    if (!this._isDragging) {
                        const e1 = this._clickTolerance || i._clickTolerance;
                        if (t1.point.dist(s) < e1) return;
                        this._isDragging = !0;
                    }
                    this._pos = t1.point.sub(r), this._lngLat = i.unproject(this._pos, this._altitude), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new e1.i("dragstart"))), this.fire(new e1.i("drag"));
                }
            }
            _onUp() {
                this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1;
                const t1 = this._map;
                t1 && (t1.off("mousemove", this._onMove), t1.off("touchmove", this._onMove)), "active" === this._state && this.fire(new e1.i("dragend")), this._state = "inactive";
            }
            _addDragHandler(e1) {
                const t1 = this._map, i = this._pos;
                t1 && i && this._element.contains(e1.originalEvent.target) && (e1.preventDefault(), this._positionDelta = e1.point.sub(i), this._pointerdownPos = e1.point, this._state = "pending", t1.on("mousemove", this._onMove), t1.on("touchmove", this._onMove), t1.once("mouseup", this._onUp), t1.once("touchend", this._onUp));
            }
            setDraggable(e1) {
                this._draggable = !!e1;
                const t1 = this._map;
                return t1 && (e1 ? (t1.on("mousedown", this._addDragHandler), t1.on("touchstart", this._addDragHandler)) : (t1.off("mousedown", this._addDragHandler), t1.off("touchstart", this._addDragHandler))), this;
            }
            isDraggable() {
                return this._draggable;
            }
            setRotation(e1) {
                return this._rotation = e1 || Sc.rotation, this._update(), this;
            }
            getRotation() {
                return this._rotation;
            }
            setRotationAlignment(e1) {
                return this._rotationAlignment = e1 || Sc.rotationAlignment, this._update(), this;
            }
            getRotationAlignment() {
                return "auto" === this._rotationAlignment || "horizon" === this._rotationAlignment && this._map && !this._map._showingGlobe() ? "viewport" : this._rotationAlignment;
            }
            setPitchAlignment(e1) {
                return this._pitchAlignment = e1 || Sc.pitchAlignment, this._update(), this;
            }
            getPitchAlignment() {
                return "auto" === this._pitchAlignment ? this.getRotationAlignment() : this._pitchAlignment;
            }
            setOccludedOpacity(e1) {
                return this._occludedOpacity = e1 || Sc.occludedOpacity, this._update(), this;
            }
            getOccludedOpacity() {
                return this._occludedOpacity;
            }
        }
        const Ec = {
            OFF: [],
            WAITING_ACTIVE: [
                "waiting",
                "active"
            ],
            ACTIVE_LOCK: [
                "active"
            ],
            ACTIVE_ERROR: [
                "waiting",
                "active-error"
            ],
            BACKGROUND: [
                "background"
            ],
            BACKGROUND_ERROR: [
                "waiting",
                "background-error"
            ]
        }, Ic = (e1)=>`mapboxgl-ctrl-geolocate-${e1}`, Dc = [
            "waiting",
            "active",
            "active-error",
            "background",
            "background-error"
        ].map(Ic), Pc = {
            positionOptions: {
                enableHighAccuracy: !1,
                maximumAge: 0,
                timeout: 6e3
            },
            fitBoundsOptions: {
                maxZoom: 15
            },
            trackUserLocation: !1,
            showAccuracyCircle: !0,
            showUserLocation: !0,
            showUserHeading: !1,
            showButton: !0,
            followUserLocation: !0
        }, Lc = {
            maxWidth: 100,
            unit: "metric"
        }, Rc = {
            kilometer: "km",
            meter: "m",
            mile: "mi",
            foot: "ft",
            "nautical-mile": "nm"
        }, Ac = /\s+/, Mc = {
            closeButton: !0,
            closeOnClick: !0,
            focusAfterOpen: !0,
            className: "",
            maxWidth: "240px",
            altitude: 0
        }, Fc = [
            "a[href]",
            "[tabindex]:not([tabindex='-1'])",
            "[contenteditable]:not([contenteditable='false'])",
            "button:not([disabled])",
            "input:not([disabled])",
            "select:not([disabled])",
            "textarea:not([disabled])"
        ].join(", ");
        function Oc(t1 = new e1.P(0, 0), i = "bottom") {
            if ("number" == typeof t1) {
                const s = Math.round(Math.sqrt(.5 * Math.pow(t1, 2)));
                switch(i){
                    case "top":
                        return new e1.P(0, t1);
                    case "top-left":
                        return new e1.P(s, s);
                    case "top-right":
                        return new e1.P(-s, s);
                    case "bottom":
                        return new e1.P(0, -t1);
                    case "bottom-left":
                        return new e1.P(s, -s);
                    case "bottom-right":
                        return new e1.P(-s, -s);
                    case "left":
                        return new e1.P(t1, 0);
                    case "right":
                        return new e1.P(-t1, 0);
                }
                return new e1.P(0, 0);
            }
            return t1 instanceof e1.P || Array.isArray(t1) ? e1.P.convert(t1) : e1.P.convert(t1[i] || [
                0,
                0
            ]);
        }
        const kc = "undefined" != typeof document ? document.currentScript : null;
        e1.fh(kc && kc.src && e1.fi(kc.src) ? "cdn" : "other");
        const Bc = {
            version: e1.fa,
            supported: function(e1) {
                return !function(e1) {
                    return "undefined" != typeof window && "undefined" != typeof document ? Object.hasOwn ? "undefined" == typeof Worker ? "Web Workers not supported" : function() {
                        const e1 = document.createElement("canvas");
                        e1.width = e1.height = 1;
                        const t1 = e1.getContext("2d");
                        return !!t1 && t1.getImageData(0, 0, 1, 1).width === e1.width;
                    }() ? function(e1) {
                        return e1 ? (void 0 === s && (s = r(!0)), s) : (void 0 === i && (i = r(!1)), i);
                    }(e1) ? "" : "insufficient WebGL2 support" : "insufficient Canvas/getImageData support" : "Object.hasOwn not supported" : "not a browser";
                }(e1);
            },
            setSdkInfo: e1.fl,
            addTileProvider: e1.fk,
            Map: class extends ac {
                constructor(t1){
                    e1.eX.mark(e1.fb.create);
                    const i = t1;
                    if (null != (t1 = {
                        ...yc,
                        ...t1
                    }).minZoom && null != t1.maxZoom && t1.minZoom > t1.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                    if (null != t1.minPitch && null != t1.maxPitch && t1.minPitch > t1.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                    if (null != t1.minPitch && t1.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
                    if (null != t1.maxPitch && t1.maxPitch > 85) throw new Error("maxPitch must be less than or equal to 85");
                    super(new e1.eY(t1.minZoom, t1.maxZoom, t1.minPitch, t1.maxPitch, t1.renderWorldCopies, null, null), t1), this._animationFrameProvider = t1.animationFrameProvider, this._repaint = !!t1.repaint, this._interactive = t1.interactive, this._minTileCacheSize = t1.minTileCacheSize, this._maxTileCacheSize = t1.maxTileCacheSize, this._failIfMajorPerformanceCaveat = t1.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = t1.preserveDrawingBuffer, this._antialias = t1.antialias, this._trackResize = t1.trackResize, this._bearingSnap = t1.bearingSnap, this._refreshExpiredTiles = t1.refreshExpiredTiles, this._fadeDuration = t1.fadeDuration, this._placementAlgorithm = t1.placementAlgorithm || "default", this._staticMode = !1, this._isInitialLoad = !0, this._crossSourceCollisions = t1.crossSourceCollisions, this._collectResourceTiming = t1.collectResourceTiming, this._language = this._parseLanguage(t1.language), this._worldview = t1.worldview, this._renderTaskQueue = new dc, this._domRenderTaskQueue = new dc, this._controls = [], this._markers = [], this._popups = [], this._mapId = e1.aG(), this._locale = {
                        ...pc,
                        ...t1.locale
                    }, this._clickTolerance = t1.clickTolerance, this._cooperativeGestures = t1.cooperativeGestures, this._performanceMetricsCollection = t1.performanceMetricsCollection, this._tessellationStep = t1.tessellationStep, this._containerWidth = 0, this._containerHeight = 0, this._showParseStatus = !0, this._precompilePrograms = t1.precompilePrograms, this._averageElevationLastSampledAt = -1 / 0, this._averageElevationExaggeration = 0, this._averageElevation = new uc(0), this._interactionRange = [
                        1 / 0,
                        -1 / 0
                    ], this._visibilityHidden = 0, this._useExplicitProjection = !1, this._frameId = 0, this._emissiveColorPrecision = t1.emissiveColorPrecision, this._scaleFactor = t1.scaleFactor, this._requestManager = new e1.eZ(t1.transformRequest, t1.accessToken, t1.testMode);
                    const s = e1.e_(t1.accessToken || e1.t.ACCESS_TOKEN);
                    if (s && "atlas" in s && "number" == typeof s.atlas && (this._tokenExpiration = s.atlas), this._silenceAuthErrors = !!t1.testMode, this._contextCreateOptions = t1.contextCreateOptions ? {
                        ...t1.contextCreateOptions
                    } : {}, "string" == typeof t1.container) {
                        const e1 = document.getElementById(t1.container);
                        if (!e1) throw new Error(`Container '${t1.container.toString()}' not found.`);
                        this._container = e1;
                    } else {
                        if (!(t1.container instanceof HTMLElement)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                        this._container = t1.container;
                    }
                    if (this._container.childNodes.length > 0 && e1.w("The map container element should be empty, otherwise the map's interactivity will be negatively impacted. If you want to display a message when WebGL is not supported, use the Mapbox GL Supported plugin instead."), t1.maxBounds && this.setMaxBounds(t1.maxBounds), this._spriteFormat = "auto", e1.b4([
                        "_onWindowOnline",
                        "_onWindowResize",
                        "_onVisibilityChange",
                        "_onMapScroll",
                        "_contextLost",
                        "_contextRestored"
                    ], this), this._setupContainer(), this._setupPainter(), void 0 === this.painter) throw new Error("Failed to initialize WebGL.");
                    if (this.on("move", ()=>this._update(!1)), this.on("moveend", ()=>this._update(!1)), this.on("zoom", ()=>this._update(!0)), this._fullscreenchangeEvent = "onfullscreenchange" in document ? "fullscreenchange" : "webkitfullscreenchange", window.addEventListener("online", this._onWindowOnline, !1), window.addEventListener("resize", this._onWindowResize, !1), window.addEventListener("orientationchange", this._onWindowResize, !1), window.addEventListener(this._fullscreenchangeEvent, this._onWindowResize, !1), window.addEventListener("visibilitychange", this._onVisibilityChange, !1), this.handlers = new oc(this, t1), this._localFontFamily = t1.localFontFamily, this._localIdeographFontFamily = t1.localIdeographFontFamily, this._fontstackCompositing = t1.fontstackCompositing, (t1.style || !t1.testMode) && this.setStyle(t1.style || e1.t.DEFAULT_STYLE, {
                        config: t1.config,
                        localFontFamily: this._localFontFamily,
                        localIdeographFontFamily: this._localIdeographFontFamily,
                        fontstackCompositing: this._fontstackCompositing
                    }), t1.projection && this.setProjection(t1.projection), t1.hash && (this._hash = new ol("string" == typeof t1.hash && t1.hash || void 0).addTo(this)), !this._hash || !this._hash._onHashChange()) {
                        null == i.center && null == i.zoom || (this.transform._unmodified = !1), this.jumpTo({
                            center: t1.center,
                            zoom: t1.zoom,
                            bearing: t1.bearing,
                            pitch: t1.pitch
                        });
                        const e1 = t1.bounds;
                        e1 && (this.resize(), this.fitBounds(e1, {
                            ...t1.fitBoundsOptions,
                            duration: 0
                        }));
                    }
                    this.resize(), t1.attributionControl && this.addControl(new cc({
                        customAttribution: t1.customAttribution
                    })), this._logoControl = new hc, this.addControl(this._logoControl, t1.logoPosition), this.on("style.load", ()=>{
                        this.transform.unmodified && this.jumpTo(this.style.stylesheet), this._postStyleLoadEvent(), this._postStyleWithAppearanceEvent();
                    }), this.on("data", (t1)=>{
                        this._update("style" === t1.dataType), this.fire(new e1.i(`${t1.dataType}data`, t1));
                    }), this.on("dataloading", (t1)=>{
                        this.fire(new e1.i(`${t1.dataType}dataloading`, t1));
                    }), this._interactions = new mc(this);
                }
                _getMapId() {
                    return this._mapId;
                }
                addControl(t1, i) {
                    let s, r;
                    if ("string" == typeof i ? s = i : i && (s = i.position, r = i.offset), void 0 === s && (s = t1.getDefaultPosition ? t1.getDefaultPosition() : "top-right"), !t1 || !t1.onAdd) return this.fire(new e1.h(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                    const o = t1.onAdd(this);
                    this._controls.push(t1), function(e1, t1, i) {
                        const s = i && void 0 !== i.x ? `${Math.max(0, i.x)}px` : "", r = i && void 0 !== i.y ? `${Math.max(0, i.y)}px` : "";
                        e1.style.marginLeft = t1.includes("left") ? s : "", e1.style.marginRight = t1.includes("right") ? s : "", e1.style.marginTop = t1.includes("top") ? r : "", e1.style.marginBottom = t1.includes("bottom") ? r : "";
                    }(o, s, r);
                    const n = this._controlPositions[s];
                    return s.includes("bottom") ? n.insertBefore(o, n.firstChild) : n.appendChild(o), this;
                }
                removeControl(t1) {
                    if (!t1 || !t1.onRemove) return this.fire(new e1.h(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                    const i = this._controls.indexOf(t1);
                    return i > -1 && this._controls.splice(i, 1), t1.onRemove(this), this;
                }
                hasControl(e1) {
                    return this._controls.includes(e1);
                }
                getContainer() {
                    return this._container;
                }
                getCanvasContainer() {
                    return this._canvasContainer;
                }
                getCanvas() {
                    return this._canvas;
                }
                resize(t1) {
                    if (this._updateContainerDimensions(), this._containerWidth === this.transform.width && this._containerHeight === this.transform.height) return this;
                    this._resizeCanvas(this._containerWidth, this._containerHeight), this.transform.resize(this._containerWidth, this._containerHeight), this.painter.resize(Math.ceil(this._containerWidth), Math.ceil(this._containerHeight));
                    const i = !this._moving;
                    return i && this.fire(new e1.i("movestart", t1)).fire(new e1.i("move", t1)), this.fire(new e1.i("resize", t1)), i && this.fire(new e1.i("moveend", t1)), this;
                }
                getBounds() {
                    return this.transform.getBounds();
                }
                getMaxBounds() {
                    return this.transform.getMaxBounds() || null;
                }
                setMaxBounds(t1) {
                    return this.transform.setMaxBounds(e1.eN.convert(t1)), this._update();
                }
                setMinZoom(t1) {
                    if ((t1 = t1 ?? -2) >= -2 && t1 <= this.transform.maxZoom) return this.transform.minZoom = t1, this._update(), this.getZoom() < t1 ? this.setZoom(t1) : this.fire(new e1.i("zoomstart")).fire(new e1.i("zoom")).fire(new e1.i("zoomend")), this;
                    throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
                }
                getMinZoom() {
                    return this.transform.minZoom;
                }
                setMaxZoom(t1) {
                    if ((t1 = t1 ?? 22) >= this.transform.minZoom) return this.transform.maxZoom = t1, this._update(), this.getZoom() > t1 ? this.setZoom(t1) : this.fire(new e1.i("zoomstart")).fire(new e1.i("zoom")).fire(new e1.i("zoomend")), this;
                    throw new Error("maxZoom must be greater than the current minZoom");
                }
                getMaxZoom() {
                    return this.transform.maxZoom;
                }
                setMinPitch(t1) {
                    if ((t1 = t1 ?? 0) < 0) throw new Error("minPitch must be greater than or equal to 0");
                    if (t1 >= 0 && t1 <= this.transform.maxPitch) return this.transform.minPitch = t1, this._update(), this.getPitch() < t1 ? this.setPitch(t1) : this.fire(new e1.i("pitchstart")).fire(new e1.i("pitch")).fire(new e1.i("pitchend")), this;
                    throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
                }
                getMinPitch() {
                    return this.transform.minPitch;
                }
                setMaxPitch(t1) {
                    if ((t1 = t1 ?? 85) > 85) throw new Error("maxPitch must be less than or equal to 85");
                    if (t1 >= this.transform.minPitch) return this.transform.maxPitch = t1, this._update(), this.getPitch() > t1 ? this.setPitch(t1) : this.fire(new e1.i("pitchstart")).fire(new e1.i("pitch")).fire(new e1.i("pitchend")), this;
                    throw new Error("maxPitch must be greater than or equal to minPitch");
                }
                getMaxPitch() {
                    return this.transform.maxPitch;
                }
                getScaleFactor() {
                    return this._scaleFactor;
                }
                setScaleFactor(e1) {
                    return this._scaleFactor = e1, this.painter.scaleFactor = e1, this.style && this.style._setLabelPlacementStale(), this.style._updateFilteredLayers((e1)=>"symbol" === e1.type), this._update(!0), this;
                }
                getRenderWorldCopies() {
                    return this.transform.renderWorldCopies;
                }
                setRenderWorldCopies(e1) {
                    return this.transform.renderWorldCopies = e1, this.transform.renderWorldCopies || this._forceMarkerAndPopupUpdate(!0), this._update();
                }
                getLanguage() {
                    return this._language;
                }
                _parseLanguage(e1) {
                    return "auto" === e1 ? navigator.language : Array.isArray(e1) ? 0 === e1.length ? void 0 : e1.map((e1)=>"auto" === e1 ? navigator.language : e1) : e1;
                }
                setLanguage(e1) {
                    const t1 = this._parseLanguage(e1);
                    if (!this.style || t1 === this._language) return this;
                    this._language = t1, this.style.reloadSources();
                    for (const e1 of this._controls)e1._setLanguage && e1._setLanguage(this._language);
                    return this;
                }
                getWorldview() {
                    return this._worldview;
                }
                setWorldview(e1) {
                    return this.style && e1 !== this._worldview ? (this._worldview = e1, this._styleDirty = !0, this.style.setWorldview(e1), this) : this;
                }
                getProjection() {
                    return this.transform.mercatorFromTransition ? {
                        name: "globe",
                        center: [
                            0,
                            0
                        ]
                    } : this.transform.getProjection();
                }
                _showingGlobe() {
                    return "globe" === this.transform.projection.name;
                }
                setProjection(e1) {
                    return this._lazyInitEmptyStyle(), e1 ? "string" == typeof e1 && (e1 = {
                        name: e1
                    }) : e1 = null, this._useExplicitProjection = !!e1, this._prioritizeAndUpdateProjection(e1, this.style.projection);
                }
                _updateProjectionTransition() {
                    if ("globe" !== this.getProjection().name) return;
                    const t1 = this.transform, i = t1.projection.name;
                    let s;
                    "globe" === i && t1.zoom >= e1.bc ? (t1.setMercatorFromTransition(), s = !0) : "mercator" === i && t1.zoom < e1.bc && (t1.setProjection({
                        name: "globe"
                    }), s = !0), s && (this.style.applyProjectionUpdate(), this.style._forceSymbolLayerUpdate(), this._update(!0));
                }
                _prioritizeAndUpdateProjection(e1, t1) {
                    return this._updateProjection(e1 || t1 || {
                        name: "mercator"
                    });
                }
                _updateProjection(t1) {
                    let i;
                    const s = this.transform.mercatorFromTransition;
                    i = "globe" === t1.name && this.transform.zoom >= e1.bc ? this.transform.setMercatorFromTransition() : this.transform.setProjection(t1), this.style.applyProjectionUpdate();
                    const r = "mercator" === this.transform.getProjection().name && s !== this.transform.mercatorFromTransition;
                    return (i || r) && (this.painter.clearBackgroundTiles(), this.style.clearSources(), this._update(!0), this._forceMarkerAndPopupUpdate(!0)), this;
                }
                project(t1, i) {
                    return this.transform.locationPoint3D(e1.cJ.convert(t1), i);
                }
                unproject(t1, i) {
                    return this.transform.pointLocation3D(e1.P.convert(t1), i);
                }
                isMoving() {
                    return this._moving || this.handlers && this.handlers.isMoving() || !1;
                }
                isZooming() {
                    return this._zooming || this.handlers && this.handlers.isZooming() || !1;
                }
                isRotating() {
                    return this._rotating || this.handlers && this.handlers.isRotating() || !1;
                }
                _isDragging() {
                    return this.handlers && this.handlers._isDragging() || !1;
                }
                _createDelegatedListener(e1, t1, i) {
                    const s = (e1)=>{
                        let i = [];
                        if (Array.isArray(t1)) {
                            const s = t1.filter((e1)=>this.getLayer(e1));
                            i = s.length ? this.queryRenderedFeatures(e1, {
                                layers: s
                            }) : [];
                        } else i = this.queryRenderedFeatures(e1, {
                            target: t1
                        });
                        return i;
                    };
                    if ("mouseenter" === e1 || "mouseover" === e1) {
                        let r = !1;
                        const o = (t1)=>{
                            const o = s(t1.point);
                            o.length ? r || (r = !0, i.call(this, new ml(e1, this, t1.originalEvent, {
                                features: o
                            }))) : r = !1;
                        };
                        return {
                            listener: i,
                            targets: t1,
                            delegates: {
                                mousemove: o,
                                mouseout: ()=>{
                                    r = !1;
                                }
                            }
                        };
                    }
                    if ("mouseleave" === e1 || "mouseout" === e1) {
                        let r = !1;
                        const o = (t1)=>{
                            s(t1.point).length ? r = !0 : r && (r = !1, i.call(this, new ml(e1, this, t1.originalEvent)));
                        }, n = (t1)=>{
                            r && (r = !1, i.call(this, new ml(e1, this, t1.originalEvent)));
                        };
                        return {
                            listener: i,
                            targets: t1,
                            delegates: {
                                mousemove: o,
                                mouseout: n
                            }
                        };
                    }
                    {
                        const r = (e1)=>{
                            const t1 = s(e1.point);
                            t1.length && (e1.features = t1, i.call(this, e1), delete e1.features);
                        };
                        return {
                            listener: i,
                            targets: t1,
                            delegates: {
                                [e1]: r
                            }
                        };
                    }
                }
                on(e1, t1, i) {
                    if ("function" == typeof t1 || void 0 === i) return super.on(e1, t1);
                    if ("string" == typeof t1 && (t1 = [
                        t1
                    ]), !this._areTargetsValid(t1)) return this;
                    const s = this._createDelegatedListener(e1, t1, i);
                    this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[e1] = this._delegatedListeners[e1] || [], this._delegatedListeners[e1].push(s);
                    for(const e1 in s.delegates)this.on(e1, s.delegates[e1]);
                    return this;
                }
                once(e1, t1, i) {
                    if ("function" == typeof t1 || void 0 === i) return super.once(e1, t1);
                    if ("string" == typeof t1 && (t1 = [
                        t1
                    ]), !this._areTargetsValid(t1)) return this;
                    const s = this._createDelegatedListener(e1, t1, i);
                    for(const e1 in s.delegates)this.once(e1, s.delegates[e1]);
                    return this;
                }
                off(e1, t1, i) {
                    if ("function" == typeof t1 || void 0 === i) return super.off(e1, t1);
                    if ("string" == typeof t1 && (t1 = [
                        t1
                    ]), !this._areTargetsValid(t1)) return this;
                    const s = this._delegatedListeners ? this._delegatedListeners[e1] : void 0;
                    return s && ((e1)=>{
                        for(let s = 0; s < e1.length; s++){
                            const r = e1[s];
                            if (r.listener === i && _c(r.targets, t1)) {
                                for(const e1 in r.delegates)this.off(e1, r.delegates[e1]);
                                return e1.splice(s, 1), this;
                            }
                        }
                    })(s), this;
                }
                queryRenderedFeatures(t1, i) {
                    if (!this.style) return [];
                    if (void 0 === t1 || t1 instanceof e1.P || Array.isArray(t1) || void 0 !== i || (i = t1, t1 = void 0), t1 = t1 || [
                        [
                            0,
                            0
                        ],
                        [
                            this.transform.width,
                            this.transform.height
                        ]
                    ], !i) {
                        const e1 = this.style.queryRenderedFeatures(t1, void 0, this.transform), i = this.style.queryRenderedFeatureset(t1, void 0, this.transform);
                        return e1.concat(i);
                    }
                    let s = !0;
                    if (i.target && (s = this._isTargetValid(i.target), s && !i.layers)) return this.style.queryRenderedFeatureset(t1, i, this.transform);
                    let r = !0;
                    if (i.layers && Array.isArray(i.layers)) {
                        for (const e1 of i.layers)if (!this._isValidId(e1)) {
                            r = !1;
                            break;
                        }
                        if (r && !i.target) return this.style.queryRenderedFeatures(t1, i, this.transform);
                    }
                    let o = [];
                    return r && (o = o.concat(this.style.queryRenderedFeatures(t1, i, this.transform))), s && (o = o.concat(this.style.queryRenderedFeatureset(t1, i, this.transform))), o;
                }
                querySourceFeatures(e1, t1) {
                    return !e1 || "string" == typeof e1 && !this._isValidId(e1) ? [] : this.style.querySourceFeatures(e1, t1);
                }
                queryRasterValue(e1, t1, i) {
                    return this._isValidId(e1) ? this.style.queryRasterValue(e1, t1, i) : Promise.resolve(null);
                }
                isPointOnSurface(t1) {
                    const { name: i } = this.transform.projection;
                    return "globe" !== i && "mercator" !== i && e1.w(`${i} projection does not support isPointOnSurface, this API may behave unexpectedly.`), this.transform.isPointOnSurface(e1.P.convert(t1));
                }
                addInteraction(e1, t1) {
                    return this._interactions.add(e1, t1), this;
                }
                removeInteraction(e1) {
                    return this._interactions.remove(e1), this;
                }
                getCooperativeGestures() {
                    return this._cooperativeGestures;
                }
                setCooperativeGestures(e1) {
                    return this._cooperativeGestures = e1, this;
                }
                setStyle(t1, i) {
                    return i = {
                        localIdeographFontFamily: this._localIdeographFontFamily,
                        localFontFamily: this._localFontFamily,
                        fontstackCompositing: this._fontstackCompositing,
                        ...i
                    }, this.style && t1 && !1 !== i.diff && i.localFontFamily === this._localFontFamily && i.localIdeographFontFamily === this._localIdeographFontFamily && i.fontstackCompositing === this._fontstackCompositing && !i.config ? (this.style._diffStyle(t1, (s, r)=>{
                        if (s) {
                            const r = "string" == typeof s ? s : s instanceof Error ? s.message : s.error;
                            e1.w(`Unable to perform style diff: ${r}. Rebuilding the style from scratch.`), this._updateStyle(t1, i);
                        } else r && this._update(!0);
                    }, ()=>this._postStyleLoadEvent()), this) : (this._localIdeographFontFamily = i.localIdeographFontFamily, this._localFontFamily = i.localFontFamily, this._fontstackCompositing = i.fontstackCompositing, this._updateStyle(t1, i));
                }
                _getUIString(e1) {
                    const t1 = this._locale[e1];
                    if (null == t1) throw new Error(`Missing UI string '${e1}'`);
                    return t1;
                }
                _updateStyle(e1, t1) {
                    if (this.style && (this.style.setEventedParent(null), this.style._remove(), this.style = void 0), e1) {
                        const i = {
                            ...t1
                        };
                        t1 && t1.config && (i.initialConfig = t1.config, delete i.config), this.style = new na(this, i).load(e1), this.style.setEventedParent(this, {
                            style: this.style
                        });
                    }
                    return this._updateTerrain(), this;
                }
                _lazyInitEmptyStyle() {
                    this.style || (this.style = new na(this, {}), this.style.setEventedParent(this, {
                        style: this.style
                    }), this.style.loadEmpty());
                }
                getStyle() {
                    if (this.style) return this.style.serialize();
                }
                isStyleLoaded() {
                    return this.style ? this.style.loaded() : (e1.w("There is no style added to the map."), !1);
                }
                _isValidId(t1) {
                    return null == t1 ? (this.fire(new e1.h(new Error("IDs can't be empty."))), !1) : e1.dN(t1) ? (this.fire(new e1.h(new Error(`IDs can't contain special symbols: "${t1}".`))), !1) : "__proto__" !== t1 && "constructor" !== t1 && "prototype" !== t1 || (this.fire(new e1.h(new Error(`IDs can't be "${t1}".`))), !1);
                }
                _isTargetValid(e1) {
                    return "featuresetId" in e1 ? this._isValidId("importId" in e1 ? e1.importId : e1.featuresetId) : "layerId" in e1 && this._isValidId(e1.layerId);
                }
                _areTargetsValid(e1) {
                    if (Array.isArray(e1)) {
                        for (const t1 of e1)if (!this._isValidId(t1)) return !1;
                        return !0;
                    }
                    return this._isTargetValid(e1);
                }
                addSource(e1, t1) {
                    return this._isValidId(e1) ? (this._lazyInitEmptyStyle(), this.style.addSource(e1, t1), this._update(!0)) : this;
                }
                isSourceLoaded(e1) {
                    return !!this._isValidId(e1) && !!this.style && this.style._isSourceCacheLoaded(e1);
                }
                areTilesLoaded() {
                    return this.style.areTilesLoaded();
                }
                removeSource(e1) {
                    return this._isValidId(e1) ? (this.style.removeSource(e1), this._updateTerrain(), this._update(!0)) : this;
                }
                getSource(e1) {
                    return this._isValidId(e1) ? this.style.getOwnSource(e1) : null;
                }
                addImage(t1, i, { pixelRatio: s = 1, sdf: r = !1, stretchX: o, stretchY: n, content: a } = {}) {
                    this._lazyInitEmptyStyle();
                    const l = e1.I.from(t1);
                    if (i instanceof HTMLImageElement || ImageBitmap && i instanceof ImageBitmap) {
                        const { width: t1, height: c, data: h } = e1.e.getImageData(i);
                        this.style.addImage(l, {
                            data: new e1.b({
                                width: t1,
                                height: c
                            }, h),
                            pixelRatio: s,
                            stretchX: o,
                            stretchY: n,
                            content: a,
                            sdf: r,
                            version: 0,
                            usvg: !1
                        });
                    } else if (void 0 === i.width || void 0 === i.height) this.fire(new e1.h(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                    else {
                        const { width: c, height: h } = i, d = i;
                        this.style.addImage(l, {
                            data: new e1.b({
                                width: c,
                                height: h
                            }, new Uint8Array(d.data)),
                            pixelRatio: s,
                            stretchX: o,
                            stretchY: n,
                            content: a,
                            sdf: r,
                            usvg: !1,
                            version: 0,
                            userImage: d
                        }), d.onAdd && d.onAdd(this, t1);
                    }
                }
                updateImage(t1, i) {
                    this._lazyInitEmptyStyle();
                    const s = e1.I.from(t1), r = this.style.getImage(s);
                    if (!r) return void this.fire(new e1.h(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                    const o = i instanceof HTMLImageElement || ImageBitmap && i instanceof ImageBitmap ? e1.e.getImageData(i) : i, { width: n, height: a, data: l } = o;
                    if (void 0 === n || void 0 === a) return void this.fire(new e1.h(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                    if (n !== (r.usvg ? r.icon.usvg_tree.width : r.data.width) || a !== (r.usvg ? r.icon.usvg_tree.height : r.data.height)) return void this.fire(new e1.h(new Error(`The width and height of the updated image (${n}, ${a})\n                must be that same as the previous version of the image\n                (${r.data.width}, ${r.data.height})`)));
                    const c = !(i instanceof HTMLImageElement || ImageBitmap && i instanceof ImageBitmap);
                    let h = !1;
                    r.usvg ? (r.data = new e1.b({
                        width: n,
                        height: a
                    }, new Uint8Array(l)), r.usvg = !1, r.icon = void 0, h = !0) : r.data.replace(l, c), this.style.updateImage(s, r, h);
                }
                hasImage(t1) {
                    return t1 ? !!this.style && !!this.style.getImage(e1.I.from(t1)) : (this.fire(new e1.h(new Error("Missing required image id"))), !1);
                }
                removeImage(t1) {
                    this.style.removeImage(e1.I.from(t1));
                }
                loadImage(t1, i) {
                    (async ()=>{
                        const i = await this._requestManager.transformRequest(t1, e1.R.Image), { data: s } = await e1.a(i);
                        return s;
                    })().then((e1)=>i(null, e1)).catch(i);
                }
                listImages() {
                    return this.style.listImages().map((e1)=>e1.name);
                }
                addModel(e1, t1) {
                    this._lazyInitEmptyStyle(), this.style.addModel(e1, t1);
                }
                hasModel(t1) {
                    return t1 ? this.style.hasModel(t1) : (this.fire(new e1.h(new Error("Missing required model id"))), !1);
                }
                removeModel(e1) {
                    this.style.removeModel(e1);
                }
                listModels() {
                    return this.style.listModels();
                }
                addLayer(e1, t1) {
                    return this._isValidId(e1.id) ? (this._lazyInitEmptyStyle(), this.style.addLayer(e1, t1), this._update(!0)) : this;
                }
                getSlot(e1) {
                    const t1 = this.getLayer(e1);
                    return t1 && t1.slot || null;
                }
                setSlot(e1, t1) {
                    return this.style.setSlot(e1, t1), this.style.mergeLayers(), this._update(!0);
                }
                addImport(t1, i) {
                    return this._isValidId(t1.id) ? (this.style.addImport(t1, i).catch((t1)=>this.fire(new e1.h(new Error("Failed to add import", t1)))), this) : this;
                }
                updateImport(e1, t1) {
                    return "string" != typeof t1 && t1.id !== e1 ? (this.removeImport(e1), this.addImport(t1)) : (this.style.updateImport(e1, t1), this._update(!0));
                }
                removeImport(t1) {
                    const i = this.style._getRasterMaskUser(t1, "import");
                    return i ? (this.fire(new e1.h(new Error(`Import "${t1}" cannot be removed while layer "${i}" uses it in "raster-mask-import".`))), this) : (this.style.removeImport(t1), this);
                }
                moveImport(e1, t1) {
                    return this.style.moveImport(e1, t1), this._update(!0);
                }
                moveLayer(e1, t1) {
                    return this._isValidId(e1) ? (this.style.moveLayer(e1, t1), this._update(!0)) : this;
                }
                removeLayer(t1) {
                    if (!this._isValidId(t1)) return this;
                    const i = this.style._getRasterMaskUser(t1, "layer");
                    return i ? (this.fire(new e1.h(new Error(`Layer "${t1}" cannot be removed while layer "${i}" uses it in "raster-mask".`))), this) : (this.style.removeLayer(t1), this._update(!0));
                }
                getLayer(e1) {
                    if (!this._isValidId(e1)) return null;
                    const t1 = this.style.getOwnLayer(e1);
                    return t1 ? "custom" === t1.type ? t1.implementation : t1.serialize() : void 0;
                }
                getSlots() {
                    return this.style.getSlots();
                }
                setLayerZoomRange(e1, t1, i) {
                    return this._isValidId(e1) ? (this.style.setLayerZoomRange(e1, t1, i), this._update(!0)) : this;
                }
                setFilter(e1, t1, i = {}) {
                    return this._isValidId(e1) ? (this.style.setFilter(e1, t1, i), this._update(!0)) : this;
                }
                getFilter(e1) {
                    return this._isValidId(e1) ? this.style.getFilter(e1) : null;
                }
                setPaintProperty(e1, t1, i, s = {}) {
                    return this._isValidId(e1) ? (this.style.setPaintProperty(e1, t1, i, s), this._update(!0)) : this;
                }
                getPaintProperty(e1, t1) {
                    return this._isValidId(e1) ? this.style.getPaintProperty(e1, t1) : null;
                }
                setLayoutProperty(e1, t1, i, s = {}) {
                    return this._isValidId(e1) ? (this.style.setLayoutProperty(e1, t1, i, s), this._update(!0)) : this;
                }
                getLayoutProperty(e1, t1) {
                    return this._isValidId(e1) ? this.style.getLayoutProperty(e1, t1) : null;
                }
                getLayerProperty(e1, t1) {
                    return this._isValidId(e1) ? this.style.getLayerProperty(e1, t1) : null;
                }
                setLayerProperty(e1, t1, i, s = {}) {
                    return this._isValidId(e1) ? ("appearances" === t1 && this._postAddingAppearancesToStyleEvent(), this.style.setLayerProperty(e1, t1, i, s), this._update(!0)) : this;
                }
                getGlyphsUrl() {
                    return this.style.getGlyphsUrl();
                }
                setGlyphsUrl(e1) {
                    return this.style.setGlyphsUrl(e1), this._update(!0);
                }
                getSchema(e1) {
                    return this.style.getSchema(e1);
                }
                setSchema(e1, t1) {
                    return this.style.setSchema(e1, t1), this._update(!0);
                }
                getConfig(e1) {
                    return this.style.getConfig(e1);
                }
                setConfig(e1, t1) {
                    return this.style.setConfig(e1, t1), this._update(!0);
                }
                getConfigProperty(e1, t1) {
                    return this.style.getConfigProperty(e1, t1);
                }
                setConfigProperty(e1, t1, i) {
                    return this.style.setConfigProperty(e1, t1, i), this._update(!0);
                }
                getFeaturesetDescriptors(e1) {
                    return this.style.getFeaturesetDescriptors(e1);
                }
                setLights(e1) {
                    if (this._lazyInitEmptyStyle(), e1 && 1 === e1.length && "flat" === e1[0].type) {
                        const t1 = e1[0];
                        t1.properties ? this.style.setFlatLight(t1.properties, t1.id, {}) : this.style.setFlatLight({}, "flat");
                    } else this.style.setLights(e1), this.painter.terrain && (this.painter.terrain.invalidateRenderCache = !0);
                    return this._update(!0);
                }
                getLights() {
                    const e1 = this.style.getLights() || [];
                    return 0 === e1.length && e1.push({
                        id: this.style.light.id,
                        type: "flat",
                        properties: this.style.getFlatLight()
                    }), e1;
                }
                setLight(e1, t1 = {}) {
                    return console.log("The `map.setLight` function is deprecated, prefer using `map.setLights` with `flat` light type instead."), this.setLights([
                        {
                            id: "flat",
                            type: "flat",
                            properties: e1
                        }
                    ]);
                }
                getLight() {
                    return console.log("The `map.getLight` function is deprecated, prefer using `map.getLights` instead."), this.style.getFlatLight();
                }
                setTerrain(e1) {
                    return this._lazyInitEmptyStyle(), !e1 && this.transform.projection.requiresDraping ? this.style.setTerrainForDraping() : this.style.setTerrain(e1), this._averageElevationLastSampledAt = -1 / 0, this._update(!0);
                }
                getTerrain() {
                    return this.style ? this.style.getTerrain() : null;
                }
                setFog(e1) {
                    return this._lazyInitEmptyStyle(), this.style.setFog(e1), this._update(!0);
                }
                getFog() {
                    return this.style ? this.style.getFog() : null;
                }
                setSnow(e1) {
                    return this._lazyInitEmptyStyle(), this.style.setSnow(e1), this._update(!0);
                }
                getSnow() {
                    return this.style ? this.style.getSnow() : null;
                }
                setRain(e1) {
                    return this._lazyInitEmptyStyle(), this.style.setRain(e1), this._update(!0);
                }
                getRain() {
                    return this.style ? this.style.getRain() : null;
                }
                setColorTheme(e1) {
                    return this._lazyInitEmptyStyle(), this.style.setColorTheme(e1), this._update(!0);
                }
                setImportColorTheme(e1, t1) {
                    return this._lazyInitEmptyStyle(), this.style.setImportColorTheme(e1, t1), this._update(!0);
                }
                setCamera(e1) {
                    return this.style.setCamera(e1), this._triggerCameraUpdate(e1);
                }
                getNearClipOffset() {
                    return this.transform.nearClipOffset;
                }
                setNearClipOffset(e1) {
                    const t1 = this.transform.nearClipOffset !== e1;
                    return this.transform.nearClipOffset = e1, this._update(t1);
                }
                _triggerCameraUpdate(e1) {
                    return this._update(this.transform.setOrthographicProjectionAtLowPitch("orthographic" === e1["camera-projection"]));
                }
                getCamera() {
                    return this.style.camera;
                }
                _queryFogOpacity(t1) {
                    return this.style && this.style.fog ? this.style.fog.getOpacityAtLatLng(e1.cJ.convert(t1), this.transform) : 0;
                }
                setFeatureState(e1, t1) {
                    return e1.source && !this._isValidId(e1.source) ? this : (this.style.setFeatureState(e1, t1), this._update());
                }
                removeFeatureState(e1, t1) {
                    return e1.source && !this._isValidId(e1.source) ? this : (this.style.removeFeatureState(e1, t1), this._update());
                }
                getFeatureState(e1) {
                    return e1.source && !this._isValidId(e1.source) ? null : this.style.getFeatureState(e1);
                }
                resetFeatureStates(e1) {
                    return this.style.resetFeatureStates(e1), this._update();
                }
                _selectIndoorFloor(e1) {
                    this.style.indoorManager && this.style.indoorManager.selectFloor(e1);
                }
                _setIndoorActiveFloorsVisibility(e1) {
                    this.style.indoorManager && this.style.indoorManager.setActiveFloorsVisibility(e1);
                }
                getIndoorTileOptions(e1, t1) {
                    return this.style && this.style.isIndoorEnabled() && this.style.indoorManager ? this.style.indoorManager.getIndoorTileOptions(e1, t1) : null;
                }
                _updateContainerDimensions() {
                    if (!this._container) return;
                    const e1 = this._container.getBoundingClientRect().width || 400, t1 = this._container.getBoundingClientRect().height || 300;
                    let i, s, r, o = this._container;
                    for(; o && (!s || !r);){
                        const e1 = window.getComputedStyle(o).transform;
                        e1 && "none" !== e1 && (i = e1.match(gc)[1].split(", "), i[0] && "0" !== i[0] && "1" !== i[0] && (s = i[0]), i[3] && "0" !== i[3] && "1" !== i[3] && (r = i[3])), o = o.parentElement;
                    }
                    this._containerWidth = s ? Math.abs(e1 / s) : e1, this._containerHeight = r ? Math.abs(t1 / r) : t1;
                }
                _detectMissingCSS() {
                    "rgb(250, 128, 114)" !== window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color") && e1.w("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");
                }
                _setupContainer() {
                    const e1 = this._container;
                    e1.classList.add("mapboxgl-map"), (this._missingCSSCanary = a("div", "mapboxgl-canary", e1)).style.visibility = "hidden", this._detectMissingCSS();
                    const t1 = this._canvasContainer = a("div", "mapboxgl-canvas-container", e1);
                    this._canvas = a("canvas", "mapboxgl-canvas", t1), this._interactive && (t1.classList.add("mapboxgl-interactive"), this._canvas.setAttribute("tabindex", "0")), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("aria-label", this._getUIString("Map.Title")), this._canvas.setAttribute("role", "region"), this._updateContainerDimensions(), this._resizeCanvas(this._containerWidth, this._containerHeight);
                    const i = this._controlContainer = a("div", "mapboxgl-control-container", e1), s = this._controlPositions = {};
                    [
                        "top-left",
                        "top",
                        "top-right",
                        "right",
                        "bottom-right",
                        "bottom",
                        "bottom-left",
                        "left"
                    ].forEach((e1)=>{
                        s[e1] = a("div", `mapboxgl-ctrl-${e1}`, i);
                    }), this._container.addEventListener("scroll", this._onMapScroll, !1);
                }
                _resizeCanvas(t1, i) {
                    const s = e1.e.devicePixelRatio || 1;
                    this._canvas.width = s * Math.ceil(t1), this._canvas.height = s * Math.ceil(i), this._canvas.style.width = `${t1}px`, this._canvas.style.height = `${i}px`;
                }
                _addMarker(e1) {
                    this._markers.push(e1);
                }
                _removeMarker(e1) {
                    const t1 = this._markers.indexOf(e1);
                    -1 !== t1 && this._markers.splice(t1, 1);
                }
                _addPopup(e1) {
                    this._popups.push(e1);
                }
                _removePopup(e1) {
                    const t1 = this._popups.indexOf(e1);
                    -1 !== t1 && this._popups.splice(t1, 1);
                }
                _setupPainter() {
                    const i = {
                        ...t1,
                        failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
                        preserveDrawingBuffer: this._preserveDrawingBuffer,
                        antialias: this._antialias || !1
                    }, s = this._canvas.getContext("webgl2", i);
                    s ? (e1.e$(s, !0), this.painter = new il(s, this._contextCreateOptions, this.transform, this._scaleFactor, this._worldview, this._emissiveColorPrecision), this.on("data", (e1)=>{
                        if ("source" === e1.dataType) {
                            const t1 = this.transform.elevation ? this.transform.elevation._source() : null;
                            t1 && e1.sourceCacheId === t1.id && this.style && this.style._setLabelPlacementStale(), this.style && e1.sourceCacheId && this.style._buildingIndex.hasLayerForSourceCache(e1.sourceCacheId) && this.style._requestFullLabelPlacement(), this.painter.setTileLoadedFlag(!0);
                        }
                    })) : this.fire(new e1.h(new Error("Failed to initialize WebGL")));
                }
                _contextLost(t1) {
                    t1.preventDefault(), this._frame && (this._frame.cancel(), this._frame = null), this.style && this.style.handleContextLost(), this.fire(new e1.i("webglcontextlost", {
                        originalEvent: t1
                    }));
                }
                _contextRestored(t1) {
                    this._setupPainter(), this.painter.resize(Math.ceil(this._containerWidth), Math.ceil(this._containerHeight)), this._updateTerrain(), this.style && (this.style.clearLayers(), this.style.imageManager.destroyAtlasTextures(), this.style.imageManager.imageAtlasCache.clear(), this.style.reloadModels(), this.style.clearSources()), this._update(), this.fire(new e1.i("webglcontextrestored", {
                        originalEvent: t1
                    }));
                }
                _onMapScroll(e1) {
                    if (e1.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
                }
                idle() {
                    return !this.isMoving() && this.loaded();
                }
                loaded() {
                    return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
                }
                frameReady() {
                    return this.loaded() && !this._placementDirty;
                }
                _update(e1) {
                    return this.style ? (this._styleDirty = this._styleDirty || e1, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
                }
                _requestRenderFrame(e1) {
                    return this._update(), this._renderTaskQueue.add(e1);
                }
                _cancelRenderFrame(e1) {
                    this._renderTaskQueue.remove(e1);
                }
                _requestDomTask(e1) {
                    !this.loaded() || this.loaded() && !this.isMoving() ? e1() : this._domRenderTaskQueue.add(e1);
                }
                _render(t1) {
                    let i;
                    this.fire(new e1.i("renderstart")), ++this._frameId;
                    const s = this.painter.context.extTimerQuery, r = e1.e.now(), o = this.painter.context.gl;
                    if (this.listens("gpu-timing-frame") && (i = o.createQuery(), o.beginQuery(s.TIME_ELAPSED_EXT, i)), this.painter.context.setDirty(), this.painter.setBaseState(), (this.isMoving() || this.isRotating() || this.isZooming()) && (this._interactionRange[0] = Math.min(this._interactionRange[0], performance.now()), this._interactionRange[1] = Math.max(this._interactionRange[1], performance.now())), this._renderTaskQueue.run(t1), this._domRenderTaskQueue.run(t1), this._removed) return;
                    this._updateProjectionTransition();
                    const n = this._isInitialLoad ? 0 : this._fadeDuration;
                    if (this.style && this._styleDirty) {
                        this._styleDirty = !1;
                        const t1 = this.transform.zoom, i = this.transform.pitch, s = e1.e.now(), r = new e1.au(t1, {
                            now: s,
                            fadeDuration: n,
                            pitch: i,
                            transition: this._loaded ? this.style.transition : {
                                duration: 0,
                                delay: 0
                            },
                            worldview: this._worldview
                        });
                        this.style.update(r);
                    }
                    this.style && this.style.hasFogTransition() && (this.style._markersNeedUpdate = !0, this._sourcesDirty = !0);
                    let a = !1;
                    if (this.style && this._sourcesDirty ? (this._sourcesDirty = !1, this.painter._updateFog(this.style), this._updateTerrain(), a = this._updateAverageElevation(r), this.style.updateSources(this.transform), this.style.updateImageProviders(), this.isMoving() || this._forceMarkerAndPopupUpdate()) : a = this._updateAverageElevation(r), this.style) {
                        const e1 = this._staticMode && !this.style.loaded();
                        this._placementDirty = e1 || this.style._updatePlacement(this.painter.transform, this.showCollisionBoxes, n, this._crossSourceCollisions, this.painter.replacementSource, this._placementAlgorithm);
                    }
                    if (this.style && this.painter.render(this.style, {
                        showTileBoundaries: this.showTileBoundaries,
                        showParseStatus: this.showParseStatus,
                        wireframe: {
                            terrain: this.showTerrainWireframe,
                            layers2D: this.showLayers2DWireframe,
                            layers3D: this.showLayers3DWireframe
                        },
                        showOverdrawInspector: this._showOverdrawInspector,
                        showQueryGeometry: !!this._showQueryGeometry,
                        showTileAABBs: this.showTileAABBs,
                        rotating: this.isRotating(),
                        zooming: this.isZooming(),
                        moving: this.isMoving(),
                        fadeDuration: n,
                        isInitialLoad: this._isInitialLoad,
                        showPadding: this.showPadding,
                        gpuTiming: !!this.listens("gpu-timing-layer"),
                        gpuTimingDeferredRender: !!this.listens("gpu-timing-deferred-render"),
                        speedIndexTiming: this.speedIndexTiming,
                        paintStartTimeStamp: t1
                    }), this.fire(new e1.i("render")), this.loaded() && !this._loaded && (this._loaded = !0, e1.eX.mark(e1.fb.load), this.fire(new e1.i("load"))), this.style && this.style.hasTransitions() && (this._styleDirty = !0), this.style && this.style.imageManager.hasPatternsInFlight() && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles(), i) {
                        const t1 = e1.e.now() - r;
                        o.endQuery(s.TIME_ELAPSED_EXT), setTimeout(()=>{
                            const s = o.getQueryParameter(i, o.QUERY_RESULT) / 1e6;
                            o.deleteQuery(i), this.fire(new e1.i("gpu-timing-frame", {
                                cpuTime: t1,
                                gpuTime: s
                            }));
                        }, 50);
                    }
                    if (this.listens("gpu-timing-layer")) {
                        const t1 = this.painter.collectGpuTimers();
                        setTimeout(()=>{
                            const i = this.painter.queryGpuTimers(t1);
                            this.fire(new e1.i("gpu-timing-layer", {
                                layerTimes: i
                            }));
                        }, 50);
                    }
                    if (this.listens("gpu-timing-deferred-render")) {
                        const t1 = this.painter.collectDeferredRenderGpuQueries();
                        setTimeout(()=>{
                            const i = this.painter.queryGpuTimeDeferredRender(t1);
                            this.fire(new e1.i("gpu-timing-deferred-render", {
                                gpuTime: i
                            }));
                        }, 50);
                    }
                    const l = this._sourcesDirty || this._styleDirty || this._placementDirty || a;
                    if (l || this._repaint || this.style && (this.style.snow || this.style.rain)) this.triggerRepaint();
                    else {
                        const t1 = this.idle();
                        if (t1 && (a = this._updateAverageElevation(r, !0)), a) this.triggerRepaint();
                        else {
                            if (this._triggerFrame(!1), t1 && (this.fire(new e1.i("idle")), this._isInitialLoad = !1, this.speedIndexTiming)) {
                                const t1 = this._calculateSpeedIndex();
                                this.fire(new e1.i("speedindexcompleted", {
                                    speedIndex: t1
                                })), this.speedIndexTiming = !1;
                            }
                            t1 && this.style && this.style.handleIdle();
                        }
                    }
                    !this._loaded || this._fullyLoaded || l || (this._fullyLoaded = !0, e1.eX.mark(e1.fb.fullLoad), this._performanceMetricsCollection && e1.f0(this._requestManager._customAccessToken, {
                        width: this.painter.width,
                        height: this.painter.height,
                        interactionRange: this._interactionRange,
                        visibilityHidden: this._visibilityHidden,
                        terrainEnabled: this.painter.style.hasTerrain(),
                        fogEnabled: !!this.painter.style.getFog(),
                        projection: this.getProjection().name,
                        zoom: this.transform.zoom,
                        renderer: this.painter.context.renderer,
                        vendor: this.painter.context.vendor
                    }), this._authenticate());
                }
                _forceMarkerAndPopupUpdate(e1) {
                    for (const t1 of this._markers)e1 && !this.getRenderWorldCopies() && (t1._lngLat = t1._lngLat.wrap()), t1._update();
                    for (const t1 of this._popups)!e1 || this.getRenderWorldCopies() || t1._trackPointer || (t1._lngLat = t1._lngLat.wrap()), t1._update();
                }
                _updateAverageElevation(e1, t1 = !1) {
                    const i = (e1)=>(this.transform.averageElevation = e1, this._update(!1), !0);
                    if (!this.painter.averageElevationNeedsEasing()) return 0 !== this.transform.averageElevation && i(0);
                    const s = this.transform.elevation && this.transform.elevation.exaggeration() !== this._averageElevationExaggeration;
                    if (s || (t1 || e1 - this._averageElevationLastSampledAt > 500) && !this._averageElevation.isEasing(e1)) {
                        const t1 = this.transform.averageElevation;
                        let r = this.transform.sampleAverageElevation();
                        null != this.transform.elevation && (this._averageElevationExaggeration = this.transform.elevation.exaggeration()), isNaN(r) ? r = 0 : this._averageElevationLastSampledAt = e1;
                        const o = Math.abs(t1 - r);
                        if (o > 1) {
                            if (this._isInitialLoad || s) return this._averageElevation.jumpTo(r), i(r);
                            this._averageElevation.easeTo(r, e1, 300);
                        } else if (o > 1e-4) return this._averageElevation.jumpTo(r), i(r);
                    }
                    return !!this._averageElevation.isEasing(e1) && i(this._averageElevation.getValue(e1));
                }
                _isTokenExpired() {
                    return null != this._tokenExpiration && Date.now() > this._tokenExpiration;
                }
                _revokeAuth() {
                    const t1 = this.painter.context.gl;
                    e1.e$(t1, !1), this._logoControl instanceof hc && this._logoControl._updateLogo(), t1 && t1.clear(t1.DEPTH_BUFFER_BIT | t1.COLOR_BUFFER_BIT | t1.STENCIL_BUFFER_BIT), this._silenceAuthErrors || this.fire(new e1.h(new Error("A valid Mapbox access token is required to use Mapbox GL JS. To create an account or a new access token, visit https://account.mapbox.com/")));
                }
                _authenticate() {
                    e1.f1(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, (t1)=>{
                        t1 && (t1.message !== e1.f2 && 401 !== t1.status || this._revokeAuth());
                    }), this._isTokenExpired() && this._revokeAuth(), e1.f3(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, ()=>{});
                }
                _postStyleLoadEvent() {
                    this.style.globalId && e1.f4(this._requestManager._customAccessToken, {
                        map: this,
                        style: this.style.globalId,
                        importedStyles: this.style.getImportGlobalIds()
                    });
                }
                _postStyleWithAppearanceEvent() {
                    this.style.globalId && this.style.hasAppearances() && e1.f5(this._requestManager._customAccessToken);
                }
                _postAddingAppearancesToStyleEvent() {
                    e1.f6(this._requestManager._customAccessToken);
                }
                _updateTerrain() {
                    const e1 = this._isDragging();
                    this.painter.updateTerrain(this.style, e1);
                }
                _calculateSpeedIndex() {
                    const e1 = this.painter.canvasCopy(), t1 = this.painter.getCanvasCopiesAndTimestamps();
                    t1.timeStamps.push(performance.now());
                    const i = this.painter.context.gl, s = i.createFramebuffer();
                    function r(e1) {
                        i.framebufferTexture2D(i.FRAMEBUFFER, i.COLOR_ATTACHMENT0, i.TEXTURE_2D, e1, 0);
                        const t1 = new Uint8Array(i.drawingBufferWidth * i.drawingBufferHeight * 4);
                        return i.readPixels(0, 0, i.drawingBufferWidth, i.drawingBufferHeight, i.RGBA, i.UNSIGNED_BYTE, t1), t1;
                    }
                    return i.bindFramebuffer(i.FRAMEBUFFER, s), this._canvasPixelComparison(r(e1), t1.canvasCopies.map(r), t1.timeStamps);
                }
                _canvasPixelComparison(e1, t1, i) {
                    let s = i[1] - i[0];
                    const r = e1.length / 4;
                    for(let o = 0; o < t1.length; o++){
                        const n = t1[o];
                        let a = 0;
                        for(let t1 = 0; t1 < n.length; t1 += 4)n[t1] === e1[t1] && n[t1 + 1] === e1[t1 + 1] && n[t1 + 2] === e1[t1 + 2] && n[t1 + 3] === e1[t1 + 3] && (a += 1);
                        s += (i[o + 2] - i[o + 1]) * (1 - a / r);
                    }
                    return s;
                }
                remove() {
                    if (this._removed) return;
                    this._hash && this._hash.remove();
                    for (const e1 of this._controls)e1.onRemove(this);
                    this._controls = [], this._frame && (this._frame.cancel(), this._frame = null), this._renderTaskQueue.clear(), this._domRenderTaskQueue.clear(), this.style && this.style.destroy(), this.painter.destroy(), this.handlers && this.handlers.destroy(), this.handlers = void 0, this.setStyle(null), window.removeEventListener("resize", this._onWindowResize, !1), window.removeEventListener("orientationchange", this._onWindowResize, !1), window.removeEventListener(this._fullscreenchangeEvent, this._onWindowResize, !1), window.removeEventListener("online", this._onWindowOnline, !1), window.removeEventListener("visibilitychange", this._onVisibilityChange, !1);
                    const t1 = this.painter.context.gl.getExtension("WEBGL_lose_context");
                    t1 && t1.loseContext(), this._canvas.removeEventListener("webglcontextlost", this._contextLost, !1), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, !1), this._canvasContainer.remove(), this._controlContainer.remove(), this._missingCSSCanary.remove(), this._canvas = void 0, this._canvasContainer = void 0, this._controlContainer = void 0, this._missingCSSCanary = void 0, this._container.classList.remove("mapboxgl-map"), this._container.removeEventListener("scroll", this._onMapScroll, !1), e1.f7(this.painter.context.gl), e1.f8.remove(), e1.f9.remove(), this._removed = !0, this.fire(new e1.i("remove"));
                }
                triggerRepaint() {
                    this._triggerFrame(!0);
                }
                _triggerFrame(t1) {
                    if (this._renderNextFrame = this._renderNextFrame || t1, !this.style || this._frame) return;
                    const i = this._animationFrameProvider;
                    if (!i) return void (this._frame = e1.e.frame((e1)=>{
                        const t1 = !!this._renderNextFrame;
                        this._frame = null, this._renderNextFrame = null, t1 && this._render(e1);
                    }));
                    const s = (e1)=>{
                        const t1 = !!this._renderNextFrame;
                        this._renderNextFrame = null;
                        try {
                            t1 && this._render(e1);
                        } finally{
                            this._frame = null;
                        }
                        t1 && !this._removed && Promise.resolve().then(function() {
                            return import(u);
                        }).then((res)=>this._triggerFrame(!1));
                    };
                    let r = null;
                    this._frame = {
                        cancel: ()=>{
                            null !== r && i.cancelAnimationFrame(r);
                        }
                    };
                    try {
                        r = i.requestAnimationFrame(s);
                    } catch (e1) {
                        throw this._frame = null, e1;
                    }
                }
                _preloadTiles(t1) {
                    const i = this.style ? this.style.getSourceCaches() : [];
                    return e1.u(i, (e1, i)=>e1._preloadTiles(t1, i), ()=>{
                        this.triggerRepaint();
                    }), this;
                }
                _onWindowOnline() {
                    this._update();
                }
                _onWindowResize(e1) {
                    this._trackResize && this.resize({
                        originalEvent: e1
                    })._update();
                }
                _onVisibilityChange() {
                    "hidden" === document.visibilityState && this._visibilityHidden++;
                }
                get showTileBoundaries() {
                    return !!this._showTileBoundaries;
                }
                set showTileBoundaries(e1) {
                    this._showTileBoundaries !== e1 && (this._showTileBoundaries = e1, e1 && Tt(), this._update());
                }
                get showParseStatus() {
                    return !!this._showParseStatus;
                }
                set showParseStatus(e1) {
                    this._showParseStatus !== e1 && (this._showParseStatus = e1, this._update());
                }
                get showTerrainWireframe() {
                    return !!this._showTerrainWireframe;
                }
                set showTerrainWireframe(e1) {
                    this._showTerrainWireframe !== e1 && (this._showTerrainWireframe = e1, this._update());
                }
                get showLayers2DWireframe() {
                    return !!this._showLayers2DWireframe;
                }
                set showLayers2DWireframe(e1) {
                    this._showLayers2DWireframe !== e1 && (this._showLayers2DWireframe = e1, this._update());
                }
                get showLayers3DWireframe() {
                    return !!this._showLayers3DWireframe;
                }
                set showLayers3DWireframe(e1) {
                    this._showLayers3DWireframe !== e1 && (this._showLayers3DWireframe = e1, this._update());
                }
                get showElevationIdDebug() {
                    return !!this.painter && this.painter._debugParams.showElevationIdDebug;
                }
                set showElevationIdDebug(e1) {
                    this.painter && this.painter._debugParams.showElevationIdDebug !== e1 && (this.painter._debugParams.showElevationIdDebug = e1, this.style && e1 ? this.style._reloadSources() : this._update());
                }
                get speedIndexTiming() {
                    return !!this._speedIndexTiming;
                }
                set speedIndexTiming(e1) {
                    this._speedIndexTiming !== e1 && (this._speedIndexTiming = e1, this._update());
                }
                get showPadding() {
                    return !!this._showPadding;
                }
                set showPadding(e1) {
                    this._showPadding !== e1 && (this._showPadding = e1, e1 && Tt(), this._update());
                }
                get showCollisionBoxes() {
                    return !!this._showCollisionBoxes;
                }
                set showCollisionBoxes(e1) {
                    this._showCollisionBoxes !== e1 && (this._showCollisionBoxes = e1, e1 && Tt(), this.style && e1 ? this.style._reloadSources() : this._update());
                }
                get showOverdrawInspector() {
                    return !!this._showOverdrawInspector;
                }
                set showOverdrawInspector(e1) {
                    this._showOverdrawInspector !== e1 && (this._showOverdrawInspector = e1, this._update());
                }
                get repaint() {
                    return !!this._repaint;
                }
                set repaint(e1) {
                    this._repaint !== e1 && (this._repaint = e1, this.triggerRepaint());
                }
                get vertices() {
                    return !!this._vertices;
                }
                set vertices(e1) {
                    this._vertices = e1, this._update();
                }
                get showTileAABBs() {
                    return !!this._showTileAABBs;
                }
                set showTileAABBs(e1) {
                    this._showTileAABBs !== e1 && (this._showTileAABBs = e1, e1 && this._update());
                }
                _setCacheLimits(t1, i) {
                    e1.fc(t1, i);
                }
                get version() {
                    return e1.fa;
                }
            },
            NavigationControl: class {
                constructor(t1 = {}){
                    this.options = {
                        ...vc,
                        ...t1
                    }, this._container = a("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._container.addEventListener("contextmenu", (e1)=>e1.preventDefault()), this.options.showZoom && (e1.b4([
                        "_setButtonTitle",
                        "_updateZoomButtons"
                    ], this), this._zoomInButton = this._createButton("mapboxgl-ctrl-zoom-in", (e1)=>{
                        this._map && this._map.zoomIn({}, {
                            originalEvent: e1
                        });
                    }), a("span", "mapboxgl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("mapboxgl-ctrl-zoom-out", (e1)=>{
                        this._map && this._map.zoomOut({}, {
                            originalEvent: e1
                        });
                    }), a("span", "mapboxgl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (e1.b4([
                        "_rotateCompassArrow"
                    ], this), this._compass = this._createButton("mapboxgl-ctrl-compass", (e1)=>{
                        const t1 = this._map;
                        t1 && (this.options.visualizePitch ? t1.resetNorthPitch({}, {
                            originalEvent: e1
                        }) : t1.resetNorth({}, {
                            originalEvent: e1
                        }));
                    }), this._compassIcon = a("span", "mapboxgl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
                }
                _updateZoomButtons() {
                    const e1 = this._map;
                    if (!e1) return;
                    const t1 = e1.getZoom(), i = t1 === e1.getMaxZoom(), s = t1 === e1.getMinZoom();
                    this._zoomInButton.disabled = i, this._zoomOutButton.disabled = s, this._zoomInButton.setAttribute("aria-disabled", i.toString()), this._zoomOutButton.setAttribute("aria-disabled", s.toString());
                }
                _rotateCompassArrow() {
                    const e1 = this._map;
                    if (!e1) return;
                    const t1 = this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(e1.transform.pitch * (Math.PI / 180)), .5)}) rotateX(${e1.transform.pitch}deg) rotateZ(${e1.transform.angle * (180 / Math.PI)}deg)` : `rotate(${e1.transform.angle * (180 / Math.PI)}deg)`;
                    e1._requestDomTask(()=>{
                        this._compassIcon && (this._compassIcon.style.transform = t1);
                    });
                }
                onAdd(e1) {
                    return this._map = e1, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), e1.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && e1.on("pitch", this._rotateCompassArrow), e1.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new bc(e1, this._compass, this.options.visualizePitch)), this._container;
                }
                onRemove() {
                    const e1 = this._map;
                    e1 && (this._container.remove(), this.options.showZoom && e1.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && e1.off("pitch", this._rotateCompassArrow), e1.off("rotate", this._rotateCompassArrow), this._handler && this._handler.off(), this._handler = void 0), this._map = void 0);
                }
                _createButton(e1, t1) {
                    const i = a("button", e1, this._container);
                    return i.type = "button", i.addEventListener("click", t1), i;
                }
                _setButtonTitle(e1, t1) {
                    if (!this._map) return;
                    const i = this._map._getUIString(`NavigationControl.${t1}`);
                    e1.setAttribute("aria-label", i), e1.firstElementChild && e1.firstElementChild.setAttribute("title", i);
                }
            },
            GeolocateControl: class extends e1.E {
                constructor(t1 = {}){
                    super();
                    const i = navigator.geolocation;
                    this.options = {
                        geolocation: i,
                        ...Pc,
                        ...t1
                    }, e1.b4([
                        "_onSuccess",
                        "_onError",
                        "_onZoom",
                        "_finish",
                        "_setupUI",
                        "_updateCamera",
                        "_updateMarker",
                        "_updateMarkerRotation",
                        "_onDeviceOrientation"
                    ], this), this._updateMarkerRotationThrottled = sl(this._updateMarkerRotation, 20), this._numberOfWatches = 0;
                }
                onAdd(e1) {
                    return this._map = e1, this._container = a("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkGeolocationSupport(this._setupUI), this._container;
                }
                onRemove() {
                    this._clearRequestTimeout(), void 0 !== this._geolocationWatchID && (this.options.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), this._container.remove(), this._map.off("zoom", this._onZoom), this._map = void 0, this._numberOfWatches = 0, this._noTimeout = !1;
                }
                _checkGeolocationSupport(e1) {
                    const t1 = (t1 = !!this.options.geolocation)=>{
                        this._supportsGeolocation = t1, e1(t1);
                    };
                    void 0 !== this._supportsGeolocation ? e1(this._supportsGeolocation) : void 0 !== navigator.permissions ? navigator.permissions.query({
                        name: "geolocation"
                    }).then((e1)=>t1("denied" !== e1.state)).catch(()=>t1()) : t1();
                }
                _isOutOfMapMaxBounds(e1) {
                    const t1 = this._map.getMaxBounds(), i = e1.coords;
                    return !!t1 && (i.longitude < t1.getWest() || i.longitude > t1.getEast() || i.latitude < t1.getSouth() || i.latitude > t1.getNorth());
                }
                _setWatchState(e1) {
                    this._watchState = e1;
                    const t1 = this._geolocateButton.classList;
                    t1.remove(...Dc);
                    for (const i of Ec[e1])t1.add(Ic(i));
                }
                _setButtonTitle(e1) {
                    const t1 = this._map._getUIString(e1);
                    this._geolocateButton.setAttribute("aria-label", t1), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", t1);
                }
                _setErrorState() {
                    switch(this._watchState){
                        case "WAITING_ACTIVE":
                        case "ACTIVE_LOCK":
                            this._setWatchState("ACTIVE_ERROR");
                            break;
                        case "BACKGROUND":
                            this._setWatchState("BACKGROUND_ERROR");
                    }
                }
                _onSuccess(t1) {
                    if (this._map) {
                        if (this._clearRequestTimeout(), this._isOutOfMapMaxBounds(t1)) return this._setErrorState(), this.fire(new e1.i("outofmaxbounds", t1)), this._updateMarker(), void this._finish();
                        if (this._lastKnownPosition = t1, this.options.trackUserLocation) switch(this._watchState){
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                                this._setWatchState(this.options.followUserLocation ? "ACTIVE_LOCK" : "BACKGROUND");
                                break;
                            case "BACKGROUND":
                            case "BACKGROUND_ERROR":
                                this._setWatchState("BACKGROUND");
                        }
                        this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(t1), this.options.followUserLocation && (!this.options.trackUserLocation || "ACTIVE_LOCK" === this._watchState) && this._updateCamera(t1), this.options.showUserLocation && this._userLocationDotMarker.removeClassName("mapboxgl-user-location-dot-stale"), this.fire(new e1.i("geolocate", {
                            coords: t1.coords,
                            timestamp: t1.timestamp,
                            ...t1.toJSON ? {
                                toJSON: t1.toJSON.bind(t1)
                            } : {}
                        })), this._finish();
                    }
                }
                _updateCamera(t1) {
                    const i = new e1.cJ(t1.coords.longitude, t1.coords.latitude), s = t1.coords.accuracy, r = {
                        bearing: this._map.getBearing(),
                        ...this.options.fitBoundsOptions
                    };
                    this._map.fitBounds(i.toBounds(s), r, {
                        geolocateSource: !0
                    });
                }
                _updateMarker(t1) {
                    if (t1) {
                        const i = new e1.cJ(t1.coords.longitude, t1.coords.latitude);
                        this.options.showAccuracyCircle ? this._accuracyCircleMarker.setLngLat(i).addTo(this._map) : this._accuracyCircleMarker.remove(), this._userLocationDotMarker.setLngLat(i).addTo(this._map), this._accuracy = t1.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                    } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
                }
                _updateCircleRadius() {
                    const t1 = this._map.transform, i = e1.ca(1, t1._center.lat) * t1.worldSize, s = Math.ceil(2 * this._accuracy * i);
                    this._circleElement.style.width = `${s}px`, this._circleElement.style.height = `${s}px`;
                }
                _onZoom() {
                    this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                }
                _updateMarkerRotation() {
                    this._userLocationDotMarker && "number" == typeof this._heading ? (this._userLocationDotMarker.setRotation(this._heading), this._userLocationDotMarker.addClassName("mapboxgl-user-location-show-heading")) : (this._userLocationDotMarker.removeClassName("mapboxgl-user-location-show-heading"), this._userLocationDotMarker.setRotation(0));
                }
                _onError(t1) {
                    if (this._map) {
                        if (this._clearRequestTimeout(), this.options.trackUserLocation) {
                            if (1 === t1.code) this._setWatchState("OFF"), this._geolocateButton.disabled = !0, this._setButtonTitle("GeolocateControl.LocationNotAvailable"), void 0 !== this._geolocationWatchID && this._clearWatch();
                            else {
                                if (3 === t1.code && this._noTimeout) return;
                                this._setErrorState();
                            }
                        }
                        "OFF" !== this._watchState && this.options.showUserLocation && this._userLocationDotMarker.addClassName("mapboxgl-user-location-dot-stale"), this.fire(new e1.i("error", {
                            code: t1.code,
                            message: t1.message,
                            PERMISSION_DENIED: t1.PERMISSION_DENIED,
                            POSITION_UNAVAILABLE: t1.POSITION_UNAVAILABLE,
                            TIMEOUT: t1.TIMEOUT
                        })), this._finish();
                    }
                }
                _finish() {
                    this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
                }
                _startRequestTimeout() {
                    this._clearRequestTimeout();
                    const e1 = this.options.positionOptions.timeout;
                    e1 && (this._requestTimeoutId = window.setTimeout(()=>{
                        this._onError({
                            code: 3,
                            message: "Geolocation request timed out"
                        });
                    }, e1));
                }
                _clearRequestTimeout() {
                    void 0 !== this._requestTimeoutId && (clearTimeout(this._requestTimeoutId), this._requestTimeoutId = void 0);
                }
                _setupUI(t1) {
                    void 0 !== this._map && (this._container.addEventListener("contextmenu", (e1)=>e1.preventDefault()), this._geolocateButton = a("button", "mapboxgl-ctrl-geolocate", this._container), a("span", "mapboxgl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", !1 === t1 ? (e1.w("Geolocation support is not available so the GeolocateControl will be disabled."), this._geolocateButton.disabled = !0, this._setButtonTitle("GeolocateControl.LocationNotAvailable")) : this._setButtonTitle("GeolocateControl.FindMyLocation"), this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._createUserLocationMarkers(), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", this.trigger.bind(this)), this._setup = !0, this.options.showButton || (this._container.style.display = "none"), this.options.trackUserLocation && this._map.on("movestart", (t1)=>{
                        t1.geolocateSource || "ACTIVE_LOCK" !== this._watchState || t1.originalEvent && "resize" === t1.originalEvent.type || (this._setWatchState("BACKGROUND"), this.fire(new e1.i("trackuserlocationend")));
                    }), this.fire(new e1.i("ready")));
                }
                _onDeviceOrientation(e1) {
                    this._userLocationDotMarker && (e1.webkitCompassHeading ? this._heading = e1.webkitCompassHeading : !0 === e1.absolute && (this._heading = -1 * e1.alpha), this._updateMarkerRotationThrottled());
                }
                trigger() {
                    if (!this._setup) return e1.w("Geolocate control triggered before added to a map"), !1;
                    if (this.options.trackUserLocation) {
                        switch(this._watchState){
                            case "OFF":
                                this._setWatchState("WAITING_ACTIVE"), this.fire(new e1.i("trackuserlocationstart"));
                                break;
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                            case "BACKGROUND_ERROR":
                                this._numberOfWatches--, this._noTimeout = !1, this._setWatchState("OFF"), this.fire(new e1.i("trackuserlocationend"));
                                break;
                            case "BACKGROUND":
                                this._setWatchState("ACTIVE_LOCK"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new e1.i("trackuserlocationstart"));
                        }
                        if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
                        else if (void 0 === this._geolocationWatchID) {
                            let e1;
                            this._geolocateButton.classList.add(Ic("waiting")), this._geolocateButton.setAttribute("aria-pressed", "true"), this._numberOfWatches++, this._numberOfWatches > 1 ? (e1 = {
                                maximumAge: 6e5,
                                timeout: 0
                            }, this._noTimeout = !0) : (e1 = this.options.positionOptions, this._noTimeout = !1), this._geolocationWatchID = this.options.geolocation.watchPosition(this._onSuccess, this._onError, e1), this._startRequestTimeout(), this.options.showUserHeading && this._addDeviceOrientationListener();
                        }
                    } else this.options.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._startRequestTimeout(), this._timeoutId = window.setTimeout(this._finish, 1e4);
                    return !0;
                }
                setFollowUserLocation(t1) {
                    return this.options.followUserLocation = t1 ?? Pc.followUserLocation, this.options.trackUserLocation && "OFF" !== this._watchState && (this.options.followUserLocation ? "BACKGROUND" !== this._watchState && "BACKGROUND_ERROR" !== this._watchState || (this._setWatchState("ACTIVE_LOCK"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new e1.i("trackuserlocationstart"))) : "ACTIVE_LOCK" !== this._watchState && "ACTIVE_ERROR" !== this._watchState || (this._setWatchState("BACKGROUND"), this.fire(new e1.i("trackuserlocationend")))), this;
                }
                setShowAccuracyCircle(t1) {
                    if (this.options.showAccuracyCircle = t1 ?? Pc.showAccuracyCircle, !this._accuracyCircleMarker) return this;
                    if (this.options.showAccuracyCircle) {
                        if (this.options.showUserLocation && this._lastKnownPosition) {
                            const { longitude: t1, latitude: i, accuracy: s } = this._lastKnownPosition.coords;
                            this._accuracy = s, this._accuracyCircleMarker.setLngLat(new e1.cJ(t1, i)).addTo(this._map), this._updateCircleRadius();
                        }
                    } else this._accuracyCircleMarker.remove();
                    return this;
                }
                setShowUserHeading(e1) {
                    return this.options.showUserHeading = e1 ?? Pc.showUserHeading, this._setup ? (this.options.showUserHeading ? void 0 !== this._geolocationWatchID && this._addDeviceOrientationListener() : (this._removeDeviceOrientationListener(), this._heading = void 0, this._userLocationDotMarker && this._updateMarkerRotation()), this) : this;
                }
                setFitBoundsOptions(e1) {
                    return this.options.fitBoundsOptions = e1 ?? Pc.fitBoundsOptions, this;
                }
                setShowUserLocation(e1) {
                    return this.options.showUserLocation = e1 ?? Pc.showUserLocation, this._setup ? (this.options.showUserLocation ? (this._userLocationDotMarker || (this._createUserLocationMarkers(), this._map.on("zoom", this._onZoom)), !this._lastKnownPosition || void 0 !== this._watchState && "OFF" === this._watchState || this._updateMarker(this._lastKnownPosition)) : (this._userLocationDotMarker && this._userLocationDotMarker.remove(), this._accuracyCircleMarker && this._accuracyCircleMarker.remove()), this) : this;
                }
                _addDeviceOrientationListener() {
                    const t1 = ()=>{
                        const e1 = "ondeviceorientationabsolute" in window ? "deviceorientationabsolute" : "deviceorientation";
                        window.addEventListener(e1, this._onDeviceOrientation);
                    }, i = DeviceOrientationEvent;
                    "function" == typeof i?.requestPermission ? i.requestPermission().then((i)=>{
                        "granted" === i ? t1() : e1.w("GeolocateControl: permission to use device orientation was denied, so the user heading arrow will not be shown.");
                    }).catch(()=>{
                        e1.w("GeolocateControl: could not request device orientation permission. Enable the user heading from a user gesture (click/tap) so the browser can prompt for access.");
                    }) : t1();
                }
                _removeDeviceOrientationListener() {
                    window.removeEventListener("deviceorientation", this._onDeviceOrientation), window.removeEventListener("deviceorientationabsolute", this._onDeviceOrientation);
                }
                _createUserLocationMarkers() {
                    this._dotElement = a("div", "mapboxgl-user-location"), this._dotElement.appendChild(a("div", "mapboxgl-user-location-dot")), this._dotElement.appendChild(a("div", "mapboxgl-user-location-heading")), this._userLocationDotMarker = new Cc({
                        element: this._dotElement,
                        rotationAlignment: "map",
                        pitchAlignment: "map"
                    }), this._circleElement = a("div", "mapboxgl-user-location-accuracy-circle"), this._accuracyCircleMarker = new Cc({
                        element: this._circleElement,
                        pitchAlignment: "map"
                    });
                }
                _clearWatch() {
                    this._clearRequestTimeout(), this.options.geolocation.clearWatch(this._geolocationWatchID), this._removeDeviceOrientationListener(), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove(Ic("waiting")), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
                }
            },
            AttributionControl: cc,
            ScaleControl: class {
                constructor(t1 = {}){
                    this.options = {
                        ...Lc,
                        ...t1
                    }, e1.b4([
                        "_update",
                        "_setScale",
                        "setUnit"
                    ], this);
                }
                getDefaultPosition() {
                    return "bottom-left";
                }
                _update() {
                    const e1 = this.options.maxWidth || 100, t1 = this._map, i = t1._containerHeight / 2, s = t1._containerWidth / 2 - e1 / 2, r = t1.unproject([
                        s,
                        i
                    ]), o = t1.unproject([
                        s + e1,
                        i
                    ]), n = r.distanceTo(o);
                    if ("imperial" === this.options.unit) {
                        const t1 = 3.2808 * n;
                        t1 > 5280 ? this._setScale(e1, t1 / 5280, "mile") : this._setScale(e1, t1, "foot");
                    } else "nautical" === this.options.unit ? this._setScale(e1, n / 1852, "nautical-mile") : n >= 1e3 ? this._setScale(e1, n / 1e3, "kilometer") : this._setScale(e1, n, "meter");
                }
                _setScale(e1, t1, i) {
                    this._map._requestDomTask(()=>{
                        const s = function(e1) {
                            const t1 = Math.pow(10, `${Math.floor(e1)}`.length - 1);
                            let i = e1 / t1;
                            return i = i >= 10 ? 10 : i >= 5 ? 5 : i >= 3 ? 3 : i >= 2 ? 2 : i >= 1 ? 1 : function(e1) {
                                const t1 = Math.pow(10, Math.ceil(-Math.log(e1) / Math.LN10));
                                return Math.round(e1 * t1) / t1;
                            }(i), t1 * i;
                        }(t1), r = s / t1;
                        this._container.innerHTML = "nautical-mile" !== i ? new Intl.NumberFormat(this._language, {
                            style: "unit",
                            unitDisplay: "short",
                            unit: i
                        }).format(s) : `${s}&nbsp;${Rc[i]}`, this._container.style.width = e1 * r + "px";
                    });
                }
                onAdd(e1) {
                    return this._map = e1, this._language = e1.getLanguage(), this._container = a("div", "mapboxgl-ctrl mapboxgl-ctrl-scale", e1.getContainer()), this._container.dir = "auto", this._map.on("move", this._update), this._update(), this._container;
                }
                onRemove() {
                    this._container.remove(), this._map.off("move", this._update), this._map = void 0;
                }
                _setLanguage(e1) {
                    this._language = e1, this._update();
                }
                setUnit(e1) {
                    this.options.unit = e1, this._update();
                }
            },
            FullscreenControl: class {
                constructor(t1 = {}){
                    this._fullscreen = !1, t1 && t1.container && (t1.container instanceof HTMLElement ? this._container = t1.container : e1.w("Full screen control 'container' must be a DOM element.")), e1.b4([
                        "_onClickFullscreen",
                        "_changeIcon"
                    ], this), "onfullscreenchange" in document ? this._fullscreenchange = "fullscreenchange" : "onwebkitfullscreenchange" in document && (this._fullscreenchange = "webkitfullscreenchange");
                }
                onAdd(t1) {
                    return this._map = t1, this._container || (this._container = this._map.getContainer()), this._controlContainer = a("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkFullscreenSupport() ? this._setupUI() : (this._controlContainer.style.display = "none", e1.w("This device does not support fullscreen mode.")), this._controlContainer;
                }
                onRemove() {
                    this._controlContainer.remove(), this._map = null, document.removeEventListener(this._fullscreenchange, this._changeIcon);
                }
                _checkFullscreenSupport() {
                    return !(!document.fullscreenEnabled && !document.webkitFullscreenEnabled);
                }
                _setupUI() {
                    const e1 = this._fullscreenButton = a("button", "mapboxgl-ctrl-fullscreen", this._controlContainer);
                    a("span", "mapboxgl-ctrl-icon", e1).setAttribute("aria-hidden", "true"), e1.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), document.addEventListener(this._fullscreenchange, this._changeIcon);
                }
                _updateTitle() {
                    const e1 = this._getTitle();
                    this._fullscreenButton.setAttribute("aria-label", e1), this._fullscreenButton.firstElementChild && this._fullscreenButton.firstElementChild.setAttribute("title", e1);
                }
                _getTitle() {
                    return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
                }
                _isFullscreen() {
                    return this._fullscreen;
                }
                _changeIcon() {
                    (document.fullscreenElement || document.webkitFullscreenElement) === this._container !== this._fullscreen && (this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"), this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"), this._updateTitle());
                }
                _onClickFullscreen() {
                    this._isFullscreen() ? document.exitFullscreen ? document.exitFullscreen() : document.webkitCancelFullScreen && document.webkitCancelFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.webkitRequestFullscreen && this._container.webkitRequestFullscreen();
                }
            },
            IndoorControl: class {
                constructor(){
                    e1.b4([
                        "_onIndoorUpdate",
                        "_onStyleData",
                        "_scrollUp",
                        "_scrollDown",
                        "_toggleIndoor"
                    ], this), this._visibleFloorStart = 0, this._lastSelectedFloorId = null;
                }
                onAdd(e1) {
                    return this._map = e1, this._container = a("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._container.style.display = "none", this._map.on("styledata", this._onStyleData), this._map.on("idle", this._onStyleData), this._updateConnection(), this._container;
                }
                _onStyleData() {
                    this._updateConnection();
                }
                _updateConnection() {
                    if (this._map && this._map.style && this._map.style.indoorManager) {
                        const e1 = this._map.style.indoorManager;
                        e1.off("selector-update", this._onIndoorUpdate), e1.on("selector-update", this._onIndoorUpdate), this._onIndoorUpdate(e1.getControlState()), this._map.off("idle", this._onStyleData);
                    }
                }
                _createButton(e1, t1) {
                    const i = a("button", e1, this._container);
                    return i.type = "button", i.addEventListener("click", t1), i;
                }
                _setButtonTitle(e1, t1) {
                    e1.setAttribute("aria-label", t1), e1.textContent = t1;
                }
                onRemove() {
                    this._container && this._container.remove(), this._map && (this._map.off("styledata", this._onStyleData), this._map.off("idle", this._onStyleData), this._map.style && this._map.style.indoorManager && this._map.style.indoorManager.off("selector-update", this._onIndoorUpdate), this._map = null);
                }
                getDefaultPosition() {
                    return "top-right";
                }
                _onIndoorUpdate(e1) {
                    if (!e1 || !e1.floors || 0 === e1.floors.length) return this._model = e1, void (this._container.style.display = "none");
                    const t1 = this._model;
                    this._model = e1, this._container.style.display = "inline-block";
                    const i = !t1 || t1.floors.length !== e1.floors.length || t1.floors.some((t1, i)=>t1.id !== e1.floors[i].id);
                    if (i && (this._visibleFloorStart = 0, this._lastSelectedFloorId = null), e1.selectedFloorId) {
                        if (e1.selectedFloorId !== this._lastSelectedFloorId || i) {
                            const t1 = e1.floors.findIndex((t1)=>t1.id === e1.selectedFloorId);
                            if (-1 !== t1) {
                                const i = e1.floors.length;
                                let s, r;
                                i <= 5 ? (s = 0, r = i - 1) : 0 === this._visibleFloorStart ? (s = 0, r = 3) : this._visibleFloorStart >= i - 3 ? (s = i - 3 - 1, r = i - 1) : (s = this._visibleFloorStart, r = this._visibleFloorStart + 3 - 1), t1 < s ? this._visibleFloorStart = t1 : t1 > r && (this._visibleFloorStart = t1 - 2);
                            }
                        }
                        this._lastSelectedFloorId = e1.selectedFloorId;
                    }
                    this._render();
                }
                _render() {
                    if (!this._container || !this._model || !this._model.floors) return;
                    this._container.innerHTML = "";
                    const e1 = this._createButton("mapboxgl-ctrl-indoor-toggle", this._toggleIndoor);
                    a("span", "mapboxgl-ctrl-icon", e1).setAttribute("aria-hidden", "true"), this._model.activeFloorsVisible || e1.classList.add("mapboxgl-ctrl-level-button-selected"), this._container.appendChild(e1);
                    const t1 = this._model.floors, i = t1.length;
                    if (i <= 5) return void t1.forEach((e1)=>this._createFloorButton(e1));
                    const s = 0 === this._visibleFloorStart, r = this._visibleFloorStart >= i - 3;
                    if (s) this._createFloorButton(t1[0]);
                    else {
                        const e1 = this._createButton("mapboxgl-ctrl-arrow-up", this._scrollUp);
                        a("span", "mapboxgl-ctrl-icon", e1).setAttribute("aria-hidden", "true"), this._container.appendChild(e1);
                    }
                    let o = [];
                    if (o = s ? t1.slice(1, 4) : r ? t1.slice(this._visibleFloorStart - 1, this._visibleFloorStart + 3 - 1) : t1.slice(this._visibleFloorStart, this._visibleFloorStart + 3), o.forEach((e1)=>this._createFloorButton(e1)), r) this._createFloorButton(t1[i - 1]);
                    else {
                        const e1 = this._createButton("mapboxgl-ctrl-arrow-down", this._scrollDown);
                        a("span", "mapboxgl-ctrl-icon", e1).setAttribute("aria-hidden", "true"), this._container.appendChild(e1);
                    }
                }
                _createFloorButton(e1) {
                    const t1 = this._createButton("mapboxgl-ctrl-level-button", ()=>{
                        const t1 = e1.id;
                        this._model && this._model.selectedFloorId === t1 && this._model.activeFloorsVisible || this._map && (this._model && !this._model.activeFloorsVisible && this._map.style && this._map.style.indoorManager && this._map.style.indoorManager.setActiveFloorsVisibility(!0), this._map._selectIndoorFloor(t1));
                    }), i = (e1.name || "").trim(), s = e1.zIndex.toString(), r = i ? Array.from(i).slice(0, 3).join("") : s;
                    this._setButtonTitle(t1, r), this._model && this._model.activeFloorsVisible && e1.id === this._model.selectedFloorId && t1.classList.add("mapboxgl-ctrl-level-button-selected"), this._container && this._container.appendChild(t1);
                }
                _toggleIndoor() {
                    this._map && this._map.style && this._map.style.indoorManager && this._model && this._model.activeFloorsVisible && this._map.style.indoorManager.setActiveFloorsVisibility(!1);
                }
                _scrollUp() {
                    if (this._visibleFloorStart > 0) {
                        this._visibleFloorStart--, 1 === this._visibleFloorStart && (this._visibleFloorStart = 0);
                        const e1 = this._model && this._model.floors || [];
                        if (e1.length > 3) {
                            const t1 = e1.length - 3;
                            this._visibleFloorStart === t1 - 1 && (this._visibleFloorStart = t1 - 2);
                        }
                        this._render();
                    }
                }
                _scrollDown() {
                    if (this._model && this._model.floors) {
                        const e1 = this._model.floors.length - 3;
                        this._visibleFloorStart < e1 && (this._visibleFloorStart++, 1 === this._visibleFloorStart && (this._visibleFloorStart = 2), this._visibleFloorStart === e1 - 1 && (this._visibleFloorStart = e1), this._visibleFloorStart > e1 && (this._visibleFloorStart = e1), this._render());
                    }
                }
            },
            Popup: class extends e1.E {
                constructor(t1){
                    super(), this.options = Object.assign(Object.create(Mc), t1), this._altitude = this.options.altitude, e1.b4([
                        "_update",
                        "_onClose",
                        "remove",
                        "_onMouseEvent"
                    ], this), this._classList = new Set(t1 && t1.className ? t1.className.trim().split(Ac) : []);
                }
                addTo(t1) {
                    return this._map && this.remove(), this._map = t1, this.options.closeOnClick && t1.on("preclick", this._onClose), this.options.closeOnMove && t1.on("move", this._onClose), t1.on("remove", this.remove), this._update(), t1._addPopup(this), this._focusFirstElement(), this._trackPointer ? (t1.on("mousemove", this._onMouseEvent), t1.on("mouseup", this._onMouseEvent), t1._canvasContainer.classList.add("mapboxgl-track-pointer")) : t1.on("move", this._update), this.fire(new e1.i("open")), this;
                }
                isOpen() {
                    return !!this._map;
                }
                remove() {
                    this._content && this._content.remove(), this._container && (this._container.remove(), this._container = void 0);
                    const t1 = this._map;
                    return t1 && (t1.off("move", this._update), t1.off("move", this._onClose), t1.off("preclick", this._onClose), t1.off("click", this._onClose), t1.off("remove", this.remove), t1.off("mousemove", this._onMouseEvent), t1.off("mouseup", this._onMouseEvent), t1.off("drag", this._onMouseEvent), t1._canvasContainer && t1._canvasContainer.classList.remove("mapboxgl-track-pointer"), t1._removePopup(this), this._map = void 0), this.fire(new e1.i("close")), this;
                }
                getLngLat() {
                    return this._lngLat;
                }
                setLngLat(t1) {
                    this._lngLat = e1.cJ.convert(t1), this._pos = null, this._trackPointer = !1, this._update();
                    const i = this._map;
                    return i && (i.on("move", this._update), i.off("mousemove", this._onMouseEvent), i._canvasContainer.classList.remove("mapboxgl-track-pointer")), this;
                }
                getAltitude() {
                    return this._altitude;
                }
                setAltitude(e1) {
                    return this._altitude = e1, this._update(), this;
                }
                trackPointer() {
                    this._trackPointer = !0, this._pos = null, this._update();
                    const e1 = this._map;
                    return e1 && (e1.off("move", this._update), e1.on("mousemove", this._onMouseEvent), e1.on("drag", this._onMouseEvent), e1._canvasContainer.classList.add("mapboxgl-track-pointer")), this;
                }
                getElement() {
                    return this._container;
                }
                setText(e1) {
                    return this.setDOMContent(document.createTextNode(e1));
                }
                setHTML(e1) {
                    const t1 = document.createDocumentFragment(), i = document.createElement("body");
                    let s;
                    for(i.innerHTML = e1; s = i.firstChild, s;)t1.appendChild(s);
                    return this.setDOMContent(t1);
                }
                getMaxWidth() {
                    return this._container && this._container.style.maxWidth;
                }
                setMaxWidth(e1) {
                    return this.options.maxWidth = e1, this._update(), this;
                }
                setDOMContent(e1) {
                    let t1 = this._content;
                    if (t1) for(; t1.hasChildNodes();)t1.firstChild && t1.removeChild(t1.firstChild);
                    else t1 = this._content = a("div", "mapboxgl-popup-content", this._container || void 0);
                    if (t1.appendChild(e1), this.options.closeButton) {
                        const e1 = this._closeButton = a("button", "mapboxgl-popup-close-button", t1);
                        e1.type = "button", e1.setAttribute("aria-label", "Close popup"), e1.innerHTML = '<span aria-hidden="true">&#215;</span>', e1.addEventListener("click", this._onClose);
                    }
                    return this._update(), this._focusFirstElement(), this;
                }
                addClassName(e1) {
                    return this._classList.add(e1), this._updateClassList(), this;
                }
                removeClassName(e1) {
                    return this._classList.delete(e1), this._updateClassList(), this;
                }
                setOffset(e1) {
                    return this.options.offset = e1, this._update(), this;
                }
                toggleClassName(e1) {
                    let t1;
                    return this._classList.delete(e1) ? t1 = !1 : (this._classList.add(e1), t1 = !0), this._updateClassList(), t1;
                }
                _onMouseEvent(e1) {
                    this._update(e1.point);
                }
                _getAnchor(e1) {
                    if (this.options.anchor) return this.options.anchor;
                    const t1 = this._map, i = this._container, s = this._pos;
                    if (!t1 || !i || !s) return "bottom";
                    const r = i.offsetWidth, o = i.offsetHeight, n = s.x < r / 2, a = s.x > t1.transform.width - r / 2;
                    if (s.y + e1 < o) return n ? "top-left" : a ? "top-right" : "top";
                    if (s.y > t1.transform.height - o) {
                        if (n) return "bottom-left";
                        if (a) return "bottom-right";
                    }
                    return n ? "left" : a ? "right" : "bottom";
                }
                _updateClassList() {
                    const e1 = this._container;
                    if (!e1) return;
                    const t1 = [
                        ...this._classList
                    ];
                    t1.push("mapboxgl-popup"), this._anchor && t1.push(`mapboxgl-popup-anchor-${this._anchor}`), this._trackPointer && t1.push("mapboxgl-popup-track-pointer"), e1.className = t1.join(" ");
                }
                _update(t1) {
                    const i = this._map, s = this._content;
                    if (!i || !this._lngLat && !this._trackPointer || !s) return;
                    let r = this._container;
                    if (r || (r = this._container = a("div", "mapboxgl-popup", i.getContainer()), this._tip = a("div", "mapboxgl-popup-tip", r), r.appendChild(s)), this.options.maxWidth && r.style.maxWidth !== this.options.maxWidth && (r.style.maxWidth = this.options.maxWidth), i.transform.renderWorldCopies && !this._trackPointer && (this._lngLat = xc(this._lngLat, this._pos, i.transform)), !this._trackPointer || t1) {
                        const s = this._pos = this._trackPointer && t1 instanceof e1.P ? t1 : i.project(this._lngLat, this._altitude), r = Oc(this.options.offset), o = this._anchor = this._getAnchor(r.y), n = Oc(this.options.offset, o), a = s.add(n).round();
                        i._requestDomTask(()=>{
                            this._container && o && (this._container.style.transform = `${wc[o]} translate(${a.x}px,${a.y}px)`);
                        });
                    }
                    if (!this._marker && i._showingGlobe()) {
                        const t1 = e1.fd(i.transform, this._lngLat) ? 0 : 1;
                        this._setOpacity(t1);
                    }
                    this._updateClassList();
                }
                _focusFirstElement() {
                    if (!this.options.focusAfterOpen || !this._container) return;
                    const e1 = this._container.querySelector(Fc);
                    e1 && e1.focus();
                }
                _onClose() {
                    this.remove();
                }
                _setOpacity(e1) {
                    this._container && (this._container.style.opacity = `${e1}`), this._content && (this._content.style.pointerEvents = e1 ? "auto" : "none");
                }
            },
            Marker: Cc,
            Style: na,
            LngLat: e1.cJ,
            LngLatBounds: e1.eN,
            Point: e1.P,
            MercatorCoordinate: e1.b$,
            FreeCameraOptions: e1.fj,
            Evented: e1.E,
            config: e1.t,
            prewarm: function() {
                Qo().acquire(ei);
            },
            clearPrewarmedResources: function() {
                const e1 = Ko;
                e1 && (e1.isPreloaded() && 1 === e1.numActive() ? (e1.release(ei), Ko = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
            },
            get accessToken () {
                return e1.t.ACCESS_TOKEN;
            },
            set accessToken (t){
                e1.fv(t);
            },
            get baseApiUrl () {
                return e1.t.API_URL;
            },
            set baseApiUrl (t){
                e1.fu(t);
            },
            get workerCount () {
                return ti.workerCount;
            },
            set workerCount (e){
                !function(e1) {
                    ti.workerCount = e1;
                }(e);
            },
            get maxParallelImageRequests () {
                return e1.t.MAX_PARALLEL_IMAGE_REQUESTS;
            },
            set maxParallelImageRequests (t){
                e1.ft(t);
            },
            clearStorage (t1) {
                e1.fs(t1);
            },
            get workerUrl () {
                return Qt.workerUrl;
            },
            set workerUrl (e){
                Qt.workerUrl = e;
            },
            get workerClass () {
                return Qt.workerClass;
            },
            set workerClass (e){
                Qt.workerClass = e;
            },
            get dracoUrl () {
                return e1.fr();
            },
            set dracoUrl (t){
                e1.fq(t);
            },
            get meshoptUrl () {
                return e1.fp();
            },
            set meshoptUrl (t){
                e1.fo(t);
            },
            get buildingGenUrl () {
                return e1.fn();
            },
            set buildingGenUrl (t){
                e1.fm(t);
            },
            setNow: e1.e.setNow,
            restoreNow: e1.e.restoreNow
        };
        return Bc;
    });
    var mapboxgl$1 = mapboxgl;
    return mapboxgl$1;
});

});

parcelRegister("6u4NZ", function(module, exports) {
/*! http://mths.be/base64 v0.1.0 by @mathias | MIT license */ (function(root) {
    // Detect free variables `exports`.
    var freeExports = exports;
    // Detect free variable `module`.
    var freeModule = module && module.exports == freeExports && module;
    // Detect free variable `global`, from Node.js or Browserified code, and use
    // it as `root`.
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) root = freeGlobal;
    /*--------------------------------------------------------------------------*/ var InvalidCharacterError = function(message) {
        this.message = message;
    };
    InvalidCharacterError.prototype = new Error;
    InvalidCharacterError.prototype.name = 'InvalidCharacterError';
    var error = function(message) {
        // Note: the error messages used throughout this file match those used by
        // the native `atob`/`btoa` implementation in Chromium.
        throw new InvalidCharacterError(message);
    };
    var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // http://whatwg.org/html/common-microsyntaxes.html#space-character
    var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g;
    // `decode` is designed to be fully compatible with `atob` as described in the
    // HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
    // The optimized base64-decoding algorithm used is based on @atk’s excellent
    // implementation. https://gist.github.com/atk/1020396
    var decode = function(input) {
        input = String(input).replace(REGEX_SPACE_CHARACTERS, '');
        var length = input.length;
        if (length % 4 == 0) {
            input = input.replace(/==?$/, '');
            length = input.length;
        }
        if (length % 4 == 1 || // http://whatwg.org/C#alphanumeric-ascii-characters
        /[^+a-zA-Z0-9/]/.test(input)) error('Invalid character: the string to be decoded is not correctly encoded.');
        var bitCounter = 0;
        var bitStorage;
        var buffer;
        var output = '';
        var position = -1;
        while(++position < length){
            buffer = TABLE.indexOf(input.charAt(position));
            bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
            // Unless this is the first of a group of 4 characters…
            if (bitCounter++ % 4) // …convert the first 8 bits to a single ASCII character.
            output += String.fromCharCode(0xFF & bitStorage >> (-2 * bitCounter & 6));
        }
        return output;
    };
    // `encode` is designed to be fully compatible with `btoa` as described in the
    // HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
    var encode = function(input) {
        input = String(input);
        if (/[^\0-\xFF]/.test(input)) // Note: no need to special-case astral symbols here, as surrogates are
        // matched, and the input is supposed to only contain ASCII anyway.
        error("The string to be encoded contains characters outside of the Latin1 range.");
        var padding = input.length % 3;
        var output = '';
        var position = -1;
        var a;
        var b;
        var c;
        var d;
        var buffer;
        // Make sure any padding is handled outside of the loop.
        var length = input.length - padding;
        while(++position < length){
            // Read three bytes, i.e. 24 bits.
            a = input.charCodeAt(position) << 16;
            b = input.charCodeAt(++position) << 8;
            c = input.charCodeAt(++position);
            buffer = a + b + c;
            // Turn the 24 bits into four chunks of 6 bits each, and append the
            // matching character for each of them to the output.
            output += TABLE.charAt(buffer >> 18 & 0x3F) + TABLE.charAt(buffer >> 12 & 0x3F) + TABLE.charAt(buffer >> 6 & 0x3F) + TABLE.charAt(buffer & 0x3F);
        }
        if (padding == 2) {
            a = input.charCodeAt(position) << 8;
            b = input.charCodeAt(++position);
            buffer = a + b;
            output += TABLE.charAt(buffer >> 10) + TABLE.charAt(buffer >> 4 & 0x3F) + TABLE.charAt(buffer << 2 & 0x3F) + '=';
        } else if (padding == 1) {
            buffer = input.charCodeAt(position);
            output += TABLE.charAt(buffer >> 2) + TABLE.charAt(buffer << 4 & 0x3F) + '==';
        }
        return output;
    };
    var base64 = {
        'encode': encode,
        'decode': decode,
        'version': '0.1.0'
    };
    // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define(function() {
        return base64;
    });
    else if (freeExports && !freeExports.nodeType) {
        if (freeModule) freeModule.exports = base64;
        else for(var key in base64)base64.hasOwnProperty(key) && (freeExports[key] = base64[key]);
    } else root.base64 = base64;
})(this);

});

var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));


var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));


var $14d120258bb760db$export$711302eb3e721627;
$14d120258bb760db$export$711302eb3e721627 = `WnT_GG_containerHome`;




var $acw62 = parcelRequire("acw62");
const $994aa1cb22f78a22$export$6b0c92c645b60d60 = 'pk.eyJ1IjoiZGlhcmlhcmEiLCJhIjoiY2w2ZXU5bXV4MGlkczNkcW92b28yaDZhdiJ9.tvNkBuIYVXtyNMfZ0vJpwg';
const $994aa1cb22f78a22$export$192b6e91c1441415 = 'mapbox://styles/diariara/clhsuubb4023301pg5r4nf18c';
const $994aa1cb22f78a22$var$BASE_INITIAL_VIEW = {
    longitude: 1.6,
    latitude: 41.687,
    zoom: 7.41
};
const $994aa1cb22f78a22$var$CATALONIA_BOUNDS = {
    west: 0.16,
    east: 3.33,
    south: 40.52,
    north: 42.9
};
const $994aa1cb22f78a22$var$WORLD_SIZE = 512;
const $994aa1cb22f78a22$var$clamp = (value, min, max)=>Math.min(max, Math.max(min, value));
const $994aa1cb22f78a22$var$latToMercatorY = (lat)=>{
    const safeLat = $994aa1cb22f78a22$var$clamp(lat, -85.05112878, 85.05112878);
    const rad = safeLat * Math.PI / 180;
    return Math.log(Math.tan(Math.PI / 4 + rad / 2));
};
const $994aa1cb22f78a22$var$mercatorYToLat = (mercatorY)=>{
    const rad = 2 * Math.atan(Math.exp(mercatorY)) - Math.PI / 2;
    return rad * 180 / Math.PI;
};
const $994aa1cb22f78a22$export$a2ac0fedb00307a4 = (width, height = 0)=>{
    if (!width) return $994aa1cb22f78a22$var$BASE_INITIAL_VIEW;
    const fallbackAspectRatio = width >= 768 ? 4 / 3 : 2 / 3;
    const computedHeight = height || width / fallbackAspectRatio;
    const isMobile = width < 768;
    const horizontalPadding = isMobile ? 18 : 30;
    const verticalPadding = isMobile ? 22 : 34;
    const usableWidth = Math.max(width - horizontalPadding * 2, 1);
    const usableHeight = Math.max(computedHeight - verticalPadding * 2, 1);
    const lngDiff = $994aa1cb22f78a22$var$CATALONIA_BOUNDS.east - $994aa1cb22f78a22$var$CATALONIA_BOUNDS.west;
    const latDiffMercator = Math.abs($994aa1cb22f78a22$var$latToMercatorY($994aa1cb22f78a22$var$CATALONIA_BOUNDS.north) - $994aa1cb22f78a22$var$latToMercatorY($994aa1cb22f78a22$var$CATALONIA_BOUNDS.south));
    const zoomByLng = Math.log2(usableWidth * 360 / ($994aa1cb22f78a22$var$WORLD_SIZE * lngDiff));
    const zoomByLat = Math.log2(usableHeight / ($994aa1cb22f78a22$var$WORLD_SIZE * (latDiffMercator / (2 * Math.PI))));
    const zoom = $994aa1cb22f78a22$var$clamp(Math.min(zoomByLng, zoomByLat), 5.8, 9.5);
    const centerLongitude = ($994aa1cb22f78a22$var$CATALONIA_BOUNDS.west + $994aa1cb22f78a22$var$CATALONIA_BOUNDS.east) / 2;
    const centerMercatorY = ($994aa1cb22f78a22$var$latToMercatorY($994aa1cb22f78a22$var$CATALONIA_BOUNDS.north) + $994aa1cb22f78a22$var$latToMercatorY($994aa1cb22f78a22$var$CATALONIA_BOUNDS.south)) / 2;
    return {
        longitude: centerLongitude,
        latitude: $994aa1cb22f78a22$var$mercatorYToLat(centerMercatorY),
        zoom: zoom
    };
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $64c812a720876a94$export$c6c68f6e4db55944 = $acw62.createContext(null);
const $64c812a720876a94$export$507c997ee09bb471 = (props)=>{
    const [maps, setMaps] = (0, $acw62.useState)({});
    const onMapMount = (0, $acw62.useCallback)((map, id = 'default')=>{
        setMaps((currMaps)=>{
            if (id === 'current') throw new Error("'current' cannot be used as map id");
            if (currMaps[id]) throw new Error(`Multiple maps with the same id: ${id}`);
            return {
                ...currMaps,
                [id]: map
            };
        });
    }, []);
    const onMapUnmount = (0, $acw62.useCallback)((id = 'default')=>{
        setMaps((currMaps)=>{
            if (currMaps[id]) {
                const nextMaps = {
                    ...currMaps
                };
                delete nextMaps[id];
                return nextMaps;
            }
            return currMaps;
        });
    }, []);
    return $acw62.createElement($64c812a720876a94$export$c6c68f6e4db55944.Provider, {
        value: {
            maps: maps,
            onMapMount: onMapMount,
            onMapUnmount: onMapUnmount
        }
    }, props.children);
};
function $64c812a720876a94$export$86f8f9f08863e403() {
    const maps = (0, $acw62.useContext)($64c812a720876a94$export$c6c68f6e4db55944)?.maps;
    const currentMap = (0, $acw62.useContext)((0, $9bfa0fb4992bfff5$export$dc7344301ae78f85));
    const mapsWithCurrent = (0, $acw62.useMemo)(()=>{
        return {
            ...maps,
            current: currentMap?.map
        };
    }, [
        maps,
        currentMap
    ]);
    return mapsWithCurrent;
}


/**
 * Capture a transform's current state
 * @param transform
 * @returns descriptor of the view state
 */ function $ff5c44d8dbab1cdc$export$6a605c5aa5bd97a8(tr) {
    return {
        longitude: tr.center.lng,
        latitude: tr.center.lat,
        zoom: tr._seaLevelZoom ?? tr.zoom,
        pitch: tr.pitch,
        bearing: tr.bearing,
        padding: tr.padding,
        elevation: tr._centerAltitude
    };
}
function $ff5c44d8dbab1cdc$export$b36064f1be29a03f(v) {
    return Number.isFinite(v.longitude) || Number.isFinite(v.latitude) || Number.isFinite(v.zoom) || Number.isFinite(v.pitch) || Number.isFinite(v.bearing);
}
function $ff5c44d8dbab1cdc$export$b3dd58694e7dc7d6(tr, v) {
    if (Number.isFinite(v.longitude) && tr.center.lng !== v.longitude) return true;
    if (Number.isFinite(v.latitude) && tr.center.lat !== v.latitude) return true;
    if (Number.isFinite(v.bearing) && tr.bearing !== v.bearing) return true;
    if (Number.isFinite(v.pitch) && tr.pitch !== v.pitch) return true;
    if (Number.isFinite(v.zoom) && (tr._seaLevelZoom ?? tr.zoom) !== v.zoom) return true;
    if (v.padding && !tr.isPaddingEqual(v.padding)) return true;
    return false;
}
function $ff5c44d8dbab1cdc$var$noOp() {}
function $ff5c44d8dbab1cdc$export$5cf06eaeb862e3ce(tr, v) {
    // prevent constrain from running until all properties are set
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const constrain = tr._constrain;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const calcMatrices = tr._calcMatrices;
    tr._constrain = $ff5c44d8dbab1cdc$var$noOp;
    tr._calcMatrices = $ff5c44d8dbab1cdc$var$noOp;
    if (Number.isFinite(v.bearing)) tr.bearing = v.bearing;
    if (Number.isFinite(v.pitch)) tr.pitch = v.pitch;
    if (v.padding && !tr.isPaddingEqual(v.padding)) tr.padding = v.padding;
    if (Number.isFinite(v.longitude) || Number.isFinite(v.latitude)) {
        const center = tr.center;
        // @ts-expect-error LngLat constructor is not typed
        tr._center = new center.constructor(v.longitude ?? center.lng, v.latitude ?? center.lat);
    }
    if (Number.isFinite(v.zoom)) {
        tr._centerAltitude = v.elevation ?? 0;
        if (tr.elevation) {
            tr._seaLevelZoom = v.zoom;
            const mercatorElevation = tr.pixelsPerMeter / tr.worldSize * tr._centerAltitude;
            const altitude = tr._mercatorZfromZoom(v.zoom);
            const minHeight = tr._mercatorZfromZoom(tr._maxZoom);
            const height = Math.max(altitude - mercatorElevation, minHeight);
            tr._setZoom(tr._zoomFromMercatorZ(height));
        } else {
            tr._seaLevelZoom = null;
            tr.zoom = v.zoom;
        }
    }
    // restore methods
    tr._constrain = constrain;
    tr._calcMatrices = calcMatrices;
    if (!tr._unmodified) {
        tr._constrain();
        tr._calcMatrices();
    }
}



// These are Transform class methods that:
// + do not mutate any view state properties
// + populate private members derived from view state properties
// They should always reflect the state of their owning instance and NOT trigger any proxied getter/setter
const $77de42fa790a40cd$var$unproxiedMethods = new Set([
    '_calcMatrices',
    '_calcFogMatrices',
    '_updateCameraState',
    '_updateSeaLevelZoom'
]);
function $77de42fa790a40cd$export$3f6fb66aeea526f4(tr) {
    let internalUpdate = false;
    let reactViewState = {};
    /**
     * Reflects view state set by react props
     * This is the transform seen by painter, style etc.
     */ const controlledTransform = tr;
    /** Populated during camera move (handler/easeTo) if there is a discrepency between react props and proposed view state
     * This is the transform seen by Mapbox's input handlers
     */ let proposedTransform = null;
    const handlers = {
        get (target, prop) {
            // Props added by us
            if (prop === '$reactViewState') return reactViewState;
            if (prop === '$proposedTransform') return proposedTransform;
            if (prop === '$internalUpdate') return internalUpdate;
            // Ugly - this method is called from HandlerManager bypassing zoom setter
            if (prop === '_setZoom') return (z)=>{
                if (internalUpdate) proposedTransform?.[prop](z);
                if (!Number.isFinite(reactViewState.zoom)) controlledTransform[prop](z);
            };
            // Ugly - this method is called from HandlerManager and mutates transform._camera
            if (internalUpdate && prop === '_translateCameraConstrained' && (0, $ff5c44d8dbab1cdc$export$b36064f1be29a03f)(reactViewState)) proposedTransform = proposedTransform || controlledTransform.clone();
            if ($77de42fa790a40cd$var$unproxiedMethods.has(prop)) // When this function is executed, it updates both transforms respectively
            return function(...parms) {
                proposedTransform?.[prop](...parms);
                controlledTransform[prop](...parms);
            };
            // Expose the proposed transform to input handlers
            if (internalUpdate && proposedTransform) return proposedTransform[prop];
            // Expose the controlled transform to renderer, markers, and event listeners
            return controlledTransform[prop];
        },
        set (target, prop, value) {
            // Props added by us
            if (prop === '$reactViewState') {
                reactViewState = value;
                (0, $ff5c44d8dbab1cdc$export$5cf06eaeb862e3ce)(controlledTransform, reactViewState);
                return true;
            }
            if (prop === '$proposedTransform') {
                proposedTransform = value;
                return true;
            }
            if (prop === '$internalUpdate') {
                internalUpdate = value;
                return true;
            }
            // Controlled props
            let controlledValue = value;
            if (prop === 'center' || prop === '_center') {
                if (Number.isFinite(reactViewState.longitude) || Number.isFinite(reactViewState.latitude)) // @ts-expect-error LngLat constructor is not typed
                controlledValue = new value.constructor(reactViewState.longitude ?? value.lng, reactViewState.latitude ?? value.lat);
            } else if (prop === 'zoom' || prop === '_zoom' || prop === '_seaLevelZoom') {
                if (Number.isFinite(reactViewState.zoom)) controlledValue = controlledTransform[prop];
            } else if (prop === '_centerAltitude') {
                if (Number.isFinite(reactViewState.elevation)) controlledValue = controlledTransform[prop];
            } else if (prop === 'pitch' || prop === '_pitch') {
                if (Number.isFinite(reactViewState.pitch)) controlledValue = controlledTransform[prop];
            } else if (prop === 'bearing' || prop === 'rotation' || prop === 'angle') {
                if (Number.isFinite(reactViewState.bearing)) controlledValue = controlledTransform[prop];
            }
            // During camera update, we save view states that are overriden by controlled values in proposedTransform
            if (internalUpdate && controlledValue !== value) proposedTransform = proposedTransform || controlledTransform.clone();
            if (internalUpdate && proposedTransform) proposedTransform[prop] = value;
            // controlledTransform is not exposed to view state mutation
            controlledTransform[prop] = controlledValue;
            return true;
        }
    };
    return new Proxy(tr, handlers);
}


const $a094c77ab2bfe883$var$refProps = [
    'type',
    'source',
    'source-layer',
    'minzoom',
    'maxzoom',
    'filter',
    'layout'
];
function $a094c77ab2bfe883$export$8756898546458274(style) {
    if (!style) return null;
    if (typeof style === 'string') return style;
    if ('toJS' in style) style = style.toJS();
    if (!style.layers) return style;
    const layerIndex = {};
    for (const layer of style.layers)layerIndex[layer.id] = layer;
    const layers = style.layers.map((layer)=>{
        let normalizedLayer = null;
        if ('interactive' in layer) {
            normalizedLayer = Object.assign({}, layer);
            // Breaks style diffing :(
            // @ts-ignore legacy field not typed
            delete normalizedLayer.interactive;
        }
        // Style diffing doesn't work with refs so expand them out manually before diffing.
        // @ts-ignore legacy field not typed
        const layerRef = layerIndex[layer.ref];
        if (layerRef) {
            normalizedLayer = normalizedLayer || Object.assign({}, layer);
            // @ts-ignore
            delete normalizedLayer.ref;
            // https://github.com/mapbox/mapbox-gl-js/blob/master/src/style-spec/deref.js
            for (const propName of $a094c77ab2bfe883$var$refProps)if (propName in layerRef) normalizedLayer[propName] = layerRef[propName];
        }
        return normalizedLayer || layer;
    });
    // Do not mutate the style object provided by the user
    return {
        ...style,
        layers: layers
    };
}


/**
 * Compare two points
 * @param a
 * @param b
 * @returns true if the points are equal
 */ function $fa9a11b39cbae09c$export$cb7477365ef68362(a, b) {
    const ax = Array.isArray(a) ? a[0] : a ? a.x : 0;
    const ay = Array.isArray(a) ? a[1] : a ? a.y : 0;
    const bx = Array.isArray(b) ? b[0] : b ? b.x : 0;
    const by = Array.isArray(b) ? b[1] : b ? b.y : 0;
    return ax === bx && ay === by;
}
function $fa9a11b39cbae09c$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    if (!a || !b) return false;
    if (Array.isArray(a)) {
        if (!Array.isArray(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!$fa9a11b39cbae09c$export$9cb4719e2e525b7a(a[i], b[i])) return false;
        }
        return true;
    } else if (Array.isArray(b)) return false;
    if (typeof a === 'object' && typeof b === 'object') {
        const aKeys = Object.keys(a);
        const bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) return false;
        for (const key of aKeys){
            if (!b.hasOwnProperty(key)) return false;
            if (!$fa9a11b39cbae09c$export$9cb4719e2e525b7a(a[key], b[key])) return false;
        }
        return true;
    }
    return false;
}


const $dd2aa969fed7ce36$var$DEFAULT_STYLE = {
    version: 8,
    sources: {},
    layers: []
};
const $dd2aa969fed7ce36$var$DEFAULT_SETTINGS = {
    minZoom: 0,
    maxZoom: 22,
    minPitch: 0,
    maxPitch: 85,
    maxBounds: [
        -180,
        -85.051129,
        180,
        85.051129
    ],
    projection: 'mercator',
    renderWorldCopies: true
};
const $dd2aa969fed7ce36$var$pointerEvents = {
    mousedown: 'onMouseDown',
    mouseup: 'onMouseUp',
    mouseover: 'onMouseOver',
    mousemove: 'onMouseMove',
    click: 'onClick',
    dblclick: 'onDblClick',
    mouseenter: 'onMouseEnter',
    mouseleave: 'onMouseLeave',
    mouseout: 'onMouseOut',
    contextmenu: 'onContextMenu',
    touchstart: 'onTouchStart',
    touchend: 'onTouchEnd',
    touchmove: 'onTouchMove',
    touchcancel: 'onTouchCancel'
};
const $dd2aa969fed7ce36$var$cameraEvents = {
    movestart: 'onMoveStart',
    move: 'onMove',
    moveend: 'onMoveEnd',
    dragstart: 'onDragStart',
    drag: 'onDrag',
    dragend: 'onDragEnd',
    zoomstart: 'onZoomStart',
    zoom: 'onZoom',
    zoomend: 'onZoomEnd',
    rotatestart: 'onRotateStart',
    rotate: 'onRotate',
    rotateend: 'onRotateEnd',
    pitchstart: 'onPitchStart',
    pitch: 'onPitch',
    pitchend: 'onPitchEnd'
};
const $dd2aa969fed7ce36$var$otherEvents = {
    wheel: 'onWheel',
    boxzoomstart: 'onBoxZoomStart',
    boxzoomend: 'onBoxZoomEnd',
    boxzoomcancel: 'onBoxZoomCancel',
    resize: 'onResize',
    load: 'onLoad',
    render: 'onRender',
    idle: 'onIdle',
    remove: 'onRemove',
    data: 'onData',
    styledata: 'onStyleData',
    sourcedata: 'onSourceData',
    error: 'onError'
};
const $dd2aa969fed7ce36$var$settingNames = [
    'minZoom',
    'maxZoom',
    'minPitch',
    'maxPitch',
    'maxBounds',
    'projection',
    'renderWorldCopies'
];
const $dd2aa969fed7ce36$var$handlerNames = [
    'scrollZoom',
    'boxZoom',
    'dragRotate',
    'dragPan',
    'keyboard',
    'doubleClickZoom',
    'touchZoomRotate',
    'touchPitch'
];
/**
 * A wrapper for mapbox-gl's Map class
 */ class $dd2aa969fed7ce36$var$Mapbox {
    constructor(MapClass, props, container){
        /** mapboxgl.Map instance */ this._map = null;
        // Internal states
        /** Making updates driven by React props. Do not trigger React callbacks to avoid infinite loop */ this._internalUpdate = false;
        /** Map is currently rendering */ this._inRender = false;
        /** Map features under the pointer */ this._hoveredFeatures = null;
        /** View state changes driven by React props
         * They still need to fire move/etc. events because controls such as marker/popup
         * subscribe to the move event internally to update their position
         * React callbacks like onMove are not called for these */ this._deferredEvents = {
            move: false,
            zoom: false,
            pitch: false,
            rotate: false
        };
        this._onEvent = (e)=>{
            // @ts-ignore
            const cb = this.props[$dd2aa969fed7ce36$var$otherEvents[e.type]];
            if (cb) cb(e);
            else if (e.type === 'error') console.error(e.error); // eslint-disable-line
        };
        this._onPointerEvent = (e)=>{
            if (e.type === 'mousemove' || e.type === 'mouseout') this._updateHover(e);
            // @ts-ignore
            const cb = this.props[$dd2aa969fed7ce36$var$pointerEvents[e.type]];
            if (cb) {
                if (this.props.interactiveLayerIds && e.type !== 'mouseover' && e.type !== 'mouseout') e.features = this._hoveredFeatures || this._queryRenderedFeatures(e.point);
                cb(e);
                delete e.features;
            }
        };
        this._onCameraEvent = (e)=>{
            if (!this._internalUpdate) {
                // @ts-ignore
                const cb = this.props[$dd2aa969fed7ce36$var$cameraEvents[e.type]];
                const tr = this._proxyTransform;
                if (cb) {
                    e.viewState = (0, $ff5c44d8dbab1cdc$export$6a605c5aa5bd97a8)(tr.$proposedTransform ?? tr);
                    cb(e);
                }
                if (e.type === 'moveend') tr.$proposedTransform = null;
            }
            if (e.type in this._deferredEvents) this._deferredEvents[e.type] = false;
        };
        this._MapClass = MapClass;
        this.props = props;
        this._initialize(container);
    }
    get map() {
        return this._map;
    }
    get transform() {
        return this._map.transform;
    }
    setProps(props) {
        const oldProps = this.props;
        this.props = props;
        const settingsChanged = this._updateSettings(props, oldProps);
        const sizeChanged = this._updateSize(props);
        const viewStateChanged = this._updateViewState(props, true);
        this._updateStyle(props, oldProps);
        this._updateStyleComponents(props, oldProps);
        this._updateHandlers(props, oldProps);
        // If 1) view state has changed to match props and
        //    2) the props change is not triggered by map events,
        // it's driven by an external state change. Redraw immediately
        if (settingsChanged || sizeChanged || viewStateChanged && !this._map.isMoving()) this.redraw();
    }
    static reuse(props, container) {
        const that = $dd2aa969fed7ce36$var$Mapbox.savedMaps.pop();
        if (!that) return null;
        const map = that.map;
        // When reusing the saved map, we need to reparent the map(canvas) and other child nodes
        // intoto the new container from the props.
        // Step 1: reparenting child nodes from old container to new container
        const oldContainer = map.getContainer();
        container.className = oldContainer.className;
        while(oldContainer.childNodes.length > 0)container.appendChild(oldContainer.childNodes[0]);
        // Step 2: replace the internal container with new container from the react component
        // @ts-ignore
        map._container = container;
        // Step 4: apply new props
        that.setProps({
            ...props,
            styleDiffing: false
        });
        map.resize();
        const { initialViewState: initialViewState } = props;
        if (initialViewState) {
            if (initialViewState.bounds) map.fitBounds(initialViewState.bounds, {
                ...initialViewState.fitBoundsOptions,
                duration: 0
            });
            else that._updateViewState(initialViewState, false);
        }
        // Simulate load event
        if (map.isStyleLoaded()) map.fire('load');
        else map.once('styledata', ()=>map.fire('load'));
        // Force reload
        // @ts-ignore
        map._update();
        return that;
    }
    /* eslint-disable complexity,max-statements */ _initialize(container) {
        const { props: props } = this;
        const { mapStyle: mapStyle = $dd2aa969fed7ce36$var$DEFAULT_STYLE } = props;
        const mapOptions = {
            ...props,
            ...props.initialViewState,
            accessToken: props.mapboxAccessToken || $dd2aa969fed7ce36$var$getAccessTokenFromEnv() || null,
            container: container,
            style: (0, $a094c77ab2bfe883$export$8756898546458274)(mapStyle)
        };
        const viewState = mapOptions.initialViewState || mapOptions.viewState || mapOptions;
        Object.assign(mapOptions, {
            center: [
                viewState.longitude || 0,
                viewState.latitude || 0
            ],
            zoom: viewState.zoom || 0,
            pitch: viewState.pitch || 0,
            bearing: viewState.bearing || 0
        });
        if (props.gl) {
            // eslint-disable-next-line
            const getContext = HTMLCanvasElement.prototype.getContext;
            // Hijack canvas.getContext to return our own WebGLContext
            // This will be called inside the mapboxgl.Map constructor
            // @ts-expect-error
            HTMLCanvasElement.prototype.getContext = ()=>{
                // Unhijack immediately
                HTMLCanvasElement.prototype.getContext = getContext;
                return props.gl;
            };
        }
        const map = new this._MapClass(mapOptions);
        // Props that are not part of constructor options
        if (viewState.padding) map.setPadding(viewState.padding);
        if (props.cursor) map.getCanvas().style.cursor = props.cursor;
        this._createProxyTransform(map);
        // Hack
        // Insert code into map's render cycle
        // eslint-disable-next-line @typescript-eslint/unbound-method
        const renderMap = map._render;
        map._render = (arg)=>{
            // Hijacked to set this state flag
            this._inRender = true;
            renderMap.call(map, arg);
            this._inRender = false;
        };
        // eslint-disable-next-line @typescript-eslint/unbound-method
        const runRenderTaskQueue = map._renderTaskQueue.run;
        map._renderTaskQueue.run = (arg)=>{
            // This is where camera updates from input handler/animation happens
            // And where all view state change events are fired
            this._proxyTransform.$internalUpdate = true;
            runRenderTaskQueue.call(map._renderTaskQueue, arg);
            this._proxyTransform.$internalUpdate = false;
            this._fireDefferedEvents();
        };
        // eslint-disable-next-line @typescript-eslint/unbound-method
        const jumpTo = map.jumpTo;
        map.jumpTo = (...args)=>{
            // This method will fire view state change events immediately
            this._proxyTransform.$internalUpdate = true;
            jumpTo.apply(map, args);
            this._proxyTransform.$internalUpdate = false;
            return map;
        };
        // Insert code into map's event pipeline
        // eslint-disable-next-line @typescript-eslint/unbound-method
        const fireEvent = map.fire;
        map.fire = this._fireEvent.bind(this, fireEvent);
        // add listeners
        map.on('styledata', ()=>{
            this._updateStyleComponents(this.props, {});
        });
        map.on('sourcedata', ()=>{
            this._updateStyleComponents(this.props, {});
        });
        for(const eventName in $dd2aa969fed7ce36$var$pointerEvents)map.on(eventName, this._onPointerEvent);
        for(const eventName in $dd2aa969fed7ce36$var$cameraEvents)map.on(eventName, this._onCameraEvent);
        for(const eventName in $dd2aa969fed7ce36$var$otherEvents)map.on(eventName, this._onEvent);
        this._map = map;
    }
    /* eslint-enable complexity,max-statements */ recycle() {
        // Clean up unnecessary elements before storing for reuse.
        const container = this.map.getContainer();
        const children = container.querySelector('[mapboxgl-children]');
        children?.remove();
        $dd2aa969fed7ce36$var$Mapbox.savedMaps.push(this);
    }
    destroy() {
        this._map.remove();
    }
    // Force redraw the map now. Typically resize() and jumpTo() is reflected in the next
    // render cycle, which is managed by Mapbox's animation loop.
    // This removes the synchronization issue caused by requestAnimationFrame.
    redraw() {
        const map = this._map;
        // map._render will throw error if style does not exist
        // https://github.com/mapbox/mapbox-gl-js/blob/fb9fc316da14e99ff4368f3e4faa3888fb43c513
        //   /src/ui/map.js#L1834
        if (!this._inRender && map.style) {
            // cancel the scheduled update
            if (map._frame) {
                map._frame.cancel();
                map._frame = null;
            }
            // the order is important - render() may schedule another update
            map._render();
        }
    }
    _createProxyTransform(map) {
        const proxyTransform = (0, $77de42fa790a40cd$export$3f6fb66aeea526f4)(map.transform);
        map.transform = proxyTransform;
        map.painter.transform = proxyTransform;
        this._proxyTransform = proxyTransform;
    }
    /* Trigger map resize if size is controlled
       @param {object} nextProps
       @returns {bool} true if size has changed
     */ _updateSize(nextProps) {
        // Check if size is controlled
        const { viewState: viewState } = nextProps;
        if (viewState) {
            const map = this._map;
            if (viewState.width !== map.transform.width || viewState.height !== map.transform.height) {
                map.resize();
                return true;
            }
        }
        return false;
    }
    // Adapted from map.jumpTo
    /* Update camera to match props
       @param {object} nextProps
       @param {bool} triggerEvents - should fire camera events
       @returns {bool} true if anything is changed
     */ _updateViewState(nextProps, triggerEvents) {
        const viewState = nextProps.viewState || nextProps;
        const tr = this._proxyTransform;
        const { zoom: zoom, pitch: pitch, bearing: bearing } = tr;
        const changed = (0, $ff5c44d8dbab1cdc$export$b3dd58694e7dc7d6)(this._proxyTransform, viewState);
        tr.$reactViewState = viewState;
        if (changed && triggerEvents) {
            const deferredEvents = this._deferredEvents;
            // Delay DOM control updates to the next render cycle
            deferredEvents.move = true;
            deferredEvents.zoom || (deferredEvents.zoom = zoom !== tr.zoom);
            deferredEvents.rotate || (deferredEvents.rotate = bearing !== tr.bearing);
            deferredEvents.pitch || (deferredEvents.pitch = pitch !== tr.pitch);
        }
        return changed;
    }
    /* Update camera constraints and projection settings to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if anything is changed
     */ _updateSettings(nextProps, currProps) {
        const map = this._map;
        let changed = false;
        for (const propName of $dd2aa969fed7ce36$var$settingNames){
            const propPresent = propName in nextProps || propName in currProps;
            if (propPresent && !(0, $fa9a11b39cbae09c$export$9cb4719e2e525b7a)(nextProps[propName], currProps[propName])) {
                changed = true;
                const nextValue = propName in nextProps ? nextProps[propName] : $dd2aa969fed7ce36$var$DEFAULT_SETTINGS[propName];
                const setter = map[`set${propName[0].toUpperCase()}${propName.slice(1)}`];
                setter?.call(map, nextValue);
            }
        }
        return changed;
    }
    /* Update map style to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if style is changed
     */ _updateStyle(nextProps, currProps) {
        if (nextProps.cursor !== currProps.cursor) this._map.getCanvas().style.cursor = nextProps.cursor || '';
        if (nextProps.mapStyle !== currProps.mapStyle) {
            const { mapStyle: mapStyle = $dd2aa969fed7ce36$var$DEFAULT_STYLE, styleDiffing: styleDiffing = true } = nextProps;
            const options = {
                diff: styleDiffing
            };
            if ('localIdeographFontFamily' in nextProps) // @ts-ignore Mapbox specific prop
            options.localIdeographFontFamily = nextProps.localIdeographFontFamily;
            this._map.setStyle((0, $a094c77ab2bfe883$export$8756898546458274)(mapStyle), options);
            return true;
        }
        return false;
    }
    /* Update fog, light and terrain to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if anything is changed
     */ _updateStyleComponents(nextProps, currProps) {
        const map = this._map;
        let changed = false;
        if (map.isStyleLoaded()) {
            if ('light' in nextProps && map.setLight && !(0, $fa9a11b39cbae09c$export$9cb4719e2e525b7a)(nextProps.light, currProps.light)) {
                changed = true;
                map.setLight(nextProps.light);
            }
            if ('fog' in nextProps && map.setFog && !(0, $fa9a11b39cbae09c$export$9cb4719e2e525b7a)(nextProps.fog, currProps.fog)) {
                changed = true;
                map.setFog(nextProps.fog);
            }
            if ('terrain' in nextProps && map.setTerrain && !(0, $fa9a11b39cbae09c$export$9cb4719e2e525b7a)(nextProps.terrain, currProps.terrain)) {
                if (!nextProps.terrain || map.getSource(nextProps.terrain.source)) {
                    changed = true;
                    map.setTerrain(nextProps.terrain);
                }
            }
        }
        return changed;
    }
    /* Update interaction handlers to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if anything is changed
     */ _updateHandlers(nextProps, currProps) {
        const map = this._map;
        let changed = false;
        for (const propName of $dd2aa969fed7ce36$var$handlerNames){
            const newValue = nextProps[propName] ?? true;
            const oldValue = currProps[propName] ?? true;
            if (!(0, $fa9a11b39cbae09c$export$9cb4719e2e525b7a)(newValue, oldValue)) {
                changed = true;
                if (newValue) map[propName].enable(newValue);
                else map[propName].disable();
            }
        }
        return changed;
    }
    _queryRenderedFeatures(point) {
        const map = this._map;
        const { interactiveLayerIds: interactiveLayerIds = [] } = this.props;
        try {
            return map.queryRenderedFeatures(point, {
                layers: interactiveLayerIds.filter(map.getLayer.bind(map))
            });
        } catch  {
            // May fail if style is not loaded
            return [];
        }
    }
    _updateHover(e) {
        const { props: props } = this;
        const shouldTrackHoveredFeatures = props.interactiveLayerIds && (props.onMouseMove || props.onMouseEnter || props.onMouseLeave);
        if (shouldTrackHoveredFeatures) {
            const eventType = e.type;
            const wasHovering = this._hoveredFeatures?.length > 0;
            const features = this._queryRenderedFeatures(e.point);
            const isHovering = features.length > 0;
            if (!isHovering && wasHovering) {
                e.type = 'mouseleave';
                this._onPointerEvent(e);
            }
            this._hoveredFeatures = features;
            if (isHovering && !wasHovering) {
                e.type = 'mouseenter';
                this._onPointerEvent(e);
            }
            e.type = eventType;
        } else this._hoveredFeatures = null;
    }
    _fireEvent(baseFire, event, properties) {
        const map = this._map;
        const tr = this._proxyTransform;
        // Always expose the controlled transform to controls/end user
        const internal = tr.$internalUpdate;
        try {
            tr.$internalUpdate = false;
            baseFire.call(map, event, properties);
        } finally{
            tr.$internalUpdate = internal;
        }
        return map;
    }
    // If there are camera changes driven by props, invoke camera events so that DOM controls are synced
    _fireDefferedEvents() {
        const map = this._map;
        this._internalUpdate = true;
        for(const eventType in this._deferredEvents)if (this._deferredEvents[eventType]) map.fire(eventType);
        this._internalUpdate = false;
    }
}
$dd2aa969fed7ce36$var$Mapbox.savedMaps = [];
var $dd2aa969fed7ce36$export$2e2bcd8739ae039 = $dd2aa969fed7ce36$var$Mapbox;
/**
 * Access token can be provided via one of:
 *   mapboxAccessToken prop
 *   access_token query parameter
 *   MapboxAccessToken environment variable
 *   REACT_APP_MAPBOX_ACCESS_TOKEN environment variable
 * @returns access token
 */ function $dd2aa969fed7ce36$var$getAccessTokenFromEnv() {
    let accessToken = null;
    /* global location, process */ if (typeof location !== 'undefined') {
        const match = /access_token=([^&\/]*)/.exec(location.search);
        accessToken = match && match[1];
    }
    // Note: This depends on bundler plugins (e.g. webpack) importing environment correctly
    try {
        // eslint-disable-next-line no-process-env
        accessToken = accessToken || undefined;
    } catch  {
    // ignore
    }
    try {
        // eslint-disable-next-line no-process-env
        accessToken = accessToken || undefined;
    } catch  {
    // ignore
    }
    return accessToken;
}


/** These methods may break the react binding if called directly */ const $446437da5c611ae3$var$skipMethods = [
    'setMaxBounds',
    'setMinZoom',
    'setMaxZoom',
    'setMinPitch',
    'setMaxPitch',
    'setRenderWorldCopies',
    'setProjection',
    'setStyle',
    'addSource',
    'removeSource',
    'addLayer',
    'removeLayer',
    'setLayerZoomRange',
    'setFilter',
    'setPaintProperty',
    'setLayoutProperty',
    'setLight',
    'setTerrain',
    'setFog',
    'remove'
];
function $446437da5c611ae3$export$2e2bcd8739ae039(mapInstance) {
    if (!mapInstance) return null;
    const map = mapInstance.map;
    const ref = {
        getMap: ()=>map,
        // Overwrite getters to use our shadow transform
        getCenter: ()=>mapInstance.transform.center,
        getZoom: ()=>mapInstance.transform.zoom,
        getBearing: ()=>mapInstance.transform.bearing,
        getPitch: ()=>mapInstance.transform.pitch,
        getPadding: ()=>mapInstance.transform.padding,
        getBounds: ()=>mapInstance.transform.getBounds(),
        project: (lnglat)=>{
            const tr = map.transform;
            map.transform = mapInstance.transform;
            const result = map.project(lnglat);
            map.transform = tr;
            return result;
        },
        unproject: (point)=>{
            const tr = map.transform;
            map.transform = mapInstance.transform;
            const result = map.unproject(point);
            map.transform = tr;
            return result;
        },
        // options diverge between mapbox and maplibre
        queryTerrainElevation: (lnglat, options)=>{
            const tr = map.transform;
            map.transform = mapInstance.transform;
            const result = map.queryTerrainElevation(lnglat, options);
            map.transform = tr;
            return result;
        },
        queryRenderedFeatures: (geometry, options)=>{
            const tr = map.transform;
            map.transform = mapInstance.transform;
            const result = map.queryRenderedFeatures(geometry, options);
            map.transform = tr;
            return result;
        }
    };
    for (const key of $446437da5c611ae3$var$getMethodNames(map))// @ts-expect-error
    if (!(key in ref) && !$446437da5c611ae3$var$skipMethods.includes(key)) ref[key] = map[key].bind(map);
    return ref;
}
function $446437da5c611ae3$var$getMethodNames(obj) {
    const result = new Set();
    let proto = obj;
    while(proto){
        for (const key of Object.getOwnPropertyNames(proto))if (key[0] !== '_' && typeof obj[key] === 'function' && key !== 'fire' && key !== 'setEventedParent') result.add(key);
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(result);
}


// From https://github.com/streamich/react-use/blob/master/src/useIsomorphicLayoutEffect.ts
// useLayoutEffect but does not trigger warning in server-side rendering

var $acw62 = parcelRequire("acw62");
const $f8b3d6ab422d616a$var$useIsomorphicLayoutEffect = typeof document !== 'undefined' ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
var $f8b3d6ab422d616a$export$2e2bcd8739ae039 = $f8b3d6ab422d616a$var$useIsomorphicLayoutEffect;


const $6bc0917fdb1df427$var$globalSettings = [
    'baseApiUrl',
    'maxParallelImageRequests',
    'workerClass',
    'workerCount',
    'workerUrl'
];
function $6bc0917fdb1df427$export$2e2bcd8739ae039(mapLib, props) {
    for (const key of $6bc0917fdb1df427$var$globalSettings)if (key in props) mapLib[key] = props[key];
    const { RTLTextPlugin: RTLTextPlugin = 'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js' } = props;
    if (RTLTextPlugin && mapLib.getRTLTextPluginStatus && mapLib.getRTLTextPluginStatus() === 'unavailable') mapLib.setRTLTextPlugin(RTLTextPlugin, (error)=>{
        if (error) // eslint-disable-next-line
        console.error(error);
    }, true);
}


const $9bfa0fb4992bfff5$export$dc7344301ae78f85 = $acw62.createContext(null);

function $9bfa0fb4992bfff5$var$_Map(props, ref) {
    const mountedMapsContext = (0, $acw62.useContext)((0, $64c812a720876a94$export$c6c68f6e4db55944));
    const [mapInstance, setMapInstance] = (0, $acw62.useState)(null);
    const containerRef = (0, $acw62.useRef)();
    const { current: contextValue } = (0, $acw62.useRef)({
        mapLib: null,
        map: null
    });
    (0, $acw62.useEffect)(()=>{
        const mapLib = props.mapLib;
        let isMounted = true;
        let mapbox;
        Promise.resolve(mapLib || Promise.resolve((parcelRequire("f2WZf")))).then((module)=>{
            if (!isMounted) return;
            if (!module) throw new Error('Invalid mapLib');
            const mapboxgl = 'Map' in module ? module : module.default;
            if (!mapboxgl.Map) throw new Error('Invalid mapLib');
            (0, $6bc0917fdb1df427$export$2e2bcd8739ae039)(mapboxgl, props);
            if (props.reuseMaps) mapbox = (0, $dd2aa969fed7ce36$export$2e2bcd8739ae039).reuse(props, containerRef.current);
            if (!mapbox) mapbox = new (0, $dd2aa969fed7ce36$export$2e2bcd8739ae039)(mapboxgl.Map, props, containerRef.current);
            contextValue.map = (0, $446437da5c611ae3$export$2e2bcd8739ae039)(mapbox);
            contextValue.mapLib = mapboxgl;
            setMapInstance(mapbox);
            mountedMapsContext?.onMapMount(contextValue.map, props.id);
        }).catch((error)=>{
            const { onError: onError } = props;
            if (onError) onError({
                type: 'error',
                target: null,
                error: error
            });
            else console.error(error); // eslint-disable-line
        });
        return ()=>{
            isMounted = false;
            if (mapbox) {
                mountedMapsContext?.onMapUnmount(props.id);
                if (props.reuseMaps) mapbox.recycle();
                else mapbox.destroy();
            }
        };
    }, []);
    (0, $f8b3d6ab422d616a$export$2e2bcd8739ae039)(()=>{
        if (mapInstance) mapInstance.setProps(props);
    });
    (0, $acw62.useImperativeHandle)(ref, ()=>contextValue.map, [
        mapInstance
    ]);
    const style = (0, $acw62.useMemo)(()=>({
            position: 'relative',
            width: '100%',
            height: '100%',
            ...props.style
        }), [
        props.style
    ]);
    const CHILD_CONTAINER_STYLE = {
        height: '100%'
    };
    return $acw62.createElement("div", {
        id: props.id,
        ref: containerRef,
        style: style
    }, mapInstance && $acw62.createElement($9bfa0fb4992bfff5$export$dc7344301ae78f85.Provider, {
        value: contextValue
    }, $acw62.createElement("div", {
        "mapboxgl-children": "",
        style: CHILD_CONTAINER_STYLE
    }, props.children)));
}
const $9bfa0fb4992bfff5$export$a5c7b93649eaf8f8 = $acw62.forwardRef($9bfa0fb4992bfff5$var$_Map);




var $1u0KT = parcelRequire("1u0KT");

var $acw62 = parcelRequire("acw62");
// This is a simplified version of
// https://github.com/facebook/react/blob/4131af3e4bf52f3a003537ec95a1655147c81270/src/renderers/dom/shared/CSSPropertyOperations.js#L62
const $18b1ed6b4fa22416$var$unitlessNumber = /box|flex|grid|column|lineHeight|fontWeight|opacity|order|tabSize|zIndex/;
function $18b1ed6b4fa22416$export$cd93e47e6d398387(element, styles) {
    if (!element || !styles) return;
    const style = element.style;
    for(const key in styles){
        const value = styles[key];
        if (Number.isFinite(value) && !$18b1ed6b4fa22416$var$unitlessNumber.test(key)) style[key] = `${value}px`;
        else style[key] = value;
    }
}




/** Compare two classNames string and return the difference */ function $f3ff1de5d4153981$export$a97e6c0d7c843e54(prevClassName, nextClassName) {
    if (prevClassName === nextClassName) return null;
    const prevClassList = $f3ff1de5d4153981$var$getClassList(prevClassName);
    const nextClassList = $f3ff1de5d4153981$var$getClassList(nextClassName);
    const diff = [];
    for (const c of nextClassList)if (!prevClassList.has(c)) diff.push(c);
    for (const c of prevClassList)if (!nextClassList.has(c)) diff.push(c);
    return diff.length === 0 ? null : diff;
}
function $f3ff1de5d4153981$var$getClassList(className) {
    return new Set(className ? className.trim().split(/\s+/) : []);
}


const $01b7fef3c5ac1f78$export$129a32eedafa97c5 = (0, $acw62.memo)((0, $acw62.forwardRef)((props, ref)=>{
    const { map: map, mapLib: mapLib } = (0, $acw62.useContext)((0, $9bfa0fb4992bfff5$export$dc7344301ae78f85));
    const container = (0, $acw62.useMemo)(()=>{
        return document.createElement('div');
    }, []);
    const thisRef = (0, $acw62.useRef)({
        props: props
    });
    const popup = (0, $acw62.useMemo)(()=>{
        const options = {
            ...props
        };
        const pp = new mapLib.Popup(options);
        pp.setLngLat([
            props.longitude,
            props.latitude
        ]);
        pp.once('open', (e)=>{
            thisRef.current.props.onOpen?.(e);
        });
        return pp;
    }, []);
    (0, $acw62.useEffect)(()=>{
        const onClose = (e)=>{
            thisRef.current.props.onClose?.(e);
        };
        popup.on('close', onClose);
        popup.setDOMContent(container).addTo(map.getMap());
        return ()=>{
            // https://github.com/visgl/react-map-gl/issues/1825
            // onClose should not be fired if the popup is removed by unmounting
            // When using React strict mode, the component is mounted twice.
            // Firing the onClose callback here would be a false signal to remove the component.
            popup.off('close', onClose);
            if (popup.isOpen()) popup.remove();
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        (0, $18b1ed6b4fa22416$export$cd93e47e6d398387)(popup.getElement(), props.style);
    }, [
        props.style
    ]);
    (0, $acw62.useImperativeHandle)(ref, ()=>popup, []);
    if (popup.isOpen()) {
        const oldProps = thisRef.current.props;
        if (popup.getLngLat().lng !== props.longitude || popup.getLngLat().lat !== props.latitude) popup.setLngLat([
            props.longitude,
            props.latitude
        ]);
        if (props.offset && !(0, $fa9a11b39cbae09c$export$9cb4719e2e525b7a)(oldProps.offset, props.offset)) {
            popup.options.anchor = props.anchor;
            popup.setOffset(props.offset);
        }
        if (oldProps.anchor !== props.anchor || oldProps.maxWidth !== props.maxWidth) popup.setMaxWidth(props.maxWidth);
        const classNameDiff = (0, $f3ff1de5d4153981$export$a97e6c0d7c843e54)(oldProps.className, props.className);
        if (classNameDiff) for (const c of classNameDiff)popup.toggleClassName(c);
        thisRef.current.props = props;
    }
    return (0, $1u0KT.createPortal)(props.children, container);
}));




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

function $546917c3aede178b$export$62ad9a427fe0e7c8(onCreate, arg1, arg2, arg3) {
    const context = (0, $acw62.useContext)((0, $9bfa0fb4992bfff5$export$dc7344301ae78f85));
    const ctrl = (0, $acw62.useMemo)(()=>onCreate(context), []);
    (0, $acw62.useEffect)(()=>{
        const opts = arg3 || arg2 || arg1;
        const onAdd = typeof arg1 === 'function' && typeof arg2 === 'function' ? arg1 : null;
        const onRemove = typeof arg2 === 'function' ? arg2 : typeof arg1 === 'function' ? arg1 : null;
        const { map: map } = context;
        if (!map.hasControl(ctrl)) {
            map.addControl(ctrl, opts?.position);
            if (onAdd) onAdd(context);
        }
        return ()=>{
            if (onRemove) onRemove(context);
            // Map might have been removed (parent effects are destroyed before child ones)
            if (map.hasControl(ctrl)) map.removeControl(ctrl);
        };
    }, []);
    return ctrl;
}


function $84bb7b8c989e3187$var$_FullscreenControl(props) {
    const ctrl = (0, $546917c3aede178b$export$62ad9a427fe0e7c8)(({ mapLib: mapLib })=>new mapLib.FullscreenControl({
            container: props.containerId && document.getElementById(props.containerId)
        }), {
        position: props.position
    });
    (0, $acw62.useEffect)(()=>{
        (0, $18b1ed6b4fa22416$export$cd93e47e6d398387)(ctrl._controlContainer, props.style);
    }, [
        props.style
    ]);
    return null;
}
const $84bb7b8c989e3187$export$91e8ffb52c2b32c5 = (0, $acw62.memo)($84bb7b8c989e3187$var$_FullscreenControl);




var $acw62 = parcelRequire("acw62");


function $b4c62ddd92212ae9$var$_NavigationControl(props) {
    const ctrl = (0, $546917c3aede178b$export$62ad9a427fe0e7c8)(({ mapLib: mapLib })=>new mapLib.NavigationControl(props), {
        position: props.position
    });
    (0, $acw62.useEffect)(()=>{
        (0, $18b1ed6b4fa22416$export$cd93e47e6d398387)(ctrl._container, props.style);
    }, [
        props.style
    ]);
    return null;
}
const $b4c62ddd92212ae9$export$49a437922edc1bd9 = (0, $acw62.memo)($b4c62ddd92212ae9$var$_NavigationControl);




var $acw62 = parcelRequire("acw62");

function $e69de7c82be7d2bb$export$2e2bcd8739ae039(condition, message) {
    if (!condition) throw new Error(message);
}



function $f3838c37798825c0$export$c724aacd61334138(map, id) {
    // Mapbox may create terrain before evaluating its properties. In that state,
    // Map#removeSource throws from its subsequent terrain update.
    // https://github.com/mapbox/mapbox-gl-js/blob/7a72385de5c7400647ea7d3539637145fdf616a7/src/terrain/terrain.ts#L380
    // @ts-ignore Mapbox private terrain state
    const terrain = map.style?.terrain;
    try {
        map.removeSource(id);
    } catch (error) {
        if (!(error instanceof TypeError) || !terrain || terrain.properties !== undefined) throw error;
        console.error(error); // eslint-disable-line
    }
}


let $c2d35c3db04f1ab9$var$sourceCounter = 0;
function $c2d35c3db04f1ab9$var$createSource(map, id, props) {
    // @ts-ignore
    if (map.style && map.style._loaded) {
        const options = {
            ...props
        };
        delete options.id;
        delete options.children;
        // @ts-ignore
        map.addSource(id, options);
        return map.getSource(id);
    }
    return null;
}
/* eslint-disable complexity */ function $c2d35c3db04f1ab9$var$updateSource(source, props, prevProps) {
    (0, $e69de7c82be7d2bb$export$2e2bcd8739ae039)(props.id === prevProps.id, 'source id changed');
    (0, $e69de7c82be7d2bb$export$2e2bcd8739ae039)(props.type === prevProps.type, 'source type changed');
    let changedKey = '';
    let changedKeyCount = 0;
    for(const key in props)if (key !== 'children' && key !== 'id' && !(0, $fa9a11b39cbae09c$export$9cb4719e2e525b7a)(prevProps[key], props[key])) {
        changedKey = key;
        changedKeyCount++;
    }
    if (!changedKeyCount) return;
    const type = props.type;
    if (type === 'geojson') source.setData(props.data);
    else if (type === 'image') source.updateImage({
        url: props.url,
        coordinates: props.coordinates
    });
    else if ('setCoordinates' in source && changedKeyCount === 1 && changedKey === 'coordinates') source.setCoordinates(props.coordinates);
    else if ('setUrl' in source && changedKey === 'url') source.setUrl(props.url);
    else if ('setTiles' in source && changedKey === 'tiles') source.setTiles(props.tiles);
    else // eslint-disable-next-line
    console.warn(`Unable to update <Source> prop: ${changedKey}`);
}
function $c2d35c3db04f1ab9$export$1d2df86270c81ecb(props) {
    const map = (0, $acw62.useContext)((0, $9bfa0fb4992bfff5$export$dc7344301ae78f85)).map.getMap();
    const propsRef = (0, $acw62.useRef)(props);
    const [, setStyleLoaded] = (0, $acw62.useState)(0);
    const id = (0, $acw62.useMemo)(()=>props.id || `jsx-source-${$c2d35c3db04f1ab9$var$sourceCounter++}`, []);
    (0, $acw62.useEffect)(()=>{
        if (map) {
            /* global setTimeout */ const forceUpdate = ()=>setTimeout(()=>setStyleLoaded((version)=>version + 1), 0);
            map.on('styledata', forceUpdate);
            forceUpdate();
            return ()=>{
                map.off('styledata', forceUpdate);
                // @ts-ignore
                if (map.style && map.style._loaded && map.getSource(id)) {
                    // Parent effects are destroyed before child ones, see
                    // https://github.com/facebook/react/issues/16728
                    // Source can only be removed after all child layers are removed
                    const allLayers = map.getStyle()?.layers;
                    if (allLayers) {
                        for (const layer of allLayers)// @ts-ignore (2339) source does not exist on all layer types
                        if (layer.source === id) map.removeLayer(layer.id);
                    }
                    (0, $f3838c37798825c0$export$c724aacd61334138)(map, id);
                }
            };
        }
        return undefined;
    }, [
        map
    ]);
    // @ts-ignore
    let source = map && map.style && map.getSource(id);
    if (source) $c2d35c3db04f1ab9$var$updateSource(source, props, propsRef.current);
    else source = $c2d35c3db04f1ab9$var$createSource(map, id, props);
    propsRef.current = props;
    return source && $acw62.Children.map(props.children, (child)=>child && (0, $acw62.cloneElement)(child, {
            source: id
        })) || null;
}



var $acw62 = parcelRequire("acw62");



/* eslint-disable complexity, max-statements */ function $baf7a1f21323fe66$var$updateLayer(map, id, props, prevProps) {
    (0, $e69de7c82be7d2bb$export$2e2bcd8739ae039)(props.id === prevProps.id, 'layer id changed');
    (0, $e69de7c82be7d2bb$export$2e2bcd8739ae039)(props.type === prevProps.type, 'layer type changed');
    if (props.type === 'custom' || prevProps.type === 'custom') return;
    // @ts-ignore filter does not exist in some Layer types
    const { layout: layout = {}, paint: paint = {}, filter: filter, minzoom: minzoom, maxzoom: maxzoom, beforeId: beforeId } = props;
    if (beforeId !== prevProps.beforeId) map.moveLayer(id, beforeId);
    if (layout !== prevProps.layout) {
        const prevLayout = prevProps.layout || {};
        for(const key in layout)if (!(0, $fa9a11b39cbae09c$export$9cb4719e2e525b7a)(layout[key], prevLayout[key])) map.setLayoutProperty(id, key, layout[key]);
        for(const key in prevLayout)if (!layout.hasOwnProperty(key)) map.setLayoutProperty(id, key, undefined);
    }
    if (paint !== prevProps.paint) {
        const prevPaint = prevProps.paint || {};
        for(const key in paint)if (!(0, $fa9a11b39cbae09c$export$9cb4719e2e525b7a)(paint[key], prevPaint[key])) map.setPaintProperty(id, key, paint[key]);
        for(const key in prevPaint)if (!paint.hasOwnProperty(key)) map.setPaintProperty(id, key, undefined);
    }
    // @ts-ignore filter does not exist in some Layer types
    if (!(0, $fa9a11b39cbae09c$export$9cb4719e2e525b7a)(filter, prevProps.filter)) map.setFilter(id, filter);
    if (minzoom !== prevProps.minzoom || maxzoom !== prevProps.maxzoom) map.setLayerZoomRange(id, minzoom, maxzoom);
}
function $baf7a1f21323fe66$var$createLayer(map, id, props) {
    // @ts-ignore
    if (map.style && map.style._loaded && (!('source' in props) || map.getSource(props.source))) {
        const options = {
            ...props,
            id: id
        };
        delete options.beforeId;
        // @ts-ignore
        map.addLayer(options, props.beforeId);
    }
}
/* eslint-enable complexity, max-statements */ let $baf7a1f21323fe66$var$layerCounter = 0;
function $baf7a1f21323fe66$export$936d0764594b6eb3(props) {
    const map = (0, $acw62.useContext)((0, $9bfa0fb4992bfff5$export$dc7344301ae78f85)).map.getMap();
    const propsRef = (0, $acw62.useRef)(props);
    const [, setStyleLoaded] = (0, $acw62.useState)(0);
    const id = (0, $acw62.useMemo)(()=>props.id || `jsx-layer-${$baf7a1f21323fe66$var$layerCounter++}`, []);
    (0, $acw62.useEffect)(()=>{
        if (map) {
            const forceUpdate = ()=>setStyleLoaded((version)=>version + 1);
            map.on('styledata', forceUpdate);
            forceUpdate();
            return ()=>{
                map.off('styledata', forceUpdate);
                // @ts-ignore
                if (map.style && map.style._loaded && map.getLayer(id)) map.removeLayer(id);
            };
        }
        return undefined;
    }, [
        map
    ]);
    // @ts-ignore
    const layer = map && map.style && map.getLayer(id);
    if (layer) try {
        $baf7a1f21323fe66$var$updateLayer(map, id, props, propsRef.current);
    } catch (error) {
        console.warn(error); // eslint-disable-line
    }
    else $baf7a1f21323fe66$var$createLayer(map, id, props);
    // Store last rendered props
    propsRef.current = props;
    return null;
}








var $e92445ef245d46f7$export$2e2bcd8739ae039 = (0, $9bfa0fb4992bfff5$export$a5c7b93649eaf8f8);


// Components

var $f2WZf = parcelRequire("f2WZf");

var $614dc5797fe9f350$exports = {};
'use strict';
var $cab0705cde42bc82$exports = {};
'use strict';
var $352ad1bb93c26c36$exports = {};
'use strict';
var $c61292941889f8f2$exports = {};
$c61292941889f8f2$exports = $c61292941889f8f2$var$extend;
var $c61292941889f8f2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $c61292941889f8f2$var$extend() {
    var target = {};
    for(var i = 0; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if ($c61292941889f8f2$var$hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}


var $ca0b4b54599ec457$exports = {};
/*
 * Fuzzy
 * https://github.com/myork/fuzzy
 *
 * Copyright (c) 2012 Matt York
 * Licensed under the MIT license.
 */ (function() {
    var root = this;
    var fuzzy = {};
    $ca0b4b54599ec457$exports = fuzzy;
    // Return all elements of `array` that have a fuzzy
    // match against `pattern`.
    fuzzy.simpleFilter = function(pattern, array) {
        return array.filter(function(str) {
            return fuzzy.test(pattern, str);
        });
    };
    // Does `pattern` fuzzy match `str`?
    fuzzy.test = function(pattern, str) {
        return fuzzy.match(pattern, str) !== null;
    };
    // If `pattern` matches `str`, wrap each matching character
    // in `opts.pre` and `opts.post`. If no match, return null
    fuzzy.match = function(pattern, str, opts) {
        opts = opts || {};
        var patternIdx = 0, result = [], len = str.length, totalScore = 0, currScore = 0, pre = opts.pre || '', post = opts.post || '', compareString = opts.caseSensitive && str || str.toLowerCase(), ch;
        pattern = opts.caseSensitive && pattern || pattern.toLowerCase();
        // For each character in the string, either add it to the result
        // or wrap in template if it's the next string in the pattern
        for(var idx = 0; idx < len; idx++){
            ch = str[idx];
            if (compareString[idx] === pattern[patternIdx]) {
                ch = pre + ch + post;
                patternIdx += 1;
                // consecutive characters should increase the score more than linearly
                currScore += 1 + currScore;
            } else currScore = 0;
            totalScore += currScore;
            result[result.length] = ch;
        }
        // return rendered string if we have a match for every char
        if (patternIdx === pattern.length) {
            // if the string is an exact match with pattern, totalScore should be maxed
            totalScore = compareString === pattern ? Infinity : totalScore;
            return {
                rendered: result.join(''),
                score: totalScore
            };
        }
        return null;
    };
    // The normal entry point. Filters `arr` for matches against `pattern`.
    // It returns an array with matching values of the type:
    //
    //     [{
    //         string:   '<b>lah' // The rendered string
    //       , index:    2        // The index of the element in `arr`
    //       , original: 'blah'   // The original element in `arr`
    //     }]
    //
    // `opts` is an optional argument bag. Details:
    //
    //    opts = {
    //        // string to put before a matching character
    //        pre:     '<b>'
    //
    //        // string to put after matching character
    //      , post:    '</b>'
    //
    //        // Optional function. Input is an entry in the given arr`,
    //        // output should be the string to test `pattern` against.
    //        // In this example, if `arr = [{crying: 'koala'}]` we would return
    //        // 'koala'.
    //      , extract: function(arg) { return arg.crying; }
    //    }
    fuzzy.filter = function(pattern, arr, opts) {
        if (!arr || arr.length === 0) return [];
        if (typeof pattern !== 'string') return arr;
        opts = opts || {};
        return arr.reduce(function(prev, element, idx, arr) {
            var str = element;
            if (opts.extract) str = opts.extract(element);
            var rendered = fuzzy.match(pattern, str, opts);
            if (rendered != null) prev[prev.length] = {
                string: rendered.rendered,
                score: rendered.score,
                index: idx,
                original: element
            };
            return prev;
        }, [])// Sort by score. Browsers are inconsistent wrt stable/unstable
        // sorting, so force stable by using the index in the case of tie.
        // See http://ofb.net/~sethml/is-sort-stable.html
        .sort(function(a, b) {
            var compare = b.score - a.score;
            if (compare) return compare;
            return a.index - b.index;
        });
    };
})();


var $f7a746d9350036f9$exports = {};
'use strict';
var $f7a746d9350036f9$var$List = function(component) {
    this.component = component;
    this.items = [];
    this.active = 0;
    this.wrapper = document.createElement('div');
    this.wrapper.className = 'suggestions-wrapper';
    this.element = document.createElement('ul');
    this.element.className = 'suggestions';
    this.wrapper.appendChild(this.element);
    // selectingListItem is set to true in the time between the mousedown and mouseup when clicking an item in the list
    // mousedown on a list item will cause the input to blur which normally hides the list, so this flag is used to keep
    // the list open until the mouseup
    this.selectingListItem = false;
    component.el.parentNode.insertBefore(this.wrapper, component.el.nextSibling);
    return this;
};
$f7a746d9350036f9$var$List.prototype.show = function() {
    this.element.style.display = 'block';
};
$f7a746d9350036f9$var$List.prototype.hide = function() {
    this.element.style.display = 'none';
};
$f7a746d9350036f9$var$List.prototype.add = function(item) {
    this.items.push(item);
};
$f7a746d9350036f9$var$List.prototype.clear = function() {
    this.items = [];
    this.active = 0;
};
$f7a746d9350036f9$var$List.prototype.isEmpty = function() {
    return !this.items.length;
};
$f7a746d9350036f9$var$List.prototype.isVisible = function() {
    return this.element.style.display === 'block';
};
$f7a746d9350036f9$var$List.prototype.draw = function() {
    this.element.innerHTML = '';
    if (this.items.length === 0) {
        this.hide();
        return;
    }
    for(var i = 0; i < this.items.length; i++)this.drawItem(this.items[i], this.active === i);
    this.show();
};
$f7a746d9350036f9$var$List.prototype.drawItem = function(item, active) {
    var li = document.createElement('li'), a = document.createElement('a');
    if (active) li.className += ' active';
    a.innerHTML = item.string;
    li.appendChild(a);
    this.element.appendChild(li);
    li.addEventListener('mousedown', (function() {
        this.selectingListItem = true;
    }).bind(this));
    li.addEventListener('mouseup', (function() {
        this.handleMouseUp.call(this, item);
    }).bind(this));
};
$f7a746d9350036f9$var$List.prototype.handleMouseUp = function(item) {
    this.selectingListItem = false;
    this.component.value(item.original);
    this.clear();
    this.draw();
};
$f7a746d9350036f9$var$List.prototype.move = function(index) {
    this.active = index;
    this.draw();
};
$f7a746d9350036f9$var$List.prototype.previous = function() {
    this.move(this.active === 0 ? this.items.length - 1 : this.active - 1);
};
$f7a746d9350036f9$var$List.prototype.next = function() {
    this.move(this.active === this.items.length - 1 ? 0 : this.active + 1);
};
$f7a746d9350036f9$var$List.prototype.drawError = function(msg) {
    var li = document.createElement('li');
    li.innerHTML = msg;
    this.element.appendChild(li);
    this.show();
};
$f7a746d9350036f9$exports = $f7a746d9350036f9$var$List;


var $352ad1bb93c26c36$var$Suggestions = function(el, data, options) {
    options = options || {};
    this.options = $c61292941889f8f2$exports({
        minLength: 2,
        limit: 5,
        filter: true,
        hideOnBlur: true
    }, options);
    this.el = el;
    this.data = data || [];
    this.list = new $f7a746d9350036f9$exports(this);
    this.query = '';
    this.selected = null;
    this.list.draw();
    this.el.addEventListener('keyup', (function(e) {
        this.handleKeyUp(e.keyCode);
    }).bind(this), false);
    this.el.addEventListener('keydown', (function(e) {
        this.handleKeyDown(e);
    }).bind(this));
    this.el.addEventListener('focus', (function() {
        this.handleFocus();
    }).bind(this));
    this.el.addEventListener('blur', (function() {
        this.handleBlur();
    }).bind(this));
    this.el.addEventListener('paste', (function(e) {
        this.handlePaste(e);
    }).bind(this));
    // use user-provided render function if given, otherwise just use the default
    this.render = this.options.render ? this.options.render.bind(this) : this.render.bind(this);
    this.getItemValue = this.options.getItemValue ? this.options.getItemValue.bind(this) : this.getItemValue.bind(this);
    return this;
};
$352ad1bb93c26c36$var$Suggestions.prototype.handleKeyUp = function(keyCode) {
    // 40 - DOWN
    // 38 - UP
    // 27 - ESC
    // 13 - ENTER
    // 9 - TAB
    if (keyCode === 40 || keyCode === 38 || keyCode === 27 || keyCode === 13 || keyCode === 9) return;
    this.handleInputChange(this.el.value);
};
$352ad1bb93c26c36$var$Suggestions.prototype.handleKeyDown = function(e) {
    switch(e.keyCode){
        case 13:
        case 9:
            if (!this.list.isEmpty()) {
                if (this.list.isVisible()) e.preventDefault();
                this.value(this.list.items[this.list.active].original);
                this.list.hide();
            }
            break;
        case 27:
            if (!this.list.isEmpty()) this.list.hide();
            break;
        case 38:
            this.list.previous();
            break;
        case 40:
            this.list.next();
            break;
    }
};
$352ad1bb93c26c36$var$Suggestions.prototype.handleBlur = function() {
    if (!this.list.selectingListItem && this.options.hideOnBlur) this.list.hide();
};
$352ad1bb93c26c36$var$Suggestions.prototype.handlePaste = function(e) {
    if (e.clipboardData) this.handleInputChange(e.clipboardData.getData('Text'));
    else {
        var self = this;
        setTimeout(function() {
            self.handleInputChange(e.target.value);
        }, 100);
    }
};
$352ad1bb93c26c36$var$Suggestions.prototype.handleInputChange = function(query) {
    this.query = this.normalize(query);
    this.list.clear();
    if (this.query.length < this.options.minLength) {
        this.list.draw();
        return;
    }
    this.getCandidates((function(data) {
        for(var i = 0; i < data.length; i++){
            this.list.add(data[i]);
            if (i === this.options.limit - 1) break;
        }
        this.list.draw();
    }).bind(this));
};
$352ad1bb93c26c36$var$Suggestions.prototype.handleFocus = function() {
    if (!this.list.isEmpty()) this.list.show();
    this.list.selectingListItem = false;
};
/**
 * Update data previously passed
 *
 * @param {Array} revisedData
 */ $352ad1bb93c26c36$var$Suggestions.prototype.update = function(revisedData) {
    this.data = revisedData;
    this.handleKeyUp();
};
/**
 * Clears data
 */ $352ad1bb93c26c36$var$Suggestions.prototype.clear = function() {
    this.data = [];
    this.list.clear();
};
/**
 * Normalize the results list and input value for matching
 *
 * @param {String} value
 * @return {String}
 */ $352ad1bb93c26c36$var$Suggestions.prototype.normalize = function(value) {
    value = value.toLowerCase();
    return value;
};
/**
 * Evaluates whether an array item qualifies as a match with the current query
 *
 * @param {String} candidate a possible item from the array passed
 * @param {String} query the current query
 * @return {Boolean}
 */ $352ad1bb93c26c36$var$Suggestions.prototype.match = function(candidate, query) {
    return candidate.indexOf(query) > -1;
};
$352ad1bb93c26c36$var$Suggestions.prototype.value = function(value) {
    this.selected = value;
    this.el.value = this.getItemValue(value);
    if (document.createEvent) {
        var e = document.createEvent('HTMLEvents');
        e.initEvent('change', true, false);
        this.el.dispatchEvent(e);
    } else this.el.fireEvent('onchange');
};
$352ad1bb93c26c36$var$Suggestions.prototype.getCandidates = function(callback) {
    var options = {
        pre: '<strong>',
        post: '</strong>',
        extract: (function(d) {
            return this.getItemValue(d);
        }).bind(this)
    };
    var results;
    if (this.options.filter) {
        results = $ca0b4b54599ec457$exports.filter(this.query, this.data, options);
        results = results.map((function(item) {
            return {
                original: item.original,
                string: this.render(item.original, item.string)
            };
        }).bind(this));
    } else results = this.data.map((function(d) {
        var renderedString = this.render(d);
        return {
            original: d,
            string: renderedString
        };
    }).bind(this));
    callback(results);
};
/**
 * For a given item in the data array, return what should be used as the candidate string
 *
 * @param {Object|String} item an item from the data array
 * @return {String} item
 */ $352ad1bb93c26c36$var$Suggestions.prototype.getItemValue = function(item) {
    return item;
};
/**
 * For a given item in the data array, return a string of html that should be rendered in the dropdown
 * @param {Object|String} item an item from the data array
 * @param {String} sourceFormatting a string that has pre-formatted html that should be passed directly through the render function 
 * @return {String} html
 */ $352ad1bb93c26c36$var$Suggestions.prototype.render = function(item, sourceFormatting) {
    if (sourceFormatting) // use existing formatting on the source string
    return sourceFormatting;
    var boldString = item.original ? this.getItemValue(item.original) : this.getItemValue(item);
    var indexString = this.normalize(boldString);
    var indexOfQuery = indexString.lastIndexOf(this.query);
    while(indexOfQuery > -1){
        var endIndexOfQuery = indexOfQuery + this.query.length;
        boldString = boldString.slice(0, indexOfQuery) + '<strong>' + boldString.slice(indexOfQuery, endIndexOfQuery) + '</strong>' + boldString.slice(endIndexOfQuery);
        indexOfQuery = indexString.slice(0, indexOfQuery).lastIndexOf(this.query);
    }
    return boldString;
};
/**
 * Render an custom error message in the suggestions list
 * @param {String} msg An html string to render as an error message
 */ $352ad1bb93c26c36$var$Suggestions.prototype.renderError = function(msg) {
    this.list.drawError(msg);
};
$352ad1bb93c26c36$exports = $352ad1bb93c26c36$var$Suggestions;


$cab0705cde42bc82$exports = $352ad1bb93c26c36$exports;
if (typeof window !== 'undefined') window.Suggestions = $352ad1bb93c26c36$exports;


var $faa88de4f0afd1d0$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $faa88de4f0afd1d0$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $faa88de4f0afd1d0$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $faa88de4f0afd1d0$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $faa88de4f0afd1d0$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $faa88de4f0afd1d0$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $faa88de4f0afd1d0$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $faa88de4f0afd1d0$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $faa88de4f0afd1d0$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $faa88de4f0afd1d0$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $faa88de4f0afd1d0$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $faa88de4f0afd1d0$var$root = $faa88de4f0afd1d0$var$freeGlobal || $faa88de4f0afd1d0$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $faa88de4f0afd1d0$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $faa88de4f0afd1d0$var$objectToString = $faa88de4f0afd1d0$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $faa88de4f0afd1d0$var$nativeMax = Math.max, $faa88de4f0afd1d0$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $faa88de4f0afd1d0$var$now = function() {
    return $faa88de4f0afd1d0$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $faa88de4f0afd1d0$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($faa88de4f0afd1d0$var$FUNC_ERROR_TEXT);
    wait = $faa88de4f0afd1d0$var$toNumber(wait) || 0;
    if ($faa88de4f0afd1d0$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $faa88de4f0afd1d0$var$nativeMax($faa88de4f0afd1d0$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $faa88de4f0afd1d0$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $faa88de4f0afd1d0$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($faa88de4f0afd1d0$var$now());
    }
    function debounced() {
        var time = $faa88de4f0afd1d0$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $faa88de4f0afd1d0$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $faa88de4f0afd1d0$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $faa88de4f0afd1d0$var$isSymbol(value) {
    return typeof value == 'symbol' || $faa88de4f0afd1d0$var$isObjectLike(value) && $faa88de4f0afd1d0$var$objectToString.call(value) == $faa88de4f0afd1d0$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $faa88de4f0afd1d0$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($faa88de4f0afd1d0$var$isSymbol(value)) return $faa88de4f0afd1d0$var$NAN;
    if ($faa88de4f0afd1d0$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $faa88de4f0afd1d0$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($faa88de4f0afd1d0$var$reTrim, '');
    var isBinary = $faa88de4f0afd1d0$var$reIsBinary.test(value);
    return isBinary || $faa88de4f0afd1d0$var$reIsOctal.test(value) ? $faa88de4f0afd1d0$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $faa88de4f0afd1d0$var$reIsBadHex.test(value) ? $faa88de4f0afd1d0$var$NAN : +value;
}
$faa88de4f0afd1d0$exports = $faa88de4f0afd1d0$var$debounce;



var $5440e9199a418654$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $5440e9199a418654$var$R = typeof Reflect === 'object' ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === 'function' ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === 'function') $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
$5440e9199a418654$exports = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}


var $614dc5797fe9f350$require$EventEmitter = $5440e9199a418654$exports.EventEmitter;
var $97c02c95601e1ba1$exports = {};
$97c02c95601e1ba1$exports = {
    'fr': {
        'name': 'France',
        'bbox': [
            [
                -4.59235,
                41.380007
            ],
            [
                9.560016,
                51.148506
            ]
        ]
    },
    'us': {
        'name': 'United States',
        'bbox': [
            [
                -171.791111,
                18.91619
            ],
            [
                -66.96466,
                71.357764
            ]
        ]
    },
    'ru': {
        'name': 'Russia',
        'bbox': [
            [
                19.66064,
                41.151416
            ],
            [
                190.10042,
                81.2504
            ]
        ]
    },
    'ca': {
        'name': 'Canada',
        'bbox': [
            [
                -140.99778,
                41.675105
            ],
            [
                -52.648099,
                83.23324
            ]
        ]
    }
};


var $74e8675559d59e8a$exports = {};
'use strict';
var $640f7206e80fb2b3$exports = {};
'use strict';
var $5e442df381553b47$exports = {};
'use strict';
var $d9beb800dae9e08e$exports = {};
'use strict';
var $1660c887cb976ce0$exports = {};
'use strict';
// Like https://github.com/thlorenz/lib/parse-link-header but without any
// additional dependencies.
function $1660c887cb976ce0$var$parseParam(param) {
    var parts = param.match(/\s*(.+)\s*=\s*"?([^"]+)"?/);
    if (!parts) return null;
    return {
        key: parts[1],
        value: parts[2]
    };
}
function $1660c887cb976ce0$var$parseLink(link) {
    var parts = link.match(/<?([^>]*)>(.*)/);
    if (!parts) return null;
    var linkUrl = parts[1];
    var linkParams = parts[2].split(';');
    var rel = null;
    var parsedLinkParams = linkParams.reduce(function(result, param) {
        var parsed = $1660c887cb976ce0$var$parseParam(param);
        if (!parsed) return result;
        if (parsed.key === 'rel') {
            if (!rel) rel = parsed.value;
            return result;
        }
        result[parsed.key] = parsed.value;
        return result;
    }, {});
    if (!rel) return null;
    return {
        url: linkUrl,
        rel: rel,
        params: parsedLinkParams
    };
}
/**
 * Parse a Link header.
 *
 * @param {string} linkHeader
 * @returns {{
 *   [string]: {
 *     url: string,
 *     params: { [string]: string }
 *   }
 * }}
 */ function $1660c887cb976ce0$var$parseLinkHeader(linkHeader) {
    if (!linkHeader) return {};
    return linkHeader.split(/,\s*</).reduce(function(result, link) {
        var parsed = $1660c887cb976ce0$var$parseLink(link);
        if (!parsed) return result;
        // rel value can be multiple whitespace-separated rels.
        var splitRel = parsed.rel.split(/\s+/);
        splitRel.forEach(function(rel) {
            if (!result[rel]) result[rel] = {
                url: parsed.url,
                params: parsed.params
            };
        });
        return result;
    }, {});
}
$1660c887cb976ce0$exports = $1660c887cb976ce0$var$parseLinkHeader;


/**
 * A Mapbox API response.
 *
 * @class MapiResponse
 * @property {Object} body - The response body, parsed as JSON.
 * @property {string} rawBody - The raw response body.
 * @property {number} statusCode - The response's status code.
 * @property {Object} headers - The parsed response headers.
 * @property {Object} links - The parsed response links.
 * @property {MapiRequest} request - The response's originating `MapiRequest`.
 */ /**
 * @ignore
 * @param {MapiRequest} request
 * @param {Object} responseData
 * @param {Object} responseData.headers
 * @param {string} responseData.body
 * @param {number} responseData.statusCode
 */ function $d9beb800dae9e08e$var$MapiResponse(request, responseData) {
    this.request = request;
    this.headers = responseData.headers;
    this.rawBody = responseData.body;
    this.statusCode = responseData.statusCode;
    try {
        this.body = JSON.parse(responseData.body || '{}');
    } catch (parseError) {
        this.body = responseData.body;
    }
    this.links = $1660c887cb976ce0$exports(this.headers.link);
}
/**
 * Check if there is a next page that you can fetch.
 *
 * @returns {boolean}
 */ $d9beb800dae9e08e$var$MapiResponse.prototype.hasNextPage = function hasNextPage() {
    return !!this.links.next;
};
/**
 * Create a request for the next page, if there is one.
 * If there is no next page, returns `null`.
 *
 * @returns {MapiRequest | null}
 */ $d9beb800dae9e08e$var$MapiResponse.prototype.nextPage = function nextPage() {
    if (!this.hasNextPage()) return null;
    return this.request._extend({
        path: this.links.next.url
    });
};
$d9beb800dae9e08e$exports = $d9beb800dae9e08e$var$MapiResponse;


var $bdb64c092e7d6f84$exports = {};
'use strict';
var $6d406f0b6d4ab5c6$exports = {};
'use strict';
$6d406f0b6d4ab5c6$exports = {
    API_ORIGIN: 'https://api.mapbox.com',
    EVENT_PROGRESS_DOWNLOAD: 'downloadProgress',
    EVENT_PROGRESS_UPLOAD: 'uploadProgress',
    EVENT_ERROR: 'error',
    EVENT_RESPONSE: 'response',
    ERROR_HTTP: 'HttpError',
    ERROR_REQUEST_ABORTED: 'RequestAbortedError'
};


/**
 * A Mapbox API error.
 *
 * If there's an error during the API transaction,
 * the Promise returned by `MapiRequest`'s [`send`](#send)
 * method should reject with a `MapiError`.
 *
 * @class MapiError
 * @hideconstructor
 * @property {MapiRequest} request - The errored request.
 * @property {string} type - The type of error. Usually this is `'HttpError'`.
 *   If the request was aborted, so the error was
 *   not sent from the server, the type will be
 *   `'RequestAbortedError'`.
 * @property {number} [statusCode] - The numeric status code of
 *   the HTTP response.
 * @property {Object | string} [body] - If the server sent a response body,
 *   this property exposes that response, parsed as JSON if possible.
 * @property {string} [message] - Whatever message could be derived from the
 *   call site and HTTP response.
 *
 * @param {MapiRequest} options.request
 * @param {number} [options.statusCode]
 * @param {string} [options.body]
 * @param {string} [options.message]
 * @param {string} [options.type]
 */ function $bdb64c092e7d6f84$var$MapiError(options) {
    var errorType = options.type || $6d406f0b6d4ab5c6$exports.ERROR_HTTP;
    var body;
    if (options.body) try {
        body = JSON.parse(options.body);
    } catch (e) {
        body = options.body;
    }
    else body = null;
    var message = options.message || null;
    if (!message) {
        if (typeof body === 'string') message = body;
        else if (body && typeof body.message === 'string') message = body.message;
        else if (errorType === $6d406f0b6d4ab5c6$exports.ERROR_REQUEST_ABORTED) message = 'Request aborted';
    }
    this.message = message;
    this.type = errorType;
    this.statusCode = options.statusCode || null;
    this.request = options.request;
    this.body = body;
}
$bdb64c092e7d6f84$exports = $bdb64c092e7d6f84$var$MapiError;



var $f9d2bce9e7e6e87b$exports = {};
'use strict';
function $f9d2bce9e7e6e87b$var$parseSingleHeader(raw) {
    var boundary = raw.indexOf(':');
    var name = raw.substring(0, boundary).trim().toLowerCase();
    var value = raw.substring(boundary + 1).trim();
    return {
        name: name,
        value: value
    };
}
/**
 * Parse raw headers into an object with lowercase properties.
 * Does not fully parse headings into more complete data structure,
 * as larger libraries might do. Also does not deal with duplicate
 * headers because Node doesn't seem to deal with those well, so
 * we shouldn't let the browser either, for consistency.
 *
 * @param {string} raw
 * @returns {Object}
 */ function $f9d2bce9e7e6e87b$var$parseHeaders(raw) {
    var headers = {};
    if (!raw) return headers;
    raw.trim().split(/[\r|\n]+/).forEach(function(rawHeader) {
        var parsed = $f9d2bce9e7e6e87b$var$parseSingleHeader(rawHeader);
        headers[parsed.name] = parsed.value;
    });
    return headers;
}
$f9d2bce9e7e6e87b$exports = $f9d2bce9e7e6e87b$var$parseHeaders;


// Keys are request IDs, values are XHRs.
var $5e442df381553b47$var$requestsUnderway = {};
function $5e442df381553b47$var$browserAbort(request) {
    var xhr = $5e442df381553b47$var$requestsUnderway[request.id];
    if (!xhr) return;
    xhr.abort();
    delete $5e442df381553b47$var$requestsUnderway[request.id];
}
function $5e442df381553b47$var$createResponse(request, xhr) {
    return new $d9beb800dae9e08e$exports(request, {
        body: xhr.response,
        headers: $f9d2bce9e7e6e87b$exports(xhr.getAllResponseHeaders()),
        statusCode: xhr.status
    });
}
function $5e442df381553b47$var$normalizeBrowserProgressEvent(event) {
    var total = event.total;
    var transferred = event.loaded;
    var percent = 100 * transferred / total;
    return {
        total: total,
        transferred: transferred,
        percent: percent
    };
}
function $5e442df381553b47$var$sendRequestXhr(request, xhr) {
    return new Promise(function(resolve, reject) {
        xhr.onprogress = function(event) {
            request.emitter.emit($6d406f0b6d4ab5c6$exports.EVENT_PROGRESS_DOWNLOAD, $5e442df381553b47$var$normalizeBrowserProgressEvent(event));
        };
        var file = request.file;
        if (file) xhr.upload.onprogress = function(event) {
            request.emitter.emit($6d406f0b6d4ab5c6$exports.EVENT_PROGRESS_UPLOAD, $5e442df381553b47$var$normalizeBrowserProgressEvent(event));
        };
        xhr.onerror = function(error) {
            reject(error);
        };
        xhr.onabort = function() {
            var mapiError = new $bdb64c092e7d6f84$exports({
                request: request,
                type: $6d406f0b6d4ab5c6$exports.ERROR_REQUEST_ABORTED
            });
            reject(mapiError);
        };
        xhr.onload = function() {
            delete $5e442df381553b47$var$requestsUnderway[request.id];
            if (xhr.status < 200 || xhr.status >= 400) {
                var mapiError = new $bdb64c092e7d6f84$exports({
                    request: request,
                    body: xhr.response,
                    statusCode: xhr.status
                });
                reject(mapiError);
                return;
            }
            resolve(xhr);
        };
        var body = request.body;
        // matching service needs to send a www-form-urlencoded request
        if (typeof body === 'string') xhr.send(body);
        else if (body) xhr.send(JSON.stringify(body));
        else if (file) xhr.send(file);
        else xhr.send();
        $5e442df381553b47$var$requestsUnderway[request.id] = xhr;
    }).then(function(xhr) {
        return $5e442df381553b47$var$createResponse(request, xhr);
    });
}
// The accessToken argument gives this function flexibility
// for Mapbox's internal client.
function $5e442df381553b47$var$createRequestXhr(request, accessToken) {
    var url = request.url(accessToken);
    var xhr = new window.XMLHttpRequest();
    xhr.open(request.method, url);
    Object.keys(request.headers).forEach(function(key) {
        xhr.setRequestHeader(key, request.headers[key]);
    });
    return xhr;
}
function $5e442df381553b47$var$browserSend(request) {
    return Promise.resolve().then(function() {
        var xhr = $5e442df381553b47$var$createRequestXhr(request, request.client.accessToken);
        return $5e442df381553b47$var$sendRequestXhr(request, xhr);
    });
}
$5e442df381553b47$exports = {
    browserAbort: $5e442df381553b47$var$browserAbort,
    sendRequestXhr: $5e442df381553b47$var$sendRequestXhr,
    browserSend: $5e442df381553b47$var$browserSend,
    createRequestXhr: $5e442df381553b47$var$createRequestXhr
};


var $2d1104909202e221$exports = {};
'use strict';
var $24ddf49a9765bd56$exports = {};
'use strict';

var $6u4NZ = parcelRequire("6u4NZ");
var $24ddf49a9765bd56$var$tokenCache = {};
function $24ddf49a9765bd56$var$parseToken(token) {
    if ($24ddf49a9765bd56$var$tokenCache[token]) return $24ddf49a9765bd56$var$tokenCache[token];
    var parts = token.split('.');
    var usage = parts[0];
    var rawPayload = parts[1];
    if (!rawPayload) throw new Error('Invalid token');
    var parsedPayload = $24ddf49a9765bd56$var$parsePaylod(rawPayload);
    var result = {
        usage: usage,
        user: parsedPayload.u
    };
    if ($24ddf49a9765bd56$var$has(parsedPayload, 'a')) result.authorization = parsedPayload.a;
    if ($24ddf49a9765bd56$var$has(parsedPayload, 'exp')) result.expires = parsedPayload.exp * 1000;
    if ($24ddf49a9765bd56$var$has(parsedPayload, 'iat')) result.created = parsedPayload.iat * 1000;
    if ($24ddf49a9765bd56$var$has(parsedPayload, 'scopes')) result.scopes = parsedPayload.scopes;
    if ($24ddf49a9765bd56$var$has(parsedPayload, 'client')) result.client = parsedPayload.client;
    if ($24ddf49a9765bd56$var$has(parsedPayload, 'll')) result.lastLogin = parsedPayload.ll;
    if ($24ddf49a9765bd56$var$has(parsedPayload, 'iu')) result.impersonator = parsedPayload.iu;
    $24ddf49a9765bd56$var$tokenCache[token] = result;
    return result;
}
function $24ddf49a9765bd56$var$parsePaylod(rawPayload) {
    try {
        return JSON.parse($6u4NZ.decode(rawPayload));
    } catch (parseError) {
        throw new Error('Invalid token');
    }
}
function $24ddf49a9765bd56$var$has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
$24ddf49a9765bd56$exports = $24ddf49a9765bd56$var$parseToken;


var $3b665dee5f80676e$exports = {};
'use strict';


var $28edd11f6c7e9f5f$exports = {};
'use strict';
var $28edd11f6c7e9f5f$var$has = Object.prototype.hasOwnProperty, $28edd11f6c7e9f5f$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $28edd11f6c7e9f5f$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $28edd11f6c7e9f5f$var$Events().__proto__) $28edd11f6c7e9f5f$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $28edd11f6c7e9f5f$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $28edd11f6c7e9f5f$var$EE(fn, context || emitter, once), evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $28edd11f6c7e9f5f$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $28edd11f6c7e9f5f$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $28edd11f6c7e9f5f$var$EventEmitter() {
    this._events = new $28edd11f6c7e9f5f$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($28edd11f6c7e9f5f$var$has.call(events, name)) names.push($28edd11f6c7e9f5f$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $28edd11f6c7e9f5f$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
        if (this._events[evt]) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        this._events = new $28edd11f6c7e9f5f$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$28edd11f6c7e9f5f$var$EventEmitter.prototype.off = $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener;
$28edd11f6c7e9f5f$var$EventEmitter.prototype.addListener = $28edd11f6c7e9f5f$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$28edd11f6c7e9f5f$var$EventEmitter.prefixed = $28edd11f6c7e9f5f$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$28edd11f6c7e9f5f$var$EventEmitter.EventEmitter = $28edd11f6c7e9f5f$var$EventEmitter;
$28edd11f6c7e9f5f$exports = $28edd11f6c7e9f5f$var$EventEmitter;


var $e15690d93ac8c4b1$exports = {};
'use strict';
// Encode each item of an array individually. The comma
// delimiters should not themselves be encoded.
function $e15690d93ac8c4b1$var$encodeArray(arrayValue) {
    return arrayValue.map(encodeURIComponent).join(',');
}
function $e15690d93ac8c4b1$var$encodeValue(value) {
    if (Array.isArray(value)) return $e15690d93ac8c4b1$var$encodeArray(value);
    return encodeURIComponent(String(value));
}
/**
 * Append a query parameter to a URL.
 *
 * @param {string} url
 * @param {string} key
 * @param {string|number|boolean|Array<*>>} [value] - Provide an array
 *   if the value is a list and commas between values need to be
 *   preserved, unencoded.
 * @returns {string} - Modified URL.
 */ function $e15690d93ac8c4b1$var$appendQueryParam(url, key, value) {
    if (value === false || value === null) return url;
    var punctuation = /\?/.test(url) ? '&' : '?';
    var query = encodeURIComponent(key);
    if (value !== undefined && value !== '' && value !== true) query += '=' + $e15690d93ac8c4b1$var$encodeValue(value);
    return '' + url + punctuation + query;
}
/**
 * Derive a query string from an object and append it
 * to a URL.
 *
 * @param {string} url
 * @param {Object} [queryObject] - Values should be primitives.
 * @returns {string} - Modified URL.
 */ function $e15690d93ac8c4b1$var$appendQueryObject(url, queryObject) {
    if (!queryObject) return url;
    var result = url;
    Object.keys(queryObject).forEach(function(key) {
        var value = queryObject[key];
        if (value === undefined) return;
        if (Array.isArray(value)) value = value.filter(function(v) {
            return v !== null && v !== undefined;
        }).join(',');
        result = $e15690d93ac8c4b1$var$appendQueryParam(result, key, value);
    });
    return result;
}
/**
 * Prepend an origin to a URL. If the URL already has an
 * origin, do nothing.
 *
 * @param {string} url
 * @param {string} origin
 * @returns {string} - Modified URL.
 */ function $e15690d93ac8c4b1$var$prependOrigin(url, origin) {
    if (!origin) return url;
    if (url.slice(0, 4) === 'http') return url;
    var delimiter = url[0] === '/' ? '' : '/';
    return '' + origin.replace(/\/$/, '') + delimiter + url;
}
/**
 * Interpolate values into a route with express-style,
 * colon-prefixed route parameters.
 *
 * @param {string} route
 * @param {Object} [params] - Values should be primitives
 *   or arrays of primitives. Provide an array if the value
 *   is a list and commas between values need to be
 *   preserved, unencoded.
 * @returns {string} - Modified URL.
 */ function $e15690d93ac8c4b1$var$interpolateRouteParams(route, params) {
    if (!params) return route;
    return route.replace(/\/:([a-zA-Z0-9]+)/g, function(_, paramId) {
        var value = params[paramId];
        if (value === undefined) throw new Error('Unspecified route parameter ' + paramId);
        var preppedValue = $e15690d93ac8c4b1$var$encodeValue(value);
        return '/' + preppedValue;
    });
}
$e15690d93ac8c4b1$exports = {
    appendQueryObject: $e15690d93ac8c4b1$var$appendQueryObject,
    appendQueryParam: $e15690d93ac8c4b1$var$appendQueryParam,
    prependOrigin: $e15690d93ac8c4b1$var$prependOrigin,
    interpolateRouteParams: $e15690d93ac8c4b1$var$interpolateRouteParams
};



var $3b665dee5f80676e$var$requestId = 1;
/**
 * A Mapbox API request.
 *
 * Note that creating a `MapiRequest` does *not* send the request automatically.
 * Use the request's `send` method to send it off and get a `Promise`.
 *
 * The `emitter` property is an `EventEmitter` that emits the following events:
 *
 * - `'response'` - Listeners will be called with a `MapiResponse`.
 * - `'error'` - Listeners will be called with a `MapiError`.
 * - `'downloadProgress'` - Listeners will be called with `ProgressEvents`.
 * - `'uploadProgress'` - Listeners will be called with `ProgressEvents`.
 *   Upload events are only available when the request includes a file.
 *
 * @class MapiRequest
 * @property {EventEmitter} emitter - An event emitter. See above.
 * @property {MapiClient} client - This request's `MapiClient`.
 * @property {MapiResponse|null} response - If this request has been sent and received
 *   a response, the response is available on this property.
 * @property {MapiError|Error|null} error - If this request has been sent and
 *   received an error in response, the error is available on this property.
 * @property {boolean} aborted - If the request has been aborted
 *   (via [`abort`](#abort)), this property will be `true`.
 * @property {boolean} sent - If the request has been sent, this property will
 *   be `true`. You cannot send the same request twice, so if you need to create
 *   a new request that is the equivalent of an existing one, use
 *   [`clone`](#clone).
 * @property {string} path - The request's path, including colon-prefixed route
 *   parameters.
 * @property {string} origin - The request's origin.
 * @property {string} method - The request's HTTP method.
 * @property {Object} query - A query object, which will be transformed into
 *   a URL query string.
 * @property {Object} params - A route parameters object, whose values will
 *   be interpolated the path.
 * @property {Object} headers - The request's headers.
 * @property {Object|string|null} body - Data to send with the request.
 *   If the request has a body, it will also be sent with the header
 *   `'Content-Type: application/json'`.
 * @property {Blob|ArrayBuffer|string|ReadStream} file - A file to
 *   send with the request. The browser client accepts Blobs and ArrayBuffers;
 *   the Node client accepts strings (filepaths) and ReadStreams.
 * @property {string} encoding - The encoding of the response.
 * @property {string} sendFileAs - The method to send the `file`. Options are
 *   `data` (x-www-form-urlencoded) or `form` (multipart/form-data).
 */ /**
 * @ignore
 * @param {MapiClient} client
 * @param {Object} options
 * @param {string} options.method
 * @param {string} options.path
 * @param {Object} [options.query={}]
 * @param {Object} [options.params={}]
 * @param {string} [options.origin]
 * @param {Object} [options.headers]
 * @param {Object} [options.body=null]
 * @param {Blob|ArrayBuffer|string|ReadStream} [options.file=null]
 * @param {string} [options.encoding=utf8]
 */ function $3b665dee5f80676e$var$MapiRequest(client, options) {
    if (!client) throw new Error('MapiRequest requires a client');
    if (!options || !options.path || !options.method) throw new Error('MapiRequest requires an options object with path and method properties');
    var defaultHeaders = {};
    if (options.body) defaultHeaders['content-type'] = 'application/json';
    var headersWithDefaults = $c61292941889f8f2$exports(defaultHeaders, options.headers);
    // Disallows duplicate header names of mixed case,
    // e.g. Content-Type and content-type.
    var headers = Object.keys(headersWithDefaults).reduce(function(memo, name) {
        memo[name.toLowerCase()] = headersWithDefaults[name];
        return memo;
    }, {});
    this.id = $3b665dee5f80676e$var$requestId++;
    this._options = options;
    this.emitter = new $28edd11f6c7e9f5f$exports();
    this.client = client;
    this.response = null;
    this.error = null;
    this.sent = false;
    this.aborted = false;
    this.path = options.path;
    this.method = options.method;
    this.origin = options.origin || client.origin;
    this.query = options.query || {};
    this.params = options.params || {};
    this.body = options.body || null;
    this.file = options.file || null;
    this.encoding = options.encoding || 'utf8';
    this.sendFileAs = options.sendFileAs || null;
    this.headers = headers;
}
/**
 * Get the URL of the request.
 *
 * @param {string} [accessToken] - By default, the access token of the request's
 *   client is used.
 * @return {string}
 */ $3b665dee5f80676e$var$MapiRequest.prototype.url = function url(accessToken) {
    var url = $e15690d93ac8c4b1$exports.prependOrigin(this.path, this.origin);
    url = $e15690d93ac8c4b1$exports.appendQueryObject(url, this.query);
    var routeParams = this.params;
    var actualAccessToken = accessToken == null ? this.client.accessToken : accessToken;
    if (actualAccessToken) {
        url = $e15690d93ac8c4b1$exports.appendQueryParam(url, 'access_token', actualAccessToken);
        var accessTokenOwnerId = $24ddf49a9765bd56$exports(actualAccessToken).user;
        routeParams = $c61292941889f8f2$exports({
            ownerId: accessTokenOwnerId
        }, routeParams);
    }
    url = $e15690d93ac8c4b1$exports.interpolateRouteParams(url, routeParams);
    return url;
};
/**
 * Send the request. Returns a Promise that resolves with a `MapiResponse`.
 * You probably want to use `response.body`.
 *
 * `send` only retrieves the first page of paginated results. You can get
 * the next page by using the `MapiResponse`'s [`nextPage`](#nextpage)
 * function, or iterate through all pages using [`eachPage`](#eachpage)
 * instead of `send`.
 *
 * @returns {Promise<MapiResponse>}
 */ $3b665dee5f80676e$var$MapiRequest.prototype.send = function send() {
    var self = this;
    if (self.sent) throw new Error('This request has already been sent. Check the response and error properties. Create a new request with clone().');
    self.sent = true;
    return self.client.sendRequest(self).then(function(response) {
        self.response = response;
        self.emitter.emit($6d406f0b6d4ab5c6$exports.EVENT_RESPONSE, response);
        return response;
    }, function(error) {
        self.error = error;
        self.emitter.emit($6d406f0b6d4ab5c6$exports.EVENT_ERROR, error);
        throw error;
    });
};
/**
 * Abort the request.
 *
 * Any pending `Promise` returned by [`send`](#send) will be rejected with
 * an error with `type: 'RequestAbortedError'`. If you've created a request
 * that might be aborted, you need to catch and handle such errors.
 *
 * This method will also abort any requests created while fetching subsequent
 * pages via [`eachPage`](#eachpage).
 *
 * If the request has not been sent or has already been aborted, nothing
 * will happen.
 */ $3b665dee5f80676e$var$MapiRequest.prototype.abort = function abort() {
    if (this._nextPageRequest) {
        this._nextPageRequest.abort();
        delete this._nextPageRequest;
    }
    if (this.response || this.error || this.aborted) return;
    this.aborted = true;
    this.client.abortRequest(this);
};
/**
 * Invoke a callback for each page of a paginated API response.
 *
 * The callback should have the following signature:
 *
 * ```js
 * (
 *   error: MapiError,
 *   response: MapiResponse,
 *   next: () => void
 * ) => void
 * ```
 *
 * **The next page will not be fetched until you've invoked the
 * `next` callback**, indicating that you're ready for it.
 *
 * @param {Function} callback
 */ $3b665dee5f80676e$var$MapiRequest.prototype.eachPage = function eachPage(callback) {
    var self = this;
    function handleResponse(response) {
        function getNextPage() {
            delete self._nextPageRequest;
            var nextPageRequest = response.nextPage();
            if (nextPageRequest) {
                self._nextPageRequest = nextPageRequest;
                getPage(nextPageRequest);
            }
        }
        callback(null, response, getNextPage);
    }
    function handleError(error) {
        callback(error, null, function() {});
    }
    function getPage(request) {
        request.send().then(handleResponse, handleError);
    }
    getPage(this);
};
/**
 * Clone this request.
 *
 * Each request can only be sent *once*. So if you'd like to send the
 * same request again, clone it and send away.
 *
 * @returns {MapiRequest} - A new `MapiRequest` configured just like this one.
 */ $3b665dee5f80676e$var$MapiRequest.prototype.clone = function clone() {
    return this._extend();
};
/**
 * @ignore
 */ $3b665dee5f80676e$var$MapiRequest.prototype._extend = function _extend(options) {
    var extendedOptions = $c61292941889f8f2$exports(this._options, options);
    return new $3b665dee5f80676e$var$MapiRequest(this.client, extendedOptions);
};
$3b665dee5f80676e$exports = $3b665dee5f80676e$var$MapiRequest;



/**
 * A low-level Mapbox API client. Use it to create service clients
 * that share the same configuration.
 *
 * Services and `MapiRequest`s use the underlying `MapiClient` to
 * determine how to create, send, and abort requests in a way
 * that is appropriate to the configuration and environment
 * (Node or the browser).
 *
 * @class MapiClient
 * @property {string} accessToken - The Mapbox access token assigned
 *   to this client.
 * @property {string} [origin] - The origin
 *   to use for API requests. Defaults to https://api.mapbox.com.
 */ function $2d1104909202e221$var$MapiClient(options) {
    if (!options || !options.accessToken) throw new Error('Cannot create a client without an access token');
    // Try parsing the access token to determine right away if it's valid.
    $24ddf49a9765bd56$exports(options.accessToken);
    this.accessToken = options.accessToken;
    this.origin = options.origin || $6d406f0b6d4ab5c6$exports.API_ORIGIN;
}
$2d1104909202e221$var$MapiClient.prototype.createRequest = function createRequest(requestOptions) {
    return new $3b665dee5f80676e$exports(this, requestOptions);
};
$2d1104909202e221$exports = $2d1104909202e221$var$MapiClient;


function $640f7206e80fb2b3$var$BrowserClient(options) {
    $2d1104909202e221$exports.call(this, options);
}
$640f7206e80fb2b3$var$BrowserClient.prototype = Object.create($2d1104909202e221$exports.prototype);
$640f7206e80fb2b3$var$BrowserClient.prototype.constructor = $640f7206e80fb2b3$var$BrowserClient;
$640f7206e80fb2b3$var$BrowserClient.prototype.sendRequest = $5e442df381553b47$exports.browserSend;
$640f7206e80fb2b3$var$BrowserClient.prototype.abortRequest = $5e442df381553b47$exports.browserAbort;
/**
 * Create a client for the browser.
 *
 * @param {Object} options
 * @param {string} options.accessToken
 * @param {string} [options.origin]
 * @returns {MapiClient}
 */ function $640f7206e80fb2b3$var$createBrowserClient(options) {
    return new $640f7206e80fb2b3$var$BrowserClient(options);
}
$640f7206e80fb2b3$exports = $640f7206e80fb2b3$var$createBrowserClient;


$74e8675559d59e8a$exports = $640f7206e80fb2b3$exports;


var $d4053cad85b8db5c$exports = {};
'use strict';

var $6526756303cd3910$exports = {};
'use strict';

var $60bbbefa9c1fc7b6$exports = {};
'use strict';
var $fd11a02fceb57d58$exports = {};
'use strict';
var $fd11a02fceb57d58$var$toString = Object.prototype.toString;
$fd11a02fceb57d58$exports = function(x) {
    var prototype;
    return $fd11a02fceb57d58$var$toString.call(x) === '[object Object]' && (prototype = Object.getPrototypeOf(x), prototype === null || prototype === Object.getPrototypeOf({}));
};



var $60bbbefa9c1fc7b6$var$DEFAULT_ERROR_PATH = 'value';
var $60bbbefa9c1fc7b6$var$NEWLINE_INDENT = '\n  ';
var $60bbbefa9c1fc7b6$var$v = {};
/**
 * Runners
 *
 * Take root validators and run assertion
 */ $60bbbefa9c1fc7b6$var$v.assert = function(rootValidator, options) {
    options = options || {};
    return function(value) {
        var message = $60bbbefa9c1fc7b6$var$validate(rootValidator, value);
        // all good
        if (!message) return;
        var errorMessage = $60bbbefa9c1fc7b6$var$processMessage(message, options);
        if (options.apiName) errorMessage = options.apiName + ': ' + errorMessage;
        throw new Error(errorMessage);
    };
};
/**
 * Higher Order Validators
 *
 * validators which take other validators as input
 * and output a new validator
 */ $60bbbefa9c1fc7b6$var$v.shape = function shape(validatorObj) {
    var validators = $60bbbefa9c1fc7b6$var$objectEntries(validatorObj);
    return function shapeValidator(value) {
        var validationResult = $60bbbefa9c1fc7b6$var$validate($60bbbefa9c1fc7b6$var$v.plainObject, value);
        if (validationResult) return validationResult;
        var key, validator;
        var errorMessages = [];
        for(var i = 0; i < validators.length; i++){
            key = validators[i].key;
            validator = validators[i].value;
            validationResult = $60bbbefa9c1fc7b6$var$validate(validator, value[key]);
            if (validationResult) // return [key].concat(validationResult);
            errorMessages.push([
                key
            ].concat(validationResult));
        }
        if (errorMessages.length < 2) return errorMessages[0];
        // enumerate all the error messages
        return function(options) {
            errorMessages = errorMessages.map(function(message) {
                var key = message[0];
                var renderedMessage = $60bbbefa9c1fc7b6$var$processMessage(message, options).split('\n').join($60bbbefa9c1fc7b6$var$NEWLINE_INDENT); // indents any inner nesting
                return '- ' + key + ': ' + renderedMessage;
            });
            var objectId = options.path.join('.');
            var ofPhrase = objectId === $60bbbefa9c1fc7b6$var$DEFAULT_ERROR_PATH ? '' : ' of ' + objectId;
            return 'The following properties' + ofPhrase + ' have invalid values:' + $60bbbefa9c1fc7b6$var$NEWLINE_INDENT + errorMessages.join($60bbbefa9c1fc7b6$var$NEWLINE_INDENT);
        };
    };
};
$60bbbefa9c1fc7b6$var$v.strictShape = function strictShape(validatorObj) {
    var shapeValidator = $60bbbefa9c1fc7b6$var$v.shape(validatorObj);
    return function strictShapeValidator(value) {
        var shapeResult = shapeValidator(value);
        if (shapeResult) return shapeResult;
        var invalidKeys = Object.keys(value).reduce(function(memo, valueKey) {
            if (validatorObj[valueKey] === undefined) memo.push(valueKey);
            return memo;
        }, []);
        if (invalidKeys.length !== 0) return function() {
            return 'The following keys are invalid: ' + invalidKeys.join(', ');
        };
    };
};
$60bbbefa9c1fc7b6$var$v.arrayOf = function arrayOf(validator) {
    return $60bbbefa9c1fc7b6$var$createArrayValidator(validator);
};
$60bbbefa9c1fc7b6$var$v.tuple = function tuple() {
    var validators = Array.isArray(arguments[0]) ? arguments[0] : Array.prototype.slice.call(arguments);
    return $60bbbefa9c1fc7b6$var$createArrayValidator(validators);
};
// Currently array validation fails when the first invalid item is found.
function $60bbbefa9c1fc7b6$var$createArrayValidator(validators) {
    var validatingTuple = Array.isArray(validators);
    var getValidator = function(index) {
        if (validatingTuple) return validators[index];
        return validators;
    };
    return function arrayValidator(value) {
        var validationResult = $60bbbefa9c1fc7b6$var$validate($60bbbefa9c1fc7b6$var$v.plainArray, value);
        if (validationResult) return validationResult;
        if (validatingTuple && value.length !== validators.length) return 'an array with ' + validators.length + ' items';
        for(var i = 0; i < value.length; i++){
            validationResult = $60bbbefa9c1fc7b6$var$validate(getValidator(i), value[i]);
            if (validationResult) return [
                i
            ].concat(validationResult);
        }
    };
}
$60bbbefa9c1fc7b6$var$v.required = function required(validator) {
    function requiredValidator(value) {
        if (value == null) return function(options) {
            return $60bbbefa9c1fc7b6$var$formatErrorMessage(options, $60bbbefa9c1fc7b6$var$isArrayCulprit(options.path) ? 'cannot be undefined/null.' : 'is required.');
        };
        return validator.apply(this, arguments);
    }
    requiredValidator.__required = true;
    return requiredValidator;
};
$60bbbefa9c1fc7b6$var$v.oneOfType = function oneOfType() {
    var validators = Array.isArray(arguments[0]) ? arguments[0] : Array.prototype.slice.call(arguments);
    return function oneOfTypeValidator(value) {
        var messages = validators.map(function(validator) {
            return $60bbbefa9c1fc7b6$var$validate(validator, value);
        }).filter(Boolean);
        // If we don't have as many messages as no. of validators,
        // then at least one validator was ok with the value.
        if (messages.length !== validators.length) return;
        // check primitive type
        if (messages.every(function(message) {
            return message.length === 1 && typeof message[0] === 'string';
        })) return $60bbbefa9c1fc7b6$var$orList(messages.map(function(m) {
            return m[0];
        }));
        // Complex oneOfTypes like
        // `v.oneOftypes(v.shape({name: v.string})`, `v.shape({name: v.number}))`
        // are complex ¯\_(ツ)_/¯. For the current scope only returning the longest message.
        return messages.reduce(function(max, arr) {
            return arr.length > max.length ? arr : max;
        });
    };
};
/**
 * Meta Validators
 * which take options as argument (not validators)
 * and return a new primitive validator
 */ $60bbbefa9c1fc7b6$var$v.equal = function equal(compareWith) {
    return function equalValidator(value) {
        if (value !== compareWith) return JSON.stringify(compareWith);
    };
};
$60bbbefa9c1fc7b6$var$v.oneOf = function oneOf() {
    var options = Array.isArray(arguments[0]) ? arguments[0] : Array.prototype.slice.call(arguments);
    var validators = options.map(function(value) {
        return $60bbbefa9c1fc7b6$var$v.equal(value);
    });
    return $60bbbefa9c1fc7b6$var$v.oneOfType.apply(this, validators);
};
$60bbbefa9c1fc7b6$var$v.range = function range(compareWith) {
    var min = compareWith[0];
    var max = compareWith[1];
    return function rangeValidator(value) {
        var validationResult = $60bbbefa9c1fc7b6$var$validate($60bbbefa9c1fc7b6$var$v.number, value);
        if (validationResult || value < min || value > max) return 'number between ' + min + ' & ' + max + ' (inclusive)';
    };
};
/**
 * Primitive validators
 *
 * simple validators which return a string or undefined
 */ $60bbbefa9c1fc7b6$var$v.any = function any() {
    return;
};
$60bbbefa9c1fc7b6$var$v.boolean = function boolean(value) {
    if (typeof value !== 'boolean') return 'boolean';
};
$60bbbefa9c1fc7b6$var$v.number = function number(value) {
    if (typeof value !== 'number') return 'number';
};
$60bbbefa9c1fc7b6$var$v.plainArray = function plainArray(value) {
    if (!Array.isArray(value)) return 'array';
};
$60bbbefa9c1fc7b6$var$v.plainObject = function plainObject(value) {
    if (!$fd11a02fceb57d58$exports(value)) return 'object';
};
$60bbbefa9c1fc7b6$var$v.string = function string(value) {
    if (typeof value !== 'string') return 'string';
};
$60bbbefa9c1fc7b6$var$v.func = function func(value) {
    if (typeof value !== 'function') return 'function';
};
function $60bbbefa9c1fc7b6$var$validate(validator, value) {
    // assertions are optional by default unless wrapped in v.require
    if (value == null && !validator.hasOwnProperty('__required')) return;
    var result = validator(value);
    if (result) return Array.isArray(result) ? result : [
        result
    ];
}
function $60bbbefa9c1fc7b6$var$processMessage(message, options) {
    // message array follows the convention
    // [...path, result]
    // path is an array of object keys / array indices
    // result is output of the validator
    var len = message.length;
    var result = message[len - 1];
    var path = message.slice(0, len - 1);
    if (path.length === 0) path = [
        $60bbbefa9c1fc7b6$var$DEFAULT_ERROR_PATH
    ];
    options = $c61292941889f8f2$exports(options, {
        path: path
    });
    return typeof result === 'function' ? result(options) // allows customization of result
     : $60bbbefa9c1fc7b6$var$formatErrorMessage(options, $60bbbefa9c1fc7b6$var$prettifyResult(result));
}
function $60bbbefa9c1fc7b6$var$orList(list) {
    if (list.length < 2) return list[0];
    if (list.length === 2) return list.join(' or ');
    return list.slice(0, -1).join(', ') + ', or ' + list.slice(-1);
}
function $60bbbefa9c1fc7b6$var$prettifyResult(result) {
    return 'must be ' + $60bbbefa9c1fc7b6$var$addArticle(result) + '.';
}
function $60bbbefa9c1fc7b6$var$addArticle(nounPhrase) {
    if (/^an? /.test(nounPhrase)) return nounPhrase;
    if (/^[aeiou]/i.test(nounPhrase)) return 'an ' + nounPhrase;
    if (/^[a-z]/i.test(nounPhrase)) return 'a ' + nounPhrase;
    return nounPhrase;
}
function $60bbbefa9c1fc7b6$var$formatErrorMessage(options, prettyResult) {
    var arrayCulprit = $60bbbefa9c1fc7b6$var$isArrayCulprit(options.path);
    var output = options.path.join('.') + ' ' + prettyResult;
    var prepend = arrayCulprit ? 'Item at position ' : '';
    return prepend + output;
}
function $60bbbefa9c1fc7b6$var$isArrayCulprit(path) {
    return typeof path[path.length - 1] == 'number' || typeof path[0] == 'number';
}
function $60bbbefa9c1fc7b6$var$objectEntries(obj) {
    return Object.keys(obj || {}).map(function(key) {
        return {
            key: key,
            value: obj[key]
        };
    });
}
$60bbbefa9c1fc7b6$var$v.validate = $60bbbefa9c1fc7b6$var$validate;
$60bbbefa9c1fc7b6$var$v.processMessage = $60bbbefa9c1fc7b6$var$processMessage;
$60bbbefa9c1fc7b6$exports = $60bbbefa9c1fc7b6$var$v;


function $6526756303cd3910$var$file(value) {
    // If we're in a browser so Blob is available, the file must be that.
    // In Node, however, it could be a filepath or a pipeable (Readable) stream.
    if (typeof window !== 'undefined') {
        if (value instanceof $parcel$global.Blob || value instanceof $parcel$global.ArrayBuffer) return;
        return 'Blob or ArrayBuffer';
    }
    if (typeof value === 'string' || value.pipe !== undefined) return;
    return 'Filename or Readable stream';
}
function $6526756303cd3910$var$assertShape(validatorObj, apiName) {
    return $60bbbefa9c1fc7b6$exports.assert($60bbbefa9c1fc7b6$exports.strictShape(validatorObj), apiName);
}
function $6526756303cd3910$var$date(value) {
    var msg = 'date';
    if (typeof value === 'boolean') return msg;
    try {
        var date = new Date(value);
        if (date.getTime && isNaN(date.getTime())) return msg;
    } catch (e) {
        return msg;
    }
}
function $6526756303cd3910$var$coordinates(value) {
    return $60bbbefa9c1fc7b6$exports.tuple($60bbbefa9c1fc7b6$exports.number, $60bbbefa9c1fc7b6$exports.number)(value);
}
$6526756303cd3910$exports = $c61292941889f8f2$exports($60bbbefa9c1fc7b6$exports, {
    file: $6526756303cd3910$var$file,
    date: $6526756303cd3910$var$date,
    coordinates: $6526756303cd3910$var$coordinates,
    assertShape: $6526756303cd3910$var$assertShape
});


var $702e71365018f71e$exports = {};
'use strict';
/**
 * Create a new object by picking properties off an existing object.
 * The second param can be overloaded as a callback for
 * more fine grained picking of properties.
 * @param {Object} source
 * @param {Array<string>|function(string, Object):boolean} keys
 * @returns {Object}
 */ function $702e71365018f71e$var$pick(source, keys) {
    var filter = function(key, val) {
        return keys.indexOf(key) !== -1 && val !== undefined;
    };
    if (typeof keys === 'function') filter = keys;
    return Object.keys(source).filter(function(key) {
        return filter(key, source[key]);
    }).reduce(function(result, key) {
        result[key] = source[key];
        return result;
    }, {});
}
$702e71365018f71e$exports = $702e71365018f71e$var$pick;


var $33c7e469dec84260$exports = {};
'use strict';
var $148fd71246ebcb3d$exports = {};
'use strict';
function $148fd71246ebcb3d$var$objectMap(obj, cb) {
    return Object.keys(obj).reduce(function(result, key) {
        result[key] = cb(key, obj[key]);
        return result;
    }, {});
}
$148fd71246ebcb3d$exports = $148fd71246ebcb3d$var$objectMap;


/**
 * Stringify all the boolean values in an object, so true becomes "true".
 *
 * @param {Object} obj
 * @returns {Object}
 */ function $33c7e469dec84260$var$stringifyBoolean(obj) {
    return $148fd71246ebcb3d$exports(obj, function(_, value) {
        return typeof value === 'boolean' ? JSON.stringify(value) : value;
    });
}
$33c7e469dec84260$exports = $33c7e469dec84260$var$stringifyBoolean;


var $f16dd55c0fa9b91d$exports = {};
'use strict';


function $f16dd55c0fa9b91d$var$createServiceFactory(ServicePrototype) {
    return function(clientOrConfig) {
        var client;
        if ($2d1104909202e221$exports.prototype.isPrototypeOf(clientOrConfig)) client = clientOrConfig;
        else client = $640f7206e80fb2b3$exports(clientOrConfig);
        var service = Object.create(ServicePrototype);
        service.client = client;
        return service;
    };
}
$f16dd55c0fa9b91d$exports = $f16dd55c0fa9b91d$var$createServiceFactory;


/**
 * Geocoding API service.
 *
 * Learn more about this service and its responses in
 * [the HTTP service documentation](https://docs.mapbox.com/api/search/#geocoding).
 */ var $d4053cad85b8db5c$var$Geocoding = {};
var $d4053cad85b8db5c$var$featureTypes = [
    'country',
    'region',
    'postcode',
    'district',
    'place',
    'locality',
    'neighborhood',
    'address',
    'poi',
    'poi.landmark'
];
/**
 * Search for a place.
 *
 * See the [public documentation](https://docs.mapbox.com/api/search/#forward-geocoding).
 *
 * @param {Object} config
 * @param {string} config.query - A place name.
 * @param {'mapbox.places'|'mapbox.places-permanent'} [config.mode="mapbox.places"] - Either `mapbox.places` for ephemeral geocoding, or `mapbox.places-permanent` for storing results and batch geocoding.
 * @param {Array<string>} [config.countries] - Limits results to the specified countries.
 *   Each item in the array should be an [ISO 3166 alpha 2 country code](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2).
 * @param {Coordinates|'ip'} [config.proximity] - Bias local results based on a provided coordinate location or a user's IP address.
 * @param {Array<'country'|'region'|'postcode'|'district'|'place'|'locality'|'neighborhood'|'address'|'poi'|'poi.landmark'>} [config.types] - Filter results by feature types.
 * @param {boolean} [config.autocomplete=true] - Return autocomplete results or not.
 * @param {BoundingBox} [config.bbox] - Limit results to a bounding box.
 * @param {number} [config.limit=5] - Limit the number of results returned.
 * @param {Array<string>} [config.language] - Specify the language to use for response text and, for forward geocoding, query result weighting.
 *  Options are [IETF language tags](https://en.wikipedia.org/wiki/IETF_language_tag) comprised of a mandatory
 *  [ISO 639-1 language code](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) and optionally one or more IETF subtags for country or script.
 * @param {boolean} [config.routing=false] - Specify whether to request additional metadata about the recommended navigation destination. Only applicable for address features.
 * @param {boolean} [config.fuzzyMatch=true] - Specify whether the Geocoding API should attempt approximate, as well as exact, matching.
 * @param {String} [config.worldview="us"] - Filter results to geographic features whose characteristics are defined differently by audiences belonging to various regional, cultural, or political groups.
 * @param {String} [config.session_token] - A unique session identifier generated by the client.
 * @return {MapiRequest}
 *
 * @example
 * geocodingClient.forwardGeocode({
 *   query: 'Paris, France',
 *   limit: 2
 * })
 *   .send()
 *   .then(response => {
 *     const match = response.body;
 *   });
 *
 * @example
 * // geocoding with proximity
 * geocodingClient.forwardGeocode({
 *   query: 'Paris, France',
 *   proximity: [-95.4431142, 33.6875431]
 * })
 *   .send()
 *   .then(response => {
 *     const match = response.body;
 *   });
 *
 * // geocoding with countries
 * geocodingClient.forwardGeocode({
 *   query: 'Paris, France',
 *   countries: ['fr']
 * })
 *   .send()
 *   .then(response => {
 *     const match = response.body;
 *   });
 *
 * // geocoding with bounding box
 * geocodingClient.forwardGeocode({
 *   query: 'Paris, France',
 *   bbox: [2.14, 48.72, 2.55, 48.96]
 * })
 *   .send()
 *   .then(response => {
 *     const match = response.body;
 *   });
 */ $d4053cad85b8db5c$var$Geocoding.forwardGeocode = function(config) {
    $6526756303cd3910$exports.assertShape({
        query: $6526756303cd3910$exports.required($6526756303cd3910$exports.string),
        mode: $6526756303cd3910$exports.oneOf('mapbox.places', 'mapbox.places-permanent'),
        countries: $6526756303cd3910$exports.arrayOf($6526756303cd3910$exports.string),
        proximity: $6526756303cd3910$exports.oneOf($6526756303cd3910$exports.coordinates, 'ip'),
        types: $6526756303cd3910$exports.arrayOf($6526756303cd3910$exports.oneOf($d4053cad85b8db5c$var$featureTypes)),
        autocomplete: $6526756303cd3910$exports.boolean,
        bbox: $6526756303cd3910$exports.arrayOf($6526756303cd3910$exports.number),
        limit: $6526756303cd3910$exports.number,
        language: $6526756303cd3910$exports.arrayOf($6526756303cd3910$exports.string),
        routing: $6526756303cd3910$exports.boolean,
        fuzzyMatch: $6526756303cd3910$exports.boolean,
        worldview: $6526756303cd3910$exports.string,
        session_token: $6526756303cd3910$exports.string
    })(config);
    config.mode = config.mode || 'mapbox.places';
    var query = $33c7e469dec84260$exports($c61292941889f8f2$exports({
        country: config.countries
    }, $702e71365018f71e$exports(config, [
        'proximity',
        'types',
        'autocomplete',
        'bbox',
        'limit',
        'language',
        'routing',
        'fuzzyMatch',
        'worldview',
        'session_token'
    ])));
    return this.client.createRequest({
        method: 'GET',
        path: '/geocoding/v5/:mode/:query.json',
        params: $702e71365018f71e$exports(config, [
            'mode',
            'query'
        ]),
        query: query
    });
};
/**
 * Search for places near coordinates.
 *
 * See the [public documentation](https://docs.mapbox.com/api/search/#reverse-geocoding).
 *
 * @param {Object} config
 * @param {Coordinates} config.query - Coordinates at which features will be searched.
 * @param {'mapbox.places'|'mapbox.places-permanent'} [config.mode="mapbox.places"] - Either `mapbox.places` for ephemeral geocoding, or `mapbox.places-permanent` for storing results and batch geocoding.
 * @param {Array<string>} [config.countries] - Limits results to the specified countries.
 *   Each item in the array should be an [ISO 3166 alpha 2 country code](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2).
 * @param {Array<'country'|'region'|'postcode'|'district'|'place'|'locality'|'neighborhood'|'address'|'poi'|'poi.landmark'>} [config.types] - Filter results by feature types.
 * @param {BoundingBox} [config.bbox] - Limit results to a bounding box.
 * @param {number} [config.limit=1] - Limit the number of results returned. If using this option, you must provide a single item for `types`.
 * @param {Array<string>} [config.language] - Specify the language to use for response text and, for forward geocoding, query result weighting.
 *  Options are [IETF language tags](https://en.wikipedia.org/wiki/IETF_language_tag) comprised of a mandatory
 *  [ISO 639-1 language code](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) and optionally one or more IETF subtags for country or script.
 * @param {'distance'|'score'} [config.reverseMode='distance'] - Set the factors that are used to sort nearby results.
 * @param {boolean} [config.routing=false] - Specify whether to request additional metadata about the recommended navigation destination. Only applicable for address features.
 * @param {String} [config.worldview="us"] - Filter results to geographic features whose characteristics are defined differently by audiences belonging to various regional, cultural, or political groups.
 * @param {String} [config.session_token] - A unique session identifier generated by the client.
 * @return {MapiRequest}
 *
 * @example
 * geocodingClient.reverseGeocode({
 *   query: [-95.4431142, 33.6875431]
 * })
 *   .send()
 *   .then(response => {
 *     // GeoJSON document with geocoding matches
 *     const match = response.body;
 *   });
 */ $d4053cad85b8db5c$var$Geocoding.reverseGeocode = function(config) {
    $6526756303cd3910$exports.assertShape({
        query: $6526756303cd3910$exports.required($6526756303cd3910$exports.coordinates),
        mode: $6526756303cd3910$exports.oneOf('mapbox.places', 'mapbox.places-permanent'),
        countries: $6526756303cd3910$exports.arrayOf($6526756303cd3910$exports.string),
        types: $6526756303cd3910$exports.arrayOf($6526756303cd3910$exports.oneOf($d4053cad85b8db5c$var$featureTypes)),
        bbox: $6526756303cd3910$exports.arrayOf($6526756303cd3910$exports.number),
        limit: $6526756303cd3910$exports.number,
        language: $6526756303cd3910$exports.arrayOf($6526756303cd3910$exports.string),
        reverseMode: $6526756303cd3910$exports.oneOf('distance', 'score'),
        routing: $6526756303cd3910$exports.boolean,
        worldview: $6526756303cd3910$exports.string,
        session_token: $6526756303cd3910$exports.string
    })(config);
    config.mode = config.mode || 'mapbox.places';
    var query = $33c7e469dec84260$exports($c61292941889f8f2$exports({
        country: config.countries
    }, $702e71365018f71e$exports(config, [
        'country',
        'types',
        'bbox',
        'limit',
        'language',
        'reverseMode',
        'routing',
        'worldview',
        'session_token'
    ])));
    return this.client.createRequest({
        method: 'GET',
        path: '/geocoding/v5/:mode/:query.json',
        params: $702e71365018f71e$exports(config, [
            'mode',
            'query'
        ]),
        query: query
    });
};
$d4053cad85b8db5c$exports = $f16dd55c0fa9b91d$exports($d4053cad85b8db5c$var$Geocoding);


var $02f891eee17bc6fb$exports = {};
'use strict';
let $f34a3dcdc8494601$export$2b646eea95309f00 = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';


let $f00a97eed1786a48$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $f00a97eed1786a48$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        if (size <= 0) return '';
        let id = '';
        while(true){
            let bytes = getRandom(step);
            let j = step | 0;
            while(j--){
                id += alphabet[bytes[j] & mask] || '';
                if (id.length === size) return id;
            }
        }
    };
};
let $f00a97eed1786a48$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$f00a97eed1786a48$export$a5cee9e955a615e5(alphabet, size, $f00a97eed1786a48$export$4385e60b38654f68);
let $f00a97eed1786a48$export$ac4959f4f1338dfc = (size = 21)=>crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte)=>{
        byte &= 63;
        if (byte < 36) id += byte.toString(36);
        else if (byte < 62) id += (byte - 26).toString(36).toUpperCase();
        else if (byte > 62) id += '-';
        else id += '_';
        return id;
    }, '');


var $02f891eee17bc6fb$require$nanoid = $f00a97eed1786a48$export$ac4959f4f1338dfc;
/**
 * Construct a new mapbox event client to send interaction events to the mapbox event service
 * @param {Object} options options with which to create the service
 * @param {String} options.accessToken the mapbox access token to make requests
 * @param {Number} [options.flushInterval=1000] the number of ms after which to flush the event queue
 * @param {Number} [options.maxQueueSize=100] the number of events to queue before flushing
 * @private
 */ function $02f891eee17bc6fb$var$MapboxEventManager(options) {
    this.origin = options.origin || 'https://api.mapbox.com';
    this.endpoint = 'events/v2';
    this.access_token = options.accessToken;
    this.version = '0.3.0';
    this.pluginSessionID = this.generateSessionID();
    this.sessionIncrementer = 0;
    this.userAgent = this.getUserAgent();
    this.options = options;
    this.send = this.send.bind(this);
    // parse global options to be sent with each request
    this.countries = options.countries ? options.countries.split(",") : null;
    this.types = options.types ? options.types.split(",") : null;
    this.bbox = options.bbox ? options.bbox : null;
    this.language = options.language ? options.language.split(",") : null;
    this.limit = options.limit ? +options.limit : null;
    this.locale = navigator.language || null;
    this.enableEventLogging = this.shouldEnableLogging(options);
    this.eventQueue = new Array();
    this.flushInterval = options.flushInterval || 1000;
    this.maxQueueSize = options.maxQueueSize || 100;
    this.timer = this.flushInterval ? setTimeout(this.flush.bind(this), this.flushInterval) : null;
    // keep some state to deduplicate requests if necessary
    this.lastSentInput = "";
    this.lastSentIndex = 0;
}
$02f891eee17bc6fb$var$MapboxEventManager.prototype = {
    /**
     * Send a search.select event to the mapbox events service
     * This event marks the array index of the item selected by the user out of the array of possible options
     * @private
     * @param {Object} selected the geojson feature selected by the user
     * @param {Object} geocoder a mapbox-gl-geocoder instance
     * @returns {Promise}
     */ select: function(selected, geocoder) {
        var payload = this.getEventPayload('search.select', geocoder, {
            selectedFeature: selected
        });
        if (!payload) return; // reject malformed event
        if (payload.resultIndex === this.lastSentIndex && payload.queryString === this.lastSentInput || payload.resultIndex == -1) // don't log duplicate events if the user re-selected the same feature on the same search
        return;
        this.lastSentIndex = payload.resultIndex;
        this.lastSentInput = payload.queryString;
        return this.push(payload);
    },
    /**
     * Send a search-start event to the mapbox events service
     * This turnstile event marks when a user starts a new search
     * @private
     * @param {Object} geocoder a mapbox-gl-geocoder instance
     * @returns {Promise}
     */ start: function(geocoder) {
        var payload = this.getEventPayload('search.start', geocoder);
        if (!payload) return; // reject malformed event
        return this.push(payload);
    },
    /**
   * Send a search-keyevent event to the mapbox events service
   * This event records each keypress in sequence
   * @private
   * @param {Object} keyEvent the keydown event to log
   * @param {Object} geocoder a mapbox-gl-geocoder instance
   * 
   */ keyevent: function(keyEvent, geocoder) {
        //pass invalid event
        if (!keyEvent.key) return;
        // don't send events for keys that don't change the input
        // TAB, ESC, LEFT, RIGHT, ENTER, UP, DOWN
        if (keyEvent.metaKey || [
            9,
            27,
            37,
            39,
            13,
            38,
            40
        ].indexOf(keyEvent.keyCode) !== -1) return;
        var payload = this.getEventPayload('search.keystroke', geocoder, {
            key: keyEvent.key
        });
        if (!payload) return; // reject malformed event
        return this.push(payload);
    },
    /**
   * Send an event to the events service
   *
   * The event is skipped if the instance is not enabled to send logging events
   *
   * @private
   * @param {Object} payload the http POST body of the event
   * @param {Function} [callback] a callback function to invoke when the send has completed
   * @returns {Promise}
   */ send: function(payload, callback) {
        if (!this.enableEventLogging) {
            if (callback) return callback();
            return;
        }
        var options = this.getRequestOptions(payload);
        this.request(options, (function(err) {
            if (err) return this.handleError(err, callback);
            if (callback) return callback();
        }).bind(this));
    },
    /**
   * Get http request options
   * @private
   * @param {*} payload
   */ getRequestOptions: function(payload) {
        if (!Array.isArray(payload)) payload = [
            payload
        ];
        var options = {
            // events must be sent with POST
            method: "POST",
            host: this.origin,
            path: this.endpoint + "?access_token=" + this.access_token,
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload) //events are arrays
        };
        return options;
    },
    /**
   * Get the event payload to send to the events service
   * Most payload properties are shared across all events
   * @private
   * @param {String} event the name of the event to send to the events service. Valid options are 'search.start', 'search.select', 'search.feedback'.
   * @param {Object} geocoder a mapbox-gl-geocoder instance
   * @param {Object} eventArgs Additional arguments needed for certain event types
   * @param {Object} eventArgs.key The key pressed by the user
   * @param {Object} eventArgs.selectedFeature GeoJSON Feature selected by the user
   * @returns {Object} an event payload
   */ getEventPayload: function(event, geocoder, eventArgs = {}) {
        // Make sure required arguments are present for certain event types
        if (event === 'search.select' && !eventArgs.selectedFeature || event === 'search.keystroke' && !eventArgs.key) return null;
        // Handle proximity, whether null, lat/lng coordinate object, or 'ip'
        var proximity;
        if (!geocoder.options.proximity) proximity = null;
        else if (typeof geocoder.options.proximity === 'object') proximity = [
            geocoder.options.proximity.longitude,
            geocoder.options.proximity.latitude
        ];
        else if (geocoder.options.proximity === 'ip') {
            var ipProximityHeader = geocoder._headers ? geocoder._headers['ip-proximity'] : null;
            if (ipProximityHeader && typeof ipProximityHeader === 'string') proximity = ipProximityHeader.split(',').map(parseFloat);
            else proximity = [
                999,
                999
            ]; // Alias for 'ip' in event logs
        } else proximity = geocoder.options.proximity;
        var zoom = geocoder._map ? geocoder._map.getZoom() : undefined;
        var payload = {
            event: event,
            version: this.getEventSchemaVersion(event),
            created: +new Date(),
            sessionIdentifier: this.getSessionId(),
            country: this.countries,
            userAgent: this.userAgent,
            language: this.language,
            bbox: this.bbox,
            types: this.types,
            endpoint: 'mapbox.places',
            autocomplete: geocoder.options.autocomplete,
            fuzzyMatch: geocoder.options.fuzzyMatch,
            proximity: proximity,
            limit: geocoder.options.limit,
            routing: geocoder.options.routing,
            worldview: geocoder.options.worldview,
            mapZoom: zoom,
            keyboardLocale: this.locale
        };
        // get the text in the search bar
        if (event === "search.select") payload.queryString = geocoder.inputString;
        else if (event != "search.select" && geocoder._inputEl) payload.queryString = geocoder._inputEl.value;
        else payload.queryString = geocoder.inputString;
        // add additional properties for certain event types
        if ([
            'search.keystroke',
            'search.select'
        ].includes(event)) payload.path = 'geocoding/v5/mapbox.places';
        if (event === 'search.keystroke' && eventArgs.key) payload.lastAction = eventArgs.key;
        else if (event === 'search.select' && eventArgs.selectedFeature) {
            var selected = eventArgs.selectedFeature;
            var resultIndex = this.getSelectedIndex(selected, geocoder);
            payload.resultIndex = resultIndex;
            payload.resultPlaceName = selected.place_name;
            payload.resultId = selected.id;
            if (selected.properties) payload.resultMapboxId = selected.properties.mapbox_id;
            if (geocoder._typeahead) {
                var results = geocoder._typeahead.data;
                if (results && results.length > 0) {
                    payload.suggestionIds = this.getSuggestionIds(results);
                    payload.suggestionNames = this.getSuggestionNames(results);
                    payload.suggestionTypes = this.getSuggestionTypes(results);
                    payload.suggestionSources = this.getSuggestionSources(results);
                }
            }
        }
        // Finally, validate that required properties are present for API compatibility
        if (!this.validatePayload(payload)) return null;
        return payload;
    },
    /**
   * Wraps the request function for easier testing
   * Make an http request and invoke a callback
   * @private
   * @param {Object} opts options describing the http request to be made
   * @param {Function} callback the callback to invoke when the http request is completed
   */ request: function(opts, callback) {
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState == 4) {
                if (this.status == 204) //success
                return callback(null);
                else return callback(this.statusText);
            }
        };
        xhttp.open(opts.method, opts.host + '/' + opts.path, true);
        for(var header in opts.headers){
            var headerValue = opts.headers[header];
            xhttp.setRequestHeader(header, headerValue);
        }
        xhttp.send(opts.body);
    },
    /**
   * Handle an error that occurred while making a request
   * @param {Object} err an error instance to log
   * @private
   */ handleError: function(err, callback) {
        if (callback) return callback(err);
    },
    /**
   * Generate a session ID to be returned with all of the searches made by this geocoder instance
   * ID is random and cannot be tracked across sessions
   * @private
   */ generateSessionID: function() {
        return $02f891eee17bc6fb$require$nanoid();
    },
    /**
   * Get the a unique session ID for the current plugin session and increment the session counter.
   *
   * @returns {String} The session ID
   */ getSessionId: function() {
        return this.pluginSessionID + '.' + this.sessionIncrementer;
    },
    /**
   * Get a user agent string to send with the request to the events service
   * @private
   */ getUserAgent: function() {
        return 'mapbox-gl-geocoder.' + this.version + "." + navigator.userAgent;
    },
    /**
     * Get the 0-based numeric index of the item that the user selected out of the list of options
     * @private
     * @param {Object} selected the geojson feature selected by the user
     * @param {Object} geocoder a Mapbox-GL-Geocoder instance
     * @returns {Number} the index of the selected result
     */ getSelectedIndex: function(selected, geocoder) {
        if (!geocoder._typeahead) return;
        var results = geocoder._typeahead.data;
        var selectedID = selected.id;
        var resultIDs = results.map(function(feature) {
            return feature.id;
        });
        var selectedIdx = resultIDs.indexOf(selectedID);
        return selectedIdx;
    },
    getSuggestionIds: function(results) {
        return results.map(function(feature) {
            if (feature.properties) return feature.properties.mapbox_id || '';
            return feature.id || '';
        });
    },
    getSuggestionNames: function(results) {
        return results.map(function(feature) {
            return feature.place_name || '';
        });
    },
    getSuggestionTypes: function(results) {
        return results.map(function(feature) {
            if (feature.place_type && Array.isArray(feature.place_type)) return feature.place_type[0] || '';
            return '';
        });
    },
    getSuggestionSources: function(results) {
        return results.map(function(feature) {
            return feature._source || '';
        });
    },
    /**
   * Get the correct schema version for the event
   * @private
   * @param {String} event Name of the event
   * @returns 
   */ getEventSchemaVersion: function(event) {
        if ([
            'search.keystroke',
            'search.select'
        ].includes(event)) return '2.2';
        else return '2.0';
    },
    /**
   * Checks if a payload has all the required properties for the event type
   * @private
   * @param {Object} payload 
   * @returns 
   */ validatePayload: function(payload) {
        if (!payload || !payload.event) return false;
        var searchStartRequiredProps = [
            'event',
            'created',
            'sessionIdentifier',
            'queryString'
        ];
        var searchKeystrokeRequiredProps = [
            'event',
            'created',
            'sessionIdentifier',
            'queryString',
            'lastAction'
        ];
        var searchSelectRequiredProps = [
            'event',
            'created',
            'sessionIdentifier',
            'queryString',
            'resultIndex',
            'path',
            'suggestionIds'
        ];
        var event = payload.event;
        if (event === 'search.start') return this.objectHasRequiredProps(payload, searchStartRequiredProps);
        else if (event === 'search.keystroke') return this.objectHasRequiredProps(payload, searchKeystrokeRequiredProps);
        else if (event === 'search.select') return this.objectHasRequiredProps(payload, searchSelectRequiredProps);
        return true;
    },
    /**
   * Checks of an object has all the required properties
   * @private
   * @param {Object} obj 
   * @param {Array<String>} requiredProps 
   * @returns 
   */ objectHasRequiredProps: function(obj, requiredProps) {
        return requiredProps.every(function(prop) {
            if (prop === 'queryString') return typeof obj[prop] === 'string' && obj[prop].length > 0;
            return obj[prop] !== undefined;
        });
    },
    /**
     * Check whether events should be logged
     * Clients using a localGeocoder or an origin other than mapbox should not have events logged
     * @private
     */ shouldEnableLogging: function(options) {
        if (options.enableEventLogging === false) return false;
        if (options.origin && options.origin !== 'https://api.mapbox.com') return false;
        return true;
    },
    /**
   * Flush out the event queue by sending events to the events service
   * @private
   */ flush: function() {
        if (this.eventQueue.length > 0) {
            this.send(this.eventQueue);
            this.eventQueue = new Array();
        }
        // //reset the timer
        if (this.timer) clearTimeout(this.timer);
        if (this.flushInterval) this.timer = setTimeout(this.flush.bind(this), this.flushInterval);
    },
    /**
   * Push event into the pending queue
   * @param {Object} evt the event to send to the events service
   * @param {Boolean} forceFlush indicates that the event queue should be flushed after adding this event regardless of size of the queue
   * @private
   */ push: function(evt, forceFlush) {
        this.eventQueue.push(evt);
        if (this.eventQueue.length >= this.maxQueueSize || forceFlush) this.flush();
    },
    /**
   * Flush any remaining events from the queue before it is removed
   * @private
   */ remove: function() {
        this.flush();
    }
};
$02f891eee17bc6fb$exports = $02f891eee17bc6fb$var$MapboxEventManager;


var $96c6bfdf991addc9$exports = {};
'use strict';
/**
 * Localized values for the placeholder string
 * 
 * @private
 */ var $96c6bfdf991addc9$var$placeholder = {
    // list drawn from https://docs.mapbox.com/api/search/#language-coverage
    'de': 'Suche',
    'it': 'Ricerca',
    'en': 'Search',
    'nl': 'Zoeken',
    'fr': 'Chercher',
    'ca': 'Cerca',
    'he': "\u05DC\u05D7\u05E4\u05E9",
    'ja': "\u30B5\u30FC\u30C1",
    'lv': "Mekl\u0113t",
    'pt': 'Procurar',
    'sr': "\u041F\u0440\u0435\u0442\u0440\u0430\u0433\u0430",
    'zh': "\u641C\u7D22",
    'cs': "Vyhled\xe1v\xe1n\xed",
    'hu': "Keres\xe9s",
    'ka': "\u10EB\u10D8\u10D4\u10D1\u10D0",
    'nb': "S\xf8ke",
    'sk': "Vyh\u013Ead\xe1vanie",
    'th': "\u0E04\u0E49\u0E19\u0E2B\u0E32",
    'fi': 'Hae',
    'is': 'Leita',
    'ko': "\uC218\uC0C9",
    'pl': 'Szukaj',
    'sl': 'Iskanje',
    'fa': "\u062C\u0633\u062A\u062C\u0648",
    'ru': "\u041F\u043E\u0438\u0441\u043A" //russian
};
$96c6bfdf991addc9$exports = {
    placeholder: $96c6bfdf991addc9$var$placeholder
};


var $18f2a2b049f8f8d3$exports = {};
!function(root, name, make) {
    if ($18f2a2b049f8f8d3$exports) $18f2a2b049f8f8d3$exports = make();
    else root[name] = make();
}($18f2a2b049f8f8d3$exports, 'subtag', function() {
    var empty = '';
    var pattern = /^([a-zA-Z]{2,3})(?:[_-]+([a-zA-Z]{3})(?=$|[_-]+))?(?:[_-]+([a-zA-Z]{4})(?=$|[_-]+))?(?:[_-]+([a-zA-Z]{2}|[0-9]{3})(?=$|[_-]+))?/;
    function match(tag) {
        return tag.match(pattern) || [];
    }
    function split(tag) {
        return match(tag).filter(function(v, i) {
            return v && i;
        });
    }
    function api(tag) {
        tag = match(tag);
        return {
            language: tag[1] || empty,
            extlang: tag[2] || empty,
            script: tag[3] || empty,
            region: tag[4] || empty
        };
    }
    function expose(target, key, value) {
        Object.defineProperty(target, key, {
            value: value,
            enumerable: true
        });
    }
    function part(position, pattern, type) {
        function method(tag) {
            return match(tag)[position] || empty;
        }
        expose(method, 'pattern', pattern);
        expose(api, type, method);
    }
    part(1, /^[a-zA-Z]{2,3}$/, 'language');
    part(2, /^[a-zA-Z]{3}$/, 'extlang');
    part(3, /^[a-zA-Z]{4}$/, 'script');
    part(4, /^[a-zA-Z]{2}$|^[0-9]{3}$/, 'region');
    expose(api, 'split', split);
    return api;
});


var $4e131e9fee0c4250$exports = {};
function $4e131e9fee0c4250$var$Geolocation() {}
$4e131e9fee0c4250$var$Geolocation.prototype = {
    isSupport: function() {
        return Boolean(window.navigator.geolocation);
    },
    getCurrentPosition: function() {
        const positionOptions = {
            enableHighAccuracy: true
        };
        return new Promise(function(resolve, reject) {
            window.navigator.geolocation.getCurrentPosition(resolve, reject, positionOptions);
        });
    }
};
$4e131e9fee0c4250$exports = $4e131e9fee0c4250$var$Geolocation;


var $cf0ee618109f3bfd$exports = {};
/**
 * This function transforms the feature from reverse geocoding to plain text with specified accuracy
 * @param {object} feature 
 * @param {string} accuracy 
 * @returns 
 */ function $cf0ee618109f3bfd$var$transformFeatureToGeolocationText(feature, accuracy) {
    const addrInfo = $cf0ee618109f3bfd$var$getAddressInfo(feature);
    const addressAccuracy = [
        'address',
        'street',
        'place',
        'country'
    ];
    var currentAccuracy;
    if (typeof accuracy === 'function') return accuracy(addrInfo);
    const accuracyIndex = addressAccuracy.indexOf(accuracy);
    if (accuracyIndex === -1) currentAccuracy = addressAccuracy;
    else currentAccuracy = addressAccuracy.slice(accuracyIndex);
    return currentAccuracy.reduce(function(acc, name) {
        if (!addrInfo[name]) return acc;
        if (acc !== '') acc = acc + ', ';
        return acc + addrInfo[name];
    }, '');
}
/**
 * This function transforms the feature from reverse geocoding to AddressInfo object
 * @param {object} feature 
 * @returns {object}
 */ function $cf0ee618109f3bfd$var$getAddressInfo(feature) {
    const houseNumber = feature.address || '';
    const street = feature.text || '';
    const placeName = feature.place_name || '';
    const address = placeName.split(',')[0];
    const addrInfo = {
        address: address,
        houseNumber: houseNumber,
        street: street,
        placeName: placeName
    };
    feature.context.forEach(function(context) {
        const layer = context.id.split('.')[0];
        addrInfo[layer] = context.text;
    });
    return addrInfo;
}
const $cf0ee618109f3bfd$var$REVERSE_GEOCODE_COORD_RGX = /^[ ]*(-?\d{1,3}(\.\d{0,256})?)[, ]+(-?\d{1,3}(\.\d{0,256})?)[ ]*$/;
$cf0ee618109f3bfd$exports = {
    transformFeatureToGeolocationText: $cf0ee618109f3bfd$var$transformFeatureToGeolocationText,
    getAddressInfo: $cf0ee618109f3bfd$var$getAddressInfo,
    REVERSE_GEOCODE_COORD_RGX: $cf0ee618109f3bfd$var$REVERSE_GEOCODE_COORD_RGX
};


const $614dc5797fe9f350$var$GEOCODE_REQUEST_TYPE = {
    FORWARD: 0,
    LOCAL: 1,
    REVERSE: 2
};
/**
 * Don't include this as part of the options object when creating a new MapboxGeocoder instance.
 */ function $614dc5797fe9f350$var$getFooterNode() {
    var div = document.createElement('div');
    div.className = 'mapboxgl-ctrl-geocoder--powered-by';
    div.innerHTML = '<a href="https://www.mapbox.com/search-service" target="_blank">Powered by Mapbox</a>';
    return div;
}
/**
 * A geocoder component using the [Mapbox Geocoding API](https://docs.mapbox.com/api/search/#geocoding)
 * @class MapboxGeocoder
 * @param {Object} options
 * @param {String} options.accessToken Required.
 * @param {String} [options.origin=https://api.mapbox.com] Use to set a custom API origin.
 * @param {Object} [options.mapboxgl] A [mapbox-gl](https://github.com/mapbox/mapbox-gl-js) instance to use when creating [Markers](https://docs.mapbox.com/mapbox-gl-js/api/#marker). Required if `options.marker` is `true`.
 * @param {Number} [options.zoom=16] On geocoded result what zoom level should the map animate to when a `bbox` isn't found in the response. If a `bbox` is found the map will fit to the `bbox`.
 * @param {Boolean|Object} [options.flyTo=true] If `false`, animating the map to a selected result is disabled. If `true`, animating the map will use the default animation parameters. If an object, it will be passed as `options` to the map [`flyTo`](https://docs.mapbox.com/mapbox-gl-js/api/#map#flyto) or [`fitBounds`](https://docs.mapbox.com/mapbox-gl-js/api/#map#fitbounds) method providing control over the animation of the transition.
 * @param {String} [options.placeholder=Search] Override the default placeholder attribute value.
 * @param {Object|'ip'} [options.proximity] a geographical point given as an object with `latitude` and `longitude` properties, or the string 'ip' to use a user's IP address location. Search results closer to this point will be given higher priority.
 * @param {Boolean} [options.trackProximity=true] If `true`, the geocoder proximity will dynamically update based on the current map view or user's IP location, depending on zoom level.
 * @param {Boolean} [options.collapsed=false] If `true`, the geocoder control will collapse until hovered or in focus.
 * @param {Boolean} [options.clearAndBlurOnEsc=false] If `true`, the geocoder control will clear it's contents and blur when user presses the escape key.
 * @param {Boolean} [options.clearOnBlur=false] If `true`, the geocoder control will clear its value when the input blurs.
 * @param {Array} [options.bbox] a bounding box argument: this is
 * a bounding box given as an array in the format `[minX, minY, maxX, maxY]`.
 * Search results will be limited to the bounding box.
 * @param {string} [options.countries] a comma separated list of country codes to
 * limit results to specified country or countries.
 * @param {string} [options.types] a comma seperated list of types that filter
 * results to match those specified. See https://docs.mapbox.com/api/search/#data-types
 * for available types.
 * If reverseGeocode is enabled and no type is specified, the type defaults to POIs. Otherwise, if you configure more than one type, the first type will be used.
 * @param {Number} [options.minLength=2] Minimum number of characters to enter before results are shown.
 * @param {Number} [options.limit=5] Maximum number of results to show.
 * @param {string} [options.language] Specify the language to use for response text and query result weighting. Options are IETF language tags comprised of a mandatory ISO 639-1 language code and optionally one or more IETF subtags for country or script. More than one value can also be specified, separated by commas. Defaults to the browser's language settings.
 * @param {Function} [options.filter] A function which accepts a Feature in the [extended GeoJSON](https://docs.mapbox.com/api/search/geocoding-v5/#geocoding-response-object) format to filter out results from the Geocoding API response before they are included in the suggestions list. Return `true` to keep the item, `false` otherwise.
 * @param {Function} [options.localGeocoder] A function accepting the query string which performs local geocoding to supplement results from the Mapbox Geocoding API. Expected to return an Array of GeoJSON Features in the [extended GeoJSON](https://docs.mapbox.com/api/search/geocoding-v5/#geocoding-response-object) format.
 * @param {Function} [options.externalGeocoder] A function accepting the query string and current features list which performs geocoding to supplement results from the Mapbox Geocoding API. Expected to return a Promise which resolves to an Array of GeoJSON Features in the [extended GeoJSON](https://docs.mapbox.com/api/search/geocoding-v5/#geocoding-response-object) format.
 * @param {distance|score} [options.reverseMode=distance] - Set the factors that are used to sort nearby results.
 * @param {boolean} [options.reverseGeocode=false] If `true`, enable reverse geocoding mode. In reverse geocoding, search input is expected to be coordinates in the form `lat, lon`, with suggestions being the reverse geocodes.
 * @param {boolean} [options.flipCoordinates=false] If `true`, search input coordinates for reverse geocoding is expected to be in the form `lon, lat` instead of the default `lat, lon`.
 * @param {Boolean} [options.enableEventLogging=true] Allow Mapbox to collect anonymous usage statistics from the plugin.
 * @param {Boolean|Object} [options.marker=true]  If `true`, a [Marker](https://docs.mapbox.com/mapbox-gl-js/api/#marker) will be added to the map at the location of the user-selected result using a default set of Marker options.  If the value is an object, the marker will be constructed using these options. If `false`, no marker will be added to the map. Requires that `options.mapboxgl` also be set.
 * @param {Function} [options.render] A function that specifies how the results should be rendered in the dropdown menu. This function should accepts a single [extended GeoJSON](https://docs.mapbox.com/api/search/geocoding-v5/#geocoding-response-object) object as input and return a string. Any HTML in the returned string will be rendered.
 * @param {Function} [options.getItemValue] A function that specifies how the selected result should be rendered in the search bar. This function should accept a single [extended GeoJSON](https://docs.mapbox.com/api/search/geocoding-v5/#geocoding-response-object) object as input and return a string. HTML tags in the output string will not be rendered. Defaults to `(item) => item.place_name`.
 * @param {String} [options.mode=mapbox.places] A string specifying the geocoding [endpoint](https://docs.mapbox.com/api/search/#endpoints) to query. Options are `mapbox.places` and `mapbox.places-permanent`. The `mapbox.places-permanent` mode requires an enterprise license for permanent geocodes.
 * @param {Boolean} [options.localGeocoderOnly=false] If `true`, indicates that the `localGeocoder` results should be the only ones returned to the user. If `false`, indicates that the `localGeocoder` results should be combined with those from the Mapbox API with the `localGeocoder` results ranked higher.
 * @param {Boolean} [options.autocomplete=true] Specify whether to return autocomplete results or not. When autocomplete is enabled, results will be included that start with the requested string, rather than just responses that match it exactly.
 * @param {Boolean} [options.fuzzyMatch=true] Specify whether the Geocoding API should attempt approximate, as well as exact, matching when performing searches, or whether it should opt out of this behavior and only attempt exact matching.
 * @param {Boolean} [options.routing=false] Specify whether to request additional metadata about the recommended navigation destination corresponding to the feature or not. Only applicable for address features.
 * @param {String} [options.worldview="us"] Filter results to geographic features whose characteristics are defined differently by audiences belonging to various regional, cultural, or political groups.
 * @param {Boolean} [options.enableGeolocation=false] If `true` enable user geolocation feature.
 * @param {Boolean} [options.useBrowserFocus=false] If `true`, the geocoder will use the browser's focus event to show suggestions. If `false`, it will only highlight active suggestions and Tab will not propagate to the suggestions list.
 * @param {('address'|'street'|'place'|'country')} [options.addressAccuracy="street"] The accuracy for the geolocation feature with which we define the address line to fill. The browser API returns the user's position with accuracy, and sometimes we can get the neighbor's address. To prevent receiving an incorrect address, you can reduce the accuracy of the definition.
 * @example
 * var geocoder = new MapboxGeocoder({ accessToken: mapboxgl.accessToken });
 * map.addControl(geocoder);
 * @return {MapboxGeocoder} `this`
 *
 */ function $614dc5797fe9f350$var$MapboxGeocoder(options) {
    this._eventEmitter = new $614dc5797fe9f350$require$EventEmitter();
    this.options = $c61292941889f8f2$exports({}, this.options, options);
    this.inputString = '';
    this.fresh = true;
    this.lastSelected = null;
    this.geolocation = new $4e131e9fee0c4250$exports();
}
function $614dc5797fe9f350$var$escapeHtml(str) {
    if (!str) return '';
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
$614dc5797fe9f350$var$MapboxGeocoder.prototype = {
    options: {
        zoom: 16,
        flyTo: true,
        trackProximity: true,
        minLength: 2,
        reverseGeocode: false,
        flipCoordinates: false,
        limit: 5,
        origin: 'https://api.mapbox.com',
        enableEventLogging: true,
        marker: true,
        mapboxgl: null,
        collapsed: false,
        clearAndBlurOnEsc: false,
        clearOnBlur: false,
        enableGeolocation: false,
        addressAccuracy: 'street',
        useBrowserFocus: false,
        getItemValue: function(item) {
            return item.place_name;
        },
        render: function(item) {
            var placeName = $614dc5797fe9f350$var$escapeHtml(item.place_name).split(',');
            return '<div class="mapboxgl-ctrl-geocoder--suggestion"><div class="mapboxgl-ctrl-geocoder--suggestion-title">' + placeName[0] + '</div><div class="mapboxgl-ctrl-geocoder--suggestion-address">' + placeName.splice(1, placeName.length).join(',') + '</div></div>';
        }
    },
    _headers: {},
    /**
   * Add the geocoder to a container. The container can be either a `mapboxgl.Map`, an `HTMLElement` or a CSS selector string.
   *
   * If the container is a [`mapboxgl.Map`](https://docs.mapbox.com/mapbox-gl-js/api/map/), this function will behave identically to [`Map.addControl(geocoder)`](https://docs.mapbox.com/mapbox-gl-js/api/map/#map#addcontrol).
   * If the container is an instance of [`HTMLElement`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement), then the geocoder will be appended as a child of that [`HTMLElement`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement).
   * If the container is a [CSS selector string](https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Selectors), the geocoder will be appended to the element returned from the query.
   *
   * This function will throw an error if the container is none of the above.
   * It will also throw an error if the referenced HTML element cannot be found in the `document.body`.
   *
   * For example, if the HTML body contains the element `<div id='geocoder-container'></div>`, the following script will append the geocoder to `#geocoder-container`:
   *
   * ```javascript
   * var geocoder = new MapboxGeocoder({ accessToken: mapboxgl.accessToken });
   * geocoder.addTo('#geocoder-container');
   * ```
   * @param {String|HTMLElement|mapboxgl.Map} container A reference to the container to which to add the geocoder
   */ addTo: function(container) {
        function addToExistingContainer(geocoder, container) {
            if (!document.body.contains(container)) throw new Error("Element provided to #addTo() exists, but is not in the DOM");
            const el = geocoder.onAdd(); //returns the input elements, which are then added to the requested html container
            container.appendChild(el);
        }
        // if the container is a map, add the control like normal
        if (container._controlContainer) //  it's a mapbox-gl map, add like normal
        container.addControl(this);
        else if (container instanceof HTMLElement) addToExistingContainer(this, container);
        else if (typeof container == 'string') {
            const parent = document.querySelectorAll(container);
            if (parent.length === 0) throw new Error("Element ", container, "not found.");
            if (parent.length > 1) throw new Error("Geocoder can only be added to a single html element");
            addToExistingContainer(this, parent[0]);
        } else throw new Error("Error: addTo must be a mapbox-gl-js map, an html element, or a CSS selector query for a single html element");
    },
    onAdd: function(map) {
        if (map && typeof map != 'string') this._map = map;
        this.setLanguage();
        if (!this.options.localGeocoderOnly) this.geocoderService = $d4053cad85b8db5c$exports($74e8675559d59e8a$exports({
            accessToken: this.options.accessToken,
            origin: this.options.origin
        }));
        if (this.options.localGeocoderOnly && !this.options.localGeocoder) throw new Error("A localGeocoder function must be specified to use localGeocoderOnly mode");
        this.eventManager = new $02f891eee17bc6fb$exports(this.options);
        this._onChange = this._onChange.bind(this);
        this._onKeyDown = this._onKeyDown.bind(this);
        this._onPaste = this._onPaste.bind(this);
        this._onBlur = this._onBlur.bind(this);
        this._showButton = this._showButton.bind(this);
        this._hideButton = this._hideButton.bind(this);
        this._onQueryResult = this._onQueryResult.bind(this);
        this.clear = this.clear.bind(this);
        this._updateProximity = this._updateProximity.bind(this);
        this._collapse = this._collapse.bind(this);
        this._unCollapse = this._unCollapse.bind(this);
        this._clear = this._clear.bind(this);
        this._clearOnBlur = this._clearOnBlur.bind(this);
        this._geolocateUser = this._geolocateUser.bind(this);
        this._onSuggestionItemFocus = this._onSuggestionItemFocus.bind(this);
        this._onSuggestionItemKeyDown = this._onSuggestionItemKeydown.bind(this);
        var el = this.container = document.createElement('div');
        el.className = 'mapboxgl-ctrl-geocoder mapboxgl-ctrl';
        var searchIcon = this.createIcon('search', '<path d="M7.4 2.5c-2.7 0-4.9 2.2-4.9 4.9s2.2 4.9 4.9 4.9c1 0 1.8-.2 2.5-.8l3.7 3.7c.2.2.4.3.8.3.7 0 1.1-.4 1.1-1.1 0-.3-.1-.5-.3-.8L11.4 10c.4-.8.8-1.6.8-2.5.1-2.8-2.1-5-4.8-5zm0 1.6c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2-3.3-1.3-3.3-3.1 1.4-3.3 3.3-3.3z"/>');
        this._inputEl = document.createElement('input');
        this._inputEl.type = 'text';
        this._inputEl.className = 'mapboxgl-ctrl-geocoder--input';
        this.setPlaceholder();
        if (this.options.collapsed) {
            this._collapse();
            this.container.addEventListener('mouseenter', this._unCollapse);
            this.container.addEventListener('mouseleave', this._collapse);
            this._inputEl.addEventListener('focus', this._unCollapse);
        }
        if (this.options.collapsed || this.options.clearOnBlur) this._inputEl.addEventListener('blur', this._onBlur);
        this._inputEl.addEventListener('keydown', $faa88de4f0afd1d0$exports(this._onKeyDown, 200));
        this._inputEl.addEventListener('paste', this._onPaste);
        this._inputEl.addEventListener('change', this._onChange);
        this.container.addEventListener('mouseenter', this._showButton);
        this.container.addEventListener('mouseleave', this._hideButton);
        this._inputEl.addEventListener('keyup', (function(e) {
            this.eventManager.keyevent(e, this);
        }).bind(this));
        var actions = document.createElement('div');
        actions.classList.add('mapboxgl-ctrl-geocoder--pin-right');
        this._clearEl = document.createElement('button');
        this._clearEl.setAttribute('aria-label', 'Clear');
        this._clearEl.addEventListener('click', this.clear);
        this._clearEl.className = 'mapboxgl-ctrl-geocoder--button';
        var buttonIcon = this.createIcon('close', '<path d="M3.8 2.5c-.6 0-1.3.7-1.3 1.3 0 .3.2.7.5.8L7.2 9 3 13.2c-.3.3-.5.7-.5 1 0 .6.7 1.3 1.3 1.3.3 0 .7-.2 1-.5L9 10.8l4.2 4.2c.2.3.7.3 1 .3.6 0 1.3-.7 1.3-1.3 0-.3-.2-.7-.3-1l-4.4-4L15 4.6c.3-.2.5-.5.5-.8 0-.7-.7-1.3-1.3-1.3-.3 0-.7.2-1 .3L9 7.1 4.8 2.8c-.3-.1-.7-.3-1-.3z"/>');
        this._clearEl.appendChild(buttonIcon);
        this._loadingEl = this.createIcon('loading', '<path fill="#333" d="M4.4 4.4l.8.8c2.1-2.1 5.5-2.1 7.6 0l.8-.8c-2.5-2.5-6.7-2.5-9.2 0z"/><path opacity=".1" d="M12.8 12.9c-2.1 2.1-5.5 2.1-7.6 0-2.1-2.1-2.1-5.5 0-7.7l-.8-.8c-2.5 2.5-2.5 6.7 0 9.2s6.6 2.5 9.2 0 2.5-6.6 0-9.2l-.8.8c2.2 2.1 2.2 5.6 0 7.7z"/>');
        actions.appendChild(this._clearEl);
        actions.appendChild(this._loadingEl);
        el.appendChild(searchIcon);
        el.appendChild(this._inputEl);
        if (this.options.enableGeolocation && this.geolocation.isSupport()) {
            this._geolocateEl = document.createElement('button');
            this._geolocateEl.setAttribute('aria-label', 'Geolocate');
            this._geolocateEl.addEventListener('click', this._geolocateUser);
            this._geolocateEl.className = 'mapboxgl-ctrl-geocoder--button';
            var geolocateIcon = this.createIcon('geolocate', '<path d="M12.999 3.677L2.042 8.269c-.962.403-.747 1.823.29 1.912l5.032.431.431 5.033c.089 1.037 1.509 1.252 1.912.29l4.592-10.957c.345-.822-.477-1.644-1.299-1.299z" fill="#4264fb"/>');
            this._geolocateEl.appendChild(geolocateIcon);
            actions.appendChild(this._geolocateEl);
            this._showGeolocateButton();
        }
        var typeahead = this._typeahead = new $cab0705cde42bc82$exports(this._inputEl, [], {
            hideOnBlur: !this.options.useBrowserFocus,
            filter: false,
            minLength: this.options.minLength,
            limit: this.options.limit
        });
        // To preserve tab navigation order
        el.insertBefore(actions, typeahead.list.wrapper);
        this.setRenderFunction(this.options.render);
        typeahead.getItemValue = this.options.getItemValue;
        const handleKeyDownTypeahead = this._typeahead.handleKeyDown.bind(this._typeahead);
        const handleKeyUpTypeahead = this._typeahead.handleKeyUp.bind(this._typeahead);
        this._typeahead.handleKeyUp;
        if (this.options.useBrowserFocus) {
            this._typeahead.handleKeyDown = (function(e) {
                if (e.keyCode === 9 && !typeahead.list.isEmpty()) return;
                // Arrow down
                if (e.keyCode === 40) {
                    this._typeahead.list.active = 0;
                    this._typeahead.list.element.querySelectorAll('li').forEach(function(item) {
                        item.classList.remove('active');
                    });
                    this._typeahead.list.element.querySelectorAll('li')[0].classList.add('active');
                    this._typeahead.list.element.querySelectorAll('li')[0].focus();
                    return;
                // Arrow up
                } else if (e.keyCode === 38) {
                    this._typeahead.list.active = typeahead.list.items.length - 1;
                    this._typeahead.list.element.querySelectorAll('li').forEach(function(item) {
                        item.classList.remove('active');
                    });
                    this._typeahead.list.element.querySelectorAll('li')[this._typeahead.list.active].classList.add('active');
                    this._typeahead.list.element.querySelectorAll('li')[this._typeahead.list.active].focus();
                    return;
                }
                handleKeyDownTypeahead(e);
            }).bind(this);
            this._typeahead.handleKeyUp = function(e) {
                if (e && e.keyCode === 16) {
                    e.preventDefault();
                    return;
                }
                handleKeyUpTypeahead(e);
            };
        }
        // Add support for footer.
        var parentDraw = typeahead.list.draw;
        var footerNode = this._footerNode = $614dc5797fe9f350$var$getFooterNode();
        var self = this;
        typeahead.list.draw = function() {
            if (self.options.useBrowserFocus) typeahead.list.element.querySelectorAll('li').forEach(function(item) {
                item.removeEventListener('focus', self._onSuggestionItemFocus);
                item.removeEventListener('keydown', self._onSuggestionItemKeyDown);
            });
            parentDraw.call(this);
            if (self.options.useBrowserFocus) typeahead.list.element.querySelectorAll('li').forEach((function(item, index) {
                if (index === 0) item.focus();
                item.setAttribute('data-index', index);
                item.tabIndex = 0;
                item.addEventListener('focus', this._onSuggestionItemFocus);
                item.addEventListener('keydown', this._onSuggestionItemKeyDown);
            }).bind(self));
            footerNode.addEventListener('mousedown', (function() {
                this.selectingListItem = true;
            }).bind(this));
            footerNode.addEventListener('mouseup', (function() {
                this.selectingListItem = false;
            }).bind(this));
            this.element.appendChild(footerNode);
        };
        this.mapMarker = null;
        this._handleMarker = this._handleMarker.bind(this);
        if (this._map) {
            if (this.options.trackProximity) {
                this._updateProximity();
                this._map.on('moveend', this._updateProximity);
            }
            this._mapboxgl = this.options.mapboxgl;
            if (!this._mapboxgl && this.options.marker) {
                // eslint-disable-next-line no-console
                console.error("No mapboxgl detected in options. Map markers are disabled. Please set options.mapboxgl.");
                this.options.marker = false;
            }
        }
        return el;
    },
    _onSuggestionItemKeydown (e) {
        const keyCode = e.keyCode;
        if (keyCode === 9) return;
        if (keyCode === 13) {
            e.preventDefault();
            const activeItem = this._typeahead.list.element.querySelector('.active');
            if (activeItem) {
                const itemIndex = activeItem.getAttribute('data-index');
                const item = this._typeahead.list.items[itemIndex];
                if (item) {
                    this._typeahead.value(item.original);
                    this._typeahead.list.hide();
                }
            }
        } else if (keyCode === 38 || keyCode === 40) {
            const items = this._typeahead.list.element.querySelectorAll('li');
            if (items.length > 0) {
                if (keyCode === 38) {
                    if (this._typeahead.list.active > 0) {
                        e.preventDefault();
                        this._typeahead.list.active--;
                    } else {
                        this._typeahead.el.focus();
                        return;
                    }
                } else if (keyCode === 40) {
                    e.preventDefault();
                    if (this._typeahead.list.active < items.length - 1) this._typeahead.list.active++;
                    else return;
                }
                items.forEach(function(item) {
                    item.classList.remove('active');
                });
                const activeItem = items[this._typeahead.list.active];
                if (activeItem) {
                    activeItem.classList.add('active');
                    activeItem.focus();
                }
            }
        }
    },
    _onSuggestionItemFocus (e) {
        this._typeahead.list.active = e.target.getAttribute('data-index');
        this._typeahead.list.element.querySelectorAll('li').forEach(function(item) {
            item.classList.remove('active');
        });
        e.target.classList.add('active');
    },
    _geolocateUser: function() {
        this._hideGeolocateButton();
        this._showLoadingIcon();
        this.geolocation.getCurrentPosition().then((function(geolocationPosition) {
            this._hideLoadingIcon();
            const geojson = {
                geometry: {
                    type: 'Point',
                    coordinates: [
                        geolocationPosition.coords.longitude,
                        geolocationPosition.coords.latitude
                    ]
                }
            };
            this._handleMarker(geojson);
            this._fly(geojson);
            this._typeahead.clear();
            this._typeahead.selected = true;
            this.lastSelected = JSON.stringify(geojson);
            this._showClearButton();
            this.fresh = false;
            const config = {
                limit: 1,
                language: [
                    this.options.language
                ],
                query: geojson.geometry.coordinates,
                types: [
                    "address"
                ]
            };
            if (this.options.localGeocoderOnly) {
                const text = geojson.geometry.coordinates[0] + ',' + geojson.geometry.coordinates[1];
                this._setInputValue(text);
                this._eventEmitter.emit('result', {
                    result: geojson
                });
            } else this.geocoderService.reverseGeocode(config).send().then((function(resp) {
                const feature = resp.body.features[0];
                if (feature) {
                    const locationText = $cf0ee618109f3bfd$exports.transformFeatureToGeolocationText(feature, this.options.addressAccuracy);
                    this._setInputValue(locationText);
                    feature.user_coordinates = geojson.geometry.coordinates;
                    this._eventEmitter.emit('result', {
                        result: feature
                    });
                } else this._eventEmitter.emit('result', {
                    result: {
                        user_coordinates: geojson.geometry.coordinates
                    }
                });
            }).bind(this));
        }).bind(this)).catch((function(error) {
            if (error.code === 1) this._renderUserDeniedGeolocationError();
            else this._renderLocationError();
            this._hideLoadingIcon();
            this._showGeolocateButton();
            this._hideAttribution();
        }).bind(this));
    },
    createIcon: function(name, path) {
        var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        icon.setAttribute('class', 'mapboxgl-ctrl-geocoder--icon mapboxgl-ctrl-geocoder--icon-' + name);
        icon.setAttribute('viewBox', '0 0 18 18');
        icon.setAttribute('xml:space', 'preserve');
        icon.setAttribute('width', 18);
        icon.setAttribute('height', 18);
        icon.innerHTML = path;
        return icon;
    },
    onRemove: function() {
        this.container.parentNode.removeChild(this.container);
        if (this.options.trackProximity && this._map) this._map.off('moveend', this._updateProximity);
        this._removeMarker();
        this._map = null;
        return this;
    },
    _setInputValue: function(value) {
        this._inputEl.value = value;
        setTimeout((function() {
            this._inputEl.focus();
            this._inputEl.scrollLeft = 0;
            this._inputEl.setSelectionRange(0, 0);
        }).bind(this), 1);
    },
    _onPaste: function(e) {
        var value = (e.clipboardData || window.clipboardData).getData('text');
        if (value.length >= this.options.minLength) this._geocode(value);
    },
    _onKeyDown: function(e) {
        var ESC_KEY_CODE = 27, TAB_KEY_CODE = 9;
        if (e.keyCode === ESC_KEY_CODE && this.options.clearAndBlurOnEsc) {
            this._clear(e);
            return this._inputEl.blur();
        }
        // if target has shadowRoot, then get the actual active element inside the shadowRoot
        var target = e.target && e.target.shadowRoot ? e.target.shadowRoot.activeElement : e.target;
        var value = target ? target.value : '';
        if (!value) {
            this.fresh = true;
            // the user has removed all the text
            if (e.keyCode !== TAB_KEY_CODE) this.clear(e);
            this._showGeolocateButton();
            return this._hideClearButton();
        }
        this._hideGeolocateButton();
        // TAB, ESC, LEFT, RIGHT, ENTER, UP, DOWN
        if (e.metaKey || [
            TAB_KEY_CODE,
            ESC_KEY_CODE,
            37,
            39,
            13,
            38,
            40
        ].indexOf(e.keyCode) !== -1) return;
        if (target.value.length >= this.options.minLength) this._geocode(target.value);
    },
    _showButton: function() {
        if (this._typeahead.selected) this._showClearButton();
    },
    _hideButton: function() {
        if (this._typeahead.selected) this._hideClearButton();
    },
    _showClearButton: function() {
        this._clearEl.style.display = 'block';
    },
    _hideClearButton: function() {
        this._clearEl.style.display = 'none';
    },
    _showGeolocateButton: function() {
        if (this._geolocateEl && this.geolocation.isSupport()) this._geolocateEl.style.display = 'block';
    },
    _hideGeolocateButton: function() {
        if (this._geolocateEl) this._geolocateEl.style.display = 'none';
    },
    _showLoadingIcon: function() {
        this._loadingEl.style.display = 'block';
    },
    _hideLoadingIcon: function() {
        this._loadingEl.style.display = 'none';
    },
    _showAttribution: function() {
        this._footerNode.style.display = 'block';
    },
    _hideAttribution: function() {
        this._footerNode.style.display = 'none';
    },
    _onBlur: function(e) {
        if (this.options.clearOnBlur) this._clearOnBlur(e);
        if (this.options.collapsed) this._collapse();
    },
    _onChange: function() {
        var selected = this._typeahead.selected;
        if (selected && JSON.stringify(selected) !== this.lastSelected) {
            this._hideClearButton();
            if (this.options.flyTo) this._fly(selected);
            if (this.options.marker && this._mapboxgl) this._handleMarker(selected);
            // After selecting a feature, re-focus the textarea and set
            // cursor at start.
            this._inputEl.focus();
            this._inputEl.scrollLeft = 0;
            this._inputEl.setSelectionRange(0, 0);
            this.lastSelected = JSON.stringify(selected);
            this._eventEmitter.emit('result', {
                result: selected
            });
            this.eventManager.select(selected, this);
        }
    },
    _fly: function(selected) {
        var flyOptions;
        if (selected.properties && $97c02c95601e1ba1$exports[selected.properties.short_code]) {
            // Certain geocoder search results return (and therefore zoom to fit)
            // an unexpectedly large bounding box: for example, both Russia and the
            // USA span both sides of -180/180, or France includes the island of
            // Reunion in the Indian Ocean. An incomplete list of these exceptions
            // at ./exceptions.json provides "reasonable" bounding boxes as a
            // short-term solution; this may be amended as necessary.
            flyOptions = $c61292941889f8f2$exports({}, this.options.flyTo);
            if (this._map) this._map.fitBounds($97c02c95601e1ba1$exports[selected.properties.short_code].bbox, flyOptions);
        } else if (selected.bbox) {
            var bbox = selected.bbox;
            flyOptions = $c61292941889f8f2$exports({}, this.options.flyTo);
            if (this._map) this._map.fitBounds([
                [
                    bbox[0],
                    bbox[1]
                ],
                [
                    bbox[2],
                    bbox[3]
                ]
            ], flyOptions);
        } else {
            var defaultFlyOptions = {
                zoom: this.options.zoom
            };
            flyOptions = $c61292941889f8f2$exports({}, defaultFlyOptions, this.options.flyTo);
            //  ensure that center is not overriden by custom options
            if (selected.center) flyOptions.center = selected.center;
            else if (selected.geometry && selected.geometry.type && selected.geometry.type === 'Point' && selected.geometry.coordinates) flyOptions.center = selected.geometry.coordinates;
            if (this._map) this._map.flyTo(flyOptions);
        }
    },
    _requestType: function(options, search) {
        var type;
        if (options.localGeocoderOnly) type = $614dc5797fe9f350$var$GEOCODE_REQUEST_TYPE.LOCAL;
        else if (options.reverseGeocode && $cf0ee618109f3bfd$exports.REVERSE_GEOCODE_COORD_RGX.test(search)) type = $614dc5797fe9f350$var$GEOCODE_REQUEST_TYPE.REVERSE;
        else type = $614dc5797fe9f350$var$GEOCODE_REQUEST_TYPE.FORWARD;
        return type;
    },
    _setupConfig: function(requestType, search) {
        // Possible config properties to pass to client
        const keys = [
            'bbox',
            'limit',
            'proximity',
            'countries',
            'types',
            'language',
            'reverseMode',
            'mode',
            'autocomplete',
            'fuzzyMatch',
            'routing',
            'worldview'
        ];
        const spacesOrCommaRgx = /[\s,]+/;
        var self = this;
        var config = keys.reduce(function(config, key) {
            // don't include undefined/null params, but allow boolean, among other, values
            if (self.options[key] === undefined || self.options[key] === null) return config;
            // countries, types, and language need to be passed in as arrays to client
            // https://github.com/mapbox/mapbox-sdk-js/blob/master/services/geocoding.js#L38-L47
            [
                'countries',
                'types',
                'language'
            ].indexOf(key) > -1 ? config[key] = self.options[key].split(spacesOrCommaRgx) : config[key] = self.options[key];
            const isCoordKey = typeof self.options[key].longitude === 'number' && typeof self.options[key].latitude === 'number';
            if (key === 'proximity' && isCoordKey) {
                const lng = self.options[key].longitude;
                const lat = self.options[key].latitude;
                config[key] = [
                    lng,
                    lat
                ];
            }
            return config;
        }, {});
        switch(requestType){
            case $614dc5797fe9f350$var$GEOCODE_REQUEST_TYPE.REVERSE:
                var coords = search.split(spacesOrCommaRgx).map(function(c) {
                    return parseFloat(c, 10);
                });
                if (!self.options.flipCoordinates) coords.reverse();
                // client only accepts one type for reverseGeocode, so
                // use first config type if one, if not default to poi
                config.types && config.types[0];
                config = $c61292941889f8f2$exports(config, {
                    query: coords,
                    limit: 1
                });
                // Remove config options not supported by the reverseGeocoder
                [
                    'proximity',
                    'autocomplete',
                    'fuzzyMatch',
                    'bbox'
                ].forEach(function(key) {
                    if (key in config) delete config[key];
                });
                break;
            case $614dc5797fe9f350$var$GEOCODE_REQUEST_TYPE.FORWARD:
                {
                    // Ensure that any reverse geocoding looking request is cleaned up
                    // to be processed as only a forward geocoding request by the server.
                    const trimmedSearch = search.trim();
                    const reverseGeocodeCoordRgx = /^(-?\d{1,3}(\.\d{0,256})?)[, ]+(-?\d{1,3}(\.\d{0,256})?)?$/;
                    if (reverseGeocodeCoordRgx.test(trimmedSearch)) search = search.replace(/,/g, ' ');
                    config = $c61292941889f8f2$exports(config, {
                        query: search
                    });
                }
                break;
        }
        config.session_token = this.eventManager.getSessionId();
        return config;
    },
    _geocode: function(searchInput) {
        this.inputString = searchInput;
        this._showLoadingIcon();
        this._eventEmitter.emit('loading', {
            query: searchInput
        });
        const requestType = this._requestType(this.options, searchInput);
        const config = this._setupConfig(requestType, searchInput);
        var request;
        switch(requestType){
            case $614dc5797fe9f350$var$GEOCODE_REQUEST_TYPE.LOCAL:
                request = Promise.resolve();
                break;
            case $614dc5797fe9f350$var$GEOCODE_REQUEST_TYPE.FORWARD:
                request = this.geocoderService.forwardGeocode(config).send();
                break;
            case $614dc5797fe9f350$var$GEOCODE_REQUEST_TYPE.REVERSE:
                request = this.geocoderService.reverseGeocode(config).send();
                break;
        }
        var localGeocoderRes = this.options.localGeocoder ? this.options.localGeocoder(searchInput) || [] : [];
        var externalGeocoderRes = [];
        var geocoderError = null;
        request.catch((function(error) {
            geocoderError = error;
        }).bind(this)).then((function(response) {
            this._hideLoadingIcon();
            var res = {};
            if (!response) res = {
                type: 'FeatureCollection',
                features: []
            };
            else if (response.statusCode == '200') {
                res = response.body;
                res.request = response.request;
                res.headers = response.headers;
                this._headers = response.headers;
            }
            res.config = config;
            if (this.fresh) {
                this.eventManager.start(this);
                this.fresh = false;
            }
            // Tag Mapbox as the source for Geocoding API results, to differentiate from local or external geocoder federated results
            if (res.features && res.features.length) res.features.map(function(feature) {
                feature._source = 'mapbox';
            });
            // supplement Mapbox Geocoding API results with locally populated results
            res.features = res.features ? localGeocoderRes.concat(res.features) : localGeocoderRes;
            if (this.options.externalGeocoder) {
                externalGeocoderRes = this.options.externalGeocoder(searchInput, res.features) || Promise.resolve([]);
                // supplement Mapbox Geocoding API results with features returned by a promise
                return externalGeocoderRes.then(function(features) {
                    res.features = res.features ? features.concat(res.features) : features;
                    return res;
                }, function() {
                    // on error, display the original result
                    return res;
                });
            }
            return res;
        }).bind(this)).then((function(res) {
            if (geocoderError) throw geocoderError;
            // apply results filter if provided
            if (this.options.filter && res.features.length) res.features = res.features.filter(this.options.filter);
            if (res.features.length) {
                this._showClearButton();
                this._hideGeolocateButton();
                this._showAttribution();
                this._eventEmitter.emit('results', res);
                this._typeahead.update(res.features);
            } else {
                this._hideClearButton();
                this._hideAttribution();
                this._typeahead.selected = null;
                this._renderNoResults();
                this._eventEmitter.emit('results', res);
            }
        }).bind(this)).catch((function(err) {
            this._hideLoadingIcon();
            this._hideAttribution();
            // in the event of an error in the Mapbox Geocoding API still display results from the localGeocoder
            if (localGeocoderRes.length && this.options.localGeocoder || externalGeocoderRes.length && this.options.externalGeocoder) {
                this._showClearButton();
                this._hideGeolocateButton();
                this._typeahead.update(localGeocoderRes);
            } else {
                this._hideClearButton();
                this._typeahead.selected = null;
                this._renderError();
            }
            this._eventEmitter.emit('results', {
                features: localGeocoderRes
            });
            this._eventEmitter.emit('error', {
                error: err
            });
        }).bind(this));
        return request;
    },
    /**
   * Shared logic for clearing input
   * @param {Event} [ev] the event that triggered the clear, if available
   * @private
   *
   */ _clear: function(ev) {
        if (ev) ev.preventDefault();
        this._inputEl.value = '';
        this._typeahead.selected = null;
        this._typeahead.clear();
        this.eventManager.sessionIncrementer++;
        this._onChange();
        this._hideClearButton();
        this._showGeolocateButton();
        this._removeMarker();
        this.lastSelected = null;
        this._eventEmitter.emit('clear');
        this.fresh = true;
    },
    /**
   * Clear and then focus the input.
   * @param {Event} [ev] the event that triggered the clear, if available
   *
   */ clear: function(ev) {
        this._clear(ev);
        this._inputEl.focus();
        // We don't hide on blur when using browser focus
        // because the list is hidden on blur by default.
        // So we hide it here manually.
        if (this.options.useBrowserFocus) this._typeahead.list.hide();
    },
    /**
   * Clear the input, without refocusing it. Used to implement clearOnBlur
   * constructor option.
   * @param {Event} [ev] the blur event
   * @private
   */ _clearOnBlur: function(ev) {
        var ctx = this;
        /*
     * If relatedTarget is not found, assume user targeted the suggestions list.
     * In that case, do not clear on blur. There are other edge cases where
     * ev.relatedTarget could be null. Clicking on list always results in null
     * relatedtarget because of upstream behavior in `suggestions`.
     *
     * The ideal solution would be to check if ev.relatedTarget is a child of
     * the list. See issue #258 for details on why we can't do that yet.
     */ if (ev.relatedTarget) ctx._clear(ev);
    },
    _onQueryResult: function(response) {
        var results = response.body;
        if (!results.features.length) return;
        var result = results.features[0];
        this._typeahead.selected = result;
        this._inputEl.value = result.place_name;
        this._onChange();
    },
    _updateProximity: function() {
        // proximity is designed for local scale, if the user is looking at the whole world,
        // it doesn't make sense to factor in the arbitrary centre of the map
        if (!this._map || !this.options.trackProximity) return;
        if (this._map.getZoom() > 9) {
            var center = this._map.getCenter().wrap();
            this.setProximity({
                longitude: center.lng,
                latitude: center.lat
            }, false);
        } else this.setProximity(null, false);
    },
    _collapse: function() {
        // do not collapse if input is in focus
        if (!this._inputEl.value && this._inputEl !== document.activeElement) this.container.classList.add('mapboxgl-ctrl-geocoder--collapsed');
    },
    _unCollapse: function() {
        this.container.classList.remove('mapboxgl-ctrl-geocoder--collapsed');
    },
    /**
   * Set & query the input
   * @param {string} searchInput location name or other search input
   * @returns {MapboxGeocoder} this
   */ query: function(searchInput) {
        this._geocode(searchInput).then(this._onQueryResult);
        return this;
    },
    _renderError: function() {
        var errorMessage = "<div class='mapbox-gl-geocoder--error'>There was an error reaching the server</div>";
        this._renderMessage(errorMessage);
    },
    _renderLocationError: function() {
        var errorMessage = "<div class='mapbox-gl-geocoder--error'>A location error has occurred</div>";
        this._renderMessage(errorMessage);
    },
    _renderNoResults: function() {
        var errorMessage = "<div class='mapbox-gl-geocoder--error mapbox-gl-geocoder--no-results'>No results found</div>";
        this._renderMessage(errorMessage);
    },
    _renderUserDeniedGeolocationError: function() {
        var errorMessage = "<div class='mapbox-gl-geocoder--error'>Geolocation permission denied</div>";
        this._renderMessage(errorMessage);
    },
    _renderMessage: function(msg) {
        this._typeahead.update([]);
        this._typeahead.selected = null;
        this._typeahead.clear();
        this._typeahead.renderError(msg);
    },
    /**
   * Get the text to use as the search bar placeholder
   *
   * If placeholder is provided in options, then use options.placeholder
   * Otherwise, if language is provided in options, then use the localized string of the first language if available
   * Otherwise use the default
   *
   * @returns {String} the value to use as the search bar placeholder
   * @private
   */ _getPlaceholderText: function() {
        if (this.options.placeholder) return this.options.placeholder;
        if (this.options.language) {
            var firstLanguage = this.options.language.split(",")[0];
            var language = $18f2a2b049f8f8d3$exports.language(firstLanguage);
            var localizedValue = $96c6bfdf991addc9$exports.placeholder[language];
            if (localizedValue) return localizedValue;
        }
        return 'Search';
    },
    /**
   * Set input
   * @param {string} searchInput location name or other search input
   * @param {boolean} [showSuggestions=false] display suggestion on setInput call
   * @returns {MapboxGeocoder} this
   */ setInput: function(searchInput, showSuggestions) {
        if (showSuggestions === undefined) showSuggestions = false;
        // Set input value to passed value and clear everything else.
        this._inputEl.value = searchInput;
        this._typeahead.selected = null;
        this._typeahead.clear();
        if (searchInput.length >= this.options.minLength) showSuggestions ? this._geocode(searchInput) : this._onChange();
        return this;
    },
    /**
   * Set proximity
   * @param {Object|'ip'} proximity The new `options.proximity` value. This is a geographical point given as an object with `latitude` and `longitude` properties or the string 'ip'.
   * @param {Boolean} disableTrackProximity If true, sets `trackProximity` to false. True by default to prevent `trackProximity` from unintentionally overriding an explicitly set proximity value.
   * @returns {MapboxGeocoder} this
   */ setProximity: function(proximity, disableTrackProximity = true) {
        this.options.proximity = proximity;
        if (disableTrackProximity) this.options.trackProximity = false;
        return this;
    },
    /**
   * Get proximity
   * @returns {Object} The geocoder proximity
   */ getProximity: function() {
        return this.options.proximity;
    },
    /**
   * Set the render function used in the results dropdown
   * @param {Function} fn The function to use as a render function. This function accepts a single [extended GeoJSON](https://docs.mapbox.com/api/search/geocoding-v5/#geocoding-response-object) object as input and returns a string. If `fn` is not a function, the default render function is used.
   * @returns {MapboxGeocoder} this
   */ setRenderFunction: function(fn) {
        // Fall back to the escaping default: keeping the suggestions library's own renderer would inject place_name unescaped
        this._typeahead.render = typeof fn === 'function' ? fn : $614dc5797fe9f350$var$MapboxGeocoder.prototype.options.render;
        return this;
    },
    /**
   * Get the function used to render the results dropdown
   *
   * @returns {Function} the render function
   */ getRenderFunction: function() {
        return this._typeahead.render;
    },
    /**
   * Get the language to use in UI elements and when making search requests
   *
   * Look first at the explicitly set options otherwise use the browser's language settings
   * @param {String} language Specify the language to use for response text and query result weighting. Options are IETF language tags comprised of a mandatory ISO 639-1 language code and optionally one or more IETF subtags for country or script. More than one value can also be specified, separated by commas.
   * @returns {MapboxGeocoder} this
   */ setLanguage: function(language) {
        var browserLocale = navigator.language || navigator.userLanguage || navigator.browserLanguage;
        this.options.language = language || this.options.language || browserLocale;
        return this;
    },
    /**
   * Get the language to use in UI elements and when making search requests
   * @returns {String} The language(s) used by the plugin, if any
   */ getLanguage: function() {
        return this.options.language;
    },
    /**
   * Get the zoom level the map will move to when there is no bounding box on the selected result
   * @returns {Number} the map zoom
   */ getZoom: function() {
        return this.options.zoom;
    },
    /**
   * Set the zoom level
   * @param {Number} zoom The zoom level that the map should animate to when a `bbox` isn't found in the response. If a `bbox` is found the map will fit to the `bbox`.
   * @returns {MapboxGeocoder} this
   */ setZoom: function(zoom) {
        this.options.zoom = zoom;
        return this;
    },
    /**
   * Get the parameters used to fly to the selected response, if any
   * @returns {Boolean|Object} The `flyTo` option
   */ getFlyTo: function() {
        return this.options.flyTo;
    },
    /**
   * Set the flyTo options
   * @param {Boolean|Object} flyTo If false, animating the map to a selected result is disabled. If true, animating the map will use the default animation parameters. If an object, it will be passed as `options` to the map [`flyTo`](https://docs.mapbox.com/mapbox-gl-js/api/#map#flyto) or [`fitBounds`](https://docs.mapbox.com/mapbox-gl-js/api/#map#fitbounds) method providing control over the animation of the transition.
   */ setFlyTo: function(flyTo) {
        this.options.flyTo = flyTo;
        return this;
    },
    /**
   * Get the value of the placeholder string
   * @returns {String} The input element's placeholder value
   */ getPlaceholder: function() {
        return this.options.placeholder;
    },
    /**
   * Set the value of the input element's placeholder
   * @param {String} placeholder the text to use as the input element's placeholder
   * @returns {MapboxGeocoder} this
   */ setPlaceholder: function(placeholder) {
        this.options.placeholder = placeholder ? placeholder : this._getPlaceholderText();
        this._inputEl.placeholder = this.options.placeholder;
        this._inputEl.setAttribute('aria-label', this.options.placeholder);
        return this;
    },
    /**
   * Get the bounding box used by the plugin
   * @returns {Array<Number>} the bounding box, if any
   */ getBbox: function() {
        return this.options.bbox;
    },
    /**
   * Set the bounding box to limit search results to
   * @param {Array<Number>} bbox a bounding box given as an array in the format [minX, minY, maxX, maxY].
   * @returns {MapboxGeocoder} this
   */ setBbox: function(bbox) {
        this.options.bbox = bbox;
        return this;
    },
    /**
   * Get a list of the countries to limit search results to
   * @returns {String} a comma separated list of countries to limit to, if any
   */ getCountries: function() {
        return this.options.countries;
    },
    /**
   * Set the countries to limit search results to
   * @param {String} countries a comma separated list of countries to limit to
   * @returns {MapboxGeocoder} this
   */ setCountries: function(countries) {
        this.options.countries = countries;
        return this;
    },
    /**
   * Get a list of the types to limit search results to
   * @returns {String} a comma separated list of types to limit to
   */ getTypes: function() {
        return this.options.types;
    },
    /**
   * Set the types to limit search results to
   * @param {String} countries a comma separated list of types to limit to
   * @returns {MapboxGeocoder} this
   */ setTypes: function(types) {
        this.options.types = types;
        return this;
    },
    /**
   * Get the minimum number of characters typed to trigger results used in the plugin
   * @returns {Number} The minimum length in characters before a search is triggered
   */ getMinLength: function() {
        return this.options.minLength;
    },
    /**
   * Set the minimum number of characters typed to trigger results used by the plugin
   * @param {Number} minLength the minimum length in characters
   * @returns {MapboxGeocoder} this
   */ setMinLength: function(minLength) {
        this.options.minLength = minLength;
        if (this._typeahead) this._typeahead.options.minLength = minLength;
        return this;
    },
    /**
   * Get the limit value for the number of results to display used by the plugin
   * @returns {Number} The limit value for the number of results to display used by the plugin
   */ getLimit: function() {
        return this.options.limit;
    },
    /**
   * Set the limit value for the number of results to display used by the plugin
   * @param {Number} limit the number of search results to return
   * @returns {MapboxGeocoder}
   */ setLimit: function(limit) {
        this.options.limit = limit;
        if (this._typeahead) this._typeahead.options.limit = limit;
        return this;
    },
    /**
   * Get the filter function used by the plugin
   * @returns {Function} the filter function
   */ getFilter: function() {
        return this.options.filter;
    },
    /**
   * Set the filter function used by the plugin.
   * @param {Function} filter A function which accepts a Feature in the [extended GeoJSON](https://docs.mapbox.com/api/search/geocoding-v5/#geocoding-response-object) format to filter out results from the Geocoding API response before they are included in the suggestions list. Return `true` to keep the item, `false` otherwise.
   * @returns {MapboxGeocoder} this
   */ setFilter: function(filter) {
        this.options.filter = filter;
        return this;
    },
    /**
   * Set the geocoding endpoint used by the plugin.
   * @param {Function} origin A function which accepts an HTTPS URL to specify the endpoint to query results from.
   * @returns {MapboxGeocoder} this
   */ setOrigin: function(origin) {
        this.options.origin = origin;
        this.geocoderService = $d4053cad85b8db5c$exports($74e8675559d59e8a$exports({
            accessToken: this.options.accessToken,
            origin: this.options.origin
        }));
        return this;
    },
    /**
   * Get the geocoding endpoint the plugin is currently set to
   * @returns {Function} the endpoint URL
   */ getOrigin: function() {
        return this.options.origin;
    },
    /**
   * Set the accessToken option used for the geocoding request endpoint.
   * @param {String} accessToken value
   * @returns {MapboxGeocoder} this
   */ setAccessToken: function(accessToken) {
        this.options.accessToken = accessToken;
        this.geocoderService = $d4053cad85b8db5c$exports($74e8675559d59e8a$exports({
            accessToken: this.options.accessToken,
            origin: this.options.origin
        }));
        return this;
    },
    /**
   * Set the autocomplete option used for geocoding requests
   * @param {Boolean} value The boolean value to set autocomplete to
   * @returns
   */ setAutocomplete: function(value) {
        this.options.autocomplete = value;
        return this;
    },
    /**
   * Get the current autocomplete parameter value used for requests
   * @returns {Boolean} The autocomplete parameter value
   */ getAutocomplete: function() {
        return this.options.autocomplete;
    },
    /**
   * Set the fuzzyMatch option used for approximate matching in geocoding requests
   * @param {Boolean} value The boolean value to set fuzzyMatch to
   * @returns
   */ setFuzzyMatch: function(value) {
        this.options.fuzzyMatch = value;
        return this;
    },
    /**
   * Get the current fuzzyMatch parameter value used for requests
   * @returns {Boolean} The fuzzyMatch parameter value
   */ getFuzzyMatch: function() {
        return this.options.fuzzyMatch;
    },
    /**
   * Set the routing parameter used to ask for routable point metadata in geocoding requests
   * @param {Boolean} value The boolean value to set routing to
   * @returns
   */ setRouting: function(value) {
        this.options.routing = value;
        return this;
    },
    /**
   * Get the current routing parameter value used for requests
   * @returns {Boolean} The routing parameter value
   */ getRouting: function() {
        return this.options.routing;
    },
    /**
   * Set the worldview parameter
   * @param {String} code The country code representing the worldview (e.g. "us" | "cn" | "jp", "in")
   * @returns
   */ setWorldview: function(code) {
        this.options.worldview = code;
        return this;
    },
    /**
   * Get the current worldview parameter value used for requests
   * @returns {String} The worldview parameter value
   */ getWorldview: function() {
        return this.options.worldview;
    },
    /**
   * Handle the placement of a result marking the selected result
   * @private
   * @param {Object} selected the selected geojson feature
   * @returns {MapboxGeocoder} this
   */ _handleMarker: function(selected) {
        // clean up any old marker that might be present
        if (!this._map) return;
        this._removeMarker();
        var defaultMarkerOptions = {
            color: '#4668F2'
        };
        var markerOptions = $c61292941889f8f2$exports({}, defaultMarkerOptions, this.options.marker);
        this.mapMarker = new this._mapboxgl.Marker(markerOptions);
        if (selected.center) this.mapMarker.setLngLat(selected.center).addTo(this._map);
        else if (selected.geometry && selected.geometry.type && selected.geometry.type === 'Point' && selected.geometry.coordinates) this.mapMarker.setLngLat(selected.geometry.coordinates).addTo(this._map);
        return this;
    },
    /**
   * Handle the removal of a result marker
   * @private
   */ _removeMarker: function() {
        if (this.mapMarker) {
            this.mapMarker.remove();
            this.mapMarker = null;
        }
    },
    /**
   * Subscribe to events that happen within the plugin.
   * @param {String} type name of event. Available events and the data passed into their respective event objects are:
   *
   * - __clear__ `Emitted when the input is cleared`
   * - __loading__ `{ query } Emitted when the geocoder is looking up a query`
   * - __results__ `{ results } Fired when the geocoder returns a response`
   * - __result__ `{ result } Fired when input is set`
   * - __error__ `{ error } Error as string`
   * @param {Function} fn function that's called when the event is emitted.
   * @returns {MapboxGeocoder} this;
   */ on: function(type, fn) {
        this._eventEmitter.on(type, fn);
        return this;
    },
    /**
   * Remove an event
   * @returns {MapboxGeocoder} this
   * @param {String} type Event name.
   * @param {Function} fn Function that should unsubscribe to the event emitted.
   */ off: function(type, fn) {
        this._eventEmitter.removeListener(type, fn);
        this.eventManager.remove();
        return this;
    }
};
$614dc5797fe9f350$exports = $614dc5797fe9f350$var$MapboxGeocoder;



const $84445ff85310bd17$var$ControlGeocoder = ({ accessToken: accessToken, position: position = 'top-left' })=>{
    (0, $546917c3aede178b$export$62ad9a427fe0e7c8)(()=>new (0, (/*@__PURE__*/$parcel$interopDefault($614dc5797fe9f350$exports)))({
            accessToken: accessToken,
            mapboxgl: (/*@__PURE__*/$parcel$interopDefault($f2WZf)),
            marker: false,
            countries: 'es'
        }), {
        position: position
    });
    return null;
};
var $84445ff85310bd17$export$2e2bcd8739ae039 = $84445ff85310bd17$var$ControlGeocoder;




var $dbb0b136ea8dbb29$exports = {};

$parcel$export($dbb0b136ea8dbb29$exports, "container", () => $dbb0b136ea8dbb29$export$34e0f9847d4c02dd, (v) => $dbb0b136ea8dbb29$export$34e0f9847d4c02dd = v);
$parcel$export($dbb0b136ea8dbb29$exports, "fila", () => $dbb0b136ea8dbb29$export$9db2e79d96753b57, (v) => $dbb0b136ea8dbb29$export$9db2e79d96753b57 = v);
$parcel$export($dbb0b136ea8dbb29$exports, "serveis", () => $dbb0b136ea8dbb29$export$74cefb0dad51fb69, (v) => $dbb0b136ea8dbb29$export$74cefb0dad51fb69 = v);
$parcel$export($dbb0b136ea8dbb29$exports, "tipologia", () => $dbb0b136ea8dbb29$export$ade06f9049e74c0f, (v) => $dbb0b136ea8dbb29$export$ade06f9049e74c0f = v);
var $dbb0b136ea8dbb29$export$34e0f9847d4c02dd;
var $dbb0b136ea8dbb29$export$9db2e79d96753b57;
var $dbb0b136ea8dbb29$export$74cefb0dad51fb69;
var $dbb0b136ea8dbb29$export$ade06f9049e74c0f;
$dbb0b136ea8dbb29$export$34e0f9847d4c02dd = `YZIJlW_container`;
$dbb0b136ea8dbb29$export$9db2e79d96753b57 = `YZIJlW_fila`;
$dbb0b136ea8dbb29$export$74cefb0dad51fb69 = `YZIJlW_serveis`;
$dbb0b136ea8dbb29$export$ade06f9049e74c0f = `YZIJlW_tipologia`;


function $608c55396029632e$export$2e2bcd8739ae039({ refugi: refugi, onClose: onClose, textos: textos }) {
    const formatTipologia = (tipologia)=>{
        if (!tipologia) return null;
        const valorNet = tipologia.startsWith('_') ? tipologia.slice(1) : tipologia;
        return valorNet.charAt(0).toUpperCase() + valorNet.slice(1);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $01b7fef3c5ac1f78$export$129a32eedafa97c5), {
        longitude: refugi.longitude,
        latitude: refugi.latitude,
        anchor: "bottom",
        onClose: onClose,
        closeOnClick: false,
        closeButton: false,
        style: {
            maxWidth: 'none',
            width: 'auto',
            padding: '0px'
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($dbb0b136ea8dbb29$exports))).container,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("header", {
                    children: refugi.nom
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($dbb0b136ea8dbb29$exports))).fila,
                    children: [
                        refugi.adreca && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: refugi.adreca
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: refugi.municipi
                        })
                    ]
                }),
                refugi.tipologia && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($dbb0b136ea8dbb29$exports))).tipologia,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: textos.tipus_refugi
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: formatTipologia(refugi.tipologia)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($dbb0b136ea8dbb29$exports))).serveis,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: textos.label_serveis
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                            children: [
                                refugi?.accessibilitat && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    children: "Accessible"
                                }),
                                refugi?.aigua && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    children: "Aigua potable"
                                }),
                                refugi?.climatitzacio && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    children: "Climatitzaci\xf3"
                                }),
                                refugi?.area_descans && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    children: "\xc0rea de descans"
                                }),
                                refugi?.lavabo && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    children: "Lavabos"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");
var $579f6fe04e2547c5$exports = {};

$parcel$export($579f6fe04e2547c5$exports, "icon", () => $579f6fe04e2547c5$export$1ca1ec8b29a4ce27, (v) => $579f6fe04e2547c5$export$1ca1ec8b29a4ce27 = v);
$parcel$export($579f6fe04e2547c5$exports, "multiSelect", () => $579f6fe04e2547c5$export$995d6bb4ae2d97fb, (v) => $579f6fe04e2547c5$export$995d6bb4ae2d97fb = v);
$parcel$export($579f6fe04e2547c5$exports, "obert", () => $579f6fe04e2547c5$export$e0f96e9264c73608, (v) => $579f6fe04e2547c5$export$e0f96e9264c73608 = v);
$parcel$export($579f6fe04e2547c5$exports, "opcio", () => $579f6fe04e2547c5$export$d99470ff49267b4b, (v) => $579f6fe04e2547c5$export$d99470ff49267b4b = v);
$parcel$export($579f6fe04e2547c5$exports, "options", () => $579f6fe04e2547c5$export$41c562ebe57d11e2, (v) => $579f6fe04e2547c5$export$41c562ebe57d11e2 = v);
$parcel$export($579f6fe04e2547c5$exports, "trigger", () => $579f6fe04e2547c5$export$e614dc9140f7ae71, (v) => $579f6fe04e2547c5$export$e614dc9140f7ae71 = v);
var $579f6fe04e2547c5$export$1ca1ec8b29a4ce27;
var $579f6fe04e2547c5$export$995d6bb4ae2d97fb;
var $579f6fe04e2547c5$export$e0f96e9264c73608;
var $579f6fe04e2547c5$export$d99470ff49267b4b;
var $579f6fe04e2547c5$export$41c562ebe57d11e2;
var $579f6fe04e2547c5$export$e614dc9140f7ae71;
$579f6fe04e2547c5$export$1ca1ec8b29a4ce27 = `Wua4ia_icon`;
$579f6fe04e2547c5$export$995d6bb4ae2d97fb = `Wua4ia_multiSelect`;
$579f6fe04e2547c5$export$e0f96e9264c73608 = `Wua4ia_obert`;
$579f6fe04e2547c5$export$d99470ff49267b4b = `Wua4ia_opcio`;
$579f6fe04e2547c5$export$41c562ebe57d11e2 = `Wua4ia_options`;
$579f6fe04e2547c5$export$e614dc9140f7ae71 = `Wua4ia_trigger`;


function $992637f4e08c587e$export$2e2bcd8739ae039({ lang: lang, textos: textos, canonics: canonics, canonicsSeleccionats: canonicsSeleccionats, totsSeleccionats: totsSeleccionats, configuracioTipologies: configuracioTipologies, onReset: onReset, onToggle: onToggle }) {
    const containerRef = (0, $acw62.useRef)(null);
    const [obert, setObert] = (0, $acw62.useState)(false);
    const getNomCanonic = (canonic)=>configuracioTipologies?.[canonic]?.nom || canonic;
    const resumTipologies = (0, $acw62.useMemo)(()=>{
        if (totsSeleccionats) return textos[lang]?.tots || 'Totes';
        if (canonicsSeleccionats.length === 0) return textos[lang]?.selecciona_tipologia || 'Selecciona tipologies';
        if (canonicsSeleccionats.length === 1) return getNomCanonic(canonicsSeleccionats[0]);
        return `${canonicsSeleccionats.length} ${textos[lang]?.tipologies_seleccionades || 'tipologies seleccionades'}`;
    }, [
        canonicsSeleccionats,
        lang,
        textos,
        totsSeleccionats
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleClickFora = (event)=>{
            if (!containerRef.current?.contains(event.target)) setObert(false);
        };
        const handleEscape = (event)=>{
            if (event.key === 'Escape') setObert(false);
        };
        document.addEventListener('pointerdown', handleClickFora);
        document.addEventListener('keydown', handleEscape);
        return ()=>{
            document.removeEventListener('pointerdown', handleClickFora);
            document.removeEventListener('keydown', handleEscape);
        };
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($579f6fe04e2547c5$exports))).multiSelect} ${obert ? (0, (/*@__PURE__*/$parcel$interopDefault($579f6fe04e2547c5$exports))).obert : ''}`,
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($579f6fe04e2547c5$exports))).trigger,
                onClick: ()=>setObert((actual)=>!actual),
                "aria-haspopup": "listbox",
                "aria-expanded": obert,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: resumTipologies
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($579f6fe04e2547c5$exports))).icon,
                        "aria-hidden": "true",
                        width: "18",
                        height: "18",
                        viewBox: "0 0 18 18",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                clipPath: "url(#clip0_2974_1556)",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M12.4425 6.44238L9 9.87738L5.5575 6.44238L4.5 7.49988L9 11.9999L13.5 7.49988L12.4425 6.44238Z",
                                    fill: "black"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                                    id: "clip0_2974_1556",
                                    clipPathUnits: "userSpaceOnUse",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                        width: "18",
                                        height: "18",
                                        fill: "white"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($579f6fe04e2547c5$exports))).options,
                role: "listbox",
                "aria-multiselectable": "true",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($579f6fe04e2547c5$exports))).opcio,
                        role: "option",
                        "aria-selected": totsSeleccionats,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "checkbox",
                                checked: totsSeleccionats,
                                onChange: onReset
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: textos[lang]?.tots || 'Totes'
                            })
                        ]
                    }),
                    canonics.map((canonic)=>{
                        const seleccionat = canonicsSeleccionats.includes(canonic);
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($579f6fe04e2547c5$exports))).opcio,
                            role: "option",
                            "aria-selected": seleccionat,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "checkbox",
                                    checked: seleccionat,
                                    onChange: ()=>onToggle(canonic)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: getNomCanonic(canonic)
                                })
                            ]
                        }, canonic);
                    })
                ]
            })
        ]
    });
}


var $3192dd7d0768a102$exports = {};
$3192dd7d0768a102$exports = JSON.parse('[{":id":"row-b3iy-7srj-rkd8",":version":"rv-vf86_xyaf-d6q8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina d\'estiu d\'Abrera","indicador_refugi":"080018|PISCINA_D_ESTIU_D_ABRERA","municipi":"Abrera","codi_municipi":"080018","latitud":"41.51957423","longitud":"1.90278811","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. de l\'Esgl\xe8sia","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-j3tp~a9gp_mx9u",":version":"rv-hetd_xkiv_39q6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa de Cultura","indicador_refugi":"080018|CASA_DE_CULTURA","municipi":"Abrera","codi_municipi":"080018","latitud":"41.521503","longitud":"1.901389","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ Federico Garc\xeda Lorca, n\xfam. 17","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-15T12:12:00.000"},{":id":"row-aiua.j38w.cuxu",":version":"rv-yj5n~5mhi.vy4f",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal d\'Avis","indicador_refugi":"080018|CASAL_DAVIS","municipi":"Abrera","codi_municipi":"080018","latitud":"41.517303","longitud":"1.900264","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ Rosers, n\xfam. 11","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-15T12:14:00.000"},{":id":"row-pxwm.f3ng.rvws",":version":"rv-9b3b-7vnw-tt6c",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia Canig\xf3","indicador_refugi":"080018|RESIDENCIA_CANIGO","municipi":"Abrera","codi_municipi":"080018","latitud":"41.521033","longitud":"1.905128","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ Menorca, n\xfam. 16","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-15T12:16:00.000"},{":id":"row-nvjk~ccgh-85ae",":version":"rv-z2hn.wjer_xewq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Am\xe8lia Claverol","indicador_refugi":"250024|BIBLIOTECA_AMELIA_CLAVEROL","municipi":"\xc0ger","codi_municipi":"250024","latitud":"41.99888810552947","longitud":"0.7632239186358284","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/Sant Mart\xed n\xba9 d\'\xc0ger","informacio_web":"https://www.ager.cat/el-municipi/biblioteca-i-punt-tic","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-09T12:38:00.000"},{":id":"row-h34k_6342.fmqm",":version":"rv-3yjn~v7yg-g8wf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament","indicador_refugi":"250024|AJUNTAMENT","municipi":"\xc0ger","codi_municipi":"250024","latitud":"41.99917314744526","longitud":"0.7636383199423508","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Major 1","informacio_web":"www.ager.cat","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-09T12:39:00.000"},{":id":"row-nchv~fmic_cimh",":version":"rv-sxy3.mrc8-eg9h",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina","indicador_refugi":"250024|PISCINA","municipi":"\xc0ger","codi_municipi":"250024","latitud":"42.003047242017686","longitud":"0.7656257257316074","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/del Cos s/n","informacio_web":"www.ager.cat","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-09T12:43:00.000"},{":id":"row-hqx8~7245_cxyu",":version":"rv-scpi-42xm~q7y9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa del Montsec","indicador_refugi":"250024|CASA_DEL_MONTSEC","municipi":"\xc0ger","codi_municipi":"250024","latitud":"42.00242270075832","longitud":"0.7587987192880282","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"No","adreca":"C/Calvari sn","informacio_web":"www.turismeager.cat","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-09T12:46:00.000"},{":id":"row-jjjt-ci3t~3rt5",":version":"rv-agjz.fqa9~sv5j",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"ESPAI C\xcdVIC D\'AGRAMUNT","indicador_refugi":"250030|ESPAI_CIVIC_DAGRAMUNT","municipi":"Agramunt","codi_municipi":"250030","latitud":"41.781815","longitud":"1.0989","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. ENSENYAMENT, 17","informacio_web":"agramunt.cat   (dilluns 15:00 a 20:00 - dimarts, dimecres, dijous i divendres 09:00 a 12:00h i de 15:00 a 20:00h)","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-22T14:55:00.000"},{":id":"row-x6iu~gte3~zqrh",":version":"rv-7qc2-sxse-tfga",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"BIBLIOTECA MUNICIPAL GUILLEM VILADOT","indicador_refugi":"250030|BIBLIOTECA_MUNICIPAL_GUILLEM_VILADOT","municipi":"Agramunt","codi_municipi":"250030","latitud":"41.785954","longitud":"1.099161","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"PL. MERCADAL, 7","informacio_web":"agramunt.cat (HORARI HIVERN Matins: dimecres, divendres i dissabte de 9 a 13h Tardes: de dilluns a divendres de 16.00 a 20.00h HORARI ESTIU (del 15 de juny al 15 de setembre) Matins: de dilluns a divendres de 9 a 13h Tardes: dimarts i dijous de 17.00 a 20.00h)","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-22T14:59:00.000"},{":id":"row-vuex.euu6_87v8",":version":"rv-raax~92bf.cb2r",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal d\'Aiguafreda","indicador_refugi":"080142|PISCINA_MUNICIPAL_D_AIGUAFREDA","municipi":"Aiguafreda","codi_municipi":"080142","latitud":"41.7704127","longitud":"2.25046554","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Nostra Senyora de N\xfaria, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-zet2.w67h.q4jc",":version":"rv-z2jp~rtg7~vtgv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"430017|PISCINA_MUNICIPAL","municipi":"Aiguam\xfarcia","codi_municipi":"430017","latitud":"41.34122395","longitud":"1.36192448","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Plana del Moli","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-7r6j~95wb~edcw",":version":"rv-7q8s~2ci4~q3pp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local Cultural \\"Ca la Neus\\"","indicador_refugi":"170025|LOCAL_CULTURAL_\\"CA_LA_NEUS\\"","municipi":"Aiguaviva","codi_municipi":"170025","latitud":"41.93824339853728","longitud":"2.7619074175520324","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a de l\'u d\'octubre n\xfam. 2","informacio_web":"horari d\'obertura de 10h a 14h","tipologia":"Equipament Cultural (teatre, auditori, museu)","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-09T13:49:00.000"},{":id":"row-pd7t.rz8v.zzfu",":version":"rv-hnms.87hn-phzc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Poliesportiu","indicador_refugi":"250387|POLIESPORTIU","municipi":"Aitona","codi_municipi":"250387","latitud":"41.49146158","longitud":"0.45956051","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Joan XXIII, s/n","tipologia":"Poliesportiu","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-d3dg.v24p.ur2v",":version":"rv-weuv_6amc~uj3q",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Llar de jubilats Sant Josep","indicador_refugi":"250083|LLAR_DE_JUBILATS_SANT_JOSEP","municipi":"Albesa","codi_municipi":"250083","latitud":"41.751902","longitud":"0.6572","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ La creu 13-15","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T10:02:00.000"},{":id":"row-nqaj-v3ub_zddm",":version":"rv-qa7f.6r2p.sp9h",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala polivalent","indicador_refugi":"170046|SALA_POLIVALENT","municipi":"Albons","codi_municipi":"170046","latitud":"42.10232719","longitud":"3.08330863","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Tor, 1","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-hjba_6qhm_v3jd",":version":"rv-n96z.5zj2-3bkq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala de ball","indicador_refugi":"170046|SALA_DE_BALL","municipi":"Albons","codi_municipi":"170046","latitud":"42.1030954","longitud":"3.08599195","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. dels donants, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-be77~q4bz_q5ww",":version":"rv-ivmr~heyi~mqzw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Alcanar","indicador_refugi":"430043|CASAL_CIVIC_I_COMUNITARI_ALCANAR","municipi":"Alcanar","codi_municipi":"430043","latitud":"40.5403296","longitud":"0.4605183","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de Llu\xeds Companys, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-v6ny~6t2n~h48k",":version":"rv-qjzv_dbxp~9p69",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa de la Vila","indicador_refugi":"250100|CASA_DE_LA_VILA","municipi":"Alcan\xf3","codi_municipi":"250100","latitud":"41.48047396","longitud":"0.61737839","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Major, 13","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-efct_vr4i-sw4x",":version":"rv-wd5n~gg46-4wk8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals","indicador_refugi":"250100|PISCINES_MUNICIPALS","municipi":"Alcan\xf3","codi_municipi":"250100","latitud":"41.48065251","longitud":"0.61889805","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Zona esportiva","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-rkt6~ywbx_uaq4",":version":"rv-gx4f.sxr2.riss",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de joves de L\'Aldea","indicador_refugi":"439044|CASAL_DE_JOVES_DE_L_ALDEA","municipi":"Aldea, l\'","codi_municipi":"439044","latitud":"40.74497457","longitud":"0.62132173","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Francesc Robert Graupera, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-vi5d_i2cr_gnrd",":version":"rv-ts4p~he2c_49xm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals","indicador_refugi":"439044|PISCINES_MUNICIPALS","municipi":"Aldea, l\'","codi_municipi":"439044","latitud":"40.744418","longitud":"0.621424","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"43896","informacio_web":"www.laldea.cat","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-05-29T13:59:00.000"},{":id":"row-x4fz.8fu4~9v2i",":version":"rv-2y64.axks.7qii",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a dels Segadors","indicador_refugi":"439044|PLACA_DELS_SEGADORS","municipi":"Aldea, l\'","codi_municipi":"439044","latitud":"40.741838","longitud":"0.613479","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"43896","informacio_web":"www.laldea.cat","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-05-29T14:03:00.000"},{":id":"row-ytwg~3awp-q7ib",":version":"rv-czer.eis3~iawb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La P\xe8rgola","indicador_refugi":"439044|LA_PERGOLA","municipi":"Aldea, l\'","codi_municipi":"439044","latitud":"40.748934","longitud":"0.627165","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"43896","informacio_web":"www.laldea.cat","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-05-29T14:05:00.000"},{":id":"row-jdgx_pwgh_z3e4",":version":"rv-gu4p_vhpc~wj7m",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a dels Pa\xefsos Catalans","indicador_refugi":"439044|PLACA_DELS_PAISOS_CATALANS","municipi":"Aldea, l\'","codi_municipi":"439044","latitud":"40.747232","longitud":"0.622392","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"43896","informacio_web":"www.laldea.cat","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-05-29T14:07:00.000"},{":id":"row-eatq_4fya_kub7",":version":"rv-s5uk.xzgn-hkkn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal d\'Aldover","indicador_refugi":"430069|PISCINA_MUNICIPAL_D_ALDOVER","municipi":"Aldover","codi_municipi":"430069","latitud":"40.88051256","longitud":"0.50427274","accessibilitat":"S\xed","aigua":"No","area_descans":"No","adreca":"Part. \\"El Riu\\"","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-uzrf-bkgj~4zhe",":version":"rv-knfj.e8yd.bmx3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bar del Casal municipal Sant Jordi d\'Aldover","indicador_refugi":"430069|BAR_DEL_CASAL_MUNICIPAL_SANT_JORDI_D_ALDOVER","municipi":"Aldover","codi_municipi":"430069","latitud":"40.88103883","longitud":"0.49932268","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Av. Catalunya, s/n","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-si4b~8imi-7jn8",":version":"rv-rcrh~tbxu_emfu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Ferrer i Gu\xe0rdia","indicador_refugi":"080039|BIBLIOTECA_FERRER_I_GUARDIA","municipi":"Alella","codi_municipi":"080039","latitud":"41.49332515","longitud":"2.2948243","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Hort de la Rectoria, s/n","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-rpf4~snr5_hn7g",":version":"rv-e8up~yyqn~jwvn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Antigues Escoles Fabra","indicador_refugi":"080039|ANTIGUES_ESCOLES_FABRA","municipi":"Alella","codi_municipi":"080039","latitud":"41.49296351","longitud":"2.29552972","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Ferran Fabra, 1","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-sw4h~2x4c-vd5s",":version":"rv-upug-zxzi~zr84",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Can Lleonart","indicador_refugi":"080039|CAN_LLEONART","municipi":"Alella","codi_municipi":"080039","latitud":"41.49275859","longitud":"2.29480553","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. dels Germans Lleonart, 1","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-8kci.x2ap~dk86",":version":"rv-paqx_7xdy.cs6q",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Serveis a les Persones","indicador_refugi":"080039|SERVEIS_A_LES_PERSONES","municipi":"Alella","codi_municipi":"080039","latitud":"41.49783843","longitud":"2.29292591","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Torrent de Vallbona, 75","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-m7fe~pbt7~p399",":version":"rv-5zyv.pmrb-69x8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals","indicador_refugi":"250143|PISCINES_MUNICIPALS","municipi":"Alf\xe9s","codi_municipi":"250143","latitud":"41.52171764","longitud":"0.61634633","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Cam\xed de Sunyer, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-528n~4ai5_fncw",":version":"rv-rcne.ica8~gevg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina p\xfablica municipal d\'Alforja","indicador_refugi":"430094|PISCINA_PUBLICA_MUNICIPAL_D_ALFORJA","municipi":"Alforja","codi_municipi":"430094","latitud":"41.21177223","longitud":"0.98063319","accessibilitat":"S\xed","aigua":"No","area_descans":"No","adreca":"Cam\xed de l\'Aleixar, s/n, 43365 Alforja","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-586p-2f6n.gxef",":version":"rv-u3tu~m7br~772m",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local social","indicador_refugi":"430108|LOCAL_SOCIAL","municipi":"Ali\xf3","codi_municipi":"430108","latitud":"41.29373433","longitud":"1.30561406","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Germ\xe0 Saperas, 15","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-gtev_munb-mr88",":version":"rv-ysqd-i6zj-p86n",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc M\xe0gic d\'Almenar","indicador_refugi":"250215|PARC_MAGIC_D_ALMENAR","municipi":"Almenar","codi_municipi":"250215","latitud":"41.79293188","longitud":"0.57391037","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Pont de l\'Alm\xfania, 1","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-mr8k_v9u2-3puq",":version":"rv-ifbv-kjzf_mnrz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals d\'Almenar","indicador_refugi":"250215|PISCINES_MUNICIPALS_D_ALMENAR","municipi":"Almenar","codi_municipi":"250215","latitud":"41.80257898","longitud":"0.57469992","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Pirineus","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-9ytx_uecg-cb5y",":version":"rv-tt32-g635.d597",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal Ramon Berenguer IV","indicador_refugi":"250215|BIBLIOTECA_MUNICIPAL_RAMON_BERENGUER_IV","municipi":"Almenar","codi_municipi":"250215","latitud":"41.79701906","longitud":"0.56837529","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Espad\xf3s, 2","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-mrzw.6zpx-pmnh",":version":"rv-9bmi_amg3_ai4k",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Recinte de les piscines municipals","indicador_refugi":"250220|RECINTE_DE_LES_PISCINES_MUNICIPALS","municipi":"Al\xf2s de Balaguer","codi_municipi":"250220","latitud":"41.91245568","longitud":"0.96162867","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Cam\xed del Vall","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-n5c7.ggvt.mev9",":version":"rv-hrat_7pus.8qbr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Consultori","indicador_refugi":"250220|CONSULTORI","municipi":"Al\xf2s de Balaguer","codi_municipi":"250220","latitud":"41.91210044","longitud":"0.9609584","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Major","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-iq2j-47tv.2mpi",":version":"rv-787m~u5sp.mx7h",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de la Torre","indicador_refugi":"080044|JARDINS_DE_LA_TORRE","municipi":"Alpens","codi_municipi":"080044","latitud":"42.11959363","longitud":"2.10278121","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. Berga, 10-12","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-ie9x~67c4~ntyw",":version":"rv-hrr5_giiw_skwz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal municipal","indicador_refugi":"250236|CASAL_MUNICIPAL","municipi":"Alpicat","codi_municipi":"250236","latitud":"41.66625571","longitud":"0.55776138","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Farraginals, 1","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-kjz2-arzc_g9t9",":version":"rv-is7a-2xub_ew3f",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal","indicador_refugi":"250236|BIBLIOTECA_MUNICIPAL","municipi":"Alpicat","codi_municipi":"250236","latitud":"41.66597087098389","longitud":"0.5571289606469516","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pa\xefsos Catalans 1","informacio_web":"https://participa.alpicat.cat/index_web.php?ap=czo3OiJwb3J0YWRhIjs=&idw=czoyOiIyNSI7&idi=czozOiJjYXQiOw==","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T11:53:00.000"},{":id":"row-yvaz.676q~cziu",":version":"rv-3xua~rnpn_ttbt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PISCINA MUNICIPAL","indicador_refugi":"430120|PISCINA_MUNICIPAL","municipi":"Altafulla","codi_municipi":"430120","latitud":"41.139255","longitud":"1.373532","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"CARRER ALCALDE PIJUAN S/N","informacio_web":"www.altafulla.cat","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T11:26:00.000"},{":id":"row-nsrd_m4jw.sde6",":version":"rv-8zaj.cdfs~xwur",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"BIBLIOTECA MUNICIPAL","indicador_refugi":"430120|BIBLIOTECA_MUNICIPAL","municipi":"Altafulla","codi_municipi":"430120","latitud":"41.1374534158927","longitud":"1.3755799820910846","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"CARRER DEL VINYET, 1","informacio_web":"www.altafulla.cat","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T11:31:00.000"},{":id":"row-w6ue.hde5~ttvu",":version":"rv-69c2~mgbh~kz6i",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ermita de Sant Antoni","indicador_refugi":"430120|ERMITA_DE_SANT_ANTONI","municipi":"Altafulla","codi_municipi":"430120","latitud":"41.14801642375902","longitud":"1.3726623287180746","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Cam\xed de l\'Ermita 35","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T11:35:00.000"},{":id":"row-3vrs~323u~3gxc",":version":"rv-x48y-dk6p-zy33",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Llar de jubilats Sant Miquel","indicador_refugi":"170078|LLAR_DE_JUBILATS_SANT_MIQUEL","municipi":"Amer","codi_municipi":"170078","latitud":"42.00829506986679","longitud":"2.6025278811190224","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Sant Miquel, 18","informacio_web":"De dilluns a diumenge de 10 a 19 h","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T12:51:00.000"},{":id":"row-rmts_tr4a.dcfw",":version":"rv-2q8y~5hfs-pv7p",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ca l\'Arenys","indicador_refugi":"080057|CA_L_ARENYS","municipi":"Ametlla del Vall\xe8s, l\'","codi_municipi":"080057","latitud":"41.66951086","longitud":"2.2671855","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Ca l\'Arenys, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-cunp-fc93.v7cf",":version":"rv-gijc~nntp_qk5q",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina de can Camp","indicador_refugi":"080057|PISCINA_DE_CAN_CAMP","municipi":"Ametlla del Vall\xe8s, l\'","codi_municipi":"080057","latitud":"41.66166101","longitud":"2.25674552","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. La Vinya, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-cgix_7mqg.w67m",":version":"rv-zgh5_gn74_h32w",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal Josep Badia i Moret","indicador_refugi":"080057|BIBLIOTECA_MUNICIPAL_JOSEP_BADIA_I_MORET","municipi":"Ametlla del Vall\xe8s, l\'","codi_municipi":"080057","latitud":"41.66948397","longitud":"2.26258755","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Torregassa, 35-37","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-68iv_z42c-ui37",":version":"rv-2wsb_q8ca-rde4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament de l\'Ametlla del Vall\xe8s","indicador_refugi":"080057|AJUNTAMENT_DE_L_AMETLLA_DEL_VALLES","municipi":"Ametlla del Vall\xe8s, l\'","codi_municipi":"080057","latitud":"41.66955886","longitud":"2.26142753","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Ajuntament, 1","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-9gpz~jsbj_mwfg",":version":"rv-vc8m~na58-6j36",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"439060|PISCINA_MUNICIPAL","municipi":"Ampolla, l\'","codi_municipi":"439060","latitud":"40.81370609","longitud":"0.71013736","accessibilitat":"S\xed","aigua":"No","area_descans":"No","adreca":"Av. Generalitat, s/n (zona d\'equipaments)","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-wwvk-nra2~rh9v",":version":"rv-jd2p~jq59.msh7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Valletes","indicador_refugi":"430141|PARC_VALLETES","municipi":"Amposta","codi_municipi":"430141","latitud":"40.704505","longitud":"0.574594","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Brasil, 103, 43870 Amposta, Tarragona","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T08:30:00.000"},{":id":"row-tpir-i4wd.67kh",":version":"rv-n6hf-uijx_r7br",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc dels Xiribecs","indicador_refugi":"430141|PARC_DELS_XIRIBECS","municipi":"Amposta","codi_municipi":"430141","latitud":"40.705188","longitud":"0.582645","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda Josep Tarradellas, 36-94, 43870 Amposta, Tarragona","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T08:32:00.000"},{":id":"row-f8ar-9nat~vg6y",":version":"rv-pur8.yb4t.quhv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Municipal","indicador_refugi":"430141|PARC_MUNICIPAL","municipi":"Amposta","codi_municipi":"430141","latitud":"40.709002","longitud":"0.577591","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"43870 Amposta, Tarragona","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T08:37:00.000"},{":id":"row-d2n2.8kxs_tvk6",":version":"rv-cy4i_xat3-6vhn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc dels Sequers de Carvallo","indicador_refugi":"430141|PARC_DELS_SEQUERS_DE_CARVALLO","municipi":"Amposta","codi_municipi":"430141","latitud":"40.713012","longitud":"0.577245","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Dos de Maig, 2, 43870 Amposta, Tarragona","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T08:39:00.000"},{":id":"row-zbqz-etb9.qrpe",":version":"rv-iccq-ehg4.guy9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de l\'Agustinet","indicador_refugi":"430141|PARC_DE_LAGUSTINET","municipi":"Amposta","codi_municipi":"430141","latitud":"40.713012","longitud":"0.577245","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Madrid, 38, 43870 Amposta, Tarragona","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T08:41:00.000"},{":id":"row-ifv9.8a3d_dxhz",":version":"rv-wsqd~5szc.kdh7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pista poliesportiva de Poble Nou del Delta","indicador_refugi":"430141|PISTA_POLIESPORTIVA_DE_POBLE_NOU_DEL_DELTA","municipi":"Amposta","codi_municipi":"430141","latitud":"40.646066","longitud":"0.688724","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Ronda dels Pins, 0, 43549 Poble Nou, Tarragona","tipologia":"Pavell\xf3 Esportiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T08:45:00.000"},{":id":"row-pyg5_kfw3.ncmp",":version":"rv-k4kc-93c6_mnzq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc d\'Eucaliptus","indicador_refugi":"430141|PARC_DEUCALIPTUS","municipi":"Amposta","codi_municipi":"430141","latitud":"40.660572","longitud":"0.785997","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Eucaliptus, 115, 43870 Eucaliptus, Tarragona","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T08:48:00.000"},{":id":"row-ewar_f82p-scm7",":version":"rv-pvjt-77ti-ysnh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal d\'Amposta","indicador_refugi":"430141|PISCINA_MUNICIPAL_DAMPOSTA","municipi":"Amposta","codi_municipi":"430141","latitud":"40.706968","longitud":"0.582407","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Fran\xe7a, 61, 73, 43870 Amposta, Tarragona","informacio_web":"Dilluns a Divendres: 7-22h\\tDissabtes: 9-14 h i 16-20 h\\tDiumenges: 10-14 h","tipologia":"Piscina Coberta","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T08:50:00.000"},{":id":"row-8br4~e2ta.btk6",":version":"rv-pt8h-uyvw.24zr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal de Poble Nou del Delta","indicador_refugi":"430141|PISCINA_MUNICIPAL_DE_POBLE_NOU_DEL_DELTA","municipi":"Amposta","codi_municipi":"430141","latitud":"40.64668","longitud":"0.688619","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Ronda dels Pins, 27, 43549 Poble Nou, Tarragona","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T08:52:00.000"},{":id":"row-yrai.qqeu-kzqz",":version":"rv-f5fc_phxg~8xx9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Passeig del Canal Mar\xedtim","indicador_refugi":"430141|PASSEIG_DEL_CANAL_MARITIM","municipi":"Amposta","codi_municipi":"430141","latitud":"40.70704","longitud":"0.585309","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Passeig del Canal Mar\xedtim, 24-30, 43870 Amposta, Tarragona","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T08:56:00.000"},{":id":"row-xedn_r65i-hz5n",":version":"rv-tp6z~fieb~rzfp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jard\xed del Bou","indicador_refugi":"430141|JARDI_DEL_BOU","municipi":"Amposta","codi_municipi":"430141","latitud":"40.718159","longitud":"0.572522","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"43870 Amposta, Tarragona","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T08:58:00.000"},{":id":"row-9ayh.4mer~fgui",":version":"rv-qrcy~cejs_z46g",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Passeig del Riu","indicador_refugi":"430141|PASSEIG_DEL_RIU","municipi":"Amposta","codi_municipi":"430141","latitud":"40.709014","longitud":"0.588937","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Passeig del Riu, 43870 Amposta, Tarragona","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T09:00:00.000"},{":id":"row-usci.fktm.9y9s",":version":"rv-svpj_tqmr~uvmt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Comarcal Sebasti\xe0 Juan Arb\xf3","indicador_refugi":"430141|BIBLIOTECA_COMARCAL_SEBASTIA_JUAN_ARBO","municipi":"Amposta","codi_municipi":"430141","latitud":"40.714333","longitud":"0.580233","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a del Castell, 13-15, 43870 Amposta, Tarragona","informacio_web":"Juliol i agost: de dilluns a dimarts de 9 a 14h i dimarts de 16 a 19h. Tanca la setmana de festes","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T09:02:00.000"},{":id":"row-ahs9-ra7u~kr2n",":version":"rv-y6fx_qgxf_8mm9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu de les Terres de l\'Ebre","indicador_refugi":"430141|MUSEU_DE_LES_TERRES_DE_LEBRE","municipi":"Amposta","codi_municipi":"430141","latitud":"40.70899","longitud":"0.577009","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Gran Capit\xe0, 34, 43870 Amposta, Tarragona","informacio_web":"\\"De dimarts a dissabte: d\u201911 a 14 h i de 17.30 a 20.00 h Diumenges i festius: d\u201911.30 a 14 h\\"","tipologia":"Equipament Cultural (teatre, auditori, museu)","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T09:03:00.000"},{":id":"row-nhus.wtcy~g4g5",":version":"rv-g9pq_2z4c.83j2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic Ruiz Salgado","indicador_refugi":"430141|CASAL_CIVIC_RUIZ_SALGADO","municipi":"Amposta","codi_municipi":"430141","latitud":"40.705877","longitud":"0.572036","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Sebasti\xe0 Juan Arb\xf3, 159, 43870 Amposta, Tarragona","informacio_web":"Juliol: de dilluns a diumenge, de 9 h a 19 h","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T09:05:00.000"},{":id":"row-mej7~s4f3~3bup",":version":"rv-kpae~f7rb_mndb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Oficina de cultura i festes","indicador_refugi":"430141|OFICINA_DE_CULTURA_I_FESTES","municipi":"Amposta","codi_municipi":"430141","latitud":"40.712344","longitud":"0.578765","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Palau i Quer, 6, 43870 Amposta, Tarragona","informacio_web":"De dimarts a divendres de 9 a 13h","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T09:08:00.000"},{":id":"row-cu6u~gx2n~vewz",":version":"rv-xeve~mvy7.ah5p",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Hospital Comarcal d\'Amposta","indicador_refugi":"430141|HOSPITAL_COMARCAL_DAMPOSTA","municipi":"Amposta","codi_municipi":"430141","latitud":"40.708901","longitud":"0.578089","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Jacint Verdaguer, 11, 13, 43870 Amposta, Tarragona","informacio_web":"De dilluns a divendres, de 8 a 20 h","tipologia":"Equipament Sanitari","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T09:09:00.000"},{":id":"row-2bv8_vrgg-265d",":version":"rv-2ny5.tyqm.6igc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Oficina de Turisme","indicador_refugi":"430141|OFICINA_DE_TURISME","municipi":"Amposta","codi_municipi":"430141","latitud":"40.710394","longitud":"0.585619","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda de Sant Jaume, 42-52, 43870 Amposta, Tarragona","informacio_web":"De dilluns a dissabte, de 9 a 15 h. Diumenge de 9,30 a 13,30","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T09:12:00.000"},{":id":"row-rysc_trwp-anrp",":version":"rv-yhem-bhfw~8paj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament de Poble Nou del Delta","indicador_refugi":"430141|AJUNTAMENT_DE_POBLE_NOU_DEL_DELTA","municipi":"Amposta","codi_municipi":"430141","latitud":"40.645286","longitud":"0.686696","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a del Jard\xed, 6, 43549 Poble Nou, Tarragona","informacio_web":"\\"De dimecres a diumenge De 9.00 h a 15.00 h Divendres i dissabte, de 16:30 h a 19 h\\"","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T09:14:00.000"},{":id":"row-fbmc_4t5w-cgn8",":version":"rv-zbq9.crvx.qsbn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat municipal","indicador_refugi":"430141|MERCAT_MUNICIPAL","municipi":"Amposta","codi_municipi":"430141","latitud":"40.71217","longitud":"0.57868","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda Alcalde Palau, 68, 43870 Amposta, Tarragona","informacio_web":"De dilluns a dissabte de 8h a 14h","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T09:15:00.000"},{":id":"row-8nj5~jkf4-qb4b",":version":"rv-c4wu~cdhh-hqy9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament d\'Amposta","indicador_refugi":"430141|AJUNTAMENT_DAMPOSTA","municipi":"Amposta","codi_municipi":"430141","latitud":"40.713463","longitud":"0.580916","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"4, Pla\xe7a de l\'Ajuntament, 3, 43870 Amposta, Tarragona","informacio_web":"De dilluns a divendres, de 9 a 14h","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T09:17:00.000"},{":id":"row-giv2~xqyc.ath4",":version":"rv-9e9a~s85h_g46f",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal","indicador_refugi":"170084|BIBLIOTECA_MUNICIPAL","municipi":"Angl\xe8s","codi_municipi":"170084","latitud":"41.955776","longitud":"2.637883","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Cr. de la Industria, n\xfamero 6, 17160 Angl\xe8s","informacio_web":"https://www.bibgirona.cat/biblioteca/angles","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-23T13:41:00.000"},{":id":"row-rdw8_ean8-bpyh",":version":"rv-t9k3.xgb8.rx26",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de Can Cendra","indicador_refugi":"170084|JARDINS_DE_CAN_CENDRA","municipi":"Angl\xe8s","codi_municipi":"170084","latitud":"41.955698","longitud":"2.639542","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Girona, n\xfamero 19, 17160 Angl\xe8s","informacio_web":"http://www.angles.cat","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-23T13:44:00.000"},{":id":"row-yh3j_fvga_v63g",":version":"rv-hhs4_5vdp~keza",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Font del Canyo","indicador_refugi":"170084|PARC_DE_LA_FONT_DEL_CANYO","municipi":"Angl\xe8s","codi_municipi":"170084","latitud":"41.951503","longitud":"2.639398","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Plaza de Salvador Costa 5, 17160 Angl\xe8s, Gerona, Espa\xf1a","informacio_web":"http://www.angles.cat","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-23T13:53:00.000"},{":id":"row-9a7x~gbgc~ehb2",":version":"rv-jqd4-2y3r~y2gs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala de ball","indicador_refugi":"430154|SALA_DE_BALL","municipi":"Arbol\xed","codi_municipi":"430154","latitud":"41.2422771","longitud":"0.9468225","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"No","adreca":"Av. la Vall, s/n","tipologia":"Sala Polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-30T07:59:00.000"},{":id":"row-8qy8_qrzw_6uvy",":version":"rv-cd8q-qsh3~fui6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina d\u2019Arbol\xed","indicador_refugi":"430154|PISCINA_D_ARBOLI","municipi":"Arbol\xed","codi_municipi":"430154","latitud":"41.2426434","longitud":"0.9495395","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. de la font, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-ac39-46im-9xhk",":version":"rv-a9h5_c69y~6idw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Prat Rod\xf3","indicador_refugi":"170097|PRAT_RODO","municipi":"Arb\xfacies","codi_municipi":"170097","latitud":"41.81679747","longitud":"2.51240888","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. de la riera, s/n","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-5ceu.tjz8_m9zq",":version":"rv-fgjx_d8e5-8cy7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal d\'Arenys de Munt","indicador_refugi":"080076|PISCINA_MUNICIPAL_D_ARENYS_DE_MUNT","municipi":"Arenys de Munt","codi_municipi":"080076","latitud":"41.61649241","longitud":"2.52943732","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Ctra. Lourdes, 25, 08358 Arenys de Munt, Barcelona","tipologia":"Piscines descobertes","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-11T09:58:00.000"},{":id":"row-thsz_avjr_5wuh",":version":"rv-vdx7.45nw-i8fp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Ant\xf2nia Torrent i Martori","indicador_refugi":"080076|BIBLIOTECA_ANTONIA_TORRENT_I_MARTORI","municipi":"Arenys de Munt","codi_municipi":"080076","latitud":"41.610274790968404","longitud":"2.5411695566947583","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Rial de Can Bellsolell, 5, 08358 Arenys de Munt, Barcelona","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-22T10:20:00.000"},{":id":"row-m39h-zgcc_3m5f",":version":"rv-b5es~5a57.67ev",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Can Mallol","indicador_refugi":"080076|CENTRE_CIVIC_CAN_MALLOL","municipi":"Arenys de Munt","codi_municipi":"080076","latitud":"41.60649475109133","longitud":"2.5418073989153807","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Jacint Verdaguer, 08358 Arenys de Munt, Barcelona","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T10:05:00.000"},{":id":"row-wg39~awr5_vyk8",":version":"rv-cj6p~tker~kmqv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Esplai de Jubilats","indicador_refugi":"080076|ESPLAI_DE_JUBILATS","municipi":"Arenys de Munt","codi_municipi":"080076","latitud":"41.609372313460575","longitud":"2.5403684288358175","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a de l\'Esgl\xe9sia, 5, Baixos, 08358 Arenys de Munt, Barcelona","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T11:58:00.000"},{":id":"row-2nv3~wpn4.xyu9",":version":"rv-rgc5_4wph~scxg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat Municipal","indicador_refugi":"080076|MERCAT_MUNICIPAL","municipi":"Arenys de Munt","codi_municipi":"080076","latitud":"41.60878931720985","longitud":"2.5405429584654766","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Rambla Sant Mart\xed, 17, 08358 Arenys de Munt, Barcelona","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T12:05:00.000"},{":id":"row-ihz6-z7my~rmhp",":version":"rv-8m9j-vevf.d8fp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala Municipal","indicador_refugi":"080076|SALA_MUNICIPAL","municipi":"Arenys de Munt","codi_municipi":"080076","latitud":"41.611479285965174","longitud":"2.539548486456809","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Rambla Francesc Maci\xe0, 59, 08358 Arenys de Munt, Barcelona","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T12:10:00.000"},{":id":"row-bhg9.yj49~2q9f",":version":"rv-r43d~c26c-469x",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina p\xfablica municipal","indicador_refugi":"430173|PISCINA_PUBLICA_MUNICIPAL","municipi":"Argentera, l\'","codi_municipi":"430173","latitud":"41.13834434","longitud":"0.90800404","accessibilitat":"No","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Primavera, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-2hvs_apiu-9unq",":version":"rv-dcvx_38mp~i7ae",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntamnet Argentona - oficines OAC","indicador_refugi":"080095|AJUNTAMNET_ARGENTONA_OFICINES_OAC","municipi":"Argentona","codi_municipi":"080095","latitud":"41.55558797","longitud":"2.40026238","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Gran, 59","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-iyny-4bgj_j47q",":version":"rv-pz4g~s7y6-bzdz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la gent gran","indicador_refugi":"080095|CASAL_DE_LA_GENT_GRAN","municipi":"Argentona","codi_municipi":"080095","latitud":"41.55468909","longitud":"2.40242911","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Av. Puig i Cadafalch, 2-4","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-kbi7-7jw2_cigm",":version":"rv-bpi3-qzc3_pv7q",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Oficina d\'atenci\xf3 del Cros","indicador_refugi":"080095|OFICINA_D_ATENCIO_DEL_CROS","municipi":"Argentona","codi_municipi":"080095","latitud":"41.53304","longitud":"2.41944","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Local 17, barri Sant Miquel del Cros","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-jtf7_udmj-ypkv",":version":"rv-sg3m-g44m-qd7k",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca d\'Argentona - Joan Fontcuberta i Gel","indicador_refugi":"080095|BIBLIOTECA_D_ARGENTONA_JOAN_FONTCUBERTA_I_GEL","municipi":"Argentona","codi_municipi":"080095","latitud":"41.55450194","longitud":"2.40209","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Gran, 3-5","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-kv8h-s78u.cbhn",":version":"rv-pcag_a3xc-vjue",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre civic de les Ginesteres","indicador_refugi":"080095|CENTRE_CIVIC_DE_LES_GINESTERES","municipi":"Argentona","codi_municipi":"080095","latitud":"41.57357688","longitud":"2.38127979","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Ignasi Barraquer i Barraquer, 14, 8 (Urb. les Ginesteres)","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-gxix~kcfc-28z2",":version":"rv-2svx-kt9j-htzq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu del  Cantir","indicador_refugi":"080095|MUSEU_DEL_CANTIR","municipi":"Argentona","codi_municipi":"080095","latitud":"41.55419955","longitud":"2.40039937","accessibilitat":"S\xed","aigua":"No","area_descans":"No","adreca":"Pl. Esglesia, 9","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-hk8v.9myc~inf2",":version":"rv-km53.nqs2.qc3i",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals d\'Artesa de Segre","indicador_refugi":"250349|PISCINES_MUNICIPALS_D_ARTESA_DE_SEGRE","municipi":"Artesa de Segre","codi_municipi":"250349","latitud":"41.89586851","longitud":"1.0424715","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Camp de Futbol, 1, Artesa de Segre","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-nsxs~zu9e.j9sn",":version":"rv-xjtp-hxz5-dcrp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Edifici cultural","indicador_refugi":"250349|EDIFICI_CULTURAL","municipi":"Artesa de Segre","codi_municipi":"250349","latitud":"41.89613372","longitud":"1.04542603","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Av. de Maria Anzizu, 30, Artesa de Segre","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-dgpe-62wn.hf3i",":version":"rv-q2hq.p3rw.3a69",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"430192|PISCINA_MUNICIPAL","municipi":"Asc\xf3","codi_municipi":"430192","latitud":"41.18623048","longitud":"0.56743697","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Margarita Sevil, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-8688_zaff-gque",":version":"rv-rjux_fe7r.mzgu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament","indicador_refugi":"430192|AJUNTAMENT","municipi":"Asc\xf3","codi_municipi":"430192","latitud":"41.18101287","longitud":"0.56702381","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Hospital, 2","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-pmxn-yek3_jv3n",":version":"rv-8278.cxqi-fhga",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pavell\xf3","indicador_refugi":"430192|PAVELLO","municipi":"Asc\xf3","codi_municipi":"430192","latitud":"41.18565254","longitud":"0.56852545","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Alcalde Tom\xe0s Biarn\xe9s, s/n","tipologia":"Poliesportiu","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-bs5w~9bmx~q8ew",":version":"rv-ugx3_8bjw-gsxs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local de joves","indicador_refugi":"430192|LOCAL_DE_JOVES","municipi":"Asc\xf3","codi_municipi":"430192","latitud":"41.1802996","longitud":"0.56823366","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Baix, 1","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-ges2-m289-ms24",":version":"rv-w7f7_6j2h_5k2i",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal","indicador_refugi":"430192|BIBLIOTECA_MUNICIPAL","municipi":"Asc\xf3","codi_municipi":"430192","latitud":"41.18171617","longitud":"0.568401","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Molins, 4","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-9whu.626a_tkvb",":version":"rv-p5gq.unh2_kgku",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"250365|PISCINA_MUNICIPAL","municipi":"Aspa","codi_municipi":"250365","latitud":"41.49428837","longitud":"0.67306876","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. portal de les Garrigues, 5","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-iiyb_kfi5.vcur",":version":"rv-sx4p-5jpd.cky6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"080116|PISCINA_MUNICIPAL","municipi":"Avi\xe0","codi_municipi":"080116","latitud":"42.07602112","longitud":"1.82145024","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de la Piscina, s/n, 08610 Avi\xe0","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-rtsc.fe7u.82qn",":version":"rv-jdh8~afmi.mn59",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals","indicador_refugi":"080121|PISCINES_MUNICIPALS","municipi":"Aviny\xf3","codi_municipi":"080121","latitud":"41.86566353","longitud":"1.97431709","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Industria","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-h587~pmgt~y38z",":version":"rv-mvp8~w592~jq76",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca","indicador_refugi":"080121|BIBLIOTECA","municipi":"Aviny\xf3","codi_municipi":"080121","latitud":"41.86524067","longitud":"1.97060421","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Passeig, 19","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-kacx-5xj6_vgyg",":version":"rv-542a.n4xf-iass",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Vicente Aleixandre","indicador_refugi":"089045|BIBLIOTECA_VICENTE_ALEIXANDRE","municipi":"Badia del Vall\xe8s","codi_municipi":"089045","latitud":"41.50649985200654","longitud":"2.116923454495086","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. de la Mediterr\xe0nia, S/N, 08214 Badia del Vall\xe8s, Barcelona","informacio_web":"https://bibliotecabadia.blogspot.com/p/disponibilitat-espais.html","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T11:15:00.000"},{":id":"row-6bvp~sejk-ghxq",":version":"rv-u5kx.kc3j.7yiq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de les Illes Balears","indicador_refugi":"089045|PARC_DE_LES_ILLES_BALEARS","municipi":"Badia del Vall\xe8s","codi_municipi":"089045","latitud":"41.50612914744454","longitud":"2.120303036154363","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Mallorca 2, 08214 Badia del Vall\xe8s","informacio_web":"Obert tots els dies","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T12:15:00.000"},{":id":"row-cnyj_sa9j-85bp",":version":"rv-b76b-cz4d.qt2d",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Nou Casal d\'avis","indicador_refugi":"089045|NOU_CASAL_DAVIS","municipi":"Badia del Vall\xe8s","codi_municipi":"089045","latitud":"41.50880918426751","longitud":"2.1143261946591267","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. de Burgos cantonada C/ B\xe9tica s/n","informacio_web":"https://www.badiadelvalles.cat/document.php?id=178","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T12:25:00.000"},{":id":"row-qnii~zuc7.gvdk",":version":"rv-yev7~hqk7.epjs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines exteriors de les instal\xb7lacions Esportives Municipals","indicador_refugi":"089045|PISCINES_EXTERIORS_DE_LES_INSTALLACIONS_ESPORTIVES_MUNICIPALS","municipi":"Badia del Vall\xe8s","codi_municipi":"089045","latitud":"41.514714024972875","longitud":"2.1139882246829416","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer del Tibidabo","informacio_web":"https://www.badiadelvalles.cat/","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T12:37:00.000"},{":id":"row-hkfx_e6cz_5rbk",":version":"rv-e5ye-67up-7i3d",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Joan Oliver, zona sota p\xe8rgola","indicador_refugi":"089045|PARC_JOAN_OLIVER_ZONA_SOTA_PERGOLA","municipi":"Badia del Vall\xe8s","codi_municipi":"089045","latitud":"41.507364522540605","longitud":"2.115804972334199","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de la Manxa 11","informacio_web":"https://www.badiadelvalles.cat/","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T12:47:00.000"},{":id":"row-na77.y9sd_tzgq",":version":"rv-zrd9.6gna-trnp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Joves","indicador_refugi":"080168|CASAL_DE_JOVES","municipi":"Bag\xe0","codi_municipi":"080168","latitud":"42.25255063","longitud":"1.8597652","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Pere Tomic, 1 baixos","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-zp2w~27dq~k2xf",":version":"rv-jxa4.irau~7spf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu de la Sal","indicador_refugi":"250390|MUSEU_DE_LA_SAL","municipi":"Baix Pallars","codi_municipi":"250390","latitud":"42.3233","longitud":"1.0642","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a \xc0ngel esteve, 10, 25590 Gerri de la Sal","informacio_web":"www.museudegerri.cat","tipologia":"Equipament Cultural (teatre, auditori, museu)","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-22T13:26:00.000"},{":id":"row-g8kr~yhr7_b6ys",":version":"rv-qrav~z2h2-qn8g",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Claustre Convent Sant Dom\xe8nec","indicador_refugi":"250404|CLAUSTRE_CONVENT_SANT_DOMENEC","municipi":"Balaguer","codi_municipi":"250404","latitud":"41.79399795","longitud":"0.80909597","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. d\'Urgell, 1","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-4ixj-vvum_rd45",":version":"rv-4538_q2uc-6v74",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Balaguer - Eixample","indicador_refugi":"250404|CASAL_CIVIC_I_COMUNITARI_BALAGUER_EIXAMPLE","municipi":"Balaguer","codi_municipi":"250404","latitud":"41.4088959","longitud":"0.8678702","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. d\'Urgell, 5","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-v5mm_r2qh_iray",":version":"rv-a4et~wf27-mah8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Margarida de Montferrat","indicador_refugi":"250404|BIBLIOTECA_MARGARIDA_DE_MONTFERRAT","municipi":"Balaguer","codi_municipi":"250404","latitud":"41.78838236","longitud":"0.80556804","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Miracle, 23, 2n pis","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-4aqu_a28q-6566",":version":"rv-nc8q.b7yr.mbmp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Reial","indicador_refugi":"250404|PARC_DEL_REIAL","municipi":"Balaguer","codi_municipi":"250404","latitud":"41.79686514","longitud":"0.80001381","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Pla d\'Almat\xe0","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-7kbk~3dn3-xsx4",":version":"rv-wis8~f4fq-b386",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu de la Noguera","indicador_refugi":"250404|MUSEU_DE_LA_NOGUERA","municipi":"Balaguer","codi_municipi":"250404","latitud":"41.78885985","longitud":"0.80488975","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. dels Comptes d\'Urgell, 5","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-94ae_4bf2-tejn",":version":"rv-zcu2_xedu_ahwq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Esgl\xe9sia de Santa Maria de Balaguer","indicador_refugi":"250404|ESGLESIA_DE_SANTA_MARIA_DE_BALAGUER","municipi":"Balaguer","codi_municipi":"250404","latitud":"41.79189467","longitud":"0.80428317","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. Cec\xedlia Comenge, 1","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-cyhp_jt9t-238w",":version":"rv-zp48.vbya.ftj9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal de Balaguer","indicador_refugi":"250404|PISCINA_MUNICIPAL_DE_BALAGUER","municipi":"Balaguer","codi_municipi":"250404","latitud":"41.78994361","longitud":"0.8176104","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. d\'Urgell, 96","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-jwcz.yp9q~qxkw",":version":"rv-zj9q_8j77.vtmt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La Bultra de les Franqueses","indicador_refugi":"250404|LA_BULTRA_DE_LES_FRANQUESES","municipi":"Balaguer","codi_municipi":"250404","latitud":"41.75629","longitud":"0.79704","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Marge dret del riu Segre (entre Balaguer i el Monestir Cistercenc de les Franqueses)","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-eyn9.4ykw_pyp8",":version":"rv-xcsk-735z.buqm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Balaguer - El Miracle","indicador_refugi":"250404|CASAL_CIVIC_I_COMUNITARI_BALAGUER_EL_MIRACLE","municipi":"Balaguer","codi_municipi":"250404","latitud":"41.7883262","longitud":"0.803015","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. del Miracle, 23 (cant. Germ\xe0 Peralba)","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-62mi-f465-693z",":version":"rv-uawv.f7m6-4f2b",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal d\'avis","indicador_refugi":"080174|CASAL_D_AVIS","municipi":"Baleny\xe0","codi_municipi":"080174","latitud":"41.81560499","longitud":"2.23600851","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Bosch i Jover, 1","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-xpf8.kjhd.c7eg",":version":"rv-gdh2_xrdf-2chx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala El Sindicat","indicador_refugi":"080180|SALA_EL_SINDICAT","municipi":"Balsareny","codi_municipi":"080180","latitud":"41.86313179","longitud":"1.87476454","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de Ponent, 7, 08660 Balsareny, Barcelona","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-57ub~rqbw_szi9",":version":"rv-jaut_ckq8-t8uy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Balsareny","indicador_refugi":"080180|CASAL_CIVIC_I_COMUNITARI_BALSARENY","municipi":"Balsareny","codi_municipi":"080180","latitud":"41.8632281","longitud":"1.8742206","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. del Rector Roc Garcia, 1","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-jxen_p6xn.kzpz",":version":"rv-4pyy.8fbf-9d3z",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local social Esplai","indicador_refugi":"430206|LOCAL_SOCIAL_ESPLAI","municipi":"Banyeres del Pened\xe8s","codi_municipi":"430206","latitud":"41.2618118","longitud":"1.46153282","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. de l\'esplai, 50","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-7h55_j5e5.rci6",":version":"rv-9cr9_gcau.b4vi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina p\xfablica municipal de Banyeres del Pened\xe8s","indicador_refugi":"430206|PISCINA_PUBLICA_MUNICIPAL_DE_BANYERES_DEL_PENEDES","municipi":"Banyeres del Pened\xe8s","codi_municipi":"430206","latitud":"41.27648383","longitud":"1.5824701","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Dos Hermanas, 2","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-sgrv.gs4k-suig",":version":"rv-eu6d-zc72.hvk3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal de Banyeres del Pened\xe8s Ernest Lluch","indicador_refugi":"430206|BIBLIOTECA_MUNICIPAL_DE_BANYERES_DEL_PENEDES_ERNEST_LLUCH","municipi":"Banyeres del Pened\xe8s","codi_municipi":"430206","latitud":"41.2789843","longitud":"1.5807527","accessibilitat":"No","aigua":"No","area_descans":"S\xed","adreca":"C. Saragossa, s/n","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-ah3k_d8ch~mz2h",":version":"rv-k4da.m3u4_gj3c",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai jove","indicador_refugi":"430206|ESPAI_JOVE","municipi":"Banyeres del Pened\xe8s","codi_municipi":"430206","latitud":"41.28060354","longitud":"1.58087211","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Montserrat, 5-7","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-c4t6-ct4k-974w",":version":"rv-y45n.wv46~uc8u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de l\'escola Mare de D\xe9u del Priorat","indicador_refugi":"430206|PARC_DE_LESCOLA_MARE_DE_DEU_DEL_PRIORAT","municipi":"Banyeres del Pened\xe8s","codi_municipi":"430206","latitud":"41.2764","longitud":"1.5813","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda Verge del Priorat, 41","informacio_web":"www.banyeresdelpenedes.cat","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T08:54:00.000"},{":id":"row-bzyh-uqnj.ixs4",":version":"rv-aa78~7a2f_quz9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PARC DEL PATUFET","indicador_refugi":"430206|PARC_DEL_PATUFET","municipi":"Banyeres del Pened\xe8s","codi_municipi":"430206","latitud":"41.2778","longitud":"1.5787","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer La Granja cantonada carrer Pened\xe8s","informacio_web":"www.banyeresdelpenedes.cat","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T08:57:00.000"},{":id":"row-xdst~kj3q~mib9",":version":"rv-d9mf-aum7.gzci",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PARC PR\xcdNCEP D\'AST\xdaRIES","indicador_refugi":"430206|PARC_PRINCEP_DASTURIES","municipi":"Banyeres del Pened\xe8s","codi_municipi":"430206","latitud":"41.27844","longitud":"1.5843","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Josep Maria Biarn\xe9s, 9","informacio_web":"www.banyeresdelpenedes.cat","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T09:01:00.000"},{":id":"row-7yty_ahre-yu3p",":version":"rv-4xbi-3hmz~mvz2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PATI DE L\'ESCOLA MARE DE D\xc9U DEL PRIORAT","indicador_refugi":"430206|PATI_DE_LESCOLA_MARE_DE_DEU_DEL_PRIORAT","municipi":"Banyeres del Pened\xe8s","codi_municipi":"430206","latitud":"41.2764","longitud":"1.5813","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda Verge del Priorat, 41","informacio_web":"www.banyeresdelpenedes.cat","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T09:07:00.000"},{":id":"row-ttfx.ajw5_ihnz",":version":"rv-7ugn~azin~9hzp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PARC DEL PRIORAT","indicador_refugi":"430206|PARC_DEL_PRIORAT","municipi":"Banyeres del Pened\xe8s","codi_municipi":"430206","latitud":"41.2741","longitud":"1.5447","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda Marquesa de Grinyi, 63","informacio_web":"www.banyeresdelpenedes.cat","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T09:12:00.000"},{":id":"row-7t7p~5ym5~dr35",":version":"rv-3prm-di94~mda9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PARC DELS BOSCOS","indicador_refugi":"430206|PARC_DELS_BOSCOS","municipi":"Banyeres del Pened\xe8s","codi_municipi":"430206","latitud":"41.2695","longitud":"1.5708","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Salvador Espriu, 14","informacio_web":"www.banyeresdelpenedes.cat","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T09:25:00.000"},{":id":"row-vpvn.g4qe_n59c",":version":"rv-m2mc~mk7j~bv58",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PARC DE LES MASIES DE SANT MIQUEL","indicador_refugi":"430206|PARC_DE_LES_MASIES_DE_SANT_MIQUEL","municipi":"Banyeres del Pened\xe8s","codi_municipi":"430206","latitud":"41.2698","longitud":"1.5604","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"CARRER TOMOV\xcd , 57, CARRER SANT MIQUEL 2","informacio_web":"ww.banyeresdelpenedes.cat","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T09:40:00.000"},{":id":"row-78j3.mzu4_ihq5",":version":"rv-at3s~djq5-q4yz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"ESCOLA MARE DE D\xc9U DEL PRIORAT","indicador_refugi":"430206|ESCOLA_MARE_DE_DEU_DEL_PRIORAT","municipi":"Banyeres del Pened\xe8s","codi_municipi":"430206","latitud":"41.276","longitud":"1.5818","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda Verge del Priorat, 41","informacio_web":"www.banyeresdelpenedes.cat","tipologia":"Escola / Institut","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T10:09:00.000"},{":id":"row-9fab-u9q8.bpka",":version":"rv-fbcc.b23u_i6cw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca de Banyoles","indicador_refugi":"170157|BIBLIOTECA_DE_BANYOLES","municipi":"Banyoles","codi_municipi":"170157","latitud":"42.12375512","longitud":"2.76306577","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Llibertat, 155","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-b6qw_sc6v_ymis",":version":"rv-69es~di2w~vzmr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Cruyff Court Andreu Font\xe0s/ barri Canaleta","indicador_refugi":"170157|PLACA_CRUYFF_COURT_ANDREU_FONTAS_BARRI_CANALETA","municipi":"Banyoles","codi_municipi":"170157","latitud":"42.12469162","longitud":"2.76993171","accessibilitat":"S\xed","aigua":"No","area_descans":"No","adreca":"Pl. Cruyff Court Andreu Font\xe0s","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-q63c_jmfp-2bj7",":version":"rv-p4n8_yyye.dmr3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de barri de Can Puig","indicador_refugi":"170157|CASAL_DE_BARRI_DE_CAN_PUIG","municipi":"Banyoles","codi_municipi":"170157","latitud":"42.18206045","longitud":"2.79145058","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Figueres, 47","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-xwqb-y8nu.iei5",":version":"rv-8i88-utvt_m9m4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu Darder","indicador_refugi":"170157|MUSEU_DARDER","municipi":"Banyoles","codi_municipi":"170157","latitud":"42.11930919","longitud":"2.76506978","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. dels estudis, 2","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-gfuf_qzty.u8i7",":version":"rv-7wsf-3tp8~jdna",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de les Rodes","indicador_refugi":"170157|PLACA_DE_LES_RODES","municipi":"Banyoles","codi_municipi":"170157","latitud":"42.11808599","longitud":"2.7617097","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de les rodes","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-urue-m5jj~xa2a",":version":"rv-9jwj_58vx_idyw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de barri de la Farga","indicador_refugi":"170157|CASAL_DE_BARRI_DE_LA_FARGA","municipi":"Banyoles","codi_municipi":"170157","latitud":"42.11500611","longitud":"2.7725514","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Barcelona, 58","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-p29t_rayb.ne55",":version":"rv-d7h3-a6y4-6wsi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Banyoles","indicador_refugi":"170157|CASAL_CIVIC_I_COMUNITARI_BANYOLES","municipi":"Banyoles","codi_municipi":"170157","latitud":"42.1188999","longitud":"2.7613251","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C.\xa0de Josep Maria Bohigas i Masoliver, 19","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-snkq-pgp2_t544",":version":"rv-wwft~4csn~ub6s",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de la Pau, Barri de la Farga","indicador_refugi":"170157|PLACA_DE_LA_PAU_BARRI_DE_LA_FARGA","municipi":"Banyoles","codi_municipi":"170157","latitud":"42.11496132","longitud":"2.77318934","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de la Pau","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-ds48_fatn-qxc8",":version":"rv-c96z_y2ka_n56u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La Caseta de fusta","indicador_refugi":"170157|LA_CASETA_DE_FUSTA","municipi":"Banyoles","codi_municipi":"170157","latitud":"42.12151898","longitud":"2.75808085","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pg. Llu\xeds Maria Vidal, 1","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-4un6.28au-whgt",":version":"rv-v2kc_sija~npkx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de barri Mas Palau","indicador_refugi":"170157|CASAL_DE_BARRI_MAS_PALAU","municipi":"Banyoles","codi_municipi":"170157","latitud":"42.12532229","longitud":"2.76694862","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Sant Narc\xeds, 12","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-uxxm_3x2d.id42",":version":"rv-cgvx_bmjr-rbnu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de barri de Sant Pere","indicador_refugi":"170157|CASAL_DE_BARRI_DE_SANT_PERE","municipi":"Banyoles","codi_municipi":"170157","latitud":"42.1110772","longitud":"2.76777015","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Maria Montesori, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-nv4b.3z82-rgwd",":version":"rv-k2j6.y7b6.vezn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Caseta De Fusta","indicador_refugi":"170157|CASETA_DE_FUSTA","municipi":"Banyoles","codi_municipi":"170157","latitud":"42.13073612","longitud":"2.75992693","accessibilitat":"S\xed","aigua":"No","area_descans":"No","adreca":"Estany de Banyoles, 17820 Banyoles, Girona","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-m9dk.e6ut.psp3",":version":"rv-6xvi_jusk-6k67",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"430213|PISCINA_MUNICIPAL","municipi":"Barber\xe0 de la Conca","codi_municipi":"430213","latitud":"41.4092116","longitud":"1.2282938","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Valldemur","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-j6jk~ks3e-pdin",":version":"rv-tnai~n9gb-cizj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local social","indicador_refugi":"170182|LOCAL_SOCIAL","municipi":"Bellcaire d\'Empord\xe0","codi_municipi":"170182","latitud":"42.08243058","longitud":"3.09588494","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Orient, s/n - Zona esportiva","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-ninm_9bt4~abr5",":version":"rv-xtp2~pehw_v4vg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals","indicador_refugi":"250479|PISCINES_MUNICIPALS","municipi":"Bellcaire d\'Urgell","codi_municipi":"250479","latitud":"41.75733474","longitud":"0.90437059","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Catalunya, 45, 25337 Bellcaire d\'Urgell","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-s3rg-gqqf-vmd7",":version":"rv-xjaf.kg3c-6wbi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca","indicador_refugi":"250479|BIBLIOTECA","municipi":"Bellcaire d\'Urgell","codi_municipi":"250479","latitud":"41.75965262","longitud":"0.90603535","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Major, 1-CP, 25337 Bellcaire d\'Urgell","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-kzny-def5_324q",":version":"rv-vv5k-bqkt-imqx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"LLAR DEL JUBILAT","indicador_refugi":"250485|LLAR_DEL_JUBILAT","municipi":"Bell-lloc d\'Urgell","codi_municipi":"250485","latitud":"41.629879","longitud":"0.781194","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"PLA\xc7A CATALUNYA, 2","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T08:41:00.000"},{":id":"row-bb5g-3brd_9gug",":version":"rv-g2jn.x76j~k984",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PISCINES MUNICIPALS","indicador_refugi":"250485|PISCINES_MUNICIPALS","municipi":"Bell-lloc d\'Urgell","codi_municipi":"250485","latitud":"41.632946","longitud":"0.781854","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ DELS CUPS S/N","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T08:43:00.000"},{":id":"row-scnm.izie.n7h9",":version":"rv-yfw4-bwmi_wgz9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"BIBLIOTECA","indicador_refugi":"250485|BIBLIOTECA","municipi":"Bell-lloc d\'Urgell","codi_municipi":"250485","latitud":"41.631762","longitud":"0.778374","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/VIA FERREA, 5","informacio_web":"https://cercadorbiblioteques.cultura.gencat.cat/biblio.do?reqCode=view&codiBiblio=P0044&pos=0","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T08:47:00.000"},{":id":"row-ssbp.y9sz-d5br",":version":"rv-4x9r_der8.ymzs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PLA\xc7A LLU\xcdS COMPANYS","indicador_refugi":"250485|PLACA_LLUIS_COMPANYS","municipi":"Bell-lloc d\'Urgell","codi_municipi":"250485","latitud":"41.631668","longitud":"0.776713","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"PLA\xc7A LLU\xcdS COMPANYS","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T08:48:00.000"},{":id":"row-8fvf.a982_xt8d",":version":"rv-mxzm_dauq-ae8k",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local social de Bellmunt d\'Urgell","indicador_refugi":"250498|LOCAL_SOCIAL_DE_BELLMUNT_D_URGELL","municipi":"Bellmunt d\'Urgell","codi_municipi":"250498","latitud":"41.773538","longitud":"0.95345458","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Escoles","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-g9ee~ayai-x499",":version":"rv-4ees_32u6.hy8u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"250518|PISCINA_MUNICIPAL","municipi":"Bellver de Cerdanya","codi_municipi":"250518","latitud":"42.36800711236008","longitud":"1.7776521370887721","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer del Bergued\xe0, 19,","informacio_web":"www.esportsbellver.org","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T12:48:00.000"},{":id":"row-3tm8-2s44-995r",":version":"rv-8cam_jxef_4uk9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic \'Escoles velles\'","indicador_refugi":"250518|CENTRE_CIVIC_ESCOLES_VELLES","municipi":"Bellver de Cerdanya","codi_municipi":"250518","latitud":"42.36901365520093","longitud":"1.7765089254428792","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Escoles, 6","informacio_web":"www.bellver.org","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T12:55:00.000"},{":id":"row-48md.38re~ietb",":version":"rv-735y.mcy8-wuqx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pavell\xf3 poliesportiu","indicador_refugi":"250518|PAVELLO_POLIESPORTIU","municipi":"Bellver de Cerdanya","codi_municipi":"250518","latitud":"42.36705588861876","longitud":"1.7773410008619641","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de l\'Esport, 5","informacio_web":"www.bellver.org","tipologia":"Pavell\xf3 Esportiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T13:01:00.000"},{":id":"row-wmdy-3zgv~mmnn",":version":"rv-u2mu~7ni2_xwgf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"430252|PISCINA_MUNICIPAL","municipi":"Benifallet","codi_municipi":"430252","latitud":"40.97243408","longitud":"0.51584758","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Marcel\xb7l\xed Domingo, 27","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-wwyc~2bex~js49",":version":"rv-5iy3_wscp.3m53",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Refugi clim\xe0tic del pati de l\'Escola Antoni Nat","indicador_refugi":"430265|REFUGI_CLIMATIC_DEL_PATI_DE_LESCOLA_ANTONI_NAT","municipi":"Benissanet","codi_municipi":"430265","latitud":"41.0567403","longitud":"0.6350701","accessibilitat":"No","aigua":"S\xed","climatitzacio":"No","area_descans":"No","lavabo":"No","adreca":"Carrer Reus, 43747, Benissanet","tipologia":"Escola / Institut","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-23T09:09:00.000"},{":id":"row-i5bv_yphz~z9gs",":version":"rv-vb67~nxst.ssim",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Municipal","indicador_refugi":"430265|BIBLIOTECA_MUNICIPAL","municipi":"Benissanet","codi_municipi":"430265","latitud":"41.0580906","longitud":"0.6329984","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Antoni Gaud\xed, 1","informacio_web":"https://tauler.seu-e.cat/detall?idEns=4302650006&idEdicte=637735","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-07T09:31:00.000"},{":id":"row-2sby-tehq_6cd2",":version":"rv-ry44_6aft-xzd5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala Entitats","indicador_refugi":"430265|SALA_ENTITATS","municipi":"Benissanet","codi_municipi":"430265","latitud":"41.05","longitud":"0.6333","accessibilitat":"S\xed","aigua":"No","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Josep Serra, 14","informacio_web":"https://tauler.seu-e.cat/detall?idEns=4302650006&idEdicte=637735","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-07T09:33:00.000"},{":id":"row-yiwz_8tak_36mz",":version":"rv-ug53.fgqb_hxs3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Berga","indicador_refugi":"080229|CASAL_CIVIC_I_COMUNITARI_BERGA","municipi":"Berga","codi_municipi":"080229","latitud":"42.1022529","longitud":"1.2352668","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de Sant Joan, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-s2wm-sweh_swhi",":version":"rv-qf4s_b2n5.qgdp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals d\'estiu","indicador_refugi":"080229|PISCINES_MUNICIPALS_D_ESTIU","municipi":"Berga","codi_municipi":"080229","latitud":"42.09870412","longitud":"1.84863395","accessibilitat":"No","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Guillem de Bergued\xe0, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-gixw~ieme-3dfy",":version":"rv-2645_3qr5_rgwb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Ramon Vidal - Can Camb\xf3","indicador_refugi":"170195|BIBLIOTECA_RAMON_VIDAL_CAN_CAMBO","municipi":"Besal\xfa","codi_municipi":"170195","latitud":"42.1992681","longitud":"2.698946","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C.Major 13 2n","informacio_web":"Estiu de 10 a 13 de dilluns a divendres i dimarts i dijous tamb\xe9 tarda de 16 a 18:30","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-05T12:14:00.000"},{":id":"row-i5b7~e3fj~964q",":version":"rv-6x4b~ep93_a2ks",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local Comunitari Can Camb\xf3","indicador_refugi":"170195|LOCAL_COMUNITARI_CAN_CAMBO","municipi":"Besal\xfa","codi_municipi":"170195","latitud":"42.1992681","longitud":"2.698946","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Major 13 1r","informacio_web":"Tardes","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-05T12:19:00.000"},{":id":"row-emjs-sm4k_hky5",":version":"rv-y4ep.yr57~w7ur",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala polivalent Baixos Can Camb\xf3","indicador_refugi":"170195|SALA_POLIVALENT_BAIXOS_CAN_CAMBO","municipi":"Besal\xfa","codi_municipi":"170195","latitud":"42.1992681","longitud":"2.698946","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Major 13 Baixos","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-05T12:24:00.000"},{":id":"row-cicd_2bcx-dv5y",":version":"rv-i7hx~qkic~h58f",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal d\'avis","indicador_refugi":"170209|CASAL_D_AVIS","municipi":"Bescan\xf3","codi_municipi":"170209","latitud":"41.96238668","longitud":"2.7380545","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. de la Torre, s/n","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-9e8c-eak3~ygut",":version":"rv-w6x9_tjmf.uzj6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Josep Fontbernat i Verdaguer","indicador_refugi":"170209|BIBLIOTECA_JOSEP_FONTBERNAT_I_VERDAGUER","municipi":"Bescan\xf3","codi_municipi":"170209","latitud":"41.96367981","longitud":"2.73764038","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de les Nacions, 10","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-7e55-tf2v~ssaa",":version":"rv-aggk_7v9z_e6e3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal d\'avis centre c\xedvic i cultural El Rieral","indicador_refugi":"080235|CASAL_D_AVIS_CENTRE_CIVIC_I_CULTURAL_EL_RIERAL","municipi":"Bigues i Riells del Fai","codi_municipi":"080235","latitud":"41.68150904","longitud":"2.20615009","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Anna Mogas, 130, 08510 Bigues i Riells del Fai","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-ais7.s7ki~a3h7",":version":"rv-a39a~diq4_6x94",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local social Can Gordei","indicador_refugi":"430287|LOCAL_SOCIAL_CAN_GORDEI","municipi":"Bisbal del Pened\xe8s, la","codi_municipi":"430287","latitud":"41.26376012","longitud":"1.47451555","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Can Gordei, 25","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-4rj9_34w6_eqmq",":version":"rv-8xdd~gwfz-yutg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"430287|PISCINA_MUNICIPAL","municipi":"Bisbal del Pened\xe8s, la","codi_municipi":"430287","latitud":"41.27494888","longitud":"1.49114524","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Av. Diputaci\xf3, 16","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-h454_8wvv.hdja",":version":"rv-ktts_89ek.kn7r",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local social Priorat","indicador_refugi":"430287|LOCAL_SOCIAL_PRIORAT","municipi":"Bisbal del Pened\xe8s, la","codi_municipi":"430287","latitud":"41.28530938","longitud":"1.47242342","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Priorat","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-u8be.2c68~azdg",":version":"rv-vn9z-9tux~m3yu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local social La Miralba","indicador_refugi":"430287|LOCAL_SOCIAL_LA_MIRALBA","municipi":"Bisbal del Pened\xe8s, la","codi_municipi":"430287","latitud":"41.26461197","longitud":"1.49240948","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Gladiol, s/n","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-23jc-27cf-zjsk",":version":"rv-b5ep-tsas-gmsr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Font de l\'Arbre","indicador_refugi":"170221|FONT_DE_L_ARBRE","municipi":"Bisbal d\'Empord\xe0, la","codi_municipi":"170221","latitud":"41.95250774","longitud":"3.02996244","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Cam\xed de la Font de l\'Arbre","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-q7eb.3qgi-x7xm",":version":"rv-pfyu_m7jf_cxkx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"El passeig Marimon Asprer","indicador_refugi":"170221|EL_PASSEIG_MARIMON_ASPRER","municipi":"Bisbal d\'Empord\xe0, la","codi_municipi":"170221","latitud":"41.96221026","longitud":"3.03774645","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. Marimon Asprer","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-t5s3.5j8h.7ptt",":version":"rv-2uhj-4un6.racc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de Torre Maria","indicador_refugi":"170221|JARDINS_DE_TORRE_MARIA","municipi":"Bisbal d\'Empord\xe0, la","codi_municipi":"170221","latitud":"41.96257672","longitud":"3.0360942","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Aig\xfceta, 17","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-tqvf.qhb8.a7en",":version":"rv-fc3z~6urm~scuz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Zona arbrada del p\xe0rquing del CAP","indicador_refugi":"170221|ZONA_ARBRADA_DEL_PARQUING_DEL_CAP","municipi":"Bisbal d\'Empord\xe0, la","codi_municipi":"170221","latitud":"41.96269175","longitud":"3.03502405","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Marcel Rall\xf3","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-v9f2.wxns_kran",":version":"rv-pvxs-mmbi.uevz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc 8 de mar\xe7","indicador_refugi":"170221|PARC_8_DE_MARC","municipi":"Bisbal d\'Empord\xe0, la","codi_municipi":"170221","latitud":"41.95657056","longitud":"3.03908368","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. de Josep Irla, 11","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-z8er_ggj4.nyec",":version":"rv-qajz-88yq_ptf6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Blanes - Benet Ribas","indicador_refugi":"170237|CASAL_CIVIC_I_COMUNITARI_BLANES_BENET_RIBAS","municipi":"Blanes","codi_municipi":"170237","latitud":"41.6746178","longitud":"2.7900147","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. d\'Espanya, 3","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-eqmv-vubp-6yqt",":version":"rv-kv8r_uj8q_rff9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"170242|PISCINA_MUNICIPAL","municipi":"Bolvir","codi_municipi":"170242","latitud":"42.42031493","longitud":"1.88125142","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"No","adreca":"C. Torrent dels Agustins, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-mdsn~kega-r8ny",":version":"rv-8wzw-y2he~wjz7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Poliesportiu","indicador_refugi":"250576|POLIESPORTIU","municipi":"B\xf2rdes, Es","codi_municipi":"250576","latitud":"42.73751618","longitud":"0.71966274","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de l\'esglesia","tipologia":"Poliesportiu","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-eexq~n2u9-nc39",":version":"rv-h3ta_xm4n.xf7r",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari les Borges Blanques","indicador_refugi":"250582|CASAL_CIVIC_I_COMUNITARI_LES_BORGES_BLANQUES","municipi":"Borges Blanques, les","codi_municipi":"250582","latitud":"41.5184596","longitud":"0.8523082","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de M\xe0rius Torres, 3","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-s26m~r2z5.3h39",":version":"rv-6szs_uaix~ug3c",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"430332|PISCINA_MUNICIPAL","municipi":"Botarell","codi_municipi":"430332","latitud":"41.13679054","longitud":"0.98813643","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. del Corralot, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-8i6h-kvsa-hws8",":version":"rv-j3n8-q7tx.svr8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal de Br\xe0fim","indicador_refugi":"430347|PISCINA_MUNICIPAL_DE_BRAFIM","municipi":"Br\xe0fim","codi_municipi":"430347","latitud":"41.26692707","longitud":"1.34823067","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Cam\xed de l\'Ermita","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-ita4~nuy2~ifq3",":version":"rv-x5ex.kks5-6zgk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic El Centru","indicador_refugi":"430347|CENTRE_CIVIC_EL_CENTRU","municipi":"Br\xe0fim","codi_municipi":"430347","latitud":"41.26791774","longitud":"1.33972879","accessibilitat":"S\xed","aigua":"No","area_descans":"No","adreca":"Av. Catalunya, 30","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-hi7x.3nt5_h8k8",":version":"rv-wxjk-pji9_57ug",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal social","indicador_refugi":"430347|CASAL_SOCIAL","municipi":"Br\xe0fim","codi_municipi":"430347","latitud":"41.26721209","longitud":"1.3393324","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Av. Catalunya, 43 (pl. Prayssac)","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-8dcy_hzer-gfdz",":version":"rv-bdpp~ptm2_bn39",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals de Breda","indicador_refugi":"170274|PISCINES_MUNICIPALS_DE_BREDA","municipi":"Breda","codi_municipi":"170274","latitud":"41.74685199","longitud":"2.56384435","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Av. Catalunya, 46","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-syni-2axa.ymym",":version":"rv-p5qg~d8zs_jgec",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"080253|PISCINA_MUNICIPAL","municipi":"Bruc, el","codi_municipi":"080253","latitud":"41.5841057","longitud":"1.77678205","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Zona esportiva, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-qmq4~e95j_u7uu",":version":"rv-rvz7-ewg9~u576",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala 1 d\'octubre","indicador_refugi":"170280|SALA_1_DOCTUBRE","municipi":"Brunyola i Sant Mart\xed Sapresa","codi_municipi":"170280","latitud":"41.9045","longitud":"2.6842","accessibilitat":"S\xed","aigua":"No","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a del Castell de Brunyola, 5, 17441, Brunyola i Sant Mart\xed Sapresa (Girona)","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-22T18:50:00.000"},{":id":"row-63hs-xrgf.3fth",":version":"rv-uijc_y8hw_ebvm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La Sala","indicador_refugi":"170314|LA_SALA","municipi":"Cabanelles","codi_municipi":"170314","latitud":"42.22915535","longitud":"2.81950988","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Ctra. GIV-5238 km 1","informacio_web":"https://cabanelles.cat/coneix/local-polivalent-la-sala/","tipologia":"Sala Polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-04T07:21:00.000"},{":id":"row-zfh6_bts2.35xc",":version":"rv-fytn-yfdk-g994",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala 1 d\'octubre","indicador_refugi":"430363|SALA_1_D_OCTUBRE","municipi":"Cabra del Camp","codi_municipi":"430363","latitud":"41.395593","longitud":"1.275454","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Raval de la Creu, 9","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-ctfp.rvpf~yxcn",":version":"rv-fth4-r5kv.8xfp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal el Castellet","indicador_refugi":"080291|CASAL_EL_CASTELLET","municipi":"Cabrera de Mar","codi_municipi":"080291","latitud":"41.523255","longitud":"2.396703","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Agust\xed Vendrell i Sol\xe9 11","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-10T09:54:00.000"},{":id":"row-vzae.byzy.xid2",":version":"rv-hh8f~r2y8.tjja",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"080291|PISCINA_MUNICIPAL","municipi":"Cabrera de Mar","codi_municipi":"080291","latitud":"41.524924","longitud":"2.39318","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Riera s/n","tipologia":"Piscina Coberta","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-10T09:56:00.000"},{":id":"row-h9s2_62pg~u4gg",":version":"rv-32xw~xpz4.44ix",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Ilturo","indicador_refugi":"080291|BIBLIOTECA_ILTURO","municipi":"Cabrera de Mar","codi_municipi":"080291","latitud":"41.528643","longitud":"2.392569","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Sant Joan, 8","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-10T09:58:00.000"},{":id":"row-rxke.mgub.dmb7",":version":"rv-7vt2_m2wn_evff",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Pla de l\'Avell\xe0","indicador_refugi":"080291|CENTRE_CIVIC_PLA_DE_LAVELLA","municipi":"Cabrera de Mar","codi_municipi":"080291","latitud":"41.510319153244424","longitud":"2.4002677862480377","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Joan XXIII, 1","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-10T10:02:00.000"},{":id":"row-q2qm_ng34~j5ez",":version":"rv-2jqh.esbs-qnmq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal de Calaf","indicador_refugi":"080312|PISCINA_MUNICIPAL_DE_CALAF","municipi":"Calaf","codi_municipi":"080312","latitud":"41.73493059","longitud":"1.52094693","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Cam\xed de Manresa, 27, 08280 Calaf, Barcelona","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-23kz~6t3g-bws4",":version":"rv-asvp_7y5g-z48j",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala d\'actes Municipal Teresa Escol\xe0 i Torra","indicador_refugi":"080312|SALA_DACTES_MUNICIPAL_TERESA_ESCOLA_I_TORRA","municipi":"Calaf","codi_municipi":"080312","latitud":"41.7339","longitud":"1.51594","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Mestre Manel Giralt, 4","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T11:32:00.000"},{":id":"row-d6jy-bh8j~w922",":version":"rv-ixny-p2cq.kjfj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa Bertran - Esplai de la Gent Gran","indicador_refugi":"080312|CASA_BERTRAN_-_ESPLAI_DE_LA_GENT_GRAN","municipi":"Calaf","codi_municipi":"080312","latitud":"41.7315","longitud":"1.5138","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Passeig Santa Calamanda, 6","informacio_web":"https://www.calaf.cat/adreces-i-telefons/1517-casa-bertran-esplai-de-la-gent-gran.html","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T11:58:00.000"},{":id":"row-9wud.tbsh~pwce",":version":"rv-vgpn_u2vw_tkk2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal social","indicador_refugi":"080348|CASAL_SOCIAL","municipi":"Calders","codi_municipi":"080348","latitud":"41.78985606","longitud":"1.99174475","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Pa\xefsos Catalans, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-rutg~gnu5.539y",":version":"rv-ua3c_9jqr-v2t8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"080348|PISCINA_MUNICIPAL","municipi":"Calders","codi_municipi":"080348","latitud":"41.78662065","longitud":"1.97851754","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Pedraforca, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-ybc7-56sq-v6em",":version":"rv-p2f7-fs7j-666n",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala Cavallerisses (Ajuntament de Caldes de Malavella)","indicador_refugi":"170335|SALA_CAVALLERISSES_AJUNTAMENT_DE_CALDES_DE_MALAVELLA","municipi":"Caldes de Malavella","codi_municipi":"170335","latitud":"41.83899472","longitud":"2.80945001","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de l\'Ajuntament, 20","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-x2r9~fwhs.sr7t",":version":"rv-9bm5-pstj~wqcq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Teatre-Casino municipal","indicador_refugi":"170335|TEATRE_CASINO_MUNICIPAL","municipi":"Caldes de Malavella","codi_municipi":"170335","latitud":"41.83589524","longitud":"2.8090881","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Moss\xe8n Cinto Verdaguer, 11","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-7pf9.9zwy_jy3s",":version":"rv-x29m-sxp2.vqdi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Francesc Ferrer i Gu\xe0rdia","indicador_refugi":"170335|BIBLIOTECA_FRANCESC_FERRER_I_GUARDIA","municipi":"Caldes de Malavella","codi_municipi":"170335","latitud":"41.83869116","longitud":"2.80972652","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de la Llibertat, 6","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-ttc2.diix-tumx",":version":"rv-tszv-s34s_fsyk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa Rosa","indicador_refugi":"170335|CASA_ROSA","municipi":"Caldes de Malavella","codi_municipi":"170335","latitud":"41.83847579","longitud":"2.80858726","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de Vall-Llobera, 4","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-vt8k~fhyw~zwcu",":version":"rv-wnr9.m9k5_zfwm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Caldes De Malavella","indicador_refugi":"170335|PISCINA_CALDES_DE_MALAVELLA","municipi":"Caldes de Malavella","codi_municipi":"170335","latitud":"41.8388576","longitud":"2.80072005","accessibilitat":"No","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Caldes de Malavella, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-ftu3_9g2n~mkjs",":version":"rv-amm2-qv6a_6mqs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Complex esportiu municipal Les Cremades","indicador_refugi":"080333|COMPLEX_ESPORTIU_MUNICIPAL_LES_CREMADES","municipi":"Caldes de Montbui","codi_municipi":"080333","latitud":"41.63681919","longitud":"2.15940458","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Zona esportiva, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-uhbg_3vd4~spkb",":version":"rv-6e4z.565x~ys3x",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament De Caldes De Montbui","indicador_refugi":"080333|AJUNTAMENT_DE_CALDES_DE_MONTBUI","municipi":"Caldes de Montbui","codi_municipi":"080333","latitud":"41.63452522","longitud":"2.16222295","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de la Font del Lle\xf3, 11","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-wy39.y2sr_ei59",":version":"rv-ybkz~x574.7czt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Les Cases Dels Metres, Cafeteria","indicador_refugi":"080333|LES_CASES_DELS_METRES_CAFETERIA","municipi":"Caldes de Montbui","codi_municipi":"080333","latitud":"41.63091502","longitud":"2.16425064","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Mestre Gregori Montserrat, 4","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-wr4r.v7bk.vwuj",":version":"rv-ti9d.sj75~c5m7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca de Caldes de Montbui","indicador_refugi":"080333|BIBLIOTECA_DE_CALDES_DE_MONTBUI","municipi":"Caldes de Montbui","codi_municipi":"080333","latitud":"41.62956185","longitud":"2.16560755","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de Santa Teresa, 3-5","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-es44~h9xh~z5ai",":version":"rv-kt8w.4rwk-ngjt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Esplai de les Escoles velles","indicador_refugi":"080386|ESPLAI_DE_LES_ESCOLES_VELLES","municipi":"Call\xfas","codi_municipi":"080386","latitud":"41.78224035","longitud":"1.78473483","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Jacint Verdaguer, 20, 08262 Call\xfas","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-5in2-uu7q~g3ci",":version":"rv-dihz_vrfq.dxvp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Call\xfas","indicador_refugi":"080386|PARC_CALLUS","municipi":"Call\xfas","codi_municipi":"080386","latitud":"41.7807","longitud":"1.78411013","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. Anselm Clav\xe9, s/n","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-jb5b-wtht.ck5t",":version":"rv-pakp_5bac.h8xd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Passeig del riu","indicador_refugi":"080386|PASSEIG_DEL_RIU","municipi":"Call\xfas","codi_municipi":"080386","latitud":"41.78416013","longitud":"1.78156587","accessibilitat":"S\xed","aigua":"No","area_descans":"No","adreca":"C. del riu, s/n","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-9pzp.dxf8.c7zh",":version":"rv-w7p4~gdev~cjwz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"080386|PISCINA_MUNICIPAL","municipi":"Call\xfas","codi_municipi":"080386","latitud":"41.77976658","longitud":"1.78195699","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de Joaquim Blume, 08262 Call\xfas","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-gipq_nj7c~epr2",":version":"rv-pihk_47mz-4xj8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal del poble","indicador_refugi":"080386|CASAL_DEL_POBLE","municipi":"Call\xfas","codi_municipi":"080386","latitud":"41.7812482","longitud":"1.78314821","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. Anselm Clav\xe9, 21, 08262 Call\xfas","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-2cus~izdu~jtvg",":version":"rv-ftbp~rffe.c5gr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Passeig Anselm Clav\xe9","indicador_refugi":"080386|PASSEIG_ANSELM_CLAVE","municipi":"Call\xfas","codi_municipi":"080386","latitud":"41.7812683","longitud":"1.78353069","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. Anselm Clav\xe9","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-dcqf.ib4t.vbyq",":version":"rv-4g8j-7gtz_wwaz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pisicina municipal Camarles","indicador_refugi":"439039|PISICINA_MUNICIPAL_CAMARLES","municipi":"Camarles","codi_municipi":"439039","latitud":"40.77431618","longitud":"0.66944925","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Cam\xed de la Gravera","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-y723~metp_e4zx",":version":"rv-pshs~ausa_azcx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local social","indicador_refugi":"170353|LOCAL_SOCIAL","municipi":"Cam\xf3s","codi_municipi":"170353","latitud":"42.09453246","longitud":"2.76653499","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Can Pon\xe7, 2","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-2qfj_ptvs-t66i",":version":"rv-75mh-5acy.keqa",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pavell\xf3 municipal","indicador_refugi":"170405|PAVELLO_MUNICIPAL","municipi":"Canet d\'Adri","codi_municipi":"170405","latitud":"42.03321122","longitud":"2.73418311","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. Vella","tipologia":"Poliesportiu","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-n792_m3iq_8u59",":version":"rv-iy7g~7vt8-78mc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Zones d\'ombra passeig mar\xedtim","indicador_refugi":"080403|ZONES_D_OMBRA_PASSEIG_MARITIM","municipi":"Canet de Mar","codi_municipi":"080403","latitud":"41.58750669","longitud":"2.58477282","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. Mar\xedtim de Canet de Mar, s/n","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-c8ke_5urq_xpfa",":version":"rv-b8pk~bhcn-28i9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa Museu Llu\xeds Dom\xe8nech i Montaner","indicador_refugi":"080403|CASA_MUSEU_LLUIS_DOMENECH_I_MONTANER","municipi":"Canet de Mar","codi_municipi":"080403","latitud":"41.58907045","longitud":"2.58126852","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ra. Gavarra, 2","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-npni-thxv~x5t7",":version":"rv-4b9x_qhvp~79uh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Can Santiny\xe0","indicador_refugi":"080403|PARC_DE_CAN_SANTINYA","municipi":"Canet de Mar","codi_municipi":"080403","latitud":"41.5916589","longitud":"2.58687325","accessibilitat":"No","aigua":"No","area_descans":"S\xed","adreca":"C. Mas el Grau, s/n","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-qixp.r3pw_4mmj",":version":"rv-v8b8~8afq.mxic",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bosquet de Vil\xb7la Flora","indicador_refugi":"080403|BOSQUET_DE_VIL_LA_FLORA","municipi":"Canet de Mar","codi_municipi":"080403","latitud":"41.59100204","longitud":"2.57257022","accessibilitat":"No","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Via Cannetum, 4","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-iie3.hjrx~bk5s",":version":"rv-f2dk_gksj-968p",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca de Canet de Mar - P. Gual i Pujadas","indicador_refugi":"080403|BIBLIOTECA_DE_CANET_DE_MAR_P_GUAL_I_PUJADAS","municipi":"Canet de Mar","codi_municipi":"080403","latitud":"41.58820301","longitud":"2.58173917","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ra. Sant Dom\xe8nec, 1A","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-78sv.igc9.8hm5",":version":"rv-8yh5_qi3j.xwj5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La Masoveria de Vil\xb7la Flora","indicador_refugi":"080403|LA_MASOVERIA_DE_VIL_LA_FLORA","municipi":"Canet de Mar","codi_municipi":"080403","latitud":"41.59159928","longitud":"2.57262419","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ra. Gavarra, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-btud_jjsp-8u2s",":version":"rv-469e_3asi~cttm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Tur\xf3 del Drac","indicador_refugi":"080403|PARC_TURO_DEL_DRAC","municipi":"Canet de Mar","codi_municipi":"080403","latitud":"41.59343975","longitud":"2.57213183","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. Busquets, s/n","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-i4ne~x7yc-w78z",":version":"rv-vdj2-bspc-fxy3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"\xc8POCA (Espai polivalent de la Canonja)","indicador_refugi":"439076|EPOCA_ESPAI_POLIVALENT_DE_LA_CANONJA","municipi":"Canonja, la","codi_municipi":"439076","latitud":"41.1203806","longitud":"1.1804432","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Rbla. 15 d\'Abril, 43110 la Canonja","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-w2nk-ydid.xxfx",":version":"rv-i4cw-ydsm_vfuj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca La Canonja","indicador_refugi":"439076|BIBLIOTECA_LA_CANONJA","municipi":"Canonja, la","codi_municipi":"439076","latitud":"41.11949404","longitud":"1.18320823","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. del Castell, 1, 43110 la Canonja","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-xuh3_4mnj.gzsk",":version":"rv-s8xy-hh5b-d34e",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Poliesportiu Josep Canadell i Veciana","indicador_refugi":"439076|POLIESPORTIU_JOSEP_CANADELL_I_VECIANA","municipi":"Canonja, la","codi_municipi":"439076","latitud":"41.12298563","longitud":"1.18152939","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Alcalde Marian Fonts, s/n, 43110 la Canonja","tipologia":"Poliesportiu","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-iejv~6hay~unde",":version":"rv-rv8v.kw2f.ecej",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Canovelles - ve\xefnat Pau Casals","indicador_refugi":"080410|CASAL_CIVIC_I_COMUNITARI_CANOVELLES_VEINAT_PAU_CASALS","municipi":"Canovelles","codi_municipi":"080410","latitud":"41.6167578","longitud":"2.274642","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de Pau Casals, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-ru2q_tcay-v46u",":version":"rv-z4cc~6g9t.yhfi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Canovelles - Can Palots","indicador_refugi":"080410|CASAL_CIVIC_I_COMUNITARI_CANOVELLES_CAN_PALOTS","municipi":"Canovelles","codi_municipi":"080410","latitud":"41.61821","longitud":"2.2789029","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Sant Jordi - ctda. Pg. de Llu\xeds Companys","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-5mv8-ckwk.y8ig",":version":"rv-kh7d~bfgm-tp42",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"430402|PISCINA_MUNICIPAL","municipi":"Cap\xe7anes","codi_municipi":"430402","latitud":"41.10111175","longitud":"0.78341391","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Llaberia, 5","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-xcqa-itir.4ijq",":version":"rv-6s85_v5i3-bthf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Font Cuitora","indicador_refugi":"080446|PARC_DE_LA_FONT_CUITORA","municipi":"Capellades","codi_municipi":"080446","latitud":"41.52688","longitud":"1.6839","accessibilitat":"No","aigua":"No","climatitzacio":"No","area_descans":"No","lavabo":"No","adreca":"C.Pau Casals, s/n","informacio_web":"www.capellades.cat","tipologia":"Parcs i jardins","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-02T09:47:00.000"},{":id":"row-qr7a~zs9f_meyn",":version":"rv-vkmg_v8wk-9nzp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La Cova- Espai jove","indicador_refugi":"080446|LA_COVA_ESPAI_JOVE","municipi":"Capellades","codi_municipi":"080446","latitud":"41.52881","longitud":"1.68379","accessibilitat":"No","aigua":"No","climatitzacio":"S\xed","area_descans":"No","lavabo":"No","adreca":"Pg. Immaculada Concepci\xf3 28","informacio_web":"www.capellades.cat","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-02T09:53:00.000"},{":id":"row-wf3d-npta-5k4v",":version":"rv-jkx3.bjyi_etdg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca el Safareig de Capellades","indicador_refugi":"080446|BIBLIOTECA_EL_SAFAREIG_DE_CAPELLADES","municipi":"Capellades","codi_municipi":"080446","latitud":"41.53091","longitud":"1.6858","accessibilitat":"No","aigua":"No","climatitzacio":"S\xed","area_descans":"No","lavabo":"No","adreca":"C. Pilar 2","informacio_web":"www.capellades.cat","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-02T09:56:00.000"},{":id":"row-5mdm_vbgz_anjf",":version":"rv-kps6~ze6f~sqf7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina blava municipal","indicador_refugi":"080446|PISCINA_BLAVA_MUNICIPAL","municipi":"Capellades","codi_municipi":"080446","latitud":"41.52896","longitud":"1.6844","accessibilitat":"No","aigua":"No","climatitzacio":"No","area_descans":"No","lavabo":"No","adreca":"C. Rec del Corronaire, 8","informacio_web":"www.capellades.cat","tipologia":"Piscines descobertes","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-02T10:01:00.000"},{":id":"row-au8y~y3en_u9sd",":version":"rv-g425_gvbd.sgk8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Punt de lectura Iba\xf1ez Escofet","indicador_refugi":"170427|PUNT_DE_LECTURA_IBANEZ_ESCOFET","municipi":"Capmany","codi_municipi":"170427","latitud":"42.37355551","longitud":"2.92079081","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Major, 8","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-i8sn~cdxj.tk7c",":version":"rv-tkq5-h7qa~dafe",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"170427|PISCINA_MUNICIPAL","municipi":"Capmany","codi_municipi":"170427","latitud":"42.37306453","longitud":"2.92274011","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Orient, 8","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-wzrw~uasn~r25n",":version":"rv-p945.7v7x.k4k7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la gent gran","indicador_refugi":"080462|CASAL_DE_LA_GENT_GRAN","municipi":"Cardedeu","codi_municipi":"080462","latitud":"41.6371375","longitud":"2.35544466","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Av. Rei en Jaume, 55","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-uaej-babm~itf4",":version":"rv-pa8i_y7bv.p3mq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal d\u2019avis de la F\xe0brica Vella-Sala polivalent T\xe8xtil Rase","indicador_refugi":"080462|CASAL_D_AVIS_DE_LA_FABRICA_VELLA_SALA_POLIVALENT_TEXTIL_RASE","municipi":"Cardedeu","codi_municipi":"080462","latitud":"41.6381964","longitud":"2.3628596","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Llinars, 61 (Pl. de les dones treballadores)","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-c95w_43pu_3p5d",":version":"rv-n7fi~tetc~gdhs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Marc de Vilalba","indicador_refugi":"080462|BIBLIOTECA_MARC_DE_VILALBA","municipi":"Cardedeu","codi_municipi":"080462","latitud":"41.63951798","longitud":"2.36093097","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Dr. Klein, 101","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-2c2b~squt.ust5",":version":"rv-jgx7-msij-t55r",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu Arxiu Tom\xe0s Balvey","indicador_refugi":"080462|MUSEU_ARXIU_TOMAS_BALVEY","municipi":"Cardedeu","codi_municipi":"080462","latitud":"41.63792548","longitud":"2.35487785","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Doctor Daurella, 1","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-8hzf~hwsq~7he2",":version":"rv-jcw8_vcs8-haxd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"F\xe0brica de Cultura- T\xe8xtil Rase","indicador_refugi":"080462|FABRICA_DE_CULTURA_TEXTIL_RASE","municipi":"Cardedeu","codi_municipi":"080462","latitud":"41.63801664","longitud":"2.36258306","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Llinars, 61","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-xb2s-9pms.zb5e",":version":"rv-jxek_43gg_kc9m",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai jove La Paki","indicador_refugi":"080462|ESPAI_JOVE_LA_PAKI","municipi":"Cardedeu","codi_municipi":"080462","latitud":"41.63733185705523","longitud":"2.3614781833252434","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. Rei en Jaume 116","informacio_web":"https://www.espaijovelapaki.cat/","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-29T11:43:00.000"},{":id":"row-epe8.vd4j_mm3y",":version":"rv-kvuh.njyp_3gmy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat Municipal de Cardedeu","indicador_refugi":"080462|MERCAT_MUNICIPAL_DE_CARDEDEU","municipi":"Cardedeu","codi_municipi":"080462","latitud":"41.64018162344824","longitud":"2.3560179103160794","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carretera de C\xe0noves, 28","informacio_web":"De dilluns a dissabte de 8 a 14h i divendres tarda de 17 a 20h","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-29T11:48:00.000"},{":id":"row-tiyd.y7bm.p3ff",":version":"rv-msxx-vw8b~8ztu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"AAVV Barri de la Granada","indicador_refugi":"080462|AAVV_BARRI_DE_LA_GRANADA","municipi":"Cardedeu","codi_municipi":"080462","latitud":"41.637305983593905","longitud":"2.365414198664757","accessibilitat":"No","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Joaquim Blume, 9","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-29T11:50:00.000"},{":id":"row-wrwm.zhit_98ss",":version":"rv-rcjy-2uaq_zd6h",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina exterior GIM10","indicador_refugi":"080462|PISCINA_EXTERIOR_GIM10","municipi":"Cardedeu","codi_municipi":"080462","latitud":"41.64952860832077","longitud":"2.3633481949769077","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda Jaume Morat\xf3 22","informacio_web":"https://gim10.cat/","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-29T11:53:00.000"},{":id":"row-abpq-kptc_m9c5",":version":"rv-4y5y_gugf_85vy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Font l\xfadica Cardedeu","indicador_refugi":"080462|FONT_LUDICA_CARDEDEU","municipi":"Cardedeu","codi_municipi":"080462","latitud":"41.63851856280014","longitud":"2.373231612160162","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Parc Bellavista","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-29T11:54:00.000"},{":id":"row-q2wq.dxf7.iav5",":version":"rv-3t6v_gt3g_2ug8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Cardona","indicador_refugi":"080478|CASAL_CIVIC_I_COMUNITARI_CARDONA","municipi":"Cardona","codi_municipi":"080478","latitud":"41.9127851","longitud":"1.6750597","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. de Pau Casals, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-69i4-mnfy.awv6",":version":"rv-a5db-336w_ny74",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala Gal\xe0","indicador_refugi":"170448|SALA_GALA","municipi":"Cass\xe0 de la Selva","codi_municipi":"170448","latitud":"41.88906137","longitud":"2.87517145","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. del Mol\xed, 9, 17244 Cass\xe0 de la Selva, Girona","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-ynmq-728p_48is",":version":"rv-nym6-38t4.8rq5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines de Casserres","indicador_refugi":"080497|PISCINES_DE_CASSERRES","municipi":"Casserres","codi_municipi":"080497","latitud":"42.01343951","longitud":"1.8331343","accessibilitat":"No","aigua":"No","area_descans":"S\xed","adreca":"Ctra. de l\'Espunyola, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-rv9q-kv6v~4cne",":version":"rv-442m_vcmg-xb2j",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat municipal","indicador_refugi":"080517|MERCAT_MUNICIPAL","municipi":"Castellar del Vall\xe8s","codi_municipi":"080517","latitud":"41.6163319","longitud":"2.08767706","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. mercat, s/n","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-8sxn~76fz-33ic",":version":"rv-eat6_sbx3-viqk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal Catalunya","indicador_refugi":"080517|CASAL_CATALUNYA","municipi":"Castellar del Vall\xe8s","codi_municipi":"080517","latitud":"41.61145983","longitud":"2.0915889","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Prat de la Riba, 17","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-zz9g~sf29-bhps",":version":"rv-2uc9-y5ve_dr7a",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal Casino del Rac\xf3","indicador_refugi":"080517|PISCINA_MUNICIPAL_CASINO_DEL_RACO","municipi":"Castellar del Vall\xe8s","codi_municipi":"080517","latitud":"41.62169259","longitud":"2.06878386","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Brutau, 19","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-3d9s~3ugw_qncs",":version":"rv-q6ew_fn6e_uhce",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Edifici El Mirador","indicador_refugi":"080517|EDIFICI_EL_MIRADOR","municipi":"Castellar del Vall\xe8s","codi_municipi":"080517","latitud":"41.61646793","longitud":"2.08725318","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Mirador, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-vxvj~hps7_dak3",":version":"rv-6z7t_u985.gk97",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal Puigvert","indicador_refugi":"080517|PISCINA_MUNICIPAL_PUIGVERT","municipi":"Castellar del Vall\xe8s","codi_municipi":"080517","latitud":"41.61385646","longitud":"2.09166949","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Pa\xeds Valenci\xe0, 1","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-etnb-7gyc~wtph",":version":"rv-fdcg_pshb-6k53",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Penya arlequinada sports","indicador_refugi":"080517|PENYA_ARLEQUINADA_SPORTS","municipi":"Castellar del Vall\xe8s","codi_municipi":"080517","latitud":"41.59377989","longitud":"2.06563694","accessibilitat":"No","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Ca n\'avellaneda, 4","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-ap3z-28ih_nccg",":version":"rv-ybcu.56su-kgrs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal Antoni Tort","indicador_refugi":"080517|BIBLIOTECA_MUNICIPAL_ANTONI_TORT","municipi":"Castellar del Vall\xe8s","codi_municipi":"080517","latitud":"41.61542334","longitud":"2.08789077","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Sala Boadella, 6","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-skvw-2qj3-iwdp",":version":"rv-y4bs-grny.f3rq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal gent gran pla\xe7a major","indicador_refugi":"080517|CASAL_GENT_GRAN_PLACA_MAJOR","municipi":"Castellar del Vall\xe8s","codi_municipi":"080517","latitud":"41.61695682","longitud":"2.08704093","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Major, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-cs6v_97fh_vx5n",":version":"rv-rth8.fica.javx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jocs d\'aigua platja de la balena","indicador_refugi":"080517|JOCS_D_AIGUA_PLATJA_DE_LA_BALENA","municipi":"Castellar del Vall\xe8s","codi_municipi":"080517","latitud":"41.61218561","longitud":"2.09092253","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Prat de la Riba, 13","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-iuhv~w4rj.h8g2",":version":"rv-dha2.uzkb-dza8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Cal Salvador","indicador_refugi":"080556|CAL_SALVADOR","municipi":"Castellcir","codi_municipi":"080556","latitud":"41.760466","longitud":"2.149922","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Major, 37","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-4fxe.m4ku_sk2i",":version":"rv-mzp9~gr5u.ap77",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Quintana","indicador_refugi":"080556|PARC_DE_LA_QUINTANA","municipi":"Castellcir","codi_municipi":"080556","latitud":"41.764659","longitud":"2.147096","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Moian\xe8s, s/n","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-v2xg.74ag.kjh8",":version":"rv-vbuj~hhjp-dyhc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PARC LA GORNAL","indicador_refugi":"080581|PARC_LA_GORNAL","municipi":"Castellet i la Gornal","codi_municipi":"080581","latitud":"41.253845","longitud":"1.590039","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Cr. del Camp. LA  GORNAL","informacio_web":"Obert de forma permanent","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-08T13:49:00.000"},{":id":"row-b9ei~hz3v.7drq",":version":"rv-6ig2_hx2b-9f3h",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PISCINA DE CLARIANA","indicador_refugi":"080581|PISCINA_DE_CLARIANA","municipi":"Castellet i la Gornal","codi_municipi":"080581","latitud":"41.245939","longitud":"1.616942","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Cr. Sant Jaume. Clariana","informacio_web":"https://www.castelletilagornal.cat/","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-08T13:53:00.000"},{":id":"row-b2bw_n53y.bj3j",":version":"rv-eqqv~6bi5.jpqe",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"080608|PISCINA_MUNICIPAL","municipi":"Castellfollit de Riubreg\xf3s","codi_municipi":"080608","latitud":"41.77407637","longitud":"1.43682395","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Escorrals","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-zqfj_h65x~mva3",":version":"rv-dmki~md4x_k65w",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Edifici ajuntament","indicador_refugi":"080594|EDIFICI_AJUNTAMENT","municipi":"Castellfollit del Boix","codi_municipi":"080594","latitud":"41.66678253","longitud":"1.68320373","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Ajuntament, s/n,  08255 Castellfollit del Boix","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-rnnt-u689~h3ms",":version":"rv-4yu3~astp.4tsb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de gent gran","indicador_refugi":"250680|CASAL_DE_GENT_GRAN","municipi":"Castellnou de Seana","codi_municipi":"250680","latitud":"41.64825099","longitud":"0.97117649","accessibilitat":"No","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Major, 1","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-p3f8.uig8~dmdy",":version":"rv-f5dn~9wjj_xmtu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals","indicador_refugi":"250680|PISCINES_MUNICIPALS","municipi":"Castellnou de Seana","codi_municipi":"250680","latitud":"41.6429494","longitud":"0.9698684","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. Diputaci\xf3, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-99kg.pbsv-dnp5",":version":"rv-fudh.e6nu_8jqe",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Cooperativa","indicador_refugi":"080636|COOPERATIVA","municipi":"Castellol\xed","codi_municipi":"080636","latitud":"41.598281","longitud":"1.700475","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"av Uni\xf3 29","informacio_web":"Horari consultable al ajuntament","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T10:27:00.000"},{":id":"row-qqd4.i8tr_8exq",":version":"rv-65ih~b6xw-ry67",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal de Castellol\xed","indicador_refugi":"080636|PISCINA_MUNICIPAL_DE_CASTELLOLI","municipi":"Castellol\xed","codi_municipi":"080636","latitud":"41.597793","longitud":"1.70219","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de la Font, 08719 Castellol\xed, Barcelona","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T10:31:00.000"},{":id":"row-seff.vac8.uixg",":version":"rv-pet9.drsm.37b6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Escoles Velles (sala Polivalent)","indicador_refugi":"080641|ESCOLES_VELLES_SALA_POLIVALENT","municipi":"Castellter\xe7ol","codi_municipi":"080641","latitud":"41.75075335","longitud":"2.12005363","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. dels estudis, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-guji~axf4~7grt",":version":"rv-ivzd~xzku~65re",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins 1 D\'octubre","indicador_refugi":"080641|JARDINS_1_D_OCTUBRE","municipi":"Castellter\xe7ol","codi_municipi":"080641","latitud":"41.75132341","longitud":"2.11971074","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Prat de la Riba","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-fx5f_qhi7_3erz",":version":"rv-4bke-ski5.aqpx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Edifici del Bosquet De Can Sed\xf3","indicador_refugi":"080641|EDIFICI_DEL_BOSQUET_DE_CAN_SEDO","municipi":"Castellter\xe7ol","codi_municipi":"080641","latitud":"41.74967913","longitud":"2.12013094","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Rocacorba, s/n (dins del Bosquet de Can Sed\xf3)","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-xsih_hpeb_tnc6",":version":"rv-ppm3_s8x7_ddaa",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Complex de les piscines municipals d\'estiu","indicador_refugi":"080641|COMPLEX_DE_LES_PISCINES_MUNICIPALS_D_ESTIU","municipi":"Castellter\xe7ol","codi_municipi":"080641","latitud":"41.75476113","longitud":"2.12249464","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Sant Jordi, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-yqqi-63gj-yrxd",":version":"rv-aey2.cipu.42vw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bosquet de Can Sed\xf3","indicador_refugi":"080641|BOSQUET_DE_CAN_SEDO","municipi":"Castellter\xe7ol","codi_municipi":"080641","latitud":"41.75020705","longitud":"2.12016282","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Rocacorba, s/n","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-dv6n_kzc2-kt44",":version":"rv-st9q~esyw_9iwk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai de lectura","indicador_refugi":"080641|ESPAI_DE_LECTURA","municipi":"Castellter\xe7ol","codi_municipi":"080641","latitud":"41.75148673","longitud":"2.12039359","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. vella, 5","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-wt9h_gdbs.vx3i",":version":"rv-u2bj~aswr_hwz8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pavell\xf3 municipal d\'esports Joan Casanovas","indicador_refugi":"080641|PAVELLO_MUNICIPAL_DESPORTS_JOAN_CASANOVAS","municipi":"Castellter\xe7ol","codi_municipi":"080641","latitud":"41.74968011740977","longitud":"2.1184140761405588","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"c/ Diputaci\xf3 s/n","informacio_web":"https://www.castelltersol.cat/","tipologia":"Pavell\xf3 Esportiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-15T14:07:00.000"},{":id":"row-paty_xp9a-urv5",":version":"rv-rnds_j9yg~6h8d",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de Cal Recader","indicador_refugi":"080641|JARDINS_DE_CAL_RECADER","municipi":"Castellter\xe7ol","codi_municipi":"080641","latitud":"41.75135605044313","longitud":"2.120593494980946","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Acc\xe9s per les escoles velles, pla\xe7a dels Estudis","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-16T12:08:00.000"},{":id":"row-47mu~ef5c.trhe",":version":"rv-27h6~kap6_r7c3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"430424|PISCINA_MUNICIPAL","municipi":"Castellvell del Camp","codi_municipi":"430424","latitud":"41.17975873","longitud":"1.09936283","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. de Castellvell del Camp a Reus, 1","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-nxq7~f5fs~39te",":version":"rv-a47g-n6hk~8dwf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal Marina Capdevila","indicador_refugi":"430424|BIBLIOTECA_MUNICIPAL_MARINA_CAPDEVILA","municipi":"Castellvell del Camp","codi_municipi":"430424","latitud":"41.18127172","longitud":"1.09608697","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Sant Joaquim, 1","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-z9c6_22j3_m9hc",":version":"rv-cks8.85rj-55nh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal d\'entitats","indicador_refugi":"430424|CASAL_D_ENTITATS","municipi":"Castellvell del Camp","codi_municipi":"430424","latitud":"41.18072642","longitud":"1.09801469","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Pompeu Fabra, 1","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-ekte-ukht.ehym",":version":"rv-xm2d~j9ks.xrzr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"080654|PISCINA_MUNICIPAL","municipi":"Castellv\xed de la Marca","codi_municipi":"080654","latitud":"41.32670052","longitud":"1.61618937","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de l\'esport, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-ijrq-9myn.vqw7",":version":"rv-tc9v.c4he_6gnv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre social","indicador_refugi":"080667|CENTRE_SOCIAL","municipi":"Castellv\xed de Rosanes","codi_municipi":"080667","latitud":"41.452391","longitud":"1.898324","accessibilitat":"No","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. Mare de D\xe9u de Montserrat, 29 (sala 2 - planta superior)","informacio_web":"https://www.castellviderosanes.cat/","tipologia":"Sala Polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-17T11:38:00.000"},{":id":"row-i4xq.7p66~cf9b",":version":"rv-mjud.jnk4~f3kt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic de Can Sunyer i Valldaina","indicador_refugi":"080667|CENTRE_CIVIC_DE_CAN_SUNYER_I_VALLDAINA","municipi":"Castellv\xed de Rosanes","codi_municipi":"080667","latitud":"41.456128","longitud":"1.949213","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Sant Lloren\xe7 de Morunys, 6 bis","informacio_web":"https://www.castellviderosanes.cat/","tipologia":"Centre C\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-17T11:40:00.000"},{":id":"row-bpi6-y52d_sy2k",":version":"rv-z2ve-euhj-f5dd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal","indicador_refugi":"080667|CASAL","municipi":"Castellv\xed de Rosanes","codi_municipi":"080667","latitud":"41.44978098","longitud":"1.90003081","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a d\'Europa, s/n","informacio_web":"https://www.castellviderosanes.cat/","tipologia":"Sala Polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-17T11:42:00.000"},{":id":"row-nt6u_u2ts~iyw4",":version":"rv-uakx-fcrj_tzi8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre cultural","indicador_refugi":"430430|CENTRE_CULTURAL","municipi":"Catllar, el","codi_municipi":"430430","latitud":"41.17575238","longitud":"1.32765961","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de l\'1 d\'Octubre","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-daz6-bb2v-fvas",":version":"rv-rvjc.8wxf~apk3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala polivalent Urb. Pins Manous","indicador_refugi":"430430|SALA_POLIVALENT_URB_PINS_MANOUS","municipi":"Catllar, el","codi_municipi":"430430","latitud":"41.15033865","longitud":"1.27579549","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Barcelon\xe8s, 5, Urb. Pins Manous","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-giec.zx2v_etwu",":version":"rv-ya6t.a64v.257y",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal Torre d\'en Guiu","indicador_refugi":"430430|PISCINA_MUNICIPAL_TORRE_D_EN_GUIU","municipi":"Catllar, el","codi_municipi":"430430","latitud":"41.1766407","longitud":"1.3281783","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Masieta Queralt, 506","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-wyd6~wtab-ukpw",":version":"rv-rq3x_q25g~hcft",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal Mas de Pallar\xe8s","indicador_refugi":"430430|PISCINA_MUNICIPAL_MAS_DE_PALLARES","municipi":"Catllar, el","codi_municipi":"430430","latitud":"41.17919964","longitud":"1.28361495","accessibilitat":"S\xed","aigua":"No","area_descans":"No","adreca":"Av. Tercera, 4, Urb. Mas de Pallar\xe8s","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-tc8q~57sg.cs3k",":version":"rv-ntux-mt8r~3bqy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Llar de jubilats La Fraternal","indicador_refugi":"171899|LLAR_DE_JUBILATS_LA_FRATERNAL","municipi":"Cellera de Ter, la","codi_municipi":"171899","latitud":"41.96719705","longitud":"2.62188538","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Montserrat, 20","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-8ibc_3r7r-q2ng",":version":"rv-qna4-uypw_pyjh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal gent gran can Ponac","indicador_refugi":"170499|CASAL_GENT_GRAN_CAN_PONAC","municipi":"Celr\xe0","codi_municipi":"170499","latitud":"42.02763733","longitud":"2.87593168","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. de la F\xe0brica, 31","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-11T10:32:00.000"},{":id":"row-c9vj-je7q.efkp",":version":"rv-9bzz-tvvd-tbhu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca de Celr\xe0","indicador_refugi":"170499|BIBLIOTECA_DE_CELRA","municipi":"Celr\xe0","codi_municipi":"170499","latitud":"42.0269","longitud":"2.8737","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Ctra. de Jui\xe0, 46","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T11:23:00.000"},{":id":"row-n5vk_dzdb_e2g3",":version":"rv-gi9q_q5qn_smcr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"082687|PISCINA_MUNICIPAL","municipi":"Cercs","codi_municipi":"082687","latitud":"42.14994735","longitud":"1.8584818","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de Sant Salvador, 2B, Sant Jordi de Cercs","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-xfzw_uddc-rg45",":version":"rv-bhmv~whsd.hm89",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Complex esportiu municipal","indicador_refugi":"250729|COMPLEX_ESPORTIU_MUNICIPAL","municipi":"Cervera","codi_municipi":"250729","latitud":"41.67732713","longitud":"1.2715636","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. de l\'esport, 1","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-f5mp.4z22_t7nv",":version":"rv-s4ff-67ig.g4xk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Cervera","indicador_refugi":"250729|CASAL_CIVIC_I_COMUNITARI_CERVERA","municipi":"Cervera","codi_municipi":"250729","latitud":"42.0150629","longitud":"1.0375184","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Manuel Ibarra, s/n (cant. Pare Claret)","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-uckq~hsgd~dahp",":version":"rv-e3i9_gm8v-2ajz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CLAUSTRE MONESTIR","indicador_refugi":"170502|CLAUSTRE_MONESTIR","municipi":"Cervi\xe0 de Ter","codi_municipi":"170502","latitud":"42.0676","longitud":"2.9123","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"No","lavabo":"No","adreca":"C/ PRIORAT, 29","informacio_web":"Horaris oficina ajuntament","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-08T18:24:00.000"},{":id":"row-bvtc.j6uh.i5yi",":version":"rv-q8i5_ztkt-kn9i",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic El Trull","indicador_refugi":"170519|CENTRE_CIVIC_EL_TRULL","municipi":"Cistella","codi_municipi":"170519","latitud":"42.26832756","longitud":"2.84745429","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Major, 4","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-99v7_52w9-qzyb",":version":"rv-xp8r-44n5-x9z6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"170519|PISCINA_MUNICIPAL","municipi":"Cistella","codi_municipi":"170519","latitud":"42.27014629","longitud":"2.84741268","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Sant Baldiri","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-avi9.7r2c-zfm6",":version":"rv-3ac6.gj36~ieik",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala Polivalent de l\'Ajuntament","indicador_refugi":"250772|SALA_POLIVALENT_DE_LAJUNTAMENT","municipi":"Coll de Narg\xf3","codi_municipi":"250772","latitud":"42.173639038015146","longitud":"1.3156677545116096","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a de l\'ajuntament, 1 (baixos)","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-09T10:37:00.000"},{":id":"row-5jk7.ywky-yxuz",":version":"rv-uxi8-epkb_nfzv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"250772|PISCINA_MUNICIPAL","municipi":"Coll de Narg\xf3","codi_municipi":"250772","latitud":"42.17319526106643","longitud":"1.311955055397028","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Xavier Marot","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-09T10:39:00.000"},{":id":"row-6qkd-p6yt~npbn",":version":"rv-bjzu_5as4.imbf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local de Gent Gran","indicador_refugi":"250772|LOCAL_DE_GENT_GRAN","municipi":"Coll de Narg\xf3","codi_municipi":"250772","latitud":"42.17350476675045","longitud":"1.3156571324184547","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"No","lavabo":"No","adreca":"Pla\xe7a de l\'ajuntament, 1  - edifici annex a l\'ajuntament","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-09T10:41:00.000"},{":id":"row-6sb4_mp82_xb6t",":version":"rv-rrn9-xrzu.2vc5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala Dinosfera","indicador_refugi":"250772|SALA_DINOSFERA","municipi":"Coll de Narg\xf3","codi_municipi":"250772","latitud":"42.173658299691645","longitud":"1.3122050410162356","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Xavier Marot","tipologia":"Equipament Cultural (teatre, auditori, museu)","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-09T10:42:00.000"},{":id":"row-xkdk.mgnh~hszg",":version":"rv-6pxq.94hs_qs2z",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"080692|PISCINA_MUNICIPAL","municipi":"Collbat\xf3","codi_municipi":"080692","latitud":"41.56616654","longitud":"1.82452484","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. Centenari Amadeu Vives, 38","informacio_web":"www.collbato.cat","tipologia":"Piscines descobertes","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-02T11:59:00.000"},{":id":"row-w9gy_yz8j-zjsu",":version":"rv-xrgz-bgjp_qhvu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de cultura - Biblioteca Sibil\xb7la Durfort","indicador_refugi":"080692|CASAL_DE_CULTURA_BIBLIOTECA_SIBIL_LA_DURFORT","municipi":"Collbat\xf3","codi_municipi":"080692","latitud":"41.56848695","longitud":"1.82942919","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pg. Mansuet, 9","informacio_web":"www.collbato.cat","tipologia":"Centre C\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-02T11:56:00.000"},{":id":"row-ssbd~f3ch-tdkw",":version":"rv-9cw6.f7f5_ars9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CASAL","indicador_refugi":"430458|CASAL","municipi":"Colldejou","codi_municipi":"430458","latitud":"41.09907","longitud":"0.8875","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Baix, 42","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-10T12:33:00.000"},{":id":"row-fqnr~kmkt.x3kh",":version":"rv-vqru_xkkk_ucar",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PISCINA MUNICIPAL","indicador_refugi":"430458|PISCINA_MUNICIPAL","municipi":"Colldejou","codi_municipi":"430458","latitud":"41.09903","longitud":"0.88811","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Baix SN","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-10T12:36:00.000"},{":id":"row-vcmv_8rxd_jec9",":version":"rv-ssb2.3jha~r6zk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal de Collsuspina","indicador_refugi":"080706|PISCINA_MUNICIPAL_DE_COLLSUSPINA","municipi":"Collsuspina","codi_municipi":"080706","latitud":"41.82685382","longitud":"2.17676259","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de l\'esport","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-md2j-n9ki_q6av",":version":"rv-z5w3_6s3n~9u9f",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic","indicador_refugi":"170558|CENTRE_CIVIC","municipi":"Colomers","codi_municipi":"170558","latitud":"42.08732289","longitud":"2.98443797","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Catalunya, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-bab6_vf7p_hwvk",":version":"rv-gb5u_ys4e_hexr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local social - piscina municipal","indicador_refugi":"251636|LOCAL_SOCIAL_PISCINA_MUNICIPAL","municipi":"Coma i la Pedra, la","codi_municipi":"251636","latitud":"42.17856958","longitud":"1.59085288","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. de Tuixent, 13","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-pfdw-ygdz~t8rg",":version":"rv-47hq_gmrx.j8rr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bar local social de Conesa","indicador_refugi":"430461|BAR_LOCAL_SOCIAL_DE_CONESA","municipi":"Conesa","codi_municipi":"430461","latitud":"41.518616","longitud":"1.29139","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Major 5, 43427 Conesa","informacio_web":"De dimarts a diumenge de 8 a 20h","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-12T13:07:00.000"},{":id":"row-p9cd~dtqu~6s8f",":version":"rv-9emi_hkb3~y7ut",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal de Constant\xed","indicador_refugi":"430477|BIBLIOTECA_MUNICIPAL_DE_CONSTANTI","municipi":"Constant\xed","codi_municipi":"430477","latitud":"41.15346752","longitud":"1.21174107","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de l\'hospital, 1","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-wjr6-9b46.hp7g",":version":"rv-jdk2-c5p5~yi7g",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala polivalent","indicador_refugi":"080713|SALA_POLIVALENT","municipi":"Copons","codi_municipi":"080713","latitud":"41.63631484","longitud":"1.51925496","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Sala Polivalent, 08289, Copons, Barcelona","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-yxqc~3v4f.sisv",":version":"rv-89zh~r4bj-98zc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"080713|PISCINA_MUNICIPAL","municipi":"Copons","codi_municipi":"080713","latitud":"41.63678861","longitud":"1.51968407","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Folquer a Jorba, s/n, Copons","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-9ufg~iazq_7e2v",":version":"rv-v5h3_kb5z.c4h9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"BIBLIOTECA MUNICIPAL CAN BAR\xd3","indicador_refugi":"080728|BIBLIOTECA_MUNICIPAL_CAN_BARO","municipi":"Corbera de Llobregat","codi_municipi":"080728","latitud":"41.415141","longitud":"1.931187","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"CARRER DE SANT SALVADOR, 25","informacio_web":"https://bibliotecavirtual.diba.cat/es/corbera-de-llobregat-biblioteca-can-baro","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-09T14:47:00.000"},{":id":"row-tag6~xg6f-95au",":version":"rv-bb6h_y998-qde2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CASAL DE LA GENT GRAN LES MAGN\xd2LIES","indicador_refugi":"080728|CASAL_DE_LA_GENT_GRAN_LES_MAGNOLIES","municipi":"Corbera de Llobregat","codi_municipi":"080728","latitud":"41.413052","longitud":"1.928214","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"CARRER PROGR\xc9S, 1","informacio_web":"https://www.corberadellobregat.cat/municipi/equipaments/casal-de-la-gent-gran-les-magnolies-.html","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-09T14:50:00.000"},{":id":"row-2tfj~2bbx~w6ui",":version":"rv-7xi2~xsb9~uzu6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PARC DEL CARRER PAU BRUNA","indicador_refugi":"080728|PARC_DEL_CARRER_PAU_BRUNA","municipi":"Corbera de Llobregat","codi_municipi":"080728","latitud":"41.415196464236004","longitud":"1.9309388694302372","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"CARRER DE SANT ANTONI, 24","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-10T11:17:00.000"},{":id":"row-yvba.ea6q.cq4x",":version":"rv-8c2b_gcis_fyix",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PARC DE LES PALMERES","indicador_refugi":"080728|PARC_DE_LES_PALMERES","municipi":"Corbera de Llobregat","codi_municipi":"080728","latitud":"41.41683534891275","longitud":"1.9207141082401706","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"CARRER DEL RAVAL, 26","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-10T11:23:00.000"},{":id":"row-dmm9-4yqz_strj",":version":"rv-bg8m~a66t~z3ck",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PARC MIQUEL PART\xcd I POL","indicador_refugi":"080728|PARC_MIQUEL_PARTI_I_POL","municipi":"Corbera de Llobregat","codi_municipi":"080728","latitud":"41.415135406532386","longitud":"1.9231559524208195","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"CARRER DE JOSEP TARRADELLES, 24","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-10T11:24:00.000"},{":id":"row-r3qd~3qia.xxpq",":version":"rv-kfip~57wc_zpi4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal","indicador_refugi":"250788|BIBLIOTECA_MUNICIPAL","municipi":"Corbins","codi_municipi":"250788","latitud":"41.69","longitud":"0.695","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. de la Sardana, 3","informacio_web":"https://www.corbins.cat/ca/administracio/ajuntamentcorbins/serveis-municipals/biblioteca/115161.html","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-01T12:10:00.000"},{":id":"row-tq2y_ukey.hmwq",":version":"rv-63h3-bc7q-9949",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal d\'avis","indicador_refugi":"250788|CASAL_D_AVIS","municipi":"Corbins","codi_municipi":"250788","latitud":"41.69059645","longitud":"0.69279113","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. de la Vila, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-6auu.wysz-dnx5",":version":"rv-k29a~dkqe_fphn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala d\'exposicions 1 d\'octubre","indicador_refugi":"430496|SALA_D_EXPOSICIONS_1_D_OCTUBRE","municipi":"Cornudella de Montsant","codi_municipi":"430496","latitud":"41.26483199","longitud":"0.90520501","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Comte de Rius, 10","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-xqzx-bpca~gwyc",":version":"rv-udgi.vma6.fh8z",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals","indicador_refugi":"430496|PISCINES_MUNICIPALS","municipi":"Cornudella de Montsant","codi_municipi":"430496","latitud":"41.26733061","longitud":"0.90437623","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. del Bassot, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-yvrj-sysj~hhw9",":version":"rv-rzkn.adjj-ku6u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Delta de l\'Ebre","indicador_refugi":"439018|BIBLIOTECA_DELTA_DE_L_EBRE","municipi":"Deltebre","codi_municipi":"439018","latitud":"40.72123953","longitud":"0.72165573","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. 1 d\'octubre","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-nip5~ku5k~f3h8",":version":"rv-ejzp.9vt7_dk97",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del riu","indicador_refugi":"439018|PARC_DEL_RIU","municipi":"Deltebre","codi_municipi":"439018","latitud":"40.72130681","longitud":"0.69973254","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc del Riu","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-wph4.r3kt_abj9",":version":"rv-yfye.ucmc_h8ty",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre esportiu del Delta","indicador_refugi":"439018|CENTRE_ESPORTIU_DEL_DELTA","municipi":"Deltebre","codi_municipi":"439018","latitud":"40.72478676","longitud":"0.72649401","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. del Canal","tipologia":"Poliesportiu","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-cb38.f5gn-rpaw",":version":"rv-njed.btyc~wtnd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Zona p\xedcnic Passeig Mar\xedtim","indicador_refugi":"439018|ZONA_PICNIC_PASSEIG_MARITIM","municipi":"Deltebre","codi_municipi":"439018","latitud":"40.72822369","longitud":"0.83996974","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. Mar\xedtim - Riumar","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-5ei8.szyw~k76s",":version":"rv-xr8r-9x8j_mik4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Jos\xe9 del Pas","indicador_refugi":"439018|PARC_JOSE_DEL_PAS","municipi":"Deltebre","codi_municipi":"439018","latitud":"40.71152759","longitud":"0.73976364","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. Paco del Chapero","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-xzcv_ruv6~kjih",":version":"rv-59e2_mtu5.vu36",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mol\xed dels Mirons","indicador_refugi":"439018|MOLI_DELS_MIRONS","municipi":"Deltebre","codi_municipi":"439018","latitud":"40.72392967","longitud":"0.68225204","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Reis Cat\xf2lics","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-3grk.86k2-ubzd",":version":"rv-ik5j-pxuq_ht7r",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Eliseo Vives - Riumar","indicador_refugi":"439018|PLACA_ELISEO_VIVES_RIUMAR","municipi":"Deltebre","codi_municipi":"439018","latitud":"40.72379212","longitud":"0.83788163","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. Eliseo Vives","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-hwfi.bxs7-kugk",":version":"rv-9byx~mp2h~y4gy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Instal\xb7lacions esportives Claudio Flores","indicador_refugi":"439018|INSTAL_LACIONS_ESPORTIVES_CLAUDIO_FLORES","municipi":"Deltebre","codi_municipi":"439018","latitud":"40.72730123","longitud":"0.70044645","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. de la Pau","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-xxmt_vagh-cmg6",":version":"rv-j7ej~jsf3-d5b8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pont Lo Passador","indicador_refugi":"439018|PONT_LO_PASSADOR","municipi":"Deltebre","codi_municipi":"439018","latitud":"40.71415675","longitud":"0.71784204","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pont Lo Passador","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-74z3~fgag.6f58",":version":"rv-qjmq~8yxz~kgms",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Entorn del Pou de Gla\xe7 de Canyamars","indicador_refugi":"080752|ENTORN_DEL_POU_DE_GLAC_DE_CANYAMARS","municipi":"Dosrius","codi_municipi":"080752","latitud":"41.60415043","longitud":"2.45435641","accessibilitat":"S\xed","aigua":"No","area_descans":"No","adreca":"Pou de Gla\xe7 de Canyamars","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-n9k5_sspy.tdfe",":version":"rv-y5qv_f3fj.y2tz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Camins saludables de la Zona esportiva de Can Massuet del Far","indicador_refugi":"080752|CAMINS_SALUDABLES_DE_LA_ZONA_ESPORTIVA_DE_CAN_MASSUET_DEL_FAR","municipi":"Dosrius","codi_municipi":"080752","latitud":"41.61986942","longitud":"2.42754294","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Zona esportiva de Can Massuet del Far","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-24cg-5irm_ykwx",":version":"rv-scyc_miap-htj2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla del Molinot","indicador_refugi":"080752|PLA_DEL_MOLINOT","municipi":"Dosrius","codi_municipi":"080752","latitud":"41.60119049","longitud":"2.44875576","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pla del Molinot","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-xtw4_ariw-kgmb",":version":"rv-ecxe-r6rd~v2i5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal del Centre Esportiu de Dosrius","indicador_refugi":"080752|PISCINA_MUNICIPAL_DEL_CENTRE_ESPORTIU_DE_DOSRIUS","municipi":"Dosrius","codi_municipi":"080752","latitud":"41.59763299","longitud":"2.41174605","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de Can Batlle, 2","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-vurd_b3sq-kwp9",":version":"rv-davm.6z9h_rbk5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala de Plens Ajuntament de Dosrius","indicador_refugi":"080752|SALA_DE_PLENS_AJUNTAMENT_DE_DOSRIUS","municipi":"Dosrius","codi_municipi":"080752","latitud":"41.59468696","longitud":"2.40604281","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Sant Antoni, 1","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-4wqh~vws7.25wx",":version":"rv-iwza-ufez-kxan",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de Can Torres","indicador_refugi":"080752|PLACA_DE_CAN_TORRES","municipi":"Dosrius","codi_municipi":"080752","latitud":"41.59518731","longitud":"2.40820921","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de Can Torres","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-cbki-eyyr_t2m9",":version":"rv-2j5u-42st_84rf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de la Germandat","indicador_refugi":"080752|PLACA_DE_LA_GERMANDAT","municipi":"Dosrius","codi_municipi":"080752","latitud":"41.60090734","longitud":"2.44675635","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. de la Germandat","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-6w6e_3gpv.ucfy",":version":"rv-mxba_a5mt_7s6u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina p\xfablica municipal de Duesaig\xfces","indicador_refugi":"430537|PISCINA_PUBLICA_MUNICIPAL_DE_DUESAIGUES","municipi":"Duesaig\xfces","codi_municipi":"430537","latitud":"41.14554736","longitud":"0.93129974","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de Baix, 30","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-f6mn-3q7v_6s9e",":version":"rv-96h4-kf6n.mnu4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Alfol\xed Museu de L\'Escala","indicador_refugi":"170622|ALFOLI_MUSEU_DE_L_ESCALA","municipi":"Escala, l\'","codi_municipi":"170622","latitud":"42.07206","longitud":"3.07531","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Alfol\xed, 6","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-des7.9yc2.v6bt",":version":"rv-bc7d-kvhk~m6fu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Llar dels Jubilats","indicador_refugi":"170622|BIBLIOTECA_LLAR_DELS_JUBILATS","municipi":"Escala, l\'","codi_municipi":"170622","latitud":"42.122377","longitud":"3.13141","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Escoles, 5","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-pqww-kx7n_7ekk",":version":"rv-qaup~a5nf-kequ",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca V\xedctor Catal\xe0","indicador_refugi":"170622|BIBLIOTECA_VICTOR_CATALA","municipi":"Escala, l\'","codi_municipi":"170622","latitud":"42.125845","longitud":"3.132564","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. V\xedctor Catal\xe0, 10","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-ijnw.ia47.jgyp",":version":"rv-wcvs~wbbs_iui5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal Mn. Ramon Muntanyola","indicador_refugi":"430542|BIBLIOTECA_MUNICIPAL_MN_RAMON_MUNTANYOLA","municipi":"Espluga de Francol\xed, l\'","codi_municipi":"430542","latitud":"41.39632894","longitud":"1.10366417","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de Torres Jordi, 16","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-i2e7~7pbf~ivvb",":version":"rv-skf6-6kfx.7kpz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Llar de Jubilats i Pensionistes","indicador_refugi":"430542|LLAR_DE_JUBILATS_I_PENSIONISTES","municipi":"Espluga de Francol\xed, l\'","codi_municipi":"430542","latitud":"41.39655932","longitud":"1.10376743","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de l\'Esgl\xe9sia, 5, 1a planta","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-2zhq_bkfw_nwdx",":version":"rv-rzim.drrk-zjcb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"430542|PISCINA_MUNICIPAL","municipi":"Espluga de Francol\xed, l\'","codi_municipi":"430542","latitud":"41.39531004","longitud":"1.09663901","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de Prat de la Riba, 1","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-7u6n.hb96.wk39",":version":"rv-x4g6_mcf7-if4b",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala de la societat La Fraternal","indicador_refugi":"170643|SALA_DE_LA_SOCIETAT_LA_FRATERNAL","municipi":"Espolla","codi_municipi":"170643","latitud":"42.39072451","longitud":"3.00081304","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. del Carme, 1","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-4mkx.b37f~d9bk",":version":"rv-wqhy~zqim-a9ac",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal d\'Espolla","indicador_refugi":"170643|PISCINA_MUNICIPAL_D_ESPOLLA","municipi":"Espolla","codi_municipi":"170643","latitud":"42.39305609","longitud":"2.99773974","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Figueres, 18","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-qbzh.d4n3-ct9b",":version":"rv-x8z5~32am.vhgx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai 1 d\'octubre","indicador_refugi":"170656|ESPAI_1_D_OCTUBRE","municipi":"Esponell\xe0","codi_municipi":"170656","latitud":"42.17737935159","longitud":"2.79543657","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. U d\'Ocutbre, 1","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-pqd6_ki9k-a34d",":version":"rv-3p9h~32f5_r5gi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local entitats","indicador_refugi":"080787|LOCAL_ENTITATS","municipi":"Espunyola, l\'","codi_municipi":"080787","latitud":"42.0541426","longitud":"1.76793475","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. de Solsona C26, Km 136","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-sgr2.expw.8h8g",":version":"rv-ehcz~jgsg_8ha7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local de la gent gran","indicador_refugi":"080790|LOCAL_DE_LA_GENT_GRAN","municipi":"Estany, l\'","codi_municipi":"080790","latitud":"41.86848462","longitud":"2.11126359","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Balmes, 30","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-a77n_u893-aghw",":version":"rv-h7ui_ti2n.mp32",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de la Nevera","indicador_refugi":"430555|PLACA_DE_LA_NEVERA","municipi":"Falset","codi_municipi":"430555","latitud":"41.143924","longitud":"0.822558","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Francesc Rispa i Perpiny\xe0","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-9p2n-s9hk_27kn",":version":"rv-m3da_4k3d.rai3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bosquet del Tancat","indicador_refugi":"430555|BOSQUET_DEL_TANCAT","municipi":"Falset","codi_municipi":"430555","latitud":"41.1467852","longitud":"0.82479773","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Av. de Reus, s/n","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-x7qu.sf2c_xqtq",":version":"rv-py7m-97wh~j3hz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca p\xfablica Salvador Estrem i Fa","indicador_refugi":"430555|BIBLIOTECA_PUBLICA_SALVADOR_ESTREM_I_FA","municipi":"Falset","codi_municipi":"430555","latitud":"41.14535775","longitud":"0.81878812","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Baix, 41","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-s4kd_grxt-yvix",":version":"rv-dcgi~8pfv~6qug",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Euterpe - zona esportiva","indicador_refugi":"430555|EUTERPE_ZONA_ESPORTIVA","municipi":"Falset","codi_municipi":"430555","latitud":"41.144596","longitud":"0.819118","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Josep Camp\xe0s, s/n","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-6yjh.5nhk_iit2",":version":"rv-ztf3.2r53-pvbx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Refugi Clim\xe0tic Barranc de la Vila","indicador_refugi":"430555|REFUGI_CLIMATIC_BARRANC_DE_LA_VILA","municipi":"Falset","codi_municipi":"430555","latitud":"41.145067","longitud":"0.818427","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a de Neus Catal\xe0 s/n","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T12:03:00.000"},{":id":"row-z8ig-g3ty_uqz2",":version":"rv-9vj9-zjrr~9yei",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala polivalent","indicador_refugi":"430574|SALA_POLIVALENT","municipi":"Febr\xf3, la","codi_municipi":"430574","latitud":"41.27715159","longitud":"1.0033987","accessibilitat":"No","aigua":"S\xed","area_descans":"S\xed","adreca":"C. canyada, 7","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-267k.8phw~t4kp",":version":"rv-ir4k.dkg6_fvw4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"081347|PISCINA_MUNICIPAL","municipi":"Figar\xf3-Montmany","codi_municipi":"081347","latitud":"41.71485491","longitud":"2.26999693","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Ctra. de Ribes, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-smvf_tpr7_fc9u",":version":"rv-hemj.bx5a.ybvh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala Nou Casino","indicador_refugi":"081347|SALA_NOU_CASINO","municipi":"Figar\xf3-Montmany","codi_municipi":"081347","latitud":"41.720814","longitud":"2.272708","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Anna Bosch, s/n","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-mpug-3d8d_mw4x",":version":"rv-dawp_v3z3~yd79",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"430580|PISCINA_MUNICIPAL","municipi":"Figuera, la","codi_municipi":"430580","latitud":"41.21515523","longitud":"0.73001309","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de la piscina, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-92q2-vern.qd4c",":version":"rv-c4sc.jdsi-uzp4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Joaquim Xirau","indicador_refugi":"170669|CENTRE_CIVIC_JOAQUIM_XIRAU","municipi":"Figueres","codi_municipi":"170669","latitud":"42.26974","longitud":"2.98018","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Vilatenim, 45","informacio_web":"https://www.figueres.cat/temes/accio-civica/centrescivicsmunicipals/centrecivicjoaquimxirau","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-09T14:27:00.000"},{":id":"row-jivk.f7rv~eg49",":version":"rv-va6e-rtah~rw3z",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Fages de Climent","indicador_refugi":"170669|BIBLIOTECA_FAGES_DE_CLIMENT","municipi":"Figueres","codi_municipi":"170669","latitud":"42.26576","longitud":"2.95711","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a del Sol, 11, 17600 FIGUERES","informacio_web":"https://www.bibliotecadefigueres.cat/","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-09T14:31:00.000"},{":id":"row-83vs.z626.kbz9",":version":"rv-t5dm_3twz_x66h",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu de l\'Empord\xe0","indicador_refugi":"170669|MUSEU_DE_LEMPORDA","municipi":"Figueres","codi_municipi":"170669","latitud":"42.26679","longitud":"2.962","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Rambla, 2, 17600 Figueres","informacio_web":"https://www.museuemporda.org/","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-09T14:50:00.000"},{":id":"row-857k~fdkv-rh8f",":version":"rv-m4ap_6djy-tu9r",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Creu de la Ma","indicador_refugi":"170669|CENTRE_CIVIC_CREU_DE_LA_MA","municipi":"Figueres","codi_municipi":"170669","latitud":"42.26042","longitud":"2.96569","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Remei Bosch, sn","informacio_web":"https://www.figueres.cat/temes/accio-civica/centrescivicsmunicipals/centre-civic-creu-de-la-ma","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-10T08:04:00.000"},{":id":"row-6hpy~z9x2-mb6x",":version":"rv-g4xy_gg69.h3r4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Seu del Consell Municipal de Vilatenim","indicador_refugi":"170669|SEU_DEL_CONSELL_MUNICIPAL_DE_VILATENIM","municipi":"Figueres","codi_municipi":"170669","latitud":"42.26861","longitud":"2.99441","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ Nou, 9 de Vilatenim 17484","informacio_web":"https://www.figueres.cat/figueres/equipaments/551986","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-10T08:17:00.000"},{":id":"row-yaqf.fnmt~zfxh",":version":"rv-bpf6_kwp2-iqpv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Esgl\xe9sia de Sant Pere","indicador_refugi":"170669|ESGLESIA_DE_SANT_PERE","municipi":"Figueres","codi_municipi":"170669","latitud":"42.2679969192312","longitud":"2.959966865480408","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de l\'Esgl\xe9sia, 8, 17600 Figueres, Girona","informacio_web":"http://www.bisbatgirona.cat/ca/parroquies/c/1277-figueres-sant-pere.html","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-19T12:09:00.000"},{":id":"row-7ncq_bwfp_jyug",":version":"rv-hg5g~nw6b~6ufg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Font lluminosa","indicador_refugi":"170669|FONT_LLUMINOSA","municipi":"Figueres","codi_municipi":"170669","latitud":"42.266089964459944","longitud":"2.9634607121850323","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Doctor Ernest Vila, 17600 Figueres, Girona","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-19T12:38:00.000"},{":id":"row-wtje.645p.r3zm",":version":"rv-qz6z~3s87_6hb7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Palmera","indicador_refugi":"170669|PLACA_PALMERA","municipi":"Figueres","codi_municipi":"170669","latitud":"42.26737046123455","longitud":"2.9643729256804328","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"17600 Figueres, Girona","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-19T12:39:00.000"},{":id":"row-y5m2_8vgf-r6m9",":version":"rv-u2y4-r9fe~9d55",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Bosc","indicador_refugi":"170669|PARC_BOSC","municipi":"Figueres","codi_municipi":"170669","latitud":"42.26807658251675","longitud":"2.955221185582616","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda de Salvador Dal\xed i Dom\xe8nech, 117, 17600 Figueres, Girona","informacio_web":"http://www.figueres.cat/","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-19T12:41:00.000"},{":id":"row-5jc4_nay3.wsen",":version":"rv-wnzz~uj4c~vner",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"la pineda de la Pujada del Castell","indicador_refugi":"170669|LA_PINEDA_DE_LA_PUJADA_DEL_CASTELL","municipi":"Figueres","codi_municipi":"170669","latitud":"42.27239098238683","longitud":"2.9512133619481893","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pujada del Castell, s/n, 17600 Figueres, Girona","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-19T12:43:00.000"},{":id":"row-zw6x-bwgv~vang",":version":"rv-m8mw-s5f8~ecj8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"el Parc de les Aig\xfces","indicador_refugi":"170669|EL_PARC_DE_LES_AIGUES","municipi":"Figueres","codi_municipi":"170669","latitud":"42.27248035403553","longitud":"2.95962455635969","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda de la Costa Brava, 6, 17600 Figueres, Girona","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-19T12:45:00.000"},{":id":"row-j3m4.8z7h-irbt",":version":"rv-a24y.ga2f_knzc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"els Jardins Puig Pujades","indicador_refugi":"170669|ELS_JARDINS_PUIG_PUJADES","municipi":"Figueres","codi_municipi":"170669","latitud":"42.26521488495962","longitud":"2.9624260851942665","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Sant Ll\xe0tzer, 7I, 17600 Figueres, Girona","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-19T12:46:00.000"},{":id":"row-444k~37c2~38jn",":version":"rv-ipq7_2ptp.skss",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Auditori Museu Empord\xe0","indicador_refugi":"170669|AUDITORI_MUSEU_EMPORDA","municipi":"Figueres","codi_municipi":"170669","latitud":"42.26682657863993","longitud":"2.9619754740103597","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"La Rambla, 2, 17600 Figueres, Girona","informacio_web":"http://www.museuemporda.org/","tipologia":"Equipament Cultural (teatre, auditori, museu)","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-19T12:50:00.000"},{":id":"row-umvp-ac4r_qn8i",":version":"rv-76wf_sjdr~q3ni",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local Social","indicador_refugi":"250925|LOCAL_SOCIAL","municipi":"Floresta, la","codi_municipi":"250925","latitud":"41.509475","longitud":"0.920055","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Sant Blai, 20","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-09T11:39:00.000"},{":id":"row-dyjd_vnw4_b9bw",":version":"rv-n7xj.mjc2~tq49",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"\\"Les Escoles\\"","indicador_refugi":"170681|LES_ESCOLES","municipi":"Foix\xe0","codi_municipi":"170681","latitud":"42.03954247","longitud":"2.99831402","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. de les Escoles, 1","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-vf5f-wgpn.d58m",":version":"rv-ixcy.ztkt~468f",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals de Folgueroles","indicador_refugi":"080832|PISCINES_MUNICIPALS_DE_FOLGUEROLES","municipi":"Folgueroles","codi_municipi":"080832","latitud":"41.93945202","longitud":"2.31291308","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Sajolida, 1","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-tpcp-2rcf_hsvp",":version":"rv-2jtq_nmk6~8bj2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PISCINA MUNICIPAL FONTCOBERTA","indicador_refugi":"170715|PISCINA_MUNICIPAL_FONTCOBERTA","municipi":"Fontcoberta","codi_municipi":"170715","latitud":"42.1419","longitud":"2.7742","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Pau Casals 16","informacio_web":"https://turisme.plaestany.cat/item-turistic/piscina-municipal-de-melianta/","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-08T18:11:00.000"},{":id":"row-dm6n_68jj~2v2n",":version":"rv-59cs-y7ri-pifz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina de Foradada","indicador_refugi":"250946|PISCINA_DE_FORADADA","municipi":"Foradada","codi_municipi":"250946","latitud":"41.87612959","longitud":"1.01082501","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Afores, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-9ikr.4hjk.sig8",":version":"rv-xkib_hvfr.p2mb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local cultural de For\xe8s","indicador_refugi":"430614|LOCAL_CULTURAL_DE_FORES","municipi":"For\xe8s","codi_municipi":"430614","latitud":"41.49338564","longitud":"1.23560438","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Pla de la bassa, 21","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-jkn7~69ua_i46i",":version":"rv-er9b~d7n4.xaf7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Social","indicador_refugi":"170736|CENTRE_SOCIAL","municipi":"Fornells de la Selva","codi_municipi":"170736","latitud":"41.93435189","longitud":"2.81204352","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Vicens Vives, 1 1r pis - 17458 Fornells de la Selva","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-8htw.68n5~giz6",":version":"rv-ug96~9bri~54sh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Pa\xefssos Catalans","indicador_refugi":"170736|PLACA_PAISSOS_CATALANS","municipi":"Fornells de la Selva","codi_municipi":"170736","latitud":"41.93137683254071","longitud":"2.810152218450131","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Pa\xefssos Catalans","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-06T16:27:00.000"},{":id":"row-khau.ny8e-rihh",":version":"rv-ajcu~w5c2_y9rv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Passatge Torola","indicador_refugi":"170736|PARC_PASSATGE_TOROLA","municipi":"Fornells de la Selva","codi_municipi":"170736","latitud":"41.932334831240055","longitud":"2.8045128552777885","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Passatge Torola","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-06T16:30:00.000"},{":id":"row-pxkz-rqaz-6h8m",":version":"rv-e42r-he34_8uui",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PISCINA MUNICIPAL","indicador_refugi":"170741|PISCINA_MUNICIPAL","municipi":"Forti\xe0","codi_municipi":"170741","latitud":"42.2405","longitud":"3.0425","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Cam\xed de la Gallinera, sn","informacio_web":"fortia.cat","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T16:53:00.000"},{":id":"row-n3zi_5t3r~dpzq",":version":"rv-xjfn-3ah8.heek",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la Gent Gran Miquel Ruiz","indicador_refugi":"170741|CASAL_DE_LA_GENT_GRAN_MIQUEL_RUIZ","municipi":"Forti\xe0","codi_municipi":"170741","latitud":"42.2421","longitud":"3.0407","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a de l\'Esgl\xe9sia, 2","informacio_web":"fortia.cat","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-18T16:43:00.000"},{":id":"row-a7x4_zpm2~a5ya",":version":"rv-uz8n_uutn-e6p4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal d\'avis i centre social de Bellavista","indicador_refugi":"080863|CASAL_D_AVIS_I_CENTRE_SOCIAL_DE_BELLAVISTA","municipi":"Franqueses del Vall\xe8s, les","codi_municipi":"080863","latitud":"41.61920035","longitud":"2.29674694","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. d\'Extremadura, 32-38 (interior d\'illa)","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-k849_v9uf.cbxx",":version":"rv-esxf~7hhu.2szw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Les Franqueses del Vall\xe8s","indicador_refugi":"080863|CASAL_CIVIC_I_COMUNITARI_LES_FRANQUESES_DEL_VALLES","municipi":"Franqueses del Vall\xe8s, les","codi_municipi":"080863","latitud":"41.62887483","longitud":"2.29599608","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. de Santa Eul\xe0lia, 7","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-swii_zxav.p76i",":version":"rv-55uk_rm35-id4e",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal municipal","indicador_refugi":"430629|CASAL_MUNICIPAL","municipi":"Freginals","codi_municipi":"430629","latitud":"40.67165396","longitud":"0.52087754","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Moss\xe8n Miquel, 18","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-jgh9.pueh-9pmv",":version":"rv-tezz_96bi~bn54",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"430629|PISCINA_MUNICIPAL","municipi":"Freginals","codi_municipi":"430629","latitud":"40.67095924","longitud":"0.51723431","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pla de Corany, 34","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-men9_5fc6-ekb9",":version":"rv-7xcu_ymu4_xcvf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pavell\xf3 municipal","indicador_refugi":"430629|PAVELLO_MUNICIPAL","municipi":"Freginals","codi_municipi":"430629","latitud":"40.66997854","longitud":"0.51959679","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Sant Antoni, s/n","tipologia":"Poliesportiu","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-9srm_57fu_7jw9",":version":"rv-n8hk.w2a2.37d9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala polivalent de l\'ajuntament","indicador_refugi":"080902|SALA_POLIVALENT_DE_L_AJUNTAMENT","municipi":"Gai\xe0","codi_municipi":"080902","latitud":"41.91653221","longitud":"1.92523955","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de l\'Ajuntament, 1 (bx)","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-neqn_25e9_u56s",":version":"rv-3jdq.v3fd_tni5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal de Gandesa","indicador_refugi":"430640|PISCINA_MUNICIPAL_DE_GANDESA","municipi":"Gandesa","codi_municipi":"430640","latitud":"41.05858967","longitud":"0.4398056","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Av. Joan Perucho, 1","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-pz4m-diwc.jpdv",":version":"rv-mhaq_k7zs-ccy4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal del Maig","indicador_refugi":"430653|CASAL_DEL_MAIG","municipi":"Garcia","codi_municipi":"430653","latitud":"41.13696156","longitud":"0.6495972","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Centre, 6","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-kvbg-9392-aisd",":version":"rv-vnt7~zcq7-9vdb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal municipal","indicador_refugi":"430666|CASAL_MUNICIPAL","municipi":"Garidells, els","codi_municipi":"430666","latitud":"41.2073674","longitud":"1.24749148","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Av. Catalunya, 2","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-4dvh_uw6y-jtwm",":version":"rv-75i2~inzh.27tw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"080885|PISCINA_MUNICIPAL","municipi":"Garriga, la","codi_municipi":"080885","latitud":"41.68841194030479","longitud":"2.282217153618451","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Bassal s/n, 08530 La Garriga","informacio_web":"https://www.egoralagarriga.cat/","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-22T08:40:00.000"},{":id":"row-bqqq.nw35_7u5u",":version":"rv-7r3y-7j8n~7285",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca N\xfaria Alb\xf3","indicador_refugi":"080885|BIBLIOTECA_NURIA_ALBO","municipi":"Garriga, la","codi_municipi":"080885","latitud":"41.685701534764746","longitud":"2.2853785951369545","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer del Centra n\xfam. 49, 08530 La Garriga","informacio_web":"https://bibliotecavirtual.diba.cat/ca/garriga-la-biblioteca-nuria-albo","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-22T08:44:00.000"},{":id":"row-9ieq.nxvv~87xx",":version":"rv-4i5n~6srm-id4f",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala La Llar","indicador_refugi":"170754|SALA_LA_LLAR","municipi":"Garrig\xe0s","codi_municipi":"170754","latitud":"42.1909072","longitud":"2.954752","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Gran, 26, Edifici 1 d\'octubre, 17476 Garrig\xe0s","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-ucvr.yq6y~482h",":version":"rv-6uic~ydne~zixs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic de l\'Escorxador","indicador_refugi":"080919|CENTRE_CIVIC_DE_L_ESCORXADOR","municipi":"Gelida","codi_municipi":"080919","latitud":"41.44165714","longitud":"1.85805068","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Escorxador, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-ktbg_3itn_yxj7",":version":"rv-vu5r-x3gd_erbb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la gent gran","indicador_refugi":"080919|CASAL_DE_LA_GENT_GRAN","municipi":"Gelida","codi_municipi":"080919","latitud":"41.44022426","longitud":"1.86434101","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Major, 10","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-mm3x~r7cs~bj3h",":version":"rv-krme-wpxz_2jeq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre d\'iniciatives culturals (cic)","indicador_refugi":"080919|CENTRE_D_INICIATIVES_CULTURALS_CIC","municipi":"Gelida","codi_municipi":"080919","latitud":"41.4398337","longitud":"1.86393882","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. del Moss\xe8n Jaume Via, 17","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-ztg8.pucy-xjis",":version":"rv-84dk_mdah.7cjw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CENTRE CULTURAL / BIBLIOTECA","indicador_refugi":"080919|CENTRE_CULTURAL_-_BIBLIOTECA","municipi":"Gelida","codi_municipi":"080919","latitud":"41.440249","longitud":"1.862851","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"No","adreca":"CARRER MAJOR,","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-03T09:30:00.000"},{":id":"row-u3aq_3nxy-7jxr",":version":"rv-tzub.hxp6-zz85",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local social Sant Isidre De Gimenells","indicador_refugi":"259123|LOCAL_SOCIAL_SANT_ISIDRE_DE_GIMENELLS","municipi":"Gimenells i el Pla de la Font","codi_municipi":"259123","latitud":"41.65366757","longitud":"0.38937456","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C./ Parc, s/n    25112 - Gimenells (Lleida)","tipologia":"Sala Polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-02T10:01:00.000"},{":id":"row-rmx9-e5gw_935b",":version":"rv-aqk8~q5n9_hcec",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Abacus Cooperativa","indicador_refugi":"170792|ABACUS_COOPERATIVA","municipi":"Girona","codi_municipi":"170792","latitud":"41.98498253","longitud":"2.82300466","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Rda. Sant Antoni Maria Claret, 39-41, 17002 Girona","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-gutf-fmsf.ypch",":version":"rv-qtjp-mxnv~2wfz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Escola \xc0gora","indicador_refugi":"170792|ESCOLA_AGORA","municipi":"Girona","codi_municipi":"170792","latitud":"41.97116915","longitud":"2.81013778","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pg. Ramon Berenguer II, 4 17005 Girona","tipologia":"Centre educatiu","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-pky8_mg2u~3hvc",":version":"rv-iyx8~jbv3_wr5x",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Esgl\xe9sia parroquial de Sant Narc\xeds","indicador_refugi":"170792|ESGLESIA_PARROQUIAL_DE_SANT_NARCIS","municipi":"Girona","codi_municipi":"170792","latitud":"41.97536399","longitud":"2.81071131","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Assumpci\xf3, 18","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-ekem_9pw2-zv3g",":version":"rv-nt4i-cnvm_6m6h",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu del cinema de Girona (zona vest\xedbul i sales d\'exposicions temporals)","indicador_refugi":"170792|MUSEU_DEL_CINEMA_DE_GIRONA_ZONA_VESTIBUL_I_SALES_D_EXPOSICIONS_TEMPORALS","municipi":"Girona","codi_municipi":"170792","latitud":"41.98381651","longitud":"2.82325239","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de la S\xe9quia, 1, 17001 Girona","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-mczu~erjp_fxsd",":version":"rv-txt7-rgjq_7y4a",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Pla de Palau","indicador_refugi":"170792|CENTRE_CIVIC_PLA_DE_PALAU","municipi":"Girona","codi_municipi":"170792","latitud":"41.97117832","longitud":"2.81904264","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Saragossa, 27, 17002 Girona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-c5kg~scgy-ectc",":version":"rv-xwzq.tikw-iv7t",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins d\'en Pablito","indicador_refugi":"170792|JARDINS_D_EN_PABLITO","municipi":"Girona","codi_municipi":"170792","latitud":"41.97720089","longitud":"2.8239443","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Jdins. d\'en Pablito","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-q4t7~a3x2_adeb",":version":"rv-kskq_7rnn~egg5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai c\xedvic Can Gibert del Pla","indicador_refugi":"170792|ESPAI_CIVIC_CAN_GIBERT_DEL_PLA","municipi":"Girona","codi_municipi":"170792","latitud":"41.97156559","longitud":"2.80711284","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Taga, 4, 17006 Girona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-2tij-frv2.6ie5",":version":"rv-h4jh~tica.j4ay",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Migdia","indicador_refugi":"170792|PARC_DEL_MIGDIA","municipi":"Girona","codi_municipi":"170792","latitud":"41.97356121","longitud":"2.81793983","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Pau Vila i Dinar\xe8s, 17003 Girona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-4n7n~3ap2-x94e",":version":"rv-hsnh.4h7z_hdms",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Passeig Arqueol\xf2gic","indicador_refugi":"170792|PASSEIG_ARQUEOLOGIC","municipi":"Girona","codi_municipi":"170792","latitud":"41.98822954","longitud":"2.82678441","accessibilitat":"No","aigua":"No","area_descans":"S\xed","adreca":"Pg. Arqueol\xf2gic","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-5676.f9pk~2mub",":version":"rv-rcic_w442-u3zg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu d\'Hist\xf2ria dels Jueus (vest\xedbul)","indicador_refugi":"170792|MUSEU_D_HISTORIA_DELS_JUEUS_VESTIBUL","municipi":"Girona","codi_municipi":"170792","latitud":"41.98614738","longitud":"2.82463485","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de la For\xe7a 8, 17004 Girona","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-2aav~ugdk~qjn7",":version":"rv-g7xv_bgjk~xn8n",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Ter","indicador_refugi":"170792|CENTRE_CIVIC_TER","municipi":"Girona","codi_municipi":"170792","latitud":"41.99397547","longitud":"2.80881092","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Can Sunyer, 46, 17007 Girona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-drm2-kfbg~yuzq",":version":"rv-5gqq-8bwf-3nx2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Pedret","indicador_refugi":"170792|CENTRE_CIVIC_PEDRET","municipi":"Girona","codi_municipi":"170792","latitud":"41.99723561","longitud":"2.82470673","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Pedret, 152-156, 17007 Girona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-suej-i7ny.knib",":version":"rv-ympc~nd46_9z4t",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Devesa","indicador_refugi":"170792|PARC_DE_LA_DEVESA","municipi":"Girona","codi_municipi":"170792","latitud":"41.98763788","longitud":"2.81557407","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pg. de la Devesa, 38, 17007 Girona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-k2uj_49zu-qqj9",":version":"rv-qpmr-a22v_tdb9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Just M. Casero","indicador_refugi":"170792|BIBLIOTECA_JUST_M_CASERO","municipi":"Girona","codi_municipi":"170792","latitud":"42.01247562","longitud":"2.82522842","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. de l\'Om, 1, 17007 Girona","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-ayes.f4mt~8gxb",":version":"rv-d6p7.wfhx.pc7s",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Santa Eug\xe8nia","indicador_refugi":"170792|CENTRE_CIVIC_SANTA_EUGENIA","municipi":"Girona","codi_municipi":"170792","latitud":"41.97801237","longitud":"2.80697762","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Santa Eug\xe8nia, 146, 17006 Girona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-y7fp_sf7b~y343",":version":"rv-2jm2~i9df~87s6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat del Lle\xf3","indicador_refugi":"170792|MERCAT_DEL_LLEO","municipi":"Girona","codi_municipi":"170792","latitud":"41.97982048","longitud":"2.82382294","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. Calvet i Rubalcaba, 15,  17002 Girona","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-2bpe.jfr4-y44g",":version":"rv-5h8v~f2ba.889y",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Arxiu municipal de Girona","indicador_refugi":"170792|ARXIU_MUNICIPAL_DE_GIRONA","municipi":"Girona","codi_municipi":"170792","latitud":"41.98715957","longitud":"2.82503781","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Plta. de l\'Institut Vell, 1, 17004 Girona","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-aumu_ea6m-c7pc",":version":"rv-f85n-qrb9_7uq8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Girona - Montilivi","indicador_refugi":"170792|CASAL_CIVIC_I_COMUNITARI_GIRONA_MONTILIVI","municipi":"Girona","codi_municipi":"170792","latitud":"41.6862232","longitud":"2.0832848","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. del Doctor Josep Ametller Vi\xf1as, 56","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-xfkq~ib9z.h6b3",":version":"rv-uf6u_vyqt-6wg5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Ernest Lluch","indicador_refugi":"170792|BIBLIOTECA_ERNEST_LLUCH","municipi":"Girona","codi_municipi":"170792","latitud":"41.97109572","longitud":"2.81950838","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Saragossa, 27, 17003 Girona","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-zjvw~nwk4.wvse",":version":"rv-ji35.8dta~yxib",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala d\'espera OAMR","indicador_refugi":"170792|SALA_D_ESPERA_OAMR","municipi":"Girona","codi_municipi":"170792","latitud":"41.98357097","longitud":"2.82473135","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. del Vi, 1, 17004 Girona","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-8t7v.mhn4~xv4b",":version":"rv-ixv7-rjpk~4d9i",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Sant Narc\xeds","indicador_refugi":"170792|CENTRE_CIVIC_SANT_NARCIS","municipi":"Girona","codi_municipi":"170792","latitud":"41.97539263","longitud":"2.81142888","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. Assumpci\xf3, 26-27, 17005 Girona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-9bwa.5yea-cuvq",":version":"rv-f6ph.as49-8kbd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Pont Major","indicador_refugi":"170792|CENTRE_CIVIC_PONT_MAJOR","municipi":"Girona","codi_municipi":"170792","latitud":"42.01238244","longitud":"2.8254044","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Pont Major, 67-73, 17007 Girona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-ccd7_vf5b~h5x9",":version":"rv-jrt3.hf8t~sarz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Salvador Allende","indicador_refugi":"170792|BIBLIOTECA_SALVADOR_ALLENDE","municipi":"Girona","codi_municipi":"170792","latitud":"41.97873294","longitud":"2.80677017","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de Baix, 2, 17006 Girona","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-q6v6_f8i9-x5hj",":version":"rv-chqp-q9sf.avc2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu d\'Hist\xf2ria de Girona (vest\xedbul)","indicador_refugi":"170792|MUSEU_D_HISTORIA_DE_GIRONA_VESTIBUL","municipi":"Girona","codi_municipi":"170792","latitud":"41.98706798","longitud":"2.82618017","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de la For\xe7a, 27, 17004 Girona","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-29um.guvj-cwdu",":version":"rv-czve_sfp9~w4r2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Soterrani de la Catedral","indicador_refugi":"170792|SOTERRANI_DE_LA_CATEDRAL","municipi":"Girona","codi_municipi":"170792","latitud":"41.98779927","longitud":"2.8263022","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Catedral, s/n","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-txdg-daw4.ih2x",":version":"rv-uaei-anr7.jsnv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"B\xf2lit. Centre d\'art contemporani","indicador_refugi":"170792|BOLIT_CENTRE_D_ART_CONTEMPORANI","municipi":"Girona","codi_municipi":"170792","latitud":"41.98871219","longitud":"2.82561201","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. del Pou Rod\xf3, 7-9 17004 Girona","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-bprb_fbca.vpe5",":version":"rv-s2b8~hcpy.8yb3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Barri Vell - Mercadal","indicador_refugi":"170792|CENTRE_CIVIC_BARRI_VELL_MERCADAL","municipi":"Girona","codi_municipi":"170792","latitud":"41.98475435","longitud":"2.82498114","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Cort Reial, 7, 17004 Girona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-an2u.i72y_ddfw",":version":"rv-qcqb-2uhr-22vg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Ant\xf2nia Adroher","indicador_refugi":"170792|BIBLIOTECA_ANTONIA_ADROHER","municipi":"Girona","codi_municipi":"170792","latitud":"41.99387891","longitud":"2.80936853","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Can Sunyer, 46 (Taial\xe0) 17007 Girona","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-wqcs~xatq_2ncq",":version":"rv-ruqa~em8h_xug8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La Merc\xe8 Girona","indicador_refugi":"170792|LA_MERCE_GIRONA","municipi":"Girona","codi_municipi":"170792","latitud":"41.98189528","longitud":"2.82530771","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pujada de la Merc\xe8, 12, 17004 Girona","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-8ruq.pbtc-dt63",":version":"rv-j92c-7j8q.s7sb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Escola Josep Dalmau Carles","indicador_refugi":"170792|ESCOLA_JOSEP_DALMAU_CARLES","municipi":"Girona","codi_municipi":"170792","latitud":"41.97167595","longitud":"2.80596648","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Taga, 1, 17006 Girona","tipologia":"Centre educatiu","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-xi7x_dex9_xggq",":version":"rv-d74y~pvtg.h22h",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Domeny","indicador_refugi":"170792|PARC_DE_DOMENY","municipi":"Girona","codi_municipi":"170792","latitud":"41.98972731","longitud":"2.80017964","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc de Domeny","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-52sg-uazk.sgdd",":version":"rv-gmj5.tpzc_mazx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai c\xedvic Mercadal","indicador_refugi":"170792|ESPAI_CIVIC_MERCADAL","municipi":"Girona","codi_municipi":"170792","latitud":"41.98492097","longitud":"2.82280004","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. Jordi de Sant Jordi, 1, 17001 Girona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-ph6p~kekb-ei6c",":version":"rv-3esj~j66x_upgv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Vista Alegre","indicador_refugi":"170792|PARC_DE_VISTA_ALEGRE","municipi":"Girona","codi_municipi":"170792","latitud":"41.97715179","longitud":"2.82600594","accessibilitat":"No","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc de Vista Alegre","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-6gpf.9q9u-w5bi",":version":"rv-6h7z-4em4-j3cj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Esgl\xe9sia parroquial del Mercadal","indicador_refugi":"170792|ESGLESIA_PARROQUIAL_DEL_MERCADAL","municipi":"Girona","codi_municipi":"170792","latitud":"41.98555454","longitud":"2.83137536","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Obra, 6","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-777h~mwhb-8r64",":version":"rv-ieh5.fxfm~z6a4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca de Gironella","indicador_refugi":"080924|BIBLIOTECA_DE_GIRONELLA","municipi":"Gironella","codi_municipi":"080924","latitud":"42.03168253","longitud":"1.88350719","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Av. Pa\xefsos Catalans, s/n","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-rtti-rn3j~p723",":version":"rv-g64n_juw5-nvqg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa de cultura","indicador_refugi":"080945|CASA_DE_CULTURA","municipi":"Granada, la","codi_municipi":"080945","latitud":"41.37714","longitud":"1.72099281","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Dr. Cusc\xf3, 9","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-x4vi_wwde~u3ha",":version":"rv-gzen~f6nz.ykkg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic","indicador_refugi":"080945|CENTRE_CIVIC","municipi":"Granada, la","codi_municipi":"080945","latitud":"41.37573255","longitud":"1.71344819","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Av. Catalunya, 135","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-zg6w~t7fx~ky6q",":version":"rv-wqe4-vudm-d8qd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PISCINA MUNICIPAL","indicador_refugi":"080945|PISCINA_MUNICIPAL","municipi":"Granada, la","codi_municipi":"080945","latitud":"41.223525","longitud":"1.425163","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Crta santa fe del Pened\xe8s BV2156","informacio_web":"www.lagranada.cat","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T10:46:00.000"},{":id":"row-igfr-ngmb_u28e",":version":"rv-nvjq_hw5k_d56h",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Granollers - Font verda","indicador_refugi":"080961|CASAL_CIVIC_I_COMUNITARI_GRANOLLERS_FONT_VERDA","municipi":"Granollers","codi_municipi":"080961","latitud":"41.6067968","longitud":"2.2894579","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. de la Muntanya, 23","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-bpgg~h9y7~ssim",":version":"rv-phru~4bgw.vej4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Granollers - Casal","indicador_refugi":"080961|CASAL_CIVIC_I_COMUNITARI_GRANOLLERS_CASAL","municipi":"Granollers","codi_municipi":"080961","latitud":"41.6071671","longitud":"2.2839107","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Nou, 22","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-3nfv.a78v~z8za",":version":"rv-ms2f_scep_z79e",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Riera de Gualba","indicador_refugi":"080977|PARC_DE_LA_RIERA_DE_GUALBA","municipi":"Gualba","codi_municipi":"080977","latitud":"41.73410504","longitud":"2.50162557","accessibilitat":"No","aigua":"No","area_descans":"S\xed","adreca":"Darrera escola CEIP Aqua Alba","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-s9bu~zgxi_pmiw",":version":"rv-mfha_mjbj-ccia",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Oac Ajuntament","indicador_refugi":"080977|OAC_AJUNTAMENT","municipi":"Gualba","codi_municipi":"080977","latitud":"41.73218128","longitud":"2.50185108","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. Montseny, 13","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-msca_5i4u_kz4t",":version":"rv-f2vp-3jfp-b6fb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"080977|PISCINA_MUNICIPAL","municipi":"Gualba","codi_municipi":"080977","latitud":"41.71045368","longitud":"2.53049772","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de la serradora, 2","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-bgpu.hsmi.gta7",":version":"rv-zu9n~qn84_496m",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Can Sanmarti","indicador_refugi":"080977|CAN_SANMARTI","municipi":"Gualba","codi_municipi":"080977","latitud":"41.72980786","longitud":"2.50499685","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. Montseny, 60","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-dgxm.4vre_gybj",":version":"rv-azyi.pvss-mudu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CASAL DE GUALBA DE BAIX","indicador_refugi":"080977|CASAL_DE_GUALBA_DE_BAIX","municipi":"Gualba","codi_municipi":"080977","latitud":"41.71033","longitud":"2.53056","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"No","adreca":"CAM\xcd RAL, 167","informacio_web":"NO","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T17:03:00.000"},{":id":"row-kywp~qi4j-87wp",":version":"rv-83c4.fy9j.hbeu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Entrada ajuntament","indicador_refugi":"170813|ENTRADA_AJUNTAMENT","municipi":"Gualta","codi_municipi":"170813","latitud":"42.02843726254579","longitud":"3.1034932381926903","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Major, 1   17257 Gualta (Girona)","informacio_web":"www.gualta.cat","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T16:59:00.000"},{":id":"row-328z.ht5f.qisy",":version":"rv-fi8x~wmia~eusz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de l\'Era","indicador_refugi":"430705|CASAL_DE_L_ERA","municipi":"Guiamets, els","codi_municipi":"430705","latitud":"41.10134976","longitud":"0.75254093","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Av. Carretera, 35, Els Guiamets","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-5uck-6jsa.c88j",":version":"rv-n3e4.zpbb_9ezt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal","indicador_refugi":"251109|BIBLIOTECA_MUNICIPAL","municipi":"Guissona","codi_municipi":"251109","latitud":"41.78694816","longitud":"1.28955057","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Onze de Setembre, 1","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-cuuz.zsti~u2as",":version":"rv-c6gb.mmc4-kvxg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"MUSEU DE GUISSONA","indicador_refugi":"251109|MUSEU_DE_GUISSONA","municipi":"Guissona","codi_municipi":"251109","latitud":"41.787156","longitud":"1.289189","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer del Tint, 41","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-10T15:57:00.000"},{":id":"row-yeqh-inri-ch5t",":version":"rv-ewut~nstm-888j",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"\xc0rea recreativa del Cod\xf3","indicador_refugi":"251116|AREA_RECREATIVA_DEL_CODO","municipi":"Guixers","codi_municipi":"251116","latitud":"42.13567394","longitud":"1.55710237","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Creu del Cod\xf3","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-zabe_x7e3_n9g7",":version":"rv-ja4m.tzaq.bvri",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local social/cultural","indicador_refugi":"251116|LOCAL_SOCIAL_CULTURAL","municipi":"Guixers","codi_municipi":"251116","latitud":"42.13258039","longitud":"1.66729587","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Casa Nova de Valls, s/n","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-jvc9_bqd5-qba5",":version":"rv-waqh~3giv~h2ae",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la gent gran","indicador_refugi":"081000|CASAL_DE_LA_GENT_GRAN","municipi":"Gurb","codi_municipi":"081000","latitud":"41.94011202","longitud":"2.24386005","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Mas l\'Esperan\xe7a, s/n","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-dqnd_nnhd.yra6",":version":"rv-ksjg.v2dh.nnzd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic de F\xe0tima","indicador_refugi":"081022|CENTRE_CIVIC_DE_FATIMA","municipi":"Igualada","codi_municipi":"081022","latitud":"41.58618081","longitud":"1.6050156","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Nostra Sra. de la Pietat, 42","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-34zw_ezd2.fmgv",":version":"rv-hrj4_v5rc~g8e7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai c\xedvic Centre","indicador_refugi":"081022|ESPAI_CIVIC_CENTRE","municipi":"Igualada","codi_municipi":"081022","latitud":"41.58003448","longitud":"1.62207865","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Trinitat, 12","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-gyea-djrj-vsiv",":version":"rv-hba8-n83b-wa7z",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Igualada - Montserrat","indicador_refugi":"081022|CASAL_CIVIC_I_COMUNITARI_IGUALADA_MONTSERRAT","municipi":"Igualada","codi_municipi":"081022","latitud":"41.5805831","longitud":"1.6298735","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de les Orqu\xeddies, 7","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-fy38-ki22.zu8b",":version":"rv-axnm_wzzb~f46w",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Igualada - Casal del passeig","indicador_refugi":"081022|CASAL_CIVIC_I_COMUNITARI_IGUALADA_CASAL_DEL_PASSEIG","municipi":"Igualada","codi_municipi":"081022","latitud":"41.5809838","longitud":"1.6191757","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. de Moss\xe8n Jacint Verdaguer, 67","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-ng7n.h55h~qiv5",":version":"rv-gyqb~i5wn-qvxa",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Nord","indicador_refugi":"081022|CENTRE_CIVIC_NORD","municipi":"Igualada","codi_municipi":"081022","latitud":"41.58842166","longitud":"1.617245","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Sant Mart\xed de Tous, 8","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-kuk8-ipyr-deev",":version":"rv-c9uz_csrp-6nd5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal d\'Isona i Conca Dell\xe0","indicador_refugi":"251155|PISCINA_MUNICIPAL_D_ISONA_I_CONCA_DELLA","municipi":"Isona i Conca Dell\xe0","codi_municipi":"251155","latitud":"42.12146777","longitud":"1.05141003","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de Sant Vicen\xe7, 81, Isona","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-5n29~ayww.kr9k",":version":"rv-3stn.3hf6.xacj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local social d\'All","indicador_refugi":"170849|LOCAL_SOCIAL_D_ALL","municipi":"Is\xf2vol","codi_municipi":"170849","latitud":"42.39850243","longitud":"1.84085434","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Major, s/n, 17539 All","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-qrze~agjc_8ynq",":version":"rv-eede-8nux-jtih",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala de plens de l\'ajuntament d\'Is\xf2vol","indicador_refugi":"170849|SALA_DE_PLENS_DE_L_AJUNTAMENT_D_ISOVOL","municipi":"Is\xf2vol","codi_municipi":"170849","latitud":"42.39759943","longitud":"1.83703781","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Major d\'All, 2, 17539 All","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-rgaa_62av~qkfx",":version":"rv-7yce_t634_v7ge",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local social d\'Ivorra","indicador_refugi":"251142|LOCAL_SOCIAL_D_IVORRA","municipi":"Ivorra","codi_municipi":"251142","latitud":"41.7719106","longitud":"1.39630801","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Major, 1, Ivorra","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-xjrg_ddxs~t7xe",":version":"rv-yhaq~i7qf_2zag",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local social de Jafre","indicador_refugi":"170852|LOCAL_SOCIAL_DE_JAFRE","municipi":"Jafre","codi_municipi":"170852","latitud":"42.07518572","longitud":"3.01153362","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Zona del Padr\xf3","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-regu_vway.e9dt",":version":"rv-uezj-zu2v-3fzd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala polivalent de Jafre","indicador_refugi":"170852|SALA_POLIVALENT_DE_JAFRE","municipi":"Jafre","codi_municipi":"170852","latitud":"42.07206682","longitud":"3.0107577","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Major, 1","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-drja~u3zx.e4pz",":version":"rv-2fhp~ztwt~gx4s",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"170865|PISCINA_MUNICIPAL","municipi":"Jonquera, la","codi_municipi":"170865","latitud":"42.41266","longitud":"2.87354","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. 11 de setembre","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-nf7a~6cv9~7548",":version":"rv-tbxv.s67y_vdc6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Porxos de Can Laporta","indicador_refugi":"170865|PORXOS_DE_CAN_LAPORTA","municipi":"Jonquera, la","codi_municipi":"170865","latitud":"42.4159","longitud":"2.87393","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Major, 2","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-chae~53a4.5ump",":version":"rv-ewz7_av2w-9jhd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Salvador Espriu","indicador_refugi":"251229|BIBLIOTECA_SALVADOR_ESPRIU","municipi":"Linyola","codi_municipi":"251229","latitud":"41.71080996","longitud":"0.90291821","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Pau Casals","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-mvmj~ym6u~mucv",":version":"rv-q3tq_tzs6_2ec2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pavell\xf3 municipal de Linyola","indicador_refugi":"251229|PAVELLO_MUNICIPAL_DE_LINYOLA","municipi":"Linyola","codi_municipi":"251229","latitud":"41.7103357","longitud":"0.89694713","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Creueta","tipologia":"Poliesportiu","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-zjyh-rmc6.frxz",":version":"rv-rhzv-4q9h~8mjv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Teatre Sindicat De Llad\xf3","indicador_refugi":"170887|TEATRE_SINDICAT_DE_LLADO","municipi":"Llad\xf3","codi_municipi":"170887","latitud":"42.24793446","longitud":"2.81389114","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Major, 2","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-gng9-trz6_w9gu",":version":"rv-gv5f-xkrt-kbrx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"251235|PISCINA_MUNICIPAL","municipi":"Lladorre","codi_municipi":"251235","latitud":"42.64473386","longitud":"1.25693057","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. \xdanic, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-qdjf_syix~r4v5",":version":"rv-253i_y9gc-zh5f",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Juli\xe0 Cutiller","indicador_refugi":"170890|BIBLIOTECA_JULIA_CUTILLER","municipi":"Llagostera","codi_municipi":"170890","latitud":"41.82681554","longitud":"2.8963298","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Lle\xf3 I, 2","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-kn72.2yre~m7we",":version":"rv-n37j_8s5k_7bgs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic l\'Estaci\xf3","indicador_refugi":"170904|CENTRE_CIVIC_LESTACIO","municipi":"Llambilles","codi_municipi":"170904","latitud":"41.91955","longitud":"2.84983","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Passeig del Carrilet, 14","informacio_web":"de dimarts a diumenge de 9h a 20h","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T14:27:00.000"},{":id":"row-y8f5~qpku-ttyg",":version":"rv-ssin.kbef.3upe",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"P\xe8rgola solar Parc de l\'Estaci\xf3","indicador_refugi":"170904|PERGOLA_SOLAR_PARC_DE_LESTACIO","municipi":"Llambilles","codi_municipi":"170904","latitud":"41.919942","longitud":"2.849874","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"No","lavabo":"No","adreca":"Passeig del Carrilet","informacio_web":"No hi ha horaris, \xe9s una p\xe8rgola solar al Parc de l\'Estaci\xf3.","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-05T08:02:00.000"},{":id":"row-ahmw_3s9u.7tb8",":version":"rv-a4uf.bw27-vqan",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Edifici de serveis","indicador_refugi":"170926|EDIFICI_DE_SERVEIS","municipi":"Llan\xe7\xe0","codi_municipi":"170926","latitud":"42.36251702","longitud":"3.15353688","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. La Selva, 17-19","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-z4cp_kfxp-hdw4",":version":"rv-8b82-9pzw.2tq2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa de cultura","indicador_refugi":"170926|CASA_DE_CULTURA","municipi":"Llan\xe7\xe0","codi_municipi":"170926","latitud":"42.36362576","longitud":"3.1521153","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Major, 3","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-prix~gtpe-xwbf",":version":"rv-bsfz_f4sh.pfst",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament de Llan\xe7\xe0","indicador_refugi":"170926|AJUNTAMENT_DE_LLANCA","municipi":"Llan\xe7\xe0","codi_municipi":"170926","latitud":"42.36600502","longitud":"3.15439518","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Europa, 37","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-phkw-ksd7.qfyy",":version":"rv-xhe9-cwib_9jnw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de gent gran","indicador_refugi":"170926|CASAL_DE_GENT_GRAN","municipi":"Llan\xe7\xe0","codi_municipi":"170926","latitud":"42.36350002","longitud":"3.15399889","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Cabrafiga, 15","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-yh8c-55bg_p9fa",":version":"rv-ysac_w3v7.fxc7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai jove","indicador_refugi":"170926|ESPAI_JOVE","municipi":"Llan\xe7\xe0","codi_municipi":"170926","latitud":"42.36376906","longitud":"3.15431874","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Rafael Estela, 18","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-xcfb.a5ez~3pvv",":version":"rv-jy3u-83qy_dxyy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca-Fonoteca de l\'Auditori","indicador_refugi":"251207|BIBLIOTECA_FONOTECA_DE_L_AUDITORI","municipi":"Lleida","codi_municipi":"251207","latitud":"41.62003237","longitud":"0.62842066","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"P\xe7. Josep Prenafeta, s/n","informacio_web":"Del 15 de setembre al 15 juny (dilluns, dimarts i dimecres de 10.00 a 12.00 h- de dilluns a dijous de 16 a 20.30 h) Del 16 de juny al 15 de setembre (de dilluns a dijous de 10.00 a 13.30 h) De l\'01 d\'agost a 06 de setembre tancat","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-18T11:54:00.000"},{":id":"row-tsd3-76qa~cpxv",":version":"rv-xah7-cisc-z2xb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre s\xe8nior Sec\xe0 Sant Pere","indicador_refugi":"251207|CENTRE_SENIOR_SECA_SANT_PERE","municipi":"Lleida","codi_municipi":"251207","latitud":"41.63632961","longitud":"0.62975604","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Sant Pere, 3","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-nr9m.8kpd~nb3t",":version":"rv-yjav_uusq-sftb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Bal\xe0fia","indicador_refugi":"251207|CENTRE_CIVIC_BALAFIA","municipi":"Lleida","codi_municipi":"251207","latitud":"41.62774314","longitud":"0.62631271","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"No","adreca":"C. Terrassa, 1","informacio_web":"De dilluns a dijous (de 9.00 h a 14.00 h i de 16.00 h a 18.00 h) Divendres (de 09.00 h a 14:00 h tardes tancat)","tipologia":"Centre C\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-18T12:14:00.000"},{":id":"row-ivn6-yhei.3m48",":version":"rv-wdiz.2crp.5g56",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre s\xe8nior de Bonaire","indicador_refugi":"251207|CENTRE_SENIOR_DE_BONAIRE","municipi":"Lleida","codi_municipi":"251207","latitud":"41.61971016","longitud":"0.62226939","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Bonaire, 37","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-xz25~pjfr~qezn",":version":"rv-guav-5rh9_n7tv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre d\'Art La Panera","indicador_refugi":"251207|CENTRE_D_ART_LA_PANERA","municipi":"Lleida","codi_municipi":"251207","latitud":"41.61727618","longitud":"0.62250939","accessibilitat":"S\xed","aigua":"No","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. de la Panera, 2","informacio_web":"De dimarts a dissabte, de 10.00 a 14.00 h i de 17.00 a 19.00 h  Diumenges i festius, d\u201911.00 a 14.00 h  Dilluns tancat","tipologia":"Equipament Cultural (teatre, auditori, museu)","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-18T12:31:00.000"},{":id":"row-9dzu-tga3.brbm",":version":"rv-aqu3_ie2t~8g8u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre s\xe8nior de la Bordeta","indicador_refugi":"251207|CENTRE_SENIOR_DE_LA_BORDETA","municipi":"Lleida","codi_municipi":"251207","latitud":"41.60530085","longitud":"0.64253936","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Sant Jaume, 1","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-9vja.35rb-65kp",":version":"rv-agk2~prkm_7na8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"MORERA, Museu d\'Art Modern i Contemporani de Lleida","indicador_refugi":"251207|MORERA_MUSEU_D_ART_MODERN_I_CONTEMPORANI_DE_LLEIDA","municipi":"Lleida","codi_municipi":"251207","latitud":"41.61770473","longitud":"0.62959902","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"No","lavabo":"No","adreca":"Rbla. de Ferran, 13","tipologia":"Equipament Cultural (teatre, auditori, museu)","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-18T12:59:00.000"},{":id":"row-c7p8-g95e-f8fb",":version":"rv-ce2z-vwib~vngs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre s\xe8nior de Santa Cec\xedlia","indicador_refugi":"251207|CENTRE_SENIOR_DE_SANTA_CECILIA","municipi":"Lleida","codi_municipi":"251207","latitud":"41.61296357","longitud":"0.63290668","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Eduardo Velasco, 5","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-ydwn~n52q.rfdn",":version":"rv-jeb8-fd6w~v9rh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Mariola","indicador_refugi":"251207|CENTRE_CIVIC_MARIOLA","municipi":"Lleida","codi_municipi":"251207","latitud":"41.61313546","longitud":"0.61143631","accessibilitat":"No","aigua":"No","climatitzacio":"No","area_descans":"No","lavabo":"No","adreca":"C. Artur Mor, 1","informacio_web":"De dilluns a dijous (de 09.00 h a 14 h i de 16.00 h a 18.00 h) Divendres (de 09.00 h a 14.00, tardes tancat)","tipologia":"Centre C\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-18T13:06:00.000"},{":id":"row-ydrg-ygk3_pgvn",":version":"rv-tb92-w3i3~ibnt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre s\xe8nior de Democr\xe0cia","indicador_refugi":"251207|CENTRE_SENIOR_DE_DEMOCRACIA","municipi":"Lleida","codi_municipi":"251207","latitud":"41.6184704","longitud":"0.63128043","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Comer\xe7, 38","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-625c-itm6.i9vh",":version":"rv-399h-7pew-8iy3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu de l\'Aigua","indicador_refugi":"251207|MUSEU_DE_L_AIGUA","municipi":"Lleida","codi_municipi":"251207","latitud":"41.60374567","longitud":"0.63587546","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Miquel Batllori, 52","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-nt3i~gpn8_weev",":version":"rv-3kxf_yhvi_acp8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Cafeteria Centre c\xedvic Pardinyes","indicador_refugi":"251207|CAFETERIA_CENTRE_CIVIC_PARDINYES","municipi":"Lleida","codi_municipi":"251207","latitud":"41.62615597","longitud":"0.63799104","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Sant Pere Claver, 5","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-9be5_r47x_kpds",":version":"rv-z3fq-93q4~mvi9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Cafeteria Centre c\xedvic Sec\xe0 Sant Pere","indicador_refugi":"251207|CAFETERIA_CENTRE_CIVIC_SECA_SANT_PERE","municipi":"Lleida","codi_municipi":"251207","latitud":"41.63605262","longitud":"0.62904213","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Sant Pere, s/n","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-qqad_tykc.aj3b",":version":"rv-gkpu~ycwb-xvnp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Lleida","indicador_refugi":"251207|CASAL_CIVIC_I_COMUNITARI_LLEIDA","municipi":"Lleida","codi_municipi":"251207","latitud":"41.6138154","longitud":"0.6086086","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de la Merc\xe8, 1","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-ig7s-ymbm.zdqz",":version":"rv-axe6~uw8j.65u6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Llar de Magraners","indicador_refugi":"251207|LLAR_DE_MAGRANERS","municipi":"Lleida","codi_municipi":"251207","latitud":"41.60983781","longitud":"0.66253868","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Joan XXIII, 1","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-xag6-8cdr-xna3",":version":"rv-npxr~znzs.fmji",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Llar de Sucs","indicador_refugi":"251207|LLAR_DE_SUCS","municipi":"Lleida","codi_municipi":"251207","latitud":"41.70218156","longitud":"0.41150841","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. del Bou, 2","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-3rg3-85vc.6gwu",":version":"rv-8kyc~j3uw.348b",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Pl. Ereta","indicador_refugi":"251207|CENTRE_CIVIC_PL_ERETA","municipi":"Lleida","codi_municipi":"251207","latitud":"41.61519604","longitud":"0.62289511","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Ereta, 10","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-f3iw-hw3y.9uh3",":version":"rv-gcsq-hthv_jvqg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu de l\'Automoci\xf3 Roda Roda","indicador_refugi":"251207|MUSEU_DE_L_AUTOMOCIO_RODA_RODA","municipi":"Lleida","codi_municipi":"251207","latitud":"41.61350172","longitud":"0.63279926","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Santa Cec\xedlia, 22 (davant dels Camps Elisis)","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-jj4v_3zxe-b2fx",":version":"rv-biq2-v389_nsxy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre s\xe8nior Santa Teresina","indicador_refugi":"251207|CENTRE_SENIOR_SANTA_TERESINA","municipi":"Lleida","codi_municipi":"251207","latitud":"41.61688621","longitud":"0.61519268","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Pica d\'Estats, 4","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-x5jz.54u9-ziy2",":version":"rv-kt6a-q2jt.uqx4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa dels Gegants","indicador_refugi":"251207|CASA_DELS_GEGANTS","municipi":"Lleida","codi_municipi":"251207","latitud":"41.61278576","longitud":"0.6241373","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Av. Blondel, 64","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-ekr4_3pyh-icnb",":version":"rv-vdzk~c2h5-btyq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal de Pardinyes","indicador_refugi":"251207|BIBLIOTECA_MUNICIPAL_DE_PARDINYES","municipi":"Lleida","codi_municipi":"251207","latitud":"41.62644752","longitud":"0.63797426","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Sant Pere Claver, 1","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-68st-2isz_nu4g",":version":"rv-maqj.si6p_6aa3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre s\xe8nior el Pilar","indicador_refugi":"251207|CENTRE_SENIOR_EL_PILAR","municipi":"Lleida","codi_municipi":"251207","latitud":"41.62291793","longitud":"0.61852094","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Tamarit de Llitera, 6","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-ngga_muic-d9pc",":version":"rv-nhyn~jafb_vwu6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Pardinyes","indicador_refugi":"251207|CENTRE_CIVIC_PARDINYES","municipi":"Lleida","codi_municipi":"251207","latitud":"41.62615597","longitud":"0.63799104","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Sant Pere Claver, 5","informacio_web":"De dilluns a divendres de 09.00 h a 21.00 h (Excepte del 03 al 31 d\'agost. tancat)","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-18T13:31:00.000"},{":id":"row-c4m5_mwur~z7pv",":version":"rv-esvi_yyvz_r3b6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia Emera Ponent","indicador_refugi":"251207|RESIDENCIA_EMERA_PONENT","municipi":"Lleida","codi_municipi":"251207","latitud":"41.610593356000486","longitud":"0.6256075815436868","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Jaume II, 55 (Cappont)","informacio_web":"Dilluns, dimecres i divendres de 10.00 h a 15.00 h","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T12:38:00.000"},{":id":"row-cqw6~4r46.kev7",":version":"rv-jbdu-6jm2-wjxf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc dels Camps Elisis","indicador_refugi":"251207|PARC_DELS_CAMPS_ELISIS","municipi":"Lleida","codi_municipi":"251207","latitud":"41.61399851358183","longitud":"0.6316709518432618","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. de les Garrigues","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T13:19:00.000"},{":id":"row-am6i-pwsb.m3nz",":version":"rv-prxn_9u8m-y3jc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de l\'Aigua","indicador_refugi":"251207|PARC_DE_LAIGUA","municipi":"Lleida","codi_municipi":"251207","latitud":"41.604044489039914","longitud":"0.6344251109367169","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a de Joan Or\xf3, 51","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T13:30:00.000"},{":id":"row-bude~2t8j.fid3",":version":"rv-eeer~t2pn.n7y4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de les Magn\xf2lies, alta","indicador_refugi":"251207|PLACA_DE_LES_MAGNOLIES_ALTA","municipi":"Lleida","codi_municipi":"251207","latitud":"41.62935787476094","longitud":"0.6242295551195366","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Jardins de les Magn\xf2lies","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T13:50:00.000"},{":id":"row-gjzm~3a76_i8bf",":version":"rv-ycr6-sjgy_2wqw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Mitjana","indicador_refugi":"251207|PARC_DE_LA_MITJANA","municipi":"Lleida","codi_municipi":"251207","latitud":"41.62894165954645","longitud":"0.6424608244286822","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Parc de la Mitjana","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T13:56:00.000"},{":id":"row-k58k~4kvz_b2c3",":version":"rv-hybp_haq8~b3ut",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pardinyes-Av.Pearson","indicador_refugi":"251207|PARDINYES-AVPEARSON","municipi":"Lleida","codi_municipi":"251207","latitud":"41.62617418046948","longitud":"0.6414029416689877","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda Pearson","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T09:15:00.000"},{":id":"row-k7ge_hfw9_6a38",":version":"rv-egbr-5dpq~d8mc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pardinyes-Carrer Xavier Puig Andreu","indicador_refugi":"251207|PARDINYES-CARRER_XAVIER_PUIG_ANDREU","municipi":"Lleida","codi_municipi":"251207","latitud":"41.62839923886911","longitud":"0.6397325532649851","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Xavier Puig Andreu","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T09:35:00.000"},{":id":"row-ucjf~b6xe-apej",":version":"rv-tgny~kbc8-uwzk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bal\xe0fia-Pl.Maria Aur\xe8lia Capmany","indicador_refugi":"251207|BALAFIA-PLMARIA_AURELIA_CAPMANY","municipi":"Lleida","codi_municipi":"251207","latitud":"41.62739840454327","longitud":"0.6274471821013134","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Maria Aur\xe8lia Capmany","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T09:54:00.000"},{":id":"row-7f6x~kjem~zbzg",":version":"rv-2ied-5nnt~uv6c",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bosc Urb\xe0 de Bal\xe0fia","indicador_refugi":"251207|BOSC_URBA_DE_BALAFIA","municipi":"Lleida","codi_municipi":"251207","latitud":"41.62980583128363","longitud":"0.6291862397741136","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. Torrevicens -C. Corregidor Escofet","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T10:07:00.000"},{":id":"row-3xiz~bq9m_afxv",":version":"rv-ug7d.c6tb~95sp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Clot i conflu\xe8ncies (vianants)","indicador_refugi":"251207|CLOT_I_CONFLUENCIES_(VIANANTS)","municipi":"Lleida","codi_municipi":"251207","latitud":"41.62091610281549","longitud":"0.6221395384130501","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Humbert Torres  (zona vianants)","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T10:24:00.000"},{":id":"row-vte5.6hg7_2y2u",":version":"rv-nz5r.xbms~3rec",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Seu Vella-Sta. Cec\xedlia","indicador_refugi":"251207|PARC_SEU_VELLA-STA_CECILIA","municipi":"Lleida","codi_municipi":"251207","latitud":"41.619993749979535","longitud":"0.6257658851020031","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Darrera Sant Marti","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T10:45:00.000"},{":id":"row-9fne-uqay~dibv",":version":"rv-hgvm_b5mz-98qj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mariola-Pl. Gal\xedcia","indicador_refugi":"251207|MARIOLA-PL_GALICIA","municipi":"Lleida","codi_municipi":"251207","latitud":"41.613074549261185","longitud":"0.611812297446157","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. Gal\xedcia","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T11:00:00.000"},{":id":"row-idje_zdtw.qnvv",":version":"rv-8gww_9ny4-8tv5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mariola-Espai de les Moreres i Jardins Primer de Maig","indicador_refugi":"251207|MARIOLA-ESPAI_DE_LES_MORERES_I_JARDINS_PRIMER_DE_MAIG","municipi":"Lleida","codi_municipi":"251207","latitud":"41.615548077231665","longitud":"0.6110421839552875","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. de la Merc\xe8","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T11:10:00.000"},{":id":"row-h4kx-mbx5.h3pe",":version":"rv-nr2t_gzxa_q9m8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Universitat-Jardins UDL-Pl. Victor Siurana","indicador_refugi":"251207|UNIVERSITAT-JARDINS_UDL-PL_VICTOR_SIURANA","municipi":"Lleida","codi_municipi":"251207","latitud":"41.61480122467979","longitud":"0.6196099363437211","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Victor Siurana","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T11:13:00.000"},{":id":"row-ymu6~dtfx~bi5v",":version":"rv-ie68~vipi~tt59",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Escorxador/Instituts-Av. Joana Raspall","indicador_refugi":"251207|ESCORXADOR-INSTITUTS-AV_JOANA_RASPALL","municipi":"Lleida","codi_municipi":"251207","latitud":"41.608793765044865","longitud":"0.6202482015182395","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. Joana Raspall","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T11:20:00.000"},{":id":"row-7f39.4u4x_y72u",":version":"rv-7zs5_e292.nnkd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Escorxador/Instituts-C. Ton Sirera","indicador_refugi":"251207|ESCORXADOR-INSTITUTS-C_TON_SIRERA","municipi":"Lleida","codi_municipi":"251207","latitud":"41.606106416347465","longitud":"0.6167313109367989","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Ton Sirera","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T12:09:00.000"},{":id":"row-stdn~pgdx_vcft",":version":"rv-yx4y~4zuc~agz5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Hist\xf2ric/Noguerola: Rambla Ferran-Pl.de la Pau","indicador_refugi":"251207|CENTRE_HISTORIC-NOGUEROLA_RAMBLA_FERRAN-PLDE_LA_PAU","municipi":"Lleida","codi_municipi":"251207","latitud":"41.61588714992888","longitud":"0.6288167397735558","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. de la Pau","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T12:12:00.000"},{":id":"row-22bm-3q2p.37ge",":version":"rv-e453~6yfi_v9ie",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Cappont: C. Doctora Castells","indicador_refugi":"251207|CAPPONT_C_DOCTORA_CASTELLS","municipi":"Lleida","codi_municipi":"251207","latitud":"41.610264814751226","longitud":"0.629114597446046","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Doctora Castells","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T12:17:00.000"},{":id":"row-z9z9-26qy-mx8j",":version":"rv-fqdm-ax5v_6buh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Cappont: C. Jaume II","indicador_refugi":"251207|CAPPONT_C_JAUME_II","municipi":"Lleida","codi_municipi":"251207","latitud":"41.609786250810174","longitud":"0.6245837127914635","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Jaume II","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T12:20:00.000"},{":id":"row-md5k-q9nc~zi3f",":version":"rv-4a3e~sp2q~dv7f",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Cappont:  Parc Fluvial del Segre","indicador_refugi":"251207|CAPPONT__PARC_FLUVIAL_DEL_SEGRE","municipi":"Lleida","codi_municipi":"251207","latitud":"41.61148608433256","longitud":"0.6245629888910584","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Jaume II","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T12:41:00.000"},{":id":"row-vfa5_7qc8_67a8",":version":"rv-dmxm~xjyn_6a87",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Cappont: Pl. Blas Infante","indicador_refugi":"251207|CAPPONT_PL_BLAS_INFANTE","municipi":"Lleida","codi_municipi":"251207","latitud":"41.612148936787115","longitud":"0.6280764109370633","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. Blas Infante","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T12:43:00.000"},{":id":"row-655w~m722-k753",":version":"rv-jmn8~66mn~qtfn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Cappont: Bosc Urb\xe0 de Cappont","indicador_refugi":"251207|CAPPONT_BOSC_URBA_DE_CAPPONT","municipi":"Lleida","codi_municipi":"251207","latitud":"41.60944709510147","longitud":"0.6320155958519994","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer d\'Esperanza Gonz\xe1lez, 13","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T12:46:00.000"},{":id":"row-n5gd_xqqj.u5i7",":version":"rv-4xj7~7a46-awnj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Magraners: C. Vila Rodona","indicador_refugi":"251207|MAGRANERS_C_VILA_RODONA","municipi":"Lleida","codi_municipi":"251207","latitud":"41.60771151553867","longitud":"0.6653192534624223","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Vila Rodona","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T12:53:00.000"},{":id":"row-xf4j.zkpe~cmv8",":version":"rv-63fx_h7qn_bphe",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Magraners:  Pl. Joan XXIII","indicador_refugi":"251207|MAGRANERS__PL_JOAN_XXIII","municipi":"Lleida","codi_municipi":"251207","latitud":"41.60915295254288","longitud":"0.663371082100581","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. Joan XXIII","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T12:56:00.000"},{":id":"row-rcks~nkn2.q2ps",":version":"rv-nyq6.ic7s.ivpq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Magraners: Bosc Urb\xe0 de Mangraners","indicador_refugi":"251207|MAGRANERS_BOSC_URBA_DE_MANGRANERS","municipi":"Lleida","codi_municipi":"251207","latitud":"41.607266953515094","longitud":"0.6619156815477095","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Camp","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T13:01:00.000"},{":id":"row-288f_tisr-ddph",":version":"rv-hfrb.v8kb-iw37",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bordeta: Pl. Sant Jordi","indicador_refugi":"251207|BORDETA_PL_SANT_JORDI","municipi":"Lleida","codi_municipi":"251207","latitud":"41.602092925994945","longitud":"0.6424038031719569","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. Sant Jordi","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T13:06:00.000"},{":id":"row-dx42_628j.8g3f",":version":"rv-qrhg_9ds9-awej",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bordeta: Pla\xe7a Major","indicador_refugi":"251207|BORDETA_PLACA_MAJOR","municipi":"Lleida","codi_municipi":"251207","latitud":"41.60260883855064","longitud":"0.6448309686093769","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Major","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T13:12:00.000"},{":id":"row-pxn9~5xwx-2bf9",":version":"rv-hv5p_gqha.jct6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bosquet de la Bordeta","indicador_refugi":"251207|BOSQUET_DE_LA_BORDETA","municipi":"Lleida","codi_municipi":"251207","latitud":"41.60955402960903","longitud":"0.6483622416277872","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Palauet, 119","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T13:15:00.000"},{":id":"row-3ma5~d4a9-mbzf",":version":"rv-rf2h.89it-wqbi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bordeta: C. del Campament","indicador_refugi":"251207|BORDETA_C_DEL_CAMPAMENT","municipi":"Lleida","codi_municipi":"251207","latitud":"41.60588752773614","longitud":"0.6366869262822252","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. del Campament","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T13:19:00.000"},{":id":"row-4r7f-na96_dkag",":version":"rv-cyb9_ebxr~s9rc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bordeta: Pla\xe7a del Mol\xed de Sant Anastasi","indicador_refugi":"251207|BORDETA_PLACA_DEL_MOLI_DE_SANT_ANASTASI","municipi":"Lleida","codi_municipi":"251207","latitud":"41.60560536224757","longitud":"0.6388245839549547","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. del Mol\xed de Sant Anastasi","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T13:30:00.000"},{":id":"row-i64f-3dbx-cqj5",":version":"rv-z7pa~ib2u-3vmg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sec\xe0 Sant Pere:  Pla\xe7a Sant Pere","indicador_refugi":"251207|SECA_SANT_PERE__PLACA_SANT_PERE","municipi":"Lleida","codi_municipi":"251207","latitud":"41.63598656007599","longitud":"0.6296190920881237","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. Sant Pere","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T13:35:00.000"},{":id":"row-k65b-tvws.g7vm",":version":"rv-pp6k_rzpd.nhma",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de Francesc Solana","indicador_refugi":"251207|JARDINS_DE_FRANCESC_SOLANA","municipi":"Lleida","codi_municipi":"251207","latitud":"41.63102032024285","longitud":"0.6293920821014647","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. Torre Vicens, 53","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T13:41:00.000"},{":id":"row-cug9.g7gb-dtrz",":version":"rv-ae6f.v5e9-dui8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Sant Anastasi (Llivia)","indicador_refugi":"251207|PARC_DE_SANT_ANASTASI_(LLIVIA)","municipi":"Lleida","codi_municipi":"251207","latitud":"41.648423621186886","longitud":"0.6394733598830484","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Gran (Llivia)","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T13:56:00.000"},{":id":"row-v6ca.jdbs.jbe2",":version":"rv-wcsg~zhj2.q6tt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Arbor\xe8tum","indicador_refugi":"251207|ARBORETUM","municipi":"Lleida","codi_municipi":"251207","latitud":"41.626988873052575","longitud":"0.6020207434830004","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Enric Farreny, 49","informacio_web":"De Juny a setembre de dimarts a diumenge (de les 10 a les 13 h i de les 16 a les 20h) excepte juliol i agost: de les 10 a les 13 h i de les 18 a les 20:30 h","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T14:12:00.000"},{":id":"row-qmmw.kbpb_c97q",":version":"rv-z4iq.c5tm_42ra",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la Gent Gran de Palaud\xe0ries","indicador_refugi":"081075|CASAL_DE_LA_GENT_GRAN_DE_PALAUDARIES","municipi":"Lli\xe7\xe0 d\'Amunt","codi_municipi":"081075","latitud":"41.59191668","longitud":"2.20289922","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. de Palaud\xe0ries, 88","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-axdd-q27g-v3di",":version":"rv-q9sm~3k9g-727n",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la Gent Gran del Centre","indicador_refugi":"081075|CASAL_DE_LA_GENT_GRAN_DEL_CENTRE","municipi":"Lli\xe7\xe0 d\'Amunt","codi_municipi":"081075","latitud":"41.61225827","longitud":"2.23930914","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Folch i Torres, 102","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-patw~rdpz_umbr",":version":"rv-jmrx~w6qv~tqk7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"081075|PISCINA_MUNICIPAL","municipi":"Lli\xe7\xe0 d\'Amunt","codi_municipi":"081075","latitud":"41.6089785","longitud":"2.24282657","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. dels Pa\xefsos Catalans, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-cev2-m7hr_m3f8",":version":"rv-v2s6-a8ry~tdwx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local Social de Ca l\'Artigues","indicador_refugi":"081075|LOCAL_SOCIAL_DE_CA_L_ARTIGUES","municipi":"Lli\xe7\xe0 d\'Amunt","codi_municipi":"081075","latitud":"41.61741224","longitud":"2.21676117","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Ribera d\'Ebre, 81, 08186 LLi\xe7\xe0 d\'Amunt","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-d4c2.b9kg~747z",":version":"rv-f4zz_me59-txg7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la gent gran","indicador_refugi":"081081|CASAL_DE_LA_GENT_GRAN","municipi":"Lli\xe7\xe0 de Vall","codi_municipi":"081081","latitud":"41.58762814","longitud":"2.23896406","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Montsi\xe0, 46","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-tyep.4ttw-4enp",":version":"rv-ytvh~xk56.cj7t",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de joves El Kaliu","indicador_refugi":"081081|CASAL_DE_JOVES_EL_KALIU","municipi":"Lli\xe7\xe0 de Vall","codi_municipi":"081081","latitud":"41.58543728","longitud":"2.23910584","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. de l\'Esgl\xe9sia, 1","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-twqa~fv5v-26v8",":version":"rv-eee8_ge8u~juyw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Oficina d\'Atenci\xf3 a la Ciutadania (Ajuntament)","indicador_refugi":"081081|OFICINA_D_ATENCIO_A_LA_CIUTADANIA_AJUNTAMENT","municipi":"Lli\xe7\xe0 de Vall","codi_municipi":"081081","latitud":"41.58639733","longitud":"2.23917166","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de la Vila, s/n","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-2bse.5889-pss5",":version":"rv-trf9_4u57~e2db",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"251288|PISCINA_MUNICIPAL","municipi":"Llimiana","codi_municipi":"251288","latitud":"42.07470596","longitud":"0.91718659","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de la font, 1","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-mc3p-fcri~gwtg",":version":"rv-c6u9-tvth-rjzd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Llinars del vall\xe8s","indicador_refugi":"081069|CASAL_CIVIC_I_COMUNITARI_LLINARS_DEL_VALLES","municipi":"Llinars del Vall\xe8s","codi_municipi":"081069","latitud":"41.6375444","longitud":"2.3907059","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Ramon y Cajal - Av. de Granollers","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-zvzc_38j4.wtta",":version":"rv-8td7_wp6u-2m8s",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La Devesa de l\'\xc0rea Central","indicador_refugi":"081069|LA_DEVESA_DE_L_AREA_CENTRAL","municipi":"Llinars del Vall\xe8s","codi_municipi":"081069","latitud":"41.63985272","longitud":"2.40252967","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Pau Casals, 4","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-zb9m~39qk~xtym",":version":"rv-prb2-3g9s~xh7p",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mas Bag\xe0","indicador_refugi":"081069|MAS_BAGA","municipi":"Llinars del Vall\xe8s","codi_municipi":"081069","latitud":"41.64027455","longitud":"2.40511934","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Mas Bag\xe0, 24","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-faku~97p5-uvmx",":version":"rv-cigd~f82f_7xvv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"170947|PISCINA_MUNICIPAL","municipi":"Ll\xedvia","codi_municipi":"170947","latitud":"42.46022899","longitud":"1.98102865","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc de Sant Guillem","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-sbbg.7dfm.ucbp",":version":"rv-m2hc-ktqw_viwp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"POLIESPORTIU DE LL\xcdVIA","indicador_refugi":"170947|POLIESPORTIU_DE_LLIVIA","municipi":"Ll\xedvia","codi_municipi":"170947","latitud":"42.46168080914811","longitud":"1.9797081279748476","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de l\'Esport, 3, 17527 Ll\xedvia, Girona","informacio_web":"POLIESPORTIU DE LLIVIA","tipologia":"Pavell\xf3 Esportiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-03T09:31:00.000"},{":id":"row-cczi~2hjx-3pww",":version":"rv-ue5q_hhbj-qytx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"LOCAL SOCIAL (MENJADOR)","indicador_refugi":"251291|LOCAL_SOCIAL_(MENJADOR)","municipi":"Llobera","codi_municipi":"251291","latitud":"41.5519","longitud":"1.2749","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Local social de Llobera","informacio_web":"horari oficina (de 09:00 a 14:00)","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-09T11:07:00.000"},{":id":"row-6u3i_54ig~5fqq",":version":"rv-56i5.nw8v~c73r",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Mestra Maria Rafecas","indicador_refugi":"430748|BIBLIOTECA_MESTRA_MARIA_RAFECAS","municipi":"Lloren\xe7 del Pened\xe8s","codi_municipi":"430748","latitud":"41.28194233214649","longitud":"1.5515694551054264","accessibilitat":"S\xed","aigua":"No","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Rb.Marinada, 27","informacio_web":"https://llorenc.cat/biblioteca-2/","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T08:35:00.000"},{":id":"row-bf32.r6zi.2x9b",":version":"rv-pje3-s9tw_z8rg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Municipal de Lloren\xe7 del Pened\xe8s","indicador_refugi":"430748|PISCINA_MUNICIPAL_DE_LLORENC_DEL_PENEDES","municipi":"Lloren\xe7 del Pened\xe8s","codi_municipi":"430748","latitud":"41.280225886469466","longitud":"1.54643426065344","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Zona Esportiva- Cami de Cal Prosset","informacio_web":"https://llorenc.cat/piscina-municipal/","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T08:42:00.000"},{":id":"row-jeyd-85i4_s2g7",":version":"rv-c8yi.dgh9_tg23",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal","indicador_refugi":"170950|BIBLIOTECA_MUNICIPAL","municipi":"Lloret de Mar","codi_municipi":"170950","latitud":"41.700302","longitud":"2.84432","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. de Pere Torrent, 1","informacio_web":"https://www.lloret.cat/ca/seccions/biblioteca-municipal","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T18:36:00.000"},{":id":"row-g7ji~355c.8zj8",":version":"rv-zufx.cvyi.wkju",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Punt d\'informaci\xf3 juvenil El Puntet","indicador_refugi":"170950|PUNT_DINFORMACIO_JUVENIL_EL_PUNTET","municipi":"Lloret de Mar","codi_municipi":"170950","latitud":"41.705147","longitud":"2.842544","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. de Vidreres, 58","informacio_web":"https://www.lloret.cat/ca/seccions/joventut/pij-el-puntet","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T18:41:00.000"},{":id":"row-q4um_dkxu_dip4",":version":"rv-yaq7.ifwf.hbzg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Punt d\'informaci\xf3 juvenil El Puntet de Fenals","indicador_refugi":"170950|PUNT_DINFORMACIO_JUVENIL_EL_PUNTET_DE_FENALS","municipi":"Lloret de Mar","codi_municipi":"170950","latitud":"41.697082","longitud":"2.830732","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. Esteve F\xe0bregas","informacio_web":"https://www.lloret.cat/ca/seccions/joventut/","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T18:44:00.000"},{":id":"row-5vnd.84pn-kcqe",":version":"rv-cvwq_rsp7_vz3q",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu del Mar - Oficina de turisme","indicador_refugi":"170950|MUSEU_DEL_MAR_-_OFICINA_DE_TURISME","municipi":"Lloret de Mar","codi_municipi":"170950","latitud":"41.69959","longitud":"2.850761","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pg. Camprodon i Arrieta, 1","informacio_web":"https://patrimoni.lloret.cat/ca/moll-museu-obert-de-lloret/museu-del-mar","tipologia":"Equipament Cultural (teatre, auditori, museu)","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T18:49:00.000"},{":id":"row-9jp7_qxh2.cbnh",":version":"rv-3gpa-8y5a_556e",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic El Rieral","indicador_refugi":"170950|CENTRE_CIVIC_EL_RIERAL","municipi":"Lloret de Mar","codi_municipi":"170950","latitud":"41.706729","longitud":"2.839468","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Joan Fuster i Ortells, 14","informacio_web":"https://www.lloret.cat/ca/seccions/participacio-ciutadana/barris-i-centres-civics/el-rieral","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T18:52:00.000"},{":id":"row-wm8b.fkgb_mb8e",":version":"rv-3fmf.sksv_czan",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic El Mol\xed","indicador_refugi":"170950|CENTRE_CIVIC_EL_MOLI","municipi":"Lloret de Mar","codi_municipi":"170950","latitud":"41.708011","longitud":"2.841374","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. de les Regions, 4","informacio_web":"https://www.lloret.cat/ca/seccions/participacio-ciutadana/barris-i-centres-civics/el-moli-mas-vila-can-ribalaigua","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T18:54:00.000"},{":id":"row-e3m6-349s.cjai",":version":"rv-yif4-f4zc-kqky",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Zona boscosa platja de Fenals","indicador_refugi":"170950|ZONA_BOSCOSA_PLATJA_DE_FENALS","municipi":"Lloret de Mar","codi_municipi":"170950","latitud":"41.69439","longitud":"2.830404","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Platja de Fenals","informacio_web":"https://lloretdemar.org/platja/platja-fenals/","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T19:10:00.000"},{":id":"row-d4zn-p9yy~4f8z",":version":"rv-xmwk_79vu_nwcv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc urb\xe0 de can Xard\xf3","indicador_refugi":"170950|PARC_URBA_DE_CAN_XARDO","municipi":"Lloret de Mar","codi_municipi":"170950","latitud":"41.704757","longitud":"2.846036","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. Vila de Tossa, s/n","informacio_web":"www.lloret.cat","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T19:12:00.000"},{":id":"row-jmef.kzmn-ztms",":version":"rv-m2hv-8hdn_iv9r",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"\xc0rea d\'esbarjo parc d\'en Fof\xf3","indicador_refugi":"170950|AREA_DESBARJO_PARC_DEN_FOFO","municipi":"Lloret de Mar","codi_municipi":"170950","latitud":"41.703634","longitud":"2.842863","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. dels Mestres, 9","informacio_web":"www.lloret.cat","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T19:14:00.000"},{":id":"row-nvse-s6ix_6wcs",":version":"rv-t25n.ivfn.sypr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de jubilats de Residencial Parc","indicador_refugi":"171030|CASAL_DE_JUBILATS_DE_RESIDENCIAL_PARC","municipi":"Ma\xe7anet de la Selva","codi_municipi":"171030","latitud":"41.78180186","longitud":"2.70209733","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Xiprer, 20","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-wzdj.23kg_6b8g",":version":"rv-xujm-2uxt~n8i6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal de Ma\xe7anet de la Selva","indicador_refugi":"171030|PISCINA_MUNICIPAL_DE_MACANET_DE_LA_SELVA","municipi":"Ma\xe7anet de la Selva","codi_municipi":"171030","latitud":"41.77599851","longitud":"2.72952897","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Av. Passeig Sant Lloren\xe7, 1","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-miqv~5676.duca",":version":"rv-bg5s~k3bv~eaan",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal de Ma\xe7anet de la Selva","indicador_refugi":"171030|BIBLIOTECA_MUNICIPAL_DE_MACANET_DE_LA_SELVA","municipi":"Ma\xe7anet de la Selva","codi_municipi":"171030","latitud":"41.77790052","longitud":"2.73121496","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Cabrera, 12","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-gued~vned_q6g4",":version":"rv-p2cb_23xv~a8ww",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal dels jubilats del Poble","indicador_refugi":"171030|CASAL_DELS_JUBILATS_DEL_POBLE","municipi":"Ma\xe7anet de la Selva","codi_municipi":"171030","latitud":"41.77841248","longitud":"2.73437546","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Dolors, 48","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-ejmk-2n43.cbvm",":version":"rv-eyvf_4jmk.2vgb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CIR de Madremanya","indicador_refugi":"170979|CIR_DE_MADREMANYA","municipi":"Madremanya","codi_municipi":"170979","latitud":"41.9914","longitud":"2.9561","accessibilitat":"No","aigua":"No","climatitzacio":"No","area_descans":"No","lavabo":"No","adreca":"c/ del Quintar, 4","informacio_web":"http://cirmadremanya.com","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-09T11:05:00.000"},{":id":"row-qkrn.6ydv_t67m",":version":"rv-rrd2~72sf~jgjb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pavell\xf3 de Madremanya","indicador_refugi":"170979|PAVELLO_DE_MADREMANYA","municipi":"Madremanya","codi_municipi":"170979","latitud":"41.9913","longitud":"2.9551","accessibilitat":"No","aigua":"No","climatitzacio":"No","area_descans":"No","lavabo":"No","adreca":"c/ del Quintar, 3","informacio_web":"https://madremanya.cat/guia-del-poble/equipaments-publics/pavello-municipal/","tipologia":"Pavell\xf3 Esportiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-09T11:06:00.000"},{":id":"row-t4dq.7x9j_ivx4",":version":"rv-6zad.qkwt.hnf8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal Ernest Lluch","indicador_refugi":"170985|PISCINA_MUNICIPAL_ERNEST_LLUCH","municipi":"Mai\xe0 de Montcal","codi_municipi":"170985","latitud":"42.21933975","longitud":"2.7459502","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Girona, 3","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-ncva.e6bk-rmny",":version":"rv-atvj~x7sf.ypc2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals de Maials","indicador_refugi":"251333|PISCINES_MUNICIPALS_DE_MAIALS","municipi":"Maials","codi_municipi":"251333","latitud":"41.36404758","longitud":"0.50992985","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Barceloneta, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-tuhr_tjpb~rqq5",":version":"rv-hvkd_jfy6_nzsk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la Pla\xe7a (ASVAT)","indicador_refugi":"081120|CASAL_DE_LA_PLACA_ASVAT","municipi":"Manlleu","codi_municipi":"081120","latitud":"42.00077908","longitud":"2.28365376","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Fra Bernad\xed, 4","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-ckcf~h3wt_46cj",":version":"rv-hwbh.kmcm-w9ci",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala exposicions Can Puget","indicador_refugi":"081120|SALA_EXPOSICIONS_CAN_PUGET","municipi":"Manlleu","codi_municipi":"081120","latitud":"42.0012186","longitud":"2.28361007","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. de Dalt Vila, 3","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-z3ny_dyax~9mnn",":version":"rv-3phs_6659.nck7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal de Manlleu","indicador_refugi":"081120|BIBLIOTECA_MUNICIPAL_DE_MANLLEU","municipi":"Manlleu","codi_municipi":"081120","latitud":"42.00021113","longitud":"2.285109","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. del Pont, 16-18 2a planta","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-2gme_fddn.vipe",":version":"rv-qrpu_f67r_esey",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat municipal de Manlleu","indicador_refugi":"081120|MERCAT_MUNICIPAL_DE_MANLLEU","municipi":"Manlleu","codi_municipi":"081120","latitud":"42.00496648","longitud":"2.285371","accessibilitat":"S\xed","aigua":"No","area_descans":"No","adreca":"C. Pintor Gu\xe0rdia, 6","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-7evq_xawj-xqbf",":version":"rv-mz6i.iikw_hamm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Selves i Carner","indicador_refugi":"081136|CENTRE_CIVIC_SELVES_I_CARNER","municipi":"Manresa","codi_municipi":"081136","latitud":"41.72740779","longitud":"1.81923091","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Bernat i Oller, 14-16","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-rgwj_idjt.t54a",":version":"rv-vmdn_32rr-w22g",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Associaci\xf3 de ve\xefns Passeig i rodalies","indicador_refugi":"081136|ASSOCIACIO_DE_VEINS_PASSEIG_I_RODALIES","municipi":"Manresa","codi_municipi":"081136","latitud":"41.72523958","longitud":"1.82332377","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Jaume I, 8, entres\xf2l","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-beem.4xf9-bvh6",":version":"rv-xbjj-6ntf_pkv9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Oficina de turisme","indicador_refugi":"081136|OFICINA_DE_TURISME","municipi":"Manresa","codi_municipi":"081136","latitud":"41.72358836","longitud":"1.82745709","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Major, 10","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-irui~38z4~v4gt",":version":"rv-975n-hgyv~5v6r",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Associaci\xf3 de ve\xefns del barri de Sant Pau","indicador_refugi":"081136|ASSOCIACIO_DE_VEINS_DEL_BARRI_DE_SANT_PAU","municipi":"Manresa","codi_municipi":"081136","latitud":"41.7145811","longitud":"1.82817842","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Cardener, 12 -14","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-jter_6fj8~rube",":version":"rv-f8w2-tedb-am6n",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Associaci\xf3 de ve\xefns Font dels Capellans","indicador_refugi":"081136|ASSOCIACIO_DE_VEINS_FONT_DELS_CAPELLANS","municipi":"Manresa","codi_municipi":"081136","latitud":"41.7286496","longitud":"1.83787812","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Font dels Capellans octogonal 14, local 75","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-vgum_tpnj.qwyk",":version":"rv-y2z5_drx9_wmtb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"El Casino","indicador_refugi":"081136|EL_CASINO","municipi":"Manresa","codi_municipi":"081136","latitud":"41.7271055","longitud":"1.82340831","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. Pere III, 29","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-a2pm~4g6u_7zee",":version":"rv-xshr~stzp-ftc6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Ateneu Les Bases","indicador_refugi":"081136|BIBLIOTECA_ATENEU_LES_BASES","municipi":"Manresa","codi_municipi":"081136","latitud":"41.73515831","longitud":"1.83008622","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Cintaires, 30-32","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-uip9-re2v_x2nr",":version":"rv-4sz5.i8xr_tmwc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Oficina d\'Atenci\xf3 Econ\xf2mica (OAE)","indicador_refugi":"081136|OFICINA_D_ATENCIO_ECONOMICA_OAE","municipi":"Manresa","codi_municipi":"081136","latitud":"41.72389101","longitud":"1.82653503","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Major, 17","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-xb87_35nq-ijfj",":version":"rv-qm4f_kvv3_bygh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Manresa - el Castell","indicador_refugi":"081136|CASAL_CIVIC_I_COMUNITARI_MANRESA_EL_CASTELL","municipi":"Manresa","codi_municipi":"081136","latitud":"41.7302173","longitud":"1.8241549","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Circumval\xb7laci\xf3, 60","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-m6tv.yvp7-upm8",":version":"rv-zazr.wwjh_npr2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Oficines municipals de Serveis econ\xf2mics","indicador_refugi":"081136|OFICINES_MUNICIPALS_DE_SERVEIS_ECONOMICS","municipi":"Manresa","codi_municipi":"081136","latitud":"41.72342072","longitud":"1.82733535","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Major, 5","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-hdug~984k_gxxx",":version":"rv-9e2p.z8zm_f2aa",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de les Escodines","indicador_refugi":"081136|CASAL_DE_LES_ESCODINES","municipi":"Manresa","codi_municipi":"081136","latitud":"41.72247854","longitud":"1.83048432","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Sant Bartomeu, 50 - 54","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-qcxy~t4zv~tnih",":version":"rv-y3eg-42yb.mscs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Palau Firal","indicador_refugi":"081136|PALAU_FIRAL","municipi":"Manresa","codi_municipi":"081136","latitud":"41.73880557","longitud":"1.8471999","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Castelladral, 5 -7","tipologia":"Espai firal","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-qnte-vvr8_4tw4",":version":"rv-a2ec.heg7-wh5u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Alberg de Joventut","indicador_refugi":"081136|ALBERG_DE_JOVENTUT","municipi":"Manresa","codi_municipi":"081136","latitud":"41.7246376","longitud":"1.8261963","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Mil centenari, s/n","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-idw9.sqcz-cduq",":version":"rv-57ww-3g6v~9m97",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal c\xedvic i comunitari Font dels Capellans","indicador_refugi":"081136|CASAL_CIVIC_I_COMUNITARI_FONT_DELS_CAPELLANS","municipi":"Manresa","codi_municipi":"081136","latitud":"41.72987301","longitud":"1.83882462","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Granollers, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-hvwe_ar4r.tum7",":version":"rv-6z97_ptpy_zaqv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Manresa - Mion Puigberenguer","indicador_refugi":"081136|CASAL_CIVIC_I_COMUNITARI_MANRESA_MION_PUIGBERENGUER","municipi":"Manresa","codi_municipi":"081136","latitud":"41.738344","longitud":"1.8041056","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de la Democr\xe0cia, 1","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-3z6r_pw4p_d97p",":version":"rv-mrkd_uubz.dtm9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Oficina d\'Atenci\xf3 al Ciutad\xe0","indicador_refugi":"081136|OFICINA_D_ATENCIO_AL_CIUTADA","municipi":"Manresa","codi_municipi":"081136","latitud":"41.72317487","longitud":"1.82697783","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Major, 1","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-q9xi.uzpa-itfc",":version":"rv-ty5w.wuvp-w2p5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de joves la Kampana","indicador_refugi":"081136|CASAL_DE_JOVES_LA_KAMPANA","municipi":"Manresa","codi_municipi":"081136","latitud":"41.7222968","longitud":"1.82291715","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Ic\xe0ria, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-9ff5-k3gc.rkez",":version":"rv-ehs9~8me2~ymnn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Manresa - Pare Ignasi Puig","indicador_refugi":"081136|CASAL_CIVIC_I_COMUNITARI_MANRESA_PARE_IGNASI_PUIG","municipi":"Manresa","codi_municipi":"081136","latitud":"41.7259263","longitud":"1.801194","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Grup d\'Habitatges El Xup, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-u57t_z3gp~nqp5",":version":"rv-nx8g~a52u_ps2t",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Joan Amades","indicador_refugi":"081136|CENTRE_CIVIC_JOAN_AMADES","municipi":"Manresa","codi_municipi":"081136","latitud":"41.72314004","longitud":"1.83872346","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Sant Blai, 14","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-6a38~65at.gidw",":version":"rv-vf58_ip66-cubx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Associaci\xf3 de ve\xefns Valldaura","indicador_refugi":"081136|ASSOCIACIO_DE_VEINS_VALLDAURA","municipi":"Manresa","codi_municipi":"081136","latitud":"41.7243339","longitud":"1.81756932","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Ausi\xe0s March, 10","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-6u8x_26mw.yejk",":version":"rv-xvrv-zfpq-izq9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Associaci\xf3 de ve\xefns de Cal Gravat","indicador_refugi":"081136|ASSOCIACIO_DE_VEINS_DE_CAL_GRAVAT","municipi":"Manresa","codi_municipi":"081136","latitud":"41.7199929","longitud":"1.84393072","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Cal Gravat, 2 i 5 baixos","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-7ne9_hcr8~bk5w",":version":"rv-xqwy~8ghv~eir3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Associaci\xf3 de ve\xefns Mion-Puigberenguer","indicador_refugi":"081136|ASSOCIACIO_DE_VEINS_MION_PUIGBERENGUER","municipi":"Manresa","codi_municipi":"081136","latitud":"41.7374814","longitud":"1.82132022","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Florida, 24, 08242 Manresa","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-mmpm-k8w8.qwr8",":version":"rv-wz9g~k9b7-jqrh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai c\xedvic El Safareig","indicador_refugi":"081154|ESPAI_CIVIC_EL_SAFAREIG","municipi":"Martorelles","codi_municipi":"081154","latitud":"41.52600937","longitud":"2.23661633","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc de Can Sunyer","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-hg5s_j4wb.whgk",":version":"rv-6yzd-bv7v-sn54",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Lolita Mila","indicador_refugi":"081154|BIBLIOTECA_LOLITA_MILA","municipi":"Martorelles","codi_municipi":"081154","latitud":"41.52936272","longitud":"2.24127802","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. del Dr. Santiago Tiffon, 21","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-gmzu.nyz6_5mnn",":version":"rv-y56v-66xc-fjdu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal de Martorelles","indicador_refugi":"081154|PISCINA_MUNICIPAL_DE_MARTORELLES","municipi":"Martorelles","codi_municipi":"081154","latitud":"41.52584789","longitud":"2.23594325","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. del Parc, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-6kdw~j8z3_72qx",":version":"rv-777t.xrpd.9v46",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai polivalent La Vinya","indicador_refugi":"081154|ESPAI_POLIVALENT_LA_VINYA","municipi":"Martorelles","codi_municipi":"081154","latitud":"41.52813562","longitud":"2.22946591","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Trav. de Carrenc\xe0, 8","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-rfqb~fhpv~rk7t",":version":"rv-wbg2-j6d7.vdxc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CENTRE CIVIC","indicador_refugi":"430770|CENTRE_CIVIC","municipi":"Mas de Barberans","codi_municipi":"430770","latitud":"40.73573440048861","longitud":"0.739210072043808","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ MOL\xcd, 26","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T10:57:00.000"},{":id":"row-2zki~afc3~igrv",":version":"rv-b9is~xjes-maaa",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Masdenverge Actiu","indicador_refugi":"430786|CENTRE_MASDENVERGE_ACTIU","municipi":"Masdenverge","codi_municipi":"430786","latitud":"40.71910105","longitud":"0.53131081","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Ctra. d\'Amposta, 11, 43878 Masdenverge, Tarragona","informacio_web":"www.masdenverge.cat","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-02T13:23:00.000"},{":id":"row-a49n~swd9~7d9v",":version":"rv-5g7t_m46v.7777",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala polivalent de les Masies de Roda","indicador_refugi":"081167|SALA_POLIVALENT_DE_LES_MASIES_DE_RODA","municipi":"Masies de Roda, les","codi_municipi":"081167","latitud":"41.99049201","longitud":"2.30678342","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. de Manlleu, s/n","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-6sfg_4ukx-8tez",":version":"rv-8qam-i46v.97ie",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament de Les Masies de Voltreg\xe0","indicador_refugi":"081173|AJUNTAMENT_DE_LES_MASIES_DE_VOLTREGA","municipi":"Masies de Voltreg\xe0, les","codi_municipi":"081173","latitud":"42.01252738","longitud":"2.25011556","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. c-17z pk 70.4, 08508 Les Masies de Voltreg\xe0","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-eukx-rvzp~4i9c",":version":"rv-5drn_rvvk.wy2v",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa del Marqu\xe8s","indicador_refugi":"081189|CASA_DEL_MARQUES","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.47807183","longitud":"2.30445872","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. del Bellresguard, 12","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-sxpt_qq2j.bfih",":version":"rv-sv8y-uqjh.kcng",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de Can Targa","indicador_refugi":"081189|JARDINS_DE_CAN_TARGA","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.47641871","longitud":"2.3064563","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Can Targa, s/n","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-um8b_csw5.wnhd",":version":"rv-didf.db6a-g6tp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de gent gran de Can Malet","indicador_refugi":"081189|CASAL_DE_GENT_GRAN_DE_CAN_MALET","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.47985316","longitud":"2.31930974","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Sant Felip, 2","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-fca5~25cc-z72f",":version":"rv-cx94~2nej~nksh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Llac","indicador_refugi":"081189|PARC_DEL_LLAC","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.47873777","longitud":"2.30359728","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ptge. Bellresguard, s/n","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-3ecg~4xsr-nis4",":version":"rv-mh2n~gmad.7iez",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins del Mestre Llu\xeds Millet","indicador_refugi":"081189|JARDINS_DEL_MESTRE_LLUIS_MILLET","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.48309263","longitud":"2.31989957","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Cus\xed Fortunet, 21","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-spdb-3cmc_fd7c",":version":"rv-sjuy.i5rt-apq6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Passad\xeds central Edifici Centre","indicador_refugi":"081189|PASSADIS_CENTRAL_EDIFICI_CENTRE","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.48243567","longitud":"2.3161181","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. It\xe0lia, 50","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-d95p-t32r_hhtc",":version":"rv-fpd7~nciv~tsm8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa de la Vila","indicador_refugi":"081189|CASA_DE_LA_VILA","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.47919247","longitud":"2.31914488","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Prat de la Riba, 1","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-zipe-dncm_i2qx",":version":"rv-hshy.fkap-zje8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de gent gran Can Mandri","indicador_refugi":"081189|CASAL_DE_GENT_GRAN_CAN_MANDRI","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.48752348","longitud":"2.30777747","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Ametllers, 12","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-pxe6-syeh-j6eu",":version":"rv-g8gd-4h96~huda",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Caramar","indicador_refugi":"081189|PARC_DE_CARAMAR","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.48248634","longitud":"2.32051897","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Joan Miro, s/n","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-gk5m~3c2d_59v8",":version":"rv-6ew7-rqkg.e6ap",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de Can Malet","indicador_refugi":"081189|JARDINS_DE_CAN_MALET","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.47959277","longitud":"2.31943078","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ptge. Maria Rossell, 9","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-yi6q-bxtv-cgcp",":version":"rv-iws3.rns7-mgxs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins Pa\xefsos Catalans","indicador_refugi":"081189|JARDINS_PAISOS_CATALANS","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.48208715","longitud":"2.32814555","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Manila, 19","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-t8c8.5ekr_j3ee",":version":"rv-fxbn-wkty_4nx6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Oficina Atenci\xf3 Ciutad\xe0 (OAC)","indicador_refugi":"081189|OFICINA_ATENCIO_CIUTADA_OAC","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.47964465","longitud":"2.31809242","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Igualtat, 1","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-3xjy_yjuc.8x92",":version":"rv-ep7p.2ner-27zg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc dels Vivers","indicador_refugi":"081189|PARC_DELS_VIVERS","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.48747522","longitud":"2.32254692","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Verge de N\xfaria, s/n","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-m9w8_2k5t~9h7n",":version":"rv-h7m9~5rqk.hf6m",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Els Vienesos","indicador_refugi":"081189|ELS_VIENESOS","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.48511548","longitud":"2.30727542","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Segarra, 12","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-dyp5_n9aw.6h46",":version":"rv-yu6s-5mkk.szg7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai ve\xefnal Masnou Alt","indicador_refugi":"081189|ESPAI_VEINAL_MASNOU_ALT","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.48643302","longitud":"2.31123514","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Ramon i Cajal","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-fgun_wdam_3vtt",":version":"rv-x7qy-295z~yhe8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu municipal de N\xe0utica","indicador_refugi":"081189|MUSEU_MUNICIPAL_DE_NAUTICA","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.48277263","longitud":"2.31574595","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Pujades Truch, 1","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-5vim~v6n9~sbem",":version":"rv-jv7w~t6tw_vdgk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de Llu\xeds Companys","indicador_refugi":"081189|JARDINS_DE_LLUIS_COMPANYS","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.48539044","longitud":"2.3097492","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Joan XXIII, s/n","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-x9cj-rvit_dm6y",":version":"rv-h3hc.zqqb.nzfq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Carrer Esperan\xe7a","indicador_refugi":"081189|CARRER_ESPERANCA","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.48024924","longitud":"2.31861691","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Esperan\xe7a, s/n","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-7t2s-pdnv_dt58",":version":"rv-tuxm-sc3a.wdts",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa de Cultura","indicador_refugi":"081189|CASA_DE_CULTURA","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.47949016","longitud":"2.32044155","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Prat de la Riba, 16","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-9rbu-djj8_ssrg",":version":"rv-xi9u~dsdx_i6es",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de les Nacions","indicador_refugi":"081189|JARDINS_DE_LES_NACIONS","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.48763875","longitud":"2.30891485","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Can Mandri, 2","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-rkbs_if3w~ctk5",":version":"rv-w866~jmv5~aww2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Vallmora","indicador_refugi":"081189|PARC_VALLMORA","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.48492496","longitud":"2.31496159","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Montevideo, 56","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-kzyw~hbgn_xkqa",":version":"rv-nw49-de9d.sma2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de gent gran Ocata","indicador_refugi":"081189|CASAL_DE_GENT_GRAN_OCATA","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.48230652","longitud":"2.3248057","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Jaume I, 121","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-nkuv-3yym-jqhm",":version":"rv-8ztk-vu66.3wiy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Creu Roja Masnou","indicador_refugi":"081189|CREU_ROJA_MASNOU","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.48347287","longitud":"2.33687596","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. de la Riera, s/n","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-3spt~wpjp-bdte",":version":"rv-j749_jygc.j7dz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat municipal","indicador_refugi":"081189|MERCAT_MUNICIPAL","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.482648263080726","longitud":"2.3164301189946186","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer It\xe0lia, 50","informacio_web":"https://www.mercatdelmasnou.cat/","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-12T09:33:00.000"},{":id":"row-i2rw~zibf-cuhy",":version":"rv-qwh8~hu46-g7ee",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Joan Coromines","indicador_refugi":"081189|BIBLIOTECA_JOAN_COROMINES","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.48284647760909","longitud":"2.3159647039420066","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Josep Pujadas Truch, 1 A, 08320 El Masnou, Barcelona","informacio_web":"http://bibliotecavirtual.diba.cat/masnou-el-biblioteca-joan-coromines","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-12T10:28:00.000"},{":id":"row-b4ti_7uhx.udxk",":version":"rv-nqjk~aenw.krhs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Equipament C\xedvic Els Masovers","indicador_refugi":"081189|EQUIPAMENT_CIVIC_ELS_MASOVERS","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.48010514638161","longitud":"2.3046301198380026","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Rosa Sensat, 08320 Barcelona","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-12T10:30:00.000"},{":id":"row-rewp~ymaq_mctu",":version":"rv-ch8u.hqth-ge2m",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai ve\xefnal del Cul d\u2019Ocata","indicador_refugi":"081189|ESPAI_VEINAL_DEL_CUL_D\u2019OCATA","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.48317815834714","longitud":"2.3284454298076724","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Paraguai, 10, 08320 El Masnou, Barcelona","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-12T10:31:00.000"},{":id":"row-ze63~4irb_qixn",":version":"rv-j2zs_gqwm~j35u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Ramon i Cajal","indicador_refugi":"081189|PLACA_RAMON_I_CAJAL","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.486793165875795","longitud":"2.311743596005727","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Ramon i Cajal","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-12T11:05:00.000"},{":id":"row-xngi.yyrv.bnrd",":version":"rv-zxx2.9na9-3h2p",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc dels Pinetons","indicador_refugi":"081189|PARC_DELS_PINETONS","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.482598460961704","longitud":"2.3124361800638233","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. Joan XXIII, 60, 08320 El Masnou, Barcelona","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-12T11:08:00.000"},{":id":"row-u8gk.vj6f.dm4v",":version":"rv-pxdx_qe7c_zm7z",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de la Nimfa","indicador_refugi":"081189|JARDINS_DE_LA_NIMFA","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.48232231878614","longitud":"2.3327303785744395","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Jardins de la Nimfa","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-12T11:09:00.000"},{":id":"row-hesq.vnuq~9t9u",":version":"rv-v6uz.hsyz.as5d",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Vila de Madrid","indicador_refugi":"081189|PLACA_VILA_DE_MADRID","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.48210852787594","longitud":"2.32798004697873","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Vila de Madrid","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-12T11:12:00.000"},{":id":"row-cg43~8dht.8a33",":version":"rv-s7an~a29s_gv7q",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Miquel Mart\xed i Pol","indicador_refugi":"081189|PLACA_MIQUEL_MARTI_I_POL","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.48309364220762","longitud":"2.317132992060575","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Miquel Mart\xed i Pol","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-12T11:13:00.000"},{":id":"row-afuk-nuv6.zu3u",":version":"rv-8d8c-fmei~ui3h",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a d\'Ocata","indicador_refugi":"081189|PLACA_DOCATA","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.481803773008416","longitud":"2.3252753080292554","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a d\'Ocata","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-12T11:16:00.000"},{":id":"row-2wmu-s4pb_843f",":version":"rv-rr6h.jkxt~a6pf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Espanya","indicador_refugi":"081189|PLACA_ESPANYA","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.4827670061434","longitud":"2.3153727205904837","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Espanya","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-12T11:17:00.000"},{":id":"row-wyxr_72hx_cg9y",":version":"rv-mh4y_944m-zwxi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Jaume Bertran","indicador_refugi":"081189|PLACA_JAUME_BERTRAN","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.480066293126455","longitud":"2.321750188386581","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Jaume Bertran","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-12T11:18:00.000"},{":id":"row-tj59-y7wz.wwti",":version":"rv-mu8q~gszy~23fz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Mil\xb7lenari","indicador_refugi":"081189|PARC_DEL_MILLENARI","municipi":"Masnou, el","codi_municipi":"081189","latitud":"41.482404823480316","longitud":"2.326760435334349","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Jaume I, 119, 08320 El Masnou,","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-18T14:22:00.000"},{":id":"row-iru8.z7b2-azv6",":version":"rv-qi93.mw2m.xgdm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pista poliesportiva","indicador_refugi":"430810|PISTA_POLIESPORTIVA","municipi":"Maspujols","codi_municipi":"430810","latitud":"41.18044230664091","longitud":"1.046271482450014","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"No","lavabo":"No","adreca":"Avinguda poliesportiu S/N","informacio_web":"https://maspujols.cat/","tipologia":"Pavell\xf3 Esportiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T12:25:00.000"},{":id":"row-ekvf~m3gr~u93x",":version":"rv-fcgq.e738.nctc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Oficina d\'Atenci\xf3 al Vilat\xe0 de l\'Ajuntament de Masquefa","indicador_refugi":"081192|OFICINA_DATENCIO_AL_VILATA_DE_LAJUNTAMENT_DE_MASQUEFA","municipi":"Masquefa","codi_municipi":"081192","latitud":"41.50221","longitud":"1.811215","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Major, 93","informacio_web":"https://masquefa.cat/oficina-atencio-vilata/","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-01T12:32:00.000"},{":id":"row-q9hz-2hxm_srjf",":version":"rv-3ejf-vpa4~jkix",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Tecnol\xf2gic Comunitari (CTC)","indicador_refugi":"081192|CENTRE_TECNOLOGIC_COMUNITARI_(CTC)","municipi":"Masquefa","codi_municipi":"081192","latitud":"41.500461","longitud":"1.81424","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda Catalunya 56-62","informacio_web":"https://masquefa.cat/tic/","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-01T12:37:00.000"},{":id":"row-yckz.e3m3~itsq",":version":"rv-qczs_d789.dkk4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca M. Carme Junyent Figueras","indicador_refugi":"081192|BIBLIOTECA_M_CARME_JUNYENT_FIGUERAS","municipi":"Masquefa","codi_municipi":"081192","latitud":"41.50036","longitud":"1.81375","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Rogelio Rojo,5-9","informacio_web":"https://masquefa.cat/cultura/","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-01T12:42:00.000"},{":id":"row-hhff.ervc.jvut",":version":"rv-83yw.vjc8-fja5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Joves Masquefa","indicador_refugi":"081192|CASAL_DE_JOVES_MASQUEFA","municipi":"Masquefa","codi_municipi":"081192","latitud":"41.49969","longitud":"1.81456","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Santa Clara 16-22","informacio_web":"https://masquefa.cat/joventut/","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-01T12:46:00.000"},{":id":"row-h3x3-jtcf_kz69",":version":"rv-x4ji_sstm-fia2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal d\'Avis de Masquefa","indicador_refugi":"081192|CASAL_DAVIS_DE_MASQUEFA","municipi":"Masquefa","codi_municipi":"081192","latitud":"41.50208","longitud":"1.81245","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Escoles, 6","informacio_web":"https://masquefa.cat/gent-gran/","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-01T12:49:00.000"},{":id":"row-surv.gzzz~e8bs",":version":"rv-ybsp.jv3k-hr4k",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Fisart","indicador_refugi":"081192|FISART","municipi":"Masquefa","codi_municipi":"081192","latitud":"41.50077","longitud":"1.81328","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda Catalunya 68-74 local 2","informacio_web":"https://fisart.es","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-02T11:18:00.000"},{":id":"row-685q~btpt_4vxb",":version":"rv-5ck8-6cxa.bj2f",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Kushala","indicador_refugi":"081192|KUSHALA","municipi":"Masquefa","codi_municipi":"081192","latitud":"41.49928","longitud":"1.8173","accessibilitat":"No","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda la L\xednia 4-6 local 1","informacio_web":"https://kushalaayurveda.es/","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-02T12:45:00.000"},{":id":"row-fqt3-btzu~vefn",":version":"rv-7496_2ry8.xapk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Farm\xe0cia Masquefa","indicador_refugi":"081192|FARMACIA_MASQUEFA","municipi":"Masquefa","codi_municipi":"081192","latitud":"41.50178","longitud":"1.81393","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Major 1","informacio_web":"https://www.farmaciamasquefa.com/","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-02T12:50:00.000"},{":id":"row-dnqb-swj2~sviv",":version":"rv-3bcy~gm8t~2phj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Punt Taronja (Hiper Gal\xedcia Can Parellada)","indicador_refugi":"081192|PUNT_TARONJA_(HIPER_GALICIA_CAN_PARELLADA)","municipi":"Masquefa","codi_municipi":"081192","latitud":"41.5004515","longitud":"1.8294492","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carretera B-224 Km. 17.5 Can Parellada","informacio_web":"https://punttaronja.com/","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-02T13:51:00.000"},{":id":"row-tpzp_cwuy~maf3",":version":"rv-tiur-9z5h_ytjk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Farm\xe0cia Durban","indicador_refugi":"081192|FARMACIA_DURBAN","municipi":"Masquefa","codi_municipi":"081192","latitud":"41.49987","longitud":"1.81633","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Doctor Rotllant 43","informacio_web":"https://www.farmaciaclotildedurbanfmas.com/","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-02T13:55:00.000"},{":id":"row-q37w_uqgk~gg4f",":version":"rv-fr7s-hxq9~838w",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Cafeteria CTC","indicador_refugi":"081192|CAFETERIA_CTC","municipi":"Masquefa","codi_municipi":"081192","latitud":"41.50063","longitud":"1.81452","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda Catalunya 58","informacio_web":"ctc.cafeteria.bar.masquefa","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-02T14:24:00.000"},{":id":"row-9bgz~f2hn-bghk",":version":"rv-pw42-e7by.b3f4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mora Tradici\xf3 Fornera","indicador_refugi":"081192|MORA_TRADICIO_FORNERA","municipi":"Masquefa","codi_municipi":"081192","latitud":"41.49907","longitud":"1.8162","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda L\xednia 7","informacio_web":"https://panaderiaminutos.es/12485-mora-tradicio-fornera-panaderia-en-masquefa-barcelona/","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-02T14:28:00.000"},{":id":"row-nvze-7dza_ntmb",":version":"rv-gfqx.jj9h-j35q",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La Lluna Cafeteria","indicador_refugi":"081192|LA_LLUNA_CAFETERIA","municipi":"Masquefa","codi_municipi":"081192","latitud":"41.49919","longitud":"1.81506","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda L\xednia 15","informacio_web":"https://cafeterisimos.com/la-lluna-cafeteria-masquefa/","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-02T14:33:00.000"},{":id":"row-s3st-9yt9.qp9d",":version":"rv-9svq-vxaw_ttfr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mora Tradici\xf3 Fornera Can Parellada","indicador_refugi":"081192|MORA_TRADICIO_FORNERA_CAN_PARELLADA","municipi":"Masquefa","codi_municipi":"081192","latitud":"41.50025","longitud":"1.83049","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carretera de Martorell a Capellades 29 Can Parellada","informacio_web":"https://pamora.net/","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-03T11:20:00.000"},{":id":"row-ym2h~neyg_ip7n",":version":"rv-6y5m~ucuk-p7ys",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal social","indicador_refugi":"251312|CASAL_SOCIAL","municipi":"Massalcoreig","codi_municipi":"251312","latitud":"41.45777718","longitud":"0.3584095","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. del Casal, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-awzg-4s5p~hx5e",":version":"rv-niy9~rea8_japs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local social 1 d\'octubre","indicador_refugi":"171019|LOCAL_SOCIAL_1_D_OCTUBRE","municipi":"Massanes","codi_municipi":"171019","latitud":"41.76667433","longitud":"2.6519036","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Montseny, 1","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-t8ua-c8eq~bpvn",":version":"rv-9bcv_butc-9p6n",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la Gent Gran","indicador_refugi":"081206|CASAL_DE_LA_GENT_GRAN","municipi":"Matadepera","codi_municipi":"081206","latitud":"41.59741942","longitud":"2.02643738","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra Terrassa, 35","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-x87k_a554~jtis",":version":"rv-tb54.4wwi-kg8u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals","indicador_refugi":"081206|PISCINES_MUNICIPALS","municipi":"Matadepera","codi_municipi":"081206","latitud":"41.60413023","longitud":"2.02063561","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Mariapfarr, 8","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-db5p-adjg.qj36",":version":"rv-ing7.za7j-j5up",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"L\'Hotel - Punt Jove","indicador_refugi":"081206|L_HOTEL_PUNT_JOVE","municipi":"Matadepera","codi_municipi":"081206","latitud":"41.5989415","longitud":"2.02710847","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Sant Isidre, 35","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-b7eb_sesu~h6tu",":version":"rv-tfm4-4deb~u8ey",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Cultura","indicador_refugi":"081206|CASAL_DE_CULTURA","municipi":"Matadepera","codi_municipi":"081206","latitud":"41.59949061","longitud":"2.02823356","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Pere Aldavert, 4","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-yswz.7gfi-8hef",":version":"rv-rkgb_yshu_dspx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Pompeu Fabra","indicador_refugi":"081213|BIBLIOTECA_POMPEU_FABRA","municipi":"Matar\xf3","codi_municipi":"081213","latitud":"41.53842258","longitud":"2.43371181","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. d\'Occitania, s/n","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-8kw6-vjad.7w5y",":version":"rv-7fza~4buj_5j3a",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la gent gran Del Parc","indicador_refugi":"081213|CASAL_DE_LA_GENT_GRAN_DEL_PARC","municipi":"Matar\xf3","codi_municipi":"081213","latitud":"41.54541559","longitud":"2.44022183","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Av. Corregiment de Matar\xf3, 28","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-wc8d~rdba~k4s2",":version":"rv-hpps_cs2p.yfns",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Espai Gatassa","indicador_refugi":"081213|CENTRE_CIVIC_ESPAI_GATASSA","municipi":"Matar\xf3","codi_municipi":"081213","latitud":"41.53785968","longitud":"2.42847476","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de Josep Montserrat i Cuadrada, 1","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-56uz_7xzd.7qaa",":version":"rv-qyks.biw6-vxu8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Antoni Comas","indicador_refugi":"081213|BIBLIOTECA_ANTONI_COMAS","municipi":"Matar\xf3","codi_municipi":"081213","latitud":"41.54481449","longitud":"2.45323949","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. d\'Enric Pla de la Riba, 110","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-n9w7.9bvw.3reu",":version":"rv-4a35~nead-7vrq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Rocafonda","indicador_refugi":"081213|CENTRE_CIVIC_ROCAFONDA","municipi":"Matar\xf3","codi_municipi":"081213","latitud":"41.548953","longitud":"2.450807","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Santiago Rusi\xf1ol, 23","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T16:01:00.000"},{":id":"row-584x~xyn4_4jnq",":version":"rv-sycq-tp89_qbqd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal d\'avis Casa Nostra","indicador_refugi":"081228|CASAL_D_AVIS_CASA_NOSTRA","municipi":"Mediona","codi_municipi":"081228","latitud":"41.47674843","longitud":"1.61136295","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Dr. Trueta, 10","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-ebmf~t8pp~9ygc",":version":"rv-npnd_f5rs-s2jr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PANTINKILLO","indicador_refugi":"081228|PANTINKILLO","municipi":"Mediona","codi_municipi":"081228","latitud":"41.475653755894285","longitud":"1.61247757375623","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"No","adreca":"C/ MOL\xcd, 25 SANT JOAN DE MEDIONA (MEDIONA)","informacio_web":"https://www.dinamo.cat/equipaments-municipals/mediona/equipaments/pantinkillo","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-09T09:21:00.000"},{":id":"row-a3ce.et5r_6sfc",":version":"rv-3g39.jvu6.f3ij",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal municipal del Mil\xe0","indicador_refugi":"430831|CASAL_MUNICIPAL_DEL_MILA","municipi":"Mil\xe0, el","codi_municipi":"430831","latitud":"41.248384","longitud":"1.20723972","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Santa \xdarsula, 4","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-kdj5.ekyn~2zha",":version":"rv-8wir.8nsa.ucca",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals de Miralcamp","indicador_refugi":"251351|PISCINES_MUNICIPALS_DE_MIRALCAMP","municipi":"Miralcamp","codi_municipi":"251351","latitud":"41.60584188","longitud":"0.87753698","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Jacint Verdaguer, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-3qj6_zt4n_655b",":version":"rv-jtsz_iy24.kc5q",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Llar de jubilats de Miralcamp","indicador_refugi":"251351|LLAR_DE_JUBILATS_DE_MIRALCAMP","municipi":"Miralcamp","codi_municipi":"251351","latitud":"41.60607275","longitud":"0.87971558","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Pa\xefsos Catalans, 1","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-ufea-y8uv_ipau",":version":"rv-q6hx.3p4r~ty27",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina muncipal de Miravet","indicador_refugi":"430846|PISCINA_MUNCIPAL_DE_MIRAVET","municipi":"Miravet","codi_municipi":"430846","latitud":"41.04161964","longitud":"0.60055501","accessibilitat":"S\xed","aigua":"No","area_descans":"No","adreca":"C. Creu, 49","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-e45s-ssdf~acng",":version":"rv-pidu.v7ft_cr7d",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"430859|PISCINA_MUNICIPAL","municipi":"Molar, el","codi_municipi":"430859","latitud":"41.16345134","longitud":"0.70361532","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. del Molar a Garcia, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-fmme.n8n5.9snn",":version":"rv-whag_q4x7.byj9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Llar dels jubilats","indicador_refugi":"430859|LLAR_DELS_JUBILATS","municipi":"Molar, el","codi_municipi":"430859","latitud":"41.16364277","longitud":"0.70608343","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Marqu\xe8s de Tamarit, 1","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-zbgr-hv8r-yw2n",":version":"rv-vinj_m5pg.xj63",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic","indicador_refugi":"171061|CENTRE_CIVIC","municipi":"Mollet de Peralada","codi_municipi":"171061","latitud":"42.35857815220418","longitud":"3.0006881482393752","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Figueres, 19","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-05-31T20:13:00.000"},{":id":"row-cm94-5g35~8aua",":version":"rv-esg6-wzry-gfvr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Mollet del Vall\xe8s","indicador_refugi":"081249|CASAL_CIVIC_I_COMUNITARI_MOLLET_DEL_VALLES","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5372812","longitud":"2.2099815","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Rbla. de Balmes, 2","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-fb4a-x55s-pjdk",":version":"rv-5rmg~sajb~fbt3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC Can Pantiquet","indicador_refugi":"081249|CC_CAN_PANTIQUET","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5451","longitud":"2.2201","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Can Flequer 25","informacio_web":"https://www.molletvalles.cat/","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-09T13:43:00.000"},{":id":"row-kgff.kh6g_u9sc",":version":"rv-juug_76mg-s93t",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC Lourdes","indicador_refugi":"081249|CC_LOURDES","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5557","longitud":"2.2205","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Miguel de Cervantes 4","informacio_web":"https://www.molletvalles.cat/","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-10T12:42:00.000"},{":id":"row-tz5e-6afd.egcv",":version":"rv-ft5n-3567_328b",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC Can Borrell","indicador_refugi":"081249|CC_CAN_BORRELL","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5466","longitud":"2.205","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda Caldes de Montbui 23","informacio_web":"https://www.molletvalles.cat/","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-10T12:46:00.000"},{":id":"row-j4y3.krwd-bsqx",":version":"rv-acki~dr8p.9ykj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai Sant Jordi","indicador_refugi":"081249|ESPAI_SANT_JORDI","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5438","longitud":"2.2068","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda Caldes de Montbui 9","informacio_web":"https://www.molletvalles.cat/","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-10T12:49:00.000"},{":id":"row-g89q~x8nu.ghm7",":version":"rv-uq2i.pbd8.vf98",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Can Mul\xe0 - Jordi Sol\xe9 Tura","indicador_refugi":"081249|BIBLIOTECA_CAN_MULA_-_JORDI_SOLE_TURA","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5373","longitud":"2.2097","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Alsina 1","informacio_web":"https://www.molletvalles.cat/","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-10T12:51:00.000"},{":id":"row-v7v5~23cx.ucxt",":version":"rv-pzqy-wvas-jpwj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu Abell\xf3","indicador_refugi":"081249|MUSEU_ABELLO","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5355","longitud":"2.216","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Berenguer III 122","informacio_web":"https://www.molletvalles.cat/","tipologia":"Equipament Cultural (teatre, auditori, museu)","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-10T12:53:00.000"},{":id":"row-m4gt_6pym~grmp",":version":"rv-kdps~frub.fni6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"OAC Casa de la Vila","indicador_refugi":"081249|OAC_CASA_DE_LA_VILA","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5354","longitud":"2.2105","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Major 1","informacio_web":"https://www.molletvalles.cat/","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-10T13:02:00.000"},{":id":"row-fv3x~3bju~5ayd",":version":"rv-gtdz_zvnu~m47w",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Seu de Creu Roja","indicador_refugi":"081249|SEU_DE_CREU_ROJA","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5478","longitud":"2.2187","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a d\'Enric Ros\xe9s 5","informacio_web":"https://www.molletvalles.cat/","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-10T13:05:00.000"},{":id":"row-f7kk_xbtr.md3w",":version":"rv-7n66_jvfd-eyf6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat Municipal","indicador_refugi":"081249|MERCAT_MUNICIPAL","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5365","longitud":"2.2114","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda Llibertat 12","informacio_web":"https://www.molletvalles.cat/","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-10T13:07:00.000"},{":id":"row-3mvv_96e3~xs78",":version":"rv-8fi8-wufc-rkxt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Can Borrell","indicador_refugi":"081249|PARC_DE_CAN_BORRELL","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5465","longitud":"2.2059","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Parc de Can Borrell","informacio_web":"https://www.molletvalles.cat/","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-10T13:11:00.000"},{":id":"row-4inz_vd4e-evnr",":version":"rv-bbqv~78s2~4rcq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Frederica Montseny","indicador_refugi":"081249|PLACA_FREDERICA_MONTSENY","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5476","longitud":"2.2055","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Frederica Montseny","informacio_web":"https://www.molletvalles.cat/","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-10T13:14:00.000"},{":id":"row-gygi.pw4p-a698",":version":"rv-2wxu.sn9s.628r",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de Dolores Ib\xe1rruri","indicador_refugi":"081249|PLACA_DE_DOLORES_IBARRURI","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.548","longitud":"2.2069","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a de Dolores Ib\xe1rruri","informacio_web":"https://www.molletvalles.cat/","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-10T13:21:00.000"},{":id":"row-mw73~e7my-k5ce",":version":"rv-szmi-h37g.ekd8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de Maria Aur\xe8lia Capmany","indicador_refugi":"081249|PLACA_DE_MARIA_AURELIA_CAPMANY","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.4578","longitud":"2.2437","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a de Maria Aur\xe8lia Capmany","informacio_web":"https://www.molletvalles.cat/","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-10T13:23:00.000"},{":id":"row-ci4y_c2n5.zqzu",":version":"rv-a6eq.k7c5-5w6r",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Plana Lled\xf3","indicador_refugi":"081249|PARC_DE_LA_PLANA_LLEDO","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5464","longitud":"2.2127","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda Parc 15","informacio_web":"https://www.molletvalles.cat/","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-10T13:26:00.000"},{":id":"row-qmuj.mszz-u2e7",":version":"rv-k3w6~ih8v.hghv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jard\xed de la Farinera","indicador_refugi":"081249|JARDI_DE_LA_FARINERA","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5382","longitud":"2.2057","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Via Ronda 85","informacio_web":"https://www.molletvalles.cat/","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-10T13:32:00.000"},{":id":"row-a7ma.7dmc-4kmx",":version":"rv-8gs7_zvbs~mv49",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Can Mul\xe0","indicador_refugi":"081249|PARC_DE_CAN_MULA","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.537","longitud":"2.2101","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda Rafael Casanova 15","informacio_web":"https://www.molletvalles.cat/","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-10T13:37:00.000"},{":id":"row-rjn4_vvuu_5pm6",":version":"rv-erhs~qzjs.uw5g",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de Pau Casals","indicador_refugi":"081249|PLACA_DE_PAU_CASALS","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5349","longitud":"2.2102","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a de Pau Casals","informacio_web":"https://www.molletvalles.cat/","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-10T13:42:00.000"},{":id":"row-g57h_jfaa-qaiz",":version":"rv-2m6w-8e5q_gavw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de la Constituci\xf3","indicador_refugi":"081249|PLACA_DE_LA_CONSTITUCIO","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5339","longitud":"2.2125","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a de la Constituci\xf3","informacio_web":"https://www.molletvalles.cat/","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T13:13:00.000"},{":id":"row-r4ft.6z75_bfjj",":version":"rv-g79u~k5e2~dp2a",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Nelson Mandela","indicador_refugi":"081249|PLACA_NELSON_MANDELA","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5338","longitud":"2.211","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Nelson Mandela","informacio_web":"https://www.molletvalles.cat/","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T13:16:00.000"},{":id":"row-jqb6_i4im_mb2e",":version":"rv-3ym2~kkzr~vhp7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a d\'Antoni Su\xf1\xe9","indicador_refugi":"081249|PLACA_DANTONI_SU\xd1E","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5339","longitud":"2.2158","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a d\'Antoni Su\xf1\xe9","informacio_web":"https://www.molletvalles.cat/","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T13:19:00.000"},{":id":"row-appu.6cbt.466x",":version":"rv-rw66~zez9.xzs8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de les Pruneres","indicador_refugi":"081249|PARC_DE_LES_PRUNERES","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5383","longitud":"2.2151","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Pau 35","informacio_web":"https://www.molletvalles.cat/","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T13:21:00.000"},{":id":"row-z9rz.p93e.jhci",":version":"rv-bbe7-pweu_vnnd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Voluntaris Ol\xedmplics i Paral\xedmpics","indicador_refugi":"081249|PLACA_VOLUNTARIS_OLIMPLICS_I_PARALIMPICS","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5435","longitud":"2.2196","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Voluntaris Ol\xedmplics i Paral\xedmpics","informacio_web":"https://www.molletvalles.cat/","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T13:24:00.000"},{":id":"row-p7gj~evky~bxze",":version":"rv-ehna~zbzy~agfg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a dels Mercaders","indicador_refugi":"081249|PLACA_DELS_MERCADERS","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5386","longitud":"2.2177","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a dels Mercaders","informacio_web":"https://www.molletvalles.cat/","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T13:26:00.000"},{":id":"row-hbnc.fvaf~8426",":version":"rv-mwgy.cswp.zr3i",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a dels Ramaders","indicador_refugi":"081249|PLACA_DELS_RAMADERS","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5393","longitud":"2.2183","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a dels Ramaders","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T13:28:00.000"},{":id":"row-mphb.pd9v~qccf",":version":"rv-66ru_fvs5~ny4v",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a dels Pagesos de Remen\xe7a","indicador_refugi":"081249|PLACA_DELS_PAGESOS_DE_REMENCA","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5404","longitud":"2.2192","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a dels Pagesos de Remen\xe7a","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T13:30:00.000"},{":id":"row-wanq.aq8p_g3ba",":version":"rv-bzuw.997x-dqzu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a dels Ferrers","indicador_refugi":"081249|PLACA_DELS_FERRERS","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5413","longitud":"2.2199","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a dels Ferrers","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T13:31:00.000"},{":id":"row-qghr~gm4k_4s9j",":version":"rv-k5bj_rcw5~iusg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bosc de Can Pantiquet","indicador_refugi":"081249|BOSC_DE_CAN_PANTIQUET","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5485","longitud":"2.2173","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Llu\xeds Millet 15","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T13:35:00.000"},{":id":"row-v2yn~6zmv.6kea",":version":"rv-mn7r_9skp-mg8h",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc dels Colors","indicador_refugi":"081249|PARC_DELS_COLORS","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5442","longitud":"2.2055","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Parc dels Colors","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T13:38:00.000"},{":id":"row-tniz.arqk.skax",":version":"rv-zv2f.f9xg-pefz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Rafael Alberti","indicador_refugi":"081249|PLACA_RAFAEL_ALBERTI","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5543","longitud":"2.2215","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Rafael Alberti","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T13:39:00.000"},{":id":"row-2ayj_85zt.sygc",":version":"rv-a6hb-ph7t~8nte",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Dona d\'Aigua","indicador_refugi":"081249|DONA_DAIGUA","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5379","longitud":"2.212","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda Jaume I 2","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-12T12:15:00.000"},{":id":"row-9bqk_53fq.br65",":version":"rv-itxt_pzg4.938g",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Font de Rambla Balmes","indicador_refugi":"081249|FONT_DE_RAMBLA_BALMES","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5364","longitud":"2.2165","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Rambla Balmes 41","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-12T12:21:00.000"},{":id":"row-qgwh.cf97~zaax",":version":"rv-8dmw.7r47_jrby",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Fonts del Parc dels Colors","indicador_refugi":"081249|FONTS_DEL_PARC_DELS_COLORS","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.544","longitud":"2.2054","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Parc dels Colors","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-12T12:23:00.000"},{":id":"row-xauc-6e2a_kx29",":version":"rv-i745~z9mz-ses7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Font del Parc de les Pruneres","indicador_refugi":"081249|FONT_DEL_PARC_DE_LES_PRUNERES","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5385","longitud":"2.2148","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Pau 35","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-12T12:25:00.000"},{":id":"row-93dm-c4um_724n",":version":"rv-zgz4.6g9i.uph3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal de Moll\xf3","indicador_refugi":"171077|PISCINA_MUNICIPAL_DE_MOLLO","municipi":"Moll\xf3","codi_municipi":"171077","latitud":"42.34553476","longitud":"2.40451678","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ptge. del Serrat, 3","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-qdsd.79ib~j5fw",":version":"rv-eq4b_33hz~99q7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala de plens de la Casa de la vila","indicador_refugi":"430884|SALA_DE_PLENS_DE_LA_CASA_DE_LA_VILA","municipi":"Montbri\xf3 del Camp","codi_municipi":"430884","latitud":"41.12082169","longitud":"1.0033502","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de la Vila, 1","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-atpg~n7vk.sfq5",":version":"rv-idwg-bz8f~jf4x",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa de Cultura de Mont-roig","indicador_refugi":"430884|CASA_DE_CULTURA_DE_MONT_ROIG","municipi":"Montbri\xf3 del Camp","codi_municipi":"430884","latitud":"41.08747805","longitud":"0.9579948","accessibilitat":"No","aigua":"No","area_descans":"S\xed","adreca":"C. Mare de Deu de la Roca, 5","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-6km2_j8kq~nvt6",":version":"rv-p5nv_p3b5~s5ym",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa de cultura","indicador_refugi":"430884|CASA_DE_CULTURA","municipi":"Montbri\xf3 del Camp","codi_municipi":"430884","latitud":"41.12111618","longitud":"1.00461955","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Av. de Sant Jordi, 4","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-f4gh.fw6p~bjgy",":version":"rv-wubd.ah5f_6n8b",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"430884|PISCINA_MUNICIPAL","municipi":"Montbri\xf3 del Camp","codi_municipi":"430884","latitud":"41.11714695","longitud":"1.00841768","accessibilitat":"S\xed","aigua":"No","area_descans":"No","adreca":"Ctra. de Cambrils, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-5sju_2tsh.etpv",":version":"rv-yqaj.92ff.j3tp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Coworking de Montclar","indicador_refugi":"081304|COWORKING_DE_MONTCLAR","municipi":"Montclar","codi_municipi":"081304","latitud":"42.01823774","longitud":"1.76512402","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"CASA DE LA VILA, SN","informacio_web":"www.montclar.cat","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-01T11:41:00.000"},{":id":"row-bng4~83m5.asvq",":version":"rv-3t3m~rp43_3vyv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala d\'actes de Montferrer","indicador_refugi":"251403|SALA_D_ACTES_DE_MONTFERRER","municipi":"Montferrer i Castellb\xf2","codi_municipi":"251403","latitud":"42.34625194","longitud":"1.42426916","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. la Coma, 4","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-jqzr~6q7m_fkb8",":version":"rv-2n4p_bszz.xrvv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament de Montferri","indicador_refugi":"430897|AJUNTAMENT_DE_MONTFERRI","municipi":"Montferri","codi_municipi":"430897","latitud":"41.26554","longitud":"1.36516","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Major, 35","informacio_web":"https://montferri.altanet.org/","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-05-29T14:34:00.000"},{":id":"row-p9sx.e577.tejj",":version":"rv-aegx~bqws~jtqq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Municipal","indicador_refugi":"430897|PISCINA_MUNICIPAL","municipi":"Montferri","codi_municipi":"430897","latitud":"41.26601","longitud":"1.36461","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Puigtiny\xf3s, s/n","informacio_web":"https://montferri.altanet.org/","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-05-29T14:36:00.000"},{":id":"row-vxwa_6nsd_pi7y",":version":"rv-um3y_wvaw-h276",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Lokal Social","indicador_refugi":"430897|LOKAL_SOCIAL","municipi":"Montferri","codi_municipi":"430897","latitud":"41.26556","longitud":"1.36519","accessibilitat":"S\xed","aigua":"No","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de la bassa, s/n","informacio_web":"https://montferri.altanet.org/","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-05-29T14:39:00.000"},{":id":"row-ggzz_ht96~p8eu",":version":"rv-kk5b~5jz8.4zmt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local Social Alzineta","indicador_refugi":"430897|LOCAL_SOCIAL_ALZINETA","municipi":"Montferri","codi_municipi":"430897","latitud":"41.28556","longitud":"1.38467","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Assutzena, 27","informacio_web":"https://montferri.altanet.org/","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T10:28:00.000"},{":id":"row-pxew~vf59-863s",":version":"rv-4ww6.rzbc.87ma",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Font l\xfadica pla\xe7a Santa Maria","indicador_refugi":"081350|FONT_LUDICA_PLACA_SANTA_MARIA","municipi":"Montmel\xf3","codi_municipi":"081350","latitud":"41.5494571795802","longitud":"2.249240682769789","accessibilitat":"No","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Santa Maria","informacio_web":"https://www.montmelo.cat/actualitat/noticies/activem-els-refugis-climatics-per-a-lestiu-2026.html","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T14:16:00.000"},{":id":"row-cshq_ru2s~4wfr",":version":"rv-s9er_dnmm~7cyf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals","indicador_refugi":"081350|PISCINES_MUNICIPALS","municipi":"Montmel\xf3","codi_municipi":"081350","latitud":"41.54888864944643","longitud":"2.2498560183832774","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Folch i Torres 6","informacio_web":"https://www.montmelo.cat/actualitat/noticies/activem-els-refugis-climatics-per-a-lestiu-2026.html","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T14:22:00.000"},{":id":"row-mqmd.bsib_9hj2",":version":"rv-w3xi.9hmt-vmtz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jard\xed de la Torreta","indicador_refugi":"081350|JARDI_DE_LA_TORRETA","municipi":"Montmel\xf3","codi_municipi":"081350","latitud":"41.54967045018549","longitud":"2.2501046512877605","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Folch i Torres 2","informacio_web":"https://www.montmelo.cat/actualitat/noticies/activem-els-refugis-climatics-per-a-lestiu-2026.html","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T14:24:00.000"},{":id":"row-g2cc-rrd8~nbus",":version":"rv-9dvq_sk9u~wgy5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca","indicador_refugi":"081350|BIBLIOTECA","municipi":"Montmel\xf3","codi_municipi":"081350","latitud":"41.55173965720554","longitud":"2.246038736578799","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Francesc Maci\xe0 11","informacio_web":"https://www.montmelo.cat/actualitat/noticies/activem-els-refugis-climatics-per-a-lestiu-2026.html","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T14:27:00.000"},{":id":"row-m27v-cwmf~ghmx",":version":"rv-hcg3_qaek_9qki",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la Gent Gran","indicador_refugi":"081350|CASAL_DE_LA_GENT_GRAN","municipi":"Montmel\xf3","codi_municipi":"081350","latitud":"41.552262973397106","longitud":"2.247690350910736","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Timbalerdel Bruc 2","informacio_web":"https://www.montmelo.cat/actualitat/noticies/activem-els-refugis-climatics-per-a-lestiu-2026.html","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T14:31:00.000"},{":id":"row-zm77-dpjq~ejhm",":version":"rv-6jsc_9nb6-uaqh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Estaci\xf3 Jove","indicador_refugi":"081350|ESTACIO_JOVE","municipi":"Montmel\xf3","codi_municipi":"081350","latitud":"41.55033505148589","longitud":"2.2468808137765204","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Passeig Miquel Biada","informacio_web":"https://www.montmelo.cat/actualitat/noticies/activem-els-refugis-climatics-per-a-lestiu-2026.html","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T14:33:00.000"},{":id":"row-8q3t-yeer~r888",":version":"rv-kb8c.vfw4-fuws",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bar Llar del poble de Montoliu de Lleida","indicador_refugi":"251425|BAR_LLAR_DEL_POBLE_DE_MONTOLIU_DE_LLEIDA","municipi":"Montoliu de Lleida","codi_municipi":"251425","latitud":"41.56053481","longitud":"0.58842222","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. La Creu","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-whg2~ism9_cnua",":version":"rv-2yh3~cjaj.me2n",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals","indicador_refugi":"251425|PISCINES_MUNICIPALS","municipi":"Montoliu de Lleida","codi_municipi":"251425","latitud":"41.55928015","longitud":"0.59307303","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Afores, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-944e.gpqv_bdvq",":version":"rv-f4nz-q3em.vkav",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local social Vilagrasseta (antigues Escoles)","indicador_refugi":"251410|LOCAL_SOCIAL_VILAGRASSETA_ANTIGUES_ESCOLES","municipi":"Montoliu de Segarra","codi_municipi":"251410","latitud":"41.605551","longitud":"1.28223","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de l\'esgl\xe8sia, s/n","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-nyyd_zxha.eqnb",":version":"rv-ufti-ia7b-tghi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal Rosa Leveroni","indicador_refugi":"081363|BIBLIOTECA_MUNICIPAL_ROSA_LEVERONI","municipi":"Montorn\xe8s del Vall\xe8s","codi_municipi":"081363","latitud":"41.546726","longitud":"2.268833","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Can Parera, 34","informacio_web":"https://www.montornes.cat/municipi/equipaments/biblioteca-rosa-leveroni","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-16T12:06:00.000"},{":id":"row-nxji-kt46~8bvu",":version":"rv-gy9b-i6hx-db4c",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal d\u2019Avis Centre","indicador_refugi":"081363|CASAL_D\u2019AVIS_CENTRE","municipi":"Montorn\xe8s del Vall\xe8s","codi_municipi":"081363","latitud":"41.545671","longitud":"2.266082","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. Llibertat, 3","informacio_web":"https://www.montornes.cat/municipi/equipaments/casal-de-la-gent-gran-centre","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-16T12:10:00.000"},{":id":"row-bev3~uaqj.teeb",":version":"rv-t5uq.vagq.tvxs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal d\u2019Avis Nord","indicador_refugi":"081363|CASAL_D\u2019AVIS_NORD","municipi":"Montorn\xe8s del Vall\xe8s","codi_municipi":"081363","latitud":"41.553071","longitud":"2.265574","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de les Hermanas de la Virgen Ni\xf1a, 4-6,","informacio_web":"https://www.montornes.cat/municipi/equipaments/casal-de-la-gent-gran-nord","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-16T12:13:00.000"},{":id":"row-qtfz-tn8n~3wkn",":version":"rv-a6e2_6x73.nuv8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Torrent de Vinyes Velles","indicador_refugi":"081363|PARC_DEL_TORRENT_DE_VINYES_VELLES","municipi":"Montorn\xe8s del Vall\xe8s","codi_municipi":"081363","latitud":"41.543802","longitud":"2.264125","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Parc del Torrent de Vinyes Velles","informacio_web":"Sense web. Parc sempre obert","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-16T12:17:00.000"},{":id":"row-tcs5.3fwi.tmd7",":version":"rv-3bhr-j8y9.2f9f",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc dels Castanyers","indicador_refugi":"081363|PARC_DELS_CASTANYERS","municipi":"Montorn\xe8s del Vall\xe8s","codi_municipi":"081363","latitud":"41.545843","longitud":"2.269072","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Parc dels Castanyers","informacio_web":"https://www.montornes.cat/municipi/llocs-d-interes/parc-dels-castanyers","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-16T12:20:00.000"},{":id":"row-xvak_eyim.wpej",":version":"rv-pfhx~cmax-zsqe",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pineda del Espai Socioesportiu de Montorn\xe8s Nord","indicador_refugi":"081363|PINEDA_DEL_ESPAI_SOCIOESPORTIU_DE_MONTORNES_NORD","municipi":"Montorn\xe8s del Vall\xe8s","codi_municipi":"081363","latitud":"41.553414","longitud":"2.262371","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pineda del Espai Socioesportiu de Montorn\xe8s Nord. c. de les Tres Creus s/n","informacio_web":"Sense web. Parc obert.","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-16T12:24:00.000"},{":id":"row-xup8~cv4k~i76y",":version":"rv-87r8_n6sk_7h6q",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines cobertes i Centre Esportiu Municipal (nom\xe9s hivern)","indicador_refugi":"081363|PISCINES_COBERTES_I_CENTRE_ESPORTIU_MUNICIPAL_(NOMES_HIVERN)","municipi":"Montorn\xe8s del Vall\xe8s","codi_municipi":"081363","latitud":"41.545986","longitud":"2.263106","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Gran Vial, 3","informacio_web":"https://www.montornes.cat/municipi/equipaments/zona-esportiva-municipal-les-vernedes-complex-esportiu","tipologia":"Piscina Coberta","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-16T12:26:00.000"},{":id":"row-n46e_pdmi_vyqb",":version":"rv-jxu4-3zrh_8t2z",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals d\'Estiu. ZEM Les Vernedes","indicador_refugi":"081363|PISCINES_MUNICIPALS_DESTIU_ZEM_LES_VERNEDES","municipi":"Montorn\xe8s del Vall\xe8s","codi_municipi":"081363","latitud":"41.545772","longitud":"2.261206","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Gran Vial, 3","informacio_web":"https://www.cemlesvernedes.cat/el-cem/calendari-i-horaris","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-16T12:41:00.000"},{":id":"row-52si.d6vi_573v",":version":"rv-w627-zer8_knvr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Polivalent de Miami-platja","indicador_refugi":"430923|CENTRE_POLIVALENT_DE_MIAMI_PLATJA","municipi":"Mont-roig del Camp","codi_municipi":"430923","latitud":"41.00401079","longitud":"0.92807339","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Soria, 16","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-rb5n-s4rw.wcrn",":version":"rv-75db~b6ny-usby",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PLA\xc7A DE LA VILA","indicador_refugi":"081379|PLACA_DE_LA_VILA","municipi":"Montseny","codi_municipi":"081379","latitud":"41.7849","longitud":"2.401","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"08469","informacio_web":"PLA\xc7A DE LA VILA, ESPAI AMB MOLT ARBRAT, FONT D\'AIGUA POTABLE, ZONES DE DESCANS.","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-06T12:14:00.000"},{":id":"row-s4sx-y4q9.nm2f",":version":"rv-c28t.w8c3~t5fk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PASSEIG DELS ENAMORATS","indicador_refugi":"081379|PASSEIG_DELS_ENAMORATS","municipi":"Montseny","codi_municipi":"081379","latitud":"41.7627","longitud":"2.3926","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"08469","informacio_web":"PASSEIG DELS ENAMORATS , PASSEIG AMB MOLT D\'ARBRAT, FONT I ZONA DE DESCANS","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-06T12:27:00.000"},{":id":"row-93kr~mmcc.t8es",":version":"rv-nwfe_jhrh.zng9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Estaci\xf3 d\'autobusos","indicador_refugi":"430939|ESTACIO_D_AUTOBUSOS","municipi":"M\xf3ra d\'Ebre","codi_municipi":"430939","latitud":"41.08864814","longitud":"0.64457194","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Cam\xed de les Hortes, 8","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-pptm.mb4v.6sft",":version":"rv-qz7m~xhw9.wcea",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Llar dels jubilats","indicador_refugi":"430944|LLAR_DELS_JUBILATS","municipi":"M\xf3ra la Nova","codi_municipi":"430944","latitud":"41.0978221","longitud":"0.65348202","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Francesc Maci\xe0, 60","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-kcse.tx32-f63z",":version":"rv-66hu.6yrj~zyzd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament de la Morera de Montsant","indicador_refugi":"430960|AJUNTAMENT_DE_LA_MORERA_DE_MONTSANT","municipi":"Morera de Montsant, la","codi_municipi":"430960","latitud":"41.26498675","longitud":"0.84187046","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. del Priorat, 6","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-z89q~6hc8.eevp",":version":"rv-mcri.5azn_zw5i",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"081290|PISCINA_MUNICIPAL","municipi":"Muntanyola","codi_municipi":"081290","latitud":"41.87216381","longitud":"2.18303437","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Serrarica, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-v2mm.rcxe-h6tg",":version":"rv-h9n6.kwww.56bj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal de Mura","indicador_refugi":"081398|PISCINA_MUNICIPAL_DE_MURA","municipi":"Mura","codi_municipi":"081398","latitud":"41.70271638","longitud":"1.97277463","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. de Rocafort, s/n, 08278 Mura","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-5z7d~x3tx-bgbr",":version":"rv-rjve-952u.uvf6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala Llevant","indicador_refugi":"171117|SALA_LLEVANT","municipi":"Navata","codi_municipi":"171117","latitud":"42.22364065","longitud":"2.86198998","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de la Creu, 13","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-sf9z-9ckn_tnnu",":version":"rv-vejf-7eeu_rnjq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"SALA 1 D\'OCTUBRE","indicador_refugi":"171117|SALA_1_DOCTUBRE","municipi":"Navata","codi_municipi":"171117","latitud":"42.223983911587425","longitud":"2.8628312332797385","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Escoles, 12 - 17774 Navata (Girona)","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-09T15:26:00.000"},{":id":"row-e8tf_33p6~22ri",":version":"rv-wwrf~33z4-cr4j",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic de La Nou","indicador_refugi":"081424|CENTRE_CIVIC_DE_LA_NOU","municipi":"Nou de Bergued\xe0, la","codi_municipi":"081424","latitud":"42.166814","longitud":"1.885127","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a 1 d\'octubre","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T12:14:00.000"},{":id":"row-6zf5-qh28~fbxs",":version":"rv-vtnf.b4fk.42a4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Municipal de la Nou de Gai\xe0","indicador_refugi":"430976|BIBLIOTECA_MUNICIPAL_DE_LA_NOU_DE_GAIA","municipi":"Nou de Gai\xe0, la","codi_municipi":"430976","latitud":"41.18327109","longitud":"1.37326562","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Castell, 8, 2n pis","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-hh3g_bya7_j7r9",":version":"rv-qfns-vz2c-dke2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina de Nulles","indicador_refugi":"430982|PISCINA_DE_NULLES","municipi":"Nulles","codi_municipi":"430982","latitud":"41.25015963","longitud":"1.29639011","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de la piscina, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-a7cd~u93i-cd3d",":version":"rv-djuf_25dj_vpvp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca l\'Atzavara","indicador_refugi":"081430|BIBLIOTECA_LATZAVARA","municipi":"\xd2dena","codi_municipi":"081430","latitud":"41.60658262955062","longitud":"1.640061998390379","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Guixera, 8 08711","informacio_web":"Dilluns a divendres de 15:30h a 20:00h, i els dimecres de 10:00h a 13.00h. Tancada del 5 al 18 d\'agost.","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-02T12:06:00.000"},{":id":"row-darw.iszy.hbwc",":version":"rv-e4se.uwcj.9cdz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Municipal d\'\xd2dena","indicador_refugi":"081430|PISCINA_MUNICIPAL_DODENA","municipi":"\xd2dena","codi_municipi":"081430","latitud":"41.60225224480667","longitud":"1.641444245691464","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Santa Olga, s/n","informacio_web":"Del 6 de juny al 30 d\'agost d\'11:00h a 20:00h","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-02T12:10:00.000"},{":id":"row-ae8r~78gy.jhvk",":version":"rv-fnb7_u74a-vbcn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala de Plens de l\'Ajuntament","indicador_refugi":"081430|SALA_DE_PLENS_DE_LAJUNTAMENT","municipi":"\xd2dena","codi_municipi":"081430","latitud":"41.60654066239679","longitud":"1.6421414204082274","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Major, 2 08711","informacio_web":"Dilluns a divendres de 8:30h a 14:00h","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-02T12:18:00.000"},{":id":"row-7bs2.5vsg-tdmi",":version":"rv-y4db-erdu-ri2w",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CCC Olesa de Montserrat","indicador_refugi":"081477|CCC_OLESA_DE_MONTSERRAT","municipi":"Olesa de Montserrat","codi_municipi":"081477","latitud":"41.54973906","longitud":"1.88368974","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. de la Puda, 08640 Olesa de Montserrat, Barcelona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-s238_67vc.bmh8",":version":"rv-2nb8.gkki-jp27",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai Fundaci\xf3 \\"la Caixa\\"","indicador_refugi":"081477|ESPAI_FUNDACIO_LA_CAIXA","municipi":"Olesa de Montserrat","codi_municipi":"081477","latitud":"41.54447437","longitud":"1.89078648","accessibilitat":"No","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Parc municipal","informacio_web":"https://www.olesademontserrat.cat/sites/default/files/2026-06/pocs-2026-aprovat-per-decret-19062026.pdf","tipologia":"Casal de Gent Gran","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-22T12:36:00.000"},{":id":"row-dv3b-55yx.sa9m",":version":"rv-zr3g~3dgj-7rn2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina d\'estiu","indicador_refugi":"081477|PISCINA_D_ESTIU","municipi":"Olesa de Montserrat","codi_municipi":"081477","latitud":"41.55443421","longitud":"1.89129347","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de l\'Urgell, 90, 08640 Olesa de Montserrat, Barcelona","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-k5iw.8atr_jbam",":version":"rv-hwcp~2btv-nweq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"AVV Rambla Eixample","indicador_refugi":"081477|AVV_RAMBLA_EIXAMPLE","municipi":"Olesa de Montserrat","codi_municipi":"081477","latitud":"41.54025405","longitud":"1.89550544","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Moss\xe8n Jacint Verdaguer, 30, 08640 Olesa de Montserrat, Barcelona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-362w-2dxr.qfdk",":version":"rv-8z2b-eeqm-jvpt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Policia Local","indicador_refugi":"081477|POLICIA_LOCAL","municipi":"Olesa de Montserrat","codi_municipi":"081477","latitud":"41.5440585","longitud":"1.88560547","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Amadeu Paltor, 28","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-c9yb-bt8y.ksgn",":version":"rv-n6mj-jxfc_4phc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Cal Rapissa - Servei de Promoci\xf3 Econ\xf2mica","indicador_refugi":"081477|CAL_RAPISSA_SERVEI_DE_PROMOCIO_ECONOMICA","municipi":"Olesa de Montserrat","codi_municipi":"081477","latitud":"41.54556986","longitud":"1.89436002","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Ample, 25, 08640 Olesa de Montserrat, Barcelona","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-jedt.vieh_3jiv",":version":"rv-qzq2.d55t.wncy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"AVV La Central","indicador_refugi":"081477|AVV_LA_CENTRAL","municipi":"Olesa de Montserrat","codi_municipi":"081477","latitud":"41.53996114","longitud":"1.89791363","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. dels Pa\xefsos Catalans, bxs bloc 1","informacio_web":"https://www.olesademontserrat.cat/sites/default/files/2026-06/pocs-2026-aprovat-per-decret-19062026.pdf","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-22T13:33:00.000"},{":id":"row-46zn_xynf~juje",":version":"rv-n3e4_vzn4.abis",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Olesa de Montserrat","indicador_refugi":"081477|CASAL_CIVIC_I_COMUNITARI_OLESA_DE_MONTSERRAT","municipi":"Olesa de Montserrat","codi_municipi":"081477","latitud":"41.5495223","longitud":"1.8656117","accessibilitat":"No","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Crta. De la Puda s/n","informacio_web":"https://www.olesademontserrat.cat/sites/default/files/2026-06/pocs-2026-aprovat-per-decret-19062026.pdf","tipologia":"Centre C\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-22T13:00:00.000"},{":id":"row-ppvs_v9w2.bh76",":version":"rv-ppz4.64c5-iqmw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Cal Puigjaner","indicador_refugi":"081477|CAL_PUIGJANER","municipi":"Olesa de Montserrat","codi_municipi":"081477","latitud":"41.54682283","longitud":"1.89430695","accessibilitat":"S\xed","aigua":"No","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Creu Real, 18","informacio_web":"https://www.olesademontserrat.cat/sites/default/files/2026-06/pocs-2026-aprovat-per-decret-19062026.pdf","tipologia":"Equipament Cultural (teatre, auditori, museu)","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-22T12:56:00.000"},{":id":"row-u37r.53i2-ti47",":version":"rv-iprj~kyav-cy6e",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal","indicador_refugi":"081477|BIBLIOTECA_MUNICIPAL","municipi":"Olesa de Montserrat","codi_municipi":"081477","latitud":"41.54443817","longitud":"1.89230514","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Salvador Cases, 26","informacio_web":"https://www.olesademontserrat.cat/sites/default/files/2026-06/pocs-2026-aprovat-per-decret-19062026.pdf","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-22T12:42:00.000"},{":id":"row-ytbm_8nnc_t7pk",":version":"rv-tbj9_dtpf.am9g",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"AVV Poble Sec","indicador_refugi":"081477|AVV_POBLE_SEC","municipi":"Olesa de Montserrat","codi_municipi":"081477","latitud":"41.54354531","longitud":"1.89954736","accessibilitat":"S\xed","aigua":"No","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Germans Casals, s/n","informacio_web":"https://www.olesademontserrat.cat/sites/default/files/2026-06/pocs-2026-aprovat-per-decret-19062026.pdf","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-22T13:35:00.000"},{":id":"row-jg4u-8z6h-q6c7",":version":"rv-cbp8-8j4t.swcs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament  (Casa consistorial)","indicador_refugi":"081477|AJUNTAMENT_CASA_CONSISTORIAL","municipi":"Olesa de Montserrat","codi_municipi":"081477","latitud":"41.54414966","longitud":"1.89135802","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. F\xe8lix Figueras i Aragay, s/n","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-y3vz~hspd.dc7k",":version":"rv-7k4n~aapp~x33c",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat municipal","indicador_refugi":"081477|MERCAT_MUNICIPAL","municipi":"Olesa de Montserrat","codi_municipi":"081477","latitud":"41.543082","longitud":"1.89350108","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Catalunya, 3","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-b3ht_bgtr_37e9",":version":"rv-23za~8cm6~an3q",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jocs d\u2019aigua","indicador_refugi":"081477|JOCS_D_AIGUA","municipi":"Olesa de Montserrat","codi_municipi":"081477","latitud":"41.53951825","longitud":"1.89434553","accessibilitat":"No","aigua":"S\xed","climatitzacio":"No","area_descans":"No","lavabo":"No","adreca":"Pla\xe7a de l\'Estatut","informacio_web":"https://www.olesademontserrat.cat/sites/default/files/2026-06/pocs-2026-aprovat-per-decret-19062026.pdf","tipologia":"Parcs i jardins","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-22T13:29:00.000"},{":id":"row-qtvs.et5t~q89p",":version":"rv-jxhh~iezu-mjzq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local social Les Planes","indicador_refugi":"081477|LOCAL_SOCIAL_LES_PLANES","municipi":"Olesa de Montserrat","codi_municipi":"081477","latitud":"41.55029128531369","longitud":"1.889475963380053","accessibilitat":"S\xed","aigua":"No","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Vall\xe8s, s/n","informacio_web":"https://www.olesademontserrat.cat/sites/default/files/2026-06/pocs-2026-aprovat-per-decret-19062026.pdf","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-22T13:39:00.000"},{":id":"row-csb2-ykkx_a29a",":version":"rv-thmh-a54f.j9wj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina","indicador_refugi":"251497|PISCINA","municipi":"Oliana","codi_municipi":"251497","latitud":"42.0673848","longitud":"1.3164511","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de l\'Esport, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-hbtw-m927-vyyr",":version":"rv-36ex~kgvp_p4s5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals pi","indicador_refugi":"251517|PISCINES_MUNICIPALS_PI","municipi":"Olius","codi_municipi":"251517","latitud":"41.97218124","longitud":"1.56162993","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Urb. el pi de sant just 25280","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-9ufx~f9n5.gxmq",":version":"rv-m5ab.yyas.6ucy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala polivalent","indicador_refugi":"251517|SALA_POLIVALENT","municipi":"Olius","codi_municipi":"251517","latitud":"41.97771991","longitud":"1.5549301","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. gafarro","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-xqxe~vzuz_ey8r",":version":"rv-shcz.qnw3~gust",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals","indicador_refugi":"081496|PISCINES_MUNICIPALS","municipi":"Olost","codi_municipi":"081496","latitud":"41.98423","longitud":"2.10043","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avda. de l\'Esport, s/n","informacio_web":"https://www.olost.cat","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T12:25:00.000"},{":id":"row-e7gf~tq96-sjf5",":version":"rv-rwhn_gsy3_apgj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la Gent Gran d\'Olost i Santa Creu","indicador_refugi":"081496|CASAL_DE_LA_GENT_GRAN_DOLOST_I_SANTA_CREU","municipi":"Olost","codi_municipi":"081496","latitud":"41.98533","longitud":"2.09607","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Passeig Dr. Lleopart, 7","informacio_web":"https://www.olost.cat/","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T12:46:00.000"},{":id":"row-zrid_p3w9.udai",":version":"rv-awy2~6utt-4skn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local social de Santa Creu de Jutglar","indicador_refugi":"081496|LOCAL_SOCIAL_DE_SANTA_CREU_DE_JUTGLAR","municipi":"Olost","codi_municipi":"081496","latitud":"42.005707592401464","longitud":"2.0604646336352213","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ Vell, 3","informacio_web":"https://www.olost.cat/","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T13:04:00.000"},{":id":"row-ktsy-ns8m.h95u",":version":"rv-tq4d.zgkz~s2tc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala cultural","indicador_refugi":"081496|SALA_CULTURAL","municipi":"Olost","codi_municipi":"081496","latitud":"41.98603428523596","longitud":"2.095491971052418","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Major, 1","informacio_web":"https://www.olost.cat/","tipologia":"Equipament Cultural (teatre, auditori, museu)","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T13:10:00.000"},{":id":"row-uj62~6699~r4tc",":version":"rv-3mer_24sv.c847",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Claustre de l\'Hospici","indicador_refugi":"171143|CLAUSTRE_DE_L_HOSPICI","municipi":"Olot","codi_municipi":"171143","latitud":"42.18135414","longitud":"2.48950113","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de l\'Hospici, 8","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-89un~64hx~sg6y",":version":"rv-uywa.uwb3.r4v4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Xiprer","indicador_refugi":"171143|PARC_DEL_XIPRER","municipi":"Olot","codi_municipi":"171143","latitud":"42.18297924","longitud":"2.4702314","accessibilitat":"No","aigua":"S\xed","area_descans":"S\xed","adreca":"Rda. del xiprer, 1","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-ycf8.43mu-ssj7",":version":"rv-9bc3.dm4e~fry4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc dels Ocells","indicador_refugi":"171143|PARC_DELS_OCELLS","municipi":"Olot","codi_municipi":"171143","latitud":"42.1922121","longitud":"2.50866438","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Rda. de les Mates","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-tku3~u3y9.sk5m",":version":"rv-mwsi~vice~kvsy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de les bisaroques","indicador_refugi":"171143|PARC_DE_LES_BISAROQUES","municipi":"Olot","codi_municipi":"171143","latitud":"42.18104521","longitud":"2.49724857","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Sant Jordi, 48","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-xbku~8cfh.m9nz",":version":"rv-iedn~eii4_bzsx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de Bonavista","indicador_refugi":"171143|PLACA_DE_BONAVISTA","municipi":"Olot","codi_municipi":"171143","latitud":"42.1650696","longitud":"2.47760583","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de Bonavista","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-ac5x.tfdt-8283",":version":"rv-v7ys.38bz.h8av",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal","indicador_refugi":"171143|BIBLIOTECA_MUNICIPAL","municipi":"Olot","codi_municipi":"171143","latitud":"42.18213526","longitud":"2.48935825","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Pati, 2","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-tmr5_cchu_5jsb",":version":"rv-wfjh_k59v_mnfh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Pequ\xedn (davant supermercat Carrefour)","indicador_refugi":"171143|PARC_DE_PEQUIN_DAVANT_SUPERMERCAT_CARREFOUR","municipi":"Olot","codi_municipi":"171143","latitud":"42.16971576","longitud":"2.47737692","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. de Santa Coloma, 74","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-hgy9.wxai_vd9b",":version":"rv-cpmq-me9x~jd4x",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Nou","indicador_refugi":"171143|PARC_NOU","municipi":"Olot","codi_municipi":"171143","latitud":"42.17156132","longitud":"2.47990946","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. de Santa Coloma, 43","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-v42r-dvqg-tpny",":version":"rv-bt8j_nsns.r3ct",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Moixina","indicador_refugi":"171143|PARC_DE_LA_MOIXINA","municipi":"Olot","codi_municipi":"171143","latitud":"42.16491472","longitud":"2.48685184","accessibilitat":"No","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. de la moixina, 1","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-6ex5_uvq5-pmaj",":version":"rv-9udh.5vht_ifkt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Dr. Zamenhof","indicador_refugi":"171143|PARC_DEL_DR_ZAMENHOF","municipi":"Olot","codi_municipi":"171143","latitud":"42.18839776","longitud":"2.49972939","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. del Compositor Serra","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-9run-22ci-8bss",":version":"rv-s2bm.n75b.ax2v",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Faja","indicador_refugi":"171143|PARC_DE_LA_FAJA","municipi":"Olot","codi_municipi":"171143","latitud":"42.18451919","longitud":"2.46386336","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de la Ferradura, 1","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-t9uh~f7qi_8h4d",":version":"rv-kkrf~fzk7_6pf4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins i parc dels pisos de la Caixa","indicador_refugi":"171143|JARDINS_I_PARC_DELS_PISOS_DE_LA_CAIXA","municipi":"Olot","codi_municipi":"171143","latitud":"42.17620642","longitud":"2.48377373","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ptge. dels pisos de la Caixa","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-szd7-uuye-nx7d",":version":"rv-uq4d~cq7g.c9u2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu dels Sants","indicador_refugi":"171143|MUSEU_DELS_SANTS","municipi":"Olot","codi_municipi":"171143","latitud":"42.17989308","longitud":"2.48900407","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Joaquim Vayreda, 9","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-622q.jfud.gd4v",":version":"rv-nb2u_tasp-qn2f",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Passeig de Sant Roc i Fonts de Sant Roc","indicador_refugi":"171143|PASSEIG_DE_SANT_ROC_I_FONTS_DE_SANT_ROC","municipi":"Olot","codi_municipi":"171143","latitud":"42.17357444","longitud":"2.47357496","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. de Sant Roc","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-hkdx~6pk4~6m3x",":version":"rv-ghcr_ztaj_qngu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai cr\xe0ter","indicador_refugi":"171143|ESPAI_CRATER","municipi":"Olot","codi_municipi":"171143","latitud":"42.16343416","longitud":"2.47687927","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Macarnau, 55","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-zrqh_2dur.ivbp",":version":"rv-zrgx-bpr9-937v",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Firal d\'Olot","indicador_refugi":"171143|FIRAL_D_OLOT","municipi":"Olot","codi_municipi":"171143","latitud":"42.1830364","longitud":"2.48704984","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Firal-Firalet","tipologia":"Espai firal","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-tqia.4ccd_f7fi",":version":"rv-pjnx~enpp-mbsp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Carrer Esparg a l\'Hostal del Sol","indicador_refugi":"171143|PARC_CARRER_ESPARG_A_L_HOSTAL_DEL_SOL","municipi":"Olot","codi_municipi":"171143","latitud":"42.19311465","longitud":"2.47774361","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Esparg","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-9ppk~iumt-q889",":version":"rv-kv6t-eb5z~2va2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Rambla de Benavent, Jardins del mirador de la pubilla","indicador_refugi":"171143|RAMBLA_DE_BENAVENT_JARDINS_DEL_MIRADOR_DE_LA_PUBILLA","municipi":"Olot","codi_municipi":"171143","latitud":"42.17846957","longitud":"2.49570793","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Sant Jordi, 51","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-wiur~hqfp.3mrt",":version":"rv-xrvd~eqh4_f2ui",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Matalosquer","indicador_refugi":"171143|PARC_DE_MATALOSQUER","municipi":"Olot","codi_municipi":"171143","latitud":"42.16807921","longitud":"2.47308456","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Madrid, 220","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-juvu-48ye_az4j",":version":"rv-vite~umdj-ppit",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"171143|PISCINA_MUNICIPAL","municipi":"Olot","codi_municipi":"171143","latitud":"42.16715121","longitud":"2.48037536","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Sant Jordi, 209","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-iu5x_azw8~8xjn",":version":"rv-a2fr~aw8f_psur",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc d\'Arturo Sim\xf3n","indicador_refugi":"171143|PARC_D_ARTURO_SIMON","municipi":"Olot","codi_municipi":"171143","latitud":"42.19226951","longitud":"2.48715056","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de la Garrinada","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-j9bs-9iqd.e2cr",":version":"rv-2web-itsk_7qzd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de les M\xf2res / Parc Espunya","indicador_refugi":"171143|PARC_DE_LES_MORES_PARC_ESPUNYA","municipi":"Olot","codi_municipi":"171143","latitud":"42.17548162","longitud":"2.48868809","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ronda Sometent, 17","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-6m4k~n6me-w9fm",":version":"rv-ry2n~ey8u-hjxf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Pic del Bac","indicador_refugi":"171143|PARC_DEL_PIC_DEL_BAC","municipi":"Olot","codi_municipi":"171143","latitud":"42.18546222","longitud":"2.47262102","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Alforja, 4","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-7a52.ghkg-zrcv",":version":"rv-pyht-gi8k~brrs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Miquel Mart\xed Pol","indicador_refugi":"171143|PARC_DE_MIQUEL_MARTI_POL","municipi":"Olot","codi_municipi":"171143","latitud":"42.18282922","longitud":"2.49459035","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pont de Palau","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-azam~gp8c.ffeg",":version":"rv-c2wn_yr2v.9bdu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Olot","indicador_refugi":"171143|CASAL_CIVIC_I_COMUNITARI_OLOT","municipi":"Olot","codi_municipi":"171143","latitud":"41.864698","longitud":"1.8568671","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. del Bisbe Lorenzana, 2","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-cgfp-wu7d_f6j2",":version":"rv-urni_p9gc-g4zs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jard\xed Moss\xe8n Llu\xeds Planella","indicador_refugi":"171143|JARDI_MOSSEN_LLUIS_PLANELLA","municipi":"Olot","codi_municipi":"171143","latitud":"42.18168566","longitud":"2.47720037","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. dels Clavells, 14","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-d8v2_n9ff_rcwa",":version":"rv-zcsj-jdtk.mqmv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"\xc0rea recreativa Tossols Basil","indicador_refugi":"171143|AREA_RECREATIVA_TOSSOLS_BASIL","municipi":"Olot","codi_municipi":"171143","latitud":"42.17505648","longitud":"2.47037611","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Sant Narc\xeds, 32","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-6fdr-2v76~jw48",":version":"rv-pywe~9vmv_zjag",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a del barri de Sant Miquel","indicador_refugi":"171143|PLACA_DEL_BARRI_DE_SANT_MIQUEL","municipi":"Olot","codi_municipi":"171143","latitud":"42.18738407","longitud":"2.4953439","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Rei Jaume II, 57","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-4967~4ng9.4vv7",":version":"rv-qczh_5xsk~fdd7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jard\xed Carrer Macarnau (cementiri)","indicador_refugi":"171143|JARDI_CARRER_MACARNAU_CEMENTIRI","municipi":"Olot","codi_municipi":"171143","latitud":"42.18512143","longitud":"2.48638002","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Macarnau, 46","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-gf7r~xkam.8k39",":version":"rv-trxc-5ii9~mut8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Passeig Bas\xe0ltic","indicador_refugi":"171143|PASSEIG_BASALTIC","municipi":"Olot","codi_municipi":"171143","latitud":"42.18316827","longitud":"2.4946218","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Terrassa, 1","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-pqr6~m2ci_mbda",":version":"rv-7qhs~ebmk-i6x2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Clar\xe0","indicador_refugi":"171143|PLACA_CLARA","municipi":"Olot","codi_municipi":"171143","latitud":"42.18046","longitud":"2.48507","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Clar\xe0","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-z7ne_h4i7.kpdg",":version":"rv-3mwm~mf34.hex4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de les Mates","indicador_refugi":"171143|PARC_DE_LES_MATES","municipi":"Olot","codi_municipi":"171143","latitud":"42.19295067","longitud":"2.50307291","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. del Mestre Vives, 30","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-nei6~guiw.mrq6",":version":"rv-vqfr~c8dw.sj8a",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre social","indicador_refugi":"171156|CENTRE_SOCIAL","municipi":"Ordis","codi_municipi":"171156","latitud":"42.21803233","longitud":"2.90900186","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de l\'Empord\xe0, 14","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-hzv2_4u5w.7gdh",":version":"rv-pc3z.jamz.3k6c",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CENTRE CIVIC","indicador_refugi":"081516|CENTRE_CIVIC","municipi":"Orist\xe0","codi_municipi":"081516","latitud":"41.93311","longitud":"2.05925","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"No","adreca":"PLA\xc7A CATALUNYA,","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-08T10:07:00.000"},{":id":"row-3c9u.fbp9.crfy",":version":"rv-pd73_tyrq~pihm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal d\'Osor","indicador_refugi":"171169|PISCINA_MUNICIPAL_D_OSOR","municipi":"Osor","codi_municipi":"171169","latitud":"41.94739183","longitud":"2.55913052","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. de la Piscina, s/n, 17161 Osor, Girona","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-vcgq~ktzt-gkju",":version":"rv-7brn-h2m4.68uk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local social Barri Pla De Cavalls","indicador_refugi":"081542|LOCAL_SOCIAL_BARRI_PLA_DE_CAVALLS","municipi":"Pacs del Pened\xe8s","codi_municipi":"081542","latitud":"41.363759","longitud":"1.64960678","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de l\'esport, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-b7fn.5kfm_r2vi",":version":"rv-4qew~ihzc_pdya",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pista coberta \\"alcalde Josep Soler\\"","indicador_refugi":"081542|PISTA_COBERTA_ALCALDE_JOSEP_SOLER","municipi":"Pacs del Pened\xe8s","codi_municipi":"081542","latitud":"41.36090004","longitud":"1.6692437","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Diputaci\xf3, 11","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-njha~upg8-qnfh",":version":"rv-vy93.kk6w~2cdp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Palafolls","indicador_refugi":"081555|PISCINA_PALAFOLLS","municipi":"Palafolls","codi_municipi":"081555","latitud":"41.67192409","longitud":"2.75153803","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Trav. de les Esplanes, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-2g84~qs78_27x3",":version":"rv-mph6-yprr~npyq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Teatre de Palafolls","indicador_refugi":"081555|TEATRE_DE_PALAFOLLS","municipi":"Palafolls","codi_municipi":"081555","latitud":"41.66852999","longitud":"2.7484143","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Francesc Maci\xe0, 1","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-haee~bguf-eqgd",":version":"rv-vk29~4nsq_ijvv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal Enric Miralles","indicador_refugi":"081555|BIBLIOTECA_MUNICIPAL_ENRIC_MIRALLES","municipi":"Palafolls","codi_municipi":"081555","latitud":"41.67099881","longitud":"2.7527407","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Parc de les, Trav. de les Esplanes, s/n","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-tmg7_4k4s.if58",":version":"rv-r5gh-msdx.n2v7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal","indicador_refugi":"171175|BIBLIOTECA_MUNICIPAL","municipi":"Palafrugell","codi_municipi":"171175","latitud":"41.91583194","longitud":"3.16436512","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de Sant Mart\xed, 18","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-3px2~b4vp~g4sx",":version":"rv-qa9w.mvpn_7ww7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Cafeteria de la resid\xe8ncia Palafrugell Gent Gran","indicador_refugi":"171175|CAFETERIA_DE_LA_RESIDENCIA_PALAFRUGELL_GENT_GRAN","municipi":"Palafrugell","codi_municipi":"171175","latitud":"41.92264959","longitud":"3.16948144","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Mestre Josep Bonay i Vidal, 15","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-bbfr-df7f_6f69",":version":"rv-zcih~c2y4~xpn8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre municipal d\'Educaci\xf3","indicador_refugi":"171175|CENTRE_MUNICIPAL_D_EDUCACIO","municipi":"Palafrugell","codi_municipi":"171175","latitud":"41.91516347","longitud":"3.17226334","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Bruguerol, 12","tipologia":"Centre educatiu","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-mx8s~qru9.ys6b",":version":"rv-kk2m_kbah.uieq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu del Suro de Catalunya","indicador_refugi":"171175|MUSEU_DEL_SURO_DE_CATALUNYA","municipi":"Palafrugell","codi_municipi":"171175","latitud":"41.91851458","longitud":"3.16519368","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Begur, 15","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-564i-i6rv-rrhv",":version":"rv-c5zi~cfym-np4a",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local Consell de la gent gran","indicador_refugi":"171175|LOCAL_CONSELL_DE_LA_GENT_GRAN","municipi":"Palafrugell","codi_municipi":"171175","latitud":"41.91829899","longitud":"3.16421269","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Onze de Setembre, 11","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-e9dj-2bbz~w86t",":version":"rv-nbve-38cd_utxw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala polivalent","indicador_refugi":"171194|SALA_POLIVALENT","municipi":"Palau de Santa Eul\xe0lia","codi_municipi":"171194","latitud":"42.17391562","longitud":"2.96432076","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Garrig\xe0s, 4","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-k5c2.tkmb-9a9p",":version":"rv-mciw~7bqx~umw5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic","indicador_refugi":"171208|CENTRE_CIVIC","municipi":"Palau-saverdera","codi_municipi":"171208","latitud":"42.3084179","longitud":"3.14871642","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Tramuntana, 1","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-equ5-ifcq.ebp8",":version":"rv-txuw_umxc_m3n7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"171208|PISCINA_MUNICIPAL","municipi":"Palau-saverdera","codi_municipi":"171208","latitud":"42.30949365","longitud":"3.14466326","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Av. Mas Oriol, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-u3p7-up98~yiif",":version":"rv-xwez_7di5~cg2p",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Torre Folch","indicador_refugi":"081568|TORRE_FOLCH","municipi":"Palau-solit\xe0 i Plegamans","codi_municipi":"081568","latitud":"41.58537116","longitud":"2.1808067","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. del Castell, 27","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-75ng-tg6t-qkf3",":version":"rv-sd9h.za2y.p9si",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca l\'Alzina","indicador_refugi":"081568|BIBLIOTECA_L_ALZINA","municipi":"Palau-solit\xe0 i Plegamans","codi_municipi":"081568","latitud":"41.58982203","longitud":"2.17949174","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Nostra Sra. de Montserrat","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-92ih-a6gg~p9ps",":version":"rv-kphr-pzv4_ip5b",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai Jove l\'Escorxador","indicador_refugi":"081568|ESPAI_JOVE_LESCORXADOR","municipi":"Palau-solit\xe0 i Plegamans","codi_municipi":"081568","latitud":"41.585373","longitud":"2.174266","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Passeig de la Carrerada, 57","informacio_web":"www.palauplegamans.cat","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-01T14:02:00.000"},{":id":"row-57v7-5e3s_cfef",":version":"rv-vzkr_emzw-an43",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de la Sardana","indicador_refugi":"081568|PLACA_DE_LA_SARDANA","municipi":"Palau-solit\xe0 i Plegamans","codi_municipi":"081568","latitud":"41.586941","longitud":"2.17751","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a de la Sardana","informacio_web":"www.palauplegamans.cat","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-01T14:11:00.000"},{":id":"row-sk8s~vfz9.cnb9",":version":"rv-gyvf.xqui-zp24",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de Manuel Carrasco i Formiguera","indicador_refugi":"081568|JARDINS_DE_MANUEL_CARRASCO_I_FORMIGUERA","municipi":"Palau-solit\xe0 i Plegamans","codi_municipi":"081568","latitud":"41.583547","longitud":"2.175559","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Can Cort\xe9s","informacio_web":"www.palauplegamans.cat","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-01T14:18:00.000"},{":id":"row-8trh_pptj-pzn4",":version":"rv-cq9h-8eh2_fwet",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Plana de Can Maiol","indicador_refugi":"081568|PARC_DE_LA_PLANA_DE_CAN_MAIOL","municipi":"Palau-solit\xe0 i Plegamans","codi_municipi":"081568","latitud":"41.573535","longitud":"2.179545","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Rambla St. Isidre","informacio_web":"www.palauplegamans.cat","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-01T14:23:00.000"},{":id":"row-pg5r~f794_c8ym",":version":"rv-2tq9.mjs6-pyx4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a del Bosc de Can Maiol","indicador_refugi":"081568|PLACA_DEL_BOSC_DE_CAN_MAIOL","municipi":"Palau-solit\xe0 i Plegamans","codi_municipi":"081568","latitud":"41.57338","longitud":"2.184407","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a del Bosc de Can Maiol","informacio_web":"www.palauplegamans.cat","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-01T14:26:00.000"},{":id":"row-zfmy.afak_qia9",":version":"rv-b25g_5trz-mud4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Sagrera","indicador_refugi":"081568|PARC_DE_LA_SAGRERA","municipi":"Palau-solit\xe0 i Plegamans","codi_municipi":"081568","latitud":"41.584974","longitud":"2.169443","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Cam\xed de Can Riera","informacio_web":"www.palauplegamans.cat","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-01T14:39:00.000"},{":id":"row-zsbd-f8ew.qggc",":version":"rv-mmix_r9qr_tb4m",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a 1 d\'Octubre","indicador_refugi":"081568|PLACA_1_DOCTUBRE","municipi":"Palau-solit\xe0 i Plegamans","codi_municipi":"081568","latitud":"41.588662","longitud":"2.177966","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a 1 d\'Octubre","informacio_web":"www.palauplegamans.cat","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-01T14:43:00.000"},{":id":"row-yfvc-rz7g_6xwi",":version":"rv-4vsi~iv4y_jm8t",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a d\'Ernest Lluch","indicador_refugi":"081568|PLACA_DERNEST_LLUCH","municipi":"Palau-solit\xe0 i Plegamans","codi_municipi":"081568","latitud":"41.58989","longitud":"2.1764","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a d\'Ernest Lluch","informacio_web":"www.palauplegamans.cat","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-01T14:50:00.000"},{":id":"row-je3u.sttt-zdrz",":version":"rv-i7iz_q2c5.k8gt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament","indicador_refugi":"431009|AJUNTAMENT","municipi":"Pallaresos, els","codi_municipi":"431009","latitud":"41.17418029","longitud":"1.27258125","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Catalunya, 8","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-q4uh~vs7f~d97a",":version":"rv-va4f-9wpz-ru4x",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"431009|PISCINA_MUNICIPAL","municipi":"Pallaresos, els","codi_municipi":"431009","latitud":"41.17418979","longitud":"1.27323572","accessibilitat":"S\xed","aigua":"No","area_descans":"No","adreca":"Av. Catalunya","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-tfgz~75d6~tv4q",":version":"rv-vix7_hfei~9xqc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal Merc\xe8 Rodoreda Els Pallaresos","indicador_refugi":"431009|BIBLIOTECA_MUNICIPAL_MERCE_RODOREDA_ELS_PALLARESOS","municipi":"Pallaresos, els","codi_municipi":"431009","latitud":"41.17590007","longitud":"1.27223633","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Alt, 23","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-q2xn~aa94-r3rp",":version":"rv-7hbd.uxab-kyiq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre cultural","indicador_refugi":"430995|CENTRE_CULTURAL","municipi":"Palma d\'Ebre, la","codi_municipi":"430995","latitud":"41.28221653","longitud":"0.665758","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Catalunya, 7","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-xb32.br4p_bkcd",":version":"rv-rtd3_z4gq_negn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de La Linera","indicador_refugi":"081593|PARC_DE_LA_LINERA","municipi":"Parets del Vall\xe8s","codi_municipi":"081593","latitud":"41.57529604","longitud":"2.2331026","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. Joan Mir\xf3, 7, 08150 Parets del Vall\xe8s","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-m2cf_k8g5.78sr",":version":"rv-pri8~a3zv-vxhf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal gent gran Ca n\'Oms","indicador_refugi":"081593|CASAL_GENT_GRAN_CA_N_OMS","municipi":"Parets del Vall\xe8s","codi_municipi":"081593","latitud":"41.57597025","longitud":"2.2310796","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Ponent, 14, 08150 Parets del Vall\xe8s","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-dupb-ncaz_iyw4",":version":"rv-z5mp-hyuq_uqcw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Can Rajoler","indicador_refugi":"081593|BIBLIOTECA_CAN_RAJOLER","municipi":"Parets del Vall\xe8s","codi_municipi":"081593","latitud":"41.57246353","longitud":"2.23404862","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Travessera, 1, 08150 Parets del Vall\xe8s","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-w9rh-9cuq_2dgb",":version":"rv-wa67_yqh5_kfsm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina descoberta municipal","indicador_refugi":"081593|PISCINA_DESCOBERTA_MUNICIPAL","municipi":"Parets del Vall\xe8s","codi_municipi":"081593","latitud":"41.57085524","longitud":"2.23526918","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pg. Fluvial, s/n, 08150 Parets del Vall\xe8s","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-7ai7.w4pb_mesv",":version":"rv-9e86_kgdx_zuas",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal gent gran Sant Jordi","indicador_refugi":"081593|CASAL_GENT_GRAN_SANT_JORDI","municipi":"Parets del Vall\xe8s","codi_municipi":"081593","latitud":"41.5635118","longitud":"2.22796745","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Galende, 1, 08150 Parets del Vall\xe8s","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-6g3f-hiww_7kcv",":version":"rv-fy66_ung5.xfmm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Can Butjosa","indicador_refugi":"081593|BIBLIOTECA_CAN_BUTJOSA","municipi":"Parets del Vall\xe8s","codi_municipi":"081593","latitud":"41.56102883","longitud":"2.21932712","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de la Salut, 50, 08150 Parets del Vall\xe8s","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-zats-944k-7cq2",":version":"rv-tjyj~def5_z68g",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal Cal Jardiner","indicador_refugi":"081593|CASAL_CAL_JARDINER","municipi":"Parets del Vall\xe8s","codi_municipi":"081593","latitud":"41.57021131","longitud":"2.22284051","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Montcau, s/n, 08150 Parets del Vall\xe8s","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-y9y9.peni_9da4",":version":"rv-afbj~wsvf.2h8v",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal gent gran Asoveen","indicador_refugi":"081593|CASAL_GENT_GRAN_ASOVEEN","municipi":"Parets del Vall\xe8s","codi_municipi":"081593","latitud":"41.55709215","longitud":"2.2211032","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Bruc, 35, 08150 Parets del Vall\xe8s","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-9qyx.3w65~xg6x",":version":"rv-9miw-n63w_z2r4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del sot d\'en Barriques","indicador_refugi":"081593|PARC_DEL_SOT_D_EN_BARRIQUES","municipi":"Parets del Vall\xe8s","codi_municipi":"081593","latitud":"41.56567084","longitud":"2.22871293","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Catalunya, 117, 08150 Parets del Vall\xe8s","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-dfkm-x37f-9icb",":version":"rv-f5pr_27g2-v9fw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina muncipal","indicador_refugi":"171289|PISCINA_MUNCIPAL","municipi":"Pau","codi_municipi":"171289","latitud":"42.31652275","longitud":"3.11830582","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Sant Pere, 12","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-pcdq~icje_4v66",":version":"rv-w72p.jtzn-dvr8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal Municipal","indicador_refugi":"431021|CASAL_MUNICIPAL","municipi":"Pa\xfcls","codi_municipi":"431021","latitud":"40.921585198348176","longitud":"0.40095475177253576","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Carretera 12","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T11:31:00.000"},{":id":"row-n44i~y4wb~t3k2",":version":"rv-bx9u.ynyr-qyts",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic","indicador_refugi":"171292|CENTRE_CIVIC","municipi":"Pedret i Marz\xe0","codi_municipi":"171292","latitud":"42.31087439","longitud":"3.06596447","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Mar, 13","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-it4a.cykq_c3qx",":version":"rv-9cg9-cev8-2s43",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines Municipals","indicador_refugi":"251641|PISCINES_MUNICIPALS","municipi":"Penelles","codi_municipi":"251641","latitud":"41.75819","longitud":"0.96759","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a del Roser s/n","informacio_web":"12.00 a 20.00 hores de dilluns a diumenge","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T10:44:00.000"},{":id":"row-jwce_dbu6_ezwi",":version":"rv-dxq8_miq5_b34t",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal d\'avis","indicador_refugi":"251641|CASAL_DAVIS","municipi":"Penelles","codi_municipi":"251641","latitud":"41.75824","longitud":"0.96556","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Rita Boldu, s/n","informacio_web":"Horari de 15.00 a 18.00 de dilluns a divendres","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T10:55:00.000"},{":id":"row-9xbb-uqm9-6gcc",":version":"rv-xxk3-r6n6-bppq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala de plens ajuntament","indicador_refugi":"251641|SALA_DE_PLENS_AJUNTAMENT","municipi":"Penelles","codi_municipi":"251641","latitud":"41.75801","longitud":"0.96544","accessibilitat":"S\xed","aigua":"No","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Major, 1","informacio_web":"12.00 a 14.00 de dilluns a divendres","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T10:58:00.000"},{":id":"row-yfuy-jpbb-uz75",":version":"rv-qzez-d67x.sha8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal de Peralada","indicador_refugi":"171328|PISCINA_MUNICIPAL_DE_PERALADA","municipi":"Peralada","codi_municipi":"171328","latitud":"42.3119038","longitud":"3.01379","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Arag\xf3","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-3wnd~3wdy-r5u2",":version":"rv-cthw-te2d~2kp3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals","indicador_refugi":"251654|PISCINES_MUNICIPALS","municipi":"Peramola","codi_municipi":"251654","latitud":"42.05858445","longitud":"1.26672465","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Piscines Peramola","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-vw96-uv2e-7ha9",":version":"rv-f6fq_bis3_sec3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"431042|PISCINA_MUNICIPAL","municipi":"Perell\xf3, el","codi_municipi":"431042","latitud":"40.87648979","longitud":"0.70965886","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Av. Pla de la Fira, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-jgbh-iv8f.kigx",":version":"rv-8ngy_x8nc~ayzi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal","indicador_refugi":"081614|CASAL","municipi":"Piera","codi_municipi":"081614","latitud":"41.521894","longitud":"1.751512","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Mar i Cel, 1","informacio_web":"De dilluns a divendres, de 10.00 a 19.00","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-09T14:06:00.000"},{":id":"row-79cq.fw8c_cejm",":version":"rv-dypk_icn7_3zyi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament de Piera","indicador_refugi":"081614|AJUNTAMENT_DE_PIERA","municipi":"Piera","codi_municipi":"081614","latitud":"41.518011","longitud":"1.743504","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Cr de la Pla\xe7a, 16-18","informacio_web":"de dilluns a divendres de 9.00 a 14.00","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-09T14:09:00.000"},{":id":"row-tdxe_6ht6-qsnr",":version":"rv-yydd.3j83-sag6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La B\xf2bila","indicador_refugi":"081614|LA_BOBILA","municipi":"Piera","codi_municipi":"081614","latitud":"41.523837","longitud":"1.754658","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av Carretera d\'Igualada, 2","informacio_web":"De dilluns a divendres de 9.00 a 14.00","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-09T14:11:00.000"},{":id":"row-vrxf~fsgm_bukj",":version":"rv-mfxz~ijzd_my5v",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal","indicador_refugi":"081614|BIBLIOTECA_MUNICIPAL","municipi":"Piera","codi_municipi":"081614","latitud":"41.522262","longitud":"1.754162","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av del Gall Mullat, 7","informacio_web":"De dilluns a divendres de 9 a 14, durant els mesos de juliol i agost","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-09T14:20:00.000"},{":id":"row-quxv_krgu~ibfn",":version":"rv-jjkv-9ruz_48b5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Font del Prat","indicador_refugi":"081614|FONT_DEL_PRAT","municipi":"Piera","codi_municipi":"081614","latitud":"41.522946","longitud":"1.742971","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Font del Prat","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-09T14:30:00.000"},{":id":"row-xn9z_8amd~a2rt",":version":"rv-zqeb.xw78_w6bq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Isaac Berroya","indicador_refugi":"081614|PARC_ISAAC_BERROYA","municipi":"Piera","codi_municipi":"081614","latitud":"41.521988","longitud":"1.744258","accessibilitat":"No","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pg del Prat, s/n","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-09T14:32:00.000"},{":id":"row-5586-3hds~esyc",":version":"rv-qf4u.52ng.gkuk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Gall Mullat","indicador_refugi":"081614|PARC_DEL_GALL_MULLAT","municipi":"Piera","codi_municipi":"081614","latitud":"41.521878","longitud":"1.752942","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Parc del Gall Mullat","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-09T14:34:00.000"},{":id":"row-trbh.bysw.vk68",":version":"rv-ra48~av4i~fuht",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal Avis Poble Nou","indicador_refugi":"081635|CASAL_AVIS_POBLE_NOU","municipi":"Pineda de Mar","codi_municipi":"081635","latitud":"41.62007292592604","longitud":"2.6745370018478503","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Passeig de la Costa Brava, 47, 08397 Pineda de Mar, Barcelona","informacio_web":"https://www.pinedademar.cat/serveis/gent-gran-activa/casal-de-gent-gran-poblenou","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-05T10:35:00.000"},{":id":"row-tv47-am7e~dn9s",":version":"rv-64mi.rd87~px3k",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Gent Gran Les M\xe8lies","indicador_refugi":"081635|CASAL_DE_GENT_GRAN_LES_MELIES","municipi":"Pineda de Mar","codi_municipi":"081635","latitud":"41.626571631041955","longitud":"2.6895674217239707","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. de Les M\xe8lies, n\xfamero 7. 08397 Pineda de Mar","informacio_web":"https://www.pinedademar.cat/serveis/gent-gran-activa/casal-de-gent-gran-les-melies","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-05T10:39:00.000"},{":id":"row-yxk5.jxs3.xwsr",":version":"rv-kp65~9jg4.kaea",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Oficina de Turisme","indicador_refugi":"081635|OFICINA_DE_TURISME","municipi":"Pineda de Mar","codi_municipi":"081635","latitud":"41.62758522104079","longitud":"2.689665517189478","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a de Catalunya, 1 08397 Pineda de Mar","informacio_web":"https://visitpineda.com/oficina-de-turisme/","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-05T10:49:00.000"},{":id":"row-ter6_mpum.mjv2",":version":"rv-accp_3fvc.mvvm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca M. Serra i Moret","indicador_refugi":"081635|BIBLIOTECA_M_SERRA_I_MORET","municipi":"Pineda de Mar","codi_municipi":"081635","latitud":"41.62440558949214","longitud":"2.693342311645928","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer del Progr\xe9s, 22 08397 Pineda de Mar","informacio_web":"https://www.pinedademar.cat/serveis/cultura/biblioteques","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-05T11:00:00.000"},{":id":"row-mrrm.d2i4-c8qn",":version":"rv-hiv9_vvvh~jsu2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Poblenou","indicador_refugi":"081635|BIBLIOTECA_POBLENOU","municipi":"Pineda de Mar","codi_municipi":"081635","latitud":"41.61952693103608","longitud":"2.6708709938976223","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Passeig d\'Europa, 23-25","informacio_web":"https://www.pinedademar.cat/serveis/cultura/biblioteques","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-05T11:09:00.000"},{":id":"row-w43x~s52z-n7tt",":version":"rv-e7ts~7efn-kmie",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai Cultural \\"Sara Llorens\\"","indicador_refugi":"081635|ESPAI_CULTURAL_\\"SARA_LLORENS\\"","municipi":"Pineda de Mar","codi_municipi":"081635","latitud":"41.625673407091","longitud":"2.6899525523186","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a de les M\xe8lies 21","informacio_web":"https://www.pinedademar.cat/serveis/cultura/espai-cultural-sara-llorens","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-05T11:14:00.000"},{":id":"row-ppmr-7bk7.qgyx",":version":"rv-w3sh_9meb~c2ii",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"AJUNTAMENT DE PINELL DE SOLSON\xc8S","indicador_refugi":"251667|AJUNTAMENT_DE_PINELL_DE_SOLSONES","municipi":"Pinell de Solson\xe8s","codi_municipi":"251667","latitud":"41.949913","longitud":"1.418172","accessibilitat":"No","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"CASA CONSISTORIAL","informacio_web":"http://www.pinelldesolson\xe8s.cat","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-05T11:21:00.000"},{":id":"row-8qh5~mzwj_y2u4",":version":"rv-dh6k.zsha-7w8g",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Ard\xe8vol","indicador_refugi":"251673|PISCINA_ARDEVOL","municipi":"Pin\xf3s","codi_municipi":"251673","latitud":"41.85068887","longitud":"1.51849395","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. Tor\xe0, s/n,  25287 Ard\xe8vol","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-f4rv_i8un.nyis",":version":"rv-ws5i_7bd9~2f9f",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal pirenc","indicador_refugi":"431074|CASAL_PIRENC","municipi":"Pira","codi_municipi":"431074","latitud":"41.4237","longitud":"1.20321","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Sant Sebasti\xe0, s/n","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-4uin_6rz4-xtcf",":version":"rv-sy6d.jkph.ap4a",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"431074|PISCINA_MUNICIPAL","municipi":"Pira","codi_municipi":"431074","latitud":"41.426463","longitud":"1.203151","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Afores municipi, Part. ullastres, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-gbre-7n9f.vxdw",":version":"rv-j7h6-nfn9.vxu6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"171349|PISCINA_MUNICIPAL","municipi":"Planoles","codi_municipi":"171349","latitud":"42.317288","longitud":"2.10071462","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Cam\xed de la Serreta, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-v84g_57ea_3ymj",":version":"rv-cwd4_9thm~cjnf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"251692|PISCINA_MUNICIPAL","municipi":"Pobla de C\xe9rvoles, la","codi_municipi":"251692","latitud":"41.3646193","longitud":"0.9172025","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Calvari, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-v5t4.znye_p3qm",":version":"rv-5pv4.6nyr-4wgd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Mossen Cinto Verdaguer","indicador_refugi":"081653|BIBLIOTECA_MOSSEN_CINTO_VERDAGUER","municipi":"Pobla de Claramunt, la","codi_municipi":"081653","latitud":"41.55441419","longitud":"1.6754238","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Catalunya, 9","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-zfq2~uvpa-jbqv",":version":"rv-yjvt.eqjr_d6n2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal Pas Blau","indicador_refugi":"081653|PISCINA_MUNICIPAL_PAS_BLAU","municipi":"Pobla de Claramunt, la","codi_municipi":"081653","latitud":"41.55162598","longitud":"1.67937527","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Josep Aguilera, 4","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-azyz.vbmp_3dsy",":version":"rv-g3d3-rhqs_phge",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"081666|PISCINA_MUNICIPAL","municipi":"Pobla de Lillet, la","codi_municipi":"081666","latitud":"42.246387","longitud":"1.973419","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ Comafiguera, s/n","informacio_web":"Temporada d\'estiu - Horari di\xfcrn","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-23T10:46:00.000"},{":id":"row-ghct-yhc8.7p3x",":version":"rv-dwe4.y3r9~h4cs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a parc Xesco Boix","indicador_refugi":"081666|PLACA_PARC_XESCO_BOIX","municipi":"Pobla de Lillet, la","codi_municipi":"081666","latitud":"42.24441","longitud":"1.975634","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Parc Xesco Boix","informacio_web":"24 hores","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-23T10:49:00.000"},{":id":"row-66yx-92zm~4mij",":version":"rv-6pr5-wmdv_xjwy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Zona font del G\xfcell","indicador_refugi":"081666|ZONA_FONT_DEL_GUELL","municipi":"Pobla de Lillet, la","codi_municipi":"081666","latitud":"42.243869","longitud":"1.975326","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Font del G\xfcell","informacio_web":"24 hores","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-23T10:52:00.000"},{":id":"row-67zs-a5kw_inyj",":version":"rv-t7ws.9dx2~j223",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Escola P\xfablica Lillet a G\xfcell","indicador_refugi":"081666|ESCOLA_PUBLICA_LILLET_A_GUELL","municipi":"Pobla de Lillet, la","codi_municipi":"081666","latitud":"42.246149","longitud":"1.975401","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ Salvador Torrents, 11","informacio_web":"24 hores","tipologia":"Escola / Institut","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-23T10:55:00.000"},{":id":"row-6mih.6mph~59nr",":version":"rv-6ja8~pxkj~3msi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pavell\xf3 municipal","indicador_refugi":"081666|PAVELLO_MUNICIPAL","municipi":"Pobla de Lillet, la","codi_municipi":"081666","latitud":"42.245587","longitud":"1.975725","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ \xc0ngel Guimer\xe0, 4","informacio_web":"Temporada d\'hivern - 24 hores","tipologia":"Pavell\xf3 Esportiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-23T10:57:00.000"},{":id":"row-qayj~gt9a_tpfy",":version":"rv-pvqx~v75y-cgmc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Gimn\xe0s municipal","indicador_refugi":"081666|GIMNAS_MUNICIPAL","municipi":"Pobla de Lillet, la","codi_municipi":"081666","latitud":"42.245722","longitud":"1.975945","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ \xc0ngel Guimer\xe0, 4","informacio_web":"Tot l\'any 24 hores","tipologia":"Gimn\xe0s Municipal","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-23T10:59:00.000"},{":id":"row-yuby.fcpc_nz2h",":version":"rv-dcv2~nd9y~5bmb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic","indicador_refugi":"081666|CENTRE_CIVIC","municipi":"Pobla de Lillet, la","codi_municipi":"081666","latitud":"42.24434","longitud":"1.974705","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ Dr. Cisneros, 4","informacio_web":"Temporada d\'hivern - 24 hores","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-23T11:01:00.000"},{":id":"row-fzm5.5bq7_24bg",":version":"rv-xzw4-s43k-hris",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Oficina de Turisme","indicador_refugi":"081666|OFICINA_DE_TURISME","municipi":"Pobla de Lillet, la","codi_municipi":"081666","latitud":"42.244366","longitud":"1.975714","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Parc Xesco Boix","informacio_web":"Tot l\'any - Horari di\xfcrn","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-23T11:02:00.000"},{":id":"row-is2e_sdgi.7qbm",":version":"rv-9rfs~end7-6pr3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Llar del Pensionista","indicador_refugi":"081666|LLAR_DEL_PENSIONISTA","municipi":"Pobla de Lillet, la","codi_municipi":"081666","latitud":"42.244943","longitud":"1.975882","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Ctra. de Ripoll, 9","informacio_web":"Temporada d\'hivern - Horari di\xfcrn","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-23T11:05:00.000"},{":id":"row-pee6~2vce_imwm",":version":"rv-zv76-kuqc_9f69",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals","indicador_refugi":"431107|PISCINES_MUNICIPALS","municipi":"Pobla de Massaluca, la","codi_municipi":"431107","latitud":"41.17930447","longitud":"0.35353707","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Santa Madrona, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-eiiw~x3w9-euqp",":version":"rv-tc93-neer_myer",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal cultural de la Pobla de Massaluca","indicador_refugi":"431107|CASAL_CULTURAL_DE_LA_POBLA_DE_MASSALUCA","municipi":"Pobla de Massaluca, la","codi_municipi":"431107","latitud":"41.18249286","longitud":"0.35409167","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Nord, 2","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-n964_w77d.rzdp",":version":"rv-tygx.2bek-jvfq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari la Pobla de Segur","indicador_refugi":"251713|CASAL_CIVIC_I_COMUNITARI_LA_POBLA_DE_SEGUR","municipi":"Pobla de Segur, la","codi_municipi":"251713","latitud":"42.2505339","longitud":"0.9639951","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Sant Miquel del Pui, 64","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-7bph-hpwy~dyzh",":version":"rv-jg9e.t8cr_2g95",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"431135|PISCINA_MUNICIPAL","municipi":"Pont d\'Armentera, el","codi_municipi":"431135","latitud":"41.38661831","longitud":"1.36116074","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"T, C-37, 6, 43817 El Pont d\'Armentera, Tarragona","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-qf9w_3n6p~3ref",":version":"rv-jjk6-jssn_wq33",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Ponts","indicador_refugi":"251728|CASAL_CIVIC_I_COMUNITARI_PONTS","municipi":"Ponts","codi_municipi":"251728","latitud":"41.9154801","longitud":"1.1833158","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Planell, 7","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-gzz7-z5e4.3v7f",":version":"rv-vvdy_u3xp_57j2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals","indicador_refugi":"251728|PISCINES_MUNICIPALS","municipi":"Ponts","codi_municipi":"251728","latitud":"41.91427","longitud":"1.17993","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. de les Piscines, 61","informacio_web":"www.ponts.cat","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T13:59:00.000"},{":id":"row-p8wb-dd8z.zmzn",":version":"rv-rgm4_qvpr~s6qa",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc municipal La Roca del Call","indicador_refugi":"251728|PARC_MUNICIPAL_LA_ROCA_DEL_CALL","municipi":"Ponts","codi_municipi":"251728","latitud":"41.9217","longitud":"1.18226","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Zona fluvial del Segre a Ponts","informacio_web":"www.ponts.cat","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T14:02:00.000"},{":id":"row-ywzp_vqj6~hu3n",":version":"rv-pk8p_pdxa-jzbj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Carles Fontser\xe8","indicador_refugi":"171371|BIBLIOTECA_CARLES_FONTSERE","municipi":"Porqueres","codi_municipi":"171371","latitud":"42.10372786","longitud":"2.77647244","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Jaume Balmes, 27","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-8pqi-fbw2.qkq6",":version":"rv-ysaz~tfn7~y4rd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CASAL DE LA GENT GRAN","indicador_refugi":"171371|CASAL_DE_LA_GENT_GRAN","municipi":"Porqueres","codi_municipi":"171371","latitud":"42.107524","longitud":"2.779808","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/SANT ANDREU, 28-30","informacio_web":"WWW.PORQUERES.CAT","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-03T12:49:00.000"},{":id":"row-aqyg.sbvg~iq5t",":version":"rv-d8vr~kwu4~jf7k",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"BAR DE LA ZONA ESPORTIVA","indicador_refugi":"171371|BAR_DE_LA_ZONA_ESPORTIVA","municipi":"Porqueres","codi_municipi":"171371","latitud":"42.104752","longitud":"2.762455","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"PG. Mediterr\xe0nia","informacio_web":"www.porqueres.cat","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-03T12:51:00.000"},{":id":"row-yk2s-gty9.g7ya",":version":"rv-ce5k.xke3-7hmv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic","indicador_refugi":"171387|CENTRE_CIVIC","municipi":"Portbou","codi_municipi":"171387","latitud":"42.42588714","longitud":"3.16038533","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Mendez Nu\xf1ez, 2","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-gb5s_2zd3_wtja",":version":"rv-emhr~z957~8bzx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala Congesta","indicador_refugi":"171387|SALA_CONGESTA","municipi":"Portbou","codi_municipi":"171387","latitud":"42.42604726","longitud":"3.16194408","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"No","adreca":"171387|SALA_CONGESTA","tipologia":"Equipament Cultural (teatre, auditori, museu)","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-05T13:29:00.000"},{":id":"row-sbdv_82uz_yhgj",":version":"rv-9ggp~i8vh~mwvz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Castell","indicador_refugi":"431153|PARC_DEL_CASTELL","municipi":"Pradell de la Teixeta","codi_municipi":"431153","latitud":"41.15662199","longitud":"0.87533054","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. del Castell","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-n8yj-8wds_kzh2",":version":"rv-6g5r~4yj5.3m6c",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal de Pratdip","indicador_refugi":"431188|PISCINA_MUNICIPAL_DE_PRATDIP","municipi":"Pratdip","codi_municipi":"431188","latitud":"41.05029776","longitud":"0.87252059","accessibilitat":"S\xed","aigua":"No","area_descans":"No","adreca":"Av. Catalunya, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-773m-rgb4~3zyf",":version":"rv-hby5-t2gw-q37r",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal de Planes del Rei","indicador_refugi":"431188|PISCINA_MUNICIPAL_DE_PLANES_DEL_REI","municipi":"Pratdip","codi_municipi":"431188","latitud":"41.02684625","longitud":"0.90203425","accessibilitat":"S\xed","aigua":"No","area_descans":"No","adreca":"Av. Pratdip, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-43jc_u43i~swtt",":version":"rv-2jqh~3245_eb58",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai del Caf\xe8 de les Persones Grans i Sala de Tallers","indicador_refugi":"081705|ESPAI_DEL_CAFE_DE_LES_PERSONES_GRANS_I_SALA_DE_TALLERS","municipi":"Prats de Rei, els","codi_municipi":"081705","latitud":"41.70619125","longitud":"1.5417927","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Ravalet, 31","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-n9kk~jqwz_nwk8",":version":"rv-x6wx.3avt-ycjh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal dels Prats de Rei","indicador_refugi":"081705|PISCINA_MUNICIPAL_DELS_PRATS_DE_REI","municipi":"Prats de Rei, els","codi_municipi":"081705","latitud":"41.70682065","longitud":"1.54518758","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Pa\xefsos Catalans, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-f9tx-eafk.nuuq",":version":"rv-yrbk-amn4.mr5n",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"251765|PISCINA_MUNICIPAL","municipi":"Preixana","codi_municipi":"251765","latitud":"41.605763","longitud":"1.040316","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Catalunya, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-wqxb~kwer-wmwm",":version":"rv-zqay-z335-djpt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal gent gran","indicador_refugi":"251765|CASAL_GENT_GRAN","municipi":"Preixana","codi_municipi":"251765","latitud":"41.60627629","longitud":"1.03882822","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Catalunya, 1","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-3g7z-548s-scyy",":version":"rv-ibj7-guar~w4at",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Lo Cabildo","indicador_refugi":"251771|LO_CABILDO","municipi":"Preixens","codi_municipi":"251771","latitud":"41.79369058","longitud":"1.0485752","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C.Sant Joan, 10","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-bikc_96ax~2xjw",":version":"rv-7x6e_gfam.hxg6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala de plens ajuntament de Premia de Dalt","indicador_refugi":"082303|SALA_DE_PLENS_AJUNTAMENT_DE_PREMIA_DE_DALT","municipi":"Premi\xe0 de Dalt","codi_municipi":"082303","latitud":"41.50565304","longitud":"2.34562338","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de la f\xe0brica, 1","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-jj7e.5m3p-a6fp",":version":"rv-mupt~ejww~d2vq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal d\'avis Santa Anna - tio","indicador_refugi":"082303|CASAL_D_AVIS_SANTA_ANNA_TIO","municipi":"Premi\xe0 de Dalt","codi_municipi":"082303","latitud":"41.49675994","longitud":"2.36259179","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. del mil\xb7lenari, 1","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-ziur.wkk4.6bhx",":version":"rv-wcds-2kk5-n8bj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jaume Perich i Escala","indicador_refugi":"082303|JAUME_PERICH_I_ESCALA","municipi":"Premi\xe0 de Dalt","codi_municipi":"082303","latitud":"41.50476366","longitud":"2.34711179","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Riera Sant Pere, 88","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-hevz_hrwz-43e2",":version":"rv-4ftg-brnk_yk5u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de gent gran La Benefica","indicador_refugi":"082303|CASAL_DE_GENT_GRAN_LA_BENEFICA","municipi":"Premi\xe0 de Dalt","codi_municipi":"082303","latitud":"41.507288","longitud":"2.34369976","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Sant Crist, 2","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-cfgz~5s34.wy5j",":version":"rv-kbsq_w8w4-2g5k",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la gent gran i tendals en espais p\xfablics exteriors","indicador_refugi":"081748|CASAL_DE_LA_GENT_GRAN_I_TENDALS_EN_ESPAIS_PUBLICS_EXTERIORS","municipi":"Puigd\xe0lber","codi_municipi":"081748","latitud":"41.40446031","longitud":"1.70109485","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. de la Vila, 1","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-vuhv-mukz.5zh2",":version":"rv-8ckz_qtxn_4395",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal Puigpelatenc","indicador_refugi":"431191|CASAL_PUIGPELATENC","municipi":"Puigpelat","codi_municipi":"431191","latitud":"41.2775794","longitud":"1.30007628","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Major, s/n","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-xvfz_m3qb-8mn8",":version":"rv-nmue-sbkm~89y3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Llar d\'avis Dr. Llaverias","indicador_refugi":"081751|LLAR_D_AVIS_DR_LLAVERIAS","municipi":"Puig-reig","codi_municipi":"081751","latitud":"41.97568568","longitud":"1.87827878","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Lleida, 1","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-ia5u_cwj6~t9vx",":version":"rv-f24y~eauc-piwv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Guillem de Bergued\xe0","indicador_refugi":"081751|BIBLIOTECA_GUILLEM_DE_BERGUEDA","municipi":"Puig-reig","codi_municipi":"081751","latitud":"41.97418615","longitud":"1.87416695","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. 1 d\'octubre, 5-7","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-tw89_s9ng.u4e4",":version":"rv-z4hn-h92s~eaae",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Llar de jubilats Sant Jordi","indicador_refugi":"251826|LLAR_DE_JUBILATS_SANT_JORDI","municipi":"Puigverd de Lleida","codi_municipi":"251826","latitud":"41.54333226","longitud":"0.733484","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Major, 10","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-ai33.eu7j_98ap",":version":"rv-q4av-zd7i-3jdy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala polivalent bar piscines","indicador_refugi":"251826|SALA_POLIVALENT_BAR_PISCINES","municipi":"Puigverd de Lleida","codi_municipi":"251826","latitud":"41.54135985","longitud":"0.73349473","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. la Bassa, s/n","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-cxhc~2db8_63mz",":version":"rv-7tev~hsas-pivb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament","indicador_refugi":"251826|AJUNTAMENT","municipi":"Puigverd de Lleida","codi_municipi":"251826","latitud":"41.54342577","longitud":"0.73320299","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Major, 7","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-6i6v~n5hu-ereg",":version":"rv-cd7d-j8g7.c2g4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La Sala","indicador_refugi":"081786|LA_SALA","municipi":"Rajadell","codi_municipi":"081786","latitud":"41.72758033","longitud":"1.70593518","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Major, 14 08256 Rajadell","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-rfaq~852s~s9eb",":version":"rv-bhzr_jpqt~5u6x",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CASAL DE LA GENT GRAN","indicador_refugi":"431212|CASAL_DE_LA_GENT_GRAN","municipi":"Rasquera","codi_municipi":"431212","latitud":"41.00255498339078","longitud":"0.6008258441833205","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ FIRAL 2","informacio_web":"WWW.RASQUERA.CAT","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T11:20:00.000"},{":id":"row-hpyv~6tgf-zpc3",":version":"rv-rar9-3cj8.3ucu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PISCINES MUNICIPALS DE RASQUERA","indicador_refugi":"431212|PISCINES_MUNICIPALS_DE_RASQUERA","municipi":"Rasquera","codi_municipi":"431212","latitud":"41.00365311005596","longitud":"0.6019561142985219","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ ESPORTS S/N","informacio_web":"WWW.RASQUERA.CAT","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T11:27:00.000"},{":id":"row-ynpf-fdyc.bcgn",":version":"rv-i5s7-sjam.r77v",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Antigues escoles de Regenc\xf3s","indicador_refugi":"171447|ANTIGUES_ESCOLES_DE_REGENCOS","municipi":"Regenc\xf3s","codi_municipi":"171447","latitud":"41.95297079","longitud":"3.17129221","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Torres Jonama, 3","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-inab~7zdn~fz77",":version":"rv-bfjy-d5kr_nu6c",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Refugi clim\xe0tic del cami del Cementiri","indicador_refugi":"171447|REFUGI_CLIMATIC_DEL_CAMI_DEL_CEMENTIRI","municipi":"Regenc\xf3s","codi_municipi":"171447","latitud":"41.95313206","longitud":"3.16648264","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Cam\xed del Cementiri, s/n, Regenc\xf2s","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-d7fw.uupy_d4kt",":version":"rv-xeci.bqgt-t6j8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de cultura L\'escola","indicador_refugi":"081799|CASAL_DE_CULTURA_L_ESCOLA","municipi":"Rellinars","codi_municipi":"081799","latitud":"41.63767056","longitud":"1.91139771","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de l\'ajuntament, s/n","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-rykc~6rzs.84iv",":version":"rv-8dqq.se4z_rpkq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Mas Abell\xf3","indicador_refugi":"431233|CENTRE_CIVIC_MAS_ABELLO","municipi":"Reus","codi_municipi":"431233","latitud":"41.15055967","longitud":"1.11862606","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Mas del Carpa, 4, 43204 Reus, Tarragona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-23q8_ycsp_u8yt",":version":"rv-si3v-zxdw_6gup",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Central Xavier Amor\xf3s","indicador_refugi":"431233|BIBLIOTECA_CENTRAL_XAVIER_AMOROS","municipi":"Reus","codi_municipi":"431233","latitud":"41.15403914","longitud":"1.10014809","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de l\'Escorxador, 1, 43202 Reus, Tarragona","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-2hau.8bph.ejqd",":version":"rv-ivxp~9w6a.web5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La Palma","indicador_refugi":"431233|LA_PALMA","municipi":"Reus","codi_municipi":"431233","latitud":"41.16083214","longitud":"1.10277371","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Ample, 75, 43202 Reus, Tarragona","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-y69k_i5dq.abu4",":version":"rv-v22p.9wsd~s9qr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal c\xedvic Reus - La Rambla (GENCAT)","indicador_refugi":"431233|CASAL_CIVIC_REUS_LA_RAMBLA_GENCAT","municipi":"Reus","codi_municipi":"431233","latitud":"41.15447","longitud":"1.11251035","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Riera d\'Arag\xf3, 11, 43204 Reus, Tarragona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-bsqt_uttp-cjex",":version":"rv-gg3h~p5eg~wcvj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Carrer de Roman\xed","indicador_refugi":"431233|PARC_DEL_CARRER_DE_ROMANI","municipi":"Reus","codi_municipi":"431233","latitud":"41.15297592","longitud":"1.09486974","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. del Roman\xed, 21, 43206 Reus, Tarragona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-85ze-pp23_vmdx",":version":"rv-2uxz-2txy~8vq9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Europa","indicador_refugi":"431233|PLACA_EUROPA","municipi":"Reus","codi_municipi":"431233","latitud":"41.14657027","longitud":"1.11009157","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. d\'Europa, 43205 Reus, Tarragona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-b45y.fhn7~3kgp",":version":"rv-5bqn~ecjz-c8eb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Reus - Sant Josep Obrer","indicador_refugi":"431233|CASAL_CIVIC_I_COMUNITARI_REUS_SANT_JOSEP_OBRER","municipi":"Reus","codi_municipi":"431233","latitud":"41.1475638","longitud":"1.1173147","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Mas del Pellicer, bloc 55 (Sant Josep Obrer)","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-6369-3jpa_5x32",":version":"rv-uyf8_erwn.6rw2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre d\'Art Cal Mass\xf3","indicador_refugi":"431233|CENTRE_D_ART_CAL_MASSO","municipi":"Reus","codi_municipi":"431233","latitud":"41.15855329","longitud":"1.10196642","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Pr\xf2sper de Bofarull, 7, 43202 Reus, Tarragona","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-wz62.fvgr.kgmc",":version":"rv-dqzc~hjqg_umhn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Mas Carandell","indicador_refugi":"431233|PARC_MAS_CARANDELL","municipi":"Reus","codi_municipi":"431233","latitud":"41.16207275","longitud":"1.09328731","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Terol, 8","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-8af2-7xh4-jckn",":version":"rv-vfg9~vg3e~qaz3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Santuari de Miseric\xf2rdia","indicador_refugi":"431233|PARC_DEL_SANTUARI_DE_MISERICORDIA","municipi":"Reus","codi_municipi":"431233","latitud":"41.14290671","longitud":"1.09969558","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Santuari Miseric\xf2rdia, s/n","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-iprg.i2sk-56kg",":version":"rv-ccr6.7fjz.75f3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Passeig Prim","indicador_refugi":"431233|PASSEIG_PRIM","municipi":"Reus","codi_municipi":"431233","latitud":"41.15223546","longitud":"1.10315538","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. de Prim, 43202 Reus, Tarragona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-suj3-imkq~vuck",":version":"rv-ssje-ypme~fcaj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat Central","indicador_refugi":"431233|MERCAT_CENTRAL","municipi":"Reus","codi_municipi":"431233","latitud":"41.15699738","longitud":"1.10307016","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"No","adreca":"C. de Josep Sard\xe0 i Cail\xe0, s/n, 43201 Reus, Tarragona","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-kxxq-6sea_24q8",":version":"rv-pnyy_upqn~rbqg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Pere Anguera","indicador_refugi":"431233|BIBLIOTECA_PERE_ANGUERA","municipi":"Reus","codi_municipi":"431233","latitud":"41.1441847","longitud":"1.11758267","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Joan Salvat Papasseit, 14, 43204 Reus, Tarragona","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-td5c.d2ux-9y5k",":version":"rv-e6dy~j5x4~2ren",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Ponent","indicador_refugi":"431233|CENTRE_CIVIC_PONENT","municipi":"Reus","codi_municipi":"431233","latitud":"41.1515604","longitud":"1.09805221","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. dels Pa\xefsos Catalans, 106, 43205 Reus, Tarragona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-taay.bnq4_3ype",":version":"rv-ehf3.be32_byvt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc d\u2019Angel Guimer\xe0","indicador_refugi":"431233|PARC_D_ANGEL_GUIMERA","municipi":"Reus","codi_municipi":"431233","latitud":"41.15816547","longitud":"1.09737713","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. d\'\xc0ngel Guimer\xe0, 31, 43202 Reus, Tarragona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-rkff_up2e-5hdb",":version":"rv-mdwh-6ss9~5ed7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Tirant lo Blanc","indicador_refugi":"431233|PARC_TIRANT_LO_BLANC","municipi":"Reus","codi_municipi":"431233","latitud":"41.15821866","longitud":"1.08802869","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Roger de Ll\xfaria, 43206 Reus, Tarragona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-q2sx-2u2h_xmhg",":version":"rv-qvtd-yvns-yhic",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic municipal Llevant","indicador_refugi":"431233|CENTRE_CIVIC_MUNICIPAL_LLEVANT","municipi":"Reus","codi_municipi":"431233","latitud":"41.15634217","longitud":"1.11425355","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Horts del Canonges, 1, 43204 Reus, Tarragona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-dgqp_4jut.b5nq",":version":"rv-sgak_pyct_9hfy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Passeig Sunyer","indicador_refugi":"431233|PASSEIG_SUNYER","municipi":"Reus","codi_municipi":"431233","latitud":"41.15673873","longitud":"1.10156334","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. de Sunyer, 20-16, 43202 Reus, Tarragona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-b43h~u7fb_ujev",":version":"rv-z9zt~3ey8-3j5p",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Trenet","indicador_refugi":"431233|PARC_DEL_TRENET","municipi":"Reus","codi_municipi":"431233","latitud":"41.14473388","longitud":"1.0989199","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. dels Pa\xefsos Catalans, 209V, 43205 Reus, Tarragona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-2hm2.9gww.qus8",":version":"rv-86yb-tx8s.pxa6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat del Carrilet","indicador_refugi":"431233|MERCAT_DEL_CARRILET","municipi":"Reus","codi_municipi":"431233","latitud":"41.14879638","longitud":"1.11128223","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"No","adreca":"Av. Jaume I, s/n, 43204 Reus, Tarragona","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-ibcn~uszq-xjk7",":version":"rv-vf2k.rf5g-tu5f",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu de Reus ( Salvador Vilaseca)","indicador_refugi":"431233|MUSEU_DE_REUS_SALVADOR_VILASECA","municipi":"Reus","codi_municipi":"431233","latitud":"41.15665102","longitud":"1.11059614","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"No","adreca":"Raval de Santa Anna, 59, 43201 Reus, Tarragona","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-rbxw.9en7-jwy9",":version":"rv-5v7k-4db2.x4a6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic del Carme","indicador_refugi":"431233|CENTRE_CIVIC_DEL_CARME","municipi":"Reus","codi_municipi":"431233","latitud":"41.15457316","longitud":"1.10494646","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de la Patacada, 10, 43201 Reus, Tarragona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-3pjx~c94r.gymk",":version":"rv-ajwm_h48s_wjz3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Sant Jordi","indicador_refugi":"431233|PARC_DE_SANT_JORDI","municipi":"Reus","codi_municipi":"431233","latitud":"41.16006222","longitud":"1.10717017","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. de Sant Jordi, 2, 43201 Reus, Tarragona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-4fb3-p59y~bwwd",":version":"rv-3bhi~kkkr.qrek",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Passeig de la Boca de la Mina","indicador_refugi":"431233|PASSEIG_DE_LA_BOCA_DE_LA_MINA","municipi":"Reus","codi_municipi":"431233","latitud":"41.16397926","longitud":"1.09539105","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Barranc de la Mina, 7A, 43206 Reus, Tarragona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-7phw.nrj4~277j",":version":"rv-rizv-n28x.tcjz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Migjorn","indicador_refugi":"431233|CENTRE_CIVIC_MIGJORN","municipi":"Reus","codi_municipi":"431233","latitud":"41.13968019","longitud":"1.11688077","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Riera de l\'Escorial, 24, 43205 Reus, Tarragona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-uej4.tvz6_baw7",":version":"rv-n3ub~c9xi-ezfd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Carretera Pere Mata","indicador_refugi":"431233|PARC_CARRETERA_PERE_MATA","municipi":"Reus","codi_municipi":"431233","latitud":"41.16215181","longitud":"1.08551133","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. Institut Pere Mata, 19V, 43206 Reus, Tarragona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-jk3s_smz9-hpv7",":version":"rv-cnbt-uyt2_vc4i",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu Gaud\xed - Oficina de Turisme","indicador_refugi":"431233|MUSEU_GAUDI_OFICINA_DE_TURISME","municipi":"Reus","codi_municipi":"431233","latitud":"41.15534514","longitud":"1.10831917","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"No","adreca":"Pl. del Mercadal, 3, 43201 Reus, Tarragona","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-pfad~hjjm~mxsc",":version":"rv-i3gf.n7xw.agc5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Passeig Miseric\xf2rdia","indicador_refugi":"431233|PASSEIG_MISERICORDIA","municipi":"Reus","codi_municipi":"431233","latitud":"41.14842638","longitud":"1.10476266","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. de Miseric\xf2rdia, 43205 Reus, Tarragona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-mgwz_gb42-fitf",":version":"rv-6ev8_ptek~sed3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal municipal de Joves","indicador_refugi":"431233|CASAL_MUNICIPAL_DE_JOVES","municipi":"Reus","codi_municipi":"431233","latitud":"41.16679388","longitud":"1.1021353","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Castellvell, 24, 43202 Reus, Tarragona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-zsbs-jh8a-hqvb",":version":"rv-hguf_fjvf_9bu6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Reus - la Rambla","indicador_refugi":"431233|CASAL_CIVIC_I_COMUNITARI_REUS_LA_RAMBLA","municipi":"Reus","codi_municipi":"431233","latitud":"41.15426","longitud":"1.1079828","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Riera d\'Arag\xf2, 11","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-i7b3.f78i_7ch3",":version":"rv-kgg3~ixx8.yggi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Mestral","indicador_refugi":"431233|CENTRE_CIVIC_MESTRAL","municipi":"Reus","codi_municipi":"431233","latitud":"41.16054434","longitud":"1.09582151","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. de Barcelona, 6, 43206 Reus, Tarragona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-i8rb.guhz.nn2n",":version":"rv-pxwg~6yzw_qsnp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal Ribet\xe0","indicador_refugi":"431248|CASAL_RIBETA","municipi":"Riba, la","codi_municipi":"431248","latitud":"41.31770166","longitud":"1.17781633","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Pag\xe8s, 14","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-bzkg.hbx6.uwxg",":version":"rv-vift~ubd4.wjzz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"431248|PISCINA_MUNICIPAL","municipi":"Riba, la","codi_municipi":"431248","latitud":"41.3169246","longitud":"1.17975971","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Pilats, 1","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-tftj_pdwh-dx5z",":version":"rv-5ugc~6vc8_5vk7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"171485|PISCINA_MUNICIPAL","municipi":"Riudarenes","codi_municipi":"171485","latitud":"41.819645","longitud":"2.723792","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Cam\xed de la Camparra, 4, Riudarenes","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-bqg8~w9bm_dqj3",":version":"rv-dxhk~3agi.8vtm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local Social","indicador_refugi":"171498|LOCAL_SOCIAL","municipi":"Riudaura","codi_municipi":"171498","latitud":"42.1889884315384","longitud":"2.407193976510658","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ Joan Castanyer i Massegur, 12 (17179 Riudaura)","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-05T10:30:00.000"},{":id":"row-ufp8_g4q2~2n5j",":version":"rv-uyaw-grmv~3igr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Poliesportiu Joan Mestre","indicador_refugi":"431286|POLIESPORTIU_JOAN_MESTRE","municipi":"Riudecols","codi_municipi":"431286","latitud":"41.16716186","longitud":"0.97754947","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Ctra. Alcolea, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-stwg_yxrf_cup3",":version":"rv-7d3c.6sut-j8ea",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Llar dels Jubilats","indicador_refugi":"431299|LLAR_DELS_JUBILATS","municipi":"Riudoms","codi_municipi":"431299","latitud":"41.13914506","longitud":"1.05078653","accessibilitat":"No","aigua":"No","climatitzacio":"S\xed","area_descans":"No","lavabo":"No","adreca":"C. Sant Jaume, 2","tipologia":"Casal de Gent Gran","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-22T11:46:00.000"},{":id":"row-ba8n-ktz7~xtiy",":version":"rv-d3ry.eiqp~dhah",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Municipal Antoni Gaud\xed","indicador_refugi":"431299|BIBLIOTECA_MUNICIPAL_ANTONI_GAUDI","municipi":"Riudoms","codi_municipi":"431299","latitud":"41.13948150375201","longitud":"1.0555250090563502","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a de l\u2019Arbre, 5","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-22T11:45:00.000"},{":id":"row-tkji.pvgf_2sdq",":version":"rv-udp3.uwbr_pjgr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de l\u2019escolale M\xfasica","indicador_refugi":"081831|JARDINS_DE_L_ESCOLALE_MUSICA","municipi":"Roda de Ter","codi_municipi":"081831","latitud":"41.98646779","longitud":"2.31148821","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Tecla Sala, 35","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-uxbb~89my~49cb",":version":"rv-wf23.yzdn-bmh2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Bac de roda","indicador_refugi":"081831|BIBLIOTECA_BAC_DE_RODA","municipi":"Roda de Ter","codi_municipi":"081831","latitud":"41.98145337","longitud":"2.30917258","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Bac de roda, 1 bis","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-xrg7.fp84-g6yb",":version":"rv-cyg3~icsj_z7ga",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Fundaci\xf3 Miquel Mart\xed I Pol","indicador_refugi":"081831|FUNDACIO_MIQUEL_MARTI_I_POL","municipi":"Roda de Ter","codi_municipi":"081831","latitud":"41.9773801","longitud":"2.307016","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. costa del Ter, 13","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-2fx6_ycfw-8usd",":version":"rv-qiet_2dez-v4qk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de la Blava","indicador_refugi":"081831|JARDINS_DE_LA_BLAVA","municipi":"Roda de Ter","codi_municipi":"081831","latitud":"41.97779196","longitud":"2.30782905","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Jardins de la Blava","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-9zeh-ud48_8ugw",":version":"rv-mywb.eqzw-xq46",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu de l\u2019Esquerda","indicador_refugi":"081831|MUSEU_DE_L_ESQUERDA","municipi":"Roda de Ter","codi_municipi":"081831","latitud":"41.97716186","longitud":"2.31271098","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"AV. Pere Baurier, 30","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-y4pr-9spv_zzkt",":version":"rv-zirj-nh76-i9yk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bar de Can Planoles","indicador_refugi":"081831|BAR_DE_CAN_PLANOLES","municipi":"Roda de Ter","codi_municipi":"081831","latitud":"41.9819135","longitud":"2.31149047","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Ramon Pujols i Caveras, 42","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-qub6.6wjz-ca7g",":version":"rv-pbh6_m25c-i97e",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals","indicador_refugi":"081831|PISCINES_MUNICIPALS","municipi":"Roda de Ter","codi_municipi":"081831","latitud":"41.98780614","longitud":"2.31063708","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"No","adreca":"Pg. de la Generalitat, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-c4ea.49hi-xk5n",":version":"rv-zfd4~b6rn_e397",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal de Rodony\xe0 \\"Salvador de Tamarit i Vilanova\\"","indicador_refugi":"431325|BIBLIOTECA_MUNICIPAL_DE_RODONYA_\\"SALVADOR_DE_TAMARIT_I_VILANOVA\\"","municipi":"Rodony\xe0","codi_municipi":"431325","latitud":"41.27978260770917","longitud":"1.3987541581645004","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Major, 1","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T09:10:00.000"},{":id":"row-x6ef-syfr_zmq5",":version":"rv-pn5s_7ayi.jxy9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CMSS","indicador_refugi":"431325|CMSS","municipi":"Rodony\xe0","codi_municipi":"431325","latitud":"41.28223933058955","longitud":"1.3978364922320647","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Diputaci\xf3 4","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T09:14:00.000"},{":id":"row-reth.d8uq_ikf2",":version":"rv-sgrt_v7x2_h8jj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Raval Nova","indicador_refugi":"431331|PLACA_RAVAL_NOVA","municipi":"Roquetes","codi_municipi":"431331","latitud":"40.82304103","longitud":"0.50108599","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Raval Nova","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-6pm8.vy75~xd2i",":version":"rv-tzem~kh22.yvrf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Hort de Cruells","indicador_refugi":"431331|PARC_HORT_DE_CRUELLS","municipi":"Roquetes","codi_municipi":"431331","latitud":"40.8178798","longitud":"0.50669657","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc Hort de Cruells","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-v9kt.npfk_nx3j",":version":"rv-6kzz-uqm5.sk7d",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Merc\xe8 Lleix\xe0","indicador_refugi":"431331|BIBLIOTECA_MERCE_LLEIXA","municipi":"Roquetes","codi_municipi":"431331","latitud":"40.81996071","longitud":"0.4953293","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Urb. Torre d\'en Gil","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-nbtt-7sni-q3rn",":version":"rv-urje-zxka~ecce",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Manel Domenech","indicador_refugi":"431331|PARC_MANEL_DOMENECH","municipi":"Roquetes","codi_municipi":"431331","latitud":"40.82035514","longitud":"0.49592082","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. Manel Cid","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-mejj.amdr~pkia",":version":"rv-28bp_fr7f_apsw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament de Roquetes","indicador_refugi":"431331|AJUNTAMENT_DE_ROQUETES","municipi":"Roquetes","codi_municipi":"431331","latitud":"40.81840757","longitud":"0.50306486","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Diputaci\xf3, s/n","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-fui7~6e97_re54",":version":"rv-sru5_w93a~h28h",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Pare Cirera","indicador_refugi":"431331|PLACA_PARE_CIRERA","municipi":"Roquetes","codi_municipi":"431331","latitud":"40.80908424","longitud":"0.49524842","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Pare Cirera","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-z9uf~twpv-hu85",":version":"rv-ccz9.7ikp.ccpq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Passeig del Canal","indicador_refugi":"431331|PASSEIG_DEL_CANAL","municipi":"Roquetes","codi_municipi":"431331","latitud":"40.81957066","longitud":"0.50458031","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. del Canal","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-edjq.ha88.ivgn",":version":"rv-4jfn-ak35_k9jw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Jaume Vicens i Vives","indicador_refugi":"171523|BIBLIOTECA_JAUME_VICENS_I_VIVES","municipi":"Roses","codi_municipi":"171523","latitud":"42.26371064","longitud":"3.17657","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de Girona, 22-30","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-222p.7i6b~7z48",":version":"rv-i7sb_hgng-444i",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal de Roses","indicador_refugi":"171523|PISCINA_MUNICIPAL_DE_ROSES","municipi":"Roses","codi_municipi":"171523","latitud":"42.26940231","longitud":"3.18128841","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Ctra. del Mas Oliva, 39","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-9fgd.fmn7-ygt2",":version":"rv-bfv3.dt98-guzm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca de Rossell\xf3","indicador_refugi":"251898|BIBLIOTECA_DE_ROSSELLO","municipi":"Rossell\xf3","codi_municipi":"251898","latitud":"41.69609024","longitud":"0.59594716","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Catalunya, 2","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-fxn2_c9b3.bara",":version":"rv-zg7y.jip4-px3k",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del carrer Aneto (Ximelis)","indicador_refugi":"081846|PARC_DEL_CARRER_ANETO_XIMELIS","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.4946474","longitud":"2.00535784","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc del C. Aneto (Ximelis)","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-c73p-x5jq~uqb4",":version":"rv-rd4i~2e9c~dary",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Oficina d\u2019Atenci\xf3 Ciutadana de Les Torres (OADF, ODE i Sector II de Serveis Socials)","indicador_refugi":"081846|OFICINA_D_ATENCIO_CIUTADANA_DE_LES_TORRES_OADF_ODE_I_SECTOR_II_DE_SERVEIS_SOCIALS","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.48573096","longitud":"2.03047463","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Rblt. de Joan Mir\xf3, s/n, 08191 Rub\xed","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-ch9k.te5g_ime7",":version":"rv-m2ys~6ifj~5yww",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a del Ve\xefnat (zona de plataners)","indicador_refugi":"081846|PLACA_DEL_VEINAT_ZONA_DE_PLATANERS","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.48741041","longitud":"2.04113431","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Terol, s/n","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-uwwx-jvtd_fkzb",":version":"rv-v4v7_jd96_vc9q",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de les Moreres","indicador_refugi":"081846|PLACA_DE_LES_MORERES","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.49511648","longitud":"2.0391695","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Mallorca, s/n","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-vfjf~dcnb.kmnu",":version":"rv-kfdy.8y7g_k9ax",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de Pep Rovira","indicador_refugi":"081846|PLACA_DE_PEP_ROVIRA","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.48796776","longitud":"2.02908438","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de Pep Rovira","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-pu6h.j97q.jfz7",":version":"rv-ddnr_aqg2-839h",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Torrent de les Abelles","indicador_refugi":"081846|TORRENT_DE_LES_ABELLES","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.48354","longitud":"2.02885","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Luxemburg - Pg. de la Riera","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-ewka.k2j6_m8ps",":version":"rv-rn3i_r925_k66x",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a d\u2019Andalusia (zona de lledoners)","indicador_refugi":"081846|PLACA_D_ANDALUSIA_ZONA_DE_LLEDONERS","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.50220363","longitud":"2.0366037","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. d\u2019Andalusia (zona de lledoners)","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-ha38-4jws-tca8",":version":"rv-cn2m-a24p_qzre",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a dels Nens","indicador_refugi":"081846|PLACA_DELS_NENS","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.48356526","longitud":"2.03096964","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. dels Nens","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-59gx-m92s_tevw",":version":"rv-7msy~85um~aqkj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a dels Ocells (Els Avets)","indicador_refugi":"081846|PLACA_DELS_OCELLS_ELS_AVETS","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.48448134","longitud":"2.01888071","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. dels Ocells (Els Avets)","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-yuhy-fjvj_tq4f",":version":"rv-fa2r.mg47.dnu2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Ca n\u2019Alzamora","indicador_refugi":"081846|PARC_DE_CA_N_ALZAMORA","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.47846908","longitud":"2.03507911","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc de Ca n\u2019Alzamora","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-9neb_mb2q~ki38",":version":"rv-g39g-j7cw.wpwy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Rambleta de Joan Mir\xf3 (zona de til\xb7lers)","indicador_refugi":"081846|RAMBLETA_DE_JOAN_MIRO_ZONA_DE_TIL_LERS","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.48625451","longitud":"2.03065831","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Rblt. de Joan Mir\xf3, 6","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-x6nw-m49h-mu7x",":version":"rv-abes~pdsb_7en9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia Rub\xed","indicador_refugi":"081846|RESIDENCIA_RUBI","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.49994462","longitud":"2.03477207","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de Lepant 31, 08191 Rub\xed","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-ztrj_xyby.qts4",":version":"rv-zhak~6y8b.3zcf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa de la vila","indicador_refugi":"081846|CASA_DE_LA_VILA","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.49397012","longitud":"2.0311326","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de Pere Aguilera, 1, 08191 Rub\xed","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-igaq_qn7g_2jfw",":version":"rv-fx35-tu7j~zte3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Torrent de Can Matal\xed","indicador_refugi":"081846|TORRENT_DE_CAN_MATALI","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.52936267","longitud":"1.99940455","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Torrent de Can Matal\xed","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-hqbr.am2x_6fyy",":version":"rv-3pbj.jigu_x5wr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal c\xedvic i comunitari de Rub\xed","indicador_refugi":"081846|CASAL_CIVIC_I_COMUNITARI_DE_RUBI","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.49008458","longitud":"2.03570031","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Magallanes, 60, 08191 Rub\xed","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-v3e6-ggs6.5ewp",":version":"rv-av7z_jk3q.bwt2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Rambla del Ferrocarril, a la zona on hi ha la p\xe8rgola","indicador_refugi":"081846|RAMBLA_DEL_FERROCARRIL_A_LA_ZONA_ON_HI_HA_LA_PERGOLA","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.48496921","longitud":"2.03468723","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. del Ferrocarril, 7","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-nvr2~z5tq.q6j8",":version":"rv-exmt_ceer-vemj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Ib\xe8ric (Can Fatj\xf3)","indicador_refugi":"081846|PARC_IBERIC_CAN_FATJO","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.49030528","longitud":"2.0269476","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc Ib\xe8ric (Can Fatj\xf3)","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-ykiq.9n4y~zyp3",":version":"rv-nd4f_n4gk-rzz2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del carrer Chueca (Can Vallhonrat)","indicador_refugi":"081846|PARC_DEL_CARRER_CHUECA_CAN_VALLHONRAT","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.47289579","longitud":"2.03349115","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc del C. Chueca (Can Vallhonrat)","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-ghbp-gquz_f9p5",":version":"rv-st3e~fnv8-4ntg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu municipal el Castell MMUC","indicador_refugi":"081846|MUSEU_MUNICIPAL_EL_CASTELL_MMUC","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.49484427","longitud":"2.02647308","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Castell, 35, 08191 Rub\xed","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-r27h.mbne~e6vd",":version":"rv-54tk_ecef_he42",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La Cru\xeflla Centre c\xedvic del Pinar","indicador_refugi":"081846|LA_CRUILLA_CENTRE_CIVIC_DEL_PINAR","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.50876468","longitud":"2.04578946","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Urbanitzaci\xf3 El Pinar, 1, 08191 Rub\xed","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-3ci3~k77f-2aap",":version":"rv-4nuu-fdi7-gs45",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc dels Geranis (Av. Can Sucarrats)","indicador_refugi":"081846|PARC_DELS_GERANIS_AV_CAN_SUCARRATS","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.48647944","longitud":"2.02047114","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc dels Geranis (Av. Can Sucarrats)","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-mwxi-qu6n.r6tk",":version":"rv-gnrk~8tzw~pi3k",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de Santa Rosa","indicador_refugi":"081846|PLACA_DE_SANTA_ROSA","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.49561704","longitud":"2.0373704","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de Santa Rosa","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-xp9i.bqpy-xx75",":version":"rv-wf37_ymc5~ginb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal Mestre Mart\xed Tauler","indicador_refugi":"081846|BIBLIOTECA_MUNICIPAL_MESTRE_MARTI_TAULER","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.49293502","longitud":"2.03632107","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. d\'Aribau, 5, 08191 Rub\xed","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-f67j-wyr7-faic",":version":"rv-2vnc~aimw-y5jd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc per la Pau i la Natura (zona de pollancres)","indicador_refugi":"081846|PARC_PER_LA_PAU_I_LA_NATURA_ZONA_DE_POLLANCRES","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.48401329","longitud":"2.03695711","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Marconi, 18","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-uya9_cmd5_yj3y",":version":"rv-9rce_fpcq_rc45",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Can Fatj\xf3 (\xe0rees carrer Topazi, pineda amb una font).","indicador_refugi":"081846|PARC_DE_CAN_FATJO_AREES_CARRER_TOPAZI_PINEDA_AMB_UNA_FONT","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.49148982","longitud":"2.02554107","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc de Can Fatj\xf3","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-6uze.rst8.fhqv",":version":"rv-gifr~vv4k~xc2y",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Rub\xed","indicador_refugi":"081846|CASAL_CIVIC_I_COMUNITARI_RUBI","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.4899118","longitud":"2.0330825","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Magallanes, 60","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-f2qe.6tie.z7fb",":version":"rv-f3k8.d7na-fgkx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de l\u2019Arag\xf3","indicador_refugi":"081846|PLACA_DE_L_ARAGO","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.49640732","longitud":"2.04078548","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de l\u2019Arag\xf3","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-82bv.ycqx_ykrs",":version":"rv-dagd-nwgz~mbqb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ateneu municipal","indicador_refugi":"081846|ATENEU_MUNICIPAL","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.4926869","longitud":"2.033071","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Xile, 1-3, 08191 Rub\xed","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-dmy9-hjfs-xpg5",":version":"rv-27tr_ngtk-6u4b",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Font de la Via","indicador_refugi":"081846|PARC_DE_LA_FONT_DE_LA_VIA","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.48949349","longitud":"2.02730999","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc de la Font de la Via","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-jg6m-yazt_z3cw",":version":"rv-5mf3~npq3_s8ie",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat municipal","indicador_refugi":"081846|MERCAT_MUNICIPAL","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.48938708","longitud":"2.03501157","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Cal Gerrer, 1, 08191 Rub\xed","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-nzj9.b67c~kgnv",":version":"rv-qpay_d5sm-ia5b",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Arbor\xe8tum del Castell","indicador_refugi":"081846|ARBORETUM_DEL_CASTELL","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.49491458","longitud":"2.02682931","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. del Castell, 35","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-93gq_ibw9~ztd5",":version":"rv-y5rs.6xsr.q8x9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala local social del Pla de Rubi\xf3","indicador_refugi":"081859|SALA_LOCAL_SOCIAL_DEL_PLA_DE_RUBIO","municipi":"Rubi\xf3","codi_municipi":"081859","latitud":"41.62581395","longitud":"1.55095337","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Escoles, s/n","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-mqks_5yg5_q2hp",":version":"rv-sz2i.igd4~wtdt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre recreatiu Castell de Rubi\xf3","indicador_refugi":"081859|CENTRE_RECREATIU_CASTELL_DE_RUBIO","municipi":"Rubi\xf3","codi_municipi":"081859","latitud":"41.64408","longitud":"1.56945","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Zona Castell de Rubi\xf3-Anoia","informacio_web":"www.rubio.cat","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T15:49:00.000"},{":id":"row-dwbs_za4x_pbdb",":version":"rv-tfvv-kg7z_ghs9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Zona esportiva municipal - El Pla de Rubi\xf3","indicador_refugi":"081859|ZONA_ESPORTIVA_MUNICIPAL_-_EL_PLA_DE_RUBIO","municipi":"Rubi\xf3","codi_municipi":"081859","latitud":"41.625997","longitud":"1.551635","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Escoles, 3","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T15:53:00.000"},{":id":"row-3gv9~d5yg~9xrg",":version":"rv-qbag~fg2g~8ze2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Teatre de Rupi\xe0","indicador_refugi":"171539|TEATRE_DE_RUPIA","municipi":"Rupi\xe0","codi_municipi":"171539","latitud":"42.0201328","longitud":"3.0114381","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Ind\xfastria, 2","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-jk87.6t8b.44az",":version":"rv-j7nb.xajn_enm5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai Joan Font","indicador_refugi":"089019|ESPAI_JOAN_FONT","municipi":"Rupit i Pruit","codi_municipi":"089019","latitud":"42.02530798","longitud":"2.46492864","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Cam\xed Sant Joan de Fabregues, 1 bis","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-m3k5_22c3-g252",":version":"rv-anwc-ere9~8ddc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca de la Serra","indicador_refugi":"081878|BIBLIOTECA_DE_LA_SERRA","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.54961554","longitud":"2.12888061","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. de Crist\xf3bal Ramos, 1","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-3nwb-u6im.na5t",":version":"rv-ih6k_ztn7_qgbk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Sabadell - Roureda","indicador_refugi":"081878|CASAL_CIVIC_I_COMUNITARI_SABADELL_ROUREDA","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.5701946","longitud":"2.0638516","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Costabona, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-74y8-g4xs~rwzu",":version":"rv-rvi9~ayd4.eijc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La Bassa","indicador_refugi":"081878|LA_BASSA","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.53779115","longitud":"2.12563901","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Cam\xed de Can Quadres, 179","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-gx76_9vg9.zfh4",":version":"rv-cn35~24nb~qvq2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Sud","indicador_refugi":"081878|BIBLIOTECA_SUD","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.53023744","longitud":"2.11965094","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pg. dels Almog\xe0vers, 49","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-37qk-gbbh~ap2m",":version":"rv-ndkx~akk7~dip5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Sabadell - Gr\xe0cia","indicador_refugi":"081878|CASAL_CIVIC_I_COMUNITARI_SABADELL_GRACIA","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.5383422","longitud":"2.0987139","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de la Reina Elionor, 110","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-mu7g-gzrj_m3uc",":version":"rv-apyy-bgyt-ight",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Torrent de la Romeua","indicador_refugi":"081878|PARC_TORRENT_DE_LA_ROMEUA","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.56608854","longitud":"2.08311343","accessibilitat":"S\xed","aigua":"No","area_descans":"No","adreca":"Torrent de la Romeua, 19, 08207 Sabadell, Barcelona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-e4vb_se2k-sm79",":version":"rv-g382-u4sj-xcxn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Can Marcet","indicador_refugi":"081878|PISCINA_CAN_MARCET","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.54171246","longitud":"2.0994306","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Riu-Sec, 54, 08205 Sabadell, Barcelona","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-3nt4~9icb_kisf",":version":"rv-mycm-8gt5~q24e",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Conc\xf2rdia","indicador_refugi":"081878|CENTRE_CIVIC_CONCORDIA","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.55850764","longitud":"2.09448069","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de la Lusit\xe0nia, 3, 08206 Sabadell, Barcelona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-b2fi.hwia.ivjw",":version":"rv-hudf-nqxp-6mcn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Catalunya","indicador_refugi":"081878|PARC_CATALUNYA","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.55314059","longitud":"2.09383033","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Prat de la Riba, 104, 08206 Sabadell, Barcelona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-i7n7_tw95-if8t",":version":"rv-5mf4-73ip-wfwg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal c\xedvic Creu Barbera","indicador_refugi":"081878|CASAL_CIVIC_CREU_BARBERA","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.52625298","longitud":"2.11846501","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"PLA\xc7A CASTELAO, 1","informacio_web":"https://web.sabadell.cat/","tipologia":"Centre C\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-05T14:28:00.000"},{":id":"row-kk4u_tu3y-pcb5",":version":"rv-wzqr~d9rv~vtc6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Sabadell - Torre Romeu","indicador_refugi":"081878|CASAL_CIVIC_I_COMUNITARI_SABADELL_TORRE_ROMEU","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.551043","longitud":"2.1230097","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. d\'Anoia, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-jakb.bxg6~mryt",":version":"rv-eqa7-66t3-mk88",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Sabadell - Creu Alta","indicador_refugi":"081878|CASAL_CIVIC_I_COMUNITARI_SABADELL_CREU_ALTA","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.5608069","longitud":"2.0977664","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Castellar del Vall\xe8s, 224","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-xtm3~wi2r.bw2k",":version":"rv-x3s5.ntzf.q65g",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Can Puiggener","indicador_refugi":"081878|CENTRE_CIVIC_CAN_PUIGGENER","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.56529696","longitud":"2.10405628","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. d\'Archidona, 3, 08208 Sabadell, Barcelona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-9eaz.en4c_zse4",":version":"rv-izb6~hhxw.23jm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Arraona- Merinals","indicador_refugi":"081878|CENTRE_CIVIC_ARRAONA_MERINALS","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.54241845","longitud":"2.09082656","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"2, Pl. del Pla de l\'Amor, 2, 08192 Sabadell, Barcelona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-wk7s_cqti_xtvi",":version":"rv-kc2g~qktw_4xrv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Ponent","indicador_refugi":"081878|BIBLIOTECA_PONENT","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.55626443","longitud":"2.08931708","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. Ovidi Montllor, 5, 08206 Sabadell, Barcelona","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-acyd-hi7d-8md8",":version":"rv-pdtu-af9b~h5zs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Central","indicador_refugi":"081878|PARC_CENTRAL","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.52085749","longitud":"2.11202027","accessibilitat":"S\xed","aigua":"No","area_descans":"No","adreca":"Torrent, 101, 25, 08210 Barber\xe0 del Vall\xe8s, Barcelona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-qja2.myyh.zmf5",":version":"rv-rk4b~yvrk.58bu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Ca N\'oriach","indicador_refugi":"081878|PISCINA_CA_N_ORIACH","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.57050706","longitud":"2.09283615","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"No","adreca":"Rbla. Navacerrada","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-e2p3~ucyk~29qa",":version":"rv-k4xv.d24g.x4iu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblitoteca Vapor Badia","indicador_refugi":"081878|BIBLITOTECA_VAPOR_BADIA","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.54673674","longitud":"2.114503","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de les Tres Creus, 127, 129, 08202 Sabadell, Barcelona","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-m44e~icq6~aecg",":version":"rv-cdt9_885e_xjpb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Sabadell - Rogelio Soto","indicador_refugi":"081878|CASAL_CIVIC_I_COMUNITARI_SABADELL_ROGELIO_SOTO","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.526220950776725","longitud":"2.1104523914554654","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Campoamor, 93-95","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-q9pk~34h3.9u79",":version":"rv-y459_ydcd_a3qp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Gr\xe0cia","indicador_refugi":"081878|CENTRE_CIVIC_GRACIA","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.53749453","longitud":"2.10271543","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. del Treball, 1","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-w5z2~9ze8~zczd",":version":"rv-uibb_tgbn-44yw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Can Rull","indicador_refugi":"081878|CENTRE_CIVIC_CAN_RULL","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.55390728","longitud":"2.08482378","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de Sant Isidor, 51, 08206 Sabadell, Barcelona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-wki2.npt2~gmga",":version":"rv-qim2.3p7g_h8bk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Sabadell - Creu de barber\xe0","indicador_refugi":"081878|CASAL_CIVIC_I_COMUNITARI_SABADELL_CREU_DE_BARBERA","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.5260842","longitud":"2.113916","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de la Verge de la Paloma, 19-21 (cant. C. Salvat Papasse\xeft, 65)","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-jmnw_xf2k~35jy",":version":"rv-6q3y-vkgn_esib",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Creu Alta","indicador_refugi":"081878|CENTRE_CIVIC_CREU_ALTA","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.55581467","longitud":"2.1025735","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Ctra. de Prats de Llu\xe7an\xe8s, 2, 08208 Sabadell, Barcelona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-ndig_s96u~3qjr",":version":"rv-xpm4-nu2i.ypsu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Sant Oleguer","indicador_refugi":"081878|CENTRE_CIVIC_SANT_OLEGUER","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.53760993","longitud":"2.11897008","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de Sol i Padr\xeds, 93","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-q5ut~4s2v_w78c",":version":"rv-nkcz-tif5.x787",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Can Llong-Castellarnau","indicador_refugi":"081878|CENTRE_CIVIC_CAN_LLONG_CASTELLARNAU","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.56178262","longitud":"2.08315404","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Av. d\'Estrasburg, 82, 08206 Sabadell, Barcelona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-8sjz~u25z-b32i",":version":"rv-9epx-pj9z~nk6u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Torre-romeu","indicador_refugi":"081878|CENTRE_CIVIC_TORRE_ROMEU","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.54993436","longitud":"2.12547805","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. de Montcort\xe8s, 1","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-uqne_z6zi.fcar",":version":"rv-iufx-crbs.3g4r",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Nord","indicador_refugi":"081878|BIBLIOTECA_NORD","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.57099445","longitud":"2.09143437","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Rda. de Navacerrada, 60, 08207 Sabadell, Barcelona","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-8yxt.ix6r.mng8",":version":"rv-274u-fzg3~jkk4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Taul\xed","indicador_refugi":"081878|PARC_TAULI","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.55646607","longitud":"2.11228518","accessibilitat":"S\xed","aigua":"No","area_descans":"No","adreca":"C. del Vidal","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-c9ah.u7ts~4npf",":version":"rv-tpng.j5cw-7bun",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Campoamor","indicador_refugi":"081878|PISCINA_CAMPOAMOR","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.52536709","longitud":"2.11198894","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Pardo Baz\xe1n, 17, 08204 Sabadell, Barcelona","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-6x8k~yvcb_ftw7",":version":"rv-b8gr_snf7~2yac",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Odessa","indicador_refugi":"081878|PARC_ODESSA","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.56243998","longitud":"2.07959383","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Av. d\'Estrasburg, 112, 08206 Sabadell, Barcelona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-jv7q-mbmn_36bm",":version":"rv-vujc.i642_yqax",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Can Gamb\xfas","indicador_refugi":"081878|PARC_CAN_GAMBUS","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.54763559","longitud":"2.0808544","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. del Kurdistan, s/n, 08205 Sabadell, Barcelona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-jeht.fr8v.wwm3",":version":"rv-g6fq_q8ii_4hi7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Sabadell - Casal","indicador_refugi":"081878|CASAL_CIVIC_I_COMUNITARI_SABADELL_CASAL","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.547914","longitud":"2.1082504","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Sant Josep, 22","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-7uwi~64dm~66v9",":version":"rv-hnm8~nr2t~k8he",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Poblenou","indicador_refugi":"081878|CENTRE_CIVIC_POBLENOU","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.56122268","longitud":"2.1301371","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. del Remei, 1-9","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-y6es-7hbi-mmrt",":version":"rv-2ia5.yw9x-xisg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CENTRE C\xcdVIC DE CA N\'ORIAC","indicador_refugi":"081878|CENTRE_CIVIC_DE_CA_NORIAC","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.56510654979748","longitud":"2.0940159512475223","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/Arousa, 2 08207 sabadell","informacio_web":"https://web.sabadell.cat/","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-05T14:35:00.000"},{":id":"row-8ep8-u69z.m5n2",":version":"rv-fccw.u2zg_xfx7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"BIBLIOTECA SAFAREIGS","indicador_refugi":"081878|BIBLIOTECA_SAFAREIGS","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.55447348660388","longitud":"2.1011141230548565","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/Papa Pius XI, 165 Sabadell","informacio_web":"https://web.sabadell.cat/","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-05T16:24:00.000"},{":id":"row-srjn_jcem_jp6n",":version":"rv-ra3c-9egs-9f2q",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"BIBLIOTECA CAN PUIGGENER","indicador_refugi":"081878|BIBLIOTECA_CAN_PUIGGENER","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.56517021730269","longitud":"2.1040419960723997","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Primer de Maig , 1 Sabadell","informacio_web":"https://web.sabadell.cat/","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-05T16:27:00.000"},{":id":"row-rxpd-t35p_hnuv",":version":"rv-mnq6~iw4q_fie2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PISCINA OLIMPIA","indicador_refugi":"081878|PISCINA_OLIMPIA","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.556388367501185","longitud":"2.092877367235714","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de l\'Ap\xfalia, 40, 08206 Sabadell, Barcelona","informacio_web":"https://web.sabadell.cat/","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-05T16:30:00.000"},{":id":"row-d3z3~23sv~x4s6",":version":"rv-h48i.n94b_7msh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PARC DE LES AIG\xdcES","indicador_refugi":"081878|PARC_DE_LES_AIGUES","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.561380311280395","longitud":"2.0828840591224385","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"08206 Sabadell, Barcelona","informacio_web":"https://web.sabadell.cat/","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-05T16:35:00.000"},{":id":"row-aack~pu9c_69nv",":version":"rv-dvqc.ri3j-dg95",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PLA\xc7A DE GERNIKA","indicador_refugi":"081878|PLACA_DE_GERNIKA","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.5587495784414","longitud":"2.0848125577084256","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"08206 Sabadell, Barcelona","informacio_web":"https://web.sabadell.cat/","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-05T16:41:00.000"},{":id":"row-qbuq-ijij-3fr3",":version":"rv-92hw.uepd~cuvb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PARC DEL NORD","indicador_refugi":"081878|PARC_DEL_NORD","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.57246277785154","longitud":"2.0870409196526936","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Feliu Elias, 5, 08207 Sabadell, Barcelona","informacio_web":"https://web.sabadell.cat/","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-05T16:49:00.000"},{":id":"row-guq8~gj59_2h3k",":version":"rv-hgi4.23zq-ie9g",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"JOCS INFANTILS D\'AIGUA PARC DE LES AIG\xdcES","indicador_refugi":"081878|JOCS_INFANTILS_DAIGUA_PARC_DE_LES_AIGUES","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.559462248114656","longitud":"2.086289182580513","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. d\'Estrasburg, 81, 08206 Sabadell, Barcelona","informacio_web":"https://web.sabadell.cat/","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-05T17:03:00.000"},{":id":"row-bwa4.g5rt.iedp",":version":"rv-55zu.7x27_zrfx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"COMPLEX ALEXANDRA PER A LA GENT GRAN","indicador_refugi":"081878|COMPLEX_ALEXANDRA_PER_A_LA_GENT_GRAN","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.556265983319925","longitud":"2.089300653744132","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Ovidi Montllor, 3, 08206 Sabadell, Barcelona","informacio_web":"https://www.sabadell.cat/","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-05T17:15:00.000"},{":id":"row-d5bz.qc6q_qqpc",":version":"rv-wxw7~qgft-cdxc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"COMPLEX PARC DENTRAL PER A LA GENT GRAN","indicador_refugi":"081878|COMPLEX_PARC_DENTRAL_PER_A_LA_GENT_GRAN","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.52326963186867","longitud":"2.113878211414407","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Diego de Almagro, 44, 08204 Sabadell, Barcelona","informacio_web":"https://www.sabadell.cat/","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-05T17:17:00.000"},{":id":"row-est3_6r82-p7g8",":version":"rv-pyyn~2rwx~bpry",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"COMPLEX GENT GRAN SANT OLEGUER","indicador_refugi":"081878|COMPLEX_GENT_GRAN_SANT_OLEGUER","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.53866164547575","longitud":"2.1177595711735995","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"c. de Sol i Padr\xeds, 56","informacio_web":"https://www.sabadell.cat/","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-05T17:25:00.000"},{":id":"row-wbmg.hs9n_q3s7",":version":"rv-2nzx-swmc.jtan",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CENTRE C\xcdVIC DR J.M.PLANS","indicador_refugi":"081878|CENTRE_CIVIC_DR_JMPLANS","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.57577669973758","longitud":"2.0861911115938168","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/Portal de la Floresta, 20 08207 Sabadell","informacio_web":"https://web.sabadell.cat/","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-05T17:41:00.000"},{":id":"row-it26_tweb~rvup",":version":"rv-qnk2_64vc~hhc8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"MERCAT DE SANT JOAN","indicador_refugi":"081878|MERCAT_DE_SANT_JOAN","municipi":"Sabadell","codi_municipi":"081878","latitud":"41.54211359802911","longitud":"2.114861279644231","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. Sant Joan, 1A, 08202 Sabadell, Barcelona","informacio_web":"https://web.sabadell.cat/","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-05T18:05:00.000"},{":id":"row-w5rz.bbjj-2px6",":version":"rv-vevh.vqbj-uje2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Sallent - Verge de Fussimanya","indicador_refugi":"081918|CASAL_CIVIC_I_COMUNITARI_SALLENT_VERGE_DE_FUSSIMANYA","municipi":"Sallent","codi_municipi":"081918","latitud":"41.8263045","longitud":"1.8921835","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Serraima, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-gccq_dgue~hcd8",":version":"rv-jvs5~uyfj.d4wb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Sallent - Casal","indicador_refugi":"081918|CASAL_CIVIC_I_COMUNITARI_SALLENT_CASAL","municipi":"Sallent","codi_municipi":"081918","latitud":"41.8247121","longitud":"1.8917479","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Santa Cristina, 2","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-yta7-2873~4uea",":version":"rv-6wgr-bxf9.vrca",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la ciutat","indicador_refugi":"439057|PARC_DE_LA_CIUTAT","municipi":"Salou","codi_municipi":"439057","latitud":"41.07306655","longitud":"1.14778466","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Carles Buigas","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-isk5_nkkh-6u2q",":version":"rv-mqr9_ejq2-cnfi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Bonet","indicador_refugi":"439057|PLACA_BONET","municipi":"Salou","codi_municipi":"439057","latitud":"41.07608943","longitud":"1.13249548","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Barcelona","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-uanz_8qpf-5b49",":version":"rv-6ry8_3e9q~frik",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Arbreda carrer Tauste","indicador_refugi":"439057|ARBREDA_CARRER_TAUSTE","municipi":"Salou","codi_municipi":"439057","latitud":"41.0769993","longitud":"1.12875103","accessibilitat":"S\xed","aigua":"No","area_descans":"No","adreca":"C. Tauste","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-ejij-2ayn-vhgq",":version":"rv-t7xb.ctup.3twb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins Platja De Llevant","indicador_refugi":"439057|JARDINS_PLATJA_DE_LLEVANT","municipi":"Salou","codi_municipi":"439057","latitud":"41.07454666","longitud":"1.13617815","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. Jaume I, entre el Passeig i la Platja de Llevant","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-kxdd_rnxe~sgne",":version":"rv-ppim~exyf_siv4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Manel Albinyana","indicador_refugi":"439057|PARC_MANEL_ALBINYANA","municipi":"Salou","codi_municipi":"439057","latitud":"41.08375824","longitud":"1.13546259","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Tarragona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-ttgy-8hvg-gbim",":version":"rv-yfpq-rv7x.nyr2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Salt - les Bernardes","indicador_refugi":"171557|CASAL_CIVIC_I_COMUNITARI_SALT_LES_BERNARDES","municipi":"Salt","codi_municipi":"171557","latitud":"41.9759048","longitud":"2.7885998","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de la Diputaci\xf3, 2","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-36is.jsst~87jf",":version":"rv-iyvc-nm24.54mj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament","indicador_refugi":"251919|AJUNTAMENT","municipi":"Sana\xfcja","codi_municipi":"251919","latitud":"41.87578406","longitud":"1.30957784","accessibilitat":"No","aigua":"No","area_descans":"S\xed","adreca":"C. Bassal, 4","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-7s48.ew5v_kmkc",":version":"rv-b55k-qpjq-7iz8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal social","indicador_refugi":"251919|CASAL_SOCIAL","municipi":"Sana\xfcja","codi_municipi":"251919","latitud":"41.87544756","longitud":"1.30978867","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. del Bassal, 22, 25753 Sana\xfcja, Lleida","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-39ug~yy89_m5ur",":version":"rv-n84z.j92f_nvmj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa de la Vila","indicador_refugi":"081957|CASA_DE_LA_VILA","municipi":"Sant Agust\xed de Llu\xe7an\xe8s","codi_municipi":"081957","latitud":"42.09384278720021","longitud":"2.1309436732147278","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Alou, 4 Sant Agust\xed de Llu\xe7an\xe8s","informacio_web":"https://www.santagustidellucanes.cat/","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-22T10:52:00.000"},{":id":"row-wkcf_h36t-bjx4",":version":"rv-mec9~4sxa-5hzd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal jove - Can Rivi\xe8re","indicador_refugi":"081976|CASAL_JOVE_CAN_RIVIERE","municipi":"Sant Andreu de Llavaneres","codi_municipi":"081976","latitud":"41.57213754","longitud":"2.4846893","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Mare de D\xe9u de Montserrat, 45","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-qj75-rrza_g4jb",":version":"rv-rymx.wnhx~q3pp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Font i Daniel","indicador_refugi":"081976|BIBLIOTECA_FONT_I_DANIEL","municipi":"Sant Andreu de Llavaneres","codi_municipi":"081976","latitud":"41.57455747","longitud":"2.48118366","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Cl\xf2sens, 65","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-efqi_dme8~7a5s",":version":"rv-cdi2.mcwu-n3yc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala de plens de l\'ajuntament","indicador_refugi":"081976|SALA_DE_PLENS_DE_L_AJUNTAMENT","municipi":"Sant Andreu de Llavaneres","codi_municipi":"081976","latitud":"41.57467051","longitud":"2.48337001","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de la Vila, 1","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-88ak~nr2i~ctdu",":version":"rv-qthi_ppea-syxz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal gent gran","indicador_refugi":"081976|CASAL_GENT_GRAN","municipi":"Sant Andreu de Llavaneres","codi_municipi":"081976","latitud":"41.57323783","longitud":"2.48472453","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Mare de D\xe9u de Montserrat, 35","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-jk33_nhtu.q3ta",":version":"rv-9x5u~xm93_wzg2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Font L\xfadica del Parc de Can Sauleda","indicador_refugi":"081982|FONT_LUDICA_DEL_PARC_DE_CAN_SAULEDA","municipi":"Sant Antoni de Vilamajor","codi_municipi":"081982","latitud":"41.63860856","longitud":"2.37394644","accessibilitat":"No","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Llinars, 325","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-w8sp~fkjc.krhs",":version":"rv-3qw5-d8kw_tiwx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la gent gran Can Monteys","indicador_refugi":"081982|CASAL_DE_LA_GENT_GRAN_CAN_MONTEYS","municipi":"Sant Antoni de Vilamajor","codi_municipi":"081982","latitud":"41.6718207","longitud":"2.40120421","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Fran\xe7a, 26","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-r7qs.4rxh~8x32",":version":"rv-ec88_grvb.6ghr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Joana Raspall i Juanola","indicador_refugi":"081982|BIBLIOTECA_JOANA_RASPALL_I_JUANOLA","municipi":"Sant Antoni de Vilamajor","codi_municipi":"081982","latitud":"41.67403588","longitud":"2.40262079","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Pau Casals, 41","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-qw3u.3kh7~jemu",":version":"rv-3c3k_mvdw-j4kh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"082016|PISCINA_MUNICIPAL","municipi":"Sant Boi de Llu\xe7an\xe8s","codi_municipi":"082016","latitud":"42.05977297","longitud":"2.15315535","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Zona esportiva municipal","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-ertg_4q6f-3qvh",":version":"rv-hknp~6d7w.g4vk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Refugi clim\xe0tic","indicador_refugi":"082037|REFUGI_CLIMATIC","municipi":"Sant Cebri\xe0 de Vallalta","codi_municipi":"082037","latitud":"41.618484","longitud":"2.596987","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"08397","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T12:46:00.000"},{":id":"row-geh2_pdjw_meiw",":version":"rv-bpgs.xwqg_tjjd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca l\'Escorxador","indicador_refugi":"082021|BIBLIOTECA_LESCORXADOR","municipi":"Sant Celoni","codi_municipi":"082021","latitud":"41.6926","longitud":"2.4913","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Passeig de Rectoria Vella 10","informacio_web":"juliol i agost: dimecres i divendres de 9.30 a 13.30 h  i de dilluns a dijous de 15 a 20 h","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-21T10:54:00.000"},{":id":"row-d474~gr7g.6qzk",":version":"rv-idq6~gxw5_pqa7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sax Sala","indicador_refugi":"082021|SAX_SALA","municipi":"Sant Celoni","codi_municipi":"082021","latitud":"41.6845","longitud":"2.486","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Montserrat, 28","informacio_web":"https://santceloni.cat/area.php?id=34","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-21T10:59:00.000"},{":id":"row-fhkf.kt2v-5vpg",":version":"rv-iva9.pinj~xkdu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de gent gran","indicador_refugi":"082021|CASAL_DE_GENT_GRAN","municipi":"Sant Celoni","codi_municipi":"082021","latitud":"41.6864","longitud":"2.4898","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Ponent 9","informacio_web":"De dilluns a divendres  de 9 a 12 i de 15 a 19 h Dissabtes de 9 a 12 h","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-21T11:08:00.000"},{":id":"row-vw28~jjnu_axby",":version":"rv-rz29_8f54~48ty",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Associaci\xf3 ve\xefns Illes Belles","indicador_refugi":"082021|ASSOCIACIO_VEINS_ILLES_BELLES","municipi":"Sant Celoni","codi_municipi":"082021","latitud":"41.6889","longitud":"2.4968","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"carrer Girona, 26","informacio_web":"Juliol i agost:  Tardes de dilluns, dimecres i divendres","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-21T11:16:00.000"},{":id":"row-tkt6-uk3b_nja4",":version":"rv-vd3z.ymvb_922w",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"associaci\xf3 de Ve\xefns Les Borrelles","indicador_refugi":"082021|ASSOCIACIO_DE_VEINS_LES_BORRELLES","municipi":"Sant Celoni","codi_municipi":"082021","latitud":"41.6934","longitud":"2.5031","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Bisbe Irurita, 4","informacio_web":"Juliol i agost:  Tardes de dilluns, dimecres i divendres","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-21T11:23:00.000"},{":id":"row-efg5_y7nk-n63r",":version":"rv-42qx.n73m.ybx8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal gent gran La Batll\xf2ria","indicador_refugi":"082021|CASAL_GENT_GRAN_LA_BATLLORIA","municipi":"Sant Celoni","codi_municipi":"082021","latitud":"41.7185","longitud":"2.5478","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"carrer Major, 31","informacio_web":"Tardes de dilluns a divendres de 17 a 20 h","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-21T11:27:00.000"},{":id":"row-58t5.pr7q~wyvm",":version":"rv-nce5~yqr5_4wjr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Uni\xf3 Batllorienca","indicador_refugi":"082021|UNIO_BATLLORIENCA","municipi":"Sant Celoni","codi_municipi":"082021","latitud":"41.7186","longitud":"2.5476","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"carrer Breda, 2 La Batll\xf2ria (Sant Celoni)","informacio_web":"Juliol i agost: de dilluns a  divendres de 10 a 14 h","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-21T11:31:00.000"},{":id":"row-vgsk~brnr~6raj",":version":"rv-n5rk_jq8v~aqmq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Font Pudosa","indicador_refugi":"171582|FONT_PUDOSA","municipi":"Sant Climent Sescebes","codi_municipi":"171582","latitud":"42.36531384","longitud":"2.97985351","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"No","adreca":"\xc0rea de picnic Font Pudosa","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-7hbm-bwbv_3cc5",":version":"rv-gwi7-7tqi~m4hc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de l\'Ajuntament","indicador_refugi":"082080|JARDINS_DE_LAJUNTAMENT","municipi":"Sant Esteve Sesrovires","codi_municipi":"082080","latitud":"41.49274642719316","longitud":"1.8751126541835805","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Cantonada Carrer Martorell amb Carrer de l\'Alba","informacio_web":"https://www.sesrovires.cat/","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-06T13:07:00.000"},{":id":"row-9368.2vsr~jbza",":version":"rv-kvd7~8v42~ajq5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament de Sant Esteve Sesrovires","indicador_refugi":"082080|AJUNTAMENT_DE_SANT_ESTEVE_SESROVIRES","municipi":"Sant Esteve Sesrovires","codi_municipi":"082080","latitud":"41.493168307494315","longitud":"1.8744155175014519","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Major, 6-8 - 08635 Sant Esteve Sesrovires","informacio_web":"https://www.sesrovires.cat/actualitat/noticies/lajuntament-activa-el-pla-de-proteccio-civil-municipal-davant-el-risc-extrem-dincendi-forestal-i-lonada-de-calor.html","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-07T08:49:00.000"},{":id":"row-7hjd_39bp.pbxc",":version":"rv-tjzj~2ptn_7d45",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Municipal","indicador_refugi":"082080|BIBLIOTECA_MUNICIPAL","municipi":"Sant Esteve Sesrovires","codi_municipi":"082080","latitud":"41.49448026175397","longitud":"1.8732244910227869","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda Montserrat, 10 - 08635 Sant Esteve Sesrovires","informacio_web":"https://www.sesrovires.cat/actualitat/noticies/lajuntament-activa-el-pla-de-proteccio-civil-municipal-davant-el-risc-extrem-dincendi-forestal-i-lonada-de-calor.html","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-07T08:50:00.000"},{":id":"row-5eec-yzw9~s8ny",":version":"rv-ccmp~vpxy.sk58",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pista Coberta Francesc Castellet","indicador_refugi":"082080|PISTA_COBERTA_FRANCESC_CASTELLET","municipi":"Sant Esteve Sesrovires","codi_municipi":"082080","latitud":"41.495011368068475","longitud":"1.8707073480075442","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Passatge Oliveres, S/N - 08635 Sant Esteve Sesrovires","informacio_web":"https://www.sesrovires.cat/actualitat/noticies/lajuntament-activa-el-pla-de-proteccio-civil-municipal-davant-el-risc-extrem-dincendi-forestal-i-lonada-de-calor.html","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-07T08:53:00.000"},{":id":"row-cqsp-3unr-63wm",":version":"rv-snpv_c39n~6gwd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal Solanes","indicador_refugi":"082107|PISCINA_MUNICIPAL_SOLANES","municipi":"Sant Feliu de Codines","codi_municipi":"082107","latitud":"41.68439546","longitud":"2.15096336","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Muntanya Solanes, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-5fzf~9sic_5p3f",":version":"rv-s7ry~qtwx-da9z",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic \\"La Fonteta\\"","indicador_refugi":"082107|CENTRE_CIVIC_LA_FONTETA","municipi":"Sant Feliu de Codines","codi_municipi":"082107","latitud":"41.68799414","longitud":"2.1626238","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Josep Umbert Ros\xe0s, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-sea6-kmph.pixa",":version":"rv-ctzc~zd66.feyi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal municipal de la Gent Gran","indicador_refugi":"082107|CASAL_MUNICIPAL_DE_LA_GENT_GRAN","municipi":"Sant Feliu de Codines","codi_municipi":"082107","latitud":"41.6894162","longitud":"2.16485796","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. de la Generalitat, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-hckd-66hy.s98s",":version":"rv-9mky~aqs6~rqef",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal Joan Petit i Aguilar","indicador_refugi":"082107|BIBLIOTECA_MUNICIPAL_JOAN_PETIT_I_AGUILAR","municipi":"Sant Feliu de Codines","codi_municipi":"082107","latitud":"41.68894231","longitud":"2.16442913","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Josep Umbert Ventura, 3, 08182 Sant Feliu de Codines, Barcelona","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-52im~dfm8.g82q",":version":"rv-gnfb_nx9u_7qxc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Complex Poliesportiu municipal","indicador_refugi":"082107|COMPLEX_POLIESPORTIU_MUNICIPAL","municipi":"Sant Feliu de Codines","codi_municipi":"082107","latitud":"41.69526099","longitud":"2.16579226","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ronda dels Esports, s/n","tipologia":"Poliesportiu","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-sp4t.jje6.4dcp",":version":"rv-zbnn.8ncr-7syn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala de Plens de L\'Ajuntament","indicador_refugi":"082107|SALA_DE_PLENS_DE_LAJUNTAMENT","municipi":"Sant Feliu de Codines","codi_municipi":"082107","latitud":"41.683","longitud":"2.161","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Josep Umbert Ventura, 2, 08182 Sant Feliu de Codines, Barcelona","informacio_web":"https://www.santfeliudecodines.cat/","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-29T09:34:00.000"},{":id":"row-ak9t_4ney_wavj",":version":"rv-zea2_hqgr-xrmw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Can Xifreda i de la Font dels \xc0lbers","indicador_refugi":"082107|PARC_DE_CAN_XIFREDA_I_DE_LA_FONT_DELS_ALBERS","municipi":"Sant Feliu de Codines","codi_municipi":"082107","latitud":"41.6863","longitud":"2.1629","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Passatge Martina, 9, 08182 Sant Feliu de Codines, Barcelona","informacio_web":"https://www.santfeliudecodines.cat/turisme/parcs-places-i-espais-verds/parc-municipal-can-xifreda.html","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-29T10:11:00.000"},{":id":"row-trf9~zu39~zwyf",":version":"rv-qsxe-z7r2~vdwe",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Tueda","indicador_refugi":"171609|CENTRE_CIVIC_TUEDA","municipi":"Sant Feliu de Gu\xedxols","codi_municipi":"171609","latitud":"41.7845300718789","longitud":"3.03560011290495","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Gravina, 39-41 - 17220 Sant Feliu de Gu\xedxols","informacio_web":"Tueda@guixols.cat 972 82 10 58 De diumenge a divendres de 8 a 20h","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-02T12:25:00.000"},{":id":"row-y5kj_p26t-m8uf",":version":"rv-v99z_rmtd~s6cq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Vilartagues","indicador_refugi":"171609|CENTRE_CIVIC_VILARTAGUES","municipi":"Sant Feliu de Gu\xedxols","codi_municipi":"171609","latitud":"41.7920261549428","longitud":"3.02472399993368","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a de Salvador Espriu s/n - 17220 Sant Feliu de Gu\xedxols","informacio_web":"ccv@guixols.cat 972 82 01 01 De dilluns a divendres de 8 a 21h i Dissabtes i diumenges de 9 a 19:00h","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-02T12:27:00.000"},{":id":"row-xd8c_bjxv_9x47",":version":"rv-wub5-sjxh.kgqq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca P\xfablica Octavi Viader i Margarit","indicador_refugi":"171609|BIBLIOTECA_PUBLICA_OCTAVI_VIADER_I_MARGARIT","municipi":"Sant Feliu de Gu\xedxols","codi_municipi":"171609","latitud":"41.7839057723951","longitud":"3.02696185048643","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Joan Sur\xeds, 28-34 - 17220 Sant Feliu de Gu\xedxols","informacio_web":"biblioteca@guixols.cat 972 32 40 57 De dilluns a divendres de 10 a 13h i de 15 a 19h. Dissabtes, de 10 a 13h","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-02T12:28:00.000"},{":id":"row-u5w4_7848.b2x2",":version":"rv-pdiw.zqxb.uawj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins Juli Garreta","indicador_refugi":"171609|JARDINS_JULI_GARRETA","municipi":"Sant Feliu de Gu\xedxols","codi_municipi":"171609","latitud":"41.781286180399","longitud":"3.0327378687240594","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Crist\xf2fol Colom - 17220 Sant Feliu de Gu\xedxols","informacio_web":"Horari indefinit","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-02T12:31:00.000"},{":id":"row-dnyi_h6ti.72k4",":version":"rv-weg6.ivmz.ppgj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Platja de Sant Feliu de Gu\xedxols","indicador_refugi":"171609|PLATJA_DE_SANT_FELIU_DE_GUIXOLS","municipi":"Sant Feliu de Gu\xedxols","codi_municipi":"171609","latitud":"41.7794300549625","longitud":"3.0297659811095654","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Sant Pere, 4 - 17220 Sant Feliu de Gu\xedxols","informacio_web":"Horari indefinit","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-02T12:32:00.000"},{":id":"row-nqaz~us8t_rwrh",":version":"rv-tyv7~ypg2-2xn3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat Municipal de Sant Feliu de Gu\xedxols","indicador_refugi":"171609|MERCAT_MUNICIPAL_DE_SANT_FELIU_DE_GUIXOLS","municipi":"Sant Feliu de Gu\xedxols","codi_municipi":"171609","latitud":"41.78079658269786","longitud":"3.0293753970401904","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a del Mercat - 17220 Sant Feliu de Gu\xedxols","informacio_web":"De dimarts a diumenge de 9 a 14h","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-02T12:34:00.000"},{":id":"row-naz8-dxmd-a8fb",":version":"rv-ejkr~j6ex_sxrk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Central","indicador_refugi":"171609|PARC_CENTRAL","municipi":"Sant Feliu de Gu\xedxols","codi_municipi":"171609","latitud":"41.7874914634843","longitud":"3.02847351103452","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Sant Bonaventura, 57, 17220 Sant Feliu de Gu\xedxols","informacio_web":"Horari Indefinit","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-02T12:36:00.000"},{":id":"row-dq4c~wpxc_ti8b",":version":"rv-2ygp-g7d6-xjrg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins del monestir","indicador_refugi":"171609|JARDINS_DEL_MONESTIR","municipi":"Sant Feliu de Gu\xedxols","codi_municipi":"171609","latitud":"41.77990850437629","longitud":"3.027325857867621","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"No","lavabo":"No","adreca":"Pla\xe7a del Monestir, 17220 Sant Feliu de Gu\xedxols","informacio_web":"Sempre que hi hagin activitats consultar www.guixols.cat","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-02T12:38:00.000"},{":id":"row-tpyg.5aik-iq86",":version":"rv-y2n5_vzvm-889s",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals Sant Feliu Sasserra","indicador_refugi":"082129|PISCINES_MUNICIPALS_SANT_FELIU_SASSERRA","municipi":"Sant Feliu Sasserra","codi_municipi":"082129","latitud":"41.94430608","longitud":"2.0154441","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Zona esportiva Sant Roc","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-2pgh_99ak-hbmx",":version":"rv-fkjq_4cig-xeax",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Social l\'Ateneu","indicador_refugi":"082129|CENTRE_SOCIAL_LATENEU","municipi":"Sant Feliu Sasserra","codi_municipi":"082129","latitud":"41.94507","longitud":"2.02166","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Pas Nou, 8","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T14:02:00.000"},{":id":"row-9xue-6tzc-3tvn",":version":"rv-rm2z_9pjb-xjrf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Sant Pere Almat\xf3","indicador_refugi":"082129|BIBLIOTECA_SANT_PERE_ALMATO","municipi":"Sant Feliu Sasserra","codi_municipi":"082129","latitud":"41.94378","longitud":"2.02278","accessibilitat":"S\xed","aigua":"No","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda Catalunya, 1","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T14:03:00.000"},{":id":"row-62bn~9h93~346x",":version":"rv-qcnm.evu9.gbzz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Sant Gregori","indicador_refugi":"171637|CENTRE_CIVIC_SANT_GREGORI","municipi":"Sant Gregori","codi_municipi":"171637","latitud":"41.99023881","longitud":"2.7602864","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Rocacorba, 2","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-r98t.uurf-6fg5",":version":"rv-er6j_exgv_ynbi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local avis","indicador_refugi":"251924|LOCAL_AVIS","municipi":"Sant Guim de Freixenet","codi_municipi":"251924","latitud":"41.655774","longitud":"1.418365","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Doctor Perell\xf3, 12 baixos","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T10:09:00.000"},{":id":"row-4rtb~b8re.bbth",":version":"rv-qkxa-aej7.wjsf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines Municipals","indicador_refugi":"251924|PISCINES_MUNICIPALS","municipi":"Sant Guim de Freixenet","codi_municipi":"251924","latitud":"41.649459","longitud":"1.421726","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carretera de la Panadella, s/n","informacio_web":"www.santguim.cat","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T10:12:00.000"},{":id":"row-53ik.sz2s.j4af",":version":"rv-kkf7~w58x-p7j4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Oficina de Turisme Can Rovira","indicador_refugi":"171642|OFICINA_DE_TURISME_CAN_ROVIRA","municipi":"Sant Hilari Sacalm","codi_municipi":"171642","latitud":"41.87964847","longitud":"2.50941409","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. del Dr. Robert","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-didu~3iwb_2stk",":version":"rv-ejju.cz2d~gkjh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Soledat Ridaura i Feixas","indicador_refugi":"171642|BIBLIOTECA_SOLEDAT_RIDAURA_I_FEIXAS","municipi":"Sant Hilari Sacalm","codi_municipi":"171642","latitud":"41.92885922","longitud":"2.51205134","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. del Doctor Gravalosa, 4","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-wz8w-abgg.z6pi",":version":"rv-8bfb.vv8t_d7xj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de gent gran de Can Blat","indicador_refugi":"171642|CASAL_DE_GENT_GRAN_DE_CAN_BLAT","municipi":"Sant Hilari Sacalm","codi_municipi":"171642","latitud":"41.87981372","longitud":"2.50915264","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Montsolis, 6-18","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-dyf7-gf6t~mgi2",":version":"rv-svmt_tgzz.3veg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament de Sant Hip\xf2lit de Voltreg\xe0","indicador_refugi":"082153|AJUNTAMENT_DE_SANT_HIPOLIT_DE_VOLTREGA","municipi":"Sant Hip\xf2lit de Voltreg\xe0","codi_municipi":"082153","latitud":"42.01559817","longitud":"2.23649046","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de la Vila, 1","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-n44y_tru4.rhrz",":version":"rv-i29q.jyaj~jbb2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa del Mallol","indicador_refugi":"082153|CASA_DEL_MALLOL","municipi":"Sant Hip\xf2lit de Voltreg\xe0","codi_municipi":"082153","latitud":"42.01703149","longitud":"2.23588554","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. del Mallol, 6","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-6bgj~b9bi.kjsn",":version":"rv-e7k3.brqh~xjk9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Marqu\xe8s de Remisa","indicador_refugi":"082153|BIBLIOTECA_MARQUES_DE_REMISA","municipi":"Sant Hip\xf2lit de Voltreg\xe0","codi_municipi":"082153","latitud":"42.01551748","longitud":"2.23612432","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de la Vinya, 2","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-5f8b.3bb4-2y6s",":version":"rv-ijfy~ncbx-srfy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Alfons Maseras","indicador_refugi":"431378|BIBLIOTECA_ALFONS_MASERAS","municipi":"Sant Jaume dels Domenys","codi_municipi":"431378","latitud":"41.2979244","longitud":"1.5600928","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Germanor, 8","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-2cqa~rsix_a8vb",":version":"rv-p3q7~afqv.yrm5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"431378|PISCINA_MUNICIPAL","municipi":"Sant Jaume dels Domenys","codi_municipi":"431378","latitud":"41.2944072","longitud":"1.5628793","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Marinada, 8","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-2znu_e262.efwh",":version":"rv-srbd-78fj~ccgn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament","indicador_refugi":"082188|AJUNTAMENT","municipi":"Sant Joan de Vilatorrada","codi_municipi":"082188","latitud":"41.74561526","longitud":"1.80546108","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Major, 91-93","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-nmuq-v629_qsc3",":version":"rv-ziiy.ft7p-vnmq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ludoteca","indicador_refugi":"082188|LUDOTECA","municipi":"Sant Joan de Vilatorrada","codi_municipi":"082188","latitud":"41.74425993","longitud":"1.8073214","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pg. Gallifa, 1 baixos","tipologia":"Ludoteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-cake~2fng_kaut",":version":"rv-963s_evxm_xisu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai jove","indicador_refugi":"082188|ESPAI_JOVE","municipi":"Sant Joan de Vilatorrada","codi_municipi":"082188","latitud":"41.74211329","longitud":"1.80206602","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Alzines, 53","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-hyk6-wp67~gmtb",":version":"rv-i6vb_xfjv_9vix",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Sant Joan de Vilatorrada","indicador_refugi":"082188|CASAL_CIVIC_I_COMUNITARI_SANT_JOAN_DE_VILATORRADA","municipi":"Sant Joan de Vilatorrada","codi_municipi":"082188","latitud":"41.743621","longitud":"1.5182089","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. de Gallifa, 8","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-5rwx_9ivj.8vwy",":version":"rv-syj6.y2xh~dkhi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Cal Gallifa","indicador_refugi":"082188|BIBLIOTECA_CAL_GALLIFA","municipi":"Sant Joan de Vilatorrada","codi_municipi":"082188","latitud":"41.74398818","longitud":"1.80717402","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pg. Gallifa, 1","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-gf8c_xd37.9ssq",":version":"rv-e8aj~wzmw~rpwg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Zona esportiva","indicador_refugi":"082188|ZONA_ESPORTIVA","municipi":"Sant Joan de Vilatorrada","codi_municipi":"082188","latitud":"41.75121108","longitud":"1.80323922","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Ctra/ BV-3008 a Calaf, km. 0.3","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-87my-hfn9_i5hb",":version":"rv-5hxi~6ix3-j6de",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CASAL C\xcdVIC DE LA CANYA (LLAR D\'AVIS)","indicador_refugi":"171851|CASAL_CIVIC_DE_LA_CANYA_(LLAR_DAVIS)","municipi":"Sant Joan les Fonts","codi_municipi":"171851","latitud":"42.206","longitud":"2.4954","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda de Les Escoles, 1","informacio_web":"CADA DIA OBERT","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T07:36:00.000"},{":id":"row-kpmf~nsjx_j4xn",":version":"rv-bgab_9gng-h7b2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"BIBLIOTECA MUNICIPAL \\"CASTELL DE JUVINY\xc0\\"","indicador_refugi":"171851|BIBLIOTECA_MUNICIPAL_\\"CASTELL_DE_JUVINYA\\"","municipi":"Sant Joan les Fonts","codi_municipi":"171851","latitud":"42.2131","longitud":"2.5075","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"CARRER JUVINY\xc0, 2","informacio_web":"OBERT DE DILLUNS A DIVENDRES","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T08:06:00.000"},{":id":"row-nq52~2tbd-69iw",":version":"rv-gkxr.93ek.nahc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CASAL CIVIC \\"EL CENTRE\\"","indicador_refugi":"171851|CASAL_CIVIC_\\"EL_CENTRE\\"","municipi":"Sant Joan les Fonts","codi_municipi":"171851","latitud":"42.2131","longitud":"2.5113","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"AV RAFEL TORRAS, 3","informacio_web":"EST\xc0 OBERT CADA DIA","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T08:16:00.000"},{":id":"row-ew87_hzv2_73i7",":version":"rv-6xqe~v9b7-p8z7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"El Polivalent","indicador_refugi":"171668|EL_POLIVALENT","municipi":"Sant Jordi Desvalls","codi_municipi":"171668","latitud":"42.07039443","longitud":"2.95344764","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. DR. Joher, s/n","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-a8zp-mfg3~b9w6",":version":"rv-38p5-mtwg~gde5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala Nova","indicador_refugi":"171668|SALA_NOVA","municipi":"Sant Jordi Desvalls","codi_municipi":"171668","latitud":"42.07244521","longitud":"2.95134898","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Francesc Maci\xe0, 3","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-47mq-hvhx-x6zj",":version":"rv-xi5t-h8g4.ku6g",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bar El Social","indicador_refugi":"171668|BAR_EL_SOCIAL","municipi":"Sant Jordi Desvalls","codi_municipi":"171668","latitud":"42.07150128","longitud":"2.95327246","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Dr. Messeguer, s/n","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-heqi~dwea~eym7",":version":"rv-u59n_cabw-3rd2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CAN BURCET","indicador_refugi":"171668|CAN_BURCET","municipi":"Sant Jordi Desvalls","codi_municipi":"171668","latitud":"42.071949","longitud":"2.951407","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"No","adreca":"CARRER FRANCESC MACI\xc0, 4","informacio_web":"https://santjordidesvalls.cat/","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T12:09:00.000"},{":id":"row-ur8s-62s5_hvbj",":version":"rv-cijm-jhkr-k29k",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"AULA DE LECTURA MODEST PRATS DE MEDINY\xc0","indicador_refugi":"171693|AULA_DE_LECTURA_MODEST_PRATS_DE_MEDINYA","municipi":"Sant Juli\xe0 de Ramis","codi_municipi":"171693","latitud":"42.04828721594297","longitud":"2.865864189101684","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"CARRER SANT SADURN\xcd S.N.","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-03T12:22:00.000"},{":id":"row-7h5p.q7xg_5u5u",":version":"rv-4q6v-xvcn-jwy3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic de Bonmat\xed","indicador_refugi":"179032|CENTRE_CIVIC_DE_BONMATI","municipi":"Sant Juli\xe0 del Llor i Bonmat\xed","codi_municipi":"179032","latitud":"41.96874","longitud":"2.67028","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"c/ Ipso Lauro, 12 Sant Juli\xe0 del Llor i Bonmat\xed","informacio_web":"https://stjuliabonmati.cat/guia-del-poble/equipaments-publics-2/centre-civic-bonmati/    ( dimarts tancat)","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-03T12:18:00.000"},{":id":"row-hug8~8jvt.mpzt",":version":"rv-n8mb_gt3s-whgh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Gimn\xe0s municipal","indicador_refugi":"251930|GIMNAS_MUNICIPAL","municipi":"Sant Lloren\xe7 de Morunys","codi_municipi":"251930","latitud":"42.13350028","longitud":"1.5914873","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Creueta, s/n","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-2t5y_iddy~xpry",":version":"rv-krk5-6hht_v7sd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La Bassa Gran","indicador_refugi":"082227|LA_BASSA_GRAN","municipi":"Sant Lloren\xe7 d\'Hortons","codi_municipi":"082227","latitud":"41.470025","longitud":"1.824378","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de la Bassa Gran, s/n","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-6jhy_ar2z~cctg",":version":"rv-ykia-3mbx.k6ic",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre cultural Joana Raspall","indicador_refugi":"082227|CENTRE_CULTURAL_JOANA_RASPALL","municipi":"Sant Lloren\xe7 d\'Hortons","codi_municipi":"082227","latitud":"41.46847852","longitud":"1.82239988","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Generalitat, 47","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-4wkc~rcsu~dggj",":version":"rv-yqke-w5wk-zvif",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Cal Sant Just","indicador_refugi":"082227|PARC_DE_CAL_SANT_JUST","municipi":"Sant Lloren\xe7 d\'Hortons","codi_municipi":"082227","latitud":"41.46587216","longitud":"1.81948605","accessibilitat":"No","aigua":"S\xed","area_descans":"No","adreca":"Rda. de la font, 28","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-74ne_sygx-aqwv",":version":"rv-nbjh~t9td_7ikt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Marimon Llan\xe7a","indicador_refugi":"082227|PLACA_MARIMON_LLANCA","municipi":"Sant Lloren\xe7 d\'Hortons","codi_municipi":"082227","latitud":"41.4681409","longitud":"1.82529677","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Marimon Llan\xe7a","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-qv9n.yvia~sgib",":version":"rv-2emu~e9jh_qrn3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Petits Caramellaires","indicador_refugi":"082227|PLACA_PETITS_CARAMELLAIRES","municipi":"Sant Lloren\xe7 d\'Hortons","codi_municipi":"082227","latitud":"41.465517","longitud":"1.826094","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"No","lavabo":"No","adreca":"Rda. de la Pagesia, 27","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-23T14:10:00.000"},{":id":"row-9mb5.zf5p~p99a",":version":"rv-j3at~5ihi~7mxe",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la gent gran","indicador_refugi":"082233|CASAL_DE_LA_GENT_GRAN","municipi":"Sant Lloren\xe7 Savall","codi_municipi":"082233","latitud":"41.68019658","longitud":"2.05861125","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Canig\xf3, 17","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-hswt-ksfs-wk3c",":version":"rv-q76e-jrcc.minb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pista poliesportiva coberta","indicador_refugi":"082251|PISTA_POLIESPORTIVA_COBERTA","municipi":"Sant Mart\xed d\'Albars","codi_municipi":"082251","latitud":"42.02841322","longitud":"2.07383373","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"No","adreca":"Zona esportiva del nucli de Sant Mart\xed d\'Albars","tipologia":"Poliesportiu","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-r6cg-x47s_9zdn",":version":"rv-rq7z-nwkm-emtm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pavell\xf3 de Llor\xe0","indicador_refugi":"171729|PAVELLO_DE_LLORA","municipi":"Sant Mart\xed de Ll\xe9mena","codi_municipi":"171729","latitud":"42.02250822005497","longitud":"2.702606160694001","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de la Fontanella, 130B, 17152 Llor\xe0, Girona","informacio_web":"https://smartillemena.cat/","tipologia":"Pavell\xf3 Esportiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T12:16:00.000"},{":id":"row-pyy2_skb2_frnq",":version":"rv-4cqw-ngui.4a7u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala de Plens Ajuntament de Sant Mart\xed","indicador_refugi":"171729|SALA_DE_PLENS_AJUNTAMENT_DE_SANT_MARTI","municipi":"Sant Mart\xed de Ll\xe9mena","codi_municipi":"171729","latitud":"42.03647741952134","longitud":"2.6475147366776657","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"No","adreca":"Pla\xe7a San Mart\xed, 1, 17153 Sant Mart\xed de Ll\xe9mena, Girona","informacio_web":"https://smartillemena.cat/","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T13:13:00.000"},{":id":"row-tikq~4bpm_7b8f",":version":"rv-ycjc~fysf_prni",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Cal Frares","indicador_refugi":"082264|CAL_FRARES","municipi":"Sant Mart\xed de Tous","codi_municipi":"082264","latitud":"41.56087244","longitud":"1.52463544","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de l\'Esgl\xe8sia, 1","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-vdyh-t3ys_gtdb",":version":"rv-3vux.swun_7t8p",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pavell\xf3 Municipal","indicador_refugi":"082270|PAVELLO_MUNICIPAL","municipi":"Sant Mart\xed Sarroca","codi_municipi":"082270","latitud":"41.38573303615649","longitud":"1.6066318894608207","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Passeig Esportiu, 15","informacio_web":"https://www.santmartisarroca.cat/el-municipi/informacio-del-municipi/107-equipaments/pavello-poliesportiu.html","tipologia":"Pavell\xf3 Esportiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T16:38:00.000"},{":id":"row-39u6.mr6v_9ne4",":version":"rv-m4vp~jw8m~ivg8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"082270|PISCINA_MUNICIPAL","municipi":"Sant Mart\xed Sarroca","codi_municipi":"082270","latitud":"41.3870346","longitud":"1.6130884","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Passeig Esportiu, 17","informacio_web":"https://www.santmartisarroca.cat/el-municipi/informacio-del-municipi/107-equipaments/piscina-municipal.html","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T16:51:00.000"},{":id":"row-vy7w-qqs3~heg7",":version":"rv-938i-gycg.icde",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Antic Ajuntament - Espai per la Gent Gran","indicador_refugi":"082270|ANTIC_AJUNTAMENT_-_ESPAI_PER_LA_GENT_GRAN","municipi":"Sant Mart\xed Sarroca","codi_municipi":"082270","latitud":"41.385816","longitud":"1.611584","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de la Font, 11","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T16:54:00.000"},{":id":"row-fm92_enhu-q876",":version":"rv-hjcn~m6vv-khg3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Social i Espai Juvenil","indicador_refugi":"171735|CENTRE_SOCIAL_I_ESPAI_JUVENIL","municipi":"Sant Mart\xed Vell","codi_municipi":"171735","latitud":"42.01957852","longitud":"2.93070963","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Dalt, 8","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-qffj.s5cw~32qe",":version":"rv-2g64~z297_5n3u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca (Can Masseg\xfa)","indicador_refugi":"171735|BIBLIOTECA_CAN_MASSEGU","municipi":"Sant Mart\xed Vell","codi_municipi":"171735","latitud":"42.01980578","longitud":"2.93045855","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. dels \xc0ngels, 1A","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-9tdd.8239_qhj3",":version":"rv-h6pd.pwqx-miws",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local Rectoria de Valls de Torroella","indicador_refugi":"082299|LOCAL_RECTORIA_DE_VALLS_DE_TORROELLA","municipi":"Sant Mateu de Bages","codi_municipi":"082299","latitud":"41.847477","longitud":"1.719547","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Esgl\xe9sia del Sagrat Cor de la Col\xf2nia, Valls","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-rgx4~yjps.n4q3",":version":"rv-hr8b_qdg4~cuzf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala d\'oci-sala polivalent","indicador_refugi":"171740|SALA_D_OCI_SALA_POLIVALENT","municipi":"Sant Miquel de Campmajor","codi_municipi":"171740","latitud":"42.12607777","longitud":"2.68417867","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pda. 1 d\'octubre, s/n","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-pr64~q884.c97g",":version":"rv-uggd-mkrq_76jx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Escoles velles","indicador_refugi":"082325|ESCOLES_VELLES","municipi":"Sant Pere de Riudebitlles","codi_municipi":"082325","latitud":"41.45117511","longitud":"1.70215844","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Nou, 80","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-6sd6~pvhz~upj2",":version":"rv-h7sc.xidv_baf3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Maria \xc0ngels Torrents I Ros\xe9s","indicador_refugi":"082325|BIBLIOTECA_MARIA_ANGELS_TORRENTS_I_ROSES","municipi":"Sant Pere de Riudebitlles","codi_municipi":"082325","latitud":"41.45350783","longitud":"1.70369771","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Major, 42","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-bw39~njq3_q357",":version":"rv-uvt3.89gt_i26f",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina d\'estiu municipal","indicador_refugi":"082325|PISCINA_D_ESTIU_MUNICIPAL","municipi":"Sant Pere de Riudebitlles","codi_municipi":"082325","latitud":"41.44903113","longitud":"1.69869582","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pg. Sant Jeroni, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-8t8f~jf49.t5xc",":version":"rv-nnx3.hzeg_frc2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament de Sant Pere de Riudebitlles","indicador_refugi":"082325|AJUNTAMENT_DE_SANT_PERE_DE_RIUDEBITLLES","municipi":"Sant Pere de Riudebitlles","codi_municipi":"082325","latitud":"41.45371883593103","longitud":"1.7017463532579136","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a de les Eres, 1 08776","informacio_web":"https://www.santperederiudebitlles.cat/","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-19T12:28:00.000"},{":id":"row-ek9u.tn79_8f9b",":version":"rv-vvzy_xm38.5zby",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pavell\xf3 municipal","indicador_refugi":"082331|PAVELLO_MUNICIPAL","municipi":"Sant Pere de Torell\xf3","codi_municipi":"082331","latitud":"42.075577","longitud":"2.292936","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. St. Pere, s/n.","informacio_web":"www.stpere.cat","tipologia":"Pavell\xf3 Esportiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T17:09:00.000"},{":id":"row-drwh-a4nj_zm3w",":version":"rv-8mjv~bmvd-drv2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PISCINA MUNICIPAL","indicador_refugi":"082331|PISCINA_MUNICIPAL","municipi":"Sant Pere de Torell\xf3","codi_municipi":"082331","latitud":"42.07532","longitud":"2.293184","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. ST PERE, S/N","informacio_web":"WWW.STPERE.CAT","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-12T10:57:00.000"},{":id":"row-e65t.3jyt~rffn",":version":"rv-r8qa.umsy~7t4q",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"BAR CASAL AVIS","indicador_refugi":"082331|BAR_CASAL_AVIS","municipi":"Sant Pere de Torell\xf3","codi_municipi":"082331","latitud":"42.075003","longitud":"2.293694","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"PL. MONMANY, S/N.","informacio_web":"WWW.STPERE.CAT","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-12T11:01:00.000"},{":id":"row-7dev.xz42-fc4j",":version":"rv-kqub.5zc2-sujy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CASAL CULTURAL","indicador_refugi":"082331|CASAL_CULTURAL","municipi":"Sant Pere de Torell\xf3","codi_municipi":"082331","latitud":"42.075108","longitud":"2.297494","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. TERRICABRAS, 2","informacio_web":"WWW.STPERE.CAT","tipologia":"Equipament Cultural (teatre, auditori, museu)","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-12T11:16:00.000"},{":id":"row-z5sz-gbjw.cnbb",":version":"rv-6yi3~i83b.c854",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal d\'avis","indicador_refugi":"082384|CASAL_D_AVIS","municipi":"Sant Quirze del Vall\xe8s","codi_municipi":"082384","latitud":"41.53373289","longitud":"2.07998521","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Pintor Vila Puig, 22","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-zczy~8quz.varq",":version":"rv-2gah_tarf.ccs5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca","indicador_refugi":"082384|BIBLIOTECA","municipi":"Sant Quirze del Vall\xe8s","codi_municipi":"082384","latitud":"41.53214086","longitud":"2.07656293","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Eduarrd Toldr\xe0, s/n","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-5yu6.9895-rifc",":version":"rv-yfta.if9p~e8nx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina de les Fonts","indicador_refugi":"082384|PISCINA_DE_LES_FONTS","municipi":"Sant Quirze del Vall\xe8s","codi_municipi":"082384","latitud":"41.52528981","longitud":"2.03465942","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. Ferrocarril, 28","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-rgyy.2b3i-bypf",":version":"rv-3mwg.dk54~qeub",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Poliesportiu Can Casablanques","indicador_refugi":"082384|POLIESPORTIU_CAN_CASABLANQUES","municipi":"Sant Quirze del Vall\xe8s","codi_municipi":"082384","latitud":"41.5359766","longitud":"2.08263731","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Priorat, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-mc8d-t32a-6tp2",":version":"rv-s8tt.wnt2_qgsr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala salut Pastor (Patronal)","indicador_refugi":"082384|SALA_SALUT_PASTOR_PATRONAL","municipi":"Sant Quirze del Vall\xe8s","codi_municipi":"082384","latitud":"41.53307182","longitud":"2.08263549","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Barcelona, 65","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-dhvc_wbna~hx9m",":version":"rv-gvnr-9dur~tz3b",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic","indicador_refugi":"082397|CENTRE_CIVIC","municipi":"Sant Quirze Safaja","codi_municipi":"082397","latitud":"41.732734","longitud":"2.153731","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"No","lavabo":"No","adreca":"Parc de l\'Aigua s/n","informacio_web":"https://www.santquirzesafaja.cat/serveis/equipaments#","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T11:01:00.000"},{":id":"row-dc57-npub_6ddj",":version":"rv-5wsz-5rgc_xbai",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Vilarnau","indicador_refugi":"082401|CENTRE_VILARNAU","municipi":"Sant Sadurn\xed d\'Anoia","codi_municipi":"082401","latitud":"41.43313583","longitud":"1.78205712","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Germans Segura Viudas, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-6abv-cnwd~7tjy",":version":"rv-h5ep~fjc3~hhv2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Pont Rom\xe0","indicador_refugi":"082401|PARC_DEL_PONT_ROMA","municipi":"Sant Sadurn\xed d\'Anoia","codi_municipi":"082401","latitud":"41.42585284","longitud":"1.79049457","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. del Pont Rom\xe0","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-4bk9.n28a~rg4y",":version":"rv-bquf_5hny.xn43",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la gent gran","indicador_refugi":"082401|CASAL_DE_LA_GENT_GRAN","municipi":"Sant Sadurn\xed d\'Anoia","codi_municipi":"082401","latitud":"41.42980014","longitud":"1.78535616","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. de Can ferrer del Mas, 11","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-z2tt-tk7y.dpje",":version":"rv-2mdp.sgy8~sktk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Manuel Ravent\xf3s","indicador_refugi":"082401|PLACA_MANUEL_RAVENTOS","municipi":"Sant Sadurn\xed d\'Anoia","codi_municipi":"082401","latitud":"41.42273087","longitud":"1.7908547","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Manuel Ravent\xf3s","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-cp9t-h6yu~ac43",":version":"rv-v2bz.sp27.z5yz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca ramon Bosch de Noya","indicador_refugi":"082401|BIBLIOTECA_RAMON_BOSCH_DE_NOYA","municipi":"Sant Sadurn\xed d\'Anoia","codi_municipi":"082401","latitud":"41.42524996","longitud":"1.78573554","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Homenatge a la vellesa, 10","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-stej.57be.mmwb",":version":"rv-ifek~pmw3~4m58",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Can Mas de la Riera","indicador_refugi":"082401|CAN_MAS_DE_LA_RIERA","municipi":"Sant Sadurn\xed d\'Anoia","codi_municipi":"082401","latitud":"41.42027318","longitud":"1.78762851","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Can Mas de la Riera","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-c3zn~5g5c.g964",":version":"rv-vt54-7b5s~2fef",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"080983|PISCINA_MUNICIPAL","municipi":"Sant Salvador de Guardiola","codi_municipi":"080983","latitud":"41.68686716","longitud":"1.7816281","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Reina Sofia, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-nc3x~pnpb-f96f",":version":"rv-q95d~hpgd_6p78",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala Polivalent de La Masia del Calvet","indicador_refugi":"080983|SALA_POLIVALENT_DE_LA_MASIA_DEL_CALVET","municipi":"Sant Salvador de Guardiola","codi_municipi":"080983","latitud":"41.68657850524552","longitud":"1.780850447910322","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Pau Casals, s/n","informacio_web":"https://www.santsalvadordeguardiola.cat/temes/medi-ambient/refugis-climatics","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-18T14:16:00.000"},{":id":"row-dsbh.sv8r_nmjn",":version":"rv-cixy~94wh-9iaf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai Cultural La Sala","indicador_refugi":"080983|ESPAI_CULTURAL_LA_SALA","municipi":"Sant Salvador de Guardiola","codi_municipi":"080983","latitud":"41.68039779241097","longitud":"1.7675100452827204","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de la Creu, 8","informacio_web":"https://www.santsalvadordeguardiola.cat/temes/medi-ambient/refugis-climatics","tipologia":"Equipament Cultural (teatre, auditori, museu)","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-18T15:27:00.000"},{":id":"row-acpc.rutf-a7cc",":version":"rv-pyyz.f67v-xijc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Patufet","indicador_refugi":"080983|PARC_DEL_PATUFET","municipi":"Sant Salvador de Guardiola","codi_municipi":"080983","latitud":"41.67963729402103","longitud":"1.7671692384315825","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"CARRER DE LES ALZINES","informacio_web":"https://www.santsalvadordeguardiola.cat/temes/medi-ambient/refugis-climatics","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-18T15:31:00.000"},{":id":"row-5x97-2hkf-x6na",":version":"rv-jczb_5dai-5bnn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"082628|PISCINA_MUNICIPAL","municipi":"Sant Vicen\xe7 de Castellet","codi_municipi":"082628","latitud":"41.66221465","longitud":"1.86366909","accessibilitat":"S\xed","aigua":"No","area_descans":"No","adreca":"C. Alfons XIII, 24","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-6wn2-wpfa-wcck",":version":"rv-5d2r_pt7m~wf4d",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Salvador Vives Casajuana","indicador_refugi":"082628|BIBLIOTECA_SALVADOR_VIVES_CASAJUANA","municipi":"Sant Vicen\xe7 de Castellet","codi_municipi":"082628","latitud":"41.66554746","longitud":"1.86252388","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Creixell, 6","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-mfvt~iggp-3mk6",":version":"rv-e2z3_2hr4.reur",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"082652|PISCINA_MUNICIPAL","municipi":"Sant Vicen\xe7 de Torell\xf3","codi_municipi":"082652","latitud":"42.06154382","longitud":"2.2627802","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. Vilaseca","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-sdzh~r855.vwz9",":version":"rv-35j7_5cww~jq5i",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Punt jove","indicador_refugi":"082652|PUNT_JOVE","municipi":"Sant Vicen\xe7 de Torell\xf3","codi_municipi":"082652","latitud":"42.06280646","longitud":"2.27410373","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Major","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-5hkt-9di3-y7dk",":version":"rv-wabn-6r6j_jwa3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Torre de les Monges","indicador_refugi":"082652|TORRE_DE_LES_MONGES","municipi":"Sant Vicen\xe7 de Torell\xf3","codi_municipi":"082652","latitud":"42.0599377","longitud":"2.25484962","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Vilaseca","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-pijb~qm5x_v3sd",":version":"rv-s3s6.n9ha.ga87",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal avis Sant Vicen\xe7","indicador_refugi":"082652|CASAL_AVIS_SANT_VICENC","municipi":"Sant Vicen\xe7 de Torell\xf3","codi_municipi":"082652","latitud":"42.06224855","longitud":"2.27339441","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. Cal Ferrer","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-bsbg-jukg.9eh2",":version":"rv-n5nf~4pbg-a7e8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Teatre Borgony\xe0","indicador_refugi":"082652|TEATRE_BORGONYA","municipi":"Sant Vicen\xe7 de Torell\xf3","codi_municipi":"082652","latitud":"42.06501193","longitud":"2.24275916","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Borgony\xe0","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-twmy_jzpu-guzt",":version":"rv-i73n_ewti.n7tm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la Gent Gran Borgony\xe0","indicador_refugi":"082652|CASAL_DE_LA_GENT_GRAN_BORGONYA","municipi":"Sant Vicen\xe7 de Torell\xf3","codi_municipi":"082652","latitud":"42.065121","longitud":"2.242358","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Girona","informacio_web":"info@svdt.cat","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-10T12:05:00.000"},{":id":"row-sfgu_mkag_5mux",":version":"rv-yp79.vn87.9x7p",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa de la Vila","indicador_refugi":"082634|CASA_DE_LA_VILA","municipi":"Sant Vicen\xe7 dels Horts","codi_municipi":"082634","latitud":"41.39326523828432","longitud":"2.009598101524632","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a de la Vila, 1","informacio_web":"www.svh.cat","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-08T08:39:00.000"},{":id":"row-zgfk.vrkx_7urd",":version":"rv-x5af.7diz~j572",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic La Gu\xe0rdia","indicador_refugi":"082634|CENTRE_CIVIC_LA_GUARDIA","municipi":"Sant Vicen\xe7 dels Horts","codi_municipi":"082634","latitud":"41.39108825154025","longitud":"2.003681958600413","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer del Mestre Ramon Camps, 86, 08620 Sant Vicen\xe7 dels Horts, Barcelona","informacio_web":"www.svh.cat","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-08T08:43:00.000"},{":id":"row-5uvw.mnju.t977",":version":"rv-fk5a.5upb-f364",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CCC Virginia Amposta","indicador_refugi":"082634|CCC_VIRGINIA_AMPOSTA","municipi":"Sant Vicen\xe7 dels Horts","codi_municipi":"082634","latitud":"41.39829768057465","longitud":"2.0092228869193693","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer d\'Antoni Mampel, 1, 3, 08620 Sant Vicen\xe7 dels Horts, Barcelona","informacio_web":"www.svh.cat","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-08T08:45:00.000"},{":id":"row-4t34~wgqw.9hvy",":version":"rv-v25c~afad-dmym",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal Les Voltes","indicador_refugi":"082634|BIBLIOTECA_MUNICIPAL_LES_VOLTES","municipi":"Sant Vicen\xe7 dels Horts","codi_municipi":"082634","latitud":"41.39300471774377","longitud":"2.011474391020152","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Nou, 7, 08620 Sant Vicen\xe7 dels Horts, Barcelona","informacio_web":"www.svh.cat","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-08T08:46:00.000"},{":id":"row-kk5n-43h6_8vib",":version":"rv-yre2.252r-9acp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mol\xed dels Frares","indicador_refugi":"082634|MOLI_DELS_FRARES","municipi":"Sant Vicen\xe7 dels Horts","codi_municipi":"082634","latitud":"41.40334754478099","longitud":"2.000893551017464","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer C, 1, 08620 Sant Vicen\xe7 dels Horts, Barcelona","informacio_web":"www.svh.cat","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-08T08:48:00.000"},{":id":"row-3gbs_mze2_qjdk",":version":"rv-8e8p-bwq2~ckzd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Can Comamala","indicador_refugi":"082634|CAN_COMAMALA","municipi":"Sant Vicen\xe7 dels Horts","codi_municipi":"082634","latitud":"41.396329687289615","longitud":"2.0080807682978383","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Moss\xe8n Jacint Verdaguer, 105, 113, 08620 Sant Vicen\xe7 dels Horts, Barcelona","informacio_web":"www.svh.cat","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-08T08:49:00.000"},{":id":"row-5j38.8634-mv4w",":version":"rv-yfpt_n9tf~g9ar",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal de Sant Antoni - La Blava","indicador_refugi":"082634|PISCINA_MUNICIPAL_DE_SANT_ANTONI_-_LA_BLAVA","municipi":"Sant Vicen\xe7 dels Horts","codi_municipi":"082634","latitud":"41.38343640052182","longitud":"1.9951948107850332","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda del Mas Pic\xf3, s/n, 08620 Sant Vicen\xe7 dels Horts, Barcelona","informacio_web":"www.svh.cat","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-08T08:51:00.000"},{":id":"row-4arr~yspm-r9r9",":version":"rv-irnv-b4yn_3qdi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Pi Gros","indicador_refugi":"082634|PARC_DEL_PI_GROS","municipi":"Sant Vicen\xe7 dels Horts","codi_municipi":"082634","latitud":"41.39584586153714","longitud":"1.9995029975776797","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Parc del Pi Gros, 08620 Sant Vicen\xe7 dels Horts, Barcelona","informacio_web":"www.svh.cat","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-08T08:53:00.000"},{":id":"row-ujqh_xafs_ypyn",":version":"rv-7ngy_vsqr.cwsx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Mamut V\xe8nux","indicador_refugi":"082634|PARC_DEL_MAMUT_VENUX","municipi":"Sant Vicen\xe7 dels Horts","codi_municipi":"082634","latitud":"41.39737586276352","longitud":"2.009925043174255","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Passatge del Comer\xe7, 2, 08620 Sant Vicen\xe7 dels Horts, Barcelona","informacio_web":"www.svh.cat","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-08T08:54:00.000"},{":id":"row-yb29-jqap~ksxk",":version":"rv-z2p8~shqs~iagz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Llar de jubilats","indicador_refugi":"171805|LLAR_DE_JUBILATS","municipi":"Santa Coloma de Farners","codi_municipi":"171805","latitud":"41.86522243","longitud":"2.66370272","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Anselm Clav\xe9, 19","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-ihex.euf6-wn3q",":version":"rv-268f-mtzt-ee2v",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pavell\xf3 els Saioners","indicador_refugi":"171805|PAVELLO_ELS_SAIONERS","municipi":"Santa Coloma de Farners","codi_municipi":"171805","latitud":"41.85716128","longitud":"2.66395142","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Salvador Espriu","tipologia":"Poliesportiu","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-bq35.njb2_aka5",":version":"rv-ehcf_kwam_8t2r",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La Font de l\'Alemany","indicador_refugi":"171805|LA_FONT_DE_L_ALEMANY","municipi":"Santa Coloma de Farners","codi_municipi":"171805","latitud":"41.86605807","longitud":"2.70072365","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Rbla. Catalunya","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-myai_75r3.fc2s",":version":"rv-4snc-2cgf-h5ud",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Joan Vinyoli","indicador_refugi":"171805|BIBLIOTECA_JOAN_VINYOLI","municipi":"Santa Coloma de Farners","codi_municipi":"171805","latitud":"41.86163819","longitud":"2.66365454","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. Sant Salvador, 1","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-psrw_z4rq_kebd",":version":"rv-7ibv~i7n3_9jiy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Sant Salvador","indicador_refugi":"171805|PARC_DE_SANT_SALVADOR","municipi":"Santa Coloma de Farners","codi_municipi":"171805","latitud":"41.85796309","longitud":"2.66042441","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc de Sant Salvador","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-9dun~v5zh.ji3a",":version":"rv-2a2c-af36-4wj9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"431397|PISCINA_MUNICIPAL","municipi":"Santa Coloma de Queralt","codi_municipi":"431397","latitud":"41.53286644","longitud":"1.38716072","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pg. de la Muralla","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-rjxe_xhug-t94a",":version":"rv-v38f_qjgp-ac4v",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CASAL DE LA GENT GRAN EL PUIG","indicador_refugi":"082476|CASAL_DE_LA_GENT_GRAN_EL_PUIG","municipi":"Santa Eul\xe0lia de Riuprimer","codi_municipi":"082476","latitud":"41.910988","longitud":"2.188067","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Major 28","informacio_web":"https://www.santaeulaliariuprimer.cat/serveis-i-tramits/cataleg-de-serveis/casal-de-la-gent-gran.html","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-30T09:48:00.000"},{":id":"row-tsb5.xtpq-nada",":version":"rv-e67b.jips-5d9u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PISCINA MUNICIPAL","indicador_refugi":"082476|PISCINA_MUNICIPAL","municipi":"Santa Eul\xe0lia de Riuprimer","codi_municipi":"082476","latitud":"41.913465","longitud":"2.183473","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Major s/n","informacio_web":"https://www.santaeulaliariuprimer.cat/serveis-i-tramits/cataleg-de-serveis/piscina-municipal.html","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-30T09:52:00.000"},{":id":"row-7wtz_wevj.s2sh",":version":"rv-srzg.e5je.bkix",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal","indicador_refugi":"082482|BIBLIOTECA_MUNICIPAL","municipi":"Santa Eul\xe0lia de Ron\xe7ana","codi_municipi":"082482","latitud":"41.65448593","longitud":"2.22304278","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Mestre Joan Batlle, 6","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-mn6k-ridi-ev3y",":version":"rv-wxg3~vif2_ie5u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals Pinedes Castellet","indicador_refugi":"082482|PISCINES_MUNICIPALS_PINEDES_CASTELLET","municipi":"Santa Eul\xe0lia de Ron\xe7ana","codi_municipi":"082482","latitud":"41.63509943","longitud":"2.22064327","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Joan I","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-3c6v.dgii~wdzd",":version":"rv-tqb8.8ska-5pzp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic La F\xe0brica","indicador_refugi":"082482|CENTRE_CIVIC_LA_FABRICA","municipi":"Santa Eul\xe0lia de Ron\xe7ana","codi_municipi":"082482","latitud":"41.63886804","longitud":"2.23740177","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Cam\xed del Gual, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-gu5w-288f_zyx4",":version":"rv-nhvj-kxev.bqr8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CENTRE CIVIC MUNICIPAL \\"SALVADOR BENACH\\"","indicador_refugi":"082495|CENTRE_CIVIC_MUNICIPAL_\\"SALVADOR_BENACH\\"","municipi":"Santa Fe del Pened\xe8s","codi_municipi":"082495","latitud":"41.384498","longitud":"1.721445","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"CARRER ESCOLES, 1","informacio_web":"https://www.santafepenedes.cat","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-08T20:15:00.000"},{":id":"row-z9t6_wptd~k4th",":version":"rv-s7bk-h9w8.hut3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala polivalent","indicador_refugi":"082536|SALA_POLIVALENT","municipi":"Santa Maria de Besora","codi_municipi":"082536","latitud":"42.12633849","longitud":"2.25699433","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. Pla de Teia, s/n","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-aen3_r3vv.2uhw",":version":"rv-p5j2-kfc7_su83",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local Social de les Antigues Escoles","indicador_refugi":"082573|LOCAL_SOCIAL_DE_LES_ANTIGUES_ESCOLES","municipi":"Santa Maria de Miralles","codi_municipi":"082573","latitud":"41.50063309","longitud":"1.52772286","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. Igualada a Valls, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-4e4x-kczb.qb6q",":version":"rv-hcee_mj7f-apcv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"082589|PISCINA_MUNICIPAL","municipi":"Santa Maria d\'Ol\xf3","codi_municipi":"082589","latitud":"41.87770896","longitud":"2.03377588","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pg. de Carme Vidal, 4","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-9eb8~mepy-9qsj",":version":"rv-6j9u_g8sr.xwvs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic - Can Tai\xf2","indicador_refugi":"082606|CENTRE_CIVIC_CAN_TAIO","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.52877781","longitud":"2.18001935","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc de Catalunya, s/n, 08130 Santa Perp\xe8tua de Mogoda","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-6mxh_cc5i-7tpy",":version":"rv-5gf2_3n64-fhvb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa De La Vila","indicador_refugi":"082606|CASA_DE_LA_VILA","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.53449205","longitud":"2.18355951","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de la vila, 5","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-6e88~cpdf.hnai",":version":"rv-a33a-vhas~m3vb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Josep Jard\xed","indicador_refugi":"082606|BIBLIOTECA_JOSEP_JARDI","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.52737311","longitud":"2.18514109","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ptge. del Mas Granollacs, s/n, 08130 Santa Perp\xe8tua de Mogoda","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-4m9p.kbci-5aam",":version":"rv-r4fn.en4c_n8ua",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc dels Ametllers","indicador_refugi":"082606|PARC_DELS_AMETLLERS","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.52555448","longitud":"2.18884863","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. de la Florida, 08130 Santa Perp\xe8tua de Mogoda, Barcelona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-uvtw-nzdu-uqjk",":version":"rv-5amv.ypsj~365v",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic - La Creueta","indicador_refugi":"082606|CENTRE_CIVIC_LA_CREUETA","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.53658202","longitud":"2.17725323","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc del Doctor Mir\xf3, s/n, 08130 Santa Perp\xe8tua de Mogoda","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-exry-ifns~sv3h",":version":"rv-fnb3~bntk~ii4a",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bosc de la Torre","indicador_refugi":"082606|BOSC_DE_LA_TORRE","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.54599741","longitud":"2.18060806","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Mar Adri\xe0tic, 2, 08130 Santa Perp\xe8tua de Mogoda","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-8k4r.g7vp_f769",":version":"rv-hrer-s7ta~ecz3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Catalunya","indicador_refugi":"082606|PARC_DE_CATALUNYA","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.52794613","longitud":"2.18026977","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Josep Carner, 32, 08130 Santa Perp\xe8tua de Mogoda","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-c3hx_q5zf~84h9",":version":"rv-y24b-uf2w~gpag",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc municipal","indicador_refugi":"082606|PARC_MUNICIPAL","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.5360767","longitud":"2.18308045","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. de Santiga, 2, 08130 Santa Perp\xe8tua de Mogoda","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-beb3_e6ta-hphx",":version":"rv-jyuq-metj.hm7r",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic - La Rambla","indicador_refugi":"082606|CENTRE_CIVIC_LA_RAMBLA","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.53511033","longitud":"2.18275469","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de la Vila, 9, 08130 Santa Perp\xe8tua de Mogoda","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-yxf5~643t~6t8y",":version":"rv-xa84.hszu_qiqb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de Miquel Segura","indicador_refugi":"082606|PLACA_DE_MIQUEL_SEGURA","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.53748684","longitud":"2.17950077","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de la Verge de Montserrat, 18, 08130 Santa Perp\xe8tua de Mogoda","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-pafh~8wk7_t2q9",":version":"rv-762t-q6rj.6uv8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Ribera","indicador_refugi":"082606|PARC_DE_LA_RIBERA","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.53307953","longitud":"2.18942306","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de les Minetes, 08130 Santa Perp\xe8tua de Mogoda","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-psmi_59t2_v8yw",":version":"rv-tbak.ngvg~6f5j",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic - Mas Costa","indicador_refugi":"082606|CENTRE_CIVIC_MAS_COSTA","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.52226666","longitud":"2.18232824","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. de Can Tai\xf3, 83, 08130 Santa Perp\xe8tua de Mogoda","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-7sci~j2f4.yjqg",":version":"rv-yzud.2em9-udjh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal c\xedvic de la Gent Gran","indicador_refugi":"082606|CASAL_CIVIC_DE_LA_GENT_GRAN","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.53145403","longitud":"2.18351655","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Ramon d\'Abadal, s/n, 08130 Santa Perp\xe8tua de Mogoda","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-n4av_59s9_6hzd",":version":"rv-dmpd_32rt-ajdx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Pesseta","indicador_refugi":"082606|PARC_DE_LA_PESSETA","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.52274541","longitud":"2.18793778","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. setze, 08130 La Florida - Santa Perp\xe8tua de Mogoda","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-krxd_e6w8~yvax",":version":"rv-jsyu-xhqr~n35w",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Santa Perp\xe8tua de Mogoda","indicador_refugi":"082606|CASAL_CIVIC_I_COMUNITARI_SANTA_PERPETUA_DE_MOGODA","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.7876571","longitud":"1.8898848","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Ramon d\'Abadal, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-cy7r.z4cp.jyf8",":version":"rv-xmmc_686d~aqcg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bosc de Ca n\'Oller","indicador_refugi":"082606|BOSC_DE_CA_N_OLLER","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.54709963","longitud":"2.17487208","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"No","adreca":"C. Sardenya, s/n, 08130 Santa Perp\xe8tua de Mogoda","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-m65w~p2v4_bqei",":version":"rv-su3b~8skp_bnb8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai natural de Santiga","indicador_refugi":"082606|ESPAI_NATURAL_DE_SANTIGA","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.53451739","longitud":"2.15224473","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Nucli antic de Santiga - 08130 Santiga - Santa Perp\xe8tua de Mogoda","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-g2ai.shdn_mxvu",":version":"rv-58rq-baz4.xwuh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc dels Pa\xefsos Catalans","indicador_refugi":"082606|PARC_DELS_PAISOS_CATALANS","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.53062886","longitud":"2.18560382","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Pablo Ruiz Picasso, 18, 08130 Santa Perp\xe8tua de Mogoda","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-i3vs~3m4s-pqax",":version":"rv-xtmh_3iq2.emnw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Granja Soldevila","indicador_refugi":"082606|GRANJA_SOLDEVILA","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.52673937","longitud":"2.18564803","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Cam\xed de la Granja, s/n, 08130 Santa Perp\xe8tua de Mogoda","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-kzbg.b4mr.knbh",":version":"rv-6myj_xuq5-fimf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat municipal","indicador_refugi":"082606|MERCAT_MUNICIPAL","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.53604291","longitud":"2.18266042","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. de Santiga, s/n, 08130 Santa Perp\xe8tua de Mogoda","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-tecg~5588-8p32",":version":"rv-x66k-9n7x~xj3x",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu del Treball i la Industria Viva - MTIV","indicador_refugi":"082606|MUSEU_DEL_TREBALL_I_LA_INDUSTRIA_VIVA_MTIV","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.53605066","longitud":"2.18012221","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. d\'Enric Granados, 8, 08130 Santa Perp\xe8tua de Mogoda","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-nxcv~dgt5~4fed",":version":"rv-7ufd-swrx.n9pw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic - Can Folguera","indicador_refugi":"082606|CENTRE_CIVIC_CAN_FOLGUERA","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.53125462","longitud":"2.18682903","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Pablo Ruiz Picasso, 32, 08130 Santa Perp\xe8tua de Mogoda","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-2ftz.62aw-9jku",":version":"rv-j3kj_ytm7.xam3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Central","indicador_refugi":"082606|PARC_CENTRAL","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.52896674","longitud":"2.18751247","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. de l\' Onze de Setembre, 1-7, 08130 Santa Perp\xe8tua de Mogoda","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-mck5~88bn.i3c4",":version":"rv-y7a6-fzgk.zinr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bosc Soldevila","indicador_refugi":"082606|BOSC_SOLDEVILA","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.52438733","longitud":"2.18540345","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. la Font dels Joncs, 2, 08130 Santa Perp\xe8tua de Mogoda","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-yxub.dub8_jp4d",":version":"rv-rqxb~8nev-7ha2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Poliesportiu municipal","indicador_refugi":"082606|POLIESPORTIU_MUNICIPAL","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.52887423","longitud":"2.18207275","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. de Girona, 7, 08130 Santa Perp\xe8tua de Mogoda","tipologia":"Poliesportiu","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-n4rd-e4e9-k5jt",":version":"rv-5chx~hzqg~fjkb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Riera Seca","indicador_refugi":"082606|PARC_DE_LA_RIERA_SECA","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.51626043","longitud":"2.18909862","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Parc Riera Seca, 24, 08130 La Florida - Santa Perp\xe8tua de Mogoda","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-b996-kyyt.7yh9",":version":"rv-e9iq_3dns-c4t8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic - La Florida","indicador_refugi":"082606|CENTRE_CIVIC_LA_FLORIDA","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.51960611","longitud":"2.1904094","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Set, 20, 08130 La Florida - Santa Perp\xe8tua de Mogoda","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-jccu~cn57~cpbc",":version":"rv-pb4f-6rxf~vchx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Tesanj","indicador_refugi":"082606|PARC_DE_TESANJ","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.53392186","longitud":"2.17629017","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Ramon Casas, s/n, 08130 Santa Perp\xe8tua de Mogoda","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-3ua5_gsn7-2wdz",":version":"rv-tiu6.wcpc-77fw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc d\'Europa","indicador_refugi":"082606|PARC_D_EUROPA","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.52149702","longitud":"2.18204831","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. de Can Tai\xf3, 75, 08130 Santa Perp\xe8tua de Mogoda","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-jfsw~hjmf~x2jn",":version":"rv-xkfa~y5wu.cvav",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Serveis Socials","indicador_refugi":"082606|SERVEIS_SOCIALS","municipi":"Santa Perp\xe8tua de Mogoda","codi_municipi":"082606","latitud":"41.53154195","longitud":"2.17762569","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Salvador Espriu, 72, 08130 Santa Perp\xe8tua de Mogoda","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-w6uf_4r2z~qdup",":version":"rv-mg56-2enb.gwf6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Pare Ignasi Casanovas","indicador_refugi":"081923|BIBLIOTECA_PARE_IGNASI_CASANOVAS","municipi":"Santpedor","codi_municipi":"081923","latitud":"41.78262","longitud":"1.83595","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"08251","informacio_web":"https://bibliotecavirtual.diba.cat/santpedor-biblioteca-pare-ignasi-casanovas","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-06T08:10:00.000"},{":id":"row-nvsu_6ctj.tcx3",":version":"rv-3si4~d3rg~xxs7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Llar d\'avis Ca l\'Arola","indicador_refugi":"081923|LLAR_DAVIS_CA_LAROLA","municipi":"Santpedor","codi_municipi":"081923","latitud":"41.78324","longitud":"1.83937","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"08251","informacio_web":"https://www.santpedor.cat/regidories-i-serveis/cultura/llar-davis-ca-larola.html","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-06T08:14:00.000"},{":id":"row-83gt~tjtj_m4r6",":version":"rv-2mre_n2ws~xyv7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament de Santpedor","indicador_refugi":"081923|AJUNTAMENT_DE_SANTPEDOR","municipi":"Santpedor","codi_municipi":"081923","latitud":"41.78324","longitud":"1.83837","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"08251","informacio_web":"https://www.santpedor.cat/municipi/oficines-municipals/oficina-atencio-al-ciutada.html","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-06T08:17:00.000"},{":id":"row-22g9-dxdx-fnpx",":version":"rv-8sum~fqnv.k9at",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Em\xedlia Xargay","indicador_refugi":"171864|BIBLIOTECA_EMILIA_XARGAY","municipi":"Sarri\xe0 de Ter","codi_municipi":"171864","latitud":"42.01091","longitud":"2.49194","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Catalunya, 1","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-gdjt.fjqp~6zec",":version":"rv-x3yz.xv9t.7rs5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local Social de la Rasa","indicador_refugi":"171864|LOCAL_SOCIAL_DE_LA_RASA","municipi":"Sarri\xe0 de Ter","codi_municipi":"171864","latitud":"42.02195991644906","longitud":"2.8225507946646546","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"No","adreca":"Carrerr Flore de Neu, 6","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T09:28:00.000"},{":id":"row-qva7~gu8e-uey7",":version":"rv-5yfk-8kmf-fzqg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic La Cooperativa","indicador_refugi":"171864|CENTRE_CIVIC_LA_COOPERATIVA","municipi":"Sarri\xe0 de Ter","codi_municipi":"171864","latitud":"42.01185117546791","longitud":"2.814066765503671","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"No","adreca":"Pla\xe7a Renaixen\xe7a S/N","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T09:30:00.000"},{":id":"row-naaq_aji2.5c9j",":version":"rv-jcti.38ea_8xjp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"El Coro","indicador_refugi":"171864|EL_CORO","municipi":"Sarri\xe0 de Ter","codi_municipi":"171864","latitud":"42.018607525322075","longitud":"2.825270593913159","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"No","adreca":"Pla\xe7a de la Font, 9","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T09:33:00.000"},{":id":"row-hg6g_67yv_z2h8",":version":"rv-i7m2~gpz6-i68f",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local Social del Pla de l\u2019Horta","indicador_refugi":"171864|LOCAL_SOCIAL_DEL_PLA_DE_L\u2019HORTA","municipi":"Sarri\xe0 de Ter","codi_municipi":"171864","latitud":"42.01519902687855","longitud":"2.81506054708262","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"No","adreca":"Carrer Rafael Casanova SN","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T10:08:00.000"},{":id":"row-9u65-6cv8_3hyr",":version":"rv-64cw~z92e-yqzf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local Social","indicador_refugi":"431439|LOCAL_SOCIAL","municipi":"Savall\xe0 del Comtat","codi_municipi":"431439","latitud":"41.54305183","longitud":"1.3009958","accessibilitat":"No","aigua":"No","area_descans":"S\xed","adreca":"C. Major, 12","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-7m7x_y6rf~dmfj",":version":"rv-5rf3~px7f~rkur",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"casal de la gent gran","indicador_refugi":"431444|CASAL_DE_LA_GENT_GRAN","municipi":"Secuita, la","codi_municipi":"431444","latitud":"41.204837","longitud":"1.281978","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Josep Gasssi\xf3, 7 43765 la Secuita","informacio_web":"De dilluns a divendres, de 8.00 a 20.00 hores","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-09T13:58:00.000"},{":id":"row-2ery-7q9v.dbxc",":version":"rv-v33t~cxhf-456s",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mas de l\'Hort d\'Igl\xe9sies","indicador_refugi":"431457|MAS_DE_LHORT_DIGLESIES","municipi":"Selva del Camp, la","codi_municipi":"431457","latitud":"41.22278325013513","longitud":"1.138020929127775","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"c. Tarragona, 10","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T10:14:00.000"},{":id":"row-87ga-j8m6-gwgv",":version":"rv-2gu9-8yrm-f2ky",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca P\xfablica de la Selva del Camp","indicador_refugi":"431457|BIBLIOTECA_PUBLICA_DE_LA_SELVA_DEL_CAMP","municipi":"Selva del Camp, la","codi_municipi":"431457","latitud":"41.22226955199804","longitud":"1.135271818174045","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"c. Tarragona, 10","informacio_web":"https://biblioteca.laselvadelcamp.cat/","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T10:19:00.000"},{":id":"row-kcxb_kzf8.z32a",":version":"rv-5t2n~cqtw.esjy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal d\'Avis","indicador_refugi":"431457|CASAL_DAVIS","municipi":"Selva del Camp, la","codi_municipi":"431457","latitud":"41.21336644254618","longitud":"1.1398075541794912","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. de Joan Puig i Ferrater, 6","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T10:26:00.000"},{":id":"row-duy3.h9ys.jp3u",":version":"rv-yp8d.536f.ngeb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a del Portal d\'Avall","indicador_refugi":"431457|PLACA_DEL_PORTAL_DAVALL","municipi":"Selva del Camp, la","codi_municipi":"431457","latitud":"41.215107950758316","longitud":"1.1391214397005518","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a del Portal d\'Avall","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T10:29:00.000"},{":id":"row-2dhr~nftu_8wwr",":version":"rv-p8ky~mtis~p56i",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de la Rasa d\'en Batlle","indicador_refugi":"431457|JARDINS_DE_LA_RASA_DEN_BATLLE","municipi":"Selva del Camp, la","codi_municipi":"431457","latitud":"41.21315710161594","longitud":"1.1344734016075144","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"c. Gandhi","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T11:47:00.000"},{":id":"row-rypi-kpir.2qx5",":version":"rv-3gyt~n433.7cst",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pavell\xf3 Municipal d\'Esports de la Selva del Camp","indicador_refugi":"431457|PAVELLO_MUNICIPAL_DESPORTS_DE_LA_SELVA_DEL_CAMP","municipi":"Selva del Camp, la","codi_municipi":"431457","latitud":"41.213365215469004","longitud":"1.142962336702021","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"c. de l\'Horta, 39","informacio_web":"https://laselvadelcamp.cat/equipaments/pavello-municipal-desports/","tipologia":"Pavell\xf3 Esportiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T11:50:00.000"},{":id":"row-gway~uisp.kr2y",":version":"rv-casj.7r2d_skyi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina d\'estiu","indicador_refugi":"431457|PISCINA_DESTIU","municipi":"Selva del Camp, la","codi_municipi":"431457","latitud":"41.21391505650985","longitud":"1.1427530060910407","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"c. Horta, 39","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T12:04:00.000"},{":id":"row-qiav~x63w~gvh7",":version":"rv-4dmt.fvmr_jkja",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del c. Puig d\'en Cama","indicador_refugi":"431457|PARC_DEL_C_PUIG_DEN_CAMA","municipi":"Selva del Camp, la","codi_municipi":"431457","latitud":"41.21680944900349","longitud":"1.1347150263002879","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"c. Puig d\'en Cama","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T12:07:00.000"},{":id":"row-khr9.cjks~8gej",":version":"rv-sxv7-tkwh_kgrz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Major","indicador_refugi":"431457|PLACA_MAJOR","municipi":"Selva del Camp, la","codi_municipi":"431457","latitud":"41.21526118681679","longitud":"1.1369672175715129","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Major","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T12:19:00.000"},{":id":"row-c9t8_m4i5-9shd",":version":"rv-bf39.zdfr-em5v",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament de la Selva del Camp","indicador_refugi":"431457|AJUNTAMENT_DE_LA_SELVA_DEL_CAMP","municipi":"Selva del Camp, la","codi_municipi":"431457","latitud":"41.21519395283302","longitud":"1.1370012168848551","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Major, 4","informacio_web":"https://laselvadelcamp.cat/","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T12:22:00.000"},{":id":"row-fpgj~brju.s4e7",":version":"rv-n4fw-pm4r-6mn9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de Sant Andreu","indicador_refugi":"431457|PLACA_DE_SANT_ANDREU","municipi":"Selva del Camp, la","codi_municipi":"431457","latitud":"41.21629652839597","longitud":"1.136536163310278","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a de Sant Andreu","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T12:24:00.000"},{":id":"row-cpce.rk58.tw9e",":version":"rv-xprr.yxnn~gnpe",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de l\'Abel Ferrater","indicador_refugi":"431457|PARC_DE_LABEL_FERRATER","municipi":"Selva del Camp, la","codi_municipi":"431457","latitud":"41.210715034719705","longitud":"1.1324363861961424","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"c. d\'Abel Ferrater i Hortet, 3","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T12:41:00.000"},{":id":"row-meah_3ga8~r5ia",":version":"rv-4pkj_7a7p~tqif",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Passatge amb Marie Curie i Marta Mata","indicador_refugi":"431457|PLACA_PASSATGE_AMB_MARIE_CURIE_I_MARTA_MATA","municipi":"Selva del Camp, la","codi_municipi":"431457","latitud":"41.214236957433435","longitud":"1.1344885942599023","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Ptge. Marie Curie amb Ptge. Marta Mata","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T12:43:00.000"},{":id":"row-zkse-wxx6.pn98",":version":"rv-wc5f~6t5b.whr2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local Social","indicador_refugi":"431460|LOCAL_SOCIAL","municipi":"Senan","codi_municipi":"431460","latitud":"41.47013082638465","longitud":"1.0878422192951616","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ Major, 6","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T13:43:00.000"},{":id":"row-gb9t-bbwi-asrv",":version":"rv-v725.cpsu~3af9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"250352|PISCINA_MUNICIPAL","municipi":"Sentiu de Si\xf3, la","codi_municipi":"250352","latitud":"41.80538491","longitud":"0.88016076","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Escoles, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-bvay~qte6.7w27",":version":"rv-6fh4_g9j6_2chs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre de serveis El Roser","indicador_refugi":"250352|CENTRE_DE_SERVEIS_EL_ROSER","municipi":"Sentiu de Si\xf3, la","codi_municipi":"250352","latitud":"41.80662528","longitud":"0.88531448","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. disset, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-8i42~6jkd-ih5x",":version":"rv-dydy-6z2t-nvpg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pavell\xf3 municipal","indicador_refugi":"250352|PAVELLO_MUNICIPAL","municipi":"Sentiu de Si\xf3, la","codi_municipi":"250352","latitud":"41.805587","longitud":"0.880683","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ Escoles, 4","tipologia":"Pavell\xf3 Esportiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-16T09:14:00.000"},{":id":"row-wzre-usbk.3eek",":version":"rv-r5s7.7avb_v4a4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Frederic Alfonso i Orfila","indicador_refugi":"082671|BIBLIOTECA_FREDERIC_ALFONSO_I_ORFILA","municipi":"Sentmenat","codi_municipi":"082671","latitud":"41.60600318","longitud":"2.13638228","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. de l\'Esgl\xe9sia, 6","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-3d7p.tac8-dbk3",":version":"rv-n2vd.3eby_334j",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de l\'Aigua","indicador_refugi":"082671|PARC_DE_L_AIGUA","municipi":"Sentmenat","codi_municipi":"082671","latitud":"41.61044019","longitud":"2.13471264","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Francesc Moragues Barr, 2, 08181 Sentmenat, Barcelona","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-r5cp-2vef.d6d9",":version":"rv-4d52.rnx3~hm5p",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La Platgeta","indicador_refugi":"171925|LA_PLATGETA","municipi":"Setcases","codi_municipi":"171925","latitud":"42.374958","longitud":"2.302448","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Espai Verd al costat Riu Ter - GIV5264","informacio_web":"www.setcases.cat","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-10T09:58:00.000"},{":id":"row-e2jb.tt4c-mzjz",":version":"rv-vmva-dwmq_i3uc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari la Seu d\'Urgell","indicador_refugi":"252038|CASAL_CIVIC_I_COMUNITARI_LA_SEU_D_URGELL","municipi":"Seu d\'Urgell, la","codi_municipi":"252038","latitud":"42.3596704","longitud":"1.454723","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. de Joan Garriga i Mass\xf3, 22-26 baixos","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-8djm_8zr2~h4sm",":version":"rv-vh43-vp6q.nna5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Els Roures Parc","indicador_refugi":"082690|ELS_ROURES_PARC","municipi":"Seva","codi_municipi":"082690","latitud":"41.83459075","longitud":"2.27382264","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Ctra. de Viladrau, s/n, 08553 Seva, Barcelona","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-58pk-4cae-3et4",":version":"rv-kiku.2vin_8pjm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre de serveis polivalent","indicador_refugi":"252056|CENTRE_DE_SERVEIS_POLIVALENT","municipi":"Sidamon","codi_municipi":"252056","latitud":"41.62865999","longitud":"0.83118646","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Carretera, 21","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-ceqg_w3np.pmxd",":version":"rv-baq5.423i~srmu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"piscina","indicador_refugi":"252056|PISCINA","municipi":"Sidamon","codi_municipi":"252056","latitud":"41.62754751","longitud":"0.83174562","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Av. Generalitat","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-sbxh-rpk3.8wwq",":version":"rv-d6zw_2jbu.9vnv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Santiago Rusi\xf1ol","indicador_refugi":"082704|BIBLIOTECA_SANTIAGO_RUSINOL","municipi":"Sitges","codi_municipi":"082704","latitud":"41.2353224","longitud":"1.81223368","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de l\'ajuntament, 13, 08870 Sitges, Barcelona","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-2r7f.quut_pcs2",":version":"rv-ywqv_m2bz~6u5d",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la gent gran Joan Maragall","indicador_refugi":"082704|CASAL_DE_LA_GENT_GRAN_JOAN_MARAGALL","municipi":"Sitges","codi_municipi":"082704","latitud":"41.23745559","longitud":"1.81621454","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Joan Maragall, 38, 08870 Sitges, Barcelona","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-38n3_7uep~aqcb",":version":"rv-i2i5-pz5i_uwbi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Josep Roig i Ravent\xf3s","indicador_refugi":"082704|BIBLIOTECA_JOSEP_ROIG_I_RAVENTOS","municipi":"Sitges","codi_municipi":"082704","latitud":"41.24169871","longitud":"1.81095238","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Catalunya, s/n, 08870 Sitges, Barcelona","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-xvc3.ie2k-rgfs",":version":"rv-4uv9-yhz7~usvj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la gent gran Pau Casals","indicador_refugi":"082704|CASAL_DE_LA_GENT_GRAN_PAU_CASALS","municipi":"Sitges","codi_municipi":"082704","latitud":"41.24073838","longitud":"1.80722785","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Pau Casals, 17, 08870 Sitges, Barcelona","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-9a5y.u8tb-j9fx",":version":"rv-az54-cemm~xtdv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala polivalent de l\'ajuntament","indicador_refugi":"252069|SALA_POLIVALENT_DE_L_AJUNTAMENT","municipi":"Soler\xe0s, el","codi_municipi":"252069","latitud":"41.41408297","longitud":"0.68286915","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. de Bellpuig, 23","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-dy2k-nzif-napq",":version":"rv-xms3.4qrg_pyxu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"431476|PISCINA_MUNICIPAL","municipi":"Solivella","codi_municipi":"431476","latitud":"41.45290679","longitud":"1.1773398","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. de Poblet","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-u7km~t3qf~ec9h",":version":"rv-6jap_p7ac~crai",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Societat","indicador_refugi":"431476|SOCIETAT","municipi":"Solivella","codi_municipi":"431476","latitud":"41.45951","longitud":"1.17864","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. de Montblanc a Artesa, 78","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-tmrn.dzv8-r95n",":version":"rv-pmqh~hkmp.ne4r",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bar picina Solivella","indicador_refugi":"431476|BAR_PICINA_SOLIVELLA","municipi":"Solivella","codi_municipi":"431476","latitud":"41.45298","longitud":"1.17732","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"carretera de Blancafort","informacio_web":"del7 de juny al 30 de agost,de 11 a 24 horas","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T15:15:00.000"},{":id":"row-c89f.easb-azym",":version":"rv-tr4g_chyh-rdv3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Solsona","indicador_refugi":"252075|CASAL_CIVIC_I_COMUNITARI_SOLSONA","municipi":"Solsona","codi_municipi":"252075","latitud":"41.9943696","longitud":"1.5106318","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. d\'Antoni Gaud\xed, 2-A (ctda. Pg. Sant Antoni Maria Claret)","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-b6qm.z8c5.9yxj",":version":"rv-bty7_2t2q_m9jy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala polivalent","indicador_refugi":"252075|SALA_POLIVALENT","municipi":"Solsona","codi_municipi":"252075","latitud":"41.99459052","longitud":"1.51365583","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Gaud\xed, 2","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-7ga8_sy8p.d76b",":version":"rv-f8r5_3vdu_x8wf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals de Solsona","indicador_refugi":"252075|PISCINES_MUNICIPALS_DE_SOLSONA","municipi":"Solsona","codi_municipi":"252075","latitud":"41.98904127","longitud":"1.51776882","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Salvador Espriu, 8","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-dt84_xf5z_5wxk",":version":"rv-8kw8~zd7h-ugdn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Carles Morat\xf3","indicador_refugi":"252075|BIBLIOTECA_CARLES_MORATO","municipi":"Solsona","codi_municipi":"252075","latitud":"41.99499313","longitud":"1.51714903","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. de Ramon Llum\xe0, 1","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-pv94.7m83_jd6t",":version":"rv-u6s6_ndrt_ycjj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"AJUNTAMENT DE SORA","indicador_refugi":"082726|AJUNTAMENT_DE_SORA","municipi":"Sora","codi_municipi":"082726","latitud":"42.11239","longitud":"2.16085","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"No","adreca":"08588","informacio_web":"www.sora.cat","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T13:07:00.000"},{":id":"row-gph4~x3aq~g4qh",":version":"rv-m6mk~mkpc~9ygs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"ESCOLES DE CUSSONS","indicador_refugi":"082726|ESCOLES_DE_CUSSONS","municipi":"Sora","codi_municipi":"082726","latitud":"42.09684","longitud":"2.19713","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"No","adreca":"Carrer de la Ribera, 2 - 08588  SORA","informacio_web":"WWW.SORA.CAT","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T13:13:00.000"},{":id":"row-tumx_vc2y_aqwg",":version":"rv-eeph_wjjy_yaxm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Sort","indicador_refugi":"252094|CASAL_CIVIC_I_COMUNITARI_SORT","municipi":"Sort","codi_municipi":"252094","latitud":"42.4128182","longitud":"1.1291667","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. del Doctor Carles Pol i Aleu, 8","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-gdru.g7eu~sxeb",":version":"rv-3k4i-i3zh-pkii",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"piscina municipal","indicador_refugi":"082747|PISCINA_MUNICIPAL","municipi":"S\xfaria","codi_municipi":"082747","latitud":"41.8305636329025","longitud":"1.7499336861286168","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Ignasi Abadal,13","informacio_web":"https://www.suria.cat/espaismunicipals/espais-esportius-i-de-salut/piscinamunicipal2/","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T13:29:00.000"},{":id":"row-24p4.xhj4-chvm",":version":"rv-kvp5-s98y_836n",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local social Empordanet","indicador_refugi":"171959|LOCAL_SOCIAL_EMPORDANET","municipi":"Tallada d\'Empord\xe0, la","codi_municipi":"171959","latitud":"42.08287526","longitud":"3.05850142","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Figueres, s/n","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-grap.t38d_xywu",":version":"rv-x97b_e2ud-6i6z",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal De La Tallada D\'empord\xe0","indicador_refugi":"171959|PISCINA_MUNICIPAL_DE_LA_TALLADA_D_EMPORDA","municipi":"Tallada d\'Empord\xe0, la","codi_municipi":"171959","latitud":"42.08324257","longitud":"3.05903465","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. Figueres, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-gzrh~8inx~csf8",":version":"rv-9d82.z92z~yvb4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai Canet","indicador_refugi":"171959|ESPAI_CANET","municipi":"Tallada d\'Empord\xe0, la","codi_municipi":"171959","latitud":"42.05258455","longitud":"3.0656274","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. de l\'espai Canet, 1","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-3kgx.e8ph~knwq",":version":"rv-4jau_fq8m-3cf8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La P\xe8rgola De Mareny\xe0","indicador_refugi":"171959|LA_PERGOLA_DE_MARENYA","municipi":"Tallada d\'Empord\xe0, la","codi_municipi":"171959","latitud":"42.09059059","longitud":"3.04822147","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. President Maci\xe0, Mareny\xe0","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-ejbf.ddse~pjqj",":version":"rv-uggt~9hrc_yure",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Tor","indicador_refugi":"171959|CASAL_DE_TOR","municipi":"Tallada d\'Empord\xe0, la","codi_municipi":"171959","latitud":"42.08888378","longitud":"3.06698958","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. del Corriol, 8","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-kysh_i2fb-ukt8",":version":"rv-3mc5.de5b-d59y",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La Font Gran","indicador_refugi":"082785|LA_FONT_GRAN","municipi":"Taradell","codi_municipi":"082785","latitud":"41.87721816","longitud":"2.28676898","accessibilitat":"No","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de la Font, s/n","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-c52r.pxyk-3hh6",":version":"rv-auyt-cf2r-qfks",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Antoni Pladevall i Font","indicador_refugi":"082785|BIBLIOTECA_ANTONI_PLADEVALL_I_FONT","municipi":"Taradell","codi_municipi":"082785","latitud":"41.87141523","longitud":"2.28463039","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Ctra. de Baleny\xe0, 101","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-fjv6~eysd_swry",":version":"rv-92su~iz3n.u84d",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La Font del Ravat\xf3","indicador_refugi":"082785|LA_FONT_DEL_RAVATO","municipi":"Taradell","codi_municipi":"082785","latitud":"41.87996","longitud":"2.29974","accessibilitat":"No","aigua":"No","area_descans":"S\xed","adreca":"c. Tagamanent, s/n","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-zztk_hbuz~d8y5",":version":"rv-sx4d-w89m-t4v2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bosc del Pujol\xf3","indicador_refugi":"082785|BOSC_DEL_PUJOLO","municipi":"Taradell","codi_municipi":"082785","latitud":"41.8729083","longitud":"2.28240046","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Mn. Cinto Verdaguer, s/n","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-u4yu.ymjf-xj3k",":version":"rv-c6ai_xea7~2im2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Can Granada - Taradell Jove","indicador_refugi":"082785|CAN_GRANADA_TARADELL_JOVE","municipi":"Taradell","codi_municipi":"082785","latitud":"41.87277573","longitud":"2.28596721","accessibilitat":"No","aigua":"No","area_descans":"S\xed","adreca":"C. Ramon Pou, 60","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-zeun_2i72-a99k",":version":"rv-t49f_5hyy.u3e3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal estiu","indicador_refugi":"082785|PISCINA_MUNICIPAL_ESTIU","municipi":"Taradell","codi_municipi":"082785","latitud":"41.87022929","longitud":"2.2796028","accessibilitat":"S\xed","aigua":"No","area_descans":"No","adreca":"C. Sant Jordi, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-wbq8.r2vi_5wtg",":version":"rv-6t8x~4j4s~axzb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Bonavista","indicador_refugi":"431482|CENTRE_CIVIC_BONAVISTA","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.12070837","longitud":"1.19370145","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Onze, 13, Bonavista, 43100 Tarragona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-pzri.5jr8_feks",":version":"rv-wwnn.7wiv~7z89",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Camp de Mart","indicador_refugi":"431482|CAMP_DE_MART","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.11992822","longitud":"1.25514211","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Catalunya, 43002 Tarragona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-5gtw~4kkt.62xh",":version":"rv-yw9c.iedd.vu6z",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"OMAC Ponent","indicador_refugi":"431482|OMAC_PONENT","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.12278168","longitud":"1.21843055","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Tortosa, 39, 43006 Tarragona","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-2vx2~6jek-q6xc",":version":"rv-s8nw~fitm.9sb9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Tarragona","indicador_refugi":"431482|CASAL_CIVIC_I_COMUNITARI_TARRAGONA","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.1135871","longitud":"1.2411954","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. d\'en Francesc Bastos, 19","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-psd3_cwm4~mg77",":version":"rv-dui8_9piv~h6nv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai Jove KESSE","indicador_refugi":"431482|ESPAI_JOVE_KESSE","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.11978362","longitud":"1.24698313","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Sant Antoni Maria Claret, 12-14","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-62q2_heuh-xpgh",":version":"rv-cg8q_me2t~yad6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Institut municipal d\'Educaci\xf3 (IMET)","indicador_refugi":"431482|INSTITUT_MUNICIPAL_D_EDUCACIO_IMET","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.11621591","longitud":"1.24195558","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Ram\xf3n y Cajal, 70, 43005 Tarragona","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-5p6x.dk8c-bgny",":version":"rv-3h5b-645s.7auj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Sant Pere i Sant Pau","indicador_refugi":"431482|PARC_DE_SANT_PERE_I_SANT_PAU","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.13406753","longitud":"1.25000366","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Urb. Pedrol, 13, 43007 Tarragona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-f7un.dwpu_jn7r",":version":"rv-jqbq-h3q2_g6uy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Fitolaca","indicador_refugi":"431482|PARC_FITOLACA","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.1267614","longitud":"1.24015564","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Josep Maria Alom\xe0","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-n2bv_q495_jxvv",":version":"rv-jv5n.6hhv_iae4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Palau municipal","indicador_refugi":"431482|PALAU_MUNICIPAL","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.12470667","longitud":"1.20452593","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de la Font, 1","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-6key_9dk2_ycv8",":version":"rv-tcue_wb52_rbn8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Sant Salvador","indicador_refugi":"431482|CENTRE_CIVIC_SANT_SALVADOR","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.16195149","longitud":"1.24349458","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. dels Pins, s/n, 43130 Sant Salvador, Tarragona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-8efs~c6fi_ta86",":version":"rv-f22i-85w3~amv8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Reconciliaci\xf3","indicador_refugi":"431482|PARC_DE_LA_RECONCILIACIO","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.11609593","longitud":"1.2579699","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Via Augusta, 43003 Tarragona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-yw92-3vsn_wthw",":version":"rv-8k2w.r7zg~z83m",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"OMAC Centre","indicador_refugi":"431482|OMAC_CENTRE","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.11694578","longitud":"1.2527736","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Rbla. Nova, 59, 43003 Tarragona","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-tn6a-kh8g-x4qg",":version":"rv-mzuj_jh93_hjei",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Bonavista","indicador_refugi":"431482|PARC_DE_BONAVISTA","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.11507572","longitud":"1.19900153","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Valencia, 227, 43006 Tarragona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-7r4x_ak5c~9w7h",":version":"rv-bu9q-riny-pig9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Rodriguez de la Fuente","indicador_refugi":"431482|PARC_RODRIGUEZ_DE_LA_FUENTE","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.12132076","longitud":"1.2143479","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Gran Canaria","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-k46w_pink-wx52",":version":"rv-xd96~q9xs-hyba",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre esportiu municipal Bonavista","indicador_refugi":"431482|CENTRE_ESPORTIU_MUNICIPAL_BONAVISTA","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.12267081","longitud":"1.19562433","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. W-Carretera de Reus, 2A, 43006 Tarragona","tipologia":"Poliesportiu","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-axzd-dij9~kk9n",":version":"rv-c9bg_4hgv-7rpr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre esportiu municipal Riu Clar","indicador_refugi":"431482|CENTRE_ESPORTIU_MUNICIPAL_RIU_CLAR","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.11993024","longitud":"1.22186605","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. B, 10A, 43006 Tarragona","tipologia":"Poliesportiu","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-hx5c~dx73-4p4w",":version":"rv-qy25~txyt_auhz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Saavedra","indicador_refugi":"431482|PARC_DE_SAAVEDRA","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.11886214","longitud":"1.25407955","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Catalunya, 2C, 43002 Tarragona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-tic2.67jk.n7s2",":version":"rv-ssg7.dyuu~ypvf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de les Am\xe8riques","indicador_refugi":"431482|PARC_DE_LES_AMERIQUES","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.13699097","longitud":"1.25084985","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Las Am\xe9ricas, 43007 Tarragona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-ci2f~btnq.hgyd",":version":"rv-dynq.yp7v_9pii",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Francol\xed","indicador_refugi":"431482|PARC_FRANCOLI","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.12530667","longitud":"1.23340804","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Joan Mir\xf3, 9, 43006 Tarragona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-b9ek.mub4_bu96",":version":"rv-8b3s-qf89~k26t",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre de dia del PASS","indicador_refugi":"431482|CENTRE_DE_DIA_DEL_PASS","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.11121007","longitud":"1.24847438","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Miseric\xf2rdia, 14, Tarragona","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-usis~vpr8~n993",":version":"rv-efxq.bbuu-mdu3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre esportiu municipal El Serrallo","indicador_refugi":"431482|CENTRE_ESPORTIU_MUNICIPAL_EL_SERRALLO","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.11165752","longitud":"1.24156025","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Josep Catal\xe0 Ruf\xe0, s/n, 43005 Tarragona","tipologia":"Poliesportiu","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-dcqi_xzk7~frfe",":version":"rv-ah7z~jx46_vmkm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc la Col\xb7lectiva","indicador_refugi":"431482|PARC_LA_COL_LECTIVA","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.12387164","longitud":"1.2419006","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Covadonga","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-79wg~7efr~rrk5",":version":"rv-jrst.kbwz~mdeh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Torreforta","indicador_refugi":"431482|CENTRE_CIVIC_TORREFORTA","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.11724044","longitud":"1.21599057","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Tarragon\xe8s, s/n, 43006 Tarragona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-tcch-km9e.x856",":version":"rv-mjm4~b8q5-uyjx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Ciutat - Parc Puig i Valls","indicador_refugi":"431482|PARC_DE_LA_CIUTAT_PARC_PUIG_I_VALLS","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.11753369","longitud":"1.24231043","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Santiago Ram\xf3n y Cajal, 55, 43005 Tarragona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-euhy~zd95-8n6t",":version":"rv-z8ip_de42-z345",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre esportiu municipal Campclar","indicador_refugi":"431482|CENTRE_ESPORTIU_MUNICIPAL_CAMPCLAR","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.12095289","longitud":"1.20699207","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Cam\xed XXIII, 3, 43006 Tarragona","tipologia":"Poliesportiu","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-wir9~5nfr.wn7d",":version":"rv-fyim.dj7g.q9km",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Tarragona - Campclar","indicador_refugi":"431482|CASAL_CIVIC_I_COMUNITARI_TARRAGONA_CAMPCLAR","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.1173761","longitud":"1.2019704","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. del Riu Llobregat, s/n -cantonada Riu Brugent-","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-6vnu-kjtv~2im6",":version":"rv-n9c6-5ce5~qut7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Sant Pere i Sant Pau","indicador_refugi":"431482|CENTRE_CIVIC_SANT_PERE_I_SANT_PAU","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.14076165","longitud":"1.24659037","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Cam\xed Pont del Diable, s/n, 43007 Tarragona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-57ja_zqwf-ncep",":version":"rv-xa84-w6qn.shxe",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de l\'Amfiteatre Rom\xe0","indicador_refugi":"431482|PARC_DE_L_AMFITEATRE_ROMA","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.11532474","longitud":"1.25825519","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Via William J. Bryant, 2, 43003 Tarragona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-xq9n_mce5_xdeu",":version":"rv-54v3~7sbm_iank",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Miracle","indicador_refugi":"431482|PARC_DEL_MIRACLE","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.1154047","longitud":"1.25836723","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. Maritim Rafael Casanova","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-knnx.dpez~wewy",":version":"rv-e2gc_yq6c~nvm8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Sant Antoni","indicador_refugi":"431482|PARC_DE_SANT_ANTONI","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.11928743","longitud":"1.26051539","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. St. Antoni, 26, 43003 Tarragona","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-9nb6-xbsh-66f9",":version":"rv-v89s-vsqy.r94d",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre esportiu municipal Sant Salvador","indicador_refugi":"431482|CENTRE_ESPORTIU_MUNICIPAL_SANT_SALVADOR","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.16301324","longitud":"1.24368884","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Stadium, 43130 Sant Salvador, Tarragona","tipologia":"Poliesportiu","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-vag7~k4ct_abaz",":version":"rv-dty5~drk5~382g",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca p\xfablica Germanes G\xfcell","indicador_refugi":"252173|BIBLIOTECA_PUBLICA_GERMANES_GUELL","municipi":"T\xe0rrega","codi_municipi":"252173","latitud":"41.64522881","longitud":"1.13855316","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Sant Antoni, 3","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-6ahx~w8xm.bnzp",":version":"rv-f6f2_xn7s-ispf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals","indicador_refugi":"252173|PISCINES_MUNICIPALS","municipi":"T\xe0rrega","codi_municipi":"252173","latitud":"41.64507898","longitud":"1.14584428","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. del parc esportiu","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-pv9r-c88e_myj6",":version":"rv-7i53_nb84~wnin",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari T\xe0rrega","indicador_refugi":"252173|CASAL_CIVIC_I_COMUNITARI_TARREGA","municipi":"T\xe0rrega","codi_municipi":"252173","latitud":"41.6430826","longitud":"1.1359135","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Salvador Espriu, 9","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-tgkw-xq7m~9s2p",":version":"rv-r8g7-ynpg_bcav",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament de T\xe0rrega","indicador_refugi":"252173|AJUNTAMENT_DE_TARREGA","municipi":"T\xe0rrega","codi_municipi":"252173","latitud":"41.646488810726275","longitud":"1.1391902810078387","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Major, 1","informacio_web":"www.ciutadaniatarrega.cat","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-23T10:21:00.000"},{":id":"row-5py8-9a3u~d55w",":version":"rv-429t-x54i_w5qs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mas de Colom","indicador_refugi":"252173|MAS_DE_COLOM","municipi":"T\xe0rrega","codi_municipi":"252173","latitud":"41.66974122410236","longitud":"1.1248318585380386","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer del Mas d\u2019en Colom, 143","informacio_web":"https://masdecolom.com/","tipologia":"Equipament Cultural (teatre, auditori, museu)","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-23T13:31:00.000"},{":id":"row-reri.zy6b.2d7y",":version":"rv-e76t-5nqi_zdk6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu Comarcal de l\'Urgell - T\xe0rrega","indicador_refugi":"252173|MUSEU_COMARCAL_DE_LURGELL_-_TARREGA","municipi":"T\xe0rrega","codi_municipi":"252173","latitud":"41.64597550370037","longitud":"1.1391807386403696","accessibilitat":"S\xed","aigua":"No","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Major, 11","informacio_web":"https://ciutadaniatarrega.cat/","tipologia":"Equipament Cultural (teatre, auditori, museu)","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-01T09:02:00.000"},{":id":"row-2nhh.rmk2~knpx",":version":"rv-7ckf-ziz6.ikym",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa de Cultura","indicador_refugi":"252173|CASA_DE_CULTURA","municipi":"T\xe0rrega","codi_municipi":"252173","latitud":"41.646385981638566","longitud":"1.1398164367900003","accessibilitat":"No","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Les Piques, 1","informacio_web":"https://ciutadaniatarrega.cat/","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-01T09:07:00.000"},{":id":"row-8xwu~tnjg-6ds3",":version":"rv-xgcn-bw44.5e4w",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Oficina d\'Acci\xf3 Social, Habitatge, Salut i Feminismes","indicador_refugi":"252173|OFICINA_DACCIO_SOCIAL_HABITATGE_SALUT_I_FEMINISMES","municipi":"T\xe0rrega","codi_municipi":"252173","latitud":"41.65276611550447","longitud":"1.1387952944618847","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Sant Pelegr\xed, 74","informacio_web":"https://ciutadaniatarrega.cat/","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-01T09:10:00.000"},{":id":"row-nwza~hccy~zwr5",":version":"rv-ut8a-m2na_bduy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local social del Talladell","indicador_refugi":"252173|LOCAL_SOCIAL_DEL_TALLADELL","municipi":"T\xe0rrega","codi_municipi":"252173","latitud":"41.64985039164518","longitud":"1.1664185386405694","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. de Sant Pere, 5, El Talladell","informacio_web":"https://ciutadaniatarrega.cat/","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-01T10:32:00.000"},{":id":"row-isvd~pt7i~tcht",":version":"rv-98nd.je38-e3xc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local social de Santa Maria de Montmagastrell","indicador_refugi":"252173|LOCAL_SOCIAL_DE_SANTA_MARIA_DE_MONTMAGASTRELL","municipi":"T\xe0rrega","codi_municipi":"252173","latitud":"41.72025741826607","longitud":"1.1058633321887446","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Passeig de Catalunya, s/n, Santa Maria de Montmagastrell","informacio_web":"https://ciutadaniatarrega.cat/","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-01T10:36:00.000"},{":id":"row-7jap-4mm2~3xtg",":version":"rv-8547~b7p5-ype5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals d\'Altet","indicador_refugi":"252173|PISCINES_MUNICIPALS_DALTET","municipi":"T\xe0rrega","codi_municipi":"252173","latitud":"41.683225287774356","longitud":"1.1418483963137882","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. Major, s/n, Altet","informacio_web":"https://ciutadaniatarrega.cat/","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-01T10:38:00.000"},{":id":"row-hgxe.w2v8_t25n",":version":"rv-kva6~s5xw-acyb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals de Claravalls","indicador_refugi":"252173|PISCINES_MUNICIPALS_DE_CLARAVALLS","municipi":"T\xe0rrega","codi_municipi":"252173","latitud":"41.707507667936525","longitud":"1.1260546277257568","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Partida nova, s/n, Claravalls","informacio_web":"https://ciutadaniatarrega.cat/","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-01T10:40:00.000"},{":id":"row-iara.dg6b_zf46",":version":"rv-25e5~9re5~fgsv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local social de La Figuerosa","indicador_refugi":"252173|LOCAL_SOCIAL_DE_LA_FIGUEROSA","municipi":"T\xe0rrega","codi_municipi":"252173","latitud":"41.696818750236964","longitud":"1.168406401348469","accessibilitat":"No","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. de la Bassa, s/n, La Figuerosa","informacio_web":"https://ciutadaniatarrega.cat/","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-01T10:43:00.000"},{":id":"row-cs8b.cudt_kbxx",":version":"rv-kevc_rvut~4izx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local social de Claravalls","indicador_refugi":"252173|LOCAL_SOCIAL_DE_CLARAVALLS","municipi":"T\xe0rrega","codi_municipi":"252173","latitud":"41.70404259249487","longitud":"1.1258289962338872","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. de les Escoles, s/n, Claravalls","informacio_web":"https://ciutadaniatarrega.cat/","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-01T10:46:00.000"},{":id":"row-jt4a-w9xb~c6u7",":version":"rv-uucf-cp6y_mrhx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic","indicador_refugi":"082750|CENTRE_CIVIC","municipi":"Tav\xe8rnoles","codi_municipi":"082750","latitud":"41.95226696","longitud":"2.32604351","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Montseny, 2","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-9v3x-ywva_zjzt",":version":"rv-gb7k~bgns.ugwy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"082802|PISCINA_MUNICIPAL","municipi":"Tavertet","codi_municipi":"082802","latitud":"41.99409192","longitud":"2.41578629","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Jaume Balmes, 45","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-3g4w~23xa~t75y",":version":"rv-dev6_4k4r~gs4b",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pavell\xf3 Poliesportiu","indicador_refugi":"252206|PAVELLO_POLIESPORTIU","municipi":"T\xe9rmens","codi_municipi":"252206","latitud":"41.71640434","longitud":"0.76159311","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. Pau Casals, 29","tipologia":"Poliesportiu","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-bquk~ru7s.vq25",":version":"rv-ww4f~87gf_fhrc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre cultural Sant Joan","indicador_refugi":"252206|CENTRE_CULTURAL_SANT_JOAN","municipi":"T\xe9rmens","codi_municipi":"252206","latitud":"41.71896834","longitud":"0.7588261","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Esgl\xe8sia, 1","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-q55a_ywgf_cryv",":version":"rv-kvzj_563y_ki8z",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Campus UPC","indicador_refugi":"082798|BIBLIOTECA_CAMPUS_UPC","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.56376555","longitud":"2.02151345","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. del Campus, 1","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-dqx7.59am_hhmy",":version":"rv-ckva_md5e~jviy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Terrassa - Casal","indicador_refugi":"082798|CASAL_CIVIC_I_COMUNITARI_TERRASSA_CASAL","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.5706352","longitud":"2.0022225","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Wagner, 2","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-43mt~ea78.rrtn",":version":"rv-a2dt~75rz~vqgf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Guernika","indicador_refugi":"082798|PARC_DE_GUERNIKA","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.56521507","longitud":"2.04216374","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. \xc1lava - C. Burgos","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-z45b~bjji.i9eq",":version":"rv-wghy-zpr8_zq4y",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Districte 2","indicador_refugi":"082798|BIBLIOTECA_DISTRICTE_2","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.56468638","longitud":"2.02944373","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Sant Cosme, 157","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-ngcw_54in~3xu3",":version":"rv-4m4x_27um-8i6w",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Avel\xb7l\xed Estrenjer","indicador_refugi":"082798|CENTRE_CIVIC_AVEL_LI_ESTRENJER","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.57692023","longitud":"2.00628977","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de la Cultura, 5","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-kg7z~wx2y.nwwz",":version":"rv-if2g-2mnx~4tj4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Catalunya","indicador_refugi":"082798|PLACA_CATALUNYA","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.56668167","longitud":"2.02562548","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Barcelona, s/n","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-6iht~64vm~iyu8",":version":"rv-b7sn-fxz4.zy2i",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Federico Garcia Lorca","indicador_refugi":"082798|PLACA_FEDERICO_GARCIA_LORCA","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.57369309","longitud":"2.0365246","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de Talamanca, 35","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-pkti-y5ki~34qy",":version":"rv-emv2.cpp4-m2h6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Terrassa - Sant lloren\xe7","indicador_refugi":"082798|CASAL_CIVIC_I_COMUNITARI_TERRASSA_SANT_LLORENC","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.5797875","longitud":"2.0263177","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Cam\xed Font de les Canyes, 15","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-2qdv~usqg.g3jk",":version":"rv-56jz_8sqk_a9p5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Equipament socioesportiu La Cogullada","indicador_refugi":"082798|EQUIPAMENT_SOCIOESPORTIU_LA_COGULLADA","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.55461375","longitud":"2.00243426","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. de Joaquim de Sagrera, 15","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-jyej.8ixr~zny9",":version":"rv-pzvr-me5j-htwq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal de Les Arenes","indicador_refugi":"082798|PISCINA_MUNICIPAL_DE_LES_ARENES","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.57095518","longitud":"2.03889924","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Tibidabo, 60","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-pq6g.znxt.c2er",":version":"rv-n48k-xn9i_z5zz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Nord","indicador_refugi":"082798|PARC_DEL_NORD","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.57093642","longitud":"2.01341854","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc del Nord","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-xm3d~hmr3.thcp",":version":"rv-h9nc~4bhs-qkcs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Doctor Robert i Passeig Comte d\'Egara","indicador_refugi":"082798|PLACA_DOCTOR_ROBERT_I_PASSEIG_COMTE_D_EGARA","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.56333652","longitud":"2.0169851","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Doctor Robert","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-6w78~czhi-6xi2",":version":"rv-3z7z~wjfb-6wsd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de Salvador Allende","indicador_refugi":"082798|JARDINS_DE_SALVADOR_ALLENDE","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.55482261","longitud":"2.02725649","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Av. de Les Gl\xf2ries Catalanes, 131","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-gvns.wfrk_gwy2",":version":"rv-7d8t-cytk~b8ga",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Terrassa - Ca n\'anglada","indicador_refugi":"082798|CASAL_CIVIC_I_COMUNITARI_TERRASSA_CA_N_ANGLADA","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.5646715","longitud":"2.0184381","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Sant Tom\xe0s, 2","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-ppzf~3uen.bgsb",":version":"rv-2umd.gaau_xgf8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Terrassa - Can boada","indicador_refugi":"082798|CASAL_CIVIC_I_COMUNITARI_TERRASSA_CAN_BOADA","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.569095","longitud":"1.9807426","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Pr\xedncep de Viana, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-9dvd.pxfm.u9mi",":version":"rv-4ud6.4mrx~3p47",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Serra Galliners","indicador_refugi":"082798|PARC_SERRA_GALLINERS","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.53546271","longitud":"2.03815162","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de Joan Santamaria","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-jgva-2vc5-2x6s",":version":"rv-r6f5~38x5_z47v",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Terrassa - Can jofresa","indicador_refugi":"082798|CASAL_CIVIC_I_COMUNITARI_TERRASSA_CAN_JOFRESA","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.5492624","longitud":"1.9988615","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. d\'Igualada, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-gqa3_pus9_fbrf",":version":"rv-yquf.8bcs.um54",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bosc de Vilardell","indicador_refugi":"082798|BOSC_DE_VILARDELL","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.55778472","longitud":"2.04015536","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Cam\xed dels Monjos, 1","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-ux7p.tq2t.dufx",":version":"rv-nyqh~5akg.exke",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Can Tusell","indicador_refugi":"082798|PLACA_CAN_TUSELL","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.58192762","longitud":"2.01832935","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. Can Tusell","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-ejzt~4dxc_jphq",":version":"rv-zzi8.4hfw-btcz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Sant Jordi","indicador_refugi":"082798|PARC_DE_SANT_JORDI","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.56322507","longitud":"2.00386523","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de Josep Freixa i Argem\xed, 11","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-hz29~nwrw.g7fu",":version":"rv-ynqu~e2sc.55ei",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Districte 3","indicador_refugi":"082798|BIBLIOTECA_DISTRICTE_3","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.55591253","longitud":"2.02046857","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. del Germ\xe0 Joaquim, 66","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-td92~yuqv_wjjv",":version":"rv-7fkz-tdki.8tbz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Alberg municipal","indicador_refugi":"082798|ALBERG_MUNICIPAL","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.57000174","longitud":"2.00744363","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. del Vint-i-dos de Juliol, 216","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-uhqz~wkst_9dmh",":version":"rv-f2vz_hu9t.y8h5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de Ca n\'Anglada","indicador_refugi":"082798|PLACA_DE_CA_N_ANGLADA","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.5640938","longitud":"2.0301652","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de Ca n\'Anglada","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-4wpc_7qa9.4fv6",":version":"rv-u4ak~9kek.zqxp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Montserrat Roig","indicador_refugi":"082798|CENTRE_CIVIC_MONTSERRAT_ROIG","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.56455743","longitud":"2.02732144","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. de Barcelona, 180","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-9z6s-4nbt_vtzk",":version":"rv-yzxn_adw6_db8w",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jard\xed Arquitecte Coll i Bacard\xed","indicador_refugi":"082798|JARDI_ARQUITECTE_COLL_I_BACARDI","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.55603479","longitud":"1.99696134","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Calder\xf3n de la Barca, 24","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-f947_3uir.2qws",":version":"rv-s7hz-gmdb.hsvt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Antoni Escud\xe9","indicador_refugi":"082798|PLACA_ANTONI_ESCUDE","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.58363638","longitud":"2.01745029","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. Antoni Escud\xe9","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-87jf.zi3b-c4n2",":version":"rv-m58n.fczm_75bf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal de La Maurina","indicador_refugi":"082798|PISCINA_MUNICIPAL_DE_LA_MAURINA","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.56389808","longitud":"1.9934219","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Felip II, 39","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-hr6b.yr63-vp25",":version":"rv-3a28-3tg3-imn6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Terrassa - les Arenes","indicador_refugi":"082798|CASAL_CIVIC_I_COMUNITARI_TERRASSA_LES_ARENES","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.5728014","longitud":"2.0316079","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. del Farell, 2","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-cp7u~i4vg_7bvf",":version":"rv-k4nq.dby4.iyp9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal c\xedvic Montserrat/Torre-sana/Vilardell","indicador_refugi":"082798|CASAL_CIVIC_MONTSERRAT_TORRE_SANA_VILARDELL","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.56058599","longitud":"2.03865606","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Salamanca, 35","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-regm~828s_6n97",":version":"rv-zmi8.rxb2_wtdh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Districte 6","indicador_refugi":"082798|BIBLIOTECA_DISTRICTE_6","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.57732476","longitud":"2.02586101","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Rbla. de Francesc Maci\xe0, 193","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-hxwm_kzbz.ak2h",":version":"rv-843z_4car-j669",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Frederica Montseny","indicador_refugi":"082798|PLACA_FREDERICA_MONTSENY","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.56379152","longitud":"2.04142043","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. \xc1laba, 3","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-v8br_f34f.mju9",":version":"rv-dmgf_ipzj.7iwf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Terrassa - Can roca","indicador_refugi":"082798|CASAL_CIVIC_I_COMUNITARI_TERRASSA_CAN_ROCA","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.5792874","longitud":"1.9946351","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. d\'Alcoi, 81","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-miij.iukk-wi36",":version":"rv-gayp-tfk9_hgqh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Recepci\xf3 del Teatre Alegria","indicador_refugi":"082798|RECEPCIO_DEL_TEATRE_ALEGRIA","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.5641599","longitud":"2.01083025","accessibilitat":"S\xed","aigua":"No","area_descans":"No","adreca":"C. Gaud\xed, 15","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-36na_n8zq-rigt",":version":"rv-47se-az8g.xvcp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Terrassa - Ca n\'aurell","indicador_refugi":"082798|CASAL_CIVIC_I_COMUNITARI_TERRASSA_CA_N_AURELL","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.5620194","longitud":"1.9864111","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Nicolau Tall\xf3, 191","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-ctmj~d77p.etq3",":version":"rv-fuut.vg5c~vhbe",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Cogullada","indicador_refugi":"082798|PARC_DE_LA_COGULLADA","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.55155737","longitud":"2.0035672","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. \u010FEdison, 123","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-4w93_df6q_8n5e",":version":"rv-npbp_pqdz~xg3p",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Primer de Maig","indicador_refugi":"082798|PLACA_PRIMER_DE_MAIG","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.57706498","longitud":"2.0221358","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. Primer de Maig","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-r3yq~3ad2.m3nr",":version":"rv-fvuz_t7hb~kkhy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Districte 5","indicador_refugi":"082798|BIBLIOTECA_DISTRICTE_5","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.57563852","longitud":"2.00965867","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Jocs Ol\xedmpics, 7","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-fwtd.bcvd_qkcd",":version":"rv-u6ms.cy4g.h32u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal de Sant Lloren\xe7","indicador_refugi":"082798|PISCINA_MUNICIPAL_DE_SANT_LLORENC","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.57719484","longitud":"2.03061081","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Castellsapera, 7","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-9jt3-nmz7-uixw",":version":"rv-3cmz-dvhs_55yw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Terrassa - Pla de bonaire","indicador_refugi":"082798|CASAL_CIVIC_I_COMUNITARI_TERRASSA_PLA_DE_BONAIRE","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.582492","longitud":"2.0146285","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Sabadell, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-zdi4-g73e.mysm",":version":"rv-p8gv.76sq_afjs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Nacions Unides Sud","indicador_refugi":"082798|PARC_NACIONS_UNIDES_SUD","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.58192902","longitud":"2.011985","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. del Parlament, 32","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-5359~4ery-k4jq",":version":"rv-c2rf-bp9b.bpec",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Arxiu Hist\xf2ric de Terrassa","indicador_refugi":"082798|ARXIU_HISTORIC_DE_TERRASSA","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.55321212","longitud":"2.01624408","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Baldrich, 268","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-h4x6_a9ng-7sgu",":version":"rv-p3dr.2m9a_xutt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal c\xedvic Can Boada","indicador_refugi":"082798|CASAL_CIVIC_CAN_BOADA","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.56927469","longitud":"2.0011234","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Joan d\'\xc0ustria, 11","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-evgp~usg8-a3ms",":version":"rv-pmda_vszs_urw6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Central (BCT)","indicador_refugi":"082798|BIBLIOTECA_CENTRAL_BCT","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.56909435","longitud":"2.00992711","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pg. de les lletres, 1","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-j7ww~gz3z-47uu",":version":"rv-ezqb_dbag_np66",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Terrassa - la Maurina","indicador_refugi":"082798|CASAL_CIVIC_I_COMUNITARI_TERRASSA_LA_MAURINA","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.5641447","longitud":"1.9770783","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de N\xfaria, 175 (cant. Franc Comtat)","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-u9yf~rsyv~waas",":version":"rv-ga4z~au8d~snzm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Vallparad\xeds","indicador_refugi":"082798|PARC_DE_VALLPARADIS","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.56561426","longitud":"2.01862902","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Jard\xed de Vallparad\xeds","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-a3c6~4h7x_zveg",":version":"rv-gsdt~wbz5-zd9y",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal c\xedvic Francisca Redondo","indicador_refugi":"082798|CASAL_CIVIC_FRANCISCA_REDONDO","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.56179671","longitud":"1.99420429","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de la Maurina, 2","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-u75j_aze8~qgrb",":version":"rv-8kqv_cp55~q9wt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal de Vallparad\xeds","indicador_refugi":"082798|PISCINA_MUNICIPAL_DE_VALLPARADIS","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.55792152","longitud":"2.02024354","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Jdins. de Vallparad\xeds, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-gjaq_krv8.3kyi",":version":"rv-k8rw_udmg_ts5b",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Districte 4","indicador_refugi":"082798|BIBLIOTECA_DISTRICTE_4","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.55698761","longitud":"1.99861858","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Infant Mart\xed, 183","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-zjzb_ewxh.cj52",":version":"rv-dw7q.9mdh~3udz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Terrassa - Sant Pere Nord","indicador_refugi":"082798|CASAL_CIVIC_I_COMUNITARI_TERRASSA_SANT_PERE_NORD","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.5774399","longitud":"2.0243088","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Rbla. de Francesc Maci\xe0, 257","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-b9v7-uisv-2hze",":version":"rv-ck6x~kdvu.uzbk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Maria Aur\xe9lia Capmany","indicador_refugi":"082798|CENTRE_CIVIC_MARIA_AURELIA_CAPMANY","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.55738652","longitud":"1.99973642","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. \u010F\xc0ngel Sallent, 55","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-53uy_9csv.zkyx",":version":"rv-jz8x-qkjj~8uvi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal c\xedvic Vapor Gran","indicador_refugi":"082798|CASAL_CIVIC_VAPOR_GRAN","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.56003859","longitud":"2.013629","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. del Vapor Gran, 39","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-cr6v.8wvk~brry",":version":"rv-z95e.pmhv.zi5c",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Les Fonts","indicador_refugi":"082798|PARC_DE_LES_FONTS","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.52072307","longitud":"2.03538374","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc de Les Fonts","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-vc4x~69bg~qh2n",":version":"rv-uauf_h5mn-hhcz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"C\xe0mping Alberg municipal de Tivissa","indicador_refugi":"431508|CAMPING_ALBERG_MUNICIPAL_DE_TIVISSA","municipi":"Tivissa","codi_municipi":"431508","latitud":"41.04174279","longitud":"0.73870651","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Foig, 3","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-knaj-mxcx_kbq8",":version":"rv-qw7f.gzij~vwh4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de les Feixetes","indicador_refugi":"082830|PARC_DE_LES_FEIXETES","municipi":"Tona","codi_municipi":"082830","latitud":"41.85287973","longitud":"2.22579724","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. del Castell, 36","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-gm8s-83i6-djz8",":version":"rv-ujtu.x4nz_6ses",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bar Can Codina","indicador_refugi":"082830|BAR_CAN_CODINA","municipi":"Tona","codi_municipi":"082830","latitud":"41.84947959","longitud":"2.22772867","accessibilitat":"S\xed","aigua":"No","area_descans":"No","adreca":"Ctra. de Manresa, 2","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-vz82_8esq.kki9",":version":"rv-8na9.t3ww.7h89",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Roqueta","indicador_refugi":"082830|PARC_ROQUETA","municipi":"Tona","codi_municipi":"082830","latitud":"41.85980209","longitud":"2.22907217","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Sebasti\xe0 Roqueta, s/n","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-prwq.vbkx-k6e8",":version":"rv-zbvj_r9eg.jcyu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de l\'Espai Muriel Casals","indicador_refugi":"082830|JARDINS_DE_L_ESPAI_MURIEL_CASALS","municipi":"Tona","codi_municipi":"082830","latitud":"41.84720338","longitud":"2.22199115","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Jaume Balmes, 51","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-au6e.crft.et4e",":version":"rv-tke9.8din.4ng6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal de Tordera","indicador_refugi":"082845|BIBLIOTECA_MUNICIPAL_DE_TORDERA","municipi":"Tordera","codi_municipi":"082845","latitud":"41.69682217","longitud":"2.72173744","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Maragall, 6","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-yky9-zsa5-c3dr",":version":"rv-nj74_5thd.b2cg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Municipal","indicador_refugi":"082845|PISCINA_MUNICIPAL","municipi":"Tordera","codi_municipi":"082845","latitud":"41.704582781225525","longitud":"2.720243110468618","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carretera de l\'Estaci\xf3 92","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-22T11:56:00.000"},{":id":"row-vj8x_58e5-qn3c",":version":"rv-5sn2-ev6f.r4zf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Municipal Mas Mora","indicador_refugi":"082845|PISCINA_MUNICIPAL_MAS_MORA","municipi":"Tordera","codi_municipi":"082845","latitud":"41.70567508955579","longitud":"2.7396350816332475","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Urbanitzaci\xf3 Mas Mora","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-22T12:01:00.000"},{":id":"row-3wv2~94m2~bskm",":version":"rv-q4w2~juiu.b463",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"L\'esplai","indicador_refugi":"082845|LESPLAI","municipi":"Tordera","codi_municipi":"082845","latitud":"41.701890884879035","longitud":"2.7160305104685154","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Jardins Alcalde Sagrera S/N","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-22T12:06:00.000"},{":id":"row-gnj5~fijb-tncy",":version":"rv-nhbs-2b7w_ayis",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Joves","indicador_refugi":"082845|CASAL_DE_JOVES","municipi":"Tordera","codi_municipi":"082845","latitud":"41.69193434906992","longitud":"2.7162834816327086","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Can Pujades 9","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-22T12:10:00.000"},{":id":"row-dnck.9upy_xiqr",":version":"rv-j3b6-6ttq~erpg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Torell\xf3","indicador_refugi":"082858|CASAL_CIVIC_I_COMUNITARI_TORELLO","municipi":"Torell\xf3","codi_municipi":"082858","latitud":"42.0447017","longitud":"2.2592711","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Rocaprevera, 31","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-7yug.j4r2-q6tg",":version":"rv-fpsz~x23s-ew4b",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre social St Joan Baptista","indicador_refugi":"082861|CENTRE_SOCIAL_ST_JOAN_BAPTISTA","municipi":"Torre de Claramunt, la","codi_municipi":"082861","latitud":"41.53412739","longitud":"1.65924413","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Piscina, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-wye9_d8ur_tsrw",":version":"rv-jk62.whpv.8dab",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre social Pinedes Armengol","indicador_refugi":"082861|CENTRE_SOCIAL_PINEDES_ARMENGOL","municipi":"Torre de Claramunt, la","codi_municipi":"082861","latitud":"41.51613824","longitud":"1.6198034","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Font de l\'Armengol, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-upnt_mem2~dqxz",":version":"rv-myuj.x2em~dcep",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"El Caf\xe8 de La Torre","indicador_refugi":"431515|EL_CAFE_DE_LA_TORRE","municipi":"Torre de Fontaubella, la","codi_municipi":"431515","latitud":"41.12465962","longitud":"0.86387078","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Major, 5","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-n3x9-77ec_x8cn",":version":"rv-3iq3_kkhk.kiid",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal de la Torre de Fontaubella","indicador_refugi":"431515|PISCINA_MUNICIPAL_DE_LA_TORRE_DE_FONTAUBELLA","municipi":"Torre de Fontaubella, la","codi_municipi":"431515","latitud":"41.12434541","longitud":"0.86334964","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. dels esports, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-zxjc_gcxu~nirn",":version":"rv-4ray-srxu.zqsh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal social","indicador_refugi":"252265|CASAL_SOCIAL","municipi":"Torrebesses","codi_municipi":"252265","latitud":"41.42610707","longitud":"0.59555573","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Planeta, 32-34","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-cejt~9prf-6vzh",":version":"rv-8xwi-jqgh-5pkv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a del microclima","indicador_refugi":"252265|PLACA_DEL_MICROCLIMA","municipi":"Torrebesses","codi_municipi":"252265","latitud":"41.42663824598549","longitud":"0.5949003286308375","accessibilitat":"S\xed","aigua":"No","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"a la intersecci\xf3 dels carrers Toll i Mestre Emili Pujol","informacio_web":"Obert els 365 dies de l\'any","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T14:32:00.000"},{":id":"row-inpd~2nad-6fid",":version":"rv-d62t~aeie.bah7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"LLAR DE JUBILATS","indicador_refugi":"252304|LLAR_DE_JUBILATS","municipi":"Torregrossa","codi_municipi":"252304","latitud":"41.57984","longitud":"0.83146","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/Sant Roc","informacio_web":"www.torregrossa.cat","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T13:49:00.000"},{":id":"row-sa28_5xg8_jhem",":version":"rv-5qyn-dvga_my57",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Barbacoes","indicador_refugi":"252304|BARBACOES","municipi":"Torregrossa","codi_municipi":"252304","latitud":"41.5574","longitud":"0.83531","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Cam\xed Les Borges","informacio_web":"www.torregrossa.cat","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T13:51:00.000"},{":id":"row-kwjz-ktjp-tw63",":version":"rv-yq83-j5ej-7bs6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic","indicador_refugi":"252311|CENTRE_CIVIC","municipi":"Torrelameu","codi_municipi":"252311","latitud":"41.70444964","longitud":"0.70355115","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de Balaguer, 5, 25138 Torrelameu, Lleida","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-ni2i-tyus-hu5y",":version":"rv-eehy_wbzn_mnnb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre de dia","indicador_refugi":"082877|CENTRE_DE_DIA","municipi":"Torrelavit","codi_municipi":"082877","latitud":"41.44320345","longitud":"1.7304173","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de M. Segimon Tomeu, 29, 08775 Torrelavit, Barcelona","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-7mb2.5yfr-kciu",":version":"rv-msch~v5cm_nhjz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"082877|PISCINA_MUNICIPAL","municipi":"Torrelavit","codi_municipi":"082877","latitud":"41.44873835","longitud":"1.72956455","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de les Escoles, 3, 08775 Torrelavit, Barcelona","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-bukn~23cn~bqwn",":version":"rv-sd79.n5wz_f8gs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal cultura","indicador_refugi":"082877|CASAL_CULTURA","municipi":"Torrelavit","codi_municipi":"082877","latitud":"41.44643573","longitud":"1.72987382","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. del Mol\xed, 29, 08775 Torrelavit, Barcelona","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-aw6k.cy5x.zsf3",":version":"rv-6k9e~paeu-2ig6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre de serveis per a la gent gran","indicador_refugi":"082877|CENTRE_DE_SERVEIS_PER_A_LA_GENT_GRAN","municipi":"Torrelavit","codi_municipi":"082877","latitud":"41.44293833709089","longitud":"1.7304397992481295","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Moss\xe8n Segimon Tomeu, 29","informacio_web":"De dilluns a divendres de 9 a 14hores","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-19T14:03:00.000"},{":id":"row-wwfh~44y3_v4v9",":version":"rv-64r5~f6ue~utdz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Cultura","indicador_refugi":"082877|CASAL_DE_CULTURA","municipi":"Torrelavit","codi_municipi":"082877","latitud":"41.44657367294525","longitud":"1.7295062910287329","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Mol\xed, 29","informacio_web":"Matins de 9 a 14hores","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-19T14:07:00.000"},{":id":"row-qaby.insa_gerw",":version":"rv-yq3h-ya9x_d6bv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala de plens Ajuntament de Torrent","indicador_refugi":"171978|SALA_DE_PLENS_AJUNTAMENT_DE_TORRENT","municipi":"Torrent","codi_municipi":"171978","latitud":"41.95197275","longitud":"3.12813517","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Ajuntament, 1","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-tufq~huxf~dj9m",":version":"rv-it3d~d3xc_tzx2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Emd","indicador_refugi":"171997|EMD","municipi":"Torroella de Montgr\xed","codi_municipi":"171997","latitud":"42.05489127","longitud":"3.20142155","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. del Port, 25, 17258 L\'Estartit, Girona","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-9cp8.zbsk~rkdw",":version":"rv-cs7i-u3tc-xzf2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu de la Mediterr\xe0nia","indicador_refugi":"171997|MUSEU_DE_LA_MEDITERRANIA","municipi":"Torroella de Montgr\xed","codi_municipi":"171997","latitud":"42.04151932","longitud":"3.12463842","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. d\'Ull\xe0, 31, 17257 Torroella de Montgr\xed, Girona","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-qr2k~whqk-pa2p",":version":"rv-gvwz-edhr~wtu3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Mar de Llibres","indicador_refugi":"171997|BIBLIOTECA_MAR_DE_LLIBRES","municipi":"Torroella de Montgr\xed","codi_municipi":"171997","latitud":"42.05299038","longitud":"3.19647026","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Guillem de Montgr\xed, 31, 17258 L\'Estartit, Girona","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-j7p3.ncrs~qkvx",":version":"rv-5yp3~uhqh~p8w2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Pere Blasi","indicador_refugi":"171997|BIBLIOTECA_PERE_BLASI","municipi":"Torroella de Montgr\xed","codi_municipi":"171997","latitud":"42.04072163","longitud":"3.12453147","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de la Porta Nova, 54, 17257 Torroella de Montgr\xed, Girona","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-jrfm_pkm6_8wmv",":version":"rv-hb3v.km5v-aih3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CASAL DE GENT GRAN \\"PONT DE LLIERCA\\"","indicador_refugi":"172001|CASAL_DE_GENT_GRAN_\\"PONT_DE_LLIERCA\\"","municipi":"Tortell\xe0","codi_municipi":"172001","latitud":"42.232966","longitud":"2.629824","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"No","adreca":"PLA\xc7A MERCAT, 22 TORTELL\xc0","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-23T07:48:00.000"},{":id":"row-kr9f~6986-fuei",":version":"rv-wcfd~6kft.qshw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PISCINA MUNICIPAL","indicador_refugi":"172001|PISCINA_MUNICIPAL","municipi":"Tortell\xe0","codi_municipi":"172001","latitud":"42.227616","longitud":"2.634454","accessibilitat":"No","aigua":"S\xed","climatitzacio":"No","area_descans":"No","lavabo":"No","adreca":"CTRA. ARGELAGUER, S/N  - TORTELL\xc0","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-23T07:50:00.000"},{":id":"row-89xc_8iab_ck8w",":version":"rv-wqam-84px~8y2g",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Tortosa","indicador_refugi":"431554|CASAL_CIVIC_I_COMUNITARI_TORTOSA","municipi":"Tortosa","codi_municipi":"431554","latitud":"40.81469398","longitud":"0.51671331","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Alfara de Carles, 27-33","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-wwgf~9pc9_5i57",":version":"rv-h8mm~kqyp-b85g",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament de Tortosa","indicador_refugi":"431554|AJUNTAMENT_DE_TORTOSA","municipi":"Tortosa","codi_municipi":"431554","latitud":"40.81109518","longitud":"0.52079188","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Espanya, s/n","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-p8kv~3vxy.kfzx",":version":"rv-pzhi~cx3h~pkbd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Complex esportiu Win","indicador_refugi":"431554|COMPLEX_ESPORTIU_WIN","municipi":"Tortosa","codi_municipi":"431554","latitud":"40.81376625","longitud":"0.51492685","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. 1 d\'octubre, 14-15","tipologia":"Poliesportiu","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-2i4a_5pki-xrcz",":version":"rv-23us-cym2.4ynz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Marcel\xb7l\xed Domingo","indicador_refugi":"431554|BIBLIOTECA_MARCEL_LI_DOMINGO","municipi":"Tortosa","codi_municipi":"431554","latitud":"40.81391187","longitud":"0.52326344","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de la Merc\xe8, 6","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-8saj.uxqn-kjxe",":version":"rv-82pk_me2i.fzdy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Tremp","indicador_refugi":"252347|CASAL_CIVIC_I_COMUNITARI_TREMP","municipi":"Tremp","codi_municipi":"252347","latitud":"42.1624336","longitud":"0.893825","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc del Pinell, s/n (C. F)","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-b7ks~bx3r.754b",":version":"rv-ra8p-h6xi.mjzs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca p\xfablica Maria Barbal","indicador_refugi":"252347|BIBLIOTECA_PUBLICA_MARIA_BARBAL","municipi":"Tremp","codi_municipi":"252347","latitud":"42.16528446","longitud":"0.89254613","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de Catalunya, 6, 25620 Tremp, Lleida","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-mn78.358n.s9mi",":version":"rv-qnuy-n8za-367v",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal de Tremp","indicador_refugi":"252347|PISCINA_MUNICIPAL_DE_TREMP","municipi":"Tremp","codi_municipi":"252347","latitud":"42.1621613","longitud":"0.89825412","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. D, 25620 Tremp, Lleida (PARC DEL PINELL)","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-anji.jkbq_zft7",":version":"rv-f7nq-gmsq~ccw9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Planta Baixa de l\'Ajuntament de Tremp","indicador_refugi":"252347|PLANTA_BAIXA_DE_LAJUNTAMENT_DE_TREMP","municipi":"Tremp","codi_municipi":"252347","latitud":"42.167190629367155","longitud":"0.8959889418835005","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"25620","informacio_web":"https://www.ajuntamentdetremp.cat","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-09T13:25:00.000"},{":id":"row-2b3c-pch3-2r4u",":version":"rv-gjnj.5t93.epbh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic","indicador_refugi":"172044|CENTRE_CIVIC","municipi":"Ull\xe0","codi_municipi":"172044","latitud":"42.04805685","longitud":"3.11329879","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Dalt, 24","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-gyr9.ihqe_6e39",":version":"rv-d6f8_6r7a-us9u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CASAL CULTURAL D\'ULLASTRELL","indicador_refugi":"082900|CASAL_CULTURAL_DULLASTRELL","municipi":"Ullastrell","codi_municipi":"082900","latitud":"41.527306","longitud":"1.957983","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"CARRER JOSEP FORNELL S/N","informacio_web":"https://www.ullastrell.cat/el-municipi/guia-del-municipi/equipaments/casal-cultural.html","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T08:37:00.000"},{":id":"row-2nwy~mf58-2mft",":version":"rv-bmyi_nry7-8cg6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PISTA POLIESPORTIVA CASAL","indicador_refugi":"082900|PISTA_POLIESPORTIVA_CASAL","municipi":"Ullastrell","codi_municipi":"082900","latitud":"41.52684","longitud":"1.957865","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"CARRER JOSEP FORNELL, S/N","informacio_web":"https://www.ullastrell.cat/el-municipi/guia-del-municipi/equipaments/pista-poliesportiva.html","tipologia":"Pavell\xf3 Esportiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T08:45:00.000"},{":id":"row-6etc_guet-8d8h",":version":"rv-5vr6.td8j~zuz2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic","indicador_refugi":"431573|CENTRE_CIVIC","municipi":"Ulldemolins","codi_municipi":"431573","latitud":"41.32147278","longitud":"0.87631266","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de la Saltadora, 26, 43363 Ulldemolins, Tarragona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-j9xu-b2rx~epvb",":version":"rv-jvbw_vzth.nc3p",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"431573|PISCINA_MUNICIPAL","municipi":"Ulldemolins","codi_municipi":"431573","latitud":"41.31945671","longitud":"0.87960898","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Duc de Cardona, 13, 43363 Ulldemolins, Tarragona","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-58je_mubx_fymr",":version":"rv-e7de.n845_z44k",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvc","indicador_refugi":"172039|CENTRE_CIVC","municipi":"Ultramort","codi_municipi":"172039","latitud":"42.03767904","longitud":"3.03604433","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Torroella, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-dnbk.gny7~5unx",":version":"rv-5qk3.d27j_d6bj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals de Barruera","indicador_refugi":"250432|PISCINES_MUNICIPALS_DE_BARRUERA","municipi":"Vall de Bo\xed, la","codi_municipi":"250432","latitud":"42.502863","longitud":"0.797085","accessibilitat":"No","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Del Eiu","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-3giz.axtk.b2am",":version":"rv-azui~ujbm-gkpc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"252385|PISCINA_MUNICIPAL","municipi":"Vallbona de les Monges","codi_municipi":"252385","latitud":"41.53906854","longitud":"1.08800114","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. Montesquiu, 25268 Vallbona de les Monges, Lleida","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-8drk~s93j-jfit",":version":"rv-8mq5~j4u2.cyay",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PISCINES MUNICIPALS","indicador_refugi":"252402|PISCINES_MUNICIPALS","municipi":"Vallfogona de Balaguer","codi_municipi":"252402","latitud":"41.75279562512019","longitud":"0.8212564157118267","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ BELLCAIRE, 39","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-09T13:18:00.000"},{":id":"row-jf2p-dtdd~xbhf",":version":"rv-343c-wr29~z22h",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"AJUNTAMENT","indicador_refugi":"252402|AJUNTAMENT","municipi":"Vallfogona de Balaguer","codi_municipi":"252402","latitud":"41.75232305328587","longitud":"0.8156953384283077","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ MAJOR, 29","informacio_web":"9:00 a 14:00","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-09T13:20:00.000"},{":id":"row-xhs6~zbvp_9mfc",":version":"rv-avt3~qrtk.ez26",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PLA\xc7A SANT MIQUEL","indicador_refugi":"252402|PLACA_SANT_MIQUEL","municipi":"Vallfogona de Balaguer","codi_municipi":"252402","latitud":"41.75251306111933","longitud":"0.8136330752860261","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"PLA\xc7A SANT MIQUEL","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-09T13:37:00.000"},{":id":"row-8mzh_4zn3~jf99",":version":"rv-4xqh_8bky~c4nc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CENTRE C\xcdVIC","indicador_refugi":"252402|CENTRE_CIVIC","municipi":"Vallfogona de Balaguer","codi_municipi":"252402","latitud":"41.75102531748975","longitud":"0.8170734539566508","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"CENTRE C\xcdVIC","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-09T13:41:00.000"},{":id":"row-yc56.t52a_77u4",":version":"rv-6ku5_zze4.d9e5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PLA\xc7A 16 JUTGES","indicador_refugi":"252402|PLACA_16_JUTGES","municipi":"Vallfogona de Balaguer","codi_municipi":"252402","latitud":"41.75127771833613","longitud":"0.8170621766563133","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"PLA\xc7A 16 JUTGES","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-09T13:42:00.000"},{":id":"row-frk9_rbpq~sqby",":version":"rv-q3y3_q546.5jqp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PLA\xc7A DEL ROSER","indicador_refugi":"252402|PLACA_DEL_ROSER","municipi":"Vallfogona de Balaguer","codi_municipi":"252402","latitud":"41.752242005719715","longitud":"0.8182088587913268","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"PLA\xc7A DEL ROSER","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-09T13:44:00.000"},{":id":"row-p32g_my4i~d4ye",":version":"rv-xa5x~bbiz.rpnq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PLA\xc7A JOAN F\xc0BREGAS","indicador_refugi":"252402|PLACA_JOAN_FABREGAS","municipi":"Vallfogona de Balaguer","codi_municipi":"252402","latitud":"41.752489954007416","longitud":"0.8210564347692064","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"PLA\xc7A JOAN F\xc0BREGAS","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-09T13:45:00.000"},{":id":"row-8cpy_griv.s4ba",":version":"rv-b9zu-2795~uyd9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PLA\xc7A DEL TAPIADOR","indicador_refugi":"252402|PLACA_DEL_TAPIADOR","municipi":"Vallfogona de Balaguer","codi_municipi":"252402","latitud":"41.75026176009146","longitud":"0.8065020188647934","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"PLA\xc7A DEL TAPIADOR","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-09T13:47:00.000"},{":id":"row-8xen-yknt_rxkm",":version":"rv-zc9c-fv8f-3g6w",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PLA\xc7A SANTA MARGARIDA","indicador_refugi":"252402|PLACA_SANTA_MARGARIDA","municipi":"Vallfogona de Balaguer","codi_municipi":"252402","latitud":"41.783304698462516","longitud":"0.8442689548954665","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"PLA\xc7A SANTA MARGARIDA - LA R\xc0PITA","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-09T13:49:00.000"},{":id":"row-y2k4~cvwn~3j9e",":version":"rv-3dku.vkz4.cs3a",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PLA\xc7A LA LL\xc0GRIMA","indicador_refugi":"252402|PLACA_LA_LLAGRIMA","municipi":"Vallfogona de Balaguer","codi_municipi":"252402","latitud":"41.793306577579585","longitud":"0.8234046921580322","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"CARRER ALMAT\xc0 - HOSTAL NOU I LA CODOSA","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-09T13:51:00.000"},{":id":"row-8a89~2baa.9krd",":version":"rv-arsj_8966~pna3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PLA\xc7A DE LA CODOSA","indicador_refugi":"252402|PLACA_DE_LA_CODOSA","municipi":"Vallfogona de Balaguer","codi_municipi":"252402","latitud":"41.79236289938432","longitud":"0.8225998669968663","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"PLA\xc7A DE LA CODOSA - HOSTAL NOU I LA CODOSA","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-09T13:54:00.000"},{":id":"row-be9m_4hkz_jcin",":version":"rv-fdrm-xqyn~q54s",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PLA\xc7A SANT JOAN","indicador_refugi":"252402|PLACA_SANT_JOAN","municipi":"Vallfogona de Balaguer","codi_municipi":"252402","latitud":"41.78693333255807","longitud":"0.8217184166850545","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"HOSTAL NOU I LA CODOSA","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-09T13:58:00.000"},{":id":"row-8e5d.ra5v-ffk5",":version":"rv-7cqc~qebb-c9x4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina p\xfablica municipal","indicador_refugi":"431592|PISCINA_PUBLICA_MUNICIPAL","municipi":"Vallfogona de Riucorb","codi_municipi":"431592","latitud":"41.56427737","longitud":"1.23772201","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Johan Cruyff","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-2s3s.ndy2-ysy2",":version":"rv-fisy~tgmy_b79g",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala polivalent","indicador_refugi":"082943|SALA_POLIVALENT","municipi":"Vallgorguina","codi_municipi":"082943","latitud":"41.64801476","longitud":"2.51005898","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Esgl\xe9sia, 13","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-t55t_3jft-pmyf",":version":"rv-vdzx.m5k6-h6m8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local Associaci\xf3 propietaris Baronia del Montseny","indicador_refugi":"082943|LOCAL_ASSOCIACIO_PROPIETARIS_BARONIA_DEL_MONTSENY","municipi":"Vallgorguina","codi_municipi":"082943","latitud":"41.66212423","longitud":"2.46579985","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Av. del Montseny, 0","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-3avt_vh3p-6nu3",":version":"rv-c7pi_3f64~mp5a",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament de Vallirana","indicador_refugi":"082956|AJUNTAMENT_DE_VALLIRANA","municipi":"Vallirana","codi_municipi":"082956","latitud":"41.38811122","longitud":"1.93203515","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Major 329, Vallirana, Barcelona","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-qmcv~nbbc-eqpd",":version":"rv-if9b_kz82~7m6h",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai central de Joves","indicador_refugi":"082956|ESPAI_CENTRAL_DE_JOVES","municipi":"Vallirana","codi_municipi":"082956","latitud":"41.38694871","longitud":"1.93269379","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Parellada, 6-8","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-wurw.e9in~weh5",":version":"rv-bksm~m4vm.vyeb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal joves Vallirana","indicador_refugi":"082956|CASAL_JOVES_VALLIRANA","municipi":"Vallirana","codi_municipi":"082956","latitud":"41.38263877","longitud":"1.92605336","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Major, 616, 08759 Vallirana, Barcelona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-spsh-ij4v-wewg",":version":"rv-35ch.debf.kmmz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bilbioteca Josep Maria L\xf3pez Pic\xf3","indicador_refugi":"082956|BILBIOTECA_JOSEP_MARIA_LOPEZ_PICO","municipi":"Vallirana","codi_municipi":"082956","latitud":"41.3899774","longitud":"1.93461898","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ptge. Bon Retir, 6, 08759 Vallirana, Barcelona","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-4zks.mh82~6snq",":version":"rv-ptd8_ha47_qjmd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pavell\xf3 municipal Vallirana","indicador_refugi":"082956|PAVELLO_MUNICIPAL_VALLIRANA","municipi":"Vallirana","codi_municipi":"082956","latitud":"41.38172152","longitud":"1.92930527","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de l\'Esgl\xe9sia, 30, 08759 Vallirana, Barcelona","tipologia":"Poliesportiu","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-c6re~n8xk_f89q",":version":"rv-db5b.wae6-tdwe",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Vallirana","indicador_refugi":"082956|CASAL_CIVIC_I_COMUNITARI_VALLIRANA","municipi":"Vallirana","codi_municipi":"082956","latitud":"41.3855442","longitud":"1.9304982","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. de l\'Esport, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-ky4k_kdvs.r5s9",":version":"rv-xp8y_vnik-4a64",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa Mestre","indicador_refugi":"082956|CASA_MESTRE","municipi":"Vallirana","codi_municipi":"082956","latitud":"41.39029606","longitud":"1.9370293","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Major, 178, 08759 Vallirana - Barcelona","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-t79v_75as.v9iu",":version":"rv-63pk~6q4w_kata",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Masia Mol\xed de Can Batlle","indicador_refugi":"082956|MASIA_MOLI_DE_CAN_BATLLE","municipi":"Vallirana","codi_municipi":"082956","latitud":"41.38410941","longitud":"1.93265865","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Mol\xed, 2, 08759 Vallirana, Barcelona","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-hdwd_ec6w-zhqi",":version":"rv-igh3~3yaf_ic3c",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local social","indicador_refugi":"172095|LOCAL_SOCIAL","municipi":"Vall-llobrega","codi_municipi":"172095","latitud":"41.880751","longitud":"3.12595799","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Rbla. de l\'Esgl\xe8sia","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-sx2s_cg9b~9ytk",":version":"rv-ht8x_8jn3_aw75",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Font transitable Pa\xefsos Catalans","indicador_refugi":"172095|FONT_TRANSITABLE_PAISOS_CATALANS","municipi":"Vall-llobrega","codi_municipi":"172095","latitud":"41.879374","longitud":"3.126593","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Raval de Mar amb C. Joaquim Ruyra","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-j4a6-5q92_vx2n",":version":"rv-vcji_5xr2~dvef",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"431606|PISCINA_MUNICIPAL","municipi":"Vallmoll","codi_municipi":"431606","latitud":"41.24681982","longitud":"1.24655856","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Joan Manel Serrat, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-ps7k.dmqq-6bm7",":version":"rv-ws7a-5z26-ksga",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Tirant lo Balnc","indicador_refugi":"431606|BIBLIOTECA_TIRANT_LO_BALNC","municipi":"Vallmoll","codi_municipi":"431606","latitud":"41.24366631","longitud":"1.2489779","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Uni\xf3, 30","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-fjzc-wh6z_n43r",":version":"rv-p89p~kydd-i4qd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre cultural","indicador_refugi":"431606|CENTRE_CULTURAL","municipi":"Vallmoll","codi_municipi":"431606","latitud":"41.24180312","longitud":"1.25003122","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. de la Mas\xf3, s/n","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-98k2_uj7b.56wv",":version":"rv-64mj_txke~dpvz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a del Quarter","indicador_refugi":"431613|PLACA_DEL_QUARTER","municipi":"Valls","codi_municipi":"431613","latitud":"41.28675851","longitud":"1.2527454","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. del Quarter","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-ecef_r2na~hgez",":version":"rv-j3kg-cr9f-75gp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Barrau","indicador_refugi":"431613|PARC_BARRAU","municipi":"Valls","codi_municipi":"431613","latitud":"41.28917615","longitud":"1.25705824","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Francesc Maci\xe0","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-in7m_u6yq-rq33",":version":"rv-7ifq-ep99.nqpt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Vest\xedbul de l\'Ajuntament de Valls","indicador_refugi":"431613|VESTIBUL_DE_L_AJUNTAMENT_DE_VALLS","municipi":"Valls","codi_municipi":"431613","latitud":"41.28431552","longitud":"1.2477455","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. del Blat, 1","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-5q8p.wixd.xgs5",":version":"rv-ajvd_mt93~3jt8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de les Escudelles","indicador_refugi":"431613|PLACA_DE_LES_ESCUDELLES","municipi":"Valls","codi_municipi":"431613","latitud":"41.28336198","longitud":"1.24878648","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de les Escudelles","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-figa-988s~7wrc",":version":"rv-yww3-9wh8.nuar",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Oficina d\'Informaci\xf3 i Turisme","indicador_refugi":"431613|OFICINA_D_INFORMACIO_I_TURISME","municipi":"Valls","codi_municipi":"431613","latitud":"41.28440133","longitud":"1.24801467","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de la Cort, 3","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-25fi-sagw-4ya2",":version":"rv-rp7c-fr6t_p7vj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pavell\xf3 Xavi Tondo","indicador_refugi":"431613|PAVELLO_XAVI_TONDO","municipi":"Valls","codi_municipi":"431613","latitud":"41.29550254","longitud":"1.259988","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. President Tarradellas, 2-6","tipologia":"Poliesportiu","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-rij4~krdf_a4dw",":version":"rv-y6qs.ky6u.9y3b",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Passeig dels Caputxins","indicador_refugi":"431613|PASSEIG_DELS_CAPUTXINS","municipi":"Valls","codi_municipi":"431613","latitud":"41.28760134","longitud":"1.25161472","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. dels Caputxins","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-qg65~5stu.isj9",":version":"rv-jamj-hcmz~tukt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a passeig Clariana","indicador_refugi":"431613|PLACA_PASSEIG_CLARIANA","municipi":"Valls","codi_municipi":"431613","latitud":"41.27989109","longitud":"1.23900104","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. Clariana","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-zjr5_8spm-tsjh",":version":"rv-cuti~48vf~dkh7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Les Comarques","indicador_refugi":"431613|CENTRE_CIVIC_LES_COMARQUES","municipi":"Valls","codi_municipi":"431613","latitud":"41.28454628","longitud":"1.24195257","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de la Vall d\'Aran, 1","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-jgr4_p27v-y8p3",":version":"rv-jzwp.axcv.rxrz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de la Xamora","indicador_refugi":"431613|PLACA_DE_LA_XAMORA","municipi":"Valls","codi_municipi":"431613","latitud":"41.29163815","longitud":"1.25204562","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de la Xamora","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-5662.53hi~vrye",":version":"rv-g8rg_62dh~5qqg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc infantil dos de vuit","indicador_refugi":"431613|PARC_INFANTIL_DOS_DE_VUIT","municipi":"Valls","codi_municipi":"431613","latitud":"41.29660368","longitud":"1.25781704","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Dos de vuit","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-midx~7fjh_q3kg",":version":"rv-bnxp_ydbg-bz22",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc infantil de Sant Francesc","indicador_refugi":"431613|PARC_INFANTIL_DE_SANT_FRANCESC","municipi":"Valls","codi_municipi":"431613","latitud":"41.28378379","longitud":"1.25176322","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Sant Francesc","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-idfn~8k97-ydxp",":version":"rv-m79q_ez6j.yp67",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu de Valls","indicador_refugi":"431613|MUSEU_DE_VALLS","municipi":"Valls","codi_municipi":"431613","latitud":"41.28884745","longitud":"1.25199501","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. dels Caputxins, 18","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-2qn5~ne92_9chn",":version":"rv-4fe6~u7sy.a7sq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Passeig de l\'Estaci\xf3","indicador_refugi":"431613|PASSEIG_DE_L_ESTACIO","municipi":"Valls","codi_municipi":"431613","latitud":"41.28767259","longitud":"1.25628094","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. de l\'Estaci\xf3","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-q5mq-pb8k_hn2c",":version":"rv-frrp.tqen.knvn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Mas Miquel","indicador_refugi":"431613|PARC_MAS_MIQUEL","municipi":"Valls","codi_municipi":"431613","latitud":"41.28589316","longitud":"1.25603359","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Pau Parellada","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-te8q-an37~hrt8",":version":"rv-pzqn-hfdf_6k38",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Zona verda carrer Onze de Setembre","indicador_refugi":"431613|ZONA_VERDA_CARRER_ONZE_DE_SETEMBRE","municipi":"Valls","codi_municipi":"431613","latitud":"41.29299977","longitud":"1.24739727","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Onze de Setembre","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-2tkx.szwt.yw38",":version":"rv-t7yj_eqdr.4tz5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Passeig President Companys","indicador_refugi":"431613|PASSEIG_PRESIDENT_COMPANYS","municipi":"Valls","codi_municipi":"431613","latitud":"41.29386797","longitud":"1.25852588","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. President Companys","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-z9ju-cwxp_z892",":version":"rv-7e7t_kwbf_5kuq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Vallsgenera","indicador_refugi":"431613|VALLSGENERA","municipi":"Valls","codi_municipi":"431613","latitud":"41.28849451","longitud":"1.25235594","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. del Pla, 37 A","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-7e64.dyh2_f4dc",":version":"rv-54t6-uxbc~7v2k",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Pompeu Fabra","indicador_refugi":"431613|PLACA_POMPEU_FABRA","municipi":"Valls","codi_municipi":"431613","latitud":"41.28774159","longitud":"1.24645444","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Pompeu Fabra","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-uf76-huy8.6yxw",":version":"rv-bvp8_py8n_5jff",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc infantil Alentorn Ballester (barri del Bon Sol)","indicador_refugi":"431613|PARC_INFANTIL_ALENTORN_BALLESTER_BARRI_DEL_BON_SOL","municipi":"Valls","codi_municipi":"431613","latitud":"41.28584576","longitud":"1.26894466","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Alentorn Ballester, 7B","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-5uvq_y77b-rjzn",":version":"rv-wnpw-7k8d~98v2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ca Xapes","indicador_refugi":"431613|CA_XAPES","municipi":"Valls","codi_municipi":"431613","latitud":"41.2855","longitud":"1.2493","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Muralla Sant Antoni, 97","informacio_web":"Juliol: de dilluns a divendres de 9 h a 13 h i de 15 h a 20 h. Dissabtes de 16 h a 21 h. Diumenges: de 17 h a 20 h","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-05T12:05:00.000"},{":id":"row-tmn2~t7qe.jau4",":version":"rv-m2e6_5t9c.rz4m",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc infantil Vilar","indicador_refugi":"431613|PARC_INFANTIL_VILAR","municipi":"Valls","codi_municipi":"431613","latitud":"41.2872","longitud":"1.2585","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Vila Romana","informacio_web":"Espai exterior","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-05T12:12:00.000"},{":id":"row-9r5y-dpdw-eu6k",":version":"rv-szga.ama7.tywt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Carles Card\xf3","indicador_refugi":"431613|BIBLIOTECA_CARLES_CARDO","municipi":"Valls","codi_municipi":"431613","latitud":"41.2844","longitud":"1.2495","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Pilar Prim","informacio_web":"De dilluns a dijous de 10 h a 14 h i de 16 h a 20 h. Divendres: de 10 h a 14 h","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-05T12:32:00.000"},{":id":"row-23zv.pajw-4h2g",":version":"rv-rf3w.i8py_3xy8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bar de Noves de Segre","indicador_refugi":"259062|BAR_DE_NOVES_DE_SEGRE","municipi":"Valls d\'Aguilar, les","codi_municipi":"259062","latitud":"42.29411","longitud":"1.3418168","accessibilitat":"No","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Diputat Garriga, 3","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-dieg-aci8_v79x",":version":"rv-p3j4~jw4j~qvs8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Vandell\xf2s","indicador_refugi":"431628|PISCINA_VANDELLOS","municipi":"Vandell\xf2s i l\'Hospitalet de l\'Infant","codi_municipi":"431628","latitud":"41.01841344","longitud":"0.83184656","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de les Flors","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-rbzh-yzds-hyxm",":version":"rv-jcyv.k3xy.6nmj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Masboquera","indicador_refugi":"431628|PISCINA_MASBOQUERA","municipi":"Vandell\xf2s i l\'Hospitalet de l\'Infant","codi_municipi":"431628","latitud":"41.01934912","longitud":"0.8578454","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Baix","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-2g34~t6m3_2wpd",":version":"rv-ts2c-uezj.72sa",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Hospitalet de L\'Infant","indicador_refugi":"431628|PISCINA_HOSPITALET_DE_L_INFANT","municipi":"Vandell\xf2s i l\'Hospitalet de l\'Infant","codi_municipi":"431628","latitud":"40.99181398","longitud":"0.91374927","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de la Porrassa, 17","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-7bjd_6m5k~vd9y",":version":"rv-ri8x~yazk-yy2z",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Antigues Escoles","indicador_refugi":"431628|ANTIGUES_ESCOLES","municipi":"Vandell\xf2s i l\'Hospitalet de l\'Infant","codi_municipi":"431628","latitud":"41.01873748","longitud":"0.85738321","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Arrabal, 2-10","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-rf4u-6ycm_vst6",":version":"rv-fy7x.vscb_uwxj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Les antigues Escoles","indicador_refugi":"431628|LES_ANTIGUES_ESCOLES","municipi":"Vandell\xf2s i l\'Hospitalet de l\'Infant","codi_municipi":"431628","latitud":"41.01878994","longitud":"0.88660513","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Nou","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-x383-pu2g.rg4f",":version":"rv-55nm~tbum~vdfh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala Polivalent del Pavell\xf3 Cobert Esportiu municipal","indicador_refugi":"431628|SALA_POLIVALENT_DEL_PAVELLO_COBERT_ESPORTIU_MUNICIPAL","municipi":"Vandell\xf2s i l\'Hospitalet de l\'Infant","codi_municipi":"431628","latitud":"41.01821799","longitud":"0.83243648","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Les flors, 34","tipologia":"Poliesportiu","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-2ex8~fcqp~dssu",":version":"rv-kns3.5577~53qq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de jubilats de L\'Hospitalet de L\'Infant","indicador_refugi":"431628|CASAL_DE_JUBILATS_DE_L_HOSPITALET_DE_L_INFANT","municipi":"Vandell\xf2s i l\'Hospitalet de l\'Infant","codi_municipi":"431628","latitud":"40.99305501","longitud":"0.9195187","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Alamanda, 6","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-xpqd.mui8_5qza",":version":"rv-7bkw.8e5m.wfup",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Joves Vandell\xf2s","indicador_refugi":"431628|CASAL_DE_JOVES_VANDELLOS","municipi":"Vandell\xf2s i l\'Hospitalet de l\'Infant","codi_municipi":"431628","latitud":"41.01825281","longitud":"0.83228396","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ptge. Cal Marino, s/n","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-aavj-jbsb.daf5",":version":"rv-7t57_mh7u_p8fy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa de Cultura Blanca d\'Anjou","indicador_refugi":"431628|CASA_DE_CULTURA_BLANCA_D_ANJOU","municipi":"Vandell\xf2s i l\'Hospitalet de l\'Infant","codi_municipi":"431628","latitud":"40.99292831","longitud":"0.92138963","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de les Escoles, 12","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-z7hz.yp9t~pwxv",":version":"rv-2p9k-evju~ff6w",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bar Restaurant Casal de Jubilats de Vandell\xf2s","indicador_refugi":"431628|BAR_RESTAURANT_CASAL_DE_JUBILATS_DE_VANDELLOS","municipi":"Vandell\xf2s i l\'Hospitalet de l\'Infant","codi_municipi":"431628","latitud":"41.02088841","longitud":"0.83152201","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. Hospitalet-Mora, 39","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-4rbg.6vxv~jeij",":version":"rv-gh9y~x77x-8wuf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La P\xe8rgola","indicador_refugi":"431628|LA_PERGOLA","municipi":"Vandell\xf2s i l\'Hospitalet de l\'Infant","codi_municipi":"431628","latitud":"40.9895118814475","longitud":"0.9208656610309296","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Coll de Balaguer","informacio_web":"Web Ajuntament de Vandell\xf2s i l\'Hospitalet de l\'Infant","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T13:23:00.000"},{":id":"row-62rf-ya36.6x7w",":version":"rv-gu6u.vbyf.582m",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parr\xf2quia de Sant Pere Ap\xf2stol","indicador_refugi":"431628|PARROQUIA_DE_SANT_PERE_APOSTOL","municipi":"Vandell\xf2s i l\'Hospitalet de l\'Infant","codi_municipi":"431628","latitud":"40.99063896539079","longitud":"0.9234760558985282","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a de l\'esgl\xe9sia, 1","informacio_web":"Web Ajuntament de Vandell\xf2s i l\'Hospitalet de l\'Infant","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T13:40:00.000"},{":id":"row-i7kt_nsmi.ncrc",":version":"rv-9vwx_6v88~39ja",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari El Vendrell","indicador_refugi":"431634|CASAL_CIVIC_I_COMUNITARI_EL_VENDRELL","municipi":"Vendrell, el","codi_municipi":"431634","latitud":"41.2233024","longitud":"1.5317749","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de l\'U d\'Octubre, 12-14 (antic C. del General Prim)","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-tcd2.hd96~6u8u",":version":"rv-3g9b~yq8k.vc8s",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca p\xfablica Terra Baixa","indicador_refugi":"431634|BIBLIOTECA_PUBLICA_TERRA_BAIXA","municipi":"Vendrell, el","codi_municipi":"431634","latitud":"41.220041868790965","longitud":"1.5340931590842855","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Major, 18","informacio_web":"https://www.bibliotecaelvendrell.cat/","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-30T18:15:00.000"},{":id":"row-xbwr-sbrn~veq2",":version":"rv-rzzb~dx5w.s5jd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic l\'Estaci\xf3","indicador_refugi":"431634|CENTRE_CIVIC_LESTACIO","municipi":"Vendrell, el","codi_municipi":"431634","latitud":"41.22127777848576","longitud":"1.5377759831149023","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda d\'en Jaume Carner, 1","informacio_web":"http://www.elvendrell.net/centre-civic-l-estacio","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-30T18:18:00.000"},{":id":"row-qcrh~u9hh~e8tn",":version":"rv-6htw.an35-9pmr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa Museu \xc0ngel Guimer\xe0","indicador_refugi":"431634|CASA_MUSEU_ANGEL_GUIMERA","municipi":"Vendrell, el","codi_municipi":"431634","latitud":"41.22201563589469","longitud":"1.5344165874448015","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Santa Anna, 10","informacio_web":"https://museus.elvendrell.net/casa-museu-angel-guimera/","tipologia":"Equipament Cultural (teatre, auditori, museu)","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-30T18:21:00.000"},{":id":"row-aush~hvsn~5f2d",":version":"rv-yr24~k8kn~277m",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu Deu","indicador_refugi":"431634|MUSEU_DEU","municipi":"Vendrell, el","codi_municipi":"431634","latitud":"41.221565346134284","longitud":"1.5343684609551744","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Nova, 6","informacio_web":"https://museus.elvendrell.net/museu-deu/","tipologia":"Equipament Cultural (teatre, auditori, museu)","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-30T18:23:00.000"},{":id":"row-fjvy.u24g~pjgv",":version":"rv-ukxx_2gr9-v52p",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Tabaris, museu fires i congressos","indicador_refugi":"431634|TABARIS_MUSEU_FIRES_I_CONGRESSOS","municipi":"Vendrell, el","codi_municipi":"431634","latitud":"41.18193443603985","longitud":"1.523277412126071","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda Balneari, 3","informacio_web":"https://tabaris.net/","tipologia":"Equipament Cultural (teatre, auditori, museu)","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-30T18:26:00.000"},{":id":"row-jv79.25ys-5w7z",":version":"rv-x3tn_iqev.8ub2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa Nadiua Pau Casals","indicador_refugi":"431634|CASA_NADIUA_PAU_CASALS","municipi":"Vendrell, el","codi_municipi":"431634","latitud":"41.22193784903992","longitud":"1.5345265686375487","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Santa Anna, 4","informacio_web":"https://museus.elvendrell.net/casa-nadiua-de-pau-casals/","tipologia":"Equipament Cultural (teatre, auditori, museu)","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-30T18:29:00.000"},{":id":"row-cvvz-q3uy_4grh",":version":"rv-27if~utbh~ywky",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala Portal del Pardo","indicador_refugi":"431634|SALA_PORTAL_DEL_PARDO","municipi":"Vendrell, el","codi_municipi":"431634","latitud":"41.22021751249056","longitud":"1.5339485379546873","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Major, 20","informacio_web":"https://museus.elvendrell.net/sala-portal-del-pardo/","tipologia":"Equipament Cultural (teatre, auditori, museu)","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-30T18:31:00.000"},{":id":"row-s4qm_t93x_nuj8",":version":"rv-gkxp_uxzu_m3z4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic de Coma-ruga","indicador_refugi":"431634|CENTRE_CIVIC_DE_COMA-RUGA","municipi":"Vendrell, el","codi_municipi":"431634","latitud":"41.184623626059334","longitud":"1.5217198977934148","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"No","adreca":"Avinguda de la Generalitat, 32","informacio_web":"https://www.elvendrell.net/centre-civic-coma-ruga","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-30T18:33:00.000"},{":id":"row-jysv~rg3a_sjj9",":version":"rv-ti6d~3b3y-ppir",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament","indicador_refugi":"431634|AJUNTAMENT","municipi":"Vendrell, el","codi_municipi":"431634","latitud":"41.220234092700416","longitud":"1.5347702091193332","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Vella, 1","informacio_web":"http://www.elvendrell.net/","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-30T18:35:00.000"},{":id":"row-kqqu-iv4x_hf27",":version":"rv-qrmu~wvde-tdbd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Roquetes","indicador_refugi":"431634|PARC_ROQUETES","municipi":"Vendrell, el","codi_municipi":"431634","latitud":"41.22279692471635","longitud":"1.5234701702725315","accessibilitat":"No","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de les Roquetes, s/n","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-30T18:37:00.000"},{":id":"row-vvmz.5eem_kk8p",":version":"rv-bjfd.stz9_m2hu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"El Puig","indicador_refugi":"431634|EL_PUIG","municipi":"Vendrell, el","codi_municipi":"431634","latitud":"41.218444328023644","longitud":"1.5396730877690685","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Josep Tarradellas, s/n","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-30T18:39:00.000"},{":id":"row-322x_msdw_ipud",":version":"rv-7jqs.a6a2~parr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de la Font","indicador_refugi":"431634|PLACA_DE_LA_FONT","municipi":"Vendrell, el","codi_municipi":"431634","latitud":"41.20472565161424","longitud":"1.5150119574460708","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de les Basses, 5","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-30T18:41:00.000"},{":id":"row-fscf.e76z_96ej",":version":"rv-8vky-av62_b65m",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"\xc0rea Recreativa del Fondo del Mata","indicador_refugi":"431634|AREA_RECREATIVA_DEL_FONDO_DEL_MATA","municipi":"Vendrell, el","codi_municipi":"431634","latitud":"41.18968622621279","longitud":"1.4977485244589386","accessibilitat":"No","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Cam\xed de les Pedreres, s/n","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-30T18:43:00.000"},{":id":"row-qres-t4f8_nn3g",":version":"rv-fkf4-4ri2-y257",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ermita de Sant Salvador","indicador_refugi":"431634|ERMITA_DE_SANT_SALVADOR","municipi":"Vendrell, el","codi_municipi":"431634","latitud":"41.185444924478276","longitud":"1.5444057411539556","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carretera de Sant Salvador, 18","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-30T18:45:00.000"},{":id":"row-365t~zyfu_utxn",":version":"rv-fq2t.zzgd.vb6z",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Muntanyeta","indicador_refugi":"431634|PARC_DE_LA_MUNTANYETA","municipi":"Vendrell, el","codi_municipi":"431634","latitud":"41.22238791974624","longitud":"1.5436313700391577","accessibilitat":"No","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de la Rosa, s/n","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-30T18:48:00.000"},{":id":"row-2284.43c5_ghiu",":version":"rv-qz6t.wvr3~6uuc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Ciutat d\'Utrera","indicador_refugi":"431634|PARC_DE_LA_CIUTAT_DUTRERA","municipi":"Vendrell, el","codi_municipi":"431634","latitud":"41.21912430823926","longitud":"1.5249078667899596","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de la Garrotxa, s/n","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-30T18:50:00.000"},{":id":"row-df6p~d7g2-nwt9",":version":"rv-xn7i-k7y9-a7bh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc dels Teletubbies","indicador_refugi":"431634|PARC_DELS_TELETUBBIES","municipi":"Vendrell, el","codi_municipi":"431634","latitud":"41.221979537861024","longitud":"1.5214944667901305","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Alt Urgell, 32","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-30T18:52:00.000"},{":id":"row-g4vf.hsxe-tnww",":version":"rv-h72a-6xhg.xrub",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"El Riuet de Coma-ruga","indicador_refugi":"431634|EL_RIUET_DE_COMA-RUGA","municipi":"Vendrell, el","codi_municipi":"431634","latitud":"41.180237212005906","longitud":"1.5241650066295913","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"No","lavabo":"No","adreca":"Pla\xe7a Trillas, s/n","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-30T18:54:00.000"},{":id":"row-q7q2.vgzn_hbn2",":version":"rv-i47w.w55w_xfw6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Antic Dispensari - Local entitats","indicador_refugi":"172116|ANTIC_DISPENSARI_LOCAL_ENTITATS","municipi":"Verges","codi_municipi":"172116","latitud":"42.06051686","longitud":"3.04676076","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Plta. de l\'1 d\'octubre, 1","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-6b8n_e88p.26vv",":version":"rv-yjfb-gm6c_anik",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Santa Anna","indicador_refugi":"082981|PARC_SANTA_ANNA","municipi":"Vic","codi_municipi":"082981","latitud":"41.92022549","longitud":"2.25821225","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc Santa Anna","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-qa4x_w9bz.9rew",":version":"rv-zfr8_ewrv-ffmp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Francesc Moragas","indicador_refugi":"082981|PLACA_FRANCESC_MORAGAS","municipi":"Vic","codi_municipi":"082981","latitud":"41.92318675","longitud":"2.25558545","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Francesc Moragas","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-2kgr~a653.zpqh",":version":"rv-nqn4-kydx_87xn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Divina Pastora","indicador_refugi":"082981|PLACA_DIVINA_PASTORA","municipi":"Vic","codi_municipi":"082981","latitud":"41.93103051","longitud":"2.26054215","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Divina Pastora","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-ujqg-gx4x_ug3w",":version":"rv-nnxp_m7rc_x6k7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de l\u2019Horta Vermella","indicador_refugi":"082981|PARC_DE_L_HORTA_VERMELLA","municipi":"Vic","codi_municipi":"082981","latitud":"41.92226414","longitud":"2.26095224","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc de l\u2019Horta Vermella","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-hwqm~8pr5~ya7j",":version":"rv-k25h-mwdx~uju4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Jaume Balmes","indicador_refugi":"082981|PARC_JAUME_BALMES","municipi":"Vic","codi_municipi":"082981","latitud":"41.92673874","longitud":"2.25374517","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc Jaume Balmes","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-6c8t~h5sa.7nbi",":version":"rv-ygez.i37d.p3ta",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Can Forcada","indicador_refugi":"082981|PARC_CAN_FORCADA","municipi":"Vic","codi_municipi":"082981","latitud":"41.92933925","longitud":"2.25145694","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc Can Forcada","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-5i5j~i586_j2hd",":version":"rv-7rnz-yemp.e69w",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Fra Joan","indicador_refugi":"082981|PLACA_FRA_JOAN","municipi":"Vic","codi_municipi":"082981","latitud":"41.92204963","longitud":"2.24915627","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"No","adreca":"Pl. Fra Joan","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-xgi9-hbjy.jeui",":version":"rv-bq6m.sw45~v2g8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Josep Maria Pericas","indicador_refugi":"082981|PLACA_JOSEP_MARIA_PERICAS","municipi":"Vic","codi_municipi":"082981","latitud":"41.92404184","longitud":"2.26141954","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. Josep Maria Pericas","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-djqt.x5mf.649z",":version":"rv-56yy_zv7g.tx7w",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Blanqueig","indicador_refugi":"082981|PARC_DEL_BLANQUEIG","municipi":"Vic","codi_municipi":"082981","latitud":"41.92312034","longitud":"2.24838704","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc del Blanqueig","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-bgjn-u3c9~n9t4",":version":"rv-2bbu~9kfr-pw77",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Interior Illa C. Ermita de Sant Sixt","indicador_refugi":"082981|INTERIOR_ILLA_C_ERMITA_DE_SANT_SIXT","municipi":"Vic","codi_municipi":"082981","latitud":"41.92966027","longitud":"2.23902594","accessibilitat":"S\xed","aigua":"No","area_descans":"No","adreca":"C. Ermita de Sant Sixt","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-v5ca.kbak.jpdd",":version":"rv-tzzt-zahy_hwwq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc d\u2019Occit\xe0nia","indicador_refugi":"082981|PARC_D_OCCITANIA","municipi":"Vic","codi_municipi":"082981","latitud":"41.93075427","longitud":"2.24351161","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc d\u2019Occit\xe0nia","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-ktby~29pg~sja8",":version":"rv-udqs_ihqq.45ws",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Passeig Pep Ventura","indicador_refugi":"082981|PASSEIG_PEP_VENTURA","municipi":"Vic","codi_municipi":"082981","latitud":"41.92488174","longitud":"2.24676176","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pg. Pep Ventura","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-cxj6.78bg.556j",":version":"rv-68jx_832f_7kcy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Pla del Maset","indicador_refugi":"082981|PARC_PLA_DEL_MASET","municipi":"Vic","codi_municipi":"082981","latitud":"41.91318967","longitud":"2.23032939","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc Pla del Maset","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-my3y-7r7a.pdvx",":version":"rv-58dq~nms7.hgau",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Vall de Sau","indicador_refugi":"082981|PARC_VALL_DE_SAU","municipi":"Vic","codi_municipi":"082981","latitud":"41.92902019","longitud":"2.26486973","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc Vall de Sau","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-unwc-kdcx-955a",":version":"rv-ck3e_wxah_avap",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Josep Maria Anglada Abadal","indicador_refugi":"082981|PARC_JOSEP_MARIA_ANGLADA_ABADAL","municipi":"Vic","codi_municipi":"082981","latitud":"41.92893893","longitud":"2.25384785","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Parc Josep Maria Anglada Abadal","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-695m.7644~hebt",":version":"rv-4pif-89w4.zp4s",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Doctor Jordi Sala","indicador_refugi":"082981|PARC_DOCTOR_JORDI_SALA","municipi":"Vic","codi_municipi":"082981","latitud":"41.93460225","longitud":"2.24890071","accessibilitat":"S\xed","aigua":"No","area_descans":"No","adreca":"Parc Doctor Jordi Sala","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-vyty_6wky~t3d5",":version":"rv-p7gz.jpdq_n3ck",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Passatge Sant Marc","indicador_refugi":"082981|PASSATGE_SANT_MARC","municipi":"Vic","codi_municipi":"082981","latitud":"41.91800765","longitud":"2.2563761","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"No","adreca":"Ptge. Sant Marc","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-2p7v.c6ky-4h6m",":version":"rv-pis7.ssfi.7s4g",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Sant Jaume","indicador_refugi":"082981|PARC_SANT_JAUME","municipi":"Vic","codi_municipi":"082981","latitud":"41.92140693","longitud":"2.25822331","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc Sant Jaume","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-qepw-kn2q-4an8",":version":"rv-4urs-qyfn.8j3y",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Santa Clara Vella","indicador_refugi":"082981|PARC_SANTA_CLARA_VELLA","municipi":"Vic","codi_municipi":"082981","latitud":"41.93380465","longitud":"2.25942849","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc Santa Clara Vella","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-svyv-susn_a8jh",":version":"rv-cqzb~fa2e.cgjj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc F\xe8lix Maci\xe0 Bonaplata","indicador_refugi":"082981|PARC_FELIX_MACIA_BONAPLATA","municipi":"Vic","codi_municipi":"082981","latitud":"41.93060046","longitud":"2.26186938","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc F\xe8lix Maci\xe0 Bonaplata","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-y94m~p5zr-r9ar",":version":"rv-5cc2~ku2h~srab",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Horta de\u2019n Pau","indicador_refugi":"082981|PARC_HORTA_DE_N_PAU","municipi":"Vic","codi_municipi":"082981","latitud":"41.92508226","longitud":"2.24934262","accessibilitat":"S\xed","aigua":"No","area_descans":"No","adreca":"Parc Horta de\u2019n Pau","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-wjmk.xxcd~sd6j",":version":"rv-h49z-pcmg_mezf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Renfe - Mn. Gudiol","indicador_refugi":"082981|RENFE_MN_GUDIOL","municipi":"Vic","codi_municipi":"082981","latitud":"41.92960608","longitud":"2.24878377","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Renfe - Mn Gudiol","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-n569~kagm-yrfj",":version":"rv-enas-mzm5-mmxi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de l\u2019Avinguda dels Pa\xefsos Catalans amb el carrer del Remei","indicador_refugi":"082981|PARC_DE_L_AVINGUDA_DELS_PAISOS_CATALANS_AMB_EL_CARRER_DEL_REMEI","municipi":"Vic","codi_municipi":"082981","latitud":"41.92103259","longitud":"2.24914247","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc de l\u2019Av. dels Pa\xefsos Catalans amb el C. del Remei","tipologia":"Parc densament arbrat","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-mzu8-8nsp.5ncy",":version":"rv-htj4-6adf_272d",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Era d\'en Sell\xe9s","indicador_refugi":"082981|PARC_ERA_DEN_SELLES","municipi":"Vic","codi_municipi":"082981","latitud":"41.93524157438571","longitud":"2.253290286399838","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer d\'At\xf3, Bisbe","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-19T12:47:00.000"},{":id":"row-c8wm~4ifx_tp3b",":version":"rv-aa9i.pqgq.pr5k",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Horta de la S\xednia","indicador_refugi":"082981|PARC_HORTA_DE_LA_SINIA","municipi":"Vic","codi_municipi":"082981","latitud":"41.91978361459529","longitud":"2.2499232497815775","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. Pa\xefsos Catalans","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-19T12:52:00.000"},{":id":"row-den3.8275_2svr",":version":"rv-kvmm_arm4-2eji",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Jaume Portell","indicador_refugi":"082981|PARC_JAUME_PORTELL","municipi":"Vic","codi_municipi":"082981","latitud":"41.92654447211196","longitud":"2.257621419473653","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer dels Pellaires","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-19T12:54:00.000"},{":id":"row-4ucn-zv5p~eces",":version":"rv-hpjj-didg_9c7p",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Miquel Coll i Alentorn","indicador_refugi":"082981|PARC_MIQUEL_COLL_I_ALENTORN","municipi":"Vic","codi_municipi":"082981","latitud":"41.9143229620239","longitud":"2.256599455954583","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. Rafael de Casanova","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-19T12:56:00.000"},{":id":"row-ccvp_j5mn~ez3n",":version":"rv-6tqz~gbia~yzc6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Pasqual Blanca","indicador_refugi":"082981|PARC_PASQUAL_BLANCA","municipi":"Vic","codi_municipi":"082981","latitud":"41.935196243855245","longitud":"2.262583877005662","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. de Sant Bernat Calb\xf3","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-19T12:59:00.000"},{":id":"row-cptc~qg7q~me6w",":version":"rv-u6mi-hemp~xdb3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Sant Llatzer","indicador_refugi":"082981|PARC_SANT_LLATZER","municipi":"Vic","codi_municipi":"082981","latitud":"41.9278856658995","longitud":"2.2730638161068035","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. de Miquel dels Sants Salarich i Torrents","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-19T13:01:00.000"},{":id":"row-cibt_5e74.9wzm",":version":"rv-hrji~xrpd_4pxd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Xavier Roca i Vi\xf1as","indicador_refugi":"082981|PARC_XAVIER_ROCA_I_VI\xd1AS","municipi":"Vic","codi_municipi":"082981","latitud":"41.92663523015437","longitud":"2.2660393150664953","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer del Prat d\'en Galliners","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-19T13:03:00.000"},{":id":"row-v5qr-fzz9-uurp",":version":"rv-4zvu-qrkc.34sw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Club Nataci\xf3 Vic \u2013 ETB","indicador_refugi":"082981|CLUB_NATACIO_VIC_\u2013_ETB","municipi":"Vic","codi_municipi":"082981","latitud":"41.92043001842664","longitud":"2.256440649613599","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Josep Maria Pall\xe0s, 1","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-19T13:10:00.000"},{":id":"row-fq7c-gj3g~mexy",":version":"rv-i3ev_abvu.nith",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Esportiu Municipal Pat\xed Vic","indicador_refugi":"082981|CENTRE_ESPORTIU_MUNICIPAL_PATI_VIC","municipi":"Vic","codi_municipi":"082981","latitud":"41.93266540718037","longitud":"2.2401649656879434","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda Ol\xedmpia, 15","informacio_web":"https://www.vic.cat/serveis/esports/esports/centre-esportiu-municipal-pati-vic","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-19T13:12:00.000"},{":id":"row-w723-9paj.vtcf",":version":"rv-dbad~q9gq~9tif",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Pilar\xedn Bay\xe9s","indicador_refugi":"082981|BIBLIOTECA_PILARIN_BAYES","municipi":"Vic","codi_municipi":"082981","latitud":"41.92491925331466","longitud":"2.253948628262944","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Passeig de la Generalitat, 1","informacio_web":"https://www.bibliotecapilarinbayes.cat/","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-19T13:16:00.000"},{":id":"row-b4xa~i353.3jnw",":version":"rv-ms8t~8qpc~ss8r",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Joan Rigau i Sala","indicador_refugi":"172137|BIBLIOTECA_JOAN_RIGAU_I_SALA","municipi":"Vidreres","codi_municipi":"172137","latitud":"41.78849327","longitud":"2.78100251","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Orient, 18","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-sbxr.s49c~zjkg",":version":"rv-6x3e_y7q8.ewdp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Can Ribotic","indicador_refugi":"172155|CAN_RIBOTIC","municipi":"Vilablareix","codi_municipi":"172155","latitud":"41.95228524","longitud":"2.7936114","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Perell\xf3, 124","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-edb5.mrxs.kbmf",":version":"rv-zkik.8u7w.d3m4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"172155|PISCINA_MUNICIPAL","municipi":"Vilablareix","codi_municipi":"172155","latitud":"41.95294995","longitud":"2.79353799","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Trav. Marroc, 5","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-xh57~vee3_7jbs",":version":"rv-wqmi-tkdk~apt4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic De Viladamat","indicador_refugi":"172174|CENTRE_CIVIC_DE_VILADAMAT","municipi":"Viladamat","codi_municipi":"172174","latitud":"42.13258299","longitud":"3.0743858","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de l\'1 d\'octubre, 1","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-jiqe~hqjz_gc9n",":version":"rv-we25~9uy4_gkgb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"ESCOLES GALLINERS","indicador_refugi":"172180|ESCOLES_GALLINERS","municipi":"Vilademuls","codi_municipi":"172180","latitud":"42.14869","longitud":"2.873225","accessibilitat":"No","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"GIV 5131","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T10:46:00.000"},{":id":"row-3xqn_bcj6_9a44",":version":"rv-pnif~bb3t_c6rb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"LOCAL 1 D\'OCTUBRE","indicador_refugi":"172180|LOCAL_1_DOCTUBRE","municipi":"Vilademuls","codi_municipi":"172180","latitud":"42.11523","longitud":"2.87449","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"SANT ESTEVE DE GUIALBES","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T10:51:00.000"},{":id":"row-5ppu_cmqt-xu5n",":version":"rv-wpfv-j8zi-yckp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"TEATRE-LOCAL POLIVALENT","indicador_refugi":"172180|TEATRE-LOCAL_POLIVALENT","municipi":"Vilademuls","codi_municipi":"172180","latitud":"42.083726","longitud":"2.882622","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"VILAFRESER","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T10:54:00.000"},{":id":"row-ej3w~cs6n_w9n5",":version":"rv-g93j~xe7b~mm3q",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai jove La Nau","indicador_refugi":"083054|ESPAI_JOVE_LA_NAU","municipi":"Vilafranca del Pened\xe8s","codi_municipi":"083054","latitud":"41.355344","longitud":"1.70352","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"c/ Balt\xe0 de Cela, 45-47","informacio_web":"https://mediambient.vilafranca.cat/sostenibilitat/refugis-climatics","tipologia":"Centre C\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-22T14:34:00.000"},{":id":"row-rnnr_ausi~j3ed",":version":"rv-m3kg.hkng.qvce",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la gent gran de l\'Espirall","indicador_refugi":"083054|CASAL_DE_LA_GENT_GRAN_DE_L_ESPIRALL","municipi":"Vilafranca del Pened\xe8s","codi_municipi":"083054","latitud":"41.35388863","longitud":"1.70161546","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Gelida, 15","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-fkfb~sp3n_vyuf",":version":"rv-q9g2~jha7-93m9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la gent gran del T\xedvoli","indicador_refugi":"083054|CASAL_DE_LA_GENT_GRAN_DEL_TIVOLI","municipi":"Vilafranca del Pened\xe8s","codi_municipi":"083054","latitud":"41.34292081","longitud":"1.69773431","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Parlament, 14","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-wanh.rczp-d5fi",":version":"rv-n6bq~wquj-gjw3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Oficina de turisme","indicador_refugi":"083054|OFICINA_DE_TURISME","municipi":"Vilafranca del Pened\xe8s","codi_municipi":"083054","latitud":"41.34613262","longitud":"1.69631005","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Hermenegild Clascar, 2","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-vfii~j6ym-mm2g",":version":"rv-bh8x~mimb~t9hv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Vilafranca del Pened\xe8s","indicador_refugi":"083054|CASAL_CIVIC_I_COMUNITARI_VILAFRANCA_DEL_PENEDES","municipi":"Vilafranca del Pened\xe8s","codi_municipi":"083054","latitud":"41.348478","longitud":"1.1203958","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Peguera, 1","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-vjn8_xj44_qgef",":version":"rv-6837-tbmr-9p6f",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"L\'escorxador","indicador_refugi":"083054|L_ESCORXADOR","municipi":"Vilafranca del Pened\xe8s","codi_municipi":"083054","latitud":"41.34938655","longitud":"1.69683577","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Escorxador, 19","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-usgc.iehd_pvie",":version":"rv-vefu_mr3r-swhw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Creu Roja Vilafranca","indicador_refugi":"083054|CREU_ROJA_VILAFRANCA","municipi":"Vilafranca del Pened\xe8s","codi_municipi":"083054","latitud":"41.34378887","longitud":"1.69200547","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Eugeni d\'Ors, 22","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-reg5.3v3d-rn3r",":version":"rv-jcep_jnqs_wvwk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Torras I Bages","indicador_refugi":"083054|BIBLIOTECA_TORRAS_I_BAGES","municipi":"Vilafranca del Pened\xe8s","codi_municipi":"083054","latitud":"41.347603","longitud":"1.695762","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a de l\'Oli, 20","informacio_web":"https://mediambient.vilafranca.cat/sostenibilitat/refugis-climatics","tipologia":"Equipament Cultural (teatre, auditori, museu)","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-22T14:40:00.000"},{":id":"row-twnc.jei4.ammz",":version":"rv-bfp5_a9ef.66vp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Vinseum","indicador_refugi":"083054|VINSEUM","municipi":"Vilafranca del Pened\xe8s","codi_municipi":"083054","latitud":"41.34676489","longitud":"1.69686795","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de Jaume I, 1","tipologia":"Espai cultural","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-n5nj~npv3_9cmh",":version":"rv-wegr-anx7~32iq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Complex Aqu\xe0tic (hall)","indicador_refugi":"083054|COMPLEX_AQUATIC_HALL","municipi":"Vilafranca del Pened\xe8s","codi_municipi":"083054","latitud":"41.34832743","longitud":"1.68340326","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Antic de Sant Mart\xed, 12","tipologia":"Poliesportiu","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-skiy-zdsg_abg8",":version":"rv-n3hb-fgfz_rh95",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bas\xedlica de Santa Maria","indicador_refugi":"083054|BASILICA_DE_SANTA_MARIA","municipi":"Vilafranca del Pened\xe8s","codi_municipi":"083054","latitud":"41.34712","longitud":"1.697198","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a de Jaume I, 2","informacio_web":"https://mediambient.vilafranca.cat/sostenibilitat/refugis-climatics","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-22T13:29:00.000"},{":id":"row-mu9x_mgpa-ke5g",":version":"rv-u475.yxek-wkpp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat Sant Salvador","indicador_refugi":"083054|MERCAT_SANT_SALVADOR","municipi":"Vilafranca del Pened\xe8s","codi_municipi":"083054","latitud":"41.342043","longitud":"1.69297","accessibilitat":"S\xed","aigua":"No","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"c/ Francesc Maci\xe0, 1","informacio_web":"https://mediambient.vilafranca.cat/sostenibilitat/refugis-climatics","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-22T14:24:00.000"},{":id":"row-qxbd.57y3.dezr",":version":"rv-v5nu.j5f2.pm62",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Punt de Trobada","indicador_refugi":"172235|CENTRE_CIVIC_PUNT_DE_TROBADA","municipi":"Vilaju\xefga","codi_municipi":"172235","latitud":"42.32758966","longitud":"3.0939555","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. Onze de Setembre, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-x3bs~m3h6~d8pt",":version":"rv-ke59_cnuw_ac3e",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal de Vilaju\xefga","indicador_refugi":"172235|PISCINA_MUNICIPAL_DE_VILAJUIGA","municipi":"Vilaju\xefga","codi_municipi":"172235","latitud":"42.33509168","longitud":"3.09421128","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Zona esportiva Mas Bartret","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-2dv5~wfvk-gwgz",":version":"rv-fi6p.rn8c~d477",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Escola El Div\xed Mestre","indicador_refugi":"431750|ESCOLA_EL_DIVI_MESTRE","municipi":"Vilalba dels Arcs","codi_municipi":"431750","latitud":"41.118283706305185","longitud":"0.4086717095661447","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ Gandesa, S/N","tipologia":"Escola / Institut","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-16T15:50:00.000"},{":id":"row-v3kt~eve2_4y49",":version":"rv-2t8b_x6ep-rcjb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal Rossinyol","indicador_refugi":"431750|CASAL_ROSSINYOL","municipi":"Vilalba dels Arcs","codi_municipi":"431750","latitud":"41.12072529999091","longitud":"0.40775633840189124","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"No","adreca":"C/ Rossinyol, 8","tipologia":"Equipament Cultural (teatre, auditori, museu)","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-16T16:44:00.000"},{":id":"row-tmea~gnzs_nmpb",":version":"rv-e3f9_ukvw.6fb6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament","indicador_refugi":"431750|AJUNTAMENT","municipi":"Vilalba dels Arcs","codi_municipi":"431750","latitud":"41.121182560354605","longitud":"0.4100306955263697","accessibilitat":"No","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"No","adreca":"Pla\xe7a de la Vila, 3","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-16T16:47:00.000"},{":id":"row-mf8v~mk58-wphk",":version":"rv-25ud_uahj-iapb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pavell\xf3 municipal","indicador_refugi":"431750|PAVELLO_MUNICIPAL","municipi":"Vilalba dels Arcs","codi_municipi":"431750","latitud":"41.12161900043192","longitud":"0.4042156664901893","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"No","lavabo":"No","adreca":"C/ Rossinyol, 31","tipologia":"Pavell\xf3 Esportiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-16T16:48:00.000"},{":id":"row-zmpi.bgur.w8i6",":version":"rv-kwrk-wr34~rc53",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Font l\xfadica","indicador_refugi":"083067|FONT_LUDICA","municipi":"Vilalba Sasserra","codi_municipi":"083067","latitud":"41.65394","longitud":"2.4403","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ Montseny, 10","informacio_web":"www.vilalbasasserra.cat","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T13:20:00.000"},{":id":"row-jcfg.9km3-bsbr",":version":"rv-m2m3.dpau-p47f",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"172240|PISCINA_MUNICIPAL","municipi":"Vilallonga de Ter","codi_municipi":"172240","latitud":"42.33126416","longitud":"2.30919195","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Zona Esportiva de Vilallonga de Ter (prop Ctra. GIV-5264)","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-rggx_4e3p.ch3q",":version":"rv-xmz7_crxw.zwcm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca de Vilallonga del Camp","indicador_refugi":"431665|BIBLIOTECA_DE_VILALLONGA_DEL_CAMP","municipi":"Vilallonga del Camp","codi_municipi":"431665","latitud":"41.21071001","longitud":"1.20741793","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Ctra. de Valls, 1, primer pis, 43141 Vilallonga del Camp, Tarragona","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-ikfv-rsxv-rgtq",":version":"rv-fxih_nwrb_s63r",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala Mestre Ramon Tubau","indicador_refugi":"172288|SALA_MESTRE_RAMON_TUBAU","municipi":"Vilanant","codi_municipi":"172288","latitud":"42.25470036","longitud":"2.88988496","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de la placeta, 3","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-m9gw-iiv3.dp8j",":version":"rv-ffad_4h6i_4zy2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines municipals","indicador_refugi":"252483|PISCINES_MUNICIPALS","municipi":"Vilanova de Bellpuig","codi_municipi":"252483","latitud":"41.61720159","longitud":"0.96390413","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. eral, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-95q2~2tzd-rqm5",":version":"rv-ayzf~p9g4_4mt9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Gl\xf2ria Tudela","indicador_refugi":"252483|BIBLIOTECA_GLORIA_TUDELA","municipi":"Vilanova de Bellpuig","codi_municipi":"252483","latitud":"41.61480514","longitud":"0.96110322","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Doctor Gassol, 1","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-eejh.xe5c.5uvb",":version":"rv-2ka2.epew_yv6i",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"LLAR MUNICIPAL GENT GRAN","indicador_refugi":"252483|LLAR_MUNICIPAL_GENT_GRAN","municipi":"Vilanova de Bellpuig","codi_municipi":"252483","latitud":"41.61374324439703","longitud":"0.9619960548644277","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"No","adreca":"CARRER PARE PAC\xcdFIC, 2","informacio_web":"Tots els dies de 16 a 20 h","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-16T13:47:00.000"},{":id":"row-twri.dauf.y4de",":version":"rv-j7tn_tcap_akqz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pavell\xf3 municipal per a usos socioculturals","indicador_refugi":"252542|PAVELLO_MUNICIPAL_PER_A_USOS_SOCIOCULTURALS","municipi":"Vilanova de la Barca","codi_municipi":"252542","latitud":"41.690067","longitud":"0.728856","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ESGL\xc9SIA, S/N","informacio_web":"www.vilanovadelabarca.cat","tipologia":"Sala Polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-02T14:00:00.000"},{":id":"row-f5ts.ayfe_ca9i",":version":"rv-pqbx.v4dq_j64t",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PISCINA MUNICIPAL DE VILANOVA DE SEGRI\xc0","indicador_refugi":"252516|PISCINA_MUNICIPAL_DE_VILANOVA_DE_SEGRIA","municipi":"Vilanova de Segri\xe0","codi_municipi":"252516","latitud":"41.4246","longitud":"0.36574","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ CAM\xcd D\'ALGUAIRE","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-22T21:46:00.000"},{":id":"row-vtfd~7cjn.wu8a",":version":"rv-48tw_pkbd-qa55",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la gent gran","indicador_refugi":"083020|CASAL_DE_LA_GENT_GRAN","municipi":"Vilanova del Cam\xed","codi_municipi":"083020","latitud":"41.57268172","longitud":"1.63946252","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. Sant Josep, 36","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-4cxi~furh.9ir7",":version":"rv-hiss-4i4t~p45k",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre d\'innovaci\xf3 Anoia","indicador_refugi":"083020|CENTRE_D_INNOVACIO_ANOIA","municipi":"Vilanova del Cam\xed","codi_municipi":"083020","latitud":"41.57246534","longitud":"1.65660375","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. dels impressors, 12, Vilanova del Cam\xed","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-xr4y-374q~aa4r",":version":"rv-t47b~h23a-gdaz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal Vilanova del Cam\xed","indicador_refugi":"083020|BIBLIOTECA_MUNICIPAL_VILANOVA_DEL_CAMI","municipi":"Vilanova del Cam\xed","codi_municipi":"083020","latitud":"41.57630165","longitud":"1.63651848","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"C. de la Verge de N\xfaria, 1, 08788 Vilanova del Cam\xed, Barcelona","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-4aa4.fkji~t2nd",":version":"rv-dqi6.7v9i.44k2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai jove Can Muscons","indicador_refugi":"083020|ESPAI_JOVE_CAN_MUSCONS","municipi":"Vilanova del Cam\xed","codi_municipi":"083020","latitud":"41.56899781","longitud":"1.6341234","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Cam\xed del cementiri, 15, 08788 Vilanova del Cam\xed","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-gmm9~bg6j.dzdi",":version":"rv-gxn2.w2as_ec2i",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Barri la Pau","indicador_refugi":"083020|CENTRE_CIVIC_BARRI_LA_PAU","municipi":"Vilanova del Cam\xed","codi_municipi":"083020","latitud":"41.5733499","longitud":"1.64473704","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de la Verge del Cap, 26, 08788 Vilanova del Cam\xed, Barcelona","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-iqdf-wzjj_mmja",":version":"rv-4un6~ep37.4afd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Municipal de Can Rabassa","indicador_refugi":"089024|PISCINA_MUNICIPAL_DE_CAN_RABASSA","municipi":"Vilanova del Vall\xe8s","codi_municipi":"089024","latitud":"41.54297923","longitud":"2.30324135","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Cam\xed de Vilassar, 18, 08410 Vilanova del Vall\xe8s","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:38:00.000"},{":id":"row-dhqa-8t2w_tyk8",":version":"rv-crdk_i2vr.6jga",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Contravent","indicador_refugi":"089024|BIBLIOTECA_CONTRAVENT","municipi":"Vilanova del Vall\xe8s","codi_municipi":"089024","latitud":"41.55174735","longitud":"2.28629735","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Pl. Pa\xefsos Catalans, 4","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-6egz.sr26-hme4",":version":"rv-sb2k-ebeg~ek59",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Cultural: sala cinema i sala polivalent","indicador_refugi":"431671|CENTRE_CULTURAL_SALA_CINEMA_I_SALA_POLIVALENT","municipi":"Vilanova d\'Escornalbou","codi_municipi":"431671","latitud":"41.11403","longitud":"0.936513","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Cosme Toda, 19","informacio_web":"Obertura en per\xedodes d\'onada de calor d\'11:30 h a 19:30 h","tipologia":"Equipament Cultural (teatre, auditori, museu)","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-23T11:04:00.000"},{":id":"row-j6fv~fpk2~h42s",":version":"rv-gb3e~ztzg-cqiu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local Gent Gran","indicador_refugi":"431671|LOCAL_GENT_GRAN","municipi":"Vilanova d\'Escornalbou","codi_municipi":"431671","latitud":"41.114001","longitud":"0.936487","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Cosme Toda, 19 1r","informacio_web":"Obertura en per\xedode d\'onada de calor de 11:30h. a 19:30 h.","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-23T11:09:00.000"},{":id":"row-jfw6-apjn.8v7h",":version":"rv-p2ju.tp9x.gv3i",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Municipal","indicador_refugi":"431671|PISCINA_MUNICIPAL","municipi":"Vilanova d\'Escornalbou","codi_municipi":"431671","latitud":"41.111247","longitud":"0.938023","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Arbocet, s/n - Pavell\xf3 Municipal","informacio_web":"Obertura a tot el p\xfablic en general en per\xedodes d\'onada de calor d\'11:30 a 19:30 h","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-23T11:12:00.000"},{":id":"row-5eja-vhfn-rybb",":version":"rv-j2wk~n74e-usdk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament - Sala de Plens","indicador_refugi":"431671|AJUNTAMENT_-_SALA_DE_PLENS","municipi":"Vilanova d\'Escornalbou","codi_municipi":"431671","latitud":"41.113135","longitud":"0.937144","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a de la Vila, 1","informacio_web":"Horari obertura de l\'Ajuntament de 08:00 a 15:00 h.","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-23T11:14:00.000"},{":id":"row-6uti-jaae_fiki",":version":"rv-jckc-yemp-4r7w",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Cultural de l\'Arbocet","indicador_refugi":"431671|CENTRE_CULTURAL_DE_LARBOCET","municipi":"Vilanova d\'Escornalbou","codi_municipi":"431671","latitud":"41.105354","longitud":"0.9608","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. de Baix, 6 - L\'Arbocet","informacio_web":"Obertura en per\xedodes d\'onada de calor d\'11:30 a 19:30 h","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-23T12:01:00.000"},{":id":"row-f5r9.7a77_5cys",":version":"rv-ds5h_k4r6_mvab",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Armand Cardona","indicador_refugi":"083073|BIBLIOTECA_ARMAND_CARDONA","municipi":"Vilanova i la Geltr\xfa","codi_municipi":"083073","latitud":"41.22203249","longitud":"1.71463179","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Menendez Pelayo, 15-17","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-96mh_dfyr_qgt7",":version":"rv-83nh_2njy~qbmp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Mol\xed de Vent","indicador_refugi":"083073|CENTRE_CIVIC_MOLI_DE_VENT","municipi":"Vilanova i la Geltr\xfa","codi_municipi":"083073","latitud":"41.22084777","longitud":"1.70988271","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. aigua, 203-205","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-ayu6.id83_czr7",":version":"rv-ehfu~gv7h-btmu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic de Mar","indicador_refugi":"083073|CENTRE_CIVIC_DE_MAR","municipi":"Vilanova i la Geltr\xfa","codi_municipi":"083073","latitud":"41.21699074","longitud":"1.73146661","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. Mar\xedtim, 73","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-bgsk-mwqi_2yde",":version":"rv-a5v6~i6ws~8cb6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic el Tac\xf3","indicador_refugi":"083073|CENTRE_CIVIC_EL_TACO","municipi":"Vilanova i la Geltr\xfa","codi_municipi":"083073","latitud":"41.23445786","longitud":"1.72686611","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Vilafranca del Pened\xe8s, 26","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-k3bx-un5s_jiq5",":version":"rv-hc3r-vrs8_dzgq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic la Geltr\xfa","indicador_refugi":"083073|CENTRE_CIVIC_LA_GELTRU","municipi":"Vilanova i la Geltr\xfa","codi_municipi":"083073","latitud":"41.2256799","longitud":"1.73145865","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Assumpci\xf3 Alumnes Obrers, 1","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-jig9_g9xy_w6dz",":version":"rv-svjf-v6i9_sma8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Joan Oliva","indicador_refugi":"083073|BIBLIOTECA_JOAN_OLIVA","municipi":"Vilanova i la Geltr\xfa","codi_municipi":"083073","latitud":"41.22455847","longitud":"1.7255597","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de la Vila, 13","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:41:00.000"},{":id":"row-de5r-j4zb_7gbu",":version":"rv-7p78.5ykw.eyr6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Sant Joan","indicador_refugi":"083073|CENTRE_CIVIC_SANT_JOAN","municipi":"Vilanova i la Geltr\xfa","codi_municipi":"083073","latitud":"41.22243346","longitud":"1.71847754","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Jardins Francesc Maci\xe0, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-hq8n.ti2r-zjxg",":version":"rv-y6g4-5hid_mquq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic La Collada Sis Camins","indicador_refugi":"083073|CENTRE_CIVIC_LA_COLLADA_SIS_CAMINS","municipi":"Vilanova i la Geltr\xfa","codi_municipi":"083073","latitud":"41.22604684","longitud":"1.69586887","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Turbina, 19","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-rqxy.p9u9.cvbi",":version":"rv-bx2q.pctc-au8f",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local jove","indicador_refugi":"431704|LOCAL_JOVE","municipi":"Vila-rodona","codi_municipi":"431704","latitud":"41.31035224","longitud":"1.35777587","accessibilitat":"No","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Casal de Vila-rodona, s/n","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-fzvy.4irc.s2ar",":version":"rv-sen2.vfdq~7xme",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"431704|PISCINA_MUNICIPAL","municipi":"Vila-rodona","codi_municipi":"431704","latitud":"41.30958958","longitud":"1.35706482","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Pagesia Catalana, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:37:00.000"},{":id":"row-waeu.fw2z~49fd",":version":"rv-gnwb~uxwq-8k7a",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal","indicador_refugi":"431704|BIBLIOTECA_MUNICIPAL","municipi":"Vila-rodona","codi_municipi":"431704","latitud":"41.31046369","longitud":"1.35858419","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de les Hortes, 4","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:39:00.000"},{":id":"row-2e45_2mdv-xe63",":version":"rv-ai9m_pyeb.3aqs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a dels Pa\xefsos Catalans","indicador_refugi":"431711|PLACA_DELS_PAISOS_CATALANS","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.108074","longitud":"1.148873","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a dels Pa\xefsos Catalans, 43480 Vila-seca","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T14:31:00.000"},{":id":"row-hni6_y23v_fthu",":version":"rv-hmvc_q5ye.u5qg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de l\'Albereda de Folc","indicador_refugi":"431711|PARC_DE_LALBEREDA_DE_FOLC","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.108478","longitud":"1.139214","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda de la Generalitat, 43480 Vila-seca","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T14:41:00.000"},{":id":"row-ybvp~c9f5-823j",":version":"rv-dxdr~6tip.yz7d",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de l\'Hort del Pep","indicador_refugi":"431711|PARC_DE_LHORT_DEL_PEP","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.112095","longitud":"1.150334","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Galceran de Pin\xf3s, 43480 Vila-seca","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T14:43:00.000"},{":id":"row-k6f8-j6up~fe7f",":version":"rv-br4y~5ic4_q2mf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Torre d\'en Dol\xe7a","indicador_refugi":"431711|PARC_DE_LA_TORRE_DEN_DOLCA","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.098988","longitud":"1.160086","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carretera Vila-seca - La Pineda, 43480 Vila-seca","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T14:48:00.000"},{":id":"row-2tc5~h9us_whwb",":version":"rv-zhhz-7xiy-f796",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Antics Rentadors","indicador_refugi":"431711|ANTICS_RENTADORS","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.110497","longitud":"1.144324","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de la Font, 43480 Vila-seca","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-03T09:24:00.000"},{":id":"row-aev5.vx3w_snnr",":version":"rv-qiv8~wgjb.s4e9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de l\'Escorxador","indicador_refugi":"431711|PARC_DE_LESCORXADOR","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.108831","longitud":"1.146593","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de l\'Escorxador, 43480 Vila-seca","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-03T09:25:00.000"},{":id":"row-w2vt-3bjf_iwq2",":version":"rv-zyq8~ctxf~mpuk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de l\'Estaci\xf3","indicador_refugi":"431711|PARC_DE_LESTACIO","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.112383","longitud":"1.150603","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Galceran de Pin\xf3s, 43480 Vila-seca","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-03T09:28:00.000"},{":id":"row-cip7.jbsb.fjjg",":version":"rv-frq2-wqte~sj9s",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins del Castell","indicador_refugi":"431711|JARDINS_DEL_CASTELL","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.114208","longitud":"1.147645","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer del Castell, 43480 Vila-seca","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-03T09:29:00.000"},{":id":"row-7dpr.6cvq-6d5k",":version":"rv-qday.4idy~j5cz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de la Pla\xe7a de l\'Esgl\xe9sia Vella","indicador_refugi":"431711|JARDINS_DE_LA_PLACA_DE_LESGLESIA_VELLA","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.113188","longitud":"1.148195","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer del Castell, 43480 Vila-seca","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-03T11:10:00.000"},{":id":"row-mmdg_74h9-h2dz",":version":"rv-i9z9_p65c-pmsz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de l\'Esgl\xe9sia","indicador_refugi":"431711|PLACA_DE_LESGLESIA","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.111491","longitud":"1.144875","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a de l\'Esgl\xe9sia, 43480 Vila-seca","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-03T11:11:00.000"},{":id":"row-txcq_hdfe-94j2",":version":"rv-hezg~jbv4_c8dt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de Joan Mir\xf3","indicador_refugi":"431711|PLACA_DE_JOAN_MIRO","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.111709","longitud":"1.137937","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Fra Joan Fernando Salvad\xf3, 43480 Vila-seca","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-03T11:12:00.000"},{":id":"row-xpai~uqu6~rgcr",":version":"rv-4gb9~6qi5~evuq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de les Illes","indicador_refugi":"431711|PARC_DE_LES_ILLES","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.105744","longitud":"1.147687","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Josep Maria Folch i Torres, 43480 Vila-seca","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-03T11:14:00.000"},{":id":"row-ti8d_48pi-yzqr",":version":"rv-ay5x.pd6m-r2dv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc dels Aragalls","indicador_refugi":"431711|PARC_DELS_ARAGALLS","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.106628","longitud":"1.151069","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer d\'Ausi\xe0s Marc, 43480 Vila-seca","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-03T11:15:00.000"},{":id":"row-3gha_mihy_yefe",":version":"rv-t2kr~8kk7.26yj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Bernat Sportella","indicador_refugi":"431711|PARC_DE_BERNAT_SPORTELLA","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.113658","longitud":"1.144999","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Reus, 43480 Vila-seca","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-03T11:16:00.000"},{":id":"row-isuz~xub7.dbei",":version":"rv-y6ki~yzs3~5m3q",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc dels Geganters","indicador_refugi":"431711|PARC_DELS_GEGANTERS","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.109885","longitud":"1.140434","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer del Mas Calv\xf3, 43480 Vila-seca","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-03T11:18:00.000"},{":id":"row-mnr4~iime_s34a",":version":"rv-ixmn~zpz2-z977",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jard\xed de Joan Amades","indicador_refugi":"431711|JARDI_DE_JOAN_AMADES","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.109677","longitud":"1.14314","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda de la Verge de Montserrat, 43480 Vila-seca","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-03T11:19:00.000"},{":id":"row-vpnk.m5un~srv4",":version":"rv-52mi~g5t8.pf7q",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament de Vila-seca","indicador_refugi":"431711|AJUNTAMENT_DE_VILA-SECA","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.110919","longitud":"1.144868","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a de l\'Esgl\xe9sia, 26, 43480 Vila-seca","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-03T11:20:00.000"},{":id":"row-q3rc.47ky~k45e",":version":"rv-yegf~jh5t.cbna",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai Jove Casa dels Obrers","indicador_refugi":"431711|ESPAI_JOVE_CASA_DELS_OBRERS","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.110659","longitud":"1.144621","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Sant Antoni, 24, 43480 Vila-seca","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-03T11:21:00.000"},{":id":"row-2e4s_dsff_46za",":version":"rv-qnxr.46nr~bg8i",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Servei d\'Ocupaci\xf3 i Creaci\xf3 d\'Empresa","indicador_refugi":"431711|SERVEI_DOCUPACIO_I_CREACIO_DEMPRESA","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.112341","longitud":"1.146699","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de l\'Hospital, 1, 43480 Vila-seca","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-03T11:24:00.000"},{":id":"row-4798_f5px_9cvc",":version":"rv-3g7i.53yh_5hnh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic i Cultural el Colom\xed","indicador_refugi":"431711|CENTRE_CIVIC_I_CULTURAL_EL_COLOMI","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.111399","longitud":"1.149903","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Tarragona, 22, 43480 Vila-seca","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-03T11:28:00.000"},{":id":"row-sv66-ip7b-53nn",":version":"rv-a4a8~2f2x_6y6y",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca P\xfablica Municipal","indicador_refugi":"431711|BIBLIOTECA_PUBLICA_MUNICIPAL","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.1100241","longitud":"1.14757","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Tarragona, 7, 43480 Vila-seca","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Biblioteca","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-03T11:37:00.000"},{":id":"row-8pty.jg8p~nu3j",":version":"rv-h3jc_pg96.4c4q",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala Sicart (Castell de Vila-seca)","indicador_refugi":"431711|SALA_SICART_(CASTELL_DE_VILA-SECA)","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.114616","longitud":"1.147439","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer del Castell, 38, 43480 Vila-seca","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T09:42:00.000"},{":id":"row-pq8x-q3fz-5szk",":version":"rv-hmpa~ffga~urpb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina exterior Vila-seca","indicador_refugi":"431711|PISCINA_EXTERIOR_VILA-SECA","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.1019145","longitud":"1.14987","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda Alcalde Pere Molas, 26, 43480 Vila-seca","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T09:44:00.000"},{":id":"row-cjnt_wuva.gtxm",":version":"rv-3rzv_vs3i-q8zm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina interior Vila-seca","indicador_refugi":"431711|PISCINA_INTERIOR_VILA-SECA","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.1019145","longitud":"1.14987","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda Alcalde Pere Molas, 26, 43480 Vila-seca","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Piscina Coberta","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T09:45:00.000"},{":id":"row-tvu4-rp4j~9bsv",":version":"rv-r4hn.rpuh~8bx3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc dels Prats","indicador_refugi":"431711|PARC_DELS_PRATS","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.083824","longitud":"1.186547","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer d\'Amadeus Vives, 43481 La Pineda","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T10:34:00.000"},{":id":"row-fvk8~8php~7u3x",":version":"rv-zman~k3fc.kz5r",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Pinar de Perruquet","indicador_refugi":"431711|PARC_DEL_PINAR_DE_PERRUQUET","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.076415","longitud":"1.181999","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Passeig de Pau Casals, 43481 La Pineda","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T10:36:00.000"},{":id":"row-xgut~r37g.w3ib",":version":"rv-ysqh-tbwx.utec",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Tanca","indicador_refugi":"431711|PARC_DE_LA_TANCA","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.08105","longitud":"1.181039","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer d\'Amadeu Vives, 43481 Vila-seca","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T10:38:00.000"},{":id":"row-gcre-4q7c_8amd",":version":"rv-hg3d~tjpc.e96d",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de les Arenes","indicador_refugi":"431711|PARC_DE_LES_ARENES","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.080148","longitud":"1.178143","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Pau Vidal, 43481 La Pineda","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T10:39:00.000"},{":id":"row-mc6t.u7d3-i8f8",":version":"rv-t7jz~favu.fahf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic i Cultural de la Pineda","indicador_refugi":"431711|CENTRE_CIVIC_I_CULTURAL_DE_LA_PINEDA","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.080399","longitud":"1.179091","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer d\'Alfredo Kraus, 20, 43481 La Pineda","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T10:40:00.000"},{":id":"row-zsf7-46qa_4dwt",":version":"rv-tri3-pj6g-bv7a",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Ramon Roig","indicador_refugi":"431711|PARC_DE_RAMON_ROIG","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.129952","longitud":"1.128908","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Sant Joan, 43206 La Plana","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T11:07:00.000"},{":id":"row-nw67.xg83~bjfj",":version":"rv-9w56_k5t4.5wbr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic i Cultural de la Plana","indicador_refugi":"431711|CENTRE_CIVIC_I_CULTURAL_DE_LA_PLANA","municipi":"Vila-seca","codi_municipi":"431711","latitud":"41.12967","longitud":"1.128561","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer d\'Almeria, 29, 43206 La Plana","informacio_web":"https://vila-seca.cat/refugis-climatics","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-04T11:08:00.000"},{":id":"row-ft9i.4hbr-scdh",":version":"rv-ftns-vzu6.4b2e",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc can Rafart","indicador_refugi":"082140|PARC_CAN_RAFART","municipi":"Vilassar de Dalt","codi_municipi":"082140","latitud":"41.51877006207332","longitud":"2.361095456600291","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"c/ Rafart, 2","informacio_web":"07:00 - 23:00","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T12:05:00.000"},{":id":"row-ebj6_2dj9-6nyv",":version":"rv-ut56.qmx4~x3vm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Riera Salvet (Barri del Pi)","indicador_refugi":"082140|RIERA_SALVET_(BARRI_DEL_PI)","municipi":"Vilassar de Dalt","codi_municipi":"082140","latitud":"41.513648470686775","longitud":"2.3629436978340945","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"c/ Del Pi","informacio_web":"horari: espai oert","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T14:45:00.000"},{":id":"row-nu3i_kwxf-fimc",":version":"rv-h32j.qp3v_yn7v",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pineda Forns Romans","indicador_refugi":"082140|PINEDA_FORNS_ROMANS","municipi":"Vilassar de Dalt","codi_municipi":"082140","latitud":"41.51611039151594","longitud":"2.368618736812529","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"c/ Cam\xed de Matar\xf3, 46-48","informacio_web":"horari: espai obert","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T14:49:00.000"},{":id":"row-v7jf-98wg-sspx",":version":"rv-2934_c8fj_8n97",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Patis Espai C\xedvic Les Escoles","indicador_refugi":"082140|PATIS_ESPAI_CIVIC_LES_ESCOLES","municipi":"Vilassar de Dalt","codi_municipi":"082140","latitud":"41.513056040750385","longitud":"2.3602800700695545","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"c/ Cam\xed de can Pons, 21","informacio_web":"07:00 - 22:00","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T14:51:00.000"},{":id":"row-wtzb.7pku~yk84",":version":"rv-5d5a~9597.58ys",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardinets Anton Feliu","indicador_refugi":"082140|JARDINETS_ANTON_FELIU","municipi":"Vilassar de Dalt","codi_municipi":"082140","latitud":"41.51659543978594","longitud":"2.358812597462281","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"c/ Anselm Clav\xe9, 2-4","informacio_web":"07:00 - 22:00","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T14:54:00.000"},{":id":"row-mh47~w9yk-quqj",":version":"rv-iim7.m6ww~7jhr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Municipal","indicador_refugi":"082140|PISCINA_MUNICIPAL","municipi":"Vilassar de Dalt","codi_municipi":"082140","latitud":"41.51971305055574","longitud":"2.356296712083836","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"c/ Marqu\xe8s de Barbar\xe0, 11","informacio_web":"08:00 - 20:00","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-25T14:58:00.000"},{":id":"row-v4ae_dzwv-hams",":version":"rv-ezmp_txma.kjam",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jard\xed Masia can Ban\xfas","indicador_refugi":"082140|JARDI_MASIA_CAN_BANUS","municipi":"Vilassar de Dalt","codi_municipi":"082140","latitud":"41.51936521006548","longitud":"2.356484662103597","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"c/ Marqu\xe8s de Barbar\xe0, 9","informacio_web":"09:00 - 17:00","tipologia":"Parcs i jardins","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-26T14:26:00.000"},{":id":"row-39wv_fkv2_cwmx",":version":"rv-xpjm~mek9~smfh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local social","indicador_refugi":"431726|LOCAL_SOCIAL","municipi":"Vilaverd","codi_municipi":"431726","latitud":"41.33737925","longitud":"1.17722807","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. de La B\xe0scula S/N","tipologia":"Sala Polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-08T17:10:00.000"},{":id":"row-jaqi-8bnu-cuuc",":version":"rv-kni7.t6zz.qape",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal de Vilaverd","indicador_refugi":"431726|PISCINA_MUNICIPAL_DE_VILAVERD","municipi":"Vilaverd","codi_municipi":"431726","latitud":"41.337847","longitud":"1.175813","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Cam\xed Ermita s/n","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-08T17:04:00.000"},{":id":"row-zngq_dxdw~d4au",":version":"rv-g8x8-zp37.66yz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal de Vilob\xed del Pened\xe8s","indicador_refugi":"083041|PISCINA_MUNICIPAL_DE_VILOBI_DEL_PENEDES","municipi":"Vilob\xed del Pened\xe8s","codi_municipi":"083041","latitud":"41.38873634","longitud":"1.6644333","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"No","adreca":"Av. Generalitat, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-qkuh-arss.cer2",":version":"rv-2rn5-qd5z_9wgg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala d\'actes Can Roscada","indicador_refugi":"172333|SALA_D_ACTES_CAN_ROSCADA","municipi":"Vilob\xed d\'Onyar","codi_municipi":"172333","latitud":"41.88839665","longitud":"2.74275567","accessibilitat":"S\xed","aigua":"No","area_descans":"S\xed","adreca":"Trv. del primer d\'octubre de 2017, 2","tipologia":"Sala polivalent","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-mfh9-8437-newf",":version":"rv-na9b-ar8b~wa6y",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Llar de Jubilats","indicador_refugi":"172333|LLAR_DE_JUBILATS","municipi":"Vilob\xed d\'Onyar","codi_municipi":"172333","latitud":"41.887712","longitud":"2.739873","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Empord\xe0, 5 de Vilob\xed d\'Onyar","informacio_web":"tarda","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-07-09T10:28:00.000"},{":id":"row-w3mb.bua6-tnff",":version":"rv-ya8h_sutx-kqry",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal de Vilopriu","indicador_refugi":"172327|PISCINA_MUNICIPAL_DE_VILOPRIU","municipi":"Vilopriu","codi_municipi":"172327","latitud":"42.14912006","longitud":"2.9895998","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Zona esportiva, s/n, 17466 Vilopriu","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-29pv.p7uv-tvaf",":version":"rv-vjpk~xmw4.bvrf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre de serveis","indicador_refugi":"252555|CENTRE_DE_SERVEIS","municipi":"Vinaixa","codi_municipi":"252555","latitud":"41.42803665","longitud":"0.97648256","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. de tarragona, 3","tipologia":"Equipament c\xedvic","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:34:00.000"},{":id":"row-iyhx_k37g~jswd",":version":"rv-pucm~wqcw_ttd2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina","indicador_refugi":"252555|PISCINA","municipi":"Vinaixa","codi_municipi":"252555","latitud":"41.4293627","longitud":"0.97077472","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Trav. Escoles, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:35:00.000"},{":id":"row-pahe_quey~kj3i",":version":"rv-ieqz~k7et_wjqx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Col\xb7legi","indicador_refugi":"252555|COL_LEGI","municipi":"Vinaixa","codi_municipi":"252555","latitud":"41.4288676","longitud":"0.97345898","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Ctra. de Lleida, 41","tipologia":"Escola / Institut","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-01T10:30:00.000"},{":id":"row-kyb9-i8nw-j52g",":version":"rv-g2mq_4ki6.ba9u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament","indicador_refugi":"252555|AJUNTAMENT","municipi":"Vinaixa","codi_municipi":"252555","latitud":"41.42821988","longitud":"0.97511854","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a dels Arbres,2","tipologia":"Ajuntament / Equipament Administratiu","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-06-01T10:33:00.000"},{":id":"row-585r_q2yg.kmwz",":version":"rv-c53w~uune~4mbn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"431779|PISCINA_MUNICIPAL","municipi":"Vinebre","codi_municipi":"431779","latitud":"41.185577","longitud":"0.590914","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Carrerada, s/n","tipologia":"Piscina","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:42:00.000"},{":id":"row-b5rr.qiy3~tqz8",":version":"rv-v33e_7j3a.m9nd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"EMBARCADOR","indicador_refugi":"431779|EMBARCADOR","municipi":"Vinebre","codi_municipi":"431779","latitud":"41.174772","longitud":"0.601249","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"43179A015000380000DR","tipologia":"Altres","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T11:34:00.000"},{":id":"row-u3r2-fhxn.5dp6",":version":"rv-exg3.kbr7_reqq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"SALA CINE","indicador_refugi":"431779|SALA_CINE","municipi":"Vinebre","codi_municipi":"431779","latitud":"41.183900659516745","longitud":"0.5911749989054811","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"PLA\xc7A AJUNTAMENT, 6","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T11:40:00.000"},{":id":"row-bxre~pzuv_rmc5",":version":"rv-n45w-5qxg-9bhk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"LLAR JUBILATS","indicador_refugi":"431779|LLAR_JUBILATS","municipi":"Vinebre","codi_municipi":"431779","latitud":"41.18437148257204","longitud":"0.5906767175615208","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"CARRER DE LA TORR, 22 BAIX","tipologia":"Casal de Gent Gran","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-01T11:43:00.000"},{":id":"row-2t7n~nbwb~bu4u",":version":"rv-cwbf-gqk5.h2b9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca municipal","indicador_refugi":"431785|BIBLIOTECA_MUNICIPAL","municipi":"Vinyols i els Arcs","codi_municipi":"431785","latitud":"41.11298526","longitud":"1.03769358","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"Ptge. d\'1 d\'octubre","tipologia":"Biblioteca","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-jp6k.wjjy.ed2k",":version":"rv-rdcy~9kef.qiiv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Llar de jubilats els Arcs","indicador_refugi":"431785|LLAR_DE_JUBILATS_ELS_ARCS","municipi":"Vinyols i els Arcs","codi_municipi":"431785","latitud":"41.06856869","longitud":"1.06216582","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"No","adreca":"C. Josep Maria Folch i Torres, 5","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:36:00.000"},{":id":"row-y97k_e437.q2bv",":version":"rv-v9wk.pwcj~9k9f",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Llar de jubilats Vinyols","indicador_refugi":"431785|LLAR_DE_JUBILATS_VINYOLS","municipi":"Vinyols i els Arcs","codi_municipi":"431785","latitud":"41.11486883","longitud":"1.04027383","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","adreca":"C. del Centre","tipologia":"Altres","origen_identificador":"historicDadesObertes2025","ultima_actualitzacio":"2026-05-14T13:40:00.000"},{":id":"row-a52s~ch5t_vfnu",":version":"rv-zhcw.jkqe-xs2n",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal Municipal","indicador_refugi":"431785|CASAL_MUNICIPAL","municipi":"Vinyols i els Arcs","codi_municipi":"431785","latitud":"41.11318191439669","longitud":"1.0376902175381542","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Ptge. d\'1 d\'Octubre, s/n","tipologia":"Sala Polivalent","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-02T12:49:00.000"},{":id":"row-uar4.tzmj_js37",":version":"rv-x6s4.ymqj-cchw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Local Social de Viver","indicador_refugi":"083089|LOCAL_SOCIAL_DE_VIVER","municipi":"Viver i Serrateix","codi_municipi":"083089","latitud":"41.956279108984994","longitud":"1.8138777154818542","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"No","lavabo":"No","adreca":"Crta de Nav\xe0s a Serrateix (BV4235) km 10.2","tipologia":"Centre C\xedvic","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-12T12:26:00.000"},{":id":"row-q4u5_wvyc.242v",":version":"rv-uj98_h98e_kxp8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"PISCINES MUNICIPALS","indicador_refugi":"430521|PISCINES_MUNICIPALS","municipi":"Xerta","codi_municipi":"430521","latitud":"40.90909","longitud":"0.49364","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"CAM\xcd DEL PORTAL, 17","informacio_web":"http://www.xerta.cat/nuclis-de-poblacio-23","tipologia":"Piscines descobertes","origen_identificador":"Municipi","ultima_actualitzacio":"2026-06-11T09:06:00.000"},{":id":"row-qe3i~rnce-5q5c",":version":"rv-x24k~ez75-8qtm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Barceloneta-La Fraternitat","indicador_refugi":"080193|BIB_BARCELONETA_LA_FRATERNITAT","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37923","longitud":"2.188872","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Fel\xedcia Fuster i Viladecans, 8-10","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/1138134103","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ab9q.ku75_s2a3",":version":"rv-5m55-8y7y-e4rs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Bon Pastor - Josefina Castellv\xed","indicador_refugi":"080193|BIB_BON_PASTOR_JOSEFINA_CASTELLVI","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4352","longitud":"2.204677","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Estadella, 64","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400098833","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-vatg_xr7t-qpew",":version":"rv-jxbc-ed8e-fh4k",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Camp de l\'Arpa - Caterina Albert","indicador_refugi":"080193|BIB_CAMP_DE_L_ARPA_CATERINA_ALBERT","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4158","longitud":"2.182298","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Ind\xfastria, 295","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400299968","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jz6v~iiss~hxx6",":version":"rv-2rj4_2uv8_q2ap",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Canyelles - M. \xc0ngels Rivas","indicador_refugi":"080193|BIB_CANYELLES_M_ANGELS_RIVAS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4438","longitud":"2.16434","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Rda. de La Guineueta Vella, 34","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086005760","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ydxr.94x9.3nva",":version":"rv-c5yh-4r7r.xf4g",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Clar\xe0","indicador_refugi":"080193|BIB_CLARA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39994","longitud":"2.129474","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Doctor Carulla, 22-24","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99329122806","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-5t3w.svbm~y3h2",":version":"rv-77i4.pg2p_yd8k",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Collserola - Josep Miracle","indicador_refugi":"080193|BIB_COLLSEROLA_JOSEP_MIRACLE","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41539","longitud":"2.102547","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Elisa Moragas i Badia, 16-34","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400010089","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-njyg~pc4s~4stc",":version":"rv-8an3-pxcb~fbiq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. El Carmel - Juan Mars\xe9","indicador_refugi":"080193|BIB_EL_CARMEL_JUAN_MARSE","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42103","longitud":"2.155116","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Murtra, 135-145","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400061992","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-myxj.8698.ixy2",":version":"rv-7425~yk77.2uh5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. El Clot - Josep Benet","indicador_refugi":"080193|BIB_EL_CLOT_JOSEP_BENET","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4026","longitud":"2.18805","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. de les Gl\xf2ries Catalanes, 37-38","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400329623","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-pmyw.u7z2~ffnt",":version":"rv-fizf.htnu-x3zq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Esquerra de l\'Eixample - Agust\xed Centelles","indicador_refugi":"080193|BIB_ESQUERRA_DE_L_EIXAMPLE_AGUSTI_CENTELLES","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3869","longitud":"2.15205","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Comte d\u2019Urgell, 145-147","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400270325","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-k79g-tx28.u8ad",":version":"rv-r5wh_qkn3~s66g",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Fort Pienc - Ana Mar\xeda Moix","indicador_refugi":"080193|BIB_FORT_PIENC_ANA_MARIA_MOIX","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39559","longitud":"2.182465","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. del Fort Pienc, 4-5","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400037765","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-k8ws~2q72.rxuk",":version":"rv-tipr-vk3c.2rng",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Francesc Candel","indicador_refugi":"080193|BIB_FRANCESC_CANDEL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.36181","longitud":"2.136295","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Amnistia Internacional, 10","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086021426","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-mrda~jaf8~bfdu",":version":"rv-sytz-2h4q.z5t7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Francesca Bonnemaison","indicador_refugi":"080193|BIB_FRANCESCA_BONNEMAISON","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38649","longitud":"2.176176","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Sant Pere m\xe9s Baix, 7","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086001171","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-g5sq-cica_5hhy",":version":"rv-mfav~ph28~rxk3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. G\xf2tic - Andreu Nin","indicador_refugi":"080193|BIB_GOTIC_ANDREU_NIN","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37849","longitud":"2.176065","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. La Rambla, 30-32","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400243881","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-v6rf~j7sx_mqp5",":version":"rv-enpd.fkrg~f3eq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Guinard\xf3 - Merc\xe8 Rodoreda","indicador_refugi":"080193|BIB_GUINARDO_MERCE_RODOREDA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41289","longitud":"2.162447","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Cam\xe8lies, 76-80","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99083114355","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-qqhm.y538_drid",":version":"rv-jvtr-dnhe-7ith",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Horta - Can Mariner","indicador_refugi":"080193|BIB_HORTA_CAN_MARINER","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43114","longitud":"2.160751","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Vent, 1","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400196643","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-gmju-qjd6.yyak",":version":"rv-3suc-s4zf~txm7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Ignasi Igl\xe9sias - Can Fabra","indicador_refugi":"080193|BIB_IGNASI_IGLESIAS_CAN_FABRA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43397","longitud":"2.191338","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Segre, 24-32","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400019598","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-k8k9~diwj-arw4",":version":"rv-jmcr~sbrh~maxx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Joan Mir\xf3","indicador_refugi":"080193|BIB_JOAN_MIRO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37885","longitud":"2.149248","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Parc Joan Mir\xf3 / Vilamar\xed, 61","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92168151705","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-879h~6gh3.ym65",":version":"rv-6was_tdqi-4czs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. La Sagrera - Marina Clotet","indicador_refugi":"080193|BIB_LA_SAGRERA_MARINA_CLOTET","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42591","longitud":"2.193781","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Josep Soldevila, 9","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400227877","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-gq6j_2jp6-bqjm",":version":"rv-xpi9_3t68.gsza",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Les Roquetes - Rafa Juncadella","indicador_refugi":"080193|BIB_LES_ROQUETES_RAFA_JUNCADELLA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4454","longitud":"2.177121","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Via Fav\xe8ncia, 288 B","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086010318","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3shp_tedw-dst8",":version":"rv-e9p2.sa5u~7brw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Montbau - Albert P\xe9rez Bar\xf3","indicador_refugi":"080193|BIB_MONTBAU_ALBERT_PEREZ_BARO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42918","longitud":"2.14197","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Arquitectura, 8","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94286172503","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-w5yu-84ws-5huy",":version":"rv-jnie_vrud_8aka",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Montserrat Abell\xf3","indicador_refugi":"080193|BIB_MONTSERRAT_ABELLO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38371","longitud":"2.135285","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Comtes de Bell-lloc, 192-200","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086002115","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-kkkk.xjys.5cj6",":version":"rv-q4fk.t93d_52pm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Nou Barris - Aurora D\xedaz Plaja","indicador_refugi":"080193|BIB_NOU_BARRIS_AURORA_DIAZ_PLAJA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43684","longitud":"2.17123","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. Major de Nou Barris, 2","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/97135114148","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-av3j.9zq8.cq6w",":version":"rv-assp_tnvd~ppmk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Poblenou - Manuel Arranz","indicador_refugi":"080193|BIB_POBLENOU_MANUEL_ARRANZ","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4014","longitud":"2.204543","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Joncar, 35","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400224356","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-uahh_6ukx.9u7s",":version":"rv-xf5w-jegk_qgay",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Poble Sec - Francesc Boix","indicador_refugi":"080193|BIB_POBLE_SEC_FRANCESC_BOIX","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37395","longitud":"2.164043","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Blai, 34","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/1242142943","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wa5q_2hus_ei3i",":version":"rv-37ix-atfa-gcm9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Ramon d\'Al\xf2s - Moner","indicador_refugi":"080193|BIB_RAMON_D_ALOS_MONER","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41635","longitud":"2.2115","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Rbla. de Prim, 87-89 (Centre C\xedvic)","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086001838","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-5cu8~rcs4~tvtx",":version":"rv-ntde_ftpm.aqfy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Sant Antoni - Joan Oliver","indicador_refugi":"080193|BIB_SANT_ANTONI_JOAN_OLIVER","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37741","longitud":"2.162796","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Comte Borrell,44-46","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400188956","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-byh5-heqv-qx2s",":version":"rv-svaq~pzct_85xh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Sant Gervasi - Joan Maragall","indicador_refugi":"080193|BIB_SANT_GERVASI_JOAN_MARAGALL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40596","longitud":"2.135993","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Sant Gervasi de Cassoles, 85","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400342694","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-pdb8-pe9u.274m",":version":"rv-nk5c-grb6-psei",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Sant Pau - Santa Creu","indicador_refugi":"080193|BIB_SANT_PAU_SANTA_CREU","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38049","longitud":"2.170353","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Carme, 47 / Hospital, 56","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086000482","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-capm-et9j~byjm",":version":"rv-g962~upgu.irby",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Sofia Barat","indicador_refugi":"080193|BIB_SOFIA_BARAT","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39471","longitud":"2.171522","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Girona, 64-68 (interior d\'illa)","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086004289","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3tud~8dte~y6up",":version":"rv-nwie~79sq.67pg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Vallcarca i els Penitents - M. Antonieta Cot","indicador_refugi":"080193|BIB_VALLCARCA_I_ELS_PENITENTS_M_ANTONIETA_COT","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42004","longitud":"2.139675","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pg. de la Vall d\'Hebron, 65-69","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400273433","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-v9kp~gjsu_5kv3",":version":"rv-622w~qbrg.93xe",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Vapor Vell","indicador_refugi":"080193|BIB_VAPOR_VELL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37693","longitud":"2.134752","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Ptge. Vapor Vell, s/n","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/249121118","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-2bng_dp49-vcns",":version":"rv-qdpk_9kmv~3jj4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Vila de Gr\xe0cia - Rosa M. Arquimbau","indicador_refugi":"080193|BIB_VILA_DE_GRACIA_ROSA_M_ARQUIMBAU","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4015","longitud":"2.158232","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Torrent de l\u2019Olla, 104","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/2123115923","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-9p9f-zy8g_pkty",":version":"rv-s6n4.sckd~ifty",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Vilapicina i la Torre Llobeta - Carmen Laforet","indicador_refugi":"080193|BIB_VILAPICINA_I_LA_TORRE_LLOBETA_CARMEN_LAFORET","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42703","longitud":"2.175994","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. de Carmen Laforet, 11","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99021111627","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-dg39~ter8~7i3g",":version":"rv-dus6.jz7r.qud4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Zona Nord - M\xe0ria S\xe1nchez","indicador_refugi":"080193|BIB_ZONA_NORD_MARIA_SANCHEZ","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.46127","longitud":"2.179893","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Vallcivera, 3 bis","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400236720","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-vuyu~snyk~2aii",":version":"rv-x6rg~sdhu_cfn9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Les Corts - Miquel Llongueras","indicador_refugi":"080193|BIB_LES_CORTS_MIQUEL_LLONGUERAS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37801","longitud":"2.121843","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Trav. de Les Corts, 58","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/284153819","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-bay5_5wbk-usrf",":version":"rv-sjjb_9w9z_27qw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CEM Can Cuy\xe0s","indicador_refugi":"080193|CEM_CAN_CUYAS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.45992","longitud":"2.168133","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. Rasos de Peguera","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086037277","tipologia":"Complexos esportius","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-8k2b-pkmd_3akp",":version":"rv-wut4.ss5p_f3jr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CEM Can Felipa","indicador_refugi":"080193|CEM_CAN_FELIPA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40405","longitud":"2.201405","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. Josep M. Huertas Claveria, 1","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92168153135","tipologia":"Complexos esportius","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-5aj7-wwsm.byi9",":version":"rv-fx3m~b7fz~y2n6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CEM Can Ricart","indicador_refugi":"080193|CEM_CAN_RICART","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37753","longitud":"2.170761","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"C. Sant Oleguer, 10","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086038230","tipologia":"Complexos esportius","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-apyu.i5jq_ar23",":version":"rv-jbw6.eh8f.xun6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CEM Can Toda","indicador_refugi":"080193|CEM_CAN_TODA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41538","longitud":"2.158172","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Ctra. dEl Carmel, 5","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086003375","tipologia":"Complexos esportius","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-e2pr.p5ez_e8wm",":version":"rv-6g63_ev4h~jx38",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CEM El Carmel","indicador_refugi":"080193|CEM_EL_CARMEL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42321","longitud":"2.158577","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Pedrell","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92132091748","tipologia":"Complexos esportius","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-a25f_6jg7-fupq",":version":"rv-39b7.rasz_qaky",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CEM Les Corts","indicador_refugi":"080193|CEM_LES_CORTS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38541","longitud":"2.133598","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Trav. de Les Corts, 252-254","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99186122857","tipologia":"Complexos esportius","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-5czy-j275_b3v4",":version":"rv-vard-47ar-cjct",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CEM Mundet","indicador_refugi":"080193|CEM_MUNDET","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43576","longitud":"2.147158","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Olympe de Gouges, s/n","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400110854","tipologia":"Complexos esportius","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3we7-wryr-xudm",":version":"rv-z2kk.cuih.di8w",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CEM Perill","indicador_refugi":"080193|CEM_PERILL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39943","longitud":"2.161522","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Perill","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92168175469","tipologia":"Complexos esportius","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-xcur_gvem-nj4x",":version":"rv-rva4~yd7b-wtk7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CEM Piscines Picornell","indicador_refugi":"080193|CEM_PISCINES_PICORNELL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.36601","longitud":"2.151086","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. de l\'Estadi, 30","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92168175397","tipologia":"Complexos esportius","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-46p5_78ic-58h5",":version":"rv-fhgu-tbjv_ib62",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CEM Putxet","indicador_refugi":"080193|CEM_PUTXET","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40973","longitud":"2.141296","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Marmell\xe0, 23","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400247031","tipologia":"Complexos esportius","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-q3w2.yj48-r2b2",":version":"rv-veir.ditf_apqf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CEM Sagrada Fam\xedlia","indicador_refugi":"080193|CEM_SAGRADA_FAMILIA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40729","longitud":"2.17932","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Cartagena, 231-239","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990492186","tipologia":"Complexos esportius","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ghaq_td98.qkwa",":version":"rv-mn3i~23kt~yjcn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CEM Vintr\xf3","indicador_refugi":"080193|CEM_VINTRO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40669","longitud":"2.186298","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Consell de Cent, 623-627","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/93050115049","tipologia":"Complexos esportius","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ugat-rh28.ahhe",":version":"rv-bdqn~tdma.tdcp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CEM Trinitat Vella","indicador_refugi":"080193|CEM_TRINITAT_VELLA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.45124","longitud":"2.193849","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Via B\xe0rcino, 84","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92168175394","tipologia":"Complexos esportius","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-995p-45qe.5vpb",":version":"rv-8j7c_8eeu.ixs4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CUESB","indicador_refugi":"080193|CUESB","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39898","longitud":"2.201438","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Llacuna, 25","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086031399","tipologia":"Altres","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-8hg5~dk33.umm5",":version":"rv-z8vs~4tb5~bhr5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"El Centre de la Platja","indicador_refugi":"080193|EL_CENTRE_DE_LA_PLATJA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38309","longitud":"2.194477","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Platja Somorrostro. Sota Porxos Passeig mar\xedtim. Front Hospital del Mar","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400147294","tipologia":"Equipaments Ambientals","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-5np2.h5gz_fp4x",":version":"rv-fyy7-nksb.kdke",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La F\xe0brica del Sol","indicador_refugi":"080193|LA_FABRICA_DEL_SOL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38219","longitud":"2.191758","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pg. Salvat Papasseit s/n","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99117135915","tipologia":"Equipaments Ambientals","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-m5xx~pijm_v37n",":version":"rv-a3yw.n8au-ygtx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de barri Raval","indicador_refugi":"080193|CASAL_DE_BARRI_RAVAL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37694","longitud":"2.167179","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Reina Am\xe0lia, 31","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400271344","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-iz9d.wv5w-5v4x",":version":"rv-uedi_rnik~68sc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC Bes\xf3s i Maresme","indicador_refugi":"080193|CC_BESOS_I_MARESME","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41635","longitud":"2.211497","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Rbla. de Prim, 87-89","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/93316140842","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-8xpt-q5p9~gqwx",":version":"rv-vpsi-j8uh_bcs8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de barri Congr\xe9s Indians","indicador_refugi":"080193|CASAL_DE_BARRI_CONGRES_INDIANS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42399","longitud":"2.179412","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Manigua 25-35","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086034049","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-8buh.2nuz-5rs3",":version":"rv-s3kt~c5bj_m97v",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC Carmel","indicador_refugi":"080193|CC_CARMEL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42029","longitud":"2.151204","accessibilitat":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Santuari, 27","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086031534","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-fyqw_v7km~5vjt",":version":"rv-cge9.548n-8648",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC Cotxeres de Sants","indicador_refugi":"080193|CC_COTXERES_DE_SANTS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3753","longitud":"2.136897","accessibilitat":"S\xed (excepte lavabos)","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Sants, 79","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086002380","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-xbqj-inff-c7fh",":version":"rv-p64z-9jk2~24u2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC El Sortidor","indicador_refugi":"080193|CC_EL_SORTIDOR","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3721","longitud":"2.162548","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. del Sortidor, 12","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99120120846","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-znzq_snv5_cqfc",":version":"rv-cgnp-yx96.sywm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC Vil.la Ur\xe0nia","indicador_refugi":"080193|CC_VIL_LA_URANIA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40151","longitud":"2.14989","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Saragossa, 29","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400179932","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-y6iq.vnjz.am5j",":version":"rv-ekbu~e644_5af3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC Bar\xf3 de Viver","indicador_refugi":"080193|CC_BARO_DE_VIVER","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.44617","longitud":"2.200389","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Quito, 8","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086004979","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-uduk~iwfu.appr",":version":"rv-ifn6~mage.2qtx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC Can Bast\xe9","indicador_refugi":"080193|CC_CAN_BASTE","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43049","longitud":"2.173233","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pg. Fabra i Puig, 274-276","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/95124132926","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-x9sz.s33v~4juj",":version":"rv-i4pc-xn27~5vzf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC Can Verdaguer","indicador_refugi":"080193|CC_CAN_VERDAGUER","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43409","longitud":"2.179183","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Piferrer, 94-100","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400313145","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-k33c-dcqx-bh5b",":version":"rv-n6qi-jzzx-6w39",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Casa Golferichs","indicador_refugi":"080193|CENTRE_CIVIC_CASA_GOLFERICHS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38085","longitud":"2.156407","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"G.V. Corts Catalanes, 491","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086008869","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-dy7i_yhwj~kxna",":version":"rv-jx4q_7mb5_sp8g",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC Casa Orlandai","indicador_refugi":"080193|CC_CASA_ORLANDAI","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39836","longitud":"2.124672","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Jaume Piquet","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400180423","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-6af7_e8xp_abwf",":version":"rv-47zr.snbe~j7bj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC Casinet d\'Hostafrancs","indicador_refugi":"080193|CC_CASINET_D_HOSTAFRANCS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37786","longitud":"2.143222","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Rector Triad\xf3, 53","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086002472","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-rpny-73wb~ndu9",":version":"rv-ecc3.5b5d~xc2h",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal Mas Guinard\xf3","indicador_refugi":"080193|CASAL_MAS_GUINARDO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41608","longitud":"2.173342","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"Altres","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. Salvador Riera, 2","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400265137","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-7nca.56jj-envj",":version":"rv-vaqz-4uqz.7ppz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC Joan Oliver Pere Quart","indicador_refugi":"080193|CC_JOAN_OLIVER_PERE_QUART","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37933","longitud":"2.127776","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Comandant Ben\xedtez, 6","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99125133528","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-d7hv_pjqi~fbu8",":version":"rv-5vyp_9as6_5hnq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Cultural La\xa0 Casa Elizalde","indicador_refugi":"080193|CENTRE_CULTURAL_LA_CASA_ELIZALDE","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39452","longitud":"2.165883","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Val\xe8ncia, 302","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086007784","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-4bp4_ez97-g6yr",":version":"rv-u5jw~ks42-kgqw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic La Sedeta","indicador_refugi":"080193|CENTRE_CIVIC_LA_SEDETA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40558","longitud":"2.167688","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Sic\xedlia, 321","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086004419","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-b829-yv5e~aqdr",":version":"rv-qqa2-6h7b~7sc5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Matas i Ramis","indicador_refugi":"080193|CENTRE_CIVIC_MATAS_I_RAMIS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43279","longitud":"2.160724","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Feliu i Codina, 20","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086035681","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-gxc2_jdx9~a5nk",":version":"rv-xy7m.fpaf-bzbf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC Tomasa Cuevas - Les Corts","indicador_refugi":"080193|CC_TOMASA_CUEVAS_LES_CORTS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38482","longitud":"2.128342","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Dolors Masferrer i Bosch, 33-35","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99026095631","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-yg6d~dk9v~mupk",":version":"rv-c55m.7svn.xpmy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre c\xedvic Torre Llobeta","indicador_refugi":"080193|CENTRE_CIVIC_TORRE_LLOBETA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42693","longitud":"2.173966","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Santa Fe, 2 bis","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086004700","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-28yc.s5fu_tn4i",":version":"rv-u96t~wrgw.3akm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Gent Gran Mediterr\xe0nia","indicador_refugi":"080193|CASAL_DE_GENT_GRAN_MEDITERRANIA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3803","longitud":"2.192316","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Conreria, 1-9","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/97161084732","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-byu6-3pex-rfy8",":version":"rv-f3re~kdh4~23mv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La Lleialtat Santsenca","indicador_refugi":"080193|LA_LLEIALTAT_SANTSENCA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3729","longitud":"2.136665","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Olzinelles, 31","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400477380","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-vn6g-fxtp-5hz5",":version":"rv-srmp_p9cc.q3ws",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Barri Transformadors","indicador_refugi":"080193|CASAL_DE_BARRI_TRANSFORMADORS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39344","longitud":"2.178587","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Ausi\xe0s Marc, 60","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400637478","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-r456-yb3b-fuak",":version":"rv-ajcq_pw77.xe9d",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Cotxeres Borrell","indicador_refugi":"080193|CENTRE_CIVIC_COTXERES_BORRELL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37557","longitud":"2.162919","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Viladomat, 2-8","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/2011131453","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-7q8p_wqc8_vph2",":version":"rv-ebmy_pyi5_zfam",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal Barri Ateneu el Poblet","indicador_refugi":"080193|CASAL_BARRI_ATENEU_EL_POBLET","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40235","longitud":"2.170377","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. N\xe0pols, 268","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400578431","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-mz8w_btiq-5rh3",":version":"rv-a4e5_g5kf.k6f2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Zona Nord","indicador_refugi":"080193|CENTRE_CIVIC_ZONA_NORD","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.46068","longitud":"2.178346","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Vallcivera, 14","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086019602","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-vr8u.pcv3~v99d",":version":"rv-kjup-dus3~sxra",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC Sagrera - La Barraca","indicador_refugi":"080193|CC_SAGRERA_LA_BARRACA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42397","longitud":"2.189151","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Mart\xed Molins, 29","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086005115","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-b3fi-322b~t6hd",":version":"rv-gq2y-scg4-mruc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu de Cultures del M\xf3n","indicador_refugi":"080193|MUSEU_DE_CULTURES_DEL_MON","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38504","longitud":"2.180911","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Montcada, 12-14","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400367586","tipologia":"Museus","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-e4dh.msmc.4qxm",":version":"rv-68xv_km2m_jfak",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu d\'Hist\xf2ria de Barcelona - Avantcambra Sal\xf3 del Tinell","indicador_refugi":"080193|MUSEU_D_HISTORIA_DE_BARCELONA_AVANTCAMBRA_SALO_DEL_TINELL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38428","longitud":"2.177341","accessibilitat":"S\xed","aigua":"No","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. del Rei","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/2071125357","tipologia":"Museus","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-c4m7.s92m_r8vb",":version":"rv-m5a5_z9np_cwiq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu d\'Hist\xf2ria de Barcelona - Pati de Padell\xe0s","indicador_refugi":"080193|MUSEU_D_HISTORIA_DE_BARCELONA_PATI_DE_PADELLAS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3838","longitud":"2.177751","accessibilitat":"S\xed","aigua":"No","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Veguer","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400147599","tipologia":"Museus","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ancr.2iuv_ffn9",":version":"rv-k9ec.5muq-prkp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu Frederic Mar\xe8s","indicador_refugi":"080193|MUSEU_FREDERIC_MARES","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38418","longitud":"2.176805","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. Sant Iu, 5-6","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086001132","tipologia":"Museus","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-hdip_5iwy-hkpn",":version":"rv-9z9k-c2b3_mbit",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu del Disseny de Barcelona - Dhub","indicador_refugi":"080193|MUSEU_DEL_DISSENY_DE_BARCELONA_DHUB","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40257","longitud":"2.188034","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. De les Gl\xf2ries, 37-38","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400218118","tipologia":"Museus","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-52mt~q5xn.2hcs",":version":"rv-synx-mrig.yriu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu Reial Monestir de Santa Maria de Pedralbes","indicador_refugi":"080193|MUSEU_REIAL_MONESTIR_DE_SANTA_MARIA_DE_PEDRALBES","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39534","longitud":"2.11212","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Baixada del Monestir, 9","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086005213","tipologia":"Museus","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-6dpt.avkf-2ewc",":version":"rv-wrck_ejjs.z28j",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu de Ci\xe8ncies Naturals de Barcelona - Museu Blau","indicador_refugi":"080193|MUSEU_DE_CIENCIES_NATURALS_DE_BARCELONA_MUSEU_BLAU","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41078","longitud":"2.220481","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"F\xf2rum. Pl. Leonardo da Vinci, 4-5","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400090058","tipologia":"Museus","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ui5h~4mm9-3rvn",":version":"rv-umeh_36qa_aszr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu Etnol\xf2gic","indicador_refugi":"080193|MUSEU_ETNOLOGIC","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.36887","longitud":"2.156166","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pg. Santa Madrona, s/n","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086000174","tipologia":"Museus","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-xf5s-eeqp-uz6g",":version":"rv-s7zr~7dj8_uuxp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jard\xed Bot\xe0nic Hist\xf2ric","indicador_refugi":"080193|JARDI_BOTANIC_HISTORIC","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.36719","longitud":"2.152699","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Av. Montanyans, 30-32","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400064283","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-q3wp~g3nb~2jzu",":version":"rv-edrd_wrud.rvdj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de Ramon Margalef","indicador_refugi":"080193|JARDINS_DE_RAMON_MARGALEF","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.36609","longitud":"2.152965","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Av. Estadi, 42-48","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011925","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-4igz.8s74_fijq",":version":"rv-6xvw.3u42.ab9b",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jard\xed de l\'Umbracle","indicador_refugi":"080193|JARDI_DE_L_UMBRACLE","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.36737","longitud":"2.158019","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Pg. Santa Madrona, 25","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400715967","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-bc52-6mws~q475",":version":"rv-zk2v-biv6_vnnp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de Can Sentmenat","indicador_refugi":"080193|JARDINS_DE_CAN_SENTMENAT","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40262","longitud":"2.115102","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Can Caralleu, 6-14","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/95081125600","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ssaj.4uyz.a6h8",":version":"rv-wcrc.72uj-8t5k",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de Joan  Brossa","indicador_refugi":"080193|JARDINS_DE_JOAN_BROSSA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.36867","longitud":"2.165013","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Pl. Dante, 9999","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400036180","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-qauy.u3n6~abkq",":version":"rv-p7gk.rw69~jbki",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de la Maternitat (manteniment Diputaci\xf3)","indicador_refugi":"080193|JARDINS_DE_LA_MATERNITAT_MANTENIMENT_DIPUTACIO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38132","longitud":"2.126252","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Trav. de Les Corts, 159","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/95143083146","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-5ivr-zkkz.pczg",":version":"rv-v2tp_wnit-zvv6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de la Tamarita","indicador_refugi":"080193|JARDINS_DE_LA_TAMARITA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41091","longitud":"2.135331","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Pg. Sant Gervasi, 47-49","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94165112247","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ezsq.gtmn.xcss",":version":"rv-dxm2.jimh_f8f4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de Laribal","indicador_refugi":"080193|JARDINS_DE_LARIBAL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.36812","longitud":"2.158483","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Pg. Santa Madrona, 25","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99329085212","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-6mai.cp9p_wccu",":version":"rv-68s5~vi44.dwvr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de Palau de Pedralbes (gestionat per la Generalitat)","indicador_refugi":"080193|JARDINS_DE_PALAU_DE_PEDRALBES_GESTIONAT_PER_LA_GENERALITAT","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38655","longitud":"2.118435","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Av. Diagonal, 686","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086010494","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-qwu9-jt3h.ahhz",":version":"rv-ed8v-beh2_nydh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de Pedro Mu\xf1oz Seca","indicador_refugi":"080193|JARDINS_DE_PEDRO_MUNOZ_SECA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42773","longitud":"2.140747","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Arquitectura, 1","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/97202125642","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-z5zk.whff_3rh8",":version":"rv-kfpm.5zbc-mr62",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de Piscines i Esports","indicador_refugi":"080193|JARDINS_DE_PISCINES_I_ESPORTS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39314","longitud":"2.135608","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Doctor Fleming, 8","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400349080","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-e6bd-z4we.d7py",":version":"rv-rj8w~dy72_dtn5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc dEl Poblenou","indicador_refugi":"080193|PARC_DEL_POBLENOU","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39728","longitud":"2.207471","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Av. Litoral, 59-71","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/96113125023","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3xgm~rg7j-t7h7",":version":"rv-54bh.28nr-kwwz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai enjardinat de la Via Trajana","indicador_refugi":"080193|ESPAI_ENJARDINAT_DE_LA_VIA_TRAJANA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42896","longitud":"2.203714","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Santander, 58","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400738079","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ncti.769m~ina6",":version":"rv-9qaf-hfvw.pum5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de Vil\xb7la Am\xe8lia","indicador_refugi":"080193|JARDINS_DE_VIL_LA_AMELIA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39391","longitud":"2.121187","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Eduardo Conde, 22","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011931","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-s5fs.c98n~nv6i",":version":"rv-uv2s~bhbz_2hem",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins del Dr.Pla i Armengol","indicador_refugi":"080193|JARDINS_DEL_DR_PLA_I_ARMENGOL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41601","longitud":"2.16992","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Av. Mare de D\xe9u de Montserrat, 132","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400643473","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-acqr.x9di~ng72",":version":"rv-5twn~epzk_75gg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mirador dEl Poble-sec","indicador_refugi":"080193|MIRADOR_DEL_POBLE_SEC","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37208","longitud":"2.170647","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Pg. Montju\xefc, 59","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/95125123610","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-e95p_jmmz~gru4",":version":"rv-qbnk~ujpg.5i8x",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Creueta del Coll","indicador_refugi":"080193|PARC_CREUETA_DEL_COLL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41926","longitud":"2.146252","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pg. de la Mare de D\xe9u del Coll, 77","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086020872","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-fwqx-3zzg.ti9n",":version":"rv-tsd6.kkdz_djnz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Can Sabat\xe9","indicador_refugi":"080193|PARC_DE_CAN_SABATE","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.36437","longitud":"2.13775","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Mineria, 16","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086029921","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-xspt_syih.wzci",":version":"rv-3sj8-6zbe.7i5g",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Cervantes","indicador_refugi":"080193|PARC_DE_CERVANTES","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38457","longitud":"2.109439","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Av. Diagonal, 706","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086010721","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-keak-e5dx~s3kc",":version":"rv-sufq_c7zu.53gf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Diagonal Mar","indicador_refugi":"080193|PARC_DE_DIAGONAL_MAR","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40849","longitud":"2.212232","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Llull, 356 - 360","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99085102712","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-5uqh~vrrh.cy6h",":version":"rv-n2pc_2h4p.6aat",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Josep Maria Serra i Mart\xed","indicador_refugi":"080193|PARC_DE_JOSEP_MARIA_SERRA_I_MARTI","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.44296","longitud":"2.165954","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Miguel Hern\xe1ndez, 16","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/97248100532","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-2dmi-98zt~b3f4",":version":"rv-r8q9_er3s_38ia",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Barceloneta","indicador_refugi":"080193|PARC_DE_LA_BARCELONETA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38206","longitud":"2.193838","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pg. Mar\xedtim de la Barceloneta, 15-21","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/96269141552","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-4k39.92g4-gwna",":version":"rv-jnp2_p94g_659m",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de La Ciutadella","indicador_refugi":"080193|PARC_DE_LA_CIUTADELLA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38634","longitud":"2.185382","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pg. de Picasso, 21","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011921","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-gif7.xttv-62xi",":version":"rv-hj4z~y265-j7mi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Font Florida","indicador_refugi":"080193|PARC_DE_LA_FONT_FLORIDA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.36863","longitud":"2.14105","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Font Florida, 102","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/95125123838","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-b88h~mszs-q6kb",":version":"rv-ephm_rauv.bmd6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Pegaso","indicador_refugi":"080193|PARC_DE_LA_PEGASO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42689","longitud":"2.190739","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Sagrera 179-197","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086017159","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-99cc~74xi_9tyf",":version":"rv-hq3v~gviu-jyqb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de les Aig\xfces","indicador_refugi":"080193|PARC_DE_LES_AIGUES","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41358","longitud":"2.165481","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Pl. Alfons el Savi, 3","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011955","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jdms_bi8j_ce9h",":version":"rv-45vz-xhuf.dhg4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Monterols","indicador_refugi":"080193|PARC_DE_MONTEROLS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40161","longitud":"2.139774","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Muntaner, 450","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011940","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wj2g-p2md-t4st",":version":"rv-gy2q.a9p7~w7sz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Sant Mart\xed","indicador_refugi":"080193|PARC_DE_SANT_MARTI","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4199","longitud":"2.198052","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Menorca, 64","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086029922","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-j847_ffyh.awgk",":version":"rv-txec-t8sy_jntv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Centre de Poblenou","indicador_refugi":"080193|PARC_DEL_CENTRE_DE_POBLENOU","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40679","longitud":"2.199757","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Av. Diagonal, 130","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400201005","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-kbi4-ef8w~qdgb",":version":"rv-g4yq~k9sa.imn9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc dEl Clot","indicador_refugi":"080193|PARC_DEL_CLOT","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40847","longitud":"2.190015","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Escultors Claper\xf3s, 55-63","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086017160","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-qbk9~dxqg~gshm",":version":"rv-pmu9.vigi_p48w",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc dEl Guinard\xf3","indicador_refugi":"080193|PARC_DEL_GUINARDO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41949","longitud":"2.169614","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Garriga i Roca, 1-13","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011954","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wxqc-v35f.rp7w",":version":"rv-67j8~dned-nbg7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Mirador del Migdia","indicador_refugi":"080193|PARC_DEL_MIRADOR_DEL_MIGDIA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.35976","longitud":"2.152844","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Pg. del Migdia, 156 - 174","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/1116122215","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-w5fb-kb7z.kn4b",":version":"rv-2q8m.zp43.txj8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Putxet","indicador_refugi":"080193|PARC_DEL_PUTXET","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40775","longitud":"2.142518","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Manacor, 9","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011938","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-8fke_gx6d-sfhd",":version":"rv-8rk4-f4up-sczg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc dEl Tur\xf3 de la Peira","indicador_refugi":"080193|PARC_DEL_TURO_DE_LA_PEIRA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43346","longitud":"2.163447","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Pg. Fabra i Puig, 396","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011958","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-986f.gee3_5in2",":version":"rv-jivg_u6bn-5c98",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Espanya Industrial","indicador_refugi":"080193|PARC_ESPANYA_INDUSTRIAL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37654","longitud":"2.139874","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Muntadas, 1","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086015836","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-pwin~i7rv_gzib",":version":"rv-45eg.eqp5_7zux",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Esportiu Can Drag\xf3","indicador_refugi":"080193|PARC_ESPORTIU_CAN_DRAGO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43659","longitud":"2.183157","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Rossell\xf3 i Porcel, 7","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/98294161742","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-s9gt~5abw.93uc",":version":"rv-e87s_nfcy-3qfd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Park G\xfcell","indicador_refugi":"080193|PARK_GUELL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41351","longitud":"2.153127","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Olot, 7","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011949","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-habf-2mia~zrrz",":version":"rv-ydv9.zuxj-gfq3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Guineueta","indicador_refugi":"080193|PARC_GUINEUETA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43905","longitud":"2.174489","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Pl. de la Rep\xfablica, 9*LB","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011957","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-8ybp~mupn-nbtx",":version":"rv-svg6_rhby~3534",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de la Farga","indicador_refugi":"080193|PLACA_DE_LA_FARGA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37245","longitud":"2.138837","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Pl. Farga, 1","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400738073","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-pwts~7dgg_dbiw",":version":"rv-my5d-jzes.qy6z",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Tur\xf3 Park","indicador_refugi":"080193|TURO_PARK","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39411","longitud":"2.141916","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. Pau Casals, 19","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011942","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jbd3~zfh7.k98m",":version":"rv-v8w2-pkrf~b9j9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pati de l\'escola Font d\'en Fargas","indicador_refugi":"080193|PATI_DE_L_ESCOLA_FONT_D_EN_FARGAS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42267","longitud":"2.16522","accessibilitat":"No","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Pg. Font d\'en Fargas, 65","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737861","tipologia":"Patis d\'Escola","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-2xni.7qy7.443k",":version":"rv-x4ib~5nf3~cvd9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pati de l\'escola Rius i Taulet","indicador_refugi":"080193|PATI_DE_L_ESCOLA_RIUS_I_TAULET","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4079","longitud":"2.15034","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Pl. Lesseps, 19","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780755","tipologia":"Patis d\'Escola","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-c6qu_r2bn-8pwp",":version":"rv-msiu~82tr_qwpc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CEM Ol\xedmpics Vall d\'Hebron","indicador_refugi":"080193|CEM_OLIMPICS_VALL_D_HEBRON","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42817","longitud":"2.144965","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pg. Vall Hebron, 166-176","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92170123435","tipologia":"Complexos esportius","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-w3wi-zabj-bswf",":version":"rv-8ucf_vvcc-4qua",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CEM Can Drag\xf3","indicador_refugi":"080193|CEM_CAN_DRAGO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43655","longitud":"2.183086","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Rossell\xf3 i P\xf2rcel, 7","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086032989","tipologia":"Complexos esportius","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-emqi~urbd-y3fz",":version":"rv-prt6.amdw-zg4t",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CEM Bac de Roda","indicador_refugi":"080193|CEM_BAC_DE_RODA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41445","longitud":"2.194065","accessibilitat":"S\xed","aigua":"No","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Rbla. Guip\xfascoa, 23-25","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/98056162156","tipologia":"Complexos esportius","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wd8k~u6kp.4q54",":version":"rv-2pju-x9a4-wfg4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CEM J\xfapiter","indicador_refugi":"080193|CEM_JUPITER","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41765","longitud":"2.202128","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"C. Agricultura, 232","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086005147","tipologia":"Complexos esportius","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-z4ie.2syg_prem",":version":"rv-ttyd~jkxm_yepy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CEM Can Caralleu","indicador_refugi":"080193|CEM_CAN_CARALLEU","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40162","longitud":"2.110814","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Esports, 2-8","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086010504","tipologia":"Complexos esportius","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-2u4m~xi9k-mauz",":version":"rv-t2q4_uz4m.9pt2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CEM Cotxeres","indicador_refugi":"080193|CEM_COTXERES","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4267","longitud":"2.176853","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. de Carmen Laforet, 7","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400270882","tipologia":"Complexos esportius","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-u2g2_uveq_pn2s",":version":"rv-bfxv-sizv-mka4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CEM Claror","indicador_refugi":"080193|CEM_CLAROR","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40447","longitud":"2.170997","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Sardenya, 333","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92168152807","tipologia":"Complexos esportius","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-j5g6_xfqd_dxvc",":version":"rv-s2g7.g5s5~mbej",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CEM Parc de la Ciutadella","indicador_refugi":"080193|CEM_PARC_DE_LA_CIUTADELLA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38535","longitud":"2.18634","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pg. Circumval\xb7laci\xf3, 1","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/93053131509","tipologia":"Complexos esportius","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-2igg_6cas-sprz",":version":"rv-dqqn_ef7b_i6zt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC Can Castell\xf3","indicador_refugi":"080193|CC_CAN_CASTELLO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3991","longitud":"2.139963","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Castell\xf3, 1-7","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400197043","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-fjme.taij_zcmh",":version":"rv-q3ew_zdd6-8qmz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Trinitat","indicador_refugi":"080193|PARC_DE_LA_TRINITAT","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.44865","longitud":"2.194313","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pg. Santa Coloma, 60","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/93188125133","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-vwvz.j35z-2329",":version":"rv-nzn9.zwkd~3r7e",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa de les aig\xfces","indicador_refugi":"080193|CASA_DE_LES_AIGUES","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4542081","longitud":"2.1866053","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Ctra. de Ribes 103-111","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780769","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-dgv9.qsyd~ar28",":version":"rv-tsbk-aak3-wuwq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de la Massana","indicador_refugi":"080193|JARDINS_DE_LA_MASSANA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.427","longitud":"2.17931","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Felip II, 216","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99106095835","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-pfyv~y2c3-i94k",":version":"rv-je7g~h4mu-3puh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Gabriel Garc\xeda M\xe1rquez","indicador_refugi":"080193|BIB_GABRIEL_GARCIA_MARQUEZ","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41717","longitud":"2.20009","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. de Carmen Balcells Segal\xe0, 1","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400659716","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jm4c-q8f6_iwit",":version":"rv-piip-wkaj-dnxa",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Gent Gran Bar\xf3 de Viver","indicador_refugi":"080193|CASAL_DE_GENT_GRAN_BARO_DE_VIVER","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.44617","longitud":"2.200389","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Quito, 8","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011152","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wufk_fxgn.xmv3",":version":"rv-dux5-6443-vtee",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal Gent Gran Carlit","indicador_refugi":"080193|CASAL_GENT_GRAN_CARLIT","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39731","longitud":"2.174749","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Roger de Flor, 162","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/95062124013","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-xa5p-5zy6_28cu",":version":"rv-9tmy_3ixb.98yw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai de Gent Gran M. Aur\xe8lia Capmany","indicador_refugi":"080193|ESPAI_DE_GENT_GRAN_M_AURELIA_CAPMANY","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39029","longitud":"2.15891","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Enric Granados, 47","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92184122533","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ck3u-49rt.xq88",":version":"rv-p4tr-pgb8-2yn8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal Gent Gran Sant Crist\xf2fol","indicador_refugi":"080193|CASAL_GENT_GRAN_SANT_CRISTOFOL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.358","longitud":"2.135181","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Bronze, 5","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/1344091708","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-mzw4_9bxw.sqvg",":version":"rv-4xvn~x5tn_zdzd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal Gent Gran La Capa","indicador_refugi":"080193|CASAL_GENT_GRAN_LA_CAPA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.35996","longitud":"2.142622","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Alts Forns, 82-86","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/95025093613","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-niqe~pm33-uwze",":version":"rv-f29s-35qj_264b",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai Gent Gran El Polvor\xed","indicador_refugi":"080193|ESPAI_GENT_GRAN_EL_POLVORI","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.36349","longitud":"2.141508","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Guadalquivir 2","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011107","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jnc3_537f_udzx",":version":"rv-nmmw-r3wd~3uyn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Gent Gran Poble-sec","indicador_refugi":"080193|CASAL_DE_GENT_GRAN_POBLE_SEC","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37208","longitud":"2.162533","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. del Sortidor, 12","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011112","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-vjqi~6zwa_88cv",":version":"rv-4zrk_vax5-ks5u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de gent gran Cotxeres de Sants","indicador_refugi":"080193|CASAL_DE_GENT_GRAN_COTXERES_DE_SANTS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3746","longitud":"2.136394","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Ptge. Fructu\xf3s Gelabert, s/n","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086002379","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-25wx_sk8t-53ue",":version":"rv-g63d.dxrf-q9aw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CGG Can Castell\xf3","indicador_refugi":"080193|CGG_CAN_CASTELLO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3991","longitud":"2.139963","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Castell\xf3, 1-7","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086032960","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-bay9-furv-nt8y",":version":"rv-jcz7-8k7d.vwvu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de GG Sant Ildefons","indicador_refugi":"080193|CASAL_DE_GG_SANT_ILDEFONS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39689","longitud":"2.147447","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. de Mari\xe0 Cub\xed, 111","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011117","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-s6gz-5qxk-4ruv",":version":"rv-26c8.3qdg.s86u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CGG Baix Guinard\xf3","indicador_refugi":"080193|CGG_BAIX_GUINARDO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40945","longitud":"2.168134","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Marina, 380","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/98293140237","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-435i~wvy3-9xfj",":version":"rv-y4rj~xejk_iub5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CGG Horta","indicador_refugi":"080193|CGG_HORTA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43435","longitud":"2.161593","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Feliu i Codina, 37","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400079710","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-63jf-5kv3.m5fv",":version":"rv-iftt.29n5~4ppb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CGG Sant Gen\xeds","indicador_refugi":"080193|CGG_SANT_GENIS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42603","longitud":"2.137926","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Na\xefm, 10","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400521766","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-tg56_j3dq-fpum",":version":"rv-mvba~aive~y5sn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CGG Vall Hebron","indicador_refugi":"080193|CGG_VALL_HEBRON","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43235","longitud":"2.146808","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Arquitecte Moragas, 5","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400215764","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-spg7~ahbf~83cv",":version":"rv-d5gi~ixxz-vhtx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Teixonera","indicador_refugi":"080193|CENTRE_CIVIC_TEIXONERA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42252","longitud":"2.144592","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Arenys, 75","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/95020142037","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-svag_zhsh~twgc",":version":"rv-yuym-ytqz.w2aj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CGG Navas","indicador_refugi":"080193|CGG_NAVAS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41686","longitud":"2.181542","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Capella, 16","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086029816","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-egt9-8xnj-p72f",":version":"rv-h5fy_yi2g_27vv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CGG La Palmera","indicador_refugi":"080193|CGG_LA_PALMERA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42273","longitud":"2.185015","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Olesa, 41-43","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011154","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-4gm4_w9ik~jd5m",":version":"rv-p7e7_28v5.t8uk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CGG Basc\xf2nia","indicador_refugi":"080193|CGG_BASCONIA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4360140622945","longitud":"2.18702115945097","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Basc\xf2nia 42","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086026574","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ywr6_mnzi~eip8",":version":"rv-cksx-aax4~vmyu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CGG BonPastor","indicador_refugi":"080193|CGG_BONPASTOR","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4381","longitud":"2.205187","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Ardevol s/n","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011153","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-cypm_8pa6~zfpf",":version":"rv-8mrn_jim8~7nt8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CGG Trinitat Vella","indicador_refugi":"080193|CGG_TRINITAT_VELLA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.45009","longitud":"2.189354","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Ctra. de Ribes, 85","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400658013","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-imm8-gtxr_mfqt",":version":"rv-b9au~7iqv.4muc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC Trinitat Vella","indicador_refugi":"080193|CC_TRINITAT_VELLA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.45161","longitud":"2.191178","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Foradada, 36","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086017153","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-pa4r_w3sb-s6gr",":version":"rv-v5pz-schb_dnsu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC Bon Pastor","indicador_refugi":"080193|CC_BON_PASTOR","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4348","longitud":"2.204793","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. Robert Gerhard, 3","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086029928","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-u3bq~kw2b_7tdy",":version":"rv-3w8y_9wem.crct",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CPG Joan Maragall","indicador_refugi":"080193|CPG_JOAN_MARAGALL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41337","longitud":"2.217492","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Bermejo, 1","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086033691","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-uxxw_mmt5.b3x3",":version":"rv-5ez4_vzw6_28kq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CPG La Verneda Alta","indicador_refugi":"080193|CPG_LA_VERNEDA_ALTA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42548","longitud":"2.204736","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Bin\xe8far, 16","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086010421","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-hmmm-zams~tkjd",":version":"rv-7f5h~xzyg~8nhg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CPG Joan Casanelles","indicador_refugi":"080193|CPG_JOAN_CASANELLES","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41177","longitud":"2.193098","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Concili de Trento, 35","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400153850","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-v3k6_svz7-kb4i",":version":"rv-b7mb~4253.uxpk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CPG Parc del Clot","indicador_refugi":"080193|CPG_PARC_DEL_CLOT","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40854","longitud":"2.191703","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. Joan Casanelles, 1","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400369552","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-dsgj_v4f5-p7ak",":version":"rv-r6z4.qxg3_rryt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CPG de Ca L\u2019Isidret","indicador_refugi":"080193|CPG_DE_CA_L_ISIDRET","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41673","longitud":"2.206812","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Josep Pla, 174","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400707246","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-agsn.885d_9siu",":version":"rv-pgtk-umvy-g7wg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CPG Quatre Cantons","indicador_refugi":"080193|CPG_QUATRE_CANTONS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40679","longitud":"2.204013","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Cam\xed Antic de Valencia, 96","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400245996","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-bhxb-9jcy-zu3d",":version":"rv-xyxi_eznu-6y92",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CPG El Taulat","indicador_refugi":"080193|CPG_EL_TAULAT","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40141","longitud":"2.204581","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Llull, 214","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011175","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-c5ku~iyaj_7g3p",":version":"rv-atgj-7tpz.7tck",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CPG Parc Sandaru","indicador_refugi":"080193|CPG_PARC_SANDARU","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39168","longitud":"2.184574","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Buenaventura Mu\xf1oz, 21","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011165","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-7x93-dfcp~6iez",":version":"rv-5gst.ii5u~8pdy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pati de l\'escola Ramon Llull","indicador_refugi":"080193|PATI_DE_L_ESCOLA_RAMON_LLULL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40099","longitud":"2.17767","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Av. Diagonal, 275","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780836","tipologia":"Patis d\'Escola","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-sw94~ndfa~384b",":version":"rv-um7a_hu6i_9cba",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de gent gran Can Novell","indicador_refugi":"080193|CASAL_DE_GENT_GRAN_CAN_NOVELL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38233","longitud":"2.134141","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Caballero, 29","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400694393","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-s9f4-wpby_ss48",":version":"rv-jdft~ikci-pz25",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de gent gran Pati Llimona","indicador_refugi":"080193|CASAL_DE_GENT_GRAN_PATI_LLIMONA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38163","longitud":"2.179707","accessibilitat":"S\xed (excepte lavabos)","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Correu Vell, 5","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011059","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-7vta_qni8-5uv2",":version":"rv-q8vc-uxzb-gkuv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Sagrada Fam\xedlia - Josep M. Ainaud de Lasarte","indicador_refugi":"080193|BIB_SAGRADA_FAMILIA_JOSEP_M_AINAUD_DE_LASARTE","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4057","longitud":"2.176274","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Proven\xe7a, 480","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400187152","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-4b9t-98wt-wpab",":version":"rv-qsh4.2sui.45u6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Seu del Districte de Ciutat Vella","indicador_refugi":"080193|SEU_DEL_DISTRICTE_DE_CIUTAT_VELLA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38396","longitud":"2.16931","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. de Vicen\xe7 Martorell, 6","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400738969","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-pyhg~wqta-egjk",":version":"rv-u2rj_2vep-besj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC Convent Sant Agust\xed","indicador_refugi":"080193|CC_CONVENT_SANT_AGUSTI","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38743","longitud":"2.181695","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. del Comer\xe7, 36","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/98286141841","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-gste~u7ee.ygxa",":version":"rv-vx4v-igiy~uqvd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai Jove Palau Al\xf2s","indicador_refugi":"080193|ESPAI_JOVE_PALAU_ALOS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38818","longitud":"2.178533","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Sant Pere M\xe9s Baix, 55","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400270019","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-8jak.u5ca.tnrc",":version":"rv-dfzp_p8pa~jtkf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Seu Districte de l\'Eixample","indicador_refugi":"080193|SEU_DISTRICTE_DE_L_EIXAMPLE","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39578","longitud":"2.169425","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Arag\xf3, 311","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400738971","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-dpi5_t3uf.s6au",":version":"rv-pjc8-tqd7_uq7q",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de gent gran Sant Ramon","indicador_refugi":"080193|CASAL_DE_GENT_GRAN_SANT_RAMON","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3775","longitud":"2.113564","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Cardenal Reig, 11","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/2107115305","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-6cak~zhr9-mif5",":version":"rv-2dgk_hdb7_tb3u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC Josep M Trias i Peitx","indicador_refugi":"080193|CC_JOSEP_M_TRIAS_I_PEITX","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3778","longitud":"2.121739","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Riera Blanca, 1-3","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/90120343","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3bfy~uxwi~j2h5",":version":"rv-mv45.yxvd-7bay",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC Pere Pruna","indicador_refugi":"080193|CC_PERE_PRUNA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4033","longitud":"2.131208","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Ganduixer, 130","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/136112242","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-2hr5-e7cv.huge",":version":"rv-uvc9_kj9x_jpk8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa de l\'Aigua de Trinitat Nova","indicador_refugi":"080193|CASA_DE_L_AIGUA_DE_TRINITAT_NOVA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.45359","longitud":"2.187544","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Garb\xed, 2","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400576085","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jzan.uy9i-gx48",":version":"rv-g6br.paun_f4t4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de barri Can Portabella","indicador_refugi":"080193|CASAL_DE_BARRI_CAN_PORTABELLA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4291","longitud":"2.193945","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Virgili, 18","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400143980","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-hcav.zr4i_6wnk",":version":"rv-kd5n.6b4x-f4su",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Barri Torre de La Sagrera","indicador_refugi":"080193|CASAL_DE_BARRI_TORRE_DE_LA_SAGRERA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42385","longitud":"2.192038","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Berenguer de Palou, 64","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400549439","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-d82n~c2kc-82pv",":version":"rv-jry4-zjf8~fb7x",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pati de l\'Escola Bressol Municipal Pau","indicador_refugi":"080193|PATI_DE_L_ESCOLA_BRESSOL_MUNICIPAL_PAU","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37671","longitud":"2.140099","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ Muntades 1","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737876","tipologia":"Patis d\'Escola Bressol","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-nf2d-wzrb-6a9k",":version":"rv-abky.6ry4.ig47",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pati de l\'Escola Bressol Municipal El Cargol","indicador_refugi":"080193|PATI_DE_L_ESCOLA_BRESSOL_MUNICIPAL_EL_CARGOL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42709","longitud":"2.167203","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ Moss\xe8n Josep Bund\xf3, 6","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737879","tipologia":"Patis d\'Escola Bressol","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-tbks.2jfc-3pzn",":version":"rv-ss9j.fmqq-skzh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pati de l\'Escola Bressol Municipal Gr\xe0cia","indicador_refugi":"080193|PATI_DE_L_ESCOLA_BRESSOL_MUNICIPAL_GRACIA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40816","longitud":"2.149672","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ Maignon, 2,","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400776970","tipologia":"Patis d\'Escola Bressol","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-tm6m_te6i-mqgy",":version":"rv-9qck~z8w4_dxkq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pati de l\'Escola Bressol Municipal Ralet","indicador_refugi":"080193|PATI_DE_L_ESCOLA_BRESSOL_MUNICIPAL_RALET","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.44255","longitud":"2.182902","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/Joaquim valls, 10","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737886","tipologia":"Patis d\'Escola Bressol","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-esvn~hku5_sbq8",":version":"rv-96zm_22uz.qt3u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CCCB, Centre de Cultura Contempor\xe0nia de Barcelona","indicador_refugi":"080193|CCCB_CENTRE_DE_CULTURA_CONTEMPORANIA_DE_BARCELONA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3837","longitud":"2.166633","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. de Montalegre, 5","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94042144909","tipologia":"Museus","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-hikr~pugk.sw8r",":version":"rv-is2h.cn9q_vxa4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"MACBA","indicador_refugi":"080193|MACBA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38305","longitud":"2.166922","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. dels \xc0ngels, 1","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94354123927","tipologia":"Museus","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-7z4n_c53q~kwuw",":version":"rv-4wws.rnmb~qg3z",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai de gent gran Esquerra de l\'Eixample","indicador_refugi":"080193|ESPAI_DE_GENT_GRAN_ESQUERRA_DE_L_EIXAMPLE","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38691","longitud":"2.149037","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Rossell\xf3, 78-80","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400080055","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-mcgu_9zpj~ab93",":version":"rv-z8wm~i6gr_gg2p",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CGG Moss\xe8n Clap\xe9s","indicador_refugi":"080193|CGG_MOSSEN_CLAPES","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.44283","longitud":"2.187734","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Gran de Sant Andreu, 467 Passatge Interior","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400143470","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-7t5d.hppz_wmz6",":version":"rv-3eyh-w6vw-3uha",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pati de l\'Escola Bressol Municipal Valldaura","indicador_refugi":"080193|PATI_DE_L_ESCOLA_BRESSOL_MUNICIPAL_VALLDAURA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43711","longitud":"2.156376","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pg. Valldaura, 18","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737889","tipologia":"Patis d\'Escola Bressol","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-b659.7p6p~tvsi",":version":"rv-6cij_pqyd_wved",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pati de l\'Escola Bressol Municipal Canig\xf3","indicador_refugi":"080193|PATI_DE_L_ESCOLA_BRESSOL_MUNICIPAL_CANIGO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38252","longitud":"2.16775","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ \xc0ngels, 7","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737891","tipologia":"Patis d\'Escola Bressol","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-zat5.fzrp_smdg",":version":"rv-yius~z5e3-kgb3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai Montserrat Olivella","indicador_refugi":"080193|ESPAI_MONTSERRAT_OLIVELLA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38697","longitud":"2.145548","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Cal\xe0bria, 260","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400548914","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-vf9f.kvt9_n35t",":version":"rv-kk7z-ugax_b3pz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC Font de la Guatlla","indicador_refugi":"080193|CC_FONT_DE_LA_GUATLLA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37046","longitud":"2.147601","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Rab\xed Rub\xe8n, 22","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94322130925","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-axne-66kp~9vmk",":version":"rv-n4zw-fqhe.jp28",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre d\u2019Informaci\xf3 del Parc Natural de la Serra de Collserola","indicador_refugi":"080193|CENTRE_D_INFORMACIO_DEL_PARC_NATURAL_DE_LA_SERRA_DE_COLLSEROLA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41968","longitud":"2.101238","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Ctra. de l\u2019Esgl\xe9sia, 92","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086029624","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3bj8~za69~uay4",":version":"rv-kzkd.yrs7_gfkc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pati de l\'escola Merc\xe8 Rodoreda","indicador_refugi":"080193|PATI_DE_L_ESCOLA_MERCE_RODOREDA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.44591","longitud":"2.185579","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. del Vesuvi, 35  (entrada per Av. Meridiana)","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737906","tipologia":"Patis d\'Escola","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-w2ex-zhan~z55m",":version":"rv-7vy7.e92x_98d4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Rector Gabriel Ferrat\xe9 (UPC)","indicador_refugi":"080193|BIBLIOTECA_RECTOR_GABRIEL_FERRATE_UPC","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38771","longitud":"2.112624","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Jordi Girona, 1-3","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/96355142237","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-i7z2~vnpx.bd7k",":version":"rv-9hvt.7dye.4q93",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca de l\'Escola T\xe8cnica Superior d\'Enginyeria Industrial de Barcelona (UPC)","indicador_refugi":"080193|BIBLIOTECA_DE_L_ESCOLA_TECNICA_SUPERIOR_D_ENGINYERIA_INDUSTRIAL_DE_BARCELONA_UPC","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38483","longitud":"2.115259","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. Diagonal, 647","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086010030","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-kqb5-8axm-vrcj",":version":"rv-fp4x_74t3-yp7g",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Oriol Bohigas de l\'Escola T\xe8cnica Superior d\'Arquitectura de Barcelona (UPC)","indicador_refugi":"080193|BIBLIOTECA_ORIOL_BOHIGAS_DE_L_ESCOLA_TECNICA_SUPERIOR_D_ARQUITECTURA_DE_BARCELONA_UPC","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38501","longitud":"2.115974","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. Diagonal, 649","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086001950","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-5evr.hb6g.fwjt",":version":"rv-qh5z.una9-74ef",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca de l\'Escola d\'Enginyeria Barcelona Est (UPC)","indicador_refugi":"080193|BIBLIOTECA_DE_L_ESCOLA_D_ENGINYERIA_BARCELONA_EST_UPC","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41352","longitud":"2.220763","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Eduard Maristany, 16","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086019686","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-d4vf~43gw_tu9v",":version":"rv-ezm8.exqn-g2px",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca de l\'Escola Polit\xe8cnica Superior d\'Edificaci\xf3 de Barcelona (UPC)","indicador_refugi":"080193|BIBLIOTECA_DE_L_ESCOLA_POLITECNICA_SUPERIOR_D_EDIFICACIO_DE_BARCELONA_UPC","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38375","longitud":"2.11275","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. Doctor Mara\xf1\xf3n, 44-50","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737844","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3nh2~rwin~kvmp",":version":"rv-mtbw.a4rn~5zye",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca de la Facultat de Matem\xe0tiques i Estad\xedstica (UPC)","indicador_refugi":"080193|BIBLIOTECA_DE_LA_FACULTAT_DE_MATEMATIQUES_I_ESTADISTICA_UPC","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38353","longitud":"2.115839","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Pau Gargallo, 14","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94102143353","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-byy7~4b3q_96fm",":version":"rv-6c6w.scp9-mbr9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca de la Facultat de N\xe0utica de Barcelona (UPC)","indicador_refugi":"080193|BIBLIOTECA_DE_LA_FACULTAT_DE_NAUTICA_DE_BARCELONA_UPC","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38235","longitud":"2.184515","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla de Palau, 18","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086008698","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-f9nn~bzsn_f7jk",":version":"rv-rhau.qqtg~ne8r",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Barri Can Travi de la Vall d\'Hebron","indicador_refugi":"080193|CASAL_DE_BARRI_CAN_TRAVI_DE_LA_VALL_D_HEBRON","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43288","longitud":"2.151471","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. Cardenal Vidal i Barraquer 45","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400234295","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-i2pk~hitd~wrj7",":version":"rv-58af~cwya_7s7i",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Institut Catal\xe0 de La Salut","indicador_refugi":"080193|INSTITUT_CATALA_DE_LA_SALUT","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38754","longitud":"2.165229","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"G.V. Corts Catalanes, 587","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009231","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-trjh.nust~r36b",":version":"rv-cbna_5uxh.bdjf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bas\xedlica de Sant Josep Oriol","indicador_refugi":"080193|BASILICA_DE_SANT_JOSEP_ORIOL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38361","longitud":"2.15784","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Diputaci\xf3, 149","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737866","tipologia":"Centres de culte","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-p2uq~cjjh~5nbv",":version":"rv-adyb.cdyp~uicb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parr\xf2quia de Santa Maria de Sants","indicador_refugi":"080193|PARROQUIA_DE_SANTA_MARIA_DE_SANTS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37449","longitud":"2.136876","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. Bonet i Moix\xed, 5","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737868","tipologia":"Centres de culte","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-8qp4_egrr.m7jc",":version":"rv-a2zh~axkg~8sy9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Hospital de Sant Pau","indicador_refugi":"080193|HOSPITAL_DE_SANT_PAU","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41512","longitud":"2.173587","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Sant Quint\xed, 89","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086003435","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-yy6f.6we3~z7vw",":version":"rv-fcn4~6jnq~syew",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parr\xf2quia del Crist Rei","indicador_refugi":"080193|PARROQUIA_DEL_CRIST_REI","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42354","longitud":"2.187757","accessibilitat":"S\xed","aigua":"No","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Mart\xed Molins, 45","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737872","tipologia":"Centres de culte","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-4b3x_nwpu-pnrf",":version":"rv-349a_4rex.qjh9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parr\xf2quia de la Pur\xedssima Concepci\xf3","indicador_refugi":"080193|PARROQUIA_DE_LA_PURISSIMA_CONCEPCIO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39451","longitud":"2.167161","accessibilitat":"S\xed","aigua":"No","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Arag\xf3, 299 (entrada per C. Roger de Ll\xfaria 70)","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737873","tipologia":"Centres de culte","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-idje.ghka.c4qy",":version":"rv-ebvr_8n2r~jyk9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Torre Jussana- Serveis per a associacions","indicador_refugi":"080193|TORRE_JUSSANA_SERVEIS_PER_A_ASSOCIACIONS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42946","longitud":"2.151921","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. Cardenal Vidal i Barraquer, 30","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086014771","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-md3f-twvd-pc9q",":version":"rv-idd4.2uhc_c42s",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal Barri Can Bar\xf3-Pirineu","indicador_refugi":"080193|CASAL_BARRI_CAN_BARO_PIRINEU","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41761","longitud":"2.162226","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Josep Serrano, 59-71","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400184358","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-i768~mj8c-vdpp",":version":"rv-dfeg.ivqq.dix4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Barri del Maresme","indicador_refugi":"080193|CASAL_DE_BARRI_DEL_MARESME","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41392","longitud":"2.211523","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Puigcerd\xe0, 100-102","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400715842","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-np6t_fx3u~c926",":version":"rv-rd68.agg2_zbwu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic el Coll - La Bruguera","indicador_refugi":"080193|CENTRE_CIVIC_EL_COLL_LA_BRUGUERA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4186","longitud":"2.149887","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Aldea, 15","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92127125234","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-w73u-gg83-4gyf",":version":"rv-3k9e.vq73_ibgv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Barri Can Carol","indicador_refugi":"080193|CASAL_DE_BARRI_CAN_CAROL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41239","longitud":"2.145957","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Cambrils, 26","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400647227","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ibfq-w3es.m3mj",":version":"rv-gfmj.3qmk.h7y6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Barri Cardener","indicador_refugi":"080193|CASAL_DE_BARRI_CARDENER","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41008","longitud":"2.156989","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Cardener, 45","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400006116","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-nw7e_vrzm_sk5j",":version":"rv-68pi_w3cq-c7if",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai Jove La Fontana","indicador_refugi":"080193|ESPAI_JOVE_LA_FONTANA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40321","longitud":"2.152462","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Gran de Gr\xe0cia, 190-192","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400219575","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-miyp_yzrn~4fqq",":version":"rv-kqgz.72nf-hchq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Barri La Barraca d\'El Carmel","indicador_refugi":"080193|CASAL_DE_BARRI_LA_BARRACA_D_EL_CARMEL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42486","longitud":"2.157359","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Llobreg\xf3s 107-113","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400618157","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-xunt_9c3b-xevv",":version":"rv-e3w9-wfj8-pa5m",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre d\'arts Santa M\xf2nica","indicador_refugi":"080193|CENTRE_D_ARTS_SANTA_MONICA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37751","longitud":"2.175824","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. La Rambla, 7","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92168151955","tipologia":"Entitats culturals","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-rdyr~7h9s~d8ec",":version":"rv-jec8_njwx~u5rw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Fundaci\xf3 Festa Major de Gr\xe0cia - Can Musons","indicador_refugi":"080193|FUNDACIO_FESTA_MAJOR_DE_GRACIA_CAN_MUSONS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40607","longitud":"2.156642","accessibilitat":"S\xed","aigua":"No","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. de l\'Alzina, 9","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400090807","tipologia":"Entitats culturals","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jnaq_jt3p.3ntd",":version":"rv-ivfi-2x3n.scpe",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Fundaci\xf3 Privada Enlla\xe7","indicador_refugi":"080193|FUNDACIO_PRIVADA_ENLLAC","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40206","longitud":"2.169197","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Rossell\xf3, 328","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400293976","tipologia":"Altres","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wssg_ye43_kq7b",":version":"rv-58ee_fxbs-mimp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Llu\xefsos de Gr\xe0cia","indicador_refugi":"080193|LLUISOS_DE_GRACIA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40717","longitud":"2.155376","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. del Nord, 7-10","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737883","tipologia":"Entitats culturals","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wjrr~h7fp.jx33",":version":"rv-gm2p.jp6t-hngi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu Ol\xedmpic i de l\'Esport Joan Antoni Samaranch","indicador_refugi":"080193|MUSEU_OLIMPIC_I_DE_L_ESPORT_JOAN_ANTONI_SAMARANCH","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.36651","longitud":"2.157516","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. de l\'Estadi, 60","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400179658","tipologia":"Museus","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wfhy~86e6-c4bz",":version":"rv-fkjy.rrut.idff",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat del Bes\xf2s","indicador_refugi":"080193|MERCAT_DEL_BESOS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4192","longitud":"2.215113","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Jaume Huguet, 38","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009790","tipologia":"Mercats","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-mh7v.49yc_zt5y",":version":"rv-pe42-dy6d~4iaq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat de la Concepci\xf3","indicador_refugi":"080193|MERCAT_DE_LA_CONCEPCIO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3958","longitud":"2.16943","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Arag\xf3, 311 bis","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009449","tipologia":"Mercats","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-izts.e2x5-d4fq",":version":"rv-rdwe~xn35~mtdj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat del Clot","indicador_refugi":"080193|MERCAT_DEL_CLOT","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40759","longitud":"2.188633","accessibilitat":"S\xed","aigua":"No","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. del Mercat, 26","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009788","tipologia":"Mercats","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-47f5.s4cv.imdd",":version":"rv-pn3j_9cpp~56b9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat del Fort Pienc","indicador_refugi":"080193|MERCAT_DEL_FORT_PIENC","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39591","longitud":"2.18241","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. Fort Pienc, 3","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400069155","tipologia":"Mercats","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jwsk~cnd8~bsx3",":version":"rv-av5s.e5aa-3ncg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat d\'Hostafrancs","indicador_refugi":"080193|MERCAT_D_HOSTAFRANCS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37513","longitud":"2.143832","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Creu Coberta, 93","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009454","tipologia":"Mercats","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-j23f~q8ey~dpvc",":version":"rv-4aei.x678_69yn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat del Ninot","indicador_refugi":"080193|MERCAT_DEL_NINOT","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38782","longitud":"2.1544","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Mallorca,133","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009451","tipologia":"Mercats","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-6r3z.axnr.2a9q",":version":"rv-equ3_9eaj_t5iz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat del Poblenou-Uni\xf3","indicador_refugi":"080193|MERCAT_DEL_POBLENOU_UNIO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.401","longitud":"2.205423","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. Uni\xf3, 25","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009791","tipologia":"Mercats","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ppw8-tubk_esjz",":version":"rv-p3b3_8pt7-7e6s",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat de Sant Antoni","indicador_refugi":"080193|MERCAT_DE_SANT_ANTONI","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37918","longitud":"2.162061","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Urgell, 1","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009452","tipologia":"Mercats","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-hnqh.xqva~6ry2",":version":"rv-mypq~kg3y~8vra",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat de Sant Mart\xed","indicador_refugi":"080193|MERCAT_DE_SANT_MARTI","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41863","longitud":"2.205298","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Puigcerd\xe0, 206-212","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009789","tipologia":"Mercats","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-kngy~j44s_nwgc",":version":"rv-px2h.87bg-59wv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat de Santa Caterina","indicador_refugi":"080193|MERCAT_DE_SANTA_CATERINA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38636","longitud":"2.178161","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. Francesc Camb\xf3, 16","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009448","tipologia":"Mercats","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-vz2v_n7t5-z567",":version":"rv-q7ve.9vnp~ntr6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat del Bon Pastor","indicador_refugi":"080193|MERCAT_DEL_BON_PASTOR","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43598","longitud":"2.206155","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Sant Adri\xe0, 154-162","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009784","tipologia":"Mercats","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-yjbj~p8v5-zd5k",":version":"rv-yvv9-krid~kb7c",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat del Carmel","indicador_refugi":"080193|MERCAT_DEL_CARMEL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42388","longitud":"2.155566","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Llobreg\xf3s, 149","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009775","tipologia":"Mercats","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-qtci~ci4t_kvcn",":version":"rv-bf4x.unrf-yixy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat de Ciutat Meridiana","indicador_refugi":"080193|MERCAT_DE_CIUTAT_MERIDIANA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.46169","longitud":"2.177788","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Costabona, 4","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009782","tipologia":"Mercats","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-pb8i-9ruv.kymw",":version":"rv-ugga_xuew~eu7h",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat de Les Corts","indicador_refugi":"080193|MERCAT_DE_LES_CORTS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38381","longitud":"2.129857","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Trav. de Les Corts, 215","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009457","tipologia":"Mercats","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-53vp.bqgk-tz3u",":version":"rv-z23e_cg69.ddjp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat de Lesseps","indicador_refugi":"080193|MERCAT_DE_LESSEPS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40901","longitud":"2.151947","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Verdi, 200-210","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009464","tipologia":"Mercats","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ru32~6s5x.w5v7",":version":"rv-wdbv-d4ei.tvdi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat de Vall d\'Hebron","indicador_refugi":"080193|MERCAT_DE_VALL_D_HEBRON","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42404","longitud":"2.142439","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pg. Vall d\'Hebron, 130-134","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009777","tipologia":"Mercats","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-d6nj.8jnq~gqne",":version":"rv-kjzj-ri3s-m2sz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala Polivalent Montbau","indicador_refugi":"080193|SALA_POLIVALENT_MONTBAU","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42958","longitud":"2.142501","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Dom\xe8nech i Montaner, 3","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400301905","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-j2n5.epae.uvks",":version":"rv-ehhx.r6w9.eern",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal Font d\'En Fargues","indicador_refugi":"080193|CASAL_FONT_D_EN_FARGUES","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42431","longitud":"2.16522","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Pedrell, 67-69","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086003483","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-6im9_zhvz~bpan",":version":"rv-yy38-g3wg~tvai",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"C\xe0ndida P\xe9rez, Jardins de (Compte Borrell 44)","indicador_refugi":"080193|CANDIDA_PEREZ_JARDINS_DE_COMPTE_BORRELL_44","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37768","longitud":"2.163102","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Jardins C\xe0ndida P\xe9rez, 0","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400226468","tipologia":"Interiors d\u2019Illa","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-4iyc_wp9n_6ts7",":version":"rv-4wd8~yjya_h7h6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Carlit, Jardins del (Roger de Flor 160)","indicador_refugi":"080193|CARLIT_JARDINS_DEL_ROGER_DE_FLOR_160","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39731","longitud":"2.175274","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Roger de Flor, 146","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/95062123700","tipologia":"Interiors d\u2019Illa","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-xj5f.7a22.xvch",":version":"rv-mq38-a3rw.zvmm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Carme Biada, Jardins de (Bruc 153 - Roger de Ll\xfaria 132)","indicador_refugi":"080193|CARME_BIADA_JARDINS_DE_BRUC_153_ROGER_DE_LLURIA_132","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39838","longitud":"2.1628","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Jardins Carme Biada, 0","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400184041","tipologia":"Interiors d\u2019Illa","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-uw9a_vd9s.6x5p",":version":"rv-jac6-jmve_83y3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Clotilde Cerd\xe0, Jardins de (Marina 197 - Sardenya 254)","indicador_refugi":"080193|CLOTILDE_CERDA_JARDINS_DE_MARINA_197_SARDENYA_254","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40016","longitud":"2.17861","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Consell de Cent, 486","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99117134859","tipologia":"Interiors d\u2019Illa","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-uyjm-u3y2-cgfg",":version":"rv-9iyb_5xuz_ikp8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Constan\xe7a d\'Arag\xf3, Jardins (Roger de Flor 194)","indicador_refugi":"080193|CONSTANCA_D_ARAGO_JARDINS_ROGER_DE_FLOR_194","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39906","longitud":"2.172981","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Roger de Flor, 194","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400260339","tipologia":"Interiors d\u2019Illa","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-rckc-xme7.2v2r",":version":"rv-aj7b_q57k-9et6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Emma de Barcelona, Jardins d\' (Comte Borrell 159)","indicador_refugi":"080193|EMMA_DE_BARCELONA_JARDINS_D_COMTE_BORRELL_159","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38239","longitud":"2.155181","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Comte Borrell, 159","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/335195642","tipologia":"Interiors d\u2019Illa","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ysm3.qhaw-4vvy",":version":"rv-nfuy_7smv_wdud",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Lina \xd3dena, Jardins  (Ali Bei 121 - Sardenya 170)","indicador_refugi":"080193|LINA_ODENA_JARDINS_ALI_BEI_121_SARDENYA_170","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39636","longitud":"2.183556","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Al\xed Bei, 115","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400047563","tipologia":"Interiors d\u2019Illa","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-2cms_b4ey.eexw",":version":"rv-5kp6~dhgy_uai4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Maria Matilde Almendros, Jardins (Cal\xe0bria 90-92)","indicador_refugi":"080193|MARIA_MATILDE_ALMENDROS_JARDINS_CALABRIA_90_92","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3793","longitud":"2.15627","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Jardins Maria Matilde Almendros, 0","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400194129","tipologia":"Interiors d\u2019Illa","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-rk65-9cep~mvhw",":version":"rv-i56i~8i3a_f2yn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Montserrat Roig, Jardins de (Rossell\xf3 490 - Proven\xe7a 533)","indicador_refugi":"080193|MONTSERRAT_ROIG_JARDINS_DE_ROSSELLO_490_PROVENCA_533","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40869","longitud":"2.178846","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Jardins Montserrat Roig, 0","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/96142123016","tipologia":"Interiors d\u2019Illa","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-xaaz_5fuj_mniw",":version":"rv-yc5w-fw9e.qz4y",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Paula Montal, Jardins de (Viladomat 149 - 151)","indicador_refugi":"080193|PAULA_MONTAL_JARDINS_DE_VILADOMAT_149_151","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38142","longitud":"2.154069","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Jardins Paula Montal, 0","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400063147","tipologia":"Interiors d\u2019Illa","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-qans.dmxd.b29q",":version":"rv-bcza~v8av~2tun",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Safo, Jardins de  (Llan\xe7a, C. 48 - Roma, Av. 20)","indicador_refugi":"080193|SAFO_JARDINS_DE_LLANCA_C_48_ROMA_AV_20","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38065","longitud":"2.145994","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Jardins Safo, 0","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/1183122853","tipologia":"Interiors d\u2019Illa","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-mh9s_67ie~njx3",":version":"rv-ivk6~t73y_abue",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Tete Montoliu, Jardins (Sep\xfalveda 88)","indicador_refugi":"080193|TETE_MONTOLIU_JARDINS_SEPULVEDA_88","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37871","longitud":"2.157611","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Jardins Tete Montoliu, 0","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400175567","tipologia":"Interiors d\u2019Illa","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-n65z-fs7r~y64f",":version":"rv-jdwc_p24z_8jge",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Torre de les Aig\xfces, Jard\xed (Roger de Ll\xfaria 56)","indicador_refugi":"080193|TORRE_DE_LES_AIGUES_JARDI_ROGER_DE_LLURIA_56","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39331","longitud":"2.169639","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Roger de Ll\xfaria, 56","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086030520","tipologia":"Interiors d\u2019Illa","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-6x5g_7jbd~bqqd",":version":"rv-9rpw.fccd.irqc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Tres Tombs, Jardins (Manso 28 - Cal\xe0bria 8)","indicador_refugi":"080193|TRES_TOMBS_JARDINS_MANSO_28_CALABRIA_8","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37606","longitud":"2.160819","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Cal\xe0bria, 940","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/1128115652","tipologia":"Interiors d\u2019Illa","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-zxjh.8m66.du5z",":version":"rv-8s67_fzmz-jj2u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Fabra i Coats: F\xe0brica de Creaci\xf3","indicador_refugi":"080193|FABRA_I_COATS_FABRICA_DE_CREACIO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43376","longitud":"2.190814","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Sant Adri\xe0, 20","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400193035","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-kcc3-dzqs.7bai",":version":"rv-xsej~a8dc_4yai",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pati de l\'Escola Bressol Municipal L\'Esquirol","indicador_refugi":"080193|PATI_DE_L_ESCOLA_BRESSOL_MUNICIPAL_L_ESQUIROL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37229","longitud":"2.139195","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"S\xed","adreca":"C Noguera Pallaresa, 32","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737907","tipologia":"Patis d\'Escola Bressol","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-khhs-mezy_8v7j",":version":"rv-2uuj.dqng_p9wz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pati de l\'Escola Bressol Municipal Margall\xf3","indicador_refugi":"080193|PATI_DE_L_ESCOLA_BRESSOL_MUNICIPAL_MARGALLO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42006","longitud":"2.203971","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"S\xed","adreca":"C Concili de Trento, 249","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737908","tipologia":"Patis d\'Escola Bressol","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ceh6~uh4k-az9x",":version":"rv-g8qt.2ewr~v997",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC Can Deu","indicador_refugi":"080193|CC_CAN_DEU","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38677","longitud":"2.132505","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. de la Conc\xf2rdia, 13","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086017856","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-hryi-7zgt.3iwi",":version":"rv-sm8w.pbu2_9p5z",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC Parc Sandaru","indicador_refugi":"080193|CC_PARC_SANDARU","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39172","longitud":"2.184738","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Buenaventura Mu\xf1oz, 21","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400161204","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ptv5.vamv_9kxs",":version":"rv-5axr-67ih.8pkk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC Sant Mart\xed","indicador_refugi":"080193|CC_SANT_MARTI","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41661","longitud":"2.198577","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Selva de Mar, 215","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086005093","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-hc5e-t9ut.5s9k",":version":"rv-myhn_akem-2amx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC Can Felipa","indicador_refugi":"080193|CC_CAN_FELIPA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40365","longitud":"2.200478","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. Josep Maria Huertas Claveria, 1","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086035490","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-bk2y~sabp-5i4u",":version":"rv-t5st.ny7u.9b4n",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Barri La Llacuna","indicador_refugi":"080193|CASAL_DE_BARRI_LA_LLACUNA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40285","longitud":"2.190664","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Bol\xedvia, 49","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400579089","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-fw75-5kvb_j9hn",":version":"rv-ya8j-hqad_z9x6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de gent gran Josep Trueta","indicador_refugi":"080193|CASAL_DE_GENT_GRAN_JOSEP_TRUETA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37692","longitud":"2.167251","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Reina Am\xe0lia, 31","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011061","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ui9c-ey9z~c88n",":version":"rv-84e5_q2nc_8ucx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de gent gran Josep Tarradellas","indicador_refugi":"080193|CASAL_DE_GENT_GRAN_JOSEP_TARRADELLAS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38194","longitud":"2.167146","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. Caramelles, 3","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92150113813","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-pyz2~t43n-nxgn",":version":"rv-79sv_4yte~kbeg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La Ludo","indicador_refugi":"080193|LA_LUDO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38681","longitud":"2.188081","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Pas Institut Escola, 1. Parc de la Ciutadella","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/69133728","tipologia":"Equipaments Ambientals","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-zbcc~yamq_kywu",":version":"rv-4ujs~4wub_q432",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CEM Sardenya","indicador_refugi":"080193|CEM_SARDENYA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41214","longitud":"2.162182","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"C. Sardenya, 549","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/97178123551","tipologia":"Complexos esportius","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-fqnh-efwc_e5q9",":version":"rv-bj47.tjyf~36kk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Persones Grans Casc Antic","indicador_refugi":"080193|CASAL_DE_PERSONES_GRANS_CASC_ANTIC","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38737","longitud":"2.178657","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Mestres Casals i Martorell, 2-16","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400659719","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-amvn_mbnb-v9j9",":version":"rv-j4gj_w8h4-pmff",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Associaci\xf3 de ve\xefnes i ve\xefns dEl Clot-Camp de l\'Arpa","indicador_refugi":"080193|ASSOCIACIO_DE_VEINES_I_VEINS_DEL_CLOT_CAMP_DE_L_ARPA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41028","longitud":"2.185959","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Sibelius, 3","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086010413","tipologia":"Altres","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-nyu3-mic5~tpe2",":version":"rv-ibib~wn35~3ahx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines Descoberta del CEM Bac de Roda","indicador_refugi":"080193|PISCINES_DESCOBERTA_DEL_CEM_BAC_DE_RODA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41435","longitud":"2.194073","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Rbla. Guip\xfascoa, 25","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400110882","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-24ra-qr7i~prri",":version":"rv-jvsh~snfh~5ufu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Descoberta del CEM Can Toda","indicador_refugi":"080193|PISCINA_DESCOBERTA_DEL_CEM_CAN_TODA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41535","longitud":"2.158164","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Ramiro de Maeztu, 25","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086003372","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-r3pe~8urd~fdq7",":version":"rv-j8eg~gv2j.4n35",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Coberta del CEM Aiguajoc Borrell","indicador_refugi":"080193|PISCINA_COBERTA_DEL_CEM_AIGUAJOC_BORRELL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37638","longitud":"2.163747","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Compte Borrell, 21-33","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/96319161157","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-v67g_8rc3_hx4n",":version":"rv-w68h-waxr-fh2z",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines Cobertes del CEM Artesania","indicador_refugi":"080193|PISCINES_COBERTES_DEL_CEM_ARTESANIA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.44416","longitud":"2.171071","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Artesania, 63","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400110352","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ng7v_wpcy.zie9",":version":"rv-3jtf_pa5u~k576",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Coberta del CEM Piscines Bernat Picornell","indicador_refugi":"080193|PISCINA_COBERTA_DEL_CEM_PISCINES_BERNAT_PICORNELL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.36629","longitud":"2.150628","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. de l\'Estadi, 30-38","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94125141220","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-y6et~rt3f~74fm",":version":"rv-hj4k_krzs_mwp9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Descoberta del CEM Can Caralleu","indicador_refugi":"080193|PISCINA_DESCOBERTA_DEL_CEM_CAN_CARALLEU","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40156","longitud":"2.111093","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. dels Esports, 2-8","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086010501","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jdy9_3r9z-trte",":version":"rv-4zhs~5dcc-9q9w",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Coberta del CEM Can Felipa","indicador_refugi":"080193|PISCINA_COBERTA_DEL_CEM_CAN_FELIPA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40365","longitud":"2.200481","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl.  Josep M\xaa Huertas Claveria, 1","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/98168115723","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-rzmp.skvq.u996",":version":"rv-ck9v_n8pq_f3wj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Coberta del CEM Can Ricart","indicador_refugi":"080193|PISCINA_COBERTA_DEL_CEM_CAN_RICART","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37728","longitud":"2.170923","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. St. Oleguer, 10","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400164786","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-cd4j.n99j.avyz",":version":"rv-6a3v_7px4~spqg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Coberta del CEM dEl Carmel","indicador_refugi":"080193|PISCINA_COBERTA_DEL_CEM_DEL_CARMEL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42317","longitud":"2.158547","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Pedrell, 192-202","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400060119","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-8v3b_hpuu~2zsj",":version":"rv-u9in_unjv~ffer",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines Cobertes del CEM Claror","indicador_refugi":"080193|PISCINES_COBERTES_DEL_CEM_CLAROR","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40464","longitud":"2.171457","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Sardenya, 333","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086020201","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-7kbf.ssb4.ixq9",":version":"rv-w3b7~v9yw-tyiw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Coberta del CEM Colom","indicador_refugi":"080193|PISCINA_COBERTA_DEL_CEM_COLOM","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37796","longitud":"2.176246","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. La Rambla, 18","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94276105023","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-tint_2u2j_tfvt",":version":"rv-2fcw_2cyt-n5pv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines Cobertes del CEM Cotxeres Borb\xf3","indicador_refugi":"080193|PISCINES_COBERTES_DEL_CEM_COTXERES_BORBO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42648","longitud":"2.17706","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Ram\xf3n Alb\xf3, 47-57","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400276356","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-mze5~v5j8~j4f9",":version":"rv-t4xy_74v6_k2uj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Descoberta del CEM de Sant Sebasti\xe0","indicador_refugi":"080193|PISCINA_DESCOBERTA_DEL_CEM_DE_SANT_SEBASTIA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37358","longitud":"2.188742","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. del Mar, s/n","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/98110133629","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-mgdq_tyep-qjnk",":version":"rv-xuk8_iakc.s4yc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Coberta del CEM Estaci\xf3 del Nord","indicador_refugi":"080193|PISCINA_COBERTA_DEL_CEM_ESTACIO_DEL_NORD","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39393","longitud":"2.183183","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. N\xe0pols, 42-44","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99133121652","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-u2yd.9t3u.srds",":version":"rv-i5zq.sqtn~eck6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Descoberta del CEM Guinard\xf3","indicador_refugi":"080193|PISCINA_DESCOBERTA_DEL_CEM_GUINARDO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41702","longitud":"2.173619","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"c. Torrent d\'en Melis s/n","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400110852","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-kz2g.9qx2.ew4b",":version":"rv-6f2t~3gek_scu9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines Cobertes del CEM Horta","indicador_refugi":"080193|PISCINES_COBERTES_DEL_CEM_HORTA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43359","longitud":"2.161094","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"SI","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Feliu i Codina, 27","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/93307114429","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-qb9e.ikme.5a6w",":version":"rv-xzvu~gwng.fq2e",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Coberta del CEM Joan Mir\xf3","indicador_refugi":"080193|PISCINA_COBERTA_DEL_CEM_JOAN_MIRO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37846","longitud":"2.150983","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"si","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Diputaci\xf3, 17-19","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/1057133310","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-gbac_wvg7~h3vi",":version":"rv-kjua~g2i2~nj5d",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines Cobertes del CEM J\xfapiter","indicador_refugi":"080193|PISCINES_COBERTES_DEL_CEM_JUPITER","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41772","longitud":"2.201996","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Agricultura, 232","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400110897","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-zzma_xqzt~up75",":version":"rv-mb33.zm9k_wxmu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines Cobertes del CEM l\'Espanya Industrial","indicador_refugi":"080193|PISCINES_COBERTES_DEL_CEM_L_ESPANYA_INDUSTRIAL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37741","longitud":"2.14192","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Parc de l\'Espanya Industrial, s/n","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/93327121407","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-qqnp_j97k-hspp",":version":"rv-n3xt_st6t-3532",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Coberta del CEM La Bordeta","indicador_refugi":"080193|PISCINA_COBERTA_DEL_CEM_LA_BORDETA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37241","longitud":"2.139625","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Noguera Pallaresa, 34-42","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400110957","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-6fjd.9jfx_i8w6",":version":"rv-ns2k~mq2g_mgf7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Coberta del CEM La Verneda","indicador_refugi":"080193|PISCINA_COBERTA_DEL_CEM_LA_VERNEDA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42513","longitud":"2.204367","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"SI","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Bin\xe8far, 10-14","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086023364","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-7wkr-nvcr-2q5h",":version":"rv-wpae-p3qq_d3q4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines Cobertes del CEM Les Corts","indicador_refugi":"080193|PISCINES_COBERTES_DEL_CEM_LES_CORTS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38569","longitud":"2.134193","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Trav. de Les Corts, 252-254","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/117132415","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ftzf.t5td_rvzy",":version":"rv-f83n_8ehx.4bxi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines Cobertes del CEM Maresme","indicador_refugi":"080193|PISCINES_COBERTES_DEL_CEM_MARESME","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41321","longitud":"2.213982","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Pallars, 484","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400036999","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-gkpf_ck6t-jyhr",":version":"rv-rt5r_iwk4_24em",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Coberta del CEM Mar\xedtim","indicador_refugi":"080193|PISCINA_COBERTA_DEL_CEM_MARITIM","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38447","longitud":"2.194867","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pg. Mar\xedtim Barceloneta, 33","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400322471","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wbcw.r43q-2c97",":version":"rv-5zma_ia8v.fhk7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines Cobertes del CEM Mundet","indicador_refugi":"080193|PISCINES_COBERTES_DEL_CEM_MUNDET","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43591","longitud":"2.142863","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Olympe de Gouges, s/n","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400322478","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-fvf7~i5y2.2583",":version":"rv-cu6r_xnuj-ktiw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Coberta del CEM Nova Ic\xe0ria","indicador_refugi":"080193|PISCINA_COBERTA_DEL_CEM_NOVA_ICARIA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39236","longitud":"2.197997","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. Ic\xe0ria, 167","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/312152814","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ukex~q6hr_7gnn",":version":"rv-n6rc_uubd-ervm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Coberta del CEM Parc de la Ciutadella","indicador_refugi":"080193|PISCINA_COBERTA_DEL_CEM_PARC_DE_LA_CIUTADELLA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38553","longitud":"2.186413","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pg. de Circumval\xb7laci\xf3, 1","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400144112","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-zini~2te4~gny6",":version":"rv-jvm3~e98z_tg7i",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines Cobertes del CEM Putxet","indicador_refugi":"080193|PISCINES_COBERTES_DEL_CEM_PUTXET","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40972","longitud":"2.14131","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Marmell\xe0, 23","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400247088","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-quyn.ewc9~hp63",":version":"rv-ebng-p7cd~ucp5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines Cobertes del CEM Sagrada Fam\xedlia","indicador_refugi":"080193|PISCINES_COBERTES_DEL_CEM_SAGRADA_FAMILIA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40725","longitud":"2.179314","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Cartagena, 231-239","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/98301132224","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-kges_are8~tthy",":version":"rv-emjk~aage.39he",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines Cobertes del CEM Sant Andreu - La Sagrera","indicador_refugi":"080193|PISCINES_COBERTES_DEL_CEM_SANT_ANDREU_LA_SAGRERA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42977","longitud":"2.192734","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Sta. Coloma, 25","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400322493","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-93pg~nqye~pzam",":version":"rv-76m7.rdff.x6jz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines Cobertes del CEM Sardenya","indicador_refugi":"080193|PISCINES_COBERTES_DEL_CEM_SARDENYA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41209","longitud":"2.162226","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Sardenya, 549-553","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99147085139","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ynt3~ajct_nep4",":version":"rv-zfv2~tysp.8vsw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Coberta del CEM Trinitat Vella","indicador_refugi":"080193|PISCINA_COBERTA_DEL_CEM_TRINITAT_VELLA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.45145","longitud":"2.193105","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"si","adreca":"Via B\xe0rcino 84-86","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086010810","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-25d5.syjy_qeys",":version":"rv-ewmf_ymaj~scgr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Coberta del CEM Vintr\xf3 - Joan Alentorn","indicador_refugi":"080193|PISCINA_COBERTA_DEL_CEM_VINTRO_JOAN_ALENTORN","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40665","longitud":"2.186275","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Consell de Cent, 623-627","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99165122406","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-vufw-vwhz-32vh",":version":"rv-fus2_2v8g.essf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Descoberta del Centre Municipal Tennis Vall Hebron","indicador_refugi":"080193|PISCINA_DESCOBERTA_DEL_CENTRE_MUNICIPAL_TENNIS_VALL_HEBRON","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42975","longitud":"2.145472","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pg. Vall d\'Hebron, 178-196","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400110881","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-z8hq_95dy_nyph",":version":"rv-bp6m_vz9p_76f7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Descoberta del CEM Bon Pastor","indicador_refugi":"080193|PISCINA_DESCOBERTA_DEL_CEM_BON_PASTOR","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43818","longitud":"2.201731","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"SI","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Costa Daurada, 12","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/98188181031","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-szjz~c35g_kvhj",":version":"rv-decq~d9sz.yvwr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Coberta del CEM Can Cuy\xe0s","indicador_refugi":"080193|PISCINA_COBERTA_DEL_CEM_CAN_CUYAS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.45988","longitud":"2.168115","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"SI","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. Rasos de Peguera, 242","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/93057134404","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-mx3m_hjk3-qaty",":version":"rv-iykv.pyva~9z8p",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Coberta del CEM Olimpics Vall Hebron","indicador_refugi":"080193|PISCINA_COBERTA_DEL_CEM_OLIMPICS_VALL_HEBRON","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42807","longitud":"2.144382","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pg. Vall d\'Hebron, 166-176","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99301125047","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-y7ac_dt4k-si7v",":version":"rv-y7bf~2jyh_6djn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Coberta del CEM Tur\xf3 de la Peira","indicador_refugi":"080193|PISCINA_COBERTA_DEL_CEM_TURO_DE_LA_PEIRA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43286","longitud":"2.172184","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"SI","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Sant Iscle, 50","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400644388","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-89wv-gmr9.b3re",":version":"rv-s6b2~bb7v.canc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Descoberta de La Clota","indicador_refugi":"080193|PISCINA_DESCOBERTA_DE_LA_CLOTA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42609","longitud":"2.149446","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. Clota, s/n","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/97331093926","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-f5vu.gs58~9eyq",":version":"rv-8qmj-qiif-eddg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines Municipals Montju\xefc","indicador_refugi":"080193|PISCINES_MUNICIPALS_MONTJUIC","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.36906","longitud":"2.164596","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. Miramar, 31-37","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086000228","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-gizr-v2tc~w6bv",":version":"rv-hrpd_5z6p-93uk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Coberta del CEM Piscina Sant Jordi","indicador_refugi":"080193|PISCINA_COBERTA_DEL_CEM_PISCINA_SANT_JORDI","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38906","longitud":"2.147353","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Par\xeds, 114","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086002693","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-rp7r_55ae~xwuh",":version":"rv-8b5c~yegc~ixne",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines Cobertes del CEM Can Drag\xf3","indicador_refugi":"080193|PISCINES_COBERTES_DEL_CEM_CAN_DRAGO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43657","longitud":"2.183127","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Rosell\xf3 i Porcel, 7-11","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400322483","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-4y2b.azkt~fcj7",":version":"rv-ffnp-p6sx_yca5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines Coberta del CEM Perill","indicador_refugi":"080193|PISCINES_COBERTA_DEL_CEM_PERILL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3994","longitud":"2.161506","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Perill, 16-22","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086031187","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ab75.jrad~upyv",":version":"rv-4qp5_p7jb~dhxf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina del Llac del Parc de la Creueta del Coll","indicador_refugi":"080193|PISCINA_DEL_LLAC_DEL_PARC_DE_LA_CREUETA_DEL_COLL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41861","longitud":"2.148139","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pg. Mare de D\xe9u del Coll, 89","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/93302114541","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-pe65~7nzg.gwyx",":version":"rv-sczg.ptnn~cncc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Artes\xe0 Tradicion\xe0rius - CAT","indicador_refugi":"080193|CENTRE_ARTESA_TRADICIONARIUS_CAT","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40255","longitud":"2.154436","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. Anna Frank","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737894","tipologia":"Entitats culturals","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-vszj.qpwh-36r8",":version":"rv-vuzz_c7ti_razk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Comercial Arenas de Barcelona","indicador_refugi":"080193|CENTRE_COMERCIAL_ARENAS_DE_BARCELONA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3763","longitud":"2.149305","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"G.V. Corts Catalanes, 373-385","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400267330","tipologia":"Centres comercials","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-axmc~3es9_f8pv",":version":"rv-ce8t-g4d5~ranv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Comercial Diagonal Mar","indicador_refugi":"080193|CENTRE_COMERCIAL_DIAGONAL_MAR","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40967","longitud":"2.21573","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. Diagonal, 3","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/1313140637","tipologia":"Centres comercials","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-k6yq-wsdu-sqeq",":version":"rv-rk9k.ej27_cai3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre d\'Atenci\xf3 Integral (CAI) Marina","indicador_refugi":"080193|CENTRE_D_ATENCIO_INTEGRAL_CAI_MARINA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.35952","longitud":"2.145259","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Foc, 97","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737609","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-i4ea-4fii~cxj4",":version":"rv-39gr_qveh_ij2k",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Cl\xednica Sant Antoni","indicador_refugi":"080193|CLINICA_SANT_ANTONI","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.35574","longitud":"2.143519","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Sant Eloi, 6-8","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400279672","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-tg59_xvfn-dhny",":version":"rv-pjru.fhmc_epsh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pati de l\'escola Seat","indicador_refugi":"080193|PATI_DE_L_ESCOLA_SEAT","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.35988","longitud":"2.137412","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Mec\xe0nica, 24 (entrada pel Pg. Zona Franca, 171 B)","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737910","tipologia":"Patis d\'Escola","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-qykf_6pyj.m8du",":version":"rv-e34x.bxpf~kvnu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parr\xf2quia de Santa Agn\xe9s","indicador_refugi":"080193|PARROQUIA_DE_SANTA_AGNES","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40102","longitud":"2.14446","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Sant Elies, 23","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400738061","tipologia":"Centres de culte","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-hdm6-t3fi-ikqb",":version":"rv-khy6_ami2.cwda",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parr\xf2quia de Sant Vicen\xe7 de Sarri\xe0","indicador_refugi":"080193|PARROQUIA_DE_SANT_VICENC_DE_SARRIA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39985","longitud":"2.12152","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. Sarri\xe0, 10","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400738062","tipologia":"Centres de culte","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wkfg-s66t~fsfw",":version":"rv-gtp2~qqif~ev3s",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Punt d\'Activitat de Creu Roja a Sants-Montju\xefc","indicador_refugi":"080193|PUNT_D_ACTIVITAT_DE_CREU_ROJA_A_SANTS_MONTJUIC","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.36111","longitud":"2.135446","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Francesc Boix Campo, 6","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400738067","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-8fqv_2r4q~qpzc",":version":"rv-6bzs-hyhn-g6ym",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parr\xf2quia de Sant Miquel del Port","indicador_refugi":"080193|PARROQUIA_DE_SANT_MIQUEL_DEL_PORT","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38001","longitud":"2.188571","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Sant Miquel, 39","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400738065","tipologia":"Centres de culte","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-854a_944y.j9k2",":version":"rv-6dge_uuf5_f8xz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Barri La Cosa Nostra","indicador_refugi":"080193|CASAL_DE_BARRI_LA_COSA_NOSTRA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43387","longitud":"2.167966","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Biure, 1","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400143979","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-szbv-rubv~i2gg",":version":"rv-xkf2~absj-z7m2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Barri Verdun","indicador_refugi":"080193|CASAL_DE_BARRI_VERDUN","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.44407","longitud":"2.17517","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Luz Casanova, 4","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400246329","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-msk4_uy3e-qqvg",":version":"rv-tyuy.g53a-sd25",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Barri de Vallbona","indicador_refugi":"080193|CASAL_DE_BARRI_DE_VALLBONA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.46437","longitud":"2.185937","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Orist\xe0, 8-10","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99026102727","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wy32-biwn.2ctk",":version":"rv-rh3v_w5gn~gu9b",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de les Tretze Roses","indicador_refugi":"080193|PARC_DE_LES_TRETZE_ROSES","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.35155","longitud":"2.140259","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. d\'Asc\xf3, 22","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400737923","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-26sg_exj4_9hwf",":version":"rv-6ab3~f8xs~8dd4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parr\xf2quia de Maria Mitjancera","indicador_refugi":"080193|PARROQUIA_DE_MARIA_MITJANCERA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38494","longitud":"2.143992","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Enten\xe7a, 198-200","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400740107","tipologia":"Centres de culte","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-6n4z-ehqj-99mb",":version":"rv-uwxv_jy8y_fr37",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat de l\'Abaceria","indicador_refugi":"080193|MERCAT_DE_L_ABACERIA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40331","longitud":"2.164824","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pg. Sant Joan, 181","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009463","tipologia":"Mercats","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-dx7q_7nq7_m9jv",":version":"rv-n29s_bqfc~hnwh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jocs d\'aigua de Canyelles","indicador_refugi":"080193|JOCS_D_AIGUA_DE_CANYELLES","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4423","longitud":"2.162721","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"No","adreca":"C. Juan Ram\xf3n Jim\xe9nez, 14","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400656486","tipologia":"Jocs d\'aigua","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-r2dp-k4fj-uwiv",":version":"rv-muzn.vm2v_d7rg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jocs d\'aigua de les Rieres d\'Horta","indicador_refugi":"080193|JOCS_D_AIGUA_DE_LES_RIERES_D_HORTA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4309","longitud":"2.155467","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"No","adreca":"Av. Estatut de Catalunya, 21","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400695979","tipologia":"Jocs d\'aigua","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-r6qf.gez9~xkv4",":version":"rv-868h~c3ku-kzyi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jocs d\'aigua de Bon Pastor","indicador_refugi":"080193|JOCS_D_AIGUA_DE_BON_PASTOR","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43774","longitud":"2.207129","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"No","adreca":"Pl. de la Lluita per les Llibertats","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400740126","tipologia":"Jocs d\'aigua","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-67m4-mhba~uqcx",":version":"rv-jnwc-u2ja~7r9f",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jocs d\'aigua del Can\xf2drom","indicador_refugi":"080193|JOCS_D_AIGUA_DEL_CANODROM","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42722","longitud":"2.183146","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"No","adreca":"C. Can Ros, 35","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400740235","tipologia":"Jocs d\'aigua","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-295m_r7ks~myi5",":version":"rv-mtmr.m8vc-ctia",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centro Galego de Barcelona","indicador_refugi":"080193|CENTRO_GALEGO_DE_BARCELONA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37939","longitud":"2.174737","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Rambla, 35-37","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086010651","tipologia":"Entitats culturals","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wjmc-tuy8_nidw",":version":"rv-79ew-pymd~9sgd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Fundaci\xf3 Casa Asil Sant Andreu de Palomar","indicador_refugi":"080193|FUNDACIO_CASA_ASIL_SANT_ANDREU_DE_PALOMAR","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4388","longitud":"2.186085","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Agust\xed i Mil\xe0, 72","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400740124","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-avun.dt6q-rqyk",":version":"rv-8r4z-vy4f.7j46",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari - La Barceloneta","indicador_refugi":"080193|CASAL_CIVIC_I_COMUNITARI_LA_BARCELONETA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38045","longitud":"2.188552","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Baluard, 28","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011057","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-8hqg~zrbj.znen",":version":"rv-vz89.gv74~i8ww",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari - Horta","indicador_refugi":"080193|CASAL_CIVIC_I_COMUNITARI_HORTA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4266","longitud":"2.156329","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Tolr\xe0, 13-21 bxs","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94110141919","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-u8kw.wkiq-gguk",":version":"rv-2c8e-hqet-d3te",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari - Guineueta","indicador_refugi":"080193|CASAL_CIVIC_I_COMUNITARI_GUINEUETA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.44035","longitud":"2.16655","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Guineueta, 19","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086026114","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-fif3_ueph~eg6x",":version":"rv-2amm-8iac~79de",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari - Prosperitat","indicador_refugi":"080193|CASAL_CIVIC_I_COMUNITARI_PROSPERITAT","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.44193","longitud":"2.180498","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. de Pablo Iglesias, 8","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400038461","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-xf8i.z5xv-kxbg",":version":"rv-mury-fd79.6q3h",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari - Trinitat Vella","indicador_refugi":"080193|CASAL_CIVIC_I_COMUNITARI_TRINITAT_VELLA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.44975","longitud":"2.191259","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. de la Madriguera, 38-42 baixos","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400513760","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-97ar_tezk-5ykt",":version":"rv-tace_s649~w786",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari - Verdum","indicador_refugi":"080193|CASAL_CIVIC_I_COMUNITARI_VERDUM","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.44423","longitud":"2.175522","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Luz Casanova, 8-10","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400595416","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-nwkm~iysm_ahrn",":version":"rv-579y_cc4k-smc2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari - Verdum Artesania","indicador_refugi":"080193|CASAL_CIVIC_I_COMUNITARI_VERDUM_ARTESANIA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.44243","longitud":"2.172552","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. de l\'Artesania, 96-98","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400079150","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-r82k~dg4x_erqu",":version":"rv-9pxu_gp5d_u7hh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari - Bac de Roda","indicador_refugi":"080193|CASAL_CIVIC_I_COMUNITARI_BAC_DE_RODA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41443","longitud":"2.195884","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Bac de Roda, 190","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011160","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-g36m_6sfk_2rh2",":version":"rv-w2z7-93tt_6bip",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari - La Pau","indicador_refugi":"080193|CASAL_CIVIC_I_COMUNITARI_LA_PAU","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42316","longitud":"2.20858","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Pere Verges 1, 8a planta","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400144312","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-f32k-hfym~8453",":version":"rv-sq5g_xct7.uj3m",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari - Sants","indicador_refugi":"080193|CASAL_CIVIC_I_COMUNITARI_SANTS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38005","longitud":"2.1335","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Violant Hongria Rna Arag\xf3, 135","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011106","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-yzu2~rzpd_3jhk",":version":"rv-zpiw_49br-7q2p",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jocs d\'aigua de la font de la pl. Maresme","indicador_refugi":"080193|JOCS_D_AIGUA_DE_LA_FONT_DE_LA_PL_MARESME","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41213","longitud":"2.215649","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"No","adreca":"Pl. del Maresme","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400757468","tipologia":"Jocs d\'aigua","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-kd4g.sydy-adyy",":version":"rv-99rq~hwj9_6hwu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jocs d\'aigua de la pla\xe7a de les Caramelles","indicador_refugi":"080193|JOCS_D_AIGUA_DE_LA_PLACA_DE_LES_CARAMELLES","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38231","longitud":"2.167777","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"No","adreca":"Pl. de les Caramelles","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400757467","tipologia":"Jocs d\'aigua","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-f2uq.abdp-xexh",":version":"rv-e89f~26gr-q6xd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jocs d\'aigua dels jardins de Sant Joan de D\xe9u - Illa Diagonal","indicador_refugi":"080193|JOCS_D_AIGUA_DELS_JARDINS_DE_SANT_JOAN_DE_DEU_ILLA_DIAGONAL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38902","longitud":"2.135393","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"No","adreca":"Av. Diagonal, 557","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400757466","tipologia":"Jocs d\'aigua","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-4bek-2qtk_2d2k",":version":"rv-i6cr_cx5t_wubk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jocs d\'aigua de la Pla\xe7a de les Gl\xf2ries","indicador_refugi":"080193|JOCS_D_AIGUA_DE_LA_PLACA_DE_LES_GLORIES","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40407","longitud":"2.185749","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"No","adreca":"Pl. de les Gl\xf2ries Catalanes","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400757464","tipologia":"Jocs d\'aigua","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-4tq5~dc5h-r7v4",":version":"rv-wktp-6yi4~vv83",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Ton i Guida","indicador_refugi":"080193|CENTRE_TON_I_GUIDA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.44633","longitud":"2.175171","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Roman\xed, 6","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400143973","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-aibf.p4kh.jsgy",":version":"rv-xt6q.82hp_xsgg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Barri de Torre Bar\xf3","indicador_refugi":"080193|CASAL_DE_BARRI_DE_TORRE_BARO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.45951","longitud":"2.180674","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. d\'Escolapi C\xe0ncer, 5","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400143974","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-hjnv_fuha-vh8w",":version":"rv-wvuz.r2up-qrfs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Barri de Prosperitat","indicador_refugi":"080193|CASAL_DE_BARRI_DE_PROSPERITAT","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.44162","longitud":"2.179794","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. d\'\xc0ngel Pesta\xf1a","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086025446","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-hwuk_z363~6ih9",":version":"rv-56yz.fzae_ms5j",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Barri Trinitat Nova - Som La Pera","indicador_refugi":"080193|CASAL_DE_BARRI_TRINITAT_NOVA_SOM_LA_PERA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.45266","longitud":"2.187632","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. de Garb\xed, 3","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400582519","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-cucb_m3t4-hufb",":version":"rv-vkqi~pdkv~4e3v",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bib. Sarri\xe0 - J.V.Foix","indicador_refugi":"080193|BIB_SARRIA_J_V_FOIX","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39956","longitud":"2.121155","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. de Sarri\xe0, 1","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400672437","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-9zef_5789-zw4m",":version":"rv-7axc_6h5q_t5a3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Civic Sant Andreu","indicador_refugi":"080193|CENTRE_CIVIC_SANT_ANDREU","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43084","longitud":"2.189411","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Gran de Sant Andreu, 111","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086004879","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3ntx_hqsg~bgq6",":version":"rv-iiu2.3xj2_t9iq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala Pepita Casanelles (CC Casa del Rellotge)","indicador_refugi":"080193|SALA_PEPITA_CASANELLES_CC_CASA_DEL_RELLOTGE","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.36095","longitud":"2.138005","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. de l\'Orgull, 1","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400180624","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-f3i7_22h8_qqid",":version":"rv-865w-tjn4_era5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC Albareda","indicador_refugi":"080193|CC_ALBAREDA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37399","longitud":"2.17325","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. d\'Albareda, 22","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400304670","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-6vzz_reqw~597k",":version":"rv-ix5c_bjpk_g5ks",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Col\xb7legi de Metges de Barcelona","indicador_refugi":"080193|COL_LEGI_DE_METGES_DE_BARCELONA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40421","longitud":"2.129325","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pg. de la Bonanova, 47","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086005338","tipologia":"Altres","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-xwc8_ukk7-k7ef",":version":"rv-9fpg~b7ty~6snd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Foodcoop BCN","indicador_refugi":"080193|FOODCOOP_BCN","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38557","longitud":"2.157338","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Ptge. d\'Arag\xf3, 9","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400685645","tipologia":"Altres","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wews-npbg_v6tq",":version":"rv-zk7u-qrx7~43dd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala Barcelona del Museu Terra","indicador_refugi":"080193|SALA_BARCELONA_DEL_MUSEU_TERRA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40203","longitud":"2.196899","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. de Pere IV, 141","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400727187","tipologia":"Museus","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-xv3i~v4e4-t9iw",":version":"rv-ke78_jz5e.w4mf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Associaci\xf3 de Comerciants Creu Coberta","indicador_refugi":"080193|ASSOCIACIO_DE_COMERCIANTS_CREU_COBERTA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.376","longitud":"2.143145","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Callao, 9","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086010309","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-nehb-nknt_r72z",":version":"rv-6dke_ynpf~3i2r",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa Sanzano","indicador_refugi":"080193|CASA_SANZANO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40471","longitud":"2.176492","accessibilitat":"Altres","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Lepant, 276","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400765984","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-hij3.h4um-gag2",":version":"rv-evyy.tz64-r9gb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Farm\xe0cia Jacas Mateu","indicador_refugi":"080193|FARMACIA_JACAS_MATEU","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40335","longitud":"2.177716","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"C. Val\xe8ncia, 470","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990129747","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-4iwj-uxf7~gzmm",":version":"rv-qxxn~7fuw.vi4q",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Llibreria Byron","indicador_refugi":"080193|LLIBRERIA_BYRON","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38338","longitud":"2.161679","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. de Casanova, 32","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400659129","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wzc2_tg3p~cv32",":version":"rv-kr8v-hwic.eedx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai Social Torrent d\'en Mariner","indicador_refugi":"080193|ESPAI_SOCIAL_TORRENT_D_EN_MARINER","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40369","longitud":"2.170008","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Ptge. de Mariner, 13-17","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400691993","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-asb6~uv9n-8br3",":version":"rv-f3fi-iun3-5bdc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Fundaci\xf3 Gentis - Concili de Trento","indicador_refugi":"080193|FUNDACIO_GENTIS_CONCILI_DE_TRENTO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4114","longitud":"2.192965","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Concili de Trento, 42, Baixos \u2013 Local 1","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400447894","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-pmpe_2utt_f4mi",":version":"rv-wszz_8ftw_ty3m",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Fundaci\xf3 Gentis - Raval","indicador_refugi":"080193|FUNDACIO_GENTIS_RAVAL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37955","longitud":"2.170168","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Sant Rafael 10, Baixos (=C. Maria Casas Mira, 10, Baixos)","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766053","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-rfqn.ketp-83nv",":version":"rv-phv2.zrht~jdfa",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"EAP Sardenya","indicador_refugi":"080193|EAP_SARDENYA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40948","longitud":"2.165579","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Sardenya, 466","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/1015170605","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-6hru.jqm8.5qyp",":version":"rv-dj9r.xpiw_4ekt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pati de l\'escola Llu\xeds Vives i d\'Institut Llu\xeds Vives","indicador_refugi":"080193|PATI_DE_L_ESCOLA_LLUIS_VIVES_I_D_INSTITUT_LLUIS_VIVES","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37177","longitud":"2.128533","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Canalejas, 107 (entrada pel C. Riera Blanca)","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400758401","tipologia":"Patis d\'Escola","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ww6t.hfgi.autr",":version":"rv-v4uh-kbvn_5c84",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca de l\'escola Merc\xe8 Rodoreda","indicador_refugi":"080193|BIBLIOTECA_DE_L_ESCOLA_MERCE_RODOREDA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.44581","longitud":"2.185406","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. del Vesuvi, 35  (entrada per Av. Meridiana)","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400758411","tipologia":"Biblioteques","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-tym6~v97g~knn4",":version":"rv-yy2i-wkya_jefb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jocs d\'aigua dels Entorns Casa de l\'Aigua Trinitat Vella","indicador_refugi":"080193|JOCS_D_AIGUA_DELS_ENTORNS_CASA_DE_L_AIGUA_TRINITAT_VELLA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.453","longitud":"2.188282","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"No","adreca":"Carretera de Ribes, 103 - 111","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400758415","tipologia":"Jocs d\'aigua","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-293b.56gp_bb9r",":version":"rv-gsxu~bszx~fnat",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Maremagnum","indicador_refugi":"080193|MAREMAGNUM","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37511","longitud":"2.183021","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Moll d\'Espanya 5-6","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/95128134914","tipologia":"Centres comercials","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-fu5g~9qjr-m837",":version":"rv-gszw~ynk9-dtay",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bebe-T\xe9","indicador_refugi":"080193|BEBE_TE","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37584","longitud":"2.161338","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Parlament, 7","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400582148","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-fc8t.7m3h-q627",":version":"rv-fk2m~ymqp-2xd3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Siente","indicador_refugi":"080193|SIENTE","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41068","longitud":"2.182774","accessibilitat":"No","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Rogent, 96","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766097","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wej6-da9r~24e5",":version":"rv-dusn.qzve~2ggd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Equipament Municipal de Pla\xe7a Sarri\xe0","indicador_refugi":"080193|EQUIPAMENT_MUNICIPAL_DE_PLACA_SARRIA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39956","longitud":"2.121155","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. de Sarri\xe0, 1-4","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400758810","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ihy9.btz4-8ins",":version":"rv-x6ra_5rux.zt22",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Fundaci\xf3 Privada Avism\xf3n-Catalunya","indicador_refugi":"080193|FUNDACIO_PRIVADA_AVISMON_CATALUNYA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37367","longitud":"2.134907","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. dels Jocs Florals, 59","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/97160101028","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-rxz5-urua_aumb",":version":"rv-4d6u~rfe9~t8hr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat de la Marina","indicador_refugi":"080193|MERCAT_DE_LA_MARINA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.36052","longitud":"2.139182","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed (gratu\xeft)","adreca":"Pg. Zona Franca 178-180","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009456","tipologia":"Mercats","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-rpc9-5imb-z4c6",":version":"rv-yk92_25cq_txb4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Store Endesa","indicador_refugi":"080193|STORE_ENDESA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42942","longitud":"2.159097","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Baixada de la Plana, 33","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766100","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-yvsz.epgx.cbh2",":version":"rv-rkcb-m7g7_rwek",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Farm\xe0cia Marina Oriol","indicador_refugi":"080193|FARMACIA_MARINA_ORIOL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40124","longitud":"2.202309","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Llull, 187","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086001777","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ahqm.jb7h_26mh",":version":"rv-vt9v.296u.nw5u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CC Gand House","indicador_refugi":"080193|CC_GAND_HOUSE","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40179","longitud":"2.202294","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Mari\xe0 Aguilo, 72","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766115","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-22sm~88hj~dwwt",":version":"rv-tz4m-vvnz~7sc3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CAP Vallcarca Sant Gervasi","indicador_refugi":"080193|CAP_VALLCARCA_SANT_GERVASI","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4167","longitud":"2.141258","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. De Vallcarca, 169-205","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400110414","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-p7pz~xtzk~jf4j",":version":"rv-mgef.mfkn_jj4x",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre de Ter\xe0pies S\xe0lvia","indicador_refugi":"080193|CENTRE_DE_TERAPIES_SALVIA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37446","longitud":"2.158557","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Ricart, 3 local 1","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766118","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-c8hf_t6iz~a2i7",":version":"rv-2tps~wqd8_deap",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Digicopy Verdaguer","indicador_refugi":"080193|DIGICOPY_VERDAGUER","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39708","longitud":"2.167953","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"C. Girona, 119","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/98132142540","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-m7w9-7vvc_tstj",":version":"rv-9ysc~5jy2.sp35",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Institut Dental Sant Jordi","indicador_refugi":"080193|INSTITUT_DENTAL_SANT_JORDI","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41479","longitud":"2.181333","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Ind\xfastria, 298-300","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400664990","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jngq-ngrp-m99h",":version":"rv-fpmj_2a28_24jw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CGG Montmany","indicador_refugi":"080193|CGG_MONTMANY","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40506","longitud":"2.159132","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Montmany, 45","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086033482","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-spk6~rzxa-zqhh",":version":"rv-fvx5_4t4i~kvmh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CGG Penitents","indicador_refugi":"080193|CGG_PENITENTS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42113","longitud":"2.140286","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Passeig Vall d\'Hebron, 76-78","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/154110817","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3iuq-ntp5~h9rc",":version":"rv-an4e-ivra_fgsb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Farm\xe0cia 24 Hores Antoni Torres","indicador_refugi":"080193|FARMACIA_24_HORES_ANTONI_TORRES","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38864","longitud":"2.159183","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"C. Aribau, 62","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990017682","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-kdpc_hpdt~zep2",":version":"rv-sha6~jvcu-mmtk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Farmacia Virrei Amat","indicador_refugi":"080193|FARMACIA_VIRREI_AMAT","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43062","longitud":"2.174537","accessibilitat":"S\xed","aigua":"No","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"C. del Doctor Pi i Molist, 1","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990049036","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-yxe6-yhda.ifu4",":version":"rv-pct9~te33~hgbj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Llanes Santa Eul\xe0lia","indicador_refugi":"080193|LLANES_SANTA_EULALIA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43065","longitud":"2.172745","accessibilitat":"No","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Pere d\'Art\xe9s, 6","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766141","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3dsr-fyvy~hprj",":version":"rv-4knh~wmex-kxad",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"V Natura","indicador_refugi":"080193|V_NATURA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43017","longitud":"2.176241","accessibilitat":"S\xed","aigua":"No","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Pg. de Fabra i Puig, 205","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766145","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-bbxa-39kg.38dx",":version":"rv-mey3.tvd8-hdm5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Moda interior dona i home Alfonsita","indicador_refugi":"080193|MODA_INTERIOR_DONA_I_HOME_ALFONSITA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43018","longitud":"2.175361","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Pg. de Fabra i Puig, 223-225","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/96082091627","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jw9q-eecw_sv2x",":version":"rv-g5nk~fa59-x26h",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"El rei del Peix","indicador_refugi":"080193|EL_REI_DEL_PEIX","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43026","longitud":"2.186018","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Rbla. de Fabra i Puig, 78","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766158","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-dgi7.um39.dbkz",":version":"rv-buxg~xvgy.vptf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Xarcuteria Gasch","indicador_refugi":"080193|XARCUTERIA_GASCH","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4302","longitud":"2.18684","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Rbla. de Fabra i Puig, 88-92","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766159","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-bpuq_7fcz_p2b6",":version":"rv-xekh-g6v5_xrpu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Farm\xe0cia Estruch","indicador_refugi":"080193|FARMACIA_ESTRUCH","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37336","longitud":"2.131451","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Rbla. de Badal, 156","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990144518","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-qibw~aar8-5ibu",":version":"rv-5jr8-haf5~4j22",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Alibri Llibreria","indicador_refugi":"080193|ALIBRI_LLIBRERIA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38792","longitud":"2.16485","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Balmes, 26","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990552606","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-5amb-tux6~5qmj",":version":"rv-iq9j_4ixk.6f52",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Manantial de salud","indicador_refugi":"080193|MANANTIAL_DE_SALUD","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38366","longitud":"2.169546","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"C. d\'en Xucl\xe0, 23","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990419327","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3wgv_jety_tvwu",":version":"rv-ytft.gux2.j3xv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Farm\xe0cia Morera","indicador_refugi":"080193|FARMACIA_MORERA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39186","longitud":"2.179096","accessibilitat":"S\xed","aigua":"No","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Pg. Sant Joan, 3","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990000684","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-nvnx_xnez_26fa",":version":"rv-m8ps.bvd4_egbr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Farm\xe0cia Borr\xe0s","indicador_refugi":"080193|FARMACIA_BORRAS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43921","longitud":"2.179991","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Pg. Valldaura, 247","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990130798","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-rryy.jicv-ngwx",":version":"rv-3vmw~8qu3-dz5z",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Seu del Districte de Les Corts","indicador_refugi":"080193|SEU_DEL_DISTRICTE_DE_LES_CORTS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3858","longitud":"2.129818","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. Comas, 18","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400762003","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-mua7~pdjz.vh6d",":version":"rv-tspi~ff2z-ggsk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pati de l\'Escola Bressol Municipal Pla de Fornells","indicador_refugi":"080193|PATI_DE_L_ESCOLA_BRESSOL_MUNICIPAL_PLA_DE_FORNELLS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.44818","longitud":"2.178725","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/ Dels Nou Barris, 12","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400762409","tipologia":"Patis d\'Escola Bressol","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wq7k-rszj-7ukh",":version":"rv-aazf~ytxf_ijnf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pati de l\'Escola Bressol Municipal El Palomar","indicador_refugi":"080193|PATI_DE_L_ESCOLA_BRESSOL_MUNICIPAL_EL_PALOMAR","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43631","longitud":"2.187186","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"S\xed","adreca":"C/de Malalts, 45","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400762448","tipologia":"Patis d\'Escola Bressol","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-5tvc-yhwq-6c7a",":version":"rv-effq_p2me.cgz9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Kinesalut Barcelona","indicador_refugi":"080193|KINESALUT_BARCELONA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43571","longitud":"2.188297","accessibilitat":"sense dades","aigua":"Sense Dades","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"sense dades","adreca":"C. Pons i Gallarza, 20","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400710085","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-r4ae~u6v9-y9bm",":version":"rv-bavd_4qnk-7wtx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Oficina Occident","indicador_refugi":"080193|OFICINA_OCCIDENT","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43422","longitud":"2.188302","accessibilitat":"sense dades","aigua":"Sense Dades","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"sense dades","adreca":"C. Rub\xe9n Dar\xedo, 27","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766161","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-qzti.s86k~ek6k",":version":"rv-947k-brgk~gdah",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Botiga \\"Equip\\" (moda)","indicador_refugi":"080193|BOTIGA_EQUIP_MODA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43398","longitud":"2.189175","accessibilitat":"sense dades","aigua":"Sense Dades","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"sense dades","adreca":"Riera de Sant Andreu, 1","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766162","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-amcn.ppjz-tch9",":version":"rv-6s6i.qvye~pitd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Kids and Us","indicador_refugi":"080193|KIDS_AND_US","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43393","longitud":"2.186393","accessibilitat":"sense dades","aigua":"Sense Dades","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"sense dades","adreca":"C. d\'Ignasi Igl\xe9sias, 85","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400442237","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jdjq~zfzq~b6qg",":version":"rv-3ywi.srk3~yqrv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Quiromassatges Pardos","indicador_refugi":"080193|QUIROMASSATGES_PARDOS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43305","longitud":"2.188528","accessibilitat":"sense dades","aigua":"Sense Dades","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"sense dades","adreca":"C. de Coroleu, 6","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766164","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-g96q_8izz_xrnb",":version":"rv-8gmt~vqze.wmxy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Several Caf\xe9","indicador_refugi":"080193|SEVERAL_CAFE","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43274","longitud":"2.189206","accessibilitat":"sense dades","aigua":"Sense Dades","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"sense dades","adreca":"C. Gran de Sant Andreu, 165","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766165","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-b52r.msdy-22gk",":version":"rv-e4ka.cg2w~25vn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Formatgeria Ireneu","indicador_refugi":"080193|FORMATGERIA_IRENEU","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4312","longitud":"2.189283","accessibilitat":"sense dades","aigua":"Sense Dades","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"sense dades","adreca":"C. Gran de Sant Andreu, 117","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766166","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-tgsc_t5ry.2et5",":version":"rv-k43j.vrtk~vjwq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Farm\xe0cia Carolina Le\xf3n","indicador_refugi":"080193|FARMACIA_CAROLINA_LEON","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43048","longitud":"2.189545","accessibilitat":"sense dades","aigua":"Sense Dades","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"sense dades","adreca":"C. Gran de Sant Andreu, 91","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086004882","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-vafr_w6gi~5tf2",":version":"rv-7tdk-hkz2~zkbh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Carns i embotits \\"Ca la Nuri\\"","indicador_refugi":"080193|CARNS_I_EMBOTITS_CA_LA_NURI","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43323","longitud":"2.185702","accessibilitat":"sense dades","aigua":"Sense Dades","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"sense dades","adreca":"Pl. de les Palemeres, 11","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766167","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-iyxh-q8dq~uujf",":version":"rv-h5w9.epqg-w2qf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Farm\xe0cia Isa Santos","indicador_refugi":"080193|FARMACIA_ISA_SANTOS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.433","longitud":"2.185778","accessibilitat":"sense dades","aigua":"Sense Dades","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"sense dades","adreca":"Pl. de les Palemeres, 9","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990114598","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ybnz-rjz7.tymt",":version":"rv-m85h_3x9p~puq6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Diambaar (moda)","indicador_refugi":"080193|DIAMBAAR_MODA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42911","longitud":"2.188032","accessibilitat":"sense dades","aigua":"Sense Dades","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"sense dades","adreca":"C. Nadal, 40","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766188","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-hecc~yxhf-5kw5",":version":"rv-qfwu.tep3_m2jq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Grup dental Santpon\xe7","indicador_refugi":"080193|GRUP_DENTAL_SANTPONC","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43188","longitud":"2.190924","accessibilitat":"sense dades","aigua":"Sense Dades","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"sense dades","adreca":"C. Dr. Santpon\xe7, 28","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766190","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-7a77~3suc_5asc",":version":"rv-bt7d_ut3m-xg9v",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Nova de Sant Andreu","indicador_refugi":"080193|NOVA_DE_SANT_ANDREU","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43178","longitud":"2.18939","accessibilitat":"sense dades","aigua":"Sense Dades","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"sense dades","adreca":"C. Gran de Sant Andreu, 142","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766191","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3srz_2u6h-xj9q",":version":"rv-tyrb.ztdj.tu2e",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Citydogs Store - Sant Andreu","indicador_refugi":"080193|CITYDOGS_STORE_SANT_ANDREU","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43561","longitud":"2.190736","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. del Doctor Balari i Jovany, 9","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766193","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3d58-wfgs_uis3",":version":"rv-dxdt-pnm4~kfap",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Restaurant La Comtal","indicador_refugi":"080193|RESTAURANT_LA_COMTAL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43583","longitud":"2.190462","accessibilitat":"sense dades","aigua":"Sense Dades","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"sense dades","adreca":"C. de l\'Ajuntament, 9","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400605576","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-e8fa_ggk5_kbi8",":version":"rv-ai8h.63zg.e6ec",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Merceria Perell\xf3","indicador_refugi":"080193|MERCERIA_PERELLO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43568","longitud":"2.189541","accessibilitat":"sense dades","aigua":"Sense Dades","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"sense dades","adreca":"C. Gran de Sant Andreu, 261","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766082","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-mnsd.wsbf-szs5",":version":"rv-t2mx_4gdz.nsc3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Abans morta que senzilla (moda)","indicador_refugi":"080193|ABANS_MORTA_QUE_SENZILLA_MODA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43571","longitud":"2.189619","accessibilitat":"sense dades","aigua":"Sense Dades","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"sense dades","adreca":"C. Gran de Sant Andreu, 259","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766080","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wrpt~put2_vz4m",":version":"rv-k3gv.rcdz-mru3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La boutique del peluquero","indicador_refugi":"080193|LA_BOUTIQUE_DEL_PELUQUERO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.435","longitud":"2.189449","accessibilitat":"sense dades","aigua":"Sense Dades","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"sense dades","adreca":"C. Gran de Sant Andreu, 239","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766074","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-iegv_cz38-y2zs",":version":"rv-vexi.f6kk~6iwx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La botiga de la Pepi","indicador_refugi":"080193|LA_BOTIGA_DE_LA_PEPI","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43496","longitud":"2.189233","accessibilitat":"sense dades","aigua":"Sense Dades","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"sense dades","adreca":"C. Mercat, 4","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766068","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3kd6.cdce.gce5",":version":"rv-u3dx_ecg2-cb5i",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Col\xb7legi Oficial d\'Infermeres i Infermers de Barcelona","indicador_refugi":"080193|COL_LEGI_OFICIAL_D_INFERMERES_I_INFERMERS_DE_BARCELONA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40707","longitud":"2.208131","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. de Pujades, 350","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086001164","tipologia":"Altres","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ee3a-ysuc_pt7u",":version":"rv-dhi8-6jyz.9xhr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"VRoom Escape","indicador_refugi":"080193|VROOM_ESCAPE","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42593","longitud":"2.190034","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Pac\xedfic 19, Baixos, Local 1","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766064","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-pqf6_ucrt-3j63",":version":"rv-e5na_9rm6~szgv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Llibrer\xeda Ulises","indicador_refugi":"080193|LLIBRERIA_ULISES","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4261","longitud":"2.188956","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Pac\xedfic, 34","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400766063","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3axj.sfhk~6wr7",":version":"rv-m24q.t26p~sdm9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Farm\xe0cia Carlota Miravitlles Gultresa","indicador_refugi":"080193|FARMACIA_CARLOTA_MIRAVITLLES_GULTRESA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41517","longitud":"2.198466","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. de Juli\xe1n Besteiro, 3","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990291699","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-pcq8-45nk.7v9w",":version":"rv-8e2g.hzub~zafg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Farm\xe0cia David Folch","indicador_refugi":"080193|FARMACIA_DAVID_FOLCH","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4325567","longitud":"2.1555175","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. F\xe0tima 10, baixos","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990054149","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-8kqi~6yqz_zts7",":version":"rv-mkuw~cehm~im3p",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Farm\xe0cia De La Rambla","indicador_refugi":"080193|FARMACIA_DE_LA_RAMBLA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42462","longitud":"2.208469","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Rambla Guip\xfascoa, 174","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400748805","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-9r54.78q3~5dy8",":version":"rv-y5de~apnt.pj7y",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Farm\xe0cia Marcos Molina","indicador_refugi":"080193|FARMACIA_MARCOS_MOLINA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43635","longitud":"2.205577","accessibilitat":"S\xed","aigua":"No","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"C. de Sant Adri\xe0, 131","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990225326","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wxnq~cjpj.3spb",":version":"rv-z48c_qtpm~prbs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Soledad P\xe9rez Fisioterapia","indicador_refugi":"080193|SOLEDAD_PEREZ_FISIOTERAPIA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.427102849691","longitud":"2.15708993956947","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Rambla del Carmel, 6","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400145611","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-5c68~a4n6-5zfx",":version":"rv-tjhr~ju6a~vckr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Hospital Universitari Sagrat Cor","indicador_refugi":"080193|HOSPITAL_UNIVERSITARI_SAGRAT_COR","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38896","longitud":"2.145559","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Viladomat 288","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086002636","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-xk2a~y62f-kvcy",":version":"rv-wtfx~5xie~aaa5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Collell (moda)","indicador_refugi":"080193|COLLELL_MODA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42956","longitud":"2.160326","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Tajo, 69","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400781055","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-zjmx~fgam_34wu",":version":"rv-8r3y_f7rc_7wbj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Cor d\'Horta Eix Comercial","indicador_refugi":"080193|COR_D_HORTA_EIX_COMERCIAL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42957","longitud":"2.160193","accessibilitat":"No","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"C/ Tajo, 71 (botiga 2); Enviaments a Tajo 69 (botiga de la presidenta de Cor d\'Horta)","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400477124","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-cthm.6ei6~zy3r",":version":"rv-e8ep.8u5w-64rq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Abacus Fabra I Puig","indicador_refugi":"080193|ABACUS_FABRA_I_PUIG","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43039","longitud":"2.18102","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Passeig Fabra i Puig, 196","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400400153","tipologia":"Centres comercials","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-akye.psv3~pnsd",":version":"rv-uu3f~nkst_tga2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jard\xed de les Tres Torres","indicador_refugi":"080193|JARDI_DE_LES_TRES_TORRES","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39874726","longitud":"2.13415046","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"Rda. General Mitre, 76","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780996","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-5n82.mpfi-m5np",":version":"rv-btpx-mu6p-3w2f",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Descoberta del CEM Parc de la Ciutadella","indicador_refugi":"080193|PISCINA_DESCOBERTA_DEL_CEM_PARC_DE_LA_CIUTADELLA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38553","longitud":"2.186413","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pg. de Circumval\xb7laci\xf3, 1","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400293637","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-va5h.nx9v_9vkg",":version":"rv-ttd7~da66.d96x",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Coberta del CEM Mundet","indicador_refugi":"080193|PISCINA_COBERTA_DEL_CEM_MUNDET","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43591","longitud":"2.142863","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Olympe de Gouges, s/n","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/93179131212","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-dcg6_9inz~nn2j",":version":"rv-y6q6-69wx.pfz9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines Cobertes del CEM Bac de Roda","indicador_refugi":"080193|PISCINES_COBERTES_DEL_CEM_BAC_DE_RODA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41435","longitud":"2.194073","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Rbla. Guip\xfascoa, 25","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400038777","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-2c7y.748f_ys8t",":version":"rv-g79e~79ve-mrk4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Coberta del CEM Bon Pastor","indicador_refugi":"080193|PISCINA_COBERTA_DEL_CEM_BON_PASTOR","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43818","longitud":"2.201731","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Costa Daurada, 12","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400322487","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-59ft-xwgv-4rhm",":version":"rv-8vsv~dfg5.yauc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Coberta del CEM Can Caralleu","indicador_refugi":"080193|PISCINA_COBERTA_DEL_CEM_CAN_CARALLEU","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40156","longitud":"2.111093","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. dels Esports, 2-8","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400228653","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-m9g8~em44-ehbc",":version":"rv-6rz3-7u82_esiy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines Descobertes del CEM Piscines Bernat Picornell","indicador_refugi":"080193|PISCINES_DESCOBERTES_DEL_CEM_PISCINES_BERNAT_PICORNELL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.36629","longitud":"2.150628","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"S\xed","adreca":"Av. de l\'Estadi, 30-38","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94125142139","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-pu9b_cny3-z8e8",":version":"rv-kyes~buv2_8e7c",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Llac del CEM Can Drag\xf3","indicador_refugi":"080193|LLAC_DEL_CEM_CAN_DRAGO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43657","longitud":"2.183127","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Rosell\xf3 i Porcel, 7-11","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94147122530","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-74rt_6qea~j5rf",":version":"rv-6e7a.b5bb~6r9u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Coberta del CEM de Sant Sebasti\xe0","indicador_refugi":"080193|PISCINA_COBERTA_DEL_CEM_DE_SANT_SEBASTIA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37358","longitud":"2.188742","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. del Mar, s/n","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/97302140150","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-4h6g_5bzj_82b9",":version":"rv-n8va~29hk~qtm4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Descoberta del CEM Trinitat Vella","indicador_refugi":"080193|PISCINA_DESCOBERTA_DEL_CEM_TRINITAT_VELLA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.45145","longitud":"2.193105","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"S\xed","adreca":"Via B\xe0rcino, 84-86","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086010811","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-m9vi.ufcf.b4xd",":version":"rv-iu27_sgkf~hmbb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines Cobertes del CEM Guinard\xf3","indicador_refugi":"080193|PISCINES_COBERTES_DEL_CEM_GUINARDO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41702","longitud":"2.173619","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Tel\xe8graf, 31-45","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400322475","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-nudr~3z9k~kvfy",":version":"rv-2b7a-j9y2-gnc3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines Cobertes del CEM Can Toda","indicador_refugi":"080193|PISCINES_COBERTES_DEL_CEM_CAN_TODA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41535","longitud":"2.158164","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Ramiro de Maeztu, 25","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086003371","tipologia":"Piscines","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-pkpx.3azi.vgwz",":version":"rv-u4n9_5pix-t9m6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jocs d\'aigua de Joan Ravent\xf3s","indicador_refugi":"080193|JOCS_D_AIGUA_DE_JOAN_RAVENTOS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4035872","longitud":"2.1169262","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"No","adreca":"Carrer Major de Sarri\xe0 242","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780974","tipologia":"Jocs d\'aigua","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-k8xs~csq8~uvyr",":version":"rv-hwwn~wx65.zgif",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jocs d\'aigua de Carme Sim\xf3","indicador_refugi":"080193|JOCS_D_AIGUA_DE_CARME_SIMO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3829675","longitud":"2.1794427","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"No","adreca":"Carrer del Sots-Tinent Navarro, 12","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780973","tipologia":"Jocs d\'aigua","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-72js.fx65~6dwb",":version":"rv-z8t4~zvrd~ee3a",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jocs d\'aigua del Parc de Santiburcio","indicador_refugi":"080193|JOCS_D_AIGUA_DEL_PARC_DE_SANTIBURCIO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4435387","longitud":"2.1882884","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"No","adreca":"Carrer Gran de Sant Andreu, 505","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780972","tipologia":"Jocs d\'aigua","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-8h5e.8pzb_mcjp",":version":"rv-qs5h.zbws_an6b",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jocs d\'aigua de Lolita Torrent\xf3","indicador_refugi":"080193|JOCS_D_AIGUA_DE_LOLITA_TORRENTO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4131371","longitud":"2.186578","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"No","adreca":"Av Meridiana 181","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780969","tipologia":"Jocs d\'aigua","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wi4u~zvpu~jdnk",":version":"rv-48sg.jxhu~3q4z",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jocs d\'aigua d\'Avinguda Mistral","indicador_refugi":"080193|JOCS_D_AIGUA_D_AVINGUDA_MISTRAL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3769365","longitud":"2.1577779","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"No","adreca":"Av. de Mistral, 41-43","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780968","tipologia":"Jocs d\'aigua","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ciqq.x4ik_yvy9",":version":"rv-97p7~db37_knt9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jocs d\'aigua de Joan Pelegr\xed","indicador_refugi":"080193|JOCS_D_AIGUA_DE_JOAN_PELEGRI","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3757959","longitud":"2.1423853","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"No","adreca":"Carrer de Miquel Bleach 24","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780967","tipologia":"Jocs d\'aigua","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-cmzh-pcie_6q2q",":version":"rv-khbs-7s8d.ppfp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jocs d\'aigua del Baix Guinard\xf3","indicador_refugi":"080193|JOCS_D_AIGUA_DEL_BAIX_GUINARDO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4047673","longitud":"2.1632812","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"No","adreca":"Travessera de Gr\xe0cia 381","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780965","tipologia":"Jocs d\'aigua","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-mih2~juw6~csix",":version":"rv-yvbw.fpbm_89u4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jocs d\'aigua de Justa Freire","indicador_refugi":"080193|JOCS_D_AIGUA_DE_JUSTA_FREIRE","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3536649","longitud":"2.1384097","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"No","adreca":"C. de Miquel Porter i Moix 22","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780962","tipologia":"Jocs d\'aigua","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-rrd4.x5pr_yqeg",":version":"rv-szyu-4j2z~xr7t",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat de la Barceloneta","indicador_refugi":"080193|MERCAT_DE_LA_BARCELONETA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3799145","longitud":"2.1893886","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Poeta Bosc\xe0, 1-2","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009445","tipologia":"Mercats","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-p6qs~8iuw_xb8d",":version":"rv-cq89-7ncz~7sak",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat de Sant Gervasi","indicador_refugi":"080193|MERCAT_DE_SANT_GERVASI","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4056154","longitud":"2.138591","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a Joaquim Folguera, 6","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086009462","tipologia":"Mercats","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-mjhv.wytx~hyka",":version":"rv-af8p-dh8x_y2br",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bosc de l\'Aula Ambiental del Bosc Turull","indicador_refugi":"080193|BOSC_DE_L_AULA_AMBIENTAL_DEL_BOSC_TURULL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4132662","longitud":"2.1470935","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"Passeig de Turull, 2","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400397214","tipologia":"Parcs i Jardins","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-uhc8_skt8.ivwg",":version":"rv-tux5.d4am-cwxn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La Masia de la Guineueta","indicador_refugi":"080193|LA_MASIA_DE_LA_GUINEUETA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43753136","longitud":"2.16930497","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a de Ca n\'Ensenya, s/n","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400065443","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-tfu7~4gt5-et7b",":version":"rv-vvmm_4654~whh9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Gent Gran de Roquetes","indicador_refugi":"080193|CASAL_DE_GENT_GRAN_DE_ROQUETES","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4460721","longitud":"2.1744819","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a dels Titellaires, 1","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94052175818","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-atsb_qqtk~knc6",":version":"rv-vatv.pa6s.kvmi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Gent Gran Casa Nostra","indicador_refugi":"080193|CASAL_DE_GENT_GRAN_CASA_NOSTRA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43275252","longitud":"2.17614027","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de la Maladeta, 38","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086011148","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-yaec_f23p~s3ek",":version":"rv-nssg-xz4v.ajgg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Gent Gran Vilapicina i la Torre Llobeta","indicador_refugi":"080193|CASAL_DE_GENT_GRAN_VILAPICINA_I_LA_TORRE_LLOBETA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42691","longitud":"2.1764078","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a de Carmen Laforet, 11","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400287230","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-h7nm-4jiy_gdv8",":version":"rv-f4bw-jq8w.ugew",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai comunitari Torre J\xfalia","indicador_refugi":"080193|ESPAI_COMUNITARI_TORRE_JULIA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4458602","longitud":"2.1808932","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Via Fav\xe8ncia, 348-350","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780950","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-5m7u-vev4~r23f",":version":"rv-vdch_2v95.ri49",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Can\xf2drom - Ateneu d\'Innovaci\xf3 Digital i Democr\xe0tica","indicador_refugi":"080193|CANODROM_ATENEU_D_INNOVACIO_DIGITAL_I_DEMOCRATICA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4274947","longitud":"2.183322","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Concepci\xf3n Arenal 165","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400407793","tipologia":"Altres","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-88ky-9rcp_tpab",":version":"rv-jw8t_kwp3.k937",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre de Vida Comunit\xe0ria de Trinitat Vella","indicador_refugi":"080193|CENTRE_DE_VIDA_COMUNITARIA_DE_TRINITAT_VELLA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4507231","longitud":"2.1891833","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carretera de Ribes, 59","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400691864","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-82yb_mzi3_vctu",":version":"rv-zfez~fcmr_t2ym",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Barri Espai Antoni Mir\xf3 Peris","indicador_refugi":"080193|CASAL_DE_BARRI_ESPAI_ANTONI_MIRO_PERIS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41285176","longitud":"2.18452812","accessibilitat":"si","aigua":"S\xed","climatitzacio":"si","area_descans":"S\xed","lavabo":"SI","adreca":"Pla\xe7a de Carme Montoriol, 10","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400201447","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-pzp9_27ex_3tjz",":version":"rv-hyga-vzs5_rqxz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Barri Bes\xf2s","indicador_refugi":"080193|CASAL_DE_BARRI_BESOS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4171152311895","longitud":"2.21468165460701","accessibilitat":"si","aigua":"S\xed","climatitzacio":"si","area_descans":"S\xed","lavabo":"si","adreca":"c. Crist\xf3bal de Moura, 232","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400023006","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-mpbf-y5p3_d8xz",":version":"rv-j8xr-5mqd-aysx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Seu del Districte de Sant Mart\xed","indicador_refugi":"080193|SEU_DEL_DISTRICTE_DE_SANT_MARTI","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4086531","longitud":"2.1923116","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pl. Valent\xed Almirall, 1","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780928","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-xzr7~8vpi.54cd",":version":"rv-u3m2-cdei~5bek",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai Ve\xefnal Olzinelles","indicador_refugi":"080193|ESPAI_VEINAL_OLZINELLES","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3728383","longitud":"2.1365287","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Olzinelles, 30","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400765478","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-5yzm_5tfz.2if6",":version":"rv-i2g5-zdnm_yqk7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai Jove la B\xe0scula","indicador_refugi":"080193|ESPAI_JOVE_LA_BASCULA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3584786","longitud":"2.1442062","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Foc, 128","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086026021","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-uvxa.mkqh~3jz6",":version":"rv-75nt-6vrs_b5sp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai Jove Casa Sagnier","indicador_refugi":"080193|ESPAI_JOVE_CASA_SAGNIER","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4018751","longitud":"2.1445129","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"si","adreca":"C. Brusi, 61","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400191463","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-dptv~7wcx~wess",":version":"rv-ucts~8yvc~bmkw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai de Gent Gran Germanetes","indicador_refugi":"080193|ESPAI_DE_GENT_GRAN_GERMANETES","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3819303","longitud":"2.1547109","accessibilitat":"si","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Viladomat, 142","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400753482","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-xxmq~bq3t_s7fd",":version":"rv-uajf_gbu4.zava",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai Jove Ca la Panarra","indicador_refugi":"080193|ESPAI_JOVE_CA_LA_PANARRA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3850453","longitud":"2.1285745","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Dolors Masferrer, 29","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400010469","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-hgkx_s847~5488",":version":"rv-svkn_dtte.a6qj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Abacus Urquinaona","indicador_refugi":"080193|ABACUS_URQUINAONA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39073","longitud":"2.175013","accessibilitat":"S\xed","aigua":"No","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer d\'Ausi\xe0s Marc, 16","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990020440","tipologia":"Centres comercials","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-zaz4~8h3k.wdid",":version":"rv-pqgm-kkjd-iayi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai Abacus Enric Granados","indicador_refugi":"080193|ESPAI_ABACUS_ENRIC_GRANADOS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39385","longitud":"2.154607","accessibilitat":"S\xed","aigua":"No","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer d\'Enric Granados, 112","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400722915","tipologia":"Centres comercials","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-gz28~x5k2-pnhu",":version":"rv-d7v4_7ytq_4mu5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Abacus Illa Diagonal","indicador_refugi":"080193|ABACUS_ILLA_DIAGONAL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38974","longitud":"2.13523","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda Diagonal, 545-557","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400234862","tipologia":"Centres comercials","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-xphg_qbcs.rzi3",":version":"rv-nzmj.9asf.a75t",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Esgl\xe9sia Evang\xe8lica Unida De Barcelona","indicador_refugi":"080193|ESGLESIA_EVANGELICA_UNIDA_DE_BARCELONA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43196","longitud":"2.1791","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Santapau, 102","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780883","tipologia":"Centres de culte","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-qes2~6ts5_2jjb",":version":"rv-bv7k.bcpb_359y",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pati de l\'escola Drassanes","indicador_refugi":"080193|PATI_DE_L_ESCOLA_DRASSANES","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37908","longitud":"2.177236","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Nou de Sant Francesc, 11 (entrada pel C. d\u2019en Rull)","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780872","tipologia":"Patis d\'Escola","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-r5yj_mi7z-6m8i",":version":"rv-vb2g~cwwn~ufry",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pati de l\'escola Antoni Brusi","indicador_refugi":"080193|PATI_DE_L_ESCOLA_ANTONI_BRUSI","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3912306177642","longitud":"2.18969489693352","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Sardenya, 27","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780869","tipologia":"Patis d\'Escola","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ydhq_mn75_e27b",":version":"rv-6x5f~q6pm-fx4r",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pati de l\'escola Baldiri Reixac","indicador_refugi":"080193|PATI_DE_L_ESCOLA_BALDIRI_REIXAC","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4138954697183","longitud":"2.15304342391782","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Olot, 1-13 (Recinte Parc G\xfcell)","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780866","tipologia":"Patis d\'Escola","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-6p7w-s5ke-qcgb",":version":"rv-2x47_eckq~ysta",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pati de l\'escola Torrent de Can Carabassa","indicador_refugi":"080193|PATI_DE_L_ESCOLA_TORRENT_DE_CAN_CARABASSA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42681","longitud":"2.161066","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. Llobreg\xf3s, 17-23 (entrada per la porta de la rampa)","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780864","tipologia":"Patis d\'Escola","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-d85k-swqq~pr5b",":version":"rv-6d33-m5wk.2icv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pati de l\'institut Escola Tramuntana","indicador_refugi":"080193|PATI_DE_L_INSTITUT_ESCOLA_TRAMUNTANA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43871","longitud":"2.189824","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"No","adreca":"C. de Guardiola i Feliu, 7-9 (entrada pel C. Lanzarote)","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400758413","tipologia":"Patis d\'Escola","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-5kta_n8bz.dkqw",":version":"rv-ju7b-h8pn.hh3i",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ca l\'Alier - Centre d\u2019Innovaci\xf3 Urbana","indicador_refugi":"080193|CA_L_ALIER_CENTRE_D_INNOVACIO_URBANA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40986","longitud":"2.203492","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C Pere IV, 362","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400605048","tipologia":"Altres","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-bcgp.vbx5~8be8",":version":"rv-q94w_y9fi~ij65",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Oficina de atenci\xf3n al p\xfablico de Endesa","indicador_refugi":"080193|OFICINA_DE_ATENCION_AL_PUBLICO_DE_ENDESA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38729","longitud":"2.1659397","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Gran Via de les Corts Catalanes  608","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/98184131023","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-hw24-bnmx~qyg5",":version":"rv-bwn6-38eq_qb3n",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Gremi de reformes d\'interiors","indicador_refugi":"080193|GREMI_DE_REFORMES_D_INTERIORS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4389749","longitud":"2.1908598","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Passeig de Torras i Bages 55","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400469849","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-9ccy_q6gk-t4ry",":version":"rv-nf2u~jb5u_yefz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Oficina de Bonavista Apartments","indicador_refugi":"080193|OFICINA_DE_BONAVISTA_APARTMENTS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3977983","longitud":"2.1590463","accessibilitat":"Altres","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Bonavista, 4","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400780855","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-9si3~2s5n.32uc",":version":"rv-u33w~y3vg.5cxp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bloc4BCN - Espai Cooperatiu","indicador_refugi":"080193|BLOC4BCN_ESPAI_COOPERATIU","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3696150521122","longitud":"2.13746324733179","accessibilitat":"Altres","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de la Constituci\xf3, 19","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400708893","tipologia":"Altres","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-qsir-gnwa~xm73",":version":"rv-675h-48ma-m2xj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Esgl\xe9sia Evang\xe8lica Baptista de Gr\xe0cia (EEBG)","indicador_refugi":"080193|ESGLESIA_EVANGELICA_BAPTISTA_DE_GRACIA_EEBG","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40952","longitud":"2.151394","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Verdi 191","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400781746","tipologia":"Centres de culte","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-gr6z_n5y4~zvah",":version":"rv-8mpd~p6ux~g3kn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Fnac Rambles","indicador_refugi":"080193|FNAC_RAMBLES","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37327","longitud":"2.168369","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"La Rambla de Canaletes, 131","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/98314113344","tipologia":"Centres comercials","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-e7kh_yq5b-2636",":version":"rv-p2m4.ihin~kdmj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Associaci\xf3 Catalana de Recursos Assistencials (ACRA)","indicador_refugi":"080193|ASSOCIACIO_CATALANA_DE_RECURSOS_ASSISTENCIALS_ACRA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37911","longitud":"2.155798","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Cal\xe0bria, 236 -240 (local)","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/92086038572","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-spsw.ttk3_gcxc",":version":"rv-z9vp.gd5w_fxn5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Farm\xe0cia Dr. Jes\xfas Paterna","indicador_refugi":"080193|FARMACIA_DR_JESUS_PATERNA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41899","longitud":"2.210454","accessibilitat":"S\xed","aigua":"No","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Bernat Metge, 6-8 (local6)","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/98357092109","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-a99g.g5ju.jxaj",":version":"rv-ush3-mqff_3udy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Farm\xe0cia Am\xedlcar","indicador_refugi":"080193|FARMACIA_AMILCAR","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42991","longitud":"2.172032","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer d\'Am\xedlcar 7","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/75990014864","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-z9w4_dhqz.cs55",":version":"rv-8p5w-xstb.kb38",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jocs d\'aigua de la Pla\xe7a de Harry Walker","indicador_refugi":"080193|JOCS_D_AIGUA_DE_LA_PLACA_DE_HARRY_WALKER","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4397626279174","longitud":"2.18150331438045","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No (aire lliure)","area_descans":"S\xed","lavabo":"No","adreca":"Pla\xe7a de Harry Walker","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/99400781745","tipologia":"Jocs d\'aigua","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-cpg6~rc6x_auqc",":version":"rv-ky4g~y4p3.s8pt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"INTERIOR:  Hall CCCB (mes d\'agost)","indicador_refugi":"080193|INTERIOR_HALL_CCCB_MES_D_AGOST","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3837","longitud":"2.166633","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. de Montalegre, 5","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94042144909","tipologia":"Museus","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ae8m_6wqq-vf59",":version":"rv-kffj_fze7~csy7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"INTERIOR: Vest\xedbul CCCB planta -1 (16 juny-13 setembre)","indicador_refugi":"080193|INTERIOR_VESTIBUL_CCCB_PLANTA_1_16_JUNY_13_SETEMBRE","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3837","longitud":"2.166633","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. de Montalegre, 5","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94042144909","tipologia":"Museus","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-cmkt-bney-7tue",":version":"rv-p93y-t9qk.iz9a",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"INTERIOR: Espai familiar CCCB planta 0 (16 juny-6 setembre, tardes)","indicador_refugi":"080193|INTERIOR_ESPAI_FAMILIAR_CCCB_PLANTA_0_16_JUNY_6_SETEMBRE_TARDES","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3837","longitud":"2.166633","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. de Montalegre, 5","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94042144909","tipologia":"Museus","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ynqh~aip8_iuqq",":version":"rv-aa4q.bce6_5zap",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"EXTERIOR: Pati de les Dones CCCB (obert cada dia)","indicador_refugi":"080193|EXTERIOR_PATI_DE_LES_DONES_CCCB_OBERT_CADA_DIA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3837","longitud":"2.166633","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"No","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. de Montalegre, 5","informacio_web":"https://www.barcelona.cat/barcelona-pel-clima/ca/projectes-i-accions/accions-concretes/xarxa-de-refugis-climatics/llistat-refugis/94042144909","tipologia":"Museus","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jhgk_4v3c-qas6",":version":"rv-fip9-jd6m.ncka",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"EAP Dreta Eixample","indicador_refugi":"080193|EAP_DRETA_EIXAMPLE","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39887","longitud":"2.172714","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Roger de Flor, 194","informacio_web":"NA","tipologia":"_Microrefugis","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jb9t.urky_w2b3",":version":"rv-e39i~fax9-vrqh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Facultat Blanquerna - cafeteria","indicador_refugi":"080193|FACULTAT_BLANQUERNA_CAFETERIA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41141","longitud":"2.132668","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer del C\xedster, 34","informacio_web":"NA","tipologia":"Universitats","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-nygx_cmdf-at2x",":version":"rv-9wms_z5is-g9sv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Reclau Projecte i Obra SL","indicador_refugi":"080193|RECLAU_PROJECTE_I_OBRA_SL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37213","longitud":"2.126748","accessibilitat":"S\xed","aigua":"No","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Riera Blanca, 105","informacio_web":"NA","tipologia":"Altres","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wbwm_hj86.8vsu",":version":"rv-99me.xxwi-4rwa",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Comercial L\'illa Diagonal","indicador_refugi":"080193|CENTRE_COMERCIAL_L_ILLA_DIAGONAL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38952","longitud":"2.134703","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda Diagonal 545","informacio_web":"NA","tipologia":"Centres comercials","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-vvfr_d3gr_kd2h",":version":"rv-4pa9~sg9j_gtn5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"The Book Bar","indicador_refugi":"080193|THE_BOOK_BAR","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43869","longitud":"2.188913","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Gran de Sant Andreu 368","informacio_web":"NA","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-c5j3_8rs9_2dhg",":version":"rv-femx~at5k.5vdg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Botiga Consum Avinguda De Madrid 46","indicador_refugi":"080193|BOTIGA_CONSUM_AVINGUDA_DE_MADRID_46","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37712","longitud":"2.125477","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda de Madrid, 46","informacio_web":"NA","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-m3fy~33ap-ki34",":version":"rv-dnp8~vadt_7ifm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Botiga Consum Avinguda De Roma","indicador_refugi":"080193|BOTIGA_CONSUM_AVINGUDA_DE_ROMA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38146","longitud":"2.146779","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda de Roma, 32","informacio_web":"NA","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-4h2n.jpny-j76p",":version":"rv-cpkp~uw3m_6qca",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Botiga Consum Llu\xe7\xe0","indicador_refugi":"080193|BOTIGA_CONSUM_LLUCA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38217","longitud":"2.130911","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Llu\xe7\xe0, 19","informacio_web":"NA","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-82s4-7de3_db33",":version":"rv-cubt.s4ek.ynf5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Botiga Consum Sants","indicador_refugi":"080193|BOTIGA_CONSUM_SANTS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37539","longitud":"2.135879","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Sants, 208","informacio_web":"NA","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wzqa_zcvv~2uhc",":version":"rv-tmv7-mmnm_ay6p",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Botiga Consum Rosell\xf3 346","indicador_refugi":"080193|BOTIGA_CONSUM_ROSELLO_346","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39086","longitud":"2.154038","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer del Rossell\xf3, 344","informacio_web":"NA","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-2i6a~7zwa~hrrc",":version":"rv-q8re.zqef_incu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Botiga Consum Meridiana","indicador_refugi":"080193|BOTIGA_CONSUM_MERIDIANA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42226","longitud":"2.186832","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda Meridiana, 260","informacio_web":"NA","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ax4j~9ip2.t3za",":version":"rv-gn4z_htq7.j79w",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Botiga Consum D\'enten\xe7a","indicador_refugi":"080193|BOTIGA_CONSUM_D_ENTENCA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37676","longitud":"2.154562","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer d\'Enten\xe7a, 28","informacio_web":"NA","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-vnmf.vv8v_6fhx",":version":"rv-a9uf.4kye_4ndu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Botiga Consum Compte Borrell","indicador_refugi":"080193|BOTIGA_CONSUM_COMPTE_BORRELL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38692","longitud":"2.149971","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer del Comte Borrell, 13","informacio_web":"NA","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-m22g-u2zh~qiux",":version":"rv-y59n~zc96~nhgt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Botiga Consum Rep\xfablica Argentina","indicador_refugi":"080193|BOTIGA_CONSUM_REPUBLICA_ARGENTINA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.41326","longitud":"2.1387","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda de la Rep\xfablica Argentina, 269","informacio_web":"NA","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-egjh_d6cu-6hry",":version":"rv-ig7n-2krx~85ze",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Botiga Consum Avinguda De Madrid 160","indicador_refugi":"080193|BOTIGA_CONSUM_AVINGUDA_DE_MADRID_160","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38027","longitud":"2.131317","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda de Madrid, 160","informacio_web":"NA","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-h9zx_7rkr~zaun",":version":"rv-ubyn~x59r~aw7d",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Botiga Consum Comte D\'urgell","indicador_refugi":"080193|BOTIGA_CONSUM_COMTE_D_URGELL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38348","longitud":"2.156527","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer del Comte d\'Urgell, 87","informacio_web":"NA","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-u4ep.4g4i.dn6z",":version":"rv-ny2p~nisf.gupu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Botiga Consum Balmes","indicador_refugi":"080193|BOTIGA_CONSUM_BALMES","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40245","longitud":"2.145526","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Balmes, 306","informacio_web":"NA","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-f84c.966m_mkxq",":version":"rv-7jxr-8w6i~4hx3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Botiga Consum Alc\xfadia","indicador_refugi":"080193|BOTIGA_CONSUM_ALCUDIA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43629","longitud":"2.17463","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Alc\xfadia, 47","informacio_web":"NA","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jc3b_7mh8_wh5z",":version":"rv-mih2-cz7d_y7qe",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Botiga Consum Avinguda Ic\xe0ria","indicador_refugi":"080193|BOTIGA_CONSUM_AVINGUDA_ICARIA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.39041","longitud":"2.196072","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda Ic\xe0ria, 164","informacio_web":"NA","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-hh3r~yhwg~rgbh",":version":"rv-wanm~zwnc.kdkp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Botiga Consum Berruguete","indicador_refugi":"080193|BOTIGA_CONSUM_BERRUGUETE","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4340777469097","longitud":"2.14847422886811","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Berruguete, 106","informacio_web":"NA","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-x6ih~3keg_t9hm",":version":"rv-ttmv~pp5b-zrjj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Botiga Consum Villarroel","indicador_refugi":"080193|BOTIGA_CONSUM_VILLARROEL","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.38079","longitud":"2.162216","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Villarroel, 15","informacio_web":"NA","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-bsaf-5kd4~h9tf",":version":"rv-kg52_3qpc-mq3z",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Botiga Consum Fabra I Puig","indicador_refugi":"080193|BOTIGA_CONSUM_FABRA_I_PUIG","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4302","longitud":"2.18684","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Rambla de Fabra i Puig, 55","informacio_web":"NA","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-drem.adhj_vnbh",":version":"rv-kfpq~dzh4_2m2d",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Botiga Consum Gran De Sant Andreu","indicador_refugi":"080193|BOTIGA_CONSUM_GRAN_DE_SANT_ANDREU","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.43824","longitud":"2.189","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Gran de Sant Andreu, 356","informacio_web":"NA","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wyz4_rh6d.tzwu",":version":"rv-idas-biu8-zs5j",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Botiga Consum Berenguer De Palou","indicador_refugi":"080193|BOTIGA_CONSUM_BERENGUER_DE_PALOU","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.42279","longitud":"2.191999","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Berenguer de Palou, 52","informacio_web":"NA","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-hqjf.8xns.6n87",":version":"rv-txgq_yn6e_chpf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Nivell Estudi De Cuines","indicador_refugi":"080193|NIVELL_ESTUDI_DE_CUINES","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.40552","longitud":"2.164701","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Travessera de Gr\xe0cia 254","informacio_web":"NA","tipologia":"_microRefugi","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3f7u-dysz_zkbz",":version":"rv-raf7-7sc5-a8qg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CSS Maternitat Sant Ramon i Pedralbes","indicador_refugi":"080193|CSS_MATERNITAT_SANT_RAMON_I_PEDRALBES","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3799831380478","longitud":"2.12602712962141","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Travessera de les Corts, 122 baixos","informacio_web":"NA","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ij6g.9pgp-b7qi",":version":"rv-kjim~h747-ddjx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai 3 Ulls","indicador_refugi":"080193|ESPAI_3_ULLS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4490810616817","longitud":"2.18459437805967","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de la Pedrosa, 16","informacio_web":"NA","tipologia":"Equipaments de proximitat","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-nxi8.g748.dhv4",":version":"rv-v27m~d6ur_z53x",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Filmoteca de Catalunya","indicador_refugi":"080193|FILMOTECA_DE_CATALUNYA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3788782537339","longitud":"2.17067349137114","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Pla\xe7a de Salvador Segu\xed, 1-9","informacio_web":"NA","tipologia":"Entitats culturals","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-n6qa-z4k5-gctc",":version":"rv-mnsi~vkgd~umpc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Escola de m\xfasica Sant Gervasi","indicador_refugi":"080193|ESCOLA_DE_MUSICA_SANT_GERVASI","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4086450783298","longitud":"2.13530007741581","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Folgueroles, 10","informacio_web":"NA","tipologia":"_Microrefugis","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-e63i~v7qd.brc7",":version":"rv-cpqe~84uz~t29p",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Farm\xe0cia Marta Ib\xe1\xf1ez Gimeno","indicador_refugi":"080193|FARMACIA_MARTA_IBANEZ_GIMENO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.399318741449","longitud":"2.17137105011407","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Avinguda Diagonal, 319","informacio_web":"NA","tipologia":"_Microrefugis","origen_identificador":"Ajuntament de Barcelona","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ih57_qrwb-bbtb",":version":"rv-xenj-bhbq.33hx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Vista Alegre","indicador_refugi":"80569|CENTRE_CIVIC_VISTA_ALEGRE","municipi":"Castelldefels","codi_municipi":"80569","latitud":"41.28935201","longitud":"1.981171685","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Mansi\xf3, 31","informacio_web":"https://www.castelldefels.org/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-67g9.bmv7-thrg",":version":"rv-f5ei~j2jr.wnwn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai del Mar","indicador_refugi":"80569|ESPAI_DEL_MAR","municipi":"Castelldefels","codi_municipi":"80569","latitud":"41.26526642","longitud":"1.96427668","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Pg. Mar\xedtim, 271-275","informacio_web":"https://www.castelldefels.org/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-8snt_sdcr-pq3d",":version":"rv-x7xt_h6rc_dzbz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Edifici de la Rep\xfablica","indicador_refugi":"80569|EDIFICI_DE_LA_REPUBLICA","municipi":"Castelldefels","codi_municipi":"80569","latitud":"41.28022385","longitud":"1.976226797","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Arcadi Balaguer, 27-29","informacio_web":"https://www.castelldefels.org/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-f3gr.6t4c.j6wd",":version":"rv-th98.28rj.f36b",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Ramon Fern\xe1ndez Jurado","indicador_refugi":"80569|BIBLIOTECA_RAMON_FERNANDEZ_JURADO","municipi":"Castelldefels","codi_municipi":"80569","latitud":"41.28286651","longitud":"1.978031623","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Bisbe Urquinaona, 19-21","informacio_web":"https://www.castelldefels.org/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-xxgj_uv67_zyk7",":version":"rv-b82q_merz.rcus",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Frederic Mompou","indicador_refugi":"80569|CENTRE_CIVIC_FREDERIC_MOMPOU","municipi":"Castelldefels","codi_municipi":"80569","latitud":"41.28515768","longitud":"1.979819379","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Pl. Joan XXIII, 10","informacio_web":"https://www.castelldefels.org/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-z2wy.cjmh~mm9n",":version":"rv-g5bu~rr6t_xfrv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Central de Cornell\xe0 (BCC)","indicador_refugi":"80734|BIBLIOTECA_CENTRAL_DE_CORNELLA_BCC","municipi":"Cornell\xe0 de Llobregat","codi_municipi":"80734","latitud":"41.36124048","longitud":"2.078505613","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. de Moss\xe8n Andreu, 15","informacio_web":"https://www.cornella.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-msyn_qvng_ci69",":version":"rv-kgcv~mzt8_amg6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Marta Mata (BMM)","indicador_refugi":"80734|BIBLIOTECA_MARTA_MATA_BMM","municipi":"Cornell\xe0 de Llobregat","codi_municipi":"80734","latitud":"41.35242856","longitud":"2.070963119","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Joaquim Rubi\xf3 i Ors, 184","informacio_web":"https://www.cornella.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-dxhh~zmsx~fi3w",":version":"rv-iwm4_5f2m-xxv8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Sant Ildefons","indicador_refugi":"80734|BIBLIOTECA_SANT_ILDEFONS","municipi":"Cornell\xe0 de Llobregat","codi_municipi":"80734","latitud":"41.36314484","longitud":"2.086294193","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Pl. Carles Navales","informacio_web":"https://www.cornella.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-qkqm-v9ew-redr",":version":"rv-crb3_vzx9~ecsk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa de la Vila","indicador_refugi":"81252|CASA_DE_LA_VILA","municipi":"Montcada i Reixac","codi_municipi":"81252","latitud":"41.48558611","longitud":"2.187916937","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","adreca":"C. Major, 32","informacio_web":"https://www.montcada.cat/","tipologia":"Ajuntament","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-8gbv_3zwi~xt8w",":version":"rv-dzv5.b9pp.3ess",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament de Montcada i Reixach","indicador_refugi":"81252|AJUNTAMENT_DE_MONTCADA_I_REIXACH","municipi":"Montcada i Reixac","codi_municipi":"81252","latitud":"41.48003001","longitud":"2.187351828","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","adreca":"Av. Unitat, 6","informacio_web":"https://www.montcada.cat/","tipologia":"Ajuntament","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-avxd-qce2_kf37",":version":"rv-kjpx-2pip-v3ug",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai cultural Kursaal","indicador_refugi":"81252|ESPAI_CULTURAL_KURSAAL","municipi":"Montcada i Reixac","codi_municipi":"81252","latitud":"41.47104651","longitud":"2.183909182","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","adreca":"C. Masia, 39","informacio_web":"https://www.montcada.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jb3b-cv7z_wsea",":version":"rv-dvcq_jbu2~4mm2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre de Promoci\xf3 Econ\xf2mica Mas Rampinyo","indicador_refugi":"81252|CENTRE_DE_PROMOCIO_ECONOMICA_MAS_RAMPINYO","municipi":"Montcada i Reixac","codi_municipi":"81252","latitud":"41.49774691","longitud":"2.183229868","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","adreca":"C. Alt de Sant Pere, 73","informacio_web":"https://www.montcada.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-7a9w-s22s~gqad",":version":"rv-vvqy-q5i7-bfuc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Elisenda","indicador_refugi":"81252|BIBLIOTECA_ELISENDA","municipi":"Montcada i Reixac","codi_municipi":"81252","latitud":"41.49205658","longitud":"2.185790116","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","adreca":"C. Tarragona, 32","informacio_web":"https://www.montcada.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-xvcq-igpy~biri",":version":"rv-uuxe-ht7i_456f",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Monserrat Roig","indicador_refugi":"82114|BIBLIOTECA_MONSERRAT_ROIG","municipi":"Sant Feliu de Llobregat","codi_municipi":"82114","latitud":"41.38274109","longitud":"2.049271119","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Verge de Montserrat, 1-3","informacio_web":"https://www.santfeliu.cat/go.faces?xmid=1","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-dret-khu5-9evi",":version":"rv-ug8z-bgg9.e49i",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Poliesportiu Municipal Gornal","indicador_refugi":"81017|POLIESPORTIU_MUNICIPAL_GORNAL","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.3603826","longitud":"2.117918999","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. de Can Trias, 20","informacio_web":"https://www.l-h.cat/","tipologia":"Equipament esportiu","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-2t8y.cg7f~in5g",":version":"rv-d48z_24cf~tryx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Poliesportiu Municipal del Centre Marcel\xb7l\xed Maneja","indicador_refugi":"81017|POLIESPORTIU_MUNICIPAL_DEL_CENTRE_MARCEL_LI_MANEJA","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.36119123","longitud":"2.096524098","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. de la Riera de l\u2019Escorxador,15","informacio_web":"https://www.l-h.cat/","tipologia":"Equipament esportiu","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-tbg6.xz24_y4a3",":version":"rv-ubva~2axc-ibxt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Jordi Rubi\xf3 i Balaguer","indicador_refugi":"82009|BIBLIOTECA_JORDI_RUBIO_I_BALAGUER","municipi":"Sant Boi de Llobregat","codi_municipi":"82009","latitud":"41.34080437","longitud":"2.035469669","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. de Baldiri Aleu, 6-8","informacio_web":"https://www.santboi.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-i3c3~am2f_qkxf",":version":"rv-cfyh-a2b4-2em6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Can Massallera","indicador_refugi":"82009|CASAL_DE_CAN_MASSALLERA","municipi":"Sant Boi de Llobregat","codi_municipi":"82009","latitud":"41.34210324","longitud":"2.043346116","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. de Mallorca, 30","informacio_web":"https://www.santboi.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jd9v_p5es.zdqv",":version":"rv-c57g.x3ci_xxcq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Cal Ninyo (zona de bar)","indicador_refugi":"82009|CAL_NINYO_ZONA_DE_BAR","municipi":"Sant Boi de Llobregat","codi_municipi":"82009","latitud":"41.34661654","longitud":"2.041677153","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Major, 43","informacio_web":"https://www.santboi.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-p5xd-i7yx.3fzv",":version":"rv-guiu~nqba.bxqb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Barri Montserratina","indicador_refugi":"83015|CASAL_DE_BARRI_MONTSERRATINA","municipi":"Viladecans","codi_municipi":"83015","latitud":"41.32039559","longitud":"2.010697431","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Pl. Constituci\xf3, 4","informacio_web":"https://www.viladecans.cat/ca","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-qgt2-ucvu_i4nh",":version":"rv-ytm9~gr7w_s88c",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca P\xfablica Can Peixauet","indicador_refugi":"82457|BIBLIOTECA_PUBLICA_CAN_PEIXAUET","municipi":"Santa Coloma de Gramenet","codi_municipi":"82457","latitud":"41.44414263","longitud":"2.210203225","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","adreca":"Av. de la Generalitat, 98","informacio_web":"https://www.gramenet.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-vyvq~erz3-szjd",":version":"rv-bpfd.uhcv~z7yw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca P\xfablica del Fondo","indicador_refugi":"82457|BIBLIOTECA_PUBLICA_DEL_FONDO","municipi":"Santa Coloma de Gramenet","codi_municipi":"82457","latitud":"41.44952248","longitud":"2.217466599","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","adreca":"C. Massenet, 28-30","informacio_web":"https://www.gramenet.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-6gyn~brw2_cj2g",":version":"rv-5ayw~53yz.88zu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca de Singuerl\xedn -Salvador Cabr\xe9","indicador_refugi":"82457|BIBLIOTECA_DE_SINGUERLIN_SALVADOR_CABRE","municipi":"Santa Coloma de Gramenet","codi_municipi":"82457","latitud":"41.45905396","longitud":"2.205819564","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","adreca":"Pl. Sagrada Fam\xedlia, s/n","informacio_web":"https://www.gramenet.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-p8vt-wua2_78zp",":version":"rv-tecj_kgyq-hyed",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Central","indicador_refugi":"82457|BIBLIOTECA_CENTRAL","municipi":"Santa Coloma de Gramenet","codi_municipi":"82457","latitud":"41.45291238","longitud":"2.207731074","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","adreca":"Jard\xed de Can Sister\xe9, s/n","informacio_web":"https://www.gramenet.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-59zp.j29b.f2pc",":version":"rv-63dx-9dgt-wwnz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la Gent Gran","indicador_refugi":"89045|CASAL_DE_LA_GENT_GRAN","municipi":"Badia del Vall\xe8s","codi_municipi":"89045","latitud":"41.50852574","longitud":"2.114151936","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","adreca":"Av. de Burgos amb c. de la B\xe8tica, s/n","informacio_web":"https://www.badiadelvalles.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-mt7w~ah4j.dtz2",":version":"rv-5dxp~zd3j~hsxs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Vicente Aleixandre","indicador_refugi":"89045|BIBLIOTECA_VICENTE_ALEIXANDRE","municipi":"Badia del Vall\xe8s","codi_municipi":"89045","latitud":"41.50641015","longitud":"2.117109273","accessibilitat":"S\xcd","climatitzacio":"S\xcd","area_descans":"S\xed","adreca":"AAv. de la Mediterr\xe0nia, s/n","informacio_web":"https://www.badiadelvalles.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-7zkw-spge~rncw",":version":"rv-pjt4~u8hq~nb6i",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de gent gran Casa de la Mina","indicador_refugi":"81252|CASAL_DE_GENT_GRAN_CASA_DE_LA_MINA","municipi":"Montcada i Reixac","codi_municipi":"81252","latitud":"41.49357623","longitud":"2.189305202","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","adreca":"Av. De la Unitat s/n","informacio_web":"https://www.montcada.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-xn5d_8a4x-8n9t",":version":"rv-vbkm.bvkb.4yzy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Sant Ildefons","indicador_refugi":"80734|CENTRE_CIVIC_SANT_ILDEFONS","municipi":"Cornell\xe0 de Llobregat","codi_municipi":"80734","latitud":"41.36532394","longitud":"2.080159518","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Gerdera, s/n","informacio_web":"https://www.cornella.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ach8~mjyf~dfam",":version":"rv-pjyq_h32x~dksq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Complex aqu\xe0tic i esportiu Can Mercader (recepci\xf3 )","indicador_refugi":"80734|COMPLEX_AQUATIC_I_ESPORTIU_CAN_MERCADER_RECEPCIO","municipi":"Cornell\xe0 de Llobregat","codi_municipi":"80734","latitud":"41.35744917","longitud":"2.085082299","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Crta de L\'Hospitalet s/n","informacio_web":"https://www.cornella.cat/","tipologia":"Equipament esportiu","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ix7m_dskf~gctx",":version":"rv-s63i.xgxm-bfkh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Esportiu Llobregat (recepci\xf3)","indicador_refugi":"80734|PARC_ESPORTIU_LLOBREGAT_RECEPCIO","municipi":"Cornell\xe0 de Llobregat","codi_municipi":"80734","latitud":"41.3486172","longitud":"2.072580786","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Av. Baix Llobregat, s/n","informacio_web":"https://www.cornella.cat/","tipologia":"Equipament esportiu","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-v59c~6tyy~mw4n",":version":"rv-vg7a~samf~8ri6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Citilab","indicador_refugi":"80734|CITILAB","municipi":"Cornell\xe0 de Llobregat","codi_municipi":"80734","latitud":"41.3598648","longitud":"2.061789135","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Pl. Can Sur\xeds, s/n","informacio_web":"https://www.cornella.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-bqf3.e9xk.attf",":version":"rv-4kp8.aq8r_6248",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Torre Barrina","indicador_refugi":"81017|TORRE_BARRINA","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.37523566","longitud":"2.117521041","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Ctra. de Collblanc, 67","informacio_web":"https://www.l-h.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-49ys~9e8w~yuis",":version":"rv-7xxd_2wqa~2cmw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Cultural Santa Eul\xe0lia","indicador_refugi":"81017|CENTRE_CULTURAL_SANTA_EULALIA","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.36780681","longitud":"2.127635363","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. de Santa Eul\xe0lia, 60","informacio_web":"https://www.l-h.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-vumt~u7i6-9nzc",":version":"rv-qby2_w9pc-7hsv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat Municipal de La Florida","indicador_refugi":"81017|MERCAT_MUNICIPAL_DE_LA_FLORIDA","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.36546533","longitud":"2.127223053","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Sevilla, 2","informacio_web":"https://www.l-h.cat/","tipologia":"Mercat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3pe8-k9av.y56z",":version":"rv-tin5.4i3m_hisz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la Gent Gran Pubilla Casas","indicador_refugi":"81017|CASAL_DE_LA_GENT_GRAN_PUBILLA_CASAS","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.3735841","longitud":"2.104633529","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. d\u2019Amadeu Vives, 1","informacio_web":"https://www.l-h.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-pxqv-9x6n~eqbr",":version":"rv-sbxz.vz7a_ttgq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Gent Gran Bellvitge - L\'Ermita","indicador_refugi":"81017|CASAL_DE_GENT_GRAN_BELLVITGE_L_ERMITA","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.34860601","longitud":"2.110180361","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C.de l\u2019Ermita de Bellvitge, 40","informacio_web":"https://www.l-h.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-h9fn-u46x_eh97",":version":"rv-y8mp.5p6e-3mv3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Gent Gran Ca N\'Ar\xfas","indicador_refugi":"81017|CASAL_DE_GENT_GRAN_CA_N_ARUS","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.35809562","longitud":"2.102430908","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Av. del Carrilet, 312","informacio_web":"https://www.l-h.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-xszi_eqv4.mk6k",":version":"rv-tb9h.r9w3.682q",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Can Casacuberta","indicador_refugi":"80155|CAN_CASACUBERTA","municipi":"Badalona","codi_municipi":"80155","latitud":"41.44543851","longitud":"2.246964266","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Carrer Moss\xe8n Anton, 40-48 08912 Badalona","informacio_web":"https://www.badalona.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-yncv.4mgr.dkew",":version":"rv-v8rz-vvyv-3uzn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Font de la Mina","indicador_refugi":"81944|BIBLIOTECA_FONT_DE_LA_MINA","municipi":"Sant Adri\xe0 del Bes\xf2s","codi_municipi":"81944","latitud":"41.41927349","longitud":"2.219108451","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","adreca":"C. Ponent, 21-25","informacio_web":"https://www.sant-adria.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-6dav-auew_hyne",":version":"rv-dqqq.jm8p.p69h",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca de Sant Adri\xe0","indicador_refugi":"81944|BIBLIOTECA_DE_SANT_ADRIA","municipi":"Sant Adri\xe0 del Bes\xf2s","codi_municipi":"81944","latitud":"41.43152598","longitud":"2.215083788","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","adreca":"Pl. Guillermo Vida\xf1a i Haro, s/n","informacio_web":"https://www.sant-adria.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-4ya9_a5dj_5mt4",":version":"rv-6jvt.2pwj-unqr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Cultural Bes\xf2s","indicador_refugi":"81944|CENTRE_CULTURAL_BESOS","municipi":"Sant Adri\xe0 del Bes\xf2s","codi_municipi":"81944","latitud":"41.421119","longitud":"2.214987734","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Josep Tarradellas, s/n","informacio_web":"https://www.sant-adria.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-gbw6-zrqq_7xwn",":version":"rv-zrvb-ezme.2mzx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal Dalt de la Vila","indicador_refugi":"81944|CASAL_DALT_DE_LA_VILA","municipi":"Sant Adri\xe0 del Bes\xf2s","codi_municipi":"81944","latitud":"41.43406847","longitud":"2.214509761","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Esgl\xe9sia, 13","informacio_web":"https://www.sant-adria.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-mu5z_ahbs-4irs",":version":"rv-sf3s-9hpm~tr6h",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Gent Gran Fiveller","indicador_refugi":"81944|CASAL_DE_GENT_GRAN_FIVELLER","municipi":"Sant Adri\xe0 del Bes\xf2s","codi_municipi":"81944","latitud":"41.43056792","longitud":"2.220291843","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","adreca":"C. Joan Fiveller, 11-13","informacio_web":"https://www.sant-adria.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-545x.pcxa.re9r",":version":"rv-bxff_e7fn-qmki",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Can Baratau","indicador_refugi":"82824|BIBLIOTECA_CAN_BARATAU","municipi":"Tiana","codi_municipi":"82824","latitud":"41.48255665","longitud":"2.269018992","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","adreca":"C. Lola Anglada, 10","informacio_web":"https://tiana.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3inr_vy8p.su2k",":version":"rv-de47_mtwp-qfg8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Llar de les Persones Grans","indicador_refugi":"82824|LLAR_DE_LES_PERSONES_GRANS","municipi":"Tiana","codi_municipi":"82824","latitud":"41.48168802","longitud":"2.268373379","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","adreca":"C. Anselm Clav\xe9, 20","informacio_web":"https://tiana.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-gu7v~menf_3n2a",":version":"rv-k6i6.h373_8tnh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Castell","indicador_refugi":"80569|PARC_DEL_CASTELL","municipi":"Castelldefels","codi_municipi":"80569","latitud":"41.28365952","longitud":"1.979074747","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Castell, 1","informacio_web":"https://refugisclimatics.amb.cat","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-tbe3-d3r3_t7kc",":version":"rv-983n~wnvn_9h63",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Muntanyeta","indicador_refugi":"80569|PARC_DE_LA_MUNTANYETA","municipi":"Castelldefels","codi_municipi":"80569","latitud":"41.28069187","longitud":"1.973255948","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Doctor Fleming, 79","informacio_web":"https://www.castelldefels.org/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-kjep~d7k7~rivp",":version":"rv-x4zz.xm46.2z6a",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Can Mercader","indicador_refugi":"80734|PARC_DE_CAN_MERCADER","municipi":"Cornell\xe0 de Llobregat","codi_municipi":"80734","latitud":"41.35744749","longitud":"2.085108448","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. de l\u2019Hospitalet, 78","informacio_web":"https://refugisclimatics.amb.cat","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3y5n-h4q9-ukc3",":version":"rv-n9fe_5jak~ctzh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Canal de la Infanta","indicador_refugi":"80734|PARC_DEL_CANAL_DE_LA_INFANTA","municipi":"Cornell\xe0 de Llobregat","codi_municipi":"80734","latitud":"41.36116019","longitud":"2.063064396","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"C.Maria Aur\xe8lia Capmany, 14","informacio_web":"https://refugisclimatics.amb.cat","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-6czz_4j9d-fiaa",":version":"rv-t73b.cfr3.q8we",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Rosa Sensat","indicador_refugi":"80734|PARC_DE_ROSA_SENSAT","municipi":"Cornell\xe0 de Llobregat","codi_municipi":"80734","latitud":"41.3549517","longitud":"2.074326246","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Vicen\xe7 Llivina, s/n","informacio_web":"https://www.cornella.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wsa8.6e2c.j389",":version":"rv-8fmz~jxar_mu8p",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Joan Fuster","indicador_refugi":"81252|PARC_DE_JOAN_FUSTER","municipi":"Montcada i Reixac","codi_municipi":"81252","latitud":"41.49315898","longitud":"2.187069467","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. de Joan Fuster  s/n","informacio_web":"https://www.montcada.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-2jnv-489v~yhkb",":version":"rv-pamv~nwag-uxa5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc d\'Europa","indicador_refugi":"82114|PARC_D_EUROPA","municipi":"Sant Feliu de Llobregat","codi_municipi":"82114","latitud":"41.3858391","longitud":"2.057773007","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Marqu\xe8s de Monistrol","informacio_web":"https://www.santfeliu.cat/go.faces?xmid=1","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-d572-cuby.7x24",":version":"rv-z56j-2xd2_j55h",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins del Palau Falguera","indicador_refugi":"82114|JARDINS_DEL_PALAU_FALGUERA","municipi":"Sant Feliu de Llobregat","codi_municipi":"82114","latitud":"41.38055403","longitud":"2.042403168","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"C. de Ram\xf3n i Cajal, 2","informacio_web":"https://www.santfeliu.cat/go.faces?xmid=1","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-4mwd-gy5s-xm8x",":version":"rv-dfr9-emg6~hej8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Llobregat","indicador_refugi":"82114|PARC_DEL_LLOBREGAT","municipi":"Sant Feliu de Llobregat","codi_municipi":"82114","latitud":"41.38315853","longitud":"2.038229577","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. del Pla, 90","informacio_web":"https://refugisclimatics.amb.cat","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-82c7-eq6p.6w5p",":version":"rv-rj5y-b5mb.bpwm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Can Buxeres","indicador_refugi":"81017|PARC_DE_CAN_BUXERES","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.36462869","longitud":"2.095921166","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. d\u2019Esplugues, 1","informacio_web":"https://refugisclimatics.amb.cat","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-4gsq~9duz.4esx",":version":"rv-rfij~7ssp.f67b",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de les Planes","indicador_refugi":"81017|PARC_DE_LES_PLANES","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.36736051","longitud":"2.105249403","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"C. del Teide, 88","informacio_web":"https://refugisclimatics.amb.cat","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-6asz.9bny~7rb2",":version":"rv-9zg7-ngvz_rnnv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de l\'Alhambra","indicador_refugi":"81017|PARC_DE_L_ALHAMBRA","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.36288494","longitud":"2.130322469","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Alhambra, 22","informacio_web":"https://www.l-h.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-bzgs.avdg_rh2c",":version":"rv-eayz_v7bw~mg36",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Can Juli\xe0","indicador_refugi":"82009|PARC_DE_CAN_JULIA","municipi":"Sant Boi de Llobregat","codi_municipi":"82009","latitud":"41.34407834","longitud":"2.046363713","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Bonaventura Calopa, s/n","informacio_web":"https://www.santboi.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wbft.9hkd-mt5f",":version":"rv-i4m3_jku3-s4gg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Marianao","indicador_refugi":"82009|PARC_DE_MARIANAO","municipi":"Sant Boi de Llobregat","codi_municipi":"82009","latitud":"41.3478877","longitud":"2.023003543","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Lledoners, 1","informacio_web":"https://www.santboi.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-fsxq_f435~pkf2",":version":"rv-x2mf.ww49_rbvd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a dels Focs de Sant Joan","indicador_refugi":"82009|PLACA_DELS_FOCS_DE_SANT_JOAN","municipi":"Sant Boi de Llobregat","codi_municipi":"82009","latitud":"41.3340529","longitud":"2.040681366","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. dels Focs de Sant Joan","informacio_web":"https://www.santboi.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-v8qt-wrpu_cv5h",":version":"rv-d65c~9m9b.cvqn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Muntanyeta","indicador_refugi":"82009|PARC_DE_LA_MUNTANYETA","municipi":"Sant Boi de Llobregat","codi_municipi":"82009","latitud":"41.34197384","longitud":"2.033606126","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Mare de D\xe9u del Pilar","informacio_web":"https://refugisclimatics.amb.cat","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-bv2d-vecm~p758",":version":"rv-eb5a-cdji~3mrv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Torrent Ballester","indicador_refugi":"83015|PARC_DEL_TORRENT_BALLESTER","municipi":"Viladecans","codi_municipi":"83015","latitud":"41.31628564","longitud":"2.011525984","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. de Josep Tarradellas, 34","informacio_web":"https://www.viladecans.cat/ca","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-448d.kp3q~ybbw",":version":"rv-cwrn.jxkr.qbqk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Torre Roja","indicador_refugi":"83015|PARC_DE_LA_TORRE_ROJA","municipi":"Viladecans","codi_municipi":"83015","latitud":"41.3216489","longitud":"2.020470028","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Mari\xe0 Sanjuan Cuch\xed, 11","informacio_web":"https://refugisclimatics.amb.cat","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-itde~a2y2~vxs4",":version":"rv-mpva.r5p2.42wd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Can Zam","indicador_refugi":"82457|PARC_DE_CAN_ZAM","municipi":"Santa Coloma de Gramenet","codi_municipi":"82457","latitud":"41.45617741","longitud":"2.196707603","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"C. V\xedctor Hugo, 70","informacio_web":"https://refugisclimatics.amb.cat","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-8ks7_s4xa.fx6t",":version":"rv-iibp.dzxi_vbur",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de les Illes Balears","indicador_refugi":"89045|PARC_DE_LES_ILLES_BALEARS","municipi":"Badia del Vall\xe8s","codi_municipi":"89045","latitud":"41.50602582","longitud":"2.120436941","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Menorca, s/n","informacio_web":"https://www.badiadelvalles.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-zur2_ky5g-eti4",":version":"rv-rp8x_5fc3.6men",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Nou","indicador_refugi":"81691|PARC_NOU","municipi":"el Prat de Llobregat","codi_municipi":"81691","latitud":"41.31399299","longitud":"2.090063488","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"Ronda sud","informacio_web":"https://refugisclimatics.amb.cat","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-srtb~f8vj~zd27",":version":"rv-uynn.kwk8_ezex",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc  Pi Gros","indicador_refugi":"82634|PARC_PI_GROS","municipi":"Sant Vicen\xe7 dels Horts","codi_municipi":"82634","latitud":"41.39584317","longitud":"2.003002107","accessibilitat":"S\xcd","area_descans":"S\xed","adreca":"Trav. d\'Arag\xf3","informacio_web":"https://refugisclimatics.amb.cat","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-8xaj-hfnr_bpy4",":version":"rv-28kz_8q5f.y9sy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Can Solei i Ca l\'Arn\xfas","indicador_refugi":"80155|PARC_DE_CAN_SOLEI_I_CA_L_ARNUS","municipi":"Badalona","codi_municipi":"80155","latitud":"41.45658526","longitud":"2.253143675","accessibilitat":"S\xcd","area_descans":"S\xed","adreca":"Riera Canyad\xf3,51\\nC/ Seu d\'Urgell,30","informacio_web":"https://refugisclimatics.amb.cat","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-72u9-e4yb.tbck",":version":"rv-hvfb_jyn6~u977",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Torreblanca","indicador_refugi":"82172|PARC_DE_TORREBLANCA","municipi":"Sant Joan Desp\xed","codi_municipi":"82172","latitud":"41.37803008","longitud":"2.056170778","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. Reial, 159","informacio_web":"https://refugisclimatics.amb.cat","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-582h-vqqw.qwr8",":version":"rv-7uan.stvs_z6r6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Can Vidalet","indicador_refugi":"80771|CAN_VIDALET","municipi":"Esplugues de Llobregat","codi_municipi":"80771","latitud":"41.37525034","longitud":"2.097142908","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"Avinguda Navarra, 205","informacio_web":"https://refugisclimatics.amb.cat","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ee9d_s4cx.p4my",":version":"rv-sea5.934f~8vsv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Arbreda de la Rambleta","indicador_refugi":"81944|ARBREDA_DE_LA_RAMBLETA","municipi":"Sant Adri\xe0 del Bes\xf2s","codi_municipi":"81944","latitud":"41.43052454","longitud":"2.215444901","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. de la Rambleta Joan Llandrich","informacio_web":"https://www.sant-adria.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wmne~hcjn~c4vs",":version":"rv-cq23_ep7v.4m2v",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de Salvador Espriu","indicador_refugi":"82824|PLACA_DE_SALVADOR_ESPRIU","municipi":"Tiana","codi_municipi":"82824","latitud":"41.47794022","longitud":"2.27183133","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Pau Casals, 2","informacio_web":"https://tiana.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-azqw-j36n-9j78",":version":"rv-7t58.vdrj-ixzk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de l\u2019Antic Camp de Futbol","indicador_refugi":"82824|PARC_DE_L_ANTIC_CAMP_DE_FUTBOL","municipi":"Tiana","codi_municipi":"82824","latitud":"41.47874252","longitud":"2.26971371","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"Pg. Vilesa, 28","informacio_web":"https://tiana.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ts78-kpk5~8q4z",":version":"rv-z7su-jice-egm2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Joan Armengol","indicador_refugi":"82824|PARC_DE_JOAN_ARMENGOL","municipi":"Tiana","codi_municipi":"82824","latitud":"41.48640113","longitud":"2.270070681","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"Cam\xed de Dalt d\u2019Alella, s/n","informacio_web":"https://tiana.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-64ec_vcs8_tbmi",":version":"rv-4b3u.s7e8_3mnu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Clara Campoamor","indicador_refugi":"80734|BIBLIOTECA_CLARA_CAMPOAMOR","municipi":"Cornell\xe0 de Llobregat","codi_municipi":"80734","latitud":"41.36060131","longitud":"2.062447071","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Crta. de Sant Joan Desp\xed, 901","informacio_web":"https://www.cornella.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wc68_nipy.3rz5",":version":"rv-qwug.dbjm~796r",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Teresa Pamies","indicador_refugi":"80734|BIBLIOTECA_TERESA_PAMIES","municipi":"Cornell\xe0 de Llobregat","codi_municipi":"80734","latitud":"41.35327852","longitud":"2.085760946","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Pg. dels Ferrocarrils Catalans, 187","informacio_web":"https://www.cornella.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ba42-yf6q~qvqn",":version":"rv-veag-dgy6.3sht",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Esteve Paluzi\xe9","indicador_refugi":"82520|BIBLIOTECA_ESTEVE_PALUZIE","municipi":"Barber\xe0 del Vall\xe8s","codi_municipi":"82520","latitud":"41.5209186","longitud":"2.121145989","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Catalans, 187","informacio_web":"https://www.bdv.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-tcn9-dqpx~fxwk",":version":"rv-k5yv-3bxg_xrki",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Ca N\'Amiguet","indicador_refugi":"82520|CENTRE_CIVIC_CA_N_AMIGUET","municipi":"Barber\xe0 del Vall\xe8s","codi_municipi":"82520","latitud":"41.52452205","longitud":"2.124268039","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Via Sant Oleguer, 20","informacio_web":"https://www.bdv.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-vr8p~3guq-xivm",":version":"rv-k4yr-2mnq.nqfc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat 11 de setembre","indicador_refugi":"82520|MERCAT_11_DE_SETEMBRE","municipi":"Barber\xe0 del Vall\xe8s","codi_municipi":"82520","latitud":"41.51781815","longitud":"2.124588125","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Verge de l\'Assumpci\xf3, 32","informacio_web":"https://www.bdv.cat/","tipologia":"Mercat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-atte.uvmc_e96c",":version":"rv-jqve_53gi_g4vr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Teatre Municipal Cooperativa","indicador_refugi":"82520|TEATRE_MUNICIPAL_COOPERATIVA","municipi":"Barber\xe0 del Vall\xe8s","codi_municipi":"82520","latitud":"41.51655864","longitud":"2.127340226","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Ptge.  Cooperativa, 5","informacio_web":"https://www.bdv.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-u379_kurj-d64v",":version":"rv-xqqf_kw28_8487",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre de Formaci\xf3 Torre d\'en Gorgs","indicador_refugi":"82520|CENTRE_DE_FORMACIO_TORRE_D_EN_GORGS","municipi":"Barber\xe0 del Vall\xe8s","codi_municipi":"82520","latitud":"41.51149557","longitud":"2.119997449","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Torre d\'en Gorgs, 40","informacio_web":"https://www.bdv.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-tg76.n6xy_zuk7",":version":"rv-3fnc.ehkj-ath3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Can Serra","indicador_refugi":"82520|PARC_DE_CAN_SERRA","municipi":"Barber\xe0 del Vall\xe8s","codi_municipi":"82520","latitud":"41.51297586","longitud":"2.125091948","accessibilitat":"S\xcd","area_descans":"S\xed","adreca":"Pg. Doctor Moragas","informacio_web":"https://www.bdv.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-p6h7_m8vw_xjtn",":version":"rv-qs62~uvtz-as89",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de la Constituci\xf3","indicador_refugi":"82520|PLACA_DE_LA_CONSTITUCIO","municipi":"Barber\xe0 del Vall\xe8s","codi_municipi":"82520","latitud":"41.52066518","longitud":"2.12157832","accessibilitat":"S\xcd","area_descans":"S\xed","adreca":"C.  Marquesos de Barber\xe0, 192","informacio_web":"https://www.bdv.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-q6z2~img8-din2",":version":"rv-jnce.grb5.z48v",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de l\'Esport","indicador_refugi":"82520|PLACA_DE_L_ESPORT","municipi":"Barber\xe0 del Vall\xe8s","codi_municipi":"82520","latitud":"41.51935198","longitud":"2.12241985","accessibilitat":"S\xcd","area_descans":"S\xed","adreca":"Pg. Doctor Moragas, 268","informacio_web":"https://www.bdv.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-prd4~2gr9_6f7y",":version":"rv-gzym~s3jh-uzjn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de la Unitat","indicador_refugi":"82520|PLACA_DE_LA_UNITAT","municipi":"Barber\xe0 del Vall\xe8s","codi_municipi":"82520","latitud":"41.51705558","longitud":"2.130455306","accessibilitat":"S\xcd","area_descans":"S\xed","adreca":"C. Nemesi Valls","informacio_web":"https://www.bdv.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-652i.cg4h_3jmc",":version":"rv-xww3-iip5-53kg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca de Pallej\xe0","indicador_refugi":"81574|BIBLIOTECA_DE_PALLEJA","municipi":"Pallej\xe0","codi_municipi":"81574","latitud":"41.42168358","longitud":"1.996917863","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Av. Prat de la Riba, 10","informacio_web":"https://www.palleja.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-y6sg-veet.h5gg",":version":"rv-kmnw_n9kp~sbkj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Gent Gran","indicador_refugi":"81574|CASAL_DE_GENT_GRAN","municipi":"Pallej\xe0","codi_municipi":"81574","latitud":"41.42538121","longitud":"1.997589889","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Pau Claris, 36","informacio_web":"https://www.palleja.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-n3td~upbh-bgcv",":version":"rv-eqfh.sud4~a9s9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Molinada","indicador_refugi":"81574|PARC_DE_LA_MOLINADA","municipi":"Pallej\xe0","codi_municipi":"81574","latitud":"41.42164958","longitud":"1.997802643","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Mare de D\xe9u de Loreto","informacio_web":"https://refugisclimatics.amb.cat","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-pwja~93x5.j7vh",":version":"rv-vbkk.3avu_4efn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Tirant Lo Blanc","indicador_refugi":"81265|BIBLIOTECA_TIRANT_LO_BLANC","municipi":"Montgat","codi_municipi":"81265","latitud":"41.46884","longitud":"2.274308013","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Rda. dels Pa\xefsos Catalans, s/n","informacio_web":"https://www.montgat.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-imdu-fsxv-vvzz",":version":"rv-t48y-qyxt_uxx2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Gent Gran Joan Maragall","indicador_refugi":"81265|CASAL_DE_GENT_GRAN_JOAN_MARAGALL","municipi":"Montgat","codi_municipi":"81265","latitud":"41.46417131","longitud":"2.273856536","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Ctra. de Matar\xf3, 113","informacio_web":"https://www.montgat.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-j7yf_ut74~b3cs",":version":"rv-fd6s-wmqn_hbpa",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Riera d\'en Font","indicador_refugi":"81265|PARC_DE_RIERA_D_EN_FONT","municipi":"Montgat","codi_municipi":"81265","latitud":"41.46891357","longitud":"2.284461573","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Riera d\'en Font","informacio_web":"https://www.montgat.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jkii-tfq7-4fgx",":version":"rv-cpvc_9mqw_jkif",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Tramvia","indicador_refugi":"81265|PARC_DEL_TRAMVIA","municipi":"Montgat","codi_municipi":"81265","latitud":"41.47110416","longitud":"2.275618429","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Jordana, 92","informacio_web":"https://refugisclimatics.amb.cat","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-hn7g-3hyw-dzdr",":version":"rv-q6nk.u96p~b4cx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Maria Regordosa-Masot","indicador_refugi":"81803|PARC_DE_MARIA_REGORDOSA_MASOT","municipi":"Ripollet","codi_municipi":"81803","latitud":"41.4919293","longitud":"2.151341807","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Nostra Senyora dels \xc0ngels","informacio_web":"https://refugisclimatics.amb.cat","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-yd5j.skqe_azg3",":version":"rv-jqc2~dy8g-igwg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre de Gent Gran Cireres","indicador_refugi":"82172|CENTRE_DE_GENT_GRAN_CIRERES","municipi":"Sant Joan Desp\xed","codi_municipi":"82172","latitud":"41.36855508","longitud":"2.076298034","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Sant Francesc de Sales, 1","informacio_web":"https://sjdespi.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-kn7v~4fs5-psns",":version":"rv-rgsd.fbau-zh2i",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Miquel Mart\xed i Pol","indicador_refugi":"82172|BIBLIOTECA_MIQUEL_MARTI_I_POL","municipi":"Sant Joan Desp\xed","codi_municipi":"82172","latitud":"41.3691764","longitud":"2.071281947","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","adreca":"Av. de Barcelona, 83-85","informacio_web":"https://sjdespi.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-mr2f~um4r.u3sr",":version":"rv-caqe-ra9h~xzde",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Poliesportiu Municipal Francesc Calvet","indicador_refugi":"82172|POLIESPORTIU_MUNICIPAL_FRANCESC_CALVET","municipi":"Sant Joan Desp\xed","codi_municipi":"82172","latitud":"41.36832652","longitud":"2.064174956","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Avinguda de Barcelona, 45","informacio_web":"https://sjdespi.cat/","tipologia":"Equipament esportiu","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-mpd4-hd8u~5zee",":version":"rv-swum~t2hd-9be4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Antoni Gaud\xed","indicador_refugi":"82172|CENTRE_CIVIC_ANTONI_GAUDI","municipi":"Sant Joan Desp\xed","codi_municipi":"82172","latitud":"41.37322164","longitud":"2.06948322","aigua":"S\xed","area_descans":"S\xed","adreca":"Pla\xe7a l\'Estatut, 5","informacio_web":"https://sjdespi.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-zb5f.f7k4.pkgu",":version":"rv-dwtw_ee77-gp4b",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Poliesportiu Salvador Gimeno","indicador_refugi":"82172|POLIESPORTIU_SALVADOR_GIMENO","municipi":"Sant Joan Desp\xed","codi_municipi":"82172","latitud":"41.36849262","longitud":"2.052048034","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Major, 75","informacio_web":"https://sjdespi.cat/","tipologia":"Equipament esportiu","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ptdn~bhcu-rcn8",":version":"rv-ubes~tv57.xdfg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Pla del Vent - Torreblanca","indicador_refugi":"82172|CENTRE_CIVIC_PLA_DEL_VENT_TORREBLANCA","municipi":"Sant Joan Desp\xed","codi_municipi":"82172","latitud":"41.37688453","longitud":"2.059522505","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Rubi\xf3 i Tuduri,5","informacio_web":"https://sjdespi.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-w5bx~r742~6kqa",":version":"rv-gfn7-cued_787k",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Cultural Merc\xe8 Rodoreda","indicador_refugi":"82172|CENTRE_CULTURAL_MERCE_RODOREDA","municipi":"Sant Joan Desp\xed","codi_municipi":"82172","latitud":"41.36709099","longitud":"2.054065399","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","adreca":"C. Major, 69","informacio_web":"https://sjdespi.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3khd-vdui.jv6s",":version":"rv-u22t_3ibe.vif8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Fontsanta","indicador_refugi":"82172|PARC_DE_LA_FONTSANTA","municipi":"Sant Joan Desp\xed","codi_municipi":"82172","latitud":"41.36984549","longitud":"2.070341758","accessibilitat":"S\xcd","adreca":"C. de la Fontsanta, s/n","informacio_web":"https://refugisclimatics.amb.cat","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-g38u_kgkm.2had",":version":"rv-vwys~jhh8.q7d6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Fontetes","indicador_refugi":"82665|CENTRE_CIVIC_FONTETES","municipi":"Cerdanyola del Vall\xe8s","codi_municipi":"82665","latitud":"41.49069939","longitud":"2.148394114","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. dels Reis, 30","informacio_web":"https://www.cerdanyola.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wvev.betw-cgbc",":version":"rv-dbzf~ufb9-t5cv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Ban\xfas-Bonasort","indicador_refugi":"82665|CENTRE_CIVIC_BANUS_BONASORT","municipi":"Cerdanyola del Vall\xe8s","codi_municipi":"82665","latitud":"41.49097301","longitud":"2.134717301","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Pl. de Sant Medir, s/n","informacio_web":"https://www.cerdanyola.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-qmu6~gjts.ysms",":version":"rv-5je5.rf2q.9bjq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Serraperera","indicador_refugi":"82665|CENTRE_CIVIC_SERRAPERERA","municipi":"Cerdanyola del Vall\xe8s","codi_municipi":"82665","latitud":"41.49737898","longitud":"2.125944568","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Sant Casimir, s/n","informacio_web":"https://www.cerdanyola.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-5p6q~a47x~zcxh",":version":"rv-a2ch-cstq-c8zt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Central","indicador_refugi":"82665|BIBLIOTECA_CENTRAL","municipi":"Cerdanyola del Vall\xe8s","codi_municipi":"82665","latitud":"41.49260045","longitud":"2.142111654","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Pl. Enric Granados, 1","informacio_web":"https://www.cerdanyola.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-nc44~6zq3~wviv",":version":"rv-9g6d.tbaz-nwkw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Cordelles","indicador_refugi":"82665|PARC_DE_CORDELLES","municipi":"Cerdanyola del Vall\xe8s","codi_municipi":"82665","latitud":"41.49621282","longitud":"2.133401174","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Diagonal, 45","informacio_web":"https://www.cerdanyola.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-fteu~cj54~dm8t",":version":"rv-7wqy~587p_z72i",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat de Fontetes","indicador_refugi":"82665|MERCAT_DE_FONTETES","municipi":"Cerdanyola del Vall\xe8s","codi_municipi":"82665","latitud":"41.49078791","longitud":"2.146544394","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. dels Reis, 22","informacio_web":"https://www.cerdanyola.cat/","tipologia":"Mercat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-8kag.u5ng-dfq5",":version":"rv-k6mc_4xjk-umrk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat de Serraperera","indicador_refugi":"82665|MERCAT_DE_SERRAPERERA","municipi":"Cerdanyola del Vall\xe8s","codi_municipi":"82665","latitud":"41.49425998","longitud":"2.133762584","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Sant Casimir, s/n","informacio_web":"https://www.cerdanyola.cat/","tipologia":"Mercat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jg66.qpgi~czm3",":version":"rv-8vua~4r2e_8y53",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Turonet","indicador_refugi":"82665|PARC_DEL_TURONET","municipi":"Cerdanyola del Vall\xe8s","codi_municipi":"82665","latitud":"41.48794378","longitud":"2.147702156","accessibilitat":"S\xcd","area_descans":"S\xed","adreca":"C. de Pizarro, 34","informacio_web":"https://refugisclimatics.amb.cat","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-fyf9-pv5y~5m39",":version":"rv-dykf.gxbd.rxtq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc esportiu municipal Guiera","indicador_refugi":"82665|PARC_ESPORTIU_MUNICIPAL_GUIERA","municipi":"Cerdanyola del Vall\xe8s","codi_municipi":"82665","latitud":"41.48329409","longitud":"2.139039841","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Av. de Guiera, 6","informacio_web":"https://www.cerdanyola.cat/","tipologia":"Equipament esportiu","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wbs7-haeh-22p7",":version":"rv-576i-4c4e_agcd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Museu de Ca n\'Oliver","indicador_refugi":"82665|MUSEU_DE_CA_N_OLIVER","municipi":"Cerdanyola del Vall\xe8s","codi_municipi":"82665","latitud":"41.48081187","longitud":"2.133918417","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Val\xe8ncia, 19","informacio_web":"https://www.cerdanyola.cat/","tipologia":"Museus","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-4vhx_ra8h-sa4v",":version":"rv-k6mu_bx5x~ts9f",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bosc de Volpelleres","indicador_refugi":"82055|BOSC_DE_VOLPELLERES","municipi":"Sant Cugat del Vall\xe8s","codi_municipi":"82055","latitud":"41.48532419","longitud":"2.074365612","accessibilitat":"S\xcd","area_descans":"S\xed","adreca":"C. d\'Alfons d\'Arag\xf3","informacio_web":"https://www.santcugat.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jzkb-urrh.277v",":version":"rv-9cev~7kj2~fmx8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins del Monestir","indicador_refugi":"82055|JARDINS_DEL_MONESTIR","municipi":"Sant Cugat del Vall\xe8s","codi_municipi":"82055","latitud":"41.47464496","longitud":"2.085708654","accessibilitat":"S\xcd","area_descans":"S\xed","adreca":"Pl.de l\'Om,1","informacio_web":"https://www.santcugat.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-gcxw~6beu~7hef",":version":"rv-yr9t_pg3u~gpt2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Central","indicador_refugi":"82055|PARC_CENTRAL","municipi":"Sant Cugat del Vall\xe8s","codi_municipi":"82055","latitud":"41.47346844","longitud":"2.073531766","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. de Manel Farr\xe9s, s/n","informacio_web":"https://www.santcugat.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ay2y_k4ib_nbu4",":version":"rv-nzk7.xn23-aad2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Torrent de Ferrussons","indicador_refugi":"82055|PARC_DE_TORRENT_DE_FERRUSSONS","municipi":"Sant Cugat del Vall\xe8s","codi_municipi":"82055","latitud":"41.48067279","longitud":"2.089130296","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Torrent de Ferrussons","informacio_web":"https://www.santcugat.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-8zx8-t3v7_vdpj",":version":"rv-3um9.r4d4_tigw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Torreblanca","indicador_refugi":"82055|CASAL_DE_TORREBLANCA","municipi":"Sant Cugat del Vall\xe8s","codi_municipi":"82055","latitud":"41.47033335","longitud":"2.091823206","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Av. Pla del Vinyet, 81-85","informacio_web":"https://www.santcugat.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3hxi_2xz3-5yj8",":version":"rv-yjxe~aquy~2e52",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat municipal de Torreblanca","indicador_refugi":"82055|MERCAT_MUNICIPAL_DE_TORREBLANCA","municipi":"Sant Cugat del Vall\xe8s","codi_municipi":"82055","latitud":"41.47058258","longitud":"2.090010067","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Av. de la Torre Blanca, 10","informacio_web":"https://www.santcugat.cat/","tipologia":"Mercat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-bzu3.j7t4-tv2t",":version":"rv-379c-7vka~ef6i",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Central Gabriel Ferrater","indicador_refugi":"82055|BIBLIOTECA_CENTRAL_GABRIEL_FERRATER","municipi":"Sant Cugat del Vall\xe8s","codi_municipi":"82055","latitud":"41.46938361","longitud":"2.088293371","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Av. del Pla del Vinyet, 40","informacio_web":"https://www.santcugat.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wk8u.sind-ma89",":version":"rv-ybzi~e74g_78m5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament de Sant Cugat del Vall\xe8s","indicador_refugi":"82055|AJUNTAMENT_DE_SANT_CUGAT_DEL_VALLES","municipi":"Sant Cugat del Vall\xe8s","codi_municipi":"82055","latitud":"41.47039726","longitud":"2.085181107","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Pl.de la Vila, 1","informacio_web":"https://www.santcugat.cat/","tipologia":"Ajuntament","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-zkaj_iejd~sb67",":version":"rv-tu8a~e54s-zyqv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La Uni\xf3 Santcugatenca","indicador_refugi":"82055|LA_UNIO_SANTCUGATENCA","municipi":"Sant Cugat del Vall\xe8s","codi_municipi":"82055","latitud":"41.47159793","longitud":"2.080513055","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Av. de Josep Anselm Clav\xe9, 13-17","informacio_web":"https://www.santcugat.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-mn6u-cpac-zp8u",":version":"rv-z9dr.83p5~e3rj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Tur\xf3 de Can Mates","indicador_refugi":"82055|PARC_DEL_TURO_DE_CAN_MATES","municipi":"Sant Cugat del Vall\xe8s","codi_municipi":"82055","latitud":"41.47529965","longitud":"2.06195221","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Ramon Llull, 18","informacio_web":"https://www.santcugat.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-x5ca-9ygu_yj2b",":version":"rv-mmg4.twit~m2zf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Mira-sol","indicador_refugi":"82055|CASAL_DE_MIRA_SOL","municipi":"Sant Cugat del Vall\xe8s","codi_municipi":"82055","latitud":"41.46784201","longitud":"2.046305366","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. de Mallorca, 42","informacio_web":"https://www.santcugat.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wuxp_xyvx_259m",":version":"rv-s3mc-8kqm~kkjd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Miquel Batllori (Volpelleres)","indicador_refugi":"82055|BIBLIOTECA_MIQUEL_BATLLORI_VOLPELLERES","municipi":"Sant Cugat del Vall\xe8s","codi_municipi":"82055","latitud":"41.4840802","longitud":"2.065491464","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C.  de Pau Mu\xf1oz i Castanyer, 3-5","informacio_web":"https://www.santcugat.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-hnwy-raty_apc3",":version":"rv-w6yr-3jy5_qmcw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat municipal Volpelleres","indicador_refugi":"82055|MERCAT_MUNICIPAL_VOLPELLERES","municipi":"Sant Cugat del Vall\xe8s","codi_municipi":"82055","latitud":"41.4815794","longitud":"2.070636766","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. de Benet Cortada,15","informacio_web":"https://www.santcugat.cat/","tipologia":"Mercat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-sphm-8k25.r26v",":version":"rv-9eud~u5ji~f8mr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Les Planes","indicador_refugi":"82055|CENTRE_CIVIC_LES_PLANES","municipi":"Sant Cugat del Vall\xe8s","codi_municipi":"82055","latitud":"41.43389472","longitud":"2.093997768","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Pl .del Coll de la Creu d\'en Blau, 7","informacio_web":"https://www.santcugat.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-npug~7uu2~t5x9",":version":"rv-4mht-hx4z_yt7d",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Social i Sanitari de la Floresta","indicador_refugi":"82055|CENTRE_SOCIAL_I_SANITARI_DE_LA_FLORESTA","municipi":"Sant Cugat del Vall\xe8s","codi_municipi":"82055","latitud":"41.44499402","longitud":"2.074828287","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Pearson, 36","informacio_web":"https://www.santcugat.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-fscm-pexu-z3m8",":version":"rv-eu7g~bzhw-sh4x",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Gent Gran de Valldoreix","indicador_refugi":"82055|CASAL_DE_GENT_GRAN_DE_VALLDOREIX","municipi":"Sant Cugat del Vall\xe8s","codi_municipi":"82055","latitud":"41.45862105","longitud":"2.063069842","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. de Tibidabo, 5","informacio_web":"https://www.santcugat.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-2tim_6kry_3rb5",":version":"rv-h8w9.s8n7_hrzn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Pessarrodona (Mira-sol)","indicador_refugi":"82055|BIBLIOTECA_PESSARRODONA_MIRA_SOL","municipi":"Sant Cugat del Vall\xe8s","codi_municipi":"82055","latitud":"41.46972942","longitud":"2.061649885","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Pl. Ausi\xe0s March, 2","informacio_web":"https://www.santcugat.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-gi3p~vys5~9ngz",":version":"rv-jxfk-5ssx~8z7h",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Vall d\'Or (Valldoreix)","indicador_refugi":"82055|BIBLIOTECA_VALL_D_OR_VALLDOREIX","municipi":"Sant Cugat del Vall\xe8s","codi_municipi":"82055","latitud":"41.45737847","longitud":"2.047910729","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Rbla. Moss\xe8n Jacint Verdaguer, 185","informacio_web":"https://www.santcugat.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-kv4x-bzgf-ty9s",":version":"rv-m2sp.uun7_e53r",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Can Barriga","indicador_refugi":"80155|PARC_DE_CAN_BARRIGA","municipi":"Badalona","codi_municipi":"80155","latitud":"41.45593017","longitud":"2.241149953","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. de Mart\xed Pujol, 410","informacio_web":"https://www.badalona.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-dryu_f5sn-3py3",":version":"rv-x6yh-xhrp_mv8c",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca  Lloreda","indicador_refugi":"80155|BIBLIOTECA_LLOREDA","municipi":"Badalona","codi_municipi":"80155","latitud":"41.44993584","longitud":"2.230616755","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Av. Catalunya, 56-62","informacio_web":"https://www.badalona.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-w7ps-kvxf.hfii",":version":"rv-wprc_nzg8~nemy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Pomar","indicador_refugi":"80155|BIBLIOTECA_POMAR","municipi":"Badalona","codi_municipi":"80155","latitud":"41.46478509","longitud":"2.25046354","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Av.Primer de Maig, s/n","informacio_web":"https://www.badalona.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-iqsv_pbav_jnj3",":version":"rv-wbft.qs6d~t7ei",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Canyad\xf3 i Casagemes","indicador_refugi":"80155|BIBLIOTECA_CANYADO_I_CASAGEMES","municipi":"Badalona","codi_municipi":"80155","latitud":"41.45627424","longitud":"2.257127046","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Jacinto Benavente, 3","informacio_web":"https://www.badalona.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-u2wd_sqke.drsg",":version":"rv-nu7j~2uvi.xmuf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Cultural El Carme","indicador_refugi":"80155|CENTRE_CULTURAL_EL_CARME","municipi":"Badalona","codi_municipi":"80155","latitud":"41.45075166","longitud":"2.248552354","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Francesc Layret, 78","informacio_web":"https://www.badalona.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-crbf_rqde.cs2j",":version":"rv-ktp5.myiu-nb8d",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la Solidaritat Can Pepus","indicador_refugi":"80155|CASAL_DE_LA_SOLIDARITAT_CAN_PEPUS","municipi":"Badalona","codi_municipi":"80155","latitud":"41.44613092","longitud":"2.240498199","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Francesc Maci\xe0, 104","informacio_web":"https://www.badalona.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-brx8_n5rg~wepg",":version":"rv-zt6t-em4t~i7a6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Nelson Mandela","indicador_refugi":"80155|PARC_DE_NELSON_MANDELA","municipi":"Badalona","codi_municipi":"80155","latitud":"41.45550101","longitud":"2.239148167","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Migjorn, 67A","informacio_web":"https://www.badalona.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-erxa~9x79~8i2h",":version":"rv-q8s4-a2gm~735y",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Nova Lloreda","indicador_refugi":"80155|PARC_DE_NOVA_LLOREDA","municipi":"Badalona","codi_municipi":"80155","latitud":"41.45001341","longitud":"2.231893304","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"Rambla de Sant Joan","informacio_web":"https://www.badalona.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-66nz~qnzx~tgwk",":version":"rv-ptfq-4egu_h6cs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Torrents i Llad\xf3","indicador_refugi":"80155|PARC_TORRENTS_I_LLADO","municipi":"Badalona","codi_municipi":"80155","latitud":"41.4617382","longitud":"2.239429234","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Mart\xed Pujol, 614","informacio_web":"https://www.badalona.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-24w2.rmcd.yqjd",":version":"rv-vziz~kiqz~v4tq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Amistat","indicador_refugi":"80155|PLACA_AMISTAT","municipi":"Badalona","codi_municipi":"80155","latitud":"41.43872475","longitud":"2.21953006","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Reus, s/n","informacio_web":"https://www.badalona.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-rywx_t3ti.39xh",":version":"rv-w5mv~cxtp_j5gk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La CIBA","indicador_refugi":"82457|LA_CIBA","municipi":"Santa Coloma de Gramenet","codi_municipi":"82457","latitud":"41.44996063","longitud":"2.203528768","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Pg. de Lloren\xe7 Serra, 64","informacio_web":"https://www.gramenet.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-z7j3_a5kp.qq39",":version":"rv-w7ry-4nyr-v5d7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Municipal de Can  Millars (recepci\xf3)","indicador_refugi":"80734|PISCINA_MUNICIPAL_DE_CAN_MILLARS_RECEPCIO","municipi":"Cornell\xe0 de Llobregat","codi_municipi":"80734","latitud":"41.35609647","longitud":"2.076811627","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Bonavista, 70","informacio_web":"https://www.cornella.cat/","tipologia":"Equipament esportiu","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ezze_e6ab.3ym8",":version":"rv-tidb.6puz_xphs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat de Sant Ildefons","indicador_refugi":"80734|MERCAT_DE_SANT_ILDEFONS","municipi":"Cornell\xe0 de Llobregat","codi_municipi":"80734","latitud":"41.36215786","longitud":"2.083292638","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Av. de Sant Ildefons, s/n","informacio_web":"https://www.cornella.cat/","tipologia":"Mercat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jihm.a4ue.a42w",":version":"rv-9vyb~bsjp_95y3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat Centre","indicador_refugi":"80734|MERCAT_CENTRE","municipi":"Cornell\xe0 de Llobregat","codi_municipi":"80734","latitud":"41.35323231","longitud":"2.071476572","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Pl. Llu\xeds Companys, s/n","informacio_web":"https://www.cornella.cat/","tipologia":"Mercat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-6zvj.n2bg_824t",":version":"rv-az4n.99kh~cb6a",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat Mersans","indicador_refugi":"80734|MERCAT_MERSANS","municipi":"Cornell\xe0 de Llobregat","codi_municipi":"80734","latitud":"41.36125072","longitud":"2.075218387","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Pl. Marsans, s/n","informacio_web":"https://www.cornella.cat/","tipologia":"Mercat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3m3q.kw4u_uem8",":version":"rv-zxmm~hav2-xciy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Cultura","indicador_refugi":"81944|CASAL_DE_CULTURA","municipi":"Sant Adri\xe0 del Bes\xf2s","codi_municipi":"81944","latitud":"41.42669993","longitud":"2.223430226","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Mare de D\xe9u del Carme, 22","informacio_web":"https://www.sant-adria.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-m4hc_whd3_5e7c",":version":"rv-z6f8.xrmr_fd8j",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Gent Gran de Via Trajana","indicador_refugi":"81944|CASAL_DE_GENT_GRAN_DE_VIA_TRAJANA","municipi":"Sant Adri\xe0 del Bes\xf2s","codi_municipi":"81944","latitud":"41.42676382","longitud":"2.208476453","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Av. Ferrocarril, 11-13","informacio_web":"https://www.sant-adria.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-fnee.d5ic~j9d5",":version":"rv-th39-28hv-kfu6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Mamut-Venux","indicador_refugi":"82634|PARC_DEL_MAMUT_VENUX","municipi":"Sant Vicen\xe7 dels Horts","codi_municipi":"82634","latitud":"41.39733584","longitud":"2.009974385","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. Sant Boi, 59","informacio_web":"https://svh.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-fcfc.s886-2xxx",":version":"rv-ab9h_txjp.jziv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casa de la Vila","indicador_refugi":"82634|CASA_DE_LA_VILA","municipi":"Sant Vicen\xe7 dels Horts","codi_municipi":"82634","latitud":"41.39325189","longitud":"2.009574552","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Pl. de la Vila, 1","informacio_web":"https://svh.cat/","tipologia":"Ajuntament","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-w2qt~dgtd~2w6j",":version":"rv-ww6s_2sm3~hisa",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Cultural i C\xedvic Virg\xednia Amposta","indicador_refugi":"82634|CENTRE_CULTURAL_I_CIVIC_VIRGINIA_AMPOSTA","municipi":"Sant Vicen\xe7 dels Horts","codi_municipi":"82634","latitud":"41.39822409","longitud":"2.009559673","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Antoni Mampel, 1-3","informacio_web":"https://svh.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-egbm~9trf-kia2",":version":"rv-dnwq.xy9e-cwnk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic de la Gu\xe0rdia","indicador_refugi":"82634|CENTRE_CIVIC_DE_LA_GUARDIA","municipi":"Sant Vicen\xe7 dels Horts","codi_municipi":"82634","latitud":"41.3909864","longitud":"2.003831045","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Mestre Ramon Camps, 86","informacio_web":"https://svh.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ex79.wme2.c6ez",":version":"rv-ung5~v9bs-ze4d",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Municipal Les Voltes","indicador_refugi":"82634|BIBLIOTECA_MUNICIPAL_LES_VOLTES","municipi":"Sant Vicen\xe7 dels Horts","codi_municipi":"82634","latitud":"41.39300429","longitud":"2.011483821","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Nou, 7","informacio_web":"https://svh.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-y6sc~cufy.4eqq",":version":"rv-su6j~ymst_xp6k",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Social El Mil\xb7lenari","indicador_refugi":"82212|CENTRE_SOCIAL_EL_MIL_LENARI","municipi":"Sant Just Desvern","codi_municipi":"82212","latitud":"41.38362993","longitud":"2.079374469","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. d\u2019\xc0ngel Guimer\xe0, 1","informacio_web":"https://santjust.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ke97_zzht_wbwj",":version":"rv-ch8u-gwpi~vmud",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic\xa0Salvador Espriu","indicador_refugi":"82212|CENTRE_CIVIC_SALVADOR_ESPRIU","municipi":"Sant Just Desvern","codi_municipi":"82212","latitud":"41.38189102","longitud":"2.070347415","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Tudona, s/n","informacio_web":"https://santjust.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-y422_wfhh~dcsy",":version":"rv-z2vk.ygtg~wrhs",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Joan Margarit","indicador_refugi":"82212|BIBLIOTECA_JOAN_MARGARIT","municipi":"Sant Just Desvern","codi_municipi":"82212","latitud":"41.38689802","longitud":"2.075623992","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Carles Mercader, 17","informacio_web":"https://santjust.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-gq2b-6j7r_g2uk",":version":"rv-kbfs~6aat-nykq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Soledat Sans Serafini","indicador_refugi":"82212|CENTRE_CIVIC_SOLEDAT_SANS_SERAFINI","municipi":"Sant Just Desvern","codi_municipi":"82212","latitud":"41.38790912","longitud":"2.061872851","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Maria Montessori, 2","informacio_web":"https://santjust.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-mtbr~3cqq_ybfr",":version":"rv-cfkm.m8xk_v4mf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Joan Maragall","indicador_refugi":"82212|CENTRE_CIVIC_JOAN_MARAGALL","municipi":"Sant Just Desvern","codi_municipi":"82212","latitud":"41.38172146","longitud":"2.080306829","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Major, 17","informacio_web":"https://santjust.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-c2s8~s4ue_9thg",":version":"rv-6bex_nv5h.qzi7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament","indicador_refugi":"82444|AJUNTAMENT","municipi":"Santa Coloma de Cervell\xf3","codi_municipi":"82444","latitud":"41.36884541","longitud":"2.016175633","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Pau Casals, 26-34","informacio_web":"https://www.santacolomadecervello.cat/","tipologia":"Ajuntament","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ddvn-k9m9_9qbp",":version":"rv-4kx4~jj94~xxsd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Camet de la Colonia G\xfcell","indicador_refugi":"82444|CAMET_DE_LA_COLONIA_GUELL","municipi":"Santa Coloma de Cervell\xf3","codi_municipi":"82444","latitud":"41.36190064","longitud":"2.02898969","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Barrau, s/n","informacio_web":"https://www.santacolomadecervello.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-u4u4.b9vv-tyvt",":version":"rv-b3qc-9mf9_uza8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal Col\xf2nia G\xfcell","indicador_refugi":"82444|CASAL_COLONIA_GUELL","municipi":"Santa Coloma de Cervell\xf3","codi_municipi":"82444","latitud":"41.36222075","longitud":"2.027584687","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Claudi G\xfcell, 1","informacio_web":"https://www.santacolomadecervello.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-sk4y~qf5u-jgp8",":version":"rv-35qr-xkqj~6bzq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Can Corts","indicador_refugi":"80734|PARC_DE_CAN_CORTS","municipi":"Cornell\xe0 de Llobregat","codi_municipi":"80734","latitud":"41.36132577","longitud":"2.065378923","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Can Corts, 38A","informacio_web":"https://refugisclimatics.amb.cat","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-h3qq-mgfx-npcu",":version":"rv-8bjd_sr2a~isd5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la  Gent Gran Gavarra","indicador_refugi":"80734|CASAL_DE_LA_GENT_GRAN_GAVARRA","municipi":"Cornell\xe0 de Llobregat","codi_municipi":"80734","latitud":"41.35882133","longitud":"2.072706471","adreca":"C. Bellaterra, 2","informacio_web":"https://www.cornella.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-reyg_hhpw~uh9q",":version":"rv-6itz.3vfy.mxey",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Tovalloles","indicador_refugi":"82114|CENTRE_CIVIC_TOVALLOLES","municipi":"Sant Feliu de Llobregat","codi_municipi":"82114","latitud":"41.38609382","longitud":"2.04496761","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Riera de la Salut, 7","informacio_web":"https://www.santfeliu.cat/go.faces?xmid=1","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-xrah-kdhx_x3x7",":version":"rv-sh6q-dghk-qmqj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Civic Mas Llu\xed","indicador_refugi":"82114|CENTRE_CIVIC_MAS_LLUI","municipi":"Sant Feliu de Llobregat","codi_municipi":"82114","latitud":"41.38554311","longitud":"2.053520957","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Carrer Estel\xed, 10-12","informacio_web":"https://www.santfeliu.cat/go.faces?xmid=1","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ffe6~dhpk-d8tn",":version":"rv-v893.v77g.9kjv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc i piscines de la Muntanyeta","indicador_refugi":"82009|PARC_I_PISCINES_DE_LA_MUNTANYETA","municipi":"Sant Boi de Llobregat","codi_municipi":"82009","latitud":"41.34006053","longitud":"2.032031195","accessibilitat":"S\xcd","adreca":"Ronda  Sant Ramon, 155","informacio_web":"https://www.santboi.cat/","tipologia":"Piscina","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-vvmp-qrz5_fjce",":version":"rv-mjmr~qfby~pr8m",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines Fontsanta","indicador_refugi":"82172|PISCINES_FONTSANTA","municipi":"Sant Joan Desp\xed","codi_municipi":"82172","latitud":"41.37089134","longitud":"2.070308435","accessibilitat":"S\xcd","adreca":"C. del Marqu\xe8s de Monistrol, 30,","informacio_web":"https://sjdespi.cat/","tipologia":"Piscina","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-q2zu_snic_dtne",":version":"rv-abaq~4hhr_7c4v",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Parc Central","indicador_refugi":"82055|PISCINA_PARC_CENTRAL","municipi":"Sant Cugat del Vall\xe8s","codi_municipi":"82055","latitud":"41.47343595","longitud":"2.076352741","accessibilitat":"S\xcd","adreca":"C. Rovellat, 37","informacio_web":"https://www.santcugat.cat/","tipologia":"Piscina","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-cxqx_7erx_tkaa",":version":"rv-a6be_xfs7_g5pn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina de la Floresta","indicador_refugi":"82055|PISCINA_DE_LA_FLORESTA","municipi":"Sant Cugat del Vall\xe8s","codi_municipi":"82055","latitud":"41.44677887","longitud":"2.070080679","accessibilitat":"S\xcd","adreca":"C. Ginjoler, 6","informacio_web":"https://www.santcugat.cat/","tipologia":"Piscina","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3g5u-ga9d-zu32",":version":"rv-xhuj_wgnq~2g3i",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Valldoreix","indicador_refugi":"82055|PISCINA_VALLDOREIX","municipi":"Sant Cugat del Vall\xe8s","codi_municipi":"82055","latitud":"41.44980675","longitud":"2.056161989","accessibilitat":"S\xcd","adreca":"Pg. Guineu, 36","informacio_web":"info@cevalldoreix.com","tipologia":"Piscina","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-52id_868w.xt4p",":version":"rv-a32j-bxzn_saya",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Complex Esportiu Torribera","indicador_refugi":"82457|COMPLEX_ESPORTIU_TORRIBERA","municipi":"Santa Coloma de Gramenet","codi_municipi":"82457","latitud":"41.46489567","longitud":"2.212778879","accessibilitat":"S\xcd","adreca":"C.Castella, s/n","informacio_web":"https://www.gramenet.cat/","tipologia":"Piscina","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-7vxt_8fyc~m5ve",":version":"rv-ayiq_id5f.7hg9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Complex Esportiu DUIN Can Zam","indicador_refugi":"82457|COMPLEX_ESPORTIU_DUIN_CAN_ZAM","municipi":"Santa Coloma de Gramenet","codi_municipi":"82457","latitud":"41.45524026","longitud":"2.203084047","accessibilitat":"S\xcd","adreca":"C. V\xedctor Hugo, s/n","informacio_web":"https://www.gramenet.cat/","tipologia":"Piscina","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ekqq-wp54.74e9",":version":"rv-crzs_5rm3.egad",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Municipal Les fontetes Turonet","indicador_refugi":"82665|PISCINA_MUNICIPAL_LES_FONTETES_TURONET","municipi":"Cerdanyola del Vall\xe8s","codi_municipi":"82665","latitud":"41.48611929","longitud":"2.145363143","accessibilitat":"S\xcd","adreca":"C. Pizarro, s/n","informacio_web":"https://www.cerdanyola.cat/","tipologia":"Piscina","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-f5p5_thh6_utsk",":version":"rv-9kgs~pjpv_zuhu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Zona esportiva municipal bosc tancat","indicador_refugi":"82665|ZONA_ESPORTIVA_MUNICIPAL_BOSC_TANCAT","municipi":"Cerdanyola del Vall\xe8s","codi_municipi":"82665","latitud":"41.50213709","longitud":"2.129873209","accessibilitat":"S\xcd","adreca":"C. Riu Sec, s/n","informacio_web":"https://www.cerdanyola.cat/","tipologia":"Piscina","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-m8x5_bgr7~26ar",":version":"rv-m3uk.dwpp.ysc8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Municipal Montflorit","indicador_refugi":"82665|PISCINA_MUNICIPAL_MONTFLORIT","municipi":"Cerdanyola del Vall\xe8s","codi_municipi":"82665","latitud":"41.48110298","longitud":"2.130773308","accessibilitat":"S\xcd","adreca":"C. Mare de D\xe9u dels Dolors, 19","informacio_web":"https://www.cerdanyola.cat/","tipologia":"Piscina","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-njy9.hyz5_j3ia",":version":"rv-k8i9-qza4.2z57",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal de Sant Antoni - La Blava","indicador_refugi":"82634|PISCINA_MUNICIPAL_DE_SANT_ANTONI_LA_BLAVA","municipi":"Sant Vicen\xe7 dels Horts","codi_municipi":"82634","latitud":"41.38332668","longitud":"1.994980581","accessibilitat":"S\xcd","adreca":"Avi. Mas Pic\xf3, s/n","informacio_web":"https://svh.cat/","tipologia":"Piscina","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-5jky.2uxm.2fvi",":version":"rv-j5uz~k65m_n9bu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Can Via","indicador_refugi":"82444|PISCINA_CAN_VIA","municipi":"Santa Coloma de Cervell\xf3","codi_municipi":"82444","latitud":"41.36559935","longitud":"2.007715558","accessibilitat":"S\xcd","adreca":"C. Rossinyol, 20","informacio_web":"https://www.santacolomadecervello.cat/","tipologia":"Piscina","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-we3c.2546.wv36",":version":"rv-ghii.v6y7-s7t5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscines exteriors de les Instal\xb7lacions Esportives Municipals","indicador_refugi":"89045|PISCINES_EXTERIORS_DE_LES_INSTAL_LACIONS_ESPORTIVES_MUNICIPALS","municipi":"Badia del Vall\xe8s","codi_municipi":"89045","latitud":"41.51445824","longitud":"2.113236627","accessibilitat":"S\xcd","adreca":"Av. Tibidabo","informacio_web":"https://www.badiadelvalles.cat/","tipologia":"Piscina","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-99ap~mu8t~tp85",":version":"rv-wspu.2eiq.j7t4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Municipal Can Bar\xf3","indicador_refugi":"80728|BIBLIOTECA_MUNICIPAL_CAN_BARO","municipi":"Corbera de Llobregat","codi_municipi":"80728","latitud":"41.41486587","longitud":"1.931144771","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"C. Sant Salvador, 25","informacio_web":"https://www.corberadellobregat.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-kyuu-86xw.cfu2",":version":"rv-8r5f-y7rb-tpme",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la gent gran Les Magn\xf2lies","indicador_refugi":"80728|CASAL_DE_LA_GENT_GRAN_LES_MAGNOLIES","municipi":"Corbera de Llobregat","codi_municipi":"80728","latitud":"41.41259978","longitud":"1.928281808","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"C. Progr\xe9s, 1","informacio_web":"https://www.corberadellobregat.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-mw8e-xf28_69ri",":version":"rv-pquh~52is-qpuv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de les Palmeres","indicador_refugi":"80728|PARC_DE_LES_PALMERES","municipi":"Corbera de Llobregat","codi_municipi":"80728","latitud":"41.41681685","longitud":"1.920439443","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Raval, 26","informacio_web":"https://refugisclimatics.amb.cat","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-tvz4~7zvq-uwtq",":version":"rv-7etu~4222-zr8y",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Miquel Mart\xed i Pol","indicador_refugi":"80728|PARC_MIQUEL_MARTI_I_POL","municipi":"Corbera de Llobregat","codi_municipi":"80728","latitud":"41.41457086","longitud":"1.922663085","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Josep Tarradellas, 24","informacio_web":"https://www.corberadellobregat.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jku2-sjyp~vn7u",":version":"rv-aam5~e2ct-upp6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Carrer Pau Bruna","indicador_refugi":"81580|PARC_CARRER_PAU_BRUNA","municipi":"Corbera de Llobregat","codi_municipi":"81580","latitud":"41.41518595","longitud":"1.931005329","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Sant Antoni, 24","informacio_web":"https://www.elpapiol.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-uz4z_9vxh-bpdy",":version":"rv-f8qt_tnbb.3e7u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Aig\xfcestortes","indicador_refugi":"81960|BIBLIOTECA_AIGUESTORTES","municipi":"Sant Andreu de la Barca","codi_municipi":"81960","latitud":"41.44941853","longitud":"1.967279732","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Av. Constituci\xf3, 24","informacio_web":"https://www.sabarca.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-8rjn_bntw.3r9g",":version":"rv-sks4~i2iv.udq6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la Gent gran Mar\xeda Aurelia Campmany","indicador_refugi":"81960|CASAL_DE_LA_GENT_GRAN_MARIA_AURELIA_CAMPMANY","municipi":"Sant Andreu de la Barca","codi_municipi":"81960","latitud":"41.45082219","longitud":"1.970490826","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Pg.  Generalitat, 0","informacio_web":"https://www.sabarca.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-sqaq-233n~ymrt",":version":"rv-2kc6~j2sw.dv5q",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ajuntament","indicador_refugi":"81960|AJUNTAMENT","municipi":"Sant Andreu de la Barca","codi_municipi":"81960","latitud":"41.45007775","longitud":"1.971295807","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Pl. Ajuntament, 1","informacio_web":"https://www.sabarca.cat/","tipologia":"Ajuntament","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-xjmi~nkgt-f2g6",":version":"rv-jf8j~4kxz.8ziy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre de Recursos Associatius","indicador_refugi":"81960|CENTRE_DE_RECURSOS_ASSOCIATIUS","municipi":"Sant Andreu de la Barca","codi_municipi":"81960","latitud":"41.44712012","longitud":"1.974563038","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Pl. Anselm Clav\xe9, 12","informacio_web":"https://www.sabarca.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-nm94-pupa~wdj6",":version":"rv-sssk_nmk8-gajj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina d\u2019estiu de Can Salvi","indicador_refugi":"81960|PISCINA_D_ESTIU_DE_CAN_SALVI","municipi":"Sant Andreu de la Barca","codi_municipi":"81960","latitud":"41.44832551","longitud":"1.962790045","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"Si","adreca":"Av. Constituci\xf3, 0","informacio_web":"https://www.sabarca.cat/","tipologia":"Piscina","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-az4a-ndjv_y5dz",":version":"rv-uaei~6rwp-6kas",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Solana","indicador_refugi":"81960|PARC_SOLANA","municipi":"Sant Andreu de la Barca","codi_municipi":"81960","latitud":"41.44745952","longitud":"1.977886267","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","adreca":"C.l Doctor Vila, 11","informacio_web":"https://refugisclimatics.amb.cat","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-skg7~ek4t.eq3i",":version":"rv-eyqi.yquw-yeny",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Central","indicador_refugi":"81960|PARC_CENTRAL","municipi":"Sant Andreu de la Barca","codi_municipi":"81960","latitud":"41.45007239","longitud":"1.969519778","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","adreca":"Parc Central","informacio_web":"https://www.sabarca.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-mn87_heph-n38z",":version":"rv-z4bt.y32b.g5tn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina municipal","indicador_refugi":"80207|PISCINA_MUNICIPAL","municipi":"Begues","codi_municipi":"80207","latitud":"41.33817821","longitud":"1.920751027","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"Si","adreca":"C.Vallirana, s/n","informacio_web":"https://www.begues.cat/","tipologia":"Piscina","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-uxza.awxk-hww7",":version":"rv-cn4f_j9tf~gx4n",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre civic El Roure","indicador_refugi":"80207|CENTRE_CIVIC_EL_ROURE","municipi":"Begues","codi_municipi":"80207","latitud":"41.33044999","longitud":"1.918214272","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Pl. 1 d\'Octubre de 2017, 1","informacio_web":"https://www.begues.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-xiek_4n6c_22cz",":version":"rv-ezxn.ybug_gape",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca la Ginesta","indicador_refugi":"80207|BIBLIOTECA_LA_GINESTA","municipi":"Begues","codi_municipi":"80207","latitud":"41.33041439","longitud":"1.9181651","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"Si","adreca":"Pl. 1 d\'Octubre de 2017, 1","informacio_web":"https://www.begues.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3ddp~saax~3fkr",":version":"rv-w542~aezj~trq5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"l\'Escorxador","indicador_refugi":"80207|L_ESCORXADOR","municipi":"Begues","codi_municipi":"80207","latitud":"41.3309081","longitud":"1.91850168","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Av. Sitges, 12","informacio_web":"https://www.begues.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-cgh2~5jnc-rzt5",":version":"rv-pqzf.eg9i-rp6q",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"El Fixu Espai Jove El Fixu","indicador_refugi":"80207|EL_FIXU_ESPAI_JOVE_EL_FIXU","municipi":"Begues","codi_municipi":"80207","latitud":"41.33840225","longitud":"1.920550225","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"C. de Vallirana, s/n","informacio_web":"https://www.begues.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3pma~sz2c~hcxd",":version":"rv-vpqv-srea.2q43",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"OAC Cal Pere Vell","indicador_refugi":"80207|OAC_CAL_PERE_VELL","municipi":"Begues","codi_municipi":"80207","latitud":"41.33084156","longitud":"1.92228974","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"C. Major, 14","informacio_web":"https://www.begues.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jjnk_eq3v~gvhw",":version":"rv-2xa8-pqan.pv4v",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CEM La Plana","indicador_refugi":"80771|CEM_LA_PLANA","municipi":"Esplugues de Llobregat","codi_municipi":"80771","latitud":"41.37463015","longitud":"2.088212655","accessibilitat":"Si","climatitzacio":"Si","area_descans":"S\xed","lavabo":"No","adreca":"Pla\xe7a Catalunya, s/n","informacio_web":"https://www.esplugues.cat/","tipologia":"Equipament esportiu","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-9rnn_r6r6.sguu",":version":"rv-bu6u-yvvg~mz45",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Parc Torrents","indicador_refugi":"80771|PISCINA_PARC_TORRENTS","municipi":"Esplugues de Llobregat","codi_municipi":"80771","latitud":"41.37495173","longitud":"2.090795396","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"Si","adreca":"Torrent d\'en Farr\xe9 (rampes d\'acc\xe9s des de pl. Catalunya, av. Cornell\xe0 i des del Jard\xed del Mirador)","informacio_web":"https://www.esplugues.cat/","tipologia":"Piscina","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-abru~dj8h_mats",":version":"rv-jf3v_nz4k-pi2m",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Pare Miquel d\'Esplugues","indicador_refugi":"80771|BIBLIOTECA_PARE_MIQUEL_D_ESPLUGUES","municipi":"Esplugues de Llobregat","codi_municipi":"80771","latitud":"41.37604604","longitud":"2.08147356","accessibilitat":"Si","climatitzacio":"Si","area_descans":"S\xed","lavabo":"No","adreca":"Carrer d\'\xc0ngel Guimer\xe0, 106","informacio_web":"https://www.esplugues.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ufe7_8px9-x693",":version":"rv-674h_hqbh~w5q8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mercat La Plana","indicador_refugi":"80771|MERCAT_LA_PLANA","municipi":"Esplugues de Llobregat","codi_municipi":"80771","latitud":"41.37271396","longitud":"2.084401083","accessibilitat":"Si","climatitzacio":"Si","area_descans":"S\xed","lavabo":"No","adreca":"Avinguda de Cornell\xe0, 87","informacio_web":"https://www.esplugues.cat/","tipologia":"Mercat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-9b6b~pibm_u4vq",":version":"rv-4rbt~ff74-ej38",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Edifici Mol\xed","indicador_refugi":"80771|EDIFICI_MOLI","municipi":"Esplugues de Llobregat","codi_municipi":"80771","latitud":"41.3726023","longitud":"2.097376168","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","adreca":"Carrer Verge de la Merc\xe8 1","informacio_web":"https://www.esplugues.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-zmk9_3th3_z5dv",":version":"rv-kdfi~v7e2~wc52",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"La Baronda","indicador_refugi":"80771|LA_BARONDA","municipi":"Esplugues de Llobregat","codi_municipi":"80771","latitud":"41.37554059","longitud":"2.090424094","accessibilitat":"Si","climatitzacio":"Si","area_descans":"S\xed","lavabo":"No","adreca":"Carrer de la Riba, 36","informacio_web":"https://www.esplugues.cat/","tipologia":"ajuntament","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-enqk-kc32_y9dn",":version":"rv-gfku~3ick~xghg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins del Parc Sanitari Sant Joan de D\xe9u","indicador_refugi":"82009|JARDINS_DEL_PARC_SANITARI_SANT_JOAN_DE_DEU","municipi":"Sant Boi de Llobregat","codi_municipi":"82009","latitud":"41.35305327","longitud":"2.032034112","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"Si","adreca":"C.Dr. Antoni Pujadas, 42","informacio_web":"https://www.santboi.cat/","tipologia":"Privat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-tfxk.7th3~rk2u",":version":"rv-auzh.8wvd_urt4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Jardins de la Pau","indicador_refugi":"81691|CENTRE_CIVIC_JARDINS_DE_LA_PAU","municipi":"El Prat de Llobregat","codi_municipi":"81691","latitud":"41.32244192","longitud":"2.09880456","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Jardins de la Pau, s/n","informacio_web":"https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-q8ep~ep83_y24z",":version":"rv-y3pk_kajb~cxex",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Sant Jordi - Ribera Baixa","indicador_refugi":"81691|CENTRE_CIVIC_SANT_JORDI_RIBERA_BAIXA","municipi":"El Prat de Llobregat","codi_municipi":"81691","latitud":"41.3198033","longitud":"2.086258237","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"C. Dolores Ibarruri, 45","informacio_web":"https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ae7w-nq4n-gqgw",":version":"rv-2ha3~y5qw-wu9x",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Cultural El Remolar","indicador_refugi":"81691|CENTRE_CULTURAL_EL_REMOLAR","municipi":"El Prat de Llobregat","codi_municipi":"81691","latitud":"41.32349637","longitud":"2.090020597","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"C.Ramon Llull, 12","informacio_web":"https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-etae.tsjc~sa8b",":version":"rv-ejd9_mvjk.pnnb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"C\xe8ntric Espai Cultural","indicador_refugi":"81691|CENTRIC_ESPAI_CULTURAL","municipi":"El Prat de Llobregat","codi_municipi":"81691","latitud":"41.32224613","longitud":"2.094016207","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Pl. Catalunya, 39-41","informacio_web":"https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-2pr3~auj8.i6hh",":version":"rv-pfeg~58qu_hvnq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Palmira Dom\xe8nech","indicador_refugi":"81691|CENTRE_CIVIC_PALMIRA_DOMENECH","municipi":"El Prat de Llobregat","codi_municipi":"81691","latitud":"41.33025674","longitud":"2.100560424","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"C. Lo Gaiter del Llobregat, 112","informacio_web":"https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-9vbw~ptvy-7nzc",":version":"rv-p3mh~r683.datj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre de Promoci\xf3 Econ\xf2mica","indicador_refugi":"81691|CENTRE_DE_PROMOCIO_ECONOMICA","municipi":"El Prat de Llobregat","codi_municipi":"81691","latitud":"41.32995944","longitud":"2.103740383","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"C. de les Moreres, 48","informacio_web":"https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-qfeg~szfp.uamz",":version":"rv-wyaf-2p4v~3w5z",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Cases d\'en Puig - edifici annex","indicador_refugi":"81691|CASES_D_EN_PUIG_EDIFICI_ANNEX","municipi":"El Prat de Llobregat","codi_municipi":"81691","latitud":"41.32465378","longitud":"2.093193792","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Pl. Agricultura, 4","informacio_web":"https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-gcse.i8hy_4rwj",":version":"rv-ifei_mce6-9zs3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CEM Estruch","indicador_refugi":"81691|CEM_ESTRUCH","municipi":"El Prat de Llobregat","codi_municipi":"81691","latitud":"41.32844242","longitud":"2.104124013","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Av.Pare Andreu de Palma, 9","informacio_web":"https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics","tipologia":"Equipament esportiu","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-44ej_zd6s_tevt",":version":"rv-5zt7~dw5x.z6iz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CEM Sagnier","indicador_refugi":"81691|CEM_SAGNIER","municipi":"El Prat de Llobregat","codi_municipi":"81691","latitud":"41.32156205","longitud":"2.082727012","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"C. Frederica Montseny","informacio_web":"https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics","tipologia":"Equipament esportiu","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-cm4t-b83t-mwi7",":version":"rv-axun.3s2d.iizq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Municipal de Vela","indicador_refugi":"81691|CENTRE_MUNICIPAL_DE_VELA","municipi":"El Prat de Llobregat","codi_municipi":"81691","latitud":"41.28783567","longitud":"2.105818112","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Pg. Platja, 3","informacio_web":"https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics","tipologia":"Equipament esportiu","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-6rxm.yh3d_5vd8",":version":"rv-ggai-uxg6~jxz2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de Pere Calders","indicador_refugi":"81691|PLACA_DE_PERE_CALDERS","municipi":"El Prat de Llobregat","codi_municipi":"81691","latitud":"41.32581249","longitud":"2.103915007","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Pl. Pere Calders","informacio_web":"https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-hx4c-hssy.wkvp",":version":"rv-bxb4.fnft-maki",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de l\'Estany de Sant Maurici","indicador_refugi":"81691|PLACA_DE_L_ESTANY_DE_SANT_MAURICI","municipi":"El Prat de Llobregat","codi_municipi":"81691","latitud":"41.32131522","longitud":"2.092354012","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Pl. de l\'Estany de Sant Maurici","informacio_web":"https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-7tnq_kjd2_dkm2",":version":"rv-9v6v-3wq7~tqfu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Solidaritat","indicador_refugi":"81691|PARC_DE_LA_SOLIDARITAT","municipi":"El Prat de Llobregat","codi_municipi":"81691","latitud":"41.32223126","longitud":"2.084537488","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Av. Verge de Montserrat, 254","informacio_web":"https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-83pj_7cfc_2yup",":version":"rv-xsid~ag7d~pyar",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de la Pau","indicador_refugi":"81691|JARDINS_DE_LA_PAU","municipi":"El Prat de Llobregat","codi_municipi":"81691","latitud":"41.32140538","longitud":"2.0975214","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Jardins de la Pau","informacio_web":"https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jbjd_7ksm-w9sx",":version":"rv-h49e~thrc_3b9h",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Fondo d\u2019en Peixo","indicador_refugi":"81691|FONDO_D_EN_PEIXO","municipi":"El Prat de Llobregat","codi_municipi":"81691","latitud":"41.32805431","longitud":"2.090605896","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"C. Pened\xe8s, s/n","informacio_web":"https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-esps.fhtx_urtk",":version":"rv-yhtt-fjjs-2yx2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de Louis Braille","indicador_refugi":"81691|PLACA_DE_LOUIS_BRAILLE","municipi":"El Prat de Llobregat","codi_municipi":"81691","latitud":"41.32551218","longitud":"2.103046453","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Pl. Louis Braille","informacio_web":"https://www.elprat.cat/ciutat-i-territori/emergencia-climatica/refugis-climatics","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-qfkh_73mu_gd33",":version":"rv-47p8-vw4e~e8jv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai Dioptra","indicador_refugi":"82824|ESPAI_DIOPTRA","municipi":"Tiana","codi_municipi":"82824","latitud":"41.4832183","longitud":"2.271692001","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"C. Cals Frares, 29","informacio_web":"https://tiana.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-zjj7-xadx.mg5u",":version":"rv-sqne.hve6-7n22",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"CEM Bonaigua","indicador_refugi":"82212|CEM_BONAIGUA","municipi":"Sant Just Desvern","codi_municipi":"82212","latitud":"41.39051965","longitud":"2.075394362","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","adreca":"Pg.Muntanya, 25","informacio_web":"https://santjust.cat/","tipologia":"Equipament esportiu","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-dpa5~87tx-7f6g",":version":"rv-4nzt~7s2w_mwpw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Can Comamala","indicador_refugi":"82634|CAN_COMAMALA","municipi":"Sant Vicen\xe7 dels Horts","codi_municipi":"82634","latitud":"41.39624767","longitud":"2.008082188","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"C. Moss\xe8n Jacint Verdaguer, 105-113","informacio_web":"https://svh.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-248k~3zmg-9ffk",":version":"rv-52ur-rkyk_rebg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Moli dels Frares","indicador_refugi":"82634|MOLI_DELS_FRARES","municipi":"Sant Vicen\xe7 dels Horts","codi_municipi":"82634","latitud":"41.40332415","longitud":"2.000896801","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"C. C, 1","informacio_web":"https://svh.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-22pu_bgmw-fias",":version":"rv-dvct_jhzc.ak2f",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Llu\xeds Companys","indicador_refugi":"80543|PLACA_LLUIS_COMPANYS","municipi":"Castellbisbal","codi_municipi":"80543","latitud":"41.47826781","longitud":"1.982101689","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","adreca":"Pl. Llu\xeds Companys","informacio_web":"https://www.castellbisbal.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-8mgk~a3xj-svpy",":version":"rv-6x3y_pvad~v3gx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Neus Catal\xe0- Parc de les Destreses (A, B,C)","indicador_refugi":"80543|PARC_NEUS_CATALA_PARC_DE_LES_DESTRESES_A_B_C","municipi":"Castellbisbal","codi_municipi":"80543","latitud":"41.4723498","longitud":"1.984591636","accessibilitat":"Si, Si, Si","adreca":"C. \xc0ngel Guimer\xe0 - C. Pa\xefsos Catalans, 38","informacio_web":"https://www.castellbisbal.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-4z72~53jr.bvf7",":version":"rv-6axa~u6fn-vy8p",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la Gent Gran","indicador_refugi":"80543|CASAL_DE_LA_GENT_GRAN","municipi":"Castellbisbal","codi_municipi":"80543","latitud":"41.47476114","longitud":"1.981026917","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"C. Sant Joan, 2","informacio_web":"https://www.castellbisbal.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-fv5b_shb9~s7yn",":version":"rv-h5uw_e593.bj7t",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca","indicador_refugi":"80543|BIBLIOTECA","municipi":"Castellbisbal","codi_municipi":"80543","latitud":"41.47482656","longitud":"1.982561825","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"SI","area_descans":"S\xed","lavabo":"Si","adreca":"Av. Pau Casals, 16","informacio_web":"https://www.castellbisbal.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-yiem-tcef-85fy",":version":"rv-ujyd~n2nv_dsg3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Barri de Sant Ildefons","indicador_refugi":"80734|CASAL_DE_BARRI_DE_SANT_ILDEFONS","municipi":"Cornell\xe0 de Llobregat","codi_municipi":"80734","latitud":"41.36644686","longitud":"2.082839826","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"C Mari\xe0 Cub\xed, 111","informacio_web":"https://www.cornella.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-friy~ean9~y2cn",":version":"rv-pxn3.d7f9.gdwj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Municipal","indicador_refugi":"81580|PISCINA_MUNICIPAL","municipi":"El Papiol","codi_municipi":"81580","latitud":"41.43698655","longitud":"2.015304137","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer d\'en Pau Casals, s/n","informacio_web":"https://www.elpapiol.cat/","tipologia":"Piscina","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-caam~qtnd-nwwb",":version":"rv-awjm~ibkf-7rm7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Edifici Ajuntament","indicador_refugi":"81580|EDIFICI_AJUNTAMENT","municipi":"El Papiol","codi_municipi":"81580","latitud":"41.43798745","longitud":"2.011031487","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda de la Generalitat de Catalunya, 7-9","informacio_web":"https://www.elpapiol.cat/","tipologia":"ajuntament","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-vpyc.uqzq~wrwd",":version":"rv-sfca~z37n~7fvi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Valent\xed Almirall","indicador_refugi":"81580|BIBLIOTECA_VALENTI_ALMIRALL","municipi":"El Papiol","codi_municipi":"81580","latitud":"41.44045091","longitud":"2.012501393","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Passatge Parellada, 1","informacio_web":"https://www.elpapiol.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-kceh.8baj_8cpr",":version":"rv-ns59-dgdm~msnc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Municipal de l\'Escorxador","indicador_refugi":"82114|PISCINA_MUNICIPAL_DE_L_ESCORXADOR","municipi":"Sant Feliu de Llobregat","codi_municipi":"82114","latitud":"41.37862365","longitud":"2.040380748","accessibilitat":"S\xcd","adreca":"Carrer Ramon y Cajal, 49","informacio_web":"https://www.santfeliu.cat/go.faces?xmid=1","tipologia":"Piscina","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-mppy-2rqk-x4kh",":version":"rv-p8iw.wavk.fbtv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Les Planes","indicador_refugi":"82172|CENTRE_CIVIC_LES_PLANES","municipi":"Sant Joan Desp\xed","codi_municipi":"82172","latitud":"41.36863407","longitud":"2.074936864","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. de John F.Kennedy, 4,","informacio_web":"https://sjdespi.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-rrgf-ik8v-bgki",":version":"rv-siw2.9vu2_dara",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Can Sostres","indicador_refugi":"82896|PARC_DE_CAN_SOSTRES","municipi":"Torrelles de Llobregat","codi_municipi":"82896","latitud":"41.35674595","longitud":"1.982306314","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","adreca":"C. Papa Joan XXIII, 4","informacio_web":"https://www.torrelles.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-vjcb.hpyb.8tdc",":version":"rv-ddzh-zzfb_hbvk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Municipal","indicador_refugi":"89058|BIBLIOTECA_MUNICIPAL","municipi":"La Palma de Cervell\xf3","codi_municipi":"89058","latitud":"41.41325404","longitud":"1.965644392","adreca":"Pl. Cervantes, 4","informacio_web":"https://www.lapalmadecervello.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-9eyw.k22d.j893",":version":"rv-2uz4~zpah~wngk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Espigol","indicador_refugi":"89058|PARC_ESPIGOL","municipi":"La Palma de Cervell\xf3","codi_municipi":"89058","latitud":"41.41419538","longitud":"1.966631439","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","adreca":"C.Joan XXIII, 2","informacio_web":"https://www.lapalmadecervello.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-a2me-28mp~cmhn",":version":"rv-mim4.b4cz.3v2e",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc l\'Olivera","indicador_refugi":"89058|PARC_L_OLIVERA","municipi":"La Palma de Cervell\xf3","codi_municipi":"89058","latitud":"41.41311736","longitud":"1.969369897","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","adreca":"C. del Canig\xf3, 9","informacio_web":"https://www.lapalmadecervello.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3ydd_bbfx.bjms",":version":"rv-fjnj.28dk_45nv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Complex aqu\xe0tic i esportiu Can Mercader (piscina )","indicador_refugi":"80734|COMPLEX_AQUATIC_I_ESPORTIU_CAN_MERCADER_PISCINA","municipi":"Cornell\xe0 de Llobregat","codi_municipi":"80734","latitud":"41.35861457","longitud":"2.086550248","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Crta de L\'Hospitalet s/n","informacio_web":"https://www.cornella.cat/","tipologia":"Piscina","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-v9eh_d48m-yemv",":version":"rv-djmf.z22f~tdsw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Esportiu Llobregat (piscina)","indicador_refugi":"80734|PARC_ESPORTIU_LLOBREGAT_PISCINA","municipi":"Cornell\xe0 de Llobregat","codi_municipi":"80734","latitud":"41.34796404","longitud":"2.071809891","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"Av. Baix Llobregat, s/n","informacio_web":"https://www.cornella.cat/","tipologia":"Piscina","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-zaxv-br4k.rw26",":version":"rv-skic-754t.eg4u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Millars (piscina)","indicador_refugi":"80734|PISCINA_MILLARS_PISCINA","municipi":"Cornell\xe0 de Llobregat","codi_municipi":"80734","latitud":"41.35609563","longitud":"2.076707258","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Bonavista, 70","informacio_web":"https://www.cornella.cat/","tipologia":"Piscina","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-hgzk~dz22-3c3x",":version":"rv-kh3a_r3et_wdhq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Torreblanca","indicador_refugi":"82212|PARC_DE_TORREBLANCA","municipi":"Sant Just Desvern","codi_municipi":"82212","latitud":"41.37803008","longitud":"2.056170778","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. Reial, 159","informacio_web":"https://refugisclimatics.amb.cat","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-7km4~m6d7_icx7",":version":"rv-9p7c-yrtc-n7tk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Tramvia","indicador_refugi":"82824|PARC_DEL_TRAMVIA","municipi":"Tiana","codi_municipi":"82824","latitud":"41.47110416","longitud":"2.275618429","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"Av. Jordana, 92","informacio_web":"https://refugisclimatics.amb.cat","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ivkz.pfsp~2tgi",":version":"rv-vutc.uigk~dg39",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre C\xedvic Roses","indicador_refugi":"82114|CENTRE_CIVIC_ROSES","municipi":"Sant Feliu de Llobregat","codi_municipi":"82114","latitud":"41.38355267","longitud":"2.053332702","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Tibidabo, 18-20","informacio_web":"https://www.santfeliu.cat/go.faces?xmid=1","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-g9rq.28xj_cjgw",":version":"rv-yg2k_6yb7.6hea",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la Gent Gran","indicador_refugi":"82114|CASAL_DE_LA_GENT_GRAN","municipi":"Sant Feliu de Llobregat","codi_municipi":"82114","latitud":"41.38164796","longitud":"2.048548013","accessibilitat":"S\xcd","aigua":"S\xed","climatitzacio":"S\xcd","area_descans":"S\xed","lavabo":"S\xcd","adreca":"C. Pi i Margall, 45","informacio_web":"https://www.santfeliu.cat/go.faces?xmid=1","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-twnd~tmx4.sac7",":version":"rv-fgqk_y87g-abvh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Municipal Tiana","indicador_refugi":"82824|PISCINA_MUNICIPAL_TIANA","municipi":"Tiana","codi_municipi":"82824","latitud":"41.49125929","longitud":"2.261242404","accessibilitat":"S\xed","aigua":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"C. Eduard Fontser\xe9, s/n.","informacio_web":"https://tiana.cat/","tipologia":"Piscina","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ubg9_zkb6.6mnt",":version":"rv-jxz4.xb9f-mm2y",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de les Moreres","indicador_refugi":"81017|JARDINS_DE_LES_MORERES","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.36731976","longitud":"2.08953765","accessibilitat":"Si","area_descans":"S\xed","lavabo":"No","adreca":"Carrer de l\'Estronci, 36","informacio_web":"https://www.l-h.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ux3i_kjrg~sedz",":version":"rv-ejb4_4js2.y257",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a dels Cirerers","indicador_refugi":"81017|PLACA_DELS_CIRERERS","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.36520246","longitud":"2.089733667","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Pl. dels Cirerers","informacio_web":"https://www.l-h.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jn4e~qrkm.wkuf",":version":"rv-tg46-ni9i.pi4g",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de la Carpa","indicador_refugi":"81017|PLACA_DE_LA_CARPA","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.36667794","longitud":"2.100032855","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Pl. de la Carpa","informacio_web":"https://www.l-h.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ehp9_s5nz.syqh",":version":"rv-kmx7.prxr~9rn3",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Can Creixells","indicador_refugi":"81017|PARC_DE_CAN_CREIXELLS","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.36364153","longitud":"2.103555487","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Riera del Canyet, 43 08906","informacio_web":"https://www.l-h.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-9d2w~v37k~w5rx",":version":"rv-avz7.zcbi_qm7c",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Serp","indicador_refugi":"81017|PARC_DE_LA_SERP","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.36188009","longitud":"2.10892334","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Carrer de Seg\xf2via, 2, 08901","informacio_web":"https://www.l-h.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-4f4x~bt54.v4me",":version":"rv-kk27~mqgx_ruan",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de Llu\xeds Companys","indicador_refugi":"81017|PLACA_DE_LLUIS_COMPANYS","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.35959021","longitud":"2.103071996","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Pl. de Llu\xeds Companys, 08901","informacio_web":"https://www.l-h.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wzjb.dau7.d6eu",":version":"rv-5rnr.qyam~fz5z",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de Can Sumarro","indicador_refugi":"81017|JARDINS_DE_CAN_SUMARRO","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.36035504","longitud":"2.096453173","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Carrer de Barcelona, 2, 08901 L\'Hospitalet de Llobregat","informacio_web":"https://www.l-h.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-aqkw~mmts-n6i9",":version":"rv-xrx2-23ft.mr4b",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Marquesa","indicador_refugi":"81017|PARC_DE_LA_MARQUESA","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.37518897","longitud":"2.117540622","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Carrer de la Riera Blanca, 08903 L\'Hospitalet de Llobregat","informacio_web":"https://www.l-h.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-bj5v_nvgx-djk2",":version":"rv-jcvn-42ix~nu6n",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a d\'Ernest Lluch","indicador_refugi":"81017|PLACA_D_ERNEST_LLUCH","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.37535285","longitud":"2.113555618","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Avinguda de la Granvia de l\u2019Hospitalet, 08902 L\'Hospitalet de Llobregat","informacio_web":"https://www.l-h.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ngba-wec8.n5jp",":version":"rv-2k4e~6v94_6zpn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de Tecla Sala","indicador_refugi":"81017|JARDINS_DE_TECLA_SALA","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.36648517","longitud":"2.116104756","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Avinguda de Josep Tarradellas i Joan, 44, 08901 L\'Hospitalet de Llobregat","informacio_web":"https://www.l-h.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-mua7-8g27_twje",":version":"rv-3wqd~s6gz_ep5t",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Cabana","indicador_refugi":"81017|PARC_DE_LA_CABANA","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.36520666","longitud":"2.1148697","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Carrer d\'Enric Prat de la Riba, 2, 08901 L\'Hospitalet de Llobregat","informacio_web":"https://www.l-h.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-243m.nrms-26vt",":version":"rv-c82y.3a9h-dbzw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de Milagros Consarnau i Sabat\xe9","indicador_refugi":"81017|PLACA_DE_MILAGROS_CONSARNAU_I_SABATE","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.36552235","longitud":"2.129642499","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Carrer de l\'Aprestadora, 08902 L\'Hospitalet de Llobregat","informacio_web":"https://www.l-h.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-rwz5_fje5_ie3y",":version":"rv-h2sg_2k4z~9fc6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Avinguda de Carmen Amaya","indicador_refugi":"81017|AVINGUDA_DE_CARMEN_AMAYA","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.35589422","longitud":"2.117571901","accessibilitat":"Si","area_descans":"S\xed","lavabo":"No","adreca":"Avinguda de Carmen Amaya, 08902 L\'Hospitalet de Llobregat","informacio_web":"https://www.l-h.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-u35v.vvuj~vrwv",":version":"rv-vr9z.5s2i~ny42",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Passeig de Bellvitge","indicador_refugi":"81017|PASSEIG_DE_BELLVITGE","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.35391857","longitud":"2.112557768","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Passeig de Bellvitge, 08907 L\'Hospitalet de Llobregat","informacio_web":"https://www.l-h.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-uerq~9ujs.dn2f",":version":"rv-6xhw~jcju_auph",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Rambla de Marina","indicador_refugi":"81017|RAMBLA_DE_MARINA","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.35133022","longitud":"2.110815534","accessibilitat":"Si","area_descans":"S\xed","lavabo":"No","adreca":"Rambla de la Marina, 08907 L\'Hospitalet de Llobregat","informacio_web":"https://www.l-h.cat/","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-cgap-sxz9_j6zs",":version":"rv-skij~bsaq.9dpp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Bellvitge","indicador_refugi":"81017|PARC_DE_BELLVITGE","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.34868353","longitud":"2.111057279","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Rambla de la Marina, 08907 L\'Hospitalet de Llobregat","informacio_web":"https://www.l-h.cat/","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ynjx_gqq4_si3n",":version":"rv-83cb_en62.x4wq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Nou Casal de Gent Gran de Sant Josep","indicador_refugi":"81017|NOU_CASAL_DE_GENT_GRAN_DE_SANT_JOSEP","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.36093626","longitud":"2.10750808","accessibilitat":"Si","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"C. Migdia, 12 (cantonada amb c. Castillejos) (08901)","informacio_web":"https://www.l-h.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-nubz.yq84.jrzw",":version":"rv-sca7_6m8b_743n",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre de Transformaci\xf3 Digital de l\u2019Hospitalet \xabLa Florida 6.0\\"","indicador_refugi":"81017|CENTRE_DE_TRANSFORMACIO_DIGITAL_DE_L_HOSPITALET_LA_FLORIDA_6_0","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.37051876","longitud":"2.108255976","accessibilitat":"Si","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Av. Primavera, 71, 2n pis (08905)","informacio_web":"https://www.l-h.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-neiv_2iju-wuiw",":version":"rv-jgty~ajgx.h4qu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Oficina Jove de L\u2019Hospitalet","indicador_refugi":"81017|OFICINA_JOVE_DE_L_HOSPITALET","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.34858243","longitud":"2.11005915","accessibilitat":"Si","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"c. Ermita de Bellvitge, 40 (08907)","informacio_web":"https://www.l-h.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-2njm_6a5c-f5ex",":version":"rv-jpex_qpsa_f8zx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal Municipal de Gent Gran de Can Serra","indicador_refugi":"81017|CASAL_MUNICIPAL_DE_GENT_GRAN_DE_CAN_SERRA","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.36743182","longitud":"2.10080697","accessibilitat":"Si","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"c. Castellb\xf3, 45 (08906)","informacio_web":"https://www.l-h.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-eky7-4yyr.2nb2",":version":"rv-baqe-nep8.2fhj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal Municipal de Gent Gran de Santa Eul\xe0lia","indicador_refugi":"81017|CASAL_MUNICIPAL_DE_GENT_GRAN_DE_SANTA_EULALIA","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.3660246","longitud":"2.126267441","accessibilitat":"Si","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Pl. dels Avis, 12 (08902)","informacio_web":"https://www.l-h.cat/","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-czh4-tc2g.5bps",":version":"rv-xqxw_vycs-ez7e",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre d\u2019Art Metropolit\xe0 Tecla Sala","indicador_refugi":"81017|CENTRE_D_ART_METROPOLITA_TECLA_SALA","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.36712205","longitud":"2.11640923","accessibilitat":"Si","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Av. Josep Tarradellas i Joan, 44 (08901)","informacio_web":"https://www.l-h.cat/","tipologia":"Museus","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-darb~zatk-9vda",":version":"rv-yykw-ct8q-a9nq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca de Bellvitge","indicador_refugi":"81017|BIBLIOTECA_DE_BELLVITGE","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.35136856","longitud":"2.11425106","accessibilitat":"Si","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Pl. de la Cultura, 1 (08907)","informacio_web":"https://www.l-h.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-rv35~2i9x-ncki",":version":"rv-wqf9_vbxf~i2x7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca de Can Sumarro","indicador_refugi":"81017|BIBLIOTECA_DE_CAN_SUMARRO","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.35976824","longitud":"2.096243921","accessibilitat":"Si","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"c. Riera de l\u2019Escorxador, 2 (08901)","informacio_web":"https://www.l-h.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ni2m-v3z8.5bb2",":version":"rv-xdeq-db5j.tx6h",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Josep Jan\xe9s","indicador_refugi":"81017|BIBLIOTECA_JOSEP_JANES","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.37455898","longitud":"2.12155649","accessibilitat":"Si","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"c. Dr. Mart\xed i Juli\xe0, 33 (08904)","informacio_web":"https://www.l-h.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-tjxu.qxsq~qkig",":version":"rv-4j9r~u5xe_r28p",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca de La B\xf2bila","indicador_refugi":"81017|BIBLIOTECA_DE_LA_BOBILA","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.37288568","longitud":"2.101042168","accessibilitat":"Si","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Pl. de La B\xf2bila, 1 (08906)","informacio_web":"https://www.l-h.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-is5c~d4p8-vhnc",":version":"rv-6mqx-5m7n-gqfp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca de La Florida","indicador_refugi":"81017|BIBLIOTECA_DE_LA_FLORIDA","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.3696471","longitud":"2.10738257","accessibilitat":"Si","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Av. Masnou, 40 (08905)","informacio_web":"https://www.l-h.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ts8r.ji3k_p4sk",":version":"rv-yrgp_ztm2-swc2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca de la Pla\xe7a Europa","indicador_refugi":"81017|BIBLIOTECA_DE_LA_PLACA_EUROPA","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.35956334","longitud":"2.12288191","accessibilitat":"Si","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Av. Amadeu Torner, 57 (08902)","informacio_web":"https://www.l-h.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-2r5d_qh92_u2qh",":version":"rv-b7jx-8d3w_y2rn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bibliomercat de Santa Eul\xe0lia","indicador_refugi":"81017|BIBLIOMERCAT_DE_SANTA_EULALIA","municipi":"L\'Hospitalet de Llobregat","codi_municipi":"81017","latitud":"41.36586073","longitud":"2.1272105","accessibilitat":"Si","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"c. Muns, 2 - parades del mercat (08902)","informacio_web":"https://www.l-h.cat/","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-4m8b_3ddn.y7xj",":version":"rv-mxe7-ym4m~c9u5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Comercial M\xe0gic Badalona","indicador_refugi":"80155|CENTRE_COMERCIAL_MAGIC_BADALONA","municipi":"Badalona","codi_municipi":"80155","latitud":"41.44436819","longitud":"2.23161754","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Carrer de la Conc\xf2rdia, 1,   08917","informacio_web":"https://www.badalona.cat/","tipologia":"Privat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-fsda~dfg7~9yy2",":version":"rv-pehg.3jbg_7bdb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Comercial Montigal\xe0","indicador_refugi":"80155|CENTRE_COMERCIAL_MONTIGALA","municipi":"Badalona","codi_municipi":"80155","latitud":"41.45567932","longitud":"2.226992045","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Pg d\'Olof Palme, 36, 08917","informacio_web":"https://www.badalona.cat/","tipologia":"Privat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-y95a~nfrt~a7cg",":version":"rv-8cb8-4bug_4rjj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Fundaci\xf3 Ana Ribot","indicador_refugi":"81574|FUNDACIO_ANA_RIBOT","municipi":"Pallej\xe0","codi_municipi":"81574","latitud":"41.42123015","longitud":"1.99870209","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Carrer Vall\xe8s i Ribot, 2, 08780","informacio_web":"www.palleja.cat","tipologia":"Privat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-439t-5q4h_z47r",":version":"rv-ji2w~nx97_p7nf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Europa","indicador_refugi":"83015|PLACA_EUROPA","municipi":"Viladecans","codi_municipi":"83015","latitud":"41.31608034","longitud":"2.021774032","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Carrer de Jaume Balmes, 1B, 08840 Viladecans","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3jzu-csdj-jdvq",":version":"rv-ngrc~i76b~rxfz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Rambla Modolell","indicador_refugi":"83015|RAMBLA_MODOLELL","municipi":"Viladecans","codi_municipi":"83015","latitud":"41.31788092","longitud":"2.019840069","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Rambla de Modolell, 08840 Viladecans","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-n3xq_x2xd_qz83",":version":"rv-cvsp_jqty.ay8w",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Jardins de Magdalena Modolell","indicador_refugi":"83015|JARDINS_DE_MAGDALENA_MODOLELL","municipi":"Viladecans","codi_municipi":"83015","latitud":"41.31623455","longitud":"2.019291974","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Carrer del Sol, 2, 08840 Viladecans","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ffym~dkz7~8a48",":version":"rv-cmb5-9n92~mwve",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a Tete Montoliu","indicador_refugi":"83015|PLACA_TETE_MONTOLIU","municipi":"Viladecans","codi_municipi":"83015","latitud":"41.31037014","longitud":"2.012204249","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Avinguda de Gav\xe0, 58, 08840 Viladecans","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-hfi4.55a7_y6gk",":version":"rv-y5w4_63q2_dhkw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Can Guardiola","indicador_refugi":"83015|PARC_DE_CAN_GUARDIOLA","municipi":"Viladecans","codi_municipi":"83015","latitud":"41.31259587","longitud":"1.998628994","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Carrer de Can Tries, 15, 08840 Viladecans","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-2yjm.9dqk.angr",":version":"rv-2tv8_apxp_d8ra",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bosc de Can Ginestar","indicador_refugi":"83015|BOSC_DE_CAN_GINESTAR","municipi":"Viladecans","codi_municipi":"83015","latitud":"41.32358838","longitud":"2.012349218","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Carrer del Salze / carrer del Roure, 08840 Viladecans","informacio_web":"https://www.viladecans.cat/es/bosque-de-can-ginestar","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-8tds.zepi_f3ev",":version":"rv-fzbp-h8k9~gbq2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Piscina Podium Viladecans - Joan Masgrau","indicador_refugi":"83015|PISCINA_PODIUM_VILADECANS_JOAN_MASGRAU","municipi":"Viladecans","codi_municipi":"83015","latitud":"41.3206735","longitud":"2.022766022","accessibilitat":"Si","aigua":"S\xed","lavabo":"Si","adreca":"Carrer de Pompeu Fabra, 5, 08840 Viladecans","informacio_web":"Podium | Atrium + Podium | Viladecans Esports","tipologia":"Piscina","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-eu7m_4kfp.zcs9",":version":"rv-f9e2.8red~ywkg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Ateneu d\'entitats Pablo Picasso","indicador_refugi":"83015|ATENEU_D_ENTITATS_PABLO_PICASSO","municipi":"Viladecans","codi_municipi":"83015","latitud":"41.32002376","longitud":"2.01760431","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Passatge de Sant Ramon, 2, 08840 Viladecans","informacio_web":"Ateneu d\u2019Entitats Pablo Picasso | Ajuntament de Viladecans","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ysrz.z7tr_tt6x",":version":"rv-zyyc~czgs-ntvp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de barri La Uni\xf3n","indicador_refugi":"83015|CASAL_DE_BARRI_LA_UNION","municipi":"Viladecans","codi_municipi":"83015","latitud":"41.31783924","longitud":"2.012282399","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Carrer del Dos de Maig, 41, 08840 Viladecans","informacio_web":"Casal de Barri la Uni\xf3n | Ajuntament de Viladecans","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-hzdp~x5hu.pmm7",":version":"rv-64xv.uf9s-zykh",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca de Viladecans","indicador_refugi":"83015|BIBLIOTECA_DE_VILADECANS","municipi":"Viladecans","codi_municipi":"83015","latitud":"41.31465487","longitud":"2.014458108","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Avinguda Josep Tarradellas i Joan, 16, 08840 Viladecans","informacio_web":"Viladecans. Biblioteca de Viladecans - Biblioteca Virtual","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-rtr6_ii46_3fjw",":version":"rv-jf78~jvk3~v9yg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Timba","indicador_refugi":"80689|PARC_DE_LA_TIMBA","municipi":"Cervell\xf3","codi_municipi":"80689","latitud":"41.39425892","longitud":"1.960091442","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Carrer de la Pau, 13, 08758 Cervell\xf3","informacio_web":"Parc de la Timba - Territori - \xc0rea Metropolitana de Barcelona","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-skeb_zppg-yk87",":version":"rv-4546.5bw7_in6m",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la gent gran Josep Tarradellas","indicador_refugi":"80689|CASAL_DE_LA_GENT_GRAN_JOSEP_TARRADELLAS","municipi":"Cervell\xf3","codi_municipi":"80689","latitud":"41.39613696","longitud":"1.95654444","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Carrer Major, 85, 08758 Cervell\xf3","informacio_web":"Casal de Gent Gran Josep Tarradellas - Ajuntament de Cervell\xf3","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-k5g7-w6u3.mndr",":version":"rv-vinf.9wzx.s67g",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Municipal","indicador_refugi":"80689|BIBLIOTECA_MUNICIPAL","municipi":"Cervell\xf3","codi_municipi":"80689","latitud":"41.39601158","longitud":"1.957653148","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Pla\xe7a de la Biblioteca , 1 - 08758 Cervell\xf3","informacio_web":"Biblioteca Municipal - Ajuntament de Cervell\xf3","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-asik~5a3e_qxib",":version":"rv-aahm-y8q4_2t4u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Mil\xb7leni","indicador_refugi":"80898|PARC_DEL_MIL_LENI","municipi":"Gav\xe0","codi_municipi":"80898","latitud":"41.30266294","longitud":"1.995024174","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Avinguda de les B\xf2biles, 1, 08850 Gav\xe0","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-pirn-hmvc~rjsq",":version":"rv-s8zm_9ajs.6rcu",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc dels Creixents","indicador_refugi":"80898|PARC_DELS_CREIXENTS","municipi":"Gav\xe0","codi_municipi":"80898","latitud":"41.30533986","longitud":"1.993565365","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Avinguda de Joan Carles I amb carrer de Santa Teresa","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-gqrq.92ak_vqgt",":version":"rv-59tg-6k99.rq9k",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Torre Lluc","indicador_refugi":"80898|PARC_TORRE_LLUC","municipi":"Gav\xe0","codi_municipi":"80898","latitud":"41.30658193","longitud":"2.005194154","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Carrer de Salvador Lluch, 27, 08850 Gav\xe0","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-7vq7.jzyn.292e",":version":"rv-mu4c~4tic.kyh8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de les Panes","indicador_refugi":"80898|PLACA_DE_LES_PANES","municipi":"Gav\xe0","codi_municipi":"80898","latitud":"41.30001208","longitud":"2.003293533","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Pla\xe7a de les Panes","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-8ruc-q2yz.wzdq",":version":"rv-dxmk.wnzm_6sv7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Calamot","indicador_refugi":"80898|PARC_DEL_CALAMOT","municipi":"Gav\xe0","codi_municipi":"80898","latitud":"41.29897841","longitud":"2.000359245","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Avinguda de Joan Carles I, s/n, 08850 Gav\xe0","informacio_web":"Parc del Calamot - Territori - \xc0rea Metropolitana de Barcelona","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-p2ru_bkh7~dpmf",":version":"rv-cbhs~kbmb_ndcm",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Rambla","indicador_refugi":"80898|RAMBLA","municipi":"Gav\xe0","codi_municipi":"80898","latitud":"41.30544302","longitud":"2.007411542","accessibilitat":"Si","area_descans":"S\xed","lavabo":"No","adreca":"Rambla de Maria Casas i Rambla de Joaquim Vayreda","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-qzyh~tjpw.ks6q",":version":"rv-xxn8~rawu~yc26",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Marian Colom\xe9","indicador_refugi":"80898|BIBLIOTECA_MARIAN_COLOME","municipi":"Gav\xe0","codi_municipi":"80898","latitud":"41.30961521","longitud":"2.000046642","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Carrer de Jaume I, 5 bis, 08850 Gav\xe0","informacio_web":"Gav\xe0. Biblioteca Marian Colom\xe9 - Biblioteca Virtual","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wwj7.jqpy.syz5",":version":"rv-bqkx~kn92-cgw6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca Josep Soler i Vidal","indicador_refugi":"80898|BIBLIOTECA_JOSEP_SOLER_I_VIDAL","municipi":"Gav\xe0","codi_municipi":"80898","latitud":"41.30364555","longitud":"1.998562826","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Pla\xe7a de Jaume Balmes, s/n","informacio_web":"Gav\xe0-Biblioteca Josep Soler Vidal - Biblioteca Virtual","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-c4x8_8fs8.5yfr",":version":"rv-vbps~qhsd.bqqi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la gent gran Can Tintorer","indicador_refugi":"80898|CASAL_DE_LA_GENT_GRAN_CAN_TINTORER","municipi":"Gav\xe0","codi_municipi":"80898","latitud":"41.31084881","longitud":"1.993773377","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Cam\xed de Can Tries, s/n","informacio_web":"Casal Municipal de la Gent Gran Can Tintorer - Gav\xe0","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wge6.y3v3.cxa8",":version":"rv-kdec_sey9_i9bw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de la gent gran Torre Lluc","indicador_refugi":"80898|CASAL_DE_LA_GENT_GRAN_TORRE_LLUC","municipi":"Gav\xe0","codi_municipi":"80898","latitud":"41.30606616","longitud":"2.00576373","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Carrer Centre, 3","informacio_web":"Casal Municipal de la Gent Gran Torre Lluc - Gav\xe0","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-d8zx_tmsy~f84h",":version":"rv-a89p~hqx3-wgth",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Espai jove La Casa Gran","indicador_refugi":"80898|ESPAI_JOVE_LA_CASA_GRAN","municipi":"Gav\xe0","codi_municipi":"80898","latitud":"41.30489656","longitud":"2.00549561","accessibilitat":"Si","climatitzacio":"Si","area_descans":"S\xed","lavabo":"No","adreca":"Carrer Major, 37, 08850 Gav\xe0","informacio_web":"Espai Jove de La Casa Gran - Gav\xe0","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-75uj_req9~wijy",":version":"rv-586k.saes_tfdi",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de Cultura","indicador_refugi":"82520|CASAL_DE_CULTURA","municipi":"Barber\xe0 del Vall\xe8s","codi_municipi":"82520","latitud":"41.51691867","longitud":"2.128907886","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Carrer Nemesi Valls, 35, 08210 Barber\xe0 del Vall\xe8s","informacio_web":"Casal de Cultura | Ayuntamiento de Barber\xe1 del Vall\xe9s","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-8428-emrg~73y8",":version":"rv-tcfq-78g9-gyhw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Centre Comercial Baricentro","indicador_refugi":"82520|CENTRE_COMERCIAL_BARICENTRO","municipi":"Barber\xe0 del Vall\xe8s","codi_municipi":"82520","latitud":"41.50777337","longitud":"2.138088088","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"N-150, km 6, 7, 08210 Barber\xe0 del Vall\xe8s","informacio_web":"Actualidad Baricentro \xab Baricentro.es","tipologia":"Privat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-yrw9.px8v~va69",":version":"rv-ggci_6bsm~xe6s",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal l\'Olivera","indicador_refugi":"82009|CASAL_L_OLIVERA","municipi":"Sant Boi de Llobregat","codi_municipi":"82009","latitud":"41.3514158","longitud":"2.029375466","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Pla\xe7a de Montserrat Roig, 1, 08830 Sant Boi de Llobregat","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-uzrj-rgq4_5ssy",":version":"rv-szwq.6cec_xmhn",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de barri de la Ciutat Cooperativa","indicador_refugi":"82009|CASAL_DE_BARRI_DE_LA_CIUTAT_COOPERATIVA","municipi":"Sant Boi de Llobregat","codi_municipi":"82009","latitud":"41.35697073","longitud":"2.029812067","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Carrer Pau Casals, 7, 08830 Sant Boi de Llobregat","informacio_web":"Casal Ciutat Cooperativa-Mol\xed Nou | Ajuntament de Sant Boi de Llobregat","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-269a.7stc-y8i9",":version":"rv-vgz8_cyjb.rw5q",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal de barri la Gralla","indicador_refugi":"82009|CASAL_DE_BARRI_LA_GRALLA","municipi":"Sant Boi de Llobregat","codi_municipi":"82009","latitud":"41.33318056","longitud":"2.038057591","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Pla\xe7a dels Gegants, 1, 08830 Sant Boi de Llobregat","informacio_web":"La Gralla | Ajuntament de Sant Boi de Llobregat","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-d67x.9amm.bhf2",":version":"rv-3te8~gsnu-yubb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Sala d\'actes de Ca N\'Ametller","indicador_refugi":"81234|SALA_D_ACTES_DE_CA_N_AMETLLER","municipi":"Molins de Rei","codi_municipi":"81234","latitud":"41.4140362","longitud":"2.016360812","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Carrer Jacint Verdaguer, 95 bis, Molins de Rei","informacio_web":"Sala d\u2019exposicions de Ca\u2019n Ametller - Ajuntament de Molins de Rei","tipologia":"Ajuntament","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-uav5_sgz4~cigg",":version":"rv-43n3.pjru-y92m",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Mol\xed Jove - Aula d\'estudi","indicador_refugi":"81234|MOLI_JOVE_AULA_D_ESTUDI","municipi":"Molins de Rei","codi_municipi":"81234","latitud":"41.41332854","longitud":"2.014713008","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Pla\xe7a de l\'U d\'Octubre de 2017, 5, Molins deRei","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-aupk-ee42~iizf",":version":"rv-rgz3.c4xp.ecek",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Biblioteca el Mol\xed","indicador_refugi":"81234|BIBLIOTECA_EL_MOLI","municipi":"Molins de Rei","codi_municipi":"81234","latitud":"41.41286902","longitud":"2.014673412","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Pla\xe7a de l\'U d\'Octubre de 2017, 2, 08750 Molins de Rei","tipologia":"Biblioteca","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-iicm.a7ib-g64a",":version":"rv-jez8.u4ty~j3w9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal d\'avis Primer de Maig","indicador_refugi":"81234|CASAL_D_AVIS_PRIMER_DE_MAIG","municipi":"Molins de Rei","codi_municipi":"81234","latitud":"41.40678905","longitud":"2.020098486","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Carrer Felip Canalies, s/n, Molins de Rei","tipologia":"Equipament de proximitat","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-hmdy_wisq_ah6m",":version":"rv-ehgq~pdba~9vce",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Oficina d\'atenci\xf3 ciutadana","indicador_refugi":"81234|OFICINA_D_ATENCIO_CIUTADANA","municipi":"Molins de Rei","codi_municipi":"81234","latitud":"41.41204285","longitud":"2.01636173","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"Si","adreca":"Carrer Rubi\xf3 i Ors, 2-4, Molins deRei","tipologia":"Ajuntament","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-mgp7-wf4e-e6bx",":version":"rv-k6j6~tspb_nzhy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a de l\'Estatut","indicador_refugi":"82172|PLACA_DE_L_ESTATUT","municipi":"Sant Joan Desp\xed","codi_municipi":"82172","latitud":"41.37277067","longitud":"2.069935031","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"No","adreca":"Pla\xe7a de l\'Estatut, 1, 08970 Sant Joan Desp\xed","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-5yya_8grc-6kb7",":version":"rv-ymui~6gxd-u2v9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Pla\xe7a del Batiport","indicador_refugi":"82172|PLACA_DEL_BATIPORT","municipi":"Sant Joan Desp\xed","codi_municipi":"82172","latitud":"41.36360689","longitud":"2.0576165","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"No","adreca":"Pla\xe7a del Batiport, Sant Joan Desp\xed","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-nj8i-ig44-w26z",":version":"rv-y9a8-ahft~w9ap",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Patufet","indicador_refugi":"82042|PARC_DEL_PATUFET","municipi":"Sant Climent de Llobregat","codi_municipi":"82042","latitud":"41.33874605","longitud":"1.994501608","accessibilitat":"Si","aigua":"S\xed","climatitzacio":"Si","area_descans":"S\xed","lavabo":"No","adreca":"Carrer de les Comes, 08849 Sant Climent de Llobregat","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-c55q_bm5t_m7tb",":version":"rv-7tbb_p8xd_hay5",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bosc del Blanc","indicador_refugi":"81580|BOSC_DEL_BLANC","municipi":"El Papiol","codi_municipi":"81580","latitud":"41.43736359","longitud":"2.005924078","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Carrer de Sant Jordi, 5, 08754 El Papiol","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-kw8k.ssvn-9a5d",":version":"rv-cq6u-wb3r-bm7c",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Mestre Voltes","indicador_refugi":"81580|PARC_MESTRE_VOLTES","municipi":"El Papiol","codi_municipi":"81580","latitud":"41.43744743","longitud":"2.008173911","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","lavabo":"No","adreca":"Carrer d\'Anselm Clav\xe9, 14, 08754 El Papiol","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-tv3j~d8ie-3se8",":version":"rv-kwb5_yqpn.tjif",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de la Bastida","indicador_refugi":"82457|PARC_DE_LA_BASTIDA","municipi":"Santa Coloma de Gramenet","codi_municipi":"82457","latitud":"41.45803074","longitud":"2.215239114","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","adreca":"Carrer de Santa Eul\xe0lia, 83, 08921 Santa Coloma de Gramenet","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-gq7x.s2hj~c88r",":version":"rv-a7ae.dda4-djvq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Joan Oliver","indicador_refugi":"89045|PARC_DE_JOAN_OLIVER","municipi":"Badia del Vall\xe8s","codi_municipi":"89045","latitud":"41.50729314","longitud":"2.116012638","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","adreca":"Carrer de la Manxa, 13, 08214 Badia del Vall\xe8s","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-y4h8_cqcq~yrk4",":version":"rv-4wvt_tg6a_xycv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Can Lluc","indicador_refugi":"82444|PARC_DE_CAN_LLUC","municipi":"Santa Coloma de Cervell\xf3","codi_municipi":"82444","latitud":"41.36942275","longitud":"2.017446355","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","adreca":"Avinguda Can Lluch, 19, 08690 Santa Coloma de Cervell\xf3","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-dz98_mnjs~m7j6",":version":"rv-am93~chwb_4q6b",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc del Mil\xb7lenari","indicador_refugi":"82212|PARC_DEL_MIL_LENARI","municipi":"Sant Just Desvern","codi_municipi":"82212","latitud":"41.38364765","longitud":"2.078739977","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","adreca":"Passatge del Mercat, s/n, 08960 Sant Just Desvern","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-h5jp.f6jw~e4ig",":version":"rv-7zak~i42r-gnai",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc de Torreblanca","indicador_refugi":"82212|PARC_DE_TORREBLANCA","municipi":"Sant Feliu de Llobregat","codi_municipi":"82212","latitud":"41.37803008","longitud":"2.056170778","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"Ctra. Reial, 159","informacio_web":"https://refugisclimatics.amb.cat","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-e486.4wkw-ithp",":version":"rv-e8p3_dy7d.m2gd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc d\'Oriol Martorell","indicador_refugi":"8180|PARC_D_ORIOL_MARTORELL","municipi":"Ripollet","codi_municipi":"8180","latitud":"41.50422083","longitud":"2.155038867","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","adreca":"Carrer Barber\xe0 del Vall\xe8s, 7","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-bahp-uszm.rvqd",":version":"rv-3jb4.b2ru~4y3h",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Parc Gass\xf3 Vargas","indicador_refugi":"8180|PARC_GASSO_VARGAS","municipi":"Ripollet","codi_municipi":"8180","latitud":"41.50299956","longitud":"2.159400826","accessibilitat":"Si","aigua":"S\xed","area_descans":"S\xed","adreca":"Rambla dels Pinetons, 6","tipologia":"Parc","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-5bjp-tcmn~ch8u",":version":"rv-9re6-fbcg~ngwk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Bosc del Pinetons","indicador_refugi":"8180|BOSC_DEL_PINETONS","municipi":"Ripollet","codi_municipi":"8180","latitud":"41.50629042","longitud":"2.16014409","accessibilitat":"S\xcd","aigua":"S\xed","area_descans":"S\xed","adreca":"Avinguda del Mediterrani","informacio_web":"https://refugisclimatics.amb.cat","tipologia":"Parc AMB","origen_identificador":"AMB","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-mi5i-754t_9y99",":version":"rv-qtix.pce2-4t2d",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Les Franqueses","indicador_refugi":"080863|CASAL_CIVIC_I_COMUNITARI_LES_FRANQUESES","municipi":"Les Franqueses del Vall\xe8s","codi_municipi":"080863","latitud":"41.6277108300567","longitud":"2.29569241963774","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda Santa Eul\xe0lia, 7","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-fkyz~66b8_gt79",":version":"rv-iw4v-dt2q~8wwp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal C\xedvic i Comunitari Rub\xed (Magallanes)","indicador_refugi":"081846|CASAL_CIVIC_I_COMUNITARI_RUBI_MAGALLANES","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.4899006129316","longitud":"2.03566668721835","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer Magallanes, 60","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-mpmn-rskq.pw79",":version":"rv-izh2~kr4x_n2zk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal per a Gent Gran Baix Camp","indicador_refugi":"430385|CASAL_PER_A_GENT_GRAN_BAIX_CAMP","municipi":"Cambrils","codi_municipi":"430385","latitud":"41.069809636619","longitud":"1.0577873650102","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Beltran de Cambrils, 2","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-y4sv_n8qt-dpvu",":version":"rv-7a6c_29eb.knyx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal per a Gent Gran Cerdanyola","indicador_refugi":"082665|CASAL_PER_A_GENT_GRAN_CERDANYOLA","municipi":"Cerdanyola del Vall\xe8s","codi_municipi":"082665","latitud":"41.484506341916","longitud":"2.14492012594745","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Avinguda de Lesseps, 4","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-fpu9~rz9d-wgpg",":version":"rv-wvb2.pmau-4k35",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal per a Gent Gran Font dels Capellans","indicador_refugi":"081136|CASAL_PER_A_GENT_GRAN_FONT_DELS_CAPELLANS","municipi":"Manresa","codi_municipi":"081136","latitud":"41.7309045372673","longitud":"1.84045074063855","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de la Font dels Capellans, 85","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jhtv~up7t_tq9x",":version":"rv-cbhj.bezi-exyc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal per a Gent Gran Gr\xe0cia","indicador_refugi":"080193|CASAL_PER_A_GENT_GRAN_GRACIA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4013120345978","longitud":"2.16000181560553","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Siracusa, 23","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-pu2e_9hmh_wm6x",":version":"rv-xuxw-pexv_ppsz",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal per a Gent Gran Horta","indicador_refugi":"080193|CASAL_PER_A_GENT_GRAN_HORTA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4255240215088","longitud":"2.15110703519081","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Josep Sangen\xeds, 75","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-s2jp-bz37-epnk",":version":"rv-jyn9.yez8-zz74",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal per a Gent Gran Jaume Nualart","indicador_refugi":"080734|CASAL_PER_A_GENT_GRAN_JAUME_NUALART","municipi":"Cornell\xe0 de Llobregat","codi_municipi":"080734","latitud":"41.358116536816","longitud":"2.07766894242841","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de l\'Anoia, 8","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-pips.9ei3.ras5",":version":"rv-zrwj-w8be.n7dr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal per a Gent Gran La Trinitat Nova","indicador_refugi":"080193|CASAL_PER_A_GENT_GRAN_LA_TRINITAT_NOVA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4477977316648","longitud":"2.18501302309001","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de la Fosca, 4-8","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-x7gm~eyf6_ijcj",":version":"rv-rzzf_urkg~ccg2",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal per a Gent Gran La Verneda","indicador_refugi":"080193|CASAL_PER_A_GENT_GRAN_LA_VERNEDA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.420634563908","longitud":"2.2008423440761","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Cant\xe0bria, 28","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wws9_2cud-epvy",":version":"rv-n86u~pjvb.7thc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal per a Gent Gran Les Corts","indicador_refugi":"080193|CASAL_PER_A_GENT_GRAN_LES_CORTS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3879889442702","longitud":"2.13911922111008","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer del Montnegre, 33","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-a3a7~c6by.nwwf",":version":"rv-dh6p.9myd.uymq",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal per a Gent Gran Rub\xed (Lepant)","indicador_refugi":"081846|CASAL_PER_A_GENT_GRAN_RUBI_LEPANT","municipi":"Rub\xed","codi_municipi":"081846","latitud":"41.4992970060081","longitud":"2.03493781574718","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Lepant, 31","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ww23.aqee.gurx",":version":"rv-c28d.7p8k_5yxd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Casal per a Gent Gran Sant Cugat del Vall\xe8s","indicador_refugi":"082055|CASAL_PER_A_GENT_GRAN_SANT_CUGAT_DEL_VALLES","municipi":"Sant Cugat del Vall\xe8s","codi_municipi":"082055","latitud":"41.4754742472575","longitud":"2.0877422269997","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"S\xed","lavabo":"S\xed","adreca":"Carrer de Santa Rosa, 1","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-83qy_xt88_y7v2",":version":"rv-9x3t~erv3.gzzp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Alchemika","indicador_refugi":"080193|RESIDENCIA_PER_A_GENT_GRAN_ALCHEMIKA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4161052208985","longitud":"2.18110772594472","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer de Sant Antoni Maria Claret, 356-360","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-836h_ht29_p4xw",":version":"rv-w3wk_dc5w-tccf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Bal\xe0fia I","indicador_refugi":"251207|RESIDENCIA_PER_A_GENT_GRAN_BALAFIA_I","municipi":"Lleida","codi_municipi":"251207","latitud":"41.6304599594668","longitud":"0.625596554625549","accessibilitat":"No","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer de Jos\xe9 Olondriz Ostiz, 6","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-f8gy~fmnc_ynyz",":version":"rv-qq5d.46wq_w6zr",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Bal\xe0fia II","indicador_refugi":"251207|RESIDENCIA_PER_A_GENT_GRAN_BALAFIA_II","municipi":"Lleida","codi_municipi":"251207","latitud":"41.6294684398987","longitud":"0.627302898580056","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer de Vic, 10","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ds5d_tkqu.r6kk",":version":"rv-mx9y.z4ju_r95g",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Bertran i Oriola","indicador_refugi":"080193|RESIDENCIA_PER_A_GENT_GRAN_BERTRAN_I_ORIOLA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3816770984348","longitud":"2.18743609491257","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer de Carbonell, 4","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-8y6h.bu23.bg2z",":version":"rv-9g9q.4biu~765k",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Bon Pastor","indicador_refugi":"080193|RESIDENCIA_PER_A_GENT_GRAN_BON_PASTOR","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4389960638927","longitud":"2.20233178523522","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer d\'Augusto C\xe8sar Sandino, 7-9","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-msum-vn6u~4dbe",":version":"rv-8gg7_emz9_bmix",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Campdev\xe0nol","indicador_refugi":"170366|RESIDENCIA_PER_A_GENT_GRAN_CAMPDEVANOL","municipi":"Campdev\xe0nol","codi_municipi":"170366","latitud":"42.2235799356","longitud":"2.1629462768413","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Passeig Cortal\xf3, 5","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-53fx~ijqz~4j8f",":version":"rv-agi5-akht~piaa",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Can Falguera","indicador_refugi":"082114|RESIDENCIA_PER_A_GENT_GRAN_CAN_FALGUERA","municipi":"Sant Feliu de Llobregat","codi_municipi":"082114","latitud":"41.3818126135733","longitud":"2.0397741573056","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer de Jaume Ribas, 26-28","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-gb52~wvv4_5kvw",":version":"rv-7wzy-bdxa-wsce",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Comtes d\'Urgell","indicador_refugi":"250404|RESIDENCIA_PER_A_GENT_GRAN_COMTES_D_URGELL","municipi":"Balaguer","codi_municipi":"250404","latitud":"41.7915057953778","longitud":"0.817578282529475","accessibilitat":"No","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer Sant Diego Calif\xf2rnia, 16-42","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-nwth-jdbu~s26b",":version":"rv-4tdy.iu4s~999u",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Conca de Barber\xe0","indicador_refugi":"430862|RESIDENCIA_PER_A_GENT_GRAN_CONCA_DE_BARBERA","municipi":"Montblanc","codi_municipi":"430862","latitud":"41.3728346692586","longitud":"1.1560406655878","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Avinguda Manel Ribe, 46-48","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-hkss~agxj~q4u4",":version":"rv-fqi4_xxkz.bjgx",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Creu de Palau","indicador_refugi":"170792|RESIDENCIA_PER_A_GENT_GRAN_CREU_DE_PALAU","municipi":"Girona","codi_municipi":"170792","latitud":"41.9587078782874","longitud":"2.8230715205192","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer Jocs Ol\xedmpics de Barcelona, 2","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-fbfq_6yr8.x263",":version":"rv-6q4u~sphb-7eh9",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran El Mil\xb7lenari","indicador_refugi":"080193|RESIDENCIA_PER_A_GENT_GRAN_EL_MIL_LENARI","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3771927474049","longitud":"2.17255644587789","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer Nou de la Rambla, 47-49","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-rb65~6k9v.sge3",":version":"rv-jv4v~b2uj_3ken",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Els Arcs","indicador_refugi":"170669|RESIDENCIA_PER_A_GENT_GRAN_ELS_ARCS","municipi":"Figueres","codi_municipi":"170669","latitud":"42.2662506073456","longitud":"2.94575007487455","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer d\'Avinyonet, s/n","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-645a.pece_iwvc",":version":"rv-chcw~bnhs.b94q",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Feixa Llarga Laia Gonz\xe1lez","indicador_refugi":"081017|RESIDENCIA_PER_A_GENT_GRAN_FEIXA_LLARGA_LAIA_GONZALEZ","municipi":"l\'Hospitalet de Llobregat","codi_municipi":"081017","latitud":"41.3471645966786","longitud":"2.10510578616733","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer de la Residencia, 14","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-n6hc-tsd8.zvqw",":version":"rv-uu7w-bwac~pp6h",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Font Florida","indicador_refugi":"080193|RESIDENCIA_PER_A_GENT_GRAN_FONT_FLORIDA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3676642559979","longitud":"2.14171233143055","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer de la Font Florida, 98","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-xja5_77ct~66uw",":version":"rv-ciqi~84x8~uvhw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Francisco Padilla","indicador_refugi":"081017|RESIDENCIA_PER_A_GENT_GRAN_FRANCISCO_PADILLA","municipi":"l\'Hospitalet de Llobregat","codi_municipi":"081017","latitud":"41.3684634892621","longitud":"2.10003026566586","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Avinguda Electricitat, 35-43","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-gtzj-s3nk-rd4b",":version":"rv-v64v_vv8a~y8j6",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Gandesa","indicador_refugi":"430640|RESIDENCIA_PER_A_GENT_GRAN_GANDESA","municipi":"Gandesa","codi_municipi":"430640","latitud":"41.0512221132116","longitud":"0.435442475162976","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carretera de Bot, 3","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jfs5_uu6i.nvj9",":version":"rv-9ghs-zgy3~eyu7",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Gav\xe0","indicador_refugi":"080898|RESIDENCIA_PER_A_GENT_GRAN_GAVA","municipi":"Gav\xe0","codi_municipi":"080898","latitud":"41.3074893396193","longitud":"2.00576236633656","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer de la Conc\xf2rdia, 24","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-722y~axgs~2z6f",":version":"rv-pfbr~fa9e~ytej",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Jaume Batlle","indicador_refugi":"080193|RESIDENCIA_PER_A_GENT_GRAN_JAUME_BATLLE","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3990338005161","longitud":"2.20600472291919","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer de Fernando Poo, 45","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-w9gc~f7ix-85wd",":version":"rv-uepd.tjk3.vsaa",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Jaume I","indicador_refugi":"430542|RESIDENCIA_PER_A_GENT_GRAN_JAUME_I","municipi":"l\'Espluga de Francol\xed","codi_municipi":"430542","latitud":"41.3951746592508","longitud":"1.10375522466311","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer de Sant Vicen\xe7 de Pa\xfcl, 20","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-q335_buaa~77y6",":version":"rv-nru8.3g6n_a5bv",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran La Merc\xe8","indicador_refugi":"431482|RESIDENCIA_PER_A_GENT_GRAN_LA_MERCE","municipi":"Tarragona","codi_municipi":"431482","latitud":"41.1180702932831","longitud":"1.26208101454686","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Cam\xed de la Cuixa, 1B","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-vgbx-yi23.ix3n",":version":"rv-kw6m.45qt_xnhw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran La Sagrera","indicador_refugi":"080193|RESIDENCIA_PER_A_GENT_GRAN_LA_SAGRERA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4263852814859","longitud":"2.19189366145783","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer de Berenguer de Palou, 102","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-duk8-ijmr~ti24",":version":"rv-8s6b~n82h_7v66",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran La S\xe9nia","indicador_refugi":"430445|RESIDENCIA_PER_A_GENT_GRAN_LA_SENIA","municipi":"la S\xe9nia","codi_municipi":"430445","latitud":"40.6360532644159","longitud":"0.27835174221843","accessibilitat":"No","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer de Jaume I, 44","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-tyht_s5yy~rnjy",":version":"rv-xb6s_fwi8.2bpk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran L\'Alta Ribagor\xe7a","indicador_refugi":"251734|RESIDENCIA_PER_A_GENT_GRAN_L_ALTA_RIBAGORCA","municipi":"el Pont de Suert","codi_municipi":"251734","latitud":"42.4059994884546","longitud":"0.740468462764732","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer del Salencar, s/n","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ue72-yxih.98zz",":version":"rv-i3bn~a8jn.hjpj",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran L\'Ametlla","indicador_refugi":"080057|RESIDENCIA_PER_A_GENT_GRAN_L_AMETLLA","municipi":"l\'Ametlla del Vall\xe8s","codi_municipi":"080057","latitud":"41.6567215228114","longitud":"2.27445788362685","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carretera de Llerona, s/n (Finca Can Focs)","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-cmzv~fqe8~2s58",":version":"rv-9vkx_b6g8_9pjb",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Les Escoles Velles","indicador_refugi":"430607|RESIDENCIA_PER_A_GENT_GRAN_LES_ESCOLES_VELLES","municipi":"Flix","codi_municipi":"430607","latitud":"41.2285641215396","longitud":"0.546840365448485","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer Escoles, 39","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ut6i~2ui7-enys",":version":"rv-w7f7~xjis-fjmy",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Matar\xf3","indicador_refugi":"081213|RESIDENCIA_PER_A_GENT_GRAN_MATARO","municipi":"Matar\xf3","codi_municipi":"081213","latitud":"41.5371094723841","longitud":"2.42913544140014","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Avinguda de la Gatassa, 43","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jmas-7ubw~9vmd",":version":"rv-n89z_3ffv-btkf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Mercat de Guinard\xf3","indicador_refugi":"080193|RESIDENCIA_PER_A_GENT_GRAN_MERCAT_DE_GUINARDO","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.419569699027","longitud":"2.17813086345402","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer de l\'Oblit, 29","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-e7kz-2uek-5dpb",":version":"rv-cyyy_5qdk~93ys",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Mol\xed - Via Fav\xe8ncia","indicador_refugi":"080193|RESIDENCIA_PER_A_GENT_GRAN_MOLI_VIA_FAVENCIA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4459346558448","longitud":"2.18137958339877","accessibilitat":"No","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer del Mol\xed, 67","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ygvw-w8cx_5c7g",":version":"rv-ghis.dmu7.t4bt",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran M\xf3ra la Nova","indicador_refugi":"430944|RESIDENCIA_PER_A_GENT_GRAN_MORA_LA_NOVA","municipi":"M\xf3ra la Nova","codi_municipi":"430944","latitud":"41.1063794844637","longitud":"0.652202536565901","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Cam\xed de l\'Estaci\xf3, 2","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jsyv_967r~gbat",":version":"rv-b3c3_4j2x_tnuf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Moss\xe8n Vidal i Aun\xf3s","indicador_refugi":"080193|RESIDENCIA_PER_A_GENT_GRAN_MOSSEN_VIDAL_I_AUNOS","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.37057794182","longitud":"2.14029142924946","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer de Navarra, 12-28","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ut7f-abhm-hhqa",":version":"rv-j8rq.mpkz~44fd",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Natzaret","indicador_refugi":"430939|RESIDENCIA_PER_A_GENT_GRAN_NATZARET","municipi":"M\xf3ra d\'Ebre","codi_municipi":"430939","latitud":"41.0850115726277","longitud":"0.633329336904647","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer de Maria del Miracle Descarrega, 8 (Ap. Co. 25)","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-udr8.by2t_nzic",":version":"rv-zy5s.r7qu_4xz8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Onze de Setembre","indicador_refugi":"081691|RESIDENCIA_PER_A_GENT_GRAN_ONZE_DE_SETEMBRE","municipi":"el Prat de Llobregat","codi_municipi":"081691","latitud":"41.3203908549538","longitud":"2.09768609745728","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Avinguda Onze de Setembre, 81-83","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-zgth_5fuu.2udw",":version":"rv-m29p_rb4a.c98v",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Parc Serentill","indicador_refugi":"080155|RESIDENCIA_PER_A_GENT_GRAN_PARC_SERENTILL","municipi":"Badalona","codi_municipi":"080155","latitud":"41.4582665163626","longitud":"2.24438191260511","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Mol\xed de la Torre, 62-75","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-pa5g.ffuw~2nud",":version":"rv-jfwr~e5mg_utc4",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Pare Batllori","indicador_refugi":"080193|RESIDENCIA_PER_A_GENT_GRAN_PARE_BATLLORI","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.3732998390039","longitud":"2.17162599165644","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer de Vila i Vil\xe0, 39-41","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3i2g_24bf_n82s",":version":"rv-pa5s_xug5.m8wp",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Poblenou","indicador_refugi":"080193|RESIDENCIA_PER_A_GENT_GRAN_POBLENOU","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4070694041723","longitud":"2.21033270295255","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer de Llull, 328-332","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-uypp~k4gv-9ivj",":version":"rv-ipzi~9u9f_gqfg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Porta","indicador_refugi":"080193|RESIDENCIA_PER_A_GENT_GRAN_PORTA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.4325617741437","longitud":"2.17622096083214","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer de la Maladeta, 30","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-8d27-77w2-9hha",":version":"rv-kzqn-xsam_h6jk",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Puig d\'en Roca","indicador_refugi":"170792|RESIDENCIA_PER_A_GENT_GRAN_PUIG_D_EN_ROCA","municipi":"Girona","codi_municipi":"170792","latitud":"41.995251111007","longitud":"2.81301768132973","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer d\'Antoni Var\xe9s i Martinell, 37","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-ywx7_7abp-dn92",":version":"rv-yimn.2wij_kbvw",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Roger de Ll\xfaria","indicador_refugi":"431233|RESIDENCIA_PER_A_GENT_GRAN_ROGER_DE_LLURIA","municipi":"Reus","codi_municipi":"431233","latitud":"41.1581870382499","longitud":"1.08891996519314","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer de Roger de Ll\xfaria, 2B-8","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-64x6~wqf4-3ida",":version":"rv-jy5n_2qhz~it8r",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Sant Bartomeu","indicador_refugi":"250501|RESIDENCIA_PER_A_GENT_GRAN_SANT_BARTOMEU","municipi":"Bellpuig","codi_municipi":"250501","latitud":"41.6203687922862","longitud":"1.00884513624857","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carretera de Belianes, s/n","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-tw6m.nv6z_zpk3",":version":"rv-f6b2_znzp~iw9f",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Sant Josep","indicador_refugi":"251207|RESIDENCIA_PER_A_GENT_GRAN_SANT_JOSEP","municipi":"Lleida","codi_municipi":"251207","latitud":"41.6143438190187","longitud":"0.611866854257835","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer de la Merc\xe8, 10-12","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-tgfr.n8mu_htcz",":version":"rv-wxsk~kt78_vb99",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Sant Lloren\xe7 Savall","indicador_refugi":"082233|RESIDENCIA_PER_A_GENT_GRAN_SANT_LLORENC_SAVALL","municipi":"Sant Lloren\xe7 Savall","codi_municipi":"082233","latitud":"41.6724394779298","longitud":"2.05402919929709","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carretera de Sabadell, km 18.5","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-8hmw.gbdg_cqf7",":version":"rv-tgx7.xwc3-hz4f",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Sant Pere Claver","indicador_refugi":"252424|RESIDENCIA_PER_A_GENT_GRAN_SANT_PERE_CLAVER","municipi":"Verd\xfa","codi_municipi":"252424","latitud":"41.6082170948633","longitud":"1.14658383200245","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer Mol\xed de Vent, 2","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-gszt-g9z8.whs4",":version":"rv-3kvp~vu3f.n5uc",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Sant Roc","indicador_refugi":"080155|RESIDENCIA_PER_A_GENT_GRAN_SANT_ROC","municipi":"Badalona","codi_municipi":"080155","latitud":"41.4356846939835","longitud":"2.22528050163319","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Avinguda del Maresme, 182-190","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-f99k-xxfu-mm6t",":version":"rv-dxu7~ked9-sykg",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Sant Vicen\xe7 de Castellet","indicador_refugi":"082628|RESIDENCIA_PER_A_GENT_GRAN_SANT_VICENC_DE_CASTELLET","municipi":"Sant Vicen\xe7 de Castellet","codi_municipi":"082628","latitud":"41.6696399810634","longitud":"1.8694860884499","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer del Poeta Maragall, 20","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-wyqz_669m_xe3w",":version":"rv-h6hx~zyuu-eh4i",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Santa Coloma de Gramenet","indicador_refugi":"082457|RESIDENCIA_PER_A_GENT_GRAN_SANTA_COLOMA_DE_GRAMENET","municipi":"Santa Coloma de Gramenet","codi_municipi":"082457","latitud":"41.4618626230239","longitud":"2.20822225210892","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Avinguda Ram\xf3n Berenguer, 68","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-cxcm~ee4g-jbe2",":version":"rv-efrh_didg_g2i8",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Santa Rosa","indicador_refugi":"081249|RESIDENCIA_PER_A_GENT_GRAN_SANTA_ROSA","municipi":"Mollet del Vall\xe8s","codi_municipi":"081249","latitud":"41.5420295144024","longitud":"2.20320126001189","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer \xc1lvarez de Castro, 53-57","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-jwi3_2qve_2wch",":version":"rv-urmv.6z3u_i59z",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Seraf\xed Casanovas Sansa","indicador_refugi":"252094|RESIDENCIA_PER_A_GENT_GRAN_SERAFI_CASANOVAS_SANSA","municipi":"Sort","codi_municipi":"252094","latitud":"42.4079752759662","longitud":"1.13319429849467","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carretera de la Seu d\u2019Urgell, 12","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-3eyw.tzak_38gd",":version":"rv-4u9w~uwg8-xe37",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Terrassa","indicador_refugi":"082798|RESIDENCIA_PER_A_GENT_GRAN_TERRASSA","municipi":"Terrassa","codi_municipi":"082798","latitud":"41.583598614398","longitud":"2.04004362708131","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carretera de Castellar, s/n (Finca Mossen Homs)","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"},{":id":"row-2qqy-i9rc-u7hj",":version":"rv-tney_s4kg-4hwf",":created_at":"2026-07-15T08:38:46.939Z",":updated_at":"2026-07-15T08:38:46.939Z","nom":"Resid\xe8ncia per a Gent Gran Vallbona","indicador_refugi":"080193|RESIDENCIA_PER_A_GENT_GRAN_VALLBONA","municipi":"Barcelona","codi_municipi":"080193","latitud":"41.462648484099","longitud":"2.18391207564431","accessibilitat":"S\xed","aigua":"S\xed","climatitzacio":"S\xed","area_descans":"No","lavabo":"S\xed","adreca":"Carrer Pierola, 22","tipologia":"Equipament de proximitat","origen_identificador":"Drets Socials i Inclusi\xf3","ultima_actualitzacio":"2026-07-15T09:50:00.000"}]');


var $95e64080dc61a506$exports = {};
$95e64080dc61a506$exports = JSON.parse('{"ca":{"label_serveis":"Serveis","label_tipologia":"Filtra per tipologia","tipus_refugi":"Tipus refugi","tots":"Totes","selecciona_tipologia":"Selecciona tipologia","tipologies_seleccionades":"Tipologies seleccionades","serveis":{"accessibilitat":"Accessible","aigua":"Aigua potable","climatitzacio":"Climatitzaci\xf3","area_descans":"\xc0rea de descans","lavabo":"Lavabos"},"font":"Font: Departament Interior, Generalitat de Catalunya. <a href=\\"https://analisi.transparenciacatalunya.cat/Seguretat/Refugis-clim-tics-dels-municipis-de-Catalunya/9gu7-iwci/about_data\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">Dades obertes</a>","tipologia":{"administracio_publica":{"nom":"Administraci\xf3 p\xfablica","opcions":["Ajuntament","ajuntament","Ajuntament / Equipament Administratiu"]},"equipament_civic_proximitat":{"nom":"Equipaments c\xedvics i de proximitat","opcions":["Casal de Gent Gran","Centre C\xedvic","Equipament c\xedvic","Equipament de proximitat","Equipaments de proximitat","Sala Polivalent","Sala polivalent"]},"centres_educatius":{"nom":"Centres educatius","opcions":["Centre educatiu","Escola / Institut","Patis d\'Escola","Patis d\'Escola Bressol","Universitats"]},"biblioteques":{"nom":"Biblioteques","opcions":["Biblioteca","Biblioteques"]},"equipament_cultural":{"nom":"Equipaments culturals","opcions":["Entitats culturals","Equipament Cultural (teatre, auditori, museu)","Espai cultural","Ludoteca","Museus"]},"equipament_esportiu":{"nom":"Equipaments esportius","opcions":["Complexos esportius","Equipament esportiu","Gimn\xe0s Municipal","Pavell\xf3 Esportiu","Piscina","Piscina Coberta","Piscines","Piscines descobertes","Poliesportiu"]},"verd_espai_obert":{"nom":"Parcs i espais oberts","opcions":["Parc","Parc AMB","Parc densament arbrat","Parcs i Jardins","Parcs i jardins","Interiors d\'Illa","Jocs d\'aigua"]},"comercial_firal_mercat":{"nom":"Centres comercials, firals i mercats","opcions":["Centres comercials","Espai firal","Mercat","Mercats"]},"equipament_sanitari":{"nom":"Equipament sanitari","opcions":["Equipament Sanitari"]},"centres_culte":{"nom":"Centres de culte","opcions":["Centres de culte"]},"ambiental_microrefugi":{"nom":"Equipament ambiental / microrefugi","opcions":["Equipaments Ambientals","_Microrefugis","_microRefugi"]},"altres_privat":{"nom":"Privat i altres","opcions":["Altres","Privat"]}},"mapbox":{"FullscreenControl.Enter":"Pantalla completa","FullscreenControl.Exit":"Torna","ScrollZoomBlocker.CmdMessage":"Fes \u2318 + scroll per fer zoom al mapa","ScrollZoomBlocker.CtrlMessage":"Fes ctrl + scroll per fer zoom al mapa"}},"es":{"label_serveis":"Servicios","label_tipologia":"Filtrar por tipolog\xeda","tipus_refugi":"Tipo de refugio","tots":"Todos","selecciona_tipologia":"Selecciona tipolog\xeda","tipologies_seleccionades":"Tipolog\xedas seleccionadas","font":"Fuente: Departamento Interior, Generalitat de Catalunya. <a href=\\"https://analisi.transparenciacatalunya.cat/Seguretat/Refugis-clim-tics-dels-municipis-de-Catalunya/9gu7-iwci/about_data\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">Dades obertes</a>","serveis":{"accessibilitat":"Accesible","aigua":"Agua potable","climatitzacio":"Climatizaci\xf3n","area_descans":"\xc1rea de descanso","lavabo":"Lavabos"},"tipologia":{"administracio_publica":{"nom":"Administraci\xf3n p\xfablica","opcions":["Ayuntamiento","ayuntamiento","Ayuntamiento / Equipamiento Administrativo"]},"equipament_civic_proximitat":{"nom":"Equipamientos c\xedvicos y de proximidad","opcions":["Casa de Abuelos","Centro C\xedvico","Equipamiento c\xedvico","Equipamiento de proximidad","Equipamientos de proximidad","Sala Polivalente","Sala polivalente"]},"centres_educatius":{"nom":"Centros educativos","opcions":["Centro educativo","Escuela / Instituto","Patios de Escuela","Patios de Guarder\xeda","Universidades"]},"biblioteques":{"nom":"Bibliotecas","opcions":["Biblioteca","Bibliotecas"]},"equipament_cultural":{"nom":"Equipamientos culturales","opcions":["Entidades culturales","Equipamiento Cultural (teatro, auditorio, museo)","Espacio cultural","Ludoteca","Museos"]},"equipament_esportiu":{"nom":"Equipamientos deportivos","opcions":["Complejos deportivos","Equipamiento deportivo","Gimnasio Municipal","Pabell\xf3n Deportivo","Piscina","Piscina Cubierta","Piscinas","Piscinas descubiertas","Polideportivo"]},"verd_espai_obert":{"nom":"Parques y espacios abiertos","opcions":["Parque","Parque AMB","Parque densamente arbolado","Parques y Jardines","Parques y jardines","Interiores de Manzana","Juegos de agua"]},"comercial_firal_mercat":{"nom":"Centros comerciales, espacios feriales y mercados","opcions":["Centros comerciales","Espacio ferial","Mercado","Mercados"]},"equipament_sanitari":{"nom":"Equipamiento sanitario","opcions":["Equipamiento Sanitario"]},"centres_culte":{"nom":"Centros de culto","opcions":["Centros de culto"]},"ambiental_microrefugi":{"nom":"Equipamiento ambiental / microrefugio","opcions":["Equipamientos Ambientales","_Microrefugios","_microRefugio"]},"altres_privat":{"nom":"Privado y otros","opcions":["Otros","Privado"]}},"mapbox":{"FullscreenControl.Enter":"Pantalla completa","FullscreenControl.Exit":"Vuelve","ScrollZoomBlocker.CmdMessage":"Usa \u2318 + scroll para hacer zoom en el mapa","ScrollZoomBlocker.CtrlMessage":"Usa ctrl + scroll para hacer zoom en el mapa"}}}');





function $2a9753ce2d0b2cb0$export$2e2bcd8739ae039({ embedHome: embedHome, lang: lang, slug: slug }) {
    const containerRef = (0, $acw62.useRef)(null);
    const mapRef = (0, $acw62.useRef)(null);
    const [containerSize, setContainerSize] = (0, $acw62.useState)({
        width: 0,
        height: 0
    });
    const [refugiSeleccionat, setRefugiSeleccionat] = (0, $acw62.useState)(null);
    const [canonicsSeleccionats, setCanonicsSeleccionats] = (0, $acw62.useState)([]);
    const [cursor, setCursor] = (0, $acw62.useState)('default');
    const initialViewState = (0, $acw62.useMemo)(()=>{
        if (!containerSize.width || !containerSize.height) return null;
        return (0, $994aa1cb22f78a22$export$a2ac0fedb00307a4)(containerSize.width, containerSize.height);
    }, [
        containerSize.width,
        containerSize.height
    ]);
    const dades = (0, $acw62.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3192dd7d0768a102$exports))).map((refugi)=>({
                ...refugi,
                latitude: Number(refugi.latitud),
                longitude: Number(refugi.longitud)
            })), []);
    const configuracioTipologies = (0, $acw62.useMemo)(()=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($95e64080dc61a506$exports)))[lang]?.tipologia ?? (0, (/*@__PURE__*/$parcel$interopDefault($95e64080dc61a506$exports))).ca?.tipologia ?? {};
    }, [
        lang
    ]);
    const canonics = (0, $acw62.useMemo)(()=>Object.keys(configuracioTipologies), [
        configuracioTipologies
    ]);
    const tipusPerCanonic = (0, $acw62.useMemo)(()=>{
        return canonics.reduce((acc, canonic)=>{
            const opcions = configuracioTipologies?.[canonic]?.opcions ?? [];
            acc[canonic] = new Set(opcions);
            return acc;
        }, {});
    }, [
        canonics,
        configuracioTipologies
    ]);
    const dadesFiltrades = (0, $acw62.useMemo)(()=>{
        if (!canonicsSeleccionats.length) return [];
        return dades.filter((refugi)=>canonicsSeleccionats.some((canonic)=>tipusPerCanonic[canonic]?.has(refugi.tipologia)));
    }, [
        canonicsSeleccionats,
        dades,
        tipusPerCanonic
    ]);
    const geojson = (0, $acw62.useMemo)(()=>({
            type: 'FeatureCollection',
            features: dadesFiltrades.map((refugi)=>({
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: [
                            refugi.longitude,
                            refugi.latitude
                        ]
                    },
                    properties: refugi
                }))
        }), [
        dadesFiltrades
    ]);
    const totsSeleccionats = canonicsSeleccionats.length === canonics.length && canonics.length > 0;
    const resetTipologies = ()=>{
        setCanonicsSeleccionats(canonics);
    };
    const toggleCanonic = (canonic)=>{
        setCanonicsSeleccionats((actuals)=>{
            if (actuals.includes(canonic)) {
                if (actuals.length === canonics.length) return [
                    canonic
                ];
                return actuals.filter((canonicActual)=>canonicActual !== canonic);
            }
            return [
                ...actuals,
                canonic
            ];
        });
    };
    const handleMapClick = (event)=>{
        const feature = event.features?.[0];
        const map = mapRef.current?.getMap();
        if (!feature || !map) {
            setRefugiSeleccionat(null);
            return;
        }
        if (feature.layer.id === 'clusters') {
            const source = map.getSource('refugis');
            source.getClusterExpansionZoom(feature.properties.cluster_id, (error, zoom)=>{
                if (!error) map.easeTo({
                    center: feature.geometry.coordinates,
                    zoom: zoom
                });
            });
            return;
        }
    };
    const handleMapMouseMove = (event)=>{
        const feature = event.features?.find(({ layer: layer })=>[
                'clusters',
                'unclustered-point'
            ].includes(layer.id));
        setCursor(feature ? 'pointer' : undefined);
        const refugi = event.features?.find(({ layer: layer })=>layer.id === 'unclustered-point');
        if (refugi) setRefugiSeleccionat(refugi.properties);
    };
    (0, $acw62.useEffect)(()=>{
        if (!containerRef.current) return;
        const updateContainerSize = ()=>{
            const rect = containerRef.current?.getBoundingClientRect?.();
            setContainerSize({
                width: rect?.width ?? 0,
                height: rect?.height ?? 0
            });
        };
        updateContainerSize();
        const resizeObserver = new ResizeObserver(updateContainerSize);
        resizeObserver.observe(containerRef.current);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        setCanonicsSeleccionats(canonics);
    }, [
        canonics
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!refugiSeleccionat) return;
        const refugiVisible = canonicsSeleccionats.some((canonic)=>tipusPerCanonic[canonic]?.has(refugiSeleccionat.tipologia));
        if (!refugiVisible) setRefugiSeleccionat(null);
    }, [
        canonicsSeleccionats,
        refugiSeleccionat,
        tipusPerCanonic
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64c812a720876a94$export$507c997ee09bb471), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "container-filtres",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            (0, (/*@__PURE__*/$parcel$interopDefault($95e64080dc61a506$exports)))[lang]?.label_tipologia,
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "filtres",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $992637f4e08c587e$export$2e2bcd8739ae039), {
                            lang: lang,
                            textos: (0, (/*@__PURE__*/$parcel$interopDefault($95e64080dc61a506$exports))),
                            canonics: canonics,
                            canonicsSeleccionats: canonicsSeleccionats,
                            totsSeleccionats: totsSeleccionats,
                            configuracioTipologies: configuracioTipologies,
                            onReset: resetTipologies,
                            onToggle: toggleCanonic
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "container-mapa",
                ref: containerRef,
                children: initialViewState && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9bfa0fb4992bfff5$export$a5c7b93649eaf8f8), {
                    id: "mapa_refugis_climatics",
                    ref: mapRef,
                    mapboxAccessToken: (0, $994aa1cb22f78a22$export$6b0c92c645b60d60),
                    projection: "mercator",
                    cursor: cursor,
                    initialViewState: initialViewState,
                    style: {
                        position: 'absolute',
                        width: '100%',
                        height: '100%'
                    },
                    mapStyle: (0, $994aa1cb22f78a22$export$192b6e91c1441415),
                    attributionControl: false,
                    cooperativeGestures: true,
                    reuseMaps: true,
                    locale: (0, (/*@__PURE__*/$parcel$interopDefault($95e64080dc61a506$exports)))[lang]?.mapbox,
                    onClick: handleMapClick,
                    onMouseMove: handleMapMouseMove,
                    onMouseLeave: ()=>{
                        setCursor('default');
                        setRefugiSeleccionat(null);
                    },
                    interactiveLayerIds: [
                        'clusters',
                        'unclustered-point'
                    ],
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c2d35c3db04f1ab9$export$1d2df86270c81ecb), {
                            id: "refugis",
                            type: "geojson",
                            data: geojson,
                            cluster: true,
                            clusterMaxZoom: 10,
                            clusterRadius: 45,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $baf7a1f21323fe66$export$936d0764594b6eb3), {
                                    id: "clusters",
                                    type: "circle",
                                    filter: [
                                        'has',
                                        'point_count'
                                    ],
                                    paint: {
                                        'circle-color': '#0073ee',
                                        'circle-radius': 20,
                                        'circle-stroke-width': 2,
                                        'circle-stroke-color': '#fff'
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $baf7a1f21323fe66$export$936d0764594b6eb3), {
                                    id: "cluster-count",
                                    type: "symbol",
                                    filter: [
                                        'has',
                                        'point_count'
                                    ],
                                    layout: {
                                        'text-field': [
                                            'get',
                                            'point_count_abbreviated'
                                        ],
                                        'text-size': 14,
                                        'text-font': [
                                            'Open Sans Bold',
                                            'Arial Unicode MS Bold'
                                        ],
                                        'text-anchor': 'center',
                                        'text-offset': [
                                            0,
                                            0
                                        ]
                                    },
                                    paint: {
                                        'text-color': '#fff'
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $baf7a1f21323fe66$export$936d0764594b6eb3), {
                                    id: "unclustered-point",
                                    type: "circle",
                                    filter: [
                                        '!',
                                        [
                                            'has',
                                            'point_count'
                                        ]
                                    ],
                                    paint: {
                                        'circle-color': '#0073ee',
                                        'circle-radius': 7,
                                        'circle-stroke-width': 2,
                                        'circle-stroke-color': '#fff'
                                    }
                                })
                            ]
                        }),
                        refugiSeleccionat && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $608c55396029632e$export$2e2bcd8739ae039), {
                            refugi: refugiSeleccionat,
                            onClose: ()=>setRefugiSeleccionat(null),
                            textos: (0, (/*@__PURE__*/$parcel$interopDefault($95e64080dc61a506$exports)))[lang]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84445ff85310bd17$export$2e2bcd8739ae039), {
                            accessToken: (0, $994aa1cb22f78a22$export$6b0c92c645b60d60)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84bb7b8c989e3187$export$91e8ffb52c2b32c5), {
                            position: "bottom-right"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4c62ddd92212ae9$export$49a437922edc1bd9), {
                            showZoom: true,
                            showCompass: false
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "font",
                dangerouslySetInnerHTML: {
                    __html: (0, (/*@__PURE__*/$parcel$interopDefault($95e64080dc61a506$exports)))[lang]?.font
                }
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");
var $bda5b0a1cec5eb2c$export$34e0f9847d4c02dd;
var $bda5b0a1cec5eb2c$export$ca787a737bfba0a9;
var $bda5b0a1cec5eb2c$export$2e6c959c16ff56b8;
$bda5b0a1cec5eb2c$export$34e0f9847d4c02dd = `QiLpzW_container`;
$bda5b0a1cec5eb2c$export$ca787a737bfba0a9 = `QiLpzW_inFlow`;
$bda5b0a1cec5eb2c$export$2e6c959c16ff56b8 = `QiLpzW_select`;


const $bf09101e5d650731$export$baf819189b0ccc9b = {
    mida_home: '978px',
    mida_noticia_lg: '1160px',
    mida_noticia_md: '600px',
    mida_noticia_sm: '320px',
    mida_noticia_xsm: '280px'
};


const $4cfd3027b4a2884b$var$VERSIONS = [
    {
        value: 'home',
        label: 'HOME'
    },
    {
        value: 'noticia_lg',
        label: "NOT\xcdCIA LG"
    },
    {
        value: 'noticia_md',
        label: "NOT\xcdCIA MD"
    },
    {
        value: 'noticia_sm',
        label: "NOT\xcdCIA SM"
    },
    {
        value: 'noticia_xsm',
        label: "NOT\xcdCIA XSM"
    }
];
const $4cfd3027b4a2884b$var$HeaderEmbed = ({ allowHomeEmbed: allowHomeEmbed = false, inFlow: inFlow = false, targetSelector: targetSelector = '[id^="app-"]' })=>{
    const [text, setText] = (0, $acw62.useState)(null);
    const [versioActiva, setVersioActiva] = (0, $acw62.useState)('noticia_md');
    const handleClick = (target)=>{
        const perHome = target === 'perHome';
        const targetLabel = target === 'perHome' ? 'HOME' : target === 'perNoticia1' ? "NOT\xcdCIA (1r embed)" : "NOT\xcdCIA (2n embed i posteriors)";
        const url = window.location.origin;
        const path = window.location.pathname;
        const projecte = path.split('/')[1];
        const query = new URLSearchParams(window.location.search);
        query.delete('preview');
        query.delete('embed-home');
        let datasets = '';
        query.forEach((value, key)=>{
            datasets += ` data-${key}="${value}"`;
        });
        const slug = query.get('slug');
        if (projecte === 'hemicicles' || projecte === 'widgets-eleccions') {
            const esHemicicles = projecte === 'hemicicles';
            const slugProj = esHemicicles ? `graficsweb/hemicicles/${slug}` : slug;
            const urlBase = query.get('url-base') || 'https://eleccions.ara.cat';
            const id = esHemicicles ? `hemicicle_${slug}` : slugProj?.replaceAll('/', '_');
            const embed = `<iframe id="${id}" src="${urlBase}/${slugProj}" height="58px" loading="lazy"></iframe>
			${perHome ? `<style>#${id}{width: 1px;min-width: 100%;margin-bottom: 20px;border: none;overflow: hidden;}
			@media only screen and (min-width: 768px) {#${id}{margin-bottom: 56px;}}</style>` : `<style>#${id}{width: 1px;min-width: 100%;border: none;overflow: hidden;}</style>`}
			<script type="text/javascript" src="${urlBase}/scripts/iframeResizer.min.js"></script>
			<script>document.addEventListener("DOMContentLoaded", function() { 
				document.getElementById("${id}").onload= function() { 
					iFrameResize({ log: false }, "#${id}");
				};
			});</script>`;
            navigator.clipboard.writeText(embed);
            setText(`Embed copiat per ${targetLabel} al porta-retalls`);
            setTimeout(()=>setText(null), 5000);
        } else {
            let embed = '';
            if (target === 'perNoticia2') embed = `<div id="app-${projecte}${slug ? `-${slug}` : ''}" class="embed-${projecte}"${datasets}></div>`;
            else embed = `<div id="app-${projecte}${slug ? `-${slug}` : ''}" class="embed-${projecte}"${datasets}${perHome ? ` data-embed-home="1"` : ''}></div>
	<link rel="stylesheet" href="${url}/projectes/${projecte}/dist/style.css">
	<script type="module" src="${url}/projectes/${projecte}/dist/index.js"></script>`;
            navigator.clipboard.writeText(embed);
            setText(`Embed copiat per ${targetLabel} al porta-retalls`);
            setTimeout(()=>setText(null), 5000);
        }
    };
    const handleVersio = (novaVersio)=>{
        localStorage.setItem('headerEmbedVersio', novaVersio ?? 'noticia_md');
        setVersioActiva(novaVersio);
        const url = new URL(window.location.href);
        // Editr search params
        const searchParams = new URLSearchParams(url.search);
        if (novaVersio === 'home') searchParams.set('embed-home', '1');
        else searchParams.delete('embed-home');
        const search = searchParams.toString();
        window.location.search = search;
    };
    const onVersio = (0, $acw62.useEffectEvent)((versio)=>{
        setVersioActiva(versio);
        const url = new URL(window.location.href);
        const searchParams = new URLSearchParams(url.search);
        if (versio === 'home' && searchParams.get('embed-home') !== '1') {
            searchParams.set('embed-home', '1');
            window.location.search = searchParams.toString();
        }
        const appElement = document.querySelector(targetSelector);
        appElement.style.maxWidth = versio === 'home' && allowHomeEmbed ? (0, $bf09101e5d650731$export$baf819189b0ccc9b).mida_home : (0, $bf09101e5d650731$export$baf819189b0ccc9b)[`mida_${versio}`];
        appElement.style.margin = inFlow ? '0 auto 40px' : '220px auto 40px';
        appElement.style.boxShadow = '0 0 12px rgba(0, 0, 0, 0.15)';
        appElement.style.backgroundColor = '#ffffff';
    });
    (0, $acw62.useEffect)(()=>{
        const versio = localStorage.getItem('headerEmbedVersio');
        document.body.style.backgroundColor = '#f4f6f8';
        if (!versio) {
            localStorage.setItem('headerEmbedVersio', 'noticia_md');
            onVersio('noticia_md');
        } else onVersio(versio);
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `${$bda5b0a1cec5eb2c$export$34e0f9847d4c02dd}${inFlow ? ` ${$bda5b0a1cec5eb2c$export$ca787a737bfba0a9}` : ''}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "Copia el codi de l\u2019embed a:"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Activity), {
                        mode: allowHomeEmbed ? 'visible' : 'hidden',
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: `ara-button${text !== null ? ' disabled' : ''}`,
                            onClick: ()=>handleClick('perHome'),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "HOME"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: `ara-button${text !== null ? ' disabled' : ''}`,
                        onClick: ()=>handleClick('perNoticia1'),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                "NOT\xcdCIA ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: "(1r embed)"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: `ara-button${text !== null ? ' disabled' : ''}`,
                        onClick: ()=>handleClick('perNoticia2'),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                "NOT\xcdCIA ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: "(2n embed i posteriors)"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    opacity: text ? 1 : 0
                },
                children: text
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $bda5b0a1cec5eb2c$export$2e6c959c16ff56b8,
                children: $4cfd3027b4a2884b$var$VERSIONS.map(({ value: value, label: label })=>{
                    const radio = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        onClick: ()=>handleVersio(value),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "radio",
                                value: value,
                                name: "versio",
                                checked: versioActiva === value,
                                onChange: ()=>{}
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                htmlFor: value,
                                style: {
                                    fontWeight: versioActiva === value ? 700 : 400
                                },
                                children: label
                            })
                        ]
                    }, value);
                    if (value === 'home') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Activity), {
                        mode: allowHomeEmbed ? 'visible' : 'hidden',
                        children: radio
                    }, value);
                    return radio;
                })
            })
        ]
    });
};
var $4cfd3027b4a2884b$export$2e2bcd8739ae039 = $4cfd3027b4a2884b$var$HeaderEmbed;


document.addEventListener('DOMContentLoaded', function() {
    const searchParams = new URLSearchParams(window.location.search);
    const lang = document.documentElement.lang || 'ca';
    const preview = searchParams.get('preview') === '1';
    const slug = searchParams.get('slug');
    const containers = document.querySelectorAll('.embed-mapa-refugis-climatics');
    containers.forEach((container)=>{
        const embedHome = searchParams.get('embed-home') === '1' || container.dataset.embedHome === '1';
        if (embedHome) container.classList.add($14d120258bb760db$export$711302eb3e721627);
        const root = (0, $7e96a608cb33bf79$exports.createRoot)(container);
        root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                preview && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4cfd3027b4a2884b$export$2e2bcd8739ae039), {
                    allowHomeEmbed: false
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        position: 'relative',
                        zIndex: 0
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a9753ce2d0b2cb0$export$2e2bcd8739ae039), {
                        lang: lang,
                        embedHome: embedHome,
                        slug: slug || container.dataset.slug || null
                    })
                })
            ]
        }));
    });
});


//# sourceMappingURL=index.js.map
